/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//localhost:3000/web/app/themes/stash/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(378);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(3);
	var core = __webpack_require__(21);
	var hide = __webpack_require__(13);
	var redefine = __webpack_require__(14);
	var ctx = __webpack_require__(22);
	var PROTOTYPE = 'prototype';
	
	var $export = function $export(type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1; // forced
	$export.G = 2; // global
	$export.S = 4; // static
	$export.P = 8; // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	$export.U = 64; // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isObject = __webpack_require__(5);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
	// eslint-disable-next-line no-new-func
	: Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	module.exports = function (it) {
	  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var store = __webpack_require__(54)('wks');
	var uid = __webpack_require__(44);
	var _Symbol = __webpack_require__(3).Symbol;
	var USE_SYMBOL = typeof _Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 7.1.15 ToLength
	var toInteger = __webpack_require__(24);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(4)(function () {
	  return Object.defineProperty({}, 'a', { get: function get() {
	      return 7;
	    } }).a != 7;
	});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(2);
	var IE8_DOM_DEFINE = __webpack_require__(109);
	var toPrimitive = __webpack_require__(28);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(8) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) {/* empty */}
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(26);
	module.exports = function (it) {
	  return Object(defined(it));
	};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * jQuery JavaScript Library v3.6.0
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2021-03-02T17:08Z
	 */
	(function (global, factory) {
	
		"use strict";
	
		if (( false ? "undefined" : _typeof(module)) === "object" && _typeof(module.exports) === "object") {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ? factory(global, true) : function (w) {
				if (!w.document) {
					throw new Error("jQuery requires a window with a document");
				}
				return factory(w);
			};
		} else {
			factory(global);
		}
	
		// Pass this if window is not defined yet
	})(typeof window !== "undefined" ? window : undefined, function (window, noGlobal) {
	
		// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
		// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
		// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
		// enough that all such attempts are guarded in a try block.
		"use strict";
	
		var arr = [];
	
		var getProto = Object.getPrototypeOf;
	
		var _slice = arr.slice;
	
		var flat = arr.flat ? function (array) {
			return arr.flat.call(array);
		} : function (array) {
			return arr.concat.apply([], array);
		};
	
		var push = arr.push;
	
		var indexOf = arr.indexOf;
	
		var class2type = {};
	
		var toString = class2type.toString;
	
		var hasOwn = class2type.hasOwnProperty;
	
		var fnToString = hasOwn.toString;
	
		var ObjectFunctionString = fnToString.call(Object);
	
		var support = {};
	
		var isFunction = function isFunction(obj) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
		};
	
		var isWindow = function isWindow(obj) {
			return obj != null && obj === obj.window;
		};
	
		var document = window.document;
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval(code, node, doc) {
			doc = doc || document;
	
			var i,
			    val,
			    script = doc.createElement("script");
	
			script.text = code;
			if (node) {
				for (i in preservedScriptAttributes) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[i] || node.getAttribute && node.getAttribute(i);
					if (val) {
						script.setAttribute(i, val);
					}
				}
			}
			doc.head.appendChild(script).parentNode.removeChild(script);
		}
	
		function toType(obj) {
			if (obj == null) {
				return obj + "";
			}
	
			// Support: Android <=2.3 only (functionish RegExp)
			return (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
		}
		/* global Symbol */
		// Defining this global in .eslintrc.json would create a danger of using the global
		// unguarded in another place, it seems safer to define global only for this module
	
	
		var version = "3.6.0",
	
	
		// Define a local copy of jQuery
		jQuery = function jQuery(selector, context) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init(selector, context);
		};
	
		jQuery.fn = jQuery.prototype = {
	
			// The current version of jQuery being used
			jquery: version,
	
			constructor: jQuery,
	
			// The default length of a jQuery object is 0
			length: 0,
	
			toArray: function toArray() {
				return _slice.call(this);
			},
	
			// Get the Nth element in the matched element set OR
			// Get the whole matched element set as a clean array
			get: function get(num) {
	
				// Return all the elements in a clean array
				if (num == null) {
					return _slice.call(this);
				}
	
				// Return just the one element from the set
				return num < 0 ? this[num + this.length] : this[num];
			},
	
			// Take an array of elements and push it onto the stack
			// (returning the new matched element set)
			pushStack: function pushStack(elems) {
	
				// Build a new jQuery matched element set
				var ret = jQuery.merge(this.constructor(), elems);
	
				// Add the old object onto the stack (as a reference)
				ret.prevObject = this;
	
				// Return the newly-formed element set
				return ret;
			},
	
			// Execute a callback for every element in the matched set.
			each: function each(callback) {
				return jQuery.each(this, callback);
			},
	
			map: function map(callback) {
				return this.pushStack(jQuery.map(this, function (elem, i) {
					return callback.call(elem, i, elem);
				}));
			},
	
			slice: function slice() {
				return this.pushStack(_slice.apply(this, arguments));
			},
	
			first: function first() {
				return this.eq(0);
			},
	
			last: function last() {
				return this.eq(-1);
			},
	
			even: function even() {
				return this.pushStack(jQuery.grep(this, function (_elem, i) {
					return (i + 1) % 2;
				}));
			},
	
			odd: function odd() {
				return this.pushStack(jQuery.grep(this, function (_elem, i) {
					return i % 2;
				}));
			},
	
			eq: function eq(i) {
				var len = this.length,
				    j = +i + (i < 0 ? len : 0);
				return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
			},
	
			end: function end() {
				return this.prevObject || this.constructor();
			},
	
			// For internal use only.
			// Behaves like an Array's method, not like a jQuery method.
			push: push,
			sort: arr.sort,
			splice: arr.splice
		};
	
		jQuery.extend = jQuery.fn.extend = function () {
			var options,
			    name,
			    src,
			    copy,
			    copyIsArray,
			    clone,
			    target = arguments[0] || {},
			    i = 1,
			    length = arguments.length,
			    deep = false;
	
			// Handle a deep copy situation
			if (typeof target === "boolean") {
				deep = target;
	
				// Skip the boolean and the target
				target = arguments[i] || {};
				i++;
			}
	
			// Handle case when target is a string or something (possible in deep copy)
			if ((typeof target === "undefined" ? "undefined" : _typeof(target)) !== "object" && !isFunction(target)) {
				target = {};
			}
	
			// Extend jQuery itself if only one argument is passed
			if (i === length) {
				target = this;
				i--;
			}
	
			for (; i < length; i++) {
	
				// Only deal with non-null/undefined values
				if ((options = arguments[i]) != null) {
	
					// Extend the base object
					for (name in options) {
						copy = options[name];
	
						// Prevent Object.prototype pollution
						// Prevent never-ending loop
						if (name === "__proto__" || target === copy) {
							continue;
						}
	
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
							src = target[name];
	
							// Ensure proper type for the source value
							if (copyIsArray && !Array.isArray(src)) {
								clone = [];
							} else if (!copyIsArray && !jQuery.isPlainObject(src)) {
								clone = {};
							} else {
								clone = src;
							}
							copyIsArray = false;
	
							// Never move original objects, clone them
							target[name] = jQuery.extend(deep, clone, copy);
	
							// Don't bring in undefined values
						} else if (copy !== undefined) {
							target[name] = copy;
						}
					}
				}
			}
	
			// Return the modified object
			return target;
		};
	
		jQuery.extend({
	
			// Unique for each copy of jQuery on the page
			expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
	
			// Assume jQuery is ready without the ready module
			isReady: true,
	
			error: function error(msg) {
				throw new Error(msg);
			},
	
			noop: function noop() {},
	
			isPlainObject: function isPlainObject(obj) {
				var proto, Ctor;
	
				// Detect obvious negatives
				// Use toString instead of jQuery.type to catch host objects
				if (!obj || toString.call(obj) !== "[object Object]") {
					return false;
				}
	
				proto = getProto(obj);
	
				// Objects with no prototype (e.g., `Object.create( null )`) are plain
				if (!proto) {
					return true;
				}
	
				// Objects with prototype are plain iff they were constructed by a global Object function
				Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
				return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
			},
	
			isEmptyObject: function isEmptyObject(obj) {
				var name;
	
				for (name in obj) {
					return false;
				}
				return true;
			},
	
			// Evaluates a script in a provided context; falls back to the global one
			// if not specified.
			globalEval: function globalEval(code, options, doc) {
				DOMEval(code, { nonce: options && options.nonce }, doc);
			},
	
			each: function each(obj, callback) {
				var length,
				    i = 0;
	
				if (isArrayLike(obj)) {
					length = obj.length;
					for (; i < length; i++) {
						if (callback.call(obj[i], i, obj[i]) === false) {
							break;
						}
					}
				} else {
					for (i in obj) {
						if (callback.call(obj[i], i, obj[i]) === false) {
							break;
						}
					}
				}
	
				return obj;
			},
	
			// results is for internal usage only
			makeArray: function makeArray(arr, results) {
				var ret = results || [];
	
				if (arr != null) {
					if (isArrayLike(Object(arr))) {
						jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
					} else {
						push.call(ret, arr);
					}
				}
	
				return ret;
			},
	
			inArray: function inArray(elem, arr, i) {
				return arr == null ? -1 : indexOf.call(arr, elem, i);
			},
	
			// Support: Android <=4.0 only, PhantomJS 1 only
			// push.apply(_, arraylike) throws on ancient WebKit
			merge: function merge(first, second) {
				var len = +second.length,
				    j = 0,
				    i = first.length;
	
				for (; j < len; j++) {
					first[i++] = second[j];
				}
	
				first.length = i;
	
				return first;
			},
	
			grep: function grep(elems, callback, invert) {
				var callbackInverse,
				    matches = [],
				    i = 0,
				    length = elems.length,
				    callbackExpect = !invert;
	
				// Go through the array, only saving the items
				// that pass the validator function
				for (; i < length; i++) {
					callbackInverse = !callback(elems[i], i);
					if (callbackInverse !== callbackExpect) {
						matches.push(elems[i]);
					}
				}
	
				return matches;
			},
	
			// arg is for internal usage only
			map: function map(elems, callback, arg) {
				var length,
				    value,
				    i = 0,
				    ret = [];
	
				// Go through the array, translating each of the items to their new values
				if (isArrayLike(elems)) {
					length = elems.length;
					for (; i < length; i++) {
						value = callback(elems[i], i, arg);
	
						if (value != null) {
							ret.push(value);
						}
					}
	
					// Go through every key on the object,
				} else {
					for (i in elems) {
						value = callback(elems[i], i, arg);
	
						if (value != null) {
							ret.push(value);
						}
					}
				}
	
				// Flatten any nested arrays
				return flat(ret);
			},
	
			// A global GUID counter for objects
			guid: 1,
	
			// jQuery.support is not used in Core but other projects attach their
			// properties to it so it needs to exist.
			support: support
		});
	
		if (typeof Symbol === "function") {
			jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
		}
	
		// Populate the class2type map
		jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (_i, name) {
			class2type["[object " + name + "]"] = name.toLowerCase();
		});
	
		function isArrayLike(obj) {
	
			// Support: real iOS 8.2 only (not reproducible in simulator)
			// `in` check used to prevent JIT error (gh-2145)
			// hasOwn isn't used here due to false negatives
			// regarding Nodelist length in IE
			var length = !!obj && "length" in obj && obj.length,
			    type = toType(obj);
	
			if (isFunction(obj) || isWindow(obj)) {
				return false;
			}
	
			return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
		}
		var Sizzle =
		/*!
	  * Sizzle CSS Selector Engine v2.3.6
	  * https://sizzlejs.com/
	  *
	  * Copyright JS Foundation and other contributors
	  * Released under the MIT license
	  * https://js.foundation/
	  *
	  * Date: 2021-02-16
	  */
		function (window) {
			var i,
			    support,
			    Expr,
			    getText,
			    isXML,
			    tokenize,
			    compile,
			    select,
			    outermostContext,
			    sortInput,
			    hasDuplicate,
	
	
			// Local document vars
			setDocument,
			    document,
			    docElem,
			    documentIsHTML,
			    rbuggyQSA,
			    rbuggyMatches,
			    matches,
			    contains,
	
	
			// Instance-specific data
			expando = "sizzle" + 1 * new Date(),
			    preferredDoc = window.document,
			    dirruns = 0,
			    done = 0,
			    classCache = createCache(),
			    tokenCache = createCache(),
			    compilerCache = createCache(),
			    nonnativeSelectorCache = createCache(),
			    sortOrder = function sortOrder(a, b) {
				if (a === b) {
					hasDuplicate = true;
				}
				return 0;
			},
	
	
			// Instance methods
			hasOwn = {}.hasOwnProperty,
			    arr = [],
			    pop = arr.pop,
			    pushNative = arr.push,
			    push = arr.push,
			    slice = arr.slice,
	
	
			// Use a stripped-down indexOf as it's faster than native
			// https://jsperf.com/thor-indexof-vs-for/5
			indexOf = function indexOf(list, elem) {
				var i = 0,
				    len = list.length;
				for (; i < len; i++) {
					if (list[i] === elem) {
						return i;
					}
				}
				return -1;
			},
			    booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" + "ismap|loop|multiple|open|readonly|required|scoped",
	
	
			// Regular expressions
	
			// http://www.w3.org/TR/css3-selectors/#whitespace
			whitespace = "[\\x20\\t\\r\\n\\f]",
	
	
			// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
			identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
	
			// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
			attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5]
			// or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]",
			    pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" + ")\\)|)",
	
	
			// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
			rwhitespace = new RegExp(whitespace + "+", "g"),
			    rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"),
			    rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
			    rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
			    rdescend = new RegExp(whitespace + "|>"),
			    rpseudo = new RegExp(pseudos),
			    ridentifier = new RegExp("^" + identifier + "$"),
			    matchExpr = {
				"ID": new RegExp("^#(" + identifier + ")"),
				"CLASS": new RegExp("^\\.(" + identifier + ")"),
				"TAG": new RegExp("^(" + identifier + "|[*])"),
				"ATTR": new RegExp("^" + attributes),
				"PSEUDO": new RegExp("^" + pseudos),
				"CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
				"bool": new RegExp("^(?:" + booleans + ")$", "i"),
	
				// For use in libraries implementing .is()
				// We use this for POS matching in `select`
				"needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
			},
			    rhtml = /HTML$/i,
			    rinputs = /^(?:input|select|textarea|button)$/i,
			    rheader = /^h\d$/i,
			    rnative = /^[^{]+\{\s*\[native \w/,
	
	
			// Easily-parseable/retrievable ID or TAG or CLASS selectors
			rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
			    rsibling = /[+~]/,
	
	
			// CSS escapes
			// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
			runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"),
			    funescape = function funescape(escape, nonHex) {
				var high = "0x" + escape.slice(1) - 0x10000;
	
				return nonHex ?
	
				// Strip the backslash prefix from a non-hex escape sequence
				nonHex :
	
				// Replace a hexadecimal escape sequence with the encoded Unicode code point
				// Support: IE <=11+
				// For values outside the Basic Multilingual Plane (BMP), manually construct a
				// surrogate pair
				high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
			},
	
	
			// CSS string/identifier serialization
			// https://drafts.csswg.org/cssom/#common-serializing-idioms
			rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
			    fcssescape = function fcssescape(ch, asCodePoint) {
				if (asCodePoint) {
	
					// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
					if (ch === "\0") {
						return "\uFFFD";
					}
	
					// Control characters and (dependent upon position) numbers get escaped as code points
					return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
				}
	
				// Other potentially-special ASCII characters get backslash-escaped
				return "\\" + ch;
			},
	
	
			// Used for iframes
			// See setDocument()
			// Removing the function wrapper causes a "Permission Denied"
			// error in IE
			unloadHandler = function unloadHandler() {
				setDocument();
			},
			    inDisabledFieldset = addCombinator(function (elem) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			}, { dir: "parentNode", next: "legend" });
	
			// Optimize for push.apply( _, NodeList )
			try {
				push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
	
				// Support: Android<4.0
				// Detect silently failing push.apply
				// eslint-disable-next-line no-unused-expressions
				arr[preferredDoc.childNodes.length].nodeType;
			} catch (e) {
				push = { apply: arr.length ?
	
					// Leverage slice if possible
					function (target, els) {
						pushNative.apply(target, slice.call(els));
					} :
	
					// Support: IE<9
					// Otherwise append directly
					function (target, els) {
						var j = target.length,
						    i = 0;
	
						// Can't trust NodeList.length
						while (target[j++] = els[i++]) {}
						target.length = j - 1;
					}
				};
			}
	
			function Sizzle(selector, context, results, seed) {
				var m,
				    i,
				    elem,
				    nid,
				    match,
				    groups,
				    newSelector,
				    newContext = context && context.ownerDocument,
	
	
				// nodeType defaults to 9, since context defaults to document
				nodeType = context ? context.nodeType : 9;
	
				results = results || [];
	
				// Return early from calls with invalid selector or context
				if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
	
					return results;
				}
	
				// Try to shortcut find operations (as opposed to filters) in HTML documents
				if (!seed) {
					setDocument(context);
					context = context || document;
	
					if (documentIsHTML) {
	
						// If the selector is sufficiently simple, try using a "get*By*" DOM method
						// (excepting DocumentFragment context, where the methods don't exist)
						if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
	
							// ID selector
							if (m = match[1]) {
	
								// Document context
								if (nodeType === 9) {
									if (elem = context.getElementById(m)) {
	
										// Support: IE, Opera, Webkit
										// TODO: identify versions
										// getElementById can match elements by name instead of ID
										if (elem.id === m) {
											results.push(elem);
											return results;
										}
									} else {
										return results;
									}
	
									// Element context
								} else {
	
									// Support: IE, Opera, Webkit
									// TODO: identify versions
									// getElementById can match elements by name instead of ID
									if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
	
										results.push(elem);
										return results;
									}
								}
	
								// Type selector
							} else if (match[2]) {
								push.apply(results, context.getElementsByTagName(selector));
								return results;
	
								// Class selector
							} else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
	
								push.apply(results, context.getElementsByClassName(m));
								return results;
							}
						}
	
						// Take advantage of querySelectorAll
						if (support.qsa && !nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector)) && (
	
						// Support: IE 8 only
						// Exclude object elements
						nodeType !== 1 || context.nodeName.toLowerCase() !== "object")) {
	
							newSelector = selector;
							newContext = context;
	
							// qSA considers elements outside a scoping root when evaluating child or
							// descendant combinators, which is not what we want.
							// In such cases, we work around the behavior by prefixing every selector in the
							// list with an ID selector referencing the scope context.
							// The technique has to be used as well when a leading combinator is used
							// as such selectors are not recognized by querySelectorAll.
							// Thanks to Andrew Dupont for this technique.
							if (nodeType === 1 && (rdescend.test(selector) || rcombinators.test(selector))) {
	
								// Expand context for sibling selectors
								newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
	
								// We can use :scope instead of the ID hack if the browser
								// supports it & if we're not changing the context.
								if (newContext !== context || !support.scope) {
	
									// Capture the context ID, setting it first if necessary
									if (nid = context.getAttribute("id")) {
										nid = nid.replace(rcssescape, fcssescape);
									} else {
										context.setAttribute("id", nid = expando);
									}
								}
	
								// Prefix every selector in the list
								groups = tokenize(selector);
								i = groups.length;
								while (i--) {
									groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
								}
								newSelector = groups.join(",");
							}
	
							try {
								push.apply(results, newContext.querySelectorAll(newSelector));
								return results;
							} catch (qsaError) {
								nonnativeSelectorCache(selector, true);
							} finally {
								if (nid === expando) {
									context.removeAttribute("id");
								}
							}
						}
					}
				}
	
				// All others
				return select(selector.replace(rtrim, "$1"), context, results, seed);
			}
	
			/**
	   * Create key-value caches of limited size
	   * @returns {function(string, object)} Returns the Object data after storing it on itself with
	   *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	   *	deleting the oldest entry
	   */
			function createCache() {
				var keys = [];
	
				function cache(key, value) {
	
					// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
					if (keys.push(key + " ") > Expr.cacheLength) {
	
						// Only keep the most recent entries
						delete cache[keys.shift()];
					}
					return cache[key + " "] = value;
				}
				return cache;
			}
	
			/**
	   * Mark a function for special use by Sizzle
	   * @param {Function} fn The function to mark
	   */
			function markFunction(fn) {
				fn[expando] = true;
				return fn;
			}
	
			/**
	   * Support testing using an element
	   * @param {Function} fn Passed the created element and returns a boolean result
	   */
			function assert(fn) {
				var el = document.createElement("fieldset");
	
				try {
					return !!fn(el);
				} catch (e) {
					return false;
				} finally {
	
					// Remove from its parent by default
					if (el.parentNode) {
						el.parentNode.removeChild(el);
					}
	
					// release memory in IE
					el = null;
				}
			}
	
			/**
	   * Adds the same handler for all of the specified attrs
	   * @param {String} attrs Pipe-separated list of attributes
	   * @param {Function} handler The method that will be applied
	   */
			function addHandle(attrs, handler) {
				var arr = attrs.split("|"),
				    i = arr.length;
	
				while (i--) {
					Expr.attrHandle[arr[i]] = handler;
				}
			}
	
			/**
	   * Checks document order of two siblings
	   * @param {Element} a
	   * @param {Element} b
	   * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	   */
			function siblingCheck(a, b) {
				var cur = b && a,
				    diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;
	
				// Use IE sourceIndex if available on both nodes
				if (diff) {
					return diff;
				}
	
				// Check if b follows a
				if (cur) {
					while (cur = cur.nextSibling) {
						if (cur === b) {
							return -1;
						}
					}
				}
	
				return a ? 1 : -1;
			}
	
			/**
	   * Returns a function to use in pseudos for input types
	   * @param {String} type
	   */
			function createInputPseudo(type) {
				return function (elem) {
					var name = elem.nodeName.toLowerCase();
					return name === "input" && elem.type === type;
				};
			}
	
			/**
	   * Returns a function to use in pseudos for buttons
	   * @param {String} type
	   */
			function createButtonPseudo(type) {
				return function (elem) {
					var name = elem.nodeName.toLowerCase();
					return (name === "input" || name === "button") && elem.type === type;
				};
			}
	
			/**
	   * Returns a function to use in pseudos for :enabled/:disabled
	   * @param {Boolean} disabled true for :disabled; false for :enabled
	   */
			function createDisabledPseudo(disabled) {
	
				// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
				return function (elem) {
	
					// Only certain elements can match :enabled or :disabled
					// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
					// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
					if ("form" in elem) {
	
						// Check for inherited disabledness on relevant non-disabled elements:
						// * listed form-associated elements in a disabled fieldset
						//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
						//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
						// * option elements in a disabled optgroup
						//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
						// All such elements have a "form" property.
						if (elem.parentNode && elem.disabled === false) {
	
							// Option elements defer to a parent optgroup if present
							if ("label" in elem) {
								if ("label" in elem.parentNode) {
									return elem.parentNode.disabled === disabled;
								} else {
									return elem.disabled === disabled;
								}
							}
	
							// Support: IE 6 - 11
							// Use the isDisabled shortcut property to check for disabled fieldset ancestors
							return elem.isDisabled === disabled ||
	
							// Where there is no isDisabled, check manually
							/* jshint -W018 */
							elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
						}
	
						return elem.disabled === disabled;
	
						// Try to winnow out elements that can't be disabled before trusting the disabled property.
						// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
						// even exist on them, let alone have a boolean value.
					} else if ("label" in elem) {
						return elem.disabled === disabled;
					}
	
					// Remaining elements are neither :enabled nor :disabled
					return false;
				};
			}
	
			/**
	   * Returns a function to use in pseudos for positionals
	   * @param {Function} fn
	   */
			function createPositionalPseudo(fn) {
				return markFunction(function (argument) {
					argument = +argument;
					return markFunction(function (seed, matches) {
						var j,
						    matchIndexes = fn([], seed.length, argument),
						    i = matchIndexes.length;
	
						// Match elements found at the specified indexes
						while (i--) {
							if (seed[j = matchIndexes[i]]) {
								seed[j] = !(matches[j] = seed[j]);
							}
						}
					});
				});
			}
	
			/**
	   * Checks a node for validity as a Sizzle context
	   * @param {Element|Object=} context
	   * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	   */
			function testContext(context) {
				return context && typeof context.getElementsByTagName !== "undefined" && context;
			}
	
			// Expose support vars for convenience
			support = Sizzle.support = {};
	
			/**
	   * Detects XML nodes
	   * @param {Element|Object} elem An element or a document
	   * @returns {Boolean} True iff elem is a non-HTML XML node
	   */
			isXML = Sizzle.isXML = function (elem) {
				var namespace = elem && elem.namespaceURI,
				    docElem = elem && (elem.ownerDocument || elem).documentElement;
	
				// Support: IE <=8
				// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
				// https://bugs.jquery.com/ticket/4833
				return !rhtml.test(namespace || docElem && docElem.nodeName || "HTML");
			};
	
			/**
	   * Sets document-related variables once based on the current document
	   * @param {Element|Object} [doc] An element or document object to use to set the document
	   * @returns {Object} Returns the current document
	   */
			setDocument = Sizzle.setDocument = function (node) {
				var hasCompare,
				    subWindow,
				    doc = node ? node.ownerDocument || node : preferredDoc;
	
				// Return early if doc is invalid or already selected
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if (doc == document || doc.nodeType !== 9 || !doc.documentElement) {
					return document;
				}
	
				// Update global variables
				document = doc;
				docElem = document.documentElement;
				documentIsHTML = !isXML(document);
	
				// Support: IE 9 - 11+, Edge 12 - 18+
				// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if (preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
	
					// Support: IE 11, Edge
					if (subWindow.addEventListener) {
						subWindow.addEventListener("unload", unloadHandler, false);
	
						// Support: IE 9 - 10 only
					} else if (subWindow.attachEvent) {
						subWindow.attachEvent("onunload", unloadHandler);
					}
				}
	
				// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
				// Safari 4 - 5 only, Opera <=11.6 - 12.x only
				// IE/Edge & older browsers don't support the :scope pseudo-class.
				// Support: Safari 6.0 only
				// Safari 6.0 supports :scope but it's an alias of :root there.
				support.scope = assert(function (el) {
					docElem.appendChild(el).appendChild(document.createElement("div"));
					return typeof el.querySelectorAll !== "undefined" && !el.querySelectorAll(":scope fieldset div").length;
				});
	
				/* Attributes
	   ---------------------------------------------------------------------- */
	
				// Support: IE<8
				// Verify that getAttribute really returns attributes and not properties
				// (excepting IE8 booleans)
				support.attributes = assert(function (el) {
					el.className = "i";
					return !el.getAttribute("className");
				});
	
				/* getElement(s)By*
	   ---------------------------------------------------------------------- */
	
				// Check if getElementsByTagName("*") returns only elements
				support.getElementsByTagName = assert(function (el) {
					el.appendChild(document.createComment(""));
					return !el.getElementsByTagName("*").length;
				});
	
				// Support: IE<9
				support.getElementsByClassName = rnative.test(document.getElementsByClassName);
	
				// Support: IE<10
				// Check if getElementById returns elements by name
				// The broken getElementById methods don't pick up programmatically-set names,
				// so use a roundabout getElementsByName test
				support.getById = assert(function (el) {
					docElem.appendChild(el).id = expando;
					return !document.getElementsByName || !document.getElementsByName(expando).length;
				});
	
				// ID filter and find
				if (support.getById) {
					Expr.filter["ID"] = function (id) {
						var attrId = id.replace(runescape, funescape);
						return function (elem) {
							return elem.getAttribute("id") === attrId;
						};
					};
					Expr.find["ID"] = function (id, context) {
						if (typeof context.getElementById !== "undefined" && documentIsHTML) {
							var elem = context.getElementById(id);
							return elem ? [elem] : [];
						}
					};
				} else {
					Expr.filter["ID"] = function (id) {
						var attrId = id.replace(runescape, funescape);
						return function (elem) {
							var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
							return node && node.value === attrId;
						};
					};
	
					// Support: IE 6 - 7 only
					// getElementById is not reliable as a find shortcut
					Expr.find["ID"] = function (id, context) {
						if (typeof context.getElementById !== "undefined" && documentIsHTML) {
							var node,
							    i,
							    elems,
							    elem = context.getElementById(id);
	
							if (elem) {
	
								// Verify the id attribute
								node = elem.getAttributeNode("id");
								if (node && node.value === id) {
									return [elem];
								}
	
								// Fall back on getElementsByName
								elems = context.getElementsByName(id);
								i = 0;
								while (elem = elems[i++]) {
									node = elem.getAttributeNode("id");
									if (node && node.value === id) {
										return [elem];
									}
								}
							}
	
							return [];
						}
					};
				}
	
				// Tag
				Expr.find["TAG"] = support.getElementsByTagName ? function (tag, context) {
					if (typeof context.getElementsByTagName !== "undefined") {
						return context.getElementsByTagName(tag);
	
						// DocumentFragment nodes don't have gEBTN
					} else if (support.qsa) {
						return context.querySelectorAll(tag);
					}
				} : function (tag, context) {
					var elem,
					    tmp = [],
					    i = 0,
	
	
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName(tag);
	
					// Filter out possible comments
					if (tag === "*") {
						while (elem = results[i++]) {
							if (elem.nodeType === 1) {
								tmp.push(elem);
							}
						}
	
						return tmp;
					}
					return results;
				};
	
				// Class
				Expr.find["CLASS"] = support.getElementsByClassName && function (className, context) {
					if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
						return context.getElementsByClassName(className);
					}
				};
	
				/* QSA/matchesSelector
	   ---------------------------------------------------------------------- */
	
				// QSA and matchesSelector support
	
				// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
				rbuggyMatches = [];
	
				// qSa(:focus) reports false when true (Chrome 21)
				// We allow this because of a bug in IE8/9 that throws an error
				// whenever `document.activeElement` is accessed on an iframe
				// So, we allow :focus to pass through QSA all the time to avoid the IE error
				// See https://bugs.jquery.com/ticket/13378
				rbuggyQSA = [];
	
				if (support.qsa = rnative.test(document.querySelectorAll)) {
	
					// Build QSA regex
					// Regex strategy adopted from Diego Perini
					assert(function (el) {
	
						var input;
	
						// Select is set to empty string on purpose
						// This is to test IE's treatment of not explicitly
						// setting a boolean content attribute,
						// since its presence should be enough
						// https://bugs.jquery.com/ticket/12359
						docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";
	
						// Support: IE8, Opera 11-12.16
						// Nothing should be selected when empty strings follow ^= or $= or *=
						// The test attribute must be unknown in Opera but "safe" for WinRT
						// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
						if (el.querySelectorAll("[msallowcapture^='']").length) {
							rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
						}
	
						// Support: IE8
						// Boolean attributes and "value" are not treated correctly
						if (!el.querySelectorAll("[selected]").length) {
							rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
						}
	
						// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
						if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
							rbuggyQSA.push("~=");
						}
	
						// Support: IE 11+, Edge 15 - 18+
						// IE 11/Edge don't find elements on a `[name='']` query in some cases.
						// Adding a temporary attribute to the document before the selection works
						// around the issue.
						// Interestingly, IE 10 & older don't seem to have the issue.
						input = document.createElement("input");
						input.setAttribute("name", "");
						el.appendChild(input);
						if (!el.querySelectorAll("[name='']").length) {
							rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
						}
	
						// Webkit/Opera - :checked should return selected option elements
						// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
						// IE8 throws error here and will not see later tests
						if (!el.querySelectorAll(":checked").length) {
							rbuggyQSA.push(":checked");
						}
	
						// Support: Safari 8+, iOS 8+
						// https://bugs.webkit.org/show_bug.cgi?id=136851
						// In-page `selector#id sibling-combinator selector` fails
						if (!el.querySelectorAll("a#" + expando + "+*").length) {
							rbuggyQSA.push(".#.+[+~]");
						}
	
						// Support: Firefox <=3.6 - 5 only
						// Old Firefox doesn't throw on a badly-escaped identifier.
						el.querySelectorAll("\\\f");
						rbuggyQSA.push("[\\r\\n\\f]");
					});
	
					assert(function (el) {
						el.innerHTML = "<a href='' disabled='disabled'></a>" + "<select disabled='disabled'><option/></select>";
	
						// Support: Windows 8 Native Apps
						// The type and name attributes are restricted during .innerHTML assignment
						var input = document.createElement("input");
						input.setAttribute("type", "hidden");
						el.appendChild(input).setAttribute("name", "D");
	
						// Support: IE8
						// Enforce case-sensitivity of name attribute
						if (el.querySelectorAll("[name=d]").length) {
							rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
						}
	
						// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
						// IE8 throws error here and will not see later tests
						if (el.querySelectorAll(":enabled").length !== 2) {
							rbuggyQSA.push(":enabled", ":disabled");
						}
	
						// Support: IE9-11+
						// IE's :disabled selector does not pick up the children of disabled fieldsets
						docElem.appendChild(el).disabled = true;
						if (el.querySelectorAll(":disabled").length !== 2) {
							rbuggyQSA.push(":enabled", ":disabled");
						}
	
						// Support: Opera 10 - 11 only
						// Opera 10-11 does not throw on post-comma invalid pseudos
						el.querySelectorAll("*,:x");
						rbuggyQSA.push(",.*:");
					});
				}
	
				if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) {
	
					assert(function (el) {
	
						// Check to see if it's possible to do matchesSelector
						// on a disconnected node (IE 9)
						support.disconnectedMatch = matches.call(el, "*");
	
						// This should fail with an exception
						// Gecko does not error, returns false instead
						matches.call(el, "[s!='']:x");
						rbuggyMatches.push("!=", pseudos);
					});
				}
	
				rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
				rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
	
				/* Contains
	   ---------------------------------------------------------------------- */
				hasCompare = rnative.test(docElem.compareDocumentPosition);
	
				// Element contains another
				// Purposefully self-exclusive
				// As in, an element does not contain itself
				contains = hasCompare || rnative.test(docElem.contains) ? function (a, b) {
					var adown = a.nodeType === 9 ? a.documentElement : a,
					    bup = b && b.parentNode;
					return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
				} : function (a, b) {
					if (b) {
						while (b = b.parentNode) {
							if (b === a) {
								return true;
							}
						}
					}
					return false;
				};
	
				/* Sorting
	   ---------------------------------------------------------------------- */
	
				// Document order sorting
				sortOrder = hasCompare ? function (a, b) {
	
					// Flag for duplicate removal
					if (a === b) {
						hasDuplicate = true;
						return 0;
					}
	
					// Sort on method existence if only one input has compareDocumentPosition
					var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
					if (compare) {
						return compare;
					}
	
					// Calculate position if both inputs belong to the same document
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) :
	
					// Otherwise we know they are disconnected
					1;
	
					// Disconnected nodes
					if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
	
						// Choose the first element that is related to our preferred document
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if (a == document || a.ownerDocument == preferredDoc && contains(preferredDoc, a)) {
							return -1;
						}
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if (b == document || b.ownerDocument == preferredDoc && contains(preferredDoc, b)) {
							return 1;
						}
	
						// Maintain original order
						return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
					}
	
					return compare & 4 ? -1 : 1;
				} : function (a, b) {
	
					// Exit early if the nodes are identical
					if (a === b) {
						hasDuplicate = true;
						return 0;
					}
	
					var cur,
					    i = 0,
					    aup = a.parentNode,
					    bup = b.parentNode,
					    ap = [a],
					    bp = [b];
	
					// Parentless nodes are either documents or disconnected
					if (!aup || !bup) {
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						/* eslint-disable eqeqeq */
						return a == document ? -1 : b == document ? 1 :
						/* eslint-enable eqeqeq */
						aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
	
						// If the nodes are siblings, we can do a quick check
					} else if (aup === bup) {
						return siblingCheck(a, b);
					}
	
					// Otherwise we need full lists of their ancestors for comparison
					cur = a;
					while (cur = cur.parentNode) {
						ap.unshift(cur);
					}
					cur = b;
					while (cur = cur.parentNode) {
						bp.unshift(cur);
					}
	
					// Walk down the tree looking for a discrepancy
					while (ap[i] === bp[i]) {
						i++;
					}
	
					return i ?
	
					// Do a sibling check if the nodes have a common ancestor
					siblingCheck(ap[i], bp[i]) :
	
					// Otherwise nodes in our document sort first
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					/* eslint-disable eqeqeq */
					ap[i] == preferredDoc ? -1 : bp[i] == preferredDoc ? 1 :
					/* eslint-enable eqeqeq */
					0;
				};
	
				return document;
			};
	
			Sizzle.matches = function (expr, elements) {
				return Sizzle(expr, null, null, elements);
			};
	
			Sizzle.matchesSelector = function (elem, expr) {
				setDocument(elem);
	
				if (support.matchesSelector && documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
	
					try {
						var ret = matches.call(elem, expr);
	
						// IE 9's matchesSelector returns false on disconnected nodes
						if (ret || support.disconnectedMatch ||
	
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11) {
							return ret;
						}
					} catch (e) {
						nonnativeSelectorCache(expr, true);
					}
				}
	
				return Sizzle(expr, document, null, [elem]).length > 0;
			};
	
			Sizzle.contains = function (context, elem) {
	
				// Set document vars if needed
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ((context.ownerDocument || context) != document) {
					setDocument(context);
				}
				return contains(context, elem);
			};
	
			Sizzle.attr = function (elem, name) {
	
				// Set document vars if needed
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ((elem.ownerDocument || elem) != document) {
					setDocument(elem);
				}
	
				var fn = Expr.attrHandle[name.toLowerCase()],
	
	
				// Don't get fooled by Object.prototype properties (jQuery #13807)
				val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
	
				return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
			};
	
			Sizzle.escape = function (sel) {
				return (sel + "").replace(rcssescape, fcssescape);
			};
	
			Sizzle.error = function (msg) {
				throw new Error("Syntax error, unrecognized expression: " + msg);
			};
	
			/**
	   * Document sorting and removing duplicates
	   * @param {ArrayLike} results
	   */
			Sizzle.uniqueSort = function (results) {
				var elem,
				    duplicates = [],
				    j = 0,
				    i = 0;
	
				// Unless we *know* we can detect duplicates, assume their presence
				hasDuplicate = !support.detectDuplicates;
				sortInput = !support.sortStable && results.slice(0);
				results.sort(sortOrder);
	
				if (hasDuplicate) {
					while (elem = results[i++]) {
						if (elem === results[i]) {
							j = duplicates.push(i);
						}
					}
					while (j--) {
						results.splice(duplicates[j], 1);
					}
				}
	
				// Clear input after sorting to release objects
				// See https://github.com/jquery/sizzle/pull/225
				sortInput = null;
	
				return results;
			};
	
			/**
	   * Utility function for retrieving the text value of an array of DOM nodes
	   * @param {Array|Element} elem
	   */
			getText = Sizzle.getText = function (elem) {
				var node,
				    ret = "",
				    i = 0,
				    nodeType = elem.nodeType;
	
				if (!nodeType) {
	
					// If no nodeType, this is expected to be an array
					while (node = elem[i++]) {
	
						// Do not traverse comment nodes
						ret += getText(node);
					}
				} else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
	
					// Use textContent for elements
					// innerText usage removed for consistency of new lines (jQuery #11153)
					if (typeof elem.textContent === "string") {
						return elem.textContent;
					} else {
	
						// Traverse its children
						for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
							ret += getText(elem);
						}
					}
				} else if (nodeType === 3 || nodeType === 4) {
					return elem.nodeValue;
				}
	
				// Do not include comment or processing instruction nodes
	
				return ret;
			};
	
			Expr = Sizzle.selectors = {
	
				// Can be adjusted by the user
				cacheLength: 50,
	
				createPseudo: markFunction,
	
				match: matchExpr,
	
				attrHandle: {},
	
				find: {},
	
				relative: {
					">": { dir: "parentNode", first: true },
					" ": { dir: "parentNode" },
					"+": { dir: "previousSibling", first: true },
					"~": { dir: "previousSibling" }
				},
	
				preFilter: {
					"ATTR": function ATTR(match) {
						match[1] = match[1].replace(runescape, funescape);
	
						// Move the given value to match[3] whether quoted or unquoted
						match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
	
						if (match[2] === "~=") {
							match[3] = " " + match[3] + " ";
						}
	
						return match.slice(0, 4);
					},
	
					"CHILD": function CHILD(match) {
	
						/* matches from matchExpr["CHILD"]
	     	1 type (only|nth|...)
	     	2 what (child|of-type)
	     	3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
	     	4 xn-component of xn+y argument ([+-]?\d*n|)
	     	5 sign of xn-component
	     	6 x of xn-component
	     	7 sign of y-component
	     	8 y of y-component
	     */
						match[1] = match[1].toLowerCase();
	
						if (match[1].slice(0, 3) === "nth") {
	
							// nth-* requires argument
							if (!match[3]) {
								Sizzle.error(match[0]);
							}
	
							// numeric x and y parameters for Expr.filter.CHILD
							// remember that false/true cast respectively to 0/1
							match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
							match[5] = +(match[7] + match[8] || match[3] === "odd");
	
							// other types prohibit arguments
						} else if (match[3]) {
							Sizzle.error(match[0]);
						}
	
						return match;
					},
	
					"PSEUDO": function PSEUDO(match) {
						var excess,
						    unquoted = !match[6] && match[2];
	
						if (matchExpr["CHILD"].test(match[0])) {
							return null;
						}
	
						// Accept quoted arguments as-is
						if (match[3]) {
							match[2] = match[4] || match[5] || "";
	
							// Strip excess characters from unquoted arguments
						} else if (unquoted && rpseudo.test(unquoted) && (
	
						// Get excess from tokenize (recursively)
						excess = tokenize(unquoted, true)) && (
	
						// advance to the next closing parenthesis
						excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
	
							// excess is a negative index
							match[0] = match[0].slice(0, excess);
							match[2] = unquoted.slice(0, excess);
						}
	
						// Return only captures needed by the pseudo filter method (type and argument)
						return match.slice(0, 3);
					}
				},
	
				filter: {
	
					"TAG": function TAG(nodeNameSelector) {
						var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
						return nodeNameSelector === "*" ? function () {
							return true;
						} : function (elem) {
							return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
						};
					},
	
					"CLASS": function CLASS(className) {
						var pattern = classCache[className + " "];
	
						return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function (elem) {
							return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
						});
					},
	
					"ATTR": function ATTR(name, operator, check) {
						return function (elem) {
							var result = Sizzle.attr(elem, name);
	
							if (result == null) {
								return operator === "!=";
							}
							if (!operator) {
								return true;
							}
	
							result += "";
	
							/* eslint-disable max-len */
	
							return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
							/* eslint-enable max-len */
						};
					},
	
					"CHILD": function CHILD(type, what, _argument, first, last) {
						var simple = type.slice(0, 3) !== "nth",
						    forward = type.slice(-4) !== "last",
						    ofType = what === "of-type";
	
						return first === 1 && last === 0 ?
	
						// Shortcut for :nth-*(n)
						function (elem) {
							return !!elem.parentNode;
						} : function (elem, _context, xml) {
							var cache,
							    uniqueCache,
							    outerCache,
							    node,
							    nodeIndex,
							    start,
							    dir = simple !== forward ? "nextSibling" : "previousSibling",
							    parent = elem.parentNode,
							    name = ofType && elem.nodeName.toLowerCase(),
							    useCache = !xml && !ofType,
							    diff = false;
	
							if (parent) {
	
								// :(first|last|only)-(child|of-type)
								if (simple) {
									while (dir) {
										node = elem;
										while (node = node[dir]) {
											if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
	
												return false;
											}
										}
	
										// Reverse direction for :only-* (if we haven't yet done so)
										start = dir = type === "only" && !start && "nextSibling";
									}
									return true;
								}
	
								start = [forward ? parent.firstChild : parent.lastChild];
	
								// non-xml :nth-child(...) stores cache data on `parent`
								if (forward && useCache) {
	
									// Seek `elem` from a previously-cached index
	
									// ...in a gzip-friendly way
									node = parent;
									outerCache = node[expando] || (node[expando] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
	
									cache = uniqueCache[type] || [];
									nodeIndex = cache[0] === dirruns && cache[1];
									diff = nodeIndex && cache[2];
									node = nodeIndex && parent.childNodes[nodeIndex];
	
									while (node = ++nodeIndex && node && node[dir] || (
	
									// Fallback to seeking `elem` from the start
									diff = nodeIndex = 0) || start.pop()) {
	
										// When found, cache indexes on `parent` and break
										if (node.nodeType === 1 && ++diff && node === elem) {
											uniqueCache[type] = [dirruns, nodeIndex, diff];
											break;
										}
									}
								} else {
	
									// Use previously-cached element index if available
									if (useCache) {
	
										// ...in a gzip-friendly way
										node = elem;
										outerCache = node[expando] || (node[expando] = {});
	
										// Support: IE <9 only
										// Defend against cloned attroperties (jQuery gh-1709)
										uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
	
										cache = uniqueCache[type] || [];
										nodeIndex = cache[0] === dirruns && cache[1];
										diff = nodeIndex;
									}
	
									// xml :nth-child(...)
									// or :nth-last-child(...) or :nth(-last)?-of-type(...)
									if (diff === false) {
	
										// Use the same loop as above to seek `elem` from the start
										while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
	
											if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
	
												// Cache the index of each encountered element
												if (useCache) {
													outerCache = node[expando] || (node[expando] = {});
	
													// Support: IE <9 only
													// Defend against cloned attroperties (jQuery gh-1709)
													uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
	
													uniqueCache[type] = [dirruns, diff];
												}
	
												if (node === elem) {
													break;
												}
											}
										}
									}
								}
	
								// Incorporate the offset, then check against cycle size
								diff -= last;
								return diff === first || diff % first === 0 && diff / first >= 0;
							}
						};
					},
	
					"PSEUDO": function PSEUDO(pseudo, argument) {
	
						// pseudo-class names are case-insensitive
						// http://www.w3.org/TR/selectors/#pseudo-classes
						// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
						// Remember that setFilters inherits from pseudos
						var args,
						    fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);
	
						// The user may use createPseudo to indicate that
						// arguments are needed to create the filter function
						// just as Sizzle does
						if (fn[expando]) {
							return fn(argument);
						}
	
						// But maintain support for old signatures
						if (fn.length > 1) {
							args = [pseudo, pseudo, "", argument];
							return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
								var idx,
								    matched = fn(seed, argument),
								    i = matched.length;
								while (i--) {
									idx = indexOf(seed, matched[i]);
									seed[idx] = !(matches[idx] = matched[i]);
								}
							}) : function (elem) {
								return fn(elem, 0, args);
							};
						}
	
						return fn;
					}
				},
	
				pseudos: {
	
					// Potentially complex pseudos
					"not": markFunction(function (selector) {
	
						// Trim the selector passed to compile
						// to avoid treating leading and trailing
						// spaces as combinators
						var input = [],
						    results = [],
						    matcher = compile(selector.replace(rtrim, "$1"));
	
						return matcher[expando] ? markFunction(function (seed, matches, _context, xml) {
							var elem,
							    unmatched = matcher(seed, null, xml, []),
							    i = seed.length;
	
							// Match elements unmatched by `matcher`
							while (i--) {
								if (elem = unmatched[i]) {
									seed[i] = !(matches[i] = elem);
								}
							}
						}) : function (elem, _context, xml) {
							input[0] = elem;
							matcher(input, null, xml, results);
	
							// Don't keep the element (issue #299)
							input[0] = null;
							return !results.pop();
						};
					}),
	
					"has": markFunction(function (selector) {
						return function (elem) {
							return Sizzle(selector, elem).length > 0;
						};
					}),
	
					"contains": markFunction(function (text) {
						text = text.replace(runescape, funescape);
						return function (elem) {
							return (elem.textContent || getText(elem)).indexOf(text) > -1;
						};
					}),
	
					// "Whether an element is represented by a :lang() selector
					// is based solely on the element's language value
					// being equal to the identifier C,
					// or beginning with the identifier C immediately followed by "-".
					// The matching of C against the element's language value is performed case-insensitively.
					// The identifier C does not have to be a valid language name."
					// http://www.w3.org/TR/selectors/#lang-pseudo
					"lang": markFunction(function (lang) {
	
						// lang value must be a valid identifier
						if (!ridentifier.test(lang || "")) {
							Sizzle.error("unsupported lang: " + lang);
						}
						lang = lang.replace(runescape, funescape).toLowerCase();
						return function (elem) {
							var elemLang;
							do {
								if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
	
									elemLang = elemLang.toLowerCase();
									return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
								}
							} while ((elem = elem.parentNode) && elem.nodeType === 1);
							return false;
						};
					}),
	
					// Miscellaneous
					"target": function target(elem) {
						var hash = window.location && window.location.hash;
						return hash && hash.slice(1) === elem.id;
					},
	
					"root": function root(elem) {
						return elem === docElem;
					},
	
					"focus": function focus(elem) {
						return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
					},
	
					// Boolean properties
					"enabled": createDisabledPseudo(false),
					"disabled": createDisabledPseudo(true),
	
					"checked": function checked(elem) {
	
						// In CSS3, :checked should return both checked and selected elements
						// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
						var nodeName = elem.nodeName.toLowerCase();
						return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
					},
	
					"selected": function selected(elem) {
	
						// Accessing this property makes selected-by-default
						// options in Safari work properly
						if (elem.parentNode) {
							// eslint-disable-next-line no-unused-expressions
							elem.parentNode.selectedIndex;
						}
	
						return elem.selected === true;
					},
	
					// Contents
					"empty": function empty(elem) {
	
						// http://www.w3.org/TR/selectors/#empty-pseudo
						// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
						//   but not by others (comment: 8; processing instruction: 7; etc.)
						// nodeType < 6 works because attributes (2) do not appear as children
						for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
							if (elem.nodeType < 6) {
								return false;
							}
						}
						return true;
					},
	
					"parent": function parent(elem) {
						return !Expr.pseudos["empty"](elem);
					},
	
					// Element/input types
					"header": function header(elem) {
						return rheader.test(elem.nodeName);
					},
	
					"input": function input(elem) {
						return rinputs.test(elem.nodeName);
					},
	
					"button": function button(elem) {
						var name = elem.nodeName.toLowerCase();
						return name === "input" && elem.type === "button" || name === "button";
					},
	
					"text": function text(elem) {
						var attr;
						return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && (
	
						// Support: IE<8
						// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
						(attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
					},
	
					// Position-in-collection
					"first": createPositionalPseudo(function () {
						return [0];
					}),
	
					"last": createPositionalPseudo(function (_matchIndexes, length) {
						return [length - 1];
					}),
	
					"eq": createPositionalPseudo(function (_matchIndexes, length, argument) {
						return [argument < 0 ? argument + length : argument];
					}),
	
					"even": createPositionalPseudo(function (matchIndexes, length) {
						var i = 0;
						for (; i < length; i += 2) {
							matchIndexes.push(i);
						}
						return matchIndexes;
					}),
	
					"odd": createPositionalPseudo(function (matchIndexes, length) {
						var i = 1;
						for (; i < length; i += 2) {
							matchIndexes.push(i);
						}
						return matchIndexes;
					}),
	
					"lt": createPositionalPseudo(function (matchIndexes, length, argument) {
						var i = argument < 0 ? argument + length : argument > length ? length : argument;
						for (; --i >= 0;) {
							matchIndexes.push(i);
						}
						return matchIndexes;
					}),
	
					"gt": createPositionalPseudo(function (matchIndexes, length, argument) {
						var i = argument < 0 ? argument + length : argument;
						for (; ++i < length;) {
							matchIndexes.push(i);
						}
						return matchIndexes;
					})
				}
			};
	
			Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
			// Add button/input type pseudos
			for (i in { radio: true, checkbox: true, file: true, password: true, image: true }) {
				Expr.pseudos[i] = createInputPseudo(i);
			}
			for (i in { submit: true, reset: true }) {
				Expr.pseudos[i] = createButtonPseudo(i);
			}
	
			// Easy API for creating new setFilters
			function setFilters() {}
			setFilters.prototype = Expr.filters = Expr.pseudos;
			Expr.setFilters = new setFilters();
	
			tokenize = Sizzle.tokenize = function (selector, parseOnly) {
				var matched,
				    match,
				    tokens,
				    type,
				    soFar,
				    groups,
				    preFilters,
				    cached = tokenCache[selector + " "];
	
				if (cached) {
					return parseOnly ? 0 : cached.slice(0);
				}
	
				soFar = selector;
				groups = [];
				preFilters = Expr.preFilter;
	
				while (soFar) {
	
					// Comma and first run
					if (!matched || (match = rcomma.exec(soFar))) {
						if (match) {
	
							// Don't consume trailing commas as valid
							soFar = soFar.slice(match[0].length) || soFar;
						}
						groups.push(tokens = []);
					}
	
					matched = false;
	
					// Combinators
					if (match = rcombinators.exec(soFar)) {
						matched = match.shift();
						tokens.push({
							value: matched,
	
							// Cast descendant combinators to space
							type: match[0].replace(rtrim, " ")
						});
						soFar = soFar.slice(matched.length);
					}
	
					// Filters
					for (type in Expr.filter) {
						if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
							matched = match.shift();
							tokens.push({
								value: matched,
								type: type,
								matches: match
							});
							soFar = soFar.slice(matched.length);
						}
					}
	
					if (!matched) {
						break;
					}
				}
	
				// Return the length of the invalid excess
				// if we're just parsing
				// Otherwise, throw an error or return tokens
				return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) :
	
				// Cache the tokens
				tokenCache(selector, groups).slice(0);
			};
	
			function toSelector(tokens) {
				var i = 0,
				    len = tokens.length,
				    selector = "";
				for (; i < len; i++) {
					selector += tokens[i].value;
				}
				return selector;
			}
	
			function addCombinator(matcher, combinator, base) {
				var dir = combinator.dir,
				    skip = combinator.next,
				    key = skip || dir,
				    checkNonElements = base && key === "parentNode",
				    doneName = done++;
	
				return combinator.first ?
	
				// Check against closest ancestor/preceding element
				function (elem, context, xml) {
					while (elem = elem[dir]) {
						if (elem.nodeType === 1 || checkNonElements) {
							return matcher(elem, context, xml);
						}
					}
					return false;
				} :
	
				// Check against all ancestor/preceding elements
				function (elem, context, xml) {
					var oldCache,
					    uniqueCache,
					    outerCache,
					    newCache = [dirruns, doneName];
	
					// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
					if (xml) {
						while (elem = elem[dir]) {
							if (elem.nodeType === 1 || checkNonElements) {
								if (matcher(elem, context, xml)) {
									return true;
								}
							}
						}
					} else {
						while (elem = elem[dir]) {
							if (elem.nodeType === 1 || checkNonElements) {
								outerCache = elem[expando] || (elem[expando] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
	
								if (skip && skip === elem.nodeName.toLowerCase()) {
									elem = elem[dir] || elem;
								} else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
	
									// Assign to newCache so results back-propagate to previous elements
									return newCache[2] = oldCache[2];
								} else {
	
									// Reuse newcache so results back-propagate to previous elements
									uniqueCache[key] = newCache;
	
									// A match means we're done; a fail means we have to keep checking
									if (newCache[2] = matcher(elem, context, xml)) {
										return true;
									}
								}
							}
						}
					}
					return false;
				};
			}
	
			function elementMatcher(matchers) {
				return matchers.length > 1 ? function (elem, context, xml) {
					var i = matchers.length;
					while (i--) {
						if (!matchers[i](elem, context, xml)) {
							return false;
						}
					}
					return true;
				} : matchers[0];
			}
	
			function multipleContexts(selector, contexts, results) {
				var i = 0,
				    len = contexts.length;
				for (; i < len; i++) {
					Sizzle(selector, contexts[i], results);
				}
				return results;
			}
	
			function condense(unmatched, map, filter, context, xml) {
				var elem,
				    newUnmatched = [],
				    i = 0,
				    len = unmatched.length,
				    mapped = map != null;
	
				for (; i < len; i++) {
					if (elem = unmatched[i]) {
						if (!filter || filter(elem, context, xml)) {
							newUnmatched.push(elem);
							if (mapped) {
								map.push(i);
							}
						}
					}
				}
	
				return newUnmatched;
			}
	
			function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
				if (postFilter && !postFilter[expando]) {
					postFilter = setMatcher(postFilter);
				}
				if (postFinder && !postFinder[expando]) {
					postFinder = setMatcher(postFinder, postSelector);
				}
				return markFunction(function (seed, results, context, xml) {
					var temp,
					    i,
					    elem,
					    preMap = [],
					    postMap = [],
					    preexisting = results.length,
	
	
					// Get initial elements from seed or context
					elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),
	
	
					// Prefilter to get matcher input, preserving a map for seed-results synchronization
					matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems,
					    matcherOut = matcher ?
	
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || (seed ? preFilter : preexisting || postFilter) ?
	
					// ...intermediate processing is necessary
					[] :
	
					// ...otherwise use results directly
					results : matcherIn;
	
					// Find primary matches
					if (matcher) {
						matcher(matcherIn, matcherOut, context, xml);
					}
	
					// Apply postFilter
					if (postFilter) {
						temp = condense(matcherOut, postMap);
						postFilter(temp, [], context, xml);
	
						// Un-match failing elements by moving them back to matcherIn
						i = temp.length;
						while (i--) {
							if (elem = temp[i]) {
								matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
							}
						}
					}
	
					if (seed) {
						if (postFinder || preFilter) {
							if (postFinder) {
	
								// Get the final matcherOut by condensing this intermediate into postFinder contexts
								temp = [];
								i = matcherOut.length;
								while (i--) {
									if (elem = matcherOut[i]) {
	
										// Restore matcherIn since elem is not yet a final match
										temp.push(matcherIn[i] = elem);
									}
								}
								postFinder(null, matcherOut = [], temp, xml);
							}
	
							// Move matched elements from seed to results to keep them synchronized
							i = matcherOut.length;
							while (i--) {
								if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) {
	
									seed[temp] = !(results[temp] = elem);
								}
							}
						}
	
						// Add elements to results, through postFinder if defined
					} else {
						matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
						if (postFinder) {
							postFinder(null, results, matcherOut, xml);
						} else {
							push.apply(results, matcherOut);
						}
					}
				});
			}
	
			function matcherFromTokens(tokens) {
				var checkContext,
				    matcher,
				    j,
				    len = tokens.length,
				    leadingRelative = Expr.relative[tokens[0].type],
				    implicitRelative = leadingRelative || Expr.relative[" "],
				    i = leadingRelative ? 1 : 0,
	
	
				// The foundational matcher ensures that elements are reachable from top-level context(s)
				matchContext = addCombinator(function (elem) {
					return elem === checkContext;
				}, implicitRelative, true),
				    matchAnyContext = addCombinator(function (elem) {
					return indexOf(checkContext, elem) > -1;
				}, implicitRelative, true),
				    matchers = [function (elem, context, xml) {
					var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
	
					// Avoid hanging onto element (issue #299)
					checkContext = null;
					return ret;
				}];
	
				for (; i < len; i++) {
					if (matcher = Expr.relative[tokens[i].type]) {
						matchers = [addCombinator(elementMatcher(matchers), matcher)];
					} else {
						matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
	
						// Return special upon seeing a positional matcher
						if (matcher[expando]) {
	
							// Find the next relative operator (if any) for proper handling
							j = ++i;
							for (; j < len; j++) {
								if (Expr.relative[tokens[j].type]) {
									break;
								}
							}
							return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(
	
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === " " ? "*" : "" })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
						}
						matchers.push(matcher);
					}
				}
	
				return elementMatcher(matchers);
			}
	
			function matcherFromGroupMatchers(elementMatchers, setMatchers) {
				var bySet = setMatchers.length > 0,
				    byElement = elementMatchers.length > 0,
				    superMatcher = function superMatcher(seed, context, xml, results, outermost) {
					var elem,
					    j,
					    matcher,
					    matchedCount = 0,
					    i = "0",
					    unmatched = seed && [],
					    setMatched = [],
					    contextBackup = outermostContext,
	
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]("*", outermost),
	
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1,
					    len = elems.length;
	
					if (outermost) {
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						outermostContext = context == document || context || outermost;
					}
	
					// Add elements passing elementMatchers directly to results
					// Support: IE<9, Safari
					// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
					for (; i !== len && (elem = elems[i]) != null; i++) {
						if (byElement && elem) {
							j = 0;
	
							// Support: IE 11+, Edge 17 - 18+
							// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
							// two documents; shallow comparisons work.
							// eslint-disable-next-line eqeqeq
							if (!context && elem.ownerDocument != document) {
								setDocument(elem);
								xml = !documentIsHTML;
							}
							while (matcher = elementMatchers[j++]) {
								if (matcher(elem, context || document, xml)) {
									results.push(elem);
									break;
								}
							}
							if (outermost) {
								dirruns = dirrunsUnique;
							}
						}
	
						// Track unmatched elements for set filters
						if (bySet) {
	
							// They will have gone through all possible matchers
							if (elem = !matcher && elem) {
								matchedCount--;
							}
	
							// Lengthen the array for every element, matched or not
							if (seed) {
								unmatched.push(elem);
							}
						}
					}
	
					// `i` is now the count of elements visited above, and adding it to `matchedCount`
					// makes the latter nonnegative.
					matchedCount += i;
	
					// Apply set filters to unmatched elements
					// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
					// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
					// no element matchers and no seed.
					// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
					// case, which will result in a "00" `matchedCount` that differs from `i` but is also
					// numerically zero.
					if (bySet && i !== matchedCount) {
						j = 0;
						while (matcher = setMatchers[j++]) {
							matcher(unmatched, setMatched, context, xml);
						}
	
						if (seed) {
	
							// Reintegrate element matches to eliminate the need for sorting
							if (matchedCount > 0) {
								while (i--) {
									if (!(unmatched[i] || setMatched[i])) {
										setMatched[i] = pop.call(results);
									}
								}
							}
	
							// Discard index placeholder values to get only actual matches
							setMatched = condense(setMatched);
						}
	
						// Add matches to results
						push.apply(results, setMatched);
	
						// Seedless set matches succeeding multiple successful matchers stipulate sorting
						if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
	
							Sizzle.uniqueSort(results);
						}
					}
	
					// Override manipulation of globals by nested matchers
					if (outermost) {
						dirruns = dirrunsUnique;
						outermostContext = contextBackup;
					}
	
					return unmatched;
				};
	
				return bySet ? markFunction(superMatcher) : superMatcher;
			}
	
			compile = Sizzle.compile = function (selector, match /* Internal Use Only */) {
				var i,
				    setMatchers = [],
				    elementMatchers = [],
				    cached = compilerCache[selector + " "];
	
				if (!cached) {
	
					// Generate a function of recursive functions that can be used to check each element
					if (!match) {
						match = tokenize(selector);
					}
					i = match.length;
					while (i--) {
						cached = matcherFromTokens(match[i]);
						if (cached[expando]) {
							setMatchers.push(cached);
						} else {
							elementMatchers.push(cached);
						}
					}
	
					// Cache the compiled function
					cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
	
					// Save selector and tokenization
					cached.selector = selector;
				}
				return cached;
			};
	
			/**
	   * A low-level selection function that works with Sizzle's compiled
	   *  selector functions
	   * @param {String|Function} selector A selector or a pre-compiled
	   *  selector function built with Sizzle.compile
	   * @param {Element} context
	   * @param {Array} [results]
	   * @param {Array} [seed] A set of elements to match against
	   */
			select = Sizzle.select = function (selector, context, results, seed) {
				var i,
				    tokens,
				    token,
				    type,
				    find,
				    compiled = typeof selector === "function" && selector,
				    match = !seed && tokenize(selector = compiled.selector || selector);
	
				results = results || [];
	
				// Try to minimize operations if there is only one selector in the list and no seed
				// (the latter of which guarantees us context)
				if (match.length === 1) {
	
					// Reduce context if the leading compound selector is an ID
					tokens = match[0] = match[0].slice(0);
					if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
	
						context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
						if (!context) {
							return results;
	
							// Precompiled matchers will still verify ancestry, so step up a level
						} else if (compiled) {
							context = context.parentNode;
						}
	
						selector = selector.slice(tokens.shift().value.length);
					}
	
					// Fetch a seed set for right-to-left matching
					i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
					while (i--) {
						token = tokens[i];
	
						// Abort if we hit a combinator
						if (Expr.relative[type = token.type]) {
							break;
						}
						if (find = Expr.find[type]) {
	
							// Search, expanding context for leading sibling combinators
							if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
	
								// If seed is empty or no tokens remain, we can return early
								tokens.splice(i, 1);
								selector = seed.length && toSelector(tokens);
								if (!selector) {
									push.apply(results, seed);
									return results;
								}
	
								break;
							}
						}
					}
				}
	
				// Compile and execute a filtering function if one is not provided
				// Provide `match` to avoid retokenization if we modified the selector above
				(compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
				return results;
			};
	
			// One-time assignments
	
			// Sort stability
			support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
	
			// Support: Chrome 14-35+
			// Always assume duplicates if they aren't passed to the comparison function
			support.detectDuplicates = !!hasDuplicate;
	
			// Initialize against the default document
			setDocument();
	
			// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
			// Detached nodes confoundingly follow *each other*
			support.sortDetached = assert(function (el) {
	
				// Should return 1, but returns 4 (following)
				return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
			});
	
			// Support: IE<8
			// Prevent attribute/property "interpolation"
			// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
			if (!assert(function (el) {
				el.innerHTML = "<a href='#'></a>";
				return el.firstChild.getAttribute("href") === "#";
			})) {
				addHandle("type|href|height|width", function (elem, name, isXML) {
					if (!isXML) {
						return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
					}
				});
			}
	
			// Support: IE<9
			// Use defaultValue in place of getAttribute("value")
			if (!support.attributes || !assert(function (el) {
				el.innerHTML = "<input/>";
				el.firstChild.setAttribute("value", "");
				return el.firstChild.getAttribute("value") === "";
			})) {
				addHandle("value", function (elem, _name, isXML) {
					if (!isXML && elem.nodeName.toLowerCase() === "input") {
						return elem.defaultValue;
					}
				});
			}
	
			// Support: IE<9
			// Use getAttributeNode to fetch booleans when getAttribute lies
			if (!assert(function (el) {
				return el.getAttribute("disabled") == null;
			})) {
				addHandle(booleans, function (elem, name, isXML) {
					var val;
					if (!isXML) {
						return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
					}
				});
			}
	
			return Sizzle;
		}(window);
	
		jQuery.find = Sizzle;
		jQuery.expr = Sizzle.selectors;
	
		// Deprecated
		jQuery.expr[":"] = jQuery.expr.pseudos;
		jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
		jQuery.text = Sizzle.getText;
		jQuery.isXMLDoc = Sizzle.isXML;
		jQuery.contains = Sizzle.contains;
		jQuery.escapeSelector = Sizzle.escape;
	
		var dir = function dir(elem, _dir, until) {
			var matched = [],
			    truncate = until !== undefined;
	
			while ((elem = elem[_dir]) && elem.nodeType !== 9) {
				if (elem.nodeType === 1) {
					if (truncate && jQuery(elem).is(until)) {
						break;
					}
					matched.push(elem);
				}
			}
			return matched;
		};
	
		var _siblings = function _siblings(n, elem) {
			var matched = [];
	
			for (; n; n = n.nextSibling) {
				if (n.nodeType === 1 && n !== elem) {
					matched.push(n);
				}
			}
	
			return matched;
		};
	
		var rneedsContext = jQuery.expr.match.needsContext;
	
		function nodeName(elem, name) {
	
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		}
		var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
	
		// Implement the identical functionality for filter and not
		function winnow(elements, qualifier, not) {
			if (isFunction(qualifier)) {
				return jQuery.grep(elements, function (elem, i) {
					return !!qualifier.call(elem, i, elem) !== not;
				});
			}
	
			// Single element
			if (qualifier.nodeType) {
				return jQuery.grep(elements, function (elem) {
					return elem === qualifier !== not;
				});
			}
	
			// Arraylike of elements (jQuery, arguments, Array)
			if (typeof qualifier !== "string") {
				return jQuery.grep(elements, function (elem) {
					return indexOf.call(qualifier, elem) > -1 !== not;
				});
			}
	
			// Filtered directly for both simple and complex selectors
			return jQuery.filter(qualifier, elements, not);
		}
	
		jQuery.filter = function (expr, elems, not) {
			var elem = elems[0];
	
			if (not) {
				expr = ":not(" + expr + ")";
			}
	
			if (elems.length === 1 && elem.nodeType === 1) {
				return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
			}
	
			return jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
				return elem.nodeType === 1;
			}));
		};
	
		jQuery.fn.extend({
			find: function find(selector) {
				var i,
				    ret,
				    len = this.length,
				    self = this;
	
				if (typeof selector !== "string") {
					return this.pushStack(jQuery(selector).filter(function () {
						for (i = 0; i < len; i++) {
							if (jQuery.contains(self[i], this)) {
								return true;
							}
						}
					}));
				}
	
				ret = this.pushStack([]);
	
				for (i = 0; i < len; i++) {
					jQuery.find(selector, self[i], ret);
				}
	
				return len > 1 ? jQuery.uniqueSort(ret) : ret;
			},
			filter: function filter(selector) {
				return this.pushStack(winnow(this, selector || [], false));
			},
			not: function not(selector) {
				return this.pushStack(winnow(this, selector || [], true));
			},
			is: function is(selector) {
				return !!winnow(this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
			}
		});
	
		// Initialize a jQuery object
	
	
		// A central reference to the root jQuery(document)
		var rootjQuery,
	
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
		    init = jQuery.fn.init = function (selector, context, root) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if (!selector) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if (typeof selector === "string") {
				if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [null, selector, null];
				} else {
					match = rquickExpr.exec(selector);
				}
	
				// Match html or make sure no context is specified for #id
				if (match && (match[1] || !context)) {
	
					// HANDLE: $(html) -> $(array)
					if (match[1]) {
						context = context instanceof jQuery ? context[0] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
	
						// HANDLE: $(html, props)
						if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
							for (match in context) {
	
								// Properties of context are called as methods if possible
								if (isFunction(this[match])) {
									this[match](context[match]);
	
									// ...and otherwise set as attributes
								} else {
									this.attr(match, context[match]);
								}
							}
						}
	
						return this;
	
						// HANDLE: $(#id)
					} else {
						elem = document.getElementById(match[2]);
	
						if (elem) {
	
							// Inject the element directly into the jQuery object
							this[0] = elem;
							this.length = 1;
						}
						return this;
					}
	
					// HANDLE: $(expr, $(...))
				} else if (!context || context.jquery) {
					return (context || root).find(selector);
	
					// HANDLE: $(expr, context)
					// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor(context).find(selector);
				}
	
				// HANDLE: $(DOMElement)
			} else if (selector.nodeType) {
				this[0] = selector;
				this.length = 1;
				return this;
	
				// HANDLE: $(function)
				// Shortcut for document ready
			} else if (isFunction(selector)) {
				return root.ready !== undefined ? root.ready(selector) :
	
				// Execute immediately if ready is not present
				selector(jQuery);
			}
	
			return jQuery.makeArray(selector, this);
		};
	
		// Give the init function the jQuery prototype for later instantiation
		init.prototype = jQuery.fn;
	
		// Initialize central reference
		rootjQuery = jQuery(document);
	
		var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
		jQuery.fn.extend({
			has: function has(target) {
				var targets = jQuery(target, this),
				    l = targets.length;
	
				return this.filter(function () {
					var i = 0;
					for (; i < l; i++) {
						if (jQuery.contains(this, targets[i])) {
							return true;
						}
					}
				});
			},
	
			closest: function closest(selectors, context) {
				var cur,
				    i = 0,
				    l = this.length,
				    matched = [],
				    targets = typeof selectors !== "string" && jQuery(selectors);
	
				// Positional selectors never match, since there's no _selection_ context
				if (!rneedsContext.test(selectors)) {
					for (; i < l; i++) {
						for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
	
							// Always skip document fragments
							if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
	
								matched.push(cur);
								break;
							}
						}
					}
				}
	
				return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
			},
	
			// Determine the position of an element within the set
			index: function index(elem) {
	
				// No argument, return index in parent
				if (!elem) {
					return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
				}
	
				// Index in selector
				if (typeof elem === "string") {
					return indexOf.call(jQuery(elem), this[0]);
				}
	
				// Locate the position of the desired element
				return indexOf.call(this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[0] : elem);
			},
	
			add: function add(selector, context) {
				return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
			},
	
			addBack: function addBack(selector) {
				return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
			}
		});
	
		function sibling(cur, dir) {
			while ((cur = cur[dir]) && cur.nodeType !== 1) {}
			return cur;
		}
	
		jQuery.each({
			parent: function parent(elem) {
				var parent = elem.parentNode;
				return parent && parent.nodeType !== 11 ? parent : null;
			},
			parents: function parents(elem) {
				return dir(elem, "parentNode");
			},
			parentsUntil: function parentsUntil(elem, _i, until) {
				return dir(elem, "parentNode", until);
			},
			next: function next(elem) {
				return sibling(elem, "nextSibling");
			},
			prev: function prev(elem) {
				return sibling(elem, "previousSibling");
			},
			nextAll: function nextAll(elem) {
				return dir(elem, "nextSibling");
			},
			prevAll: function prevAll(elem) {
				return dir(elem, "previousSibling");
			},
			nextUntil: function nextUntil(elem, _i, until) {
				return dir(elem, "nextSibling", until);
			},
			prevUntil: function prevUntil(elem, _i, until) {
				return dir(elem, "previousSibling", until);
			},
			siblings: function siblings(elem) {
				return _siblings((elem.parentNode || {}).firstChild, elem);
			},
			children: function children(elem) {
				return _siblings(elem.firstChild);
			},
			contents: function contents(elem) {
				if (elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto(elem.contentDocument)) {
	
					return elem.contentDocument;
				}
	
				// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
				// Treat the template element as a regular one in browsers that
				// don't support it.
				if (nodeName(elem, "template")) {
					elem = elem.content || elem;
				}
	
				return jQuery.merge([], elem.childNodes);
			}
		}, function (name, fn) {
			jQuery.fn[name] = function (until, selector) {
				var matched = jQuery.map(this, fn, until);
	
				if (name.slice(-5) !== "Until") {
					selector = until;
				}
	
				if (selector && typeof selector === "string") {
					matched = jQuery.filter(selector, matched);
				}
	
				if (this.length > 1) {
	
					// Remove duplicates
					if (!guaranteedUnique[name]) {
						jQuery.uniqueSort(matched);
					}
	
					// Reverse order for parents* and prev-derivatives
					if (rparentsprev.test(name)) {
						matched.reverse();
					}
				}
	
				return this.pushStack(matched);
			};
		});
		var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
	
		// Convert String-formatted options into Object-formatted ones
		function createOptions(options) {
			var object = {};
			jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
				object[flag] = true;
			});
			return object;
		}
	
		/*
	  * Create a callback list using the following parameters:
	  *
	  *	options: an optional list of space-separated options that will change how
	  *			the callback list behaves or a more traditional option object
	  *
	  * By default a callback list will act like an event callback list and can be
	  * "fired" multiple times.
	  *
	  * Possible options:
	  *
	  *	once:			will ensure the callback list can only be fired once (like a Deferred)
	  *
	  *	memory:			will keep track of previous values and will call any callback added
	  *					after the list has been fired right away with the latest "memorized"
	  *					values (like a Deferred)
	  *
	  *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	  *
	  *	stopOnFalse:	interrupt callings when a callback returns false
	  *
	  */
		jQuery.Callbacks = function (options) {
	
			// Convert options from String-formatted to Object-formatted if needed
			// (we check in cache first)
			options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
	
			var // Flag to know if list is currently firing
			firing,
	
	
			// Last fire value for non-forgettable lists
			memory,
	
	
			// Flag to know if list was already fired
			_fired,
	
	
			// Flag to prevent firing
			_locked,
	
	
			// Actual callback list
			list = [],
	
	
			// Queue of execution data for repeatable lists
			queue = [],
	
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
	
			// Fire callbacks
			fire = function fire() {
	
				// Enforce single-firing
				_locked = _locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				_fired = firing = true;
				for (; queue.length; firingIndex = -1) {
					memory = queue.shift();
					while (++firingIndex < list.length) {
	
						// Run callback and check for early termination
						if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if (!options.memory) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if (_locked) {
	
					// Keep an empty list if we have data for future add calls
					if (memory) {
						list = [];
	
						// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function add() {
					if (list) {
	
						// If we have memory from a past run, we should fire after adding
						if (memory && !firing) {
							firingIndex = list.length - 1;
							queue.push(memory);
						}
	
						(function add(args) {
							jQuery.each(args, function (_, arg) {
								if (isFunction(arg)) {
									if (!options.unique || !self.has(arg)) {
										list.push(arg);
									}
								} else if (arg && arg.length && toType(arg) !== "string") {
	
									// Inspect recursively
									add(arg);
								}
							});
						})(arguments);
	
						if (memory && !firing) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function remove() {
					jQuery.each(arguments, function (_, arg) {
						var index;
						while ((index = jQuery.inArray(arg, list, index)) > -1) {
							list.splice(index, 1);
	
							// Handle firing indexes
							if (index <= firingIndex) {
								firingIndex--;
							}
						}
					});
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function has(fn) {
					return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function empty() {
					if (list) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function disable() {
					_locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function disabled() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function lock() {
					_locked = queue = [];
					if (!memory && !firing) {
						list = memory = "";
					}
					return this;
				},
				locked: function locked() {
					return !!_locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function fireWith(context, args) {
					if (!_locked) {
						args = args || [];
						args = [context, args.slice ? args.slice() : args];
						queue.push(args);
						if (!firing) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function fire() {
					self.fireWith(this, arguments);
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function fired() {
					return !!_fired;
				}
			};
	
			return self;
		};
	
		function Identity(v) {
			return v;
		}
		function Thrower(ex) {
			throw ex;
		}
	
		function adoptValue(value, resolve, reject, noValue) {
			var method;
	
			try {
	
				// Check for promise aspect first to privilege synchronous behavior
				if (value && isFunction(method = value.promise)) {
					method.call(value).done(resolve).fail(reject);
	
					// Other thenables
				} else if (value && isFunction(method = value.then)) {
					method.call(value, resolve, reject);
	
					// Other non-thenables
				} else {
	
					// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
					// * false: [ value ].slice( 0 ) => resolve( value )
					// * true: [ value ].slice( 1 ) => resolve()
					resolve.apply(undefined, [value].slice(noValue));
				}
	
				// For Promises/A+, convert exceptions into rejections
				// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
				// Deferred#then to conditionally suppress rejection.
			} catch (value) {
	
				// Support: Android 4.0 only
				// Strict mode functions invoked without .call/.apply get global-object context
				reject.apply(undefined, [value]);
			}
		}
	
		jQuery.extend({
	
			Deferred: function Deferred(func) {
				var tuples = [
	
				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				["notify", "progress", jQuery.Callbacks("memory"), jQuery.Callbacks("memory"), 2], ["resolve", "done", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 1, "rejected"]],
				    _state = "pending",
				    _promise = {
					state: function state() {
						return _state;
					},
					always: function always() {
						deferred.done(arguments).fail(arguments);
						return this;
					},
					"catch": function _catch(fn) {
						return _promise.then(null, fn);
					},
	
					// Keep pipe for back-compat
					pipe: function pipe() /* fnDone, fnFail, fnProgress */{
						var fns = arguments;
	
						return jQuery.Deferred(function (newDefer) {
							jQuery.each(tuples, function (_i, tuple) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[tuple[1]](function () {
									var returned = fn && fn.apply(this, arguments);
									if (returned && isFunction(returned.promise)) {
										returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
									} else {
										newDefer[tuple[0] + "With"](this, fn ? [returned] : arguments);
									}
								});
							});
							fns = null;
						}).promise();
					},
					then: function then(onFulfilled, onRejected, onProgress) {
						var maxDepth = 0;
						function resolve(depth, deferred, handler, special) {
							return function () {
								var that = this,
								    args = arguments,
								    mightThrow = function mightThrow() {
									var returned, then;
	
									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if (depth < maxDepth) {
										return;
									}
	
									returned = handler.apply(that, args);
	
									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if (returned === deferred.promise()) {
										throw new TypeError("Thenable self-resolution");
									}
	
									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned && (
	
									// Support: Promises/A+ section 2.3.4
									// https://promisesaplus.com/#point-64
									// Only check objects and functions for thenability
									(typeof returned === "undefined" ? "undefined" : _typeof(returned)) === "object" || typeof returned === "function") && returned.then;
	
									// Handle a returned thenable
									if (isFunction(then)) {
	
										// Special processors (notify) just wait for resolution
										if (special) {
											then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
	
											// Normal processors (resolve) also hook into progress
										} else {
	
											// ...and disregard older resolution values
											maxDepth++;
	
											then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
										}
	
										// Handle all other returned values
									} else {
	
										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if (handler !== Identity) {
											that = undefined;
											args = [returned];
										}
	
										// Process the value(s)
										// Default process is resolve
										(special || deferred.resolveWith)(that, args);
									}
								},
	
	
								// Only normal processors (resolve) catch and reject exceptions
								process = special ? mightThrow : function () {
									try {
										mightThrow();
									} catch (e) {
	
										if (jQuery.Deferred.exceptionHook) {
											jQuery.Deferred.exceptionHook(e, process.stackTrace);
										}
	
										// Support: Promises/A+ section 2.3.3.3.4.1
										// https://promisesaplus.com/#point-61
										// Ignore post-resolution exceptions
										if (depth + 1 >= maxDepth) {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if (handler !== Thrower) {
												that = undefined;
												args = [e];
											}
	
											deferred.rejectWith(that, args);
										}
									}
								};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if (depth) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if (jQuery.Deferred.getStackHook) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout(process);
								}
							};
						}
	
						return jQuery.Deferred(function (newDefer) {
	
							// progress_handlers.add( ... )
							tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
	
							// fulfilled_handlers.add( ... )
							tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
	
							// rejected_handlers.add( ... )
							tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
						}).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function promise(obj) {
						return obj != null ? jQuery.extend(obj, _promise) : _promise;
					}
				},
				    deferred = {};
	
				// Add list-specific methods
				jQuery.each(tuples, function (i, tuple) {
					var list = tuple[2],
					    stateString = tuple[5];
	
					// promise.progress = list.add
					// promise.done = list.add
					// promise.fail = list.add
					_promise[tuple[1]] = list.add;
	
					// Handle state
					if (stateString) {
						list.add(function () {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							_state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[3 - i][2].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[3 - i][3].disable,
	
						// progress_callbacks.lock
						tuples[0][2].lock,
	
						// progress_handlers.lock
						tuples[0][3].lock);
					}
	
					// progress_handlers.fire
					// fulfilled_handlers.fire
					// rejected_handlers.fire
					list.add(tuple[3].fire);
	
					// deferred.notify = function() { deferred.notifyWith(...) }
					// deferred.resolve = function() { deferred.resolveWith(...) }
					// deferred.reject = function() { deferred.rejectWith(...) }
					deferred[tuple[0]] = function () {
						deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
						return this;
					};
	
					// deferred.notifyWith = list.fireWith
					// deferred.resolveWith = list.fireWith
					// deferred.rejectWith = list.fireWith
					deferred[tuple[0] + "With"] = list.fireWith;
				});
	
				// Make the deferred a promise
				_promise.promise(deferred);
	
				// Call given func if any
				if (func) {
					func.call(deferred, deferred);
				}
	
				// All done!
				return deferred;
			},
	
			// Deferred helper
			when: function when(singleValue) {
				var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
	
				// count of unprocessed arguments
				i = remaining,
	
	
				// subordinate fulfillment data
				resolveContexts = Array(i),
				    resolveValues = _slice.call(arguments),
	
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
	
				// subordinate callback factory
				updateFunc = function updateFunc(i) {
					return function (value) {
						resolveContexts[i] = this;
						resolveValues[i] = arguments.length > 1 ? _slice.call(arguments) : value;
						if (! --remaining) {
							primary.resolveWith(resolveContexts, resolveValues);
						}
					};
				};
	
				// Single- and empty arguments are adopted like Promise.resolve
				if (remaining <= 1) {
					adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
	
					// Use .then() to unwrap secondary thenables (cf. gh-3000)
					if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) {
	
						return primary.then();
					}
				}
	
				// Multiple arguments are aggregated like Promise.all array elements
				while (i--) {
					adoptValue(resolveValues[i], updateFunc(i), primary.reject);
				}
	
				return primary.promise();
			}
		});
	
		// These usually indicate a programmer mistake during development,
		// warn about them ASAP rather than swallowing them by default.
		var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
		jQuery.Deferred.exceptionHook = function (error, stack) {
	
			// Support: IE 8 - 9 only
			// Console exists when dev tools are open, which can happen at any time
			if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
				window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
			}
		};
	
		jQuery.readyException = function (error) {
			window.setTimeout(function () {
				throw error;
			});
		};
	
		// The deferred used on DOM ready
		var readyList = jQuery.Deferred();
	
		jQuery.fn.ready = function (fn) {
	
			readyList.then(fn)
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch(function (error) {
				jQuery.readyException(error);
			});
	
			return this;
		};
	
		jQuery.extend({
	
			// Is the DOM ready to be used? Set to true once it occurs.
			isReady: false,
	
			// A counter to track how many items to wait for before
			// the ready event fires. See #6781
			readyWait: 1,
	
			// Handle when the DOM is ready
			ready: function ready(wait) {
	
				// Abort if there are pending holds or we're already ready
				if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
					return;
				}
	
				// Remember that the DOM is ready
				jQuery.isReady = true;
	
				// If a normal DOM Ready event fired, decrement, and wait if need be
				if (wait !== true && --jQuery.readyWait > 0) {
					return;
				}
	
				// If there are functions bound, to execute
				readyList.resolveWith(document, [jQuery]);
			}
		});
	
		jQuery.ready.then = readyList.then;
	
		// The ready event handler and self cleanup method
		function completed() {
			document.removeEventListener("DOMContentLoaded", completed);
			window.removeEventListener("load", completed);
			jQuery.ready();
		}
	
		// Catch cases where $(document).ready() is called
		// after the browser event has already occurred.
		// Support: IE <=9 - 10 only
		// Older IE sometimes signals "interactive" too soon
		if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) {
	
			// Handle it asynchronously to allow scripts the opportunity to delay ready
			window.setTimeout(jQuery.ready);
		} else {
	
			// Use the handy event callback
			document.addEventListener("DOMContentLoaded", completed);
	
			// A fallback to window.onload, that will always work
			window.addEventListener("load", completed);
		}
	
		// Multifunctional method to get and set values of a collection
		// The value/s can optionally be executed if it's a function
		var access = function access(elems, fn, key, value, chainable, emptyGet, raw) {
			var i = 0,
			    len = elems.length,
			    bulk = key == null;
	
			// Sets many values
			if (toType(key) === "object") {
				chainable = true;
				for (i in key) {
					access(elems, fn, i, key[i], true, emptyGet, raw);
				}
	
				// Sets one value
			} else if (value !== undefined) {
				chainable = true;
	
				if (!isFunction(value)) {
					raw = true;
				}
	
				if (bulk) {
	
					// Bulk operations run against the entire set
					if (raw) {
						fn.call(elems, value);
						fn = null;
	
						// ...except when executing function values
					} else {
						bulk = fn;
						fn = function fn(elem, _key, value) {
							return bulk.call(jQuery(elem), value);
						};
					}
				}
	
				if (fn) {
					for (; i < len; i++) {
						fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
					}
				}
			}
	
			if (chainable) {
				return elems;
			}
	
			// Gets
			if (bulk) {
				return fn.call(elems);
			}
	
			return len ? fn(elems[0], key) : emptyGet;
		};
	
		// Matches dashed string for camelizing
		var rmsPrefix = /^-ms-/,
		    rdashAlpha = /-([a-z])/g;
	
		// Used by camelCase as callback to replace()
		function fcamelCase(_all, letter) {
			return letter.toUpperCase();
		}
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE <=9 - 11, Edge 12 - 15
		// Microsoft forgot to hump their vendor prefix (#9572)
		function camelCase(string) {
			return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
		}
		var acceptData = function acceptData(owner) {
	
			// Accepts only:
			//  - Node
			//    - Node.ELEMENT_NODE
			//    - Node.DOCUMENT_NODE
			//  - Object
			//    - Any
			return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
		};
	
		function Data() {
			this.expando = jQuery.expando + Data.uid++;
		}
	
		Data.uid = 1;
	
		Data.prototype = {
	
			cache: function cache(owner) {
	
				// Check if the owner object already has a cache
				var value = owner[this.expando];
	
				// If not, create one
				if (!value) {
					value = {};
	
					// We can accept data for non-element nodes in modern browsers,
					// but we should not, see #8335.
					// Always return an empty object.
					if (acceptData(owner)) {
	
						// If it is a node unlikely to be stringify-ed or looped over
						// use plain assignment
						if (owner.nodeType) {
							owner[this.expando] = value;
	
							// Otherwise secure it in a non-enumerable property
							// configurable must be true to allow the property to be
							// deleted when data is removed
						} else {
							Object.defineProperty(owner, this.expando, {
								value: value,
								configurable: true
							});
						}
					}
				}
	
				return value;
			},
			set: function set(owner, data, value) {
				var prop,
				    cache = this.cache(owner);
	
				// Handle: [ owner, key, value ] args
				// Always use camelCase key (gh-2257)
				if (typeof data === "string") {
					cache[camelCase(data)] = value;
	
					// Handle: [ owner, { properties } ] args
				} else {
	
					// Copy the properties one-by-one to the cache object
					for (prop in data) {
						cache[camelCase(prop)] = data[prop];
					}
				}
				return cache;
			},
			get: function get(owner, key) {
				return key === undefined ? this.cache(owner) :
	
				// Always use camelCase key (gh-2257)
				owner[this.expando] && owner[this.expando][camelCase(key)];
			},
			access: function access(owner, key, value) {
	
				// In cases where either:
				//
				//   1. No key was specified
				//   2. A string key was specified, but no value provided
				//
				// Take the "read" path and allow the get method to determine
				// which value to return, respectively either:
				//
				//   1. The entire cache object
				//   2. The data stored at the key
				//
				if (key === undefined || key && typeof key === "string" && value === undefined) {
	
					return this.get(owner, key);
				}
	
				// When the key is not a string, or both a key and value
				// are specified, set or extend (existing objects) with either:
				//
				//   1. An object of properties
				//   2. A key and value
				//
				this.set(owner, key, value);
	
				// Since the "set" path can have two possible entry points
				// return the expected data based on which path was taken[*]
				return value !== undefined ? value : key;
			},
			remove: function remove(owner, key) {
				var i,
				    cache = owner[this.expando];
	
				if (cache === undefined) {
					return;
				}
	
				if (key !== undefined) {
	
					// Support array or space separated string of keys
					if (Array.isArray(key)) {
	
						// If key is an array of keys...
						// We always set camelCase keys, so remove that.
						key = key.map(camelCase);
					} else {
						key = camelCase(key);
	
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
					}
	
					i = key.length;
	
					while (i--) {
						delete cache[key[i]];
					}
				}
	
				// Remove the expando if there's no more data
				if (key === undefined || jQuery.isEmptyObject(cache)) {
	
					// Support: Chrome <=35 - 45
					// Webkit & Blink performance suffers when deleting properties
					// from DOM nodes, so set to undefined instead
					// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
					if (owner.nodeType) {
						owner[this.expando] = undefined;
					} else {
						delete owner[this.expando];
					}
				}
			},
			hasData: function hasData(owner) {
				var cache = owner[this.expando];
				return cache !== undefined && !jQuery.isEmptyObject(cache);
			}
		};
		var dataPriv = new Data();
	
		var dataUser = new Data();
	
		//	Implementation Summary
		//
		//	1. Enforce API surface and semantic compatibility with 1.9.x branch
		//	2. Improve the module's maintainability by reducing the storage
		//		paths to a single mechanism.
		//	3. Use the same single mechanism to support "private" and "user" data.
		//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
		//	5. Avoid exposing implementation details on user objects (eg. expando properties)
		//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
		var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		    rmultiDash = /[A-Z]/g;
	
		function getData(data) {
			if (data === "true") {
				return true;
			}
	
			if (data === "false") {
				return false;
			}
	
			if (data === "null") {
				return null;
			}
	
			// Only convert to a number if it doesn't change the string
			if (data === +data + "") {
				return +data;
			}
	
			if (rbrace.test(data)) {
				return JSON.parse(data);
			}
	
			return data;
		}
	
		function dataAttr(elem, key, data) {
			var name;
	
			// If nothing was found internally, try to fetch any
			// data from the HTML5 data-* attribute
			if (data === undefined && elem.nodeType === 1) {
				name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
				data = elem.getAttribute(name);
	
				if (typeof data === "string") {
					try {
						data = getData(data);
					} catch (e) {}
	
					// Make sure we set the data so it isn't changed later
					dataUser.set(elem, key, data);
				} else {
					data = undefined;
				}
			}
			return data;
		}
	
		jQuery.extend({
			hasData: function hasData(elem) {
				return dataUser.hasData(elem) || dataPriv.hasData(elem);
			},
	
			data: function data(elem, name, _data) {
				return dataUser.access(elem, name, _data);
			},
	
			removeData: function removeData(elem, name) {
				dataUser.remove(elem, name);
			},
	
			// TODO: Now that all calls to _data and _removeData have been replaced
			// with direct calls to dataPriv methods, these can be deprecated.
			_data: function _data(elem, name, data) {
				return dataPriv.access(elem, name, data);
			},
	
			_removeData: function _removeData(elem, name) {
				dataPriv.remove(elem, name);
			}
		});
	
		jQuery.fn.extend({
			data: function data(key, value) {
				var i,
				    name,
				    data,
				    elem = this[0],
				    attrs = elem && elem.attributes;
	
				// Gets all values
				if (key === undefined) {
					if (this.length) {
						data = dataUser.get(elem);
	
						if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
							i = attrs.length;
							while (i--) {
	
								// Support: IE 11 only
								// The attrs elements can be null (#14894)
								if (attrs[i]) {
									name = attrs[i].name;
									if (name.indexOf("data-") === 0) {
										name = camelCase(name.slice(5));
										dataAttr(elem, name, data[name]);
									}
								}
							}
							dataPriv.set(elem, "hasDataAttrs", true);
						}
					}
	
					return data;
				}
	
				// Sets multiple values
				if ((typeof key === "undefined" ? "undefined" : _typeof(key)) === "object") {
					return this.each(function () {
						dataUser.set(this, key);
					});
				}
	
				return access(this, function (value) {
					var data;
	
					// The calling jQuery object (element matches) is not empty
					// (and therefore has an element appears at this[ 0 ]) and the
					// `value` parameter was not undefined. An empty jQuery object
					// will result in `undefined` for elem = this[ 0 ] which will
					// throw an exception if an attempt to read a data cache is made.
					if (elem && value === undefined) {
	
						// Attempt to get data from the cache
						// The key will always be camelCased in Data
						data = dataUser.get(elem, key);
						if (data !== undefined) {
							return data;
						}
	
						// Attempt to "discover" the data in
						// HTML5 custom data-* attrs
						data = dataAttr(elem, key);
						if (data !== undefined) {
							return data;
						}
	
						// We tried really hard, but the data doesn't exist.
						return;
					}
	
					// Set the data...
					this.each(function () {
	
						// We always store the camelCased key
						dataUser.set(this, key, value);
					});
				}, null, value, arguments.length > 1, null, true);
			},
	
			removeData: function removeData(key) {
				return this.each(function () {
					dataUser.remove(this, key);
				});
			}
		});
	
		jQuery.extend({
			queue: function queue(elem, type, data) {
				var queue;
	
				if (elem) {
					type = (type || "fx") + "queue";
					queue = dataPriv.get(elem, type);
	
					// Speed up dequeue by getting out quickly if this is just a lookup
					if (data) {
						if (!queue || Array.isArray(data)) {
							queue = dataPriv.access(elem, type, jQuery.makeArray(data));
						} else {
							queue.push(data);
						}
					}
					return queue || [];
				}
			},
	
			dequeue: function dequeue(elem, type) {
				type = type || "fx";
	
				var queue = jQuery.queue(elem, type),
				    startLength = queue.length,
				    fn = queue.shift(),
				    hooks = jQuery._queueHooks(elem, type),
				    next = function next() {
					jQuery.dequeue(elem, type);
				};
	
				// If the fx queue is dequeued, always remove the progress sentinel
				if (fn === "inprogress") {
					fn = queue.shift();
					startLength--;
				}
	
				if (fn) {
	
					// Add a progress sentinel to prevent the fx queue from being
					// automatically dequeued
					if (type === "fx") {
						queue.unshift("inprogress");
					}
	
					// Clear up the last queue stop function
					delete hooks.stop;
					fn.call(elem, next, hooks);
				}
	
				if (!startLength && hooks) {
					hooks.empty.fire();
				}
			},
	
			// Not public - generate a queueHooks object, or return the current one
			_queueHooks: function _queueHooks(elem, type) {
				var key = type + "queueHooks";
				return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
					empty: jQuery.Callbacks("once memory").add(function () {
						dataPriv.remove(elem, [type + "queue", key]);
					})
				});
			}
		});
	
		jQuery.fn.extend({
			queue: function queue(type, data) {
				var setter = 2;
	
				if (typeof type !== "string") {
					data = type;
					type = "fx";
					setter--;
				}
	
				if (arguments.length < setter) {
					return jQuery.queue(this[0], type);
				}
	
				return data === undefined ? this : this.each(function () {
					var queue = jQuery.queue(this, type, data);
	
					// Ensure a hooks for this queue
					jQuery._queueHooks(this, type);
	
					if (type === "fx" && queue[0] !== "inprogress") {
						jQuery.dequeue(this, type);
					}
				});
			},
			dequeue: function dequeue(type) {
				return this.each(function () {
					jQuery.dequeue(this, type);
				});
			},
			clearQueue: function clearQueue(type) {
				return this.queue(type || "fx", []);
			},
	
			// Get a promise resolved when queues of a certain type
			// are emptied (fx is the type by default)
			promise: function promise(type, obj) {
				var tmp,
				    count = 1,
				    defer = jQuery.Deferred(),
				    elements = this,
				    i = this.length,
				    resolve = function resolve() {
					if (! --count) {
						defer.resolveWith(elements, [elements]);
					}
				};
	
				if (typeof type !== "string") {
					obj = type;
					type = undefined;
				}
				type = type || "fx";
	
				while (i--) {
					tmp = dataPriv.get(elements[i], type + "queueHooks");
					if (tmp && tmp.empty) {
						count++;
						tmp.empty.add(resolve);
					}
				}
				resolve();
				return defer.promise(obj);
			}
		});
		var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
	
		var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
	
		var cssExpand = ["Top", "Right", "Bottom", "Left"];
	
		var documentElement = document.documentElement;
	
		var isAttached = function isAttached(elem) {
			return jQuery.contains(elem.ownerDocument, elem);
		},
		    composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if (documentElement.getRootNode) {
			isAttached = function isAttached(elem) {
				return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
			};
		}
		var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" || elem.style.display === "" &&
	
			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached(elem) && jQuery.css(elem, "display") === "none";
		};
	
		function adjustCSS(elem, prop, valueParts, tween) {
			var adjusted,
			    scale,
			    maxIterations = 20,
			    currentValue = tween ? function () {
				return tween.cur();
			} : function () {
				return jQuery.css(elem, prop, "");
			},
			    initial = currentValue(),
			    unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"),
	
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
	
			if (initialInUnit && initialInUnit[3] !== unit) {
	
				// Support: Firefox <=54
				// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
				initial = initial / 2;
	
				// Trust units reported by jQuery.css
				unit = unit || initialInUnit[3];
	
				// Iteratively approximate from a nonzero starting point
				initialInUnit = +initial || 1;
	
				while (maxIterations--) {
	
					// Evaluate and update our best guess (doubling guesses that zero out).
					// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
					jQuery.style(elem, prop, initialInUnit + unit);
					if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
						maxIterations = 0;
					}
					initialInUnit = initialInUnit / scale;
				}
	
				initialInUnit = initialInUnit * 2;
				jQuery.style(elem, prop, initialInUnit + unit);
	
				// Make sure we update the tween properties later on
				valueParts = valueParts || [];
			}
	
			if (valueParts) {
				initialInUnit = +initialInUnit || +initial || 0;
	
				// Apply relative offset (+=/-=) if specified
				adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
				if (tween) {
					tween.unit = unit;
					tween.start = initialInUnit;
					tween.end = adjusted;
				}
			}
			return adjusted;
		}
	
		var defaultDisplayMap = {};
	
		function getDefaultDisplay(elem) {
			var temp,
			    doc = elem.ownerDocument,
			    nodeName = elem.nodeName,
			    display = defaultDisplayMap[nodeName];
	
			if (display) {
				return display;
			}
	
			temp = doc.body.appendChild(doc.createElement(nodeName));
			display = jQuery.css(temp, "display");
	
			temp.parentNode.removeChild(temp);
	
			if (display === "none") {
				display = "block";
			}
			defaultDisplayMap[nodeName] = display;
	
			return display;
		}
	
		function showHide(elements, show) {
			var display,
			    elem,
			    values = [],
			    index = 0,
			    length = elements.length;
	
			// Determine new display value for elements that need to change
			for (; index < length; index++) {
				elem = elements[index];
				if (!elem.style) {
					continue;
				}
	
				display = elem.style.display;
				if (show) {
	
					// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
					// check is required in this first loop unless we have a nonempty display value (either
					// inline or about-to-be-restored)
					if (display === "none") {
						values[index] = dataPriv.get(elem, "display") || null;
						if (!values[index]) {
							elem.style.display = "";
						}
					}
					if (elem.style.display === "" && isHiddenWithinTree(elem)) {
						values[index] = getDefaultDisplay(elem);
					}
				} else {
					if (display !== "none") {
						values[index] = "none";
	
						// Remember what we're overwriting
						dataPriv.set(elem, "display", display);
					}
				}
			}
	
			// Set the display of the elements in a second loop to avoid constant reflow
			for (index = 0; index < length; index++) {
				if (values[index] != null) {
					elements[index].style.display = values[index];
				}
			}
	
			return elements;
		}
	
		jQuery.fn.extend({
			show: function show() {
				return showHide(this, true);
			},
			hide: function hide() {
				return showHide(this);
			},
			toggle: function toggle(state) {
				if (typeof state === "boolean") {
					return state ? this.show() : this.hide();
				}
	
				return this.each(function () {
					if (isHiddenWithinTree(this)) {
						jQuery(this).show();
					} else {
						jQuery(this).hide();
					}
				});
			}
		});
		var rcheckableType = /^(?:checkbox|radio)$/i;
	
		var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
	
		var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
	
		(function () {
			var fragment = document.createDocumentFragment(),
			    div = fragment.appendChild(document.createElement("div")),
			    input = document.createElement("input");
	
			// Support: Android 4.0 - 4.3 only
			// Check state lost if the name is set (#11217)
			// Support: Windows Web Apps (WWA)
			// `name` and `type` must use .setAttribute for WWA (#14901)
			input.setAttribute("type", "radio");
			input.setAttribute("checked", "checked");
			input.setAttribute("name", "t");
	
			div.appendChild(input);
	
			// Support: Android <=4.1 only
			// Older WebKit doesn't clone checked state correctly in fragments
			support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
	
			// Support: IE <=11 only
			// Make sure textarea (and checkbox) defaultValue is properly cloned
			div.innerHTML = "<textarea>x</textarea>";
			support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
	
			// Support: IE <=9 only
			// IE <=9 replaces <option> tags with their contents when inserted outside of
			// the select element.
			div.innerHTML = "<option></option>";
			support.option = !!div.lastChild;
		})();
	
		// We have to close these tags to support XHTML (#13200)
		var wrapMap = {
	
			// XHTML parsers do not magically insert elements in the
			// same way that tag soup parsers do. So we cannot shorten
			// this by omitting <tbody> or other required elements.
			thead: [1, "<table>", "</table>"],
			col: [2, "<table><colgroup>", "</colgroup></table>"],
			tr: [2, "<table><tbody>", "</tbody></table>"],
			td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
	
			_default: [0, "", ""]
		};
	
		wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
		wrapMap.th = wrapMap.td;
	
		// Support: IE <=9 only
		if (!support.option) {
			wrapMap.optgroup = wrapMap.option = [1, "<select multiple='multiple'>", "</select>"];
		}
	
		function getAll(context, tag) {
	
			// Support: IE <=9 - 11 only
			// Use typeof to avoid zero-argument method invocation on host objects (#15151)
			var ret;
	
			if (typeof context.getElementsByTagName !== "undefined") {
				ret = context.getElementsByTagName(tag || "*");
			} else if (typeof context.querySelectorAll !== "undefined") {
				ret = context.querySelectorAll(tag || "*");
			} else {
				ret = [];
			}
	
			if (tag === undefined || tag && nodeName(context, tag)) {
				return jQuery.merge([context], ret);
			}
	
			return ret;
		}
	
		// Mark scripts as having already been evaluated
		function setGlobalEval(elems, refElements) {
			var i = 0,
			    l = elems.length;
	
			for (; i < l; i++) {
				dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
			}
		}
	
		var rhtml = /<|&#?\w+;/;
	
		function buildFragment(elems, context, scripts, selection, ignored) {
			var elem,
			    tmp,
			    tag,
			    wrap,
			    attached,
			    j,
			    fragment = context.createDocumentFragment(),
			    nodes = [],
			    i = 0,
			    l = elems.length;
	
			for (; i < l; i++) {
				elem = elems[i];
	
				if (elem || elem === 0) {
	
					// Add nodes directly
					if (toType(elem) === "object") {
	
						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge(nodes, elem.nodeType ? [elem] : elem);
	
						// Convert non-html into a text node
					} else if (!rhtml.test(elem)) {
						nodes.push(context.createTextNode(elem));
	
						// Convert html into DOM nodes
					} else {
						tmp = tmp || fragment.appendChild(context.createElement("div"));
	
						// Deserialize a standard representation
						tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
						wrap = wrapMap[tag] || wrapMap._default;
						tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
	
						// Descend through wrappers to the right content
						j = wrap[0];
						while (j--) {
							tmp = tmp.lastChild;
						}
	
						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge(nodes, tmp.childNodes);
	
						// Remember the top-level container
						tmp = fragment.firstChild;
	
						// Ensure the created nodes are orphaned (#12392)
						tmp.textContent = "";
					}
				}
			}
	
			// Remove wrapper from fragment
			fragment.textContent = "";
	
			i = 0;
			while (elem = nodes[i++]) {
	
				// Skip elements already in the context collection (trac-4087)
				if (selection && jQuery.inArray(elem, selection) > -1) {
					if (ignored) {
						ignored.push(elem);
					}
					continue;
				}
	
				attached = isAttached(elem);
	
				// Append to fragment
				tmp = getAll(fragment.appendChild(elem), "script");
	
				// Preserve script evaluation history
				if (attached) {
					setGlobalEval(tmp);
				}
	
				// Capture executables
				if (scripts) {
					j = 0;
					while (elem = tmp[j++]) {
						if (rscriptType.test(elem.type || "")) {
							scripts.push(elem);
						}
					}
				}
			}
	
			return fragment;
		}
	
		var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
		function returnTrue() {
			return true;
		}
	
		function returnFalse() {
			return false;
		}
	
		// Support: IE <=9 - 11+
		// focus() and blur() are asynchronous, except when they are no-op.
		// So expect focus to be synchronous when the element is already active,
		// and blur to be synchronous when the element is not already active.
		// (focus and blur are always synchronous in other supported browsers,
		// this just defines when we can count on it).
		function expectSync(elem, type) {
			return elem === safeActiveElement() === (type === "focus");
		}
	
		// Support: IE <=9 only
		// Accessing document.activeElement can throw unexpectedly
		// https://bugs.jquery.com/ticket/13393
		function safeActiveElement() {
			try {
				return document.activeElement;
			} catch (err) {}
		}
	
		function _on(elem, types, selector, data, fn, one) {
			var origFn, type;
	
			// Types can be a map of types/handlers
			if ((typeof types === "undefined" ? "undefined" : _typeof(types)) === "object") {
	
				// ( types-Object, selector, data )
				if (typeof selector !== "string") {
	
					// ( types-Object, data )
					data = data || selector;
					selector = undefined;
				}
				for (type in types) {
					_on(elem, type, selector, data, types[type], one);
				}
				return elem;
			}
	
			if (data == null && fn == null) {
	
				// ( types, fn )
				fn = selector;
				data = selector = undefined;
			} else if (fn == null) {
				if (typeof selector === "string") {
	
					// ( types, selector, fn )
					fn = data;
					data = undefined;
				} else {
	
					// ( types, data, fn )
					fn = data;
					data = selector;
					selector = undefined;
				}
			}
			if (fn === false) {
				fn = returnFalse;
			} else if (!fn) {
				return elem;
			}
	
			if (one === 1) {
				origFn = fn;
				fn = function fn(event) {
	
					// Can use an empty set, since event contains the info
					jQuery().off(event);
					return origFn.apply(this, arguments);
				};
	
				// Use same guid so caller can remove using origFn
				fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
			}
			return elem.each(function () {
				jQuery.event.add(this, types, fn, data, selector);
			});
		}
	
		/*
	  * Helper functions for managing events -- not part of the public interface.
	  * Props to Dean Edwards' addEvent library for many of the ideas.
	  */
		jQuery.event = {
	
			global: {},
	
			add: function add(elem, types, handler, data, selector) {
	
				var handleObjIn,
				    eventHandle,
				    tmp,
				    events,
				    t,
				    handleObj,
				    special,
				    handlers,
				    type,
				    namespaces,
				    origType,
				    elemData = dataPriv.get(elem);
	
				// Only attach events to objects that accept data
				if (!acceptData(elem)) {
					return;
				}
	
				// Caller can pass in an object of custom data in lieu of the handler
				if (handler.handler) {
					handleObjIn = handler;
					handler = handleObjIn.handler;
					selector = handleObjIn.selector;
				}
	
				// Ensure that invalid selectors throw exceptions at attach time
				// Evaluate against documentElement in case elem is a non-element node (e.g., document)
				if (selector) {
					jQuery.find.matchesSelector(documentElement, selector);
				}
	
				// Make sure that the handler has a unique ID, used to find/remove it later
				if (!handler.guid) {
					handler.guid = jQuery.guid++;
				}
	
				// Init the element's event structure and main handler, if this is the first
				if (!(events = elemData.events)) {
					events = elemData.events = Object.create(null);
				}
				if (!(eventHandle = elemData.handle)) {
					eventHandle = elemData.handle = function (e) {
	
						// Discard the second event of a jQuery.event.trigger() and
						// when an event is called after a page has unloaded
						return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
					};
				}
	
				// Handle multiple events separated by a space
				types = (types || "").match(rnothtmlwhite) || [""];
				t = types.length;
				while (t--) {
					tmp = rtypenamespace.exec(types[t]) || [];
					type = origType = tmp[1];
					namespaces = (tmp[2] || "").split(".").sort();
	
					// There *must* be a type, no attaching namespace-only handlers
					if (!type) {
						continue;
					}
	
					// If event changes its type, use the special event handlers for the changed type
					special = jQuery.event.special[type] || {};
	
					// If selector defined, determine special event api type, otherwise given type
					type = (selector ? special.delegateType : special.bindType) || type;
	
					// Update special based on newly reset type
					special = jQuery.event.special[type] || {};
	
					// handleObj is passed to all event handlers
					handleObj = jQuery.extend({
						type: type,
						origType: origType,
						data: data,
						handler: handler,
						guid: handler.guid,
						selector: selector,
						needsContext: selector && jQuery.expr.match.needsContext.test(selector),
						namespace: namespaces.join(".")
					}, handleObjIn);
	
					// Init the event handler queue if we're the first
					if (!(handlers = events[type])) {
						handlers = events[type] = [];
						handlers.delegateCount = 0;
	
						// Only use addEventListener if the special events handler returns false
						if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
	
							if (elem.addEventListener) {
								elem.addEventListener(type, eventHandle);
							}
						}
					}
	
					if (special.add) {
						special.add.call(elem, handleObj);
	
						if (!handleObj.handler.guid) {
							handleObj.handler.guid = handler.guid;
						}
					}
	
					// Add to the element's handler list, delegates in front
					if (selector) {
						handlers.splice(handlers.delegateCount++, 0, handleObj);
					} else {
						handlers.push(handleObj);
					}
	
					// Keep track of which events have ever been used, for event optimization
					jQuery.event.global[type] = true;
				}
			},
	
			// Detach an event or set of events from an element
			remove: function remove(elem, types, handler, selector, mappedTypes) {
	
				var j,
				    origCount,
				    tmp,
				    events,
				    t,
				    handleObj,
				    special,
				    handlers,
				    type,
				    namespaces,
				    origType,
				    elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
	
				if (!elemData || !(events = elemData.events)) {
					return;
				}
	
				// Once for each type.namespace in types; type may be omitted
				types = (types || "").match(rnothtmlwhite) || [""];
				t = types.length;
				while (t--) {
					tmp = rtypenamespace.exec(types[t]) || [];
					type = origType = tmp[1];
					namespaces = (tmp[2] || "").split(".").sort();
	
					// Unbind all events (on this namespace, if provided) for the element
					if (!type) {
						for (type in events) {
							jQuery.event.remove(elem, type + types[t], handler, selector, true);
						}
						continue;
					}
	
					special = jQuery.event.special[type] || {};
					type = (selector ? special.delegateType : special.bindType) || type;
					handlers = events[type] || [];
					tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
	
					// Remove matching events
					origCount = j = handlers.length;
					while (j--) {
						handleObj = handlers[j];
	
						if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
							handlers.splice(j, 1);
	
							if (handleObj.selector) {
								handlers.delegateCount--;
							}
							if (special.remove) {
								special.remove.call(elem, handleObj);
							}
						}
					}
	
					// Remove generic event handler if we removed something and no more handlers exist
					// (avoids potential for endless recursion during removal of special event handlers)
					if (origCount && !handlers.length) {
						if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {
	
							jQuery.removeEvent(elem, type, elemData.handle);
						}
	
						delete events[type];
					}
				}
	
				// Remove data and the expando if it's no longer used
				if (jQuery.isEmptyObject(events)) {
					dataPriv.remove(elem, "handle events");
				}
			},
	
			dispatch: function dispatch(nativeEvent) {
	
				var i,
				    j,
				    ret,
				    matched,
				    handleObj,
				    handlerQueue,
				    args = new Array(arguments.length),
	
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix(nativeEvent),
				    handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [],
				    special = jQuery.event.special[event.type] || {};
	
				// Use the fix-ed jQuery.Event rather than the (read-only) native event
				args[0] = event;
	
				for (i = 1; i < arguments.length; i++) {
					args[i] = arguments[i];
				}
	
				event.delegateTarget = this;
	
				// Call the preDispatch hook for the mapped type, and let it bail if desired
				if (special.preDispatch && special.preDispatch.call(this, event) === false) {
					return;
				}
	
				// Determine handlers
				handlerQueue = jQuery.event.handlers.call(this, event, handlers);
	
				// Run delegates first; they may want to stop propagation beneath us
				i = 0;
				while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
					event.currentTarget = matched.elem;
	
					j = 0;
					while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {
	
						// If the event is namespaced, then each handler is only invoked if it is
						// specially universal or its namespaces are a superset of the event's.
						if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
	
							event.handleObj = handleObj;
							event.data = handleObj.data;
	
							ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
	
							if (ret !== undefined) {
								if ((event.result = ret) === false) {
									event.preventDefault();
									event.stopPropagation();
								}
							}
						}
					}
				}
	
				// Call the postDispatch hook for the mapped type
				if (special.postDispatch) {
					special.postDispatch.call(this, event);
				}
	
				return event.result;
			},
	
			handlers: function handlers(event, _handlers) {
				var i,
				    handleObj,
				    sel,
				    matchedHandlers,
				    matchedSelectors,
				    handlerQueue = [],
				    delegateCount = _handlers.delegateCount,
				    cur = event.target;
	
				// Find delegate handlers
				if (delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!(event.type === "click" && event.button >= 1)) {
	
					for (; cur !== this; cur = cur.parentNode || this) {
	
						// Don't check non-elements (#13208)
						// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
						if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
							matchedHandlers = [];
							matchedSelectors = {};
							for (i = 0; i < delegateCount; i++) {
								handleObj = _handlers[i];
	
								// Don't conflict with Object.prototype properties (#13203)
								sel = handleObj.selector + " ";
	
								if (matchedSelectors[sel] === undefined) {
									matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length;
								}
								if (matchedSelectors[sel]) {
									matchedHandlers.push(handleObj);
								}
							}
							if (matchedHandlers.length) {
								handlerQueue.push({ elem: cur, handlers: matchedHandlers });
							}
						}
					}
				}
	
				// Add the remaining (directly-bound) handlers
				cur = this;
				if (delegateCount < _handlers.length) {
					handlerQueue.push({ elem: cur, handlers: _handlers.slice(delegateCount) });
				}
	
				return handlerQueue;
			},
	
			addProp: function addProp(name, hook) {
				Object.defineProperty(jQuery.Event.prototype, name, {
					enumerable: true,
					configurable: true,
	
					get: isFunction(hook) ? function () {
						if (this.originalEvent) {
							return hook(this.originalEvent);
						}
					} : function () {
						if (this.originalEvent) {
							return this.originalEvent[name];
						}
					},
	
					set: function set(value) {
						Object.defineProperty(this, name, {
							enumerable: true,
							configurable: true,
							writable: true,
							value: value
						});
					}
				});
			},
	
			fix: function fix(originalEvent) {
				return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
			},
	
			special: {
				load: {
	
					// Prevent triggered image.load events from bubbling to window.load
					noBubble: true
				},
				click: {
	
					// Utilize native event to ensure correct state for checkable inputs
					setup: function setup(data) {
	
						// For mutual compressibility with _default, replace `this` access with a local var.
						// `|| data` is dead code meant only to preserve the variable through minification.
						var el = this || data;
	
						// Claim the first handler
						if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
	
							// dataPriv.set( el, "click", ... )
							leverageNative(el, "click", returnTrue);
						}
	
						// Return false to allow normal processing in the caller
						return false;
					},
					trigger: function trigger(data) {
	
						// For mutual compressibility with _default, replace `this` access with a local var.
						// `|| data` is dead code meant only to preserve the variable through minification.
						var el = this || data;
	
						// Force setup before triggering a click
						if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
	
							leverageNative(el, "click");
						}
	
						// Return non-false to allow normal event-path propagation
						return true;
					},
	
					// For cross-browser consistency, suppress native .click() on links
					// Also prevent it if we're currently inside a leveraged native-event stack
					_default: function _default(event) {
						var target = event.target;
						return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
					}
				},
	
				beforeunload: {
					postDispatch: function postDispatch(event) {
	
						// Support: Firefox 20+
						// Firefox doesn't alert if the returnValue field is not set.
						if (event.result !== undefined && event.originalEvent) {
							event.originalEvent.returnValue = event.result;
						}
					}
				}
			}
		};
	
		// Ensure the presence of an event listener that handles manually-triggered
		// synthetic events by interrupting progress until reinvoked in response to
		// *native* events that it fires directly, ensuring that state changes have
		// already occurred before other listeners are invoked.
		function leverageNative(el, type, expectSync) {
	
			// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
			if (!expectSync) {
				if (dataPriv.get(el, type) === undefined) {
					jQuery.event.add(el, type, returnTrue);
				}
				return;
			}
	
			// Register the controller as a special universal handler for all event namespaces
			dataPriv.set(el, type, false);
			jQuery.event.add(el, type, {
				namespace: false,
				handler: function handler(event) {
					var notAsync,
					    result,
					    saved = dataPriv.get(this, type);
	
					if (event.isTrigger & 1 && this[type]) {
	
						// Interrupt processing of the outer synthetic .trigger()ed event
						// Saved data should be false in such cases, but might be a leftover capture object
						// from an async native handler (gh-4350)
						if (!saved.length) {
	
							// Store arguments for use when handling the inner native event
							// There will always be at least one argument (an event object), so this array
							// will not be confused with a leftover capture object.
							saved = _slice.call(arguments);
							dataPriv.set(this, type, saved);
	
							// Trigger the native event and capture its result
							// Support: IE <=9 - 11+
							// focus() and blur() are asynchronous
							notAsync = expectSync(this, type);
							this[type]();
							result = dataPriv.get(this, type);
							if (saved !== result || notAsync) {
								dataPriv.set(this, type, false);
							} else {
								result = {};
							}
							if (saved !== result) {
	
								// Cancel the outer synthetic event
								event.stopImmediatePropagation();
								event.preventDefault();
	
								// Support: Chrome 86+
								// In Chrome, if an element having a focusout handler is blurred by
								// clicking outside of it, it invokes the handler synchronously. If
								// that handler calls `.remove()` on the element, the data is cleared,
								// leaving `result` undefined. We need to guard against this.
								return result && result.value;
							}
	
							// If this is an inner synthetic event for an event with a bubbling surrogate
							// (focus or blur), assume that the surrogate already propagated from triggering the
							// native event and prevent that from happening again here.
							// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
							// bubbling surrogate propagates *after* the non-bubbling base), but that seems
							// less bad than duplication.
						} else if ((jQuery.event.special[type] || {}).delegateType) {
							event.stopPropagation();
						}
	
						// If this is a native event triggered above, everything is now in order
						// Fire an inner synthetic event with the original arguments
					} else if (saved.length) {
	
						// ...and capture the result
						dataPriv.set(this, type, {
							value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend(saved[0], jQuery.Event.prototype), saved.slice(1), this)
						});
	
						// Abort handling of the native event
						event.stopImmediatePropagation();
					}
				}
			});
		}
	
		jQuery.removeEvent = function (elem, type, handle) {
	
			// This "if" is needed for plain objects
			if (elem.removeEventListener) {
				elem.removeEventListener(type, handle);
			}
		};
	
		jQuery.Event = function (src, props) {
	
			// Allow instantiation without the 'new' keyword
			if (!(this instanceof jQuery.Event)) {
				return new jQuery.Event(src, props);
			}
	
			// Event object
			if (src && src.type) {
				this.originalEvent = src;
				this.type = src.type;
	
				// Events bubbling up the document may have been marked as prevented
				// by a handler lower down the tree; reflect the correct value.
				this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined &&
	
				// Support: Android <=2.3 only
				src.returnValue === false ? returnTrue : returnFalse;
	
				// Create target properties
				// Support: Safari <=6 - 7 only
				// Target should not be a text node (#504, #13143)
				this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
	
				this.currentTarget = src.currentTarget;
				this.relatedTarget = src.relatedTarget;
	
				// Event type
			} else {
				this.type = src;
			}
	
			// Put explicitly provided properties onto the event object
			if (props) {
				jQuery.extend(this, props);
			}
	
			// Create a timestamp if incoming event doesn't have one
			this.timeStamp = src && src.timeStamp || Date.now();
	
			// Mark it as fixed
			this[jQuery.expando] = true;
		};
	
		// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
		// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
		jQuery.Event.prototype = {
			constructor: jQuery.Event,
			isDefaultPrevented: returnFalse,
			isPropagationStopped: returnFalse,
			isImmediatePropagationStopped: returnFalse,
			isSimulated: false,
	
			preventDefault: function preventDefault() {
				var e = this.originalEvent;
	
				this.isDefaultPrevented = returnTrue;
	
				if (e && !this.isSimulated) {
					e.preventDefault();
				}
			},
			stopPropagation: function stopPropagation() {
				var e = this.originalEvent;
	
				this.isPropagationStopped = returnTrue;
	
				if (e && !this.isSimulated) {
					e.stopPropagation();
				}
			},
			stopImmediatePropagation: function stopImmediatePropagation() {
				var e = this.originalEvent;
	
				this.isImmediatePropagationStopped = returnTrue;
	
				if (e && !this.isSimulated) {
					e.stopImmediatePropagation();
				}
	
				this.stopPropagation();
			}
		};
	
		// Includes all common event props including KeyEvent and MouseEvent specific props
		jQuery.each({
			altKey: true,
			bubbles: true,
			cancelable: true,
			changedTouches: true,
			ctrlKey: true,
			detail: true,
			eventPhase: true,
			metaKey: true,
			pageX: true,
			pageY: true,
			shiftKey: true,
			view: true,
			"char": true,
			code: true,
			charCode: true,
			key: true,
			keyCode: true,
			button: true,
			buttons: true,
			clientX: true,
			clientY: true,
			offsetX: true,
			offsetY: true,
			pointerId: true,
			pointerType: true,
			screenX: true,
			screenY: true,
			targetTouches: true,
			toElement: true,
			touches: true,
			which: true
		}, jQuery.event.addProp);
	
		jQuery.each({ focus: "focusin", blur: "focusout" }, function (type, delegateType) {
			jQuery.event.special[type] = {
	
				// Utilize native event if possible so blur/focus sequence is correct
				setup: function setup() {
	
					// Claim the first handler
					// dataPriv.set( this, "focus", ... )
					// dataPriv.set( this, "blur", ... )
					leverageNative(this, type, expectSync);
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function trigger() {
	
					// Force setup before trigger
					leverageNative(this, type);
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// Suppress native focus or blur as it's already being fired
				// in leverageNative.
				_default: function _default() {
					return true;
				},
	
				delegateType: delegateType
			};
		});
	
		// Create mouseenter/leave events using mouseover/out and event-time checks
		// so that event delegation works in jQuery.
		// Do the same for pointerenter/pointerleave and pointerover/pointerout
		//
		// Support: Safari 7 only
		// Safari sends mouseenter too often; see:
		// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
		// for the description of the bug (it existed in older Chrome versions as well).
		jQuery.each({
			mouseenter: "mouseover",
			mouseleave: "mouseout",
			pointerenter: "pointerover",
			pointerleave: "pointerout"
		}, function (orig, fix) {
			jQuery.event.special[orig] = {
				delegateType: fix,
				bindType: fix,
	
				handle: function handle(event) {
					var ret,
					    target = this,
					    related = event.relatedTarget,
					    handleObj = event.handleObj;
	
					// For mouseenter/leave call the handler if related is outside the target.
					// NB: No relatedTarget if the mouse left/entered the browser window
					if (!related || related !== target && !jQuery.contains(target, related)) {
						event.type = handleObj.origType;
						ret = handleObj.handler.apply(this, arguments);
						event.type = fix;
					}
					return ret;
				}
			};
		});
	
		jQuery.fn.extend({
	
			on: function on(types, selector, data, fn) {
				return _on(this, types, selector, data, fn);
			},
			one: function one(types, selector, data, fn) {
				return _on(this, types, selector, data, fn, 1);
			},
			off: function off(types, selector, fn) {
				var handleObj, type;
				if (types && types.preventDefault && types.handleObj) {
	
					// ( event )  dispatched jQuery.Event
					handleObj = types.handleObj;
					jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
					return this;
				}
				if ((typeof types === "undefined" ? "undefined" : _typeof(types)) === "object") {
	
					// ( types-object [, selector] )
					for (type in types) {
						this.off(type, selector, types[type]);
					}
					return this;
				}
				if (selector === false || typeof selector === "function") {
	
					// ( types [, fn] )
					fn = selector;
					selector = undefined;
				}
				if (fn === false) {
					fn = returnFalse;
				}
				return this.each(function () {
					jQuery.event.remove(this, types, fn, selector);
				});
			}
		});
	
		var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		    rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
		// Prefer a tbody over its parent table for containing new rows
		function manipulationTarget(elem, content) {
			if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {
	
				return jQuery(elem).children("tbody")[0] || elem;
			}
	
			return elem;
		}
	
		// Replace/restore the type attribute of script elements for safe DOM manipulation
		function disableScript(elem) {
			elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
			return elem;
		}
		function restoreScript(elem) {
			if ((elem.type || "").slice(0, 5) === "true/") {
				elem.type = elem.type.slice(5);
			} else {
				elem.removeAttribute("type");
			}
	
			return elem;
		}
	
		function cloneCopyEvent(src, dest) {
			var i, l, type, pdataOld, udataOld, udataCur, events;
	
			if (dest.nodeType !== 1) {
				return;
			}
	
			// 1. Copy private data: events, handlers, etc.
			if (dataPriv.hasData(src)) {
				pdataOld = dataPriv.get(src);
				events = pdataOld.events;
	
				if (events) {
					dataPriv.remove(dest, "handle events");
	
					for (type in events) {
						for (i = 0, l = events[type].length; i < l; i++) {
							jQuery.event.add(dest, type, events[type][i]);
						}
					}
				}
			}
	
			// 2. Copy user data
			if (dataUser.hasData(src)) {
				udataOld = dataUser.access(src);
				udataCur = jQuery.extend({}, udataOld);
	
				dataUser.set(dest, udataCur);
			}
		}
	
		// Fix IE bugs, see support tests
		function fixInput(src, dest) {
			var nodeName = dest.nodeName.toLowerCase();
	
			// Fails to persist the checked state of a cloned checkbox or radio button.
			if (nodeName === "input" && rcheckableType.test(src.type)) {
				dest.checked = src.checked;
	
				// Fails to return the selected option to the default selected state when cloning options
			} else if (nodeName === "input" || nodeName === "textarea") {
				dest.defaultValue = src.defaultValue;
			}
		}
	
		function domManip(collection, args, callback, ignored) {
	
			// Flatten any nested arrays
			args = flat(args);
	
			var fragment,
			    first,
			    scripts,
			    hasScripts,
			    node,
			    doc,
			    i = 0,
			    l = collection.length,
			    iNoClone = l - 1,
			    value = args[0],
			    valueIsFunction = isFunction(value);
	
			// We can't cloneNode fragments that contain checked, in WebKit
			if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
				return collection.each(function (index) {
					var self = collection.eq(index);
					if (valueIsFunction) {
						args[0] = value.call(this, index, self.html());
					}
					domManip(self, args, callback, ignored);
				});
			}
	
			if (l) {
				fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
				first = fragment.firstChild;
	
				if (fragment.childNodes.length === 1) {
					fragment = first;
				}
	
				// Require either new content or an interest in ignored elements to invoke the callback
				if (first || ignored) {
					scripts = jQuery.map(getAll(fragment, "script"), disableScript);
					hasScripts = scripts.length;
	
					// Use the original fragment for the last item
					// instead of the first because it can end up
					// being emptied incorrectly in certain situations (#8070).
					for (; i < l; i++) {
						node = fragment;
	
						if (i !== iNoClone) {
							node = jQuery.clone(node, true, true);
	
							// Keep references to cloned scripts for later restoration
							if (hasScripts) {
	
								// Support: Android <=4.0 only, PhantomJS 1 only
								// push.apply(_, arraylike) throws on ancient WebKit
								jQuery.merge(scripts, getAll(node, "script"));
							}
						}
	
						callback.call(collection[i], node, i);
					}
	
					if (hasScripts) {
						doc = scripts[scripts.length - 1].ownerDocument;
	
						// Reenable scripts
						jQuery.map(scripts, restoreScript);
	
						// Evaluate executable scripts on first document insertion
						for (i = 0; i < hasScripts; i++) {
							node = scripts[i];
							if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
	
								if (node.src && (node.type || "").toLowerCase() !== "module") {
	
									// Optional AJAX dependency, but won't run scripts if not present
									if (jQuery._evalUrl && !node.noModule) {
										jQuery._evalUrl(node.src, {
											nonce: node.nonce || node.getAttribute("nonce")
										}, doc);
									}
								} else {
									DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
								}
							}
						}
					}
				}
			}
	
			return collection;
		}
	
		function _remove(elem, selector, keepData) {
			var node,
			    nodes = selector ? jQuery.filter(selector, elem) : elem,
			    i = 0;
	
			for (; (node = nodes[i]) != null; i++) {
				if (!keepData && node.nodeType === 1) {
					jQuery.cleanData(getAll(node));
				}
	
				if (node.parentNode) {
					if (keepData && isAttached(node)) {
						setGlobalEval(getAll(node, "script"));
					}
					node.parentNode.removeChild(node);
				}
			}
	
			return elem;
		}
	
		jQuery.extend({
			htmlPrefilter: function htmlPrefilter(html) {
				return html;
			},
	
			clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
				var i,
				    l,
				    srcElements,
				    destElements,
				    clone = elem.cloneNode(true),
				    inPage = isAttached(elem);
	
				// Fix IE cloning issues
				if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
	
					// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
					destElements = getAll(clone);
					srcElements = getAll(elem);
	
					for (i = 0, l = srcElements.length; i < l; i++) {
						fixInput(srcElements[i], destElements[i]);
					}
				}
	
				// Copy the events from the original to the clone
				if (dataAndEvents) {
					if (deepDataAndEvents) {
						srcElements = srcElements || getAll(elem);
						destElements = destElements || getAll(clone);
	
						for (i = 0, l = srcElements.length; i < l; i++) {
							cloneCopyEvent(srcElements[i], destElements[i]);
						}
					} else {
						cloneCopyEvent(elem, clone);
					}
				}
	
				// Preserve script evaluation history
				destElements = getAll(clone, "script");
				if (destElements.length > 0) {
					setGlobalEval(destElements, !inPage && getAll(elem, "script"));
				}
	
				// Return the cloned set
				return clone;
			},
	
			cleanData: function cleanData(elems) {
				var data,
				    elem,
				    type,
				    special = jQuery.event.special,
				    i = 0;
	
				for (; (elem = elems[i]) !== undefined; i++) {
					if (acceptData(elem)) {
						if (data = elem[dataPriv.expando]) {
							if (data.events) {
								for (type in data.events) {
									if (special[type]) {
										jQuery.event.remove(elem, type);
	
										// This is a shortcut to avoid jQuery.event.remove's overhead
									} else {
										jQuery.removeEvent(elem, type, data.handle);
									}
								}
							}
	
							// Support: Chrome <=35 - 45+
							// Assign undefined instead of using delete, see Data#remove
							elem[dataPriv.expando] = undefined;
						}
						if (elem[dataUser.expando]) {
	
							// Support: Chrome <=35 - 45+
							// Assign undefined instead of using delete, see Data#remove
							elem[dataUser.expando] = undefined;
						}
					}
				}
			}
		});
	
		jQuery.fn.extend({
			detach: function detach(selector) {
				return _remove(this, selector, true);
			},
	
			remove: function remove(selector) {
				return _remove(this, selector);
			},
	
			text: function text(value) {
				return access(this, function (value) {
					return value === undefined ? jQuery.text(this) : this.empty().each(function () {
						if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
							this.textContent = value;
						}
					});
				}, null, value, arguments.length);
			},
	
			append: function append() {
				return domManip(this, arguments, function (elem) {
					if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
						var target = manipulationTarget(this, elem);
						target.appendChild(elem);
					}
				});
			},
	
			prepend: function prepend() {
				return domManip(this, arguments, function (elem) {
					if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
						var target = manipulationTarget(this, elem);
						target.insertBefore(elem, target.firstChild);
					}
				});
			},
	
			before: function before() {
				return domManip(this, arguments, function (elem) {
					if (this.parentNode) {
						this.parentNode.insertBefore(elem, this);
					}
				});
			},
	
			after: function after() {
				return domManip(this, arguments, function (elem) {
					if (this.parentNode) {
						this.parentNode.insertBefore(elem, this.nextSibling);
					}
				});
			},
	
			empty: function empty() {
				var elem,
				    i = 0;
	
				for (; (elem = this[i]) != null; i++) {
					if (elem.nodeType === 1) {
	
						// Prevent memory leaks
						jQuery.cleanData(getAll(elem, false));
	
						// Remove any remaining nodes
						elem.textContent = "";
					}
				}
	
				return this;
			},
	
			clone: function clone(dataAndEvents, deepDataAndEvents) {
				dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
				deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
				return this.map(function () {
					return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
				});
			},
	
			html: function html(value) {
				return access(this, function (value) {
					var elem = this[0] || {},
					    i = 0,
					    l = this.length;
	
					if (value === undefined && elem.nodeType === 1) {
						return elem.innerHTML;
					}
	
					// See if we can take a shortcut and just use innerHTML
					if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {
	
						value = jQuery.htmlPrefilter(value);
	
						try {
							for (; i < l; i++) {
								elem = this[i] || {};
	
								// Remove element nodes and prevent memory leaks
								if (elem.nodeType === 1) {
									jQuery.cleanData(getAll(elem, false));
									elem.innerHTML = value;
								}
							}
	
							elem = 0;
	
							// If using innerHTML throws an exception, use the fallback method
						} catch (e) {}
					}
	
					if (elem) {
						this.empty().append(value);
					}
				}, null, value, arguments.length);
			},
	
			replaceWith: function replaceWith() {
				var ignored = [];
	
				// Make the changes, replacing each non-ignored context element with the new content
				return domManip(this, arguments, function (elem) {
					var parent = this.parentNode;
	
					if (jQuery.inArray(this, ignored) < 0) {
						jQuery.cleanData(getAll(this));
						if (parent) {
							parent.replaceChild(elem, this);
						}
					}
	
					// Force callback invocation
				}, ignored);
			}
		});
	
		jQuery.each({
			appendTo: "append",
			prependTo: "prepend",
			insertBefore: "before",
			insertAfter: "after",
			replaceAll: "replaceWith"
		}, function (name, original) {
			jQuery.fn[name] = function (selector) {
				var elems,
				    ret = [],
				    insert = jQuery(selector),
				    last = insert.length - 1,
				    i = 0;
	
				for (; i <= last; i++) {
					elems = i === last ? this : this.clone(true);
					jQuery(insert[i])[original](elems);
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// .get() because push.apply(_, arraylike) throws on ancient WebKit
					push.apply(ret, elems.get());
				}
	
				return this.pushStack(ret);
			};
		});
		var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
	
		var getStyles = function getStyles(elem) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if (!view || !view.opener) {
				view = window;
			}
	
			return view.getComputedStyle(elem);
		};
	
		var swap = function swap(elem, options, callback) {
			var ret,
			    name,
			    old = {};
	
			// Remember the old values, and insert the new ones
			for (name in options) {
				old[name] = elem.style[name];
				elem.style[name] = options[name];
			}
	
			ret = callback.call(elem);
	
			// Revert the old values
			for (name in options) {
				elem.style[name] = old[name];
			}
	
			return ret;
		};
	
		var rboxStyle = new RegExp(cssExpand.join("|"), "i");
	
		(function () {
	
			// Executing both pixelPosition & boxSizingReliable tests require only one layout
			// so they're executed at the same time to save the second computation.
			function computeStyleTests() {
	
				// This is a singleton, we need to execute it only once
				if (!div) {
					return;
				}
	
				container.style.cssText = "position:absolute;left:-11111px;width:60px;" + "margin-top:1px;padding:0;border:0";
				div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;" + "margin:auto;border:1px;padding:1px;" + "width:60%;top:1%";
				documentElement.appendChild(container).appendChild(div);
	
				var divStyle = window.getComputedStyle(div);
				pixelPositionVal = divStyle.top !== "1%";
	
				// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
				reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
	
				// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
				// Some styles come back with percentage values, even though they shouldn't
				div.style.right = "60%";
				pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
	
				// Support: IE 9 - 11 only
				// Detect misreporting of content dimensions for box-sizing:border-box elements
				boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
	
				// Support: IE 9 only
				// Detect overflow:scroll screwiness (gh-3699)
				// Support: Chrome <=64
				// Don't get tricked when zoom affects offsetWidth (gh-4029)
				div.style.position = "absolute";
				scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
	
				documentElement.removeChild(container);
	
				// Nullify the div so it wouldn't be stored in the memory and
				// it will also be a sign that checks already performed
				div = null;
			}
	
			function roundPixelMeasures(measure) {
				return Math.round(parseFloat(measure));
			}
	
			var pixelPositionVal,
			    boxSizingReliableVal,
			    scrollboxSizeVal,
			    pixelBoxStylesVal,
			    reliableTrDimensionsVal,
			    reliableMarginLeftVal,
			    container = document.createElement("div"),
			    div = document.createElement("div");
	
			// Finish early in limited (non-browser) environments
			if (!div.style) {
				return;
			}
	
			// Support: IE <=9 - 11 only
			// Style of cloned element affects source element cloned (#8908)
			div.style.backgroundClip = "content-box";
			div.cloneNode(true).style.backgroundClip = "";
			support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
			jQuery.extend(support, {
				boxSizingReliable: function boxSizingReliable() {
					computeStyleTests();
					return boxSizingReliableVal;
				},
				pixelBoxStyles: function pixelBoxStyles() {
					computeStyleTests();
					return pixelBoxStylesVal;
				},
				pixelPosition: function pixelPosition() {
					computeStyleTests();
					return pixelPositionVal;
				},
				reliableMarginLeft: function reliableMarginLeft() {
					computeStyleTests();
					return reliableMarginLeftVal;
				},
				scrollboxSize: function scrollboxSize() {
					computeStyleTests();
					return scrollboxSizeVal;
				},
	
				// Support: IE 9 - 11+, Edge 15 - 18+
				// IE/Edge misreport `getComputedStyle` of table rows with width/height
				// set in CSS while `offset*` properties report correct values.
				// Behavior in IE 9 is more subtle than in newer versions & it passes
				// some versions of this test; make sure not to make it pass there!
				//
				// Support: Firefox 70+
				// Only Firefox includes border widths
				// in computed dimensions. (gh-4529)
				reliableTrDimensions: function reliableTrDimensions() {
					var table, tr, trChild, trStyle;
					if (reliableTrDimensionsVal == null) {
						table = document.createElement("table");
						tr = document.createElement("tr");
						trChild = document.createElement("div");
	
						table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
						tr.style.cssText = "border:1px solid";
	
						// Support: Chrome 86+
						// Height set through cssText does not get applied.
						// Computed height then comes back as 0.
						tr.style.height = "1px";
						trChild.style.height = "9px";
	
						// Support: Android 8 Chrome 86+
						// In our bodyBackground.html iframe,
						// display for all div elements is set to "inline",
						// which causes a problem only in Android 8 Chrome 86.
						// Ensuring the div is display: block
						// gets around this issue.
						trChild.style.display = "block";
	
						documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
	
						trStyle = window.getComputedStyle(tr);
						reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
	
						documentElement.removeChild(table);
					}
					return reliableTrDimensionsVal;
				}
			});
		})();
	
		function curCSS(elem, name, computed) {
			var width,
			    minWidth,
			    maxWidth,
			    ret,
	
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
			computed = computed || getStyles(elem);
	
			// getPropertyValue is needed for:
			//   .css('filter') (IE 9 only, #12537)
			//   .css('--customProperty) (#3144)
			if (computed) {
				ret = computed.getPropertyValue(name) || computed[name];
	
				if (ret === "" && !isAttached(elem)) {
					ret = jQuery.style(elem, name);
				}
	
				// A tribute to the "awesome hack by Dean Edwards"
				// Android Browser returns percentage for some values,
				// but width seems to be reliably pixels.
				// This is against the CSSOM draft spec:
				// https://drafts.csswg.org/cssom/#resolved-values
				if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
	
					// Remember the original values
					width = style.width;
					minWidth = style.minWidth;
					maxWidth = style.maxWidth;
	
					// Put in the new values to get a computed value out
					style.minWidth = style.maxWidth = style.width = ret;
					ret = computed.width;
	
					// Revert the changed values
					style.width = width;
					style.minWidth = minWidth;
					style.maxWidth = maxWidth;
				}
			}
	
			return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" : ret;
		}
	
		function addGetHookIf(conditionFn, hookFn) {
	
			// Define the hook, we'll check on the first run if it's really needed.
			return {
				get: function get() {
					if (conditionFn()) {
	
						// Hook not needed (or it's not possible to use it due
						// to missing dependency), remove it.
						delete this.get;
						return;
					}
	
					// Hook needed; redefine it so that the support test is not executed again.
					return (this.get = hookFn).apply(this, arguments);
				}
			};
		}
	
		var cssPrefixes = ["Webkit", "Moz", "ms"],
		    emptyStyle = document.createElement("div").style,
		    vendorProps = {};
	
		// Return a vendor-prefixed property or undefined
		function vendorPropName(name) {
	
			// Check for vendor prefixed names
			var capName = name[0].toUpperCase() + name.slice(1),
			    i = cssPrefixes.length;
	
			while (i--) {
				name = cssPrefixes[i] + capName;
				if (name in emptyStyle) {
					return name;
				}
			}
		}
	
		// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
		function finalPropName(name) {
			var final = jQuery.cssProps[name] || vendorProps[name];
	
			if (final) {
				return final;
			}
			if (name in emptyStyle) {
				return name;
			}
			return vendorProps[name] = vendorPropName(name) || name;
		}
	
		var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		    rcustomProp = /^--/,
		    cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		    cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
		function setPositiveNumber(_elem, value, subtract) {
	
			// Any relative (+/-) values have already been
			// normalized at this point
			var matches = rcssNum.exec(value);
			return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
		}
	
		function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
			var i = dimension === "width" ? 1 : 0,
			    extra = 0,
			    delta = 0;
	
			// Adjustment may not be necessary
			if (box === (isBorderBox ? "border" : "content")) {
				return 0;
			}
	
			for (; i < 4; i += 2) {
	
				// Both box models exclude margin
				if (box === "margin") {
					delta += jQuery.css(elem, box + cssExpand[i], true, styles);
				}
	
				// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
				if (!isBorderBox) {
	
					// Add padding
					delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
	
					// For "border" or "margin", add border
					if (box !== "padding") {
						delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
	
						// But still keep track of it otherwise
					} else {
						extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
					}
	
					// If we get here with a border-box (content + padding + border), we're seeking "content" or
					// "padding" or "margin"
				} else {
	
					// For "content", subtract padding
					if (box === "content") {
						delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
					}
	
					// For "content" or "padding", subtract border
					if (box !== "margin") {
						delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
					}
				}
			}
	
			// Account for positive content-box scroll gutter when requested by providing computedVal
			if (!isBorderBox && computedVal >= 0) {
	
				// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
				// Assuming integer scroll gutter, subtract the rest and round down
				delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5
	
				// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
				// Use an explicit zero to avoid NaN (gh-3964)
				)) || 0;
			}
	
			return delta;
		}
	
		function getWidthOrHeight(elem, dimension, extra) {
	
			// Start with computed style
			var styles = getStyles(elem),
	
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			    isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box",
			    valueIsBorderBox = isBorderBox,
			    val = curCSS(elem, dimension, styles),
			    offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
	
			// Support: Firefox <=54
			// Return a confounding non-pixel value or feign ignorance, as appropriate.
			if (rnumnonpx.test(val)) {
				if (!extra) {
					return val;
				}
				val = "auto";
			}
	
			// Support: IE 9 - 11 only
			// Use offsetWidth/offsetHeight for when box sizing is unreliable.
			// In those cases, the computed value can be trusted to be border-box.
			if ((!support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName(elem, "tr") ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length) {
	
				isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
	
				// Where available, offsetWidth/offsetHeight approximate border box dimensions.
				// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
				// retrieved value as a content box dimension.
				valueIsBorderBox = offsetProp in elem;
				if (valueIsBorderBox) {
					val = elem[offsetProp];
				}
			}
	
			// Normalize "" and auto
			val = parseFloat(val) || 0;
	
			// Adjust for the element's box model
			return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles,
	
			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val) + "px";
		}
	
		jQuery.extend({
	
			// Add in style property hooks for overriding the default
			// behavior of getting and setting a style property
			cssHooks: {
				opacity: {
					get: function get(elem, computed) {
						if (computed) {
	
							// We should always get a number back from opacity
							var ret = curCSS(elem, "opacity");
							return ret === "" ? "1" : ret;
						}
					}
				}
			},
	
			// Don't automatically add "px" to these possibly-unitless properties
			cssNumber: {
				"animationIterationCount": true,
				"columnCount": true,
				"fillOpacity": true,
				"flexGrow": true,
				"flexShrink": true,
				"fontWeight": true,
				"gridArea": true,
				"gridColumn": true,
				"gridColumnEnd": true,
				"gridColumnStart": true,
				"gridRow": true,
				"gridRowEnd": true,
				"gridRowStart": true,
				"lineHeight": true,
				"opacity": true,
				"order": true,
				"orphans": true,
				"widows": true,
				"zIndex": true,
				"zoom": true
			},
	
			// Add in properties whose names you wish to fix before
			// setting or getting the value
			cssProps: {},
	
			// Get and set the style property on a DOM Node
			style: function style(elem, name, value, extra) {
	
				// Don't set styles on text and comment nodes
				if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
					return;
				}
	
				// Make sure that we're working with the right name
				var ret,
				    type,
				    hooks,
				    origName = camelCase(name),
				    isCustomProp = rcustomProp.test(name),
				    style = elem.style;
	
				// Make sure that we're working with the right name. We don't
				// want to query the value if it is a CSS custom property
				// since they are user-defined.
				if (!isCustomProp) {
					name = finalPropName(origName);
				}
	
				// Gets hook for the prefixed version, then unprefixed version
				hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
	
				// Check if we're setting a value
				if (value !== undefined) {
					type = typeof value === "undefined" ? "undefined" : _typeof(value);
	
					// Convert "+=" or "-=" to relative numbers (#7345)
					if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
						value = adjustCSS(elem, name, ret);
	
						// Fixes bug #9237
						type = "number";
					}
	
					// Make sure that null and NaN values aren't set (#7116)
					if (value == null || value !== value) {
						return;
					}
	
					// If a number was passed in, add the unit (except for certain CSS properties)
					// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
					// "px" to a few hardcoded values.
					if (type === "number" && !isCustomProp) {
						value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
					}
	
					// background-* props affect original clone's values
					if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
						style[name] = "inherit";
					}
	
					// If a hook was provided, use that value, otherwise just set the specified value
					if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
	
						if (isCustomProp) {
							style.setProperty(name, value);
						} else {
							style[name] = value;
						}
					}
				} else {
	
					// If a hook was provided get the non-computed value from there
					if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {
	
						return ret;
					}
	
					// Otherwise just get the value from the style object
					return style[name];
				}
			},
	
			css: function css(elem, name, extra, styles) {
				var val,
				    num,
				    hooks,
				    origName = camelCase(name),
				    isCustomProp = rcustomProp.test(name);
	
				// Make sure that we're working with the right name. We don't
				// want to modify the value if it is a CSS custom property
				// since they are user-defined.
				if (!isCustomProp) {
					name = finalPropName(origName);
				}
	
				// Try prefixed name followed by the unprefixed name
				hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
	
				// If a hook was provided get the computed value from there
				if (hooks && "get" in hooks) {
					val = hooks.get(elem, true, extra);
				}
	
				// Otherwise, if a way to get the computed value exists, use that
				if (val === undefined) {
					val = curCSS(elem, name, styles);
				}
	
				// Convert "normal" to computed value
				if (val === "normal" && name in cssNormalTransform) {
					val = cssNormalTransform[name];
				}
	
				// Make numeric if forced or a qualifier was provided and val looks numeric
				if (extra === "" || extra) {
					num = parseFloat(val);
					return extra === true || isFinite(num) ? num || 0 : val;
				}
	
				return val;
			}
		});
	
		jQuery.each(["height", "width"], function (_i, dimension) {
			jQuery.cssHooks[dimension] = {
				get: function get(elem, computed, extra) {
					if (computed) {
	
						// Certain elements can have dimension info if we invisibly show them
						// but it must have a current display style that would benefit
						return rdisplayswap.test(jQuery.css(elem, "display")) && (
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function () {
							return getWidthOrHeight(elem, dimension, extra);
						}) : getWidthOrHeight(elem, dimension, extra);
					}
				},
	
				set: function set(elem, value, extra) {
					var matches,
					    styles = getStyles(elem),
	
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute",
	
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					    isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box",
					    subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
	
					// Account for unreliable border-box dimensions by comparing offset* to computed and
					// faking a content-box to get border and padding (gh-3699)
					if (isBorderBox && scrollboxSizeBuggy) {
						subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
					}
	
					// Convert to pixels if value adjustment is needed
					if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
	
						elem.style[dimension] = value;
						value = jQuery.css(elem, dimension);
					}
	
					return setPositiveNumber(elem, value, subtract);
				}
			};
		});
	
		jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function (elem, computed) {
			if (computed) {
				return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, { marginLeft: 0 }, function () {
					return elem.getBoundingClientRect().left;
				})) + "px";
			}
		});
	
		// These hooks are used by animate to expand properties
		jQuery.each({
			margin: "",
			padding: "",
			border: "Width"
		}, function (prefix, suffix) {
			jQuery.cssHooks[prefix + suffix] = {
				expand: function expand(value) {
					var i = 0,
					    expanded = {},
	
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split(" ") : [value];
	
					for (; i < 4; i++) {
						expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
					}
	
					return expanded;
				}
			};
	
			if (prefix !== "margin") {
				jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
			}
		});
	
		jQuery.fn.extend({
			css: function css(name, value) {
				return access(this, function (elem, name, value) {
					var styles,
					    len,
					    map = {},
					    i = 0;
	
					if (Array.isArray(name)) {
						styles = getStyles(elem);
						len = name.length;
	
						for (; i < len; i++) {
							map[name[i]] = jQuery.css(elem, name[i], false, styles);
						}
	
						return map;
					}
	
					return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
				}, name, value, arguments.length > 1);
			}
		});
	
		function Tween(elem, options, prop, end, easing) {
			return new Tween.prototype.init(elem, options, prop, end, easing);
		}
		jQuery.Tween = Tween;
	
		Tween.prototype = {
			constructor: Tween,
			init: function init(elem, options, prop, end, easing, unit) {
				this.elem = elem;
				this.prop = prop;
				this.easing = easing || jQuery.easing._default;
				this.options = options;
				this.start = this.now = this.cur();
				this.end = end;
				this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
			},
			cur: function cur() {
				var hooks = Tween.propHooks[this.prop];
	
				return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
			},
			run: function run(percent) {
				var eased,
				    hooks = Tween.propHooks[this.prop];
	
				if (this.options.duration) {
					this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
				} else {
					this.pos = eased = percent;
				}
				this.now = (this.end - this.start) * eased + this.start;
	
				if (this.options.step) {
					this.options.step.call(this.elem, this.now, this);
				}
	
				if (hooks && hooks.set) {
					hooks.set(this);
				} else {
					Tween.propHooks._default.set(this);
				}
				return this;
			}
		};
	
		Tween.prototype.init.prototype = Tween.prototype;
	
		Tween.propHooks = {
			_default: {
				get: function get(tween) {
					var result;
	
					// Use a property on the element directly when it is not a DOM element,
					// or when there is no matching style property that exists.
					if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
						return tween.elem[tween.prop];
					}
	
					// Passing an empty string as a 3rd parameter to .css will automatically
					// attempt a parseFloat and fallback to a string if the parse fails.
					// Simple values such as "10px" are parsed to Float;
					// complex values such as "rotate(1rad)" are returned as-is.
					result = jQuery.css(tween.elem, tween.prop, "");
	
					// Empty strings, null, undefined and "auto" are converted to 0.
					return !result || result === "auto" ? 0 : result;
				},
				set: function set(tween) {
	
					// Use step hook for back compat.
					// Use cssHook if its there.
					// Use .style if available and use plain properties where available.
					if (jQuery.fx.step[tween.prop]) {
						jQuery.fx.step[tween.prop](tween);
					} else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) {
						jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
					} else {
						tween.elem[tween.prop] = tween.now;
					}
				}
			}
		};
	
		// Support: IE <=9 only
		// Panic based approach to setting things on disconnected nodes
		Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
			set: function set(tween) {
				if (tween.elem.nodeType && tween.elem.parentNode) {
					tween.elem[tween.prop] = tween.now;
				}
			}
		};
	
		jQuery.easing = {
			linear: function linear(p) {
				return p;
			},
			swing: function swing(p) {
				return 0.5 - Math.cos(p * Math.PI) / 2;
			},
			_default: "swing"
		};
	
		jQuery.fx = Tween.prototype.init;
	
		// Back compat <1.8 extension point
		jQuery.fx.step = {};
	
		var fxNow,
		    inProgress,
		    rfxtypes = /^(?:toggle|show|hide)$/,
		    rrun = /queueHooks$/;
	
		function schedule() {
			if (inProgress) {
				if (document.hidden === false && window.requestAnimationFrame) {
					window.requestAnimationFrame(schedule);
				} else {
					window.setTimeout(schedule, jQuery.fx.interval);
				}
	
				jQuery.fx.tick();
			}
		}
	
		// Animations created synchronously will run synchronously
		function createFxNow() {
			window.setTimeout(function () {
				fxNow = undefined;
			});
			return fxNow = Date.now();
		}
	
		// Generate parameters to create a standard animation
		function genFx(type, includeWidth) {
			var which,
			    i = 0,
			    attrs = { height: type };
	
			// If we include width, step value is 1 to do all cssExpand values,
			// otherwise step value is 2 to skip over Left and Right
			includeWidth = includeWidth ? 1 : 0;
			for (; i < 4; i += 2 - includeWidth) {
				which = cssExpand[i];
				attrs["margin" + which] = attrs["padding" + which] = type;
			}
	
			if (includeWidth) {
				attrs.opacity = attrs.width = type;
			}
	
			return attrs;
		}
	
		function createTween(value, prop, animation) {
			var tween,
			    collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]),
			    index = 0,
			    length = collection.length;
			for (; index < length; index++) {
				if (tween = collection[index].call(animation, prop, value)) {
	
					// We're done with this property
					return tween;
				}
			}
		}
	
		function defaultPrefilter(elem, props, opts) {
			var prop,
			    value,
			    toggle,
			    hooks,
			    oldfire,
			    propTween,
			    restoreDisplay,
			    display,
			    isBox = "width" in props || "height" in props,
			    anim = this,
			    orig = {},
			    style = elem.style,
			    hidden = elem.nodeType && isHiddenWithinTree(elem),
			    dataShow = dataPriv.get(elem, "fxshow");
	
			// Queue-skipping animations hijack the fx hooks
			if (!opts.queue) {
				hooks = jQuery._queueHooks(elem, "fx");
				if (hooks.unqueued == null) {
					hooks.unqueued = 0;
					oldfire = hooks.empty.fire;
					hooks.empty.fire = function () {
						if (!hooks.unqueued) {
							oldfire();
						}
					};
				}
				hooks.unqueued++;
	
				anim.always(function () {
	
					// Ensure the complete handler is called before this completes
					anim.always(function () {
						hooks.unqueued--;
						if (!jQuery.queue(elem, "fx").length) {
							hooks.empty.fire();
						}
					});
				});
			}
	
			// Detect show/hide animations
			for (prop in props) {
				value = props[prop];
				if (rfxtypes.test(value)) {
					delete props[prop];
					toggle = toggle || value === "toggle";
					if (value === (hidden ? "hide" : "show")) {
	
						// Pretend to be hidden if this is a "show" and
						// there is still data from a stopped show/hide
						if (value === "show" && dataShow && dataShow[prop] !== undefined) {
							hidden = true;
	
							// Ignore all other no-op show/hide data
						} else {
							continue;
						}
					}
					orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
				}
			}
	
			// Bail out if this is a no-op like .hide().hide()
			propTween = !jQuery.isEmptyObject(props);
			if (!propTween && jQuery.isEmptyObject(orig)) {
				return;
			}
	
			// Restrict "overflow" and "display" styles during box animations
			if (isBox && elem.nodeType === 1) {
	
				// Support: IE <=9 - 11, Edge 12 - 15
				// Record all 3 overflow attributes because IE does not infer the shorthand
				// from identically-valued overflowX and overflowY and Edge just mirrors
				// the overflowX value there.
				opts.overflow = [style.overflow, style.overflowX, style.overflowY];
	
				// Identify a display type, preferring old show/hide data over the CSS cascade
				restoreDisplay = dataShow && dataShow.display;
				if (restoreDisplay == null) {
					restoreDisplay = dataPriv.get(elem, "display");
				}
				display = jQuery.css(elem, "display");
				if (display === "none") {
					if (restoreDisplay) {
						display = restoreDisplay;
					} else {
	
						// Get nonempty value(s) by temporarily forcing visibility
						showHide([elem], true);
						restoreDisplay = elem.style.display || restoreDisplay;
						display = jQuery.css(elem, "display");
						showHide([elem]);
					}
				}
	
				// Animate inline elements as inline-block
				if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
					if (jQuery.css(elem, "float") === "none") {
	
						// Restore the original display value at the end of pure show/hide animations
						if (!propTween) {
							anim.done(function () {
								style.display = restoreDisplay;
							});
							if (restoreDisplay == null) {
								display = style.display;
								restoreDisplay = display === "none" ? "" : display;
							}
						}
						style.display = "inline-block";
					}
				}
			}
	
			if (opts.overflow) {
				style.overflow = "hidden";
				anim.always(function () {
					style.overflow = opts.overflow[0];
					style.overflowX = opts.overflow[1];
					style.overflowY = opts.overflow[2];
				});
			}
	
			// Implement show/hide animations
			propTween = false;
			for (prop in orig) {
	
				// General show/hide setup for this element animation
				if (!propTween) {
					if (dataShow) {
						if ("hidden" in dataShow) {
							hidden = dataShow.hidden;
						}
					} else {
						dataShow = dataPriv.access(elem, "fxshow", { display: restoreDisplay });
					}
	
					// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
					if (toggle) {
						dataShow.hidden = !hidden;
					}
	
					// Show elements before animating them
					if (hidden) {
						showHide([elem], true);
					}
	
					/* eslint-disable no-loop-func */
	
					anim.done(function () {
	
						/* eslint-enable no-loop-func */
	
						// The final step of a "hide" animation is actually hiding the element
						if (!hidden) {
							showHide([elem]);
						}
						dataPriv.remove(elem, "fxshow");
						for (prop in orig) {
							jQuery.style(elem, prop, orig[prop]);
						}
					});
				}
	
				// Per-property setup
				propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
				if (!(prop in dataShow)) {
					dataShow[prop] = propTween.start;
					if (hidden) {
						propTween.end = propTween.start;
						propTween.start = 0;
					}
				}
			}
		}
	
		function propFilter(props, specialEasing) {
			var index, name, easing, value, hooks;
	
			// camelCase, specialEasing and expand cssHook pass
			for (index in props) {
				name = camelCase(index);
				easing = specialEasing[name];
				value = props[index];
				if (Array.isArray(value)) {
					easing = value[1];
					value = props[index] = value[0];
				}
	
				if (index !== name) {
					props[name] = value;
					delete props[index];
				}
	
				hooks = jQuery.cssHooks[name];
				if (hooks && "expand" in hooks) {
					value = hooks.expand(value);
					delete props[name];
	
					// Not quite $.extend, this won't overwrite existing keys.
					// Reusing 'index' because we have the correct "name"
					for (index in value) {
						if (!(index in props)) {
							props[index] = value[index];
							specialEasing[index] = easing;
						}
					}
				} else {
					specialEasing[name] = easing;
				}
			}
		}
	
		function Animation(elem, properties, options) {
			var result,
			    stopped,
			    index = 0,
			    length = Animation.prefilters.length,
			    deferred = jQuery.Deferred().always(function () {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			}),
			    tick = function tick() {
				if (stopped) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
				    remaining = Math.max(0, animation.startTime + animation.duration - currentTime),
	
	
				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				    percent = 1 - temp,
				    index = 0,
				    length = animation.tweens.length;
	
				for (; index < length; index++) {
					animation.tweens[index].run(percent);
				}
	
				deferred.notifyWith(elem, [animation, percent, remaining]);
	
				// If there's more to do, yield
				if (percent < 1 && length) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if (!length) {
					deferred.notifyWith(elem, [animation, 1, 0]);
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith(elem, [animation]);
				return false;
			},
			    animation = deferred.promise({
				elem: elem,
				props: jQuery.extend({}, properties),
				opts: jQuery.extend(true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function createTween(prop, end) {
					var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
					animation.tweens.push(tween);
					return tween;
				},
				stop: function stop(gotoEnd) {
					var index = 0,
	
	
					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
					if (stopped) {
						return this;
					}
					stopped = true;
					for (; index < length; index++) {
						animation.tweens[index].run(1);
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if (gotoEnd) {
						deferred.notifyWith(elem, [animation, 1, 0]);
						deferred.resolveWith(elem, [animation, gotoEnd]);
					} else {
						deferred.rejectWith(elem, [animation, gotoEnd]);
					}
					return this;
				}
			}),
			    props = animation.props;
	
			propFilter(props, animation.opts.specialEasing);
	
			for (; index < length; index++) {
				result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
				if (result) {
					if (isFunction(result.stop)) {
						jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
					}
					return result;
				}
			}
	
			jQuery.map(props, createTween, animation);
	
			if (isFunction(animation.opts.start)) {
				animation.opts.start.call(elem, animation);
			}
	
			// Attach callbacks from options
			animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
	
			jQuery.fx.timer(jQuery.extend(tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			}));
	
			return animation;
		}
	
		jQuery.Animation = jQuery.extend(Animation, {
	
			tweeners: {
				"*": [function (prop, value) {
					var tween = this.createTween(prop, value);
					adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
					return tween;
				}]
			},
	
			tweener: function tweener(props, callback) {
				if (isFunction(props)) {
					callback = props;
					props = ["*"];
				} else {
					props = props.match(rnothtmlwhite);
				}
	
				var prop,
				    index = 0,
				    length = props.length;
	
				for (; index < length; index++) {
					prop = props[index];
					Animation.tweeners[prop] = Animation.tweeners[prop] || [];
					Animation.tweeners[prop].unshift(callback);
				}
			},
	
			prefilters: [defaultPrefilter],
	
			prefilter: function prefilter(callback, prepend) {
				if (prepend) {
					Animation.prefilters.unshift(callback);
				} else {
					Animation.prefilters.push(callback);
				}
			}
		});
	
		jQuery.speed = function (speed, easing, fn) {
			var opt = speed && (typeof speed === "undefined" ? "undefined" : _typeof(speed)) === "object" ? jQuery.extend({}, speed) : {
				complete: fn || !fn && easing || isFunction(speed) && speed,
				duration: speed,
				easing: fn && easing || easing && !isFunction(easing) && easing
			};
	
			// Go to the end state if fx are off
			if (jQuery.fx.off) {
				opt.duration = 0;
			} else {
				if (typeof opt.duration !== "number") {
					if (opt.duration in jQuery.fx.speeds) {
						opt.duration = jQuery.fx.speeds[opt.duration];
					} else {
						opt.duration = jQuery.fx.speeds._default;
					}
				}
			}
	
			// Normalize opt.queue - true/undefined/null -> "fx"
			if (opt.queue == null || opt.queue === true) {
				opt.queue = "fx";
			}
	
			// Queueing
			opt.old = opt.complete;
	
			opt.complete = function () {
				if (isFunction(opt.old)) {
					opt.old.call(this);
				}
	
				if (opt.queue) {
					jQuery.dequeue(this, opt.queue);
				}
			};
	
			return opt;
		};
	
		jQuery.fn.extend({
			fadeTo: function fadeTo(speed, to, easing, callback) {
	
				// Show any hidden elements after setting opacity to 0
				return this.filter(isHiddenWithinTree).css("opacity", 0).show()
	
				// Animate to the value specified
				.end().animate({ opacity: to }, speed, easing, callback);
			},
			animate: function animate(prop, speed, easing, callback) {
				var empty = jQuery.isEmptyObject(prop),
				    optall = jQuery.speed(speed, easing, callback),
				    doAnimation = function doAnimation() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation(this, jQuery.extend({}, prop), optall);
	
					// Empty animations, or finishing resolves immediately
					if (empty || dataPriv.get(this, "finish")) {
						anim.stop(true);
					}
				};
	
				doAnimation.finish = doAnimation;
	
				return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
			},
			stop: function stop(type, clearQueue, gotoEnd) {
				var stopQueue = function stopQueue(hooks) {
					var stop = hooks.stop;
					delete hooks.stop;
					stop(gotoEnd);
				};
	
				if (typeof type !== "string") {
					gotoEnd = clearQueue;
					clearQueue = type;
					type = undefined;
				}
				if (clearQueue) {
					this.queue(type || "fx", []);
				}
	
				return this.each(function () {
					var dequeue = true,
					    index = type != null && type + "queueHooks",
					    timers = jQuery.timers,
					    data = dataPriv.get(this);
	
					if (index) {
						if (data[index] && data[index].stop) {
							stopQueue(data[index]);
						}
					} else {
						for (index in data) {
							if (data[index] && data[index].stop && rrun.test(index)) {
								stopQueue(data[index]);
							}
						}
					}
	
					for (index = timers.length; index--;) {
						if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
	
							timers[index].anim.stop(gotoEnd);
							dequeue = false;
							timers.splice(index, 1);
						}
					}
	
					// Start the next in the queue if the last step wasn't forced.
					// Timers currently will call their complete callbacks, which
					// will dequeue but only if they were gotoEnd.
					if (dequeue || !gotoEnd) {
						jQuery.dequeue(this, type);
					}
				});
			},
			finish: function finish(type) {
				if (type !== false) {
					type = type || "fx";
				}
				return this.each(function () {
					var index,
					    data = dataPriv.get(this),
					    queue = data[type + "queue"],
					    hooks = data[type + "queueHooks"],
					    timers = jQuery.timers,
					    length = queue ? queue.length : 0;
	
					// Enable finishing flag on private data
					data.finish = true;
	
					// Empty the queue first
					jQuery.queue(this, type, []);
	
					if (hooks && hooks.stop) {
						hooks.stop.call(this, true);
					}
	
					// Look for any active animations, and finish them
					for (index = timers.length; index--;) {
						if (timers[index].elem === this && timers[index].queue === type) {
							timers[index].anim.stop(true);
							timers.splice(index, 1);
						}
					}
	
					// Look for any animations in the old queue and finish them
					for (index = 0; index < length; index++) {
						if (queue[index] && queue[index].finish) {
							queue[index].finish.call(this);
						}
					}
	
					// Turn off finishing flag
					delete data.finish;
				});
			}
		});
	
		jQuery.each(["toggle", "show", "hide"], function (_i, name) {
			var cssFn = jQuery.fn[name];
			jQuery.fn[name] = function (speed, easing, callback) {
				return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
			};
		});
	
		// Generate shortcuts for custom animations
		jQuery.each({
			slideDown: genFx("show"),
			slideUp: genFx("hide"),
			slideToggle: genFx("toggle"),
			fadeIn: { opacity: "show" },
			fadeOut: { opacity: "hide" },
			fadeToggle: { opacity: "toggle" }
		}, function (name, props) {
			jQuery.fn[name] = function (speed, easing, callback) {
				return this.animate(props, speed, easing, callback);
			};
		});
	
		jQuery.timers = [];
		jQuery.fx.tick = function () {
			var timer,
			    i = 0,
			    timers = jQuery.timers;
	
			fxNow = Date.now();
	
			for (; i < timers.length; i++) {
				timer = timers[i];
	
				// Run the timer and safely remove it when done (allowing for external removal)
				if (!timer() && timers[i] === timer) {
					timers.splice(i--, 1);
				}
			}
	
			if (!timers.length) {
				jQuery.fx.stop();
			}
			fxNow = undefined;
		};
	
		jQuery.fx.timer = function (timer) {
			jQuery.timers.push(timer);
			jQuery.fx.start();
		};
	
		jQuery.fx.interval = 13;
		jQuery.fx.start = function () {
			if (inProgress) {
				return;
			}
	
			inProgress = true;
			schedule();
		};
	
		jQuery.fx.stop = function () {
			inProgress = null;
		};
	
		jQuery.fx.speeds = {
			slow: 600,
			fast: 200,
	
			// Default speed
			_default: 400
		};
	
		// Based off of the plugin by Clint Helfers, with permission.
		// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
		jQuery.fn.delay = function (time, type) {
			time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
			type = type || "fx";
	
			return this.queue(type, function (next, hooks) {
				var timeout = window.setTimeout(next, time);
				hooks.stop = function () {
					window.clearTimeout(timeout);
				};
			});
		};
	
		(function () {
			var input = document.createElement("input"),
			    select = document.createElement("select"),
			    opt = select.appendChild(document.createElement("option"));
	
			input.type = "checkbox";
	
			// Support: Android <=4.3 only
			// Default value for a checkbox should be "on"
			support.checkOn = input.value !== "";
	
			// Support: IE <=11 only
			// Must access selectedIndex to make default options select
			support.optSelected = opt.selected;
	
			// Support: IE <=11 only
			// An input loses its value after becoming a radio
			input = document.createElement("input");
			input.value = "t";
			input.type = "radio";
			support.radioValue = input.value === "t";
		})();
	
		var boolHook,
		    attrHandle = jQuery.expr.attrHandle;
	
		jQuery.fn.extend({
			attr: function attr(name, value) {
				return access(this, jQuery.attr, name, value, arguments.length > 1);
			},
	
			removeAttr: function removeAttr(name) {
				return this.each(function () {
					jQuery.removeAttr(this, name);
				});
			}
		});
	
		jQuery.extend({
			attr: function attr(elem, name, value) {
				var ret,
				    hooks,
				    nType = elem.nodeType;
	
				// Don't get/set attributes on text, comment and attribute nodes
				if (nType === 3 || nType === 8 || nType === 2) {
					return;
				}
	
				// Fallback to prop when attributes are not supported
				if (typeof elem.getAttribute === "undefined") {
					return jQuery.prop(elem, name, value);
				}
	
				// Attribute hooks are determined by the lowercase version
				// Grab necessary hook if one is defined
				if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
					hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
				}
	
				if (value !== undefined) {
					if (value === null) {
						jQuery.removeAttr(elem, name);
						return;
					}
	
					if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
						return ret;
					}
	
					elem.setAttribute(name, value + "");
					return value;
				}
	
				if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
					return ret;
				}
	
				ret = jQuery.find.attr(elem, name);
	
				// Non-existent attributes return null, we normalize to undefined
				return ret == null ? undefined : ret;
			},
	
			attrHooks: {
				type: {
					set: function set(elem, value) {
						if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
							var val = elem.value;
							elem.setAttribute("type", value);
							if (val) {
								elem.value = val;
							}
							return value;
						}
					}
				}
			},
	
			removeAttr: function removeAttr(elem, value) {
				var name,
				    i = 0,
	
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match(rnothtmlwhite);
	
				if (attrNames && elem.nodeType === 1) {
					while (name = attrNames[i++]) {
						elem.removeAttribute(name);
					}
				}
			}
		});
	
		// Hooks for boolean attributes
		boolHook = {
			set: function set(elem, value, name) {
				if (value === false) {
	
					// Remove boolean attributes when set to false
					jQuery.removeAttr(elem, name);
				} else {
					elem.setAttribute(name, name);
				}
				return name;
			}
		};
	
		jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (_i, name) {
			var getter = attrHandle[name] || jQuery.find.attr;
	
			attrHandle[name] = function (elem, name, isXML) {
				var ret,
				    handle,
				    lowercaseName = name.toLowerCase();
	
				if (!isXML) {
	
					// Avoid an infinite loop by temporarily removing this function from the getter
					handle = attrHandle[lowercaseName];
					attrHandle[lowercaseName] = ret;
					ret = getter(elem, name, isXML) != null ? lowercaseName : null;
					attrHandle[lowercaseName] = handle;
				}
				return ret;
			};
		});
	
		var rfocusable = /^(?:input|select|textarea|button)$/i,
		    rclickable = /^(?:a|area)$/i;
	
		jQuery.fn.extend({
			prop: function prop(name, value) {
				return access(this, jQuery.prop, name, value, arguments.length > 1);
			},
	
			removeProp: function removeProp(name) {
				return this.each(function () {
					delete this[jQuery.propFix[name] || name];
				});
			}
		});
	
		jQuery.extend({
			prop: function prop(elem, name, value) {
				var ret,
				    hooks,
				    nType = elem.nodeType;
	
				// Don't get/set properties on text, comment and attribute nodes
				if (nType === 3 || nType === 8 || nType === 2) {
					return;
				}
	
				if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
	
					// Fix name and attach hooks
					name = jQuery.propFix[name] || name;
					hooks = jQuery.propHooks[name];
				}
	
				if (value !== undefined) {
					if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
						return ret;
					}
	
					return elem[name] = value;
				}
	
				if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
					return ret;
				}
	
				return elem[name];
			},
	
			propHooks: {
				tabIndex: {
					get: function get(elem) {
	
						// Support: IE <=9 - 11 only
						// elem.tabIndex doesn't always return the
						// correct value when it hasn't been explicitly set
						// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
						// Use proper attribute retrieval(#12072)
						var tabindex = jQuery.find.attr(elem, "tabindex");
	
						if (tabindex) {
							return parseInt(tabindex, 10);
						}
	
						if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) {
							return 0;
						}
	
						return -1;
					}
				}
			},
	
			propFix: {
				"for": "htmlFor",
				"class": "className"
			}
		});
	
		// Support: IE <=11 only
		// Accessing the selectedIndex property
		// forces the browser to respect setting selected
		// on the option
		// The getter ensures a default option is selected
		// when in an optgroup
		// eslint rule "no-unused-expressions" is disabled for this code
		// since it considers such accessions noop
		if (!support.optSelected) {
			jQuery.propHooks.selected = {
				get: function get(elem) {
	
					/* eslint no-unused-expressions: "off" */
	
					var parent = elem.parentNode;
					if (parent && parent.parentNode) {
						parent.parentNode.selectedIndex;
					}
					return null;
				},
				set: function set(elem) {
	
					/* eslint no-unused-expressions: "off" */
	
					var parent = elem.parentNode;
					if (parent) {
						parent.selectedIndex;
	
						if (parent.parentNode) {
							parent.parentNode.selectedIndex;
						}
					}
				}
			};
		}
	
		jQuery.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
			jQuery.propFix[this.toLowerCase()] = this;
		});
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse(value) {
			var tokens = value.match(rnothtmlwhite) || [];
			return tokens.join(" ");
		}
	
		function getClass(elem) {
			return elem.getAttribute && elem.getAttribute("class") || "";
		}
	
		function classesToArray(value) {
			if (Array.isArray(value)) {
				return value;
			}
			if (typeof value === "string") {
				return value.match(rnothtmlwhite) || [];
			}
			return [];
		}
	
		jQuery.fn.extend({
			addClass: function addClass(value) {
				var classes,
				    elem,
				    cur,
				    curValue,
				    clazz,
				    j,
				    finalValue,
				    i = 0;
	
				if (isFunction(value)) {
					return this.each(function (j) {
						jQuery(this).addClass(value.call(this, j, getClass(this)));
					});
				}
	
				classes = classesToArray(value);
	
				if (classes.length) {
					while (elem = this[i++]) {
						curValue = getClass(elem);
						cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
	
						if (cur) {
							j = 0;
							while (clazz = classes[j++]) {
								if (cur.indexOf(" " + clazz + " ") < 0) {
									cur += clazz + " ";
								}
							}
	
							// Only assign if different to avoid unneeded rendering.
							finalValue = stripAndCollapse(cur);
							if (curValue !== finalValue) {
								elem.setAttribute("class", finalValue);
							}
						}
					}
				}
	
				return this;
			},
	
			removeClass: function removeClass(value) {
				var classes,
				    elem,
				    cur,
				    curValue,
				    clazz,
				    j,
				    finalValue,
				    i = 0;
	
				if (isFunction(value)) {
					return this.each(function (j) {
						jQuery(this).removeClass(value.call(this, j, getClass(this)));
					});
				}
	
				if (!arguments.length) {
					return this.attr("class", "");
				}
	
				classes = classesToArray(value);
	
				if (classes.length) {
					while (elem = this[i++]) {
						curValue = getClass(elem);
	
						// This expression is here for better compressibility (see addClass)
						cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
	
						if (cur) {
							j = 0;
							while (clazz = classes[j++]) {
	
								// Remove *all* instances
								while (cur.indexOf(" " + clazz + " ") > -1) {
									cur = cur.replace(" " + clazz + " ", " ");
								}
							}
	
							// Only assign if different to avoid unneeded rendering.
							finalValue = stripAndCollapse(cur);
							if (curValue !== finalValue) {
								elem.setAttribute("class", finalValue);
							}
						}
					}
				}
	
				return this;
			},
	
			toggleClass: function toggleClass(value, stateVal) {
				var type = typeof value === "undefined" ? "undefined" : _typeof(value),
				    isValidValue = type === "string" || Array.isArray(value);
	
				if (typeof stateVal === "boolean" && isValidValue) {
					return stateVal ? this.addClass(value) : this.removeClass(value);
				}
	
				if (isFunction(value)) {
					return this.each(function (i) {
						jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
					});
				}
	
				return this.each(function () {
					var className, i, self, classNames;
	
					if (isValidValue) {
	
						// Toggle individual class names
						i = 0;
						self = jQuery(this);
						classNames = classesToArray(value);
	
						while (className = classNames[i++]) {
	
							// Check each className given, space separated list
							if (self.hasClass(className)) {
								self.removeClass(className);
							} else {
								self.addClass(className);
							}
						}
	
						// Toggle whole class name
					} else if (value === undefined || type === "boolean") {
						className = getClass(this);
						if (className) {
	
							// Store className if set
							dataPriv.set(this, "__className__", className);
						}
	
						// If the element has a class name or if we're passed `false`,
						// then remove the whole classname (if there was one, the above saved it).
						// Otherwise bring back whatever was previously saved (if anything),
						// falling back to the empty string if nothing was stored.
						if (this.setAttribute) {
							this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
						}
					}
				});
			},
	
			hasClass: function hasClass(selector) {
				var className,
				    elem,
				    i = 0;
	
				className = " " + selector + " ";
				while (elem = this[i++]) {
					if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
						return true;
					}
				}
	
				return false;
			}
		});
	
		var rreturn = /\r/g;
	
		jQuery.fn.extend({
			val: function val(value) {
				var hooks,
				    ret,
				    valueIsFunction,
				    elem = this[0];
	
				if (!arguments.length) {
					if (elem) {
						hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
	
						if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
							return ret;
						}
	
						ret = elem.value;
	
						// Handle most common string cases
						if (typeof ret === "string") {
							return ret.replace(rreturn, "");
						}
	
						// Handle cases where value is null/undef or number
						return ret == null ? "" : ret;
					}
	
					return;
				}
	
				valueIsFunction = isFunction(value);
	
				return this.each(function (i) {
					var val;
	
					if (this.nodeType !== 1) {
						return;
					}
	
					if (valueIsFunction) {
						val = value.call(this, i, jQuery(this).val());
					} else {
						val = value;
					}
	
					// Treat null/undefined as ""; convert numbers to string
					if (val == null) {
						val = "";
					} else if (typeof val === "number") {
						val += "";
					} else if (Array.isArray(val)) {
						val = jQuery.map(val, function (value) {
							return value == null ? "" : value + "";
						});
					}
	
					hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
	
					// If set returns undefined, fall back to normal setting
					if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
						this.value = val;
					}
				});
			}
		});
	
		jQuery.extend({
			valHooks: {
				option: {
					get: function get(elem) {
	
						var val = jQuery.find.attr(elem, "value");
						return val != null ? val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse(jQuery.text(elem));
					}
				},
				select: {
					get: function get(elem) {
						var value,
						    option,
						    i,
						    options = elem.options,
						    index = elem.selectedIndex,
						    one = elem.type === "select-one",
						    values = one ? null : [],
						    max = one ? index + 1 : options.length;
	
						if (index < 0) {
							i = max;
						} else {
							i = one ? index : 0;
						}
	
						// Loop through all the selected options
						for (; i < max; i++) {
							option = options[i];
	
							// Support: IE <=9 only
							// IE8-9 doesn't update selected after form reset (#2551)
							if ((option.selected || i === index) &&
	
							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
	
								// Get the specific value for the option
								value = jQuery(option).val();
	
								// We don't need an array for one selects
								if (one) {
									return value;
								}
	
								// Multi-Selects return an array
								values.push(value);
							}
						}
	
						return values;
					},
	
					set: function set(elem, value) {
						var optionSet,
						    option,
						    options = elem.options,
						    values = jQuery.makeArray(value),
						    i = options.length;
	
						while (i--) {
							option = options[i];
	
							/* eslint-disable no-cond-assign */
	
							if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
								optionSet = true;
							}
	
							/* eslint-enable no-cond-assign */
						}
	
						// Force browsers to behave consistently when non-matching value is set
						if (!optionSet) {
							elem.selectedIndex = -1;
						}
						return values;
					}
				}
			}
		});
	
		// Radios and checkboxes getter/setter
		jQuery.each(["radio", "checkbox"], function () {
			jQuery.valHooks[this] = {
				set: function set(elem, value) {
					if (Array.isArray(value)) {
						return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
					}
				}
			};
			if (!support.checkOn) {
				jQuery.valHooks[this].get = function (elem) {
					return elem.getAttribute("value") === null ? "on" : elem.value;
				};
			}
		});
	
		// Return jQuery for attributes-only inclusion
	
	
		support.focusin = "onfocusin" in window;
	
		var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		    stopPropagationCallback = function stopPropagationCallback(e) {
			e.stopPropagation();
		};
	
		jQuery.extend(jQuery.event, {
	
			trigger: function trigger(event, data, elem, onlyHandlers) {
	
				var i,
				    cur,
				    tmp,
				    bubbleType,
				    ontype,
				    handle,
				    special,
				    lastElement,
				    eventPath = [elem || document],
				    type = hasOwn.call(event, "type") ? event.type : event,
				    namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
	
				cur = lastElement = tmp = elem = elem || document;
	
				// Don't do events on text and comment nodes
				if (elem.nodeType === 3 || elem.nodeType === 8) {
					return;
				}
	
				// focus/blur morphs to focusin/out; ensure we're not firing them right now
				if (rfocusMorph.test(type + jQuery.event.triggered)) {
					return;
				}
	
				if (type.indexOf(".") > -1) {
	
					// Namespaced trigger; create a regexp to match event type in handle()
					namespaces = type.split(".");
					type = namespaces.shift();
					namespaces.sort();
				}
				ontype = type.indexOf(":") < 0 && "on" + type;
	
				// Caller can pass in a jQuery.Event object, Object, or just an event type string
				event = event[jQuery.expando] ? event : new jQuery.Event(type, (typeof event === "undefined" ? "undefined" : _typeof(event)) === "object" && event);
	
				// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
				event.isTrigger = onlyHandlers ? 2 : 3;
				event.namespace = namespaces.join(".");
				event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
	
				// Clean up the event in case it is being reused
				event.result = undefined;
				if (!event.target) {
					event.target = elem;
				}
	
				// Clone any incoming data and prepend the event, creating the handler arg list
				data = data == null ? [event] : jQuery.makeArray(data, [event]);
	
				// Allow special events to draw outside the lines
				special = jQuery.event.special[type] || {};
				if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
					return;
				}
	
				// Determine event propagation path in advance, per W3C events spec (#9951)
				// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
				if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
	
					bubbleType = special.delegateType || type;
					if (!rfocusMorph.test(bubbleType + type)) {
						cur = cur.parentNode;
					}
					for (; cur; cur = cur.parentNode) {
						eventPath.push(cur);
						tmp = cur;
					}
	
					// Only add window if we got to document (e.g., not plain obj or detached DOM)
					if (tmp === (elem.ownerDocument || document)) {
						eventPath.push(tmp.defaultView || tmp.parentWindow || window);
					}
				}
	
				// Fire handlers on the event path
				i = 0;
				while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
					lastElement = cur;
					event.type = i > 1 ? bubbleType : special.bindType || type;
	
					// jQuery handler
					handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
					if (handle) {
						handle.apply(cur, data);
					}
	
					// Native handler
					handle = ontype && cur[ontype];
					if (handle && handle.apply && acceptData(cur)) {
						event.result = handle.apply(cur, data);
						if (event.result === false) {
							event.preventDefault();
						}
					}
				}
				event.type = type;
	
				// If nobody prevented the default action, do it now
				if (!onlyHandlers && !event.isDefaultPrevented()) {
	
					if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {
	
						// Call a native DOM method on the target with the same name as the event.
						// Don't do default actions on window, that's where global variables be (#6170)
						if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
	
							// Don't re-trigger an onFOO event when we call its FOO() method
							tmp = elem[ontype];
	
							if (tmp) {
								elem[ontype] = null;
							}
	
							// Prevent re-triggering of the same event, since we already bubbled it above
							jQuery.event.triggered = type;
	
							if (event.isPropagationStopped()) {
								lastElement.addEventListener(type, stopPropagationCallback);
							}
	
							elem[type]();
	
							if (event.isPropagationStopped()) {
								lastElement.removeEventListener(type, stopPropagationCallback);
							}
	
							jQuery.event.triggered = undefined;
	
							if (tmp) {
								elem[ontype] = tmp;
							}
						}
					}
				}
	
				return event.result;
			},
	
			// Piggyback on a donor event to simulate a different one
			// Used only for `focus(in | out)` events
			simulate: function simulate(type, elem, event) {
				var e = jQuery.extend(new jQuery.Event(), event, {
					type: type,
					isSimulated: true
				});
	
				jQuery.event.trigger(e, null, elem);
			}
	
		});
	
		jQuery.fn.extend({
	
			trigger: function trigger(type, data) {
				return this.each(function () {
					jQuery.event.trigger(type, data, this);
				});
			},
			triggerHandler: function triggerHandler(type, data) {
				var elem = this[0];
				if (elem) {
					return jQuery.event.trigger(type, data, elem, true);
				}
			}
		});
	
		// Support: Firefox <=44
		// Firefox doesn't have focus(in | out) events
		// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
		//
		// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
		// focus(in | out) events fire after focus & blur events,
		// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
		// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
		if (!support.focusin) {
			jQuery.each({ focus: "focusin", blur: "focusout" }, function (orig, fix) {
	
				// Attach a single capturing handler on the document while someone wants focusin/focusout
				var handler = function handler(event) {
					jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
				};
	
				jQuery.event.special[fix] = {
					setup: function setup() {
	
						// Handle: regular nodes (via `this.ownerDocument`), window
						// (via `this.document`) & document (via `this`).
						var doc = this.ownerDocument || this.document || this,
						    attaches = dataPriv.access(doc, fix);
	
						if (!attaches) {
							doc.addEventListener(orig, handler, true);
						}
						dataPriv.access(doc, fix, (attaches || 0) + 1);
					},
					teardown: function teardown() {
						var doc = this.ownerDocument || this.document || this,
						    attaches = dataPriv.access(doc, fix) - 1;
	
						if (!attaches) {
							doc.removeEventListener(orig, handler, true);
							dataPriv.remove(doc, fix);
						} else {
							dataPriv.access(doc, fix, attaches);
						}
					}
				};
			});
		}
		var location = window.location;
	
		var nonce = { guid: Date.now() };
	
		var rquery = /\?/;
	
		// Cross-browser xml parsing
		jQuery.parseXML = function (data) {
			var xml, parserErrorElem;
			if (!data || typeof data !== "string") {
				return null;
			}
	
			// Support: IE 9 - 11 only
			// IE throws on parseFromString with invalid input.
			try {
				xml = new window.DOMParser().parseFromString(data, "text/xml");
			} catch (e) {}
	
			parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
			if (!xml || parserErrorElem) {
				jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function (el) {
					return el.textContent;
				}).join("\n") : data));
			}
			return xml;
		};
	
		var rbracket = /\[\]$/,
		    rCRLF = /\r?\n/g,
		    rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		    rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
		function buildParams(prefix, obj, traditional, add) {
			var name;
	
			if (Array.isArray(obj)) {
	
				// Serialize array item.
				jQuery.each(obj, function (i, v) {
					if (traditional || rbracket.test(prefix)) {
	
						// Treat each array item as a scalar.
						add(prefix, v);
					} else {
	
						// Item is non-scalar (array or object), encode its numeric index.
						buildParams(prefix + "[" + ((typeof v === "undefined" ? "undefined" : _typeof(v)) === "object" && v != null ? i : "") + "]", v, traditional, add);
					}
				});
			} else if (!traditional && toType(obj) === "object") {
	
				// Serialize object item.
				for (name in obj) {
					buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
				}
			} else {
	
				// Serialize scalar item.
				add(prefix, obj);
			}
		}
	
		// Serialize an array of form elements or a set of
		// key/values into a query string
		jQuery.param = function (a, traditional) {
			var prefix,
			    s = [],
			    add = function add(key, valueOrFunction) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
	
				s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
			};
	
			if (a == null) {
				return "";
			}
	
			// If an array was passed in, assume that it is an array of form elements.
			if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) {
	
				// Serialize the form elements
				jQuery.each(a, function () {
					add(this.name, this.value);
				});
			} else {
	
				// If traditional, encode the "old" way (the way 1.3.2 or older
				// did it), otherwise encode params recursively.
				for (prefix in a) {
					buildParams(prefix, a[prefix], traditional, add);
				}
			}
	
			// Return the resulting serialization
			return s.join("&");
		};
	
		jQuery.fn.extend({
			serialize: function serialize() {
				return jQuery.param(this.serializeArray());
			},
			serializeArray: function serializeArray() {
				return this.map(function () {
	
					// Can add propHook for "elements" to filter or add form elements
					var elements = jQuery.prop(this, "elements");
					return elements ? jQuery.makeArray(elements) : this;
				}).filter(function () {
					var type = this.type;
	
					// Use .is( ":disabled" ) so that fieldset[disabled] works
					return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
				}).map(function (_i, elem) {
					var val = jQuery(this).val();
	
					if (val == null) {
						return null;
					}
	
					if (Array.isArray(val)) {
						return jQuery.map(val, function (val) {
							return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
						});
					}
	
					return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
				}).get();
			}
		});
	
		var r20 = /%20/g,
		    rhash = /#.*$/,
		    rantiCache = /([?&])_=[^&]*/,
		    rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		    rnoContent = /^(?:GET|HEAD)$/,
		    rprotocol = /^\/\//,
	
	
		/* Prefilters
	  * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	  * 2) These are called:
	  *    - BEFORE asking for a transport
	  *    - AFTER param serialization (s.data is a string if s.processData is true)
	  * 3) key is the dataType
	  * 4) the catchall symbol "*" can be used
	  * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	  */
		prefilters = {},
	
	
		/* Transports bindings
	  * 1) key is the dataType
	  * 2) the catchall symbol "*" can be used
	  * 3) selection will start with transport dataType and THEN go to "*" if needed
	  */
		transports = {},
	
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat("*"),
	
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement("a");
	
		originAnchor.href = location.href;
	
		// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
		function addToPrefiltersOrTransports(structure) {
	
			// dataTypeExpression is optional and defaults to "*"
			return function (dataTypeExpression, func) {
	
				if (typeof dataTypeExpression !== "string") {
					func = dataTypeExpression;
					dataTypeExpression = "*";
				}
	
				var dataType,
				    i = 0,
				    dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
	
				if (isFunction(func)) {
	
					// For each dataType in the dataTypeExpression
					while (dataType = dataTypes[i++]) {
	
						// Prepend if requested
						if (dataType[0] === "+") {
							dataType = dataType.slice(1) || "*";
							(structure[dataType] = structure[dataType] || []).unshift(func);
	
							// Otherwise append
						} else {
							(structure[dataType] = structure[dataType] || []).push(func);
						}
					}
				}
			};
		}
	
		// Base inspection function for prefilters and transports
		function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
	
			var inspected = {},
			    seekingTransport = structure === transports;
	
			function inspect(dataType) {
				var selected;
				inspected[dataType] = true;
				jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
					var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
					if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
	
						options.dataTypes.unshift(dataTypeOrTransport);
						inspect(dataTypeOrTransport);
						return false;
					} else if (seekingTransport) {
						return !(selected = dataTypeOrTransport);
					}
				});
				return selected;
			}
	
			return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
		}
	
		// A special extend for ajax options
		// that takes "flat" options (not to be deep extended)
		// Fixes #9887
		function ajaxExtend(target, src) {
			var key,
			    deep,
			    flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
			for (key in src) {
				if (src[key] !== undefined) {
					(flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
				}
			}
			if (deep) {
				jQuery.extend(true, target, deep);
			}
	
			return target;
		}
	
		/* Handles responses to an ajax request:
	  * - finds the right dataType (mediates between content-type and expected dataType)
	  * - returns the corresponding response
	  */
		function ajaxHandleResponses(s, jqXHR, responses) {
	
			var ct,
			    type,
			    finalDataType,
			    firstDataType,
			    contents = s.contents,
			    dataTypes = s.dataTypes;
	
			// Remove auto dataType and get content-type in the process
			while (dataTypes[0] === "*") {
				dataTypes.shift();
				if (ct === undefined) {
					ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
				}
			}
	
			// Check if we're dealing with a known content-type
			if (ct) {
				for (type in contents) {
					if (contents[type] && contents[type].test(ct)) {
						dataTypes.unshift(type);
						break;
					}
				}
			}
	
			// Check to see if we have a response for the expected dataType
			if (dataTypes[0] in responses) {
				finalDataType = dataTypes[0];
			} else {
	
				// Try convertible dataTypes
				for (type in responses) {
					if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
						finalDataType = type;
						break;
					}
					if (!firstDataType) {
						firstDataType = type;
					}
				}
	
				// Or just use first one
				finalDataType = finalDataType || firstDataType;
			}
	
			// If we found a dataType
			// We add the dataType to the list if needed
			// and return the corresponding response
			if (finalDataType) {
				if (finalDataType !== dataTypes[0]) {
					dataTypes.unshift(finalDataType);
				}
				return responses[finalDataType];
			}
		}
	
		/* Chain conversions given the request and the original response
	  * Also sets the responseXXX fields on the jqXHR instance
	  */
		function ajaxConvert(s, response, jqXHR, isSuccess) {
			var conv2,
			    current,
			    conv,
			    tmp,
			    prev,
			    converters = {},
	
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
			// Create converters map with lowercased keys
			if (dataTypes[1]) {
				for (conv in s.converters) {
					converters[conv.toLowerCase()] = s.converters[conv];
				}
			}
	
			current = dataTypes.shift();
	
			// Convert to each sequential dataType
			while (current) {
	
				if (s.responseFields[current]) {
					jqXHR[s.responseFields[current]] = response;
				}
	
				// Apply the dataFilter if provided
				if (!prev && isSuccess && s.dataFilter) {
					response = s.dataFilter(response, s.dataType);
				}
	
				prev = current;
				current = dataTypes.shift();
	
				if (current) {
	
					// There's only work to do if current dataType is non-auto
					if (current === "*") {
	
						current = prev;
	
						// Convert response if prev dataType is non-auto and differs from current
					} else if (prev !== "*" && prev !== current) {
	
						// Seek a direct converter
						conv = converters[prev + " " + current] || converters["* " + current];
	
						// If none found, seek a pair
						if (!conv) {
							for (conv2 in converters) {
	
								// If conv2 outputs current
								tmp = conv2.split(" ");
								if (tmp[1] === current) {
	
									// If prev can be converted to accepted input
									conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
									if (conv) {
	
										// Condense equivalence converters
										if (conv === true) {
											conv = converters[conv2];
	
											// Otherwise, insert the intermediate dataType
										} else if (converters[conv2] !== true) {
											current = tmp[0];
											dataTypes.unshift(tmp[1]);
										}
										break;
									}
								}
							}
						}
	
						// Apply converter (if not an equivalence)
						if (conv !== true) {
	
							// Unless errors are allowed to bubble, catch and return them
							if (conv && s.throws) {
								response = conv(response);
							} else {
								try {
									response = conv(response);
								} catch (e) {
									return {
										state: "parsererror",
										error: conv ? e : "No conversion from " + prev + " to " + current
									};
								}
							}
						}
					}
				}
			}
	
			return { state: "success", data: response };
		}
	
		jQuery.extend({
	
			// Counter for holding the number of active queries
			active: 0,
	
			// Last-Modified header cache for next request
			lastModified: {},
			etag: {},
	
			ajaxSettings: {
				url: location.href,
				type: "GET",
				isLocal: rlocalProtocol.test(location.protocol),
				global: true,
				processData: true,
				async: true,
				contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
				/*
	   timeout: 0,
	   data: null,
	   dataType: null,
	   username: null,
	   password: null,
	   cache: null,
	   throws: false,
	   traditional: false,
	   headers: {},
	   */
	
				accepts: {
					"*": allTypes,
					text: "text/plain",
					html: "text/html",
					xml: "application/xml, text/xml",
					json: "application/json, text/javascript"
				},
	
				contents: {
					xml: /\bxml\b/,
					html: /\bhtml/,
					json: /\bjson\b/
				},
	
				responseFields: {
					xml: "responseXML",
					text: "responseText",
					json: "responseJSON"
				},
	
				// Data converters
				// Keys separate source (or catchall "*") and destination types with a single space
				converters: {
	
					// Convert anything to text
					"* text": String,
	
					// Text to html (true = no transformation)
					"text html": true,
	
					// Evaluate text as a json expression
					"text json": JSON.parse,
	
					// Parse text as xml
					"text xml": jQuery.parseXML
				},
	
				// For options that shouldn't be deep extended:
				// you can add your own custom options here if
				// and when you create one that shouldn't be
				// deep extended (see ajaxExtend)
				flatOptions: {
					url: true,
					context: true
				}
			},
	
			// Creates a full fledged settings object into target
			// with both ajaxSettings and settings fields.
			// If target is omitted, writes into ajaxSettings.
			ajaxSetup: function ajaxSetup(target, settings) {
				return settings ?
	
				// Building a settings object
				ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) :
	
				// Extending ajaxSettings
				ajaxExtend(jQuery.ajaxSettings, target);
			},
	
			ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
			ajaxTransport: addToPrefiltersOrTransports(transports),
	
			// Main method
			ajax: function ajax(url, options) {
	
				// If url is an object, simulate pre-1.5 signature
				if ((typeof url === "undefined" ? "undefined" : _typeof(url)) === "object") {
					options = url;
					url = undefined;
				}
	
				// Force options to be an object
				options = options || {};
	
				var transport,
	
	
				// URL without anti-cache param
				cacheURL,
	
	
				// Response headers
				responseHeadersString,
				    responseHeaders,
	
	
				// timeout handle
				timeoutTimer,
	
	
				// Url cleanup var
				urlAnchor,
	
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
	
				// To know if global events are to be dispatched
				fireGlobals,
	
	
				// Loop variable
				i,
	
	
				// uncached part of the url
				uncached,
	
	
				// Create the final options object
				s = jQuery.ajaxSetup({}, options),
	
	
				// Callbacks context
				callbackContext = s.context || s,
	
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event,
	
	
				// Deferreds
				deferred = jQuery.Deferred(),
				    completeDeferred = jQuery.Callbacks("once memory"),
	
	
				// Status-dependent callbacks
				_statusCode = s.statusCode || {},
	
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				    requestHeadersNames = {},
	
	
				// Default abort message
				strAbort = "canceled",
	
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function getResponseHeader(key) {
						var match;
						if (completed) {
							if (!responseHeaders) {
								responseHeaders = {};
								while (match = rheaders.exec(responseHeadersString)) {
									responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
								}
							}
							match = responseHeaders[key.toLowerCase() + " "];
						}
						return match == null ? null : match.join(", ");
					},
	
					// Raw string
					getAllResponseHeaders: function getAllResponseHeaders() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function setRequestHeader(name, value) {
						if (completed == null) {
							name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
							requestHeaders[name] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function overrideMimeType(type) {
						if (completed == null) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function statusCode(map) {
						var code;
						if (map) {
							if (completed) {
	
								// Execute the appropriate callbacks
								jqXHR.always(map[jqXHR.status]);
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for (code in map) {
									_statusCode[code] = [_statusCode[code], map[code]];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function abort(statusText) {
						var finalText = statusText || strAbort;
						if (transport) {
							transport.abort(finalText);
						}
						done(0, finalText);
						return this;
					}
				};
	
				// Attach deferreds
				deferred.promise(jqXHR);
	
				// Add protocol if not provided (prefilters might expect it)
				// Handle falsy url in the settings object (#10093: consistency with old signature)
				// We also use the url parameter if available
				s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
	
				// Alias method option to type as per ticket #12004
				s.type = options.method || options.type || s.method || s.type;
	
				// Extract dataTypes list
				s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];
	
				// A cross-domain request is in order when the origin doesn't match the current origin.
				if (s.crossDomain == null) {
					urlAnchor = document.createElement("a");
	
					// Support: IE <=8 - 11, Edge 12 - 15
					// IE throws exception on accessing the href property if url is malformed,
					// e.g. http://example.com:80x/
					try {
						urlAnchor.href = s.url;
	
						// Support: IE <=8 - 11 only
						// Anchor's host property isn't correctly set when s.url is relative
						urlAnchor.href = urlAnchor.href;
						s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
					} catch (e) {
	
						// If there is an error parsing the URL, assume it is crossDomain,
						// it can be rejected by the transport if it is invalid
						s.crossDomain = true;
					}
				}
	
				// Convert data if not already a string
				if (s.data && s.processData && typeof s.data !== "string") {
					s.data = jQuery.param(s.data, s.traditional);
				}
	
				// Apply prefilters
				inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
	
				// If request was aborted inside a prefilter, stop there
				if (completed) {
					return jqXHR;
				}
	
				// We can fire global events as of now if asked to
				// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
				fireGlobals = jQuery.event && s.global;
	
				// Watch for a new set of requests
				if (fireGlobals && jQuery.active++ === 0) {
					jQuery.event.trigger("ajaxStart");
				}
	
				// Uppercase the type
				s.type = s.type.toUpperCase();
	
				// Determine if request has content
				s.hasContent = !rnoContent.test(s.type);
	
				// Save the URL in case we're toying with the If-Modified-Since
				// and/or If-None-Match header later on
				// Remove hash to simplify url manipulation
				cacheURL = s.url.replace(rhash, "");
	
				// More options handling for requests with no content
				if (!s.hasContent) {
	
					// Remember the hash so we can put it back
					uncached = s.url.slice(cacheURL.length);
	
					// If data is available and should be processed, append data to url
					if (s.data && (s.processData || typeof s.data === "string")) {
						cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
	
						// #9682: remove data so that it's not used in an eventual retry
						delete s.data;
					}
	
					// Add or update anti-cache param if needed
					if (s.cache === false) {
						cacheURL = cacheURL.replace(rantiCache, "$1");
						uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
					}
	
					// Put hash and anti-cache on the URL that will be requested (gh-1732)
					s.url = cacheURL + uncached;
	
					// Change '%20' to '+' if this is encoded form body content (gh-2658)
				} else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
					s.data = s.data.replace(r20, "+");
				}
	
				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if (s.ifModified) {
					if (jQuery.lastModified[cacheURL]) {
						jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
					}
					if (jQuery.etag[cacheURL]) {
						jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
					}
				}
	
				// Set the correct header, if data is being sent
				if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
					jqXHR.setRequestHeader("Content-Type", s.contentType);
				}
	
				// Set the Accepts header for the server, depending on the dataType
				jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
	
				// Check for headers option
				for (i in s.headers) {
					jqXHR.setRequestHeader(i, s.headers[i]);
				}
	
				// Allow custom headers/mimetypes and early abort
				if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) {
	
					// Abort if not done already and return
					return jqXHR.abort();
				}
	
				// Aborting is no longer a cancellation
				strAbort = "abort";
	
				// Install callbacks on deferreds
				completeDeferred.add(s.complete);
				jqXHR.done(s.success);
				jqXHR.fail(s.error);
	
				// Get transport
				transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
	
				// If no transport, we auto-abort
				if (!transport) {
					done(-1, "No Transport");
				} else {
					jqXHR.readyState = 1;
	
					// Send global event
					if (fireGlobals) {
						globalEventContext.trigger("ajaxSend", [jqXHR, s]);
					}
	
					// If request was aborted inside ajaxSend, stop there
					if (completed) {
						return jqXHR;
					}
	
					// Timeout
					if (s.async && s.timeout > 0) {
						timeoutTimer = window.setTimeout(function () {
							jqXHR.abort("timeout");
						}, s.timeout);
					}
	
					try {
						completed = false;
						transport.send(requestHeaders, done);
					} catch (e) {
	
						// Rethrow post-completion exceptions
						if (completed) {
							throw e;
						}
	
						// Propagate others as results
						done(-1, e);
					}
				}
	
				// Callback for when everything is done
				function done(status, nativeStatusText, responses, headers) {
					var isSuccess,
					    success,
					    error,
					    response,
					    modified,
					    statusText = nativeStatusText;
	
					// Ignore repeat invocations
					if (completed) {
						return;
					}
	
					completed = true;
	
					// Clear timeout if it exists
					if (timeoutTimer) {
						window.clearTimeout(timeoutTimer);
					}
	
					// Dereference transport for early garbage collection
					// (no matter how long the jqXHR object will be used)
					transport = undefined;
	
					// Cache response headers
					responseHeadersString = headers || "";
	
					// Set readyState
					jqXHR.readyState = status > 0 ? 4 : 0;
	
					// Determine if successful
					isSuccess = status >= 200 && status < 300 || status === 304;
	
					// Get response data
					if (responses) {
						response = ajaxHandleResponses(s, jqXHR, responses);
					}
	
					// Use a noop converter for missing script but not if jsonp
					if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) {
						s.converters["text script"] = function () {};
					}
	
					// Convert no matter what (that way responseXXX fields are always set)
					response = ajaxConvert(s, response, jqXHR, isSuccess);
	
					// If successful, handle type chaining
					if (isSuccess) {
	
						// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
						if (s.ifModified) {
							modified = jqXHR.getResponseHeader("Last-Modified");
							if (modified) {
								jQuery.lastModified[cacheURL] = modified;
							}
							modified = jqXHR.getResponseHeader("etag");
							if (modified) {
								jQuery.etag[cacheURL] = modified;
							}
						}
	
						// if no content
						if (status === 204 || s.type === "HEAD") {
							statusText = "nocontent";
	
							// if not modified
						} else if (status === 304) {
							statusText = "notmodified";
	
							// If we have data, let's convert it
						} else {
							statusText = response.state;
							success = response.data;
							error = response.error;
							isSuccess = !error;
						}
					} else {
	
						// Extract error from statusText and normalize for non-aborts
						error = statusText;
						if (status || !statusText) {
							statusText = "error";
							if (status < 0) {
								status = 0;
							}
						}
					}
	
					// Set data for the fake xhr object
					jqXHR.status = status;
					jqXHR.statusText = (nativeStatusText || statusText) + "";
	
					// Success/Error
					if (isSuccess) {
						deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
					} else {
						deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
					}
	
					// Status-dependent callbacks
					jqXHR.statusCode(_statusCode);
					_statusCode = undefined;
	
					if (fireGlobals) {
						globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [jqXHR, s, isSuccess ? success : error]);
					}
	
					// Complete
					completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);
	
					if (fireGlobals) {
						globalEventContext.trigger("ajaxComplete", [jqXHR, s]);
	
						// Handle the global AJAX counter
						if (! --jQuery.active) {
							jQuery.event.trigger("ajaxStop");
						}
					}
				}
	
				return jqXHR;
			},
	
			getJSON: function getJSON(url, data, callback) {
				return jQuery.get(url, data, callback, "json");
			},
	
			getScript: function getScript(url, callback) {
				return jQuery.get(url, undefined, callback, "script");
			}
		});
	
		jQuery.each(["get", "post"], function (_i, method) {
			jQuery[method] = function (url, data, callback, type) {
	
				// Shift arguments if data argument was omitted
				if (isFunction(data)) {
					type = type || callback;
					callback = data;
					data = undefined;
				}
	
				// The url can be an options object (which then must have .url)
				return jQuery.ajax(jQuery.extend({
					url: url,
					type: method,
					dataType: type,
					data: data,
					success: callback
				}, jQuery.isPlainObject(url) && url));
			};
		});
	
		jQuery.ajaxPrefilter(function (s) {
			var i;
			for (i in s.headers) {
				if (i.toLowerCase() === "content-type") {
					s.contentType = s.headers[i] || "";
				}
			}
		});
	
		jQuery._evalUrl = function (url, options, doc) {
			return jQuery.ajax({
				url: url,
	
				// Make this explicit, since user can override this through ajaxSetup (#11264)
				type: "GET",
				dataType: "script",
				cache: true,
				async: false,
				global: false,
	
				// Only evaluate the response if it is successful (gh-4126)
				// dataFilter is not invoked for failure responses, so using it instead
				// of the default converter is kludgy but it works.
				converters: {
					"text script": function textScript() {}
				},
				dataFilter: function dataFilter(response) {
					jQuery.globalEval(response, options, doc);
				}
			});
		};
	
		jQuery.fn.extend({
			wrapAll: function wrapAll(html) {
				var wrap;
	
				if (this[0]) {
					if (isFunction(html)) {
						html = html.call(this[0]);
					}
	
					// The elements to wrap the target around
					wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
	
					if (this[0].parentNode) {
						wrap.insertBefore(this[0]);
					}
	
					wrap.map(function () {
						var elem = this;
	
						while (elem.firstElementChild) {
							elem = elem.firstElementChild;
						}
	
						return elem;
					}).append(this);
				}
	
				return this;
			},
	
			wrapInner: function wrapInner(html) {
				if (isFunction(html)) {
					return this.each(function (i) {
						jQuery(this).wrapInner(html.call(this, i));
					});
				}
	
				return this.each(function () {
					var self = jQuery(this),
					    contents = self.contents();
	
					if (contents.length) {
						contents.wrapAll(html);
					} else {
						self.append(html);
					}
				});
			},
	
			wrap: function wrap(html) {
				var htmlIsFunction = isFunction(html);
	
				return this.each(function (i) {
					jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
				});
			},
	
			unwrap: function unwrap(selector) {
				this.parent(selector).not("body").each(function () {
					jQuery(this).replaceWith(this.childNodes);
				});
				return this;
			}
		});
	
		jQuery.expr.pseudos.hidden = function (elem) {
			return !jQuery.expr.pseudos.visible(elem);
		};
		jQuery.expr.pseudos.visible = function (elem) {
			return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
		};
	
		jQuery.ajaxSettings.xhr = function () {
			try {
				return new window.XMLHttpRequest();
			} catch (e) {}
		};
	
		var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		    xhrSupported = jQuery.ajaxSettings.xhr();
	
		support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
		support.ajax = xhrSupported = !!xhrSupported;
	
		jQuery.ajaxTransport(function (options) {
			var _callback, errorCallback;
	
			// Cross domain only allowed if supported through XMLHttpRequest
			if (support.cors || xhrSupported && !options.crossDomain) {
				return {
					send: function send(headers, complete) {
						var i,
						    xhr = options.xhr();
	
						xhr.open(options.type, options.url, options.async, options.username, options.password);
	
						// Apply custom fields if provided
						if (options.xhrFields) {
							for (i in options.xhrFields) {
								xhr[i] = options.xhrFields[i];
							}
						}
	
						// Override mime type if needed
						if (options.mimeType && xhr.overrideMimeType) {
							xhr.overrideMimeType(options.mimeType);
						}
	
						// X-Requested-With header
						// For cross-domain requests, seeing as conditions for a preflight are
						// akin to a jigsaw puzzle, we simply never set it to be sure.
						// (it can always be set on a per-request basis or even using ajaxSetup)
						// For same-domain requests, won't change header if already provided.
						if (!options.crossDomain && !headers["X-Requested-With"]) {
							headers["X-Requested-With"] = "XMLHttpRequest";
						}
	
						// Set headers
						for (i in headers) {
							xhr.setRequestHeader(i, headers[i]);
						}
	
						// Callback
						_callback = function callback(type) {
							return function () {
								if (_callback) {
									_callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
	
									if (type === "abort") {
										xhr.abort();
									} else if (type === "error") {
	
										// Support: IE <=9 only
										// On a manual native abort, IE9 throws
										// errors on any property access that is not readyState
										if (typeof xhr.status !== "number") {
											complete(0, "error");
										} else {
											complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status, xhr.statusText);
										}
									} else {
										complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										(xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? { binary: xhr.response } : { text: xhr.responseText }, xhr.getAllResponseHeaders());
									}
								}
							};
						};
	
						// Listen to events
						xhr.onload = _callback();
						errorCallback = xhr.onerror = xhr.ontimeout = _callback("error");
	
						// Support: IE 9 only
						// Use onreadystatechange to replace onabort
						// to handle uncaught aborts
						if (xhr.onabort !== undefined) {
							xhr.onabort = errorCallback;
						} else {
							xhr.onreadystatechange = function () {
	
								// Check readyState before timeout as it changes
								if (xhr.readyState === 4) {
	
									// Allow onerror to be called first,
									// but that will not handle a native abort
									// Also, save errorCallback to a variable
									// as xhr.onerror cannot be accessed
									window.setTimeout(function () {
										if (_callback) {
											errorCallback();
										}
									});
								}
							};
						}
	
						// Create the abort callback
						_callback = _callback("abort");
	
						try {
	
							// Do send the request (this may raise an exception)
							xhr.send(options.hasContent && options.data || null);
						} catch (e) {
	
							// #14683: Only rethrow if this hasn't been notified as an error yet
							if (_callback) {
								throw e;
							}
						}
					},
	
					abort: function abort() {
						if (_callback) {
							_callback();
						}
					}
				};
			}
		});
	
		// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
		jQuery.ajaxPrefilter(function (s) {
			if (s.crossDomain) {
				s.contents.script = false;
			}
		});
	
		// Install script dataType
		jQuery.ajaxSetup({
			accepts: {
				script: "text/javascript, application/javascript, " + "application/ecmascript, application/x-ecmascript"
			},
			contents: {
				script: /\b(?:java|ecma)script\b/
			},
			converters: {
				"text script": function textScript(text) {
					jQuery.globalEval(text);
					return text;
				}
			}
		});
	
		// Handle cache's special case and crossDomain
		jQuery.ajaxPrefilter("script", function (s) {
			if (s.cache === undefined) {
				s.cache = false;
			}
			if (s.crossDomain) {
				s.type = "GET";
			}
		});
	
		// Bind script tag hack transport
		jQuery.ajaxTransport("script", function (s) {
	
			// This transport only deals with cross domain or forced-by-attrs requests
			if (s.crossDomain || s.scriptAttrs) {
				var script, _callback2;
				return {
					send: function send(_, complete) {
						script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({ charset: s.scriptCharset, src: s.url }).on("load error", _callback2 = function callback(evt) {
							script.remove();
							_callback2 = null;
							if (evt) {
								complete(evt.type === "error" ? 404 : 200, evt.type);
							}
						});
	
						// Use native DOM manipulation to avoid our domManip AJAX trickery
						document.head.appendChild(script[0]);
					},
					abort: function abort() {
						if (_callback2) {
							_callback2();
						}
					}
				};
			}
		});
	
		var oldCallbacks = [],
		    rjsonp = /(=)\?(?=&|$)|\?\?/;
	
		// Default jsonp settings
		jQuery.ajaxSetup({
			jsonp: "callback",
			jsonpCallback: function jsonpCallback() {
				var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
				this[callback] = true;
				return callback;
			}
		});
	
		// Detect, normalize options and install callbacks for jsonp requests
		jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {
	
			var callbackName,
			    overwritten,
			    responseContainer,
			    jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
	
			// Handle iff the expected data type is "jsonp" or we have a parameter to set
			if (jsonProp || s.dataTypes[0] === "jsonp") {
	
				// Get callback name, remembering preexisting value associated with it
				callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
	
				// Insert callback into url or form data
				if (jsonProp) {
					s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
				} else if (s.jsonp !== false) {
					s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
				}
	
				// Use data converter to retrieve json after script execution
				s.converters["script json"] = function () {
					if (!responseContainer) {
						jQuery.error(callbackName + " was not called");
					}
					return responseContainer[0];
				};
	
				// Force json dataType
				s.dataTypes[0] = "json";
	
				// Install callback
				overwritten = window[callbackName];
				window[callbackName] = function () {
					responseContainer = arguments;
				};
	
				// Clean-up function (fires after converters)
				jqXHR.always(function () {
	
					// If previous value didn't exist - remove it
					if (overwritten === undefined) {
						jQuery(window).removeProp(callbackName);
	
						// Otherwise restore preexisting value
					} else {
						window[callbackName] = overwritten;
					}
	
					// Save back as free
					if (s[callbackName]) {
	
						// Make sure that re-using the options doesn't screw things around
						s.jsonpCallback = originalSettings.jsonpCallback;
	
						// Save the callback name for future use
						oldCallbacks.push(callbackName);
					}
	
					// Call if it was a function and we have a response
					if (responseContainer && isFunction(overwritten)) {
						overwritten(responseContainer[0]);
					}
	
					responseContainer = overwritten = undefined;
				});
	
				// Delegate to script
				return "script";
			}
		});
	
		// Support: Safari 8 only
		// In Safari 8 documents created via document.implementation.createHTMLDocument
		// collapse sibling forms: the second one becomes a child of the first one.
		// Because of that, this security measure has to be disabled in Safari 8.
		// https://bugs.webkit.org/show_bug.cgi?id=137337
		support.createHTMLDocument = function () {
			var body = document.implementation.createHTMLDocument("").body;
			body.innerHTML = "<form></form><form></form>";
			return body.childNodes.length === 2;
		}();
	
		// Argument "data" should be string of html
		// context (optional): If specified, the fragment will be created in this context,
		// defaults to document
		// keepScripts (optional): If true, will include scripts passed in the html string
		jQuery.parseHTML = function (data, context, keepScripts) {
			if (typeof data !== "string") {
				return [];
			}
			if (typeof context === "boolean") {
				keepScripts = context;
				context = false;
			}
	
			var base, parsed, scripts;
	
			if (!context) {
	
				// Stop scripts or inline event handlers from being executed immediately
				// by using document.implementation
				if (support.createHTMLDocument) {
					context = document.implementation.createHTMLDocument("");
	
					// Set the base href for the created document
					// so any parsed elements with URLs
					// are based on the document's URL (gh-2965)
					base = context.createElement("base");
					base.href = document.location.href;
					context.head.appendChild(base);
				} else {
					context = document;
				}
			}
	
			parsed = rsingleTag.exec(data);
			scripts = !keepScripts && [];
	
			// Single tag
			if (parsed) {
				return [context.createElement(parsed[1])];
			}
	
			parsed = buildFragment([data], context, scripts);
	
			if (scripts && scripts.length) {
				jQuery(scripts).remove();
			}
	
			return jQuery.merge([], parsed.childNodes);
		};
	
		/**
	  * Load a url into a page
	  */
		jQuery.fn.load = function (url, params, callback) {
			var selector,
			    type,
			    response,
			    self = this,
			    off = url.indexOf(" ");
	
			if (off > -1) {
				selector = stripAndCollapse(url.slice(off));
				url = url.slice(0, off);
			}
	
			// If it's a function
			if (isFunction(params)) {
	
				// We assume that it's the callback
				callback = params;
				params = undefined;
	
				// Otherwise, build a param string
			} else if (params && (typeof params === "undefined" ? "undefined" : _typeof(params)) === "object") {
				type = "POST";
			}
	
			// If we have elements to modify, make the request
			if (self.length > 0) {
				jQuery.ajax({
					url: url,
	
					// If "type" variable is undefined, then "GET" method will be used.
					// Make value of this field explicit since
					// user can override it through ajaxSetup method
					type: type || "GET",
					dataType: "html",
					data: params
				}).done(function (responseText) {
	
					// Save response for use in complete callback
					response = arguments;
	
					self.html(selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) :
	
					// Otherwise use the full result
					responseText);
	
					// If the request succeeds, this function gets "data", "status", "jqXHR"
					// but they are ignored because response was set above.
					// If it fails, this function gets "jqXHR", "status", "error"
				}).always(callback && function (jqXHR, status) {
					self.each(function () {
						callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
					});
				});
			}
	
			return this;
		};
	
		jQuery.expr.pseudos.animated = function (elem) {
			return jQuery.grep(jQuery.timers, function (fn) {
				return elem === fn.elem;
			}).length;
		};
	
		jQuery.offset = {
			setOffset: function setOffset(elem, options, i) {
				var curPosition,
				    curLeft,
				    curCSSTop,
				    curTop,
				    curOffset,
				    curCSSLeft,
				    calculatePosition,
				    position = jQuery.css(elem, "position"),
				    curElem = jQuery(elem),
				    props = {};
	
				// Set position first, in-case top/left are set even on static elem
				if (position === "static") {
					elem.style.position = "relative";
				}
	
				curOffset = curElem.offset();
				curCSSTop = jQuery.css(elem, "top");
				curCSSLeft = jQuery.css(elem, "left");
				calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
	
				// Need to be able to calculate position if either
				// top or left is auto and position is either absolute or fixed
				if (calculatePosition) {
					curPosition = curElem.position();
					curTop = curPosition.top;
					curLeft = curPosition.left;
				} else {
					curTop = parseFloat(curCSSTop) || 0;
					curLeft = parseFloat(curCSSLeft) || 0;
				}
	
				if (isFunction(options)) {
	
					// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
					options = options.call(elem, i, jQuery.extend({}, curOffset));
				}
	
				if (options.top != null) {
					props.top = options.top - curOffset.top + curTop;
				}
				if (options.left != null) {
					props.left = options.left - curOffset.left + curLeft;
				}
	
				if ("using" in options) {
					options.using.call(elem, props);
				} else {
					curElem.css(props);
				}
			}
		};
	
		jQuery.fn.extend({
	
			// offset() relates an element's border box to the document origin
			offset: function offset(options) {
	
				// Preserve chaining for setter
				if (arguments.length) {
					return options === undefined ? this : this.each(function (i) {
						jQuery.offset.setOffset(this, options, i);
					});
				}
	
				var rect,
				    win,
				    elem = this[0];
	
				if (!elem) {
					return;
				}
	
				// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
				// Support: IE <=11 only
				// Running getBoundingClientRect on a
				// disconnected node in IE throws an error
				if (!elem.getClientRects().length) {
					return { top: 0, left: 0 };
				}
	
				// Get document-relative position by adding viewport scroll to viewport-relative gBCR
				rect = elem.getBoundingClientRect();
				win = elem.ownerDocument.defaultView;
				return {
					top: rect.top + win.pageYOffset,
					left: rect.left + win.pageXOffset
				};
			},
	
			// position() relates an element's margin box to its offset parent's padding box
			// This corresponds to the behavior of CSS absolute positioning
			position: function position() {
				if (!this[0]) {
					return;
				}
	
				var offsetParent,
				    offset,
				    doc,
				    elem = this[0],
				    parentOffset = { top: 0, left: 0 };
	
				// position:fixed elements are offset from the viewport, which itself always has zero offset
				if (jQuery.css(elem, "position") === "fixed") {
	
					// Assume position:fixed implies availability of getBoundingClientRect
					offset = elem.getBoundingClientRect();
				} else {
					offset = this.offset();
	
					// Account for the *real* offset parent, which can be the document or its root element
					// when a statically positioned element is identified
					doc = elem.ownerDocument;
					offsetParent = elem.offsetParent || doc.documentElement;
					while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static") {
	
						offsetParent = offsetParent.parentNode;
					}
					if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
	
						// Incorporate borders into its offset, since they are outside its content origin
						parentOffset = jQuery(offsetParent).offset();
						parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
						parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
					}
				}
	
				// Subtract parent offsets and element margins
				return {
					top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
					left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
				};
			},
	
			// This method will return documentElement in the following cases:
			// 1) For the element inside the iframe without offsetParent, this method will return
			//    documentElement of the parent window
			// 2) For the hidden or detached element
			// 3) For body or html element, i.e. in case of the html node - it will return itself
			//
			// but those exceptions were never presented as a real life use-cases
			// and might be considered as more preferable results.
			//
			// This logic, however, is not guaranteed and can change at any point in the future
			offsetParent: function offsetParent() {
				return this.map(function () {
					var offsetParent = this.offsetParent;
	
					while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
						offsetParent = offsetParent.offsetParent;
					}
	
					return offsetParent || documentElement;
				});
			}
		});
	
		// Create scrollLeft and scrollTop methods
		jQuery.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (method, prop) {
			var top = "pageYOffset" === prop;
	
			jQuery.fn[method] = function (val) {
				return access(this, function (elem, method, val) {
	
					// Coalesce documents and windows
					var win;
					if (isWindow(elem)) {
						win = elem;
					} else if (elem.nodeType === 9) {
						win = elem.defaultView;
					}
	
					if (val === undefined) {
						return win ? win[prop] : elem[method];
					}
	
					if (win) {
						win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
					} else {
						elem[method] = val;
					}
				}, method, val, arguments.length);
			};
		});
	
		// Support: Safari <=7 - 9.1, Chrome <=37 - 49
		// Add the top/left cssHooks using jQuery.fn.position
		// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
		// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
		// getComputedStyle returns percent when specified for top/left/bottom/right;
		// rather than make the css module depend on the offset module, just check for it here
		jQuery.each(["top", "left"], function (_i, prop) {
			jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function (elem, computed) {
				if (computed) {
					computed = curCSS(elem, prop);
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
				}
			});
		});
	
		// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
		jQuery.each({ Height: "height", Width: "width" }, function (name, type) {
			jQuery.each({
				padding: "inner" + name,
				content: type,
				"": "outer" + name
			}, function (defaultExtra, funcName) {
	
				// Margin is only for outerHeight, outerWidth
				jQuery.fn[funcName] = function (margin, value) {
					var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
					    extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
	
					return access(this, function (elem, type, value) {
						var doc;
	
						if (isWindow(elem)) {
	
							// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
							return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
						}
	
						// Get document width or height
						if (elem.nodeType === 9) {
							doc = elem.documentElement;
	
							// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
							// whichever is greatest
							return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
						}
	
						return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css(elem, type, extra) :
	
						// Set width or height on the element
						jQuery.style(elem, type, value, extra);
					}, type, chainable ? margin : undefined, chainable);
				};
			});
		});
	
		jQuery.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (_i, type) {
			jQuery.fn[type] = function (fn) {
				return this.on(type, fn);
			};
		});
	
		jQuery.fn.extend({
	
			bind: function bind(types, data, fn) {
				return this.on(types, null, data, fn);
			},
			unbind: function unbind(types, fn) {
				return this.off(types, null, fn);
			},
	
			delegate: function delegate(selector, types, data, fn) {
				return this.on(types, selector, data, fn);
			},
			undelegate: function undelegate(selector, types, fn) {
	
				// ( namespace ) or ( selector, types [, fn] )
				return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
			},
	
			hover: function hover(fnOver, fnOut) {
				return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
			}
		});
	
		jQuery.each(("blur focus focusin focusout resize scroll click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select submit keydown keypress keyup contextmenu").split(" "), function (_i, name) {
	
			// Handle event binding
			jQuery.fn[name] = function (data, fn) {
				return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
			};
		});
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
		// However, it is not slated for removal any time soon
		jQuery.proxy = function (fn, context) {
			var tmp, args, proxy;
	
			if (typeof context === "string") {
				tmp = fn[context];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if (!isFunction(fn)) {
				return undefined;
			}
	
			// Simulated bind
			args = _slice.call(arguments, 2);
			proxy = function proxy() {
				return fn.apply(context || this, args.concat(_slice.call(arguments)));
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		};
	
		jQuery.holdReady = function (hold) {
			if (hold) {
				jQuery.readyWait++;
			} else {
				jQuery.ready(true);
			}
		};
		jQuery.isArray = Array.isArray;
		jQuery.parseJSON = JSON.parse;
		jQuery.nodeName = nodeName;
		jQuery.isFunction = isFunction;
		jQuery.isWindow = isWindow;
		jQuery.camelCase = camelCase;
		jQuery.type = toType;
	
		jQuery.now = Date.now;
	
		jQuery.isNumeric = function (obj) {
	
			// As of jQuery 3.0, isNumeric is limited to
			// strings and numbers (primitives or objects)
			// that can be coerced to finite numbers (gh-2662)
			var type = jQuery.type(obj);
			return (type === "number" || type === "string") &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN(obj - parseFloat(obj));
		};
	
		jQuery.trim = function (text) {
			return text == null ? "" : (text + "").replace(rtrim, "");
		};
	
		// Register as a named AMD module, since jQuery can be concatenated with other
		// files that may use define, but not via a proper concatenation script that
		// understands anonymous AMD modules. A named AMD is safest and most robust
		// way to register. Lowercase jquery is used because AMD module names are
		// derived from file names, and jQuery is normally delivered in a lowercase
		// file name. Do this after creating the global so that if an AMD module wants
		// to call noConflict to hide this version of jQuery, it will work.
	
		// Note that for maximum portability, libraries that are not jQuery should
		// declare themselves as anonymous modules, and avoid setting a global if an
		// AMD loader is present. jQuery is a special case. For more information, see
		// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return jQuery;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	
		var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
		jQuery.noConflict = function (deep) {
			if (window.$ === jQuery) {
				window.$ = _$;
			}
	
			if (deep && window.jQuery === jQuery) {
				window.jQuery = _jQuery;
			}
	
			return jQuery;
		};
	
		// Expose jQuery and $ identifiers, even in AMD
		// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
		// and CommonJS for browser emulators (#13566)
		if (typeof noGlobal === "undefined") {
			window.jQuery = window.$ = jQuery;
		}
	
		return jQuery;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(99)(module)))

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var dP = __webpack_require__(9);
	var createDesc = __webpack_require__(40);
	module.exports = __webpack_require__(8) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(3);
	var hide = __webpack_require__(13);
	var has = __webpack_require__(16);
	var SRC = __webpack_require__(44)('src');
	var $toString = __webpack_require__(146);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(21).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var fails = __webpack_require__(4);
	var defined = __webpack_require__(26);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function createHTML(string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	"use strict";
	
	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var pIE = __webpack_require__(53);
	var createDesc = __webpack_require__(40);
	var toIObject = __webpack_require__(19);
	var toPrimitive = __webpack_require__(28);
	var has = __webpack_require__(16);
	var IE8_DOM_DEFINE = __webpack_require__(109);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(8) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) {/* empty */}
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(16);
	var toObject = __webpack_require__(10);
	var IE_PROTO = __webpack_require__(89)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  }return O instanceof Object ? ObjectProto : null;
	};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(52);
	var defined = __webpack_require__(26);
	module.exports = function (it) {
	  return IObject(defined(it));
	};

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	"use strict";
	
	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';
	
	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// optional / simple context binding
	var aFunction = __webpack_require__(12);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1:
	      return function (a) {
	        return fn.call(that, a);
	      };
	    case 2:
	      return function (a, b) {
	        return fn.call(that, a, b);
	      };
	    case 3:
	      return function (a, b, c) {
	        return fn.call(that, a, b, c);
	      };
	  }
	  return function () /* ...args */{
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var fails = __webpack_require__(4);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () {/* empty */}, 1) : method.call(null);
	  });
	};

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	"use strict";
	
	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(22);
	var IObject = __webpack_require__(52);
	var toObject = __webpack_require__(10);
	var toLength = __webpack_require__(7);
	var asc = __webpack_require__(73);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (; length > index; index++) {
	      if (NO_HOLES || index in self) {
	        val = self[index];
	        res = f(val, index, O);
	        if (TYPE) {
	          if (IS_MAP) result[index] = res; // map
	          else if (res) switch (TYPE) {
	              case 3:
	                return true; // some
	              case 5:
	                return val; // find
	              case 6:
	                return index; // findIndex
	              case 2:
	                result.push(val); // filter
	            } else if (IS_EVERY) return false; // every
	        }
	      }
	    }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	"use strict";
	
	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(1);
	var core = __webpack_require__(21);
	var fails = __webpack_require__(4);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () {
	    fn(1);
	  }), 'Object', exp);
	};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(5);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var Map = __webpack_require__(131);
	var $export = __webpack_require__(1);
	var shared = __webpack_require__(54)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(135))());
	
	var getOrCreateMetadataMap = function getOrCreateMetadataMap(target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  }return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function ordinaryHasOwnMetadata(MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function ordinaryGetOwnMetadata(MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function ordinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function ordinaryOwnMetadataKeys(target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) {
	    keys.push(key);
	  });
	  return keys;
	};
	var toMetaKey = function toMetaKey(it) {
	  return it === undefined || (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : String(it);
	};
	var exp = function exp(O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	if (__webpack_require__(8)) {
	  var LIBRARY = __webpack_require__(32);
	  var global = __webpack_require__(3);
	  var fails = __webpack_require__(4);
	  var $export = __webpack_require__(1);
	  var $typed = __webpack_require__(68);
	  var $buffer = __webpack_require__(94);
	  var ctx = __webpack_require__(22);
	  var anInstance = __webpack_require__(35);
	  var propertyDesc = __webpack_require__(40);
	  var hide = __webpack_require__(13);
	  var redefineAll = __webpack_require__(41);
	  var toInteger = __webpack_require__(24);
	  var toLength = __webpack_require__(7);
	  var toIndex = __webpack_require__(129);
	  var toAbsoluteIndex = __webpack_require__(43);
	  var toPrimitive = __webpack_require__(28);
	  var has = __webpack_require__(16);
	  var classof = __webpack_require__(47);
	  var isObject = __webpack_require__(5);
	  var toObject = __webpack_require__(10);
	  var isArrayIter = __webpack_require__(80);
	  var create = __webpack_require__(37);
	  var getPrototypeOf = __webpack_require__(18);
	  var gOPN = __webpack_require__(38).f;
	  var getIterFn = __webpack_require__(96);
	  var uid = __webpack_require__(44);
	  var wks = __webpack_require__(6);
	  var createArrayMethod = __webpack_require__(25);
	  var createArrayIncludes = __webpack_require__(56);
	  var speciesConstructor = __webpack_require__(55);
	  var ArrayIterators = __webpack_require__(97);
	  var Iterators = __webpack_require__(48);
	  var $iterDetect = __webpack_require__(61);
	  var setSpecies = __webpack_require__(42);
	  var arrayFill = __webpack_require__(72);
	  var arrayCopyWithin = __webpack_require__(101);
	  var $DP = __webpack_require__(9);
	  var $GOPD = __webpack_require__(17);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function toOffset(it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function validate(it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function allocate(C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    }return new C(length);
	  };
	
	  var speciesFromList = function speciesFromList(O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function fromList(C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) {
	      result[index] = list[index++];
	    }return result;
	  };
	
	  var addGetter = function addGetter(it, key, internal) {
	    dP(it, key, { get: function get() {
	        return this._d[internal];
	      } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      }O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of() /* ...items */{
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) {
	      result[index] = arguments[index++];
	    }return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () {
	    arrayToLocaleString.call(new Uint8Array(1));
	  });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) {
	      // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) {
	      // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) {
	      // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) {
	      // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	      // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      }return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin));
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) {
	      this[offset + index] = src[index++];
	    }
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function isTAIndex(target, key) {
	    return isObject(target) && target[TYPED_ARRAY] && (typeof key === 'undefined' ? 'undefined' : _typeof(key)) != 'symbol' && key in target && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true)) ? propertyDesc(2, target[key]) : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true)) && isObject(desc) && has(desc, 'value') && !has(desc, 'get') && !has(desc, 'set')
	    // TODO: add validation descriptor w/o calling accessors
	    && !desc.configurable && (!has(desc, 'writable') || desc.writable) && (!has(desc, 'enumerable') || desc.enumerable)) {
	      target[key] = desc.value;
	      return target;
	    }return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () {
	    arrayToString.call({});
	  })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function constructor() {/* noop */},
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function get() {
	      return this[TYPED_ARRAY];
	    }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function getter(that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function setter(that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function addElement(that, index) {
	      dP(that, index, {
	        get: function get() {
	          return getter(this, index);
	        },
	        set: function set(value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) {
	          addElement(that, index++);
	        }
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined ? new Base(data, toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, toOffset($offset, BYTES)) : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function get() {
	          return NAME;
	        }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () {
	      Base.of.call(TypedArray, 1);
	    }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () {/* empty */};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(6)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(13)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = false;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var META = __webpack_require__(44)('meta');
	var isObject = __webpack_require__(5);
	var has = __webpack_require__(16);
	var setDesc = __webpack_require__(9).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(4)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function setMeta(it) {
	  setDesc(it, META, { value: {
	      i: 'O' + ++id, // object ID
	      w: {} // weak collections IDs
	    } });
	};
	var fastKey = function fastKey(it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	    // return object ID
	  }return it[META].i;
	};
	var getWeak = function getWeak(it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	    // return hash weak collections IDs
	  }return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function onFreeze(it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Fizzy UI utils v2.0.7
	 * MIT license
	 */
	
	/*jshint browser: true, undef: true, unused: true, strict: true */
	
	(function (window, factory) {
	  // universal module definition
	  /*jshint strict: false */ /*globals define, module, require */
	
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(341)], __WEBPACK_AMD_DEFINE_RESULT__ = function (matchesSelector) {
	      return factory(window, matchesSelector);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory(window, require('desandro-matches-selector'));
	  } else {
	    // browser global
	    window.fizzyUIUtils = factory(window, window.matchesSelector);
	  }
	})(window, function factory(window, matchesSelector) {
	
	  'use strict';
	
	  var utils = {};
	
	  // ----- extend ----- //
	
	  // extends objects
	  utils.extend = function (a, b) {
	    for (var prop in b) {
	      a[prop] = b[prop];
	    }
	    return a;
	  };
	
	  // ----- modulo ----- //
	
	  utils.modulo = function (num, div) {
	    return (num % div + div) % div;
	  };
	
	  // ----- makeArray ----- //
	
	  var arraySlice = Array.prototype.slice;
	
	  // turn element or nodeList into an array
	  utils.makeArray = function (obj) {
	    if (Array.isArray(obj)) {
	      // use object if already an array
	      return obj;
	    }
	    // return empty array if undefined or null. #6
	    if (obj === null || obj === undefined) {
	      return [];
	    }
	
	    var isArrayLike = (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) == 'object' && typeof obj.length == 'number';
	    if (isArrayLike) {
	      // convert nodeList to array
	      return arraySlice.call(obj);
	    }
	
	    // array of single index
	    return [obj];
	  };
	
	  // ----- removeFrom ----- //
	
	  utils.removeFrom = function (ary, obj) {
	    var index = ary.indexOf(obj);
	    if (index != -1) {
	      ary.splice(index, 1);
	    }
	  };
	
	  // ----- getParent ----- //
	
	  utils.getParent = function (elem, selector) {
	    while (elem.parentNode && elem != document.body) {
	      elem = elem.parentNode;
	      if (matchesSelector(elem, selector)) {
	        return elem;
	      }
	    }
	  };
	
	  // ----- getQueryElement ----- //
	
	  // use element as selector string
	  utils.getQueryElement = function (elem) {
	    if (typeof elem == 'string') {
	      return document.querySelector(elem);
	    }
	    return elem;
	  };
	
	  // ----- handleEvent ----- //
	
	  // enable .ontype to trigger from .addEventListener( elem, 'type' )
	  utils.handleEvent = function (event) {
	    var method = 'on' + event.type;
	    if (this[method]) {
	      this[method](event);
	    }
	  };
	
	  // ----- filterFindElements ----- //
	
	  utils.filterFindElements = function (elems, selector) {
	    // make array of elems
	    elems = utils.makeArray(elems);
	    var ffElems = [];
	
	    elems.forEach(function (elem) {
	      // check that elem is an actual element
	      if (!(elem instanceof HTMLElement)) {
	        return;
	      }
	      // add elem if no selector
	      if (!selector) {
	        ffElems.push(elem);
	        return;
	      }
	      // filter & find items if we have a selector
	      // filter
	      if (matchesSelector(elem, selector)) {
	        ffElems.push(elem);
	      }
	      // find children
	      var childElems = elem.querySelectorAll(selector);
	      // concat childElems to filterFound array
	      for (var i = 0; i < childElems.length; i++) {
	        ffElems.push(childElems[i]);
	      }
	    });
	
	    return ffElems;
	  };
	
	  // ----- debounceMethod ----- //
	
	  utils.debounceMethod = function (_class, methodName, threshold) {
	    threshold = threshold || 100;
	    // original method
	    var method = _class.prototype[methodName];
	    var timeoutName = methodName + 'Timeout';
	
	    _class.prototype[methodName] = function () {
	      var timeout = this[timeoutName];
	      clearTimeout(timeout);
	
	      var args = arguments;
	      var _this = this;
	      this[timeoutName] = setTimeout(function () {
	        method.apply(_this, args);
	        delete _this[timeoutName];
	      }, threshold);
	    };
	  };
	
	  // ----- docReady ----- //
	
	  utils.docReady = function (callback) {
	    var readyState = document.readyState;
	    if (readyState == 'complete' || readyState == 'interactive') {
	      // do async to allow for other scripts to run. metafizzy/flickity#441
	      setTimeout(callback);
	    } else {
	      document.addEventListener('DOMContentLoaded', callback);
	    }
	  };
	
	  // ----- htmlInit ----- //
	
	  // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
	  utils.toDashed = function (str) {
	    return str.replace(/(.)([A-Z])/g, function (match, $1, $2) {
	      return $1 + '-' + $2;
	    }).toLowerCase();
	  };
	
	  var console = window.console;
	  /**
	   * allow user to initialize classes via [data-namespace] or .js-namespace class
	   * htmlInit( Widget, 'widgetName' )
	   * options are parsed from data-namespace-options
	   */
	  utils.htmlInit = function (WidgetClass, namespace) {
	    utils.docReady(function () {
	      var dashedNamespace = utils.toDashed(namespace);
	      var dataAttr = 'data-' + dashedNamespace;
	      var dataAttrElems = document.querySelectorAll('[' + dataAttr + ']');
	      var jsDashElems = document.querySelectorAll('.js-' + dashedNamespace);
	      var elems = utils.makeArray(dataAttrElems).concat(utils.makeArray(jsDashElems));
	      var dataOptionsAttr = dataAttr + '-options';
	      var jQuery = window.jQuery;
	
	      elems.forEach(function (elem) {
	        var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
	        var options;
	        try {
	          options = attr && JSON.parse(attr);
	        } catch (error) {
	          // log error, do not initialize
	          if (console) {
	            console.error('Error parsing ' + dataAttr + ' on ' + elem.className + ': ' + error);
	          }
	          return;
	        }
	        // initialize
	        var instance = new WidgetClass(elem, options);
	        // make available via $().data('namespace')
	        if (jQuery) {
	          jQuery.data(elem, namespace, instance);
	        }
	      });
	    });
	  };
	
	  // -----  ----- //
	
	  return utils;
	});

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
	    throw TypeError(name + ': incorrect invocation!');
	  }return it;
	};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ctx = __webpack_require__(22);
	var call = __webpack_require__(112);
	var isArrayIter = __webpack_require__(80);
	var anObject = __webpack_require__(2);
	var toLength = __webpack_require__(7);
	var getIterFn = __webpack_require__(96);
	var BREAK = {};
	var RETURN = {};
	var _exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () {
	    return iterable;
	  } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	_exports.BREAK = BREAK;
	_exports.RETURN = RETURN;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(2);
	var dPs = __webpack_require__(118);
	var enumBugKeys = __webpack_require__(76);
	var IE_PROTO = __webpack_require__(89)('IE_PROTO');
	var Empty = function Empty() {/* empty */};
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var _createDict = function createDict() {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(75)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(78).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  _createDict = iframeDocument.F;
	  while (i--) {
	    delete _createDict[PROTOTYPE][enumBugKeys[i]];
	  }return _createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = _createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(120);
	var hiddenKeys = __webpack_require__(76).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(120);
	var enumBugKeys = __webpack_require__(76);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var redefine = __webpack_require__(14);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    redefine(target, key, src[key], safe);
	  }return target;
	};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(3);
	var dP = __webpack_require__(9);
	var DESCRIPTORS = __webpack_require__(8);
	var SPECIES = __webpack_require__(6)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function get() {
	      return this;
	    }
	  });
	};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var toInteger = __webpack_require__(24);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isObject = __webpack_require__(5);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// Flickity main
	/* eslint-disable max-params */
	(function (window, factory) {
	  // universal module definition
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(70), __webpack_require__(136), __webpack_require__(34), __webpack_require__(345), __webpack_require__(352), __webpack_require__(344)], __WEBPACK_AMD_DEFINE_RESULT__ = function (EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
	      return factory(window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory(window, require('ev-emitter'), require('get-size'), require('fizzy-ui-utils'), require('./cell'), require('./slide'), require('./animate'));
	  } else {
	    // browser global
	    var _Flickity = window.Flickity;
	
	    window.Flickity = factory(window, window.EvEmitter, window.getSize, window.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype);
	  }
	})(window, function factory(window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
	
	  /* eslint-enable max-params */
	  'use strict';
	
	  // vars
	
	  var jQuery = window.jQuery;
	  var getComputedStyle = window.getComputedStyle;
	  var console = window.console;
	
	  function moveElements(elems, toElem) {
	    elems = utils.makeArray(elems);
	    while (elems.length) {
	      toElem.appendChild(elems.shift());
	    }
	  }
	
	  // -------------------------- Flickity -------------------------- //
	
	  // globally unique identifiers
	  var GUID = 0;
	  // internal store of all Flickity intances
	  var instances = {};
	
	  function Flickity(element, options) {
	    var queryElement = utils.getQueryElement(element);
	    if (!queryElement) {
	      if (console) {
	        console.error('Bad element for Flickity: ' + (queryElement || element));
	      }
	      return;
	    }
	    this.element = queryElement;
	    // do not initialize twice on same element
	    if (this.element.flickityGUID) {
	      var instance = instances[this.element.flickityGUID];
	      if (instance) instance.option(options);
	      return instance;
	    }
	
	    // add jQuery
	    if (jQuery) {
	      this.$element = jQuery(this.element);
	    }
	    // options
	    this.options = utils.extend({}, this.constructor.defaults);
	    this.option(options);
	
	    // kick things off
	    this._create();
	  }
	
	  Flickity.defaults = {
	    accessibility: true,
	    // adaptiveHeight: false,
	    cellAlign: 'center',
	    // cellSelector: undefined,
	    // contain: false,
	    freeScrollFriction: 0.075, // friction when free-scrolling
	    friction: 0.28, // friction when selecting
	    namespaceJQueryEvents: true,
	    // initialIndex: 0,
	    percentPosition: true,
	    resize: true,
	    selectedAttraction: 0.025,
	    setGallerySize: true
	    // watchCSS: false,
	    // wrapAround: false
	  };
	
	  // hash of methods triggered on _create()
	  Flickity.createMethods = [];
	
	  var proto = Flickity.prototype;
	  // inherit EventEmitter
	  utils.extend(proto, EvEmitter.prototype);
	
	  proto._create = function () {
	    // add id for Flickity.data
	    var id = this.guid = ++GUID;
	    this.element.flickityGUID = id; // expando
	    instances[id] = this; // associate via id
	    // initial properties
	    this.selectedIndex = 0;
	    // how many frames slider has been in same position
	    this.restingFrames = 0;
	    // initial physics properties
	    this.x = 0;
	    this.velocity = 0;
	    this.originSide = this.options.rightToLeft ? 'right' : 'left';
	    // create viewport & slider
	    this.viewport = document.createElement('div');
	    this.viewport.className = 'flickity-viewport';
	    this._createSlider();
	
	    if (this.options.resize || this.options.watchCSS) {
	      window.addEventListener('resize', this);
	    }
	
	    // add listeners from on option
	    for (var eventName in this.options.on) {
	      var listener = this.options.on[eventName];
	      this.on(eventName, listener);
	    }
	
	    Flickity.createMethods.forEach(function (method) {
	      this[method]();
	    }, this);
	
	    if (this.options.watchCSS) {
	      this.watchCSS();
	    } else {
	      this.activate();
	    }
	  };
	
	  /**
	   * set options
	   * @param {Object} opts - options to extend
	   */
	  proto.option = function (opts) {
	    utils.extend(this.options, opts);
	  };
	
	  proto.activate = function () {
	    if (this.isActive) {
	      return;
	    }
	    this.isActive = true;
	    this.element.classList.add('flickity-enabled');
	    if (this.options.rightToLeft) {
	      this.element.classList.add('flickity-rtl');
	    }
	
	    this.getSize();
	    // move initial cell elements so they can be loaded as cells
	    var cellElems = this._filterFindCellElements(this.element.children);
	    moveElements(cellElems, this.slider);
	    this.viewport.appendChild(this.slider);
	    this.element.appendChild(this.viewport);
	    // get cells from children
	    this.reloadCells();
	
	    if (this.options.accessibility) {
	      // allow element to focusable
	      this.element.tabIndex = 0;
	      // listen for key presses
	      this.element.addEventListener('keydown', this);
	    }
	
	    this.emitEvent('activate');
	    this.selectInitialIndex();
	    // flag for initial activation, for using initialIndex
	    this.isInitActivated = true;
	    // ready event. #493
	    this.dispatchEvent('ready');
	  };
	
	  // slider positions the cells
	  proto._createSlider = function () {
	    // slider element does all the positioning
	    var slider = document.createElement('div');
	    slider.className = 'flickity-slider';
	    slider.style[this.originSide] = 0;
	    this.slider = slider;
	  };
	
	  proto._filterFindCellElements = function (elems) {
	    return utils.filterFindElements(elems, this.options.cellSelector);
	  };
	
	  // goes through all children
	  proto.reloadCells = function () {
	    // collection of item elements
	    this.cells = this._makeCells(this.slider.children);
	    this.positionCells();
	    this._getWrapShiftCells();
	    this.setGallerySize();
	  };
	
	  /**
	   * turn elements into Flickity.Cells
	   * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
	   * @returns {Array} items - collection of new Flickity Cells
	   */
	  proto._makeCells = function (elems) {
	    var cellElems = this._filterFindCellElements(elems);
	
	    // create new Flickity for collection
	    var cells = cellElems.map(function (cellElem) {
	      return new Cell(cellElem, this);
	    }, this);
	
	    return cells;
	  };
	
	  proto.getLastCell = function () {
	    return this.cells[this.cells.length - 1];
	  };
	
	  proto.getLastSlide = function () {
	    return this.slides[this.slides.length - 1];
	  };
	
	  // positions all cells
	  proto.positionCells = function () {
	    // size all cells
	    this._sizeCells(this.cells);
	    // position all cells
	    this._positionCells(0);
	  };
	
	  /**
	   * position certain cells
	   * @param {Integer} index - which cell to start with
	   */
	  proto._positionCells = function (index) {
	    index = index || 0;
	    // also measure maxCellHeight
	    // start 0 if positioning all cells
	    this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
	    var cellX = 0;
	    // get cellX
	    if (index > 0) {
	      var startCell = this.cells[index - 1];
	      cellX = startCell.x + startCell.size.outerWidth;
	    }
	    var len = this.cells.length;
	    for (var i = index; i < len; i++) {
	      var cell = this.cells[i];
	      cell.setPosition(cellX);
	      cellX += cell.size.outerWidth;
	      this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
	    }
	    // keep track of cellX for wrap-around
	    this.slideableWidth = cellX;
	    // slides
	    this.updateSlides();
	    // contain slides target
	    this._containSlides();
	    // update slidesWidth
	    this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
	  };
	
	  /**
	   * cell.getSize() on multiple cells
	   * @param {Array} cells - cells to size
	   */
	  proto._sizeCells = function (cells) {
	    cells.forEach(function (cell) {
	      cell.getSize();
	    });
	  };
	
	  // --------------------------  -------------------------- //
	
	  proto.updateSlides = function () {
	    this.slides = [];
	    if (!this.cells.length) {
	      return;
	    }
	
	    var slide = new Slide(this);
	    this.slides.push(slide);
	    var isOriginLeft = this.originSide == 'left';
	    var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';
	
	    var canCellFit = this._getCanCellFit();
	
	    this.cells.forEach(function (cell, i) {
	      // just add cell if first cell in slide
	      if (!slide.cells.length) {
	        slide.addCell(cell);
	        return;
	      }
	
	      var slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[nextMargin]);
	
	      if (canCellFit.call(this, i, slideWidth)) {
	        slide.addCell(cell);
	      } else {
	        // doesn't fit, new slide
	        slide.updateTarget();
	
	        slide = new Slide(this);
	        this.slides.push(slide);
	        slide.addCell(cell);
	      }
	    }, this);
	    // last slide
	    slide.updateTarget();
	    // update .selectedSlide
	    this.updateSelectedSlide();
	  };
	
	  proto._getCanCellFit = function () {
	    var groupCells = this.options.groupCells;
	    if (!groupCells) {
	      return function () {
	        return false;
	      };
	    } else if (typeof groupCells == 'number') {
	      // group by number. 3 -> [0,1,2], [3,4,5], ...
	      var number = parseInt(groupCells, 10);
	      return function (i) {
	        return i % number !== 0;
	      };
	    }
	    // default, group by width of slide
	    // parse '75%
	    var percentMatch = typeof groupCells == 'string' && groupCells.match(/^(\d+)%$/);
	    var percent = percentMatch ? parseInt(percentMatch[1], 10) / 100 : 1;
	    return function (i, slideWidth) {
	      /* eslint-disable-next-line no-invalid-this */
	      return slideWidth <= (this.size.innerWidth + 1) * percent;
	    };
	  };
	
	  // alias _init for jQuery plugin .flickity()
	  proto._init = proto.reposition = function () {
	    this.positionCells();
	    this.positionSliderAtSelected();
	  };
	
	  proto.getSize = function () {
	    this.size = getSize(this.element);
	    this.setCellAlign();
	    this.cursorPosition = this.size.innerWidth * this.cellAlign;
	  };
	
	  var cellAlignShorthands = {
	    // cell align, then based on origin side
	    center: {
	      left: 0.5,
	      right: 0.5
	    },
	    left: {
	      left: 0,
	      right: 1
	    },
	    right: {
	      right: 0,
	      left: 1
	    }
	  };
	
	  proto.setCellAlign = function () {
	    var shorthand = cellAlignShorthands[this.options.cellAlign];
	    this.cellAlign = shorthand ? shorthand[this.originSide] : this.options.cellAlign;
	  };
	
	  proto.setGallerySize = function () {
	    if (this.options.setGallerySize) {
	      var height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
	      this.viewport.style.height = height + 'px';
	    }
	  };
	
	  proto._getWrapShiftCells = function () {
	    // only for wrap-around
	    if (!this.options.wrapAround) {
	      return;
	    }
	    // unshift previous cells
	    this._unshiftCells(this.beforeShiftCells);
	    this._unshiftCells(this.afterShiftCells);
	    // get before cells
	    // initial gap
	    var gapX = this.cursorPosition;
	    var cellIndex = this.cells.length - 1;
	    this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
	    // get after cells
	    // ending gap between last cell and end of gallery viewport
	    gapX = this.size.innerWidth - this.cursorPosition;
	    // start cloning at first cell, working forwards
	    this.afterShiftCells = this._getGapCells(gapX, 0, 1);
	  };
	
	  proto._getGapCells = function (gapX, cellIndex, increment) {
	    // keep adding cells until the cover the initial gap
	    var cells = [];
	    while (gapX > 0) {
	      var cell = this.cells[cellIndex];
	      if (!cell) {
	        break;
	      }
	      cells.push(cell);
	      cellIndex += increment;
	      gapX -= cell.size.outerWidth;
	    }
	    return cells;
	  };
	
	  // ----- contain ----- //
	
	  // contain cell targets so no excess sliding
	  proto._containSlides = function () {
	    if (!this.options.contain || this.options.wrapAround || !this.cells.length) {
	      return;
	    }
	    var isRightToLeft = this.options.rightToLeft;
	    var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
	    var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
	    var contentWidth = this.slideableWidth - this.getLastCell().size[endMargin];
	    // content is less than gallery size
	    var isContentSmaller = contentWidth < this.size.innerWidth;
	    // bounds
	    var beginBound = this.cursorPosition + this.cells[0].size[beginMargin];
	    var endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
	    // contain each cell target
	    this.slides.forEach(function (slide) {
	      if (isContentSmaller) {
	        // all cells fit inside gallery
	        slide.target = contentWidth * this.cellAlign;
	      } else {
	        // contain to bounds
	        slide.target = Math.max(slide.target, beginBound);
	        slide.target = Math.min(slide.target, endBound);
	      }
	    }, this);
	  };
	
	  // -----  ----- //
	
	  /**
	   * emits events via eventEmitter and jQuery events
	   * @param {String} type - name of event
	   * @param {Event} event - original event
	   * @param {Array} args - extra arguments
	   */
	  proto.dispatchEvent = function (type, event, args) {
	    var emitArgs = event ? [event].concat(args) : args;
	    this.emitEvent(type, emitArgs);
	
	    if (jQuery && this.$element) {
	      // default trigger with type if no event
	      type += this.options.namespaceJQueryEvents ? '.flickity' : '';
	      var $event = type;
	      if (event) {
	        // create jQuery event
	        var jQEvent = new jQuery.Event(event);
	        jQEvent.type = type;
	        $event = jQEvent;
	      }
	      this.$element.trigger($event, args);
	    }
	  };
	
	  // -------------------------- select -------------------------- //
	
	  /**
	   * @param {Integer} index - index of the slide
	   * @param {Boolean} isWrap - will wrap-around to last/first if at the end
	   * @param {Boolean} isInstant - will immediately set position at selected cell
	   */
	  proto.select = function (index, isWrap, isInstant) {
	    if (!this.isActive) {
	      return;
	    }
	    index = parseInt(index, 10);
	    this._wrapSelect(index);
	
	    if (this.options.wrapAround || isWrap) {
	      index = utils.modulo(index, this.slides.length);
	    }
	    // bail if invalid index
	    if (!this.slides[index]) {
	      return;
	    }
	    var prevIndex = this.selectedIndex;
	    this.selectedIndex = index;
	    this.updateSelectedSlide();
	    if (isInstant) {
	      this.positionSliderAtSelected();
	    } else {
	      this.startAnimation();
	    }
	    if (this.options.adaptiveHeight) {
	      this.setGallerySize();
	    }
	    // events
	    this.dispatchEvent('select', null, [index]);
	    // change event if new index
	    if (index != prevIndex) {
	      this.dispatchEvent('change', null, [index]);
	    }
	    // old v1 event name, remove in v3
	    this.dispatchEvent('cellSelect');
	  };
	
	  // wraps position for wrapAround, to move to closest slide. #113
	  proto._wrapSelect = function (index) {
	    var len = this.slides.length;
	    var isWrapping = this.options.wrapAround && len > 1;
	    if (!isWrapping) {
	      return index;
	    }
	    var wrapIndex = utils.modulo(index, len);
	    // go to shortest
	    var delta = Math.abs(wrapIndex - this.selectedIndex);
	    var backWrapDelta = Math.abs(wrapIndex + len - this.selectedIndex);
	    var forewardWrapDelta = Math.abs(wrapIndex - len - this.selectedIndex);
	    if (!this.isDragSelect && backWrapDelta < delta) {
	      index += len;
	    } else if (!this.isDragSelect && forewardWrapDelta < delta) {
	      index -= len;
	    }
	    // wrap position so slider is within normal area
	    if (index < 0) {
	      this.x -= this.slideableWidth;
	    } else if (index >= len) {
	      this.x += this.slideableWidth;
	    }
	  };
	
	  proto.previous = function (isWrap, isInstant) {
	    this.select(this.selectedIndex - 1, isWrap, isInstant);
	  };
	
	  proto.next = function (isWrap, isInstant) {
	    this.select(this.selectedIndex + 1, isWrap, isInstant);
	  };
	
	  proto.updateSelectedSlide = function () {
	    var slide = this.slides[this.selectedIndex];
	    // selectedIndex could be outside of slides, if triggered before resize()
	    if (!slide) {
	      return;
	    }
	    // unselect previous selected slide
	    this.unselectSelectedSlide();
	    // update new selected slide
	    this.selectedSlide = slide;
	    slide.select();
	    this.selectedCells = slide.cells;
	    this.selectedElements = slide.getCellElements();
	    // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
	    // Remove in v3?
	    this.selectedCell = slide.cells[0];
	    this.selectedElement = this.selectedElements[0];
	  };
	
	  proto.unselectSelectedSlide = function () {
	    if (this.selectedSlide) {
	      this.selectedSlide.unselect();
	    }
	  };
	
	  proto.selectInitialIndex = function () {
	    var initialIndex = this.options.initialIndex;
	    // already activated, select previous selectedIndex
	    if (this.isInitActivated) {
	      this.select(this.selectedIndex, false, true);
	      return;
	    }
	    // select with selector string
	    if (initialIndex && typeof initialIndex == 'string') {
	      var cell = this.queryCell(initialIndex);
	      if (cell) {
	        this.selectCell(initialIndex, false, true);
	        return;
	      }
	    }
	
	    var index = 0;
	    // select with number
	    if (initialIndex && this.slides[initialIndex]) {
	      index = initialIndex;
	    }
	    // select instantly
	    this.select(index, false, true);
	  };
	
	  /**
	   * select slide from number or cell element
	   * @param {[Element, Number]} value - zero-based index or element to select
	   * @param {Boolean} isWrap - enables wrapping around for extra index
	   * @param {Boolean} isInstant - disables slide animation
	   */
	  proto.selectCell = function (value, isWrap, isInstant) {
	    // get cell
	    var cell = this.queryCell(value);
	    if (!cell) {
	      return;
	    }
	
	    var index = this.getCellSlideIndex(cell);
	    this.select(index, isWrap, isInstant);
	  };
	
	  proto.getCellSlideIndex = function (cell) {
	    // get index of slides that has cell
	    for (var i = 0; i < this.slides.length; i++) {
	      var slide = this.slides[i];
	      var index = slide.cells.indexOf(cell);
	      if (index != -1) {
	        return i;
	      }
	    }
	  };
	
	  // -------------------------- get cells -------------------------- //
	
	  /**
	   * get Flickity.Cell, given an Element
	   * @param {Element} elem - matching cell element
	   * @returns {Flickity.Cell} cell - matching cell
	   */
	  proto.getCell = function (elem) {
	    // loop through cells to get the one that matches
	    for (var i = 0; i < this.cells.length; i++) {
	      var cell = this.cells[i];
	      if (cell.element == elem) {
	        return cell;
	      }
	    }
	  };
	
	  /**
	   * get collection of Flickity.Cells, given Elements
	   * @param {[Element, Array, NodeList]} elems - multiple elements
	   * @returns {Array} cells - Flickity.Cells
	   */
	  proto.getCells = function (elems) {
	    elems = utils.makeArray(elems);
	    var cells = [];
	    elems.forEach(function (elem) {
	      var cell = this.getCell(elem);
	      if (cell) {
	        cells.push(cell);
	      }
	    }, this);
	    return cells;
	  };
	
	  /**
	   * get cell elements
	   * @returns {Array} cellElems
	   */
	  proto.getCellElements = function () {
	    return this.cells.map(function (cell) {
	      return cell.element;
	    });
	  };
	
	  /**
	   * get parent cell from an element
	   * @param {Element} elem - child element
	   * @returns {Flickit.Cell} cell - parent cell
	   */
	  proto.getParentCell = function (elem) {
	    // first check if elem is cell
	    var cell = this.getCell(elem);
	    if (cell) {
	      return cell;
	    }
	    // try to get parent cell elem
	    elem = utils.getParent(elem, '.flickity-slider > *');
	    return this.getCell(elem);
	  };
	
	  /**
	   * get cells adjacent to a slide
	   * @param {Integer} adjCount - number of adjacent slides
	   * @param {Integer} index - index of slide to start
	   * @returns {Array} cells - array of Flickity.Cells
	   */
	  proto.getAdjacentCellElements = function (adjCount, index) {
	    if (!adjCount) {
	      return this.selectedSlide.getCellElements();
	    }
	    index = index === undefined ? this.selectedIndex : index;
	
	    var len = this.slides.length;
	    if (1 + adjCount * 2 >= len) {
	      return this.getCellElements();
	    }
	
	    var cellElems = [];
	    for (var i = index - adjCount; i <= index + adjCount; i++) {
	      var slideIndex = this.options.wrapAround ? utils.modulo(i, len) : i;
	      var slide = this.slides[slideIndex];
	      if (slide) {
	        cellElems = cellElems.concat(slide.getCellElements());
	      }
	    }
	    return cellElems;
	  };
	
	  /**
	   * select slide from number or cell element
	   * @param {[Element, String, Number]} selector - element, selector string, or index
	   * @returns {Flickity.Cell} - matching cell
	   */
	  proto.queryCell = function (selector) {
	    if (typeof selector == 'number') {
	      // use number as index
	      return this.cells[selector];
	    }
	    if (typeof selector == 'string') {
	      // do not select invalid selectors from hash: #123, #/. #791
	      if (selector.match(/^[#.]?[\d/]/)) {
	        return;
	      }
	      // use string as selector, get element
	      selector = this.element.querySelector(selector);
	    }
	    // get cell from element
	    return this.getCell(selector);
	  };
	
	  // -------------------------- events -------------------------- //
	
	  proto.uiChange = function () {
	    this.emitEvent('uiChange');
	  };
	
	  // keep focus on element when child UI elements are clicked
	  proto.childUIPointerDown = function (event) {
	    // HACK iOS does not allow touch events to bubble up?!
	    if (event.type != 'touchstart') {
	      event.preventDefault();
	    }
	    this.focus();
	  };
	
	  // ----- resize ----- //
	
	  proto.onresize = function () {
	    this.watchCSS();
	    this.resize();
	  };
	
	  utils.debounceMethod(Flickity, 'onresize', 150);
	
	  proto.resize = function () {
	    // #1177 disable resize behavior when animating or dragging for iOS 15
	    if (!this.isActive || this.isAnimating || this.isDragging) {
	      return;
	    }
	    this.getSize();
	    // wrap values
	    if (this.options.wrapAround) {
	      this.x = utils.modulo(this.x, this.slideableWidth);
	    }
	    this.positionCells();
	    this._getWrapShiftCells();
	    this.setGallerySize();
	    this.emitEvent('resize');
	    // update selected index for group slides, instant
	    // TODO: position can be lost between groups of various numbers
	    var selectedElement = this.selectedElements && this.selectedElements[0];
	    this.selectCell(selectedElement, false, true);
	  };
	
	  // watches the :after property, activates/deactivates
	  proto.watchCSS = function () {
	    var watchOption = this.options.watchCSS;
	    if (!watchOption) {
	      return;
	    }
	
	    var afterContent = getComputedStyle(this.element, ':after').content;
	    // activate if :after { content: 'flickity' }
	    if (afterContent.indexOf('flickity') != -1) {
	      this.activate();
	    } else {
	      this.deactivate();
	    }
	  };
	
	  // ----- keydown ----- //
	
	  // go previous/next if left/right keys pressed
	  proto.onkeydown = function (event) {
	    // only work if element is in focus
	    var isNotFocused = document.activeElement && document.activeElement != this.element;
	    if (!this.options.accessibility || isNotFocused) {
	      return;
	    }
	
	    var handler = Flickity.keyboardHandlers[event.keyCode];
	    if (handler) {
	      handler.call(this);
	    }
	  };
	
	  Flickity.keyboardHandlers = {
	    // left arrow
	    37: function _() {
	      var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
	      this.uiChange();
	      this[leftMethod]();
	    },
	    // right arrow
	    39: function _() {
	      var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
	      this.uiChange();
	      this[rightMethod]();
	    }
	  };
	
	  // ----- focus ----- //
	
	  proto.focus = function () {
	    // TODO remove scrollTo once focus options gets more support
	    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus ...
	    //    #Browser_compatibility
	    var prevScrollY = window.pageYOffset;
	    this.element.focus({ preventScroll: true });
	    // hack to fix scroll jump after focus, #76
	    if (window.pageYOffset != prevScrollY) {
	      window.scrollTo(window.pageXOffset, prevScrollY);
	    }
	  };
	
	  // -------------------------- destroy -------------------------- //
	
	  // deactivate all Flickity functionality, but keep stuff available
	  proto.deactivate = function () {
	    if (!this.isActive) {
	      return;
	    }
	    this.element.classList.remove('flickity-enabled');
	    this.element.classList.remove('flickity-rtl');
	    this.unselectSelectedSlide();
	    // destroy cells
	    this.cells.forEach(function (cell) {
	      cell.destroy();
	    });
	    this.element.removeChild(this.viewport);
	    // move child elements back into element
	    moveElements(this.slider.children, this.element);
	    if (this.options.accessibility) {
	      this.element.removeAttribute('tabIndex');
	      this.element.removeEventListener('keydown', this);
	    }
	    // set flags
	    this.isActive = false;
	    this.emitEvent('deactivate');
	  };
	
	  proto.destroy = function () {
	    this.deactivate();
	    window.removeEventListener('resize', this);
	    this.allOff();
	    this.emitEvent('destroy');
	    if (jQuery && this.$element) {
	      jQuery.removeData(this.element, 'flickity');
	    }
	    delete this.element.flickityGUID;
	    delete instances[this.guid];
	  };
	
	  // -------------------------- prototype -------------------------- //
	
	  utils.extend(proto, animatePrototype);
	
	  // -------------------------- extras -------------------------- //
	
	  /**
	   * get Flickity instance from element
	   * @param {[Element, String]} elem - element or selector string
	   * @returns {Flickity} - Flickity instance
	   */
	  Flickity.data = function (elem) {
	    elem = utils.getQueryElement(elem);
	    var id = elem && elem.flickityGUID;
	    return id && instances[id];
	  };
	
	  utils.htmlInit(Flickity, 'flickity');
	
	  if (jQuery && jQuery.bridget) {
	    jQuery.bridget('flickity', Flickity);
	  }
	
	  // set internal jQuery, for Webpack + jQuery v3, #478
	  Flickity.setJQuery = function (jq) {
	    jQuery = jq;
	  };
	
	  Flickity.Cell = Cell;
	  Flickity.Slide = Slide;
	
	  return Flickity;
	});

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(20);
	var TAG = __webpack_require__(6)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () {
	  return arguments;
	}()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function tryGet(it, key) {
	  try {
	    return it[key];
	  } catch (e) {/* empty */}
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	  // @@toStringTag case
	  : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	  // builtinTag case
	  : ARG ? cof(O)
	  // ES3 arguments fallback
	  : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var def = __webpack_require__(9).f;
	var has = __webpack_require__(16);
	var TAG = __webpack_require__(6)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var defined = __webpack_require__(26);
	var fails = __webpack_require__(4);
	var spaces = __webpack_require__(92);
	var space = '[' + spaces + ']';
	var non = '\u200B\x85';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function exporter(KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	
	var anObject = __webpack_require__(2);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(20);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var core = __webpack_require__(21);
	var global = __webpack_require__(3);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(32) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(2);
	var aFunction = __webpack_require__(12);
	var SPECIES = __webpack_require__(6)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(19);
	var toLength = __webpack_require__(7);
	var toAbsoluteIndex = __webpack_require__(43);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	      // Array#indexOf ignores holes, Array#includes - not
	    } else for (; length > index; index++) {
	      if (IS_INCLUDES || index in O) {
	        if (O[index] === el) return IS_INCLUDES || index || 0;
	      }
	    }return !IS_INCLUDES && -1;
	  };
	};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(3);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(14);
	var redefineAll = __webpack_require__(41);
	var meta = __webpack_require__(33);
	var forOf = __webpack_require__(36);
	var anInstance = __webpack_require__(35);
	var isObject = __webpack_require__(5);
	var fails = __webpack_require__(4);
	var $iterDetect = __webpack_require__(61);
	var setToStringTag = __webpack_require__(49);
	var inheritIfRequired = __webpack_require__(79);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function fixMethod(KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY, KEY == 'delete' ? function (a) {
	      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	    } : KEY == 'has' ? function has(a) {
	      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	    } : KEY == 'get' ? function get(a) {
	      return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	    } : KEY == 'add' ? function add(a) {
	      fn.call(this, a === 0 ? 0 : a);return this;
	    } : function set(a, b) {
	      fn.call(this, a === 0 ? 0 : a, b);return this;
	    });
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () {
	      instance.has(1);
	    });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) {
	      new C(iter);
	    }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) {
	        $instance[ADDER](index, index);
	      }return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(132);
	var redefine = __webpack_require__(14);
	var hide = __webpack_require__(13);
	var fails = __webpack_require__(4);
	var defined = __webpack_require__(26);
	var wks = __webpack_require__(6);
	var regexpExec = __webpack_require__(87);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () {
	    return originalExec.apply(this, arguments);
	  };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	}();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () {
	      return 7;
	    };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () {
	      execCalled = true;return null;
	    };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () {
	        return re;
	      };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS || KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(defined, SYMBOL, ''[KEY], function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	      if (regexp.exec === regexpExec) {
	        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	          // The native String method already delegates to @@method (this
	          // polyfilled function), leasing to infinite recursion.
	          // We avoid it by directly calling the native @@method method.
	          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	        }
	        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	      }
	      return { done: false };
	    });
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	    // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	    // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	    ? function (string, arg) {
	      return rxfn.call(string, this, arg);
	    }
	    // 21.2.5.6 RegExp.prototype[@@match](string)
	    // 21.2.5.9 RegExp.prototype[@@search](string)
	    : function (string) {
	      return rxfn.call(string, this);
	    });
	  }
	};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(20);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(5);
	var cof = __webpack_require__(20);
	var MATCH = __webpack_require__(6)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ITERATOR = __webpack_require__(6)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () {
	    SAFE_CLOSING = true;
	  };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () {
	    throw 2;
	  });
	} catch (e) {/* empty */}
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () {
	      return { done: safe = true };
	    };
	    arr[ITERATOR] = function () {
	      return iter;
	    };
	    exec(arr);
	  } catch (e) {/* empty */}
	  return safe;
	};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	
	module.exports = __webpack_require__(32) || !__webpack_require__(4)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () {/* empty */});
	  delete __webpack_require__(3)[K];
	});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var classof = __webpack_require__(47);
	var builtinExec = RegExp.prototype.exec;
	
	// `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(12);
	var ctx = __webpack_require__(22);
	var forOf = __webpack_require__(36);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	      var mapFn = arguments[1];
	      var mapping, A, n, cb;
	      aFunction(this);
	      mapping = mapFn !== undefined;
	      if (mapping) aFunction(mapFn);
	      if (source == undefined) return new this();
	      A = [];
	      if (mapping) {
	        n = 0;
	        cb = ctx(mapFn, arguments[2], 2);
	        forOf(source, false, function (nextItem) {
	          A.push(cb(nextItem, n++));
	        });
	      } else {
	        forOf(source, false, A.push, A);
	      }
	      return new this(A);
	    } });
	};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	
	var $export = __webpack_require__(1);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	      var length = arguments.length;
	      var A = new Array(length);
	      while (length--) {
	        A[length] = arguments[length];
	      }return new this(A);
	    } });
	};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var toInteger = __webpack_require__(24);
	var defined = __webpack_require__(26);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(3);
	var hide = __webpack_require__(13);
	var uid = __webpack_require__(44);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(3);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * EvEmitter v1.1.0
	 * Lil' event emitter
	 * MIT License
	 */
	
	/* jshint unused: true, undef: true, strict: true */
	
	(function (global, factory) {
	  // universal module definition
	  /* jshint strict: false */ /* globals define, module, window */
	  if (true) {
	    // AMD - RequireJS
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS - Browserify, Webpack
	    module.exports = factory();
	  } else {
	    // Browser globals
	    global.EvEmitter = factory();
	  }
	})(typeof window != 'undefined' ? window : undefined, function () {
	
	  "use strict";
	
	  function EvEmitter() {}
	
	  var proto = EvEmitter.prototype;
	
	  proto.on = function (eventName, listener) {
	    if (!eventName || !listener) {
	      return;
	    }
	    // set events hash
	    var events = this._events = this._events || {};
	    // set listeners array
	    var listeners = events[eventName] = events[eventName] || [];
	    // only add once
	    if (listeners.indexOf(listener) == -1) {
	      listeners.push(listener);
	    }
	
	    return this;
	  };
	
	  proto.once = function (eventName, listener) {
	    if (!eventName || !listener) {
	      return;
	    }
	    // add event
	    this.on(eventName, listener);
	    // set once flag
	    // set onceEvents hash
	    var onceEvents = this._onceEvents = this._onceEvents || {};
	    // set onceListeners object
	    var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
	    // set flag
	    onceListeners[listener] = true;
	
	    return this;
	  };
	
	  proto.off = function (eventName, listener) {
	    var listeners = this._events && this._events[eventName];
	    if (!listeners || !listeners.length) {
	      return;
	    }
	    var index = listeners.indexOf(listener);
	    if (index != -1) {
	      listeners.splice(index, 1);
	    }
	
	    return this;
	  };
	
	  proto.emitEvent = function (eventName, args) {
	    var listeners = this._events && this._events[eventName];
	    if (!listeners || !listeners.length) {
	      return;
	    }
	    // copy over to avoid interference if .off() in listener
	    listeners = listeners.slice(0);
	    args = args || [];
	    // once stuff
	    var onceListeners = this._onceEvents && this._onceEvents[eventName];
	
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      var isOnce = onceListeners && onceListeners[listener];
	      if (isOnce) {
	        // remove listener
	        // remove before trigger to prevent recursion
	        this.off(eventName, listener);
	        // unset once flag
	        delete onceListeners[listener];
	      }
	      // trigger listener
	      listener.apply(this, args);
	    }
	
	    return this;
	  };
	
	  proto.allOff = function () {
	    delete this._events;
	    delete this._onceEvents;
	  };
	
	  return EvEmitter;
	});

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var at = __webpack_require__(67)(true);
	
	// `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	
	var toObject = __webpack_require__(10);
	var toAbsoluteIndex = __webpack_require__(43);
	var toLength = __webpack_require__(7);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) {
	    O[index++] = value;
	  }return O;
	};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(142);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(9);
	var createDesc = __webpack_require__(40);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
	};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isObject = __webpack_require__(5);
	var document = __webpack_require__(3).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	'use strict';
	
	// IE 8- don't enum bug keys
	module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var MATCH = __webpack_require__(6)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) {/* empty */}
	  }return true;
	};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var document = __webpack_require__(3).document;
	module.exports = document && document.documentElement;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isObject = __webpack_require__(5);
	var setPrototypeOf = __webpack_require__(88).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  }return that;
	};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// check on default Array iterator
	var Iterators = __webpack_require__(48);
	var ITERATOR = __webpack_require__(6)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var create = __webpack_require__(37);
	var descriptor = __webpack_require__(40);
	var setToStringTag = __webpack_require__(49);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(13)(IteratorPrototype, __webpack_require__(6)('iterator'), function () {
	  return this;
	});
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var LIBRARY = __webpack_require__(32);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(14);
	var hide = __webpack_require__(13);
	var Iterators = __webpack_require__(48);
	var $iterCreate = __webpack_require__(81);
	var setToStringTag = __webpack_require__(49);
	var getPrototypeOf = __webpack_require__(18);
	var ITERATOR = __webpack_require__(6)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function returnThis() {
	  return this;
	};
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function getMethod(kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS:
	        return function keys() {
	          return new Constructor(this, kind);
	        };
	      case VALUES:
	        return function values() {
	          return new Constructor(this, kind);
	        };
	    }return function entries() {
	      return new Constructor(this, kind);
	    };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() {
	      return $native.call(this);
	    };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	"use strict";
	
	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = !$expm1
	// Old FF bug
	|| $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	// Tor Browser bug
	|| $expm1(-2e-17) != -2e-17 ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	"use strict";
	
	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(3);
	var macrotask = __webpack_require__(93).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(20)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function flush() {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();else last = undefined;
	        throw e;
	      }
	    }last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function notify() {
	      process.nextTick(flush);
	    };
	    // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function notify() {
	      node.data = toggle = !toggle;
	    };
	    // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function notify() {
	      promise.then(flush);
	    };
	    // for other environments - macrotask based on:
	    // - setImmediate
	    // - MessageChannel
	    // - window.postMessag
	    // - onreadystatechange
	    // - setTimeout
	  } else {
	    notify = function notify() {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    }last = task;
	  };
	};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	
	var aFunction = __webpack_require__(12);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(51);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	}();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(5);
	var anObject = __webpack_require__(2);
	var check = function check(O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	  function (test, buggy, set) {
	    try {
	      set = __webpack_require__(22)(Function.call, __webpack_require__(17).f(Object.prototype, '__proto__').set, 2);
	      set(test, []);
	      buggy = !(test instanceof Array);
	    } catch (e) {
	      buggy = true;
	    }
	    return function setPrototypeOf(O, proto) {
	      check(O, proto);
	      if (buggy) O.__proto__ = proto;else set(O, proto);
	      return O;
	    };
	  }({}, false) : undefined),
	  check: check
	};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var shared = __webpack_require__(54)('keys');
	var uid = __webpack_require__(44);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(60);
	var defined = __webpack_require__(26);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var toInteger = __webpack_require__(24);
	var defined = __webpack_require__(26);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (; n > 0; (n >>>= 1) && (str += str)) {
	    if (n & 1) res += str;
	  }return res;
	};

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = '\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003' + '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ctx = __webpack_require__(22);
	var invoke = __webpack_require__(110);
	var html = __webpack_require__(78);
	var cel = __webpack_require__(75);
	var global = __webpack_require__(3);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function run() {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function listener(event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) {
	      args.push(arguments[i++]);
	    }queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(20)(process) == 'process') {
	    defer = function defer(id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	    // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function defer(id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	    // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	    // Browsers with postMessage, skip WebWorkers
	    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function defer(id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	    // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function defer(id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	    // Rest old browsers
	  } else {
	    defer = function defer(id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(3);
	var DESCRIPTORS = __webpack_require__(8);
	var LIBRARY = __webpack_require__(32);
	var $typed = __webpack_require__(68);
	var hide = __webpack_require__(13);
	var redefineAll = __webpack_require__(41);
	var fails = __webpack_require__(4);
	var anInstance = __webpack_require__(35);
	var toInteger = __webpack_require__(24);
	var toLength = __webpack_require__(7);
	var toIndex = __webpack_require__(129);
	var gOPN = __webpack_require__(38).f;
	var dP = __webpack_require__(9).f;
	var arrayFill = __webpack_require__(72);
	var setToStringTag = __webpack_require__(49);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8) {}
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8) {}
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8) {}
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8) {}
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  }return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function get() {
	      return this[internal];
	    } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) {
	    store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	  }
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(3);
	var core = __webpack_require__(21);
	var LIBRARY = __webpack_require__(32);
	var wksExt = __webpack_require__(130);
	var defineProperty = __webpack_require__(9).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(47);
	var ITERATOR = __webpack_require__(6)('iterator');
	var Iterators = __webpack_require__(48);
	module.exports = __webpack_require__(21).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
	};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var addToUnscopables = __webpack_require__(31);
	var step = __webpack_require__(113);
	var Iterators = __webpack_require__(48);
	var toIObject = __webpack_require__(19);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(82)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0; // next index
	  this._k = kind; // kind
	  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * Unipointer v2.4.0
	 * base class for doing one thing with pointer event
	 * MIT license
	 */
	
	/*jshint browser: true, undef: true, unused: true, strict: true */
	
	(function (window, factory) {
	  // universal module definition
	  /* jshint strict: false */ /*global define, module, require */
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(70)], __WEBPACK_AMD_DEFINE_RESULT__ = function (EvEmitter) {
	      return factory(window, EvEmitter);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory(window, require('ev-emitter'));
	  } else {
	    // browser global
	    window.Unipointer = factory(window, window.EvEmitter);
	  }
	})(window, function factory(window, EvEmitter) {
	
	  'use strict';
	
	  function noop() {}
	
	  function Unipointer() {}
	
	  // inherit EvEmitter
	  var proto = Unipointer.prototype = Object.create(EvEmitter.prototype);
	
	  proto.bindStartEvent = function (elem) {
	    this._bindStartEvent(elem, true);
	  };
	
	  proto.unbindStartEvent = function (elem) {
	    this._bindStartEvent(elem, false);
	  };
	
	  /**
	   * Add or remove start event
	   * @param {Boolean} isAdd - remove if falsey
	   */
	  proto._bindStartEvent = function (elem, isAdd) {
	    // munge isAdd, default to true
	    isAdd = isAdd === undefined ? true : isAdd;
	    var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
	
	    // default to mouse events
	    var startEvent = 'mousedown';
	    if ('ontouchstart' in window) {
	      // HACK prefer Touch Events as you can preventDefault on touchstart to
	      // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
	      startEvent = 'touchstart';
	    } else if (window.PointerEvent) {
	      // Pointer Events
	      startEvent = 'pointerdown';
	    }
	    elem[bindMethod](startEvent, this);
	  };
	
	  // trigger handler methods for events
	  proto.handleEvent = function (event) {
	    var method = 'on' + event.type;
	    if (this[method]) {
	      this[method](event);
	    }
	  };
	
	  // returns the touch that we're keeping track of
	  proto.getTouch = function (touches) {
	    for (var i = 0; i < touches.length; i++) {
	      var touch = touches[i];
	      if (touch.identifier == this.pointerIdentifier) {
	        return touch;
	      }
	    }
	  };
	
	  // ----- start event ----- //
	
	  proto.onmousedown = function (event) {
	    // dismiss clicks from right or middle buttons
	    var button = event.button;
	    if (button && button !== 0 && button !== 1) {
	      return;
	    }
	    this._pointerDown(event, event);
	  };
	
	  proto.ontouchstart = function (event) {
	    this._pointerDown(event, event.changedTouches[0]);
	  };
	
	  proto.onpointerdown = function (event) {
	    this._pointerDown(event, event);
	  };
	
	  /**
	   * pointer start
	   * @param {Event} event
	   * @param {Event or Touch} pointer
	   */
	  proto._pointerDown = function (event, pointer) {
	    // dismiss right click and other pointers
	    // button = 0 is okay, 1-4 not
	    if (event.button || this.isPointerDown) {
	      return;
	    }
	
	    this.isPointerDown = true;
	    // save pointer identifier to match up touch events
	    this.pointerIdentifier = pointer.pointerId !== undefined ?
	    // pointerId for pointer events, touch.indentifier for touch events
	    pointer.pointerId : pointer.identifier;
	
	    this.pointerDown(event, pointer);
	  };
	
	  proto.pointerDown = function (event, pointer) {
	    this._bindPostStartEvents(event);
	    this.emitEvent('pointerDown', [event, pointer]);
	  };
	
	  // hash of events to be bound after start event
	  var postStartEvents = {
	    mousedown: ['mousemove', 'mouseup'],
	    touchstart: ['touchmove', 'touchend', 'touchcancel'],
	    pointerdown: ['pointermove', 'pointerup', 'pointercancel']
	  };
	
	  proto._bindPostStartEvents = function (event) {
	    if (!event) {
	      return;
	    }
	    // get proper events to match start event
	    var events = postStartEvents[event.type];
	    // bind events to node
	    events.forEach(function (eventName) {
	      window.addEventListener(eventName, this);
	    }, this);
	    // save these arguments
	    this._boundPointerEvents = events;
	  };
	
	  proto._unbindPostStartEvents = function () {
	    // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
	    if (!this._boundPointerEvents) {
	      return;
	    }
	    this._boundPointerEvents.forEach(function (eventName) {
	      window.removeEventListener(eventName, this);
	    }, this);
	
	    delete this._boundPointerEvents;
	  };
	
	  // ----- move event ----- //
	
	  proto.onmousemove = function (event) {
	    this._pointerMove(event, event);
	  };
	
	  proto.onpointermove = function (event) {
	    if (event.pointerId == this.pointerIdentifier) {
	      this._pointerMove(event, event);
	    }
	  };
	
	  proto.ontouchmove = function (event) {
	    var touch = this.getTouch(event.changedTouches);
	    if (touch) {
	      this._pointerMove(event, touch);
	    }
	  };
	
	  /**
	   * pointer move
	   * @param {Event} event
	   * @param {Event or Touch} pointer
	   * @private
	   */
	  proto._pointerMove = function (event, pointer) {
	    this.pointerMove(event, pointer);
	  };
	
	  // public
	  proto.pointerMove = function (event, pointer) {
	    this.emitEvent('pointerMove', [event, pointer]);
	  };
	
	  // ----- end event ----- //
	
	
	  proto.onmouseup = function (event) {
	    this._pointerUp(event, event);
	  };
	
	  proto.onpointerup = function (event) {
	    if (event.pointerId == this.pointerIdentifier) {
	      this._pointerUp(event, event);
	    }
	  };
	
	  proto.ontouchend = function (event) {
	    var touch = this.getTouch(event.changedTouches);
	    if (touch) {
	      this._pointerUp(event, touch);
	    }
	  };
	
	  /**
	   * pointer up
	   * @param {Event} event
	   * @param {Event or Touch} pointer
	   * @private
	   */
	  proto._pointerUp = function (event, pointer) {
	    this._pointerDone();
	    this.pointerUp(event, pointer);
	  };
	
	  // public
	  proto.pointerUp = function (event, pointer) {
	    this.emitEvent('pointerUp', [event, pointer]);
	  };
	
	  // ----- pointer done ----- //
	
	  // triggered on pointer up & pointer cancel
	  proto._pointerDone = function () {
	    this._pointerReset();
	    this._unbindPostStartEvents();
	    this.pointerDone();
	  };
	
	  proto._pointerReset = function () {
	    // reset properties
	    this.isPointerDown = false;
	    delete this.pointerIdentifier;
	  };
	
	  proto.pointerDone = noop;
	
	  // ----- pointer cancel ----- //
	
	  proto.onpointercancel = function (event) {
	    if (event.pointerId == this.pointerIdentifier) {
	      this._pointerCancel(event, event);
	    }
	  };
	
	  proto.ontouchcancel = function (event) {
	    var touch = this.getTouch(event.changedTouches);
	    if (touch) {
	      this._pointerCancel(event, touch);
	    }
	  };
	
	  /**
	   * pointer cancel
	   * @param {Event} event
	   * @param {Event or Touch} pointer
	   * @private
	   */
	  proto._pointerCancel = function (event, pointer) {
	    this._pointerDone();
	    this.pointerCancel(event, pointer);
	  };
	
	  // public
	  proto.pointerCancel = function (event, pointer) {
	    this.emitEvent('pointerCancel', [event, pointer]);
	  };
	
	  // -----  ----- //
	
	  // utility function for getting x/y coords from event
	  Unipointer.getPointerPoint = function (pointer) {
	    return {
	      x: pointer.pageX,
	      y: pointer.pageY
	    };
	  };
	
	  // -----  ----- //
	
	  return Unipointer;
	});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (module) {
		if (!module.webpackPolyfill) {
			module.deprecate = function () {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var cof = __webpack_require__(20);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	
	var toObject = __webpack_require__(10);
	var toAbsoluteIndex = __webpack_require__(43);
	var toLength = __webpack_require__(7);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];else delete O[to];
	    to += inc;
	    from += inc;
	  }return O;
	};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var forOf = __webpack_require__(36);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var aFunction = __webpack_require__(12);
	var toObject = __webpack_require__(10);
	var IObject = __webpack_require__(52);
	var toLength = __webpack_require__(7);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (; isRight ? index >= 0 : length > index; index += i) {
	    if (index in self) {
	      memo = callbackfn(memo, self[index], index, O);
	    }
	  }return memo;
	};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var aFunction = __webpack_require__(12);
	var isObject = __webpack_require__(5);
	var invoke = __webpack_require__(110);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function construct(F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) {
	      n[i] = 'a[' + i + ']';
	    } // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  }return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function bound() /* args... */{
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var dP = __webpack_require__(9).f;
	var create = __webpack_require__(37);
	var redefineAll = __webpack_require__(41);
	var ctx = __webpack_require__(22);
	var anInstance = __webpack_require__(35);
	var forOf = __webpack_require__(36);
	var $iterDefine = __webpack_require__(82);
	var step = __webpack_require__(113);
	var setSpecies = __webpack_require__(42);
	var DESCRIPTORS = __webpack_require__(8);
	var fastKey = __webpack_require__(33).fastKey;
	var validate = __webpack_require__(45);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function getEntry(that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME; // collection type
	      that._i = create(null); // index
	      that._f = undefined; // first entry
	      that._l = undefined; // last entry
	      that[SIZE] = 0; // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function _delete(key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        }return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) {
	            entry = entry.p;
	          }
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function get() {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function def(that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	      // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key, // <- key
	        v: value, // <- value
	        p: prev = that._l, // <- previous entry
	        n: undefined, // <- next entry
	        r: false // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    }return that;
	  },
	  getEntry: getEntry,
	  setStrong: function setStrong(C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind; // kind
	      this._l = undefined; // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) {
	        entry = entry.p;
	      } // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(47);
	var from = __webpack_require__(102);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var redefineAll = __webpack_require__(41);
	var getWeak = __webpack_require__(33).getWeak;
	var anObject = __webpack_require__(2);
	var isObject = __webpack_require__(5);
	var anInstance = __webpack_require__(35);
	var forOf = __webpack_require__(36);
	var createArrayMethod = __webpack_require__(25);
	var $has = __webpack_require__(16);
	var validate = __webpack_require__(45);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function UncaughtFrozenStore() {
	  this.a = [];
	};
	var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function get(key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function has(key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function set(key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;else this.a.push([key, value]);
	  },
	  'delete': function _delete(key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME; // collection type
	      that._i = id++; // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function _delete(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function def(that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	
	var isArray = __webpack_require__(59);
	var isObject = __webpack_require__(5);
	var toLength = __webpack_require__(7);
	var ctx = __webpack_require__(22);
	var IS_CONCAT_SPREADABLE = __webpack_require__(6)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = !__webpack_require__(8) && !__webpack_require__(4)(function () {
	  return Object.defineProperty(__webpack_require__(75)('div'), 'a', { get: function get() {
	      return 7;
	    } }).a != 7;
	});

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	"use strict";
	
	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	                  var un = that === undefined;
	                  switch (args.length) {
	                                    case 0:
	                                                      return un ? fn() : fn.call(that);
	                                    case 1:
	                                                      return un ? fn(args[0]) : fn.call(that, args[0]);
	                                    case 2:
	                                                      return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
	                                    case 3:
	                                                      return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
	                                    case 4:
	                                                      return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
	                  }return fn.apply(that, args);
	};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(5);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(2);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	    // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(84);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function roundTiesToEven(n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	"use strict";
	
	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	"use strict";
	
	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (arguments.length === 0
	  // eslint-disable-next-line no-self-compare
	  || x != x
	  // eslint-disable-next-line no-self-compare
	  || inLow != inLow
	  // eslint-disable-next-line no-self-compare
	  || inHigh != inHigh
	  // eslint-disable-next-line no-self-compare
	  || outLow != outLow
	  // eslint-disable-next-line no-self-compare
	  || outHigh != outHigh) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	
	var DESCRIPTORS = __webpack_require__(8);
	var getKeys = __webpack_require__(39);
	var gOPS = __webpack_require__(63);
	var pIE = __webpack_require__(53);
	var toObject = __webpack_require__(10);
	var IObject = __webpack_require__(52);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(4)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) {
	    B[k] = k;
	  });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) {
	  // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  }return T;
	} : $assign;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var dP = __webpack_require__(9);
	var anObject = __webpack_require__(2);
	var getKeys = __webpack_require__(39);
	
	module.exports = __webpack_require__(8) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) {
	    dP.f(O, P = keys[i++], Properties[P]);
	  }return O;
	};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(19);
	var gOPN = __webpack_require__(38).f;
	var toString = {}.toString;
	
	var windowNames = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function getWindowNames(it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(16);
	var toIObject = __webpack_require__(19);
	var arrayIndexOf = __webpack_require__(56)(false);
	var IE_PROTO = __webpack_require__(89)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) {
	    if (key != IE_PROTO) has(O, key) && result.push(key);
	  } // Don't enum bug & hidden keys
	  while (names.length > i) {
	    if (has(O, key = names[i++])) {
	      ~arrayIndexOf(result, key) || result.push(key);
	    }
	  }return result;
	};

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DESCRIPTORS = __webpack_require__(8);
	var getKeys = __webpack_require__(39);
	var toIObject = __webpack_require__(19);
	var isEnum = __webpack_require__(53).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(38);
	var gOPS = __webpack_require__(63);
	var anObject = __webpack_require__(2);
	var Reflect = __webpack_require__(3).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $parseFloat = __webpack_require__(3).parseFloat;
	var $trim = __webpack_require__(50).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(92) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $parseInt = __webpack_require__(3).parseInt;
	var $trim = __webpack_require__(50).trim;
	var ws = __webpack_require__(92);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, radix >>> 0 || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(2);
	var isObject = __webpack_require__(5);
	var newPromiseCapability = __webpack_require__(86);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	"use strict";
	
	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(7);
	var repeat = __webpack_require__(91);
	var defined = __webpack_require__(26);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(24);
	var toLength = __webpack_require__(7);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.f = __webpack_require__(6);

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var strong = __webpack_require__(105);
	var validate = __webpack_require__(45);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(57)(MAP, function (get) {
	  return function Map() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpExec = __webpack_require__(87);
	__webpack_require__(1)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(8) && /./g.flags != 'g') __webpack_require__(9).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(51)
	});

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var strong = __webpack_require__(105);
	var validate = __webpack_require__(45);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(57)(SET, function (get) {
	  return function Set() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(3);
	var each = __webpack_require__(25)(0);
	var redefine = __webpack_require__(14);
	var meta = __webpack_require__(33);
	var assign = __webpack_require__(117);
	var weak = __webpack_require__(107);
	var isObject = __webpack_require__(5);
	var validate = __webpack_require__(45);
	var NATIVE_WEAK_MAP = __webpack_require__(45);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function wrapper(get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(57)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	        // store all the rest on native weakmap
	      }return method.call(this, a, b);
	    });
	  });
	}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * getSize v2.0.3
	 * measure size of elements
	 * MIT license
	 */
	
	/* jshint browser: true, strict: true, undef: true, unused: true */
	/* globals console: false */
	
	(function (window, factory) {
	  /* jshint strict: false */ /* globals define, module */
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory();
	  } else {
	    // browser global
	    window.getSize = factory();
	  }
	})(window, function factory() {
	  'use strict';
	
	  // -------------------------- helpers -------------------------- //
	
	  // get a number from a string, not a percentage
	
	  function getStyleSize(value) {
	    var num = parseFloat(value);
	    // not a percent like '100%', and a number
	    var isValid = value.indexOf('%') == -1 && !isNaN(num);
	    return isValid && num;
	  }
	
	  function noop() {}
	
	  var logError = typeof console == 'undefined' ? noop : function (message) {
	    console.error(message);
	  };
	
	  // -------------------------- measurements -------------------------- //
	
	  var measurements = ['paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'borderBottomWidth'];
	
	  var measurementsLength = measurements.length;
	
	  function getZeroSize() {
	    var size = {
	      width: 0,
	      height: 0,
	      innerWidth: 0,
	      innerHeight: 0,
	      outerWidth: 0,
	      outerHeight: 0
	    };
	    for (var i = 0; i < measurementsLength; i++) {
	      var measurement = measurements[i];
	      size[measurement] = 0;
	    }
	    return size;
	  }
	
	  // -------------------------- getStyle -------------------------- //
	
	  /**
	   * getStyle, get style of element, check for Firefox bug
	   * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	   */
	  function getStyle(elem) {
	    var style = getComputedStyle(elem);
	    if (!style) {
	      logError('Style returned ' + style + '. Are you running this code in a hidden iframe on Firefox? ' + 'See https://bit.ly/getsizebug1');
	    }
	    return style;
	  }
	
	  // -------------------------- setup -------------------------- //
	
	  var isSetup = false;
	
	  var isBoxSizeOuter;
	
	  /**
	   * setup
	   * check isBoxSizerOuter
	   * do on first getSize() rather than on page load for Firefox bug
	   */
	  function setup() {
	    // setup once
	    if (isSetup) {
	      return;
	    }
	    isSetup = true;
	
	    // -------------------------- box sizing -------------------------- //
	
	    /**
	     * Chrome & Safari measure the outer-width on style.width on border-box elems
	     * IE11 & Firefox<29 measures the inner-width
	     */
	    var div = document.createElement('div');
	    div.style.width = '200px';
	    div.style.padding = '1px 2px 3px 4px';
	    div.style.borderStyle = 'solid';
	    div.style.borderWidth = '1px 2px 3px 4px';
	    div.style.boxSizing = 'border-box';
	
	    var body = document.body || document.documentElement;
	    body.appendChild(div);
	    var style = getStyle(div);
	    // round value for browser zoom. desandro/masonry#928
	    isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
	    getSize.isBoxSizeOuter = isBoxSizeOuter;
	
	    body.removeChild(div);
	  }
	
	  // -------------------------- getSize -------------------------- //
	
	  function getSize(elem) {
	    setup();
	
	    // use querySeletor if elem is string
	    if (typeof elem == 'string') {
	      elem = document.querySelector(elem);
	    }
	
	    // do not proceed on non-objects
	    if (!elem || (typeof elem === 'undefined' ? 'undefined' : _typeof(elem)) != 'object' || !elem.nodeType) {
	      return;
	    }
	
	    var style = getStyle(elem);
	
	    // if hidden, everything is 0
	    if (style.display == 'none') {
	      return getZeroSize();
	    }
	
	    var size = {};
	    size.width = elem.offsetWidth;
	    size.height = elem.offsetHeight;
	
	    var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
	
	    // get all measurements
	    for (var i = 0; i < measurementsLength; i++) {
	      var measurement = measurements[i];
	      var value = style[measurement];
	      var num = parseFloat(value);
	      // any 'auto', 'medium' value will be 0
	      size[measurement] = !isNaN(num) ? num : 0;
	    }
	
	    var paddingWidth = size.paddingLeft + size.paddingRight;
	    var paddingHeight = size.paddingTop + size.paddingBottom;
	    var marginWidth = size.marginLeft + size.marginRight;
	    var marginHeight = size.marginTop + size.marginBottom;
	    var borderWidth = size.borderLeftWidth + size.borderRightWidth;
	    var borderHeight = size.borderTopWidth + size.borderBottomWidth;
	
	    var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
	
	    // overwrite width and height if we can get it from style
	    var styleWidth = getStyleSize(style.width);
	    if (styleWidth !== false) {
	      size.width = styleWidth + (
	      // add padding and border unless it's already including it
	      isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
	    }
	
	    var styleHeight = getStyleSize(style.height);
	    if (styleHeight !== false) {
	      size.height = styleHeight + (
	      // add padding and border unless it's already including it
	      isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
	    }
	
	    size.innerWidth = size.width - (paddingWidth + borderWidth);
	    size.innerHeight = size.height - (paddingHeight + borderHeight);
	
	    size.outerWidth = size.width + marginWidth;
	    size.outerHeight = size.height + marginHeight;
	
	    return size;
	  }
	
	  return getSize;
	});

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */;(function(){/** Used as a safe reference for `undefined` in pre-ES5 environments. */var undefined;/** Used as the semantic version number. */var VERSION='4.17.21';/** Used as the size to enable large array optimizations. */var LARGE_ARRAY_SIZE=200;/** Error message constants. */var CORE_ERROR_TEXT='Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',FUNC_ERROR_TEXT='Expected a function',INVALID_TEMPL_VAR_ERROR_TEXT='Invalid `variable` option passed into `_.template`';/** Used to stand-in for `undefined` hash values. */var HASH_UNDEFINED='__lodash_hash_undefined__';/** Used as the maximum memoize cache size. */var MAX_MEMOIZE_SIZE=500;/** Used as the internal argument placeholder. */var PLACEHOLDER='__lodash_placeholder__';/** Used to compose bitmasks for cloning. */var CLONE_DEEP_FLAG=1,CLONE_FLAT_FLAG=2,CLONE_SYMBOLS_FLAG=4;/** Used to compose bitmasks for value comparisons. */var COMPARE_PARTIAL_FLAG=1,COMPARE_UNORDERED_FLAG=2;/** Used to compose bitmasks for function metadata. */var WRAP_BIND_FLAG=1,WRAP_BIND_KEY_FLAG=2,WRAP_CURRY_BOUND_FLAG=4,WRAP_CURRY_FLAG=8,WRAP_CURRY_RIGHT_FLAG=16,WRAP_PARTIAL_FLAG=32,WRAP_PARTIAL_RIGHT_FLAG=64,WRAP_ARY_FLAG=128,WRAP_REARG_FLAG=256,WRAP_FLIP_FLAG=512;/** Used as default options for `_.truncate`. */var DEFAULT_TRUNC_LENGTH=30,DEFAULT_TRUNC_OMISSION='...';/** Used to detect hot functions by number of calls within a span of milliseconds. */var HOT_COUNT=800,HOT_SPAN=16;/** Used to indicate the type of lazy iteratees. */var LAZY_FILTER_FLAG=1,LAZY_MAP_FLAG=2,LAZY_WHILE_FLAG=3;/** Used as references for various `Number` constants. */var INFINITY=1/0,MAX_SAFE_INTEGER=9007199254740991,MAX_INTEGER=1.7976931348623157e+308,NAN=0/0;/** Used as references for the maximum length and index of an array. */var MAX_ARRAY_LENGTH=4294967295,MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1;/** Used to associate wrap methods with their bit flags. */var wrapFlags=[['ary',WRAP_ARY_FLAG],['bind',WRAP_BIND_FLAG],['bindKey',WRAP_BIND_KEY_FLAG],['curry',WRAP_CURRY_FLAG],['curryRight',WRAP_CURRY_RIGHT_FLAG],['flip',WRAP_FLIP_FLAG],['partial',WRAP_PARTIAL_FLAG],['partialRight',WRAP_PARTIAL_RIGHT_FLAG],['rearg',WRAP_REARG_FLAG]];/** `Object#toString` result references. */var argsTag='[object Arguments]',arrayTag='[object Array]',asyncTag='[object AsyncFunction]',boolTag='[object Boolean]',dateTag='[object Date]',domExcTag='[object DOMException]',errorTag='[object Error]',funcTag='[object Function]',genTag='[object GeneratorFunction]',mapTag='[object Map]',numberTag='[object Number]',nullTag='[object Null]',objectTag='[object Object]',promiseTag='[object Promise]',proxyTag='[object Proxy]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',symbolTag='[object Symbol]',undefinedTag='[object Undefined]',weakMapTag='[object WeakMap]',weakSetTag='[object WeakSet]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/** Used to match empty string literals in compiled template source. */var reEmptyStringLeading=/\b__p \+= '';/g,reEmptyStringMiddle=/\b(__p \+=) '' \+/g,reEmptyStringTrailing=/(__e\(.*?\)|\b__t\)) \+\n'';/g;/** Used to match HTML entities and HTML characters. */var reEscapedHtml=/&(?:amp|lt|gt|quot|#39);/g,reUnescapedHtml=/[&<>"']/g,reHasEscapedHtml=RegExp(reEscapedHtml.source),reHasUnescapedHtml=RegExp(reUnescapedHtml.source);/** Used to match template delimiters. */var reEscape=/<%-([\s\S]+?)%>/g,reEvaluate=/<%([\s\S]+?)%>/g,reInterpolate=/<%=([\s\S]+?)%>/g;/** Used to match property names within property paths. */var reIsDeepProp=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,reIsPlainProp=/^\w*$/,rePropName=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;/**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */var reRegExpChar=/[\\^$.*+?()[\]{}|]/g,reHasRegExpChar=RegExp(reRegExpChar.source);/** Used to match leading whitespace. */var reTrimStart=/^\s+/;/** Used to match a single whitespace character. */var reWhitespace=/\s/;/** Used to match wrap detail comments. */var reWrapComment=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,reWrapDetails=/\{\n\/\* \[wrapped with (.+)\] \*/,reSplitDetails=/,? & /;/** Used to match words composed of alphanumeric characters. */var reAsciiWord=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;/**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */var reForbiddenIdentifierChars=/[()=,{}\[\]\/\s]/;/** Used to match backslashes in property paths. */var reEscapeChar=/\\(\\)?/g;/**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */var reEsTemplate=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;/** Used to match `RegExp` flags from their coerced string values. */var reFlags=/\w*$/;/** Used to detect bad signed hexadecimal string values. */var reIsBadHex=/^[-+]0x[0-9a-f]+$/i;/** Used to detect binary string values. */var reIsBinary=/^0b[01]+$/i;/** Used to detect host constructors (Safari). */var reIsHostCtor=/^\[object .+?Constructor\]$/;/** Used to detect octal string values. */var reIsOctal=/^0o[0-7]+$/i;/** Used to detect unsigned integer values. */var reIsUint=/^(?:0|[1-9]\d*)$/;/** Used to match Latin Unicode letters (excluding mathematical operators). */var reLatin=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;/** Used to ensure capturing order of template delimiters. */var reNoMatch=/($^)/;/** Used to match unescaped characters in compiled string literals. */var reUnescapedString=/['\n\r\u2028\u2029\\]/g;/** Used to compose unicode character classes. */var rsAstralRange='\\ud800-\\udfff',rsComboMarksRange='\\u0300-\\u036f',reComboHalfMarksRange='\\ufe20-\\ufe2f',rsComboSymbolsRange='\\u20d0-\\u20ff',rsComboRange=rsComboMarksRange+reComboHalfMarksRange+rsComboSymbolsRange,rsDingbatRange='\\u2700-\\u27bf',rsLowerRange='a-z\\xdf-\\xf6\\xf8-\\xff',rsMathOpRange='\\xac\\xb1\\xd7\\xf7',rsNonCharRange='\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',rsPunctuationRange='\\u2000-\\u206f',rsSpaceRange=' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',rsUpperRange='A-Z\\xc0-\\xd6\\xd8-\\xde',rsVarRange='\\ufe0e\\ufe0f',rsBreakRange=rsMathOpRange+rsNonCharRange+rsPunctuationRange+rsSpaceRange;/** Used to compose unicode capture groups. */var rsApos='[\'\u2019]',rsAstral='['+rsAstralRange+']',rsBreak='['+rsBreakRange+']',rsCombo='['+rsComboRange+']',rsDigits='\\d+',rsDingbat='['+rsDingbatRange+']',rsLower='['+rsLowerRange+']',rsMisc='[^'+rsAstralRange+rsBreakRange+rsDigits+rsDingbatRange+rsLowerRange+rsUpperRange+']',rsFitz='\\ud83c[\\udffb-\\udfff]',rsModifier='(?:'+rsCombo+'|'+rsFitz+')',rsNonAstral='[^'+rsAstralRange+']',rsRegional='(?:\\ud83c[\\udde6-\\uddff]){2}',rsSurrPair='[\\ud800-\\udbff][\\udc00-\\udfff]',rsUpper='['+rsUpperRange+']',rsZWJ='\\u200d';/** Used to compose unicode regexes. */var rsMiscLower='(?:'+rsLower+'|'+rsMisc+')',rsMiscUpper='(?:'+rsUpper+'|'+rsMisc+')',rsOptContrLower='(?:'+rsApos+'(?:d|ll|m|re|s|t|ve))?',rsOptContrUpper='(?:'+rsApos+'(?:D|LL|M|RE|S|T|VE))?',reOptMod=rsModifier+'?',rsOptVar='['+rsVarRange+']?',rsOptJoin='(?:'+rsZWJ+'(?:'+[rsNonAstral,rsRegional,rsSurrPair].join('|')+')'+rsOptVar+reOptMod+')*',rsOrdLower='\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',rsOrdUpper='\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',rsSeq=rsOptVar+reOptMod+rsOptJoin,rsEmoji='(?:'+[rsDingbat,rsRegional,rsSurrPair].join('|')+')'+rsSeq,rsSymbol='(?:'+[rsNonAstral+rsCombo+'?',rsCombo,rsRegional,rsSurrPair,rsAstral].join('|')+')';/** Used to match apostrophes. */var reApos=RegExp(rsApos,'g');/**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */var reComboMark=RegExp(rsCombo,'g');/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */var reUnicode=RegExp(rsFitz+'(?='+rsFitz+')|'+rsSymbol+rsSeq,'g');/** Used to match complex or compound words. */var reUnicodeWord=RegExp([rsUpper+'?'+rsLower+'+'+rsOptContrLower+'(?='+[rsBreak,rsUpper,'$'].join('|')+')',rsMiscUpper+'+'+rsOptContrUpper+'(?='+[rsBreak,rsUpper+rsMiscLower,'$'].join('|')+')',rsUpper+'?'+rsMiscLower+'+'+rsOptContrLower,rsUpper+'+'+rsOptContrUpper,rsOrdUpper,rsOrdLower,rsDigits,rsEmoji].join('|'),'g');/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */var reHasUnicode=RegExp('['+rsZWJ+rsAstralRange+rsComboRange+rsVarRange+']');/** Used to detect strings that need a more robust regexp to match words. */var reHasUnicodeWord=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;/** Used to assign default `context` object properties. */var contextProps=['Array','Buffer','DataView','Date','Error','Float32Array','Float64Array','Function','Int8Array','Int16Array','Int32Array','Map','Math','Object','Promise','RegExp','Set','String','Symbol','TypeError','Uint8Array','Uint8ClampedArray','Uint16Array','Uint32Array','WeakMap','_','clearTimeout','isFinite','parseInt','setTimeout'];/** Used to make template sourceURLs easier to identify. */var templateCounter=-1;/** Used to identify `toStringTag` values of typed arrays. */var typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=true;typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=false;/** Used to identify `toStringTag` values supported by `_.clone`. */var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[dataViewTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[mapTag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[setTag]=cloneableTags[stringTag]=cloneableTags[symbolTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=true;cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[weakMapTag]=false;/** Used to map Latin Unicode letters to basic Latin letters. */var deburredLetters={// Latin-1 Supplement block.
	'\xc0':'A','\xc1':'A','\xc2':'A','\xc3':'A','\xc4':'A','\xc5':'A','\xe0':'a','\xe1':'a','\xe2':'a','\xe3':'a','\xe4':'a','\xe5':'a','\xc7':'C','\xe7':'c','\xd0':'D','\xf0':'d','\xc8':'E','\xc9':'E','\xca':'E','\xcb':'E','\xe8':'e','\xe9':'e','\xea':'e','\xeb':'e','\xcc':'I','\xcd':'I','\xce':'I','\xcf':'I','\xec':'i','\xed':'i','\xee':'i','\xef':'i','\xd1':'N','\xf1':'n','\xd2':'O','\xd3':'O','\xd4':'O','\xd5':'O','\xd6':'O','\xd8':'O','\xf2':'o','\xf3':'o','\xf4':'o','\xf5':'o','\xf6':'o','\xf8':'o','\xd9':'U','\xda':'U','\xdb':'U','\xdc':'U','\xf9':'u','\xfa':'u','\xfb':'u','\xfc':'u','\xdd':'Y','\xfd':'y','\xff':'y','\xc6':'Ae','\xe6':'ae','\xde':'Th','\xfe':'th','\xdf':'ss',// Latin Extended-A block.
	'\u0100':'A','\u0102':'A','\u0104':'A','\u0101':'a','\u0103':'a','\u0105':'a','\u0106':'C','\u0108':'C','\u010A':'C','\u010C':'C','\u0107':'c','\u0109':'c','\u010B':'c','\u010D':'c','\u010E':'D','\u0110':'D','\u010F':'d','\u0111':'d','\u0112':'E','\u0114':'E','\u0116':'E','\u0118':'E','\u011A':'E','\u0113':'e','\u0115':'e','\u0117':'e','\u0119':'e','\u011B':'e','\u011C':'G','\u011E':'G','\u0120':'G','\u0122':'G','\u011D':'g','\u011F':'g','\u0121':'g','\u0123':'g','\u0124':'H','\u0126':'H','\u0125':'h','\u0127':'h','\u0128':'I','\u012A':'I','\u012C':'I','\u012E':'I','\u0130':'I','\u0129':'i','\u012B':'i','\u012D':'i','\u012F':'i','\u0131':'i','\u0134':'J','\u0135':'j','\u0136':'K','\u0137':'k','\u0138':'k','\u0139':'L','\u013B':'L','\u013D':'L','\u013F':'L','\u0141':'L','\u013A':'l','\u013C':'l','\u013E':'l','\u0140':'l','\u0142':'l','\u0143':'N','\u0145':'N','\u0147':'N','\u014A':'N','\u0144':'n','\u0146':'n','\u0148':'n','\u014B':'n','\u014C':'O','\u014E':'O','\u0150':'O','\u014D':'o','\u014F':'o','\u0151':'o','\u0154':'R','\u0156':'R','\u0158':'R','\u0155':'r','\u0157':'r','\u0159':'r','\u015A':'S','\u015C':'S','\u015E':'S','\u0160':'S','\u015B':'s','\u015D':'s','\u015F':'s','\u0161':'s','\u0162':'T','\u0164':'T','\u0166':'T','\u0163':'t','\u0165':'t','\u0167':'t','\u0168':'U','\u016A':'U','\u016C':'U','\u016E':'U','\u0170':'U','\u0172':'U','\u0169':'u','\u016B':'u','\u016D':'u','\u016F':'u','\u0171':'u','\u0173':'u','\u0174':'W','\u0175':'w','\u0176':'Y','\u0177':'y','\u0178':'Y','\u0179':'Z','\u017B':'Z','\u017D':'Z','\u017A':'z','\u017C':'z','\u017E':'z','\u0132':'IJ','\u0133':'ij','\u0152':'Oe','\u0153':'oe','\u0149':"'n",'\u017F':'s'};/** Used to map characters to HTML entities. */var htmlEscapes={'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'};/** Used to map HTML entities to characters. */var htmlUnescapes={'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&#39;':"'"};/** Used to escape characters for inclusion in compiled string literals. */var stringEscapes={'\\':'\\',"'":"'",'\n':'n','\r':'r','\u2028':'u2028','\u2029':'u2029'};/** Built-in method references without a dependency on `root`. */var freeParseFloat=parseFloat,freeParseInt=parseInt;/** Detect free variable `global` from Node.js. */var freeGlobal=(typeof global==='undefined'?'undefined':_typeof(global))=='object'&&global&&global.Object===Object&&global;/** Detect free variable `self`. */var freeSelf=(typeof self==='undefined'?'undefined':_typeof(self))=='object'&&self&&self.Object===Object&&self;/** Used as a reference to the global object. */var root=freeGlobal||freeSelf||Function('return this')();/** Detect free variable `exports`. */var freeExports=( false?'undefined':_typeof(exports))=='object'&&exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&( false?'undefined':_typeof(module))=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Detect free variable `process` from Node.js. */var freeProcess=moduleExports&&freeGlobal.process;/** Used to access faster Node.js helpers. */var nodeUtil=function(){try{// Use `util.types` for Node.js 10+.
	var types=freeModule&&freeModule.require&&freeModule.require('util').types;if(types){return types;}// Legacy `process.binding('util')` for Node.js < 10.
	return freeProcess&&freeProcess.binding&&freeProcess.binding('util');}catch(e){}}();/* Node.js helper references. */var nodeIsArrayBuffer=nodeUtil&&nodeUtil.isArrayBuffer,nodeIsDate=nodeUtil&&nodeUtil.isDate,nodeIsMap=nodeUtil&&nodeUtil.isMap,nodeIsRegExp=nodeUtil&&nodeUtil.isRegExp,nodeIsSet=nodeUtil&&nodeUtil.isSet,nodeIsTypedArray=nodeUtil&&nodeUtil.isTypedArray;/*--------------------------------------------------------------------------*//**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */function apply(func,thisArg,args){switch(args.length){case 0:return func.call(thisArg);case 1:return func.call(thisArg,args[0]);case 2:return func.call(thisArg,args[0],args[1]);case 3:return func.call(thisArg,args[0],args[1],args[2]);}return func.apply(thisArg,args);}/**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */function arrayAggregator(array,setter,iteratee,accumulator){var index=-1,length=array==null?0:array.length;while(++index<length){var value=array[index];setter(accumulator,value,iteratee(value),array);}return accumulator;}/**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */function arrayEach(array,iteratee){var index=-1,length=array==null?0:array.length;while(++index<length){if(iteratee(array[index],index,array)===false){break;}}return array;}/**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */function arrayEachRight(array,iteratee){var length=array==null?0:array.length;while(length--){if(iteratee(array[length],length,array)===false){break;}}return array;}/**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */function arrayEvery(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(!predicate(array[index],index,array)){return false;}}return true;}/**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */function arrayFilter(array,predicate){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(predicate(value,index,array)){result[resIndex++]=value;}}return result;}/**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */function arrayIncludes(array,value){var length=array==null?0:array.length;return!!length&&baseIndexOf(array,value,0)>-1;}/**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */function arrayIncludesWith(array,value,comparator){var index=-1,length=array==null?0:array.length;while(++index<length){if(comparator(value,array[index])){return true;}}return false;}/**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */function arrayMap(array,iteratee){var index=-1,length=array==null?0:array.length,result=Array(length);while(++index<length){result[index]=iteratee(array[index],index,array);}return result;}/**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */function arrayPush(array,values){var index=-1,length=values.length,offset=array.length;while(++index<length){array[offset+index]=values[index];}return array;}/**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */function arrayReduce(array,iteratee,accumulator,initAccum){var index=-1,length=array==null?0:array.length;if(initAccum&&length){accumulator=array[++index];}while(++index<length){accumulator=iteratee(accumulator,array[index],index,array);}return accumulator;}/**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */function arrayReduceRight(array,iteratee,accumulator,initAccum){var length=array==null?0:array.length;if(initAccum&&length){accumulator=array[--length];}while(length--){accumulator=iteratee(accumulator,array[length],length,array);}return accumulator;}/**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */function arraySome(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(predicate(array[index],index,array)){return true;}}return false;}/**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */var asciiSize=baseProperty('length');/**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */function asciiToArray(string){return string.split('');}/**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */function asciiWords(string){return string.match(reAsciiWord)||[];}/**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */function baseFindKey(collection,predicate,eachFunc){var result;eachFunc(collection,function(value,key,collection){if(predicate(value,key,collection)){result=key;return false;}});return result;}/**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function baseFindIndex(array,predicate,fromIndex,fromRight){var length=array.length,index=fromIndex+(fromRight?1:-1);while(fromRight?index--:++index<length){if(predicate(array[index],index,array)){return index;}}return-1;}/**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function baseIndexOf(array,value,fromIndex){return value===value?strictIndexOf(array,value,fromIndex):baseFindIndex(array,baseIsNaN,fromIndex);}/**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function baseIndexOfWith(array,value,fromIndex,comparator){var index=fromIndex-1,length=array.length;while(++index<length){if(comparator(array[index],value)){return index;}}return-1;}/**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */function baseIsNaN(value){return value!==value;}/**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */function baseMean(array,iteratee){var length=array==null?0:array.length;return length?baseSum(array,iteratee)/length:NAN;}/**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */function baseProperty(key){return function(object){return object==null?undefined:object[key];};}/**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */function basePropertyOf(object){return function(key){return object==null?undefined:object[key];};}/**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */function baseReduce(collection,iteratee,accumulator,initAccum,eachFunc){eachFunc(collection,function(value,index,collection){accumulator=initAccum?(initAccum=false,value):iteratee(accumulator,value,index,collection);});return accumulator;}/**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */function baseSortBy(array,comparer){var length=array.length;array.sort(comparer);while(length--){array[length]=array[length].value;}return array;}/**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */function baseSum(array,iteratee){var result,index=-1,length=array.length;while(++index<length){var current=iteratee(array[index]);if(current!==undefined){result=result===undefined?current:result+current;}}return result;}/**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */function baseTimes(n,iteratee){var index=-1,result=Array(n);while(++index<n){result[index]=iteratee(index);}return result;}/**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */function baseToPairs(object,props){return arrayMap(props,function(key){return[key,object[key]];});}/**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */function baseTrim(string){return string?string.slice(0,trimmedEndIndex(string)+1).replace(reTrimStart,''):string;}/**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */function baseUnary(func){return function(value){return func(value);};}/**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */function baseValues(object,props){return arrayMap(props,function(key){return object[key];});}/**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */function cacheHas(cache,key){return cache.has(key);}/**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */function charsStartIndex(strSymbols,chrSymbols){var index=-1,length=strSymbols.length;while(++index<length&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */function charsEndIndex(strSymbols,chrSymbols){var index=strSymbols.length;while(index--&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */function countHolders(array,placeholder){var length=array.length,result=0;while(length--){if(array[length]===placeholder){++result;}}return result;}/**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */var deburrLetter=basePropertyOf(deburredLetters);/**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */var escapeHtmlChar=basePropertyOf(htmlEscapes);/**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */function escapeStringChar(chr){return'\\'+stringEscapes[chr];}/**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */function getValue(object,key){return object==null?undefined:object[key];}/**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */function hasUnicode(string){return reHasUnicode.test(string);}/**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */function hasUnicodeWord(string){return reHasUnicodeWord.test(string);}/**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */function iteratorToArray(iterator){var data,result=[];while(!(data=iterator.next()).done){result.push(data.value);}return result;}/**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */function mapToArray(map){var index=-1,result=Array(map.size);map.forEach(function(value,key){result[++index]=[key,value];});return result;}/**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */function overArg(func,transform){return function(arg){return func(transform(arg));};}/**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */function replaceHolders(array,placeholder){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value===placeholder||value===PLACEHOLDER){array[index]=PLACEHOLDER;result[resIndex++]=index;}}return result;}/**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */function setToArray(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=value;});return result;}/**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */function setToPairs(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=[value,value];});return result;}/**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function strictIndexOf(array,value,fromIndex){var index=fromIndex-1,length=array.length;while(++index<length){if(array[index]===value){return index;}}return-1;}/**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function strictLastIndexOf(array,value,fromIndex){var index=fromIndex+1;while(index--){if(array[index]===value){return index;}}return index;}/**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */function stringSize(string){return hasUnicode(string)?unicodeSize(string):asciiSize(string);}/**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */function stringToArray(string){return hasUnicode(string)?unicodeToArray(string):asciiToArray(string);}/**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */function trimmedEndIndex(string){var index=string.length;while(index--&&reWhitespace.test(string.charAt(index))){}return index;}/**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */var unescapeHtmlChar=basePropertyOf(htmlUnescapes);/**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */function unicodeSize(string){var result=reUnicode.lastIndex=0;while(reUnicode.test(string)){++result;}return result;}/**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */function unicodeToArray(string){return string.match(reUnicode)||[];}/**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */function unicodeWords(string){return string.match(reUnicodeWord)||[];}/*--------------------------------------------------------------------------*//**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */var runInContext=function runInContext(context){context=context==null?root:_.defaults(root.Object(),context,_.pick(root,contextProps));/** Built-in constructor references. */var Array=context.Array,Date=context.Date,Error=context.Error,Function=context.Function,Math=context.Math,Object=context.Object,RegExp=context.RegExp,String=context.String,TypeError=context.TypeError;/** Used for built-in method references. */var arrayProto=Array.prototype,funcProto=Function.prototype,objectProto=Object.prototype;/** Used to detect overreaching core-js shims. */var coreJsData=context['__core-js_shared__'];/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Used to generate unique IDs. */var idCounter=0;/** Used to detect methods masquerading as native. */var maskSrcKey=function(){var uid=/[^.]+$/.exec(coreJsData&&coreJsData.keys&&coreJsData.keys.IE_PROTO||'');return uid?'Symbol(src)_1.'+uid:'';}();/**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */var nativeObjectToString=objectProto.toString;/** Used to infer the `Object` constructor. */var objectCtorString=funcToString.call(Object);/** Used to restore the original `_` reference in `_.noConflict`. */var oldDash=root._;/** Used to detect if a method is native. */var reIsNative=RegExp('^'+funcToString.call(hasOwnProperty).replace(reRegExpChar,'\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$');/** Built-in value references. */var Buffer=moduleExports?context.Buffer:undefined,_Symbol=context.Symbol,Uint8Array=context.Uint8Array,allocUnsafe=Buffer?Buffer.allocUnsafe:undefined,getPrototype=overArg(Object.getPrototypeOf,Object),objectCreate=Object.create,propertyIsEnumerable=objectProto.propertyIsEnumerable,splice=arrayProto.splice,spreadableSymbol=_Symbol?_Symbol.isConcatSpreadable:undefined,symIterator=_Symbol?_Symbol.iterator:undefined,symToStringTag=_Symbol?_Symbol.toStringTag:undefined;var defineProperty=function(){try{var func=getNative(Object,'defineProperty');func({},'',{});return func;}catch(e){}}();/** Mocked built-ins. */var ctxClearTimeout=context.clearTimeout!==root.clearTimeout&&context.clearTimeout,ctxNow=Date&&Date.now!==root.Date.now&&Date.now,ctxSetTimeout=context.setTimeout!==root.setTimeout&&context.setTimeout;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeCeil=Math.ceil,nativeFloor=Math.floor,nativeGetSymbols=Object.getOwnPropertySymbols,nativeIsBuffer=Buffer?Buffer.isBuffer:undefined,nativeIsFinite=context.isFinite,nativeJoin=arrayProto.join,nativeKeys=overArg(Object.keys,Object),nativeMax=Math.max,nativeMin=Math.min,nativeNow=Date.now,nativeParseInt=context.parseInt,nativeRandom=Math.random,nativeReverse=arrayProto.reverse;/* Built-in method references that are verified to be native. */var DataView=getNative(context,'DataView'),Map=getNative(context,'Map'),Promise=getNative(context,'Promise'),Set=getNative(context,'Set'),WeakMap=getNative(context,'WeakMap'),nativeCreate=getNative(Object,'create');/** Used to store function metadata. */var metaMap=WeakMap&&new WeakMap();/** Used to lookup unminified function names. */var realNames={};/** Used to detect maps, sets, and weakmaps. */var dataViewCtorString=toSource(DataView),mapCtorString=toSource(Map),promiseCtorString=toSource(Promise),setCtorString=toSource(Set),weakMapCtorString=toSource(WeakMap);/** Used to convert symbols to primitives and strings. */var symbolProto=_Symbol?_Symbol.prototype:undefined,symbolValueOf=symbolProto?symbolProto.valueOf:undefined,symbolToString=symbolProto?symbolProto.toString:undefined;/*------------------------------------------------------------------------*//**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */function lodash(value){if(isObjectLike(value)&&!isArray(value)&&!(value instanceof LazyWrapper)){if(value instanceof LodashWrapper){return value;}if(hasOwnProperty.call(value,'__wrapped__')){return wrapperClone(value);}}return new LodashWrapper(value);}/**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */var baseCreate=function(){function object(){}return function(proto){if(!isObject(proto)){return{};}if(objectCreate){return objectCreate(proto);}object.prototype=proto;var result=new object();object.prototype=undefined;return result;};}();/**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */function baseLodash(){}// No operation performed.
	/**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */function LodashWrapper(value,chainAll){this.__wrapped__=value;this.__actions__=[];this.__chain__=!!chainAll;this.__index__=0;this.__values__=undefined;}/**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */lodash.templateSettings={/**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */'escape':reEscape,/**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */'evaluate':reEvaluate,/**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */'interpolate':reInterpolate,/**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */'variable':'',/**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */'imports':{/**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */'_':lodash}};// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype=baseLodash.prototype;lodash.prototype.constructor=lodash;LodashWrapper.prototype=baseCreate(baseLodash.prototype);LodashWrapper.prototype.constructor=LodashWrapper;/*------------------------------------------------------------------------*//**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */function LazyWrapper(value){this.__wrapped__=value;this.__actions__=[];this.__dir__=1;this.__filtered__=false;this.__iteratees__=[];this.__takeCount__=MAX_ARRAY_LENGTH;this.__views__=[];}/**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */function lazyClone(){var result=new LazyWrapper(this.__wrapped__);result.__actions__=copyArray(this.__actions__);result.__dir__=this.__dir__;result.__filtered__=this.__filtered__;result.__iteratees__=copyArray(this.__iteratees__);result.__takeCount__=this.__takeCount__;result.__views__=copyArray(this.__views__);return result;}/**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */function lazyReverse(){if(this.__filtered__){var result=new LazyWrapper(this);result.__dir__=-1;result.__filtered__=true;}else{result=this.clone();result.__dir__*=-1;}return result;}/**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */function lazyValue(){var array=this.__wrapped__.value(),dir=this.__dir__,isArr=isArray(array),isRight=dir<0,arrLength=isArr?array.length:0,view=getView(0,arrLength,this.__views__),start=view.start,end=view.end,length=end-start,index=isRight?end:start-1,iteratees=this.__iteratees__,iterLength=iteratees.length,resIndex=0,takeCount=nativeMin(length,this.__takeCount__);if(!isArr||!isRight&&arrLength==length&&takeCount==length){return baseWrapperValue(array,this.__actions__);}var result=[];outer:while(length--&&resIndex<takeCount){index+=dir;var iterIndex=-1,value=array[index];while(++iterIndex<iterLength){var data=iteratees[iterIndex],iteratee=data.iteratee,type=data.type,computed=iteratee(value);if(type==LAZY_MAP_FLAG){value=computed;}else if(!computed){if(type==LAZY_FILTER_FLAG){continue outer;}else{break outer;}}}result[resIndex++]=value;}return result;}// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype=baseCreate(baseLodash.prototype);LazyWrapper.prototype.constructor=LazyWrapper;/*------------------------------------------------------------------------*//**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function Hash(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */function hashClear(){this.__data__=nativeCreate?nativeCreate(null):{};this.size=0;}/**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function hashDelete(key){var result=this.has(key)&&delete this.__data__[key];this.size-=result?1:0;return result;}/**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function hashGet(key){var data=this.__data__;if(nativeCreate){var result=data[key];return result===HASH_UNDEFINED?undefined:result;}return hasOwnProperty.call(data,key)?data[key]:undefined;}/**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function hashHas(key){var data=this.__data__;return nativeCreate?data[key]!==undefined:hasOwnProperty.call(data,key);}/**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */function hashSet(key,value){var data=this.__data__;this.size+=this.has(key)?0:1;data[key]=nativeCreate&&value===undefined?HASH_UNDEFINED:value;return this;}// Add methods to `Hash`.
	Hash.prototype.clear=hashClear;Hash.prototype['delete']=hashDelete;Hash.prototype.get=hashGet;Hash.prototype.has=hashHas;Hash.prototype.set=hashSet;/*------------------------------------------------------------------------*//**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function ListCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */function listCacheClear(){this.__data__=[];this.size=0;}/**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function listCacheDelete(key){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){return false;}var lastIndex=data.length-1;if(index==lastIndex){data.pop();}else{splice.call(data,index,1);}--this.size;return true;}/**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function listCacheGet(key){var data=this.__data__,index=assocIndexOf(data,key);return index<0?undefined:data[index][1];}/**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function listCacheHas(key){return assocIndexOf(this.__data__,key)>-1;}/**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */function listCacheSet(key,value){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){++this.size;data.push([key,value]);}else{data[index][1]=value;}return this;}// Add methods to `ListCache`.
	ListCache.prototype.clear=listCacheClear;ListCache.prototype['delete']=listCacheDelete;ListCache.prototype.get=listCacheGet;ListCache.prototype.has=listCacheHas;ListCache.prototype.set=listCacheSet;/*------------------------------------------------------------------------*//**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function MapCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */function mapCacheClear(){this.size=0;this.__data__={'hash':new Hash(),'map':new(Map||ListCache)(),'string':new Hash()};}/**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function mapCacheDelete(key){var result=getMapData(this,key)['delete'](key);this.size-=result?1:0;return result;}/**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function mapCacheGet(key){return getMapData(this,key).get(key);}/**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function mapCacheHas(key){return getMapData(this,key).has(key);}/**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */function mapCacheSet(key,value){var data=getMapData(this,key),size=data.size;data.set(key,value);this.size+=data.size==size?0:1;return this;}// Add methods to `MapCache`.
	MapCache.prototype.clear=mapCacheClear;MapCache.prototype['delete']=mapCacheDelete;MapCache.prototype.get=mapCacheGet;MapCache.prototype.has=mapCacheHas;MapCache.prototype.set=mapCacheSet;/*------------------------------------------------------------------------*//**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */function SetCache(values){var index=-1,length=values==null?0:values.length;this.__data__=new MapCache();while(++index<length){this.add(values[index]);}}/**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */function setCacheAdd(value){this.__data__.set(value,HASH_UNDEFINED);return this;}/**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */function setCacheHas(value){return this.__data__.has(value);}// Add methods to `SetCache`.
	SetCache.prototype.add=SetCache.prototype.push=setCacheAdd;SetCache.prototype.has=setCacheHas;/*------------------------------------------------------------------------*//**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function Stack(entries){var data=this.__data__=new ListCache(entries);this.size=data.size;}/**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */function stackClear(){this.__data__=new ListCache();this.size=0;}/**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function stackDelete(key){var data=this.__data__,result=data['delete'](key);this.size=data.size;return result;}/**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function stackGet(key){return this.__data__.get(key);}/**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function stackHas(key){return this.__data__.has(key);}/**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */function stackSet(key,value){var data=this.__data__;if(data instanceof ListCache){var pairs=data.__data__;if(!Map||pairs.length<LARGE_ARRAY_SIZE-1){pairs.push([key,value]);this.size=++data.size;return this;}data=this.__data__=new MapCache(pairs);}data.set(key,value);this.size=data.size;return this;}// Add methods to `Stack`.
	Stack.prototype.clear=stackClear;Stack.prototype['delete']=stackDelete;Stack.prototype.get=stackGet;Stack.prototype.has=stackHas;Stack.prototype.set=stackSet;/*------------------------------------------------------------------------*//**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */function arrayLikeKeys(value,inherited){var isArr=isArray(value),isArg=!isArr&&isArguments(value),isBuff=!isArr&&!isArg&&isBuffer(value),isType=!isArr&&!isArg&&!isBuff&&isTypedArray(value),skipIndexes=isArr||isArg||isBuff||isType,result=skipIndexes?baseTimes(value.length,String):[],length=result.length;for(var key in value){if((inherited||hasOwnProperty.call(value,key))&&!(skipIndexes&&(// Safari 9 has enumerable `arguments.length` in strict mode.
	key=='length'||// Node.js 0.10 has enumerable non-index properties on buffers.
	isBuff&&(key=='offset'||key=='parent')||// PhantomJS 2 has enumerable non-index properties on typed arrays.
	isType&&(key=='buffer'||key=='byteLength'||key=='byteOffset')||// Skip index properties.
	isIndex(key,length)))){result.push(key);}}return result;}/**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */function arraySample(array){var length=array.length;return length?array[baseRandom(0,length-1)]:undefined;}/**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */function arraySampleSize(array,n){return shuffleSelf(copyArray(array),baseClamp(n,0,array.length));}/**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */function arrayShuffle(array){return shuffleSelf(copyArray(array));}/**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */function assignMergeValue(object,key,value){if(value!==undefined&&!eq(object[key],value)||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */function assignValue(object,key,value){var objValue=object[key];if(!(hasOwnProperty.call(object,key)&&eq(objValue,value))||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */function assocIndexOf(array,key){var length=array.length;while(length--){if(eq(array[length][0],key)){return length;}}return-1;}/**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */function baseAggregator(collection,setter,iteratee,accumulator){baseEach(collection,function(value,key,collection){setter(accumulator,value,iteratee(value),collection);});return accumulator;}/**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */function baseAssign(object,source){return object&&copyObject(source,keys(source),object);}/**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */function baseAssignIn(object,source){return object&&copyObject(source,keysIn(source),object);}/**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */function baseAssignValue(object,key,value){if(key=='__proto__'&&defineProperty){defineProperty(object,key,{'configurable':true,'enumerable':true,'value':value,'writable':true});}else{object[key]=value;}}/**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */function baseAt(object,paths){var index=-1,length=paths.length,result=Array(length),skip=object==null;while(++index<length){result[index]=skip?undefined:get(object,paths[index]);}return result;}/**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */function baseClamp(number,lower,upper){if(number===number){if(upper!==undefined){number=number<=upper?number:upper;}if(lower!==undefined){number=number>=lower?number:lower;}}return number;}/**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */function baseClone(value,bitmask,customizer,key,object,stack){var result,isDeep=bitmask&CLONE_DEEP_FLAG,isFlat=bitmask&CLONE_FLAT_FLAG,isFull=bitmask&CLONE_SYMBOLS_FLAG;if(customizer){result=object?customizer(value,key,object,stack):customizer(value);}if(result!==undefined){return result;}if(!isObject(value)){return value;}var isArr=isArray(value);if(isArr){result=initCloneArray(value);if(!isDeep){return copyArray(value,result);}}else{var tag=getTag(value),isFunc=tag==funcTag||tag==genTag;if(isBuffer(value)){return cloneBuffer(value,isDeep);}if(tag==objectTag||tag==argsTag||isFunc&&!object){result=isFlat||isFunc?{}:initCloneObject(value);if(!isDeep){return isFlat?copySymbolsIn(value,baseAssignIn(result,value)):copySymbols(value,baseAssign(result,value));}}else{if(!cloneableTags[tag]){return object?value:{};}result=initCloneByTag(value,tag,isDeep);}}// Check for circular references and return its corresponding clone.
	stack||(stack=new Stack());var stacked=stack.get(value);if(stacked){return stacked;}stack.set(value,result);if(isSet(value)){value.forEach(function(subValue){result.add(baseClone(subValue,bitmask,customizer,subValue,value,stack));});}else if(isMap(value)){value.forEach(function(subValue,key){result.set(key,baseClone(subValue,bitmask,customizer,key,value,stack));});}var keysFunc=isFull?isFlat?getAllKeysIn:getAllKeys:isFlat?keysIn:keys;var props=isArr?undefined:keysFunc(value);arrayEach(props||value,function(subValue,key){if(props){key=subValue;subValue=value[key];}// Recursively populate clone (susceptible to call stack limits).
	assignValue(result,key,baseClone(subValue,bitmask,customizer,key,value,stack));});return result;}/**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */function baseConforms(source){var props=keys(source);return function(object){return baseConformsTo(object,source,props);};}/**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */function baseConformsTo(object,source,props){var length=props.length;if(object==null){return!length;}object=Object(object);while(length--){var key=props[length],predicate=source[key],value=object[key];if(value===undefined&&!(key in object)||!predicate(value)){return false;}}return true;}/**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */function baseDelay(func,wait,args){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return setTimeout(function(){func.apply(undefined,args);},wait);}/**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */function baseDifference(array,values,iteratee,comparator){var index=-1,includes=arrayIncludes,isCommon=true,length=array.length,result=[],valuesLength=values.length;if(!length){return result;}if(iteratee){values=arrayMap(values,baseUnary(iteratee));}if(comparator){includes=arrayIncludesWith;isCommon=false;}else if(values.length>=LARGE_ARRAY_SIZE){includes=cacheHas;isCommon=false;values=new SetCache(values);}outer:while(++index<length){var value=array[index],computed=iteratee==null?value:iteratee(value);value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var valuesIndex=valuesLength;while(valuesIndex--){if(values[valuesIndex]===computed){continue outer;}}result.push(value);}else if(!includes(values,computed,comparator)){result.push(value);}}return result;}/**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */var baseEach=createBaseEach(baseForOwn);/**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */var baseEachRight=createBaseEach(baseForOwnRight,true);/**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */function baseEvery(collection,predicate){var result=true;baseEach(collection,function(value,index,collection){result=!!predicate(value,index,collection);return result;});return result;}/**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */function baseExtremum(array,iteratee,comparator){var index=-1,length=array.length;while(++index<length){var value=array[index],current=iteratee(value);if(current!=null&&(computed===undefined?current===current&&!isSymbol(current):comparator(current,computed))){var computed=current,result=value;}}return result;}/**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */function baseFill(array,value,start,end){var length=array.length;start=toInteger(start);if(start<0){start=-start>length?0:length+start;}end=end===undefined||end>length?length:toInteger(end);if(end<0){end+=length;}end=start>end?0:toLength(end);while(start<end){array[start++]=value;}return array;}/**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */function baseFilter(collection,predicate){var result=[];baseEach(collection,function(value,index,collection){if(predicate(value,index,collection)){result.push(value);}});return result;}/**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */function baseFlatten(array,depth,predicate,isStrict,result){var index=-1,length=array.length;predicate||(predicate=isFlattenable);result||(result=[]);while(++index<length){var value=array[index];if(depth>0&&predicate(value)){if(depth>1){// Recursively flatten arrays (susceptible to call stack limits).
	baseFlatten(value,depth-1,predicate,isStrict,result);}else{arrayPush(result,value);}}else if(!isStrict){result[result.length]=value;}}return result;}/**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */var baseFor=createBaseFor();/**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */var baseForRight=createBaseFor(true);/**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */function baseForOwn(object,iteratee){return object&&baseFor(object,iteratee,keys);}/**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */function baseForOwnRight(object,iteratee){return object&&baseForRight(object,iteratee,keys);}/**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */function baseFunctions(object,props){return arrayFilter(props,function(key){return isFunction(object[key]);});}/**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */function baseGet(object,path){path=castPath(path,object);var index=0,length=path.length;while(object!=null&&index<length){object=object[toKey(path[index++])];}return index&&index==length?object:undefined;}/**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */function baseGetAllKeys(object,keysFunc,symbolsFunc){var result=keysFunc(object);return isArray(object)?result:arrayPush(result,symbolsFunc(object));}/**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */function baseGetTag(value){if(value==null){return value===undefined?undefinedTag:nullTag;}return symToStringTag&&symToStringTag in Object(value)?getRawTag(value):objectToString(value);}/**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */function baseGt(value,other){return value>other;}/**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */function baseHas(object,key){return object!=null&&hasOwnProperty.call(object,key);}/**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */function baseHasIn(object,key){return object!=null&&key in Object(object);}/**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */function baseInRange(number,start,end){return number>=nativeMin(start,end)&&number<nativeMax(start,end);}/**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */function baseIntersection(arrays,iteratee,comparator){var includes=comparator?arrayIncludesWith:arrayIncludes,length=arrays[0].length,othLength=arrays.length,othIndex=othLength,caches=Array(othLength),maxLength=Infinity,result=[];while(othIndex--){var array=arrays[othIndex];if(othIndex&&iteratee){array=arrayMap(array,baseUnary(iteratee));}maxLength=nativeMin(array.length,maxLength);caches[othIndex]=!comparator&&(iteratee||length>=120&&array.length>=120)?new SetCache(othIndex&&array):undefined;}array=arrays[0];var index=-1,seen=caches[0];outer:while(++index<length&&result.length<maxLength){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(!(seen?cacheHas(seen,computed):includes(result,computed,comparator))){othIndex=othLength;while(--othIndex){var cache=caches[othIndex];if(!(cache?cacheHas(cache,computed):includes(arrays[othIndex],computed,comparator))){continue outer;}}if(seen){seen.push(computed);}result.push(value);}}return result;}/**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */function baseInverter(object,setter,iteratee,accumulator){baseForOwn(object,function(value,key,object){setter(accumulator,iteratee(value),key,object);});return accumulator;}/**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */function baseInvoke(object,path,args){path=castPath(path,object);object=parent(object,path);var func=object==null?object:object[toKey(last(path))];return func==null?undefined:apply(func,object,args);}/**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */function baseIsArguments(value){return isObjectLike(value)&&baseGetTag(value)==argsTag;}/**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */function baseIsArrayBuffer(value){return isObjectLike(value)&&baseGetTag(value)==arrayBufferTag;}/**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */function baseIsDate(value){return isObjectLike(value)&&baseGetTag(value)==dateTag;}/**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */function baseIsEqual(value,other,bitmask,customizer,stack){if(value===other){return true;}if(value==null||other==null||!isObjectLike(value)&&!isObjectLike(other)){return value!==value&&other!==other;}return baseIsEqualDeep(value,other,bitmask,customizer,baseIsEqual,stack);}/**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */function baseIsEqualDeep(object,other,bitmask,customizer,equalFunc,stack){var objIsArr=isArray(object),othIsArr=isArray(other),objTag=objIsArr?arrayTag:getTag(object),othTag=othIsArr?arrayTag:getTag(other);objTag=objTag==argsTag?objectTag:objTag;othTag=othTag==argsTag?objectTag:othTag;var objIsObj=objTag==objectTag,othIsObj=othTag==objectTag,isSameTag=objTag==othTag;if(isSameTag&&isBuffer(object)){if(!isBuffer(other)){return false;}objIsArr=true;objIsObj=false;}if(isSameTag&&!objIsObj){stack||(stack=new Stack());return objIsArr||isTypedArray(object)?equalArrays(object,other,bitmask,customizer,equalFunc,stack):equalByTag(object,other,objTag,bitmask,customizer,equalFunc,stack);}if(!(bitmask&COMPARE_PARTIAL_FLAG)){var objIsWrapped=objIsObj&&hasOwnProperty.call(object,'__wrapped__'),othIsWrapped=othIsObj&&hasOwnProperty.call(other,'__wrapped__');if(objIsWrapped||othIsWrapped){var objUnwrapped=objIsWrapped?object.value():object,othUnwrapped=othIsWrapped?other.value():other;stack||(stack=new Stack());return equalFunc(objUnwrapped,othUnwrapped,bitmask,customizer,stack);}}if(!isSameTag){return false;}stack||(stack=new Stack());return equalObjects(object,other,bitmask,customizer,equalFunc,stack);}/**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */function baseIsMap(value){return isObjectLike(value)&&getTag(value)==mapTag;}/**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */function baseIsMatch(object,source,matchData,customizer){var index=matchData.length,length=index,noCustomizer=!customizer;if(object==null){return!length;}object=Object(object);while(index--){var data=matchData[index];if(noCustomizer&&data[2]?data[1]!==object[data[0]]:!(data[0]in object)){return false;}}while(++index<length){data=matchData[index];var key=data[0],objValue=object[key],srcValue=data[1];if(noCustomizer&&data[2]){if(objValue===undefined&&!(key in object)){return false;}}else{var stack=new Stack();if(customizer){var result=customizer(objValue,srcValue,key,object,source,stack);}if(!(result===undefined?baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG,customizer,stack):result)){return false;}}}return true;}/**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */function baseIsNative(value){if(!isObject(value)||isMasked(value)){return false;}var pattern=isFunction(value)?reIsNative:reIsHostCtor;return pattern.test(toSource(value));}/**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */function baseIsRegExp(value){return isObjectLike(value)&&baseGetTag(value)==regexpTag;}/**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */function baseIsSet(value){return isObjectLike(value)&&getTag(value)==setTag;}/**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */function baseIsTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[baseGetTag(value)];}/**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */function baseIteratee(value){// Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	// See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	if(typeof value=='function'){return value;}if(value==null){return identity;}if((typeof value==='undefined'?'undefined':_typeof(value))=='object'){return isArray(value)?baseMatchesProperty(value[0],value[1]):baseMatches(value);}return property(value);}/**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */function baseKeys(object){if(!isPrototype(object)){return nativeKeys(object);}var result=[];for(var key in Object(object)){if(hasOwnProperty.call(object,key)&&key!='constructor'){result.push(key);}}return result;}/**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */function baseKeysIn(object){if(!isObject(object)){return nativeKeysIn(object);}var isProto=isPrototype(object),result=[];for(var key in object){if(!(key=='constructor'&&(isProto||!hasOwnProperty.call(object,key)))){result.push(key);}}return result;}/**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */function baseLt(value,other){return value<other;}/**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */function baseMap(collection,iteratee){var index=-1,result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value,key,collection){result[++index]=iteratee(value,key,collection);});return result;}/**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */function baseMatches(source){var matchData=getMatchData(source);if(matchData.length==1&&matchData[0][2]){return matchesStrictComparable(matchData[0][0],matchData[0][1]);}return function(object){return object===source||baseIsMatch(object,source,matchData);};}/**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */function baseMatchesProperty(path,srcValue){if(isKey(path)&&isStrictComparable(srcValue)){return matchesStrictComparable(toKey(path),srcValue);}return function(object){var objValue=get(object,path);return objValue===undefined&&objValue===srcValue?hasIn(object,path):baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG);};}/**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */function baseMerge(object,source,srcIndex,customizer,stack){if(object===source){return;}baseFor(source,function(srcValue,key){stack||(stack=new Stack());if(isObject(srcValue)){baseMergeDeep(object,source,key,srcIndex,baseMerge,customizer,stack);}else{var newValue=customizer?customizer(safeGet(object,key),srcValue,key+'',object,source,stack):undefined;if(newValue===undefined){newValue=srcValue;}assignMergeValue(object,key,newValue);}},keysIn);}/**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */function baseMergeDeep(object,source,key,srcIndex,mergeFunc,customizer,stack){var objValue=safeGet(object,key),srcValue=safeGet(source,key),stacked=stack.get(srcValue);if(stacked){assignMergeValue(object,key,stacked);return;}var newValue=customizer?customizer(objValue,srcValue,key+'',object,source,stack):undefined;var isCommon=newValue===undefined;if(isCommon){var isArr=isArray(srcValue),isBuff=!isArr&&isBuffer(srcValue),isTyped=!isArr&&!isBuff&&isTypedArray(srcValue);newValue=srcValue;if(isArr||isBuff||isTyped){if(isArray(objValue)){newValue=objValue;}else if(isArrayLikeObject(objValue)){newValue=copyArray(objValue);}else if(isBuff){isCommon=false;newValue=cloneBuffer(srcValue,true);}else if(isTyped){isCommon=false;newValue=cloneTypedArray(srcValue,true);}else{newValue=[];}}else if(isPlainObject(srcValue)||isArguments(srcValue)){newValue=objValue;if(isArguments(objValue)){newValue=toPlainObject(objValue);}else if(!isObject(objValue)||isFunction(objValue)){newValue=initCloneObject(srcValue);}}else{isCommon=false;}}if(isCommon){// Recursively merge objects and arrays (susceptible to call stack limits).
	stack.set(srcValue,newValue);mergeFunc(newValue,srcValue,srcIndex,customizer,stack);stack['delete'](srcValue);}assignMergeValue(object,key,newValue);}/**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */function baseNth(array,n){var length=array.length;if(!length){return;}n+=n<0?length:0;return isIndex(n,length)?array[n]:undefined;}/**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */function baseOrderBy(collection,iteratees,orders){if(iteratees.length){iteratees=arrayMap(iteratees,function(iteratee){if(isArray(iteratee)){return function(value){return baseGet(value,iteratee.length===1?iteratee[0]:iteratee);};}return iteratee;});}else{iteratees=[identity];}var index=-1;iteratees=arrayMap(iteratees,baseUnary(getIteratee()));var result=baseMap(collection,function(value,key,collection){var criteria=arrayMap(iteratees,function(iteratee){return iteratee(value);});return{'criteria':criteria,'index':++index,'value':value};});return baseSortBy(result,function(object,other){return compareMultiple(object,other,orders);});}/**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */function basePick(object,paths){return basePickBy(object,paths,function(value,path){return hasIn(object,path);});}/**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */function basePickBy(object,paths,predicate){var index=-1,length=paths.length,result={};while(++index<length){var path=paths[index],value=baseGet(object,path);if(predicate(value,path)){baseSet(result,castPath(path,object),value);}}return result;}/**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */function basePropertyDeep(path){return function(object){return baseGet(object,path);};}/**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */function basePullAll(array,values,iteratee,comparator){var indexOf=comparator?baseIndexOfWith:baseIndexOf,index=-1,length=values.length,seen=array;if(array===values){values=copyArray(values);}if(iteratee){seen=arrayMap(array,baseUnary(iteratee));}while(++index<length){var fromIndex=0,value=values[index],computed=iteratee?iteratee(value):value;while((fromIndex=indexOf(seen,computed,fromIndex,comparator))>-1){if(seen!==array){splice.call(seen,fromIndex,1);}splice.call(array,fromIndex,1);}}return array;}/**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */function basePullAt(array,indexes){var length=array?indexes.length:0,lastIndex=length-1;while(length--){var index=indexes[length];if(length==lastIndex||index!==previous){var previous=index;if(isIndex(index)){splice.call(array,index,1);}else{baseUnset(array,index);}}}return array;}/**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */function baseRandom(lower,upper){return lower+nativeFloor(nativeRandom()*(upper-lower+1));}/**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */function baseRange(start,end,step,fromRight){var index=-1,length=nativeMax(nativeCeil((end-start)/(step||1)),0),result=Array(length);while(length--){result[fromRight?length:++index]=start;start+=step;}return result;}/**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */function baseRepeat(string,n){var result='';if(!string||n<1||n>MAX_SAFE_INTEGER){return result;}// Leverage the exponentiation by squaring algorithm for a faster repeat.
	// See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	do{if(n%2){result+=string;}n=nativeFloor(n/2);if(n){string+=string;}}while(n);return result;}/**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */function baseRest(func,start){return setToString(overRest(func,start,identity),func+'');}/**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */function baseSample(collection){return arraySample(values(collection));}/**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */function baseSampleSize(collection,n){var array=values(collection);return shuffleSelf(array,baseClamp(n,0,array.length));}/**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */function baseSet(object,path,value,customizer){if(!isObject(object)){return object;}path=castPath(path,object);var index=-1,length=path.length,lastIndex=length-1,nested=object;while(nested!=null&&++index<length){var key=toKey(path[index]),newValue=value;if(key==='__proto__'||key==='constructor'||key==='prototype'){return object;}if(index!=lastIndex){var objValue=nested[key];newValue=customizer?customizer(objValue,key,nested):undefined;if(newValue===undefined){newValue=isObject(objValue)?objValue:isIndex(path[index+1])?[]:{};}}assignValue(nested,key,newValue);nested=nested[key];}return object;}/**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */var baseSetData=!metaMap?identity:function(func,data){metaMap.set(func,data);return func;};/**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */var baseSetToString=!defineProperty?identity:function(func,string){return defineProperty(func,'toString',{'configurable':true,'enumerable':false,'value':constant(string),'writable':true});};/**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */function baseShuffle(collection){return shuffleSelf(values(collection));}/**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */function baseSlice(array,start,end){var index=-1,length=array.length;if(start<0){start=-start>length?0:length+start;}end=end>length?length:end;if(end<0){end+=length;}length=start>end?0:end-start>>>0;start>>>=0;var result=Array(length);while(++index<length){result[index]=array[index+start];}return result;}/**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */function baseSome(collection,predicate){var result;baseEach(collection,function(value,index,collection){result=predicate(value,index,collection);return!result;});return!!result;}/**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */function baseSortedIndex(array,value,retHighest){var low=0,high=array==null?low:array.length;if(typeof value=='number'&&value===value&&high<=HALF_MAX_ARRAY_LENGTH){while(low<high){var mid=low+high>>>1,computed=array[mid];if(computed!==null&&!isSymbol(computed)&&(retHighest?computed<=value:computed<value)){low=mid+1;}else{high=mid;}}return high;}return baseSortedIndexBy(array,value,identity,retHighest);}/**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */function baseSortedIndexBy(array,value,iteratee,retHighest){var low=0,high=array==null?0:array.length;if(high===0){return 0;}value=iteratee(value);var valIsNaN=value!==value,valIsNull=value===null,valIsSymbol=isSymbol(value),valIsUndefined=value===undefined;while(low<high){var mid=nativeFloor((low+high)/2),computed=iteratee(array[mid]),othIsDefined=computed!==undefined,othIsNull=computed===null,othIsReflexive=computed===computed,othIsSymbol=isSymbol(computed);if(valIsNaN){var setLow=retHighest||othIsReflexive;}else if(valIsUndefined){setLow=othIsReflexive&&(retHighest||othIsDefined);}else if(valIsNull){setLow=othIsReflexive&&othIsDefined&&(retHighest||!othIsNull);}else if(valIsSymbol){setLow=othIsReflexive&&othIsDefined&&!othIsNull&&(retHighest||!othIsSymbol);}else if(othIsNull||othIsSymbol){setLow=false;}else{setLow=retHighest?computed<=value:computed<value;}if(setLow){low=mid+1;}else{high=mid;}}return nativeMin(high,MAX_ARRAY_INDEX);}/**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */function baseSortedUniq(array,iteratee){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;if(!index||!eq(computed,seen)){var seen=computed;result[resIndex++]=value===0?0:value;}}return result;}/**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */function baseToNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}return+value;}/**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */function baseToString(value){// Exit early for strings to avoid a performance hit in some environments.
	if(typeof value=='string'){return value;}if(isArray(value)){// Recursively convert values (susceptible to call stack limits).
	return arrayMap(value,baseToString)+'';}if(isSymbol(value)){return symbolToString?symbolToString.call(value):'';}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */function baseUniq(array,iteratee,comparator){var index=-1,includes=arrayIncludes,length=array.length,isCommon=true,result=[],seen=result;if(comparator){isCommon=false;includes=arrayIncludesWith;}else if(length>=LARGE_ARRAY_SIZE){var set=iteratee?null:createSet(array);if(set){return setToArray(set);}isCommon=false;includes=cacheHas;seen=new SetCache();}else{seen=iteratee?[]:result;}outer:while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var seenIndex=seen.length;while(seenIndex--){if(seen[seenIndex]===computed){continue outer;}}if(iteratee){seen.push(computed);}result.push(value);}else if(!includes(seen,computed,comparator)){if(seen!==result){seen.push(computed);}result.push(value);}}return result;}/**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */function baseUnset(object,path){path=castPath(path,object);object=parent(object,path);return object==null||delete object[toKey(last(path))];}/**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */function baseUpdate(object,path,updater,customizer){return baseSet(object,path,updater(baseGet(object,path)),customizer);}/**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */function baseWhile(array,predicate,isDrop,fromRight){var length=array.length,index=fromRight?length:-1;while((fromRight?index--:++index<length)&&predicate(array[index],index,array)){}return isDrop?baseSlice(array,fromRight?0:index,fromRight?index+1:length):baseSlice(array,fromRight?index+1:0,fromRight?length:index);}/**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */function baseWrapperValue(value,actions){var result=value;if(result instanceof LazyWrapper){result=result.value();}return arrayReduce(actions,function(result,action){return action.func.apply(action.thisArg,arrayPush([result],action.args));},result);}/**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */function baseXor(arrays,iteratee,comparator){var length=arrays.length;if(length<2){return length?baseUniq(arrays[0]):[];}var index=-1,result=Array(length);while(++index<length){var array=arrays[index],othIndex=-1;while(++othIndex<length){if(othIndex!=index){result[index]=baseDifference(result[index]||array,arrays[othIndex],iteratee,comparator);}}}return baseUniq(baseFlatten(result,1),iteratee,comparator);}/**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */function baseZipObject(props,values,assignFunc){var index=-1,length=props.length,valsLength=values.length,result={};while(++index<length){var value=index<valsLength?values[index]:undefined;assignFunc(result,props[index],value);}return result;}/**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */function castArrayLikeObject(value){return isArrayLikeObject(value)?value:[];}/**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */function castFunction(value){return typeof value=='function'?value:identity;}/**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */function castPath(value,object){if(isArray(value)){return value;}return isKey(value,object)?[value]:stringToPath(toString(value));}/**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */var castRest=baseRest;/**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */function castSlice(array,start,end){var length=array.length;end=end===undefined?length:end;return!start&&end>=length?array:baseSlice(array,start,end);}/**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */var clearTimeout=ctxClearTimeout||function(id){return root.clearTimeout(id);};/**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */function cloneBuffer(buffer,isDeep){if(isDeep){return buffer.slice();}var length=buffer.length,result=allocUnsafe?allocUnsafe(length):new buffer.constructor(length);buffer.copy(result);return result;}/**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */function cloneArrayBuffer(arrayBuffer){var result=new arrayBuffer.constructor(arrayBuffer.byteLength);new Uint8Array(result).set(new Uint8Array(arrayBuffer));return result;}/**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */function cloneDataView(dataView,isDeep){var buffer=isDeep?cloneArrayBuffer(dataView.buffer):dataView.buffer;return new dataView.constructor(buffer,dataView.byteOffset,dataView.byteLength);}/**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */function cloneRegExp(regexp){var result=new regexp.constructor(regexp.source,reFlags.exec(regexp));result.lastIndex=regexp.lastIndex;return result;}/**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */function cloneSymbol(symbol){return symbolValueOf?Object(symbolValueOf.call(symbol)):{};}/**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */function cloneTypedArray(typedArray,isDeep){var buffer=isDeep?cloneArrayBuffer(typedArray.buffer):typedArray.buffer;return new typedArray.constructor(buffer,typedArray.byteOffset,typedArray.length);}/**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */function compareAscending(value,other){if(value!==other){var valIsDefined=value!==undefined,valIsNull=value===null,valIsReflexive=value===value,valIsSymbol=isSymbol(value);var othIsDefined=other!==undefined,othIsNull=other===null,othIsReflexive=other===other,othIsSymbol=isSymbol(other);if(!othIsNull&&!othIsSymbol&&!valIsSymbol&&value>other||valIsSymbol&&othIsDefined&&othIsReflexive&&!othIsNull&&!othIsSymbol||valIsNull&&othIsDefined&&othIsReflexive||!valIsDefined&&othIsReflexive||!valIsReflexive){return 1;}if(!valIsNull&&!valIsSymbol&&!othIsSymbol&&value<other||othIsSymbol&&valIsDefined&&valIsReflexive&&!valIsNull&&!valIsSymbol||othIsNull&&valIsDefined&&valIsReflexive||!othIsDefined&&valIsReflexive||!othIsReflexive){return-1;}}return 0;}/**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */function compareMultiple(object,other,orders){var index=-1,objCriteria=object.criteria,othCriteria=other.criteria,length=objCriteria.length,ordersLength=orders.length;while(++index<length){var result=compareAscending(objCriteria[index],othCriteria[index]);if(result){if(index>=ordersLength){return result;}var order=orders[index];return result*(order=='desc'?-1:1);}}// Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	// that causes it, under certain circumstances, to provide the same value for
	// `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	// for more details.
	//
	// This also ensures a stable sort in V8 and other engines.
	// See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	return object.index-other.index;}/**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */function composeArgs(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersLength=holders.length,leftIndex=-1,leftLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(leftLength+rangeLength),isUncurried=!isCurried;while(++leftIndex<leftLength){result[leftIndex]=partials[leftIndex];}while(++argsIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[holders[argsIndex]]=args[argsIndex];}}while(rangeLength--){result[leftIndex++]=args[argsIndex++];}return result;}/**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */function composeArgsRight(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersIndex=-1,holdersLength=holders.length,rightIndex=-1,rightLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(rangeLength+rightLength),isUncurried=!isCurried;while(++argsIndex<rangeLength){result[argsIndex]=args[argsIndex];}var offset=argsIndex;while(++rightIndex<rightLength){result[offset+rightIndex]=partials[rightIndex];}while(++holdersIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[offset+holders[holdersIndex]]=args[argsIndex++];}}return result;}/**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */function copyArray(source,array){var index=-1,length=source.length;array||(array=Array(length));while(++index<length){array[index]=source[index];}return array;}/**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */function copyObject(source,props,object,customizer){var isNew=!object;object||(object={});var index=-1,length=props.length;while(++index<length){var key=props[index];var newValue=customizer?customizer(object[key],source[key],key,object,source):undefined;if(newValue===undefined){newValue=source[key];}if(isNew){baseAssignValue(object,key,newValue);}else{assignValue(object,key,newValue);}}return object;}/**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */function copySymbols(source,object){return copyObject(source,getSymbols(source),object);}/**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */function copySymbolsIn(source,object){return copyObject(source,getSymbolsIn(source),object);}/**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */function createAggregator(setter,initializer){return function(collection,iteratee){var func=isArray(collection)?arrayAggregator:baseAggregator,accumulator=initializer?initializer():{};return func(collection,setter,getIteratee(iteratee,2),accumulator);};}/**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */function createAssigner(assigner){return baseRest(function(object,sources){var index=-1,length=sources.length,customizer=length>1?sources[length-1]:undefined,guard=length>2?sources[2]:undefined;customizer=assigner.length>3&&typeof customizer=='function'?(length--,customizer):undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){customizer=length<3?undefined:customizer;length=1;}object=Object(object);while(++index<length){var source=sources[index];if(source){assigner(object,source,index,customizer);}}return object;});}/**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */function createBaseEach(eachFunc,fromRight){return function(collection,iteratee){if(collection==null){return collection;}if(!isArrayLike(collection)){return eachFunc(collection,iteratee);}var length=collection.length,index=fromRight?length:-1,iterable=Object(collection);while(fromRight?index--:++index<length){if(iteratee(iterable[index],index,iterable)===false){break;}}return collection;};}/**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */function createBaseFor(fromRight){return function(object,iteratee,keysFunc){var index=-1,iterable=Object(object),props=keysFunc(object),length=props.length;while(length--){var key=props[fromRight?length:++index];if(iteratee(iterable[key],key,iterable)===false){break;}}return object;};}/**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createBind(func,bitmask,thisArg){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return fn.apply(isBind?thisArg:this,arguments);}return wrapper;}/**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */function createCaseFirst(methodName){return function(string){string=toString(string);var strSymbols=hasUnicode(string)?stringToArray(string):undefined;var chr=strSymbols?strSymbols[0]:string.charAt(0);var trailing=strSymbols?castSlice(strSymbols,1).join(''):string.slice(1);return chr[methodName]()+trailing;};}/**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */function createCompounder(callback){return function(string){return arrayReduce(words(deburr(string).replace(reApos,'')),callback,'');};}/**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */function createCtor(Ctor){return function(){// Use a `switch` statement to work with class constructors. See
	// http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	// for more details.
	var args=arguments;switch(args.length){case 0:return new Ctor();case 1:return new Ctor(args[0]);case 2:return new Ctor(args[0],args[1]);case 3:return new Ctor(args[0],args[1],args[2]);case 4:return new Ctor(args[0],args[1],args[2],args[3]);case 5:return new Ctor(args[0],args[1],args[2],args[3],args[4]);case 6:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5]);case 7:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5],args[6]);}var thisBinding=baseCreate(Ctor.prototype),result=Ctor.apply(thisBinding,args);// Mimic the constructor's `return` behavior.
	// See https://es5.github.io/#x13.2.2 for more details.
	return isObject(result)?result:thisBinding;};}/**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createCurry(func,bitmask,arity){var Ctor=createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length,placeholder=getHolder(wrapper);while(index--){args[index]=arguments[index];}var holders=length<3&&args[0]!==placeholder&&args[length-1]!==placeholder?[]:replaceHolders(args,placeholder);length-=holders.length;if(length<arity){return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,undefined,args,holders,undefined,undefined,arity-length);}var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return apply(fn,this,args);}return wrapper;}/**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */function createFind(findIndexFunc){return function(collection,predicate,fromIndex){var iterable=Object(collection);if(!isArrayLike(collection)){var iteratee=getIteratee(predicate,3);collection=keys(collection);predicate=function predicate(key){return iteratee(iterable[key],key,iterable);};}var index=findIndexFunc(collection,predicate,fromIndex);return index>-1?iterable[iteratee?collection[index]:index]:undefined;};}/**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */function createFlow(fromRight){return flatRest(function(funcs){var length=funcs.length,index=length,prereq=LodashWrapper.prototype.thru;if(fromRight){funcs.reverse();}while(index--){var func=funcs[index];if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(prereq&&!wrapper&&getFuncName(func)=='wrapper'){var wrapper=new LodashWrapper([],true);}}index=wrapper?index:length;while(++index<length){func=funcs[index];var funcName=getFuncName(func),data=funcName=='wrapper'?getData(func):undefined;if(data&&isLaziable(data[0])&&data[1]==(WRAP_ARY_FLAG|WRAP_CURRY_FLAG|WRAP_PARTIAL_FLAG|WRAP_REARG_FLAG)&&!data[4].length&&data[9]==1){wrapper=wrapper[getFuncName(data[0])].apply(wrapper,data[3]);}else{wrapper=func.length==1&&isLaziable(func)?wrapper[funcName]():wrapper.thru(func);}}return function(){var args=arguments,value=args[0];if(wrapper&&args.length==1&&isArray(value)){return wrapper.plant(value).value();}var index=0,result=length?funcs[index].apply(this,args):value;while(++index<length){result=funcs[index].call(this,result);}return result;};});}/**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createHybrid(func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity){var isAry=bitmask&WRAP_ARY_FLAG,isBind=bitmask&WRAP_BIND_FLAG,isBindKey=bitmask&WRAP_BIND_KEY_FLAG,isCurried=bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG),isFlip=bitmask&WRAP_FLIP_FLAG,Ctor=isBindKey?undefined:createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length;while(index--){args[index]=arguments[index];}if(isCurried){var placeholder=getHolder(wrapper),holdersCount=countHolders(args,placeholder);}if(partials){args=composeArgs(args,partials,holders,isCurried);}if(partialsRight){args=composeArgsRight(args,partialsRight,holdersRight,isCurried);}length-=holdersCount;if(isCurried&&length<arity){var newHolders=replaceHolders(args,placeholder);return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,thisArg,args,newHolders,argPos,ary,arity-length);}var thisBinding=isBind?thisArg:this,fn=isBindKey?thisBinding[func]:func;length=args.length;if(argPos){args=reorder(args,argPos);}else if(isFlip&&length>1){args.reverse();}if(isAry&&ary<length){args.length=ary;}if(this&&this!==root&&this instanceof wrapper){fn=Ctor||createCtor(fn);}return fn.apply(thisBinding,args);}return wrapper;}/**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */function createInverter(setter,toIteratee){return function(object,iteratee){return baseInverter(object,setter,toIteratee(iteratee),{});};}/**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */function createMathOperation(operator,defaultValue){return function(value,other){var result;if(value===undefined&&other===undefined){return defaultValue;}if(value!==undefined){result=value;}if(other!==undefined){if(result===undefined){return other;}if(typeof value=='string'||typeof other=='string'){value=baseToString(value);other=baseToString(other);}else{value=baseToNumber(value);other=baseToNumber(other);}result=operator(value,other);}return result;};}/**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */function createOver(arrayFunc){return flatRest(function(iteratees){iteratees=arrayMap(iteratees,baseUnary(getIteratee()));return baseRest(function(args){var thisArg=this;return arrayFunc(iteratees,function(iteratee){return apply(iteratee,thisArg,args);});});});}/**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */function createPadding(length,chars){chars=chars===undefined?' ':baseToString(chars);var charsLength=chars.length;if(charsLength<2){return charsLength?baseRepeat(chars,length):chars;}var result=baseRepeat(chars,nativeCeil(length/stringSize(chars)));return hasUnicode(chars)?castSlice(stringToArray(result),0,length).join(''):result.slice(0,length);}/**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */function createPartial(func,bitmask,thisArg,partials){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var argsIndex=-1,argsLength=arguments.length,leftIndex=-1,leftLength=partials.length,args=Array(leftLength+argsLength),fn=this&&this!==root&&this instanceof wrapper?Ctor:func;while(++leftIndex<leftLength){args[leftIndex]=partials[leftIndex];}while(argsLength--){args[leftIndex++]=arguments[++argsIndex];}return apply(fn,isBind?thisArg:this,args);}return wrapper;}/**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */function createRange(fromRight){return function(start,end,step){if(step&&typeof step!='number'&&isIterateeCall(start,end,step)){end=step=undefined;}// Ensure the sign of `-0` is preserved.
	start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}step=step===undefined?start<end?1:-1:toFinite(step);return baseRange(start,end,step,fromRight);};}/**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */function createRelationalOperation(operator){return function(value,other){if(!(typeof value=='string'&&typeof other=='string')){value=toNumber(value);other=toNumber(other);}return operator(value,other);};}/**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createRecurry(func,bitmask,wrapFunc,placeholder,thisArg,partials,holders,argPos,ary,arity){var isCurry=bitmask&WRAP_CURRY_FLAG,newHolders=isCurry?holders:undefined,newHoldersRight=isCurry?undefined:holders,newPartials=isCurry?partials:undefined,newPartialsRight=isCurry?undefined:partials;bitmask|=isCurry?WRAP_PARTIAL_FLAG:WRAP_PARTIAL_RIGHT_FLAG;bitmask&=~(isCurry?WRAP_PARTIAL_RIGHT_FLAG:WRAP_PARTIAL_FLAG);if(!(bitmask&WRAP_CURRY_BOUND_FLAG)){bitmask&=~(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG);}var newData=[func,bitmask,thisArg,newPartials,newHolders,newPartialsRight,newHoldersRight,argPos,ary,arity];var result=wrapFunc.apply(undefined,newData);if(isLaziable(func)){setData(result,newData);}result.placeholder=placeholder;return setWrapToString(result,func,bitmask);}/**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */function createRound(methodName){var func=Math[methodName];return function(number,precision){number=toNumber(number);precision=precision==null?0:nativeMin(toInteger(precision),292);if(precision&&nativeIsFinite(number)){// Shift with exponential notation to avoid floating-point issues.
	// See [MDN](https://mdn.io/round#Examples) for more details.
	var pair=(toString(number)+'e').split('e'),value=func(pair[0]+'e'+(+pair[1]+precision));pair=(toString(value)+'e').split('e');return+(pair[0]+'e'+(+pair[1]-precision));}return func(number);};}/**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */var createSet=!(Set&&1/setToArray(new Set([,-0]))[1]==INFINITY)?noop:function(values){return new Set(values);};/**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */function createToPairs(keysFunc){return function(object){var tag=getTag(object);if(tag==mapTag){return mapToArray(object);}if(tag==setTag){return setToPairs(object);}return baseToPairs(object,keysFunc(object));};}/**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createWrap(func,bitmask,thisArg,partials,holders,argPos,ary,arity){var isBindKey=bitmask&WRAP_BIND_KEY_FLAG;if(!isBindKey&&typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var length=partials?partials.length:0;if(!length){bitmask&=~(WRAP_PARTIAL_FLAG|WRAP_PARTIAL_RIGHT_FLAG);partials=holders=undefined;}ary=ary===undefined?ary:nativeMax(toInteger(ary),0);arity=arity===undefined?arity:toInteger(arity);length-=holders?holders.length:0;if(bitmask&WRAP_PARTIAL_RIGHT_FLAG){var partialsRight=partials,holdersRight=holders;partials=holders=undefined;}var data=isBindKey?undefined:getData(func);var newData=[func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity];if(data){mergeData(newData,data);}func=newData[0];bitmask=newData[1];thisArg=newData[2];partials=newData[3];holders=newData[4];arity=newData[9]=newData[9]===undefined?isBindKey?0:func.length:nativeMax(newData[9]-length,0);if(!arity&&bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG)){bitmask&=~(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG);}if(!bitmask||bitmask==WRAP_BIND_FLAG){var result=createBind(func,bitmask,thisArg);}else if(bitmask==WRAP_CURRY_FLAG||bitmask==WRAP_CURRY_RIGHT_FLAG){result=createCurry(func,bitmask,arity);}else if((bitmask==WRAP_PARTIAL_FLAG||bitmask==(WRAP_BIND_FLAG|WRAP_PARTIAL_FLAG))&&!holders.length){result=createPartial(func,bitmask,thisArg,partials);}else{result=createHybrid.apply(undefined,newData);}var setter=data?baseSetData:setData;return setWrapToString(setter(result,newData),func,bitmask);}/**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */function customDefaultsAssignIn(objValue,srcValue,key,object){if(objValue===undefined||eq(objValue,objectProto[key])&&!hasOwnProperty.call(object,key)){return srcValue;}return objValue;}/**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */function customDefaultsMerge(objValue,srcValue,key,object,source,stack){if(isObject(objValue)&&isObject(srcValue)){// Recursively merge objects and arrays (susceptible to call stack limits).
	stack.set(srcValue,objValue);baseMerge(objValue,srcValue,undefined,customDefaultsMerge,stack);stack['delete'](srcValue);}return objValue;}/**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */function customOmitClone(value){return isPlainObject(value)?undefined:value;}/**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */function equalArrays(array,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,arrLength=array.length,othLength=other.length;if(arrLength!=othLength&&!(isPartial&&othLength>arrLength)){return false;}// Check that cyclic values are equal.
	var arrStacked=stack.get(array);var othStacked=stack.get(other);if(arrStacked&&othStacked){return arrStacked==other&&othStacked==array;}var index=-1,result=true,seen=bitmask&COMPARE_UNORDERED_FLAG?new SetCache():undefined;stack.set(array,other);stack.set(other,array);// Ignore non-index properties.
	while(++index<arrLength){var arrValue=array[index],othValue=other[index];if(customizer){var compared=isPartial?customizer(othValue,arrValue,index,other,array,stack):customizer(arrValue,othValue,index,array,other,stack);}if(compared!==undefined){if(compared){continue;}result=false;break;}// Recursively compare arrays (susceptible to call stack limits).
	if(seen){if(!arraySome(other,function(othValue,othIndex){if(!cacheHas(seen,othIndex)&&(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){return seen.push(othIndex);}})){result=false;break;}}else if(!(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){result=false;break;}}stack['delete'](array);stack['delete'](other);return result;}/**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */function equalByTag(object,other,tag,bitmask,customizer,equalFunc,stack){switch(tag){case dataViewTag:if(object.byteLength!=other.byteLength||object.byteOffset!=other.byteOffset){return false;}object=object.buffer;other=other.buffer;case arrayBufferTag:if(object.byteLength!=other.byteLength||!equalFunc(new Uint8Array(object),new Uint8Array(other))){return false;}return true;case boolTag:case dateTag:case numberTag:// Coerce booleans to `1` or `0` and dates to milliseconds.
	// Invalid dates are coerced to `NaN`.
	return eq(+object,+other);case errorTag:return object.name==other.name&&object.message==other.message;case regexpTag:case stringTag:// Coerce regexes to strings and treat strings, primitives and objects,
	// as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	// for more details.
	return object==other+'';case mapTag:var convert=mapToArray;case setTag:var isPartial=bitmask&COMPARE_PARTIAL_FLAG;convert||(convert=setToArray);if(object.size!=other.size&&!isPartial){return false;}// Assume cyclic values are equal.
	var stacked=stack.get(object);if(stacked){return stacked==other;}bitmask|=COMPARE_UNORDERED_FLAG;// Recursively compare objects (susceptible to call stack limits).
	stack.set(object,other);var result=equalArrays(convert(object),convert(other),bitmask,customizer,equalFunc,stack);stack['delete'](object);return result;case symbolTag:if(symbolValueOf){return symbolValueOf.call(object)==symbolValueOf.call(other);}}return false;}/**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */function equalObjects(object,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,objProps=getAllKeys(object),objLength=objProps.length,othProps=getAllKeys(other),othLength=othProps.length;if(objLength!=othLength&&!isPartial){return false;}var index=objLength;while(index--){var key=objProps[index];if(!(isPartial?key in other:hasOwnProperty.call(other,key))){return false;}}// Check that cyclic values are equal.
	var objStacked=stack.get(object);var othStacked=stack.get(other);if(objStacked&&othStacked){return objStacked==other&&othStacked==object;}var result=true;stack.set(object,other);stack.set(other,object);var skipCtor=isPartial;while(++index<objLength){key=objProps[index];var objValue=object[key],othValue=other[key];if(customizer){var compared=isPartial?customizer(othValue,objValue,key,other,object,stack):customizer(objValue,othValue,key,object,other,stack);}// Recursively compare objects (susceptible to call stack limits).
	if(!(compared===undefined?objValue===othValue||equalFunc(objValue,othValue,bitmask,customizer,stack):compared)){result=false;break;}skipCtor||(skipCtor=key=='constructor');}if(result&&!skipCtor){var objCtor=object.constructor,othCtor=other.constructor;// Non `Object` object instances with different constructors are not equal.
	if(objCtor!=othCtor&&'constructor'in object&&'constructor'in other&&!(typeof objCtor=='function'&&objCtor instanceof objCtor&&typeof othCtor=='function'&&othCtor instanceof othCtor)){result=false;}}stack['delete'](object);stack['delete'](other);return result;}/**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */function flatRest(func){return setToString(overRest(func,undefined,flatten),func+'');}/**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */function getAllKeys(object){return baseGetAllKeys(object,keys,getSymbols);}/**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */function getAllKeysIn(object){return baseGetAllKeys(object,keysIn,getSymbolsIn);}/**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */var getData=!metaMap?noop:function(func){return metaMap.get(func);};/**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */function getFuncName(func){var result=func.name+'',array=realNames[result],length=hasOwnProperty.call(realNames,result)?array.length:0;while(length--){var data=array[length],otherFunc=data.func;if(otherFunc==null||otherFunc==func){return data.name;}}return result;}/**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */function getHolder(func){var object=hasOwnProperty.call(lodash,'placeholder')?lodash:func;return object.placeholder;}/**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */function getIteratee(){var result=lodash.iteratee||iteratee;result=result===iteratee?baseIteratee:result;return arguments.length?result(arguments[0],arguments[1]):result;}/**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */function getMapData(map,key){var data=map.__data__;return isKeyable(key)?data[typeof key=='string'?'string':'hash']:data.map;}/**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */function getMatchData(object){var result=keys(object),length=result.length;while(length--){var key=result[length],value=object[key];result[length]=[key,value,isStrictComparable(value)];}return result;}/**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */function getNative(object,key){var value=getValue(object,key);return baseIsNative(value)?value:undefined;}/**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */function getRawTag(value){var isOwn=hasOwnProperty.call(value,symToStringTag),tag=value[symToStringTag];try{value[symToStringTag]=undefined;var unmasked=true;}catch(e){}var result=nativeObjectToString.call(value);if(unmasked){if(isOwn){value[symToStringTag]=tag;}else{delete value[symToStringTag];}}return result;}/**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */var getSymbols=!nativeGetSymbols?stubArray:function(object){if(object==null){return[];}object=Object(object);return arrayFilter(nativeGetSymbols(object),function(symbol){return propertyIsEnumerable.call(object,symbol);});};/**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */var getSymbolsIn=!nativeGetSymbols?stubArray:function(object){var result=[];while(object){arrayPush(result,getSymbols(object));object=getPrototype(object);}return result;};/**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */var getTag=baseGetTag;// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if(DataView&&getTag(new DataView(new ArrayBuffer(1)))!=dataViewTag||Map&&getTag(new Map())!=mapTag||Promise&&getTag(Promise.resolve())!=promiseTag||Set&&getTag(new Set())!=setTag||WeakMap&&getTag(new WeakMap())!=weakMapTag){getTag=function getTag(value){var result=baseGetTag(value),Ctor=result==objectTag?value.constructor:undefined,ctorString=Ctor?toSource(Ctor):'';if(ctorString){switch(ctorString){case dataViewCtorString:return dataViewTag;case mapCtorString:return mapTag;case promiseCtorString:return promiseTag;case setCtorString:return setTag;case weakMapCtorString:return weakMapTag;}}return result;};}/**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */function getView(start,end,transforms){var index=-1,length=transforms.length;while(++index<length){var data=transforms[index],size=data.size;switch(data.type){case'drop':start+=size;break;case'dropRight':end-=size;break;case'take':end=nativeMin(end,start+size);break;case'takeRight':start=nativeMax(start,end-size);break;}}return{'start':start,'end':end};}/**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */function getWrapDetails(source){var match=source.match(reWrapDetails);return match?match[1].split(reSplitDetails):[];}/**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */function hasPath(object,path,hasFunc){path=castPath(path,object);var index=-1,length=path.length,result=false;while(++index<length){var key=toKey(path[index]);if(!(result=object!=null&&hasFunc(object,key))){break;}object=object[key];}if(result||++index!=length){return result;}length=object==null?0:object.length;return!!length&&isLength(length)&&isIndex(key,length)&&(isArray(object)||isArguments(object));}/**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */function initCloneArray(array){var length=array.length,result=new array.constructor(length);// Add properties assigned by `RegExp#exec`.
	if(length&&typeof array[0]=='string'&&hasOwnProperty.call(array,'index')){result.index=array.index;result.input=array.input;}return result;}/**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */function initCloneObject(object){return typeof object.constructor=='function'&&!isPrototype(object)?baseCreate(getPrototype(object)):{};}/**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */function initCloneByTag(object,tag,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return cloneArrayBuffer(object);case boolTag:case dateTag:return new Ctor(+object);case dataViewTag:return cloneDataView(object,isDeep);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:return cloneTypedArray(object,isDeep);case mapTag:return new Ctor();case numberTag:case stringTag:return new Ctor(object);case regexpTag:return cloneRegExp(object);case setTag:return new Ctor();case symbolTag:return cloneSymbol(object);}}/**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */function insertWrapDetails(source,details){var length=details.length;if(!length){return source;}var lastIndex=length-1;details[lastIndex]=(length>1?'& ':'')+details[lastIndex];details=details.join(length>2?', ':' ');return source.replace(reWrapComment,'{\n/* [wrapped with '+details+'] */\n');}/**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */function isFlattenable(value){return isArray(value)||isArguments(value)||!!(spreadableSymbol&&value&&value[spreadableSymbol]);}/**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */function isIndex(value,length){var type=typeof value==='undefined'?'undefined':_typeof(value);length=length==null?MAX_SAFE_INTEGER:length;return!!length&&(type=='number'||type!='symbol'&&reIsUint.test(value))&&value>-1&&value%1==0&&value<length;}/**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */function isIterateeCall(value,index,object){if(!isObject(object)){return false;}var type=typeof index==='undefined'?'undefined':_typeof(index);if(type=='number'?isArrayLike(object)&&isIndex(index,object.length):type=='string'&&index in object){return eq(object[index],value);}return false;}/**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */function isKey(value,object){if(isArray(value)){return false;}var type=typeof value==='undefined'?'undefined':_typeof(value);if(type=='number'||type=='symbol'||type=='boolean'||value==null||isSymbol(value)){return true;}return reIsPlainProp.test(value)||!reIsDeepProp.test(value)||object!=null&&value in Object(object);}/**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */function isKeyable(value){var type=typeof value==='undefined'?'undefined':_typeof(value);return type=='string'||type=='number'||type=='symbol'||type=='boolean'?value!=='__proto__':value===null;}/**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */function isLaziable(func){var funcName=getFuncName(func),other=lodash[funcName];if(typeof other!='function'||!(funcName in LazyWrapper.prototype)){return false;}if(func===other){return true;}var data=getData(other);return!!data&&func===data[0];}/**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */function isMasked(func){return!!maskSrcKey&&maskSrcKey in func;}/**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */var isMaskable=coreJsData?isFunction:stubFalse;/**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */function isPrototype(value){var Ctor=value&&value.constructor,proto=typeof Ctor=='function'&&Ctor.prototype||objectProto;return value===proto;}/**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */function isStrictComparable(value){return value===value&&!isObject(value);}/**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */function matchesStrictComparable(key,srcValue){return function(object){if(object==null){return false;}return object[key]===srcValue&&(srcValue!==undefined||key in Object(object));};}/**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */function memoizeCapped(func){var result=memoize(func,function(key){if(cache.size===MAX_MEMOIZE_SIZE){cache.clear();}return key;});var cache=result.cache;return result;}/**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */function mergeData(data,source){var bitmask=data[1],srcBitmask=source[1],newBitmask=bitmask|srcBitmask,isCommon=newBitmask<(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG|WRAP_ARY_FLAG);var isCombo=srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_CURRY_FLAG||srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_REARG_FLAG&&data[7].length<=source[8]||srcBitmask==(WRAP_ARY_FLAG|WRAP_REARG_FLAG)&&source[7].length<=source[8]&&bitmask==WRAP_CURRY_FLAG;// Exit early if metadata can't be merged.
	if(!(isCommon||isCombo)){return data;}// Use source `thisArg` if available.
	if(srcBitmask&WRAP_BIND_FLAG){data[2]=source[2];// Set when currying a bound function.
	newBitmask|=bitmask&WRAP_BIND_FLAG?0:WRAP_CURRY_BOUND_FLAG;}// Compose partial arguments.
	var value=source[3];if(value){var partials=data[3];data[3]=partials?composeArgs(partials,value,source[4]):value;data[4]=partials?replaceHolders(data[3],PLACEHOLDER):source[4];}// Compose partial right arguments.
	value=source[5];if(value){partials=data[5];data[5]=partials?composeArgsRight(partials,value,source[6]):value;data[6]=partials?replaceHolders(data[5],PLACEHOLDER):source[6];}// Use source `argPos` if available.
	value=source[7];if(value){data[7]=value;}// Use source `ary` if it's smaller.
	if(srcBitmask&WRAP_ARY_FLAG){data[8]=data[8]==null?source[8]:nativeMin(data[8],source[8]);}// Use source `arity` if one is not provided.
	if(data[9]==null){data[9]=source[9];}// Use source `func` and merge bitmasks.
	data[0]=source[0];data[1]=newBitmask;return data;}/**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */function nativeKeysIn(object){var result=[];if(object!=null){for(var key in Object(object)){result.push(key);}}return result;}/**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */function objectToString(value){return nativeObjectToString.call(value);}/**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */function overRest(func,start,transform){start=nativeMax(start===undefined?func.length-1:start,0);return function(){var args=arguments,index=-1,length=nativeMax(args.length-start,0),array=Array(length);while(++index<length){array[index]=args[start+index];}index=-1;var otherArgs=Array(start+1);while(++index<start){otherArgs[index]=args[index];}otherArgs[start]=transform(array);return apply(func,this,otherArgs);};}/**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */function parent(object,path){return path.length<2?object:baseGet(object,baseSlice(path,0,-1));}/**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */function reorder(array,indexes){var arrLength=array.length,length=nativeMin(indexes.length,arrLength),oldArray=copyArray(array);while(length--){var index=indexes[length];array[length]=isIndex(index,arrLength)?oldArray[index]:undefined;}return array;}/**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */function safeGet(object,key){if(key==='constructor'&&typeof object[key]==='function'){return;}if(key=='__proto__'){return;}return object[key];}/**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */var setData=shortOut(baseSetData);/**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */var setTimeout=ctxSetTimeout||function(func,wait){return root.setTimeout(func,wait);};/**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */var setToString=shortOut(baseSetToString);/**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */function setWrapToString(wrapper,reference,bitmask){var source=reference+'';return setToString(wrapper,insertWrapDetails(source,updateWrapDetails(getWrapDetails(source),bitmask)));}/**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */function shortOut(func){var count=0,lastCalled=0;return function(){var stamp=nativeNow(),remaining=HOT_SPAN-(stamp-lastCalled);lastCalled=stamp;if(remaining>0){if(++count>=HOT_COUNT){return arguments[0];}}else{count=0;}return func.apply(undefined,arguments);};}/**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */function shuffleSelf(array,size){var index=-1,length=array.length,lastIndex=length-1;size=size===undefined?length:size;while(++index<size){var rand=baseRandom(index,lastIndex),value=array[rand];array[rand]=array[index];array[index]=value;}array.length=size;return array;}/**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */var stringToPath=memoizeCapped(function(string){var result=[];if(string.charCodeAt(0)===46/* . */){result.push('');}string.replace(rePropName,function(match,number,quote,subString){result.push(quote?subString.replace(reEscapeChar,'$1'):number||match);});return result;});/**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */function toKey(value){if(typeof value=='string'||isSymbol(value)){return value;}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */function toSource(func){if(func!=null){try{return funcToString.call(func);}catch(e){}try{return func+'';}catch(e){}}return'';}/**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */function updateWrapDetails(details,bitmask){arrayEach(wrapFlags,function(pair){var value='_.'+pair[0];if(bitmask&pair[1]&&!arrayIncludes(details,value)){details.push(value);}});return details.sort();}/**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */function wrapperClone(wrapper){if(wrapper instanceof LazyWrapper){return wrapper.clone();}var result=new LodashWrapper(wrapper.__wrapped__,wrapper.__chain__);result.__actions__=copyArray(wrapper.__actions__);result.__index__=wrapper.__index__;result.__values__=wrapper.__values__;return result;}/*------------------------------------------------------------------------*//**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */function chunk(array,size,guard){if(guard?isIterateeCall(array,size,guard):size===undefined){size=1;}else{size=nativeMax(toInteger(size),0);}var length=array==null?0:array.length;if(!length||size<1){return[];}var index=0,resIndex=0,result=Array(nativeCeil(length/size));while(index<length){result[resIndex++]=baseSlice(array,index,index+=size);}return result;}/**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */function compact(array){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value){result[resIndex++]=value;}}return result;}/**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */function concat(){var length=arguments.length;if(!length){return[];}var args=Array(length-1),array=arguments[0],index=length;while(index--){args[index-1]=arguments[index];}return arrayPush(isArray(array)?copyArray(array):[array],baseFlatten(args,1));}/**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */var difference=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true)):[];});/**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */var differenceBy=baseRest(function(array,values){var iteratee=last(values);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),getIteratee(iteratee,2)):[];});/**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */var differenceWith=baseRest(function(array,values){var comparator=last(values);if(isArrayLikeObject(comparator)){comparator=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),undefined,comparator):[];});/**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */function drop(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,n<0?0:n,length);}/**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */function dropRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,0,n<0?0:n);}/**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */function dropRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true,true):[];}/**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */function dropWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true):[];}/**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */function fill(array,value,start,end){var length=array==null?0:array.length;if(!length){return[];}if(start&&typeof start!='number'&&isIterateeCall(array,value,start)){start=0;end=length;}return baseFill(array,value,start,end);}/**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */function findIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseFindIndex(array,getIteratee(predicate,3),index);}/**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */function findLastIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length-1;if(fromIndex!==undefined){index=toInteger(fromIndex);index=fromIndex<0?nativeMax(length+index,0):nativeMin(index,length-1);}return baseFindIndex(array,getIteratee(predicate,3),index,true);}/**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */function flatten(array){var length=array==null?0:array.length;return length?baseFlatten(array,1):[];}/**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */function flattenDeep(array){var length=array==null?0:array.length;return length?baseFlatten(array,INFINITY):[];}/**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */function flattenDepth(array,depth){var length=array==null?0:array.length;if(!length){return[];}depth=depth===undefined?1:toInteger(depth);return baseFlatten(array,depth);}/**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */function fromPairs(pairs){var index=-1,length=pairs==null?0:pairs.length,result={};while(++index<length){var pair=pairs[index];result[pair[0]]=pair[1];}return result;}/**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */function head(array){return array&&array.length?array[0]:undefined;}/**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */function indexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseIndexOf(array,value,index);}/**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */function initial(array){var length=array==null?0:array.length;return length?baseSlice(array,0,-1):[];}/**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */var intersection=baseRest(function(arrays){var mapped=arrayMap(arrays,castArrayLikeObject);return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped):[];});/**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */var intersectionBy=baseRest(function(arrays){var iteratee=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);if(iteratee===last(mapped)){iteratee=undefined;}else{mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,getIteratee(iteratee,2)):[];});/**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */var intersectionWith=baseRest(function(arrays){var comparator=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);comparator=typeof comparator=='function'?comparator:undefined;if(comparator){mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,undefined,comparator):[];});/**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */function join(array,separator){return array==null?'':nativeJoin.call(array,separator);}/**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */function last(array){var length=array==null?0:array.length;return length?array[length-1]:undefined;}/**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */function lastIndexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length;if(fromIndex!==undefined){index=toInteger(fromIndex);index=index<0?nativeMax(length+index,0):nativeMin(index,length-1);}return value===value?strictLastIndexOf(array,value,index):baseFindIndex(array,baseIsNaN,index,true);}/**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */function nth(array,n){return array&&array.length?baseNth(array,toInteger(n)):undefined;}/**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */var pull=baseRest(pullAll);/**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */function pullAll(array,values){return array&&array.length&&values&&values.length?basePullAll(array,values):array;}/**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */function pullAllBy(array,values,iteratee){return array&&array.length&&values&&values.length?basePullAll(array,values,getIteratee(iteratee,2)):array;}/**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */function pullAllWith(array,values,comparator){return array&&array.length&&values&&values.length?basePullAll(array,values,undefined,comparator):array;}/**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */var pullAt=flatRest(function(array,indexes){var length=array==null?0:array.length,result=baseAt(array,indexes);basePullAt(array,arrayMap(indexes,function(index){return isIndex(index,length)?+index:index;}).sort(compareAscending));return result;});/**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */function remove(array,predicate){var result=[];if(!(array&&array.length)){return result;}var index=-1,indexes=[],length=array.length;predicate=getIteratee(predicate,3);while(++index<length){var value=array[index];if(predicate(value,index,array)){result.push(value);indexes.push(index);}}basePullAt(array,indexes);return result;}/**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */function reverse(array){return array==null?array:nativeReverse.call(array);}/**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */function slice(array,start,end){var length=array==null?0:array.length;if(!length){return[];}if(end&&typeof end!='number'&&isIterateeCall(array,start,end)){start=0;end=length;}else{start=start==null?0:toInteger(start);end=end===undefined?length:toInteger(end);}return baseSlice(array,start,end);}/**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */function sortedIndex(array,value){return baseSortedIndex(array,value);}/**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */function sortedIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2));}/**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */function sortedIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value);if(index<length&&eq(array[index],value)){return index;}}return-1;}/**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */function sortedLastIndex(array,value){return baseSortedIndex(array,value,true);}/**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */function sortedLastIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2),true);}/**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */function sortedLastIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value,true)-1;if(eq(array[index],value)){return index;}}return-1;}/**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */function sortedUniq(array){return array&&array.length?baseSortedUniq(array):[];}/**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */function sortedUniqBy(array,iteratee){return array&&array.length?baseSortedUniq(array,getIteratee(iteratee,2)):[];}/**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */function tail(array){var length=array==null?0:array.length;return length?baseSlice(array,1,length):[];}/**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */function take(array,n,guard){if(!(array&&array.length)){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,0,n<0?0:n);}/**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */function takeRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,n<0?0:n,length);}/**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */function takeRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),false,true):[];}/**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */function takeWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3)):[];}/**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */var union=baseRest(function(arrays){return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true));});/**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */var unionBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),getIteratee(iteratee,2));});/**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */var unionWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined;return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),undefined,comparator);});/**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */function uniq(array){return array&&array.length?baseUniq(array):[];}/**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */function uniqBy(array,iteratee){return array&&array.length?baseUniq(array,getIteratee(iteratee,2)):[];}/**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */function uniqWith(array,comparator){comparator=typeof comparator=='function'?comparator:undefined;return array&&array.length?baseUniq(array,undefined,comparator):[];}/**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */function unzip(array){if(!(array&&array.length)){return[];}var length=0;array=arrayFilter(array,function(group){if(isArrayLikeObject(group)){length=nativeMax(group.length,length);return true;}});return baseTimes(length,function(index){return arrayMap(array,baseProperty(index));});}/**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */function unzipWith(array,iteratee){if(!(array&&array.length)){return[];}var result=unzip(array);if(iteratee==null){return result;}return arrayMap(result,function(group){return apply(iteratee,undefined,group);});}/**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */var without=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,values):[];});/**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */var xor=baseRest(function(arrays){return baseXor(arrayFilter(arrays,isArrayLikeObject));});/**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */var xorBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseXor(arrayFilter(arrays,isArrayLikeObject),getIteratee(iteratee,2));});/**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */var xorWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined;return baseXor(arrayFilter(arrays,isArrayLikeObject),undefined,comparator);});/**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */var zip=baseRest(unzip);/**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */function zipObject(props,values){return baseZipObject(props||[],values||[],assignValue);}/**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */function zipObjectDeep(props,values){return baseZipObject(props||[],values||[],baseSet);}/**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */var zipWith=baseRest(function(arrays){var length=arrays.length,iteratee=length>1?arrays[length-1]:undefined;iteratee=typeof iteratee=='function'?(arrays.pop(),iteratee):undefined;return unzipWith(arrays,iteratee);});/*------------------------------------------------------------------------*//**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */function chain(value){var result=lodash(value);result.__chain__=true;return result;}/**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */function tap(value,interceptor){interceptor(value);return value;}/**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */function thru(value,interceptor){return interceptor(value);}/**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */var wrapperAt=flatRest(function(paths){var length=paths.length,start=length?paths[0]:0,value=this.__wrapped__,interceptor=function interceptor(object){return baseAt(object,paths);};if(length>1||this.__actions__.length||!(value instanceof LazyWrapper)||!isIndex(start)){return this.thru(interceptor);}value=value.slice(start,+start+(length?1:0));value.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(value,this.__chain__).thru(function(array){if(length&&!array.length){array.push(undefined);}return array;});});/**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */function wrapperChain(){return chain(this);}/**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */function wrapperCommit(){return new LodashWrapper(this.value(),this.__chain__);}/**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */function wrapperNext(){if(this.__values__===undefined){this.__values__=toArray(this.value());}var done=this.__index__>=this.__values__.length,value=done?undefined:this.__values__[this.__index__++];return{'done':done,'value':value};}/**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */function wrapperToIterator(){return this;}/**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */function wrapperPlant(value){var result,parent=this;while(parent instanceof baseLodash){var clone=wrapperClone(parent);clone.__index__=0;clone.__values__=undefined;if(result){previous.__wrapped__=clone;}else{result=clone;}var previous=clone;parent=parent.__wrapped__;}previous.__wrapped__=value;return result;}/**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */function wrapperReverse(){var value=this.__wrapped__;if(value instanceof LazyWrapper){var wrapped=value;if(this.__actions__.length){wrapped=new LazyWrapper(this);}wrapped=wrapped.reverse();wrapped.__actions__.push({'func':thru,'args':[reverse],'thisArg':undefined});return new LodashWrapper(wrapped,this.__chain__);}return this.thru(reverse);}/**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */function wrapperValue(){return baseWrapperValue(this.__wrapped__,this.__actions__);}/*------------------------------------------------------------------------*//**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */var countBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){++result[key];}else{baseAssignValue(result,key,1);}});/**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */function every(collection,predicate,guard){var func=isArray(collection)?arrayEvery:baseEvery;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */function filter(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,getIteratee(predicate,3));}/**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */var find=createFind(findIndex);/**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */var findLast=createFind(findLastIndex);/**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */function flatMap(collection,iteratee){return baseFlatten(map(collection,iteratee),1);}/**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */function flatMapDeep(collection,iteratee){return baseFlatten(map(collection,iteratee),INFINITY);}/**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */function flatMapDepth(collection,iteratee,depth){depth=depth===undefined?1:toInteger(depth);return baseFlatten(map(collection,iteratee),depth);}/**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */function forEach(collection,iteratee){var func=isArray(collection)?arrayEach:baseEach;return func(collection,getIteratee(iteratee,3));}/**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */function forEachRight(collection,iteratee){var func=isArray(collection)?arrayEachRight:baseEachRight;return func(collection,getIteratee(iteratee,3));}/**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */var groupBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){result[key].push(value);}else{baseAssignValue(result,key,[value]);}});/**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */function includes(collection,value,fromIndex,guard){collection=isArrayLike(collection)?collection:values(collection);fromIndex=fromIndex&&!guard?toInteger(fromIndex):0;var length=collection.length;if(fromIndex<0){fromIndex=nativeMax(length+fromIndex,0);}return isString(collection)?fromIndex<=length&&collection.indexOf(value,fromIndex)>-1:!!length&&baseIndexOf(collection,value,fromIndex)>-1;}/**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */var invokeMap=baseRest(function(collection,path,args){var index=-1,isFunc=typeof path=='function',result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value){result[++index]=isFunc?apply(path,value,args):baseInvoke(value,path,args);});return result;});/**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */var keyBy=createAggregator(function(result,value,key){baseAssignValue(result,key,value);});/**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */function map(collection,iteratee){var func=isArray(collection)?arrayMap:baseMap;return func(collection,getIteratee(iteratee,3));}/**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */function orderBy(collection,iteratees,orders,guard){if(collection==null){return[];}if(!isArray(iteratees)){iteratees=iteratees==null?[]:[iteratees];}orders=guard?undefined:orders;if(!isArray(orders)){orders=orders==null?[]:[orders];}return baseOrderBy(collection,iteratees,orders);}/**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */var partition=createAggregator(function(result,value,key){result[key?0:1].push(value);},function(){return[[],[]];});/**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */function reduce(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduce:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEach);}/**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */function reduceRight(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduceRight:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEachRight);}/**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */function reject(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,negate(getIteratee(predicate,3)));}/**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */function sample(collection){var func=isArray(collection)?arraySample:baseSample;return func(collection);}/**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */function sampleSize(collection,n,guard){if(guard?isIterateeCall(collection,n,guard):n===undefined){n=1;}else{n=toInteger(n);}var func=isArray(collection)?arraySampleSize:baseSampleSize;return func(collection,n);}/**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */function shuffle(collection){var func=isArray(collection)?arrayShuffle:baseShuffle;return func(collection);}/**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */function size(collection){if(collection==null){return 0;}if(isArrayLike(collection)){return isString(collection)?stringSize(collection):collection.length;}var tag=getTag(collection);if(tag==mapTag||tag==setTag){return collection.size;}return baseKeys(collection).length;}/**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */function some(collection,predicate,guard){var func=isArray(collection)?arraySome:baseSome;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */var sortBy=baseRest(function(collection,iteratees){if(collection==null){return[];}var length=iteratees.length;if(length>1&&isIterateeCall(collection,iteratees[0],iteratees[1])){iteratees=[];}else if(length>2&&isIterateeCall(iteratees[0],iteratees[1],iteratees[2])){iteratees=[iteratees[0]];}return baseOrderBy(collection,baseFlatten(iteratees,1),[]);});/*------------------------------------------------------------------------*//**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */var now=ctxNow||function(){return root.Date.now();};/*------------------------------------------------------------------------*//**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */function after(n,func){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n<1){return func.apply(this,arguments);}};}/**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */function ary(func,n,guard){n=guard?undefined:n;n=func&&n==null?func.length:n;return createWrap(func,WRAP_ARY_FLAG,undefined,undefined,undefined,undefined,n);}/**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */function before(n,func){var result;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n>0){result=func.apply(this,arguments);}if(n<=1){func=undefined;}return result;};}/**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */var bind=baseRest(function(func,thisArg,partials){var bitmask=WRAP_BIND_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bind));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(func,bitmask,thisArg,partials,holders);});/**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */var bindKey=baseRest(function(object,key,partials){var bitmask=WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bindKey));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(key,bitmask,object,partials,holders);});/**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */function curry(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curry.placeholder;return result;}/**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */function curryRight(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_RIGHT_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curryRight.placeholder;return result;}/**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */function debounce(func,wait,options){var lastArgs,lastThis,maxWait,result,timerId,lastCallTime,lastInvokeTime=0,leading=false,maxing=false,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}wait=toNumber(wait)||0;if(isObject(options)){leading=!!options.leading;maxing='maxWait'in options;maxWait=maxing?nativeMax(toNumber(options.maxWait)||0,wait):maxWait;trailing='trailing'in options?!!options.trailing:trailing;}function invokeFunc(time){var args=lastArgs,thisArg=lastThis;lastArgs=lastThis=undefined;lastInvokeTime=time;result=func.apply(thisArg,args);return result;}function leadingEdge(time){// Reset any `maxWait` timer.
	lastInvokeTime=time;// Start the timer for the trailing edge.
	timerId=setTimeout(timerExpired,wait);// Invoke the leading edge.
	return leading?invokeFunc(time):result;}function remainingWait(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime,timeWaiting=wait-timeSinceLastCall;return maxing?nativeMin(timeWaiting,maxWait-timeSinceLastInvoke):timeWaiting;}function shouldInvoke(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime;// Either this is the first call, activity has stopped and we're at the
	// trailing edge, the system time has gone backwards and we're treating
	// it as the trailing edge, or we've hit the `maxWait` limit.
	return lastCallTime===undefined||timeSinceLastCall>=wait||timeSinceLastCall<0||maxing&&timeSinceLastInvoke>=maxWait;}function timerExpired(){var time=now();if(shouldInvoke(time)){return trailingEdge(time);}// Restart the timer.
	timerId=setTimeout(timerExpired,remainingWait(time));}function trailingEdge(time){timerId=undefined;// Only invoke if we have `lastArgs` which means `func` has been
	// debounced at least once.
	if(trailing&&lastArgs){return invokeFunc(time);}lastArgs=lastThis=undefined;return result;}function cancel(){if(timerId!==undefined){clearTimeout(timerId);}lastInvokeTime=0;lastArgs=lastCallTime=lastThis=timerId=undefined;}function flush(){return timerId===undefined?result:trailingEdge(now());}function debounced(){var time=now(),isInvoking=shouldInvoke(time);lastArgs=arguments;lastThis=this;lastCallTime=time;if(isInvoking){if(timerId===undefined){return leadingEdge(lastCallTime);}if(maxing){// Handle invocations in a tight loop.
	clearTimeout(timerId);timerId=setTimeout(timerExpired,wait);return invokeFunc(lastCallTime);}}if(timerId===undefined){timerId=setTimeout(timerExpired,wait);}return result;}debounced.cancel=cancel;debounced.flush=flush;return debounced;}/**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */var defer=baseRest(function(func,args){return baseDelay(func,1,args);});/**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */var delay=baseRest(function(func,wait,args){return baseDelay(func,toNumber(wait)||0,args);});/**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */function flip(func){return createWrap(func,WRAP_FLIP_FLAG);}/**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */function memoize(func,resolver){if(typeof func!='function'||resolver!=null&&typeof resolver!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var memoized=function memoized(){var args=arguments,key=resolver?resolver.apply(this,args):args[0],cache=memoized.cache;if(cache.has(key)){return cache.get(key);}var result=func.apply(this,args);memoized.cache=cache.set(key,result)||cache;return result;};memoized.cache=new(memoize.Cache||MapCache)();return memoized;}// Expose `MapCache`.
	memoize.Cache=MapCache;/**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */function negate(predicate){if(typeof predicate!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return function(){var args=arguments;switch(args.length){case 0:return!predicate.call(this);case 1:return!predicate.call(this,args[0]);case 2:return!predicate.call(this,args[0],args[1]);case 3:return!predicate.call(this,args[0],args[1],args[2]);}return!predicate.apply(this,args);};}/**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */function once(func){return before(2,func);}/**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */var overArgs=castRest(function(func,transforms){transforms=transforms.length==1&&isArray(transforms[0])?arrayMap(transforms[0],baseUnary(getIteratee())):arrayMap(baseFlatten(transforms,1),baseUnary(getIteratee()));var funcsLength=transforms.length;return baseRest(function(args){var index=-1,length=nativeMin(args.length,funcsLength);while(++index<length){args[index]=transforms[index].call(this,args[index]);}return apply(func,this,args);});});/**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */var partial=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partial));return createWrap(func,WRAP_PARTIAL_FLAG,undefined,partials,holders);});/**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */var partialRight=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partialRight));return createWrap(func,WRAP_PARTIAL_RIGHT_FLAG,undefined,partials,holders);});/**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */var rearg=flatRest(function(func,indexes){return createWrap(func,WRAP_REARG_FLAG,undefined,undefined,undefined,indexes);});/**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */function rest(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start===undefined?start:toInteger(start);return baseRest(func,start);}/**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */function spread(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start==null?0:nativeMax(toInteger(start),0);return baseRest(function(args){var array=args[start],otherArgs=castSlice(args,0,start);if(array){arrayPush(otherArgs,array);}return apply(func,this,otherArgs);});}/**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */function throttle(func,wait,options){var leading=true,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(isObject(options)){leading='leading'in options?!!options.leading:leading;trailing='trailing'in options?!!options.trailing:trailing;}return debounce(func,wait,{'leading':leading,'maxWait':wait,'trailing':trailing});}/**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */function unary(func){return ary(func,1);}/**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */function wrap(value,wrapper){return partial(castFunction(wrapper),value);}/*------------------------------------------------------------------------*//**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */function castArray(){if(!arguments.length){return[];}var value=arguments[0];return isArray(value)?value:[value];}/**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */function clone(value){return baseClone(value,CLONE_SYMBOLS_FLAG);}/**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */function cloneWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseClone(value,CLONE_SYMBOLS_FLAG,customizer);}/**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */function cloneDeep(value){return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG);}/**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */function cloneDeepWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG,customizer);}/**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */function conformsTo(object,source){return source==null||baseConformsTo(object,source,keys(source));}/**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */function eq(value,other){return value===other||value!==value&&other!==other;}/**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */var gt=createRelationalOperation(baseGt);/**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */var gte=createRelationalOperation(function(value,other){return value>=other;});/**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */var isArguments=baseIsArguments(function(){return arguments;}())?baseIsArguments:function(value){return isObjectLike(value)&&hasOwnProperty.call(value,'callee')&&!propertyIsEnumerable.call(value,'callee');};/**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */var isArray=Array.isArray;/**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */var isArrayBuffer=nodeIsArrayBuffer?baseUnary(nodeIsArrayBuffer):baseIsArrayBuffer;/**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */function isArrayLike(value){return value!=null&&isLength(value.length)&&!isFunction(value);}/**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */function isArrayLikeObject(value){return isObjectLike(value)&&isArrayLike(value);}/**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */function isBoolean(value){return value===true||value===false||isObjectLike(value)&&baseGetTag(value)==boolTag;}/**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */var isBuffer=nativeIsBuffer||stubFalse;/**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */var isDate=nodeIsDate?baseUnary(nodeIsDate):baseIsDate;/**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */function isElement(value){return isObjectLike(value)&&value.nodeType===1&&!isPlainObject(value);}/**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */function isEmpty(value){if(value==null){return true;}if(isArrayLike(value)&&(isArray(value)||typeof value=='string'||typeof value.splice=='function'||isBuffer(value)||isTypedArray(value)||isArguments(value))){return!value.length;}var tag=getTag(value);if(tag==mapTag||tag==setTag){return!value.size;}if(isPrototype(value)){return!baseKeys(value).length;}for(var key in value){if(hasOwnProperty.call(value,key)){return false;}}return true;}/**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */function isEqual(value,other){return baseIsEqual(value,other);}/**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */function isEqualWith(value,other,customizer){customizer=typeof customizer=='function'?customizer:undefined;var result=customizer?customizer(value,other):undefined;return result===undefined?baseIsEqual(value,other,undefined,customizer):!!result;}/**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */function isError(value){if(!isObjectLike(value)){return false;}var tag=baseGetTag(value);return tag==errorTag||tag==domExcTag||typeof value.message=='string'&&typeof value.name=='string'&&!isPlainObject(value);}/**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */function isFinite(value){return typeof value=='number'&&nativeIsFinite(value);}/**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */function isFunction(value){if(!isObject(value)){return false;}// The use of `Object#toString` avoids issues with the `typeof` operator
	// in Safari 9 which returns 'object' for typed arrays and other constructors.
	var tag=baseGetTag(value);return tag==funcTag||tag==genTag||tag==asyncTag||tag==proxyTag;}/**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */function isInteger(value){return typeof value=='number'&&value==toInteger(value);}/**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */function isLength(value){return typeof value=='number'&&value>-1&&value%1==0&&value<=MAX_SAFE_INTEGER;}/**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */function isObject(value){var type=typeof value==='undefined'?'undefined':_typeof(value);return value!=null&&(type=='object'||type=='function');}/**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */function isObjectLike(value){return value!=null&&(typeof value==='undefined'?'undefined':_typeof(value))=='object';}/**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */var isMap=nodeIsMap?baseUnary(nodeIsMap):baseIsMap;/**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */function isMatch(object,source){return object===source||baseIsMatch(object,source,getMatchData(source));}/**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */function isMatchWith(object,source,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseIsMatch(object,source,getMatchData(source),customizer);}/**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */function isNaN(value){// An `NaN` primitive is the only value that is not equal to itself.
	// Perform the `toStringTag` check first to avoid errors with some
	// ActiveX objects in IE.
	return isNumber(value)&&value!=+value;}/**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */function isNative(value){if(isMaskable(value)){throw new Error(CORE_ERROR_TEXT);}return baseIsNative(value);}/**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */function isNull(value){return value===null;}/**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */function isNil(value){return value==null;}/**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */function isNumber(value){return typeof value=='number'||isObjectLike(value)&&baseGetTag(value)==numberTag;}/**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */function isPlainObject(value){if(!isObjectLike(value)||baseGetTag(value)!=objectTag){return false;}var proto=getPrototype(value);if(proto===null){return true;}var Ctor=hasOwnProperty.call(proto,'constructor')&&proto.constructor;return typeof Ctor=='function'&&Ctor instanceof Ctor&&funcToString.call(Ctor)==objectCtorString;}/**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */var isRegExp=nodeIsRegExp?baseUnary(nodeIsRegExp):baseIsRegExp;/**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */function isSafeInteger(value){return isInteger(value)&&value>=-MAX_SAFE_INTEGER&&value<=MAX_SAFE_INTEGER;}/**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */var isSet=nodeIsSet?baseUnary(nodeIsSet):baseIsSet;/**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */function isString(value){return typeof value=='string'||!isArray(value)&&isObjectLike(value)&&baseGetTag(value)==stringTag;}/**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */function isSymbol(value){return(typeof value==='undefined'?'undefined':_typeof(value))=='symbol'||isObjectLike(value)&&baseGetTag(value)==symbolTag;}/**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */var isTypedArray=nodeIsTypedArray?baseUnary(nodeIsTypedArray):baseIsTypedArray;/**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */function isUndefined(value){return value===undefined;}/**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */function isWeakMap(value){return isObjectLike(value)&&getTag(value)==weakMapTag;}/**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */function isWeakSet(value){return isObjectLike(value)&&baseGetTag(value)==weakSetTag;}/**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */var lt=createRelationalOperation(baseLt);/**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */var lte=createRelationalOperation(function(value,other){return value<=other;});/**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */function toArray(value){if(!value){return[];}if(isArrayLike(value)){return isString(value)?stringToArray(value):copyArray(value);}if(symIterator&&value[symIterator]){return iteratorToArray(value[symIterator]());}var tag=getTag(value),func=tag==mapTag?mapToArray:tag==setTag?setToArray:values;return func(value);}/**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */function toFinite(value){if(!value){return value===0?value:0;}value=toNumber(value);if(value===INFINITY||value===-INFINITY){var sign=value<0?-1:1;return sign*MAX_INTEGER;}return value===value?value:0;}/**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */function toInteger(value){var result=toFinite(value),remainder=result%1;return result===result?remainder?result-remainder:result:0;}/**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */function toLength(value){return value?baseClamp(toInteger(value),0,MAX_ARRAY_LENGTH):0;}/**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */function toNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}if(isObject(value)){var other=typeof value.valueOf=='function'?value.valueOf():value;value=isObject(other)?other+'':other;}if(typeof value!='string'){return value===0?value:+value;}value=baseTrim(value);var isBinary=reIsBinary.test(value);return isBinary||reIsOctal.test(value)?freeParseInt(value.slice(2),isBinary?2:8):reIsBadHex.test(value)?NAN:+value;}/**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */function toPlainObject(value){return copyObject(value,keysIn(value));}/**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */function toSafeInteger(value){return value?baseClamp(toInteger(value),-MAX_SAFE_INTEGER,MAX_SAFE_INTEGER):value===0?value:0;}/**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */function toString(value){return value==null?'':baseToString(value);}/*------------------------------------------------------------------------*//**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */var assign=createAssigner(function(object,source){if(isPrototype(source)||isArrayLike(source)){copyObject(source,keys(source),object);return;}for(var key in source){if(hasOwnProperty.call(source,key)){assignValue(object,key,source[key]);}}});/**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */var assignIn=createAssigner(function(object,source){copyObject(source,keysIn(source),object);});/**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */var assignInWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keysIn(source),object,customizer);});/**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */var assignWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keys(source),object,customizer);});/**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */var at=flatRest(baseAt);/**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */function create(prototype,properties){var result=baseCreate(prototype);return properties==null?result:baseAssign(result,properties);}/**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */var defaults=baseRest(function(object,sources){object=Object(object);var index=-1;var length=sources.length;var guard=length>2?sources[2]:undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){length=1;}while(++index<length){var source=sources[index];var props=keysIn(source);var propsIndex=-1;var propsLength=props.length;while(++propsIndex<propsLength){var key=props[propsIndex];var value=object[key];if(value===undefined||eq(value,objectProto[key])&&!hasOwnProperty.call(object,key)){object[key]=source[key];}}}return object;});/**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */var defaultsDeep=baseRest(function(args){args.push(undefined,customDefaultsMerge);return apply(mergeWith,undefined,args);});/**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */function findKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwn);}/**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */function findLastKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwnRight);}/**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */function forIn(object,iteratee){return object==null?object:baseFor(object,getIteratee(iteratee,3),keysIn);}/**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */function forInRight(object,iteratee){return object==null?object:baseForRight(object,getIteratee(iteratee,3),keysIn);}/**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */function forOwn(object,iteratee){return object&&baseForOwn(object,getIteratee(iteratee,3));}/**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */function forOwnRight(object,iteratee){return object&&baseForOwnRight(object,getIteratee(iteratee,3));}/**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */function functions(object){return object==null?[]:baseFunctions(object,keys(object));}/**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */function functionsIn(object){return object==null?[]:baseFunctions(object,keysIn(object));}/**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */function get(object,path,defaultValue){var result=object==null?undefined:baseGet(object,path);return result===undefined?defaultValue:result;}/**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */function has(object,path){return object!=null&&hasPath(object,path,baseHas);}/**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */function hasIn(object,path){return object!=null&&hasPath(object,path,baseHasIn);}/**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */var invert=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!='function'){value=nativeObjectToString.call(value);}result[value]=key;},constant(identity));/**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */var invertBy=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!='function'){value=nativeObjectToString.call(value);}if(hasOwnProperty.call(result,value)){result[value].push(key);}else{result[value]=[key];}},getIteratee);/**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */var invoke=baseRest(baseInvoke);/**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */function keys(object){return isArrayLike(object)?arrayLikeKeys(object):baseKeys(object);}/**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */function keysIn(object){return isArrayLike(object)?arrayLikeKeys(object,true):baseKeysIn(object);}/**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */function mapKeys(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,iteratee(value,key,object),value);});return result;}/**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */function mapValues(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,key,iteratee(value,key,object));});return result;}/**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */var merge=createAssigner(function(object,source,srcIndex){baseMerge(object,source,srcIndex);});/**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */var mergeWith=createAssigner(function(object,source,srcIndex,customizer){baseMerge(object,source,srcIndex,customizer);});/**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */var omit=flatRest(function(object,paths){var result={};if(object==null){return result;}var isDeep=false;paths=arrayMap(paths,function(path){path=castPath(path,object);isDeep||(isDeep=path.length>1);return path;});copyObject(object,getAllKeysIn(object),result);if(isDeep){result=baseClone(result,CLONE_DEEP_FLAG|CLONE_FLAT_FLAG|CLONE_SYMBOLS_FLAG,customOmitClone);}var length=paths.length;while(length--){baseUnset(result,paths[length]);}return result;});/**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */function omitBy(object,predicate){return pickBy(object,negate(getIteratee(predicate)));}/**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */var pick=flatRest(function(object,paths){return object==null?{}:basePick(object,paths);});/**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */function pickBy(object,predicate){if(object==null){return{};}var props=arrayMap(getAllKeysIn(object),function(prop){return[prop];});predicate=getIteratee(predicate);return basePickBy(object,props,function(value,path){return predicate(value,path[0]);});}/**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */function result(object,path,defaultValue){path=castPath(path,object);var index=-1,length=path.length;// Ensure the loop is entered when path is empty.
	if(!length){length=1;object=undefined;}while(++index<length){var value=object==null?undefined:object[toKey(path[index])];if(value===undefined){index=length;value=defaultValue;}object=isFunction(value)?value.call(object):value;}return object;}/**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */function set(object,path,value){return object==null?object:baseSet(object,path,value);}/**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */function setWith(object,path,value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseSet(object,path,value,customizer);}/**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */var toPairs=createToPairs(keys);/**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */var toPairsIn=createToPairs(keysIn);/**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */function transform(object,iteratee,accumulator){var isArr=isArray(object),isArrLike=isArr||isBuffer(object)||isTypedArray(object);iteratee=getIteratee(iteratee,4);if(accumulator==null){var Ctor=object&&object.constructor;if(isArrLike){accumulator=isArr?new Ctor():[];}else if(isObject(object)){accumulator=isFunction(Ctor)?baseCreate(getPrototype(object)):{};}else{accumulator={};}}(isArrLike?arrayEach:baseForOwn)(object,function(value,index,object){return iteratee(accumulator,value,index,object);});return accumulator;}/**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */function unset(object,path){return object==null?true:baseUnset(object,path);}/**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */function update(object,path,updater){return object==null?object:baseUpdate(object,path,castFunction(updater));}/**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */function updateWith(object,path,updater,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseUpdate(object,path,castFunction(updater),customizer);}/**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */function values(object){return object==null?[]:baseValues(object,keys(object));}/**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */function valuesIn(object){return object==null?[]:baseValues(object,keysIn(object));}/*------------------------------------------------------------------------*//**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */function clamp(number,lower,upper){if(upper===undefined){upper=lower;lower=undefined;}if(upper!==undefined){upper=toNumber(upper);upper=upper===upper?upper:0;}if(lower!==undefined){lower=toNumber(lower);lower=lower===lower?lower:0;}return baseClamp(toNumber(number),lower,upper);}/**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */function inRange(number,start,end){start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}number=toNumber(number);return baseInRange(number,start,end);}/**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */function random(lower,upper,floating){if(floating&&typeof floating!='boolean'&&isIterateeCall(lower,upper,floating)){upper=floating=undefined;}if(floating===undefined){if(typeof upper=='boolean'){floating=upper;upper=undefined;}else if(typeof lower=='boolean'){floating=lower;lower=undefined;}}if(lower===undefined&&upper===undefined){lower=0;upper=1;}else{lower=toFinite(lower);if(upper===undefined){upper=lower;lower=0;}else{upper=toFinite(upper);}}if(lower>upper){var temp=lower;lower=upper;upper=temp;}if(floating||lower%1||upper%1){var rand=nativeRandom();return nativeMin(lower+rand*(upper-lower+freeParseFloat('1e-'+((rand+'').length-1))),upper);}return baseRandom(lower,upper);}/*------------------------------------------------------------------------*//**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */var camelCase=createCompounder(function(result,word,index){word=word.toLowerCase();return result+(index?capitalize(word):word);});/**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */function capitalize(string){return upperFirst(toString(string).toLowerCase());}/**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */function deburr(string){string=toString(string);return string&&string.replace(reLatin,deburrLetter).replace(reComboMark,'');}/**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */function endsWith(string,target,position){string=toString(string);target=baseToString(target);var length=string.length;position=position===undefined?length:baseClamp(toInteger(position),0,length);var end=position;position-=target.length;return position>=0&&string.slice(position,end)==target;}/**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */function escape(string){string=toString(string);return string&&reHasUnescapedHtml.test(string)?string.replace(reUnescapedHtml,escapeHtmlChar):string;}/**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */function escapeRegExp(string){string=toString(string);return string&&reHasRegExpChar.test(string)?string.replace(reRegExpChar,'\\$&'):string;}/**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */var kebabCase=createCompounder(function(result,word,index){return result+(index?'-':'')+word.toLowerCase();});/**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */var lowerCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toLowerCase();});/**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */var lowerFirst=createCaseFirst('toLowerCase');/**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */function pad(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;if(!length||strLength>=length){return string;}var mid=(length-strLength)/2;return createPadding(nativeFloor(mid),chars)+string+createPadding(nativeCeil(mid),chars);}/**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */function padEnd(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?string+createPadding(length-strLength,chars):string;}/**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */function padStart(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?createPadding(length-strLength,chars)+string:string;}/**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */function parseInt(string,radix,guard){if(guard||radix==null){radix=0;}else if(radix){radix=+radix;}return nativeParseInt(toString(string).replace(reTrimStart,''),radix||0);}/**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */function repeat(string,n,guard){if(guard?isIterateeCall(string,n,guard):n===undefined){n=1;}else{n=toInteger(n);}return baseRepeat(toString(string),n);}/**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */function replace(){var args=arguments,string=toString(args[0]);return args.length<3?string:string.replace(args[1],args[2]);}/**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */var snakeCase=createCompounder(function(result,word,index){return result+(index?'_':'')+word.toLowerCase();});/**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */function split(string,separator,limit){if(limit&&typeof limit!='number'&&isIterateeCall(string,separator,limit)){separator=limit=undefined;}limit=limit===undefined?MAX_ARRAY_LENGTH:limit>>>0;if(!limit){return[];}string=toString(string);if(string&&(typeof separator=='string'||separator!=null&&!isRegExp(separator))){separator=baseToString(separator);if(!separator&&hasUnicode(string)){return castSlice(stringToArray(string),0,limit);}}return string.split(separator,limit);}/**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */var startCase=createCompounder(function(result,word,index){return result+(index?' ':'')+upperFirst(word);});/**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */function startsWith(string,target,position){string=toString(string);position=position==null?0:baseClamp(toInteger(position),0,string.length);target=baseToString(target);return string.slice(position,position+target.length)==target;}/**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */function template(string,options,guard){// Based on John Resig's `tmpl` implementation
	// (http://ejohn.org/blog/javascript-micro-templating/)
	// and Laura Doktorova's doT.js (https://github.com/olado/doT).
	var settings=lodash.templateSettings;if(guard&&isIterateeCall(string,options,guard)){options=undefined;}string=toString(string);options=assignInWith({},options,settings,customDefaultsAssignIn);var imports=assignInWith({},options.imports,settings.imports,customDefaultsAssignIn),importsKeys=keys(imports),importsValues=baseValues(imports,importsKeys);var isEscaping,isEvaluating,index=0,interpolate=options.interpolate||reNoMatch,source="__p += '";// Compile the regexp to match each delimiter.
	var reDelimiters=RegExp((options.escape||reNoMatch).source+'|'+interpolate.source+'|'+(interpolate===reInterpolate?reEsTemplate:reNoMatch).source+'|'+(options.evaluate||reNoMatch).source+'|$','g');// Use a sourceURL for easier debugging.
	// The sourceURL gets injected into the source that's eval-ed, so be careful
	// to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	// and escape the comment, thus injecting code that gets evaled.
	var sourceURL='//# sourceURL='+(hasOwnProperty.call(options,'sourceURL')?(options.sourceURL+'').replace(/\s/g,' '):'lodash.templateSources['+ ++templateCounter+']')+'\n';string.replace(reDelimiters,function(match,escapeValue,interpolateValue,esTemplateValue,evaluateValue,offset){interpolateValue||(interpolateValue=esTemplateValue);// Escape characters that can't be included in string literals.
	source+=string.slice(index,offset).replace(reUnescapedString,escapeStringChar);// Replace delimiters with snippets.
	if(escapeValue){isEscaping=true;source+="' +\n__e("+escapeValue+") +\n'";}if(evaluateValue){isEvaluating=true;source+="';\n"+evaluateValue+";\n__p += '";}if(interpolateValue){source+="' +\n((__t = ("+interpolateValue+")) == null ? '' : __t) +\n'";}index=offset+match.length;// The JS engine embedded in Adobe products needs `match` returned in
	// order to produce the correct `offset` value.
	return match;});source+="';\n";// If `variable` is not specified wrap a with-statement around the generated
	// code to add the data object to the top of the scope chain.
	var variable=hasOwnProperty.call(options,'variable')&&options.variable;if(!variable){source='with (obj) {\n'+source+'\n}\n';}// Throw an error if a forbidden character was found in `variable`, to prevent
	// potential command injection attacks.
	else if(reForbiddenIdentifierChars.test(variable)){throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);}// Cleanup code by stripping empty strings.
	source=(isEvaluating?source.replace(reEmptyStringLeading,''):source).replace(reEmptyStringMiddle,'$1').replace(reEmptyStringTrailing,'$1;');// Frame code as the function body.
	source='function('+(variable||'obj')+') {\n'+(variable?'':'obj || (obj = {});\n')+"var __t, __p = ''"+(isEscaping?', __e = _.escape':'')+(isEvaluating?', __j = Array.prototype.join;\n'+"function print() { __p += __j.call(arguments, '') }\n":';\n')+source+'return __p\n}';var result=attempt(function(){return Function(importsKeys,sourceURL+'return '+source).apply(undefined,importsValues);});// Provide the compiled function's source by its `toString` method or
	// the `source` property as a convenience for inlining compiled templates.
	result.source=source;if(isError(result)){throw result;}return result;}/**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */function toLower(value){return toString(value).toLowerCase();}/**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */function toUpper(value){return toString(value).toUpperCase();}/**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */function trim(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return baseTrim(string);}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),chrSymbols=stringToArray(chars),start=charsStartIndex(strSymbols,chrSymbols),end=charsEndIndex(strSymbols,chrSymbols)+1;return castSlice(strSymbols,start,end).join('');}/**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */function trimEnd(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.slice(0,trimmedEndIndex(string)+1);}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),end=charsEndIndex(strSymbols,stringToArray(chars))+1;return castSlice(strSymbols,0,end).join('');}/**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */function trimStart(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimStart,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),start=charsStartIndex(strSymbols,stringToArray(chars));return castSlice(strSymbols,start).join('');}/**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */function truncate(string,options){var length=DEFAULT_TRUNC_LENGTH,omission=DEFAULT_TRUNC_OMISSION;if(isObject(options)){var separator='separator'in options?options.separator:separator;length='length'in options?toInteger(options.length):length;omission='omission'in options?baseToString(options.omission):omission;}string=toString(string);var strLength=string.length;if(hasUnicode(string)){var strSymbols=stringToArray(string);strLength=strSymbols.length;}if(length>=strLength){return string;}var end=length-stringSize(omission);if(end<1){return omission;}var result=strSymbols?castSlice(strSymbols,0,end).join(''):string.slice(0,end);if(separator===undefined){return result+omission;}if(strSymbols){end+=result.length-end;}if(isRegExp(separator)){if(string.slice(end).search(separator)){var match,substring=result;if(!separator.global){separator=RegExp(separator.source,toString(reFlags.exec(separator))+'g');}separator.lastIndex=0;while(match=separator.exec(substring)){var newEnd=match.index;}result=result.slice(0,newEnd===undefined?end:newEnd);}}else if(string.indexOf(baseToString(separator),end)!=end){var index=result.lastIndexOf(separator);if(index>-1){result=result.slice(0,index);}}return result+omission;}/**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */function unescape(string){string=toString(string);return string&&reHasEscapedHtml.test(string)?string.replace(reEscapedHtml,unescapeHtmlChar):string;}/**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */var upperCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toUpperCase();});/**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */var upperFirst=createCaseFirst('toUpperCase');/**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */function words(string,pattern,guard){string=toString(string);pattern=guard?undefined:pattern;if(pattern===undefined){return hasUnicodeWord(string)?unicodeWords(string):asciiWords(string);}return string.match(pattern)||[];}/*------------------------------------------------------------------------*//**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */var attempt=baseRest(function(func,args){try{return apply(func,undefined,args);}catch(e){return isError(e)?e:new Error(e);}});/**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */var bindAll=flatRest(function(object,methodNames){arrayEach(methodNames,function(key){key=toKey(key);baseAssignValue(object,key,bind(object[key],object));});return object;});/**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */function cond(pairs){var length=pairs==null?0:pairs.length,toIteratee=getIteratee();pairs=!length?[]:arrayMap(pairs,function(pair){if(typeof pair[1]!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return[toIteratee(pair[0]),pair[1]];});return baseRest(function(args){var index=-1;while(++index<length){var pair=pairs[index];if(apply(pair[0],this,args)){return apply(pair[1],this,args);}}});}/**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */function conforms(source){return baseConforms(baseClone(source,CLONE_DEEP_FLAG));}/**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */function constant(value){return function(){return value;};}/**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */function defaultTo(value,defaultValue){return value==null||value!==value?defaultValue:value;}/**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */var flow=createFlow();/**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */var flowRight=createFlow(true);/**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */function identity(value){return value;}/**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */function iteratee(func){return baseIteratee(typeof func=='function'?func:baseClone(func,CLONE_DEEP_FLAG));}/**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */function matches(source){return baseMatches(baseClone(source,CLONE_DEEP_FLAG));}/**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */function matchesProperty(path,srcValue){return baseMatchesProperty(path,baseClone(srcValue,CLONE_DEEP_FLAG));}/**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */var method=baseRest(function(path,args){return function(object){return baseInvoke(object,path,args);};});/**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */var methodOf=baseRest(function(object,args){return function(path){return baseInvoke(object,path,args);};});/**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */function mixin(object,source,options){var props=keys(source),methodNames=baseFunctions(source,props);if(options==null&&!(isObject(source)&&(methodNames.length||!props.length))){options=source;source=object;object=this;methodNames=baseFunctions(source,keys(source));}var chain=!(isObject(options)&&'chain'in options)||!!options.chain,isFunc=isFunction(object);arrayEach(methodNames,function(methodName){var func=source[methodName];object[methodName]=func;if(isFunc){object.prototype[methodName]=function(){var chainAll=this.__chain__;if(chain||chainAll){var result=object(this.__wrapped__),actions=result.__actions__=copyArray(this.__actions__);actions.push({'func':func,'args':arguments,'thisArg':object});result.__chain__=chainAll;return result;}return func.apply(object,arrayPush([this.value()],arguments));};}});return object;}/**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */function noConflict(){if(root._===this){root._=oldDash;}return this;}/**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */function noop(){}// No operation performed.
	/**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */function nthArg(n){n=toInteger(n);return baseRest(function(args){return baseNth(args,n);});}/**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */var over=createOver(arrayMap);/**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */var overEvery=createOver(arrayEvery);/**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */var overSome=createOver(arraySome);/**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */function property(path){return isKey(path)?baseProperty(toKey(path)):basePropertyDeep(path);}/**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */function propertyOf(object){return function(path){return object==null?undefined:baseGet(object,path);};}/**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */var range=createRange();/**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */var rangeRight=createRange(true);/**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */function stubArray(){return[];}/**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */function stubFalse(){return false;}/**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */function stubObject(){return{};}/**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */function stubString(){return'';}/**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */function stubTrue(){return true;}/**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */function times(n,iteratee){n=toInteger(n);if(n<1||n>MAX_SAFE_INTEGER){return[];}var index=MAX_ARRAY_LENGTH,length=nativeMin(n,MAX_ARRAY_LENGTH);iteratee=getIteratee(iteratee);n-=MAX_ARRAY_LENGTH;var result=baseTimes(length,iteratee);while(++index<n){iteratee(index);}return result;}/**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */function toPath(value){if(isArray(value)){return arrayMap(value,toKey);}return isSymbol(value)?[value]:copyArray(stringToPath(toString(value)));}/**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */function uniqueId(prefix){var id=++idCounter;return toString(prefix)+id;}/*------------------------------------------------------------------------*//**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */var add=createMathOperation(function(augend,addend){return augend+addend;},0);/**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */var ceil=createRound('ceil');/**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */var divide=createMathOperation(function(dividend,divisor){return dividend/divisor;},1);/**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */var floor=createRound('floor');/**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */function max(array){return array&&array.length?baseExtremum(array,identity,baseGt):undefined;}/**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */function maxBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseGt):undefined;}/**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */function mean(array){return baseMean(array,identity);}/**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */function meanBy(array,iteratee){return baseMean(array,getIteratee(iteratee,2));}/**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */function min(array){return array&&array.length?baseExtremum(array,identity,baseLt):undefined;}/**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */function minBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseLt):undefined;}/**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */var multiply=createMathOperation(function(multiplier,multiplicand){return multiplier*multiplicand;},1);/**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */var round=createRound('round');/**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */var subtract=createMathOperation(function(minuend,subtrahend){return minuend-subtrahend;},0);/**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */function sum(array){return array&&array.length?baseSum(array,identity):0;}/**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */function sumBy(array,iteratee){return array&&array.length?baseSum(array,getIteratee(iteratee,2)):0;}/*------------------------------------------------------------------------*/// Add methods that return wrapped values in chain sequences.
	lodash.after=after;lodash.ary=ary;lodash.assign=assign;lodash.assignIn=assignIn;lodash.assignInWith=assignInWith;lodash.assignWith=assignWith;lodash.at=at;lodash.before=before;lodash.bind=bind;lodash.bindAll=bindAll;lodash.bindKey=bindKey;lodash.castArray=castArray;lodash.chain=chain;lodash.chunk=chunk;lodash.compact=compact;lodash.concat=concat;lodash.cond=cond;lodash.conforms=conforms;lodash.constant=constant;lodash.countBy=countBy;lodash.create=create;lodash.curry=curry;lodash.curryRight=curryRight;lodash.debounce=debounce;lodash.defaults=defaults;lodash.defaultsDeep=defaultsDeep;lodash.defer=defer;lodash.delay=delay;lodash.difference=difference;lodash.differenceBy=differenceBy;lodash.differenceWith=differenceWith;lodash.drop=drop;lodash.dropRight=dropRight;lodash.dropRightWhile=dropRightWhile;lodash.dropWhile=dropWhile;lodash.fill=fill;lodash.filter=filter;lodash.flatMap=flatMap;lodash.flatMapDeep=flatMapDeep;lodash.flatMapDepth=flatMapDepth;lodash.flatten=flatten;lodash.flattenDeep=flattenDeep;lodash.flattenDepth=flattenDepth;lodash.flip=flip;lodash.flow=flow;lodash.flowRight=flowRight;lodash.fromPairs=fromPairs;lodash.functions=functions;lodash.functionsIn=functionsIn;lodash.groupBy=groupBy;lodash.initial=initial;lodash.intersection=intersection;lodash.intersectionBy=intersectionBy;lodash.intersectionWith=intersectionWith;lodash.invert=invert;lodash.invertBy=invertBy;lodash.invokeMap=invokeMap;lodash.iteratee=iteratee;lodash.keyBy=keyBy;lodash.keys=keys;lodash.keysIn=keysIn;lodash.map=map;lodash.mapKeys=mapKeys;lodash.mapValues=mapValues;lodash.matches=matches;lodash.matchesProperty=matchesProperty;lodash.memoize=memoize;lodash.merge=merge;lodash.mergeWith=mergeWith;lodash.method=method;lodash.methodOf=methodOf;lodash.mixin=mixin;lodash.negate=negate;lodash.nthArg=nthArg;lodash.omit=omit;lodash.omitBy=omitBy;lodash.once=once;lodash.orderBy=orderBy;lodash.over=over;lodash.overArgs=overArgs;lodash.overEvery=overEvery;lodash.overSome=overSome;lodash.partial=partial;lodash.partialRight=partialRight;lodash.partition=partition;lodash.pick=pick;lodash.pickBy=pickBy;lodash.property=property;lodash.propertyOf=propertyOf;lodash.pull=pull;lodash.pullAll=pullAll;lodash.pullAllBy=pullAllBy;lodash.pullAllWith=pullAllWith;lodash.pullAt=pullAt;lodash.range=range;lodash.rangeRight=rangeRight;lodash.rearg=rearg;lodash.reject=reject;lodash.remove=remove;lodash.rest=rest;lodash.reverse=reverse;lodash.sampleSize=sampleSize;lodash.set=set;lodash.setWith=setWith;lodash.shuffle=shuffle;lodash.slice=slice;lodash.sortBy=sortBy;lodash.sortedUniq=sortedUniq;lodash.sortedUniqBy=sortedUniqBy;lodash.split=split;lodash.spread=spread;lodash.tail=tail;lodash.take=take;lodash.takeRight=takeRight;lodash.takeRightWhile=takeRightWhile;lodash.takeWhile=takeWhile;lodash.tap=tap;lodash.throttle=throttle;lodash.thru=thru;lodash.toArray=toArray;lodash.toPairs=toPairs;lodash.toPairsIn=toPairsIn;lodash.toPath=toPath;lodash.toPlainObject=toPlainObject;lodash.transform=transform;lodash.unary=unary;lodash.union=union;lodash.unionBy=unionBy;lodash.unionWith=unionWith;lodash.uniq=uniq;lodash.uniqBy=uniqBy;lodash.uniqWith=uniqWith;lodash.unset=unset;lodash.unzip=unzip;lodash.unzipWith=unzipWith;lodash.update=update;lodash.updateWith=updateWith;lodash.values=values;lodash.valuesIn=valuesIn;lodash.without=without;lodash.words=words;lodash.wrap=wrap;lodash.xor=xor;lodash.xorBy=xorBy;lodash.xorWith=xorWith;lodash.zip=zip;lodash.zipObject=zipObject;lodash.zipObjectDeep=zipObjectDeep;lodash.zipWith=zipWith;// Add aliases.
	lodash.entries=toPairs;lodash.entriesIn=toPairsIn;lodash.extend=assignIn;lodash.extendWith=assignInWith;// Add methods to `lodash.prototype`.
	mixin(lodash,lodash);/*------------------------------------------------------------------------*/// Add methods that return unwrapped values in chain sequences.
	lodash.add=add;lodash.attempt=attempt;lodash.camelCase=camelCase;lodash.capitalize=capitalize;lodash.ceil=ceil;lodash.clamp=clamp;lodash.clone=clone;lodash.cloneDeep=cloneDeep;lodash.cloneDeepWith=cloneDeepWith;lodash.cloneWith=cloneWith;lodash.conformsTo=conformsTo;lodash.deburr=deburr;lodash.defaultTo=defaultTo;lodash.divide=divide;lodash.endsWith=endsWith;lodash.eq=eq;lodash.escape=escape;lodash.escapeRegExp=escapeRegExp;lodash.every=every;lodash.find=find;lodash.findIndex=findIndex;lodash.findKey=findKey;lodash.findLast=findLast;lodash.findLastIndex=findLastIndex;lodash.findLastKey=findLastKey;lodash.floor=floor;lodash.forEach=forEach;lodash.forEachRight=forEachRight;lodash.forIn=forIn;lodash.forInRight=forInRight;lodash.forOwn=forOwn;lodash.forOwnRight=forOwnRight;lodash.get=get;lodash.gt=gt;lodash.gte=gte;lodash.has=has;lodash.hasIn=hasIn;lodash.head=head;lodash.identity=identity;lodash.includes=includes;lodash.indexOf=indexOf;lodash.inRange=inRange;lodash.invoke=invoke;lodash.isArguments=isArguments;lodash.isArray=isArray;lodash.isArrayBuffer=isArrayBuffer;lodash.isArrayLike=isArrayLike;lodash.isArrayLikeObject=isArrayLikeObject;lodash.isBoolean=isBoolean;lodash.isBuffer=isBuffer;lodash.isDate=isDate;lodash.isElement=isElement;lodash.isEmpty=isEmpty;lodash.isEqual=isEqual;lodash.isEqualWith=isEqualWith;lodash.isError=isError;lodash.isFinite=isFinite;lodash.isFunction=isFunction;lodash.isInteger=isInteger;lodash.isLength=isLength;lodash.isMap=isMap;lodash.isMatch=isMatch;lodash.isMatchWith=isMatchWith;lodash.isNaN=isNaN;lodash.isNative=isNative;lodash.isNil=isNil;lodash.isNull=isNull;lodash.isNumber=isNumber;lodash.isObject=isObject;lodash.isObjectLike=isObjectLike;lodash.isPlainObject=isPlainObject;lodash.isRegExp=isRegExp;lodash.isSafeInteger=isSafeInteger;lodash.isSet=isSet;lodash.isString=isString;lodash.isSymbol=isSymbol;lodash.isTypedArray=isTypedArray;lodash.isUndefined=isUndefined;lodash.isWeakMap=isWeakMap;lodash.isWeakSet=isWeakSet;lodash.join=join;lodash.kebabCase=kebabCase;lodash.last=last;lodash.lastIndexOf=lastIndexOf;lodash.lowerCase=lowerCase;lodash.lowerFirst=lowerFirst;lodash.lt=lt;lodash.lte=lte;lodash.max=max;lodash.maxBy=maxBy;lodash.mean=mean;lodash.meanBy=meanBy;lodash.min=min;lodash.minBy=minBy;lodash.stubArray=stubArray;lodash.stubFalse=stubFalse;lodash.stubObject=stubObject;lodash.stubString=stubString;lodash.stubTrue=stubTrue;lodash.multiply=multiply;lodash.nth=nth;lodash.noConflict=noConflict;lodash.noop=noop;lodash.now=now;lodash.pad=pad;lodash.padEnd=padEnd;lodash.padStart=padStart;lodash.parseInt=parseInt;lodash.random=random;lodash.reduce=reduce;lodash.reduceRight=reduceRight;lodash.repeat=repeat;lodash.replace=replace;lodash.result=result;lodash.round=round;lodash.runInContext=runInContext;lodash.sample=sample;lodash.size=size;lodash.snakeCase=snakeCase;lodash.some=some;lodash.sortedIndex=sortedIndex;lodash.sortedIndexBy=sortedIndexBy;lodash.sortedIndexOf=sortedIndexOf;lodash.sortedLastIndex=sortedLastIndex;lodash.sortedLastIndexBy=sortedLastIndexBy;lodash.sortedLastIndexOf=sortedLastIndexOf;lodash.startCase=startCase;lodash.startsWith=startsWith;lodash.subtract=subtract;lodash.sum=sum;lodash.sumBy=sumBy;lodash.template=template;lodash.times=times;lodash.toFinite=toFinite;lodash.toInteger=toInteger;lodash.toLength=toLength;lodash.toLower=toLower;lodash.toNumber=toNumber;lodash.toSafeInteger=toSafeInteger;lodash.toString=toString;lodash.toUpper=toUpper;lodash.trim=trim;lodash.trimEnd=trimEnd;lodash.trimStart=trimStart;lodash.truncate=truncate;lodash.unescape=unescape;lodash.uniqueId=uniqueId;lodash.upperCase=upperCase;lodash.upperFirst=upperFirst;// Add aliases.
	lodash.each=forEach;lodash.eachRight=forEachRight;lodash.first=head;mixin(lodash,function(){var source={};baseForOwn(lodash,function(func,methodName){if(!hasOwnProperty.call(lodash.prototype,methodName)){source[methodName]=func;}});return source;}(),{'chain':false});/*------------------------------------------------------------------------*//**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */lodash.VERSION=VERSION;// Assign default placeholders.
	arrayEach(['bind','bindKey','curry','curryRight','partial','partialRight'],function(methodName){lodash[methodName].placeholder=lodash;});// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	arrayEach(['drop','take'],function(methodName,index){LazyWrapper.prototype[methodName]=function(n){n=n===undefined?1:nativeMax(toInteger(n),0);var result=this.__filtered__&&!index?new LazyWrapper(this):this.clone();if(result.__filtered__){result.__takeCount__=nativeMin(n,result.__takeCount__);}else{result.__views__.push({'size':nativeMin(n,MAX_ARRAY_LENGTH),'type':methodName+(result.__dir__<0?'Right':'')});}return result;};LazyWrapper.prototype[methodName+'Right']=function(n){return this.reverse()[methodName](n).reverse();};});// Add `LazyWrapper` methods that accept an `iteratee` value.
	arrayEach(['filter','map','takeWhile'],function(methodName,index){var type=index+1,isFilter=type==LAZY_FILTER_FLAG||type==LAZY_WHILE_FLAG;LazyWrapper.prototype[methodName]=function(iteratee){var result=this.clone();result.__iteratees__.push({'iteratee':getIteratee(iteratee,3),'type':type});result.__filtered__=result.__filtered__||isFilter;return result;};});// Add `LazyWrapper` methods for `_.head` and `_.last`.
	arrayEach(['head','last'],function(methodName,index){var takeName='take'+(index?'Right':'');LazyWrapper.prototype[methodName]=function(){return this[takeName](1).value()[0];};});// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	arrayEach(['initial','tail'],function(methodName,index){var dropName='drop'+(index?'':'Right');LazyWrapper.prototype[methodName]=function(){return this.__filtered__?new LazyWrapper(this):this[dropName](1);};});LazyWrapper.prototype.compact=function(){return this.filter(identity);};LazyWrapper.prototype.find=function(predicate){return this.filter(predicate).head();};LazyWrapper.prototype.findLast=function(predicate){return this.reverse().find(predicate);};LazyWrapper.prototype.invokeMap=baseRest(function(path,args){if(typeof path=='function'){return new LazyWrapper(this);}return this.map(function(value){return baseInvoke(value,path,args);});});LazyWrapper.prototype.reject=function(predicate){return this.filter(negate(getIteratee(predicate)));};LazyWrapper.prototype.slice=function(start,end){start=toInteger(start);var result=this;if(result.__filtered__&&(start>0||end<0)){return new LazyWrapper(result);}if(start<0){result=result.takeRight(-start);}else if(start){result=result.drop(start);}if(end!==undefined){end=toInteger(end);result=end<0?result.dropRight(-end):result.take(end-start);}return result;};LazyWrapper.prototype.takeRightWhile=function(predicate){return this.reverse().takeWhile(predicate).reverse();};LazyWrapper.prototype.toArray=function(){return this.take(MAX_ARRAY_LENGTH);};// Add `LazyWrapper` methods to `lodash.prototype`.
	baseForOwn(LazyWrapper.prototype,function(func,methodName){var checkIteratee=/^(?:filter|find|map|reject)|While$/.test(methodName),isTaker=/^(?:head|last)$/.test(methodName),lodashFunc=lodash[isTaker?'take'+(methodName=='last'?'Right':''):methodName],retUnwrapped=isTaker||/^find/.test(methodName);if(!lodashFunc){return;}lodash.prototype[methodName]=function(){var value=this.__wrapped__,args=isTaker?[1]:arguments,isLazy=value instanceof LazyWrapper,iteratee=args[0],useLazy=isLazy||isArray(value);var interceptor=function interceptor(value){var result=lodashFunc.apply(lodash,arrayPush([value],args));return isTaker&&chainAll?result[0]:result;};if(useLazy&&checkIteratee&&typeof iteratee=='function'&&iteratee.length!=1){// Avoid lazy use if the iteratee has a "length" value other than `1`.
	isLazy=useLazy=false;}var chainAll=this.__chain__,isHybrid=!!this.__actions__.length,isUnwrapped=retUnwrapped&&!chainAll,onlyLazy=isLazy&&!isHybrid;if(!retUnwrapped&&useLazy){value=onlyLazy?value:new LazyWrapper(this);var result=func.apply(value,args);result.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(result,chainAll);}if(isUnwrapped&&onlyLazy){return func.apply(this,args);}result=this.thru(interceptor);return isUnwrapped?isTaker?result.value()[0]:result.value():result;};});// Add `Array` methods to `lodash.prototype`.
	arrayEach(['pop','push','shift','sort','splice','unshift'],function(methodName){var func=arrayProto[methodName],chainName=/^(?:push|sort|unshift)$/.test(methodName)?'tap':'thru',retUnwrapped=/^(?:pop|shift)$/.test(methodName);lodash.prototype[methodName]=function(){var args=arguments;if(retUnwrapped&&!this.__chain__){var value=this.value();return func.apply(isArray(value)?value:[],args);}return this[chainName](function(value){return func.apply(isArray(value)?value:[],args);});};});// Map minified method names to their real names.
	baseForOwn(LazyWrapper.prototype,function(func,methodName){var lodashFunc=lodash[methodName];if(lodashFunc){var key=lodashFunc.name+'';if(!hasOwnProperty.call(realNames,key)){realNames[key]=[];}realNames[key].push({'name':methodName,'func':lodashFunc});}});realNames[createHybrid(undefined,WRAP_BIND_KEY_FLAG).name]=[{'name':'wrapper','func':undefined}];// Add methods to `LazyWrapper`.
	LazyWrapper.prototype.clone=lazyClone;LazyWrapper.prototype.reverse=lazyReverse;LazyWrapper.prototype.value=lazyValue;// Add chain sequence methods to the `lodash` wrapper.
	lodash.prototype.at=wrapperAt;lodash.prototype.chain=wrapperChain;lodash.prototype.commit=wrapperCommit;lodash.prototype.next=wrapperNext;lodash.prototype.plant=wrapperPlant;lodash.prototype.reverse=wrapperReverse;lodash.prototype.toJSON=lodash.prototype.valueOf=lodash.prototype.value=wrapperValue;// Add lazy aliases.
	lodash.prototype.first=lodash.prototype.head;if(symIterator){lodash.prototype[symIterator]=wrapperToIterator;}return lodash;};/*--------------------------------------------------------------------------*/// Export lodash.
	var _=runInContext();// Some AMD build optimizers, like r.js, check for condition patterns like:
	if("function"=='function'&&_typeof(__webpack_require__(139))=='object'&&__webpack_require__(139)){// Expose Lodash on the global object to prevent errors when Lodash is
	// loaded by a script tag in the presence of an AMD loader.
	// See http://requirejs.org/docs/errors.html#mismatch for more details.
	// Use `_.noConflict` to remove Lodash from the global object.
	root._=_;// Define as an anonymous module so, through path mapping, it can be
	// referenced as the "underscore" module.
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return _;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}// Check for `exports` after `define` in case a build optimizer adds it.
	else if(freeModule){// Export for Node.js.
	(freeModule.exports=_)._=_;// Export for CommonJS support.
	freeExports._=_;}else{// Export to the global object.
	root._=_;}}).call(undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(99)(module)))

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _flickityImagesloaded = __webpack_require__(342);
	
	var _flickityImagesloaded2 = _interopRequireDefault(_flickityImagesloaded);
	
	var _jquery = __webpack_require__(11);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(137);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Slider = function () {
	    function Slider(selector, options) {
	        _classCallCheck(this, Slider);
	
	        this.el = selector;
	        this.init(options);
	        this.$body = (0, _jquery2.default)('body');
	    }
	
	    _createClass(Slider, [{
	        key: 'goTo',
	        value: function goTo(index) {
	            this.flkty.select(index);
	        }
	    }, {
	        key: 'init',
	        value: function init(options) {
	            var _this = this;
	
	            this.flkty = new _flickityImagesloaded2.default(this.el, options);
	
	            setTimeout(function () {
	                _this.flkty.resize();
	            }, 500);
	
	            this.flkty.on('resize', _lodash2.default.debounce(function () {
	                _this.$body.trigger('flkty:updated');
	            }, 100));
	
	            this.flkty.on('settle', function () {
	                _this.$body.trigger('flkty:updated');
	            });
	        }
	    }]);
	
	    return Slider;
	}();
	
	module.exports = Slider;

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(340);
	
	__webpack_require__(359);
	
	__webpack_require__(141);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(148);
	module.exports = __webpack_require__(21).RegExp.escape;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isObject = __webpack_require__(5);
	var isArray = __webpack_require__(59);
	var SPECIES = __webpack_require__(6)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  }return C === undefined ? Array : C;
	};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	
	var fails = __webpack_require__(4);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function lz(num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	}) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) + '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) + 'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) + ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(2);
	var toPrimitive = __webpack_require__(28);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(39);
	var gOPS = __webpack_require__(63);
	var pIE = __webpack_require__(53);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) {
	      if (isEnum.call(it, key = symbols[i++])) result.push(key);
	    }
	  }return result;
	};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(54)('native-function-to-string', Function.toString);

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(1);
	var $re = __webpack_require__(147)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) {
	    return $re(it);
	  } });

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(101) });
	
	__webpack_require__(31)('copyWithin');

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var $every = __webpack_require__(25)(4);
	
	$export($export.P + $export.F * !__webpack_require__(23)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', { fill: __webpack_require__(72) });
	
	__webpack_require__(31)('fill');

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var $filter = __webpack_require__(25)(2);
	
	$export($export.P + $export.F * !__webpack_require__(23)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	
	var $export = __webpack_require__(1);
	var $find = __webpack_require__(25)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () {
	  forced = false;
	});
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(31)(KEY);

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	
	var $export = __webpack_require__(1);
	var $find = __webpack_require__(25)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () {
	  forced = false;
	});
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(31)(KEY);

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var $forEach = __webpack_require__(25)(0);
	var STRICT = __webpack_require__(23)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ctx = __webpack_require__(22);
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(10);
	var call = __webpack_require__(112);
	var isArrayIter = __webpack_require__(80);
	var toLength = __webpack_require__(7);
	var createProperty = __webpack_require__(74);
	var getIterFn = __webpack_require__(96);
	
	$export($export.S + $export.F * !__webpack_require__(61)(function (iter) {
	  Array.from(iter);
	}), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var $indexOf = __webpack_require__(56)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(23)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	    // convert -0 to +0
	    ? $native.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(59) });

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	
	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(19);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(52) != Object || !__webpack_require__(23)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(19);
	var toInteger = __webpack_require__(24);
	var toLength = __webpack_require__(7);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(23)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (; index >= 0; index--) {
	      if (index in O) if (O[index] === searchElement) return index || 0;
	    }return -1;
	  }
	});

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var $map = __webpack_require__(25)(1);
	
	$export($export.P + $export.F * !__webpack_require__(23)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var createProperty = __webpack_require__(74);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(4)(function () {
	  function F() {/* empty */}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of() /* ...args */{
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) {
	      createProperty(result, index, arguments[index++]);
	    }result.length = aLen;
	    return result;
	  }
	});

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var $reduce = __webpack_require__(103);
	
	$export($export.P + $export.F * !__webpack_require__(23)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var $reduce = __webpack_require__(103);
	
	$export($export.P + $export.F * !__webpack_require__(23)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var html = __webpack_require__(78);
	var cof = __webpack_require__(20);
	var toAbsoluteIndex = __webpack_require__(43);
	var toLength = __webpack_require__(7);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(4)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) {
	      cloned[i] = klass == 'String' ? this.charAt(start + i) : this[start + i];
	    }return cloned;
	  }
	});

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var $some = __webpack_require__(25)(3);
	
	$export($export.P + $export.F * !__webpack_require__(23)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(12);
	var toObject = __webpack_require__(10);
	var fails = __webpack_require__(4);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(23)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined ? $sort.call(toObject(this)) : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(42)('Array');

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Date', { now: function now() {
	    return new Date().getTime();
	  } });

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(1);
	var toISOString = __webpack_require__(143);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(10);
	var toPrimitive = __webpack_require__(28);
	
	$export($export.P + $export.F * __webpack_require__(4)(function () {
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({ toISOString: function toISOString() {
	      return 1;
	    } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var TO_PRIMITIVE = __webpack_require__(6)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(13)(proto, TO_PRIMITIVE, __webpack_require__(144));

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(14)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Function', { bind: __webpack_require__(104) });

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isObject = __webpack_require__(5);
	var getPrototypeOf = __webpack_require__(18);
	var HAS_INSTANCE = __webpack_require__(6)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(9).f(FunctionProto, HAS_INSTANCE, { value: function value(O) {
	    if (typeof this != 'function' || !isObject(O)) return false;
	    if (!isObject(this.prototype)) return O instanceof this;
	    // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	    while (O = getPrototypeOf(O)) {
	      if (this.prototype === O) return true;
	    }return false;
	  } });

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var dP = __webpack_require__(9).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(8) && dP(FProto, NAME, {
	  configurable: true,
	  get: function get() {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(1);
	var log1p = __webpack_require__(115);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	// V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	&& Math.floor($acosh(Number.MAX_VALUE)) == 710
	// Tor Browser bug: Math.acosh(Infinity) -> NaN
	&& $acosh(Infinity) == Infinity), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? Math.log(x) + Math.LN2 : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(1);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(1);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(1);
	var sign = __webpack_require__(84);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(1);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(1);
	var $expm1 = __webpack_require__(83);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { fround: __webpack_require__(114) });

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(1);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) {
	    // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(1);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(4)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(115) });

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { sign: __webpack_require__(84) });

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(1);
	var expm1 = __webpack_require__(83);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(4)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1 ? (expm1(x) - expm1(-x)) / 2 : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(1);
	var expm1 = __webpack_require__(83);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(3);
	var has = __webpack_require__(16);
	var cof = __webpack_require__(20);
	var inheritIfRequired = __webpack_require__(79);
	var toPrimitive = __webpack_require__(28);
	var fails = __webpack_require__(4);
	var gOPN = __webpack_require__(38).f;
	var gOPD = __webpack_require__(17).f;
	var dP = __webpack_require__(9).f;
	var $trim = __webpack_require__(50).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(37)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function toNumber(argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66:case 98:
	          radix = 2;maxCode = 49;break; // fast equal /^0b[01]+$/i
	        case 79:case 111:
	          radix = 8;maxCode = 55;break; // fast equal /^0o[0-7]+$/i
	        default:
	          return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      }return parseInt(digits, radix);
	    }
	  }return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	    // check on 1..constructor(foo) case
	    && (BROKEN_COF ? fails(function () {
	      proto.valueOf.call(that);
	    }) : cof(that) != NUMBER) ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(8) ? gOPN(Base) : (
	  // ES3:
	  'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	  // ES6 (in case, if modules with ES6 Number statics required before):
	  'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' + 'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger').split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(14)(global, NUMBER, $Number);
	}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(1);
	var _isFinite = __webpack_require__(3).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(111) });

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(1);
	var isInteger = __webpack_require__(111);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var $parseFloat = __webpack_require__(123);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var $parseInt = __webpack_require__(124);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var toInteger = __webpack_require__(24);
	var aNumberValue = __webpack_require__(100);
	var repeat = __webpack_require__(91);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function multiply(n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function divide(n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = c % n * 1e7;
	  }
	};
	var numToString = function numToString() {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  }return s;
	};
	var pow = function pow(x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function log(x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  }return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (0.00008.toFixed(3) !== '0.000' || 0.9.toFixed(0) !== '1' || 1.255.toFixed(2) !== '1.25' || 1000000000000000128.0.toFixed(0) !== '1000000000000000128') || !__webpack_require__(4)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    }return m;
	  }
	});

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var $fails = __webpack_require__(4);
	var aNumberValue = __webpack_require__(100);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(1);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(117) });

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(37) });

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(8), 'Object', { defineProperties: __webpack_require__(118) });

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(8), 'Object', { defineProperty: __webpack_require__(9).f });

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(5);
	var meta = __webpack_require__(33).onFreeze;
	
	__webpack_require__(27)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(19);
	var $getOwnPropertyDescriptor = __webpack_require__(17).f;
	
	__webpack_require__(27)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(27)('getOwnPropertyNames', function () {
	  return __webpack_require__(119).f;
	});

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(10);
	var $getPrototypeOf = __webpack_require__(18);
	
	__webpack_require__(27)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(5);
	
	__webpack_require__(27)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(5);
	
	__webpack_require__(27)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(5);
	
	__webpack_require__(27)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', { is: __webpack_require__(127) });

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(10);
	var $keys = __webpack_require__(39);
	
	__webpack_require__(27)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(5);
	var meta = __webpack_require__(33).onFreeze;
	
	__webpack_require__(27)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(5);
	var meta = __webpack_require__(33).onFreeze;
	
	__webpack_require__(27)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(88).set });

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	
	var classof = __webpack_require__(47);
	var test = {};
	test[__webpack_require__(6)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(14)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var $parseFloat = __webpack_require__(123);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var $parseInt = __webpack_require__(124);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var LIBRARY = __webpack_require__(32);
	var global = __webpack_require__(3);
	var ctx = __webpack_require__(22);
	var classof = __webpack_require__(47);
	var $export = __webpack_require__(1);
	var isObject = __webpack_require__(5);
	var aFunction = __webpack_require__(12);
	var anInstance = __webpack_require__(35);
	var forOf = __webpack_require__(36);
	var speciesConstructor = __webpack_require__(55);
	var task = __webpack_require__(93).set;
	var microtask = __webpack_require__(85)();
	var newPromiseCapabilityModule = __webpack_require__(86);
	var perform = __webpack_require__(125);
	var userAgent = __webpack_require__(69);
	var promiseResolve = __webpack_require__(126);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function empty() {/* empty */};
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(6)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise
	    // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	    // we can't detect it synchronously, so just check versions
	    && v8.indexOf('6.6') !== 0 && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) {/* empty */}
	}();
	
	// helpers
	var isThenable = function isThenable(it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function notify(promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function run(reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) {
	      run(chain[i++]);
	    } // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function onUnhandled(promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    }promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function isUnhandled(promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function onHandleUnhandled(promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function $reject(value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function $resolve(value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = []; // <- awaiting reactions
	    this._a = undefined; // <- checked in isUnhandled reactions
	    this._s = 0; // <- state
	    this._d = false; // <- done
	    this._v = undefined; // <- value
	    this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false; // <- notify
	  };
	  Internal.prototype = __webpack_require__(41)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function _catch(onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function OwnPromiseCapability() {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
	    return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(49)($Promise, PROMISE);
	__webpack_require__(42)(PROMISE);
	Wrapper = __webpack_require__(21)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(61)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(12);
	var anObject = __webpack_require__(2);
	var rApply = (__webpack_require__(3).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(4)(function () {
	  rApply(function () {/* empty */});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(1);
	var create = __webpack_require__(37);
	var aFunction = __webpack_require__(12);
	var anObject = __webpack_require__(2);
	var isObject = __webpack_require__(5);
	var fails = __webpack_require__(4);
	var bind = __webpack_require__(104);
	var rConstruct = (__webpack_require__(3).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() {/* empty */}
	  return !(rConstruct(function () {/* empty */}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () {/* empty */});
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0:
	          return new Target();
	        case 1:
	          return new Target(args[0]);
	        case 2:
	          return new Target(args[0], args[1]);
	        case 3:
	          return new Target(args[0], args[1], args[2]);
	        case 4:
	          return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(9);
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(2);
	var toPrimitive = __webpack_require__(28);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(4)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(1);
	var gOPD = __webpack_require__(17).f;
	var anObject = __webpack_require__(2);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(2);
	var Enumerate = function Enumerate(iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0; // next index
	  var keys = this._k = []; // keys
	  var key;
	  for (key in iterated) {
	    keys.push(key);
	  }
	};
	__webpack_require__(81)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(17);
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(2);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(1);
	var getProto = __webpack_require__(18);
	var anObject = __webpack_require__(2);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(17);
	var getPrototypeOf = __webpack_require__(18);
	var has = __webpack_require__(16);
	var $export = __webpack_require__(1);
	var isObject = __webpack_require__(5);
	var anObject = __webpack_require__(2);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(2);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(122) });

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(2);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(1);
	var setProto = __webpack_require__(88);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(9);
	var gOPD = __webpack_require__(17);
	var getPrototypeOf = __webpack_require__(18);
	var has = __webpack_require__(16);
	var $export = __webpack_require__(1);
	var createDesc = __webpack_require__(40);
	var anObject = __webpack_require__(2);
	var isObject = __webpack_require__(5);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var global = __webpack_require__(3);
	var inheritIfRequired = __webpack_require__(79);
	var dP = __webpack_require__(9).f;
	var gOPN = __webpack_require__(38).f;
	var isRegExp = __webpack_require__(60);
	var $flags = __webpack_require__(51);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(8) && (!CORRECT_NEW || __webpack_require__(4)(function () {
	  re2[__webpack_require__(6)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p : inheritIfRequired(CORRECT_NEW ? new Base(piRE && !fiU ? p.source : p, f) : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f), tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function proxy(key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function get() {
	        return Base[key];
	      },
	      set: function set(it) {
	        Base[key] = it;
	      }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) {
	    proxy(keys[i++]);
	  }proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(14)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(42)('RegExp');

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(2);
	var toLength = __webpack_require__(7);
	var advanceStringIndex = __webpack_require__(71);
	var regExpExec = __webpack_require__(64);
	
	// @@match logic
	__webpack_require__(58)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	  // `String.prototype.match` method
	  // https://tc39.github.io/ecma262/#sec-string.prototype.match
	  function match(regexp) {
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  },
	  // `RegExp.prototype[@@match]` method
	  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	  function (regexp) {
	    var res = maybeCallNative($match, regexp, this);
	    if (res.done) return res.value;
	    var rx = anObject(regexp);
	    var S = String(this);
	    if (!rx.global) return regExpExec(rx, S);
	    var fullUnicode = rx.unicode;
	    rx.lastIndex = 0;
	    var A = [];
	    var n = 0;
	    var result;
	    while ((result = regExpExec(rx, S)) !== null) {
	      var matchStr = String(result[0]);
	      A[n] = matchStr;
	      if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      n++;
	    }
	    return n === 0 ? null : A;
	  }];
	});

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(2);
	var toObject = __webpack_require__(10);
	var toLength = __webpack_require__(7);
	var toInteger = __webpack_require__(24);
	var advanceStringIndex = __webpack_require__(71);
	var regExpExec = __webpack_require__(64);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function maybeToString(it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(58)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	  // `String.prototype.replace` method
	  // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	  function replace(searchValue, replaceValue) {
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
	  },
	  // `RegExp.prototype[@@replace]` method
	  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	  function (regexp, replaceValue) {
	    var res = maybeCallNative($replace, regexp, this, replaceValue);
	    if (res.done) return res.value;
	
	    var rx = anObject(regexp);
	    var S = String(this);
	    var functionalReplace = typeof replaceValue === 'function';
	    if (!functionalReplace) replaceValue = String(replaceValue);
	    var global = rx.global;
	    if (global) {
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	    }
	    var results = [];
	    while (true) {
	      var result = regExpExec(rx, S);
	      if (result === null) break;
	      results.push(result);
	      if (!global) break;
	      var matchStr = String(result[0]);
	      if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	    }
	    var accumulatedResult = '';
	    var nextSourcePosition = 0;
	    for (var i = 0; i < results.length; i++) {
	      result = results[i];
	      var matched = String(result[0]);
	      var position = max(min(toInteger(result.index), S.length), 0);
	      var captures = [];
	      // NOTE: This is equivalent to
	      //   captures = result.slice(1).map(maybeToString)
	      // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	      // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	      // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	      for (var j = 1; j < result.length; j++) {
	        captures.push(maybeToString(result[j]));
	      }var namedCaptures = result.groups;
	      if (functionalReplace) {
	        var replacerArgs = [matched].concat(captures, position, S);
	        if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	        var replacement = String(replaceValue.apply(undefined, replacerArgs));
	      } else {
	        replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	      }
	      if (position >= nextSourcePosition) {
	        accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	        nextSourcePosition = position + matched.length;
	      }
	    }
	    return accumulatedResult + S.slice(nextSourcePosition);
	  }];
	
	  // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$':
	          return '$';
	        case '&':
	          return matched;
	        case '`':
	          return str.slice(0, position);
	        case "'":
	          return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default:
	          // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(2);
	var sameValue = __webpack_require__(127);
	var regExpExec = __webpack_require__(64);
	
	// @@search logic
	__webpack_require__(58)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	  // `String.prototype.search` method
	  // https://tc39.github.io/ecma262/#sec-string.prototype.search
	  function search(regexp) {
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  },
	  // `RegExp.prototype[@@search]` method
	  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	  function (regexp) {
	    var res = maybeCallNative($search, regexp, this);
	    if (res.done) return res.value;
	    var rx = anObject(regexp);
	    var S = String(this);
	    var previousLastIndex = rx.lastIndex;
	    if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	    var result = regExpExec(rx, S);
	    if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	    return result === null ? -1 : result.index;
	  }];
	});

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(60);
	var anObject = __webpack_require__(2);
	var speciesConstructor = __webpack_require__(55);
	var advanceStringIndex = __webpack_require__(71);
	var toLength = __webpack_require__(7);
	var callRegExpExec = __webpack_require__(64);
	var regexpExec = __webpack_require__(87);
	var fails = __webpack_require__(4);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () {
	  RegExp(MAX_UINT32, 'y');
	});
	
	// @@split logic
	__webpack_require__(58)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if ('abbc'[$SPLIT](/(b)*/)[1] == 'c' || 'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || 'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || '.'[$SPLIT](/()()/)[LENGTH] > 1 || ''[$SPLIT](/.?/)[LENGTH]) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function internalSplit(separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	    // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function internalSplit(separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	  // `String.prototype.split` method
	  // https://tc39.github.io/ecma262/#sec-string.prototype.split
	  function split(separator, limit) {
	    var O = defined(this);
	    var splitter = separator == undefined ? undefined : separator[SPLIT];
	    return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
	  },
	  // `RegExp.prototype[@@split]` method
	  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	  //
	  // NOTE: This cannot be properly polyfilled in engines that don't support
	  // the 'y' flag.
	  function (regexp, limit) {
	    var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	    if (res.done) return res.value;
	
	    var rx = anObject(regexp);
	    var S = String(this);
	    var C = speciesConstructor(rx, RegExp);
	
	    var unicodeMatching = rx.unicode;
	    var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (SUPPORTS_Y ? 'y' : 'g');
	
	    // ^(? + rx + ) is needed, in combination with some S slicing, to
	    // simulate the 'y' flag.
	    var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	    var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	    if (lim === 0) return [];
	    if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	    var p = 0;
	    var q = 0;
	    var A = [];
	    while (q < S.length) {
	      splitter.lastIndex = SUPPORTS_Y ? q : 0;
	      var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	      var e;
	      if (z === null || (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p) {
	        q = advanceStringIndex(S, q, unicodeMatching);
	      } else {
	        A.push(S.slice(p, q));
	        if (A.length === lim) return A;
	        for (var i = 1; i <= z.length - 1; i++) {
	          A.push(z[i]);
	          if (A.length === lim) return A;
	        }
	        q = p = e;
	      }
	    }
	    A.push(S.slice(p));
	    return A;
	  }];
	});

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(133);
	var anObject = __webpack_require__(2);
	var $flags = __webpack_require__(51);
	var DESCRIPTORS = __webpack_require__(8);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function define(fn) {
	  __webpack_require__(14)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(4)(function () {
	  return $toString.call({ source: 'a', flags: 'b' }) != '/a/b';
	})) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	  // FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	
	__webpack_require__(15)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	
	__webpack_require__(15)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	
	__webpack_require__(15)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	
	__webpack_require__(15)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var $at = __webpack_require__(67)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	
	var $export = __webpack_require__(1);
	var toLength = __webpack_require__(7);
	var context = __webpack_require__(90);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(77)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith ? $endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
	  }
	});

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	
	__webpack_require__(15)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	
	__webpack_require__(15)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	
	__webpack_require__(15)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var toAbsoluteIndex = __webpack_require__(43);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) {
	    // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
	    }return res.join('');
	  }
	});

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	
	var $export = __webpack_require__(1);
	var context = __webpack_require__(90);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(77)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	
	__webpack_require__(15)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $at = __webpack_require__(67)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(82)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0; // next index
	  // 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	
	__webpack_require__(15)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(19);
	var toLength = __webpack_require__(7);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    }return res.join('');
	  }
	});

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(91)
	});

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	
	__webpack_require__(15)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	
	var $export = __webpack_require__(1);
	var toLength = __webpack_require__(7);
	var context = __webpack_require__(90);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(77)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
	  }
	});

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	
	__webpack_require__(15)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	
	__webpack_require__(15)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	
	__webpack_require__(15)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	
	__webpack_require__(50)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var global = __webpack_require__(3);
	var has = __webpack_require__(16);
	var DESCRIPTORS = __webpack_require__(8);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(14);
	var META = __webpack_require__(33).KEY;
	var $fails = __webpack_require__(4);
	var shared = __webpack_require__(54);
	var setToStringTag = __webpack_require__(49);
	var uid = __webpack_require__(44);
	var wks = __webpack_require__(6);
	var wksExt = __webpack_require__(130);
	var wksDefine = __webpack_require__(95);
	var enumKeys = __webpack_require__(145);
	var isArray = __webpack_require__(59);
	var anObject = __webpack_require__(2);
	var isObject = __webpack_require__(5);
	var toObject = __webpack_require__(10);
	var toIObject = __webpack_require__(19);
	var toPrimitive = __webpack_require__(28);
	var createDesc = __webpack_require__(40);
	var _create = __webpack_require__(37);
	var gOPNExt = __webpack_require__(119);
	var $GOPD = __webpack_require__(17);
	var $GOPS = __webpack_require__(63);
	var $DP = __webpack_require__(9);
	var $keys = __webpack_require__(39);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function get() {
	      return dP(this, 'a', { value: 7 }).a;
	    }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function wrap(tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && _typeof($Symbol.iterator) == 'symbol' ? function (it) {
	  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    }return setSymbolDesc(it, key, D);
	  }return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) {
	    $defineProperty(it, key = keys[i++], P[key]);
	  }return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  }return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  }return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function _Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function $set(value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(38).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(53).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(32)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols =
	// 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
	  wks(es6Symbols[j++]);
	}for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
	  wksDefine(wellKnownSymbols[k++]);
	}$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function _for(key) {
	    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) {
	      if (SymbolRegistry[key] === sym) return key;
	    }
	  },
	  useSetter: function useSetter() {
	    setter = true;
	  },
	  useSimple: function useSimple() {
	    setter = false;
	  }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () {
	  $GOPS.f(1);
	});
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) {
	      args.push(arguments[i++]);
	    }$replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function replacer(key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(13)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var $typed = __webpack_require__(68);
	var buffer = __webpack_require__(94);
	var anObject = __webpack_require__(2);
	var toAbsoluteIndex = __webpack_require__(43);
	var toLength = __webpack_require__(7);
	var isObject = __webpack_require__(5);
	var ArrayBuffer = __webpack_require__(3).ArrayBuffer;
	var speciesConstructor = __webpack_require__(55);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(4)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    }return result;
	  }
	});
	
	__webpack_require__(42)(ARRAY_BUFFER);

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	$export($export.G + $export.W + $export.F * !__webpack_require__(68).ABV, {
	  DataView: __webpack_require__(94).DataView
	});

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(30)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(30)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(30)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(30)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(30)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(30)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(30)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(30)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(30)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var weak = __webpack_require__(107);
	var validate = __webpack_require__(45);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(57)(WEAK_SET, function (get) {
	  return function WeakSet() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	
	var $export = __webpack_require__(1);
	var flattenIntoArray = __webpack_require__(108);
	var toObject = __webpack_require__(10);
	var toLength = __webpack_require__(7);
	var aFunction = __webpack_require__(12);
	var arraySpeciesCreate = __webpack_require__(73);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(31)('flatMap');

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	
	var $export = __webpack_require__(1);
	var flattenIntoArray = __webpack_require__(108);
	var toObject = __webpack_require__(10);
	var toLength = __webpack_require__(7);
	var toInteger = __webpack_require__(24);
	var arraySpeciesCreate = __webpack_require__(73);
	
	$export($export.P, 'Array', {
	  flatten: function flatten() /* depthArg = 1 */{
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(31)('flatten');

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	
	var $export = __webpack_require__(1);
	var $includes = __webpack_require__(56)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(31)('includes');

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(1);
	var microtask = __webpack_require__(85)();
	var process = __webpack_require__(3).process;
	var isNode = __webpack_require__(20)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(1);
	var cof = __webpack_require__(20);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(1);
	
	$export($export.G, { global: __webpack_require__(3) });

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(65)('Map');

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(66)('Map');

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(106)('Map') });

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var scale = __webpack_require__(116);
	var fround = __webpack_require__(114);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { scale: __webpack_require__(116) });

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	    // eslint-disable-next-line no-self-compare
	    return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	  } });

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(10);
	var aFunction = __webpack_require__(12);
	var $defineProperty = __webpack_require__(9);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(8) && $export($export.P + __webpack_require__(62), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(10);
	var aFunction = __webpack_require__(12);
	var $defineProperty = __webpack_require__(9);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(8) && $export($export.P + __webpack_require__(62), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(1);
	var $entries = __webpack_require__(121)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(1);
	var ownKeys = __webpack_require__(122);
	var toIObject = __webpack_require__(19);
	var gOPD = __webpack_require__(17);
	var createProperty = __webpack_require__(74);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(10);
	var toPrimitive = __webpack_require__(28);
	var getPrototypeOf = __webpack_require__(18);
	var getOwnPropertyDescriptor = __webpack_require__(17).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(8) && $export($export.P + __webpack_require__(62), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(10);
	var toPrimitive = __webpack_require__(28);
	var getPrototypeOf = __webpack_require__(18);
	var getOwnPropertyDescriptor = __webpack_require__(17).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(8) && $export($export.P + __webpack_require__(62), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(1);
	var $values = __webpack_require__(121)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	
	var $export = __webpack_require__(1);
	var global = __webpack_require__(3);
	var core = __webpack_require__(21);
	var microtask = __webpack_require__(85)();
	var OBSERVABLE = __webpack_require__(6)('observable');
	var aFunction = __webpack_require__(12);
	var anObject = __webpack_require__(2);
	var anInstance = __webpack_require__(35);
	var redefineAll = __webpack_require__(41);
	var hide = __webpack_require__(13);
	var forOf = __webpack_require__(36);
	var RETURN = forOf.RETURN;
	
	var getMethod = function getMethod(fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function cleanupSubscription(subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function subscriptionClosed(subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function closeSubscription(subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function Subscription(observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function cleanup() {
	        subscription.unsubscribe();
	      };else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  }if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() {
	    closeSubscription(this);
	  }
	});
	
	var SubscriptionObserver = function SubscriptionObserver(subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    }cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function next(value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          }observer.complete();
	        }
	      });
	      return function () {
	        done = true;
	      };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) {
	      items[i] = arguments[i++];
	    }return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          }observer.complete();
	        }
	      });
	      return function () {
	        done = true;
	      };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () {
	  return this;
	});
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(42)('Observable');

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	
	var $export = __webpack_require__(1);
	var core = __webpack_require__(21);
	var global = __webpack_require__(3);
	var speciesConstructor = __webpack_require__(55);
	var promiseResolve = __webpack_require__(126);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function _finally(onFinally) {
	    var C = speciesConstructor(this, core.Promise || global.Promise);
	    var isFunction = typeof onFinally == 'function';
	    return this.then(isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () {
	        return x;
	      });
	    } : onFinally, isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () {
	        throw e;
	      });
	    } : onFinally);
	  } });

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	
	var $export = __webpack_require__(1);
	var newPromiseCapability = __webpack_require__(86);
	var perform = __webpack_require__(125);
	
	$export($export.S, 'Promise', { 'try': function _try(callbackfn) {
	    var promiseCapability = newPromiseCapability.f(this);
	    var result = perform(callbackfn);
	    (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	    return promiseCapability.promise;
	  } });

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var metadata = __webpack_require__(29);
	var anObject = __webpack_require__(2);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	    ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	  } });

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var metadata = __webpack_require__(29);
	var anObject = __webpack_require__(2);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	    var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	    var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	    if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	    if (metadataMap.size) return true;
	    var targetMetadata = store.get(target);
	    targetMetadata['delete'](targetKey);
	    return !!targetMetadata.size || store['delete'](target);
	  } });

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Set = __webpack_require__(134);
	var from = __webpack_require__(102);
	var metadata = __webpack_require__(29);
	var anObject = __webpack_require__(2);
	var getPrototypeOf = __webpack_require__(18);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function ordinaryMetadataKeys(O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	    return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	  } });

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var metadata = __webpack_require__(29);
	var anObject = __webpack_require__(2);
	var getPrototypeOf = __webpack_require__(18);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function ordinaryGetMetadata(MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	    return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	  } });

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var metadata = __webpack_require__(29);
	var anObject = __webpack_require__(2);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	    return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	  } });

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var metadata = __webpack_require__(29);
	var anObject = __webpack_require__(2);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	    return ordinaryGetOwnMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	  } });

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var metadata = __webpack_require__(29);
	var anObject = __webpack_require__(2);
	var getPrototypeOf = __webpack_require__(18);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function ordinaryHasMetadata(MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	    return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	  } });

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var metadata = __webpack_require__(29);
	var anObject = __webpack_require__(2);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	    return ordinaryHasOwnMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	  } });

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $metadata = __webpack_require__(29);
	var anObject = __webpack_require__(2);
	var aFunction = __webpack_require__(12);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	    return function decorator(target, targetKey) {
	      ordinaryDefineOwnMetadata(metadataKey, metadataValue, (targetKey !== undefined ? anObject : aFunction)(target), toMetaKey(targetKey));
	    };
	  } });

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(65)('Set');

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(66)('Set');

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(106)('Set') });

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	
	var $export = __webpack_require__(1);
	var $at = __webpack_require__(67)(true);
	var $fails = __webpack_require__(4);
	
	var FORCED = $fails(function () {
	  return '𠮷'.at(0) !== '𠮷';
	});
	
	$export($export.P + $export.F * FORCED, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	
	var $export = __webpack_require__(1);
	var defined = __webpack_require__(26);
	var toLength = __webpack_require__(7);
	var isRegExp = __webpack_require__(60);
	var getFlags = __webpack_require__(51);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function $RegExpStringIterator(regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(81)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	
	var $export = __webpack_require__(1);
	var $pad = __webpack_require__(128);
	var userAgent = __webpack_require__(69);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	
	var $export = __webpack_require__(1);
	var $pad = __webpack_require__(128);
	var userAgent = __webpack_require__(69);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	
	__webpack_require__(50)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	
	__webpack_require__(50)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(95)('asyncIterator');

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(95)('observable');

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(1);
	
	$export($export.S, 'System', { global: __webpack_require__(3) });

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(65)('WeakMap');

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(66)('WeakMap');

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(65)('WeakSet');

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(66)('WeakSet');

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $iterators = __webpack_require__(97);
	var getKeys = __webpack_require__(39);
	var redefine = __webpack_require__(14);
	var global = __webpack_require__(3);
	var hide = __webpack_require__(13);
	var Iterators = __webpack_require__(48);
	var wks = __webpack_require__(6);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) {
	      if (!proto[key]) redefine(proto, key, $iterators[key], true);
	    }
	  }
	}

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $export = __webpack_require__(1);
	var $task = __webpack_require__(93);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(3);
	var $export = __webpack_require__(1);
	var userAgent = __webpack_require__(69);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function wrap(set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(268);
	__webpack_require__(207);
	__webpack_require__(209);
	__webpack_require__(208);
	__webpack_require__(211);
	__webpack_require__(213);
	__webpack_require__(218);
	__webpack_require__(212);
	__webpack_require__(210);
	__webpack_require__(220);
	__webpack_require__(219);
	__webpack_require__(215);
	__webpack_require__(216);
	__webpack_require__(214);
	__webpack_require__(206);
	__webpack_require__(217);
	__webpack_require__(221);
	__webpack_require__(222);
	__webpack_require__(174);
	__webpack_require__(176);
	__webpack_require__(175);
	__webpack_require__(224);
	__webpack_require__(223);
	__webpack_require__(194);
	__webpack_require__(204);
	__webpack_require__(205);
	__webpack_require__(195);
	__webpack_require__(196);
	__webpack_require__(197);
	__webpack_require__(198);
	__webpack_require__(199);
	__webpack_require__(200);
	__webpack_require__(201);
	__webpack_require__(202);
	__webpack_require__(203);
	__webpack_require__(177);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(180);
	__webpack_require__(181);
	__webpack_require__(182);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(185);
	__webpack_require__(186);
	__webpack_require__(187);
	__webpack_require__(188);
	__webpack_require__(189);
	__webpack_require__(190);
	__webpack_require__(191);
	__webpack_require__(192);
	__webpack_require__(193);
	__webpack_require__(255);
	__webpack_require__(260);
	__webpack_require__(267);
	__webpack_require__(258);
	__webpack_require__(250);
	__webpack_require__(251);
	__webpack_require__(256);
	__webpack_require__(261);
	__webpack_require__(263);
	__webpack_require__(246);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(249);
	__webpack_require__(252);
	__webpack_require__(253);
	__webpack_require__(254);
	__webpack_require__(257);
	__webpack_require__(259);
	__webpack_require__(262);
	__webpack_require__(264);
	__webpack_require__(265);
	__webpack_require__(266);
	__webpack_require__(169);
	__webpack_require__(171);
	__webpack_require__(170);
	__webpack_require__(173);
	__webpack_require__(172);
	__webpack_require__(158);
	__webpack_require__(156);
	__webpack_require__(162);
	__webpack_require__(159);
	__webpack_require__(165);
	__webpack_require__(167);
	__webpack_require__(155);
	__webpack_require__(161);
	__webpack_require__(152);
	__webpack_require__(166);
	__webpack_require__(150);
	__webpack_require__(164);
	__webpack_require__(163);
	__webpack_require__(157);
	__webpack_require__(160);
	__webpack_require__(149);
	__webpack_require__(151);
	__webpack_require__(154);
	__webpack_require__(153);
	__webpack_require__(168);
	__webpack_require__(97);
	__webpack_require__(240);
	__webpack_require__(132);
	__webpack_require__(245);
	__webpack_require__(133);
	__webpack_require__(241);
	__webpack_require__(242);
	__webpack_require__(243);
	__webpack_require__(244);
	__webpack_require__(225);
	__webpack_require__(131);
	__webpack_require__(134);
	__webpack_require__(135);
	__webpack_require__(280);
	__webpack_require__(269);
	__webpack_require__(270);
	__webpack_require__(275);
	__webpack_require__(278);
	__webpack_require__(279);
	__webpack_require__(273);
	__webpack_require__(276);
	__webpack_require__(274);
	__webpack_require__(277);
	__webpack_require__(271);
	__webpack_require__(272);
	__webpack_require__(226);
	__webpack_require__(227);
	__webpack_require__(228);
	__webpack_require__(229);
	__webpack_require__(230);
	__webpack_require__(233);
	__webpack_require__(231);
	__webpack_require__(232);
	__webpack_require__(234);
	__webpack_require__(235);
	__webpack_require__(236);
	__webpack_require__(237);
	__webpack_require__(239);
	__webpack_require__(238);
	__webpack_require__(283);
	__webpack_require__(281);
	__webpack_require__(282);
	__webpack_require__(324);
	__webpack_require__(327);
	__webpack_require__(326);
	__webpack_require__(328);
	__webpack_require__(329);
	__webpack_require__(325);
	__webpack_require__(330);
	__webpack_require__(331);
	__webpack_require__(305);
	__webpack_require__(308);
	__webpack_require__(304);
	__webpack_require__(302);
	__webpack_require__(303);
	__webpack_require__(306);
	__webpack_require__(307);
	__webpack_require__(289);
	__webpack_require__(323);
	__webpack_require__(288);
	__webpack_require__(322);
	__webpack_require__(334);
	__webpack_require__(336);
	__webpack_require__(287);
	__webpack_require__(321);
	__webpack_require__(333);
	__webpack_require__(335);
	__webpack_require__(286);
	__webpack_require__(332);
	__webpack_require__(285);
	__webpack_require__(290);
	__webpack_require__(291);
	__webpack_require__(292);
	__webpack_require__(293);
	__webpack_require__(294);
	__webpack_require__(296);
	__webpack_require__(295);
	__webpack_require__(297);
	__webpack_require__(298);
	__webpack_require__(299);
	__webpack_require__(301);
	__webpack_require__(300);
	__webpack_require__(310);
	__webpack_require__(311);
	__webpack_require__(312);
	__webpack_require__(313);
	__webpack_require__(315);
	__webpack_require__(314);
	__webpack_require__(317);
	__webpack_require__(316);
	__webpack_require__(318);
	__webpack_require__(319);
	__webpack_require__(320);
	__webpack_require__(284);
	__webpack_require__(309);
	__webpack_require__(339);
	__webpack_require__(338);
	__webpack_require__(337);
	module.exports = __webpack_require__(21);

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * matchesSelector v2.0.2
	 * matchesSelector( element, '.selector' )
	 * MIT license
	 */
	
	/*jshint browser: true, strict: true, undef: true, unused: true */
	
	(function (window, factory) {
	  /*global define: false, module: false */
	  'use strict';
	  // universal module definition
	
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory();
	  } else {
	    // browser global
	    window.matchesSelector = factory();
	  }
	})(window, function factory() {
	  'use strict';
	
	  var matchesMethod = function () {
	    var ElemProto = window.Element.prototype;
	    // check for the standard method name first
	    if (ElemProto.matches) {
	      return 'matches';
	    }
	    // check un-prefixed
	    if (ElemProto.matchesSelector) {
	      return 'matchesSelector';
	    }
	    // check vendor prefixes
	    var prefixes = ['webkit', 'moz', 'ms', 'o'];
	
	    for (var i = 0; i < prefixes.length; i++) {
	      var prefix = prefixes[i];
	      var method = prefix + 'MatchesSelector';
	      if (ElemProto[method]) {
	        return method;
	      }
	    }
	  }();
	
	  return function matchesSelector(elem, selector) {
	    return elem[matchesMethod](selector);
	  };
	});

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * Flickity imagesLoaded v2.0.0
	 * enables imagesLoaded option for Flickity
	 */
	
	/*jshint browser: true, strict: true, undef: true, unused: true */
	
	(function (window, factory) {
	  // universal module definition
	  /*jshint strict: false */ /*globals define, module, require */
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(347), __webpack_require__(353)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, imagesLoaded) {
	      return factory(window, Flickity, imagesLoaded);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory(window, require('flickity'), require('imagesloaded'));
	  } else {
	    // browser global
	    window.Flickity = factory(window, window.Flickity, window.imagesLoaded);
	  }
	})(window, function factory(window, Flickity, imagesLoaded) {
	  'use strict';
	
	  Flickity.createMethods.push('_createImagesLoaded');
	
	  var proto = Flickity.prototype;
	
	  proto._createImagesLoaded = function () {
	    this.on('activate', this.imagesLoaded);
	  };
	
	  proto.imagesLoaded = function () {
	    if (!this.options.imagesLoaded) {
	      return;
	    }
	    var _this = this;
	    function onImagesLoadedProgress(instance, image) {
	      var cell = _this.getParentCell(image.img);
	      _this.cellSizeChange(cell && cell.element);
	      if (!_this.options.freeScroll) {
	        _this.positionSliderAtSelected();
	      }
	    }
	    imagesLoaded(this.slider).on('progress', onImagesLoadedProgress);
	  };
	
	  return Flickity;
	});

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// add, remove cell
	(function (window, factory) {
	  // universal module definition
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(46), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, utils) {
	      return factory(window, Flickity, utils);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory(window, require('./flickity'), require('fizzy-ui-utils'));
	  } else {
	    // browser global
	    factory(window, window.Flickity, window.fizzyUIUtils);
	  }
	})(window, function factory(window, Flickity, utils) {
	
	  'use strict';
	
	  // append cells to a document fragment
	
	  function getCellsFragment(cells) {
	    var fragment = document.createDocumentFragment();
	    cells.forEach(function (cell) {
	      fragment.appendChild(cell.element);
	    });
	    return fragment;
	  }
	
	  // -------------------------- add/remove cell prototype -------------------------- //
	
	  var proto = Flickity.prototype;
	
	  /**
	   * Insert, prepend, or append cells
	   * @param {[Element, Array, NodeList]} elems - Elements to insert
	   * @param {Integer} index - Zero-based number to insert
	   */
	  proto.insert = function (elems, index) {
	    var cells = this._makeCells(elems);
	    if (!cells || !cells.length) {
	      return;
	    }
	    var len = this.cells.length;
	    // default to append
	    index = index === undefined ? len : index;
	    // add cells with document fragment
	    var fragment = getCellsFragment(cells);
	    // append to slider
	    var isAppend = index == len;
	    if (isAppend) {
	      this.slider.appendChild(fragment);
	    } else {
	      var insertCellElement = this.cells[index].element;
	      this.slider.insertBefore(fragment, insertCellElement);
	    }
	    // add to this.cells
	    if (index === 0) {
	      // prepend, add to start
	      this.cells = cells.concat(this.cells);
	    } else if (isAppend) {
	      // append, add to end
	      this.cells = this.cells.concat(cells);
	    } else {
	      // insert in this.cells
	      var endCells = this.cells.splice(index, len - index);
	      this.cells = this.cells.concat(cells).concat(endCells);
	    }
	
	    this._sizeCells(cells);
	    this.cellChange(index, true);
	  };
	
	  proto.append = function (elems) {
	    this.insert(elems, this.cells.length);
	  };
	
	  proto.prepend = function (elems) {
	    this.insert(elems, 0);
	  };
	
	  /**
	   * Remove cells
	   * @param {[Element, Array, NodeList]} elems - ELements to remove
	   */
	  proto.remove = function (elems) {
	    var cells = this.getCells(elems);
	    if (!cells || !cells.length) {
	      return;
	    }
	
	    var minCellIndex = this.cells.length - 1;
	    // remove cells from collection & DOM
	    cells.forEach(function (cell) {
	      cell.remove();
	      var index = this.cells.indexOf(cell);
	      minCellIndex = Math.min(index, minCellIndex);
	      utils.removeFrom(this.cells, cell);
	    }, this);
	
	    this.cellChange(minCellIndex, true);
	  };
	
	  /**
	   * logic to be run after a cell's size changes
	   * @param {Element} elem - cell's element
	   */
	  proto.cellSizeChange = function (elem) {
	    var cell = this.getCell(elem);
	    if (!cell) {
	      return;
	    }
	    cell.getSize();
	
	    var index = this.cells.indexOf(cell);
	    this.cellChange(index);
	  };
	
	  /**
	   * logic any time a cell is changed: added, removed, or size changed
	   * @param {Integer} changedCellIndex - index of the changed cell, optional
	   * @param {Boolean} isPositioningSlider - Positions slider after selection
	   */
	  proto.cellChange = function (changedCellIndex, isPositioningSlider) {
	    var prevSelectedElem = this.selectedElement;
	    this._positionCells(changedCellIndex);
	    this._getWrapShiftCells();
	    this.setGallerySize();
	    // update selectedIndex
	    // try to maintain position & select previous selected element
	    var cell = this.getCell(prevSelectedElem);
	    if (cell) {
	      this.selectedIndex = this.getCellSlideIndex(cell);
	    }
	    this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
	
	    this.emitEvent('cellChange', [changedCellIndex]);
	    // position slider
	    this.select(this.selectedIndex);
	    // do not position slider after lazy load
	    if (isPositioningSlider) {
	      this.positionSliderAtSelected();
	    }
	  };
	
	  // -----  ----- //
	
	  return Flickity;
	});

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// animate
	(function (window, factory) {
	  // universal module definition
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(34)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils) {
	      return factory(window, utils);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory(window, require('fizzy-ui-utils'));
	  } else {
	    // browser global
	    window.Flickity = window.Flickity || {};
	    window.Flickity.animatePrototype = factory(window, window.fizzyUIUtils);
	  }
	})(window, function factory(window, utils) {
	
	  'use strict';
	
	  // -------------------------- animate -------------------------- //
	
	  var proto = {};
	
	  proto.startAnimation = function () {
	    if (this.isAnimating) {
	      return;
	    }
	
	    this.isAnimating = true;
	    this.restingFrames = 0;
	    this.animate();
	  };
	
	  proto.animate = function () {
	    this.applyDragForce();
	    this.applySelectedAttraction();
	
	    var previousX = this.x;
	
	    this.integratePhysics();
	    this.positionSlider();
	    this.settle(previousX);
	    // animate next frame
	    if (this.isAnimating) {
	      var _this = this;
	      requestAnimationFrame(function animateFrame() {
	        _this.animate();
	      });
	    }
	  };
	
	  proto.positionSlider = function () {
	    var x = this.x;
	    // wrap position around
	    if (this.options.wrapAround && this.cells.length > 1) {
	      x = utils.modulo(x, this.slideableWidth);
	      x -= this.slideableWidth;
	      this.shiftWrapCells(x);
	    }
	
	    this.setTranslateX(x, this.isAnimating);
	    this.dispatchScrollEvent();
	  };
	
	  proto.setTranslateX = function (x, is3d) {
	    x += this.cursorPosition;
	    // reverse if right-to-left and using transform
	    x = this.options.rightToLeft ? -x : x;
	    var translateX = this.getPositionValue(x);
	    // use 3D transforms for hardware acceleration on iOS
	    // but use 2D when settled, for better font-rendering
	    this.slider.style.transform = is3d ? 'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
	  };
	
	  proto.dispatchScrollEvent = function () {
	    var firstSlide = this.slides[0];
	    if (!firstSlide) {
	      return;
	    }
	    var positionX = -this.x - firstSlide.target;
	    var progress = positionX / this.slidesWidth;
	    this.dispatchEvent('scroll', null, [progress, positionX]);
	  };
	
	  proto.positionSliderAtSelected = function () {
	    if (!this.cells.length) {
	      return;
	    }
	    this.x = -this.selectedSlide.target;
	    this.velocity = 0; // stop wobble
	    this.positionSlider();
	  };
	
	  proto.getPositionValue = function (position) {
	    if (this.options.percentPosition) {
	      // percent position, round to 2 digits, like 12.34%
	      return Math.round(position / this.size.innerWidth * 10000) * 0.01 + '%';
	    } else {
	      // pixel positioning
	      return Math.round(position) + 'px';
	    }
	  };
	
	  proto.settle = function (previousX) {
	    // keep track of frames where x hasn't moved
	    var isResting = !this.isPointerDown && Math.round(this.x * 100) == Math.round(previousX * 100);
	    if (isResting) {
	      this.restingFrames++;
	    }
	    // stop animating if resting for 3 or more frames
	    if (this.restingFrames > 2) {
	      this.isAnimating = false;
	      delete this.isFreeScrolling;
	      // render position with translateX when settled
	      this.positionSlider();
	      this.dispatchEvent('settle', null, [this.selectedIndex]);
	    }
	  };
	
	  proto.shiftWrapCells = function (x) {
	    // shift before cells
	    var beforeGap = this.cursorPosition + x;
	    this._shiftCells(this.beforeShiftCells, beforeGap, -1);
	    // shift after cells
	    var afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
	    this._shiftCells(this.afterShiftCells, afterGap, 1);
	  };
	
	  proto._shiftCells = function (cells, gap, shift) {
	    for (var i = 0; i < cells.length; i++) {
	      var cell = cells[i];
	      var cellShift = gap > 0 ? shift : 0;
	      cell.wrapShift(cellShift);
	      gap -= cell.size.outerWidth;
	    }
	  };
	
	  proto._unshiftCells = function (cells) {
	    if (!cells || !cells.length) {
	      return;
	    }
	    for (var i = 0; i < cells.length; i++) {
	      cells[i].wrapShift(0);
	    }
	  };
	
	  // -------------------------- physics -------------------------- //
	
	  proto.integratePhysics = function () {
	    this.x += this.velocity;
	    this.velocity *= this.getFrictionFactor();
	  };
	
	  proto.applyForce = function (force) {
	    this.velocity += force;
	  };
	
	  proto.getFrictionFactor = function () {
	    return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
	  };
	
	  proto.getRestingPosition = function () {
	    // my thanks to Steven Wittens, who simplified this math greatly
	    return this.x + this.velocity / (1 - this.getFrictionFactor());
	  };
	
	  proto.applyDragForce = function () {
	    if (!this.isDraggable || !this.isPointerDown) {
	      return;
	    }
	    // change the position to drag position by applying force
	    var dragVelocity = this.dragX - this.x;
	    var dragForce = dragVelocity - this.velocity;
	    this.applyForce(dragForce);
	  };
	
	  proto.applySelectedAttraction = function () {
	    // do not attract if pointer down or no slides
	    var dragDown = this.isDraggable && this.isPointerDown;
	    if (dragDown || this.isFreeScrolling || !this.slides.length) {
	      return;
	    }
	    var distance = this.selectedSlide.target * -1 - this.x;
	    var force = distance * this.options.selectedAttraction;
	    this.applyForce(force);
	  };
	
	  return proto;
	});

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// Flickity.Cell
	(function (window, factory) {
	  // universal module definition
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(136)], __WEBPACK_AMD_DEFINE_RESULT__ = function (getSize) {
	      return factory(window, getSize);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory(window, require('get-size'));
	  } else {
	    // browser global
	    window.Flickity = window.Flickity || {};
	    window.Flickity.Cell = factory(window, window.getSize);
	  }
	})(window, function factory(window, getSize) {
	
	  'use strict';
	
	  function Cell(elem, parent) {
	    this.element = elem;
	    this.parent = parent;
	
	    this.create();
	  }
	
	  var proto = Cell.prototype;
	
	  proto.create = function () {
	    this.element.style.position = 'absolute';
	    this.element.setAttribute('aria-hidden', 'true');
	    this.x = 0;
	    this.shift = 0;
	    this.element.style[this.parent.originSide] = 0;
	  };
	
	  proto.destroy = function () {
	    // reset style
	    this.unselect();
	    this.element.style.position = '';
	    var side = this.parent.originSide;
	    this.element.style[side] = '';
	    this.element.style.transform = '';
	    this.element.removeAttribute('aria-hidden');
	  };
	
	  proto.getSize = function () {
	    this.size = getSize(this.element);
	  };
	
	  proto.setPosition = function (x) {
	    this.x = x;
	    this.updateTarget();
	    this.renderPosition(x);
	  };
	
	  // setDefaultTarget v1 method, backwards compatibility, remove in v3
	  proto.updateTarget = proto.setDefaultTarget = function () {
	    var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
	    this.target = this.x + this.size[marginProperty] + this.size.width * this.parent.cellAlign;
	  };
	
	  proto.renderPosition = function (x) {
	    // render position of cell with in slider
	    var sideOffset = this.parent.originSide === 'left' ? 1 : -1;
	
	    var adjustedX = this.parent.options.percentPosition ? x * sideOffset * (this.parent.size.innerWidth / this.size.width) : x * sideOffset;
	
	    this.element.style.transform = 'translateX(' + this.parent.getPositionValue(adjustedX) + ')';
	  };
	
	  proto.select = function () {
	    this.element.classList.add('is-selected');
	    this.element.removeAttribute('aria-hidden');
	  };
	
	  proto.unselect = function () {
	    this.element.classList.remove('is-selected');
	    this.element.setAttribute('aria-hidden', 'true');
	  };
	
	  /**
	   * @param {Integer} shift - 0, 1, or -1
	   */
	  proto.wrapShift = function (shift) {
	    this.shift = shift;
	    this.renderPosition(this.x + this.parent.slideableWidth * shift);
	  };
	
	  proto.remove = function () {
	    this.element.parentNode.removeChild(this.element);
	  };
	
	  return Cell;
	});

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// drag
	(function (window, factory) {
	  // universal module definition
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(46), __webpack_require__(360), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, Unidragger, utils) {
	      return factory(window, Flickity, Unidragger, utils);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory(window, require('./flickity'), require('unidragger'), require('fizzy-ui-utils'));
	  } else {
	    // browser global
	    window.Flickity = factory(window, window.Flickity, window.Unidragger, window.fizzyUIUtils);
	  }
	})(window, function factory(window, Flickity, Unidragger, utils) {
	
	  'use strict';
	
	  // ----- defaults ----- //
	
	  utils.extend(Flickity.defaults, {
	    draggable: '>1',
	    dragThreshold: 3
	  });
	
	  // ----- create ----- //
	
	  Flickity.createMethods.push('_createDrag');
	
	  // -------------------------- drag prototype -------------------------- //
	
	  var proto = Flickity.prototype;
	  utils.extend(proto, Unidragger.prototype);
	  proto._touchActionValue = 'pan-y';
	
	  // --------------------------  -------------------------- //
	
	  proto._createDrag = function () {
	    this.on('activate', this.onActivateDrag);
	    this.on('uiChange', this._uiChangeDrag);
	    this.on('deactivate', this.onDeactivateDrag);
	    this.on('cellChange', this.updateDraggable);
	    // TODO updateDraggable on resize? if groupCells & slides change
	  };
	
	  proto.onActivateDrag = function () {
	    this.handles = [this.viewport];
	    this.bindHandles();
	    this.updateDraggable();
	  };
	
	  proto.onDeactivateDrag = function () {
	    this.unbindHandles();
	    this.element.classList.remove('is-draggable');
	  };
	
	  proto.updateDraggable = function () {
	    // disable dragging if less than 2 slides. #278
	    if (this.options.draggable == '>1') {
	      this.isDraggable = this.slides.length > 1;
	    } else {
	      this.isDraggable = this.options.draggable;
	    }
	    if (this.isDraggable) {
	      this.element.classList.add('is-draggable');
	    } else {
	      this.element.classList.remove('is-draggable');
	    }
	  };
	
	  // backwards compatibility
	  proto.bindDrag = function () {
	    this.options.draggable = true;
	    this.updateDraggable();
	  };
	
	  proto.unbindDrag = function () {
	    this.options.draggable = false;
	    this.updateDraggable();
	  };
	
	  proto._uiChangeDrag = function () {
	    delete this.isFreeScrolling;
	  };
	
	  // -------------------------- pointer events -------------------------- //
	
	  proto.pointerDown = function (event, pointer) {
	    if (!this.isDraggable) {
	      this._pointerDownDefault(event, pointer);
	      return;
	    }
	    var isOkay = this.okayPointerDown(event);
	    if (!isOkay) {
	      return;
	    }
	
	    this._pointerDownPreventDefault(event);
	    this.pointerDownFocus(event);
	    // blur
	    if (document.activeElement != this.element) {
	      // do not blur if already focused
	      this.pointerDownBlur();
	    }
	
	    // stop if it was moving
	    this.dragX = this.x;
	    this.viewport.classList.add('is-pointer-down');
	    // track scrolling
	    this.pointerDownScroll = getScrollPosition();
	    window.addEventListener('scroll', this);
	
	    this._pointerDownDefault(event, pointer);
	  };
	
	  // default pointerDown logic, used for staticClick
	  proto._pointerDownDefault = function (event, pointer) {
	    // track start event position
	    // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
	    this.pointerDownPointer = {
	      pageX: pointer.pageX,
	      pageY: pointer.pageY
	    };
	    // bind move and end events
	    this._bindPostStartEvents(event);
	    this.dispatchEvent('pointerDown', event, [pointer]);
	  };
	
	  var focusNodes = {
	    INPUT: true,
	    TEXTAREA: true,
	    SELECT: true
	  };
	
	  proto.pointerDownFocus = function (event) {
	    var isFocusNode = focusNodes[event.target.nodeName];
	    if (!isFocusNode) {
	      this.focus();
	    }
	  };
	
	  proto._pointerDownPreventDefault = function (event) {
	    var isTouchStart = event.type == 'touchstart';
	    var isTouchPointer = event.pointerType == 'touch';
	    var isFocusNode = focusNodes[event.target.nodeName];
	    if (!isTouchStart && !isTouchPointer && !isFocusNode) {
	      event.preventDefault();
	    }
	  };
	
	  // ----- move ----- //
	
	  proto.hasDragStarted = function (moveVector) {
	    return Math.abs(moveVector.x) > this.options.dragThreshold;
	  };
	
	  // ----- up ----- //
	
	  proto.pointerUp = function (event, pointer) {
	    delete this.isTouchScrolling;
	    this.viewport.classList.remove('is-pointer-down');
	    this.dispatchEvent('pointerUp', event, [pointer]);
	    this._dragPointerUp(event, pointer);
	  };
	
	  proto.pointerDone = function () {
	    window.removeEventListener('scroll', this);
	    delete this.pointerDownScroll;
	  };
	
	  // -------------------------- dragging -------------------------- //
	
	  proto.dragStart = function (event, pointer) {
	    if (!this.isDraggable) {
	      return;
	    }
	    this.dragStartPosition = this.x;
	    this.startAnimation();
	    window.removeEventListener('scroll', this);
	    this.dispatchEvent('dragStart', event, [pointer]);
	  };
	
	  proto.pointerMove = function (event, pointer) {
	    var moveVector = this._dragPointerMove(event, pointer);
	    this.dispatchEvent('pointerMove', event, [pointer, moveVector]);
	    this._dragMove(event, pointer, moveVector);
	  };
	
	  proto.dragMove = function (event, pointer, moveVector) {
	    if (!this.isDraggable) {
	      return;
	    }
	    event.preventDefault();
	
	    this.previousDragX = this.dragX;
	    // reverse if right-to-left
	    var direction = this.options.rightToLeft ? -1 : 1;
	    if (this.options.wrapAround) {
	      // wrap around move. #589
	      moveVector.x %= this.slideableWidth;
	    }
	    var dragX = this.dragStartPosition + moveVector.x * direction;
	
	    if (!this.options.wrapAround && this.slides.length) {
	      // slow drag
	      var originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
	      dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
	      var endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
	      dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
	    }
	
	    this.dragX = dragX;
	
	    this.dragMoveTime = new Date();
	    this.dispatchEvent('dragMove', event, [pointer, moveVector]);
	  };
	
	  proto.dragEnd = function (event, pointer) {
	    if (!this.isDraggable) {
	      return;
	    }
	    if (this.options.freeScroll) {
	      this.isFreeScrolling = true;
	    }
	    // set selectedIndex based on where flick will end up
	    var index = this.dragEndRestingSelect();
	
	    if (this.options.freeScroll && !this.options.wrapAround) {
	      // if free-scroll & not wrap around
	      // do not free-scroll if going outside of bounding slides
	      // so bounding slides can attract slider, and keep it in bounds
	      var restingX = this.getRestingPosition();
	      this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
	    } else if (!this.options.freeScroll && index == this.selectedIndex) {
	      // boost selection if selected index has not changed
	      index += this.dragEndBoostSelect();
	    }
	    delete this.previousDragX;
	    // apply selection
	    // TODO refactor this, selecting here feels weird
	    // HACK, set flag so dragging stays in correct direction
	    this.isDragSelect = this.options.wrapAround;
	    this.select(index);
	    delete this.isDragSelect;
	    this.dispatchEvent('dragEnd', event, [pointer]);
	  };
	
	  proto.dragEndRestingSelect = function () {
	    var restingX = this.getRestingPosition();
	    // how far away from selected slide
	    var distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
	    // get closet resting going up and going down
	    var positiveResting = this._getClosestResting(restingX, distance, 1);
	    var negativeResting = this._getClosestResting(restingX, distance, -1);
	    // use closer resting for wrap-around
	    var index = positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
	    return index;
	  };
	
	  /**
	   * given resting X and distance to selected cell
	   * get the distance and index of the closest cell
	   * @param {Number} restingX - estimated post-flick resting position
	   * @param {Number} distance - distance to selected cell
	   * @param {Integer} increment - +1 or -1, going up or down
	   * @returns {Object} - { distance: {Number}, index: {Integer} }
	   */
	  proto._getClosestResting = function (restingX, distance, increment) {
	    var index = this.selectedIndex;
	    var minDistance = Infinity;
	    var condition = this.options.contain && !this.options.wrapAround ?
	    // if contain, keep going if distance is equal to minDistance
	    function (dist, minDist) {
	      return dist <= minDist;
	    } : function (dist, minDist) {
	      return dist < minDist;
	    };
	    while (condition(distance, minDistance)) {
	      // measure distance to next cell
	      index += increment;
	      minDistance = distance;
	      distance = this.getSlideDistance(-restingX, index);
	      if (distance === null) {
	        break;
	      }
	      distance = Math.abs(distance);
	    }
	    return {
	      distance: minDistance,
	      // selected was previous index
	      index: index - increment
	    };
	  };
	
	  /**
	   * measure distance between x and a slide target
	   * @param {Number} x - horizontal position
	   * @param {Integer} index - slide index
	   * @returns {Number} - slide distance
	   */
	  proto.getSlideDistance = function (x, index) {
	    var len = this.slides.length;
	    // wrap around if at least 2 slides
	    var isWrapAround = this.options.wrapAround && len > 1;
	    var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
	    var slide = this.slides[slideIndex];
	    if (!slide) {
	      return null;
	    }
	    // add distance for wrap-around slides
	    var wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
	    return x - (slide.target + wrap);
	  };
	
	  proto.dragEndBoostSelect = function () {
	    // do not boost if no previousDragX or dragMoveTime
	    if (this.previousDragX === undefined || !this.dragMoveTime ||
	    // or if drag was held for 100 ms
	    new Date() - this.dragMoveTime > 100) {
	      return 0;
	    }
	
	    var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
	    var delta = this.previousDragX - this.dragX;
	    if (distance > 0 && delta > 0) {
	      // boost to next if moving towards the right, and positive velocity
	      return 1;
	    } else if (distance < 0 && delta < 0) {
	      // boost to previous if moving towards the left, and negative velocity
	      return -1;
	    }
	    return 0;
	  };
	
	  // ----- staticClick ----- //
	
	  proto.staticClick = function (event, pointer) {
	    // get clickedCell, if cell was clicked
	    var clickedCell = this.getParentCell(event.target);
	    var cellElem = clickedCell && clickedCell.element;
	    var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
	    this.dispatchEvent('staticClick', event, [pointer, cellElem, cellIndex]);
	  };
	
	  // ----- scroll ----- //
	
	  proto.onscroll = function () {
	    var scroll = getScrollPosition();
	    var scrollMoveX = this.pointerDownScroll.x - scroll.x;
	    var scrollMoveY = this.pointerDownScroll.y - scroll.y;
	    // cancel click/tap if scroll is too much
	    if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
	      this._pointerDone();
	    }
	  };
	
	  // ----- utils ----- //
	
	  function getScrollPosition() {
	    return {
	      x: window.pageXOffset,
	      y: window.pageYOffset
	    };
	  }
	
	  // -----  ----- //
	
	  return Flickity;
	});

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * Flickity v2.3.0
	 * Touch, responsive, flickable carousels
	 *
	 * Licensed GPLv3 for open source use
	 * or Flickity Commercial License for commercial use
	 *
	 * https://flickity.metafizzy.co
	 * Copyright 2015-2021 Metafizzy
	 */
	
	(function (window, factory) {
	  // universal module definition
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(46), __webpack_require__(346), __webpack_require__(351), __webpack_require__(349), __webpack_require__(350), __webpack_require__(343), __webpack_require__(348)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory(require('./flickity'), require('./drag'), require('./prev-next-button'), require('./page-dots'), require('./player'), require('./add-remove-cell'), require('./lazyload'));
	  }
	})(window, function factory(Flickity) {
	  return Flickity;
	});

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// lazyload
	(function (window, factory) {
	  // universal module definition
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(46), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, utils) {
	      return factory(window, Flickity, utils);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory(window, require('./flickity'), require('fizzy-ui-utils'));
	  } else {
	    // browser global
	    factory(window, window.Flickity, window.fizzyUIUtils);
	  }
	})(window, function factory(window, Flickity, utils) {
	  'use strict';
	
	  Flickity.createMethods.push('_createLazyload');
	  var proto = Flickity.prototype;
	
	  proto._createLazyload = function () {
	    this.on('select', this.lazyLoad);
	  };
	
	  proto.lazyLoad = function () {
	    var lazyLoad = this.options.lazyLoad;
	    if (!lazyLoad) {
	      return;
	    }
	    // get adjacent cells, use lazyLoad option for adjacent count
	    var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
	    var cellElems = this.getAdjacentCellElements(adjCount);
	    // get lazy images in those cells
	    var lazyImages = [];
	    cellElems.forEach(function (cellElem) {
	      var lazyCellImages = getCellLazyImages(cellElem);
	      lazyImages = lazyImages.concat(lazyCellImages);
	    });
	    // load lazy images
	    lazyImages.forEach(function (img) {
	      new LazyLoader(img, this);
	    }, this);
	  };
	
	  function getCellLazyImages(cellElem) {
	    // check if cell element is lazy image
	    if (cellElem.nodeName == 'IMG') {
	      var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
	      var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
	      var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
	      if (lazyloadAttr || srcAttr || srcsetAttr) {
	        return [cellElem];
	      }
	    }
	    // select lazy images in cell
	    var lazySelector = 'img[data-flickity-lazyload], ' + 'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
	    var imgs = cellElem.querySelectorAll(lazySelector);
	    return utils.makeArray(imgs);
	  }
	
	  // -------------------------- LazyLoader -------------------------- //
	
	  /**
	   * class to handle loading images
	   * @param {Image} img - Image element
	   * @param {Flickity} flickity - Flickity instance
	   */
	  function LazyLoader(img, flickity) {
	    this.img = img;
	    this.flickity = flickity;
	    this.load();
	  }
	
	  LazyLoader.prototype.handleEvent = utils.handleEvent;
	
	  LazyLoader.prototype.load = function () {
	    this.img.addEventListener('load', this);
	    this.img.addEventListener('error', this);
	    // get src & srcset
	    var src = this.img.getAttribute('data-flickity-lazyload') || this.img.getAttribute('data-flickity-lazyload-src');
	    var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
	    // set src & serset
	    this.img.src = src;
	    if (srcset) {
	      this.img.setAttribute('srcset', srcset);
	    }
	    // remove attr
	    this.img.removeAttribute('data-flickity-lazyload');
	    this.img.removeAttribute('data-flickity-lazyload-src');
	    this.img.removeAttribute('data-flickity-lazyload-srcset');
	  };
	
	  LazyLoader.prototype.onload = function (event) {
	    this.complete(event, 'flickity-lazyloaded');
	  };
	
	  LazyLoader.prototype.onerror = function (event) {
	    this.complete(event, 'flickity-lazyerror');
	  };
	
	  LazyLoader.prototype.complete = function (event, className) {
	    // unbind events
	    this.img.removeEventListener('load', this);
	    this.img.removeEventListener('error', this);
	
	    var cell = this.flickity.getParentCell(this.img);
	    var cellElem = cell && cell.element;
	    this.flickity.cellSizeChange(cellElem);
	
	    this.img.classList.add(className);
	    this.flickity.dispatchEvent('lazyLoad', event, cellElem);
	  };
	
	  // -----  ----- //
	
	  Flickity.LazyLoader = LazyLoader;
	
	  return Flickity;
	});

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// page dots
	(function (window, factory) {
	  // universal module definition
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(46), __webpack_require__(98), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, Unipointer, utils) {
	      return factory(window, Flickity, Unipointer, utils);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory(window, require('./flickity'), require('unipointer'), require('fizzy-ui-utils'));
	  } else {
	    // browser global
	    factory(window, window.Flickity, window.Unipointer, window.fizzyUIUtils);
	  }
	})(window, function factory(window, Flickity, Unipointer, utils) {
	
	  // -------------------------- PageDots -------------------------- //
	
	  'use strict';
	
	  function PageDots(parent) {
	    this.parent = parent;
	    this._create();
	  }
	
	  PageDots.prototype = Object.create(Unipointer.prototype);
	
	  PageDots.prototype._create = function () {
	    // create holder element
	    this.holder = document.createElement('ol');
	    this.holder.className = 'flickity-page-dots';
	    // create dots, array of elements
	    this.dots = [];
	    // events
	    this.handleClick = this.onClick.bind(this);
	    this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
	  };
	
	  PageDots.prototype.activate = function () {
	    this.setDots();
	    this.holder.addEventListener('click', this.handleClick);
	    this.bindStartEvent(this.holder);
	    // add to DOM
	    this.parent.element.appendChild(this.holder);
	  };
	
	  PageDots.prototype.deactivate = function () {
	    this.holder.removeEventListener('click', this.handleClick);
	    this.unbindStartEvent(this.holder);
	    // remove from DOM
	    this.parent.element.removeChild(this.holder);
	  };
	
	  PageDots.prototype.setDots = function () {
	    // get difference between number of slides and number of dots
	    var delta = this.parent.slides.length - this.dots.length;
	    if (delta > 0) {
	      this.addDots(delta);
	    } else if (delta < 0) {
	      this.removeDots(-delta);
	    }
	  };
	
	  PageDots.prototype.addDots = function (count) {
	    var fragment = document.createDocumentFragment();
	    var newDots = [];
	    var length = this.dots.length;
	    var max = length + count;
	
	    for (var i = length; i < max; i++) {
	      var dot = document.createElement('li');
	      dot.className = 'dot';
	      dot.setAttribute('aria-label', 'Page dot ' + (i + 1));
	      fragment.appendChild(dot);
	      newDots.push(dot);
	    }
	
	    this.holder.appendChild(fragment);
	    this.dots = this.dots.concat(newDots);
	  };
	
	  PageDots.prototype.removeDots = function (count) {
	    // remove from this.dots collection
	    var removeDots = this.dots.splice(this.dots.length - count, count);
	    // remove from DOM
	    removeDots.forEach(function (dot) {
	      this.holder.removeChild(dot);
	    }, this);
	  };
	
	  PageDots.prototype.updateSelected = function () {
	    // remove selected class on previous
	    if (this.selectedDot) {
	      this.selectedDot.className = 'dot';
	      this.selectedDot.removeAttribute('aria-current');
	    }
	    // don't proceed if no dots
	    if (!this.dots.length) {
	      return;
	    }
	    this.selectedDot = this.dots[this.parent.selectedIndex];
	    this.selectedDot.className = 'dot is-selected';
	    this.selectedDot.setAttribute('aria-current', 'step');
	  };
	
	  PageDots.prototype.onTap = // old method name, backwards-compatible
	  PageDots.prototype.onClick = function (event) {
	    var target = event.target;
	    // only care about dot clicks
	    if (target.nodeName != 'LI') {
	      return;
	    }
	
	    this.parent.uiChange();
	    var index = this.dots.indexOf(target);
	    this.parent.select(index);
	  };
	
	  PageDots.prototype.destroy = function () {
	    this.deactivate();
	    this.allOff();
	  };
	
	  Flickity.PageDots = PageDots;
	
	  // -------------------------- Flickity -------------------------- //
	
	  utils.extend(Flickity.defaults, {
	    pageDots: true
	  });
	
	  Flickity.createMethods.push('_createPageDots');
	
	  var proto = Flickity.prototype;
	
	  proto._createPageDots = function () {
	    if (!this.options.pageDots) {
	      return;
	    }
	    this.pageDots = new PageDots(this);
	    // events
	    this.on('activate', this.activatePageDots);
	    this.on('select', this.updateSelectedPageDots);
	    this.on('cellChange', this.updatePageDots);
	    this.on('resize', this.updatePageDots);
	    this.on('deactivate', this.deactivatePageDots);
	  };
	
	  proto.activatePageDots = function () {
	    this.pageDots.activate();
	  };
	
	  proto.updateSelectedPageDots = function () {
	    this.pageDots.updateSelected();
	  };
	
	  proto.updatePageDots = function () {
	    this.pageDots.setDots();
	  };
	
	  proto.deactivatePageDots = function () {
	    this.pageDots.deactivate();
	  };
	
	  // -----  ----- //
	
	  Flickity.PageDots = PageDots;
	
	  return Flickity;
	});

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// player & autoPlay
	(function (window, factory) {
	  // universal module definition
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(70), __webpack_require__(34), __webpack_require__(46)], __WEBPACK_AMD_DEFINE_RESULT__ = function (EvEmitter, utils, Flickity) {
	      return factory(EvEmitter, utils, Flickity);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory(require('ev-emitter'), require('fizzy-ui-utils'), require('./flickity'));
	  } else {
	    // browser global
	    factory(window.EvEmitter, window.fizzyUIUtils, window.Flickity);
	  }
	})(window, function factory(EvEmitter, utils, Flickity) {
	
	  'use strict';
	
	  // -------------------------- Player -------------------------- //
	
	  function Player(parent) {
	    this.parent = parent;
	    this.state = 'stopped';
	    // visibility change event handler
	    this.onVisibilityChange = this.visibilityChange.bind(this);
	    this.onVisibilityPlay = this.visibilityPlay.bind(this);
	  }
	
	  Player.prototype = Object.create(EvEmitter.prototype);
	
	  // start play
	  Player.prototype.play = function () {
	    if (this.state == 'playing') {
	      return;
	    }
	    // do not play if page is hidden, start playing when page is visible
	    var isPageHidden = document.hidden;
	    if (isPageHidden) {
	      document.addEventListener('visibilitychange', this.onVisibilityPlay);
	      return;
	    }
	
	    this.state = 'playing';
	    // listen to visibility change
	    document.addEventListener('visibilitychange', this.onVisibilityChange);
	    // start ticking
	    this.tick();
	  };
	
	  Player.prototype.tick = function () {
	    // do not tick if not playing
	    if (this.state != 'playing') {
	      return;
	    }
	
	    var time = this.parent.options.autoPlay;
	    // default to 3 seconds
	    time = typeof time == 'number' ? time : 3000;
	    var _this = this;
	    // HACK: reset ticks if stopped and started within interval
	    this.clear();
	    this.timeout = setTimeout(function () {
	      _this.parent.next(true);
	      _this.tick();
	    }, time);
	  };
	
	  Player.prototype.stop = function () {
	    this.state = 'stopped';
	    this.clear();
	    // remove visibility change event
	    document.removeEventListener('visibilitychange', this.onVisibilityChange);
	  };
	
	  Player.prototype.clear = function () {
	    clearTimeout(this.timeout);
	  };
	
	  Player.prototype.pause = function () {
	    if (this.state == 'playing') {
	      this.state = 'paused';
	      this.clear();
	    }
	  };
	
	  Player.prototype.unpause = function () {
	    // re-start play if paused
	    if (this.state == 'paused') {
	      this.play();
	    }
	  };
	
	  // pause if page visibility is hidden, unpause if visible
	  Player.prototype.visibilityChange = function () {
	    var isPageHidden = document.hidden;
	    this[isPageHidden ? 'pause' : 'unpause']();
	  };
	
	  Player.prototype.visibilityPlay = function () {
	    this.play();
	    document.removeEventListener('visibilitychange', this.onVisibilityPlay);
	  };
	
	  // -------------------------- Flickity -------------------------- //
	
	  utils.extend(Flickity.defaults, {
	    pauseAutoPlayOnHover: true
	  });
	
	  Flickity.createMethods.push('_createPlayer');
	  var proto = Flickity.prototype;
	
	  proto._createPlayer = function () {
	    this.player = new Player(this);
	
	    this.on('activate', this.activatePlayer);
	    this.on('uiChange', this.stopPlayer);
	    this.on('pointerDown', this.stopPlayer);
	    this.on('deactivate', this.deactivatePlayer);
	  };
	
	  proto.activatePlayer = function () {
	    if (!this.options.autoPlay) {
	      return;
	    }
	    this.player.play();
	    this.element.addEventListener('mouseenter', this);
	  };
	
	  // Player API, don't hate the ... thanks I know where the door is
	
	  proto.playPlayer = function () {
	    this.player.play();
	  };
	
	  proto.stopPlayer = function () {
	    this.player.stop();
	  };
	
	  proto.pausePlayer = function () {
	    this.player.pause();
	  };
	
	  proto.unpausePlayer = function () {
	    this.player.unpause();
	  };
	
	  proto.deactivatePlayer = function () {
	    this.player.stop();
	    this.element.removeEventListener('mouseenter', this);
	  };
	
	  // ----- mouseenter/leave ----- //
	
	  // pause auto-play on hover
	  proto.onmouseenter = function () {
	    if (!this.options.pauseAutoPlayOnHover) {
	      return;
	    }
	    this.player.pause();
	    this.element.addEventListener('mouseleave', this);
	  };
	
	  // resume auto-play on hover off
	  proto.onmouseleave = function () {
	    this.player.unpause();
	    this.element.removeEventListener('mouseleave', this);
	  };
	
	  // -----  ----- //
	
	  Flickity.Player = Player;
	
	  return Flickity;
	});

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// prev/next buttons
	(function (window, factory) {
	  // universal module definition
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(46), __webpack_require__(98), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Flickity, Unipointer, utils) {
	      return factory(window, Flickity, Unipointer, utils);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory(window, require('./flickity'), require('unipointer'), require('fizzy-ui-utils'));
	  } else {
	    // browser global
	    factory(window, window.Flickity, window.Unipointer, window.fizzyUIUtils);
	  }
	})(window, function factory(window, Flickity, Unipointer, utils) {
	  'use strict';
	
	  var svgURI = 'http://www.w3.org/2000/svg';
	
	  // -------------------------- PrevNextButton -------------------------- //
	
	  function PrevNextButton(direction, parent) {
	    this.direction = direction;
	    this.parent = parent;
	    this._create();
	  }
	
	  PrevNextButton.prototype = Object.create(Unipointer.prototype);
	
	  PrevNextButton.prototype._create = function () {
	    // properties
	    this.isEnabled = true;
	    this.isPrevious = this.direction == -1;
	    var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
	    this.isLeft = this.direction == leftDirection;
	
	    var element = this.element = document.createElement('button');
	    element.className = 'flickity-button flickity-prev-next-button';
	    element.className += this.isPrevious ? ' previous' : ' next';
	    // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
	    element.setAttribute('type', 'button');
	    // init as disabled
	    this.disable();
	
	    element.setAttribute('aria-label', this.isPrevious ? 'Previous' : 'Next');
	
	    // create arrow
	    var svg = this.createSVG();
	    element.appendChild(svg);
	    // events
	    this.parent.on('select', this.update.bind(this));
	    this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
	  };
	
	  PrevNextButton.prototype.activate = function () {
	    this.bindStartEvent(this.element);
	    this.element.addEventListener('click', this);
	    // add to DOM
	    this.parent.element.appendChild(this.element);
	  };
	
	  PrevNextButton.prototype.deactivate = function () {
	    // remove from DOM
	    this.parent.element.removeChild(this.element);
	    // click events
	    this.unbindStartEvent(this.element);
	    this.element.removeEventListener('click', this);
	  };
	
	  PrevNextButton.prototype.createSVG = function () {
	    var svg = document.createElementNS(svgURI, 'svg');
	    svg.setAttribute('class', 'flickity-button-icon');
	    svg.setAttribute('viewBox', '0 0 100 100');
	    var path = document.createElementNS(svgURI, 'path');
	    var pathMovements = getArrowMovements(this.parent.options.arrowShape);
	    path.setAttribute('d', pathMovements);
	    path.setAttribute('class', 'arrow');
	    // rotate arrow
	    if (!this.isLeft) {
	      path.setAttribute('transform', 'translate(100, 100) rotate(180) ');
	    }
	    svg.appendChild(path);
	    return svg;
	  };
	
	  // get SVG path movmement
	  function getArrowMovements(shape) {
	    // use shape as movement if string
	    if (typeof shape == 'string') {
	      return shape;
	    }
	    // create movement string
	    return 'M ' + shape.x0 + ',50' + ' L ' + shape.x1 + ',' + (shape.y1 + 50) + ' L ' + shape.x2 + ',' + (shape.y2 + 50) + ' L ' + shape.x3 + ',50 ' + ' L ' + shape.x2 + ',' + (50 - shape.y2) + ' L ' + shape.x1 + ',' + (50 - shape.y1) + ' Z';
	  }
	
	  PrevNextButton.prototype.handleEvent = utils.handleEvent;
	
	  PrevNextButton.prototype.onclick = function () {
	    if (!this.isEnabled) {
	      return;
	    }
	    this.parent.uiChange();
	    var method = this.isPrevious ? 'previous' : 'next';
	    this.parent[method]();
	  };
	
	  // -----  ----- //
	
	  PrevNextButton.prototype.enable = function () {
	    if (this.isEnabled) {
	      return;
	    }
	    this.element.disabled = false;
	    this.isEnabled = true;
	  };
	
	  PrevNextButton.prototype.disable = function () {
	    if (!this.isEnabled) {
	      return;
	    }
	    this.element.disabled = true;
	    this.isEnabled = false;
	  };
	
	  PrevNextButton.prototype.update = function () {
	    // index of first or last slide, if previous or next
	    var slides = this.parent.slides;
	    // enable is wrapAround and at least 2 slides
	    if (this.parent.options.wrapAround && slides.length > 1) {
	      this.enable();
	      return;
	    }
	    var lastIndex = slides.length ? slides.length - 1 : 0;
	    var boundIndex = this.isPrevious ? 0 : lastIndex;
	    var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
	    this[method]();
	  };
	
	  PrevNextButton.prototype.destroy = function () {
	    this.deactivate();
	    this.allOff();
	  };
	
	  // -------------------------- Flickity prototype -------------------------- //
	
	  utils.extend(Flickity.defaults, {
	    prevNextButtons: true,
	    arrowShape: {
	      x0: 10,
	      x1: 60, y1: 50,
	      x2: 70, y2: 40,
	      x3: 30
	    }
	  });
	
	  Flickity.createMethods.push('_createPrevNextButtons');
	  var proto = Flickity.prototype;
	
	  proto._createPrevNextButtons = function () {
	    if (!this.options.prevNextButtons) {
	      return;
	    }
	
	    this.prevButton = new PrevNextButton(-1, this);
	    this.nextButton = new PrevNextButton(1, this);
	
	    this.on('activate', this.activatePrevNextButtons);
	  };
	
	  proto.activatePrevNextButtons = function () {
	    this.prevButton.activate();
	    this.nextButton.activate();
	    this.on('deactivate', this.deactivatePrevNextButtons);
	  };
	
	  proto.deactivatePrevNextButtons = function () {
	    this.prevButton.deactivate();
	    this.nextButton.deactivate();
	    this.off('deactivate', this.deactivatePrevNextButtons);
	  };
	
	  // --------------------------  -------------------------- //
	
	  Flickity.PrevNextButton = PrevNextButton;
	
	  return Flickity;
	});

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// slide
	(function (window, factory) {
	  // universal module definition
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory();
	  } else {
	    // browser global
	    window.Flickity = window.Flickity || {};
	    window.Flickity.Slide = factory();
	  }
	})(window, function factory() {
	  'use strict';
	
	  function Slide(parent) {
	    this.parent = parent;
	    this.isOriginLeft = parent.originSide == 'left';
	    this.cells = [];
	    this.outerWidth = 0;
	    this.height = 0;
	  }
	
	  var proto = Slide.prototype;
	
	  proto.addCell = function (cell) {
	    this.cells.push(cell);
	    this.outerWidth += cell.size.outerWidth;
	    this.height = Math.max(cell.size.outerHeight, this.height);
	    // first cell stuff
	    if (this.cells.length == 1) {
	      this.x = cell.x; // x comes from first cell
	      var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
	      this.firstMargin = cell.size[beginMargin];
	    }
	  };
	
	  proto.updateTarget = function () {
	    var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
	    var lastCell = this.getLastCell();
	    var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
	    var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
	    this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
	  };
	
	  proto.getLastCell = function () {
	    return this.cells[this.cells.length - 1];
	  };
	
	  proto.select = function () {
	    this.cells.forEach(function (cell) {
	      cell.select();
	    });
	  };
	
	  proto.unselect = function () {
	    this.cells.forEach(function (cell) {
	      cell.unselect();
	    });
	  };
	
	  proto.getCellElements = function () {
	    return this.cells.map(function (cell) {
	      return cell.element;
	    });
	  };
	
	  return Slide;
	});

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * imagesLoaded v4.1.4
	 * JavaScript is all like "You images are done yet or what?"
	 * MIT License
	 */
	
	(function (window, factory) {
	  'use strict';
	  // universal module definition
	
	  /*global define: false, module: false, require: false */
	
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(70)], __WEBPACK_AMD_DEFINE_RESULT__ = function (EvEmitter) {
	      return factory(window, EvEmitter);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory(window, require('ev-emitter'));
	  } else {
	    // browser global
	    window.imagesLoaded = factory(window, window.EvEmitter);
	  }
	})(typeof window !== 'undefined' ? window : undefined,
	
	// --------------------------  factory -------------------------- //
	
	function factory(window, EvEmitter) {
	
	  'use strict';
	
	  var $ = window.jQuery;
	  var console = window.console;
	
	  // -------------------------- helpers -------------------------- //
	
	  // extend objects
	  function extend(a, b) {
	    for (var prop in b) {
	      a[prop] = b[prop];
	    }
	    return a;
	  }
	
	  var arraySlice = Array.prototype.slice;
	
	  // turn element or nodeList into an array
	  function makeArray(obj) {
	    if (Array.isArray(obj)) {
	      // use object if already an array
	      return obj;
	    }
	
	    var isArrayLike = (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) == 'object' && typeof obj.length == 'number';
	    if (isArrayLike) {
	      // convert nodeList to array
	      return arraySlice.call(obj);
	    }
	
	    // array of single index
	    return [obj];
	  }
	
	  // -------------------------- imagesLoaded -------------------------- //
	
	  /**
	   * @param {Array, Element, NodeList, String} elem
	   * @param {Object or Function} options - if function, use as callback
	   * @param {Function} onAlways - callback function
	   */
	  function ImagesLoaded(elem, options, onAlways) {
	    // coerce ImagesLoaded() without new, to be new ImagesLoaded()
	    if (!(this instanceof ImagesLoaded)) {
	      return new ImagesLoaded(elem, options, onAlways);
	    }
	    // use elem as selector string
	    var queryElem = elem;
	    if (typeof elem == 'string') {
	      queryElem = document.querySelectorAll(elem);
	    }
	    // bail if bad element
	    if (!queryElem) {
	      console.error('Bad element for imagesLoaded ' + (queryElem || elem));
	      return;
	    }
	
	    this.elements = makeArray(queryElem);
	    this.options = extend({}, this.options);
	    // shift arguments if no options set
	    if (typeof options == 'function') {
	      onAlways = options;
	    } else {
	      extend(this.options, options);
	    }
	
	    if (onAlways) {
	      this.on('always', onAlways);
	    }
	
	    this.getImages();
	
	    if ($) {
	      // add jQuery Deferred object
	      this.jqDeferred = new $.Deferred();
	    }
	
	    // HACK check async to allow time to bind listeners
	    setTimeout(this.check.bind(this));
	  }
	
	  ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
	
	  ImagesLoaded.prototype.options = {};
	
	  ImagesLoaded.prototype.getImages = function () {
	    this.images = [];
	
	    // filter & find items if we have an item selector
	    this.elements.forEach(this.addElementImages, this);
	  };
	
	  /**
	   * @param {Node} element
	   */
	  ImagesLoaded.prototype.addElementImages = function (elem) {
	    // filter siblings
	    if (elem.nodeName == 'IMG') {
	      this.addImage(elem);
	    }
	    // get background image on element
	    if (this.options.background === true) {
	      this.addElementBackgroundImages(elem);
	    }
	
	    // find children
	    // no non-element nodes, #143
	    var nodeType = elem.nodeType;
	    if (!nodeType || !elementNodeTypes[nodeType]) {
	      return;
	    }
	    var childImgs = elem.querySelectorAll('img');
	    // concat childElems to filterFound array
	    for (var i = 0; i < childImgs.length; i++) {
	      var img = childImgs[i];
	      this.addImage(img);
	    }
	
	    // get child background images
	    if (typeof this.options.background == 'string') {
	      var children = elem.querySelectorAll(this.options.background);
	      for (i = 0; i < children.length; i++) {
	        var child = children[i];
	        this.addElementBackgroundImages(child);
	      }
	    }
	  };
	
	  var elementNodeTypes = {
	    1: true,
	    9: true,
	    11: true
	  };
	
	  ImagesLoaded.prototype.addElementBackgroundImages = function (elem) {
	    var style = getComputedStyle(elem);
	    if (!style) {
	      // Firefox returns null if in a hidden iframe https://bugzil.la/548397
	      return;
	    }
	    // get url inside url("...")
	    var reURL = /url\((['"])?(.*?)\1\)/gi;
	    var matches = reURL.exec(style.backgroundImage);
	    while (matches !== null) {
	      var url = matches && matches[2];
	      if (url) {
	        this.addBackground(url, elem);
	      }
	      matches = reURL.exec(style.backgroundImage);
	    }
	  };
	
	  /**
	   * @param {Image} img
	   */
	  ImagesLoaded.prototype.addImage = function (img) {
	    var loadingImage = new LoadingImage(img);
	    this.images.push(loadingImage);
	  };
	
	  ImagesLoaded.prototype.addBackground = function (url, elem) {
	    var background = new Background(url, elem);
	    this.images.push(background);
	  };
	
	  ImagesLoaded.prototype.check = function () {
	    var _this = this;
	    this.progressedCount = 0;
	    this.hasAnyBroken = false;
	    // complete if no images
	    if (!this.images.length) {
	      this.complete();
	      return;
	    }
	
	    function onProgress(image, elem, message) {
	      // HACK - Chrome triggers event before object properties have changed. #83
	      setTimeout(function () {
	        _this.progress(image, elem, message);
	      });
	    }
	
	    this.images.forEach(function (loadingImage) {
	      loadingImage.once('progress', onProgress);
	      loadingImage.check();
	    });
	  };
	
	  ImagesLoaded.prototype.progress = function (image, elem, message) {
	    this.progressedCount++;
	    this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
	    // progress event
	    this.emitEvent('progress', [this, image, elem]);
	    if (this.jqDeferred && this.jqDeferred.notify) {
	      this.jqDeferred.notify(this, image);
	    }
	    // check if completed
	    if (this.progressedCount == this.images.length) {
	      this.complete();
	    }
	
	    if (this.options.debug && console) {
	      console.log('progress: ' + message, image, elem);
	    }
	  };
	
	  ImagesLoaded.prototype.complete = function () {
	    var eventName = this.hasAnyBroken ? 'fail' : 'done';
	    this.isComplete = true;
	    this.emitEvent(eventName, [this]);
	    this.emitEvent('always', [this]);
	    if (this.jqDeferred) {
	      var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
	      this.jqDeferred[jqMethod](this);
	    }
	  };
	
	  // --------------------------  -------------------------- //
	
	  function LoadingImage(img) {
	    this.img = img;
	  }
	
	  LoadingImage.prototype = Object.create(EvEmitter.prototype);
	
	  LoadingImage.prototype.check = function () {
	    // If complete is true and browser supports natural sizes,
	    // try to check for image status manually.
	    var isComplete = this.getIsImageComplete();
	    if (isComplete) {
	      // report based on naturalWidth
	      this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
	      return;
	    }
	
	    // If none of the checks above matched, simulate loading on detached element.
	    this.proxyImage = new Image();
	    this.proxyImage.addEventListener('load', this);
	    this.proxyImage.addEventListener('error', this);
	    // bind to image as well for Firefox. #191
	    this.img.addEventListener('load', this);
	    this.img.addEventListener('error', this);
	    this.proxyImage.src = this.img.src;
	  };
	
	  LoadingImage.prototype.getIsImageComplete = function () {
	    // check for non-zero, non-undefined naturalWidth
	    // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
	    return this.img.complete && this.img.naturalWidth;
	  };
	
	  LoadingImage.prototype.confirm = function (isLoaded, message) {
	    this.isLoaded = isLoaded;
	    this.emitEvent('progress', [this, this.img, message]);
	  };
	
	  // ----- events ----- //
	
	  // trigger specified handler for event type
	  LoadingImage.prototype.handleEvent = function (event) {
	    var method = 'on' + event.type;
	    if (this[method]) {
	      this[method](event);
	    }
	  };
	
	  LoadingImage.prototype.onload = function () {
	    this.confirm(true, 'onload');
	    this.unbindEvents();
	  };
	
	  LoadingImage.prototype.onerror = function () {
	    this.confirm(false, 'onerror');
	    this.unbindEvents();
	  };
	
	  LoadingImage.prototype.unbindEvents = function () {
	    this.proxyImage.removeEventListener('load', this);
	    this.proxyImage.removeEventListener('error', this);
	    this.img.removeEventListener('load', this);
	    this.img.removeEventListener('error', this);
	  };
	
	  // -------------------------- Background -------------------------- //
	
	  function Background(url, element) {
	    this.url = url;
	    this.element = element;
	    this.img = new Image();
	  }
	
	  // inherit LoadingImage prototype
	  Background.prototype = Object.create(LoadingImage.prototype);
	
	  Background.prototype.check = function () {
	    this.img.addEventListener('load', this);
	    this.img.addEventListener('error', this);
	    this.img.src = this.url;
	    // check if image is already complete
	    var isComplete = this.getIsImageComplete();
	    if (isComplete) {
	      this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
	      this.unbindEvents();
	    }
	  };
	
	  Background.prototype.unbindEvents = function () {
	    this.img.removeEventListener('load', this);
	    this.img.removeEventListener('error', this);
	  };
	
	  Background.prototype.confirm = function (isLoaded, message) {
	    this.isLoaded = isLoaded;
	    this.emitEvent('progress', [this, this.element, message]);
	  };
	
	  // -------------------------- jQuery -------------------------- //
	
	  ImagesLoaded.makeJQueryPlugin = function (jQuery) {
	    jQuery = jQuery || window.jQuery;
	    if (!jQuery) {
	      return;
	    }
	    // set local variable
	    $ = jQuery;
	    // $().imagesLoaded()
	    $.fn.imagesLoaded = function (options, callback) {
	      var instance = new ImagesLoaded(this, options, callback);
	      return instance.jqDeferred.promise($(this));
	    };
	  };
	  // try making plugin
	  ImagesLoaded.makeJQueryPlugin();
	
	  // --------------------------  -------------------------- //
	
	  return ImagesLoaded;
	});

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	(function (factory) {
	  "use strict";
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    module.exports = factory(require("jquery"));
	  } else {
	    factory(jQuery);
	  }
	})(function ($) {
	  $.fn.marquee = function (options) {
	    return this.each(function () {
	      var o = $.extend({}, $.fn.marquee.defaults, options),
	          $this = $(this),
	          $marqueeWrapper,
	          containerWidth,
	          animationCss,
	          verticalDir,
	          elWidth,
	          loopCount = 3,
	          playState = "animation-play-state",
	          css3AnimationIsSupported = false,
	          _prefixedEvent = function _prefixedEvent(element, type, callback) {
	        var pfx = ["webkit", "moz", "MS", "o", ""];for (var p = 0; p < pfx.length; p++) {
	          if (!pfx[p]) type = type.toLowerCase();element.addEventListener(pfx[p] + type, callback, false);
	        }
	      },
	          _objToString = function _objToString(obj) {
	        var tabjson = [];for (var p in obj) {
	          if (obj.hasOwnProperty(p)) {
	            tabjson.push(p + ":" + obj[p]);
	          }
	        }tabjson.push();return "{" + tabjson.join(",") + "}";
	      },
	          _startAnimationWithDelay = function _startAnimationWithDelay() {
	        $this.timer = setTimeout(animate, o.delayBeforeStart);
	      },
	          methods = { pause: function pause() {
	          if (css3AnimationIsSupported && o.allowCss3Support) {
	            $marqueeWrapper.css(playState, "paused");
	          } else {
	            if ($.fn.pause) {
	              $marqueeWrapper.pause();
	            }
	          }$this.data("runningStatus", "paused");$this.trigger("paused");
	        }, resume: function resume() {
	          if (css3AnimationIsSupported && o.allowCss3Support) {
	            $marqueeWrapper.css(playState, "running");
	          } else {
	            if ($.fn.resume) {
	              $marqueeWrapper.resume();
	            }
	          }$this.data("runningStatus", "resumed");$this.trigger("resumed");
	        }, toggle: function toggle() {
	          methods[$this.data("runningStatus") === "resumed" ? "pause" : "resume"]();
	        }, destroy: function destroy() {
	          clearTimeout($this.timer);$this.find("*").addBack().off();$this.html($this.find(".js-marquee:first").html());
	        } };if (typeof options === "string") {
	        if ($.isFunction(methods[options])) {
	          if (!$marqueeWrapper) {
	            $marqueeWrapper = $this.find(".js-marquee-wrapper");
	          }if ($this.data("css3AnimationIsSupported") === true) {
	            css3AnimationIsSupported = true;
	          }methods[options]();
	        }return;
	      }var dataAttributes = {},
	          attr;$.each(o, function (key) {
	        attr = $this.attr("data-" + key);if (typeof attr !== "undefined") {
	          switch (attr) {case "true":
	              attr = true;break;case "false":
	              attr = false;break;}o[key] = attr;
	        }
	      });if (o.speed) {
	        o.duration = parseInt($this.width(), 10) / o.speed * 1e3;
	      }verticalDir = o.direction === "up" || o.direction === "down";o.gap = o.duplicated ? parseInt(o.gap) : 0;$this.wrapInner('<div class="js-marquee"></div>');var $el = $this.find(".js-marquee").css({ "margin-right": o.gap, float: "left" });if (o.duplicated) {
	        $el.clone(true).appendTo($this);
	      }$this.wrapInner('<div style="width:100000px" class="js-marquee-wrapper"></div>');$marqueeWrapper = $this.find(".js-marquee-wrapper");if (verticalDir) {
	        var containerHeight = $this.height();$marqueeWrapper.removeAttr("style");$this.height(containerHeight);$this.find(".js-marquee").css({ float: "none", "margin-bottom": o.gap, "margin-right": 0 });if (o.duplicated) {
	          $this.find(".js-marquee:last").css({ "margin-bottom": 0 });
	        }var elHeight = $this.find(".js-marquee:first").height() + o.gap;if (o.startVisible && !o.duplicated) {
	          o._completeDuration = (parseInt(elHeight, 10) + parseInt(containerHeight, 10)) / parseInt(containerHeight, 10) * o.duration;o.duration = parseInt(elHeight, 10) / parseInt(containerHeight, 10) * o.duration;
	        } else {
	          o.duration = (parseInt(elHeight, 10) + parseInt(containerHeight, 10)) / parseInt(containerHeight, 10) * o.duration;
	        }
	      } else {
	        elWidth = $this.find(".js-marquee:first").width() + o.gap;containerWidth = $this.width();if (o.startVisible && !o.duplicated) {
	          o._completeDuration = (parseInt(elWidth, 10) + parseInt(containerWidth, 10)) / parseInt(containerWidth, 10) * o.duration;o.duration = parseInt(elWidth, 10) / parseInt(containerWidth, 10) * o.duration;
	        } else {
	          o.duration = (parseInt(elWidth, 10) + parseInt(containerWidth, 10)) / parseInt(containerWidth, 10) * o.duration;
	        }
	      }if (o.duplicated) {
	        o.duration = o.duration / 2;
	      }if (o.allowCss3Support) {
	        var elm = document.body || document.createElement("div"),
	            animationName = "marqueeAnimation-" + Math.floor(Math.random() * 1e7),
	            domPrefixes = "Webkit Moz O ms Khtml".split(" "),
	            animationString = "animation",
	            animationCss3Str = "",
	            keyframeString = "";if (elm.style.animation !== undefined) {
	          keyframeString = "@keyframes " + animationName + " ";css3AnimationIsSupported = true;
	        }if (css3AnimationIsSupported === false) {
	          for (var i = 0; i < domPrefixes.length; i++) {
	            if (elm.style[domPrefixes[i] + "AnimationName"] !== undefined) {
	              var prefix = "-" + domPrefixes[i].toLowerCase() + "-";animationString = prefix + animationString;playState = prefix + playState;keyframeString = "@" + prefix + "keyframes " + animationName + " ";css3AnimationIsSupported = true;break;
	            }
	          }
	        }if (css3AnimationIsSupported) {
	          animationCss3Str = animationName + " " + o.duration / 1e3 + "s " + o.delayBeforeStart / 1e3 + "s infinite " + o.css3easing;$this.data("css3AnimationIsSupported", true);
	        }
	      }var _rePositionVertically = function _rePositionVertically() {
	        $marqueeWrapper.css("transform", "translateY(" + (o.direction === "up" ? containerHeight + "px" : "-" + elHeight + "px") + ")");
	      },
	          _rePositionHorizontally = function _rePositionHorizontally() {
	        $marqueeWrapper.css("transform", "translateX(" + (o.direction === "left" ? containerWidth + "px" : "-" + elWidth + "px") + ")");
	      };if (o.duplicated) {
	        if (verticalDir) {
	          if (o.startVisible) {
	            $marqueeWrapper.css("transform", "translateY(0)");
	          } else {
	            $marqueeWrapper.css("transform", "translateY(" + (o.direction === "up" ? containerHeight + "px" : "-" + (elHeight * 2 - o.gap) + "px") + ")");
	          }
	        } else {
	          if (o.startVisible) {
	            $marqueeWrapper.css("transform", "translateX(0)");
	          } else {
	            $marqueeWrapper.css("transform", "translateX(" + (o.direction === "left" ? containerWidth + "px" : "-" + (elWidth * 2 - o.gap) + "px") + ")");
	          }
	        }if (!o.startVisible) {
	          loopCount = 1;
	        }
	      } else if (o.startVisible) {
	        loopCount = 2;
	      } else {
	        if (verticalDir) {
	          _rePositionVertically();
	        } else {
	          _rePositionHorizontally();
	        }
	      }var animate = function animate() {
	        if (o.duplicated) {
	          if (loopCount === 1) {
	            o._originalDuration = o.duration;if (verticalDir) {
	              o.duration = o.direction === "up" ? o.duration + containerHeight / (elHeight / o.duration) : o.duration * 2;
	            } else {
	              o.duration = o.direction === "left" ? o.duration + containerWidth / (elWidth / o.duration) : o.duration * 2;
	            }if (animationCss3Str) {
	              animationCss3Str = animationName + " " + o.duration / 1e3 + "s " + o.delayBeforeStart / 1e3 + "s " + o.css3easing;
	            }loopCount++;
	          } else if (loopCount === 2) {
	            o.duration = o._originalDuration;if (animationCss3Str) {
	              animationName = animationName + "0";keyframeString = $.trim(keyframeString) + "0 ";animationCss3Str = animationName + " " + o.duration / 1e3 + "s 0s infinite " + o.css3easing;
	            }loopCount++;
	          }
	        }if (verticalDir) {
	          if (o.duplicated) {
	            if (loopCount > 2) {
	              $marqueeWrapper.css("transform", "translateY(" + (o.direction === "up" ? 0 : "-" + elHeight + "px") + ")");
	            }animationCss = { transform: "translateY(" + (o.direction === "up" ? "-" + elHeight + "px" : 0) + ")" };
	          } else if (o.startVisible) {
	            if (loopCount === 2) {
	              if (animationCss3Str) {
	                animationCss3Str = animationName + " " + o.duration / 1e3 + "s " + o.delayBeforeStart / 1e3 + "s " + o.css3easing;
	              }animationCss = { transform: "translateY(" + (o.direction === "up" ? "-" + elHeight + "px" : containerHeight + "px") + ")" };loopCount++;
	            } else if (loopCount === 3) {
	              o.duration = o._completeDuration;if (animationCss3Str) {
	                animationName = animationName + "0";keyframeString = $.trim(keyframeString) + "0 ";animationCss3Str = animationName + " " + o.duration / 1e3 + "s 0s infinite " + o.css3easing;
	              }_rePositionVertically();
	            }
	          } else {
	            _rePositionVertically();animationCss = { transform: "translateY(" + (o.direction === "up" ? "-" + $marqueeWrapper.height() + "px" : containerHeight + "px") + ")" };
	          }
	        } else {
	          if (o.duplicated) {
	            if (loopCount > 2) {
	              $marqueeWrapper.css("transform", "translateX(" + (o.direction === "left" ? 0 : "-" + elWidth + "px") + ")");
	            }animationCss = { transform: "translateX(" + (o.direction === "left" ? "-" + elWidth + "px" : 0) + ")" };
	          } else if (o.startVisible) {
	            if (loopCount === 2) {
	              if (animationCss3Str) {
	                animationCss3Str = animationName + " " + o.duration / 1e3 + "s " + o.delayBeforeStart / 1e3 + "s " + o.css3easing;
	              }animationCss = { transform: "translateX(" + (o.direction === "left" ? "-" + elWidth + "px" : containerWidth + "px") + ")" };loopCount++;
	            } else if (loopCount === 3) {
	              o.duration = o._completeDuration;if (animationCss3Str) {
	                animationName = animationName + "0";keyframeString = $.trim(keyframeString) + "0 ";animationCss3Str = animationName + " " + o.duration / 1e3 + "s 0s infinite " + o.css3easing;
	              }_rePositionHorizontally();
	            }
	          } else {
	            _rePositionHorizontally();animationCss = { transform: "translateX(" + (o.direction === "left" ? "-" + elWidth + "px" : containerWidth + "px") + ")" };
	          }
	        }$this.trigger("beforeStarting");if (css3AnimationIsSupported) {
	          $marqueeWrapper.css(animationString, animationCss3Str);var keyframeCss = keyframeString + " { 100%  " + _objToString(animationCss) + "}",
	              $styles = $marqueeWrapper.find("style");if ($styles.length !== 0) {
	            $styles.filter(":last").html(keyframeCss);
	          } else {
	            $("head").append("<style>" + keyframeCss + "</style>");
	          }_prefixedEvent($marqueeWrapper[0], "AnimationIteration", function () {
	            $this.trigger("finished");
	          });_prefixedEvent($marqueeWrapper[0], "AnimationEnd", function () {
	            animate();$this.trigger("finished");
	          });
	        } else {
	          $marqueeWrapper.animate(animationCss, o.duration, o.easing, function () {
	            $this.trigger("finished");if (o.pauseOnCycle) {
	              _startAnimationWithDelay();
	            } else {
	              animate();
	            }
	          });
	        }$this.data("runningStatus", "resumed");
	      };$this.on("pause", methods.pause);$this.on("resume", methods.resume);if (o.pauseOnHover) {
	        $this.on("mouseenter", methods.pause);$this.on("mouseleave", methods.resume);
	      }if (css3AnimationIsSupported && o.allowCss3Support) {
	        animate();
	      } else {
	        _startAnimationWithDelay();
	      }
	    });
	  };$.fn.marquee.defaults = { allowCss3Support: true, css3easing: "linear", easing: "linear", delayBeforeStart: 1e3, direction: "left", duplicated: false, duration: 5e3, speed: 0, gap: 20, pauseOnCycle: false, pauseOnHover: false, startVisible: false };
	});

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var require;var require;/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * The MIT License (MIT)
	 *
	 * Copyright (c) 2015 p2.js authors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 */
	!function (e) {
	    if ("object" == ( false ? "undefined" : _typeof(exports))) module.exports = e();else if (false) define(e);else {
	        var f;"undefined" != typeof window ? f = window : "undefined" != typeof global ? f = global : "undefined" != typeof self && (f = self), f.p2 = e();
	    }
	}(function () {
	    var define, module, exports;return function e(t, n, r) {
	        function s(o, u) {
	            if (!n[o]) {
	                if (!t[o]) {
	                    var a = typeof require == "function" && require;if (!u && a) return require(o, !0);if (i) return i(o, !0);throw new Error("Cannot find module '" + o + "'");
	                }var f = n[o] = { exports: {} };t[o][0].call(f.exports, function (e) {
	                    var n = t[o][1][e];return s(n ? n : e);
	                }, f, f.exports, e, t, n, r);
	            }return n[o].exports;
	        }var i = typeof require == "function" && require;for (var o = 0; o < r.length; o++) {
	            s(r[o]);
	        }return s;
	    }({ 1: [function (_dereq_, module, exports) {
	            var Scalar = _dereq_('./Scalar');
	
	            module.exports = Line;
	
	            /**
	             * Container for line-related functions
	             * @class Line
	             */
	            function Line() {};
	
	            /**
	             * Compute the intersection between two lines.
	             * @static
	             * @method lineInt
	             * @param  {Array}  l1          Line vector 1
	             * @param  {Array}  l2          Line vector 2
	             * @param  {Number} precision   Precision to use when checking if the lines are parallel
	             * @return {Array}              The intersection point.
	             */
	            Line.lineInt = function (l1, l2, precision) {
	                precision = precision || 0;
	                var i = [0, 0]; // point
	                var a1, b1, c1, a2, b2, c2, det; // scalars
	                a1 = l1[1][1] - l1[0][1];
	                b1 = l1[0][0] - l1[1][0];
	                c1 = a1 * l1[0][0] + b1 * l1[0][1];
	                a2 = l2[1][1] - l2[0][1];
	                b2 = l2[0][0] - l2[1][0];
	                c2 = a2 * l2[0][0] + b2 * l2[0][1];
	                det = a1 * b2 - a2 * b1;
	                if (!Scalar.eq(det, 0, precision)) {
	                    // lines are not parallel
	                    i[0] = (b2 * c1 - b1 * c2) / det;
	                    i[1] = (a1 * c2 - a2 * c1) / det;
	                }
	                return i;
	            };
	
	            /**
	             * Checks if two line segments intersects.
	             * @method segmentsIntersect
	             * @param {Array} p1 The start vertex of the first line segment.
	             * @param {Array} p2 The end vertex of the first line segment.
	             * @param {Array} q1 The start vertex of the second line segment.
	             * @param {Array} q2 The end vertex of the second line segment.
	             * @return {Boolean} True if the two line segments intersect
	             */
	            Line.segmentsIntersect = function (p1, p2, q1, q2) {
	                var dx = p2[0] - p1[0];
	                var dy = p2[1] - p1[1];
	                var da = q2[0] - q1[0];
	                var db = q2[1] - q1[1];
	
	                // segments are parallel
	                if (da * dy - db * dx == 0) return false;
	
	                var s = (dx * (q1[1] - p1[1]) + dy * (p1[0] - q1[0])) / (da * dy - db * dx);
	                var t = (da * (p1[1] - q1[1]) + db * (q1[0] - p1[0])) / (db * dx - da * dy);
	
	                return s >= 0 && s <= 1 && t >= 0 && t <= 1;
	            };
	        }, { "./Scalar": 4 }], 2: [function (_dereq_, module, exports) {
	            module.exports = Point;
	
	            /**
	             * Point related functions
	             * @class Point
	             */
	            function Point() {};
	
	            /**
	             * Get the area of a triangle spanned by the three given points. Note that the area will be negative if the points are not given in counter-clockwise order.
	             * @static
	             * @method area
	             * @param  {Array} a
	             * @param  {Array} b
	             * @param  {Array} c
	             * @return {Number}
	             */
	            Point.area = function (a, b, c) {
	                return (b[0] - a[0]) * (c[1] - a[1]) - (c[0] - a[0]) * (b[1] - a[1]);
	            };
	
	            Point.left = function (a, b, c) {
	                return Point.area(a, b, c) > 0;
	            };
	
	            Point.leftOn = function (a, b, c) {
	                return Point.area(a, b, c) >= 0;
	            };
	
	            Point.right = function (a, b, c) {
	                return Point.area(a, b, c) < 0;
	            };
	
	            Point.rightOn = function (a, b, c) {
	                return Point.area(a, b, c) <= 0;
	            };
	
	            var tmpPoint1 = [],
	                tmpPoint2 = [];
	
	            /**
	             * Check if three points are collinear
	             * @method collinear
	             * @param  {Array} a
	             * @param  {Array} b
	             * @param  {Array} c
	             * @param  {Number} [thresholdAngle=0] Threshold angle to use when comparing the vectors. The function will return true if the angle between the resulting vectors is less than this value. Use zero for max precision.
	             * @return {Boolean}
	             */
	            Point.collinear = function (a, b, c, thresholdAngle) {
	                if (!thresholdAngle) return Point.area(a, b, c) == 0;else {
	                    var ab = tmpPoint1,
	                        bc = tmpPoint2;
	
	                    ab[0] = b[0] - a[0];
	                    ab[1] = b[1] - a[1];
	                    bc[0] = c[0] - b[0];
	                    bc[1] = c[1] - b[1];
	
	                    var dot = ab[0] * bc[0] + ab[1] * bc[1],
	                        magA = Math.sqrt(ab[0] * ab[0] + ab[1] * ab[1]),
	                        magB = Math.sqrt(bc[0] * bc[0] + bc[1] * bc[1]),
	                        angle = Math.acos(dot / (magA * magB));
	                    return angle < thresholdAngle;
	                }
	            };
	
	            Point.sqdist = function (a, b) {
	                var dx = b[0] - a[0];
	                var dy = b[1] - a[1];
	                return dx * dx + dy * dy;
	            };
	        }, {}], 3: [function (_dereq_, module, exports) {
	            var Line = _dereq_("./Line"),
	                Point = _dereq_("./Point"),
	                Scalar = _dereq_("./Scalar");
	
	            module.exports = Polygon;
	
	            /**
	             * Polygon class.
	             * @class Polygon
	             * @constructor
	             */
	            function Polygon() {
	
	                /**
	                 * Vertices that this polygon consists of. An array of array of numbers, example: [[0,0],[1,0],..]
	                 * @property vertices
	                 * @type {Array}
	                 */
	                this.vertices = [];
	            }
	
	            /**
	             * Get a vertex at position i. It does not matter if i is out of bounds, this function will just cycle.
	             * @method at
	             * @param  {Number} i
	             * @return {Array}
	             */
	            Polygon.prototype.at = function (i) {
	                var v = this.vertices,
	                    s = v.length;
	                return v[i < 0 ? i % s + s : i % s];
	            };
	
	            /**
	             * Get first vertex
	             * @method first
	             * @return {Array}
	             */
	            Polygon.prototype.first = function () {
	                return this.vertices[0];
	            };
	
	            /**
	             * Get last vertex
	             * @method last
	             * @return {Array}
	             */
	            Polygon.prototype.last = function () {
	                return this.vertices[this.vertices.length - 1];
	            };
	
	            /**
	             * Clear the polygon data
	             * @method clear
	             * @return {Array}
	             */
	            Polygon.prototype.clear = function () {
	                this.vertices.length = 0;
	            };
	
	            /**
	             * Append points "from" to "to"-1 from an other polygon "poly" onto this one.
	             * @method append
	             * @param {Polygon} poly The polygon to get points from.
	             * @param {Number}  from The vertex index in "poly".
	             * @param {Number}  to The end vertex index in "poly". Note that this vertex is NOT included when appending.
	             * @return {Array}
	             */
	            Polygon.prototype.append = function (poly, from, to) {
	                if (typeof from == "undefined") throw new Error("From is not given!");
	                if (typeof to == "undefined") throw new Error("To is not given!");
	
	                if (to - 1 < from) throw new Error("lol1");
	                if (to > poly.vertices.length) throw new Error("lol2");
	                if (from < 0) throw new Error("lol3");
	
	                for (var i = from; i < to; i++) {
	                    this.vertices.push(poly.vertices[i]);
	                }
	            };
	
	            /**
	             * Make sure that the polygon vertices are ordered counter-clockwise.
	             * @method makeCCW
	             */
	            Polygon.prototype.makeCCW = function () {
	                var br = 0,
	                    v = this.vertices;
	
	                // find bottom right point
	                for (var i = 1; i < this.vertices.length; ++i) {
	                    if (v[i][1] < v[br][1] || v[i][1] == v[br][1] && v[i][0] > v[br][0]) {
	                        br = i;
	                    }
	                }
	
	                // reverse poly if clockwise
	                if (!Point.left(this.at(br - 1), this.at(br), this.at(br + 1))) {
	                    this.reverse();
	                }
	            };
	
	            /**
	             * Reverse the vertices in the polygon
	             * @method reverse
	             */
	            Polygon.prototype.reverse = function () {
	                var tmp = [];
	                for (var i = 0, N = this.vertices.length; i !== N; i++) {
	                    tmp.push(this.vertices.pop());
	                }
	                this.vertices = tmp;
	            };
	
	            /**
	             * Check if a point in the polygon is a reflex point
	             * @method isReflex
	             * @param  {Number}  i
	             * @return {Boolean}
	             */
	            Polygon.prototype.isReflex = function (i) {
	                return Point.right(this.at(i - 1), this.at(i), this.at(i + 1));
	            };
	
	            var tmpLine1 = [],
	                tmpLine2 = [];
	
	            /**
	             * Check if two vertices in the polygon can see each other
	             * @method canSee
	             * @param  {Number} a Vertex index 1
	             * @param  {Number} b Vertex index 2
	             * @return {Boolean}
	             */
	            Polygon.prototype.canSee = function (a, b) {
	                var p,
	                    dist,
	                    l1 = tmpLine1,
	                    l2 = tmpLine2;
	
	                if (Point.leftOn(this.at(a + 1), this.at(a), this.at(b)) && Point.rightOn(this.at(a - 1), this.at(a), this.at(b))) {
	                    return false;
	                }
	                dist = Point.sqdist(this.at(a), this.at(b));
	                for (var i = 0; i !== this.vertices.length; ++i) {
	                    // for each edge
	                    if ((i + 1) % this.vertices.length === a || i === a) // ignore incident edges
	                        continue;
	                    if (Point.leftOn(this.at(a), this.at(b), this.at(i + 1)) && Point.rightOn(this.at(a), this.at(b), this.at(i))) {
	                        // if diag intersects an edge
	                        l1[0] = this.at(a);
	                        l1[1] = this.at(b);
	                        l2[0] = this.at(i);
	                        l2[1] = this.at(i + 1);
	                        p = Line.lineInt(l1, l2);
	                        if (Point.sqdist(this.at(a), p) < dist) {
	                            // if edge is blocking visibility to b
	                            return false;
	                        }
	                    }
	                }
	
	                return true;
	            };
	
	            /**
	             * Copy the polygon from vertex i to vertex j.
	             * @method copy
	             * @param  {Number} i
	             * @param  {Number} j
	             * @param  {Polygon} [targetPoly]   Optional target polygon to save in.
	             * @return {Polygon}                The resulting copy.
	             */
	            Polygon.prototype.copy = function (i, j, targetPoly) {
	                var p = targetPoly || new Polygon();
	                p.clear();
	                if (i < j) {
	                    // Insert all vertices from i to j
	                    for (var k = i; k <= j; k++) {
	                        p.vertices.push(this.vertices[k]);
	                    }
	                } else {
	
	                    // Insert vertices 0 to j
	                    for (var k = 0; k <= j; k++) {
	                        p.vertices.push(this.vertices[k]);
	                    } // Insert vertices i to end
	                    for (var k = i; k < this.vertices.length; k++) {
	                        p.vertices.push(this.vertices[k]);
	                    }
	                }
	
	                return p;
	            };
	
	            /**
	             * Decomposes the polygon into convex pieces. Returns a list of edges [[p1,p2],[p2,p3],...] that cuts the polygon.
	             * Note that this algorithm has complexity O(N^4) and will be very slow for polygons with many vertices.
	             * @method getCutEdges
	             * @return {Array}
	             */
	            Polygon.prototype.getCutEdges = function () {
	                var min = [],
	                    tmp1 = [],
	                    tmp2 = [],
	                    tmpPoly = new Polygon();
	                var nDiags = Number.MAX_VALUE;
	
	                for (var i = 0; i < this.vertices.length; ++i) {
	                    if (this.isReflex(i)) {
	                        for (var j = 0; j < this.vertices.length; ++j) {
	                            if (this.canSee(i, j)) {
	                                tmp1 = this.copy(i, j, tmpPoly).getCutEdges();
	                                tmp2 = this.copy(j, i, tmpPoly).getCutEdges();
	
	                                for (var k = 0; k < tmp2.length; k++) {
	                                    tmp1.push(tmp2[k]);
	                                }if (tmp1.length < nDiags) {
	                                    min = tmp1;
	                                    nDiags = tmp1.length;
	                                    min.push([this.at(i), this.at(j)]);
	                                }
	                            }
	                        }
	                    }
	                }
	
	                return min;
	            };
	
	            /**
	             * Decomposes the polygon into one or more convex sub-Polygons.
	             * @method decomp
	             * @return {Array} An array or Polygon objects.
	             */
	            Polygon.prototype.decomp = function () {
	                var edges = this.getCutEdges();
	                if (edges.length > 0) return this.slice(edges);else return [this];
	            };
	
	            /**
	             * Slices the polygon given one or more cut edges. If given one, this function will return two polygons (false on failure). If many, an array of polygons.
	             * @method slice
	             * @param {Array} cutEdges A list of edges, as returned by .getCutEdges()
	             * @return {Array}
	             */
	            Polygon.prototype.slice = function (cutEdges) {
	                if (cutEdges.length == 0) return [this];
	                if (cutEdges instanceof Array && cutEdges.length && cutEdges[0] instanceof Array && cutEdges[0].length == 2 && cutEdges[0][0] instanceof Array) {
	
	                    var polys = [this];
	
	                    for (var i = 0; i < cutEdges.length; i++) {
	                        var cutEdge = cutEdges[i];
	                        // Cut all polys
	                        for (var j = 0; j < polys.length; j++) {
	                            var poly = polys[j];
	                            var result = poly.slice(cutEdge);
	                            if (result) {
	                                // Found poly! Cut and quit
	                                polys.splice(j, 1);
	                                polys.push(result[0], result[1]);
	                                break;
	                            }
	                        }
	                    }
	
	                    return polys;
	                } else {
	
	                    // Was given one edge
	                    var cutEdge = cutEdges;
	                    var i = this.vertices.indexOf(cutEdge[0]);
	                    var j = this.vertices.indexOf(cutEdge[1]);
	
	                    if (i != -1 && j != -1) {
	                        return [this.copy(i, j), this.copy(j, i)];
	                    } else {
	                        return false;
	                    }
	                }
	            };
	
	            /**
	             * Checks that the line segments of this polygon do not intersect each other.
	             * @method isSimple
	             * @param  {Array} path An array of vertices e.g. [[0,0],[0,1],...]
	             * @return {Boolean}
	             * @todo Should it check all segments with all others?
	             */
	            Polygon.prototype.isSimple = function () {
	                var path = this.vertices;
	                // Check
	                for (var i = 0; i < path.length - 1; i++) {
	                    for (var j = 0; j < i - 1; j++) {
	                        if (Line.segmentsIntersect(path[i], path[i + 1], path[j], path[j + 1])) {
	                            return false;
	                        }
	                    }
	                }
	
	                // Check the segment between the last and the first point to all others
	                for (var i = 1; i < path.length - 2; i++) {
	                    if (Line.segmentsIntersect(path[0], path[path.length - 1], path[i], path[i + 1])) {
	                        return false;
	                    }
	                }
	
	                return true;
	            };
	
	            function getIntersectionPoint(p1, p2, q1, q2, delta) {
	                delta = delta || 0;
	                var a1 = p2[1] - p1[1];
	                var b1 = p1[0] - p2[0];
	                var c1 = a1 * p1[0] + b1 * p1[1];
	                var a2 = q2[1] - q1[1];
	                var b2 = q1[0] - q2[0];
	                var c2 = a2 * q1[0] + b2 * q1[1];
	                var det = a1 * b2 - a2 * b1;
	
	                if (!Scalar.eq(det, 0, delta)) return [(b2 * c1 - b1 * c2) / det, (a1 * c2 - a2 * c1) / det];else return [0, 0];
	            }
	
	            /**
	             * Quickly decompose the Polygon into convex sub-polygons.
	             * @method quickDecomp
	             * @param  {Array} result
	             * @param  {Array} [reflexVertices]
	             * @param  {Array} [steinerPoints]
	             * @param  {Number} [delta]
	             * @param  {Number} [maxlevel]
	             * @param  {Number} [level]
	             * @return {Array}
	             */
	            Polygon.prototype.quickDecomp = function (result, reflexVertices, steinerPoints, delta, maxlevel, level) {
	                maxlevel = maxlevel || 100;
	                level = level || 0;
	                delta = delta || 25;
	                result = typeof result != "undefined" ? result : [];
	                reflexVertices = reflexVertices || [];
	                steinerPoints = steinerPoints || [];
	
	                var upperInt = [0, 0],
	                    lowerInt = [0, 0],
	                    p = [0, 0]; // Points
	                var upperDist = 0,
	                    lowerDist = 0,
	                    d = 0,
	                    closestDist = 0; // scalars
	                var upperIndex = 0,
	                    lowerIndex = 0,
	                    closestIndex = 0; // Integers
	                var lowerPoly = new Polygon(),
	                    upperPoly = new Polygon(); // polygons
	                var poly = this,
	                    v = this.vertices;
	
	                if (v.length < 3) return result;
	
	                level++;
	                if (level > maxlevel) {
	                    console.warn("quickDecomp: max level (" + maxlevel + ") reached.");
	                    return result;
	                }
	
	                for (var i = 0; i < this.vertices.length; ++i) {
	                    if (poly.isReflex(i)) {
	                        reflexVertices.push(poly.vertices[i]);
	                        upperDist = lowerDist = Number.MAX_VALUE;
	
	                        for (var j = 0; j < this.vertices.length; ++j) {
	                            if (Point.left(poly.at(i - 1), poly.at(i), poly.at(j)) && Point.rightOn(poly.at(i - 1), poly.at(i), poly.at(j - 1))) {
	                                // if line intersects with an edge
	                                p = getIntersectionPoint(poly.at(i - 1), poly.at(i), poly.at(j), poly.at(j - 1)); // find the point of intersection
	                                if (Point.right(poly.at(i + 1), poly.at(i), p)) {
	                                    // make sure it's inside the poly
	                                    d = Point.sqdist(poly.vertices[i], p);
	                                    if (d < lowerDist) {
	                                        // keep only the closest intersection
	                                        lowerDist = d;
	                                        lowerInt = p;
	                                        lowerIndex = j;
	                                    }
	                                }
	                            }
	                            if (Point.left(poly.at(i + 1), poly.at(i), poly.at(j + 1)) && Point.rightOn(poly.at(i + 1), poly.at(i), poly.at(j))) {
	                                p = getIntersectionPoint(poly.at(i + 1), poly.at(i), poly.at(j), poly.at(j + 1));
	                                if (Point.left(poly.at(i - 1), poly.at(i), p)) {
	                                    d = Point.sqdist(poly.vertices[i], p);
	                                    if (d < upperDist) {
	                                        upperDist = d;
	                                        upperInt = p;
	                                        upperIndex = j;
	                                    }
	                                }
	                            }
	                        }
	
	                        // if there are no vertices to connect to, choose a point in the middle
	                        if (lowerIndex == (upperIndex + 1) % this.vertices.length) {
	                            //console.log("Case 1: Vertex("+i+"), lowerIndex("+lowerIndex+"), upperIndex("+upperIndex+"), poly.size("+this.vertices.length+")");
	                            p[0] = (lowerInt[0] + upperInt[0]) / 2;
	                            p[1] = (lowerInt[1] + upperInt[1]) / 2;
	                            steinerPoints.push(p);
	
	                            if (i < upperIndex) {
	                                //lowerPoly.insert(lowerPoly.end(), poly.begin() + i, poly.begin() + upperIndex + 1);
	                                lowerPoly.append(poly, i, upperIndex + 1);
	                                lowerPoly.vertices.push(p);
	                                upperPoly.vertices.push(p);
	                                if (lowerIndex != 0) {
	                                    //upperPoly.insert(upperPoly.end(), poly.begin() + lowerIndex, poly.end());
	                                    upperPoly.append(poly, lowerIndex, poly.vertices.length);
	                                }
	                                //upperPoly.insert(upperPoly.end(), poly.begin(), poly.begin() + i + 1);
	                                upperPoly.append(poly, 0, i + 1);
	                            } else {
	                                if (i != 0) {
	                                    //lowerPoly.insert(lowerPoly.end(), poly.begin() + i, poly.end());
	                                    lowerPoly.append(poly, i, poly.vertices.length);
	                                }
	                                //lowerPoly.insert(lowerPoly.end(), poly.begin(), poly.begin() + upperIndex + 1);
	                                lowerPoly.append(poly, 0, upperIndex + 1);
	                                lowerPoly.vertices.push(p);
	                                upperPoly.vertices.push(p);
	                                //upperPoly.insert(upperPoly.end(), poly.begin() + lowerIndex, poly.begin() + i + 1);
	                                upperPoly.append(poly, lowerIndex, i + 1);
	                            }
	                        } else {
	                            // connect to the closest point within the triangle
	                            //console.log("Case 2: Vertex("+i+"), closestIndex("+closestIndex+"), poly.size("+this.vertices.length+")\n");
	
	                            if (lowerIndex > upperIndex) {
	                                upperIndex += this.vertices.length;
	                            }
	                            closestDist = Number.MAX_VALUE;
	
	                            if (upperIndex < lowerIndex) {
	                                return result;
	                            }
	
	                            for (var j = lowerIndex; j <= upperIndex; ++j) {
	                                if (Point.leftOn(poly.at(i - 1), poly.at(i), poly.at(j)) && Point.rightOn(poly.at(i + 1), poly.at(i), poly.at(j))) {
	                                    d = Point.sqdist(poly.at(i), poly.at(j));
	                                    if (d < closestDist) {
	                                        closestDist = d;
	                                        closestIndex = j % this.vertices.length;
	                                    }
	                                }
	                            }
	
	                            if (i < closestIndex) {
	                                lowerPoly.append(poly, i, closestIndex + 1);
	                                if (closestIndex != 0) {
	                                    upperPoly.append(poly, closestIndex, v.length);
	                                }
	                                upperPoly.append(poly, 0, i + 1);
	                            } else {
	                                if (i != 0) {
	                                    lowerPoly.append(poly, i, v.length);
	                                }
	                                lowerPoly.append(poly, 0, closestIndex + 1);
	                                upperPoly.append(poly, closestIndex, i + 1);
	                            }
	                        }
	
	                        // solve smallest poly first
	                        if (lowerPoly.vertices.length < upperPoly.vertices.length) {
	                            lowerPoly.quickDecomp(result, reflexVertices, steinerPoints, delta, maxlevel, level);
	                            upperPoly.quickDecomp(result, reflexVertices, steinerPoints, delta, maxlevel, level);
	                        } else {
	                            upperPoly.quickDecomp(result, reflexVertices, steinerPoints, delta, maxlevel, level);
	                            lowerPoly.quickDecomp(result, reflexVertices, steinerPoints, delta, maxlevel, level);
	                        }
	
	                        return result;
	                    }
	                }
	                result.push(this);
	
	                return result;
	            };
	
	            /**
	             * Remove collinear points in the polygon.
	             * @method removeCollinearPoints
	             * @param  {Number} [precision] The threshold angle to use when determining whether two edges are collinear. Use zero for finest precision.
	             * @return {Number}           The number of points removed
	             */
	            Polygon.prototype.removeCollinearPoints = function (precision) {
	                var num = 0;
	                for (var i = this.vertices.length - 1; this.vertices.length > 3 && i >= 0; --i) {
	                    if (Point.collinear(this.at(i - 1), this.at(i), this.at(i + 1), precision)) {
	                        // Remove the middle point
	                        this.vertices.splice(i % this.vertices.length, 1);
	                        i--; // Jump one point forward. Otherwise we may get a chain removal
	                        num++;
	                    }
	                }
	                return num;
	            };
	        }, { "./Line": 1, "./Point": 2, "./Scalar": 4 }], 4: [function (_dereq_, module, exports) {
	            module.exports = Scalar;
	
	            /**
	             * Scalar functions
	             * @class Scalar
	             */
	            function Scalar() {}
	
	            /**
	             * Check if two scalars are equal
	             * @static
	             * @method eq
	             * @param  {Number} a
	             * @param  {Number} b
	             * @param  {Number} [precision]
	             * @return {Boolean}
	             */
	            Scalar.eq = function (a, b, precision) {
	                precision = precision || 0;
	                return Math.abs(a - b) < precision;
	            };
	        }, {}], 5: [function (_dereq_, module, exports) {
	            module.exports = {
	                Polygon: _dereq_("./Polygon"),
	                Point: _dereq_("./Point")
	            };
	        }, { "./Point": 2, "./Polygon": 3 }], 6: [function (_dereq_, module, exports) {
	            module.exports = {
	                "name": "p2",
	                "version": "0.7.0",
	                "description": "A JavaScript 2D physics engine.",
	                "author": "Stefan Hedman <schteppe@gmail.com> (http://steffe.se)",
	                "keywords": ["p2.js", "p2", "physics", "engine", "2d"],
	                "main": "./src/p2.js",
	                "engines": {
	                    "node": "*"
	                },
	                "repository": {
	                    "type": "git",
	                    "url": "https://github.com/schteppe/p2.js.git"
	                },
	                "bugs": {
	                    "url": "https://github.com/schteppe/p2.js/issues"
	                },
	                "licenses": [{
	                    "type": "MIT"
	                }],
	                "devDependencies": {
	                    "grunt": "^0.4.5",
	                    "grunt-contrib-jshint": "^0.11.2",
	                    "grunt-contrib-nodeunit": "^0.4.1",
	                    "grunt-contrib-uglify": "~0.4.0",
	                    "grunt-contrib-watch": "~0.5.0",
	                    "grunt-browserify": "~2.0.1",
	                    "grunt-contrib-concat": "^0.4.0"
	                },
	                "dependencies": {
	                    "poly-decomp": "0.1.0"
	                }
	            };
	        }, {}], 7: [function (_dereq_, module, exports) {
	            var vec2 = _dereq_('../math/vec2'),
	                Utils = _dereq_('../utils/Utils');
	
	            module.exports = AABB;
	
	            /**
	             * Axis aligned bounding box class.
	             * @class AABB
	             * @constructor
	             * @param {Object}  [options]
	             * @param {Array}   [options.upperBound]
	             * @param {Array}   [options.lowerBound]
	             */
	            function AABB(options) {
	
	                /**
	                 * The lower bound of the bounding box.
	                 * @property lowerBound
	                 * @type {Array}
	                 */
	                this.lowerBound = vec2.create();
	                if (options && options.lowerBound) {
	                    vec2.copy(this.lowerBound, options.lowerBound);
	                }
	
	                /**
	                 * The upper bound of the bounding box.
	                 * @property upperBound
	                 * @type {Array}
	                 */
	                this.upperBound = vec2.create();
	                if (options && options.upperBound) {
	                    vec2.copy(this.upperBound, options.upperBound);
	                }
	            }
	
	            var tmp = vec2.create();
	
	            /**
	             * Set the AABB bounds from a set of points, transformed by the given position and angle.
	             * @method setFromPoints
	             * @param {Array} points An array of vec2's.
	             * @param {Array} position
	             * @param {number} angle
	             * @param {number} skinSize Some margin to be added to the AABB.
	             */
	            AABB.prototype.setFromPoints = function (points, position, angle, skinSize) {
	                var l = this.lowerBound,
	                    u = this.upperBound;
	
	                if (typeof angle !== "number") {
	                    angle = 0;
	                }
	
	                // Set to the first point
	                if (angle !== 0) {
	                    vec2.rotate(l, points[0], angle);
	                } else {
	                    vec2.copy(l, points[0]);
	                }
	                vec2.copy(u, l);
	
	                // Compute cosines and sines just once
	                var cosAngle = Math.cos(angle),
	                    sinAngle = Math.sin(angle);
	                for (var i = 1; i < points.length; i++) {
	                    var p = points[i];
	
	                    if (angle !== 0) {
	                        var x = p[0],
	                            y = p[1];
	                        tmp[0] = cosAngle * x - sinAngle * y;
	                        tmp[1] = sinAngle * x + cosAngle * y;
	                        p = tmp;
	                    }
	
	                    for (var j = 0; j < 2; j++) {
	                        if (p[j] > u[j]) {
	                            u[j] = p[j];
	                        }
	                        if (p[j] < l[j]) {
	                            l[j] = p[j];
	                        }
	                    }
	                }
	
	                // Add offset
	                if (position) {
	                    vec2.add(this.lowerBound, this.lowerBound, position);
	                    vec2.add(this.upperBound, this.upperBound, position);
	                }
	
	                if (skinSize) {
	                    this.lowerBound[0] -= skinSize;
	                    this.lowerBound[1] -= skinSize;
	                    this.upperBound[0] += skinSize;
	                    this.upperBound[1] += skinSize;
	                }
	            };
	
	            /**
	             * Copy bounds from an AABB to this AABB
	             * @method copy
	             * @param  {AABB} aabb
	             */
	            AABB.prototype.copy = function (aabb) {
	                vec2.copy(this.lowerBound, aabb.lowerBound);
	                vec2.copy(this.upperBound, aabb.upperBound);
	            };
	
	            /**
	             * Extend this AABB so that it covers the given AABB too.
	             * @method extend
	             * @param  {AABB} aabb
	             */
	            AABB.prototype.extend = function (aabb) {
	                // Loop over x and y
	                var i = 2;
	                while (i--) {
	                    // Extend lower bound
	                    var l = aabb.lowerBound[i];
	                    if (this.lowerBound[i] > l) {
	                        this.lowerBound[i] = l;
	                    }
	
	                    // Upper
	                    var u = aabb.upperBound[i];
	                    if (this.upperBound[i] < u) {
	                        this.upperBound[i] = u;
	                    }
	                }
	            };
	
	            /**
	             * Returns true if the given AABB overlaps this AABB.
	             * @method overlaps
	             * @param  {AABB} aabb
	             * @return {Boolean}
	             */
	            AABB.prototype.overlaps = function (aabb) {
	                var l1 = this.lowerBound,
	                    u1 = this.upperBound,
	                    l2 = aabb.lowerBound,
	                    u2 = aabb.upperBound;
	
	                //      l2        u2
	                //      |---------|
	                // |--------|
	                // l1       u1
	
	                return (l2[0] <= u1[0] && u1[0] <= u2[0] || l1[0] <= u2[0] && u2[0] <= u1[0]) && (l2[1] <= u1[1] && u1[1] <= u2[1] || l1[1] <= u2[1] && u2[1] <= u1[1]);
	            };
	
	            /**
	             * @method containsPoint
	             * @param  {Array} point
	             * @return {boolean}
	             */
	            AABB.prototype.containsPoint = function (point) {
	                var l = this.lowerBound,
	                    u = this.upperBound;
	                return l[0] <= point[0] && point[0] <= u[0] && l[1] <= point[1] && point[1] <= u[1];
	            };
	
	            /**
	             * Check if the AABB is hit by a ray.
	             * @method overlapsRay
	             * @param  {Ray} ray
	             * @return {number} -1 if no hit, a number between 0 and 1 if hit.
	             */
	            AABB.prototype.overlapsRay = function (ray) {
	                var t = 0;
	
	                // ray.direction is unit direction vector of ray
	                var dirFracX = 1 / ray.direction[0];
	                var dirFracY = 1 / ray.direction[1];
	
	                // this.lowerBound is the corner of AABB with minimal coordinates - left bottom, rt is maximal corner
	                var t1 = (this.lowerBound[0] - ray.from[0]) * dirFracX;
	                var t2 = (this.upperBound[0] - ray.from[0]) * dirFracX;
	                var t3 = (this.lowerBound[1] - ray.from[1]) * dirFracY;
	                var t4 = (this.upperBound[1] - ray.from[1]) * dirFracY;
	
	                var tmin = Math.max(Math.max(Math.min(t1, t2), Math.min(t3, t4)));
	                var tmax = Math.min(Math.min(Math.max(t1, t2), Math.max(t3, t4)));
	
	                // if tmax < 0, ray (line) is intersecting AABB, but whole AABB is behing us
	                if (tmax < 0) {
	                    //t = tmax;
	                    return -1;
	                }
	
	                // if tmin > tmax, ray doesn't intersect AABB
	                if (tmin > tmax) {
	                    //t = tmax;
	                    return -1;
	                }
	
	                return tmin;
	            };
	        }, { "../math/vec2": 30, "../utils/Utils": 57 }], 8: [function (_dereq_, module, exports) {
	            var vec2 = _dereq_('../math/vec2');
	            var Body = _dereq_('../objects/Body');
	
	            module.exports = Broadphase;
	
	            /**
	             * Base class for broadphase implementations.
	             * @class Broadphase
	             * @constructor
	             */
	            function Broadphase(type) {
	
	                this.type = type;
	
	                /**
	                 * The resulting overlapping pairs. Will be filled with results during .getCollisionPairs().
	                 * @property result
	                 * @type {Array}
	                 */
	                this.result = [];
	
	                /**
	                 * The world to search for collision pairs in. To change it, use .setWorld()
	                 * @property world
	                 * @type {World}
	                 * @readOnly
	                 */
	                this.world = null;
	
	                /**
	                 * The bounding volume type to use in the broadphase algorithms. Should be set to Broadphase.AABB or Broadphase.BOUNDING_CIRCLE.
	                 * @property {Number} boundingVolumeType
	                 */
	                this.boundingVolumeType = Broadphase.AABB;
	            }
	
	            /**
	             * Axis aligned bounding box type.
	             * @static
	             * @property {Number} AABB
	             */
	            Broadphase.AABB = 1;
	
	            /**
	             * Bounding circle type.
	             * @static
	             * @property {Number} BOUNDING_CIRCLE
	             */
	            Broadphase.BOUNDING_CIRCLE = 2;
	
	            /**
	             * Set the world that we are searching for collision pairs in.
	             * @method setWorld
	             * @param  {World} world
	             */
	            Broadphase.prototype.setWorld = function (world) {
	                this.world = world;
	            };
	
	            /**
	             * Get all potential intersecting body pairs.
	             * @method getCollisionPairs
	             * @param  {World} world The world to search in.
	             * @return {Array} An array of the bodies, ordered in pairs. Example: A result of [a,b,c,d] means that the potential pairs are: (a,b), (c,d).
	             */
	            Broadphase.prototype.getCollisionPairs = function (world) {};
	
	            var dist = vec2.create();
	
	            /**
	             * Check whether the bounding radius of two bodies overlap.
	             * @method  boundingRadiusCheck
	             * @param  {Body} bodyA
	             * @param  {Body} bodyB
	             * @return {Boolean}
	             */
	            Broadphase.boundingRadiusCheck = function (bodyA, bodyB) {
	                vec2.sub(dist, bodyA.position, bodyB.position);
	                var d2 = vec2.squaredLength(dist),
	                    r = bodyA.boundingRadius + bodyB.boundingRadius;
	                return d2 <= r * r;
	            };
	
	            /**
	             * Check whether the bounding radius of two bodies overlap.
	             * @method  boundingRadiusCheck
	             * @param  {Body} bodyA
	             * @param  {Body} bodyB
	             * @return {Boolean}
	             */
	            Broadphase.aabbCheck = function (bodyA, bodyB) {
	                return bodyA.getAABB().overlaps(bodyB.getAABB());
	            };
	
	            /**
	             * Check whether the bounding radius of two bodies overlap.
	             * @method  boundingRadiusCheck
	             * @param  {Body} bodyA
	             * @param  {Body} bodyB
	             * @return {Boolean}
	             */
	            Broadphase.prototype.boundingVolumeCheck = function (bodyA, bodyB) {
	                var result;
	
	                switch (this.boundingVolumeType) {
	                    case Broadphase.BOUNDING_CIRCLE:
	                        result = Broadphase.boundingRadiusCheck(bodyA, bodyB);
	                        break;
	                    case Broadphase.AABB:
	                        result = Broadphase.aabbCheck(bodyA, bodyB);
	                        break;
	                    default:
	                        throw new Error('Bounding volume type not recognized: ' + this.boundingVolumeType);
	                }
	                return result;
	            };
	
	            /**
	             * Check whether two bodies are allowed to collide at all.
	             * @method  canCollide
	             * @param  {Body} bodyA
	             * @param  {Body} bodyB
	             * @return {Boolean}
	             */
	            Broadphase.canCollide = function (bodyA, bodyB) {
	                var KINEMATIC = Body.KINEMATIC;
	                var STATIC = Body.STATIC;
	
	                // Cannot collide static bodies
	                if (bodyA.type === STATIC && bodyB.type === STATIC) {
	                    return false;
	                }
	
	                // Cannot collide static vs kinematic bodies
	                if (bodyA.type === KINEMATIC && bodyB.type === STATIC || bodyA.type === STATIC && bodyB.type === KINEMATIC) {
	                    return false;
	                }
	
	                // Cannot collide kinematic vs kinematic
	                if (bodyA.type === KINEMATIC && bodyB.type === KINEMATIC) {
	                    return false;
	                }
	
	                // Cannot collide both sleeping bodies
	                if (bodyA.sleepState === Body.SLEEPING && bodyB.sleepState === Body.SLEEPING) {
	                    return false;
	                }
	
	                // Cannot collide if one is static and the other is sleeping
	                if (bodyA.sleepState === Body.SLEEPING && bodyB.type === STATIC || bodyB.sleepState === Body.SLEEPING && bodyA.type === STATIC) {
	                    return false;
	                }
	
	                return true;
	            };
	
	            Broadphase.NAIVE = 1;
	            Broadphase.SAP = 2;
	        }, { "../math/vec2": 30, "../objects/Body": 31 }], 9: [function (_dereq_, module, exports) {
	            var Circle = _dereq_('../shapes/Circle'),
	                Plane = _dereq_('../shapes/Plane'),
	                Shape = _dereq_('../shapes/Shape'),
	                Particle = _dereq_('../shapes/Particle'),
	                Broadphase = _dereq_('../collision/Broadphase'),
	                vec2 = _dereq_('../math/vec2');
	
	            module.exports = NaiveBroadphase;
	
	            /**
	             * Naive broadphase implementation. Does N^2 tests.
	             *
	             * @class NaiveBroadphase
	             * @constructor
	             * @extends Broadphase
	             */
	            function NaiveBroadphase() {
	                Broadphase.call(this, Broadphase.NAIVE);
	            }
	            NaiveBroadphase.prototype = new Broadphase();
	            NaiveBroadphase.prototype.constructor = NaiveBroadphase;
	
	            /**
	             * Get the colliding pairs
	             * @method getCollisionPairs
	             * @param  {World} world
	             * @return {Array}
	             */
	            NaiveBroadphase.prototype.getCollisionPairs = function (world) {
	                var bodies = world.bodies,
	                    result = this.result;
	
	                result.length = 0;
	
	                for (var i = 0, Ncolliding = bodies.length; i !== Ncolliding; i++) {
	                    var bi = bodies[i];
	
	                    for (var j = 0; j < i; j++) {
	                        var bj = bodies[j];
	
	                        if (Broadphase.canCollide(bi, bj) && this.boundingVolumeCheck(bi, bj)) {
	                            result.push(bi, bj);
	                        }
	                    }
	                }
	
	                return result;
	            };
	
	            /**
	             * Returns all the bodies within an AABB.
	             * @method aabbQuery
	             * @param  {World} world
	             * @param  {AABB} aabb
	             * @param {array} result An array to store resulting bodies in.
	             * @return {array}
	             */
	            NaiveBroadphase.prototype.aabbQuery = function (world, aabb, result) {
	                result = result || [];
	
	                var bodies = world.bodies;
	                for (var i = 0; i < bodies.length; i++) {
	                    var b = bodies[i];
	
	                    if (b.aabbNeedsUpdate) {
	                        b.updateAABB();
	                    }
	
	                    if (b.aabb.overlaps(aabb)) {
	                        result.push(b);
	                    }
	                }
	
	                return result;
	            };
	        }, { "../collision/Broadphase": 8, "../math/vec2": 30, "../shapes/Circle": 39, "../shapes/Particle": 43, "../shapes/Plane": 44, "../shapes/Shape": 45 }], 10: [function (_dereq_, module, exports) {
	            var vec2 = _dereq_('../math/vec2'),
	                sub = vec2.sub,
	                add = vec2.add,
	                dot = vec2.dot,
	                Utils = _dereq_('../utils/Utils'),
	                ContactEquationPool = _dereq_('../utils/ContactEquationPool'),
	                FrictionEquationPool = _dereq_('../utils/FrictionEquationPool'),
	                TupleDictionary = _dereq_('../utils/TupleDictionary'),
	                Equation = _dereq_('../equations/Equation'),
	                ContactEquation = _dereq_('../equations/ContactEquation'),
	                FrictionEquation = _dereq_('../equations/FrictionEquation'),
	                Circle = _dereq_('../shapes/Circle'),
	                Convex = _dereq_('../shapes/Convex'),
	                Shape = _dereq_('../shapes/Shape'),
	                Body = _dereq_('../objects/Body'),
	                Box = _dereq_('../shapes/Box');
	
	            module.exports = Narrowphase;
	
	            // Temp things
	            var yAxis = vec2.fromValues(0, 1);
	
	            var tmp1 = vec2.fromValues(0, 0),
	                tmp2 = vec2.fromValues(0, 0),
	                tmp3 = vec2.fromValues(0, 0),
	                tmp4 = vec2.fromValues(0, 0),
	                tmp5 = vec2.fromValues(0, 0),
	                tmp6 = vec2.fromValues(0, 0),
	                tmp7 = vec2.fromValues(0, 0),
	                tmp8 = vec2.fromValues(0, 0),
	                tmp9 = vec2.fromValues(0, 0),
	                tmp10 = vec2.fromValues(0, 0),
	                tmp11 = vec2.fromValues(0, 0),
	                tmp12 = vec2.fromValues(0, 0),
	                tmp13 = vec2.fromValues(0, 0),
	                tmp14 = vec2.fromValues(0, 0),
	                tmp15 = vec2.fromValues(0, 0),
	                tmp16 = vec2.fromValues(0, 0),
	                tmp17 = vec2.fromValues(0, 0),
	                tmp18 = vec2.fromValues(0, 0),
	                tmpArray = [];
	
	            /**
	             * Narrowphase. Creates contacts and friction given shapes and transforms.
	             * @class Narrowphase
	             * @constructor
	             */
	            function Narrowphase() {
	
	                /**
	                 * @property contactEquations
	                 * @type {Array}
	                 */
	                this.contactEquations = [];
	
	                /**
	                 * @property frictionEquations
	                 * @type {Array}
	                 */
	                this.frictionEquations = [];
	
	                /**
	                 * Whether to make friction equations in the upcoming contacts.
	                 * @property enableFriction
	                 * @type {Boolean}
	                 */
	                this.enableFriction = true;
	
	                /**
	                 * Whether to make equations enabled in upcoming contacts.
	                 * @property enabledEquations
	                 * @type {Boolean}
	                 */
	                this.enabledEquations = true;
	
	                /**
	                 * The friction slip force to use when creating friction equations.
	                 * @property slipForce
	                 * @type {Number}
	                 */
	                this.slipForce = 10.0;
	
	                /**
	                 * The friction value to use in the upcoming friction equations.
	                 * @property frictionCoefficient
	                 * @type {Number}
	                 */
	                this.frictionCoefficient = 0.3;
	
	                /**
	                 * Will be the .relativeVelocity in each produced FrictionEquation.
	                 * @property {Number} surfaceVelocity
	                 */
	                this.surfaceVelocity = 0;
	
	                /**
	                 * Keeps track of the allocated ContactEquations.
	                 * @property {ContactEquationPool} contactEquationPool
	                 *
	                 * @example
	                 *
	                 *     // Allocate a few equations before starting the simulation.
	                 *     // This way, no contact objects need to be created on the fly in the game loop.
	                 *     world.narrowphase.contactEquationPool.resize(1024);
	                 *     world.narrowphase.frictionEquationPool.resize(1024);
	                 */
	                this.contactEquationPool = new ContactEquationPool({ size: 32 });
	
	                /**
	                 * Keeps track of the allocated ContactEquations.
	                 * @property {FrictionEquationPool} frictionEquationPool
	                 */
	                this.frictionEquationPool = new FrictionEquationPool({ size: 64 });
	
	                /**
	                 * The restitution value to use in the next contact equations.
	                 * @property restitution
	                 * @type {Number}
	                 */
	                this.restitution = 0;
	
	                /**
	                 * The stiffness value to use in the next contact equations.
	                 * @property {Number} stiffness
	                 */
	                this.stiffness = Equation.DEFAULT_STIFFNESS;
	
	                /**
	                 * The stiffness value to use in the next contact equations.
	                 * @property {Number} stiffness
	                 */
	                this.relaxation = Equation.DEFAULT_RELAXATION;
	
	                /**
	                 * The stiffness value to use in the next friction equations.
	                 * @property frictionStiffness
	                 * @type {Number}
	                 */
	                this.frictionStiffness = Equation.DEFAULT_STIFFNESS;
	
	                /**
	                 * The relaxation value to use in the next friction equations.
	                 * @property frictionRelaxation
	                 * @type {Number}
	                 */
	                this.frictionRelaxation = Equation.DEFAULT_RELAXATION;
	
	                /**
	                 * Enable reduction of friction equations. If disabled, a box on a plane will generate 2 contact equations and 2 friction equations. If enabled, there will be only one friction equation. Same kind of simplifications are made  for all collision types.
	                 * @property enableFrictionReduction
	                 * @type {Boolean}
	                 * @deprecated This flag will be removed when the feature is stable enough.
	                 * @default true
	                 */
	                this.enableFrictionReduction = true;
	
	                /**
	                 * Keeps track of the colliding bodies last step.
	                 * @private
	                 * @property collidingBodiesLastStep
	                 * @type {TupleDictionary}
	                 */
	                this.collidingBodiesLastStep = new TupleDictionary();
	
	                /**
	                 * Contact skin size value to use in the next contact equations.
	                 * @property {Number} contactSkinSize
	                 * @default 0.01
	                 */
	                this.contactSkinSize = 0.01;
	            }
	
	            var bodiesOverlap_shapePositionA = vec2.create();
	            var bodiesOverlap_shapePositionB = vec2.create();
	
	            /**
	             * @method bodiesOverlap
	             * @param  {Body} bodyA
	             * @param  {Body} bodyB
	             * @return {Boolean}
	             * @todo shape world transforms are wrong
	             */
	            Narrowphase.prototype.bodiesOverlap = function (bodyA, bodyB) {
	                var shapePositionA = bodiesOverlap_shapePositionA;
	                var shapePositionB = bodiesOverlap_shapePositionB;
	
	                // Loop over all shapes of bodyA
	                for (var k = 0, Nshapesi = bodyA.shapes.length; k !== Nshapesi; k++) {
	                    var shapeA = bodyA.shapes[k];
	
	                    bodyA.toWorldFrame(shapePositionA, shapeA.position);
	
	                    // All shapes of body j
	                    for (var l = 0, Nshapesj = bodyB.shapes.length; l !== Nshapesj; l++) {
	                        var shapeB = bodyB.shapes[l];
	
	                        bodyB.toWorldFrame(shapePositionB, shapeB.position);
	
	                        if (this[shapeA.type | shapeB.type](bodyA, shapeA, shapePositionA, shapeA.angle + bodyA.angle, bodyB, shapeB, shapePositionB, shapeB.angle + bodyB.angle, true)) {
	                            return true;
	                        }
	                    }
	                }
	
	                return false;
	            };
	
	            /**
	             * Check if the bodies were in contact since the last reset().
	             * @method collidedLastStep
	             * @param  {Body} bodyA
	             * @param  {Body} bodyB
	             * @return {Boolean}
	             */
	            Narrowphase.prototype.collidedLastStep = function (bodyA, bodyB) {
	                var id1 = bodyA.id | 0,
	                    id2 = bodyB.id | 0;
	                return !!this.collidingBodiesLastStep.get(id1, id2);
	            };
	
	            /**
	             * Throws away the old equations and gets ready to create new
	             * @method reset
	             */
	            Narrowphase.prototype.reset = function () {
	                this.collidingBodiesLastStep.reset();
	
	                var eqs = this.contactEquations;
	                var l = eqs.length;
	                while (l--) {
	                    var eq = eqs[l],
	                        id1 = eq.bodyA.id,
	                        id2 = eq.bodyB.id;
	                    this.collidingBodiesLastStep.set(id1, id2, true);
	                }
	
	                var ce = this.contactEquations,
	                    fe = this.frictionEquations;
	                for (var i = 0; i < ce.length; i++) {
	                    this.contactEquationPool.release(ce[i]);
	                }
	                for (var i = 0; i < fe.length; i++) {
	                    this.frictionEquationPool.release(fe[i]);
	                }
	
	                // Reset
	                this.contactEquations.length = this.frictionEquations.length = 0;
	            };
	
	            /**
	             * Creates a ContactEquation, either by reusing an existing object or creating a new one.
	             * @method createContactEquation
	             * @param  {Body} bodyA
	             * @param  {Body} bodyB
	             * @return {ContactEquation}
	             */
	            Narrowphase.prototype.createContactEquation = function (bodyA, bodyB, shapeA, shapeB) {
	                var c = this.contactEquationPool.get();
	                c.bodyA = bodyA;
	                c.bodyB = bodyB;
	                c.shapeA = shapeA;
	                c.shapeB = shapeB;
	                c.restitution = this.restitution;
	                c.firstImpact = !this.collidedLastStep(bodyA, bodyB);
	                c.stiffness = this.stiffness;
	                c.relaxation = this.relaxation;
	                c.needsUpdate = true;
	                c.enabled = this.enabledEquations;
	                c.offset = this.contactSkinSize;
	
	                return c;
	            };
	
	            /**
	             * Creates a FrictionEquation, either by reusing an existing object or creating a new one.
	             * @method createFrictionEquation
	             * @param  {Body} bodyA
	             * @param  {Body} bodyB
	             * @return {FrictionEquation}
	             */
	            Narrowphase.prototype.createFrictionEquation = function (bodyA, bodyB, shapeA, shapeB) {
	                var c = this.frictionEquationPool.get();
	                c.bodyA = bodyA;
	                c.bodyB = bodyB;
	                c.shapeA = shapeA;
	                c.shapeB = shapeB;
	                c.setSlipForce(this.slipForce);
	                c.frictionCoefficient = this.frictionCoefficient;
	                c.relativeVelocity = this.surfaceVelocity;
	                c.enabled = this.enabledEquations;
	                c.needsUpdate = true;
	                c.stiffness = this.frictionStiffness;
	                c.relaxation = this.frictionRelaxation;
	                c.contactEquations.length = 0;
	                return c;
	            };
	
	            /**
	             * Creates a FrictionEquation given the data in the ContactEquation. Uses same offset vectors ri and rj, but the tangent vector will be constructed from the collision normal.
	             * @method createFrictionFromContact
	             * @param  {ContactEquation} contactEquation
	             * @return {FrictionEquation}
	             */
	            Narrowphase.prototype.createFrictionFromContact = function (c) {
	                var eq = this.createFrictionEquation(c.bodyA, c.bodyB, c.shapeA, c.shapeB);
	                vec2.copy(eq.contactPointA, c.contactPointA);
	                vec2.copy(eq.contactPointB, c.contactPointB);
	                vec2.rotate90cw(eq.t, c.normalA);
	                eq.contactEquations.push(c);
	                return eq;
	            };
	
	            // Take the average N latest contact point on the plane.
	            Narrowphase.prototype.createFrictionFromAverage = function (numContacts) {
	                var c = this.contactEquations[this.contactEquations.length - 1];
	                var eq = this.createFrictionEquation(c.bodyA, c.bodyB, c.shapeA, c.shapeB);
	                var bodyA = c.bodyA;
	                var bodyB = c.bodyB;
	                vec2.set(eq.contactPointA, 0, 0);
	                vec2.set(eq.contactPointB, 0, 0);
	                vec2.set(eq.t, 0, 0);
	                for (var i = 0; i !== numContacts; i++) {
	                    c = this.contactEquations[this.contactEquations.length - 1 - i];
	                    if (c.bodyA === bodyA) {
	                        vec2.add(eq.t, eq.t, c.normalA);
	                        vec2.add(eq.contactPointA, eq.contactPointA, c.contactPointA);
	                        vec2.add(eq.contactPointB, eq.contactPointB, c.contactPointB);
	                    } else {
	                        vec2.sub(eq.t, eq.t, c.normalA);
	                        vec2.add(eq.contactPointA, eq.contactPointA, c.contactPointB);
	                        vec2.add(eq.contactPointB, eq.contactPointB, c.contactPointA);
	                    }
	                    eq.contactEquations.push(c);
	                }
	
	                var invNumContacts = 1 / numContacts;
	                vec2.scale(eq.contactPointA, eq.contactPointA, invNumContacts);
	                vec2.scale(eq.contactPointB, eq.contactPointB, invNumContacts);
	                vec2.normalize(eq.t, eq.t);
	                vec2.rotate90cw(eq.t, eq.t);
	                return eq;
	            };
	
	            /**
	             * Convex/line narrowphase
	             * @method convexLine
	             * @param  {Body}       convexBody
	             * @param  {Convex}     convexShape
	             * @param  {Array}      convexOffset
	             * @param  {Number}     convexAngle
	             * @param  {Body}       lineBody
	             * @param  {Line}       lineShape
	             * @param  {Array}      lineOffset
	             * @param  {Number}     lineAngle
	             * @param {boolean}     justTest
	             * @todo Implement me!
	             */
	            Narrowphase.prototype[Shape.LINE | Shape.CONVEX] = Narrowphase.prototype.convexLine = function (convexBody, convexShape, convexOffset, convexAngle, lineBody, lineShape, lineOffset, lineAngle, justTest) {
	                // TODO
	                if (justTest) {
	                    return false;
	                } else {
	                    return 0;
	                }
	            };
	
	            /**
	             * Line/box narrowphase
	             * @method lineBox
	             * @param  {Body}       lineBody
	             * @param  {Line}       lineShape
	             * @param  {Array}      lineOffset
	             * @param  {Number}     lineAngle
	             * @param  {Body}       boxBody
	             * @param  {Box}  boxShape
	             * @param  {Array}      boxOffset
	             * @param  {Number}     boxAngle
	             * @param  {Boolean}    justTest
	             * @todo Implement me!
	             */
	            Narrowphase.prototype[Shape.LINE | Shape.BOX] = Narrowphase.prototype.lineBox = function (lineBody, lineShape, lineOffset, lineAngle, boxBody, boxShape, boxOffset, boxAngle, justTest) {
	                // TODO
	                if (justTest) {
	                    return false;
	                } else {
	                    return 0;
	                }
	            };
	
	            function setConvexToCapsuleShapeMiddle(convexShape, capsuleShape) {
	                vec2.set(convexShape.vertices[0], -capsuleShape.length * 0.5, -capsuleShape.radius);
	                vec2.set(convexShape.vertices[1], capsuleShape.length * 0.5, -capsuleShape.radius);
	                vec2.set(convexShape.vertices[2], capsuleShape.length * 0.5, capsuleShape.radius);
	                vec2.set(convexShape.vertices[3], -capsuleShape.length * 0.5, capsuleShape.radius);
	            }
	
	            var convexCapsule_tempRect = new Box({ width: 1, height: 1 }),
	                convexCapsule_tempVec = vec2.create();
	
	            /**
	             * Convex/capsule narrowphase
	             * @method convexCapsule
	             * @param  {Body}       convexBody
	             * @param  {Convex}     convexShape
	             * @param  {Array}      convexPosition
	             * @param  {Number}     convexAngle
	             * @param  {Body}       capsuleBody
	             * @param  {Capsule}    capsuleShape
	             * @param  {Array}      capsulePosition
	             * @param  {Number}     capsuleAngle
	             */
	            Narrowphase.prototype[Shape.CAPSULE | Shape.CONVEX] = Narrowphase.prototype[Shape.CAPSULE | Shape.BOX] = Narrowphase.prototype.convexCapsule = function (convexBody, convexShape, convexPosition, convexAngle, capsuleBody, capsuleShape, capsulePosition, capsuleAngle, justTest) {
	
	                // Check the circles
	                // Add offsets!
	                var circlePos = convexCapsule_tempVec;
	                vec2.set(circlePos, capsuleShape.length / 2, 0);
	                vec2.rotate(circlePos, circlePos, capsuleAngle);
	                vec2.add(circlePos, circlePos, capsulePosition);
	                var result1 = this.circleConvex(capsuleBody, capsuleShape, circlePos, capsuleAngle, convexBody, convexShape, convexPosition, convexAngle, justTest, capsuleShape.radius);
	
	                vec2.set(circlePos, -capsuleShape.length / 2, 0);
	                vec2.rotate(circlePos, circlePos, capsuleAngle);
	                vec2.add(circlePos, circlePos, capsulePosition);
	                var result2 = this.circleConvex(capsuleBody, capsuleShape, circlePos, capsuleAngle, convexBody, convexShape, convexPosition, convexAngle, justTest, capsuleShape.radius);
	
	                if (justTest && (result1 || result2)) {
	                    return true;
	                }
	
	                // Check center rect
	                var r = convexCapsule_tempRect;
	                setConvexToCapsuleShapeMiddle(r, capsuleShape);
	                var result = this.convexConvex(convexBody, convexShape, convexPosition, convexAngle, capsuleBody, r, capsulePosition, capsuleAngle, justTest);
	
	                return result + result1 + result2;
	            };
	
	            /**
	             * Capsule/line narrowphase
	             * @method lineCapsule
	             * @param  {Body}       lineBody
	             * @param  {Line}       lineShape
	             * @param  {Array}      linePosition
	             * @param  {Number}     lineAngle
	             * @param  {Body}       capsuleBody
	             * @param  {Capsule}    capsuleShape
	             * @param  {Array}      capsulePosition
	             * @param  {Number}     capsuleAngle
	             * @todo Implement me!
	             */
	            Narrowphase.prototype[Shape.CAPSULE | Shape.LINE] = Narrowphase.prototype.lineCapsule = function (lineBody, lineShape, linePosition, lineAngle, capsuleBody, capsuleShape, capsulePosition, capsuleAngle, justTest) {
	                // TODO
	                if (justTest) {
	                    return false;
	                } else {
	                    return 0;
	                }
	            };
	
	            var capsuleCapsule_tempVec1 = vec2.create();
	            var capsuleCapsule_tempVec2 = vec2.create();
	            var capsuleCapsule_tempRect1 = new Box({ width: 1, height: 1 });
	
	            /**
	             * Capsule/capsule narrowphase
	             * @method capsuleCapsule
	             * @param  {Body}       bi
	             * @param  {Capsule}    si
	             * @param  {Array}      xi
	             * @param  {Number}     ai
	             * @param  {Body}       bj
	             * @param  {Capsule}    sj
	             * @param  {Array}      xj
	             * @param  {Number}     aj
	             */
	            Narrowphase.prototype[Shape.CAPSULE | Shape.CAPSULE] = Narrowphase.prototype.capsuleCapsule = function (bi, si, xi, ai, bj, sj, xj, aj, justTest) {
	
	                var enableFrictionBefore;
	
	                // Check the circles
	                // Add offsets!
	                var circlePosi = capsuleCapsule_tempVec1,
	                    circlePosj = capsuleCapsule_tempVec2;
	
	                var numContacts = 0;
	
	                // Need 4 circle checks, between all
	                for (var i = 0; i < 2; i++) {
	
	                    vec2.set(circlePosi, (i === 0 ? -1 : 1) * si.length / 2, 0);
	                    vec2.rotate(circlePosi, circlePosi, ai);
	                    vec2.add(circlePosi, circlePosi, xi);
	
	                    for (var j = 0; j < 2; j++) {
	
	                        vec2.set(circlePosj, (j === 0 ? -1 : 1) * sj.length / 2, 0);
	                        vec2.rotate(circlePosj, circlePosj, aj);
	                        vec2.add(circlePosj, circlePosj, xj);
	
	                        // Temporarily turn off friction
	                        if (this.enableFrictionReduction) {
	                            enableFrictionBefore = this.enableFriction;
	                            this.enableFriction = false;
	                        }
	
	                        var result = this.circleCircle(bi, si, circlePosi, ai, bj, sj, circlePosj, aj, justTest, si.radius, sj.radius);
	
	                        if (this.enableFrictionReduction) {
	                            this.enableFriction = enableFrictionBefore;
	                        }
	
	                        if (justTest && result) {
	                            return true;
	                        }
	
	                        numContacts += result;
	                    }
	                }
	
	                if (this.enableFrictionReduction) {
	                    // Temporarily turn off friction
	                    enableFrictionBefore = this.enableFriction;
	                    this.enableFriction = false;
	                }
	
	                // Check circles against the center boxs
	                var rect = capsuleCapsule_tempRect1;
	                setConvexToCapsuleShapeMiddle(rect, si);
	                var result1 = this.convexCapsule(bi, rect, xi, ai, bj, sj, xj, aj, justTest);
	
	                if (this.enableFrictionReduction) {
	                    this.enableFriction = enableFrictionBefore;
	                }
	
	                if (justTest && result1) {
	                    return true;
	                }
	                numContacts += result1;
	
	                if (this.enableFrictionReduction) {
	                    // Temporarily turn off friction
	                    var enableFrictionBefore = this.enableFriction;
	                    this.enableFriction = false;
	                }
	
	                setConvexToCapsuleShapeMiddle(rect, sj);
	                var result2 = this.convexCapsule(bj, rect, xj, aj, bi, si, xi, ai, justTest);
	
	                if (this.enableFrictionReduction) {
	                    this.enableFriction = enableFrictionBefore;
	                }
	
	                if (justTest && result2) {
	                    return true;
	                }
	                numContacts += result2;
	
	                if (this.enableFrictionReduction) {
	                    if (numContacts && this.enableFriction) {
	                        this.frictionEquations.push(this.createFrictionFromAverage(numContacts));
	                    }
	                }
	
	                return numContacts;
	            };
	
	            /**
	             * Line/line narrowphase
	             * @method lineLine
	             * @param  {Body}       bodyA
	             * @param  {Line}       shapeA
	             * @param  {Array}      positionA
	             * @param  {Number}     angleA
	             * @param  {Body}       bodyB
	             * @param  {Line}       shapeB
	             * @param  {Array}      positionB
	             * @param  {Number}     angleB
	             * @todo Implement me!
	             */
	            Narrowphase.prototype[Shape.LINE | Shape.LINE] = Narrowphase.prototype.lineLine = function (bodyA, shapeA, positionA, angleA, bodyB, shapeB, positionB, angleB, justTest) {
	                // TODO
	                if (justTest) {
	                    return false;
	                } else {
	                    return 0;
	                }
	            };
	
	            /**
	             * Plane/line Narrowphase
	             * @method planeLine
	             * @param  {Body}   planeBody
	             * @param  {Plane}  planeShape
	             * @param  {Array}  planeOffset
	             * @param  {Number} planeAngle
	             * @param  {Body}   lineBody
	             * @param  {Line}   lineShape
	             * @param  {Array}  lineOffset
	             * @param  {Number} lineAngle
	             */
	            Narrowphase.prototype[Shape.PLANE | Shape.LINE] = Narrowphase.prototype.planeLine = function (planeBody, planeShape, planeOffset, planeAngle, lineBody, lineShape, lineOffset, lineAngle, justTest) {
	                var worldVertex0 = tmp1,
	                    worldVertex1 = tmp2,
	                    worldVertex01 = tmp3,
	                    worldVertex11 = tmp4,
	                    worldEdge = tmp5,
	                    worldEdgeUnit = tmp6,
	                    dist = tmp7,
	                    worldNormal = tmp8,
	                    worldTangent = tmp9,
	                    verts = tmpArray,
	                    numContacts = 0;
	
	                // Get start and end points
	                vec2.set(worldVertex0, -lineShape.length / 2, 0);
	                vec2.set(worldVertex1, lineShape.length / 2, 0);
	
	                // Not sure why we have to use worldVertex*1 here, but it won't work otherwise. Tired.
	                vec2.rotate(worldVertex01, worldVertex0, lineAngle);
	                vec2.rotate(worldVertex11, worldVertex1, lineAngle);
	
	                add(worldVertex01, worldVertex01, lineOffset);
	                add(worldVertex11, worldVertex11, lineOffset);
	
	                vec2.copy(worldVertex0, worldVertex01);
	                vec2.copy(worldVertex1, worldVertex11);
	
	                // Get vector along the line
	                sub(worldEdge, worldVertex1, worldVertex0);
	                vec2.normalize(worldEdgeUnit, worldEdge);
	
	                // Get tangent to the edge.
	                vec2.rotate90cw(worldTangent, worldEdgeUnit);
	
	                vec2.rotate(worldNormal, yAxis, planeAngle);
	
	                // Check line ends
	                verts[0] = worldVertex0;
	                verts[1] = worldVertex1;
	                for (var i = 0; i < verts.length; i++) {
	                    var v = verts[i];
	
	                    sub(dist, v, planeOffset);
	
	                    var d = dot(dist, worldNormal);
	
	                    if (d < 0) {
	
	                        if (justTest) {
	                            return true;
	                        }
	
	                        var c = this.createContactEquation(planeBody, lineBody, planeShape, lineShape);
	                        numContacts++;
	
	                        vec2.copy(c.normalA, worldNormal);
	                        vec2.normalize(c.normalA, c.normalA);
	
	                        // distance vector along plane normal
	                        vec2.scale(dist, worldNormal, d);
	
	                        // Vector from plane center to contact
	                        sub(c.contactPointA, v, dist);
	                        sub(c.contactPointA, c.contactPointA, planeBody.position);
	
	                        // From line center to contact
	                        sub(c.contactPointB, v, lineOffset);
	                        add(c.contactPointB, c.contactPointB, lineOffset);
	                        sub(c.contactPointB, c.contactPointB, lineBody.position);
	
	                        this.contactEquations.push(c);
	
	                        if (!this.enableFrictionReduction) {
	                            if (this.enableFriction) {
	                                this.frictionEquations.push(this.createFrictionFromContact(c));
	                            }
	                        }
	                    }
	                }
	
	                if (justTest) {
	                    return false;
	                }
	
	                if (!this.enableFrictionReduction) {
	                    if (numContacts && this.enableFriction) {
	                        this.frictionEquations.push(this.createFrictionFromAverage(numContacts));
	                    }
	                }
	
	                return numContacts;
	            };
	
	            Narrowphase.prototype[Shape.PARTICLE | Shape.CAPSULE] = Narrowphase.prototype.particleCapsule = function (particleBody, particleShape, particlePosition, particleAngle, capsuleBody, capsuleShape, capsulePosition, capsuleAngle, justTest) {
	                return this.circleLine(particleBody, particleShape, particlePosition, particleAngle, capsuleBody, capsuleShape, capsulePosition, capsuleAngle, justTest, capsuleShape.radius, 0);
	            };
	
	            /**
	             * Circle/line Narrowphase
	             * @method circleLine
	             * @param  {Body} circleBody
	             * @param  {Circle} circleShape
	             * @param  {Array} circleOffset
	             * @param  {Number} circleAngle
	             * @param  {Body} lineBody
	             * @param  {Line} lineShape
	             * @param  {Array} lineOffset
	             * @param  {Number} lineAngle
	             * @param {Boolean} justTest If set to true, this function will return the result (intersection or not) without adding equations.
	             * @param {Number} lineRadius Radius to add to the line. Can be used to test Capsules.
	             * @param {Number} circleRadius If set, this value overrides the circle shape radius.
	             */
	            Narrowphase.prototype[Shape.CIRCLE | Shape.LINE] = Narrowphase.prototype.circleLine = function (circleBody, circleShape, circleOffset, circleAngle, lineBody, lineShape, lineOffset, lineAngle, justTest, lineRadius, circleRadius) {
	                var lineRadius = lineRadius || 0,
	                    circleRadius = typeof circleRadius !== "undefined" ? circleRadius : circleShape.radius,
	                    orthoDist = tmp1,
	                    lineToCircleOrthoUnit = tmp2,
	                    projectedPoint = tmp3,
	                    centerDist = tmp4,
	                    worldTangent = tmp5,
	                    worldEdge = tmp6,
	                    worldEdgeUnit = tmp7,
	                    worldVertex0 = tmp8,
	                    worldVertex1 = tmp9,
	                    worldVertex01 = tmp10,
	                    worldVertex11 = tmp11,
	                    dist = tmp12,
	                    lineToCircle = tmp13,
	                    lineEndToLineRadius = tmp14,
	                    verts = tmpArray;
	
	                // Get start and end points
	                vec2.set(worldVertex0, -lineShape.length / 2, 0);
	                vec2.set(worldVertex1, lineShape.length / 2, 0);
	
	                // Not sure why we have to use worldVertex*1 here, but it won't work otherwise. Tired.
	                vec2.rotate(worldVertex01, worldVertex0, lineAngle);
	                vec2.rotate(worldVertex11, worldVertex1, lineAngle);
	
	                add(worldVertex01, worldVertex01, lineOffset);
	                add(worldVertex11, worldVertex11, lineOffset);
	
	                vec2.copy(worldVertex0, worldVertex01);
	                vec2.copy(worldVertex1, worldVertex11);
	
	                // Get vector along the line
	                sub(worldEdge, worldVertex1, worldVertex0);
	                vec2.normalize(worldEdgeUnit, worldEdge);
	
	                // Get tangent to the edge.
	                vec2.rotate90cw(worldTangent, worldEdgeUnit);
	
	                // Check distance from the plane spanned by the edge vs the circle
	                sub(dist, circleOffset, worldVertex0);
	                var d = dot(dist, worldTangent); // Distance from center of line to circle center
	                sub(centerDist, worldVertex0, lineOffset);
	
	                sub(lineToCircle, circleOffset, lineOffset);
	
	                var radiusSum = circleRadius + lineRadius;
	
	                if (Math.abs(d) < radiusSum) {
	
	                    // Now project the circle onto the edge
	                    vec2.scale(orthoDist, worldTangent, d);
	                    sub(projectedPoint, circleOffset, orthoDist);
	
	                    // Add the missing line radius
	                    vec2.scale(lineToCircleOrthoUnit, worldTangent, dot(worldTangent, lineToCircle));
	                    vec2.normalize(lineToCircleOrthoUnit, lineToCircleOrthoUnit);
	                    vec2.scale(lineToCircleOrthoUnit, lineToCircleOrthoUnit, lineRadius);
	                    add(projectedPoint, projectedPoint, lineToCircleOrthoUnit);
	
	                    // Check if the point is within the edge span
	                    var pos = dot(worldEdgeUnit, projectedPoint);
	                    var pos0 = dot(worldEdgeUnit, worldVertex0);
	                    var pos1 = dot(worldEdgeUnit, worldVertex1);
	
	                    if (pos > pos0 && pos < pos1) {
	                        // We got contact!
	
	                        if (justTest) {
	                            return true;
	                        }
	
	                        var c = this.createContactEquation(circleBody, lineBody, circleShape, lineShape);
	
	                        vec2.scale(c.normalA, orthoDist, -1);
	                        vec2.normalize(c.normalA, c.normalA);
	
	                        vec2.scale(c.contactPointA, c.normalA, circleRadius);
	                        add(c.contactPointA, c.contactPointA, circleOffset);
	                        sub(c.contactPointA, c.contactPointA, circleBody.position);
	
	                        sub(c.contactPointB, projectedPoint, lineOffset);
	                        add(c.contactPointB, c.contactPointB, lineOffset);
	                        sub(c.contactPointB, c.contactPointB, lineBody.position);
	
	                        this.contactEquations.push(c);
	
	                        if (this.enableFriction) {
	                            this.frictionEquations.push(this.createFrictionFromContact(c));
	                        }
	
	                        return 1;
	                    }
	                }
	
	                // Add corner
	                verts[0] = worldVertex0;
	                verts[1] = worldVertex1;
	
	                for (var i = 0; i < verts.length; i++) {
	                    var v = verts[i];
	
	                    sub(dist, v, circleOffset);
	
	                    if (vec2.squaredLength(dist) < Math.pow(radiusSum, 2)) {
	
	                        if (justTest) {
	                            return true;
	                        }
	
	                        var c = this.createContactEquation(circleBody, lineBody, circleShape, lineShape);
	
	                        vec2.copy(c.normalA, dist);
	                        vec2.normalize(c.normalA, c.normalA);
	
	                        // Vector from circle to contact point is the normal times the circle radius
	                        vec2.scale(c.contactPointA, c.normalA, circleRadius);
	                        add(c.contactPointA, c.contactPointA, circleOffset);
	                        sub(c.contactPointA, c.contactPointA, circleBody.position);
	
	                        sub(c.contactPointB, v, lineOffset);
	                        vec2.scale(lineEndToLineRadius, c.normalA, -lineRadius);
	                        add(c.contactPointB, c.contactPointB, lineEndToLineRadius);
	                        add(c.contactPointB, c.contactPointB, lineOffset);
	                        sub(c.contactPointB, c.contactPointB, lineBody.position);
	
	                        this.contactEquations.push(c);
	
	                        if (this.enableFriction) {
	                            this.frictionEquations.push(this.createFrictionFromContact(c));
	                        }
	
	                        return 1;
	                    }
	                }
	
	                return 0;
	            };
	
	            /**
	             * Circle/capsule Narrowphase
	             * @method circleCapsule
	             * @param  {Body}   bi
	             * @param  {Circle} si
	             * @param  {Array}  xi
	             * @param  {Number} ai
	             * @param  {Body}   bj
	             * @param  {Line}   sj
	             * @param  {Array}  xj
	             * @param  {Number} aj
	             */
	            Narrowphase.prototype[Shape.CIRCLE | Shape.CAPSULE] = Narrowphase.prototype.circleCapsule = function (bi, si, xi, ai, bj, sj, xj, aj, justTest) {
	                return this.circleLine(bi, si, xi, ai, bj, sj, xj, aj, justTest, sj.radius);
	            };
	
	            /**
	             * Circle/convex Narrowphase.
	             * @method circleConvex
	             * @param  {Body} circleBody
	             * @param  {Circle} circleShape
	             * @param  {Array} circleOffset
	             * @param  {Number} circleAngle
	             * @param  {Body} convexBody
	             * @param  {Convex} convexShape
	             * @param  {Array} convexOffset
	             * @param  {Number} convexAngle
	             * @param  {Boolean} justTest
	             * @param  {Number} circleRadius
	             */
	            Narrowphase.prototype[Shape.CIRCLE | Shape.CONVEX] = Narrowphase.prototype[Shape.CIRCLE | Shape.BOX] = Narrowphase.prototype.circleConvex = function (circleBody, circleShape, circleOffset, circleAngle, convexBody, convexShape, convexOffset, convexAngle, justTest, circleRadius) {
	                var circleRadius = typeof circleRadius === "number" ? circleRadius : circleShape.radius;
	
	                var worldVertex0 = tmp1,
	                    worldVertex1 = tmp2,
	                    worldEdge = tmp3,
	                    worldEdgeUnit = tmp4,
	                    worldNormal = tmp5,
	                    centerDist = tmp6,
	                    convexToCircle = tmp7,
	                    orthoDist = tmp8,
	                    projectedPoint = tmp9,
	                    dist = tmp10,
	                    worldVertex = tmp11,
	                    closestEdge = -1,
	                    closestEdgeDistance = null,
	                    closestEdgeOrthoDist = tmp12,
	                    closestEdgeProjectedPoint = tmp13,
	                    candidate = tmp14,
	                    candidateDist = tmp15,
	                    minCandidate = tmp16,
	                    found = false,
	                    minCandidateDistance = Number.MAX_VALUE;
	
	                var numReported = 0;
	
	                // New algorithm:
	                // 1. Check so center of circle is not inside the polygon. If it is, this wont work...
	                // 2. For each edge
	                // 2. 1. Get point on circle that is closest to the edge (scale normal with -radius)
	                // 2. 2. Check if point is inside.
	
	                var verts = convexShape.vertices;
	
	                // Check all edges first
	                for (var i = 0; i !== verts.length + 1; i++) {
	                    var v0 = verts[i % verts.length],
	                        v1 = verts[(i + 1) % verts.length];
	
	                    vec2.rotate(worldVertex0, v0, convexAngle);
	                    vec2.rotate(worldVertex1, v1, convexAngle);
	                    add(worldVertex0, worldVertex0, convexOffset);
	                    add(worldVertex1, worldVertex1, convexOffset);
	                    sub(worldEdge, worldVertex1, worldVertex0);
	
	                    vec2.normalize(worldEdgeUnit, worldEdge);
	
	                    // Get tangent to the edge. Points out of the Convex
	                    vec2.rotate90cw(worldNormal, worldEdgeUnit);
	
	                    // Get point on circle, closest to the polygon
	                    vec2.scale(candidate, worldNormal, -circleShape.radius);
	                    add(candidate, candidate, circleOffset);
	
	                    if (pointInConvex(candidate, convexShape, convexOffset, convexAngle)) {
	
	                        vec2.sub(candidateDist, worldVertex0, candidate);
	                        var candidateDistance = Math.abs(vec2.dot(candidateDist, worldNormal));
	
	                        if (candidateDistance < minCandidateDistance) {
	                            vec2.copy(minCandidate, candidate);
	                            minCandidateDistance = candidateDistance;
	                            vec2.scale(closestEdgeProjectedPoint, worldNormal, candidateDistance);
	                            vec2.add(closestEdgeProjectedPoint, closestEdgeProjectedPoint, candidate);
	                            found = true;
	                        }
	                    }
	                }
	
	                if (found) {
	
	                    if (justTest) {
	                        return true;
	                    }
	
	                    var c = this.createContactEquation(circleBody, convexBody, circleShape, convexShape);
	                    vec2.sub(c.normalA, minCandidate, circleOffset);
	                    vec2.normalize(c.normalA, c.normalA);
	
	                    vec2.scale(c.contactPointA, c.normalA, circleRadius);
	                    add(c.contactPointA, c.contactPointA, circleOffset);
	                    sub(c.contactPointA, c.contactPointA, circleBody.position);
	
	                    sub(c.contactPointB, closestEdgeProjectedPoint, convexOffset);
	                    add(c.contactPointB, c.contactPointB, convexOffset);
	                    sub(c.contactPointB, c.contactPointB, convexBody.position);
	
	                    this.contactEquations.push(c);
	
	                    if (this.enableFriction) {
	                        this.frictionEquations.push(this.createFrictionFromContact(c));
	                    }
	
	                    return 1;
	                }
	
	                // Check all vertices
	                if (circleRadius > 0) {
	                    for (var i = 0; i < verts.length; i++) {
	                        var localVertex = verts[i];
	                        vec2.rotate(worldVertex, localVertex, convexAngle);
	                        add(worldVertex, worldVertex, convexOffset);
	
	                        sub(dist, worldVertex, circleOffset);
	                        if (vec2.squaredLength(dist) < Math.pow(circleRadius, 2)) {
	
	                            if (justTest) {
	                                return true;
	                            }
	
	                            var c = this.createContactEquation(circleBody, convexBody, circleShape, convexShape);
	
	                            vec2.copy(c.normalA, dist);
	                            vec2.normalize(c.normalA, c.normalA);
	
	                            // Vector from circle to contact point is the normal times the circle radius
	                            vec2.scale(c.contactPointA, c.normalA, circleRadius);
	                            add(c.contactPointA, c.contactPointA, circleOffset);
	                            sub(c.contactPointA, c.contactPointA, circleBody.position);
	
	                            sub(c.contactPointB, worldVertex, convexOffset);
	                            add(c.contactPointB, c.contactPointB, convexOffset);
	                            sub(c.contactPointB, c.contactPointB, convexBody.position);
	
	                            this.contactEquations.push(c);
	
	                            if (this.enableFriction) {
	                                this.frictionEquations.push(this.createFrictionFromContact(c));
	                            }
	
	                            return 1;
	                        }
	                    }
	                }
	
	                return 0;
	            };
	
	            var pic_worldVertex0 = vec2.create(),
	                pic_worldVertex1 = vec2.create(),
	                pic_r0 = vec2.create(),
	                pic_r1 = vec2.create();
	
	            /*
	             * Check if a point is in a polygon
	             */
	            function pointInConvex(worldPoint, convexShape, convexOffset, convexAngle) {
	                var worldVertex0 = pic_worldVertex0,
	                    worldVertex1 = pic_worldVertex1,
	                    r0 = pic_r0,
	                    r1 = pic_r1,
	                    point = worldPoint,
	                    verts = convexShape.vertices,
	                    lastCross = null;
	                for (var i = 0; i !== verts.length + 1; i++) {
	                    var v0 = verts[i % verts.length],
	                        v1 = verts[(i + 1) % verts.length];
	
	                    // Transform vertices to world
	                    // @todo The point should be transformed to local coordinates in the convex, no need to transform each vertex
	                    vec2.rotate(worldVertex0, v0, convexAngle);
	                    vec2.rotate(worldVertex1, v1, convexAngle);
	                    add(worldVertex0, worldVertex0, convexOffset);
	                    add(worldVertex1, worldVertex1, convexOffset);
	
	                    sub(r0, worldVertex0, point);
	                    sub(r1, worldVertex1, point);
	                    var cross = vec2.crossLength(r0, r1);
	
	                    if (lastCross === null) {
	                        lastCross = cross;
	                    }
	
	                    // If we got a different sign of the distance vector, the point is out of the polygon
	                    if (cross * lastCross <= 0) {
	                        return false;
	                    }
	                    lastCross = cross;
	                }
	                return true;
	            }
	
	            /**
	             * Particle/convex Narrowphase
	             * @method particleConvex
	             * @param  {Body} particleBody
	             * @param  {Particle} particleShape
	             * @param  {Array} particleOffset
	             * @param  {Number} particleAngle
	             * @param  {Body} convexBody
	             * @param  {Convex} convexShape
	             * @param  {Array} convexOffset
	             * @param  {Number} convexAngle
	             * @param {Boolean} justTest
	             * @todo use pointInConvex and code more similar to circleConvex
	             * @todo don't transform each vertex, but transform the particle position to convex-local instead
	             */
	            Narrowphase.prototype[Shape.PARTICLE | Shape.CONVEX] = Narrowphase.prototype[Shape.PARTICLE | Shape.BOX] = Narrowphase.prototype.particleConvex = function (particleBody, particleShape, particleOffset, particleAngle, convexBody, convexShape, convexOffset, convexAngle, justTest) {
	                var worldVertex0 = tmp1,
	                    worldVertex1 = tmp2,
	                    worldEdge = tmp3,
	                    worldEdgeUnit = tmp4,
	                    worldTangent = tmp5,
	                    centerDist = tmp6,
	                    convexToparticle = tmp7,
	                    orthoDist = tmp8,
	                    projectedPoint = tmp9,
	                    dist = tmp10,
	                    worldVertex = tmp11,
	                    closestEdge = -1,
	                    closestEdgeDistance = null,
	                    closestEdgeOrthoDist = tmp12,
	                    closestEdgeProjectedPoint = tmp13,
	                    r0 = tmp14,
	                    // vector from particle to vertex0
	                r1 = tmp15,
	                    localPoint = tmp16,
	                    candidateDist = tmp17,
	                    minEdgeNormal = tmp18,
	                    minCandidateDistance = Number.MAX_VALUE;
	
	                var numReported = 0,
	                    found = false,
	                    verts = convexShape.vertices;
	
	                // Check if the particle is in the polygon at all
	                if (!pointInConvex(particleOffset, convexShape, convexOffset, convexAngle)) {
	                    return 0;
	                }
	
	                if (justTest) {
	                    return true;
	                }
	
	                // Check edges first
	                var lastCross = null;
	                for (var i = 0; i !== verts.length + 1; i++) {
	                    var v0 = verts[i % verts.length],
	                        v1 = verts[(i + 1) % verts.length];
	
	                    // Transform vertices to world
	                    vec2.rotate(worldVertex0, v0, convexAngle);
	                    vec2.rotate(worldVertex1, v1, convexAngle);
	                    add(worldVertex0, worldVertex0, convexOffset);
	                    add(worldVertex1, worldVertex1, convexOffset);
	
	                    // Get world edge
	                    sub(worldEdge, worldVertex1, worldVertex0);
	                    vec2.normalize(worldEdgeUnit, worldEdge);
	
	                    // Get tangent to the edge. Points out of the Convex
	                    vec2.rotate90cw(worldTangent, worldEdgeUnit);
	
	                    // Check distance from the infinite line (spanned by the edge) to the particle
	                    sub(dist, particleOffset, worldVertex0);
	                    var d = dot(dist, worldTangent);
	                    sub(centerDist, worldVertex0, convexOffset);
	
	                    sub(convexToparticle, particleOffset, convexOffset);
	
	                    vec2.sub(candidateDist, worldVertex0, particleOffset);
	                    var candidateDistance = Math.abs(vec2.dot(candidateDist, worldTangent));
	
	                    if (candidateDistance < minCandidateDistance) {
	                        minCandidateDistance = candidateDistance;
	                        vec2.scale(closestEdgeProjectedPoint, worldTangent, candidateDistance);
	                        vec2.add(closestEdgeProjectedPoint, closestEdgeProjectedPoint, particleOffset);
	                        vec2.copy(minEdgeNormal, worldTangent);
	                        found = true;
	                    }
	                }
	
	                if (found) {
	                    var c = this.createContactEquation(particleBody, convexBody, particleShape, convexShape);
	
	                    vec2.scale(c.normalA, minEdgeNormal, -1);
	                    vec2.normalize(c.normalA, c.normalA);
	
	                    // Particle has no extent to the contact point
	                    vec2.set(c.contactPointA, 0, 0);
	                    add(c.contactPointA, c.contactPointA, particleOffset);
	                    sub(c.contactPointA, c.contactPointA, particleBody.position);
	
	                    // From convex center to point
	                    sub(c.contactPointB, closestEdgeProjectedPoint, convexOffset);
	                    add(c.contactPointB, c.contactPointB, convexOffset);
	                    sub(c.contactPointB, c.contactPointB, convexBody.position);
	
	                    this.contactEquations.push(c);
	
	                    if (this.enableFriction) {
	                        this.frictionEquations.push(this.createFrictionFromContact(c));
	                    }
	
	                    return 1;
	                }
	
	                return 0;
	            };
	
	            /**
	             * Circle/circle Narrowphase
	             * @method circleCircle
	             * @param  {Body} bodyA
	             * @param  {Circle} shapeA
	             * @param  {Array} offsetA
	             * @param  {Number} angleA
	             * @param  {Body} bodyB
	             * @param  {Circle} shapeB
	             * @param  {Array} offsetB
	             * @param  {Number} angleB
	             * @param {Boolean} justTest
	             * @param {Number} [radiusA] Optional radius to use for shapeA
	             * @param {Number} [radiusB] Optional radius to use for shapeB
	             */
	            Narrowphase.prototype[Shape.CIRCLE] = Narrowphase.prototype.circleCircle = function (bodyA, shapeA, offsetA, angleA, bodyB, shapeB, offsetB, angleB, justTest, radiusA, radiusB) {
	
	                var dist = tmp1,
	                    radiusA = radiusA || shapeA.radius,
	                    radiusB = radiusB || shapeB.radius;
	
	                sub(dist, offsetA, offsetB);
	                var r = radiusA + radiusB;
	                if (vec2.squaredLength(dist) > Math.pow(r, 2)) {
	                    return 0;
	                }
	
	                if (justTest) {
	                    return true;
	                }
	
	                var c = this.createContactEquation(bodyA, bodyB, shapeA, shapeB);
	                sub(c.normalA, offsetB, offsetA);
	                vec2.normalize(c.normalA, c.normalA);
	
	                vec2.scale(c.contactPointA, c.normalA, radiusA);
	                vec2.scale(c.contactPointB, c.normalA, -radiusB);
	
	                add(c.contactPointA, c.contactPointA, offsetA);
	                sub(c.contactPointA, c.contactPointA, bodyA.position);
	
	                add(c.contactPointB, c.contactPointB, offsetB);
	                sub(c.contactPointB, c.contactPointB, bodyB.position);
	
	                this.contactEquations.push(c);
	
	                if (this.enableFriction) {
	                    this.frictionEquations.push(this.createFrictionFromContact(c));
	                }
	                return 1;
	            };
	
	            /**
	             * Plane/Convex Narrowphase
	             * @method planeConvex
	             * @param  {Body} planeBody
	             * @param  {Plane} planeShape
	             * @param  {Array} planeOffset
	             * @param  {Number} planeAngle
	             * @param  {Body} convexBody
	             * @param  {Convex} convexShape
	             * @param  {Array} convexOffset
	             * @param  {Number} convexAngle
	             * @param {Boolean} justTest
	             */
	            Narrowphase.prototype[Shape.PLANE | Shape.CONVEX] = Narrowphase.prototype[Shape.PLANE | Shape.BOX] = Narrowphase.prototype.planeConvex = function (planeBody, planeShape, planeOffset, planeAngle, convexBody, convexShape, convexOffset, convexAngle, justTest) {
	                var worldVertex = tmp1,
	                    worldNormal = tmp2,
	                    dist = tmp3;
	
	                var numReported = 0;
	                vec2.rotate(worldNormal, yAxis, planeAngle);
	
	                for (var i = 0; i !== convexShape.vertices.length; i++) {
	                    var v = convexShape.vertices[i];
	                    vec2.rotate(worldVertex, v, convexAngle);
	                    add(worldVertex, worldVertex, convexOffset);
	
	                    sub(dist, worldVertex, planeOffset);
	
	                    if (dot(dist, worldNormal) <= 0) {
	
	                        if (justTest) {
	                            return true;
	                        }
	
	                        // Found vertex
	                        numReported++;
	
	                        var c = this.createContactEquation(planeBody, convexBody, planeShape, convexShape);
	
	                        sub(dist, worldVertex, planeOffset);
	
	                        vec2.copy(c.normalA, worldNormal);
	
	                        var d = dot(dist, c.normalA);
	                        vec2.scale(dist, c.normalA, d);
	
	                        // rj is from convex center to contact
	                        sub(c.contactPointB, worldVertex, convexBody.position);
	
	                        // ri is from plane center to contact
	                        sub(c.contactPointA, worldVertex, dist);
	                        sub(c.contactPointA, c.contactPointA, planeBody.position);
	
	                        this.contactEquations.push(c);
	
	                        if (!this.enableFrictionReduction) {
	                            if (this.enableFriction) {
	                                this.frictionEquations.push(this.createFrictionFromContact(c));
	                            }
	                        }
	                    }
	                }
	
	                if (this.enableFrictionReduction) {
	                    if (this.enableFriction && numReported) {
	                        this.frictionEquations.push(this.createFrictionFromAverage(numReported));
	                    }
	                }
	
	                return numReported;
	            };
	
	            /**
	             * Narrowphase for particle vs plane
	             * @method particlePlane
	             * @param  {Body}       particleBody
	             * @param  {Particle}   particleShape
	             * @param  {Array}      particleOffset
	             * @param  {Number}     particleAngle
	             * @param  {Body}       planeBody
	             * @param  {Plane}      planeShape
	             * @param  {Array}      planeOffset
	             * @param  {Number}     planeAngle
	             * @param {Boolean}     justTest
	             */
	            Narrowphase.prototype[Shape.PARTICLE | Shape.PLANE] = Narrowphase.prototype.particlePlane = function (particleBody, particleShape, particleOffset, particleAngle, planeBody, planeShape, planeOffset, planeAngle, justTest) {
	                var dist = tmp1,
	                    worldNormal = tmp2;
	
	                planeAngle = planeAngle || 0;
	
	                sub(dist, particleOffset, planeOffset);
	                vec2.rotate(worldNormal, yAxis, planeAngle);
	
	                var d = dot(dist, worldNormal);
	
	                if (d > 0) {
	                    return 0;
	                }
	                if (justTest) {
	                    return true;
	                }
	
	                var c = this.createContactEquation(planeBody, particleBody, planeShape, particleShape);
	
	                vec2.copy(c.normalA, worldNormal);
	                vec2.scale(dist, c.normalA, d);
	                // dist is now the distance vector in the normal direction
	
	                // ri is the particle position projected down onto the plane, from the plane center
	                sub(c.contactPointA, particleOffset, dist);
	                sub(c.contactPointA, c.contactPointA, planeBody.position);
	
	                // rj is from the body center to the particle center
	                sub(c.contactPointB, particleOffset, particleBody.position);
	
	                this.contactEquations.push(c);
	
	                if (this.enableFriction) {
	                    this.frictionEquations.push(this.createFrictionFromContact(c));
	                }
	                return 1;
	            };
	
	            /**
	             * Circle/Particle Narrowphase
	             * @method circleParticle
	             * @param  {Body} circleBody
	             * @param  {Circle} circleShape
	             * @param  {Array} circleOffset
	             * @param  {Number} circleAngle
	             * @param  {Body} particleBody
	             * @param  {Particle} particleShape
	             * @param  {Array} particleOffset
	             * @param  {Number} particleAngle
	             * @param  {Boolean} justTest
	             */
	            Narrowphase.prototype[Shape.CIRCLE | Shape.PARTICLE] = Narrowphase.prototype.circleParticle = function (circleBody, circleShape, circleOffset, circleAngle, particleBody, particleShape, particleOffset, particleAngle, justTest) {
	                var dist = tmp1;
	
	                sub(dist, particleOffset, circleOffset);
	                if (vec2.squaredLength(dist) > Math.pow(circleShape.radius, 2)) {
	                    return 0;
	                }
	                if (justTest) {
	                    return true;
	                }
	
	                var c = this.createContactEquation(circleBody, particleBody, circleShape, particleShape);
	                vec2.copy(c.normalA, dist);
	                vec2.normalize(c.normalA, c.normalA);
	
	                // Vector from circle to contact point is the normal times the circle radius
	                vec2.scale(c.contactPointA, c.normalA, circleShape.radius);
	                add(c.contactPointA, c.contactPointA, circleOffset);
	                sub(c.contactPointA, c.contactPointA, circleBody.position);
	
	                // Vector from particle center to contact point is zero
	                sub(c.contactPointB, particleOffset, particleBody.position);
	
	                this.contactEquations.push(c);
	
	                if (this.enableFriction) {
	                    this.frictionEquations.push(this.createFrictionFromContact(c));
	                }
	
	                return 1;
	            };
	
	            var planeCapsule_tmpCircle = new Circle({ radius: 1 }),
	                planeCapsule_tmp1 = vec2.create(),
	                planeCapsule_tmp2 = vec2.create(),
	                planeCapsule_tmp3 = vec2.create();
	
	            /**
	             * @method planeCapsule
	             * @param  {Body} planeBody
	             * @param  {Circle} planeShape
	             * @param  {Array} planeOffset
	             * @param  {Number} planeAngle
	             * @param  {Body} capsuleBody
	             * @param  {Particle} capsuleShape
	             * @param  {Array} capsuleOffset
	             * @param  {Number} capsuleAngle
	             * @param {Boolean} justTest
	             */
	            Narrowphase.prototype[Shape.PLANE | Shape.CAPSULE] = Narrowphase.prototype.planeCapsule = function (planeBody, planeShape, planeOffset, planeAngle, capsuleBody, capsuleShape, capsuleOffset, capsuleAngle, justTest) {
	                var end1 = planeCapsule_tmp1,
	                    end2 = planeCapsule_tmp2,
	                    circle = planeCapsule_tmpCircle,
	                    dst = planeCapsule_tmp3;
	
	                // Compute world end positions
	                vec2.set(end1, -capsuleShape.length / 2, 0);
	                vec2.rotate(end1, end1, capsuleAngle);
	                add(end1, end1, capsuleOffset);
	
	                vec2.set(end2, capsuleShape.length / 2, 0);
	                vec2.rotate(end2, end2, capsuleAngle);
	                add(end2, end2, capsuleOffset);
	
	                circle.radius = capsuleShape.radius;
	
	                var enableFrictionBefore;
	
	                // Temporarily turn off friction
	                if (this.enableFrictionReduction) {
	                    enableFrictionBefore = this.enableFriction;
	                    this.enableFriction = false;
	                }
	
	                // Do Narrowphase as two circles
	                var numContacts1 = this.circlePlane(capsuleBody, circle, end1, 0, planeBody, planeShape, planeOffset, planeAngle, justTest),
	                    numContacts2 = this.circlePlane(capsuleBody, circle, end2, 0, planeBody, planeShape, planeOffset, planeAngle, justTest);
	
	                // Restore friction
	                if (this.enableFrictionReduction) {
	                    this.enableFriction = enableFrictionBefore;
	                }
	
	                if (justTest) {
	                    return numContacts1 || numContacts2;
	                } else {
	                    var numTotal = numContacts1 + numContacts2;
	                    if (this.enableFrictionReduction) {
	                        if (numTotal) {
	                            this.frictionEquations.push(this.createFrictionFromAverage(numTotal));
	                        }
	                    }
	                    return numTotal;
	                }
	            };
	
	            /**
	             * Creates ContactEquations and FrictionEquations for a collision.
	             * @method circlePlane
	             * @param  {Body}    bi     The first body that should be connected to the equations.
	             * @param  {Circle}  si     The circle shape participating in the collision.
	             * @param  {Array}   xi     Extra offset to take into account for the Shape, in addition to the one in circleBody.position. Will *not* be rotated by circleBody.angle (maybe it should, for sake of homogenity?). Set to null if none.
	             * @param  {Body}    bj     The second body that should be connected to the equations.
	             * @param  {Plane}   sj     The Plane shape that is participating
	             * @param  {Array}   xj     Extra offset for the plane shape.
	             * @param  {Number}  aj     Extra angle to apply to the plane
	             */
	            Narrowphase.prototype[Shape.CIRCLE | Shape.PLANE] = Narrowphase.prototype.circlePlane = function (bi, si, xi, ai, bj, sj, xj, aj, justTest) {
	                var circleBody = bi,
	                    circleShape = si,
	                    circleOffset = xi,
	                    // Offset from body center, rotated!
	                planeBody = bj,
	                    shapeB = sj,
	                    planeOffset = xj,
	                    planeAngle = aj;
	
	                planeAngle = planeAngle || 0;
	
	                // Vector from plane to circle
	                var planeToCircle = tmp1,
	                    worldNormal = tmp2,
	                    temp = tmp3;
	
	                sub(planeToCircle, circleOffset, planeOffset);
	
	                // World plane normal
	                vec2.rotate(worldNormal, yAxis, planeAngle);
	
	                // Normal direction distance
	                var d = dot(worldNormal, planeToCircle);
	
	                if (d > circleShape.radius) {
	                    return 0; // No overlap. Abort.
	                }
	
	                if (justTest) {
	                    return true;
	                }
	
	                // Create contact
	                var contact = this.createContactEquation(planeBody, circleBody, sj, si);
	
	                // ni is the plane world normal
	                vec2.copy(contact.normalA, worldNormal);
	
	                // rj is the vector from circle center to the contact point
	                vec2.scale(contact.contactPointB, contact.normalA, -circleShape.radius);
	                add(contact.contactPointB, contact.contactPointB, circleOffset);
	                sub(contact.contactPointB, contact.contactPointB, circleBody.position);
	
	                // ri is the distance from plane center to contact.
	                vec2.scale(temp, contact.normalA, d);
	                sub(contact.contactPointA, planeToCircle, temp); // Subtract normal distance vector from the distance vector
	                add(contact.contactPointA, contact.contactPointA, planeOffset);
	                sub(contact.contactPointA, contact.contactPointA, planeBody.position);
	
	                this.contactEquations.push(contact);
	
	                if (this.enableFriction) {
	                    this.frictionEquations.push(this.createFrictionFromContact(contact));
	                }
	
	                return 1;
	            };
	
	            /**
	             * Convex/convex Narrowphase.See <a href="http://www.altdevblogaday.com/2011/05/13/contact-generation-between-3d-convex-meshes/">this article</a> for more info.
	             * @method convexConvex
	             * @param  {Body} bi
	             * @param  {Convex} si
	             * @param  {Array} xi
	             * @param  {Number} ai
	             * @param  {Body} bj
	             * @param  {Convex} sj
	             * @param  {Array} xj
	             * @param  {Number} aj
	             */
	            Narrowphase.prototype[Shape.CONVEX] = Narrowphase.prototype[Shape.CONVEX | Shape.BOX] = Narrowphase.prototype[Shape.BOX] = Narrowphase.prototype.convexConvex = function (bi, si, xi, ai, bj, sj, xj, aj, justTest, precision) {
	                var sepAxis = tmp1,
	                    worldPoint = tmp2,
	                    worldPoint0 = tmp3,
	                    worldPoint1 = tmp4,
	                    worldEdge = tmp5,
	                    projected = tmp6,
	                    penetrationVec = tmp7,
	                    dist = tmp8,
	                    worldNormal = tmp9,
	                    numContacts = 0,
	                    precision = typeof precision === 'number' ? precision : 0;
	
	                var found = Narrowphase.findSeparatingAxis(si, xi, ai, sj, xj, aj, sepAxis);
	                if (!found) {
	                    return 0;
	                }
	
	                // Make sure the separating axis is directed from shape i to shape j
	                sub(dist, xj, xi);
	                if (dot(sepAxis, dist) > 0) {
	                    vec2.scale(sepAxis, sepAxis, -1);
	                }
	
	                // Find edges with normals closest to the separating axis
	                var closestEdge1 = Narrowphase.getClosestEdge(si, ai, sepAxis, true),
	                    // Flipped axis
	                closestEdge2 = Narrowphase.getClosestEdge(sj, aj, sepAxis);
	
	                if (closestEdge1 === -1 || closestEdge2 === -1) {
	                    return 0;
	                }
	
	                // Loop over the shapes
	                for (var k = 0; k < 2; k++) {
	
	                    var closestEdgeA = closestEdge1,
	                        closestEdgeB = closestEdge2,
	                        shapeA = si,
	                        shapeB = sj,
	                        offsetA = xi,
	                        offsetB = xj,
	                        angleA = ai,
	                        angleB = aj,
	                        bodyA = bi,
	                        bodyB = bj;
	
	                    if (k === 0) {
	                        // Swap!
	                        var tmp;
	                        tmp = closestEdgeA;
	                        closestEdgeA = closestEdgeB;
	                        closestEdgeB = tmp;
	
	                        tmp = shapeA;
	                        shapeA = shapeB;
	                        shapeB = tmp;
	
	                        tmp = offsetA;
	                        offsetA = offsetB;
	                        offsetB = tmp;
	
	                        tmp = angleA;
	                        angleA = angleB;
	                        angleB = tmp;
	
	                        tmp = bodyA;
	                        bodyA = bodyB;
	                        bodyB = tmp;
	                    }
	
	                    // Loop over 2 points in convex B
	                    for (var j = closestEdgeB; j < closestEdgeB + 2; j++) {
	
	                        // Get world point
	                        var v = shapeB.vertices[(j + shapeB.vertices.length) % shapeB.vertices.length];
	                        vec2.rotate(worldPoint, v, angleB);
	                        add(worldPoint, worldPoint, offsetB);
	
	                        var insideNumEdges = 0;
	
	                        // Loop over the 3 closest edges in convex A
	                        for (var i = closestEdgeA - 1; i < closestEdgeA + 2; i++) {
	
	                            var v0 = shapeA.vertices[(i + shapeA.vertices.length) % shapeA.vertices.length],
	                                v1 = shapeA.vertices[(i + 1 + shapeA.vertices.length) % shapeA.vertices.length];
	
	                            // Construct the edge
	                            vec2.rotate(worldPoint0, v0, angleA);
	                            vec2.rotate(worldPoint1, v1, angleA);
	                            add(worldPoint0, worldPoint0, offsetA);
	                            add(worldPoint1, worldPoint1, offsetA);
	
	                            sub(worldEdge, worldPoint1, worldPoint0);
	
	                            vec2.rotate90cw(worldNormal, worldEdge); // Normal points out of convex 1
	                            vec2.normalize(worldNormal, worldNormal);
	
	                            sub(dist, worldPoint, worldPoint0);
	
	                            var d = dot(worldNormal, dist);
	
	                            if (i === closestEdgeA && d <= precision || i !== closestEdgeA && d <= 0) {
	                                insideNumEdges++;
	                            }
	                        }
	
	                        if (insideNumEdges >= 3) {
	
	                            if (justTest) {
	                                return true;
	                            }
	
	                            // worldPoint was on the "inside" side of each of the 3 checked edges.
	                            // Project it to the center edge and use the projection direction as normal
	
	                            // Create contact
	                            var c = this.createContactEquation(bodyA, bodyB, shapeA, shapeB);
	                            numContacts++;
	
	                            // Get center edge from body A
	                            var v0 = shapeA.vertices[closestEdgeA % shapeA.vertices.length],
	                                v1 = shapeA.vertices[(closestEdgeA + 1) % shapeA.vertices.length];
	
	                            // Construct the edge
	                            vec2.rotate(worldPoint0, v0, angleA);
	                            vec2.rotate(worldPoint1, v1, angleA);
	                            add(worldPoint0, worldPoint0, offsetA);
	                            add(worldPoint1, worldPoint1, offsetA);
	
	                            sub(worldEdge, worldPoint1, worldPoint0);
	
	                            vec2.rotate90cw(c.normalA, worldEdge); // Normal points out of convex A
	                            vec2.normalize(c.normalA, c.normalA);
	
	                            sub(dist, worldPoint, worldPoint0); // From edge point to the penetrating point
	                            var d = dot(c.normalA, dist); // Penetration
	                            vec2.scale(penetrationVec, c.normalA, d); // Vector penetration
	
	                            sub(c.contactPointA, worldPoint, offsetA);
	                            sub(c.contactPointA, c.contactPointA, penetrationVec);
	                            add(c.contactPointA, c.contactPointA, offsetA);
	                            sub(c.contactPointA, c.contactPointA, bodyA.position);
	
	                            sub(c.contactPointB, worldPoint, offsetB);
	                            add(c.contactPointB, c.contactPointB, offsetB);
	                            sub(c.contactPointB, c.contactPointB, bodyB.position);
	
	                            this.contactEquations.push(c);
	
	                            // Todo reduce to 1 friction equation if we have 2 contact points
	                            if (!this.enableFrictionReduction) {
	                                if (this.enableFriction) {
	                                    this.frictionEquations.push(this.createFrictionFromContact(c));
	                                }
	                            }
	                        }
	                    }
	                }
	
	                if (this.enableFrictionReduction) {
	                    if (this.enableFriction && numContacts) {
	                        this.frictionEquations.push(this.createFrictionFromAverage(numContacts));
	                    }
	                }
	
	                return numContacts;
	            };
	
	            // .projectConvex is called by other functions, need local tmp vectors
	            var pcoa_tmp1 = vec2.fromValues(0, 0);
	
	            /**
	             * Project a Convex onto a world-oriented axis
	             * @method projectConvexOntoAxis
	             * @static
	             * @param  {Convex} convexShape
	             * @param  {Array} convexOffset
	             * @param  {Number} convexAngle
	             * @param  {Array} worldAxis
	             * @param  {Array} result
	             */
	            Narrowphase.projectConvexOntoAxis = function (convexShape, convexOffset, convexAngle, worldAxis, result) {
	                var max = null,
	                    min = null,
	                    v,
	                    value,
	                    localAxis = pcoa_tmp1;
	
	                // Convert the axis to local coords of the body
	                vec2.rotate(localAxis, worldAxis, -convexAngle);
	
	                // Get projected position of all vertices
	                for (var i = 0; i < convexShape.vertices.length; i++) {
	                    v = convexShape.vertices[i];
	                    value = dot(v, localAxis);
	                    if (max === null || value > max) {
	                        max = value;
	                    }
	                    if (min === null || value < min) {
	                        min = value;
	                    }
	                }
	
	                if (min > max) {
	                    var t = min;
	                    min = max;
	                    max = t;
	                }
	
	                // Project the position of the body onto the axis - need to add this to the result
	                var offset = dot(convexOffset, worldAxis);
	
	                vec2.set(result, min + offset, max + offset);
	            };
	
	            // .findSeparatingAxis is called by other functions, need local tmp vectors
	            var fsa_tmp1 = vec2.fromValues(0, 0),
	                fsa_tmp2 = vec2.fromValues(0, 0),
	                fsa_tmp3 = vec2.fromValues(0, 0),
	                fsa_tmp4 = vec2.fromValues(0, 0),
	                fsa_tmp5 = vec2.fromValues(0, 0),
	                fsa_tmp6 = vec2.fromValues(0, 0);
	
	            /**
	             * Find a separating axis between the shapes, that maximizes the separating distance between them.
	             * @method findSeparatingAxis
	             * @static
	             * @param  {Convex}     c1
	             * @param  {Array}      offset1
	             * @param  {Number}     angle1
	             * @param  {Convex}     c2
	             * @param  {Array}      offset2
	             * @param  {Number}     angle2
	             * @param  {Array}      sepAxis     The resulting axis
	             * @return {Boolean}                Whether the axis could be found.
	             */
	            Narrowphase.findSeparatingAxis = function (c1, offset1, angle1, c2, offset2, angle2, sepAxis) {
	                var maxDist = null,
	                    overlap = false,
	                    found = false,
	                    edge = fsa_tmp1,
	                    worldPoint0 = fsa_tmp2,
	                    worldPoint1 = fsa_tmp3,
	                    normal = fsa_tmp4,
	                    span1 = fsa_tmp5,
	                    span2 = fsa_tmp6;
	
	                if (c1 instanceof Box && c2 instanceof Box) {
	
	                    for (var j = 0; j !== 2; j++) {
	                        var c = c1,
	                            angle = angle1;
	                        if (j === 1) {
	                            c = c2;
	                            angle = angle2;
	                        }
	
	                        for (var i = 0; i !== 2; i++) {
	
	                            // Get the world edge
	                            if (i === 0) {
	                                vec2.set(normal, 0, 1);
	                            } else if (i === 1) {
	                                vec2.set(normal, 1, 0);
	                            }
	                            if (angle !== 0) {
	                                vec2.rotate(normal, normal, angle);
	                            }
	
	                            // Project hulls onto that normal
	                            Narrowphase.projectConvexOntoAxis(c1, offset1, angle1, normal, span1);
	                            Narrowphase.projectConvexOntoAxis(c2, offset2, angle2, normal, span2);
	
	                            // Order by span position
	                            var a = span1,
	                                b = span2,
	                                swapped = false;
	                            if (span1[0] > span2[0]) {
	                                b = span1;
	                                a = span2;
	                                swapped = true;
	                            }
	
	                            // Get separating distance
	                            var dist = b[0] - a[1];
	                            overlap = dist <= 0;
	
	                            if (maxDist === null || dist > maxDist) {
	                                vec2.copy(sepAxis, normal);
	                                maxDist = dist;
	                                found = overlap;
	                            }
	                        }
	                    }
	                } else {
	
	                    for (var j = 0; j !== 2; j++) {
	                        var c = c1,
	                            angle = angle1;
	                        if (j === 1) {
	                            c = c2;
	                            angle = angle2;
	                        }
	
	                        for (var i = 0; i !== c.vertices.length; i++) {
	                            // Get the world edge
	                            vec2.rotate(worldPoint0, c.vertices[i], angle);
	                            vec2.rotate(worldPoint1, c.vertices[(i + 1) % c.vertices.length], angle);
	
	                            sub(edge, worldPoint1, worldPoint0);
	
	                            // Get normal - just rotate 90 degrees since vertices are given in CCW
	                            vec2.rotate90cw(normal, edge);
	                            vec2.normalize(normal, normal);
	
	                            // Project hulls onto that normal
	                            Narrowphase.projectConvexOntoAxis(c1, offset1, angle1, normal, span1);
	                            Narrowphase.projectConvexOntoAxis(c2, offset2, angle2, normal, span2);
	
	                            // Order by span position
	                            var a = span1,
	                                b = span2,
	                                swapped = false;
	                            if (span1[0] > span2[0]) {
	                                b = span1;
	                                a = span2;
	                                swapped = true;
	                            }
	
	                            // Get separating distance
	                            var dist = b[0] - a[1];
	                            overlap = dist <= 0;
	
	                            if (maxDist === null || dist > maxDist) {
	                                vec2.copy(sepAxis, normal);
	                                maxDist = dist;
	                                found = overlap;
	                            }
	                        }
	                    }
	                }
	
	                /*
	                // Needs to be tested some more
	                for(var j=0; j!==2; j++){
	                    var c = c1,
	                        angle = angle1;
	                    if(j===1){
	                        c = c2;
	                        angle = angle2;
	                    }
	                     for(var i=0; i!==c.axes.length; i++){
	                         var normal = c.axes[i];
	                         // Project hulls onto that normal
	                        Narrowphase.projectConvexOntoAxis(c1, offset1, angle1, normal, span1);
	                        Narrowphase.projectConvexOntoAxis(c2, offset2, angle2, normal, span2);
	                         // Order by span position
	                        var a=span1,
	                            b=span2,
	                            swapped = false;
	                        if(span1[0] > span2[0]){
	                            b=span1;
	                            a=span2;
	                            swapped = true;
	                        }
	                         // Get separating distance
	                        var dist = b[0] - a[1];
	                        overlap = (dist <= Narrowphase.convexPrecision);
	                         if(maxDist===null || dist > maxDist){
	                            vec2.copy(sepAxis, normal);
	                            maxDist = dist;
	                            found = overlap;
	                        }
	                    }
	                }
	                */
	
	                return found;
	            };
	
	            // .getClosestEdge is called by other functions, need local tmp vectors
	            var gce_tmp1 = vec2.fromValues(0, 0),
	                gce_tmp2 = vec2.fromValues(0, 0),
	                gce_tmp3 = vec2.fromValues(0, 0);
	
	            /**
	             * Get the edge that has a normal closest to an axis.
	             * @method getClosestEdge
	             * @static
	             * @param  {Convex}     c
	             * @param  {Number}     angle
	             * @param  {Array}      axis
	             * @param  {Boolean}    flip
	             * @return {Number}             Index of the edge that is closest. This index and the next spans the resulting edge. Returns -1 if failed.
	             */
	            Narrowphase.getClosestEdge = function (c, angle, axis, flip) {
	                var localAxis = gce_tmp1,
	                    edge = gce_tmp2,
	                    normal = gce_tmp3;
	
	                // Convert the axis to local coords of the body
	                vec2.rotate(localAxis, axis, -angle);
	                if (flip) {
	                    vec2.scale(localAxis, localAxis, -1);
	                }
	
	                var closestEdge = -1,
	                    N = c.vertices.length,
	                    maxDot = -1;
	                for (var i = 0; i !== N; i++) {
	                    // Get the edge
	                    sub(edge, c.vertices[(i + 1) % N], c.vertices[i % N]);
	
	                    // Get normal - just rotate 90 degrees since vertices are given in CCW
	                    vec2.rotate90cw(normal, edge);
	                    vec2.normalize(normal, normal);
	
	                    var d = dot(normal, localAxis);
	                    if (closestEdge === -1 || d > maxDot) {
	                        closestEdge = i % N;
	                        maxDot = d;
	                    }
	                }
	
	                return closestEdge;
	            };
	
	            var circleHeightfield_candidate = vec2.create(),
	                circleHeightfield_dist = vec2.create(),
	                circleHeightfield_v0 = vec2.create(),
	                circleHeightfield_v1 = vec2.create(),
	                circleHeightfield_minCandidate = vec2.create(),
	                circleHeightfield_worldNormal = vec2.create(),
	                circleHeightfield_minCandidateNormal = vec2.create();
	
	            /**
	             * @method circleHeightfield
	             * @param  {Body}           bi
	             * @param  {Circle}         si
	             * @param  {Array}          xi
	             * @param  {Body}           bj
	             * @param  {Heightfield}    sj
	             * @param  {Array}          xj
	             * @param  {Number}         aj
	             */
	            Narrowphase.prototype[Shape.CIRCLE | Shape.HEIGHTFIELD] = Narrowphase.prototype.circleHeightfield = function (circleBody, circleShape, circlePos, circleAngle, hfBody, hfShape, hfPos, hfAngle, justTest, radius) {
	                var data = hfShape.heights,
	                    radius = radius || circleShape.radius,
	                    w = hfShape.elementWidth,
	                    dist = circleHeightfield_dist,
	                    candidate = circleHeightfield_candidate,
	                    minCandidate = circleHeightfield_minCandidate,
	                    minCandidateNormal = circleHeightfield_minCandidateNormal,
	                    worldNormal = circleHeightfield_worldNormal,
	                    v0 = circleHeightfield_v0,
	                    v1 = circleHeightfield_v1;
	
	                // Get the index of the points to test against
	                var idxA = Math.floor((circlePos[0] - radius - hfPos[0]) / w),
	                    idxB = Math.ceil((circlePos[0] + radius - hfPos[0]) / w);
	
	                /*if(idxB < 0 || idxA >= data.length)
	                    return justTest ? false : 0;*/
	
	                if (idxA < 0) {
	                    idxA = 0;
	                }
	                if (idxB >= data.length) {
	                    idxB = data.length - 1;
	                }
	
	                // Get max and min
	                var max = data[idxA],
	                    min = data[idxB];
	                for (var i = idxA; i < idxB; i++) {
	                    if (data[i] < min) {
	                        min = data[i];
	                    }
	                    if (data[i] > max) {
	                        max = data[i];
	                    }
	                }
	
	                if (circlePos[1] - radius > max) {
	                    return justTest ? false : 0;
	                }
	
	                /*
	                if(circlePos[1]+radius < min){
	                    // Below the minimum point... We can just guess.
	                    // TODO
	                }
	                */
	
	                // 1. Check so center of circle is not inside the field. If it is, this wont work...
	                // 2. For each edge
	                // 2. 1. Get point on circle that is closest to the edge (scale normal with -radius)
	                // 2. 2. Check if point is inside.
	
	                var found = false;
	
	                // Check all edges first
	                for (var i = idxA; i < idxB; i++) {
	
	                    // Get points
	                    vec2.set(v0, i * w, data[i]);
	                    vec2.set(v1, (i + 1) * w, data[i + 1]);
	                    vec2.add(v0, v0, hfPos);
	                    vec2.add(v1, v1, hfPos);
	
	                    // Get normal
	                    vec2.sub(worldNormal, v1, v0);
	                    vec2.rotate(worldNormal, worldNormal, Math.PI / 2);
	                    vec2.normalize(worldNormal, worldNormal);
	
	                    // Get point on circle, closest to the edge
	                    vec2.scale(candidate, worldNormal, -radius);
	                    vec2.add(candidate, candidate, circlePos);
	
	                    // Distance from v0 to the candidate point
	                    vec2.sub(dist, candidate, v0);
	
	                    // Check if it is in the element "stick"
	                    var d = vec2.dot(dist, worldNormal);
	                    if (candidate[0] >= v0[0] && candidate[0] < v1[0] && d <= 0) {
	
	                        if (justTest) {
	                            return true;
	                        }
	
	                        found = true;
	
	                        // Store the candidate point, projected to the edge
	                        vec2.scale(dist, worldNormal, -d);
	                        vec2.add(minCandidate, candidate, dist);
	                        vec2.copy(minCandidateNormal, worldNormal);
	
	                        var c = this.createContactEquation(hfBody, circleBody, hfShape, circleShape);
	
	                        // Normal is out of the heightfield
	                        vec2.copy(c.normalA, minCandidateNormal);
	
	                        // Vector from circle to heightfield
	                        vec2.scale(c.contactPointB, c.normalA, -radius);
	                        add(c.contactPointB, c.contactPointB, circlePos);
	                        sub(c.contactPointB, c.contactPointB, circleBody.position);
	
	                        vec2.copy(c.contactPointA, minCandidate);
	                        vec2.sub(c.contactPointA, c.contactPointA, hfBody.position);
	
	                        this.contactEquations.push(c);
	
	                        if (this.enableFriction) {
	                            this.frictionEquations.push(this.createFrictionFromContact(c));
	                        }
	                    }
	                }
	
	                // Check all vertices
	                found = false;
	                if (radius > 0) {
	                    for (var i = idxA; i <= idxB; i++) {
	
	                        // Get point
	                        vec2.set(v0, i * w, data[i]);
	                        vec2.add(v0, v0, hfPos);
	
	                        vec2.sub(dist, circlePos, v0);
	
	                        if (vec2.squaredLength(dist) < Math.pow(radius, 2)) {
	
	                            if (justTest) {
	                                return true;
	                            }
	
	                            found = true;
	
	                            var c = this.createContactEquation(hfBody, circleBody, hfShape, circleShape);
	
	                            // Construct normal - out of heightfield
	                            vec2.copy(c.normalA, dist);
	                            vec2.normalize(c.normalA, c.normalA);
	
	                            vec2.scale(c.contactPointB, c.normalA, -radius);
	                            add(c.contactPointB, c.contactPointB, circlePos);
	                            sub(c.contactPointB, c.contactPointB, circleBody.position);
	
	                            sub(c.contactPointA, v0, hfPos);
	                            add(c.contactPointA, c.contactPointA, hfPos);
	                            sub(c.contactPointA, c.contactPointA, hfBody.position);
	
	                            this.contactEquations.push(c);
	
	                            if (this.enableFriction) {
	                                this.frictionEquations.push(this.createFrictionFromContact(c));
	                            }
	                        }
	                    }
	                }
	
	                if (found) {
	                    return 1;
	                }
	
	                return 0;
	            };
	
	            var convexHeightfield_v0 = vec2.create(),
	                convexHeightfield_v1 = vec2.create(),
	                convexHeightfield_tilePos = vec2.create(),
	                convexHeightfield_tempConvexShape = new Convex({ vertices: [vec2.create(), vec2.create(), vec2.create(), vec2.create()] });
	            /**
	             * @method circleHeightfield
	             * @param  {Body}           bi
	             * @param  {Circle}         si
	             * @param  {Array}          xi
	             * @param  {Body}           bj
	             * @param  {Heightfield}    sj
	             * @param  {Array}          xj
	             * @param  {Number}         aj
	             */
	            Narrowphase.prototype[Shape.BOX | Shape.HEIGHTFIELD] = Narrowphase.prototype[Shape.CONVEX | Shape.HEIGHTFIELD] = Narrowphase.prototype.convexHeightfield = function (convexBody, convexShape, convexPos, convexAngle, hfBody, hfShape, hfPos, hfAngle, justTest) {
	                var data = hfShape.heights,
	                    w = hfShape.elementWidth,
	                    v0 = convexHeightfield_v0,
	                    v1 = convexHeightfield_v1,
	                    tilePos = convexHeightfield_tilePos,
	                    tileConvex = convexHeightfield_tempConvexShape;
	
	                // Get the index of the points to test against
	                var idxA = Math.floor((convexBody.aabb.lowerBound[0] - hfPos[0]) / w),
	                    idxB = Math.ceil((convexBody.aabb.upperBound[0] - hfPos[0]) / w);
	
	                if (idxA < 0) {
	                    idxA = 0;
	                }
	                if (idxB >= data.length) {
	                    idxB = data.length - 1;
	                }
	
	                // Get max and min
	                var max = data[idxA],
	                    min = data[idxB];
	                for (var i = idxA; i < idxB; i++) {
	                    if (data[i] < min) {
	                        min = data[i];
	                    }
	                    if (data[i] > max) {
	                        max = data[i];
	                    }
	                }
	
	                if (convexBody.aabb.lowerBound[1] > max) {
	                    return justTest ? false : 0;
	                }
	
	                var found = false;
	                var numContacts = 0;
	
	                // Loop over all edges
	                // TODO: If possible, construct a convex from several data points (need o check if the points make a convex shape)
	                for (var i = idxA; i < idxB; i++) {
	
	                    // Get points
	                    vec2.set(v0, i * w, data[i]);
	                    vec2.set(v1, (i + 1) * w, data[i + 1]);
	                    vec2.add(v0, v0, hfPos);
	                    vec2.add(v1, v1, hfPos);
	
	                    // Construct a convex
	                    var tileHeight = 100; // todo
	                    vec2.set(tilePos, (v1[0] + v0[0]) * 0.5, (v1[1] + v0[1] - tileHeight) * 0.5);
	
	                    vec2.sub(tileConvex.vertices[0], v1, tilePos);
	                    vec2.sub(tileConvex.vertices[1], v0, tilePos);
	                    vec2.copy(tileConvex.vertices[2], tileConvex.vertices[1]);
	                    vec2.copy(tileConvex.vertices[3], tileConvex.vertices[0]);
	                    tileConvex.vertices[2][1] -= tileHeight;
	                    tileConvex.vertices[3][1] -= tileHeight;
	
	                    // Do convex collision
	                    numContacts += this.convexConvex(convexBody, convexShape, convexPos, convexAngle, hfBody, tileConvex, tilePos, 0, justTest);
	                }
	
	                return numContacts;
	            };
	        }, { "../equations/ContactEquation": 21, "../equations/Equation": 22, "../equations/FrictionEquation": 23, "../math/vec2": 30, "../objects/Body": 31, "../shapes/Box": 37, "../shapes/Circle": 39, "../shapes/Convex": 40, "../shapes/Shape": 45, "../utils/ContactEquationPool": 48, "../utils/FrictionEquationPool": 49, "../utils/TupleDictionary": 56, "../utils/Utils": 57 }], 11: [function (_dereq_, module, exports) {
	            module.exports = Ray;
	
	            var vec2 = _dereq_('../math/vec2');
	            var RaycastResult = _dereq_('../collision/RaycastResult');
	            var Shape = _dereq_('../shapes/Shape');
	            var AABB = _dereq_('../collision/AABB');
	
	            /**
	             * A line with a start and end point that is used to intersect shapes. For an example, see {{#crossLink "World/raycast:method"}}World.raycast{{/crossLink}}
	             * @class Ray
	             * @constructor
	             * @param {object} [options]
	             * @param {array} [options.from]
	             * @param {array} [options.to]
	             * @param {boolean} [options.checkCollisionResponse=true]
	             * @param {boolean} [options.skipBackfaces=false]
	             * @param {number} [options.collisionMask=-1]
	             * @param {number} [options.collisionGroup=-1]
	             * @param {number} [options.mode=Ray.ANY]
	             * @param {number} [options.callback]
	             */
	            function Ray(options) {
	                options = options || {};
	
	                /**
	                 * Ray start point.
	                 * @property {array} from
	                 */
	                this.from = options.from ? vec2.fromValues(options.from[0], options.from[1]) : vec2.create();
	
	                /**
	                 * Ray end point
	                 * @property {array} to
	                 */
	                this.to = options.to ? vec2.fromValues(options.to[0], options.to[1]) : vec2.create();
	
	                /**
	                 * Set to true if you want the Ray to take .collisionResponse flags into account on bodies and shapes.
	                 * @property {Boolean} checkCollisionResponse
	                 */
	                this.checkCollisionResponse = options.checkCollisionResponse !== undefined ? options.checkCollisionResponse : true;
	
	                /**
	                 * If set to true, the ray skips any hits with normal.dot(rayDirection) < 0.
	                 * @property {Boolean} skipBackfaces
	                 */
	                this.skipBackfaces = !!options.skipBackfaces;
	
	                /**
	                 * @property {number} collisionMask
	                 * @default -1
	                 */
	                this.collisionMask = options.collisionMask !== undefined ? options.collisionMask : -1;
	
	                /**
	                 * @property {number} collisionGroup
	                 * @default -1
	                 */
	                this.collisionGroup = options.collisionGroup !== undefined ? options.collisionGroup : -1;
	
	                /**
	                 * The intersection mode. Should be {{#crossLink "Ray/ANY:property"}}Ray.ANY{{/crossLink}}, {{#crossLink "Ray/ALL:property"}}Ray.ALL{{/crossLink}} or {{#crossLink "Ray/CLOSEST:property"}}Ray.CLOSEST{{/crossLink}}.
	                 * @property {number} mode
	                 */
	                this.mode = options.mode !== undefined ? options.mode : Ray.ANY;
	
	                /**
	                 * Current, user-provided result callback. Will be used if mode is Ray.ALL.
	                 * @property {Function} callback
	                 */
	                this.callback = options.callback || function (result) {};
	
	                /**
	                 * @readOnly
	                 * @property {array} direction
	                 */
	                this.direction = vec2.create();
	
	                /**
	                 * Length of the ray
	                 * @readOnly
	                 * @property {number} length
	                 */
	                this.length = 1;
	
	                this.update();
	            }
	            Ray.prototype.constructor = Ray;
	
	            /**
	             * This raycasting mode will make the Ray traverse through all intersection points and only return the closest one.
	             * @static
	             * @property {Number} CLOSEST
	             */
	            Ray.CLOSEST = 1;
	
	            /**
	             * This raycasting mode will make the Ray stop when it finds the first intersection point.
	             * @static
	             * @property {Number} ANY
	             */
	            Ray.ANY = 2;
	
	            /**
	             * This raycasting mode will traverse all intersection points and executes a callback for each one.
	             * @static
	             * @property {Number} ALL
	             */
	            Ray.ALL = 4;
	
	            /**
	             * Should be called if you change the from or to point.
	             * @method update
	             */
	            Ray.prototype.update = function () {
	
	                // Update .direction and .length
	                var d = this.direction;
	                vec2.sub(d, this.to, this.from);
	                this.length = vec2.length(d);
	                vec2.normalize(d, d);
	            };
	
	            /**
	             * @method intersectBodies
	             * @param {Array} bodies An array of Body objects.
	             */
	            Ray.prototype.intersectBodies = function (result, bodies) {
	                for (var i = 0, l = bodies.length; !result.shouldStop(this) && i < l; i++) {
	                    var body = bodies[i];
	                    var aabb = body.getAABB();
	                    if (aabb.overlapsRay(this) >= 0 || aabb.containsPoint(this.from)) {
	                        this.intersectBody(result, body);
	                    }
	                }
	            };
	
	            var intersectBody_worldPosition = vec2.create();
	
	            /**
	             * Shoot a ray at a body, get back information about the hit.
	             * @method intersectBody
	             * @private
	             * @param {Body} body
	             */
	            Ray.prototype.intersectBody = function (result, body) {
	                var checkCollisionResponse = this.checkCollisionResponse;
	
	                if (checkCollisionResponse && !body.collisionResponse) {
	                    return;
	                }
	
	                var worldPosition = intersectBody_worldPosition;
	
	                for (var i = 0, N = body.shapes.length; i < N; i++) {
	                    var shape = body.shapes[i];
	
	                    if (checkCollisionResponse && !shape.collisionResponse) {
	                        continue; // Skip
	                    }
	
	                    if ((this.collisionGroup & shape.collisionMask) === 0 || (shape.collisionGroup & this.collisionMask) === 0) {
	                        continue;
	                    }
	
	                    // Get world angle and position of the shape
	                    vec2.rotate(worldPosition, shape.position, body.angle);
	                    vec2.add(worldPosition, worldPosition, body.position);
	                    var worldAngle = shape.angle + body.angle;
	
	                    this.intersectShape(result, shape, worldAngle, worldPosition, body);
	
	                    if (result.shouldStop(this)) {
	                        break;
	                    }
	                }
	            };
	
	            /**
	             * @method intersectShape
	             * @private
	             * @param {Shape} shape
	             * @param {number} angle
	             * @param {array} position
	             * @param {Body} body
	             */
	            Ray.prototype.intersectShape = function (result, shape, angle, position, body) {
	                var from = this.from;
	
	                // Checking radius
	                var distance = distanceFromIntersectionSquared(from, this.direction, position);
	                if (distance > shape.boundingRadius * shape.boundingRadius) {
	                    return;
	                }
	
	                this._currentBody = body;
	                this._currentShape = shape;
	
	                shape.raycast(result, this, position, angle);
	
	                this._currentBody = this._currentShape = null;
	            };
	
	            /**
	             * Get the AABB of the ray.
	             * @method getAABB
	             * @param  {AABB} aabb
	             */
	            Ray.prototype.getAABB = function (result) {
	                var to = this.to;
	                var from = this.from;
	                vec2.set(result.lowerBound, Math.min(to[0], from[0]), Math.min(to[1], from[1]));
	                vec2.set(result.upperBound, Math.max(to[0], from[0]), Math.max(to[1], from[1]));
	            };
	
	            var hitPointWorld = vec2.create();
	
	            /**
	             * @method reportIntersection
	             * @private
	             * @param  {number} fraction
	             * @param  {array} normal
	             * @param  {number} [faceIndex=-1]
	             * @return {boolean} True if the intersections should continue
	             */
	            Ray.prototype.reportIntersection = function (result, fraction, normal, faceIndex) {
	                var from = this.from;
	                var to = this.to;
	                var shape = this._currentShape;
	                var body = this._currentBody;
	
	                // Skip back faces?
	                if (this.skipBackfaces && vec2.dot(normal, this.direction) > 0) {
	                    return;
	                }
	
	                switch (this.mode) {
	
	                    case Ray.ALL:
	                        result.set(normal, shape, body, fraction, faceIndex);
	                        this.callback(result);
	                        break;
	
	                    case Ray.CLOSEST:
	
	                        // Store if closer than current closest
	                        if (fraction < result.fraction || !result.hasHit()) {
	                            result.set(normal, shape, body, fraction, faceIndex);
	                        }
	                        break;
	
	                    case Ray.ANY:
	
	                        // Report and stop.
	                        result.set(normal, shape, body, fraction, faceIndex);
	                        break;
	                }
	            };
	
	            var v0 = vec2.create(),
	                intersect = vec2.create();
	            function distanceFromIntersectionSquared(from, direction, position) {
	
	                // v0 is vector from from to position
	                vec2.sub(v0, position, from);
	                var dot = vec2.dot(v0, direction);
	
	                // intersect = direction * dot + from
	                vec2.scale(intersect, direction, dot);
	                vec2.add(intersect, intersect, from);
	
	                return vec2.squaredDistance(position, intersect);
	            }
	        }, { "../collision/AABB": 7, "../collision/RaycastResult": 12, "../math/vec2": 30, "../shapes/Shape": 45 }], 12: [function (_dereq_, module, exports) {
	            var vec2 = _dereq_('../math/vec2');
	            var Ray = _dereq_('../collision/Ray');
	
	            module.exports = RaycastResult;
	
	            /**
	             * Storage for Ray casting hit data.
	             * @class RaycastResult
	             * @constructor
	             */
	            function RaycastResult() {
	
	                /**
	                 * The normal of the hit, oriented in world space.
	                 * @property {array} normal
	                 */
	                this.normal = vec2.create();
	
	                /**
	                 * The hit shape, or null.
	                 * @property {Shape} shape
	                 */
	                this.shape = null;
	
	                /**
	                 * The hit body, or null.
	                 * @property {Body} body
	                 */
	                this.body = null;
	
	                /**
	                 * The index of the hit triangle, if the hit shape was indexable.
	                 * @property {number} faceIndex
	                 * @default -1
	                 */
	                this.faceIndex = -1;
	
	                /**
	                 * Distance to the hit, as a fraction. 0 is at the "from" point, 1 is at the "to" point. Will be set to -1 if there was no hit yet.
	                 * @property {number} fraction
	                 * @default -1
	                 */
	                this.fraction = -1;
	
	                /**
	                 * If the ray should stop traversing.
	                 * @readonly
	                 * @property {Boolean} isStopped
	                 */
	                this.isStopped = false;
	            }
	
	            /**
	             * Reset all result data. Must be done before re-using the result object.
	             * @method reset
	             */
	            RaycastResult.prototype.reset = function () {
	                vec2.set(this.normal, 0, 0);
	                this.shape = null;
	                this.body = null;
	                this.faceIndex = -1;
	                this.fraction = -1;
	                this.isStopped = false;
	            };
	
	            /**
	             * Get the distance to the hit point.
	             * @method getHitDistance
	             * @param {Ray} ray
	             */
	            RaycastResult.prototype.getHitDistance = function (ray) {
	                return vec2.distance(ray.from, ray.to) * this.fraction;
	            };
	
	            /**
	             * Returns true if the ray hit something since the last reset().
	             * @method hasHit
	             */
	            RaycastResult.prototype.hasHit = function () {
	                return this.fraction !== -1;
	            };
	
	            /**
	             * Get world hit point.
	             * @method getHitPoint
	             * @param {array} out
	             * @param {Ray} ray
	             */
	            RaycastResult.prototype.getHitPoint = function (out, ray) {
	                vec2.lerp(out, ray.from, ray.to, this.fraction);
	            };
	
	            /**
	             * Can be called while iterating over hits to stop searching for hit points.
	             * @method stop
	             */
	            RaycastResult.prototype.stop = function () {
	                this.isStopped = true;
	            };
	
	            /**
	             * @method shouldStop
	             * @private
	             * @param {Ray} ray
	             * @return {boolean}
	             */
	            RaycastResult.prototype.shouldStop = function (ray) {
	                return this.isStopped || this.fraction !== -1 && ray.mode === Ray.ANY;
	            };
	
	            /**
	             * @method set
	             * @private
	             * @param {array} normal
	             * @param {Shape} shape
	             * @param {Body} body
	             * @param {number} fraction
	             */
	            RaycastResult.prototype.set = function (normal, shape, body, fraction, faceIndex) {
	                vec2.copy(this.normal, normal);
	                this.shape = shape;
	                this.body = body;
	                this.fraction = fraction;
	                this.faceIndex = faceIndex;
	            };
	        }, { "../collision/Ray": 11, "../math/vec2": 30 }], 13: [function (_dereq_, module, exports) {
	            var Utils = _dereq_('../utils/Utils'),
	                Broadphase = _dereq_('../collision/Broadphase');
	
	            module.exports = SAPBroadphase;
	
	            /**
	             * Sweep and prune broadphase along one axis.
	             *
	             * @class SAPBroadphase
	             * @constructor
	             * @extends Broadphase
	             */
	            function SAPBroadphase() {
	                Broadphase.call(this, Broadphase.SAP);
	
	                /**
	                 * List of bodies currently in the broadphase.
	                 * @property axisList
	                 * @type {Array}
	                 */
	                this.axisList = [];
	
	                /**
	                 * The axis to sort along. 0 means x-axis and 1 y-axis. If your bodies are more spread out over the X axis, set axisIndex to 0, and you will gain some performance.
	                 * @property axisIndex
	                 * @type {Number}
	                 */
	                this.axisIndex = 0;
	
	                var that = this;
	                this._addBodyHandler = function (e) {
	                    that.axisList.push(e.body);
	                };
	
	                this._removeBodyHandler = function (e) {
	                    // Remove from list
	                    var idx = that.axisList.indexOf(e.body);
	                    if (idx !== -1) {
	                        that.axisList.splice(idx, 1);
	                    }
	                };
	            }
	            SAPBroadphase.prototype = new Broadphase();
	            SAPBroadphase.prototype.constructor = SAPBroadphase;
	
	            /**
	             * Change the world
	             * @method setWorld
	             * @param {World} world
	             */
	            SAPBroadphase.prototype.setWorld = function (world) {
	                // Clear the old axis array
	                this.axisList.length = 0;
	
	                // Add all bodies from the new world
	                Utils.appendArray(this.axisList, world.bodies);
	
	                // Remove old handlers, if any
	                world.off("addBody", this._addBodyHandler).off("removeBody", this._removeBodyHandler);
	
	                // Add handlers to update the list of bodies.
	                world.on("addBody", this._addBodyHandler).on("removeBody", this._removeBodyHandler);
	
	                this.world = world;
	            };
	
	            /**
	             * Sorts bodies along an axis.
	             * @method sortAxisList
	             * @param {Array} a
	             * @param {number} axisIndex
	             * @return {Array}
	             */
	            SAPBroadphase.sortAxisList = function (a, axisIndex) {
	                axisIndex = axisIndex | 0;
	                for (var i = 1, l = a.length; i < l; i++) {
	                    var v = a[i];
	                    for (var j = i - 1; j >= 0; j--) {
	                        if (a[j].aabb.lowerBound[axisIndex] <= v.aabb.lowerBound[axisIndex]) {
	                            break;
	                        }
	                        a[j + 1] = a[j];
	                    }
	                    a[j + 1] = v;
	                }
	                return a;
	            };
	
	            SAPBroadphase.prototype.sortList = function () {
	                var bodies = this.axisList,
	                    axisIndex = this.axisIndex;
	
	                // Sort the lists
	                SAPBroadphase.sortAxisList(bodies, axisIndex);
	            };
	
	            /**
	             * Get the colliding pairs
	             * @method getCollisionPairs
	             * @param  {World} world
	             * @return {Array}
	             */
	            SAPBroadphase.prototype.getCollisionPairs = function (world) {
	                var bodies = this.axisList,
	                    result = this.result,
	                    axisIndex = this.axisIndex;
	
	                result.length = 0;
	
	                // Update all AABBs if needed
	                var l = bodies.length;
	                while (l--) {
	                    var b = bodies[l];
	                    if (b.aabbNeedsUpdate) {
	                        b.updateAABB();
	                    }
	                }
	
	                // Sort the lists
	                this.sortList();
	
	                // Look through the X list
	                for (var i = 0, N = bodies.length | 0; i !== N; i++) {
	                    var bi = bodies[i];
	
	                    for (var j = i + 1; j < N; j++) {
	                        var bj = bodies[j];
	
	                        // Bounds overlap?
	                        var overlaps = bj.aabb.lowerBound[axisIndex] <= bi.aabb.upperBound[axisIndex];
	                        if (!overlaps) {
	                            break;
	                        }
	
	                        if (Broadphase.canCollide(bi, bj) && this.boundingVolumeCheck(bi, bj)) {
	                            result.push(bi, bj);
	                        }
	                    }
	                }
	
	                return result;
	            };
	
	            /**
	             * Returns all the bodies within an AABB.
	             * @method aabbQuery
	             * @param  {World} world
	             * @param  {AABB} aabb
	             * @param {array} result An array to store resulting bodies in.
	             * @return {array}
	             */
	            SAPBroadphase.prototype.aabbQuery = function (world, aabb, result) {
	                result = result || [];
	
	                this.sortList();
	
	                var axisIndex = this.axisIndex;
	                var axis = 'x';
	                if (axisIndex === 1) {
	                    axis = 'y';
	                }
	                if (axisIndex === 2) {
	                    axis = 'z';
	                }
	
	                var axisList = this.axisList;
	                var lower = aabb.lowerBound[axis];
	                var upper = aabb.upperBound[axis];
	                for (var i = 0; i < axisList.length; i++) {
	                    var b = axisList[i];
	
	                    if (b.aabbNeedsUpdate) {
	                        b.updateAABB();
	                    }
	
	                    if (b.aabb.overlaps(aabb)) {
	                        result.push(b);
	                    }
	                }
	
	                return result;
	            };
	        }, { "../collision/Broadphase": 8, "../utils/Utils": 57 }], 14: [function (_dereq_, module, exports) {
	            module.exports = Constraint;
	
	            var Utils = _dereq_('../utils/Utils');
	
	            /**
	             * Base constraint class.
	             *
	             * @class Constraint
	             * @constructor
	             * @author schteppe
	             * @param {Body} bodyA
	             * @param {Body} bodyB
	             * @param {Number} type
	             * @param {Object} [options]
	             * @param {Object} [options.collideConnected=true]
	             */
	            function Constraint(bodyA, bodyB, type, options) {
	
	                /**
	                 * The type of constraint. May be one of Constraint.DISTANCE, Constraint.GEAR, Constraint.LOCK, Constraint.PRISMATIC or Constraint.REVOLUTE.
	                 * @property {number} type
	                 */
	                this.type = type;
	
	                options = Utils.defaults(options, {
	                    collideConnected: true,
	                    wakeUpBodies: true
	                });
	
	                /**
	                 * Equations to be solved in this constraint
	                 *
	                 * @property equations
	                 * @type {Array}
	                 */
	                this.equations = [];
	
	                /**
	                 * First body participating in the constraint.
	                 * @property bodyA
	                 * @type {Body}
	                 */
	                this.bodyA = bodyA;
	
	                /**
	                 * Second body participating in the constraint.
	                 * @property bodyB
	                 * @type {Body}
	                 */
	                this.bodyB = bodyB;
	
	                /**
	                 * Set to true if you want the connected bodies to collide.
	                 * @property collideConnected
	                 * @type {Boolean}
	                 * @default true
	                 */
	                this.collideConnected = options.collideConnected;
	
	                // Wake up bodies when connected
	                if (options.wakeUpBodies) {
	                    if (bodyA) {
	                        bodyA.wakeUp();
	                    }
	                    if (bodyB) {
	                        bodyB.wakeUp();
	                    }
	                }
	            }
	
	            /**
	             * Updates the internal constraint parameters before solve.
	             * @method update
	             */
	            Constraint.prototype.update = function () {
	                throw new Error("method update() not implmemented in this Constraint subclass!");
	            };
	
	            /**
	             * @static
	             * @property {number} DISTANCE
	             */
	            Constraint.DISTANCE = 1;
	
	            /**
	             * @static
	             * @property {number} GEAR
	             */
	            Constraint.GEAR = 2;
	
	            /**
	             * @static
	             * @property {number} LOCK
	             */
	            Constraint.LOCK = 3;
	
	            /**
	             * @static
	             * @property {number} PRISMATIC
	             */
	            Constraint.PRISMATIC = 4;
	
	            /**
	             * @static
	             * @property {number} REVOLUTE
	             */
	            Constraint.REVOLUTE = 5;
	
	            /**
	             * Set stiffness for this constraint.
	             * @method setStiffness
	             * @param {Number} stiffness
	             */
	            Constraint.prototype.setStiffness = function (stiffness) {
	                var eqs = this.equations;
	                for (var i = 0; i !== eqs.length; i++) {
	                    var eq = eqs[i];
	                    eq.stiffness = stiffness;
	                    eq.needsUpdate = true;
	                }
	            };
	
	            /**
	             * Set relaxation for this constraint.
	             * @method setRelaxation
	             * @param {Number} relaxation
	             */
	            Constraint.prototype.setRelaxation = function (relaxation) {
	                var eqs = this.equations;
	                for (var i = 0; i !== eqs.length; i++) {
	                    var eq = eqs[i];
	                    eq.relaxation = relaxation;
	                    eq.needsUpdate = true;
	                }
	            };
	        }, { "../utils/Utils": 57 }], 15: [function (_dereq_, module, exports) {
	            var Constraint = _dereq_('./Constraint'),
	                Equation = _dereq_('../equations/Equation'),
	                vec2 = _dereq_('../math/vec2'),
	                Utils = _dereq_('../utils/Utils');
	
	            module.exports = DistanceConstraint;
	
	            /**
	             * Constraint that tries to keep the distance between two bodies constant.
	             *
	             * @class DistanceConstraint
	             * @constructor
	             * @author schteppe
	             * @param {Body} bodyA
	             * @param {Body} bodyB
	             * @param {object} [options]
	             * @param {number} [options.distance] The distance to keep between the anchor points. Defaults to the current distance between the bodies.
	             * @param {Array} [options.localAnchorA] The anchor point for bodyA, defined locally in bodyA frame. Defaults to [0,0].
	             * @param {Array} [options.localAnchorB] The anchor point for bodyB, defined locally in bodyB frame. Defaults to [0,0].
	             * @param {object} [options.maxForce=Number.MAX_VALUE] Maximum force to apply.
	             * @extends Constraint
	             *
	             * @example
	             *     // If distance is not given as an option, then the current distance between the bodies is used.
	             *     // In this example, the bodies will be constrained to have a distance of 2 between their centers.
	             *     var bodyA = new Body({ mass: 1, position: [-1, 0] });
	             *     var bodyB = new Body({ mass: 1, position: [1, 0] });
	             *     var constraint = new DistanceConstraint(bodyA, bodyB);
	             *     world.addConstraint(constraint);
	             *
	             * @example
	             *     // Manually set the distance and anchors
	             *     var constraint = new DistanceConstraint(bodyA, bodyB, {
	             *         distance: 1,          // Distance to keep between the points
	             *         localAnchorA: [1, 0], // Point on bodyA
	             *         localAnchorB: [-1, 0] // Point on bodyB
	             *     });
	             *     world.addConstraint(constraint);
	             */
	            function DistanceConstraint(bodyA, bodyB, options) {
	                options = Utils.defaults(options, {
	                    localAnchorA: [0, 0],
	                    localAnchorB: [0, 0]
	                });
	
	                Constraint.call(this, bodyA, bodyB, Constraint.DISTANCE, options);
	
	                /**
	                 * Local anchor in body A.
	                 * @property localAnchorA
	                 * @type {Array}
	                 */
	                this.localAnchorA = vec2.fromValues(options.localAnchorA[0], options.localAnchorA[1]);
	
	                /**
	                 * Local anchor in body B.
	                 * @property localAnchorB
	                 * @type {Array}
	                 */
	                this.localAnchorB = vec2.fromValues(options.localAnchorB[0], options.localAnchorB[1]);
	
	                var localAnchorA = this.localAnchorA;
	                var localAnchorB = this.localAnchorB;
	
	                /**
	                 * The distance to keep.
	                 * @property distance
	                 * @type {Number}
	                 */
	                this.distance = 0;
	
	                if (typeof options.distance === 'number') {
	                    this.distance = options.distance;
	                } else {
	                    // Use the current world distance between the world anchor points.
	                    var worldAnchorA = vec2.create(),
	                        worldAnchorB = vec2.create(),
	                        r = vec2.create();
	
	                    // Transform local anchors to world
	                    vec2.rotate(worldAnchorA, localAnchorA, bodyA.angle);
	                    vec2.rotate(worldAnchorB, localAnchorB, bodyB.angle);
	
	                    vec2.add(r, bodyB.position, worldAnchorB);
	                    vec2.sub(r, r, worldAnchorA);
	                    vec2.sub(r, r, bodyA.position);
	
	                    this.distance = vec2.length(r);
	                }
	
	                var maxForce;
	                if (typeof options.maxForce === "undefined") {
	                    maxForce = Number.MAX_VALUE;
	                } else {
	                    maxForce = options.maxForce;
	                }
	
	                var normal = new Equation(bodyA, bodyB, -maxForce, maxForce); // Just in the normal direction
	                this.equations = [normal];
	
	                /**
	                 * Max force to apply.
	                 * @property {number} maxForce
	                 */
	                this.maxForce = maxForce;
	
	                // g = (xi - xj).dot(n)
	                // dg/dt = (vi - vj).dot(n) = G*W = [n 0 -n 0] * [vi wi vj wj]'
	
	                // ...and if we were to include offset points:
	                // g =
	                //      (xj + rj - xi - ri).dot(n) - distance
	                //
	                // dg/dt =
	                //      (vj + wj x rj - vi - wi x ri).dot(n) =
	                //      { term 2 is near zero } =
	                //      [-n   -ri x n   n   rj x n] * [vi wi vj wj]' =
	                //      G * W
	                //
	                // => G = [-n -rixn n rjxn]
	
	                var r = vec2.create();
	                var ri = vec2.create(); // worldAnchorA
	                var rj = vec2.create(); // worldAnchorB
	                var that = this;
	                normal.computeGq = function () {
	                    var bodyA = this.bodyA,
	                        bodyB = this.bodyB,
	                        xi = bodyA.position,
	                        xj = bodyB.position;
	
	                    // Transform local anchors to world
	                    vec2.rotate(ri, localAnchorA, bodyA.angle);
	                    vec2.rotate(rj, localAnchorB, bodyB.angle);
	
	                    vec2.add(r, xj, rj);
	                    vec2.sub(r, r, ri);
	                    vec2.sub(r, r, xi);
	
	                    //vec2.sub(r, bodyB.position, bodyA.position);
	                    return vec2.length(r) - that.distance;
	                };
	
	                // Make the contact constraint bilateral
	                this.setMaxForce(maxForce);
	
	                /**
	                 * If the upper limit is enabled or not.
	                 * @property {Boolean} upperLimitEnabled
	                 */
	                this.upperLimitEnabled = false;
	
	                /**
	                 * The upper constraint limit.
	                 * @property {number} upperLimit
	                 */
	                this.upperLimit = 1;
	
	                /**
	                 * If the lower limit is enabled or not.
	                 * @property {Boolean} lowerLimitEnabled
	                 */
	                this.lowerLimitEnabled = false;
	
	                /**
	                 * The lower constraint limit.
	                 * @property {number} lowerLimit
	                 */
	                this.lowerLimit = 0;
	
	                /**
	                 * Current constraint position. This is equal to the current distance between the world anchor points.
	                 * @property {number} position
	                 */
	                this.position = 0;
	            }
	            DistanceConstraint.prototype = new Constraint();
	            DistanceConstraint.prototype.constructor = DistanceConstraint;
	
	            /**
	             * Update the constraint equations. Should be done if any of the bodies changed position, before solving.
	             * @method update
	             */
	            var n = vec2.create();
	            var ri = vec2.create(); // worldAnchorA
	            var rj = vec2.create(); // worldAnchorB
	            DistanceConstraint.prototype.update = function () {
	                var normal = this.equations[0],
	                    bodyA = this.bodyA,
	                    bodyB = this.bodyB,
	                    distance = this.distance,
	                    xi = bodyA.position,
	                    xj = bodyB.position,
	                    normalEquation = this.equations[0],
	                    G = normal.G;
	
	                // Transform local anchors to world
	                vec2.rotate(ri, this.localAnchorA, bodyA.angle);
	                vec2.rotate(rj, this.localAnchorB, bodyB.angle);
	
	                // Get world anchor points and normal
	                vec2.add(n, xj, rj);
	                vec2.sub(n, n, ri);
	                vec2.sub(n, n, xi);
	                this.position = vec2.length(n);
	
	                var violating = false;
	                if (this.upperLimitEnabled) {
	                    if (this.position > this.upperLimit) {
	                        normalEquation.maxForce = 0;
	                        normalEquation.minForce = -this.maxForce;
	                        this.distance = this.upperLimit;
	                        violating = true;
	                    }
	                }
	
	                if (this.lowerLimitEnabled) {
	                    if (this.position < this.lowerLimit) {
	                        normalEquation.maxForce = this.maxForce;
	                        normalEquation.minForce = 0;
	                        this.distance = this.lowerLimit;
	                        violating = true;
	                    }
	                }
	
	                if ((this.lowerLimitEnabled || this.upperLimitEnabled) && !violating) {
	                    // No constraint needed.
	                    normalEquation.enabled = false;
	                    return;
	                }
	
	                normalEquation.enabled = true;
	
	                vec2.normalize(n, n);
	
	                // Caluclate cross products
	                var rixn = vec2.crossLength(ri, n),
	                    rjxn = vec2.crossLength(rj, n);
	
	                // G = [-n -rixn n rjxn]
	                G[0] = -n[0];
	                G[1] = -n[1];
	                G[2] = -rixn;
	                G[3] = n[0];
	                G[4] = n[1];
	                G[5] = rjxn;
	            };
	
	            /**
	             * Set the max force to be used
	             * @method setMaxForce
	             * @param {Number} maxForce
	             */
	            DistanceConstraint.prototype.setMaxForce = function (maxForce) {
	                var normal = this.equations[0];
	                normal.minForce = -maxForce;
	                normal.maxForce = maxForce;
	            };
	
	            /**
	             * Get the max force
	             * @method getMaxForce
	             * @return {Number}
	             */
	            DistanceConstraint.prototype.getMaxForce = function () {
	                var normal = this.equations[0];
	                return normal.maxForce;
	            };
	        }, { "../equations/Equation": 22, "../math/vec2": 30, "../utils/Utils": 57, "./Constraint": 14 }], 16: [function (_dereq_, module, exports) {
	            var Constraint = _dereq_('./Constraint'),
	                Equation = _dereq_('../equations/Equation'),
	                AngleLockEquation = _dereq_('../equations/AngleLockEquation'),
	                vec2 = _dereq_('../math/vec2');
	
	            module.exports = GearConstraint;
	
	            /**
	             * Constrains the angle of two bodies to each other to be equal. If a gear ratio is not one, the angle of bodyA must be a multiple of the angle of bodyB.
	             * @class GearConstraint
	             * @constructor
	             * @author schteppe
	             * @param {Body}            bodyA
	             * @param {Body}            bodyB
	             * @param {Object}          [options]
	             * @param {Number}          [options.angle=0] Relative angle between the bodies. Will be set to the current angle between the bodies (the gear ratio is accounted for).
	             * @param {Number}          [options.ratio=1] Gear ratio.
	             * @param {Number}          [options.maxTorque] Maximum torque to apply.
	             * @extends Constraint
	             *
	             * @example
	             *     var constraint = new GearConstraint(bodyA, bodyB);
	             *     world.addConstraint(constraint);
	             *
	             * @example
	             *     var constraint = new GearConstraint(bodyA, bodyB, {
	             *         ratio: 2,
	             *         maxTorque: 1000
	             *     });
	             *     world.addConstraint(constraint);
	             */
	            function GearConstraint(bodyA, bodyB, options) {
	                options = options || {};
	
	                Constraint.call(this, bodyA, bodyB, Constraint.GEAR, options);
	
	                /**
	                 * The gear ratio.
	                 * @property ratio
	                 * @type {Number}
	                 */
	                this.ratio = options.ratio !== undefined ? options.ratio : 1;
	
	                /**
	                 * The relative angle
	                 * @property angle
	                 * @type {Number}
	                 */
	                this.angle = options.angle !== undefined ? options.angle : bodyB.angle - this.ratio * bodyA.angle;
	
	                // Send same parameters to the equation
	                options.angle = this.angle;
	                options.ratio = this.ratio;
	
	                this.equations = [new AngleLockEquation(bodyA, bodyB, options)];
	
	                // Set max torque
	                if (options.maxTorque !== undefined) {
	                    this.setMaxTorque(options.maxTorque);
	                }
	            }
	            GearConstraint.prototype = new Constraint();
	            GearConstraint.prototype.constructor = GearConstraint;
	
	            GearConstraint.prototype.update = function () {
	                var eq = this.equations[0];
	                if (eq.ratio !== this.ratio) {
	                    eq.setRatio(this.ratio);
	                }
	                eq.angle = this.angle;
	            };
	
	            /**
	             * Set the max torque for the constraint.
	             * @method setMaxTorque
	             * @param {Number} torque
	             */
	            GearConstraint.prototype.setMaxTorque = function (torque) {
	                this.equations[0].setMaxTorque(torque);
	            };
	
	            /**
	             * Get the max torque for the constraint.
	             * @method getMaxTorque
	             * @return {Number}
	             */
	            GearConstraint.prototype.getMaxTorque = function (torque) {
	                return this.equations[0].maxForce;
	            };
	        }, { "../equations/AngleLockEquation": 20, "../equations/Equation": 22, "../math/vec2": 30, "./Constraint": 14 }], 17: [function (_dereq_, module, exports) {
	            var Constraint = _dereq_('./Constraint'),
	                vec2 = _dereq_('../math/vec2'),
	                Equation = _dereq_('../equations/Equation');
	
	            module.exports = LockConstraint;
	
	            /**
	             * Locks the relative position and rotation between two bodies.
	             *
	             * @class LockConstraint
	             * @constructor
	             * @author schteppe
	             * @param {Body} bodyA
	             * @param {Body} bodyB
	             * @param {Object} [options]
	             * @param {Array}  [options.localOffsetB] The offset of bodyB in bodyA's frame. If not given the offset is computed from current positions.
	             * @param {number} [options.localAngleB] The angle of bodyB in bodyA's frame. If not given, the angle is computed from current angles.
	             * @param {number} [options.maxForce]
	             * @extends Constraint
	             *
	             * @example
	             *     // Locks the relative position and rotation between bodyA and bodyB
	             *     var constraint = new LockConstraint(bodyA, bodyB);
	             *     world.addConstraint(constraint);
	             */
	            function LockConstraint(bodyA, bodyB, options) {
	                options = options || {};
	
	                Constraint.call(this, bodyA, bodyB, Constraint.LOCK, options);
	
	                var maxForce = typeof options.maxForce === "undefined" ? Number.MAX_VALUE : options.maxForce;
	
	                var localAngleB = options.localAngleB || 0;
	
	                // Use 3 equations:
	                // gx =   (xj - xi - l) * xhat = 0
	                // gy =   (xj - xi - l) * yhat = 0
	                // gr =   (xi - xj + r) * that = 0
	                //
	                // ...where:
	                //   l is the localOffsetB vector rotated to world in bodyA frame
	                //   r is the same vector but reversed and rotated from bodyB frame
	                //   xhat, yhat are world axis vectors
	                //   that is the tangent of r
	                //
	                // For the first two constraints, we get
	                // G*W = (vj - vi - ldot  ) * xhat
	                //     = (vj - vi - wi x l) * xhat
	                //
	                // Since (wi x l) * xhat = (l x xhat) * wi, we get
	                // G*W = [ -1   0   (-l x xhat)  1   0   0] * [vi wi vj wj]
	                //
	                // The last constraint gives
	                // GW = (vi - vj + wj x r) * that
	                //    = [  that   0  -that  (r x t) ]
	
	                var x = new Equation(bodyA, bodyB, -maxForce, maxForce),
	                    y = new Equation(bodyA, bodyB, -maxForce, maxForce),
	                    rot = new Equation(bodyA, bodyB, -maxForce, maxForce);
	
	                var l = vec2.create(),
	                    g = vec2.create(),
	                    that = this;
	                x.computeGq = function () {
	                    vec2.rotate(l, that.localOffsetB, bodyA.angle);
	                    vec2.sub(g, bodyB.position, bodyA.position);
	                    vec2.sub(g, g, l);
	                    return g[0];
	                };
	                y.computeGq = function () {
	                    vec2.rotate(l, that.localOffsetB, bodyA.angle);
	                    vec2.sub(g, bodyB.position, bodyA.position);
	                    vec2.sub(g, g, l);
	                    return g[1];
	                };
	                var r = vec2.create(),
	                    t = vec2.create();
	                rot.computeGq = function () {
	                    vec2.rotate(r, that.localOffsetB, bodyB.angle - that.localAngleB);
	                    vec2.scale(r, r, -1);
	                    vec2.sub(g, bodyA.position, bodyB.position);
	                    vec2.add(g, g, r);
	                    vec2.rotate(t, r, -Math.PI / 2);
	                    vec2.normalize(t, t);
	                    return vec2.dot(g, t);
	                };
	
	                /**
	                 * The offset of bodyB in bodyA's frame.
	                 * @property {Array} localOffsetB
	                 */
	                this.localOffsetB = vec2.create();
	                if (options.localOffsetB) {
	                    vec2.copy(this.localOffsetB, options.localOffsetB);
	                } else {
	                    // Construct from current positions
	                    vec2.sub(this.localOffsetB, bodyB.position, bodyA.position);
	                    vec2.rotate(this.localOffsetB, this.localOffsetB, -bodyA.angle);
	                }
	
	                /**
	                 * The offset angle of bodyB in bodyA's frame.
	                 * @property {Number} localAngleB
	                 */
	                this.localAngleB = 0;
	                if (typeof options.localAngleB === 'number') {
	                    this.localAngleB = options.localAngleB;
	                } else {
	                    // Construct
	                    this.localAngleB = bodyB.angle - bodyA.angle;
	                }
	
	                this.equations.push(x, y, rot);
	                this.setMaxForce(maxForce);
	            }
	            LockConstraint.prototype = new Constraint();
	            LockConstraint.prototype.constructor = LockConstraint;
	
	            /**
	             * Set the maximum force to be applied.
	             * @method setMaxForce
	             * @param {Number} force
	             */
	            LockConstraint.prototype.setMaxForce = function (force) {
	                var eqs = this.equations;
	                for (var i = 0; i < this.equations.length; i++) {
	                    eqs[i].maxForce = force;
	                    eqs[i].minForce = -force;
	                }
	            };
	
	            /**
	             * Get the max force.
	             * @method getMaxForce
	             * @return {Number}
	             */
	            LockConstraint.prototype.getMaxForce = function () {
	                return this.equations[0].maxForce;
	            };
	
	            var l = vec2.create();
	            var r = vec2.create();
	            var t = vec2.create();
	            var xAxis = vec2.fromValues(1, 0);
	            var yAxis = vec2.fromValues(0, 1);
	            LockConstraint.prototype.update = function () {
	                var x = this.equations[0],
	                    y = this.equations[1],
	                    rot = this.equations[2],
	                    bodyA = this.bodyA,
	                    bodyB = this.bodyB;
	
	                vec2.rotate(l, this.localOffsetB, bodyA.angle);
	                vec2.rotate(r, this.localOffsetB, bodyB.angle - this.localAngleB);
	                vec2.scale(r, r, -1);
	
	                vec2.rotate(t, r, Math.PI / 2);
	                vec2.normalize(t, t);
	
	                x.G[0] = -1;
	                x.G[1] = 0;
	                x.G[2] = -vec2.crossLength(l, xAxis);
	                x.G[3] = 1;
	
	                y.G[0] = 0;
	                y.G[1] = -1;
	                y.G[2] = -vec2.crossLength(l, yAxis);
	                y.G[4] = 1;
	
	                rot.G[0] = -t[0];
	                rot.G[1] = -t[1];
	                rot.G[3] = t[0];
	                rot.G[4] = t[1];
	                rot.G[5] = vec2.crossLength(r, t);
	            };
	        }, { "../equations/Equation": 22, "../math/vec2": 30, "./Constraint": 14 }], 18: [function (_dereq_, module, exports) {
	            var Constraint = _dereq_('./Constraint'),
	                ContactEquation = _dereq_('../equations/ContactEquation'),
	                Equation = _dereq_('../equations/Equation'),
	                vec2 = _dereq_('../math/vec2'),
	                RotationalLockEquation = _dereq_('../equations/RotationalLockEquation');
	
	            module.exports = PrismaticConstraint;
	
	            /**
	             * Constraint that only allows bodies to move along a line, relative to each other. See <a href="http://www.iforce2d.net/b2dtut/joints-prismatic">this tutorial</a>. Also called "slider constraint".
	             *
	             * @class PrismaticConstraint
	             * @constructor
	             * @extends Constraint
	             * @author schteppe
	             * @param {Body}    bodyA
	             * @param {Body}    bodyB
	             * @param {Object}  [options]
	             * @param {Number}  [options.maxForce]                Max force to be applied by the constraint
	             * @param {Array}   [options.localAnchorA]            Body A's anchor point, defined in its own local frame.
	             * @param {Array}   [options.localAnchorB]            Body B's anchor point, defined in its own local frame.
	             * @param {Array}   [options.localAxisA]              An axis, defined in body A frame, that body B's anchor point may slide along.
	             * @param {Boolean} [options.disableRotationalLock]   If set to true, bodyB will be free to rotate around its anchor point.
	             * @param {Number}  [options.upperLimit]
	             * @param {Number}  [options.lowerLimit]
	             * @todo Ability to create using only a point and a worldAxis
	             */
	            function PrismaticConstraint(bodyA, bodyB, options) {
	                options = options || {};
	                Constraint.call(this, bodyA, bodyB, Constraint.PRISMATIC, options);
	
	                // Get anchors
	                var localAnchorA = vec2.fromValues(0, 0),
	                    localAxisA = vec2.fromValues(1, 0),
	                    localAnchorB = vec2.fromValues(0, 0);
	                if (options.localAnchorA) {
	                    vec2.copy(localAnchorA, options.localAnchorA);
	                }
	                if (options.localAxisA) {
	                    vec2.copy(localAxisA, options.localAxisA);
	                }
	                if (options.localAnchorB) {
	                    vec2.copy(localAnchorB, options.localAnchorB);
	                }
	
	                /**
	                 * @property localAnchorA
	                 * @type {Array}
	                 */
	                this.localAnchorA = localAnchorA;
	
	                /**
	                 * @property localAnchorB
	                 * @type {Array}
	                 */
	                this.localAnchorB = localAnchorB;
	
	                /**
	                 * @property localAxisA
	                 * @type {Array}
	                 */
	                this.localAxisA = localAxisA;
	
	                /*
	                 The constraint violation for the common axis point is
	                     g = ( xj + rj - xi - ri ) * t   :=  gg*t
	                 where r are body-local anchor points, and t is a tangent to the constraint axis defined in body i frame.
	                     gdot =  ( vj + wj x rj - vi - wi x ri ) * t + ( xj + rj - xi - ri ) * ( wi x t )
	                 Note the use of the chain rule. Now we identify the jacobian
	                     G*W = [ -t      -ri x t + t x gg     t    rj x t ] * [vi wi vj wj]
	                 The rotational part is just a rotation lock.
	                  */
	
	                var maxForce = this.maxForce = typeof options.maxForce !== "undefined" ? options.maxForce : Number.MAX_VALUE;
	
	                // Translational part
	                var trans = new Equation(bodyA, bodyB, -maxForce, maxForce);
	                var ri = new vec2.create(),
	                    rj = new vec2.create(),
	                    gg = new vec2.create(),
	                    t = new vec2.create();
	                trans.computeGq = function () {
	                    // g = ( xj + rj - xi - ri ) * t
	                    return vec2.dot(gg, t);
	                };
	                trans.updateJacobian = function () {
	                    var G = this.G,
	                        xi = bodyA.position,
	                        xj = bodyB.position;
	                    vec2.rotate(ri, localAnchorA, bodyA.angle);
	                    vec2.rotate(rj, localAnchorB, bodyB.angle);
	                    vec2.add(gg, xj, rj);
	                    vec2.sub(gg, gg, xi);
	                    vec2.sub(gg, gg, ri);
	                    vec2.rotate(t, localAxisA, bodyA.angle + Math.PI / 2);
	
	                    G[0] = -t[0];
	                    G[1] = -t[1];
	                    G[2] = -vec2.crossLength(ri, t) + vec2.crossLength(t, gg);
	                    G[3] = t[0];
	                    G[4] = t[1];
	                    G[5] = vec2.crossLength(rj, t);
	                };
	                this.equations.push(trans);
	
	                // Rotational part
	                if (!options.disableRotationalLock) {
	                    var rot = new RotationalLockEquation(bodyA, bodyB, -maxForce, maxForce);
	                    this.equations.push(rot);
	                }
	
	                /**
	                 * The position of anchor A relative to anchor B, along the constraint axis.
	                 * @property position
	                 * @type {Number}
	                 */
	                this.position = 0;
	
	                // Is this one used at all?
	                this.velocity = 0;
	
	                /**
	                 * Set to true to enable lower limit.
	                 * @property lowerLimitEnabled
	                 * @type {Boolean}
	                 */
	                this.lowerLimitEnabled = typeof options.lowerLimit !== "undefined" ? true : false;
	
	                /**
	                 * Set to true to enable upper limit.
	                 * @property upperLimitEnabled
	                 * @type {Boolean}
	                 */
	                this.upperLimitEnabled = typeof options.upperLimit !== "undefined" ? true : false;
	
	                /**
	                 * Lower constraint limit. The constraint position is forced to be larger than this value.
	                 * @property lowerLimit
	                 * @type {Number}
	                 */
	                this.lowerLimit = typeof options.lowerLimit !== "undefined" ? options.lowerLimit : 0;
	
	                /**
	                 * Upper constraint limit. The constraint position is forced to be smaller than this value.
	                 * @property upperLimit
	                 * @type {Number}
	                 */
	                this.upperLimit = typeof options.upperLimit !== "undefined" ? options.upperLimit : 1;
	
	                // Equations used for limits
	                this.upperLimitEquation = new ContactEquation(bodyA, bodyB);
	                this.lowerLimitEquation = new ContactEquation(bodyA, bodyB);
	
	                // Set max/min forces
	                this.upperLimitEquation.minForce = this.lowerLimitEquation.minForce = 0;
	                this.upperLimitEquation.maxForce = this.lowerLimitEquation.maxForce = maxForce;
	
	                /**
	                 * Equation used for the motor.
	                 * @property motorEquation
	                 * @type {Equation}
	                 */
	                this.motorEquation = new Equation(bodyA, bodyB);
	
	                /**
	                 * The current motor state. Enable or disable the motor using .enableMotor
	                 * @property motorEnabled
	                 * @type {Boolean}
	                 */
	                this.motorEnabled = false;
	
	                /**
	                 * Set the target speed for the motor.
	                 * @property motorSpeed
	                 * @type {Number}
	                 */
	                this.motorSpeed = 0;
	
	                var that = this;
	                var motorEquation = this.motorEquation;
	                var old = motorEquation.computeGW;
	                motorEquation.computeGq = function () {
	                    return 0;
	                };
	                motorEquation.computeGW = function () {
	                    var G = this.G,
	                        bi = this.bodyA,
	                        bj = this.bodyB,
	                        vi = bi.velocity,
	                        vj = bj.velocity,
	                        wi = bi.angularVelocity,
	                        wj = bj.angularVelocity;
	                    return this.gmult(G, vi, wi, vj, wj) + that.motorSpeed;
	                };
	            }
	
	            PrismaticConstraint.prototype = new Constraint();
	            PrismaticConstraint.prototype.constructor = PrismaticConstraint;
	
	            var worldAxisA = vec2.create(),
	                worldAnchorA = vec2.create(),
	                worldAnchorB = vec2.create(),
	                orientedAnchorA = vec2.create(),
	                orientedAnchorB = vec2.create(),
	                tmp = vec2.create();
	
	            /**
	             * Update the constraint equations. Should be done if any of the bodies changed position, before solving.
	             * @method update
	             */
	            PrismaticConstraint.prototype.update = function () {
	                var eqs = this.equations,
	                    trans = eqs[0],
	                    upperLimit = this.upperLimit,
	                    lowerLimit = this.lowerLimit,
	                    upperLimitEquation = this.upperLimitEquation,
	                    lowerLimitEquation = this.lowerLimitEquation,
	                    bodyA = this.bodyA,
	                    bodyB = this.bodyB,
	                    localAxisA = this.localAxisA,
	                    localAnchorA = this.localAnchorA,
	                    localAnchorB = this.localAnchorB;
	
	                trans.updateJacobian();
	
	                // Transform local things to world
	                vec2.rotate(worldAxisA, localAxisA, bodyA.angle);
	                vec2.rotate(orientedAnchorA, localAnchorA, bodyA.angle);
	                vec2.add(worldAnchorA, orientedAnchorA, bodyA.position);
	                vec2.rotate(orientedAnchorB, localAnchorB, bodyB.angle);
	                vec2.add(worldAnchorB, orientedAnchorB, bodyB.position);
	
	                var relPosition = this.position = vec2.dot(worldAnchorB, worldAxisA) - vec2.dot(worldAnchorA, worldAxisA);
	
	                // Motor
	                if (this.motorEnabled) {
	                    // G = [ a     a x ri   -a   -a x rj ]
	                    var G = this.motorEquation.G;
	                    G[0] = worldAxisA[0];
	                    G[1] = worldAxisA[1];
	                    G[2] = vec2.crossLength(worldAxisA, orientedAnchorB);
	                    G[3] = -worldAxisA[0];
	                    G[4] = -worldAxisA[1];
	                    G[5] = -vec2.crossLength(worldAxisA, orientedAnchorA);
	                }
	
	                /*
	                    Limits strategy:
	                    Add contact equation, with normal along the constraint axis.
	                    min/maxForce is set so the constraint is repulsive in the correct direction.
	                    Some offset is added to either equation.contactPointA or .contactPointB to get the correct upper/lower limit.
	                              ^
	                             |
	                  upperLimit x
	                             |    ------
	                     anchorB x<---|  B |
	                             |    |    |
	                    ------   |    ------
	                    |    |   |
	                    |  A |-->x anchorA
	                    ------   |
	                             x lowerLimit
	                             |
	                            axis
	                 */
	
	                if (this.upperLimitEnabled && relPosition > upperLimit) {
	                    // Update contact constraint normal, etc
	                    vec2.scale(upperLimitEquation.normalA, worldAxisA, -1);
	                    vec2.sub(upperLimitEquation.contactPointA, worldAnchorA, bodyA.position);
	                    vec2.sub(upperLimitEquation.contactPointB, worldAnchorB, bodyB.position);
	                    vec2.scale(tmp, worldAxisA, upperLimit);
	                    vec2.add(upperLimitEquation.contactPointA, upperLimitEquation.contactPointA, tmp);
	                    if (eqs.indexOf(upperLimitEquation) === -1) {
	                        eqs.push(upperLimitEquation);
	                    }
	                } else {
	                    var idx = eqs.indexOf(upperLimitEquation);
	                    if (idx !== -1) {
	                        eqs.splice(idx, 1);
	                    }
	                }
	
	                if (this.lowerLimitEnabled && relPosition < lowerLimit) {
	                    // Update contact constraint normal, etc
	                    vec2.scale(lowerLimitEquation.normalA, worldAxisA, 1);
	                    vec2.sub(lowerLimitEquation.contactPointA, worldAnchorA, bodyA.position);
	                    vec2.sub(lowerLimitEquation.contactPointB, worldAnchorB, bodyB.position);
	                    vec2.scale(tmp, worldAxisA, lowerLimit);
	                    vec2.sub(lowerLimitEquation.contactPointB, lowerLimitEquation.contactPointB, tmp);
	                    if (eqs.indexOf(lowerLimitEquation) === -1) {
	                        eqs.push(lowerLimitEquation);
	                    }
	                } else {
	                    var idx = eqs.indexOf(lowerLimitEquation);
	                    if (idx !== -1) {
	                        eqs.splice(idx, 1);
	                    }
	                }
	            };
	
	            /**
	             * Enable the motor
	             * @method enableMotor
	             */
	            PrismaticConstraint.prototype.enableMotor = function () {
	                if (this.motorEnabled) {
	                    return;
	                }
	                this.equations.push(this.motorEquation);
	                this.motorEnabled = true;
	            };
	
	            /**
	             * Disable the rotational motor
	             * @method disableMotor
	             */
	            PrismaticConstraint.prototype.disableMotor = function () {
	                if (!this.motorEnabled) {
	                    return;
	                }
	                var i = this.equations.indexOf(this.motorEquation);
	                this.equations.splice(i, 1);
	                this.motorEnabled = false;
	            };
	
	            /**
	             * Set the constraint limits.
	             * @method setLimits
	             * @param {number} lower Lower limit.
	             * @param {number} upper Upper limit.
	             */
	            PrismaticConstraint.prototype.setLimits = function (lower, upper) {
	                if (typeof lower === 'number') {
	                    this.lowerLimit = lower;
	                    this.lowerLimitEnabled = true;
	                } else {
	                    this.lowerLimit = lower;
	                    this.lowerLimitEnabled = false;
	                }
	
	                if (typeof upper === 'number') {
	                    this.upperLimit = upper;
	                    this.upperLimitEnabled = true;
	                } else {
	                    this.upperLimit = upper;
	                    this.upperLimitEnabled = false;
	                }
	            };
	        }, { "../equations/ContactEquation": 21, "../equations/Equation": 22, "../equations/RotationalLockEquation": 24, "../math/vec2": 30, "./Constraint": 14 }], 19: [function (_dereq_, module, exports) {
	            var Constraint = _dereq_('./Constraint'),
	                Equation = _dereq_('../equations/Equation'),
	                RotationalVelocityEquation = _dereq_('../equations/RotationalVelocityEquation'),
	                RotationalLockEquation = _dereq_('../equations/RotationalLockEquation'),
	                vec2 = _dereq_('../math/vec2');
	
	            module.exports = RevoluteConstraint;
	
	            var worldPivotA = vec2.create(),
	                worldPivotB = vec2.create(),
	                xAxis = vec2.fromValues(1, 0),
	                yAxis = vec2.fromValues(0, 1),
	                g = vec2.create();
	
	            /**
	             * Connects two bodies at given offset points, letting them rotate relative to each other around this point.
	             * @class RevoluteConstraint
	             * @constructor
	             * @author schteppe
	             * @param {Body}    bodyA
	             * @param {Body}    bodyB
	             * @param {Object}  [options]
	             * @param {Array}   [options.worldPivot] A pivot point given in world coordinates. If specified, localPivotA and localPivotB are automatically computed from this value.
	             * @param {Array}   [options.localPivotA] The point relative to the center of mass of bodyA which bodyA is constrained to.
	             * @param {Array}   [options.localPivotB] See localPivotA.
	             * @param {Number}  [options.maxForce] The maximum force that should be applied to constrain the bodies.
	             * @extends Constraint
	             *
	             * @example
	             *     // This will create a revolute constraint between two bodies with pivot point in between them.
	             *     var bodyA = new Body({ mass: 1, position: [-1, 0] });
	             *     var bodyB = new Body({ mass: 1, position: [1, 0] });
	             *     var constraint = new RevoluteConstraint(bodyA, bodyB, {
	             *         worldPivot: [0, 0]
	             *     });
	             *     world.addConstraint(constraint);
	             *
	             *     // Using body-local pivot points, the constraint could have been constructed like this:
	             *     var constraint = new RevoluteConstraint(bodyA, bodyB, {
	             *         localPivotA: [1, 0],
	             *         localPivotB: [-1, 0]
	             *     });
	             */
	            function RevoluteConstraint(bodyA, bodyB, options) {
	                options = options || {};
	                Constraint.call(this, bodyA, bodyB, Constraint.REVOLUTE, options);
	
	                var maxForce = this.maxForce = typeof options.maxForce !== "undefined" ? options.maxForce : Number.MAX_VALUE;
	
	                /**
	                 * @property {Array} pivotA
	                 */
	                this.pivotA = vec2.create();
	
	                /**
	                 * @property {Array} pivotB
	                 */
	                this.pivotB = vec2.create();
	
	                if (options.worldPivot) {
	                    // Compute pivotA and pivotB
	                    vec2.sub(this.pivotA, options.worldPivot, bodyA.position);
	                    vec2.sub(this.pivotB, options.worldPivot, bodyB.position);
	                    // Rotate to local coordinate system
	                    vec2.rotate(this.pivotA, this.pivotA, -bodyA.angle);
	                    vec2.rotate(this.pivotB, this.pivotB, -bodyB.angle);
	                } else {
	                    // Get pivotA and pivotB
	                    vec2.copy(this.pivotA, options.localPivotA);
	                    vec2.copy(this.pivotB, options.localPivotB);
	                }
	
	                // Equations to be fed to the solver
	                var eqs = this.equations = [new Equation(bodyA, bodyB, -maxForce, maxForce), new Equation(bodyA, bodyB, -maxForce, maxForce)];
	
	                var x = eqs[0];
	                var y = eqs[1];
	                var that = this;
	
	                x.computeGq = function () {
	                    vec2.rotate(worldPivotA, that.pivotA, bodyA.angle);
	                    vec2.rotate(worldPivotB, that.pivotB, bodyB.angle);
	                    vec2.add(g, bodyB.position, worldPivotB);
	                    vec2.sub(g, g, bodyA.position);
	                    vec2.sub(g, g, worldPivotA);
	                    return vec2.dot(g, xAxis);
	                };
	
	                y.computeGq = function () {
	                    vec2.rotate(worldPivotA, that.pivotA, bodyA.angle);
	                    vec2.rotate(worldPivotB, that.pivotB, bodyB.angle);
	                    vec2.add(g, bodyB.position, worldPivotB);
	                    vec2.sub(g, g, bodyA.position);
	                    vec2.sub(g, g, worldPivotA);
	                    return vec2.dot(g, yAxis);
	                };
	
	                y.minForce = x.minForce = -maxForce;
	                y.maxForce = x.maxForce = maxForce;
	
	                this.motorEquation = new RotationalVelocityEquation(bodyA, bodyB);
	
	                /**
	                 * Indicates whether the motor is enabled. Use .enableMotor() to enable the constraint motor.
	                 * @property {Boolean} motorEnabled
	                 * @readOnly
	                 */
	                this.motorEnabled = false;
	
	                /**
	                 * The constraint position.
	                 * @property angle
	                 * @type {Number}
	                 * @readOnly
	                 */
	                this.angle = 0;
	
	                /**
	                 * Set to true to enable lower limit
	                 * @property lowerLimitEnabled
	                 * @type {Boolean}
	                 */
	                this.lowerLimitEnabled = false;
	
	                /**
	                 * Set to true to enable upper limit
	                 * @property upperLimitEnabled
	                 * @type {Boolean}
	                 */
	                this.upperLimitEnabled = false;
	
	                /**
	                 * The lower limit on the constraint angle.
	                 * @property lowerLimit
	                 * @type {Boolean}
	                 */
	                this.lowerLimit = 0;
	
	                /**
	                 * The upper limit on the constraint angle.
	                 * @property upperLimit
	                 * @type {Boolean}
	                 */
	                this.upperLimit = 0;
	
	                this.upperLimitEquation = new RotationalLockEquation(bodyA, bodyB);
	                this.lowerLimitEquation = new RotationalLockEquation(bodyA, bodyB);
	                this.upperLimitEquation.minForce = 0;
	                this.lowerLimitEquation.maxForce = 0;
	            }
	            RevoluteConstraint.prototype = new Constraint();
	            RevoluteConstraint.prototype.constructor = RevoluteConstraint;
	
	            /**
	             * Set the constraint angle limits.
	             * @method setLimits
	             * @param {number} lower Lower angle limit.
	             * @param {number} upper Upper angle limit.
	             */
	            RevoluteConstraint.prototype.setLimits = function (lower, upper) {
	                if (typeof lower === 'number') {
	                    this.lowerLimit = lower;
	                    this.lowerLimitEnabled = true;
	                } else {
	                    this.lowerLimit = lower;
	                    this.lowerLimitEnabled = false;
	                }
	
	                if (typeof upper === 'number') {
	                    this.upperLimit = upper;
	                    this.upperLimitEnabled = true;
	                } else {
	                    this.upperLimit = upper;
	                    this.upperLimitEnabled = false;
	                }
	            };
	
	            RevoluteConstraint.prototype.update = function () {
	                var bodyA = this.bodyA,
	                    bodyB = this.bodyB,
	                    pivotA = this.pivotA,
	                    pivotB = this.pivotB,
	                    eqs = this.equations,
	                    normal = eqs[0],
	                    tangent = eqs[1],
	                    x = eqs[0],
	                    y = eqs[1],
	                    upperLimit = this.upperLimit,
	                    lowerLimit = this.lowerLimit,
	                    upperLimitEquation = this.upperLimitEquation,
	                    lowerLimitEquation = this.lowerLimitEquation;
	
	                var relAngle = this.angle = bodyB.angle - bodyA.angle;
	
	                if (this.upperLimitEnabled && relAngle > upperLimit) {
	                    upperLimitEquation.angle = upperLimit;
	                    if (eqs.indexOf(upperLimitEquation) === -1) {
	                        eqs.push(upperLimitEquation);
	                    }
	                } else {
	                    var idx = eqs.indexOf(upperLimitEquation);
	                    if (idx !== -1) {
	                        eqs.splice(idx, 1);
	                    }
	                }
	
	                if (this.lowerLimitEnabled && relAngle < lowerLimit) {
	                    lowerLimitEquation.angle = lowerLimit;
	                    if (eqs.indexOf(lowerLimitEquation) === -1) {
	                        eqs.push(lowerLimitEquation);
	                    }
	                } else {
	                    var idx = eqs.indexOf(lowerLimitEquation);
	                    if (idx !== -1) {
	                        eqs.splice(idx, 1);
	                    }
	                }
	
	                /*
	                 The constraint violation is
	                     g = xj + rj - xi - ri
	                 ...where xi and xj are the body positions and ri and rj world-oriented offset vectors. Differentiate:
	                     gdot = vj + wj x rj - vi - wi x ri
	                 We split this into x and y directions. (let x and y be unit vectors along the respective axes)
	                     gdot * x = ( vj + wj x rj - vi - wi x ri ) * x
	                             = ( vj*x + (wj x rj)*x -vi*x -(wi x ri)*x
	                             = ( vj*x + (rj x x)*wj -vi*x -(ri x x)*wi
	                             = [ -x   -(ri x x)   x   (rj x x)] * [vi wi vj wj]
	                             = G*W
	                 ...and similar for y. We have then identified the jacobian entries for x and y directions:
	                     Gx = [ x   (rj x x)   -x   -(ri x x)]
	                    Gy = [ y   (rj x y)   -y   -(ri x y)]
	                  */
	
	                vec2.rotate(worldPivotA, pivotA, bodyA.angle);
	                vec2.rotate(worldPivotB, pivotB, bodyB.angle);
	
	                // todo: these are a bit sparse. We could save some computations on making custom eq.computeGW functions, etc
	
	                x.G[0] = -1;
	                x.G[1] = 0;
	                x.G[2] = -vec2.crossLength(worldPivotA, xAxis);
	                x.G[3] = 1;
	                x.G[4] = 0;
	                x.G[5] = vec2.crossLength(worldPivotB, xAxis);
	
	                y.G[0] = 0;
	                y.G[1] = -1;
	                y.G[2] = -vec2.crossLength(worldPivotA, yAxis);
	                y.G[3] = 0;
	                y.G[4] = 1;
	                y.G[5] = vec2.crossLength(worldPivotB, yAxis);
	            };
	
	            /**
	             * Enable the rotational motor
	             * @method enableMotor
	             */
	            RevoluteConstraint.prototype.enableMotor = function () {
	                if (this.motorEnabled) {
	                    return;
	                }
	                this.equations.push(this.motorEquation);
	                this.motorEnabled = true;
	            };
	
	            /**
	             * Disable the rotational motor
	             * @method disableMotor
	             */
	            RevoluteConstraint.prototype.disableMotor = function () {
	                if (!this.motorEnabled) {
	                    return;
	                }
	                var i = this.equations.indexOf(this.motorEquation);
	                this.equations.splice(i, 1);
	                this.motorEnabled = false;
	            };
	
	            /**
	             * Check if the motor is enabled.
	             * @method motorIsEnabled
	             * @deprecated use property motorEnabled instead.
	             * @return {Boolean}
	             */
	            RevoluteConstraint.prototype.motorIsEnabled = function () {
	                return !!this.motorEnabled;
	            };
	
	            /**
	             * Set the speed of the rotational constraint motor
	             * @method setMotorSpeed
	             * @param  {Number} speed
	             */
	            RevoluteConstraint.prototype.setMotorSpeed = function (speed) {
	                if (!this.motorEnabled) {
	                    return;
	                }
	                var i = this.equations.indexOf(this.motorEquation);
	                this.equations[i].relativeVelocity = speed;
	            };
	
	            /**
	             * Get the speed of the rotational constraint motor
	             * @method getMotorSpeed
	             * @return {Number} The current speed, or false if the motor is not enabled.
	             */
	            RevoluteConstraint.prototype.getMotorSpeed = function () {
	                if (!this.motorEnabled) {
	                    return false;
	                }
	                return this.motorEquation.relativeVelocity;
	            };
	        }, { "../equations/Equation": 22, "../equations/RotationalLockEquation": 24, "../equations/RotationalVelocityEquation": 25, "../math/vec2": 30, "./Constraint": 14 }], 20: [function (_dereq_, module, exports) {
	            var Equation = _dereq_("./Equation"),
	                vec2 = _dereq_('../math/vec2');
	
	            module.exports = AngleLockEquation;
	
	            /**
	             * Locks the relative angle between two bodies. The constraint tries to keep the dot product between two vectors, local in each body, to zero. The local angle in body i is a parameter.
	             *
	             * @class AngleLockEquation
	             * @constructor
	             * @extends Equation
	             * @param {Body} bodyA
	             * @param {Body} bodyB
	             * @param {Object} [options]
	             * @param {Number} [options.angle] Angle to add to the local vector in body A.
	             * @param {Number} [options.ratio] Gear ratio
	             */
	            function AngleLockEquation(bodyA, bodyB, options) {
	                options = options || {};
	                Equation.call(this, bodyA, bodyB, -Number.MAX_VALUE, Number.MAX_VALUE);
	                this.angle = options.angle || 0;
	
	                /**
	                 * The gear ratio.
	                 * @property {Number} ratio
	                 * @private
	                 * @see setRatio
	                 */
	                this.ratio = typeof options.ratio === "number" ? options.ratio : 1;
	
	                this.setRatio(this.ratio);
	            }
	            AngleLockEquation.prototype = new Equation();
	            AngleLockEquation.prototype.constructor = AngleLockEquation;
	
	            AngleLockEquation.prototype.computeGq = function () {
	                return this.ratio * this.bodyA.angle - this.bodyB.angle + this.angle;
	            };
	
	            /**
	             * Set the gear ratio for this equation
	             * @method setRatio
	             * @param {Number} ratio
	             */
	            AngleLockEquation.prototype.setRatio = function (ratio) {
	                var G = this.G;
	                G[2] = ratio;
	                G[5] = -1;
	                this.ratio = ratio;
	            };
	
	            /**
	             * Set the max force for the equation.
	             * @method setMaxTorque
	             * @param {Number} torque
	             */
	            AngleLockEquation.prototype.setMaxTorque = function (torque) {
	                this.maxForce = torque;
	                this.minForce = -torque;
	            };
	        }, { "../math/vec2": 30, "./Equation": 22 }], 21: [function (_dereq_, module, exports) {
	            var Equation = _dereq_("./Equation"),
	                vec2 = _dereq_('../math/vec2');
	
	            module.exports = ContactEquation;
	
	            /**
	             * Non-penetration constraint equation. Tries to make the contactPointA and contactPointB vectors coincide, while keeping the applied force repulsive.
	             *
	             * @class ContactEquation
	             * @constructor
	             * @extends Equation
	             * @param {Body} bodyA
	             * @param {Body} bodyB
	             */
	            function ContactEquation(bodyA, bodyB) {
	                Equation.call(this, bodyA, bodyB, 0, Number.MAX_VALUE);
	
	                /**
	                 * Vector from body i center of mass to the contact point.
	                 * @property contactPointA
	                 * @type {Array}
	                 */
	                this.contactPointA = vec2.create();
	                this.penetrationVec = vec2.create();
	
	                /**
	                 * World-oriented vector from body A center of mass to the contact point.
	                 * @property contactPointB
	                 * @type {Array}
	                 */
	                this.contactPointB = vec2.create();
	
	                /**
	                 * The normal vector, pointing out of body i
	                 * @property normalA
	                 * @type {Array}
	                 */
	                this.normalA = vec2.create();
	
	                /**
	                 * The restitution to use (0=no bounciness, 1=max bounciness).
	                 * @property restitution
	                 * @type {Number}
	                 */
	                this.restitution = 0;
	
	                /**
	                 * This property is set to true if this is the first impact between the bodies (not persistant contact).
	                 * @property firstImpact
	                 * @type {Boolean}
	                 * @readOnly
	                 */
	                this.firstImpact = false;
	
	                /**
	                 * The shape in body i that triggered this contact.
	                 * @property shapeA
	                 * @type {Shape}
	                 */
	                this.shapeA = null;
	
	                /**
	                 * The shape in body j that triggered this contact.
	                 * @property shapeB
	                 * @type {Shape}
	                 */
	                this.shapeB = null;
	            }
	            ContactEquation.prototype = new Equation();
	            ContactEquation.prototype.constructor = ContactEquation;
	            ContactEquation.prototype.computeB = function (a, b, h) {
	                var bi = this.bodyA,
	                    bj = this.bodyB,
	                    ri = this.contactPointA,
	                    rj = this.contactPointB,
	                    xi = bi.position,
	                    xj = bj.position;
	
	                var penetrationVec = this.penetrationVec,
	                    n = this.normalA,
	                    G = this.G;
	
	                // Caluclate cross products
	                var rixn = vec2.crossLength(ri, n),
	                    rjxn = vec2.crossLength(rj, n);
	
	                // G = [-n -rixn n rjxn]
	                G[0] = -n[0];
	                G[1] = -n[1];
	                G[2] = -rixn;
	                G[3] = n[0];
	                G[4] = n[1];
	                G[5] = rjxn;
	
	                // Calculate q = xj+rj -(xi+ri) i.e. the penetration vector
	                vec2.add(penetrationVec, xj, rj);
	                vec2.sub(penetrationVec, penetrationVec, xi);
	                vec2.sub(penetrationVec, penetrationVec, ri);
	
	                // Compute iteration
	                var GW, Gq;
	                if (this.firstImpact && this.restitution !== 0) {
	                    Gq = 0;
	                    GW = 1 / b * (1 + this.restitution) * this.computeGW();
	                } else {
	                    Gq = vec2.dot(n, penetrationVec) + this.offset;
	                    GW = this.computeGW();
	                }
	
	                var GiMf = this.computeGiMf();
	                var B = -Gq * a - GW * b - h * GiMf;
	
	                return B;
	            };
	        }, { "../math/vec2": 30, "./Equation": 22 }], 22: [function (_dereq_, module, exports) {
	            module.exports = Equation;
	
	            var vec2 = _dereq_('../math/vec2'),
	                Utils = _dereq_('../utils/Utils'),
	                Body = _dereq_('../objects/Body');
	
	            /**
	             * Base class for constraint equations.
	             * @class Equation
	             * @constructor
	             * @param {Body} bodyA First body participating in the equation
	             * @param {Body} bodyB Second body participating in the equation
	             * @param {number} minForce Minimum force to apply. Default: -Number.MAX_VALUE
	             * @param {number} maxForce Maximum force to apply. Default: Number.MAX_VALUE
	             */
	            function Equation(bodyA, bodyB, minForce, maxForce) {
	
	                /**
	                 * Minimum force to apply when solving.
	                 * @property minForce
	                 * @type {Number}
	                 */
	                this.minForce = typeof minForce === "undefined" ? -Number.MAX_VALUE : minForce;
	
	                /**
	                 * Max force to apply when solving.
	                 * @property maxForce
	                 * @type {Number}
	                 */
	                this.maxForce = typeof maxForce === "undefined" ? Number.MAX_VALUE : maxForce;
	
	                /**
	                 * First body participating in the constraint
	                 * @property bodyA
	                 * @type {Body}
	                 */
	                this.bodyA = bodyA;
	
	                /**
	                 * Second body participating in the constraint
	                 * @property bodyB
	                 * @type {Body}
	                 */
	                this.bodyB = bodyB;
	
	                /**
	                 * The stiffness of this equation. Typically chosen to a large number (~1e7), but can be chosen somewhat freely to get a stable simulation.
	                 * @property stiffness
	                 * @type {Number}
	                 */
	                this.stiffness = Equation.DEFAULT_STIFFNESS;
	
	                /**
	                 * The number of time steps needed to stabilize the constraint equation. Typically between 3 and 5 time steps.
	                 * @property relaxation
	                 * @type {Number}
	                 */
	                this.relaxation = Equation.DEFAULT_RELAXATION;
	
	                /**
	                 * The Jacobian entry of this equation. 6 numbers, 3 per body (x,y,angle).
	                 * @property G
	                 * @type {Array}
	                 */
	                this.G = new Utils.ARRAY_TYPE(6);
	                for (var i = 0; i < 6; i++) {
	                    this.G[i] = 0;
	                }
	
	                this.offset = 0;
	
	                this.a = 0;
	                this.b = 0;
	                this.epsilon = 0;
	                this.timeStep = 1 / 60;
	
	                /**
	                 * Indicates if stiffness or relaxation was changed.
	                 * @property {Boolean} needsUpdate
	                 */
	                this.needsUpdate = true;
	
	                /**
	                 * The resulting constraint multiplier from the last solve. This is mostly equivalent to the force produced by the constraint.
	                 * @property multiplier
	                 * @type {Number}
	                 */
	                this.multiplier = 0;
	
	                /**
	                 * Relative velocity.
	                 * @property {Number} relativeVelocity
	                 */
	                this.relativeVelocity = 0;
	
	                /**
	                 * Whether this equation is enabled or not. If true, it will be added to the solver.
	                 * @property {Boolean} enabled
	                 */
	                this.enabled = true;
	            }
	            Equation.prototype.constructor = Equation;
	
	            /**
	             * The default stiffness when creating a new Equation.
	             * @static
	             * @property {Number} DEFAULT_STIFFNESS
	             * @default 1e6
	             */
	            Equation.DEFAULT_STIFFNESS = 1e6;
	
	            /**
	             * The default relaxation when creating a new Equation.
	             * @static
	             * @property {Number} DEFAULT_RELAXATION
	             * @default 4
	             */
	            Equation.DEFAULT_RELAXATION = 4;
	
	            /**
	             * Compute SPOOK parameters .a, .b and .epsilon according to the current parameters. See equations 9, 10 and 11 in the <a href="http://www8.cs.umu.se/kurser/5DV058/VT09/lectures/spooknotes.pdf">SPOOK notes</a>.
	             * @method update
	             */
	            Equation.prototype.update = function () {
	                var k = this.stiffness,
	                    d = this.relaxation,
	                    h = this.timeStep;
	
	                this.a = 4.0 / (h * (1 + 4 * d));
	                this.b = 4.0 * d / (1 + 4 * d);
	                this.epsilon = 4.0 / (h * h * k * (1 + 4 * d));
	
	                this.needsUpdate = false;
	            };
	
	            /**
	             * Multiply a jacobian entry with corresponding positions or velocities
	             * @method gmult
	             * @return {Number}
	             */
	            Equation.prototype.gmult = function (G, vi, wi, vj, wj) {
	                return G[0] * vi[0] + G[1] * vi[1] + G[2] * wi + G[3] * vj[0] + G[4] * vj[1] + G[5] * wj;
	            };
	
	            /**
	             * Computes the RHS of the SPOOK equation
	             * @method computeB
	             * @return {Number}
	             */
	            Equation.prototype.computeB = function (a, b, h) {
	                var GW = this.computeGW();
	                var Gq = this.computeGq();
	                var GiMf = this.computeGiMf();
	                return -Gq * a - GW * b - GiMf * h;
	            };
	
	            /**
	             * Computes G\*q, where q are the generalized body coordinates
	             * @method computeGq
	             * @return {Number}
	             */
	            var qi = vec2.create(),
	                qj = vec2.create();
	            Equation.prototype.computeGq = function () {
	                var G = this.G,
	                    bi = this.bodyA,
	                    bj = this.bodyB,
	                    xi = bi.position,
	                    xj = bj.position,
	                    ai = bi.angle,
	                    aj = bj.angle;
	
	                return this.gmult(G, qi, ai, qj, aj) + this.offset;
	            };
	
	            /**
	             * Computes G\*W, where W are the body velocities
	             * @method computeGW
	             * @return {Number}
	             */
	            Equation.prototype.computeGW = function () {
	                var G = this.G,
	                    bi = this.bodyA,
	                    bj = this.bodyB,
	                    vi = bi.velocity,
	                    vj = bj.velocity,
	                    wi = bi.angularVelocity,
	                    wj = bj.angularVelocity;
	                return this.gmult(G, vi, wi, vj, wj) + this.relativeVelocity;
	            };
	
	            /**
	             * Computes G\*Wlambda, where W are the body velocities
	             * @method computeGWlambda
	             * @return {Number}
	             */
	            Equation.prototype.computeGWlambda = function () {
	                var G = this.G,
	                    bi = this.bodyA,
	                    bj = this.bodyB,
	                    vi = bi.vlambda,
	                    vj = bj.vlambda,
	                    wi = bi.wlambda,
	                    wj = bj.wlambda;
	                return this.gmult(G, vi, wi, vj, wj);
	            };
	
	            /**
	             * Computes G\*inv(M)\*f, where M is the mass matrix with diagonal blocks for each body, and f are the forces on the bodies.
	             * @method computeGiMf
	             * @return {Number}
	             */
	            var iMfi = vec2.create(),
	                iMfj = vec2.create();
	            Equation.prototype.computeGiMf = function () {
	                var bi = this.bodyA,
	                    bj = this.bodyB,
	                    fi = bi.force,
	                    ti = bi.angularForce,
	                    fj = bj.force,
	                    tj = bj.angularForce,
	                    invMassi = bi.invMassSolve,
	                    invMassj = bj.invMassSolve,
	                    invIi = bi.invInertiaSolve,
	                    invIj = bj.invInertiaSolve,
	                    G = this.G;
	
	                vec2.scale(iMfi, fi, invMassi);
	                vec2.multiply(iMfi, bi.massMultiplier, iMfi);
	                vec2.scale(iMfj, fj, invMassj);
	                vec2.multiply(iMfj, bj.massMultiplier, iMfj);
	
	                return this.gmult(G, iMfi, ti * invIi, iMfj, tj * invIj);
	            };
	
	            /**
	             * Computes G\*inv(M)\*G'
	             * @method computeGiMGt
	             * @return {Number}
	             */
	            Equation.prototype.computeGiMGt = function () {
	                var bi = this.bodyA,
	                    bj = this.bodyB,
	                    invMassi = bi.invMassSolve,
	                    invMassj = bj.invMassSolve,
	                    invIi = bi.invInertiaSolve,
	                    invIj = bj.invInertiaSolve,
	                    G = this.G;
	
	                return G[0] * G[0] * invMassi * bi.massMultiplier[0] + G[1] * G[1] * invMassi * bi.massMultiplier[1] + G[2] * G[2] * invIi + G[3] * G[3] * invMassj * bj.massMultiplier[0] + G[4] * G[4] * invMassj * bj.massMultiplier[1] + G[5] * G[5] * invIj;
	            };
	
	            var addToWlambda_temp = vec2.create(),
	                addToWlambda_Gi = vec2.create(),
	                addToWlambda_Gj = vec2.create(),
	                addToWlambda_ri = vec2.create(),
	                addToWlambda_rj = vec2.create(),
	                addToWlambda_Mdiag = vec2.create();
	
	            /**
	             * Add constraint velocity to the bodies.
	             * @method addToWlambda
	             * @param {Number} deltalambda
	             */
	            Equation.prototype.addToWlambda = function (deltalambda) {
	                var bi = this.bodyA,
	                    bj = this.bodyB,
	                    temp = addToWlambda_temp,
	                    Gi = addToWlambda_Gi,
	                    Gj = addToWlambda_Gj,
	                    ri = addToWlambda_ri,
	                    rj = addToWlambda_rj,
	                    invMassi = bi.invMassSolve,
	                    invMassj = bj.invMassSolve,
	                    invIi = bi.invInertiaSolve,
	                    invIj = bj.invInertiaSolve,
	                    Mdiag = addToWlambda_Mdiag,
	                    G = this.G;
	
	                Gi[0] = G[0];
	                Gi[1] = G[1];
	                Gj[0] = G[3];
	                Gj[1] = G[4];
	
	                // Add to linear velocity
	                // v_lambda += inv(M) * delta_lamba * G
	                vec2.scale(temp, Gi, invMassi * deltalambda);
	                vec2.multiply(temp, temp, bi.massMultiplier);
	                vec2.add(bi.vlambda, bi.vlambda, temp);
	                // This impulse is in the offset frame
	                // Also add contribution to angular
	                //bi.wlambda -= vec2.crossLength(temp,ri);
	                bi.wlambda += invIi * G[2] * deltalambda;
	
	                vec2.scale(temp, Gj, invMassj * deltalambda);
	                vec2.multiply(temp, temp, bj.massMultiplier);
	                vec2.add(bj.vlambda, bj.vlambda, temp);
	                //bj.wlambda -= vec2.crossLength(temp,rj);
	                bj.wlambda += invIj * G[5] * deltalambda;
	            };
	
	            /**
	             * Compute the denominator part of the SPOOK equation: C = G\*inv(M)\*G' + eps
	             * @method computeInvC
	             * @param  {Number} eps
	             * @return {Number}
	             */
	            Equation.prototype.computeInvC = function (eps) {
	                return 1.0 / (this.computeGiMGt() + eps);
	            };
	        }, { "../math/vec2": 30, "../objects/Body": 31, "../utils/Utils": 57 }], 23: [function (_dereq_, module, exports) {
	            var vec2 = _dereq_('../math/vec2'),
	                Equation = _dereq_('./Equation'),
	                Utils = _dereq_('../utils/Utils');
	
	            module.exports = FrictionEquation;
	
	            /**
	             * Constrains the slipping in a contact along a tangent
	             *
	             * @class FrictionEquation
	             * @constructor
	             * @param {Body} bodyA
	             * @param {Body} bodyB
	             * @param {Number} slipForce
	             * @extends Equation
	             */
	            function FrictionEquation(bodyA, bodyB, slipForce) {
	                Equation.call(this, bodyA, bodyB, -slipForce, slipForce);
	
	                /**
	                 * Relative vector from center of body A to the contact point, world oriented.
	                 * @property contactPointA
	                 * @type {Array}
	                 */
	                this.contactPointA = vec2.create();
	
	                /**
	                 * Relative vector from center of body B to the contact point, world oriented.
	                 * @property contactPointB
	                 * @type {Array}
	                 */
	                this.contactPointB = vec2.create();
	
	                /**
	                 * Tangent vector that the friction force will act along. World oriented.
	                 * @property t
	                 * @type {Array}
	                 */
	                this.t = vec2.create();
	
	                /**
	                 * ContactEquations connected to this friction equation. The contact equations can be used to rescale the max force for the friction. If more than one contact equation is given, then the max force can be set to the average.
	                 * @property contactEquations
	                 * @type {ContactEquation}
	                 */
	                this.contactEquations = [];
	
	                /**
	                 * The shape in body i that triggered this friction.
	                 * @property shapeA
	                 * @type {Shape}
	                 * @todo Needed? The shape can be looked up via contactEquation.shapeA...
	                 */
	                this.shapeA = null;
	
	                /**
	                 * The shape in body j that triggered this friction.
	                 * @property shapeB
	                 * @type {Shape}
	                 * @todo Needed? The shape can be looked up via contactEquation.shapeB...
	                 */
	                this.shapeB = null;
	
	                /**
	                 * The friction coefficient to use.
	                 * @property frictionCoefficient
	                 * @type {Number}
	                 */
	                this.frictionCoefficient = 0.3;
	            }
	            FrictionEquation.prototype = new Equation();
	            FrictionEquation.prototype.constructor = FrictionEquation;
	
	            /**
	             * Set the slipping condition for the constraint. The friction force cannot be
	             * larger than this value.
	             * @method setSlipForce
	             * @param  {Number} slipForce
	             */
	            FrictionEquation.prototype.setSlipForce = function (slipForce) {
	                this.maxForce = slipForce;
	                this.minForce = -slipForce;
	            };
	
	            /**
	             * Get the max force for the constraint.
	             * @method getSlipForce
	             * @return {Number}
	             */
	            FrictionEquation.prototype.getSlipForce = function () {
	                return this.maxForce;
	            };
	
	            FrictionEquation.prototype.computeB = function (a, b, h) {
	                var bi = this.bodyA,
	                    bj = this.bodyB,
	                    ri = this.contactPointA,
	                    rj = this.contactPointB,
	                    t = this.t,
	                    G = this.G;
	
	                // G = [-t -rixt t rjxt]
	                // And remember, this is a pure velocity constraint, g is always zero!
	                G[0] = -t[0];
	                G[1] = -t[1];
	                G[2] = -vec2.crossLength(ri, t);
	                G[3] = t[0];
	                G[4] = t[1];
	                G[5] = vec2.crossLength(rj, t);
	
	                var GW = this.computeGW(),
	                    GiMf = this.computeGiMf();
	
	                var B = /* - g * a  */-GW * b - h * GiMf;
	
	                return B;
	            };
	        }, { "../math/vec2": 30, "../utils/Utils": 57, "./Equation": 22 }], 24: [function (_dereq_, module, exports) {
	            var Equation = _dereq_("./Equation"),
	                vec2 = _dereq_('../math/vec2');
	
	            module.exports = RotationalLockEquation;
	
	            /**
	             * Locks the relative angle between two bodies. The constraint tries to keep the dot product between two vectors, local in each body, to zero. The local angle in body i is a parameter.
	             *
	             * @class RotationalLockEquation
	             * @constructor
	             * @extends Equation
	             * @param {Body} bodyA
	             * @param {Body} bodyB
	             * @param {Object} [options]
	             * @param {Number} [options.angle] Angle to add to the local vector in bodyA.
	             */
	            function RotationalLockEquation(bodyA, bodyB, options) {
	                options = options || {};
	                Equation.call(this, bodyA, bodyB, -Number.MAX_VALUE, Number.MAX_VALUE);
	
	                /**
	                 * @property {number} angle
	                 */
	                this.angle = options.angle || 0;
	
	                var G = this.G;
	                G[2] = 1;
	                G[5] = -1;
	            }
	            RotationalLockEquation.prototype = new Equation();
	            RotationalLockEquation.prototype.constructor = RotationalLockEquation;
	
	            var worldVectorA = vec2.create(),
	                worldVectorB = vec2.create(),
	                xAxis = vec2.fromValues(1, 0),
	                yAxis = vec2.fromValues(0, 1);
	            RotationalLockEquation.prototype.computeGq = function () {
	                vec2.rotate(worldVectorA, xAxis, this.bodyA.angle + this.angle);
	                vec2.rotate(worldVectorB, yAxis, this.bodyB.angle);
	                return vec2.dot(worldVectorA, worldVectorB);
	            };
	        }, { "../math/vec2": 30, "./Equation": 22 }], 25: [function (_dereq_, module, exports) {
	            var Equation = _dereq_("./Equation"),
	                vec2 = _dereq_('../math/vec2');
	
	            module.exports = RotationalVelocityEquation;
	
	            /**
	             * Syncs rotational velocity of two bodies, or sets a relative velocity (motor).
	             *
	             * @class RotationalVelocityEquation
	             * @constructor
	             * @extends Equation
	             * @param {Body} bodyA
	             * @param {Body} bodyB
	             */
	            function RotationalVelocityEquation(bodyA, bodyB) {
	                Equation.call(this, bodyA, bodyB, -Number.MAX_VALUE, Number.MAX_VALUE);
	                this.relativeVelocity = 1;
	                this.ratio = 1;
	            }
	            RotationalVelocityEquation.prototype = new Equation();
	            RotationalVelocityEquation.prototype.constructor = RotationalVelocityEquation;
	            RotationalVelocityEquation.prototype.computeB = function (a, b, h) {
	                var G = this.G;
	                G[2] = -1;
	                G[5] = this.ratio;
	
	                var GiMf = this.computeGiMf();
	                var GW = this.computeGW();
	                var B = -GW * b - h * GiMf;
	
	                return B;
	            };
	        }, { "../math/vec2": 30, "./Equation": 22 }], 26: [function (_dereq_, module, exports) {
	            /**
	             * Base class for objects that dispatches events.
	             * @class EventEmitter
	             * @constructor
	             */
	            var EventEmitter = function EventEmitter() {};
	
	            module.exports = EventEmitter;
	
	            EventEmitter.prototype = {
	                constructor: EventEmitter,
	
	                /**
	                 * Add an event listener
	                 * @method on
	                 * @param  {String} type
	                 * @param  {Function} listener
	                 * @return {EventEmitter} The self object, for chainability.
	                 */
	                on: function on(type, listener, context) {
	                    listener.context = context || this;
	                    if (this._listeners === undefined) {
	                        this._listeners = {};
	                    }
	                    var listeners = this._listeners;
	                    if (listeners[type] === undefined) {
	                        listeners[type] = [];
	                    }
	                    if (listeners[type].indexOf(listener) === -1) {
	                        listeners[type].push(listener);
	                    }
	                    return this;
	                },
	
	                /**
	                 * Check if an event listener is added
	                 * @method has
	                 * @param  {String} type
	                 * @param  {Function} listener
	                 * @return {Boolean}
	                 */
	                has: function has(type, listener) {
	                    if (this._listeners === undefined) {
	                        return false;
	                    }
	                    var listeners = this._listeners;
	                    if (listener) {
	                        if (listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1) {
	                            return true;
	                        }
	                    } else {
	                        if (listeners[type] !== undefined) {
	                            return true;
	                        }
	                    }
	
	                    return false;
	                },
	
	                /**
	                 * Remove an event listener
	                 * @method off
	                 * @param  {String} type
	                 * @param  {Function} listener
	                 * @return {EventEmitter} The self object, for chainability.
	                 */
	                off: function off(type, listener) {
	                    if (this._listeners === undefined) {
	                        return this;
	                    }
	                    var listeners = this._listeners;
	                    var index = listeners[type].indexOf(listener);
	                    if (index !== -1) {
	                        listeners[type].splice(index, 1);
	                    }
	                    return this;
	                },
	
	                /**
	                 * Emit an event.
	                 * @method emit
	                 * @param  {Object} event
	                 * @param  {String} event.type
	                 * @return {EventEmitter} The self object, for chainability.
	                 */
	                emit: function emit(event) {
	                    if (this._listeners === undefined) {
	                        return this;
	                    }
	                    var listeners = this._listeners;
	                    var listenerArray = listeners[event.type];
	                    if (listenerArray !== undefined) {
	                        event.target = this;
	                        for (var i = 0, l = listenerArray.length; i < l; i++) {
	                            var listener = listenerArray[i];
	                            listener.call(listener.context, event);
	                        }
	                    }
	                    return this;
	                }
	            };
	        }, {}], 27: [function (_dereq_, module, exports) {
	            var Material = _dereq_('./Material');
	            var Equation = _dereq_('../equations/Equation');
	
	            module.exports = ContactMaterial;
	
	            /**
	             * Defines what happens when two materials meet, such as what friction coefficient to use. You can also set other things such as restitution, surface velocity and constraint parameters.
	             * @class ContactMaterial
	             * @constructor
	             * @param {Material} materialA
	             * @param {Material} materialB
	             * @param {Object}   [options]
	             * @param {Number}   [options.friction=0.3]       Friction coefficient.
	             * @param {Number}   [options.restitution=0]      Restitution coefficient aka "bounciness".
	             * @param {Number}   [options.stiffness]          ContactEquation stiffness.
	             * @param {Number}   [options.relaxation]         ContactEquation relaxation.
	             * @param {Number}   [options.frictionStiffness]  FrictionEquation stiffness.
	             * @param {Number}   [options.frictionRelaxation] FrictionEquation relaxation.
	             * @param {Number}   [options.surfaceVelocity=0]  Surface velocity.
	             * @author schteppe
	             */
	            function ContactMaterial(materialA, materialB, options) {
	                options = options || {};
	
	                if (!(materialA instanceof Material) || !(materialB instanceof Material)) {
	                    throw new Error("First two arguments must be Material instances.");
	                }
	
	                /**
	                 * The contact material identifier
	                 * @property id
	                 * @type {Number}
	                 */
	                this.id = ContactMaterial.idCounter++;
	
	                /**
	                 * First material participating in the contact material
	                 * @property materialA
	                 * @type {Material}
	                 */
	                this.materialA = materialA;
	
	                /**
	                 * Second material participating in the contact material
	                 * @property materialB
	                 * @type {Material}
	                 */
	                this.materialB = materialB;
	
	                /**
	                 * Friction to use in the contact of these two materials
	                 * @property friction
	                 * @type {Number}
	                 */
	                this.friction = typeof options.friction !== "undefined" ? Number(options.friction) : 0.3;
	
	                /**
	                 * Restitution to use in the contact of these two materials
	                 * @property restitution
	                 * @type {Number}
	                 */
	                this.restitution = typeof options.restitution !== "undefined" ? Number(options.restitution) : 0.0;
	
	                /**
	                 * Stiffness of the resulting ContactEquation that this ContactMaterial generate
	                 * @property stiffness
	                 * @type {Number}
	                 */
	                this.stiffness = typeof options.stiffness !== "undefined" ? Number(options.stiffness) : Equation.DEFAULT_STIFFNESS;
	
	                /**
	                 * Relaxation of the resulting ContactEquation that this ContactMaterial generate
	                 * @property relaxation
	                 * @type {Number}
	                 */
	                this.relaxation = typeof options.relaxation !== "undefined" ? Number(options.relaxation) : Equation.DEFAULT_RELAXATION;
	
	                /**
	                 * Stiffness of the resulting FrictionEquation that this ContactMaterial generate
	                 * @property frictionStiffness
	                 * @type {Number}
	                 */
	                this.frictionStiffness = typeof options.frictionStiffness !== "undefined" ? Number(options.frictionStiffness) : Equation.DEFAULT_STIFFNESS;
	
	                /**
	                 * Relaxation of the resulting FrictionEquation that this ContactMaterial generate
	                 * @property frictionRelaxation
	                 * @type {Number}
	                 */
	                this.frictionRelaxation = typeof options.frictionRelaxation !== "undefined" ? Number(options.frictionRelaxation) : Equation.DEFAULT_RELAXATION;
	
	                /**
	                 * Will add surface velocity to this material. If bodyA rests on top if bodyB, and the surface velocity is positive, bodyA will slide to the right.
	                 * @property {Number} surfaceVelocity
	                 */
	                this.surfaceVelocity = typeof options.surfaceVelocity !== "undefined" ? Number(options.surfaceVelocity) : 0;
	
	                /**
	                 * Offset to be set on ContactEquations. A positive value will make the bodies penetrate more into each other. Can be useful in scenes where contacts need to be more persistent, for example when stacking. Aka "cure for nervous contacts".
	                 * @property contactSkinSize
	                 * @type {Number}
	                 */
	                this.contactSkinSize = 0.005;
	            }
	
	            ContactMaterial.idCounter = 0;
	        }, { "../equations/Equation": 22, "./Material": 28 }], 28: [function (_dereq_, module, exports) {
	            module.exports = Material;
	
	            /**
	             * Defines a physics material.
	             * @class Material
	             * @constructor
	             * @param {number} id Material identifier
	             * @author schteppe
	             */
	            function Material(id) {
	                /**
	                 * The material identifier
	                 * @property id
	                 * @type {Number}
	                 */
	                this.id = id || Material.idCounter++;
	            }
	
	            Material.idCounter = 0;
	        }, {}], 29: [function (_dereq_, module, exports) {
	
	            /*
	                PolyK library
	                url: http://polyk.ivank.net
	                Released under MIT licence.
	                 Copyright (c) 2012 Ivan Kuckir
	                 Permission is hereby granted, free of charge, to any person
	                obtaining a copy of this software and associated documentation
	                files (the "Software"), to deal in the Software without
	                restriction, including without limitation the rights to use,
	                copy, modify, merge, publish, distribute, sublicense, and/or sell
	                copies of the Software, and to permit persons to whom the
	                Software is furnished to do so, subject to the following
	                conditions:
	                 The above copyright notice and this permission notice shall be
	                included in all copies or substantial portions of the Software.
	                 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	                EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
	                OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	                NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
	                HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
	                WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	                FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
	                OTHER DEALINGS IN THE SOFTWARE.
	            */
	
	            var PolyK = {};
	
	            /*
	                Is Polygon self-intersecting?
	                 O(n^2)
	            */
	            /*
	            PolyK.IsSimple = function(p)
	            {
	                var n = p.length>>1;
	                if(n<4) return true;
	                var a1 = new PolyK._P(), a2 = new PolyK._P();
	                var b1 = new PolyK._P(), b2 = new PolyK._P();
	                var c = new PolyK._P();
	                 for(var i=0; i<n; i++)
	                {
	                    a1.x = p[2*i  ];
	                    a1.y = p[2*i+1];
	                    if(i==n-1)  { a2.x = p[0    ];  a2.y = p[1    ]; }
	                    else        { a2.x = p[2*i+2];  a2.y = p[2*i+3]; }
	                     for(var j=0; j<n; j++)
	                    {
	                        if(Math.abs(i-j) < 2) continue;
	                        if(j==n-1 && i==0) continue;
	                        if(i==n-1 && j==0) continue;
	                         b1.x = p[2*j  ];
	                        b1.y = p[2*j+1];
	                        if(j==n-1)  { b2.x = p[0    ];  b2.y = p[1    ]; }
	                        else        { b2.x = p[2*j+2];  b2.y = p[2*j+3]; }
	                         if(PolyK._GetLineIntersection(a1,a2,b1,b2,c) != null) return false;
	                    }
	                }
	                return true;
	            }
	             PolyK.IsConvex = function(p)
	            {
	                if(p.length<6) return true;
	                var l = p.length - 4;
	                for(var i=0; i<l; i+=2)
	                    if(!PolyK._convex(p[i], p[i+1], p[i+2], p[i+3], p[i+4], p[i+5])) return false;
	                if(!PolyK._convex(p[l  ], p[l+1], p[l+2], p[l+3], p[0], p[1])) return false;
	                if(!PolyK._convex(p[l+2], p[l+3], p[0  ], p[1  ], p[2], p[3])) return false;
	                return true;
	            }
	            */
	            PolyK.GetArea = function (p) {
	                if (p.length < 6) return 0;
	                var l = p.length - 2;
	                var sum = 0;
	                for (var i = 0; i < l; i += 2) {
	                    sum += (p[i + 2] - p[i]) * (p[i + 1] + p[i + 3]);
	                }sum += (p[0] - p[l]) * (p[l + 1] + p[1]);
	                return -sum * 0.5;
	            };
	            /*
	            PolyK.GetAABB = function(p)
	            {
	                var minx = Infinity;
	                var miny = Infinity;
	                var maxx = -minx;
	                var maxy = -miny;
	                for(var i=0; i<p.length; i+=2)
	                {
	                    minx = Math.min(minx, p[i  ]);
	                    maxx = Math.max(maxx, p[i  ]);
	                    miny = Math.min(miny, p[i+1]);
	                    maxy = Math.max(maxy, p[i+1]);
	                }
	                return {x:minx, y:miny, width:maxx-minx, height:maxy-miny};
	            }
	            */
	
	            PolyK.Triangulate = function (p) {
	                var n = p.length >> 1;
	                if (n < 3) return [];
	                var tgs = [];
	                var avl = [];
	                for (var i = 0; i < n; i++) {
	                    avl.push(i);
	                }var i = 0;
	                var al = n;
	                while (al > 3) {
	                    var i0 = avl[(i + 0) % al];
	                    var i1 = avl[(i + 1) % al];
	                    var i2 = avl[(i + 2) % al];
	
	                    var ax = p[2 * i0],
	                        ay = p[2 * i0 + 1];
	                    var bx = p[2 * i1],
	                        by = p[2 * i1 + 1];
	                    var cx = p[2 * i2],
	                        cy = p[2 * i2 + 1];
	
	                    var earFound = false;
	                    if (PolyK._convex(ax, ay, bx, by, cx, cy)) {
	                        earFound = true;
	                        for (var j = 0; j < al; j++) {
	                            var vi = avl[j];
	                            if (vi == i0 || vi == i1 || vi == i2) continue;
	                            if (PolyK._PointInTriangle(p[2 * vi], p[2 * vi + 1], ax, ay, bx, by, cx, cy)) {
	                                earFound = false;break;
	                            }
	                        }
	                    }
	                    if (earFound) {
	                        tgs.push(i0, i1, i2);
	                        avl.splice((i + 1) % al, 1);
	                        al--;
	                        i = 0;
	                    } else if (i++ > 3 * al) break; // no convex angles :(
	                }
	                tgs.push(avl[0], avl[1], avl[2]);
	                return tgs;
	            };
	            /*
	            PolyK.ContainsPoint = function(p, px, py)
	            {
	                var n = p.length>>1;
	                var ax, ay, bx = p[2*n-2]-px, by = p[2*n-1]-py;
	                var depth = 0;
	                for(var i=0; i<n; i++)
	                {
	                    ax = bx;  ay = by;
	                    bx = p[2*i  ] - px;
	                    by = p[2*i+1] - py;
	                    if(ay< 0 && by< 0) continue;    // both "up" or both "donw"
	                    if(ay>=0 && by>=0) continue;    // both "up" or both "donw"
	                    if(ax< 0 && bx< 0) continue;
	                     var lx = ax + (bx-ax)*(-ay)/(by-ay);
	                    if(lx>0) depth++;
	                }
	                return (depth & 1) == 1;
	            }
	             PolyK.Slice = function(p, ax, ay, bx, by)
	            {
	                if(PolyK.ContainsPoint(p, ax, ay) || PolyK.ContainsPoint(p, bx, by)) return [p.slice(0)];
	                 var a = new PolyK._P(ax, ay);
	                var b = new PolyK._P(bx, by);
	                var iscs = [];  // intersections
	                var ps = [];    // points
	                for(var i=0; i<p.length; i+=2) ps.push(new PolyK._P(p[i], p[i+1]));
	                 for(var i=0; i<ps.length; i++)
	                {
	                    var isc = new PolyK._P(0,0);
	                    isc = PolyK._GetLineIntersection(a, b, ps[i], ps[(i+1)%ps.length], isc);
	                     if(isc)
	                    {
	                        isc.flag = true;
	                        iscs.push(isc);
	                        ps.splice(i+1,0,isc);
	                        i++;
	                    }
	                }
	                if(iscs.length == 0) return [p.slice(0)];
	                var comp = function(u,v) {return PolyK._P.dist(a,u) - PolyK._P.dist(a,v); }
	                iscs.sort(comp);
	                 var pgs = [];
	                var dir = 0;
	                while(iscs.length > 0)
	                {
	                    var n = ps.length;
	                    var i0 = iscs[0];
	                    var i1 = iscs[1];
	                    var ind0 = ps.indexOf(i0);
	                    var ind1 = ps.indexOf(i1);
	                    var solved = false;
	                     if(PolyK._firstWithFlag(ps, ind0) == ind1) solved = true;
	                    else
	                    {
	                        i0 = iscs[1];
	                        i1 = iscs[0];
	                        ind0 = ps.indexOf(i0);
	                        ind1 = ps.indexOf(i1);
	                        if(PolyK._firstWithFlag(ps, ind0) == ind1) solved = true;
	                    }
	                    if(solved)
	                    {
	                        dir--;
	                        var pgn = PolyK._getPoints(ps, ind0, ind1);
	                        pgs.push(pgn);
	                        ps = PolyK._getPoints(ps, ind1, ind0);
	                        i0.flag = i1.flag = false;
	                        iscs.splice(0,2);
	                        if(iscs.length == 0) pgs.push(ps);
	                    }
	                    else { dir++; iscs.reverse(); }
	                    if(dir>1) break;
	                }
	                var result = [];
	                for(var i=0; i<pgs.length; i++)
	                {
	                    var pg = pgs[i];
	                    var npg = [];
	                    for(var j=0; j<pg.length; j++) npg.push(pg[j].x, pg[j].y);
	                    result.push(npg);
	                }
	                return result;
	            }
	             PolyK.Raycast = function(p, x, y, dx, dy, isc)
	            {
	                var l = p.length - 2;
	                var tp = PolyK._tp;
	                var a1 = tp[0], a2 = tp[1],
	                b1 = tp[2], b2 = tp[3], c = tp[4];
	                a1.x = x; a1.y = y;
	                a2.x = x+dx; a2.y = y+dy;
	                 if(isc==null) isc = {dist:0, edge:0, norm:{x:0, y:0}, refl:{x:0, y:0}};
	                isc.dist = Infinity;
	                 for(var i=0; i<l; i+=2)
	                {
	                    b1.x = p[i  ];  b1.y = p[i+1];
	                    b2.x = p[i+2];  b2.y = p[i+3];
	                    var nisc = PolyK._RayLineIntersection(a1, a2, b1, b2, c);
	                    if(nisc) PolyK._updateISC(dx, dy, a1, b1, b2, c, i/2, isc);
	                }
	                b1.x = b2.x;  b1.y = b2.y;
	                b2.x = p[0];  b2.y = p[1];
	                var nisc = PolyK._RayLineIntersection(a1, a2, b1, b2, c);
	                if(nisc) PolyK._updateISC(dx, dy, a1, b1, b2, c, p.length/2, isc);
	                 return (isc.dist != Infinity) ? isc : null;
	            }
	             PolyK.ClosestEdge = function(p, x, y, isc)
	            {
	                var l = p.length - 2;
	                var tp = PolyK._tp;
	                var a1 = tp[0],
	                b1 = tp[2], b2 = tp[3], c = tp[4];
	                a1.x = x; a1.y = y;
	                 if(isc==null) isc = {dist:0, edge:0, point:{x:0, y:0}, norm:{x:0, y:0}};
	                isc.dist = Infinity;
	                 for(var i=0; i<l; i+=2)
	                {
	                    b1.x = p[i  ];  b1.y = p[i+1];
	                    b2.x = p[i+2];  b2.y = p[i+3];
	                    PolyK._pointLineDist(a1, b1, b2, i>>1, isc);
	                }
	                b1.x = b2.x;  b1.y = b2.y;
	                b2.x = p[0];  b2.y = p[1];
	                PolyK._pointLineDist(a1, b1, b2, l>>1, isc);
	                 var idst = 1/isc.dist;
	                isc.norm.x = (x-isc.point.x)*idst;
	                isc.norm.y = (y-isc.point.y)*idst;
	                return isc;
	            }
	             PolyK._pointLineDist = function(p, a, b, edge, isc)
	            {
	                var x = p.x, y = p.y, x1 = a.x, y1 = a.y, x2 = b.x, y2 = b.y;
	                 var A = x - x1;
	                var B = y - y1;
	                var C = x2 - x1;
	                var D = y2 - y1;
	                 var dot = A * C + B * D;
	                var len_sq = C * C + D * D;
	                var param = dot / len_sq;
	                 var xx, yy;
	                 if (param < 0 || (x1 == x2 && y1 == y2)) {
	                    xx = x1;
	                    yy = y1;
	                }
	                else if (param > 1) {
	                    xx = x2;
	                    yy = y2;
	                }
	                else {
	                    xx = x1 + param * C;
	                    yy = y1 + param * D;
	                }
	                 var dx = x - xx;
	                var dy = y - yy;
	                var dst = Math.sqrt(dx * dx + dy * dy);
	                if(dst<isc.dist)
	                {
	                    isc.dist = dst;
	                    isc.edge = edge;
	                    isc.point.x = xx;
	                    isc.point.y = yy;
	                }
	            }
	             PolyK._updateISC = function(dx, dy, a1, b1, b2, c, edge, isc)
	            {
	                var nrl = PolyK._P.dist(a1, c);
	                if(nrl<isc.dist)
	                {
	                    var ibl = 1/PolyK._P.dist(b1, b2);
	                    var nx = -(b2.y-b1.y)*ibl;
	                    var ny =  (b2.x-b1.x)*ibl;
	                    var ddot = 2*(dx*nx+dy*ny);
	                    isc.dist = nrl;
	                    isc.norm.x = nx;
	                    isc.norm.y = ny;
	                    isc.refl.x = -ddot*nx+dx;
	                    isc.refl.y = -ddot*ny+dy;
	                    isc.edge = edge;
	                }
	            }
	             PolyK._getPoints = function(ps, ind0, ind1)
	            {
	                var n = ps.length;
	                var nps = [];
	                if(ind1<ind0) ind1 += n;
	                for(var i=ind0; i<= ind1; i++) nps.push(ps[i%n]);
	                return nps;
	            }
	             PolyK._firstWithFlag = function(ps, ind)
	            {
	                var n = ps.length;
	                while(true)
	                {
	                    ind = (ind+1)%n;
	                    if(ps[ind].flag) return ind;
	                }
	            }
	            */
	            PolyK._PointInTriangle = function (px, py, ax, ay, bx, by, cx, cy) {
	                var v0x = cx - ax;
	                var v0y = cy - ay;
	                var v1x = bx - ax;
	                var v1y = by - ay;
	                var v2x = px - ax;
	                var v2y = py - ay;
	
	                var dot00 = v0x * v0x + v0y * v0y;
	                var dot01 = v0x * v1x + v0y * v1y;
	                var dot02 = v0x * v2x + v0y * v2y;
	                var dot11 = v1x * v1x + v1y * v1y;
	                var dot12 = v1x * v2x + v1y * v2y;
	
	                var invDenom = 1 / (dot00 * dot11 - dot01 * dot01);
	                var u = (dot11 * dot02 - dot01 * dot12) * invDenom;
	                var v = (dot00 * dot12 - dot01 * dot02) * invDenom;
	
	                // Check if point is in triangle
	                return u >= 0 && v >= 0 && u + v < 1;
	            };
	            /*
	            PolyK._RayLineIntersection = function(a1, a2, b1, b2, c)
	            {
	                var dax = (a1.x-a2.x), dbx = (b1.x-b2.x);
	                var day = (a1.y-a2.y), dby = (b1.y-b2.y);
	                 var Den = dax*dby - day*dbx;
	                if (Den == 0) return null;  // parallel
	                 var A = (a1.x * a2.y - a1.y * a2.x);
	                var B = (b1.x * b2.y - b1.y * b2.x);
	                 var I = c;
	                var iDen = 1/Den;
	                I.x = ( A*dbx - dax*B ) * iDen;
	                I.y = ( A*dby - day*B ) * iDen;
	                 if(!PolyK._InRect(I, b1, b2)) return null;
	                if((day>0 && I.y>a1.y) || (day<0 && I.y<a1.y)) return null;
	                if((dax>0 && I.x>a1.x) || (dax<0 && I.x<a1.x)) return null;
	                return I;
	            }
	             PolyK._GetLineIntersection = function(a1, a2, b1, b2, c)
	            {
	                var dax = (a1.x-a2.x), dbx = (b1.x-b2.x);
	                var day = (a1.y-a2.y), dby = (b1.y-b2.y);
	                 var Den = dax*dby - day*dbx;
	                if (Den == 0) return null;  // parallel
	                 var A = (a1.x * a2.y - a1.y * a2.x);
	                var B = (b1.x * b2.y - b1.y * b2.x);
	                 var I = c;
	                I.x = ( A*dbx - dax*B ) / Den;
	                I.y = ( A*dby - day*B ) / Den;
	                 if(PolyK._InRect(I, a1, a2) && PolyK._InRect(I, b1, b2)) return I;
	                return null;
	            }
	             PolyK._InRect = function(a, b, c)
	            {
	                if  (b.x == c.x) return (a.y>=Math.min(b.y, c.y) && a.y<=Math.max(b.y, c.y));
	                if  (b.y == c.y) return (a.x>=Math.min(b.x, c.x) && a.x<=Math.max(b.x, c.x));
	                 if(a.x >= Math.min(b.x, c.x) && a.x <= Math.max(b.x, c.x)
	                && a.y >= Math.min(b.y, c.y) && a.y <= Math.max(b.y, c.y))
	                return true;
	                return false;
	            }
	            */
	            PolyK._convex = function (ax, ay, bx, by, cx, cy) {
	                return (ay - by) * (cx - bx) + (bx - ax) * (cy - by) >= 0;
	            };
	            /*
	            PolyK._P = function(x,y)
	            {
	                this.x = x;
	                this.y = y;
	                this.flag = false;
	            }
	            PolyK._P.prototype.toString = function()
	            {
	                return "Point ["+this.x+", "+this.y+"]";
	            }
	            PolyK._P.dist = function(a,b)
	            {
	                var dx = b.x-a.x;
	                var dy = b.y-a.y;
	                return Math.sqrt(dx*dx + dy*dy);
	            }
	             PolyK._tp = [];
	            for(var i=0; i<10; i++) PolyK._tp.push(new PolyK._P(0,0));
	                */
	
	            module.exports = PolyK;
	        }, {}], 30: [function (_dereq_, module, exports) {
	            /* Copyright (c) 2013, Brandon Jones, Colin MacKenzie IV. All rights reserved.
	            
	            Redistribution and use in source and binary forms, with or without modification,
	            are permitted provided that the following conditions are met:
	            
	              * Redistributions of source code must retain the above copyright notice, this
	                list of conditions and the following disclaimer.
	              * Redistributions in binary form must reproduce the above copyright notice,
	                this list of conditions and the following disclaimer in the documentation
	                and/or other materials provided with the distribution.
	            
	            THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
	            ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	            WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	            DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
	            ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
	            (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
	            LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
	            ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	            (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	            SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. */
	
	            /**
	             * The vec2 object from glMatrix, with some extensions and some removed methods. See http://glmatrix.net.
	             * @class vec2
	             */
	
	            var vec2 = module.exports = {};
	
	            var Utils = _dereq_('../utils/Utils');
	
	            /**
	             * Make a cross product and only return the z component
	             * @method crossLength
	             * @static
	             * @param  {Array} a
	             * @param  {Array} b
	             * @return {Number}
	             */
	            vec2.crossLength = function (a, b) {
	                return a[0] * b[1] - a[1] * b[0];
	            };
	
	            /**
	             * Cross product between a vector and the Z component of a vector
	             * @method crossVZ
	             * @static
	             * @param  {Array} out
	             * @param  {Array} vec
	             * @param  {Number} zcomp
	             * @return {Number}
	             */
	            vec2.crossVZ = function (out, vec, zcomp) {
	                vec2.rotate(out, vec, -Math.PI / 2); // Rotate according to the right hand rule
	                vec2.scale(out, out, zcomp); // Scale with z
	                return out;
	            };
	
	            /**
	             * Cross product between a vector and the Z component of a vector
	             * @method crossZV
	             * @static
	             * @param  {Array} out
	             * @param  {Number} zcomp
	             * @param  {Array} vec
	             * @return {Number}
	             */
	            vec2.crossZV = function (out, zcomp, vec) {
	                vec2.rotate(out, vec, Math.PI / 2); // Rotate according to the right hand rule
	                vec2.scale(out, out, zcomp); // Scale with z
	                return out;
	            };
	
	            /**
	             * Rotate a vector by an angle
	             * @method rotate
	             * @static
	             * @param  {Array} out
	             * @param  {Array} a
	             * @param  {Number} angle
	             */
	            vec2.rotate = function (out, a, angle) {
	                if (angle !== 0) {
	                    var c = Math.cos(angle),
	                        s = Math.sin(angle),
	                        x = a[0],
	                        y = a[1];
	                    out[0] = c * x - s * y;
	                    out[1] = s * x + c * y;
	                } else {
	                    out[0] = a[0];
	                    out[1] = a[1];
	                }
	            };
	
	            /**
	             * Rotate a vector 90 degrees clockwise
	             * @method rotate90cw
	             * @static
	             * @param  {Array} out
	             * @param  {Array} a
	             * @param  {Number} angle
	             */
	            vec2.rotate90cw = function (out, a) {
	                var x = a[0];
	                var y = a[1];
	                out[0] = y;
	                out[1] = -x;
	            };
	
	            /**
	             * Transform a point position to local frame.
	             * @method toLocalFrame
	             * @param  {Array} out
	             * @param  {Array} worldPoint
	             * @param  {Array} framePosition
	             * @param  {Number} frameAngle
	             */
	            vec2.toLocalFrame = function (out, worldPoint, framePosition, frameAngle) {
	                vec2.copy(out, worldPoint);
	                vec2.sub(out, out, framePosition);
	                vec2.rotate(out, out, -frameAngle);
	            };
	
	            /**
	             * Transform a point position to global frame.
	             * @method toGlobalFrame
	             * @param  {Array} out
	             * @param  {Array} localPoint
	             * @param  {Array} framePosition
	             * @param  {Number} frameAngle
	             */
	            vec2.toGlobalFrame = function (out, localPoint, framePosition, frameAngle) {
	                vec2.copy(out, localPoint);
	                vec2.rotate(out, out, frameAngle);
	                vec2.add(out, out, framePosition);
	            };
	
	            /**
	             * Transform a vector to local frame.
	             * @method vectorToLocalFrame
	             * @param  {Array} out
	             * @param  {Array} worldVector
	             * @param  {Number} frameAngle
	             */
	            vec2.vectorToLocalFrame = function (out, worldVector, frameAngle) {
	                vec2.rotate(out, worldVector, -frameAngle);
	            };
	
	            /**
	             * Transform a point position to global frame.
	             * @method toGlobalFrame
	             * @param  {Array} out
	             * @param  {Array} localVector
	             * @param  {Number} frameAngle
	             */
	            vec2.vectorToGlobalFrame = function (out, localVector, frameAngle) {
	                vec2.rotate(out, localVector, frameAngle);
	            };
	
	            /**
	             * Compute centroid of a triangle spanned by vectors a,b,c. See http://easycalculation.com/analytical/learn-centroid.php
	             * @method centroid
	             * @static
	             * @param  {Array} out
	             * @param  {Array} a
	             * @param  {Array} b
	             * @param  {Array} c
	             * @return  {Array} The out object
	             */
	            vec2.centroid = function (out, a, b, c) {
	                vec2.add(out, a, b);
	                vec2.add(out, out, c);
	                vec2.scale(out, out, 1 / 3);
	                return out;
	            };
	
	            /**
	             * Creates a new, empty vec2
	             * @static
	             * @method create
	             * @return {Array} a new 2D vector
	             */
	            vec2.create = function () {
	                var out = new Utils.ARRAY_TYPE(2);
	                out[0] = 0;
	                out[1] = 0;
	                return out;
	            };
	
	            /**
	             * Creates a new vec2 initialized with values from an existing vector
	             * @static
	             * @method clone
	             * @param {Array} a vector to clone
	             * @return {Array} a new 2D vector
	             */
	            vec2.clone = function (a) {
	                var out = new Utils.ARRAY_TYPE(2);
	                out[0] = a[0];
	                out[1] = a[1];
	                return out;
	            };
	
	            /**
	             * Creates a new vec2 initialized with the given values
	             * @static
	             * @method fromValues
	             * @param {Number} x X component
	             * @param {Number} y Y component
	             * @return {Array} a new 2D vector
	             */
	            vec2.fromValues = function (x, y) {
	                var out = new Utils.ARRAY_TYPE(2);
	                out[0] = x;
	                out[1] = y;
	                return out;
	            };
	
	            /**
	             * Copy the values from one vec2 to another
	             * @static
	             * @method copy
	             * @param {Array} out the receiving vector
	             * @param {Array} a the source vector
	             * @return {Array} out
	             */
	            vec2.copy = function (out, a) {
	                out[0] = a[0];
	                out[1] = a[1];
	                return out;
	            };
	
	            /**
	             * Set the components of a vec2 to the given values
	             * @static
	             * @method set
	             * @param {Array} out the receiving vector
	             * @param {Number} x X component
	             * @param {Number} y Y component
	             * @return {Array} out
	             */
	            vec2.set = function (out, x, y) {
	                out[0] = x;
	                out[1] = y;
	                return out;
	            };
	
	            /**
	             * Adds two vec2's
	             * @static
	             * @method add
	             * @param {Array} out the receiving vector
	             * @param {Array} a the first operand
	             * @param {Array} b the second operand
	             * @return {Array} out
	             */
	            vec2.add = function (out, a, b) {
	                out[0] = a[0] + b[0];
	                out[1] = a[1] + b[1];
	                return out;
	            };
	
	            /**
	             * Subtracts two vec2's
	             * @static
	             * @method subtract
	             * @param {Array} out the receiving vector
	             * @param {Array} a the first operand
	             * @param {Array} b the second operand
	             * @return {Array} out
	             */
	            vec2.subtract = function (out, a, b) {
	                out[0] = a[0] - b[0];
	                out[1] = a[1] - b[1];
	                return out;
	            };
	
	            /**
	             * Alias for vec2.subtract
	             * @static
	             * @method sub
	             */
	            vec2.sub = vec2.subtract;
	
	            /**
	             * Multiplies two vec2's
	             * @static
	             * @method multiply
	             * @param {Array} out the receiving vector
	             * @param {Array} a the first operand
	             * @param {Array} b the second operand
	             * @return {Array} out
	             */
	            vec2.multiply = function (out, a, b) {
	                out[0] = a[0] * b[0];
	                out[1] = a[1] * b[1];
	                return out;
	            };
	
	            /**
	             * Alias for vec2.multiply
	             * @static
	             * @method mul
	             */
	            vec2.mul = vec2.multiply;
	
	            /**
	             * Divides two vec2's
	             * @static
	             * @method divide
	             * @param {Array} out the receiving vector
	             * @param {Array} a the first operand
	             * @param {Array} b the second operand
	             * @return {Array} out
	             */
	            vec2.divide = function (out, a, b) {
	                out[0] = a[0] / b[0];
	                out[1] = a[1] / b[1];
	                return out;
	            };
	
	            /**
	             * Alias for vec2.divide
	             * @static
	             * @method div
	             */
	            vec2.div = vec2.divide;
	
	            /**
	             * Scales a vec2 by a scalar number
	             * @static
	             * @method scale
	             * @param {Array} out the receiving vector
	             * @param {Array} a the vector to scale
	             * @param {Number} b amount to scale the vector by
	             * @return {Array} out
	             */
	            vec2.scale = function (out, a, b) {
	                out[0] = a[0] * b;
	                out[1] = a[1] * b;
	                return out;
	            };
	
	            /**
	             * Calculates the euclidian distance between two vec2's
	             * @static
	             * @method distance
	             * @param {Array} a the first operand
	             * @param {Array} b the second operand
	             * @return {Number} distance between a and b
	             */
	            vec2.distance = function (a, b) {
	                var x = b[0] - a[0],
	                    y = b[1] - a[1];
	                return Math.sqrt(x * x + y * y);
	            };
	
	            /**
	             * Alias for vec2.distance
	             * @static
	             * @method dist
	             */
	            vec2.dist = vec2.distance;
	
	            /**
	             * Calculates the squared euclidian distance between two vec2's
	             * @static
	             * @method squaredDistance
	             * @param {Array} a the first operand
	             * @param {Array} b the second operand
	             * @return {Number} squared distance between a and b
	             */
	            vec2.squaredDistance = function (a, b) {
	                var x = b[0] - a[0],
	                    y = b[1] - a[1];
	                return x * x + y * y;
	            };
	
	            /**
	             * Alias for vec2.squaredDistance
	             * @static
	             * @method sqrDist
	             */
	            vec2.sqrDist = vec2.squaredDistance;
	
	            /**
	             * Calculates the length of a vec2
	             * @static
	             * @method length
	             * @param {Array} a vector to calculate length of
	             * @return {Number} length of a
	             */
	            vec2.length = function (a) {
	                var x = a[0],
	                    y = a[1];
	                return Math.sqrt(x * x + y * y);
	            };
	
	            /**
	             * Alias for vec2.length
	             * @method len
	             * @static
	             */
	            vec2.len = vec2.length;
	
	            /**
	             * Calculates the squared length of a vec2
	             * @static
	             * @method squaredLength
	             * @param {Array} a vector to calculate squared length of
	             * @return {Number} squared length of a
	             */
	            vec2.squaredLength = function (a) {
	                var x = a[0],
	                    y = a[1];
	                return x * x + y * y;
	            };
	
	            /**
	             * Alias for vec2.squaredLength
	             * @static
	             * @method sqrLen
	             */
	            vec2.sqrLen = vec2.squaredLength;
	
	            /**
	             * Negates the components of a vec2
	             * @static
	             * @method negate
	             * @param {Array} out the receiving vector
	             * @param {Array} a vector to negate
	             * @return {Array} out
	             */
	            vec2.negate = function (out, a) {
	                out[0] = -a[0];
	                out[1] = -a[1];
	                return out;
	            };
	
	            /**
	             * Normalize a vec2
	             * @static
	             * @method normalize
	             * @param {Array} out the receiving vector
	             * @param {Array} a vector to normalize
	             * @return {Array} out
	             */
	            vec2.normalize = function (out, a) {
	                var x = a[0],
	                    y = a[1];
	                var len = x * x + y * y;
	                if (len > 0) {
	                    //TODO: evaluate use of glm_invsqrt here?
	                    len = 1 / Math.sqrt(len);
	                    out[0] = a[0] * len;
	                    out[1] = a[1] * len;
	                }
	                return out;
	            };
	
	            /**
	             * Calculates the dot product of two vec2's
	             * @static
	             * @method dot
	             * @param {Array} a the first operand
	             * @param {Array} b the second operand
	             * @return {Number} dot product of a and b
	             */
	            vec2.dot = function (a, b) {
	                return a[0] * b[0] + a[1] * b[1];
	            };
	
	            /**
	             * Returns a string representation of a vector
	             * @static
	             * @method str
	             * @param {Array} vec vector to represent as a string
	             * @return {String} string representation of the vector
	             */
	            vec2.str = function (a) {
	                return 'vec2(' + a[0] + ', ' + a[1] + ')';
	            };
	
	            /**
	             * Linearly interpolate/mix two vectors.
	             * @static
	             * @method lerp
	             * @param {Array} out
	             * @param {Array} a First vector
	             * @param {Array} b Second vector
	             * @param {number} t Lerp factor
	             */
	            vec2.lerp = function (out, a, b, t) {
	                var ax = a[0],
	                    ay = a[1];
	                out[0] = ax + t * (b[0] - ax);
	                out[1] = ay + t * (b[1] - ay);
	                return out;
	            };
	
	            /**
	             * Reflect a vector along a normal.
	             * @static
	             * @method reflect
	             * @param {Array} out
	             * @param {Array} vector
	             * @param {Array} normal
	             */
	            vec2.reflect = function (out, vector, normal) {
	                var dot = vector[0] * normal[0] + vector[1] * normal[1];
	                out[0] = vector[0] - 2 * normal[0] * dot;
	                out[1] = vector[1] - 2 * normal[1] * dot;
	            };
	
	            /**
	             * Get the intersection point between two line segments.
	             * @static
	             * @method getLineSegmentsIntersection
	             * @param  {Array} out
	             * @param  {Array} p0
	             * @param  {Array} p1
	             * @param  {Array} p2
	             * @param  {Array} p3
	             * @return {boolean} True if there was an intersection, otherwise false.
	             */
	            vec2.getLineSegmentsIntersection = function (out, p0, p1, p2, p3) {
	                var t = vec2.getLineSegmentsIntersectionFraction(p0, p1, p2, p3);
	                if (t < 0) {
	                    return false;
	                } else {
	                    out[0] = p0[0] + t * (p1[0] - p0[0]);
	                    out[1] = p0[1] + t * (p1[1] - p0[1]);
	                    return true;
	                }
	            };
	
	            /**
	             * Get the intersection fraction between two line segments. If successful, the intersection is at p0 + t * (p1 - p0)
	             * @static
	             * @method getLineSegmentsIntersectionFraction
	             * @param  {Array} p0
	             * @param  {Array} p1
	             * @param  {Array} p2
	             * @param  {Array} p3
	             * @return {number} A number between 0 and 1 if there was an intersection, otherwise -1.
	             */
	            vec2.getLineSegmentsIntersectionFraction = function (p0, p1, p2, p3) {
	                var s1_x = p1[0] - p0[0];
	                var s1_y = p1[1] - p0[1];
	                var s2_x = p3[0] - p2[0];
	                var s2_y = p3[1] - p2[1];
	
	                var s, t;
	                s = (-s1_y * (p0[0] - p2[0]) + s1_x * (p0[1] - p2[1])) / (-s2_x * s1_y + s1_x * s2_y);
	                t = (s2_x * (p0[1] - p2[1]) - s2_y * (p0[0] - p2[0])) / (-s2_x * s1_y + s1_x * s2_y);
	                if (s >= 0 && s <= 1 && t >= 0 && t <= 1) {
	                    // Collision detected
	                    return t;
	                }
	                return -1; // No collision
	            };
	        }, { "../utils/Utils": 57 }], 31: [function (_dereq_, module, exports) {
	            var vec2 = _dereq_('../math/vec2'),
	                decomp = _dereq_('poly-decomp'),
	                Convex = _dereq_('../shapes/Convex'),
	                RaycastResult = _dereq_('../collision/RaycastResult'),
	                Ray = _dereq_('../collision/Ray'),
	                AABB = _dereq_('../collision/AABB'),
	                EventEmitter = _dereq_('../events/EventEmitter');
	
	            module.exports = Body;
	
	            /**
	             * A rigid body. Has got a center of mass, position, velocity and a number of
	             * shapes that are used for collisions.
	             *
	             * @class Body
	             * @constructor
	             * @extends EventEmitter
	             * @param {Array} [options.force]
	             * @param {Array} [options.position]
	             * @param {Array} [options.velocity]
	             * @param {Boolean} [options.allowSleep]
	             * @param {Boolean} [options.collisionResponse]
	             * @param {Number} [options.angle=0]
	             * @param {Number} [options.angularForce=0]
	             * @param {Number} [options.angularVelocity=0]
	             * @param {Number} [options.ccdIterations=10]
	             * @param {Number} [options.ccdSpeedThreshold=-1]
	             * @param {Number} [options.fixedRotation=false]
	             * @param {Number} [options.gravityScale]
	             * @param {Number} [options.id]
	             * @param {Number} [options.mass=0] A number >= 0. If zero, the .type will be set to Body.STATIC.
	             * @param {Number} [options.sleepSpeedLimit]
	             * @param {Number} [options.sleepTimeLimit]
	             * @param {Object} [options]
	             *
	             * @example
	             *
	             *     // Create a typical dynamic body
	             *     var body = new Body({
	             *         mass: 1,
	             *         position: [0, 0],
	             *         angle: 0,
	             *         velocity: [0, 0],
	             *         angularVelocity: 0
	             *     });
	             *
	             *     // Add a circular shape to the body
	             *     body.addShape(new Circle({ radius: 1 }));
	             *
	             *     // Add the body to the world
	             *     world.addBody(body);
	             */
	            function Body(options) {
	                options = options || {};
	
	                EventEmitter.call(this);
	
	                /**
	                 * The body identifyer
	                 * @property id
	                 * @type {Number}
	                 */
	                this.id = options.id || ++Body._idCounter;
	
	                /**
	                 * The world that this body is added to. This property is set to NULL if the body is not added to any world.
	                 * @property world
	                 * @type {World}
	                 */
	                this.world = null;
	
	                /**
	                 * The shapes of the body.
	                 *
	                 * @property shapes
	                 * @type {Array}
	                 */
	                this.shapes = [];
	
	                /**
	                 * The mass of the body.
	                 * @property mass
	                 * @type {number}
	                 */
	                this.mass = options.mass || 0;
	
	                /**
	                 * The inverse mass of the body.
	                 * @property invMass
	                 * @type {number}
	                 */
	                this.invMass = 0;
	
	                /**
	                 * The inertia of the body around the Z axis.
	                 * @property inertia
	                 * @type {number}
	                 */
	                this.inertia = 0;
	
	                /**
	                 * The inverse inertia of the body.
	                 * @property invInertia
	                 * @type {number}
	                 */
	                this.invInertia = 0;
	
	                this.invMassSolve = 0;
	                this.invInertiaSolve = 0;
	
	                /**
	                 * Set to true if you want to fix the rotation of the body.
	                 * @property fixedRotation
	                 * @type {Boolean}
	                 */
	                this.fixedRotation = !!options.fixedRotation;
	
	                /**
	                 * Set to true if you want to fix the body movement along the X axis. The body will still be able to move along Y.
	                 * @property {Boolean} fixedX
	                 */
	                this.fixedX = !!options.fixedX;
	
	                /**
	                 * Set to true if you want to fix the body movement along the Y axis. The body will still be able to move along X.
	                 * @property {Boolean} fixedY
	                 */
	                this.fixedY = !!options.fixedY;
	
	                /**
	                 * @private
	                 * @property {array} massMultiplier
	                 */
	                this.massMultiplier = vec2.create();
	
	                /**
	                 * The position of the body
	                 * @property position
	                 * @type {Array}
	                 */
	                this.position = vec2.fromValues(0, 0);
	                if (options.position) {
	                    vec2.copy(this.position, options.position);
	                }
	
	                /**
	                 * The interpolated position of the body. Use this for rendering.
	                 * @property interpolatedPosition
	                 * @type {Array}
	                 */
	                this.interpolatedPosition = vec2.fromValues(0, 0);
	
	                /**
	                 * The interpolated angle of the body. Use this for rendering.
	                 * @property interpolatedAngle
	                 * @type {Number}
	                 */
	                this.interpolatedAngle = 0;
	
	                /**
	                 * The previous position of the body.
	                 * @property previousPosition
	                 * @type {Array}
	                 */
	                this.previousPosition = vec2.fromValues(0, 0);
	
	                /**
	                 * The previous angle of the body.
	                 * @property previousAngle
	                 * @type {Number}
	                 */
	                this.previousAngle = 0;
	
	                /**
	                 * The current velocity of the body.
	                 * @property velocity
	                 * @type {Array}
	                 */
	                this.velocity = vec2.fromValues(0, 0);
	                if (options.velocity) {
	                    vec2.copy(this.velocity, options.velocity);
	                }
	
	                /**
	                 * Constraint velocity that was added to the body during the last step.
	                 * @property vlambda
	                 * @type {Array}
	                 */
	                this.vlambda = vec2.fromValues(0, 0);
	
	                /**
	                 * Angular constraint velocity that was added to the body during last step.
	                 * @property wlambda
	                 * @type {Array}
	                 */
	                this.wlambda = 0;
	
	                /**
	                 * The angle of the body, in radians.
	                 * @property angle
	                 * @type {number}
	                 * @example
	                 *     // The angle property is not normalized to the interval 0 to 2*pi, it can be any value.
	                 *     // If you need a value between 0 and 2*pi, use the following function to normalize it.
	                 *     function normalizeAngle(angle){
	                 *         angle = angle % (2*Math.PI);
	                 *         if(angle < 0){
	                 *             angle += (2*Math.PI);
	                 *         }
	                 *         return angle;
	                 *     }
	                 */
	                this.angle = options.angle || 0;
	
	                /**
	                 * The angular velocity of the body, in radians per second.
	                 * @property angularVelocity
	                 * @type {number}
	                 */
	                this.angularVelocity = options.angularVelocity || 0;
	
	                /**
	                 * The force acting on the body. Since the body force (and {{#crossLink "Body/angularForce:property"}}{{/crossLink}}) will be zeroed after each step, so you need to set the force before each step.
	                 * @property force
	                 * @type {Array}
	                 *
	                 * @example
	                 *     // This produces a forcefield of 1 Newton in the positive x direction.
	                 *     for(var i=0; i<numSteps; i++){
	                 *         body.force[0] = 1;
	                 *         world.step(1/60);
	                 *     }
	                 *
	                 * @example
	                 *     // This will apply a rotational force on the body
	                 *     for(var i=0; i<numSteps; i++){
	                 *         body.angularForce = -3;
	                 *         world.step(1/60);
	                 *     }
	                 */
	                this.force = vec2.create();
	                if (options.force) {
	                    vec2.copy(this.force, options.force);
	                }
	
	                /**
	                 * The angular force acting on the body. See {{#crossLink "Body/force:property"}}{{/crossLink}}.
	                 * @property angularForce
	                 * @type {number}
	                 */
	                this.angularForce = options.angularForce || 0;
	
	                /**
	                 * The linear damping acting on the body in the velocity direction. Should be a value between 0 and 1.
	                 * @property damping
	                 * @type {Number}
	                 * @default 0.1
	                 */
	                this.damping = typeof options.damping === "number" ? options.damping : 0.1;
	
	                /**
	                 * The angular force acting on the body. Should be a value between 0 and 1.
	                 * @property angularDamping
	                 * @type {Number}
	                 * @default 0.1
	                 */
	                this.angularDamping = typeof options.angularDamping === "number" ? options.angularDamping : 0.1;
	
	                /**
	                 * The type of motion this body has. Should be one of: {{#crossLink "Body/STATIC:property"}}Body.STATIC{{/crossLink}}, {{#crossLink "Body/DYNAMIC:property"}}Body.DYNAMIC{{/crossLink}} and {{#crossLink "Body/KINEMATIC:property"}}Body.KINEMATIC{{/crossLink}}.
	                 *
	                 * * Static bodies do not move, and they do not respond to forces or collision.
	                 * * Dynamic bodies body can move and respond to collisions and forces.
	                 * * Kinematic bodies only moves according to its .velocity, and does not respond to collisions or force.
	                 *
	                 * @property type
	                 * @type {number}
	                 *
	                 * @example
	                 *     // Bodies are static by default. Static bodies will never move.
	                 *     var body = new Body();
	                 *     console.log(body.type == Body.STATIC); // true
	                 *
	                 * @example
	                 *     // By setting the mass of a body to a nonzero number, the body
	                 *     // will become dynamic and will move and interact with other bodies.
	                 *     var dynamicBody = new Body({
	                 *         mass : 1
	                 *     });
	                 *     console.log(dynamicBody.type == Body.DYNAMIC); // true
	                 *
	                 * @example
	                 *     // Kinematic bodies will only move if you change their velocity.
	                 *     var kinematicBody = new Body({
	                 *         type: Body.KINEMATIC // Type can be set via the options object.
	                 *     });
	                 */
	                this.type = Body.STATIC;
	
	                if (typeof options.type !== 'undefined') {
	                    this.type = options.type;
	                } else if (!options.mass) {
	                    this.type = Body.STATIC;
	                } else {
	                    this.type = Body.DYNAMIC;
	                }
	
	                /**
	                 * Bounding circle radius.
	                 * @property boundingRadius
	                 * @type {Number}
	                 */
	                this.boundingRadius = 0;
	
	                /**
	                 * Bounding box of this body.
	                 * @property aabb
	                 * @type {AABB}
	                 */
	                this.aabb = new AABB();
	
	                /**
	                 * Indicates if the AABB needs update. Update it with {{#crossLink "Body/updateAABB:method"}}.updateAABB(){{/crossLink}}.
	                 * @property aabbNeedsUpdate
	                 * @type {Boolean}
	                 * @see updateAABB
	                 *
	                 * @example
	                 *     // Force update the AABB
	                 *     body.aabbNeedsUpdate = true;
	                 *     body.updateAABB();
	                 *     console.log(body.aabbNeedsUpdate); // false
	                 */
	                this.aabbNeedsUpdate = true;
	
	                /**
	                 * If true, the body will automatically fall to sleep. Note that you need to enable sleeping in the {{#crossLink "World"}}{{/crossLink}} before anything will happen.
	                 * @property allowSleep
	                 * @type {Boolean}
	                 * @default true
	                 */
	                this.allowSleep = options.allowSleep !== undefined ? options.allowSleep : true;
	
	                this.wantsToSleep = false;
	
	                /**
	                 * One of {{#crossLink "Body/AWAKE:property"}}Body.AWAKE{{/crossLink}}, {{#crossLink "Body/SLEEPY:property"}}Body.SLEEPY{{/crossLink}} and {{#crossLink "Body/SLEEPING:property"}}Body.SLEEPING{{/crossLink}}.
	                 *
	                 * The body is initially Body.AWAKE. If its velocity norm is below .sleepSpeedLimit, the sleepState will become Body.SLEEPY. If the body continues to be Body.SLEEPY for .sleepTimeLimit seconds, it will fall asleep (Body.SLEEPY).
	                 *
	                 * @property sleepState
	                 * @type {Number}
	                 * @default Body.AWAKE
	                 */
	                this.sleepState = Body.AWAKE;
	
	                /**
	                 * If the speed (the norm of the velocity) is smaller than this value, the body is considered sleepy.
	                 * @property sleepSpeedLimit
	                 * @type {Number}
	                 * @default 0.2
	                 */
	                this.sleepSpeedLimit = options.sleepSpeedLimit !== undefined ? options.sleepSpeedLimit : 0.2;
	
	                /**
	                 * If the body has been sleepy for this sleepTimeLimit seconds, it is considered sleeping.
	                 * @property sleepTimeLimit
	                 * @type {Number}
	                 * @default 1
	                 */
	                this.sleepTimeLimit = options.sleepTimeLimit !== undefined ? options.sleepTimeLimit : 1;
	
	                /**
	                 * Gravity scaling factor. If you want the body to ignore gravity, set this to zero. If you want to reverse gravity, set it to -1.
	                 * @property {Number} gravityScale
	                 * @default 1
	                 */
	                this.gravityScale = options.gravityScale !== undefined ? options.gravityScale : 1;
	
	                /**
	                 * Whether to produce contact forces when in contact with other bodies. Note that contacts will be generated, but they will be disabled. That means that this body will move through other bodies, but it will still trigger contact events, etc.
	                 * @property {Boolean} collisionResponse
	                 */
	                this.collisionResponse = options.collisionResponse !== undefined ? options.collisionResponse : true;
	
	                /**
	                 * How long the body has been sleeping.
	                 * @property {Number} idleTime
	                 */
	                this.idleTime = 0;
	
	                /**
	                 * The last time when the body went to SLEEPY state.
	                 * @property {Number} timeLastSleepy
	                 * @private
	                 */
	                this.timeLastSleepy = 0;
	
	                /**
	                 * If the body speed exceeds this threshold, CCD (continuous collision detection) will be enabled. Set it to a negative number to disable CCD completely for this body.
	                 * @property {number} ccdSpeedThreshold
	                 * @default -1
	                 */
	                this.ccdSpeedThreshold = options.ccdSpeedThreshold !== undefined ? options.ccdSpeedThreshold : -1;
	
	                /**
	                 * The number of iterations that should be used when searching for the time of impact during CCD. A larger number will assure that there's a small penetration on CCD collision, but a small number will give more performance.
	                 * @property {number} ccdIterations
	                 * @default 10
	                 */
	                this.ccdIterations = options.ccdIterations !== undefined ? options.ccdIterations : 10;
	
	                this.concavePath = null;
	
	                this._wakeUpAfterNarrowphase = false;
	
	                this.updateMassProperties();
	            }
	            Body.prototype = new EventEmitter();
	            Body.prototype.constructor = Body;
	
	            Body._idCounter = 0;
	
	            /**
	             * @private
	             * @method updateSolveMassProperties
	             */
	            Body.prototype.updateSolveMassProperties = function () {
	                if (this.sleepState === Body.SLEEPING || this.type === Body.KINEMATIC) {
	                    this.invMassSolve = 0;
	                    this.invInertiaSolve = 0;
	                } else {
	                    this.invMassSolve = this.invMass;
	                    this.invInertiaSolve = this.invInertia;
	                }
	            };
	
	            /**
	             * Set the total density of the body
	             * @method setDensity
	             * @param {number} density
	             */
	            Body.prototype.setDensity = function (density) {
	                var totalArea = this.getArea();
	                this.mass = totalArea * density;
	                this.updateMassProperties();
	            };
	
	            /**
	             * Get the total area of all shapes in the body
	             * @method getArea
	             * @return {Number}
	             */
	            Body.prototype.getArea = function () {
	                var totalArea = 0;
	                for (var i = 0; i < this.shapes.length; i++) {
	                    totalArea += this.shapes[i].area;
	                }
	                return totalArea;
	            };
	
	            /**
	             * Get the AABB from the body. The AABB is updated if necessary.
	             * @method getAABB
	             * @return {AABB} The AABB instance (this.aabb)
	             */
	            Body.prototype.getAABB = function () {
	                if (this.aabbNeedsUpdate) {
	                    this.updateAABB();
	                }
	                return this.aabb;
	            };
	
	            var shapeAABB = new AABB(),
	                tmp = vec2.create();
	
	            /**
	             * Updates the AABB of the Body, and set .aabbNeedsUpdate = false.
	             * @method updateAABB
	             */
	            Body.prototype.updateAABB = function () {
	                var shapes = this.shapes,
	                    N = shapes.length,
	                    offset = tmp,
	                    bodyAngle = this.angle;
	
	                for (var i = 0; i !== N; i++) {
	                    var shape = shapes[i],
	                        angle = shape.angle + bodyAngle;
	
	                    // Get shape world offset
	                    vec2.rotate(offset, shape.position, bodyAngle);
	                    vec2.add(offset, offset, this.position);
	
	                    // Get shape AABB
	                    shape.computeAABB(shapeAABB, offset, angle);
	
	                    if (i === 0) {
	                        this.aabb.copy(shapeAABB);
	                    } else {
	                        this.aabb.extend(shapeAABB);
	                    }
	                }
	
	                this.aabbNeedsUpdate = false;
	            };
	
	            /**
	             * Update the bounding radius of the body (this.boundingRadius). Should be done if any of the shape dimensions or positions are changed.
	             * @method updateBoundingRadius
	             */
	            Body.prototype.updateBoundingRadius = function () {
	                var shapes = this.shapes,
	                    N = shapes.length,
	                    radius = 0;
	
	                for (var i = 0; i !== N; i++) {
	                    var shape = shapes[i],
	                        offset = vec2.length(shape.position),
	                        r = shape.boundingRadius;
	                    if (offset + r > radius) {
	                        radius = offset + r;
	                    }
	                }
	
	                this.boundingRadius = radius;
	            };
	
	            /**
	             * Add a shape to the body. You can pass a local transform when adding a shape,
	             * so that the shape gets an offset and angle relative to the body center of mass.
	             * Will automatically update the mass properties and bounding radius.
	             *
	             * @method addShape
	             * @param  {Shape}              shape
	             * @param  {Array} [offset] Local body offset of the shape.
	             * @param  {Number}             [angle]  Local body angle.
	             *
	             * @example
	             *     var body = new Body(),
	             *         shape = new Circle({ radius: 1 });
	             *
	             *     // Add the shape to the body, positioned in the center
	             *     body.addShape(shape);
	             *
	             *     // Add another shape to the body, positioned 1 unit length from the body center of mass along the local x-axis.
	             *     body.addShape(shape,[1,0]);
	             *
	             *     // Add another shape to the body, positioned 1 unit length from the body center of mass along the local y-axis, and rotated 90 degrees CCW.
	             *     body.addShape(shape,[0,1],Math.PI/2);
	             */
	            Body.prototype.addShape = function (shape, offset, angle) {
	                if (shape.body) {
	                    throw new Error('A shape can only be added to one body.');
	                }
	                shape.body = this;
	
	                // Copy the offset vector
	                if (offset) {
	                    vec2.copy(shape.position, offset);
	                } else {
	                    vec2.set(shape.position, 0, 0);
	                }
	
	                shape.angle = angle || 0;
	
	                this.shapes.push(shape);
	                this.updateMassProperties();
	                this.updateBoundingRadius();
	
	                this.aabbNeedsUpdate = true;
	            };
	
	            /**
	             * Remove a shape
	             * @method removeShape
	             * @param  {Shape} shape
	             * @return {Boolean} True if the shape was found and removed, else false.
	             */
	            Body.prototype.removeShape = function (shape) {
	                var idx = this.shapes.indexOf(shape);
	
	                if (idx !== -1) {
	                    this.shapes.splice(idx, 1);
	                    this.aabbNeedsUpdate = true;
	                    shape.body = null;
	                    return true;
	                } else {
	                    return false;
	                }
	            };
	
	            /**
	             * Updates .inertia, .invMass, .invInertia for this Body. Should be called when
	             * changing the structure or mass of the Body.
	             *
	             * @method updateMassProperties
	             *
	             * @example
	             *     body.mass += 1;
	             *     body.updateMassProperties();
	             */
	            Body.prototype.updateMassProperties = function () {
	                if (this.type === Body.STATIC || this.type === Body.KINEMATIC) {
	
	                    this.mass = Number.MAX_VALUE;
	                    this.invMass = 0;
	                    this.inertia = Number.MAX_VALUE;
	                    this.invInertia = 0;
	                } else {
	
	                    var shapes = this.shapes,
	                        N = shapes.length,
	                        m = this.mass / N,
	                        I = 0;
	
	                    if (!this.fixedRotation) {
	                        for (var i = 0; i < N; i++) {
	                            var shape = shapes[i],
	                                r2 = vec2.squaredLength(shape.position),
	                                Icm = shape.computeMomentOfInertia(m);
	                            I += Icm + m * r2;
	                        }
	                        this.inertia = I;
	                        this.invInertia = I > 0 ? 1 / I : 0;
	                    } else {
	                        this.inertia = Number.MAX_VALUE;
	                        this.invInertia = 0;
	                    }
	
	                    // Inverse mass properties are easy
	                    this.invMass = 1 / this.mass;
	
	                    vec2.set(this.massMultiplier, this.fixedX ? 0 : 1, this.fixedY ? 0 : 1);
	                }
	            };
	
	            var Body_applyForce_r = vec2.create();
	
	            /**
	             * Apply force to a point relative to the center of mass of the body. This could for example be a point on the RigidBody surface. Applying force this way will add to Body.force and Body.angularForce. If relativePoint is zero, the force will be applied directly on the center of mass, and the torque produced will be zero.
	             * @method applyForce
	             * @param {Array} force The force to add.
	             * @param {Array} [relativePoint] A world point to apply the force on.
	             */
	            Body.prototype.applyForce = function (force, relativePoint) {
	
	                // Add linear force
	                vec2.add(this.force, this.force, force);
	
	                if (relativePoint) {
	
	                    // Compute produced rotational force
	                    var rotForce = vec2.crossLength(relativePoint, force);
	
	                    // Add rotational force
	                    this.angularForce += rotForce;
	                }
	            };
	
	            /**
	             * Apply force to a body-local point.
	             * @method applyForceLocal
	             * @param  {Array} localForce The force vector to add, oriented in local body space.
	             * @param  {Array} localPoint A point relative to the body in world space. If not given, it is set to zero and all of the impulse will be excerted on the center of mass.
	             */
	            var Body_applyForce_forceWorld = vec2.create();
	            var Body_applyForce_pointWorld = vec2.create();
	            var Body_applyForce_pointLocal = vec2.create();
	            Body.prototype.applyForceLocal = function (localForce, localPoint) {
	                localPoint = localPoint || Body_applyForce_pointLocal;
	                var worldForce = Body_applyForce_forceWorld;
	                var worldPoint = Body_applyForce_pointWorld;
	                this.vectorToWorldFrame(worldForce, localForce);
	                this.vectorToWorldFrame(worldPoint, localPoint);
	                this.applyForce(worldForce, worldPoint);
	            };
	
	            /**
	             * Apply impulse to a point relative to the body. This could for example be a point on the Body surface. An impulse is a force added to a body during a short period of time (impulse = force * time). Impulses will be added to Body.velocity and Body.angularVelocity.
	             * @method applyImpulse
	             * @param  {Array} impulse The impulse vector to add, oriented in world space.
	             * @param  {Array} [relativePoint] A point relative to the body in world space. If not given, it is set to zero and all of the impulse will be excerted on the center of mass.
	             */
	            var Body_applyImpulse_velo = vec2.create();
	            Body.prototype.applyImpulse = function (impulseVector, relativePoint) {
	                if (this.type !== Body.DYNAMIC) {
	                    return;
	                }
	
	                // Compute produced central impulse velocity
	                var velo = Body_applyImpulse_velo;
	                vec2.scale(velo, impulseVector, this.invMass);
	                vec2.multiply(velo, this.massMultiplier, velo);
	
	                // Add linear impulse
	                vec2.add(this.velocity, velo, this.velocity);
	
	                if (relativePoint) {
	                    // Compute produced rotational impulse velocity
	                    var rotVelo = vec2.crossLength(relativePoint, impulseVector);
	                    rotVelo *= this.invInertia;
	
	                    // Add rotational Impulse
	                    this.angularVelocity += rotVelo;
	                }
	            };
	
	            /**
	             * Apply impulse to a point relative to the body. This could for example be a point on the Body surface. An impulse is a force added to a body during a short period of time (impulse = force * time). Impulses will be added to Body.velocity and Body.angularVelocity.
	             * @method applyImpulseLocal
	             * @param  {Array} impulse The impulse vector to add, oriented in world space.
	             * @param  {Array} [relativePoint] A point relative to the body in world space. If not given, it is set to zero and all of the impulse will be excerted on the center of mass.
	             */
	            var Body_applyImpulse_impulseWorld = vec2.create();
	            var Body_applyImpulse_pointWorld = vec2.create();
	            var Body_applyImpulse_pointLocal = vec2.create();
	            Body.prototype.applyImpulseLocal = function (localImpulse, localPoint) {
	                localPoint = localPoint || Body_applyImpulse_pointLocal;
	                var worldImpulse = Body_applyImpulse_impulseWorld;
	                var worldPoint = Body_applyImpulse_pointWorld;
	                this.vectorToWorldFrame(worldImpulse, localImpulse);
	                this.vectorToWorldFrame(worldPoint, localPoint);
	                this.applyImpulse(worldImpulse, worldPoint);
	            };
	
	            /**
	             * Transform a world point to local body frame.
	             * @method toLocalFrame
	             * @param  {Array} out          The vector to store the result in
	             * @param  {Array} worldPoint   The input world point
	             */
	            Body.prototype.toLocalFrame = function (out, worldPoint) {
	                vec2.toLocalFrame(out, worldPoint, this.position, this.angle);
	            };
	
	            /**
	             * Transform a local point to world frame.
	             * @method toWorldFrame
	             * @param  {Array} out          The vector to store the result in
	             * @param  {Array} localPoint   The input local point
	             */
	            Body.prototype.toWorldFrame = function (out, localPoint) {
	                vec2.toGlobalFrame(out, localPoint, this.position, this.angle);
	            };
	
	            /**
	             * Transform a world point to local body frame.
	             * @method vectorToLocalFrame
	             * @param  {Array} out          The vector to store the result in
	             * @param  {Array} worldVector  The input world vector
	             */
	            Body.prototype.vectorToLocalFrame = function (out, worldVector) {
	                vec2.vectorToLocalFrame(out, worldVector, this.angle);
	            };
	
	            /**
	             * Transform a local point to world frame.
	             * @method vectorToWorldFrame
	             * @param  {Array} out          The vector to store the result in
	             * @param  {Array} localVector  The input local vector
	             */
	            Body.prototype.vectorToWorldFrame = function (out, localVector) {
	                vec2.vectorToGlobalFrame(out, localVector, this.angle);
	            };
	
	            /**
	             * Reads a polygon shape path, and assembles convex shapes from that and puts them at proper offset points.
	             * @method fromPolygon
	             * @param {Array} path An array of 2d vectors, e.g. [[0,0],[0,1],...] that resembles a concave or convex polygon. The shape must be simple and without holes.
	             * @param {Object} [options]
	             * @param {Boolean} [options.optimalDecomp=false]   Set to true if you need optimal decomposition. Warning: very slow for polygons with more than 10 vertices.
	             * @param {Boolean} [options.skipSimpleCheck=false] Set to true if you already know that the path is not intersecting itself.
	             * @param {Boolean|Number} [options.removeCollinearPoints=false] Set to a number (angle threshold value) to remove collinear points, or false to keep all points.
	             * @return {Boolean} True on success, else false.
	             */
	            Body.prototype.fromPolygon = function (path, options) {
	                options = options || {};
	
	                // Remove all shapes
	                for (var i = this.shapes.length; i >= 0; --i) {
	                    this.removeShape(this.shapes[i]);
	                }
	
	                var p = new decomp.Polygon();
	                p.vertices = path;
	
	                // Make it counter-clockwise
	                p.makeCCW();
	
	                if (typeof options.removeCollinearPoints === "number") {
	                    p.removeCollinearPoints(options.removeCollinearPoints);
	                }
	
	                // Check if any line segment intersects the path itself
	                if (typeof options.skipSimpleCheck === "undefined") {
	                    if (!p.isSimple()) {
	                        return false;
	                    }
	                }
	
	                // Save this path for later
	                this.concavePath = p.vertices.slice(0);
	                for (var i = 0; i < this.concavePath.length; i++) {
	                    var v = [0, 0];
	                    vec2.copy(v, this.concavePath[i]);
	                    this.concavePath[i] = v;
	                }
	
	                // Slow or fast decomp?
	                var convexes;
	                if (options.optimalDecomp) {
	                    convexes = p.decomp();
	                } else {
	                    convexes = p.quickDecomp();
	                }
	
	                var cm = vec2.create();
	
	                // Add convexes
	                for (var i = 0; i !== convexes.length; i++) {
	                    // Create convex
	                    var c = new Convex({ vertices: convexes[i].vertices });
	
	                    // Move all vertices so its center of mass is in the local center of the convex
	                    for (var j = 0; j !== c.vertices.length; j++) {
	                        var v = c.vertices[j];
	                        vec2.sub(v, v, c.centerOfMass);
	                    }
	
	                    vec2.scale(cm, c.centerOfMass, 1);
	                    c.updateTriangles();
	                    c.updateCenterOfMass();
	                    c.updateBoundingRadius();
	
	                    // Add the shape
	                    this.addShape(c, cm);
	                }
	
	                this.adjustCenterOfMass();
	
	                this.aabbNeedsUpdate = true;
	
	                return true;
	            };
	
	            var adjustCenterOfMass_tmp1 = vec2.fromValues(0, 0),
	                adjustCenterOfMass_tmp2 = vec2.fromValues(0, 0),
	                adjustCenterOfMass_tmp3 = vec2.fromValues(0, 0),
	                adjustCenterOfMass_tmp4 = vec2.fromValues(0, 0);
	
	            /**
	             * Moves the shape offsets so their center of mass becomes the body center of mass.
	             * @method adjustCenterOfMass
	             */
	            Body.prototype.adjustCenterOfMass = function () {
	                var offset_times_area = adjustCenterOfMass_tmp2,
	                    sum = adjustCenterOfMass_tmp3,
	                    cm = adjustCenterOfMass_tmp4,
	                    totalArea = 0;
	                vec2.set(sum, 0, 0);
	
	                for (var i = 0; i !== this.shapes.length; i++) {
	                    var s = this.shapes[i];
	                    vec2.scale(offset_times_area, s.position, s.area);
	                    vec2.add(sum, sum, offset_times_area);
	                    totalArea += s.area;
	                }
	
	                vec2.scale(cm, sum, 1 / totalArea);
	
	                // Now move all shapes
	                for (var i = 0; i !== this.shapes.length; i++) {
	                    var s = this.shapes[i];
	                    vec2.sub(s.position, s.position, cm);
	                }
	
	                // Move the body position too
	                vec2.add(this.position, this.position, cm);
	
	                // And concave path
	                for (var i = 0; this.concavePath && i < this.concavePath.length; i++) {
	                    vec2.sub(this.concavePath[i], this.concavePath[i], cm);
	                }
	
	                this.updateMassProperties();
	                this.updateBoundingRadius();
	            };
	
	            /**
	             * Sets the force on the body to zero.
	             * @method setZeroForce
	             */
	            Body.prototype.setZeroForce = function () {
	                vec2.set(this.force, 0.0, 0.0);
	                this.angularForce = 0.0;
	            };
	
	            Body.prototype.resetConstraintVelocity = function () {
	                var b = this,
	                    vlambda = b.vlambda;
	                vec2.set(vlambda, 0, 0);
	                b.wlambda = 0;
	            };
	
	            Body.prototype.addConstraintVelocity = function () {
	                var b = this,
	                    v = b.velocity;
	                vec2.add(v, v, b.vlambda);
	                b.angularVelocity += b.wlambda;
	            };
	
	            /**
	             * Apply damping, see <a href="http://code.google.com/p/bullet/issues/detail?id=74">this</a> for details.
	             * @method applyDamping
	             * @param  {number} dt Current time step
	             */
	            Body.prototype.applyDamping = function (dt) {
	                if (this.type === Body.DYNAMIC) {
	                    // Only for dynamic bodies
	                    var v = this.velocity;
	                    vec2.scale(v, v, Math.pow(1.0 - this.damping, dt));
	                    this.angularVelocity *= Math.pow(1.0 - this.angularDamping, dt);
	                }
	            };
	
	            /**
	             * Wake the body up. Normally you should not need this, as the body is automatically awoken at events such as collisions.
	             * Sets the sleepState to {{#crossLink "Body/AWAKE:property"}}Body.AWAKE{{/crossLink}} and emits the wakeUp event if the body wasn't awake before.
	             * @method wakeUp
	             */
	            Body.prototype.wakeUp = function () {
	                var s = this.sleepState;
	                this.sleepState = Body.AWAKE;
	                this.idleTime = 0;
	                if (s !== Body.AWAKE) {
	                    this.emit(Body.wakeUpEvent);
	                }
	            };
	
	            /**
	             * Force body sleep
	             * @method sleep
	             */
	            Body.prototype.sleep = function () {
	                this.sleepState = Body.SLEEPING;
	                this.angularVelocity = 0;
	                this.angularForce = 0;
	                vec2.set(this.velocity, 0, 0);
	                vec2.set(this.force, 0, 0);
	                this.emit(Body.sleepEvent);
	            };
	
	            /**
	             * Called every timestep to update internal sleep timer and change sleep state if needed.
	             * @method sleepTick
	             * @param {number} time The world time in seconds
	             * @param {boolean} dontSleep
	             * @param {number} dt
	             */
	            Body.prototype.sleepTick = function (time, dontSleep, dt) {
	                if (!this.allowSleep || this.type === Body.SLEEPING) {
	                    return;
	                }
	
	                this.wantsToSleep = false;
	
	                var sleepState = this.sleepState,
	                    speedSquared = vec2.squaredLength(this.velocity) + Math.pow(this.angularVelocity, 2),
	                    speedLimitSquared = Math.pow(this.sleepSpeedLimit, 2);
	
	                // Add to idle time
	                if (speedSquared >= speedLimitSquared) {
	                    this.idleTime = 0;
	                    this.sleepState = Body.AWAKE;
	                } else {
	                    this.idleTime += dt;
	                    this.sleepState = Body.SLEEPY;
	                }
	                if (this.idleTime > this.sleepTimeLimit) {
	                    if (!dontSleep) {
	                        this.sleep();
	                    } else {
	                        this.wantsToSleep = true;
	                    }
	                }
	            };
	
	            /**
	             * Check if the body is overlapping another body. Note that this method only works if the body was added to a World and if at least one step was taken.
	             * @method overlaps
	             * @param  {Body} body
	             * @return {boolean}
	             */
	            Body.prototype.overlaps = function (body) {
	                return this.world.overlapKeeper.bodiesAreOverlapping(this, body);
	            };
	
	            var integrate_fhMinv = vec2.create();
	            var integrate_velodt = vec2.create();
	
	            /**
	             * Move the body forward in time given its current velocity.
	             * @method integrate
	             * @param  {Number} dt
	             */
	            Body.prototype.integrate = function (dt) {
	                var minv = this.invMass,
	                    f = this.force,
	                    pos = this.position,
	                    velo = this.velocity;
	
	                // Save old position
	                vec2.copy(this.previousPosition, this.position);
	                this.previousAngle = this.angle;
	
	                // Velocity update
	                if (!this.fixedRotation) {
	                    this.angularVelocity += this.angularForce * this.invInertia * dt;
	                }
	                vec2.scale(integrate_fhMinv, f, dt * minv);
	                vec2.multiply(integrate_fhMinv, this.massMultiplier, integrate_fhMinv);
	                vec2.add(velo, integrate_fhMinv, velo);
	
	                // CCD
	                if (!this.integrateToTimeOfImpact(dt)) {
	
	                    // Regular position update
	                    vec2.scale(integrate_velodt, velo, dt);
	                    vec2.add(pos, pos, integrate_velodt);
	                    if (!this.fixedRotation) {
	                        this.angle += this.angularVelocity * dt;
	                    }
	                }
	
	                this.aabbNeedsUpdate = true;
	            };
	
	            var result = new RaycastResult();
	            var ray = new Ray({
	                mode: Ray.ALL
	            });
	            var direction = vec2.create();
	            var end = vec2.create();
	            var startToEnd = vec2.create();
	            var rememberPosition = vec2.create();
	            Body.prototype.integrateToTimeOfImpact = function (dt) {
	
	                if (this.ccdSpeedThreshold < 0 || vec2.squaredLength(this.velocity) < Math.pow(this.ccdSpeedThreshold, 2)) {
	                    return false;
	                }
	
	                vec2.normalize(direction, this.velocity);
	
	                vec2.scale(end, this.velocity, dt);
	                vec2.add(end, end, this.position);
	
	                vec2.sub(startToEnd, end, this.position);
	                var startToEndAngle = this.angularVelocity * dt;
	                var len = vec2.length(startToEnd);
	
	                var timeOfImpact = 1;
	
	                var hit;
	                var that = this;
	                result.reset();
	                ray.callback = function (result) {
	                    if (result.body === that) {
	                        return;
	                    }
	                    hit = result.body;
	                    result.getHitPoint(end, ray);
	                    vec2.sub(startToEnd, end, that.position);
	                    timeOfImpact = vec2.length(startToEnd) / len;
	                    result.stop();
	                };
	                vec2.copy(ray.from, this.position);
	                vec2.copy(ray.to, end);
	                ray.update();
	                this.world.raycast(result, ray);
	
	                if (!hit) {
	                    return false;
	                }
	
	                var rememberAngle = this.angle;
	                vec2.copy(rememberPosition, this.position);
	
	                // Got a start and end point. Approximate time of impact using binary search
	                var iter = 0;
	                var tmin = 0;
	                var tmid = 0;
	                var tmax = timeOfImpact;
	                while (tmax >= tmin && iter < this.ccdIterations) {
	                    iter++;
	
	                    // calculate the midpoint
	                    tmid = (tmax - tmin) / 2;
	
	                    // Move the body to that point
	                    vec2.scale(integrate_velodt, startToEnd, timeOfImpact);
	                    vec2.add(this.position, rememberPosition, integrate_velodt);
	                    this.angle = rememberAngle + startToEndAngle * timeOfImpact;
	                    this.updateAABB();
	
	                    // check overlap
	                    var overlaps = this.aabb.overlaps(hit.aabb) && this.world.narrowphase.bodiesOverlap(this, hit);
	
	                    if (overlaps) {
	                        // change min to search upper interval
	                        tmin = tmid;
	                    } else {
	                        // change max to search lower interval
	                        tmax = tmid;
	                    }
	                }
	
	                timeOfImpact = tmid;
	
	                vec2.copy(this.position, rememberPosition);
	                this.angle = rememberAngle;
	
	                // move to TOI
	                vec2.scale(integrate_velodt, startToEnd, timeOfImpact);
	                vec2.add(this.position, this.position, integrate_velodt);
	                if (!this.fixedRotation) {
	                    this.angle += startToEndAngle * timeOfImpact;
	                }
	
	                return true;
	            };
	
	            /**
	             * Get velocity of a point in the body.
	             * @method getVelocityAtPoint
	             * @param  {Array} result A vector to store the result in
	             * @param  {Array} relativePoint A world oriented vector, indicating the position of the point to get the velocity from
	             * @return {Array} The result vector
	             */
	            Body.prototype.getVelocityAtPoint = function (result, relativePoint) {
	                vec2.crossVZ(result, relativePoint, this.angularVelocity);
	                vec2.subtract(result, this.velocity, result);
	                return result;
	            };
	
	            /**
	             * @event sleepy
	             */
	            Body.sleepyEvent = {
	                type: "sleepy"
	            };
	
	            /**
	             * @event sleep
	             */
	            Body.sleepEvent = {
	                type: "sleep"
	            };
	
	            /**
	             * @event wakeup
	             */
	            Body.wakeUpEvent = {
	                type: "wakeup"
	            };
	
	            /**
	             * Dynamic body.
	             * @property DYNAMIC
	             * @type {Number}
	             * @static
	             */
	            Body.DYNAMIC = 1;
	
	            /**
	             * Static body.
	             * @property STATIC
	             * @type {Number}
	             * @static
	             */
	            Body.STATIC = 2;
	
	            /**
	             * Kinematic body.
	             * @property KINEMATIC
	             * @type {Number}
	             * @static
	             */
	            Body.KINEMATIC = 4;
	
	            /**
	             * @property AWAKE
	             * @type {Number}
	             * @static
	             */
	            Body.AWAKE = 0;
	
	            /**
	             * @property SLEEPY
	             * @type {Number}
	             * @static
	             */
	            Body.SLEEPY = 1;
	
	            /**
	             * @property SLEEPING
	             * @type {Number}
	             * @static
	             */
	            Body.SLEEPING = 2;
	        }, { "../collision/AABB": 7, "../collision/Ray": 11, "../collision/RaycastResult": 12, "../events/EventEmitter": 26, "../math/vec2": 30, "../shapes/Convex": 40, "poly-decomp": 5 }], 32: [function (_dereq_, module, exports) {
	            var vec2 = _dereq_('../math/vec2');
	            var Spring = _dereq_('./Spring');
	            var Utils = _dereq_('../utils/Utils');
	
	            module.exports = LinearSpring;
	
	            /**
	             * A spring, connecting two bodies.
	             *
	             * The Spring explicitly adds force and angularForce to the bodies.
	             *
	             * @class LinearSpring
	             * @extends Spring
	             * @constructor
	             * @param {Body} bodyA
	             * @param {Body} bodyB
	             * @param {Object} [options]
	             * @param {number} [options.restLength]   A number > 0. Default is the current distance between the world anchor points.
	             * @param {number} [options.stiffness=100]  Spring constant (see Hookes Law). A number >= 0.
	             * @param {number} [options.damping=1]      A number >= 0. Default: 1
	             * @param {Array}  [options.worldAnchorA]   Where to hook the spring to body A, in world coordinates. Overrides the option "localAnchorA" if given.
	             * @param {Array}  [options.worldAnchorB]
	             * @param {Array}  [options.localAnchorA]   Where to hook the spring to body A, in local body coordinates. Defaults to the body center.
	             * @param {Array}  [options.localAnchorB]
	             */
	            function LinearSpring(bodyA, bodyB, options) {
	                options = options || {};
	
	                Spring.call(this, bodyA, bodyB, options);
	
	                /**
	                 * Anchor for bodyA in local bodyA coordinates.
	                 * @property localAnchorA
	                 * @type {Array}
	                 */
	                this.localAnchorA = vec2.fromValues(0, 0);
	
	                /**
	                 * Anchor for bodyB in local bodyB coordinates.
	                 * @property localAnchorB
	                 * @type {Array}
	                 */
	                this.localAnchorB = vec2.fromValues(0, 0);
	
	                if (options.localAnchorA) {
	                    vec2.copy(this.localAnchorA, options.localAnchorA);
	                }
	                if (options.localAnchorB) {
	                    vec2.copy(this.localAnchorB, options.localAnchorB);
	                }
	                if (options.worldAnchorA) {
	                    this.setWorldAnchorA(options.worldAnchorA);
	                }
	                if (options.worldAnchorB) {
	                    this.setWorldAnchorB(options.worldAnchorB);
	                }
	
	                var worldAnchorA = vec2.create();
	                var worldAnchorB = vec2.create();
	                this.getWorldAnchorA(worldAnchorA);
	                this.getWorldAnchorB(worldAnchorB);
	                var worldDistance = vec2.distance(worldAnchorA, worldAnchorB);
	
	                /**
	                 * Rest length of the spring.
	                 * @property restLength
	                 * @type {number}
	                 */
	                this.restLength = typeof options.restLength === "number" ? options.restLength : worldDistance;
	            }
	            LinearSpring.prototype = new Spring();
	            LinearSpring.prototype.constructor = LinearSpring;
	
	            /**
	             * Set the anchor point on body A, using world coordinates.
	             * @method setWorldAnchorA
	             * @param {Array} worldAnchorA
	             */
	            LinearSpring.prototype.setWorldAnchorA = function (worldAnchorA) {
	                this.bodyA.toLocalFrame(this.localAnchorA, worldAnchorA);
	            };
	
	            /**
	             * Set the anchor point on body B, using world coordinates.
	             * @method setWorldAnchorB
	             * @param {Array} worldAnchorB
	             */
	            LinearSpring.prototype.setWorldAnchorB = function (worldAnchorB) {
	                this.bodyB.toLocalFrame(this.localAnchorB, worldAnchorB);
	            };
	
	            /**
	             * Get the anchor point on body A, in world coordinates.
	             * @method getWorldAnchorA
	             * @param {Array} result The vector to store the result in.
	             */
	            LinearSpring.prototype.getWorldAnchorA = function (result) {
	                this.bodyA.toWorldFrame(result, this.localAnchorA);
	            };
	
	            /**
	             * Get the anchor point on body B, in world coordinates.
	             * @method getWorldAnchorB
	             * @param {Array} result The vector to store the result in.
	             */
	            LinearSpring.prototype.getWorldAnchorB = function (result) {
	                this.bodyB.toWorldFrame(result, this.localAnchorB);
	            };
	
	            var applyForce_r = vec2.create(),
	                applyForce_r_unit = vec2.create(),
	                applyForce_u = vec2.create(),
	                applyForce_f = vec2.create(),
	                applyForce_worldAnchorA = vec2.create(),
	                applyForce_worldAnchorB = vec2.create(),
	                applyForce_ri = vec2.create(),
	                applyForce_rj = vec2.create(),
	                applyForce_tmp = vec2.create();
	
	            /**
	             * Apply the spring force to the connected bodies.
	             * @method applyForce
	             */
	            LinearSpring.prototype.applyForce = function () {
	                var k = this.stiffness,
	                    d = this.damping,
	                    l = this.restLength,
	                    bodyA = this.bodyA,
	                    bodyB = this.bodyB,
	                    r = applyForce_r,
	                    r_unit = applyForce_r_unit,
	                    u = applyForce_u,
	                    f = applyForce_f,
	                    tmp = applyForce_tmp;
	
	                var worldAnchorA = applyForce_worldAnchorA,
	                    worldAnchorB = applyForce_worldAnchorB,
	                    ri = applyForce_ri,
	                    rj = applyForce_rj;
	
	                // Get world anchors
	                this.getWorldAnchorA(worldAnchorA);
	                this.getWorldAnchorB(worldAnchorB);
	
	                // Get offset points
	                vec2.sub(ri, worldAnchorA, bodyA.position);
	                vec2.sub(rj, worldAnchorB, bodyB.position);
	
	                // Compute distance vector between world anchor points
	                vec2.sub(r, worldAnchorB, worldAnchorA);
	                var rlen = vec2.len(r);
	                vec2.normalize(r_unit, r);
	
	                //console.log(rlen)
	                //console.log("A",vec2.str(worldAnchorA),"B",vec2.str(worldAnchorB))
	
	                // Compute relative velocity of the anchor points, u
	                vec2.sub(u, bodyB.velocity, bodyA.velocity);
	                vec2.crossZV(tmp, bodyB.angularVelocity, rj);
	                vec2.add(u, u, tmp);
	                vec2.crossZV(tmp, bodyA.angularVelocity, ri);
	                vec2.sub(u, u, tmp);
	
	                // F = - k * ( x - L ) - D * ( u )
	                vec2.scale(f, r_unit, -k * (rlen - l) - d * vec2.dot(u, r_unit));
	
	                // Add forces to bodies
	                vec2.sub(bodyA.force, bodyA.force, f);
	                vec2.add(bodyB.force, bodyB.force, f);
	
	                // Angular force
	                var ri_x_f = vec2.crossLength(ri, f);
	                var rj_x_f = vec2.crossLength(rj, f);
	                bodyA.angularForce -= ri_x_f;
	                bodyB.angularForce += rj_x_f;
	            };
	        }, { "../math/vec2": 30, "../utils/Utils": 57, "./Spring": 34 }], 33: [function (_dereq_, module, exports) {
	            var vec2 = _dereq_('../math/vec2');
	            var Spring = _dereq_('./Spring');
	
	            module.exports = RotationalSpring;
	
	            /**
	             * A rotational spring, connecting two bodies rotation. This spring explicitly adds angularForce (torque) to the bodies.
	             *
	             * The spring can be combined with a {{#crossLink "RevoluteConstraint"}}{{/crossLink}} to make, for example, a mouse trap.
	             *
	             * @class RotationalSpring
	             * @extends Spring
	             * @constructor
	             * @param {Body} bodyA
	             * @param {Body} bodyB
	             * @param {Object} [options]
	             * @param {number} [options.restAngle] The relative angle of bodies at which the spring is at rest. If not given, it's set to the current relative angle between the bodies.
	             * @param {number} [options.stiffness=100] Spring constant (see Hookes Law). A number >= 0.
	             * @param {number} [options.damping=1] A number >= 0.
	             */
	            function RotationalSpring(bodyA, bodyB, options) {
	                options = options || {};
	
	                Spring.call(this, bodyA, bodyB, options);
	
	                /**
	                 * Rest angle of the spring.
	                 * @property restAngle
	                 * @type {number}
	                 */
	                this.restAngle = typeof options.restAngle === "number" ? options.restAngle : bodyB.angle - bodyA.angle;
	            }
	            RotationalSpring.prototype = new Spring();
	            RotationalSpring.prototype.constructor = RotationalSpring;
	
	            /**
	             * Apply the spring force to the connected bodies.
	             * @method applyForce
	             */
	            RotationalSpring.prototype.applyForce = function () {
	                var k = this.stiffness,
	                    d = this.damping,
	                    l = this.restAngle,
	                    bodyA = this.bodyA,
	                    bodyB = this.bodyB,
	                    x = bodyB.angle - bodyA.angle,
	                    u = bodyB.angularVelocity - bodyA.angularVelocity;
	
	                var torque = -k * (x - l) - d * u * 0;
	
	                bodyA.angularForce -= torque;
	                bodyB.angularForce += torque;
	            };
	        }, { "../math/vec2": 30, "./Spring": 34 }], 34: [function (_dereq_, module, exports) {
	            var vec2 = _dereq_('../math/vec2');
	            var Utils = _dereq_('../utils/Utils');
	
	            module.exports = Spring;
	
	            /**
	             * A spring, connecting two bodies. The Spring explicitly adds force and angularForce to the bodies and does therefore not put load on the constraint solver.
	             *
	             * @class Spring
	             * @constructor
	             * @param {Body} bodyA
	             * @param {Body} bodyB
	             * @param {Object} [options]
	             * @param {number} [options.stiffness=100]  Spring constant (see Hookes Law). A number >= 0.
	             * @param {number} [options.damping=1]      A number >= 0. Default: 1
	             * @param {Array}  [options.localAnchorA]   Where to hook the spring to body A, in local body coordinates. Defaults to the body center.
	             * @param {Array}  [options.localAnchorB]
	             * @param {Array}  [options.worldAnchorA]   Where to hook the spring to body A, in world coordinates. Overrides the option "localAnchorA" if given.
	             * @param {Array}  [options.worldAnchorB]
	             */
	            function Spring(bodyA, bodyB, options) {
	                options = Utils.defaults(options, {
	                    stiffness: 100,
	                    damping: 1
	                });
	
	                /**
	                 * Stiffness of the spring.
	                 * @property stiffness
	                 * @type {number}
	                 */
	                this.stiffness = options.stiffness;
	
	                /**
	                 * Damping of the spring.
	                 * @property damping
	                 * @type {number}
	                 */
	                this.damping = options.damping;
	
	                /**
	                 * First connected body.
	                 * @property bodyA
	                 * @type {Body}
	                 */
	                this.bodyA = bodyA;
	
	                /**
	                 * Second connected body.
	                 * @property bodyB
	                 * @type {Body}
	                 */
	                this.bodyB = bodyB;
	            }
	
	            /**
	             * Apply the spring force to the connected bodies.
	             * @method applyForce
	             */
	            Spring.prototype.applyForce = function () {
	                // To be implemented by subclasses
	            };
	        }, { "../math/vec2": 30, "../utils/Utils": 57 }], 35: [function (_dereq_, module, exports) {
	            var vec2 = _dereq_('../math/vec2');
	            var Utils = _dereq_('../utils/Utils');
	            var Constraint = _dereq_('../constraints/Constraint');
	            var FrictionEquation = _dereq_('../equations/FrictionEquation');
	            var Body = _dereq_('../objects/Body');
	
	            module.exports = TopDownVehicle;
	
	            /**
	             * @class TopDownVehicle
	             * @constructor
	             * @param {Body} chassisBody A dynamic body, already added to the world.
	             * @param {Object} [options]
	             *
	             * @example
	             *
	             *     // Create a dynamic body for the chassis
	             *     var chassisBody = new Body({
	             *         mass: 1
	             *     });
	             *     var boxShape = new Box({ width: 0.5, height: 1 });
	             *     chassisBody.addShape(boxShape);
	             *     world.addBody(chassisBody);
	             *
	             *     // Create the vehicle
	             *     var vehicle = new TopDownVehicle(chassisBody);
	             *
	             *     // Add one front wheel and one back wheel - we don't actually need four :)
	             *     var frontWheel = vehicle.addWheel({
	             *         localPosition: [0, 0.5] // front
	             *     });
	             *     frontWheel.setSideFriction(4);
	             *
	             *     // Back wheel
	             *     var backWheel = vehicle.addWheel({
	             *         localPosition: [0, -0.5] // back
	             *     });
	             *     backWheel.setSideFriction(3); // Less side friction on back wheel makes it easier to drift
	             *     vehicle.addToWorld(world);
	             *
	             *     // Steer value zero means straight forward. Positive is left and negative right.
	             *     frontWheel.steerValue = Math.PI / 16;
	             *
	             *     // Engine force forward
	             *     backWheel.engineForce = 10;
	             *     backWheel.setBrakeForce(0);
	             */
	            function TopDownVehicle(chassisBody, options) {
	                options = options || {};
	
	                /**
	                 * @property {Body} chassisBody
	                 */
	                this.chassisBody = chassisBody;
	
	                /**
	                 * @property {Array} wheels
	                 */
	                this.wheels = [];
	
	                // A dummy body to constrain the chassis to
	                this.groundBody = new Body({ mass: 0 });
	
	                this.world = null;
	
	                var that = this;
	                this.preStepCallback = function () {
	                    that.update();
	                };
	            }
	
	            /**
	             * @method addToWorld
	             * @param {World} world
	             */
	            TopDownVehicle.prototype.addToWorld = function (world) {
	                this.world = world;
	                world.addBody(this.groundBody);
	                world.on('preStep', this.preStepCallback);
	                for (var i = 0; i < this.wheels.length; i++) {
	                    var wheel = this.wheels[i];
	                    world.addConstraint(wheel);
	                }
	            };
	
	            /**
	             * @method removeFromWorld
	             * @param {World} world
	             */
	            TopDownVehicle.prototype.removeFromWorld = function () {
	                var world = this.world;
	                world.removeBody(this.groundBody);
	                world.off('preStep', this.preStepCallback);
	                for (var i = 0; i < this.wheels.length; i++) {
	                    var wheel = this.wheels[i];
	                    world.removeConstraint(wheel);
	                }
	                this.world = null;
	            };
	
	            /**
	             * @method addWheel
	             * @param {object} [wheelOptions]
	             * @return {WheelConstraint}
	             */
	            TopDownVehicle.prototype.addWheel = function (wheelOptions) {
	                var wheel = new WheelConstraint(this, wheelOptions);
	                this.wheels.push(wheel);
	                return wheel;
	            };
	
	            /**
	             * @method update
	             */
	            TopDownVehicle.prototype.update = function () {
	                for (var i = 0; i < this.wheels.length; i++) {
	                    this.wheels[i].update();
	                }
	            };
	
	            /**
	             * @class WheelConstraint
	             * @constructor
	             * @extends {Constraint}
	             * @param {Vehicle} vehicle
	             * @param {object} [options]
	             * @param {Array} [options.localForwardVector]The local wheel forward vector in local body space. Default is zero.
	             * @param {Array} [options.localPosition] The local position of the wheen in the chassis body. Default is zero - the center of the body.
	             * @param {Array} [options.sideFriction=5] The max friction force in the sideways direction.
	             */
	            function WheelConstraint(vehicle, options) {
	                options = options || {};
	
	                this.vehicle = vehicle;
	
	                this.forwardEquation = new FrictionEquation(vehicle.chassisBody, vehicle.groundBody);
	
	                this.sideEquation = new FrictionEquation(vehicle.chassisBody, vehicle.groundBody);
	
	                /**
	                 * @property {number} steerValue
	                 */
	                this.steerValue = 0;
	
	                /**
	                 * @property {number} engineForce
	                 */
	                this.engineForce = 0;
	
	                this.setSideFriction(options.sideFriction !== undefined ? options.sideFriction : 5);
	
	                /**
	                 * @property {Array} localForwardVector
	                 */
	                this.localForwardVector = vec2.fromValues(0, 1);
	                if (options.localForwardVector) {
	                    vec2.copy(this.localForwardVector, options.localForwardVector);
	                }
	
	                /**
	                 * @property {Array} localPosition
	                 */
	                this.localPosition = vec2.fromValues(0, 0);
	                if (options.localPosition) {
	                    vec2.copy(this.localPosition, options.localPosition);
	                }
	
	                Constraint.apply(this, vehicle.chassisBody, vehicle.groundBody);
	
	                this.equations.push(this.forwardEquation, this.sideEquation);
	
	                this.setBrakeForce(0);
	            }
	            WheelConstraint.prototype = new Constraint();
	
	            /**
	             * @method setForwardFriction
	             */
	            WheelConstraint.prototype.setBrakeForce = function (force) {
	                this.forwardEquation.setSlipForce(force);
	            };
	
	            /**
	             * @method setSideFriction
	             */
	            WheelConstraint.prototype.setSideFriction = function (force) {
	                this.sideEquation.setSlipForce(force);
	            };
	
	            var worldVelocity = vec2.create();
	            var relativePoint = vec2.create();
	
	            /**
	             * @method getSpeed
	             */
	            WheelConstraint.prototype.getSpeed = function () {
	                this.vehicle.chassisBody.vectorToWorldFrame(relativePoint, this.localForwardVector);
	                this.vehicle.chassisBody.getVelocityAtPoint(worldVelocity, relativePoint);
	                return vec2.dot(worldVelocity, relativePoint);
	            };
	
	            var tmpVec = vec2.create();
	
	            /**
	             * @method update
	             */
	            WheelConstraint.prototype.update = function () {
	
	                // Directional
	                this.vehicle.chassisBody.vectorToWorldFrame(this.forwardEquation.t, this.localForwardVector);
	                vec2.rotate(this.sideEquation.t, this.localForwardVector, Math.PI / 2);
	                this.vehicle.chassisBody.vectorToWorldFrame(this.sideEquation.t, this.sideEquation.t);
	
	                vec2.rotate(this.forwardEquation.t, this.forwardEquation.t, this.steerValue);
	                vec2.rotate(this.sideEquation.t, this.sideEquation.t, this.steerValue);
	
	                // Attachment point
	                this.vehicle.chassisBody.toWorldFrame(this.forwardEquation.contactPointB, this.localPosition);
	                vec2.copy(this.sideEquation.contactPointB, this.forwardEquation.contactPointB);
	
	                this.vehicle.chassisBody.vectorToWorldFrame(this.forwardEquation.contactPointA, this.localPosition);
	                vec2.copy(this.sideEquation.contactPointA, this.forwardEquation.contactPointA);
	
	                // Add engine force
	                vec2.normalize(tmpVec, this.forwardEquation.t);
	                vec2.scale(tmpVec, tmpVec, this.engineForce);
	
	                this.vehicle.chassisBody.applyForce(tmpVec, this.forwardEquation.contactPointA);
	            };
	        }, { "../constraints/Constraint": 14, "../equations/FrictionEquation": 23, "../math/vec2": 30, "../objects/Body": 31, "../utils/Utils": 57 }], 36: [function (_dereq_, module, exports) {
	            // Export p2 classes
	            var p2 = module.exports = {
	                AABB: _dereq_('./collision/AABB'),
	                AngleLockEquation: _dereq_('./equations/AngleLockEquation'),
	                Body: _dereq_('./objects/Body'),
	                Broadphase: _dereq_('./collision/Broadphase'),
	                Capsule: _dereq_('./shapes/Capsule'),
	                Circle: _dereq_('./shapes/Circle'),
	                Constraint: _dereq_('./constraints/Constraint'),
	                ContactEquation: _dereq_('./equations/ContactEquation'),
	                ContactEquationPool: _dereq_('./utils/ContactEquationPool'),
	                ContactMaterial: _dereq_('./material/ContactMaterial'),
	                Convex: _dereq_('./shapes/Convex'),
	                DistanceConstraint: _dereq_('./constraints/DistanceConstraint'),
	                Equation: _dereq_('./equations/Equation'),
	                EventEmitter: _dereq_('./events/EventEmitter'),
	                FrictionEquation: _dereq_('./equations/FrictionEquation'),
	                FrictionEquationPool: _dereq_('./utils/FrictionEquationPool'),
	                GearConstraint: _dereq_('./constraints/GearConstraint'),
	                GSSolver: _dereq_('./solver/GSSolver'),
	                Heightfield: _dereq_('./shapes/Heightfield'),
	                Line: _dereq_('./shapes/Line'),
	                LockConstraint: _dereq_('./constraints/LockConstraint'),
	                Material: _dereq_('./material/Material'),
	                Narrowphase: _dereq_('./collision/Narrowphase'),
	                NaiveBroadphase: _dereq_('./collision/NaiveBroadphase'),
	                Particle: _dereq_('./shapes/Particle'),
	                Plane: _dereq_('./shapes/Plane'),
	                Pool: _dereq_('./utils/Pool'),
	                RevoluteConstraint: _dereq_('./constraints/RevoluteConstraint'),
	                PrismaticConstraint: _dereq_('./constraints/PrismaticConstraint'),
	                Ray: _dereq_('./collision/Ray'),
	                RaycastResult: _dereq_('./collision/RaycastResult'),
	                Box: _dereq_('./shapes/Box'),
	                RotationalVelocityEquation: _dereq_('./equations/RotationalVelocityEquation'),
	                SAPBroadphase: _dereq_('./collision/SAPBroadphase'),
	                Shape: _dereq_('./shapes/Shape'),
	                Solver: _dereq_('./solver/Solver'),
	                Spring: _dereq_('./objects/Spring'),
	                TopDownVehicle: _dereq_('./objects/TopDownVehicle'),
	                LinearSpring: _dereq_('./objects/LinearSpring'),
	                RotationalSpring: _dereq_('./objects/RotationalSpring'),
	                Utils: _dereq_('./utils/Utils'),
	                World: _dereq_('./world/World'),
	                vec2: _dereq_('./math/vec2'),
	                version: _dereq_('../package.json').version
	            };
	
	            Object.defineProperty(p2, 'Rectangle', {
	                get: function get() {
	                    console.warn('The Rectangle class has been renamed to Box.');
	                    return this.Box;
	                }
	            });
	        }, { "../package.json": 6, "./collision/AABB": 7, "./collision/Broadphase": 8, "./collision/NaiveBroadphase": 9, "./collision/Narrowphase": 10, "./collision/Ray": 11, "./collision/RaycastResult": 12, "./collision/SAPBroadphase": 13, "./constraints/Constraint": 14, "./constraints/DistanceConstraint": 15, "./constraints/GearConstraint": 16, "./constraints/LockConstraint": 17, "./constraints/PrismaticConstraint": 18, "./constraints/RevoluteConstraint": 19, "./equations/AngleLockEquation": 20, "./equations/ContactEquation": 21, "./equations/Equation": 22, "./equations/FrictionEquation": 23, "./equations/RotationalVelocityEquation": 25, "./events/EventEmitter": 26, "./material/ContactMaterial": 27, "./material/Material": 28, "./math/vec2": 30, "./objects/Body": 31, "./objects/LinearSpring": 32, "./objects/RotationalSpring": 33, "./objects/Spring": 34, "./objects/TopDownVehicle": 35, "./shapes/Box": 37, "./shapes/Capsule": 38, "./shapes/Circle": 39, "./shapes/Convex": 40, "./shapes/Heightfield": 41, "./shapes/Line": 42, "./shapes/Particle": 43, "./shapes/Plane": 44, "./shapes/Shape": 45, "./solver/GSSolver": 46, "./solver/Solver": 47, "./utils/ContactEquationPool": 48, "./utils/FrictionEquationPool": 49, "./utils/Pool": 55, "./utils/Utils": 57, "./world/World": 61 }], 37: [function (_dereq_, module, exports) {
	            var vec2 = _dereq_('../math/vec2'),
	                Shape = _dereq_('./Shape'),
	                Convex = _dereq_('./Convex');
	
	            module.exports = Box;
	
	            /**
	             * Box shape class.
	             * @class Box
	             * @constructor
	             * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
	             * @param {Number} [options.width=1] Total width of the box
	             * @param {Number} [options.height=1] Total height of the box
	             * @extends Convex
	             */
	            function Box(options) {
	                if (typeof arguments[0] === 'number' && typeof arguments[1] === 'number') {
	                    options = {
	                        width: arguments[0],
	                        height: arguments[1]
	                    };
	                    console.warn('The Rectangle has been renamed to Box and its constructor signature has changed. Please use the following format: new Box({ width: 1, height: 1, ... })');
	                }
	                options = options || {};
	
	                /**
	                 * Total width of the box
	                 * @property width
	                 * @type {Number}
	                 */
	                var width = this.width = options.width || 1;
	
	                /**
	                 * Total height of the box
	                 * @property height
	                 * @type {Number}
	                 */
	                var height = this.height = options.height || 1;
	
	                var verts = [vec2.fromValues(-width / 2, -height / 2), vec2.fromValues(width / 2, -height / 2), vec2.fromValues(width / 2, height / 2), vec2.fromValues(-width / 2, height / 2)];
	                var axes = [vec2.fromValues(1, 0), vec2.fromValues(0, 1)];
	
	                options.vertices = verts;
	                options.axes = axes;
	                options.type = Shape.BOX;
	                Convex.call(this, options);
	            }
	            Box.prototype = new Convex();
	            Box.prototype.constructor = Box;
	
	            /**
	             * Compute moment of inertia
	             * @method computeMomentOfInertia
	             * @param  {Number} mass
	             * @return {Number}
	             */
	            Box.prototype.computeMomentOfInertia = function (mass) {
	                var w = this.width,
	                    h = this.height;
	                return mass * (h * h + w * w) / 12;
	            };
	
	            /**
	             * Update the bounding radius
	             * @method updateBoundingRadius
	             */
	            Box.prototype.updateBoundingRadius = function () {
	                var w = this.width,
	                    h = this.height;
	                this.boundingRadius = Math.sqrt(w * w + h * h) / 2;
	            };
	
	            var corner1 = vec2.create(),
	                corner2 = vec2.create(),
	                corner3 = vec2.create(),
	                corner4 = vec2.create();
	
	            /**
	             * @method computeAABB
	             * @param  {AABB}   out      The resulting AABB.
	             * @param  {Array}  position
	             * @param  {Number} angle
	             */
	            Box.prototype.computeAABB = function (out, position, angle) {
	                out.setFromPoints(this.vertices, position, angle, 0);
	            };
	
	            Box.prototype.updateArea = function () {
	                this.area = this.width * this.height;
	            };
	        }, { "../math/vec2": 30, "./Convex": 40, "./Shape": 45 }], 38: [function (_dereq_, module, exports) {
	            var Shape = _dereq_('./Shape'),
	                vec2 = _dereq_('../math/vec2');
	
	            module.exports = Capsule;
	
	            /**
	             * Capsule shape class.
	             * @class Capsule
	             * @constructor
	             * @extends Shape
	             * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
	             * @param {Number} [options.length=1] The distance between the end points
	             * @param {Number} [options.radius=1] Radius of the capsule
	             * @example
	             *     var capsuleShape = new Capsule({
	             *         length: 1,
	             *         radius: 2
	             *     });
	             *     body.addShape(capsuleShape);
	             */
	            function Capsule(options) {
	                if (typeof arguments[0] === 'number' && typeof arguments[1] === 'number') {
	                    options = {
	                        length: arguments[0],
	                        radius: arguments[1]
	                    };
	                    console.warn('The Capsule constructor signature has changed. Please use the following format: new Capsule({ radius: 1, length: 1 })');
	                }
	                options = options || {};
	
	                /**
	                 * The distance between the end points.
	                 * @property {Number} length
	                 */
	                this.length = options.length || 1;
	
	                /**
	                 * The radius of the capsule.
	                 * @property {Number} radius
	                 */
	                this.radius = options.radius || 1;
	
	                options.type = Shape.CAPSULE;
	                Shape.call(this, options);
	            }
	            Capsule.prototype = new Shape();
	            Capsule.prototype.constructor = Capsule;
	
	            /**
	             * Compute the mass moment of inertia of the Capsule.
	             * @method conputeMomentOfInertia
	             * @param  {Number} mass
	             * @return {Number}
	             * @todo
	             */
	            Capsule.prototype.computeMomentOfInertia = function (mass) {
	                // Approximate with rectangle
	                var r = this.radius,
	                    w = this.length + r,
	                    // 2*r is too much, 0 is too little
	                h = r * 2;
	                return mass * (h * h + w * w) / 12;
	            };
	
	            /**
	             * @method updateBoundingRadius
	             */
	            Capsule.prototype.updateBoundingRadius = function () {
	                this.boundingRadius = this.radius + this.length / 2;
	            };
	
	            /**
	             * @method updateArea
	             */
	            Capsule.prototype.updateArea = function () {
	                this.area = Math.PI * this.radius * this.radius + this.radius * 2 * this.length;
	            };
	
	            var r = vec2.create();
	
	            /**
	             * @method computeAABB
	             * @param  {AABB}   out      The resulting AABB.
	             * @param  {Array}  position
	             * @param  {Number} angle
	             */
	            Capsule.prototype.computeAABB = function (out, position, angle) {
	                var radius = this.radius;
	
	                // Compute center position of one of the the circles, world oriented, but with local offset
	                vec2.set(r, this.length / 2, 0);
	                if (angle !== 0) {
	                    vec2.rotate(r, r, angle);
	                }
	
	                // Get bounds
	                vec2.set(out.upperBound, Math.max(r[0] + radius, -r[0] + radius), Math.max(r[1] + radius, -r[1] + radius));
	                vec2.set(out.lowerBound, Math.min(r[0] - radius, -r[0] - radius), Math.min(r[1] - radius, -r[1] - radius));
	
	                // Add offset
	                vec2.add(out.lowerBound, out.lowerBound, position);
	                vec2.add(out.upperBound, out.upperBound, position);
	            };
	
	            var intersectCapsule_hitPointWorld = vec2.create();
	            var intersectCapsule_normal = vec2.create();
	            var intersectCapsule_l0 = vec2.create();
	            var intersectCapsule_l1 = vec2.create();
	            var intersectCapsule_unit_y = vec2.fromValues(0, 1);
	
	            /**
	             * @method raycast
	             * @param  {RaycastResult} result
	             * @param  {Ray} ray
	             * @param  {array} position
	             * @param  {number} angle
	             */
	            Capsule.prototype.raycast = function (result, ray, position, angle) {
	                var from = ray.from;
	                var to = ray.to;
	                var direction = ray.direction;
	
	                var hitPointWorld = intersectCapsule_hitPointWorld;
	                var normal = intersectCapsule_normal;
	                var l0 = intersectCapsule_l0;
	                var l1 = intersectCapsule_l1;
	
	                // The sides
	                var halfLen = this.length / 2;
	                for (var i = 0; i < 2; i++) {
	
	                    // get start and end of the line
	                    var y = this.radius * (i * 2 - 1);
	                    vec2.set(l0, -halfLen, y);
	                    vec2.set(l1, halfLen, y);
	                    vec2.toGlobalFrame(l0, l0, position, angle);
	                    vec2.toGlobalFrame(l1, l1, position, angle);
	
	                    var delta = vec2.getLineSegmentsIntersectionFraction(from, to, l0, l1);
	                    if (delta >= 0) {
	                        vec2.rotate(normal, intersectCapsule_unit_y, angle);
	                        vec2.scale(normal, normal, i * 2 - 1);
	                        ray.reportIntersection(result, delta, normal, -1);
	                        if (result.shouldStop(ray)) {
	                            return;
	                        }
	                    }
	                }
	
	                // Circles
	                var diagonalLengthSquared = Math.pow(this.radius, 2) + Math.pow(halfLen, 2);
	                for (var i = 0; i < 2; i++) {
	                    vec2.set(l0, halfLen * (i * 2 - 1), 0);
	                    vec2.toGlobalFrame(l0, l0, position, angle);
	
	                    var a = Math.pow(to[0] - from[0], 2) + Math.pow(to[1] - from[1], 2);
	                    var b = 2 * ((to[0] - from[0]) * (from[0] - l0[0]) + (to[1] - from[1]) * (from[1] - l0[1]));
	                    var c = Math.pow(from[0] - l0[0], 2) + Math.pow(from[1] - l0[1], 2) - Math.pow(this.radius, 2);
	                    var delta = Math.pow(b, 2) - 4 * a * c;
	
	                    if (delta < 0) {
	                        // No intersection
	                        continue;
	                    } else if (delta === 0) {
	                        // single intersection point
	                        vec2.lerp(hitPointWorld, from, to, delta);
	
	                        if (vec2.squaredDistance(hitPointWorld, position) > diagonalLengthSquared) {
	                            vec2.sub(normal, hitPointWorld, l0);
	                            vec2.normalize(normal, normal);
	                            ray.reportIntersection(result, delta, normal, -1);
	                            if (result.shouldStop(ray)) {
	                                return;
	                            }
	                        }
	                    } else {
	                        var sqrtDelta = Math.sqrt(delta);
	                        var inv2a = 1 / (2 * a);
	                        var d1 = (-b - sqrtDelta) * inv2a;
	                        var d2 = (-b + sqrtDelta) * inv2a;
	
	                        if (d1 >= 0 && d1 <= 1) {
	                            vec2.lerp(hitPointWorld, from, to, d1);
	                            if (vec2.squaredDistance(hitPointWorld, position) > diagonalLengthSquared) {
	                                vec2.sub(normal, hitPointWorld, l0);
	                                vec2.normalize(normal, normal);
	                                ray.reportIntersection(result, d1, normal, -1);
	                                if (result.shouldStop(ray)) {
	                                    return;
	                                }
	                            }
	                        }
	
	                        if (d2 >= 0 && d2 <= 1) {
	                            vec2.lerp(hitPointWorld, from, to, d2);
	                            if (vec2.squaredDistance(hitPointWorld, position) > diagonalLengthSquared) {
	                                vec2.sub(normal, hitPointWorld, l0);
	                                vec2.normalize(normal, normal);
	                                ray.reportIntersection(result, d2, normal, -1);
	                                if (result.shouldStop(ray)) {
	                                    return;
	                                }
	                            }
	                        }
	                    }
	                }
	            };
	        }, { "../math/vec2": 30, "./Shape": 45 }], 39: [function (_dereq_, module, exports) {
	            var Shape = _dereq_('./Shape'),
	                vec2 = _dereq_('../math/vec2');
	
	            module.exports = Circle;
	
	            /**
	             * Circle shape class.
	             * @class Circle
	             * @extends Shape
	             * @constructor
	             * @param {options} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
	             * @param {number} [options.radius=1] The radius of this circle
	             *
	             * @example
	             *     var circleShape = new Circle({ radius: 1 });
	             *     body.addShape(circleShape);
	             */
	            function Circle(options) {
	                if (typeof arguments[0] === 'number') {
	                    options = {
	                        radius: arguments[0]
	                    };
	                    console.warn('The Circle constructor signature has changed. Please use the following format: new Circle({ radius: 1 })');
	                }
	                options = options || {};
	
	                /**
	                 * The radius of the circle.
	                 * @property radius
	                 * @type {number}
	                 */
	                this.radius = options.radius || 1;
	
	                options.type = Shape.CIRCLE;
	                Shape.call(this, options);
	            }
	            Circle.prototype = new Shape();
	            Circle.prototype.constructor = Circle;
	
	            /**
	             * @method computeMomentOfInertia
	             * @param  {Number} mass
	             * @return {Number}
	             */
	            Circle.prototype.computeMomentOfInertia = function (mass) {
	                var r = this.radius;
	                return mass * r * r / 2;
	            };
	
	            /**
	             * @method updateBoundingRadius
	             * @return {Number}
	             */
	            Circle.prototype.updateBoundingRadius = function () {
	                this.boundingRadius = this.radius;
	            };
	
	            /**
	             * @method updateArea
	             * @return {Number}
	             */
	            Circle.prototype.updateArea = function () {
	                this.area = Math.PI * this.radius * this.radius;
	            };
	
	            /**
	             * @method computeAABB
	             * @param  {AABB}   out      The resulting AABB.
	             * @param  {Array}  position
	             * @param  {Number} angle
	             */
	            Circle.prototype.computeAABB = function (out, position, angle) {
	                var r = this.radius;
	                vec2.set(out.upperBound, r, r);
	                vec2.set(out.lowerBound, -r, -r);
	                if (position) {
	                    vec2.add(out.lowerBound, out.lowerBound, position);
	                    vec2.add(out.upperBound, out.upperBound, position);
	                }
	            };
	
	            var Ray_intersectSphere_intersectionPoint = vec2.create();
	            var Ray_intersectSphere_normal = vec2.create();
	
	            /**
	             * @method raycast
	             * @param  {RaycastResult} result
	             * @param  {Ray} ray
	             * @param  {array} position
	             * @param  {number} angle
	             */
	            Circle.prototype.raycast = function (result, ray, position, angle) {
	                var from = ray.from,
	                    to = ray.to,
	                    r = this.radius;
	
	                var a = Math.pow(to[0] - from[0], 2) + Math.pow(to[1] - from[1], 2);
	                var b = 2 * ((to[0] - from[0]) * (from[0] - position[0]) + (to[1] - from[1]) * (from[1] - position[1]));
	                var c = Math.pow(from[0] - position[0], 2) + Math.pow(from[1] - position[1], 2) - Math.pow(r, 2);
	                var delta = Math.pow(b, 2) - 4 * a * c;
	
	                var intersectionPoint = Ray_intersectSphere_intersectionPoint;
	                var normal = Ray_intersectSphere_normal;
	
	                if (delta < 0) {
	                    // No intersection
	                    return;
	                } else if (delta === 0) {
	                    // single intersection point
	                    vec2.lerp(intersectionPoint, from, to, delta);
	
	                    vec2.sub(normal, intersectionPoint, position);
	                    vec2.normalize(normal, normal);
	
	                    ray.reportIntersection(result, delta, normal, -1);
	                } else {
	                    var sqrtDelta = Math.sqrt(delta);
	                    var inv2a = 1 / (2 * a);
	                    var d1 = (-b - sqrtDelta) * inv2a;
	                    var d2 = (-b + sqrtDelta) * inv2a;
	
	                    if (d1 >= 0 && d1 <= 1) {
	                        vec2.lerp(intersectionPoint, from, to, d1);
	
	                        vec2.sub(normal, intersectionPoint, position);
	                        vec2.normalize(normal, normal);
	
	                        ray.reportIntersection(result, d1, normal, -1);
	
	                        if (result.shouldStop(ray)) {
	                            return;
	                        }
	                    }
	
	                    if (d2 >= 0 && d2 <= 1) {
	                        vec2.lerp(intersectionPoint, from, to, d2);
	
	                        vec2.sub(normal, intersectionPoint, position);
	                        vec2.normalize(normal, normal);
	
	                        ray.reportIntersection(result, d2, normal, -1);
	                    }
	                }
	            };
	        }, { "../math/vec2": 30, "./Shape": 45 }], 40: [function (_dereq_, module, exports) {
	            var Shape = _dereq_('./Shape'),
	                vec2 = _dereq_('../math/vec2'),
	                polyk = _dereq_('../math/polyk'),
	                decomp = _dereq_('poly-decomp');
	
	            module.exports = Convex;
	
	            /**
	             * Convex shape class.
	             * @class Convex
	             * @constructor
	             * @extends Shape
	             * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
	             * @param {Array} [options.vertices] An array of vertices that span this shape. Vertices are given in counter-clockwise (CCW) direction.
	             * @param {Array} [options.axes] An array of unit length vectors, representing the symmetry axes in the convex.
	             * @example
	             *     // Create a box
	             *     var vertices = [[-1,-1], [1,-1], [1,1], [-1,1]];
	             *     var convexShape = new Convex({ vertices: vertices });
	             *     body.addShape(convexShape);
	             */
	            function Convex(options) {
	                if (Array.isArray(arguments[0])) {
	                    options = {
	                        vertices: arguments[0],
	                        axes: arguments[1]
	                    };
	                    console.warn('The Convex constructor signature has changed. Please use the following format: new Convex({ vertices: [...], ... })');
	                }
	                options = options || {};
	
	                /**
	                 * Vertices defined in the local frame.
	                 * @property vertices
	                 * @type {Array}
	                 */
	                this.vertices = [];
	
	                // Copy the verts
	                var vertices = options.vertices !== undefined ? options.vertices : [];
	                for (var i = 0; i < vertices.length; i++) {
	                    var v = vec2.create();
	                    vec2.copy(v, vertices[i]);
	                    this.vertices.push(v);
	                }
	
	                /**
	                 * Axes defined in the local frame.
	                 * @property axes
	                 * @type {Array}
	                 */
	                this.axes = [];
	
	                if (options.axes) {
	
	                    // Copy the axes
	                    for (var i = 0; i < options.axes.length; i++) {
	                        var axis = vec2.create();
	                        vec2.copy(axis, options.axes[i]);
	                        this.axes.push(axis);
	                    }
	                } else {
	
	                    // Construct axes from the vertex data
	                    for (var i = 0; i < this.vertices.length; i++) {
	                        // Get the world edge
	                        var worldPoint0 = this.vertices[i];
	                        var worldPoint1 = this.vertices[(i + 1) % this.vertices.length];
	
	                        var normal = vec2.create();
	                        vec2.sub(normal, worldPoint1, worldPoint0);
	
	                        // Get normal - just rotate 90 degrees since vertices are given in CCW
	                        vec2.rotate90cw(normal, normal);
	                        vec2.normalize(normal, normal);
	
	                        this.axes.push(normal);
	                    }
	                }
	
	                /**
	                 * The center of mass of the Convex
	                 * @property centerOfMass
	                 * @type {Array}
	                 */
	                this.centerOfMass = vec2.fromValues(0, 0);
	
	                /**
	                 * Triangulated version of this convex. The structure is Array of 3-Arrays, and each subarray contains 3 integers, referencing the vertices.
	                 * @property triangles
	                 * @type {Array}
	                 */
	                this.triangles = [];
	
	                if (this.vertices.length) {
	                    this.updateTriangles();
	                    this.updateCenterOfMass();
	                }
	
	                /**
	                 * The bounding radius of the convex
	                 * @property boundingRadius
	                 * @type {Number}
	                 */
	                this.boundingRadius = 0;
	
	                options.type = Shape.CONVEX;
	                Shape.call(this, options);
	
	                this.updateBoundingRadius();
	                this.updateArea();
	                if (this.area < 0) {
	                    throw new Error("Convex vertices must be given in conter-clockwise winding.");
	                }
	            }
	            Convex.prototype = new Shape();
	            Convex.prototype.constructor = Convex;
	
	            var tmpVec1 = vec2.create();
	            var tmpVec2 = vec2.create();
	
	            /**
	             * Project a Convex onto a world-oriented axis
	             * @method projectOntoAxis
	             * @static
	             * @param  {Array} offset
	             * @param  {Array} localAxis
	             * @param  {Array} result
	             */
	            Convex.prototype.projectOntoLocalAxis = function (localAxis, result) {
	                var max = null,
	                    min = null,
	                    v,
	                    value,
	                    localAxis = tmpVec1;
	
	                // Get projected position of all vertices
	                for (var i = 0; i < this.vertices.length; i++) {
	                    v = this.vertices[i];
	                    value = vec2.dot(v, localAxis);
	                    if (max === null || value > max) {
	                        max = value;
	                    }
	                    if (min === null || value < min) {
	                        min = value;
	                    }
	                }
	
	                if (min > max) {
	                    var t = min;
	                    min = max;
	                    max = t;
	                }
	
	                vec2.set(result, min, max);
	            };
	
	            Convex.prototype.projectOntoWorldAxis = function (localAxis, shapeOffset, shapeAngle, result) {
	                var worldAxis = tmpVec2;
	
	                this.projectOntoLocalAxis(localAxis, result);
	
	                // Project the position of the body onto the axis - need to add this to the result
	                if (shapeAngle !== 0) {
	                    vec2.rotate(worldAxis, localAxis, shapeAngle);
	                } else {
	                    worldAxis = localAxis;
	                }
	                var offset = vec2.dot(shapeOffset, worldAxis);
	
	                vec2.set(result, result[0] + offset, result[1] + offset);
	            };
	
	            /**
	             * Update the .triangles property
	             * @method updateTriangles
	             */
	            Convex.prototype.updateTriangles = function () {
	
	                this.triangles.length = 0;
	
	                // Rewrite on polyk notation, array of numbers
	                var polykVerts = [];
	                for (var i = 0; i < this.vertices.length; i++) {
	                    var v = this.vertices[i];
	                    polykVerts.push(v[0], v[1]);
	                }
	
	                // Triangulate
	                var triangles = polyk.Triangulate(polykVerts);
	
	                // Loop over all triangles, add their inertia contributions to I
	                for (var i = 0; i < triangles.length; i += 3) {
	                    var id1 = triangles[i],
	                        id2 = triangles[i + 1],
	                        id3 = triangles[i + 2];
	
	                    // Add to triangles
	                    this.triangles.push([id1, id2, id3]);
	                }
	            };
	
	            var updateCenterOfMass_centroid = vec2.create(),
	                updateCenterOfMass_centroid_times_mass = vec2.create(),
	                updateCenterOfMass_a = vec2.create(),
	                updateCenterOfMass_b = vec2.create(),
	                updateCenterOfMass_c = vec2.create(),
	                updateCenterOfMass_ac = vec2.create(),
	                updateCenterOfMass_ca = vec2.create(),
	                updateCenterOfMass_cb = vec2.create(),
	                updateCenterOfMass_n = vec2.create();
	
	            /**
	             * Update the .centerOfMass property.
	             * @method updateCenterOfMass
	             */
	            Convex.prototype.updateCenterOfMass = function () {
	                var triangles = this.triangles,
	                    verts = this.vertices,
	                    cm = this.centerOfMass,
	                    centroid = updateCenterOfMass_centroid,
	                    n = updateCenterOfMass_n,
	                    a = updateCenterOfMass_a,
	                    b = updateCenterOfMass_b,
	                    c = updateCenterOfMass_c,
	                    ac = updateCenterOfMass_ac,
	                    ca = updateCenterOfMass_ca,
	                    cb = updateCenterOfMass_cb,
	                    centroid_times_mass = updateCenterOfMass_centroid_times_mass;
	
	                vec2.set(cm, 0, 0);
	                var totalArea = 0;
	
	                for (var i = 0; i !== triangles.length; i++) {
	                    var t = triangles[i],
	                        a = verts[t[0]],
	                        b = verts[t[1]],
	                        c = verts[t[2]];
	
	                    vec2.centroid(centroid, a, b, c);
	
	                    // Get mass for the triangle (density=1 in this case)
	                    // http://math.stackexchange.com/questions/80198/area-of-triangle-via-vectors
	                    var m = Convex.triangleArea(a, b, c);
	                    totalArea += m;
	
	                    // Add to center of mass
	                    vec2.scale(centroid_times_mass, centroid, m);
	                    vec2.add(cm, cm, centroid_times_mass);
	                }
	
	                vec2.scale(cm, cm, 1 / totalArea);
	            };
	
	            /**
	             * Compute the mass moment of inertia of the Convex.
	             * @method computeMomentOfInertia
	             * @param  {Number} mass
	             * @return {Number}
	             * @see http://www.gamedev.net/topic/342822-moment-of-inertia-of-a-polygon-2d/
	             */
	            Convex.prototype.computeMomentOfInertia = function (mass) {
	                var denom = 0.0,
	                    numer = 0.0,
	                    N = this.vertices.length;
	                for (var j = N - 1, i = 0; i < N; j = i, i++) {
	                    var p0 = this.vertices[j];
	                    var p1 = this.vertices[i];
	                    var a = Math.abs(vec2.crossLength(p0, p1));
	                    var b = vec2.dot(p1, p1) + vec2.dot(p1, p0) + vec2.dot(p0, p0);
	                    denom += a * b;
	                    numer += a;
	                }
	                return mass / 6.0 * (denom / numer);
	            };
	
	            /**
	             * Updates the .boundingRadius property
	             * @method updateBoundingRadius
	             */
	            Convex.prototype.updateBoundingRadius = function () {
	                var verts = this.vertices,
	                    r2 = 0;
	
	                for (var i = 0; i !== verts.length; i++) {
	                    var l2 = vec2.squaredLength(verts[i]);
	                    if (l2 > r2) {
	                        r2 = l2;
	                    }
	                }
	
	                this.boundingRadius = Math.sqrt(r2);
	            };
	
	            /**
	             * Get the area of the triangle spanned by the three points a, b, c. The area is positive if the points are given in counter-clockwise order, otherwise negative.
	             * @static
	             * @method triangleArea
	             * @param {Array} a
	             * @param {Array} b
	             * @param {Array} c
	             * @return {Number}
	             */
	            Convex.triangleArea = function (a, b, c) {
	                return ((b[0] - a[0]) * (c[1] - a[1]) - (c[0] - a[0]) * (b[1] - a[1])) * 0.5;
	            };
	
	            /**
	             * Update the .area
	             * @method updateArea
	             */
	            Convex.prototype.updateArea = function () {
	                this.updateTriangles();
	                this.area = 0;
	
	                var triangles = this.triangles,
	                    verts = this.vertices;
	                for (var i = 0; i !== triangles.length; i++) {
	                    var t = triangles[i],
	                        a = verts[t[0]],
	                        b = verts[t[1]],
	                        c = verts[t[2]];
	
	                    // Get mass for the triangle (density=1 in this case)
	                    var m = Convex.triangleArea(a, b, c);
	                    this.area += m;
	                }
	            };
	
	            /**
	             * @method computeAABB
	             * @param  {AABB}   out
	             * @param  {Array}  position
	             * @param  {Number} angle
	             */
	            Convex.prototype.computeAABB = function (out, position, angle) {
	                out.setFromPoints(this.vertices, position, angle, 0);
	            };
	
	            var intersectConvex_rayStart = vec2.create();
	            var intersectConvex_rayEnd = vec2.create();
	            var intersectConvex_normal = vec2.create();
	
	            /**
	             * @method raycast
	             * @param  {RaycastResult} result
	             * @param  {Ray} ray
	             * @param  {array} position
	             * @param  {number} angle
	             */
	            Convex.prototype.raycast = function (result, ray, position, angle) {
	                var rayStart = intersectConvex_rayStart;
	                var rayEnd = intersectConvex_rayEnd;
	                var normal = intersectConvex_normal;
	                var vertices = this.vertices;
	
	                // Transform to local shape space
	                vec2.toLocalFrame(rayStart, ray.from, position, angle);
	                vec2.toLocalFrame(rayEnd, ray.to, position, angle);
	
	                var n = vertices.length;
	
	                for (var i = 0; i < n && !result.shouldStop(ray); i++) {
	                    var q1 = vertices[i];
	                    var q2 = vertices[(i + 1) % n];
	                    var delta = vec2.getLineSegmentsIntersectionFraction(rayStart, rayEnd, q1, q2);
	
	                    if (delta >= 0) {
	                        vec2.sub(normal, q2, q1);
	                        vec2.rotate(normal, normal, -Math.PI / 2 + angle);
	                        vec2.normalize(normal, normal);
	                        ray.reportIntersection(result, delta, normal, i);
	                    }
	                }
	            };
	        }, { "../math/polyk": 29, "../math/vec2": 30, "./Shape": 45, "poly-decomp": 5 }], 41: [function (_dereq_, module, exports) {
	            var Shape = _dereq_('./Shape'),
	                vec2 = _dereq_('../math/vec2'),
	                Utils = _dereq_('../utils/Utils');
	
	            module.exports = Heightfield;
	
	            /**
	             * Heightfield shape class. Height data is given as an array. These data points are spread out evenly with a distance "elementWidth".
	             * @class Heightfield
	             * @extends Shape
	             * @constructor
	             * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
	             * @param {array} [options.heights] An array of Y values that will be used to construct the terrain.
	             * @param {Number} [options.minValue] Minimum value of the data points in the data array. Will be computed automatically if not given.
	             * @param {Number} [options.maxValue] Maximum value.
	             * @param {Number} [options.elementWidth=0.1] World spacing between the data points in X direction.
	             *
	             * @example
	             *     // Generate some height data (y-values).
	             *     var heights = [];
	             *     for(var i = 0; i < 1000; i++){
	             *         var y = 0.5 * Math.cos(0.2 * i);
	             *         heights.push(y);
	             *     }
	             *
	             *     // Create the heightfield shape
	             *     var heightfieldShape = new Heightfield({
	             *         heights: heights,
	             *         elementWidth: 1 // Distance between the data points in X direction
	             *     });
	             *     var heightfieldBody = new Body();
	             *     heightfieldBody.addShape(heightfieldShape);
	             *     world.addBody(heightfieldBody);
	             *
	             * @todo Should use a scale property with X and Y direction instead of just elementWidth
	             */
	            function Heightfield(options) {
	                if (Array.isArray(arguments[0])) {
	                    options = {
	                        heights: arguments[0]
	                    };
	
	                    if (_typeof(arguments[1]) === 'object') {
	                        for (var key in arguments[1]) {
	                            options[key] = arguments[1][key];
	                        }
	                    }
	
	                    console.warn('The Heightfield constructor signature has changed. Please use the following format: new Heightfield({ heights: [...], ... })');
	                }
	                options = options || {};
	
	                /**
	                 * An array of numbers, or height values, that are spread out along the x axis.
	                 * @property {array} heights
	                 */
	                this.heights = options.heights ? options.heights.slice(0) : [];
	
	                /**
	                 * Max value of the heights
	                 * @property {number} maxValue
	                 */
	                this.maxValue = options.maxValue || null;
	
	                /**
	                 * Max value of the heights
	                 * @property {number} minValue
	                 */
	                this.minValue = options.minValue || null;
	
	                /**
	                 * The width of each element
	                 * @property {number} elementWidth
	                 */
	                this.elementWidth = options.elementWidth || 0.1;
	
	                if (options.maxValue === undefined || options.minValue === undefined) {
	                    this.updateMaxMinValues();
	                }
	
	                options.type = Shape.HEIGHTFIELD;
	                Shape.call(this, options);
	            }
	            Heightfield.prototype = new Shape();
	            Heightfield.prototype.constructor = Heightfield;
	
	            /**
	             * Update the .minValue and the .maxValue
	             * @method updateMaxMinValues
	             */
	            Heightfield.prototype.updateMaxMinValues = function () {
	                var data = this.heights;
	                var maxValue = data[0];
	                var minValue = data[0];
	                for (var i = 0; i !== data.length; i++) {
	                    var v = data[i];
	                    if (v > maxValue) {
	                        maxValue = v;
	                    }
	                    if (v < minValue) {
	                        minValue = v;
	                    }
	                }
	                this.maxValue = maxValue;
	                this.minValue = minValue;
	            };
	
	            /**
	             * @method computeMomentOfInertia
	             * @param  {Number} mass
	             * @return {Number}
	             */
	            Heightfield.prototype.computeMomentOfInertia = function (mass) {
	                return Number.MAX_VALUE;
	            };
	
	            Heightfield.prototype.updateBoundingRadius = function () {
	                this.boundingRadius = Number.MAX_VALUE;
	            };
	
	            Heightfield.prototype.updateArea = function () {
	                var data = this.heights,
	                    area = 0;
	                for (var i = 0; i < data.length - 1; i++) {
	                    area += (data[i] + data[i + 1]) / 2 * this.elementWidth;
	                }
	                this.area = area;
	            };
	
	            var points = [vec2.create(), vec2.create(), vec2.create(), vec2.create()];
	
	            /**
	             * @method computeAABB
	             * @param  {AABB}   out      The resulting AABB.
	             * @param  {Array}  position
	             * @param  {Number} angle
	             */
	            Heightfield.prototype.computeAABB = function (out, position, angle) {
	                vec2.set(points[0], 0, this.maxValue);
	                vec2.set(points[1], this.elementWidth * this.heights.length, this.maxValue);
	                vec2.set(points[2], this.elementWidth * this.heights.length, this.minValue);
	                vec2.set(points[3], 0, this.minValue);
	                out.setFromPoints(points, position, angle);
	            };
	
	            /**
	             * Get a line segment in the heightfield
	             * @method getLineSegment
	             * @param  {array} start Where to store the resulting start point
	             * @param  {array} end Where to store the resulting end point
	             * @param  {number} i
	             */
	            Heightfield.prototype.getLineSegment = function (start, end, i) {
	                var data = this.heights;
	                var width = this.elementWidth;
	                vec2.set(start, i * width, data[i]);
	                vec2.set(end, (i + 1) * width, data[i + 1]);
	            };
	
	            Heightfield.prototype.getSegmentIndex = function (position) {
	                return Math.floor(position[0] / this.elementWidth);
	            };
	
	            Heightfield.prototype.getClampedSegmentIndex = function (position) {
	                var i = this.getSegmentIndex(position);
	                i = Math.min(this.heights.length, Math.max(i, 0)); // clamp
	                return i;
	            };
	
	            var intersectHeightfield_hitPointWorld = vec2.create();
	            var intersectHeightfield_worldNormal = vec2.create();
	            var intersectHeightfield_l0 = vec2.create();
	            var intersectHeightfield_l1 = vec2.create();
	            var intersectHeightfield_localFrom = vec2.create();
	            var intersectHeightfield_localTo = vec2.create();
	            var intersectHeightfield_unit_y = vec2.fromValues(0, 1);
	
	            // Returns 1 if the lines intersect, otherwise 0.
	            function getLineSegmentsIntersection(out, p0, p1, p2, p3) {
	
	                var s1_x, s1_y, s2_x, s2_y;
	                s1_x = p1[0] - p0[0];
	                s1_y = p1[1] - p0[1];
	                s2_x = p3[0] - p2[0];
	                s2_y = p3[1] - p2[1];
	
	                var s, t;
	                s = (-s1_y * (p0[0] - p2[0]) + s1_x * (p0[1] - p2[1])) / (-s2_x * s1_y + s1_x * s2_y);
	                t = (s2_x * (p0[1] - p2[1]) - s2_y * (p0[0] - p2[0])) / (-s2_x * s1_y + s1_x * s2_y);
	                if (s >= 0 && s <= 1 && t >= 0 && t <= 1) {
	                    // Collision detected
	                    var intX = p0[0] + t * s1_x;
	                    var intY = p0[1] + t * s1_y;
	                    out[0] = intX;
	                    out[1] = intY;
	                    return t;
	                }
	                return -1; // No collision
	            }
	
	            /**
	             * @method raycast
	             * @param  {RayResult} result
	             * @param  {Ray} ray
	             * @param  {array} position
	             * @param  {number} angle
	             */
	            Heightfield.prototype.raycast = function (result, ray, position, angle) {
	                var from = ray.from;
	                var to = ray.to;
	                var direction = ray.direction;
	
	                var hitPointWorld = intersectHeightfield_hitPointWorld;
	                var worldNormal = intersectHeightfield_worldNormal;
	                var l0 = intersectHeightfield_l0;
	                var l1 = intersectHeightfield_l1;
	                var localFrom = intersectHeightfield_localFrom;
	                var localTo = intersectHeightfield_localTo;
	
	                // get local ray start and end
	                vec2.toLocalFrame(localFrom, from, position, angle);
	                vec2.toLocalFrame(localTo, to, position, angle);
	
	                // Get the segment range
	                var i0 = this.getClampedSegmentIndex(localFrom);
	                var i1 = this.getClampedSegmentIndex(localTo);
	                if (i0 > i1) {
	                    var tmp = i0;
	                    i0 = i1;
	                    i1 = tmp;
	                }
	
	                // The segments
	                for (var i = 0; i < this.heights.length - 1; i++) {
	                    this.getLineSegment(l0, l1, i);
	                    var t = vec2.getLineSegmentsIntersectionFraction(localFrom, localTo, l0, l1);
	                    if (t >= 0) {
	                        vec2.sub(worldNormal, l1, l0);
	                        vec2.rotate(worldNormal, worldNormal, angle + Math.PI / 2);
	                        vec2.normalize(worldNormal, worldNormal);
	                        ray.reportIntersection(result, t, worldNormal, -1);
	                        if (result.shouldStop(ray)) {
	                            return;
	                        }
	                    }
	                }
	            };
	        }, { "../math/vec2": 30, "../utils/Utils": 57, "./Shape": 45 }], 42: [function (_dereq_, module, exports) {
	            var Shape = _dereq_('./Shape'),
	                vec2 = _dereq_('../math/vec2');
	
	            module.exports = Line;
	
	            /**
	             * Line shape class. The line shape is along the x direction, and stretches from [-length/2, 0] to [length/2,0].
	             * @class Line
	             * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
	             * @param {Number} [options.length=1] The total length of the line
	             * @extends Shape
	             * @constructor
	             */
	            function Line(options) {
	                if (typeof arguments[0] === 'number') {
	                    options = {
	                        length: arguments[0]
	                    };
	                    console.warn('The Line constructor signature has changed. Please use the following format: new Line({ length: 1, ... })');
	                }
	                options = options || {};
	
	                /**
	                 * Length of this line
	                 * @property {Number} length
	                 * @default 1
	                 */
	                this.length = options.length || 1;
	
	                options.type = Shape.LINE;
	                Shape.call(this, options);
	            }
	            Line.prototype = new Shape();
	            Line.prototype.constructor = Line;
	
	            Line.prototype.computeMomentOfInertia = function (mass) {
	                return mass * Math.pow(this.length, 2) / 12;
	            };
	
	            Line.prototype.updateBoundingRadius = function () {
	                this.boundingRadius = this.length / 2;
	            };
	
	            var points = [vec2.create(), vec2.create()];
	
	            /**
	             * @method computeAABB
	             * @param  {AABB}   out      The resulting AABB.
	             * @param  {Array}  position
	             * @param  {Number} angle
	             */
	            Line.prototype.computeAABB = function (out, position, angle) {
	                var l2 = this.length / 2;
	                vec2.set(points[0], -l2, 0);
	                vec2.set(points[1], l2, 0);
	                out.setFromPoints(points, position, angle, 0);
	            };
	
	            var raycast_hitPoint = vec2.create();
	            var raycast_normal = vec2.create();
	            var raycast_l0 = vec2.create();
	            var raycast_l1 = vec2.create();
	            var raycast_unit_y = vec2.fromValues(0, 1);
	
	            /**
	             * @method raycast
	             * @param  {RaycastResult} result
	             * @param  {Ray} ray
	             * @param  {number} angle
	             * @param  {array} position
	             */
	            Line.prototype.raycast = function (result, ray, position, angle) {
	                var from = ray.from;
	                var to = ray.to;
	
	                var l0 = raycast_l0;
	                var l1 = raycast_l1;
	
	                // get start and end of the line
	                var halfLen = this.length / 2;
	                vec2.set(l0, -halfLen, 0);
	                vec2.set(l1, halfLen, 0);
	                vec2.toGlobalFrame(l0, l0, position, angle);
	                vec2.toGlobalFrame(l1, l1, position, angle);
	
	                var fraction = vec2.getLineSegmentsIntersectionFraction(l0, l1, from, to);
	                if (fraction >= 0) {
	                    var normal = raycast_normal;
	                    vec2.rotate(normal, raycast_unit_y, angle); // todo: this should depend on which side the ray comes from
	                    ray.reportIntersection(result, fraction, normal, -1);
	                }
	            };
	        }, { "../math/vec2": 30, "./Shape": 45 }], 43: [function (_dereq_, module, exports) {
	            var Shape = _dereq_('./Shape'),
	                vec2 = _dereq_('../math/vec2');
	
	            module.exports = Particle;
	
	            /**
	             * Particle shape class.
	             * @class Particle
	             * @constructor
	             * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
	             * @extends Shape
	             */
	            function Particle(options) {
	                options = options || {};
	                options.type = Shape.PARTICLE;
	                Shape.call(this, options);
	            }
	            Particle.prototype = new Shape();
	            Particle.prototype.constructor = Particle;
	
	            Particle.prototype.computeMomentOfInertia = function (mass) {
	                return 0; // Can't rotate a particle
	            };
	
	            Particle.prototype.updateBoundingRadius = function () {
	                this.boundingRadius = 0;
	            };
	
	            /**
	             * @method computeAABB
	             * @param  {AABB}   out
	             * @param  {Array}  position
	             * @param  {Number} angle
	             */
	            Particle.prototype.computeAABB = function (out, position, angle) {
	                vec2.copy(out.lowerBound, position);
	                vec2.copy(out.upperBound, position);
	            };
	        }, { "../math/vec2": 30, "./Shape": 45 }], 44: [function (_dereq_, module, exports) {
	            var Shape = _dereq_('./Shape'),
	                vec2 = _dereq_('../math/vec2'),
	                Utils = _dereq_('../utils/Utils');
	
	            module.exports = Plane;
	
	            /**
	             * Plane shape class. The plane is facing in the Y direction.
	             * @class Plane
	             * @extends Shape
	             * @constructor
	             * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
	             */
	            function Plane(options) {
	                options = options || {};
	                options.type = Shape.PLANE;
	                Shape.call(this, options);
	            }
	            Plane.prototype = new Shape();
	            Plane.prototype.constructor = Plane;
	
	            /**
	             * Compute moment of inertia
	             * @method computeMomentOfInertia
	             */
	            Plane.prototype.computeMomentOfInertia = function (mass) {
	                return 0; // Plane is infinite. The inertia should therefore be infinty but by convention we set 0 here
	            };
	
	            /**
	             * Update the bounding radius
	             * @method updateBoundingRadius
	             */
	            Plane.prototype.updateBoundingRadius = function () {
	                this.boundingRadius = Number.MAX_VALUE;
	            };
	
	            /**
	             * @method computeAABB
	             * @param  {AABB}   out
	             * @param  {Array}  position
	             * @param  {Number} angle
	             */
	            Plane.prototype.computeAABB = function (out, position, angle) {
	                var a = angle % (2 * Math.PI);
	                var set = vec2.set;
	                var max = Number.MAX_VALUE;
	                var lowerBound = out.lowerBound;
	                var upperBound = out.upperBound;
	
	                if (a === 0) {
	                    // y goes from -inf to 0
	                    set(lowerBound, -max, -max);
	                    set(upperBound, max, 0);
	                } else if (a === Math.PI / 2) {
	
	                    // x goes from 0 to inf
	                    set(lowerBound, 0, -max);
	                    set(upperBound, max, max);
	                } else if (a === Math.PI) {
	
	                    // y goes from 0 to inf
	                    set(lowerBound, -max, 0);
	                    set(upperBound, max, max);
	                } else if (a === 3 * Math.PI / 2) {
	
	                    // x goes from -inf to 0
	                    set(lowerBound, -max, -max);
	                    set(upperBound, 0, max);
	                } else {
	
	                    // Set max bounds
	                    set(lowerBound, -max, -max);
	                    set(upperBound, max, max);
	                }
	
	                vec2.add(lowerBound, lowerBound, position);
	                vec2.add(upperBound, upperBound, position);
	            };
	
	            Plane.prototype.updateArea = function () {
	                this.area = Number.MAX_VALUE;
	            };
	
	            var intersectPlane_planePointToFrom = vec2.create();
	            var intersectPlane_dir_scaled_with_t = vec2.create();
	            var intersectPlane_hitPoint = vec2.create();
	            var intersectPlane_normal = vec2.create();
	            var intersectPlane_len = vec2.create();
	
	            /**
	             * @method raycast
	             * @param  {RayResult} result
	             * @param  {Ray} ray
	             * @param  {array} position
	             * @param  {number} angle
	             */
	            Plane.prototype.raycast = function (result, ray, position, angle) {
	                var from = ray.from;
	                var to = ray.to;
	                var direction = ray.direction;
	                var planePointToFrom = intersectPlane_planePointToFrom;
	                var dir_scaled_with_t = intersectPlane_dir_scaled_with_t;
	                var hitPoint = intersectPlane_hitPoint;
	                var normal = intersectPlane_normal;
	                var len = intersectPlane_len;
	
	                // Get plane normal
	                vec2.set(normal, 0, 1);
	                vec2.rotate(normal, normal, angle);
	
	                vec2.sub(len, from, position);
	                var planeToFrom = vec2.dot(len, normal);
	                vec2.sub(len, to, position);
	                var planeToTo = vec2.dot(len, normal);
	
	                if (planeToFrom * planeToTo > 0) {
	                    // "from" and "to" are on the same side of the plane... bail out
	                    return;
	                }
	
	                if (vec2.squaredDistance(from, to) < planeToFrom * planeToFrom) {
	                    return;
	                }
	
	                var n_dot_dir = vec2.dot(normal, direction);
	
	                vec2.sub(planePointToFrom, from, position);
	                var t = -vec2.dot(normal, planePointToFrom) / n_dot_dir / ray.length;
	
	                ray.reportIntersection(result, t, normal, -1);
	            };
	        }, { "../math/vec2": 30, "../utils/Utils": 57, "./Shape": 45 }], 45: [function (_dereq_, module, exports) {
	            module.exports = Shape;
	
	            var vec2 = _dereq_('../math/vec2');
	
	            /**
	             * Base class for shapes.
	             * @class Shape
	             * @constructor
	             * @param {object} [options]
	             * @param {array} [options.position]
	             * @param {number} [options.angle=0]
	             * @param {number} [options.collisionGroup=1]
	             * @param {number} [options.collisionMask=1]
	             * @param {boolean} [options.sensor=false]
	             * @param {boolean} [options.collisionResponse=true]
	             * @param {object} [options.type=0]
	             */
	            function Shape(options) {
	                options = options || {};
	
	                /**
	                 * The body this shape is attached to. A shape can only be attached to a single body.
	                 * @property {Body} body
	                 */
	                this.body = null;
	
	                /**
	                 * Body-local position of the shape.
	                 * @property {Array} position
	                 */
	                this.position = vec2.fromValues(0, 0);
	                if (options.position) {
	                    vec2.copy(this.position, options.position);
	                }
	
	                /**
	                 * Body-local angle of the shape.
	                 * @property {number} angle
	                 */
	                this.angle = options.angle || 0;
	
	                /**
	                 * The type of the shape. One of:
	                 *
	                 * * {{#crossLink "Shape/CIRCLE:property"}}Shape.CIRCLE{{/crossLink}}
	                 * * {{#crossLink "Shape/PARTICLE:property"}}Shape.PARTICLE{{/crossLink}}
	                 * * {{#crossLink "Shape/PLANE:property"}}Shape.PLANE{{/crossLink}}
	                 * * {{#crossLink "Shape/CONVEX:property"}}Shape.CONVEX{{/crossLink}}
	                 * * {{#crossLink "Shape/LINE:property"}}Shape.LINE{{/crossLink}}
	                 * * {{#crossLink "Shape/BOX:property"}}Shape.BOX{{/crossLink}}
	                 * * {{#crossLink "Shape/CAPSULE:property"}}Shape.CAPSULE{{/crossLink}}
	                 * * {{#crossLink "Shape/HEIGHTFIELD:property"}}Shape.HEIGHTFIELD{{/crossLink}}
	                 *
	                 * @property {number} type
	                 */
	                this.type = options.type || 0;
	
	                /**
	                 * Shape object identifier.
	                 * @type {Number}
	                 * @property id
	                 */
	                this.id = Shape.idCounter++;
	
	                /**
	                 * Bounding circle radius of this shape
	                 * @property boundingRadius
	                 * @type {Number}
	                 */
	                this.boundingRadius = 0;
	
	                /**
	                 * Collision group that this shape belongs to (bit mask). See <a href="http://www.aurelienribon.com/blog/2011/07/box2d-tutorial-collision-filtering/">this tutorial</a>.
	                 * @property collisionGroup
	                 * @type {Number}
	                 * @example
	                 *     // Setup bits for each available group
	                 *     var PLAYER = Math.pow(2,0),
	                 *         ENEMY =  Math.pow(2,1),
	                 *         GROUND = Math.pow(2,2)
	                 *
	                 *     // Put shapes into their groups
	                 *     player1Shape.collisionGroup = PLAYER;
	                 *     player2Shape.collisionGroup = PLAYER;
	                 *     enemyShape  .collisionGroup = ENEMY;
	                 *     groundShape .collisionGroup = GROUND;
	                 *
	                 *     // Assign groups that each shape collide with.
	                 *     // Note that the players can collide with ground and enemies, but not with other players.
	                 *     player1Shape.collisionMask = ENEMY | GROUND;
	                 *     player2Shape.collisionMask = ENEMY | GROUND;
	                 *     enemyShape  .collisionMask = PLAYER | GROUND;
	                 *     groundShape .collisionMask = PLAYER | ENEMY;
	                 *
	                 * @example
	                 *     // How collision check is done
	                 *     if(shapeA.collisionGroup & shapeB.collisionMask)!=0 && (shapeB.collisionGroup & shapeA.collisionMask)!=0){
	                 *         // The shapes will collide
	                 *     }
	                 */
	                this.collisionGroup = options.collisionGroup !== undefined ? options.collisionGroup : 1;
	
	                /**
	                 * Whether to produce contact forces when in contact with other bodies. Note that contacts will be generated, but they will be disabled. That means that this shape will move through other body shapes, but it will still trigger contact events, etc.
	                 * @property {Boolean} collisionResponse
	                 */
	                this.collisionResponse = options.collisionResponse !== undefined ? options.collisionResponse : true;
	
	                /**
	                 * Collision mask of this shape. See .collisionGroup.
	                 * @property collisionMask
	                 * @type {Number}
	                 */
	                this.collisionMask = options.collisionMask !== undefined ? options.collisionMask : 1;
	
	                /**
	                 * Material to use in collisions for this Shape. If this is set to null, the world will use default material properties instead.
	                 * @property material
	                 * @type {Material}
	                 */
	                this.material = options.material || null;
	
	                /**
	                 * Area of this shape.
	                 * @property area
	                 * @type {Number}
	                 */
	                this.area = 0;
	
	                /**
	                 * Set to true if you want this shape to be a sensor. A sensor does not generate contacts, but it still reports contact events. This is good if you want to know if a shape is overlapping another shape, without them generating contacts.
	                 * @property {Boolean} sensor
	                 */
	                this.sensor = options.sensor !== undefined ? options.sensor : false;
	
	                if (this.type) {
	                    this.updateBoundingRadius();
	                }
	
	                this.updateArea();
	            }
	
	            Shape.idCounter = 0;
	
	            /**
	             * @static
	             * @property {Number} CIRCLE
	             */
	            Shape.CIRCLE = 1;
	
	            /**
	             * @static
	             * @property {Number} PARTICLE
	             */
	            Shape.PARTICLE = 2;
	
	            /**
	             * @static
	             * @property {Number} PLANE
	             */
	            Shape.PLANE = 4;
	
	            /**
	             * @static
	             * @property {Number} CONVEX
	             */
	            Shape.CONVEX = 8;
	
	            /**
	             * @static
	             * @property {Number} LINE
	             */
	            Shape.LINE = 16;
	
	            /**
	             * @static
	             * @property {Number} BOX
	             */
	            Shape.BOX = 32;
	
	            Object.defineProperty(Shape, 'RECTANGLE', {
	                get: function get() {
	                    console.warn('Shape.RECTANGLE is deprecated, use Shape.BOX instead.');
	                    return Shape.BOX;
	                }
	            });
	
	            /**
	             * @static
	             * @property {Number} CAPSULE
	             */
	            Shape.CAPSULE = 64;
	
	            /**
	             * @static
	             * @property {Number} HEIGHTFIELD
	             */
	            Shape.HEIGHTFIELD = 128;
	
	            /**
	             * Should return the moment of inertia around the Z axis of the body given the total mass. See <a href="http://en.wikipedia.org/wiki/List_of_moments_of_inertia">Wikipedia's list of moments of inertia</a>.
	             * @method computeMomentOfInertia
	             * @param  {Number} mass
	             * @return {Number} If the inertia is infinity or if the object simply isn't possible to rotate, return 0.
	             */
	            Shape.prototype.computeMomentOfInertia = function (mass) {};
	
	            /**
	             * Returns the bounding circle radius of this shape.
	             * @method updateBoundingRadius
	             * @return {Number}
	             */
	            Shape.prototype.updateBoundingRadius = function () {};
	
	            /**
	             * Update the .area property of the shape.
	             * @method updateArea
	             */
	            Shape.prototype.updateArea = function () {
	                // To be implemented in all subclasses
	            };
	
	            /**
	             * Compute the world axis-aligned bounding box (AABB) of this shape.
	             * @method computeAABB
	             * @param  {AABB} out The resulting AABB.
	             * @param  {Array} position World position of the shape.
	             * @param  {Number} angle World angle of the shape.
	             */
	            Shape.prototype.computeAABB = function (out, position, angle) {
	                // To be implemented in each subclass
	            };
	
	            /**
	             * Perform raycasting on this shape.
	             * @method raycast
	             * @param  {RayResult} result Where to store the resulting data.
	             * @param  {Ray} ray The Ray that you want to use for raycasting.
	             * @param  {array} position World position of the shape (the .position property will be ignored).
	             * @param  {number} angle World angle of the shape (the .angle property will be ignored).
	             */
	            Shape.prototype.raycast = function (result, ray, position, angle) {
	                // To be implemented in each subclass
	            };
	        }, { "../math/vec2": 30 }], 46: [function (_dereq_, module, exports) {
	            var vec2 = _dereq_('../math/vec2'),
	                Solver = _dereq_('./Solver'),
	                Utils = _dereq_('../utils/Utils'),
	                FrictionEquation = _dereq_('../equations/FrictionEquation');
	
	            module.exports = GSSolver;
	
	            /**
	             * Iterative Gauss-Seidel constraint equation solver.
	             *
	             * @class GSSolver
	             * @constructor
	             * @extends Solver
	             * @param {Object} [options]
	             * @param {Number} [options.iterations=10]
	             * @param {Number} [options.tolerance=0]
	             */
	            function GSSolver(options) {
	                Solver.call(this, options, Solver.GS);
	                options = options || {};
	
	                /**
	                 * The max number of iterations to do when solving. More gives better results, but is more expensive.
	                 * @property iterations
	                 * @type {Number}
	                 */
	                this.iterations = options.iterations || 10;
	
	                /**
	                 * The error tolerance, per constraint. If the total error is below this limit, the solver will stop iterating. Set to zero for as good solution as possible, but to something larger than zero to make computations faster.
	                 * @property tolerance
	                 * @type {Number}
	                 * @default 1e-7
	                 */
	                this.tolerance = options.tolerance || 1e-7;
	
	                this.arrayStep = 30;
	                this.lambda = new Utils.ARRAY_TYPE(this.arrayStep);
	                this.Bs = new Utils.ARRAY_TYPE(this.arrayStep);
	                this.invCs = new Utils.ARRAY_TYPE(this.arrayStep);
	
	                /**
	                 * Set to true to set all right hand side terms to zero when solving. Can be handy for a few applications.
	                 * @property useZeroRHS
	                 * @type {Boolean}
	                 */
	                this.useZeroRHS = false;
	
	                /**
	                 * Number of solver iterations that are done to approximate normal forces. When these iterations are done, friction force will be computed from the contact normal forces. These friction forces will override any other friction forces set from the World for example.
	                 * The solver will use less iterations if the solution is below the .tolerance.
	                 * @property frictionIterations
	                 * @type {Number}
	                 */
	                this.frictionIterations = 0;
	
	                /**
	                 * The number of iterations that were made during the last solve. If .tolerance is zero, this value will always be equal to .iterations, but if .tolerance is larger than zero, and the solver can quit early, then this number will be somewhere between 1 and .iterations.
	                 * @property {Number} usedIterations
	                 */
	                this.usedIterations = 0;
	            }
	            GSSolver.prototype = new Solver();
	            GSSolver.prototype.constructor = GSSolver;
	
	            function setArrayZero(array) {
	                var l = array.length;
	                while (l--) {
	                    array[l] = +0.0;
	                }
	            }
	
	            /**
	             * Solve the system of equations
	             * @method solve
	             * @param  {Number}  h       Time step
	             * @param  {World}   world    World to solve
	             */
	            GSSolver.prototype.solve = function (h, world) {
	
	                this.sortEquations();
	
	                var iter = 0,
	                    maxIter = this.iterations,
	                    maxFrictionIter = this.frictionIterations,
	                    equations = this.equations,
	                    Neq = equations.length,
	                    tolSquared = Math.pow(this.tolerance * Neq, 2),
	                    bodies = world.bodies,
	                    Nbodies = world.bodies.length,
	                    add = vec2.add,
	                    set = vec2.set,
	                    useZeroRHS = this.useZeroRHS,
	                    lambda = this.lambda;
	
	                this.usedIterations = 0;
	
	                if (Neq) {
	                    for (var i = 0; i !== Nbodies; i++) {
	                        var b = bodies[i];
	
	                        // Update solve mass
	                        b.updateSolveMassProperties();
	                    }
	                }
	
	                // Things that does not change during iteration can be computed once
	                if (lambda.length < Neq) {
	                    lambda = this.lambda = new Utils.ARRAY_TYPE(Neq + this.arrayStep);
	                    this.Bs = new Utils.ARRAY_TYPE(Neq + this.arrayStep);
	                    this.invCs = new Utils.ARRAY_TYPE(Neq + this.arrayStep);
	                }
	                setArrayZero(lambda);
	                var invCs = this.invCs,
	                    Bs = this.Bs,
	                    lambda = this.lambda;
	
	                for (var i = 0; i !== equations.length; i++) {
	                    var c = equations[i];
	                    if (c.timeStep !== h || c.needsUpdate) {
	                        c.timeStep = h;
	                        c.update();
	                    }
	                    Bs[i] = c.computeB(c.a, c.b, h);
	                    invCs[i] = c.computeInvC(c.epsilon);
	                }
	
	                var q, B, c, deltalambdaTot, i, j;
	
	                if (Neq !== 0) {
	
	                    for (i = 0; i !== Nbodies; i++) {
	                        var b = bodies[i];
	
	                        // Reset vlambda
	                        b.resetConstraintVelocity();
	                    }
	
	                    if (maxFrictionIter) {
	                        // Iterate over contact equations to get normal forces
	                        for (iter = 0; iter !== maxFrictionIter; iter++) {
	
	                            // Accumulate the total error for each iteration.
	                            deltalambdaTot = 0.0;
	
	                            for (j = 0; j !== Neq; j++) {
	                                c = equations[j];
	
	                                var deltalambda = GSSolver.iterateEquation(j, c, c.epsilon, Bs, invCs, lambda, useZeroRHS, h, iter);
	                                deltalambdaTot += Math.abs(deltalambda);
	                            }
	
	                            this.usedIterations++;
	
	                            // If the total error is small enough - stop iterate
	                            if (deltalambdaTot * deltalambdaTot <= tolSquared) {
	                                break;
	                            }
	                        }
	
	                        GSSolver.updateMultipliers(equations, lambda, 1 / h);
	
	                        // Set computed friction force
	                        for (j = 0; j !== Neq; j++) {
	                            var eq = equations[j];
	                            if (eq instanceof FrictionEquation) {
	                                var f = 0.0;
	                                for (var k = 0; k !== eq.contactEquations.length; k++) {
	                                    f += eq.contactEquations[k].multiplier;
	                                }
	                                f *= eq.frictionCoefficient / eq.contactEquations.length;
	                                eq.maxForce = f;
	                                eq.minForce = -f;
	                            }
	                        }
	                    }
	
	                    // Iterate over all equations
	                    for (iter = 0; iter !== maxIter; iter++) {
	
	                        // Accumulate the total error for each iteration.
	                        deltalambdaTot = 0.0;
	
	                        for (j = 0; j !== Neq; j++) {
	                            c = equations[j];
	
	                            var deltalambda = GSSolver.iterateEquation(j, c, c.epsilon, Bs, invCs, lambda, useZeroRHS, h, iter);
	                            deltalambdaTot += Math.abs(deltalambda);
	                        }
	
	                        this.usedIterations++;
	
	                        // If the total error is small enough - stop iterate
	                        if (deltalambdaTot * deltalambdaTot <= tolSquared) {
	                            break;
	                        }
	                    }
	
	                    // Add result to velocity
	                    for (i = 0; i !== Nbodies; i++) {
	                        bodies[i].addConstraintVelocity();
	                    }
	
	                    GSSolver.updateMultipliers(equations, lambda, 1 / h);
	                }
	            };
	
	            // Sets the .multiplier property of each equation
	            GSSolver.updateMultipliers = function (equations, lambda, invDt) {
	                // Set the .multiplier property of each equation
	                var l = equations.length;
	                while (l--) {
	                    equations[l].multiplier = lambda[l] * invDt;
	                }
	            };
	
	            GSSolver.iterateEquation = function (j, eq, eps, Bs, invCs, lambda, useZeroRHS, dt, iter) {
	                // Compute iteration
	                var B = Bs[j],
	                    invC = invCs[j],
	                    lambdaj = lambda[j],
	                    GWlambda = eq.computeGWlambda();
	
	                var maxForce = eq.maxForce,
	                    minForce = eq.minForce;
	
	                if (useZeroRHS) {
	                    B = 0;
	                }
	
	                var deltalambda = invC * (B - GWlambda - eps * lambdaj);
	
	                // Clamp if we are not within the min/max interval
	                var lambdaj_plus_deltalambda = lambdaj + deltalambda;
	                if (lambdaj_plus_deltalambda < minForce * dt) {
	                    deltalambda = minForce * dt - lambdaj;
	                } else if (lambdaj_plus_deltalambda > maxForce * dt) {
	                    deltalambda = maxForce * dt - lambdaj;
	                }
	                lambda[j] += deltalambda;
	                eq.addToWlambda(deltalambda);
	
	                return deltalambda;
	            };
	        }, { "../equations/FrictionEquation": 23, "../math/vec2": 30, "../utils/Utils": 57, "./Solver": 47 }], 47: [function (_dereq_, module, exports) {
	            var Utils = _dereq_('../utils/Utils'),
	                EventEmitter = _dereq_('../events/EventEmitter');
	
	            module.exports = Solver;
	
	            /**
	             * Base class for constraint solvers.
	             * @class Solver
	             * @constructor
	             * @extends EventEmitter
	             */
	            function Solver(options, type) {
	                options = options || {};
	
	                EventEmitter.call(this);
	
	                this.type = type;
	
	                /**
	                 * Current equations in the solver.
	                 *
	                 * @property equations
	                 * @type {Array}
	                 */
	                this.equations = [];
	
	                /**
	                 * Function that is used to sort all equations before each solve.
	                 * @property equationSortFunction
	                 * @type {function|boolean}
	                 */
	                this.equationSortFunction = options.equationSortFunction || false;
	            }
	            Solver.prototype = new EventEmitter();
	            Solver.prototype.constructor = Solver;
	
	            /**
	             * Method to be implemented in each subclass
	             * @method solve
	             * @param  {Number} dt
	             * @param  {World} world
	             */
	            Solver.prototype.solve = function (dt, world) {
	                throw new Error("Solver.solve should be implemented by subclasses!");
	            };
	
	            var mockWorld = { bodies: [] };
	
	            /**
	             * Solves all constraints in an island.
	             * @method solveIsland
	             * @param  {Number} dt
	             * @param  {Island} island
	             */
	            Solver.prototype.solveIsland = function (dt, island) {
	
	                this.removeAllEquations();
	
	                if (island.equations.length) {
	                    // Add equations to solver
	                    this.addEquations(island.equations);
	                    mockWorld.bodies.length = 0;
	                    island.getBodies(mockWorld.bodies);
	
	                    // Solve
	                    if (mockWorld.bodies.length) {
	                        this.solve(dt, mockWorld);
	                    }
	                }
	            };
	
	            /**
	             * Sort all equations using the .equationSortFunction. Should be called by subclasses before solving.
	             * @method sortEquations
	             */
	            Solver.prototype.sortEquations = function () {
	                if (this.equationSortFunction) {
	                    this.equations.sort(this.equationSortFunction);
	                }
	            };
	
	            /**
	             * Add an equation to be solved.
	             *
	             * @method addEquation
	             * @param {Equation} eq
	             */
	            Solver.prototype.addEquation = function (eq) {
	                if (eq.enabled) {
	                    this.equations.push(eq);
	                }
	            };
	
	            /**
	             * Add equations. Same as .addEquation, but this time the argument is an array of Equations
	             *
	             * @method addEquations
	             * @param {Array} eqs
	             */
	            Solver.prototype.addEquations = function (eqs) {
	                //Utils.appendArray(this.equations,eqs);
	                for (var i = 0, N = eqs.length; i !== N; i++) {
	                    var eq = eqs[i];
	                    if (eq.enabled) {
	                        this.equations.push(eq);
	                    }
	                }
	            };
	
	            /**
	             * Remove an equation.
	             *
	             * @method removeEquation
	             * @param {Equation} eq
	             */
	            Solver.prototype.removeEquation = function (eq) {
	                var i = this.equations.indexOf(eq);
	                if (i !== -1) {
	                    this.equations.splice(i, 1);
	                }
	            };
	
	            /**
	             * Remove all currently added equations.
	             *
	             * @method removeAllEquations
	             */
	            Solver.prototype.removeAllEquations = function () {
	                this.equations.length = 0;
	            };
	
	            Solver.GS = 1;
	            Solver.ISLAND = 2;
	        }, { "../events/EventEmitter": 26, "../utils/Utils": 57 }], 48: [function (_dereq_, module, exports) {
	            var ContactEquation = _dereq_('../equations/ContactEquation');
	            var Pool = _dereq_('./Pool');
	
	            module.exports = ContactEquationPool;
	
	            /**
	             * @class
	             */
	            function ContactEquationPool() {
	                Pool.apply(this, arguments);
	            }
	            ContactEquationPool.prototype = new Pool();
	            ContactEquationPool.prototype.constructor = ContactEquationPool;
	
	            /**
	             * @method create
	             * @return {ContactEquation}
	             */
	            ContactEquationPool.prototype.create = function () {
	                return new ContactEquation();
	            };
	
	            /**
	             * @method destroy
	             * @param {ContactEquation} equation
	             * @return {ContactEquationPool}
	             */
	            ContactEquationPool.prototype.destroy = function (equation) {
	                equation.bodyA = equation.bodyB = null;
	                return this;
	            };
	        }, { "../equations/ContactEquation": 21, "./Pool": 55 }], 49: [function (_dereq_, module, exports) {
	            var FrictionEquation = _dereq_('../equations/FrictionEquation');
	            var Pool = _dereq_('./Pool');
	
	            module.exports = FrictionEquationPool;
	
	            /**
	             * @class
	             */
	            function FrictionEquationPool() {
	                Pool.apply(this, arguments);
	            }
	            FrictionEquationPool.prototype = new Pool();
	            FrictionEquationPool.prototype.constructor = FrictionEquationPool;
	
	            /**
	             * @method create
	             * @return {FrictionEquation}
	             */
	            FrictionEquationPool.prototype.create = function () {
	                return new FrictionEquation();
	            };
	
	            /**
	             * @method destroy
	             * @param {FrictionEquation} equation
	             * @return {FrictionEquationPool}
	             */
	            FrictionEquationPool.prototype.destroy = function (equation) {
	                equation.bodyA = equation.bodyB = null;
	                return this;
	            };
	        }, { "../equations/FrictionEquation": 23, "./Pool": 55 }], 50: [function (_dereq_, module, exports) {
	            var IslandNode = _dereq_('../world/IslandNode');
	            var Pool = _dereq_('./Pool');
	
	            module.exports = IslandNodePool;
	
	            /**
	             * @class
	             */
	            function IslandNodePool() {
	                Pool.apply(this, arguments);
	            }
	            IslandNodePool.prototype = new Pool();
	            IslandNodePool.prototype.constructor = IslandNodePool;
	
	            /**
	             * @method create
	             * @return {IslandNode}
	             */
	            IslandNodePool.prototype.create = function () {
	                return new IslandNode();
	            };
	
	            /**
	             * @method destroy
	             * @param {IslandNode} node
	             * @return {IslandNodePool}
	             */
	            IslandNodePool.prototype.destroy = function (node) {
	                node.reset();
	                return this;
	            };
	        }, { "../world/IslandNode": 60, "./Pool": 55 }], 51: [function (_dereq_, module, exports) {
	            var Island = _dereq_('../world/Island');
	            var Pool = _dereq_('./Pool');
	
	            module.exports = IslandPool;
	
	            /**
	             * @class
	             */
	            function IslandPool() {
	                Pool.apply(this, arguments);
	            }
	            IslandPool.prototype = new Pool();
	            IslandPool.prototype.constructor = IslandPool;
	
	            /**
	             * @method create
	             * @return {Island}
	             */
	            IslandPool.prototype.create = function () {
	                return new Island();
	            };
	
	            /**
	             * @method destroy
	             * @param {Island} island
	             * @return {IslandPool}
	             */
	            IslandPool.prototype.destroy = function (island) {
	                island.reset();
	                return this;
	            };
	        }, { "../world/Island": 58, "./Pool": 55 }], 52: [function (_dereq_, module, exports) {
	            var TupleDictionary = _dereq_('./TupleDictionary');
	            var OverlapKeeperRecord = _dereq_('./OverlapKeeperRecord');
	            var OverlapKeeperRecordPool = _dereq_('./OverlapKeeperRecordPool');
	            var Utils = _dereq_('./Utils');
	
	            module.exports = OverlapKeeper;
	
	            /**
	             * Keeps track of overlaps in the current state and the last step state.
	             * @class OverlapKeeper
	             * @constructor
	             */
	            function OverlapKeeper() {
	                this.overlappingShapesLastState = new TupleDictionary();
	                this.overlappingShapesCurrentState = new TupleDictionary();
	                this.recordPool = new OverlapKeeperRecordPool({ size: 16 });
	                this.tmpDict = new TupleDictionary();
	                this.tmpArray1 = [];
	            }
	
	            /**
	             * Ticks one step forward in time. This will move the current overlap state to the "old" overlap state, and create a new one as current.
	             * @method tick
	             */
	            OverlapKeeper.prototype.tick = function () {
	                var last = this.overlappingShapesLastState;
	                var current = this.overlappingShapesCurrentState;
	
	                // Save old objects into pool
	                var l = last.keys.length;
	                while (l--) {
	                    var key = last.keys[l];
	                    var lastObject = last.getByKey(key);
	                    var currentObject = current.getByKey(key);
	                    if (lastObject) {
	                        // The record is only used in the "last" dict, and will be removed. We might as well pool it.
	                        this.recordPool.release(lastObject);
	                    }
	                }
	
	                // Clear last object
	                last.reset();
	
	                // Transfer from new object to old
	                last.copy(current);
	
	                // Clear current object
	                current.reset();
	            };
	
	            /**
	             * @method setOverlapping
	             * @param {Body} bodyA
	             * @param {Body} shapeA
	             * @param {Body} bodyB
	             * @param {Body} shapeB
	             */
	            OverlapKeeper.prototype.setOverlapping = function (bodyA, shapeA, bodyB, shapeB) {
	                var last = this.overlappingShapesLastState;
	                var current = this.overlappingShapesCurrentState;
	
	                // Store current contact state
	                if (!current.get(shapeA.id, shapeB.id)) {
	                    var data = this.recordPool.get();
	                    data.set(bodyA, shapeA, bodyB, shapeB);
	                    current.set(shapeA.id, shapeB.id, data);
	                }
	            };
	
	            OverlapKeeper.prototype.getNewOverlaps = function (result) {
	                return this.getDiff(this.overlappingShapesLastState, this.overlappingShapesCurrentState, result);
	            };
	
	            OverlapKeeper.prototype.getEndOverlaps = function (result) {
	                return this.getDiff(this.overlappingShapesCurrentState, this.overlappingShapesLastState, result);
	            };
	
	            /**
	             * Checks if two bodies are currently overlapping.
	             * @method bodiesAreOverlapping
	             * @param  {Body} bodyA
	             * @param  {Body} bodyB
	             * @return {boolean}
	             */
	            OverlapKeeper.prototype.bodiesAreOverlapping = function (bodyA, bodyB) {
	                var current = this.overlappingShapesCurrentState;
	                var l = current.keys.length;
	                while (l--) {
	                    var key = current.keys[l];
	                    var data = current.data[key];
	                    if (data.bodyA === bodyA && data.bodyB === bodyB || data.bodyA === bodyB && data.bodyB === bodyA) {
	                        return true;
	                    }
	                }
	                return false;
	            };
	
	            OverlapKeeper.prototype.getDiff = function (dictA, dictB, result) {
	                var result = result || [];
	                var last = dictA;
	                var current = dictB;
	
	                result.length = 0;
	
	                var l = current.keys.length;
	                while (l--) {
	                    var key = current.keys[l];
	                    var data = current.data[key];
	
	                    if (!data) {
	                        throw new Error('Key ' + key + ' had no data!');
	                    }
	
	                    var lastData = last.data[key];
	                    if (!lastData) {
	                        // Not overlapping in last state, but in current.
	                        result.push(data);
	                    }
	                }
	
	                return result;
	            };
	
	            OverlapKeeper.prototype.isNewOverlap = function (shapeA, shapeB) {
	                var idA = shapeA.id | 0,
	                    idB = shapeB.id | 0;
	                var last = this.overlappingShapesLastState;
	                var current = this.overlappingShapesCurrentState;
	                // Not in last but in new
	                return !!!last.get(idA, idB) && !!current.get(idA, idB);
	            };
	
	            OverlapKeeper.prototype.getNewBodyOverlaps = function (result) {
	                this.tmpArray1.length = 0;
	                var overlaps = this.getNewOverlaps(this.tmpArray1);
	                return this.getBodyDiff(overlaps, result);
	            };
	
	            OverlapKeeper.prototype.getEndBodyOverlaps = function (result) {
	                this.tmpArray1.length = 0;
	                var overlaps = this.getEndOverlaps(this.tmpArray1);
	                return this.getBodyDiff(overlaps, result);
	            };
	
	            OverlapKeeper.prototype.getBodyDiff = function (overlaps, result) {
	                result = result || [];
	                var accumulator = this.tmpDict;
	
	                var l = overlaps.length;
	
	                while (l--) {
	                    var data = overlaps[l];
	
	                    // Since we use body id's for the accumulator, these will be a subset of the original one
	                    accumulator.set(data.bodyA.id | 0, data.bodyB.id | 0, data);
	                }
	
	                l = accumulator.keys.length;
	                while (l--) {
	                    var data = accumulator.getByKey(accumulator.keys[l]);
	                    if (data) {
	                        result.push(data.bodyA, data.bodyB);
	                    }
	                }
	
	                accumulator.reset();
	
	                return result;
	            };
	        }, { "./OverlapKeeperRecord": 53, "./OverlapKeeperRecordPool": 54, "./TupleDictionary": 56, "./Utils": 57 }], 53: [function (_dereq_, module, exports) {
	            module.exports = OverlapKeeperRecord;
	
	            /**
	             * Overlap data container for the OverlapKeeper
	             * @class OverlapKeeperRecord
	             * @constructor
	             * @param {Body} bodyA
	             * @param {Shape} shapeA
	             * @param {Body} bodyB
	             * @param {Shape} shapeB
	             */
	            function OverlapKeeperRecord(bodyA, shapeA, bodyB, shapeB) {
	                /**
	                 * @property {Shape} shapeA
	                 */
	                this.shapeA = shapeA;
	                /**
	                 * @property {Shape} shapeB
	                 */
	                this.shapeB = shapeB;
	                /**
	                 * @property {Body} bodyA
	                 */
	                this.bodyA = bodyA;
	                /**
	                 * @property {Body} bodyB
	                 */
	                this.bodyB = bodyB;
	            }
	
	            /**
	             * Set the data for the record
	             * @method set
	             * @param {Body} bodyA
	             * @param {Shape} shapeA
	             * @param {Body} bodyB
	             * @param {Shape} shapeB
	             */
	            OverlapKeeperRecord.prototype.set = function (bodyA, shapeA, bodyB, shapeB) {
	                OverlapKeeperRecord.call(this, bodyA, shapeA, bodyB, shapeB);
	            };
	        }, {}], 54: [function (_dereq_, module, exports) {
	            var OverlapKeeperRecord = _dereq_('./OverlapKeeperRecord');
	            var Pool = _dereq_('./Pool');
	
	            module.exports = OverlapKeeperRecordPool;
	
	            /**
	             * @class
	             */
	            function OverlapKeeperRecordPool() {
	                Pool.apply(this, arguments);
	            }
	            OverlapKeeperRecordPool.prototype = new Pool();
	            OverlapKeeperRecordPool.prototype.constructor = OverlapKeeperRecordPool;
	
	            /**
	             * @method create
	             * @return {OverlapKeeperRecord}
	             */
	            OverlapKeeperRecordPool.prototype.create = function () {
	                return new OverlapKeeperRecord();
	            };
	
	            /**
	             * @method destroy
	             * @param {OverlapKeeperRecord} record
	             * @return {OverlapKeeperRecordPool}
	             */
	            OverlapKeeperRecordPool.prototype.destroy = function (record) {
	                record.bodyA = record.bodyB = record.shapeA = record.shapeB = null;
	                return this;
	            };
	        }, { "./OverlapKeeperRecord": 53, "./Pool": 55 }], 55: [function (_dereq_, module, exports) {
	            module.exports = Pool;
	
	            /**
	             * @class Object pooling utility.
	             */
	            function Pool(options) {
	                options = options || {};
	
	                /**
	                 * @property {Array} objects
	                 * @type {Array}
	                 */
	                this.objects = [];
	
	                if (options.size !== undefined) {
	                    this.resize(options.size);
	                }
	            }
	
	            /**
	             * @method resize
	             * @param {number} size
	             * @return {Pool} Self, for chaining
	             */
	            Pool.prototype.resize = function (size) {
	                var objects = this.objects;
	
	                while (objects.length > size) {
	                    objects.pop();
	                }
	
	                while (objects.length < size) {
	                    objects.push(this.create());
	                }
	
	                return this;
	            };
	
	            /**
	             * Get an object from the pool or create a new instance.
	             * @method get
	             * @return {Object}
	             */
	            Pool.prototype.get = function () {
	                var objects = this.objects;
	                return objects.length ? objects.pop() : this.create();
	            };
	
	            /**
	             * Clean up and put the object back into the pool for later use.
	             * @method release
	             * @param {Object} object
	             * @return {Pool} Self for chaining
	             */
	            Pool.prototype.release = function (object) {
	                this.destroy(object);
	                this.objects.push(object);
	                return this;
	            };
	        }, {}], 56: [function (_dereq_, module, exports) {
	            var Utils = _dereq_('./Utils');
	
	            module.exports = TupleDictionary;
	
	            /**
	             * @class TupleDictionary
	             * @constructor
	             */
	            function TupleDictionary() {
	
	                /**
	                 * The data storage
	                 * @property data
	                 * @type {Object}
	                 */
	                this.data = {};
	
	                /**
	                 * Keys that are currently used.
	                 * @property {Array} keys
	                 */
	                this.keys = [];
	            }
	
	            /**
	             * Generate a key given two integers
	             * @method getKey
	             * @param  {number} i
	             * @param  {number} j
	             * @return {string}
	             */
	            TupleDictionary.prototype.getKey = function (id1, id2) {
	                id1 = id1 | 0;
	                id2 = id2 | 0;
	
	                if ((id1 | 0) === (id2 | 0)) {
	                    return -1;
	                }
	
	                // valid for values < 2^16
	                return ((id1 | 0) > (id2 | 0) ? id1 << 16 | id2 & 0xFFFF : id2 << 16 | id1 & 0xFFFF) | 0;
	            };
	
	            /**
	             * @method getByKey
	             * @param  {Number} key
	             * @return {Object}
	             */
	            TupleDictionary.prototype.getByKey = function (key) {
	                key = key | 0;
	                return this.data[key];
	            };
	
	            /**
	             * @method get
	             * @param  {Number} i
	             * @param  {Number} j
	             * @return {Number}
	             */
	            TupleDictionary.prototype.get = function (i, j) {
	                return this.data[this.getKey(i, j)];
	            };
	
	            /**
	             * Set a value.
	             * @method set
	             * @param  {Number} i
	             * @param  {Number} j
	             * @param {Number} value
	             */
	            TupleDictionary.prototype.set = function (i, j, value) {
	                if (!value) {
	                    throw new Error("No data!");
	                }
	
	                var key = this.getKey(i, j);
	
	                // Check if key already exists
	                if (!this.data[key]) {
	                    this.keys.push(key);
	                }
	
	                this.data[key] = value;
	
	                return key;
	            };
	
	            /**
	             * Remove all data.
	             * @method reset
	             */
	            TupleDictionary.prototype.reset = function () {
	                var data = this.data,
	                    keys = this.keys;
	
	                var l = keys.length;
	                while (l--) {
	                    delete data[keys[l]];
	                }
	
	                keys.length = 0;
	            };
	
	            /**
	             * Copy another TupleDictionary. Note that all data in this dictionary will be removed.
	             * @method copy
	             * @param {TupleDictionary} dict The TupleDictionary to copy into this one.
	             */
	            TupleDictionary.prototype.copy = function (dict) {
	                this.reset();
	                Utils.appendArray(this.keys, dict.keys);
	                var l = dict.keys.length;
	                while (l--) {
	                    var key = dict.keys[l];
	                    this.data[key] = dict.data[key];
	                }
	            };
	        }, { "./Utils": 57 }], 57: [function (_dereq_, module, exports) {
	            /* global P2_ARRAY_TYPE */
	
	            module.exports = Utils;
	
	            /**
	             * Misc utility functions
	             * @class Utils
	             * @constructor
	             */
	            function Utils() {}
	
	            /**
	             * Append the values in array b to the array a. See <a href="http://stackoverflow.com/questions/1374126/how-to-append-an-array-to-an-existing-javascript-array/1374131#1374131">this</a> for an explanation.
	             * @method appendArray
	             * @static
	             * @param  {Array} a
	             * @param  {Array} b
	             */
	            Utils.appendArray = function (a, b) {
	                if (b.length < 150000) {
	                    a.push.apply(a, b);
	                } else {
	                    for (var i = 0, len = b.length; i !== len; ++i) {
	                        a.push(b[i]);
	                    }
	                }
	            };
	
	            /**
	             * Garbage free Array.splice(). Does not allocate a new array.
	             * @method splice
	             * @static
	             * @param  {Array} array
	             * @param  {Number} index
	             * @param  {Number} howmany
	             */
	            Utils.splice = function (array, index, howmany) {
	                howmany = howmany || 1;
	                for (var i = index, len = array.length - howmany; i < len; i++) {
	                    array[i] = array[i + howmany];
	                }
	                array.length = len;
	            };
	
	            /**
	             * The array type to use for internal numeric computations throughout the library. Float32Array is used if it is available, but falls back on Array. If you want to set array type manually, inject it via the global variable P2_ARRAY_TYPE. See example below.
	             * @static
	             * @property {function} ARRAY_TYPE
	             * @example
	             *     <script>
	             *         <!-- Inject your preferred array type before loading p2.js -->
	             *         P2_ARRAY_TYPE = Array;
	             *     </script>
	             *     <script src="p2.js"></script>
	             */
	            if (typeof P2_ARRAY_TYPE !== 'undefined') {
	                Utils.ARRAY_TYPE = P2_ARRAY_TYPE;
	            } else if (typeof Float32Array !== 'undefined') {
	                Utils.ARRAY_TYPE = Float32Array;
	            } else {
	                Utils.ARRAY_TYPE = Array;
	            }
	
	            /**
	             * Extend an object with the properties of another
	             * @static
	             * @method extend
	             * @param  {object} a
	             * @param  {object} b
	             */
	            Utils.extend = function (a, b) {
	                for (var key in b) {
	                    a[key] = b[key];
	                }
	            };
	
	            /**
	             * Extend an options object with default values.
	             * @static
	             * @method defaults
	             * @param  {object} options The options object. May be falsy: in this case, a new object is created and returned.
	             * @param  {object} defaults An object containing default values.
	             * @return {object} The modified options object.
	             */
	            Utils.defaults = function (options, defaults) {
	                options = options || {};
	                for (var key in defaults) {
	                    if (!(key in options)) {
	                        options[key] = defaults[key];
	                    }
	                }
	                return options;
	            };
	        }, {}], 58: [function (_dereq_, module, exports) {
	            var Body = _dereq_('../objects/Body');
	
	            module.exports = Island;
	
	            /**
	             * An island of bodies connected with equations.
	             * @class Island
	             * @constructor
	             */
	            function Island() {
	
	                /**
	                 * Current equations in this island.
	                 * @property equations
	                 * @type {Array}
	                 */
	                this.equations = [];
	
	                /**
	                 * Current bodies in this island.
	                 * @property bodies
	                 * @type {Array}
	                 */
	                this.bodies = [];
	            }
	
	            /**
	             * Clean this island from bodies and equations.
	             * @method reset
	             */
	            Island.prototype.reset = function () {
	                this.equations.length = this.bodies.length = 0;
	            };
	
	            var bodyIds = [];
	
	            /**
	             * Get all unique bodies in this island.
	             * @method getBodies
	             * @return {Array} An array of Body
	             */
	            Island.prototype.getBodies = function (result) {
	                var bodies = result || [],
	                    eqs = this.equations;
	                bodyIds.length = 0;
	                for (var i = 0; i !== eqs.length; i++) {
	                    var eq = eqs[i];
	                    if (bodyIds.indexOf(eq.bodyA.id) === -1) {
	                        bodies.push(eq.bodyA);
	                        bodyIds.push(eq.bodyA.id);
	                    }
	                    if (bodyIds.indexOf(eq.bodyB.id) === -1) {
	                        bodies.push(eq.bodyB);
	                        bodyIds.push(eq.bodyB.id);
	                    }
	                }
	                return bodies;
	            };
	
	            /**
	             * Check if the entire island wants to sleep.
	             * @method wantsToSleep
	             * @return {Boolean}
	             */
	            Island.prototype.wantsToSleep = function () {
	                for (var i = 0; i < this.bodies.length; i++) {
	                    var b = this.bodies[i];
	                    if (b.type === Body.DYNAMIC && !b.wantsToSleep) {
	                        return false;
	                    }
	                }
	                return true;
	            };
	
	            /**
	             * Make all bodies in the island sleep.
	             * @method sleep
	             */
	            Island.prototype.sleep = function () {
	                for (var i = 0; i < this.bodies.length; i++) {
	                    var b = this.bodies[i];
	                    b.sleep();
	                }
	                return true;
	            };
	        }, { "../objects/Body": 31 }], 59: [function (_dereq_, module, exports) {
	            var vec2 = _dereq_('../math/vec2'),
	                Island = _dereq_('./Island'),
	                IslandNode = _dereq_('./IslandNode'),
	                IslandNodePool = _dereq_('./../utils/IslandNodePool'),
	                IslandPool = _dereq_('./../utils/IslandPool'),
	                Body = _dereq_('../objects/Body');
	
	            module.exports = IslandManager;
	
	            /**
	             * Splits the system of bodies and equations into independent islands
	             *
	             * @class IslandManager
	             * @constructor
	             * @param {Object} [options]
	             * @extends Solver
	             */
	            function IslandManager(options) {
	
	                /**
	                 * @property nodePool
	                 * @type {IslandNodePool}
	                 */
	                this.nodePool = new IslandNodePool({ size: 16 });
	
	                /**
	                 * @property islandPool
	                 * @type {IslandPool}
	                 */
	                this.islandPool = new IslandPool({ size: 8 });
	
	                /**
	                 * The equations to split. Manually fill this array before running .split().
	                 * @property {Array} equations
	                 */
	                this.equations = [];
	
	                /**
	                 * The resulting {{#crossLink "Island"}}{{/crossLink}}s.
	                 * @property {Array} islands
	                 */
	                this.islands = [];
	
	                /**
	                 * The resulting graph nodes.
	                 * @property {Array} nodes
	                 */
	                this.nodes = [];
	
	                /**
	                 * The node queue, used when traversing the graph of nodes.
	                 * @private
	                 * @property {Array} queue
	                 */
	                this.queue = [];
	            }
	
	            /**
	             * Get an unvisited node from a list of nodes.
	             * @static
	             * @method getUnvisitedNode
	             * @param  {Array} nodes
	             * @return {IslandNode|boolean} The node if found, else false.
	             */
	            IslandManager.getUnvisitedNode = function (nodes) {
	                var Nnodes = nodes.length;
	                for (var i = 0; i !== Nnodes; i++) {
	                    var node = nodes[i];
	                    if (!node.visited && node.body.type === Body.DYNAMIC) {
	                        return node;
	                    }
	                }
	                return false;
	            };
	
	            /**
	             * Visit a node.
	             * @method visit
	             * @param  {IslandNode} node
	             * @param  {Array} bds
	             * @param  {Array} eqs
	             */
	            IslandManager.prototype.visit = function (node, bds, eqs) {
	                bds.push(node.body);
	                var Neqs = node.equations.length;
	                for (var i = 0; i !== Neqs; i++) {
	                    var eq = node.equations[i];
	                    if (eqs.indexOf(eq) === -1) {
	                        // Already added?
	                        eqs.push(eq);
	                    }
	                }
	            };
	
	            /**
	             * Runs the search algorithm, starting at a root node. The resulting bodies and equations will be stored in the provided arrays.
	             * @method bfs
	             * @param  {IslandNode} root The node to start from
	             * @param  {Array} bds  An array to append resulting Bodies to.
	             * @param  {Array} eqs  An array to append resulting Equations to.
	             */
	            IslandManager.prototype.bfs = function (root, bds, eqs) {
	
	                // Reset the visit queue
	                var queue = this.queue;
	                queue.length = 0;
	
	                // Add root node to queue
	                queue.push(root);
	                root.visited = true;
	                this.visit(root, bds, eqs);
	
	                // Process all queued nodes
	                while (queue.length) {
	
	                    // Get next node in the queue
	                    var node = queue.pop();
	
	                    // Visit unvisited neighboring nodes
	                    var child;
	                    while (child = IslandManager.getUnvisitedNode(node.neighbors)) {
	                        child.visited = true;
	                        this.visit(child, bds, eqs);
	
	                        // Only visit the children of this node if it's dynamic
	                        if (child.body.type === Body.DYNAMIC) {
	                            queue.push(child);
	                        }
	                    }
	                }
	            };
	
	            /**
	             * Split the world into independent islands. The result is stored in .islands.
	             * @method split
	             * @param  {World} world
	             * @return {Array} The generated islands
	             */
	            IslandManager.prototype.split = function (world) {
	                var bodies = world.bodies,
	                    nodes = this.nodes,
	                    equations = this.equations;
	
	                // Move old nodes to the node pool
	                while (nodes.length) {
	                    this.nodePool.release(nodes.pop());
	                }
	
	                // Create needed nodes, reuse if possible
	                for (var i = 0; i !== bodies.length; i++) {
	                    var node = this.nodePool.get();
	                    node.body = bodies[i];
	                    nodes.push(node);
	                    // if(this.nodePool.length){
	                    //     var node = this.nodePool.pop();
	                    //     node.reset();
	                    //     node.body = bodies[i];
	                    //     nodes.push(node);
	                    // } else {
	                    //     nodes.push(new IslandNode(bodies[i]));
	                    // }
	                }
	
	                // Add connectivity data. Each equation connects 2 bodies.
	                for (var k = 0; k !== equations.length; k++) {
	                    var eq = equations[k],
	                        i = bodies.indexOf(eq.bodyA),
	                        j = bodies.indexOf(eq.bodyB),
	                        ni = nodes[i],
	                        nj = nodes[j];
	                    ni.neighbors.push(nj);
	                    nj.neighbors.push(ni);
	                    ni.equations.push(eq);
	                    nj.equations.push(eq);
	                }
	
	                // Move old islands to the island pool
	                var islands = this.islands;
	                for (var i = 0; i < islands.length; i++) {
	                    this.islandPool.release(islands[i]);
	                }
	                islands.length = 0;
	
	                // Get islands
	                var child;
	                while (child = IslandManager.getUnvisitedNode(nodes)) {
	
	                    // Create new island
	                    var island = this.islandPool.get();
	
	                    // Get all equations and bodies in this island
	                    this.bfs(child, island.bodies, island.equations);
	
	                    islands.push(island);
	                }
	
	                return islands;
	            };
	        }, { "../math/vec2": 30, "../objects/Body": 31, "./../utils/IslandNodePool": 50, "./../utils/IslandPool": 51, "./Island": 58, "./IslandNode": 60 }], 60: [function (_dereq_, module, exports) {
	            module.exports = IslandNode;
	
	            /**
	             * Holds a body and keeps track of some additional properties needed for graph traversal.
	             * @class IslandNode
	             * @constructor
	             * @param {Body} body
	             */
	            function IslandNode(body) {
	
	                /**
	                 * The body that is contained in this node.
	                 * @property {Body} body
	                 */
	                this.body = body;
	
	                /**
	                 * Neighboring IslandNodes
	                 * @property {Array} neighbors
	                 */
	                this.neighbors = [];
	
	                /**
	                 * Equations connected to this node.
	                 * @property {Array} equations
	                 */
	                this.equations = [];
	
	                /**
	                 * If this node was visiting during the graph traversal.
	                 * @property visited
	                 * @type {Boolean}
	                 */
	                this.visited = false;
	            }
	
	            /**
	             * Clean this node from bodies and equations.
	             * @method reset
	             */
	            IslandNode.prototype.reset = function () {
	                this.equations.length = 0;
	                this.neighbors.length = 0;
	                this.visited = false;
	                this.body = null;
	            };
	        }, {}], 61: [function (_dereq_, module, exports) {
	            var GSSolver = _dereq_('../solver/GSSolver'),
	                Solver = _dereq_('../solver/Solver'),
	                Ray = _dereq_('../collision/Ray'),
	                vec2 = _dereq_('../math/vec2'),
	                Circle = _dereq_('../shapes/Circle'),
	                Convex = _dereq_('../shapes/Convex'),
	                Line = _dereq_('../shapes/Line'),
	                Plane = _dereq_('../shapes/Plane'),
	                Capsule = _dereq_('../shapes/Capsule'),
	                Particle = _dereq_('../shapes/Particle'),
	                EventEmitter = _dereq_('../events/EventEmitter'),
	                Body = _dereq_('../objects/Body'),
	                Shape = _dereq_('../shapes/Shape'),
	                LinearSpring = _dereq_('../objects/LinearSpring'),
	                Material = _dereq_('../material/Material'),
	                ContactMaterial = _dereq_('../material/ContactMaterial'),
	                DistanceConstraint = _dereq_('../constraints/DistanceConstraint'),
	                Constraint = _dereq_('../constraints/Constraint'),
	                LockConstraint = _dereq_('../constraints/LockConstraint'),
	                RevoluteConstraint = _dereq_('../constraints/RevoluteConstraint'),
	                PrismaticConstraint = _dereq_('../constraints/PrismaticConstraint'),
	                GearConstraint = _dereq_('../constraints/GearConstraint'),
	                pkg = _dereq_('../../package.json'),
	                Broadphase = _dereq_('../collision/Broadphase'),
	                AABB = _dereq_('../collision/AABB'),
	                SAPBroadphase = _dereq_('../collision/SAPBroadphase'),
	                Narrowphase = _dereq_('../collision/Narrowphase'),
	                Utils = _dereq_('../utils/Utils'),
	                OverlapKeeper = _dereq_('../utils/OverlapKeeper'),
	                IslandManager = _dereq_('./IslandManager'),
	                RotationalSpring = _dereq_('../objects/RotationalSpring');
	
	            module.exports = World;
	
	            /**
	             * The dynamics world, where all bodies and constraints live.
	             *
	             * @class World
	             * @constructor
	             * @param {Object} [options]
	             * @param {Solver} [options.solver] Defaults to GSSolver.
	             * @param {Array} [options.gravity] Defaults to y=-9.78.
	             * @param {Broadphase} [options.broadphase] Defaults to SAPBroadphase
	             * @param {Boolean} [options.islandSplit=true]
	             * @extends EventEmitter
	             *
	             * @example
	             *     var world = new World({
	             *         gravity: [0, -10],
	             *         broadphase: new SAPBroadphase()
	             *     });
	             *     world.addBody(new Body());
	             */
	            function World(options) {
	                EventEmitter.apply(this);
	
	                options = options || {};
	
	                /**
	                 * All springs in the world. To add a spring to the world, use {{#crossLink "World/addSpring:method"}}{{/crossLink}}.
	                 *
	                 * @property springs
	                 * @type {Array}
	                 */
	                this.springs = [];
	
	                /**
	                 * All bodies in the world. To add a body to the world, use {{#crossLink "World/addBody:method"}}{{/crossLink}}.
	                 * @property {Array} bodies
	                 */
	                this.bodies = [];
	
	                /**
	                 * Disabled body collision pairs. See {{#crossLink "World/disableBodyCollision:method"}}.
	                 * @private
	                 * @property {Array} disabledBodyCollisionPairs
	                 */
	                this.disabledBodyCollisionPairs = [];
	
	                /**
	                 * The solver used to satisfy constraints and contacts. Default is {{#crossLink "GSSolver"}}{{/crossLink}}.
	                 * @property {Solver} solver
	                 */
	                this.solver = options.solver || new GSSolver();
	
	                /**
	                 * The narrowphase to use to generate contacts.
	                 *
	                 * @property narrowphase
	                 * @type {Narrowphase}
	                 */
	                this.narrowphase = new Narrowphase(this);
	
	                /**
	                 * The island manager of this world.
	                 * @property {IslandManager} islandManager
	                 */
	                this.islandManager = new IslandManager();
	
	                /**
	                 * Gravity in the world. This is applied on all bodies in the beginning of each step().
	                 *
	                 * @property gravity
	                 * @type {Array}
	                 */
	                this.gravity = vec2.fromValues(0, -9.78);
	                if (options.gravity) {
	                    vec2.copy(this.gravity, options.gravity);
	                }
	
	                /**
	                 * Gravity to use when approximating the friction max force (mu*mass*gravity).
	                 * @property {Number} frictionGravity
	                 */
	                this.frictionGravity = vec2.length(this.gravity) || 10;
	
	                /**
	                 * Set to true if you want .frictionGravity to be automatically set to the length of .gravity.
	                 * @property {Boolean} useWorldGravityAsFrictionGravity
	                 * @default true
	                 */
	                this.useWorldGravityAsFrictionGravity = true;
	
	                /**
	                 * If the length of .gravity is zero, and .useWorldGravityAsFrictionGravity=true, then switch to using .frictionGravity for friction instead. This fallback is useful for gravityless games.
	                 * @property {Boolean} useFrictionGravityOnZeroGravity
	                 * @default true
	                 */
	                this.useFrictionGravityOnZeroGravity = true;
	
	                /**
	                 * The broadphase algorithm to use.
	                 *
	                 * @property broadphase
	                 * @type {Broadphase}
	                 */
	                this.broadphase = options.broadphase || new SAPBroadphase();
	                this.broadphase.setWorld(this);
	
	                /**
	                 * User-added constraints.
	                 *
	                 * @property constraints
	                 * @type {Array}
	                 */
	                this.constraints = [];
	
	                /**
	                 * Dummy default material in the world, used in .defaultContactMaterial
	                 * @property {Material} defaultMaterial
	                 */
	                this.defaultMaterial = new Material();
	
	                /**
	                 * The default contact material to use, if no contact material was set for the colliding materials.
	                 * @property {ContactMaterial} defaultContactMaterial
	                 */
	                this.defaultContactMaterial = new ContactMaterial(this.defaultMaterial, this.defaultMaterial);
	
	                /**
	                 * For keeping track of what time step size we used last step
	                 * @property lastTimeStep
	                 * @type {Number}
	                 */
	                this.lastTimeStep = 1 / 60;
	
	                /**
	                 * Enable to automatically apply spring forces each step.
	                 * @property applySpringForces
	                 * @type {Boolean}
	                 * @default true
	                 */
	                this.applySpringForces = true;
	
	                /**
	                 * Enable to automatically apply body damping each step.
	                 * @property applyDamping
	                 * @type {Boolean}
	                 * @default true
	                 */
	                this.applyDamping = true;
	
	                /**
	                 * Enable to automatically apply gravity each step.
	                 * @property applyGravity
	                 * @type {Boolean}
	                 * @default true
	                 */
	                this.applyGravity = true;
	
	                /**
	                 * Enable/disable constraint solving in each step.
	                 * @property solveConstraints
	                 * @type {Boolean}
	                 * @default true
	                 */
	                this.solveConstraints = true;
	
	                /**
	                 * The ContactMaterials added to the World.
	                 * @property contactMaterials
	                 * @type {Array}
	                 */
	                this.contactMaterials = [];
	
	                /**
	                 * World time.
	                 * @property time
	                 * @type {Number}
	                 */
	                this.time = 0.0;
	                this.accumulator = 0;
	
	                /**
	                 * Is true during step().
	                 * @property {Boolean} stepping
	                 */
	                this.stepping = false;
	
	                /**
	                 * Bodies that are scheduled to be removed at the end of the step.
	                 * @property {Array} bodiesToBeRemoved
	                 * @private
	                 */
	                this.bodiesToBeRemoved = [];
	
	                /**
	                 * Whether to enable island splitting. Island splitting can be an advantage for both precision and performance. See {{#crossLink "IslandManager"}}{{/crossLink}}.
	                 * @property {Boolean} islandSplit
	                 * @default true
	                 */
	                this.islandSplit = typeof options.islandSplit !== "undefined" ? !!options.islandSplit : true;
	
	                /**
	                 * Set to true if you want to the world to emit the "impact" event. Turning this off could improve performance.
	                 * @property emitImpactEvent
	                 * @type {Boolean}
	                 * @default true
	                 */
	                this.emitImpactEvent = true;
	
	                // Id counters
	                this._constraintIdCounter = 0;
	                this._bodyIdCounter = 0;
	
	                /**
	                 * Fired after the step().
	                 * @event postStep
	                 */
	                this.postStepEvent = {
	                    type: "postStep"
	                };
	
	                /**
	                 * Fired when a body is added to the world.
	                 * @event addBody
	                 * @param {Body} body
	                 */
	                this.addBodyEvent = {
	                    type: "addBody",
	                    body: null
	                };
	
	                /**
	                 * Fired when a body is removed from the world.
	                 * @event removeBody
	                 * @param {Body} body
	                 */
	                this.removeBodyEvent = {
	                    type: "removeBody",
	                    body: null
	                };
	
	                /**
	                 * Fired when a spring is added to the world.
	                 * @event addSpring
	                 * @param {Spring} spring
	                 */
	                this.addSpringEvent = {
	                    type: "addSpring",
	                    spring: null
	                };
	
	                /**
	                 * Fired when a first contact is created between two bodies. This event is fired after the step has been done.
	                 * @event impact
	                 * @param {Body} bodyA
	                 * @param {Body} bodyB
	                 */
	                this.impactEvent = {
	                    type: "impact",
	                    bodyA: null,
	                    bodyB: null,
	                    shapeA: null,
	                    shapeB: null,
	                    contactEquation: null
	                };
	
	                /**
	                 * Fired after the Broadphase has collected collision pairs in the world.
	                 * Inside the event handler, you can modify the pairs array as you like, to
	                 * prevent collisions between objects that you don't want.
	                 * @event postBroadphase
	                 * @param {Array} pairs An array of collision pairs. If this array is [body1,body2,body3,body4], then the body pairs 1,2 and 3,4 would advance to narrowphase.
	                 */
	                this.postBroadphaseEvent = {
	                    type: "postBroadphase",
	                    pairs: null
	                };
	
	                /**
	                 * How to deactivate bodies during simulation. Possible modes are: {{#crossLink "World/NO_SLEEPING:property"}}World.NO_SLEEPING{{/crossLink}}, {{#crossLink "World/BODY_SLEEPING:property"}}World.BODY_SLEEPING{{/crossLink}} and {{#crossLink "World/ISLAND_SLEEPING:property"}}World.ISLAND_SLEEPING{{/crossLink}}.
	                 * If sleeping is enabled, you might need to {{#crossLink "Body/wakeUp:method"}}wake up{{/crossLink}} the bodies if they fall asleep when they shouldn't. If you want to enable sleeping in the world, but want to disable it for a particular body, see {{#crossLink "Body/allowSleep:property"}}Body.allowSleep{{/crossLink}}.
	                 * @property sleepMode
	                 * @type {number}
	                 * @default World.NO_SLEEPING
	                 */
	                this.sleepMode = World.NO_SLEEPING;
	
	                /**
	                 * Fired when two shapes starts start to overlap. Fired in the narrowphase, during step.
	                 * @event beginContact
	                 * @param {Shape} shapeA
	                 * @param {Shape} shapeB
	                 * @param {Body}  bodyA
	                 * @param {Body}  bodyB
	                 * @param {Array} contactEquations
	                 */
	                this.beginContactEvent = {
	                    type: "beginContact",
	                    shapeA: null,
	                    shapeB: null,
	                    bodyA: null,
	                    bodyB: null,
	                    contactEquations: []
	                };
	
	                /**
	                 * Fired when two shapes stop overlapping, after the narrowphase (during step).
	                 * @event endContact
	                 * @param {Shape} shapeA
	                 * @param {Shape} shapeB
	                 * @param {Body}  bodyA
	                 * @param {Body}  bodyB
	                 */
	                this.endContactEvent = {
	                    type: "endContact",
	                    shapeA: null,
	                    shapeB: null,
	                    bodyA: null,
	                    bodyB: null
	                };
	
	                /**
	                 * Fired just before equations are added to the solver to be solved. Can be used to control what equations goes into the solver.
	                 * @event preSolve
	                 * @param {Array} contactEquations  An array of contacts to be solved.
	                 * @param {Array} frictionEquations An array of friction equations to be solved.
	                 */
	                this.preSolveEvent = {
	                    type: "preSolve",
	                    contactEquations: null,
	                    frictionEquations: null
	                };
	
	                // For keeping track of overlapping shapes
	                this.overlappingShapesLastState = { keys: [] };
	                this.overlappingShapesCurrentState = { keys: [] };
	
	                /**
	                 * @property {OverlapKeeper} overlapKeeper
	                 */
	                this.overlapKeeper = new OverlapKeeper();
	            }
	            World.prototype = new Object(EventEmitter.prototype);
	            World.prototype.constructor = World;
	
	            /**
	             * Never deactivate bodies.
	             * @static
	             * @property {number} NO_SLEEPING
	             */
	            World.NO_SLEEPING = 1;
	
	            /**
	             * Deactivate individual bodies if they are sleepy.
	             * @static
	             * @property {number} BODY_SLEEPING
	             */
	            World.BODY_SLEEPING = 2;
	
	            /**
	             * Deactivates bodies that are in contact, if all of them are sleepy. Note that you must enable {{#crossLink "World/islandSplit:property"}}.islandSplit{{/crossLink}} for this to work.
	             * @static
	             * @property {number} ISLAND_SLEEPING
	             */
	            World.ISLAND_SLEEPING = 4;
	
	            /**
	             * Add a constraint to the simulation.
	             *
	             * @method addConstraint
	             * @param {Constraint} constraint
	             * @example
	             *     var constraint = new LockConstraint(bodyA, bodyB);
	             *     world.addConstraint(constraint);
	             */
	            World.prototype.addConstraint = function (constraint) {
	                this.constraints.push(constraint);
	            };
	
	            /**
	             * Add a ContactMaterial to the simulation.
	             * @method addContactMaterial
	             * @param {ContactMaterial} contactMaterial
	             */
	            World.prototype.addContactMaterial = function (contactMaterial) {
	                this.contactMaterials.push(contactMaterial);
	            };
	
	            /**
	             * Removes a contact material
	             *
	             * @method removeContactMaterial
	             * @param {ContactMaterial} cm
	             */
	            World.prototype.removeContactMaterial = function (cm) {
	                var idx = this.contactMaterials.indexOf(cm);
	                if (idx !== -1) {
	                    Utils.splice(this.contactMaterials, idx, 1);
	                }
	            };
	
	            /**
	             * Get a contact material given two materials
	             * @method getContactMaterial
	             * @param {Material} materialA
	             * @param {Material} materialB
	             * @return {ContactMaterial} The matching ContactMaterial, or false on fail.
	             * @todo Use faster hash map to lookup from material id's
	             */
	            World.prototype.getContactMaterial = function (materialA, materialB) {
	                var cmats = this.contactMaterials;
	                for (var i = 0, N = cmats.length; i !== N; i++) {
	                    var cm = cmats[i];
	                    if (cm.materialA.id === materialA.id && cm.materialB.id === materialB.id || cm.materialA.id === materialB.id && cm.materialB.id === materialA.id) {
	                        return cm;
	                    }
	                }
	                return false;
	            };
	
	            /**
	             * Removes a constraint
	             *
	             * @method removeConstraint
	             * @param {Constraint} constraint
	             */
	            World.prototype.removeConstraint = function (constraint) {
	                var idx = this.constraints.indexOf(constraint);
	                if (idx !== -1) {
	                    Utils.splice(this.constraints, idx, 1);
	                }
	            };
	
	            var step_r = vec2.create(),
	                step_runit = vec2.create(),
	                step_u = vec2.create(),
	                step_f = vec2.create(),
	                step_fhMinv = vec2.create(),
	                step_velodt = vec2.create(),
	                step_mg = vec2.create(),
	                xiw = vec2.fromValues(0, 0),
	                xjw = vec2.fromValues(0, 0),
	                zero = vec2.fromValues(0, 0),
	                interpvelo = vec2.fromValues(0, 0);
	
	            /**
	             * Step the physics world forward in time.
	             *
	             * There are two modes. The simple mode is fixed timestepping without interpolation. In this case you only use the first argument. The second case uses interpolation. In that you also provide the time since the function was last used, as well as the maximum fixed timesteps to take.
	             *
	             * @method step
	             * @param {Number} dt                       The fixed time step size to use.
	             * @param {Number} [timeSinceLastCalled=0]  The time elapsed since the function was last called.
	             * @param {Number} [maxSubSteps=10]         Maximum number of fixed steps to take per function call.
	             *
	             * @example
	             *     // Simple fixed timestepping without interpolation
	             *     var fixedTimeStep = 1 / 60;
	             *     var world = new World();
	             *     var body = new Body({ mass: 1 });
	             *     world.addBody(body);
	             *
	             *     function animate(){
	             *         requestAnimationFrame(animate);
	             *         world.step(fixedTimeStep);
	             *         renderBody(body.position, body.angle);
	             *     }
	             *
	             *     // Start animation loop
	             *     requestAnimationFrame(animate);
	             *
	             * @example
	             *     // Fixed timestepping with interpolation
	             *     var maxSubSteps = 10;
	             *     var lastTimeSeconds;
	             *
	             *     function animate(t){
	             *         requestAnimationFrame(animate);
	             *         timeSeconds = t / 1000;
	             *         lastTimeSeconds = lastTimeSeconds || timeSeconds;
	             *
	             *         deltaTime = timeSeconds - lastTimeSeconds;
	             *         world.step(fixedTimeStep, deltaTime, maxSubSteps);
	             *
	             *         renderBody(body.interpolatedPosition, body.interpolatedAngle);
	             *     }
	             *
	             *     // Start animation loop
	             *     requestAnimationFrame(animate);
	             *
	             * @see http://bulletphysics.org/mediawiki-1.5.8/index.php/Stepping_The_World
	             */
	            World.prototype.step = function (dt, timeSinceLastCalled, maxSubSteps) {
	                maxSubSteps = maxSubSteps || 10;
	                timeSinceLastCalled = timeSinceLastCalled || 0;
	
	                if (timeSinceLastCalled === 0) {
	                    // Fixed, simple stepping
	
	                    this.internalStep(dt);
	
	                    // Increment time
	                    this.time += dt;
	                } else {
	
	                    this.accumulator += timeSinceLastCalled;
	                    var substeps = 0;
	                    while (this.accumulator >= dt && substeps < maxSubSteps) {
	                        // Do fixed steps to catch up
	                        this.internalStep(dt);
	                        this.time += dt;
	                        this.accumulator -= dt;
	                        substeps++;
	                    }
	
	                    var t = this.accumulator % dt / dt;
	                    for (var j = 0; j !== this.bodies.length; j++) {
	                        var b = this.bodies[j];
	                        vec2.lerp(b.interpolatedPosition, b.previousPosition, b.position, t);
	                        b.interpolatedAngle = b.previousAngle + t * (b.angle - b.previousAngle);
	                    }
	                }
	            };
	
	            var endOverlaps = [];
	
	            /**
	             * Make a fixed step.
	             * @method internalStep
	             * @param  {number} dt
	             * @private
	             */
	            World.prototype.internalStep = function (dt) {
	                this.stepping = true;
	
	                var that = this,
	                    Nsprings = this.springs.length,
	                    springs = this.springs,
	                    bodies = this.bodies,
	                    g = this.gravity,
	                    solver = this.solver,
	                    Nbodies = this.bodies.length,
	                    broadphase = this.broadphase,
	                    np = this.narrowphase,
	                    constraints = this.constraints,
	                    t0,
	                    t1,
	                    fhMinv = step_fhMinv,
	                    velodt = step_velodt,
	                    mg = step_mg,
	                    scale = vec2.scale,
	                    add = vec2.add,
	                    rotate = vec2.rotate,
	                    islandManager = this.islandManager;
	
	                this.overlapKeeper.tick();
	
	                this.lastTimeStep = dt;
	
	                // Update approximate friction gravity.
	                if (this.useWorldGravityAsFrictionGravity) {
	                    var gravityLen = vec2.length(this.gravity);
	                    if (!(gravityLen === 0 && this.useFrictionGravityOnZeroGravity)) {
	                        // Nonzero gravity. Use it.
	                        this.frictionGravity = gravityLen;
	                    }
	                }
	
	                // Add gravity to bodies
	                if (this.applyGravity) {
	                    for (var i = 0; i !== Nbodies; i++) {
	                        var b = bodies[i],
	                            fi = b.force;
	                        if (b.type !== Body.DYNAMIC || b.sleepState === Body.SLEEPING) {
	                            continue;
	                        }
	                        vec2.scale(mg, g, b.mass * b.gravityScale); // F=m*g
	                        add(fi, fi, mg);
	                    }
	                }
	
	                // Add spring forces
	                if (this.applySpringForces) {
	                    for (var i = 0; i !== Nsprings; i++) {
	                        var s = springs[i];
	                        s.applyForce();
	                    }
	                }
	
	                if (this.applyDamping) {
	                    for (var i = 0; i !== Nbodies; i++) {
	                        var b = bodies[i];
	                        if (b.type === Body.DYNAMIC) {
	                            b.applyDamping(dt);
	                        }
	                    }
	                }
	
	                // Broadphase
	                var result = broadphase.getCollisionPairs(this);
	
	                // Remove ignored collision pairs
	                var ignoredPairs = this.disabledBodyCollisionPairs;
	                for (var i = ignoredPairs.length - 2; i >= 0; i -= 2) {
	                    for (var j = result.length - 2; j >= 0; j -= 2) {
	                        if (ignoredPairs[i] === result[j] && ignoredPairs[i + 1] === result[j + 1] || ignoredPairs[i + 1] === result[j] && ignoredPairs[i] === result[j + 1]) {
	                            result.splice(j, 2);
	                        }
	                    }
	                }
	
	                // Remove constrained pairs with collideConnected == false
	                var Nconstraints = constraints.length;
	                for (i = 0; i !== Nconstraints; i++) {
	                    var c = constraints[i];
	                    if (!c.collideConnected) {
	                        for (var j = result.length - 2; j >= 0; j -= 2) {
	                            if (c.bodyA === result[j] && c.bodyB === result[j + 1] || c.bodyB === result[j] && c.bodyA === result[j + 1]) {
	                                result.splice(j, 2);
	                            }
	                        }
	                    }
	                }
	
	                // postBroadphase event
	                this.postBroadphaseEvent.pairs = result;
	                this.emit(this.postBroadphaseEvent);
	                this.postBroadphaseEvent.pairs = null;
	
	                // Narrowphase
	                np.reset(this);
	                for (var i = 0, Nresults = result.length; i !== Nresults; i += 2) {
	                    var bi = result[i],
	                        bj = result[i + 1];
	
	                    // Loop over all shapes of body i
	                    for (var k = 0, Nshapesi = bi.shapes.length; k !== Nshapesi; k++) {
	                        var si = bi.shapes[k],
	                            xi = si.position,
	                            ai = si.angle;
	
	                        // All shapes of body j
	                        for (var l = 0, Nshapesj = bj.shapes.length; l !== Nshapesj; l++) {
	                            var sj = bj.shapes[l],
	                                xj = sj.position,
	                                aj = sj.angle;
	
	                            var cm = this.defaultContactMaterial;
	                            if (si.material && sj.material) {
	                                var tmp = this.getContactMaterial(si.material, sj.material);
	                                if (tmp) {
	                                    cm = tmp;
	                                }
	                            }
	
	                            this.runNarrowphase(np, bi, si, xi, ai, bj, sj, xj, aj, cm, this.frictionGravity);
	                        }
	                    }
	                }
	
	                // Wake up bodies
	                for (var i = 0; i !== Nbodies; i++) {
	                    var body = bodies[i];
	                    if (body._wakeUpAfterNarrowphase) {
	                        body.wakeUp();
	                        body._wakeUpAfterNarrowphase = false;
	                    }
	                }
	
	                // Emit end overlap events
	                if (this.has('endContact')) {
	                    this.overlapKeeper.getEndOverlaps(endOverlaps);
	                    var e = this.endContactEvent;
	                    var l = endOverlaps.length;
	                    while (l--) {
	                        var data = endOverlaps[l];
	                        e.shapeA = data.shapeA;
	                        e.shapeB = data.shapeB;
	                        e.bodyA = data.bodyA;
	                        e.bodyB = data.bodyB;
	                        this.emit(e);
	                    }
	                    endOverlaps.length = 0;
	                }
	
	                var preSolveEvent = this.preSolveEvent;
	                preSolveEvent.contactEquations = np.contactEquations;
	                preSolveEvent.frictionEquations = np.frictionEquations;
	                this.emit(preSolveEvent);
	                preSolveEvent.contactEquations = preSolveEvent.frictionEquations = null;
	
	                // update constraint equations
	                var Nconstraints = constraints.length;
	                for (i = 0; i !== Nconstraints; i++) {
	                    constraints[i].update();
	                }
	
	                if (np.contactEquations.length || np.frictionEquations.length || Nconstraints) {
	                    if (this.islandSplit) {
	                        // Split into islands
	                        islandManager.equations.length = 0;
	                        Utils.appendArray(islandManager.equations, np.contactEquations);
	                        Utils.appendArray(islandManager.equations, np.frictionEquations);
	                        for (i = 0; i !== Nconstraints; i++) {
	                            Utils.appendArray(islandManager.equations, constraints[i].equations);
	                        }
	                        islandManager.split(this);
	
	                        for (var i = 0; i !== islandManager.islands.length; i++) {
	                            var island = islandManager.islands[i];
	                            if (island.equations.length) {
	                                solver.solveIsland(dt, island);
	                            }
	                        }
	                    } else {
	
	                        // Add contact equations to solver
	                        solver.addEquations(np.contactEquations);
	                        solver.addEquations(np.frictionEquations);
	
	                        // Add user-defined constraint equations
	                        for (i = 0; i !== Nconstraints; i++) {
	                            solver.addEquations(constraints[i].equations);
	                        }
	
	                        if (this.solveConstraints) {
	                            solver.solve(dt, this);
	                        }
	
	                        solver.removeAllEquations();
	                    }
	                }
	
	                // Step forward
	                for (var i = 0; i !== Nbodies; i++) {
	                    var body = bodies[i];
	
	                    // if(body.sleepState !== Body.SLEEPING && body.type !== Body.STATIC){
	                    body.integrate(dt);
	                    // }
	                }
	
	                // Reset force
	                for (var i = 0; i !== Nbodies; i++) {
	                    bodies[i].setZeroForce();
	                }
	
	                // Emit impact event
	                if (this.emitImpactEvent && this.has('impact')) {
	                    var ev = this.impactEvent;
	                    for (var i = 0; i !== np.contactEquations.length; i++) {
	                        var eq = np.contactEquations[i];
	                        if (eq.firstImpact) {
	                            ev.bodyA = eq.bodyA;
	                            ev.bodyB = eq.bodyB;
	                            ev.shapeA = eq.shapeA;
	                            ev.shapeB = eq.shapeB;
	                            ev.contactEquation = eq;
	                            this.emit(ev);
	                        }
	                    }
	                }
	
	                // Sleeping update
	                if (this.sleepMode === World.BODY_SLEEPING) {
	                    for (i = 0; i !== Nbodies; i++) {
	                        bodies[i].sleepTick(this.time, false, dt);
	                    }
	                } else if (this.sleepMode === World.ISLAND_SLEEPING && this.islandSplit) {
	
	                    // Tell all bodies to sleep tick but dont sleep yet
	                    for (i = 0; i !== Nbodies; i++) {
	                        bodies[i].sleepTick(this.time, true, dt);
	                    }
	
	                    // Sleep islands
	                    for (var i = 0; i < this.islandManager.islands.length; i++) {
	                        var island = this.islandManager.islands[i];
	                        if (island.wantsToSleep()) {
	                            island.sleep();
	                        }
	                    }
	                }
	
	                this.stepping = false;
	
	                // Remove bodies that are scheduled for removal
	                var bodiesToBeRemoved = this.bodiesToBeRemoved;
	                for (var i = 0; i !== bodiesToBeRemoved.length; i++) {
	                    this.removeBody(bodiesToBeRemoved[i]);
	                }
	                bodiesToBeRemoved.length = 0;
	
	                this.emit(this.postStepEvent);
	            };
	
	            /**
	             * Runs narrowphase for the shape pair i and j.
	             * @method runNarrowphase
	             * @param  {Narrowphase} np
	             * @param  {Body} bi
	             * @param  {Shape} si
	             * @param  {Array} xi
	             * @param  {Number} ai
	             * @param  {Body} bj
	             * @param  {Shape} sj
	             * @param  {Array} xj
	             * @param  {Number} aj
	             * @param  {Number} mu
	             */
	            World.prototype.runNarrowphase = function (np, bi, si, xi, ai, bj, sj, xj, aj, cm, glen) {
	
	                // Check collision groups and masks
	                if (!((si.collisionGroup & sj.collisionMask) !== 0 && (sj.collisionGroup & si.collisionMask) !== 0)) {
	                    return;
	                }
	
	                // Get world position and angle of each shape
	                vec2.rotate(xiw, xi, bi.angle);
	                vec2.rotate(xjw, xj, bj.angle);
	                vec2.add(xiw, xiw, bi.position);
	                vec2.add(xjw, xjw, bj.position);
	                var aiw = ai + bi.angle;
	                var ajw = aj + bj.angle;
	
	                np.enableFriction = cm.friction > 0;
	                np.frictionCoefficient = cm.friction;
	                var reducedMass;
	                if (bi.type === Body.STATIC || bi.type === Body.KINEMATIC) {
	                    reducedMass = bj.mass;
	                } else if (bj.type === Body.STATIC || bj.type === Body.KINEMATIC) {
	                    reducedMass = bi.mass;
	                } else {
	                    reducedMass = bi.mass * bj.mass / (bi.mass + bj.mass);
	                }
	                np.slipForce = cm.friction * glen * reducedMass;
	                np.restitution = cm.restitution;
	                np.surfaceVelocity = cm.surfaceVelocity;
	                np.frictionStiffness = cm.frictionStiffness;
	                np.frictionRelaxation = cm.frictionRelaxation;
	                np.stiffness = cm.stiffness;
	                np.relaxation = cm.relaxation;
	                np.contactSkinSize = cm.contactSkinSize;
	                np.enabledEquations = bi.collisionResponse && bj.collisionResponse && si.collisionResponse && sj.collisionResponse;
	
	                var resolver = np[si.type | sj.type],
	                    numContacts = 0;
	                if (resolver) {
	                    var sensor = si.sensor || sj.sensor;
	                    var numFrictionBefore = np.frictionEquations.length;
	                    if (si.type < sj.type) {
	                        numContacts = resolver.call(np, bi, si, xiw, aiw, bj, sj, xjw, ajw, sensor);
	                    } else {
	                        numContacts = resolver.call(np, bj, sj, xjw, ajw, bi, si, xiw, aiw, sensor);
	                    }
	                    var numFrictionEquations = np.frictionEquations.length - numFrictionBefore;
	
	                    if (numContacts) {
	
	                        if (bi.allowSleep && bi.type === Body.DYNAMIC && bi.sleepState === Body.SLEEPING && bj.sleepState === Body.AWAKE && bj.type !== Body.STATIC) {
	                            var speedSquaredB = vec2.squaredLength(bj.velocity) + Math.pow(bj.angularVelocity, 2);
	                            var speedLimitSquaredB = Math.pow(bj.sleepSpeedLimit, 2);
	                            if (speedSquaredB >= speedLimitSquaredB * 2) {
	                                bi._wakeUpAfterNarrowphase = true;
	                            }
	                        }
	
	                        if (bj.allowSleep && bj.type === Body.DYNAMIC && bj.sleepState === Body.SLEEPING && bi.sleepState === Body.AWAKE && bi.type !== Body.STATIC) {
	                            var speedSquaredA = vec2.squaredLength(bi.velocity) + Math.pow(bi.angularVelocity, 2);
	                            var speedLimitSquaredA = Math.pow(bi.sleepSpeedLimit, 2);
	                            if (speedSquaredA >= speedLimitSquaredA * 2) {
	                                bj._wakeUpAfterNarrowphase = true;
	                            }
	                        }
	
	                        this.overlapKeeper.setOverlapping(bi, si, bj, sj);
	                        if (this.has('beginContact') && this.overlapKeeper.isNewOverlap(si, sj)) {
	
	                            // Report new shape overlap
	                            var e = this.beginContactEvent;
	                            e.shapeA = si;
	                            e.shapeB = sj;
	                            e.bodyA = bi;
	                            e.bodyB = bj;
	
	                            // Reset contact equations
	                            e.contactEquations.length = 0;
	
	                            if (typeof numContacts === "number") {
	                                for (var i = np.contactEquations.length - numContacts; i < np.contactEquations.length; i++) {
	                                    e.contactEquations.push(np.contactEquations[i]);
	                                }
	                            }
	
	                            this.emit(e);
	                        }
	
	                        // divide the max friction force by the number of contacts
	                        if (typeof numContacts === "number" && numFrictionEquations > 1) {
	                            // Why divide by 1?
	                            for (var i = np.frictionEquations.length - numFrictionEquations; i < np.frictionEquations.length; i++) {
	                                var f = np.frictionEquations[i];
	                                f.setSlipForce(f.getSlipForce() / numFrictionEquations);
	                            }
	                        }
	                    }
	                }
	            };
	
	            /**
	             * Add a spring to the simulation
	             *
	             * @method addSpring
	             * @param {Spring} spring
	             */
	            World.prototype.addSpring = function (spring) {
	                this.springs.push(spring);
	                var evt = this.addSpringEvent;
	                evt.spring = spring;
	                this.emit(evt);
	                evt.spring = null;
	            };
	
	            /**
	             * Remove a spring
	             *
	             * @method removeSpring
	             * @param {Spring} spring
	             */
	            World.prototype.removeSpring = function (spring) {
	                var idx = this.springs.indexOf(spring);
	                if (idx !== -1) {
	                    Utils.splice(this.springs, idx, 1);
	                }
	            };
	
	            /**
	             * Add a body to the simulation
	             *
	             * @method addBody
	             * @param {Body} body
	             *
	             * @example
	             *     var world = new World(),
	             *         body = new Body();
	             *     world.addBody(body);
	             * @todo What if this is done during step?
	             */
	            World.prototype.addBody = function (body) {
	                if (this.bodies.indexOf(body) === -1) {
	                    this.bodies.push(body);
	                    body.world = this;
	                    var evt = this.addBodyEvent;
	                    evt.body = body;
	                    this.emit(evt);
	                    evt.body = null;
	                }
	            };
	
	            /**
	             * Remove a body from the simulation. If this method is called during step(), the body removal is scheduled to after the step.
	             *
	             * @method removeBody
	             * @param {Body} body
	             */
	            World.prototype.removeBody = function (body) {
	                if (this.stepping) {
	                    this.bodiesToBeRemoved.push(body);
	                } else {
	                    body.world = null;
	                    var idx = this.bodies.indexOf(body);
	                    if (idx !== -1) {
	                        Utils.splice(this.bodies, idx, 1);
	                        this.removeBodyEvent.body = body;
	                        body.resetConstraintVelocity();
	                        this.emit(this.removeBodyEvent);
	                        this.removeBodyEvent.body = null;
	                    }
	                }
	            };
	
	            /**
	             * Get a body by its id.
	             * @method getBodyById
	             * @param {number} id
	             * @return {Body} The body, or false if it was not found.
	             */
	            World.prototype.getBodyById = function (id) {
	                var bodies = this.bodies;
	                for (var i = 0; i < bodies.length; i++) {
	                    var b = bodies[i];
	                    if (b.id === id) {
	                        return b;
	                    }
	                }
	                return false;
	            };
	
	            /**
	             * Disable collision between two bodies
	             * @method disableBodyCollision
	             * @param {Body} bodyA
	             * @param {Body} bodyB
	             */
	            World.prototype.disableBodyCollision = function (bodyA, bodyB) {
	                this.disabledBodyCollisionPairs.push(bodyA, bodyB);
	            };
	
	            /**
	             * Enable collisions between the given two bodies
	             * @method enableBodyCollision
	             * @param {Body} bodyA
	             * @param {Body} bodyB
	             */
	            World.prototype.enableBodyCollision = function (bodyA, bodyB) {
	                var pairs = this.disabledBodyCollisionPairs;
	                for (var i = 0; i < pairs.length; i += 2) {
	                    if (pairs[i] === bodyA && pairs[i + 1] === bodyB || pairs[i + 1] === bodyA && pairs[i] === bodyB) {
	                        pairs.splice(i, 2);
	                        return;
	                    }
	                }
	            };
	
	            /**
	             * Resets the World, removes all bodies, constraints and springs.
	             *
	             * @method clear
	             */
	            World.prototype.clear = function () {
	
	                this.time = 0;
	
	                // Remove all solver equations
	                if (this.solver && this.solver.equations.length) {
	                    this.solver.removeAllEquations();
	                }
	
	                // Remove all constraints
	                var cs = this.constraints;
	                for (var i = cs.length - 1; i >= 0; i--) {
	                    this.removeConstraint(cs[i]);
	                }
	
	                // Remove all bodies
	                var bodies = this.bodies;
	                for (var i = bodies.length - 1; i >= 0; i--) {
	                    this.removeBody(bodies[i]);
	                }
	
	                // Remove all springs
	                var springs = this.springs;
	                for (var i = springs.length - 1; i >= 0; i--) {
	                    this.removeSpring(springs[i]);
	                }
	
	                // Remove all contact materials
	                var cms = this.contactMaterials;
	                for (var i = cms.length - 1; i >= 0; i--) {
	                    this.removeContactMaterial(cms[i]);
	                }
	
	                World.apply(this);
	            };
	
	            var hitTest_tmp1 = vec2.create(),
	                hitTest_zero = vec2.fromValues(0, 0),
	                hitTest_tmp2 = vec2.fromValues(0, 0);
	
	            /**
	             * Test if a world point overlaps bodies
	             * @method hitTest
	             * @param  {Array}  worldPoint  Point to use for intersection tests
	             * @param  {Array}  bodies      A list of objects to check for intersection
	             * @param  {Number} precision   Used for matching against particles and lines. Adds some margin to these infinitesimal objects.
	             * @return {Array}              Array of bodies that overlap the point
	             * @todo Should use an api similar to the raycast function
	             * @todo Should probably implement a .containsPoint method for all shapes. Would be more efficient
	             */
	            World.prototype.hitTest = function (worldPoint, bodies, precision) {
	                precision = precision || 0;
	
	                // Create a dummy particle body with a particle shape to test against the bodies
	                var pb = new Body({ position: worldPoint }),
	                    ps = new Particle(),
	                    px = worldPoint,
	                    pa = 0,
	                    x = hitTest_tmp1,
	                    zero = hitTest_zero,
	                    tmp = hitTest_tmp2;
	                pb.addShape(ps);
	
	                var n = this.narrowphase,
	                    result = [];
	
	                // Check bodies
	                for (var i = 0, N = bodies.length; i !== N; i++) {
	                    var b = bodies[i];
	
	                    for (var j = 0, NS = b.shapes.length; j !== NS; j++) {
	                        var s = b.shapes[j];
	
	                        // Get shape world position + angle
	                        vec2.rotate(x, s.position, b.angle);
	                        vec2.add(x, x, b.position);
	                        var a = s.angle + b.angle;
	
	                        if (s instanceof Circle && n.circleParticle(b, s, x, a, pb, ps, px, pa, true) || s instanceof Convex && n.particleConvex(pb, ps, px, pa, b, s, x, a, true) || s instanceof Plane && n.particlePlane(pb, ps, px, pa, b, s, x, a, true) || s instanceof Capsule && n.particleCapsule(pb, ps, px, pa, b, s, x, a, true) || s instanceof Particle && vec2.squaredLength(vec2.sub(tmp, x, worldPoint)) < precision * precision) {
	                            result.push(b);
	                        }
	                    }
	                }
	
	                return result;
	            };
	
	            /**
	             * Set the stiffness for all equations and contact materials.
	             * @method setGlobalStiffness
	             * @param {Number} stiffness
	             */
	            World.prototype.setGlobalStiffness = function (stiffness) {
	
	                // Set for all constraints
	                var constraints = this.constraints;
	                for (var i = 0; i !== constraints.length; i++) {
	                    var c = constraints[i];
	                    for (var j = 0; j !== c.equations.length; j++) {
	                        var eq = c.equations[j];
	                        eq.stiffness = stiffness;
	                        eq.needsUpdate = true;
	                    }
	                }
	
	                // Set for all contact materials
	                var contactMaterials = this.contactMaterials;
	                for (var i = 0; i !== contactMaterials.length; i++) {
	                    var c = contactMaterials[i];
	                    c.stiffness = c.frictionStiffness = stiffness;
	                }
	
	                // Set for default contact material
	                var c = this.defaultContactMaterial;
	                c.stiffness = c.frictionStiffness = stiffness;
	            };
	
	            /**
	             * Set the relaxation for all equations and contact materials.
	             * @method setGlobalRelaxation
	             * @param {Number} relaxation
	             */
	            World.prototype.setGlobalRelaxation = function (relaxation) {
	
	                // Set for all constraints
	                for (var i = 0; i !== this.constraints.length; i++) {
	                    var c = this.constraints[i];
	                    for (var j = 0; j !== c.equations.length; j++) {
	                        var eq = c.equations[j];
	                        eq.relaxation = relaxation;
	                        eq.needsUpdate = true;
	                    }
	                }
	
	                // Set for all contact materials
	                for (var i = 0; i !== this.contactMaterials.length; i++) {
	                    var c = this.contactMaterials[i];
	                    c.relaxation = c.frictionRelaxation = relaxation;
	                }
	
	                // Set for default contact material
	                var c = this.defaultContactMaterial;
	                c.relaxation = c.frictionRelaxation = relaxation;
	            };
	
	            var tmpAABB = new AABB();
	            var tmpArray = [];
	
	            /**
	             * Ray cast against all bodies in the world.
	             * @method raycast
	             * @param  {RaycastResult} result
	             * @param  {Ray} ray
	             * @return {boolean} True if any body was hit.
	             *
	             * @example
	             *     var ray = new Ray({
	             *         mode: Ray.CLOSEST, // or ANY
	             *         from: [0, 0],
	             *         to: [10, 0],
	             *     });
	             *     var result = new RaycastResult();
	             *     world.raycast(result, ray);
	             *
	             *     // Get the hit point
	             *     var hitPoint = vec2.create();
	             *     result.getHitPoint(hitPoint, ray);
	             *     console.log('Hit point: ', hitPoint[0], hitPoint[1], ' at distance ' + result.getHitDistance(ray));
	             *
	             * @example
	             *     var ray = new Ray({
	             *         mode: Ray.ALL,
	             *         from: [0, 0],
	             *         to: [10, 0],
	             *         callback: function(result){
	             *
	             *             // Print some info about the hit
	             *             console.log('Hit body and shape: ', result.body, result.shape);
	             *
	             *             // Get the hit point
	             *             var hitPoint = vec2.create();
	             *             result.getHitPoint(hitPoint, ray);
	             *             console.log('Hit point: ', hitPoint[0], hitPoint[1], ' at distance ' + result.getHitDistance(ray));
	             *
	             *             // If you are happy with the hits you got this far, you can stop the traversal here:
	             *             result.stop();
	             *         }
	             *     });
	             *     var result = new RaycastResult();
	             *     world.raycast(result, ray);
	             */
	            World.prototype.raycast = function (result, ray) {
	
	                // Get all bodies within the ray AABB
	                ray.getAABB(tmpAABB);
	                this.broadphase.aabbQuery(this, tmpAABB, tmpArray);
	                ray.intersectBodies(result, tmpArray);
	                tmpArray.length = 0;
	
	                return result.hasHit();
	            };
	        }, { "../../package.json": 6, "../collision/AABB": 7, "../collision/Broadphase": 8, "../collision/Narrowphase": 10, "../collision/Ray": 11, "../collision/SAPBroadphase": 13, "../constraints/Constraint": 14, "../constraints/DistanceConstraint": 15, "../constraints/GearConstraint": 16, "../constraints/LockConstraint": 17, "../constraints/PrismaticConstraint": 18, "../constraints/RevoluteConstraint": 19, "../events/EventEmitter": 26, "../material/ContactMaterial": 27, "../material/Material": 28, "../math/vec2": 30, "../objects/Body": 31, "../objects/LinearSpring": 32, "../objects/RotationalSpring": 33, "../shapes/Capsule": 38, "../shapes/Circle": 39, "../shapes/Convex": 40, "../shapes/Line": 42, "../shapes/Particle": 43, "../shapes/Plane": 44, "../shapes/Shape": 45, "../solver/GSSolver": 46, "../solver/Solver": 47, "../utils/OverlapKeeper": 52, "../utils/Utils": 57, "./IslandManager": 59 }] }, {}, [36])(36);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*
	* @overview
	*
	* Phaser - http://phaser.io
	*
	* v2.6.2 "Kore Springs" - Built: Fri Aug 26 2016 01:03:19
	*
	* By Richard Davey http://www.photonstorm.com @photonstorm
	*
	* Phaser is a fun, free and fast 2D game framework for making HTML5 games
	* for desktop and mobile web browsers, supporting Canvas and WebGL rendering.
	*
	* Phaser uses Pixi.js for rendering, created by Mat Groves http://matgroves.com @Doormat23
	* Phaser uses p2.js for full-body physics, created by Stefan Hedman https://github.com/schteppe/p2.js @schteppe
	* Phaser contains a port of N+ Physics, converted by Richard Davey, original by http://www.metanetsoftware.com
	*
	* Many thanks to Adam Saltsman (@ADAMATOMIC) for releasing Flixel, from which both Phaser and my love of framework development originate.
	*
	* Follow development at http://phaser.io and on our forum
	*
	* "If you want your children to be intelligent,  read them fairy tales."
	* "If you want them to be more intelligent, read them more fairy tales."
	*                                                     -- Albert Einstein
	*//**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*/(function(){var root=this;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* @namespace Phaser
	*/var Phaser=Phaser||{// jshint ignore:line
	/**
	    * The Phaser version number.
	    * @constant
	    * @type {string}
	    */VERSION:'2.6.2',/**
	    * An array of Phaser game instances.
	    * @constant
	    * @type {array}
	    */GAMES:[],/**
	    * AUTO renderer - picks between WebGL or Canvas based on device.
	    * @constant
	    * @type {integer}
	    */AUTO:0,/**
	    * Canvas Renderer.
	    * @constant
	    * @type {integer}
	    */CANVAS:1,/**
	    * WebGL Renderer.
	    * @constant
	    * @type {integer}
	    */WEBGL:2,/**
	    * Headless renderer (not visual output)
	    * @constant
	    * @type {integer}
	    */HEADLESS:3,/**
	    * Direction constant.
	    * @constant
	    * @type {integer}
	    */NONE:0,/**
	    * Direction constant.
	    * @constant
	    * @type {integer}
	    */LEFT:1,/**
	    * Direction constant.
	    * @constant
	    * @type {integer}
	    */RIGHT:2,/**
	    * Direction constant.
	    * @constant
	    * @type {integer}
	    */UP:3,/**
	    * Direction constant.
	    * @constant
	    * @type {integer}
	    */DOWN:4,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */SPRITE:0,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */BUTTON:1,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */IMAGE:2,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */GRAPHICS:3,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */TEXT:4,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */TILESPRITE:5,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */BITMAPTEXT:6,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */GROUP:7,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */RENDERTEXTURE:8,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */TILEMAP:9,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */TILEMAPLAYER:10,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */EMITTER:11,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */POLYGON:12,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */BITMAPDATA:13,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */CANVAS_FILTER:14,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */WEBGL_FILTER:15,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */ELLIPSE:16,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */SPRITEBATCH:17,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */RETROFONT:18,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */POINTER:19,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */ROPE:20,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */CIRCLE:21,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */RECTANGLE:22,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */LINE:23,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */MATRIX:24,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */POINT:25,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */ROUNDEDRECTANGLE:26,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */CREATURE:27,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */VIDEO:28,/**
	    * Game Object type.
	    * @constant
	    * @type {integer}
	    */PENDING_ATLAS:-1,/**
	    * A horizontal orientation
	    * @constant
	    * @type {integer}
	    */HORIZONTAL:0,/**
	    * A vertical orientation
	    * @constant
	    * @type {integer}
	    */VERTICAL:1,/**
	    * A landscape orientation
	    * @constant
	    * @type {integer}
	    */LANDSCAPE:0,/**
	    * A portrait orientation
	    * @constant
	    * @type {integer}
	    */PORTRAIT:1,/**
	    * The Angle (in degrees) a Game Object needs to be set to in order to face up.
	    * @constant
	    * @type {integer}
	    */ANGLE_UP:270,/**
	    * The Angle (in degrees) a Game Object needs to be set to in order to face down.
	    * @constant
	    * @type {integer}
	    */ANGLE_DOWN:90,/**
	    * The Angle (in degrees) a Game Object needs to be set to in order to face left.
	    * @constant
	    * @type {integer}
	    */ANGLE_LEFT:180,/**
	    * The Angle (in degrees) a Game Object needs to be set to in order to face right.
	    * @constant
	    * @type {integer}
	    */ANGLE_RIGHT:0,/**
	    * The Angle (in degrees) a Game Object needs to be set to in order to face north east.
	    * @constant
	    * @type {integer}
	    */ANGLE_NORTH_EAST:315,/**
	    * The Angle (in degrees) a Game Object needs to be set to in order to face north west.
	    * @constant
	    * @type {integer}
	    */ANGLE_NORTH_WEST:225,/**
	    * The Angle (in degrees) a Game Object needs to be set to in order to face south east.
	    * @constant
	    * @type {integer}
	    */ANGLE_SOUTH_EAST:45,/**
	    * The Angle (in degrees) a Game Object needs to be set to in order to face south west.
	    * @constant
	    * @type {integer}
	    */ANGLE_SOUTH_WEST:135,/**
	    * A constant representing a top-left alignment or position.
	    * @constant
	    * @type {integer}
	    */TOP_LEFT:0,/**
	    * A constant representing a top-center alignment or position.
	    * @constant
	    * @type {integer}
	    */TOP_CENTER:1,/**
	    * A constant representing a top-right alignment or position.
	    * @constant
	    * @type {integer}
	    */TOP_RIGHT:2,/**
	    * A constant representing a left-top alignment or position.
	    * @constant
	    * @type {integer}
	    */LEFT_TOP:3,/**
	    * A constant representing a left-center alignment or position.
	    * @constant
	    * @type {integer}
	    */LEFT_CENTER:4,/**
	    * A constant representing a left-bottom alignment or position.
	    * @constant
	    * @type {integer}
	    */LEFT_BOTTOM:5,/**
	    * A constant representing a center alignment or position.
	    * @constant
	    * @type {integer}
	    */CENTER:6,/**
	    * A constant representing a right-top alignment or position.
	    * @constant
	    * @type {integer}
	    */RIGHT_TOP:7,/**
	    * A constant representing a right-center alignment or position.
	    * @constant
	    * @type {integer}
	    */RIGHT_CENTER:8,/**
	    * A constant representing a right-bottom alignment or position.
	    * @constant
	    * @type {integer}
	    */RIGHT_BOTTOM:9,/**
	    * A constant representing a bottom-left alignment or position.
	    * @constant
	    * @type {integer}
	    */BOTTOM_LEFT:10,/**
	    * A constant representing a bottom-center alignment or position.
	    * @constant
	    * @type {integer}
	    */BOTTOM_CENTER:11,/**
	    * A constant representing a bottom-right alignment or position.
	    * @constant
	    * @type {integer}
	    */BOTTOM_RIGHT:12,/**
	     * Various blend modes supported by Pixi.
	     * 
	     * IMPORTANT: The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
	     * 
	     * @constant
	     * @property {Number} blendModes.NORMAL
	     * @property {Number} blendModes.ADD
	     * @property {Number} blendModes.MULTIPLY
	     * @property {Number} blendModes.SCREEN
	     * @property {Number} blendModes.OVERLAY
	     * @property {Number} blendModes.DARKEN
	     * @property {Number} blendModes.LIGHTEN
	     * @property {Number} blendModes.COLOR_DODGE
	     * @property {Number} blendModes.COLOR_BURN
	     * @property {Number} blendModes.HARD_LIGHT
	     * @property {Number} blendModes.SOFT_LIGHT
	     * @property {Number} blendModes.DIFFERENCE
	     * @property {Number} blendModes.EXCLUSION
	     * @property {Number} blendModes.HUE
	     * @property {Number} blendModes.SATURATION
	     * @property {Number} blendModes.COLOR
	     * @property {Number} blendModes.LUMINOSITY
	     * @static
	     */blendModes:{NORMAL:0,ADD:1,MULTIPLY:2,SCREEN:3,OVERLAY:4,DARKEN:5,LIGHTEN:6,COLOR_DODGE:7,COLOR_BURN:8,HARD_LIGHT:9,SOFT_LIGHT:10,DIFFERENCE:11,EXCLUSION:12,HUE:13,SATURATION:14,COLOR:15,LUMINOSITY:16},/**
	     * The scale modes that are supported by Pixi.
	     *
	     * The DEFAULT scale mode affects the default scaling mode of future operations.
	     * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
	     *
	     * @constant
	     * @property {Object} Phaser.scaleModes
	     * @property {Number} scaleModes.DEFAULT=LINEAR
	     * @property {Number} scaleModes.LINEAR Smooth scaling
	     * @property {Number} scaleModes.NEAREST Pixelating scaling
	     * @static
	     */scaleModes:{DEFAULT:0,LINEAR:0,NEAREST:1},PIXI:PIXI||{}};/**
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*/// ES6 Math.trunc - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/trunc
	if(!Math.trunc){Math.trunc=function trunc(x){return x<0?Math.ceil(x):Math.floor(x);};}/**
	* A polyfill for Function.prototype.bind
	*/if(!Function.prototype.bind){/* jshint freeze: false */Function.prototype.bind=function(){var slice=Array.prototype.slice;return function(thisArg){var target=this,boundArgs=slice.call(arguments,1);if(typeof target!=='function'){throw new TypeError();}function bound(){var args=boundArgs.concat(slice.call(arguments));target.apply(this instanceof bound?this:thisArg,args);}bound.prototype=function F(proto){if(proto){F.prototype=proto;}if(!(this instanceof F)){/* jshint supernew: true */return new F();}}(target.prototype);return bound;};}();}/**
	* A polyfill for Array.isArray
	*/if(!Array.isArray){Array.isArray=function(arg){return Object.prototype.toString.call(arg)==='[object Array]';};}/**
	* A polyfill for Array.forEach
	* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
	*/if(!Array.prototype.forEach){Array.prototype.forEach=function(fun/*, thisArg */){"use strict";if(this===void 0||this===null){throw new TypeError();}var t=Object(this);var len=t.length>>>0;if(typeof fun!=="function"){throw new TypeError();}var thisArg=arguments.length>=2?arguments[1]:void 0;for(var i=0;i<len;i++){if(i in t){fun.call(thisArg,t[i],i,t);}}};}/**
	* Low-budget Float32Array knock-off, suitable for use with P2.js in IE9
	* Source: http://www.html5gamedevs.com/topic/5988-phaser-12-ie9/
	* Cameron Foale (http://www.kibibu.com)
	*/if(typeof window.Uint32Array!=="function"&&_typeof(window.Uint32Array)!=="object"){var CheapArray=function CheapArray(type){var proto=new Array();// jshint ignore:line
	window[type]=function(arg){if(typeof arg==="number"){Array.call(this,arg);this.length=arg;for(var i=0;i<this.length;i++){this[i]=0;}}else{Array.call(this,arg.length);this.length=arg.length;for(var i=0;i<this.length;i++){this[i]=arg[i];}}};window[type].prototype=proto;window[type].constructor=window[type];};CheapArray('Uint32Array');// jshint ignore:line
	CheapArray('Int16Array');// jshint ignore:line
	}/**
	 * Also fix for the absent console in IE9
	 */if(!window.console){window.console={};window.console.log=window.console.assert=function(){};window.console.warn=window.console.assert=function(){};}/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* @class Phaser.Utils
	* @static
	*/Phaser.Utils={/**
	    * Takes the given string and reverses it, returning the reversed string.
	    * For example if given the string `Atari 520ST` it would return `TS025 iratA`.
	    *
	    * @method Phaser.Utils.reverseString
	    * @param {string} string - The string to be reversed.
	    * @return {string} The reversed string.
	    */reverseString:function reverseString(string){return string.split('').reverse().join('');},/**
	     * Gets an objects property by string.
	     *
	     * @method Phaser.Utils.getProperty
	     * @param {object} obj - The object to traverse.
	     * @param {string} prop - The property whose value will be returned.
	     * @return {*} the value of the property or null if property isn't found .
	     */getProperty:function getProperty(obj,prop){var parts=prop.split('.'),last=parts.pop(),l=parts.length,i=1,current=parts[0];while(i<l&&(obj=obj[current])){current=parts[i];i++;}if(obj){return obj[last];}else{return null;}},/**
	     * Sets an objects property by string.
	     *
	     * @method Phaser.Utils.setProperty
	     * @param {object} obj - The object to traverse
	     * @param {string} prop - The property whose value will be changed
	     * @return {object} The object on which the property was set.
	     */setProperty:function setProperty(obj,prop,value){var parts=prop.split('.'),last=parts.pop(),l=parts.length,i=1,current=parts[0];while(i<l&&(obj=obj[current])){current=parts[i];i++;}if(obj){obj[last]=value;}return obj;},/**
	    * Generate a random bool result based on the chance value.
	    *
	    * Returns true or false based on the chance value (default 50%). For example if you wanted a player to have a 30% chance
	    * of getting a bonus, call chanceRoll(30) - true means the chance passed, false means it failed.
	    *
	    * @method Phaser.Utils#chanceRoll
	    * @param {number} chance - The chance of receiving the value. A number between 0 and 100 (effectively 0% to 100%).
	    * @return {boolean} True if the roll passed, or false otherwise.
	    */chanceRoll:function chanceRoll(chance){if(chance===undefined){chance=50;}return chance>0&&Math.random()*100<=chance;},/**
	    * Choose between one of two values randomly.
	    *
	    * @method Phaser.Utils#randomChoice
	    * @param {any} choice1
	    * @param {any} choice2
	    * @return {any} The randomly selected choice
	    */randomChoice:function randomChoice(choice1,choice2){return Math.random()<0.5?choice1:choice2;},/**
	    * Get a unit dimension from a string.
	    *
	    * @method Phaser.Utils.parseDimension
	    * @param {string|number} size - The size to parse.
	    * @param {number} dimension - The window dimension to check.
	    * @return {number} The parsed dimension.
	    */parseDimension:function parseDimension(size,dimension){var f=0;var px=0;if(typeof size==='string'){//  %?
	if(size.substr(-1)==='%'){f=parseInt(size,10)/100;if(dimension===0){px=window.innerWidth*f;}else{px=window.innerHeight*f;}}else{px=parseInt(size,10);}}else{px=size;}return px;},/**
	    * Takes the given string and pads it out, to the length required, using the character
	    * specified. For example if you need a string to be 6 characters long, you can call:
	    *
	    * `pad('bob', 6, '-', 2)`
	    *
	    * This would return: `bob---` as it has padded it out to 6 characters, using the `-` on the right.
	    *
	    * You can also use it to pad numbers (they are always returned as strings):
	    * 
	    * `pad(512, 6, '0', 1)`
	    *
	    * Would return: `000512` with the string padded to the left.
	    *
	    * If you don't specify a direction it'll pad to both sides:
	    * 
	    * `pad('c64', 7, '*')`
	    *
	    * Would return: `**c64**`
	    *
	    * @method Phaser.Utils.pad
	    * @param {string} str - The target string. `toString()` will be called on the string, which means you can also pass in common data types like numbers.
	    * @param {integer} [len=0] - The number of characters to be added.
	    * @param {string} [pad=" "] - The string to pad it out with (defaults to a space).
	    * @param {integer} [dir=3] - The direction dir = 1 (left), 2 (right), 3 (both).
	    * @return {string} The padded string.
	    */pad:function pad(str,len,pad,dir){if(len===undefined){var len=0;}if(pad===undefined){var pad=' ';}if(dir===undefined){var dir=3;}str=str.toString();var padlen=0;if(len+1>=str.length){switch(dir){case 1:str=new Array(len+1-str.length).join(pad)+str;break;case 3:var right=Math.ceil((padlen=len-str.length)/2);var left=padlen-right;str=new Array(left+1).join(pad)+str+new Array(right+1).join(pad);break;default:str=str+new Array(len+1-str.length).join(pad);break;}}return str;},/**
	    * This is a slightly modified version of jQuery.isPlainObject.
	    * A plain object is an object whose internal class property is [object Object].
	    * @method Phaser.Utils.isPlainObject
	    * @param {object} obj - The object to inspect.
	    * @return {boolean} - true if the object is plain, otherwise false.
	    */isPlainObject:function isPlainObject(obj){// Not plain objects:
	// - Any object or value whose internal [[Class]] property is not "[object Object]"
	// - DOM nodes
	// - window
	if((typeof obj==='undefined'?'undefined':_typeof(obj))!=="object"||obj.nodeType||obj===obj.window){return false;}// Support: Firefox <20
	// The try/catch suppresses exceptions thrown when attempting to access
	// the "constructor" property of certain host objects, ie. |window.location|
	// https://bugzilla.mozilla.org/show_bug.cgi?id=814622
	try{if(obj.constructor&&!{}.hasOwnProperty.call(obj.constructor.prototype,"isPrototypeOf")){return false;}}catch(e){return false;}// If the function hasn't returned already, we're confident that
	// |obj| is a plain object, created by {} or constructed with new Object
	return true;},/**
	    * This is a slightly modified version of http://api.jquery.com/jQuery.extend/
	    * 
	    * @method Phaser.Utils.extend
	    * @param {boolean} deep - Perform a deep copy?
	    * @param {object} target - The target object to copy to.
	    * @return {object} The extended object.
	    */extend:function extend(){var options,name,src,copy,copyIsArray,clone,target=arguments[0]||{},i=1,length=arguments.length,deep=false;// Handle a deep copy situation
	if(typeof target==="boolean"){deep=target;target=arguments[1]||{};// skip the boolean and the target
	i=2;}// extend Phaser if only one argument is passed
	if(length===i){target=this;--i;}for(;i<length;i++){// Only deal with non-null/undefined values
	if((options=arguments[i])!=null){// Extend the base object
	for(name in options){src=target[name];copy=options[name];// Prevent never-ending loop
	if(target===copy){continue;}// Recurse if we're merging plain objects or arrays
	if(deep&&copy&&(Phaser.Utils.isPlainObject(copy)||(copyIsArray=Array.isArray(copy)))){if(copyIsArray){copyIsArray=false;clone=src&&Array.isArray(src)?src:[];}else{clone=src&&Phaser.Utils.isPlainObject(src)?src:{};}// Never move original objects, clone them
	target[name]=Phaser.Utils.extend(deep,clone,copy);// Don't bring in undefined values
	}else if(copy!==undefined){target[name]=copy;}}}}// Return the modified object
	return target;},/**
	    * Mixes in an existing mixin object with the target.
	    *
	    * Values in the mixin that have either `get` or `set` functions are created as properties via `defineProperty`
	    * _except_ if they also define a `clone` method - if a clone method is defined that is called instead and
	    * the result is assigned directly.
	    *
	    * @method Phaser.Utils.mixinPrototype
	    * @param {object} target - The target object to receive the new functions.
	    * @param {object} mixin - The object to copy the functions from.
	    * @param {boolean} [replace=false] - If the target object already has a matching function should it be overwritten or not?
	    */mixinPrototype:function mixinPrototype(target,mixin,replace){if(replace===undefined){replace=false;}var mixinKeys=Object.keys(mixin);for(var i=0;i<mixinKeys.length;i++){var key=mixinKeys[i];var value=mixin[key];if(!replace&&key in target){//  Not overwriting existing property
	continue;}else{if(value&&(typeof value.get==='function'||typeof value.set==='function')){//  Special case for classes like Phaser.Point which has a 'set' function!
	if(typeof value.clone==='function'){target[key]=value.clone();}else{Object.defineProperty(target,key,value);}}else{target[key]=value;}}}},/**
	    * Mixes the source object into the destination object, returning the newly modified destination object.
	    * Based on original code by @mudcube
	    *
	    * @method Phaser.Utils.mixin
	    * @param {object} from - The object to copy (the source object).
	    * @param {object} to - The object to copy to (the destination object).
	    * @return {object} The modified destination object.
	    */mixin:function mixin(from,to){if(!from||(typeof from==='undefined'?'undefined':_typeof(from))!=="object"){return to;}for(var key in from){var o=from[key];if(o.childNodes||o.cloneNode){continue;}var type=_typeof(from[key]);if(!from[key]||type!=="object"){to[key]=from[key];}else{//  Clone sub-object
	if(_typeof(to[key])===type){to[key]=Phaser.Utils.mixin(from[key],to[key]);}else{to[key]=Phaser.Utils.mixin(from[key],new o.constructor());}}}return to;}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Creates a new Circle object with the center coordinate specified by the x and y parameters and the diameter specified by the diameter parameter.
	* If you call this function without parameters, a circle with x, y, diameter and radius properties set to 0 is created.
	* 
	* @class Phaser.Circle
	* @constructor
	* @param {number} [x=0] - The x coordinate of the center of the circle.
	* @param {number} [y=0] - The y coordinate of the center of the circle.
	* @param {number} [diameter=0] - The diameter of the circle.
	*/Phaser.Circle=function(x,y,diameter){x=x||0;y=y||0;diameter=diameter||0;/**
	    * @property {number} x - The x coordinate of the center of the circle.
	    */this.x=x;/**
	    * @property {number} y - The y coordinate of the center of the circle.
	    */this.y=y;/**
	    * @property {number} _diameter - The diameter of the circle.
	    * @private
	    */this._diameter=diameter;/**
	   * @property {number} _radius - The radius of the circle.
	   * @private
	   */this._radius=0;if(diameter>0){this._radius=diameter*0.5;}/**
	    * @property {number} type - The const type of this object.
	    * @readonly
	    */this.type=Phaser.CIRCLE;};Phaser.Circle.prototype={/**
	    * The circumference of the circle.
	    * 
	    * @method Phaser.Circle#circumference
	    * @return {number} The circumference of the circle.
	    */circumference:function circumference(){return 2*(Math.PI*this._radius);},/**
	    * Returns a uniformly distributed random point from anywhere within this Circle.
	    * 
	    * @method Phaser.Circle#random
	    * @param {Phaser.Point|object} [out] - A Phaser.Point, or any object with public x/y properties, that the values will be set in.
	    *     If no object is provided a new Phaser.Point object will be created. In high performance areas avoid this by re-using an existing object.
	    * @return {Phaser.Point} An object containing the random point in its `x` and `y` properties.
	    */random:function random(out){if(out===undefined){out=new Phaser.Point();}var t=2*Math.PI*Math.random();var u=Math.random()+Math.random();var r=u>1?2-u:u;var x=r*Math.cos(t);var y=r*Math.sin(t);out.x=this.x+x*this.radius;out.y=this.y+y*this.radius;return out;},/**
	    * Returns the framing rectangle of the circle as a Phaser.Rectangle object.
	    * 
	    * @method Phaser.Circle#getBounds
	    * @return {Phaser.Rectangle} The bounds of the Circle.
	    */getBounds:function getBounds(){return new Phaser.Rectangle(this.x-this.radius,this.y-this.radius,this.diameter,this.diameter);},/**
	    * Sets the members of Circle to the specified values.
	    * @method Phaser.Circle#setTo
	    * @param {number} x - The x coordinate of the center of the circle.
	    * @param {number} y - The y coordinate of the center of the circle.
	    * @param {number} diameter - The diameter of the circle.
	    * @return {Circle} This circle object.
	    */setTo:function setTo(x,y,diameter){this.x=x;this.y=y;this._diameter=diameter;this._radius=diameter*0.5;return this;},/**
	    * Copies the x, y and diameter properties from any given object to this Circle.
	    * @method Phaser.Circle#copyFrom
	    * @param {any} source - The object to copy from.
	    * @return {Circle} This Circle object.
	    */copyFrom:function copyFrom(source){return this.setTo(source.x,source.y,source.diameter);},/**
	    * Copies the x, y and diameter properties from this Circle to any given object.
	    * @method Phaser.Circle#copyTo
	    * @param {any} dest - The object to copy to.
	    * @return {object} This dest object.
	    */copyTo:function copyTo(dest){dest.x=this.x;dest.y=this.y;dest.diameter=this._diameter;return dest;},/**
	    * Returns the distance from the center of the Circle object to the given object
	    * (can be Circle, Point or anything with x/y properties)
	    * @method Phaser.Circle#distance
	    * @param {object} dest - The target object. Must have visible x and y properties that represent the center of the object.
	    * @param {boolean} [round=false] - Round the distance to the nearest integer.
	    * @return {number} The distance between this Point object and the destination Point object.
	    */distance:function distance(dest,round){var distance=Phaser.Math.distance(this.x,this.y,dest.x,dest.y);return round?Math.round(distance):distance;},/**
	    * Returns a new Circle object with the same values for the x, y, width, and height properties as this Circle object.
	    * @method Phaser.Circle#clone
	    * @param {Phaser.Circle} output - Optional Circle object. If given the values will be set into the object, otherwise a brand new Circle object will be created and returned.
	    * @return {Phaser.Circle} The cloned Circle object.
	    */clone:function clone(output){if(output===undefined||output===null){output=new Phaser.Circle(this.x,this.y,this.diameter);}else{output.setTo(this.x,this.y,this.diameter);}return output;},/**
	    * Return true if the given x/y coordinates are within this Circle object.
	    * @method Phaser.Circle#contains
	    * @param {number} x - The X value of the coordinate to test.
	    * @param {number} y - The Y value of the coordinate to test.
	    * @return {boolean} True if the coordinates are within this circle, otherwise false.
	    */contains:function contains(x,y){return Phaser.Circle.contains(this,x,y);},/**
	    * Returns a Point object containing the coordinates of a point on the circumference of the Circle based on the given angle.
	    * @method Phaser.Circle#circumferencePoint
	    * @param {number} angle - The angle in radians (unless asDegrees is true) to return the point from.
	    * @param {boolean} [asDegrees=false] - Is the given angle in radians (false) or degrees (true)?
	    * @param {Phaser.Point} [out] - An optional Point object to put the result in to. If none specified a new Point object will be created.
	    * @return {Phaser.Point} The Point object holding the result.
	    */circumferencePoint:function circumferencePoint(angle,asDegrees,out){return Phaser.Circle.circumferencePoint(this,angle,asDegrees,out);},/**
	    * Adjusts the location of the Circle object, as determined by its center coordinate, by the specified amounts.
	    * @method Phaser.Circle#offset
	    * @param {number} dx - Moves the x value of the Circle object by this amount.
	    * @param {number} dy - Moves the y value of the Circle object by this amount.
	    * @return {Circle} This Circle object.
	    */offset:function offset(dx,dy){this.x+=dx;this.y+=dy;return this;},/**
	    * Adjusts the location of the Circle object using a Point object as a parameter. This method is similar to the Circle.offset() method, except that it takes a Point object as a parameter.
	    * @method Phaser.Circle#offsetPoint
	    * @param {Point} point A Point object to use to offset this Circle object (or any valid object with exposed x and y properties).
	    * @return {Circle} This Circle object.
	    */offsetPoint:function offsetPoint(point){return this.offset(point.x,point.y);},/**
	    * Returns a string representation of this object.
	    * @method Phaser.Circle#toString
	    * @return {string} a string representation of the instance.
	    */toString:function toString(){return"[{Phaser.Circle (x="+this.x+" y="+this.y+" diameter="+this.diameter+" radius="+this.radius+")}]";}};Phaser.Circle.prototype.constructor=Phaser.Circle;/**
	* The largest distance between any two points on the circle. The same as the radius * 2.
	* 
	* @name Phaser.Circle#diameter
	* @property {number} diameter - Gets or sets the diameter of the circle.
	*/Object.defineProperty(Phaser.Circle.prototype,"diameter",{get:function get(){return this._diameter;},set:function set(value){if(value>0){this._diameter=value;this._radius=value*0.5;}}});/**
	* The length of a line extending from the center of the circle to any point on the circle itself. The same as half the diameter.
	* @name Phaser.Circle#radius
	* @property {number} radius - Gets or sets the radius of the circle.
	*/Object.defineProperty(Phaser.Circle.prototype,"radius",{get:function get(){return this._radius;},set:function set(value){if(value>0){this._radius=value;this._diameter=value*2;}}});/**
	* The x coordinate of the leftmost point of the circle. Changing the left property of a Circle object has no effect on the x and y properties. However it does affect the diameter, whereas changing the x value does not affect the diameter property.
	* @name Phaser.Circle#left
	* @propety {number} left - Gets or sets the value of the leftmost point of the circle.
	*/Object.defineProperty(Phaser.Circle.prototype,"left",{get:function get(){return this.x-this._radius;},set:function set(value){if(value>this.x){this._radius=0;this._diameter=0;}else{this.radius=this.x-value;}}});/**
	* The x coordinate of the rightmost point of the circle. Changing the right property of a Circle object has no effect on the x and y properties. However it does affect the diameter, whereas changing the x value does not affect the diameter property.
	* @name Phaser.Circle#right
	* @property {number} right - Gets or sets the value of the rightmost point of the circle.
	*/Object.defineProperty(Phaser.Circle.prototype,"right",{get:function get(){return this.x+this._radius;},set:function set(value){if(value<this.x){this._radius=0;this._diameter=0;}else{this.radius=value-this.x;}}});/**
	* The sum of the y minus the radius property. Changing the top property of a Circle object has no effect on the x and y properties, but does change the diameter.
	* @name Phaser.Circle#top
	* @property {number} top - Gets or sets the top of the circle.
	*/Object.defineProperty(Phaser.Circle.prototype,"top",{get:function get(){return this.y-this._radius;},set:function set(value){if(value>this.y){this._radius=0;this._diameter=0;}else{this.radius=this.y-value;}}});/**
	* The sum of the y and radius properties. Changing the bottom property of a Circle object has no effect on the x and y properties, but does change the diameter.
	* @name Phaser.Circle#bottom
	* @property {number} bottom - Gets or sets the bottom of the circle.
	*/Object.defineProperty(Phaser.Circle.prototype,"bottom",{get:function get(){return this.y+this._radius;},set:function set(value){if(value<this.y){this._radius=0;this._diameter=0;}else{this.radius=value-this.y;}}});/**
	* The area of this Circle.
	* @name Phaser.Circle#area
	* @property {number} area - The area of this circle.
	* @readonly
	*/Object.defineProperty(Phaser.Circle.prototype,"area",{get:function get(){if(this._radius>0){return Math.PI*this._radius*this._radius;}else{return 0;}}});/**
	* Determines whether or not this Circle object is empty. Will return a value of true if the Circle objects diameter is less than or equal to 0; otherwise false.
	* If set to true it will reset all of the Circle objects properties to 0. A Circle object is empty if its diameter is less than or equal to 0.
	* @name Phaser.Circle#empty
	* @property {boolean} empty - Gets or sets the empty state of the circle.
	*/Object.defineProperty(Phaser.Circle.prototype,"empty",{get:function get(){return this._diameter===0;},set:function set(value){if(value===true){this.setTo(0,0,0);}}});/**
	* Return true if the given x/y coordinates are within the Circle object.
	* @method Phaser.Circle.contains
	* @param {Phaser.Circle} a - The Circle to be checked.
	* @param {number} x - The X value of the coordinate to test.
	* @param {number} y - The Y value of the coordinate to test.
	* @return {boolean} True if the coordinates are within this circle, otherwise false.
	*/Phaser.Circle.contains=function(a,x,y){//  Check if x/y are within the bounds first
	if(a.radius>0&&x>=a.left&&x<=a.right&&y>=a.top&&y<=a.bottom){var dx=(a.x-x)*(a.x-x);var dy=(a.y-y)*(a.y-y);return dx+dy<=a.radius*a.radius;}else{return false;}};/**
	* Determines whether the two Circle objects match. This method compares the x, y and diameter properties.
	* @method Phaser.Circle.equals
	* @param {Phaser.Circle} a - The first Circle object.
	* @param {Phaser.Circle} b - The second Circle object.
	* @return {boolean} A value of true if the object has exactly the same values for the x, y and diameter properties as this Circle object; otherwise false.
	*/Phaser.Circle.equals=function(a,b){return a.x===b.x&&a.y===b.y&&a.diameter===b.diameter;};/**
	* Determines whether the two Circle objects intersect.
	* This method checks the radius distances between the two Circle objects to see if they intersect.
	* @method Phaser.Circle.intersects
	* @param {Phaser.Circle} a - The first Circle object.
	* @param {Phaser.Circle} b - The second Circle object.
	* @return {boolean} A value of true if the specified object intersects with this Circle object; otherwise false.
	*/Phaser.Circle.intersects=function(a,b){return Phaser.Math.distance(a.x,a.y,b.x,b.y)<=a.radius+b.radius;};/**
	* Returns a Point object containing the coordinates of a point on the circumference of the Circle based on the given angle.
	* @method Phaser.Circle.circumferencePoint
	* @param {Phaser.Circle} a - The first Circle object.
	* @param {number} angle - The angle in radians (unless asDegrees is true) to return the point from.
	* @param {boolean} [asDegrees=false] - Is the given angle in radians (false) or degrees (true)?
	* @param {Phaser.Point} [out] - An optional Point object to put the result in to. If none specified a new Point object will be created.
	* @return {Phaser.Point} The Point object holding the result.
	*/Phaser.Circle.circumferencePoint=function(a,angle,asDegrees,out){if(asDegrees===undefined){asDegrees=false;}if(out===undefined){out=new Phaser.Point();}if(asDegrees===true){angle=Phaser.Math.degToRad(angle);}out.x=a.x+a.radius*Math.cos(angle);out.y=a.y+a.radius*Math.sin(angle);return out;};/**
	* Checks if the given Circle and Rectangle objects intersect.
	* @method Phaser.Circle.intersectsRectangle
	* @param {Phaser.Circle} c - The Circle object to test.
	* @param {Phaser.Rectangle} r - The Rectangle object to test.
	* @return {boolean} True if the two objects intersect, otherwise false.
	*/Phaser.Circle.intersectsRectangle=function(c,r){var cx=Math.abs(c.x-r.x-r.halfWidth);var xDist=r.halfWidth+c.radius;if(cx>xDist){return false;}var cy=Math.abs(c.y-r.y-r.halfHeight);var yDist=r.halfHeight+c.radius;if(cy>yDist){return false;}if(cx<=r.halfWidth||cy<=r.halfHeight){return true;}var xCornerDist=cx-r.halfWidth;var yCornerDist=cy-r.halfHeight;var xCornerDistSq=xCornerDist*xCornerDist;var yCornerDistSq=yCornerDist*yCornerDist;var maxCornerDistSq=c.radius*c.radius;return xCornerDistSq+yCornerDistSq<=maxCornerDistSq;};//   Because PIXI uses its own Circle, we'll replace it with ours to avoid duplicating code or confusion.
	PIXI.Circle=Phaser.Circle;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @author       Chad Engler <chad@pantherdev.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Creates a Ellipse object. A curve on a plane surrounding two focal points.
	* 
	* @class Phaser.Ellipse
	* @constructor
	* @param {number} [x=0] - The X coordinate of the upper-left corner of the framing rectangle of this ellipse.
	* @param {number} [y=0] - The Y coordinate of the upper-left corner of the framing rectangle of this ellipse.
	* @param {number} [width=0] - The overall width of this ellipse.
	* @param {number} [height=0] - The overall height of this ellipse.
	*/Phaser.Ellipse=function(x,y,width,height){x=x||0;y=y||0;width=width||0;height=height||0;/**
	    * @property {number} x - The X coordinate of the upper-left corner of the framing rectangle of this ellipse.
	    */this.x=x;/**
	    * @property {number} y - The Y coordinate of the upper-left corner of the framing rectangle of this ellipse.
	    */this.y=y;/**
	    * @property {number} width - The overall width of this ellipse.
	    */this.width=width;/**
	    * @property {number} height - The overall height of this ellipse.
	    */this.height=height;/**
	    * @property {number} type - The const type of this object.
	    * @readonly
	    */this.type=Phaser.ELLIPSE;};Phaser.Ellipse.prototype={/**
	    * Sets the members of the Ellipse to the specified values.
	    * @method Phaser.Ellipse#setTo
	    * @param {number} x - The X coordinate of the upper-left corner of the framing rectangle of this ellipse.
	    * @param {number} y - The Y coordinate of the upper-left corner of the framing rectangle of this ellipse.
	    * @param {number} width - The overall width of this ellipse.
	    * @param {number} height - The overall height of this ellipse.
	    * @return {Phaser.Ellipse} This Ellipse object.
	    */setTo:function setTo(x,y,width,height){this.x=x;this.y=y;this.width=width;this.height=height;return this;},/**
	    * Returns the framing rectangle of the ellipse as a Phaser.Rectangle object.
	    * 
	    * @method Phaser.Ellipse#getBounds
	    * @return {Phaser.Rectangle} The bounds of the Ellipse.
	    */getBounds:function getBounds(){return new Phaser.Rectangle(this.x-this.width,this.y-this.height,this.width,this.height);},/**
	    * Copies the x, y, width and height properties from any given object to this Ellipse.
	    * 
	    * @method Phaser.Ellipse#copyFrom
	    * @param {any} source - The object to copy from.
	    * @return {Phaser.Ellipse} This Ellipse object.
	    */copyFrom:function copyFrom(source){return this.setTo(source.x,source.y,source.width,source.height);},/**
	    * Copies the x, y, width and height properties from this Ellipse to any given object.
	    * @method Phaser.Ellipse#copyTo
	    * @param {any} dest - The object to copy to.
	    * @return {object} This dest object.
	    */copyTo:function copyTo(dest){dest.x=this.x;dest.y=this.y;dest.width=this.width;dest.height=this.height;return dest;},/**
	    * Returns a new Ellipse object with the same values for the x, y, width, and height properties as this Ellipse object.
	    * @method Phaser.Ellipse#clone
	    * @param {Phaser.Ellipse} output - Optional Ellipse object. If given the values will be set into the object, otherwise a brand new Ellipse object will be created and returned.
	    * @return {Phaser.Ellipse} The cloned Ellipse object.
	    */clone:function clone(output){if(output===undefined||output===null){output=new Phaser.Ellipse(this.x,this.y,this.width,this.height);}else{output.setTo(this.x,this.y,this.width,this.height);}return output;},/**
	    * Return true if the given x/y coordinates are within this Ellipse object.
	    * 
	    * @method Phaser.Ellipse#contains
	    * @param {number} x - The X value of the coordinate to test.
	    * @param {number} y - The Y value of the coordinate to test.
	    * @return {boolean} True if the coordinates are within this ellipse, otherwise false.
	    */contains:function contains(x,y){return Phaser.Ellipse.contains(this,x,y);},/**
	    * Returns a uniformly distributed random point from anywhere within this Ellipse.
	    * 
	    * @method Phaser.Ellipse#random
	    * @param {Phaser.Point|object} [out] - A Phaser.Point, or any object with public x/y properties, that the values will be set in.
	    *     If no object is provided a new Phaser.Point object will be created. In high performance areas avoid this by re-using an existing object.
	    * @return {Phaser.Point} An object containing the random point in its `x` and `y` properties.
	    */random:function random(out){if(out===undefined){out=new Phaser.Point();}var p=Math.random()*Math.PI*2;var r=Math.random();out.x=Math.sqrt(r)*Math.cos(p);out.y=Math.sqrt(r)*Math.sin(p);out.x=this.x+out.x*this.width/2.0;out.y=this.y+out.y*this.height/2.0;return out;},/**
	    * Returns a string representation of this object.
	    * @method Phaser.Ellipse#toString
	    * @return {string} A string representation of the instance.
	    */toString:function toString(){return"[{Phaser.Ellipse (x="+this.x+" y="+this.y+" width="+this.width+" height="+this.height+")}]";}};Phaser.Ellipse.prototype.constructor=Phaser.Ellipse;/**
	* The left coordinate of the Ellipse. The same as the X coordinate.
	* @name Phaser.Ellipse#left
	* @propety {number} left - Gets or sets the value of the leftmost point of the ellipse.
	*/Object.defineProperty(Phaser.Ellipse.prototype,"left",{get:function get(){return this.x;},set:function set(value){this.x=value;}});/**
	* The x coordinate of the rightmost point of the Ellipse. Changing the right property of an Ellipse object has no effect on the x property, but does adjust the width.
	* @name Phaser.Ellipse#right
	* @property {number} right - Gets or sets the value of the rightmost point of the ellipse.
	*/Object.defineProperty(Phaser.Ellipse.prototype,"right",{get:function get(){return this.x+this.width;},set:function set(value){if(value<this.x){this.width=0;}else{this.width=value-this.x;}}});/**
	* The top of the Ellipse. The same as its y property.
	* @name Phaser.Ellipse#top
	* @property {number} top - Gets or sets the top of the ellipse.
	*/Object.defineProperty(Phaser.Ellipse.prototype,"top",{get:function get(){return this.y;},set:function set(value){this.y=value;}});/**
	* The sum of the y and height properties. Changing the bottom property of an Ellipse doesn't adjust the y property, but does change the height.
	* @name Phaser.Ellipse#bottom
	* @property {number} bottom - Gets or sets the bottom of the ellipse.
	*/Object.defineProperty(Phaser.Ellipse.prototype,"bottom",{get:function get(){return this.y+this.height;},set:function set(value){if(value<this.y){this.height=0;}else{this.height=value-this.y;}}});/**
	* Determines whether or not this Ellipse object is empty. Will return a value of true if the Ellipse objects dimensions are less than or equal to 0; otherwise false.
	* If set to true it will reset all of the Ellipse objects properties to 0. An Ellipse object is empty if its width or height is less than or equal to 0.
	* @name Phaser.Ellipse#empty
	* @property {boolean} empty - Gets or sets the empty state of the ellipse.
	*/Object.defineProperty(Phaser.Ellipse.prototype,"empty",{get:function get(){return this.width===0||this.height===0;},set:function set(value){if(value===true){this.setTo(0,0,0,0);}}});/**
	* Return true if the given x/y coordinates are within the Ellipse object.
	* 
	* @method Phaser.Ellipse.contains
	* @param {Phaser.Ellipse} a - The Ellipse to be checked.
	* @param {number} x - The X value of the coordinate to test.
	* @param {number} y - The Y value of the coordinate to test.
	* @return {boolean} True if the coordinates are within this ellipse, otherwise false.
	*/Phaser.Ellipse.contains=function(a,x,y){if(a.width<=0||a.height<=0){return false;}//  Normalize the coords to an ellipse with center 0,0 and a radius of 0.5
	var normx=(x-a.x)/a.width-0.5;var normy=(y-a.y)/a.height-0.5;normx*=normx;normy*=normy;return normx+normy<0.25;};//   Because PIXI uses its own Ellipse, we'll replace it with ours to avoid duplicating code or confusion.
	PIXI.Ellipse=Phaser.Ellipse;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Creates a new Line object with a start and an end point.
	*
	* @class Phaser.Line
	* @constructor
	* @param {number} [x1=0] - The x coordinate of the start of the line.
	* @param {number} [y1=0] - The y coordinate of the start of the line.
	* @param {number} [x2=0] - The x coordinate of the end of the line.
	* @param {number} [y2=0] - The y coordinate of the end of the line.
	*/Phaser.Line=function(x1,y1,x2,y2){x1=x1||0;y1=y1||0;x2=x2||0;y2=y2||0;/**
	    * @property {Phaser.Point} start - The start point of the line.
	    */this.start=new Phaser.Point(x1,y1);/**
	    * @property {Phaser.Point} end - The end point of the line.
	    */this.end=new Phaser.Point(x2,y2);/**
	    * @property {number} type - The const type of this object.
	    * @readonly
	    */this.type=Phaser.LINE;};Phaser.Line.prototype={/**
	    * Sets the components of the Line to the specified values.
	    *
	    * @method Phaser.Line#setTo
	    * @param {number} [x1=0] - The x coordinate of the start of the line.
	    * @param {number} [y1=0] - The y coordinate of the start of the line.
	    * @param {number} [x2=0] - The x coordinate of the end of the line.
	    * @param {number} [y2=0] - The y coordinate of the end of the line.
	    * @return {Phaser.Line} This line object
	    */setTo:function setTo(x1,y1,x2,y2){this.start.setTo(x1,y1);this.end.setTo(x2,y2);return this;},/**
	    * Sets the line to match the x/y coordinates of the two given sprites.
	    * Can optionally be calculated from their center coordinates.
	    *
	    * @method Phaser.Line#fromSprite
	    * @param {Phaser.Sprite} startSprite - The coordinates of this Sprite will be set to the Line.start point.
	    * @param {Phaser.Sprite} endSprite - The coordinates of this Sprite will be set to the Line.start point.
	    * @param {boolean} [useCenter=false] - If true it will use startSprite.center.x, if false startSprite.x. Note that Sprites don't have a center property by default, so only enable if you've over-ridden your Sprite with a custom class.
	    * @return {Phaser.Line} This line object
	    */fromSprite:function fromSprite(startSprite,endSprite,useCenter){if(useCenter===undefined){useCenter=false;}if(useCenter){return this.setTo(startSprite.center.x,startSprite.center.y,endSprite.center.x,endSprite.center.y);}return this.setTo(startSprite.x,startSprite.y,endSprite.x,endSprite.y);},/**
	    * Sets this line to start at the given `x` and `y` coordinates and for the segment to extend at `angle` for the given `length`.
	    *
	    * @method Phaser.Line#fromAngle
	    * @param {number} x - The x coordinate of the start of the line.
	    * @param {number} y - The y coordinate of the start of the line.
	    * @param {number} angle - The angle of the line in radians.
	    * @param {number} length - The length of the line in pixels.
	    * @return {Phaser.Line} This line object
	    */fromAngle:function fromAngle(x,y,angle,length){this.start.setTo(x,y);this.end.setTo(x+Math.cos(angle)*length,y+Math.sin(angle)*length);return this;},/**
	    * Rotates the line by the amount specified in `angle`.
	    *
	    * Rotation takes place from the center of the line.
	    * If you wish to rotate around a different point see Line.rotateAround.
	    *
	    * If you wish to rotate the ends of the Line then see Line.start.rotate or Line.end.rotate.
	    *
	    * @method Phaser.Line#rotate
	    * @param {number} angle - The angle in radians (unless asDegrees is true) to rotate the line by.
	    * @param {boolean} [asDegrees=false] - Is the given angle in radians (false) or degrees (true)?
	    * @return {Phaser.Line} This line object
	    */rotate:function rotate(angle,asDegrees){var cx=(this.start.x+this.end.x)/2;var cy=(this.start.y+this.end.y)/2;this.start.rotate(cx,cy,angle,asDegrees);this.end.rotate(cx,cy,angle,asDegrees);return this;},/**
	    * Rotates the line by the amount specified in `angle`.
	    *
	    * Rotation takes place around the coordinates given.
	    *
	    * @method Phaser.Line#rotateAround
	    * @param {number} x - The x coordinate to offset the rotation from.
	    * @param {number} y - The y coordinate to offset the rotation from.
	    * @param {number} angle - The angle in radians (unless asDegrees is true) to rotate the line by.
	    * @param {boolean} [asDegrees=false] - Is the given angle in radians (false) or degrees (true)?
	    * @return {Phaser.Line} This line object
	    */rotateAround:function rotateAround(x,y,angle,asDegrees){this.start.rotate(x,y,angle,asDegrees);this.end.rotate(x,y,angle,asDegrees);return this;},/**
	    * Checks for intersection between this line and another Line.
	    * If asSegment is true it will check for segment intersection. If asSegment is false it will check for line intersection.
	    * Returns the intersection segment of AB and EF as a Point, or null if there is no intersection.
	    *
	    * @method Phaser.Line#intersects
	    * @param {Phaser.Line} line - The line to check against this one.
	    * @param {boolean} [asSegment=true] - If true it will check for segment intersection, otherwise full line intersection.
	    * @param {Phaser.Point} [result] - A Point object to store the result in, if not given a new one will be created.
	    * @return {Phaser.Point} The intersection segment of the two lines as a Point, or null if there is no intersection.
	    */intersects:function intersects(line,asSegment,result){return Phaser.Line.intersectsPoints(this.start,this.end,line.start,line.end,asSegment,result);},/**
	    * Returns the reflected angle between two lines.
	    * This is the outgoing angle based on the angle of this line and the normalAngle of the given line.
	    *
	    * @method Phaser.Line#reflect
	    * @param {Phaser.Line} line - The line to reflect off this line.
	    * @return {number} The reflected angle in radians.
	    */reflect:function reflect(line){return Phaser.Line.reflect(this,line);},/**
	    * Returns a Point object where the x and y values correspond to the center (or midpoint) of the Line segment.
	    *
	    * @method Phaser.Line#midPoint
	    * @param {Phaser.Point} [out] - A Phaser.Point object into which the result will be populated. If not given a new Point object is created.
	    * @return {Phaser.Point} A Phaser.Point object with the x and y values set to the center of the line segment.
	    */midPoint:function midPoint(out){if(out===undefined){out=new Phaser.Point();}out.x=(this.start.x+this.end.x)/2;out.y=(this.start.y+this.end.y)/2;return out;},/**
	    * Centers this Line on the given coordinates.
	    *
	    * The line is centered by positioning the start and end points so that the lines midpoint matches
	    * the coordinates given.
	    *
	    * @method Phaser.Line#centerOn
	    * @param {number} x - The x position to center the line on.
	    * @param {number} y - The y position to center the line on.
	    * @return {Phaser.Line} This line object
	    */centerOn:function centerOn(x,y){var cx=(this.start.x+this.end.x)/2;var cy=(this.start.y+this.end.y)/2;var tx=x-cx;var ty=y-cy;this.start.add(tx,ty);this.end.add(tx,ty);},/**
	    * Tests if the given coordinates fall on this line. See pointOnSegment to test against just the line segment.
	    *
	    * @method Phaser.Line#pointOnLine
	    * @param {number} x - The line to check against this one.
	    * @param {number} y - The line to check against this one.
	    * @return {boolean} True if the point is on the line, false if not.
	    */pointOnLine:function pointOnLine(x,y){return(x-this.start.x)*(this.end.y-this.start.y)===(this.end.x-this.start.x)*(y-this.start.y);},/**
	    * Tests if the given coordinates fall on this line and within the segment. See pointOnLine to test against just the line.
	    *
	    * @method Phaser.Line#pointOnSegment
	    * @param {number} x - The line to check against this one.
	    * @param {number} y - The line to check against this one.
	    * @return {boolean} True if the point is on the line and segment, false if not.
	    */pointOnSegment:function pointOnSegment(x,y){var xMin=Math.min(this.start.x,this.end.x);var xMax=Math.max(this.start.x,this.end.x);var yMin=Math.min(this.start.y,this.end.y);var yMax=Math.max(this.start.y,this.end.y);return this.pointOnLine(x,y)&&x>=xMin&&x<=xMax&&y>=yMin&&y<=yMax;},/**
	    * Picks a random point from anywhere on the Line segment and returns it.
	    *
	    * @method Phaser.Line#random
	    * @param {Phaser.Point|object} [out] - A Phaser.Point, or any object with public x/y properties, that the values will be set in.
	    *     If no object is provided a new Phaser.Point object will be created. In high performance areas avoid this by re-using an object.
	    * @return {Phaser.Point} An object containing the random point in its `x` and `y` properties.
	    */random:function random(out){if(out===undefined){out=new Phaser.Point();}var t=Math.random();out.x=this.start.x+t*(this.end.x-this.start.x);out.y=this.start.y+t*(this.end.y-this.start.y);return out;},/**
	    * Using Bresenham's line algorithm this will return an array of all coordinates on this line.
	    * The start and end points are rounded before this runs as the algorithm works on integers.
	    *
	    * @method Phaser.Line#coordinatesOnLine
	    * @param {number} [stepRate=1] - How many steps will we return? 1 = every coordinate on the line, 2 = every other coordinate, etc.
	    * @param {array} [results] - The array to store the results in. If not provided a new one will be generated.
	    * @return {array} An array of coordinates.
	    */coordinatesOnLine:function coordinatesOnLine(stepRate,results){if(stepRate===undefined){stepRate=1;}if(results===undefined){results=[];}var x1=Math.round(this.start.x);var y1=Math.round(this.start.y);var x2=Math.round(this.end.x);var y2=Math.round(this.end.y);var dx=Math.abs(x2-x1);var dy=Math.abs(y2-y1);var sx=x1<x2?1:-1;var sy=y1<y2?1:-1;var err=dx-dy;results.push([x1,y1]);var i=1;while(!(x1===x2&&y1===y2)){var e2=err<<1;if(e2>-dy){err-=dy;x1+=sx;}if(e2<dx){err+=dx;y1+=sy;}if(i%stepRate===0){results.push([x1,y1]);}i++;}return results;},/**
	     * Returns a new Line object with the same values for the start and end properties as this Line object.
	     * @method Phaser.Line#clone
	     * @param {Phaser.Line} output - Optional Line object. If given the values will be set into the object, otherwise a brand new Line object will be created and returned.
	     * @return {Phaser.Line} The cloned Line object.
	     */clone:function clone(output){if(output===undefined||output===null){output=new Phaser.Line(this.start.x,this.start.y,this.end.x,this.end.y);}else{output.setTo(this.start.x,this.start.y,this.end.x,this.end.y);}return output;}};/**
	* @name Phaser.Line#length
	* @property {number} length - Gets the length of the line segment.
	* @readonly
	*/Object.defineProperty(Phaser.Line.prototype,"length",{get:function get(){return Math.sqrt((this.end.x-this.start.x)*(this.end.x-this.start.x)+(this.end.y-this.start.y)*(this.end.y-this.start.y));}});/**
	* @name Phaser.Line#angle
	* @property {number} angle - Gets the angle of the line in radians.
	* @readonly
	*/Object.defineProperty(Phaser.Line.prototype,"angle",{get:function get(){return Math.atan2(this.end.y-this.start.y,this.end.x-this.start.x);}});/**
	* @name Phaser.Line#slope
	* @property {number} slope - Gets the slope of the line (y/x).
	* @readonly
	*/Object.defineProperty(Phaser.Line.prototype,"slope",{get:function get(){return(this.end.y-this.start.y)/(this.end.x-this.start.x);}});/**
	* @name Phaser.Line#perpSlope
	* @property {number} perpSlope - Gets the perpendicular slope of the line (x/y).
	* @readonly
	*/Object.defineProperty(Phaser.Line.prototype,"perpSlope",{get:function get(){return-((this.end.x-this.start.x)/(this.end.y-this.start.y));}});/**
	* @name Phaser.Line#x
	* @property {number} x - Gets the x coordinate of the top left of the bounds around this line.
	* @readonly
	*/Object.defineProperty(Phaser.Line.prototype,"x",{get:function get(){return Math.min(this.start.x,this.end.x);}});/**
	* @name Phaser.Line#y
	* @property {number} y - Gets the y coordinate of the top left of the bounds around this line.
	* @readonly
	*/Object.defineProperty(Phaser.Line.prototype,"y",{get:function get(){return Math.min(this.start.y,this.end.y);}});/**
	* @name Phaser.Line#left
	* @property {number} left - Gets the left-most point of this line.
	* @readonly
	*/Object.defineProperty(Phaser.Line.prototype,"left",{get:function get(){return Math.min(this.start.x,this.end.x);}});/**
	* @name Phaser.Line#right
	* @property {number} right - Gets the right-most point of this line.
	* @readonly
	*/Object.defineProperty(Phaser.Line.prototype,"right",{get:function get(){return Math.max(this.start.x,this.end.x);}});/**
	* @name Phaser.Line#top
	* @property {number} top - Gets the top-most point of this line.
	* @readonly
	*/Object.defineProperty(Phaser.Line.prototype,"top",{get:function get(){return Math.min(this.start.y,this.end.y);}});/**
	* @name Phaser.Line#bottom
	* @property {number} bottom - Gets the bottom-most point of this line.
	* @readonly
	*/Object.defineProperty(Phaser.Line.prototype,"bottom",{get:function get(){return Math.max(this.start.y,this.end.y);}});/**
	* @name Phaser.Line#width
	* @property {number} width - Gets the width of this bounds of this line.
	* @readonly
	*/Object.defineProperty(Phaser.Line.prototype,"width",{get:function get(){return Math.abs(this.start.x-this.end.x);}});/**
	* @name Phaser.Line#height
	* @property {number} height - Gets the height of this bounds of this line.
	* @readonly
	*/Object.defineProperty(Phaser.Line.prototype,"height",{get:function get(){return Math.abs(this.start.y-this.end.y);}});/**
	* @name Phaser.Line#normalX
	* @property {number} normalX - Gets the x component of the left-hand normal of this line.
	* @readonly
	*/Object.defineProperty(Phaser.Line.prototype,"normalX",{get:function get(){return Math.cos(this.angle-1.5707963267948966);}});/**
	* @name Phaser.Line#normalY
	* @property {number} normalY - Gets the y component of the left-hand normal of this line.
	* @readonly
	*/Object.defineProperty(Phaser.Line.prototype,"normalY",{get:function get(){return Math.sin(this.angle-1.5707963267948966);}});/**
	* @name Phaser.Line#normalAngle
	* @property {number} normalAngle - Gets the angle in radians of the normal of this line (line.angle - 90 degrees.)
	* @readonly
	*/Object.defineProperty(Phaser.Line.prototype,"normalAngle",{get:function get(){return Phaser.Math.wrap(this.angle-1.5707963267948966,-Math.PI,Math.PI);}});/**
	* Checks for intersection between two lines as defined by the given start and end points.
	* If asSegment is true it will check for line segment intersection. If asSegment is false it will check for line intersection.
	* Returns the intersection segment of AB and EF as a Point, or null if there is no intersection.
	* Adapted from code by Keith Hair
	*
	* @method Phaser.Line.intersectsPoints
	* @param {Phaser.Point} a - The start of the first Line to be checked.
	* @param {Phaser.Point} b - The end of the first line to be checked.
	* @param {Phaser.Point} e - The start of the second Line to be checked.
	* @param {Phaser.Point} f - The end of the second line to be checked.
	* @param {boolean} [asSegment=true] - If true it will check for segment intersection, otherwise full line intersection.
	* @param {Phaser.Point|object} [result] - A Point object to store the result in, if not given a new one will be created.
	* @return {Phaser.Point} The intersection segment of the two lines as a Point, or null if there is no intersection.
	*/Phaser.Line.intersectsPoints=function(a,b,e,f,asSegment,result){if(asSegment===undefined){asSegment=true;}if(result===undefined){result=new Phaser.Point();}var a1=b.y-a.y;var a2=f.y-e.y;var b1=a.x-b.x;var b2=e.x-f.x;var c1=b.x*a.y-a.x*b.y;var c2=f.x*e.y-e.x*f.y;var denom=a1*b2-a2*b1;if(denom===0){return null;}result.x=(b1*c2-b2*c1)/denom;result.y=(a2*c1-a1*c2)/denom;if(asSegment){var uc=(f.y-e.y)*(b.x-a.x)-(f.x-e.x)*(b.y-a.y);var ua=((f.x-e.x)*(a.y-e.y)-(f.y-e.y)*(a.x-e.x))/uc;var ub=((b.x-a.x)*(a.y-e.y)-(b.y-a.y)*(a.x-e.x))/uc;if(ua>=0&&ua<=1&&ub>=0&&ub<=1){return result;}else{return null;}}return result;};/**
	* Checks for intersection between two lines.
	* If asSegment is true it will check for segment intersection.
	* If asSegment is false it will check for line intersection.
	* Returns the intersection segment of AB and EF as a Point, or null if there is no intersection.
	* Adapted from code by Keith Hair
	*
	* @method Phaser.Line.intersects
	* @param {Phaser.Line} a - The first Line to be checked.
	* @param {Phaser.Line} b - The second Line to be checked.
	* @param {boolean} [asSegment=true] - If true it will check for segment intersection, otherwise full line intersection.
	* @param {Phaser.Point} [result] - A Point object to store the result in, if not given a new one will be created.
	* @return {Phaser.Point} The intersection segment of the two lines as a Point, or null if there is no intersection.
	*/Phaser.Line.intersects=function(a,b,asSegment,result){return Phaser.Line.intersectsPoints(a.start,a.end,b.start,b.end,asSegment,result);};/**
	* Checks for intersection between the Line and a Rectangle shape, or a rectangle-like
	* object, with public `x`, `y`, `right` and `bottom` properties, such as a Sprite or Body.
	*
	* An intersection is considered valid if:
	*
	* The line starts within, or ends within, the Rectangle.
	* The line segment intersects one of the 4 rectangle edges.
	*
	* The for the purposes of this function rectangles are considered 'solid'.
	*
	* @method Phaser.Line.intersectsRectangle
	* @param {Phaser.Line} line - The line to check for intersection with.
	* @param {Phaser.Rectangle|object} rect - The rectangle, or rectangle-like object, to check for intersection with.
	* @return {boolean} True if the line intersects with the rectangle edges, or starts or ends within the rectangle.
	*/Phaser.Line.intersectsRectangle=function(line,rect){//  Quick bail out of the Line and Rect bounds don't intersect
	if(!Phaser.Rectangle.intersects(line,rect)){return false;}var x1=line.start.x;var y1=line.start.y;var x2=line.end.x;var y2=line.end.y;var bx1=rect.x;var by1=rect.y;var bx2=rect.right;var by2=rect.bottom;var t=0;//  If the start or end of the line is inside the rect then we assume
	//  collision, as rects are solid for our use-case.
	if(x1>=bx1&&x1<=bx2&&y1>=by1&&y1<=by2||x2>=bx1&&x2<=bx2&&y2>=by1&&y2<=by2){return true;}if(x1<bx1&&x2>=bx1){//  Left edge
	t=y1+(y2-y1)*(bx1-x1)/(x2-x1);if(t>by1&&t<=by2){return true;}}else if(x1>bx2&&x2<=bx2){//  Right edge
	t=y1+(y2-y1)*(bx2-x1)/(x2-x1);if(t>=by1&&t<=by2){return true;}}if(y1<by1&&y2>=by1){//  Top edge
	t=x1+(x2-x1)*(by1-y1)/(y2-y1);if(t>=bx1&&t<=bx2){return true;}}else if(y1>by2&&y2<=by2){//  Bottom edge
	t=x1+(x2-x1)*(by2-y1)/(y2-y1);if(t>=bx1&&t<=bx2){return true;}}return false;};/**
	* Returns the reflected angle between two lines.
	* This is the outgoing angle based on the angle of Line 1 and the normalAngle of Line 2.
	*
	* @method Phaser.Line.reflect
	* @param {Phaser.Line} a - The base line.
	* @param {Phaser.Line} b - The line to be reflected from the base line.
	* @return {number} The reflected angle in radians.
	*/Phaser.Line.reflect=function(a,b){return 2*b.normalAngle-3.141592653589793-a.angle;};/**
	* @author       Mat Groves http://matgroves.com/ @Doormat23
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Matrix is a 3x3 matrix mostly used for display transforms within the renderer.
	* 
	* It is represented like so:
	* 
	* | a | b | tx |
	* | c | d | ty |
	* | 0 | 0 | 1 |
	*
	* @class Phaser.Matrix
	* @constructor
	* @param {number} [a=1] - Horizontal scaling
	* @param {number} [b=0] - Horizontal skewing
	* @param {number} [c=0] - Vertical skewing
	* @param {number} [d=1] - Vertical scaling
	* @param {number} [tx=0] - Horizontal translation
	* @param {number} [ty=0] - Vertical translation
	*/Phaser.Matrix=function(a,b,c,d,tx,ty){if(a===undefined||a===null){a=1;}if(b===undefined||b===null){b=0;}if(c===undefined||c===null){c=0;}if(d===undefined||d===null){d=1;}if(tx===undefined||tx===null){tx=0;}if(ty===undefined||ty===null){ty=0;}/**
	    * @property {number} a
	    * @default 1
	    */this.a=a;/**
	    * @property {number} b
	    * @default 0
	    */this.b=b;/**
	    * @property {number} c
	    * @default 0
	    */this.c=c;/**
	    * @property {number} d
	    * @default 1
	    */this.d=d;/**
	    * @property {number} tx
	    * @default 0
	    */this.tx=tx;/**
	    * @property {number} ty
	    * @default 0
	    */this.ty=ty;/**
	    * @property {number} type - The const type of this object.
	    * @readonly
	    */this.type=Phaser.MATRIX;};Phaser.Matrix.prototype={/**
	    * Sets the values of this Matrix to the values in the given array.
	    * 
	    * The Array elements should be set as follows:
	    *
	    * a = array[0]
	    * b = array[1]
	    * c = array[3]
	    * d = array[4]
	    * tx = array[2]
	    * ty = array[5]
	    *
	    * @method Phaser.Matrix#fromArray
	    * @param {Array} array - The array to copy from.
	    * @return {Phaser.Matrix} This Matrix object.
	    */fromArray:function fromArray(array){return this.setTo(array[0],array[1],array[3],array[4],array[2],array[5]);},/**
	    * Sets the values of this Matrix to the given values.
	    *
	    * @method Phaser.Matrix#setTo
	    * @param {number} a - Horizontal scaling
	    * @param {number} b - Horizontal skewing
	    * @param {number} c - Vertical skewing
	    * @param {number} d - Vertical scaling
	    * @param {number} tx - Horizontal translation
	    * @param {number} ty - Vertical translation
	    * @return {Phaser.Matrix} This Matrix object.
	    */setTo:function setTo(a,b,c,d,tx,ty){this.a=a;this.b=b;this.c=c;this.d=d;this.tx=tx;this.ty=ty;return this;},/**
	     * Creates a new Matrix object based on the values of this Matrix.
	     * If you provide the output parameter the values of this Matrix will be copied over to it.
	     * If the output parameter is blank a new Matrix object will be created.
	     *
	     * @method Phaser.Matrix#clone
	     * @param {Phaser.Matrix} [output] - If provided the values of this Matrix will be copied to it, otherwise a new Matrix object is created.
	     * @return {Phaser.Matrix} A clone of this Matrix.
	     */clone:function clone(output){if(output===undefined||output===null){output=new Phaser.Matrix(this.a,this.b,this.c,this.d,this.tx,this.ty);}else{output.a=this.a;output.b=this.b;output.c=this.c;output.d=this.d;output.tx=this.tx;output.ty=this.ty;}return output;},/**
	    * Copies the properties from this Matrix to the given Matrix.
	    *
	    * @method Phaser.Matrix#copyTo
	    * @param {Phaser.Matrix} matrix - The Matrix to copy from.
	    * @return {Phaser.Matrix} The destination Matrix object.
	    */copyTo:function copyTo(matrix){matrix.copyFrom(this);return matrix;},/**
	    * Copies the properties from the given Matrix into this Matrix.
	    *
	    * @method Phaser.Matrix#copyFrom
	    * @param {Phaser.Matrix} matrix - The Matrix to copy from.
	    * @return {Phaser.Matrix} This Matrix object.
	    */copyFrom:function copyFrom(matrix){this.a=matrix.a;this.b=matrix.b;this.c=matrix.c;this.d=matrix.d;this.tx=matrix.tx;this.ty=matrix.ty;return this;},/**
	    * Creates a Float32 Array with values populated from this Matrix object.
	    *
	    * @method Phaser.Matrix#toArray
	    * @param {boolean} [transpose=false] - Whether the values in the array are transposed or not.
	    * @param {PIXI.Float32Array} [array] - If provided the values will be set into this array, otherwise a new Float32Array is created.
	    * @return {PIXI.Float32Array} The newly created array which contains the matrix.
	    */toArray:function toArray(transpose,array){if(array===undefined){array=new PIXI.Float32Array(9);}if(transpose){array[0]=this.a;array[1]=this.b;array[2]=0;array[3]=this.c;array[4]=this.d;array[5]=0;array[6]=this.tx;array[7]=this.ty;array[8]=1;}else{array[0]=this.a;array[1]=this.c;array[2]=this.tx;array[3]=this.b;array[4]=this.d;array[5]=this.ty;array[6]=0;array[7]=0;array[8]=1;}return array;},/**
	    * Get a new position with the current transformation applied.
	    * 
	    * Can be used to go from a childs coordinate space to the world coordinate space (e.g. rendering)
	    *
	    * @method Phaser.Matrix#apply
	    * @param {Phaser.Point} pos - The origin Point.
	    * @param {Phaser.Point} [newPos] - The point that the new position is assigned to. This can be same as input point.
	    * @return {Phaser.Point} The new point, transformed through this matrix.
	    */apply:function apply(pos,newPos){if(newPos===undefined){newPos=new Phaser.Point();}newPos.x=this.a*pos.x+this.c*pos.y+this.tx;newPos.y=this.b*pos.x+this.d*pos.y+this.ty;return newPos;},/**
	    * Get a new position with the inverse of the current transformation applied.
	    * 
	    * Can be used to go from the world coordinate space to a childs coordinate space. (e.g. input)
	    *
	    * @method Phaser.Matrix#applyInverse
	    * @param {Phaser.Point} pos - The origin Point.
	    * @param {Phaser.Point} [newPos] - The point that the new position is assigned to. This can be same as input point.
	    * @return {Phaser.Point} The new point, inverse transformed through this matrix.
	    */applyInverse:function applyInverse(pos,newPos){if(newPos===undefined){newPos=new Phaser.Point();}var id=1/(this.a*this.d+this.c*-this.b);var x=pos.x;var y=pos.y;newPos.x=this.d*id*x+-this.c*id*y+(this.ty*this.c-this.tx*this.d)*id;newPos.y=this.a*id*y+-this.b*id*x+(-this.ty*this.a+this.tx*this.b)*id;return newPos;},/**
	    * Translates the matrix on the x and y.
	    * This is the same as Matrix.tx += x.
	    * 
	    * @method Phaser.Matrix#translate
	    * @param {number} x - The x value to translate on.
	    * @param {number} y - The y value to translate on.
	    * @return {Phaser.Matrix} This Matrix object.
	    */translate:function translate(x,y){this.tx+=x;this.ty+=y;return this;},/**
	    * Applies a scale transformation to this matrix.
	    * 
	    * @method Phaser.Matrix#scale
	    * @param {number} x - The amount to scale horizontally.
	    * @param {number} y - The amount to scale vertically.
	    * @return {Phaser.Matrix} This Matrix object.
	    */scale:function scale(x,y){this.a*=x;this.d*=y;this.c*=x;this.b*=y;this.tx*=x;this.ty*=y;return this;},/**
	    * Applies a rotation transformation to this matrix.
	    * 
	    * @method Phaser.Matrix#rotate
	    * @param {number} angle - The angle to rotate by, given in radians.
	    * @return {Phaser.Matrix} This Matrix object.
	    */rotate:function rotate(angle){var cos=Math.cos(angle);var sin=Math.sin(angle);var a1=this.a;var c1=this.c;var tx1=this.tx;this.a=a1*cos-this.b*sin;this.b=a1*sin+this.b*cos;this.c=c1*cos-this.d*sin;this.d=c1*sin+this.d*cos;this.tx=tx1*cos-this.ty*sin;this.ty=tx1*sin+this.ty*cos;return this;},/**
	    * Appends the given Matrix to this Matrix.
	    * 
	    * @method Phaser.Matrix#append
	    * @param {Phaser.Matrix} matrix - The matrix to append to this one.
	    * @return {Phaser.Matrix} This Matrix object.
	    */append:function append(matrix){var a1=this.a;var b1=this.b;var c1=this.c;var d1=this.d;this.a=matrix.a*a1+matrix.b*c1;this.b=matrix.a*b1+matrix.b*d1;this.c=matrix.c*a1+matrix.d*c1;this.d=matrix.c*b1+matrix.d*d1;this.tx=matrix.tx*a1+matrix.ty*c1+this.tx;this.ty=matrix.tx*b1+matrix.ty*d1+this.ty;return this;},/**
	    * Resets this Matrix to an identity (default) matrix.
	    * 
	    * @method Phaser.Matrix#identity
	    * @return {Phaser.Matrix} This Matrix object.
	    */identity:function identity(){return this.setTo(1,0,0,1,0,0);}};Phaser.identityMatrix=new Phaser.Matrix();//  Because PIXI uses its own type, we'll replace it with ours to avoid duplicating code or confusion.
	PIXI.Matrix=Phaser.Matrix;PIXI.identityMatrix=Phaser.identityMatrix;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A Point object represents a location in a two-dimensional coordinate system, where x represents the horizontal axis and y represents the vertical axis.
	* The following code creates a point at (0,0):
	* `var myPoint = new Phaser.Point();`
	* You can also use them as 2D Vectors and you'll find different vector related methods in this class.
	* 
	* @class Phaser.Point
	* @constructor
	* @param {number} [x=0] - The horizontal position of this Point.
	* @param {number} [y=0] - The vertical position of this Point.
	*/Phaser.Point=function(x,y){x=x||0;y=y||0;/**
	    * @property {number} x - The x value of the point.
	    */this.x=x;/**
	    * @property {number} y - The y value of the point.
	    */this.y=y;/**
	    * @property {number} type - The const type of this object.
	    * @readonly
	    */this.type=Phaser.POINT;};Phaser.Point.prototype={/**
	    * Copies the x and y properties from any given object to this Point.
	    *
	    * @method Phaser.Point#copyFrom
	    * @param {any} source - The object to copy from.
	    * @return {Phaser.Point} This Point object.
	    */copyFrom:function copyFrom(source){return this.setTo(source.x,source.y);},/**
	    * Inverts the x and y values of this Point
	    *
	    * @method Phaser.Point#invert
	    * @return {Phaser.Point} This Point object.
	    */invert:function invert(){return this.setTo(this.y,this.x);},/**
	    * Sets the `x` and `y` values of this Point object to the given values.
	    * If you omit the `y` value then the `x` value will be applied to both, for example:
	    * `Point.setTo(2)` is the same as `Point.setTo(2, 2)`
	    *
	    * @method Phaser.Point#setTo
	    * @param {number} x - The horizontal value of this point.
	    * @param {number} [y] - The vertical value of this point. If not given the x value will be used in its place.
	    * @return {Phaser.Point} This Point object. Useful for chaining method calls.
	    */setTo:function setTo(x,y){this.x=x||0;this.y=y||(y!==0?this.x:0);return this;},/**
	    * Sets the `x` and `y` values of this Point object to the given values.
	    * If you omit the `y` value then the `x` value will be applied to both, for example:
	    * `Point.set(2)` is the same as `Point.set(2, 2)`
	    *
	    * @method Phaser.Point#set
	    * @param {number} x - The horizontal value of this point.
	    * @param {number} [y] - The vertical value of this point. If not given the x value will be used in its place.
	    * @return {Phaser.Point} This Point object. Useful for chaining method calls.
	    */set:function set(x,y){this.x=x||0;this.y=y||(y!==0?this.x:0);return this;},/**
	    * Adds the given x and y values to this Point.
	    *
	    * @method Phaser.Point#add
	    * @param {number} x - The value to add to Point.x.
	    * @param {number} y - The value to add to Point.y.
	    * @return {Phaser.Point} This Point object. Useful for chaining method calls.
	    */add:function add(x,y){this.x+=x;this.y+=y;return this;},/**
	    * Subtracts the given x and y values from this Point.
	    *
	    * @method Phaser.Point#subtract
	    * @param {number} x - The value to subtract from Point.x.
	    * @param {number} y - The value to subtract from Point.y.
	    * @return {Phaser.Point} This Point object. Useful for chaining method calls.
	    */subtract:function subtract(x,y){this.x-=x;this.y-=y;return this;},/**
	    * Multiplies Point.x and Point.y by the given x and y values. Sometimes known as `Scale`.
	    *
	    * @method Phaser.Point#multiply
	    * @param {number} x - The value to multiply Point.x by.
	    * @param {number} y - The value to multiply Point.x by.
	    * @return {Phaser.Point} This Point object. Useful for chaining method calls.
	    */multiply:function multiply(x,y){this.x*=x;this.y*=y;return this;},/**
	    * Divides Point.x and Point.y by the given x and y values.
	    *
	    * @method Phaser.Point#divide
	    * @param {number} x - The value to divide Point.x by.
	    * @param {number} y - The value to divide Point.x by.
	    * @return {Phaser.Point} This Point object. Useful for chaining method calls.
	    */divide:function divide(x,y){this.x/=x;this.y/=y;return this;},/**
	    * Clamps the x value of this Point to be between the given min and max.
	    *
	    * @method Phaser.Point#clampX
	    * @param {number} min - The minimum value to clamp this Point to.
	    * @param {number} max - The maximum value to clamp this Point to.
	    * @return {Phaser.Point} This Point object.
	    */clampX:function clampX(min,max){this.x=Phaser.Math.clamp(this.x,min,max);return this;},/**
	    * Clamps the y value of this Point to be between the given min and max
	    *
	    * @method Phaser.Point#clampY
	    * @param {number} min - The minimum value to clamp this Point to.
	    * @param {number} max - The maximum value to clamp this Point to.
	    * @return {Phaser.Point} This Point object.
	    */clampY:function clampY(min,max){this.y=Phaser.Math.clamp(this.y,min,max);return this;},/**
	    * Clamps this Point object values to be between the given min and max.
	    *
	    * @method Phaser.Point#clamp
	    * @param {number} min - The minimum value to clamp this Point to.
	    * @param {number} max - The maximum value to clamp this Point to.
	    * @return {Phaser.Point} This Point object.
	    */clamp:function clamp(min,max){this.x=Phaser.Math.clamp(this.x,min,max);this.y=Phaser.Math.clamp(this.y,min,max);return this;},/**
	    * Creates a copy of the given Point.
	    *
	    * @method Phaser.Point#clone
	    * @param {Phaser.Point} [output] Optional Point object. If given the values will be set into this object, otherwise a brand new Point object will be created and returned.
	    * @return {Phaser.Point} The new Point object.
	    */clone:function clone(output){if(output===undefined||output===null){output=new Phaser.Point(this.x,this.y);}else{output.setTo(this.x,this.y);}return output;},/**
	    * Copies the x and y properties from this Point to any given object.
	    *
	    * @method Phaser.Point#copyTo
	    * @param {any} dest - The object to copy to.
	    * @return {object} The dest object.
	    */copyTo:function copyTo(dest){dest.x=this.x;dest.y=this.y;return dest;},/**
	    * Returns the distance of this Point object to the given object (can be a Circle, Point or anything with x/y properties)
	    *
	    * @method Phaser.Point#distance
	    * @param {object} dest - The target object. Must have visible x and y properties that represent the center of the object.
	    * @param {boolean} [round] - Round the distance to the nearest integer (default false).
	    * @return {number} The distance between this Point object and the destination Point object.
	    */distance:function distance(dest,round){return Phaser.Point.distance(this,dest,round);},/**
	    * Determines whether the given objects x/y values are equal to this Point object.
	    *
	    * @method Phaser.Point#equals
	    * @param {Phaser.Point|any} a - The object to compare with this Point.
	    * @return {boolean} A value of true if the x and y points are equal, otherwise false.
	    */equals:function equals(a){return a.x===this.x&&a.y===this.y;},/**
	    * Returns the angle between this Point object and another object with public x and y properties.
	    *
	    * @method Phaser.Point#angle
	    * @param {Phaser.Point|any} a - The object to get the angle from this Point to.
	    * @param {boolean} [asDegrees=false] - Is the given angle in radians (false) or degrees (true)?
	    * @return {number} The angle between the two objects.
	    */angle:function angle(a,asDegrees){if(asDegrees===undefined){asDegrees=false;}if(asDegrees){return Phaser.Math.radToDeg(Math.atan2(a.y-this.y,a.x-this.x));}else{return Math.atan2(a.y-this.y,a.x-this.x);}},/**
	    * Rotates this Point around the x/y coordinates given to the desired angle.
	    *
	    * @method Phaser.Point#rotate
	    * @param {number} x - The x coordinate of the anchor point.
	    * @param {number} y - The y coordinate of the anchor point.
	    * @param {number} angle - The angle in radians (unless asDegrees is true) to rotate the Point to.
	    * @param {boolean} [asDegrees=false] - Is the given angle in radians (false) or degrees (true)?
	    * @param {number} [distance] - An optional distance constraint between the Point and the anchor.
	    * @return {Phaser.Point} The modified point object.
	    */rotate:function rotate(x,y,angle,asDegrees,distance){return Phaser.Point.rotate(this,x,y,angle,asDegrees,distance);},/**
	    * Calculates the length of the Point object.
	    *
	    * @method Phaser.Point#getMagnitude
	    * @return {number} The length of the Point.
	    */getMagnitude:function getMagnitude(){return Math.sqrt(this.x*this.x+this.y*this.y);},/**
	    * Calculates the length squared of the Point object.
	    *
	    * @method Phaser.Point#getMagnitudeSq
	    * @return {number} The length ^ 2 of the Point.
	    */getMagnitudeSq:function getMagnitudeSq(){return this.x*this.x+this.y*this.y;},/**
	    * Alters the length of the Point without changing the direction.
	    *
	    * @method Phaser.Point#setMagnitude
	    * @param {number} magnitude - The desired magnitude of the resulting Point.
	    * @return {Phaser.Point} This Point object.
	    */setMagnitude:function setMagnitude(magnitude){return this.normalize().multiply(magnitude,magnitude);},/**
	    * Alters the Point object so that its length is 1, but it retains the same direction.
	    *
	    * @method Phaser.Point#normalize
	    * @return {Phaser.Point} This Point object.
	    */normalize:function normalize(){if(!this.isZero()){var m=this.getMagnitude();this.x/=m;this.y/=m;}return this;},/**
	    * Determine if this point is at 0,0.
	    *
	    * @method Phaser.Point#isZero
	    * @return {boolean} True if this Point is 0,0, otherwise false.
	    */isZero:function isZero(){return this.x===0&&this.y===0;},/**
	    * The dot product of this and another Point object.
	    * 
	    * @method Phaser.Point#dot
	    * @param {Phaser.Point} a - The Point object to get the dot product combined with this Point.
	    * @return {number} The result.
	    */dot:function dot(a){return this.x*a.x+this.y*a.y;},/**
	    * The cross product of this and another Point object.
	    * 
	    * @method Phaser.Point#cross
	    * @param {Phaser.Point} a - The Point object to get the cross product combined with this Point.
	    * @return {number} The result.
	    */cross:function cross(a){return this.x*a.y-this.y*a.x;},/**
	    * Make this Point perpendicular (90 degrees rotation)
	    * 
	    * @method Phaser.Point#perp
	    * @return {Phaser.Point} This Point object.
	    */perp:function perp(){return this.setTo(-this.y,this.x);},/**
	    * Make this Point perpendicular (-90 degrees rotation)
	    * 
	    * @method Phaser.Point#rperp
	    * @return {Phaser.Point} This Point object.
	    */rperp:function rperp(){return this.setTo(this.y,-this.x);},/**
	    * Right-hand normalize (make unit length) this Point.
	    *
	    * @method Phaser.Point#normalRightHand
	    * @return {Phaser.Point} This Point object.
	    */normalRightHand:function normalRightHand(){return this.setTo(this.y*-1,this.x);},/**
	    * Math.floor() both the x and y properties of this Point.
	    *
	    * @method Phaser.Point#floor
	    * @return {Phaser.Point} This Point object.
	    */floor:function floor(){return this.setTo(Math.floor(this.x),Math.floor(this.y));},/**
	    * Math.ceil() both the x and y properties of this Point.
	    *
	    * @method Phaser.Point#ceil
	    * @return {Phaser.Point} This Point object.
	    */ceil:function ceil(){return this.setTo(Math.ceil(this.x),Math.ceil(this.y));},/**
	    * Returns a string representation of this object.
	    *
	    * @method Phaser.Point#toString
	    * @return {string} A string representation of the instance.
	    */toString:function toString(){return'[{Point (x='+this.x+' y='+this.y+')}]';}};Phaser.Point.prototype.constructor=Phaser.Point;/**
	* Adds the coordinates of two points together to create a new point.
	*
	* @method Phaser.Point.add
	* @param {Phaser.Point} a - The first Point object.
	* @param {Phaser.Point} b - The second Point object.
	* @param {Phaser.Point} [out] - Optional Point to store the value in, if not supplied a new Point object will be created.
	* @return {Phaser.Point} The new Point object.
	*/Phaser.Point.add=function(a,b,out){if(out===undefined){out=new Phaser.Point();}out.x=a.x+b.x;out.y=a.y+b.y;return out;};/**
	* Subtracts the coordinates of two points to create a new point.
	*
	* @method Phaser.Point.subtract
	* @param {Phaser.Point} a - The first Point object.
	* @param {Phaser.Point} b - The second Point object.
	* @param {Phaser.Point} [out] - Optional Point to store the value in, if not supplied a new Point object will be created.
	* @return {Phaser.Point} The new Point object.
	*/Phaser.Point.subtract=function(a,b,out){if(out===undefined){out=new Phaser.Point();}out.x=a.x-b.x;out.y=a.y-b.y;return out;};/**
	* Multiplies the coordinates of two points to create a new point.
	*
	* @method Phaser.Point.multiply
	* @param {Phaser.Point} a - The first Point object.
	* @param {Phaser.Point} b - The second Point object.
	* @param {Phaser.Point} [out] - Optional Point to store the value in, if not supplied a new Point object will be created.
	* @return {Phaser.Point} The new Point object.
	*/Phaser.Point.multiply=function(a,b,out){if(out===undefined){out=new Phaser.Point();}out.x=a.x*b.x;out.y=a.y*b.y;return out;};/**
	* Divides the coordinates of two points to create a new point.
	*
	* @method Phaser.Point.divide
	* @param {Phaser.Point} a - The first Point object.
	* @param {Phaser.Point} b - The second Point object.
	* @param {Phaser.Point} [out] - Optional Point to store the value in, if not supplied a new Point object will be created.
	* @return {Phaser.Point} The new Point object.
	*/Phaser.Point.divide=function(a,b,out){if(out===undefined){out=new Phaser.Point();}out.x=a.x/b.x;out.y=a.y/b.y;return out;};/**
	* Determines whether the two given Point objects are equal. They are considered equal if they have the same x and y values.
	*
	* @method Phaser.Point.equals
	* @param {Phaser.Point} a - The first Point object.
	* @param {Phaser.Point} b - The second Point object.
	* @return {boolean} A value of true if the Points are equal, otherwise false.
	*/Phaser.Point.equals=function(a,b){return a.x===b.x&&a.y===b.y;};/**
	* Returns the angle between two Point objects.
	*
	* @method Phaser.Point.angle
	* @param {Phaser.Point} a - The first Point object.
	* @param {Phaser.Point} b - The second Point object.
	* @return {number} The angle between the two Points.
	*/Phaser.Point.angle=function(a,b){// return Math.atan2(a.x * b.y - a.y * b.x, a.x * b.x + a.y * b.y);
	return Math.atan2(a.y-b.y,a.x-b.x);};/**
	* Creates a negative Point.
	*
	* @method Phaser.Point.negative
	* @param {Phaser.Point} a - The first Point object.
	* @param {Phaser.Point} [out] - Optional Point to store the value in, if not supplied a new Point object will be created.
	* @return {Phaser.Point} The new Point object.
	*/Phaser.Point.negative=function(a,out){if(out===undefined){out=new Phaser.Point();}return out.setTo(-a.x,-a.y);};/**
	* Adds two 2D Points together and multiplies the result by the given scalar.
	* 
	* @method Phaser.Point.multiplyAdd
	* @param {Phaser.Point} a - The first Point object.
	* @param {Phaser.Point} b - The second Point object.
	* @param {number} s - The scaling value.
	* @param {Phaser.Point} [out] - Optional Point to store the value in, if not supplied a new Point object will be created.
	* @return {Phaser.Point} The new Point object.
	*/Phaser.Point.multiplyAdd=function(a,b,s,out){if(out===undefined){out=new Phaser.Point();}return out.setTo(a.x+b.x*s,a.y+b.y*s);};/**
	* Interpolates the two given Points, based on the `f` value (between 0 and 1) and returns a new Point.
	* 
	* @method Phaser.Point.interpolate
	* @param {Phaser.Point} a - The first Point object.
	* @param {Phaser.Point} b - The second Point object.
	* @param {number} f - The level of interpolation between the two points. Indicates where the new point will be, along the line between pt1 and pt2. If f=1, pt1 is returned; if f=0, pt2 is returned.
	* @param {Phaser.Point} [out] - Optional Point to store the value in, if not supplied a new Point object will be created.
	* @return {Phaser.Point} The new Point object.
	*/Phaser.Point.interpolate=function(a,b,f,out){if(out===undefined){out=new Phaser.Point();}return out.setTo(a.x+(b.x-a.x)*f,a.y+(b.y-a.y)*f);};/**
	* Return a perpendicular vector (90 degrees rotation)
	*
	* @method Phaser.Point.perp
	* @param {Phaser.Point} a - The Point object.
	* @param {Phaser.Point} [out] - Optional Point to store the value in, if not supplied a new Point object will be created.
	* @return {Phaser.Point} The new Point object.
	*/Phaser.Point.perp=function(a,out){if(out===undefined){out=new Phaser.Point();}return out.setTo(-a.y,a.x);};/**
	* Return a perpendicular vector (-90 degrees rotation)
	*
	* @method Phaser.Point.rperp
	* @param {Phaser.Point} a - The Point object.
	* @param {Phaser.Point} [out] - Optional Point to store the value in, if not supplied a new Point object will be created.
	* @return {Phaser.Point} The new Point object.
	*/Phaser.Point.rperp=function(a,out){if(out===undefined){out=new Phaser.Point();}return out.setTo(a.y,-a.x);};/**
	* Returns the euclidian distance of this Point object to the given object (can be a Circle, Point or anything with x/y properties).
	*
	* @method Phaser.Point.distance
	* @param {object} a - The target object. Must have visible x and y properties that represent the center of the object.
	* @param {object} b - The target object. Must have visible x and y properties that represent the center of the object.
	* @param {boolean} [round=false] - Round the distance to the nearest integer.
	* @return {number} The distance between this Point object and the destination Point object.
	*/Phaser.Point.distance=function(a,b,round){var distance=Phaser.Math.distance(a.x,a.y,b.x,b.y);return round?Math.round(distance):distance;};/**
	* Project two Points onto another Point.
	* 
	* @method Phaser.Point.project
	* @param {Phaser.Point} a - The first Point object.
	* @param {Phaser.Point} b - The second Point object.
	* @param {Phaser.Point} [out] - Optional Point to store the value in, if not supplied a new Point object will be created.
	* @return {Phaser.Point} The new Point object.
	*/Phaser.Point.project=function(a,b,out){if(out===undefined){out=new Phaser.Point();}var amt=a.dot(b)/b.getMagnitudeSq();if(amt!==0){out.setTo(amt*b.x,amt*b.y);}return out;};/**
	* Project two Points onto a Point of unit length.
	* 
	* @method Phaser.Point.projectUnit
	* @param {Phaser.Point} a - The first Point object.
	* @param {Phaser.Point} b - The second Point object.
	* @param {Phaser.Point} [out] - Optional Point to store the value in, if not supplied a new Point object will be created.
	* @return {Phaser.Point} The new Point object.
	*/Phaser.Point.projectUnit=function(a,b,out){if(out===undefined){out=new Phaser.Point();}var amt=a.dot(b);if(amt!==0){out.setTo(amt*b.x,amt*b.y);}return out;};/**
	* Right-hand normalize (make unit length) a Point.
	*
	* @method Phaser.Point.normalRightHand
	* @param {Phaser.Point} a - The Point object.
	* @param {Phaser.Point} [out] - Optional Point to store the value in, if not supplied a new Point object will be created.
	* @return {Phaser.Point} The new Point object.
	*/Phaser.Point.normalRightHand=function(a,out){if(out===undefined){out=new Phaser.Point();}return out.setTo(a.y*-1,a.x);};/**
	* Normalize (make unit length) a Point.
	*
	* @method Phaser.Point.normalize
	* @param {Phaser.Point} a - The Point object.
	* @param {Phaser.Point} [out] - Optional Point to store the value in, if not supplied a new Point object will be created.
	* @return {Phaser.Point} The new Point object.
	*/Phaser.Point.normalize=function(a,out){if(out===undefined){out=new Phaser.Point();}var m=a.getMagnitude();if(m!==0){out.setTo(a.x/m,a.y/m);}return out;};/**
	* Rotates a Point object, or any object with exposed x/y properties, around the given coordinates by
	* the angle specified. If the angle between the point and coordinates was 45 deg and the angle argument
	* is 45 deg then the resulting angle will be 90 deg, as the angle argument is added to the current angle.
	*
	* The distance allows you to specify a distance constraint for the rotation between the point and the 
	* coordinates. If none is given the distance between the two is calculated and used.
	*
	* @method Phaser.Point.rotate
	* @param {Phaser.Point} a - The Point object to rotate.
	* @param {number} x - The x coordinate of the anchor point
	* @param {number} y - The y coordinate of the anchor point
	* @param {number} angle - The angle in radians (unless asDegrees is true) to rotate the Point by.
	* @param {boolean} [asDegrees=false] - Is the given angle in radians (false) or degrees (true)?
	* @param {number} [distance] - An optional distance constraint between the Point and the anchor.
	* @return {Phaser.Point} The modified point object.
	*/Phaser.Point.rotate=function(a,x,y,angle,asDegrees,distance){if(asDegrees){angle=Phaser.Math.degToRad(angle);}if(distance===undefined){a.subtract(x,y);var s=Math.sin(angle);var c=Math.cos(angle);var tx=c*a.x-s*a.y;var ty=s*a.x+c*a.y;a.x=tx+x;a.y=ty+y;}else{var t=angle+Math.atan2(a.y-y,a.x-x);a.x=x+distance*Math.cos(t);a.y=y+distance*Math.sin(t);}return a;};/**
	* Calculates centroid (or midpoint) from an array of points. If only one point is provided, that point is returned.
	*
	* @method Phaser.Point.centroid
	* @param {Phaser.Point[]} points - The array of one or more points.
	* @param {Phaser.Point} [out] - Optional Point to store the value in, if not supplied a new Point object will be created.
	* @return {Phaser.Point} The new Point object.
	*/Phaser.Point.centroid=function(points,out){if(out===undefined){out=new Phaser.Point();}if(Object.prototype.toString.call(points)!=='[object Array]'){throw new Error("Phaser.Point. Parameter 'points' must be an array");}var pointslength=points.length;if(pointslength<1){throw new Error("Phaser.Point. Parameter 'points' array must not be empty");}if(pointslength===1){out.copyFrom(points[0]);return out;}for(var i=0;i<pointslength;i++){Phaser.Point.add(out,points[i],out);}out.divide(pointslength,pointslength);return out;};/**
	* Parses an object for x and/or y properties and returns a new Phaser.Point with matching values.
	* If the object doesn't contain those properties a Point with x/y of zero will be returned.
	*
	* @method Phaser.Point.parse
	* @static
	* @param {object} obj - The object to parse.
	* @param {string} [xProp='x'] - The property used to set the Point.x value.
	* @param {string} [yProp='y'] - The property used to set the Point.y value.
	* @return {Phaser.Point} The new Point object.
	*/Phaser.Point.parse=function(obj,xProp,yProp){xProp=xProp||'x';yProp=yProp||'y';var point=new Phaser.Point();if(obj[xProp]){point.x=parseInt(obj[xProp],10);}if(obj[yProp]){point.y=parseInt(obj[yProp],10);}return point;};//   Because PIXI uses its own Point, we'll replace it with ours to avoid duplicating code or confusion.
	PIXI.Point=Phaser.Point;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @author       Adrien Brault <adrien.brault@gmail.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Creates a new Polygon.
	* 
	* The points can be set from a variety of formats:
	*
	* - An array of Point objects: `[new Phaser.Point(x1, y1), ...]`
	* - An array of objects with public x/y properties: `[obj1, obj2, ...]`
	* - An array of paired numbers that represent point coordinates: `[x1,y1, x2,y2, ...]`
	* - As separate Point arguments: `setTo(new Phaser.Point(x1, y1), ...)`
	* - As separate objects with public x/y properties arguments: `setTo(obj1, obj2, ...)`
	* - As separate arguments representing point coordinates: `setTo(x1,y1, x2,y2, ...)`
	*
	* @class Phaser.Polygon
	* @constructor
	* @param {Phaser.Point[]|number[]|...Phaser.Point|...number} points - The points to set.
	*/Phaser.Polygon=function(){/**
	    * @property {number} area - The area of this Polygon.
	    */this.area=0;/**
	    * @property {array} _points - An array of Points that make up this Polygon.
	    * @private
	    */this._points=[];if(arguments.length>0){this.setTo.apply(this,arguments);}/**
	    * @property {boolean} closed - Is the Polygon closed or not?
	    */this.closed=true;/**
	    * @property {boolean} flattened - Has this Polygon been flattened by a call to `Polygon.flatten` ?
	    */this.flattened=false;/**
	     * @property {number} type - The base object type.
	     */this.type=Phaser.POLYGON;};Phaser.Polygon.prototype={/**
	     * Export the points as an array of flat numbers, following the sequence [ x,y, x,y, x,y ]
	     *
	     * @method Phaser.Polygon#toNumberArray
	     * @param {array} [output] - The array to append the points to. If not specified a new array will be created.
	     * @return {array} The flattened array.
	     */toNumberArray:function toNumberArray(output){if(output===undefined){output=[];}for(var i=0;i<this._points.length;i++){if(typeof this._points[i]==='number'){output.push(this._points[i]);output.push(this._points[i+1]);i++;}else{output.push(this._points[i].x);output.push(this._points[i].y);}}return output;},/**
	     * Flattens this Polygon so the points are a sequence of numbers.
	     * Any Point objects found are removed and replaced with two numbers.
	     * Also sets the Polygon.flattened property to `true`.
	     *
	     * @method Phaser.Polygon#flatten
	     * @return {Phaser.Polygon} This Polygon object
	     */flatten:function flatten(){this._points=this.toNumberArray();this.flattened=true;return this;},/**
	     * Creates a copy of the given Polygon.
	     * This is a deep clone, the resulting copy contains new Phaser.Point objects
	     *
	     * @method Phaser.Polygon#clone
	     * @param {Phaser.Polygon} [output=(new Polygon)] - The polygon to update. If not specified a new polygon will be created.
	     * @return {Phaser.Polygon} The cloned (`output`) polygon object.
	     */clone:function clone(output){var points=this._points.slice();if(output===undefined||output===null){output=new Phaser.Polygon(points);}else{output.setTo(points);}return output;},/**
	    * Checks whether the x and y coordinates are contained within this polygon.
	    *
	    * @method Phaser.Polygon#contains
	    * @param {number} x - The X value of the coordinate to test.
	    * @param {number} y - The Y value of the coordinate to test.
	    * @return {boolean} True if the coordinates are within this polygon, otherwise false.
	    */contains:function contains(x,y){//  Adapted from http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html by Jonas Raoni Soares Silva
	var inside=false;if(this.flattened){for(var i=-2,j=this._points.length-2;(i+=2)<this._points.length;j=i){var ix=this._points[i];var iy=this._points[i+1];var jx=this._points[j];var jy=this._points[j+1];if((iy<=y&&y<jy||jy<=y&&y<iy)&&x<(jx-ix)*(y-iy)/(jy-iy)+ix){inside=!inside;}}}else{for(var i=-1,j=this._points.length-1;++i<this._points.length;j=i){var ix=this._points[i].x;var iy=this._points[i].y;var jx=this._points[j].x;var jy=this._points[j].y;if((iy<=y&&y<jy||jy<=y&&y<iy)&&x<(jx-ix)*(y-iy)/(jy-iy)+ix){inside=!inside;}}}return inside;},/**
	     * Sets this Polygon to the given points.
	     *
	     * The points can be set from a variety of formats:
	     *
	     * - An array of Point objects: `[new Phaser.Point(x1, y1), ...]`
	     * - An array of objects with public x/y properties: `[obj1, obj2, ...]`
	     * - An array of paired numbers that represent point coordinates: `[x1,y1, x2,y2, ...]`
	     * - An array of arrays with two elements representing x/y coordinates: `[[x1, y1], [x2, y2], ...]`
	     * - As separate Point arguments: `setTo(new Phaser.Point(x1, y1), ...)`
	     * - As separate objects with public x/y properties arguments: `setTo(obj1, obj2, ...)`
	     * - As separate arguments representing point coordinates: `setTo(x1,y1, x2,y2, ...)`
	     *
	     * `setTo` may also be called without any arguments to remove all points.
	     *
	     * @method Phaser.Polygon#setTo
	     * @param {Phaser.Point[]|number[]|...Phaser.Point|...number} points - The points to set.
	     * @return {Phaser.Polygon} This Polygon object
	     */setTo:function setTo(points){this.area=0;this._points=[];if(arguments.length>0){//  If points isn't an array, use arguments as the array
	if(!Array.isArray(points)){points=Array.prototype.slice.call(arguments);}var y0=Number.MAX_VALUE;//  Allows for mixed-type arguments
	for(var i=0,len=points.length;i<len;i++){if(typeof points[i]==='number'){var p=new PIXI.Point(points[i],points[i+1]);i++;}else if(Array.isArray(points[i])){var p=new PIXI.Point(points[i][0],points[i][1]);}else{var p=new PIXI.Point(points[i].x,points[i].y);}this._points.push(p);//  Lowest boundary
	if(p.y<y0){y0=p.y;}}this.calculateArea(y0);}return this;},/**
	     * Calcuates the area of the Polygon. This is available in the property Polygon.area
	     *
	     * @method Phaser.Polygon#calculateArea
	     * @private
	     * @param {number} y0 - The lowest boundary
	     * @return {number} The area of the Polygon.
	     */calculateArea:function calculateArea(y0){var p1;var p2;var avgHeight;var width;for(var i=0,len=this._points.length;i<len;i++){p1=this._points[i];if(i===len-1){p2=this._points[0];}else{p2=this._points[i+1];}avgHeight=(p1.y-y0+(p2.y-y0))/2;width=p1.x-p2.x;this.area+=avgHeight*width;}return this.area;}};Phaser.Polygon.prototype.constructor=Phaser.Polygon;/**
	* Sets and modifies the points of this polygon.
	*
	* See {@link Phaser.Polygon#setTo setTo} for the different kinds of arrays formats that can be assigned.
	*
	* @name Phaser.Polygon#points
	* @property {Phaser.Point[]} points - The array of vertex points.
	* @deprecated Use `setTo`.
	*/Object.defineProperty(Phaser.Polygon.prototype,'points',{get:function get(){return this._points;},set:function set(points){if(points!=null){this.setTo(points);}else{//  Clear the points
	this.setTo();}}});//  Because PIXI uses its own type, we'll replace it with ours to avoid duplicating code or confusion.
	PIXI.Polygon=Phaser.Polygon;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Creates a new Rectangle object with the top-left corner specified by the x and y parameters and with the specified width and height parameters.
	* If you call this function without parameters, a Rectangle with x, y, width, and height properties set to 0 is created.
	*
	* @class Phaser.Rectangle
	* @constructor
	* @param {number} x - The x coordinate of the top-left corner of the Rectangle.
	* @param {number} y - The y coordinate of the top-left corner of the Rectangle.
	* @param {number} width - The width of the Rectangle. Should always be either zero or a positive value.
	* @param {number} height - The height of the Rectangle. Should always be either zero or a positive value.
	*/Phaser.Rectangle=function(x,y,width,height){x=x||0;y=y||0;width=width||0;height=height||0;/**
	    * @property {number} x - The x coordinate of the top-left corner of the Rectangle.
	    */this.x=x;/**
	    * @property {number} y - The y coordinate of the top-left corner of the Rectangle.
	    */this.y=y;/**
	    * @property {number} width - The width of the Rectangle. This value should never be set to a negative.
	    */this.width=width;/**
	    * @property {number} height - The height of the Rectangle. This value should never be set to a negative.
	    */this.height=height;/**
	    * @property {number} type - The const type of this object.
	    * @readonly
	    */this.type=Phaser.RECTANGLE;};Phaser.Rectangle.prototype={/**
	    * Adjusts the location of the Rectangle object, as determined by its top-left corner, by the specified amounts.
	    * @method Phaser.Rectangle#offset
	    * @param {number} dx - Moves the x value of the Rectangle object by this amount.
	    * @param {number} dy - Moves the y value of the Rectangle object by this amount.
	    * @return {Phaser.Rectangle} This Rectangle object.
	    */offset:function offset(dx,dy){this.x+=dx;this.y+=dy;return this;},/**
	    * Adjusts the location of the Rectangle object using a Point object as a parameter. This method is similar to the Rectangle.offset() method, except that it takes a Point object as a parameter.
	    * @method Phaser.Rectangle#offsetPoint
	    * @param {Phaser.Point} point - A Point object to use to offset this Rectangle object.
	    * @return {Phaser.Rectangle} This Rectangle object.
	    */offsetPoint:function offsetPoint(point){return this.offset(point.x,point.y);},/**
	    * Sets the members of Rectangle to the specified values.
	    * @method Phaser.Rectangle#setTo
	    * @param {number} x - The x coordinate of the top-left corner of the Rectangle.
	    * @param {number} y - The y coordinate of the top-left corner of the Rectangle.
	    * @param {number} width - The width of the Rectangle. Should always be either zero or a positive value.
	    * @param {number} height - The height of the Rectangle. Should always be either zero or a positive value.
	    * @return {Phaser.Rectangle} This Rectangle object
	    */setTo:function setTo(x,y,width,height){this.x=x;this.y=y;this.width=width;this.height=height;return this;},/**
	    * Scales the width and height of this Rectangle by the given amounts.
	    * 
	    * @method Phaser.Rectangle#scale
	    * @param {number} x - The amount to scale the width of the Rectangle by. A value of 0.5 would reduce by half, a value of 2 would double the width, etc.
	    * @param {number} [y] - The amount to scale the height of the Rectangle by. A value of 0.5 would reduce by half, a value of 2 would double the height, etc.
	    * @return {Phaser.Rectangle} This Rectangle object
	    */scale:function scale(x,y){if(y===undefined){y=x;}this.width*=x;this.height*=y;return this;},/**
	    * Centers this Rectangle so that the center coordinates match the given x and y values.
	    *
	    * @method Phaser.Rectangle#centerOn
	    * @param {number} x - The x coordinate to place the center of the Rectangle at.
	    * @param {number} y - The y coordinate to place the center of the Rectangle at.
	    * @return {Phaser.Rectangle} This Rectangle object
	    */centerOn:function centerOn(x,y){this.centerX=x;this.centerY=y;return this;},/**
	    * Runs Math.floor() on both the x and y values of this Rectangle.
	    * @method Phaser.Rectangle#floor
	    */floor:function floor(){this.x=Math.floor(this.x);this.y=Math.floor(this.y);},/**
	    * Runs Math.floor() on the x, y, width and height values of this Rectangle.
	    * @method Phaser.Rectangle#floorAll
	    */floorAll:function floorAll(){this.x=Math.floor(this.x);this.y=Math.floor(this.y);this.width=Math.floor(this.width);this.height=Math.floor(this.height);},/**
	    * Runs Math.ceil() on both the x and y values of this Rectangle.
	    * @method Phaser.Rectangle#ceil
	    */ceil:function ceil(){this.x=Math.ceil(this.x);this.y=Math.ceil(this.y);},/**
	    * Runs Math.ceil() on the x, y, width and height values of this Rectangle.
	    * @method Phaser.Rectangle#ceilAll
	    */ceilAll:function ceilAll(){this.x=Math.ceil(this.x);this.y=Math.ceil(this.y);this.width=Math.ceil(this.width);this.height=Math.ceil(this.height);},/**
	    * Copies the x, y, width and height properties from any given object to this Rectangle.
	    * @method Phaser.Rectangle#copyFrom
	    * @param {any} source - The object to copy from.
	    * @return {Phaser.Rectangle} This Rectangle object.
	    */copyFrom:function copyFrom(source){return this.setTo(source.x,source.y,source.width,source.height);},/**
	    * Copies the x, y, width and height properties from this Rectangle to any given object.
	    * @method Phaser.Rectangle#copyTo
	    * @param {any} source - The object to copy to.
	    * @return {object} This object.
	    */copyTo:function copyTo(dest){dest.x=this.x;dest.y=this.y;dest.width=this.width;dest.height=this.height;return dest;},/**
	    * Increases the size of the Rectangle object by the specified amounts. The center point of the Rectangle object stays the same, and its size increases to the left and right by the dx value, and to the top and the bottom by the dy value.
	    * @method Phaser.Rectangle#inflate
	    * @param {number} dx - The amount to be added to the left side of the Rectangle.
	    * @param {number} dy - The amount to be added to the bottom side of the Rectangle.
	    * @return {Phaser.Rectangle} This Rectangle object.
	    */inflate:function inflate(dx,dy){return Phaser.Rectangle.inflate(this,dx,dy);},/**
	    * The size of the Rectangle object, expressed as a Point object with the values of the width and height properties.
	    * @method Phaser.Rectangle#size
	    * @param {Phaser.Point} [output] - Optional Point object. If given the values will be set into the object, otherwise a brand new Point object will be created and returned.
	    * @return {Phaser.Point} The size of the Rectangle object.
	    */size:function size(output){return Phaser.Rectangle.size(this,output);},/**
	    * Resize the Rectangle by providing a new width and height.
	    * The x and y positions remain unchanged.
	    * 
	    * @method Phaser.Rectangle#resize
	    * @param {number} width - The width of the Rectangle. Should always be either zero or a positive value.
	    * @param {number} height - The height of the Rectangle. Should always be either zero or a positive value.
	    * @return {Phaser.Rectangle} This Rectangle object
	    */resize:function resize(width,height){this.width=width;this.height=height;return this;},/**
	    * Returns a new Rectangle object with the same values for the x, y, width, and height properties as the original Rectangle object.
	    * @method Phaser.Rectangle#clone
	    * @param {Phaser.Rectangle} [output] - Optional Rectangle object. If given the values will be set into the object, otherwise a brand new Rectangle object will be created and returned.
	    * @return {Phaser.Rectangle}
	    */clone:function clone(output){return Phaser.Rectangle.clone(this,output);},/**
	    * Determines whether the specified coordinates are contained within the region defined by this Rectangle object.
	    * @method Phaser.Rectangle#contains
	    * @param {number} x - The x coordinate of the point to test.
	    * @param {number} y - The y coordinate of the point to test.
	    * @return {boolean} A value of true if the Rectangle object contains the specified point; otherwise false.
	    */contains:function contains(x,y){return Phaser.Rectangle.contains(this,x,y);},/**
	    * Determines whether the first Rectangle object is fully contained within the second Rectangle object.
	    * A Rectangle object is said to contain another if the second Rectangle object falls entirely within the boundaries of the first.
	    * @method Phaser.Rectangle#containsRect
	    * @param {Phaser.Rectangle} b - The second Rectangle object.
	    * @return {boolean} A value of true if the Rectangle object contains the specified point; otherwise false.
	    */containsRect:function containsRect(b){return Phaser.Rectangle.containsRect(b,this);},/**
	    * Determines whether the two Rectangles are equal.
	    * This method compares the x, y, width and height properties of each Rectangle.
	    * @method Phaser.Rectangle#equals
	    * @param {Phaser.Rectangle} b - The second Rectangle object.
	    * @return {boolean} A value of true if the two Rectangles have exactly the same values for the x, y, width and height properties; otherwise false.
	    */equals:function equals(b){return Phaser.Rectangle.equals(this,b);},/**
	    * If the Rectangle object specified in the toIntersect parameter intersects with this Rectangle object, returns the area of intersection as a Rectangle object. If the Rectangles do not intersect, this method returns an empty Rectangle object with its properties set to 0.
	    * @method Phaser.Rectangle#intersection
	    * @param {Phaser.Rectangle} b - The second Rectangle object.
	    * @param {Phaser.Rectangle} out - Optional Rectangle object. If given the intersection values will be set into this object, otherwise a brand new Rectangle object will be created and returned.
	    * @return {Phaser.Rectangle} A Rectangle object that equals the area of intersection. If the Rectangles do not intersect, this method returns an empty Rectangle object; that is, a Rectangle with its x, y, width, and height properties set to 0.
	    */intersection:function intersection(b,out){return Phaser.Rectangle.intersection(this,b,out);},/**
	    * Determines whether this Rectangle and another given Rectangle intersect with each other.
	    * This method checks the x, y, width, and height properties of the two Rectangles.
	    * 
	    * @method Phaser.Rectangle#intersects
	    * @param {Phaser.Rectangle} b - The second Rectangle object.
	    * @return {boolean} A value of true if the specified object intersects with this Rectangle object; otherwise false.
	    */intersects:function intersects(b){return Phaser.Rectangle.intersects(this,b);},/**
	    * Determines whether the coordinates given intersects (overlaps) with this Rectangle.
	    *
	    * @method Phaser.Rectangle#intersectsRaw
	    * @param {number} left - The x coordinate of the left of the area.
	    * @param {number} right - The right coordinate of the area.
	    * @param {number} top - The y coordinate of the area.
	    * @param {number} bottom - The bottom coordinate of the area.
	    * @param {number} tolerance - A tolerance value to allow for an intersection test with padding, default to 0
	    * @return {boolean} A value of true if the specified object intersects with the Rectangle; otherwise false.
	    */intersectsRaw:function intersectsRaw(left,right,top,bottom,tolerance){return Phaser.Rectangle.intersectsRaw(this,left,right,top,bottom,tolerance);},/**
	    * Adds two Rectangles together to create a new Rectangle object, by filling in the horizontal and vertical space between the two Rectangles.
	    * @method Phaser.Rectangle#union
	    * @param {Phaser.Rectangle} b - The second Rectangle object.
	    * @param {Phaser.Rectangle} [out] - Optional Rectangle object. If given the new values will be set into this object, otherwise a brand new Rectangle object will be created and returned.
	    * @return {Phaser.Rectangle} A Rectangle object that is the union of the two Rectangles.
	    */union:function union(b,out){return Phaser.Rectangle.union(this,b,out);},/**
	    * Returns a uniformly distributed random point from anywhere within this Rectangle.
	    * 
	    * @method Phaser.Rectangle#random
	    * @param {Phaser.Point|object} [out] - A Phaser.Point, or any object with public x/y properties, that the values will be set in.
	    *     If no object is provided a new Phaser.Point object will be created. In high performance areas avoid this by re-using an existing object.
	    * @return {Phaser.Point} An object containing the random point in its `x` and `y` properties.
	    */random:function random(out){if(out===undefined){out=new Phaser.Point();}out.x=this.randomX;out.y=this.randomY;return out;},/**
	    * Returns a point based on the given position constant, which can be one of:
	    * 
	    * `Phaser.TOP_LEFT`, `Phaser.TOP_CENTER`, `Phaser.TOP_RIGHT`, `Phaser.LEFT_CENTER`,
	    * `Phaser.CENTER`, `Phaser.RIGHT_CENTER`, `Phaser.BOTTOM_LEFT`, `Phaser.BOTTOM_CENTER` 
	    * and `Phaser.BOTTOM_RIGHT`.
	    *
	    * This method returns the same values as calling Rectangle.bottomLeft, etc, but those
	    * calls always create a new Point object, where-as this one allows you to use your own.
	    * 
	    * @method Phaser.Rectangle#getPoint
	    * @param {integer} [position] - One of the Phaser position constants, such as `Phaser.TOP_RIGHT`.
	    * @param {Phaser.Point} [out] - A Phaser.Point that the values will be set in.
	    *     If no object is provided a new Phaser.Point object will be created. In high performance areas avoid this by re-using an existing object.
	    * @return {Phaser.Point} An object containing the point in its `x` and `y` properties.
	    */getPoint:function getPoint(position,out){if(out===undefined){out=new Phaser.Point();}switch(position){default:case Phaser.TOP_LEFT:return out.set(this.x,this.y);case Phaser.TOP_CENTER:return out.set(this.centerX,this.y);case Phaser.TOP_RIGHT:return out.set(this.right,this.y);case Phaser.LEFT_CENTER:return out.set(this.x,this.centerY);case Phaser.CENTER:return out.set(this.centerX,this.centerY);case Phaser.RIGHT_CENTER:return out.set(this.right,this.centerY);case Phaser.BOTTOM_LEFT:return out.set(this.x,this.bottom);case Phaser.BOTTOM_CENTER:return out.set(this.centerX,this.bottom);case Phaser.BOTTOM_RIGHT:return out.set(this.right,this.bottom);}},/**
	    * Returns a string representation of this object.
	    * @method Phaser.Rectangle#toString
	    * @return {string} A string representation of the instance.
	    */toString:function toString(){return"[{Rectangle (x="+this.x+" y="+this.y+" width="+this.width+" height="+this.height+" empty="+this.empty+")}]";}};/**
	* @name Phaser.Rectangle#halfWidth
	* @property {number} halfWidth - Half of the width of the Rectangle.
	* @readonly
	*/Object.defineProperty(Phaser.Rectangle.prototype,"halfWidth",{get:function get(){return Math.round(this.width/2);}});/**
	* @name Phaser.Rectangle#halfHeight
	* @property {number} halfHeight - Half of the height of the Rectangle.
	* @readonly
	*/Object.defineProperty(Phaser.Rectangle.prototype,"halfHeight",{get:function get(){return Math.round(this.height/2);}});/**
	* The sum of the y and height properties. Changing the bottom property of a Rectangle object has no effect on the x, y and width properties, but does change the height property.
	* @name Phaser.Rectangle#bottom
	* @property {number} bottom - The sum of the y and height properties.
	*/Object.defineProperty(Phaser.Rectangle.prototype,"bottom",{get:function get(){return this.y+this.height;},set:function set(value){if(value<=this.y){this.height=0;}else{this.height=value-this.y;}}});/**
	* The location of the Rectangles bottom left corner as a Point object.
	* @name Phaser.Rectangle#bottomLeft
	* @property {Phaser.Point} bottomLeft - Gets or sets the location of the Rectangles bottom left corner as a Point object.
	*/Object.defineProperty(Phaser.Rectangle.prototype,"bottomLeft",{get:function get(){return new Phaser.Point(this.x,this.bottom);},set:function set(value){this.x=value.x;this.bottom=value.y;}});/**
	* The location of the Rectangles bottom right corner as a Point object.
	* @name Phaser.Rectangle#bottomRight
	* @property {Phaser.Point} bottomRight - Gets or sets the location of the Rectangles bottom right corner as a Point object.
	*/Object.defineProperty(Phaser.Rectangle.prototype,"bottomRight",{get:function get(){return new Phaser.Point(this.right,this.bottom);},set:function set(value){this.right=value.x;this.bottom=value.y;}});/**
	* The x coordinate of the left of the Rectangle. Changing the left property of a Rectangle object has no effect on the y and height properties. However it does affect the width property, whereas changing the x value does not affect the width property.
	* @name Phaser.Rectangle#left
	* @property {number} left - The x coordinate of the left of the Rectangle.
	*/Object.defineProperty(Phaser.Rectangle.prototype,"left",{get:function get(){return this.x;},set:function set(value){if(value>=this.right){this.width=0;}else{this.width=this.right-value;}this.x=value;}});/**
	* The sum of the x and width properties. Changing the right property of a Rectangle object has no effect on the x, y and height properties, however it does affect the width property.
	* @name Phaser.Rectangle#right
	* @property {number} right - The sum of the x and width properties.
	*/Object.defineProperty(Phaser.Rectangle.prototype,"right",{get:function get(){return this.x+this.width;},set:function set(value){if(value<=this.x){this.width=0;}else{this.width=value-this.x;}}});/**
	* The volume of the Rectangle derived from width * height.
	* @name Phaser.Rectangle#volume
	* @property {number} volume - The volume of the Rectangle derived from width * height.
	* @readonly
	*/Object.defineProperty(Phaser.Rectangle.prototype,"volume",{get:function get(){return this.width*this.height;}});/**
	* The perimeter size of the Rectangle. This is the sum of all 4 sides.
	* @name Phaser.Rectangle#perimeter
	* @property {number} perimeter - The perimeter size of the Rectangle. This is the sum of all 4 sides.
	* @readonly
	*/Object.defineProperty(Phaser.Rectangle.prototype,"perimeter",{get:function get(){return this.width*2+this.height*2;}});/**
	* The x coordinate of the center of the Rectangle.
	* @name Phaser.Rectangle#centerX
	* @property {number} centerX - The x coordinate of the center of the Rectangle.
	*/Object.defineProperty(Phaser.Rectangle.prototype,"centerX",{get:function get(){return this.x+this.halfWidth;},set:function set(value){this.x=value-this.halfWidth;}});/**
	* The y coordinate of the center of the Rectangle.
	* @name Phaser.Rectangle#centerY
	* @property {number} centerY - The y coordinate of the center of the Rectangle.
	*/Object.defineProperty(Phaser.Rectangle.prototype,"centerY",{get:function get(){return this.y+this.halfHeight;},set:function set(value){this.y=value-this.halfHeight;}});/**
	* A random value between the left and right values (inclusive) of the Rectangle.
	*
	* @name Phaser.Rectangle#randomX
	* @property {number} randomX - A random value between the left and right values (inclusive) of the Rectangle.
	*/Object.defineProperty(Phaser.Rectangle.prototype,"randomX",{get:function get(){return this.x+Math.random()*this.width;}});/**
	* A random value between the top and bottom values (inclusive) of the Rectangle.
	*
	* @name Phaser.Rectangle#randomY
	* @property {number} randomY - A random value between the top and bottom values (inclusive) of the Rectangle.
	*/Object.defineProperty(Phaser.Rectangle.prototype,"randomY",{get:function get(){return this.y+Math.random()*this.height;}});/**
	* The y coordinate of the top of the Rectangle. Changing the top property of a Rectangle object has no effect on the x and width properties.
	* However it does affect the height property, whereas changing the y value does not affect the height property.
	* @name Phaser.Rectangle#top
	* @property {number} top - The y coordinate of the top of the Rectangle.
	*/Object.defineProperty(Phaser.Rectangle.prototype,"top",{get:function get(){return this.y;},set:function set(value){if(value>=this.bottom){this.height=0;this.y=value;}else{this.height=this.bottom-value;}}});/**
	* The location of the Rectangles top left corner as a Point object.
	* @name Phaser.Rectangle#topLeft
	* @property {Phaser.Point} topLeft - The location of the Rectangles top left corner as a Point object.
	*/Object.defineProperty(Phaser.Rectangle.prototype,"topLeft",{get:function get(){return new Phaser.Point(this.x,this.y);},set:function set(value){this.x=value.x;this.y=value.y;}});/**
	* The location of the Rectangles top right corner as a Point object.
	* @name Phaser.Rectangle#topRight
	* @property {Phaser.Point} topRight - The location of the Rectangles top left corner as a Point object.
	*/Object.defineProperty(Phaser.Rectangle.prototype,"topRight",{get:function get(){return new Phaser.Point(this.x+this.width,this.y);},set:function set(value){this.right=value.x;this.y=value.y;}});/**
	* Determines whether or not this Rectangle object is empty. A Rectangle object is empty if its width or height is less than or equal to 0.
	* If set to true then all of the Rectangle properties are set to 0.
	* @name Phaser.Rectangle#empty
	* @property {boolean} empty - Gets or sets the Rectangles empty state.
	*/Object.defineProperty(Phaser.Rectangle.prototype,"empty",{get:function get(){return!this.width||!this.height;},set:function set(value){if(value===true){this.setTo(0,0,0,0);}}});Phaser.Rectangle.prototype.constructor=Phaser.Rectangle;/**
	* Increases the size of the Rectangle object by the specified amounts. The center point of the Rectangle object stays the same, and its size increases to the left and right by the dx value, and to the top and the bottom by the dy value.
	* @method Phaser.Rectangle.inflate
	* @param {Phaser.Rectangle} a - The Rectangle object.
	* @param {number} dx - The amount to be added to the left side of the Rectangle.
	* @param {number} dy - The amount to be added to the bottom side of the Rectangle.
	* @return {Phaser.Rectangle} This Rectangle object.
	*/Phaser.Rectangle.inflate=function(a,dx,dy){a.x-=dx;a.width+=2*dx;a.y-=dy;a.height+=2*dy;return a;};/**
	* Increases the size of the Rectangle object. This method is similar to the Rectangle.inflate() method except it takes a Point object as a parameter.
	* @method Phaser.Rectangle.inflatePoint
	* @param {Phaser.Rectangle} a - The Rectangle object.
	* @param {Phaser.Point} point - The x property of this Point object is used to increase the horizontal dimension of the Rectangle object. The y property is used to increase the vertical dimension of the Rectangle object.
	* @return {Phaser.Rectangle} The Rectangle object.
	*/Phaser.Rectangle.inflatePoint=function(a,point){return Phaser.Rectangle.inflate(a,point.x,point.y);};/**
	* The size of the Rectangle object, expressed as a Point object with the values of the width and height properties.
	* @method Phaser.Rectangle.size
	* @param {Phaser.Rectangle} a - The Rectangle object.
	* @param {Phaser.Point} [output] - Optional Point object. If given the values will be set into the object, otherwise a brand new Point object will be created and returned.
	* @return {Phaser.Point} The size of the Rectangle object
	*/Phaser.Rectangle.size=function(a,output){if(output===undefined||output===null){output=new Phaser.Point(a.width,a.height);}else{output.setTo(a.width,a.height);}return output;};/**
	* Returns a new Rectangle object with the same values for the x, y, width, and height properties as the original Rectangle object.
	* @method Phaser.Rectangle.clone
	* @param {Phaser.Rectangle} a - The Rectangle object.
	* @param {Phaser.Rectangle} [output] - Optional Rectangle object. If given the values will be set into the object, otherwise a brand new Rectangle object will be created and returned.
	* @return {Phaser.Rectangle}
	*/Phaser.Rectangle.clone=function(a,output){if(output===undefined||output===null){output=new Phaser.Rectangle(a.x,a.y,a.width,a.height);}else{output.setTo(a.x,a.y,a.width,a.height);}return output;};/**
	* Determines whether the specified coordinates are contained within the region defined by this Rectangle object.
	* @method Phaser.Rectangle.contains
	* @param {Phaser.Rectangle} a - The Rectangle object.
	* @param {number} x - The x coordinate of the point to test.
	* @param {number} y - The y coordinate of the point to test.
	* @return {boolean} A value of true if the Rectangle object contains the specified point; otherwise false.
	*/Phaser.Rectangle.contains=function(a,x,y){if(a.width<=0||a.height<=0){return false;}return x>=a.x&&x<a.right&&y>=a.y&&y<a.bottom;};/**
	* Determines whether the specified coordinates are contained within the region defined by the given raw values.
	* @method Phaser.Rectangle.containsRaw
	* @param {number} rx - The x coordinate of the top left of the area.
	* @param {number} ry - The y coordinate of the top left of the area.
	* @param {number} rw - The width of the area.
	* @param {number} rh - The height of the area.
	* @param {number} x - The x coordinate of the point to test.
	* @param {number} y - The y coordinate of the point to test.
	* @return {boolean} A value of true if the Rectangle object contains the specified point; otherwise false.
	*/Phaser.Rectangle.containsRaw=function(rx,ry,rw,rh,x,y){return x>=rx&&x<rx+rw&&y>=ry&&y<ry+rh;};/**
	* Determines whether the specified point is contained within the rectangular region defined by this Rectangle object. This method is similar to the Rectangle.contains() method, except that it takes a Point object as a parameter.
	* @method Phaser.Rectangle.containsPoint
	* @param {Phaser.Rectangle} a - The Rectangle object.
	* @param {Phaser.Point} point - The point object being checked. Can be Point or any object with .x and .y values.
	* @return {boolean} A value of true if the Rectangle object contains the specified point; otherwise false.
	*/Phaser.Rectangle.containsPoint=function(a,point){return Phaser.Rectangle.contains(a,point.x,point.y);};/**
	* Determines whether the first Rectangle object is fully contained within the second Rectangle object.
	* A Rectangle object is said to contain another if the second Rectangle object falls entirely within the boundaries of the first.
	* @method Phaser.Rectangle.containsRect
	* @param {Phaser.Rectangle} a - The first Rectangle object.
	* @param {Phaser.Rectangle} b - The second Rectangle object.
	* @return {boolean} A value of true if the Rectangle object contains the specified point; otherwise false.
	*/Phaser.Rectangle.containsRect=function(a,b){//  If the given rect has a larger volume than this one then it can never contain it
	if(a.volume>b.volume){return false;}return a.x>=b.x&&a.y>=b.y&&a.right<b.right&&a.bottom<b.bottom;};/**
	* Determines whether the two Rectangles are equal.
	* This method compares the x, y, width and height properties of each Rectangle.
	* @method Phaser.Rectangle.equals
	* @param {Phaser.Rectangle} a - The first Rectangle object.
	* @param {Phaser.Rectangle} b - The second Rectangle object.
	* @return {boolean} A value of true if the two Rectangles have exactly the same values for the x, y, width and height properties; otherwise false.
	*/Phaser.Rectangle.equals=function(a,b){return a.x===b.x&&a.y===b.y&&a.width===b.width&&a.height===b.height;};/**
	* Determines if the two objects (either Rectangles or Rectangle-like) have the same width and height values under strict equality.
	* @method Phaser.Rectangle.sameDimensions
	* @param {Rectangle-like} a - The first Rectangle object.
	* @param {Rectangle-like} b - The second Rectangle object.
	* @return {boolean} True if the object have equivalent values for the width and height properties.
	*/Phaser.Rectangle.sameDimensions=function(a,b){return a.width===b.width&&a.height===b.height;};/**
	* If the Rectangle object specified in the toIntersect parameter intersects with this Rectangle object, returns the area of intersection as a Rectangle object. If the Rectangles do not intersect, this method returns an empty Rectangle object with its properties set to 0.
	* @method Phaser.Rectangle.intersection
	* @param {Phaser.Rectangle} a - The first Rectangle object.
	* @param {Phaser.Rectangle} b - The second Rectangle object.
	* @param {Phaser.Rectangle} [output] - Optional Rectangle object. If given the intersection values will be set into this object, otherwise a brand new Rectangle object will be created and returned.
	* @return {Phaser.Rectangle} A Rectangle object that equals the area of intersection. If the Rectangles do not intersect, this method returns an empty Rectangle object; that is, a Rectangle with its x, y, width, and height properties set to 0.
	*/Phaser.Rectangle.intersection=function(a,b,output){if(output===undefined){output=new Phaser.Rectangle();}if(Phaser.Rectangle.intersects(a,b)){output.x=Math.max(a.x,b.x);output.y=Math.max(a.y,b.y);output.width=Math.min(a.right,b.right)-output.x;output.height=Math.min(a.bottom,b.bottom)-output.y;}return output;};/**
	* Determines whether the two Rectangles intersect with each other.
	* This method checks the x, y, width, and height properties of the Rectangles.
	* @method Phaser.Rectangle.intersects
	* @param {Phaser.Rectangle} a - The first Rectangle object.
	* @param {Phaser.Rectangle} b - The second Rectangle object.
	* @return {boolean} A value of true if the specified object intersects with this Rectangle object; otherwise false.
	*/Phaser.Rectangle.intersects=function(a,b){if(a.width<=0||a.height<=0||b.width<=0||b.height<=0){return false;}return!(a.right<b.x||a.bottom<b.y||a.x>b.right||a.y>b.bottom);};/**
	* Determines whether the object specified intersects (overlaps) with the given values.
	* @method Phaser.Rectangle.intersectsRaw
	* @param {number} left - The x coordinate of the left of the area.
	* @param {number} right - The right coordinate of the area.
	* @param {number} top - The y coordinate of the area.
	* @param {number} bottom - The bottom coordinate of the area.
	* @param {number} tolerance - A tolerance value to allow for an intersection test with padding, default to 0
	* @return {boolean} A value of true if the specified object intersects with the Rectangle; otherwise false.
	*/Phaser.Rectangle.intersectsRaw=function(a,left,right,top,bottom,tolerance){if(tolerance===undefined){tolerance=0;}return!(left>a.right+tolerance||right<a.left-tolerance||top>a.bottom+tolerance||bottom<a.top-tolerance);};/**
	* Adds two Rectangles together to create a new Rectangle object, by filling in the horizontal and vertical space between the two Rectangles.
	* @method Phaser.Rectangle.union
	* @param {Phaser.Rectangle} a - The first Rectangle object.
	* @param {Phaser.Rectangle} b - The second Rectangle object.
	* @param {Phaser.Rectangle} [output] - Optional Rectangle object. If given the new values will be set into this object, otherwise a brand new Rectangle object will be created and returned.
	* @return {Phaser.Rectangle} A Rectangle object that is the union of the two Rectangles.
	*/Phaser.Rectangle.union=function(a,b,output){if(output===undefined){output=new Phaser.Rectangle();}return output.setTo(Math.min(a.x,b.x),Math.min(a.y,b.y),Math.max(a.right,b.right)-Math.min(a.left,b.left),Math.max(a.bottom,b.bottom)-Math.min(a.top,b.top));};/**
	* Calculates the Axis Aligned Bounding Box (or aabb) from an array of points.
	*
	* @method Phaser.Rectangle#aabb
	* @param {Phaser.Point[]} points - The array of one or more points.
	* @param {Phaser.Rectangle} [out] - Optional Rectangle to store the value in, if not supplied a new Rectangle object will be created.
	* @return {Phaser.Rectangle} The new Rectangle object.
	* @static
	*/Phaser.Rectangle.aabb=function(points,out){if(out===undefined){out=new Phaser.Rectangle();}var xMax=Number.NEGATIVE_INFINITY,xMin=Number.POSITIVE_INFINITY,yMax=Number.NEGATIVE_INFINITY,yMin=Number.POSITIVE_INFINITY;points.forEach(function(point){if(point.x>xMax){xMax=point.x;}if(point.x<xMin){xMin=point.x;}if(point.y>yMax){yMax=point.y;}if(point.y<yMin){yMin=point.y;}});out.setTo(xMin,yMin,xMax-xMin,yMax-yMin);return out;};//   Because PIXI uses its own Rectangle, we'll replace it with ours to avoid duplicating code or confusion.
	PIXI.Rectangle=Phaser.Rectangle;PIXI.EmptyRectangle=new Phaser.Rectangle(0,0,0,0);/**
	* @author       Mat Groves http://matgroves.com/
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Rounded Rectangle object is an area defined by its position and has nice rounded corners, 
	* as indicated by its top-left corner point (x, y) and by its width and its height.
	*
	* @class Phaser.RoundedRectangle
	* @constructor
	* @param {number} [x=0] - The x coordinate of the top-left corner of the Rectangle.
	* @param {number} [y=0] - The y coordinate of the top-left corner of the Rectangle.
	* @param {number} [width=0] - The width of the Rectangle. Should always be either zero or a positive value.
	* @param {number} [height=0] - The height of the Rectangle. Should always be either zero or a positive value.
	* @param {number} [radius=20] - Controls the radius of the rounded corners.
	*/Phaser.RoundedRectangle=function(x,y,width,height,radius){if(x===undefined){x=0;}if(y===undefined){y=0;}if(width===undefined){width=0;}if(height===undefined){height=0;}if(radius===undefined){radius=20;}/**
	    * @property {number} x - The x coordinate of the top-left corner of the Rectangle.
	    */this.x=x;/**
	    * @property {number} y - The y coordinate of the top-left corner of the Rectangle.
	    */this.y=y;/**
	    * @property {number} width - The width of the Rectangle. This value should never be set to a negative.
	    */this.width=width;/**
	    * @property {number} height - The height of the Rectangle. This value should never be set to a negative.
	    */this.height=height;/**
	    * @property {number} radius - The radius of the rounded corners.
	    */this.radius=radius||20;/**
	    * @property {number} type - The const type of this object.
	    * @readonly
	    */this.type=Phaser.ROUNDEDRECTANGLE;};Phaser.RoundedRectangle.prototype={/**
	    * Returns a new RoundedRectangle object with the same values for the x, y, width, height and
	    * radius properties as this RoundedRectangle object.
	    * 
	    * @method Phaser.RoundedRectangle#clone
	    * @return {Phaser.RoundedRectangle}
	    */clone:function clone(){return new Phaser.RoundedRectangle(this.x,this.y,this.width,this.height,this.radius);},/**
	    * Determines whether the specified coordinates are contained within the region defined by this Rounded Rectangle object.
	    * 
	    * @method Phaser.RoundedRectangle#contains
	    * @param {number} x - The x coordinate of the point to test.
	    * @param {number} y - The y coordinate of the point to test.
	    * @return {boolean} A value of true if the RoundedRectangle Rectangle object contains the specified point; otherwise false.
	    */contains:function contains(x,y){if(this.width<=0||this.height<=0){return false;}var x1=this.x;if(x>=x1&&x<=x1+this.width){var y1=this.y;if(y>=y1&&y<=y1+this.height){return true;}}return false;}};Phaser.RoundedRectangle.prototype.constructor=Phaser.RoundedRectangle;//  Because PIXI uses its own type, we'll replace it with ours to avoid duplicating code or confusion.
	PIXI.RoundedRectangle=Phaser.RoundedRectangle;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A Camera is your view into the game world. It has a position and size and renders only those objects within its field of view.
	* The game automatically creates a single Stage sized camera on boot. Move the camera around the world with Phaser.Camera.x/y
	*
	* @class Phaser.Camera
	* @constructor
	* @param {Phaser.Game} game - Game reference to the currently running game.
	* @param {number} id - Not being used at the moment, will be when Phaser supports multiple camera
	* @param {number} x - Position of the camera on the X axis
	* @param {number} y - Position of the camera on the Y axis
	* @param {number} width - The width of the view rectangle
	* @param {number} height - The height of the view rectangle
	*/Phaser.Camera=function(game,id,x,y,width,height){/**
	    * @property {Phaser.Game} game - A reference to the currently running Game.
	    */this.game=game;/**
	    * @property {Phaser.World} world - A reference to the game world.
	    */this.world=game.world;/**
	    * @property {number} id - Reserved for future multiple camera set-ups.
	    * @default
	    */this.id=0;/**
	    * Camera view.
	    * The view into the world we wish to render (by default the game dimensions).
	    * The x/y values are in world coordinates, not screen coordinates, the width/height is how many pixels to render.
	    * Sprites outside of this view are not rendered if Sprite.autoCull is set to `true`. Otherwise they are always rendered.
	    * @property {Phaser.Rectangle} view
	    */this.view=new Phaser.Rectangle(x,y,width,height);/**
	    * The Camera is bound to this Rectangle and cannot move outside of it. By default it is enabled and set to the size of the World.
	    * The Rectangle can be located anywhere in the world and updated as often as you like. If you don't wish the Camera to be bound
	    * at all then set this to null. The values can be anything and are in World coordinates, with 0,0 being the top-left of the world.
	    *
	    * @property {Phaser.Rectangle} bounds - The Rectangle in which the Camera is bounded. Set to null to allow for movement anywhere.
	    */this.bounds=new Phaser.Rectangle(x,y,width,height);/**
	    * @property {Phaser.Rectangle} deadzone - Moving inside this Rectangle will not cause the camera to move.
	    */this.deadzone=null;/**
	    * @property {boolean} visible - Whether this camera is visible or not.
	    * @default
	    */this.visible=true;/**
	    * @property {boolean} roundPx - If a Camera has roundPx set to `true` it will call `view.floor` as part of its update loop, keeping its boundary to integer values. Set this to `false` to disable this from happening.
	    * @default
	    */this.roundPx=true;/**
	    * @property {boolean} atLimit - Whether this camera is flush with the World Bounds or not.
	    */this.atLimit={x:false,y:false};/**
	    * @property {Phaser.Sprite} target - If the camera is tracking a Sprite, this is a reference to it, otherwise null.
	    * @default
	    */this.target=null;/**
	    * @property {PIXI.DisplayObject} displayObject - The display object to which all game objects are added. Set by World.boot.
	    */this.displayObject=null;/**
	    * @property {Phaser.Point} scale - The scale of the display object to which all game objects are added. Set by World.boot.
	    */this.scale=null;/**
	    * @property {number} totalInView - The total number of Sprites with `autoCull` set to `true` that are visible by this Camera.
	    * @readonly
	    */this.totalInView=0;/**
	    * The linear interpolation value to use when following a target.
	    * The default values of 1 means the camera will instantly snap to the target coordinates.
	    * A lower value, such as 0.1 means the camera will more slowly track the target, giving
	    * a smooth transition. You can set the horizontal and vertical values independently, and also
	    * adjust this value in real-time during your game.
	    * @property {Phaser.Point} lerp
	    * @default
	    */this.lerp=new Phaser.Point(1,1);/**
	    * @property {Phaser.Signal} onShakeComplete - This signal is dispatched when the camera shake effect completes.
	    */this.onShakeComplete=new Phaser.Signal();/**
	    * @property {Phaser.Signal} onFlashComplete - This signal is dispatched when the camera flash effect completes.
	    */this.onFlashComplete=new Phaser.Signal();/**
	    * This signal is dispatched when the camera fade effect completes.
	    * When the fade effect completes you will be left with the screen black (or whatever
	    * color you faded to). In order to reset this call `Camera.resetFX`. This is called
	    * automatically when you change State.
	    * @property {Phaser.Signal} onFadeComplete
	    */this.onFadeComplete=new Phaser.Signal();/**
	    * The Graphics object used to handle camera fx such as fade and flash.
	    * @property {Phaser.Graphics} fx
	    * @protected
	    */this.fx=null;/**
	    * @property {Phaser.Point} _targetPosition - Internal point used to calculate target position.
	    * @private
	    */this._targetPosition=new Phaser.Point();/**
	    * @property {number} edge - Edge property.
	    * @private
	    * @default
	    */this._edge=0;/**
	    * @property {Phaser.Point} position - Current position of the camera in world.
	    * @private
	    * @default
	    */this._position=new Phaser.Point();/**
	    * @property {Object} _shake - The shake effect container.
	    * @private
	    */this._shake={intensity:0,duration:0,horizontal:false,vertical:false,shakeBounds:true,x:0,y:0};/**
	    * @property {number} _fxDuration - FX duration timer.
	    * @private
	    */this._fxDuration=0;/**
	    * @property {number} _fxType - The FX type running.
	    * @private
	    */this._fxType=0;};/**
	* @constant
	* @type {number}
	*/Phaser.Camera.FOLLOW_LOCKON=0;/**
	* @constant
	* @type {number}
	*/Phaser.Camera.FOLLOW_PLATFORMER=1;/**
	* @constant
	* @type {number}
	*/Phaser.Camera.FOLLOW_TOPDOWN=2;/**
	* @constant
	* @type {number}
	*/Phaser.Camera.FOLLOW_TOPDOWN_TIGHT=3;/**
	* @constant
	* @type {number}
	*/Phaser.Camera.SHAKE_BOTH=4;/**
	* @constant
	* @type {number}
	*/Phaser.Camera.SHAKE_HORIZONTAL=5;/**
	* @constant
	* @type {number}
	*/Phaser.Camera.SHAKE_VERTICAL=6;/**
	* @constant
	* @type {boolean}
	*/Phaser.Camera.ENABLE_FX=true;Phaser.Camera.prototype={/**
	    * Called automatically by Phaser.World.
	    *
	    * @method Phaser.Camera#boot
	    * @private
	    */boot:function boot(){this.displayObject=this.game.world;this.scale=this.game.world.scale;this.game.camera=this;if(Phaser.Graphics&&Phaser.Camera.ENABLE_FX){this.fx=new Phaser.Graphics(this.game);this.game.stage.addChild(this.fx);}},/**
	    * Camera preUpdate. Sets the total view counter to zero.
	    *
	    * @method Phaser.Camera#preUpdate
	    */preUpdate:function preUpdate(){this.totalInView=0;},/**
	    * Tell the camera which sprite to follow.
	    *
	    * You can set the follow type and a linear interpolation value.
	    * Use low lerp values (such as 0.1) to automatically smooth the camera motion.
	    *
	    * If you find you're getting a slight "jitter" effect when following a Sprite it's probably to do with sub-pixel rendering of the Sprite position.
	    * This can be disabled by setting `game.renderer.renderSession.roundPixels = true` to force full pixel rendering.
	    *
	    * @method Phaser.Camera#follow
	    * @param {Phaser.Sprite|Phaser.Image|Phaser.Text} target - The object you want the camera to track. Set to null to not follow anything.
	    * @param {number} [style] - Leverage one of the existing "deadzone" presets. If you use a custom deadzone, ignore this parameter and manually specify the deadzone after calling follow().
	    * @param {float} [lerpX=1] - A value between 0 and 1. This value specifies the amount of linear interpolation to use when horizontally tracking the target. The closer the value to 1, the faster the camera will track.
	    * @param {float} [lerpY=1] - A value between 0 and 1. This value specifies the amount of linear interpolation to use when vertically tracking the target. The closer the value to 1, the faster the camera will track.
	    */follow:function follow(target,style,lerpX,lerpY){if(style===undefined){style=Phaser.Camera.FOLLOW_LOCKON;}if(lerpX===undefined){lerpX=1;}if(lerpY===undefined){lerpY=1;}this.target=target;this.lerp.set(lerpX,lerpY);var helper;switch(style){case Phaser.Camera.FOLLOW_PLATFORMER:var w=this.width/8;var h=this.height/3;this.deadzone=new Phaser.Rectangle((this.width-w)/2,(this.height-h)/2-h*0.25,w,h);break;case Phaser.Camera.FOLLOW_TOPDOWN:helper=Math.max(this.width,this.height)/4;this.deadzone=new Phaser.Rectangle((this.width-helper)/2,(this.height-helper)/2,helper,helper);break;case Phaser.Camera.FOLLOW_TOPDOWN_TIGHT:helper=Math.max(this.width,this.height)/8;this.deadzone=new Phaser.Rectangle((this.width-helper)/2,(this.height-helper)/2,helper,helper);break;case Phaser.Camera.FOLLOW_LOCKON:this.deadzone=null;break;default:this.deadzone=null;break;}},/**
	    * Sets the Camera follow target to null, stopping it from following an object if it's doing so.
	    *
	    * @method Phaser.Camera#unfollow
	    */unfollow:function unfollow(){this.target=null;},/**
	    * Move the camera focus on a display object instantly.
	    * @method Phaser.Camera#focusOn
	    * @param {any} displayObject - The display object to focus the camera on. Must have visible x/y properties.
	    */focusOn:function focusOn(displayObject){this.setPosition(Math.round(displayObject.x-this.view.halfWidth),Math.round(displayObject.y-this.view.halfHeight));},/**
	    * Move the camera focus on a location instantly.
	    * @method Phaser.Camera#focusOnXY
	    * @param {number} x - X position.
	    * @param {number} y - Y position.
	    */focusOnXY:function focusOnXY(x,y){this.setPosition(Math.round(x-this.view.halfWidth),Math.round(y-this.view.halfHeight));},/**
	    * This creates a camera shake effect. It works by applying a random amount of additional
	    * spacing on the x and y axis each frame. You can control the intensity and duration
	    * of the effect, and if it should effect both axis or just one.
	    *
	    * When the shake effect ends the signal Camera.onShakeComplete is dispatched.
	    *
	    * @method Phaser.Camera#shake
	    * @param {float} [intensity=0.05] - The intensity of the camera shake. Given as a percentage of the camera size representing the maximum distance that the camera can move while shaking.
	    * @param {number} [duration=500] - The duration of the shake effect in milliseconds.
	    * @param {boolean} [force=true] - If a camera shake effect is already running and force is true it will replace the previous effect, resetting the duration.
	    * @param {number} [direction=Phaser.Camera.SHAKE_BOTH] - The directions in which the camera can shake. Either Phaser.Camera.SHAKE_BOTH, Phaser.Camera.SHAKE_HORIZONTAL or Phaser.Camera.SHAKE_VERTICAL.
	    * @param {boolean} [shakeBounds=true] - Is the effect allowed to shake the camera beyond its bounds (if set?).
	    * @return {boolean} True if the shake effect was started, otherwise false.
	    */shake:function shake(intensity,duration,force,direction,shakeBounds){if(intensity===undefined){intensity=0.05;}if(duration===undefined){duration=500;}if(force===undefined){force=true;}if(direction===undefined){direction=Phaser.Camera.SHAKE_BOTH;}if(shakeBounds===undefined){shakeBounds=true;}if(!force&&this._shake.duration>0){//  Can't reset an already running shake
	return false;}this._shake.intensity=intensity;this._shake.duration=duration;this._shake.shakeBounds=shakeBounds;this._shake.x=0;this._shake.y=0;this._shake.horizontal=direction===Phaser.Camera.SHAKE_BOTH||direction===Phaser.Camera.SHAKE_HORIZONTAL;this._shake.vertical=direction===Phaser.Camera.SHAKE_BOTH||direction===Phaser.Camera.SHAKE_VERTICAL;return true;},/**
	    * This creates a camera flash effect. It works by filling the game with the solid fill
	    * color specified, and then fading it away to alpha 0 over the duration given.
	    *
	    * You can use this for things such as hit feedback effects.
	    *
	    * When the effect ends the signal Camera.onFlashComplete is dispatched.
	    *
	    * @method Phaser.Camera#flash
	    * @param {numer} [color=0xffffff] - The color of the flash effect. I.e. 0xffffff for white, 0xff0000 for red, etc.
	    * @param {number} [duration=500] - The duration of the flash effect in milliseconds.
	    * @param {boolean} [force=false] - If a camera flash or fade effect is already running and force is true it will replace the previous effect, resetting the duration.
	    * @return {boolean} True if the effect was started, otherwise false.
	    */flash:function flash(color,duration,force){if(color===undefined){color=0xffffff;}if(duration===undefined){duration=500;}if(force===undefined){force=false;}if(!this.fx||!force&&this._fxDuration>0){return false;}this.fx.clear();this.fx.beginFill(color);this.fx.drawRect(0,0,this.width,this.height);this.fx.endFill();this.fx.alpha=1;this._fxDuration=duration;this._fxType=0;return true;},/**
	    * This creates a camera fade effect. It works by filling the game with the
	    * color specified, over the duration given, ending with a solid fill.
	    *
	    * You can use this for things such as transitioning to a new scene.
	    *
	    * The game will be left 'filled' at the end of this effect, likely obscuring
	    * everything. In order to reset it you can call `Camera.resetFX` and it will clear the
	    * fade. Or you can call `Camera.flash` with the same color as the fade, and it will
	    * reverse the process, bringing the game back into view again.
	    *
	    * When the effect ends the signal Camera.onFadeComplete is dispatched.
	    *
	    * @method Phaser.Camera#fade
	    * @param {numer} [color=0x000000] - The color the game will fade to. I.e. 0x000000 for black, 0xff0000 for red, etc.
	    * @param {number} [duration=500] - The duration of the fade in milliseconds.
	    * @param {boolean} [force=false] - If a camera flash or fade effect is already running and force is true it will replace the previous effect, resetting the duration.
	    * @return {boolean} True if the effect was started, otherwise false.
	    */fade:function fade(color,duration,force){if(color===undefined){color=0x000000;}if(duration===undefined){duration=500;}if(force===undefined){force=false;}if(!this.fx||!force&&this._fxDuration>0){return false;}this.fx.clear();this.fx.beginFill(color);this.fx.drawRect(0,0,this.width,this.height);this.fx.endFill();this.fx.alpha=0;this._fxDuration=duration;this._fxType=1;return true;},/**
	    * The camera update loop. This is called automatically by the core game loop.
	    *
	    * @method Phaser.Camera#update
	    * @protected
	    */update:function update(){if(this._fxDuration>0){this.updateFX();}if(this._shake.duration>0){this.updateShake();}if(this.bounds){this.checkBounds();}if(this.roundPx){this.view.floor();this._shake.x=Math.floor(this._shake.x);this._shake.y=Math.floor(this._shake.y);}this.displayObject.position.x=-this.view.x;this.displayObject.position.y=-this.view.y;},/**
	    * Update the camera flash and fade effects.
	    *
	    * @method Phaser.Camera#updateFX
	    * @private
	    */updateFX:function updateFX(){if(this._fxType===0){//  flash
	this.fx.alpha-=this.game.time.elapsedMS/this._fxDuration;if(this.fx.alpha<=0){this._fxDuration=0;this.fx.alpha=0;this.onFlashComplete.dispatch();}}else{//  fade
	this.fx.alpha+=this.game.time.elapsedMS/this._fxDuration;if(this.fx.alpha>=1){this._fxDuration=0;this.fx.alpha=1;this.onFadeComplete.dispatch();}}},/**
	    * Update the camera shake effect.
	    *
	    * @method Phaser.Camera#updateShake
	    * @private
	    */updateShake:function updateShake(){this._shake.duration-=this.game.time.elapsedMS;if(this._shake.duration<=0){this.onShakeComplete.dispatch();this._shake.x=0;this._shake.y=0;}else{if(this._shake.horizontal){this._shake.x=this.game.rnd.frac()*this._shake.intensity*this.view.width*2-this._shake.intensity*this.view.width;}if(this._shake.vertical){this._shake.y=this.game.rnd.frac()*this._shake.intensity*this.view.height*2-this._shake.intensity*this.view.height;}}},/**
	    * Internal method that handles tracking a sprite.
	    *
	    * @method Phaser.Camera#updateTarget
	    * @private
	    */updateTarget:function updateTarget(){this._targetPosition.x=this.view.x+this.target.worldPosition.x;this._targetPosition.y=this.view.y+this.target.worldPosition.y;if(this.deadzone){this._edge=this._targetPosition.x-this.view.x;if(this._edge<this.deadzone.left){this.view.x=this.game.math.linear(this.view.x,this._targetPosition.x-this.deadzone.left,this.lerp.x);}else if(this._edge>this.deadzone.right){this.view.x=this.game.math.linear(this.view.x,this._targetPosition.x-this.deadzone.right,this.lerp.x);}this._edge=this._targetPosition.y-this.view.y;if(this._edge<this.deadzone.top){this.view.y=this.game.math.linear(this.view.y,this._targetPosition.y-this.deadzone.top,this.lerp.y);}else if(this._edge>this.deadzone.bottom){this.view.y=this.game.math.linear(this.view.y,this._targetPosition.y-this.deadzone.bottom,this.lerp.y);}}else{this.view.x=this.game.math.linear(this.view.x,this._targetPosition.x-this.view.halfWidth,this.lerp.x);this.view.y=this.game.math.linear(this.view.y,this._targetPosition.y-this.view.halfHeight,this.lerp.y);}if(this.bounds){this.checkBounds();}if(this.roundPx){this.view.floor();}this.displayObject.position.x=-this.view.x;this.displayObject.position.y=-this.view.y;},/**
	    * Update the Camera bounds to match the game world.
	    *
	    * @method Phaser.Camera#setBoundsToWorld
	    */setBoundsToWorld:function setBoundsToWorld(){if(this.bounds){this.bounds.copyFrom(this.game.world.bounds);}},/**
	    * Method called to ensure the camera doesn't venture outside of the game world.
	    * Called automatically by Camera.update.
	    *
	    * @method Phaser.Camera#checkBounds
	    * @protected
	    */checkBounds:function checkBounds(){this.atLimit.x=false;this.atLimit.y=false;var vx=this.view.x+this._shake.x;var vw=this.view.right+this._shake.x;var vy=this.view.y+this._shake.y;var vh=this.view.bottom+this._shake.y;//  Make sure we didn't go outside the cameras bounds
	if(vx<=this.bounds.x*this.scale.x){this.atLimit.x=true;this.view.x=this.bounds.x*this.scale.x;if(!this._shake.shakeBounds){//  The camera is up against the bounds, so reset the shake
	this._shake.x=0;}}if(vw>=this.bounds.right*this.scale.x){this.atLimit.x=true;this.view.x=this.bounds.right*this.scale.x-this.width;if(!this._shake.shakeBounds){//  The camera is up against the bounds, so reset the shake
	this._shake.x=0;}}if(vy<=this.bounds.top*this.scale.y){this.atLimit.y=true;this.view.y=this.bounds.top*this.scale.y;if(!this._shake.shakeBounds){//  The camera is up against the bounds, so reset the shake
	this._shake.y=0;}}if(vh>=this.bounds.bottom*this.scale.y){this.atLimit.y=true;this.view.y=this.bounds.bottom*this.scale.y-this.height;if(!this._shake.shakeBounds){//  The camera is up against the bounds, so reset the shake
	this._shake.y=0;}}},/**
	    * A helper function to set both the X and Y properties of the camera at once
	    * without having to use game.camera.x and game.camera.y.
	    *
	    * @method Phaser.Camera#setPosition
	    * @param {number} x - X position.
	    * @param {number} y - Y position.
	    */setPosition:function setPosition(x,y){this.view.x=x;this.view.y=y;if(this.bounds){this.checkBounds();}},/**
	    * Sets the size of the view rectangle given the width and height in parameters.
	    *
	    * @method Phaser.Camera#setSize
	    * @param {number} width - The desired width.
	    * @param {number} height - The desired height.
	    */setSize:function setSize(width,height){this.view.width=width;this.view.height=height;},/**
	    * Resets the camera back to 0,0 and un-follows any object it may have been tracking.
	    * Also immediately resets any camera effects that may have been running such as
	    * shake, flash or fade.
	    *
	    * @method Phaser.Camera#reset
	    */reset:function reset(){this.target=null;this.view.x=0;this.view.y=0;this._shake.duration=0;this.resetFX();},/**
	    * Resets any active FX, such as a fade or flash and immediately clears it.
	    * Useful to calling after a fade in order to remove the fade from the Stage.
	    *
	    * @method Phaser.Camera#resetFX
	    */resetFX:function resetFX(){this.fx.clear();this.fx.alpha=0;this._fxDuration=0;}};Phaser.Camera.prototype.constructor=Phaser.Camera;/**
	* The Cameras x coordinate. This value is automatically clamped if it falls outside of the World bounds.
	* @name Phaser.Camera#x
	* @property {number} x - Gets or sets the cameras x position.
	*/Object.defineProperty(Phaser.Camera.prototype,"x",{get:function get(){return this.view.x;},set:function set(value){this.view.x=value;if(this.bounds){this.checkBounds();}}});/**
	* The Cameras y coordinate. This value is automatically clamped if it falls outside of the World bounds.
	* @name Phaser.Camera#y
	* @property {number} y - Gets or sets the cameras y position.
	*/Object.defineProperty(Phaser.Camera.prototype,"y",{get:function get(){return this.view.y;},set:function set(value){this.view.y=value;if(this.bounds){this.checkBounds();}}});/**
	* The Cameras position. This value is automatically clamped if it falls outside of the World bounds.
	* @name Phaser.Camera#position
	* @property {Phaser.Point} position - Gets or sets the cameras xy position using Phaser.Point object.
	*/Object.defineProperty(Phaser.Camera.prototype,"position",{get:function get(){this._position.set(this.view.x,this.view.y);return this._position;},set:function set(value){if(typeof value.x!=="undefined"){this.view.x=value.x;}if(typeof value.y!=="undefined"){this.view.y=value.y;}if(this.bounds){this.checkBounds();}}});/**
	* The Cameras width. By default this is the same as the Game size and should not be adjusted for now.
	* @name Phaser.Camera#width
	* @property {number} width - Gets or sets the cameras width.
	*/Object.defineProperty(Phaser.Camera.prototype,"width",{get:function get(){return this.view.width;},set:function set(value){this.view.width=value;}});/**
	* The Cameras height. By default this is the same as the Game size and should not be adjusted for now.
	* @name Phaser.Camera#height
	* @property {number} height - Gets or sets the cameras height.
	*/Object.defineProperty(Phaser.Camera.prototype,"height",{get:function get(){return this.view.height;},set:function set(value){this.view.height=value;}});/**
	* The Cameras shake intensity.
	* @name Phaser.Camera#shakeIntensity
	* @property {number} shakeIntensity - Gets or sets the cameras shake intensity.
	*/Object.defineProperty(Phaser.Camera.prototype,"shakeIntensity",{get:function get(){return this._shake.intensity;},set:function set(value){this._shake.intensity=value;}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* This is a base State class which can be extended if you are creating your own game.
	* It provides quick access to common functions such as the camera, cache, input, match, sound and more.
	*
	* @class Phaser.State
	* @constructor
	*/Phaser.State=function(){/**
	    * @property {Phaser.Game} game - This is a reference to the currently running Game.
	    */this.game=null;/**
	    * @property {string} key - The string based identifier given to the State when added into the State Manager.
	    */this.key='';/**
	    * @property {Phaser.GameObjectFactory} add - A reference to the GameObjectFactory which can be used to add new objects to the World.
	    */this.add=null;/**
	    * @property {Phaser.GameObjectCreator} make - A reference to the GameObjectCreator which can be used to make new objects.
	    */this.make=null;/**
	    * @property {Phaser.Camera} camera - A handy reference to World.camera.
	    */this.camera=null;/**
	    * @property {Phaser.Cache} cache - A reference to the game cache which contains any loaded or generated assets, such as images, sound and more.
	    */this.cache=null;/**
	    * @property {Phaser.Input} input - A reference to the Input Manager.
	    */this.input=null;/**
	    * @property {Phaser.Loader} load - A reference to the Loader, which you mostly use in the preload method of your state to load external assets.
	    */this.load=null;/**
	    * @property {Phaser.Math} math - A reference to Math class with lots of helpful functions.
	    */this.math=null;/**
	    * @property {Phaser.SoundManager} sound - A reference to the Sound Manager which can create, play and stop sounds, as well as adjust global volume.
	    */this.sound=null;/**
	    * @property {Phaser.ScaleManager} scale - A reference to the Scale Manager which controls the way the game scales on different displays.
	    */this.scale=null;/**
	    * @property {Phaser.Stage} stage - A reference to the Stage.
	    */this.stage=null;/**
	    * @property {Phaser.StateManager} stage - A reference to the State Manager, which controls state changes.
	    */this.state=null;/**
	    * @property {Phaser.Time} time - A reference to the game clock and timed events system.
	    */this.time=null;/**
	    * @property {Phaser.TweenManager} tweens - A reference to the tween manager.
	    */this.tweens=null;/**
	    * @property {Phaser.World} world - A reference to the game world. All objects live in the Game World and its size is not bound by the display resolution.
	    */this.world=null;/**
	    * @property {Phaser.Particles} particles - The Particle Manager. It is called during the core gameloop and updates any Particle Emitters it has created.
	    */this.particles=null;/**
	    * @property {Phaser.Physics} physics - A reference to the physics manager which looks after the different physics systems available within Phaser.
	    */this.physics=null;/**
	    * @property {Phaser.RandomDataGenerator} rnd - A reference to the seeded and repeatable random data generator.
	    */this.rnd=null;};Phaser.State.prototype={/**
	    * init is the very first function called when your State starts up. It's called before preload, create or anything else.
	    * If you need to route the game away to another State you could do so here, or if you need to prepare a set of variables
	    * or objects before the preloading starts.
	    *
	    * @method Phaser.State#init
	    */init:function init(){},/**
	    * preload is called first. Normally you'd use this to load your game assets (or those needed for the current State)
	    * You shouldn't create any objects in this method that require assets that you're also loading in this method, as
	    * they won't yet be available.
	    *
	    * @method Phaser.State#preload
	    */preload:function preload(){},/**
	    * loadUpdate is called during the Loader process. This only happens if you've set one or more assets to load in the preload method.
	    *
	    * @method Phaser.State#loadUpdate
	    */loadUpdate:function loadUpdate(){},/**
	    * loadRender is called during the Loader process. This only happens if you've set one or more assets to load in the preload method.
	    * The difference between loadRender and render is that any objects you render in this method you must be sure their assets exist.
	    *
	    * @method Phaser.State#loadRender
	    */loadRender:function loadRender(){},/**
	    * create is called once preload has completed, this includes the loading of any assets from the Loader.
	    * If you don't have a preload method then create is the first method called in your State.
	    *
	    * @method Phaser.State#create
	    */create:function create(){},/**
	    * The update method is left empty for your own use.
	    * It is called during the core game loop AFTER debug, physics, plugins and the Stage have had their preUpdate methods called.
	    * It is called BEFORE Stage, Tweens, Sounds, Input, Physics, Particles and Plugins have had their postUpdate methods called.
	    *
	    * @method Phaser.State#update
	    */update:function update(){},/**
	    * The preRender method is called after all Game Objects have been updated, but before any rendering takes place.
	    *
	    * @method Phaser.State#preRender
	    */preRender:function preRender(){},/**
	    * Nearly all display objects in Phaser render automatically, you don't need to tell them to render.
	    * However the render method is called AFTER the game renderer and plugins have rendered, so you're able to do any
	    * final post-processing style effects here. Note that this happens before plugins postRender takes place.
	    *
	    * @method Phaser.State#render
	    */render:function render(){},/**
	    * If your game is set to Scalemode RESIZE then each time the browser resizes it will call this function, passing in the new width and height.
	    *
	    * @method Phaser.State#resize
	    */resize:function resize(){},/**
	    * This method will be called if the core game loop is paused.
	    *
	    * @method Phaser.State#paused
	    */paused:function paused(){},/**
	    * This method will be called when the core game loop resumes from a paused state.
	    *
	    * @method Phaser.State#resumed
	    */resumed:function resumed(){},/**
	    * pauseUpdate is called while the game is paused instead of preUpdate, update and postUpdate.
	    *
	    * @method Phaser.State#pauseUpdate
	    */pauseUpdate:function pauseUpdate(){},/**
	    * This method will be called when the State is shutdown (i.e. you switch to another state from this one).
	    *
	    * @method Phaser.State#shutdown
	    */shutdown:function shutdown(){}};Phaser.State.prototype.constructor=Phaser.State;/* jshint newcap: false *//**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The State Manager is responsible for loading, setting up and switching game states.
	*
	* @class Phaser.StateManager
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {Phaser.State|Object} [pendingState=null] - A State object to seed the manager with.
	*/Phaser.StateManager=function(game,pendingState){/**
	    * @property {Phaser.Game} game - A reference to the currently running game.
	    */this.game=game;/**
	    * @property {object} states - The object containing Phaser.States.
	    */this.states={};/**
	    * @property {Phaser.State} _pendingState - The state to be switched to in the next frame.
	    * @private
	    */this._pendingState=null;if(typeof pendingState!=='undefined'&&pendingState!==null){this._pendingState=pendingState;}/**
	    * @property {boolean} _clearWorld - Clear the world when we switch state?
	    * @private
	    */this._clearWorld=false;/**
	    * @property {boolean} _clearCache - Clear the cache when we switch state?
	    * @private
	    */this._clearCache=false;/**
	    * @property {boolean} _created - Flag that sets if the State has been created or not.
	    * @private
	    */this._created=false;/**
	    * @property {any[]} _args - Temporary container when you pass vars from one State to another.
	    * @private
	    */this._args=[];/**
	    * @property {string} current - The current active State object.
	    * @default
	    */this.current='';/**
	    * onStateChange is a Phaser.Signal that is dispatched whenever the game changes state.
	    * 
	    * It is dispatched only when the new state is started, which isn't usually at the same time as StateManager.start
	    * is called because state swapping is done in sync with the game loop. It is dispatched *before* any of the new states
	    * methods (such as preload and create) are called, and *after* the previous states shutdown method has been run.
	    *
	    * The callback you specify is sent two parameters: the string based key of the new state, 
	    * and the second parameter is the string based key of the old / previous state.
	    * 
	    * @property {Phaser.Signal} onStateChange
	    */this.onStateChange=new Phaser.Signal();/**
	    * @property {function} onInitCallback - This is called when the state is set as the active state.
	    * @default
	    */this.onInitCallback=null;/**
	    * @property {function} onPreloadCallback - This is called when the state starts to load assets.
	    * @default
	    */this.onPreloadCallback=null;/**
	    * @property {function} onCreateCallback - This is called when the state preload has finished and creation begins.
	    * @default
	    */this.onCreateCallback=null;/**
	    * @property {function} onUpdateCallback - This is called when the state is updated, every game loop. It doesn't happen during preload (@see onLoadUpdateCallback).
	    * @default
	    */this.onUpdateCallback=null;/**
	    * @property {function} onRenderCallback - This is called post-render. It doesn't happen during preload (see onLoadRenderCallback).
	    * @default
	    */this.onRenderCallback=null;/**
	    * @property {function} onResizeCallback - This is called if ScaleManager.scalemode is RESIZE and a resize event occurs. It's passed the new width and height.
	    * @default
	    */this.onResizeCallback=null;/**
	    * @property {function} onPreRenderCallback - This is called before the state is rendered and before the stage is cleared but after all game objects have had their final properties adjusted.
	    * @default
	    */this.onPreRenderCallback=null;/**
	    * @property {function} onLoadUpdateCallback - This is called when the State is updated during the preload phase.
	    * @default
	    */this.onLoadUpdateCallback=null;/**
	    * @property {function} onLoadRenderCallback - This is called when the State is rendered during the preload phase.
	    * @default
	    */this.onLoadRenderCallback=null;/**
	    * @property {function} onPausedCallback - This is called when the game is paused.
	    * @default
	    */this.onPausedCallback=null;/**
	    * @property {function} onResumedCallback - This is called when the game is resumed from a paused state.
	    * @default
	    */this.onResumedCallback=null;/**
	    * @property {function} onPauseUpdateCallback - This is called every frame while the game is paused.
	    * @default
	    */this.onPauseUpdateCallback=null;/**
	    * @property {function} onShutDownCallback - This is called when the state is shut down (i.e. swapped to another state).
	    * @default
	    */this.onShutDownCallback=null;};Phaser.StateManager.prototype={/**
	    * The Boot handler is called by Phaser.Game when it first starts up.
	    * @method Phaser.StateManager#boot
	    * @private
	    */boot:function boot(){this.game.onPause.add(this.pause,this);this.game.onResume.add(this.resume,this);if(this._pendingState!==null&&typeof this._pendingState!=='string'){this.add('default',this._pendingState,true);}},/**
	    * Adds a new State into the StateManager. You must give each State a unique key by which you'll identify it.
	    * The State can be either a Phaser.State object (or an object that extends it), a plain JavaScript object or a function.
	    * If a function is given a new state object will be created by calling it.
	    *
	    * @method Phaser.StateManager#add
	    * @param {string} key - A unique key you use to reference this state, i.e. "MainMenu", "Level1".
	    * @param {Phaser.State|object|function} state  - The state you want to switch to.
	    * @param {boolean} [autoStart=false]  - If true the State will be started immediately after adding it.
	    */add:function add(key,state,autoStart){if(autoStart===undefined){autoStart=false;}var newState;if(state instanceof Phaser.State){newState=state;}else if((typeof state==='undefined'?'undefined':_typeof(state))==='object'){newState=state;newState.game=this.game;}else if(typeof state==='function'){newState=new state(this.game);}this.states[key]=newState;if(autoStart){if(this.game.isBooted){this.start(key);}else{this._pendingState=key;}}return newState;},/**
	    * Delete the given state.
	    * @method Phaser.StateManager#remove
	    * @param {string} key - A unique key you use to reference this state, i.e. "MainMenu", "Level1".
	    */remove:function remove(key){if(this.current===key){this.callbackContext=null;this.onInitCallback=null;this.onShutDownCallback=null;this.onPreloadCallback=null;this.onLoadRenderCallback=null;this.onLoadUpdateCallback=null;this.onCreateCallback=null;this.onUpdateCallback=null;this.onPreRenderCallback=null;this.onRenderCallback=null;this.onResizeCallback=null;this.onPausedCallback=null;this.onResumedCallback=null;this.onPauseUpdateCallback=null;}delete this.states[key];},/**
	    * Start the given State. If a State is already running then State.shutDown will be called (if it exists) before switching to the new State.
	    *
	    * @method Phaser.StateManager#start
	    * @param {string} key - The key of the state you want to start.
	    * @param {boolean} [clearWorld=true] - Clear everything in the world? This clears the World display list fully (but not the Stage, so if you've added your own objects to the Stage they will need managing directly)
	    * @param {boolean} [clearCache=false] - Clear the Game.Cache? This purges out all loaded assets. The default is false and you must have clearWorld=true if you want to clearCache as well.
	    * @param {...*} parameter - Additional parameters that will be passed to the State.init function (if it has one).
	    */start:function start(key,clearWorld,clearCache){if(clearWorld===undefined){clearWorld=true;}if(clearCache===undefined){clearCache=false;}if(this.checkState(key)){//  Place the state in the queue. It will be started the next time the game loop begins.
	this._pendingState=key;this._clearWorld=clearWorld;this._clearCache=clearCache;if(arguments.length>3){this._args=Array.prototype.splice.call(arguments,3);}}},/**
	    * Restarts the current State. State.shutDown will be called (if it exists) before the State is restarted.
	    *
	    * @method Phaser.StateManager#restart
	    * @param {boolean} [clearWorld=true] - Clear everything in the world? This clears the World display list fully (but not the Stage, so if you've added your own objects to the Stage they will need managing directly)
	    * @param {boolean} [clearCache=false] - Clear the Game.Cache? This purges out all loaded assets. The default is false and you must have clearWorld=true if you want to clearCache as well.
	    * @param {...*} parameter - Additional parameters that will be passed to the State.init function if it has one.
	    */restart:function restart(clearWorld,clearCache){if(clearWorld===undefined){clearWorld=true;}if(clearCache===undefined){clearCache=false;}//  Place the state in the queue. It will be started the next time the game loop starts.
	this._pendingState=this.current;this._clearWorld=clearWorld;this._clearCache=clearCache;if(arguments.length>2){this._args=Array.prototype.slice.call(arguments,2);}},/**
	    * Used by onInit and onShutdown when those functions don't exist on the state
	    * @method Phaser.StateManager#dummy
	    * @private
	    */dummy:function dummy(){},/**
	    * preUpdate is called right at the start of the game loop. It is responsible for changing to a new state that was requested previously.
	    *
	    * @method Phaser.StateManager#preUpdate
	    */preUpdate:function preUpdate(){if(this._pendingState&&this.game.isBooted){var previousStateKey=this.current;//  Already got a state running?
	this.clearCurrentState();this.setCurrentState(this._pendingState);this.onStateChange.dispatch(this.current,previousStateKey);if(this.current!==this._pendingState){return;}else{this._pendingState=null;}//  If StateManager.start has been called from the init of a State that ALSO has a preload, then
	//  onPreloadCallback will be set, but must be ignored
	if(this.onPreloadCallback){this.game.load.reset(true);this.onPreloadCallback.call(this.callbackContext,this.game);//  Is the loader empty?
	if(this.game.load.totalQueuedFiles()===0&&this.game.load.totalQueuedPacks()===0){this.loadComplete();}else{//  Start the loader going as we have something in the queue
	this.game.load.start();}}else{//  No init? Then there was nothing to load either
	this.loadComplete();}}},/**
	    * This method clears the current State, calling its shutdown callback. The process also removes any active tweens,
	    * resets the camera, resets input, clears physics, removes timers and if set clears the world and cache too.
	    *
	    * @method Phaser.StateManager#clearCurrentState
	    */clearCurrentState:function clearCurrentState(){if(this.current){if(this.onShutDownCallback){this.onShutDownCallback.call(this.callbackContext,this.game);}this.game.tweens.removeAll();this.game.camera.reset();this.game.input.reset(true);this.game.physics.clear();this.game.time.removeAll();this.game.scale.reset(this._clearWorld);if(this.game.debug){this.game.debug.reset();}if(this._clearWorld){this.game.world.shutdown();if(this._clearCache){this.game.cache.destroy();}}}},/**
	    * Checks if a given phaser state is valid. A State is considered valid if it has at least one of the core functions: preload, create, update or render.
	    *
	    * @method Phaser.StateManager#checkState
	    * @param {string} key - The key of the state you want to check.
	    * @return {boolean} true if the State has the required functions, otherwise false.
	    */checkState:function checkState(key){if(this.states[key]){if(this.states[key]['preload']||this.states[key]['create']||this.states[key]['update']||this.states[key]['render']){return true;}else{console.warn("Invalid Phaser State object given. Must contain at least a one of the required functions: preload, create, update or render");return false;}}else{console.warn("Phaser.StateManager - No state found with the key: "+key);return false;}},/**
	    * Links game properties to the State given by the key.
	    *
	    * @method Phaser.StateManager#link
	    * @param {string} key - State key.
	    * @protected
	    */link:function link(key){this.states[key].game=this.game;this.states[key].add=this.game.add;this.states[key].make=this.game.make;this.states[key].camera=this.game.camera;this.states[key].cache=this.game.cache;this.states[key].input=this.game.input;this.states[key].load=this.game.load;this.states[key].math=this.game.math;this.states[key].sound=this.game.sound;this.states[key].scale=this.game.scale;this.states[key].state=this;this.states[key].stage=this.game.stage;this.states[key].time=this.game.time;this.states[key].tweens=this.game.tweens;this.states[key].world=this.game.world;this.states[key].particles=this.game.particles;this.states[key].rnd=this.game.rnd;this.states[key].physics=this.game.physics;this.states[key].key=key;},/**
	    * Nulls all State level Phaser properties, including a reference to Game.
	    *
	    * @method Phaser.StateManager#unlink
	    * @param {string} key - State key.
	    * @protected
	    */unlink:function unlink(key){if(this.states[key]){this.states[key].game=null;this.states[key].add=null;this.states[key].make=null;this.states[key].camera=null;this.states[key].cache=null;this.states[key].input=null;this.states[key].load=null;this.states[key].math=null;this.states[key].sound=null;this.states[key].scale=null;this.states[key].state=null;this.states[key].stage=null;this.states[key].time=null;this.states[key].tweens=null;this.states[key].world=null;this.states[key].particles=null;this.states[key].rnd=null;this.states[key].physics=null;}},/**
	    * Sets the current State. Should not be called directly (use StateManager.start)
	    *
	    * @method Phaser.StateManager#setCurrentState
	    * @param {string} key - State key.
	    * @private
	    */setCurrentState:function setCurrentState(key){this.callbackContext=this.states[key];this.link(key);//  Used when the state is set as being the current active state
	this.onInitCallback=this.states[key]['init']||this.dummy;this.onPreloadCallback=this.states[key]['preload']||null;this.onLoadRenderCallback=this.states[key]['loadRender']||null;this.onLoadUpdateCallback=this.states[key]['loadUpdate']||null;this.onCreateCallback=this.states[key]['create']||null;this.onUpdateCallback=this.states[key]['update']||null;this.onPreRenderCallback=this.states[key]['preRender']||null;this.onRenderCallback=this.states[key]['render']||null;this.onResizeCallback=this.states[key]['resize']||null;this.onPausedCallback=this.states[key]['paused']||null;this.onResumedCallback=this.states[key]['resumed']||null;this.onPauseUpdateCallback=this.states[key]['pauseUpdate']||null;//  Used when the state is no longer the current active state
	this.onShutDownCallback=this.states[key]['shutdown']||this.dummy;//  Reset the physics system, but not on the first state start
	if(this.current!==''){this.game.physics.reset();}this.current=key;this._created=false;//  At this point key and pendingState should equal each other
	this.onInitCallback.apply(this.callbackContext,this._args);//  If they no longer do then the init callback hit StateManager.start
	if(key===this._pendingState){this._args=[];}this.game._kickstart=true;},/**
	     * Gets the current State.
	     *
	     * @method Phaser.StateManager#getCurrentState
	     * @return {Phaser.State}
	     * @public
	     */getCurrentState:function getCurrentState(){return this.states[this.current];},/**
	    * @method Phaser.StateManager#loadComplete
	    * @protected
	    */loadComplete:function loadComplete(){//  Make sure to do load-update one last time before state is set to _created
	if(this._created===false&&this.onLoadUpdateCallback){this.onLoadUpdateCallback.call(this.callbackContext,this.game);}if(this._created===false&&this.onCreateCallback){this._created=true;this.onCreateCallback.call(this.callbackContext,this.game);}else{this._created=true;}},/**
	    * @method Phaser.StateManager#pause
	    * @protected
	    */pause:function pause(){if(this._created&&this.onPausedCallback){this.onPausedCallback.call(this.callbackContext,this.game);}},/**
	    * @method Phaser.StateManager#resume
	    * @protected
	    */resume:function resume(){if(this._created&&this.onResumedCallback){this.onResumedCallback.call(this.callbackContext,this.game);}},/**
	    * @method Phaser.StateManager#update
	    * @protected
	    */update:function update(){if(this._created){if(this.onUpdateCallback){this.onUpdateCallback.call(this.callbackContext,this.game);}}else{if(this.onLoadUpdateCallback){this.onLoadUpdateCallback.call(this.callbackContext,this.game);}}},/**
	    * @method Phaser.StateManager#pauseUpdate
	    * @protected
	    */pauseUpdate:function pauseUpdate(){if(this._created){if(this.onPauseUpdateCallback){this.onPauseUpdateCallback.call(this.callbackContext,this.game);}}else{if(this.onLoadUpdateCallback){this.onLoadUpdateCallback.call(this.callbackContext,this.game);}}},/**
	    * @method Phaser.StateManager#preRender
	    * @protected
	    * @param {number} elapsedTime - The time elapsed since the last update.
	    */preRender:function preRender(elapsedTime){if(this._created&&this.onPreRenderCallback){this.onPreRenderCallback.call(this.callbackContext,this.game,elapsedTime);}},/**
	    * @method Phaser.StateManager#resize
	    * @protected
	    */resize:function resize(width,height){if(this.onResizeCallback){this.onResizeCallback.call(this.callbackContext,width,height);}},/**
	    * @method Phaser.StateManager#render
	    * @protected
	    */render:function render(){if(this._created){if(this.onRenderCallback){if(this.game.renderType===Phaser.CANVAS){this.game.context.save();this.game.context.setTransform(1,0,0,1,0,0);this.onRenderCallback.call(this.callbackContext,this.game);this.game.context.restore();}else{this.onRenderCallback.call(this.callbackContext,this.game);}}}else{if(this.onLoadRenderCallback){this.onLoadRenderCallback.call(this.callbackContext,this.game);}}},/**
	    * Removes all StateManager callback references to the State object, nulls the game reference and clears the States object.
	    * You don't recover from this without rebuilding the Phaser instance again.
	    * @method Phaser.StateManager#destroy
	    */destroy:function destroy(){this._clearWorld=true;this._clearCache=true;this.clearCurrentState();this.callbackContext=null;this.onInitCallback=null;this.onShutDownCallback=null;this.onPreloadCallback=null;this.onLoadRenderCallback=null;this.onLoadUpdateCallback=null;this.onCreateCallback=null;this.onUpdateCallback=null;this.onRenderCallback=null;this.onPausedCallback=null;this.onResumedCallback=null;this.onPauseUpdateCallback=null;this.game=null;this.states={};this._pendingState=null;this.current='';}};Phaser.StateManager.prototype.constructor=Phaser.StateManager;/**
	* @name Phaser.StateManager#created
	* @property {boolean} created - True if the current state has had its `create` method run (if it has one, if not this is true by default).
	* @readOnly
	*/Object.defineProperty(Phaser.StateManager.prototype,"created",{get:function get(){return this._created;}});/**
	* "It's like nailing jelly to a kitten" - Gary Penn
	*//**
	* @author       Miller Medeiros http://millermedeiros.github.com/js-signals/
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Signals are what Phaser uses to handle events and event dispatching.
	* You can listen for a Signal by binding a callback / function to it.
	* This is done by using either `Signal.add` or `Signal.addOnce`.
	*
	* For example you can listen for a touch or click event from the Input Manager 
	* by using its `onDown` Signal:
	*
	* `game.input.onDown.add(function() { ... });`
	*
	* Rather than inline your function, you can pass a reference:
	*
	* `game.input.onDown.add(clicked, this);`
	* `function clicked () { ... }`
	*
	* In this case the second argument (`this`) is the context in which your function should be called.
	*
	* Now every time the InputManager dispatches the `onDown` signal (or event), your function
	* will be called.
	*
	* Very often a Signal will send arguments to your function.
	* This is specific to the Signal itself.
	* If you're unsure then check the documentation, or failing that simply do:
	*
	* `Signal.add(function() { console.log(arguments); })`
	*
	* and it will log all of the arguments your function received from the Signal.
	*
	* Sprites have lots of default signals you can listen to in their Events class, such as:
	*
	* `sprite.events.onKilled`
	* 
	* Which is called automatically whenever the Sprite is killed.
	* There are lots of other events, see the Events component for a list.
	*
	* As well as listening to pre-defined Signals you can also create your own:
	*
	* `var mySignal = new Phaser.Signal();`
	*
	* This creates a new Signal. You can bind a callback to it:
	*
	* `mySignal.add(myCallback, this);`
	*
	* and then finally when ready you can dispatch the Signal:
	*
	* `mySignal.dispatch(your arguments);`
	*
	* And your callback will be invoked. See the dispatch method for more details.
	*
	* @class Phaser.Signal
	* @constructor
	*/Phaser.Signal=function(){};Phaser.Signal.prototype={/**
	    * @property {?Array.<Phaser.SignalBinding>} _bindings - Internal variable.
	    * @private
	    */_bindings:null,/**
	    * @property {any} _prevParams - Internal variable.
	    * @private
	    */_prevParams:null,/**
	    * Memorize the previously dispatched event?
	    *
	    * If an event has been memorized it is automatically dispatched when a new listener is added with {@link #add} or {@link #addOnce}.
	    * Use {@link #forget} to clear any currently memorized event.
	    *
	    * @property {boolean} memorize
	    */memorize:false,/**
	    * @property {boolean} _shouldPropagate
	    * @private
	    */_shouldPropagate:true,/**
	    * Is the Signal active? Only active signals will broadcast dispatched events.
	    *
	    * Setting this property during a dispatch will only affect the next dispatch. To stop the propagation of a signal from a listener use {@link #halt}.
	    *
	    * @property {boolean} active
	    * @default
	    */active:true,/**
	    * @property {function} _boundDispatch - The bound dispatch function, if any.
	    * @private
	    */_boundDispatch:false,/**
	    * @method Phaser.Signal#validateListener
	    * @param {function} listener - Signal handler function.
	    * @param {string} fnName - Function name.
	    * @private
	    */validateListener:function validateListener(listener,fnName){if(typeof listener!=='function'){throw new Error('Phaser.Signal: listener is a required param of {fn}() and should be a Function.'.replace('{fn}',fnName));}},/**
	    * @method Phaser.Signal#_registerListener
	    * @private
	    * @param {function} listener - Signal handler function.
	    * @param {boolean} isOnce - Should the listener only be called once?
	    * @param {object} [listenerContext] - The context under which the listener is invoked.
	    * @param {number} [priority] - The priority level of the event listener. Listeners with higher priority will be executed before listeners with lower priority. Listeners with same priority level will be executed at the same order as they were added. (default = 0).
	    * @return {Phaser.SignalBinding} An Object representing the binding between the Signal and listener.
	    */_registerListener:function _registerListener(listener,isOnce,listenerContext,priority,args){var prevIndex=this._indexOfListener(listener,listenerContext);var binding;if(prevIndex!==-1){binding=this._bindings[prevIndex];if(binding.isOnce()!==isOnce){throw new Error('You cannot add'+(isOnce?'':'Once')+'() then add'+(!isOnce?'':'Once')+'() the same listener without removing the relationship first.');}}else{binding=new Phaser.SignalBinding(this,listener,isOnce,listenerContext,priority,args);this._addBinding(binding);}if(this.memorize&&this._prevParams){binding.execute(this._prevParams);}return binding;},/**
	    * @method Phaser.Signal#_addBinding
	    * @private
	    * @param {Phaser.SignalBinding} binding - An Object representing the binding between the Signal and listener.
	    */_addBinding:function _addBinding(binding){if(!this._bindings){this._bindings=[];}//  Simplified insertion sort
	var n=this._bindings.length;do{n--;}while(this._bindings[n]&&binding._priority<=this._bindings[n]._priority);this._bindings.splice(n+1,0,binding);},/**
	    * @method Phaser.Signal#_indexOfListener
	    * @private
	    * @param {function} listener - Signal handler function.
	    * @param {object} [context=null] - Signal handler function.
	    * @return {number} The index of the listener within the private bindings array.
	    */_indexOfListener:function _indexOfListener(listener,context){if(!this._bindings){return-1;}if(context===undefined){context=null;}var n=this._bindings.length;var cur;while(n--){cur=this._bindings[n];if(cur._listener===listener&&cur.context===context){return n;}}return-1;},/**
	    * Check if a specific listener is attached.
	    *
	    * @method Phaser.Signal#has
	    * @param {function} listener - Signal handler function.
	    * @param {object} [context] - Context on which listener will be executed (object that should represent the `this` variable inside listener function).
	    * @return {boolean} If Signal has the specified listener.
	    */has:function has(listener,context){return this._indexOfListener(listener,context)!==-1;},/**
	    * Add an event listener for this signal.
	    *
	    * An event listener is a callback with a related context and priority.
	    *
	    * You can optionally provide extra arguments which will be passed to the callback after any internal parameters.
	    *
	    * For example: `Phaser.Key.onDown` when dispatched will send the Phaser.Key object that caused the signal as the first parameter.
	    * Any arguments you've specified after `priority` will be sent as well:
	    *
	    * `fireButton.onDown.add(shoot, this, 0, 'lazer', 100);`
	    *
	    * When onDown dispatches it will call the `shoot` callback passing it: `Phaser.Key, 'lazer', 100`.
	    *
	    * Where the first parameter is the one that Key.onDown dispatches internally and 'lazer', 
	    * and the value 100 were the custom arguments given in the call to 'add'.
	    *
	    * @method Phaser.Signal#add
	    * @param {function} listener - The function to call when this Signal is dispatched.
	    * @param {object} [listenerContext] - The context under which the listener will be executed (i.e. the object that should represent the `this` variable).
	    * @param {number} [priority] - The priority level of the event listener. Listeners with higher priority will be executed before listeners with lower priority. Listeners with same priority level will be executed at the same order as they were added (default = 0)
	    * @param {...any} [args=(none)] - Additional arguments to pass to the callback (listener) function. They will be appended after any arguments usually dispatched.
	    * @return {Phaser.SignalBinding} An Object representing the binding between the Signal and listener.
	    */add:function add(listener,listenerContext,priority){this.validateListener(listener,'add');var args=[];if(arguments.length>3){for(var i=3;i<arguments.length;i++){args.push(arguments[i]);}}return this._registerListener(listener,false,listenerContext,priority,args);},/**
	    * Add a one-time listener - the listener is automatically removed after the first execution.
	    *
	    * If there is as {@link Phaser.Signal#memorize memorized} event then it will be dispatched and
	    * the listener will be removed immediately.
	    *
	    * @method Phaser.Signal#addOnce
	    * @param {function} listener - The function to call when this Signal is dispatched.
	    * @param {object} [listenerContext] - The context under which the listener will be executed (i.e. the object that should represent the `this` variable).
	    * @param {number} [priority] - The priority level of the event listener. Listeners with higher priority will be executed before listeners with lower priority. Listeners with same priority level will be executed at the same order as they were added (default = 0)
	    * @param {...any} [args=(none)] - Additional arguments to pass to the callback (listener) function. They will be appended after any arguments usually dispatched.
	    * @return {Phaser.SignalBinding} An Object representing the binding between the Signal and listener.
	    */addOnce:function addOnce(listener,listenerContext,priority){this.validateListener(listener,'addOnce');var args=[];if(arguments.length>3){for(var i=3;i<arguments.length;i++){args.push(arguments[i]);}}return this._registerListener(listener,true,listenerContext,priority,args);},/**
	    * Remove a single event listener.
	    *
	    * @method Phaser.Signal#remove
	    * @param {function} listener - Handler function that should be removed.
	    * @param {object} [context=null] - Execution context (since you can add the same handler multiple times if executing in a different context).
	    * @return {function} Listener handler function.
	    */remove:function remove(listener,context){this.validateListener(listener,'remove');var i=this._indexOfListener(listener,context);if(i!==-1){this._bindings[i]._destroy();//no reason to a Phaser.SignalBinding exist if it isn't attached to a signal
	this._bindings.splice(i,1);}return listener;},/**
	    * Remove all event listeners.
	    *
	    * @method Phaser.Signal#removeAll
	    * @param {object} [context=null] - If specified only listeners for the given context will be removed.
	    */removeAll:function removeAll(context){if(context===undefined){context=null;}if(!this._bindings){return;}var n=this._bindings.length;while(n--){if(context){if(this._bindings[n].context===context){this._bindings[n]._destroy();this._bindings.splice(n,1);}}else{this._bindings[n]._destroy();}}if(!context){this._bindings.length=0;}},/**
	    * Gets the total number of listeners attached to this Signal.
	    *
	    * @method Phaser.Signal#getNumListeners
	    * @return {integer} Number of listeners attached to the Signal.
	    */getNumListeners:function getNumListeners(){return this._bindings?this._bindings.length:0;},/**
	    * Stop propagation of the event, blocking the dispatch to next listener on the queue.
	    *
	    * This should be called only during event dispatch as calling it before/after dispatch won't affect another broadcast.
	    * See {@link #active} to enable/disable the signal entirely.
	    *
	    * @method Phaser.Signal#halt
	    */halt:function halt(){this._shouldPropagate=false;},/**
	    * Dispatch / broadcast the event to all listeners.
	    *
	    * To create an instance-bound dispatch for this Signal, use {@link #boundDispatch}.
	    *
	    * @method Phaser.Signal#dispatch
	    * @param {any} [params] - Parameters that should be passed to each handler.
	    */dispatch:function dispatch(){if(!this.active||!this._bindings){return;}var paramsArr=Array.prototype.slice.call(arguments);var n=this._bindings.length;var bindings;if(this.memorize){this._prevParams=paramsArr;}if(!n){//  Should come after memorize
	return;}bindings=this._bindings.slice();//clone array in case add/remove items during dispatch
	this._shouldPropagate=true;//in case `halt` was called before dispatch or during the previous dispatch.
	//execute all callbacks until end of the list or until a callback returns `false` or stops propagation
	//reverse loop since listeners with higher priority will be added at the end of the list
	do{n--;}while(bindings[n]&&this._shouldPropagate&&bindings[n].execute(paramsArr)!==false);},/**
	    * Forget the currently {@link Phaser.Signal#memorize memorized} event, if any.
	    *
	    * @method Phaser.Signal#forget
	    */forget:function forget(){if(this._prevParams){this._prevParams=null;}},/**
	    * Dispose the signal - no more events can be dispatched.
	    *
	    * This removes all event listeners and clears references to external objects.
	    * Calling methods on a disposed objects results in undefined behavior.
	    *
	    * @method Phaser.Signal#dispose
	    */dispose:function dispose(){this.removeAll();this._bindings=null;if(this._prevParams){this._prevParams=null;}},/**
	    * A string representation of the object.
	    *
	    * @method Phaser.Signal#toString
	    * @return {string} String representation of the object.
	    */toString:function toString(){return'[Phaser.Signal active:'+this.active+' numListeners:'+this.getNumListeners()+']';}};/**
	* Create a `dispatch` function that maintains a binding to the original Signal context.
	*
	* Use the resulting value if the dispatch function needs to be passed somewhere
	* or called independently of the Signal object.
	*
	* @memberof Phaser.Signal
	* @property {function} boundDispatch
	*/Object.defineProperty(Phaser.Signal.prototype,"boundDispatch",{get:function get(){var _this=this;return this._boundDispatch||(this._boundDispatch=function(){return _this.dispatch.apply(_this,arguments);});}});Phaser.Signal.prototype.constructor=Phaser.Signal;/**
	* @author       Miller Medeiros http://millermedeiros.github.com/js-signals/
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Object that represents a binding between a Signal and a listener function.
	* This is an internal constructor and shouldn't be created directly.
	* Inspired by Joa Ebert AS3 SignalBinding and Robert Penner's Slot classes.
	* 
	* @class Phaser.SignalBinding
	* @constructor
	* @param {Phaser.Signal} signal - Reference to Signal object that listener is currently bound to.
	* @param {function} listener - Handler function bound to the signal.
	* @param {boolean} isOnce - If binding should be executed just once.
	* @param {object} [listenerContext=null] - Context on which listener will be executed (object that should represent the `this` variable inside listener function).
	* @param {number} [priority] - The priority level of the event listener. (default = 0).
	* @param {...any} [args=(none)] - Additional arguments to pass to the callback (listener) function. They will be appended after any arguments usually dispatched.
	*/Phaser.SignalBinding=function(signal,listener,isOnce,listenerContext,priority,args){/**
	    * @property {Phaser.Game} _listener - Handler function bound to the signal.
	    * @private
	    */this._listener=listener;if(isOnce){this._isOnce=true;}if(listenerContext!=null)/* not null/undefined */{this.context=listenerContext;}/**
	    * @property {Phaser.Signal} _signal - Reference to Signal object that listener is currently bound to.
	    * @private
	    */this._signal=signal;if(priority){this._priority=priority;}if(args&&args.length){this._args=args;}};Phaser.SignalBinding.prototype={/**
	    * @property {?object} context - Context on which listener will be executed (object that should represent the `this` variable inside listener function).
	    */context:null,/**
	    * @property {boolean} _isOnce - If binding should be executed just once.
	    * @private
	    */_isOnce:false,/**
	    * @property {number} _priority - Listener priority.
	    * @private
	    */_priority:0,/**
	    * @property {array} _args - Listener arguments.
	    * @private
	    */_args:null,/**
	    * @property {number} callCount - The number of times the handler function has been called.
	    */callCount:0,/**
	    * If binding is active and should be executed.
	    * @property {boolean} active
	    * @default
	    */active:true,/**
	    * Default parameters passed to listener during `Signal.dispatch` and `SignalBinding.execute` (curried parameters).
	    * @property {array|null} params
	    * @default
	    */params:null,/**
	    * Call listener passing arbitrary parameters.
	    * If binding was added using `Signal.addOnce()` it will be automatically removed from signal dispatch queue, this method is used internally for the signal dispatch.
	    * @method Phaser.SignalBinding#execute
	    * @param {any[]} [paramsArr] - Array of parameters that should be passed to the listener.
	    * @return {any} Value returned by the listener.
	    */execute:function execute(paramsArr){var handlerReturn,params;if(this.active&&!!this._listener){params=this.params?this.params.concat(paramsArr):paramsArr;if(this._args){params=params.concat(this._args);}handlerReturn=this._listener.apply(this.context,params);this.callCount++;if(this._isOnce){this.detach();}}return handlerReturn;},/**
	    * Detach binding from signal.
	    * alias to: @see mySignal.remove(myBinding.getListener());
	    * @method Phaser.SignalBinding#detach
	    * @return {function|null} Handler function bound to the signal or `null` if binding was previously detached.
	    */detach:function detach(){return this.isBound()?this._signal.remove(this._listener,this.context):null;},/**
	    * @method Phaser.SignalBinding#isBound
	    * @return {boolean} True if binding is still bound to the signal and has a listener.
	    */isBound:function isBound(){return!!this._signal&&!!this._listener;},/**
	    * @method Phaser.SignalBinding#isOnce
	    * @return {boolean} If SignalBinding will only be executed once.
	    */isOnce:function isOnce(){return this._isOnce;},/**
	    * @method Phaser.SignalBinding#getListener
	    * @return {function} Handler function bound to the signal.
	    */getListener:function getListener(){return this._listener;},/**
	    * @method Phaser.SignalBinding#getSignal
	    * @return {Phaser.Signal} Signal that listener is currently bound to.
	    */getSignal:function getSignal(){return this._signal;},/**
	    * Delete instance properties
	    * @method Phaser.SignalBinding#_destroy
	    * @private
	    */_destroy:function _destroy(){delete this._signal;delete this._listener;delete this.context;},/**
	    * @method Phaser.SignalBinding#toString
	    * @return {string} String representation of the object.
	    */toString:function toString(){return'[Phaser.SignalBinding isOnce:'+this._isOnce+', isBound:'+this.isBound()+', active:'+this.active+']';}};Phaser.SignalBinding.prototype.constructor=Phaser.SignalBinding;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* This is a base Filter class to use for any Phaser filter development.
	*
	* The vast majority of filters (including all of those that ship with Phaser) use fragment shaders, and
	* therefore only work in WebGL and are not supported by Canvas at all.
	*
	* @class Phaser.Filter
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {object} uniforms - Uniform mappings object
	* @param {Array|string} fragmentSrc - The fragment shader code. Either an array, one element per line of code, or a string.
	*/Phaser.Filter=function(game,uniforms,fragmentSrc){/**
	    * @property {Phaser.Game} game - A reference to the currently running game.
	    */this.game=game;/**
	    * @property {number} type - The const type of this object, either Phaser.WEBGL_FILTER or Phaser.CANVAS_FILTER.
	    * @default
	    */this.type=Phaser.WEBGL_FILTER;/**
	    * An array of passes - some filters contain a few steps this array simply stores the steps in a linear fashion.
	    * For example the blur filter has two passes blurX and blurY.
	    * @property {array} passes - An array of filter objects.
	    * @private
	    */this.passes=[this];/**
	    * @property {array} shaders - Array an array of shaders.
	    * @private
	    */this.shaders=[];/**
	    * @property {boolean} dirty - Internal PIXI var.
	    * @default
	    */this.dirty=true;/**
	    * @property {number} padding - Internal PIXI var.
	    * @default
	    */this.padding=0;/**
	    * @property {Phaser.Point} prevPoint - The previous position of the pointer (we don't update the uniform if the same)
	    */this.prevPoint=new Phaser.Point();/*
	    * The supported types are: 1f, 1fv, 1i, 2f, 2fv, 2i, 2iv, 3f, 3fv, 3i, 3iv, 4f, 4fv, 4i, 4iv, mat2, mat3, mat4 and sampler2D.
	    */var d=new Date();/**
	    * @property {object} uniforms - Default uniform mappings. Compatible with ShaderToy and GLSLSandbox.
	    */this.uniforms={resolution:{type:'2f',value:{x:256,y:256}},time:{type:'1f',value:0},mouse:{type:'2f',value:{x:0.0,y:0.0}},date:{type:'4fv',value:[d.getFullYear(),d.getMonth(),d.getDate(),d.getHours()*60*60+d.getMinutes()*60+d.getSeconds()]},sampleRate:{type:'1f',value:44100.0},iChannel0:{type:'sampler2D',value:null,textureData:{repeat:true}},iChannel1:{type:'sampler2D',value:null,textureData:{repeat:true}},iChannel2:{type:'sampler2D',value:null,textureData:{repeat:true}},iChannel3:{type:'sampler2D',value:null,textureData:{repeat:true}}};//  Copy over/replace any passed in the constructor
	if(uniforms){for(var key in uniforms){this.uniforms[key]=uniforms[key];}}/**
	    * @property {array|string} fragmentSrc - The fragment shader code.
	    */this.fragmentSrc=fragmentSrc||'';};Phaser.Filter.prototype={/**
	    * Should be over-ridden.
	    * @method Phaser.Filter#init
	    */init:function init(){//  This should be over-ridden. Will receive a variable number of arguments.
	},/**
	    * Set the resolution uniforms on the filter.
	    * @method Phaser.Filter#setResolution
	    * @param {number} width - The width of the display.
	    * @param {number} height - The height of the display.
	    */setResolution:function setResolution(width,height){this.uniforms.resolution.value.x=width;this.uniforms.resolution.value.y=height;},/**
	    * Updates the filter.
	    * @method Phaser.Filter#update
	    * @param {Phaser.Pointer} [pointer] - A Pointer object to use for the filter. The coordinates are mapped to the mouse uniform.
	    */update:function update(pointer){if(typeof pointer!=='undefined'){var x=pointer.x/this.game.width;var y=1-pointer.y/this.game.height;if(x!==this.prevPoint.x||y!==this.prevPoint.y){this.uniforms.mouse.value.x=x.toFixed(2);this.uniforms.mouse.value.y=y.toFixed(2);this.prevPoint.set(x,y);}}this.uniforms.time.value=this.game.time.totalElapsedSeconds();},/**
	    * Creates a new Phaser.Image object using a blank texture and assigns 
	    * this Filter to it. The image is then added to the world.
	    *
	    * If you don't provide width and height values then Filter.width and Filter.height are used.
	    *
	    * If you do provide width and height values then this filter will be resized to match those
	    * values.
	    *
	    * @method Phaser.Filter#addToWorld
	    * @param {number} [x=0] - The x coordinate to place the Image at.
	    * @param {number} [y=0] - The y coordinate to place the Image at.
	    * @param {number} [width] - The width of the Image. If not specified (or null) it will use Filter.width. If specified Filter.width will be set to this value.
	    * @param {number} [height] - The height of the Image. If not specified (or null) it will use Filter.height. If specified Filter.height will be set to this value.
	    * @param {number} [anchorX=0] - Set the x anchor point of the Image. A value between 0 and 1, where 0 is the top-left and 1 is bottom-right.
	    * @param {number} [anchorY=0] - Set the y anchor point of the Image. A value between 0 and 1, where 0 is the top-left and 1 is bottom-right.
	    * @return {Phaser.Image} The newly added Image object.
	    */addToWorld:function addToWorld(x,y,width,height,anchorX,anchorY){if(anchorX===undefined){anchorX=0;}if(anchorY===undefined){anchorY=0;}if(width!==undefined&&width!==null){this.width=width;}else{width=this.width;}if(height!==undefined&&height!==null){this.height=height;}else{height=this.height;}var image=this.game.add.image(x,y,'__default');image.width=width;image.height=height;image.anchor.set(anchorX,anchorY);image.filters=[this];return image;},/**
	    * Clear down this Filter and null out references
	    * @method Phaser.Filter#destroy
	    */destroy:function destroy(){this.game=null;}};Phaser.Filter.prototype.constructor=Phaser.Filter;/**
	* @name Phaser.Filter#width
	* @property {number} width - The width (resolution uniform)
	*/Object.defineProperty(Phaser.Filter.prototype,'width',{get:function get(){return this.uniforms.resolution.value.x;},set:function set(value){this.uniforms.resolution.value.x=value;}});/**
	* @name Phaser.Filter#height
	* @property {number} height - The height (resolution uniform)
	*/Object.defineProperty(Phaser.Filter.prototype,'height',{get:function get(){return this.uniforms.resolution.value.y;},set:function set(value){this.uniforms.resolution.value.y=value;}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* This is a base Plugin template to use for any Phaser plugin development.
	*
	* @class Phaser.Plugin
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {any} parent - The object that owns this plugin, usually Phaser.PluginManager.
	*/Phaser.Plugin=function(game,parent){if(parent===undefined){parent=null;}/**
	    * @property {Phaser.Game} game - A reference to the currently running game.
	    */this.game=game;/**
	    * @property {any} parent - The parent of this plugin. If added to the PluginManager the parent will be set to that, otherwise it will be null.
	    */this.parent=parent;/**
	    * @property {boolean} active - A Plugin with active=true has its preUpdate and update methods called by the parent, otherwise they are skipped.
	    * @default
	    */this.active=false;/**
	    * @property {boolean} visible - A Plugin with visible=true has its render and postRender methods called by the parent, otherwise they are skipped.
	    * @default
	    */this.visible=false;/**
	    * @property {boolean} hasPreUpdate - A flag to indicate if this plugin has a preUpdate method.
	    * @default
	    */this.hasPreUpdate=false;/**
	    * @property {boolean} hasUpdate - A flag to indicate if this plugin has an update method.
	    * @default
	    */this.hasUpdate=false;/**
	    * @property {boolean} hasPostUpdate - A flag to indicate if this plugin has a postUpdate method.
	    * @default
	    */this.hasPostUpdate=false;/**
	    * @property {boolean} hasRender - A flag to indicate if this plugin has a render method.
	    * @default
	    */this.hasRender=false;/**
	    * @property {boolean} hasPostRender - A flag to indicate if this plugin has a postRender method.
	    * @default
	    */this.hasPostRender=false;};Phaser.Plugin.prototype={/**
	    * Pre-update is called at the very start of the update cycle, before any other subsystems have been updated (including Physics).
	    * It is only called if active is set to true.
	    * @method Phaser.Plugin#preUpdate
	    */preUpdate:function preUpdate(){},/**
	    * Update is called after all the core subsystems (Input, Tweens, Sound, etc) and the State have updated, but before the render.
	    * It is only called if active is set to true.
	    * @method Phaser.Plugin#update
	    */update:function update(){},/**
	    * Render is called right after the Game Renderer completes, but before the State.render.
	    * It is only called if visible is set to true.
	    * @method Phaser.Plugin#render
	    */render:function render(){},/**
	    * Post-render is called after the Game Renderer and State.render have run.
	    * It is only called if visible is set to true.
	    * @method Phaser.Plugin#postRender
	    */postRender:function postRender(){},/**
	    * Clear down this Plugin and null out references
	    * @method Phaser.Plugin#destroy
	    */destroy:function destroy(){this.game=null;this.parent=null;this.active=false;this.visible=false;}};Phaser.Plugin.prototype.constructor=Phaser.Plugin;/* jshint newcap: false *//**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Plugin Manager is responsible for the loading, running and unloading of Phaser Plugins.
	*
	* @class Phaser.PluginManager
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	*/Phaser.PluginManager=function(game){/**
	    * @property {Phaser.Game} game - A reference to the currently running game.
	    */this.game=game;/**
	    * @property {Phaser.Plugin[]} plugins - An array of all the plugins being managed by this PluginManager.
	    */this.plugins=[];/**
	    * @property {number} _len - Internal cache var.
	    * @private
	    */this._len=0;/**
	    * @property {number} _i - Internal cache var.
	    * @private
	    */this._i=0;};Phaser.PluginManager.prototype={/**
	    * Add a new Plugin into the PluginManager.
	    * The Plugin must have 2 properties: game and parent. Plugin.game is set to the game reference the PluginManager uses, and parent is set to the PluginManager.
	    *
	    * @method Phaser.PluginManager#add
	    * @param {object|Phaser.Plugin} plugin - The Plugin to add into the PluginManager. This can be a function or an existing object.
	    * @param {...*} parameter - Additional arguments that will be passed to the Plugin.init method.
	    * @return {Phaser.Plugin} The Plugin that was added to the manager.
	    */add:function add(plugin){var args=Array.prototype.slice.call(arguments,1);var result=false;//  Prototype?
	if(typeof plugin==='function'){plugin=new plugin(this.game,this);}else{plugin.game=this.game;plugin.parent=this;}//  Check for methods now to avoid having to do this every loop
	if(typeof plugin['preUpdate']==='function'){plugin.hasPreUpdate=true;result=true;}if(typeof plugin['update']==='function'){plugin.hasUpdate=true;result=true;}if(typeof plugin['postUpdate']==='function'){plugin.hasPostUpdate=true;result=true;}if(typeof plugin['render']==='function'){plugin.hasRender=true;result=true;}if(typeof plugin['postRender']==='function'){plugin.hasPostRender=true;result=true;}//  The plugin must have at least one of the above functions to be added to the PluginManager.
	if(result){if(plugin.hasPreUpdate||plugin.hasUpdate||plugin.hasPostUpdate){plugin.active=true;}if(plugin.hasRender||plugin.hasPostRender){plugin.visible=true;}this._len=this.plugins.push(plugin);// Allows plugins to run potentially destructive code outside of the constructor, and only if being added to the PluginManager
	if(typeof plugin['init']==='function'){plugin.init.apply(plugin,args);}return plugin;}else{return null;}},/**
	    * Remove a Plugin from the PluginManager. It calls Plugin.destroy on the plugin before removing it from the manager.
	    *
	    * @method Phaser.PluginManager#remove
	    * @param {Phaser.Plugin} plugin - The plugin to be removed.
	    * @param {boolean} [destroy=true] - Call destroy on the plugin that is removed?
	    */remove:function remove(plugin,destroy){if(destroy===undefined){destroy=true;}this._i=this._len;while(this._i--){if(this.plugins[this._i]===plugin){if(destroy){plugin.destroy();}this.plugins.splice(this._i,1);this._len--;return;}}},/**
	    * Remove all Plugins from the PluginManager. It calls Plugin.destroy on every plugin before removing it from the manager.
	    *
	    * @method Phaser.PluginManager#removeAll
	    */removeAll:function removeAll(){this._i=this._len;while(this._i--){this.plugins[this._i].destroy();}this.plugins.length=0;this._len=0;},/**
	    * Pre-update is called at the very start of the update cycle, before any other subsystems have been updated (including Physics).
	    * It only calls plugins who have active=true.
	    *
	    * @method Phaser.PluginManager#preUpdate
	    */preUpdate:function preUpdate(){this._i=this._len;while(this._i--){if(this.plugins[this._i].active&&this.plugins[this._i].hasPreUpdate){this.plugins[this._i].preUpdate();}}},/**
	    * Update is called after all the core subsystems (Input, Tweens, Sound, etc) and the State have updated, but before the render.
	    * It only calls plugins who have active=true.
	    *
	    * @method Phaser.PluginManager#update
	    */update:function update(){this._i=this._len;while(this._i--){if(this.plugins[this._i].active&&this.plugins[this._i].hasUpdate){this.plugins[this._i].update();}}},/**
	    * PostUpdate is the last thing to be called before the world render.
	    * In particular, it is called after the world postUpdate, which means the camera has been adjusted.
	    * It only calls plugins who have active=true.
	    *
	    * @method Phaser.PluginManager#postUpdate
	    */postUpdate:function postUpdate(){this._i=this._len;while(this._i--){if(this.plugins[this._i].active&&this.plugins[this._i].hasPostUpdate){this.plugins[this._i].postUpdate();}}},/**
	    * Render is called right after the Game Renderer completes, but before the State.render.
	    * It only calls plugins who have visible=true.
	    *
	    * @method Phaser.PluginManager#render
	    */render:function render(){this._i=this._len;while(this._i--){if(this.plugins[this._i].visible&&this.plugins[this._i].hasRender){this.plugins[this._i].render();}}},/**
	    * Post-render is called after the Game Renderer and State.render have run.
	    * It only calls plugins who have visible=true.
	    *
	    * @method Phaser.PluginManager#postRender
	    */postRender:function postRender(){this._i=this._len;while(this._i--){if(this.plugins[this._i].visible&&this.plugins[this._i].hasPostRender){this.plugins[this._i].postRender();}}},/**
	    * Clear down this PluginManager, calls destroy on every plugin and nulls out references.
	    *
	    * @method Phaser.PluginManager#destroy
	    */destroy:function destroy(){this.removeAll();this.game=null;}};Phaser.PluginManager.prototype.constructor=Phaser.PluginManager;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Stage controls root level display objects upon which everything is displayed.
	* It also handles browser visibility handling and the pausing due to loss of focus.
	*
	* @class Phaser.Stage
	* @extends PIXI.DisplayObjectContainer
	* @constructor
	* @param {Phaser.Game} game - Game reference to the currently running game.
	 */Phaser.Stage=function(game){/**
	    * @property {Phaser.Game} game - A reference to the currently running Game.
	    */this.game=game;PIXI.DisplayObjectContainer.call(this);/**
	    * @property {string} name - The name of this object.
	    * @default
	    */this.name='_stage_root';/**
	    * By default if the browser tab loses focus the game will pause.
	    * You can stop that behavior by setting this property to true.
	    * Note that the browser can still elect to pause your game if it wishes to do so,
	    * for example swapping to another browser tab. This will cause the RAF callback to halt,
	    * effectively pausing your game, even though no in-game pause event is triggered if you enable this property.
	    * @property {boolean} disableVisibilityChange
	    * @default
	    */this.disableVisibilityChange=false;/**
	    * @property {boolean} exists - If exists is true the Stage and all children are updated, otherwise it is skipped.
	    * @default
	    */this.exists=true;/**
	    * @property {PIXI.Matrix} worldTransform - Current transform of the object based on world (parent) factors
	    * @private
	    * @readOnly
	    */this.worldTransform=new PIXI.Matrix();/**
	    * @property {Phaser.Stage} stage - The stage reference (the Stage is its own stage)
	    * @private
	    * @readOnly
	    */this.stage=this;/**
	    * @property {number} currentRenderOrderID - Reset each frame, keeps a count of the total number of objects updated.
	    */this.currentRenderOrderID=0;/**
	    * @property {string} hiddenVar - The page visibility API event name.
	    * @private
	    */this._hiddenVar='hidden';/**
	    * @property {function} _onChange - The blur/focus event handler.
	    * @private
	    */this._onChange=null;/**
	    * @property {number} _bgColor - Stage background color object. Populated by setBackgroundColor.
	    * @private
	    */this._bgColor={r:0,g:0,b:0,a:0,color:0,rgba:'#000000'};if(!this.game.transparent){//  transparent = 0,0,0,0 - otherwise r,g,b,1
	this._bgColor.a=1;}if(game.config){this.parseConfig(game.config);}};Phaser.Stage.prototype=Object.create(PIXI.DisplayObjectContainer.prototype);Phaser.Stage.prototype.constructor=Phaser.Stage;/**
	* Parses a Game configuration object.
	*
	* @method Phaser.Stage#parseConfig
	* @protected
	* @param {object} config -The configuration object to parse.
	*/Phaser.Stage.prototype.parseConfig=function(config){if(config['disableVisibilityChange']){this.disableVisibilityChange=config['disableVisibilityChange'];}if(config['backgroundColor']){this.setBackgroundColor(config['backgroundColor']);}};/**
	* Initialises the stage and adds the event listeners.
	* @method Phaser.Stage#boot
	* @private
	*/Phaser.Stage.prototype.boot=function(){Phaser.DOM.getOffset(this.game.canvas,this.offset);Phaser.Canvas.setUserSelect(this.game.canvas,'none');Phaser.Canvas.setTouchAction(this.game.canvas,'none');this.checkVisibility();};/**
	* This is called automatically after the plugins preUpdate and before the State.update.
	* Most objects have preUpdate methods and it's where initial movement and positioning is done.
	*
	* @method Phaser.Stage#preUpdate
	*/Phaser.Stage.prototype.preUpdate=function(){this.currentRenderOrderID=0;//  This can't loop in reverse, we need the renderOrderID to be in sequence
	for(var i=0;i<this.children.length;i++){this.children[i].preUpdate();}};/**
	* This is called automatically after the State.update, but before particles or plugins update.
	*
	* @method Phaser.Stage#update
	*/Phaser.Stage.prototype.update=function(){//  Goes in reverse, because it's highly likely the child will destroy itself in `update`
	var i=this.children.length;while(i--){this.children[i].update();}};/**
	* This is called automatically before the renderer runs and after the plugins have updated.
	* In postUpdate this is where all the final physics calculations and object positioning happens.
	* The objects are processed in the order of the display list.
	*
	* @method Phaser.Stage#postUpdate
	*/Phaser.Stage.prototype.postUpdate=function(){//  Apply the camera shake, fade, bounds, etc
	this.game.camera.update();//  Camera target first?
	if(this.game.camera.target){this.game.camera.target.postUpdate();this.updateTransform();this.game.camera.updateTarget();}for(var i=0;i<this.children.length;i++){this.children[i].postUpdate();}this.updateTransform();};/**
	* Updates the transforms for all objects on the display list.
	* This overrides the Pixi default as we don't need the interactionManager, but do need the game property check.
	* 
	* @method Phaser.Stage#updateTransform
	*/Phaser.Stage.prototype.updateTransform=function(){this.worldAlpha=1;for(var i=0;i<this.children.length;i++){this.children[i].updateTransform();}};/**
	* Starts a page visibility event listener running, or window.onpagehide/onpageshow if not supported by the browser.
	* Also listens for window.onblur and window.onfocus.
	* 
	* @method Phaser.Stage#checkVisibility
	*/Phaser.Stage.prototype.checkVisibility=function(){if(document.hidden!==undefined){this._hiddenVar='visibilitychange';}else if(document.webkitHidden!==undefined){this._hiddenVar='webkitvisibilitychange';}else if(document.mozHidden!==undefined){this._hiddenVar='mozvisibilitychange';}else if(document.msHidden!==undefined){this._hiddenVar='msvisibilitychange';}else{this._hiddenVar=null;}var _this=this;this._onChange=function(event){return _this.visibilityChange(event);};//  Does browser support it? If not (like in IE9 or old Android) we need to fall back to blur/focus
	if(this._hiddenVar){document.addEventListener(this._hiddenVar,this._onChange,false);}window.onblur=this._onChange;window.onfocus=this._onChange;window.onpagehide=this._onChange;window.onpageshow=this._onChange;if(this.game.device.cocoonJSApp){CocoonJS.App.onSuspended.addEventListener(function(){Phaser.Stage.prototype.visibilityChange.call(_this,{type:"pause"});});CocoonJS.App.onActivated.addEventListener(function(){Phaser.Stage.prototype.visibilityChange.call(_this,{type:"resume"});});}};/**
	* This method is called when the document visibility is changed.
	* 
	* @method Phaser.Stage#visibilityChange
	* @param {Event} event - Its type will be used to decide whether the game should be paused or not.
	*/Phaser.Stage.prototype.visibilityChange=function(event){if(event.type==='pagehide'||event.type==='blur'||event.type==='pageshow'||event.type==='focus'){if(event.type==='pagehide'||event.type==='blur'){this.game.focusLoss(event);}else if(event.type==='pageshow'||event.type==='focus'){this.game.focusGain(event);}return;}if(this.disableVisibilityChange){return;}if(document.hidden||document.mozHidden||document.msHidden||document.webkitHidden||event.type==="pause"){this.game.gamePaused(event);}else{this.game.gameResumed(event);}};/**
	* Sets the background color for the Stage.
	*
	* The color can be given as a hex string (`'#RRGGBB'`), a CSS color string (`'rgb(r,g,b)'`), or a numeric value (`0xRRGGBB`).
	*
	* An alpha channel is _not_ supported and will be ignored.
	*
	* If you've set your game to be transparent then calls to setBackgroundColor are ignored.
	*
	* @method Phaser.Stage#setBackgroundColor
	* @param {number|string} color - The color of the background.
	*/Phaser.Stage.prototype.setBackgroundColor=function(color){if(this.game.transparent){return;}Phaser.Color.valueToColor(color,this._bgColor);Phaser.Color.updateColor(this._bgColor);//  For gl.clearColor (canvas uses _bgColor.rgba)
	this._bgColor.r/=255;this._bgColor.g/=255;this._bgColor.b/=255;this._bgColor.a=1;};/**
	* Destroys the Stage and removes event listeners.
	*
	* @method Phaser.Stage#destroy
	*/Phaser.Stage.prototype.destroy=function(){if(this._hiddenVar){document.removeEventListener(this._hiddenVar,this._onChange,false);}window.onpagehide=null;window.onpageshow=null;window.onblur=null;window.onfocus=null;};/**
	* @name Phaser.Stage#backgroundColor
	* @property {number|string} backgroundColor - Gets and sets the background color of the stage. The color can be given as a number: 0xff0000 or a hex string: '#ff0000'
	*/Object.defineProperty(Phaser.Stage.prototype,"backgroundColor",{get:function get(){return this._bgColor.color;},set:function set(color){this.setBackgroundColor(color);}});/**
	* Enable or disable texture smoothing for all objects on this Stage. Only works for bitmap/image textures. Smoothing is enabled by default.
	*
	* @name Phaser.Stage#smoothed
	* @property {boolean} smoothed - Set to true to smooth all sprites rendered on this Stage, or false to disable smoothing (great for pixel art)
	*/Object.defineProperty(Phaser.Stage.prototype,"smoothed",{get:function get(){return PIXI.scaleModes.DEFAULT===PIXI.scaleModes.LINEAR;},set:function set(value){if(value){PIXI.scaleModes.DEFAULT=PIXI.scaleModes.LINEAR;}else{PIXI.scaleModes.DEFAULT=PIXI.scaleModes.NEAREST;}}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A Group is a container for {@link DisplayObject display objects} including {@link Phaser.Sprite Sprites} and {@link Phaser.Image Images}.
	*
	* Groups form the logical tree structure of the display/scene graph where local transformations are applied to children.
	* For instance, all children are also moved/rotated/scaled when the group is moved/rotated/scaled.
	*
	* In addition, Groups provides support for fast pooling and object recycling.
	*
	* Groups are also display objects and can be nested as children within other Groups.
	*
	* @class Phaser.Group
	* @extends PIXI.DisplayObjectContainer
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {DisplayObject|null} [parent=(game world)] - The parent Group (or other {@link DisplayObject}) that this group will be added to.
	*     If undefined/unspecified the Group will be added to the {@link Phaser.Game#world Game World}; if null the Group will not be added to any parent.
	* @param {string} [name='group'] - A name for this group. Not used internally but useful for debugging.
	* @param {boolean} [addToStage=false] - If true this group will be added directly to the Game.Stage instead of Game.World.
	* @param {boolean} [enableBody=false] - If true all Sprites created with {@link #create} or {@link #createMulitple} will have a physics body created on them. Change the body type with {@link #physicsBodyType}.
	* @param {integer} [physicsBodyType=0] - The physics body type to use when physics bodies are automatically added. See {@link #physicsBodyType} for values.
	*/Phaser.Group=function(game,parent,name,addToStage,enableBody,physicsBodyType){if(addToStage===undefined){addToStage=false;}if(enableBody===undefined){enableBody=false;}if(physicsBodyType===undefined){physicsBodyType=Phaser.Physics.ARCADE;}/**
	    * A reference to the currently running Game.
	    * @property {Phaser.Game} game
	    * @protected
	    */this.game=game;if(parent===undefined){parent=game.world;}/**
	    * A name for this group. Not used internally but useful for debugging.
	    * @property {string} name
	    */this.name=name||'group';/**
	    * The z-depth value of this object within its parent container/Group - the World is a Group as well.
	    * This value must be unique for each child in a Group.
	    * @property {integer} z
	    * @readOnly
	    */this.z=0;PIXI.DisplayObjectContainer.call(this);if(addToStage){this.game.stage.addChild(this);this.z=this.game.stage.children.length;}else{if(parent){parent.addChild(this);this.z=parent.children.length;}}/**
	    * Internal Phaser Type value.
	    * @property {integer} type
	    * @protected
	    */this.type=Phaser.GROUP;/**
	    * @property {number} physicsType - The const physics body type of this object.
	    * @readonly
	    */this.physicsType=Phaser.GROUP;/**
	    * The alive property is useful for Groups that are children of other Groups and need to be included/excluded in checks like forEachAlive.
	    * @property {boolean} alive
	    * @default
	    */this.alive=true;/**
	    * If exists is true the group is updated, otherwise it is skipped.
	    * @property {boolean} exists
	    * @default
	    */this.exists=true;/**
	    * A group with `ignoreDestroy` set to `true` ignores all calls to its `destroy` method.
	    * @property {boolean} ignoreDestroy
	    * @default
	    */this.ignoreDestroy=false;/**
	    * A Group is that has `pendingDestroy` set to `true` is flagged to have its destroy method
	    * called on the next logic update.
	    * You can set it directly to flag the Group to be destroyed on its next update.
	    *
	    * This is extremely useful if you wish to destroy a Group from within one of its own callbacks
	    * or a callback of one of its children.
	    *
	    * @property {boolean} pendingDestroy
	    */this.pendingDestroy=false;/**
	    * The type of objects that will be created when using {@link #create} or {@link #createMultiple}.
	    *
	    * Any object may be used but it should extend either Sprite or Image and accept the same constructor arguments:
	    * when a new object is created it is passed the following parameters to its constructor: `(game, x, y, key, frame)`.
	    *
	    * @property {object} classType
	    * @default {@link Phaser.Sprite}
	    */this.classType=Phaser.Sprite;/**
	    * The current display object that the group cursor is pointing to, if any. (Can be set manually.)
	    *
	    * The cursor is a way to iterate through the children in a Group using {@link #next} and {@link #previous}.
	    * @property {?DisplayObject} cursor
	    */this.cursor=null;/**
	    * A Group with `inputEnableChildren` set to `true` will automatically call `inputEnabled = true` 
	    * on any children _added_ to, or _created by_, this Group.
	    * 
	    * If there are children already in the Group at the time you set this property, they are not changed.
	    * 
	    * @property {boolean} inputEnableChildren
	    * @default
	    */this.inputEnableChildren=false;/**
	    * This Signal is dispatched whenever a child of this Group emits an onInputDown signal as a result
	    * of having been interacted with by a Pointer. You can bind functions to this Signal instead of to
	    * every child Sprite.
	    * 
	    * This Signal is sent 2 arguments: A reference to the Sprite that triggered the signal, and
	    * a reference to the Pointer that caused it.
	    * 
	    * @property {Phaser.Signal} onChildInputDown
	    */this.onChildInputDown=new Phaser.Signal();/**
	    * This Signal is dispatched whenever a child of this Group emits an onInputUp signal as a result
	    * of having been interacted with by a Pointer. You can bind functions to this Signal instead of to
	    * every child Sprite.
	    * 
	    * This Signal is sent 3 arguments: A reference to the Sprite that triggered the signal, 
	    * a reference to the Pointer that caused it, and a boolean value `isOver` that tells you if the Pointer
	    * is still over the Sprite or not.
	    * 
	    * @property {Phaser.Signal} onChildInputUp
	    */this.onChildInputUp=new Phaser.Signal();/**
	    * This Signal is dispatched whenever a child of this Group emits an onInputOver signal as a result
	    * of having been interacted with by a Pointer. You can bind functions to this Signal instead of to
	    * every child Sprite.
	    * 
	    * This Signal is sent 2 arguments: A reference to the Sprite that triggered the signal, and
	    * a reference to the Pointer that caused it.
	    * 
	    * @property {Phaser.Signal} onChildInputOver
	    */this.onChildInputOver=new Phaser.Signal();/**
	    * This Signal is dispatched whenever a child of this Group emits an onInputOut signal as a result
	    * of having been interacted with by a Pointer. You can bind functions to this Signal instead of to
	    * every child Sprite.
	    * 
	    * This Signal is sent 2 arguments: A reference to the Sprite that triggered the signal, and
	    * a reference to the Pointer that caused it.
	    * 
	    * @property {Phaser.Signal} onChildInputOut
	    */this.onChildInputOut=new Phaser.Signal();/**
	    * If true all Sprites created by, or added to this group, will have a physics body enabled on them.
	    *
	    * If there are children already in the Group at the time you set this property, they are not changed.
	    *
	    * The default body type is controlled with {@link #physicsBodyType}.
	    * @property {boolean} enableBody
	    */this.enableBody=enableBody;/**
	    * If true when a physics body is created (via {@link #enableBody}) it will create a physics debug object as well.
	    *
	    * This only works for P2 bodies.
	    * @property {boolean} enableBodyDebug
	    * @default
	    */this.enableBodyDebug=false;/**
	    * If {@link #enableBody} is true this is the type of physics body that is created on new Sprites.
	    *
	    * The valid values are {@link Phaser.Physics.ARCADE}, {@link Phaser.Physics.P2JS}, {@link Phaser.Physics.NINJA}, etc.
	    * @property {integer} physicsBodyType
	    */this.physicsBodyType=physicsBodyType;/**
	    * If this Group contains Arcade Physics Sprites you can set a custom sort direction via this property.
	    *
	    * It should be set to one of the Phaser.Physics.Arcade sort direction constants: 
	    * 
	    * Phaser.Physics.Arcade.SORT_NONE
	    * Phaser.Physics.Arcade.LEFT_RIGHT
	    * Phaser.Physics.Arcade.RIGHT_LEFT
	    * Phaser.Physics.Arcade.TOP_BOTTOM
	    * Phaser.Physics.Arcade.BOTTOM_TOP
	    *
	    * If set to `null` the Group will use whatever Phaser.Physics.Arcade.sortDirection is set to. This is the default behavior.
	    * 
	    * @property {integer} physicsSortDirection
	    * @default
	    */this.physicsSortDirection=null;/**
	    * This signal is dispatched when the group is destroyed.
	    * @property {Phaser.Signal} onDestroy
	    */this.onDestroy=new Phaser.Signal();/**
	    * @property {integer} cursorIndex - The current index of the Group cursor. Advance it with Group.next.
	    * @readOnly
	    */this.cursorIndex=0;/**
	    * A Group that is fixed to the camera uses its x/y coordinates as offsets from the top left of the camera. These are stored in Group.cameraOffset.
	    * 
	    * Note that the cameraOffset values are in addition to any parent in the display list.
	    * So if this Group was in a Group that has x: 200, then this will be added to the cameraOffset.x
	    * 
	    * @property {boolean} fixedToCamera
	    */this.fixedToCamera=false;/**
	    * If this object is {@link #fixedToCamera} then this stores the x/y position offset relative to the top-left of the camera view.
	    * If the parent of this Group is also `fixedToCamera` then the offset here is in addition to that and should typically be disabled.
	    * @property {Phaser.Point} cameraOffset
	    */this.cameraOffset=new Phaser.Point();/**
	    * The hash array is an array belonging to this Group into which you can add any of its children via Group.addToHash and Group.removeFromHash.
	    * 
	    * Only children of this Group can be added to and removed from the hash.
	    * 
	    * This hash is used automatically by Phaser Arcade Physics in order to perform non z-index based destructive sorting.
	    * However if you don't use Arcade Physics, or this isn't a physics enabled Group, then you can use the hash to perform your own
	    * sorting and filtering of Group children without touching their z-index (and therefore display draw order)
	    * 
	    * @property {array} hash
	    */this.hash=[];/**
	    * The property on which children are sorted.
	    * @property {string} _sortProperty
	    * @private
	    */this._sortProperty='z';};Phaser.Group.prototype=Object.create(PIXI.DisplayObjectContainer.prototype);Phaser.Group.prototype.constructor=Phaser.Group;/**
	* A returnType value, as specified in {@link #iterate} eg.
	* @constant
	* @type {integer}
	*/Phaser.Group.RETURN_NONE=0;/**
	* A returnType value, as specified in {@link #iterate} eg.
	* @constant
	* @type {integer}
	*/Phaser.Group.RETURN_TOTAL=1;/**
	* A returnType value, as specified in {@link #iterate} eg.
	* @constant
	* @type {integer}
	*/Phaser.Group.RETURN_CHILD=2;/**
	* A returnType value, as specified in {@link #iterate} eg.
	* @constant
	* @type {integer}
	*/Phaser.Group.RETURN_ALL=3;/**
	* A sort ordering value, as specified in {@link #sort} eg.
	* @constant
	* @type {integer}
	*/Phaser.Group.SORT_ASCENDING=-1;/**
	* A sort ordering value, as specified in {@link #sort} eg.
	* @constant
	* @type {integer}
	*/Phaser.Group.SORT_DESCENDING=1;/**
	* Adds an existing object as the top child in this group.
	*
	* The child is automatically added to the top of the group, and is displayed above every previous child.
	*
	* Or if the _optional_ index is specified, the child is added at the location specified by the index value, 
	* this allows you to control child ordering.
	*
	* If the child was already in this Group, it is simply returned, and nothing else happens to it.
	*
	* If `Group.enableBody` is set, then a physics body will be created on the object, so long as one does not already exist.
	*
	* If `Group.inputEnableChildren` is set, then an Input Handler will be created on the object, so long as one does not already exist.
	*
	* Use {@link #addAt} to control where a child is added. Use {@link #create} to create and add a new child.
	*
	* @method Phaser.Group#add
	* @param {DisplayObject} child - The display object to add as a child.
	* @param {boolean} [silent=false] - If true the child will not dispatch the `onAddedToGroup` event.
	* @param {integer} [index] - The index within the group to insert the child to. Where 0 is the bottom of the Group.
	* @return {DisplayObject} The child that was added to the group.
	*/Phaser.Group.prototype.add=function(child,silent,index){if(silent===undefined){silent=false;}if(child.parent===this){return child;}if(child.body&&child.parent&&child.parent.hash){child.parent.removeFromHash(child);}if(index===undefined){child.z=this.children.length;this.addChild(child);}else{this.addChildAt(child,index);this.updateZ();}if(this.enableBody&&child.hasOwnProperty('body')&&child.body===null){this.game.physics.enable(child,this.physicsBodyType);}else if(child.body){this.addToHash(child);}if(this.inputEnableChildren&&(!child.input||child.inputEnabled)){child.inputEnabled=true;}if(!silent&&child.events){child.events.onAddedToGroup$dispatch(child,this);}if(this.cursor===null){this.cursor=child;}return child;};/**
	* Adds an existing object to this group.
	*
	* The child is added to the group at the location specified by the index value, this allows you to control child ordering.
	* 
	* If `Group.enableBody` is set, then a physics body will be created on the object, so long as one does not already exist.
	*
	* If `Group.inputEnableChildren` is set, then an Input Handler will be created on the object, so long as one does not already exist.
	*
	* @method Phaser.Group#addAt
	* @param {DisplayObject} child - The display object to add as a child.
	* @param {integer} [index=0] - The index within the group to insert the child to.
	* @param {boolean} [silent=false] - If true the child will not dispatch the `onAddedToGroup` event.
	* @return {DisplayObject} The child that was added to the group.
	*/Phaser.Group.prototype.addAt=function(child,index,silent){this.add(child,silent,index);};/**
	* Adds a child of this Group into the hash array.
	* This call will return false if the child is not a child of this Group, or is already in the hash.
	*
	* @method Phaser.Group#addToHash
	* @param {DisplayObject} child - The display object to add to this Groups hash. Must be a member of this Group already and not present in the hash.
	* @return {boolean} True if the child was successfully added to the hash, otherwise false.
	*/Phaser.Group.prototype.addToHash=function(child){if(child.parent===this){var index=this.hash.indexOf(child);if(index===-1){this.hash.push(child);return true;}}return false;};/**
	* Removes a child of this Group from the hash array.
	* This call will return false if the child is not in the hash.
	*
	* @method Phaser.Group#removeFromHash
	* @param {DisplayObject} child - The display object to remove from this Groups hash. Must be a member of this Group and in the hash.
	* @return {boolean} True if the child was successfully removed from the hash, otherwise false.
	*/Phaser.Group.prototype.removeFromHash=function(child){if(child){var index=this.hash.indexOf(child);if(index!==-1){this.hash.splice(index,1);return true;}}return false;};/**
	* Adds an array of existing Display Objects to this Group.
	*
	* The Display Objects are automatically added to the top of this Group, and will render on-top of everything already in this Group.
	*
	* As well as an array you can also pass another Group as the first argument. In this case all of the children from that
	* Group will be removed from it and added into this Group.
	* 
	* If `Group.enableBody` is set, then a physics body will be created on the objects, so long as one does not already exist.
	*
	* If `Group.inputEnableChildren` is set, then an Input Handler will be created on the objects, so long as one does not already exist.
	*
	* @method Phaser.Group#addMultiple
	* @param {DisplayObject[]|Phaser.Group} children - An array of display objects or a Phaser.Group. If a Group is given then *all* children will be moved from it.
	* @param {boolean} [silent=false] - If true the children will not dispatch the `onAddedToGroup` event.
	* @return {DisplayObject[]|Phaser.Group} The array of children or Group of children that were added to this Group.
	*/Phaser.Group.prototype.addMultiple=function(children,silent){if(children instanceof Phaser.Group){children.moveAll(this,silent);}else if(Array.isArray(children)){for(var i=0;i<children.length;i++){this.add(children[i],silent);}}return children;};/**
	* Returns the child found at the given index within this group.
	*
	* @method Phaser.Group#getAt
	* @param {integer} index - The index to return the child from.
	* @return {DisplayObject|integer} The child that was found at the given index, or -1 for an invalid index.
	*/Phaser.Group.prototype.getAt=function(index){if(index<0||index>=this.children.length){return-1;}else{return this.getChildAt(index);}};/**
	* Creates a new Phaser.Sprite object and adds it to the top of this group.
	*
	* Use {@link #classType} to change the type of object created.
	* 
	* The child is automatically added to the top of the group, and is displayed above every previous child.
	*
	* Or if the _optional_ index is specified, the child is added at the location specified by the index value, 
	* this allows you to control child ordering.
	* 
	* If `Group.enableBody` is set, then a physics body will be created on the object, so long as one does not already exist.
	*
	* If `Group.inputEnableChildren` is set, then an Input Handler will be created on the object, so long as one does not already exist.
	*
	* @method Phaser.Group#create
	* @param {number} x - The x coordinate to display the newly created Sprite at. The value is in relation to the group.x point.
	* @param {number} y - The y coordinate to display the newly created Sprite at. The value is in relation to the group.y point.
	* @param {string|Phaser.RenderTexture|Phaser.BitmapData|Phaser.Video|PIXI.Texture} [key] - This is the image or texture used by the Sprite during rendering. It can be a string which is a reference to the Cache Image entry, or an instance of a RenderTexture, BitmapData, Video or PIXI.Texture.
	* @param {string|number} [frame] - If this Sprite is using part of a sprite sheet or texture atlas you can specify the exact frame to use by giving a string or numeric index.
	* @param {boolean} [exists=true] - The default exists state of the Sprite.
	* @param {integer} [index] - The index within the group to insert the child to. Where 0 is the bottom of the Group.
	* @return {DisplayObject} The child that was created: will be a {@link Phaser.Sprite} unless {@link #classType} has been changed.
	*/Phaser.Group.prototype.create=function(x,y,key,frame,exists,index){if(exists===undefined){exists=true;}var child=new this.classType(this.game,x,y,key,frame);child.exists=exists;child.visible=exists;child.alive=exists;return this.add(child,false,index);};/**
	* Creates multiple Phaser.Sprite objects and adds them to the top of this Group.
	* 
	* This method is useful if you need to quickly generate a pool of sprites, such as bullets.
	*
	* Use {@link #classType} to change the type of object created.
	*
	* You can provide an array as the `key` and / or `frame` arguments. When you do this
	* it will create `quantity` Sprites for every key (and frame) in the arrays.
	* 
	* For example:
	* 
	* `createMultiple(25, ['ball', 'carrot'])`
	*
	* In the above code there are 2 keys (ball and carrot) which means that 50 sprites will be
	* created in total, 25 of each. You can also have the `frame` as an array:
	*
	* `createMultiple(5, 'bricks', [0, 1, 2, 3])`
	*
	* In the above there is one key (bricks), which is a sprite sheet. The frames array tells
	* this method to use frames 0, 1, 2 and 3. So in total it will create 20 sprites, because
	* the quantity was set to 5, so that is 5 brick sprites of frame 0, 5 brick sprites with
	* frame 1, and so on.
	*
	* If you set both the key and frame arguments to be arrays then understand it will create
	* a total quantity of sprites equal to the size of both arrays times each other. I.e.:
	*
	* `createMultiple(20, ['diamonds', 'balls'], [0, 1, 2])`
	*
	* The above will create 20 'diamonds' of frame 0, 20 with frame 1 and 20 with frame 2.
	* It will then create 20 'balls' of frame 0, 20 with frame 1 and 20 with frame 2.
	* In total it will have created 120 sprites.
	*
	* By default the Sprites will have their `exists` property set to `false`, and they will be 
	* positioned at 0x0, relative to the `Group.x / y` values.
	* 
	* If `Group.enableBody` is set, then a physics body will be created on the objects, so long as one does not already exist.
	*
	* If `Group.inputEnableChildren` is set, then an Input Handler will be created on the objects, so long as one does not already exist.
	*
	* @method Phaser.Group#createMultiple
	* @param {integer} quantity - The number of Sprites to create.
	* @param {string|array} key - The Cache key of the image that the Sprites will use. Or an Array of keys. See the description for details on how the quantity applies when arrays are used.
	* @param {integer|string|array} [frame=0] - If the Sprite image contains multiple frames you can specify which one to use here. Or an Array of frames. See the description for details on how the quantity applies when arrays are used.
	* @param {boolean} [exists=false] - The default exists state of the Sprite.
	* @return {array} An array containing all of the Sprites that were created.
	*/Phaser.Group.prototype.createMultiple=function(quantity,key,frame,exists){if(frame===undefined){frame=0;}if(exists===undefined){exists=false;}if(!Array.isArray(key)){key=[key];}if(!Array.isArray(frame)){frame=[frame];}var _this=this;var children=[];key.forEach(function(singleKey){frame.forEach(function(singleFrame){for(var i=0;i<quantity;i++){children.push(_this.create(0,0,singleKey,singleFrame,exists));}});});return children;};/**
	* Internal method that re-applies all of the children's Z values.
	*
	* This must be called whenever children ordering is altered so that their `z` indices are correctly updated.
	*
	* @method Phaser.Group#updateZ
	* @protected
	*/Phaser.Group.prototype.updateZ=function(){var i=this.children.length;while(i--){this.children[i].z=i;}};/**
	* This method iterates through all children in the Group (regardless if they are visible or exist)
	* and then changes their position so they are arranged in a Grid formation. Children must have
	* the `alignTo` method in order to be positioned by this call. All default Phaser Game Objects have
	* this.
	*
	* The grid dimensions are determined by the first four arguments. The `width` and `height` arguments
	* relate to the width and height of the grid respectively.
	*
	* For example if the Group had 100 children in it:
	*
	* `Group.align(10, 10, 32, 32)`
	*
	* This will align all of the children into a grid formation of 10x10, using 32 pixels per
	* grid cell. If you want a wider grid, you could do:
	* 
	* `Group.align(25, 4, 32, 32)`
	*
	* This will align the children into a grid of 25x4, again using 32 pixels per grid cell.
	*
	* You can choose to set _either_ the `width` or `height` value to -1. Doing so tells the method
	* to keep on aligning children until there are no children left. For example if this Group had
	* 48 children in it, the following:
	*
	* `Group.align(-1, 8, 32, 32)`
	*
	* ... will align the children so that there are 8 children vertically (the second argument), 
	* and each row will contain 6 sprites, except the last one, which will contain 5 (totaling 48)
	*
	* You can also do:
	* 
	* `Group.align(10, -1, 32, 32)`
	*
	* In this case it will create a grid 10 wide, and as tall as it needs to be in order to fit
	* all of the children in.
	*
	* The `position` property allows you to control where in each grid cell the child is positioned.
	* This is a constant and can be one of `Phaser.TOP_LEFT` (default), `Phaser.TOP_CENTER`, 
	* `Phaser.TOP_RIGHT`, `Phaser.LEFT_CENTER`, `Phaser.CENTER`, `Phaser.RIGHT_CENTER`, 
	* `Phaser.BOTTOM_LEFT`, `Phaser.BOTTOM_CENTER` or `Phaser.BOTTOM_RIGHT`.
	*
	* The final argument; `offset` lets you start the alignment from a specific child index.
	*
	* @method Phaser.Group#align
	* @param {integer} width - The width of the grid in items (not pixels). Set to -1 for a dynamic width. If -1 then you must set an explicit height value.
	* @param {integer} height - The height of the grid in items (not pixels). Set to -1 for a dynamic height. If -1 then you must set an explicit width value.
	* @param {integer} cellWidth - The width of each grid cell, in pixels.
	* @param {integer} cellHeight - The height of each grid cell, in pixels.
	* @param {integer} [position] - The position constant. One of `Phaser.TOP_LEFT` (default), `Phaser.TOP_CENTER`, `Phaser.TOP_RIGHT`, `Phaser.LEFT_CENTER`, `Phaser.CENTER`, `Phaser.RIGHT_CENTER`, `Phaser.BOTTOM_LEFT`, `Phaser.BOTTOM_CENTER` or `Phaser.BOTTOM_RIGHT`.
	* @param {integer} [offset=0] - Optional index to start the alignment from. Defaults to zero, the first child in the Group, but can be set to any valid child index value.
	* @return {boolean} True if the Group children were aligned, otherwise false.
	*/Phaser.Group.prototype.align=function(width,height,cellWidth,cellHeight,position,offset){if(position===undefined){position=Phaser.TOP_LEFT;}if(offset===undefined){offset=0;}if(this.children.length===0||offset>this.children.length||width===-1&&height===-1){return false;}var r=new Phaser.Rectangle(0,0,cellWidth,cellHeight);var w=width*cellWidth;var h=height*cellHeight;for(var i=offset;i<this.children.length;i++){var child=this.children[i];if(child['alignIn']){child.alignIn(r,position);}else{continue;}if(width===-1){//  We keep laying them out horizontally until we've done them all
	r.y+=cellHeight;if(r.y===h){r.x+=cellWidth;r.y=0;}}else if(height===-1){//  We keep laying them out vertically until we've done them all
	r.x+=cellWidth;if(r.x===w){r.x=0;r.y+=cellHeight;}}else{//  We keep laying them out until we hit the column limit
	r.x+=cellWidth;if(r.x===w){r.x=0;r.y+=cellHeight;if(r.y===h){//  We've hit the column limit, so return, even if there are children left
	return true;}}}}return true;};/**
	* Sets the group cursor to the first child in the group.
	*
	* If the optional index parameter is given it sets the cursor to the object at that index instead.
	*
	* @method Phaser.Group#resetCursor
	* @param {integer} [index=0] - Set the cursor to point to a specific index.
	* @return {any} The child the cursor now points to.
	*/Phaser.Group.prototype.resetCursor=function(index){if(index===undefined){index=0;}if(index>this.children.length-1){index=0;}if(this.cursor){this.cursorIndex=index;this.cursor=this.children[this.cursorIndex];return this.cursor;}};/**
	* Advances the group cursor to the next (higher) object in the group.
	*
	* If the cursor is at the end of the group (top child) it is moved the start of the group (bottom child).
	*
	* @method Phaser.Group#next
	* @return {any} The child the cursor now points to.
	*/Phaser.Group.prototype.next=function(){if(this.cursor){//  Wrap the cursor?
	if(this.cursorIndex>=this.children.length-1){this.cursorIndex=0;}else{this.cursorIndex++;}this.cursor=this.children[this.cursorIndex];return this.cursor;}};/**
	* Moves the group cursor to the previous (lower) child in the group.
	*
	* If the cursor is at the start of the group (bottom child) it is moved to the end (top child).
	*
	* @method Phaser.Group#previous
	* @return {any} The child the cursor now points to.
	*/Phaser.Group.prototype.previous=function(){if(this.cursor){//  Wrap the cursor?
	if(this.cursorIndex===0){this.cursorIndex=this.children.length-1;}else{this.cursorIndex--;}this.cursor=this.children[this.cursorIndex];return this.cursor;}};/**
	* Swaps the position of two children in this group.
	*
	* Both children must be in this group, a child cannot be swapped with itself, and unparented children cannot be swapped.
	*
	* @method Phaser.Group#swap
	* @param {any} child1 - The first child to swap.
	* @param {any} child2 - The second child to swap.
	*/Phaser.Group.prototype.swap=function(child1,child2){this.swapChildren(child1,child2);this.updateZ();};/**
	* Brings the given child to the top of this group so it renders above all other children.
	*
	* @method Phaser.Group#bringToTop
	* @param {any} child - The child to bring to the top of this group.
	* @return {any} The child that was moved.
	*/Phaser.Group.prototype.bringToTop=function(child){if(child.parent===this&&this.getIndex(child)<this.children.length){this.remove(child,false,true);this.add(child,true);}return child;};/**
	* Sends the given child to the bottom of this group so it renders below all other children.
	*
	* @method Phaser.Group#sendToBack
	* @param {any} child - The child to send to the bottom of this group.
	* @return {any} The child that was moved.
	*/Phaser.Group.prototype.sendToBack=function(child){if(child.parent===this&&this.getIndex(child)>0){this.remove(child,false,true);this.addAt(child,0,true);}return child;};/**
	* Moves the given child up one place in this group unless it's already at the top.
	*
	* @method Phaser.Group#moveUp
	* @param {any} child - The child to move up in the group.
	* @return {any} The child that was moved.
	*/Phaser.Group.prototype.moveUp=function(child){if(child.parent===this&&this.getIndex(child)<this.children.length-1){var a=this.getIndex(child);var b=this.getAt(a+1);if(b){this.swap(child,b);}}return child;};/**
	* Moves the given child down one place in this group unless it's already at the bottom.
	*
	* @method Phaser.Group#moveDown
	* @param {any} child - The child to move down in the group.
	* @return {any} The child that was moved.
	*/Phaser.Group.prototype.moveDown=function(child){if(child.parent===this&&this.getIndex(child)>0){var a=this.getIndex(child);var b=this.getAt(a-1);if(b){this.swap(child,b);}}return child;};/**
	* Positions the child found at the given index within this group to the given x and y coordinates.
	*
	* @method Phaser.Group#xy
	* @param {integer} index - The index of the child in the group to set the position of.
	* @param {number} x - The new x position of the child.
	* @param {number} y - The new y position of the child.
	*/Phaser.Group.prototype.xy=function(index,x,y){if(index<0||index>this.children.length){return-1;}else{this.getChildAt(index).x=x;this.getChildAt(index).y=y;}};/**
	* Reverses all children in this group.
	*
	* This operation applies only to immediate children and does not propagate to subgroups.
	*
	* @method Phaser.Group#reverse
	*/Phaser.Group.prototype.reverse=function(){this.children.reverse();this.updateZ();};/**
	* Get the index position of the given child in this group, which should match the child's `z` property.
	*
	* @method Phaser.Group#getIndex
	* @param {any} child - The child to get the index for.
	* @return {integer} The index of the child or -1 if it's not a member of this group.
	*/Phaser.Group.prototype.getIndex=function(child){return this.children.indexOf(child);};/**
	* Searches the Group for the first instance of a child with the `name`
	* property matching the given argument. Should more than one child have
	* the same name only the first instance is returned.
	*
	* @method Phaser.Group#getByName
	* @param {string} name - The name to search for.
	* @return {any} The first child with a matching name, or null if none were found.
	*/Phaser.Group.prototype.getByName=function(name){for(var i=0;i<this.children.length;i++){if(this.children[i].name===name){return this.children[i];}}return null;};/**
	* Replaces a child of this Group with the given newChild. The newChild cannot be a member of this Group.
	*
	* If `Group.enableBody` is set, then a physics body will be created on the object, so long as one does not already exist.
	*
	* If `Group.inputEnableChildren` is set, then an Input Handler will be created on the object, so long as one does not already exist.
	*
	* @method Phaser.Group#replace
	* @param {any} oldChild - The child in this group that will be replaced.
	* @param {any} newChild - The child to be inserted into this group.
	* @return {any} Returns the oldChild that was replaced within this group.
	*/Phaser.Group.prototype.replace=function(oldChild,newChild){var index=this.getIndex(oldChild);if(index!==-1){if(newChild.parent){if(newChild.parent instanceof Phaser.Group){newChild.parent.remove(newChild);}else{newChild.parent.removeChild(newChild);}}this.remove(oldChild);this.addAt(newChild,index);return oldChild;}};/**
	* Checks if the child has the given property.
	*
	* Will scan up to 4 levels deep only.
	*
	* @method Phaser.Group#hasProperty
	* @param {any} child - The child to check for the existence of the property on.
	* @param {string[]} key - An array of strings that make up the property.
	* @return {boolean} True if the child has the property, otherwise false.
	*/Phaser.Group.prototype.hasProperty=function(child,key){var len=key.length;if(len===1&&key[0]in child){return true;}else if(len===2&&key[0]in child&&key[1]in child[key[0]]){return true;}else if(len===3&&key[0]in child&&key[1]in child[key[0]]&&key[2]in child[key[0]][key[1]]){return true;}else if(len===4&&key[0]in child&&key[1]in child[key[0]]&&key[2]in child[key[0]][key[1]]&&key[3]in child[key[0]][key[1]][key[2]]){return true;}return false;};/**
	* Sets a property to the given value on the child. The operation parameter controls how the value is set.
	*
	* The operations are:
	* - 0: set the existing value to the given value; if force is `true` a new property will be created if needed
	* - 1: will add the given value to the value already present.
	* - 2: will subtract the given value from the value already present.
	* - 3: will multiply the value already present by the given value.
	* - 4: will divide the value already present by the given value.
	*
	* @method Phaser.Group#setProperty
	* @param {any} child - The child to set the property value on.
	* @param {array} key - An array of strings that make up the property that will be set.
	* @param {any} value - The value that will be set.
	* @param {integer} [operation=0] - Controls how the value is assigned. A value of 0 replaces the value with the new one. A value of 1 adds it, 2 subtracts it, 3 multiplies it and 4 divides it.
	* @param {boolean} [force=false] - If `force` is true then the property will be set on the child regardless if it already exists or not. If false and the property doesn't exist, nothing will be set.
	* @return {boolean} True if the property was set, false if not.
	*/Phaser.Group.prototype.setProperty=function(child,key,value,operation,force){if(force===undefined){force=false;}operation=operation||0;//  As ugly as this approach looks, and although it's limited to a depth of only 4, it's much faster than a for loop or object iteration.
	//  0 = Equals
	//  1 = Add
	//  2 = Subtract
	//  3 = Multiply
	//  4 = Divide
	//  We can't force a property in and the child doesn't have it, so abort.
	//  Equally we can't add, subtract, multiply or divide a property value if it doesn't exist, so abort in those cases too.
	if(!this.hasProperty(child,key)&&(!force||operation>0)){return false;}var len=key.length;if(len===1){if(operation===0){child[key[0]]=value;}else if(operation===1){child[key[0]]+=value;}else if(operation===2){child[key[0]]-=value;}else if(operation===3){child[key[0]]*=value;}else if(operation===4){child[key[0]]/=value;}}else if(len===2){if(operation===0){child[key[0]][key[1]]=value;}else if(operation===1){child[key[0]][key[1]]+=value;}else if(operation===2){child[key[0]][key[1]]-=value;}else if(operation===3){child[key[0]][key[1]]*=value;}else if(operation===4){child[key[0]][key[1]]/=value;}}else if(len===3){if(operation===0){child[key[0]][key[1]][key[2]]=value;}else if(operation===1){child[key[0]][key[1]][key[2]]+=value;}else if(operation===2){child[key[0]][key[1]][key[2]]-=value;}else if(operation===3){child[key[0]][key[1]][key[2]]*=value;}else if(operation===4){child[key[0]][key[1]][key[2]]/=value;}}else if(len===4){if(operation===0){child[key[0]][key[1]][key[2]][key[3]]=value;}else if(operation===1){child[key[0]][key[1]][key[2]][key[3]]+=value;}else if(operation===2){child[key[0]][key[1]][key[2]][key[3]]-=value;}else if(operation===3){child[key[0]][key[1]][key[2]][key[3]]*=value;}else if(operation===4){child[key[0]][key[1]][key[2]][key[3]]/=value;}}return true;};/**
	* Checks a property for the given value on the child.
	*
	* @method Phaser.Group#checkProperty
	* @param {any} child - The child to check the property value on.
	* @param {array} key - An array of strings that make up the property that will be set.
	* @param {any} value - The value that will be checked.
	* @param {boolean} [force=false] - If `force` is true then the property will be checked on the child regardless if it already exists or not. If true and the property doesn't exist, false will be returned.
	* @return {boolean} True if the property was was equal to value, false if not.
	*/Phaser.Group.prototype.checkProperty=function(child,key,value,force){if(force===undefined){force=false;}//  We can't force a property in and the child doesn't have it, so abort.
	if(!Phaser.Utils.getProperty(child,key)&&force){return false;}if(Phaser.Utils.getProperty(child,key)!==value){return false;}return true;};/**
	* Quickly set a property on a single child of this group to a new value.
	*
	* The operation parameter controls how the new value is assigned to the property, from simple replacement to addition and multiplication.
	*
	* @method Phaser.Group#set
	* @param {Phaser.Sprite} child - The child to set the property on.
	* @param {string} key - The property, as a string, to be set. For example: 'body.velocity.x'
	* @param {any} value - The value that will be set.
	* @param {boolean} [checkAlive=false] - If set then the child will only be updated if alive=true.
	* @param {boolean} [checkVisible=false] - If set then the child will only be updated if visible=true.
	* @param {integer} [operation=0] - Controls how the value is assigned. A value of 0 replaces the value with the new one. A value of 1 adds it, 2 subtracts it, 3 multiplies it and 4 divides it.
	* @param {boolean} [force=false] - If `force` is true then the property will be set on the child regardless if it already exists or not. If false and the property doesn't exist, nothing will be set.
	* @return {boolean} True if the property was set, false if not.
	*/Phaser.Group.prototype.set=function(child,key,value,checkAlive,checkVisible,operation,force){if(force===undefined){force=false;}key=key.split('.');if(checkAlive===undefined){checkAlive=false;}if(checkVisible===undefined){checkVisible=false;}if((checkAlive===false||checkAlive&&child.alive)&&(checkVisible===false||checkVisible&&child.visible)){return this.setProperty(child,key,value,operation,force);}};/**
	* Quickly set the same property across all children of this group to a new value.
	*
	* This call doesn't descend down children, so if you have a Group inside of this group, the property will be set on the group but not its children.
	* If you need that ability please see `Group.setAllChildren`.
	*
	* The operation parameter controls how the new value is assigned to the property, from simple replacement to addition and multiplication.
	*
	* @method Phaser.Group#setAll
	* @param {string} key - The property, as a string, to be set. For example: 'body.velocity.x'
	* @param {any} value - The value that will be set.
	* @param {boolean} [checkAlive=false] - If set then only children with alive=true will be updated. This includes any Groups that are children.
	* @param {boolean} [checkVisible=false] - If set then only children with visible=true will be updated. This includes any Groups that are children.
	* @param {integer} [operation=0] - Controls how the value is assigned. A value of 0 replaces the value with the new one. A value of 1 adds it, 2 subtracts it, 3 multiplies it and 4 divides it.
	* @param {boolean} [force=false] - If `force` is true then the property will be set on the child regardless if it already exists or not. If false and the property doesn't exist, nothing will be set.
	*/Phaser.Group.prototype.setAll=function(key,value,checkAlive,checkVisible,operation,force){if(checkAlive===undefined){checkAlive=false;}if(checkVisible===undefined){checkVisible=false;}if(force===undefined){force=false;}key=key.split('.');operation=operation||0;for(var i=0;i<this.children.length;i++){if((!checkAlive||checkAlive&&this.children[i].alive)&&(!checkVisible||checkVisible&&this.children[i].visible)){this.setProperty(this.children[i],key,value,operation,force);}}};/**
	* Quickly set the same property across all children of this group, and any child Groups, to a new value.
	*
	* If this group contains other Groups then the same property is set across their children as well, iterating down until it reaches the bottom.
	* Unlike with `setAll` the property is NOT set on child Groups itself.
	*
	* The operation parameter controls how the new value is assigned to the property, from simple replacement to addition and multiplication.
	*
	* @method Phaser.Group#setAllChildren
	* @param {string} key - The property, as a string, to be set. For example: 'body.velocity.x'
	* @param {any} value - The value that will be set.
	* @param {boolean} [checkAlive=false] - If set then only children with alive=true will be updated. This includes any Groups that are children.
	* @param {boolean} [checkVisible=false] - If set then only children with visible=true will be updated. This includes any Groups that are children.
	* @param {integer} [operation=0] - Controls how the value is assigned. A value of 0 replaces the value with the new one. A value of 1 adds it, 2 subtracts it, 3 multiplies it and 4 divides it.
	* @param {boolean} [force=false] - If `force` is true then the property will be set on the child regardless if it already exists or not. If false and the property doesn't exist, nothing will be set.
	*/Phaser.Group.prototype.setAllChildren=function(key,value,checkAlive,checkVisible,operation,force){if(checkAlive===undefined){checkAlive=false;}if(checkVisible===undefined){checkVisible=false;}if(force===undefined){force=false;}operation=operation||0;for(var i=0;i<this.children.length;i++){if((!checkAlive||checkAlive&&this.children[i].alive)&&(!checkVisible||checkVisible&&this.children[i].visible)){if(this.children[i]instanceof Phaser.Group){this.children[i].setAllChildren(key,value,checkAlive,checkVisible,operation,force);}else{this.setProperty(this.children[i],key.split('.'),value,operation,force);}}}};/**
	* Quickly check that the same property across all children of this group is equal to the given value.
	*
	* This call doesn't descend down children, so if you have a Group inside of this group, the property will be checked on the group but not its children.
	*
	* @method Phaser.Group#checkAll
	* @param {string} key - The property, as a string, to be set. For example: 'body.velocity.x'
	* @param {any} value - The value that will be checked.
	* @param {boolean} [checkAlive=false] - If set then only children with alive=true will be checked. This includes any Groups that are children.
	* @param {boolean} [checkVisible=false] - If set then only children with visible=true will be checked. This includes any Groups that are children.
	* @param {boolean} [force=false] - If `force` is true then the property will be checked on the child regardless if it already exists or not. If true and the property doesn't exist, false will be returned.
	*/Phaser.Group.prototype.checkAll=function(key,value,checkAlive,checkVisible,force){if(checkAlive===undefined){checkAlive=false;}if(checkVisible===undefined){checkVisible=false;}if(force===undefined){force=false;}for(var i=0;i<this.children.length;i++){if((!checkAlive||checkAlive&&this.children[i].alive)&&(!checkVisible||checkVisible&&this.children[i].visible)){if(!this.checkProperty(this.children[i],key,value,force)){return false;}}}return true;};/**
	* Adds the amount to the given property on all children in this group.
	*
	* `Group.addAll('x', 10)` will add 10 to the child.x value for each child.
	*
	* @method Phaser.Group#addAll
	* @param {string} property - The property to increment, for example 'body.velocity.x' or 'angle'.
	* @param {number} amount - The amount to increment the property by. If child.x = 10 then addAll('x', 40) would make child.x = 50.
	* @param {boolean} checkAlive - If true the property will only be changed if the child is alive.
	* @param {boolean} checkVisible - If true the property will only be changed if the child is visible.
	*/Phaser.Group.prototype.addAll=function(property,amount,checkAlive,checkVisible){this.setAll(property,amount,checkAlive,checkVisible,1);};/**
	* Subtracts the amount from the given property on all children in this group.
	*
	* `Group.subAll('x', 10)` will minus 10 from the child.x value for each child.
	*
	* @method Phaser.Group#subAll
	* @param {string} property - The property to decrement, for example 'body.velocity.x' or 'angle'.
	* @param {number} amount - The amount to subtract from the property. If child.x = 50 then subAll('x', 40) would make child.x = 10.
	* @param {boolean} checkAlive - If true the property will only be changed if the child is alive.
	* @param {boolean} checkVisible - If true the property will only be changed if the child is visible.
	*/Phaser.Group.prototype.subAll=function(property,amount,checkAlive,checkVisible){this.setAll(property,amount,checkAlive,checkVisible,2);};/**
	* Multiplies the given property by the amount on all children in this group.
	*
	* `Group.multiplyAll('x', 2)` will x2 the child.x value for each child.
	*
	* @method Phaser.Group#multiplyAll
	* @param {string} property - The property to multiply, for example 'body.velocity.x' or 'angle'.
	* @param {number} amount - The amount to multiply the property by. If child.x = 10 then multiplyAll('x', 2) would make child.x = 20.
	* @param {boolean} checkAlive - If true the property will only be changed if the child is alive.
	* @param {boolean} checkVisible - If true the property will only be changed if the child is visible.
	*/Phaser.Group.prototype.multiplyAll=function(property,amount,checkAlive,checkVisible){this.setAll(property,amount,checkAlive,checkVisible,3);};/**
	* Divides the given property by the amount on all children in this group.
	*
	* `Group.divideAll('x', 2)` will half the child.x value for each child.
	*
	* @method Phaser.Group#divideAll
	* @param {string} property - The property to divide, for example 'body.velocity.x' or 'angle'.
	* @param {number} amount - The amount to divide the property by. If child.x = 100 then divideAll('x', 2) would make child.x = 50.
	* @param {boolean} checkAlive - If true the property will only be changed if the child is alive.
	* @param {boolean} checkVisible - If true the property will only be changed if the child is visible.
	*/Phaser.Group.prototype.divideAll=function(property,amount,checkAlive,checkVisible){this.setAll(property,amount,checkAlive,checkVisible,4);};/**
	* Calls a function, specified by name, on all children in the group who exist (or do not exist).
	*
	* After the existsValue parameter you can add as many parameters as you like, which will all be passed to the child callback.
	*
	* @method Phaser.Group#callAllExists
	* @param {string} callback - Name of the function on the children to call.
	* @param {boolean} existsValue - Only children with exists=existsValue will be called.
	* @param {...any} parameter - Additional parameters that will be passed to the callback.
	*/Phaser.Group.prototype.callAllExists=function(callback,existsValue){var args;if(arguments.length>2){args=[];for(var i=2;i<arguments.length;i++){args.push(arguments[i]);}}for(var i=0;i<this.children.length;i++){if(this.children[i].exists===existsValue&&this.children[i][callback]){this.children[i][callback].apply(this.children[i],args);}}};/**
	* Returns a reference to a function that exists on a child of the group based on the given callback array.
	*
	* @method Phaser.Group#callbackFromArray
	* @param {object} child - The object to inspect.
	* @param {array} callback - The array of function names.
	* @param {integer} length - The size of the array (pre-calculated in callAll).
	* @protected
	*/Phaser.Group.prototype.callbackFromArray=function(child,callback,length){//  Kinda looks like a Christmas tree
	if(length===1){if(child[callback[0]]){return child[callback[0]];}}else if(length===2){if(child[callback[0]][callback[1]]){return child[callback[0]][callback[1]];}}else if(length===3){if(child[callback[0]][callback[1]][callback[2]]){return child[callback[0]][callback[1]][callback[2]];}}else if(length===4){if(child[callback[0]][callback[1]][callback[2]][callback[3]]){return child[callback[0]][callback[1]][callback[2]][callback[3]];}}else if(child[callback]){return child[callback];}return false;};/**
	* Calls a function, specified by name, on all on children.
	*
	* The function is called for all children regardless if they are dead or alive (see callAllExists for different options).
	* After the method parameter and context you can add as many extra parameters as you like, which will all be passed to the child.
	*
	* @method Phaser.Group#callAll
	* @param {string} method - Name of the function on the child to call. Deep property lookup is supported.
	* @param {string} [context=null] - A string containing the context under which the method will be executed. Set to null to default to the child.
	* @param {...any} args - Additional parameters that will be passed to the method.
	*/Phaser.Group.prototype.callAll=function(method,context){if(method===undefined){return;}//  Extract the method into an array
	method=method.split('.');var methodLength=method.length;if(context===undefined||context===null||context===''){context=null;}else{//  Extract the context into an array
	if(typeof context==='string'){context=context.split('.');var contextLength=context.length;}}var args;if(arguments.length>2){args=[];for(var i=2;i<arguments.length;i++){args.push(arguments[i]);}}var callback=null;var callbackContext=null;for(var i=0;i<this.children.length;i++){callback=this.callbackFromArray(this.children[i],method,methodLength);if(context&&callback){callbackContext=this.callbackFromArray(this.children[i],context,contextLength);if(callback){callback.apply(callbackContext,args);}}else if(callback){callback.apply(this.children[i],args);}}};/**
	* The core preUpdate - as called by World.
	* @method Phaser.Group#preUpdate
	* @protected
	*/Phaser.Group.prototype.preUpdate=function(){if(this.pendingDestroy){this.destroy();return false;}if(!this.exists||!this.parent.exists){this.renderOrderID=-1;return false;}for(var i=0;i<this.children.length;i++){this.children[i].preUpdate();}return true;};/**
	* The core update - as called by World.
	* @method Phaser.Group#update
	* @protected
	*/Phaser.Group.prototype.update=function(){//  Goes in reverse, because it's highly likely the child will destroy itself in `update`
	var i=this.children.length;while(i--){this.children[i].update();}};/**
	* The core postUpdate - as called by World.
	* @method Phaser.Group#postUpdate
	* @protected
	*/Phaser.Group.prototype.postUpdate=function(){//  Fixed to Camera?
	if(this.fixedToCamera){this.x=this.game.camera.view.x+this.cameraOffset.x;this.y=this.game.camera.view.y+this.cameraOffset.y;}for(var i=0;i<this.children.length;i++){this.children[i].postUpdate();}};/**
	* Find children matching a certain predicate.
	*
	* For example:
	*
	*     var healthyList = Group.filter(function(child, index, children) {
	*         return child.health > 10 ? true : false;
	*     }, true);
	*     healthyList.callAll('attack');
	*
	* Note: Currently this will skip any children which are Groups themselves.
	*
	* @method Phaser.Group#filter
	* @param {function} predicate - The function that each child will be evaluated against. Each child of the group will be passed to it as its first parameter, the index as the second, and the entire child array as the third
	* @param {boolean} [checkExists=false] - If true, only existing can be selected; otherwise all children can be selected and will be passed to the predicate.
	* @return {Phaser.ArraySet} Returns an array list containing all the children that the predicate returned true for
	*/Phaser.Group.prototype.filter=function(predicate,checkExists){var index=-1;var length=this.children.length;var results=[];while(++index<length){var child=this.children[index];if(!checkExists||checkExists&&child.exists){if(predicate(child,index,this.children)){results.push(child);}}}return new Phaser.ArraySet(results);};/**
	* Call a function on each child in this group.
	*
	* Additional arguments for the callback can be specified after the `checkExists` parameter. For example,
	*
	*     Group.forEach(awardBonusGold, this, true, 100, 500)
	*
	* would invoke `awardBonusGold` function with the parameters `(child, 100, 500)`.
	*
	* Note: This check will skip any children which are Groups themselves.
	*
	* @method Phaser.Group#forEach
	* @param {function} callback - The function that will be called for each applicable child. The child will be passed as the first argument.
	* @param {object} callbackContext - The context in which the function should be called (usually 'this').
	* @param {boolean} [checkExists=false] - If set only children matching for which `exists` is true will be passed to the callback, otherwise all children will be passed.
	* @param {...any} [args=(none)] - Additional arguments to pass to the callback function, after the child item.
	*/Phaser.Group.prototype.forEach=function(callback,callbackContext,checkExists){if(checkExists===undefined){checkExists=false;}if(arguments.length<=3){for(var i=0;i<this.children.length;i++){if(!checkExists||checkExists&&this.children[i].exists){callback.call(callbackContext,this.children[i]);}}}else{// Assigning to arguments properties causes Extreme Deoptimization in Chrome, FF, and IE.
	// Using an array and pushing each element (not a slice!) is _significantly_ faster.
	var args=[null];for(var i=3;i<arguments.length;i++){args.push(arguments[i]);}for(var i=0;i<this.children.length;i++){if(!checkExists||checkExists&&this.children[i].exists){args[0]=this.children[i];callback.apply(callbackContext,args);}}}};/**
	* Call a function on each existing child in this group.
	*
	* See {@link Phaser.Group#forEach forEach} for details.
	*
	* @method Phaser.Group#forEachExists
	* @param {function} callback - The function that will be called for each applicable child. The child will be passed as the first argument.
	* @param {object} callbackContext - The context in which the function should be called (usually 'this').
	* @param {...any} [args=(none)] - Additional arguments to pass to the callback function, after the child item.
	*/Phaser.Group.prototype.forEachExists=function(callback,callbackContext){var args;if(arguments.length>2){args=[null];for(var i=2;i<arguments.length;i++){args.push(arguments[i]);}}this.iterate('exists',true,Phaser.Group.RETURN_TOTAL,callback,callbackContext,args);};/**
	* Call a function on each alive child in this group.
	*
	* See {@link Phaser.Group#forEach forEach} for details.
	*
	* @method Phaser.Group#forEachAlive
	* @param {function} callback - The function that will be called for each applicable child. The child will be passed as the first argument.
	* @param {object} callbackContext - The context in which the function should be called (usually 'this').
	* @param {...any} [args=(none)] - Additional arguments to pass to the callback function, after the child item.
	*/Phaser.Group.prototype.forEachAlive=function(callback,callbackContext){var args;if(arguments.length>2){args=[null];for(var i=2;i<arguments.length;i++){args.push(arguments[i]);}}this.iterate('alive',true,Phaser.Group.RETURN_TOTAL,callback,callbackContext,args);};/**
	* Call a function on each dead child in this group.
	*
	* See {@link Phaser.Group#forEach forEach} for details.
	*
	* @method Phaser.Group#forEachDead
	* @param {function} callback - The function that will be called for each applicable child. The child will be passed as the first argument.
	* @param {object} callbackContext - The context in which the function should be called (usually 'this').
	* @param {...any} [args=(none)] - Additional arguments to pass to the callback function, after the child item.
	*/Phaser.Group.prototype.forEachDead=function(callback,callbackContext){var args;if(arguments.length>2){args=[null];for(var i=2;i<arguments.length;i++){args.push(arguments[i]);}}this.iterate('alive',false,Phaser.Group.RETURN_TOTAL,callback,callbackContext,args);};/**
	* Sort the children in the group according to a particular key and ordering.
	*
	* Call this function to sort the group according to a particular key value and order.
	* 
	* For example to depth sort Sprites for Zelda-style game you might call `group.sort('y', Phaser.Group.SORT_ASCENDING)` at the bottom of your `State.update()`.
	*
	* Internally this uses a standard JavaScript Array sort, so everything that applies there also applies here, including
	* alphabetical sorting, mixing strings and numbers, and Unicode sorting. See MDN for more details.
	*
	* @method Phaser.Group#sort
	* @param {string} [key='z'] - The name of the property to sort on. Defaults to the objects z-depth value.
	* @param {integer} [order=Phaser.Group.SORT_ASCENDING] - Order ascending ({@link Phaser.Group.SORT_ASCENDING SORT_ASCENDING}) or descending ({@link Phaser.Group.SORT_DESCENDING SORT_DESCENDING}).
	*/Phaser.Group.prototype.sort=function(key,order){if(this.children.length<2){//  Nothing to swap
	return;}if(key===undefined){key='z';}if(order===undefined){order=Phaser.Group.SORT_ASCENDING;}this._sortProperty=key;if(order===Phaser.Group.SORT_ASCENDING){this.children.sort(this.ascendingSortHandler.bind(this));}else{this.children.sort(this.descendingSortHandler.bind(this));}this.updateZ();};/**
	* Sort the children in the group according to custom sort function.
	*
	* The `sortHandler` is provided the two parameters: the two children involved in the comparison (a and b).
	* It should return -1 if `a > b`, 1 if `a < b` or 0 if `a === b`.
	*
	* @method Phaser.Group#customSort
	* @param {function} sortHandler - The custom sort function.
	* @param {object} [context=undefined] - The context in which the sortHandler is called.
	*/Phaser.Group.prototype.customSort=function(sortHandler,context){if(this.children.length<2){//  Nothing to swap
	return;}this.children.sort(sortHandler.bind(context));this.updateZ();};/**
	* An internal helper function for the sort process.
	*
	* @method Phaser.Group#ascendingSortHandler
	* @protected
	* @param {object} a - The first object being sorted.
	* @param {object} b - The second object being sorted.
	*/Phaser.Group.prototype.ascendingSortHandler=function(a,b){if(a[this._sortProperty]<b[this._sortProperty]){return-1;}else if(a[this._sortProperty]>b[this._sortProperty]){return 1;}else{if(a.z<b.z){return-1;}else{return 1;}}};/**
	* An internal helper function for the sort process.
	*
	* @method Phaser.Group#descendingSortHandler
	* @protected
	* @param {object} a - The first object being sorted.
	* @param {object} b - The second object being sorted.
	*/Phaser.Group.prototype.descendingSortHandler=function(a,b){if(a[this._sortProperty]<b[this._sortProperty]){return 1;}else if(a[this._sortProperty]>b[this._sortProperty]){return-1;}else{return 0;}};/**
	* Iterates over the children of the group performing one of several actions for matched children.
	*
	* A child is considered a match when it has a property, named `key`, whose value is equal to `value`
	* according to a strict equality comparison.
	*
	* The result depends on the `returnType`:
	*
	* - {@link Phaser.Group.RETURN_TOTAL RETURN_TOTAL}:
	*     The callback, if any, is applied to all matching children. The number of matched children is returned.
	* - {@link Phaser.Group.RETURN_NONE RETURN_NONE}:
	*     The callback, if any, is applied to all matching children. No value is returned.
	* - {@link Phaser.Group.RETURN_CHILD RETURN_CHILD}:
	*     The callback, if any, is applied to the *first* matching child and the *first* matched child is returned.
	*     If there is no matching child then null is returned.
	*
	* If `args` is specified it must be an array. The matched child will be assigned to the first
	* element and the entire array will be applied to the callback function.
	*
	* @method Phaser.Group#iterate
	* @param {string} key - The child property to check, i.e. 'exists', 'alive', 'health'
	* @param {any} value - A child matches if `child[key] === value` is true.
	* @param {integer} returnType - How to iterate the children and what to return.
	* @param {function} [callback=null] - Optional function that will be called on each matching child. The matched child is supplied as the first argument.
	* @param {object} [callbackContext] - The context in which the function should be called (usually 'this').
	* @param {any[]} [args=(none)] - The arguments supplied to to the callback; the first array index (argument) will be replaced with the matched child.
	* @return {any} Returns either an integer (for RETURN_TOTAL), the first matched child (for RETURN_CHILD), or null.
	*/Phaser.Group.prototype.iterate=function(key,value,returnType,callback,callbackContext,args){if(this.children.length===0){if(returnType===Phaser.Group.RETURN_TOTAL){return 0;}else if(returnType===Phaser.Group.RETURN_ALL){return[];}}var total=0;if(returnType===Phaser.Group.RETURN_ALL){var output=[];}for(var i=0;i<this.children.length;i++){if(this.children[i][key]===value){total++;if(callback){if(args){args[0]=this.children[i];callback.apply(callbackContext,args);}else{callback.call(callbackContext,this.children[i]);}}if(returnType===Phaser.Group.RETURN_CHILD){return this.children[i];}else if(returnType===Phaser.Group.RETURN_ALL){output.push(this.children[i]);}}}if(returnType===Phaser.Group.RETURN_TOTAL){return total;}else if(returnType===Phaser.Group.RETURN_ALL){return output;}else{//  RETURN_CHILD or RETURN_NONE
	return null;}};/**
	* Get the first display object that exists, or doesn't exist.
	* 
	* You can use the optional argument `createIfNull` to create a new Game Object if none matching your exists argument were found in this Group.
	*
	* It works by calling `Group.create` passing it the parameters given to this method, and returning the new child.
	*
	* If a child *was* found , `createIfNull` is `false` and you provided the additional arguments then the child
	* will be reset and/or have a new texture loaded on it. This is handled by `Group.resetChild`.
	*
	* @method Phaser.Group#getFirstExists
	* @param {boolean} [exists=true] - If true, find the first existing child; otherwise find the first non-existing child.
	* @param {boolean} [createIfNull=false] - If `true` and no alive children are found a new one is created.
	* @param {number} [x] - The x coordinate to reset the child to. The value is in relation to the group.x point.
	* @param {number} [y] - The y coordinate to reset the child to. The value is in relation to the group.y point.
	* @param {string|Phaser.RenderTexture|Phaser.BitmapData|Phaser.Video|PIXI.Texture} [key] - This is the image or texture used by the Sprite during rendering. It can be a string which is a reference to the Cache Image entry, or an instance of a RenderTexture, BitmapData, Video or PIXI.Texture.
	* @param {string|number} [frame] - If this Sprite is using part of a sprite sheet or texture atlas you can specify the exact frame to use by giving a string or numeric index.
	* @return {DisplayObject} The first child, or `null` if none found and `createIfNull` was false.
	*/Phaser.Group.prototype.getFirstExists=function(exists,createIfNull,x,y,key,frame){if(createIfNull===undefined){createIfNull=false;}if(typeof exists!=='boolean'){exists=true;}var child=this.iterate('exists',exists,Phaser.Group.RETURN_CHILD);return child===null&&createIfNull?this.create(x,y,key,frame):this.resetChild(child,x,y,key,frame);};/**
	* Get the first child that is alive (`child.alive === true`).
	*
	* This is handy for choosing a squad leader, etc.
	*
	* You can use the optional argument `createIfNull` to create a new Game Object if no alive ones were found in this Group.
	*
	* It works by calling `Group.create` passing it the parameters given to this method, and returning the new child.
	*
	* If a child *was* found , `createIfNull` is `false` and you provided the additional arguments then the child
	* will be reset and/or have a new texture loaded on it. This is handled by `Group.resetChild`.
	*
	* @method Phaser.Group#getFirstAlive
	* @param {boolean} [createIfNull=false] - If `true` and no alive children are found a new one is created.
	* @param {number} [x] - The x coordinate to reset the child to. The value is in relation to the group.x point.
	* @param {number} [y] - The y coordinate to reset the child to. The value is in relation to the group.y point.
	* @param {string|Phaser.RenderTexture|Phaser.BitmapData|Phaser.Video|PIXI.Texture} [key] - This is the image or texture used by the Sprite during rendering. It can be a string which is a reference to the Cache Image entry, or an instance of a RenderTexture, BitmapData, Video or PIXI.Texture.
	* @param {string|number} [frame] - If this Sprite is using part of a sprite sheet or texture atlas you can specify the exact frame to use by giving a string or numeric index.
	* @return {DisplayObject} The alive dead child, or `null` if none found and `createIfNull` was false.
	*/Phaser.Group.prototype.getFirstAlive=function(createIfNull,x,y,key,frame){if(createIfNull===undefined){createIfNull=false;}var child=this.iterate('alive',true,Phaser.Group.RETURN_CHILD);return child===null&&createIfNull?this.create(x,y,key,frame):this.resetChild(child,x,y,key,frame);};/**
	* Get the first child that is dead (`child.alive === false`).
	*
	* This is handy for checking if everything has been wiped out and adding to the pool as needed.
	*
	* You can use the optional argument `createIfNull` to create a new Game Object if no dead ones were found in this Group.
	*
	* It works by calling `Group.create` passing it the parameters given to this method, and returning the new child.
	*
	* If a child *was* found , `createIfNull` is `false` and you provided the additional arguments then the child
	* will be reset and/or have a new texture loaded on it. This is handled by `Group.resetChild`.
	*
	* @method Phaser.Group#getFirstDead
	* @param {boolean} [createIfNull=false] - If `true` and no dead children are found a new one is created.
	* @param {number} [x] - The x coordinate to reset the child to. The value is in relation to the group.x point.
	* @param {number} [y] - The y coordinate to reset the child to. The value is in relation to the group.y point.
	* @param {string|Phaser.RenderTexture|Phaser.BitmapData|Phaser.Video|PIXI.Texture} [key] - This is the image or texture used by the Sprite during rendering. It can be a string which is a reference to the Cache Image entry, or an instance of a RenderTexture, BitmapData, Video or PIXI.Texture.
	* @param {string|number} [frame] - If this Sprite is using part of a sprite sheet or texture atlas you can specify the exact frame to use by giving a string or numeric index.
	* @return {DisplayObject} The first dead child, or `null` if none found and `createIfNull` was false.
	*/Phaser.Group.prototype.getFirstDead=function(createIfNull,x,y,key,frame){if(createIfNull===undefined){createIfNull=false;}var child=this.iterate('alive',false,Phaser.Group.RETURN_CHILD);return child===null&&createIfNull?this.create(x,y,key,frame):this.resetChild(child,x,y,key,frame);};/**
	* Takes a child and if the `x` and `y` arguments are given it calls `child.reset(x, y)` on it.
	*
	* If the `key` and optionally the `frame` arguments are given, it calls `child.loadTexture(key, frame)` on it.
	*
	* The two operations are separate. For example if you just wish to load a new texture then pass `null` as the x and y values.
	*
	* @method Phaser.Group#resetChild
	* @param {DisplayObject} child - The child to reset and/or load the texture on.
	* @param {number} [x] - The x coordinate to reset the child to. The value is in relation to the group.x point.
	* @param {number} [y] - The y coordinate to reset the child to. The value is in relation to the group.y point.
	* @param {string|Phaser.RenderTexture|Phaser.BitmapData|Phaser.Video|PIXI.Texture} [key] - This is the image or texture used by the Sprite during rendering. It can be a string which is a reference to the Cache Image entry, or an instance of a RenderTexture, BitmapData, Video or PIXI.Texture.
	* @param {string|number} [frame] - If this Sprite is using part of a sprite sheet or texture atlas you can specify the exact frame to use by giving a string or numeric index.
	* @return {DisplayObject} The child that was reset: usually a {@link Phaser.Sprite}.
	*/Phaser.Group.prototype.resetChild=function(child,x,y,key,frame){if(child===null){return null;}if(x===undefined){x=null;}if(y===undefined){y=null;}if(x!==null&&y!==null){child.reset(x,y);}if(key!==undefined){child.loadTexture(key,frame);}return child;};/**
	* Return the child at the top of this group.
	*
	* The top child is the child displayed (rendered) above every other child.
	*
	* @method Phaser.Group#getTop
	* @return {any} The child at the top of the Group.
	*/Phaser.Group.prototype.getTop=function(){if(this.children.length>0){return this.children[this.children.length-1];}};/**
	* Returns the child at the bottom of this group.
	*
	* The bottom child the child being displayed (rendered) below every other child.
	*
	* @method Phaser.Group#getBottom
	* @return {any} The child at the bottom of the Group.
	*/Phaser.Group.prototype.getBottom=function(){if(this.children.length>0){return this.children[0];}};/**
	* Get the closest child to given Object, with optional callback to filter children.
	*
	* This can be a Sprite, Group, Image or any object with public x and y properties.
	*
	* 'close' is determined by the distance from the objects `x` and `y` properties compared to the childs `x` and `y` properties.
	*
	* You can use the optional `callback` argument to apply your own filter to the distance checks.
	* If the child is closer then the previous child, it will be sent to `callback` as the first argument,
	* with the distance as the second. The callback should return `true` if it passes your 
	* filtering criteria, otherwise it should return `false`.
	*
	* @method Phaser.Group#getClosestTo
	* @param {any} object - The object used to determine the distance. This can be a Sprite, Group, Image or any object with public x and y properties.
	* @param {function} [callback] - The function that each child will be evaluated against. Each child of the group will be passed to it as its first parameter, with the distance as the second. It should return `true` if the child passes the matching criteria.
	* @param {object} [callbackContext] - The context in which the function should be called (usually 'this').
	* @return {any} The child closest to given object, or `null` if no child was found.
	*/Phaser.Group.prototype.getClosestTo=function(object,callback,callbackContext){var distance=Number.MAX_VALUE;var tempDistance=0;var result=null;for(var i=0;i<this.children.length;i++){var child=this.children[i];if(child.exists){tempDistance=Math.abs(Phaser.Point.distance(object,child));if(tempDistance<distance&&(!callback||callback.call(callbackContext,child,tempDistance))){distance=tempDistance;result=child;}}}return result;};/**
	* Get the child furthest away from the given Object, with optional callback to filter children.
	*
	* This can be a Sprite, Group, Image or any object with public x and y properties.
	*
	* 'furthest away' is determined by the distance from the objects `x` and `y` properties compared to the childs `x` and `y` properties.
	*
	* You can use the optional `callback` argument to apply your own filter to the distance checks.
	* If the child is closer then the previous child, it will be sent to `callback` as the first argument,
	* with the distance as the second. The callback should return `true` if it passes your 
	* filtering criteria, otherwise it should return `false`.
	*
	* @method Phaser.Group#getFurthestFrom
	* @param {any} object - The object used to determine the distance. This can be a Sprite, Group, Image or any object with public x and y properties.
	* @param {function} [callback] - The function that each child will be evaluated against. Each child of the group will be passed to it as its first parameter, with the distance as the second. It should return `true` if the child passes the matching criteria.
	* @param {object} [callbackContext] - The context in which the function should be called (usually 'this').
	* @return {any} The child furthest from the given object, or `null` if no child was found.
	*/Phaser.Group.prototype.getFurthestFrom=function(object,callback,callbackContext){var distance=0;var tempDistance=0;var result=null;for(var i=0;i<this.children.length;i++){var child=this.children[i];if(child.exists){tempDistance=Math.abs(Phaser.Point.distance(object,child));if(tempDistance>distance&&(!callback||callback.call(callbackContext,child,tempDistance))){distance=tempDistance;result=child;}}}return result;};/**
	* Get the number of living children in this group.
	*
	* @method Phaser.Group#countLiving
	* @return {integer} The number of children flagged as alive.
	*/Phaser.Group.prototype.countLiving=function(){return this.iterate('alive',true,Phaser.Group.RETURN_TOTAL);};/**
	* Get the number of dead children in this group.
	*
	* @method Phaser.Group#countDead
	* @return {integer} The number of children flagged as dead.
	*/Phaser.Group.prototype.countDead=function(){return this.iterate('alive',false,Phaser.Group.RETURN_TOTAL);};/**
	* Returns a random child from the group.
	*
	* @method Phaser.Group#getRandom
	* @param {integer} [startIndex=0] - Offset from the front of the group (lowest child).
	* @param {integer} [length=(to top)] - Restriction on the number of values you want to randomly select from.
	* @return {any} A random child of this Group.
	*/Phaser.Group.prototype.getRandom=function(startIndex,length){if(startIndex===undefined){startIndex=0;}if(length===undefined){length=this.children.length;}if(length===0){return null;}return Phaser.ArrayUtils.getRandomItem(this.children,startIndex,length);};/**
	* Returns a random child from the Group that has `exists` set to `true`.
	*
	* Optionally you can specify a start and end index. For example if this Group had 100 children,
	* and you set `startIndex` to 0 and `endIndex` to 50, it would return a random child from only
	* the first 50 children in the Group.
	*
	* @method Phaser.Group#getRandomExists
	* @param {integer} [startIndex=0] - The first child index to start the search from.
	* @param {integer} [endIndex] - The last child index to search up to.
	* @return {any} A random child of this Group that exists.
	*/Phaser.Group.prototype.getRandomExists=function(startIndex,endIndex){var list=this.getAll('exists',true,startIndex,endIndex);return this.game.rnd.pick(list);};/**
	* Returns all children in this Group.
	*
	* You can optionally specify a matching criteria using the `property` and `value` arguments.
	*
	* For example: `getAll('exists', true)` would return only children that have their exists property set.
	*
	* Optionally you can specify a start and end index. For example if this Group had 100 children,
	* and you set `startIndex` to 0 and `endIndex` to 50, it would return a random child from only
	* the first 50 children in the Group.
	*
	* @method Phaser.Group#getAll
	* @param {string} [property] - An optional property to test against the value argument.
	* @param {any} [value] - If property is set then Child.property must strictly equal this value to be included in the results.
	* @param {integer} [startIndex=0] - The first child index to start the search from.
	* @param {integer} [endIndex] - The last child index to search up until.
	* @return {any} A random existing child of this Group.
	*/Phaser.Group.prototype.getAll=function(property,value,startIndex,endIndex){if(startIndex===undefined){startIndex=0;}if(endIndex===undefined){endIndex=this.children.length;}var output=[];for(var i=startIndex;i<endIndex;i++){var child=this.children[i];if(property&&child[property]===value){output.push(child);}}return output;};/**
	* Removes the given child from this group.
	*
	* This will dispatch an `onRemovedFromGroup` event from the child (if it has one), and optionally destroy the child.
	*
	* If the group cursor was referring to the removed child it is updated to refer to the next child.
	*
	* @method Phaser.Group#remove
	* @param {any} child - The child to remove.
	* @param {boolean} [destroy=false] - If true `destroy` will be invoked on the removed child.
	* @param {boolean} [silent=false] - If true the the child will not dispatch the `onRemovedFromGroup` event.
	* @return {boolean} true if the child was removed from this group, otherwise false.
	*/Phaser.Group.prototype.remove=function(child,destroy,silent){if(destroy===undefined){destroy=false;}if(silent===undefined){silent=false;}if(this.children.length===0||this.children.indexOf(child)===-1){return false;}if(!silent&&child.events&&!child.destroyPhase){child.events.onRemovedFromGroup$dispatch(child,this);}var removed=this.removeChild(child);this.removeFromHash(child);this.updateZ();if(this.cursor===child){this.next();}if(destroy&&removed){removed.destroy(true);}return true;};/**
	* Moves all children from this Group to the Group given.
	*
	* @method Phaser.Group#moveAll
	* @param {Phaser.Group} group - The new Group to which the children will be moved to.
	* @param {boolean} [silent=false] - If true the children will not dispatch the `onAddedToGroup` event for the new Group.
	* @return {Phaser.Group} The Group to which all the children were moved.
	*/Phaser.Group.prototype.moveAll=function(group,silent){if(silent===undefined){silent=false;}if(this.children.length>0&&group instanceof Phaser.Group){do{group.add(this.children[0],silent);}while(this.children.length>0);this.hash=[];this.cursor=null;}return group;};/**
	* Removes all children from this Group, but does not remove the group from its parent.
	*
	* The children can be optionally destroyed as they are removed.
	* 
	* You can also optionally also destroy the BaseTexture the Child is using. Be careful if you've
	* more than one Game Object sharing the same BaseTexture.
	*
	* @method Phaser.Group#removeAll
	* @param {boolean} [destroy=false] - If true `destroy` will be invoked on each removed child.
	* @param {boolean} [silent=false] - If true the children will not dispatch their `onRemovedFromGroup` events.
	* @param {boolean} [destroyTexture=false] - If true, and if the `destroy` argument is also true, the BaseTexture belonging to the Child is also destroyed. Note that if another Game Object is sharing the same BaseTexture it will invalidate it.
	*/Phaser.Group.prototype.removeAll=function(destroy,silent,destroyTexture){if(destroy===undefined){destroy=false;}if(silent===undefined){silent=false;}if(destroyTexture===undefined){destroyTexture=false;}if(this.children.length===0){return;}do{if(!silent&&this.children[0].events){this.children[0].events.onRemovedFromGroup$dispatch(this.children[0],this);}var removed=this.removeChild(this.children[0]);this.removeFromHash(removed);if(destroy&&removed){removed.destroy(true,destroyTexture);}}while(this.children.length>0);this.hash=[];this.cursor=null;};/**
	* Removes all children from this group whose index falls beteen the given startIndex and endIndex values.
	*
	* @method Phaser.Group#removeBetween
	* @param {integer} startIndex - The index to start removing children from.
	* @param {integer} [endIndex] - The index to stop removing children at. Must be higher than startIndex. If undefined this method will remove all children between startIndex and the end of the group.
	* @param {boolean} [destroy=false] - If true `destroy` will be invoked on each removed child.
	* @param {boolean} [silent=false] - If true the children will not dispatch their `onRemovedFromGroup` events.
	*/Phaser.Group.prototype.removeBetween=function(startIndex,endIndex,destroy,silent){if(endIndex===undefined){endIndex=this.children.length-1;}if(destroy===undefined){destroy=false;}if(silent===undefined){silent=false;}if(this.children.length===0){return;}if(startIndex>endIndex||startIndex<0||endIndex>this.children.length){return false;}var i=endIndex;while(i>=startIndex){if(!silent&&this.children[i].events){this.children[i].events.onRemovedFromGroup$dispatch(this.children[i],this);}var removed=this.removeChild(this.children[i]);this.removeFromHash(removed);if(destroy&&removed){removed.destroy(true);}if(this.cursor===this.children[i]){this.cursor=null;}i--;}this.updateZ();};/**
	* Destroys this group.
	*
	* Removes all children, then removes this group from its parent and nulls references.
	*
	* @method Phaser.Group#destroy
	* @param {boolean} [destroyChildren=true] - If true `destroy` will be invoked on each removed child.
	* @param {boolean} [soft=false] - A 'soft destroy' (set to true) doesn't remove this group from its parent or null the game reference. Set to false and it does.
	*/Phaser.Group.prototype.destroy=function(destroyChildren,soft){if(this.game===null||this.ignoreDestroy){return;}if(destroyChildren===undefined){destroyChildren=true;}if(soft===undefined){soft=false;}this.onDestroy.dispatch(this,destroyChildren,soft);this.removeAll(destroyChildren);this.cursor=null;this.filters=null;this.pendingDestroy=false;if(!soft){if(this.parent){this.parent.removeChild(this);}this.game=null;this.exists=false;}};/**
	* Total number of existing children in the group.
	*
	* @name Phaser.Group#total
	* @property {integer} total
	* @readonly
	*/Object.defineProperty(Phaser.Group.prototype,"total",{get:function get(){return this.iterate('exists',true,Phaser.Group.RETURN_TOTAL);}});/**
	* Total number of children in this group, regardless of exists/alive status.
	*
	* @name Phaser.Group#length
	* @property {integer} length 
	* @readonly
	*/Object.defineProperty(Phaser.Group.prototype,"length",{get:function get(){return this.children.length;}});/**
	* The angle of rotation of the group container, in degrees.
	*
	* This adjusts the group itself by modifying its local rotation transform.
	*
	* This has no impact on the rotation/angle properties of the children, but it will update their worldTransform
	* and on-screen orientation and position.
	*
	* @name Phaser.Group#angle
	* @property {number} angle
	*/Object.defineProperty(Phaser.Group.prototype,"angle",{get:function get(){return Phaser.Math.radToDeg(this.rotation);},set:function set(value){this.rotation=Phaser.Math.degToRad(value);}});/**
	* The center x coordinate of this Group.
	*
	* It is derived by calling `getBounds`, calculating the Groups dimensions based on its
	* visible children.
	* 
	* @name Phaser.Group#centerX
	* @property {number} centerX
	*/Object.defineProperty(Phaser.Group.prototype,"centerX",{get:function get(){return this.getBounds(this.parent).centerX;},set:function set(value){var r=this.getBounds(this.parent);var offset=this.x-r.x;this.x=value+offset-r.halfWidth;}});/**
	* The center y coordinate of this Group.
	*
	* It is derived by calling `getBounds`, calculating the Groups dimensions based on its
	* visible children.
	* 
	* @name Phaser.Group#centerY
	* @property {number} centerY
	*/Object.defineProperty(Phaser.Group.prototype,"centerY",{get:function get(){return this.getBounds(this.parent).centerY;},set:function set(value){var r=this.getBounds(this.parent);var offset=this.y-r.y;this.y=value+offset-r.halfHeight;}});/**
	* The left coordinate of this Group.
	*
	* It is derived by calling `getBounds`, calculating the Groups dimensions based on its
	* visible children.
	* 
	* @name Phaser.Group#left
	* @property {number} left
	*/Object.defineProperty(Phaser.Group.prototype,"left",{get:function get(){return this.getBounds(this.parent).left;},set:function set(value){var r=this.getBounds(this.parent);var offset=this.x-r.x;this.x=value+offset;}});/**
	* The right coordinate of this Group.
	*
	* It is derived by calling `getBounds`, calculating the Groups dimensions based on its
	* visible children.
	*
	* @name Phaser.Group#right
	* @property {number} right
	*/Object.defineProperty(Phaser.Group.prototype,"right",{get:function get(){return this.getBounds(this.parent).right;},set:function set(value){var r=this.getBounds(this.parent);var offset=this.x-r.x;this.x=value+offset-r.width;}});/**
	* The top coordinate of this Group.
	*
	* It is derived by calling `getBounds`, calculating the Groups dimensions based on its
	* visible children.
	*
	* @name Phaser.Group#top
	* @property {number} top
	*/Object.defineProperty(Phaser.Group.prototype,"top",{get:function get(){return this.getBounds(this.parent).top;},set:function set(value){var r=this.getBounds(this.parent);var offset=this.y-r.y;this.y=value+offset;}});/**
	* The bottom coordinate of this Group.
	*
	* It is derived by calling `getBounds`, calculating the Groups dimensions based on its
	* visible children.
	* 
	* @name Phaser.Group#bottom
	* @property {number} bottom
	*/Object.defineProperty(Phaser.Group.prototype,"bottom",{get:function get(){return this.getBounds(this.parent).bottom;},set:function set(value){var r=this.getBounds(this.parent);var offset=this.y-r.y;this.y=value+offset-r.height;}});/**
	* Aligns this Group within another Game Object, or Rectangle, known as the
	* 'container', to one of 9 possible positions.
	*
	* The container must be a Game Object, or Phaser.Rectangle object. This can include properties
	* such as `World.bounds` or `Camera.view`, for aligning Groups within the world 
	* and camera bounds. Or it can include other Sprites, Images, Text objects, BitmapText,
	* TileSprites or Buttons.
	*
	* Please note that aligning a Group to another Game Object does **not** make it a child of
	* the container. It simply modifies its position coordinates so it aligns with it.
	* 
	* The position constants you can use are:
	* 
	* `Phaser.TOP_LEFT`, `Phaser.TOP_CENTER`, `Phaser.TOP_RIGHT`, `Phaser.LEFT_CENTER`, 
	* `Phaser.CENTER`, `Phaser.RIGHT_CENTER`, `Phaser.BOTTOM_LEFT`, 
	* `Phaser.BOTTOM_CENTER` and `Phaser.BOTTOM_RIGHT`.
	*
	* Groups are placed in such a way that their _bounds_ align with the
	* container, taking into consideration rotation and scale of its children.
	* This allows you to neatly align Groups, irrespective of their position value.
	*
	* The optional `offsetX` and `offsetY` arguments allow you to apply extra spacing to the final
	* aligned position of the Group. For example:
	*
	* `group.alignIn(background, Phaser.BOTTOM_RIGHT, -20, -20)`
	*
	* Would align the `group` to the bottom-right, but moved 20 pixels in from the corner.
	* Think of the offsets as applying an adjustment to the containers bounds before the alignment takes place.
	* So providing a negative offset will 'shrink' the container bounds by that amount, and providing a positive
	* one expands it.
	*
	* @method Phaser.Group#alignIn
	* @param {Phaser.Rectangle|Phaser.Sprite|Phaser.Image|Phaser.Text|Phaser.BitmapText|Phaser.Button|Phaser.Graphics|Phaser.TileSprite} container - The Game Object or Rectangle with which to align this Group to. Can also include properties such as `World.bounds` or `Camera.view`.
	* @param {integer} [position] - The position constant. One of `Phaser.TOP_LEFT` (default), `Phaser.TOP_CENTER`, `Phaser.TOP_RIGHT`, `Phaser.LEFT_CENTER`, `Phaser.CENTER`, `Phaser.RIGHT_CENTER`, `Phaser.BOTTOM_LEFT`, `Phaser.BOTTOM_CENTER` or `Phaser.BOTTOM_RIGHT`.
	* @param {integer} [offsetX=0] - A horizontal adjustment of the Containers bounds, applied to the aligned position of the Game Object. Use a negative value to shrink the bounds, positive to increase it.
	* @param {integer} [offsetY=0] - A vertical adjustment of the Containers bounds, applied to the aligned position of the Game Object. Use a negative value to shrink the bounds, positive to increase it.
	* @return {Phaser.Group} This Group.
	*///  This function is set at the bottom of src/gameobjects/components/Bounds.js
	/**
	* Aligns this Group to the side of another Game Object, or Rectangle, known as the
	* 'parent', in one of 11 possible positions.
	*
	* The parent must be a Game Object, or Phaser.Rectangle object. This can include properties
	* such as `World.bounds` or `Camera.view`, for aligning Groups within the world 
	* and camera bounds. Or it can include other Sprites, Images, Text objects, BitmapText,
	* TileSprites or Buttons.
	*
	* Please note that aligning a Group to another Game Object does **not** make it a child of
	* the parent. It simply modifies its position coordinates so it aligns with it.
	* 
	* The position constants you can use are:
	* 
	* `Phaser.TOP_LEFT` (default), `Phaser.TOP_CENTER`, `Phaser.TOP_RIGHT`, `Phaser.LEFT_TOP`, 
	* `Phaser.LEFT_CENTER`, `Phaser.LEFT_BOTTOM`, `Phaser.RIGHT_TOP`, `Phaser.RIGHT_CENTER`, 
	* `Phaser.RIGHT_BOTTOM`, `Phaser.BOTTOM_LEFT`, `Phaser.BOTTOM_CENTER` 
	* and `Phaser.BOTTOM_RIGHT`.
	*
	* Groups are placed in such a way that their _bounds_ align with the
	* parent, taking into consideration rotation and scale of the children.
	* This allows you to neatly align Groups, irrespective of their position value.
	*
	* The optional `offsetX` and `offsetY` arguments allow you to apply extra spacing to the final
	* aligned position of the Group. For example:
	*
	* `group.alignTo(background, Phaser.BOTTOM_RIGHT, -20, -20)`
	*
	* Would align the `group` to the bottom-right, but moved 20 pixels in from the corner.
	* Think of the offsets as applying an adjustment to the parents bounds before the alignment takes place.
	* So providing a negative offset will 'shrink' the parent bounds by that amount, and providing a positive
	* one expands it.
	*
	* @method Phaser.Group#alignTo
	* @param {Phaser.Rectangle|Phaser.Sprite|Phaser.Image|Phaser.Text|Phaser.BitmapText|Phaser.Button|Phaser.Graphics|Phaser.TileSprite} parent - The Game Object or Rectangle with which to align this Group to. Can also include properties such as `World.bounds` or `Camera.view`.
	* @param {integer} [position] - The position constant. One of `Phaser.TOP_LEFT`, `Phaser.TOP_CENTER`, `Phaser.TOP_RIGHT`, `Phaser.LEFT_TOP`, `Phaser.LEFT_CENTER`, `Phaser.LEFT_BOTTOM`, `Phaser.RIGHT_TOP`, `Phaser.RIGHT_CENTER`, `Phaser.RIGHT_BOTTOM`, `Phaser.BOTTOM_LEFT`, `Phaser.BOTTOM_CENTER` or `Phaser.BOTTOM_RIGHT`.
	* @param {integer} [offsetX=0] - A horizontal adjustment of the Containers bounds, applied to the aligned position of the Game Object. Use a negative value to shrink the bounds, positive to increase it.
	* @param {integer} [offsetY=0] - A vertical adjustment of the Containers bounds, applied to the aligned position of the Game Object. Use a negative value to shrink the bounds, positive to increase it.
	* @return {Phaser.Group} This Group.
	*///  This function is set at the bottom of src/gameobjects/components/Bounds.js
	/**
	* A display object is any object that can be rendered in the Phaser/pixi.js scene graph.
	*
	* This includes {@link Phaser.Group} (groups are display objects!),
	* {@link Phaser.Sprite}, {@link Phaser.Button}, {@link Phaser.Text}
	* as well as {@link PIXI.DisplayObject} and all derived types.
	*
	* @typedef {object} DisplayObject
	*/// Documentation stub for linking.
	/**
	* The x coordinate of the group container.
	*
	* You can adjust the group container itself by modifying its coordinates.
	* This will have no impact on the x/y coordinates of its children, but it will update their worldTransform and on-screen position.
	* @name Phaser.Group#x
	* @property {number} x
	*//**
	* The y coordinate of the group container.
	*
	* You can adjust the group container itself by modifying its coordinates.
	* This will have no impact on the x/y coordinates of its children, but it will update their worldTransform and on-screen position.
	* @name Phaser.Group#y
	* @property {number} y
	*//**
	* The angle of rotation of the group container, in radians.
	*
	* This will adjust the group container itself by modifying its rotation.
	* This will have no impact on the rotation value of its children, but it will update their worldTransform and on-screen position.
	* @name Phaser.Group#rotation
	* @property {number} rotation
	*//**
	* The visible state of the group. Non-visible Groups and all of their children are not rendered.
	*
	* @name Phaser.Group#visible
	* @property {boolean} visible
	*//**
	* The alpha value of the group container.
	*
	* @name Phaser.Group#alpha
	* @property {number} alpha
	*//**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* "This world is but a canvas to our imagination." - Henry David Thoreau
	*
	* A game has only one world. The world is an abstract place in which all game objects live. It is not bound
	* by stage limits and can be any size. You look into the world via cameras. All game objects live within
	* the world at world-based coordinates. By default a world is created the same size as your Stage.
	*
	* @class Phaser.World
	* @extends Phaser.Group
	* @constructor
	* @param {Phaser.Game} game - Reference to the current game instance.
	*/Phaser.World=function(game){Phaser.Group.call(this,game,null,'__world',false);/**
	    * The World has no fixed size, but it does have a bounds outside of which objects are no longer considered as being "in world" and you should use this to clean-up the display list and purge dead objects.
	    * By default we set the Bounds to be from 0,0 to Game.width,Game.height. I.e. it will match the size given to the game constructor with 0,0 representing the top-left of the display.
	    * However 0,0 is actually the center of the world, and if you rotate or scale the world all of that will happen from 0,0.
	    * So if you want to make a game in which the world itself will rotate you should adjust the bounds so that 0,0 is the center point, i.e. set them to -1000,-1000,2000,2000 for a 2000x2000 sized world centered around 0,0.
	    * @property {Phaser.Rectangle} bounds - Bound of this world that objects can not escape from.
	    */this.bounds=new Phaser.Rectangle(0,0,game.width,game.height);/**
	    * @property {Phaser.Camera} camera - Camera instance.
	    */this.camera=null;/**
	    * @property {boolean} _definedSize - True if the World has been given a specifically defined size (i.e. from a Tilemap or direct in code) or false if it's just matched to the Game dimensions.
	    * @readonly
	    */this._definedSize=false;/**
	    * @property {number} width - The defined width of the World. Sometimes the bounds needs to grow larger than this (if you resize the game) but this retains the original requested dimension.
	    */this._width=game.width;/**
	    * @property {number} height - The defined height of the World. Sometimes the bounds needs to grow larger than this (if you resize the game) but this retains the original requested dimension.
	    */this._height=game.height;this.game.state.onStateChange.add(this.stateChange,this);};Phaser.World.prototype=Object.create(Phaser.Group.prototype);Phaser.World.prototype.constructor=Phaser.World;/**
	* Initialises the game world.
	*
	* @method Phaser.World#boot
	* @protected
	*/Phaser.World.prototype.boot=function(){this.camera=new Phaser.Camera(this.game,0,0,0,this.game.width,this.game.height);this.game.stage.addChild(this);this.camera.boot();};/**
	* Called whenever the State changes or resets.
	* 
	* It resets the world.x and world.y coordinates back to zero,
	* then resets the Camera.
	*
	* @method Phaser.World#stateChange
	* @protected
	*/Phaser.World.prototype.stateChange=function(){this.x=0;this.y=0;this.camera.reset();};/**
	* Updates the size of this world and sets World.x/y to the given values
	* The Camera bounds and Physics bounds (if set) are also updated to match the new World bounds.
	*
	* @method Phaser.World#setBounds
	* @param {number} x - Top left most corner of the world.
	* @param {number} y - Top left most corner of the world.
	* @param {number} width - New width of the game world in pixels.
	* @param {number} height - New height of the game world in pixels.
	*/Phaser.World.prototype.setBounds=function(x,y,width,height){this._definedSize=true;this._width=width;this._height=height;this.bounds.setTo(x,y,width,height);this.x=x;this.y=y;if(this.camera.bounds){//  The Camera can never be smaller than the game size
	this.camera.bounds.setTo(x,y,Math.max(width,this.game.width),Math.max(height,this.game.height));}this.game.physics.setBoundsToWorld();};/**
	* Updates the size of this world. Note that this doesn't modify the world x/y coordinates, just the width and height.
	*
	* @method Phaser.World#resize
	* @param {number} width - New width of the game world in pixels.
	* @param {number} height - New height of the game world in pixels.
	*/Phaser.World.prototype.resize=function(width,height){//  Don't ever scale the World bounds lower than the original requested dimensions if it's a defined world size
	if(this._definedSize){if(width<this._width){width=this._width;}if(height<this._height){height=this._height;}}this.bounds.width=width;this.bounds.height=height;this.game.camera.setBoundsToWorld();this.game.physics.setBoundsToWorld();};/**
	* Destroyer of worlds.
	*
	* @method Phaser.World#shutdown
	*/Phaser.World.prototype.shutdown=function(){//  World is a Group, so run a soft destruction on this and all children.
	this.destroy(true,true);};/**
	* This will take the given game object and check if its x/y coordinates fall outside of the world bounds.
	* If they do it will reposition the object to the opposite side of the world, creating a wrap-around effect.
	* If sprite has a P2 body then the body (sprite.body) should be passed as first parameter to the function.
	*
	* Please understand there are limitations to this method. For example if you have scaled the World
	* then objects won't always be re-positioned correctly, and you'll need to employ your own wrapping function.
	*
	* @method Phaser.World#wrap
	* @param {Phaser.Sprite|Phaser.Image|Phaser.TileSprite|Phaser.Text} sprite - The object you wish to wrap around the world bounds.
	* @param {number} [padding=0] - Extra padding added equally to the sprite.x and y coordinates before checking if within the world bounds. Ignored if useBounds is true.
	* @param {boolean} [useBounds=false] - If useBounds is false wrap checks the object.x/y coordinates. If true it does a more accurate bounds check, which is more expensive.
	* @param {boolean} [horizontal=true] - If horizontal is false, wrap will not wrap the object.x coordinates horizontally.
	* @param {boolean} [vertical=true] - If vertical is false, wrap will not wrap the object.y coordinates vertically.
	*/Phaser.World.prototype.wrap=function(sprite,padding,useBounds,horizontal,vertical){if(padding===undefined){padding=0;}if(useBounds===undefined){useBounds=false;}if(horizontal===undefined){horizontal=true;}if(vertical===undefined){vertical=true;}if(!useBounds){if(horizontal&&sprite.x+padding<this.bounds.x){sprite.x=this.bounds.right+padding;}else if(horizontal&&sprite.x-padding>this.bounds.right){sprite.x=this.bounds.left-padding;}if(vertical&&sprite.y+padding<this.bounds.top){sprite.y=this.bounds.bottom+padding;}else if(vertical&&sprite.y-padding>this.bounds.bottom){sprite.y=this.bounds.top-padding;}}else{sprite.getBounds();if(horizontal){if(sprite.x+sprite._currentBounds.width<this.bounds.x){sprite.x=this.bounds.right;}else if(sprite.x>this.bounds.right){sprite.x=this.bounds.left;}}if(vertical){if(sprite.y+sprite._currentBounds.height<this.bounds.top){sprite.y=this.bounds.bottom;}else if(sprite.y>this.bounds.bottom){sprite.y=this.bounds.top;}}}};/**
	* @name Phaser.World#width
	* @property {number} width - Gets or sets the current width of the game world. The world can never be smaller than the game (canvas) dimensions.
	*/Object.defineProperty(Phaser.World.prototype,"width",{get:function get(){return this.bounds.width;},set:function set(value){if(value<this.game.width){value=this.game.width;}this.bounds.width=value;this._width=value;this._definedSize=true;}});/**
	* @name Phaser.World#height
	* @property {number} height - Gets or sets the current height of the game world. The world can never be smaller than the game (canvas) dimensions.
	*/Object.defineProperty(Phaser.World.prototype,"height",{get:function get(){return this.bounds.height;},set:function set(value){if(value<this.game.height){value=this.game.height;}this.bounds.height=value;this._height=value;this._definedSize=true;}});/**
	* @name Phaser.World#centerX
	* @property {number} centerX - Gets the X position corresponding to the center point of the world.
	* @readonly
	*/Object.defineProperty(Phaser.World.prototype,"centerX",{get:function get(){return this.bounds.halfWidth+this.bounds.x;}});/**
	* @name Phaser.World#centerY
	* @property {number} centerY - Gets the Y position corresponding to the center point of the world.
	* @readonly
	*/Object.defineProperty(Phaser.World.prototype,"centerY",{get:function get(){return this.bounds.halfHeight+this.bounds.y;}});/**
	* @name Phaser.World#randomX
	* @property {number} randomX - Gets a random integer which is lesser than or equal to the current width of the game world.
	* @readonly
	*/Object.defineProperty(Phaser.World.prototype,"randomX",{get:function get(){if(this.bounds.x<0){return this.game.rnd.between(this.bounds.x,this.bounds.width-Math.abs(this.bounds.x));}else{return this.game.rnd.between(this.bounds.x,this.bounds.width);}}});/**
	* @name Phaser.World#randomY
	* @property {number} randomY - Gets a random integer which is lesser than or equal to the current height of the game world.
	* @readonly
	*/Object.defineProperty(Phaser.World.prototype,"randomY",{get:function get(){if(this.bounds.y<0){return this.game.rnd.between(this.bounds.y,this.bounds.height-Math.abs(this.bounds.y));}else{return this.game.rnd.between(this.bounds.y,this.bounds.height);}}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* This is where the magic happens. The Game object is the heart of your game,
	* providing quick access to common functions and handling the boot process.
	* 
	* "Hell, there are no rules here - we're trying to accomplish something."
	*                                                       Thomas A. Edison
	*
	* @class Phaser.Game
	* @constructor
	* @param {number|string} [width=800] - The width of your game in game pixels. If given as a string the value must be between 0 and 100 and will be used as the percentage width of the parent container, or the browser window if no parent is given.
	* @param {number|string} [height=600] - The height of your game in game pixels. If given as a string the value must be between 0 and 100 and will be used as the percentage height of the parent container, or the browser window if no parent is given.
	* @param {number} [renderer=Phaser.AUTO] - Which renderer to use: Phaser.AUTO will auto-detect, Phaser.WEBGL, Phaser.CANVAS or Phaser.HEADLESS (no rendering at all).
	* @param {string|HTMLElement} [parent=''] - The DOM element into which this games canvas will be injected. Either a DOM ID (string) or the element itself.
	* @param {object} [state=null] - The default state object. A object consisting of Phaser.State functions (preload, create, update, render) or null.
	* @param {boolean} [transparent=false] - Use a transparent canvas background or not.
	* @param {boolean} [antialias=true] - Draw all image textures anti-aliased or not. The default is for smooth textures, but disable if your game features pixel art.
	* @param {object} [physicsConfig=null] - A physics configuration object to pass to the Physics world on creation.
	*/Phaser.Game=function(width,height,renderer,parent,state,transparent,antialias,physicsConfig){/**
	    * @property {number} id - Phaser Game ID (for when Pixi supports multiple instances).
	    * @readonly
	    */this.id=Phaser.GAMES.push(this)-1;/**
	    * @property {object} config - The Phaser.Game configuration object.
	    */this.config=null;/**
	    * @property {object} physicsConfig - The Phaser.Physics.World configuration object.
	    */this.physicsConfig=physicsConfig;/**
	    * @property {string|HTMLElement} parent - The Games DOM parent.
	    * @default
	    */this.parent='';/**
	    * The current Game Width in pixels.
	    *
	    * _Do not modify this property directly:_ use {@link Phaser.ScaleManager#setGameSize} - eg. `game.scale.setGameSize(width, height)` - instead.
	    *
	    * @property {integer} width
	    * @readonly
	    * @default
	    */this.width=800;/**
	    * The current Game Height in pixels.
	    *
	    * _Do not modify this property directly:_ use {@link Phaser.ScaleManager#setGameSize} - eg. `game.scale.setGameSize(width, height)` - instead.
	    *
	    * @property {integer} height
	    * @readonly
	    * @default
	    */this.height=600;/**
	    * The resolution of your game. This value is read only, but can be changed at start time it via a game configuration object.
	    *
	    * @property {integer} resolution
	    * @readonly
	    * @default
	    */this.resolution=1;/**
	    * @property {integer} _width - Private internal var.
	    * @private
	    */this._width=800;/**
	    * @property {integer} _height - Private internal var.
	    * @private
	    */this._height=600;/**
	    * @property {boolean} transparent - Use a transparent canvas background or not.
	    * @default
	    */this.transparent=false;/**
	    * @property {boolean} antialias - Anti-alias graphics. By default scaled images are smoothed in Canvas and WebGL, set anti-alias to false to disable this globally.
	    * @default
	    */this.antialias=true;/**
	    * @property {boolean} preserveDrawingBuffer - The value of the preserveDrawingBuffer flag affects whether or not the contents of the stencil buffer is retained after rendering.
	    * @default
	    */this.preserveDrawingBuffer=false;/**
	    * Clear the Canvas each frame before rendering the display list.
	    * You can set this to `false` to gain some performance if your game always contains a background that completely fills the display.
	    * @property {boolean} clearBeforeRender
	    * @default
	    */this.clearBeforeRender=true;/**
	    * @property {PIXI.CanvasRenderer|PIXI.WebGLRenderer} renderer - The Pixi Renderer.
	    * @protected
	    */this.renderer=null;/**
	    * @property {number} renderType - The Renderer this game will use. Either Phaser.AUTO, Phaser.CANVAS, Phaser.WEBGL, or Phaser.HEADLESS.
	    * @readonly
	    */this.renderType=Phaser.AUTO;/**
	    * @property {Phaser.StateManager} state - The StateManager.
	    */this.state=null;/**
	    * @property {boolean} isBooted - Whether the game engine is booted, aka available.
	    * @readonly
	    */this.isBooted=false;/**
	    * @property {boolean} isRunning - Is game running or paused?
	    * @readonly
	    */this.isRunning=false;/**
	    * @property {Phaser.RequestAnimationFrame} raf - Automatically handles the core game loop via requestAnimationFrame or setTimeout
	    * @protected
	    */this.raf=null;/**
	    * @property {Phaser.GameObjectFactory} add - Reference to the Phaser.GameObjectFactory.
	    */this.add=null;/**
	    * @property {Phaser.GameObjectCreator} make - Reference to the GameObject Creator.
	    */this.make=null;/**
	    * @property {Phaser.Cache} cache - Reference to the assets cache.
	    */this.cache=null;/**
	    * @property {Phaser.Input} input - Reference to the input manager
	    */this.input=null;/**
	    * @property {Phaser.Loader} load - Reference to the assets loader.
	    */this.load=null;/**
	    * @property {Phaser.Math} math - Reference to the math helper.
	    */this.math=null;/**
	    * @property {Phaser.Net} net - Reference to the network class.
	    */this.net=null;/**
	    * @property {Phaser.ScaleManager} scale - The game scale manager.
	    */this.scale=null;/**
	    * @property {Phaser.SoundManager} sound - Reference to the sound manager.
	    */this.sound=null;/**
	    * @property {Phaser.Stage} stage - Reference to the stage.
	    */this.stage=null;/**
	    * @property {Phaser.Time} time - Reference to the core game clock.
	    */this.time=null;/**
	    * @property {Phaser.TweenManager} tweens - Reference to the tween manager.
	    */this.tweens=null;/**
	    * @property {Phaser.World} world - Reference to the world.
	    */this.world=null;/**
	    * @property {Phaser.Physics} physics - Reference to the physics manager.
	    */this.physics=null;/**
	    * @property {Phaser.PluginManager} plugins - Reference to the plugin manager.
	    */this.plugins=null;/**
	    * @property {Phaser.RandomDataGenerator} rnd - Instance of repeatable random data generator helper.
	    */this.rnd=null;/**
	    * @property {Phaser.Device} device - Contains device information and capabilities.
	    */this.device=Phaser.Device;/**
	    * @property {Phaser.Camera} camera - A handy reference to world.camera.
	    */this.camera=null;/**
	    * @property {HTMLCanvasElement} canvas - A handy reference to renderer.view, the canvas that the game is being rendered in to.
	    */this.canvas=null;/**
	    * @property {CanvasRenderingContext2D} context - A handy reference to renderer.context (only set for CANVAS games, not WebGL)
	    */this.context=null;/**
	    * @property {Phaser.Utils.Debug} debug - A set of useful debug utilities.
	    */this.debug=null;/**
	    * @property {Phaser.Particles} particles - The Particle Manager.
	    */this.particles=null;/**
	    * @property {Phaser.Create} create - The Asset Generator.
	    */this.create=null;/**
	    * If `false` Phaser will automatically render the display list every update. If `true` the render loop will be skipped.
	    * You can toggle this value at run-time to gain exact control over when Phaser renders. This can be useful in certain types of game or application.
	    * Please note that if you don't render the display list then none of the game object transforms will be updated, so use this value carefully.
	    * @property {boolean} lockRender
	    * @default
	    */this.lockRender=false;/**
	    * @property {boolean} stepping - Enable core loop stepping with Game.enableStep().
	    * @default
	    * @readonly
	    */this.stepping=false;/**
	    * @property {boolean} pendingStep - An internal property used by enableStep, but also useful to query from your own game objects.
	    * @default
	    * @readonly
	    */this.pendingStep=false;/**
	    * @property {number} stepCount - When stepping is enabled this contains the current step cycle.
	    * @default
	    * @readonly
	    */this.stepCount=0;/**
	    * @property {Phaser.Signal} onPause - This event is fired when the game pauses.
	    */this.onPause=null;/**
	    * @property {Phaser.Signal} onResume - This event is fired when the game resumes from a paused state.
	    */this.onResume=null;/**
	    * @property {Phaser.Signal} onBlur - This event is fired when the game no longer has focus (typically on page hide).
	    */this.onBlur=null;/**
	    * @property {Phaser.Signal} onFocus - This event is fired when the game has focus (typically on page show).
	    */this.onFocus=null;/**
	    * @property {boolean} _paused - Is game paused?
	    * @private
	    */this._paused=false;/**
	    * @property {boolean} _codePaused - Was the game paused via code or a visibility change?
	    * @private
	    */this._codePaused=false;/**
	    * The ID of the current/last logic update applied this render frame, starting from 0.
	    * The first update is `currentUpdateID === 0` and the last update is `currentUpdateID === updatesThisFrame.`
	    * @property {integer} currentUpdateID
	    * @protected
	    */this.currentUpdateID=0;/**
	    * Number of logic updates expected to occur this render frame; will be 1 unless there are catch-ups required (and allowed).
	    * @property {integer} updatesThisFrame
	    * @protected
	    */this.updatesThisFrame=1;/**
	    * @property {number} _deltaTime - Accumulate elapsed time until a logic update is due.
	    * @private
	    */this._deltaTime=0;/**
	    * @property {number} _lastCount - Remember how many 'catch-up' iterations were used on the logicUpdate last frame.
	    * @private
	    */this._lastCount=0;/**
	    * @property {number} _spiraling - If the 'catch-up' iterations are spiraling out of control, this counter is incremented.
	    * @private
	    */this._spiraling=0;/**
	    * @property {boolean} _kickstart - Force a logic update + render by default (always set on Boot and State swap)
	    * @private
	    */this._kickstart=true;/**
	    * If the game is struggling to maintain the desired FPS, this signal will be dispatched.
	    * The desired/chosen FPS should probably be closer to the {@link Phaser.Time#suggestedFps} value.
	    * @property {Phaser.Signal} fpsProblemNotifier
	    * @public
	    */this.fpsProblemNotifier=new Phaser.Signal();/**
	    * @property {boolean} forceSingleUpdate - Should the game loop force a logic update, regardless of the delta timer? Set to true if you know you need this. You can toggle it on the fly.
	    */this.forceSingleUpdate=true;/**
	    * @property {number} _nextNotification - The soonest game.time.time value that the next fpsProblemNotifier can be dispatched.
	    * @private
	    */this._nextFpsNotification=0;//  Parse the configuration object (if any)
	if(arguments.length===1&&_typeof(arguments[0])==='object'){this.parseConfig(arguments[0]);}else{this.config={enableDebug:true};if(typeof width!=='undefined'){this._width=width;}if(typeof height!=='undefined'){this._height=height;}if(typeof renderer!=='undefined'){this.renderType=renderer;}if(typeof parent!=='undefined'){this.parent=parent;}if(typeof transparent!=='undefined'){this.transparent=transparent;}if(typeof antialias!=='undefined'){this.antialias=antialias;}this.rnd=new Phaser.RandomDataGenerator([(Date.now()*Math.random()).toString()]);this.state=new Phaser.StateManager(this,state);}this.device.whenReady(this.boot,this);return this;};Phaser.Game.prototype={/**
	    * Parses a Game configuration object.
	    *
	    * @method Phaser.Game#parseConfig
	    * @protected
	    */parseConfig:function parseConfig(config){this.config=config;if(config['enableDebug']===undefined){this.config.enableDebug=true;}if(config['width']){this._width=config['width'];}if(config['height']){this._height=config['height'];}if(config['renderer']){this.renderType=config['renderer'];}if(config['parent']){this.parent=config['parent'];}if(config['transparent']!==undefined){this.transparent=config['transparent'];}if(config['antialias']!==undefined){this.antialias=config['antialias'];}if(config['resolution']){this.resolution=config['resolution'];}if(config['preserveDrawingBuffer']!==undefined){this.preserveDrawingBuffer=config['preserveDrawingBuffer'];}if(config['physicsConfig']){this.physicsConfig=config['physicsConfig'];}var seed=[(Date.now()*Math.random()).toString()];if(config['seed']){seed=config['seed'];}this.rnd=new Phaser.RandomDataGenerator(seed);var state=null;if(config['state']){state=config['state'];}this.state=new Phaser.StateManager(this,state);},/**
	    * Initialize engine sub modules and start the game.
	    *
	    * @method Phaser.Game#boot
	    * @protected
	    */boot:function boot(){if(this.isBooted){return;}this.onPause=new Phaser.Signal();this.onResume=new Phaser.Signal();this.onBlur=new Phaser.Signal();this.onFocus=new Phaser.Signal();this.isBooted=true;PIXI.game=this;this.math=Phaser.Math;this.scale=new Phaser.ScaleManager(this,this._width,this._height);this.stage=new Phaser.Stage(this);this.setUpRenderer();this.world=new Phaser.World(this);this.add=new Phaser.GameObjectFactory(this);this.make=new Phaser.GameObjectCreator(this);this.cache=new Phaser.Cache(this);this.load=new Phaser.Loader(this);this.time=new Phaser.Time(this);this.tweens=new Phaser.TweenManager(this);this.input=new Phaser.Input(this);this.sound=new Phaser.SoundManager(this);this.physics=new Phaser.Physics(this,this.physicsConfig);this.particles=new Phaser.Particles(this);this.create=new Phaser.Create(this);this.plugins=new Phaser.PluginManager(this);this.net=new Phaser.Net(this);this.time.boot();this.stage.boot();this.world.boot();this.scale.boot();this.input.boot();this.sound.boot();this.state.boot();if(this.config['enableDebug']){this.debug=new Phaser.Utils.Debug(this);this.debug.boot();}else{this.debug={preUpdate:function preUpdate(){},update:function update(){},reset:function reset(){}};}this.showDebugHeader();this.isRunning=true;if(this.config&&this.config['forceSetTimeOut']){this.raf=new Phaser.RequestAnimationFrame(this,this.config['forceSetTimeOut']);}else{this.raf=new Phaser.RequestAnimationFrame(this,false);}this._kickstart=true;if(window['focus']){if(!window['PhaserGlobal']||window['PhaserGlobal']&&!window['PhaserGlobal'].stopFocus){window.focus();}}this.raf.start();},/**
	    * Displays a Phaser version debug header in the console.
	    *
	    * @method Phaser.Game#showDebugHeader
	    * @protected
	    */showDebugHeader:function showDebugHeader(){if(window['PhaserGlobal']&&window['PhaserGlobal'].hideBanner){return;}var v=Phaser.VERSION;var r='Canvas';var a='HTML Audio';var c=1;if(this.renderType===Phaser.WEBGL){r='WebGL';c++;}else if(this.renderType===Phaser.HEADLESS){r='Headless';}if(this.device.webAudio){a='WebAudio';c++;}if(this.device.chrome){var args=['%c %c %c Phaser v'+v+' | Pixi.js | '+r+' | '+a+'  %c %c '+'%c http://phaser.io %c\u2665%c\u2665%c\u2665','background: #fb8cb3','background: #d44a52','color: #ffffff; background: #871905;','background: #d44a52','background: #fb8cb3','background: #ffffff'];for(var i=0;i<3;i++){if(i<c){args.push('color: #ff2424; background: #fff');}else{args.push('color: #959595; background: #fff');}}console.log.apply(console,args);}else if(window['console']){console.log('Phaser v'+v+' | Pixi.js '+PIXI.VERSION+' | '+r+' | '+a+' | http://phaser.io');}},/**
	    * Checks if the device is capable of using the requested renderer and sets it up or an alternative if not.
	    *
	    * @method Phaser.Game#setUpRenderer
	    * @protected
	    */setUpRenderer:function setUpRenderer(){if(this.config['canvas']){this.canvas=this.config['canvas'];}else{this.canvas=Phaser.Canvas.create(this,this.width,this.height,this.config['canvasID'],true);}if(this.config['canvasStyle']){this.canvas.style=this.config['canvasStyle'];}else{this.canvas.style['-webkit-full-screen']='width: 100%; height: 100%';}if(this.renderType===Phaser.HEADLESS||this.renderType===Phaser.CANVAS||this.renderType===Phaser.AUTO&&!this.device.webGL){if(this.device.canvas){//  They requested Canvas and their browser supports it
	this.renderType=Phaser.CANVAS;this.renderer=new PIXI.CanvasRenderer(this);this.context=this.renderer.context;}else{throw new Error('Phaser.Game - Cannot create Canvas or WebGL context, aborting.');}}else{//  They requested WebGL and their browser supports it
	this.renderType=Phaser.WEBGL;this.renderer=new PIXI.WebGLRenderer(this);this.context=null;this.canvas.addEventListener('webglcontextlost',this.contextLost.bind(this),false);this.canvas.addEventListener('webglcontextrestored',this.contextRestored.bind(this),false);}if(this.device.cocoonJS){this.canvas.screencanvas=this.renderType===Phaser.CANVAS?true:false;}if(this.renderType!==Phaser.HEADLESS){this.stage.smoothed=this.antialias;Phaser.Canvas.addToDOM(this.canvas,this.parent,false);Phaser.Canvas.setTouchAction(this.canvas);}},/**
	    * Handles WebGL context loss.
	    *
	    * @method Phaser.Game#contextLost
	    * @private
	    * @param {Event} event - The webglcontextlost event.
	    */contextLost:function contextLost(event){event.preventDefault();this.renderer.contextLost=true;},/**
	    * Handles WebGL context restoration.
	    *
	    * @method Phaser.Game#contextRestored
	    * @private
	    */contextRestored:function contextRestored(){this.renderer.initContext();this.cache.clearGLTextures();this.renderer.contextLost=false;},/**
	    * The core game loop.
	    *
	    * @method Phaser.Game#update
	    * @protected
	    * @param {number} time - The current time as provided by RequestAnimationFrame.
	    */update:function update(time){this.time.update(time);if(this._kickstart){this.updateLogic(this.time.desiredFpsMult);// call the game render update exactly once every frame
	this.updateRender(this.time.slowMotion*this.time.desiredFps);this._kickstart=false;return;}// if the logic time is spiraling upwards, skip a frame entirely
	if(this._spiraling>1&&!this.forceSingleUpdate){// cause an event to warn the program that this CPU can't keep up with the current desiredFps rate
	if(this.time.time>this._nextFpsNotification){// only permit one fps notification per 10 seconds
	this._nextFpsNotification=this.time.time+10000;// dispatch the notification signal
	this.fpsProblemNotifier.dispatch();}// reset the _deltaTime accumulator which will cause all pending dropped frames to be permanently skipped
	this._deltaTime=0;this._spiraling=0;// call the game render update exactly once every frame
	this.updateRender(this.time.slowMotion*this.time.desiredFps);}else{// step size taking into account the slow motion speed
	var slowStep=this.time.slowMotion*1000.0/this.time.desiredFps;// accumulate time until the slowStep threshold is met or exceeded... up to a limit of 3 catch-up frames at slowStep intervals
	this._deltaTime+=Math.max(Math.min(slowStep*3,this.time.elapsed),0);// call the game update logic multiple times if necessary to "catch up" with dropped frames
	// unless forceSingleUpdate is true
	var count=0;this.updatesThisFrame=Math.floor(this._deltaTime/slowStep);if(this.forceSingleUpdate){this.updatesThisFrame=Math.min(1,this.updatesThisFrame);}while(this._deltaTime>=slowStep){this._deltaTime-=slowStep;this.currentUpdateID=count;this.updateLogic(this.time.desiredFpsMult);count++;if(this.forceSingleUpdate&&count===1){break;}else{this.time.refresh();}}// detect spiraling (if the catch-up loop isn't fast enough, the number of iterations will increase constantly)
	if(count>this._lastCount){this._spiraling++;}else if(count<this._lastCount){// looks like it caught up successfully, reset the spiral alert counter
	this._spiraling=0;}this._lastCount=count;// call the game render update exactly once every frame unless we're playing catch-up from a spiral condition
	this.updateRender(this._deltaTime/slowStep);}},/**
	    * Updates all logic subsystems in Phaser. Called automatically by Game.update.
	    *
	    * @method Phaser.Game#updateLogic
	    * @protected
	    * @param {number} timeStep - The current timeStep value as determined by Game.update.
	    */updateLogic:function updateLogic(timeStep){if(!this._paused&&!this.pendingStep){if(this.stepping){this.pendingStep=true;}this.scale.preUpdate();this.debug.preUpdate();this.camera.preUpdate();this.physics.preUpdate();this.state.preUpdate(timeStep);this.plugins.preUpdate(timeStep);this.stage.preUpdate();this.state.update();this.stage.update();this.tweens.update();this.sound.update();this.input.update();this.physics.update();this.particles.update();this.plugins.update();this.stage.postUpdate();this.plugins.postUpdate();}else{// Scaling and device orientation changes are still reflected when paused.
	this.scale.pauseUpdate();this.state.pauseUpdate();this.debug.preUpdate();}this.stage.updateTransform();},/**
	    * Runs the Render cycle.
	    * It starts by calling State.preRender. In here you can do any last minute adjustments of display objects as required.
	    * It then calls the renderer, which renders the entire display list, starting from the Stage object and working down.
	    * It then calls plugin.render on any loaded plugins, in the order in which they were enabled.
	    * After this State.render is called. Any rendering that happens here will take place on-top of the display list.
	    * Finally plugin.postRender is called on any loaded plugins, in the order in which they were enabled.
	    * This method is called automatically by Game.update, you don't need to call it directly.
	    * Should you wish to have fine-grained control over when Phaser renders then use the `Game.lockRender` boolean.
	    * Phaser will only render when this boolean is `false`.
	    *
	    * @method Phaser.Game#updateRender
	    * @protected
	    * @param {number} elapsedTime - The time elapsed since the last update.
	    */updateRender:function updateRender(elapsedTime){if(this.lockRender){return;}this.state.preRender(elapsedTime);if(this.renderType!==Phaser.HEADLESS){this.renderer.render(this.stage);this.plugins.render(elapsedTime);this.state.render(elapsedTime);}this.plugins.postRender(elapsedTime);},/**
	    * Enable core game loop stepping. When enabled you must call game.step() directly (perhaps via a DOM button?)
	    * Calling step will advance the game loop by one frame. This is extremely useful for hard to track down errors!
	    *
	    * @method Phaser.Game#enableStep
	    */enableStep:function enableStep(){this.stepping=true;this.pendingStep=false;this.stepCount=0;},/**
	    * Disables core game loop stepping.
	    *
	    * @method Phaser.Game#disableStep
	    */disableStep:function disableStep(){this.stepping=false;this.pendingStep=false;},/**
	    * When stepping is enabled you must call this function directly (perhaps via a DOM button?) to advance the game loop by one frame.
	    * This is extremely useful to hard to track down errors! Use the internal stepCount property to monitor progress.
	    *
	    * @method Phaser.Game#step
	    */step:function step(){this.pendingStep=false;this.stepCount++;},/**
	    * Nukes the entire game from orbit.
	    *
	    * Calls destroy on Game.state, Game.sound, Game.scale, Game.stage, Game.input, Game.physics and Game.plugins.
	    *
	    * Then sets all of those local handlers to null, destroys the renderer, removes the canvas from the DOM
	    * and resets the PIXI default renderer.
	    *
	    * @method Phaser.Game#destroy
	    */destroy:function destroy(){this.raf.stop();this.state.destroy();this.sound.destroy();this.scale.destroy();this.stage.destroy();this.input.destroy();this.physics.destroy();this.plugins.destroy();this.state=null;this.sound=null;this.scale=null;this.stage=null;this.input=null;this.physics=null;this.plugins=null;this.cache=null;this.load=null;this.time=null;this.world=null;this.isBooted=false;this.renderer.destroy(false);Phaser.Canvas.removeFromDOM(this.canvas);PIXI.defaultRenderer=null;Phaser.GAMES[this.id]=null;},/**
	    * Called by the Stage visibility handler.
	    *
	    * @method Phaser.Game#gamePaused
	    * @param {object} event - The DOM event that caused the game to pause, if any.
	    * @protected
	    */gamePaused:function gamePaused(event){//   If the game is already paused it was done via game code, so don't re-pause it
	if(!this._paused){this._paused=true;this.time.gamePaused();if(this.sound.muteOnPause){this.sound.setMute();}this.onPause.dispatch(event);//  Avoids Cordova iOS crash event: https://github.com/photonstorm/phaser/issues/1800
	if(this.device.cordova&&this.device.iOS){this.lockRender=true;}}},/**
	    * Called by the Stage visibility handler.
	    *
	    * @method Phaser.Game#gameResumed
	    * @param {object} event - The DOM event that caused the game to pause, if any.
	    * @protected
	    */gameResumed:function gameResumed(event){//  Game is paused, but wasn't paused via code, so resume it
	if(this._paused&&!this._codePaused){this._paused=false;this.time.gameResumed();this.input.reset();if(this.sound.muteOnPause){this.sound.unsetMute();}this.onResume.dispatch(event);//  Avoids Cordova iOS crash event: https://github.com/photonstorm/phaser/issues/1800
	if(this.device.cordova&&this.device.iOS){this.lockRender=false;}}},/**
	    * Called by the Stage visibility handler.
	    *
	    * @method Phaser.Game#focusLoss
	    * @param {object} event - The DOM event that caused the game to pause, if any.
	    * @protected
	    */focusLoss:function focusLoss(event){this.onBlur.dispatch(event);if(!this.stage.disableVisibilityChange){this.gamePaused(event);}},/**
	    * Called by the Stage visibility handler.
	    *
	    * @method Phaser.Game#focusGain
	    * @param {object} event - The DOM event that caused the game to pause, if any.
	    * @protected
	    */focusGain:function focusGain(event){this.onFocus.dispatch(event);if(!this.stage.disableVisibilityChange){this.gameResumed(event);}}};Phaser.Game.prototype.constructor=Phaser.Game;/**
	* The paused state of the Game. A paused game doesn't update any of its subsystems.
	* When a game is paused the onPause event is dispatched. When it is resumed the onResume event is dispatched.
	* @name Phaser.Game#paused
	* @property {boolean} paused - Gets and sets the paused state of the Game.
	*/Object.defineProperty(Phaser.Game.prototype,"paused",{get:function get(){return this._paused;},set:function set(value){if(value===true){if(this._paused===false){this._paused=true;this.sound.setMute();this.time.gamePaused();this.onPause.dispatch(this);}this._codePaused=true;}else{if(this._paused){this._paused=false;this.input.reset();this.sound.unsetMute();this.time.gameResumed();this.onResume.dispatch(this);}this._codePaused=false;}}});/**
	 * 
	 * "Deleted code is debugged code." - Jeff Sickel
	 *
	 * ヽ(〃＾▽＾〃)ﾉ
	 * 
	*//**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Phaser.Input is the Input Manager for all types of Input across Phaser, including mouse, keyboard, touch and MSPointer.
	* The Input manager is updated automatically by the core game loop.
	*
	* @class Phaser.Input
	* @constructor
	* @param {Phaser.Game} game - Current game instance.
	*/Phaser.Input=function(game){/**
	    * @property {Phaser.Game} game - A reference to the currently running game.
	    */this.game=game;/**
	    * @property {HTMLCanvasElement} hitCanvas - The canvas to which single pixels are drawn in order to perform pixel-perfect hit detection.
	    * @default
	    */this.hitCanvas=null;/**
	    * @property {CanvasRenderingContext2D} hitContext - The context of the pixel perfect hit canvas.
	    * @default
	    */this.hitContext=null;/**
	    * An array of callbacks that will be fired every time the activePointer receives a move event from the DOM.
	    * To add a callback to this array please use `Input.addMoveCallback`.
	    * @property {array} moveCallbacks
	    * @protected
	    */this.moveCallbacks=[];/**
	    * @property {function} customCandidateHandler - See Input.setInteractiveCandidateHandler.
	    * @private
	    */this.customCandidateHandler=null;/**
	    * @property {object} customCandidateHandlerContext - See Input.setInteractiveCandidateHandler.
	    * @private
	    */this.customCandidateHandlerContext=null;/**
	    * @property {number} pollRate - How often should the input pointers be checked for updates? A value of 0 means every single frame (60fps); a value of 1 means every other frame (30fps) and so on.
	    * @default
	    */this.pollRate=0;/**
	    * When enabled, input (eg. Keyboard, Mouse, Touch) will be processed - as long as the individual sources are enabled themselves.
	    *
	    * When not enabled, _all_ input sources are ignored. To disable just one type of input; for example, the Mouse, use `input.mouse.enabled = false`.
	    * @property {boolean} enabled
	    * @default
	    */this.enabled=true;/**
	    * @property {number} multiInputOverride - Controls the expected behavior when using a mouse and touch together on a multi-input device.
	    * @default
	    */this.multiInputOverride=Phaser.Input.MOUSE_TOUCH_COMBINE;/**
	    * @property {Phaser.Point} position - A point object representing the current position of the Pointer.
	    * @default
	    */this.position=null;/**
	    * @property {Phaser.Point} speed - A point object representing the speed of the Pointer. Only really useful in single Pointer games; otherwise see the Pointer objects directly.
	    */this.speed=null;/**
	    * A Circle object centered on the x/y screen coordinates of the Input.
	    * Default size of 44px (Apples recommended "finger tip" size) but can be changed to anything.
	    * @property {Phaser.Circle} circle
	    */this.circle=null;/**
	    * @property {Phaser.Point} scale - The scale by which all input coordinates are multiplied; calculated by the ScaleManager. In an un-scaled game the values will be x = 1 and y = 1.
	    */this.scale=null;/**
	    * @property {integer} maxPointers - The maximum number of Pointers allowed to be active at any one time. A value of -1 is only limited by the total number of pointers. For lots of games it's useful to set this to 1.
	    * @default -1 (Limited by total pointers.)
	    */this.maxPointers=-1;/**
	    * @property {number} tapRate - The number of milliseconds that the Pointer has to be pressed down and then released to be considered a tap or click.
	    * @default
	    */this.tapRate=200;/**
	    * @property {number} doubleTapRate - The number of milliseconds between taps of the same Pointer for it to be considered a double tap / click.
	    * @default
	    */this.doubleTapRate=300;/**
	    * @property {number} holdRate - The number of milliseconds that the Pointer has to be pressed down for it to fire a onHold event.
	    * @default
	    */this.holdRate=2000;/**
	    * @property {number} justPressedRate - The number of milliseconds below which the Pointer is considered justPressed.
	    * @default
	    */this.justPressedRate=200;/**
	    * @property {number} justReleasedRate - The number of milliseconds below which the Pointer is considered justReleased .
	    * @default
	    */this.justReleasedRate=200;/**
	    * Sets if the Pointer objects should record a history of x/y coordinates they have passed through.
	    * The history is cleared each time the Pointer is pressed down.
	    * The history is updated at the rate specified in Input.pollRate
	    * @property {boolean} recordPointerHistory
	    * @default
	    */this.recordPointerHistory=false;/**
	    * @property {number} recordRate - The rate in milliseconds at which the Pointer objects should update their tracking history.
	    * @default
	    */this.recordRate=100;/**
	    * The total number of entries that can be recorded into the Pointer objects tracking history.
	    * If the Pointer is tracking one event every 100ms; then a trackLimit of 100 would store the last 10 seconds worth of history.
	    * @property {number} recordLimit
	    * @default
	    */this.recordLimit=100;/**
	    * @property {Phaser.Pointer} pointer1 - A Pointer object.
	    */this.pointer1=null;/**
	    * @property {Phaser.Pointer} pointer2 - A Pointer object.
	    */this.pointer2=null;/**
	    * @property {Phaser.Pointer} pointer3 - A Pointer object.
	    */this.pointer3=null;/**
	    * @property {Phaser.Pointer} pointer4 - A Pointer object.
	    */this.pointer4=null;/**
	    * @property {Phaser.Pointer} pointer5 - A Pointer object.
	    */this.pointer5=null;/**
	    * @property {Phaser.Pointer} pointer6 - A Pointer object.
	    */this.pointer6=null;/**
	    * @property {Phaser.Pointer} pointer7 - A Pointer object.
	    */this.pointer7=null;/**
	    * @property {Phaser.Pointer} pointer8 - A Pointer object.
	    */this.pointer8=null;/**
	    * @property {Phaser.Pointer} pointer9 - A Pointer object.
	    */this.pointer9=null;/**
	    * @property {Phaser.Pointer} pointer10 - A Pointer object.
	    */this.pointer10=null;/**
	    * An array of non-mouse pointers that have been added to the game.
	    * The properties `pointer1..N` are aliases for `pointers[0..N-1]`.
	    * @property {Phaser.Pointer[]} pointers
	    * @public
	    * @readonly
	    */this.pointers=[];/**
	    * The most recently active Pointer object.
	    * 
	    * When you've limited max pointers to 1 this will accurately be either the first finger touched or mouse.
	    * 
	    * @property {Phaser.Pointer} activePointer
	    */this.activePointer=null;/**
	    * The mouse has its own unique Phaser.Pointer object which you can use if making a desktop specific game.
	    * 
	    * @property {Pointer} mousePointer
	    */this.mousePointer=null;/**
	    * The Mouse Input manager.
	    * 
	    * You should not usually access this manager directly, but instead use Input.mousePointer or Input.activePointer 
	    * which normalizes all the input values for you, regardless of browser.
	    * 
	    * @property {Phaser.Mouse} mouse
	    */this.mouse=null;/**
	    * The Keyboard Input manager.
	    * 
	    * @property {Phaser.Keyboard} keyboard
	    */this.keyboard=null;/**
	    * The Touch Input manager.
	    * 
	    * You should not usually access this manager directly, but instead use Input.activePointer 
	    * which normalizes all the input values for you, regardless of browser.
	    * 
	    * @property {Phaser.Touch} touch
	    */this.touch=null;/**
	    * The MSPointer Input manager.
	    * 
	    * You should not usually access this manager directly, but instead use Input.activePointer 
	    * which normalizes all the input values for you, regardless of browser.
	    * 
	    * @property {Phaser.MSPointer} mspointer
	    */this.mspointer=null;/**
	    * The Gamepad Input manager.
	    * 
	    * @property {Phaser.Gamepad} gamepad
	    */this.gamepad=null;/**
	    * If the Input Manager has been reset locked then all calls made to InputManager.reset, 
	    * such as from a State change, are ignored.
	    * @property {boolean} resetLocked
	    * @default
	    */this.resetLocked=false;/**
	    * A Signal that is dispatched each time a pointer is pressed down.
	    * @property {Phaser.Signal} onDown
	    */this.onDown=null;/**
	    * A Signal that is dispatched each time a pointer is released.
	    * @property {Phaser.Signal} onUp
	    */this.onUp=null;/**
	    * A Signal that is dispatched each time a pointer is tapped.
	    * @property {Phaser.Signal} onTap
	    */this.onTap=null;/**
	    * A Signal that is dispatched each time a pointer is held down.
	    * @property {Phaser.Signal} onHold
	    */this.onHold=null;/**
	    * You can tell all Pointers to ignore any Game Object with a `priorityID` lower than this value.
	    * This is useful when stacking UI layers. Set to zero to disable.
	    * @property {number} minPriorityID
	    * @default
	    */this.minPriorityID=0;/**
	    * A list of interactive objects. The InputHandler components add and remove themselves from this list.
	    * @property {Phaser.ArraySet} interactiveItems
	    */this.interactiveItems=new Phaser.ArraySet();/**
	    * @property {Phaser.Point} _localPoint - Internal cache var.
	    * @private
	    */this._localPoint=new Phaser.Point();/**
	    * @property {number} _pollCounter - Internal var holding the current poll counter.
	    * @private
	    */this._pollCounter=0;/**
	    * @property {Phaser.Point} _oldPosition - A point object representing the previous position of the Pointer.
	    * @private
	    */this._oldPosition=null;/**
	    * @property {number} _x - x coordinate of the most recent Pointer event
	    * @private
	    */this._x=0;/**
	    * @property {number} _y - Y coordinate of the most recent Pointer event
	    * @private
	    */this._y=0;};/**
	* @constant
	* @type {number}
	*/Phaser.Input.MOUSE_OVERRIDES_TOUCH=0;/**
	* @constant
	* @type {number}
	*/Phaser.Input.TOUCH_OVERRIDES_MOUSE=1;/**
	* @constant
	* @type {number}
	*/Phaser.Input.MOUSE_TOUCH_COMBINE=2;/**
	* The maximum number of pointers that can be added. This excludes the mouse pointer.
	* @constant
	* @type {integer}
	*/Phaser.Input.MAX_POINTERS=10;Phaser.Input.prototype={/**
	    * Starts the Input Manager running.
	    *
	    * @method Phaser.Input#boot
	    * @protected
	    */boot:function boot(){this.mousePointer=new Phaser.Pointer(this.game,0,Phaser.PointerMode.CURSOR);this.addPointer();this.addPointer();this.mouse=new Phaser.Mouse(this.game);this.touch=new Phaser.Touch(this.game);this.mspointer=new Phaser.MSPointer(this.game);if(Phaser.Keyboard){this.keyboard=new Phaser.Keyboard(this.game);}if(Phaser.Gamepad){this.gamepad=new Phaser.Gamepad(this.game);}this.onDown=new Phaser.Signal();this.onUp=new Phaser.Signal();this.onTap=new Phaser.Signal();this.onHold=new Phaser.Signal();this.scale=new Phaser.Point(1,1);this.speed=new Phaser.Point();this.position=new Phaser.Point();this._oldPosition=new Phaser.Point();this.circle=new Phaser.Circle(0,0,44);this.activePointer=this.mousePointer;this.hitCanvas=PIXI.CanvasPool.create(this,1,1);this.hitContext=this.hitCanvas.getContext('2d');this.mouse.start();this.touch.start();this.mspointer.start();this.mousePointer.active=true;if(this.keyboard){this.keyboard.start();}var _this=this;this._onClickTrampoline=function(event){_this.onClickTrampoline(event);};this.game.canvas.addEventListener('click',this._onClickTrampoline,false);},/**
	    * Stops all of the Input Managers from running.
	    *
	    * @method Phaser.Input#destroy
	    */destroy:function destroy(){this.mouse.stop();this.touch.stop();this.mspointer.stop();if(this.keyboard){this.keyboard.stop();}if(this.gamepad){this.gamepad.stop();}this.moveCallbacks=[];PIXI.CanvasPool.remove(this);this.game.canvas.removeEventListener('click',this._onClickTrampoline);},/**
	    * Adds a callback that is fired every time `Pointer.processInteractiveObjects` is called.
	    * The purpose of `processInteractiveObjects` is to work out which Game Object the Pointer is going to
	    * interact with. It works by polling all of the valid game objects, and then slowly discounting those
	    * that don't meet the criteria (i.e. they aren't under the Pointer, are disabled, invisible, etc).
	    *
	    * Eventually a short-list of 'candidates' is created. These are all of the Game Objects which are valid
	    * for input and overlap with the Pointer. If you need fine-grained control over which of the items is
	    * selected then you can use this callback to do so.
	    *
	    * The callback will be sent 3 parameters:
	    * 
	    * 1) A reference to the Phaser.Pointer object that is processing the Items.
	    * 2) An array containing all potential interactive candidates. This is an array of `InputHandler` objects, not Sprites.
	    * 3) The current 'favorite' candidate, based on its priorityID and position in the display list.
	    *
	    * Your callback MUST return one of the candidates sent to it.
	    * 
	    * @method Phaser.Input#setInteractiveCandidateHandler
	    * @param {function} callback - The callback that will be called each time `Pointer.processInteractiveObjects` is called. Set to `null` to disable.
	    * @param {object} context - The context in which the callback will be called.
	    */setInteractiveCandidateHandler:function setInteractiveCandidateHandler(callback,context){this.customCandidateHandler=callback;this.customCandidateHandlerContext=context;},/**
	    * Adds a callback that is fired every time the activePointer receives a DOM move event such as a mousemove or touchmove.
	    *
	    * The callback will be sent 4 parameters:
	    * 
	    * A reference to the Phaser.Pointer object that moved,
	    * The x position of the pointer,
	    * The y position,
	    * A boolean indicating if the movement was the result of a 'click' event (such as a mouse click or touch down).
	    * 
	    * It will be called every time the activePointer moves, which in a multi-touch game can be a lot of times, so this is best
	    * to only use if you've limited input to a single pointer (i.e. mouse or touch).
	    * 
	    * The callback is added to the Phaser.Input.moveCallbacks array and should be removed with Phaser.Input.deleteMoveCallback.
	    * 
	    * @method Phaser.Input#addMoveCallback
	    * @param {function} callback - The callback that will be called each time the activePointer receives a DOM move event.
	    * @param {object} context - The context in which the callback will be called.
	    */addMoveCallback:function addMoveCallback(callback,context){this.moveCallbacks.push({callback:callback,context:context});},/**
	    * Removes the callback from the Phaser.Input.moveCallbacks array.
	    * 
	    * @method Phaser.Input#deleteMoveCallback
	    * @param {function} callback - The callback to be removed.
	    * @param {object} context - The context in which the callback exists.
	    */deleteMoveCallback:function deleteMoveCallback(callback,context){var i=this.moveCallbacks.length;while(i--){if(this.moveCallbacks[i].callback===callback&&this.moveCallbacks[i].context===context){this.moveCallbacks.splice(i,1);return;}}},/**
	    * Add a new Pointer object to the Input Manager.
	    * By default Input creates 3 pointer objects: `mousePointer` (not include in part of general pointer pool), `pointer1` and `pointer2`.
	    * This method adds an additional pointer, up to a maximum of Phaser.Input.MAX_POINTERS (default of 10).
	    *
	    * @method Phaser.Input#addPointer
	    * @return {Phaser.Pointer|null} The new Pointer object that was created; null if a new pointer could not be added.
	    */addPointer:function addPointer(){if(this.pointers.length>=Phaser.Input.MAX_POINTERS){console.warn("Phaser.Input.addPointer: Maximum limit of "+Phaser.Input.MAX_POINTERS+" pointers reached.");return null;}var id=this.pointers.length+1;var pointer=new Phaser.Pointer(this.game,id,Phaser.PointerMode.TOUCH);this.pointers.push(pointer);this['pointer'+id]=pointer;return pointer;},/**
	    * Updates the Input Manager. Called by the core Game loop.
	    * 
	    * @method Phaser.Input#update
	    * @protected
	    */update:function update(){if(this.keyboard){this.keyboard.update();}if(this.pollRate>0&&this._pollCounter<this.pollRate){this._pollCounter++;return;}this.speed.x=this.position.x-this._oldPosition.x;this.speed.y=this.position.y-this._oldPosition.y;this._oldPosition.copyFrom(this.position);this.mousePointer.update();if(this.gamepad&&this.gamepad.active){this.gamepad.update();}for(var i=0;i<this.pointers.length;i++){this.pointers[i].update();}this._pollCounter=0;},/**
	    * Reset all of the Pointers and Input states.
	    *
	    * The optional `hard` parameter will reset any events or callbacks that may be bound.
	    * Input.reset is called automatically during a State change or if a game loses focus / visibility.
	    * To control control the reset manually set {@link Phaser.InputManager.resetLocked} to `true`.
	    *
	    * @method Phaser.Input#reset
	    * @public
	    * @param {boolean} [hard=false] - A soft reset won't reset any events or callbacks that are bound. A hard reset will.
	    */reset:function reset(hard){if(!this.game.isBooted||this.resetLocked){return;}if(hard===undefined){hard=false;}this.mousePointer.reset();if(this.keyboard){this.keyboard.reset(hard);}if(this.gamepad){this.gamepad.reset();}for(var i=0;i<this.pointers.length;i++){this.pointers[i].reset();}if(this.game.canvas.style.cursor!=='none'){this.game.canvas.style.cursor='inherit';}if(hard){this.onDown.dispose();this.onUp.dispose();this.onTap.dispose();this.onHold.dispose();this.onDown=new Phaser.Signal();this.onUp=new Phaser.Signal();this.onTap=new Phaser.Signal();this.onHold=new Phaser.Signal();this.moveCallbacks=[];}this._pollCounter=0;},/**
	    * Resets the speed and old position properties.
	    *
	    * @method Phaser.Input#resetSpeed
	    * @param {number} x - Sets the oldPosition.x value.
	    * @param {number} y - Sets the oldPosition.y value.
	    */resetSpeed:function resetSpeed(x,y){this._oldPosition.setTo(x,y);this.speed.setTo(0,0);},/**
	    * Find the first free Pointer object and start it, passing in the event data.
	    * This is called automatically by Phaser.Touch and Phaser.MSPointer.
	    *
	    * @method Phaser.Input#startPointer
	    * @protected
	    * @param {any} event - The event data from the Touch event.
	    * @return {Phaser.Pointer} The Pointer object that was started or null if no Pointer object is available.
	    */startPointer:function startPointer(event){if(this.maxPointers>=0&&this.countActivePointers(this.maxPointers)>=this.maxPointers){return null;}if(!this.pointer1.active){return this.pointer1.start(event);}if(!this.pointer2.active){return this.pointer2.start(event);}for(var i=2;i<this.pointers.length;i++){var pointer=this.pointers[i];if(!pointer.active){return pointer.start(event);}}return null;},/**
	    * Updates the matching Pointer object, passing in the event data.
	    * This is called automatically and should not normally need to be invoked.
	    *
	    * @method Phaser.Input#updatePointer
	    * @protected
	    * @param {any} event - The event data from the Touch event.
	    * @return {Phaser.Pointer} The Pointer object that was updated; null if no pointer was updated.
	    */updatePointer:function updatePointer(event){if(this.pointer1.active&&this.pointer1.identifier===event.identifier){return this.pointer1.move(event);}if(this.pointer2.active&&this.pointer2.identifier===event.identifier){return this.pointer2.move(event);}for(var i=2;i<this.pointers.length;i++){var pointer=this.pointers[i];if(pointer.active&&pointer.identifier===event.identifier){return pointer.move(event);}}return null;},/**
	    * Stops the matching Pointer object, passing in the event data.
	    *
	    * @method Phaser.Input#stopPointer
	    * @protected
	    * @param {any} event - The event data from the Touch event.
	    * @return {Phaser.Pointer} The Pointer object that was stopped or null if no Pointer object is available.
	    */stopPointer:function stopPointer(event){if(this.pointer1.active&&this.pointer1.identifier===event.identifier){return this.pointer1.stop(event);}if(this.pointer2.active&&this.pointer2.identifier===event.identifier){return this.pointer2.stop(event);}for(var i=2;i<this.pointers.length;i++){var pointer=this.pointers[i];if(pointer.active&&pointer.identifier===event.identifier){return pointer.stop(event);}}return null;},/**
	    * Returns the total number of active pointers, not exceeding the specified limit
	    *
	    * @name Phaser.Input#countActivePointers
	    * @private
	    * @property {integer} [limit=(max pointers)] - Stop counting after this.
	    * @return {integer} The number of active pointers, or limit - whichever is less.
	    */countActivePointers:function countActivePointers(limit){if(limit===undefined){limit=this.pointers.length;}var count=limit;for(var i=0;i<this.pointers.length&&count>0;i++){var pointer=this.pointers[i];if(pointer.active){count--;}}return limit-count;},/**
	    * Get the first Pointer with the given active state.
	    *
	    * @method Phaser.Input#getPointer
	    * @param {boolean} [isActive=false] - The state the Pointer should be in - active or inactive?
	    * @return {Phaser.Pointer} A Pointer object or null if no Pointer object matches the requested state.
	    */getPointer:function getPointer(isActive){if(isActive===undefined){isActive=false;}for(var i=0;i<this.pointers.length;i++){var pointer=this.pointers[i];if(pointer.active===isActive){return pointer;}}return null;},/**
	    * Get the Pointer object whos `identifier` property matches the given identifier value.
	    *
	    * The identifier property is not set until the Pointer has been used at least once, as its populated by the DOM event.
	    * Also it can change every time you press the pointer down, and is not fixed once set.
	    * Note: Not all browsers set the identifier property and it's not part of the W3C spec, so you may need getPointerFromId instead.
	    *
	    * @method Phaser.Input#getPointerFromIdentifier
	    * @param {number} identifier - The Pointer.identifier value to search for.
	    * @return {Phaser.Pointer} A Pointer object or null if no Pointer object matches the requested identifier.
	    */getPointerFromIdentifier:function getPointerFromIdentifier(identifier){for(var i=0;i<this.pointers.length;i++){var pointer=this.pointers[i];if(pointer.identifier===identifier){return pointer;}}return null;},/**
	    * Get the Pointer object whos `pointerId` property matches the given value.
	    *
	    * The pointerId property is not set until the Pointer has been used at least once, as its populated by the DOM event.
	    * Also it can change every time you press the pointer down if the browser recycles it.
	    *
	    * @method Phaser.Input#getPointerFromId
	    * @param {number} pointerId - The `pointerId` (not 'id') value to search for.
	    * @return {Phaser.Pointer} A Pointer object or null if no Pointer object matches the requested identifier.
	    */getPointerFromId:function getPointerFromId(pointerId){for(var i=0;i<this.pointers.length;i++){var pointer=this.pointers[i];if(pointer.pointerId===pointerId){return pointer;}}return null;},/**
	    * This will return the local coordinates of the specified displayObject based on the given Pointer.
	    *
	    * @method Phaser.Input#getLocalPosition
	    * @param {Phaser.Sprite|Phaser.Image} displayObject - The DisplayObject to get the local coordinates for.
	    * @param {Phaser.Pointer} pointer - The Pointer to use in the check against the displayObject.
	    * @return {Phaser.Point} A point containing the coordinates of the Pointer position relative to the DisplayObject.
	    */getLocalPosition:function getLocalPosition(displayObject,pointer,output){if(output===undefined){output=new Phaser.Point();}var wt=displayObject.worldTransform;var id=1/(wt.a*wt.d+wt.c*-wt.b);return output.setTo(wt.d*id*pointer.x+-wt.c*id*pointer.y+(wt.ty*wt.c-wt.tx*wt.d)*id,wt.a*id*pointer.y+-wt.b*id*pointer.x+(-wt.ty*wt.a+wt.tx*wt.b)*id);},/**
	    * Tests if the pointer hits the given object.
	    *
	    * @method Phaser.Input#hitTest
	    * @param {DisplayObject} displayObject - The displayObject to test for a hit.
	    * @param {Phaser.Pointer} pointer - The pointer to use for the test.
	    * @param {Phaser.Point} localPoint - The local translated point.
	    */hitTest:function hitTest(displayObject,pointer,localPoint){if(!displayObject.worldVisible){return false;}this.getLocalPosition(displayObject,pointer,this._localPoint);localPoint.copyFrom(this._localPoint);if(displayObject.hitArea&&displayObject.hitArea.contains){return displayObject.hitArea.contains(this._localPoint.x,this._localPoint.y);}else if(displayObject instanceof Phaser.TileSprite){var width=displayObject.width;var height=displayObject.height;var x1=-width*displayObject.anchor.x;if(this._localPoint.x>=x1&&this._localPoint.x<x1+width){var y1=-height*displayObject.anchor.y;if(this._localPoint.y>=y1&&this._localPoint.y<y1+height){return true;}}}else if(displayObject instanceof PIXI.Sprite){var width=displayObject.texture.frame.width;var height=displayObject.texture.frame.height;var x1=-width*displayObject.anchor.x;if(this._localPoint.x>=x1&&this._localPoint.x<x1+width){var y1=-height*displayObject.anchor.y;if(this._localPoint.y>=y1&&this._localPoint.y<y1+height){return true;}}}else if(displayObject instanceof Phaser.Graphics){for(var i=0;i<displayObject.graphicsData.length;i++){var data=displayObject.graphicsData[i];if(!data.fill){continue;}//  Only deal with fills..
	if(data.shape&&data.shape.contains(this._localPoint.x,this._localPoint.y)){return true;}}}//  Didn't hit the parent, does it have any children?
	for(var i=0;i<displayObject.children.length;i++){if(this.hitTest(displayObject.children[i],pointer,localPoint)){return true;}}return false;},/**
	    * Used for click trampolines. See {@link Phaser.Pointer.addClickTrampoline}.
	    *
	    * @method Phaser.Input#onClickTrampoline
	    * @private
	    */onClickTrampoline:function onClickTrampoline(){// It might not always be the active pointer, but this does work on
	// Desktop browsers (read: IE) with Mouse or MSPointer input.
	this.activePointer.processClickTrampolines();}};Phaser.Input.prototype.constructor=Phaser.Input;/**
	* The X coordinate of the most recently active pointer.
	* This value takes game scaling into account automatically. See Pointer.screenX/clientX for source values.
	* @name Phaser.Input#x
	* @property {number} x
	*/Object.defineProperty(Phaser.Input.prototype,"x",{get:function get(){return this._x;},set:function set(value){this._x=Math.floor(value);}});/**
	* The Y coordinate of the most recently active pointer.
	* This value takes game scaling into account automatically. See Pointer.screenY/clientY for source values.
	* @name Phaser.Input#y
	* @property {number} y
	*/Object.defineProperty(Phaser.Input.prototype,"y",{get:function get(){return this._y;},set:function set(value){this._y=Math.floor(value);}});/**
	* True if the Input is currently poll rate locked.
	* @name Phaser.Input#pollLocked
	* @property {boolean} pollLocked
	* @readonly
	*/Object.defineProperty(Phaser.Input.prototype,"pollLocked",{get:function get(){return this.pollRate>0&&this._pollCounter<this.pollRate;}});/**
	* The total number of inactive Pointers.
	* @name Phaser.Input#totalInactivePointers
	* @property {number} totalInactivePointers
	* @readonly
	*/Object.defineProperty(Phaser.Input.prototype,"totalInactivePointers",{get:function get(){return this.pointers.length-this.countActivePointers();}});/**
	* The total number of active Pointers, not counting the mouse pointer.
	* @name Phaser.Input#totalActivePointers
	* @property {integers} totalActivePointers
	* @readonly
	*/Object.defineProperty(Phaser.Input.prototype,"totalActivePointers",{get:function get(){return this.countActivePointers();}});/**
	* The world X coordinate of the most recently active pointer.
	* @name Phaser.Input#worldX
	* @property {number} worldX - The world X coordinate of the most recently active pointer.
	* @readonly
	*/Object.defineProperty(Phaser.Input.prototype,"worldX",{get:function get(){return this.game.camera.view.x+this.x;}});/**
	* The world Y coordinate of the most recently active pointer.
	* @name Phaser.Input#worldY
	* @property {number} worldY - The world Y coordinate of the most recently active pointer.
	* @readonly
	*/Object.defineProperty(Phaser.Input.prototype,"worldY",{get:function get(){return this.game.camera.view.y+this.y;}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Mouse class is responsible for handling all aspects of mouse interaction with the browser.
	*
	* It captures and processes mouse events that happen on the game canvas object.
	* It also adds a single `mouseup` listener to `window` which is used to capture the mouse being released
	* when not over the game.
	*
	* You should not normally access this class directly, but instead use a Phaser.Pointer object
	* which normalises all game input for you, including accurate button handling.
	*
	* @class Phaser.Mouse
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	*/Phaser.Mouse=function(game){/**
	    * @property {Phaser.Game} game - A reference to the currently running game.
	    */this.game=game;/**
	    * @property {Phaser.Input} input - A reference to the Phaser Input Manager.
	    * @protected
	    */this.input=game.input;/**
	    * @property {object} callbackContext - The context under which callbacks are called.
	    */this.callbackContext=this.game;/**
	    * @property {function} mouseDownCallback - A callback that can be fired when the mouse is pressed down.
	    */this.mouseDownCallback=null;/**
	    * @property {function} mouseUpCallback - A callback that can be fired when the mouse is released from a pressed down state.
	    */this.mouseUpCallback=null;/**
	    * @property {function} mouseOutCallback - A callback that can be fired when the mouse is no longer over the game canvas.
	    */this.mouseOutCallback=null;/**
	    * @property {function} mouseOverCallback - A callback that can be fired when the mouse enters the game canvas (usually after a mouseout).
	    */this.mouseOverCallback=null;/**
	     * @property {function} mouseWheelCallback - A callback that can be fired when the mousewheel is used.
	     */this.mouseWheelCallback=null;/**
	    * @property {boolean} capture - If true the DOM mouse events will have event.preventDefault applied to them, if false they will propagate fully.
	    */this.capture=false;/**
	    * This property was removed in Phaser 2.4 and should no longer be used.
	    * Instead please see the Pointer button properties such as `Pointer.leftButton`, `Pointer.rightButton` and so on.
	    * Or Pointer.button holds the DOM event button value if you require that.
	    * @property {number} button
	    * @default
	    */this.button=-1;/**
	     * The direction of the _last_ mousewheel usage 1 for up -1 for down.
	     * @property {number} wheelDelta
	     */this.wheelDelta=0;/**
	    * Mouse input will only be processed if enabled.
	    * @property {boolean} enabled
	    * @default
	    */this.enabled=true;/**
	    * @property {boolean} locked - If the mouse has been Pointer Locked successfully this will be set to true.
	    * @default
	    */this.locked=false;/**
	    * @property {boolean} stopOnGameOut - If true Pointer.stop will be called if the mouse leaves the game canvas.
	    * @default
	    */this.stopOnGameOut=false;/**
	    * @property {Phaser.Signal} pointerLock - This event is dispatched when the browser enters or leaves pointer lock state.
	    * @default
	    */this.pointerLock=new Phaser.Signal();/**
	    * The browser mouse DOM event. Will be null if no mouse event has ever been received.
	    * Access this property only inside a Mouse event handler and do not keep references to it.
	    * @property {MouseEvent|null} event
	    * @default
	    */this.event=null;/**
	    * @property {function} _onMouseDown - Internal event handler reference.
	    * @private
	    */this._onMouseDown=null;/**
	    * @property {function} _onMouseMove - Internal event handler reference.
	    * @private
	    */this._onMouseMove=null;/**
	    * @property {function} _onMouseUp - Internal event handler reference.
	    * @private
	    */this._onMouseUp=null;/**
	    * @property {function} _onMouseOut - Internal event handler reference.
	    * @private
	    */this._onMouseOut=null;/**
	    * @property {function} _onMouseOver - Internal event handler reference.
	    * @private
	    */this._onMouseOver=null;/**
	    * @property {function} _onMouseWheel - Internal event handler reference.
	    * @private
	    */this._onMouseWheel=null;/**
	    * Wheel proxy event object, if required. Shared for all wheel events for this mouse.
	    * @property {Phaser.Mouse~WheelEventProxy} _wheelEvent
	    * @private
	    */this._wheelEvent=null;};/**
	* @constant
	* @type {number}
	*/Phaser.Mouse.NO_BUTTON=-1;/**
	* @constant
	* @type {number}
	*/Phaser.Mouse.LEFT_BUTTON=0;/**
	* @constant
	* @type {number}
	*/Phaser.Mouse.MIDDLE_BUTTON=1;/**
	* @constant
	* @type {number}
	*/Phaser.Mouse.RIGHT_BUTTON=2;/**
	* @constant
	* @type {number}
	*/Phaser.Mouse.BACK_BUTTON=3;/**
	* @constant
	* @type {number}
	*/Phaser.Mouse.FORWARD_BUTTON=4;/**
	 * @constant
	 * @type {number}
	 */Phaser.Mouse.WHEEL_UP=1;/**
	 * @constant
	 * @type {number}
	 */Phaser.Mouse.WHEEL_DOWN=-1;Phaser.Mouse.prototype={/**
	    * Starts the event listeners running.
	    * @method Phaser.Mouse#start
	    */start:function start(){if(this.game.device.android&&this.game.device.chrome===false){//  Android stock browser fires mouse events even if you preventDefault on the touchStart, so ...
	return;}if(this._onMouseDown!==null){//  Avoid setting multiple listeners
	return;}var _this=this;this._onMouseDown=function(event){return _this.onMouseDown(event);};this._onMouseMove=function(event){return _this.onMouseMove(event);};this._onMouseUp=function(event){return _this.onMouseUp(event);};this._onMouseUpGlobal=function(event){return _this.onMouseUpGlobal(event);};this._onMouseOutGlobal=function(event){return _this.onMouseOutGlobal(event);};this._onMouseOut=function(event){return _this.onMouseOut(event);};this._onMouseOver=function(event){return _this.onMouseOver(event);};this._onMouseWheel=function(event){return _this.onMouseWheel(event);};var canvas=this.game.canvas;canvas.addEventListener('mousedown',this._onMouseDown,true);canvas.addEventListener('mousemove',this._onMouseMove,true);canvas.addEventListener('mouseup',this._onMouseUp,true);if(!this.game.device.cocoonJS){window.addEventListener('mouseup',this._onMouseUpGlobal,true);window.addEventListener('mouseout',this._onMouseOutGlobal,true);canvas.addEventListener('mouseover',this._onMouseOver,true);canvas.addEventListener('mouseout',this._onMouseOut,true);}var wheelEvent=this.game.device.wheelEvent;if(wheelEvent){canvas.addEventListener(wheelEvent,this._onMouseWheel,true);if(wheelEvent==='mousewheel'){this._wheelEvent=new WheelEventProxy(-1/40,1);}else if(wheelEvent==='DOMMouseScroll'){this._wheelEvent=new WheelEventProxy(1,1);}}},/**
	    * The internal method that handles the mouse down event from the browser.
	    * @method Phaser.Mouse#onMouseDown
	    * @param {MouseEvent} event - The native event from the browser. This gets stored in Mouse.event.
	    */onMouseDown:function onMouseDown(event){this.event=event;if(this.capture){event.preventDefault();}if(this.mouseDownCallback){this.mouseDownCallback.call(this.callbackContext,event);}if(!this.input.enabled||!this.enabled){return;}event['identifier']=0;this.input.mousePointer.start(event);},/**
	    * The internal method that handles the mouse move event from the browser.
	    * @method Phaser.Mouse#onMouseMove
	    * @param {MouseEvent} event - The native event from the browser. This gets stored in Mouse.event.
	    */onMouseMove:function onMouseMove(event){this.event=event;if(this.capture){event.preventDefault();}if(this.mouseMoveCallback){this.mouseMoveCallback.call(this.callbackContext,event);}if(!this.input.enabled||!this.enabled){return;}event['identifier']=0;this.input.mousePointer.move(event);},/**
	    * The internal method that handles the mouse up event from the browser.
	    * @method Phaser.Mouse#onMouseUp
	    * @param {MouseEvent} event - The native event from the browser. This gets stored in Mouse.event.
	    */onMouseUp:function onMouseUp(event){this.event=event;if(this.capture){event.preventDefault();}if(this.mouseUpCallback){this.mouseUpCallback.call(this.callbackContext,event);}if(!this.input.enabled||!this.enabled){return;}event['identifier']=0;this.input.mousePointer.stop(event);},/**
	    * The internal method that handles the mouse up event from the window.
	    *
	    * @method Phaser.Mouse#onMouseUpGlobal
	    * @param {MouseEvent} event - The native event from the browser. This gets stored in Mouse.event.
	    */onMouseUpGlobal:function onMouseUpGlobal(event){if(!this.input.mousePointer.withinGame){if(this.mouseUpCallback){this.mouseUpCallback.call(this.callbackContext,event);}event['identifier']=0;this.input.mousePointer.stop(event);}},/**
	    * The internal method that handles the mouse out event from the window.
	    *
	    * @method Phaser.Mouse#onMouseOutGlobal
	    * @param {MouseEvent} event - The native event from the browser. This gets stored in Mouse.event.
	    */onMouseOutGlobal:function onMouseOutGlobal(event){this.event=event;if(this.capture){event.preventDefault();}this.input.mousePointer.withinGame=false;if(!this.input.enabled||!this.enabled){return;}//  If we get a mouseout event from the window then basically
	//  something serious has gone down, usually along the lines of
	//  the browser opening a context-menu or similar.
	//  On OS X Chrome especially this is bad news, as it blocks
	//  us then getting a mouseup event, so we need to force that through.
	//
	//  No matter what, we must cancel the left and right buttons
	this.input.mousePointer.stop(event);this.input.mousePointer.leftButton.stop(event);this.input.mousePointer.rightButton.stop(event);},/**
	    * The internal method that handles the mouse out event from the browser.
	    *
	    * @method Phaser.Mouse#onMouseOut
	    * @param {MouseEvent} event - The native event from the browser. This gets stored in Mouse.event.
	    */onMouseOut:function onMouseOut(event){this.event=event;if(this.capture){event.preventDefault();}this.input.mousePointer.withinGame=false;if(this.mouseOutCallback){this.mouseOutCallback.call(this.callbackContext,event);}if(!this.input.enabled||!this.enabled){return;}if(this.stopOnGameOut){event['identifier']=0;this.input.mousePointer.stop(event);}},/**
	    * The internal method that handles the mouse over event from the browser.
	    *
	    * @method Phaser.Mouse#onMouseOver
	    * @param {MouseEvent} event - The native event from the browser. This gets stored in Mouse.event.
	    */onMouseOver:function onMouseOver(event){this.event=event;if(this.capture){event.preventDefault();}this.input.mousePointer.withinGame=true;if(this.mouseOverCallback){this.mouseOverCallback.call(this.callbackContext,event);}},/**
	     * The internal method that handles the mouse wheel event from the browser.
	     *
	     * @method Phaser.Mouse#onMouseWheel
	     * @param {MouseEvent} event - The native event from the browser.
	     */onMouseWheel:function onMouseWheel(event){if(this._wheelEvent){event=this._wheelEvent.bindEvent(event);}this.event=event;if(this.capture){event.preventDefault();}// reverse detail for firefox
	this.wheelDelta=Phaser.Math.clamp(-event.deltaY,-1,1);if(this.mouseWheelCallback){this.mouseWheelCallback.call(this.callbackContext,event);}},/**
	    * If the browser supports it you can request that the pointer be locked to the browser window.
	    * This is classically known as 'FPS controls', where the pointer can't leave the browser until the user presses an exit key.
	    * If the browser successfully enters a locked state the event Phaser.Mouse.pointerLock will be dispatched and the first parameter will be 'true'.
	    * @method Phaser.Mouse#requestPointerLock
	    */requestPointerLock:function requestPointerLock(){if(this.game.device.pointerLock){var element=this.game.canvas;element.requestPointerLock=element.requestPointerLock||element.mozRequestPointerLock||element.webkitRequestPointerLock;element.requestPointerLock();var _this=this;this._pointerLockChange=function(event){return _this.pointerLockChange(event);};document.addEventListener('pointerlockchange',this._pointerLockChange,true);document.addEventListener('mozpointerlockchange',this._pointerLockChange,true);document.addEventListener('webkitpointerlockchange',this._pointerLockChange,true);}},/**
	    * Internal pointerLockChange handler.
	    *
	    * @method Phaser.Mouse#pointerLockChange
	    * @param {Event} event - The native event from the browser. This gets stored in Mouse.event.
	    */pointerLockChange:function pointerLockChange(event){var element=this.game.canvas;if(document.pointerLockElement===element||document.mozPointerLockElement===element||document.webkitPointerLockElement===element){//  Pointer was successfully locked
	this.locked=true;this.pointerLock.dispatch(true,event);}else{//  Pointer was unlocked
	this.locked=false;this.pointerLock.dispatch(false,event);}},/**
	    * Internal release pointer lock handler.
	    * @method Phaser.Mouse#releasePointerLock
	    */releasePointerLock:function releasePointerLock(){document.exitPointerLock=document.exitPointerLock||document.mozExitPointerLock||document.webkitExitPointerLock;document.exitPointerLock();document.removeEventListener('pointerlockchange',this._pointerLockChange,true);document.removeEventListener('mozpointerlockchange',this._pointerLockChange,true);document.removeEventListener('webkitpointerlockchange',this._pointerLockChange,true);},/**
	    * Stop the event listeners.
	    * @method Phaser.Mouse#stop
	    */stop:function stop(){var canvas=this.game.canvas;canvas.removeEventListener('mousedown',this._onMouseDown,true);canvas.removeEventListener('mousemove',this._onMouseMove,true);canvas.removeEventListener('mouseup',this._onMouseUp,true);canvas.removeEventListener('mouseover',this._onMouseOver,true);canvas.removeEventListener('mouseout',this._onMouseOut,true);var wheelEvent=this.game.device.wheelEvent;if(wheelEvent){canvas.removeEventListener(wheelEvent,this._onMouseWheel,true);}window.removeEventListener('mouseup',this._onMouseUpGlobal,true);window.removeEventListener('mouseout',this._onMouseOutGlobal,true);document.removeEventListener('pointerlockchange',this._pointerLockChange,true);document.removeEventListener('mozpointerlockchange',this._pointerLockChange,true);document.removeEventListener('webkitpointerlockchange',this._pointerLockChange,true);}};Phaser.Mouse.prototype.constructor=Phaser.Mouse;/* jshint latedef:nofunc *//**
	* A purely internal event support class to proxy 'wheelscroll' and 'DOMMouseWheel'
	* events to 'wheel'-like events.
	*
	* See https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel for choosing a scale and delta mode.
	*
	* @method Phaser.Mouse#WheelEventProxy
	* @private
	* @param {number} scaleFactor - Scale factor as applied to wheelDelta/wheelDeltaX or details.
	* @param {integer} deltaMode - The reported delta mode.
	*/function WheelEventProxy(scaleFactor,deltaMode){/**
	    * @property {number} _scaleFactor - Scale factor as applied to wheelDelta/wheelDeltaX or details.
	    * @private
	    */this._scaleFactor=scaleFactor;/**
	    * @property {number} _deltaMode - The reported delta mode.
	    * @private
	    */this._deltaMode=deltaMode;/**
	    * @property {any} originalEvent - The original event _currently_ being proxied; the getters will follow suit.
	    * @private
	    */this.originalEvent=null;}WheelEventProxy.prototype={};WheelEventProxy.prototype.constructor=WheelEventProxy;WheelEventProxy.prototype.bindEvent=function(event){// Generate stubs automatically
	if(!WheelEventProxy._stubsGenerated&&event){var makeBinder=function makeBinder(name){return function(){var v=this.originalEvent[name];return typeof v!=='function'?v:v.bind(this.originalEvent);};};for(var prop in event){if(!(prop in WheelEventProxy.prototype)){Object.defineProperty(WheelEventProxy.prototype,prop,{get:makeBinder(prop)});}}WheelEventProxy._stubsGenerated=true;}this.originalEvent=event;return this;};Object.defineProperties(WheelEventProxy.prototype,{"type":{value:"wheel"},"deltaMode":{get:function get(){return this._deltaMode;}},"deltaY":{get:function get(){return this._scaleFactor*(this.originalEvent.wheelDelta||this.originalEvent.detail)||0;}},"deltaX":{get:function get(){return this._scaleFactor*this.originalEvent.wheelDeltaX||0;}},"deltaZ":{value:0}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The MSPointer class handles Microsoft touch interactions with the game and the resulting Pointer objects.
	*
	* It will work only in Internet Explorer 10+ and Windows Store or Windows Phone 8 apps using JavaScript.
	* http://msdn.microsoft.com/en-us/library/ie/hh673557(v=vs.85).aspx
	*
	* You should not normally access this class directly, but instead use a Phaser.Pointer object which 
	* normalises all game input for you including accurate button handling.
	*
	* Please note that at the current time of writing Phaser does not yet support chorded button interactions:
	* http://www.w3.org/TR/pointerevents/#chorded-button-interactions
	*
	* @class Phaser.MSPointer
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	*/Phaser.MSPointer=function(game){/**
	    * @property {Phaser.Game} game - A reference to the currently running game.
	    */this.game=game;/**
	    * @property {Phaser.Input} input - A reference to the Phaser Input Manager.
	    * @protected
	    */this.input=game.input;/**
	    * @property {object} callbackContext - The context under which callbacks are called (defaults to game).
	    */this.callbackContext=this.game;/**
	    * @property {function} pointerDownCallback - A callback that can be fired on a MSPointerDown event.
	    */this.pointerDownCallback=null;/**
	    * @property {function} pointerMoveCallback - A callback that can be fired on a MSPointerMove event.
	    */this.pointerMoveCallback=null;/**
	    * @property {function} pointerUpCallback - A callback that can be fired on a MSPointerUp event.
	    */this.pointerUpCallback=null;/**
	    * @property {boolean} capture - If true the Pointer events will have event.preventDefault applied to them, if false they will propagate fully.
	    */this.capture=true;/**
	    * This property was removed in Phaser 2.4 and should no longer be used.
	    * Instead please see the Pointer button properties such as `Pointer.leftButton`, `Pointer.rightButton` and so on.
	    * Or Pointer.button holds the DOM event button value if you require that.
	    * @property {number} button
	    */this.button=-1;/**
	    * The browser MSPointer DOM event. Will be null if no event has ever been received.
	    * Access this property only inside a Pointer event handler and do not keep references to it.
	    * @property {MSPointerEvent|null} event
	    * @default
	    */this.event=null;/**
	    * MSPointer input will only be processed if enabled.
	    * @property {boolean} enabled
	    * @default
	    */this.enabled=true;/**
	    * @property {function} _onMSPointerDown - Internal function to handle MSPointer events.
	    * @private
	    */this._onMSPointerDown=null;/**
	    * @property {function} _onMSPointerMove - Internal function to handle MSPointer events.
	    * @private
	    */this._onMSPointerMove=null;/**
	    * @property {function} _onMSPointerUp - Internal function to handle MSPointer events.
	    * @private
	    */this._onMSPointerUp=null;/**
	    * @property {function} _onMSPointerUpGlobal - Internal function to handle MSPointer events.
	    * @private
	    */this._onMSPointerUpGlobal=null;/**
	    * @property {function} _onMSPointerOut - Internal function to handle MSPointer events.
	    * @private
	    */this._onMSPointerOut=null;/**
	    * @property {function} _onMSPointerOver - Internal function to handle MSPointer events.
	    * @private
	    */this._onMSPointerOver=null;};Phaser.MSPointer.prototype={/**
	    * Starts the event listeners running.
	    * @method Phaser.MSPointer#start
	    */start:function start(){if(this._onMSPointerDown!==null){//  Avoid setting multiple listeners
	return;}var _this=this;if(this.game.device.mspointer){this._onMSPointerDown=function(event){return _this.onPointerDown(event);};this._onMSPointerMove=function(event){return _this.onPointerMove(event);};this._onMSPointerUp=function(event){return _this.onPointerUp(event);};this._onMSPointerUpGlobal=function(event){return _this.onPointerUpGlobal(event);};this._onMSPointerOut=function(event){return _this.onPointerOut(event);};this._onMSPointerOver=function(event){return _this.onPointerOver(event);};var canvas=this.game.canvas;canvas.addEventListener('MSPointerDown',this._onMSPointerDown,false);canvas.addEventListener('MSPointerMove',this._onMSPointerMove,false);canvas.addEventListener('MSPointerUp',this._onMSPointerUp,false);//  IE11+ uses non-prefix events
	canvas.addEventListener('pointerdown',this._onMSPointerDown,false);canvas.addEventListener('pointermove',this._onMSPointerMove,false);canvas.addEventListener('pointerup',this._onMSPointerUp,false);canvas.style['-ms-content-zooming']='none';canvas.style['-ms-touch-action']='none';if(!this.game.device.cocoonJS){window.addEventListener('MSPointerUp',this._onMSPointerUpGlobal,true);canvas.addEventListener('MSPointerOver',this._onMSPointerOver,true);canvas.addEventListener('MSPointerOut',this._onMSPointerOut,true);//  IE11+ uses non-prefix events
	window.addEventListener('pointerup',this._onMSPointerUpGlobal,true);canvas.addEventListener('pointerover',this._onMSPointerOver,true);canvas.addEventListener('pointerout',this._onMSPointerOut,true);}}},/**
	    * The function that handles the PointerDown event.
	    * 
	    * @method Phaser.MSPointer#onPointerDown
	    * @param {PointerEvent} event - The native DOM event.
	    */onPointerDown:function onPointerDown(event){this.event=event;if(this.capture){event.preventDefault();}if(this.pointerDownCallback){this.pointerDownCallback.call(this.callbackContext,event);}if(!this.input.enabled||!this.enabled){return;}event.identifier=event.pointerId;if(event.pointerType==='mouse'||event.pointerType===0x00000004){this.input.mousePointer.start(event);}else{this.input.startPointer(event);}},/**
	    * The function that handles the PointerMove event.
	    * @method Phaser.MSPointer#onPointerMove
	    * @param {PointerEvent} event - The native DOM event.
	    */onPointerMove:function onPointerMove(event){this.event=event;if(this.capture){event.preventDefault();}if(this.pointerMoveCallback){this.pointerMoveCallback.call(this.callbackContext,event);}if(!this.input.enabled||!this.enabled){return;}event.identifier=event.pointerId;if(event.pointerType==='mouse'||event.pointerType===0x00000004){this.input.mousePointer.move(event);}else{this.input.updatePointer(event);}},/**
	    * The function that handles the PointerUp event.
	    * @method Phaser.MSPointer#onPointerUp
	    * @param {PointerEvent} event - The native DOM event.
	    */onPointerUp:function onPointerUp(event){this.event=event;if(this.capture){event.preventDefault();}if(this.pointerUpCallback){this.pointerUpCallback.call(this.callbackContext,event);}if(!this.input.enabled||!this.enabled){return;}event.identifier=event.pointerId;if(event.pointerType==='mouse'||event.pointerType===0x00000004){this.input.mousePointer.stop(event);}else{this.input.stopPointer(event);}},/**
	    * The internal method that handles the mouse up event from the window.
	    * 
	    * @method Phaser.MSPointer#onPointerUpGlobal
	    * @param {PointerEvent} event - The native event from the browser. This gets stored in MSPointer.event.
	    */onPointerUpGlobal:function onPointerUpGlobal(event){if((event.pointerType==='mouse'||event.pointerType===0x00000004)&&!this.input.mousePointer.withinGame){this.onPointerUp(event);}else{var pointer=this.input.getPointerFromIdentifier(event.identifier);if(pointer&&pointer.withinGame){this.onPointerUp(event);}}},/**
	    * The internal method that handles the pointer out event from the browser.
	    *
	    * @method Phaser.MSPointer#onPointerOut
	    * @param {PointerEvent} event - The native event from the browser. This gets stored in MSPointer.event.
	    */onPointerOut:function onPointerOut(event){this.event=event;if(this.capture){event.preventDefault();}if(event.pointerType==='mouse'||event.pointerType===0x00000004){this.input.mousePointer.withinGame=false;}else{var pointer=this.input.getPointerFromIdentifier(event.identifier);if(pointer){pointer.withinGame=false;}}if(this.input.mouse.mouseOutCallback){this.input.mouse.mouseOutCallback.call(this.input.mouse.callbackContext,event);}if(!this.input.enabled||!this.enabled){return;}if(this.input.mouse.stopOnGameOut){event['identifier']=0;if(pointer){pointer.stop(event);}else{this.input.mousePointer.stop(event);}}},/**
	    * The internal method that handles the pointer out event from the browser.
	    *
	    * @method Phaser.MSPointer#onPointerOut
	    * @param {PointerEvent} event - The native event from the browser. This gets stored in MSPointer.event.
	    */onPointerOver:function onPointerOver(event){this.event=event;if(this.capture){event.preventDefault();}if(event.pointerType==='mouse'||event.pointerType===0x00000004){this.input.mousePointer.withinGame=true;}else{var pointer=this.input.getPointerFromIdentifier(event.identifier);if(pointer){pointer.withinGame=true;}}if(this.input.mouse.mouseOverCallback){this.input.mouse.mouseOverCallback.call(this.input.mouse.callbackContext,event);}},/**
	    * Stop the event listeners.
	    * @method Phaser.MSPointer#stop
	    */stop:function stop(){var canvas=this.game.canvas;canvas.removeEventListener('MSPointerDown',this._onMSPointerDown,false);canvas.removeEventListener('MSPointerMove',this._onMSPointerMove,false);canvas.removeEventListener('MSPointerUp',this._onMSPointerUp,false);//  IE11+ uses non-prefix events
	canvas.removeEventListener('pointerdown',this._onMSPointerDown,false);canvas.removeEventListener('pointermove',this._onMSPointerMove,false);canvas.removeEventListener('pointerup',this._onMSPointerUp,false);window.removeEventListener('MSPointerUp',this._onMSPointerUpGlobal,true);canvas.removeEventListener('MSPointerOver',this._onMSPointerOver,true);canvas.removeEventListener('MSPointerOut',this._onMSPointerOut,true);//  IE11+ uses non-prefix events
	window.removeEventListener('pointerup',this._onMSPointerUpGlobal,true);canvas.removeEventListener('pointerover',this._onMSPointerOver,true);canvas.removeEventListener('pointerout',this._onMSPointerOut,true);}};Phaser.MSPointer.prototype.constructor=Phaser.MSPointer;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @author       @karlmacklin <tacklemcclean@gmail.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* DeviceButtons belong to both `Phaser.Pointer` and `Phaser.SinglePad` (Gamepad) instances.
	*
	* For Pointers they represent the various buttons that can exist on mice and pens, such as the left button, right button,
	* middle button and advanced buttons like back and forward.
	*
	* Access them via `Pointer.leftbutton`, `Pointer.rightButton` and so on.
	*
	* On Gamepads they represent all buttons on the pad: from shoulder buttons to action buttons.
	*
	* At the time of writing this there are device limitations you should be aware of:
	*
	* - On Windows, if you install a mouse driver, and its utility software allows you to customize button actions 
	*   (e.g., IntelliPoint and SetPoint), the middle (wheel) button, the 4th button, and the 5th button might not be set, 
	*   even when they are pressed.
	* - On Linux (GTK), the 4th button and the 5th button are not supported.
	* - On Mac OS X 10.5 there is no platform API for implementing any advanced buttons.
	* 
	* @class Phaser.DeviceButton
	* @constructor
	* @param {Phaser.Pointer|Phaser.SinglePad} parent - A reference to the parent of this button. Either a Pointer or a Gamepad.
	* @param {number} buttonCode - The button code this DeviceButton is responsible for.
	*/Phaser.DeviceButton=function(parent,buttonCode){/**
	    * @property {Phaser.Pointer|Phaser.SinglePad} parent - A reference to the Pointer or Gamepad that owns this button.
	    */this.parent=parent;/**
	    * @property {Phaser.Game} game - A reference to the currently running game.
	    */this.game=parent.game;/**
	    * @property {object} event - The DOM event that caused the change in button state.
	    * @default
	    */this.event=null;/**
	    * @property {boolean} isDown - The "down" state of the button.
	    * @default
	    */this.isDown=false;/**
	    * @property {boolean} isUp - The "up" state of the button.
	    * @default
	    */this.isUp=true;/**
	    * @property {number} timeDown - The timestamp when the button was last pressed down.
	    * @default
	    */this.timeDown=0;/**
	    * @property {number} timeUp - The timestamp when the button was last released.
	    * @default
	    */this.timeUp=0;/**
	    * Gamepad only.
	    * If a button is held down this holds down the number of times the button has 'repeated'.
	    * @property {number} repeats
	    * @default
	    */this.repeats=0;/**
	    * True if the alt key was held down when this button was last pressed or released.
	    * Not supported on Gamepads.
	    * @property {boolean} altKey
	    * @default
	    */this.altKey=false;/**
	    * True if the shift key was held down when this button was last pressed or released.
	    * Not supported on Gamepads.
	    * @property {boolean} shiftKey
	    * @default
	    */this.shiftKey=false;/**
	    * True if the control key was held down when this button was last pressed or released.
	    * Not supported on Gamepads.
	    * @property {boolean} ctrlKey
	    * @default
	    */this.ctrlKey=false;/**
	    * @property {number} value - Button value. Mainly useful for checking analog buttons (like shoulder triggers) on Gamepads.
	    * @default
	    */this.value=0;/**
	    * @property {number} buttonCode - The buttoncode of this button if a Gamepad, or the DOM button event value if a Pointer.
	    */this.buttonCode=buttonCode;/**
	    * This Signal is dispatched every time this DeviceButton is pressed down.
	    * It is only dispatched once (until the button is released again).
	    * When dispatched it sends 2 arguments: A reference to this DeviceButton and the value of the button.
	    * @property {Phaser.Signal} onDown
	    */this.onDown=new Phaser.Signal();/**
	    * This Signal is dispatched every time this DeviceButton is released from a down state.
	    * It is only dispatched once (until the button is pressed again).
	    * When dispatched it sends 2 arguments: A reference to this DeviceButton and the value of the button.
	    * @property {Phaser.Signal} onUp
	    */this.onUp=new Phaser.Signal();/**
	    * Gamepad only.
	    * This Signal is dispatched every time this DeviceButton changes floating value (between, but not exactly, 0 and 1).
	    * When dispatched it sends 2 arguments: A reference to this DeviceButton and the value of the button.
	    * @property {Phaser.Signal} onFloat
	    */this.onFloat=new Phaser.Signal();};Phaser.DeviceButton.prototype={/**
	    * Called automatically by Phaser.Pointer and Phaser.SinglePad.
	    * Handles the button down state.
	    * 
	    * @method Phaser.DeviceButton#start
	    * @protected
	    * @param {object} [event] - The DOM event that triggered the button change.
	    * @param {number} [value] - The button value. Only get for Gamepads.
	    */start:function start(event,value){if(this.isDown){return;}this.isDown=true;this.isUp=false;this.timeDown=this.game.time.time;this.repeats=0;this.event=event;this.value=value;if(event){this.altKey=event.altKey;this.shiftKey=event.shiftKey;this.ctrlKey=event.ctrlKey;}this.onDown.dispatch(this,value);},/**
	    * Called automatically by Phaser.Pointer and Phaser.SinglePad.
	    * Handles the button up state.
	    * 
	    * @method Phaser.DeviceButton#stop
	    * @protected
	    * @param {object} [event] - The DOM event that triggered the button change.
	    * @param {number} [value] - The button value. Only get for Gamepads.
	    */stop:function stop(event,value){if(this.isUp){return;}this.isDown=false;this.isUp=true;this.timeUp=this.game.time.time;this.event=event;this.value=value;if(event){this.altKey=event.altKey;this.shiftKey=event.shiftKey;this.ctrlKey=event.ctrlKey;}this.onUp.dispatch(this,value);},/**
	    * Called automatically by Phaser.SinglePad.
	    * 
	    * @method Phaser.DeviceButton#padFloat
	    * @protected
	    * @param {number} value - Button value
	    */padFloat:function padFloat(value){this.value=value;this.onFloat.dispatch(this,value);},/**
	    * Returns the "just pressed" state of this button.
	    * Just pressed is considered true if the button was pressed down within the duration given (default 250ms).
	    * 
	    * @method Phaser.DeviceButton#justPressed
	    * @param {number} [duration=250] - The duration in ms below which the button is considered as being just pressed.
	    * @return {boolean} True if the button is just pressed otherwise false.
	    */justPressed:function justPressed(duration){duration=duration||250;return this.isDown&&this.timeDown+duration>this.game.time.time;},/**
	    * Returns the "just released" state of this button.
	    * Just released is considered as being true if the button was released within the duration given (default 250ms).
	    * 
	    * @method Phaser.DeviceButton#justReleased
	    * @param {number} [duration=250] - The duration in ms below which the button is considered as being just released.
	    * @return {boolean} True if the button is just released otherwise false.
	    */justReleased:function justReleased(duration){duration=duration||250;return this.isUp&&this.timeUp+duration>this.game.time.time;},/**
	    * Resets this DeviceButton, changing it to an isUp state and resetting the duration and repeats counters.
	    * 
	    * @method Phaser.DeviceButton#reset
	    */reset:function reset(){this.isDown=false;this.isUp=true;this.timeDown=this.game.time.time;this.repeats=0;this.altKey=false;this.shiftKey=false;this.ctrlKey=false;},/**
	    * Destroys this DeviceButton, this disposes of the onDown, onUp and onFloat signals 
	    * and clears the parent and game references.
	    * 
	    * @method Phaser.DeviceButton#destroy
	    */destroy:function destroy(){this.onDown.dispose();this.onUp.dispose();this.onFloat.dispose();this.parent=null;this.game=null;}};Phaser.DeviceButton.prototype.constructor=Phaser.DeviceButton;/**
	* How long the button has been held down for in milliseconds.
	* If not currently down it returns -1.
	* 
	* @name Phaser.DeviceButton#duration
	* @property {number} duration
	* @readonly
	*/Object.defineProperty(Phaser.DeviceButton.prototype,"duration",{get:function get(){if(this.isUp){return-1;}return this.game.time.time-this.timeDown;}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A Pointer object is used by the Mouse, Touch and MSPoint managers and represents a single finger on the touch screen.
	*
	* @class Phaser.Pointer
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {number} id - The ID of the Pointer object within the game. Each game can have up to 10 active pointers.
	* @param {Phaser.PointerMode} pointerMode=(CURSOR|CONTACT) - The operational mode of this pointer, eg. CURSOR or TOUCH.
	*/Phaser.Pointer=function(game,id,pointerMode){/**
	    * @property {Phaser.Game} game - A reference to the currently running game.
	    */this.game=game;/**
	    * @property {number} id - The ID of the Pointer object within the game. Each game can have up to 10 active pointers.
	    */this.id=id;/**
	    * @property {number} type - The const type of this object.
	    * @readonly
	    */this.type=Phaser.POINTER;/**
	    * @property {boolean} exists - A Pointer object that exists is allowed to be checked for physics collisions and overlaps.
	    * @default
	    */this.exists=true;/**
	    * @property {number} identifier - The identifier property of the Pointer as set by the DOM event when this Pointer is started.
	    * @default
	    */this.identifier=0;/**
	    * @property {number} pointerId - The pointerId property of the Pointer as set by the DOM event when this Pointer is started. The browser can and will recycle this value.
	    * @default
	    */this.pointerId=null;/**
	    * @property {Phaser.PointerMode} pointerMode - The operational mode of this pointer.
	    */this.pointerMode=pointerMode||Phaser.PointerMode.CURSOR|Phaser.PointerMode.CONTACT;/**
	    * @property {any} target - The target property of the Pointer as set by the DOM event when this Pointer is started.
	    * @default
	    */this.target=null;/**
	    * The button property of the most recent DOM event when this Pointer is started.
	    * You should not rely on this value for accurate button detection, instead use the Pointer properties
	    * `leftButton`, `rightButton`, `middleButton` and so on.
	    * @property {any} button
	    * @default
	    */this.button=null;/**
	    * If this Pointer is a Mouse or Pen / Stylus then you can access its left button directly through this property.
	    * 
	    * The DeviceButton has its own properties such as `isDown`, `duration` and methods like `justReleased` for more fine-grained
	    * button control.
	    * 
	    * @property {Phaser.DeviceButton} leftButton
	    * @default
	    */this.leftButton=new Phaser.DeviceButton(this,Phaser.Pointer.LEFT_BUTTON);/**
	    * If this Pointer is a Mouse or Pen / Stylus then you can access its middle button directly through this property.
	    * 
	    * The DeviceButton has its own properties such as `isDown`, `duration` and methods like `justReleased` for more fine-grained
	    * button control.
	    *
	    * Please see the DeviceButton docs for details on browser button limitations.
	    * 
	    * @property {Phaser.DeviceButton} middleButton
	    * @default
	    */this.middleButton=new Phaser.DeviceButton(this,Phaser.Pointer.MIDDLE_BUTTON);/**
	    * If this Pointer is a Mouse or Pen / Stylus then you can access its right button directly through this property.
	    * 
	    * The DeviceButton has its own properties such as `isDown`, `duration` and methods like `justReleased` for more fine-grained
	    * button control.
	    *
	    * Please see the DeviceButton docs for details on browser button limitations.
	    * 
	    * @property {Phaser.DeviceButton} rightButton
	    * @default
	    */this.rightButton=new Phaser.DeviceButton(this,Phaser.Pointer.RIGHT_BUTTON);/**
	    * If this Pointer is a Mouse or Pen / Stylus then you can access its X1 (back) button directly through this property.
	    * 
	    * The DeviceButton has its own properties such as `isDown`, `duration` and methods like `justReleased` for more fine-grained
	    * button control.
	    *
	    * Please see the DeviceButton docs for details on browser button limitations.
	    * 
	    * @property {Phaser.DeviceButton} backButton
	    * @default
	    */this.backButton=new Phaser.DeviceButton(this,Phaser.Pointer.BACK_BUTTON);/**
	    * If this Pointer is a Mouse or Pen / Stylus then you can access its X2 (forward) button directly through this property.
	    * 
	    * The DeviceButton has its own properties such as `isDown`, `duration` and methods like `justReleased` for more fine-grained
	    * button control.
	    *
	    * Please see the DeviceButton docs for details on browser button limitations.
	    * 
	    * @property {Phaser.DeviceButton} forwardButton
	    * @default
	    */this.forwardButton=new Phaser.DeviceButton(this,Phaser.Pointer.FORWARD_BUTTON);/**
	    * If this Pointer is a Pen / Stylus then you can access its eraser button directly through this property.
	    * 
	    * The DeviceButton has its own properties such as `isDown`, `duration` and methods like `justReleased` for more fine-grained
	    * button control.
	    *
	    * Please see the DeviceButton docs for details on browser button limitations.
	    * 
	    * @property {Phaser.DeviceButton} eraserButton
	    * @default
	    */this.eraserButton=new Phaser.DeviceButton(this,Phaser.Pointer.ERASER_BUTTON);/**
	    * @property {boolean} _holdSent - Local private variable to store the status of dispatching a hold event.
	    * @private
	    * @default
	    */this._holdSent=false;/**
	    * @property {array} _history - Local private variable storing the short-term history of pointer movements.
	    * @private
	    */this._history=[];/**
	    * @property {number} _nextDrop - Local private variable storing the time at which the next history drop should occur.
	    * @private
	    */this._nextDrop=0;/**
	    * @property {boolean} _stateReset - Monitor events outside of a state reset loop.
	    * @private
	    */this._stateReset=false;/**
	    * @property {boolean} withinGame - true if the Pointer is over the game canvas, otherwise false.
	    */this.withinGame=false;/**
	    * @property {number} clientX - The horizontal coordinate of the Pointer within the application's client area at which the event occurred (as opposed to the coordinates within the page).
	    */this.clientX=-1;/**
	    * @property {number} clientY - The vertical coordinate of the Pointer within the application's client area at which the event occurred (as opposed to the coordinates within the page).
	    */this.clientY=-1;/**
	    * @property {number} pageX - The horizontal coordinate of the Pointer relative to whole document.
	    */this.pageX=-1;/**
	    * @property {number} pageY - The vertical coordinate of the Pointer relative to whole document.
	    */this.pageY=-1;/**
	    * @property {number} screenX - The horizontal coordinate of the Pointer relative to the screen.
	    */this.screenX=-1;/**
	    * @property {number} screenY - The vertical coordinate of the Pointer relative to the screen.
	    */this.screenY=-1;/**
	    * @property {number} rawMovementX - The horizontal raw relative movement of the Pointer in pixels since last event.
	    * @default
	    */this.rawMovementX=0;/**
	    * @property {number} rawMovementY - The vertical raw relative movement of the Pointer in pixels since last event.
	    * @default
	    */this.rawMovementY=0;/**
	    * @property {number} movementX - The horizontal processed relative movement of the Pointer in pixels since last event.
	    * @default
	    */this.movementX=0;/**
	    * @property {number} movementY - The vertical processed relative movement of the Pointer in pixels since last event.
	    * @default
	    */this.movementY=0;/**
	    * @property {number} x - The horizontal coordinate of the Pointer. This value is automatically scaled based on the game scale.
	    * @default
	    */this.x=-1;/**
	    * @property {number} y - The vertical coordinate of the Pointer. This value is automatically scaled based on the game scale.
	    * @default
	    */this.y=-1;/**
	    * @property {boolean} isMouse - If the Pointer is a mouse or pen / stylus this is true, otherwise false.
	    */this.isMouse=id===0;/**
	    * If the Pointer is touching the touchscreen, or *any* mouse or pen button is held down, isDown is set to true.
	    * If you need to check a specific mouse or pen button then use the button properties, i.e. Pointer.rightButton.isDown.
	    * @property {boolean} isDown
	    * @default
	    */this.isDown=false;/**
	    * If the Pointer is not touching the touchscreen, or *all* mouse or pen buttons are up, isUp is set to true.
	    * If you need to check a specific mouse or pen button then use the button properties, i.e. Pointer.rightButton.isUp.
	    * @property {boolean} isUp
	    * @default
	    */this.isUp=true;/**
	    * @property {number} timeDown - A timestamp representing when the Pointer first touched the touchscreen.
	    * @default
	    */this.timeDown=0;/**
	    * @property {number} timeUp - A timestamp representing when the Pointer left the touchscreen.
	    * @default
	    */this.timeUp=0;/**
	    * @property {number} previousTapTime - A timestamp representing when the Pointer was last tapped or clicked.
	    * @default
	    */this.previousTapTime=0;/**
	    * @property {number} totalTouches - The total number of times this Pointer has been touched to the touchscreen.
	    * @default
	    */this.totalTouches=0;/**
	    * @property {number} msSinceLastClick - The number of milliseconds since the last click or touch event.
	    * @default
	    */this.msSinceLastClick=Number.MAX_VALUE;/**
	    * @property {any} targetObject - The Game Object this Pointer is currently over / touching / dragging.
	    * @default
	    */this.targetObject=null;/**
	    * This array is erased and re-populated every time this Pointer is updated. It contains references to all
	    * of the Game Objects that were considered as being valid for processing by this Pointer, this frame. To be
	    * valid they must have suitable a `priorityID`, be Input enabled, visible and actually have the Pointer over
	    * them. You can check the contents of this array in events such as `onInputDown`, but beware it is reset
	    * every frame.
	    * @property {array} interactiveCandidates
	    * @default
	    */this.interactiveCandidates=[];/**
	    * @property {boolean} active - An active pointer is one that is currently pressed down on the display. A Mouse is always active.
	    * @default
	    */this.active=false;/**
	    * @property {boolean} dirty - A dirty pointer needs to re-poll any interactive objects it may have been over, regardless if it has moved or not.
	    * @default
	    */this.dirty=false;/**
	    * @property {Phaser.Point} position - A Phaser.Point object containing the current x/y values of the pointer on the display.
	    */this.position=new Phaser.Point();/**
	    * @property {Phaser.Point} positionDown - A Phaser.Point object containing the x/y values of the pointer when it was last in a down state on the display.
	    */this.positionDown=new Phaser.Point();/**
	    * @property {Phaser.Point} positionUp - A Phaser.Point object containing the x/y values of the pointer when it was last released.
	    */this.positionUp=new Phaser.Point();/**
	    * A Phaser.Circle that is centered on the x/y coordinates of this pointer, useful for hit detection.
	    * The Circle size is 44px (Apples recommended "finger tip" size).
	    * @property {Phaser.Circle} circle
	    */this.circle=new Phaser.Circle(0,0,44);/**
	    * Click trampolines associated with this pointer. See `addClickTrampoline`.
	    * @property {object[]|null} _clickTrampolines
	    * @private
	    */this._clickTrampolines=null;/**
	    * When the Pointer has click trampolines the last target object is stored here
	    * so it can be used to check for validity of the trampoline in a post-Up/'stop'.
	    * @property {object} _trampolineTargetObject
	    * @private
	    */this._trampolineTargetObject=null;};/**
	* No buttons at all.
	* @constant
	* @type {number}
	*/Phaser.Pointer.NO_BUTTON=0;/**
	* The Left Mouse button, or in PointerEvent devices a Touch contact or Pen contact.
	* @constant
	* @type {number}
	*/Phaser.Pointer.LEFT_BUTTON=1;/**
	* The Right Mouse button, or in PointerEvent devices a Pen contact with a barrel button.
	* @constant
	* @type {number}
	*/Phaser.Pointer.RIGHT_BUTTON=2;/**
	* The Middle Mouse button.
	* @constant
	* @type {number}
	*/Phaser.Pointer.MIDDLE_BUTTON=4;/**
	* The X1 button. This is typically the mouse Back button, but is often reconfigured.
	* On Linux (GTK) this is unsupported. On Windows if advanced pointer software (such as IntelliPoint) is installed this doesn't register.
	* @constant
	* @type {number}
	*/Phaser.Pointer.BACK_BUTTON=8;/**
	* The X2 button. This is typically the mouse Forward button, but is often reconfigured.
	* On Linux (GTK) this is unsupported. On Windows if advanced pointer software (such as IntelliPoint) is installed this doesn't register.
	* @constant
	* @type {number}
	*/Phaser.Pointer.FORWARD_BUTTON=16;/**
	* The Eraser pen button on PointerEvent supported devices only.
	* @constant
	* @type {number}
	*/Phaser.Pointer.ERASER_BUTTON=32;Phaser.Pointer.prototype={/**
	    * Resets the states of all the button booleans.
	    * 
	    * @method Phaser.Pointer#resetButtons
	    * @protected
	    */resetButtons:function resetButtons(){this.isDown=false;this.isUp=true;if(this.isMouse){this.leftButton.reset();this.middleButton.reset();this.rightButton.reset();this.backButton.reset();this.forwardButton.reset();this.eraserButton.reset();}},/**
	    * Called by updateButtons.
	    * 
	    * @method Phaser.Pointer#processButtonsDown
	    * @private
	    * @param {integer} buttons - The DOM event.buttons property.
	    * @param {MouseEvent} event - The DOM event.
	    */processButtonsDown:function processButtonsDown(buttons,event){//  Note: These are bitwise checks, not booleans
	if(Phaser.Pointer.LEFT_BUTTON&buttons){this.leftButton.start(event);}if(Phaser.Pointer.RIGHT_BUTTON&buttons){this.rightButton.start(event);}if(Phaser.Pointer.MIDDLE_BUTTON&buttons){this.middleButton.start(event);}if(Phaser.Pointer.BACK_BUTTON&buttons){this.backButton.start(event);}if(Phaser.Pointer.FORWARD_BUTTON&buttons){this.forwardButton.start(event);}if(Phaser.Pointer.ERASER_BUTTON&buttons){this.eraserButton.start(event);}},/**
	    * Called by updateButtons.
	    * 
	    * @method Phaser.Pointer#processButtonsUp
	    * @private
	    * @param {integer} buttons - The DOM event.buttons property.
	    * @param {MouseEvent} event - The DOM event.
	    */processButtonsUp:function processButtonsUp(button,event){//  Note: These are bitwise checks, not booleans
	if(button===Phaser.Mouse.LEFT_BUTTON){this.leftButton.stop(event);}if(button===Phaser.Mouse.RIGHT_BUTTON){this.rightButton.stop(event);}if(button===Phaser.Mouse.MIDDLE_BUTTON){this.middleButton.stop(event);}if(button===Phaser.Mouse.BACK_BUTTON){this.backButton.stop(event);}if(button===Phaser.Mouse.FORWARD_BUTTON){this.forwardButton.stop(event);}if(button===5){this.eraserButton.stop(event);}},/**
	    * Called when the event.buttons property changes from zero.
	    * Contains a button bitmask.
	    * 
	    * @method Phaser.Pointer#updateButtons
	    * @protected
	    * @param {MouseEvent} event - The DOM event.
	    */updateButtons:function updateButtons(event){this.button=event.button;var down=event.type.toLowerCase().substr(-4)==='down';if(event.buttons!==undefined){if(down){this.processButtonsDown(event.buttons,event);}else{this.processButtonsUp(event.button,event);}}else{//  No buttons property (like Safari on OSX when using a trackpad)
	if(down){this.leftButton.start(event);}else{this.leftButton.stop(event);this.rightButton.stop(event);}}//  On OS X (and other devices with trackpads) you have to press CTRL + the pad
	//  to initiate a right-click event, so we'll check for that here ONLY if
	//  event.buttons = 1 (i.e. they only have a 1 button mouse or trackpad)
	if(event.buttons===1&&event.ctrlKey&&this.leftButton.isDown){this.leftButton.stop(event);this.rightButton.start(event);}this.isUp=true;this.isDown=false;if(this.leftButton.isDown||this.rightButton.isDown||this.middleButton.isDown||this.backButton.isDown||this.forwardButton.isDown||this.eraserButton.isDown){this.isUp=false;this.isDown=true;}},/**
	    * Called when the Pointer is pressed onto the touchscreen.
	    * @method Phaser.Pointer#start
	    * @param {any} event - The DOM event from the browser.
	    */start:function start(event){var input=this.game.input;if(event['pointerId']){this.pointerId=event.pointerId;}this.identifier=event.identifier;this.target=event.target;if(this.isMouse){this.updateButtons(event);}else{this.isDown=true;this.isUp=false;}this.active=true;this.withinGame=true;this.dirty=false;this._history=[];this._clickTrampolines=null;this._trampolineTargetObject=null;//  Work out how long it has been since the last click
	this.msSinceLastClick=this.game.time.time-this.timeDown;this.timeDown=this.game.time.time;this._holdSent=false;//  This sets the x/y and other local values
	this.move(event,true);// x and y are the old values here?
	this.positionDown.setTo(this.x,this.y);if(input.multiInputOverride===Phaser.Input.MOUSE_OVERRIDES_TOUCH||input.multiInputOverride===Phaser.Input.MOUSE_TOUCH_COMBINE||input.multiInputOverride===Phaser.Input.TOUCH_OVERRIDES_MOUSE&&input.totalActivePointers===0){input.x=this.x;input.y=this.y;input.position.setTo(this.x,this.y);input.onDown.dispatch(this,event);input.resetSpeed(this.x,this.y);}this._stateReset=false;this.totalTouches++;if(this.targetObject!==null){this.targetObject._touchedHandler(this);}return this;},/**
	    * Called by the Input Manager.
	    * @method Phaser.Pointer#update
	    */update:function update(){var input=this.game.input;if(this.active){//  Force a check?
	if(this.dirty){if(input.interactiveItems.total>0){this.processInteractiveObjects(false);}this.dirty=false;}if(this._holdSent===false&&this.duration>=input.holdRate){if(input.multiInputOverride===Phaser.Input.MOUSE_OVERRIDES_TOUCH||input.multiInputOverride===Phaser.Input.MOUSE_TOUCH_COMBINE||input.multiInputOverride===Phaser.Input.TOUCH_OVERRIDES_MOUSE&&input.totalActivePointers===0){input.onHold.dispatch(this);}this._holdSent=true;}//  Update the droppings history
	if(input.recordPointerHistory&&this.game.time.time>=this._nextDrop){this._nextDrop=this.game.time.time+input.recordRate;this._history.push({x:this.position.x,y:this.position.y});if(this._history.length>input.recordLimit){this._history.shift();}}}},/**
	    * Called when the Pointer is moved.
	    * 
	    * @method Phaser.Pointer#move
	    * @param {MouseEvent|PointerEvent|TouchEvent} event - The event passed up from the input handler.
	    * @param {boolean} [fromClick=false] - Was this called from the click event?
	    */move:function move(event,fromClick){var input=this.game.input;if(input.pollLocked){return;}if(fromClick===undefined){fromClick=false;}if(event.button!==undefined){this.button=event.button;}if(fromClick&&this.isMouse){this.updateButtons(event);}this.clientX=event.clientX;this.clientY=event.clientY;this.pageX=event.pageX;this.pageY=event.pageY;this.screenX=event.screenX;this.screenY=event.screenY;if(this.isMouse&&input.mouse.locked&&!fromClick){this.rawMovementX=event.movementX||event.mozMovementX||event.webkitMovementX||0;this.rawMovementY=event.movementY||event.mozMovementY||event.webkitMovementY||0;this.movementX+=this.rawMovementX;this.movementY+=this.rawMovementY;}this.x=(this.pageX-this.game.scale.offset.x)*input.scale.x;this.y=(this.pageY-this.game.scale.offset.y)*input.scale.y;this.position.setTo(this.x,this.y);this.circle.x=this.x;this.circle.y=this.y;if(input.multiInputOverride===Phaser.Input.MOUSE_OVERRIDES_TOUCH||input.multiInputOverride===Phaser.Input.MOUSE_TOUCH_COMBINE||input.multiInputOverride===Phaser.Input.TOUCH_OVERRIDES_MOUSE&&input.totalActivePointers===0){input.activePointer=this;input.x=this.x;input.y=this.y;input.position.setTo(input.x,input.y);input.circle.x=input.x;input.circle.y=input.y;}this.withinGame=this.game.scale.bounds.contains(this.pageX,this.pageY);//  If the game is paused we don't process any target objects or callbacks
	if(this.game.paused){return this;}var i=input.moveCallbacks.length;while(i--){input.moveCallbacks[i].callback.call(input.moveCallbacks[i].context,this,this.x,this.y,fromClick);}//  Easy out if we're dragging something and it still exists
	if(this.targetObject!==null&&this.targetObject.isDragged===true){if(this.targetObject.update(this)===false){this.targetObject=null;}}else if(input.interactiveItems.total>0){this.processInteractiveObjects(fromClick);}return this;},/**
	    * Process all interactive objects to find out which ones were updated in the recent Pointer move.
	    * 
	    * @method Phaser.Pointer#processInteractiveObjects
	    * @protected
	    * @param {boolean} [fromClick=false] - Was this called from the click event?
	    * @return {boolean} True if this method processes an object (i.e. a Sprite becomes the Pointers currentTarget), otherwise false.
	    */processInteractiveObjects:function processInteractiveObjects(fromClick){//  Work out which object is on the top
	var highestRenderOrderID=0;var highestInputPriorityID=-1;var candidateTarget=null;//  First pass gets all objects that the pointer is over that DON'T use pixelPerfect checks and get the highest ID
	//  We know they'll be valid for input detection but not which is the top just yet
	var currentNode=this.game.input.interactiveItems.first;this.interactiveCandidates=[];while(currentNode){//  Reset checked status
	currentNode.checked=false;if(currentNode.validForInput(highestInputPriorityID,highestRenderOrderID,false)){//  Flag it as checked so we don't re-scan it on the next phase
	currentNode.checked=true;if(fromClick&&currentNode.checkPointerDown(this,true)||!fromClick&&currentNode.checkPointerOver(this,true)){highestRenderOrderID=currentNode.sprite.renderOrderID;highestInputPriorityID=currentNode.priorityID;candidateTarget=currentNode;this.interactiveCandidates.push(currentNode);}}currentNode=this.game.input.interactiveItems.next;}//  Then in the second sweep we process ONLY the pixel perfect ones that are checked and who have a higher ID
	//  because if their ID is lower anyway then we can just automatically discount them
	//  (A node that was previously checked did not request a pixel-perfect check.)
	currentNode=this.game.input.interactiveItems.first;while(currentNode){if(!currentNode.checked&&currentNode.validForInput(highestInputPriorityID,highestRenderOrderID,true)){if(fromClick&&currentNode.checkPointerDown(this,false)||!fromClick&&currentNode.checkPointerOver(this,false)){highestRenderOrderID=currentNode.sprite.renderOrderID;highestInputPriorityID=currentNode.priorityID;candidateTarget=currentNode;this.interactiveCandidates.push(currentNode);}}currentNode=this.game.input.interactiveItems.next;}if(this.game.input.customCandidateHandler){candidateTarget=this.game.input.customCandidateHandler.call(this.game.input.customCandidateHandlerContext,this,this.interactiveCandidates,candidateTarget);}this.swapTarget(candidateTarget,false);return this.targetObject!==null;},/**
	    * This will change the `Pointer.targetObject` object to be the one provided.
	    * 
	    * This allows you to have fine-grained control over which object the Pointer is targeting.
	    *
	    * Note that even if you set a new Target here, it is still able to be replaced by any other valid
	    * target during the next Pointer update.
	    *
	    * @method Phaser.Pointer#swapTarget
	    * @param {Phaser.InputHandler} newTarget - The new target for this Pointer. Note this is an `InputHandler`, so don't pass a Sprite, instead pass `sprite.input` to it.
	    * @param {boolean} [silent=false] - If true the new target AND the old one will NOT dispatch their `onInputOver` or `onInputOut` events.
	    */swapTarget:function swapTarget(newTarget,silent){if(silent===undefined){silent=false;}//  Now we know the top-most item (if any) we can process it
	if(newTarget===null){//  The pointer isn't currently over anything, check if we've got a lingering previous target
	if(this.targetObject){this.targetObject._pointerOutHandler(this,silent);this.targetObject=null;}}else{if(this.targetObject===null){//  And now set the new one
	this.targetObject=newTarget;newTarget._pointerOverHandler(this,silent);}else{//  We've got a target from the last update
	if(this.targetObject===newTarget){//  Same target as before, so update it
	if(newTarget.update(this)===false){this.targetObject=null;}}else{//  The target has changed, so tell the old one we've left it
	this.targetObject._pointerOutHandler(this,silent);//  And now set the new one
	this.targetObject=newTarget;this.targetObject._pointerOverHandler(this,silent);}}}},/**
	    * Called when the Pointer leaves the target area.
	    *
	    * @method Phaser.Pointer#leave
	    * @param {MouseEvent|PointerEvent|TouchEvent} event - The event passed up from the input handler.
	    */leave:function leave(event){this.withinGame=false;this.move(event,false);},/**
	    * Called when the Pointer leaves the touchscreen.
	    *
	    * @method Phaser.Pointer#stop
	    * @param {MouseEvent|PointerEvent|TouchEvent} event - The event passed up from the input handler.
	    */stop:function stop(event){var input=this.game.input;if(this._stateReset&&this.withinGame){event.preventDefault();return;}this.timeUp=this.game.time.time;if(input.multiInputOverride===Phaser.Input.MOUSE_OVERRIDES_TOUCH||input.multiInputOverride===Phaser.Input.MOUSE_TOUCH_COMBINE||input.multiInputOverride===Phaser.Input.TOUCH_OVERRIDES_MOUSE&&input.totalActivePointers===0){input.onUp.dispatch(this,event);//  Was it a tap?
	if(this.duration>=0&&this.duration<=input.tapRate){//  Was it a double-tap?
	if(this.timeUp-this.previousTapTime<input.doubleTapRate){//  Yes, let's dispatch the signal then with the 2nd parameter set to true
	input.onTap.dispatch(this,true);}else{//  Wasn't a double-tap, so dispatch a single tap signal
	input.onTap.dispatch(this,false);}this.previousTapTime=this.timeUp;}}if(this.isMouse){this.updateButtons(event);}else{this.isDown=false;this.isUp=true;}//  Mouse is always active
	if(this.id>0){this.active=false;}this.withinGame=this.game.scale.bounds.contains(event.pageX,event.pageY);this.pointerId=null;this.identifier=null;this.positionUp.setTo(this.x,this.y);if(this.isMouse===false){input.currentPointers--;}input.interactiveItems.callAll('_releasedHandler',this);if(this._clickTrampolines){this._trampolineTargetObject=this.targetObject;}this.targetObject=null;return this;},/**
	    * The Pointer is considered justPressed if the time it was pressed onto the touchscreen or clicked is less than justPressedRate.
	    * Note that calling justPressed doesn't reset the pressed status of the Pointer, it will return `true` for as long as the duration is valid.
	    * If you wish to check if the Pointer was pressed down just once then see the Sprite.events.onInputDown event.
	    * @method Phaser.Pointer#justPressed
	    * @param {number} [duration] - The time to check against. If none given it will use InputManager.justPressedRate.
	    * @return {boolean} true if the Pointer was pressed down within the duration given.
	    */justPressed:function justPressed(duration){duration=duration||this.game.input.justPressedRate;return this.isDown===true&&this.timeDown+duration>this.game.time.time;},/**
	    * The Pointer is considered justReleased if the time it left the touchscreen is less than justReleasedRate.
	    * Note that calling justReleased doesn't reset the pressed status of the Pointer, it will return `true` for as long as the duration is valid.
	    * If you wish to check if the Pointer was released just once then see the Sprite.events.onInputUp event.
	    * @method Phaser.Pointer#justReleased
	    * @param {number} [duration] - The time to check against. If none given it will use InputManager.justReleasedRate.
	    * @return {boolean} true if the Pointer was released within the duration given.
	    */justReleased:function justReleased(duration){duration=duration||this.game.input.justReleasedRate;return this.isUp&&this.timeUp+duration>this.game.time.time;},/**
	    * Add a click trampoline to this pointer.
	    *
	    * A click trampoline is a callback that is run on the DOM 'click' event; this is primarily
	    * needed with certain browsers (ie. IE11) which restrict some actions like requestFullscreen
	    * to the DOM 'click' event and rejects it for 'pointer*' and 'mouse*' events.
	    *
	    * This is used internally by the ScaleManager; click trampoline usage is uncommon.
	    * Click trampolines can only be added to pointers that are currently down.
	    *
	    * @method Phaser.Pointer#addClickTrampoline
	    * @protected
	    * @param {string} name - The name of the trampoline; must be unique among active trampolines in this pointer.
	    * @param {function} callback - Callback to run/trampoline.
	    * @param {object} callbackContext - Context of the callback.
	    * @param {object[]|null} callbackArgs - Additional callback args, if any. Supplied as an array.
	    */addClickTrampoline:function addClickTrampoline(name,callback,callbackContext,callbackArgs){if(!this.isDown){return;}var trampolines=this._clickTrampolines=this._clickTrampolines||[];for(var i=0;i<trampolines.length;i++){if(trampolines[i].name===name){trampolines.splice(i,1);break;}}trampolines.push({name:name,targetObject:this.targetObject,callback:callback,callbackContext:callbackContext,callbackArgs:callbackArgs});},/**
	    * Fire all click trampolines for which the pointers are still referring to the registered object.
	    * @method Phaser.Pointer#processClickTrampolines
	    * @private
	    */processClickTrampolines:function processClickTrampolines(){var trampolines=this._clickTrampolines;if(!trampolines){return;}for(var i=0;i<trampolines.length;i++){var trampoline=trampolines[i];if(trampoline.targetObject===this._trampolineTargetObject){trampoline.callback.apply(trampoline.callbackContext,trampoline.callbackArgs);}}this._clickTrampolines=null;this._trampolineTargetObject=null;},/**
	    * Resets the Pointer properties. Called by InputManager.reset when you perform a State change.
	    * @method Phaser.Pointer#reset
	    */reset:function reset(){if(this.isMouse===false){this.active=false;}this.pointerId=null;this.identifier=null;this.dirty=false;this.totalTouches=0;this._holdSent=false;this._history.length=0;this._stateReset=true;this.resetButtons();if(this.targetObject){this.targetObject._releasedHandler(this);}this.targetObject=null;},/**
	     * Resets the movementX and movementY properties. Use in your update handler after retrieving the values.
	     * @method Phaser.Pointer#resetMovement
	     */resetMovement:function resetMovement(){this.movementX=0;this.movementY=0;}};Phaser.Pointer.prototype.constructor=Phaser.Pointer;/**
	* How long the Pointer has been depressed on the touchscreen or *any* of the mouse buttons have been held down.
	* If not currently down it returns -1.
	* If you need to test a specific mouse or pen button then access the buttons directly, i.e. `Pointer.rightButton.duration`.
	* 
	* @name Phaser.Pointer#duration
	* @property {number} duration
	* @readonly
	*/Object.defineProperty(Phaser.Pointer.prototype,"duration",{get:function get(){if(this.isUp){return-1;}return this.game.time.time-this.timeDown;}});/**
	* Gets the X value of this Pointer in world coordinates based on the world camera.
	* @name Phaser.Pointer#worldX
	* @property {number} worldX - The X value of this Pointer in world coordinates based on the world camera.
	* @readonly
	*/Object.defineProperty(Phaser.Pointer.prototype,"worldX",{get:function get(){return this.game.world.camera.x+this.x;}});/**
	* Gets the Y value of this Pointer in world coordinates based on the world camera.
	* @name Phaser.Pointer#worldY
	* @property {number} worldY - The Y value of this Pointer in world coordinates based on the world camera.
	* @readonly
	*/Object.defineProperty(Phaser.Pointer.prototype,"worldY",{get:function get(){return this.game.world.camera.y+this.y;}});/**
	* Enumeration categorizing operational modes of pointers.
	*
	* PointerType values represent valid bitmasks.
	* For example, a value representing both Mouse and Touch devices
	* can be expressed as `PointerMode.CURSOR | PointerMode.CONTACT`.
	*
	* Values may be added for future mode categorizations.
	* @class Phaser.PointerMode
	*/Phaser.PointerMode={/**
	    * A 'CURSOR' is a pointer with a *passive cursor* such as a mouse, touchpad, watcom stylus, or even TV-control arrow-pad.
	    *
	    * It has the property that a cursor is passively moved without activating the input.
	    * This currently corresponds with {@link Phaser.Pointer#isMouse} property.
	    * @constant
	    */CURSOR:1<<0,/**
	    * A 'CONTACT' pointer has an *active cursor* that only tracks movement when actived; notably this is a touch-style input.
	    * @constant
	    */CONTACT:1<<1};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Phaser.Touch handles touch events with your game. Note: Android 2.x only supports 1 touch event at once, no multi-touch.
	*
	* You should not normally access this class directly, but instead use a Phaser.Pointer object which normalises all game input for you.
	*
	* @class Phaser.Touch
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	*/Phaser.Touch=function(game){/**
	    * @property {Phaser.Game} game - A reference to the currently running game.
	    */this.game=game;/**
	    * Touch events will only be processed if enabled.
	    * @property {boolean} enabled
	    * @default
	    */this.enabled=true;/**
	    * An array of callbacks that will be fired every time a native touch start or touch end event is received from the browser.
	    * This is used internally to handle audio and video unlocking on mobile devices.
	    * To add a callback to this array please use `Touch.addTouchLockCallback`.
	    * @property {array} touchLockCallbacks
	    * @protected
	    */this.touchLockCallbacks=[];/**
	    * @property {object} callbackContext - The context under which callbacks are called.
	    */this.callbackContext=this.game;/**
	    * @property {function} touchStartCallback - A callback that can be fired on a touchStart event.
	    */this.touchStartCallback=null;/**
	    * @property {function} touchMoveCallback - A callback that can be fired on a touchMove event.
	    */this.touchMoveCallback=null;/**
	    * @property {function} touchEndCallback - A callback that can be fired on a touchEnd event.
	    */this.touchEndCallback=null;/**
	    * @property {function} touchEnterCallback - A callback that can be fired on a touchEnter event.
	    */this.touchEnterCallback=null;/**
	    * @property {function} touchLeaveCallback - A callback that can be fired on a touchLeave event.
	    */this.touchLeaveCallback=null;/**
	    * @property {function} touchCancelCallback - A callback that can be fired on a touchCancel event.
	    */this.touchCancelCallback=null;/**
	    * @property {boolean} preventDefault - If true the TouchEvent will have prevent.default called on it.
	    * @default
	    */this.preventDefault=true;/**
	    * @property {TouchEvent} event - The browser touch DOM event. Will be set to null if no touch event has ever been received.
	    * @default
	    */this.event=null;/**
	    * @property {function} _onTouchStart - Internal event handler reference.
	    * @private
	    */this._onTouchStart=null;/**
	    * @property {function} _onTouchMove - Internal event handler reference.
	    * @private
	    */this._onTouchMove=null;/**
	    * @property {function} _onTouchEnd - Internal event handler reference.
	    * @private
	    */this._onTouchEnd=null;/**
	    * @property {function} _onTouchEnter - Internal event handler reference.
	    * @private
	    */this._onTouchEnter=null;/**
	    * @property {function} _onTouchLeave - Internal event handler reference.
	    * @private
	    */this._onTouchLeave=null;/**
	    * @property {function} _onTouchCancel - Internal event handler reference.
	    * @private
	    */this._onTouchCancel=null;/**
	    * @property {function} _onTouchMove - Internal event handler reference.
	    * @private
	    */this._onTouchMove=null;};Phaser.Touch.prototype={/**
	    * Starts the event listeners running.
	    * @method Phaser.Touch#start
	    */start:function start(){if(this._onTouchStart!==null){//  Avoid setting multiple listeners
	return;}var _this=this;if(this.game.device.touch){this._onTouchStart=function(event){return _this.onTouchStart(event);};this._onTouchMove=function(event){return _this.onTouchMove(event);};this._onTouchEnd=function(event){return _this.onTouchEnd(event);};this._onTouchEnter=function(event){return _this.onTouchEnter(event);};this._onTouchLeave=function(event){return _this.onTouchLeave(event);};this._onTouchCancel=function(event){return _this.onTouchCancel(event);};this.game.canvas.addEventListener('touchstart',this._onTouchStart,false);this.game.canvas.addEventListener('touchmove',this._onTouchMove,false);this.game.canvas.addEventListener('touchend',this._onTouchEnd,false);this.game.canvas.addEventListener('touchcancel',this._onTouchCancel,false);if(!this.game.device.cocoonJS){this.game.canvas.addEventListener('touchenter',this._onTouchEnter,false);this.game.canvas.addEventListener('touchleave',this._onTouchLeave,false);}}},/**
	    * Consumes all touchmove events on the document (only enable this if you know you need it!).
	    * @method Phaser.Touch#consumeTouchMove
	    */consumeDocumentTouches:function consumeDocumentTouches(){this._documentTouchMove=function(event){event.preventDefault();};document.addEventListener('touchmove',this._documentTouchMove,false);},/**
	    * Adds a callback that is fired when a browser touchstart or touchend event is received.
	    *
	    * This is used internally to handle audio and video unlocking on mobile devices.
	    *
	    * If the callback returns 'true' then the callback is automatically deleted once invoked.
	    *
	    * The callback is added to the Phaser.Touch.touchLockCallbacks array and should be removed with Phaser.Touch.removeTouchLockCallback.
	    * 
	    * @method Phaser.Touch#addTouchLockCallback
	    * @param {function} callback - The callback that will be called when a touchstart event is received.
	    * @param {object} context - The context in which the callback will be called.
	    * @param {boolean} [onEnd=false] - Will the callback fire on a touchstart (default) or touchend event?
	    */addTouchLockCallback:function addTouchLockCallback(callback,context,onEnd){if(onEnd===undefined){onEnd=false;}this.touchLockCallbacks.push({callback:callback,context:context,onEnd:onEnd});},/**
	    * Removes the callback at the defined index from the Phaser.Touch.touchLockCallbacks array
	    * 
	    * @method Phaser.Touch#removeTouchLockCallback
	    * @param {function} callback - The callback to be removed.
	    * @param {object} context - The context in which the callback exists.
	    * @return {boolean} True if the callback was deleted, otherwise false.
	    */removeTouchLockCallback:function removeTouchLockCallback(callback,context){var i=this.touchLockCallbacks.length;while(i--){if(this.touchLockCallbacks[i].callback===callback&&this.touchLockCallbacks[i].context===context){this.touchLockCallbacks.splice(i,1);return true;}}return false;},/**
	    * The internal method that handles the touchstart event from the browser.
	    * @method Phaser.Touch#onTouchStart
	    * @param {TouchEvent} event - The native event from the browser. This gets stored in Touch.event.
	    */onTouchStart:function onTouchStart(event){var i=this.touchLockCallbacks.length;while(i--){var cb=this.touchLockCallbacks[i];if(!cb.onEnd&&cb.callback.call(cb.context,this,event)){this.touchLockCallbacks.splice(i,1);}}this.event=event;if(!this.game.input.enabled||!this.enabled){return;}if(this.touchStartCallback){this.touchStartCallback.call(this.callbackContext,event);}if(this.preventDefault){event.preventDefault();}//  event.targetTouches = list of all touches on the TARGET ELEMENT (i.e. game dom element)
	//  event.touches = list of all touches on the ENTIRE DOCUMENT, not just the target element
	//  event.changedTouches = the touches that CHANGED in this event, not the total number of them
	for(var i=0;i<event.changedTouches.length;i++){this.game.input.startPointer(event.changedTouches[i]);}},/**
	    * Touch cancel - touches that were disrupted (perhaps by moving into a plugin or browser chrome).
	    * Occurs for example on iOS when you put down 4 fingers and the app selector UI appears.
	    * @method Phaser.Touch#onTouchCancel
	    * @param {TouchEvent} event - The native event from the browser. This gets stored in Touch.event.
	    */onTouchCancel:function onTouchCancel(event){this.event=event;if(this.touchCancelCallback){this.touchCancelCallback.call(this.callbackContext,event);}if(!this.game.input.enabled||!this.enabled){return;}if(this.preventDefault){event.preventDefault();}//  Touch cancel - touches that were disrupted (perhaps by moving into a plugin or browser chrome)
	//  http://www.w3.org/TR/touch-events/#dfn-touchcancel
	for(var i=0;i<event.changedTouches.length;i++){this.game.input.stopPointer(event.changedTouches[i]);}},/**
	    * For touch enter and leave its a list of the touch points that have entered or left the target.
	    * Doesn't appear to be supported by most browsers on a canvas element yet.
	    * @method Phaser.Touch#onTouchEnter
	    * @param {TouchEvent} event - The native event from the browser. This gets stored in Touch.event.
	    */onTouchEnter:function onTouchEnter(event){this.event=event;if(this.touchEnterCallback){this.touchEnterCallback.call(this.callbackContext,event);}if(!this.game.input.enabled||!this.enabled){return;}if(this.preventDefault){event.preventDefault();}},/**
	    * For touch enter and leave its a list of the touch points that have entered or left the target.
	    * Doesn't appear to be supported by most browsers on a canvas element yet.
	    * @method Phaser.Touch#onTouchLeave
	    * @param {TouchEvent} event - The native event from the browser. This gets stored in Touch.event.
	    */onTouchLeave:function onTouchLeave(event){this.event=event;if(this.touchLeaveCallback){this.touchLeaveCallback.call(this.callbackContext,event);}if(this.preventDefault){event.preventDefault();}},/**
	    * The handler for the touchmove events.
	    * @method Phaser.Touch#onTouchMove
	    * @param {TouchEvent} event - The native event from the browser. This gets stored in Touch.event.
	    */onTouchMove:function onTouchMove(event){this.event=event;if(this.touchMoveCallback){this.touchMoveCallback.call(this.callbackContext,event);}if(this.preventDefault){event.preventDefault();}for(var i=0;i<event.changedTouches.length;i++){this.game.input.updatePointer(event.changedTouches[i]);}},/**
	    * The handler for the touchend events.
	    * @method Phaser.Touch#onTouchEnd
	    * @param {TouchEvent} event - The native event from the browser. This gets stored in Touch.event.
	    */onTouchEnd:function onTouchEnd(event){var i=this.touchLockCallbacks.length;while(i--){var cb=this.touchLockCallbacks[i];if(cb.onEnd&&cb.callback.call(cb.context,this,event)){this.touchLockCallbacks.splice(i,1);}}this.event=event;if(this.touchEndCallback){this.touchEndCallback.call(this.callbackContext,event);}if(this.preventDefault){event.preventDefault();}//  For touch end its a list of the touch points that have been removed from the surface
	//  https://developer.mozilla.org/en-US/docs/DOM/TouchList
	//  event.changedTouches = the touches that CHANGED in this event, not the total number of them
	for(var i=0;i<event.changedTouches.length;i++){this.game.input.stopPointer(event.changedTouches[i]);}},/**
	    * Stop the event listeners.
	    * @method Phaser.Touch#stop
	    */stop:function stop(){if(this.game.device.touch){this.game.canvas.removeEventListener('touchstart',this._onTouchStart);this.game.canvas.removeEventListener('touchmove',this._onTouchMove);this.game.canvas.removeEventListener('touchend',this._onTouchEnd);this.game.canvas.removeEventListener('touchenter',this._onTouchEnter);this.game.canvas.removeEventListener('touchleave',this._onTouchLeave);this.game.canvas.removeEventListener('touchcancel',this._onTouchCancel);}}};Phaser.Touch.prototype.constructor=Phaser.Touch;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Input Handler is bound to a specific Sprite and is responsible for managing all Input events on that Sprite.
	*
	* @class Phaser.InputHandler
	* @constructor
	* @param {Phaser.Sprite} sprite - The Sprite object to which this Input Handler belongs.
	*/Phaser.InputHandler=function(sprite){/**
	    * @property {Phaser.Sprite} sprite - The Sprite object to which this Input Handler belongs.
	    */this.sprite=sprite;/**
	    * @property {Phaser.Game} game - A reference to the currently running game.
	    */this.game=sprite.game;/**
	    * @property {boolean} enabled - If enabled the Input Handler will process input requests and monitor pointer activity.
	    * @default
	    */this.enabled=false;/**
	    * @property {boolean} checked - A disposable flag used by the Pointer class when performing priority checks.
	    * @protected
	    */this.checked=false;/**
	    * The priorityID is used to determine which game objects should get priority when input events occur. For example if you have
	    * several Sprites that overlap, by default the one at the top of the display list is given priority for input events. You can
	    * stop this from happening by controlling the priorityID value. The higher the value, the more important they are considered to the Input events.
	    * @property {number} priorityID
	    * @default
	    */this.priorityID=0;/**
	    * @property {boolean} useHandCursor - On a desktop browser you can set the 'hand' cursor to appear when moving over the Sprite.
	    * @default
	    */this.useHandCursor=false;/**
	    * @property {boolean} _setHandCursor - Did this Sprite trigger the hand cursor?
	    * @private
	    */this._setHandCursor=false;/**
	    * @property {boolean} isDragged - true if the Sprite is being currently dragged.
	    * @default
	    */this.isDragged=false;/**
	    * @property {boolean} allowHorizontalDrag - Controls if the Sprite is allowed to be dragged horizontally.
	    * @default
	    */this.allowHorizontalDrag=true;/**
	    * @property {boolean} allowVerticalDrag - Controls if the Sprite is allowed to be dragged vertically.
	    * @default
	    */this.allowVerticalDrag=true;/**
	    * @property {boolean} bringToTop - If true when this Sprite is clicked or dragged it will automatically be bought to the top of the Group it is within.
	    * @default
	    */this.bringToTop=false;/**
	    * @property {Phaser.Point} snapOffset - A Point object that contains by how far the Sprite snap is offset.
	    * @default
	    */this.snapOffset=null;/**
	    * @property {boolean} snapOnDrag - When the Sprite is dragged this controls if the center of the Sprite will snap to the pointer on drag or not.
	    * @default
	    */this.snapOnDrag=false;/**
	    * @property {boolean} snapOnRelease - When the Sprite is dragged this controls if the Sprite will be snapped on release.
	    * @default
	    */this.snapOnRelease=false;/**
	    * @property {number} snapX - When a Sprite has snapping enabled this holds the width of the snap grid.
	    * @default
	    */this.snapX=0;/**
	    * @property {number} snapY - When a Sprite has snapping enabled this holds the height of the snap grid.
	    * @default
	    */this.snapY=0;/**
	    * @property {number} snapOffsetX - This defines the top-left X coordinate of the snap grid.
	    * @default
	    */this.snapOffsetX=0;/**
	    * @property {number} snapOffsetY - This defines the top-left Y coordinate of the snap grid..
	    * @default
	    */this.snapOffsetY=0;/**
	    * Set to true to use pixel perfect hit detection when checking if the pointer is over this Sprite.
	    * The x/y coordinates of the pointer are tested against the image in combination with the InputHandler.pixelPerfectAlpha value.
	    * This feature only works for display objects with image based textures such as Sprites. It won't work on BitmapText or Rope.
	    * Warning: This is expensive, especially on mobile (where it's not even needed!) so only enable if required. Also see the less-expensive InputHandler.pixelPerfectClick.
	    * @property {boolean} pixelPerfectOver - Use a pixel perfect check when testing for pointer over.
	    * @default
	    */this.pixelPerfectOver=false;/**
	    * Set to true to use pixel perfect hit detection when checking if the pointer is over this Sprite when it's clicked or touched.
	    * The x/y coordinates of the pointer are tested against the image in combination with the InputHandler.pixelPerfectAlpha value.
	    * This feature only works for display objects with image based textures such as Sprites. It won't work on BitmapText or Rope.
	    * Warning: This is expensive so only enable if you really need it.
	    * @property {boolean} pixelPerfectClick - Use a pixel perfect check when testing for clicks or touches on the Sprite.
	    * @default
	    */this.pixelPerfectClick=false;/**
	    * @property {number} pixelPerfectAlpha - The alpha tolerance threshold. If the alpha value of the pixel matches or is above this value, it's considered a hit.
	    * @default
	    */this.pixelPerfectAlpha=255;/**
	    * @property {boolean} draggable - Is this sprite allowed to be dragged by the mouse? true = yes, false = no
	    * @default
	    */this.draggable=false;/**
	    * @property {Phaser.Rectangle} boundsRect - A region of the game world within which the sprite is restricted during drag.
	    * @default
	    */this.boundsRect=null;/**
	    * @property {Phaser.Sprite} boundsSprite - A Sprite the bounds of which this sprite is restricted during drag.
	    * @default
	    */this.boundsSprite=null;/**
	    * @property {boolean} scaleLayer - EXPERIMENTAL: Please do not use this property unless you know what it does. Likely to change in the future.
	    */this.scaleLayer=false;/**
	    * @property {Phaser.Point} dragOffset - The offset from the Sprites position that dragging takes place from.
	    */this.dragOffset=new Phaser.Point();/**
	    * @property {boolean} dragFromCenter - Is the Sprite dragged from its center, or the point at which the Pointer was pressed down upon it?
	    */this.dragFromCenter=false;/**
	    * @property {boolean} dragStopBlocksInputUp - If enabled, when the Sprite stops being dragged, it will only dispatch the `onDragStop` event, and not the `onInputUp` event. If set to `false` it will dispatch both events.
	    */this.dragStopBlocksInputUp=false;/**
	    * @property {Phaser.Point} dragStartPoint - The Point from which the most recent drag started from. Useful if you need to return an object to its starting position.
	    */this.dragStartPoint=new Phaser.Point();/**
	    * @property {integer} dragDistanceThreshold - The distance, in pixels, the pointer has to move while being held down, before the Sprite thinks it is being dragged.
	    */this.dragDistanceThreshold=0;/**
	    * @property {integer} dragTimeThreshold - The amount of time, in ms, the pointer has to be held down over the Sprite before it thinks it is being dragged.
	    */this.dragTimeThreshold=0;/**
	    * @property {Phaser.Point} downPoint - A Point object containing the coordinates of the Pointer when it was first pressed down onto this Sprite.
	    */this.downPoint=new Phaser.Point();/**
	    * @property {Phaser.Point} snapPoint - If the sprite is set to snap while dragging this holds the point of the most recent 'snap' event.
	    */this.snapPoint=new Phaser.Point();/**
	    * @property {Phaser.Point} _dragPoint - Internal cache var.
	    * @private
	    */this._dragPoint=new Phaser.Point();/**
	    * @property {boolean} _dragPhase - Internal cache var.
	    * @private
	    */this._dragPhase=false;/**
	    * @property {boolean} _pendingDrag - Internal cache var.
	    * @private
	    */this._pendingDrag=false;/**
	    * @property {boolean} _dragTimePass - Internal cache var.
	    * @private
	    */this._dragTimePass=false;/**
	    * @property {boolean} _dragDistancePass - Internal cache var.
	    * @private
	    */this._dragDistancePass=false;/**
	    * @property {boolean} _wasEnabled - Internal cache var.
	    * @private
	    */this._wasEnabled=false;/**
	    * @property {Phaser.Point} _tempPoint - Internal cache var.
	    * @private
	    */this._tempPoint=new Phaser.Point();/**
	    * @property {array} _pointerData - Internal cache var.
	    * @private
	    */this._pointerData=[];this._pointerData.push({id:0,x:0,y:0,camX:0,camY:0,isDown:false,isUp:false,isOver:false,isOut:false,timeOver:0,timeOut:0,timeDown:0,timeUp:0,downDuration:0,isDragged:false});};Phaser.InputHandler.prototype={/**
	    * Starts the Input Handler running. This is called automatically when you enable input on a Sprite, or can be called directly if you need to set a specific priority.
	    * 
	    * @method Phaser.InputHandler#start
	    * @param {number} [priority=0] - Higher priority sprites take click priority over low-priority sprites when they are stacked on-top of each other.
	    * @param {boolean} [useHandCursor=false] - If true the Sprite will show the hand cursor on mouse-over (doesn't apply to mobile browsers)
	    * @return {Phaser.Sprite} The Sprite object to which the Input Handler is bound.
	    */start:function start(priority,useHandCursor){priority=priority||0;if(useHandCursor===undefined){useHandCursor=false;}//  Turning on
	if(this.enabled===false){//  Register, etc
	this.game.input.interactiveItems.add(this);this.useHandCursor=useHandCursor;this.priorityID=priority;for(var i=0;i<10;i++){this._pointerData[i]={id:i,x:0,y:0,isDown:false,isUp:false,isOver:false,isOut:false,timeOver:0,timeOut:0,timeDown:0,timeUp:0,downDuration:0,isDragged:false};}this.snapOffset=new Phaser.Point();this.enabled=true;this._wasEnabled=true;}this.sprite.events.onAddedToGroup.add(this.addedToGroup,this);this.sprite.events.onRemovedFromGroup.add(this.removedFromGroup,this);return this.sprite;},/**
	    * Handles when the parent Sprite is added to a new Group.
	    *
	    * @method Phaser.InputHandler#addedToGroup
	    * @private
	    */addedToGroup:function addedToGroup(){if(this._dragPhase){return;}if(this._wasEnabled&&!this.enabled){this.start();}},/**
	    * Handles when the parent Sprite is removed from a Group.
	    *
	    * @method Phaser.InputHandler#removedFromGroup
	    * @private
	    */removedFromGroup:function removedFromGroup(){if(this._dragPhase){return;}if(this.enabled){this._wasEnabled=true;this.stop();}else{this._wasEnabled=false;}},/**
	    * Resets the Input Handler and disables it.
	    * @method Phaser.InputHandler#reset
	    */reset:function reset(){this.enabled=false;for(var i=0;i<10;i++){this._pointerData[i]={id:i,x:0,y:0,isDown:false,isUp:false,isOver:false,isOut:false,timeOver:0,timeOut:0,timeDown:0,timeUp:0,downDuration:0,isDragged:false};}},/**
	    * Stops the Input Handler from running.
	    * @method Phaser.InputHandler#stop
	    */stop:function stop(){//  Turning off
	if(this.enabled===false){return;}else{//  De-register, etc
	this.enabled=false;this.game.input.interactiveItems.remove(this);}},/**
	    * Clean up memory.
	    * @method Phaser.InputHandler#destroy
	    */destroy:function destroy(){if(this.sprite){if(this._setHandCursor){this.game.canvas.style.cursor="default";this._setHandCursor=false;}this.enabled=false;this.game.input.interactiveItems.remove(this);this._pointerData.length=0;this.boundsRect=null;this.boundsSprite=null;this.sprite=null;}},/**
	    * Checks if the object this InputHandler is bound to is valid for consideration in the Pointer move event.
	    * This is called by Phaser.Pointer and shouldn't typically be called directly.
	    *
	    * @method Phaser.InputHandler#validForInput
	    * @protected
	    * @param {number} highestID - The highest ID currently processed by the Pointer.
	    * @param {number} highestRenderID - The highest Render Order ID currently processed by the Pointer.
	    * @param {boolean} [includePixelPerfect=true] - If this object has `pixelPerfectClick` or `pixelPerfectOver` set should it be considered as valid?
	    * @return {boolean} True if the object this InputHandler is bound to should be considered as valid for input detection.
	    */validForInput:function validForInput(highestID,highestRenderID,includePixelPerfect){if(includePixelPerfect===undefined){includePixelPerfect=true;}if(!this.enabled||this.sprite.scale.x===0||this.sprite.scale.y===0||this.priorityID<this.game.input.minPriorityID||this.sprite.parent&&this.sprite.parent.ignoreChildInput){return false;}//   If we're trying to specifically IGNORE pixel perfect objects, then set includePixelPerfect to false and skip it
	if(!includePixelPerfect&&(this.pixelPerfectClick||this.pixelPerfectOver)){return false;}if(this.priorityID>highestID||this.priorityID===highestID&&this.sprite.renderOrderID>highestRenderID){return true;}return false;},/**
	    * Is this object using pixel perfect checking?
	    *
	    * @method Phaser.InputHandler#isPixelPerfect
	    * @return {boolean} True if the this InputHandler has either `pixelPerfectClick` or `pixelPerfectOver` set to `true`.
	    */isPixelPerfect:function isPixelPerfect(){return this.pixelPerfectClick||this.pixelPerfectOver;},/**
	    * The x coordinate of the Input pointer, relative to the top-left of the parent Sprite.
	    * This value is only set when the pointer is over this Sprite.
	    *
	    * @method Phaser.InputHandler#pointerX
	    * @param {integer} [pointerId=0]
	    * @return {number} The x coordinate of the Input pointer.
	    */pointerX:function pointerX(pointerId){pointerId=pointerId||0;return this._pointerData[pointerId].x;},/**
	    * The y coordinate of the Input pointer, relative to the top-left of the parent Sprite
	    * This value is only set when the pointer is over this Sprite.
	    *
	    * @method Phaser.InputHandler#pointerY
	    * @param {integer} [pointerId=0]
	    * @return {number} The y coordinate of the Input pointer.
	    */pointerY:function pointerY(pointerId){pointerId=pointerId||0;return this._pointerData[pointerId].y;},/**
	    * If the Pointer is down this returns true.
	    * This *only* checks if the Pointer is down, not if it's down over any specific Sprite.
	    *
	    * @method Phaser.InputHandler#pointerDown
	    * @param {integer} [pointerId=0]
	    * @return {boolean} - True if the given pointer is down, otherwise false.
	    */pointerDown:function pointerDown(pointerId){pointerId=pointerId||0;return this._pointerData[pointerId].isDown;},/**
	    * If the Pointer is up this returns true.
	    * This *only* checks if the Pointer is up, not if it's up over any specific Sprite.
	    *
	    * @method Phaser.InputHandler#pointerUp
	    * @param {integer} [pointerId=0]
	    * @return {boolean} - True if the given pointer is up, otherwise false.
	    */pointerUp:function pointerUp(pointerId){pointerId=pointerId||0;return this._pointerData[pointerId].isUp;},/**
	    * A timestamp representing when the Pointer first touched the touchscreen.
	    *
	    * @method Phaser.InputHandler#pointerTimeDown
	    * @param {integer} [pointerId=(check all)]
	    * @return {number}
	    */pointerTimeDown:function pointerTimeDown(pointerId){pointerId=pointerId||0;return this._pointerData[pointerId].timeDown;},/**
	    * A timestamp representing when the Pointer left the touchscreen.
	    *
	    * @method Phaser.InputHandler#pointerTimeUp
	    * @param {integer} [pointerId=0]
	    * @return {number}
	    */pointerTimeUp:function pointerTimeUp(pointerId){pointerId=pointerId||0;return this._pointerData[pointerId].timeUp;},/**
	    * Is the Pointer over this Sprite?
	    *
	    * @method Phaser.InputHandler#pointerOver
	    * @param {integer} [pointerId=(check all)] The ID number of a Pointer to check. If you don't provide a number it will check all Pointers.
	    * @return {boolean} - True if the given pointer (if a index was given, or any pointer if not) is over this object.
	    */pointerOver:function pointerOver(pointerId){if(!this.enabled){return false;}if(pointerId===undefined){for(var i=0;i<10;i++){if(this._pointerData[i].isOver){return true;}}return false;}else{return this._pointerData[pointerId].isOver;}},/**
	    * Is the Pointer outside of this Sprite?
	    *
	    * @method Phaser.InputHandler#pointerOut
	    * @param {integer} [pointerId=(check all)] The ID number of a Pointer to check. If you don't provide a number it will check all Pointers.
	    * @return {boolean} True if the given pointer (if a index was given, or any pointer if not) is out of this object.
	    */pointerOut:function pointerOut(pointerId){if(!this.enabled){return false;}if(pointerId===undefined){for(var i=0;i<10;i++){if(this._pointerData[i].isOut){return true;}}}else{return this._pointerData[pointerId].isOut;}},/**
	    * A timestamp representing when the Pointer first touched the touchscreen.
	    *
	    * @method Phaser.InputHandler#pointerTimeOver
	    * @param {integer} [pointerId=0]
	    * @return {number}
	    */pointerTimeOver:function pointerTimeOver(pointerId){pointerId=pointerId||0;return this._pointerData[pointerId].timeOver;},/**
	    * A timestamp representing when the Pointer left the touchscreen.
	    *
	    * @method Phaser.InputHandler#pointerTimeOut
	    * @param {integer} [pointerId=0]
	    * @return {number}
	    */pointerTimeOut:function pointerTimeOut(pointerId){pointerId=pointerId||0;return this._pointerData[pointerId].timeOut;},/**
	    * Is this sprite being dragged by the mouse or not?
	    *
	    * @method Phaser.InputHandler#pointerDragged
	    * @param {integer} [pointerId=0]
	    * @return {boolean} True if the pointer is dragging an object, otherwise false.
	    */pointerDragged:function pointerDragged(pointerId){pointerId=pointerId||0;return this._pointerData[pointerId].isDragged;},/**
	    * Checks if the given pointer is both down and over the Sprite this InputHandler belongs to.
	    * Use the `fastTest` flag is to quickly check just the bounding hit area even if `InputHandler.pixelPerfectOver` is `true`.
	    *
	    * @method Phaser.InputHandler#checkPointerDown
	    * @param {Phaser.Pointer} pointer
	    * @param {boolean} [fastTest=false] - Force a simple hit area check even if `pixelPerfectOver` is true for this object?
	    * @return {boolean} True if the pointer is down, otherwise false.
	    */checkPointerDown:function checkPointerDown(pointer,fastTest){if(!pointer.isDown||!this.enabled||!this.sprite||!this.sprite.parent||!this.sprite.visible||!this.sprite.parent.visible||this.sprite.worldScale.x===0||this.sprite.worldScale.y===0){return false;}//  Need to pass it a temp point, in case we need it again for the pixel check
	if(this.game.input.hitTest(this.sprite,pointer,this._tempPoint)){if(fastTest===undefined){fastTest=false;}if(!fastTest&&this.pixelPerfectClick){return this.checkPixel(this._tempPoint.x,this._tempPoint.y);}else{return true;}}return false;},/**
	    * Checks if the given pointer is over the Sprite this InputHandler belongs to.
	    * Use the `fastTest` flag is to quickly check just the bounding hit area even if `InputHandler.pixelPerfectOver` is `true`.
	    *
	    * @method Phaser.InputHandler#checkPointerOver
	    * @param {Phaser.Pointer} pointer
	    * @param {boolean} [fastTest=false] - Force a simple hit area check even if `pixelPerfectOver` is true for this object?
	    * @return {boolean}
	    */checkPointerOver:function checkPointerOver(pointer,fastTest){if(!this.enabled||!this.sprite||!this.sprite.parent||!this.sprite.visible||!this.sprite.parent.visible||this.sprite.worldScale.x===0||this.sprite.worldScale.y===0){return false;}//  Need to pass it a temp point, in case we need it again for the pixel check
	if(this.game.input.hitTest(this.sprite,pointer,this._tempPoint)){if(fastTest===undefined){fastTest=false;}if(!fastTest&&this.pixelPerfectOver){return this.checkPixel(this._tempPoint.x,this._tempPoint.y);}else{return true;}}return false;},/**
	    * Runs a pixel perfect check against the given x/y coordinates of the Sprite this InputHandler is bound to.
	    * It compares the alpha value of the pixel and if >= InputHandler.pixelPerfectAlpha it returns true.
	    *
	    * @method Phaser.InputHandler#checkPixel
	    * @param {number} x - The x coordinate to check.
	    * @param {number} y - The y coordinate to check.
	    * @param {Phaser.Pointer} [pointer] - The pointer to get the x/y coordinate from if not passed as the first two parameters.
	    * @return {boolean} true if there is the alpha of the pixel is >= InputHandler.pixelPerfectAlpha
	    */checkPixel:function checkPixel(x,y,pointer){//  Grab a pixel from our image into the hitCanvas and then test it
	if(this.sprite.texture.baseTexture.source){if(x===null&&y===null){//  Use the pointer parameter
	this.game.input.getLocalPosition(this.sprite,pointer,this._tempPoint);var x=this._tempPoint.x;var y=this._tempPoint.y;}if(this.sprite.anchor.x!==0){x-=-this.sprite.texture.frame.width*this.sprite.anchor.x;}if(this.sprite.anchor.y!==0){y-=-this.sprite.texture.frame.height*this.sprite.anchor.y;}x+=this.sprite.texture.frame.x;y+=this.sprite.texture.frame.y;if(this.sprite.texture.trim){x-=this.sprite.texture.trim.x;y-=this.sprite.texture.trim.y;//  If the coordinates are outside the trim area we return false immediately, to save doing a draw call
	if(x<this.sprite.texture.crop.x||x>this.sprite.texture.crop.right||y<this.sprite.texture.crop.y||y>this.sprite.texture.crop.bottom){this._dx=x;this._dy=y;return false;}}this._dx=x;this._dy=y;this.game.input.hitContext.clearRect(0,0,1,1);this.game.input.hitContext.drawImage(this.sprite.texture.baseTexture.source,x,y,1,1,0,0,1,1);var rgb=this.game.input.hitContext.getImageData(0,0,1,1);if(rgb.data[3]>=this.pixelPerfectAlpha){return true;}}return false;},/**
	    * Internal Update method. This is called automatically and handles the Pointer
	    * and drag update loops.
	    * 
	    * @method Phaser.InputHandler#update
	    * @protected
	    * @param {Phaser.Pointer} pointer
	    * @return {boolean} True if the pointer is still active, otherwise false.
	    */update:function update(pointer){if(this.sprite===null||this.sprite.parent===undefined){//  Abort. We've been destroyed.
	return;}if(!this.enabled||!this.sprite.visible||!this.sprite.parent.visible){this._pointerOutHandler(pointer);return false;}if(this._pendingDrag){if(!this._dragDistancePass){this._dragDistancePass=Phaser.Math.distance(pointer.x,pointer.y,this.downPoint.x,this.downPoint.y)>=this.dragDistanceThreshold;}if(this._dragDistancePass&&this._dragTimePass){this.startDrag(pointer);}return true;}else if(this.draggable&&this._draggedPointerID===pointer.id){return this.updateDrag(pointer,false);}else if(this._pointerData[pointer.id].isOver){if(this.checkPointerOver(pointer)){this._pointerData[pointer.id].x=pointer.x-this.sprite.x;this._pointerData[pointer.id].y=pointer.y-this.sprite.y;return true;}else{this._pointerOutHandler(pointer);return false;}}},/**
	    * Internal method handling the pointer over event.
	    * 
	    * @method Phaser.InputHandler#_pointerOverHandler
	    * @private
	    * @param {Phaser.Pointer} pointer - The pointer that triggered the event
	    * @param {boolean} [silent=false] - If silent is `true` then this method will not dispatch any Signals from the parent Sprite.
	    */_pointerOverHandler:function _pointerOverHandler(pointer,silent){if(this.sprite===null){//  Abort. We've been destroyed.
	return;}var data=this._pointerData[pointer.id];if(data.isOver===false||pointer.dirty){var sendEvent=data.isOver===false;data.isOver=true;data.isOut=false;data.timeOver=this.game.time.time;data.x=pointer.x-this.sprite.x;data.y=pointer.y-this.sprite.y;if(this.useHandCursor&&data.isDragged===false){this.game.canvas.style.cursor="pointer";this._setHandCursor=true;}if(!silent&&sendEvent&&this.sprite&&this.sprite.events){this.sprite.events.onInputOver$dispatch(this.sprite,pointer);}if(this.sprite.parent&&this.sprite.parent.type===Phaser.GROUP){this.sprite.parent.onChildInputOver.dispatch(this.sprite,pointer);}}},/**
	    * Internal method handling the pointer out event.
	    * 
	    * @method Phaser.InputHandler#_pointerOutHandler
	    * @private
	    * @param {Phaser.Pointer} pointer - The pointer that triggered the event.
	    * @param {boolean} [silent=false] - If silent is `true` then this method will not dispatch any Signals from the parent Sprite.
	    */_pointerOutHandler:function _pointerOutHandler(pointer,silent){if(this.sprite===null){//  Abort. We've been destroyed.
	return;}var data=this._pointerData[pointer.id];data.isOver=false;data.isOut=true;data.timeOut=this.game.time.time;if(this.useHandCursor&&data.isDragged===false){this.game.canvas.style.cursor="default";this._setHandCursor=false;}if(!silent&&this.sprite&&this.sprite.events){this.sprite.events.onInputOut$dispatch(this.sprite,pointer);if(this.sprite&&this.sprite.parent&&this.sprite.parent.type===Phaser.GROUP){this.sprite.parent.onChildInputOut.dispatch(this.sprite,pointer);}}},/**
	    * Internal method handling the touched / clicked event.
	    * 
	    * @method Phaser.InputHandler#_touchedHandler
	    * @private
	    * @param {Phaser.Pointer} pointer - The pointer that triggered the event.
	    */_touchedHandler:function _touchedHandler(pointer){if(this.sprite===null){//  Abort. We've been destroyed.
	return;}var data=this._pointerData[pointer.id];if(!data.isDown&&data.isOver){if(this.pixelPerfectClick&&!this.checkPixel(null,null,pointer)){return;}data.isDown=true;data.isUp=false;data.timeDown=this.game.time.time;this.downPoint.set(pointer.x,pointer.y);//  It's possible the onInputDown event creates a new Sprite that is on-top of this one, so we ought to force a Pointer update
	pointer.dirty=true;if(this.sprite&&this.sprite.events){this.sprite.events.onInputDown$dispatch(this.sprite,pointer);//  The event above might have destroyed this sprite.
	if(this.sprite&&this.sprite.parent&&this.sprite.parent.type===Phaser.GROUP){this.sprite.parent.onChildInputDown.dispatch(this.sprite,pointer);}//  The events might have destroyed this sprite.
	if(this.sprite===null){return;}}//  Start drag
	if(this.draggable&&this.isDragged===false){if(this.dragTimeThreshold===0&&this.dragDistanceThreshold===0){this.startDrag(pointer);}else{this._pendingDrag=true;this._dragDistancePass=this.dragDistanceThreshold===0;if(this.dragTimeThreshold>0){this._dragTimePass=false;this.game.time.events.add(this.dragTimeThreshold,this.dragTimeElapsed,this,pointer);}else{this._dragTimePass=true;}}}if(this.bringToTop){this.sprite.bringToTop();}}},/**
	    * Internal method handling the drag threshold timer.
	    * 
	    * @method Phaser.InputHandler#dragTimeElapsed
	    * @private
	    * @param {Phaser.Pointer} pointer
	    */dragTimeElapsed:function dragTimeElapsed(pointer){this._dragTimePass=true;if(this._pendingDrag&&this.sprite){if(this._dragDistancePass){this.startDrag(pointer);}}},/**
	    * Internal method handling the pointer released event.
	    * @method Phaser.InputHandler#_releasedHandler
	    * @private
	    * @param {Phaser.Pointer} pointer
	    */_releasedHandler:function _releasedHandler(pointer){if(this.sprite===null){//  Abort. We've been destroyed.
	return;}var data=this._pointerData[pointer.id];//  If was previously touched by this Pointer, check if still is AND still over this item
	if(data.isDown&&pointer.isUp){data.isDown=false;data.isUp=true;data.timeUp=this.game.time.time;data.downDuration=data.timeUp-data.timeDown;//  Only release the InputUp signal if the pointer is still over this sprite
	var isOver=this.checkPointerOver(pointer);if(this.sprite&&this.sprite.events){if(!this.dragStopBlocksInputUp||this.dragStopBlocksInputUp&&!(this.draggable&&this.isDragged&&this._draggedPointerID===pointer.id)){this.sprite.events.onInputUp$dispatch(this.sprite,pointer,isOver);}if(this.sprite&&this.sprite.parent&&this.sprite.parent.type===Phaser.GROUP){this.sprite.parent.onChildInputUp.dispatch(this.sprite,pointer,isOver);}//  The onInputUp event may have changed the sprite so that checkPointerOver is no longer true, so update it.
	if(isOver){isOver=this.checkPointerOver(pointer);}}data.isOver=isOver;if(!isOver&&this.useHandCursor){this.game.canvas.style.cursor="default";this._setHandCursor=false;}//  It's possible the onInputUp event created a new Sprite that is on-top of this one, so force a Pointer update
	pointer.dirty=true;this._pendingDrag=false;//  Stop drag
	if(this.draggable&&this.isDragged&&this._draggedPointerID===pointer.id){this.stopDrag(pointer);}}},/**
	    * Called as a Pointer actively drags this Game Object.
	    * 
	    * @method Phaser.InputHandler#updateDrag
	    * @private
	    * @param {Phaser.Pointer} pointer - The Pointer causing the drag update.
	    * @param {boolean} fromStart - True if this is the first update, immediately after the drag has started.
	    * @return {boolean}
	    */updateDrag:function updateDrag(pointer,fromStart){if(fromStart===undefined){fromStart=false;}if(pointer.isUp){this.stopDrag(pointer);return false;}var px=this.globalToLocalX(pointer.x)+this._dragPoint.x+this.dragOffset.x;var py=this.globalToLocalY(pointer.y)+this._dragPoint.y+this.dragOffset.y;if(this.sprite.fixedToCamera){if(this.allowHorizontalDrag){this.sprite.cameraOffset.x=px;}if(this.allowVerticalDrag){this.sprite.cameraOffset.y=py;}if(this.boundsRect){this.checkBoundsRect();}if(this.boundsSprite){this.checkBoundsSprite();}if(this.snapOnDrag){this.sprite.cameraOffset.x=Math.round((this.sprite.cameraOffset.x-this.snapOffsetX%this.snapX)/this.snapX)*this.snapX+this.snapOffsetX%this.snapX;this.sprite.cameraOffset.y=Math.round((this.sprite.cameraOffset.y-this.snapOffsetY%this.snapY)/this.snapY)*this.snapY+this.snapOffsetY%this.snapY;this.snapPoint.set(this.sprite.cameraOffset.x,this.sprite.cameraOffset.y);}}else{var cx=this.game.camera.x-this._pointerData[pointer.id].camX;var cy=this.game.camera.y-this._pointerData[pointer.id].camY;if(this.allowHorizontalDrag){this.sprite.x=px+cx;}if(this.allowVerticalDrag){this.sprite.y=py+cy;}if(this.boundsRect){this.checkBoundsRect();}if(this.boundsSprite){this.checkBoundsSprite();}if(this.snapOnDrag){this.sprite.x=Math.round((this.sprite.x-this.snapOffsetX%this.snapX)/this.snapX)*this.snapX+this.snapOffsetX%this.snapX;this.sprite.y=Math.round((this.sprite.y-this.snapOffsetY%this.snapY)/this.snapY)*this.snapY+this.snapOffsetY%this.snapY;this.snapPoint.set(this.sprite.x,this.sprite.y);}}this.sprite.events.onDragUpdate.dispatch(this.sprite,pointer,px,py,this.snapPoint,fromStart);return true;},/**
	    * Returns true if the pointer has entered the Sprite within the specified delay time (defaults to 500ms, half a second)
	    *
	    * @method Phaser.InputHandler#justOver
	    * @param {integer} [pointerId=0]
	    * @param {number} delay - The time below which the pointer is considered as just over.
	    * @return {boolean}
	    */justOver:function justOver(pointerId,delay){pointerId=pointerId||0;delay=delay||500;return this._pointerData[pointerId].isOver&&this.overDuration(pointerId)<delay;},/**
	    * Returns true if the pointer has left the Sprite within the specified delay time (defaults to 500ms, half a second)
	    *
	    * @method Phaser.InputHandler#justOut
	    * @param {integer} [pointerId=0]
	    * @param {number} delay - The time below which the pointer is considered as just out.
	    * @return {boolean}
	    */justOut:function justOut(pointerId,delay){pointerId=pointerId||0;delay=delay||500;return this._pointerData[pointerId].isOut&&this.game.time.time-this._pointerData[pointerId].timeOut<delay;},/**
	    * Returns true if the pointer has touched or clicked on the Sprite within the specified delay time (defaults to 500ms, half a second)
	    *
	    * @method Phaser.InputHandler#justPressed
	    * @param {integer} [pointerId=0]
	    * @param {number} delay - The time below which the pointer is considered as just over.
	    * @return {boolean}
	    */justPressed:function justPressed(pointerId,delay){pointerId=pointerId||0;delay=delay||500;return this._pointerData[pointerId].isDown&&this.downDuration(pointerId)<delay;},/**
	    * Returns true if the pointer was touching this Sprite, but has been released within the specified delay time (defaults to 500ms, half a second)
	    *
	    * @method Phaser.InputHandler#justReleased
	    * @param {integer} [pointerId=0]
	    * @param {number} delay - The time below which the pointer is considered as just out.
	    * @return {boolean}
	    */justReleased:function justReleased(pointerId,delay){pointerId=pointerId||0;delay=delay||500;return this._pointerData[pointerId].isUp&&this.game.time.time-this._pointerData[pointerId].timeUp<delay;},/**
	    * If the pointer is currently over this Sprite this returns how long it has been there for in milliseconds.
	    *
	    * @method Phaser.InputHandler#overDuration
	    * @param {integer} [pointerId=0]
	    * @return {number} The number of milliseconds the pointer has been over the Sprite, or -1 if not over.
	    */overDuration:function overDuration(pointerId){pointerId=pointerId||0;if(this._pointerData[pointerId].isOver){return this.game.time.time-this._pointerData[pointerId].timeOver;}return-1;},/**
	    * If the pointer is currently over this Sprite this returns how long it has been there for in milliseconds.
	    *
	    * @method Phaser.InputHandler#downDuration
	    * @param {integer} [pointerId=0]
	    * @return {number} The number of milliseconds the pointer has been pressed down on the Sprite, or -1 if not over.
	    */downDuration:function downDuration(pointerId){pointerId=pointerId||0;if(this._pointerData[pointerId].isDown){return this.game.time.time-this._pointerData[pointerId].timeDown;}return-1;},/**
	    * Allow this Sprite to be dragged by any valid pointer.
	    *
	    * When the drag begins the Sprite.events.onDragStart event will be dispatched.
	    * 
	    * When the drag completes by way of the user letting go of the pointer that was dragging the sprite, the Sprite.events.onDragStop event is dispatched.
	    *
	    * You can control the thresholds over when a drag starts via the properties:
	    * 
	    * `Pointer.dragDistanceThreshold` the distance, in pixels, that the pointer has to move
	    * before the drag will start.
	    *
	    * `Pointer.dragTimeThreshold` the time, in ms, that the pointer must be held down on
	    * the Sprite before the drag will start.
	    *
	    * You can set either (or both) of these properties after enabling a Sprite for drag.
	    *
	    * For the duration of the drag the Sprite.events.onDragUpdate event is dispatched. This event is only dispatched when the pointer actually
	    * changes position and moves. The event sends 5 parameters: `sprite`, `pointer`, `dragX`, `dragY` and `snapPoint`.
	    * 
	    * @method Phaser.InputHandler#enableDrag
	    * @param {boolean} [lockCenter=false] - If false the Sprite will drag from where you click it minus the dragOffset. If true it will center itself to the tip of the mouse pointer.
	    * @param {boolean} [bringToTop=false] - If true the Sprite will be bought to the top of the rendering list in its current Group.
	    * @param {boolean} [pixelPerfect=false] - If true it will use a pixel perfect test to see if you clicked the Sprite. False uses the bounding box.
	    * @param {boolean} [alphaThreshold=255] - If using pixel perfect collision this specifies the alpha level from 0 to 255 above which a collision is processed.
	    * @param {Phaser.Rectangle} [boundsRect=null] - If you want to restrict the drag of this sprite to a specific Rectangle, pass the Phaser.Rectangle here, otherwise it's free to drag anywhere.
	    * @param {Phaser.Sprite} [boundsSprite=null] - If you want to restrict the drag of this sprite to within the bounding box of another sprite, pass it here.
	    */enableDrag:function enableDrag(lockCenter,bringToTop,pixelPerfect,alphaThreshold,boundsRect,boundsSprite){if(lockCenter===undefined){lockCenter=false;}if(bringToTop===undefined){bringToTop=false;}if(pixelPerfect===undefined){pixelPerfect=false;}if(alphaThreshold===undefined){alphaThreshold=255;}if(boundsRect===undefined){boundsRect=null;}if(boundsSprite===undefined){boundsSprite=null;}this._dragPoint=new Phaser.Point();this.draggable=true;this.bringToTop=bringToTop;this.dragOffset=new Phaser.Point();this.dragFromCenter=lockCenter;this.pixelPerfectClick=pixelPerfect;this.pixelPerfectAlpha=alphaThreshold;if(boundsRect){this.boundsRect=boundsRect;}if(boundsSprite){this.boundsSprite=boundsSprite;}},/**
	    * Stops this sprite from being able to be dragged.
	    * If it is currently the target of an active drag it will be stopped immediately; also disables any set callbacks.
	    *
	    * @method Phaser.InputHandler#disableDrag
	    */disableDrag:function disableDrag(){if(this._pointerData){for(var i=0;i<10;i++){this._pointerData[i].isDragged=false;}}this.draggable=false;this.isDragged=false;this._draggedPointerID=-1;this._pendingDrag=false;},/**
	    * Called by Pointer when drag starts on this Sprite. Should not usually be called directly.
	    *
	    * @method Phaser.InputHandler#startDrag
	    * @param {Phaser.Pointer} pointer
	    */startDrag:function startDrag(pointer){var x=this.sprite.x;var y=this.sprite.y;this.isDragged=true;this._draggedPointerID=pointer.id;this._pointerData[pointer.id].camX=this.game.camera.x;this._pointerData[pointer.id].camY=this.game.camera.y;this._pointerData[pointer.id].isDragged=true;if(this.sprite.fixedToCamera){if(this.dragFromCenter){var bounds=this.sprite.getBounds();this.sprite.cameraOffset.x=this.globalToLocalX(pointer.x)+(this.sprite.cameraOffset.x-bounds.centerX);this.sprite.cameraOffset.y=this.globalToLocalY(pointer.y)+(this.sprite.cameraOffset.y-bounds.centerY);}this._dragPoint.setTo(this.sprite.cameraOffset.x-pointer.x,this.sprite.cameraOffset.y-pointer.y);}else{if(this.dragFromCenter){var bounds=this.sprite.getBounds();this.sprite.x=this.globalToLocalX(pointer.x)+(this.sprite.x-bounds.centerX);this.sprite.y=this.globalToLocalY(pointer.y)+(this.sprite.y-bounds.centerY);}this._dragPoint.setTo(this.sprite.x-this.globalToLocalX(pointer.x),this.sprite.y-this.globalToLocalY(pointer.y));}this.updateDrag(pointer,true);if(this.bringToTop){this._dragPhase=true;this.sprite.bringToTop();}this.dragStartPoint.set(x,y);this.sprite.events.onDragStart$dispatch(this.sprite,pointer,x,y);this._pendingDrag=false;},/**
	    * Warning: EXPERIMENTAL
	    *
	    * @method Phaser.InputHandler#globalToLocalX
	    * @param {number} x
	    */globalToLocalX:function globalToLocalX(x){if(this.scaleLayer){x-=this.game.scale.grid.boundsFluid.x;x*=this.game.scale.grid.scaleFluidInversed.x;}return x;},/**
	    * Warning: EXPERIMENTAL
	    *
	    * @method Phaser.InputHandler#globalToLocalY
	    * @param {number} y
	    */globalToLocalY:function globalToLocalY(y){if(this.scaleLayer){y-=this.game.scale.grid.boundsFluid.y;y*=this.game.scale.grid.scaleFluidInversed.y;}return y;},/**
	    * Called by Pointer when drag is stopped on this Sprite. Should not usually be called directly.
	    *
	    * @method Phaser.InputHandler#stopDrag
	    * @param {Phaser.Pointer} pointer
	    */stopDrag:function stopDrag(pointer){this.isDragged=false;this._draggedPointerID=-1;this._pointerData[pointer.id].isDragged=false;this._dragPhase=false;this._pendingDrag=false;if(this.snapOnRelease){if(this.sprite.fixedToCamera){this.sprite.cameraOffset.x=Math.round((this.sprite.cameraOffset.x-this.snapOffsetX%this.snapX)/this.snapX)*this.snapX+this.snapOffsetX%this.snapX;this.sprite.cameraOffset.y=Math.round((this.sprite.cameraOffset.y-this.snapOffsetY%this.snapY)/this.snapY)*this.snapY+this.snapOffsetY%this.snapY;}else{this.sprite.x=Math.round((this.sprite.x-this.snapOffsetX%this.snapX)/this.snapX)*this.snapX+this.snapOffsetX%this.snapX;this.sprite.y=Math.round((this.sprite.y-this.snapOffsetY%this.snapY)/this.snapY)*this.snapY+this.snapOffsetY%this.snapY;}}this.sprite.events.onDragStop$dispatch(this.sprite,pointer);if(this.checkPointerOver(pointer)===false){this._pointerOutHandler(pointer);}},/**
	    * Restricts this sprite to drag movement only on the given axis. Note: If both are set to false the sprite will never move!
	    *
	    * @method Phaser.InputHandler#setDragLock
	    * @param {boolean} [allowHorizontal=true] - To enable the sprite to be dragged horizontally set to true, otherwise false.
	    * @param {boolean} [allowVertical=true] - To enable the sprite to be dragged vertically set to true, otherwise false.
	    */setDragLock:function setDragLock(allowHorizontal,allowVertical){if(allowHorizontal===undefined){allowHorizontal=true;}if(allowVertical===undefined){allowVertical=true;}this.allowHorizontalDrag=allowHorizontal;this.allowVerticalDrag=allowVertical;},/**
	    * Make this Sprite snap to the given grid either during drag or when it's released.
	    * For example 16x16 as the snapX and snapY would make the sprite snap to every 16 pixels.
	    *
	    * @method Phaser.InputHandler#enableSnap
	    * @param {number} snapX - The width of the grid cell to snap to.
	    * @param {number} snapY - The height of the grid cell to snap to.
	    * @param {boolean} [onDrag=true] - If true the sprite will snap to the grid while being dragged.
	    * @param {boolean} [onRelease=false] - If true the sprite will snap to the grid when released.
	    * @param {number} [snapOffsetX=0] - Used to offset the top-left starting point of the snap grid.
	    * @param {number} [snapOffsetY=0] - Used to offset the top-left starting point of the snap grid.
	    */enableSnap:function enableSnap(snapX,snapY,onDrag,onRelease,snapOffsetX,snapOffsetY){if(onDrag===undefined){onDrag=true;}if(onRelease===undefined){onRelease=false;}if(snapOffsetX===undefined){snapOffsetX=0;}if(snapOffsetY===undefined){snapOffsetY=0;}this.snapX=snapX;this.snapY=snapY;this.snapOffsetX=snapOffsetX;this.snapOffsetY=snapOffsetY;this.snapOnDrag=onDrag;this.snapOnRelease=onRelease;},/**
	    * Stops the sprite from snapping to a grid during drag or release.
	    *
	    * @method Phaser.InputHandler#disableSnap
	    */disableSnap:function disableSnap(){this.snapOnDrag=false;this.snapOnRelease=false;},/**
	    * Bounds Rect check for the sprite drag
	    *
	    * @method Phaser.InputHandler#checkBoundsRect
	    */checkBoundsRect:function checkBoundsRect(){if(this.sprite.fixedToCamera){if(this.sprite.cameraOffset.x<this.boundsRect.left){this.sprite.cameraOffset.x=this.boundsRect.left;}else if(this.sprite.cameraOffset.x+this.sprite.width>this.boundsRect.right){this.sprite.cameraOffset.x=this.boundsRect.right-this.sprite.width;}if(this.sprite.cameraOffset.y<this.boundsRect.top){this.sprite.cameraOffset.y=this.boundsRect.top;}else if(this.sprite.cameraOffset.y+this.sprite.height>this.boundsRect.bottom){this.sprite.cameraOffset.y=this.boundsRect.bottom-this.sprite.height;}}else{if(this.sprite.left<this.boundsRect.left){this.sprite.x=this.boundsRect.x+this.sprite.offsetX;}else if(this.sprite.right>this.boundsRect.right){this.sprite.x=this.boundsRect.right-(this.sprite.width-this.sprite.offsetX);}if(this.sprite.top<this.boundsRect.top){this.sprite.y=this.boundsRect.top+this.sprite.offsetY;}else if(this.sprite.bottom>this.boundsRect.bottom){this.sprite.y=this.boundsRect.bottom-(this.sprite.height-this.sprite.offsetY);}}},/**
	    * Parent Sprite Bounds check for the sprite drag.
	    *
	    * @method Phaser.InputHandler#checkBoundsSprite
	    */checkBoundsSprite:function checkBoundsSprite(){if(this.sprite.fixedToCamera&&this.boundsSprite.fixedToCamera){if(this.sprite.cameraOffset.x<this.boundsSprite.cameraOffset.x){this.sprite.cameraOffset.x=this.boundsSprite.cameraOffset.x;}else if(this.sprite.cameraOffset.x+this.sprite.width>this.boundsSprite.cameraOffset.x+this.boundsSprite.width){this.sprite.cameraOffset.x=this.boundsSprite.cameraOffset.x+this.boundsSprite.width-this.sprite.width;}if(this.sprite.cameraOffset.y<this.boundsSprite.cameraOffset.y){this.sprite.cameraOffset.y=this.boundsSprite.cameraOffset.y;}else if(this.sprite.cameraOffset.y+this.sprite.height>this.boundsSprite.cameraOffset.y+this.boundsSprite.height){this.sprite.cameraOffset.y=this.boundsSprite.cameraOffset.y+this.boundsSprite.height-this.sprite.height;}}else{if(this.sprite.left<this.boundsSprite.left){this.sprite.x=this.boundsSprite.left+this.sprite.offsetX;}else if(this.sprite.right>this.boundsSprite.right){this.sprite.x=this.boundsSprite.right-(this.sprite.width-this.sprite.offsetX);}if(this.sprite.top<this.boundsSprite.top){this.sprite.y=this.boundsSprite.top+this.sprite.offsetY;}else if(this.sprite.bottom>this.boundsSprite.bottom){this.sprite.y=this.boundsSprite.bottom-(this.sprite.height-this.sprite.offsetY);}}}};Phaser.InputHandler.prototype.constructor=Phaser.InputHandler;/**
	* @author       @karlmacklin <tacklemcclean@gmail.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Gamepad class handles gamepad input and dispatches gamepad events.
	*
	* Remember to call `gamepad.start()`.
	*
	* HTML5 GAMEPAD API SUPPORT IS AT AN EXPERIMENTAL STAGE!
	* At moment of writing this (end of 2013) only Chrome supports parts of it out of the box. Firefox supports it
	* via prefs flags (about:config, search gamepad). The browsers map the same controllers differently.
	* This class has constants for Windows 7 Chrome mapping of XBOX 360 controller.
	*
	* @class Phaser.Gamepad
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	*/Phaser.Gamepad=function(game){/**
	    * @property {Phaser.Game} game - Local reference to game.
	    */this.game=game;/**
	    * @property {object} _gamepadIndexMap - Maps the browsers gamepad indices to our Phaser Gamepads
	    * @private
	    */this._gamepadIndexMap={};/**
	    * @property {Array} _rawPads - The raw state of the gamepads from the browser
	    * @private
	    */this._rawPads=[];/**
	    * @property {boolean} _active - Private flag for whether or not the API is polled
	    * @private
	    * @default
	    */this._active=false;/**
	    * Gamepad input will only be processed if enabled.
	    * @property {boolean} enabled
	    * @default
	    */this.enabled=true;/**
	    * Whether or not gamepads are supported in the current browser. Note that as of Dec. 2013 this check is actually not accurate at all due to poor implementation.
	    * @property {boolean} _gamepadSupportAvailable - Are gamepads supported in this browser or not?
	    * @private
	    */this._gamepadSupportAvailable=!!navigator.webkitGetGamepads||!!navigator.webkitGamepads||navigator.userAgent.indexOf('Firefox/')!==-1||!!navigator.getGamepads;/**
	    * Used to check for differences between earlier polls and current state of gamepads.
	    * @property {Array} _prevRawGamepadTypes
	    * @private
	    * @default
	    */this._prevRawGamepadTypes=[];/**
	    * Used to check for differences between earlier polls and current state of gamepads.
	    * @property {Array} _prevTimestamps
	    * @private
	    * @default
	    */this._prevTimestamps=[];/**
	    * @property {object} callbackContext - The context under which the callbacks are run.
	    */this.callbackContext=this;/**
	    * @property {function} onConnectCallback - This callback is invoked every time any gamepad is connected
	    */this.onConnectCallback=null;/**
	    * @property {function} onDisconnectCallback - This callback is invoked every time any gamepad is disconnected
	    */this.onDisconnectCallback=null;/**
	    * @property {function} onDownCallback - This callback is invoked every time any gamepad button is pressed down.
	    */this.onDownCallback=null;/**
	    * @property {function} onUpCallback - This callback is invoked every time any gamepad button is released.
	    */this.onUpCallback=null;/**
	    * @property {function} onAxisCallback - This callback is invoked every time any gamepad axis is changed.
	    */this.onAxisCallback=null;/**
	    * @property {function} onFloatCallback - This callback is invoked every time any gamepad button is changed to a value where value > 0 and value < 1.
	    */this.onFloatCallback=null;/**
	    * @property {function} _ongamepadconnected - Private callback for Firefox gamepad connection handling
	    * @private
	    */this._ongamepadconnected=null;/**
	    * @property {function} _gamepaddisconnected - Private callback for Firefox gamepad connection handling
	    * @private
	    */this._gamepaddisconnected=null;/**
	    * @property {Array<Phaser.SinglePad>} _gamepads - The four Phaser Gamepads.
	    * @private
	    */this._gamepads=[new Phaser.SinglePad(game,this),new Phaser.SinglePad(game,this),new Phaser.SinglePad(game,this),new Phaser.SinglePad(game,this)];};Phaser.Gamepad.prototype={/**
	    * Add callbacks to the main Gamepad handler to handle connect/disconnect/button down/button up/axis change/float value buttons.
	    * 
	    * @method Phaser.Gamepad#addCallbacks
	    * @param {object} context - The context under which the callbacks are run.
	    * @param {object} callbacks - Object that takes six different callback methods:
	    * onConnectCallback, onDisconnectCallback, onDownCallback, onUpCallback, onAxisCallback, onFloatCallback
	    */addCallbacks:function addCallbacks(context,callbacks){if(typeof callbacks!=='undefined'){this.onConnectCallback=typeof callbacks.onConnect==='function'?callbacks.onConnect:this.onConnectCallback;this.onDisconnectCallback=typeof callbacks.onDisconnect==='function'?callbacks.onDisconnect:this.onDisconnectCallback;this.onDownCallback=typeof callbacks.onDown==='function'?callbacks.onDown:this.onDownCallback;this.onUpCallback=typeof callbacks.onUp==='function'?callbacks.onUp:this.onUpCallback;this.onAxisCallback=typeof callbacks.onAxis==='function'?callbacks.onAxis:this.onAxisCallback;this.onFloatCallback=typeof callbacks.onFloat==='function'?callbacks.onFloat:this.onFloatCallback;this.callbackContext=context;}},/**
	    * Starts the Gamepad event handling.
	    * This MUST be called manually before Phaser will start polling the Gamepad API.
	    *
	    * @method Phaser.Gamepad#start
	    */start:function start(){if(this._active){//  Avoid setting multiple listeners
	return;}this._active=true;var _this=this;this._onGamepadConnected=function(event){return _this.onGamepadConnected(event);};this._onGamepadDisconnected=function(event){return _this.onGamepadDisconnected(event);};window.addEventListener('gamepadconnected',this._onGamepadConnected,false);window.addEventListener('gamepaddisconnected',this._onGamepadDisconnected,false);},/**
	     * Handles the connection of a Gamepad.
	     *
	     * @method onGamepadConnected
	     * @private
	     * @param {object} event - The DOM event.
	     */onGamepadConnected:function onGamepadConnected(event){var newPad=event.gamepad;this._rawPads.push(newPad);this._gamepads[newPad.index].connect(newPad);},/**
	     * Handles the disconnection of a Gamepad.
	     *
	     * @method onGamepadDisconnected
	     * @private
	     * @param {object} event - The DOM event.
	     */onGamepadDisconnected:function onGamepadDisconnected(event){var removedPad=event.gamepad;for(var i in this._rawPads){if(this._rawPads[i].index===removedPad.index){this._rawPads.splice(i,1);}}this._gamepads[removedPad.index].disconnect();},/**
	    * Main gamepad update loop. Should not be called manually.
	    * @method Phaser.Gamepad#update
	    * @protected
	    */update:function update(){this._pollGamepads();this.pad1.pollStatus();this.pad2.pollStatus();this.pad3.pollStatus();this.pad4.pollStatus();},/**
	    * Updating connected gamepads (for Google Chrome). Should not be called manually.
	    * 
	    * @method Phaser.Gamepad#_pollGamepads
	    * @private
	    */_pollGamepads:function _pollGamepads(){if(!this._active){return;}if(navigator['getGamepads']){var rawGamepads=navigator.getGamepads();}else if(navigator['webkitGetGamepads']){var rawGamepads=navigator.webkitGetGamepads();}else if(navigator['webkitGamepads']){var rawGamepads=navigator.webkitGamepads();}if(rawGamepads){this._rawPads=[];var gamepadsChanged=false;for(var i=0;i<rawGamepads.length;i++){if(_typeof(rawGamepads[i])!==this._prevRawGamepadTypes[i]){gamepadsChanged=true;this._prevRawGamepadTypes[i]=_typeof(rawGamepads[i]);}if(rawGamepads[i]){this._rawPads.push(rawGamepads[i]);}// Support max 4 pads at the moment
	if(i===3){break;}}for(var g=0;g<this._gamepads.length;g++){this._gamepads[g]._rawPad=this._rawPads[g];}if(gamepadsChanged){var validConnections={rawIndices:{},padIndices:{}};var singlePad;for(var j=0;j<this._gamepads.length;j++){singlePad=this._gamepads[j];if(singlePad.connected){for(var k=0;k<this._rawPads.length;k++){if(this._rawPads[k].index===singlePad.index){validConnections.rawIndices[singlePad.index]=true;validConnections.padIndices[j]=true;}}}}for(var l=0;l<this._gamepads.length;l++){singlePad=this._gamepads[l];if(validConnections.padIndices[l]){continue;}if(this._rawPads.length<1){singlePad.disconnect();}for(var m=0;m<this._rawPads.length;m++){if(validConnections.padIndices[l]){break;}var rawPad=this._rawPads[m];if(rawPad){if(validConnections.rawIndices[rawPad.index]){singlePad.disconnect();continue;}else{singlePad.connect(rawPad);validConnections.rawIndices[rawPad.index]=true;validConnections.padIndices[l]=true;}}else{singlePad.disconnect();}}}}}},/**
	    * Sets the deadZone variable for all four gamepads
	    * @method Phaser.Gamepad#setDeadZones
	    */setDeadZones:function setDeadZones(value){for(var i=0;i<this._gamepads.length;i++){this._gamepads[i].deadZone=value;}},/**
	    * Stops the Gamepad event handling.
	    *
	    * @method Phaser.Gamepad#stop
	    */stop:function stop(){this._active=false;window.removeEventListener('gamepadconnected',this._onGamepadConnected);window.removeEventListener('gamepaddisconnected',this._onGamepadDisconnected);},/**
	    * Reset all buttons/axes of all gamepads
	    * @method Phaser.Gamepad#reset
	    */reset:function reset(){this.update();for(var i=0;i<this._gamepads.length;i++){this._gamepads[i].reset();}},/**
	    * Returns the "just pressed" state of a button from ANY gamepad connected. Just pressed is considered true if the button was pressed down within the duration given (default 250ms).
	    * @method Phaser.Gamepad#justPressed
	    * @param {number} buttonCode - The buttonCode of the button to check for.
	    * @param {number} [duration=250] - The duration below which the button is considered as being just pressed.
	    * @return {boolean} True if the button is just pressed otherwise false.
	    */justPressed:function justPressed(buttonCode,duration){for(var i=0;i<this._gamepads.length;i++){if(this._gamepads[i].justPressed(buttonCode,duration)===true){return true;}}return false;},/**
	    * Returns the "just released" state of a button from ANY gamepad connected. Just released is considered as being true if the button was released within the duration given (default 250ms).
	    * @method Phaser.Gamepad#justPressed
	    * @param {number} buttonCode - The buttonCode of the button to check for.
	    * @param {number} [duration=250] - The duration below which the button is considered as being just released.
	    * @return {boolean} True if the button is just released otherwise false.
	    */justReleased:function justReleased(buttonCode,duration){for(var i=0;i<this._gamepads.length;i++){if(this._gamepads[i].justReleased(buttonCode,duration)===true){return true;}}return false;},/**
	    * Returns true if the button is currently pressed down, on ANY gamepad.
	    * @method Phaser.Gamepad#isDown
	    * @param {number} buttonCode - The buttonCode of the button to check for.
	    * @return {boolean} True if a button is currently down.
	    */isDown:function isDown(buttonCode){for(var i=0;i<this._gamepads.length;i++){if(this._gamepads[i].isDown(buttonCode)===true){return true;}}return false;},/**
	     * Destroys this object and the associated event listeners.
	     *
	     * @method Phaser.Gamepad#destroy
	     */destroy:function destroy(){this.stop();for(var i=0;i<this._gamepads.length;i++){this._gamepads[i].destroy();}}};Phaser.Gamepad.prototype.constructor=Phaser.Gamepad;/**
	* If the gamepad input is active or not - if not active it should not be updated from Input.js
	* @name Phaser.Gamepad#active
	* @property {boolean} active - If the gamepad input is active or not.
	* @readonly
	*/Object.defineProperty(Phaser.Gamepad.prototype,"active",{get:function get(){return this._active;}});/**
	* Whether or not gamepads are supported in current browser.
	* @name Phaser.Gamepad#supported
	* @property {boolean} supported - Whether or not gamepads are supported in current browser.
	* @readonly
	*/Object.defineProperty(Phaser.Gamepad.prototype,"supported",{get:function get(){return this._gamepadSupportAvailable;}});/**
	* How many live gamepads are currently connected.
	* @name Phaser.Gamepad#padsConnected
	* @property {number} padsConnected - How many live gamepads are currently connected.
	* @readonly
	*/Object.defineProperty(Phaser.Gamepad.prototype,"padsConnected",{get:function get(){return this._rawPads.length;}});/**
	* Gamepad #1
	* @name Phaser.Gamepad#pad1
	* @property {Phaser.SinglePad} pad1 - Gamepad #1;
	* @readonly
	*/Object.defineProperty(Phaser.Gamepad.prototype,"pad1",{get:function get(){return this._gamepads[0];}});/**
	* Gamepad #2
	* @name Phaser.Gamepad#pad2
	* @property {Phaser.SinglePad} pad2 - Gamepad #2
	* @readonly
	*/Object.defineProperty(Phaser.Gamepad.prototype,"pad2",{get:function get(){return this._gamepads[1];}});/**
	* Gamepad #3
	* @name Phaser.Gamepad#pad3
	* @property {Phaser.SinglePad} pad3 - Gamepad #3
	* @readonly
	*/Object.defineProperty(Phaser.Gamepad.prototype,"pad3",{get:function get(){return this._gamepads[2];}});/**
	* Gamepad #4
	* @name Phaser.Gamepad#pad4
	* @property {Phaser.SinglePad} pad4 - Gamepad #4
	* @readonly
	*/Object.defineProperty(Phaser.Gamepad.prototype,"pad4",{get:function get(){return this._gamepads[3];}});Phaser.Gamepad.BUTTON_0=0;Phaser.Gamepad.BUTTON_1=1;Phaser.Gamepad.BUTTON_2=2;Phaser.Gamepad.BUTTON_3=3;Phaser.Gamepad.BUTTON_4=4;Phaser.Gamepad.BUTTON_5=5;Phaser.Gamepad.BUTTON_6=6;Phaser.Gamepad.BUTTON_7=7;Phaser.Gamepad.BUTTON_8=8;Phaser.Gamepad.BUTTON_9=9;Phaser.Gamepad.BUTTON_10=10;Phaser.Gamepad.BUTTON_11=11;Phaser.Gamepad.BUTTON_12=12;Phaser.Gamepad.BUTTON_13=13;Phaser.Gamepad.BUTTON_14=14;Phaser.Gamepad.BUTTON_15=15;Phaser.Gamepad.AXIS_0=0;Phaser.Gamepad.AXIS_1=1;Phaser.Gamepad.AXIS_2=2;Phaser.Gamepad.AXIS_3=3;Phaser.Gamepad.AXIS_4=4;Phaser.Gamepad.AXIS_5=5;Phaser.Gamepad.AXIS_6=6;Phaser.Gamepad.AXIS_7=7;Phaser.Gamepad.AXIS_8=8;Phaser.Gamepad.AXIS_9=9;// Below mapping applies to XBOX 360 Wired and Wireless controller on Google Chrome (tested on Windows 7).
	// - Firefox uses different map! Separate amount of buttons and axes. DPAD = axis and not a button.
	// In other words - discrepancies when using gamepads.
	Phaser.Gamepad.XBOX360_A=0;Phaser.Gamepad.XBOX360_B=1;Phaser.Gamepad.XBOX360_X=2;Phaser.Gamepad.XBOX360_Y=3;Phaser.Gamepad.XBOX360_LEFT_BUMPER=4;Phaser.Gamepad.XBOX360_RIGHT_BUMPER=5;Phaser.Gamepad.XBOX360_LEFT_TRIGGER=6;Phaser.Gamepad.XBOX360_RIGHT_TRIGGER=7;Phaser.Gamepad.XBOX360_BACK=8;Phaser.Gamepad.XBOX360_START=9;Phaser.Gamepad.XBOX360_STICK_LEFT_BUTTON=10;Phaser.Gamepad.XBOX360_STICK_RIGHT_BUTTON=11;Phaser.Gamepad.XBOX360_DPAD_LEFT=14;Phaser.Gamepad.XBOX360_DPAD_RIGHT=15;Phaser.Gamepad.XBOX360_DPAD_UP=12;Phaser.Gamepad.XBOX360_DPAD_DOWN=13;//  On FF 0 = Y, 1 = X, 2 = Y, 3 = X, 4 = left bumper, 5 = dpad left, 6 = dpad right
	Phaser.Gamepad.XBOX360_STICK_LEFT_X=0;Phaser.Gamepad.XBOX360_STICK_LEFT_Y=1;Phaser.Gamepad.XBOX360_STICK_RIGHT_X=2;Phaser.Gamepad.XBOX360_STICK_RIGHT_Y=3;//  PlayStation 3 controller (masquerading as xbox360 controller) button mappings
	Phaser.Gamepad.PS3XC_X=0;Phaser.Gamepad.PS3XC_CIRCLE=1;Phaser.Gamepad.PS3XC_SQUARE=2;Phaser.Gamepad.PS3XC_TRIANGLE=3;Phaser.Gamepad.PS3XC_L1=4;Phaser.Gamepad.PS3XC_R1=5;Phaser.Gamepad.PS3XC_L2=6;// analog trigger, range 0..1
	Phaser.Gamepad.PS3XC_R2=7;// analog trigger, range 0..1
	Phaser.Gamepad.PS3XC_SELECT=8;Phaser.Gamepad.PS3XC_START=9;Phaser.Gamepad.PS3XC_STICK_LEFT_BUTTON=10;Phaser.Gamepad.PS3XC_STICK_RIGHT_BUTTON=11;Phaser.Gamepad.PS3XC_DPAD_UP=12;Phaser.Gamepad.PS3XC_DPAD_DOWN=13;Phaser.Gamepad.PS3XC_DPAD_LEFT=14;Phaser.Gamepad.PS3XC_DPAD_RIGHT=15;Phaser.Gamepad.PS3XC_STICK_LEFT_X=0;// analog stick, range -1..1
	Phaser.Gamepad.PS3XC_STICK_LEFT_Y=1;// analog stick, range -1..1
	Phaser.Gamepad.PS3XC_STICK_RIGHT_X=2;// analog stick, range -1..1
	Phaser.Gamepad.PS3XC_STICK_RIGHT_Y=3;// analog stick, range -1..1
	/**
	* @author       @karlmacklin <tacklemcclean@gmail.com>
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A single Phaser Gamepad
	* 
	* @class Phaser.SinglePad
	* @constructor
	* @param {Phaser.Game} game - Current game instance.
	* @param {object} padParent - The parent Phaser.Gamepad object (all gamepads reside under this)
	*/Phaser.SinglePad=function(game,padParent){/**
	    * @property {Phaser.Game} game - Local reference to game.
	    */this.game=game;/**
	    * @property {number} index - The gamepad index as per browsers data
	    * @readonly
	    */this.index=null;/**
	    * @property {boolean} connected - Whether or not this particular gamepad is connected or not.
	    * @readonly
	    */this.connected=false;/**
	    * @property {object} callbackContext - The context under which the callbacks are run.
	    */this.callbackContext=this;/**
	    * @property {function} onConnectCallback - This callback is invoked every time this gamepad is connected
	    */this.onConnectCallback=null;/**
	    * @property {function} onDisconnectCallback - This callback is invoked every time this gamepad is disconnected
	    */this.onDisconnectCallback=null;/**
	    * @property {function} onDownCallback - This callback is invoked every time a button is pressed down.
	    */this.onDownCallback=null;/**
	    * @property {function} onUpCallback - This callback is invoked every time a gamepad button is released.
	    */this.onUpCallback=null;/**
	    * @property {function} onAxisCallback - This callback is invoked every time an axis is changed.
	    */this.onAxisCallback=null;/**
	    * @property {function} onFloatCallback - This callback is invoked every time a button is changed to a value where value > 0 and value < 1.
	    */this.onFloatCallback=null;/**
	    * @property {number} deadZone - Dead zone for axis feedback - within this value you won't trigger updates.
	    */this.deadZone=0.26;/**
	    * @property {Phaser.Gamepad} padParent - Main Phaser Gamepad object
	    * @private
	    */this._padParent=padParent;/**
	    * @property {object} _rawPad - The 'raw' gamepad data.
	    * @private
	    */this._rawPad=null;/**
	    * @property {number} _prevTimestamp - Used to check for differences between earlier polls and current state of gamepads.
	    * @private
	    */this._prevTimestamp=null;/**
	    * @property {Array} _buttons - Array of Phaser.DeviceButton objects. This array is populated when the gamepad is connected.
	    * @private
	    */this._buttons=[];/**
	    * @property {number} _buttonsLen - Length of the _buttons array.
	    * @private
	    */this._buttonsLen=0;/**
	    * @property {Array} _axes - Current axes state.
	    * @private
	    */this._axes=[];/**
	    * @property {number} _axesLen - Length of the _axes array.
	    * @private
	    */this._axesLen=0;};Phaser.SinglePad.prototype={/**
	    * Add callbacks to this Gamepad to handle connect / disconnect / button down / button up / axis change / float value buttons.
	    * 
	    * @method Phaser.SinglePad#addCallbacks
	    * @param {object} context - The context under which the callbacks are run.
	    * @param {object} callbacks - Object that takes six different callbak methods:
	    * onConnectCallback, onDisconnectCallback, onDownCallback, onUpCallback, onAxisCallback, onFloatCallback
	    */addCallbacks:function addCallbacks(context,callbacks){if(typeof callbacks!=='undefined'){this.onConnectCallback=typeof callbacks.onConnect==='function'?callbacks.onConnect:this.onConnectCallback;this.onDisconnectCallback=typeof callbacks.onDisconnect==='function'?callbacks.onDisconnect:this.onDisconnectCallback;this.onDownCallback=typeof callbacks.onDown==='function'?callbacks.onDown:this.onDownCallback;this.onUpCallback=typeof callbacks.onUp==='function'?callbacks.onUp:this.onUpCallback;this.onAxisCallback=typeof callbacks.onAxis==='function'?callbacks.onAxis:this.onAxisCallback;this.onFloatCallback=typeof callbacks.onFloat==='function'?callbacks.onFloat:this.onFloatCallback;this.callbackContext=context;}},/**
	    * Gets a DeviceButton object from this controller to be stored and referenced locally.
	    * The DeviceButton object can then be polled, have events attached to it, etc.
	    *
	    * @method Phaser.SinglePad#getButton
	    * @param {number} buttonCode - The buttonCode of the button, i.e. Phaser.Gamepad.BUTTON_0, Phaser.Gamepad.XBOX360_A, etc.
	    * @return {Phaser.DeviceButton} The DeviceButton object which you can store locally and reference directly.
	    */getButton:function getButton(buttonCode){if(this._buttons[buttonCode]){return this._buttons[buttonCode];}else{return null;}},/**
	    * Main update function called by Phaser.Gamepad.
	    * 
	    * @method Phaser.SinglePad#pollStatus
	    */pollStatus:function pollStatus(){if(!this.connected||!this.game.input.enabled||!this.game.input.gamepad.enabled||this._rawPad.timestamp&&this._rawPad.timestamp===this._prevTimestamp){return;}for(var i=0;i<this._buttonsLen;i++){var rawButtonVal=isNaN(this._rawPad.buttons[i])?this._rawPad.buttons[i].value:this._rawPad.buttons[i];if(rawButtonVal!==this._buttons[i].value){if(rawButtonVal===1){this.processButtonDown(i,rawButtonVal);}else if(rawButtonVal===0){this.processButtonUp(i,rawButtonVal);}else{this.processButtonFloat(i,rawButtonVal);}}}for(var index=0;index<this._axesLen;index++){var value=this._rawPad.axes[index];if(value>0&&value>this.deadZone||value<0&&value<-this.deadZone){this.processAxisChange(index,value);}else{this.processAxisChange(index,0);}}this._prevTimestamp=this._rawPad.timestamp;},/**
	    * Gamepad connect function, should be called by Phaser.Gamepad.
	    * 
	    * @method Phaser.SinglePad#connect
	    * @param {object} rawPad - The raw gamepad object
	    */connect:function connect(rawPad){var triggerCallback=!this.connected;this.connected=true;this.index=rawPad.index;this._rawPad=rawPad;this._buttons=[];this._buttonsLen=rawPad.buttons.length;this._axes=[];this._axesLen=rawPad.axes.length;for(var a=0;a<this._axesLen;a++){this._axes[a]=rawPad.axes[a];}for(var buttonCode in rawPad.buttons){buttonCode=parseInt(buttonCode,10);this._buttons[buttonCode]=new Phaser.DeviceButton(this,buttonCode);}if(triggerCallback&&this._padParent.onConnectCallback){this._padParent.onConnectCallback.call(this._padParent.callbackContext,this.index);}if(triggerCallback&&this.onConnectCallback){this.onConnectCallback.call(this.callbackContext);}},/**
	    * Gamepad disconnect function, should be called by Phaser.Gamepad.
	    * 
	    * @method Phaser.SinglePad#disconnect
	    */disconnect:function disconnect(){var triggerCallback=this.connected;var disconnectingIndex=this.index;this.connected=false;this.index=null;this._rawPad=undefined;for(var i=0;i<this._buttonsLen;i++){this._buttons[i].destroy();}this._buttons=[];this._buttonsLen=0;this._axes=[];this._axesLen=0;if(triggerCallback&&this._padParent.onDisconnectCallback){this._padParent.onDisconnectCallback.call(this._padParent.callbackContext,disconnectingIndex);}if(triggerCallback&&this.onDisconnectCallback){this.onDisconnectCallback.call(this.callbackContext);}},/**
	     * Destroys this object and associated callback references.
	     *
	     * @method Phaser.SinglePad#destroy
	     */destroy:function destroy(){this._rawPad=undefined;for(var i=0;i<this._buttonsLen;i++){this._buttons[i].destroy();}this._buttons=[];this._buttonsLen=0;this._axes=[];this._axesLen=0;this.onConnectCallback=null;this.onDisconnectCallback=null;this.onDownCallback=null;this.onUpCallback=null;this.onAxisCallback=null;this.onFloatCallback=null;},/**
	    * Handles changes in axis.
	    * 
	    * @method Phaser.SinglePad#processAxisChange
	    * @param {object} axisState - State of the relevant axis
	    */processAxisChange:function processAxisChange(index,value){if(this._axes[index]===value){return;}this._axes[index]=value;if(this._padParent.onAxisCallback){this._padParent.onAxisCallback.call(this._padParent.callbackContext,this,index,value);}if(this.onAxisCallback){this.onAxisCallback.call(this.callbackContext,this,index,value);}},/**
	    * Handles button down press.
	    * 
	    * @method Phaser.SinglePad#processButtonDown
	    * @param {number} buttonCode - Which buttonCode of this button
	    * @param {object} value - Button value
	    */processButtonDown:function processButtonDown(buttonCode,value){if(this._buttons[buttonCode]){this._buttons[buttonCode].start(null,value);}if(this._padParent.onDownCallback){this._padParent.onDownCallback.call(this._padParent.callbackContext,buttonCode,value,this.index);}if(this.onDownCallback){this.onDownCallback.call(this.callbackContext,buttonCode,value);}},/**
	    * Handles button release.
	    * 
	    * @method Phaser.SinglePad#processButtonUp
	    * @param {number} buttonCode - Which buttonCode of this button
	    * @param {object} value - Button value
	    */processButtonUp:function processButtonUp(buttonCode,value){if(this._padParent.onUpCallback){this._padParent.onUpCallback.call(this._padParent.callbackContext,buttonCode,value,this.index);}if(this.onUpCallback){this.onUpCallback.call(this.callbackContext,buttonCode,value);}if(this._buttons[buttonCode]){this._buttons[buttonCode].stop(null,value);}},/**
	    * Handles buttons with floating values (like analog buttons that acts almost like an axis but still registers like a button)
	    * 
	    * @method Phaser.SinglePad#processButtonFloat
	    * @param {number} buttonCode - Which buttonCode of this button
	    * @param {object} value - Button value (will range somewhere between 0 and 1, but not specifically 0 or 1.
	    */processButtonFloat:function processButtonFloat(buttonCode,value){if(this._padParent.onFloatCallback){this._padParent.onFloatCallback.call(this._padParent.callbackContext,buttonCode,value,this.index);}if(this.onFloatCallback){this.onFloatCallback.call(this.callbackContext,buttonCode,value);}if(this._buttons[buttonCode]){this._buttons[buttonCode].padFloat(value);}},/**
	    * Returns value of requested axis.
	    * 
	    * @method Phaser.SinglePad#axis
	    * @param {number} axisCode - The index of the axis to check
	    * @return {number} Axis value if available otherwise false
	    */axis:function axis(axisCode){if(this._axes[axisCode]){return this._axes[axisCode];}return false;},/**
	    * Returns true if the button is pressed down.
	    * 
	    * @method Phaser.SinglePad#isDown
	    * @param {number} buttonCode - The buttonCode of the button to check.
	    * @return {boolean} True if the button is pressed down.
	    */isDown:function isDown(buttonCode){if(this._buttons[buttonCode]){return this._buttons[buttonCode].isDown;}return false;},/**
	    * Returns true if the button is not currently pressed.
	    * 
	    * @method Phaser.SinglePad#isUp
	    * @param {number} buttonCode - The buttonCode of the button to check.
	    * @return {boolean} True if the button is not currently pressed down.
	    */isUp:function isUp(buttonCode){if(this._buttons[buttonCode]){return this._buttons[buttonCode].isUp;}return false;},/**
	    * Returns the "just released" state of a button from this gamepad. Just released is considered as being true if the button was released within the duration given (default 250ms).
	    * 
	    * @method Phaser.SinglePad#justReleased
	    * @param {number} buttonCode - The buttonCode of the button to check for.
	    * @param {number} [duration=250] - The duration below which the button is considered as being just released.
	    * @return {boolean} True if the button is just released otherwise false.
	    */justReleased:function justReleased(buttonCode,duration){if(this._buttons[buttonCode]){return this._buttons[buttonCode].justReleased(duration);}},/**
	    * Returns the "just pressed" state of a button from this gamepad. Just pressed is considered true if the button was pressed down within the duration given (default 250ms).
	    * 
	    * @method Phaser.SinglePad#justPressed
	    * @param {number} buttonCode - The buttonCode of the button to check for.
	    * @param {number} [duration=250] - The duration below which the button is considered as being just pressed.
	    * @return {boolean} True if the button is just pressed otherwise false.
	    */justPressed:function justPressed(buttonCode,duration){if(this._buttons[buttonCode]){return this._buttons[buttonCode].justPressed(duration);}},/**
	    * Returns the value of a gamepad button. Intended mainly for cases when you have floating button values, for example
	    * analog trigger buttons on the XBOX 360 controller.
	    * 
	    * @method Phaser.SinglePad#buttonValue
	    * @param {number} buttonCode - The buttonCode of the button to check.
	    * @return {number} Button value if available otherwise null. Be careful as this can incorrectly evaluate to 0.
	    */buttonValue:function buttonValue(buttonCode){if(this._buttons[buttonCode]){return this._buttons[buttonCode].value;}return null;},/**
	    * Reset all buttons/axes of this gamepad.
	    * 
	    * @method Phaser.SinglePad#reset
	    */reset:function reset(){for(var j=0;j<this._axes.length;j++){this._axes[j]=0;}}};Phaser.SinglePad.prototype.constructor=Phaser.SinglePad;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* If you need more fine-grained control over the handling of specific keys you can create and use Phaser.Key objects.
	* 
	* @class Phaser.Key
	* @constructor
	* @param {Phaser.Game} game - Current game instance.
	* @param {integer} keycode - The key code this Key is responsible for. See {@link Phaser.KeyCode}.
	*/Phaser.Key=function(game,keycode){/**
	    * @property {Phaser.Game} game - A reference to the currently running game.
	    */this.game=game;/**
	    * The enabled state of the key - see `enabled`.
	    * @property {boolean} _enabled
	    * @private
	    */this._enabled=true;/**
	    * @property {object} event - Stores the most recent DOM event.
	    * @readonly
	    */this.event=null;/**
	    * @property {boolean} isDown - The "down" state of the key. This will remain `true` for as long as the keyboard thinks this key is held down.
	    * @default
	    */this.isDown=false;/**
	    * @property {boolean} isUp - The "up" state of the key. This will remain `true` for as long as the keyboard thinks this key is up.
	    * @default
	    */this.isUp=true;/**
	    * @property {boolean} altKey - The down state of the ALT key, if pressed at the same time as this key.
	    * @default
	    */this.altKey=false;/**
	    * @property {boolean} ctrlKey - The down state of the CTRL key, if pressed at the same time as this key.
	    * @default
	    */this.ctrlKey=false;/**
	    * @property {boolean} shiftKey - The down state of the SHIFT key, if pressed at the same time as this key.
	    * @default
	    */this.shiftKey=false;/**
	    * @property {number} timeDown - The timestamp when the key was last pressed down. This is based on Game.time.now.
	    */this.timeDown=0;/**
	    * If the key is down this value holds the duration of that key press and is constantly updated.
	    * If the key is up it holds the duration of the previous down session.
	    * @property {number} duration - The number of milliseconds this key has been held down for.
	    * @default
	    */this.duration=0;/**
	    * @property {number} timeUp - The timestamp when the key was last released. This is based on Game.time.now.
	    * @default
	    */this.timeUp=-2500;/**
	    * @property {number} repeats - If a key is held down this holds down the number of times the key has 'repeated'.
	    * @default
	    */this.repeats=0;/**
	    * @property {number} keyCode - The keycode of this key.
	    */this.keyCode=keycode;/**
	    * @property {Phaser.Signal} onDown - This Signal is dispatched every time this Key is pressed down. It is only dispatched once (until the key is released again).
	    */this.onDown=new Phaser.Signal();/**
	    * @property {function} onHoldCallback - A callback that is called while this Key is held down. Warning: Depending on refresh rate that could be 60+ times per second.
	    */this.onHoldCallback=null;/**
	    * @property {object} onHoldContext - The context under which the onHoldCallback will be called.
	    */this.onHoldContext=null;/**
	    * @property {Phaser.Signal} onUp - This Signal is dispatched every time this Key is released. It is only dispatched once (until the key is pressed and released again).
	    */this.onUp=new Phaser.Signal();/**
	     * @property {boolean} _justDown - True if the key has just been pressed (NOTE: requires to be reset, see justDown getter)
	     * @private
	     */this._justDown=false;/**
	     * @property {boolean} _justUp - True if the key has just been pressed (NOTE: requires to be reset, see justDown getter)
	     * @private
	     */this._justUp=false;};Phaser.Key.prototype={/**
	    * Called automatically by Phaser.Keyboard.
	    * 
	    * @method Phaser.Key#update
	    * @protected
	    */update:function update(){if(!this._enabled){return;}if(this.isDown){this.duration=this.game.time.time-this.timeDown;this.repeats++;if(this.onHoldCallback){this.onHoldCallback.call(this.onHoldContext,this);}}},/**
	    * Called automatically by Phaser.Keyboard.
	    * 
	    * @method Phaser.Key#processKeyDown
	    * @param {KeyboardEvent} event - The DOM event that triggered this.
	    * @protected
	    */processKeyDown:function processKeyDown(event){if(!this._enabled){return;}this.event=event;// exit if this key down is from auto-repeat
	if(this.isDown){return;}this.altKey=event.altKey;this.ctrlKey=event.ctrlKey;this.shiftKey=event.shiftKey;this.isDown=true;this.isUp=false;this.timeDown=this.game.time.time;this.duration=0;this.repeats=0;// _justDown will remain true until it is read via the justDown Getter
	// this enables the game to poll for past presses, or reset it at the start of a new game state
	this._justDown=true;this.onDown.dispatch(this);},/**
	    * Called automatically by Phaser.Keyboard.
	    * 
	    * @method Phaser.Key#processKeyUp
	    * @param {KeyboardEvent} event - The DOM event that triggered this.
	    * @protected
	    */processKeyUp:function processKeyUp(event){if(!this._enabled){return;}this.event=event;if(this.isUp){return;}this.isDown=false;this.isUp=true;this.timeUp=this.game.time.time;this.duration=this.game.time.time-this.timeDown;// _justUp will remain true until it is read via the justUp Getter
	// this enables the game to poll for past presses, or reset it at the start of a new game state
	this._justUp=true;this.onUp.dispatch(this);},/**
	    * Resets the state of this Key.
	    *
	    * This sets isDown to false, isUp to true, resets the time to be the current time, and _enables_ the key.
	    * In addition, if it is a "hard reset", it clears clears any callbacks associated with the onDown and onUp events and removes the onHoldCallback.
	    *
	    * @method Phaser.Key#reset
	    * @param {boolean} [hard=true] - A soft reset won't reset any events or callbacks; a hard reset will.
	    */reset:function reset(hard){if(hard===undefined){hard=true;}this.isDown=false;this.isUp=true;this.timeUp=this.game.time.time;this.duration=0;this._enabled=true;// .enabled causes reset(false)
	this._justDown=false;this._justUp=false;if(hard){this.onDown.removeAll();this.onUp.removeAll();this.onHoldCallback=null;this.onHoldContext=null;}},/**
	    * Returns `true` if the Key was pressed down within the `duration` value given, or `false` if it either isn't down,
	    * or was pressed down longer ago than then given duration.
	    * 
	    * @method Phaser.Key#downDuration
	    * @param {number} [duration=50] - The duration within which the key is considered as being just pressed. Given in ms.
	    * @return {boolean} True if the key was pressed down within the given duration.
	    */downDuration:function downDuration(duration){if(duration===undefined){duration=50;}return this.isDown&&this.duration<duration;},/**
	    * Returns `true` if the Key was pressed down within the `duration` value given, or `false` if it either isn't down,
	    * or was pressed down longer ago than then given duration.
	    * 
	    * @method Phaser.Key#upDuration
	    * @param {number} [duration=50] - The duration within which the key is considered as being just released. Given in ms.
	    * @return {boolean} True if the key was released within the given duration.
	    */upDuration:function upDuration(duration){if(duration===undefined){duration=50;}return!this.isDown&&this.game.time.time-this.timeUp<duration;}};/**
	* The justDown value allows you to test if this Key has just been pressed down or not.
	* When you check this value it will return `true` if the Key is down, otherwise `false`.
	* You can only call justDown once per key press. It will only return `true` once, until the Key is released and pressed down again.
	* This allows you to use it in situations where you want to check if this key is down without using a Signal, such as in a core game loop.
	* 
	* @property {boolean} justDown
	* @memberof Phaser.Key
	* @default false
	*/Object.defineProperty(Phaser.Key.prototype,"justDown",{get:function get(){var current=this._justDown;this._justDown=false;return current;}});/**
	* The justUp value allows you to test if this Key has just been released or not.
	* When you check this value it will return `true` if the Key is up, otherwise `false`.
	* You can only call justUp once per key release. It will only return `true` once, until the Key is pressed down and released again.
	* This allows you to use it in situations where you want to check if this key is up without using a Signal, such as in a core game loop.
	* 
	* @property {boolean} justUp
	* @memberof Phaser.Key
	* @default false
	*/Object.defineProperty(Phaser.Key.prototype,"justUp",{get:function get(){var current=this._justUp;this._justUp=false;return current;}});/**
	* An enabled key processes its update and dispatches events.
	* A key can be disabled momentarily at runtime instead of deleting it.
	* 
	* @property {boolean} enabled
	* @memberof Phaser.Key
	* @default true
	*/Object.defineProperty(Phaser.Key.prototype,"enabled",{get:function get(){return this._enabled;},set:function set(value){value=!!value;if(value!==this._enabled){if(!value){this.reset(false);}this._enabled=value;}}});Phaser.Key.prototype.constructor=Phaser.Key;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Keyboard class monitors keyboard input and dispatches keyboard events.
	*
	* _Note_: many keyboards are unable to process certain combinations of keys due to hardware limitations known as ghosting.
	* See http://www.html5gamedevs.com/topic/4876-impossible-to-use-more-than-2-keyboard-input-buttons-at-the-same-time/ for more details.
	*
	* Also please be aware that certain browser extensions can disable or override Phaser keyboard handling.
	* For example the Chrome extension vimium is known to disable Phaser from using the D key. And there are others.
	* So please check your extensions before opening Phaser issues.
	*
	* @class Phaser.Keyboard
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	*/Phaser.Keyboard=function(game){/**
	    * @property {Phaser.Game} game - Local reference to game.
	    */this.game=game;/**
	    * Keyboard input will only be processed if enabled.
	    * @property {boolean} enabled
	    * @default
	    */this.enabled=true;/**
	    * @property {object} event - The most recent DOM event from keydown or keyup. This is updated every time a new key is pressed or released.
	    */this.event=null;/**
	    * @property {object} pressEvent - The most recent DOM event from keypress.
	    */this.pressEvent=null;/**
	    * @property {object} callbackContext - The context under which the callbacks are run.
	    */this.callbackContext=this;/**
	    * @property {function} onDownCallback - This callback is invoked every time a key is pressed down, including key repeats when a key is held down.
	    */this.onDownCallback=null;/**
	    * @property {function} onPressCallback - This callback is invoked every time a DOM onkeypress event is raised, which is only for printable keys.
	    */this.onPressCallback=null;/**
	    * @property {function} onUpCallback - This callback is invoked every time a key is released.
	    */this.onUpCallback=null;/**
	    * @property {array<Phaser.Key>} _keys - The array the Phaser.Key objects are stored in.
	    * @private
	    */this._keys=[];/**
	    * @property {array} _capture - The array the key capture values are stored in.
	    * @private
	    */this._capture=[];/**
	    * @property {function} _onKeyDown
	    * @private
	    * @default
	    */this._onKeyDown=null;/**
	    * @property {function} _onKeyPress
	    * @private
	    * @default
	    */this._onKeyPress=null;/**
	    * @property {function} _onKeyUp
	    * @private
	    * @default
	    */this._onKeyUp=null;/**
	    * @property {number} _i - Internal cache var
	    * @private
	    */this._i=0;/**
	    * @property {number} _k - Internal cache var
	    * @private
	    */this._k=0;};Phaser.Keyboard.prototype={/**
	    * Add callbacks to the Keyboard handler so that each time a key is pressed down or released the callbacks are activated.
	    *
	    * @method Phaser.Keyboard#addCallbacks
	    * @param {object} context - The context under which the callbacks are run.
	    * @param {function} [onDown=null] - This callback is invoked every time a key is pressed down.
	    * @param {function} [onUp=null] - This callback is invoked every time a key is released.
	    * @param {function} [onPress=null] - This callback is invoked every time the onkeypress event is raised.
	    */addCallbacks:function addCallbacks(context,onDown,onUp,onPress){this.callbackContext=context;if(onDown!==undefined&&onDown!==null){this.onDownCallback=onDown;}if(onUp!==undefined&&onUp!==null){this.onUpCallback=onUp;}if(onPress!==undefined&&onPress!==null){this.onPressCallback=onPress;}},/**
	    * If you need more fine-grained control over a Key you can create a new Phaser.Key object via this method.
	    * The Key object can then be polled, have events attached to it, etc.
	    *
	    * @method Phaser.Keyboard#addKey
	    * @param {integer} keycode - The {@link Phaser.KeyCode keycode} of the key.
	    * @return {Phaser.Key} The Key object which you can store locally and reference directly.
	    */addKey:function addKey(keycode){if(!this._keys[keycode]){this._keys[keycode]=new Phaser.Key(this.game,keycode);this.addKeyCapture(keycode);}return this._keys[keycode];},/**
	    * A practical way to create an object containing user selected hotkeys.
	    *
	    * For example,
	    *
	    *     addKeys( { 'up': Phaser.KeyCode.W, 'down': Phaser.KeyCode.S, 'left': Phaser.KeyCode.A, 'right': Phaser.KeyCode.D } );
	    *
	    * would return an object containing properties (`up`, `down`, `left` and `right`) referring to {@link Phaser.Key} object.
	    *
	    * @method Phaser.Keyboard#addKeys
	    * @param {object} keys - A key mapping object, i.e. `{ 'up': Phaser.KeyCode.W, 'down': Phaser.KeyCode.S }` or `{ 'up': 52, 'down': 53 }`.
	    * @return {object} An object containing the properties mapped to {@link Phaser.Key} values.
	    */addKeys:function addKeys(keys){var output={};for(var key in keys){output[key]=this.addKey(keys[key]);}return output;},/**
	    * Removes a Key object from the Keyboard manager.
	    *
	    * @method Phaser.Keyboard#removeKey
	    * @param {integer} keycode - The {@link Phaser.KeyCode keycode} of the key to remove.
	    */removeKey:function removeKey(keycode){if(this._keys[keycode]){this._keys[keycode]=null;this.removeKeyCapture(keycode);}},/**
	    * Creates and returns an object containing 4 hotkeys for Up, Down, Left and Right.
	    *
	    * @method Phaser.Keyboard#createCursorKeys
	    * @return {object} An object containing properties: `up`, `down`, `left` and `right` of {@link Phaser.Key} objects.
	    */createCursorKeys:function createCursorKeys(){return this.addKeys({'up':Phaser.KeyCode.UP,'down':Phaser.KeyCode.DOWN,'left':Phaser.KeyCode.LEFT,'right':Phaser.KeyCode.RIGHT});},/**
	    * Starts the Keyboard event listeners running (keydown and keyup). They are attached to the window.
	    * This is called automatically by Phaser.Input and should not normally be invoked directly.
	    *
	    * @method Phaser.Keyboard#start
	    * @protected
	    */start:function start(){if(this.game.device.cocoonJS){return;}if(this._onKeyDown!==null){//  Avoid setting multiple listeners
	return;}var _this=this;this._onKeyDown=function(event){return _this.processKeyDown(event);};this._onKeyUp=function(event){return _this.processKeyUp(event);};this._onKeyPress=function(event){return _this.processKeyPress(event);};window.addEventListener('keydown',this._onKeyDown,false);window.addEventListener('keyup',this._onKeyUp,false);window.addEventListener('keypress',this._onKeyPress,false);},/**
	    * Stops the Keyboard event listeners from running (keydown, keyup and keypress). They are removed from the window.
	    *
	    * @method Phaser.Keyboard#stop
	    */stop:function stop(){window.removeEventListener('keydown',this._onKeyDown);window.removeEventListener('keyup',this._onKeyUp);window.removeEventListener('keypress',this._onKeyPress);this._onKeyDown=null;this._onKeyUp=null;this._onKeyPress=null;},/**
	    * Stops the Keyboard event listeners from running (keydown and keyup). They are removed from the window.
	    * Also clears all key captures and currently created Key objects.
	    *
	    * @method Phaser.Keyboard#destroy
	    */destroy:function destroy(){this.stop();this.clearCaptures();this._keys.length=0;this._i=0;},/**
	    * By default when a key is pressed Phaser will not stop the event from propagating up to the browser.
	    * There are some keys this can be annoying for, like the arrow keys or space bar, which make the browser window scroll.
	    *
	    * The `addKeyCapture` method enables consuming keyboard event for specific keys so it doesn't bubble up to the the browser
	    * and cause the default browser behavior.
	    *
	    * Pass in either a single keycode or an array/hash of keycodes.
	    *
	    * @method Phaser.Keyboard#addKeyCapture
	    * @param {integer|integer[]|object} keycode - Either a single {@link Phaser.KeyCode keycode} or an array/hash of keycodes such as `[65, 67, 68]`.
	    */addKeyCapture:function addKeyCapture(keycode){if((typeof keycode==='undefined'?'undefined':_typeof(keycode))==='object'){for(var key in keycode){this._capture[keycode[key]]=true;}}else{this._capture[keycode]=true;}},/**
	    * Removes an existing key capture.
	    *
	    * @method Phaser.Keyboard#removeKeyCapture
	    * @param {integer} keycode - The {@link Phaser.KeyCode keycode} to remove capturing of.
	    */removeKeyCapture:function removeKeyCapture(keycode){delete this._capture[keycode];},/**
	    * Clear all set key captures.
	    *
	    * @method Phaser.Keyboard#clearCaptures
	    */clearCaptures:function clearCaptures(){this._capture={};},/**
	    * Updates all currently defined keys.
	    *
	    * @method Phaser.Keyboard#update
	    */update:function update(){this._i=this._keys.length;while(this._i--){if(this._keys[this._i]){this._keys[this._i].update();}}},/**
	    * Process the keydown event.
	    *
	    * @method Phaser.Keyboard#processKeyDown
	    * @param {KeyboardEvent} event
	    * @protected
	    */processKeyDown:function processKeyDown(event){this.event=event;if(!this.game.input.enabled||!this.enabled){return;}var key=event.keyCode;//   The event is being captured but another hotkey may need it
	if(this._capture[key]){event.preventDefault();}if(!this._keys[key]){this._keys[key]=new Phaser.Key(this.game,key);}this._keys[key].processKeyDown(event);this._k=key;if(this.onDownCallback){this.onDownCallback.call(this.callbackContext,event);}},/**
	    * Process the keypress event.
	    *
	    * @method Phaser.Keyboard#processKeyPress
	    * @param {KeyboardEvent} event
	    * @protected
	    */processKeyPress:function processKeyPress(event){this.pressEvent=event;if(!this.game.input.enabled||!this.enabled){return;}if(this.onPressCallback){this.onPressCallback.call(this.callbackContext,String.fromCharCode(event.charCode),event);}},/**
	    * Process the keyup event.
	    *
	    * @method Phaser.Keyboard#processKeyUp
	    * @param {KeyboardEvent} event
	    * @protected
	    */processKeyUp:function processKeyUp(event){this.event=event;if(!this.game.input.enabled||!this.enabled){return;}var key=event.keyCode;if(this._capture[key]){event.preventDefault();}if(!this._keys[key]){this._keys[key]=new Phaser.Key(this.game,key);}this._keys[key].processKeyUp(event);if(this.onUpCallback){this.onUpCallback.call(this.callbackContext,event);}},/**
	    * Resets all Keys.
	    *
	    * @method Phaser.Keyboard#reset
	    * @param {boolean} [hard=true] - A soft reset won't reset any events or callbacks that are bound to the Keys. A hard reset will.
	    */reset:function reset(hard){if(hard===undefined){hard=true;}this.event=null;var i=this._keys.length;while(i--){if(this._keys[i]){this._keys[i].reset(hard);}}},/**
	    * Returns `true` if the Key was pressed down within the `duration` value given, or `false` if it either isn't down,
	    * or was pressed down longer ago than then given duration.
	    * 
	    * @method Phaser.Keyboard#downDuration
	    * @param {integer} keycode - The {@link Phaser.KeyCode keycode} of the key to check: i.e. Phaser.KeyCode.UP or Phaser.KeyCode.SPACEBAR.
	    * @param {number} [duration=50] - The duration within which the key is considered as being just pressed. Given in ms.
	    * @return {boolean} True if the key was pressed down within the given duration, false if not or null if the Key wasn't found.
	    */downDuration:function downDuration(keycode,duration){if(this._keys[keycode]){return this._keys[keycode].downDuration(duration);}else{return null;}},/**
	    * Returns `true` if the Key was pressed down within the `duration` value given, or `false` if it either isn't down,
	    * or was pressed down longer ago than then given duration.
	    * 
	    * @method Phaser.Keyboard#upDuration
	    * @param {Phaser.KeyCode|integer} keycode - The keycode of the key to check, i.e. Phaser.KeyCode.UP or Phaser.KeyCode.SPACEBAR.
	    * @param {number} [duration=50] - The duration within which the key is considered as being just released. Given in ms.
	    * @return {boolean} True if the key was released within the given duration, false if not or null if the Key wasn't found.
	    */upDuration:function upDuration(keycode,duration){if(this._keys[keycode]){return this._keys[keycode].upDuration(duration);}else{return null;}},/**
	    * Returns true of the key is currently pressed down. Note that it can only detect key presses on the web browser.
	    *
	    * @method Phaser.Keyboard#isDown
	    * @param {integer} keycode - The {@link Phaser.KeyCode keycode} of the key to check: i.e. Phaser.KeyCode.UP or Phaser.KeyCode.SPACEBAR.
	    * @return {boolean} True if the key is currently down, false if not or null if the Key wasn't found.
	    */isDown:function isDown(keycode){if(this._keys[keycode]){return this._keys[keycode].isDown;}else{return null;}}};/**
	* Returns the string value of the most recently pressed key.
	* @name Phaser.Keyboard#lastChar
	* @property {string} lastChar - The string value of the most recently pressed key.
	* @readonly
	*/Object.defineProperty(Phaser.Keyboard.prototype,"lastChar",{get:function get(){if(this.event.charCode===32){return'';}else{return String.fromCharCode(this.pressEvent.charCode);}}});/**
	* Returns the most recently pressed Key. This is a Phaser.Key object and it changes every time a key is pressed.
	* @name Phaser.Keyboard#lastKey
	* @property {Phaser.Key} lastKey - The most recently pressed Key.
	* @readonly
	*/Object.defineProperty(Phaser.Keyboard.prototype,"lastKey",{get:function get(){return this._keys[this._k];}});Phaser.Keyboard.prototype.constructor=Phaser.Keyboard;/**
	* A key code represents a physical key on a keyboard.
	*
	* The KeyCode class contains commonly supported keyboard key codes which can be used
	* as keycode`-parameters in several {@link Phaser.Keyboard} and {@link Phaser.Key} methods.
	*
	* _Note_: These values should only be used indirectly, eg. as `Phaser.KeyCode.KEY`.
	* Future versions may replace the actual values, such that they remain compatible with `keycode`-parameters.
	* The current implementation maps to the {@link https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode KeyboardEvent.keyCode} property.
	*
	* _Note_: Use `Phaser.KeyCode.KEY` instead of `Phaser.Keyboard.KEY` to refer to a key code;
	* the latter approach is supported for compatibility.
	*
	* @class Phaser.KeyCode
	*/Phaser.KeyCode={/** @static */A:"A".charCodeAt(0),/** @static */B:"B".charCodeAt(0),/** @static */C:"C".charCodeAt(0),/** @static */D:"D".charCodeAt(0),/** @static */E:"E".charCodeAt(0),/** @static */F:"F".charCodeAt(0),/** @static */G:"G".charCodeAt(0),/** @static */H:"H".charCodeAt(0),/** @static */I:"I".charCodeAt(0),/** @static */J:"J".charCodeAt(0),/** @static */K:"K".charCodeAt(0),/** @static */L:"L".charCodeAt(0),/** @static */M:"M".charCodeAt(0),/** @static */N:"N".charCodeAt(0),/** @static */O:"O".charCodeAt(0),/** @static */P:"P".charCodeAt(0),/** @static */Q:"Q".charCodeAt(0),/** @static */R:"R".charCodeAt(0),/** @static */S:"S".charCodeAt(0),/** @static */T:"T".charCodeAt(0),/** @static */U:"U".charCodeAt(0),/** @static */V:"V".charCodeAt(0),/** @static */W:"W".charCodeAt(0),/** @static */X:"X".charCodeAt(0),/** @static */Y:"Y".charCodeAt(0),/** @static */Z:"Z".charCodeAt(0),/** @static */ZERO:"0".charCodeAt(0),/** @static */ONE:"1".charCodeAt(0),/** @static */TWO:"2".charCodeAt(0),/** @static */THREE:"3".charCodeAt(0),/** @static */FOUR:"4".charCodeAt(0),/** @static */FIVE:"5".charCodeAt(0),/** @static */SIX:"6".charCodeAt(0),/** @static */SEVEN:"7".charCodeAt(0),/** @static */EIGHT:"8".charCodeAt(0),/** @static */NINE:"9".charCodeAt(0),/** @static */NUMPAD_0:96,/** @static */NUMPAD_1:97,/** @static */NUMPAD_2:98,/** @static */NUMPAD_3:99,/** @static */NUMPAD_4:100,/** @static */NUMPAD_5:101,/** @static */NUMPAD_6:102,/** @static */NUMPAD_7:103,/** @static */NUMPAD_8:104,/** @static */NUMPAD_9:105,/** @static */NUMPAD_MULTIPLY:106,/** @static */NUMPAD_ADD:107,/** @static */NUMPAD_ENTER:108,/** @static */NUMPAD_SUBTRACT:109,/** @static */NUMPAD_DECIMAL:110,/** @static */NUMPAD_DIVIDE:111,/** @static */F1:112,/** @static */F2:113,/** @static */F3:114,/** @static */F4:115,/** @static */F5:116,/** @static */F6:117,/** @static */F7:118,/** @static */F8:119,/** @static */F9:120,/** @static */F10:121,/** @static */F11:122,/** @static */F12:123,/** @static */F13:124,/** @static */F14:125,/** @static */F15:126,/** @static */COLON:186,/** @static */EQUALS:187,/** @static */COMMA:188,/** @static */UNDERSCORE:189,/** @static */PERIOD:190,/** @static */QUESTION_MARK:191,/** @static */TILDE:192,/** @static */OPEN_BRACKET:219,/** @static */BACKWARD_SLASH:220,/** @static */CLOSED_BRACKET:221,/** @static */QUOTES:222,/** @static */BACKSPACE:8,/** @static */TAB:9,/** @static */CLEAR:12,/** @static */ENTER:13,/** @static */SHIFT:16,/** @static */CONTROL:17,/** @static */ALT:18,/** @static */CAPS_LOCK:20,/** @static */ESC:27,/** @static */SPACEBAR:32,/** @static */PAGE_UP:33,/** @static */PAGE_DOWN:34,/** @static */END:35,/** @static */HOME:36,/** @static */LEFT:37,/** @static */UP:38,/** @static */RIGHT:39,/** @static */DOWN:40,/** @static */PLUS:43,/** @static */MINUS:44,/** @static */INSERT:45,/** @static */DELETE:46,/** @static */HELP:47,/** @static */NUM_LOCK:144};// Duplicate Phaser.KeyCode values in Phaser.Keyboard for compatibility
	for(var key in Phaser.KeyCode){if(Phaser.KeyCode.hasOwnProperty(key)&&!key.match(/[a-z]/)){Phaser.Keyboard[key]=Phaser.KeyCode[key];}}/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*/Phaser.Component=function(){};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Angle Component provides access to an `angle` property; the rotation of a Game Object in degrees.
	*
	* @class
	*/Phaser.Component.Angle=function(){};Phaser.Component.Angle.prototype={/**
	    * The angle property is the rotation of the Game Object in *degrees* from its original orientation.
	    * 
	    * Values from 0 to 180 represent clockwise rotation; values from 0 to -180 represent counterclockwise rotation.
	    * 
	    * Values outside this range are added to or subtracted from 360 to obtain a value within the range. 
	    * For example, the statement player.angle = 450 is the same as player.angle = 90.
	    * 
	    * If you wish to work in radians instead of degrees you can use the property `rotation` instead. 
	    * Working in radians is slightly faster as it doesn't have to perform any calculations.
	    *
	    * @property {number} angle
	    */angle:{get:function get(){return Phaser.Math.wrapAngle(Phaser.Math.radToDeg(this.rotation));},set:function set(value){this.rotation=Phaser.Math.degToRad(Phaser.Math.wrapAngle(value));}}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Animation Component provides a `play` method, which is a proxy to the `AnimationManager.play` method.
	*
	* @class
	*/Phaser.Component.Animation=function(){};Phaser.Component.Animation.prototype={/**
	    * Plays an Animation.
	    * 
	    * The animation should have previously been created via `animations.add`.
	    * 
	    * If the animation is already playing calling this again won't do anything.
	    * If you need to reset an already running animation do so directly on the Animation object itself or via `AnimationManager.stop`.
	    *
	    * @method
	    * @param {string} name - The name of the animation to be played, e.g. "fire", "walk", "jump". Must have been previously created via 'AnimationManager.add'.
	    * @param {number} [frameRate=null] - The framerate to play the animation at. The speed is given in frames per second. If not provided the previously set frameRate of the Animation is used.
	    * @param {boolean} [loop=false] - Should the animation be looped after playback. If not provided the previously set loop value of the Animation is used.
	    * @param {boolean} [killOnComplete=false] - If set to true when the animation completes (only happens if loop=false) the parent Sprite will be killed.
	    * @return {Phaser.Animation} A reference to playing Animation.
	    */play:function play(name,frameRate,loop,killOnComplete){if(this.animations){return this.animations.play(name,frameRate,loop,killOnComplete);}}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The AutoCull Component is responsible for providing methods that check if a Game Object is within the bounds of the World Camera.
	* It is used by the InWorld component.
	*
	* @class
	*/Phaser.Component.AutoCull=function(){};Phaser.Component.AutoCull.prototype={/**
	    * A Game Object with `autoCull` set to true will check its bounds against the World Camera every frame.
	    * If it is not intersecting the Camera bounds at any point then it has its `renderable` property set to `false`.
	    * This keeps the Game Object alive and still processing updates, but forces it to skip the render step entirely.
	    * 
	    * This is a relatively expensive operation, especially if enabled on hundreds of Game Objects. So enable it only if you know it's required,
	    * or you have tested performance and find it acceptable.
	    *
	    * @property {boolean} autoCull
	    * @default
	    */autoCull:false,/**
	    * Checks if the Game Objects bounds intersect with the Game Camera bounds.
	    * Returns `true` if they do, otherwise `false` if fully outside of the Cameras bounds.
	    *
	    * @property {boolean} inCamera
	    * @readonly
	    */inCamera:{get:function get(){if(!this.autoCull&&!this.checkWorldBounds){this._bounds.copyFrom(this.getBounds());this._bounds.x+=this.game.camera.view.x;this._bounds.y+=this.game.camera.view.y;}return this.game.world.camera.view.intersects(this._bounds);}}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Bounds component contains properties related to the bounds of the Game Object.
	*
	* @class
	*/Phaser.Component.Bounds=function(){};Phaser.Component.Bounds.prototype={/**
	    * The amount the Game Object is visually offset from its x coordinate.
	    * This is the same as `width * anchor.x`.
	    * It will only be > 0 if anchor.x is not equal to zero.
	    *
	    * @property {number} offsetX
	    * @readOnly
	    */offsetX:{get:function get(){return this.anchor.x*this.width;}},/**
	    * The amount the Game Object is visually offset from its y coordinate.
	    * This is the same as `height * anchor.y`.
	    * It will only be > 0 if anchor.y is not equal to zero.
	    *
	    * @property {number} offsetY
	    * @readOnly
	    */offsetY:{get:function get(){return this.anchor.y*this.height;}},/**
	    * The center x coordinate of the Game Object.
	    * This is the same as `(x - offsetX) + (width / 2)`.
	    *
	    * @property {number} centerX
	    */centerX:{get:function get(){return this.x-this.offsetX+this.width*0.5;},set:function set(value){this.x=value+this.offsetX-this.width*0.5;}},/**
	    * The center y coordinate of the Game Object.
	    * This is the same as `(y - offsetY) + (height / 2)`.
	    *
	    * @property {number} centerY
	    */centerY:{get:function get(){return this.y-this.offsetY+this.height*0.5;},set:function set(value){this.y=value+this.offsetY-this.height*0.5;}},/**
	    * The left coordinate of the Game Object.
	    * This is the same as `x - offsetX`.
	    *
	    * @property {number} left
	    */left:{get:function get(){return this.x-this.offsetX;},set:function set(value){this.x=value+this.offsetX;}},/**
	    * The right coordinate of the Game Object.
	    * This is the same as `x + width - offsetX`.
	    *
	    * @property {number} right
	    */right:{get:function get(){return this.x+this.width-this.offsetX;},set:function set(value){this.x=value-this.width+this.offsetX;}},/**
	    * The y coordinate of the Game Object.
	    * This is the same as `y - offsetY`.
	    *
	    * @property {number} top
	    */top:{get:function get(){return this.y-this.offsetY;},set:function set(value){this.y=value+this.offsetY;}},/**
	    * The sum of the y and height properties.
	    * This is the same as `y + height - offsetY`.
	    *
	    * @property {number} bottom
	    */bottom:{get:function get(){return this.y+this.height-this.offsetY;},set:function set(value){this.y=value-this.height+this.offsetY;}},/**
	    * Aligns this Game Object within another Game Object, or Rectangle, known as the
	    * 'container', to one of 9 possible positions.
	    *
	    * The container must be a Game Object, or Phaser.Rectangle object. This can include properties
	    * such as `World.bounds` or `Camera.view`, for aligning Game Objects within the world 
	    * and camera bounds. Or it can include other Sprites, Images, Text objects, BitmapText,
	    * TileSprites or Buttons.
	    *
	    * Please note that aligning a Sprite to another Game Object does **not** make it a child of
	    * the container. It simply modifies its position coordinates so it aligns with it.
	    * 
	    * The position constants you can use are:
	    * 
	    * `Phaser.TOP_LEFT`, `Phaser.TOP_CENTER`, `Phaser.TOP_RIGHT`, `Phaser.LEFT_CENTER`, 
	    * `Phaser.CENTER`, `Phaser.RIGHT_CENTER`, `Phaser.BOTTOM_LEFT`, 
	    * `Phaser.BOTTOM_CENTER` and `Phaser.BOTTOM_RIGHT`.
	    *
	    * The Game Objects are placed in such a way that their _bounds_ align with the
	    * container, taking into consideration rotation, scale and the anchor property.
	    * This allows you to neatly align Game Objects, irrespective of their position value.
	    *
	    * The optional `offsetX` and `offsetY` arguments allow you to apply extra spacing to the final
	    * aligned position of the Game Object. For example:
	    *
	    * `sprite.alignIn(background, Phaser.BOTTOM_RIGHT, -20, -20)`
	    *
	    * Would align the `sprite` to the bottom-right, but moved 20 pixels in from the corner.
	    * Think of the offsets as applying an adjustment to the containers bounds before the alignment takes place.
	    * So providing a negative offset will 'shrink' the container bounds by that amount, and providing a positive
	    * one expands it.
	    *
	    * @method
	    * @param {Phaser.Rectangle|Phaser.Sprite|Phaser.Image|Phaser.Text|Phaser.BitmapText|Phaser.Button|Phaser.Graphics|Phaser.TileSprite} container - The Game Object or Rectangle with which to align this Game Object to. Can also include properties such as `World.bounds` or `Camera.view`.
	    * @param {integer} [position] - The position constant. One of `Phaser.TOP_LEFT` (default), `Phaser.TOP_CENTER`, `Phaser.TOP_RIGHT`, `Phaser.LEFT_CENTER`, `Phaser.CENTER`, `Phaser.RIGHT_CENTER`, `Phaser.BOTTOM_LEFT`, `Phaser.BOTTOM_CENTER` or `Phaser.BOTTOM_RIGHT`.
	    * @param {integer} [offsetX=0] - A horizontal adjustment of the Containers bounds, applied to the aligned position of the Game Object. Use a negative value to shrink the bounds, positive to increase it.
	    * @param {integer} [offsetY=0] - A vertical adjustment of the Containers bounds, applied to the aligned position of the Game Object. Use a negative value to shrink the bounds, positive to increase it.
	    * @return {Object} This Game Object.
	    */alignIn:function alignIn(container,position,offsetX,offsetY){if(offsetX===undefined){offsetX=0;}if(offsetY===undefined){offsetY=0;}switch(position){default:case Phaser.TOP_LEFT:this.left=container.left-offsetX;this.top=container.top-offsetY;break;case Phaser.TOP_CENTER:this.centerX=container.centerX+offsetX;this.top=container.top-offsetY;break;case Phaser.TOP_RIGHT:this.right=container.right+offsetX;this.top=container.top-offsetY;break;case Phaser.LEFT_CENTER:this.left=container.left-offsetX;this.centerY=container.centerY+offsetY;break;case Phaser.CENTER:this.centerX=container.centerX+offsetX;this.centerY=container.centerY+offsetY;break;case Phaser.RIGHT_CENTER:this.right=container.right+offsetX;this.centerY=container.centerY+offsetY;break;case Phaser.BOTTOM_LEFT:this.left=container.left-offsetX;this.bottom=container.bottom+offsetY;break;case Phaser.BOTTOM_CENTER:this.centerX=container.centerX+offsetX;this.bottom=container.bottom+offsetY;break;case Phaser.BOTTOM_RIGHT:this.right=container.right+offsetX;this.bottom=container.bottom+offsetY;break;}return this;},/**
	    * Aligns this Game Object to the side of another Game Object, or Rectangle, known as the
	    * 'parent', in one of 11 possible positions.
	    *
	    * The parent must be a Game Object, or Phaser.Rectangle object. This can include properties
	    * such as `World.bounds` or `Camera.view`, for aligning Game Objects within the world 
	    * and camera bounds. Or it can include other Sprites, Images, Text objects, BitmapText,
	    * TileSprites or Buttons.
	    *
	    * Please note that aligning a Sprite to another Game Object does **not** make it a child of
	    * the parent. It simply modifies its position coordinates so it aligns with it.
	    * 
	    * The position constants you can use are:
	    * 
	    * `Phaser.TOP_LEFT` (default), `Phaser.TOP_CENTER`, `Phaser.TOP_RIGHT`, `Phaser.LEFT_TOP`, 
	    * `Phaser.LEFT_CENTER`, `Phaser.LEFT_BOTTOM`, `Phaser.RIGHT_TOP`, `Phaser.RIGHT_CENTER`, 
	    * `Phaser.RIGHT_BOTTOM`, `Phaser.BOTTOM_LEFT`, `Phaser.BOTTOM_CENTER` 
	    * and `Phaser.BOTTOM_RIGHT`.
	    *
	    * The Game Objects are placed in such a way that their _bounds_ align with the
	    * parent, taking into consideration rotation, scale and the anchor property.
	    * This allows you to neatly align Game Objects, irrespective of their position value.
	    *
	    * The optional `offsetX` and `offsetY` arguments allow you to apply extra spacing to the final
	    * aligned position of the Game Object. For example:
	    *
	    * `sprite.alignTo(background, Phaser.BOTTOM_RIGHT, -20, -20)`
	    *
	    * Would align the `sprite` to the bottom-right, but moved 20 pixels in from the corner.
	    * Think of the offsets as applying an adjustment to the parents bounds before the alignment takes place.
	    * So providing a negative offset will 'shrink' the parent bounds by that amount, and providing a positive
	    * one expands it.
	    *
	    * @method
	    * @param {Phaser.Rectangle|Phaser.Sprite|Phaser.Image|Phaser.Text|Phaser.BitmapText|Phaser.Button|Phaser.Graphics|Phaser.TileSprite} parent - The Game Object or Rectangle with which to align this Game Object to. Can also include properties such as `World.bounds` or `Camera.view`.
	    * @param {integer} [position] - The position constant. One of `Phaser.TOP_LEFT`, `Phaser.TOP_CENTER`, `Phaser.TOP_RIGHT`, `Phaser.LEFT_TOP`, `Phaser.LEFT_CENTER`, `Phaser.LEFT_BOTTOM`, `Phaser.RIGHT_TOP`, `Phaser.RIGHT_CENTER`, `Phaser.RIGHT_BOTTOM`, `Phaser.BOTTOM_LEFT`, `Phaser.BOTTOM_CENTER` or `Phaser.BOTTOM_RIGHT`.
	    * @param {integer} [offsetX=0] - A horizontal adjustment of the Containers bounds, applied to the aligned position of the Game Object. Use a negative value to shrink the bounds, positive to increase it.
	    * @param {integer} [offsetY=0] - A vertical adjustment of the Containers bounds, applied to the aligned position of the Game Object. Use a negative value to shrink the bounds, positive to increase it.
	    * @return {Object} This Game Object.
	    */alignTo:function alignTo(parent,position,offsetX,offsetY){if(offsetX===undefined){offsetX=0;}if(offsetY===undefined){offsetY=0;}switch(position){default:case Phaser.TOP_LEFT:this.left=parent.left-offsetX;this.bottom=parent.top-offsetY;break;case Phaser.TOP_CENTER:this.centerX=parent.centerX+offsetX;this.bottom=parent.top-offsetY;break;case Phaser.TOP_RIGHT:this.right=parent.right+offsetX;this.bottom=parent.top-offsetY;break;case Phaser.LEFT_TOP:this.right=parent.left-offsetX;this.top=parent.top-offsetY;break;case Phaser.LEFT_CENTER:this.right=parent.left-offsetX;this.centerY=parent.centerY+offsetY;break;case Phaser.LEFT_BOTTOM:this.right=parent.left-offsetX;this.bottom=parent.bottom+offsetY;break;case Phaser.RIGHT_TOP:this.left=parent.right+offsetX;this.top=parent.top-offsetY;break;case Phaser.RIGHT_CENTER:this.left=parent.right+offsetX;this.centerY=parent.centerY+offsetY;break;case Phaser.RIGHT_BOTTOM:this.left=parent.right+offsetX;this.bottom=parent.bottom+offsetY;break;case Phaser.BOTTOM_LEFT:this.left=parent.left-offsetX;this.top=parent.bottom+offsetY;break;case Phaser.BOTTOM_CENTER:this.centerX=parent.centerX+offsetX;this.top=parent.bottom+offsetY;break;case Phaser.BOTTOM_RIGHT:this.right=parent.right+offsetX;this.top=parent.bottom+offsetY;break;}return this;}};//  Phaser.Group extensions
	Phaser.Group.prototype.alignIn=Phaser.Component.Bounds.prototype.alignIn;Phaser.Group.prototype.alignTo=Phaser.Component.Bounds.prototype.alignTo;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The BringToTop Component features quick access to Group sorting related methods.
	*
	* @class
	*/Phaser.Component.BringToTop=function(){};/**
	* Brings this Game Object to the top of its parents display list.
	* Visually this means it will render over the top of any old child in the same Group.
	* 
	* If this Game Object hasn't been added to a custom Group then this method will bring it to the top of the Game World, 
	* because the World is the root Group from which all Game Objects descend.
	*
	* @method
	* @return {PIXI.DisplayObject} This instance.
	*/Phaser.Component.BringToTop.prototype.bringToTop=function(){if(this.parent){this.parent.bringToTop(this);}return this;};/**
	* Sends this Game Object to the bottom of its parents display list.
	* Visually this means it will render below all other children in the same Group.
	* 
	* If this Game Object hasn't been added to a custom Group then this method will send it to the bottom of the Game World, 
	* because the World is the root Group from which all Game Objects descend.
	*
	* @method
	* @return {PIXI.DisplayObject} This instance.
	*/Phaser.Component.BringToTop.prototype.sendToBack=function(){if(this.parent){this.parent.sendToBack(this);}return this;};/**
	* Moves this Game Object up one place in its parents display list.
	* This call has no effect if the Game Object is already at the top of the display list.
	* 
	* If this Game Object hasn't been added to a custom Group then this method will move it one object up within the Game World, 
	* because the World is the root Group from which all Game Objects descend.
	*
	* @method
	* @return {PIXI.DisplayObject} This instance.
	*/Phaser.Component.BringToTop.prototype.moveUp=function(){if(this.parent){this.parent.moveUp(this);}return this;};/**
	* Moves this Game Object down one place in its parents display list.
	* This call has no effect if the Game Object is already at the bottom of the display list.
	* 
	* If this Game Object hasn't been added to a custom Group then this method will move it one object down within the Game World, 
	* because the World is the root Group from which all Game Objects descend.
	*
	* @method
	* @return {PIXI.DisplayObject} This instance.
	*/Phaser.Component.BringToTop.prototype.moveDown=function(){if(this.parent){this.parent.moveDown(this);}return this;};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Core Component Features.
	*
	* @class
	*/Phaser.Component.Core=function(){};/**
	* Installs / registers mixin components.
	*
	* The `this` context should be that of the applicable object instance or prototype.
	*
	* @method
	* @protected
	*/Phaser.Component.Core.install=function(components){// Always install 'Core' first
	Phaser.Utils.mixinPrototype(this,Phaser.Component.Core.prototype);this.components={};for(var i=0;i<components.length;i++){var id=components[i];var replace=false;if(id==='Destroy'){replace=true;}Phaser.Utils.mixinPrototype(this,Phaser.Component[id].prototype,replace);this.components[id]=true;}};/**
	* Initializes the mixin components.
	*
	* The `this` context should be an instance of the component mixin target.
	*
	* @method
	* @protected
	*/Phaser.Component.Core.init=function(game,x,y,key,frame){this.game=game;this.key=key;this.data={};this.position.set(x,y);this.world=new Phaser.Point(x,y);this.previousPosition=new Phaser.Point(x,y);this.events=new Phaser.Events(this);this._bounds=new Phaser.Rectangle();if(this.components.PhysicsBody){// Enable-body checks for hasOwnProperty; makes sure to lift property from prototype.
	this.body=this.body;}if(this.components.Animation){this.animations=new Phaser.AnimationManager(this);}if(this.components.LoadTexture&&key!==null){this.loadTexture(key,frame);}if(this.components.FixedToCamera){this.cameraOffset=new Phaser.Point(x,y);}};Phaser.Component.Core.preUpdate=function(){if(this.pendingDestroy){this.destroy();return;}this.previousPosition.set(this.world.x,this.world.y);this.previousRotation=this.rotation;if(!this.exists||!this.parent.exists){this.renderOrderID=-1;return false;}this.world.setTo(this.game.camera.x+this.worldTransform.tx,this.game.camera.y+this.worldTransform.ty);if(this.visible){this.renderOrderID=this.game.stage.currentRenderOrderID++;}if(this.animations){this.animations.update();}if(this.body){this.body.preUpdate();}for(var i=0;i<this.children.length;i++){this.children[i].preUpdate();}return true;};Phaser.Component.Core.prototype={/**
	    * A reference to the currently running Game.
	    * @property {Phaser.Game} game
	    */game:null,/**
	    * A user defined name given to this Game Object.
	    * This value isn't ever used internally by Phaser, it is meant as a game level property.
	    * @property {string} name
	    * @default
	    */name:'',/**
	    * An empty Object that belongs to this Game Object.
	    * This value isn't ever used internally by Phaser, but may be used by your own code, or
	    * by Phaser Plugins, to store data that needs to be associated with the Game Object,
	    * without polluting the Game Object directly.
	    * @property {Object} data
	    * @default
	    */data:{},/**
	    * The components this Game Object has installed.
	    * @property {object} components
	    * @protected
	    */components:{},/**
	    * The z depth of this Game Object within its parent Group.
	    * No two objects in a Group can have the same z value.
	    * This value is adjusted automatically whenever the Group hierarchy changes.
	    * If you wish to re-order the layering of a Game Object then see methods like Group.moveUp or Group.bringToTop.
	    * @property {number} z
	    * @readOnly
	    */z:0,/**
	    * All Phaser Game Objects have an Events class which contains all of the events that are dispatched when certain things happen to this
	    * Game Object, or any of its components.
	    * @see Phaser.Events
	    * @property {Phaser.Events} events
	    */events:undefined,/**
	    * If the Game Object is enabled for animation (such as a Phaser.Sprite) this is a reference to its AnimationManager instance.
	    * Through it you can create, play, pause and stop animations.
	    * @see Phaser.AnimationManager
	    * @property {Phaser.AnimationManager} animations
	    */animations:undefined,/**
	    * The key of the image or texture used by this Game Object during rendering.
	    * If it is a string it's the string used to retrieve the texture from the Phaser Image Cache.
	    * It can also be an instance of a RenderTexture, BitmapData, Video or PIXI.Texture.
	    * If a Game Object is created without a key it is automatically assigned the key `__default` which is a 32x32 transparent PNG stored within the Cache.
	    * If a Game Object is given a key which doesn't exist in the Image Cache it is re-assigned the key `__missing` which is a 32x32 PNG of a green box with a line through it.
	    * @property {string|Phaser.RenderTexture|Phaser.BitmapData|Phaser.Video|PIXI.Texture} key
	    */key:'',/**
	    * The world coordinates of this Game Object in pixels.
	    * Depending on where in the display list this Game Object is placed this value can differ from `position`, 
	    * which contains the x/y coordinates relative to the Game Objects parent.
	    * @property {Phaser.Point} world
	    */world:null,/**
	    * A debug flag designed for use with `Game.enableStep`.
	    * @property {boolean} debug
	    * @default
	    */debug:false,/**
	    * The position the Game Object was located in the previous frame.
	    * @property {Phaser.Point} previousPosition
	    * @readOnly
	    */previousPosition:null,/**
	    * The rotation the Game Object was in set to in the previous frame. Value is in radians.
	    * @property {number} previousRotation
	    * @readOnly
	    */previousRotation:0,/**
	    * The render order ID is used internally by the renderer and Input Manager and should not be modified.
	    * This property is mostly used internally by the renderers, but is exposed for the use of plugins.
	    * @property {number} renderOrderID
	    * @readOnly
	    */renderOrderID:0,/**
	    * A Game Object is considered `fresh` if it has just been created or reset and is yet to receive a renderer transform update.
	    * This property is mostly used internally by the physics systems, but is exposed for the use of plugins.
	    * @property {boolean} fresh
	    * @readOnly
	    */fresh:true,/**
	    * A Game Object is that is pendingDestroy is flagged to have its destroy method called on the next logic update.
	    * You can set it directly to allow you to flag an object to be destroyed on its next update.
	    * 
	    * This is extremely useful if you wish to destroy an object from within one of its own callbacks 
	    * such as with Buttons or other Input events.
	    * 
	    * @property {boolean} pendingDestroy
	    */pendingDestroy:false,/**
	    * @property {Phaser.Rectangle} _bounds - Internal cache var.
	    * @private
	    */_bounds:null,/**
	    * @property {boolean} _exists - Internal cache var.
	    * @private
	    */_exists:true,/**
	    * Controls if this Game Object is processed by the core game loop.
	    * If this Game Object has a physics body it also controls if its physics body is updated or not.
	    * When `exists` is set to `false` it will remove its physics body from the physics world if it has one.
	    * It also toggles the `visible` property to false as well.
	    *
	    * Setting `exists` to true will add its physics body back in to the physics world, if it has one.
	    * It will also set the `visible` property to `true`.
	    *
	    * @property {boolean} exists
	    */exists:{get:function get(){return this._exists;},set:function set(value){if(value){this._exists=true;if(this.body&&this.body.type===Phaser.Physics.P2JS){this.body.addToWorld();}this.visible=true;}else{this._exists=false;if(this.body&&this.body.type===Phaser.Physics.P2JS){this.body.removeFromWorld();}this.visible=false;}}},/**
	    * Override this method in your own custom objects to handle any update requirements.
	    * It is called immediately after `preUpdate` and before `postUpdate`.
	    * Remember if this Game Object has any children you should call update on those too.
	    *
	    * @method
	    */update:function update(){},/**
	    * Internal method called by the World postUpdate cycle.
	    *
	    * @method
	    * @protected
	    */postUpdate:function postUpdate(){if(this.customRender){this.key.render();}if(this.components.PhysicsBody){Phaser.Component.PhysicsBody.postUpdate.call(this);}if(this.components.FixedToCamera){Phaser.Component.FixedToCamera.postUpdate.call(this);}for(var i=0;i<this.children.length;i++){this.children[i].postUpdate();}}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Crop component provides the ability to crop a texture based Game Object to a defined rectangle, 
	* which can be updated in real-time.
	*
	* @class
	*/Phaser.Component.Crop=function(){};Phaser.Component.Crop.prototype={/**
	    * The Rectangle used to crop the texture this Game Object uses.
	    * Set this property via `crop`. 
	    * If you modify this property directly you must call `updateCrop` in order to have the change take effect.
	    * @property {Phaser.Rectangle} cropRect
	    * @default
	    */cropRect:null,/**
	    * @property {Phaser.Rectangle} _crop - Internal cache var.
	    * @private
	    */_crop:null,/**
	    * Crop allows you to crop the texture being used to display this Game Object.
	    * Setting a crop rectangle modifies the core texture frame. The Game Object width and height properties will be adjusted accordingly.
	    *
	    * Cropping takes place from the top-left and can be modified in real-time either by providing an updated rectangle object to this method,
	    * or by modifying `cropRect` property directly and then calling `updateCrop`.
	    *
	    * The rectangle object given to this method can be either a `Phaser.Rectangle` or any other object 
	    * so long as it has public `x`, `y`, `width`, `height`, `right` and `bottom` properties.
	    * 
	    * A reference to the rectangle is stored in `cropRect` unless the `copy` parameter is `true`, 
	    * in which case the values are duplicated to a local object.
	    *
	    * @method
	    * @param {Phaser.Rectangle} rect - The Rectangle used during cropping. Pass null or no parameters to clear a previously set crop rectangle.
	    * @param {boolean} [copy=false] - If false `cropRect` will be stored as a reference to the given rect. If true it will copy the rect values into a local Phaser Rectangle object stored in cropRect.
	    */crop:function crop(rect,copy){if(copy===undefined){copy=false;}if(rect){if(copy&&this.cropRect!==null){this.cropRect.setTo(rect.x,rect.y,rect.width,rect.height);}else if(copy&&this.cropRect===null){this.cropRect=new Phaser.Rectangle(rect.x,rect.y,rect.width,rect.height);}else{this.cropRect=rect;}this.updateCrop();}else{this._crop=null;this.cropRect=null;this.resetFrame();}},/**
	    * If you have set a crop rectangle on this Game Object via `crop` and since modified the `cropRect` property,
	    * or the rectangle it references, then you need to update the crop frame by calling this method.
	    *
	    * @method
	    */updateCrop:function updateCrop(){if(!this.cropRect){return;}var oldX=this.texture.crop.x;var oldY=this.texture.crop.y;var oldW=this.texture.crop.width;var oldH=this.texture.crop.height;this._crop=Phaser.Rectangle.clone(this.cropRect,this._crop);this._crop.x+=this._frame.x;this._crop.y+=this._frame.y;var cx=Math.max(this._frame.x,this._crop.x);var cy=Math.max(this._frame.y,this._crop.y);var cw=Math.min(this._frame.right,this._crop.right)-cx;var ch=Math.min(this._frame.bottom,this._crop.bottom)-cy;this.texture.crop.x=cx;this.texture.crop.y=cy;this.texture.crop.width=cw;this.texture.crop.height=ch;this.texture.frame.width=Math.min(cw,this.cropRect.width);this.texture.frame.height=Math.min(ch,this.cropRect.height);this.texture.width=this.texture.frame.width;this.texture.height=this.texture.frame.height;this.texture._updateUvs();if(this.tint!==0xffffff&&(oldX!==cx||oldY!==cy||oldW!==cw||oldH!==ch)){this.texture.requiresReTint=true;}}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Delta component provides access to delta values between the Game Objects current and previous position.
	*
	* @class
	*/Phaser.Component.Delta=function(){};Phaser.Component.Delta.prototype={/**
	    * Returns the delta x value. The difference between world.x now and in the previous frame.
	    * 
	    * The value will be positive if the Game Object has moved to the right or negative if to the left.
	    *
	    * @property {number} deltaX
	    * @readonly
	    */deltaX:{get:function get(){return this.world.x-this.previousPosition.x;}},/**
	    * Returns the delta y value. The difference between world.y now and in the previous frame.
	    * 
	    * The value will be positive if the Game Object has moved down or negative if up.
	    *
	    * @property {number} deltaY
	    * @readonly
	    */deltaY:{get:function get(){return this.world.y-this.previousPosition.y;}},/**
	    * Returns the delta z value. The difference between rotation now and in the previous frame.
	    *
	    * @property {number} deltaZ - The delta value.
	    * @readonly
	    */deltaZ:{get:function get(){return this.rotation-this.previousRotation;}}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Destroy component is responsible for destroying a Game Object.
	*
	* @class
	*/Phaser.Component.Destroy=function(){};Phaser.Component.Destroy.prototype={/**
	    * As a Game Object runs through its destroy method this flag is set to true, 
	    * and can be checked in any sub-systems or plugins it is being destroyed from.
	    * @property {boolean} destroyPhase
	    * @readOnly
	    */destroyPhase:false,/**
	    * Destroys the Game Object. This removes it from its parent group, destroys the input, event and animation handlers if present
	    * and nulls its reference to `game`, freeing it up for garbage collection.
	    * 
	    * If this Game Object has the Events component it will also dispatch the `onDestroy` event.
	    *
	    * You can optionally also destroy the BaseTexture this Game Object is using. Be careful if you've
	    * more than one Game Object sharing the same BaseTexture.
	    *
	    * @method
	    * @param {boolean} [destroyChildren=true] - Should every child of this object have its destroy method called as well?
	    * @param {boolean} [destroyTexture=false] - Destroy the BaseTexture this Game Object is using? Note that if another Game Object is sharing the same BaseTexture it will invalidate it.
	    */destroy:function destroy(destroyChildren,destroyTexture){if(this.game===null||this.destroyPhase){return;}if(destroyChildren===undefined){destroyChildren=true;}if(destroyTexture===undefined){destroyTexture=false;}this.destroyPhase=true;if(this.events){this.events.onDestroy$dispatch(this);}if(this.parent){if(this.parent instanceof Phaser.Group){this.parent.remove(this);}else{this.parent.removeChild(this);}}if(this.input){this.input.destroy();}if(this.animations){this.animations.destroy();}if(this.body){this.body.destroy();}if(this.events){this.events.destroy();}this.game.tweens.removeFrom(this);var i=this.children.length;if(destroyChildren){while(i--){this.children[i].destroy(destroyChildren);}}else{while(i--){this.removeChild(this.children[i]);}}if(this._crop){this._crop=null;this.cropRect=null;}if(this._frame){this._frame=null;}if(Phaser.Video&&this.key instanceof Phaser.Video){this.key.onChangeSource.remove(this.resizeFrame,this);}if(Phaser.BitmapText&&this._glyphs){this._glyphs=[];}this.alive=false;this.exists=false;this.visible=false;this.filters=null;this.mask=null;this.game=null;this.data={};//  In case Pixi is still going to try and render it even though destroyed
	this.renderable=false;if(this.transformCallback){this.transformCallback=null;this.transformCallbackContext=null;}//  Pixi level DisplayObject destroy
	this.hitArea=null;this.parent=null;this.stage=null;this.worldTransform=null;this.filterArea=null;this._bounds=null;this._currentBounds=null;this._mask=null;this._destroyCachedSprite();//  Texture?
	if(destroyTexture){this.texture.destroy(true);}this.destroyPhase=false;this.pendingDestroy=false;}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Events component is a collection of events fired by the parent Game Object.
	* 
	* Phaser uses what are known as 'Signals' for all event handling. All of the events in
	* this class are signals you can subscribe to, much in the same way you'd "listen" for
	* an event.
	*
	* For example to tell when a Sprite has been added to a new group, you can bind a function
	* to the `onAddedToGroup` signal:
	*
	* `sprite.events.onAddedToGroup.add(yourFunction, this);`
	*
	* Where `yourFunction` is the function you want called when this event occurs.
	* 
	* For more details about how signals work please see the Phaser.Signal class.
	*
	* The Input-related events will only be dispatched if the Sprite has had `inputEnabled` set to `true`
	* and the Animation-related events only apply to game objects with animations like {@link Phaser.Sprite}.
	*
	* @class Phaser.Events
	* @constructor
	* @param {Phaser.Sprite} sprite - A reference to the game object / Sprite that owns this Events object.
	*/Phaser.Events=function(sprite){/**
	    * @property {Phaser.Sprite} parent - The Sprite that owns these events.
	    */this.parent=sprite;// The signals are automatically added by the corresponding proxy properties
	};Phaser.Events.prototype={/**
	     * Removes all events.
	     *
	     * @method Phaser.Events#destroy
	     */destroy:function destroy(){this._parent=null;if(this._onDestroy){this._onDestroy.dispose();}if(this._onAddedToGroup){this._onAddedToGroup.dispose();}if(this._onRemovedFromGroup){this._onRemovedFromGroup.dispose();}if(this._onRemovedFromWorld){this._onRemovedFromWorld.dispose();}if(this._onKilled){this._onKilled.dispose();}if(this._onRevived){this._onRevived.dispose();}if(this._onEnterBounds){this._onEnterBounds.dispose();}if(this._onOutOfBounds){this._onOutOfBounds.dispose();}if(this._onInputOver){this._onInputOver.dispose();}if(this._onInputOut){this._onInputOut.dispose();}if(this._onInputDown){this._onInputDown.dispose();}if(this._onInputUp){this._onInputUp.dispose();}if(this._onDragStart){this._onDragStart.dispose();}if(this._onDragUpdate){this._onDragUpdate.dispose();}if(this._onDragStop){this._onDragStop.dispose();}if(this._onAnimationStart){this._onAnimationStart.dispose();}if(this._onAnimationComplete){this._onAnimationComplete.dispose();}if(this._onAnimationLoop){this._onAnimationLoop.dispose();}},// The following properties are sentinels that will be replaced with getters
	/**
	    * This signal is dispatched when this Game Object is added to a new Group.
	    * It is sent two arguments:
	    * {any} The Game Object that was added to the Group.
	    * {Phaser.Group} The Group it was added to.
	    * @property {Phaser.Signal} onAddedToGroup
	    */onAddedToGroup:null,/**
	    * This signal is dispatched when the Game Object is removed from a Group.
	    * It is sent two arguments:
	    * {any} The Game Object that was removed from the Group.
	    * {Phaser.Group} The Group it was removed from.
	    * @property {Phaser.Signal} onRemovedFromGroup
	    */onRemovedFromGroup:null,/**
	    * This Signal is never used internally by Phaser and is now deprecated.
	    * @deprecated
	    * @property {Phaser.Signal} onRemovedFromWorld
	    */onRemovedFromWorld:null,/**
	    * This signal is dispatched when the Game Object is destroyed.
	    * This happens when `Sprite.destroy()` is called, or `Group.destroy()` with `destroyChildren` set to true.
	    * It is sent one argument:
	    * {any} The Game Object that was destroyed.
	    * @property {Phaser.Signal} onDestroy
	    */onDestroy:null,/**
	    * This signal is dispatched when the Game Object is killed.
	    * This happens when `Sprite.kill()` is called.
	    * Please understand the difference between `kill` and `destroy` by looking at their respective methods.
	    * It is sent one argument:
	    * {any} The Game Object that was killed.
	    * @property {Phaser.Signal} onKilled
	    */onKilled:null,/**
	    * This signal is dispatched when the Game Object is revived from a previously killed state.
	    * This happens when `Sprite.revive()` is called.
	    * It is sent one argument:
	    * {any} The Game Object that was revived.
	    * @property {Phaser.Signal} onRevived
	    */onRevived:null,/**
	    * This signal is dispatched when the Game Object leaves the Phaser.World bounds.
	    * This signal is only if `Sprite.checkWorldBounds` is set to `true`.
	    * It is sent one argument:
	    * {any} The Game Object that left the World bounds.
	    * @property {Phaser.Signal} onOutOfBounds
	    */onOutOfBounds:null,/**
	    * This signal is dispatched when the Game Object returns within the Phaser.World bounds, having previously been outside of them.
	    * This signal is only if `Sprite.checkWorldBounds` is set to `true`.
	    * It is sent one argument:
	    * {any} The Game Object that entered the World bounds.
	    * @property {Phaser.Signal} onEnterBounds
	    */onEnterBounds:null,/**
	    * This signal is dispatched if the Game Object has `inputEnabled` set to `true`, 
	    * and receives an over event from a Phaser.Pointer.
	    * It is sent two arguments:
	    * {any} The Game Object that received the event.
	    * {Phaser.Pointer} The Phaser.Pointer object that caused the event.
	    * @property {Phaser.Signal} onInputOver
	    */onInputOver:null,/**
	    * This signal is dispatched if the Game Object has `inputEnabled` set to `true`, 
	    * and receives an out event from a Phaser.Pointer, which was previously over it.
	    * It is sent two arguments:
	    * {any} The Game Object that received the event.
	    * {Phaser.Pointer} The Phaser.Pointer object that caused the event.
	    * @property {Phaser.Signal} onInputOut
	    */onInputOut:null,/**
	    * This signal is dispatched if the Game Object has `inputEnabled` set to `true`, 
	    * and receives a down event from a Phaser.Pointer. This effectively means the Pointer has been
	    * pressed down (but not yet released) on the Game Object.
	    * It is sent two arguments:
	    * {any} The Game Object that received the event.
	    * {Phaser.Pointer} The Phaser.Pointer object that caused the event.
	    * @property {Phaser.Signal} onInputDown
	    */onInputDown:null,/**
	    * This signal is dispatched if the Game Object has `inputEnabled` set to `true`, 
	    * and receives an up event from a Phaser.Pointer. This effectively means the Pointer had been
	    * pressed down, and was then released on the Game Object.
	    * It is sent three arguments:
	    * {any} The Game Object that received the event.
	    * {Phaser.Pointer} The Phaser.Pointer object that caused the event.
	    * {boolean} isOver - Is the Pointer still over the Game Object?
	    * @property {Phaser.Signal} onInputUp
	    */onInputUp:null,/**
	    * This signal is dispatched if the Game Object has been `inputEnabled` and `enableDrag` has been set.
	    * It is sent when a Phaser.Pointer starts to drag the Game Object, taking into consideration the various
	    * drag limitations that may be set.
	    * It is sent four arguments:
	    * {any} The Game Object that received the event.
	    * {Phaser.Pointer} The Phaser.Pointer object that caused the event.
	    * {number} The x coordinate that the drag started from.
	    * {number} The y coordinate that the drag started from.
	    * @property {Phaser.Signal} onDragStart
	    */onDragStart:null,/**
	    * This signal is dispatched if the Game Object has been `inputEnabled` and `enableDrag` has been set.
	    * It is sent when a Phaser.Pointer is actively dragging the Game Object.
	    * Be warned: This is a high volume Signal. Be careful what you bind to it.
	    * It is sent six arguments:
	    * {any} The Game Object that received the event.
	    * {Phaser.Pointer} The Phaser.Pointer object that caused the event.
	    * {number} The new x coordinate of the Game Object.
	    * {number} The new y coordinate of the Game Object.
	    * {Phaser.Point} A Point object that contains the point the Game Object was snapped to, if `snapOnDrag` has been enabled.
	    * {boolean} The `fromStart` boolean, indicates if this is the first update immediately after the drag has started.
	    * @property {Phaser.Signal} onDragUpdate
	    */onDragUpdate:null,/**
	    * This signal is dispatched if the Game Object has been `inputEnabled` and `enableDrag` has been set.
	    * It is sent when a Phaser.Pointer stops dragging the Game Object.
	    * It is sent two arguments:
	    * {any} The Game Object that received the event.
	    * {Phaser.Pointer} The Phaser.Pointer object that caused the event.
	    * @property {Phaser.Signal} onDragStop
	    */onDragStop:null,/**
	    * This signal is dispatched if the Game Object has the AnimationManager component, 
	    * and an Animation has been played.
	    * You can also listen to `Animation.onStart` rather than via the Game Objects events.
	    * It is sent two arguments:
	    * {any} The Game Object that received the event.
	    * {Phaser.Animation} The Phaser.Animation that was started.
	    * @property {Phaser.Signal} onAnimationStart
	    */onAnimationStart:null,/**
	    * This signal is dispatched if the Game Object has the AnimationManager component, 
	    * and an Animation has been stopped (via `animation.stop()` and the `dispatchComplete` argument has been set.
	    * You can also listen to `Animation.onComplete` rather than via the Game Objects events.
	    * It is sent two arguments:
	    * {any} The Game Object that received the event.
	    * {Phaser.Animation} The Phaser.Animation that was stopped.
	    * @property {Phaser.Signal} onAnimationComplete
	    */onAnimationComplete:null,/**
	    * This signal is dispatched if the Game Object has the AnimationManager component, 
	    * and an Animation has looped playback.
	    * You can also listen to `Animation.onLoop` rather than via the Game Objects events.
	    * It is sent two arguments:
	    * {any} The Game Object that received the event.
	    * {Phaser.Animation} The Phaser.Animation that looped.
	    * @property {Phaser.Signal} onAnimationLoop
	    */onAnimationLoop:null};Phaser.Events.prototype.constructor=Phaser.Events;// Create an auto-create proxy getter and dispatch method for all events.
	// The backing property is the same as the event name, prefixed with '_'
	// and the dispatch method is the same as the event name postfixed with '$dispatch'.
	for(var prop in Phaser.Events.prototype){if(!Phaser.Events.prototype.hasOwnProperty(prop)||prop.indexOf('on')!==0||Phaser.Events.prototype[prop]!==null){continue;}(function(prop,backing){'use strict';// The accessor creates a new Signal; and so it should only be used from user-code.
	Object.defineProperty(Phaser.Events.prototype,prop,{get:function get(){return this[backing]||(this[backing]=new Phaser.Signal());}});// The dispatcher will only broadcast on an already-created signal; call this internally.
	Phaser.Events.prototype[prop+'$dispatch']=function(){return this[backing]?this[backing].dispatch.apply(this[backing],arguments):null;};})(prop,'_'+prop);}/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The FixedToCamera component enables a Game Object to be rendered relative to the game camera coordinates, regardless 
	* of where in the world the camera is. This is used for things like sticking game UI to the camera that scrolls as it moves around the world.
	*
	* @class
	*/Phaser.Component.FixedToCamera=function(){};/**
	 * The FixedToCamera component postUpdate handler.
	 * Called automatically by the Game Object.
	 *
	 * @method
	 */Phaser.Component.FixedToCamera.postUpdate=function(){if(this.fixedToCamera){this.position.x=(this.game.camera.view.x+this.cameraOffset.x)/this.game.camera.scale.x;this.position.y=(this.game.camera.view.y+this.cameraOffset.y)/this.game.camera.scale.y;}};Phaser.Component.FixedToCamera.prototype={/**
	    * @property {boolean} _fixedToCamera
	    * @private
	    */_fixedToCamera:false,/**
	    * A Game Object that is "fixed" to the camera uses its x/y coordinates as offsets from the top left of the camera during rendering.
	    * 
	    * The values are adjusted at the rendering stage, overriding the Game Objects actual world position.
	    * 
	    * The end result is that the Game Object will appear to be 'fixed' to the camera, regardless of where in the game world
	    * the camera is viewing. This is useful if for example this Game Object is a UI item that you wish to be visible at all times 
	    * regardless where in the world the camera is.
	    * 
	    * The offsets are stored in the `cameraOffset` property.
	    * 
	    * Note that the `cameraOffset` values are in addition to any parent of this Game Object on the display list.
	    *
	    * Be careful not to set `fixedToCamera` on Game Objects which are in Groups that already have `fixedToCamera` enabled on them.
	    *
	    * @property {boolean} fixedToCamera
	    */fixedToCamera:{get:function get(){return this._fixedToCamera;},set:function set(value){if(value){this._fixedToCamera=true;this.cameraOffset.set(this.x,this.y);}else{this._fixedToCamera=false;}}},/**
	    * The x/y coordinate offset applied to the top-left of the camera that this Game Object will be drawn at if `fixedToCamera` is true.
	    * 
	    * The values are relative to the top-left of the camera view and in addition to any parent of the Game Object on the display list.
	    * @property {Phaser.Point} cameraOffset
	    */cameraOffset:new Phaser.Point()};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Health component provides the ability for Game Objects to have a `health` property 
	* that can be damaged and reset through game code.
	* Requires the LifeSpan component.
	*
	* @class
	*/Phaser.Component.Health=function(){};Phaser.Component.Health.prototype={/**
	    * The Game Objects health value. This is a handy property for setting and manipulating health on a Game Object.
	    * 
	    * It can be used in combination with the `damage` method or modified directly.
	    * 
	    * @property {number} health
	    * @default
	    */health:1,/**
	    * The Game Objects maximum health value. This works in combination with the `heal` method to ensure
	    * the health value never exceeds the maximum.
	    * 
	    * @property {number} maxHealth
	    * @default
	    */maxHealth:100,/**
	    * Damages the Game Object. This removes the given amount of health from the `health` property.
	    * 
	    * If health is taken below or is equal to zero then the `kill` method is called.
	    *
	    * @member
	    * @param {number} amount - The amount to subtract from the current `health` value.
	    * @return {Phaser.Sprite} This instance.
	    */damage:function damage(amount){if(this.alive){this.health-=amount;if(this.health<=0){this.kill();}}return this;},/**
	    * Sets the health property of the Game Object to the given amount.
	    * Will never exceed the `maxHealth` value.
	    *
	    * @member
	    * @param {number} amount - The amount to set the `health` value to. The total will never exceed `maxHealth`.
	    * @return {Phaser.Sprite} This instance.
	    */setHealth:function setHealth(amount){this.health=amount;if(this.health>this.maxHealth){this.health=this.maxHealth;}return this;},/**
	    * Heal the Game Object. This adds the given amount of health to the `health` property.
	    *
	    * @member
	    * @param {number} amount - The amount to add to the current `health` value. The total will never exceed `maxHealth`.
	    * @return {Phaser.Sprite} This instance.
	    */heal:function heal(amount){if(this.alive){this.health+=amount;if(this.health>this.maxHealth){this.health=this.maxHealth;}}return this;}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The InCamera component checks if the Game Object intersects with the Game Camera.
	*
	* @class
	*/Phaser.Component.InCamera=function(){};Phaser.Component.InCamera.prototype={/**
	    * Checks if this Game Objects bounds intersects with the Game Cameras bounds.
	    * 
	    * It will be `true` if they intersect, or `false` if the Game Object is fully outside of the Cameras bounds.
	    * 
	    * An object outside the bounds can be considered for camera culling if it has the AutoCull component.
	    *
	    * @property {boolean} inCamera
	    * @readonly
	    */inCamera:{get:function get(){return this.game.world.camera.view.intersects(this._bounds);}}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The InputEnabled component allows a Game Object to have its own InputHandler and process input related events.
	*
	* @class
	*/Phaser.Component.InputEnabled=function(){};Phaser.Component.InputEnabled.prototype={/**
	    * The Input Handler for this Game Object.
	    * 
	    * By default it is disabled. If you wish this Game Object to process input events you should enable it with: `inputEnabled = true`.
	    * 
	    * After you have done this, this property will be a reference to the Phaser InputHandler.
	    * @property {Phaser.InputHandler|null} input 
	    */input:null,/**
	    * By default a Game Object won't process any input events. By setting `inputEnabled` to true a Phaser.InputHandler is created
	    * for this Game Object and it will then start to process click / touch events and more.
	    * 
	    * You can then access the Input Handler via `this.input`.
	    * 
	    * Note that Input related events are dispatched from `this.events`, i.e.: `events.onInputDown`.
	    * 
	    * If you set this property to false it will stop the Input Handler from processing any more input events.
	    * 
	    * If you want to _temporarily_ disable input for a Game Object, then it's better to set
	    * `input.enabled = false`, as it won't reset any of the Input Handlers internal properties.
	    * You can then toggle this back on as needed.
	    *
	    * @property {boolean} inputEnabled
	    */inputEnabled:{get:function get(){return this.input&&this.input.enabled;},set:function set(value){if(value){if(this.input===null){this.input=new Phaser.InputHandler(this);this.input.start();}else if(this.input&&!this.input.enabled){this.input.start();}}else{if(this.input&&this.input.enabled){this.input.stop();}}}}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The InWorld component checks if a Game Object is within the Game World Bounds.
	* An object is considered as being "in bounds" so long as its own bounds intersects at any point with the World bounds.
	* If the AutoCull component is enabled on the Game Object then it will check the Game Object against the Camera bounds as well.
	*
	* @class
	*/Phaser.Component.InWorld=function(){};/**
	 * The InWorld component preUpdate handler.
	 * Called automatically by the Game Object.
	 *
	 * @method
	 */Phaser.Component.InWorld.preUpdate=function(){//  Cache the bounds if we need it
	if(this.autoCull||this.checkWorldBounds){this._bounds.copyFrom(this.getBounds());this._bounds.x+=this.game.camera.view.x;this._bounds.y+=this.game.camera.view.y;if(this.autoCull){//  Won't get rendered but will still get its transform updated
	if(this.game.world.camera.view.intersects(this._bounds)){this.renderable=true;this.game.world.camera.totalInView++;}else{this.renderable=false;if(this.outOfCameraBoundsKill){this.kill();return false;}}}if(this.checkWorldBounds){//  The Sprite is already out of the world bounds, so let's check to see if it has come back again
	if(this._outOfBoundsFired&&this.game.world.bounds.intersects(this._bounds)){this._outOfBoundsFired=false;this.events.onEnterBounds$dispatch(this);}else if(!this._outOfBoundsFired&&!this.game.world.bounds.intersects(this._bounds)){//  The Sprite WAS in the screen, but has now left.
	this._outOfBoundsFired=true;this.events.onOutOfBounds$dispatch(this);if(this.outOfBoundsKill){this.kill();return false;}}}}return true;};Phaser.Component.InWorld.prototype={/**
	    * If this is set to `true` the Game Object checks if it is within the World bounds each frame. 
	    * 
	    * When it is no longer intersecting the world bounds it dispatches the `onOutOfBounds` event.
	    * 
	    * If it was *previously* out of bounds but is now intersecting the world bounds again it dispatches the `onEnterBounds` event.
	    * 
	    * It also optionally kills the Game Object if `outOfBoundsKill` is `true`.
	    * 
	    * When `checkWorldBounds` is enabled it forces the Game Object to calculate its full bounds every frame.
	    * 
	    * This is a relatively expensive operation, especially if enabled on hundreds of Game Objects. So enable it only if you know it's required,
	    * or you have tested performance and find it acceptable.
	    * 
	    * @property {boolean} checkWorldBounds
	    * @default
	    */checkWorldBounds:false,/**
	    * If this and the `checkWorldBounds` property are both set to `true` then the `kill` method is called as soon as `inWorld` returns false.
	    * 
	    * @property {boolean} outOfBoundsKill
	    * @default
	    */outOfBoundsKill:false,/**
	     * If this and the `autoCull` property are both set to `true`, then the `kill` method
	     * is called as soon as the Game Object leaves the camera bounds.
	     *
	     * @property {boolean} outOfCameraBoundsKill
	     * @default
	     */outOfCameraBoundsKill:false,/**
	    * @property {boolean} _outOfBoundsFired - Internal state var.
	    * @private
	    */_outOfBoundsFired:false,/**
	    * Checks if the Game Objects bounds are within, or intersect at any point with the Game World bounds.
	    *
	    * @property {boolean} inWorld
	    * @readonly
	    */inWorld:{get:function get(){return this.game.world.bounds.intersects(this.getBounds());}}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* LifeSpan Component Features.
	*
	* @class
	*/Phaser.Component.LifeSpan=function(){};/**
	 * The LifeSpan component preUpdate handler.
	 * Called automatically by the Game Object.
	 *
	 * @method
	 */Phaser.Component.LifeSpan.preUpdate=function(){if(this.lifespan>0){this.lifespan-=this.game.time.physicsElapsedMS;if(this.lifespan<=0){this.kill();return false;}}return true;};Phaser.Component.LifeSpan.prototype={/**
	    * A useful flag to control if the Game Object is alive or dead.
	    *
	    * This is set automatically by the Health components `damage` method should the object run out of health.
	    * Or you can toggle it via your game code.
	    *
	    * This property is mostly just provided to be used by your game - it doesn't effect rendering or logic updates.
	    * However you can use `Group.getFirstAlive` in conjunction with this property for fast object pooling and recycling.
	    * @property {boolean} alive
	    * @default
	    */alive:true,/**
	    * The lifespan allows you to give a Game Object a lifespan in milliseconds.
	    *
	    * Once the Game Object is 'born' you can set this to a positive value.
	    *
	    * It is automatically decremented by the millisecond equivalent of `game.time.physicsElapsed` each frame.
	    * When it reaches zero it will call the `kill` method.
	    *
	    * Very handy for particles, bullets, collectibles, or any other short-lived entity.
	    *
	    * @property {number} lifespan
	    * @default
	    */lifespan:0,/**
	    * Brings a 'dead' Game Object back to life, optionally resetting its health value in the process.
	    *
	    * A resurrected Game Object has its `alive`, `exists` and `visible` properties all set to true.
	    *
	    * It will dispatch the `onRevived` event. Listen to `events.onRevived` for the signal.
	    *
	    * @method
	    * @param {number} [health=100] - The health to give the Game Object. Only set if the GameObject has the Health component.
	    * @return {PIXI.DisplayObject} This instance.
	    */revive:function revive(health){if(health===undefined){health=100;}this.alive=true;this.exists=true;this.visible=true;if(typeof this.setHealth==='function'){this.setHealth(health);}if(this.events){this.events.onRevived$dispatch(this);}return this;},/**
	    * Kills a Game Object. A killed Game Object has its `alive`, `exists` and `visible` properties all set to false.
	    *
	    * It will dispatch the `onKilled` event. You can listen to `events.onKilled` for the signal.
	    *
	    * Note that killing a Game Object is a way for you to quickly recycle it in an object pool,
	    * it doesn't destroy the object or free it up from memory.
	    *
	    * If you don't need this Game Object any more you should call `destroy` instead.
	    *
	    * @method
	    * @return {PIXI.DisplayObject} This instance.
	    */kill:function kill(){this.alive=false;this.exists=false;this.visible=false;if(this.events){this.events.onKilled$dispatch(this);}return this;}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The LoadTexture component manages the loading of a texture into the Game Object and the changing of frames.
	*
	* @class
	*/Phaser.Component.LoadTexture=function(){};Phaser.Component.LoadTexture.prototype={/**
	    * @property {boolean} customRender - Does this texture require a custom render call? (as set by BitmapData, Video, etc)
	    * @private
	    */customRender:false,/**
	    * @property {Phaser.Rectangle} _frame - Internal cache var.
	    * @private
	    */_frame:null,/**
	    * Changes the base texture the Game Object is using. The old texture is removed and the new one is referenced or fetched from the Cache.
	    * 
	    * If your Game Object is using a frame from a texture atlas and you just wish to change to another frame, then see the `frame` or `frameName` properties instead.
	    * 
	    * You should only use `loadTexture` if you want to replace the base texture entirely.
	    * 
	    * Calling this method causes a WebGL texture update, so use sparingly or in low-intensity portions of your game, or if you know the new texture is already on the GPU.
	    *
	    * You can use the new const `Phaser.PENDING_ATLAS` as the texture key for any sprite. 
	    * Doing this then sets the key to be the `frame` argument (the frame is set to zero). 
	    * 
	    * This allows you to create sprites using `load.image` during development, and then change them 
	    * to use a Texture Atlas later in development by simply searching your code for 'PENDING_ATLAS' 
	    * and swapping it to be the key of the atlas data.
	    *
	    * Note: You cannot use a RenderTexture as a texture for a TileSprite.
	    *
	    * @method
	    * @param {string|Phaser.RenderTexture|Phaser.BitmapData|Phaser.Video|PIXI.Texture} key - This is the image or texture used by the Sprite during rendering. It can be a string which is a reference to the Cache Image entry, or an instance of a RenderTexture, BitmapData, Video or PIXI.Texture.
	    * @param {string|number} [frame] - If this Sprite is using part of a sprite sheet or texture atlas you can specify the exact frame to use by giving a string or numeric index.
	    * @param {boolean} [stopAnimation=true] - If an animation is already playing on this Sprite you can choose to stop it or let it carry on playing.
	    */loadTexture:function loadTexture(key,frame,stopAnimation){if(key===Phaser.PENDING_ATLAS){key=frame;frame=0;}else{frame=frame||0;}if((stopAnimation||stopAnimation===undefined)&&this.animations){this.animations.stop();}this.key=key;this.customRender=false;var cache=this.game.cache;var setFrame=true;var smoothed=!this.texture.baseTexture.scaleMode;if(Phaser.RenderTexture&&key instanceof Phaser.RenderTexture){this.key=key.key;this.setTexture(key);}else if(Phaser.BitmapData&&key instanceof Phaser.BitmapData){this.customRender=true;this.setTexture(key.texture);if(cache.hasFrameData(key.key,Phaser.Cache.BITMAPDATA)){setFrame=!this.animations.loadFrameData(cache.getFrameData(key.key,Phaser.Cache.BITMAPDATA),frame);}else{setFrame=!this.animations.loadFrameData(key.frameData,0);}}else if(Phaser.Video&&key instanceof Phaser.Video){this.customRender=true;//  This works from a reference, which probably isn't what we need here
	var valid=key.texture.valid;this.setTexture(key.texture);this.setFrame(key.texture.frame.clone());key.onChangeSource.add(this.resizeFrame,this);this.texture.valid=valid;}else if(Phaser.Tilemap&&key instanceof Phaser.TilemapLayer){// this.customRender = true;
	this.setTexture(PIXI.Texture.fromCanvas(key.canvas));}else if(key instanceof PIXI.Texture){this.setTexture(key);}else{var img=cache.getImage(key,true);this.key=img.key;this.setTexture(new PIXI.Texture(img.base));if(key==='__default'){this.texture.baseTexture.skipRender=true;}else{this.texture.baseTexture.skipRender=false;}setFrame=!this.animations.loadFrameData(img.frameData,frame);}if(setFrame){this._frame=Phaser.Rectangle.clone(this.texture.frame);}if(!smoothed){this.texture.baseTexture.scaleMode=1;}},/**
	    * Sets the texture frame the Game Object uses for rendering.
	    * 
	    * This is primarily an internal method used by `loadTexture`, but is exposed for the use of plugins and custom classes.
	    *
	    * @method
	    * @param {Phaser.Frame} frame - The Frame to be used by the texture.
	    */setFrame:function setFrame(frame){this._frame=frame;this.texture.frame.x=frame.x;this.texture.frame.y=frame.y;this.texture.frame.width=frame.width;this.texture.frame.height=frame.height;this.texture.crop.x=frame.x;this.texture.crop.y=frame.y;this.texture.crop.width=frame.width;this.texture.crop.height=frame.height;if(frame.trimmed){if(this.texture.trim){this.texture.trim.x=frame.spriteSourceSizeX;this.texture.trim.y=frame.spriteSourceSizeY;this.texture.trim.width=frame.sourceSizeW;this.texture.trim.height=frame.sourceSizeH;}else{this.texture.trim={x:frame.spriteSourceSizeX,y:frame.spriteSourceSizeY,width:frame.sourceSizeW,height:frame.sourceSizeH};}this.texture.width=frame.sourceSizeW;this.texture.height=frame.sourceSizeH;this.texture.frame.width=frame.sourceSizeW;this.texture.frame.height=frame.sourceSizeH;}else if(!frame.trimmed&&this.texture.trim){this.texture.trim=null;}if(this.cropRect){this.updateCrop();}this.texture.requiresReTint=true;this.texture._updateUvs();if(this.tilingTexture){this.refreshTexture=true;}},/**
	    * Resizes the Frame dimensions that the Game Object uses for rendering.
	    * 
	    * You shouldn't normally need to ever call this, but in the case of special texture types such as Video or BitmapData
	    * it can be useful to adjust the dimensions directly in this way.
	    *
	    * @method
	    * @param {object} parent - The parent texture object that caused the resize, i.e. a Phaser.Video object.
	    * @param {integer} width - The new width of the texture.
	    * @param {integer} height - The new height of the texture.
	    */resizeFrame:function resizeFrame(parent,width,height){this.texture.frame.resize(width,height);this.texture.setFrame(this.texture.frame);},/**
	    * Resets the texture frame dimensions that the Game Object uses for rendering.
	    *
	    * @method
	    */resetFrame:function resetFrame(){if(this._frame){this.setFrame(this._frame);}},/**
	    * Gets or sets the current frame index of the texture being used to render this Game Object.
	    *
	    * To change the frame set `frame` to the index of the new frame in the sprite sheet you wish this Game Object to use,
	    * for example: `player.frame = 4`.
	    * 
	    * If the frame index given doesn't exist it will revert to the first frame found in the texture.
	    * 
	    * If you are using a texture atlas then you should use the `frameName` property instead.
	    * 
	    * If you wish to fully replace the texture being used see `loadTexture`.
	    * @property {integer} frame
	    */frame:{get:function get(){return this.animations.frame;},set:function set(value){this.animations.frame=value;}},/**
	    * Gets or sets the current frame name of the texture being used to render this Game Object.
	    * 
	    * To change the frame set `frameName` to the name of the new frame in the texture atlas you wish this Game Object to use, 
	    * for example: `player.frameName = "idle"`.
	    *
	    * If the frame name given doesn't exist it will revert to the first frame found in the texture and throw a console warning.
	    * 
	    * If you are using a sprite sheet then you should use the `frame` property instead.
	    * 
	    * If you wish to fully replace the texture being used see `loadTexture`.
	    * @property {string} frameName
	    */frameName:{get:function get(){return this.animations.frameName;},set:function set(value){this.animations.frameName=value;}}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Overlap component allows a Game Object to check if it overlaps with the bounds of another Game Object.
	*
	* @class
	*/Phaser.Component.Overlap=function(){};Phaser.Component.Overlap.prototype={/**
	    * Checks to see if the bounds of this Game Object overlaps with the bounds of the given Display Object, 
	    * which can be a Sprite, Image, TileSprite or anything that extends those such as Button or provides a `getBounds` method and result.
	    * 
	    * This check ignores the `hitArea` property if set and runs a `getBounds` comparison on both objects to determine the result.
	    * 
	    * Therefore it's relatively expensive to use in large quantities, i.e. with lots of Sprites at a high frequency.
	    * It should be fine for low-volume testing where physics isn't required.
	    *
	    * @method
	    * @param {Phaser.Sprite|Phaser.Image|Phaser.TileSprite|Phaser.Button|PIXI.DisplayObject} displayObject - The display object to check against.
	    * @return {boolean} True if the bounds of this Game Object intersects at any point with the bounds of the given display object.
	    */overlap:function overlap(displayObject){return Phaser.Rectangle.intersects(this.getBounds(),displayObject.getBounds());}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The PhysicsBody component manages the Game Objects physics body and physics enabling.
	* It also overrides the x and y properties, ensuring that any manual adjustment of them is reflected in the physics body itself.
	*
	* @class
	*/Phaser.Component.PhysicsBody=function(){};/**
	 * The PhysicsBody component preUpdate handler.
	 * Called automatically by the Game Object.
	 *
	 * @method
	 */Phaser.Component.PhysicsBody.preUpdate=function(){if(this.fresh&&this.exists){this.world.setTo(this.parent.position.x+this.position.x,this.parent.position.y+this.position.y);this.worldTransform.tx=this.world.x;this.worldTransform.ty=this.world.y;this.previousPosition.set(this.world.x,this.world.y);this.previousRotation=this.rotation;if(this.body){this.body.preUpdate();}this.fresh=false;return false;}this.previousPosition.set(this.world.x,this.world.y);this.previousRotation=this.rotation;if(!this._exists||!this.parent.exists){this.renderOrderID=-1;return false;}return true;};/**
	 * The PhysicsBody component postUpdate handler.
	 * Called automatically by the Game Object.
	 *
	 * @method
	 */Phaser.Component.PhysicsBody.postUpdate=function(){if(this.exists&&this.body){this.body.postUpdate();}};Phaser.Component.PhysicsBody.prototype={/**
	    * `body` is the Game Objects physics body. Once a Game Object is enabled for physics you access all associated 
	    * properties and methods via it.
	    * 
	    * By default Game Objects won't add themselves to any physics system and their `body` property will be `null`.
	    * 
	    * To enable this Game Object for physics you need to call `game.physics.enable(object, system)` where `object` is this object
	    * and `system` is the Physics system you are using. If none is given it defaults to `Phaser.Physics.Arcade`.
	    * 
	    * You can alternatively call `game.physics.arcade.enable(object)`, or add this Game Object to a physics enabled Group.
	    *
	    * Important: Enabling a Game Object for P2 or Ninja physics will automatically set its `anchor` property to 0.5, 
	    * so the physics body is centered on the Game Object.
	    * 
	    * If you need a different result then adjust or re-create the Body shape offsets manually or reset the anchor after enabling physics.
	    *
	    * @property {Phaser.Physics.Arcade.Body|Phaser.Physics.P2.Body|Phaser.Physics.Ninja.Body|null} body
	    * @default
	    */body:null,/**
	    * The position of the Game Object on the x axis relative to the local coordinates of the parent.
	    *
	    * @property {number} x
	    */x:{get:function get(){return this.position.x;},set:function set(value){this.position.x=value;if(this.body&&!this.body.dirty){this.body._reset=true;}}},/**
	    * The position of the Game Object on the y axis relative to the local coordinates of the parent.
	    *
	    * @property {number} y
	    */y:{get:function get(){return this.position.y;},set:function set(value){this.position.y=value;if(this.body&&!this.body.dirty){this.body._reset=true;}}}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Reset component allows a Game Object to be reset and repositioned to a new location.
	*
	* @class
	*/Phaser.Component.Reset=function(){};/**
	* Resets the Game Object.
	* 
	* This moves the Game Object to the given x/y world coordinates and sets `fresh`, `exists`, 
	* `visible` and `renderable` to true.
	*
	* If this Game Object has the LifeSpan component it will also set `alive` to true and `health` to the given value.
	*
	* If this Game Object has a Physics Body it will reset the Body.
	*
	* @method
	* @param {number} x - The x coordinate (in world space) to position the Game Object at.
	* @param {number} y - The y coordinate (in world space) to position the Game Object at.
	* @param {number} [health=1] - The health to give the Game Object if it has the Health component.
	* @return {PIXI.DisplayObject} This instance.
	*/Phaser.Component.Reset.prototype.reset=function(x,y,health){if(health===undefined){health=1;}this.world.set(x,y);this.position.set(x,y);this.fresh=true;this.exists=true;this.visible=true;this.renderable=true;if(this.components.InWorld){this._outOfBoundsFired=false;}if(this.components.LifeSpan){this.alive=true;this.health=health;}if(this.components.PhysicsBody){if(this.body){this.body.reset(x,y,false,false);}}return this;};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The ScaleMinMax component allows a Game Object to limit how far it can be scaled by its parent.
	*
	* @class
	*/Phaser.Component.ScaleMinMax=function(){};Phaser.Component.ScaleMinMax.prototype={/**
	    * The callback that will apply any scale limiting to the worldTransform.
	    * @property {function} transformCallback
	    */transformCallback:null,/**
	    * The context under which `transformCallback` is called.
	    * @property {object} transformCallbackContext
	    */transformCallbackContext:this,/**
	    * The minimum scale this Game Object will scale down to.
	    * 
	    * It allows you to prevent a parent from scaling this Game Object lower than the given value.
	    * 
	    * Set it to `null` to remove the limit.
	    * @property {Phaser.Point} scaleMin
	    */scaleMin:null,/**
	    * The maximum scale this Game Object will scale up to. 
	    * 
	    * It allows you to prevent a parent from scaling this Game Object higher than the given value.
	    * 
	    * Set it to `null` to remove the limit.
	    * @property {Phaser.Point} scaleMax
	    */scaleMax:null,/**
	     * Adjust scaling limits, if set, to this Game Object.
	     *
	     * @method
	     * @private
	     * @param {PIXI.Matrix} wt - The updated worldTransform matrix.
	     */checkTransform:function checkTransform(wt){if(this.scaleMin){if(wt.a<this.scaleMin.x){wt.a=this.scaleMin.x;}if(wt.d<this.scaleMin.y){wt.d=this.scaleMin.y;}}if(this.scaleMax){if(wt.a>this.scaleMax.x){wt.a=this.scaleMax.x;}if(wt.d>this.scaleMax.y){wt.d=this.scaleMax.y;}}},/**
	     * Sets the scaleMin and scaleMax values. These values are used to limit how far this Game Object will scale based on its parent.
	     * 
	     * For example if this Game Object has a `minScale` value of 1 and its parent has a `scale` value of 0.5, the 0.5 will be ignored 
	     * and the scale value of 1 will be used, as the parents scale is lower than the minimum scale this Game Object should adhere to.
	     * 
	     * By setting these values you can carefully control how Game Objects deal with responsive scaling.
	     * 
	     * If only one parameter is given then that value will be used for both scaleMin and scaleMax:
	     * `setScaleMinMax(1)` = scaleMin.x, scaleMin.y, scaleMax.x and scaleMax.y all = 1
	     *
	     * If only two parameters are given the first is set as scaleMin.x and y and the second as scaleMax.x and y:
	     * `setScaleMinMax(0.5, 2)` = scaleMin.x and y = 0.5 and scaleMax.x and y = 2
	     *
	     * If you wish to set `scaleMin` with different values for x and y then either modify Game Object.scaleMin directly, 
	     * or pass `null` for the `maxX` and `maxY` parameters.
	     * 
	     * Call `setScaleMinMax(null)` to clear all previously set values.
	     *
	     * @method
	     * @param {number|null} minX - The minimum horizontal scale value this Game Object can scale down to.
	     * @param {number|null} minY - The minimum vertical scale value this Game Object can scale down to.
	     * @param {number|null} maxX - The maximum horizontal scale value this Game Object can scale up to.
	     * @param {number|null} maxY - The maximum vertical scale value this Game Object can scale up to.
	     */setScaleMinMax:function setScaleMinMax(minX,minY,maxX,maxY){if(minY===undefined){//  1 parameter, set all to it
	minY=maxX=maxY=minX;}else if(maxX===undefined){//  2 parameters, the first is min, the second max
	maxX=maxY=minY;minY=minX;}if(minX===null){this.scaleMin=null;}else{if(this.scaleMin){this.scaleMin.set(minX,minY);}else{this.scaleMin=new Phaser.Point(minX,minY);}}if(maxX===null){this.scaleMax=null;}else{if(this.scaleMax){this.scaleMax.set(maxX,maxY);}else{this.scaleMax=new Phaser.Point(maxX,maxY);}}if(this.scaleMin===null){this.transformCallback=null;}else{this.transformCallback=this.checkTransform;this.transformCallbackContext=this;}}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Smoothed component allows a Game Object to control anti-aliasing of an image based texture.
	*
	* @class
	*/Phaser.Component.Smoothed=function(){};Phaser.Component.Smoothed.prototype={/**
	    * Enable or disable texture smoothing for this Game Object.
	    * 
	    * It only takes effect if the Game Object is using an image based texture.
	    * 
	    * Smoothing is enabled by default.
	    *
	    * @property {boolean} smoothed
	    */smoothed:{get:function get(){return!this.texture.baseTexture.scaleMode;},set:function set(value){if(value){if(this.texture){this.texture.baseTexture.scaleMode=0;}}else{if(this.texture){this.texture.baseTexture.scaleMode=1;}}}}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The GameObjectFactory is a quick way to create many common game objects
	* using {@linkcode Phaser.Game#add `game.add`}.
	*
	* Created objects are _automatically added_ to the appropriate Manager, World, or manually specified parent Group.
	*
	* @class Phaser.GameObjectFactory
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	*/Phaser.GameObjectFactory=function(game){/**
	    * @property {Phaser.Game} game - A reference to the currently running Game.
	    * @protected
	    */this.game=game;/**
	    * @property {Phaser.World} world - A reference to the game world.
	    * @protected
	    */this.world=this.game.world;};Phaser.GameObjectFactory.prototype={/**
	    * Adds an existing display object to the game world.
	    * 
	    * @method Phaser.GameObjectFactory#existing
	    * @param {any} object - An instance of Phaser.Sprite, Phaser.Button or any other display object.
	    * @return {any} The child that was added to the World.
	    */existing:function existing(object){return this.world.add(object);},/**
	    * Weapons provide the ability to easily create a bullet pool and manager.
	    *
	    * Weapons fire Phaser.Bullet objects, which are essentially Sprites with a few extra properties.
	    * The Bullets are enabled for Arcade Physics. They do not currently work with P2 Physics.
	    *
	    * The Bullets are created inside of `Weapon.bullets`, which is a Phaser.Group instance. Anything you
	    * can usually do with a Group, such as move it around the display list, iterate it, etc can be done
	    * to the bullets Group too.
	    *
	    * Bullets can have textures and even animations. You can control the speed at which they are fired,
	    * the firing rate, the firing angle, and even set things like gravity for them.
	    *
	    * @method Phaser.GameObjectFactory#weapon
	    * @param {integer} [quantity=1] - The quantity of bullets to seed the Weapon with. If -1 it will set the pool to automatically expand.
	    * @param {string|Phaser.RenderTexture|Phaser.BitmapData|Phaser.Video|PIXI.Texture} [key] - The image used as a texture by the bullets during rendering. If a string Phaser will get for an entry in the Image Cache. Or it can be an instance of a RenderTexture, BitmapData, Video or PIXI.Texture.
	    * @param {string|number} [frame] - If a Texture Atlas or Sprite Sheet is used this allows you to specify the frame to be used by the bullets. Use either an integer for a Frame ID or a string for a frame name.
	    * @param {Phaser.Group} [group] - Optional Group to add the Weapon to. If not specified it will be added to the World group.
	    * @returns {Phaser.Weapon} A Weapon instance.
	    */weapon:function weapon(quantity,key,frame,group){var weapon=this.game.plugins.add(Phaser.Weapon);weapon.createBullets(quantity,key,frame,group);return weapon;},/**
	    * Create a new `Image` object.
	    * 
	    * An Image is a light-weight object you can use to display anything that doesn't need physics or animation.
	    * 
	    * It can still rotate, scale, crop and receive input events. 
	    * This makes it perfect for logos, backgrounds, simple buttons and other non-Sprite graphics.
	    *
	    * @method Phaser.GameObjectFactory#image
	    * @param {number} [x=0] - The x coordinate of the Image. The coordinate is relative to any parent container this Image may be in.
	    * @param {number} [y=0] - The y coordinate of the Image. The coordinate is relative to any parent container this Image may be in.
	    * @param {string|Phaser.RenderTexture|Phaser.BitmapData|Phaser.Video|PIXI.Texture} [key] - The image used as a texture by this display object during rendering. If a string Phaser will get for an entry in the Image Cache. Or it can be an instance of a RenderTexture, BitmapData, Video or PIXI.Texture.
	    * @param {string|number} [frame] - If a Texture Atlas or Sprite Sheet is used this allows you to specify the frame to be used. Use either an integer for a Frame ID or a string for a frame name.
	    * @param {Phaser.Group} [group] - Optional Group to add the object to. If not specified it will be added to the World group.
	    * @returns {Phaser.Image} The newly created Image object.
	    */image:function image(x,y,key,frame,group){if(group===undefined){group=this.world;}return group.add(new Phaser.Image(this.game,x,y,key,frame));},/**
	    * Create a new Sprite with specific position and sprite sheet key.
	    *
	    * At its most basic a Sprite consists of a set of coordinates and a texture that is used when rendered.
	    * They also contain additional properties allowing for physics motion (via Sprite.body), input handling (via Sprite.input),
	    * events (via Sprite.events), animation (via Sprite.animations), camera culling and more. Please see the Examples for use cases.
	    *
	    * @method Phaser.GameObjectFactory#sprite
	    * @param {number} [x=0] - The x coordinate of the sprite. The coordinate is relative to any parent container this sprite may be in.
	    * @param {number} [y=0] - The y coordinate of the sprite. The coordinate is relative to any parent container this sprite may be in.
	    * @param {string|Phaser.RenderTexture|Phaser.BitmapData|Phaser.Video|PIXI.Texture} [key] - The image used as a texture by this display object during rendering. If a string Phaser will get for an entry in the Image Cache. Or it can be an instance of a RenderTexture, BitmapData, Video or PIXI.Texture.
	    * @param {string|number} [frame] - If a Texture Atlas or Sprite Sheet is used this allows you to specify the frame to be used. Use either an integer for a Frame ID or a string for a frame name.
	    * @param {Phaser.Group} [group] - Optional Group to add the object to. If not specified it will be added to the World group.
	    * @returns {Phaser.Sprite} The newly created Sprite object.
	    */sprite:function sprite(x,y,key,frame,group){if(group===undefined){group=this.world;}return group.create(x,y,key,frame);},/**
	    * Create a new Creature Animation object.
	    *
	    * Creature is a custom Game Object used in conjunction with the Creature Runtime libraries by Kestrel Moon Studios.
	    * 
	    * It allows you to display animated Game Objects that were created with the [Creature Automated Animation Tool](http://www.kestrelmoon.com/creature/).
	    * 
	    * Note 1: You can only use Phaser.Creature objects in WebGL enabled games. They do not work in Canvas mode games.
	    *
	    * Note 2: You must use a build of Phaser that includes the CreatureMeshBone.js runtime and gl-matrix.js, or have them
	    * loaded before your Phaser game boots.
	    * 
	    * See the Phaser custom build process for more details.
	    *
	    * @method Phaser.GameObjectFactory#creature
	    * @param {number} [x=0] - The x coordinate of the creature. The coordinate is relative to any parent container this creature may be in.
	    * @param {number} [y=0] - The y coordinate of the creature. The coordinate is relative to any parent container this creature may be in.
	    * @param {string|PIXI.Texture} [key] - The image used as a texture by this creature object during rendering. If a string Phaser will get for an entry in the Image Cache. Or it can be an instance of a PIXI.Texture.
	    * @param {Phaser.Group} [group] - Optional Group to add the object to. If not specified it will be added to the World group.
	    * @returns {Phaser.Creature} The newly created Sprite object.
	    */creature:function creature(x,y,key,mesh,group){if(group===undefined){group=this.world;}var obj=new Phaser.Creature(this.game,x,y,key,mesh);group.add(obj);return obj;},/**
	    * Create a tween on a specific object.
	    * 
	    * The object can be any JavaScript object or Phaser object such as Sprite.
	    *
	    * @method Phaser.GameObjectFactory#tween
	    * @param {object} object - Object the tween will be run on.
	    * @return {Phaser.Tween} The newly created Phaser.Tween object.
	    */tween:function tween(object){return this.game.tweens.create(object);},/**
	    * A Group is a container for display objects that allows for fast pooling, recycling and collision checks.
	    *
	    * @method Phaser.GameObjectFactory#group
	    * @param {any} [parent] - The parent Group or DisplayObjectContainer that will hold this group, if any. If set to null the Group won't be added to the display list. If undefined it will be added to World by default.
	    * @param {string} [name='group'] - A name for this Group. Not used internally but useful for debugging.
	    * @param {boolean} [addToStage=false] - If set to true this Group will be added directly to the Game.Stage instead of Game.World.
	    * @param {boolean} [enableBody=false] - If true all Sprites created with `Group.create` or `Group.createMulitple` will have a physics body created on them. Change the body type with physicsBodyType.
	    * @param {number} [physicsBodyType=0] - If enableBody is true this is the type of physics body that is created on new Sprites. Phaser.Physics.ARCADE, Phaser.Physics.P2, Phaser.Physics.NINJA, etc.
	    * @return {Phaser.Group} The newly created Group.
	    */group:function group(parent,name,addToStage,enableBody,physicsBodyType){return new Phaser.Group(this.game,parent,name,addToStage,enableBody,physicsBodyType);},/**
	    * A Group is a container for display objects that allows for fast pooling, recycling and collision checks.
	    * 
	    * A Physics Group is the same as an ordinary Group except that is has enableBody turned on by default, so any Sprites it creates
	    * are automatically given a physics body.
	    *
	    * @method Phaser.GameObjectFactory#physicsGroup
	    * @param {number} [physicsBodyType=Phaser.Physics.ARCADE] - If enableBody is true this is the type of physics body that is created on new Sprites. Phaser.Physics.ARCADE, Phaser.Physics.P2JS, Phaser.Physics.NINJA, etc.
	    * @param {any} [parent] - The parent Group or DisplayObjectContainer that will hold this group, if any. If set to null the Group won't be added to the display list. If undefined it will be added to World by default.
	    * @param {string} [name='group'] - A name for this Group. Not used internally but useful for debugging.
	    * @param {boolean} [addToStage=false] - If set to true this Group will be added directly to the Game.Stage instead of Game.World.
	    * @return {Phaser.Group} The newly created Group.
	    */physicsGroup:function physicsGroup(physicsBodyType,parent,name,addToStage){return new Phaser.Group(this.game,parent,name,addToStage,true,physicsBodyType);},/**
	    * A SpriteBatch is a really fast version of a Phaser Group built solely for speed.
	    * Use when you need a lot of sprites or particles all sharing the same texture.
	    * The speed gains are specifically for WebGL. In Canvas mode you won't see any real difference.
	    *
	    * @method Phaser.GameObjectFactory#spriteBatch
	    * @param {Phaser.Group|null} parent - The parent Group that will hold this Sprite Batch. Set to `undefined` or `null` to add directly to game.world.
	    * @param {string} [name='group'] - A name for this Sprite Batch. Not used internally but useful for debugging.
	    * @param {boolean} [addToStage=false] - If set to true this Sprite Batch will be added directly to the Game.Stage instead of the parent.
	    * @return {Phaser.SpriteBatch} The newly created Sprite Batch.
	    */spriteBatch:function spriteBatch(parent,name,addToStage){if(parent===undefined){parent=null;}if(name===undefined){name='group';}if(addToStage===undefined){addToStage=false;}return new Phaser.SpriteBatch(this.game,parent,name,addToStage);},/**
	    * Creates a new Sound object.
	    *
	    * @method Phaser.GameObjectFactory#audio
	    * @param {string} key - The Game.cache key of the sound that this object will use.
	    * @param {number} [volume=1] - The volume at which the sound will be played.
	    * @param {boolean} [loop=false] - Whether or not the sound will loop.
	    * @param {boolean} [connect=true] - Controls if the created Sound object will connect to the master gainNode of the SoundManager when running under WebAudio.
	    * @return {Phaser.Sound} The newly created sound object.
	    */audio:function audio(key,volume,loop,connect){return this.game.sound.add(key,volume,loop,connect);},/**
	    * Creates a new Sound object.
	    *
	    * @method Phaser.GameObjectFactory#sound
	    * @param {string} key - The Game.cache key of the sound that this object will use.
	    * @param {number} [volume=1] - The volume at which the sound will be played.
	    * @param {boolean} [loop=false] - Whether or not the sound will loop.
	    * @param {boolean} [connect=true] - Controls if the created Sound object will connect to the master gainNode of the SoundManager when running under WebAudio.
	    * @return {Phaser.Sound} The newly created sound object.
	    */sound:function sound(key,volume,loop,connect){return this.game.sound.add(key,volume,loop,connect);},/**
	     * Creates a new AudioSprite object.
	     *
	     * @method Phaser.GameObjectFactory#audioSprite
	     * @param {string} key - The Game.cache key of the sound that this object will use.
	     * @return {Phaser.AudioSprite} The newly created AudioSprite object.
	     */audioSprite:function audioSprite(key){return this.game.sound.addSprite(key);},/**
	    * Creates a new TileSprite object.
	    *
	    * @method Phaser.GameObjectFactory#tileSprite
	    * @param {number} x - The x coordinate of the TileSprite. The coordinate is relative to any parent container this TileSprite may be in.
	    * @param {number} y - The y coordinate of the TileSprite. The coordinate is relative to any parent container this TileSprite may be in.
	    * @param {number} width - The width of the TileSprite.
	    * @param {number} height - The height of the TileSprite.
	    * @param {string|Phaser.BitmapData|PIXI.Texture} key - This is the image or texture used by the TileSprite during rendering. It can be a string which is a reference to the Phaser Image Cache entry, or an instance of a PIXI.Texture or BitmapData.
	    * @param {string|number} [frame] - If a Texture Atlas or Sprite Sheet is used this allows you to specify the frame to be used. Use either an integer for a Frame ID or a string for a frame name.
	    * @param {Phaser.Group} [group] - Optional Group to add the object to. If not specified it will be added to the World group.
	    * @return {Phaser.TileSprite} The newly created TileSprite object.
	    */tileSprite:function tileSprite(x,y,width,height,key,frame,group){if(group===undefined){group=this.world;}return group.add(new Phaser.TileSprite(this.game,x,y,width,height,key,frame));},/**
	    * Creates a new Rope object.
	    *
	    * Example usage: https://github.com/codevinsky/phaser-rope-demo/blob/master/dist/demo.js
	    *
	    * @method Phaser.GameObjectFactory#rope
	    * @param {number} [x=0] - The x coordinate of the Rope. The coordinate is relative to any parent container this rope may be in.
	    * @param {number} [y=0] - The y coordinate of the Rope. The coordinate is relative to any parent container this rope may be in.
	    * @param {string|Phaser.RenderTexture|Phaser.BitmapData|Phaser.Video|PIXI.Texture} [key] - The image used as a texture by this display object during rendering. If a string Phaser will get for an entry in the Image Cache. Or it can be an instance of a RenderTexture, BitmapData, Video or PIXI.Texture.
	    * @param {string|number} [frame] - If a Texture Atlas or Sprite Sheet is used this allows you to specify the frame to be used. Use either an integer for a Frame ID or a string for a frame name.
	    * @param {Array} points - An array of {Phaser.Point}.
	    * @param {Phaser.Group} [group] - Optional Group to add the object to. If not specified it will be added to the World group.
	    * @return {Phaser.Rope} The newly created Rope object.
	    */rope:function rope(x,y,key,frame,points,group){if(group===undefined){group=this.world;}return group.add(new Phaser.Rope(this.game,x,y,key,frame,points));},/**
	    * Creates a new Text object.
	    *
	    * @method Phaser.GameObjectFactory#text
	    * @param {number} [x=0] - The x coordinate of the Text. The coordinate is relative to any parent container this text may be in.
	    * @param {number} [y=0] - The y coordinate of the Text. The coordinate is relative to any parent container this text may be in.
	    * @param {string} [text=''] - The text string that will be displayed.
	    * @param {object} [style] - The style object containing style attributes like font, font size , etc.
	    * @param {Phaser.Group} [group] - Optional Group to add the object to. If not specified it will be added to the World group.
	    * @return {Phaser.Text} The newly created text object.
	    */text:function text(x,y,_text,style,group){if(group===undefined){group=this.world;}return group.add(new Phaser.Text(this.game,x,y,_text,style));},/**
	    * Creates a new Button object.
	    *
	    * @method Phaser.GameObjectFactory#button
	    * @param {number} [x=0] - The x coordinate of the Button. The coordinate is relative to any parent container this button may be in.
	    * @param {number} [y=0] - The y coordinate of the Button. The coordinate is relative to any parent container this button may be in.
	    * @param {string} [key] - The image key as defined in the Game.Cache to use as the texture for this button.
	    * @param {function} [callback] - The function to call when this button is pressed
	    * @param {object} [callbackContext] - The context in which the callback will be called (usually 'this')
	    * @param {string|number} [overFrame] - This is the frame or frameName that will be set when this button is in an over state. Give either a number to use a frame ID or a string for a frame name.
	    * @param {string|number} [outFrame] - This is the frame or frameName that will be set when this button is in an out state. Give either a number to use a frame ID or a string for a frame name.
	    * @param {string|number} [downFrame] - This is the frame or frameName that will be set when this button is in a down state. Give either a number to use a frame ID or a string for a frame name.
	    * @param {string|number} [upFrame] - This is the frame or frameName that will be set when this button is in an up state. Give either a number to use a frame ID or a string for a frame name.
	    * @param {Phaser.Group} [group] - Optional Group to add the object to. If not specified it will be added to the World group.
	    * @return {Phaser.Button} The newly created Button object.
	    */button:function button(x,y,key,callback,callbackContext,overFrame,outFrame,downFrame,upFrame,group){if(group===undefined){group=this.world;}return group.add(new Phaser.Button(this.game,x,y,key,callback,callbackContext,overFrame,outFrame,downFrame,upFrame));},/**
	    * Creates a new Graphics object.
	    *
	    * @method Phaser.GameObjectFactory#graphics
	    * @param {number} [x=0] - The x coordinate of the Graphic. The coordinate is relative to any parent container this object may be in.
	    * @param {number} [y=0] - The y coordinate of the Graphic. The coordinate is relative to any parent container this object may be in.
	    * @param {Phaser.Group} [group] - Optional Group to add the object to. If not specified it will be added to the World group.
	    * @return {Phaser.Graphics} The newly created graphics object.
	    */graphics:function graphics(x,y,group){if(group===undefined){group=this.world;}return group.add(new Phaser.Graphics(this.game,x,y));},/**
	    * Create a new Emitter.
	    *
	    * A particle emitter can be used for one-time explosions or for
	    * continuous effects like rain and fire. All it really does is launch Particle objects out
	    * at set intervals, and fixes their positions and velocities accordingly.
	    *
	    * @method Phaser.GameObjectFactory#emitter
	    * @param {number} [x=0] - The x coordinate within the Emitter that the particles are emitted from.
	    * @param {number} [y=0] - The y coordinate within the Emitter that the particles are emitted from.
	    * @param {number} [maxParticles=50] - The total number of particles in this emitter.
	    * @return {Phaser.Particles.Arcade.Emitter} The newly created emitter object.
	    */emitter:function emitter(x,y,maxParticles){return this.game.particles.add(new Phaser.Particles.Arcade.Emitter(this.game,x,y,maxParticles));},/**
	    * Create a new RetroFont object.
	    *
	    * A RetroFont can be used as a texture for an Image or Sprite and optionally add it to the Cache.
	    * A RetroFont uses a bitmap which contains fixed with characters for the font set. You use character spacing to define the set.
	    * If you need variable width character support then use a BitmapText object instead. The main difference between a RetroFont and a BitmapText
	    * is that a RetroFont creates a single texture that you can apply to a game object, where-as a BitmapText creates one Sprite object per letter of text.
	    * The texture can be asssigned or one or multiple images/sprites, but note that the text the RetroFont uses will be shared across them all,
	    * i.e. if you need each Image to have different text in it, then you need to create multiple RetroFont objects.
	    *
	    * @method Phaser.GameObjectFactory#retroFont
	    * @param {string} font - The key of the image in the Game.Cache that the RetroFont will use.
	    * @param {number} characterWidth - The width of each character in the font set.
	    * @param {number} characterHeight - The height of each character in the font set.
	    * @param {string} chars - The characters used in the font set, in display order. You can use the TEXT_SET consts for common font set arrangements.
	    * @param {number} charsPerRow - The number of characters per row in the font set.
	    * @param {number} [xSpacing=0] - If the characters in the font set have horizontal spacing between them set the required amount here.
	    * @param {number} [ySpacing=0] - If the characters in the font set have vertical spacing between them set the required amount here.
	    * @param {number} [xOffset=0] - If the font set doesn't start at the top left of the given image, specify the X coordinate offset here.
	    * @param {number} [yOffset=0] - If the font set doesn't start at the top left of the given image, specify the Y coordinate offset here.
	    * @return {Phaser.RetroFont} The newly created RetroFont texture which can be applied to an Image or Sprite.
	    */retroFont:function retroFont(font,characterWidth,characterHeight,chars,charsPerRow,xSpacing,ySpacing,xOffset,yOffset){return new Phaser.RetroFont(this.game,font,characterWidth,characterHeight,chars,charsPerRow,xSpacing,ySpacing,xOffset,yOffset);},/**
	    * Create a new BitmapText object.
	    *
	    * BitmapText objects work by taking a texture file and an XML file that describes the font structure.
	    * It then generates a new Sprite object for each letter of the text, proportionally spaced out and aligned to 
	    * match the font structure.
	    * 
	    * BitmapText objects are less flexible than Text objects, in that they have less features such as shadows, fills and the ability 
	    * to use Web Fonts. However you trade this flexibility for pure rendering speed. You can also create visually compelling BitmapTexts by 
	    * processing the font texture in an image editor first, applying fills and any other effects required.
	    *
	    * To create multi-line text insert \r, \n or \r\n escape codes into the text string.
	    *
	    * To create a BitmapText data files you can use:
	    *
	    * BMFont (Windows, free): http://www.angelcode.com/products/bmfont/
	    * Glyph Designer (OS X, commercial): http://www.71squared.com/en/glyphdesigner
	    * Littera (Web-based, free): http://kvazars.com/littera/
	    *
	    * @method Phaser.GameObjectFactory#bitmapText
	    * @param {number} x - X coordinate to display the BitmapText object at.
	    * @param {number} y - Y coordinate to display the BitmapText object at.
	    * @param {string} font - The key of the BitmapText as stored in Phaser.Cache.
	    * @param {string} [text=''] - The text that will be rendered. This can also be set later via BitmapText.text.
	    * @param {number} [size=32] - The size the font will be rendered at in pixels.
	    * @param {Phaser.Group} [group] - Optional Group to add the object to. If not specified it will be added to the World group.
	    * @return {Phaser.BitmapText} The newly created bitmapText object.
	    */bitmapText:function bitmapText(x,y,font,text,size,group){if(group===undefined){group=this.world;}return group.add(new Phaser.BitmapText(this.game,x,y,font,text,size));},/**
	    * Creates a new Phaser.Tilemap object.
	    *
	    * The map can either be populated with data from a Tiled JSON file or from a CSV file.
	    * To do this pass the Cache key as the first parameter. When using Tiled data you need only provide the key.
	    * When using CSV data you must provide the key and the tileWidth and tileHeight parameters.
	    * If creating a blank tilemap to be populated later, you can either specify no parameters at all and then use `Tilemap.create` or pass the map and tile dimensions here.
	    * Note that all Tilemaps use a base tile size to calculate dimensions from, but that a TilemapLayer may have its own unique tile size that overrides it.
	    *
	    * @method Phaser.GameObjectFactory#tilemap
	    * @param {string} [key] - The key of the tilemap data as stored in the Cache. If you're creating a blank map either leave this parameter out or pass `null`.
	    * @param {number} [tileWidth=32] - The pixel width of a single map tile. If using CSV data you must specify this. Not required if using Tiled map data.
	    * @param {number} [tileHeight=32] - The pixel height of a single map tile. If using CSV data you must specify this. Not required if using Tiled map data.
	    * @param {number} [width=10] - The width of the map in tiles. If this map is created from Tiled or CSV data you don't need to specify this.
	    * @param {number} [height=10] - The height of the map in tiles. If this map is created from Tiled or CSV data you don't need to specify this.
	    * @return {Phaser.Tilemap} The newly created tilemap object.
	    */tilemap:function tilemap(key,tileWidth,tileHeight,width,height){return new Phaser.Tilemap(this.game,key,tileWidth,tileHeight,width,height);},/**
	    * A dynamic initially blank canvas to which images can be drawn.
	    *
	    * @method Phaser.GameObjectFactory#renderTexture
	    * @param {number} [width=100] - the width of the RenderTexture.
	    * @param {number} [height=100] - the height of the RenderTexture.
	    * @param {string} [key=''] - Asset key for the RenderTexture when stored in the Cache (see addToCache parameter).
	    * @param {boolean} [addToCache=false] - Should this RenderTexture be added to the Game.Cache? If so you can retrieve it with Cache.getTexture(key)
	    * @return {Phaser.RenderTexture} The newly created RenderTexture object.
	    */renderTexture:function renderTexture(width,height,key,addToCache){if(key===undefined||key===''){key=this.game.rnd.uuid();}if(addToCache===undefined){addToCache=false;}var texture=new Phaser.RenderTexture(this.game,width,height,key);if(addToCache){this.game.cache.addRenderTexture(key,texture);}return texture;},/**
	    * Create a Video object.
	    *
	    * This will return a Phaser.Video object which you can pass to a Sprite to be used as a texture.
	    *
	    * @method Phaser.GameObjectFactory#video
	    * @param {string|null} [key=null] - The key of the video file in the Phaser.Cache that this Video object will play. Set to `null` or leave undefined if you wish to use a webcam as the source. See `startMediaStream` to start webcam capture.
	    * @param {string|null} [url=null] - If the video hasn't been loaded then you can provide a full URL to the file here (make sure to set key to null)
	    * @return {Phaser.Video} The newly created Video object.
	    */video:function video(key,url){return new Phaser.Video(this.game,key,url);},/**
	    * Create a BitmapData object.
	    *
	    * A BitmapData object can be manipulated and drawn to like a traditional Canvas object and used to texture Sprites.
	    *
	    * @method Phaser.GameObjectFactory#bitmapData
	    * @param {number} [width=256] - The width of the BitmapData in pixels.
	    * @param {number} [height=256] - The height of the BitmapData in pixels.
	    * @param {string} [key=''] - Asset key for the BitmapData when stored in the Cache (see addToCache parameter).
	    * @param {boolean} [addToCache=false] - Should this BitmapData be added to the Game.Cache? If so you can retrieve it with Cache.getBitmapData(key)
	    * @return {Phaser.BitmapData} The newly created BitmapData object.
	    */bitmapData:function bitmapData(width,height,key,addToCache){if(addToCache===undefined){addToCache=false;}if(key===undefined||key===''){key=this.game.rnd.uuid();}var texture=new Phaser.BitmapData(this.game,key,width,height);if(addToCache){this.game.cache.addBitmapData(key,texture);}return texture;},/**
	    * A WebGL shader/filter that can be applied to Sprites.
	    *
	    * @method Phaser.GameObjectFactory#filter
	    * @param {string} filter - The name of the filter you wish to create, for example HueRotate or SineWave.
	    * @param {any} - Whatever parameters are needed to be passed to the filter init function.
	    * @return {Phaser.Filter} The newly created Phaser.Filter object.
	    */filter:function filter(filter){var args=Array.prototype.slice.call(arguments,1);var filter=new Phaser.Filter[filter](this.game);filter.init.apply(filter,args);return filter;},/**
	    * Add a new Plugin into the PluginManager.
	    *
	    * The Plugin must have 2 properties: `game` and `parent`. Plugin.game is set to the game reference the PluginManager uses, and parent is set to the PluginManager.
	    *
	    * @method Phaser.GameObjectFactory#plugin
	    * @param {object|Phaser.Plugin} plugin - The Plugin to add into the PluginManager. This can be a function or an existing object.
	    * @param {...*} parameter - Additional parameters that will be passed to the Plugin.init method.
	    * @return {Phaser.Plugin} The Plugin that was added to the manager.
	    */plugin:function plugin(_plugin){return this.game.plugins.add(_plugin);}};Phaser.GameObjectFactory.prototype.constructor=Phaser.GameObjectFactory;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The GameObjectCreator is a quick way to create common game objects _without_ adding them to the game world.
	* The object creator can be accessed with {@linkcode Phaser.Game#make `game.make`}.
	*
	* @class Phaser.GameObjectCreator
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	*/Phaser.GameObjectCreator=function(game){/**
	    * @property {Phaser.Game} game - A reference to the currently running Game.
	    * @protected
	    */this.game=game;/**
	    * @property {Phaser.World} world - A reference to the game world.
	    * @protected
	    */this.world=this.game.world;};Phaser.GameObjectCreator.prototype={/**
	    * Create a new Image object.
	    *
	    * An Image is a light-weight object you can use to display anything that doesn't need physics or animation.
	    * It can still rotate, scale, crop and receive input events. This makes it perfect for logos, backgrounds, simple buttons and other non-Sprite graphics.
	    *
	    * @method Phaser.GameObjectCreator#image
	    * @param {number} x - X position of the image.
	    * @param {number} y - Y position of the image.
	    * @param {string|Phaser.RenderTexture|PIXI.Texture} key - This is the image or texture used by the Sprite during rendering. It can be a string which is a reference to the Cache entry, or an instance of a RenderTexture or PIXI.Texture.
	    * @param {string|number} [frame] - If the sprite uses an image from a texture atlas or sprite sheet you can pass the frame here. Either a number for a frame ID or a string for a frame name.
	    * @returns {Phaser.Image} the newly created sprite object.
	    */image:function image(x,y,key,frame){return new Phaser.Image(this.game,x,y,key,frame);},/**
	    * Create a new Sprite with specific position and sprite sheet key.
	    *
	    * @method Phaser.GameObjectCreator#sprite
	    * @param {number} x - X position of the new sprite.
	    * @param {number} y - Y position of the new sprite.
	    * @param {string|Phaser.RenderTexture|PIXI.Texture} key - This is the image or texture used by the Sprite during rendering. It can be a string which is a reference to the Cache entry, or an instance of a RenderTexture or PIXI.Texture.
	    * @param {string|number} [frame] - If the sprite uses an image from a texture atlas or sprite sheet you can pass the frame here. Either a number for a frame ID or a string for a frame name.
	    * @returns {Phaser.Sprite} the newly created sprite object.
	    */sprite:function sprite(x,y,key,frame){return new Phaser.Sprite(this.game,x,y,key,frame);},/**
	    * Create a tween object for a specific object.
	    *
	    * The object can be any JavaScript object or Phaser object such as Sprite.
	    *
	    * @method Phaser.GameObjectCreator#tween
	    * @param {object} obj - Object the tween will be run on.
	    * @return {Phaser.Tween} The Tween object.
	    */tween:function tween(obj){return new Phaser.Tween(obj,this.game,this.game.tweens);},/**
	    * A Group is a container for display objects that allows for fast pooling, recycling and collision checks.
	    *
	    * @method Phaser.GameObjectCreator#group
	    * @param {any} parent - The parent Group or DisplayObjectContainer that will hold this group, if any.
	    * @param {string} [name='group'] - A name for this Group. Not used internally but useful for debugging.
	    * @param {boolean} [addToStage=false] - If set to true this Group will be added directly to the Game.Stage instead of Game.World.
	    * @param {boolean} [enableBody=false] - If true all Sprites created with `Group.create` or `Group.createMulitple` will have a physics body created on them. Change the body type with physicsBodyType.
	    * @param {number} [physicsBodyType=0] - If enableBody is true this is the type of physics body that is created on new Sprites. Phaser.Physics.ARCADE, Phaser.Physics.P2, Phaser.Physics.NINJA, etc.
	    * @return {Phaser.Group} The newly created Group.
	    */group:function group(parent,name,addToStage,enableBody,physicsBodyType){return new Phaser.Group(this.game,parent,name,addToStage,enableBody,physicsBodyType);},/**
	    * Create a new SpriteBatch.
	    *
	    * @method Phaser.GameObjectCreator#spriteBatch
	    * @param {any} parent - The parent Group or DisplayObjectContainer that will hold this group, if any.
	    * @param {string} [name='group'] - A name for this Group. Not used internally but useful for debugging.
	    * @param {boolean} [addToStage=false] - If set to true this Group will be added directly to the Game.Stage instead of Game.World.
	    * @return {Phaser.SpriteBatch} The newly created group.
	    */spriteBatch:function spriteBatch(parent,name,addToStage){if(name===undefined){name='group';}if(addToStage===undefined){addToStage=false;}return new Phaser.SpriteBatch(this.game,parent,name,addToStage);},/**
	    * Creates a new Sound object.
	    *
	    * @method Phaser.GameObjectCreator#audio
	    * @param {string} key - The Game.cache key of the sound that this object will use.
	    * @param {number} [volume=1] - The volume at which the sound will be played.
	    * @param {boolean} [loop=false] - Whether or not the sound will loop.
	    * @param {boolean} [connect=true] - Controls if the created Sound object will connect to the master gainNode of the SoundManager when running under WebAudio.
	    * @return {Phaser.Sound} The newly created text object.
	    */audio:function audio(key,volume,loop,connect){return this.game.sound.add(key,volume,loop,connect);},/**
	     * Creates a new AudioSprite object.
	     *
	     * @method Phaser.GameObjectCreator#audioSprite
	     * @param {string} key - The Game.cache key of the sound that this object will use.
	     * @return {Phaser.AudioSprite} The newly created AudioSprite object.
	     */audioSprite:function audioSprite(key){return this.game.sound.addSprite(key);},/**
	    * Creates a new Sound object.
	    *
	    * @method Phaser.GameObjectCreator#sound
	    * @param {string} key - The Game.cache key of the sound that this object will use.
	    * @param {number} [volume=1] - The volume at which the sound will be played.
	    * @param {boolean} [loop=false] - Whether or not the sound will loop.
	    * @param {boolean} [connect=true] - Controls if the created Sound object will connect to the master gainNode of the SoundManager when running under WebAudio.
	    * @return {Phaser.Sound} The newly created text object.
	    */sound:function sound(key,volume,loop,connect){return this.game.sound.add(key,volume,loop,connect);},/**
	    * Creates a new TileSprite object.
	    *
	    * @method Phaser.GameObjectCreator#tileSprite
	    * @param {number} x - The x coordinate (in world space) to position the TileSprite at.
	    * @param {number} y - The y coordinate (in world space) to position the TileSprite at.
	    * @param {number} width - The width of the TileSprite.
	    * @param {number} height - The height of the TileSprite.
	    * @param {string|Phaser.BitmapData|PIXI.Texture} key - This is the image or texture used by the TileSprite during rendering. It can be a string which is a reference to the Phaser Image Cache entry, or an instance of a PIXI.Texture or BitmapData.
	    * @param {string|number} frame - If this TileSprite is using part of a sprite sheet or texture atlas you can specify the exact frame to use by giving a string or numeric index.
	    * @return {Phaser.TileSprite} The newly created tileSprite object.
	    */tileSprite:function tileSprite(x,y,width,height,key,frame){return new Phaser.TileSprite(this.game,x,y,width,height,key,frame);},/**
	    * Creates a new Rope object.
	    *
	    * @method Phaser.GameObjectCreator#rope
	    * @param {number} x - The x coordinate (in world space) to position the Rope at.
	    * @param {number} y - The y coordinate (in world space) to position the Rope at.
	    * @param {number} width - The width of the Rope.
	    * @param {number} height - The height of the Rope.
	    * @param {string|Phaser.RenderTexture|Phaser.BitmapData|PIXI.Texture} key - This is the image or texture used by the TileSprite during rendering. It can be a string which is a reference to the Cache entry, or an instance of a RenderTexture or PIXI.Texture.
	    * @param {string|number} frame - If this Rope is using part of a sprite sheet or texture atlas you can specify the exact frame to use by giving a string or numeric index.
	    * @return {Phaser.Rope} The newly created rope object.
	    */rope:function rope(x,y,key,frame,points){return new Phaser.Rope(this.game,x,y,key,frame,points);},/**
	    * Creates a new Text object.
	    *
	    * @method Phaser.GameObjectCreator#text
	    * @param {number} x - X position of the new text object.
	    * @param {number} y - Y position of the new text object.
	    * @param {string} text - The actual text that will be written.
	    * @param {object} style - The style object containing style attributes like font, font size , etc.
	    * @return {Phaser.Text} The newly created text object.
	    */text:function text(x,y,_text2,style){return new Phaser.Text(this.game,x,y,_text2,style);},/**
	    * Creates a new Button object.
	    *
	    * @method Phaser.GameObjectCreator#button
	    * @param {number} [x] X position of the new button object.
	    * @param {number} [y] Y position of the new button object.
	    * @param {string} [key] The image key as defined in the Game.Cache to use as the texture for this button.
	    * @param {function} [callback] The function to call when this button is pressed
	    * @param {object} [callbackContext] The context in which the callback will be called (usually 'this')
	    * @param {string|number} [overFrame] This is the frame or frameName that will be set when this button is in an over state. Give either a number to use a frame ID or a string for a frame name.
	    * @param {string|number} [outFrame] This is the frame or frameName that will be set when this button is in an out state. Give either a number to use a frame ID or a string for a frame name.
	    * @param {string|number} [downFrame] This is the frame or frameName that will be set when this button is in a down state. Give either a number to use a frame ID or a string for a frame name.
	    * @param {string|number} [upFrame] This is the frame or frameName that will be set when this button is in an up state. Give either a number to use a frame ID or a string for a frame name.
	    * @return {Phaser.Button} The newly created button object.
	    */button:function button(x,y,key,callback,callbackContext,overFrame,outFrame,downFrame,upFrame){return new Phaser.Button(this.game,x,y,key,callback,callbackContext,overFrame,outFrame,downFrame,upFrame);},/**
	    * Creates a new Graphics object.
	    *
	    * @method Phaser.GameObjectCreator#graphics
	    * @param {number} [x=0] - X position of the new graphics object.
	    * @param {number} [y=0] - Y position of the new graphics object.
	    * @return {Phaser.Graphics} The newly created graphics object.
	    */graphics:function graphics(x,y){return new Phaser.Graphics(this.game,x,y);},/**
	    * Creat a new Emitter.
	    *
	    * An Emitter is a lightweight particle emitter. It can be used for one-time explosions or for
	    * continuous effects like rain and fire. All it really does is launch Particle objects out
	    * at set intervals, and fixes their positions and velocities accorindgly.
	    *
	    * @method Phaser.GameObjectCreator#emitter
	    * @param {number} [x=0] - The x coordinate within the Emitter that the particles are emitted from.
	    * @param {number} [y=0] - The y coordinate within the Emitter that the particles are emitted from.
	    * @param {number} [maxParticles=50] - The total number of particles in this emitter.
	    * @return {Phaser.Emitter} The newly created emitter object.
	    */emitter:function emitter(x,y,maxParticles){return new Phaser.Particles.Arcade.Emitter(this.game,x,y,maxParticles);},/**
	    * Create a new RetroFont object.
	    *
	    * A RetroFont can be used as a texture for an Image or Sprite and optionally add it to the Cache.
	    * A RetroFont uses a bitmap which contains fixed with characters for the font set. You use character spacing to define the set.
	    * If you need variable width character support then use a BitmapText object instead. The main difference between a RetroFont and a BitmapText
	    * is that a RetroFont creates a single texture that you can apply to a game object, where-as a BitmapText creates one Sprite object per letter of text.
	    * The texture can be asssigned or one or multiple images/sprites, but note that the text the RetroFont uses will be shared across them all,
	    * i.e. if you need each Image to have different text in it, then you need to create multiple RetroFont objects.
	    *
	    * @method Phaser.GameObjectCreator#retroFont
	    * @param {string} font - The key of the image in the Game.Cache that the RetroFont will use.
	    * @param {number} characterWidth - The width of each character in the font set.
	    * @param {number} characterHeight - The height of each character in the font set.
	    * @param {string} chars - The characters used in the font set, in display order. You can use the TEXT_SET consts for common font set arrangements.
	    * @param {number} charsPerRow - The number of characters per row in the font set.
	    * @param {number} [xSpacing=0] - If the characters in the font set have horizontal spacing between them set the required amount here.
	    * @param {number} [ySpacing=0] - If the characters in the font set have vertical spacing between them set the required amount here.
	    * @param {number} [xOffset=0] - If the font set doesn't start at the top left of the given image, specify the X coordinate offset here.
	    * @param {number} [yOffset=0] - If the font set doesn't start at the top left of the given image, specify the Y coordinate offset here.
	    * @return {Phaser.RetroFont} The newly created RetroFont texture which can be applied to an Image or Sprite.
	    */retroFont:function retroFont(font,characterWidth,characterHeight,chars,charsPerRow,xSpacing,ySpacing,xOffset,yOffset){return new Phaser.RetroFont(this.game,font,characterWidth,characterHeight,chars,charsPerRow,xSpacing,ySpacing,xOffset,yOffset);},/**
	    * Create a new BitmapText object.
	    *
	    * BitmapText objects work by taking a texture file and an XML file that describes the font structure.
	    * It then generates a new Sprite object for each letter of the text, proportionally spaced out and aligned to 
	    * match the font structure.
	    * 
	    * BitmapText objects are less flexible than Text objects, in that they have less features such as shadows, fills and the ability 
	    * to use Web Fonts. However you trade this flexibility for pure rendering speed. You can also create visually compelling BitmapTexts by 
	    * processing the font texture in an image editor first, applying fills and any other effects required.
	    *
	    * To create multi-line text insert \r, \n or \r\n escape codes into the text string.
	    *
	    * To create a BitmapText data files you can use:
	    *
	    * BMFont (Windows, free): http://www.angelcode.com/products/bmfont/
	    * Glyph Designer (OS X, commercial): http://www.71squared.com/en/glyphdesigner
	    * Littera (Web-based, free): http://kvazars.com/littera/
	    *
	    * @method Phaser.GameObjectCreator#bitmapText
	    * @param {number} x - X coordinate to display the BitmapText object at.
	    * @param {number} y - Y coordinate to display the BitmapText object at.
	    * @param {string} font - The key of the BitmapText as stored in Phaser.Cache.
	    * @param {string} [text=''] - The text that will be rendered. This can also be set later via BitmapText.text.
	    * @param {number} [size=32] - The size the font will be rendered at in pixels.
	    * @param {string} [align='left'] - The alignment of multi-line text. Has no effect if there is only one line of text.
	    * @return {Phaser.BitmapText} The newly created bitmapText object.
	    */bitmapText:function bitmapText(x,y,font,text,size,align){return new Phaser.BitmapText(this.game,x,y,font,text,size,align);},/**
	    * Creates a new Phaser.Tilemap object.
	    *
	    * The map can either be populated with data from a Tiled JSON file or from a CSV file.
	    * To do this pass the Cache key as the first parameter. When using Tiled data you need only provide the key.
	    * When using CSV data you must provide the key and the tileWidth and tileHeight parameters.
	    * If creating a blank tilemap to be populated later, you can either specify no parameters at all and then use `Tilemap.create` or pass the map and tile dimensions here.
	    * Note that all Tilemaps use a base tile size to calculate dimensions from, but that a TilemapLayer may have its own unique tile size that overrides it.
	    *
	    * @method Phaser.GameObjectCreator#tilemap
	    * @param {string} [key] - The key of the tilemap data as stored in the Cache. If you're creating a blank map either leave this parameter out or pass `null`.
	    * @param {number} [tileWidth=32] - The pixel width of a single map tile. If using CSV data you must specify this. Not required if using Tiled map data.
	    * @param {number} [tileHeight=32] - The pixel height of a single map tile. If using CSV data you must specify this. Not required if using Tiled map data.
	    * @param {number} [width=10] - The width of the map in tiles. If this map is created from Tiled or CSV data you don't need to specify this.
	    * @param {number} [height=10] - The height of the map in tiles. If this map is created from Tiled or CSV data you don't need to specify this.
	    */tilemap:function tilemap(key,tileWidth,tileHeight,width,height){return new Phaser.Tilemap(this.game,key,tileWidth,tileHeight,width,height);},/**
	    * A dynamic initially blank canvas to which images can be drawn.
	    *
	    * @method Phaser.GameObjectCreator#renderTexture
	    * @param {number} [width=100] - the width of the RenderTexture.
	    * @param {number} [height=100] - the height of the RenderTexture.
	    * @param {string} [key=''] - Asset key for the RenderTexture when stored in the Cache (see addToCache parameter).
	    * @param {boolean} [addToCache=false] - Should this RenderTexture be added to the Game.Cache? If so you can retrieve it with Cache.getTexture(key)
	    * @return {Phaser.RenderTexture} The newly created RenderTexture object.
	    */renderTexture:function renderTexture(width,height,key,addToCache){if(key===undefined||key===''){key=this.game.rnd.uuid();}if(addToCache===undefined){addToCache=false;}var texture=new Phaser.RenderTexture(this.game,width,height,key);if(addToCache){this.game.cache.addRenderTexture(key,texture);}return texture;},/**
	    * Create a BitmpaData object.
	    *
	    * A BitmapData object can be manipulated and drawn to like a traditional Canvas object and used to texture Sprites.
	    *
	    * @method Phaser.GameObjectCreator#bitmapData
	    * @param {number} [width=256] - The width of the BitmapData in pixels.
	    * @param {number} [height=256] - The height of the BitmapData in pixels.
	    * @param {string} [key=''] - Asset key for the BitmapData when stored in the Cache (see addToCache parameter).
	    * @param {boolean} [addToCache=false] - Should this BitmapData be added to the Game.Cache? If so you can retrieve it with Cache.getBitmapData(key)
	    * @return {Phaser.BitmapData} The newly created BitmapData object.
	    */bitmapData:function bitmapData(width,height,key,addToCache){if(addToCache===undefined){addToCache=false;}if(key===undefined||key===''){key=this.game.rnd.uuid();}var texture=new Phaser.BitmapData(this.game,key,width,height);if(addToCache){this.game.cache.addBitmapData(key,texture);}return texture;},/**
	    * A WebGL shader/filter that can be applied to Sprites.
	    *
	    * @method Phaser.GameObjectCreator#filter
	    * @param {string} filter - The name of the filter you wish to create, for example HueRotate or SineWave.
	    * @param {any} - Whatever parameters are needed to be passed to the filter init function.
	    * @return {Phaser.Filter} The newly created Phaser.Filter object.
	    */filter:function filter(filter){var args=Array.prototype.slice.call(arguments,1);var filter=new Phaser.Filter[filter](this.game);filter.init.apply(filter,args);return filter;}};Phaser.GameObjectCreator.prototype.constructor=Phaser.GameObjectCreator;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Sprites are the lifeblood of your game, used for nearly everything visual.
	*
	* At its most basic a Sprite consists of a set of coordinates and a texture that is rendered to the canvas.
	* They also contain additional properties allowing for physics motion (via Sprite.body), input handling (via Sprite.input),
	* events (via Sprite.events), animation (via Sprite.animations), camera culling and more. Please see the Examples for use cases.
	*
	* @class Phaser.Sprite
	* @constructor
	* @extends PIXI.Sprite
	* @extends Phaser.Component.Core
	* @extends Phaser.Component.Angle
	* @extends Phaser.Component.Animation
	* @extends Phaser.Component.AutoCull
	* @extends Phaser.Component.Bounds
	* @extends Phaser.Component.BringToTop
	* @extends Phaser.Component.Crop
	* @extends Phaser.Component.Delta
	* @extends Phaser.Component.Destroy
	* @extends Phaser.Component.FixedToCamera
	* @extends Phaser.Component.Health
	* @extends Phaser.Component.InCamera
	* @extends Phaser.Component.InputEnabled
	* @extends Phaser.Component.InWorld
	* @extends Phaser.Component.LifeSpan
	* @extends Phaser.Component.LoadTexture
	* @extends Phaser.Component.Overlap
	* @extends Phaser.Component.PhysicsBody
	* @extends Phaser.Component.Reset
	* @extends Phaser.Component.ScaleMinMax
	* @extends Phaser.Component.Smoothed
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {number} x - The x coordinate (in world space) to position the Sprite at.
	* @param {number} y - The y coordinate (in world space) to position the Sprite at.
	* @param {string|Phaser.RenderTexture|Phaser.BitmapData|PIXI.Texture} key - This is the image or texture used by the Sprite during rendering. It can be a string which is a reference to the Cache entry, or an instance of a RenderTexture or PIXI.Texture.
	* @param {string|number} frame - If this Sprite is using part of a sprite sheet or texture atlas you can specify the exact frame to use by giving a string or numeric index.
	*/Phaser.Sprite=function(game,x,y,key,frame){x=x||0;y=y||0;key=key||null;frame=frame||null;/**
	    * @property {number} type - The const type of this object.
	    * @readonly
	    */this.type=Phaser.SPRITE;/**
	    * @property {number} physicsType - The const physics body type of this object.
	    * @readonly
	    */this.physicsType=Phaser.SPRITE;PIXI.Sprite.call(this,Phaser.Cache.DEFAULT);Phaser.Component.Core.init.call(this,game,x,y,key,frame);};Phaser.Sprite.prototype=Object.create(PIXI.Sprite.prototype);Phaser.Sprite.prototype.constructor=Phaser.Sprite;Phaser.Component.Core.install.call(Phaser.Sprite.prototype,['Angle','Animation','AutoCull','Bounds','BringToTop','Crop','Delta','Destroy','FixedToCamera','Health','InCamera','InputEnabled','InWorld','LifeSpan','LoadTexture','Overlap','PhysicsBody','Reset','ScaleMinMax','Smoothed']);Phaser.Sprite.prototype.preUpdatePhysics=Phaser.Component.PhysicsBody.preUpdate;Phaser.Sprite.prototype.preUpdateLifeSpan=Phaser.Component.LifeSpan.preUpdate;Phaser.Sprite.prototype.preUpdateInWorld=Phaser.Component.InWorld.preUpdate;Phaser.Sprite.prototype.preUpdateCore=Phaser.Component.Core.preUpdate;/**
	* Automatically called by World.preUpdate.
	*
	* @method
	* @memberof Phaser.Sprite
	* @return {boolean} True if the Sprite was rendered, otherwise false.
	*/Phaser.Sprite.prototype.preUpdate=function(){if(!this.preUpdatePhysics()||!this.preUpdateLifeSpan()||!this.preUpdateInWorld()){return false;}return this.preUpdateCore();};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* An Image is a light-weight object you can use to display anything that doesn't need physics or animation.
	* It can still rotate, scale, crop and receive input events. This makes it perfect for logos, backgrounds, simple buttons and other non-Sprite graphics.
	*
	* @class Phaser.Image
	* @extends PIXI.Sprite
	* @extends Phaser.Component.Core
	* @extends Phaser.Component.Angle
	* @extends Phaser.Component.Animation
	* @extends Phaser.Component.AutoCull
	* @extends Phaser.Component.Bounds
	* @extends Phaser.Component.BringToTop
	* @extends Phaser.Component.Crop
	* @extends Phaser.Component.Destroy
	* @extends Phaser.Component.FixedToCamera
	* @extends Phaser.Component.InputEnabled
	* @extends Phaser.Component.LifeSpan
	* @extends Phaser.Component.LoadTexture
	* @extends Phaser.Component.Overlap
	* @extends Phaser.Component.Reset
	* @extends Phaser.Component.ScaleMinMax
	* @extends Phaser.Component.Smoothed
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {number} [x=0] - The x coordinate of the Image. The coordinate is relative to any parent container this Image may be in.
	* @param {number} [y=0] - The y coordinate of the Image. The coordinate is relative to any parent container this Image may be in.
	* @param {string|Phaser.RenderTexture|Phaser.BitmapData|PIXI.Texture} [key] - The texture used by the Image during rendering. It can be a string which is a reference to the Cache entry, or an instance of a RenderTexture, BitmapData or PIXI.Texture.
	* @param {string|number} [frame] - If this Image is using part of a sprite sheet or texture atlas you can specify the exact frame to use by giving a string or numeric index.
	*/Phaser.Image=function(game,x,y,key,frame){x=x||0;y=y||0;key=key||null;frame=frame||null;/**
	    * @property {number} type - The const type of this object.
	    * @readonly
	    */this.type=Phaser.IMAGE;PIXI.Sprite.call(this,Phaser.Cache.DEFAULT);Phaser.Component.Core.init.call(this,game,x,y,key,frame);};Phaser.Image.prototype=Object.create(PIXI.Sprite.prototype);Phaser.Image.prototype.constructor=Phaser.Image;Phaser.Component.Core.install.call(Phaser.Image.prototype,['Angle','Animation','AutoCull','Bounds','BringToTop','Crop','Destroy','FixedToCamera','InputEnabled','LifeSpan','LoadTexture','Overlap','Reset','ScaleMinMax','Smoothed']);Phaser.Image.prototype.preUpdateInWorld=Phaser.Component.InWorld.preUpdate;Phaser.Image.prototype.preUpdateCore=Phaser.Component.Core.preUpdate;/**
	* Automatically called by World.preUpdate.
	*
	* @method Phaser.Image#preUpdate
	* @memberof Phaser.Image
	*/Phaser.Image.prototype.preUpdate=function(){if(!this.preUpdateInWorld()){return false;}return this.preUpdateCore();};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Create a new `Button` object. A Button is a special type of Sprite that is set-up to handle Pointer events automatically.
	*
	* The four states a Button responds to are:
	*
	* * 'Over' - when the Pointer moves over the Button. This is also commonly known as 'hover'.
	* * 'Out' - when the Pointer that was previously over the Button moves out of it.
	* * 'Down' - when the Pointer is pressed down on the Button. I.e. touched on a touch enabled device or clicked with the mouse.
	* * 'Up' - when the Pointer that was pressed down on the Button is released again.
	*
	* A different texture/frame and activation sound can be specified for any of the states.
	*
	* Frames can be specified as either an integer (the frame ID) or a string (the frame name); the same values that can be used with a Sprite constructor.
	*
	* @class Phaser.Button
	* @constructor
	* @extends Phaser.Image
	* @param {Phaser.Game} game Current game instance.
	* @param {number} [x=0] - X position of the Button.
	* @param {number} [y=0] - Y position of the Button.
	* @param {string} [key] - The image key (in the Game.Cache) to use as the texture for this Button.
	* @param {function} [callback] - The function to call when this Button is pressed.
	* @param {object} [callbackContext] - The context in which the callback will be called (usually 'this').
	* @param {string|integer} [overFrame] - The frame / frameName when the button is in the Over state.
	* @param {string|integer} [outFrame] - The frame / frameName when the button is in the Out state.
	* @param {string|integer} [downFrame] - The frame / frameName when the button is in the Down state.
	* @param {string|integer} [upFrame] - The frame / frameName when the button is in the Up state.
	*/Phaser.Button=function(game,x,y,key,callback,callbackContext,overFrame,outFrame,downFrame,upFrame){x=x||0;y=y||0;key=key||null;callback=callback||null;callbackContext=callbackContext||this;Phaser.Image.call(this,game,x,y,key,outFrame);/**
	    * The Phaser Object Type.
	    * @property {number} type
	    * @readonly
	    */this.type=Phaser.BUTTON;/**
	    * @property {number} physicsType - The const physics body type of this object.
	    * @readonly
	    */this.physicsType=Phaser.SPRITE;/**
	    * The name or ID of the Over state frame.
	    * @property {string|integer} onOverFrame
	    * @private
	    */this._onOverFrame=null;/**
	    * The name or ID of the Out state frame.
	    * @property {string|integer} onOutFrame
	    * @private
	    */this._onOutFrame=null;/**
	    * The name or ID of the Down state frame.
	    * @property {string|integer} onDownFrame
	    * @private
	    */this._onDownFrame=null;/**
	    * The name or ID of the Up state frame.
	    * @property {string|integer} onUpFrame
	    * @private
	    */this._onUpFrame=null;/**
	    * The Sound to be played when this Buttons Over state is activated.
	    * @property {Phaser.Sound|Phaser.AudioSprite|null} onOverSound
	    * @readonly
	    */this.onOverSound=null;/**
	    * The Sound to be played when this Buttons Out state is activated.
	    * @property {Phaser.Sound|Phaser.AudioSprite|null} onOutSound
	    * @readonly
	    */this.onOutSound=null;/**
	    * The Sound to be played when this Buttons Down state is activated.
	    * @property {Phaser.Sound|Phaser.AudioSprite|null} onDownSound
	    * @readonly
	    */this.onDownSound=null;/**
	    * The Sound to be played when this Buttons Up state is activated.
	    * @property {Phaser.Sound|Phaser.AudioSprite|null} onUpSound
	    * @readonly
	    */this.onUpSound=null;/**
	    * The Sound Marker used in conjunction with the onOverSound.
	    * @property {string} onOverSoundMarker
	    * @readonly
	    */this.onOverSoundMarker='';/**
	    * The Sound Marker used in conjunction with the onOutSound.
	    * @property {string} onOutSoundMarker
	    * @readonly
	    */this.onOutSoundMarker='';/**
	    * The Sound Marker used in conjunction with the onDownSound.
	    * @property {string} onDownSoundMarker
	    * @readonly
	    */this.onDownSoundMarker='';/**
	    * The Sound Marker used in conjunction with the onUpSound.
	    * @property {string} onUpSoundMarker
	    * @readonly
	    */this.onUpSoundMarker='';/**
	    * The Signal (or event) dispatched when this Button is in an Over state.
	    * @property {Phaser.Signal} onInputOver
	    */this.onInputOver=new Phaser.Signal();/**
	    * The Signal (or event) dispatched when this Button is in an Out state.
	    * @property {Phaser.Signal} onInputOut
	    */this.onInputOut=new Phaser.Signal();/**
	    * The Signal (or event) dispatched when this Button is in an Down state.
	    * @property {Phaser.Signal} onInputDown
	    */this.onInputDown=new Phaser.Signal();/**
	    * The Signal (or event) dispatched when this Button is in an Up state.
	    * @property {Phaser.Signal} onInputUp
	    */this.onInputUp=new Phaser.Signal();/**
	    * If true then onOver events (such as onOverSound) will only be triggered if the Pointer object causing them was the Mouse Pointer.
	    * The frame will still be changed as applicable.
	    *
	    * @property {boolean} onOverMouseOnly
	    * @default
	    */this.onOverMouseOnly=true;/**
	    * Suppress the over event if a pointer was just released and it matches the given {@link Phaser.PointerModer pointer mode bitmask}.
	    *
	    * This behavior was introduced in Phaser 2.3.1; this property is a soft-revert of the change.
	    *
	    * @property {Phaser.PointerMode?} justReleasedPreventsOver=ACTIVE_CURSOR
	    */this.justReleasedPreventsOver=Phaser.PointerMode.TOUCH;/**
	    * When true the the texture frame will not be automatically switched on up/down/over/out events.
	    * @property {boolean} freezeFrames
	    * @default
	    */this.freezeFrames=false;/**
	    * When the Button is touched / clicked and then released you can force it to enter a state of "out" instead of "up".
	    *
	    * This can also accept a {@link Phaser.PointerModer pointer mode bitmask} for more refined control.
	    *
	    * @property {boolean|Phaser.PointerMode} forceOut=false
	    * @default
	    */this.forceOut=false;this.inputEnabled=true;this.input.start(0,true);this.input.useHandCursor=true;this.setFrames(overFrame,outFrame,downFrame,upFrame);if(callback!==null){this.onInputUp.add(callback,callbackContext);}//  Redirect the input events to here so we can handle animation updates, etc
	this.events.onInputOver.add(this.onInputOverHandler,this);this.events.onInputOut.add(this.onInputOutHandler,this);this.events.onInputDown.add(this.onInputDownHandler,this);this.events.onInputUp.add(this.onInputUpHandler,this);this.events.onRemovedFromWorld.add(this.removedFromWorld,this);};Phaser.Button.prototype=Object.create(Phaser.Image.prototype);Phaser.Button.prototype.constructor=Phaser.Button;//  State constants; local only. These are tied to property names in Phaser.Button.
	var STATE_OVER='Over';var STATE_OUT='Out';var STATE_DOWN='Down';var STATE_UP='Up';/**
	* Clears all of the frames set on this Button.
	*
	* @method Phaser.Button#clearFrames
	*/Phaser.Button.prototype.clearFrames=function(){this.setFrames(null,null,null,null);};/**
	* Called when this Button is removed from the World.
	*
	* @method Phaser.Button#removedFromWorld
	* @protected
	*/Phaser.Button.prototype.removedFromWorld=function(){this.inputEnabled=false;};/**
	* Set the frame name/ID for the given state.
	*
	* @method Phaser.Button#setStateFrame
	* @private
	* @param {object} state - See `STATE_*`
	* @param {number|string} frame - The number or string representing the frame.
	* @param {boolean} switchImmediately - Immediately switch to the frame if it was set - and this is true.
	*/Phaser.Button.prototype.setStateFrame=function(state,frame,switchImmediately){var frameKey='_on'+state+'Frame';if(frame!==null)// not null or undefined
	{this[frameKey]=frame;if(switchImmediately){this.changeStateFrame(state);}}else{this[frameKey]=null;}};/**
	* Change the frame to that of the given state, _if_ the state has a frame assigned _and_ if the frames are not currently "frozen".
	*
	* @method Phaser.Button#changeStateFrame
	* @private
	* @param {object} state - See `STATE_*`
	* @return {boolean} True only if the frame was assigned a value, possibly the same one it already had.
	*/Phaser.Button.prototype.changeStateFrame=function(state){if(this.freezeFrames){return false;}var frameKey='_on'+state+'Frame';var frame=this[frameKey];if(typeof frame==='string'){this.frameName=frame;return true;}else if(typeof frame==='number'){this.frame=frame;return true;}else{return false;}};/**
	* Used to manually set the frames that will be used for the different states of the Button.
	*
	* Frames can be specified as either an integer (the frame ID) or a string (the frame name); these are the same values that can be used with a Sprite constructor.
	*
	* @method Phaser.Button#setFrames
	* @public
	* @param {string|integer} [overFrame] - The frame / frameName when the button is in the Over state.
	* @param {string|integer} [outFrame] - The frame / frameName when the button is in the Out state.
	* @param {string|integer} [downFrame] - The frame / frameName when the button is in the Down state.
	* @param {string|integer} [upFrame] - The frame / frameName when the button is in the Up state.
	*/Phaser.Button.prototype.setFrames=function(overFrame,outFrame,downFrame,upFrame){this.setStateFrame(STATE_OVER,overFrame,this.input.pointerOver());this.setStateFrame(STATE_OUT,outFrame,!this.input.pointerOver());this.setStateFrame(STATE_DOWN,downFrame,this.input.pointerDown());this.setStateFrame(STATE_UP,upFrame,this.input.pointerUp());};/**
	* Set the sound/marker for the given state.
	*
	* @method Phaser.Button#setStateSound
	* @private
	* @param {object} state - See `STATE_*`
	* @param {Phaser.Sound|Phaser.AudioSprite} [sound] - Sound.
	* @param {string} [marker=''] - Sound marker.
	*/Phaser.Button.prototype.setStateSound=function(state,sound,marker){var soundKey='on'+state+'Sound';var markerKey='on'+state+'SoundMarker';if(sound instanceof Phaser.Sound||sound instanceof Phaser.AudioSprite){this[soundKey]=sound;this[markerKey]=typeof marker==='string'?marker:'';}else{this[soundKey]=null;this[markerKey]='';}};/**
	* Play the sound for the given state, _if_ the state has a sound assigned.
	*
	* @method Phaser.Button#playStateSound
	* @private
	* @param {object} state - See `STATE_*`
	* @return {boolean} True only if a sound was played.
	*/Phaser.Button.prototype.playStateSound=function(state){var soundKey='on'+state+'Sound';var sound=this[soundKey];if(sound){var markerKey='on'+state+'SoundMarker';var marker=this[markerKey];sound.play(marker);return true;}else{return false;}};/**
	* Sets the sounds to be played whenever this Button is interacted with. Sounds can be either full Sound objects, or markers pointing to a section of a Sound object.
	* The most common forms of sounds are 'hover' effects and 'click' effects, which is why the order of the parameters is overSound then downSound.
	*
	* Call this function with no parameters to reset all sounds on this Button.
	*
	* @method Phaser.Button#setSounds
	* @public
	* @param {Phaser.Sound|Phaser.AudioSprite} [overSound] - Over Button Sound.
	* @param {string} [overMarker] - Over Button Sound Marker.
	* @param {Phaser.Sound|Phaser.AudioSprite} [downSound] - Down Button Sound.
	* @param {string} [downMarker] - Down Button Sound Marker.
	* @param {Phaser.Sound|Phaser.AudioSprite} [outSound] - Out Button Sound.
	* @param {string} [outMarker] - Out Button Sound Marker.
	* @param {Phaser.Sound|Phaser.AudioSprite} [upSound] - Up Button Sound.
	* @param {string} [upMarker] - Up Button Sound Marker.
	*/Phaser.Button.prototype.setSounds=function(overSound,overMarker,downSound,downMarker,outSound,outMarker,upSound,upMarker){this.setStateSound(STATE_OVER,overSound,overMarker);this.setStateSound(STATE_OUT,outSound,outMarker);this.setStateSound(STATE_DOWN,downSound,downMarker);this.setStateSound(STATE_UP,upSound,upMarker);};/**
	* The Sound to be played when a Pointer moves over this Button.
	*
	* @method Phaser.Button#setOverSound
	* @public
	* @param {Phaser.Sound|Phaser.AudioSprite} sound - The Sound that will be played.
	* @param {string} [marker] - A Sound Marker that will be used in the playback.
	*/Phaser.Button.prototype.setOverSound=function(sound,marker){this.setStateSound(STATE_OVER,sound,marker);};/**
	* The Sound to be played when a Pointer moves out of this Button.
	*
	* @method Phaser.Button#setOutSound
	* @public
	* @param {Phaser.Sound|Phaser.AudioSprite} sound - The Sound that will be played.
	* @param {string} [marker] - A Sound Marker that will be used in the playback.
	*/Phaser.Button.prototype.setOutSound=function(sound,marker){this.setStateSound(STATE_OUT,sound,marker);};/**
	* The Sound to be played when a Pointer presses down on this Button.
	*
	* @method Phaser.Button#setDownSound
	* @public
	* @param {Phaser.Sound|Phaser.AudioSprite} sound - The Sound that will be played.
	* @param {string} [marker] - A Sound Marker that will be used in the playback.
	*/Phaser.Button.prototype.setDownSound=function(sound,marker){this.setStateSound(STATE_DOWN,sound,marker);};/**
	* The Sound to be played when a Pointer has pressed down and is released from this Button.
	*
	* @method Phaser.Button#setUpSound
	* @public
	* @param {Phaser.Sound|Phaser.AudioSprite} sound - The Sound that will be played.
	* @param {string} [marker] - A Sound Marker that will be used in the playback.
	*/Phaser.Button.prototype.setUpSound=function(sound,marker){this.setStateSound(STATE_UP,sound,marker);};/**
	* Internal function that handles input events.
	*
	* @method Phaser.Button#onInputOverHandler
	* @protected
	* @param {Phaser.Button} sprite - The Button that the event occurred on.
	* @param {Phaser.Pointer} pointer - The Pointer that activated the Button.
	*/Phaser.Button.prototype.onInputOverHandler=function(sprite,pointer){if(pointer.justReleased()&&(this.justReleasedPreventsOver&pointer.pointerMode)===pointer.pointerMode){//  If the Pointer was only just released then we don't fire an over event
	return;}this.changeStateFrame(STATE_OVER);if(this.onOverMouseOnly&&!pointer.isMouse){return;}this.playStateSound(STATE_OVER);if(this.onInputOver){this.onInputOver.dispatch(this,pointer);}};/**
	* Internal function that handles input events.
	*
	* @method Phaser.Button#onInputOutHandler
	* @protected
	* @param {Phaser.Button} sprite - The Button that the event occurred on.
	* @param {Phaser.Pointer} pointer - The Pointer that activated the Button.
	*/Phaser.Button.prototype.onInputOutHandler=function(sprite,pointer){this.changeStateFrame(STATE_OUT);this.playStateSound(STATE_OUT);if(this.onInputOut){this.onInputOut.dispatch(this,pointer);}};/**
	* Internal function that handles input events.
	*
	* @method Phaser.Button#onInputDownHandler
	* @protected
	* @param {Phaser.Button} sprite - The Button that the event occurred on.
	* @param {Phaser.Pointer} pointer - The Pointer that activated the Button.
	*/Phaser.Button.prototype.onInputDownHandler=function(sprite,pointer){this.changeStateFrame(STATE_DOWN);this.playStateSound(STATE_DOWN);if(this.onInputDown){this.onInputDown.dispatch(this,pointer);}};/**
	* Internal function that handles input events.
	*
	* @method Phaser.Button#onInputUpHandler
	* @protected
	* @param {Phaser.Button} sprite - The Button that the event occurred on.
	* @param {Phaser.Pointer} pointer - The Pointer that activated the Button.
	*/Phaser.Button.prototype.onInputUpHandler=function(sprite,pointer,isOver){this.playStateSound(STATE_UP);//  Input dispatched early, before state change (but after sound)
	if(this.onInputUp){this.onInputUp.dispatch(this,pointer,isOver);}if(this.freezeFrames){return;}if(this.forceOut===true||(this.forceOut&pointer.pointerMode)===pointer.pointerMode){this.changeStateFrame(STATE_OUT);}else{var changedUp=this.changeStateFrame(STATE_UP);if(!changedUp){//  No Up frame to show..
	if(isOver){this.changeStateFrame(STATE_OVER);}else{this.changeStateFrame(STATE_OUT);}}}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The SpriteBatch class is a really fast version of the DisplayObjectContainer built purely for speed, so use when you need a lot of sprites or particles.
	* It's worth mentioning that by default sprite batches are used through-out the renderer, so you only really need to use a SpriteBatch if you have over
	* 1000 sprites that all share the same texture (or texture atlas). It's also useful if running in Canvas mode and you have a lot of un-rotated or un-scaled
	* Sprites as it skips all of the Canvas setTransform calls, which helps performance, especially on mobile devices.
	*
	* Please note that any Sprite that is part of a SpriteBatch will not have its bounds updated, so will fail checks such as outOfBounds.
	*
	* @class Phaser.SpriteBatch
	* @extends Phaser.Group
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {Phaser.Group|Phaser.Sprite|null} parent - The parent Group, DisplayObject or DisplayObjectContainer that this Group will be added to. If `undefined` or `null` it will use game.world.
	* @param {string} [name=group] - A name for this Group. Not used internally but useful for debugging.
	* @param {boolean} [addToStage=false] - If set to true this Group will be added directly to the Game.Stage instead of Game.World.
	*/Phaser.SpriteBatch=function(game,parent,name,addToStage){if(parent===undefined||parent===null){parent=game.world;}PIXI.SpriteBatch.call(this);Phaser.Group.call(this,game,parent,name,addToStage);/**
	    * @property {number} type - Internal Phaser Type value.
	    * @protected
	    */this.type=Phaser.SPRITEBATCH;};Phaser.SpriteBatch.prototype=Phaser.Utils.extend(true,Phaser.SpriteBatch.prototype,PIXI.SpriteBatch.prototype,Phaser.Group.prototype);Phaser.SpriteBatch.prototype.constructor=Phaser.SpriteBatch;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A BitmapData object contains a Canvas element to which you can draw anything you like via normal Canvas context operations.
	* A single BitmapData can be used as the texture for one or many Images / Sprites. 
	* So if you need to dynamically create a Sprite texture then they are a good choice.
	*
	* Important note: Every BitmapData creates its own Canvas element. Because BitmapData's are now Game Objects themselves, and don't
	* live on the display list, they are NOT automatically cleared when you change State. Therefore you _must_ call BitmapData.destroy
	* in your State's shutdown method if you wish to free-up the resources the BitmapData used, it will not happen for you.
	*
	* @class Phaser.BitmapData
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {string} key - Internal Phaser reference key for the BitmapData.
	* @param {number} [width=256] - The width of the BitmapData in pixels. If undefined or zero it's set to a default value.
	* @param {number} [height=256] - The height of the BitmapData in pixels. If undefined or zero it's set to a default value.
	* @param {boolean} [skipPool=false] - When this BitmapData generates its internal canvas to use for rendering, it will get the canvas from the CanvasPool if false, or create its own if true.
	*/Phaser.BitmapData=function(game,key,width,height,skipPool){if(width===undefined||width===0){width=256;}if(height===undefined||height===0){height=256;}if(skipPool===undefined){skipPool=false;}/**
	    * @property {Phaser.Game} game - A reference to the currently running game.
	    */this.game=game;/**
	    * @property {string} key - The key of the BitmapData in the Cache, if stored there.
	    */this.key=key;/**
	    * @property {number} width - The width of the BitmapData in pixels.
	    */this.width=width;/**
	    * @property {number} height - The height of the BitmapData in pixels.
	    */this.height=height;/**
	    * @property {HTMLCanvasElement} canvas - The canvas to which this BitmapData draws.
	    * @default
	    */this.canvas=Phaser.Canvas.create(this,width,height,null,skipPool);/**
	    * @property {CanvasRenderingContext2D} context - The 2d context of the canvas.
	    * @default
	    */this.context=this.canvas.getContext('2d',{alpha:true});/**
	    * @property {CanvasRenderingContext2D} ctx - A reference to BitmapData.context.
	    */this.ctx=this.context;/**
	    * @property {string} smoothProperty - The context property needed for smoothing this Canvas.
	    */this.smoothProperty=game.renderType===Phaser.CANVAS?game.renderer.renderSession.smoothProperty:Phaser.Canvas.getSmoothingPrefix(this.context);/**
	    * @property {ImageData} imageData - The context image data.
	    * Please note that a call to BitmapData.draw() or BitmapData.copy() does not update immediately this property for performance reason. Use BitmapData.update() to do so.
	    * This property is updated automatically after the first game loop, according to the dirty flag property.
	    */this.imageData=this.context.getImageData(0,0,width,height);/**
	    * A Uint8ClampedArray view into BitmapData.buffer.
	    * Note that this is unavailable in some browsers (such as Epic Browser due to its security restrictions)
	    * @property {Uint8ClampedArray} data
	    */this.data=null;if(this.imageData){this.data=this.imageData.data;}/**
	    * @property {Uint32Array} pixels - An Uint32Array view into BitmapData.buffer.
	    */this.pixels=null;/**
	    * @property {ArrayBuffer} buffer - An ArrayBuffer the same size as the context ImageData.
	    */if(this.data){if(this.imageData.data.buffer){this.buffer=this.imageData.data.buffer;this.pixels=new Uint32Array(this.buffer);}else{if(window['ArrayBuffer']){this.buffer=new ArrayBuffer(this.imageData.data.length);this.pixels=new Uint32Array(this.buffer);}else{this.pixels=this.imageData.data;}}}/**
	    * @property {PIXI.BaseTexture} baseTexture - The PIXI.BaseTexture.
	    * @default
	    */this.baseTexture=new PIXI.BaseTexture(this.canvas);/**
	    * @property {PIXI.Texture} texture - The PIXI.Texture.
	    * @default
	    */this.texture=new PIXI.Texture(this.baseTexture);/**
	    * @property {Phaser.FrameData} frameData - The FrameData container this BitmapData uses for rendering.
	    */this.frameData=new Phaser.FrameData();/**
	    * @property {Phaser.Frame} textureFrame - The Frame this BitmapData uses for rendering.
	    * @default
	    */this.textureFrame=this.frameData.addFrame(new Phaser.Frame(0,0,0,width,height,'bitmapData'));this.texture.frame=this.textureFrame;/**
	    * @property {number} type - The const type of this object.
	    * @default
	    */this.type=Phaser.BITMAPDATA;/**
	    * @property {boolean} disableTextureUpload - If disableTextureUpload is true this BitmapData will never send its image data to the GPU when its dirty flag is true.
	    */this.disableTextureUpload=false;/**
	    * @property {boolean} dirty - If dirty this BitmapData will be re-rendered.
	    */this.dirty=false;//  Aliases
	this.cls=this.clear;/**
	    * @property {number} _image - Internal cache var.
	    * @private
	    */this._image=null;/**
	    * @property {Phaser.Point} _pos - Internal cache var.
	    * @private
	    */this._pos=new Phaser.Point();/**
	    * @property {Phaser.Point} _size - Internal cache var.
	    * @private
	    */this._size=new Phaser.Point();/**
	    * @property {Phaser.Point} _scale - Internal cache var.
	    * @private
	    */this._scale=new Phaser.Point();/**
	    * @property {number} _rotate - Internal cache var.
	    * @private
	    */this._rotate=0;/**
	    * @property {object} _alpha - Internal cache var.
	    * @private
	    */this._alpha={prev:1,current:1};/**
	    * @property {Phaser.Point} _anchor - Internal cache var.
	    * @private
	    */this._anchor=new Phaser.Point();/**
	    * @property {number} _tempR - Internal cache var.
	    * @private
	    */this._tempR=0;/**
	    * @property {number} _tempG - Internal cache var.
	    * @private
	    */this._tempG=0;/**
	    * @property {number} _tempB - Internal cache var.
	    * @private
	    */this._tempB=0;/**
	    * @property {Phaser.Circle} _circle - Internal cache var.
	    * @private
	    */this._circle=new Phaser.Circle();/**
	    * @property {HTMLCanvasElement} _swapCanvas - A swap canvas. Used by moveH and moveV, created in those methods.
	    * @private
	    */this._swapCanvas=undefined;};Phaser.BitmapData.prototype={/**
	    * Shifts the contents of this BitmapData by the distances given.
	    * 
	    * The image will wrap-around the edges on all sides if the wrap argument is true (the default).
	    *
	    * @method Phaser.BitmapData#move
	    * @param {integer} x - The amount of pixels to horizontally shift the canvas by. Use a negative value to shift to the left, positive to the right.
	    * @param {integer} y - The amount of pixels to vertically shift the canvas by. Use a negative value to shift up, positive to shift down.
	    * @param {boolean} [wrap=true] - Wrap the content of the BitmapData.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */move:function move(x,y,wrap){if(x!==0){this.moveH(x,wrap);}if(y!==0){this.moveV(y,wrap);}return this;},/**
	    * Shifts the contents of this BitmapData horizontally.
	    * 
	    * The image will wrap-around the sides if the wrap argument is true (the default).
	    *
	    * @method Phaser.BitmapData#moveH
	    * @param {integer} distance - The amount of pixels to horizontally shift the canvas by. Use a negative value to shift to the left, positive to the right.
	    * @param {boolean} [wrap=true] - Wrap the content of the BitmapData.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */moveH:function moveH(distance,wrap){if(wrap===undefined){wrap=true;}if(this._swapCanvas===undefined){this._swapCanvas=PIXI.CanvasPool.create(this,this.width,this.height);}var c=this._swapCanvas;var ctx=c.getContext('2d');var h=this.height;var src=this.canvas;ctx.clearRect(0,0,this.width,this.height);if(distance<0){distance=Math.abs(distance);//  Moving to the left
	var w=this.width-distance;//  Left-hand chunk
	if(wrap){ctx.drawImage(src,0,0,distance,h,w,0,distance,h);}//  Rest of the image
	ctx.drawImage(src,distance,0,w,h,0,0,w,h);}else{//  Moving to the right
	var w=this.width-distance;//  Right-hand chunk
	if(wrap){ctx.drawImage(src,w,0,distance,h,0,0,distance,h);}//  Rest of the image
	ctx.drawImage(src,0,0,w,h,distance,0,w,h);}this.clear();return this.copy(this._swapCanvas);},/**
	    * Shifts the contents of this BitmapData vertically.
	    * 
	    * The image will wrap-around the sides if the wrap argument is true (the default).
	    *
	    * @method Phaser.BitmapData#moveV
	    * @param {integer} distance - The amount of pixels to vertically shift the canvas by. Use a negative value to shift up, positive to shift down.
	    * @param {boolean} [wrap=true] - Wrap the content of the BitmapData.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */moveV:function moveV(distance,wrap){if(wrap===undefined){wrap=true;}if(this._swapCanvas===undefined){this._swapCanvas=PIXI.CanvasPool.create(this,this.width,this.height);}var c=this._swapCanvas;var ctx=c.getContext('2d');var w=this.width;var src=this.canvas;ctx.clearRect(0,0,this.width,this.height);if(distance<0){distance=Math.abs(distance);//  Moving up
	var h=this.height-distance;//  Top chunk
	if(wrap){ctx.drawImage(src,0,0,w,distance,0,h,w,distance);}//  Rest of the image
	ctx.drawImage(src,0,distance,w,h,0,0,w,h);}else{//  Moving down
	var h=this.height-distance;//  Bottom chunk
	if(wrap){ctx.drawImage(src,0,h,w,distance,0,0,w,distance);}//  Rest of the image
	ctx.drawImage(src,0,0,w,h,0,distance,w,h);}this.clear();return this.copy(this._swapCanvas);},/**
	    * Updates the given objects so that they use this BitmapData as their texture.
	    * This will replace any texture they will currently have set.
	    *
	    * @method Phaser.BitmapData#add
	    * @param {Phaser.Sprite|Phaser.Sprite[]|Phaser.Image|Phaser.Image[]} object - Either a single Sprite/Image or an Array of Sprites/Images.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */add:function add(object){if(Array.isArray(object)){for(var i=0;i<object.length;i++){if(object[i]['loadTexture']){object[i].loadTexture(this);}}}else{object.loadTexture(this);}return this;},/**
	    * Takes the given Game Object, resizes this BitmapData to match it and then draws it into this BitmapDatas canvas, ready for further processing.
	    * The source game object is not modified by this operation.
	    * If the source object uses a texture as part of a Texture Atlas or Sprite Sheet, only the current frame will be used for sizing.
	    * If a string is given it will assume it's a cache key and look in Phaser.Cache for an image key matching the string.
	    *
	    * @method Phaser.BitmapData#load
	    * @param {Phaser.Sprite|Phaser.Image|Phaser.Text|Phaser.BitmapData|Image|HTMLCanvasElement|string} source - The object that will be used to populate this BitmapData. If you give a string it will try and find the Image in the Game.Cache first.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */load:function load(source){if(typeof source==='string'){source=this.game.cache.getImage(source);}if(source){this.resize(source.width,source.height);this.cls();}else{return;}this.draw(source);this.update();return this;},/**
	    * Clears the BitmapData context using a clearRect.
	    *
	    * @method Phaser.BitmapData#cls
	    *//**
	    * Clears the BitmapData context using a clearRect.
	    *
	    * You can optionally define the area to clear.
	    * If the arguments are left empty it will clear the entire canvas.
	    *
	    * You may need to call BitmapData.update after this in order to clear out the pixel data, 
	    * but Phaser will not do this automatically for you.
	    *
	    * @method Phaser.BitmapData#clear
	    * @param {number} [x=0] - The x coordinate of the top-left of the area to clear.
	    * @param {number} [y=0] - The y coordinate of the top-left of the area to clear.
	    * @param {number} [width] - The width of the area to clear. If undefined it will use BitmapData.width.
	    * @param {number} [height] - The height of the area to clear. If undefined it will use BitmapData.height.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */clear:function clear(x,y,width,height){if(x===undefined){x=0;}if(y===undefined){y=0;}if(width===undefined){width=this.width;}if(height===undefined){height=this.height;}this.context.clearRect(x,y,width,height);this.dirty=true;return this;},/**
	    * Fills the BitmapData with the given color.
	    *
	    * @method Phaser.BitmapData#fill
	    * @param {number} r - The red color value, between 0 and 0xFF (255).
	    * @param {number} g - The green color value, between 0 and 0xFF (255).
	    * @param {number} b - The blue color value, between 0 and 0xFF (255).
	    * @param {number} [a=1] - The alpha color value, between 0 and 1.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */fill:function fill(r,g,b,a){if(a===undefined){a=1;}this.context.fillStyle='rgba('+r+','+g+','+b+','+a+')';this.context.fillRect(0,0,this.width,this.height);this.dirty=true;return this;},/**
	    * Creates a new Image element by converting this BitmapDatas canvas into a dataURL.
	    *
	    * The image is then stored in the image Cache using the key given.
	    *
	    * Finally a PIXI.Texture is created based on the image and returned.
	    *
	    * You can apply the texture to a sprite or any other supporting object by using either the
	    * key or the texture. First call generateTexture:
	    *
	    * `var texture = bitmapdata.generateTexture('ball');`
	    *
	    * Then you can either apply the texture to a sprite:
	    * 
	    * `game.add.sprite(0, 0, texture);`
	    *
	    * or by using the string based key:
	    *
	    * `game.add.sprite(0, 0, 'ball');`
	    *
	    * @method Phaser.BitmapData#generateTexture
	    * @param {string} key - The key which will be used to store the image in the Cache.
	    * @return {PIXI.Texture} The newly generated texture.
	    */generateTexture:function generateTexture(key){var image=new Image();image.src=this.canvas.toDataURL("image/png");var obj=this.game.cache.addImage(key,'',image);return new PIXI.Texture(obj.base);},/**
	    * Resizes the BitmapData. This changes the size of the underlying canvas and refreshes the buffer.
	    *
	    * @method Phaser.BitmapData#resize
	    * @param {integer} width - The new width of the BitmapData.
	    * @param {integer} height - The new height of the BitmapData.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */resize:function resize(width,height){if(width!==this.width||height!==this.height){this.width=width;this.height=height;this.canvas.width=width;this.canvas.height=height;if(this._swapCanvas!==undefined){this._swapCanvas.width=width;this._swapCanvas.height=height;}this.baseTexture.width=width;this.baseTexture.height=height;this.textureFrame.width=width;this.textureFrame.height=height;this.texture.width=width;this.texture.height=height;this.texture.crop.width=width;this.texture.crop.height=height;this.update();this.dirty=true;}return this;},/**
	    * This re-creates the BitmapData.imageData from the current context.
	    * It then re-builds the ArrayBuffer, the data Uint8ClampedArray reference and the pixels Int32Array.
	    * If not given the dimensions defaults to the full size of the context.
	    *
	    * Warning: This is a very expensive operation, so use it sparingly.
	    *
	    * @method Phaser.BitmapData#update
	    * @param {number} [x=0] - The x coordinate of the top-left of the image data area to grab from.
	    * @param {number} [y=0] - The y coordinate of the top-left of the image data area to grab from.
	    * @param {number} [width=1] - The width of the image data area.
	    * @param {number} [height=1] - The height of the image data area.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */update:function update(x,y,width,height){if(x===undefined){x=0;}if(y===undefined){y=0;}if(width===undefined){width=Math.max(1,this.width);}if(height===undefined){height=Math.max(1,this.height);}this.imageData=this.context.getImageData(x,y,width,height);this.data=this.imageData.data;if(this.imageData.data.buffer){this.buffer=this.imageData.data.buffer;this.pixels=new Uint32Array(this.buffer);}else{if(window['ArrayBuffer']){this.buffer=new ArrayBuffer(this.imageData.data.length);this.pixels=new Uint32Array(this.buffer);}else{this.pixels=this.imageData.data;}}return this;},/**
	    * Scans through the area specified in this BitmapData and sends a color object for every pixel to the given callback.
	    * The callback will be sent a color object with 6 properties: `{ r: number, g: number, b: number, a: number, color: number, rgba: string }`.
	    * Where r, g, b and a are integers between 0 and 255 representing the color component values for red, green, blue and alpha.
	    * The `color` property is an Int32 of the full color. Note the endianess of this will change per system.
	    * The `rgba` property is a CSS style rgba() string which can be used with context.fillStyle calls, among others.
	    * The callback will also be sent the pixels x and y coordinates respectively.
	    * The callback must return either `false`, in which case no change will be made to the pixel, or a new color object.
	    * If a new color object is returned the pixel will be set to the r, g, b and a color values given within it.
	    *
	    * @method Phaser.BitmapData#processPixelRGB
	    * @param {function} callback - The callback that will be sent each pixel color object to be processed.
	    * @param {object} callbackContext - The context under which the callback will be called.
	    * @param {number} [x=0] - The x coordinate of the top-left of the region to process from.
	    * @param {number} [y=0] - The y coordinate of the top-left of the region to process from.
	    * @param {number} [width] - The width of the region to process.
	    * @param {number} [height] - The height of the region to process.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */processPixelRGB:function processPixelRGB(callback,callbackContext,x,y,width,height){if(x===undefined){x=0;}if(y===undefined){y=0;}if(width===undefined){width=this.width;}if(height===undefined){height=this.height;}var w=x+width;var h=y+height;var pixel=Phaser.Color.createColor();var result={r:0,g:0,b:0,a:0};var dirty=false;for(var ty=y;ty<h;ty++){for(var tx=x;tx<w;tx++){Phaser.Color.unpackPixel(this.getPixel32(tx,ty),pixel);result=callback.call(callbackContext,pixel,tx,ty);if(result!==false&&result!==null&&result!==undefined){this.setPixel32(tx,ty,result.r,result.g,result.b,result.a,false);dirty=true;}}}if(dirty){this.context.putImageData(this.imageData,0,0);this.dirty=true;}return this;},/**
	    * Scans through the area specified in this BitmapData and sends the color for every pixel to the given callback along with its x and y coordinates.
	    * Whatever value the callback returns is set as the new color for that pixel, unless it returns the same color, in which case it's skipped.
	    * Note that the format of the color received will be different depending on if the system is big or little endian.
	    * It is expected that your callback will deal with endianess. If you'd rather Phaser did it then use processPixelRGB instead.
	    * The callback will also be sent the pixels x and y coordinates respectively.
	    *
	    * @method Phaser.BitmapData#processPixel
	    * @param {function} callback - The callback that will be sent each pixel color to be processed.
	    * @param {object} callbackContext - The context under which the callback will be called.
	    * @param {number} [x=0] - The x coordinate of the top-left of the region to process from.
	    * @param {number} [y=0] - The y coordinate of the top-left of the region to process from.
	    * @param {number} [width] - The width of the region to process.
	    * @param {number} [height] - The height of the region to process.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */processPixel:function processPixel(callback,callbackContext,x,y,width,height){if(x===undefined){x=0;}if(y===undefined){y=0;}if(width===undefined){width=this.width;}if(height===undefined){height=this.height;}var w=x+width;var h=y+height;var pixel=0;var result=0;var dirty=false;for(var ty=y;ty<h;ty++){for(var tx=x;tx<w;tx++){pixel=this.getPixel32(tx,ty);result=callback.call(callbackContext,pixel,tx,ty);if(result!==pixel){this.pixels[ty*this.width+tx]=result;dirty=true;}}}if(dirty){this.context.putImageData(this.imageData,0,0);this.dirty=true;}return this;},/**
	    * Replaces all pixels matching one color with another. The color values are given as two sets of RGBA values.
	    * An optional region parameter controls if the replacement happens in just a specific area of the BitmapData or the entire thing. 
	    *
	    * @method Phaser.BitmapData#replaceRGB
	    * @param {number} r1 - The red color value to be replaced. Between 0 and 255.
	    * @param {number} g1 - The green color value to be replaced. Between 0 and 255.
	    * @param {number} b1 - The blue color value to be replaced. Between 0 and 255.
	    * @param {number} a1 - The alpha color value to be replaced. Between 0 and 255.
	    * @param {number} r2 - The red color value that is the replacement color. Between 0 and 255.
	    * @param {number} g2 - The green color value that is the replacement color. Between 0 and 255.
	    * @param {number} b2 - The blue color value that is the replacement color. Between 0 and 255.
	    * @param {number} a2 - The alpha color value that is the replacement color. Between 0 and 255.
	    * @param {Phaser.Rectangle} [region] - The area to perform the search over. If not given it will replace over the whole BitmapData.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */replaceRGB:function replaceRGB(r1,g1,b1,a1,r2,g2,b2,a2,region){var sx=0;var sy=0;var w=this.width;var h=this.height;var source=Phaser.Color.packPixel(r1,g1,b1,a1);if(region!==undefined&&region instanceof Phaser.Rectangle){sx=region.x;sy=region.y;w=region.width;h=region.height;}for(var y=0;y<h;y++){for(var x=0;x<w;x++){if(this.getPixel32(sx+x,sy+y)===source){this.setPixel32(sx+x,sy+y,r2,g2,b2,a2,false);}}}this.context.putImageData(this.imageData,0,0);this.dirty=true;return this;},/**
	    * Sets the hue, saturation and lightness values on every pixel in the given region, or the whole BitmapData if no region was specified.
	    *
	    * @method Phaser.BitmapData#setHSL
	    * @param {number} [h=null] - The hue, in the range 0 - 1.
	    * @param {number} [s=null] - The saturation, in the range 0 - 1.
	    * @param {number} [l=null] - The lightness, in the range 0 - 1.
	    * @param {Phaser.Rectangle} [region] - The area to perform the operation on. If not given it will run over the whole BitmapData.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */setHSL:function setHSL(h,s,l,region){var bHaveH=h||h===0;var bHaveS=s||s===0;var bHaveL=l||l===0;if(!bHaveH&&!bHaveS&&!bHaveL){return;}if(region===undefined){region=new Phaser.Rectangle(0,0,this.width,this.height);}var pixel=Phaser.Color.createColor();for(var y=region.y;y<region.bottom;y++){for(var x=region.x;x<region.right;x++){Phaser.Color.unpackPixel(this.getPixel32(x,y),pixel,true);if(bHaveH){pixel.h=h;}if(bHaveS){pixel.s=s;}if(bHaveL){pixel.l=l;}Phaser.Color.HSLtoRGB(pixel.h,pixel.s,pixel.l,pixel);this.setPixel32(x,y,pixel.r,pixel.g,pixel.b,pixel.a,false);}}this.context.putImageData(this.imageData,0,0);this.dirty=true;return this;},/**
	    * Shifts any or all of the hue, saturation and lightness values on every pixel in the given region, or the whole BitmapData if no region was specified.
	    * Shifting will add the given value onto the current h, s and l values, not replace them.
	    * The hue is wrapped to keep it within the range 0 to 1. Saturation and lightness are clamped to not exceed 1.
	    *
	    * @method Phaser.BitmapData#shiftHSL
	    * @param {number} [h=null] - The amount to shift the hue by.
	    * @param {number} [s=null] - The amount to shift the saturation by.
	    * @param {number} [l=null] - The amount to shift the lightness by.
	    * @param {Phaser.Rectangle} [region] - The area to perform the operation on. If not given it will run over the whole BitmapData.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */shiftHSL:function shiftHSL(h,s,l,region){if(h===undefined||h===null){h=false;}if(s===undefined||s===null){s=false;}if(l===undefined||l===null){l=false;}if(!h&&!s&&!l){return;}if(region===undefined){region=new Phaser.Rectangle(0,0,this.width,this.height);}var pixel=Phaser.Color.createColor();for(var y=region.y;y<region.bottom;y++){for(var x=region.x;x<region.right;x++){Phaser.Color.unpackPixel(this.getPixel32(x,y),pixel,true);if(h){pixel.h=this.game.math.wrap(pixel.h+h,0,1);}if(s){pixel.s=this.game.math.clamp(pixel.s+s,0,1);}if(l){pixel.l=this.game.math.clamp(pixel.l+l,0,1);}Phaser.Color.HSLtoRGB(pixel.h,pixel.s,pixel.l,pixel);this.setPixel32(x,y,pixel.r,pixel.g,pixel.b,pixel.a,false);}}this.context.putImageData(this.imageData,0,0);this.dirty=true;return this;},/**
	    * Sets the color of the given pixel to the specified red, green, blue and alpha values.
	    *
	    * @method Phaser.BitmapData#setPixel32
	    * @param {number} x - The x coordinate of the pixel to be set. Must lay within the dimensions of this BitmapData.
	    * @param {number} y - The y coordinate of the pixel to be set. Must lay within the dimensions of this BitmapData.
	    * @param {number} red - The red color value, between 0 and 0xFF (255).
	    * @param {number} green - The green color value, between 0 and 0xFF (255).
	    * @param {number} blue - The blue color value, between 0 and 0xFF (255).
	    * @param {number} alpha - The alpha color value, between 0 and 0xFF (255).
	    * @param {boolean} [immediate=true] - If `true` the context.putImageData will be called and the dirty flag set.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */setPixel32:function setPixel32(x,y,red,green,blue,alpha,immediate){if(immediate===undefined){immediate=true;}if(x>=0&&x<=this.width&&y>=0&&y<=this.height){if(Phaser.Device.LITTLE_ENDIAN){this.pixels[y*this.width+x]=alpha<<24|blue<<16|green<<8|red;}else{this.pixels[y*this.width+x]=red<<24|green<<16|blue<<8|alpha;}if(immediate){this.context.putImageData(this.imageData,0,0);this.dirty=true;}}return this;},/**
	    * Sets the color of the given pixel to the specified red, green and blue values.
	    *
	    * @method Phaser.BitmapData#setPixel
	    * @param {number} x - The x coordinate of the pixel to be set. Must lay within the dimensions of this BitmapData.
	    * @param {number} y - The y coordinate of the pixel to be set. Must lay within the dimensions of this BitmapData.
	    * @param {number} red - The red color value, between 0 and 0xFF (255).
	    * @param {number} green - The green color value, between 0 and 0xFF (255).
	    * @param {number} blue - The blue color value, between 0 and 0xFF (255).
	    * @param {boolean} [immediate=true] - If `true` the context.putImageData will be called and the dirty flag set.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */setPixel:function setPixel(x,y,red,green,blue,immediate){return this.setPixel32(x,y,red,green,blue,255,immediate);},/**
	    * Get the color of a specific pixel in the context into a color object.
	    * If you have drawn anything to the BitmapData since it was created you must call BitmapData.update to refresh the array buffer,
	    * otherwise this may return out of date color values, or worse - throw a run-time error as it tries to access an array element that doesn't exist.
	    *
	    * @method Phaser.BitmapData#getPixel
	    * @param {number} x - The x coordinate of the pixel to be set. Must lay within the dimensions of this BitmapData.
	    * @param {number} y - The y coordinate of the pixel to be set. Must lay within the dimensions of this BitmapData.
	    * @param {object} [out] - An object into which 4 properties will be created: r, g, b and a. If not provided a new object will be created.
	    * @return {object} An object with the red, green, blue and alpha values set in the r, g, b and a properties.
	    */getPixel:function getPixel(x,y,out){if(!out){out=Phaser.Color.createColor();}var index=~~(x+y*this.width);index*=4;out.r=this.data[index];out.g=this.data[++index];out.b=this.data[++index];out.a=this.data[++index];return out;},/**
	    * Get the color of a specific pixel including its alpha value.
	    * If you have drawn anything to the BitmapData since it was created you must call BitmapData.update to refresh the array buffer,
	    * otherwise this may return out of date color values, or worse - throw a run-time error as it tries to access an array element that doesn't exist.
	    * Note that on little-endian systems the format is 0xAABBGGRR and on big-endian the format is 0xRRGGBBAA.
	    *
	    * @method Phaser.BitmapData#getPixel32
	    * @param {number} x - The x coordinate of the pixel to be set. Must lay within the dimensions of this BitmapData.
	    * @param {number} y - The y coordinate of the pixel to be set. Must lay within the dimensions of this BitmapData.
	    * @return {number} A native color value integer (format: 0xAARRGGBB)
	    */getPixel32:function getPixel32(x,y){if(x>=0&&x<=this.width&&y>=0&&y<=this.height){return this.pixels[y*this.width+x];}},/**
	    * Get the color of a specific pixel including its alpha value as a color object containing r,g,b,a and rgba properties.
	    * If you have drawn anything to the BitmapData since it was created you must call BitmapData.update to refresh the array buffer,
	    * otherwise this may return out of date color values, or worse - throw a run-time error as it tries to access an array element that doesn't exist.
	    *
	    * @method Phaser.BitmapData#getPixelRGB
	    * @param {number} x - The x coordinate of the pixel to be set. Must lay within the dimensions of this BitmapData.
	    * @param {number} y - The y coordinate of the pixel to be set. Must lay within the dimensions of this BitmapData.
	    * @param {object} [out] - An object into which 3 properties will be created: r, g and b. If not provided a new object will be created.
	    * @param {boolean} [hsl=false] - Also convert the rgb values into hsl?
	    * @param {boolean} [hsv=false] - Also convert the rgb values into hsv?
	    * @return {object} An object with the red, green and blue values set in the r, g and b properties.
	    */getPixelRGB:function getPixelRGB(x,y,out,hsl,hsv){return Phaser.Color.unpackPixel(this.getPixel32(x,y),out,hsl,hsv);},/**
	    * Gets all the pixels from the region specified by the given Rectangle object.
	    *
	    * @method Phaser.BitmapData#getPixels
	    * @param {Phaser.Rectangle} rect - The Rectangle region to get.
	    * @return {ImageData} Returns a ImageData object containing a Uint8ClampedArray data property.
	    */getPixels:function getPixels(rect){return this.context.getImageData(rect.x,rect.y,rect.width,rect.height);},/**
	    * Scans the BitmapData, pixel by pixel, until it encounters a pixel that isn't transparent (i.e. has an alpha value > 0).
	    * It then stops scanning and returns an object containing the color of the pixel in r, g and b properties and the location in the x and y properties.
	    * 
	    * The direction parameter controls from which direction it should start the scan:
	    * 
	    * 0 = top to bottom
	    * 1 = bottom to top
	    * 2 = left to right
	    * 3 = right to left
	    *
	    * @method Phaser.BitmapData#getFirstPixel
	    * @param {number} [direction=0] - The direction in which to scan for the first pixel. 0 = top to bottom, 1 = bottom to top, 2 = left to right and 3 = right to left.
	    * @return {object} Returns an object containing the color of the pixel in the `r`, `g` and `b` properties and the location in the `x` and `y` properties.
	    */getFirstPixel:function getFirstPixel(direction){if(direction===undefined){direction=0;}var pixel=Phaser.Color.createColor();var x=0;var y=0;var v=1;var scan=false;if(direction===1){v=-1;y=this.height;}else if(direction===3){v=-1;x=this.width;}do{Phaser.Color.unpackPixel(this.getPixel32(x,y),pixel);if(direction===0||direction===1){//  Top to Bottom / Bottom to Top
	x++;if(x===this.width){x=0;y+=v;if(y>=this.height||y<=0){scan=true;}}}else if(direction===2||direction===3){//  Left to Right / Right to Left
	y++;if(y===this.height){y=0;x+=v;if(x>=this.width||x<=0){scan=true;}}}}while(pixel.a===0&&!scan);pixel.x=x;pixel.y=y;return pixel;},/**
	    * Scans the BitmapData and calculates the bounds. This is a rectangle that defines the extent of all non-transparent pixels.
	    * The rectangle returned will extend from the top-left of the image to the bottom-right, excluding transparent pixels.
	    *
	    * @method Phaser.BitmapData#getBounds
	    * @param {Phaser.Rectangle} [rect] - If provided this Rectangle object will be populated with the bounds, otherwise a new object will be created.
	    * @return {Phaser.Rectangle} A Rectangle whose dimensions encompass the full extent of non-transparent pixels in this BitmapData.
	    */getBounds:function getBounds(rect){if(rect===undefined){rect=new Phaser.Rectangle();}rect.x=this.getFirstPixel(2).x;//  If we hit this, there's no point scanning any more, the image is empty
	if(rect.x===this.width){return rect.setTo(0,0,0,0);}rect.y=this.getFirstPixel(0).y;rect.width=this.getFirstPixel(3).x-rect.x+1;rect.height=this.getFirstPixel(1).y-rect.y+1;return rect;},/**
	    * Creates a new Phaser.Image object, assigns this BitmapData to be its texture, adds it to the world then returns it.
	    *
	    * @method Phaser.BitmapData#addToWorld
	    * @param {number} [x=0] - The x coordinate to place the Image at.
	    * @param {number} [y=0] - The y coordinate to place the Image at.
	    * @param {number} [anchorX=0] - Set the x anchor point of the Image. A value between 0 and 1, where 0 is the top-left and 1 is bottom-right.
	    * @param {number} [anchorY=0] - Set the y anchor point of the Image. A value between 0 and 1, where 0 is the top-left and 1 is bottom-right.
	    * @param {number} [scaleX=1] - The horizontal scale factor of the Image. A value of 1 means no scaling. 2 would be twice the size, and so on.
	    * @param {number} [scaleY=1] - The vertical scale factor of the Image. A value of 1 means no scaling. 2 would be twice the size, and so on.
	    * @return {Phaser.Image} The newly added Image object.
	    */addToWorld:function addToWorld(x,y,anchorX,anchorY,scaleX,scaleY){scaleX=scaleX||1;scaleY=scaleY||1;var image=this.game.add.image(x,y,this);image.anchor.set(anchorX,anchorY);image.scale.set(scaleX,scaleY);return image;},/**
	     * Copies a rectangular area from the source object to this BitmapData. If you give `null` as the source it will copy from itself.
	     * 
	     * You can optionally resize, translate, rotate, scale, alpha or blend as it's drawn.
	     * 
	     * All rotation, scaling and drawing takes place around the regions center point by default, but can be changed with the anchor parameters.
	     * 
	     * Note that the source image can also be this BitmapData, which can create some interesting effects.
	     * 
	     * This method has a lot of parameters for maximum control.
	     * You can use the more friendly methods like `copyRect` and `draw` to avoid having to remember them all.
	     * 
	     * You may prefer to use `copyTransform` if you're simply trying to draw a Sprite to this BitmapData,
	     * and don't wish to translate, scale or rotate it from its original values.
	     *
	     * @method Phaser.BitmapData#copy
	     * @param {Phaser.Sprite|Phaser.Image|Phaser.Text|Phaser.BitmapData|Phaser.RenderTexture|Image|HTMLCanvasElement|string} [source] - The source to copy from. If you give a string it will try and find the Image in the Game.Cache first. This is quite expensive so try to provide the image itself.
	     * @param {number} [x=0] - The x coordinate representing the top-left of the region to copy from the source image.
	     * @param {number} [y=0] - The y coordinate representing the top-left of the region to copy from the source image.
	     * @param {number} [width] - The width of the region to copy from the source image. If not specified it will use the full source image width.
	     * @param {number} [height] - The height of the region to copy from the source image. If not specified it will use the full source image height.
	     * @param {number} [tx] - The x coordinate to translate to before drawing. If not specified it will default to the `x` parameter. If `null` and `source` is a Display Object, it will default to `source.x`.
	     * @param {number} [ty] - The y coordinate to translate to before drawing. If not specified it will default to the `y` parameter. If `null` and `source` is a Display Object, it will default to `source.y`.
	     * @param {number} [newWidth] - The new width of the block being copied. If not specified it will default to the `width` parameter.
	     * @param {number} [newHeight] - The new height of the block being copied. If not specified it will default to the `height` parameter.
	     * @param {number} [rotate=0] - The angle in radians to rotate the block to before drawing. Rotation takes place around the center by default, but can be changed with the `anchor` parameters.
	     * @param {number} [anchorX=0] - The anchor point around which the block is rotated and scaled. A value between 0 and 1, where 0 is the top-left and 1 is bottom-right.
	     * @param {number} [anchorY=0] - The anchor point around which the block is rotated and scaled. A value between 0 and 1, where 0 is the top-left and 1 is bottom-right.
	     * @param {number} [scaleX=1] - The horizontal scale factor of the block. A value of 1 means no scaling. 2 would be twice the size, and so on.
	     * @param {number} [scaleY=1] - The vertical scale factor of the block. A value of 1 means no scaling. 2 would be twice the size, and so on.
	     * @param {number} [alpha=1] - The alpha that will be set on the context before drawing. A value between 0 (fully transparent) and 1, opaque.
	     * @param {string} [blendMode=null] - The composite blend mode that will be used when drawing. The default is no blend mode at all. This is a Canvas globalCompositeOperation value such as 'lighter' or 'xor'.
	     * @param {boolean} [roundPx=false] - Should the x and y values be rounded to integers before drawing? This prevents anti-aliasing in some instances.
	     * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	     */copy:function copy(source,x,y,width,height,tx,ty,newWidth,newHeight,rotate,anchorX,anchorY,scaleX,scaleY,alpha,blendMode,roundPx){if(source===undefined||source===null){source=this;}if(source instanceof Phaser.RenderTexture||source instanceof PIXI.RenderTexture){source=source.getCanvas();}this._image=source;if(source instanceof Phaser.Sprite||source instanceof Phaser.Image||source instanceof Phaser.Text||source instanceof PIXI.Sprite){//  Copy over sprite values
	this._pos.set(source.texture.crop.x,source.texture.crop.y);this._size.set(source.texture.crop.width,source.texture.crop.height);this._scale.set(source.scale.x,source.scale.y);this._anchor.set(source.anchor.x,source.anchor.y);this._rotate=source.rotation;this._alpha.current=source.alpha;if(source.texture instanceof Phaser.RenderTexture||source.texture instanceof PIXI.RenderTexture){this._image=source.texture.getCanvas();}else{this._image=source.texture.baseTexture.source;}if(tx===undefined||tx===null){tx=source.x;}if(ty===undefined||ty===null){ty=source.y;}if(source.texture.trim){//  Offset the translation coordinates by the trim amount
	tx+=source.texture.trim.x-source.anchor.x*source.texture.trim.width;ty+=source.texture.trim.y-source.anchor.y*source.texture.trim.height;}if(source.tint!==0xFFFFFF){if(source.cachedTint!==source.tint){source.cachedTint=source.tint;source.tintedTexture=PIXI.CanvasTinter.getTintedTexture(source,source.tint);}this._image=source.tintedTexture;this._pos.set(0);}}else{//  Reset
	this._pos.set(0);this._scale.set(1);this._anchor.set(0);this._rotate=0;this._alpha.current=1;if(source instanceof Phaser.BitmapData){this._image=source.canvas;}else if(typeof source==='string'){source=this.game.cache.getImage(source);if(source===null){return;}else{this._image=source;}}this._size.set(this._image.width,this._image.height);}//  The source region to copy from
	if(x===undefined||x===null){x=0;}if(y===undefined||y===null){y=0;}//  If they set a width/height then we override the frame values with them
	if(width){this._size.x=width;}if(height){this._size.y=height;}//  The destination region to copy to
	if(tx===undefined||tx===null){tx=x;}if(ty===undefined||ty===null){ty=y;}if(newWidth===undefined||newWidth===null){newWidth=this._size.x;}if(newHeight===undefined||newHeight===null){newHeight=this._size.y;}//  Rotation - if set this will override any potential Sprite value
	if(typeof rotate==='number'){this._rotate=rotate;}//  Anchor - if set this will override any potential Sprite value
	if(typeof anchorX==='number'){this._anchor.x=anchorX;}if(typeof anchorY==='number'){this._anchor.y=anchorY;}//  Scaling - if set this will override any potential Sprite value
	if(typeof scaleX==='number'){this._scale.x=scaleX;}if(typeof scaleY==='number'){this._scale.y=scaleY;}//  Effects
	if(typeof alpha==='number'){this._alpha.current=alpha;}if(blendMode===undefined){blendMode=null;}if(roundPx===undefined){roundPx=false;}if(this._alpha.current<=0||this._scale.x===0||this._scale.y===0||this._size.x===0||this._size.y===0){//  Why bother wasting CPU cycles drawing something you can't see?
	return;}var ctx=this.context;this._alpha.prev=ctx.globalAlpha;ctx.save();ctx.globalAlpha=this._alpha.current;if(blendMode){this.op=blendMode;}if(roundPx){tx|=0;ty|=0;}//  Doesn't work fully with children, or nested scale + rotation transforms (see copyTransform)
	ctx.translate(tx,ty);ctx.scale(this._scale.x,this._scale.y);ctx.rotate(this._rotate);ctx.drawImage(this._image,this._pos.x+x,this._pos.y+y,this._size.x,this._size.y,-newWidth*this._anchor.x,-newHeight*this._anchor.y,newWidth,newHeight);//  Carry on ...
	ctx.restore();ctx.globalAlpha=this._alpha.prev;this.dirty=true;return this;},/**
	    * Draws the given `source` Game Object to this BitmapData, using its `worldTransform` property to set the
	    * position, scale and rotation of where it is drawn. This function is used internally by `drawGroup`.
	    * It takes the objects tint and scale mode into consideration before drawing.
	    *
	    * You can optionally specify Blend Mode and Round Pixels arguments.
	    * 
	    * @method Phaser.BitmapData#copyTransform
	    * @param {Phaser.Sprite|Phaser.Image|Phaser.Text|Phaser.BitmapData|Phaser.BitmapText} [source] - The Game Object to draw.
	    * @param {string} [blendMode=null] - The composite blend mode that will be used when drawing. The default is no blend mode at all. This is a Canvas globalCompositeOperation value such as 'lighter' or 'xor'.
	    * @param {boolean} [roundPx=false] - Should the x and y values be rounded to integers before drawing? This prevents anti-aliasing in some instances.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */copyTransform:function copyTransform(source,blendMode,roundPx){if(blendMode===undefined){blendMode=null;}if(roundPx===undefined){roundPx=false;}if(!source.hasOwnProperty('worldTransform')||!source.worldVisible||source.worldAlpha===0){return this;}var wt=source.worldTransform;this._pos.set(source.texture.crop.x,source.texture.crop.y);this._size.set(source.texture.crop.width,source.texture.crop.height);if(wt.a===0||wt.d===0||this._size.x===0||this._size.y===0){// Why bother wasting CPU cycles drawing something you can't see?
	return this;}if(source.texture instanceof Phaser.RenderTexture||source.texture instanceof PIXI.RenderTexture){this._image=source.texture.getCanvas();}else{this._image=source.texture.baseTexture.source;}var tx=wt.tx;var ty=wt.ty;if(source.texture.trim){//  Offset the translation coordinates by the trim amount
	tx+=source.texture.trim.x-source.anchor.x*source.texture.trim.width;ty+=source.texture.trim.y-source.anchor.y*source.texture.trim.height;}if(source.tint!==0xFFFFFF){if(source.cachedTint!==source.tint){source.cachedTint=source.tint;source.tintedTexture=PIXI.CanvasTinter.getTintedTexture(source,source.tint);}this._image=source.tintedTexture;this._pos.set(0);}if(roundPx){tx|=0;ty|=0;}var ctx=this.context;this._alpha.prev=ctx.globalAlpha;ctx.save();ctx.globalAlpha=this._alpha.current;if(blendMode){this.op=blendMode;}ctx[this.smoothProperty]=source.texture.baseTexture.scaleMode===PIXI.scaleModes.LINEAR;ctx.setTransform(wt.a,wt.b,wt.c,wt.d,tx,ty);ctx.drawImage(this._image,this._pos.x,this._pos.y,this._size.x,this._size.y,-this._size.x*source.anchor.x,-this._size.y*source.anchor.y,this._size.x,this._size.y);ctx.restore();ctx.globalAlpha=this._alpha.prev;this.dirty=true;return this;},/**
	    * Copies the area defined by the Rectangle parameter from the source image to this BitmapData at the given location.
	    *
	    * @method Phaser.BitmapData#copyRect
	    * @param {Phaser.Sprite|Phaser.Image|Phaser.Text|Phaser.BitmapData|Phaser.RenderTexture|Image|string} source - The Image to copy from. If you give a string it will try and find the Image in the Game.Cache.
	    * @param {Phaser.Rectangle} area - The Rectangle region to copy from the source image.
	    * @param {number} x - The destination x coordinate to copy the image to.
	    * @param {number} y - The destination y coordinate to copy the image to.
	    * @param {number} [alpha=1] - The alpha that will be set on the context before drawing. A value between 0 (fully transparent) and 1, opaque.
	    * @param {string} [blendMode=null] - The composite blend mode that will be used when drawing. The default is no blend mode at all. This is a Canvas globalCompositeOperation value such as 'lighter' or 'xor'.
	    * @param {boolean} [roundPx=false] - Should the x and y values be rounded to integers before drawing? This prevents anti-aliasing in some instances.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */copyRect:function copyRect(source,area,x,y,alpha,blendMode,roundPx){return this.copy(source,area.x,area.y,area.width,area.height,x,y,area.width,area.height,0,0,0,1,1,alpha,blendMode,roundPx);},/**
	    * Draws the given Phaser.Sprite, Phaser.Image or Phaser.Text to this BitmapData at the coordinates specified.
	    * You can use the optional width and height values to 'stretch' the sprite as it is drawn. This uses drawImage stretching, not scaling.
	    * 
	    * The children will be drawn at their `x` and `y` world space coordinates. If this is outside the bounds of the BitmapData they won't be visible.
	    * When drawing it will take into account the rotation, scale, scaleMode, alpha and tint values.
	    * 
	    * Note: You should ensure that at least 1 full update has taken place before calling this, 
	    * otherwise the objects are likely to render incorrectly, if at all.
	    * You can trigger an update yourself by calling `stage.updateTransform()` before calling `draw`.
	    *
	    * @method Phaser.BitmapData#draw
	    * @param {Phaser.Sprite|Phaser.Image|Phaser.Text|Phaser.RenderTexture} source - The Sprite, Image or Text object to draw onto this BitmapData.
	    * @param {number} [x=0] - The x coordinate to translate to before drawing. If not specified it will default to `source.x`.
	    * @param {number} [y=0] - The y coordinate to translate to before drawing. If not specified it will default to `source.y`.
	    * @param {number} [width] - The new width of the Sprite being copied. If not specified it will default to `source.width`.
	    * @param {number} [height] - The new height of the Sprite being copied. If not specified it will default to `source.height`.
	    * @param {string} [blendMode=null] - The composite blend mode that will be used when drawing. The default is no blend mode at all. This is a Canvas globalCompositeOperation value such as 'lighter' or 'xor'.
	    * @param {boolean} [roundPx=false] - Should the x and y values be rounded to integers before drawing? This prevents anti-aliasing in some instances.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */draw:function draw(source,x,y,width,height,blendMode,roundPx){//  By specifying null for most parameters it will tell `copy` to use the Sprite values instead, which is what we want here
	return this.copy(source,null,null,null,null,x,y,width,height,null,null,null,null,null,null,blendMode,roundPx);},/**
	    * Draws the immediate children of a Phaser.Group to this BitmapData.
	    * 
	    * It's perfectly valid to pass in `game.world` as the Group, and it will iterate through the entire display list.
	    * 
	    * Children are drawn _only_ if they have their `exists` property set to `true`, and have image, or RenderTexture, based Textures.
	    * 
	    * The children will be drawn at their `x` and `y` world space coordinates. If this is outside the bounds of the BitmapData they won't be visible.
	    * When drawing it will take into account the rotation, scale, scaleMode, alpha and tint values.
	    * 
	    * Note: You should ensure that at least 1 full update has taken place before calling this, 
	    * otherwise the objects are likely to render incorrectly, if at all.
	    * You can trigger an update yourself by calling `stage.updateTransform()` before calling `drawGroup`.
	    *
	    * @method Phaser.BitmapData#drawGroup
	    * @param {Phaser.Group} group - The Group to draw onto this BitmapData. Can also be Phaser.World.
	    * @param {string} [blendMode=null] - The composite blend mode that will be used when drawing. The default is no blend mode at all. This is a Canvas globalCompositeOperation value such as 'lighter' or 'xor'.
	    * @param {boolean} [roundPx=false] - Should the x and y values be rounded to integers before drawing? This prevents anti-aliasing in some instances.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */drawGroup:function drawGroup(group,blendMode,roundPx){if(group.total>0){group.forEachExists(this.drawGroupProxy,this,blendMode,roundPx);}return this;},/**
	    * A proxy for drawGroup that handles child iteration for more complex Game Objects.
	    * 
	    * @method Phaser.BitmapData#drawGroupProxy
	    * @private
	    * @param {Phaser.Sprite|Phaser.Image|Phaser.BitmapText} child - The child to draw.
	    * @param {string} [blendMode=null] - The composite blend mode that will be used when drawing. The default is no blend mode at all. This is a Canvas globalCompositeOperation value such as 'lighter' or 'xor'.
	    * @param {boolean} [roundPx=false] - Should the x and y values be rounded to integers before drawing? This prevents anti-aliasing in some instances.
	    */drawGroupProxy:function drawGroupProxy(child,blendMode,roundPx){if(child.hasOwnProperty('texture')){this.copyTransform(child,blendMode,roundPx);}if(child.type===Phaser.GROUP&&child.exists){this.drawGroup(child,blendMode,roundPx);}else{if(child.hasOwnProperty('children')&&child.children.length>0){for(var i=0;i<child.children.length;i++){if(child.children[i].exists){this.copyTransform(child.children[i],blendMode,roundPx);}}}}},/**
	    * Draws the Game Object or Group to this BitmapData and then recursively iterates through all of its children.
	    * 
	    * If a child has an `exists` property then it (and its children) will be only be drawn if exists is `true`.
	    * 
	    * The children will be drawn at their `x` and `y` world space coordinates. If this is outside the bounds of the BitmapData 
	    * they won't be drawn. Depending on your requirements you may need to resize the BitmapData in advance to match the 
	    * bounds of the top-level Game Object.
	    * 
	    * When drawing it will take into account the child's world rotation, scale and alpha values.
	    *
	    * It's perfectly valid to pass in `game.world` as the parent object, and it will iterate through the entire display list.
	    * 
	    * Note: If you are trying to grab your entire game at the start of a State then you should ensure that at least 1 full update
	    * has taken place before doing so, otherwise all of the objects will render with incorrect positions and scales. You can 
	    * trigger an update yourself by calling `stage.updateTransform()` before calling `drawFull`.
	    *
	    * @method Phaser.BitmapData#drawFull
	    * @param {Phaser.World|Phaser.Group|Phaser.Sprite|Phaser.Image|Phaser.Text|Phaser.BitmapText} parent - The Game Object to draw onto this BitmapData and then recursively draw all of its children.
	    * @param {string} [blendMode=null] - The composite blend mode that will be used when drawing. The default is no blend mode at all. This is a Canvas globalCompositeOperation value such as 'lighter' or 'xor'.
	    * @param {boolean} [roundPx=false] - Should the x and y values be rounded to integers before drawing? This prevents anti-aliasing in some instances.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */drawFull:function drawFull(parent,blendMode,roundPx){if(parent.worldVisible===false||parent.worldAlpha===0||parent.hasOwnProperty('exists')&&parent.exists===false){return this;}if(parent.type!==Phaser.GROUP&&parent.type!==Phaser.EMITTER&&parent.type!==Phaser.BITMAPTEXT){if(parent.type===Phaser.GRAPHICS){var bounds=parent.getBounds();this.ctx.save();this.ctx.translate(bounds.x,bounds.y);PIXI.CanvasGraphics.renderGraphics(parent,this.ctx);this.ctx.restore();}else{this.copy(parent,null,null,null,null,parent.worldPosition.x,parent.worldPosition.y,null,null,parent.worldRotation,null,null,parent.worldScale.x,parent.worldScale.y,parent.worldAlpha,blendMode,roundPx);}}if(parent.children){for(var i=0;i<parent.children.length;i++){this.drawFull(parent.children[i],blendMode,roundPx);}}return this;},/**
	    * Sets the shadow properties of this BitmapDatas context which will affect all draw operations made to it.
	    * You can cancel an existing shadow by calling this method and passing no parameters.
	    * Note: At the time of writing (October 2014) Chrome still doesn't support shadowBlur used with drawImage.
	    *
	    * @method Phaser.BitmapData#shadow
	    * @param {string} color - The color of the shadow, given in a CSS format, i.e. `#000000` or `rgba(0,0,0,1)`. If `null` or `undefined` the shadow will be reset.
	    * @param {number} [blur=5] - The amount the shadow will be blurred by. Low values = a crisp shadow, high values = a softer shadow.
	    * @param {number} [x=10] - The horizontal offset of the shadow in pixels.
	    * @param {number} [y=10] - The vertical offset of the shadow in pixels.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */shadow:function shadow(color,blur,x,y){var ctx=this.context;if(color===undefined||color===null){ctx.shadowColor='rgba(0,0,0,0)';}else{ctx.shadowColor=color;ctx.shadowBlur=blur||5;ctx.shadowOffsetX=x||10;ctx.shadowOffsetY=y||10;}return this;},/**
	    * Draws the image onto this BitmapData using an image as an alpha mask.
	    *
	    * @method Phaser.BitmapData#alphaMask
	    * @param {Phaser.Sprite|Phaser.Image|Phaser.Text|Phaser.BitmapData|Image|HTMLCanvasElement|string} source - The source to copy from. If you give a string it will try and find the Image in the Game.Cache first. This is quite expensive so try to provide the image itself.
	    * @param {Phaser.Sprite|Phaser.Image|Phaser.Text|Phaser.BitmapData|Image|HTMLCanvasElement|string} [mask] - The object to be used as the mask. If you give a string it will try and find the Image in the Game.Cache first. This is quite expensive so try to provide the image itself. If you don't provide a mask it will use this BitmapData as the mask.
	    * @param {Phaser.Rectangle} [sourceRect] - A Rectangle where x/y define the coordinates to draw the Source image to and width/height define the size.
	    * @param {Phaser.Rectangle} [maskRect] - A Rectangle where x/y define the coordinates to draw the Mask image to and width/height define the size.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */alphaMask:function alphaMask(source,mask,sourceRect,maskRect){if(maskRect===undefined||maskRect===null){this.draw(mask).blendSourceAtop();}else{this.draw(mask,maskRect.x,maskRect.y,maskRect.width,maskRect.height).blendSourceAtop();}if(sourceRect===undefined||sourceRect===null){this.draw(source).blendReset();}else{this.draw(source,sourceRect.x,sourceRect.y,sourceRect.width,sourceRect.height).blendReset();}return this;},/**
	    * Scans this BitmapData for all pixels matching the given r,g,b values and then draws them into the given destination BitmapData.
	    * The original BitmapData remains unchanged.
	    * The destination BitmapData must be large enough to receive all of the pixels that are scanned unless the 'resize' parameter is true.
	    * Although the destination BitmapData is returned from this method, it's actually modified directly in place, meaning this call is perfectly valid:
	    * `picture.extract(mask, r, g, b)`
	    * You can specify optional r2, g2, b2 color values. If given the pixel written to the destination bitmap will be of the r2, g2, b2 color.
	    * If not given it will be written as the same color it was extracted. You can provide one or more alternative colors, allowing you to tint
	    * the color during extraction.
	    *
	    * @method Phaser.BitmapData#extract
	    * @param {Phaser.BitmapData} destination - The BitmapData that the extracted pixels will be drawn to.
	    * @param {number} r - The red color component, in the range 0 - 255.
	    * @param {number} g - The green color component, in the range 0 - 255.
	    * @param {number} b - The blue color component, in the range 0 - 255.
	    * @param {number} [a=255] - The alpha color component, in the range 0 - 255 that the new pixel will be drawn at.
	    * @param {boolean} [resize=false] - Should the destination BitmapData be resized to match this one before the pixels are copied?
	    * @param {number} [r2] - An alternative red color component to be written to the destination, in the range 0 - 255.
	    * @param {number} [g2] - An alternative green color component to be written to the destination, in the range 0 - 255.
	    * @param {number} [b2] - An alternative blue color component to be written to the destination, in the range 0 - 255.
	    * @returns {Phaser.BitmapData} The BitmapData that the extract pixels were drawn on.
	    */extract:function extract(destination,r,g,b,a,resize,r2,g2,b2){if(a===undefined){a=255;}if(resize===undefined){resize=false;}if(r2===undefined){r2=r;}if(g2===undefined){g2=g;}if(b2===undefined){b2=b;}if(resize){destination.resize(this.width,this.height);}this.processPixelRGB(function(pixel,x,y){if(pixel.r===r&&pixel.g===g&&pixel.b===b){destination.setPixel32(x,y,r2,g2,b2,a,false);}return false;},this);destination.context.putImageData(destination.imageData,0,0);destination.dirty=true;return destination;},/**
	    * Draws a filled Rectangle to the BitmapData at the given x, y coordinates and width / height in size.
	    *
	    * @method Phaser.BitmapData#rect
	    * @param {number} x - The x coordinate of the top-left of the Rectangle.
	    * @param {number} y - The y coordinate of the top-left of the Rectangle.
	    * @param {number} width - The width of the Rectangle.
	    * @param {number} height - The height of the Rectangle.
	    * @param {string} [fillStyle] - If set the context fillStyle will be set to this value before the rect is drawn.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */rect:function rect(x,y,width,height,fillStyle){if(typeof fillStyle!=='undefined'){this.context.fillStyle=fillStyle;}this.context.fillRect(x,y,width,height);return this;},/**
	    * Draws text to the BitmapData in the given font and color.
	    * The default font is 14px Courier, so useful for quickly drawing debug text.
	    * If you need to do a lot of font work to this BitmapData we'd recommend implementing your own text draw method.
	    *
	    * @method Phaser.BitmapData#text
	    * @param {string} text - The text to write to the BitmapData.
	    * @param {number} x - The x coordinate of the top-left of the text string.
	    * @param {number} y - The y coordinate of the top-left of the text string.
	    * @param {string} [font='14px Courier'] - The font. This is passed directly to Context.font, so anything that can support, this can.
	    * @param {string} [color='rgb(255,255,255)'] - The color the text will be drawn in.
	    * @param {boolean} [shadow=true] - Draw a single pixel black shadow below the text (offset by text.x/y + 1)
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */text:function text(_text3,x,y,font,color,shadow){if(x===undefined){x=0;}if(y===undefined){y=0;}if(font===undefined){font='14px Courier';}if(color===undefined){color='rgb(255,255,255)';}if(shadow===undefined){shadow=true;}var ctx=this.context;var prevFont=ctx.font;ctx.font=font;if(shadow){ctx.fillStyle='rgb(0,0,0)';ctx.fillText(_text3,x+1,y+1);}ctx.fillStyle=color;ctx.fillText(_text3,x,y);ctx.font=prevFont;return this;},/**
	    * Draws a filled Circle to the BitmapData at the given x, y coordinates and radius in size.
	    *
	    * @method Phaser.BitmapData#circle
	    * @param {number} x - The x coordinate to draw the Circle at. This is the center of the circle.
	    * @param {number} y - The y coordinate to draw the Circle at. This is the center of the circle.
	    * @param {number} radius - The radius of the Circle in pixels. The radius is half the diameter.
	    * @param {string} [fillStyle] - If set the context fillStyle will be set to this value before the circle is drawn.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */circle:function circle(x,y,radius,fillStyle){var ctx=this.context;if(fillStyle!==undefined){ctx.fillStyle=fillStyle;}ctx.beginPath();ctx.arc(x,y,radius,0,Math.PI*2,false);ctx.closePath();ctx.fill();return this;},/**
	    * Draws a line between the coordinates given in the color and thickness specified.
	    *
	    * @method Phaser.BitmapData#line
	    * @param {number} x1 - The x coordinate to start the line from.
	    * @param {number} y1 - The y coordinate to start the line from.
	    * @param {number} x2 - The x coordinate to draw the line to.
	    * @param {number} y2 - The y coordinate to draw the line to.
	    * @param {string} [color='#fff'] - The stroke color that the line will be drawn in.
	    * @param {number} [width=1] - The line thickness.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */line:function line(x1,y1,x2,y2,color,width){if(color===undefined){color='#fff';}if(width===undefined){width=1;}var ctx=this.context;ctx.beginPath();ctx.moveTo(x1,y1);ctx.lineTo(x2,y2);ctx.lineWidth=width;ctx.strokeStyle=color;ctx.stroke();ctx.closePath();return this;},/**
	    * Takes the given Line object and image and renders it to this BitmapData as a repeating texture line.
	    *
	    * @method Phaser.BitmapData#textureLine
	    * @param {Phaser.Line} line - A Phaser.Line object that will be used to plot the start and end of the line.
	    * @param {string|Image} image - The key of an image in the Phaser.Cache to use as the texture for this line, or an actual Image.
	    * @param {string} [repeat='repeat-x'] - The pattern repeat mode to use when drawing the line. Either `repeat`, `repeat-x` or `no-repeat`.
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */textureLine:function textureLine(line,image,repeat){if(repeat===undefined){repeat='repeat-x';}if(typeof image==='string'){image=this.game.cache.getImage(image);if(!image){return;}}var width=line.length;if(repeat==='no-repeat'&&width>image.width){width=image.width;}var ctx=this.context;ctx.fillStyle=ctx.createPattern(image,repeat);this._circle=new Phaser.Circle(line.start.x,line.start.y,image.height);this._circle.circumferencePoint(line.angle-1.5707963267948966,false,this._pos);ctx.save();ctx.translate(this._pos.x,this._pos.y);ctx.rotate(line.angle);ctx.fillRect(0,0,width,image.height);ctx.restore();this.dirty=true;return this;},/**
	    * If the game is running in WebGL this will push the texture up to the GPU if it's dirty.
	    * This is called automatically if the BitmapData is being used by a Sprite, otherwise you need to remember to call it in your render function.
	    * If you wish to suppress this functionality set BitmapData.disableTextureUpload to `true`.
	    *
	    * @method Phaser.BitmapData#render
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */render:function render(){if(!this.disableTextureUpload&&this.dirty){this.baseTexture.dirty();this.dirty=false;}return this;},/**
	    * Destroys this BitmapData and puts the canvas it was using back into the canvas pool for re-use.
	    *
	    * @method Phaser.BitmapData#destroy
	    */destroy:function destroy(){this.frameData.destroy();this.texture.destroy(true);PIXI.CanvasPool.remove(this);},/**
	    * Resets the blend mode (effectively sets it to 'source-over')
	    *
	    * @method Phaser.BitmapData#blendReset
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendReset:function blendReset(){this.op='source-over';return this;},/**
	    * Sets the blend mode to 'source-over'
	    *
	    * @method Phaser.BitmapData#blendSourceOver
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendSourceOver:function blendSourceOver(){this.op='source-over';return this;},/**
	    * Sets the blend mode to 'source-in'
	    *
	    * @method Phaser.BitmapData#blendSourceIn
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendSourceIn:function blendSourceIn(){this.op='source-in';return this;},/**
	    * Sets the blend mode to 'source-out'
	    *
	    * @method Phaser.BitmapData#blendSourceOut
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendSourceOut:function blendSourceOut(){this.op='source-out';return this;},/**
	    * Sets the blend mode to 'source-atop'
	    *
	    * @method Phaser.BitmapData#blendSourceAtop
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendSourceAtop:function blendSourceAtop(){this.op='source-atop';return this;},/**
	    * Sets the blend mode to 'destination-over'
	    *
	    * @method Phaser.BitmapData#blendDestinationOver
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendDestinationOver:function blendDestinationOver(){this.op='destination-over';return this;},/**
	    * Sets the blend mode to 'destination-in'
	    *
	    * @method Phaser.BitmapData#blendDestinationIn
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendDestinationIn:function blendDestinationIn(){this.op='destination-in';return this;},/**
	    * Sets the blend mode to 'destination-out'
	    *
	    * @method Phaser.BitmapData#blendDestinationOut
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendDestinationOut:function blendDestinationOut(){this.op='destination-out';return this;},/**
	    * Sets the blend mode to 'destination-atop'
	    *
	    * @method Phaser.BitmapData#blendDestinationAtop
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendDestinationAtop:function blendDestinationAtop(){this.op='destination-atop';return this;},/**
	    * Sets the blend mode to 'xor'
	    *
	    * @method Phaser.BitmapData#blendXor
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendXor:function blendXor(){this.op='xor';return this;},/**
	    * Sets the blend mode to 'lighter'
	    *
	    * @method Phaser.BitmapData#blendAdd
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendAdd:function blendAdd(){this.op='lighter';return this;},/**
	    * Sets the blend mode to 'multiply'
	    *
	    * @method Phaser.BitmapData#blendMultiply
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendMultiply:function blendMultiply(){this.op='multiply';return this;},/**
	    * Sets the blend mode to 'screen'
	    *
	    * @method Phaser.BitmapData#blendScreen
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendScreen:function blendScreen(){this.op='screen';return this;},/**
	    * Sets the blend mode to 'overlay'
	    *
	    * @method Phaser.BitmapData#blendOverlay
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendOverlay:function blendOverlay(){this.op='overlay';return this;},/**
	    * Sets the blend mode to 'darken'
	    *
	    * @method Phaser.BitmapData#blendDarken
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendDarken:function blendDarken(){this.op='darken';return this;},/**
	    * Sets the blend mode to 'lighten'
	    *
	    * @method Phaser.BitmapData#blendLighten
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendLighten:function blendLighten(){this.op='lighten';return this;},/**
	    * Sets the blend mode to 'color-dodge'
	    *
	    * @method Phaser.BitmapData#blendColorDodge
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendColorDodge:function blendColorDodge(){this.op='color-dodge';return this;},/**
	    * Sets the blend mode to 'color-burn'
	    *
	    * @method Phaser.BitmapData#blendColorBurn
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendColorBurn:function blendColorBurn(){this.op='color-burn';return this;},/**
	    * Sets the blend mode to 'hard-light'
	    *
	    * @method Phaser.BitmapData#blendHardLight
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendHardLight:function blendHardLight(){this.op='hard-light';return this;},/**
	    * Sets the blend mode to 'soft-light'
	    *
	    * @method Phaser.BitmapData#blendSoftLight
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendSoftLight:function blendSoftLight(){this.op='soft-light';return this;},/**
	    * Sets the blend mode to 'difference'
	    *
	    * @method Phaser.BitmapData#blendDifference
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendDifference:function blendDifference(){this.op='difference';return this;},/**
	    * Sets the blend mode to 'exclusion'
	    *
	    * @method Phaser.BitmapData#blendExclusion
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendExclusion:function blendExclusion(){this.op='exclusion';return this;},/**
	    * Sets the blend mode to 'hue'
	    *
	    * @method Phaser.BitmapData#blendHue
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendHue:function blendHue(){this.op='hue';return this;},/**
	    * Sets the blend mode to 'saturation'
	    *
	    * @method Phaser.BitmapData#blendSaturation
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendSaturation:function blendSaturation(){this.op='saturation';return this;},/**
	    * Sets the blend mode to 'color'
	    *
	    * @method Phaser.BitmapData#blendColor
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendColor:function blendColor(){this.op='color';return this;},/**
	    * Sets the blend mode to 'luminosity'
	    *
	    * @method Phaser.BitmapData#blendLuminosity
	    * @return {Phaser.BitmapData} This BitmapData object for method chaining.
	    */blendLuminosity:function blendLuminosity(){this.op='luminosity';return this;}};/**
	* @memberof Phaser.BitmapData
	* @property {boolean} smoothed - Gets or sets this BitmapData.contexts smoothing enabled value.
	*/Object.defineProperty(Phaser.BitmapData.prototype,"smoothed",{get:function get(){Phaser.Canvas.getSmoothingEnabled(this.context);},set:function set(value){Phaser.Canvas.setSmoothingEnabled(this.context,value);}});/**
	* @memberof Phaser.BitmapData
	* @property {string} op - A short-hand code to get or set the global composite operation of the BitmapDatas canvas.
	*/Object.defineProperty(Phaser.BitmapData.prototype,"op",{get:function get(){return this.context.globalCompositeOperation;},set:function set(value){this.context.globalCompositeOperation=value;}});/**
	 * Gets a JavaScript object that has 6 properties set that are used by BitmapData in a transform.
	 *
	 * @method Phaser.BitmapData.getTransform
	 * @param {number} translateX - The x translate value.
	 * @param {number} translateY - The y translate value.
	 * @param {number} scaleX - The scale x value.
	 * @param {number} scaleY - The scale y value.
	 * @param {number} skewX - The skew x value.
	 * @param {number} skewY - The skew y value.
	 * @return {object} A JavaScript object containing all of the properties BitmapData needs for transforms.
	 */Phaser.BitmapData.getTransform=function(translateX,translateY,scaleX,scaleY,skewX,skewY){if(typeof translateX!=='number'){translateX=0;}if(typeof translateY!=='number'){translateY=0;}if(typeof scaleX!=='number'){scaleX=1;}if(typeof scaleY!=='number'){scaleY=1;}if(typeof skewX!=='number'){skewX=0;}if(typeof skewY!=='number'){skewY=0;}return{sx:scaleX,sy:scaleY,scaleX:scaleX,scaleY:scaleY,skewX:skewX,skewY:skewY,translateX:translateX,translateY:translateY,tx:translateX,ty:translateY};};Phaser.BitmapData.prototype.constructor=Phaser.BitmapData;/**
	 * @author Mat Groves http://matgroves.com/ @Doormat23
	 *//**
	 * The Graphics class contains methods used to draw primitive shapes such as lines, circles and rectangles to the display, and color and fill them.
	 * 
	 * @class Graphics
	 * @extends DisplayObjectContainer
	 * @constructor
	 */PIXI.Graphics=function(){PIXI.DisplayObjectContainer.call(this);this.renderable=true;/**
	     * The alpha value used when filling the Graphics object.
	     *
	     * @property fillAlpha
	     * @type Number
	     */this.fillAlpha=1;/**
	     * The width (thickness) of any lines drawn.
	     *
	     * @property lineWidth
	     * @type Number
	     */this.lineWidth=0;/**
	     * The color of any lines drawn.
	     *
	     * @property lineColor
	     * @type String
	     * @default 0
	     */this.lineColor=0;/**
	     * Graphics data
	     *
	     * @property graphicsData
	     * @type Array
	     * @private
	     */this.graphicsData=[];/**
	     * The tint applied to the graphic shape. This is a hex value. Apply a value of 0xFFFFFF to reset the tint.
	     *
	     * @property tint
	     * @type Number
	     * @default 0xFFFFFF
	     */this.tint=0xFFFFFF;/**
	     * The blend mode to be applied to the graphic shape. Apply a value of PIXI.blendModes.NORMAL to reset the blend mode.
	     *
	     * @property blendMode
	     * @type Number
	     * @default PIXI.blendModes.NORMAL;
	     */this.blendMode=PIXI.blendModes.NORMAL;/**
	     * Current path
	     *
	     * @property currentPath
	     * @type Object
	     * @private
	     */this.currentPath=null;/**
	     * Array containing some WebGL-related properties used by the WebGL renderer.
	     *
	     * @property _webGL
	     * @type Array
	     * @private
	     */this._webGL=[];/**
	     * Whether this shape is being used as a mask.
	     *
	     * @property isMask
	     * @type Boolean
	     */this.isMask=false;/**
	     * The bounds' padding used for bounds calculation.
	     *
	     * @property boundsPadding
	     * @type Number
	     */this.boundsPadding=0;this._localBounds=new PIXI.Rectangle(0,0,1,1);/**
	     * Used to detect if the graphics object has changed. If this is set to true then the graphics object will be recalculated.
	     * 
	     * @property dirty
	     * @type Boolean
	     * @private
	     */this.dirty=true;/**
	     * Used to detect if the bounds have been invalidated, by this Graphics being cleared or drawn to.
	     * If this is set to true then the updateLocalBounds is called once in the postUpdate method.
	     * 
	     * @property _boundsDirty
	     * @type Boolean
	     * @private
	     */this._boundsDirty=false;/**
	     * Used to detect if the webgl graphics object has changed. If this is set to true then the graphics object will be recalculated.
	     * 
	     * @property webGLDirty
	     * @type Boolean
	     * @private
	     */this.webGLDirty=false;/**
	     * Used to detect if the cached sprite object needs to be updated.
	     * 
	     * @property cachedSpriteDirty
	     * @type Boolean
	     * @private
	     */this.cachedSpriteDirty=false;};// constructor
	PIXI.Graphics.prototype=Object.create(PIXI.DisplayObjectContainer.prototype);PIXI.Graphics.prototype.constructor=PIXI.Graphics;/**
	 * Specifies the line style used for subsequent calls to Graphics methods such as the lineTo() method or the drawCircle() method.
	 *
	 * @method lineStyle
	 * @param lineWidth {Number} width of the line to draw, will update the objects stored style
	 * @param color {Number} color of the line to draw, will update the objects stored style
	 * @param alpha {Number} alpha of the line to draw, will update the objects stored style
	 * @return {Graphics}
	 */PIXI.Graphics.prototype.lineStyle=function(lineWidth,color,alpha){this.lineWidth=lineWidth||0;this.lineColor=color||0;this.lineAlpha=alpha===undefined?1:alpha;if(this.currentPath){if(this.currentPath.shape.points.length){// halfway through a line? start a new one!
	this.drawShape(new PIXI.Polygon(this.currentPath.shape.points.slice(-2)));}else{// otherwise its empty so lets just set the line properties
	this.currentPath.lineWidth=this.lineWidth;this.currentPath.lineColor=this.lineColor;this.currentPath.lineAlpha=this.lineAlpha;}}return this;};/**
	 * Moves the current drawing position to x, y.
	 *
	 * @method moveTo
	 * @param x {Number} the X coordinate to move to
	 * @param y {Number} the Y coordinate to move to
	 * @return {Graphics}
	  */PIXI.Graphics.prototype.moveTo=function(x,y){this.drawShape(new PIXI.Polygon([x,y]));return this;};/**
	 * Draws a line using the current line style from the current drawing position to (x, y);
	 * The current drawing position is then set to (x, y).
	 *
	 * @method lineTo
	 * @param x {Number} the X coordinate to draw to
	 * @param y {Number} the Y coordinate to draw to
	 * @return {Graphics}
	 */PIXI.Graphics.prototype.lineTo=function(x,y){if(!this.currentPath){this.moveTo(0,0);}this.currentPath.shape.points.push(x,y);this.dirty=true;this._boundsDirty=true;return this;};/**
	 * Calculate the points for a quadratic bezier curve and then draws it.
	 * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
	 *
	 * @method quadraticCurveTo
	 * @param cpX {Number} Control point x
	 * @param cpY {Number} Control point y
	 * @param toX {Number} Destination point x
	 * @param toY {Number} Destination point y
	 * @return {Graphics}
	 */PIXI.Graphics.prototype.quadraticCurveTo=function(cpX,cpY,toX,toY){if(this.currentPath){if(this.currentPath.shape.points.length===0){this.currentPath.shape.points=[0,0];}}else{this.moveTo(0,0);}var xa,ya,n=20,points=this.currentPath.shape.points;if(points.length===0){this.moveTo(0,0);}var fromX=points[points.length-2];var fromY=points[points.length-1];var j=0;for(var i=1;i<=n;++i){j=i/n;xa=fromX+(cpX-fromX)*j;ya=fromY+(cpY-fromY)*j;points.push(xa+(cpX+(toX-cpX)*j-xa)*j,ya+(cpY+(toY-cpY)*j-ya)*j);}this.dirty=true;this._boundsDirty=true;return this;};/**
	 * Calculate the points for a bezier curve and then draws it.
	 *
	 * @method bezierCurveTo
	 * @param cpX {Number} Control point x
	 * @param cpY {Number} Control point y
	 * @param cpX2 {Number} Second Control point x
	 * @param cpY2 {Number} Second Control point y
	 * @param toX {Number} Destination point x
	 * @param toY {Number} Destination point y
	 * @return {Graphics}
	 */PIXI.Graphics.prototype.bezierCurveTo=function(cpX,cpY,cpX2,cpY2,toX,toY){if(this.currentPath){if(this.currentPath.shape.points.length===0){this.currentPath.shape.points=[0,0];}}else{this.moveTo(0,0);}var n=20,dt,dt2,dt3,t2,t3,points=this.currentPath.shape.points;var fromX=points[points.length-2];var fromY=points[points.length-1];var j=0;for(var i=1;i<=n;++i){j=i/n;dt=1-j;dt2=dt*dt;dt3=dt2*dt;t2=j*j;t3=t2*j;points.push(dt3*fromX+3*dt2*j*cpX+3*dt*t2*cpX2+t3*toX,dt3*fromY+3*dt2*j*cpY+3*dt*t2*cpY2+t3*toY);}this.dirty=true;this._boundsDirty=true;return this;};/*
	 * The arcTo() method creates an arc/curve between two tangents on the canvas.
	 * 
	 * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
	 *
	 * @method arcTo
	 * @param x1 {Number} The x-coordinate of the beginning of the arc
	 * @param y1 {Number} The y-coordinate of the beginning of the arc
	 * @param x2 {Number} The x-coordinate of the end of the arc
	 * @param y2 {Number} The y-coordinate of the end of the arc
	 * @param radius {Number} The radius of the arc
	 * @return {Graphics}
	 */PIXI.Graphics.prototype.arcTo=function(x1,y1,x2,y2,radius){if(this.currentPath){if(this.currentPath.shape.points.length===0){this.currentPath.shape.points.push(x1,y1);}}else{this.moveTo(x1,y1);}var points=this.currentPath.shape.points,fromX=points[points.length-2],fromY=points[points.length-1],a1=fromY-y1,b1=fromX-x1,a2=y2-y1,b2=x2-x1,mm=Math.abs(a1*b2-b1*a2);if(mm<1.0e-8||radius===0){if(points[points.length-2]!==x1||points[points.length-1]!==y1){points.push(x1,y1);}}else{var dd=a1*a1+b1*b1,cc=a2*a2+b2*b2,tt=a1*a2+b1*b2,k1=radius*Math.sqrt(dd)/mm,k2=radius*Math.sqrt(cc)/mm,j1=k1*tt/dd,j2=k2*tt/cc,cx=k1*b2+k2*b1,cy=k1*a2+k2*a1,px=b1*(k2+j1),py=a1*(k2+j1),qx=b2*(k1+j2),qy=a2*(k1+j2),startAngle=Math.atan2(py-cy,px-cx),endAngle=Math.atan2(qy-cy,qx-cx);this.arc(cx+x1,cy+y1,radius,startAngle,endAngle,b1*a2>b2*a1);}this.dirty=true;this._boundsDirty=true;return this;};/**
	 * The arc method creates an arc/curve (used to create circles, or parts of circles).
	 *
	 * @method arc
	 * @param cx {Number} The x-coordinate of the center of the circle
	 * @param cy {Number} The y-coordinate of the center of the circle
	 * @param radius {Number} The radius of the circle
	 * @param startAngle {Number} The starting angle, in radians (0 is at the 3 o'clock position of the arc's circle)
	 * @param endAngle {Number} The ending angle, in radians
	 * @param anticlockwise {Boolean} Optional. Specifies whether the drawing should be counterclockwise or clockwise. False is default, and indicates clockwise, while true indicates counter-clockwise.
	 * @param segments {Number} Optional. The number of segments to use when calculating the arc. The default is 40. If you need more fidelity use a higher number.
	 * @return {Graphics}
	 */PIXI.Graphics.prototype.arc=function(cx,cy,radius,startAngle,endAngle,anticlockwise,segments){//  If we do this we can never draw a full circle
	if(startAngle===endAngle){return this;}if(anticlockwise===undefined){anticlockwise=false;}if(segments===undefined){segments=40;}if(!anticlockwise&&endAngle<=startAngle){endAngle+=Math.PI*2;}else if(anticlockwise&&startAngle<=endAngle){startAngle+=Math.PI*2;}var sweep=anticlockwise?(startAngle-endAngle)*-1:endAngle-startAngle;var segs=Math.ceil(Math.abs(sweep)/(Math.PI*2))*segments;//  Sweep check - moved here because we don't want to do the moveTo below if the arc fails
	if(sweep===0){return this;}var startX=cx+Math.cos(startAngle)*radius;var startY=cy+Math.sin(startAngle)*radius;if(anticlockwise&&this.filling){this.moveTo(cx,cy);}else{this.moveTo(startX,startY);}//  currentPath will always exist after calling a moveTo
	var points=this.currentPath.shape.points;var theta=sweep/(segs*2);var theta2=theta*2;var cTheta=Math.cos(theta);var sTheta=Math.sin(theta);var segMinus=segs-1;var remainder=segMinus%1/segMinus;for(var i=0;i<=segMinus;i++){var real=i+remainder*i;var angle=theta+startAngle+theta2*real;var c=Math.cos(angle);var s=-Math.sin(angle);points.push((cTheta*c+sTheta*s)*radius+cx,(cTheta*-s+sTheta*c)*radius+cy);}this.dirty=true;this._boundsDirty=true;return this;};/**
	 * Specifies a simple one-color fill that subsequent calls to other Graphics methods
	 * (such as lineTo() or drawCircle()) use when drawing.
	 *
	 * @method beginFill
	 * @param color {Number} the color of the fill
	 * @param alpha {Number} the alpha of the fill
	 * @return {Graphics}
	 */PIXI.Graphics.prototype.beginFill=function(color,alpha){this.filling=true;this.fillColor=color||0;this.fillAlpha=alpha===undefined?1:alpha;if(this.currentPath){if(this.currentPath.shape.points.length<=2){this.currentPath.fill=this.filling;this.currentPath.fillColor=this.fillColor;this.currentPath.fillAlpha=this.fillAlpha;}}return this;};/**
	 * Applies a fill to the lines and shapes that were added since the last call to the beginFill() method.
	 *
	 * @method endFill
	 * @return {Graphics}
	 */PIXI.Graphics.prototype.endFill=function(){this.filling=false;this.fillColor=null;this.fillAlpha=1;return this;};/**
	 * @method drawRect
	 *
	 * @param x {Number} The X coord of the top-left of the rectangle
	 * @param y {Number} The Y coord of the top-left of the rectangle
	 * @param width {Number} The width of the rectangle
	 * @param height {Number} The height of the rectangle
	 * @return {Graphics}
	 */PIXI.Graphics.prototype.drawRect=function(x,y,width,height){this.drawShape(new PIXI.Rectangle(x,y,width,height));return this;};/**
	 * @method drawRoundedRect
	 * @param x {Number} The X coord of the top-left of the rectangle
	 * @param y {Number} The Y coord of the top-left of the rectangle
	 * @param width {Number} The width of the rectangle
	 * @param height {Number} The height of the rectangle
	 * @param radius {Number} Radius of the rectangle corners. In WebGL this must be a value between 0 and 9.
	 */PIXI.Graphics.prototype.drawRoundedRect=function(x,y,width,height,radius){this.drawShape(new PIXI.RoundedRectangle(x,y,width,height,radius));return this;};/**
	 * Draws a circle.
	 *
	 * @method drawCircle
	 * @param x {Number} The X coordinate of the center of the circle
	 * @param y {Number} The Y coordinate of the center of the circle
	 * @param diameter {Number} The diameter of the circle
	 * @return {Graphics}
	 */PIXI.Graphics.prototype.drawCircle=function(x,y,diameter){this.drawShape(new PIXI.Circle(x,y,diameter));return this;};/**
	 * Draws an ellipse.
	 *
	 * @method drawEllipse
	 * @param x {Number} The X coordinate of the center of the ellipse
	 * @param y {Number} The Y coordinate of the center of the ellipse
	 * @param width {Number} The half width of the ellipse
	 * @param height {Number} The half height of the ellipse
	 * @return {Graphics}
	 */PIXI.Graphics.prototype.drawEllipse=function(x,y,width,height){this.drawShape(new PIXI.Ellipse(x,y,width,height));return this;};/**
	 * Draws a polygon using the given path.
	 *
	 * @method drawPolygon
	 * @param path {Array|Phaser.Polygon} The path data used to construct the polygon. Can either be an array of points or a Phaser.Polygon object.
	 * @return {Graphics}
	 */PIXI.Graphics.prototype.drawPolygon=function(path){if(path instanceof Phaser.Polygon||path instanceof PIXI.Polygon){path=path.points;}// prevents an argument assignment deopt
	// see section 3.1: https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
	var points=path;if(!Array.isArray(points)){// prevents an argument leak deopt
	// see section 3.2: https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
	points=new Array(arguments.length);for(var i=0;i<points.length;++i){points[i]=arguments[i];}}this.drawShape(new Phaser.Polygon(points));return this;};/**
	 * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
	 *
	 * @method clear
	 * @return {Graphics}
	 */PIXI.Graphics.prototype.clear=function(){this.lineWidth=0;this.filling=false;this.dirty=true;this._boundsDirty=true;this.clearDirty=true;this.graphicsData=[];this.updateLocalBounds();return this;};/**
	 * Useful function that returns a texture of the graphics object that can then be used to create sprites
	 * This can be quite useful if your geometry is complicated and needs to be reused multiple times.
	 *
	 * @method generateTexture
	 * @param [resolution=1] {Number} The resolution of the texture being generated
	 * @param [scaleMode=0] {Number} Should be one of the PIXI.scaleMode consts
	 * @param [padding=0] {Number} Add optional extra padding to the generated texture (default 0)
	 * @return {Texture} a texture of the graphics object
	 */PIXI.Graphics.prototype.generateTexture=function(resolution,scaleMode,padding){if(resolution===undefined){resolution=1;}if(scaleMode===undefined){scaleMode=PIXI.scaleModes.DEFAULT;}if(padding===undefined){padding=0;}var bounds=this.getBounds();bounds.width+=padding;bounds.height+=padding;var canvasBuffer=new PIXI.CanvasBuffer(bounds.width*resolution,bounds.height*resolution);var texture=PIXI.Texture.fromCanvas(canvasBuffer.canvas,scaleMode);texture.baseTexture.resolution=resolution;canvasBuffer.context.scale(resolution,resolution);canvasBuffer.context.translate(-bounds.x,-bounds.y);PIXI.CanvasGraphics.renderGraphics(this,canvasBuffer.context);return texture;};/**
	* Renders the object using the WebGL renderer
	*
	* @method _renderWebGL
	* @param renderSession {RenderSession} 
	* @private
	*/PIXI.Graphics.prototype._renderWebGL=function(renderSession){// if the sprite is not visible or the alpha is 0 then no need to render this element
	if(this.visible===false||this.alpha===0||this.isMask===true)return;if(this._cacheAsBitmap){if(this.dirty||this.cachedSpriteDirty){this._generateCachedSprite();// we will also need to update the texture on the gpu too!
	this.updateCachedSpriteTexture();this.cachedSpriteDirty=false;this.dirty=false;}this._cachedSprite.worldAlpha=this.worldAlpha;PIXI.Sprite.prototype._renderWebGL.call(this._cachedSprite,renderSession);return;}else{renderSession.spriteBatch.stop();renderSession.blendModeManager.setBlendMode(this.blendMode);if(this._mask)renderSession.maskManager.pushMask(this._mask,renderSession);if(this._filters)renderSession.filterManager.pushFilter(this._filterBlock);// check blend mode
	if(this.blendMode!==renderSession.spriteBatch.currentBlendMode){renderSession.spriteBatch.currentBlendMode=this.blendMode;var blendModeWebGL=PIXI.blendModesWebGL[renderSession.spriteBatch.currentBlendMode];renderSession.spriteBatch.gl.blendFunc(blendModeWebGL[0],blendModeWebGL[1]);}// check if the webgl graphic needs to be updated
	if(this.webGLDirty){this.dirty=true;this.webGLDirty=false;}PIXI.WebGLGraphics.renderGraphics(this,renderSession);// only render if it has children!
	if(this.children.length){renderSession.spriteBatch.start();// simple render children!
	for(var i=0;i<this.children.length;i++){this.children[i]._renderWebGL(renderSession);}renderSession.spriteBatch.stop();}if(this._filters)renderSession.filterManager.popFilter();if(this._mask)renderSession.maskManager.popMask(this.mask,renderSession);renderSession.drawCount++;renderSession.spriteBatch.start();}};/**
	* Renders the object using the Canvas renderer
	*
	* @method _renderCanvas
	* @param renderSession {RenderSession} 
	* @private
	*/PIXI.Graphics.prototype._renderCanvas=function(renderSession){// if the sprite is not visible or the alpha is 0 then no need to render this element
	if(this.visible===false||this.alpha===0||this.isMask===true)return;// if the tint has changed, set the graphics object to dirty.
	if(this._prevTint!==this.tint){this.dirty=true;this._prevTint=this.tint;}if(this._cacheAsBitmap){if(this.dirty||this.cachedSpriteDirty){this._generateCachedSprite();// we will also need to update the texture
	this.updateCachedSpriteTexture();this.cachedSpriteDirty=false;this.dirty=false;}this._cachedSprite.alpha=this.alpha;PIXI.Sprite.prototype._renderCanvas.call(this._cachedSprite,renderSession);return;}else{var context=renderSession.context;var transform=this.worldTransform;if(this.blendMode!==renderSession.currentBlendMode){renderSession.currentBlendMode=this.blendMode;context.globalCompositeOperation=PIXI.blendModesCanvas[renderSession.currentBlendMode];}if(this._mask){renderSession.maskManager.pushMask(this._mask,renderSession);}var resolution=renderSession.resolution;var tx=transform.tx*renderSession.resolution+renderSession.shakeX;var ty=transform.ty*renderSession.resolution+renderSession.shakeY;context.setTransform(transform.a*resolution,transform.b*resolution,transform.c*resolution,transform.d*resolution,tx,ty);PIXI.CanvasGraphics.renderGraphics(this,context);// simple render children!
	for(var i=0;i<this.children.length;i++){this.children[i]._renderCanvas(renderSession);}if(this._mask){renderSession.maskManager.popMask(renderSession);}}};/**
	 * Retrieves the bounds of the graphic shape as a rectangle object
	 *
	 * @method getBounds
	 * @return {Rectangle} the rectangular bounding area
	 */PIXI.Graphics.prototype.getBounds=function(matrix){if(!this._currentBounds){//  Return an empty object if the item is a mask!
	if(!this.renderable){return PIXI.EmptyRectangle;}if(this.dirty){this.updateLocalBounds();this.webGLDirty=true;this.cachedSpriteDirty=true;this.dirty=false;}var bounds=this._localBounds;var w0=bounds.x;var w1=bounds.width+bounds.x;var h0=bounds.y;var h1=bounds.height+bounds.y;var worldTransform=matrix||this.worldTransform;var a=worldTransform.a;var b=worldTransform.b;var c=worldTransform.c;var d=worldTransform.d;var tx=worldTransform.tx;var ty=worldTransform.ty;var x1=a*w1+c*h1+tx;var y1=d*h1+b*w1+ty;var x2=a*w0+c*h1+tx;var y2=d*h1+b*w0+ty;var x3=a*w0+c*h0+tx;var y3=d*h0+b*w0+ty;var x4=a*w1+c*h0+tx;var y4=d*h0+b*w1+ty;var maxX=x1;var maxY=y1;var minX=x1;var minY=y1;minX=x2<minX?x2:minX;minX=x3<minX?x3:minX;minX=x4<minX?x4:minX;minY=y2<minY?y2:minY;minY=y3<minY?y3:minY;minY=y4<minY?y4:minY;maxX=x2>maxX?x2:maxX;maxX=x3>maxX?x3:maxX;maxX=x4>maxX?x4:maxX;maxY=y2>maxY?y2:maxY;maxY=y3>maxY?y3:maxY;maxY=y4>maxY?y4:maxY;this._bounds.x=minX;this._bounds.width=maxX-minX;this._bounds.y=minY;this._bounds.height=maxY-minY;this._currentBounds=this._bounds;}return this._currentBounds;};/**
	 * Retrieves the non-global local bounds of the graphic shape as a rectangle. The calculation takes all visible children into consideration.
	 *
	 * @method getLocalBounds
	 * @return {Rectangle} The rectangular bounding area
	 */PIXI.Graphics.prototype.getLocalBounds=function(){var matrixCache=this.worldTransform;this.worldTransform=PIXI.identityMatrix;for(var i=0;i<this.children.length;i++){this.children[i].updateTransform();}var bounds=this.getBounds();this.worldTransform=matrixCache;for(i=0;i<this.children.length;i++){this.children[i].updateTransform();}return bounds;};/**
	* Tests if a point is inside this graphics object
	*
	* @param point {Point} the point to test
	* @return {boolean} the result of the test
	*/PIXI.Graphics.prototype.containsPoint=function(point){this.worldTransform.applyInverse(point,tempPoint);var graphicsData=this.graphicsData;for(var i=0;i<graphicsData.length;i++){var data=graphicsData[i];if(!data.fill){continue;}// only deal with fills..
	if(data.shape){if(data.shape.contains(tempPoint.x,tempPoint.y)){return true;}}}return false;};/**
	 * Update the bounds of the object
	 *
	 * @method updateLocalBounds
	 */PIXI.Graphics.prototype.updateLocalBounds=function(){var minX=Infinity;var maxX=-Infinity;var minY=Infinity;var maxY=-Infinity;if(this.graphicsData.length){var shape,points,x,y,w,h;for(var i=0;i<this.graphicsData.length;i++){var data=this.graphicsData[i];var type=data.type;var lineWidth=data.lineWidth;shape=data.shape;if(type===PIXI.Graphics.RECT||type===PIXI.Graphics.RREC){x=shape.x-lineWidth/2;y=shape.y-lineWidth/2;w=shape.width+lineWidth;h=shape.height+lineWidth;minX=x<minX?x:minX;maxX=x+w>maxX?x+w:maxX;minY=y<minY?y:minY;maxY=y+h>maxY?y+h:maxY;}else if(type===PIXI.Graphics.CIRC){x=shape.x;y=shape.y;w=shape.radius+lineWidth/2;h=shape.radius+lineWidth/2;minX=x-w<minX?x-w:minX;maxX=x+w>maxX?x+w:maxX;minY=y-h<minY?y-h:minY;maxY=y+h>maxY?y+h:maxY;}else if(type===PIXI.Graphics.ELIP){x=shape.x;y=shape.y;w=shape.width+lineWidth/2;h=shape.height+lineWidth/2;minX=x-w<minX?x-w:minX;maxX=x+w>maxX?x+w:maxX;minY=y-h<minY?y-h:minY;maxY=y+h>maxY?y+h:maxY;}else{// POLY - assumes points are sequential, not Point objects
	points=shape.points;for(var j=0;j<points.length;j++){if(points[j]instanceof Phaser.Point){x=points[j].x;y=points[j].y;}else{x=points[j];y=points[j+1];if(j<points.length-1){j++;}}minX=x-lineWidth<minX?x-lineWidth:minX;maxX=x+lineWidth>maxX?x+lineWidth:maxX;minY=y-lineWidth<minY?y-lineWidth:minY;maxY=y+lineWidth>maxY?y+lineWidth:maxY;}}}}else{minX=0;maxX=0;minY=0;maxY=0;}var padding=this.boundsPadding;this._localBounds.x=minX-padding;this._localBounds.width=maxX-minX+padding*2;this._localBounds.y=minY-padding;this._localBounds.height=maxY-minY+padding*2;};/**
	 * Generates the cached sprite when the sprite has cacheAsBitmap = true
	 *
	 * @method _generateCachedSprite
	 * @private
	 */PIXI.Graphics.prototype._generateCachedSprite=function(){var bounds=this.getLocalBounds();if(!this._cachedSprite){var canvasBuffer=new PIXI.CanvasBuffer(bounds.width,bounds.height);var texture=PIXI.Texture.fromCanvas(canvasBuffer.canvas);this._cachedSprite=new PIXI.Sprite(texture);this._cachedSprite.buffer=canvasBuffer;this._cachedSprite.worldTransform=this.worldTransform;}else{this._cachedSprite.buffer.resize(bounds.width,bounds.height);}// leverage the anchor to account for the offset of the element
	this._cachedSprite.anchor.x=-(bounds.x/bounds.width);this._cachedSprite.anchor.y=-(bounds.y/bounds.height);// this._cachedSprite.buffer.context.save();
	this._cachedSprite.buffer.context.translate(-bounds.x,-bounds.y);// make sure we set the alpha of the graphics to 1 for the render.. 
	this.worldAlpha=1;// now render the graphic..
	PIXI.CanvasGraphics.renderGraphics(this,this._cachedSprite.buffer.context);this._cachedSprite.alpha=this.alpha;};/**
	 * Updates texture size based on canvas size
	 *
	 * @method updateCachedSpriteTexture
	 * @private
	 */PIXI.Graphics.prototype.updateCachedSpriteTexture=function(){var cachedSprite=this._cachedSprite;var texture=cachedSprite.texture;var canvas=cachedSprite.buffer.canvas;texture.baseTexture.width=canvas.width;texture.baseTexture.height=canvas.height;texture.crop.width=texture.frame.width=canvas.width;texture.crop.height=texture.frame.height=canvas.height;cachedSprite._width=canvas.width;cachedSprite._height=canvas.height;// update the dirty base textures
	texture.baseTexture.dirty();};/**
	 * Destroys a previous cached sprite.
	 *
	 * @method destroyCachedSprite
	 */PIXI.Graphics.prototype.destroyCachedSprite=function(){this._cachedSprite.texture.destroy(true);this._cachedSprite=null;};/**
	 * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
	 *
	 * @method drawShape
	 * @param {Circle|Rectangle|Ellipse|Line|Polygon} shape The Shape object to draw.
	 * @return {GraphicsData} The generated GraphicsData object.
	 */PIXI.Graphics.prototype.drawShape=function(shape){if(this.currentPath){// check current path!
	if(this.currentPath.shape.points.length<=2){this.graphicsData.pop();}}this.currentPath=null;//  Handle mixed-type polygons
	if(shape instanceof Phaser.Polygon){shape=shape.clone();shape.flatten();}var data=new PIXI.GraphicsData(this.lineWidth,this.lineColor,this.lineAlpha,this.fillColor,this.fillAlpha,this.filling,shape);this.graphicsData.push(data);if(data.type===PIXI.Graphics.POLY){data.shape.closed=this.filling;this.currentPath=data;}this.dirty=true;this._boundsDirty=true;return data;};/**
	 * When cacheAsBitmap is set to true the graphics object will be rendered as if it was a sprite.
	 * This is useful if your graphics element does not change often, as it will speed up the rendering of the object in exchange for taking up texture memory.
	 * It is also useful if you need the graphics object to be anti-aliased, because it will be rendered using canvas.
	 * This is not recommended if you are constantly redrawing the graphics element.
	 *
	 * @property cacheAsBitmap
	 * @type Boolean
	 * @default false
	 * @private
	 */Object.defineProperty(PIXI.Graphics.prototype,"cacheAsBitmap",{get:function get(){return this._cacheAsBitmap;},set:function set(value){this._cacheAsBitmap=value;if(this._cacheAsBitmap){this._generateCachedSprite();}else{this.destroyCachedSprite();}this.dirty=true;this.webGLDirty=true;}});/**
	 * A GraphicsData object.
	 * 
	 * @class GraphicsData
	 * @constructor
	PIXI.GraphicsData = function(lineWidth, lineColor, lineAlpha, fillColor, fillAlpha, fill, shape)
	{
	    this.lineWidth = lineWidth;
	    this.lineColor = lineColor;
	    this.lineAlpha = lineAlpha;
	    this._lineTint = lineColor;
	
	    this.fillColor = fillColor;
	    this.fillAlpha = fillAlpha;
	    this._fillTint = fillColor;
	    this.fill = fill;
	
	    this.shape = shape;
	    this.type = shape.type;
	};
	 *//**
	 * A GraphicsData object.
	 *
	 * @class
	 * @memberof PIXI
	 * @param lineWidth {number} the width of the line to draw
	 * @param lineColor {number} the color of the line to draw
	 * @param lineAlpha {number} the alpha of the line to draw
	 * @param fillColor {number} the color of the fill
	 * @param fillAlpha {number} the alpha of the fill
	 * @param fill      {boolean} whether or not the shape is filled with a colour
	 * @param shape     {Circle|Rectangle|Ellipse|Line|Polygon} The shape object to draw.
	 */PIXI.GraphicsData=function(lineWidth,lineColor,lineAlpha,fillColor,fillAlpha,fill,shape){/*
	     * @member {number} the width of the line to draw
	     */this.lineWidth=lineWidth;/*
	     * @member {number} the color of the line to draw
	     */this.lineColor=lineColor;/*
	     * @member {number} the alpha of the line to draw
	     */this.lineAlpha=lineAlpha;/*
	     * @member {number} cached tint of the line to draw
	     */this._lineTint=lineColor;/*
	     * @member {number} the color of the fill
	     */this.fillColor=fillColor;/*
	     * @member {number} the alpha of the fill
	     */this.fillAlpha=fillAlpha;/*
	     * @member {number} cached tint of the fill
	     */this._fillTint=fillColor;/*
	     * @member {boolean} whether or not the shape is filled with a color
	     */this.fill=fill;/*
	     * @member {Circle|Rectangle|Ellipse|Line|Polygon} The shape object to draw.
	     */this.shape=shape;/*
	     * @member {number} The type of the shape, see the Const.Shapes file for all the existing types,
	     */this.type=shape.type;};PIXI.GraphicsData.prototype.constructor=PIXI.GraphicsData;/**
	 * Creates a new GraphicsData object with the same values as this one.
	 *
	 * @return {GraphicsData}
	 */PIXI.GraphicsData.prototype.clone=function(){return new GraphicsData(this.lineWidth,this.lineColor,this.lineAlpha,this.fillColor,this.fillAlpha,this.fill,this.shape);};/*
	Copyright (c) 2016, Mapbox
	
	Permission to use, copy, modify, and/or distribute this software for any purpose
	with or without fee is hereby granted, provided that the above copyright notice
	and this permission notice appear in all copies.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
	FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS
	OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
	TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF
	THIS SOFTWARE.
	*//**
	* @class EarCut
	*/PIXI.EarCut={};PIXI.EarCut.Triangulate=function(data,holeIndices,dim){dim=dim||2;var hasHoles=holeIndices&&holeIndices.length,outerLen=hasHoles?holeIndices[0]*dim:data.length,outerNode=PIXI.EarCut.linkedList(data,0,outerLen,dim,true),triangles=[];if(!outerNode)return triangles;var minX,minY,maxX,maxY,x,y,size;if(hasHoles)outerNode=PIXI.EarCut.eliminateHoles(data,holeIndices,outerNode,dim);// if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
	if(data.length>80*dim){minX=maxX=data[0];minY=maxY=data[1];for(var i=dim;i<outerLen;i+=dim){x=data[i];y=data[i+1];if(x<minX)minX=x;if(y<minY)minY=y;if(x>maxX)maxX=x;if(y>maxY)maxY=y;}// minX, minY and size are later used to transform coords into integers for z-order calculation
	size=Math.max(maxX-minX,maxY-minY);}PIXI.EarCut.earcutLinked(outerNode,triangles,dim,minX,minY,size);return triangles;};// create a circular doubly linked list from polygon points in the specified winding order
	PIXI.EarCut.linkedList=function(data,start,end,dim,clockwise){var sum=0,i,j,last;// calculate original winding order of a polygon ring
	for(i=start,j=end-dim;i<end;i+=dim){sum+=(data[j]-data[i])*(data[i+1]+data[j+1]);j=i;}// link points into circular doubly-linked list in the specified winding order
	if(clockwise===sum>0){for(i=start;i<end;i+=dim){last=PIXI.EarCut.insertNode(i,data[i],data[i+1],last);}}else{for(i=end-dim;i>=start;i-=dim){last=PIXI.EarCut.insertNode(i,data[i],data[i+1],last);}}return last;};// eliminate colinear or duplicate points
	PIXI.EarCut.filterPoints=function(start,end){if(!start)return start;if(!end)end=start;var p=start,again;do{again=false;if(!p.steiner&&(PIXI.EarCut.equals(p,p.next)||PIXI.EarCut.area(p.prev,p,p.next)===0)){PIXI.EarCut.removeNode(p);p=end=p.prev;if(p===p.next)return null;again=true;}else{p=p.next;}}while(again||p!==end);return end;};// main ear slicing loop which triangulates a polygon (given as a linked list)
	PIXI.EarCut.earcutLinked=function(ear,triangles,dim,minX,minY,size,pass){if(!ear)return;// interlink polygon nodes in z-order
	if(!pass&&size)PIXI.EarCut.indexCurve(ear,minX,minY,size);var stop=ear,prev,next;// iterate through ears, slicing them one by one
	while(ear.prev!==ear.next){prev=ear.prev;next=ear.next;if(size?PIXI.EarCut.isEarHashed(ear,minX,minY,size):PIXI.EarCut.isEar(ear)){// cut off the triangle
	triangles.push(prev.i/dim);triangles.push(ear.i/dim);triangles.push(next.i/dim);PIXI.EarCut.removeNode(ear);// skipping the next vertice leads to less sliver triangles
	ear=next.next;stop=next.next;continue;}ear=next;// if we looped through the whole remaining polygon and can't find any more ears
	if(ear===stop){// try filtering points and slicing again
	if(!pass){PIXI.EarCut.earcutLinked(PIXI.EarCut.filterPoints(ear),triangles,dim,minX,minY,size,1);// if this didn't work, try curing all small self-intersections locally
	}else if(pass===1){ear=PIXI.EarCut.cureLocalIntersections(ear,triangles,dim);PIXI.EarCut.earcutLinked(ear,triangles,dim,minX,minY,size,2);// as a last resort, try splitting the remaining polygon into two
	}else if(pass===2){PIXI.EarCut.splitEarcut(ear,triangles,dim,minX,minY,size);}break;}}};// check whether a polygon node forms a valid ear with adjacent nodes
	PIXI.EarCut.isEar=function(ear){var a=ear.prev,b=ear,c=ear.next;if(PIXI.EarCut.area(a,b,c)>=0)return false;// reflex, can't be an ear
	// now make sure we don't have other points inside the potential ear
	var p=ear.next.next;while(p!==ear.prev){if(PIXI.EarCut.pointInTriangle(a.x,a.y,b.x,b.y,c.x,c.y,p.x,p.y)&&PIXI.EarCut.area(p.prev,p,p.next)>=0)return false;p=p.next;}return true;};PIXI.EarCut.isEarHashed=function(ear,minX,minY,size){var a=ear.prev,b=ear,c=ear.next;if(PIXI.EarCut.area(a,b,c)>=0)return false;// reflex, can't be an ear
	// triangle bbox; min & max are calculated like this for speed
	var minTX=a.x<b.x?a.x<c.x?a.x:c.x:b.x<c.x?b.x:c.x,minTY=a.y<b.y?a.y<c.y?a.y:c.y:b.y<c.y?b.y:c.y,maxTX=a.x>b.x?a.x>c.x?a.x:c.x:b.x>c.x?b.x:c.x,maxTY=a.y>b.y?a.y>c.y?a.y:c.y:b.y>c.y?b.y:c.y;// z-order range for the current triangle bbox;
	var minZ=PIXI.EarCut.zOrder(minTX,minTY,minX,minY,size),maxZ=PIXI.EarCut.zOrder(maxTX,maxTY,minX,minY,size);// first look for points inside the triangle in increasing z-order
	var p=ear.nextZ;while(p&&p.z<=maxZ){if(p!==ear.prev&&p!==ear.next&&PIXI.EarCut.pointInTriangle(a.x,a.y,b.x,b.y,c.x,c.y,p.x,p.y)&&PIXI.EarCut.area(p.prev,p,p.next)>=0)return false;p=p.nextZ;}// then look for points in decreasing z-order
	p=ear.prevZ;while(p&&p.z>=minZ){if(p!==ear.prev&&p!==ear.next&&PIXI.EarCut.pointInTriangle(a.x,a.y,b.x,b.y,c.x,c.y,p.x,p.y)&&PIXI.EarCut.area(p.prev,p,p.next)>=0)return false;p=p.prevZ;}return true;};// go through all polygon nodes and cure small local self-intersections
	PIXI.EarCut.cureLocalIntersections=function(start,triangles,dim){var p=start;do{var a=p.prev,b=p.next.next;// a self-intersection where edge (v[i-1],v[i]) intersects (v[i+1],v[i+2])
	if(PIXI.EarCut.intersects(a,p,p.next,b)&&PIXI.EarCut.locallyInside(a,b)&&PIXI.EarCut.locallyInside(b,a)){triangles.push(a.i/dim);triangles.push(p.i/dim);triangles.push(b.i/dim);// remove two nodes involved
	PIXI.EarCut.removeNode(p);PIXI.EarCut.removeNode(p.next);p=start=b;}p=p.next;}while(p!==start);return p;};// try splitting polygon into two and triangulate them independently
	PIXI.EarCut.splitEarcut=function(start,triangles,dim,minX,minY,size){// look for a valid diagonal that divides the polygon into two
	var a=start;do{var b=a.next.next;while(b!==a.prev){if(a.i!==b.i&&PIXI.EarCut.isValidDiagonal(a,b)){// split the polygon in two by the diagonal
	var c=PIXI.EarCut.splitPolygon(a,b);// filter colinear points around the cuts
	a=PIXI.EarCut.filterPoints(a,a.next);c=PIXI.EarCut.filterPoints(c,c.next);// run earcut on each half
	PIXI.EarCut.earcutLinked(a,triangles,dim,minX,minY,size);PIXI.EarCut.earcutLinked(c,triangles,dim,minX,minY,size);return;}b=b.next;}a=a.next;}while(a!==start);};// link every hole into the outer loop, producing a single-ring polygon without holes
	PIXI.EarCut.eliminateHoles=function(data,holeIndices,outerNode,dim){var queue=[],i,len,start,end,list;for(i=0,len=holeIndices.length;i<len;i++){start=holeIndices[i]*dim;end=i<len-1?holeIndices[i+1]*dim:data.length;list=PIXI.EarCut.linkedList(data,start,end,dim,false);if(list===list.next)list.steiner=true;queue.push(PIXI.EarCut.getLeftmost(list));}queue.sort(compareX);// process holes from left to right
	for(i=0;i<queue.length;i++){PIXI.EarCut.eliminateHole(queue[i],outerNode);outerNode=PIXI.EarCut.filterPoints(outerNode,outerNode.next);}return outerNode;};PIXI.EarCut.compareX=function(a,b){return a.x-b.x;};// find a bridge between vertices that connects hole with an outer ring and and link it
	PIXI.EarCut.eliminateHole=function(hole,outerNode){outerNode=PIXI.EarCut.findHoleBridge(hole,outerNode);if(outerNode){var b=PIXI.EarCut.splitPolygon(outerNode,hole);PIXI.EarCut.filterPoints(b,b.next);}};// David Eberly's algorithm for finding a bridge between hole and outer polygon
	PIXI.EarCut.findHoleBridge=function(hole,outerNode){var p=outerNode,hx=hole.x,hy=hole.y,qx=-Infinity,m;// find a segment intersected by a ray from the hole's leftmost point to the left;
	// segment's endpoint with lesser x will be potential connection point
	do{if(hy<=p.y&&hy>=p.next.y){var x=p.x+(hy-p.y)*(p.next.x-p.x)/(p.next.y-p.y);if(x<=hx&&x>qx){qx=x;m=p.x<p.next.x?p:p.next;}}p=p.next;}while(p!==outerNode);if(!m)return null;if(hole.x===m.x)return m.prev;// hole touches outer segment; pick lower endpoint
	// look for points inside the triangle of hole point, segment intersection and endpoint;
	// if there are no points found, we have a valid connection;
	// otherwise choose the point of the minimum angle with the ray as connection point
	var stop=m,tanMin=Infinity,tan;p=m.next;while(p!==stop){if(hx>=p.x&&p.x>=m.x&&PIXI.EarCut.pointInTriangle(hy<m.y?hx:qx,hy,m.x,m.y,hy<m.y?qx:hx,hy,p.x,p.y)){tan=Math.abs(hy-p.y)/(hx-p.x);// tangential
	if((tan<tanMin||tan===tanMin&&p.x>m.x)&&PIXI.EarCut.locallyInside(p,hole)){m=p;tanMin=tan;}}p=p.next;}return m;};// interlink polygon nodes in z-order
	PIXI.EarCut.indexCurve=function(start,minX,minY,size){var p=start;do{if(p.z===null)p.z=PIXI.EarCut.zOrder(p.x,p.y,minX,minY,size);p.prevZ=p.prev;p.nextZ=p.next;p=p.next;}while(p!==start);p.prevZ.nextZ=null;p.prevZ=null;PIXI.EarCut.sortLinked(p);};// Simon Tatham's linked list merge sort algorithm
	// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
	PIXI.EarCut.sortLinked=function(list){var i,p,q,e,tail,numMerges,pSize,qSize,inSize=1;do{p=list;list=null;tail=null;numMerges=0;while(p){numMerges++;q=p;pSize=0;for(i=0;i<inSize;i++){pSize++;q=q.nextZ;if(!q)break;}qSize=inSize;while(pSize>0||qSize>0&&q){if(pSize===0){e=q;q=q.nextZ;qSize--;}else if(qSize===0||!q){e=p;p=p.nextZ;pSize--;}else if(p.z<=q.z){e=p;p=p.nextZ;pSize--;}else{e=q;q=q.nextZ;qSize--;}if(tail)tail.nextZ=e;else list=e;e.prevZ=tail;tail=e;}p=q;}tail.nextZ=null;inSize*=2;}while(numMerges>1);return list;};// z-order of a point given coords and size of the data bounding box
	PIXI.EarCut.zOrder=function(x,y,minX,minY,size){// coords are transformed into non-negative 15-bit integer range
	x=32767*(x-minX)/size;y=32767*(y-minY)/size;x=(x|x<<8)&0x00FF00FF;x=(x|x<<4)&0x0F0F0F0F;x=(x|x<<2)&0x33333333;x=(x|x<<1)&0x55555555;y=(y|y<<8)&0x00FF00FF;y=(y|y<<4)&0x0F0F0F0F;y=(y|y<<2)&0x33333333;y=(y|y<<1)&0x55555555;return x|y<<1;};// find the leftmost node of a polygon ring
	PIXI.EarCut.getLeftmost=function(start){var p=start,leftmost=start;do{if(p.x<leftmost.x)leftmost=p;p=p.next;}while(p!==start);return leftmost;};// check if a point lies within a convex triangle
	PIXI.EarCut.pointInTriangle=function(ax,ay,bx,by,cx,cy,px,py){return(cx-px)*(ay-py)-(ax-px)*(cy-py)>=0&&(ax-px)*(by-py)-(bx-px)*(ay-py)>=0&&(bx-px)*(cy-py)-(cx-px)*(by-py)>=0;};// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
	PIXI.EarCut.isValidDiagonal=function(a,b){return PIXI.EarCut.equals(a,b)||a.next.i!==b.i&&a.prev.i!==b.i&&!PIXI.EarCut.intersectsPolygon(a,b)&&PIXI.EarCut.locallyInside(a,b)&&PIXI.EarCut.locallyInside(b,a)&&PIXI.EarCut.middleInside(a,b);};// signed area of a triangle
	PIXI.EarCut.area=function(p,q,r){return(q.y-p.y)*(r.x-q.x)-(q.x-p.x)*(r.y-q.y);};// check if two points are equal
	PIXI.EarCut.equals=function(p1,p2){return p1.x===p2.x&&p1.y===p2.y;};// check if two segments intersect
	PIXI.EarCut.intersects=function(p1,q1,p2,q2){return PIXI.EarCut.area(p1,q1,p2)>0!==PIXI.EarCut.area(p1,q1,q2)>0&&PIXI.EarCut.area(p2,q2,p1)>0!==PIXI.EarCut.area(p2,q2,q1)>0;};// check if a polygon diagonal intersects any polygon segments
	PIXI.EarCut.intersectsPolygon=function(a,b){var p=a;do{if(p.i!==a.i&&p.next.i!==a.i&&p.i!==b.i&&p.next.i!==b.i&&PIXI.EarCut.intersects(p,p.next,a,b))return true;p=p.next;}while(p!==a);return false;};// check if a polygon diagonal is locally inside the polygon
	PIXI.EarCut.locallyInside=function(a,b){return PIXI.EarCut.area(a.prev,a,a.next)<0?PIXI.EarCut.area(a,b,a.next)>=0&&PIXI.EarCut.area(a,a.prev,b)>=0:PIXI.EarCut.area(a,b,a.prev)<0||PIXI.EarCut.area(a,a.next,b)<0;};// check if the middle point of a polygon diagonal is inside the polygon
	PIXI.EarCut.middleInside=function(a,b){var p=a,inside=false,px=(a.x+b.x)/2,py=(a.y+b.y)/2;do{if(p.y>py!==p.next.y>py&&px<(p.next.x-p.x)*(py-p.y)/(p.next.y-p.y)+p.x)inside=!inside;p=p.next;}while(p!==a);return inside;};// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
	// if one belongs to the outer ring and another to a hole, it merges it into a single ring
	PIXI.EarCut.splitPolygon=function(a,b){var a2=new PIXI.EarCut.Node(a.i,a.x,a.y),b2=new PIXI.EarCut.Node(b.i,b.x,b.y),an=a.next,bp=b.prev;a.next=b;b.prev=a;a2.next=an;an.prev=a2;b2.next=a2;a2.prev=b2;bp.next=b2;b2.prev=bp;return b2;};// create a node and optionally link it with previous one (in a circular doubly linked list)
	PIXI.EarCut.insertNode=function(i,x,y,last){var p=new PIXI.EarCut.Node(i,x,y);if(!last){p.prev=p;p.next=p;}else{p.next=last.next;p.prev=last;last.next.prev=p;last.next=p;}return p;};PIXI.EarCut.removeNode=function(p){p.next.prev=p.prev;p.prev.next=p.next;if(p.prevZ)p.prevZ.nextZ=p.nextZ;if(p.nextZ)p.nextZ.prevZ=p.prevZ;};PIXI.EarCut.Node=function(i,x,y){// vertice index in coordinates array
	this.i=i;// vertex coordinates
	this.x=x;this.y=y;// previous and next vertice nodes in a polygon ring
	this.prev=null;this.next=null;// z-order curve value
	this.z=null;// previous and next nodes in z-order
	this.prevZ=null;this.nextZ=null;// indicates whether this is a steiner point
	this.steiner=false;};/**
	 * @author Mat Groves http://matgroves.com/ @Doormat23
	 *//**
	 * A set of functions used by the webGL renderer to draw the primitive graphics data
	 *
	 * @class WebGLGraphics
	 * @private
	 * @static
	 */PIXI.WebGLGraphics=function(){};/**
	 * The number of points beyond which Pixi swaps to using the Stencil Buffer to render the Graphics.
	 *
	 * @type {number}
	 */PIXI.WebGLGraphics.stencilBufferLimit=6;/**
	 * Renders the graphics object
	 *
	 * @static
	 * @private
	 * @method renderGraphics
	 * @param graphics {Graphics}
	 * @param renderSession {Object}
	 */PIXI.WebGLGraphics.renderGraphics=function(graphics,renderSession)//projection, offset)
	{var gl=renderSession.gl;var projection=renderSession.projection,offset=renderSession.offset,shader=renderSession.shaderManager.primitiveShader,webGLData;if(graphics.dirty){PIXI.WebGLGraphics.updateGraphics(graphics,gl);}var webGL=graphics._webGL[gl.id];// This  could be speeded up for sure!
	for(var i=0;i<webGL.data.length;i++){if(webGL.data[i].mode===1){webGLData=webGL.data[i];renderSession.stencilManager.pushStencil(graphics,webGLData,renderSession);// render quad..
	gl.drawElements(gl.TRIANGLE_FAN,4,gl.UNSIGNED_SHORT,(webGLData.indices.length-4)*2);renderSession.stencilManager.popStencil(graphics,webGLData,renderSession);}else{webGLData=webGL.data[i];renderSession.shaderManager.setShader(shader);//activatePrimitiveShader();
	shader=renderSession.shaderManager.primitiveShader;gl.uniformMatrix3fv(shader.translationMatrix,false,graphics.worldTransform.toArray(true));gl.uniform1f(shader.flipY,1);gl.uniform2f(shader.projectionVector,projection.x,-projection.y);gl.uniform2f(shader.offsetVector,-offset.x,-offset.y);gl.uniform3fv(shader.tintColor,PIXI.hex2rgb(graphics.tint));gl.uniform1f(shader.alpha,graphics.worldAlpha);gl.bindBuffer(gl.ARRAY_BUFFER,webGLData.buffer);gl.vertexAttribPointer(shader.aVertexPosition,2,gl.FLOAT,false,4*6,0);gl.vertexAttribPointer(shader.colorAttribute,4,gl.FLOAT,false,4*6,2*4);// set the index buffer!
	gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,webGLData.indexBuffer);gl.drawElements(gl.TRIANGLE_STRIP,webGLData.indices.length,gl.UNSIGNED_SHORT,0);}}};/**
	 * Updates the graphics object
	 *
	 * @static
	 * @private
	 * @method updateGraphics
	 * @param graphicsData {Graphics} The graphics object to update
	 * @param gl {WebGLContext} the current WebGL drawing context
	 */PIXI.WebGLGraphics.updateGraphics=function(graphics,gl){// get the contexts graphics object
	var webGL=graphics._webGL[gl.id];// if the graphics object does not exist in the webGL context time to create it!
	if(!webGL)webGL=graphics._webGL[gl.id]={lastIndex:0,data:[],gl:gl};// flag the graphics as not dirty as we are about to update it...
	graphics.dirty=false;var i;// if the user cleared the graphics object we will need to clear every object
	if(graphics.clearDirty){graphics.clearDirty=false;// lop through and return all the webGLDatas to the object pool so than can be reused later on
	for(i=0;i<webGL.data.length;i++){var graphicsData=webGL.data[i];graphicsData.reset();PIXI.WebGLGraphics.graphicsDataPool.push(graphicsData);}// clear the array and reset the index.. 
	webGL.data=[];webGL.lastIndex=0;}var webGLData;// loop through the graphics datas and construct each one..
	// if the object is a complex fill then the new stencil buffer technique will be used
	// other wise graphics objects will be pushed into a batch..
	for(i=webGL.lastIndex;i<graphics.graphicsData.length;i++){var data=graphics.graphicsData[i];if(data.type===PIXI.Graphics.POLY){// need to add the points the the graphics object..
	data.points=data.shape.points.slice();if(data.shape.closed){// close the poly if the value is true!
	if(data.points[0]!==data.points[data.points.length-2]||data.points[1]!==data.points[data.points.length-1]){data.points.push(data.points[0],data.points[1]);}}// MAKE SURE WE HAVE THE CORRECT TYPE..
	if(data.fill){if(data.points.length>=PIXI.WebGLGraphics.stencilBufferLimit){if(data.points.length<PIXI.WebGLGraphics.stencilBufferLimit*2){webGLData=PIXI.WebGLGraphics.switchMode(webGL,0);var canDrawUsingSimple=PIXI.WebGLGraphics.buildPoly(data,webGLData);//     console.log(canDrawUsingSimple);
	if(!canDrawUsingSimple){//    console.log("<>>>")
	webGLData=PIXI.WebGLGraphics.switchMode(webGL,1);PIXI.WebGLGraphics.buildComplexPoly(data,webGLData);}}else{webGLData=PIXI.WebGLGraphics.switchMode(webGL,1);PIXI.WebGLGraphics.buildComplexPoly(data,webGLData);}}}if(data.lineWidth>0){webGLData=PIXI.WebGLGraphics.switchMode(webGL,0);PIXI.WebGLGraphics.buildLine(data,webGLData);}}else{webGLData=PIXI.WebGLGraphics.switchMode(webGL,0);if(data.type===PIXI.Graphics.RECT){PIXI.WebGLGraphics.buildRectangle(data,webGLData);}else if(data.type===PIXI.Graphics.CIRC||data.type===PIXI.Graphics.ELIP){PIXI.WebGLGraphics.buildCircle(data,webGLData);}else if(data.type===PIXI.Graphics.RREC){PIXI.WebGLGraphics.buildRoundedRectangle(data,webGLData);}}webGL.lastIndex++;}// upload all the dirty data...
	for(i=0;i<webGL.data.length;i++){webGLData=webGL.data[i];if(webGLData.dirty)webGLData.upload();}};/**
	 * @static
	 * @private
	 * @method switchMode
	 * @param webGL {WebGLContext}
	 * @param type {Number}
	 */PIXI.WebGLGraphics.switchMode=function(webGL,type){var webGLData;if(!webGL.data.length){webGLData=PIXI.WebGLGraphics.graphicsDataPool.pop()||new PIXI.WebGLGraphicsData(webGL.gl);webGLData.mode=type;webGL.data.push(webGLData);}else{webGLData=webGL.data[webGL.data.length-1];if(webGLData.mode!==type||type===1){webGLData=PIXI.WebGLGraphics.graphicsDataPool.pop()||new PIXI.WebGLGraphicsData(webGL.gl);webGLData.mode=type;webGL.data.push(webGLData);}}webGLData.dirty=true;return webGLData;};/**
	 * Builds a rectangle to draw
	 *
	 * @static
	 * @private
	 * @method buildRectangle
	 * @param graphicsData {Graphics} The graphics object containing all the necessary properties
	 * @param webGLData {Object}
	 */PIXI.WebGLGraphics.buildRectangle=function(graphicsData,webGLData){// --- //
	// need to convert points to a nice regular data
	//
	var rectData=graphicsData.shape;var x=rectData.x;var y=rectData.y;var width=rectData.width;var height=rectData.height;if(graphicsData.fill){var color=PIXI.hex2rgb(graphicsData.fillColor);var alpha=graphicsData.fillAlpha;var r=color[0]*alpha;var g=color[1]*alpha;var b=color[2]*alpha;var verts=webGLData.points;var indices=webGLData.indices;var vertPos=verts.length/6;// start
	verts.push(x,y);verts.push(r,g,b,alpha);verts.push(x+width,y);verts.push(r,g,b,alpha);verts.push(x,y+height);verts.push(r,g,b,alpha);verts.push(x+width,y+height);verts.push(r,g,b,alpha);// insert 2 dead triangles..
	indices.push(vertPos,vertPos,vertPos+1,vertPos+2,vertPos+3,vertPos+3);}if(graphicsData.lineWidth){var tempPoints=graphicsData.points;graphicsData.points=[x,y,x+width,y,x+width,y+height,x,y+height,x,y];PIXI.WebGLGraphics.buildLine(graphicsData,webGLData);graphicsData.points=tempPoints;}};/**
	 * Builds a rounded rectangle to draw
	 *
	 * @static
	 * @private
	 * @method buildRoundedRectangle
	 * @param graphicsData {Graphics} The graphics object containing all the necessary properties
	 * @param webGLData {Object}
	 */PIXI.WebGLGraphics.buildRoundedRectangle=function(graphicsData,webGLData){var rrectData=graphicsData.shape;var x=rrectData.x;var y=rrectData.y;var width=rrectData.width;var height=rrectData.height;var radius=rrectData.radius;var recPoints=[];recPoints.push(x,y+radius);recPoints=recPoints.concat(PIXI.WebGLGraphics.quadraticBezierCurve(x,y+height-radius,x,y+height,x+radius,y+height));recPoints=recPoints.concat(PIXI.WebGLGraphics.quadraticBezierCurve(x+width-radius,y+height,x+width,y+height,x+width,y+height-radius));recPoints=recPoints.concat(PIXI.WebGLGraphics.quadraticBezierCurve(x+width,y+radius,x+width,y,x+width-radius,y));recPoints=recPoints.concat(PIXI.WebGLGraphics.quadraticBezierCurve(x+radius,y,x,y,x,y+radius));if(graphicsData.fill){var color=PIXI.hex2rgb(graphicsData.fillColor);var alpha=graphicsData.fillAlpha;var r=color[0]*alpha;var g=color[1]*alpha;var b=color[2]*alpha;var verts=webGLData.points;var indices=webGLData.indices;var vecPos=verts.length/6;var triangles=PIXI.EarCut.Triangulate(recPoints,null,2);var i=0;for(i=0;i<triangles.length;i+=3){indices.push(triangles[i]+vecPos);indices.push(triangles[i]+vecPos);indices.push(triangles[i+1]+vecPos);indices.push(triangles[i+2]+vecPos);indices.push(triangles[i+2]+vecPos);}for(i=0;i<recPoints.length;i++){verts.push(recPoints[i],recPoints[++i],r,g,b,alpha);}}if(graphicsData.lineWidth){var tempPoints=graphicsData.points;graphicsData.points=recPoints;PIXI.WebGLGraphics.buildLine(graphicsData,webGLData);graphicsData.points=tempPoints;}};/**
	 * Calculate the points for a quadratic bezier curve. (helper function..)
	 * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
	 *
	 * @static
	 * @private
	 * @method quadraticBezierCurve
	 * @param fromX {Number} Origin point x
	 * @param fromY {Number} Origin point x
	 * @param cpX {Number} Control point x
	 * @param cpY {Number} Control point y
	 * @param toX {Number} Destination point x
	 * @param toY {Number} Destination point y
	 * @return {Array(Number)}
	 */PIXI.WebGLGraphics.quadraticBezierCurve=function(fromX,fromY,cpX,cpY,toX,toY){var xa,ya,xb,yb,x,y,n=20,points=[];function getPt(n1,n2,perc){var diff=n2-n1;return n1+diff*perc;}var j=0;for(var i=0;i<=n;i++){j=i/n;// The Green Line
	xa=getPt(fromX,cpX,j);ya=getPt(fromY,cpY,j);xb=getPt(cpX,toX,j);yb=getPt(cpY,toY,j);// The Black Dot
	x=getPt(xa,xb,j);y=getPt(ya,yb,j);points.push(x,y);}return points;};/**
	 * Builds a circle to draw
	 *
	 * @static
	 * @private
	 * @method buildCircle
	 * @param graphicsData {Graphics} The graphics object to draw
	 * @param webGLData {Object}
	 */PIXI.WebGLGraphics.buildCircle=function(graphicsData,webGLData){// need to convert points to a nice regular data
	var circleData=graphicsData.shape;var x=circleData.x;var y=circleData.y;var width;var height;// TODO - bit hacky??
	if(graphicsData.type===PIXI.Graphics.CIRC){width=circleData.radius;height=circleData.radius;}else{width=circleData.width;height=circleData.height;}var totalSegs=40;var seg=Math.PI*2/totalSegs;var i=0;if(graphicsData.fill){var color=PIXI.hex2rgb(graphicsData.fillColor);var alpha=graphicsData.fillAlpha;var r=color[0]*alpha;var g=color[1]*alpha;var b=color[2]*alpha;var verts=webGLData.points;var indices=webGLData.indices;var vecPos=verts.length/6;indices.push(vecPos);for(i=0;i<totalSegs+1;i++){verts.push(x,y,r,g,b,alpha);verts.push(x+Math.sin(seg*i)*width,y+Math.cos(seg*i)*height,r,g,b,alpha);indices.push(vecPos++,vecPos++);}indices.push(vecPos-1);}if(graphicsData.lineWidth){var tempPoints=graphicsData.points;graphicsData.points=[];for(i=0;i<totalSegs+1;i++){graphicsData.points.push(x+Math.sin(seg*i)*width,y+Math.cos(seg*i)*height);}PIXI.WebGLGraphics.buildLine(graphicsData,webGLData);graphicsData.points=tempPoints;}};/**
	 * Builds a line to draw
	 *
	 * @static
	 * @private
	 * @method buildLine
	 * @param graphicsData {Graphics} The graphics object containing all the necessary properties
	 * @param webGLData {Object}
	 */PIXI.WebGLGraphics.buildLine=function(graphicsData,webGLData){// TODO OPTIMISE!
	var i=0;var points=graphicsData.points;if(points.length===0)return;// if the line width is an odd number add 0.5 to align to a whole pixel
	if(graphicsData.lineWidth%2){for(i=0;i<points.length;i++){points[i]+=0.5;}}// get first and last point.. figure out the middle!
	var firstPoint=new PIXI.Point(points[0],points[1]);var lastPoint=new PIXI.Point(points[points.length-2],points[points.length-1]);// if the first point is the last point - gonna have issues :)
	if(firstPoint.x===lastPoint.x&&firstPoint.y===lastPoint.y){// need to clone as we are going to slightly modify the shape..
	points=points.slice();points.pop();points.pop();lastPoint=new PIXI.Point(points[points.length-2],points[points.length-1]);var midPointX=lastPoint.x+(firstPoint.x-lastPoint.x)*0.5;var midPointY=lastPoint.y+(firstPoint.y-lastPoint.y)*0.5;points.unshift(midPointX,midPointY);points.push(midPointX,midPointY);}var verts=webGLData.points;var indices=webGLData.indices;var length=points.length/2;var indexCount=points.length;var indexStart=verts.length/6;// DRAW the Line
	var width=graphicsData.lineWidth/2;// sort color
	var color=PIXI.hex2rgb(graphicsData.lineColor);var alpha=graphicsData.lineAlpha;var r=color[0]*alpha;var g=color[1]*alpha;var b=color[2]*alpha;var px,py,p1x,p1y,p2x,p2y,p3x,p3y;var perpx,perpy,perp2x,perp2y,perp3x,perp3y;var a1,b1,c1,a2,b2,c2;var denom,pdist,dist;p1x=points[0];p1y=points[1];p2x=points[2];p2y=points[3];perpx=-(p1y-p2y);perpy=p1x-p2x;dist=Math.sqrt(perpx*perpx+perpy*perpy);perpx/=dist;perpy/=dist;perpx*=width;perpy*=width;// start
	verts.push(p1x-perpx,p1y-perpy,r,g,b,alpha);verts.push(p1x+perpx,p1y+perpy,r,g,b,alpha);for(i=1;i<length-1;i++){p1x=points[(i-1)*2];p1y=points[(i-1)*2+1];p2x=points[i*2];p2y=points[i*2+1];p3x=points[(i+1)*2];p3y=points[(i+1)*2+1];perpx=-(p1y-p2y);perpy=p1x-p2x;dist=Math.sqrt(perpx*perpx+perpy*perpy);perpx/=dist;perpy/=dist;perpx*=width;perpy*=width;perp2x=-(p2y-p3y);perp2y=p2x-p3x;dist=Math.sqrt(perp2x*perp2x+perp2y*perp2y);perp2x/=dist;perp2y/=dist;perp2x*=width;perp2y*=width;a1=-perpy+p1y-(-perpy+p2y);b1=-perpx+p2x-(-perpx+p1x);c1=(-perpx+p1x)*(-perpy+p2y)-(-perpx+p2x)*(-perpy+p1y);a2=-perp2y+p3y-(-perp2y+p2y);b2=-perp2x+p2x-(-perp2x+p3x);c2=(-perp2x+p3x)*(-perp2y+p2y)-(-perp2x+p2x)*(-perp2y+p3y);denom=a1*b2-a2*b1;if(Math.abs(denom)<0.1){denom+=10.1;verts.push(p2x-perpx,p2y-perpy,r,g,b,alpha);verts.push(p2x+perpx,p2y+perpy,r,g,b,alpha);continue;}px=(b1*c2-b2*c1)/denom;py=(a2*c1-a1*c2)/denom;pdist=(px-p2x)*(px-p2x)+(py-p2y)+(py-p2y);if(pdist>140*140){perp3x=perpx-perp2x;perp3y=perpy-perp2y;dist=Math.sqrt(perp3x*perp3x+perp3y*perp3y);perp3x/=dist;perp3y/=dist;perp3x*=width;perp3y*=width;verts.push(p2x-perp3x,p2y-perp3y);verts.push(r,g,b,alpha);verts.push(p2x+perp3x,p2y+perp3y);verts.push(r,g,b,alpha);verts.push(p2x-perp3x,p2y-perp3y);verts.push(r,g,b,alpha);indexCount++;}else{verts.push(px,py);verts.push(r,g,b,alpha);verts.push(p2x-(px-p2x),p2y-(py-p2y));verts.push(r,g,b,alpha);}}p1x=points[(length-2)*2];p1y=points[(length-2)*2+1];p2x=points[(length-1)*2];p2y=points[(length-1)*2+1];perpx=-(p1y-p2y);perpy=p1x-p2x;dist=Math.sqrt(perpx*perpx+perpy*perpy);perpx/=dist;perpy/=dist;perpx*=width;perpy*=width;verts.push(p2x-perpx,p2y-perpy);verts.push(r,g,b,alpha);verts.push(p2x+perpx,p2y+perpy);verts.push(r,g,b,alpha);indices.push(indexStart);for(i=0;i<indexCount;i++){indices.push(indexStart++);}indices.push(indexStart-1);};/**
	 * Builds a complex polygon to draw
	 *
	 * @static
	 * @private
	 * @method buildComplexPoly
	 * @param graphicsData {Graphics} The graphics object containing all the necessary properties
	 * @param webGLData {Object}
	 */PIXI.WebGLGraphics.buildComplexPoly=function(graphicsData,webGLData){//TODO - no need to copy this as it gets turned into a FLoat32Array anyways..
	var points=graphicsData.points.slice();if(points.length<6)return;// get first and last point.. figure out the middle!
	var indices=webGLData.indices;webGLData.points=points;webGLData.alpha=graphicsData.fillAlpha;webGLData.color=PIXI.hex2rgb(graphicsData.fillColor);/*
	        calclate the bounds..
	    */var minX=Infinity;var maxX=-Infinity;var minY=Infinity;var maxY=-Infinity;var x,y;// get size..
	for(var i=0;i<points.length;i+=2){x=points[i];y=points[i+1];minX=x<minX?x:minX;maxX=x>maxX?x:maxX;minY=y<minY?y:minY;maxY=y>maxY?y:maxY;}// add a quad to the end cos there is no point making another buffer!
	points.push(minX,minY,maxX,minY,maxX,maxY,minX,maxY);// push a quad onto the end.. 
	//TODO - this aint needed!
	var length=points.length/2;for(i=0;i<length;i++){indices.push(i);}};/**
	 * Builds a polygon to draw
	 *
	 * @static
	 * @private
	 * @method buildPoly
	 * @param graphicsData {Graphics} The graphics object containing all the necessary properties
	 * @param webGLData {Object}
	 */PIXI.WebGLGraphics.buildPoly=function(graphicsData,webGLData){var points=graphicsData.points;if(points.length<6)return;// get first and last point.. figure out the middle!
	var verts=webGLData.points;var indices=webGLData.indices;var length=points.length/2;// sort color
	var color=PIXI.hex2rgb(graphicsData.fillColor);var alpha=graphicsData.fillAlpha;var r=color[0]*alpha;var g=color[1]*alpha;var b=color[2]*alpha;var triangles=PIXI.EarCut.Triangulate(points,null,2);if(!triangles)return false;var vertPos=verts.length/6;var i=0;for(i=0;i<triangles.length;i+=3){indices.push(triangles[i]+vertPos);indices.push(triangles[i]+vertPos);indices.push(triangles[i+1]+vertPos);indices.push(triangles[i+2]+vertPos);indices.push(triangles[i+2]+vertPos);}for(i=0;i<length;i++){verts.push(points[i*2],points[i*2+1],r,g,b,alpha);}return true;};PIXI.WebGLGraphics.graphicsDataPool=[];/**
	 * @class WebGLGraphicsData
	 * @private
	 * @static
	 */PIXI.WebGLGraphicsData=function(gl){this.gl=gl;//TODO does this need to be split before uploding??
	this.color=[0,0,0];// color split!
	this.points=[];this.indices=[];this.buffer=gl.createBuffer();this.indexBuffer=gl.createBuffer();this.mode=1;this.alpha=1;this.dirty=true;};/**
	 * @method reset
	 */PIXI.WebGLGraphicsData.prototype.reset=function(){this.points=[];this.indices=[];};/**
	 * @method upload
	 */PIXI.WebGLGraphicsData.prototype.upload=function(){var gl=this.gl;//    this.lastIndex = graphics.graphicsData.length;
	this.glPoints=new PIXI.Float32Array(this.points);gl.bindBuffer(gl.ARRAY_BUFFER,this.buffer);gl.bufferData(gl.ARRAY_BUFFER,this.glPoints,gl.STATIC_DRAW);this.glIndicies=new PIXI.Uint16Array(this.indices);gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,this.indexBuffer);gl.bufferData(gl.ELEMENT_ARRAY_BUFFER,this.glIndicies,gl.STATIC_DRAW);this.dirty=false;};/**
	 * @author Mat Groves http://matgroves.com/ @Doormat23
	 *//**
	 * A set of functions used by the canvas renderer to draw the primitive graphics data.
	 *
	 * @class CanvasGraphics
	 * @static
	 */PIXI.CanvasGraphics=function(){};/*
	 * Renders a PIXI.Graphics object to a canvas.
	 *
	 * @method renderGraphics
	 * @static
	 * @param graphics {Graphics} the actual graphics object to render
	 * @param context {CanvasRenderingContext2D} the 2d drawing method of the canvas
	 */PIXI.CanvasGraphics.renderGraphics=function(graphics,context){var worldAlpha=graphics.worldAlpha;if(graphics.dirty){this.updateGraphicsTint(graphics);graphics.dirty=false;}for(var i=0;i<graphics.graphicsData.length;i++){var data=graphics.graphicsData[i];var shape=data.shape;var fillColor=data._fillTint;var lineColor=data._lineTint;context.lineWidth=data.lineWidth;if(data.type===PIXI.Graphics.POLY){context.beginPath();var points=shape.points;context.moveTo(points[0],points[1]);for(var j=1;j<points.length/2;j++){context.lineTo(points[j*2],points[j*2+1]);}if(shape.closed){context.lineTo(points[0],points[1]);}// if the first and last point are the same close the path - much neater :)
	if(points[0]===points[points.length-2]&&points[1]===points[points.length-1]){context.closePath();}if(data.fill){context.globalAlpha=data.fillAlpha*worldAlpha;context.fillStyle='#'+('00000'+(fillColor|0).toString(16)).substr(-6);context.fill();}if(data.lineWidth){context.globalAlpha=data.lineAlpha*worldAlpha;context.strokeStyle='#'+('00000'+(lineColor|0).toString(16)).substr(-6);context.stroke();}}else if(data.type===PIXI.Graphics.RECT){if(data.fillColor||data.fillColor===0){context.globalAlpha=data.fillAlpha*worldAlpha;context.fillStyle='#'+('00000'+(fillColor|0).toString(16)).substr(-6);context.fillRect(shape.x,shape.y,shape.width,shape.height);}if(data.lineWidth){context.globalAlpha=data.lineAlpha*worldAlpha;context.strokeStyle='#'+('00000'+(lineColor|0).toString(16)).substr(-6);context.strokeRect(shape.x,shape.y,shape.width,shape.height);}}else if(data.type===PIXI.Graphics.CIRC){// TODO - need to be Undefined!
	context.beginPath();context.arc(shape.x,shape.y,shape.radius,0,2*Math.PI);context.closePath();if(data.fill){context.globalAlpha=data.fillAlpha*worldAlpha;context.fillStyle='#'+('00000'+(fillColor|0).toString(16)).substr(-6);context.fill();}if(data.lineWidth){context.globalAlpha=data.lineAlpha*worldAlpha;context.strokeStyle='#'+('00000'+(lineColor|0).toString(16)).substr(-6);context.stroke();}}else if(data.type===PIXI.Graphics.ELIP){// ellipse code taken from: http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
	var w=shape.width*2;var h=shape.height*2;var x=shape.x-w/2;var y=shape.y-h/2;context.beginPath();var kappa=0.5522848,ox=w/2*kappa,// control point offset horizontal
	oy=h/2*kappa,// control point offset vertical
	xe=x+w,// x-end
	ye=y+h,// y-end
	xm=x+w/2,// x-middle
	ym=y+h/2;// y-middle
	context.moveTo(x,ym);context.bezierCurveTo(x,ym-oy,xm-ox,y,xm,y);context.bezierCurveTo(xm+ox,y,xe,ym-oy,xe,ym);context.bezierCurveTo(xe,ym+oy,xm+ox,ye,xm,ye);context.bezierCurveTo(xm-ox,ye,x,ym+oy,x,ym);context.closePath();if(data.fill){context.globalAlpha=data.fillAlpha*worldAlpha;context.fillStyle='#'+('00000'+(fillColor|0).toString(16)).substr(-6);context.fill();}if(data.lineWidth){context.globalAlpha=data.lineAlpha*worldAlpha;context.strokeStyle='#'+('00000'+(lineColor|0).toString(16)).substr(-6);context.stroke();}}else if(data.type===PIXI.Graphics.RREC){var rx=shape.x;var ry=shape.y;var width=shape.width;var height=shape.height;var radius=shape.radius;var maxRadius=Math.min(width,height)/2|0;radius=radius>maxRadius?maxRadius:radius;context.beginPath();context.moveTo(rx,ry+radius);context.lineTo(rx,ry+height-radius);context.quadraticCurveTo(rx,ry+height,rx+radius,ry+height);context.lineTo(rx+width-radius,ry+height);context.quadraticCurveTo(rx+width,ry+height,rx+width,ry+height-radius);context.lineTo(rx+width,ry+radius);context.quadraticCurveTo(rx+width,ry,rx+width-radius,ry);context.lineTo(rx+radius,ry);context.quadraticCurveTo(rx,ry,rx,ry+radius);context.closePath();if(data.fillColor||data.fillColor===0){context.globalAlpha=data.fillAlpha*worldAlpha;context.fillStyle='#'+('00000'+(fillColor|0).toString(16)).substr(-6);context.fill();}if(data.lineWidth){context.globalAlpha=data.lineAlpha*worldAlpha;context.strokeStyle='#'+('00000'+(lineColor|0).toString(16)).substr(-6);context.stroke();}}}};/*
	 * Renders a graphics mask
	 *
	 * @static
	 * @private
	 * @method renderGraphicsMask
	 * @param graphics {Graphics} the graphics which will be used as a mask
	 * @param context {CanvasRenderingContext2D} the context 2d method of the canvas
	 */PIXI.CanvasGraphics.renderGraphicsMask=function(graphics,context){var len=graphics.graphicsData.length;if(len===0){return;}context.beginPath();for(var i=0;i<len;i++){var data=graphics.graphicsData[i];var shape=data.shape;if(data.type===PIXI.Graphics.POLY){var points=shape.points;context.moveTo(points[0],points[1]);for(var j=1;j<points.length/2;j++){context.lineTo(points[j*2],points[j*2+1]);}// if the first and last point are the same close the path - much neater :)
	if(points[0]===points[points.length-2]&&points[1]===points[points.length-1]){context.closePath();}}else if(data.type===PIXI.Graphics.RECT){context.rect(shape.x,shape.y,shape.width,shape.height);context.closePath();}else if(data.type===PIXI.Graphics.CIRC){// TODO - need to be Undefined!
	context.arc(shape.x,shape.y,shape.radius,0,2*Math.PI);context.closePath();}else if(data.type===PIXI.Graphics.ELIP){// ellipse code taken from: http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
	var w=shape.width*2;var h=shape.height*2;var x=shape.x-w/2;var y=shape.y-h/2;var kappa=0.5522848,ox=w/2*kappa,// control point offset horizontal
	oy=h/2*kappa,// control point offset vertical
	xe=x+w,// x-end
	ye=y+h,// y-end
	xm=x+w/2,// x-middle
	ym=y+h/2;// y-middle
	context.moveTo(x,ym);context.bezierCurveTo(x,ym-oy,xm-ox,y,xm,y);context.bezierCurveTo(xm+ox,y,xe,ym-oy,xe,ym);context.bezierCurveTo(xe,ym+oy,xm+ox,ye,xm,ye);context.bezierCurveTo(xm-ox,ye,x,ym+oy,x,ym);context.closePath();}else if(data.type===PIXI.Graphics.RREC){var rx=shape.x;var ry=shape.y;var width=shape.width;var height=shape.height;var radius=shape.radius;var maxRadius=Math.min(width,height)/2|0;radius=radius>maxRadius?maxRadius:radius;context.moveTo(rx,ry+radius);context.lineTo(rx,ry+height-radius);context.quadraticCurveTo(rx,ry+height,rx+radius,ry+height);context.lineTo(rx+width-radius,ry+height);context.quadraticCurveTo(rx+width,ry+height,rx+width,ry+height-radius);context.lineTo(rx+width,ry+radius);context.quadraticCurveTo(rx+width,ry,rx+width-radius,ry);context.lineTo(rx+radius,ry);context.quadraticCurveTo(rx,ry,rx,ry+radius);context.closePath();}}};PIXI.CanvasGraphics.updateGraphicsTint=function(graphics){if(graphics.tint===0xFFFFFF){return;}var tintR=(graphics.tint>>16&0xFF)/255;var tintG=(graphics.tint>>8&0xFF)/255;var tintB=(graphics.tint&0xFF)/255;for(var i=0;i<graphics.graphicsData.length;i++){var data=graphics.graphicsData[i];var fillColor=data.fillColor|0;var lineColor=data.lineColor|0;data._fillTint=((fillColor>>16&0xFF)/255*tintR*255<<16)+((fillColor>>8&0xFF)/255*tintG*255<<8)+(fillColor&0xFF)/255*tintB*255;data._lineTint=((lineColor>>16&0xFF)/255*tintR*255<<16)+((lineColor>>8&0xFF)/255*tintG*255<<8)+(lineColor&0xFF)/255*tintB*255;}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A Graphics object is a way to draw primitives to your game. Primitives include forms of geometry, such as Rectangles,
	* Circles and Polygons. They also include lines, arcs and curves. When you initially create a Graphics object it will
	* be empty. To 'draw' to it you first specify a lineStyle or fillStyle (or both), and then draw a shape. For example:
	*
	* ```
	* graphics.beginFill(0xff0000);
	* graphics.drawCircle(50, 50, 100);
	* graphics.endFill();
	* ```
	* 
	* This will draw a circle shape to the Graphics object, with a diameter of 100, located at x: 50, y: 50.
	*
	* When a Graphics object is rendered it will render differently based on if the game is running under Canvas or
	* WebGL. Under Canvas it will use the HTML Canvas context drawing operations to draw the path. Under WebGL the
	* graphics data is decomposed into polygons. Both of these are expensive processes, especially with complex shapes.
	* 
	* If your Graphics object doesn't change much (or at all) once you've drawn your shape to it, then you will help
	* performance by calling `Graphics.generateTexture`. This will 'bake' the Graphics object into a Texture, and return it.
	* You can then use this Texture for Sprites or other display objects. If your Graphics object updates frequently then
	* you should avoid doing this, as it will constantly generate new textures, which will consume memory.
	*
	* As you can tell, Graphics objects are a bit of a trade-off. While they are extremely useful, you need to be careful
	* in their complexity and quantity of them in your game.
	*
	* @class Phaser.Graphics
	* @constructor
	* @extends PIXI.Graphics
	* @extends Phaser.Component.Core
	* @extends Phaser.Component.Angle
	* @extends Phaser.Component.AutoCull
	* @extends Phaser.Component.Bounds
	* @extends Phaser.Component.Destroy
	* @extends Phaser.Component.FixedToCamera
	* @extends Phaser.Component.InputEnabled
	* @extends Phaser.Component.InWorld
	* @extends Phaser.Component.LifeSpan
	* @extends Phaser.Component.PhysicsBody
	* @extends Phaser.Component.Reset
	* @param {Phaser.Game} game - Current game instance.
	* @param {number} [x=0] - X position of the new graphics object.
	* @param {number} [y=0] - Y position of the new graphics object.
	*/Phaser.Graphics=function(game,x,y){if(x===undefined){x=0;}if(y===undefined){y=0;}/**
	    * @property {number} type - The const type of this object.
	    * @default
	    */this.type=Phaser.GRAPHICS;/**
	    * @property {number} physicsType - The const physics body type of this object.
	    * @readonly
	    */this.physicsType=Phaser.SPRITE;/**
	    * @property {Phaser.Point} anchor - Required for a Graphics shape to work as a Physics body, do not modify this value.
	    * @private
	    */this.anchor=new Phaser.Point();PIXI.Graphics.call(this);Phaser.Component.Core.init.call(this,game,x,y,'',null);};Phaser.Graphics.prototype=Object.create(PIXI.Graphics.prototype);Phaser.Graphics.prototype.constructor=Phaser.Graphics;Phaser.Component.Core.install.call(Phaser.Graphics.prototype,['Angle','AutoCull','Bounds','Destroy','FixedToCamera','InputEnabled','InWorld','LifeSpan','PhysicsBody','Reset']);Phaser.Graphics.prototype.preUpdatePhysics=Phaser.Component.PhysicsBody.preUpdate;Phaser.Graphics.prototype.preUpdateLifeSpan=Phaser.Component.LifeSpan.preUpdate;Phaser.Graphics.prototype.preUpdateInWorld=Phaser.Component.InWorld.preUpdate;Phaser.Graphics.prototype.preUpdateCore=Phaser.Component.Core.preUpdate;/**
	* Automatically called by World.preUpdate.
	* 
	* @method
	* @memberof Phaser.Graphics
	*/Phaser.Graphics.prototype.preUpdate=function(){if(!this.preUpdatePhysics()||!this.preUpdateLifeSpan()||!this.preUpdateInWorld()){return false;}return this.preUpdateCore();};/**
	* Automatically called by World
	* @method Phaser.Graphics.prototype.postUpdate
	*/Phaser.Graphics.prototype.postUpdate=function(){Phaser.Component.PhysicsBody.postUpdate.call(this);Phaser.Component.FixedToCamera.postUpdate.call(this);if(this._boundsDirty){this.updateLocalBounds();this._boundsDirty=false;}for(var i=0;i<this.children.length;i++){this.children[i].postUpdate();}};/**
	* Destroy this Graphics instance.
	*
	* @method Phaser.Graphics.prototype.destroy
	* @param {boolean} [destroyChildren=true] - Should every child of this object have its destroy method called?
	*/Phaser.Graphics.prototype.destroy=function(destroyChildren){this.clear();Phaser.Component.Destroy.prototype.destroy.call(this,destroyChildren);};/*
	* Draws a single {Phaser.Polygon} triangle from a {Phaser.Point} array
	*
	* @method Phaser.Graphics.prototype.drawTriangle
	* @param {Array<Phaser.Point>} points - An array of Phaser.Points that make up the three vertices of this triangle
	* @param {boolean} [cull=false] - Should we check if the triangle is back-facing
	*/Phaser.Graphics.prototype.drawTriangle=function(points,cull){if(cull===undefined){cull=false;}var triangle=new Phaser.Polygon(points);if(cull){var cameraToFace=new Phaser.Point(this.game.camera.x-points[0].x,this.game.camera.y-points[0].y);var ab=new Phaser.Point(points[1].x-points[0].x,points[1].y-points[0].y);var cb=new Phaser.Point(points[1].x-points[2].x,points[1].y-points[2].y);var faceNormal=cb.cross(ab);if(cameraToFace.dot(faceNormal)>0){this.drawPolygon(triangle);}}else{this.drawPolygon(triangle);}};/*
	* Draws {Phaser.Polygon} triangles 
	*
	* @method Phaser.Graphics.prototype.drawTriangles
	* @param {Array<Phaser.Point>|Array<number>} vertices - An array of Phaser.Points or numbers that make up the vertices of the triangles
	* @param {Array<number>} {indices=null} - An array of numbers that describe what order to draw the vertices in
	* @param {boolean} [cull=false] - Should we check if the triangle is back-facing
	*/Phaser.Graphics.prototype.drawTriangles=function(vertices,indices,cull){if(cull===undefined){cull=false;}var point1=new Phaser.Point();var point2=new Phaser.Point();var point3=new Phaser.Point();var points=[];var i;if(!indices){if(vertices[0]instanceof Phaser.Point){for(i=0;i<vertices.length/3;i++){this.drawTriangle([vertices[i*3],vertices[i*3+1],vertices[i*3+2]],cull);}}else{for(i=0;i<vertices.length/6;i++){point1.x=vertices[i*6+0];point1.y=vertices[i*6+1];point2.x=vertices[i*6+2];point2.y=vertices[i*6+3];point3.x=vertices[i*6+4];point3.y=vertices[i*6+5];this.drawTriangle([point1,point2,point3],cull);}}}else{if(vertices[0]instanceof Phaser.Point){for(i=0;i<indices.length/3;i++){points.push(vertices[indices[i*3]]);points.push(vertices[indices[i*3+1]]);points.push(vertices[indices[i*3+2]]);if(points.length===3){this.drawTriangle(points,cull);points=[];}}}else{for(i=0;i<indices.length;i++){point1.x=vertices[indices[i]*2];point1.y=vertices[indices[i]*2+1];points.push(point1.copyTo({}));if(points.length===3){this.drawTriangle(points,cull);points=[];}}}}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A RenderTexture is a special texture that allows any displayObject to be rendered to it. It allows you to take many complex objects and
	* render them down into a single quad (on WebGL) which can then be used to texture other display objects with. A way of generating textures at run-time.
	* 
	* @class Phaser.RenderTexture
	* @constructor
	* @extends PIXI.RenderTexture
	* @param {Phaser.Game} game - Current game instance.
	* @param {number} [width=100] - The width of the render texture.
	* @param {number} [height=100] - The height of the render texture.
	* @param {string} [key=''] - The key of the RenderTexture in the Cache, if stored there.
	* @param {number} [scaleMode=Phaser.scaleModes.DEFAULT] - One of the Phaser.scaleModes consts.
	* @param {number} [resolution=1] - The resolution of the texture being generated.
	*/Phaser.RenderTexture=function(game,width,height,key,scaleMode,resolution){if(key===undefined){key='';}if(scaleMode===undefined){scaleMode=Phaser.scaleModes.DEFAULT;}if(resolution===undefined){resolution=1;}/**
	    * @property {Phaser.Game} game - A reference to the currently running game.
	    */this.game=game;/**
	    * @property {string} key - The key of the RenderTexture in the Cache, if stored there.
	    */this.key=key;/**
	    * @property {number} type - Base Phaser object type.
	    */this.type=Phaser.RENDERTEXTURE;/**
	    * @property {PIXI.Matrix} _tempMatrix - The matrix that is applied when display objects are rendered to this RenderTexture.
	    * @private
	    */this._tempMatrix=new PIXI.Matrix();PIXI.RenderTexture.call(this,width,height,this.game.renderer,scaleMode,resolution);this.render=Phaser.RenderTexture.prototype.render;};Phaser.RenderTexture.prototype=Object.create(PIXI.RenderTexture.prototype);Phaser.RenderTexture.prototype.constructor=Phaser.RenderTexture;/**
	* This function will draw the display object to the RenderTexture at the given coordinates.
	*
	* When the display object is drawn it takes into account scale and rotation.
	*
	* If you don't want those then use RenderTexture.renderRawXY instead.
	*
	* @method Phaser.RenderTexture.prototype.renderXY
	* @param {Phaser.Sprite|Phaser.Image|Phaser.Text|Phaser.BitmapText|Phaser.Group} displayObject - The display object to render to this texture.
	* @param {number} x - The x position to render the object at.
	* @param {number} y - The y position to render the object at.
	* @param {boolean} [clear=false] - If true the texture will be cleared before the display object is drawn.
	*/Phaser.RenderTexture.prototype.renderXY=function(displayObject,x,y,clear){displayObject.updateTransform();this._tempMatrix.copyFrom(displayObject.worldTransform);this._tempMatrix.tx=x;this._tempMatrix.ty=y;if(this.renderer.type===PIXI.WEBGL_RENDERER){this.renderWebGL(displayObject,this._tempMatrix,clear);}else{this.renderCanvas(displayObject,this._tempMatrix,clear);}};/**
	* This function will draw the display object to the RenderTexture at the given coordinates.
	*
	* When the display object is drawn it doesn't take into account scale, rotation or translation.
	*
	* If you need those then use RenderTexture.renderXY instead.
	*
	* @method Phaser.RenderTexture.prototype.renderRawXY
	* @param {Phaser.Sprite|Phaser.Image|Phaser.Text|Phaser.BitmapText|Phaser.Group} displayObject - The display object to render to this texture.
	* @param {number} x - The x position to render the object at.
	* @param {number} y - The y position to render the object at.
	* @param {boolean} [clear=false] - If true the texture will be cleared before the display object is drawn.
	*/Phaser.RenderTexture.prototype.renderRawXY=function(displayObject,x,y,clear){this._tempMatrix.identity().translate(x,y);if(this.renderer.type===PIXI.WEBGL_RENDERER){this.renderWebGL(displayObject,this._tempMatrix,clear);}else{this.renderCanvas(displayObject,this._tempMatrix,clear);}};/**
	* This function will draw the display object to the RenderTexture.
	*
	* In versions of Phaser prior to 2.4.0 the second parameter was a Phaser.Point object. 
	* This is now a Matrix allowing you much more control over how the Display Object is rendered.
	* If you need to replicate the earlier behavior please use Phaser.RenderTexture.renderXY instead.
	*
	* If you wish for the displayObject to be rendered taking its current scale, rotation and translation into account then either
	* pass `null`, leave it undefined or pass `displayObject.worldTransform` as the matrix value.
	*
	* @method Phaser.RenderTexture.prototype.render
	* @param {Phaser.Sprite|Phaser.Image|Phaser.Text|Phaser.BitmapText|Phaser.Group} displayObject - The display object to render to this texture.
	* @param {Phaser.Matrix} [matrix] - Optional matrix to apply to the display object before rendering. If null or undefined it will use the worldTransform matrix of the given display object.
	* @param {boolean} [clear=false] - If true the texture will be cleared before the display object is drawn.
	*/Phaser.RenderTexture.prototype.render=function(displayObject,matrix,clear){if(matrix===undefined||matrix===null){this._tempMatrix.copyFrom(displayObject.worldTransform);}else{this._tempMatrix.copyFrom(matrix);}if(this.renderer.type===PIXI.WEBGL_RENDERER){this.renderWebGL(displayObject,this._tempMatrix,clear);}else{this.renderCanvas(displayObject,this._tempMatrix,clear);}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Create a new game object for displaying Text.
	*
	* This uses a local hidden Canvas object and renders the type into it. It then makes a texture from this for rendering to the view.
	* Because of this you can only display fonts that are currently loaded and available to the browser: fonts must be pre-loaded.
	*
	* See {@link http://www.jordanm.co.uk/tinytype this compatibility table} for the available default fonts across mobile browsers.
	*
	* @class Phaser.Text
	* @extends Phaser.Sprite
	* @constructor
	* @param {Phaser.Game} game - Current game instance.
	* @param {number} x - X position of the new text object.
	* @param {number} y - Y position of the new text object.
	* @param {string} text - The actual text that will be written.
	* @param {object} [style] - The style properties to be set on the Text.
	* @param {string} [style.font='bold 20pt Arial'] - The style and size of the font.
	* @param {string} [style.fontStyle=(from font)] - The style of the font (eg. 'italic'): overrides the value in `style.font`.
	* @param {string} [style.fontVariant=(from font)] - The variant of the font (eg. 'small-caps'): overrides the value in `style.font`.
	* @param {string} [style.fontWeight=(from font)] - The weight of the font (eg. 'bold'): overrides the value in `style.font`.
	* @param {string|number} [style.fontSize=(from font)] - The size of the font (eg. 32 or '32px'): overrides the value in `style.font`.
	* @param {string} [style.backgroundColor=null] - A canvas fillstyle that will be used as the background for the whole Text object. Set to `null` to disable.
	* @param {string} [style.fill='black'] - A canvas fillstyle that will be used on the text eg 'red', '#00FF00'.
	* @param {string} [style.align='left'] - Horizontal alignment of each line in multiline text. Can be: 'left', 'center' or 'right'. Does not affect single lines of text (see `textBounds` and `boundsAlignH` for that).
	* @param {string} [style.boundsAlignH='left'] - Horizontal alignment of the text within the `textBounds`. Can be: 'left', 'center' or 'right'.
	* @param {string} [style.boundsAlignV='top'] - Vertical alignment of the text within the `textBounds`. Can be: 'top', 'middle' or 'bottom'.
	* @param {string} [style.stroke='black'] - A canvas stroke style that will be used on the text stroke eg 'blue', '#FCFF00'.
	* @param {number} [style.strokeThickness=0] - A number that represents the thickness of the stroke. Default is 0 (no stroke).
	* @param {boolean} [style.wordWrap=false] - Indicates if word wrap should be used.
	* @param {number} [style.wordWrapWidth=100] - The width in pixels at which text will wrap.
	* @param {number} [style.maxLines=0] - The maximum number of lines to be shown for wrapped text.
	* @param {number} [style.tabs=0] - The size (in pixels) of the tabs, for when text includes tab characters. 0 disables. Can be an array of varying tab sizes, one per tab stop.
	*/Phaser.Text=function(game,x,y,text,style){x=x||0;y=y||0;if(text===undefined||text===null){text='';}else{text=text.toString();}style=Phaser.Utils.extend({},style);/**
	    * @property {number} type - The const type of this object.
	    * @default
	    */this.type=Phaser.TEXT;/**
	    * @property {number} physicsType - The const physics body type of this object.
	    * @readonly
	    */this.physicsType=Phaser.SPRITE;/**
	    * Specify a padding value which is added to the line width and height when calculating the Text size.
	    * ALlows you to add extra spacing if Phaser is unable to accurately determine the true font dimensions.
	    * @property {Phaser.Point} padding
	    */this.padding=new Phaser.Point();/**
	    * The textBounds property allows you to specify a rectangular region upon which text alignment is based.
	    * See `Text.setTextBounds` for more details.
	    * @property {Phaser.Rectangle} textBounds
	    * @readOnly
	    */this.textBounds=null;/**
	     * @property {HTMLCanvasElement} canvas - The canvas element that the text is rendered.
	     */this.canvas=PIXI.CanvasPool.create(this);/**
	     * @property {HTMLCanvasElement} context - The context of the canvas element that the text is rendered to.
	     */this.context=this.canvas.getContext('2d');/**
	    * @property {array} colors - An array of the color values as specified by {@link Phaser.Text#addColor addColor}.
	    */this.colors=[];/**
	    * @property {array} strokeColors - An array of the stroke color values as specified by {@link Phaser.Text#addStrokeColor addStrokeColor}.
	    */this.strokeColors=[];/**
	    * @property {array} fontStyles - An array of the font styles values as specified by {@link Phaser.Text#addFontStyle addFontStyle}.
	    */this.fontStyles=[];/**
	    * @property {array} fontWeights - An array of the font weights values as specified by {@link Phaser.Text#addFontWeight addFontWeight}.
	    */this.fontWeights=[];/**
	    * Should the linePositionX and Y values be automatically rounded before rendering the Text?
	    * You may wish to enable this if you want to remove the effect of sub-pixel aliasing from text.
	    * @property {boolean} autoRound
	    * @default
	    */this.autoRound=false;/**
	    * Will this Text object use Basic or Advanced Word Wrapping?
	    * 
	    * Advanced wrapping breaks long words if they are the first of a line, and repeats the process as necessary.
	    * White space is condensed (e.g., consecutive spaces are replaced with one).
	    * Lines are trimmed of white space before processing.
	    * 
	    * It throws an error if wordWrapWidth is less than a single character.
	    * @property {boolean} useAdvancedWrap
	    * @default
	    */this.useAdvancedWrap=false;/**
	     * @property {number} _res - Internal canvas resolution var.
	     * @private
	     */this._res=game.renderer.resolution;/**
	    * @property {string} _text - Internal cache var.
	    * @private
	    */this._text=text;/**
	    * @property {object} _fontComponents - The font, broken down into components, set in `setStyle`.
	    * @private
	    */this._fontComponents=null;/**
	    * @property {number} lineSpacing - Additional spacing (in pixels) between each line of text if multi-line.
	    * @private
	    */this._lineSpacing=0;/**
	    * @property {number} _charCount - Internal character counter used by the text coloring.
	    * @private
	    */this._charCount=0;/**
	    * @property {number} _width - Internal width var.
	    * @private
	    */this._width=0;/**
	    * @property {number} _height - Internal height var.
	    * @private
	    */this._height=0;Phaser.Sprite.call(this,game,x,y,PIXI.Texture.fromCanvas(this.canvas));this.setStyle(style);if(text!==''){this.updateText();}};Phaser.Text.prototype=Object.create(Phaser.Sprite.prototype);Phaser.Text.prototype.constructor=Phaser.Text;/**
	* Automatically called by World.preUpdate.
	* 
	* @method Phaser.Text#preUpdate
	* @protected
	*/Phaser.Text.prototype.preUpdate=function(){if(!this.preUpdatePhysics()||!this.preUpdateLifeSpan()||!this.preUpdateInWorld()){return false;}return this.preUpdateCore();};/**
	* Override this function to handle any special update requirements.
	*
	* @method Phaser.Text#update
	* @protected
	*/Phaser.Text.prototype.update=function(){};/**
	* Destroy this Text object, removing it from the group it belongs to.
	*
	* @method Phaser.Text#destroy
	* @param {boolean} [destroyChildren=true] - Should every child of this object have its destroy method called?
	*/Phaser.Text.prototype.destroy=function(destroyChildren){this.texture.destroy(true);Phaser.Component.Destroy.prototype.destroy.call(this,destroyChildren);};/**
	* Sets a drop shadow effect on the Text. You can specify the horizontal and vertical distance of the drop shadow with the `x` and `y` parameters.
	* The color controls the shade of the shadow (default is black) and can be either an `rgba` or `hex` value.
	* The blur is the strength of the shadow. A value of zero means a hard shadow, a value of 10 means a very soft shadow.
	* To remove a shadow already in place you can call this method with no parameters set.
	* 
	* @method Phaser.Text#setShadow
	* @param {number} [x=0] - The shadowOffsetX value in pixels. This is how far offset horizontally the shadow effect will be.
	* @param {number} [y=0] - The shadowOffsetY value in pixels. This is how far offset vertically the shadow effect will be.
	* @param {string} [color='rgba(0,0,0,1)'] - The color of the shadow, as given in CSS rgba or hex format. Set the alpha component to 0 to disable the shadow.
	* @param {number} [blur=0] - The shadowBlur value. Make the shadow softer by applying a Gaussian blur to it. A number from 0 (no blur) up to approx. 10 (depending on scene).
	* @param {boolean} [shadowStroke=true] - Apply the drop shadow to the Text stroke (if set).
	* @param {boolean} [shadowFill=true] - Apply the drop shadow to the Text fill (if set).
	* @return {Phaser.Text} This Text instance.
	*/Phaser.Text.prototype.setShadow=function(x,y,color,blur,shadowStroke,shadowFill){if(x===undefined){x=0;}if(y===undefined){y=0;}if(color===undefined){color='rgba(0, 0, 0, 1)';}if(blur===undefined){blur=0;}if(shadowStroke===undefined){shadowStroke=true;}if(shadowFill===undefined){shadowFill=true;}this.style.shadowOffsetX=x;this.style.shadowOffsetY=y;this.style.shadowColor=color;this.style.shadowBlur=blur;this.style.shadowStroke=shadowStroke;this.style.shadowFill=shadowFill;this.dirty=true;return this;};/**
	* Set the style of the text by passing a single style object to it.
	*
	* @method Phaser.Text#setStyle
	* @param {object} [style] - The style properties to be set on the Text.
	* @param {string} [style.font='bold 20pt Arial'] - The style and size of the font.
	* @param {string} [style.fontStyle=(from font)] - The style of the font (eg. 'italic'): overrides the value in `style.font`.
	* @param {string} [style.fontVariant=(from font)] - The variant of the font (eg. 'small-caps'): overrides the value in `style.font`.
	* @param {string} [style.fontWeight=(from font)] - The weight of the font (eg. 'bold'): overrides the value in `style.font`.
	* @param {string|number} [style.fontSize=(from font)] - The size of the font (eg. 32 or '32px'): overrides the value in `style.font`.
	* @param {string} [style.backgroundColor=null] - A canvas fillstyle that will be used as the background for the whole Text object. Set to `null` to disable.
	* @param {string} [style.fill='black'] - A canvas fillstyle that will be used on the text eg 'red', '#00FF00'.
	* @param {string} [style.align='left'] - Horizontal alignment of each line in multiline text. Can be: 'left', 'center' or 'right'. Does not affect single lines of text (see `textBounds` and `boundsAlignH` for that).
	* @param {string} [style.boundsAlignH='left'] - Horizontal alignment of the text within the `textBounds`. Can be: 'left', 'center' or 'right'.
	* @param {string} [style.boundsAlignV='top'] - Vertical alignment of the text within the `textBounds`. Can be: 'top', 'middle' or 'bottom'.
	* @param {string} [style.stroke='black'] - A canvas stroke style that will be used on the text stroke eg 'blue', '#FCFF00'.
	* @param {number} [style.strokeThickness=0] - A number that represents the thickness of the stroke. Default is 0 (no stroke).
	* @param {boolean} [style.wordWrap=false] - Indicates if word wrap should be used.
	* @param {number} [style.wordWrapWidth=100] - The width in pixels at which text will wrap.
	* @param {number} [style.maxLines=0] - The maximum number of lines to be shown for wrapped text.
	* @param {number|array} [style.tabs=0] - The size (in pixels) of the tabs, for when text includes tab characters. 0 disables. Can be an array of varying tab sizes, one per tab stop.
	* @param {boolean} [update=false] - Immediately update the Text object after setting the new style? Or wait for the next frame.
	* @return {Phaser.Text} This Text instance.
	*/Phaser.Text.prototype.setStyle=function(style,update){if(update===undefined){update=false;}style=style||{};style.font=style.font||'bold 20pt Arial';style.backgroundColor=style.backgroundColor||null;style.fill=style.fill||'black';style.align=style.align||'left';style.boundsAlignH=style.boundsAlignH||'left';style.boundsAlignV=style.boundsAlignV||'top';style.stroke=style.stroke||'black';//provide a default, see: https://github.com/GoodBoyDigital/pixi.js/issues/136
	style.strokeThickness=style.strokeThickness||0;style.wordWrap=style.wordWrap||false;style.wordWrapWidth=style.wordWrapWidth||100;style.maxLines=style.maxLines||0;style.shadowOffsetX=style.shadowOffsetX||0;style.shadowOffsetY=style.shadowOffsetY||0;style.shadowColor=style.shadowColor||'rgba(0,0,0,0)';style.shadowBlur=style.shadowBlur||0;style.tabs=style.tabs||0;var components=this.fontToComponents(style.font);if(style.fontStyle){components.fontStyle=style.fontStyle;}if(style.fontVariant){components.fontVariant=style.fontVariant;}if(style.fontWeight){components.fontWeight=style.fontWeight;}if(style.fontSize){if(typeof style.fontSize==='number'){style.fontSize=style.fontSize+'px';}components.fontSize=style.fontSize;}this._fontComponents=components;style.font=this.componentsToFont(this._fontComponents);this.style=style;this.dirty=true;if(update){this.updateText();}return this;};/**
	* Renders text. This replaces the Pixi.Text.updateText function as we need a few extra bits in here.
	*
	* @method Phaser.Text#updateText
	* @private
	*/Phaser.Text.prototype.updateText=function(){this.texture.baseTexture.resolution=this._res;this.context.font=this.style.font;var outputText=this.text;if(this.style.wordWrap){outputText=this.runWordWrap(this.text);}//  Split text into lines
	var lines=outputText.split(/(?:\r\n|\r|\n)/);//  Calculate text width
	var tabs=this.style.tabs;var lineWidths=[];var maxLineWidth=0;var fontProperties=this.determineFontProperties(this.style.font);var drawnLines=lines.length;if(this.style.maxLines>0&&this.style.maxLines<lines.length){drawnLines=this.style.maxLines;}this._charCount=0;for(var i=0;i<drawnLines;i++){if(tabs===0){//  Simple layout (no tabs)
	var lineWidth=this.style.strokeThickness+this.padding.x;if(this.colors.length>0||this.strokeColors.length>0||this.fontWeights.length>0||this.fontStyles.length>0){lineWidth+=this.measureLine(lines[i]);}else{lineWidth+=this.context.measureText(lines[i]).width;}// Adjust for wrapped text
	if(this.style.wordWrap){lineWidth-=this.context.measureText(' ').width;}}else{//  Complex layout (tabs)
	var line=lines[i].split(/(?:\t)/);var lineWidth=this.padding.x+this.style.strokeThickness;if(Array.isArray(tabs)){var tab=0;for(var c=0;c<line.length;c++){var section=0;if(this.colors.length>0||this.strokeColors.length>0||this.fontWeights.length>0||this.fontStyles.length>0){section=this.measureLine(line[c]);}else{section=Math.ceil(this.context.measureText(line[c]).width);}if(c>0){tab+=tabs[c-1];}lineWidth=tab+section;}}else{for(var c=0;c<line.length;c++){//  How far to the next tab?
	if(this.colors.length>0||this.strokeColors.length>0||this.fontWeights.length>0||this.fontStyles.length>0){lineWidth+=this.measureLine(line[c]);}else{lineWidth+=Math.ceil(this.context.measureText(line[c]).width);}var diff=this.game.math.snapToCeil(lineWidth,tabs)-lineWidth;lineWidth+=diff;}}}lineWidths[i]=Math.ceil(lineWidth);maxLineWidth=Math.max(maxLineWidth,lineWidths[i]);}this.canvas.width=maxLineWidth*this._res;//  Calculate text height
	var lineHeight=fontProperties.fontSize+this.style.strokeThickness+this.padding.y;var height=lineHeight*drawnLines;var lineSpacing=this._lineSpacing;if(lineSpacing<0&&Math.abs(lineSpacing)>lineHeight){lineSpacing=-lineHeight;}//  Adjust for line spacing
	if(lineSpacing!==0){height+=lineSpacing>0?lineSpacing*lines.length:lineSpacing*(lines.length-1);}this.canvas.height=height*this._res;this.context.scale(this._res,this._res);if(navigator.isCocoonJS){this.context.clearRect(0,0,this.canvas.width,this.canvas.height);}if(this.style.backgroundColor){this.context.fillStyle=this.style.backgroundColor;this.context.fillRect(0,0,this.canvas.width,this.canvas.height);}this.context.fillStyle=this.style.fill;this.context.font=this.style.font;this.context.strokeStyle=this.style.stroke;this.context.textBaseline='alphabetic';this.context.lineWidth=this.style.strokeThickness;this.context.lineCap='round';this.context.lineJoin='round';var linePositionX;var linePositionY;this._charCount=0;//  Draw text line by line
	for(i=0;i<drawnLines;i++){//  Split the line by
	linePositionX=this.style.strokeThickness/2;linePositionY=this.style.strokeThickness/2+i*lineHeight+fontProperties.ascent;if(i>0){linePositionY+=lineSpacing*i;}if(this.style.align==='right'){linePositionX+=maxLineWidth-lineWidths[i];}else if(this.style.align==='center'){linePositionX+=(maxLineWidth-lineWidths[i])/2;}if(this.autoRound){linePositionX=Math.round(linePositionX);linePositionY=Math.round(linePositionY);}if(this.colors.length>0||this.strokeColors.length>0||this.fontWeights.length>0||this.fontStyles.length>0){this.updateLine(lines[i],linePositionX,linePositionY);}else{if(this.style.stroke&&this.style.strokeThickness){this.updateShadow(this.style.shadowStroke);if(tabs===0){this.context.strokeText(lines[i],linePositionX,linePositionY);}else{this.renderTabLine(lines[i],linePositionX,linePositionY,false);}}if(this.style.fill){this.updateShadow(this.style.shadowFill);if(tabs===0){this.context.fillText(lines[i],linePositionX,linePositionY);}else{this.renderTabLine(lines[i],linePositionX,linePositionY,true);}}}}this.updateTexture();this.dirty=false;};/**
	* Renders a line of text that contains tab characters if Text.tab > 0.
	* Called automatically by updateText.
	*
	* @method Phaser.Text#renderTabLine
	* @private
	* @param {string} line - The line of text to render.
	* @param {integer} x - The x position to start rendering from.
	* @param {integer} y - The y position to start rendering from.
	* @param {boolean} fill - If true uses fillText, if false uses strokeText.
	*/Phaser.Text.prototype.renderTabLine=function(line,x,y,fill){var text=line.split(/(?:\t)/);var tabs=this.style.tabs;var snap=0;if(Array.isArray(tabs)){var tab=0;for(var c=0;c<text.length;c++){if(c>0){tab+=tabs[c-1];}snap=x+tab;if(fill){this.context.fillText(text[c],snap,y);}else{this.context.strokeText(text[c],snap,y);}}}else{for(var c=0;c<text.length;c++){var section=Math.ceil(this.context.measureText(text[c]).width);//  How far to the next tab?
	snap=this.game.math.snapToCeil(x,tabs);if(fill){this.context.fillText(text[c],snap,y);}else{this.context.strokeText(text[c],snap,y);}x=snap+section;}}};/**
	* Sets the Shadow on the Text.context based on the Style settings, or disables it if not enabled.
	* This is called automatically by Text.updateText.
	*
	* @method Phaser.Text#updateShadow
	* @param {boolean} state - If true the shadow will be set to the Style values, otherwise it will be set to zero.
	*/Phaser.Text.prototype.updateShadow=function(state){if(state){this.context.shadowOffsetX=this.style.shadowOffsetX;this.context.shadowOffsetY=this.style.shadowOffsetY;this.context.shadowColor=this.style.shadowColor;this.context.shadowBlur=this.style.shadowBlur;}else{this.context.shadowOffsetX=0;this.context.shadowOffsetY=0;this.context.shadowColor=0;this.context.shadowBlur=0;}};/**
	* Measures a line of text character by character taking into the account the specified character styles.
	*
	* @method Phaser.Text#measureLine
	* @private
	* @param {string} line - The line of text to measure.
	* @return {integer} length of the line.
	*/Phaser.Text.prototype.measureLine=function(line){var lineLength=0;for(var i=0;i<line.length;i++){var letter=line[i];if(this.fontWeights.length>0||this.fontStyles.length>0){var components=this.fontToComponents(this.context.font);if(this.fontStyles[this._charCount]){components.fontStyle=this.fontStyles[this._charCount];}if(this.fontWeights[this._charCount]){components.fontWeight=this.fontWeights[this._charCount];}this.context.font=this.componentsToFont(components);}if(this.style.stroke&&this.style.strokeThickness){if(this.strokeColors[this._charCount]){this.context.strokeStyle=this.strokeColors[this._charCount];}this.updateShadow(this.style.shadowStroke);}if(this.style.fill){if(this.colors[this._charCount]){this.context.fillStyle=this.colors[this._charCount];}this.updateShadow(this.style.shadowFill);}lineLength+=this.context.measureText(letter).width;this._charCount++;}return Math.ceil(lineLength);};/**
	* Updates a line of text, applying fill and stroke per-character colors or style and weight per-character font if applicable.
	*
	* @method Phaser.Text#updateLine
	* @private
	*/Phaser.Text.prototype.updateLine=function(line,x,y){for(var i=0;i<line.length;i++){var letter=line[i];if(this.fontWeights.length>0||this.fontStyles.length>0){var components=this.fontToComponents(this.context.font);if(this.fontStyles[this._charCount]){components.fontStyle=this.fontStyles[this._charCount];}if(this.fontWeights[this._charCount]){components.fontWeight=this.fontWeights[this._charCount];}this.context.font=this.componentsToFont(components);}if(this.style.stroke&&this.style.strokeThickness){if(this.strokeColors[this._charCount]){this.context.strokeStyle=this.strokeColors[this._charCount];}this.updateShadow(this.style.shadowStroke);this.context.strokeText(letter,x,y);}if(this.style.fill){if(this.colors[this._charCount]){this.context.fillStyle=this.colors[this._charCount];}this.updateShadow(this.style.shadowFill);this.context.fillText(letter,x,y);}x+=this.context.measureText(letter).width;this._charCount++;}};/**
	* Clears any text fill or stroke colors that were set by `addColor` or `addStrokeColor`.
	*
	* @method Phaser.Text#clearColors
	* @return {Phaser.Text} This Text instance.
	*/Phaser.Text.prototype.clearColors=function(){this.colors=[];this.strokeColors=[];this.dirty=true;return this;};/**
	* Clears any text styles or weights font that were set by `addFontStyle` or `addFontWeight`.
	*
	* @method Phaser.Text#clearFontValues
	* @return {Phaser.Text} This Text instance.
	*/Phaser.Text.prototype.clearFontValues=function(){this.fontStyles=[];this.fontWeights=[];this.dirty=true;return this;};/**
	* Set specific colors for certain characters within the Text.
	*
	* It works by taking a color value, which is a typical HTML string such as `#ff0000` or `rgb(255,0,0)` and a position.
	* The position value is the index of the character in the Text string to start applying this color to.
	* Once set the color remains in use until either another color or the end of the string is encountered.
	* For example if the Text was `Photon Storm` and you did `Text.addColor('#ffff00', 6)` it would color in the word `Storm` in yellow.
	*
	* If you wish to change the stroke color see addStrokeColor instead.
	*
	* @method Phaser.Text#addColor
	* @param {string} color - A canvas fillstyle that will be used on the text eg `red`, `#00FF00`, `rgba()`.
	* @param {number} position - The index of the character in the string to start applying this color value from.
	* @return {Phaser.Text} This Text instance.
	*/Phaser.Text.prototype.addColor=function(color,position){this.colors[position]=color;this.dirty=true;return this;};/**
	* Set specific stroke colors for certain characters within the Text.
	*
	* It works by taking a color value, which is a typical HTML string such as `#ff0000` or `rgb(255,0,0)` and a position.
	* The position value is the index of the character in the Text string to start applying this color to.
	* Once set the color remains in use until either another color or the end of the string is encountered.
	* For example if the Text was `Photon Storm` and you did `Text.addColor('#ffff00', 6)` it would color in the word `Storm` in yellow.
	*
	* This has no effect if stroke is disabled or has a thickness of 0.
	*
	* If you wish to change the text fill color see addColor instead.
	*
	* @method Phaser.Text#addStrokeColor
	* @param {string} color - A canvas fillstyle that will be used on the text stroke eg `red`, `#00FF00`, `rgba()`.
	* @param {number} position - The index of the character in the string to start applying this color value from.
	* @return {Phaser.Text} This Text instance.
	*/Phaser.Text.prototype.addStrokeColor=function(color,position){this.strokeColors[position]=color;this.dirty=true;return this;};/**
	* Set specific font styles for certain characters within the Text.
	*
	* It works by taking a font style value, which is a typical string such as `normal`, `italic` or `oblique`.
	* The position value is the index of the character in the Text string to start applying this font style to.
	* Once set the font style remains in use until either another font style or the end of the string is encountered.
	* For example if the Text was `Photon Storm` and you did `Text.addFontStyle('italic', 6)` it would font style in the word `Storm` in italic.
	*
	* If you wish to change the text font weight see addFontWeight instead.
	*
	* @method Phaser.Text#addFontStyle
	* @param {string} style - A canvas font-style that will be used on the text style eg `normal`, `italic`, `oblique`.
	* @param {number} position - The index of the character in the string to start applying this font style value from.
	* @return {Phaser.Text} This Text instance.
	*/Phaser.Text.prototype.addFontStyle=function(style,position){this.fontStyles[position]=style;this.dirty=true;return this;};/**
	* Set specific font weights for certain characters within the Text.
	*
	* It works by taking a font weight value, which is a typical string such as `normal`, `bold`, `bolder`, etc.
	* The position value is the index of the character in the Text string to start applying this font weight to.
	* Once set the font weight remains in use until either another font weight or the end of the string is encountered.
	* For example if the Text was `Photon Storm` and you did `Text.addFontWeight('bold', 6)` it would font weight in the word `Storm` in bold.
	*
	* If you wish to change the text font style see addFontStyle instead.
	*
	* @method Phaser.Text#addFontWeight
	* @param {string} style - A canvas font-weight that will be used on the text weight eg `normal`, `bold`, `bolder`, `lighter`, etc.
	* @param {number} position - The index of the character in the string to start applying this font weight value from.
	* @return {Phaser.Text} This Text instance.
	*/Phaser.Text.prototype.addFontWeight=function(weight,position){this.fontWeights[position]=weight;this.dirty=true;return this;};/**
	* Runs the given text through the Text.runWordWrap function and returns
	* the results as an array, where each element of the array corresponds to a wrapped
	* line of text.
	*
	* Useful if you wish to control pagination on long pieces of content.
	*
	* @method Phaser.Text#precalculateWordWrap
	* @param {string} text - The text for which the wrapping will be calculated.
	* @return {array} An array of strings with the pieces of wrapped text.
	*/Phaser.Text.prototype.precalculateWordWrap=function(text){this.texture.baseTexture.resolution=this._res;this.context.font=this.style.font;var wrappedLines=this.runWordWrap(text);return wrappedLines.split(/(?:\r\n|\r|\n)/);};/**
	* Greedy wrapping algorithm that will wrap words as the line grows longer than its horizontal bounds.
	*
	* @method Phaser.Text#runWordWrap
	* @param {string} text - The text to perform word wrap detection against.
	* @private
	*/Phaser.Text.prototype.runWordWrap=function(text){if(this.useAdvancedWrap){return this.advancedWordWrap(text);}else{return this.basicWordWrap(text);}};/**
	* Advanced wrapping algorithm that will wrap words as the line grows longer than its horizontal bounds.
	* White space is condensed (e.g., consecutive spaces are replaced with one).
	* Lines are trimmed of white space before processing.
	* Throws an error if the user was smart enough to specify a wordWrapWidth less than a single character.
	*
	* @method Phaser.Text#advancedWordWrap
	* @param {string} text - The text to perform word wrap detection against.
	* @private
	*/Phaser.Text.prototype.advancedWordWrap=function(text){var context=this.context;var wordWrapWidth=this.style.wordWrapWidth;var output='';// (1) condense whitespace
	// (2) split into lines
	var lines=text.replace(/ +/gi,' ').split(/\r?\n/gi);var linesCount=lines.length;for(var i=0;i<linesCount;i++){var line=lines[i];var out='';// trim whitespace
	line=line.replace(/^ *|\s*$/gi,'');// if entire line is less than wordWrapWidth
	// append the entire line and exit early
	var lineWidth=context.measureText(line).width;if(lineWidth<wordWrapWidth){output+=line+'\n';continue;}// otherwise, calculate new lines
	var currentLineWidth=wordWrapWidth;// split into words
	var words=line.split(' ');for(var j=0;j<words.length;j++){var word=words[j];var wordWithSpace=word+' ';var wordWidth=context.measureText(wordWithSpace).width;if(wordWidth>currentLineWidth){// break word
	if(j===0){// shave off letters from word until it's small enough
	var newWord=wordWithSpace;while(newWord.length){newWord=newWord.slice(0,-1);wordWidth=context.measureText(newWord).width;if(wordWidth<=currentLineWidth){break;}}// if wordWrapWidth is too small for even a single
	// letter, shame user failure with a fatal error
	if(!newWord.length){throw new Error('This text\'s wordWrapWidth setting is less than a single character!');}// replace current word in array with remainder
	var secondPart=word.substr(newWord.length);words[j]=secondPart;// append first piece to output
	out+=newWord;}// if existing word length is 0, don't include it
	var offset=words[j].length?j:j+1;// collapse rest of sentence
	var remainder=words.slice(offset).join(' ')// remove any trailing white space
	.replace(/[ \n]*$/gi,'');// prepend remainder to next line
	lines[i+1]=remainder+' '+(lines[i+1]||'');linesCount=lines.length;break;// processing on this line
	// append word with space to output
	}else{out+=wordWithSpace;currentLineWidth-=wordWidth;}}// append processed line to output
	output+=out.replace(/[ \n]*$/gi,'')+'\n';}// trim the end of the string
	output=output.replace(/[\s|\n]*$/gi,'');return output;};/**
	* Greedy wrapping algorithm that will wrap words as the line grows longer than its horizontal bounds.
	*
	* @method Phaser.Text#basicWordWrap
	* @param {string} text - The text to perform word wrap detection against.
	* @private
	*/Phaser.Text.prototype.basicWordWrap=function(text){var result='';var lines=text.split('\n');for(var i=0;i<lines.length;i++){var spaceLeft=this.style.wordWrapWidth;var words=lines[i].split(' ');for(var j=0;j<words.length;j++){var wordWidth=this.context.measureText(words[j]).width;var wordWidthWithSpace=wordWidth+this.context.measureText(' ').width;if(wordWidthWithSpace>spaceLeft){// Skip printing the newline if it's the first word of the line that is greater than the word wrap width.
	if(j>0){result+='\n';}result+=words[j]+' ';spaceLeft=this.style.wordWrapWidth-wordWidth;}else{spaceLeft-=wordWidthWithSpace;result+=words[j]+' ';}}if(i<lines.length-1){result+='\n';}}return result;};/**
	* Updates the internal `style.font` if it now differs according to generation from components.
	*
	* @method Phaser.Text#updateFont
	* @private
	* @param {object} components - Font components.
	*/Phaser.Text.prototype.updateFont=function(components){var font=this.componentsToFont(components);if(this.style.font!==font){this.style.font=font;this.dirty=true;if(this.parent){this.updateTransform();}}};/**
	* Converting a short CSS-font string into the relevant components.
	*
	* @method Phaser.Text#fontToComponents
	* @private
	* @param {string} font - a CSS font string
	*/Phaser.Text.prototype.fontToComponents=function(font){// The format is specified in http://www.w3.org/TR/CSS2/fonts.html#font-shorthand:
	// style - normal | italic | oblique | inherit
	// variant - normal | small-caps | inherit
	// weight - normal | bold | bolder | lighter | 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | inherit
	// size - xx-small | x-small | small | medium | large | x-large | xx-large,
	//        larger | smaller
	//        {number} (em | ex | ch | rem | vh | vw | vmin | vmax | px | mm | cm | in | pt | pc | %)
	// font-family - rest (but identifiers or quoted with comma separation)
	var m=font.match(/^\s*(?:\b(normal|italic|oblique|inherit)?\b)\s*(?:\b(normal|small-caps|inherit)?\b)\s*(?:\b(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit)?\b)\s*(?:\b(xx-small|x-small|small|medium|large|x-large|xx-large|larger|smaller|0|\d*(?:[.]\d*)?(?:%|[a-z]{2,5}))?\b)\s*(.*)\s*$/);if(m){var family=m[5].trim();// If it looks like the value should be quoted, but isn't, then quote it.
	if(!/^(?:inherit|serif|sans-serif|cursive|fantasy|monospace)$/.exec(family)&&!/['",]/.exec(family)){family="'"+family+"'";}return{font:font,fontStyle:m[1]||'normal',fontVariant:m[2]||'normal',fontWeight:m[3]||'normal',fontSize:m[4]||'medium',fontFamily:family};}else{console.warn("Phaser.Text - unparsable CSS font: "+font);return{font:font};}};/**
	* Converts individual font components (see `fontToComponents`) to a short CSS font string.
	*
	* @method Phaser.Text#componentsToFont
	* @private
	* @param {object} components - Font components.
	*/Phaser.Text.prototype.componentsToFont=function(components){var parts=[];var v;v=components.fontStyle;if(v&&v!=='normal'){parts.push(v);}v=components.fontVariant;if(v&&v!=='normal'){parts.push(v);}v=components.fontWeight;if(v&&v!=='normal'){parts.push(v);}v=components.fontSize;if(v&&v!=='medium'){parts.push(v);}v=components.fontFamily;if(v){parts.push(v);}if(!parts.length){// Fallback to whatever value the 'font' was
	parts.push(components.font);}return parts.join(" ");};/**
	* The text to be displayed by this Text object.
	* Use a \n to insert a carriage return and split the text.
	* The text will be rendered with any style currently set.
	*
	* Use the optional `immediate` argument if you need the Text display to update immediately.
	* 
	* If not it will re-create the texture of this Text object during the next time the render
	* loop is called.
	*
	* @method Phaser.Text#setText
	* @param {string} [text] - The text to be displayed. Set to an empty string to clear text that is already present.
	* @param {boolean} [immediate=false] - Update the texture used by this Text object immediately (true) or automatically during the next render loop (false).
	* @return {Phaser.Text} This Text instance.
	*/Phaser.Text.prototype.setText=function(text,immediate){if(immediate===undefined){immediate=false;}this.text=text.toString()||'';if(immediate){this.updateText();}else{this.dirty=true;}return this;};/**
	 * Converts the given array into a tab delimited string and then updates this Text object.
	 * This is mostly used when you want to display external data using tab stops.
	 *
	 * The array can be either single or multi dimensional depending on the result you need:
	 *
	 * `[ 'a', 'b', 'c' ]` would convert in to `"a\tb\tc"`.
	 *
	 * Where as:
	 *
	 * `[
	 *      [ 'a', 'b', 'c' ],
	 *      [ 'd', 'e', 'f']
	 * ]`
	 *
	 * would convert in to: `"a\tb\tc\nd\te\tf"`
	 *
	 * @method Phaser.Text#parseList
	 * @param {array} list - The array of data to convert into a string.
	 * @return {Phaser.Text} This Text instance.
	 */Phaser.Text.prototype.parseList=function(list){if(!Array.isArray(list)){return this;}else{var s="";for(var i=0;i<list.length;i++){if(Array.isArray(list[i])){s+=list[i].join("\t");if(i<list.length-1){s+="\n";}}else{s+=list[i];if(i<list.length-1){s+="\t";}}}}this.text=s;this.dirty=true;return this;};/**
	 * The Text Bounds is a rectangular region that you control the dimensions of into which the Text object itself is positioned,
	 * regardless of the number of lines in the text, the font size or any other attribute.
	 *
	 * Alignment is controlled via the properties `boundsAlignH` and `boundsAlignV` within the Text.style object, or can be directly
	 * set through the setters `Text.boundsAlignH` and `Text.boundsAlignV`. Bounds alignment is independent of text alignment.
	 *
	 * For example: If your game is 800x600 in size and you set the text bounds to be 0,0,800,600 then by setting boundsAlignH to
	 * 'center' and boundsAlignV to 'bottom' the text will render in the center and at the bottom of your game window, regardless of
	 * how many lines of text there may be. Even if you adjust the text content or change the style it will remain at the bottom center
	 * of the text bounds.
	 *
	 * This is especially powerful when you need to align text against specific coordinates in your game, but the actual text dimensions
	 * may vary based on font (say for multi-lingual games).
	 *
	 * If `Text.wordWrapWidth` is greater than the width of the text bounds it is clamped to match the bounds width.
	 *
	 * Call this method with no arguments given to reset an existing textBounds.
	 * 
	 * It works by calculating the final position based on the Text.canvas size, which is modified as the text is updated. Some fonts
	 * have additional padding around them which you can mitigate by tweaking the Text.padding property. It then adjusts the `pivot`
	 * property based on the given bounds and canvas size. This means if you need to set the pivot property directly in your game then
	 * you either cannot use `setTextBounds` or you must place the Text object inside another DisplayObject on which you set the pivot.
	 *
	 * @method Phaser.Text#setTextBounds
	 * @param {number} [x] - The x coordinate of the Text Bounds region.
	 * @param {number} [y] - The y coordinate of the Text Bounds region.
	 * @param {number} [width] - The width of the Text Bounds region.
	 * @param {number} [height] - The height of the Text Bounds region.
	 * @return {Phaser.Text} This Text instance.
	 */Phaser.Text.prototype.setTextBounds=function(x,y,width,height){if(x===undefined){this.textBounds=null;}else{if(!this.textBounds){this.textBounds=new Phaser.Rectangle(x,y,width,height);}else{this.textBounds.setTo(x,y,width,height);}if(this.style.wordWrapWidth>width){this.style.wordWrapWidth=width;}}this.updateTexture();return this;};/**
	 * Updates the texture based on the canvas dimensions.
	 *
	 * @method Phaser.Text#updateTexture
	 * @private
	 */Phaser.Text.prototype.updateTexture=function(){var base=this.texture.baseTexture;var crop=this.texture.crop;var frame=this.texture.frame;var w=this.canvas.width;var h=this.canvas.height;base.width=w;base.height=h;crop.width=w;crop.height=h;frame.width=w;frame.height=h;this.texture.width=w;this.texture.height=h;this._width=w;this._height=h;if(this.textBounds){var x=this.textBounds.x;var y=this.textBounds.y;//  Align the canvas based on the bounds
	if(this.style.boundsAlignH==='right'){x+=this.textBounds.width-this.canvas.width/this.resolution;}else if(this.style.boundsAlignH==='center'){x+=this.textBounds.halfWidth-this.canvas.width/this.resolution/2;}if(this.style.boundsAlignV==='bottom'){y+=this.textBounds.height-this.canvas.height/this.resolution;}else if(this.style.boundsAlignV==='middle'){y+=this.textBounds.halfHeight-this.canvas.height/this.resolution/2;}this.pivot.x=-x;this.pivot.y=-y;}//  Can't render something with a zero sized dimension
	this.renderable=w!==0&&h!==0;this.texture.requiresReTint=true;this.texture.baseTexture.dirty();};/**
	* Renders the object using the WebGL renderer
	*
	* @method Phaser.Text#_renderWebGL
	* @private
	* @param {RenderSession} renderSession - The Render Session to render the Text on.
	*/Phaser.Text.prototype._renderWebGL=function(renderSession){if(this.dirty){this.updateText();this.dirty=false;}PIXI.Sprite.prototype._renderWebGL.call(this,renderSession);};/**
	* Renders the object using the Canvas renderer.
	*
	* @method Phaser.Text#_renderCanvas
	* @private
	* @param {RenderSession} renderSession - The Render Session to render the Text on.
	*/Phaser.Text.prototype._renderCanvas=function(renderSession){if(this.dirty){this.updateText();this.dirty=false;}PIXI.Sprite.prototype._renderCanvas.call(this,renderSession);};/**
	* Calculates the ascent, descent and fontSize of a given font style.
	*
	* @method Phaser.Text#determineFontProperties
	* @private
	* @param {object} fontStyle 
	*/Phaser.Text.prototype.determineFontProperties=function(fontStyle){var properties=Phaser.Text.fontPropertiesCache[fontStyle];if(!properties){properties={};var canvas=Phaser.Text.fontPropertiesCanvas;var context=Phaser.Text.fontPropertiesContext;context.font=fontStyle;var width=Math.ceil(context.measureText('|MÉq').width);var baseline=Math.ceil(context.measureText('|MÉq').width);var height=2*baseline;baseline=baseline*1.4|0;canvas.width=width;canvas.height=height;context.fillStyle='#f00';context.fillRect(0,0,width,height);context.font=fontStyle;context.textBaseline='alphabetic';context.fillStyle='#000';context.fillText('|MÉq',0,baseline);if(!context.getImageData(0,0,width,height)){properties.ascent=baseline;properties.descent=baseline+6;properties.fontSize=properties.ascent+properties.descent;Phaser.Text.fontPropertiesCache[fontStyle]=properties;return properties;}var imagedata=context.getImageData(0,0,width,height).data;var pixels=imagedata.length;var line=width*4;var i,j;var idx=0;var stop=false;// ascent. scan from top to bottom until we find a non red pixel
	for(i=0;i<baseline;i++){for(j=0;j<line;j+=4){if(imagedata[idx+j]!==255){stop=true;break;}}if(!stop){idx+=line;}else{break;}}properties.ascent=baseline-i;idx=pixels-line;stop=false;// descent. scan from bottom to top until we find a non red pixel
	for(i=height;i>baseline;i--){for(j=0;j<line;j+=4){if(imagedata[idx+j]!==255){stop=true;break;}}if(!stop){idx-=line;}else{break;}}properties.descent=i-baseline;//TODO might need a tweak. kind of a temp fix!
	properties.descent+=6;properties.fontSize=properties.ascent+properties.descent;Phaser.Text.fontPropertiesCache[fontStyle]=properties;}return properties;};/**
	* Returns the bounds of the Text as a rectangle.
	* The bounds calculation takes the worldTransform into account.
	*
	* @method Phaser.Text#getBounds
	* @param {Phaser.Matrix} matrix - The transformation matrix of the Text.
	* @return {Phaser.Rectangle} The framing rectangle
	*/Phaser.Text.prototype.getBounds=function(matrix){if(this.dirty){this.updateText();this.dirty=false;}return PIXI.Sprite.prototype.getBounds.call(this,matrix);};/**
	* The text to be displayed by this Text object.
	* Use a \n to insert a carriage return and split the text.
	* The text will be rendered with any style currently set.
	*
	* @name Phaser.Text#text
	* @property {string} text
	*/Object.defineProperty(Phaser.Text.prototype,'text',{get:function get(){return this._text;},set:function set(value){if(value!==this._text){this._text=value.toString()||'';this.dirty=true;if(this.parent){this.updateTransform();}}}});/**
	* Change the font used.
	*
	* This is equivalent of the `font` property specified to {@link Phaser.Text#setStyle setStyle}, except
	* that unlike using `setStyle` this will not change any current font fill/color settings.
	*
	* The CSS font string can also be individually altered with the `font`, `fontSize`, `fontWeight`, `fontStyle`, and `fontVariant` properties.
	*
	* @name Phaser.Text#cssFont
	* @property {string} cssFont
	*/Object.defineProperty(Phaser.Text.prototype,'cssFont',{get:function get(){return this.componentsToFont(this._fontComponents);},set:function set(value){value=value||'bold 20pt Arial';this._fontComponents=this.fontToComponents(value);this.updateFont(this._fontComponents);}});/**
	* Change the font family that the text will be rendered in, such as 'Arial'.
	*
	* Multiple CSS font families and generic fallbacks can be specified as long as
	* {@link http://www.w3.org/TR/CSS2/fonts.html#propdef-font-family CSS font-family rules} are followed.
	*
	* To change the entire font string use {@link Phaser.Text#cssFont cssFont} instead: eg. `text.cssFont = 'bold 20pt Arial'`.
	*
	* @name Phaser.Text#font
	* @property {string} font
	*/Object.defineProperty(Phaser.Text.prototype,'font',{get:function get(){return this._fontComponents.fontFamily;},set:function set(value){value=value||'Arial';value=value.trim();// If it looks like the value should be quoted, but isn't, then quote it.
	if(!/^(?:inherit|serif|sans-serif|cursive|fantasy|monospace)$/.exec(value)&&!/['",]/.exec(value)){value="'"+value+"'";}this._fontComponents.fontFamily=value;this.updateFont(this._fontComponents);}});/**
	* The size of the font.
	*
	* If the font size is specified in pixels (eg. `32` or `'32px`') then a number (ie. `32`) representing
	* the font size in pixels is returned; otherwise the value with CSS unit is returned as a string (eg. `'12pt'`).
	*
	* @name Phaser.Text#fontSize
	* @property {number|string} fontSize
	*/Object.defineProperty(Phaser.Text.prototype,'fontSize',{get:function get(){var size=this._fontComponents.fontSize;if(size&&/(?:^0$|px$)/.exec(size)){return parseInt(size,10);}else{return size;}},set:function set(value){value=value||'0';if(typeof value==='number'){value=value+'px';}this._fontComponents.fontSize=value;this.updateFont(this._fontComponents);}});/**
	* The weight of the font: 'normal', 'bold', or {@link http://www.w3.org/TR/CSS2/fonts.html#propdef-font-weight a valid CSS font weight}.
	* @name Phaser.Text#fontWeight
	* @property {string} fontWeight
	*/Object.defineProperty(Phaser.Text.prototype,'fontWeight',{get:function get(){return this._fontComponents.fontWeight||'normal';},set:function set(value){value=value||'normal';this._fontComponents.fontWeight=value;this.updateFont(this._fontComponents);}});/**
	* The style of the font: 'normal', 'italic', 'oblique'
	* @name Phaser.Text#fontStyle
	* @property {string} fontStyle
	*/Object.defineProperty(Phaser.Text.prototype,'fontStyle',{get:function get(){return this._fontComponents.fontStyle||'normal';},set:function set(value){value=value||'normal';this._fontComponents.fontStyle=value;this.updateFont(this._fontComponents);}});/**
	* The variant the font: 'normal', 'small-caps'
	* @name Phaser.Text#fontVariant
	* @property {string} fontVariant
	*/Object.defineProperty(Phaser.Text.prototype,'fontVariant',{get:function get(){return this._fontComponents.fontVariant||'normal';},set:function set(value){value=value||'normal';this._fontComponents.fontVariant=value;this.updateFont(this._fontComponents);}});/**
	* @name Phaser.Text#fill
	* @property {object} fill - A canvas fillstyle that will be used on the text eg 'red', '#00FF00'.
	*/Object.defineProperty(Phaser.Text.prototype,'fill',{get:function get(){return this.style.fill;},set:function set(value){if(value!==this.style.fill){this.style.fill=value;this.dirty=true;}}});/**
	* Controls the horizontal alignment for multiline text.
	* Can be: 'left', 'center' or 'right'.
	* Does not affect single lines of text. For that please see `setTextBounds`.
	* @name Phaser.Text#align
	* @property {string} align
	*/Object.defineProperty(Phaser.Text.prototype,'align',{get:function get(){return this.style.align;},set:function set(value){if(value!==this.style.align){this.style.align=value;this.dirty=true;}}});/**
	* The resolution of the canvas the text is rendered to.
	* This defaults to match the resolution of the renderer, but can be changed on a per Text object basis.
	* @name Phaser.Text#resolution
	* @property {integer} resolution
	*/Object.defineProperty(Phaser.Text.prototype,'resolution',{get:function get(){return this._res;},set:function set(value){if(value!==this._res){this._res=value;this.dirty=true;}}});/**
	* The size (in pixels) of the tabs, for when text includes tab characters. 0 disables. 
	* Can be an integer or an array of varying tab sizes, one tab per element.
	* For example if you set tabs to 100 then when Text encounters a tab it will jump ahead 100 pixels.
	* If you set tabs to be `[100,200]` then it will set the first tab at 100px and the second at 200px.
	* 
	* @name Phaser.Text#tabs
	* @property {integer|array} tabs
	*/Object.defineProperty(Phaser.Text.prototype,'tabs',{get:function get(){return this.style.tabs;},set:function set(value){if(value!==this.style.tabs){this.style.tabs=value;this.dirty=true;}}});/**
	* Horizontal alignment of the text within the `textBounds`. Can be: 'left', 'center' or 'right'.
	* @name Phaser.Text#boundsAlignH
	* @property {string} boundsAlignH
	*/Object.defineProperty(Phaser.Text.prototype,'boundsAlignH',{get:function get(){return this.style.boundsAlignH;},set:function set(value){if(value!==this.style.boundsAlignH){this.style.boundsAlignH=value;this.dirty=true;}}});/**
	* Vertical alignment of the text within the `textBounds`. Can be: 'top', 'middle' or 'bottom'.
	* @name Phaser.Text#boundsAlignV
	* @property {string} boundsAlignV
	*/Object.defineProperty(Phaser.Text.prototype,'boundsAlignV',{get:function get(){return this.style.boundsAlignV;},set:function set(value){if(value!==this.style.boundsAlignV){this.style.boundsAlignV=value;this.dirty=true;}}});/**
	* @name Phaser.Text#stroke
	* @property {string} stroke - A canvas fillstyle that will be used on the text stroke eg 'blue', '#FCFF00'.
	*/Object.defineProperty(Phaser.Text.prototype,'stroke',{get:function get(){return this.style.stroke;},set:function set(value){if(value!==this.style.stroke){this.style.stroke=value;this.dirty=true;}}});/**
	* @name Phaser.Text#strokeThickness
	* @property {number} strokeThickness - A number that represents the thickness of the stroke. Default is 0 (no stroke)
	*/Object.defineProperty(Phaser.Text.prototype,'strokeThickness',{get:function get(){return this.style.strokeThickness;},set:function set(value){if(value!==this.style.strokeThickness){this.style.strokeThickness=value;this.dirty=true;}}});/**
	* @name Phaser.Text#wordWrap
	* @property {boolean} wordWrap - Indicates if word wrap should be used.
	*/Object.defineProperty(Phaser.Text.prototype,'wordWrap',{get:function get(){return this.style.wordWrap;},set:function set(value){if(value!==this.style.wordWrap){this.style.wordWrap=value;this.dirty=true;}}});/**
	* @name Phaser.Text#wordWrapWidth
	* @property {number} wordWrapWidth - The width at which text will wrap.
	*/Object.defineProperty(Phaser.Text.prototype,'wordWrapWidth',{get:function get(){return this.style.wordWrapWidth;},set:function set(value){if(value!==this.style.wordWrapWidth){this.style.wordWrapWidth=value;this.dirty=true;}}});/**
	* @name Phaser.Text#lineSpacing
	* @property {number} lineSpacing - Additional spacing (in pixels) between each line of text if multi-line.
	*/Object.defineProperty(Phaser.Text.prototype,'lineSpacing',{get:function get(){return this._lineSpacing;},set:function set(value){if(value!==this._lineSpacing){this._lineSpacing=parseFloat(value);this.dirty=true;if(this.parent){this.updateTransform();}}}});/**
	* @name Phaser.Text#shadowOffsetX
	* @property {number} shadowOffsetX - The shadowOffsetX value in pixels. This is how far offset horizontally the shadow effect will be.
	*/Object.defineProperty(Phaser.Text.prototype,'shadowOffsetX',{get:function get(){return this.style.shadowOffsetX;},set:function set(value){if(value!==this.style.shadowOffsetX){this.style.shadowOffsetX=value;this.dirty=true;}}});/**
	* @name Phaser.Text#shadowOffsetY
	* @property {number} shadowOffsetY - The shadowOffsetY value in pixels. This is how far offset vertically the shadow effect will be.
	*/Object.defineProperty(Phaser.Text.prototype,'shadowOffsetY',{get:function get(){return this.style.shadowOffsetY;},set:function set(value){if(value!==this.style.shadowOffsetY){this.style.shadowOffsetY=value;this.dirty=true;}}});/**
	* @name Phaser.Text#shadowColor
	* @property {string} shadowColor - The color of the shadow, as given in CSS rgba format. Set the alpha component to 0 to disable the shadow.
	*/Object.defineProperty(Phaser.Text.prototype,'shadowColor',{get:function get(){return this.style.shadowColor;},set:function set(value){if(value!==this.style.shadowColor){this.style.shadowColor=value;this.dirty=true;}}});/**
	* @name Phaser.Text#shadowBlur
	* @property {number} shadowBlur - The shadowBlur value. Make the shadow softer by applying a Gaussian blur to it. A number from 0 (no blur) up to approx. 10 (depending on scene).
	*/Object.defineProperty(Phaser.Text.prototype,'shadowBlur',{get:function get(){return this.style.shadowBlur;},set:function set(value){if(value!==this.style.shadowBlur){this.style.shadowBlur=value;this.dirty=true;}}});/**
	* @name Phaser.Text#shadowStroke
	* @property {boolean} shadowStroke - Sets if the drop shadow is applied to the Text stroke.
	*/Object.defineProperty(Phaser.Text.prototype,'shadowStroke',{get:function get(){return this.style.shadowStroke;},set:function set(value){if(value!==this.style.shadowStroke){this.style.shadowStroke=value;this.dirty=true;}}});/**
	* @name Phaser.Text#shadowFill
	* @property {boolean} shadowFill - Sets if the drop shadow is applied to the Text fill.
	*/Object.defineProperty(Phaser.Text.prototype,'shadowFill',{get:function get(){return this.style.shadowFill;},set:function set(value){if(value!==this.style.shadowFill){this.style.shadowFill=value;this.dirty=true;}}});/**
	* @name Phaser.Text#width
	* @property {number} width - The width of the Text. Setting this will modify the scale to achieve the value requested.
	*/Object.defineProperty(Phaser.Text.prototype,'width',{get:function get(){if(this.dirty){this.updateText();this.dirty=false;}return this.scale.x*this.texture.frame.width;},set:function set(value){this.scale.x=value/this.texture.frame.width;this._width=value;}});/**
	* @name Phaser.Text#height
	* @property {number} height - The height of the Text. Setting this will modify the scale to achieve the value requested.
	*/Object.defineProperty(Phaser.Text.prototype,'height',{get:function get(){if(this.dirty){this.updateText();this.dirty=false;}return this.scale.y*this.texture.frame.height;},set:function set(value){this.scale.y=value/this.texture.frame.height;this._height=value;}});Phaser.Text.fontPropertiesCache={};Phaser.Text.fontPropertiesCanvas=document.createElement('canvas');Phaser.Text.fontPropertiesContext=Phaser.Text.fontPropertiesCanvas.getContext('2d');/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* BitmapText objects work by taking a texture file and an XML or JSON file that describes the font structure.
	* It then generates a new Sprite object for each letter of the text, proportionally spaced out and aligned to 
	* match the font structure.
	* 
	* BitmapText objects are less flexible than Text objects, in that they have less features such as shadows, fills and the ability 
	* to use Web Fonts, however you trade this flexibility for rendering speed. You can also create visually compelling BitmapTexts by
	* processing the font texture in an image editor, applying fills and any other effects required.
	*
	* To create multi-line text insert \r, \n or \r\n escape codes into the text string.
	*
	* If you are having performance issues due to the volume of sprites being rendered, and do not require the text to be constantly
	* updating, you can use BitmapText.generateTexture to create a static texture from this BitmapText.
	*
	* To create a BitmapText data files you can use:
	*
	* BMFont (Windows, free): http://www.angelcode.com/products/bmfont/
	* Glyph Designer (OS X, commercial): http://www.71squared.com/en/glyphdesigner
	* Littera (Web-based, free): http://kvazars.com/littera/
	*
	* For most use cases it is recommended to use XML. If you wish to use JSON, the formatting should be equal to the result of
	* converting a valid XML file through the popular X2JS library. An online tool for conversion can be found here: http://codebeautify.org/xmltojson
	*
	* If you were using an older version of Phaser (< 2.4) and using the DOMish parser hack, please remove this. It isn't required any longer.
	*
	* @class Phaser.BitmapText
	* @constructor
	* @extends PIXI.DisplayObjectContainer
	* @extends Phaser.Component.Core
	* @extends Phaser.Component.Angle
	* @extends Phaser.Component.AutoCull
	* @extends Phaser.Component.Bounds
	* @extends Phaser.Component.Destroy
	* @extends Phaser.Component.FixedToCamera
	* @extends Phaser.Component.InputEnabled
	* @extends Phaser.Component.InWorld
	* @extends Phaser.Component.LifeSpan
	* @extends Phaser.Component.PhysicsBody
	* @extends Phaser.Component.Reset
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {number} x - X coordinate to display the BitmapText object at.
	* @param {number} y - Y coordinate to display the BitmapText object at.
	* @param {string} font - The key of the BitmapText as stored in Phaser.Cache.
	* @param {string} [text=''] - The text that will be rendered. This can also be set later via BitmapText.text.
	* @param {number} [size=32] - The size the font will be rendered at in pixels.
	* @param {string} [align='left'] - The alignment of multi-line text. Has no effect if there is only one line of text.
	*/Phaser.BitmapText=function(game,x,y,font,text,size,align){x=x||0;y=y||0;font=font||'';text=text||'';size=size||32;align=align||'left';PIXI.DisplayObjectContainer.call(this);/**
	    * @property {number} type - The const type of this object.
	    * @readonly
	    */this.type=Phaser.BITMAPTEXT;/**
	    * @property {number} physicsType - The const physics body type of this object.
	    * @readonly
	    */this.physicsType=Phaser.SPRITE;/**
	    * @property {number} textWidth - The width in pixels of the overall text area, taking into consideration multi-line text.
	    * @readOnly
	    */this.textWidth=0;/**
	    * @property {number} textHeight - The height in pixels of the overall text area, taking into consideration multi-line text.
	    * @readOnly
	    */this.textHeight=0;/**
	    * @property {Phaser.Point} anchor - The anchor value of this BitmapText.
	    */this.anchor=new Phaser.Point();/**
	    * @property {Phaser.Point} _prevAnchor - The previous anchor value.
	    * @private
	    */this._prevAnchor=new Phaser.Point();/**
	    * @property {array} _glyphs - Private tracker for the letter sprite pool.
	    * @private
	    */this._glyphs=[];/**
	    * @property {number} _maxWidth - Internal cache var.
	    * @private
	    */this._maxWidth=0;/**
	    * @property {string} _text - Internal cache var.
	    * @private
	    */this._text=text.toString()||'';/**
	    * @property {string} _data - Internal cache var.
	    * @private
	    */this._data=game.cache.getBitmapFont(font);/**
	    * @property {string} _font - Internal cache var.
	    * @private
	    */this._font=font;/**
	    * @property {number} _fontSize - Internal cache var.
	    * @private
	    */this._fontSize=size;/**
	    * @property {string} _align - Internal cache var.
	    * @private
	    */this._align=align;/**
	    * @property {number} _tint - Internal cache var.
	    * @private
	    */this._tint=0xFFFFFF;this.updateText();/**
	    * @property {boolean} dirty - The dirty state of this object.
	    */this.dirty=false;Phaser.Component.Core.init.call(this,game,x,y,'',null);};Phaser.BitmapText.prototype=Object.create(PIXI.DisplayObjectContainer.prototype);Phaser.BitmapText.prototype.constructor=Phaser.BitmapText;Phaser.Component.Core.install.call(Phaser.BitmapText.prototype,['Angle','AutoCull','Bounds','Destroy','FixedToCamera','InputEnabled','InWorld','LifeSpan','PhysicsBody','Reset']);Phaser.BitmapText.prototype.preUpdatePhysics=Phaser.Component.PhysicsBody.preUpdate;Phaser.BitmapText.prototype.preUpdateLifeSpan=Phaser.Component.LifeSpan.preUpdate;Phaser.BitmapText.prototype.preUpdateInWorld=Phaser.Component.InWorld.preUpdate;Phaser.BitmapText.prototype.preUpdateCore=Phaser.Component.Core.preUpdate;/**
	* Automatically called by World.preUpdate.
	*
	* @method
	* @memberof Phaser.BitmapText
	* @return {boolean} True if the BitmapText was rendered, otherwise false.
	*/Phaser.BitmapText.prototype.preUpdate=function(){if(!this.preUpdatePhysics()||!this.preUpdateLifeSpan()||!this.preUpdateInWorld()){return false;}return this.preUpdateCore();};/**
	* Automatically called by World.preUpdate.
	* @method Phaser.BitmapText.prototype.postUpdate
	*/Phaser.BitmapText.prototype.postUpdate=function(){Phaser.Component.PhysicsBody.postUpdate.call(this);Phaser.Component.FixedToCamera.postUpdate.call(this);if(this.body&&this.body.type===Phaser.Physics.ARCADE){if(this.textWidth!==this.body.sourceWidth||this.textHeight!==this.body.sourceHeight){this.body.setSize(this.textWidth,this.textHeight);}}};/**
	* The text to be displayed by this BitmapText object.
	* 
	* It's faster to use `BitmapText.text = string`, but this is kept for backwards compatibility.
	*
	* @method Phaser.BitmapText.prototype.setText
	* @param {string} text - The text to be displayed by this BitmapText object.
	*/Phaser.BitmapText.prototype.setText=function(text){this.text=text;};/**
	* Given the input text this will scan the characters until either a newline is encountered, 
	* or the line exceeds maxWidth, taking into account kerning, character widths and scaling.
	* 
	* @method Phaser.BitmapText.prototype.scanLine
	* @private
	* @param {object} data - A reference to the font object in the Phaser.Cache.
	* @param {float} scale - The scale of the font in relation to the texture.
	* @param {string} text - The text to parse.
	* @return {object} An object containing the parsed characters, total pixel width and x offsets.
	*/Phaser.BitmapText.prototype.scanLine=function(data,scale,text){var x=0;var w=0;var lastSpace=-1;var wrappedWidth=0;var prevCharCode=null;var maxWidth=this._maxWidth>0?this._maxWidth:null;var chars=[];//  Let's scan the text and work out if any of the lines are > maxWidth
	for(var i=0;i<text.length;i++){var end=i===text.length-1?true:false;if(/(?:\r\n|\r|\n)/.test(text.charAt(i))){return{width:w,text:text.substr(0,i),end:end,chars:chars};}else{var charCode=text.charCodeAt(i);var charData=data.chars[charCode];var c=0;//  If the character data isn't found in the data array 
	//  then we replace it with a blank space
	if(charData===undefined){charCode=32;charData=data.chars[charCode];}//  Adjust for kerning from previous character to this one
	var kerning=prevCharCode&&charData.kerning[prevCharCode]?charData.kerning[prevCharCode]:0;//  Record the last space in the string and the current width
	if(/(\s)/.test(text.charAt(i))){lastSpace=i;wrappedWidth=w;}//  What will the line width be if we add this character to it?
	c=(kerning+charData.texture.width+charData.xOffset)*scale;//  Do we need to line-wrap?
	if(maxWidth&&w+c>=maxWidth&&lastSpace>-1){//  The last space was at "lastSpace" which was "i - lastSpace" characters ago
	return{width:wrappedWidth||w,text:text.substr(0,i-(i-lastSpace)),end:end,chars:chars};}else{w+=(charData.xAdvance+kerning)*scale;chars.push(x+(charData.xOffset+kerning)*scale);x+=(charData.xAdvance+kerning)*scale;prevCharCode=charCode;}}}return{width:w,text:text,end:end,chars:chars};};/**
	* Given a text string this will scan each character in the string to ensure it exists
	* in the BitmapText font data. If it doesn't the character is removed, or replaced with the `replace` argument.
	*
	* If no font data has been loaded at all this returns an empty string, as nothing can be rendered.
	* 
	* @method Phaser.BitmapText.prototype.cleanText
	* @param {string} text - The text to parse.
	* @param {string} [replace=''] - The replacement string for any missing characters.
	* @return {string} The cleaned text string.
	*/Phaser.BitmapText.prototype.cleanText=function(text,replace){if(replace===undefined){replace='';}var data=this._data.font;if(!data){return'';}var re=/\r\n|\n\r|\n|\r/g;var lines=text.replace(re,"\n").split("\n");for(var i=0;i<lines.length;i++){var output='';var line=lines[i];for(var c=0;c<line.length;c++){if(data.chars[line.charCodeAt(c)]){output=output.concat(line[c]);}else{output=output.concat(replace);}}lines[i]=output;}return lines.join("\n");};/**
	* Renders text and updates it when needed.
	*
	* @method Phaser.BitmapText.prototype.updateText
	* @private
	*/Phaser.BitmapText.prototype.updateText=function(){var data=this._data.font;if(!data){return;}var text=this.text;var scale=this._fontSize/data.size;var lines=[];var y=0;this.textWidth=0;do{var line=this.scanLine(data,scale,text);line.y=y;lines.push(line);if(line.width>this.textWidth){this.textWidth=line.width;}y+=data.lineHeight*scale;text=text.substr(line.text.length+1);}while(line.end===false);this.textHeight=y;var t=0;var align=0;var ax=this.textWidth*this.anchor.x;var ay=this.textHeight*this.anchor.y;for(var i=0;i<lines.length;i++){var line=lines[i];if(this._align==='right'){align=this.textWidth-line.width;}else if(this._align==='center'){align=(this.textWidth-line.width)/2;}for(var c=0;c<line.text.length;c++){var charCode=line.text.charCodeAt(c);var charData=data.chars[charCode];if(charData===undefined){charCode=32;charData=data.chars[charCode];}var g=this._glyphs[t];if(g){//  Sprite already exists in the glyphs pool, so we'll reuse it for this letter
	g.texture=charData.texture;}else{//  We need a new sprite as the pool is empty or exhausted
	g=new PIXI.Sprite(charData.texture);g.name=line.text[c];this._glyphs.push(g);}g.position.x=line.chars[c]+align-ax;g.position.y=line.y+charData.yOffset*scale-ay;g.scale.set(scale);g.tint=this.tint;g.texture.requiresReTint=true;if(!g.parent){this.addChild(g);}t++;}}//  Remove unnecessary children
	//  This moves them from the display list (children array) but retains them in the _glyphs pool
	for(i=t;i<this._glyphs.length;i++){this.removeChild(this._glyphs[i]);}};/**
	* If a BitmapText changes from having a large number of characters to having very few characters it will cause lots of
	* Sprites to be retained in the BitmapText._glyphs array. Although they are not attached to the display list they
	* still take up memory while sat in the glyphs pool waiting to be re-used in the future.
	*
	* If you know that the BitmapText will not grow any larger then you can purge out the excess glyphs from the pool 
	* by calling this method.
	*
	* Calling this doesn't prevent you from increasing the length of the text again in the future.
	*
	* @method Phaser.BitmapText.prototype.purgeGlyphs
	* @return {integer} The amount of glyphs removed from the pool.
	*/Phaser.BitmapText.prototype.purgeGlyphs=function(){var len=this._glyphs.length;var kept=[];for(var i=0;i<this._glyphs.length;i++){if(this._glyphs[i].parent!==this){this._glyphs[i].destroy();}else{kept.push(this._glyphs[i]);}}this._glyphs=[];this._glyphs=kept;this.updateText();return len-kept.length;};/**
	* Updates the transform of this object.
	*
	* @method Phaser.BitmapText.prototype.updateTransform
	* @private
	*/Phaser.BitmapText.prototype.updateTransform=function(){if(this.dirty||!this.anchor.equals(this._prevAnchor)){this.updateText();this.dirty=false;this._prevAnchor.copyFrom(this.anchor);}PIXI.DisplayObjectContainer.prototype.updateTransform.call(this);};/**
	* @name Phaser.BitmapText#align
	* @property {string} align - Alignment for multi-line text ('left', 'center' or 'right'), does not affect single lines of text.
	*/Object.defineProperty(Phaser.BitmapText.prototype,'align',{get:function get(){return this._align;},set:function set(value){if(value!==this._align&&(value==='left'||value==='center'||value==='right')){this._align=value;this.updateText();}}});/**
	* @name Phaser.BitmapText#tint
	* @property {number} tint - The tint applied to the BitmapText. This is a hex value. Set to white to disable (0xFFFFFF)
	*/Object.defineProperty(Phaser.BitmapText.prototype,'tint',{get:function get(){return this._tint;},set:function set(value){if(value!==this._tint){this._tint=value;this.updateText();}}});/**
	* @name Phaser.BitmapText#font
	* @property {string} font - The font the text will be rendered in, i.e. 'Arial'. Must be loaded in the browser before use.
	*/Object.defineProperty(Phaser.BitmapText.prototype,'font',{get:function get(){return this._font;},set:function set(value){if(value!==this._font){this._font=value.trim();this._data=this.game.cache.getBitmapFont(this._font);this.updateText();}}});/**
	* @name Phaser.BitmapText#fontSize
	* @property {number} fontSize - The size of the font in pixels.
	*/Object.defineProperty(Phaser.BitmapText.prototype,'fontSize',{get:function get(){return this._fontSize;},set:function set(value){value=parseInt(value,10);if(value!==this._fontSize&&value>0){this._fontSize=value;this.updateText();}}});/**
	* @name Phaser.BitmapText#text
	* @property {string} text - The text to be displayed by this BitmapText object.
	*/Object.defineProperty(Phaser.BitmapText.prototype,'text',{get:function get(){return this._text;},set:function set(value){if(value!==this._text){this._text=value.toString()||'';this.updateText();}}});/**
	* The maximum display width of this BitmapText in pixels.
	* 
	* If BitmapText.text is longer than maxWidth then the lines will be automatically wrapped 
	* based on the last whitespace character found in the line.
	* 
	* If no whitespace was found then no wrapping will take place and consequently the maxWidth value will not be honored.
	* 
	* Disable maxWidth by setting the value to 0.
	* 
	* @name Phaser.BitmapText#maxWidth
	* @property {number} maxWidth - The maximum width of this BitmapText in pixels.
	*/Object.defineProperty(Phaser.BitmapText.prototype,'maxWidth',{get:function get(){return this._maxWidth;},set:function set(value){if(value!==this._maxWidth){this._maxWidth=value;this.updateText();}}});/**
	* Enable or disable texture smoothing for this BitmapText.
	*
	* The smoothing is applied to the BaseTexture of this font, which all letters of the text reference.
	* 
	* Smoothing is enabled by default.
	* 
	* @name Phaser.BitmapText#smoothed
	* @property {boolean} smoothed
	*/Object.defineProperty(Phaser.BitmapText.prototype,'smoothed',{get:function get(){return!this._data.base.scaleMode;},set:function set(value){if(value){this._data.base.scaleMode=0;}else{this._data.base.scaleMode=1;}}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A Retro Font is similar to a BitmapFont, in that it uses a texture to render the text. However unlike a BitmapFont every character in a RetroFont
	* is the same size. This makes it similar to a sprite sheet. You typically find font sheets like this from old 8/16-bit games and demos.
	* 
	* @class Phaser.RetroFont
	* @extends Phaser.RenderTexture
	* @constructor
	* @param {Phaser.Game} game - Current game instance.
	* @param {string} key - The font set graphic set as stored in the Game.Cache.
	* @param {number} characterWidth - The width of each character in the font set.
	* @param {number} characterHeight - The height of each character in the font set.
	* @param {string} chars - The characters used in the font set, in display order. You can use the TEXT_SET consts for common font set arrangements.
	* @param {number} [charsPerRow] - The number of characters per row in the font set. If not given charsPerRow will be the image width / characterWidth.
	* @param {number} [xSpacing=0] - If the characters in the font set have horizontal spacing between them set the required amount here.
	* @param {number} [ySpacing=0] - If the characters in the font set have vertical spacing between them set the required amount here.
	* @param {number} [xOffset=0] - If the font set doesn't start at the top left of the given image, specify the X coordinate offset here.
	* @param {number} [yOffset=0] - If the font set doesn't start at the top left of the given image, specify the Y coordinate offset here.
	*/Phaser.RetroFont=function(game,key,characterWidth,characterHeight,chars,charsPerRow,xSpacing,ySpacing,xOffset,yOffset){if(!game.cache.checkImageKey(key)){return false;}if(charsPerRow===undefined||charsPerRow===null){charsPerRow=game.cache.getImage(key).width/characterWidth;}/**
	    * @property {number} characterWidth - The width of each character in the font set.
	    */this.characterWidth=characterWidth;/**
	    * @property {number} characterHeight - The height of each character in the font set.
	    */this.characterHeight=characterHeight;/**
	    * @property {number} characterSpacingX - If the characters in the font set have horizontal spacing between them set the required amount here.
	    */this.characterSpacingX=xSpacing||0;/**
	    * @property {number} characterSpacingY - If the characters in the font set have vertical spacing between them set the required amount here.
	    */this.characterSpacingY=ySpacing||0;/**
	    * @property {number} characterPerRow - The number of characters per row in the font set.
	    */this.characterPerRow=charsPerRow;/**
	    * @property {number} offsetX - If the font set doesn't start at the top left of the given image, specify the X coordinate offset here.
	    * @readonly
	    */this.offsetX=xOffset||0;/**
	    * @property {number} offsetY - If the font set doesn't start at the top left of the given image, specify the Y coordinate offset here.
	    * @readonly
	    */this.offsetY=yOffset||0;/**
	    * @property {string} align - Alignment of the text when multiLine = true or a fixedWidth is set. Set to RetroFont.ALIGN_LEFT (default), RetroFont.ALIGN_RIGHT or RetroFont.ALIGN_CENTER.
	    */this.align="left";/**
	    * @property {boolean} multiLine - If set to true all carriage-returns in text will form new lines (see align). If false the font will only contain one single line of text (the default)
	    * @default
	    */this.multiLine=false;/**
	    * @property {boolean} autoUpperCase - Automatically convert any text to upper case. Lots of old bitmap fonts only contain upper-case characters, so the default is true.
	    * @default
	    */this.autoUpperCase=true;/**
	    * @property {number} customSpacingX - Adds horizontal spacing between each character of the font, in pixels.
	    * @default
	    */this.customSpacingX=0;/**
	    * @property {number} customSpacingY - Adds vertical spacing between each line of multi-line text, set in pixels.
	    * @default
	    */this.customSpacingY=0;/**
	    * If you need this RetroFont image to have a fixed width you can set the width in this value.
	    * If text is wider than the width specified it will be cropped off.
	    * @property {number} fixedWidth
	    */this.fixedWidth=0;/**
	    * @property {Image} fontSet - A reference to the image stored in the Game.Cache that contains the font.
	    */this.fontSet=game.cache.getImage(key);/**
	    * @property {string} _text - The text of the font image.
	    * @private
	    */this._text='';/**
	    * @property {array} grabData - An array of rects for faster character pasting.
	    * @private
	    */this.grabData=[];/**
	    * @property {Phaser.FrameData} frameData - The FrameData representing this Retro Font.
	    */this.frameData=new Phaser.FrameData();//  Now generate our rects for faster copying later on
	var currentX=this.offsetX;var currentY=this.offsetY;var r=0;for(var c=0;c<chars.length;c++){var frame=this.frameData.addFrame(new Phaser.Frame(c,currentX,currentY,this.characterWidth,this.characterHeight));this.grabData[chars.charCodeAt(c)]=frame.index;r++;if(r===this.characterPerRow){r=0;currentX=this.offsetX;currentY+=this.characterHeight+this.characterSpacingY;}else{currentX+=this.characterWidth+this.characterSpacingX;}}game.cache.updateFrameData(key,this.frameData);/**
	    * @property {Phaser.Image} stamp - The image that is stamped to the RenderTexture for each character in the font.
	    * @readonly
	    */this.stamp=new Phaser.Image(game,0,0,key,0);Phaser.RenderTexture.call(this,game,100,100,'',Phaser.scaleModes.NEAREST);/**
	    * @property {number} type - Base Phaser object type.
	    */this.type=Phaser.RETROFONT;};Phaser.RetroFont.prototype=Object.create(Phaser.RenderTexture.prototype);Phaser.RetroFont.prototype.constructor=Phaser.RetroFont;/**
	* Align each line of multi-line text to the left.
	* @constant
	* @type {string}
	*/Phaser.RetroFont.ALIGN_LEFT="left";/**
	* Align each line of multi-line text to the right.
	* @constant
	* @type {string}
	*/Phaser.RetroFont.ALIGN_RIGHT="right";/**
	* Align each line of multi-line text in the center.
	* @constant
	* @type {string}
	*/Phaser.RetroFont.ALIGN_CENTER="center";/**
	* Text Set 1 =  !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\]^_`abcdefghijklmnopqrstuvwxyz{|}~
	* @constant
	* @type {string}
	*/Phaser.RetroFont.TEXT_SET1=" !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~";/**
	* Text Set 2 =  !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ
	* @constant
	* @type {string}
	*/Phaser.RetroFont.TEXT_SET2=" !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ";/**
	* Text Set 3 = ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 
	* @constant
	* @type {string}
	*/Phaser.RetroFont.TEXT_SET3="ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 ";/**
	* Text Set 4 = ABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789
	* @constant
	* @type {string}
	*/Phaser.RetroFont.TEXT_SET4="ABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789";/**
	* Text Set 5 = ABCDEFGHIJKLMNOPQRSTUVWXYZ.,/() '!?-*:0123456789
	* @constant
	* @type {string}
	*/Phaser.RetroFont.TEXT_SET5="ABCDEFGHIJKLMNOPQRSTUVWXYZ.,/() '!?-*:0123456789";/**
	* Text Set 6 = ABCDEFGHIJKLMNOPQRSTUVWXYZ!?:;0123456789"(),-.' 
	* @constant
	* @type {string}
	*/Phaser.RetroFont.TEXT_SET6="ABCDEFGHIJKLMNOPQRSTUVWXYZ!?:;0123456789\"(),-.' ";/**
	* Text Set 7 = AGMSY+:4BHNTZ!;5CIOU.?06DJPV,(17EKQW")28FLRX-'39
	* @constant
	* @type {string}
	*/Phaser.RetroFont.TEXT_SET7="AGMSY+:4BHNTZ!;5CIOU.?06DJPV,(17EKQW\")28FLRX-'39";/**
	* Text Set 8 = 0123456789 .ABCDEFGHIJKLMNOPQRSTUVWXYZ
	* @constant
	* @type {string}
	*/Phaser.RetroFont.TEXT_SET8="0123456789 .ABCDEFGHIJKLMNOPQRSTUVWXYZ";/**
	* Text Set 9 = ABCDEFGHIJKLMNOPQRSTUVWXYZ()-0123456789.:,'"?!
	* @constant
	* @type {string}
	*/Phaser.RetroFont.TEXT_SET9="ABCDEFGHIJKLMNOPQRSTUVWXYZ()-0123456789.:,'\"?!";/**
	* Text Set 10 = ABCDEFGHIJKLMNOPQRSTUVWXYZ
	* @constant
	* @type {string}
	*/Phaser.RetroFont.TEXT_SET10="ABCDEFGHIJKLMNOPQRSTUVWXYZ";/**
	* Text Set 11 = ABCDEFGHIJKLMNOPQRSTUVWXYZ.,"-+!?()':;0123456789
	* @constant
	* @type {string}
	*/Phaser.RetroFont.TEXT_SET11="ABCDEFGHIJKLMNOPQRSTUVWXYZ.,\"-+!?()':;0123456789";/**
	* If you need this RetroFont to have a fixed width and custom alignment you can set the width here.
	* If text is wider than the width specified it will be cropped off.
	*
	* @method Phaser.RetroFont#setFixedWidth
	* @memberof Phaser.RetroFont
	* @param {number} width - Width in pixels of this RetroFont. Set to zero to disable and re-enable automatic resizing.
	* @param {string} [lineAlignment='left'] - Align the text within this width. Set to RetroFont.ALIGN_LEFT (default), RetroFont.ALIGN_RIGHT or RetroFont.ALIGN_CENTER.
	*/Phaser.RetroFont.prototype.setFixedWidth=function(width,lineAlignment){if(lineAlignment===undefined){lineAlignment='left';}this.fixedWidth=width;this.align=lineAlignment;};/**
	* A helper function that quickly sets lots of variables at once, and then updates the text.
	*
	* @method Phaser.RetroFont#setText
	* @memberof Phaser.RetroFont
	* @param {string} content - The text of this sprite.
	* @param {boolean} [multiLine=false] - Set to true if you want to support carriage-returns in the text and create a multi-line sprite instead of a single line.
	* @param {number} [characterSpacing=0] - To add horizontal spacing between each character specify the amount in pixels.
	* @param {number} [lineSpacing=0] - To add vertical spacing between each line of text, set the amount in pixels.
	* @param {string} [lineAlignment='left'] - Align each line of multi-line text. Set to RetroFont.ALIGN_LEFT, RetroFont.ALIGN_RIGHT or RetroFont.ALIGN_CENTER.
	* @param {boolean} [allowLowerCase=false] - Lots of bitmap font sets only include upper-case characters, if yours needs to support lower case then set this to true.
	*/Phaser.RetroFont.prototype.setText=function(content,multiLine,characterSpacing,lineSpacing,lineAlignment,allowLowerCase){this.multiLine=multiLine||false;this.customSpacingX=characterSpacing||0;this.customSpacingY=lineSpacing||0;this.align=lineAlignment||'left';if(allowLowerCase){this.autoUpperCase=false;}else{this.autoUpperCase=true;}if(content.length>0){this.text=content;}};/**
	* Updates the texture with the new text.
	*
	* @method Phaser.RetroFont#buildRetroFontText
	* @memberof Phaser.RetroFont
	*/Phaser.RetroFont.prototype.buildRetroFontText=function(){var cx=0;var cy=0;//  Clears the textureBuffer
	this.clear();if(this.multiLine){var lines=this._text.split("\n");if(this.fixedWidth>0){this.resize(this.fixedWidth,lines.length*(this.characterHeight+this.customSpacingY)-this.customSpacingY,true);}else{this.resize(this.getLongestLine()*(this.characterWidth+this.customSpacingX),lines.length*(this.characterHeight+this.customSpacingY)-this.customSpacingY,true);}//  Loop through each line of text
	for(var i=0;i<lines.length;i++){//  Phaser.RetroFont.ALIGN_LEFT
	cx=0;//  This line of text is held in lines[i] - need to work out the alignment
	if(this.align===Phaser.RetroFont.ALIGN_RIGHT){cx=this.width-lines[i].length*(this.characterWidth+this.customSpacingX);}else if(this.align===Phaser.RetroFont.ALIGN_CENTER){cx=this.width/2-lines[i].length*(this.characterWidth+this.customSpacingX)/2;cx+=this.customSpacingX/2;}//  Sanity checks
	if(cx<0){cx=0;}this.pasteLine(lines[i],cx,cy,this.customSpacingX);cy+=this.characterHeight+this.customSpacingY;}}else{if(this.fixedWidth>0){this.resize(this.fixedWidth,this.characterHeight,true);}else{this.resize(this._text.length*(this.characterWidth+this.customSpacingX),this.characterHeight,true);}//  Phaser.RetroFont.ALIGN_LEFT
	cx=0;if(this.align===Phaser.RetroFont.ALIGN_RIGHT){cx=this.width-this._text.length*(this.characterWidth+this.customSpacingX);}else if(this.align===Phaser.RetroFont.ALIGN_CENTER){cx=this.width/2-this._text.length*(this.characterWidth+this.customSpacingX)/2;cx+=this.customSpacingX/2;}//  Sanity checks
	if(cx<0){cx=0;}this.pasteLine(this._text,cx,0,this.customSpacingX);}this.requiresReTint=true;};/**
	* Internal function that takes a single line of text (2nd parameter) and pastes it into the BitmapData at the given coordinates.
	* Used by getLine and getMultiLine
	*
	* @method Phaser.RetroFont#pasteLine
	* @memberof Phaser.RetroFont
	* @param {string} line - The single line of text to paste.
	* @param {number} x - The x coordinate.
	* @param {number} y - The y coordinate.
	* @param {number} customSpacingX - Custom X spacing.
	*/Phaser.RetroFont.prototype.pasteLine=function(line,x,y,customSpacingX){for(var c=0;c<line.length;c++){//  If it's a space then there is no point copying, so leave a blank space
	if(line.charAt(c)===" "){x+=this.characterWidth+customSpacingX;}else{//  If the character doesn't exist in the font then we don't want a blank space, we just want to skip it
	if(this.grabData[line.charCodeAt(c)]>=0){this.stamp.frame=this.grabData[line.charCodeAt(c)];this.renderXY(this.stamp,x,y,false);x+=this.characterWidth+customSpacingX;if(x>this.width){break;}}}}};/**
	* Works out the longest line of text in _text and returns its length
	*
	* @method Phaser.RetroFont#getLongestLine
	* @memberof Phaser.RetroFont
	* @return {number} The length of the longest line of text.
	*/Phaser.RetroFont.prototype.getLongestLine=function(){var longestLine=0;if(this._text.length>0){var lines=this._text.split("\n");for(var i=0;i<lines.length;i++){if(lines[i].length>longestLine){longestLine=lines[i].length;}}}return longestLine;};/**
	* Internal helper function that removes all unsupported characters from the _text String, leaving only characters contained in the font set.
	*
	* @method Phaser.RetroFont#removeUnsupportedCharacters
	* @memberof Phaser.RetroFont
	* @protected
	* @param {boolean} [stripCR=true] - Should it strip carriage returns as well?
	* @return {string}  A clean version of the string.
	*/Phaser.RetroFont.prototype.removeUnsupportedCharacters=function(stripCR){var newString="";for(var c=0;c<this._text.length;c++){var aChar=this._text[c];var code=aChar.charCodeAt(0);if(this.grabData[code]>=0||!stripCR&&aChar==="\n"){newString=newString.concat(aChar);}}return newString;};/**
	* Updates the x and/or y offset that the font is rendered from. This updates all of the texture frames, so be careful how often it is called.
	* Note that the values given for the x and y properties are either ADDED to or SUBTRACTED from (if negative) the existing offsetX/Y values of the characters.
	* So if the current offsetY is 8 and you want it to start rendering from y16 you would call updateOffset(0, 8) to add 8 to the current y offset.
	*
	* @method Phaser.RetroFont#updateOffset
	* @memberof Phaser.RetroFont
	* @param {number} [xOffset=0] - If the font set doesn't start at the top left of the given image, specify the X coordinate offset here.
	* @param {number} [yOffset=0] - If the font set doesn't start at the top left of the given image, specify the Y coordinate offset here.
	*/Phaser.RetroFont.prototype.updateOffset=function(x,y){if(this.offsetX===x&&this.offsetY===y){return;}var diffX=x-this.offsetX;var diffY=y-this.offsetY;var frames=this.game.cache.getFrameData(this.stamp.key).getFrames();var i=frames.length;while(i--){frames[i].x+=diffX;frames[i].y+=diffY;}this.buildRetroFontText();};/**
	* @name Phaser.RetroFont#text
	* @property {string} text - Set this value to update the text in this sprite. Carriage returns are automatically stripped out if multiLine is false. Text is converted to upper case if autoUpperCase is true.
	*/Object.defineProperty(Phaser.RetroFont.prototype,"text",{get:function get(){return this._text;},set:function set(value){var newText;if(this.autoUpperCase){newText=value.toUpperCase();}else{newText=value;}if(newText!==this._text){this._text=newText;this.removeUnsupportedCharacters(this.multiLine);this.buildRetroFontText();}}});/**
	* @name Phaser.RetroFont#smoothed
	* @property {boolean} smoothed - Sets if the stamp is smoothed or not.
	*/Object.defineProperty(Phaser.RetroFont.prototype,"smoothed",{get:function get(){return this.stamp.smoothed;},set:function set(value){this.stamp.smoothed=value;this.buildRetroFontText();}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd, Richard Davey
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A Rope is a Sprite that has a repeating texture.
	* 
	* The texture will automatically wrap on the edges as it moves.
	* 
	* Please note that Ropes cannot have an input handler.
	*
	* @class Phaser.Rope
	* @constructor
	* @extends PIXI.Rope
	* @extends Phaser.Component.Core
	* @extends Phaser.Component.Angle
	* @extends Phaser.Component.Animation
	* @extends Phaser.Component.AutoCull
	* @extends Phaser.Component.Bounds
	* @extends Phaser.Component.BringToTop
	* @extends Phaser.Component.Crop
	* @extends Phaser.Component.Delta
	* @extends Phaser.Component.Destroy
	* @extends Phaser.Component.FixedToCamera
	* @extends Phaser.Component.InWorld
	* @extends Phaser.Component.LifeSpan
	* @extends Phaser.Component.LoadTexture
	* @extends Phaser.Component.Overlap
	* @extends Phaser.Component.PhysicsBody
	* @extends Phaser.Component.Reset
	* @extends Phaser.Component.ScaleMinMax
	* @extends Phaser.Component.Smoothed
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {number} x - The x coordinate (in world space) to position the Rope at.
	* @param {number} y - The y coordinate (in world space) to position the Rope at.
	* @param {string|Phaser.RenderTexture|Phaser.BitmapData|PIXI.Texture} key - This is the image or texture used by the Rope during rendering. It can be a string which is a reference to the Cache entry, or an instance of a RenderTexture or PIXI.Texture.
	* @param {string|number} frame - If this Rope is using part of a sprite sheet or texture atlas you can specify the exact frame to use by giving a string or numeric index.
	* @param {Array} points - An array of {Phaser.Point}.
	*/Phaser.Rope=function(game,x,y,key,frame,points){this.points=[];this.points=points;this._hasUpdateAnimation=false;this._updateAnimationCallback=null;x=x||0;y=y||0;key=key||null;frame=frame||null;/**
	    * @property {number} type - The const type of this object.
	    * @readonly
	    */this.type=Phaser.ROPE;PIXI.Rope.call(this,Phaser.Cache.DEFAULT,this.points);Phaser.Component.Core.init.call(this,game,x,y,key,frame);};Phaser.Rope.prototype=Object.create(PIXI.Rope.prototype);Phaser.Rope.prototype.constructor=Phaser.Rope;Phaser.Component.Core.install.call(Phaser.Rope.prototype,['Angle','Animation','AutoCull','Bounds','BringToTop','Crop','Delta','Destroy','FixedToCamera','InWorld','LifeSpan','LoadTexture','Overlap','PhysicsBody','Reset','ScaleMinMax','Smoothed']);Phaser.Rope.prototype.preUpdatePhysics=Phaser.Component.PhysicsBody.preUpdate;Phaser.Rope.prototype.preUpdateLifeSpan=Phaser.Component.LifeSpan.preUpdate;Phaser.Rope.prototype.preUpdateInWorld=Phaser.Component.InWorld.preUpdate;Phaser.Rope.prototype.preUpdateCore=Phaser.Component.Core.preUpdate;/**
	* Automatically called by World.preUpdate.
	*
	* @method Phaser.Rope#preUpdate
	* @memberof Phaser.Rope
	*/Phaser.Rope.prototype.preUpdate=function(){if(!this.preUpdatePhysics()||!this.preUpdateLifeSpan()||!this.preUpdateInWorld()){return false;}return this.preUpdateCore();};/**
	* Override and use this function in your own custom objects to handle any update requirements you may have.
	*
	* @method Phaser.Rope#update
	* @memberof Phaser.Rope
	*/Phaser.Rope.prototype.update=function(){if(this._hasUpdateAnimation){this.updateAnimation.call(this);}};/**
	* Resets the Rope. This places the Rope at the given x/y world coordinates and then
	* sets alive, exists, visible and renderable all to true. Also resets the outOfBounds state.
	* If the Rope has a physics body that too is reset.
	*
	* @method Phaser.Rope#reset
	* @memberof Phaser.Rope
	* @param {number} x - The x coordinate (in world space) to position the Sprite at.
	* @param {number} y - The y coordinate (in world space) to position the Sprite at.
	* @return {Phaser.Rope} This instance.
	*/Phaser.Rope.prototype.reset=function(x,y){Phaser.Component.Reset.prototype.reset.call(this,x,y);return this;};/**
	* A Rope will call its updateAnimation function on each update loop if it has one.
	*
	* @name Phaser.Rope#updateAnimation
	* @property {function} updateAnimation - Set to a function if you'd like the rope to animate during the update phase. Set to false or null to remove it.
	*/Object.defineProperty(Phaser.Rope.prototype,"updateAnimation",{get:function get(){return this._updateAnimation;},set:function set(value){if(value&&typeof value==='function'){this._hasUpdateAnimation=true;this._updateAnimation=value;}else{this._hasUpdateAnimation=false;this._updateAnimation=null;}}});/**
	* The segments that make up the rope body as an array of Phaser.Rectangles
	*
	* @name Phaser.Rope#segments
	* @property {Phaser.Rectangles[]} updateAnimation - Returns an array of Phaser.Rectangles that represent the segments of the given rope
	*/Object.defineProperty(Phaser.Rope.prototype,"segments",{get:function get(){var segments=[];var index,x1,y1,x2,y2,width,height,rect;for(var i=0;i<this.points.length;i++){index=i*4;x1=this.vertices[index]*this.scale.x;y1=this.vertices[index+1]*this.scale.y;x2=this.vertices[index+4]*this.scale.x;y2=this.vertices[index+3]*this.scale.y;width=Phaser.Math.difference(x1,x2);height=Phaser.Math.difference(y1,y2);x1+=this.world.x;y1+=this.world.y;rect=new Phaser.Rectangle(x1,y1,width,height);segments.push(rect);}return segments;}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A TileSprite is a Sprite that has a repeating texture. The texture can be scrolled and scaled independently of the TileSprite itself.
	* Textures will automatically wrap and are designed so that you can create game backdrops using seamless textures as a source.
	* 
	* TileSprites have no input handler or physics bodies by default, both need enabling in the same way as for normal Sprites.
	*
	* You shouldn't ever create a TileSprite any larger than your actual screen size. If you want to create a large repeating background
	* that scrolls across the whole map of your game, then you create a TileSprite that fits the screen size and then use the `tilePosition`
	* property to scroll the texture as the player moves. If you create a TileSprite that is thousands of pixels in size then it will 
	* consume huge amounts of memory and cause performance issues. Remember: use `tilePosition` to scroll your texture and `tileScale` to
	* adjust the scale of the texture - don't resize the sprite itself or make it larger than it needs.
	*
	* An important note about texture dimensions:
	*
	* When running under Canvas a TileSprite can use any texture size without issue. When running under WebGL the texture should ideally be
	* a power of two in size (i.e. 4, 8, 16, 32, 64, 128, 256, 512, etc pixels width by height). If the texture isn't a power of two
	* it will be rendered to a blank canvas that is the correct size, which means you may have 'blank' areas appearing to the right and
	* bottom of your frame. To avoid this ensure your textures are perfect powers of two.
	* 
	* TileSprites support animations in the same way that Sprites do. You add and play animations using the AnimationManager. However
	* if your game is running under WebGL please note that each frame of the animation must be a power of two in size, or it will receive
	* additional padding to enforce it to be so.
	*
	* @class Phaser.TileSprite
	* @constructor
	* @extends PIXI.TilingSprite
	* @extends Phaser.Component.Core
	* @extends Phaser.Component.Angle
	* @extends Phaser.Component.Animation
	* @extends Phaser.Component.AutoCull
	* @extends Phaser.Component.Bounds
	* @extends Phaser.Component.BringToTop
	* @extends Phaser.Component.Destroy
	* @extends Phaser.Component.FixedToCamera
	* @extends Phaser.Component.Health
	* @extends Phaser.Component.InCamera
	* @extends Phaser.Component.InputEnabled
	* @extends Phaser.Component.InWorld
	* @extends Phaser.Component.LifeSpan
	* @extends Phaser.Component.LoadTexture
	* @extends Phaser.Component.Overlap
	* @extends Phaser.Component.PhysicsBody
	* @extends Phaser.Component.Reset
	* @extends Phaser.Component.Smoothed
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {number} x - The x coordinate (in world space) to position the TileSprite at.
	* @param {number} y - The y coordinate (in world space) to position the TileSprite at.
	* @param {number} width - The width of the TileSprite.
	* @param {number} height - The height of the TileSprite.
	* @param {string|Phaser.BitmapData|PIXI.Texture} key - This is the image or texture used by the TileSprite during rendering. It can be a string which is a reference to the Phaser Image Cache entry, or an instance of a PIXI.Texture or BitmapData.
	* @param {string|number} frame - If this TileSprite is using part of a sprite sheet or texture atlas you can specify the exact frame to use by giving a string or numeric index.
	*/Phaser.TileSprite=function(game,x,y,width,height,key,frame){x=x||0;y=y||0;width=width||256;height=height||256;key=key||null;frame=frame||null;/**
	    * @property {number} type - The const type of this object.
	    * @readonly
	    */this.type=Phaser.TILESPRITE;/**
	    * @property {number} physicsType - The const physics body type of this object.
	    * @readonly
	    */this.physicsType=Phaser.SPRITE;/**
	    * @property {Phaser.Point} _scroll - Internal cache var.
	    * @private
	    */this._scroll=new Phaser.Point();var def=game.cache.getImage('__default',true);PIXI.TilingSprite.call(this,new PIXI.Texture(def.base),width,height);Phaser.Component.Core.init.call(this,game,x,y,key,frame);};Phaser.TileSprite.prototype=Object.create(PIXI.TilingSprite.prototype);Phaser.TileSprite.prototype.constructor=Phaser.TileSprite;Phaser.Component.Core.install.call(Phaser.TileSprite.prototype,['Angle','Animation','AutoCull','Bounds','BringToTop','Destroy','FixedToCamera','Health','InCamera','InputEnabled','InWorld','LifeSpan','LoadTexture','Overlap','PhysicsBody','Reset','Smoothed']);Phaser.TileSprite.prototype.preUpdatePhysics=Phaser.Component.PhysicsBody.preUpdate;Phaser.TileSprite.prototype.preUpdateLifeSpan=Phaser.Component.LifeSpan.preUpdate;Phaser.TileSprite.prototype.preUpdateInWorld=Phaser.Component.InWorld.preUpdate;Phaser.TileSprite.prototype.preUpdateCore=Phaser.Component.Core.preUpdate;/**
	* Automatically called by World.preUpdate.
	*
	* @method Phaser.TileSprite#preUpdate
	* @memberof Phaser.TileSprite
	*/Phaser.TileSprite.prototype.preUpdate=function(){if(this._scroll.x!==0){this.tilePosition.x+=this._scroll.x*this.game.time.physicsElapsed;}if(this._scroll.y!==0){this.tilePosition.y+=this._scroll.y*this.game.time.physicsElapsed;}if(!this.preUpdatePhysics()||!this.preUpdateLifeSpan()||!this.preUpdateInWorld()){return false;}return this.preUpdateCore();};/**
	* Sets this TileSprite to automatically scroll in the given direction until stopped via TileSprite.stopScroll().
	* The scroll speed is specified in pixels per second.
	* A negative x value will scroll to the left. A positive x value will scroll to the right.
	* A negative y value will scroll up. A positive y value will scroll down.
	*
	* @method Phaser.TileSprite#autoScroll
	* @memberof Phaser.TileSprite
	* @param {number} x - Horizontal scroll speed in pixels per second.
	* @param {number} y - Vertical scroll speed in pixels per second.
	*/Phaser.TileSprite.prototype.autoScroll=function(x,y){this._scroll.set(x,y);};/**
	* Stops an automatically scrolling TileSprite.
	*
	* @method Phaser.TileSprite#stopScroll
	* @memberof Phaser.TileSprite
	*/Phaser.TileSprite.prototype.stopScroll=function(){this._scroll.set(0,0);};/**
	* Destroys the TileSprite. This removes it from its parent group, destroys the event and animation handlers if present
	* and nulls its reference to game, freeing it up for garbage collection.
	*
	* @method Phaser.TileSprite#destroy
	* @memberof Phaser.TileSprite
	* @param {boolean} [destroyChildren=true] - Should every child of this object have its destroy method called?
	*/Phaser.TileSprite.prototype.destroy=function(destroyChildren){Phaser.Component.Destroy.prototype.destroy.call(this,destroyChildren);PIXI.TilingSprite.prototype.destroy.call(this);};/**
	* Resets the TileSprite. This places the TileSprite at the given x/y world coordinates, resets the tilePosition and then
	* sets alive, exists, visible and renderable all to true. Also resets the outOfBounds state.
	* If the TileSprite has a physics body that too is reset.
	*
	* @method Phaser.TileSprite#reset
	* @memberof Phaser.TileSprite
	* @param {number} x - The x coordinate (in world space) to position the Sprite at.
	* @param {number} y - The y coordinate (in world space) to position the Sprite at.
	* @return {Phaser.TileSprite} This instance.
	*/Phaser.TileSprite.prototype.reset=function(x,y){Phaser.Component.Reset.prototype.reset.call(this,x,y);this.tilePosition.x=0;this.tilePosition.y=0;return this;};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* @classdesc
	* Detects device support capabilities and is responsible for device initialization - see {@link Phaser.Device.whenReady whenReady}.
	*
	* This class represents a singleton object that can be accessed directly as `game.device`
	* (or, as a fallback, `Phaser.Device` when a game instance is not available) without the need to instantiate it.
	*
	* Unless otherwise noted the device capabilities are only guaranteed after initialization. Initialization
	* occurs automatically and is guaranteed complete before {@link Phaser.Game} begins its "boot" phase.
	* Feature detection can be modified in the {@link Phaser.Device.onInitialized onInitialized} signal.
	*
	* When checking features using the exposed properties only the *truth-iness* of the value should be relied upon
	* unless the documentation states otherwise: properties may return `false`, `''`, `null`, or even `undefined`
	* when indicating the lack of a feature.
	*
	* Uses elements from System.js by MrDoob and Modernizr
	*
	* @description
	* It is not possible to instantiate the Device class manually.
	*
	* @class
	* @protected
	*/Phaser.Device=function(){/**
	    * The time the device became ready.
	    * @property {integer} deviceReadyAt
	    * @protected
	    */this.deviceReadyAt=0;/**
	    * The time as which initialization has completed.
	    * @property {boolean} initialized
	    * @protected
	    */this.initialized=false;//  Browser / Host / Operating System
	/**
	    * @property {boolean} desktop - Is running on a desktop?
	    * @default
	    */this.desktop=false;/**
	    * @property {boolean} iOS - Is running on iOS?
	    * @default
	    */this.iOS=false;/**
	    * @property {number} iOSVersion - If running in iOS this will contain the major version number.
	    * @default
	    */this.iOSVersion=0;/**
	    * @property {boolean} cocoonJS - Is the game running under CocoonJS?
	    * @default
	    */this.cocoonJS=false;/**
	    * @property {boolean} cocoonJSApp - Is this game running with CocoonJS.App?
	    * @default
	    */this.cocoonJSApp=false;/**
	    * @property {boolean} cordova - Is the game running under Apache Cordova?
	    * @default
	    */this.cordova=false;/**
	    * @property {boolean} node - Is the game running under Node.js?
	    * @default
	    */this.node=false;/**
	    * @property {boolean} nodeWebkit - Is the game running under Node-Webkit?
	    * @default
	    */this.nodeWebkit=false;/**
	    * @property {boolean} electron - Is the game running under GitHub Electron?
	    * @default
	    */this.electron=false;/**
	    * @property {boolean} ejecta - Is the game running under Ejecta?
	    * @default
	    */this.ejecta=false;/**
	    * @property {boolean} crosswalk - Is the game running under the Intel Crosswalk XDK?
	    * @default
	    */this.crosswalk=false;/**
	    * @property {boolean} android - Is running on android?
	    * @default
	    */this.android=false;/**
	    * @property {boolean} chromeOS - Is running on chromeOS?
	    * @default
	    */this.chromeOS=false;/**
	    * @property {boolean} linux - Is running on linux?
	    * @default
	    */this.linux=false;/**
	    * @property {boolean} macOS - Is running on macOS?
	    * @default
	    */this.macOS=false;/**
	    * @property {boolean} windows - Is running on windows?
	    * @default
	    */this.windows=false;/**
	    * @property {boolean} windowsPhone - Is running on a Windows Phone?
	    * @default
	    */this.windowsPhone=false;//  Features
	/**
	    * @property {boolean} canvas - Is canvas available?
	    * @default
	    */this.canvas=false;/**
	    * @property {?boolean} canvasBitBltShift - True if canvas supports a 'copy' bitblt onto itself when the source and destination regions overlap.
	    * @default
	    */this.canvasBitBltShift=null;/**
	    * @property {boolean} webGL - Is webGL available?
	    * @default
	    */this.webGL=false;/**
	    * @property {boolean} file - Is file available?
	    * @default
	    */this.file=false;/**
	    * @property {boolean} fileSystem - Is fileSystem available?
	    * @default
	    */this.fileSystem=false;/**
	    * @property {boolean} localStorage - Is localStorage available?
	    * @default
	    */this.localStorage=false;/**
	    * @property {boolean} worker - Is worker available?
	    * @default
	    */this.worker=false;/**
	    * @property {boolean} css3D - Is css3D available?
	    * @default
	    */this.css3D=false;/**
	    * @property {boolean} pointerLock - Is Pointer Lock available?
	    * @default
	    */this.pointerLock=false;/**
	    * @property {boolean} typedArray - Does the browser support TypedArrays?
	    * @default
	    */this.typedArray=false;/**
	    * @property {boolean} vibration - Does the device support the Vibration API?
	    * @default
	    */this.vibration=false;/**
	    * @property {boolean} getUserMedia - Does the device support the getUserMedia API?
	    * @default
	    */this.getUserMedia=true;/**
	    * @property {boolean} quirksMode - Is the browser running in strict mode (false) or quirks mode? (true)
	    * @default
	    */this.quirksMode=false;//  Input
	/**
	    * @property {boolean} touch - Is touch available?
	    * @default
	    */this.touch=false;/**
	    * @property {boolean} mspointer - Is mspointer available?
	    * @default
	    */this.mspointer=false;/**
	    * @property {?string} wheelType - The newest type of Wheel/Scroll event supported: 'wheel', 'mousewheel', 'DOMMouseScroll'
	    * @default
	    * @protected
	    */this.wheelEvent=null;//  Browser
	/**
	    * @property {boolean} arora - Set to true if running in Arora.
	    * @default
	    */this.arora=false;/**
	    * @property {boolean} chrome - Set to true if running in Chrome.
	    * @default
	    */this.chrome=false;/**
	    * @property {number} chromeVersion - If running in Chrome this will contain the major version number.
	    * @default
	    */this.chromeVersion=0;/**
	    * @property {boolean} epiphany - Set to true if running in Epiphany.
	    * @default
	    */this.epiphany=false;/**
	    * @property {boolean} firefox - Set to true if running in Firefox.
	    * @default
	    */this.firefox=false;/**
	    * @property {number} firefoxVersion - If running in Firefox this will contain the major version number.
	    * @default
	    */this.firefoxVersion=0;/**
	    * @property {boolean} ie - Set to true if running in Internet Explorer.
	    * @default
	    */this.ie=false;/**
	    * @property {number} ieVersion - If running in Internet Explorer this will contain the major version number. Beyond IE10 you should use Device.trident and Device.tridentVersion.
	    * @default
	    */this.ieVersion=0;/**
	    * @property {boolean} trident - Set to true if running a Trident version of Internet Explorer (IE11+)
	    * @default
	    */this.trident=false;/**
	    * @property {number} tridentVersion - If running in Internet Explorer 11 this will contain the major version number. See {@link http://msdn.microsoft.com/en-us/library/ie/ms537503(v=vs.85).aspx}
	    * @default
	    */this.tridentVersion=0;/**
	    * @property {boolean} edge - Set to true if running in Microsoft Edge browser.
	    * @default
	    */this.edge=false;/**
	    * @property {boolean} mobileSafari - Set to true if running in Mobile Safari.
	    * @default
	    */this.mobileSafari=false;/**
	    * @property {boolean} midori - Set to true if running in Midori.
	    * @default
	    */this.midori=false;/**
	    * @property {boolean} opera - Set to true if running in Opera.
	    * @default
	    */this.opera=false;/**
	    * @property {boolean} safari - Set to true if running in Safari.
	    * @default
	    */this.safari=false;/**
	    * @property {number} safariVersion - If running in Safari this will contain the major version number.
	    * @default
	    */this.safariVersion=0;/**
	    * @property {boolean} webApp - Set to true if running as a WebApp, i.e. within a WebView
	    * @default
	    */this.webApp=false;/**
	    * @property {boolean} silk - Set to true if running in the Silk browser (as used on the Amazon Kindle)
	    * @default
	    */this.silk=false;//  Audio
	/**
	    * @property {boolean} audioData - Are Audio tags available?
	    * @default
	    */this.audioData=false;/**
	    * @property {boolean} webAudio - Is the WebAudio API available?
	    * @default
	    */this.webAudio=false;/**
	    * @property {boolean} ogg - Can this device play ogg files?
	    * @default
	    */this.ogg=false;/**
	    * @property {boolean} opus - Can this device play opus files?
	    * @default
	    */this.opus=false;/**
	    * @property {boolean} mp3 - Can this device play mp3 files?
	    * @default
	    */this.mp3=false;/**
	    * @property {boolean} wav - Can this device play wav files?
	    * @default
	    */this.wav=false;/**
	    * Can this device play m4a files?
	    * @property {boolean} m4a - True if this device can play m4a files.
	    * @default
	    */this.m4a=false;/**
	    * @property {boolean} webm - Can this device play webm files?
	    * @default
	    */this.webm=false;/**
	    * @property {boolean} dolby - Can this device play EC-3 Dolby Digital Plus files?
	    * @default
	    */this.dolby=false;//  Video
	/**
	    * @property {boolean} oggVideo - Can this device play ogg video files?
	    * @default
	    */this.oggVideo=false;/**
	    * @property {boolean} h264Video - Can this device play h264 mp4 video files?
	    * @default
	    */this.h264Video=false;/**
	    * @property {boolean} mp4Video - Can this device play h264 mp4 video files?
	    * @default
	    */this.mp4Video=false;/**
	    * @property {boolean} webmVideo - Can this device play webm video files?
	    * @default
	    */this.webmVideo=false;/**
	    * @property {boolean} vp9Video - Can this device play vp9 video files?
	    * @default
	    */this.vp9Video=false;/**
	    * @property {boolean} hlsVideo - Can this device play hls video files?
	    * @default
	    */this.hlsVideo=false;//  Device
	/**
	    * @property {boolean} iPhone - Is running on iPhone?
	    * @default
	    */this.iPhone=false;/**
	    * @property {boolean} iPhone4 - Is running on iPhone4?
	    * @default
	    */this.iPhone4=false;/**
	    * @property {boolean} iPad - Is running on iPad?
	    * @default
	    */this.iPad=false;// Device features
	/**
	    * @property {number} pixelRatio - PixelRatio of the host device?
	    * @default
	    */this.pixelRatio=0;/**
	    * @property {boolean} littleEndian - Is the device big or little endian? (only detected if the browser supports TypedArrays)
	    * @default
	    */this.littleEndian=false;/**
	    * @property {boolean} LITTLE_ENDIAN - Same value as `littleEndian`.
	    * @default
	    */this.LITTLE_ENDIAN=false;/**
	    * @property {boolean} support32bit - Does the device context support 32bit pixel manipulation using array buffer views?
	    * @default
	    */this.support32bit=false;/**
	    * @property {boolean} fullscreen - Does the browser support the Full Screen API?
	    * @default
	    */this.fullscreen=false;/**
	    * @property {string} requestFullscreen - If the browser supports the Full Screen API this holds the call you need to use to activate it.
	    * @default
	    */this.requestFullscreen='';/**
	    * @property {string} cancelFullscreen - If the browser supports the Full Screen API this holds the call you need to use to cancel it.
	    * @default
	    */this.cancelFullscreen='';/**
	    * @property {boolean} fullscreenKeyboard - Does the browser support access to the Keyboard during Full Screen mode?
	    * @default
	    */this.fullscreenKeyboard=false;};// Device is really a singleton/static entity; instantiate it
	// and add new methods directly sans-prototype.
	Phaser.Device=new Phaser.Device();/**
	* This signal is dispatched after device initialization occurs but before any of the ready
	* callbacks (see {@link Phaser.Device.whenReady whenReady}) have been invoked.
	*
	* Local "patching" for a particular device can/should be done in this event.
	*
	* _Note_: This signal is removed after the device has been readied; if a handler has not been
	* added _before_ `new Phaser.Game(..)` it is probably too late.
	*
	* @type {?Phaser.Signal}
	* @static
	*/Phaser.Device.onInitialized=new Phaser.Signal();/**
	* Add a device-ready handler and ensure the device ready sequence is started.
	*
	* Phaser.Device will _not_ activate or initialize until at least one `whenReady` handler is added,
	* which is normally done automatically be calling `new Phaser.Game(..)`.
	*
	* The handler is invoked when the device is considered "ready", which may be immediately
	* if the device is already "ready". See {@link Phaser.Device#deviceReadyAt deviceReadyAt}.
	*
	* @method
	* @param {function} handler - Callback to invoke when the device is ready. It is invoked with the given context the Phaser.Device object is supplied as the first argument.
	* @param {object} [context] - Context in which to invoke the handler
	* @param {boolean} [nonPrimer=false] - If true the device ready check will not be started.
	*/Phaser.Device.whenReady=function(callback,context,nonPrimer){var readyCheck=this._readyCheck;if(this.deviceReadyAt||!readyCheck){callback.call(context,this);}else if(readyCheck._monitor||nonPrimer){readyCheck._queue=readyCheck._queue||[];readyCheck._queue.push([callback,context]);}else{readyCheck._monitor=readyCheck.bind(this);readyCheck._queue=readyCheck._queue||[];readyCheck._queue.push([callback,context]);var cordova=typeof window.cordova!=='undefined';var cocoonJS=navigator['isCocoonJS'];if(document.readyState==='complete'||document.readyState==='interactive'){// Why is there an additional timeout here?
	window.setTimeout(readyCheck._monitor,0);}else if(cordova&&!cocoonJS){// Ref. http://docs.phonegap.com/en/3.5.0/cordova_events_events.md.html#deviceready
	//  Cordova, but NOT Cocoon?
	document.addEventListener('deviceready',readyCheck._monitor,false);}else{document.addEventListener('DOMContentLoaded',readyCheck._monitor,false);window.addEventListener('load',readyCheck._monitor,false);}}};/**
	* Internal method used for checking when the device is ready.
	* This function is removed from Phaser.Device when the device becomes ready.
	*
	* @method
	* @private
	*/Phaser.Device._readyCheck=function(){var readyCheck=this._readyCheck;if(!document.body){window.setTimeout(readyCheck._monitor,20);}else if(!this.deviceReadyAt){this.deviceReadyAt=Date.now();document.removeEventListener('deviceready',readyCheck._monitor);document.removeEventListener('DOMContentLoaded',readyCheck._monitor);window.removeEventListener('load',readyCheck._monitor);this._initialize();this.initialized=true;this.onInitialized.dispatch(this);var item;while(item=readyCheck._queue.shift()){var callback=item[0];var context=item[1];callback.call(context,this);}// Remove no longer useful methods and properties.
	this._readyCheck=null;this._initialize=null;this.onInitialized=null;}};/**
	* Internal method to initialize the capability checks.
	* This function is removed from Phaser.Device once the device is initialized.
	*
	* @method
	* @private
	*/Phaser.Device._initialize=function(){var device=this;/**
	    * Check which OS is game running on.
	    */function _checkOS(){var ua=navigator.userAgent;if(/Playstation Vita/.test(ua)){device.vita=true;}else if(/Kindle/.test(ua)||/\bKF[A-Z][A-Z]+/.test(ua)||/Silk.*Mobile Safari/.test(ua)){device.kindle=true;// This will NOT detect early generations of Kindle Fire, I think there is no reliable way...
	// E.g. "Mozilla/5.0 (Macintosh; U; Intel Mac OS X 10_6_3; en-us; Silk/1.1.0-80) AppleWebKit/533.16 (KHTML, like Gecko) Version/5.0 Safari/533.16 Silk-Accelerated=true"
	}else if(/Android/.test(ua)){device.android=true;}else if(/CrOS/.test(ua)){device.chromeOS=true;}else if(/iP[ao]d|iPhone/i.test(ua)){device.iOS=true;navigator.appVersion.match(/OS (\d+)/);device.iOSVersion=parseInt(RegExp.$1,10);}else if(/Linux/.test(ua)){device.linux=true;}else if(/Mac OS/.test(ua)){device.macOS=true;}else if(/Windows/.test(ua)){device.windows=true;}if(/Windows Phone/i.test(ua)||/IEMobile/i.test(ua)){device.android=false;device.iOS=false;device.macOS=false;device.windows=true;device.windowsPhone=true;}var silk=/Silk/.test(ua);// detected in browsers
	if(device.windows||device.macOS||device.linux&&!silk||device.chromeOS){device.desktop=true;}//  Windows Phone / Table reset
	if(device.windowsPhone||/Windows NT/i.test(ua)&&/Touch/i.test(ua)){device.desktop=false;}}/**
	    * Check HTML5 features of the host environment.
	    */function _checkFeatures(){device.canvas=!!window['CanvasRenderingContext2D']||device.cocoonJS;try{device.localStorage=!!localStorage.getItem;}catch(error){device.localStorage=false;}device.file=!!window['File']&&!!window['FileReader']&&!!window['FileList']&&!!window['Blob'];device.fileSystem=!!window['requestFileSystem'];device.webGL=function(){try{var canvas=document.createElement('canvas');/*Force screencanvas to false*/canvas.screencanvas=false;return!!window.WebGLRenderingContext&&(canvas.getContext('webgl')||canvas.getContext('experimental-webgl'));}catch(e){return false;}}();device.webGL=!!device.webGL;device.worker=!!window['Worker'];device.pointerLock='pointerLockElement'in document||'mozPointerLockElement'in document||'webkitPointerLockElement'in document;device.quirksMode=document.compatMode==='CSS1Compat'?false:true;navigator.getUserMedia=navigator.getUserMedia||navigator.webkitGetUserMedia||navigator.mozGetUserMedia||navigator.msGetUserMedia||navigator.oGetUserMedia;window.URL=window.URL||window.webkitURL||window.mozURL||window.msURL;device.getUserMedia=device.getUserMedia&&!!navigator.getUserMedia&&!!window.URL;// Older versions of firefox (< 21) apparently claim support but user media does not actually work
	if(device.firefox&&device.firefoxVersion<21){device.getUserMedia=false;}// TODO: replace canvasBitBltShift detection with actual feature check
	// Excludes iOS versions as they generally wrap UIWebView (eg. Safari WebKit) and it
	// is safer to not try and use the fast copy-over method.
	if(!device.iOS&&(device.ie||device.firefox||device.chrome)){device.canvasBitBltShift=true;}// Known not to work
	if(device.safari||device.mobileSafari){device.canvasBitBltShift=false;}}/**
	    * Checks/configures various input.
	    */function _checkInput(){if('ontouchstart'in document.documentElement||window.navigator.maxTouchPoints&&window.navigator.maxTouchPoints>=1){device.touch=true;}if(window.navigator.msPointerEnabled||window.navigator.pointerEnabled){device.mspointer=true;}if(!device.cocoonJS){// See https://developer.mozilla.org/en-US/docs/Web/Events/wheel
	if('onwheel'in window||device.ie&&'WheelEvent'in window){// DOM3 Wheel Event: FF 17+, IE 9+, Chrome 31+, Safari 7+
	device.wheelEvent='wheel';}else if('onmousewheel'in window){// Non-FF legacy: IE 6-9, Chrome 1-31, Safari 5-7.
	device.wheelEvent='mousewheel';}else if(device.firefox&&'MouseScrollEvent'in window){// FF prior to 17. This should probably be scrubbed.
	device.wheelEvent='DOMMouseScroll';}}}/**
	    * Checks for support of the Full Screen API.
	    */function _checkFullScreenSupport(){var fs=['requestFullscreen','requestFullScreen','webkitRequestFullscreen','webkitRequestFullScreen','msRequestFullscreen','msRequestFullScreen','mozRequestFullScreen','mozRequestFullscreen'];var element=document.createElement('div');for(var i=0;i<fs.length;i++){if(element[fs[i]]){device.fullscreen=true;device.requestFullscreen=fs[i];break;}}var cfs=['cancelFullScreen','exitFullscreen','webkitCancelFullScreen','webkitExitFullscreen','msCancelFullScreen','msExitFullscreen','mozCancelFullScreen','mozExitFullscreen'];if(device.fullscreen){for(var i=0;i<cfs.length;i++){if(document[cfs[i]]){device.cancelFullscreen=cfs[i];break;}}}//  Keyboard Input?
	if(window['Element']&&Element['ALLOW_KEYBOARD_INPUT']){device.fullscreenKeyboard=true;}}/**
	    * Check what browser is game running in.
	    */function _checkBrowser(){var ua=navigator.userAgent;if(/Arora/.test(ua)){device.arora=true;}else if(/Edge\/\d+/.test(ua)){device.edge=true;}else if(/Chrome\/(\d+)/.test(ua)&&!device.windowsPhone){device.chrome=true;device.chromeVersion=parseInt(RegExp.$1,10);}else if(/Epiphany/.test(ua)){device.epiphany=true;}else if(/Firefox\D+(\d+)/.test(ua)){device.firefox=true;device.firefoxVersion=parseInt(RegExp.$1,10);}else if(/AppleWebKit/.test(ua)&&device.iOS){device.mobileSafari=true;}else if(/MSIE (\d+\.\d+);/.test(ua)){device.ie=true;device.ieVersion=parseInt(RegExp.$1,10);}else if(/Midori/.test(ua)){device.midori=true;}else if(/Opera/.test(ua)){device.opera=true;}else if(/Safari\/(\d+)/.test(ua)&&!device.windowsPhone){device.safari=true;if(/Version\/(\d+)\./.test(ua)){device.safariVersion=parseInt(RegExp.$1,10);}}else if(/Trident\/(\d+\.\d+)(.*)rv:(\d+\.\d+)/.test(ua)){device.ie=true;device.trident=true;device.tridentVersion=parseInt(RegExp.$1,10);device.ieVersion=parseInt(RegExp.$3,10);}//  Silk gets its own if clause because its ua also contains 'Safari'
	if(/Silk/.test(ua)){device.silk=true;}//  WebApp mode in iOS
	if(navigator['standalone']){device.webApp=true;}if(typeof window.cordova!=='undefined'){device.cordova=true;}if(typeof process!=='undefined'&&"function"!=='undefined'){device.node=true;}if(device.node&&_typeof(process.versions)==='object'){device.nodeWebkit=!!process.versions['node-webkit'];device.electron=!!process.versions.electron;}if(navigator['isCocoonJS']){device.cocoonJS=true;}if(device.cocoonJS){try{device.cocoonJSApp=typeof CocoonJS!=='undefined';}catch(error){device.cocoonJSApp=false;}}if(typeof window.ejecta!=='undefined'){device.ejecta=true;}if(/Crosswalk/.test(ua)){device.crosswalk=true;}}/**
	    * Check video support.
	    */function _checkVideo(){var videoElement=document.createElement("video");var result=false;try{if(result=!!videoElement.canPlayType){if(videoElement.canPlayType('video/ogg; codecs="theora"').replace(/^no$/,'')){device.oggVideo=true;}if(videoElement.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/,'')){// Without QuickTime, this value will be `undefined`. github.com/Modernizr/Modernizr/issues/546
	device.h264Video=true;device.mp4Video=true;}if(videoElement.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/,'')){device.webmVideo=true;}if(videoElement.canPlayType('video/webm; codecs="vp9"').replace(/^no$/,'')){device.vp9Video=true;}if(videoElement.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/,'')){device.hlsVideo=true;}}}catch(e){}}/**
	    * Check audio support.
	    */function _checkAudio(){device.audioData=!!window['Audio'];device.webAudio=!!(window['AudioContext']||window['webkitAudioContext']);var audioElement=document.createElement('audio');var result=false;try{if(result=!!audioElement.canPlayType){if(audioElement.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,'')){device.ogg=true;}if(audioElement.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/,'')||audioElement.canPlayType('audio/opus;').replace(/^no$/,'')){device.opus=true;}if(audioElement.canPlayType('audio/mpeg;').replace(/^no$/,'')){device.mp3=true;}// Mimetypes accepted:
	//   developer.mozilla.org/En/Media_formats_supported_by_the_audio_and_video_elements
	//   bit.ly/iphoneoscodecs
	if(audioElement.canPlayType('audio/wav; codecs="1"').replace(/^no$/,'')){device.wav=true;}if(audioElement.canPlayType('audio/x-m4a;')||audioElement.canPlayType('audio/aac;').replace(/^no$/,'')){device.m4a=true;}if(audioElement.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/,'')){device.webm=true;}if(audioElement.canPlayType('audio/mp4;codecs="ec-3"')!==''){if(device.edge){device.dolby=true;}else if(device.safari&&device.safariVersion>=9){if(/Mac OS X (\d+)_(\d+)/.test(navigator.userAgent)){var major=parseInt(RegExp.$1,10);var minor=parseInt(RegExp.$2,10);if(major===10&&minor>=11||major>10){device.dolby=true;}}}}}}catch(e){}}/**
	    * Check Little or Big Endian system.
	    *
	    * @author Matt DesLauriers (@mattdesl)
	    */function _checkIsLittleEndian(){var a=new ArrayBuffer(4);var b=new Uint8Array(a);var c=new Uint32Array(a);b[0]=0xa1;b[1]=0xb2;b[2]=0xc3;b[3]=0xd4;if(c[0]===0xd4c3b2a1){return true;}if(c[0]===0xa1b2c3d4){return false;}else{//  Could not determine endianness
	return null;}}/**
	    * Test to see if ImageData uses CanvasPixelArray or Uint8ClampedArray.
	    *
	    * @author Matt DesLauriers (@mattdesl)
	    */function _checkIsUint8ClampedImageData(){if(Uint8ClampedArray===undefined){return false;}var elem=PIXI.CanvasPool.create(this,1,1);var ctx=elem.getContext('2d');if(!ctx){return false;}var image=ctx.createImageData(1,1);PIXI.CanvasPool.remove(this);return image.data instanceof Uint8ClampedArray;}/**
	    * Check PixelRatio, iOS device, Vibration API, ArrayBuffers and endianess.
	    */function _checkDevice(){device.pixelRatio=window['devicePixelRatio']||1;device.iPhone=navigator.userAgent.toLowerCase().indexOf('iphone')!==-1;device.iPhone4=device.pixelRatio===2&&device.iPhone;device.iPad=navigator.userAgent.toLowerCase().indexOf('ipad')!==-1;if(typeof Int8Array!=='undefined'){device.typedArray=true;}else{device.typedArray=false;}if(typeof ArrayBuffer!=='undefined'&&typeof Uint8Array!=='undefined'&&typeof Uint32Array!=='undefined'){device.littleEndian=_checkIsLittleEndian();device.LITTLE_ENDIAN=device.littleEndian;}device.support32bit=typeof ArrayBuffer!=='undefined'&&typeof Uint8ClampedArray!=='undefined'&&typeof Int32Array!=='undefined'&&device.littleEndian!==null&&_checkIsUint8ClampedImageData();navigator.vibrate=navigator.vibrate||navigator.webkitVibrate||navigator.mozVibrate||navigator.msVibrate;if(navigator.vibrate){device.vibration=true;}}/**
	    * Check whether the host environment support 3D CSS.
	    */function _checkCSS3D(){var el=document.createElement('p');var has3d;var transforms={'webkitTransform':'-webkit-transform','OTransform':'-o-transform','msTransform':'-ms-transform','MozTransform':'-moz-transform','transform':'transform'};// Add it to the body to get the computed style.
	document.body.insertBefore(el,null);for(var t in transforms){if(el.style[t]!==undefined){el.style[t]="translate3d(1px,1px,1px)";has3d=window.getComputedStyle(el).getPropertyValue(transforms[t]);}}document.body.removeChild(el);device.css3D=has3d!==undefined&&has3d.length>0&&has3d!=="none";}//  Run the checks
	_checkOS();_checkBrowser();_checkAudio();_checkVideo();_checkCSS3D();_checkDevice();_checkFeatures();_checkFullScreenSupport();_checkInput();};/**
	* Check whether the host environment can play audio.
	*
	* @method canPlayAudio
	* @memberof Phaser.Device.prototype
	* @param {string} type - One of 'mp3, 'ogg', 'm4a', 'wav', 'webm' or 'opus'.
	* @return {boolean} True if the given file type is supported by the browser, otherwise false.
	*/Phaser.Device.canPlayAudio=function(type){if(type==='mp3'&&this.mp3){return true;}else if(type==='ogg'&&(this.ogg||this.opus)){return true;}else if(type==='m4a'&&this.m4a){return true;}else if(type==='opus'&&this.opus){return true;}else if(type==='wav'&&this.wav){return true;}else if(type==='webm'&&this.webm){return true;}else if(type==='mp4'&&this.dolby){return true;}return false;};/**
	* Check whether the host environment can play video files.
	*
	* @method canPlayVideo
	* @memberof Phaser.Device.prototype
	* @param {string} type - One of 'mp4, 'ogg', 'webm' or 'mpeg'.
	* @return {boolean} True if the given file type is supported by the browser, otherwise false.
	*/Phaser.Device.canPlayVideo=function(type){if(type==='webm'&&(this.webmVideo||this.vp9Video)){return true;}else if(type==='mp4'&&(this.mp4Video||this.h264Video)){return true;}else if((type==='ogg'||type==='ogv')&&this.oggVideo){return true;}else if(type==='mpeg'&&this.hlsVideo){return true;}return false;};/**
	* Check whether the console is open.
	* Note that this only works in Firefox with Firebug and earlier versions of Chrome.
	* It used to work in Chrome, but then they removed the ability: {@link http://src.chromium.org/viewvc/blink?view=revision&revision=151136}
	*
	* @method isConsoleOpen
	* @memberof Phaser.Device.prototype
	*/Phaser.Device.isConsoleOpen=function(){if(window.console&&window.console['firebug']){return true;}if(window.console){console.profile();console.profileEnd();if(console.clear){console.clear();}if(console['profiles']){return console['profiles'].length>0;}}return false;};/**
	* Detect if the host is a an Android Stock browser.
	* This is available before the device "ready" event.
	*
	* Authors might want to scale down on effects and switch to the CANVAS rendering method on those devices.
	*
	* @example
	* var defaultRenderingMode = Phaser.Device.isAndroidStockBrowser() ? Phaser.CANVAS : Phaser.AUTO;
	* 
	* @method isAndroidStockBrowser
	* @memberof Phaser.Device.prototype
	*/Phaser.Device.isAndroidStockBrowser=function(){var matches=window.navigator.userAgent.match(/Android.*AppleWebKit\/([\d.]+)/);return matches&&matches[1]<537;};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Canvas class handles everything related to creating the `canvas` DOM tag that Phaser will use, 
	* including styles, offset and aspect ratio.
	*
	* @class Phaser.Canvas
	* @static
	*/Phaser.Canvas={/**
	    * Creates a `canvas` DOM element. The element is not automatically added to the document.
	    *
	    * @method Phaser.Canvas.create
	    * @param {object} parent - The object that will own the canvas that is created.
	    * @param {number} [width=256] - The width of the canvas element.
	    * @param {number} [height=256] - The height of the canvas element..
	    * @param {string} [id=(none)] - If specified, and not the empty string, this will be set as the ID of the canvas element. Otherwise no ID will be set.
	    * @param {boolean} [skipPool=false] - If `true` the canvas will not be placed in the CanvasPool global.
	    * @return {HTMLCanvasElement} The newly created canvas element.
	    */create:function create(parent,width,height,id,skipPool){width=width||256;height=height||256;var canvas=skipPool?document.createElement('canvas'):PIXI.CanvasPool.create(parent,width,height);if(typeof id==='string'&&id!==''){canvas.id=id;}canvas.width=width;canvas.height=height;canvas.style.display='block';return canvas;},/**
	    * Sets the background color behind the canvas. This changes the canvas style property.
	    *
	    * @method Phaser.Canvas.setBackgroundColor
	    * @param {HTMLCanvasElement} canvas - The canvas to set the background color on.
	    * @param {string} [color='rgb(0,0,0)'] - The color to set. Can be in the format 'rgb(r,g,b)', or '#RRGGBB' or any valid CSS color.
	    * @return {HTMLCanvasElement} Returns the source canvas.
	    */setBackgroundColor:function setBackgroundColor(canvas,color){color=color||'rgb(0,0,0)';canvas.style.backgroundColor=color;return canvas;},/**
	    * Sets the touch-action property on the canvas style. Can be used to disable default browser touch actions.
	    *
	    * @method Phaser.Canvas.setTouchAction
	    * @param {HTMLCanvasElement} canvas - The canvas to set the touch action on.
	    * @param {string} [value] - The touch action to set. Defaults to 'none'.
	    * @return {HTMLCanvasElement} The source canvas.
	    */setTouchAction:function setTouchAction(canvas,value){value=value||'none';canvas.style.msTouchAction=value;canvas.style['ms-touch-action']=value;canvas.style['touch-action']=value;return canvas;},/**
	    * Sets the user-select property on the canvas style. Can be used to disable default browser selection actions.
	    *
	    * @method Phaser.Canvas.setUserSelect
	    * @param {HTMLCanvasElement} canvas - The canvas to set the touch action on.
	    * @param {string} [value] - The touch action to set. Defaults to 'none'.
	    * @return {HTMLCanvasElement} The source canvas.
	    */setUserSelect:function setUserSelect(canvas,value){value=value||'none';canvas.style['-webkit-touch-callout']=value;canvas.style['-webkit-user-select']=value;canvas.style['-khtml-user-select']=value;canvas.style['-moz-user-select']=value;canvas.style['-ms-user-select']=value;canvas.style['user-select']=value;canvas.style['-webkit-tap-highlight-color']='rgba(0, 0, 0, 0)';return canvas;},/**
	    * Adds the given canvas element to the DOM. The canvas will be added as a child of the given parent.
	    * If no parent is given it will be added as a child of the document.body.
	    *
	    * @method Phaser.Canvas.addToDOM
	    * @param {HTMLCanvasElement} canvas - The canvas to be added to the DOM.
	    * @param {string|HTMLElement} parent - The DOM element to add the canvas to.
	    * @param {boolean} [overflowHidden=true] - If set to true it will add the overflow='hidden' style to the parent DOM element.
	    * @return {HTMLCanvasElement} Returns the source canvas.
	    */addToDOM:function addToDOM(canvas,parent,overflowHidden){var target;if(overflowHidden===undefined){overflowHidden=true;}if(parent){if(typeof parent==='string'){// hopefully an element ID
	target=document.getElementById(parent);}else if((typeof parent==='undefined'?'undefined':_typeof(parent))==='object'&&parent.nodeType===1){// quick test for a HTMLelement
	target=parent;}}// Fallback, covers an invalid ID and a non HTMLelement object
	if(!target){target=document.body;}if(overflowHidden&&target.style){target.style.overflow='hidden';}target.appendChild(canvas);return canvas;},/**
	    * Removes the given canvas element from the DOM.
	    *
	    * @method Phaser.Canvas.removeFromDOM
	    * @param {HTMLCanvasElement} canvas - The canvas to be removed from the DOM.
	    */removeFromDOM:function removeFromDOM(canvas){if(canvas.parentNode){canvas.parentNode.removeChild(canvas);}},/**
	    * Sets the transform of the given canvas to the matrix values provided.
	    *
	    * @method Phaser.Canvas.setTransform
	    * @param {CanvasRenderingContext2D} context - The context to set the transform on.
	    * @param {number} translateX - The value to translate horizontally by.
	    * @param {number} translateY - The value to translate vertically by.
	    * @param {number} scaleX - The value to scale horizontally by.
	    * @param {number} scaleY - The value to scale vertically by.
	    * @param {number} skewX - The value to skew horizontaly by.
	    * @param {number} skewY - The value to skew vertically by.
	    * @return {CanvasRenderingContext2D} Returns the source context.
	    */setTransform:function setTransform(context,translateX,translateY,scaleX,scaleY,skewX,skewY){context.setTransform(scaleX,skewX,skewY,scaleY,translateX,translateY);return context;},/**
	    * Sets the Image Smoothing property on the given context. Set to false to disable image smoothing.
	    * By default browsers have image smoothing enabled, which isn't always what you visually want, especially
	    * when using pixel art in a game. Note that this sets the property on the context itself, so that any image
	    * drawn to the context will be affected. This sets the property across all current browsers but support is
	    * patchy on earlier browsers, especially on mobile.
	    *
	    * @method Phaser.Canvas.setSmoothingEnabled
	    * @param {CanvasRenderingContext2D} context - The context to enable or disable the image smoothing on.
	    * @param {boolean} value - If set to true it will enable image smoothing, false will disable it.
	    * @return {CanvasRenderingContext2D} Returns the source context.
	    */setSmoothingEnabled:function setSmoothingEnabled(context,value){var s=Phaser.Canvas.getSmoothingPrefix(context);if(s){context[s]=value;}return context;},/**
	    * Gets the Smoothing Enabled vendor prefix being used on the given context, or null if not set.
	    *
	    * @method Phaser.Canvas.getSmoothingPrefix
	    * @param {CanvasRenderingContext2D} context - The context to enable or disable the image smoothing on.
	    * @return {string|null} Returns the smoothingEnabled vendor prefix, or null if not set on the context.
	    */getSmoothingPrefix:function getSmoothingPrefix(context){var vendor=['i','webkitI','msI','mozI','oI'];for(var prefix in vendor){var s=vendor[prefix]+'mageSmoothingEnabled';if(s in context){return s;}}return null;},/**
	     * Returns `true` if the given context has image smoothing enabled, otherwise returns `false`.
	     *
	     * @method Phaser.Canvas.getSmoothingEnabled
	     * @param {CanvasRenderingContext2D} context - The context to check for smoothing on.
	     * @return {boolean} True if the given context has image smoothing enabled, otherwise false.
	     */getSmoothingEnabled:function getSmoothingEnabled(context){var s=Phaser.Canvas.getSmoothingPrefix(context);if(s){return context[s];}},/**
	    * Sets the CSS image-rendering property on the given canvas to be 'crisp' (aka 'optimize contrast' on webkit).
	    * Note that if this doesn't given the desired result then see the setSmoothingEnabled.
	    *
	    * @method Phaser.Canvas.setImageRenderingCrisp
	    * @param {HTMLCanvasElement} canvas - The canvas to set image-rendering crisp on.
	    * @return {HTMLCanvasElement} Returns the source canvas.
	    */setImageRenderingCrisp:function setImageRenderingCrisp(canvas){var types=['optimizeSpeed','crisp-edges','-moz-crisp-edges','-webkit-optimize-contrast','optimize-contrast','pixelated'];for(var i=0;i<types.length;i++){canvas.style['image-rendering']=types[i];}canvas.style.msInterpolationMode='nearest-neighbor';return canvas;},/**
	    * Sets the CSS image-rendering property on the given canvas to be 'bicubic' (aka 'auto').
	    * Note that if this doesn't given the desired result then see the CanvasUtils.setSmoothingEnabled method.
	    *
	    * @method Phaser.Canvas.setImageRenderingBicubic
	    * @param {HTMLCanvasElement} canvas The canvas to set image-rendering bicubic on.
	    * @return {HTMLCanvasElement} Returns the source canvas.
	    */setImageRenderingBicubic:function setImageRenderingBicubic(canvas){canvas.style['image-rendering']='auto';canvas.style.msInterpolationMode='bicubic';return canvas;}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Abstracts away the use of RAF or setTimeOut for the core game update loop.
	*
	* @class Phaser.RequestAnimationFrame
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {boolean} [forceSetTimeOut=false] - Tell Phaser to use setTimeOut even if raf is available.
	*/Phaser.RequestAnimationFrame=function(game,forceSetTimeOut){if(forceSetTimeOut===undefined){forceSetTimeOut=false;}/**
	    * @property {Phaser.Game} game - The currently running game.
	    */this.game=game;/**
	    * @property {boolean} isRunning - true if RequestAnimationFrame is running, otherwise false.
	    * @default
	    */this.isRunning=false;/**
	    * @property {boolean} forceSetTimeOut - Tell Phaser to use setTimeOut even if raf is available.
	    */this.forceSetTimeOut=forceSetTimeOut;var vendors=['ms','moz','webkit','o'];for(var x=0;x<vendors.length&&!window.requestAnimationFrame;x++){window.requestAnimationFrame=window[vendors[x]+'RequestAnimationFrame'];window.cancelAnimationFrame=window[vendors[x]+'CancelAnimationFrame'];}/**
	    * @property {boolean} _isSetTimeOut  - true if the browser is using setTimeout instead of raf.
	    * @private
	    */this._isSetTimeOut=false;/**
	    * @property {function} _onLoop - The function called by the update.
	    * @private
	    */this._onLoop=null;/**
	    * @property {number} _timeOutID - The callback ID used when calling cancel.
	    * @private
	    */this._timeOutID=null;};Phaser.RequestAnimationFrame.prototype={/**
	    * Starts the requestAnimationFrame running or setTimeout if unavailable in browser
	    * @method Phaser.RequestAnimationFrame#start
	    */start:function start(){this.isRunning=true;var _this=this;if(!window.requestAnimationFrame||this.forceSetTimeOut){this._isSetTimeOut=true;this._onLoop=function(){return _this.updateSetTimeout();};this._timeOutID=window.setTimeout(this._onLoop,0);}else{this._isSetTimeOut=false;this._onLoop=function(time){return _this.updateRAF(time);};this._timeOutID=window.requestAnimationFrame(this._onLoop);}},/**
	    * The update method for the requestAnimationFrame
	    * @method Phaser.RequestAnimationFrame#updateRAF
	    */updateRAF:function updateRAF(rafTime){if(this.isRunning){// floor the rafTime to make it equivalent to the Date.now() provided by updateSetTimeout (just below)
	this.game.update(Math.floor(rafTime));this._timeOutID=window.requestAnimationFrame(this._onLoop);}},/**
	    * The update method for the setTimeout.
	    * @method Phaser.RequestAnimationFrame#updateSetTimeout
	    */updateSetTimeout:function updateSetTimeout(){if(this.isRunning){this.game.update(Date.now());this._timeOutID=window.setTimeout(this._onLoop,this.game.time.timeToCall);}},/**
	    * Stops the requestAnimationFrame from running.
	    * @method Phaser.RequestAnimationFrame#stop
	    */stop:function stop(){if(this._isSetTimeOut){clearTimeout(this._timeOutID);}else{window.cancelAnimationFrame(this._timeOutID);}this.isRunning=false;},/**
	    * Is the browser using setTimeout?
	    * @method Phaser.RequestAnimationFrame#isSetTimeOut
	    * @return {boolean}
	    */isSetTimeOut:function isSetTimeOut(){return this._isSetTimeOut;},/**
	    * Is the browser using requestAnimationFrame?
	    * @method Phaser.RequestAnimationFrame#isRAF
	    * @return {boolean}
	    */isRAF:function isRAF(){return this._isSetTimeOut===false;}};Phaser.RequestAnimationFrame.prototype.constructor=Phaser.RequestAnimationFrame;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A collection of useful mathematical functions.
	*
	* These are normally accessed through `game.math`.
	*
	* @class Phaser.Math
	* @static
	* @see {@link Phaser.Utils}
	* @see {@link Phaser.ArrayUtils}
	*/Phaser.Math={/**
	    * Twice PI.
	    * @property {number} Phaser.Math#PI2
	    * @default ~6.283
	    */PI2:Math.PI*2,/**
	    * Returns a number between the `min` and `max` values.
	    *
	    * @method Phaser.Math#between
	    * @param {number} min - The minimum value. Must be positive, and less than 'max'.
	    * @param {number} max - The maximum value. Must be position, and greater than 'min'.
	    * @return {number} A value between the range min to max.
	    */between:function between(min,max){return Math.floor(Math.random()*(max-min+1)+min);},/**
	    * Two number are fuzzyEqual if their difference is less than epsilon.
	    *
	    * @method Phaser.Math#fuzzyEqual
	    * @param {number} a - The first number to compare.
	    * @param {number} b - The second number to compare.
	    * @param {number} [epsilon=0.0001] - The epsilon (a small value used in the calculation)
	    * @return {boolean} True if |a-b|<epsilon
	    */fuzzyEqual:function fuzzyEqual(a,b,epsilon){if(epsilon===undefined){epsilon=0.0001;}return Math.abs(a-b)<epsilon;},/**
	    * `a` is fuzzyLessThan `b` if it is less than b + epsilon.
	    *
	    * @method Phaser.Math#fuzzyLessThan
	    * @param {number} a - The first number to compare.
	    * @param {number} b - The second number to compare.
	    * @param {number} [epsilon=0.0001] - The epsilon (a small value used in the calculation)
	    * @return {boolean} True if a<b+epsilon
	    */fuzzyLessThan:function fuzzyLessThan(a,b,epsilon){if(epsilon===undefined){epsilon=0.0001;}return a<b+epsilon;},/**
	    * `a` is fuzzyGreaterThan `b` if it is more than b - epsilon.
	    *
	    * @method Phaser.Math#fuzzyGreaterThan
	    * @param {number} a - The first number to compare.
	    * @param {number} b - The second number to compare.
	    * @param {number} [epsilon=0.0001] - The epsilon (a small value used in the calculation)
	    * @return {boolean} True if a>b+epsilon
	    */fuzzyGreaterThan:function fuzzyGreaterThan(a,b,epsilon){if(epsilon===undefined){epsilon=0.0001;}return a>b-epsilon;},/**
	    * Applies a fuzzy ceil to the given value.
	    * 
	    * @method Phaser.Math#fuzzyCeil
	    * @param {number} val - The value to ceil.
	    * @param {number} [epsilon=0.0001] - The epsilon (a small value used in the calculation)
	    * @return {number} ceiling(val-epsilon)
	    */fuzzyCeil:function fuzzyCeil(val,epsilon){if(epsilon===undefined){epsilon=0.0001;}return Math.ceil(val-epsilon);},/**
	    * Applies a fuzzy floor to the given value.
	    * 
	    * @method Phaser.Math#fuzzyFloor
	    * @param {number} val - The value to floor.
	    * @param {number} [epsilon=0.0001] - The epsilon (a small value used in the calculation)
	    * @return {number} floor(val+epsilon)
	    */fuzzyFloor:function fuzzyFloor(val,epsilon){if(epsilon===undefined){epsilon=0.0001;}return Math.floor(val+epsilon);},/**
	    * Averages all values passed to the function and returns the result.
	    *
	    * @method Phaser.Math#average
	    * @params {...number} The numbers to average
	    * @return {number} The average of all given values.
	    */average:function average(){var sum=0;var len=arguments.length;for(var i=0;i<len;i++){sum+=+arguments[i];}return sum/len;},/**
	    * @method Phaser.Math#shear
	    * @param {number} n
	    * @return {number} n mod 1
	    */shear:function shear(n){return n%1;},/**
	    * Snap a value to nearest grid slice, using rounding.
	    *
	    * Example: if you have an interval gap of 5 and a position of 12... you will snap to 10 whereas 14 will snap to 15.
	    *
	    * @method Phaser.Math#snapTo
	    * @param {number} input - The value to snap.
	    * @param {number} gap - The interval gap of the grid.
	    * @param {number} [start=0] - Optional starting offset for gap.
	    * @return {number} The snapped value.
	    */snapTo:function snapTo(input,gap,start){if(start===undefined){start=0;}if(gap===0){return input;}input-=start;input=gap*Math.round(input/gap);return start+input;},/**
	    * Snap a value to nearest grid slice, using floor.
	    *
	    * Example: if you have an interval gap of 5 and a position of 12... you will snap to 10.
	    * As will 14 snap to 10... but 16 will snap to 15.
	    *
	    * @method Phaser.Math#snapToFloor
	    * @param {number} input - The value to snap.
	    * @param {number} gap - The interval gap of the grid.
	    * @param {number} [start=0] - Optional starting offset for gap.
	    * @return {number} The snapped value.
	    */snapToFloor:function snapToFloor(input,gap,start){if(start===undefined){start=0;}if(gap===0){return input;}input-=start;input=gap*Math.floor(input/gap);return start+input;},/**
	    * Snap a value to nearest grid slice, using ceil.
	    *
	    * Example: if you have an interval gap of 5 and a position of 12... you will snap to 15.
	    * As will 14 will snap to 15... but 16 will snap to 20.
	    *
	    * @method Phaser.Math#snapToCeil
	    * @param {number} input - The value to snap.
	    * @param {number} gap - The interval gap of the grid.
	    * @param {number} [start=0] - Optional starting offset for gap.
	    * @return {number} The snapped value.
	    */snapToCeil:function snapToCeil(input,gap,start){if(start===undefined){start=0;}if(gap===0){return input;}input-=start;input=gap*Math.ceil(input/gap);return start+input;},/**
	    * Round to some place comparative to a `base`, default is 10 for decimal place.
	    * The `place` is represented by the power applied to `base` to get that place.
	    *
	    *     e.g. 2000/7 ~= 285.714285714285714285714 ~= (bin)100011101.1011011011011011
	    *
	    *     roundTo(2000/7,3) === 0
	    *     roundTo(2000/7,2) == 300
	    *     roundTo(2000/7,1) == 290
	    *     roundTo(2000/7,0) == 286
	    *     roundTo(2000/7,-1) == 285.7
	    *     roundTo(2000/7,-2) == 285.71
	    *     roundTo(2000/7,-3) == 285.714
	    *     roundTo(2000/7,-4) == 285.7143
	    *     roundTo(2000/7,-5) == 285.71429
	    *
	    *     roundTo(2000/7,3,2)  == 288       -- 100100000
	    *     roundTo(2000/7,2,2)  == 284       -- 100011100
	    *     roundTo(2000/7,1,2)  == 286       -- 100011110
	    *     roundTo(2000/7,0,2)  == 286       -- 100011110
	    *     roundTo(2000/7,-1,2) == 285.5     -- 100011101.1
	    *     roundTo(2000/7,-2,2) == 285.75    -- 100011101.11
	    *     roundTo(2000/7,-3,2) == 285.75    -- 100011101.11
	    *     roundTo(2000/7,-4,2) == 285.6875  -- 100011101.1011
	    *     roundTo(2000/7,-5,2) == 285.71875 -- 100011101.10111
	    *
	    * Note what occurs when we round to the 3rd space (8ths place), 100100000, this is to be assumed
	    * because we are rounding 100011.1011011011011011 which rounds up.
	    *
	    * @method Phaser.Math#roundTo
	    * @param {number} value - The value to round.
	    * @param {number} [place=0] - The place to round to.
	    * @param {number} [base=10] - The base to round in. Default is 10 for decimal.
	    * @return {number} The rounded value.
	    */roundTo:function roundTo(value,place,base){if(place===undefined){place=0;}if(base===undefined){base=10;}var p=Math.pow(base,-place);return Math.round(value*p)/p;},/**
	    * Floors to some place comparative to a `base`, default is 10 for decimal place.
	    * The `place` is represented by the power applied to `base` to get that place.
	    * 
	    * @method Phaser.Math#floorTo
	    * @param {number} value - The value to round.
	    * @param {number} [place=0] - The place to round to.
	    * @param {number} [base=10] - The base to round in. Default is 10 for decimal.
	    * @return {number} The rounded value.
	    */floorTo:function floorTo(value,place,base){if(place===undefined){place=0;}if(base===undefined){base=10;}var p=Math.pow(base,-place);return Math.floor(value*p)/p;},/**
	    * Ceils to some place comparative to a `base`, default is 10 for decimal place.
	    * The `place` is represented by the power applied to `base` to get that place.
	    * 
	    * @method Phaser.Math#ceilTo
	    * @param {number} value - The value to round.
	    * @param {number} [place=0] - The place to round to.
	    * @param {number} [base=10] - The base to round in. Default is 10 for decimal.
	    * @return {number} The rounded value.
	    */ceilTo:function ceilTo(value,place,base){if(place===undefined){place=0;}if(base===undefined){base=10;}var p=Math.pow(base,-place);return Math.ceil(value*p)/p;},/**
	    * Rotates currentAngle towards targetAngle, taking the shortest rotation distance.
	    * The lerp argument is the amount to rotate by in this call.
	    * 
	    * @method Phaser.Math#rotateToAngle
	    * @param {number} currentAngle - The current angle, in radians.
	    * @param {number} targetAngle - The target angle to rotate to, in radians.
	    * @param {number} [lerp=0.05] - The lerp value to add to the current angle.
	    * @return {number} The adjusted angle.
	    */rotateToAngle:function rotateToAngle(currentAngle,targetAngle,lerp){if(lerp===undefined){lerp=0.05;}if(currentAngle===targetAngle){return currentAngle;}if(Math.abs(targetAngle-currentAngle)<=lerp||Math.abs(targetAngle-currentAngle)>=Phaser.Math.PI2-lerp){currentAngle=targetAngle;}else{if(Math.abs(targetAngle-currentAngle)>Math.PI){if(targetAngle<currentAngle){targetAngle+=Phaser.Math.PI2;}else{targetAngle-=Phaser.Math.PI2;}}if(targetAngle>currentAngle){currentAngle+=lerp;}else if(targetAngle<currentAngle){currentAngle-=lerp;}}return currentAngle;},/**
	    * Gets the shortest angle between `angle1` and `angle2`.
	    * Both angles must be in the range -180 to 180, which is the same clamped
	    * range that `sprite.angle` uses, so you can pass in two sprite angles to
	    * this method, and get the shortest angle back between the two of them.
	    *
	    * The angle returned will be in the same range. If the returned angle is
	    * greater than 0 then it's a counter-clockwise rotation, if < 0 then it's
	    * a clockwise rotation.
	    * 
	    * @method Phaser.Math#getShortestAngle
	    * @param {number} angle1 - The first angle. In the range -180 to 180.
	    * @param {number} angle2 - The second angle. In the range -180 to 180.
	    * @return {number} The shortest angle, in degrees. If greater than zero it's a counter-clockwise rotation.
	    */getShortestAngle:function getShortestAngle(angle1,angle2){var difference=angle2-angle1;if(difference===0){return 0;}var times=Math.floor((difference- -180)/360);return difference-times*360;},/**
	    * Find the angle of a segment from (x1, y1) -> (x2, y2).
	    * 
	    * @method Phaser.Math#angleBetween
	    * @param {number} x1 - The x coordinate of the first value.
	    * @param {number} y1 - The y coordinate of the first value.
	    * @param {number} x2 - The x coordinate of the second value.
	    * @param {number} y2 - The y coordinate of the second value.
	    * @return {number} The angle, in radians.
	    */angleBetween:function angleBetween(x1,y1,x2,y2){return Math.atan2(y2-y1,x2-x1);},/**
	    * Find the angle of a segment from (x1, y1) -> (x2, y2).
	    * 
	    * The difference between this method and Math.angleBetween is that this assumes the y coordinate travels
	    * down the screen.
	    *
	    * @method Phaser.Math#angleBetweenY
	    * @param {number} x1 - The x coordinate of the first value.
	    * @param {number} y1 - The y coordinate of the first value.
	    * @param {number} x2 - The x coordinate of the second value.
	    * @param {number} y2 - The y coordinate of the second value.
	    * @return {number} The angle, in radians.
	    */angleBetweenY:function angleBetweenY(x1,y1,x2,y2){return Math.atan2(x2-x1,y2-y1);},/**
	    * Find the angle of a segment from (point1.x, point1.y) -> (point2.x, point2.y).
	    * 
	    * @method Phaser.Math#angleBetweenPoints
	    * @param {Phaser.Point} point1 - The first point.
	    * @param {Phaser.Point} point2 - The second point.
	    * @return {number} The angle between the two points, in radians.
	    */angleBetweenPoints:function angleBetweenPoints(point1,point2){return Math.atan2(point2.y-point1.y,point2.x-point1.x);},/**
	    * Find the angle of a segment from (point1.x, point1.y) -> (point2.x, point2.y).
	    * @method Phaser.Math#angleBetweenPointsY
	    * @param {Phaser.Point} point1
	    * @param {Phaser.Point} point2
	    * @return {number} The angle, in radians.
	    */angleBetweenPointsY:function angleBetweenPointsY(point1,point2){return Math.atan2(point2.x-point1.x,point2.y-point1.y);},/**
	    * Reverses an angle.
	    * @method Phaser.Math#reverseAngle
	    * @param {number} angleRad - The angle to reverse, in radians.
	    * @return {number} The reverse angle, in radians.
	    */reverseAngle:function reverseAngle(angleRad){return this.normalizeAngle(angleRad+Math.PI,true);},/**
	    * Normalizes an angle to the [0,2pi) range.
	    * @method Phaser.Math#normalizeAngle
	    * @param {number} angleRad - The angle to normalize, in radians.
	    * @return {number} The angle, fit within the [0,2pi] range, in radians.
	    */normalizeAngle:function normalizeAngle(angleRad){angleRad=angleRad%(2*Math.PI);return angleRad>=0?angleRad:angleRad+2*Math.PI;},/**
	    * Adds the given amount to the value, but never lets the value go over the specified maximum.
	    *
	    * @method Phaser.Math#maxAdd
	    * @param {number} value - The value to add the amount to.
	    * @param {number} amount - The amount to add to the value.
	    * @param {number} max - The maximum the value is allowed to be.
	    * @return {number} The new value.
	    */maxAdd:function maxAdd(value,amount,max){return Math.min(value+amount,max);},/**
	    * Subtracts the given amount from the value, but never lets the value go below the specified minimum.
	    *
	    * @method Phaser.Math#minSub
	    * @param {number} value - The base value.
	    * @param {number} amount - The amount to subtract from the base value.
	    * @param {number} min - The minimum the value is allowed to be.
	    * @return {number} The new value.
	    */minSub:function minSub(value,amount,min){return Math.max(value-amount,min);},/**
	    * Ensures that the value always stays between min and max, by wrapping the value around.
	    *
	    * If `max` is not larger than `min` the result is 0.
	    *
	    * @method Phaser.Math#wrap
	    * @param {number} value - The value to wrap.
	    * @param {number} min - The minimum the value is allowed to be.
	    * @param {number} max - The maximum the value is allowed to be, should be larger than `min`.
	    * @return {number} The wrapped value.
	    */wrap:function wrap(value,min,max){var range=max-min;if(range<=0){return 0;}var result=(value-min)%range;if(result<0){result+=range;}return result+min;},/**
	    * Adds value to amount and ensures that the result always stays between 0 and max, by wrapping the value around.
	    *
	    * Values _must_ be positive integers, and are passed through Math.abs. See {@link Phaser.Math#wrap} for an alternative.
	    *
	    * @method Phaser.Math#wrapValue
	    * @param {number} value - The value to add the amount to.
	    * @param {number} amount - The amount to add to the value.
	    * @param {number} max - The maximum the value is allowed to be.
	    * @return {number} The wrapped value.
	    */wrapValue:function wrapValue(value,amount,max){var diff;value=Math.abs(value);amount=Math.abs(amount);max=Math.abs(max);diff=(value+amount)%max;return diff;},/**
	    * Returns true if the number given is odd.
	    *
	    * @method Phaser.Math#isOdd
	    * @param {integer} n - The number to check.
	    * @return {boolean} True if the given number is odd. False if the given number is even.
	    */isOdd:function isOdd(n){// Does not work with extremely large values
	return!!(n&1);},/**
	    * Returns true if the number given is even.
	    *
	    * @method Phaser.Math#isEven
	    * @param {integer} n - The number to check.
	    * @return {boolean} True if the given number is even. False if the given number is odd.
	    */isEven:function isEven(n){// Does not work with extremely large values
	return!(n&1);},/**
	    * Variation of Math.min that can be passed either an array of numbers or the numbers as parameters.
	    *
	    * Prefer the standard `Math.min` function when appropriate.
	    *
	    * @method Phaser.Math#min
	    * @return {number} The lowest value from those given.
	    * @see {@link http://jsperf.com/math-s-min-max-vs-homemade}
	    */min:function min(){if(arguments.length===1&&_typeof(arguments[0])==='object'){var data=arguments[0];}else{var data=arguments;}for(var i=1,min=0,len=data.length;i<len;i++){if(data[i]<data[min]){min=i;}}return data[min];},/**
	    * Variation of Math.max that can be passed either an array of numbers or the numbers as parameters.
	    *
	    * Prefer the standard `Math.max` function when appropriate.
	    *
	    * @method Phaser.Math#max
	    * @return {number} The largest value from those given.
	    * @see {@link http://jsperf.com/math-s-min-max-vs-homemade}
	    */max:function max(){if(arguments.length===1&&_typeof(arguments[0])==='object'){var data=arguments[0];}else{var data=arguments;}for(var i=1,max=0,len=data.length;i<len;i++){if(data[i]>data[max]){max=i;}}return data[max];},/**
	    * Variation of Math.min that can be passed a property and either an array of objects or the objects as parameters.
	    * It will find the lowest matching property value from the given objects.
	    *
	    * @method Phaser.Math#minProperty
	    * @return {number} The lowest value from those given.
	    */minProperty:function minProperty(property){if(arguments.length===2&&_typeof(arguments[1])==='object'){var data=arguments[1];}else{var data=arguments.slice(1);}for(var i=1,min=0,len=data.length;i<len;i++){if(data[i][property]<data[min][property]){min=i;}}return data[min][property];},/**
	    * Variation of Math.max that can be passed a property and either an array of objects or the objects as parameters.
	    * It will find the largest matching property value from the given objects.
	    *
	    * @method Phaser.Math#maxProperty
	    * @return {number} The largest value from those given.
	    */maxProperty:function maxProperty(property){if(arguments.length===2&&_typeof(arguments[1])==='object'){var data=arguments[1];}else{var data=arguments.slice(1);}for(var i=1,max=0,len=data.length;i<len;i++){if(data[i][property]>data[max][property]){max=i;}}return data[max][property];},/**
	    * Keeps an angle value between -180 and +180; or -PI and PI if radians.
	    *
	    * @method Phaser.Math#wrapAngle
	    * @param {number} angle - The angle value to wrap
	    * @param {boolean} [radians=false] - Set to `true` if the angle is given in radians, otherwise degrees is expected.
	    * @return {number} The new angle value; will be the same as the input angle if it was within bounds.
	    */wrapAngle:function wrapAngle(angle,radians){return radians?this.wrap(angle,-Math.PI,Math.PI):this.wrap(angle,-180,180);},/**
	    * A Linear Interpolation Method, mostly used by Phaser.Tween.
	    *
	    * @method Phaser.Math#linearInterpolation
	    * @param {Array} v - The input array of values to interpolate between.
	    * @param {number} k - The percentage of interpolation, between 0 and 1.
	    * @return {number} The interpolated value
	    */linearInterpolation:function linearInterpolation(v,k){var m=v.length-1;var f=m*k;var i=Math.floor(f);if(k<0){return this.linear(v[0],v[1],f);}if(k>1){return this.linear(v[m],v[m-1],m-f);}return this.linear(v[i],v[i+1>m?m:i+1],f-i);},/**
	    * A Bezier Interpolation Method, mostly used by Phaser.Tween.
	    *
	    * @method Phaser.Math#bezierInterpolation
	    * @param {Array} v - The input array of values to interpolate between.
	    * @param {number} k - The percentage of interpolation, between 0 and 1.
	    * @return {number} The interpolated value
	    */bezierInterpolation:function bezierInterpolation(v,k){var b=0;var n=v.length-1;for(var i=0;i<=n;i++){b+=Math.pow(1-k,n-i)*Math.pow(k,i)*v[i]*this.bernstein(n,i);}return b;},/**
	    * A Catmull Rom Interpolation Method, mostly used by Phaser.Tween.
	    *
	    * @method Phaser.Math#catmullRomInterpolation
	    * @param {Array} v - The input array of values to interpolate between.
	    * @param {number} k - The percentage of interpolation, between 0 and 1.
	    * @return {number} The interpolated value
	    */catmullRomInterpolation:function catmullRomInterpolation(v,k){var m=v.length-1;var f=m*k;var i=Math.floor(f);if(v[0]===v[m]){if(k<0){i=Math.floor(f=m*(1+k));}return this.catmullRom(v[(i-1+m)%m],v[i],v[(i+1)%m],v[(i+2)%m],f-i);}else{if(k<0){return v[0]-(this.catmullRom(v[0],v[0],v[1],v[1],-f)-v[0]);}if(k>1){return v[m]-(this.catmullRom(v[m],v[m],v[m-1],v[m-1],f-m)-v[m]);}return this.catmullRom(v[i?i-1:0],v[i],v[m<i+1?m:i+1],v[m<i+2?m:i+2],f-i);}},/**
	    * Calculates a linear (interpolation) value over t.
	    *
	    * @method Phaser.Math#linear
	    * @param {number} p0
	    * @param {number} p1
	    * @param {number} t - A value between 0 and 1.
	    * @return {number}
	    */linear:function linear(p0,p1,t){return(p1-p0)*t+p0;},/**
	    * @method Phaser.Math#bernstein
	    * @protected
	    * @param {number} n
	    * @param {number} i
	    * @return {number}
	    */bernstein:function bernstein(n,i){return this.factorial(n)/this.factorial(i)/this.factorial(n-i);},/**
	    * @method Phaser.Math#factorial
	    * @param {number} value - the number you want to evaluate
	    * @return {number}
	    */factorial:function factorial(value){if(value===0){return 1;}var res=value;while(--value){res*=value;}return res;},/**
	    * Calculates a catmum rom value.
	    *
	    * @method Phaser.Math#catmullRom
	    * @protected
	    * @param {number} p0
	    * @param {number} p1
	    * @param {number} p2
	    * @param {number} p3
	    * @param {number} t
	    * @return {number}
	    */catmullRom:function catmullRom(p0,p1,p2,p3,t){var v0=(p2-p0)*0.5,v1=(p3-p1)*0.5,t2=t*t,t3=t*t2;return(2*p1-2*p2+v0+v1)*t3+(-3*p1+3*p2-2*v0-v1)*t2+v0*t+p1;},/**
	    * The absolute difference between two values.
	    *
	    * @method Phaser.Math#difference
	    * @param {number} a - The first value to check.
	    * @param {number} b - The second value to check.
	    * @return {number} The absolute difference between the two values.
	    */difference:function difference(a,b){return Math.abs(a-b);},/**
	    * Round to the next whole number _away_ from zero.
	    *
	    * @method Phaser.Math#roundAwayFromZero
	    * @param {number} value - Any number.
	    * @return {integer} The rounded value of that number.
	    */roundAwayFromZero:function roundAwayFromZero(value){// "Opposite" of truncate.
	return value>0?Math.ceil(value):Math.floor(value);},/**
	    * Generate a sine and cosine table simultaneously and extremely quickly.
	    * The parameters allow you to specify the length, amplitude and frequency of the wave.
	    * This generator is fast enough to be used in real-time.
	    * Code based on research by Franky of scene.at
	    *
	    * @method Phaser.Math#sinCosGenerator
	    * @param {number} length - The length of the wave
	    * @param {number} sinAmplitude - The amplitude to apply to the sine table (default 1.0) if you need values between say -+ 125 then give 125 as the value
	    * @param {number} cosAmplitude - The amplitude to apply to the cosine table (default 1.0) if you need values between say -+ 125 then give 125 as the value
	    * @param {number} frequency  - The frequency of the sine and cosine table data
	    * @return {{sin:number[], cos:number[]}} Returns the table data.
	    */sinCosGenerator:function sinCosGenerator(length,sinAmplitude,cosAmplitude,frequency){if(sinAmplitude===undefined){sinAmplitude=1.0;}if(cosAmplitude===undefined){cosAmplitude=1.0;}if(frequency===undefined){frequency=1.0;}var sin=sinAmplitude;var cos=cosAmplitude;var frq=frequency*Math.PI/length;var cosTable=[];var sinTable=[];for(var c=0;c<length;c++){cos-=sin*frq;sin+=cos*frq;cosTable[c]=cos;sinTable[c]=sin;}return{sin:sinTable,cos:cosTable,length:length};},/**
	    * Returns the euclidian distance between the two given set of coordinates.
	    *
	    * @method Phaser.Math#distance
	    * @param {number} x1
	    * @param {number} y1
	    * @param {number} x2
	    * @param {number} y2
	    * @return {number} The distance between the two sets of coordinates.
	    */distance:function distance(x1,y1,x2,y2){var dx=x1-x2;var dy=y1-y2;return Math.sqrt(dx*dx+dy*dy);},/**
	    * Returns the euclidean distance squared between the two given set of
	    * coordinates (cuts out a square root operation before returning).
	    *
	    * @method Phaser.Math#distanceSq
	    * @param {number} x1
	    * @param {number} y1
	    * @param {number} x2
	    * @param {number} y2
	    * @return {number} The distance squared between the two sets of coordinates.
	    */distanceSq:function distanceSq(x1,y1,x2,y2){var dx=x1-x2;var dy=y1-y2;return dx*dx+dy*dy;},/**
	    * Returns the distance between the two given set of coordinates at the power given.
	    *
	    * @method Phaser.Math#distancePow
	    * @param {number} x1
	    * @param {number} y1
	    * @param {number} x2
	    * @param {number} y2
	    * @param {number} [pow=2]
	    * @return {number} The distance between the two sets of coordinates.
	    */distancePow:function distancePow(x1,y1,x2,y2,pow){if(pow===undefined){pow=2;}return Math.sqrt(Math.pow(x2-x1,pow)+Math.pow(y2-y1,pow));},/**
	    * Force a value within the boundaries by clamping it to the range `min`, `max`.
	    *
	    * @method Phaser.Math#clamp
	    * @param {float} v - The value to be clamped.
	    * @param {float} min - The minimum bounds.
	    * @param {float} max - The maximum bounds.
	    * @return {number} The clamped value.
	    */clamp:function clamp(v,min,max){if(v<min){return min;}else if(max<v){return max;}else{return v;}},/**
	    * Clamp `x` to the range `[a, Infinity)`.
	    * Roughly the same as `Math.max(x, a)`, except for NaN handling.
	    *
	    * @method Phaser.Math#clampBottom
	    * @param {number} x
	    * @param {number} a
	    * @return {number}
	    */clampBottom:function clampBottom(x,a){return x<a?a:x;},/**
	    * Checks if two values are within the given tolerance of each other.
	    *
	    * @method Phaser.Math#within
	    * @param {number} a - The first number to check
	    * @param {number} b - The second number to check
	    * @param {number} tolerance - The tolerance. Anything equal to or less than this is considered within the range.
	    * @return {boolean} True if a is <= tolerance of b.
	    * @see {@link Phaser.Math.fuzzyEqual}
	    */within:function within(a,b,tolerance){return Math.abs(a-b)<=tolerance;},/**
	    * Linear mapping from range <a1, a2> to range <b1, b2>
	    *
	    * @method Phaser.Math#mapLinear
	    * @param {number} x - The value to map
	    * @param {number} a1 - First endpoint of the range <a1, a2>
	    * @param {number} a2 - Final endpoint of the range <a1, a2>
	    * @param {number} b1 - First endpoint of the range <b1, b2>
	    * @param {number} b2 - Final endpoint of the range  <b1, b2>
	    * @return {number}
	    */mapLinear:function mapLinear(x,a1,a2,b1,b2){return b1+(x-a1)*(b2-b1)/(a2-a1);},/**
	    * Smoothstep function as detailed at http://en.wikipedia.org/wiki/Smoothstep
	    *
	    * @method Phaser.Math#smoothstep
	    * @param {float} x - The input value.
	    * @param {float} min - The left edge. Should be smaller than the right edge.
	    * @param {float} max - The right edge.
	    * @return {float} A value between 0 and 1.
	    */smoothstep:function smoothstep(x,min,max){// Scale, bias and saturate x to 0..1 range
	x=Math.max(0,Math.min(1,(x-min)/(max-min)));// Evaluate polynomial
	return x*x*(3-2*x);},/**
	    * Smootherstep function as detailed at http://en.wikipedia.org/wiki/Smoothstep
	    *
	    * @method Phaser.Math#smootherstep
	    * @param {float} x - The input value.
	    * @param {float} min - The left edge. Should be smaller than the right edge.
	    * @param {float} max - The right edge.
	    * @return {float} A value between 0 and 1.
	    */smootherstep:function smootherstep(x,min,max){x=Math.max(0,Math.min(1,(x-min)/(max-min)));return x*x*x*(x*(x*6-15)+10);},/**
	    * A value representing the sign of the value: -1 for negative, +1 for positive, 0 if value is 0.
	    *
	    * This works differently from `Math.sign` for values of NaN and -0, etc.
	    *
	    * @method Phaser.Math#sign
	    * @param {number} x
	    * @return {integer} An integer in {-1, 0, 1}
	    */sign:function sign(x){return x<0?-1:x>0?1:0;},/**
	    * Work out what percentage value `a` is of value `b` using the given base.
	    *
	    * @method Phaser.Math#percent
	    * @param {number} a - The value to work out the percentage for.
	    * @param {number} b - The value you wish to get the percentage of.
	    * @param {number} [base=0] - The base value.
	    * @return {number} The percentage a is of b, between 0 and 1.
	    */percent:function percent(a,b,base){if(base===undefined){base=0;}if(a>b||base>b){return 1;}else if(a<base||base>a){return 0;}else{return(a-base)/b;}}};var degreeToRadiansFactor=Math.PI/180;var radianToDegreesFactor=180/Math.PI;/**
	* Convert degrees to radians.
	*
	* @method Phaser.Math#degToRad
	* @param {number} degrees - Angle in degrees.
	* @return {number} Angle in radians.
	*/Phaser.Math.degToRad=function degToRad(degrees){return degrees*degreeToRadiansFactor;};/**
	* Convert radians to degrees.
	*
	* @method Phaser.Math#radToDeg
	* @param {number} radians - Angle in radians.
	* @return {number} Angle in degrees
	*/Phaser.Math.radToDeg=function radToDeg(radians){return radians*radianToDegreesFactor;};/* jshint noempty: false *//**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* An extremely useful repeatable random data generator.
	*
	* Based on Nonsense by Josh Faul https://github.com/jocafa/Nonsense.
	*
	* The random number genererator is based on the Alea PRNG, but is modified.
	*  - https://github.com/coverslide/node-alea
	*  - https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
	*  - http://baagoe.org/en/wiki/Better_random_numbers_for_javascript (original, perm. 404)
	*
	* @class Phaser.RandomDataGenerator
	* @constructor
	* @param {any[]|string} [seeds] - An array of values to use as the seed, or a generator state (from {#state}).
	*/Phaser.RandomDataGenerator=function(seeds){if(seeds===undefined){seeds=[];}/**
	    * @property {number} c - Internal var.
	    * @private
	    */this.c=1;/**
	    * @property {number} s0 - Internal var.
	    * @private
	    */this.s0=0;/**
	    * @property {number} s1 - Internal var.
	    * @private
	    */this.s1=0;/**
	    * @property {number} s2 - Internal var.
	    * @private
	    */this.s2=0;if(typeof seeds==='string'){this.state(seeds);}else{this.sow(seeds);}};Phaser.RandomDataGenerator.prototype={/**
	    * Private random helper.
	    *
	    * @method Phaser.RandomDataGenerator#rnd
	    * @private
	    * @return {number}
	    */rnd:function rnd(){var t=2091639*this.s0+this.c*2.3283064365386963e-10;// 2^-32
	this.c=t|0;this.s0=this.s1;this.s1=this.s2;this.s2=t-this.c;return this.s2;},/**
	    * Reset the seed of the random data generator.
	    *
	    * _Note_: the seed array is only processed up to the first `undefined` (or `null`) value, should such be present.
	    *
	    * @method Phaser.RandomDataGenerator#sow
	    * @param {any[]} seeds - The array of seeds: the `toString()` of each value is used.
	    */sow:function sow(seeds){// Always reset to default seed
	this.s0=this.hash(' ');this.s1=this.hash(this.s0);this.s2=this.hash(this.s1);this.c=1;if(!seeds){return;}// Apply any seeds
	for(var i=0;i<seeds.length&&seeds[i]!=null;i++){var seed=seeds[i];this.s0-=this.hash(seed);this.s0+=~~(this.s0<0);this.s1-=this.hash(seed);this.s1+=~~(this.s1<0);this.s2-=this.hash(seed);this.s2+=~~(this.s2<0);}},/**
	    * Internal method that creates a seed hash.
	    *
	    * @method Phaser.RandomDataGenerator#hash
	    * @private
	    * @param {any} data
	    * @return {number} hashed value.
	    */hash:function hash(data){var h,i,n;n=0xefc8249d;data=data.toString();for(i=0;i<data.length;i++){n+=data.charCodeAt(i);h=0.02519603282416938*n;n=h>>>0;h-=n;h*=n;n=h>>>0;h-=n;n+=h*0x100000000;// 2^32
	}return(n>>>0)*2.3283064365386963e-10;// 2^-32
	},/**
	    * Returns a random integer between 0 and 2^32.
	    *
	    * @method Phaser.RandomDataGenerator#integer
	    * @return {number} A random integer between 0 and 2^32.
	    */integer:function integer(){return this.rnd.apply(this)*0x100000000;// 2^32
	},/**
	    * Returns a random real number between 0 and 1.
	    *
	    * @method Phaser.RandomDataGenerator#frac
	    * @return {number} A random real number between 0 and 1.
	    */frac:function frac(){return this.rnd.apply(this)+(this.rnd.apply(this)*0x200000|0)*1.1102230246251565e-16;// 2^-53
	},/**
	    * Returns a random real number between 0 and 2^32.
	    *
	    * @method Phaser.RandomDataGenerator#real
	    * @return {number} A random real number between 0 and 2^32.
	    */real:function real(){return this.integer()+this.frac();},/**
	    * Returns a random integer between and including min and max.
	    *
	    * @method Phaser.RandomDataGenerator#integerInRange
	    * @param {number} min - The minimum value in the range.
	    * @param {number} max - The maximum value in the range.
	    * @return {number} A random number between min and max.
	    */integerInRange:function integerInRange(min,max){return Math.floor(this.realInRange(0,max-min+1)+min);},/**
	    * Returns a random integer between and including min and max.
	    * This method is an alias for RandomDataGenerator.integerInRange.
	    *
	    * @method Phaser.RandomDataGenerator#between
	    * @param {number} min - The minimum value in the range.
	    * @param {number} max - The maximum value in the range.
	    * @return {number} A random number between min and max.
	    */between:function between(min,max){return this.integerInRange(min,max);},/**
	    * Returns a random real number between min and max.
	    *
	    * @method Phaser.RandomDataGenerator#realInRange
	    * @param {number} min - The minimum value in the range.
	    * @param {number} max - The maximum value in the range.
	    * @return {number} A random number between min and max.
	    */realInRange:function realInRange(min,max){return this.frac()*(max-min)+min;},/**
	    * Returns a random real number between -1 and 1.
	    *
	    * @method Phaser.RandomDataGenerator#normal
	    * @return {number} A random real number between -1 and 1.
	    */normal:function normal(){return 1-2*this.frac();},/**
	    * Returns a valid RFC4122 version4 ID hex string from https://gist.github.com/1308368
	    *
	    * @method Phaser.RandomDataGenerator#uuid
	    * @return {string} A valid RFC4122 version4 ID hex string
	    */uuid:function uuid(){var a='';var b='';for(b=a='';a++<36;b+=~a%5|a*3&4?(a^15?8^this.frac()*(a^20?16:4):4).toString(16):'-'){}return b;},/**
	    * Returns a random member of `array`.
	    *
	    * @method Phaser.RandomDataGenerator#pick
	    * @param {Array} ary - An Array to pick a random member of.
	    * @return {any} A random member of the array.
	    */pick:function pick(ary){return ary[this.integerInRange(0,ary.length-1)];},/**
	    * Returns a sign to be used with multiplication operator.
	    *
	    * @method Phaser.RandomDataGenerator#sign
	    * @return {number} -1 or +1.
	    */sign:function sign(){return this.pick([-1,1]);},/**
	    * Returns a random member of `array`, favoring the earlier entries.
	    *
	    * @method Phaser.RandomDataGenerator#weightedPick
	    * @param {Array} ary - An Array to pick a random member of.
	    * @return {any} A random member of the array.
	    */weightedPick:function weightedPick(ary){return ary[~~(Math.pow(this.frac(),2)*(ary.length-1)+0.5)];},/**
	    * Returns a random timestamp between min and max, or between the beginning of 2000 and the end of 2020 if min and max aren't specified.
	    *
	    * @method Phaser.RandomDataGenerator#timestamp
	    * @param {number} min - The minimum value in the range.
	    * @param {number} max - The maximum value in the range.
	    * @return {number} A random timestamp between min and max.
	    */timestamp:function timestamp(min,max){return this.realInRange(min||946684800000,max||1577862000000);},/**
	    * Returns a random angle between -180 and 180.
	    *
	    * @method Phaser.RandomDataGenerator#angle
	    * @return {number} A random number between -180 and 180.
	    */angle:function angle(){return this.integerInRange(-180,180);},/**
	    * Gets or Sets the state of the generator. This allows you to retain the values
	    * that the generator is using between games, i.e. in a game save file.
	    * 
	    * To seed this generator with a previously saved state you can pass it as the 
	    * `seed` value in your game config, or call this method directly after Phaser has booted.
	    *
	    * Call this method with no parameters to return the current state.
	    * 
	    * If providing a state it should match the same format that this method
	    * returns, which is a string with a header `!rnd` followed by the `c`,
	    * `s0`, `s1` and `s2` values respectively, each comma-delimited. 
	    *
	    * @method Phaser.RandomDataGenerator#state
	    * @param {string} [state] - Generator state to be set.
	    * @return {string} The current state of the generator.
	    */state:function state(_state){if(typeof _state==='string'&&_state.match(/^!rnd/)){_state=_state.split(',');this.c=parseFloat(_state[1]);this.s0=parseFloat(_state[2]);this.s1=parseFloat(_state[3]);this.s2=parseFloat(_state[4]);}return['!rnd',this.c,this.s0,this.s1,this.s2].join(',');}};Phaser.RandomDataGenerator.prototype.constructor=Phaser.RandomDataGenerator;/**
	 * @author       Timo Hausmann
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2016 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 *//**
	* A QuadTree implementation. The original code was a conversion of the Java code posted to GameDevTuts.
	* However I've tweaked it massively to add node indexing, removed lots of temp. var creation and significantly increased performance as a result.
	* Original version at https://github.com/timohausmann/quadtree-js/
	*
	* @class Phaser.QuadTree
	* @constructor
	* @param {number} x - The top left coordinate of the quadtree.
	* @param {number} y - The top left coordinate of the quadtree.
	* @param {number} width - The width of the quadtree in pixels.
	* @param {number} height - The height of the quadtree in pixels.
	* @param {number} [maxObjects=10] - The maximum number of objects per node.
	* @param {number} [maxLevels=4] - The maximum number of levels to iterate to.
	* @param {number} [level=0] - Which level is this?
	*/Phaser.QuadTree=function(x,y,width,height,maxObjects,maxLevels,level){/**
	    * @property {number} maxObjects - The maximum number of objects per node.
	    * @default
	    */this.maxObjects=10;/**
	    * @property {number} maxLevels - The maximum number of levels to break down to.
	    * @default
	    */this.maxLevels=4;/**
	    * @property {number} level - The current level.
	    */this.level=0;/**
	    * @property {object} bounds - Object that contains the quadtree bounds.
	    */this.bounds={};/**
	    * @property {array} objects - Array of quadtree children.
	    */this.objects=[];/**
	    * @property {array} nodes - Array of associated child nodes.
	    */this.nodes=[];/**
	    * @property {array} _empty - Internal empty array.
	    * @private
	    */this._empty=[];this.reset(x,y,width,height,maxObjects,maxLevels,level);};Phaser.QuadTree.prototype={/**
	    * Resets the QuadTree.
	    *
	    * @method Phaser.QuadTree#reset
	    * @param {number} x - The top left coordinate of the quadtree.
	    * @param {number} y - The top left coordinate of the quadtree.
	    * @param {number} width - The width of the quadtree in pixels.
	    * @param {number} height - The height of the quadtree in pixels.
	    * @param {number} [maxObjects=10] - The maximum number of objects per node.
	    * @param {number} [maxLevels=4] - The maximum number of levels to iterate to.
	    * @param {number} [level=0] - Which level is this?
	    */reset:function reset(x,y,width,height,maxObjects,maxLevels,level){this.maxObjects=maxObjects||10;this.maxLevels=maxLevels||4;this.level=level||0;this.bounds={x:Math.round(x),y:Math.round(y),width:width,height:height,subWidth:Math.floor(width/2),subHeight:Math.floor(height/2),right:Math.round(x)+Math.floor(width/2),bottom:Math.round(y)+Math.floor(height/2)};this.objects.length=0;this.nodes.length=0;},/**
	    * Populates this quadtree with the children of the given Group. In order to be added the child must exist and have a body property.
	    *
	    * @method Phaser.QuadTree#populate
	    * @param {Phaser.Group} group - The Group to add to the quadtree.
	    */populate:function populate(group){group.forEach(this.populateHandler,this,true);},/**
	    * Handler for the populate method.
	    *
	    * @method Phaser.QuadTree#populateHandler
	    * @param {Phaser.Sprite|object} sprite - The Sprite to check.
	    */populateHandler:function populateHandler(sprite){if(sprite.body&&sprite.exists){this.insert(sprite.body);}},/**
	    * Split the node into 4 subnodes
	    *
	    * @method Phaser.QuadTree#split
	    */split:function split(){//  top right node
	this.nodes[0]=new Phaser.QuadTree(this.bounds.right,this.bounds.y,this.bounds.subWidth,this.bounds.subHeight,this.maxObjects,this.maxLevels,this.level+1);//  top left node
	this.nodes[1]=new Phaser.QuadTree(this.bounds.x,this.bounds.y,this.bounds.subWidth,this.bounds.subHeight,this.maxObjects,this.maxLevels,this.level+1);//  bottom left node
	this.nodes[2]=new Phaser.QuadTree(this.bounds.x,this.bounds.bottom,this.bounds.subWidth,this.bounds.subHeight,this.maxObjects,this.maxLevels,this.level+1);//  bottom right node
	this.nodes[3]=new Phaser.QuadTree(this.bounds.right,this.bounds.bottom,this.bounds.subWidth,this.bounds.subHeight,this.maxObjects,this.maxLevels,this.level+1);},/**
	    * Insert the object into the node. If the node exceeds the capacity, it will split and add all objects to their corresponding subnodes.
	    *
	    * @method Phaser.QuadTree#insert
	    * @param {Phaser.Physics.Arcade.Body|object} body - The Body object to insert into the quadtree. Can be any object so long as it exposes x, y, right and bottom properties.
	    */insert:function insert(body){var i=0;var index;//  if we have subnodes ...
	if(this.nodes[0]!=null){index=this.getIndex(body);if(index!==-1){this.nodes[index].insert(body);return;}}this.objects.push(body);if(this.objects.length>this.maxObjects&&this.level<this.maxLevels){//  Split if we don't already have subnodes
	if(this.nodes[0]==null){this.split();}//  Add objects to subnodes
	while(i<this.objects.length){index=this.getIndex(this.objects[i]);if(index!==-1){//  this is expensive - see what we can do about it
	this.nodes[index].insert(this.objects.splice(i,1)[0]);}else{i++;}}}},/**
	    * Determine which node the object belongs to.
	    *
	    * @method Phaser.QuadTree#getIndex
	    * @param {Phaser.Rectangle|object} rect - The bounds in which to check.
	    * @return {number} index - Index of the subnode (0-3), or -1 if rect cannot completely fit within a subnode and is part of the parent node.
	    */getIndex:function getIndex(rect){//  default is that rect doesn't fit, i.e. it straddles the internal quadrants
	var index=-1;if(rect.x<this.bounds.right&&rect.right<this.bounds.right){if(rect.y<this.bounds.bottom&&rect.bottom<this.bounds.bottom){//  rect fits within the top-left quadrant of this quadtree
	index=1;}else if(rect.y>this.bounds.bottom){//  rect fits within the bottom-left quadrant of this quadtree
	index=2;}}else if(rect.x>this.bounds.right){//  rect can completely fit within the right quadrants
	if(rect.y<this.bounds.bottom&&rect.bottom<this.bounds.bottom){//  rect fits within the top-right quadrant of this quadtree
	index=0;}else if(rect.y>this.bounds.bottom){//  rect fits within the bottom-right quadrant of this quadtree
	index=3;}}return index;},/**
	    * Return all objects that could collide with the given Sprite or Rectangle.
	    *
	    * @method Phaser.QuadTree#retrieve
	    * @param {Phaser.Sprite|Phaser.Rectangle} source - The source object to check the QuadTree against. Either a Sprite or Rectangle.
	    * @return {array} - Array with all detected objects.
	    */retrieve:function retrieve(source){if(source instanceof Phaser.Rectangle){var returnObjects=this.objects;var index=this.getIndex(source);}else{if(!source.body){return this._empty;}var returnObjects=this.objects;var index=this.getIndex(source.body);}if(this.nodes[0]){//  If rect fits into a subnode ..
	if(index!==-1){returnObjects=returnObjects.concat(this.nodes[index].retrieve(source));}else{//  If rect does not fit into a subnode, check it against all subnodes (unrolled for speed)
	returnObjects=returnObjects.concat(this.nodes[0].retrieve(source));returnObjects=returnObjects.concat(this.nodes[1].retrieve(source));returnObjects=returnObjects.concat(this.nodes[2].retrieve(source));returnObjects=returnObjects.concat(this.nodes[3].retrieve(source));}}return returnObjects;},/**
	    * Clear the quadtree.
	    * @method Phaser.QuadTree#clear
	    */clear:function clear(){this.objects.length=0;var i=this.nodes.length;while(i--){this.nodes[i].clear();this.nodes.splice(i,1);}this.nodes.length=0;}};Phaser.QuadTree.prototype.constructor=Phaser.QuadTree;/**
	* Javascript QuadTree
	* @version 1.0
	*
	* @version 1.3, March 11th 2014
	* @author Richard Davey
	* The original code was a conversion of the Java code posted to GameDevTuts. However I've tweaked
	* it massively to add node indexing, removed lots of temp. var creation and significantly
	* increased performance as a result.
	*
	* Original version at https://github.com/timohausmann/quadtree-js/
	*//**
	* @copyright © 2012 Timo Hausmann
	*
	* Permission is hereby granted, free of charge, to any person obtaining
	* a copy of this software and associated documentation files (the
	* "Software"), to deal in the Software without restriction, including
	* without limitation the rights to use, copy, modify, merge, publish,
	* distribute, sublicense, and/or sell copies of the Software, and to
	* permit persons to whom the Software is furnished to do so, subject to
	* the following conditions:
	*
	* The above copyright notice and this permission notice shall be
	* included in all copies or substantial portions of the Software.
	*
	* THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	* EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	* MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	* NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	* LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	* OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	* WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	*//**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Phaser.Net handles browser URL related tasks such as checking host names, domain names and query string manipulation.
	*
	* @class Phaser.Net
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	*/Phaser.Net=function(game){this.game=game;};Phaser.Net.prototype={/**
	    * Returns the hostname given by the browser.
	    *
	    * @method Phaser.Net#getHostName
	    * @return {string}
	    */getHostName:function getHostName(){if(window.location&&window.location.hostname){return window.location.hostname;}return null;},/**
	    * Compares the given domain name against the hostname of the browser containing the game.
	    * If the domain name is found it returns true.
	    * You can specify a part of a domain, for example 'google' would match 'google.com', 'google.co.uk', etc.
	    * Do not include 'http://' at the start.
	    *
	    * @method Phaser.Net#checkDomainName
	    * @param {string} domain
	    * @return {boolean} true if the given domain fragment can be found in the window.location.hostname
	    */checkDomainName:function checkDomainName(domain){return window.location.hostname.indexOf(domain)!==-1;},/**
	    * Updates a value on the Query String and returns it in full.
	    * If the value doesn't already exist it is set.
	    * If the value exists it is replaced with the new value given. If you don't provide a new value it is removed from the query string.
	    * Optionally you can redirect to the new url, or just return it as a string.
	    *
	    * @method Phaser.Net#updateQueryString
	    * @param {string} key - The querystring key to update.
	    * @param {string} value - The new value to be set. If it already exists it will be replaced.
	    * @param {boolean} redirect - If true the browser will issue a redirect to the url with the new querystring.
	    * @param {string} url - The URL to modify. If none is given it uses window.location.href.
	    * @return {string} If redirect is false then the modified url and query string is returned.
	    */updateQueryString:function updateQueryString(key,value,redirect,url){if(redirect===undefined){redirect=false;}if(url===undefined||url===''){url=window.location.href;}var output='';var re=new RegExp("([?|&])"+key+"=.*?(&|#|$)(.*)","gi");if(re.test(url)){if(typeof value!=='undefined'&&value!==null){output=url.replace(re,'$1'+key+"="+value+'$2$3');}else{output=url.replace(re,'$1$3').replace(/(&|\?)$/,'');}}else{if(typeof value!=='undefined'&&value!==null){var separator=url.indexOf('?')!==-1?'&':'?';var hash=url.split('#');url=hash[0]+separator+key+'='+value;if(hash[1]){url+='#'+hash[1];}output=url;}else{output=url;}}if(redirect){window.location.href=output;}else{return output;}},/**
	    * Returns the Query String as an object.
	    * If you specify a parameter it will return just the value of that parameter, should it exist.
	    *
	    * @method Phaser.Net#getQueryString
	    * @param {string} [parameter=''] - If specified this will return just the value for that key.
	    * @return {string|object} An object containing the key value pairs found in the query string or just the value if a parameter was given.
	    */getQueryString:function getQueryString(parameter){if(parameter===undefined){parameter='';}var output={};var keyValues=location.search.substring(1).split('&');for(var i in keyValues){var key=keyValues[i].split('=');if(key.length>1){if(parameter&&parameter===this.decodeURI(key[0])){return this.decodeURI(key[1]);}else{output[this.decodeURI(key[0])]=this.decodeURI(key[1]);}}}return output;},/**
	    * Takes a Uniform Resource Identifier (URI) component (previously created by encodeURIComponent or by a similar routine) and
	    * decodes it, replacing \ with spaces in the return. Used internally by the Net classes.
	    *
	    * @method Phaser.Net#decodeURI
	    * @param {string} value - The URI component to be decoded.
	    * @return {string} The decoded value.
	    */decodeURI:function decodeURI(value){return decodeURIComponent(value.replace(/\+/g," "));}};Phaser.Net.prototype.constructor=Phaser.Net;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Phaser.Game has a single instance of the TweenManager through which all Tween objects are created and updated.
	* Tweens are hooked into the game clock and pause system, adjusting based on the game state.
	*
	* TweenManager is based heavily on tween.js by http://soledadpenades.com.
	* The difference being that tweens belong to a games instance of TweenManager, rather than to a global TWEEN object.
	* It also has callbacks swapped for Signals and a few issues patched with regard to properties and completion errors.
	* Please see https://github.com/sole/tween.js for a full list of contributors.
	* 
	* @class Phaser.TweenManager
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	*/Phaser.TweenManager=function(game){/**
	    * @property {Phaser.Game} game - Local reference to game.
	    */this.game=game;/**
	    * Are all newly created Tweens frame or time based? A frame based tween will use the physics elapsed timer when updating. This means
	    * it will retain the same consistent frame rate, regardless of the speed of the device. The duration value given should
	    * be given in frames.
	    * 
	    * If the Tween uses a time based update (which is the default) then the duration is given in milliseconds.
	    * In this situation a 2000ms tween will last exactly 2 seconds, regardless of the device and how many visual updates the tween
	    * has actually been through. For very short tweens you may wish to experiment with a frame based update instead.
	    * @property {boolean} frameBased
	    * @default
	    */this.frameBased=false;/**
	    * @property {array<Phaser.Tween>} _tweens - All of the currently running tweens.
	    * @private
	    */this._tweens=[];/**
	    * @property {array<Phaser.Tween>} _add - All of the tweens queued to be added in the next update.
	    * @private
	    */this._add=[];this.easeMap={"Power0":Phaser.Easing.Power0,"Power1":Phaser.Easing.Power1,"Power2":Phaser.Easing.Power2,"Power3":Phaser.Easing.Power3,"Power4":Phaser.Easing.Power4,"Linear":Phaser.Easing.Linear.None,"Quad":Phaser.Easing.Quadratic.Out,"Cubic":Phaser.Easing.Cubic.Out,"Quart":Phaser.Easing.Quartic.Out,"Quint":Phaser.Easing.Quintic.Out,"Sine":Phaser.Easing.Sinusoidal.Out,"Expo":Phaser.Easing.Exponential.Out,"Circ":Phaser.Easing.Circular.Out,"Elastic":Phaser.Easing.Elastic.Out,"Back":Phaser.Easing.Back.Out,"Bounce":Phaser.Easing.Bounce.Out,"Quad.easeIn":Phaser.Easing.Quadratic.In,"Cubic.easeIn":Phaser.Easing.Cubic.In,"Quart.easeIn":Phaser.Easing.Quartic.In,"Quint.easeIn":Phaser.Easing.Quintic.In,"Sine.easeIn":Phaser.Easing.Sinusoidal.In,"Expo.easeIn":Phaser.Easing.Exponential.In,"Circ.easeIn":Phaser.Easing.Circular.In,"Elastic.easeIn":Phaser.Easing.Elastic.In,"Back.easeIn":Phaser.Easing.Back.In,"Bounce.easeIn":Phaser.Easing.Bounce.In,"Quad.easeOut":Phaser.Easing.Quadratic.Out,"Cubic.easeOut":Phaser.Easing.Cubic.Out,"Quart.easeOut":Phaser.Easing.Quartic.Out,"Quint.easeOut":Phaser.Easing.Quintic.Out,"Sine.easeOut":Phaser.Easing.Sinusoidal.Out,"Expo.easeOut":Phaser.Easing.Exponential.Out,"Circ.easeOut":Phaser.Easing.Circular.Out,"Elastic.easeOut":Phaser.Easing.Elastic.Out,"Back.easeOut":Phaser.Easing.Back.Out,"Bounce.easeOut":Phaser.Easing.Bounce.Out,"Quad.easeInOut":Phaser.Easing.Quadratic.InOut,"Cubic.easeInOut":Phaser.Easing.Cubic.InOut,"Quart.easeInOut":Phaser.Easing.Quartic.InOut,"Quint.easeInOut":Phaser.Easing.Quintic.InOut,"Sine.easeInOut":Phaser.Easing.Sinusoidal.InOut,"Expo.easeInOut":Phaser.Easing.Exponential.InOut,"Circ.easeInOut":Phaser.Easing.Circular.InOut,"Elastic.easeInOut":Phaser.Easing.Elastic.InOut,"Back.easeInOut":Phaser.Easing.Back.InOut,"Bounce.easeInOut":Phaser.Easing.Bounce.InOut};this.game.onPause.add(this._pauseAll,this);this.game.onResume.add(this._resumeAll,this);};Phaser.TweenManager.prototype={/**
	    * Get all the tween objects in an array.
	    * @method Phaser.TweenManager#getAll
	    * @returns {Phaser.Tween[]} Array with all tween objects.
	    */getAll:function getAll(){return this._tweens;},/**
	    * Remove all tweens running and in the queue. Doesn't call any of the tween onComplete events.
	    * @method Phaser.TweenManager#removeAll
	    */removeAll:function removeAll(){for(var i=0;i<this._tweens.length;i++){this._tweens[i].pendingDelete=true;}this._add=[];},/**
	    * Remove all tweens from a specific object, array of objects or Group.
	    * 
	    * @method Phaser.TweenManager#removeFrom
	    * @param {object|object[]|Phaser.Group} obj - The object you want to remove the tweens from.
	    * @param {boolean} [children=true] - If passing a group, setting this to true will remove the tweens from all of its children instead of the group itself.
	    */removeFrom:function removeFrom(obj,children){if(children===undefined){children=true;}var i;var len;if(Array.isArray(obj)){for(i=0,len=obj.length;i<len;i++){this.removeFrom(obj[i]);}}else if(obj.type===Phaser.GROUP&&children){for(var i=0,len=obj.children.length;i<len;i++){this.removeFrom(obj.children[i]);}}else{for(i=0,len=this._tweens.length;i<len;i++){if(obj===this._tweens[i].target){this.remove(this._tweens[i]);}}for(i=0,len=this._add.length;i<len;i++){if(obj===this._add[i].target){this.remove(this._add[i]);}}}},/**
	    * Add a new tween into the TweenManager.
	    *
	    * @method Phaser.TweenManager#add
	    * @param {Phaser.Tween} tween - The tween object you want to add.
	    * @returns {Phaser.Tween} The tween object you added to the manager.
	    */add:function add(tween){tween._manager=this;this._add.push(tween);},/**
	    * Create a tween object for a specific object. The object can be any JavaScript object or Phaser object such as Sprite.
	    *
	    * @method Phaser.TweenManager#create
	    * @param {object} object - Object the tween will be run on.
	    * @returns {Phaser.Tween} The newly created tween object.
	    */create:function create(object){return new Phaser.Tween(object,this.game,this);},/**
	    * Remove a tween from this manager.
	    *
	    * @method Phaser.TweenManager#remove
	    * @param {Phaser.Tween} tween - The tween object you want to remove.
	    */remove:function remove(tween){var i=this._tweens.indexOf(tween);if(i!==-1){this._tweens[i].pendingDelete=true;}else{i=this._add.indexOf(tween);if(i!==-1){this._add[i].pendingDelete=true;}}},/**
	    * Update all the tween objects you added to this manager.
	    *
	    * @method Phaser.TweenManager#update
	    * @returns {boolean} Return false if there's no tween to update, otherwise return true.
	    */update:function update(){var addTweens=this._add.length;var numTweens=this._tweens.length;if(numTweens===0&&addTweens===0){return false;}var i=0;while(i<numTweens){if(this._tweens[i].update(this.game.time.time)){i++;}else{this._tweens.splice(i,1);numTweens--;}}//  If there are any new tweens to be added, do so now - otherwise they can be spliced out of the array before ever running
	if(addTweens>0){this._tweens=this._tweens.concat(this._add);this._add.length=0;}return true;},/**
	    * Checks to see if a particular Sprite is currently being tweened.
	    *
	    * @method Phaser.TweenManager#isTweening
	    * @param {object} object - The object to check for tweens against.
	    * @returns {boolean} Returns true if the object is currently being tweened, false if not.
	    */isTweening:function isTweening(object){return this._tweens.some(function(tween){return tween.target===object;});},/**
	    * Private. Called by game focus loss. Pauses all currently running tweens.
	    *
	    * @method Phaser.TweenManager#_pauseAll
	    * @private
	    */_pauseAll:function _pauseAll(){for(var i=this._tweens.length-1;i>=0;i--){this._tweens[i]._pause();}},/**
	    * Private. Called by game focus loss. Resumes all currently paused tweens.
	    *
	    * @method Phaser.TweenManager#_resumeAll
	    * @private
	    */_resumeAll:function _resumeAll(){for(var i=this._tweens.length-1;i>=0;i--){this._tweens[i]._resume();}},/**
	    * Pauses all currently running tweens.
	    *
	    * @method Phaser.TweenManager#pauseAll
	    */pauseAll:function pauseAll(){for(var i=this._tweens.length-1;i>=0;i--){this._tweens[i].pause();}},/**
	    * Resumes all currently paused tweens.
	    *
	    * @method Phaser.TweenManager#resumeAll
	    */resumeAll:function resumeAll(){for(var i=this._tweens.length-1;i>=0;i--){this._tweens[i].resume(true);}}};Phaser.TweenManager.prototype.constructor=Phaser.TweenManager;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A Tween allows you to alter one or more properties of a target object over a defined period of time.
	* This can be used for things such as alpha fading Sprites, scaling them or motion.
	* Use `Tween.to` or `Tween.from` to set-up the tween values. You can create multiple tweens on the same object
	* by calling Tween.to multiple times on the same Tween. Additional tweens specified in this way become "child" tweens and
	* are played through in sequence. You can use Tween.timeScale and Tween.reverse to control the playback of this Tween and all of its children.
	*
	* @class Phaser.Tween
	* @constructor
	* @param {object} target - The target object, such as a Phaser.Sprite or Phaser.Sprite.scale.
	* @param {Phaser.Game} game - Current game instance.
	* @param {Phaser.TweenManager} manager - The TweenManager responsible for looking after this Tween.
	*/Phaser.Tween=function(target,game,manager){/**
	    * @property {Phaser.Game} game - A reference to the currently running Game.
	    */this.game=game;/**
	    * @property {object} target - The target object, such as a Phaser.Sprite or property like Phaser.Sprite.scale.
	    */this.target=target;/**
	    * @property {Phaser.TweenManager} manager - Reference to the TweenManager responsible for updating this Tween.
	    */this.manager=manager;/**
	    * @property {Array} timeline - An Array of TweenData objects that comprise the different parts of this Tween.
	    */this.timeline=[];/**
	    * If set to `true` the current tween will play in reverse.
	    * If the tween hasn't yet started this has no effect.
	    * If there are child tweens then all child tweens will play in reverse from the current point.
	    * @property {boolean} reverse
	    * @default
	    */this.reverse=false;/**
	    * The speed at which the tweens will run. A value of 1 means it will match the game frame rate. 0.5 will run at half the frame rate. 2 at double the frame rate, etc.
	    * If a tweens duration is 1 second but timeScale is 0.5 then it will take 2 seconds to complete.
	    *
	    * @property {number} timeScale
	    * @default
	    */this.timeScale=1;/**
	    * @property {number} repeatCounter - If the Tween and any child tweens are set to repeat this contains the current repeat count.
	    */this.repeatCounter=0;/**
	    * @property {boolean} pendingDelete - True if this Tween is ready to be deleted by the TweenManager.
	    * @default
	    * @readonly
	    */this.pendingDelete=false;/**
	    * The onStart event is fired when the Tween begins. If there is a delay before the tween starts then onStart fires after the delay is finished.
	    * It will be sent 2 parameters: the target object and this tween.
	    * @property {Phaser.Signal} onStart
	    */this.onStart=new Phaser.Signal();/**
	    * The onLoop event is fired if the Tween, or any child tweens loop.
	    * It will be sent 2 parameters: the target object and this tween.
	    * 
	    * @property {Phaser.Signal} onLoop
	    */this.onLoop=new Phaser.Signal();/**
	    * The onRepeat event is fired if the Tween and all of its children repeats. If this tween has no children this will never be fired.
	    * It will be sent 2 parameters: the target object and this tween.
	    * @property {Phaser.Signal} onRepeat
	    */this.onRepeat=new Phaser.Signal();/**
	    * The onChildComplete event is fired when the Tween or any of its children completes.
	    * Fires every time a child completes unless a child is set to repeat forever.
	    * It will be sent 2 parameters: the target object and this tween.
	    * @property {Phaser.Signal} onChildComplete
	    */this.onChildComplete=new Phaser.Signal();/**
	    * The onComplete event is fired when the Tween and all of its children completes. Does not fire if the Tween is set to loop or repeatAll(-1).
	    * It will be sent 2 parameters: the target object and this tween.
	    * @property {Phaser.Signal} onComplete
	    */this.onComplete=new Phaser.Signal();/**
	    * @property {boolean} isRunning - If the tween is running this is set to true, otherwise false. Tweens that are in a delayed state or waiting to start are considered as being running.
	    * @default
	    */this.isRunning=false;/**
	    * @property {number} current - The current Tween child being run.
	    * @default
	    * @readonly
	    */this.current=0;/**
	    * @property {object} properties - Target property cache used when building the child data values.
	    */this.properties={};/**
	    * @property {Phaser.Tween} chainedTween - If this Tween is chained to another this holds a reference to it.
	    */this.chainedTween=null;/**
	    * @property {boolean} isPaused - Is this Tween paused or not?
	    * @default
	    */this.isPaused=false;/**
	    * Is this Tween frame or time based? A frame based tween will use the physics elapsed timer when updating. This means
	    * it will retain the same consistent frame rate, regardless of the speed of the device. The duration value given should
	    * be given in frames.
	    *
	    * If the Tween uses a time based update (which is the default) then the duration is given in milliseconds.
	    * In this situation a 2000ms tween will last exactly 2 seconds, regardless of the device and how many visual updates the tween
	    * has actually been through. For very short tweens you may wish to experiment with a frame based update instead.
	    *
	    * The default value is whatever you've set in TweenManager.frameBased.
	    *
	    * @property {boolean} frameBased
	    * @default
	    */this.frameBased=manager.frameBased;/**
	    * @property {function} _onUpdateCallback - An onUpdate callback.
	    * @private
	    * @default null
	    */this._onUpdateCallback=null;/**
	    * @property {object} _onUpdateCallbackContext - The context in which to call the onUpdate callback.
	    * @private
	    * @default null
	    */this._onUpdateCallbackContext=null;/**
	    * @property {number} _pausedTime - Private pause timer.
	    * @private
	    * @default
	    */this._pausedTime=0;/**
	    * @property {boolean} _codePaused - Was the Tween paused by code or by Game focus loss?
	    * @private
	    */this._codePaused=false;/**
	    * @property {boolean} _hasStarted - Internal var to track if the Tween has started yet or not.
	    * @private
	    */this._hasStarted=false;};Phaser.Tween.prototype={/**
	    * Sets this tween to be a `to` tween on the properties given. A `to` tween starts at the current value and tweens to the destination value given.
	    * For example a Sprite with an `x` coordinate of 100 could be tweened to `x` 200 by giving a properties object of `{ x: 200 }`.
	    * The ease function allows you define the rate of change. You can pass either a function such as Phaser.Easing.Circular.Out or a string such as "Circ".
	    * ".easeIn", ".easeOut" and "easeInOut" variants are all supported for all ease types.
	    *
	    * @method Phaser.Tween#to
	    * @param {object} properties - An object containing the properties you want to tween, such as `Sprite.x` or `Sound.volume`. Given as a JavaScript object.
	    * @param {number} [duration=1000] - Duration of this tween in ms. Or if `Tween.frameBased` is true this represents the number of frames that should elapse.
	    * @param {function|string} [ease=null] - Easing function. If not set it will default to Phaser.Easing.Default, which is Phaser.Easing.Linear.None by default but can be over-ridden.
	    * @param {boolean} [autoStart=false] - Set to `true` to allow this tween to start automatically. Otherwise call Tween.start().
	    * @param {number} [delay=0] - Delay before this tween will start in milliseconds. Defaults to 0, no delay.
	    * @param {number} [repeat=0] - Should the tween automatically restart once complete? If you want it to run forever set as -1. This only effects this individual tween, not any chained tweens.
	    * @param {boolean} [yoyo=false] - A tween that yoyos will reverse itself and play backwards automatically. A yoyo'd tween doesn't fire the Tween.onComplete event, so listen for Tween.onLoop instead.
	    * @return {Phaser.Tween} This Tween object.
	    */to:function to(properties,duration,ease,autoStart,delay,repeat,yoyo){if(duration===undefined||duration<=0){duration=1000;}if(ease===undefined||ease===null){ease=Phaser.Easing.Default;}if(autoStart===undefined){autoStart=false;}if(delay===undefined){delay=0;}if(repeat===undefined){repeat=0;}if(yoyo===undefined){yoyo=false;}if(typeof ease==='string'&&this.manager.easeMap[ease]){ease=this.manager.easeMap[ease];}if(this.isRunning){console.warn('Phaser.Tween.to cannot be called after Tween.start');return this;}this.timeline.push(new Phaser.TweenData(this).to(properties,duration,ease,delay,repeat,yoyo));if(autoStart){this.start();}return this;},/**
	    * Sets this tween to be a `from` tween on the properties given. A `from` tween sets the target to the destination value and tweens to its current value.
	    * For example a Sprite with an `x` coordinate of 100 tweened from `x` 500 would be set to `x` 500 and then tweened to `x` 100 by giving a properties object of `{ x: 500 }`.
	    * The ease function allows you define the rate of change. You can pass either a function such as Phaser.Easing.Circular.Out or a string such as "Circ".
	    * ".easeIn", ".easeOut" and "easeInOut" variants are all supported for all ease types.
	    *
	    * @method Phaser.Tween#from
	    * @param {object} properties - An object containing the properties you want to tween., such as `Sprite.x` or `Sound.volume`. Given as a JavaScript object.
	    * @param {number} [duration=1000] - Duration of this tween in ms. Or if `Tween.frameBased` is true this represents the number of frames that should elapse.
	    * @param {function|string} [ease=null] - Easing function. If not set it will default to Phaser.Easing.Default, which is Phaser.Easing.Linear.None by default but can be over-ridden.
	    * @param {boolean} [autoStart=false] - Set to `true` to allow this tween to start automatically. Otherwise call Tween.start().
	    * @param {number} [delay=0] - Delay before this tween will start in milliseconds. Defaults to 0, no delay.
	    * @param {number} [repeat=0] - Should the tween automatically restart once complete? If you want it to run forever set as -1. This only effects this individual tween, not any chained tweens.
	    * @param {boolean} [yoyo=false] - A tween that yoyos will reverse itself and play backwards automatically. A yoyo'd tween doesn't fire the Tween.onComplete event, so listen for Tween.onLoop instead.
	    * @return {Phaser.Tween} This Tween object.
	    */from:function from(properties,duration,ease,autoStart,delay,repeat,yoyo){if(duration===undefined){duration=1000;}if(ease===undefined||ease===null){ease=Phaser.Easing.Default;}if(autoStart===undefined){autoStart=false;}if(delay===undefined){delay=0;}if(repeat===undefined){repeat=0;}if(yoyo===undefined){yoyo=false;}if(typeof ease==='string'&&this.manager.easeMap[ease]){ease=this.manager.easeMap[ease];}if(this.isRunning){console.warn('Phaser.Tween.from cannot be called after Tween.start');return this;}this.timeline.push(new Phaser.TweenData(this).from(properties,duration,ease,delay,repeat,yoyo));if(autoStart){this.start();}return this;},/**
	    * Starts the tween running. Can also be called by the autoStart parameter of `Tween.to` or `Tween.from`.
	    * This sets the `Tween.isRunning` property to `true` and dispatches a `Tween.onStart` signal.
	    * If the Tween has a delay set then nothing will start tweening until the delay has expired.
	    *
	    * @method Phaser.Tween#start
	    * @param {number} [index=0] - If this Tween contains child tweens you can specify which one to start from. The default is zero, i.e. the first tween created.
	    * @return {Phaser.Tween} This tween. Useful for method chaining.
	    */start:function start(index){if(index===undefined){index=0;}if(this.game===null||this.target===null||this.timeline.length===0||this.isRunning){return this;}//  Populate the tween data
	for(var i=0;i<this.timeline.length;i++){//  Build our master property list with the starting values
	for(var property in this.timeline[i].vEnd){this.properties[property]=this.target[property]||0;if(!Array.isArray(this.properties[property])){//  Ensures we're using numbers, not strings
	this.properties[property]*=1.0;}}}for(var i=0;i<this.timeline.length;i++){this.timeline[i].loadValues();}this.manager.add(this);this.isRunning=true;if(index<0||index>this.timeline.length-1){index=0;}this.current=index;this.timeline[this.current].start();return this;},/**
	    * Stops the tween if running and flags it for deletion from the TweenManager.
	    * If called directly the `Tween.onComplete` signal is not dispatched and no chained tweens are started unless the complete parameter is set to `true`.
	    * If you just wish to pause a tween then use Tween.pause instead.
	    *
	    * @method Phaser.Tween#stop
	    * @param {boolean} [complete=false] - Set to `true` to dispatch the Tween.onComplete signal.
	    * @return {Phaser.Tween} This tween. Useful for method chaining.
	    */stop:function stop(complete){if(complete===undefined){complete=false;}this.isRunning=false;this._onUpdateCallback=null;this._onUpdateCallbackContext=null;if(complete){this.onComplete.dispatch(this.target,this);this._hasStarted=false;if(this.chainedTween){this.chainedTween.start();}}this.manager.remove(this);return this;},/**
	    * Updates either a single TweenData or all TweenData objects properties to the given value.
	    * Used internally by methods like Tween.delay, Tween.yoyo, etc. but can also be called directly if you know which property you want to tweak.
	    * The property is not checked, so if you pass an invalid one you'll generate a run-time error.
	    *
	    * @method Phaser.Tween#updateTweenData
	    * @param {string} property - The property to update.
	    * @param {number|function} value - The value to set the property to.
	    * @param {number} [index=0] - If this tween has more than one child this allows you to target a specific child. If set to -1 it will set the delay on all the children.
	    * @return {Phaser.Tween} This tween. Useful for method chaining.
	    */updateTweenData:function updateTweenData(property,value,index){if(this.timeline.length===0){return this;}if(index===undefined){index=0;}if(index===-1){for(var i=0;i<this.timeline.length;i++){this.timeline[i][property]=value;}}else{this.timeline[index][property]=value;}return this;},/**
	    * Sets the delay in milliseconds before this tween will start. If there are child tweens it sets the delay before the first child starts.
	    * The delay is invoked as soon as you call `Tween.start`. If the tween is already running this method doesn't do anything for the current active tween.
	    * If you have not yet called `Tween.to` or `Tween.from` at least once then this method will do nothing, as there are no tweens to delay.
	    * If you have child tweens and pass -1 as the index value it sets the delay across all of them.
	    *
	    * @method Phaser.Tween#delay
	    * @param {number} duration - The amount of time in ms that the Tween should wait until it begins once started is called. Set to zero to remove any active delay.
	    * @param {number} [index=0] - If this tween has more than one child this allows you to target a specific child. If set to -1 it will set the delay on all the children.
	    * @return {Phaser.Tween} This tween. Useful for method chaining.
	    */delay:function delay(duration,index){return this.updateTweenData('delay',duration,index);},/**
	    * Sets the number of times this tween will repeat.
	    * If you have not yet called `Tween.to` or `Tween.from` at least once then this method will do nothing, as there are no tweens to repeat.
	    * If you have child tweens and pass -1 as the index value it sets the number of times they'll repeat across all of them.
	    * If you wish to define how many times this Tween and all children will repeat see Tween.repeatAll.
	    *
	    * @method Phaser.Tween#repeat
	    * @param {number} total - How many times a tween should repeat before completing. Set to zero to remove an active repeat. Set to -1 to repeat forever.
	    * @param {number} [repeat=0] - This is the amount of time to pause (in ms) before the repeat will start.
	    * @param {number} [index=0] - If this tween has more than one child this allows you to target a specific child. If set to -1 it will set the repeat value on all the children.
	    * @return {Phaser.Tween} This tween. Useful for method chaining.
	    */repeat:function repeat(total,repeatDelay,index){if(repeatDelay===undefined){repeatDelay=0;}this.updateTweenData('repeatCounter',total,index);return this.updateTweenData('repeatDelay',repeatDelay,index);},/**
	    * Sets the delay in milliseconds before this tween will repeat itself.
	    * The repeatDelay is invoked as soon as you call `Tween.start`. If the tween is already running this method doesn't do anything for the current active tween.
	    * If you have not yet called `Tween.to` or `Tween.from` at least once then this method will do nothing, as there are no tweens to set repeatDelay on.
	    * If you have child tweens and pass -1 as the index value it sets the repeatDelay across all of them.
	    *
	    * @method Phaser.Tween#repeatDelay
	    * @param {number} duration - The amount of time in ms that the Tween should wait until it repeats or yoyos once start is called. Set to zero to remove any active repeatDelay.
	    * @param {number} [index=0] - If this tween has more than one child this allows you to target a specific child. If set to -1 it will set the repeatDelay on all the children.
	    * @return {Phaser.Tween} This tween. Useful for method chaining.
	    */repeatDelay:function repeatDelay(duration,index){return this.updateTweenData('repeatDelay',duration,index);},/**
	    * A Tween that has yoyo set to true will run through from its starting values to its end values and then play back in reverse from end to start.
	    * Used in combination with repeat you can create endless loops.
	    * If you have not yet called `Tween.to` or `Tween.from` at least once then this method will do nothing, as there are no tweens to yoyo.
	    * If you have child tweens and pass -1 as the index value it sets the yoyo property across all of them.
	    * If you wish to yoyo this Tween and all of its children then see Tween.yoyoAll.
	    *
	    * @method Phaser.Tween#yoyo
	    * @param {boolean} enable - Set to true to yoyo this tween, or false to disable an already active yoyo.
	    * @param {number} [yoyoDelay=0] - This is the amount of time to pause (in ms) before the yoyo will start.
	    * @param {number} [index=0] - If this tween has more than one child this allows you to target a specific child. If set to -1 it will set yoyo on all the children.
	    * @return {Phaser.Tween} This tween. Useful for method chaining.
	    */yoyo:function yoyo(enable,yoyoDelay,index){if(yoyoDelay===undefined){yoyoDelay=0;}this.updateTweenData('yoyo',enable,index);return this.updateTweenData('yoyoDelay',yoyoDelay,index);},/**
	    * Sets the delay in milliseconds before this tween will run a yoyo (only applies if yoyo is enabled).
	    * The repeatDelay is invoked as soon as you call `Tween.start`. If the tween is already running this method doesn't do anything for the current active tween.
	    * If you have not yet called `Tween.to` or `Tween.from` at least once then this method will do nothing, as there are no tweens to set repeatDelay on.
	    * If you have child tweens and pass -1 as the index value it sets the repeatDelay across all of them.
	    *
	    * @method Phaser.Tween#yoyoDelay
	    * @param {number} duration - The amount of time in ms that the Tween should wait until it repeats or yoyos once start is called. Set to zero to remove any active yoyoDelay.
	    * @param {number} [index=0] - If this tween has more than one child this allows you to target a specific child. If set to -1 it will set the yoyoDelay on all the children.
	    * @return {Phaser.Tween} This tween. Useful for method chaining.
	    */yoyoDelay:function yoyoDelay(duration,index){return this.updateTweenData('yoyoDelay',duration,index);},/**
	    * Set easing function this tween will use, i.e. Phaser.Easing.Linear.None.
	    * The ease function allows you define the rate of change. You can pass either a function such as Phaser.Easing.Circular.Out or a string such as "Circ".
	    * ".easeIn", ".easeOut" and "easeInOut" variants are all supported for all ease types.
	    * If you have child tweens and pass -1 as the index value it sets the easing function defined here across all of them.
	    *
	    * @method Phaser.Tween#easing
	    * @param {function|string} ease - The easing function this tween will use, i.e. Phaser.Easing.Linear.None.
	    * @param {number} [index=0] - If this tween has more than one child this allows you to target a specific child. If set to -1 it will set the easing function on all children.
	    * @return {Phaser.Tween} This tween. Useful for method chaining.
	    */easing:function easing(ease,index){if(typeof ease==='string'&&this.manager.easeMap[ease]){ease=this.manager.easeMap[ease];}return this.updateTweenData('easingFunction',ease,index);},/**
	    * Sets the interpolation function the tween will use. By default it uses Phaser.Math.linearInterpolation.
	    * Also available: Phaser.Math.bezierInterpolation and Phaser.Math.catmullRomInterpolation.
	    * The interpolation function is only used if the target properties is an array.
	    * If you have child tweens and pass -1 as the index value and it will set the interpolation function across all of them.
	    *
	    * @method Phaser.Tween#interpolation
	    * @param {function} interpolation - The interpolation function to use (Phaser.Math.linearInterpolation by default)
	    * @param {object} [context] - The context under which the interpolation function will be run.
	    * @param {number} [index=0] - If this tween has more than one child this allows you to target a specific child. If set to -1 it will set the interpolation function on all children.
	    * @return {Phaser.Tween} This tween. Useful for method chaining.
	    */interpolation:function interpolation(_interpolation,context,index){if(context===undefined){context=Phaser.Math;}this.updateTweenData('interpolationFunction',_interpolation,index);return this.updateTweenData('interpolationContext',context,index);},/**
	    * Set how many times this tween and all of its children will repeat.
	    * A tween (A) with 3 children (B,C,D) with a `repeatAll` value of 2 would play as: ABCDABCD before completing.
	    *
	    * @method Phaser.Tween#repeatAll
	    * @param {number} [total=0] - How many times this tween and all children should repeat before completing. Set to zero to remove an active repeat. Set to -1 to repeat forever.
	    * @return {Phaser.Tween} This tween. Useful for method chaining.
	    */repeatAll:function repeatAll(total){if(total===undefined){total=0;}this.repeatCounter=total;return this;},/**
	    * This method allows you to chain tweens together. Any tween chained to this tween will have its `Tween.start` method called
	    * as soon as this tween completes. If this tween never completes (i.e. repeatAll or loop is set) then the chain will never progress.
	    * Note that `Tween.onComplete` will fire when *this* tween completes, not when the whole chain completes.
	    * For that you should listen to `onComplete` on the final tween in your chain.
	    *
	    * If you pass multiple tweens to this method they will be joined into a single long chain.
	    * For example if this is Tween A and you pass in B, C and D then B will be chained to A, C will be chained to B and D will be chained to C.
	    * Any previously chained tweens that may have been set will be overwritten.
	    *
	    * @method Phaser.Tween#chain
	    * @param {...Phaser.Tween} tweens - One or more tweens that will be chained to this one.
	    * @return {Phaser.Tween} This tween. Useful for method chaining.
	    */chain:function chain(){var i=arguments.length;while(i--){if(i>0){arguments[i-1].chainedTween=arguments[i];}else{this.chainedTween=arguments[i];}}return this;},/**
	    * Enables the looping of this tween. The tween will loop forever, and onComplete will never fire.
	    *
	    * If `value` is `true` then this is the same as setting `Tween.repeatAll(-1)`.
	    * If `value` is `false` it is the same as setting `Tween.repeatAll(0)` and will reset the `repeatCounter` to zero.
	    *
	    * Usage:
	    * game.add.tween(p).to({ x: 700 }, 1000, Phaser.Easing.Linear.None, true)
	    * .to({ y: 300 }, 1000, Phaser.Easing.Linear.None)
	    * .to({ x: 0 }, 1000, Phaser.Easing.Linear.None)
	    * .to({ y: 0 }, 1000, Phaser.Easing.Linear.None)
	    * .loop();
	    * @method Phaser.Tween#loop
	    * @param {boolean} [value=true] - If `true` this tween will loop once it reaches the end. Set to `false` to remove an active loop.
	    * @return {Phaser.Tween} This tween. Useful for method chaining.
	    */loop:function loop(value){if(value===undefined){value=true;}this.repeatCounter=value?-1:0;return this;},/**
	    * Sets a callback to be fired each time this tween updates.
	    *
	    * @method Phaser.Tween#onUpdateCallback
	    * @param {function} callback - The callback to invoke each time this tween is updated. Set to `null` to remove an already active callback.
	    * @param {object} callbackContext - The context in which to call the onUpdate callback.
	    * @return {Phaser.Tween} This tween. Useful for method chaining.
	    */onUpdateCallback:function onUpdateCallback(callback,callbackContext){this._onUpdateCallback=callback;this._onUpdateCallbackContext=callbackContext;return this;},/**
	    * Pauses the tween. Resume playback with Tween.resume.
	    *
	    * @method Phaser.Tween#pause
	    */pause:function pause(){this.isPaused=true;this._codePaused=true;this._pausedTime=this.game.time.time;},/**
	    * This is called by the core Game loop. Do not call it directly, instead use Tween.pause.
	    *
	    * @private
	    * @method Phaser.Tween#_pause
	    */_pause:function _pause(){if(!this._codePaused){this.isPaused=true;this._pausedTime=this.game.time.time;}},/**
	    * Resumes a paused tween.
	    *
	    * @method Phaser.Tween#resume
	    */resume:function resume(){if(this.isPaused){this.isPaused=false;this._codePaused=false;for(var i=0;i<this.timeline.length;i++){if(!this.timeline[i].isRunning){this.timeline[i].startTime+=this.game.time.time-this._pausedTime;}}}},/**
	    * This is called by the core Game loop. Do not call it directly, instead use Tween.pause.
	    * @method Phaser.Tween#_resume
	    * @private
	    */_resume:function _resume(){if(this._codePaused){return;}else{this.resume();}},/**
	    * Core tween update function called by the TweenManager. Does not need to be invoked directly.
	    *
	    * @method Phaser.Tween#update
	    * @param {number} time - A timestamp passed in by the TweenManager.
	    * @return {boolean} false if the tween and all child tweens have completed and should be deleted from the manager, otherwise true (still active).
	    */update:function update(time){if(this.pendingDelete||!this.target){return false;}if(this.isPaused){return true;}var status=this.timeline[this.current].update(time);if(status===Phaser.TweenData.PENDING){return true;}else if(status===Phaser.TweenData.RUNNING){if(!this._hasStarted){this.onStart.dispatch(this.target,this);this._hasStarted=true;}if(this._onUpdateCallback!==null){this._onUpdateCallback.call(this._onUpdateCallbackContext,this,this.timeline[this.current].value,this.timeline[this.current]);}//  In case the update callback modifies this tween
	return this.isRunning;}else if(status===Phaser.TweenData.LOOPED){if(this.timeline[this.current].repeatCounter===-1){this.onLoop.dispatch(this.target,this);}else{this.onRepeat.dispatch(this.target,this);}return true;}else if(status===Phaser.TweenData.COMPLETE){var complete=false;//  What now?
	if(this.reverse){this.current--;if(this.current<0){this.current=this.timeline.length-1;complete=true;}}else{this.current++;if(this.current===this.timeline.length){this.current=0;complete=true;}}if(complete){//  We've reached the start or end of the child tweens (depending on Tween.reverse), should we repeat it?
	if(this.repeatCounter===-1){this.timeline[this.current].start();this.onLoop.dispatch(this.target,this);return true;}else if(this.repeatCounter>0){this.repeatCounter--;this.timeline[this.current].start();this.onRepeat.dispatch(this.target,this);return true;}else{//  No more repeats and no more children, so we're done
	this.isRunning=false;this.onComplete.dispatch(this.target,this);this._hasStarted=false;if(this.chainedTween){this.chainedTween.start();}return false;}}else{//  We've still got some children to go
	this.onChildComplete.dispatch(this.target,this);this.timeline[this.current].start();return true;}}},/**
	    * This will generate an array populated with the tweened object values from start to end.
	    * It works by running the tween simulation at the given frame rate based on the values set-up in Tween.to and Tween.from.
	    * It ignores delay and repeat counts and any chained tweens, but does include child tweens.
	    * Just one play through of the tween data is returned, including yoyo if set.
	    *
	    * @method Phaser.Tween#generateData
	    * @param {number} [frameRate=60] - The speed in frames per second that the data should be generated at. The higher the value, the larger the array it creates.
	    * @param {array} [data] - If given the generated data will be appended to this array, otherwise a new array will be returned.
	    * @return {array} An array of tweened values.
	    */generateData:function generateData(frameRate,data){if(this.game===null||this.target===null){return null;}if(frameRate===undefined){frameRate=60;}if(data===undefined){data=[];}//  Populate the tween data
	for(var i=0;i<this.timeline.length;i++){//  Build our master property list with the starting values
	for(var property in this.timeline[i].vEnd){this.properties[property]=this.target[property]||0;if(!Array.isArray(this.properties[property])){//  Ensures we're using numbers, not strings
	this.properties[property]*=1.0;}}}for(var i=0;i<this.timeline.length;i++){this.timeline[i].loadValues();}for(var i=0;i<this.timeline.length;i++){data=data.concat(this.timeline[i].generateData(frameRate));}return data;}};/**
	* @name Phaser.Tween#totalDuration
	* @property {Phaser.TweenData} totalDuration - Gets the total duration of this Tween, including all child tweens, in milliseconds.
	*/Object.defineProperty(Phaser.Tween.prototype,'totalDuration',{get:function get(){var total=0;for(var i=0;i<this.timeline.length;i++){total+=this.timeline[i].duration;}return total;}});Phaser.Tween.prototype.constructor=Phaser.Tween;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A Phaser.Tween contains at least one TweenData object. It contains all of the tween data values, such as the
	* starting and ending values, the ease function, interpolation and duration. The Tween acts as a timeline manager for
	* TweenData objects and can contain multiple TweenData objects.
	*
	* @class Phaser.TweenData
	* @constructor
	* @param {Phaser.Tween} parent - The Tween that owns this TweenData object.
	*/Phaser.TweenData=function(parent){/**
	    * @property {Phaser.Tween} parent - The Tween which owns this TweenData.
	    */this.parent=parent;/**
	    * @property {Phaser.Game} game - A reference to the currently running Game.
	    */this.game=parent.game;/**
	    * @property {object} vStart - An object containing the values at the start of the tween.
	    * @private
	    */this.vStart={};/**
	    * @property {object} vStartCache - Cached starting values.
	    * @private
	    */this.vStartCache={};/**
	    * @property {object} vEnd - An object containing the values at the end of the tween.
	    * @private
	    */this.vEnd={};/**
	    * @property {object} vEndCache - Cached ending values.
	    * @private
	    */this.vEndCache={};/**
	    * @property {number} duration - The duration of the tween in ms.
	    * @default
	    */this.duration=1000;/**
	    * @property {number} percent - A value between 0 and 1 that represents how far through the duration this tween is.
	    * @readonly
	    */this.percent=0;/**
	    * @property {number} value - The current calculated value.
	    * @readonly
	    */this.value=0;/**
	    * @property {number} repeatCounter - If the Tween is set to repeat this contains the current repeat count.
	    */this.repeatCounter=0;/**
	    * @property {number} repeatDelay - The amount of time in ms between repeats of this tween.
	    */this.repeatDelay=0;/**
	    * @property {number} repeatTotal - The total number of times this Tween will repeat.
	    * @readonly
	    */this.repeatTotal=0;/**
	    * @property {boolean} interpolate - True if the Tween will use interpolation (i.e. is an Array to Array tween)
	    * @default
	    */this.interpolate=false;/**
	    * @property {boolean} yoyo - True if the Tween is set to yoyo, otherwise false.
	    * @default
	    */this.yoyo=false;/**
	    * @property {number} yoyoDelay - The amount of time in ms between yoyos of this tween.
	    */this.yoyoDelay=0;/**
	    * @property {boolean} inReverse - When a Tween is yoyoing this value holds if it's currently playing forwards (false) or in reverse (true).
	    * @default
	    */this.inReverse=false;/**
	    * @property {number} delay - The amount to delay by until the Tween starts (in ms). Only applies to the start, use repeatDelay to handle repeats.
	    * @default
	    */this.delay=0;/**
	    * @property {number} dt - Current time value.
	    */this.dt=0;/**
	    * @property {number} startTime - The time the Tween started or null if it hasn't yet started.
	    */this.startTime=null;/**
	    * @property {function} easingFunction - The easing function used for the Tween.
	    * @default Phaser.Easing.Default
	    */this.easingFunction=Phaser.Easing.Default;/**
	    * @property {function} interpolationFunction - The interpolation function used for the Tween.
	    * @default Phaser.Math.linearInterpolation
	    */this.interpolationFunction=Phaser.Math.linearInterpolation;/**
	    * @property {object} interpolationContext - The interpolation function context used for the Tween.
	    * @default Phaser.Math
	    */this.interpolationContext=Phaser.Math;/**
	    * @property {boolean} isRunning - If the tween is running this is set to `true`. Unless Phaser.Tween a TweenData that is waiting for a delay to expire is *not* considered as running.
	    * @default
	    */this.isRunning=false;/**
	    * @property {boolean} isFrom - Is this a from tween or a to tween?
	    * @default
	    */this.isFrom=false;};/**
	* @constant
	* @type {number}
	*/Phaser.TweenData.PENDING=0;/**
	* @constant
	* @type {number}
	*/Phaser.TweenData.RUNNING=1;/**
	* @constant
	* @type {number}
	*/Phaser.TweenData.LOOPED=2;/**
	* @constant
	* @type {number}
	*/Phaser.TweenData.COMPLETE=3;Phaser.TweenData.prototype={/**
	    * Sets this tween to be a `to` tween on the properties given. A `to` tween starts at the current value and tweens to the destination value given.
	    * For example a Sprite with an `x` coordinate of 100 could be tweened to `x` 200 by giving a properties object of `{ x: 200 }`.
	    *
	    * @method Phaser.TweenData#to
	    * @param {object} properties - The properties you want to tween, such as `Sprite.x` or `Sound.volume`. Given as a JavaScript object.
	    * @param {number} [duration=1000] - Duration of this tween in ms.
	    * @param {function} [ease=null] - Easing function. If not set it will default to Phaser.Easing.Default, which is Phaser.Easing.Linear.None by default but can be over-ridden at will.
	    * @param {number} [delay=0] - Delay before this tween will start, defaults to 0 (no delay). Value given is in ms.
	    * @param {number} [repeat=0] - Should the tween automatically restart once complete? If you want it to run forever set as -1. This ignores any chained tweens.
	    * @param {boolean} [yoyo=false] - A tween that yoyos will reverse itself and play backwards automatically. A yoyo'd tween doesn't fire the Tween.onComplete event, so listen for Tween.onLoop instead.
	    * @return {Phaser.TweenData} This Tween object.
	    */to:function to(properties,duration,ease,delay,repeat,yoyo){this.vEnd=properties;this.duration=duration;this.easingFunction=ease;this.delay=delay;this.repeatTotal=repeat;this.yoyo=yoyo;this.isFrom=false;return this;},/**
	    * Sets this tween to be a `from` tween on the properties given. A `from` tween sets the target to the destination value and tweens to its current value.
	    * For example a Sprite with an `x` coordinate of 100 tweened from `x` 500 would be set to `x` 500 and then tweened to `x` 100 by giving a properties object of `{ x: 500 }`.
	    *
	    * @method Phaser.TweenData#from
	    * @param {object} properties - The properties you want to tween, such as `Sprite.x` or `Sound.volume`. Given as a JavaScript object.
	    * @param {number} [duration=1000] - Duration of this tween in ms.
	    * @param {function} [ease=null] - Easing function. If not set it will default to Phaser.Easing.Default, which is Phaser.Easing.Linear.None by default but can be over-ridden at will.
	    * @param {number} [delay=0] - Delay before this tween will start, defaults to 0 (no delay). Value given is in ms.
	    * @param {number} [repeat=0] - Should the tween automatically restart once complete? If you want it to run forever set as -1. This ignores any chained tweens.
	    * @param {boolean} [yoyo=false] - A tween that yoyos will reverse itself and play backwards automatically. A yoyo'd tween doesn't fire the Tween.onComplete event, so listen for Tween.onLoop instead.
	    * @return {Phaser.TweenData} This Tween object.
	    */from:function from(properties,duration,ease,delay,repeat,yoyo){this.vEnd=properties;this.duration=duration;this.easingFunction=ease;this.delay=delay;this.repeatTotal=repeat;this.yoyo=yoyo;this.isFrom=true;return this;},/**
	    * Starts the Tween running.
	    *
	    * @method Phaser.TweenData#start
	    * @return {Phaser.TweenData} This Tween object.
	    */start:function start(){this.startTime=this.game.time.time+this.delay;if(this.parent.reverse){this.dt=this.duration;}else{this.dt=0;}if(this.delay>0){this.isRunning=false;}else{this.isRunning=true;}if(this.isFrom){//  Reverse them all and instant set them
	for(var property in this.vStartCache){this.vStart[property]=this.vEndCache[property];this.vEnd[property]=this.vStartCache[property];this.parent.target[property]=this.vStart[property];}}this.value=0;this.yoyoCounter=0;this.repeatCounter=this.repeatTotal;return this;},/**
	    * Loads the values from the target object into this Tween.
	    *
	    * @private
	    * @method Phaser.TweenData#loadValues
	    * @return {Phaser.TweenData} This Tween object.
	    */loadValues:function loadValues(){for(var property in this.parent.properties){//  Load the property from the parent object
	this.vStart[property]=this.parent.properties[property];//  Check if an Array was provided as property value
	if(Array.isArray(this.vEnd[property])){if(this.vEnd[property].length===0){continue;}if(this.percent===0){//  Put the start value at the beginning of the array
	//  but we only want to do this once, if the Tween hasn't run before
	this.vEnd[property]=[this.vStart[property]].concat(this.vEnd[property]);}}if(typeof this.vEnd[property]!=='undefined'){if(typeof this.vEnd[property]==='string'){//  Parses relative end values with start as base (e.g.: +10, -3)
	this.vEnd[property]=this.vStart[property]+parseFloat(this.vEnd[property],10);}this.parent.properties[property]=this.vEnd[property];}else{//  Null tween
	this.vEnd[property]=this.vStart[property];}this.vStartCache[property]=this.vStart[property];this.vEndCache[property]=this.vEnd[property];}return this;},/**
	    * Updates this Tween. This is called automatically by Phaser.Tween.
	    *
	    * @protected
	    * @method Phaser.TweenData#update
	    * @param {number} time - A timestamp passed in by the Tween parent.
	    * @return {number} The current status of this Tween. One of the Phaser.TweenData constants: PENDING, RUNNING, LOOPED or COMPLETE.
	    */update:function update(time){if(!this.isRunning){if(time>=this.startTime){this.isRunning=true;}else{return Phaser.TweenData.PENDING;}}else{//  Is Running, but is waiting to repeat
	if(time<this.startTime){return Phaser.TweenData.RUNNING;}}var ms=this.parent.frameBased?this.game.time.physicsElapsedMS:this.game.time.elapsedMS;if(this.parent.reverse){this.dt-=ms*this.parent.timeScale;this.dt=Math.max(this.dt,0);}else{this.dt+=ms*this.parent.timeScale;this.dt=Math.min(this.dt,this.duration);}this.percent=this.dt/this.duration;this.value=this.easingFunction(this.percent);for(var property in this.vEnd){var start=this.vStart[property];var end=this.vEnd[property];if(Array.isArray(end)){this.parent.target[property]=this.interpolationFunction.call(this.interpolationContext,end,this.value);}else{this.parent.target[property]=start+(end-start)*this.value;}}if(!this.parent.reverse&&this.percent===1||this.parent.reverse&&this.percent===0){return this.repeat();}return Phaser.TweenData.RUNNING;},/**
	    * This will generate an array populated with the tweened object values from start to end.
	    * It works by running the tween simulation at the given frame rate based on the values set-up in Tween.to and Tween.from.
	    * Just one play through of the tween data is returned, including yoyo if set.
	    *
	    * @method Phaser.TweenData#generateData
	    * @param {number} [frameRate=60] - The speed in frames per second that the data should be generated at. The higher the value, the larger the array it creates.
	    * @return {array} An array of tweened values.
	    */generateData:function generateData(frameRate){if(this.parent.reverse){this.dt=this.duration;}else{this.dt=0;}var data=[];var complete=false;var fps=1/frameRate*1000;do{if(this.parent.reverse){this.dt-=fps;this.dt=Math.max(this.dt,0);}else{this.dt+=fps;this.dt=Math.min(this.dt,this.duration);}this.percent=this.dt/this.duration;this.value=this.easingFunction(this.percent);var blob={};for(var property in this.vEnd){var start=this.vStart[property];var end=this.vEnd[property];if(Array.isArray(end)){blob[property]=this.interpolationFunction(end,this.value);}else{blob[property]=start+(end-start)*this.value;}}data.push(blob);if(!this.parent.reverse&&this.percent===1||this.parent.reverse&&this.percent===0){complete=true;}}while(!complete);if(this.yoyo){var reversed=data.slice();reversed.reverse();data=data.concat(reversed);}return data;},/**
	    * Checks if this Tween is meant to repeat or yoyo and handles doing so.
	    *
	    * @private
	    * @method Phaser.TweenData#repeat
	    * @return {number} Either Phaser.TweenData.LOOPED or Phaser.TweenData.COMPLETE.
	    */repeat:function repeat(){//  If not a yoyo and repeatCounter = 0 then we're done
	if(this.yoyo){//  We're already in reverse mode, which means the yoyo has finished and there's no repeats, so end
	if(this.inReverse&&this.repeatCounter===0){//  Restore the properties
	for(var property in this.vStartCache){this.vStart[property]=this.vStartCache[property];this.vEnd[property]=this.vEndCache[property];}this.inReverse=false;return Phaser.TweenData.COMPLETE;}this.inReverse=!this.inReverse;}else{if(this.repeatCounter===0){return Phaser.TweenData.COMPLETE;}}if(this.inReverse){//  If inReverse we're going from vEnd to vStartCache
	for(var property in this.vStartCache){this.vStart[property]=this.vEndCache[property];this.vEnd[property]=this.vStartCache[property];}}else{//  If not inReverse we're just repopulating the cache again
	for(var property in this.vStartCache){this.vStart[property]=this.vStartCache[property];this.vEnd[property]=this.vEndCache[property];}//  -1 means repeat forever, otherwise decrement the repeatCounter
	//  We only decrement this counter if the tween isn't doing a yoyo, as that doesn't count towards the repeat total
	if(this.repeatCounter>0){this.repeatCounter--;}}this.startTime=this.game.time.time;if(this.yoyo&&this.inReverse){this.startTime+=this.yoyoDelay;}else if(!this.inReverse){this.startTime+=this.repeatDelay;}if(this.parent.reverse){this.dt=this.duration;}else{this.dt=0;}return Phaser.TweenData.LOOPED;}};Phaser.TweenData.prototype.constructor=Phaser.TweenData;/* jshint curly: false *//**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A collection of easing methods defining ease-in and ease-out curves.
	*
	* @class Phaser.Easing
	*/Phaser.Easing={/**
	    * Linear easing.
	    *
	    * @class Phaser.Easing.Linear
	    */Linear:{/**
	        * Linear Easing (no variation).
	        *
	        * @method Phaser.Easing.Linear#None
	        * @param {number} k - The value to be tweened.
	        * @returns {number} k.
	        */None:function None(k){return k;}},/**
	    * Quadratic easing.
	    *
	    * @class Phaser.Easing.Quadratic
	    */Quadratic:{/**
	        * Ease-in.
	        *
	        * @method Phaser.Easing.Quadratic#In
	        * @param {number} k - The value to be tweened.
	        * @returns {number} k^2.
	        */In:function In(k){return k*k;},/**
	        * Ease-out.
	        *
	        * @method Phaser.Easing.Quadratic#Out
	        * @param {number} k - The value to be tweened.
	        * @returns {number} k* (2-k).
	        */Out:function Out(k){return k*(2-k);},/**
	        * Ease-in/out.
	        *
	        * @method Phaser.Easing.Quadratic#InOut
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */InOut:function InOut(k){if((k*=2)<1)return 0.5*k*k;return-0.5*(--k*(k-2)-1);}},/**
	    * Cubic easing.
	    *
	    * @class Phaser.Easing.Cubic
	    */Cubic:{/**
	        * Cubic ease-in.
	        *
	        * @method Phaser.Easing.Cubic#In
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */In:function In(k){return k*k*k;},/**
	        * Cubic ease-out.
	        *
	        * @method Phaser.Easing.Cubic#Out
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */Out:function Out(k){return--k*k*k+1;},/**
	        * Cubic ease-in/out.
	        *
	        * @method Phaser.Easing.Cubic#InOut
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */InOut:function InOut(k){if((k*=2)<1)return 0.5*k*k*k;return 0.5*((k-=2)*k*k+2);}},/**
	    * Quartic easing.
	    *
	    * @class Phaser.Easing.Quartic
	    */Quartic:{/**
	        * Quartic ease-in.
	        *
	        * @method Phaser.Easing.Quartic#In
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */In:function In(k){return k*k*k*k;},/**
	        * Quartic ease-out.
	        *
	        * @method Phaser.Easing.Quartic#Out
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */Out:function Out(k){return 1- --k*k*k*k;},/**
	        * Quartic ease-in/out.
	        *
	        * @method Phaser.Easing.Quartic#InOut
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */InOut:function InOut(k){if((k*=2)<1)return 0.5*k*k*k*k;return-0.5*((k-=2)*k*k*k-2);}},/**
	    * Quintic easing.
	    *
	    * @class Phaser.Easing.Quintic
	    */Quintic:{/**
	        * Quintic ease-in.
	        *
	        * @method Phaser.Easing.Quintic#In
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */In:function In(k){return k*k*k*k*k;},/**
	        * Quintic ease-out.
	        *
	        * @method Phaser.Easing.Quintic#Out
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */Out:function Out(k){return--k*k*k*k*k+1;},/**
	        * Quintic ease-in/out.
	        *
	        * @method Phaser.Easing.Quintic#InOut
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */InOut:function InOut(k){if((k*=2)<1)return 0.5*k*k*k*k*k;return 0.5*((k-=2)*k*k*k*k+2);}},/**
	    * Sinusoidal easing.
	    *
	    * @class Phaser.Easing.Sinusoidal
	    */Sinusoidal:{/**
	        * Sinusoidal ease-in.
	        *
	        * @method Phaser.Easing.Sinusoidal#In
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */In:function In(k){if(k===0)return 0;if(k===1)return 1;return 1-Math.cos(k*Math.PI/2);},/**
	        * Sinusoidal ease-out.
	        *
	        * @method Phaser.Easing.Sinusoidal#Out
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */Out:function Out(k){if(k===0)return 0;if(k===1)return 1;return Math.sin(k*Math.PI/2);},/**
	        * Sinusoidal ease-in/out.
	        *
	        * @method Phaser.Easing.Sinusoidal#InOut
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */InOut:function InOut(k){if(k===0)return 0;if(k===1)return 1;return 0.5*(1-Math.cos(Math.PI*k));}},/**
	    * Exponential easing.
	    *
	    * @class Phaser.Easing.Exponential
	    */Exponential:{/**
	        * Exponential ease-in.
	        *
	        * @method Phaser.Easing.Exponential#In
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */In:function In(k){return k===0?0:Math.pow(1024,k-1);},/**
	        * Exponential ease-out.
	        *
	        * @method Phaser.Easing.Exponential#Out
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */Out:function Out(k){return k===1?1:1-Math.pow(2,-10*k);},/**
	        * Exponential ease-in/out.
	        *
	        * @method Phaser.Easing.Exponential#InOut
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */InOut:function InOut(k){if(k===0)return 0;if(k===1)return 1;if((k*=2)<1)return 0.5*Math.pow(1024,k-1);return 0.5*(-Math.pow(2,-10*(k-1))+2);}},/**
	    * Circular easing.
	    *
	    * @class Phaser.Easing.Circular
	    */Circular:{/**
	        * Circular ease-in.
	        *
	        * @method Phaser.Easing.Circular#In
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */In:function In(k){return 1-Math.sqrt(1-k*k);},/**
	        * Circular ease-out.
	        *
	        * @method Phaser.Easing.Circular#Out
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */Out:function Out(k){return Math.sqrt(1- --k*k);},/**
	        * Circular ease-in/out.
	        *
	        * @method Phaser.Easing.Circular#InOut
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */InOut:function InOut(k){if((k*=2)<1)return-0.5*(Math.sqrt(1-k*k)-1);return 0.5*(Math.sqrt(1-(k-=2)*k)+1);}},/**
	    * Elastic easing.
	    *
	    * @class Phaser.Easing.Elastic
	    */Elastic:{/**
	        * Elastic ease-in.
	        *
	        * @method Phaser.Easing.Elastic#In
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */In:function In(k){var s,a=0.1,p=0.4;if(k===0)return 0;if(k===1)return 1;if(!a||a<1){a=1;s=p/4;}else s=p*Math.asin(1/a)/(2*Math.PI);return-(a*Math.pow(2,10*(k-=1))*Math.sin((k-s)*(2*Math.PI)/p));},/**
	        * Elastic ease-out.
	        *
	        * @method Phaser.Easing.Elastic#Out
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */Out:function Out(k){var s,a=0.1,p=0.4;if(k===0)return 0;if(k===1)return 1;if(!a||a<1){a=1;s=p/4;}else s=p*Math.asin(1/a)/(2*Math.PI);return a*Math.pow(2,-10*k)*Math.sin((k-s)*(2*Math.PI)/p)+1;},/**
	        * Elastic ease-in/out.
	        *
	        * @method Phaser.Easing.Elastic#InOut
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */InOut:function InOut(k){var s,a=0.1,p=0.4;if(k===0)return 0;if(k===1)return 1;if(!a||a<1){a=1;s=p/4;}else s=p*Math.asin(1/a)/(2*Math.PI);if((k*=2)<1)return-0.5*(a*Math.pow(2,10*(k-=1))*Math.sin((k-s)*(2*Math.PI)/p));return a*Math.pow(2,-10*(k-=1))*Math.sin((k-s)*(2*Math.PI)/p)*0.5+1;}},/**
	    * Back easing.
	    *
	    * @class Phaser.Easing.Back
	    */Back:{/**
	        * Back ease-in.
	        *
	        * @method Phaser.Easing.Back#In
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */In:function In(k){var s=1.70158;return k*k*((s+1)*k-s);},/**
	        * Back ease-out.
	        *
	        * @method Phaser.Easing.Back#Out
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */Out:function Out(k){var s=1.70158;return--k*k*((s+1)*k+s)+1;},/**
	        * Back ease-in/out.
	        *
	        * @method Phaser.Easing.Back#InOut
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */InOut:function InOut(k){var s=1.70158*1.525;if((k*=2)<1)return 0.5*(k*k*((s+1)*k-s));return 0.5*((k-=2)*k*((s+1)*k+s)+2);}},/**
	    * Bounce easing.
	    *
	    * @class Phaser.Easing.Bounce
	    */Bounce:{/**
	        * Bounce ease-in.
	        *
	        * @method Phaser.Easing.Bounce#In
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */In:function In(k){return 1-Phaser.Easing.Bounce.Out(1-k);},/**
	        * Bounce ease-out.
	        *
	        * @method Phaser.Easing.Bounce#Out
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */Out:function Out(k){if(k<1/2.75){return 7.5625*k*k;}else if(k<2/2.75){return 7.5625*(k-=1.5/2.75)*k+0.75;}else if(k<2.5/2.75){return 7.5625*(k-=2.25/2.75)*k+0.9375;}else{return 7.5625*(k-=2.625/2.75)*k+0.984375;}},/**
	        * Bounce ease-in/out.
	        *
	        * @method Phaser.Easing.Bounce#InOut
	        * @param {number} k - The value to be tweened.
	        * @returns {number} The tweened value.
	        */InOut:function InOut(k){if(k<0.5)return Phaser.Easing.Bounce.In(k*2)*0.5;return Phaser.Easing.Bounce.Out(k*2-1)*0.5+0.5;}}};Phaser.Easing.Default=Phaser.Easing.Linear.None;Phaser.Easing.Power0=Phaser.Easing.Linear.None;Phaser.Easing.Power1=Phaser.Easing.Quadratic.Out;Phaser.Easing.Power2=Phaser.Easing.Cubic.Out;Phaser.Easing.Power3=Phaser.Easing.Quartic.Out;Phaser.Easing.Power4=Phaser.Easing.Quintic.Out;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* This is the core internal game clock.
	*
	* It manages the elapsed time and calculation of elapsed values, used for game object motion and tweens,
	* and also handles the standard Timer pool.
	*
	* To create a general timed event, use the master {@link Phaser.Timer} accessible through {@link Phaser.Time.events events}.
	*
	* There are different *types* of time in Phaser:
	*
	* - ***Game time*** always runs at the speed of time in real life.
	*
	*   Unlike wall-clock time, *game time stops when Phaser is paused*.
	*
	*   Game time is used for {@link Phaser.Timer timer events}.
	*
	* - ***Physics time*** represents the amount of time given to physics calculations.
	*
	*   *When {@link #slowMotion} is in effect physics time runs slower than game time.*
	*   Like game time, physics time stops when Phaser is paused.
	*
	*   Physics time is used for physics calculations and {@link Phaser.Tween tweens}.
	*
	* - {@link https://en.wikipedia.org/wiki/Wall-clock_time ***Wall-clock time***} represents the duration between two events in real life time.
	*
	*   This time is independent of Phaser and always progresses, regardless of if Phaser is paused.
	*
	* @class Phaser.Time
	* @constructor
	* @param {Phaser.Game} game A reference to the currently running game.
	*/Phaser.Time=function(game){/**
	    * @property {Phaser.Game} game - Local reference to game.
	    * @protected
	    */this.game=game;/**
	    * The `Date.now()` value when the time was last updated.
	    * @property {integer} time
	    * @protected
	    */this.time=0;/**
	    * The `now` when the previous update occurred.
	    * @property {number} prevTime
	    * @protected
	    */this.prevTime=0;/**
	    * An increasing value representing cumulative milliseconds since an undisclosed epoch.
	    *
	    * While this value is in milliseconds and can be used to compute time deltas,
	    * it must must _not_ be used with `Date.now()` as it may not use the same epoch / starting reference.
	    *
	    * The source may either be from a high-res source (eg. if RAF is available) or the standard Date.now;
	    * the value can only be relied upon within a particular game instance.
	    *
	    * @property {number} now
	    * @protected
	    */this.now=0;/**
	    * Elapsed time since the last time update, in milliseconds, based on `now`.
	    *
	    * This value _may_ include time that the game is paused/inactive.
	    *
	    * _Note:_ This is updated only once per game loop - even if multiple logic update steps are done.
	    * Use {@link Phaser.Timer#physicsTime physicsTime} as a basis of game/logic calculations instead.
	    *
	    * @property {number} elapsed
	    * @see Phaser.Time.time
	    * @protected
	    */this.elapsed=0;/**
	    * The time in ms since the last time update, in milliseconds, based on `time`.
	    *
	    * This value is corrected for game pauses and will be "about zero" after a game is resumed.
	    *
	    * _Note:_ This is updated once per game loop - even if multiple logic update steps are done.
	    * Use {@link Phaser.Timer#physicsTime physicsTime} as a basis of game/logic calculations instead.
	    *
	    * @property {integer} elapsedMS
	    * @protected
	    */this.elapsedMS=0;/**
	    * The physics update delta, in fractional seconds.
	    *
	    * This should be used as an applicable multiplier by all logic update steps (eg. `preUpdate/postUpdate/update`)
	    * to ensure consistent game timing. Game/logic timing can drift from real-world time if the system
	    * is unable to consistently maintain the desired FPS.
	    *
	    * With fixed-step updates this is normally equivalent to `1.0 / desiredFps`.
	    *
	    * @property {number} physicsElapsed
	    */this.physicsElapsed=1/60;/**
	    * The physics update delta, in milliseconds - equivalent to `physicsElapsed * 1000`.
	    *
	    * @property {number} physicsElapsedMS
	    */this.physicsElapsedMS=1/60*1000;/**
	    * The desiredFps multiplier as used by Game.update.
	    * @property {integer} desiredFpsMult
	    * @protected
	    */this.desiredFpsMult=1.0/60;/**
	    * The desired frame rate of the game.
	    *
	    * This is used is used to calculate the physic/logic multiplier and how to apply catch-up logic updates.
	    *
	    * @property {number} _desiredFps
	    * @private
	    * @default
	    */this._desiredFps=60;/**
	    * The suggested frame rate for your game, based on an averaged real frame rate.
	    * This value is only populated if `Time.advancedTiming` is enabled.
	    *
	    * _Note:_ This is not available until after a few frames have passed; until then
	    * it's set to the same value as desiredFps.
	    *
	    * @property {number} suggestedFps
	    * @default
	    */this.suggestedFps=this.desiredFps;/**
	    * Scaling factor to make the game move smoothly in slow motion
	    * - 1.0 = normal speed
	    * - 2.0 = half speed
	    * @property {number} slowMotion
	    * @default
	    */this.slowMotion=1.0;/**
	    * If true then advanced profiling, including the fps rate, fps min/max, suggestedFps and msMin/msMax are updated.
	    * @property {boolean} advancedTiming
	    * @default
	    */this.advancedTiming=false;/**
	    * Advanced timing result: The number of render frames record in the last second.
	    *
	    * Only calculated if {@link Phaser.Time#advancedTiming advancedTiming} is enabled.
	    * @property {integer} frames
	    * @readonly
	    */this.frames=0;/**
	    * Advanced timing result: Frames per second.
	    *
	    * Only calculated if {@link Phaser.Time#advancedTiming advancedTiming} is enabled.
	    * @property {number} fps
	    * @readonly
	    */this.fps=0;/**
	    * Advanced timing result: The lowest rate the fps has dropped to.
	    *
	    * Only calculated if {@link Phaser.Time#advancedTiming advancedTiming} is enabled.
	    * This value can be manually reset.
	    * @property {number} fpsMin
	    */this.fpsMin=1000;/**
	    * Advanced timing result: The highest rate the fps has reached (usually no higher than 60fps).
	    *
	    * Only calculated if {@link Phaser.Time#advancedTiming advancedTiming} is enabled.
	    * This value can be manually reset.
	    * @property {number} fpsMax
	    */this.fpsMax=0;/**
	    * Advanced timing result: The minimum amount of time the game has taken between consecutive frames.
	    *
	    * Only calculated if {@link Phaser.Time#advancedTiming advancedTiming} is enabled.
	    * This value can be manually reset.
	    * @property {number} msMin
	    * @default
	    */this.msMin=1000;/**
	    * Advanced timing result: The maximum amount of time the game has taken between consecutive frames.
	    *
	    * Only calculated if {@link Phaser.Time#advancedTiming advancedTiming} is enabled.
	    * This value can be manually reset.
	    * @property {number} msMax
	    */this.msMax=0;/**
	    * Records how long the game was last paused, in milliseconds.
	    * (This is not updated until the game is resumed.)
	    * @property {number} pauseDuration
	    */this.pauseDuration=0;/**
	    * @property {number} timeToCall - The value that setTimeout needs to work out when to next update
	    * @protected
	    */this.timeToCall=0;/**
	    * @property {number} timeExpected - The time when the next call is expected when using setTimer to control the update loop
	    * @protected
	    */this.timeExpected=0;/**
	    * A {@link Phaser.Timer} object bound to the master clock (this Time object) which events can be added to.
	    * @property {Phaser.Timer} events
	    */this.events=new Phaser.Timer(this.game,false);/**
	    * @property {number} _frameCount - count the number of calls to time.update since the last suggestedFps was calculated
	    * @private
	    */this._frameCount=0;/**
	    * @property {number} _elapsedAcumulator - sum of the elapsed time since the last suggestedFps was calculated
	    * @private
	    */this._elapsedAccumulator=0;/**
	    * @property {number} _started - The time at which the Game instance started.
	    * @private
	    */this._started=0;/**
	    * @property {number} _timeLastSecond - The time (in ms) that the last second counter ticked over.
	    * @private
	    */this._timeLastSecond=0;/**
	    * @property {number} _pauseStarted - The time the game started being paused.
	    * @private
	    */this._pauseStarted=0;/**
	    * @property {boolean} _justResumed - Internal value used to recover from the game pause state.
	    * @private
	    */this._justResumed=false;/**
	    * @property {Phaser.Timer[]} _timers - Internal store of Phaser.Timer objects.
	    * @private
	    */this._timers=[];};Phaser.Time.prototype={/**
	    * Called automatically by Phaser.Game after boot. Should not be called directly.
	    *
	    * @method Phaser.Time#boot
	    * @protected
	    */boot:function boot(){this._started=Date.now();this.time=Date.now();this.events.start();this.timeExpected=this.time;},/**
	    * Adds an existing Phaser.Timer object to the Timer pool.
	    *
	    * @method Phaser.Time#add
	    * @param {Phaser.Timer} timer - An existing Phaser.Timer object.
	    * @return {Phaser.Timer} The given Phaser.Timer object.
	    */add:function add(timer){this._timers.push(timer);return timer;},/**
	    * Creates a new stand-alone Phaser.Timer object.
	    *
	    * @method Phaser.Time#create
	    * @param {boolean} [autoDestroy=true] - A Timer that is set to automatically destroy itself will do so after all of its events have been dispatched (assuming no looping events).
	    * @return {Phaser.Timer} The Timer object that was created.
	    */create:function create(autoDestroy){if(autoDestroy===undefined){autoDestroy=true;}var timer=new Phaser.Timer(this.game,autoDestroy);this._timers.push(timer);return timer;},/**
	    * Remove all Timer objects, regardless of their state and clears all Timers from the {@link Phaser.Time#events events} timer.
	    *
	    * @method Phaser.Time#removeAll
	    */removeAll:function removeAll(){for(var i=0;i<this._timers.length;i++){this._timers[i].destroy();}this._timers=[];this.events.removeAll();},/**
	    * Refreshes the Time.time and Time.elapsedMS properties from the system clock.
	    *
	    * @method Phaser.Time#refresh
	    */refresh:function refresh(){//  Set to the old Date.now value
	var previousDateNow=this.time;// this.time always holds a Date.now value
	this.time=Date.now();//  Adjust accordingly.
	this.elapsedMS=this.time-previousDateNow;},/**
	    * Updates the game clock and if enabled the advanced timing data. This is called automatically by Phaser.Game.
	    *
	    * @method Phaser.Time#update
	    * @protected
	    * @param {number} time - The current relative timestamp; see {@link Phaser.Time#now now}.
	    */update:function update(time){//  Set to the old Date.now value
	var previousDateNow=this.time;// this.time always holds a Date.now value
	this.time=Date.now();//  Adjust accordingly.
	this.elapsedMS=this.time-previousDateNow;// 'now' is currently still holding the time of the last call, move it into prevTime
	this.prevTime=this.now;// update 'now' to hold the current time
	// this.now may hold the RAF high resolution time value if RAF is available (otherwise it also holds Date.now)
	this.now=time;// elapsed time between previous call and now - this could be a high resolution value
	this.elapsed=this.now-this.prevTime;if(this.game.raf._isSetTimeOut){// console.log('Time isSet', this._desiredFps, 'te', this.timeExpected, 'time', time);
	// time to call this function again in ms in case we're using timers instead of RequestAnimationFrame to update the game
	this.timeToCall=Math.floor(Math.max(0,1000.0/this._desiredFps-(this.timeExpected-time)));// time when the next call is expected if using timers
	this.timeExpected=time+this.timeToCall;// console.log('Time expect', this.timeExpected);
	}if(this.advancedTiming){this.updateAdvancedTiming();}//  Paused but still running?
	if(!this.game.paused){//  Our internal Phaser.Timer
	this.events.update(this.time);if(this._timers.length){this.updateTimers();}}},/**
	    * Handles the updating of the Phaser.Timers (if any)
	    * Called automatically by Time.update.
	    *
	    * @method Phaser.Time#updateTimers
	    * @private
	    */updateTimers:function updateTimers(){//  Any game level timers
	var i=0;var len=this._timers.length;while(i<len){if(this._timers[i].update(this.time)){i++;}else{//  Timer requests to be removed
	this._timers.splice(i,1);len--;}}},/**
	    * Handles the updating of the advanced timing values (if enabled)
	    * Called automatically by Time.update.
	    *
	    * @method Phaser.Time#updateAdvancedTiming
	    * @private
	    */updateAdvancedTiming:function updateAdvancedTiming(){// count the number of time.update calls
	this._frameCount++;this._elapsedAccumulator+=this.elapsed;// occasionally recalculate the suggestedFps based on the accumulated elapsed time
	if(this._frameCount>=this._desiredFps*2){// this formula calculates suggestedFps in multiples of 5 fps
	this.suggestedFps=Math.floor(200/(this._elapsedAccumulator/this._frameCount))*5;this._frameCount=0;this._elapsedAccumulator=0;}this.msMin=Math.min(this.msMin,this.elapsed);this.msMax=Math.max(this.msMax,this.elapsed);this.frames++;if(this.now>this._timeLastSecond+1000){this.fps=Math.round(this.frames*1000/(this.now-this._timeLastSecond));this.fpsMin=Math.min(this.fpsMin,this.fps);this.fpsMax=Math.max(this.fpsMax,this.fps);this._timeLastSecond=this.now;this.frames=0;}},/**
	    * Called when the game enters a paused state.
	    *
	    * @method Phaser.Time#gamePaused
	    * @private
	    */gamePaused:function gamePaused(){this._pauseStarted=Date.now();this.events.pause();var i=this._timers.length;while(i--){this._timers[i]._pause();}},/**
	    * Called when the game resumes from a paused state.
	    *
	    * @method Phaser.Time#gameResumed
	    * @private
	    */gameResumed:function gameResumed(){// Set the parameter which stores Date.now() to make sure it's correct on resume
	this.time=Date.now();this.pauseDuration=this.time-this._pauseStarted;this.events.resume();var i=this._timers.length;while(i--){this._timers[i]._resume();}},/**
	    * The number of seconds that have elapsed since the game was started.
	    *
	    * @method Phaser.Time#totalElapsedSeconds
	    * @return {number} The number of seconds that have elapsed since the game was started.
	    */totalElapsedSeconds:function totalElapsedSeconds(){return(this.time-this._started)*0.001;},/**
	    * How long has passed since the given time.
	    *
	    * @method Phaser.Time#elapsedSince
	    * @param {number} since - The time you want to measure against.
	    * @return {number} The difference between the given time and now.
	    */elapsedSince:function elapsedSince(since){return this.time-since;},/**
	    * How long has passed since the given time (in seconds).
	    *
	    * @method Phaser.Time#elapsedSecondsSince
	    * @param {number} since - The time you want to measure (in seconds).
	    * @return {number} Duration between given time and now (in seconds).
	    */elapsedSecondsSince:function elapsedSecondsSince(since){return(this.time-since)*0.001;},/**
	    * Resets the private _started value to now and removes all currently running Timers.
	    *
	    * @method Phaser.Time#reset
	    */reset:function reset(){this._started=this.time;this.removeAll();}};/**
	* The desired frame rate of the game.
	*
	* This is used is used to calculate the physic / logic multiplier and how to apply catch-up logic updates.
	* 
	* @name Phaser.Time#desiredFps
	* @property {integer} desiredFps - The desired frame rate of the game. Defaults to 60.
	*/Object.defineProperty(Phaser.Time.prototype,"desiredFps",{get:function get(){return this._desiredFps;},set:function set(value){this._desiredFps=value;//  Set the physics elapsed time... this will always be 1 / this.desiredFps 
	//  because we're using fixed time steps in game.update
	this.physicsElapsed=1/value;this.physicsElapsedMS=this.physicsElapsed*1000;this.desiredFpsMult=1.0/value;}});Phaser.Time.prototype.constructor=Phaser.Time;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A Timer is a way to create and manage {@link Phaser.TimerEvent timer events} that wait for a specific duration and then run a callback.
	* Many different timer events, with individual delays, can be added to the same Timer.
	*
	* All Timer delays are in milliseconds (there are 1000 ms in 1 second); so a delay value of 250 represents a quarter of a second.
	*
	* Timers are based on real life time, adjusted for game pause durations.
	* That is, *timer events are based on elapsed {@link Phaser.Time game time}* and do *not* take physics time or slow motion into account.
	*
	* @class Phaser.Timer
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {boolean} [autoDestroy=true] - If true, the timer will automatically destroy itself after all the events have been dispatched (assuming no looping events).
	*/Phaser.Timer=function(game,autoDestroy){if(autoDestroy===undefined){autoDestroy=true;}/**
	    * @property {Phaser.Game} game - Local reference to game.
	    * @protected
	    */this.game=game;/**
	    * True if the Timer is actively running.
	    *
	    * Do not modify this boolean - use {@link Phaser.Timer#pause pause} (and {@link Phaser.Timer#resume resume}) to pause the timer.
	    * @property {boolean} running
	    * @default
	    * @readonly
	    */this.running=false;/**
	    * If true, the timer will automatically destroy itself after all the events have been dispatched (assuming no looping events).
	    * @property {boolean} autoDestroy
	    */this.autoDestroy=autoDestroy;/**
	    * @property {boolean} expired - An expired Timer is one in which all of its events have been dispatched and none are pending.
	    * @readonly
	    * @default
	    */this.expired=false;/**
	    * @property {number} elapsed - Elapsed time since the last frame (in ms).
	    * @protected
	    */this.elapsed=0;/**
	    * @property {Phaser.TimerEvent[]} events - An array holding all of this timers Phaser.TimerEvent objects. Use the methods add, repeat and loop to populate it.
	    */this.events=[];/**
	    * This signal will be dispatched when this Timer has completed which means that there are no more events in the queue.
	    *
	    * The signal is supplied with one argument, `timer`, which is this Timer object.
	    *
	    * @property {Phaser.Signal} onComplete
	    */this.onComplete=new Phaser.Signal();/**
	    * @property {number} nextTick - The time the next tick will occur.
	    * @readonly
	    * @protected
	    */this.nextTick=0;/**
	    * @property {number} timeCap - If the difference in time between two frame updates exceeds this value, the event times are reset to avoid catch-up situations.
	    */this.timeCap=1000;/**
	    * @property {boolean} paused - The paused state of the Timer. You can pause the timer by calling Timer.pause() and Timer.resume() or by the game pausing.
	    * @readonly
	    * @default
	    */this.paused=false;/**
	    * @property {boolean} _codePaused - Was the Timer paused by code or by Game focus loss?
	    * @private
	    */this._codePaused=false;/**
	    * @property {number} _started - The time at which this Timer instance started running.
	    * @private
	    * @default
	    */this._started=0;/**
	    * @property {number} _pauseStarted - The time the game started being paused.
	    * @private
	    */this._pauseStarted=0;/**
	    * @property {number} _pauseTotal - Total paused time.
	    * @private
	    */this._pauseTotal=0;/**
	    * @property {number} _now - The current start-time adjusted time.
	    * @private
	    */this._now=Date.now();/**
	    * @property {number} _len - Temp. array length variable.
	    * @private
	    */this._len=0;/**
	    * @property {number} _marked - Temp. counter variable.
	    * @private
	    */this._marked=0;/**
	    * @property {number} _i - Temp. array counter variable.
	    * @private
	    */this._i=0;/**
	    * @property {number} _diff - Internal cache var.
	    * @private
	    */this._diff=0;/**
	    * @property {number} _newTick - Internal cache var.
	    * @private
	    */this._newTick=0;};/**
	* Number of milliseconds in a minute.
	* @constant
	* @type {integer}
	*/Phaser.Timer.MINUTE=60000;/**
	* Number of milliseconds in a second.
	* @constant
	* @type {integer}
	*/Phaser.Timer.SECOND=1000;/**
	* Number of milliseconds in half a second.
	* @constant
	* @type {integer}
	*/Phaser.Timer.HALF=500;/**
	* Number of milliseconds in a quarter of a second.
	* @constant
	* @type {integer}
	*/Phaser.Timer.QUARTER=250;Phaser.Timer.prototype={/**
	    * Creates a new TimerEvent on this Timer.
	    *
	    * Use {@link Phaser.Timer#add}, {@link Phaser.Timer#repeat}, or {@link Phaser.Timer#loop} methods to create a new event.
	    *
	    * @method Phaser.Timer#create
	    * @private
	    * @param {integer} delay - The number of milliseconds, in {@link Phaser.Time game time}, before the timer event occurs.
	    * @param {boolean} loop - Should the event loop or not?
	    * @param {number} repeatCount - The number of times the event will repeat.
	    * @param {function} callback - The callback that will be called when the timer event occurs.
	    * @param {object} callbackContext - The context in which the callback will be called.
	    * @param {any[]} arguments - The values to be sent to your callback function when it is called.
	    * @return {Phaser.TimerEvent} The Phaser.TimerEvent object that was created.
	    */create:function create(delay,loop,repeatCount,callback,callbackContext,args){delay=Math.round(delay);var tick=delay;if(this._now===0){tick+=this.game.time.time;}else{tick+=this._now;}var event=new Phaser.TimerEvent(this,delay,tick,repeatCount,loop,callback,callbackContext,args);this.events.push(event);this.order();this.expired=false;return event;},/**
	    * Adds a new Event to this Timer.
	    *
	    * The event will fire after the given amount of `delay` in milliseconds has passed, once the Timer has started running.
	    * The delay is in relation to when the Timer starts, not the time it was added. If the Timer is already running the delay will be calculated based on the timers current time.
	    *
	    * Make sure to call {@link Phaser.Timer#start start} after adding all of the Events you require for this Timer.
	    *
	    * @method Phaser.Timer#add
	    * @param {integer} delay - The number of milliseconds, in {@link Phaser.Time game time}, before the timer event occurs.
	    * @param {function} callback - The callback that will be called when the timer event occurs.
	    * @param {object} callbackContext - The context in which the callback will be called.
	    * @param {...*} arguments - Additional arguments that will be supplied to the callback.
	    * @return {Phaser.TimerEvent} The Phaser.TimerEvent object that was created.
	    */add:function add(delay,callback,callbackContext){return this.create(delay,false,0,callback,callbackContext,Array.prototype.slice.call(arguments,3));},/**
	    * Adds a new TimerEvent that will always play through once and then repeat for the given number of iterations.
	    *
	    * The event will fire after the given amount of `delay` in milliseconds has passed, once the Timer has started running.
	    * The delay is in relation to when the Timer starts, not the time it was added.
	    * If the Timer is already running the delay will be calculated based on the timers current time.
	    *
	    * Make sure to call {@link Phaser.Timer#start start} after adding all of the Events you require for this Timer.
	    *
	    * @method Phaser.Timer#repeat
	    * @param {integer} delay - The number of milliseconds, in {@link Phaser.Time game time}, before the timer event occurs.
	    * @param {number} repeatCount - The number of times the event will repeat once is has finished playback. A repeatCount of 1 means it will repeat itself once, playing the event twice in total.
	    * @param {function} callback - The callback that will be called when the timer event occurs.
	    * @param {object} callbackContext - The context in which the callback will be called.
	    * @param {...*} arguments - Additional arguments that will be supplied to the callback.
	    * @return {Phaser.TimerEvent} The Phaser.TimerEvent object that was created.
	    */repeat:function repeat(delay,repeatCount,callback,callbackContext){return this.create(delay,false,repeatCount,callback,callbackContext,Array.prototype.slice.call(arguments,4));},/**
	    * Adds a new looped Event to this Timer that will repeat forever or until the Timer is stopped.
	    *
	    * The event will fire after the given amount of `delay` in milliseconds has passed, once the Timer has started running.
	    * The delay is in relation to when the Timer starts, not the time it was added. If the Timer is already running the delay will be calculated based on the timers current time.
	    *
	    * Make sure to call {@link Phaser.Timer#start start} after adding all of the Events you require for this Timer.
	    *
	    * @method Phaser.Timer#loop
	    * @param {integer} delay - The number of milliseconds, in {@link Phaser.Time game time}, before the timer event occurs.
	    * @param {function} callback - The callback that will be called when the timer event occurs.
	    * @param {object} callbackContext - The context in which the callback will be called.
	    * @param {...*} arguments - Additional arguments that will be supplied to the callback.
	    * @return {Phaser.TimerEvent} The Phaser.TimerEvent object that was created.
	    */loop:function loop(delay,callback,callbackContext){return this.create(delay,true,0,callback,callbackContext,Array.prototype.slice.call(arguments,3));},/**
	    * Starts this Timer running.
	    * @method Phaser.Timer#start
	    * @param {integer} [delay=0] - The number of milliseconds, in {@link Phaser.Time game time}, that should elapse before the Timer will start.
	    */start:function start(delay){if(this.running){return;}this._started=this.game.time.time+(delay||0);this.running=true;for(var i=0;i<this.events.length;i++){this.events[i].tick=this.events[i].delay+this._started;}},/**
	    * Stops this Timer from running. Does not cause it to be destroyed if autoDestroy is set to true.
	    * @method Phaser.Timer#stop
	    * @param {boolean} [clearEvents=true] - If true all the events in Timer will be cleared, otherwise they will remain.
	    */stop:function stop(clearEvents){this.running=false;if(clearEvents===undefined){clearEvents=true;}if(clearEvents){this.events.length=0;}},/**
	    * Removes a pending TimerEvent from the queue.
	    * @param {Phaser.TimerEvent} event - The event to remove from the queue.
	    * @method Phaser.Timer#remove
	    */remove:function remove(event){for(var i=0;i<this.events.length;i++){if(this.events[i]===event){this.events[i].pendingDelete=true;return true;}}return false;},/**
	    * Orders the events on this Timer so they are in tick order.
	    * This is called automatically when new events are created.
	    * @method Phaser.Timer#order
	    * @protected
	    */order:function order(){if(this.events.length>0){//  Sort the events so the one with the lowest tick is first
	this.events.sort(this.sortHandler);this.nextTick=this.events[0].tick;}},/**
	    * Sort handler used by Phaser.Timer.order.
	    * @method Phaser.Timer#sortHandler
	    * @private
	    */sortHandler:function sortHandler(a,b){if(a.tick<b.tick){return-1;}else if(a.tick>b.tick){return 1;}return 0;},/**
	    * Clears any events from the Timer which have pendingDelete set to true and then resets the private _len and _i values.
	    *
	    * @method Phaser.Timer#clearPendingEvents
	    * @protected
	    */clearPendingEvents:function clearPendingEvents(){this._i=this.events.length;while(this._i--){if(this.events[this._i].pendingDelete){this.events.splice(this._i,1);}}this._len=this.events.length;this._i=0;},/**
	    * The main Timer update event, called automatically by Phaser.Time.update.
	    *
	    * @method Phaser.Timer#update
	    * @protected
	    * @param {number} time - The time from the core game clock.
	    * @return {boolean} True if there are still events waiting to be dispatched, otherwise false if this Timer can be destroyed.
	    */update:function update(time){if(this.paused){return true;}this.elapsed=time-this._now;this._now=time;//  spike-dislike
	if(this.elapsed>this.timeCap){//  For some reason the time between now and the last time the game was updated was larger than our timeCap.
	//  This can happen if the Stage.disableVisibilityChange is true and you swap tabs, which makes the raf pause.
	//  In this case we need to adjust the TimerEvents and nextTick.
	this.adjustEvents(time-this.elapsed);}this._marked=0;//  Clears events marked for deletion and resets _len and _i to 0.
	this.clearPendingEvents();if(this.running&&this._now>=this.nextTick&&this._len>0){while(this._i<this._len&&this.running){if(this._now>=this.events[this._i].tick&&!this.events[this._i].pendingDelete){//  (now + delay) - (time difference from last tick to now)
	this._newTick=this._now+this.events[this._i].delay-(this._now-this.events[this._i].tick);if(this._newTick<0){this._newTick=this._now+this.events[this._i].delay;}if(this.events[this._i].loop===true){this.events[this._i].tick=this._newTick;this.events[this._i].callback.apply(this.events[this._i].callbackContext,this.events[this._i].args);}else if(this.events[this._i].repeatCount>0){this.events[this._i].repeatCount--;this.events[this._i].tick=this._newTick;this.events[this._i].callback.apply(this.events[this._i].callbackContext,this.events[this._i].args);}else{this._marked++;this.events[this._i].pendingDelete=true;this.events[this._i].callback.apply(this.events[this._i].callbackContext,this.events[this._i].args);}this._i++;}else{break;}}//  Are there any events left?
	if(this.events.length>this._marked){this.order();}else{this.expired=true;this.onComplete.dispatch(this);}}if(this.expired&&this.autoDestroy){return false;}else{return true;}},/**
	    * Pauses the Timer and all events in the queue.
	    * @method Phaser.Timer#pause
	    */pause:function pause(){if(!this.running){return;}this._codePaused=true;if(this.paused){return;}this._pauseStarted=this.game.time.time;this.paused=true;},/**
	    * Internal pause/resume control - user code should use Timer.pause instead.
	    * @method Phaser.Timer#_pause
	    * @private
	    */_pause:function _pause(){if(this.paused||!this.running){return;}this._pauseStarted=this.game.time.time;this.paused=true;},/**
	    * Adjusts the time of all pending events and the nextTick by the given baseTime.
	    *
	    * @method Phaser.Timer#adjustEvents
	    * @protected
	    */adjustEvents:function adjustEvents(baseTime){for(var i=0;i<this.events.length;i++){if(!this.events[i].pendingDelete){//  Work out how long there would have been from when the game paused until the events next tick
	var t=this.events[i].tick-baseTime;if(t<0){t=0;}//  Add the difference on to the time now
	this.events[i].tick=this._now+t;}}var d=this.nextTick-baseTime;if(d<0){this.nextTick=this._now;}else{this.nextTick=this._now+d;}},/**
	    * Resumes the Timer and updates all pending events.
	    *
	    * @method Phaser.Timer#resume
	    */resume:function resume(){if(!this.paused){return;}var now=this.game.time.time;this._pauseTotal+=now-this._now;this._now=now;this.adjustEvents(this._pauseStarted);this.paused=false;this._codePaused=false;},/**
	    * Internal pause/resume control - user code should use Timer.resume instead.
	    * @method Phaser.Timer#_resume
	    * @private
	    */_resume:function _resume(){if(this._codePaused){return;}else{this.resume();}},/**
	    * Removes all Events from this Timer and all callbacks linked to onComplete, but leaves the Timer running.    
	    * The onComplete callbacks won't be called.
	    *
	    * @method Phaser.Timer#removeAll
	    */removeAll:function removeAll(){this.onComplete.removeAll();this.events.length=0;this._len=0;this._i=0;},/**
	    * Destroys this Timer. Any pending Events are not dispatched.
	    * The onComplete callbacks won't be called.
	    *
	    * @method Phaser.Timer#destroy
	    */destroy:function destroy(){this.onComplete.removeAll();this.running=false;this.events=[];this._len=0;this._i=0;}};/**
	* @name Phaser.Timer#next
	* @property {number} next - The time at which the next event will occur.
	* @readonly
	*/Object.defineProperty(Phaser.Timer.prototype,"next",{get:function get(){return this.nextTick;}});/**
	* @name Phaser.Timer#duration
	* @property {number} duration - The duration in ms remaining until the next event will occur.
	* @readonly
	*/Object.defineProperty(Phaser.Timer.prototype,"duration",{get:function get(){if(this.running&&this.nextTick>this._now){return this.nextTick-this._now;}else{return 0;}}});/**
	* @name Phaser.Timer#length
	* @property {number} length - The number of pending events in the queue.
	* @readonly
	*/Object.defineProperty(Phaser.Timer.prototype,"length",{get:function get(){return this.events.length;}});/**
	* @name Phaser.Timer#ms
	* @property {number} ms - The duration in milliseconds that this Timer has been running for.
	* @readonly
	*/Object.defineProperty(Phaser.Timer.prototype,"ms",{get:function get(){if(this.running){return this._now-this._started-this._pauseTotal;}else{return 0;}}});/**
	* @name Phaser.Timer#seconds
	* @property {number} seconds - The duration in seconds that this Timer has been running for.
	* @readonly
	*/Object.defineProperty(Phaser.Timer.prototype,"seconds",{get:function get(){if(this.running){return this.ms*0.001;}else{return 0;}}});Phaser.Timer.prototype.constructor=Phaser.Timer;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A TimerEvent is a single event that is processed by a Phaser.Timer.
	*
	* It consists of a delay, which is a value in milliseconds after which the event will fire.
	* When the event fires it calls a specific callback with the specified arguments.
	* 
	* TimerEvents are removed by their parent timer once finished firing or repeating.
	* 
	* Use {@link Phaser.Timer#add}, {@link Phaser.Timer#repeat}, or {@link Phaser.Timer#loop} methods to create a new event.
	*
	* @class Phaser.TimerEvent
	* @constructor
	* @param {Phaser.Timer} timer - The Timer object that this TimerEvent belongs to.
	* @param {number} delay - The delay in ms at which this TimerEvent fires.
	* @param {number} tick - The tick is the next game clock time that this event will fire at.
	* @param {number} repeatCount - If this TimerEvent repeats it will do so this many times.
	* @param {boolean} loop - True if this TimerEvent loops, otherwise false.
	* @param {function} callback - The callback that will be called when the TimerEvent occurs.
	* @param {object} callbackContext - The context in which the callback will be called.
	* @param {any[]} arguments - Additional arguments to be passed to the callback.
	*/Phaser.TimerEvent=function(timer,delay,tick,repeatCount,loop,callback,callbackContext,args){/**
	    * @property {Phaser.Timer} timer - The Timer object that this TimerEvent belongs to.
	    * @protected
	    * @readonly
	    */this.timer=timer;/**
	    * @property {number} delay - The delay in ms at which this TimerEvent fires.
	    */this.delay=delay;/**
	    * @property {number} tick - The tick is the next game clock time that this event will fire at.
	    */this.tick=tick;/**
	    * @property {number} repeatCount - If this TimerEvent repeats it will do so this many times.
	    */this.repeatCount=repeatCount-1;/**
	    * @property {boolean} loop - True if this TimerEvent loops, otherwise false.
	    */this.loop=loop;/**
	    * @property {function} callback - The callback that will be called when the TimerEvent occurs.
	    */this.callback=callback;/**
	    * @property {object} callbackContext - The context in which the callback will be called.
	    */this.callbackContext=callbackContext;/**
	    * @property {any[]} arguments - Additional arguments to be passed to the callback.
	    */this.args=args;/**
	    * @property {boolean} pendingDelete - A flag that controls if the TimerEvent is pending deletion.
	    * @protected
	    */this.pendingDelete=false;};Phaser.TimerEvent.prototype.constructor=Phaser.TimerEvent;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Animation Manager is used to add, play and update Phaser Animations.
	* Any Game Object such as Phaser.Sprite that supports animation contains a single AnimationManager instance.
	*
	* @class Phaser.AnimationManager
	* @constructor
	* @param {Phaser.Sprite} sprite - A reference to the Game Object that owns this AnimationManager.
	*/Phaser.AnimationManager=function(sprite){/**
	    * @property {Phaser.Sprite} sprite - A reference to the parent Sprite that owns this AnimationManager.
	    */this.sprite=sprite;/**
	    * @property {Phaser.Game} game - A reference to the currently running Game.
	    */this.game=sprite.game;/**
	    * The currently displayed Frame of animation, if any.
	    * This property is only set once an Animation starts playing. Until that point it remains set as `null`.
	    * 
	    * @property {Phaser.Frame} currentFrame
	    * @default
	    */this.currentFrame=null;/**
	    * @property {Phaser.Animation} currentAnim - The currently displayed animation, if any.
	    * @default
	    */this.currentAnim=null;/**
	    * @property {boolean} updateIfVisible - Should the animation data continue to update even if the Sprite.visible is set to false.
	    * @default
	    */this.updateIfVisible=true;/**
	    * @property {boolean} isLoaded - Set to true once animation data has been loaded.
	    * @default
	    */this.isLoaded=false;/**
	    * @property {Phaser.FrameData} _frameData - A temp. var for holding the currently playing Animations FrameData.
	    * @private
	    * @default
	    */this._frameData=null;/**
	    * @property {object} _anims - An internal object that stores all of the Animation instances.
	    * @private
	    */this._anims={};/**
	    * @property {object} _outputFrames - An internal object to help avoid gc.
	    * @private
	    */this._outputFrames=[];};Phaser.AnimationManager.prototype={/**
	    * Loads FrameData into the internal temporary vars and resets the frame index to zero.
	    * This is called automatically when a new Sprite is created.
	    *
	    * @method Phaser.AnimationManager#loadFrameData
	    * @private
	    * @param {Phaser.FrameData} frameData - The FrameData set to load.
	    * @param {string|number} frame - The frame to default to.
	    * @return {boolean} Returns `true` if the frame data was loaded successfully, otherwise `false`
	    */loadFrameData:function loadFrameData(frameData,frame){if(frameData===undefined){return false;}if(this.isLoaded){//   We need to update the frameData that the animations are using
	for(var anim in this._anims){this._anims[anim].updateFrameData(frameData);}}this._frameData=frameData;if(frame===undefined||frame===null){this.frame=0;}else{if(typeof frame==='string'){this.frameName=frame;}else{this.frame=frame;}}this.isLoaded=true;return true;},/**
	    * Loads FrameData into the internal temporary vars and resets the frame index to zero.
	    * This is called automatically when a new Sprite is created.
	    *
	    * @method Phaser.AnimationManager#copyFrameData
	    * @private
	    * @param {Phaser.FrameData} frameData - The FrameData set to load.
	    * @param {string|number} frame - The frame to default to.
	    * @return {boolean} Returns `true` if the frame data was loaded successfully, otherwise `false`
	    */copyFrameData:function copyFrameData(frameData,frame){this._frameData=frameData.clone();if(this.isLoaded){//   We need to update the frameData that the animations are using
	for(var anim in this._anims){this._anims[anim].updateFrameData(this._frameData);}}if(frame===undefined||frame===null){this.frame=0;}else{if(typeof frame==='string'){this.frameName=frame;}else{this.frame=frame;}}this.isLoaded=true;return true;},/**
	    * Adds a new animation under the given key. Optionally set the frames, frame rate and loop.
	    * Animations added in this way are played back with the play function.
	    *
	    * @method Phaser.AnimationManager#add
	    * @param {string} name - The unique (within this Sprite) name for the animation, i.e. "run", "fire", "walk".
	    * @param {Array} [frames=null] - An array of numbers/strings that correspond to the frames to add to this animation and in which order. e.g. [1, 2, 3] or ['run0', 'run1', run2]). If null then all frames will be used.
	    * @param {number} [frameRate=60] - The speed at which the animation should play. The speed is given in frames per second.
	    * @param {boolean} [loop=false] - Whether or not the animation is looped or just plays once.
	    * @param {boolean} [useNumericIndex=true] - Are the given frames using numeric indexes (default) or strings?
	    * @return {Phaser.Animation} The Animation object that was created.
	    */add:function add(name,frames,frameRate,loop,useNumericIndex){frames=frames||[];frameRate=frameRate||60;if(loop===undefined){loop=false;}//  If they didn't set the useNumericIndex then let's at least try and guess it
	if(useNumericIndex===undefined){if(frames&&typeof frames[0]==='number'){useNumericIndex=true;}else{useNumericIndex=false;}}this._outputFrames=[];this._frameData.getFrameIndexes(frames,useNumericIndex,this._outputFrames);this._anims[name]=new Phaser.Animation(this.game,this.sprite,name,this._frameData,this._outputFrames,frameRate,loop);this.currentAnim=this._anims[name];if(this.sprite.tilingTexture){this.sprite.refreshTexture=true;}return this._anims[name];},/**
	    * Check whether the frames in the given array are valid and exist.
	    *
	    * @method Phaser.AnimationManager#validateFrames
	    * @param {Array} frames - An array of frames to be validated.
	    * @param {boolean} [useNumericIndex=true] - Validate the frames based on their numeric index (true) or string index (false)
	    * @return {boolean} True if all given Frames are valid, otherwise false.
	    */validateFrames:function validateFrames(frames,useNumericIndex){if(useNumericIndex===undefined){useNumericIndex=true;}for(var i=0;i<frames.length;i++){if(useNumericIndex===true){if(frames[i]>this._frameData.total){return false;}}else{if(this._frameData.checkFrameName(frames[i])===false){return false;}}}return true;},/**
	    * Play an animation based on the given key. The animation should previously have been added via `animations.add`
	    * 
	    * If the requested animation is already playing this request will be ignored. 
	    * If you need to reset an already running animation do so directly on the Animation object itself.
	    *
	    * @method Phaser.AnimationManager#play
	    * @param {string} name - The name of the animation to be played, e.g. "fire", "walk", "jump".
	    * @param {number} [frameRate=null] - The framerate to play the animation at. The speed is given in frames per second. If not provided the previously set frameRate of the Animation is used.
	    * @param {boolean} [loop=false] - Should the animation be looped after playback. If not provided the previously set loop value of the Animation is used.
	    * @param {boolean} [killOnComplete=false] - If set to true when the animation completes (only happens if loop=false) the parent Sprite will be killed.
	    * @return {Phaser.Animation} A reference to playing Animation instance.
	    */play:function play(name,frameRate,loop,killOnComplete){if(this._anims[name]){if(this.currentAnim===this._anims[name]){if(this.currentAnim.isPlaying===false){this.currentAnim.paused=false;return this.currentAnim.play(frameRate,loop,killOnComplete);}return this.currentAnim;}else{if(this.currentAnim&&this.currentAnim.isPlaying){this.currentAnim.stop();}this.currentAnim=this._anims[name];this.currentAnim.paused=false;this.currentFrame=this.currentAnim.currentFrame;return this.currentAnim.play(frameRate,loop,killOnComplete);}}},/**
	    * Stop playback of an animation. If a name is given that specific animation is stopped, otherwise the current animation is stopped.
	    * The currentAnim property of the AnimationManager is automatically set to the animation given.
	    *
	    * @method Phaser.AnimationManager#stop
	    * @param {string} [name=null] - The name of the animation to be stopped, e.g. "fire". If none is given the currently running animation is stopped.
	    * @param {boolean} [resetFrame=false] - When the animation is stopped should the currentFrame be set to the first frame of the animation (true) or paused on the last frame displayed (false)
	    */stop:function stop(name,resetFrame){if(resetFrame===undefined){resetFrame=false;}if(this.currentAnim&&(typeof name!=='string'||name===this.currentAnim.name)){this.currentAnim.stop(resetFrame);}},/**
	    * The main update function is called by the Sprites update loop. It's responsible for updating animation frames and firing related events.
	    *
	    * @method Phaser.AnimationManager#update
	    * @protected
	    * @return {boolean} True if a new animation frame has been set, otherwise false.
	    */update:function update(){if(this.updateIfVisible&&!this.sprite.visible){return false;}if(this.currentAnim&&this.currentAnim.update()){this.currentFrame=this.currentAnim.currentFrame;return true;}return false;},/**
	    * Advances by the given number of frames in the current animation, taking the loop value into consideration.
	    *
	    * @method Phaser.AnimationManager#next
	    * @param {number} [quantity=1] - The number of frames to advance.
	    */next:function next(quantity){if(this.currentAnim){this.currentAnim.next(quantity);this.currentFrame=this.currentAnim.currentFrame;}},/**
	    * Moves backwards the given number of frames in the current animation, taking the loop value into consideration.
	    *
	    * @method Phaser.AnimationManager#previous
	    * @param {number} [quantity=1] - The number of frames to move back.
	    */previous:function previous(quantity){if(this.currentAnim){this.currentAnim.previous(quantity);this.currentFrame=this.currentAnim.currentFrame;}},/**
	    * Returns an animation that was previously added by name.
	    *
	    * @method Phaser.AnimationManager#getAnimation
	    * @param {string} name - The name of the animation to be returned, e.g. "fire".
	    * @return {Phaser.Animation} The Animation instance, if found, otherwise null.
	    */getAnimation:function getAnimation(name){if(typeof name==='string'){if(this._anims[name]){return this._anims[name];}}return null;},/**
	    * Refreshes the current frame data back to the parent Sprite and also resets the texture data.
	    *
	    * @method Phaser.AnimationManager#refreshFrame
	    */refreshFrame:function refreshFrame(){//  TODO
	// this.sprite.setTexture(PIXI.TextureCache[this.currentFrame.uuid]);
	},/**
	    * Destroys all references this AnimationManager contains.
	    * Iterates through the list of animations stored in this manager and calls destroy on each of them.
	    *
	    * @method Phaser.AnimationManager#destroy
	    */destroy:function destroy(){var anim=null;for(var anim in this._anims){if(this._anims.hasOwnProperty(anim)){this._anims[anim].destroy();}}this._anims={};this._outputFrames=[];this._frameData=null;this.currentAnim=null;this.currentFrame=null;this.sprite=null;this.game=null;}};Phaser.AnimationManager.prototype.constructor=Phaser.AnimationManager;/**
	* @name Phaser.AnimationManager#frameData
	* @property {Phaser.FrameData} frameData - The current animations FrameData.
	* @readonly
	*/Object.defineProperty(Phaser.AnimationManager.prototype,'frameData',{get:function get(){return this._frameData;}});/**
	* @name Phaser.AnimationManager#frameTotal
	* @property {number} frameTotal - The total number of frames in the currently loaded FrameData, or -1 if no FrameData is loaded.
	* @readonly
	*/Object.defineProperty(Phaser.AnimationManager.prototype,'frameTotal',{get:function get(){return this._frameData.total;}});/**
	* @name Phaser.AnimationManager#paused
	* @property {boolean} paused - Gets and sets the paused state of the current animation.
	*/Object.defineProperty(Phaser.AnimationManager.prototype,'paused',{get:function get(){return this.currentAnim.isPaused;},set:function set(value){this.currentAnim.paused=value;}});/**
	* @name Phaser.AnimationManager#name
	* @property {string} name - Gets the current animation name, if set.
	*/Object.defineProperty(Phaser.AnimationManager.prototype,'name',{get:function get(){if(this.currentAnim){return this.currentAnim.name;}}});/**
	* @name Phaser.AnimationManager#frame
	* @property {number} frame - Gets or sets the current frame index and updates the Texture Cache for display.
	*/Object.defineProperty(Phaser.AnimationManager.prototype,'frame',{get:function get(){if(this.currentFrame){return this.currentFrame.index;}},set:function set(value){if(typeof value==='number'&&this._frameData&&this._frameData.getFrame(value)!==null){this.currentFrame=this._frameData.getFrame(value);if(this.currentFrame){this.sprite.setFrame(this.currentFrame);}}}});/**
	* @name Phaser.AnimationManager#frameName
	* @property {string} frameName - Gets or sets the current frame name and updates the Texture Cache for display.
	*/Object.defineProperty(Phaser.AnimationManager.prototype,'frameName',{get:function get(){if(this.currentFrame){return this.currentFrame.name;}},set:function set(value){if(typeof value==='string'&&this._frameData&&this._frameData.getFrameByName(value)!==null){this.currentFrame=this._frameData.getFrameByName(value);if(this.currentFrame){this._frameIndex=this.currentFrame.index;this.sprite.setFrame(this.currentFrame);}}else{console.warn('Cannot set frameName: '+value);}}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* An Animation instance contains a single animation and the controls to play it.
	*
	* It is created by the AnimationManager, consists of Animation.Frame objects and belongs to a single Game Object such as a Sprite.
	*
	* @class Phaser.Animation
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {Phaser.Sprite} parent - A reference to the owner of this Animation.
	* @param {string} name - The unique name for this animation, used in playback commands.
	* @param {Phaser.FrameData} frameData - The FrameData object that contains all frames used by this Animation.
	* @param {number[]|string[]} frames - An array of numbers or strings indicating which frames to play in which order.
	* @param {number} [frameRate=60] - The speed at which the animation should play. The speed is given in frames per second.
	* @param {boolean} [loop=false] - Whether or not the animation is looped or just plays once.
	*/Phaser.Animation=function(game,parent,name,frameData,frames,frameRate,loop){if(loop===undefined){loop=false;}/**
	    * @property {Phaser.Game} game - A reference to the currently running Game.
	    */this.game=game;/**
	    * @property {Phaser.Sprite} _parent - A reference to the parent Sprite that owns this Animation.
	    * @private
	    */this._parent=parent;/**
	    * @property {Phaser.FrameData} _frameData - The FrameData the Animation uses.
	    * @private
	    */this._frameData=frameData;/**
	    * @property {string} name - The user defined name given to this Animation.
	    */this.name=name;/**
	    * @property {array} _frames
	    * @private
	    */this._frames=[];this._frames=this._frames.concat(frames);/**
	    * @property {number} delay - The delay in ms between each frame of the Animation, based on the given frameRate.
	    */this.delay=1000/frameRate;/**
	    * @property {boolean} loop - The loop state of the Animation.
	    */this.loop=loop;/**
	    * @property {number} loopCount - The number of times the animation has looped since it was last started.
	    */this.loopCount=0;/**
	    * @property {boolean} killOnComplete - Should the parent of this Animation be killed when the animation completes?
	    * @default
	    */this.killOnComplete=false;/**
	    * @property {boolean} isFinished - The finished state of the Animation. Set to true once playback completes, false during playback.
	    * @default
	    */this.isFinished=false;/**
	    * @property {boolean} isPlaying - The playing state of the Animation. Set to false once playback completes, true during playback.
	    * @default
	    */this.isPlaying=false;/**
	    * @property {boolean} isPaused - The paused state of the Animation.
	    * @default
	    */this.isPaused=false;/**
	    * @property {boolean} _pauseStartTime - The time the animation paused.
	    * @private
	    * @default
	    */this._pauseStartTime=0;/**
	    * @property {number} _frameIndex
	    * @private
	    * @default
	    */this._frameIndex=0;/**
	    * @property {number} _frameDiff
	    * @private
	    * @default
	    */this._frameDiff=0;/**
	    * @property {number} _frameSkip
	    * @private
	    * @default
	    */this._frameSkip=1;/**
	    * @property {Phaser.Frame} currentFrame - The currently displayed frame of the Animation.
	    */this.currentFrame=this._frameData.getFrame(this._frames[this._frameIndex]);/**
	    * @property {Phaser.Signal} onStart - This event is dispatched when this Animation starts playback.
	    */this.onStart=new Phaser.Signal();/**
	    * This event is dispatched when the Animation changes frame.
	    * By default this event is disabled due to its intensive nature. Enable it with: `Animation.enableUpdate = true`.
	    * Note that the event is only dispatched with the current frame. In a low-FPS environment Animations
	    * will automatically frame-skip to try and claw back time, so do not base your code on expecting to
	    * receive a perfectly sequential set of frames from this event.
	    * @property {Phaser.Signal|null} onUpdate
	    * @default
	    */this.onUpdate=null;/**
	    * @property {Phaser.Signal} onComplete - This event is dispatched when this Animation completes playback. If the animation is set to loop this is never fired, listen for onLoop instead.
	    */this.onComplete=new Phaser.Signal();/**
	    * @property {Phaser.Signal} onLoop - This event is dispatched when this Animation loops.
	    */this.onLoop=new Phaser.Signal();/**
	     * @property {boolean} isReversed - Indicates if the animation will play backwards.
	     * @default
	     */this.isReversed=false;//  Set-up some event listeners
	this.game.onPause.add(this.onPause,this);this.game.onResume.add(this.onResume,this);};Phaser.Animation.prototype={/**
	    * Plays this animation.
	    *
	    * @method Phaser.Animation#play
	    * @param {number} [frameRate=null] - The framerate to play the animation at. The speed is given in frames per second. If not provided the previously set frameRate of the Animation is used.
	    * @param {boolean} [loop=false] - Should the animation be looped after playback. If not provided the previously set loop value of the Animation is used.
	    * @param {boolean} [killOnComplete=false] - If set to true when the animation completes (only happens if loop=false) the parent Sprite will be killed.
	    * @return {Phaser.Animation} - A reference to this Animation instance.
	    */play:function play(frameRate,loop,killOnComplete){if(typeof frameRate==='number'){//  If they set a new frame rate then use it, otherwise use the one set on creation
	this.delay=1000/frameRate;}if(typeof loop==='boolean'){//  If they set a new loop value then use it, otherwise use the one set on creation
	this.loop=loop;}if(typeof killOnComplete!=='undefined'){//  Remove the parent sprite once the animation has finished?
	this.killOnComplete=killOnComplete;}this.isPlaying=true;this.isFinished=false;this.paused=false;this.loopCount=0;this._timeLastFrame=this.game.time.time;this._timeNextFrame=this.game.time.time+this.delay;this._frameIndex=this.isReversed?this._frames.length-1:0;this.updateCurrentFrame(false,true);this._parent.events.onAnimationStart$dispatch(this._parent,this);this.onStart.dispatch(this._parent,this);this._parent.animations.currentAnim=this;this._parent.animations.currentFrame=this.currentFrame;return this;},/**
	    * Sets this animation back to the first frame and restarts the animation.
	    *
	    * @method Phaser.Animation#restart
	    */restart:function restart(){this.isPlaying=true;this.isFinished=false;this.paused=false;this.loopCount=0;this._timeLastFrame=this.game.time.time;this._timeNextFrame=this.game.time.time+this.delay;this._frameIndex=0;this.currentFrame=this._frameData.getFrame(this._frames[this._frameIndex]);this._parent.setFrame(this.currentFrame);this._parent.animations.currentAnim=this;this._parent.animations.currentFrame=this.currentFrame;this.onStart.dispatch(this._parent,this);},/**
	    * Reverses the animation direction.
	    *
	    * @method Phaser.Animation#reverse
	    * @return {Phaser.Animation} The animation instance.
	    */reverse:function reverse(){this.reversed=!this.reversed;return this;},/**
	    * Reverses the animation direction for the current/next animation only
	    * Once the onComplete event is called this method will be called again and revert
	    * the reversed state.
	    *
	    * @method Phaser.Animation#reverseOnce
	    * @return {Phaser.Animation} The animation instance.
	    */reverseOnce:function reverseOnce(){this.onComplete.addOnce(this.reverse,this);return this.reverse();},/**
	    * Sets this animations playback to a given frame with the given ID.
	    *
	    * @method Phaser.Animation#setFrame
	    * @param {string|number} [frameId] - The identifier of the frame to set. Can be the name of the frame, the sprite index of the frame, or the animation-local frame index.
	    * @param {boolean} [useLocalFrameIndex=false] - If you provide a number for frameId, should it use the numeric indexes of the frameData, or the 0-indexed frame index local to the animation.
	    */setFrame:function setFrame(frameId,useLocalFrameIndex){var frameIndex;if(useLocalFrameIndex===undefined){useLocalFrameIndex=false;}//  Find the index to the desired frame.
	if(typeof frameId==="string"){for(var i=0;i<this._frames.length;i++){if(this._frameData.getFrame(this._frames[i]).name===frameId){frameIndex=i;}}}else if(typeof frameId==="number"){if(useLocalFrameIndex){frameIndex=frameId;}else{for(var i=0;i<this._frames.length;i++){if(this._frames[i]===frameId){frameIndex=i;}}}}if(frameIndex){//  Set the current frame index to the found index. Subtract 1 so that it animates to the desired frame on update.
	this._frameIndex=frameIndex-1;//  Make the animation update at next update
	this._timeNextFrame=this.game.time.time;this.update();}},/**
	    * Stops playback of this animation and set it to a finished state. If a resetFrame is provided it will stop playback and set frame to the first in the animation.
	    * If `dispatchComplete` is true it will dispatch the complete events, otherwise they'll be ignored.
	    *
	    * @method Phaser.Animation#stop
	    * @param {boolean} [resetFrame=false] - If true after the animation stops the currentFrame value will be set to the first frame in this animation.
	    * @param {boolean} [dispatchComplete=false] - Dispatch the Animation.onComplete and parent.onAnimationComplete events?
	    */stop:function stop(resetFrame,dispatchComplete){if(resetFrame===undefined){resetFrame=false;}if(dispatchComplete===undefined){dispatchComplete=false;}this.isPlaying=false;this.isFinished=true;this.paused=false;if(resetFrame){this.currentFrame=this._frameData.getFrame(this._frames[0]);this._parent.setFrame(this.currentFrame);}if(dispatchComplete){this._parent.events.onAnimationComplete$dispatch(this._parent,this);this.onComplete.dispatch(this._parent,this);}},/**
	    * Called when the Game enters a paused state.
	    *
	    * @method Phaser.Animation#onPause
	    */onPause:function onPause(){if(this.isPlaying){this._frameDiff=this._timeNextFrame-this.game.time.time;}},/**
	    * Called when the Game resumes from a paused state.
	    *
	    * @method Phaser.Animation#onResume
	    */onResume:function onResume(){if(this.isPlaying){this._timeNextFrame=this.game.time.time+this._frameDiff;}},/**
	    * Updates this animation. Called automatically by the AnimationManager.
	    *
	    * @method Phaser.Animation#update
	    */update:function update(){if(this.isPaused){return false;}if(this.isPlaying&&this.game.time.time>=this._timeNextFrame){this._frameSkip=1;//  Lagging?
	this._frameDiff=this.game.time.time-this._timeNextFrame;this._timeLastFrame=this.game.time.time;if(this._frameDiff>this.delay){//  We need to skip a frame, work out how many
	this._frameSkip=Math.floor(this._frameDiff/this.delay);this._frameDiff-=this._frameSkip*this.delay;}//  And what's left now?
	this._timeNextFrame=this.game.time.time+(this.delay-this._frameDiff);if(this.isReversed){this._frameIndex-=this._frameSkip;}else{this._frameIndex+=this._frameSkip;}if(!this.isReversed&&this._frameIndex>=this._frames.length||this.isReversed&&this._frameIndex<=-1){if(this.loop){// Update current state before event callback
	this._frameIndex=Math.abs(this._frameIndex)%this._frames.length;if(this.isReversed){this._frameIndex=this._frames.length-1-this._frameIndex;}this.currentFrame=this._frameData.getFrame(this._frames[this._frameIndex]);//  Instead of calling updateCurrentFrame we do it here instead
	if(this.currentFrame){this._parent.setFrame(this.currentFrame);}this.loopCount++;this._parent.events.onAnimationLoop$dispatch(this._parent,this);this.onLoop.dispatch(this._parent,this);if(this.onUpdate){this.onUpdate.dispatch(this,this.currentFrame);// False if the animation was destroyed from within a callback
	return!!this._frameData;}else{return true;}}else{this.complete();return false;}}else{return this.updateCurrentFrame(true);}}return false;},/**
	    * Changes the currentFrame per the _frameIndex, updates the display state,
	    * and triggers the update signal.
	    *
	    * Returns true if the current frame update was 'successful', false otherwise.
	    *
	    * @method Phaser.Animation#updateCurrentFrame
	    * @private
	    * @param {boolean} signalUpdate - If true the `Animation.onUpdate` signal will be dispatched.
	    * @param {boolean} fromPlay - Was this call made from the playing of a new animation?
	    * @return {boolean} True if the current frame was updated, otherwise false.
	    */updateCurrentFrame:function updateCurrentFrame(signalUpdate,fromPlay){if(fromPlay===undefined){fromPlay=false;}if(!this._frameData){// The animation is already destroyed, probably from a callback
	return false;}//  Previous index
	var idx=this.currentFrame.index;this.currentFrame=this._frameData.getFrame(this._frames[this._frameIndex]);if(this.currentFrame&&(fromPlay||!fromPlay&&idx!==this.currentFrame.index)){this._parent.setFrame(this.currentFrame);}if(this.onUpdate&&signalUpdate){this.onUpdate.dispatch(this,this.currentFrame);// False if the animation was destroyed from within a callback
	return!!this._frameData;}else{return true;}},/**
	    * Advances by the given number of frames in the Animation, taking the loop value into consideration.
	    *
	    * @method Phaser.Animation#next
	    * @param {number} [quantity=1] - The number of frames to advance.
	    */next:function next(quantity){if(quantity===undefined){quantity=1;}var frame=this._frameIndex+quantity;if(frame>=this._frames.length){if(this.loop){frame%=this._frames.length;}else{frame=this._frames.length-1;}}if(frame!==this._frameIndex){this._frameIndex=frame;this.updateCurrentFrame(true);}},/**
	    * Moves backwards the given number of frames in the Animation, taking the loop value into consideration.
	    *
	    * @method Phaser.Animation#previous
	    * @param {number} [quantity=1] - The number of frames to move back.
	    */previous:function previous(quantity){if(quantity===undefined){quantity=1;}var frame=this._frameIndex-quantity;if(frame<0){if(this.loop){frame=this._frames.length+frame;}else{frame++;}}if(frame!==this._frameIndex){this._frameIndex=frame;this.updateCurrentFrame(true);}},/**
	    * Changes the FrameData object this Animation is using.
	    *
	    * @method Phaser.Animation#updateFrameData
	    * @param {Phaser.FrameData} frameData - The FrameData object that contains all frames used by this Animation.
	    */updateFrameData:function updateFrameData(frameData){this._frameData=frameData;this.currentFrame=this._frameData?this._frameData.getFrame(this._frames[this._frameIndex%this._frames.length]):null;},/**
	    * Cleans up this animation ready for deletion. Nulls all values and references.
	    *
	    * @method Phaser.Animation#destroy
	    */destroy:function destroy(){if(!this._frameData){// Already destroyed
	return;}this.game.onPause.remove(this.onPause,this);this.game.onResume.remove(this.onResume,this);this.game=null;this._parent=null;this._frames=null;this._frameData=null;this.currentFrame=null;this.isPlaying=false;this.onStart.dispose();this.onLoop.dispose();this.onComplete.dispose();if(this.onUpdate){this.onUpdate.dispose();}},/**
	    * Called internally when the animation finishes playback.
	    * Sets the isPlaying and isFinished states and dispatches the onAnimationComplete event if it exists on the parent and local onComplete event.
	    *
	    * @method Phaser.Animation#complete
	    */complete:function complete(){this._frameIndex=this._frames.length-1;this.currentFrame=this._frameData.getFrame(this._frames[this._frameIndex]);this.isPlaying=false;this.isFinished=true;this.paused=false;this._parent.events.onAnimationComplete$dispatch(this._parent,this);this.onComplete.dispatch(this._parent,this);if(this.killOnComplete){this._parent.kill();}}};Phaser.Animation.prototype.constructor=Phaser.Animation;/**
	* @name Phaser.Animation#paused
	* @property {boolean} paused - Gets and sets the paused state of this Animation.
	*/Object.defineProperty(Phaser.Animation.prototype,'paused',{get:function get(){return this.isPaused;},set:function set(value){this.isPaused=value;if(value){//  Paused
	this._pauseStartTime=this.game.time.time;}else{//  Un-paused
	if(this.isPlaying){this._timeNextFrame=this.game.time.time+this.delay;}}}});/**
	* @name Phaser.Animation#reversed
	* @property {boolean} reversed - Gets and sets the isReversed state of this Animation.
	*/Object.defineProperty(Phaser.Animation.prototype,'reversed',{get:function get(){return this.isReversed;},set:function set(value){this.isReversed=value;}});/**
	* @name Phaser.Animation#frameTotal
	* @property {number} frameTotal - The total number of frames in the currently loaded FrameData, or -1 if no FrameData is loaded.
	* @readonly
	*/Object.defineProperty(Phaser.Animation.prototype,'frameTotal',{get:function get(){return this._frames.length;}});/**
	* @name Phaser.Animation#frame
	* @property {number} frame - Gets or sets the current frame index and updates the Texture Cache for display.
	*/Object.defineProperty(Phaser.Animation.prototype,'frame',{get:function get(){if(this.currentFrame!==null){return this.currentFrame.index;}else{return this._frameIndex;}},set:function set(value){this.currentFrame=this._frameData.getFrame(this._frames[value]);if(this.currentFrame!==null){this._frameIndex=value;this._parent.setFrame(this.currentFrame);if(this.onUpdate){this.onUpdate.dispatch(this,this.currentFrame);}}}});/**
	* @name Phaser.Animation#speed
	* @property {number} speed - Gets or sets the current speed of the animation in frames per second. Changing this in a playing animation will take effect from the next frame. Value must be greater than 0.
	*/Object.defineProperty(Phaser.Animation.prototype,'speed',{get:function get(){return 1000/this.delay;},set:function set(value){if(value>0){this.delay=1000/value;}}});/**
	* @name Phaser.Animation#enableUpdate
	* @property {boolean} enableUpdate - Gets or sets if this animation will dispatch the onUpdate events upon changing frame.
	*/Object.defineProperty(Phaser.Animation.prototype,'enableUpdate',{get:function get(){return this.onUpdate!==null;},set:function set(value){if(value&&this.onUpdate===null){this.onUpdate=new Phaser.Signal();}else if(!value&&this.onUpdate!==null){this.onUpdate.dispose();this.onUpdate=null;}}});/**
	* Really handy function for when you are creating arrays of animation data but it's using frame names and not numbers.
	* For example imagine you've got 30 frames named: 'explosion_0001-large' to 'explosion_0030-large'
	* You could use this function to generate those by doing: Phaser.Animation.generateFrameNames('explosion_', 1, 30, '-large', 4);
	*
	* @method Phaser.Animation.generateFrameNames
	* @static
	* @param {string} prefix - The start of the filename. If the filename was 'explosion_0001-large' the prefix would be 'explosion_'.
	* @param {number} start - The number to start sequentially counting from. If your frames are named 'explosion_0001' to 'explosion_0034' the start is 1.
	* @param {number} stop - The number to count to. If your frames are named 'explosion_0001' to 'explosion_0034' the stop value is 34.
	* @param {string} [suffix=''] - The end of the filename. If the filename was 'explosion_0001-large' the prefix would be '-large'.
	* @param {number} [zeroPad=0] - The number of zeros to pad the min and max values with. If your frames are named 'explosion_0001' to 'explosion_0034' then the zeroPad is 4.
	* @return {string[]} An array of framenames.
	*/Phaser.Animation.generateFrameNames=function(prefix,start,stop,suffix,zeroPad){if(suffix===undefined){suffix='';}var output=[];var frame='';if(start<stop){for(var i=start;i<=stop;i++){if(typeof zeroPad==='number'){//  str, len, pad, dir
	frame=Phaser.Utils.pad(i.toString(),zeroPad,'0',1);}else{frame=i.toString();}frame=prefix+frame+suffix;output.push(frame);}}else{for(var i=start;i>=stop;i--){if(typeof zeroPad==='number'){//  str, len, pad, dir
	frame=Phaser.Utils.pad(i.toString(),zeroPad,'0',1);}else{frame=i.toString();}frame=prefix+frame+suffix;output.push(frame);}}return output;};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A Frame is a single frame of an animation and is part of a FrameData collection.
	*
	* @class Phaser.Frame
	* @constructor
	* @param {number} index - The index of this Frame within the FrameData set it is being added to.
	* @param {number} x - X position of the frame within the texture image.
	* @param {number} y - Y position of the frame within the texture image.
	* @param {number} width - Width of the frame within the texture image.
	* @param {number} height - Height of the frame within the texture image.
	* @param {string} name - The name of the frame. In Texture Atlas data this is usually set to the filename.
	*/Phaser.Frame=function(index,x,y,width,height,name){/**
	    * @property {number} index - The index of this Frame within the FrameData set it is being added to.
	    */this.index=index;/**
	    * @property {number} x - X position within the image to cut from.
	    */this.x=x;/**
	    * @property {number} y - Y position within the image to cut from.
	    */this.y=y;/**
	    * @property {number} width - Width of the frame.
	    */this.width=width;/**
	    * @property {number} height - Height of the frame.
	    */this.height=height;/**
	    * @property {string} name - Useful for Texture Atlas files (is set to the filename value).
	    */this.name=name;/**
	    * @property {number} centerX - Center X position within the image to cut from.
	    */this.centerX=Math.floor(width/2);/**
	    * @property {number} centerY - Center Y position within the image to cut from.
	    */this.centerY=Math.floor(height/2);/**
	    * @property {number} distance - The distance from the top left to the bottom-right of this Frame.
	    */this.distance=Phaser.Math.distance(0,0,width,height);/**
	    * @property {boolean} rotated - Rotated? (not yet implemented)
	    * @default
	    */this.rotated=false;/**
	    * @property {string} rotationDirection - Either 'cw' or 'ccw', rotation is always 90 degrees.
	    * @default 'cw'
	    */this.rotationDirection='cw';/**
	    * @property {boolean} trimmed - Was it trimmed when packed?
	    * @default
	    */this.trimmed=false;/**
	    * @property {number} sourceSizeW - Width of the original sprite before it was trimmed.
	    */this.sourceSizeW=width;/**
	    * @property {number} sourceSizeH - Height of the original sprite before it was trimmed.
	    */this.sourceSizeH=height;/**
	    * @property {number} spriteSourceSizeX - X position of the trimmed sprite inside original sprite.
	    * @default
	    */this.spriteSourceSizeX=0;/**
	    * @property {number} spriteSourceSizeY - Y position of the trimmed sprite inside original sprite.
	    * @default
	    */this.spriteSourceSizeY=0;/**
	    * @property {number} spriteSourceSizeW - Width of the trimmed sprite.
	    * @default
	    */this.spriteSourceSizeW=0;/**
	    * @property {number} spriteSourceSizeH - Height of the trimmed sprite.
	    * @default
	    */this.spriteSourceSizeH=0;/**
	    * @property {number} right - The right of the Frame (x + width).
	    */this.right=this.x+this.width;/**
	    * @property {number} bottom - The bottom of the frame (y + height).
	    */this.bottom=this.y+this.height;};Phaser.Frame.prototype={/**
	    * Adjusts of all the Frame properties based on the given width and height values.
	    *
	    * @method Phaser.Frame#resize
	    * @param {integer} width - The new width of the Frame.
	    * @param {integer} height - The new height of the Frame.
	    */resize:function resize(width,height){this.width=width;this.height=height;this.centerX=Math.floor(width/2);this.centerY=Math.floor(height/2);this.distance=Phaser.Math.distance(0,0,width,height);this.sourceSizeW=width;this.sourceSizeH=height;this.right=this.x+width;this.bottom=this.y+height;},/**
	    * If the frame was trimmed when added to the Texture Atlas this records the trim and source data.
	    *
	    * @method Phaser.Frame#setTrim
	    * @param {boolean} trimmed - If this frame was trimmed or not.
	    * @param {number} actualWidth - The width of the frame before being trimmed.
	    * @param {number} actualHeight - The height of the frame before being trimmed.
	    * @param {number} destX - The destination X position of the trimmed frame for display.
	    * @param {number} destY - The destination Y position of the trimmed frame for display.
	    * @param {number} destWidth - The destination width of the trimmed frame for display.
	    * @param {number} destHeight - The destination height of the trimmed frame for display.
	    */setTrim:function setTrim(trimmed,actualWidth,actualHeight,destX,destY,destWidth,destHeight){this.trimmed=trimmed;if(trimmed){this.sourceSizeW=actualWidth;this.sourceSizeH=actualHeight;this.centerX=Math.floor(actualWidth/2);this.centerY=Math.floor(actualHeight/2);this.spriteSourceSizeX=destX;this.spriteSourceSizeY=destY;this.spriteSourceSizeW=destWidth;this.spriteSourceSizeH=destHeight;}},/**
	     * Clones this Frame into a new Phaser.Frame object and returns it.
	     * Note that all properties are cloned, including the name, index and UUID.
	     *
	     * @method Phaser.Frame#clone
	     * @return {Phaser.Frame} An exact copy of this Frame object.
	     */clone:function clone(){var output=new Phaser.Frame(this.index,this.x,this.y,this.width,this.height,this.name);for(var prop in this){if(this.hasOwnProperty(prop)){output[prop]=this[prop];}}return output;},/**
	    * Returns a Rectangle set to the dimensions of this Frame.
	    *
	    * @method Phaser.Frame#getRect
	    * @param {Phaser.Rectangle} [out] - A rectangle to copy the frame dimensions to.
	    * @return {Phaser.Rectangle} A rectangle.
	    */getRect:function getRect(out){if(out===undefined){out=new Phaser.Rectangle(this.x,this.y,this.width,this.height);}else{out.setTo(this.x,this.y,this.width,this.height);}return out;}};Phaser.Frame.prototype.constructor=Phaser.Frame;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* FrameData is a container for Frame objects, which are the internal representation of animation data in Phaser.
	*
	* @class Phaser.FrameData
	* @constructor
	*/Phaser.FrameData=function(){/**
	    * @property {Array} _frames - Local array of frames.
	    * @private
	    */this._frames=[];/**
	    * @property {Array} _frameNames - Local array of frame names for name to index conversions.
	    * @private
	    */this._frameNames=[];};Phaser.FrameData.prototype={/**
	    * Adds a new Frame to this FrameData collection. Typically called by the Animation.Parser and not directly.
	    *
	    * @method Phaser.FrameData#addFrame
	    * @param {Phaser.Frame} frame - The frame to add to this FrameData set.
	    * @return {Phaser.Frame} The frame that was just added.
	    */addFrame:function addFrame(frame){frame.index=this._frames.length;this._frames.push(frame);if(frame.name!==''){this._frameNames[frame.name]=frame.index;}return frame;},/**
	    * Get a Frame by its numerical index.
	    *
	    * @method Phaser.FrameData#getFrame
	    * @param {number} index - The index of the frame you want to get.
	    * @return {Phaser.Frame} The frame, if found.
	    */getFrame:function getFrame(index){if(index>=this._frames.length){index=0;}return this._frames[index];},/**
	    * Get a Frame by its frame name.
	    *
	    * @method Phaser.FrameData#getFrameByName
	    * @param {string} name - The name of the frame you want to get.
	    * @return {Phaser.Frame} The frame, if found.
	    */getFrameByName:function getFrameByName(name){if(typeof this._frameNames[name]==='number'){return this._frames[this._frameNames[name]];}return null;},/**
	    * Check if there is a Frame with the given name.
	    *
	    * @method Phaser.FrameData#checkFrameName
	    * @param {string} name - The name of the frame you want to check.
	    * @return {boolean} True if the frame is found, otherwise false.
	    */checkFrameName:function checkFrameName(name){if(this._frameNames[name]==null){return false;}return true;},/**
	     * Makes a copy of this FrameData including copies (not references) to all of the Frames it contains.
	     *
	     * @method Phaser.FrameData#clone
	     * @return {Phaser.FrameData} A clone of this object, including clones of the Frame objects it contains.
	     */clone:function clone(){var output=new Phaser.FrameData();//  No input array, so we loop through all frames
	for(var i=0;i<this._frames.length;i++){output._frames.push(this._frames[i].clone());}for(var p in this._frameNames){if(this._frameNames.hasOwnProperty(p)){output._frameNames.push(this._frameNames[p]);}}return output;},/**
	    * Returns a range of frames based on the given start and end frame indexes and returns them in an Array.
	    *
	    * @method Phaser.FrameData#getFrameRange
	    * @param {number} start - The starting frame index.
	    * @param {number} end - The ending frame index.
	    * @param {Array} [output] - If given the results will be appended to the end of this array otherwise a new array will be created.
	    * @return {Array} An array of Frames between the start and end index values, or an empty array if none were found.
	    */getFrameRange:function getFrameRange(start,end,output){if(output===undefined){output=[];}for(var i=start;i<=end;i++){output.push(this._frames[i]);}return output;},/**
	    * Returns all of the Frames in this FrameData set where the frame index is found in the input array.
	    * The frames are returned in the output array, or if none is provided in a new Array object.
	    *
	    * @method Phaser.FrameData#getFrames
	    * @param {Array} [frames] - An Array containing the indexes of the frames to retrieve. If the array is empty or undefined then all frames in the FrameData are returned.
	    * @param {boolean} [useNumericIndex=true] - Are the given frames using numeric indexes (default) or strings? (false)
	    * @param {Array} [output] - If given the results will be appended to the end of this array otherwise a new array will be created.
	    * @return {Array} An array of all Frames in this FrameData set matching the given names or IDs.
	    */getFrames:function getFrames(frames,useNumericIndex,output){if(useNumericIndex===undefined){useNumericIndex=true;}if(output===undefined){output=[];}if(frames===undefined||frames.length===0){//  No input array, so we loop through all frames
	for(var i=0;i<this._frames.length;i++){//  We only need the indexes
	output.push(this._frames[i]);}}else{//  Input array given, loop through that instead
	for(var i=0;i<frames.length;i++){//  Does the input array contain names or indexes?
	if(useNumericIndex){//  The actual frame
	output.push(this.getFrame(frames[i]));}else{//  The actual frame
	output.push(this.getFrameByName(frames[i]));}}}return output;},/**
	    * Returns all of the Frame indexes in this FrameData set.
	    * The frames indexes are returned in the output array, or if none is provided in a new Array object.
	    *
	    * @method Phaser.FrameData#getFrameIndexes
	    * @param {Array} [frames] - An Array containing the indexes of the frames to retrieve. If undefined or the array is empty then all frames in the FrameData are returned.
	    * @param {boolean} [useNumericIndex=true] - Are the given frames using numeric indexes (default) or strings? (false)
	    * @param {Array} [output] - If given the results will be appended to the end of this array otherwise a new array will be created.
	    * @return {Array} An array of all Frame indexes matching the given names or IDs.
	    */getFrameIndexes:function getFrameIndexes(frames,useNumericIndex,output){if(useNumericIndex===undefined){useNumericIndex=true;}if(output===undefined){output=[];}if(frames===undefined||frames.length===0){//  No frames array, so we loop through all frames
	for(var i=0;i<this._frames.length;i++){output.push(this._frames[i].index);}}else{//  Input array given, loop through that instead
	for(var i=0;i<frames.length;i++){//  Does the frames array contain names or indexes?
	if(useNumericIndex&&this._frames[frames[i]]){output.push(this._frames[frames[i]].index);}else{if(this.getFrameByName(frames[i])){output.push(this.getFrameByName(frames[i]).index);}}}}return output;},/**
	    * Destroys this FrameData collection by nulling the _frames and _frameNames arrays.
	    *
	    * @method Phaser.FrameData#destroy
	    */destroy:function destroy(){this._frames=null;this._frameNames=null;}};Phaser.FrameData.prototype.constructor=Phaser.FrameData;/**
	* @name Phaser.FrameData#total
	* @property {number} total - The total number of frames in this FrameData set.
	* @readonly
	*/Object.defineProperty(Phaser.FrameData.prototype,"total",{get:function get(){return this._frames.length;}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Responsible for parsing sprite sheet and JSON data into the internal FrameData format that Phaser uses for animations.
	*
	* @class Phaser.AnimationParser
	* @static
	*/Phaser.AnimationParser={/**
	    * Parse a Sprite Sheet and extract the animation frame data from it.
	    *
	    * @method Phaser.AnimationParser.spriteSheet
	    * @param {Phaser.Game} game - A reference to the currently running game.
	    * @param {string|Image} key - The Game.Cache asset key of the Sprite Sheet image or an actual HTML Image element.
	    * @param {number} frameWidth - The fixed width of each frame of the animation.
	    * @param {number} frameHeight - The fixed height of each frame of the animation.
	    * @param {number} [frameMax=-1] - The total number of animation frames to extract from the Sprite Sheet. The default value of -1 means "extract all frames".
	    * @param {number} [margin=0] - If the frames have been drawn with a margin, specify the amount here.
	    * @param {number} [spacing=0] - If the frames have been drawn with spacing between them, specify the amount here.
	    * @return {Phaser.FrameData} A FrameData object containing the parsed frames.
	    */spriteSheet:function spriteSheet(game,key,frameWidth,frameHeight,frameMax,margin,spacing){var img=key;if(typeof key==='string'){img=game.cache.getImage(key);}if(img===null){return null;}var width=img.width;var height=img.height;if(frameWidth<=0){frameWidth=Math.floor(-width/Math.min(-1,frameWidth));}if(frameHeight<=0){frameHeight=Math.floor(-height/Math.min(-1,frameHeight));}var row=Math.floor((width-margin)/(frameWidth+spacing));var column=Math.floor((height-margin)/(frameHeight+spacing));var total=row*column;if(frameMax!==-1){total=frameMax;}//  Zero or smaller than frame sizes?
	if(width===0||height===0||width<frameWidth||height<frameHeight||total===0){console.warn("Phaser.AnimationParser.spriteSheet: '"+key+"'s width/height zero or width/height < given frameWidth/frameHeight");return null;}//  Let's create some frames then
	var data=new Phaser.FrameData();var x=margin;var y=margin;for(var i=0;i<total;i++){data.addFrame(new Phaser.Frame(i,x,y,frameWidth,frameHeight,''));x+=frameWidth+spacing;if(x+frameWidth>width){x=margin;y+=frameHeight+spacing;}}return data;},/**
	    * Parse the JSON data and extract the animation frame data from it.
	    *
	    * @method Phaser.AnimationParser.JSONData
	    * @param {Phaser.Game} game - A reference to the currently running game.
	    * @param {object} json - The JSON data from the Texture Atlas. Must be in Array format.
	    * @return {Phaser.FrameData} A FrameData object containing the parsed frames.
	    */JSONData:function JSONData(game,json){//  Malformed?
	if(!json['frames']){console.warn("Phaser.AnimationParser.JSONData: Invalid Texture Atlas JSON given, missing 'frames' array");console.log(json);return;}//  Let's create some frames then
	var data=new Phaser.FrameData();//  By this stage frames is a fully parsed array
	var frames=json['frames'];var newFrame;for(var i=0;i<frames.length;i++){newFrame=data.addFrame(new Phaser.Frame(i,frames[i].frame.x,frames[i].frame.y,frames[i].frame.w,frames[i].frame.h,frames[i].filename));if(frames[i].trimmed){newFrame.setTrim(frames[i].trimmed,frames[i].sourceSize.w,frames[i].sourceSize.h,frames[i].spriteSourceSize.x,frames[i].spriteSourceSize.y,frames[i].spriteSourceSize.w,frames[i].spriteSourceSize.h);}}return data;},/**
	    * Parse the JSON data and extract the animation frame data from it.
	    *
	    * @method Phaser.AnimationParser.JSONDataPyxel
	    * @param {Phaser.Game} game - A reference to the currently running game.
	    * @param {object} json - The JSON data from the Texture Atlas. Must be in Pyxel JSON format.
	    * @return {Phaser.FrameData} A FrameData object containing the parsed frames.
	    */JSONDataPyxel:function JSONDataPyxel(game,json){//  Malformed? There are a few keys to check here.
	var signature=['layers','tilewidth','tileheight','tileswide','tileshigh'];signature.forEach(function(key){if(!json[key]){console.warn('Phaser.AnimationParser.JSONDataPyxel: Invalid Pyxel Tilemap JSON given, missing "'+key+'" key.');console.log(json);return;}});// For this purpose, I only care about parsing tilemaps with a single layer.
	if(json['layers'].length!==1){console.warn('Phaser.AnimationParser.JSONDataPyxel: Too many layers, this parser only supports flat Tilemaps.');console.log(json);return;}var data=new Phaser.FrameData();var tileheight=json['tileheight'];var tilewidth=json['tilewidth'];var frames=json['layers'][0]['tiles'];var newFrame;for(var i=0;i<frames.length;i++){newFrame=data.addFrame(new Phaser.Frame(i,frames[i].x,frames[i].y,tilewidth,tileheight,"frame_"+i// No names are included in pyxel tilemap data.
	));// No trim data is included.
	newFrame.setTrim(false);}return data;},/**
	    * Parse the JSON data and extract the animation frame data from it.
	    *
	    * @method Phaser.AnimationParser.JSONDataHash
	    * @param {Phaser.Game} game - A reference to the currently running game.
	    * @param {object} json - The JSON data from the Texture Atlas. Must be in JSON Hash format.
	    * @return {Phaser.FrameData} A FrameData object containing the parsed frames.
	    */JSONDataHash:function JSONDataHash(game,json){//  Malformed?
	if(!json['frames']){console.warn("Phaser.AnimationParser.JSONDataHash: Invalid Texture Atlas JSON given, missing 'frames' object");console.log(json);return;}//  Let's create some frames then
	var data=new Phaser.FrameData();//  By this stage frames is a fully parsed array
	var frames=json['frames'];var newFrame;var i=0;for(var key in frames){newFrame=data.addFrame(new Phaser.Frame(i,frames[key].frame.x,frames[key].frame.y,frames[key].frame.w,frames[key].frame.h,key));if(frames[key].trimmed){newFrame.setTrim(frames[key].trimmed,frames[key].sourceSize.w,frames[key].sourceSize.h,frames[key].spriteSourceSize.x,frames[key].spriteSourceSize.y,frames[key].spriteSourceSize.w,frames[key].spriteSourceSize.h);}i++;}return data;},/**
	    * Parse the XML data and extract the animation frame data from it.
	    *
	    * @method Phaser.AnimationParser.XMLData
	    * @param {Phaser.Game} game - A reference to the currently running game.
	    * @param {object} xml - The XML data from the Texture Atlas. Must be in Starling XML format.
	    * @return {Phaser.FrameData} A FrameData object containing the parsed frames.
	    */XMLData:function XMLData(game,xml){//  Malformed?
	if(!xml.getElementsByTagName('TextureAtlas')){console.warn("Phaser.AnimationParser.XMLData: Invalid Texture Atlas XML given, missing <TextureAtlas> tag");return;}//  Let's create some frames then
	var data=new Phaser.FrameData();var frames=xml.getElementsByTagName('SubTexture');var newFrame;var name;var frame;var x;var y;var width;var height;var frameX;var frameY;var frameWidth;var frameHeight;for(var i=0;i<frames.length;i++){frame=frames[i].attributes;name=frame.name.value;x=parseInt(frame.x.value,10);y=parseInt(frame.y.value,10);width=parseInt(frame.width.value,10);height=parseInt(frame.height.value,10);frameX=null;frameY=null;if(frame.frameX){frameX=Math.abs(parseInt(frame.frameX.value,10));frameY=Math.abs(parseInt(frame.frameY.value,10));frameWidth=parseInt(frame.frameWidth.value,10);frameHeight=parseInt(frame.frameHeight.value,10);}newFrame=data.addFrame(new Phaser.Frame(i,x,y,width,height,name));//  Trimmed?
	if(frameX!==null||frameY!==null){newFrame.setTrim(true,width,height,frameX,frameY,frameWidth,frameHeight);}}return data;}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Phaser has one single cache in which it stores all assets.
	*
	* The cache is split up into sections, such as images, sounds, video, json, etc. All assets are stored using
	* a unique string-based key as their identifier. Assets stored in different areas of the cache can have the
	* same key, for example 'playerWalking' could be used as the key for both a sprite sheet and an audio file,
	* because they are unique data types.
	*
	* The cache is automatically populated by the Phaser.Loader. When you use the loader to pull in external assets
	* such as images they are automatically placed into their respective cache. Most common Game Objects, such as
	* Sprites and Videos automatically query the cache to extract the assets they need on instantiation.
	*
	* You can access the cache from within a State via `this.cache`. From here you can call any public method it has,
	* including adding new entries to it, deleting them or querying them.
	*
	* Understand that almost without exception when you get an item from the cache it will return a reference to the
	* item stored in the cache, not a copy of it. Therefore if you retrieve an item and then modify it, the original
	* object in the cache will also be updated, even if you don't put it back into the cache again.
	*
	* By default when you change State the cache is _not_ cleared, although there is an option to clear it should
	* your game require it. In a typical game set-up the cache is populated once after the main game has loaded and
	* then used as an asset store.
	*
	* @class Phaser.Cache
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	*/Phaser.Cache=function(game){/**
	    * @property {Phaser.Game} game - Local reference to game.
	    */this.game=game;/**
	    * Automatically resolve resource URLs to absolute paths for use with the Cache.getURL method.
	    * @property {boolean} autoResolveURL
	    */this.autoResolveURL=false;/**
	    * The main cache object into which all resources are placed.
	    * @property {object} _cache
	    * @private
	    */this._cache={canvas:{},image:{},texture:{},sound:{},video:{},text:{},json:{},xml:{},physics:{},tilemap:{},binary:{},bitmapData:{},bitmapFont:{},shader:{},renderTexture:{}};/**
	    * @property {object} _urlMap - Maps URLs to resources.
	    * @private
	    */this._urlMap={};/**
	    * @property {Image} _urlResolver - Used to resolve URLs to the absolute path.
	    * @private
	    */this._urlResolver=new Image();/**
	    * @property {string} _urlTemp - Temporary variable to hold a resolved url.
	    * @private
	    */this._urlTemp=null;/**
	    * @property {Phaser.Signal} onSoundUnlock - This event is dispatched when the sound system is unlocked via a touch event on cellular devices.
	    */this.onSoundUnlock=new Phaser.Signal();/**
	    * @property {array} _cacheMap - Const to cache object look-up array.
	    * @private
	    */this._cacheMap=[];this._cacheMap[Phaser.Cache.CANVAS]=this._cache.canvas;this._cacheMap[Phaser.Cache.IMAGE]=this._cache.image;this._cacheMap[Phaser.Cache.TEXTURE]=this._cache.texture;this._cacheMap[Phaser.Cache.SOUND]=this._cache.sound;this._cacheMap[Phaser.Cache.TEXT]=this._cache.text;this._cacheMap[Phaser.Cache.PHYSICS]=this._cache.physics;this._cacheMap[Phaser.Cache.TILEMAP]=this._cache.tilemap;this._cacheMap[Phaser.Cache.BINARY]=this._cache.binary;this._cacheMap[Phaser.Cache.BITMAPDATA]=this._cache.bitmapData;this._cacheMap[Phaser.Cache.BITMAPFONT]=this._cache.bitmapFont;this._cacheMap[Phaser.Cache.JSON]=this._cache.json;this._cacheMap[Phaser.Cache.XML]=this._cache.xml;this._cacheMap[Phaser.Cache.VIDEO]=this._cache.video;this._cacheMap[Phaser.Cache.SHADER]=this._cache.shader;this._cacheMap[Phaser.Cache.RENDER_TEXTURE]=this._cache.renderTexture;this.addDefaultImage();this.addMissingImage();};/**
	* @constant
	* @type {number}
	*/Phaser.Cache.CANVAS=1;/**
	* @constant
	* @type {number}
	*/Phaser.Cache.IMAGE=2;/**
	* @constant
	* @type {number}
	*/Phaser.Cache.TEXTURE=3;/**
	* @constant
	* @type {number}
	*/Phaser.Cache.SOUND=4;/**
	* @constant
	* @type {number}
	*/Phaser.Cache.TEXT=5;/**
	* @constant
	* @type {number}
	*/Phaser.Cache.PHYSICS=6;/**
	* @constant
	* @type {number}
	*/Phaser.Cache.TILEMAP=7;/**
	* @constant
	* @type {number}
	*/Phaser.Cache.BINARY=8;/**
	* @constant
	* @type {number}
	*/Phaser.Cache.BITMAPDATA=9;/**
	* @constant
	* @type {number}
	*/Phaser.Cache.BITMAPFONT=10;/**
	* @constant
	* @type {number}
	*/Phaser.Cache.JSON=11;/**
	* @constant
	* @type {number}
	*/Phaser.Cache.XML=12;/**
	* @constant
	* @type {number}
	*/Phaser.Cache.VIDEO=13;/**
	* @constant
	* @type {number}
	*/Phaser.Cache.SHADER=14;/**
	* @constant
	* @type {number}
	*/Phaser.Cache.RENDER_TEXTURE=15;/**
	* The default image used for a texture when no other is specified.
	* @constant
	* @type {PIXI.Texture}
	*/Phaser.Cache.DEFAULT=null;/**
	* The default image used for a texture when the source image is missing.
	* @constant
	* @type {PIXI.Texture}
	*/Phaser.Cache.MISSING=null;Phaser.Cache.prototype={//////////////////
	//  Add Methods //
	//////////////////
	/**
	    * Add a new canvas object in to the cache.
	    *
	    * @method Phaser.Cache#addCanvas
	    * @param {string} key - The key that this asset will be stored in the cache under. This should be unique within this cache.
	    * @param {HTMLCanvasElement} canvas - The Canvas DOM element.
	    * @param {CanvasRenderingContext2D} [context] - The context of the canvas element. If not specified it will default go `getContext('2d')`.
	    */addCanvas:function addCanvas(key,canvas,context){if(context===undefined){context=canvas.getContext('2d');}this._cache.canvas[key]={canvas:canvas,context:context};},/**
	    * Adds an Image file into the Cache. The file must have already been loaded, typically via Phaser.Loader, but can also have been loaded into the DOM.
	    * If an image already exists in the cache with the same key then it is removed and destroyed, and the new image inserted in its place.
	    *
	    * @method Phaser.Cache#addImage
	    * @param {string} key - The key that this asset will be stored in the cache under. This should be unique within this cache.
	    * @param {string} url - The URL the asset was loaded from. If the asset was not loaded externally set to `null`.
	    * @param {object} data - Extra image data.
	    * @return {object} The full image object that was added to the cache.
	    */addImage:function addImage(key,url,data){if(this.checkImageKey(key)){this.removeImage(key);}var img={key:key,url:url,data:data,base:new PIXI.BaseTexture(data),frame:new Phaser.Frame(0,0,0,data.width,data.height,key),frameData:new Phaser.FrameData()};img.frameData.addFrame(new Phaser.Frame(0,0,0,data.width,data.height,url));this._cache.image[key]=img;this._resolveURL(url,img);if(key==='__default'){Phaser.Cache.DEFAULT=new PIXI.Texture(img.base);}else if(key==='__missing'){Phaser.Cache.MISSING=new PIXI.Texture(img.base);}return img;},/**
	    * Adds a default image to be used in special cases such as WebGL Filters.
	    * It uses the special reserved key of `__default`.
	    * This method is called automatically when the Cache is created.
	    * This image is skipped when `Cache.destroy` is called due to its internal requirements.
	    *
	    * @method Phaser.Cache#addDefaultImage
	    * @protected
	    */addDefaultImage:function addDefaultImage(){var img=new Image();img.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgAQMAAABJtOi3AAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABVJREFUeF7NwIEAAAAAgKD9qdeocAMAoAABm3DkcAAAAABJRU5ErkJggg==";var obj=this.addImage('__default',null,img);//  Because we don't want to invalidate the sprite batch for an invisible texture
	obj.base.skipRender=true;//  Make it easily available within the rest of Phaser / Pixi
	Phaser.Cache.DEFAULT=new PIXI.Texture(obj.base);},/**
	    * Adds an image to be used when a key is wrong / missing.
	    * It uses the special reserved key of `__missing`.
	    * This method is called automatically when the Cache is created.
	    * This image is skipped when `Cache.destroy` is called due to its internal requirements.
	    *
	    * @method Phaser.Cache#addMissingImage
	    * @protected
	    */addMissingImage:function addMissingImage(){var img=new Image();img.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAIAAAD8GO2jAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJ9JREFUeNq01ssOwyAMRFG46v//Mt1ESmgh+DFmE2GPOBARKb2NVjo+17PXLD8a1+pl5+A+wSgFygymWYHBb0FtsKhJDdZlncG2IzJ4ayoMDv20wTmSMzClEgbWYNTAkQ0Z+OJ+A/eWnAaR9+oxCF4Os0H8htsMUp+pwcgBBiMNnAwF8GqIgL2hAzaGFFgZauDPKABmowZ4GL369/0rwACp2yA/ttmvsQAAAABJRU5ErkJggg==";var obj=this.addImage('__missing',null,img);//  Make it easily available within the rest of Phaser / Pixi
	Phaser.Cache.MISSING=new PIXI.Texture(obj.base);},/**
	    * Adds a Sound file into the Cache. The file must have already been loaded, typically via Phaser.Loader.
	    *
	    * @method Phaser.Cache#addSound
	    * @param {string} key - The key that this asset will be stored in the cache under. This should be unique within this cache.
	    * @param {string} url - The URL the asset was loaded from. If the asset was not loaded externally set to `null`.
	    * @param {object} data - Extra sound data.
	    * @param {boolean} webAudio - True if the file is using web audio.
	    * @param {boolean} audioTag - True if the file is using legacy HTML audio.
	    */addSound:function addSound(key,url,data,webAudio,audioTag){if(webAudio===undefined){webAudio=true;audioTag=false;}if(audioTag===undefined){webAudio=false;audioTag=true;}var decoded=false;if(audioTag){decoded=true;}this._cache.sound[key]={url:url,data:data,isDecoding:false,decoded:decoded,webAudio:webAudio,audioTag:audioTag,locked:this.game.sound.touchLocked};this._resolveURL(url,this._cache.sound[key]);},/**
	    * Add a new text data.
	    *
	    * @method Phaser.Cache#addText
	    * @param {string} key - The key that this asset will be stored in the cache under. This should be unique within this cache.
	    * @param {string} url - The URL the asset was loaded from. If the asset was not loaded externally set to `null`.
	    * @param {object} data - Extra text data.
	    */addText:function addText(key,url,data){this._cache.text[key]={url:url,data:data};this._resolveURL(url,this._cache.text[key]);},/**
	    * Add a new physics data object to the Cache.
	    *
	    * @method Phaser.Cache#addPhysicsData
	    * @param {string} key - The key that this asset will be stored in the cache under. This should be unique within this cache.
	    * @param {string} url - The URL the asset was loaded from. If the asset was not loaded externally set to `null`.
	    * @param {object} JSONData - The physics data object (a JSON file).
	    * @param {number} format - The format of the physics data.
	    */addPhysicsData:function addPhysicsData(key,url,JSONData,format){this._cache.physics[key]={url:url,data:JSONData,format:format};this._resolveURL(url,this._cache.physics[key]);},/**
	    * Add a new tilemap to the Cache.
	    *
	    * @method Phaser.Cache#addTilemap
	    * @param {string} key - The key that this asset will be stored in the cache under. This should be unique within this cache.
	    * @param {string} url - The URL the asset was loaded from. If the asset was not loaded externally set to `null`.
	    * @param {object} mapData - The tilemap data object (either a CSV or JSON file).
	    * @param {number} format - The format of the tilemap data.
	    */addTilemap:function addTilemap(key,url,mapData,format){this._cache.tilemap[key]={url:url,data:mapData,format:format};this._resolveURL(url,this._cache.tilemap[key]);},/**
	    * Add a binary object in to the cache.
	    *
	    * @method Phaser.Cache#addBinary
	    * @param {string} key - The key that this asset will be stored in the cache under. This should be unique within this cache.
	    * @param {object} binaryData - The binary object to be added to the cache.
	    */addBinary:function addBinary(key,binaryData){this._cache.binary[key]=binaryData;},/**
	    * Add a BitmapData object to the cache.
	    *
	    * @method Phaser.Cache#addBitmapData
	    * @param {string} key - The key that this asset will be stored in the cache under. This should be unique within this cache.
	    * @param {Phaser.BitmapData} bitmapData - The BitmapData object to be addded to the cache.
	    * @param {Phaser.FrameData|null} [frameData=(auto create)] - Optional FrameData set associated with the given BitmapData. If not specified (or `undefined`) a new FrameData object is created containing the Bitmap's Frame. If `null` is supplied then no FrameData will be created.
	    * @return {Phaser.BitmapData} The BitmapData object to be addded to the cache.
	    */addBitmapData:function addBitmapData(key,bitmapData,frameData){bitmapData.key=key;if(frameData===undefined){frameData=new Phaser.FrameData();frameData.addFrame(bitmapData.textureFrame);}this._cache.bitmapData[key]={data:bitmapData,frameData:frameData};return bitmapData;},/**
	    * Add a new Bitmap Font to the Cache.
	    *
	    * @method Phaser.Cache#addBitmapFont
	    * @param {string} key - The key that this asset will be stored in the cache under. This should be unique within this cache.
	    * @param {string} url - The URL the asset was loaded from. If the asset was not loaded externally set to `null`.
	    * @param {object} data - Extra font data.
	    * @param {object} atlasData - Texture atlas frames data.
	    * @param {string} [atlasType='xml'] - The format of the texture atlas ( 'json' or 'xml' ).
	    * @param {number} [xSpacing=0] - If you'd like to add additional horizontal spacing between the characters then set the pixel value here.
	    * @param {number} [ySpacing=0] - If you'd like to add additional vertical spacing between the lines then set the pixel value here.
	    */addBitmapFont:function addBitmapFont(key,url,data,atlasData,atlasType,xSpacing,ySpacing){var obj={url:url,data:data,font:null,base:new PIXI.BaseTexture(data)};if(xSpacing===undefined){xSpacing=0;}if(ySpacing===undefined){ySpacing=0;}if(atlasType==='json'){obj.font=Phaser.LoaderParser.jsonBitmapFont(atlasData,obj.base,xSpacing,ySpacing);}else{obj.font=Phaser.LoaderParser.xmlBitmapFont(atlasData,obj.base,xSpacing,ySpacing);}this._cache.bitmapFont[key]=obj;this._resolveURL(url,obj);},/**
	    * Add a new json object into the cache.
	    *
	    * @method Phaser.Cache#addJSON
	    * @param {string} key - The key that this asset will be stored in the cache under. This should be unique within this cache.
	    * @param {string} url - The URL the asset was loaded from. If the asset was not loaded externally set to `null`.
	    * @param {object} data - Extra json data.
	    */addJSON:function addJSON(key,url,data){this._cache.json[key]={url:url,data:data};this._resolveURL(url,this._cache.json[key]);},/**
	    * Add a new xml object into the cache.
	    *
	    * @method Phaser.Cache#addXML
	    * @param {string} key - The key that this asset will be stored in the cache under. This should be unique within this cache.
	    * @param {string} url - The URL the asset was loaded from. If the asset was not loaded externally set to `null`.
	    * @param {object} data - Extra text data.
	    */addXML:function addXML(key,url,data){this._cache.xml[key]={url:url,data:data};this._resolveURL(url,this._cache.xml[key]);},/**
	    * Adds a Video file into the Cache. The file must have already been loaded, typically via Phaser.Loader.
	    *
	    * @method Phaser.Cache#addVideo
	    * @param {string} key - The key that this asset will be stored in the cache under. This should be unique within this cache.
	    * @param {string} url - The URL the asset was loaded from. If the asset was not loaded externally set to `null`.
	    * @param {object} data - Extra video data.
	    * @param {boolean} isBlob - True if the file was preloaded via xhr and the data parameter is a Blob. false if a Video tag was created instead.
	    */addVideo:function addVideo(key,url,data,isBlob){this._cache.video[key]={url:url,data:data,isBlob:isBlob,locked:true};this._resolveURL(url,this._cache.video[key]);},/**
	    * Adds a Fragment Shader in to the Cache. The file must have already been loaded, typically via Phaser.Loader.
	    *
	    * @method Phaser.Cache#addShader
	    * @param {string} key - The key that this asset will be stored in the cache under. This should be unique within this cache.
	    * @param {string} url - The URL the asset was loaded from. If the asset was not loaded externally set to `null`.
	    * @param {object} data - Extra shader data.
	    */addShader:function addShader(key,url,data){this._cache.shader[key]={url:url,data:data};this._resolveURL(url,this._cache.shader[key]);},/**
	    * Add a new Phaser.RenderTexture in to the cache.
	    *
	    * @method Phaser.Cache#addRenderTexture
	    * @param {string} key - The key that this asset will be stored in the cache under. This should be unique within this cache.
	    * @param {Phaser.RenderTexture} texture - The texture to use as the base of the RenderTexture.
	    */addRenderTexture:function addRenderTexture(key,texture){this._cache.renderTexture[key]={texture:texture,frame:new Phaser.Frame(0,0,0,texture.width,texture.height,'','')};},/**
	    * Add a new sprite sheet in to the cache.
	    *
	    * @method Phaser.Cache#addSpriteSheet
	    * @param {string} key - The key that this asset will be stored in the cache under. This should be unique within this cache.
	    * @param {string} url - The URL the asset was loaded from. If the asset was not loaded externally set to `null`.
	    * @param {object} data - Extra sprite sheet data.
	    * @param {number} frameWidth - Width of the sprite sheet.
	    * @param {number} frameHeight - Height of the sprite sheet.
	    * @param {number} [frameMax=-1] - How many frames stored in the sprite sheet. If -1 then it divides the whole sheet evenly.
	    * @param {number} [margin=0] - If the frames have been drawn with a margin, specify the amount here.
	    * @param {number} [spacing=0] - If the frames have been drawn with spacing between them, specify the amount here.
	    */addSpriteSheet:function addSpriteSheet(key,url,data,frameWidth,frameHeight,frameMax,margin,spacing){if(frameMax===undefined){frameMax=-1;}if(margin===undefined){margin=0;}if(spacing===undefined){spacing=0;}var obj={key:key,url:url,data:data,frameWidth:frameWidth,frameHeight:frameHeight,margin:margin,spacing:spacing,base:new PIXI.BaseTexture(data),frameData:Phaser.AnimationParser.spriteSheet(this.game,data,frameWidth,frameHeight,frameMax,margin,spacing)};this._cache.image[key]=obj;this._resolveURL(url,obj);},/**
	    * Add a new texture atlas to the Cache.
	    *
	    * @method Phaser.Cache#addTextureAtlas
	    * @param {string} key - The key that this asset will be stored in the cache under. This should be unique within this cache.
	    * @param {string} url - The URL the asset was loaded from. If the asset was not loaded externally set to `null`.
	    * @param {object} data - Extra texture atlas data.
	    * @param {object} atlasData  - Texture atlas frames data.
	    * @param {number} format - The format of the texture atlas.
	    */addTextureAtlas:function addTextureAtlas(key,url,data,atlasData,format){var obj={key:key,url:url,data:data,base:new PIXI.BaseTexture(data)};if(format===Phaser.Loader.TEXTURE_ATLAS_XML_STARLING){obj.frameData=Phaser.AnimationParser.XMLData(this.game,atlasData,key);}else if(format===Phaser.Loader.TEXTURE_ATLAS_JSON_PYXEL){obj.frameData=Phaser.AnimationParser.JSONDataPyxel(this.game,atlasData,key);}else{//  Let's just work it out from the frames array
	if(Array.isArray(atlasData.frames)){obj.frameData=Phaser.AnimationParser.JSONData(this.game,atlasData,key);}else{obj.frameData=Phaser.AnimationParser.JSONDataHash(this.game,atlasData,key);}}this._cache.image[key]=obj;this._resolveURL(url,obj);},////////////////////////////
	//  Sound Related Methods //
	////////////////////////////
	/**
	    * Reload a Sound file from the server.
	    *
	    * @method Phaser.Cache#reloadSound
	    * @param {string} key - The key of the asset within the cache.
	    */reloadSound:function reloadSound(key){var _this=this;var sound=this.getSound(key);if(sound){sound.data.src=sound.url;sound.data.addEventListener('canplaythrough',function(){return _this.reloadSoundComplete(key);},false);sound.data.load();}},/**
	    * Fires the onSoundUnlock event when the sound has completed reloading.
	    *
	    * @method Phaser.Cache#reloadSoundComplete
	    * @param {string} key - The key of the asset within the cache.
	    */reloadSoundComplete:function reloadSoundComplete(key){var sound=this.getSound(key);if(sound){sound.locked=false;this.onSoundUnlock.dispatch(key);}},/**
	    * Updates the sound object in the cache.
	    *
	    * @method Phaser.Cache#updateSound
	    * @param {string} key - The key of the asset within the cache.
	    */updateSound:function updateSound(key,property,value){var sound=this.getSound(key);if(sound){sound[property]=value;}},/**
	    * Add a new decoded sound.
	    *
	    * @method Phaser.Cache#decodedSound
	    * @param {string} key - The key of the asset within the cache.
	    * @param {object} data - Extra sound data.
	    */decodedSound:function decodedSound(key,data){var sound=this.getSound(key);sound.data=data;sound.decoded=true;sound.isDecoding=false;},/**
	    * Check if the given sound has finished decoding.
	    *
	    * @method Phaser.Cache#isSoundDecoded
	    * @param {string} key - The key of the asset within the cache.
	    * @return {boolean} The decoded state of the Sound object.
	    */isSoundDecoded:function isSoundDecoded(key){var sound=this.getItem(key,Phaser.Cache.SOUND,'isSoundDecoded');if(sound){return sound.decoded;}},/**
	    * Check if the given sound is ready for playback.
	    * A sound is considered ready when it has finished decoding and the device is no longer touch locked.
	    *
	    * @method Phaser.Cache#isSoundReady
	    * @param {string} key - The key of the asset within the cache.
	    * @return {boolean} True if the sound is decoded and the device is not touch locked.
	    */isSoundReady:function isSoundReady(key){var sound=this.getItem(key,Phaser.Cache.SOUND,'isSoundDecoded');if(sound){return sound.decoded&&!this.game.sound.touchLocked;}},////////////////////////
	//  Check Key Methods //
	////////////////////////
	/**
	    * Checks if a key for the given cache object type exists.
	    *
	    * @method Phaser.Cache#checkKey
	    * @param {integer} cache - The cache to search. One of the Cache consts such as `Phaser.Cache.IMAGE` or `Phaser.Cache.SOUND`.
	    * @param {string} key - The key of the asset within the cache.
	    * @return {boolean} True if the key exists, otherwise false.
	    */checkKey:function checkKey(cache,key){if(this._cacheMap[cache][key]){return true;}return false;},/**
	    * Checks if the given URL has been loaded into the Cache.
	    * This method will only work if Cache.autoResolveURL was set to `true` before any preloading took place.
	    * The method will make a DOM src call to the URL given, so please be aware of this for certain file types, such as Sound files on Firefox
	    * which may cause double-load instances.
	    *
	    * @method Phaser.Cache#checkURL
	    * @param {string} url - The url to check for in the cache.
	    * @return {boolean} True if the url exists, otherwise false.
	    */checkURL:function checkURL(url){if(this._urlMap[this._resolveURL(url)]){return true;}return false;},/**
	    * Checks if the given key exists in the Canvas Cache.
	    *
	    * @method Phaser.Cache#checkCanvasKey
	    * @param {string} key - The key of the asset within the cache.
	    * @return {boolean} True if the key exists in the cache, otherwise false.
	    */checkCanvasKey:function checkCanvasKey(key){return this.checkKey(Phaser.Cache.CANVAS,key);},/**
	    * Checks if the given key exists in the Image Cache. Note that this also includes Texture Atlases, Sprite Sheets and Retro Fonts.
	    *
	    * @method Phaser.Cache#checkImageKey
	    * @param {string} key - The key of the asset within the cache.
	    * @return {boolean} True if the key exists in the cache, otherwise false.
	    */checkImageKey:function checkImageKey(key){return this.checkKey(Phaser.Cache.IMAGE,key);},/**
	    * Checks if the given key exists in the Texture Cache.
	    *
	    * @method Phaser.Cache#checkTextureKey
	    * @param {string} key - The key of the asset within the cache.
	    * @return {boolean} True if the key exists in the cache, otherwise false.
	    */checkTextureKey:function checkTextureKey(key){return this.checkKey(Phaser.Cache.TEXTURE,key);},/**
	    * Checks if the given key exists in the Sound Cache.
	    *
	    * @method Phaser.Cache#checkSoundKey
	    * @param {string} key - The key of the asset within the cache.
	    * @return {boolean} True if the key exists in the cache, otherwise false.
	    */checkSoundKey:function checkSoundKey(key){return this.checkKey(Phaser.Cache.SOUND,key);},/**
	    * Checks if the given key exists in the Text Cache.
	    *
	    * @method Phaser.Cache#checkTextKey
	    * @param {string} key - The key of the asset within the cache.
	    * @return {boolean} True if the key exists in the cache, otherwise false.
	    */checkTextKey:function checkTextKey(key){return this.checkKey(Phaser.Cache.TEXT,key);},/**
	    * Checks if the given key exists in the Physics Cache.
	    *
	    * @method Phaser.Cache#checkPhysicsKey
	    * @param {string} key - The key of the asset within the cache.
	    * @return {boolean} True if the key exists in the cache, otherwise false.
	    */checkPhysicsKey:function checkPhysicsKey(key){return this.checkKey(Phaser.Cache.PHYSICS,key);},/**
	    * Checks if the given key exists in the Tilemap Cache.
	    *
	    * @method Phaser.Cache#checkTilemapKey
	    * @param {string} key - The key of the asset within the cache.
	    * @return {boolean} True if the key exists in the cache, otherwise false.
	    */checkTilemapKey:function checkTilemapKey(key){return this.checkKey(Phaser.Cache.TILEMAP,key);},/**
	    * Checks if the given key exists in the Binary Cache.
	    *
	    * @method Phaser.Cache#checkBinaryKey
	    * @param {string} key - The key of the asset within the cache.
	    * @return {boolean} True if the key exists in the cache, otherwise false.
	    */checkBinaryKey:function checkBinaryKey(key){return this.checkKey(Phaser.Cache.BINARY,key);},/**
	    * Checks if the given key exists in the BitmapData Cache.
	    *
	    * @method Phaser.Cache#checkBitmapDataKey
	    * @param {string} key - The key of the asset within the cache.
	    * @return {boolean} True if the key exists in the cache, otherwise false.
	    */checkBitmapDataKey:function checkBitmapDataKey(key){return this.checkKey(Phaser.Cache.BITMAPDATA,key);},/**
	    * Checks if the given key exists in the BitmapFont Cache.
	    *
	    * @method Phaser.Cache#checkBitmapFontKey
	    * @param {string} key - The key of the asset within the cache.
	    * @return {boolean} True if the key exists in the cache, otherwise false.
	    */checkBitmapFontKey:function checkBitmapFontKey(key){return this.checkKey(Phaser.Cache.BITMAPFONT,key);},/**
	    * Checks if the given key exists in the JSON Cache.
	    *
	    * @method Phaser.Cache#checkJSONKey
	    * @param {string} key - The key of the asset within the cache.
	    * @return {boolean} True if the key exists in the cache, otherwise false.
	    */checkJSONKey:function checkJSONKey(key){return this.checkKey(Phaser.Cache.JSON,key);},/**
	    * Checks if the given key exists in the XML Cache.
	    *
	    * @method Phaser.Cache#checkXMLKey
	    * @param {string} key - The key of the asset within the cache.
	    * @return {boolean} True if the key exists in the cache, otherwise false.
	    */checkXMLKey:function checkXMLKey(key){return this.checkKey(Phaser.Cache.XML,key);},/**
	    * Checks if the given key exists in the Video Cache.
	    *
	    * @method Phaser.Cache#checkVideoKey
	    * @param {string} key - The key of the asset within the cache.
	    * @return {boolean} True if the key exists in the cache, otherwise false.
	    */checkVideoKey:function checkVideoKey(key){return this.checkKey(Phaser.Cache.VIDEO,key);},/**
	    * Checks if the given key exists in the Fragment Shader Cache.
	    *
	    * @method Phaser.Cache#checkShaderKey
	    * @param {string} key - The key of the asset within the cache.
	    * @return {boolean} True if the key exists in the cache, otherwise false.
	    */checkShaderKey:function checkShaderKey(key){return this.checkKey(Phaser.Cache.SHADER,key);},/**
	    * Checks if the given key exists in the Render Texture Cache.
	    *
	    * @method Phaser.Cache#checkRenderTextureKey
	    * @param {string} key - The key of the asset within the cache.
	    * @return {boolean} True if the key exists in the cache, otherwise false.
	    */checkRenderTextureKey:function checkRenderTextureKey(key){return this.checkKey(Phaser.Cache.RENDER_TEXTURE,key);},////////////////
	//  Get Items //
	////////////////
	/**
	    * Get an item from a cache based on the given key and property.
	    *
	    * This method is mostly used internally by other Cache methods such as `getImage` but is exposed
	    * publicly for your own use as well.
	    *
	    * @method Phaser.Cache#getItem
	    * @param {string} key - The key of the asset within the cache.
	    * @param {integer} cache - The cache to search. One of the Cache consts such as `Phaser.Cache.IMAGE` or `Phaser.Cache.SOUND`.
	    * @param {string} [method] - The string name of the method calling getItem. Can be empty, in which case no console warning is output.
	    * @param {string} [property] - If you require a specific property from the cache item, specify it here.
	    * @return {object} The cached item if found, otherwise `null`. If the key is invalid and `method` is set then a console.warn is output.
	    */getItem:function getItem(key,cache,method,property){if(!this.checkKey(cache,key)){if(method){console.warn('Phaser.Cache.'+method+': Key "'+key+'" not found in Cache.');}}else{if(property===undefined){return this._cacheMap[cache][key];}else{return this._cacheMap[cache][key][property];}}return null;},/**
	    * Gets a Canvas object from the cache.
	    *
	    * The object is looked-up based on the key given.
	    *
	    * Note: If the object cannot be found a `console.warn` message is displayed.
	    *
	    * @method Phaser.Cache#getCanvas
	    * @param {string} key - The key of the asset to retrieve from the cache.
	    * @return {object} The canvas object or `null` if no item could be found matching the given key.
	    */getCanvas:function getCanvas(key){return this.getItem(key,Phaser.Cache.CANVAS,'getCanvas','canvas');},/**
	    * Gets a Image object from the cache. This returns a DOM Image object, not a Phaser.Image object.
	    *
	    * The object is looked-up based on the key given.
	    *
	    * Note: If the object cannot be found a `console.warn` message is displayed.
	    *
	    * Only the Image cache is searched, which covers images loaded via Loader.image, Sprite Sheets and Texture Atlases.
	    *
	    * If you need the image used by a bitmap font or similar then please use those respective 'get' methods.
	    *
	    * @method Phaser.Cache#getImage
	    * @param {string} [key] - The key of the asset to retrieve from the cache. If not given or null it will return a default image. If given but not found in the cache it will throw a warning and return the missing image.
	    * @param {boolean} [full=false] - If true the full image object will be returned, if false just the HTML Image object is returned.
	    * @return {Image} The Image object if found in the Cache, otherwise `null`. If `full` was true then a JavaScript object is returned.
	    */getImage:function getImage(key,full){if(key===undefined||key===null){key='__default';}if(full===undefined){full=false;}var img=this.getItem(key,Phaser.Cache.IMAGE,'getImage');if(img===null){img=this.getItem('__missing',Phaser.Cache.IMAGE,'getImage');}if(full){return img;}else{return img.data;}},/**
	    * Get a single texture frame by key.
	    *
	    * You'd only do this to get the default Frame created for a non-atlas / spritesheet image.
	    *
	    * @method Phaser.Cache#getTextureFrame
	    * @param {string} key - The key of the asset to retrieve from the cache.
	    * @return {Phaser.Frame} The frame data.
	    */getTextureFrame:function getTextureFrame(key){return this.getItem(key,Phaser.Cache.TEXTURE,'getTextureFrame','frame');},/**
	    * Gets a Phaser.Sound object from the cache.
	    *
	    * The object is looked-up based on the key given.
	    *
	    * Note: If the object cannot be found a `console.warn` message is displayed.
	    *
	    * @method Phaser.Cache#getSound
	    * @param {string} key - The key of the asset to retrieve from the cache.
	    * @return {Phaser.Sound} The sound object.
	    */getSound:function getSound(key){return this.getItem(key,Phaser.Cache.SOUND,'getSound');},/**
	    * Gets a raw Sound data object from the cache.
	    *
	    * The object is looked-up based on the key given.
	    *
	    * Note: If the object cannot be found a `console.warn` message is displayed.
	    *
	    * @method Phaser.Cache#getSoundData
	    * @param {string} key - The key of the asset to retrieve from the cache.
	    * @return {object} The sound data.
	    */getSoundData:function getSoundData(key){return this.getItem(key,Phaser.Cache.SOUND,'getSoundData','data');},/**
	    * Gets a Text object from the cache.
	    *
	    * The object is looked-up based on the key given.
	    *
	    * Note: If the object cannot be found a `console.warn` message is displayed.
	    *
	    * @method Phaser.Cache#getText
	    * @param {string} key - The key of the asset to retrieve from the cache.
	    * @return {object} The text data.
	    */getText:function getText(key){return this.getItem(key,Phaser.Cache.TEXT,'getText','data');},/**
	    * Gets a Physics Data object from the cache.
	    *
	    * The object is looked-up based on the key given.
	    *
	    * Note: If the object cannot be found a `console.warn` message is displayed.
	    *
	    * You can get either the entire data set, a single object or a single fixture of an object from it.
	    *
	    * @method Phaser.Cache#getPhysicsData
	    * @param {string} key - The key of the asset to retrieve from the cache.
	    * @param {string} [object=null] - If specified it will return just the physics object that is part of the given key, if null it will return them all.
	    * @param {string} fixtureKey - Fixture key of fixture inside an object. This key can be set per fixture with the Phaser Exporter.
	    * @return {object} The requested physics object data if found.
	    */getPhysicsData:function getPhysicsData(key,object,fixtureKey){var data=this.getItem(key,Phaser.Cache.PHYSICS,'getPhysicsData','data');if(data===null||object===undefined||object===null){return data;}else{if(data[object]){var fixtures=data[object];//  Try to find a fixture by its fixture key if given
	if(fixtures&&fixtureKey){for(var fixture in fixtures){//  This contains the fixture data of a polygon or a circle
	fixture=fixtures[fixture];//  Test the key
	if(fixture.fixtureKey===fixtureKey){return fixture;}}//  We did not find the requested fixture
	console.warn('Phaser.Cache.getPhysicsData: Could not find given fixtureKey: "'+fixtureKey+' in '+key+'"');}else{return fixtures;}}else{console.warn('Phaser.Cache.getPhysicsData: Invalid key/object: "'+key+' / '+object+'"');}}return null;},/**
	    * Gets a raw Tilemap data object from the cache. This will be in either CSV or JSON format.
	    *
	    * The object is looked-up based on the key given.
	    *
	    * Note: If the object cannot be found a `console.warn` message is displayed.
	    *
	    * @method Phaser.Cache#getTilemapData
	    * @param {string} key - The key of the asset to retrieve from the cache.
	    * @return {object} The raw tilemap data in CSV or JSON format.
	    */getTilemapData:function getTilemapData(key){return this.getItem(key,Phaser.Cache.TILEMAP,'getTilemapData');},/**
	    * Gets a binary object from the cache.
	    *
	    * The object is looked-up based on the key given.
	    *
	    * Note: If the object cannot be found a `console.warn` message is displayed.
	    *
	    * @method Phaser.Cache#getBinary
	    * @param {string} key - The key of the asset to retrieve from the cache.
	    * @return {object} The binary data object.
	    */getBinary:function getBinary(key){return this.getItem(key,Phaser.Cache.BINARY,'getBinary');},/**
	    * Gets a BitmapData object from the cache.
	    *
	    * The object is looked-up based on the key given.
	    *
	    * Note: If the object cannot be found a `console.warn` message is displayed.
	    *
	    * @method Phaser.Cache#getBitmapData
	    * @param {string} key - The key of the asset to retrieve from the cache.
	    * @return {Phaser.BitmapData} The requested BitmapData object if found, or null if not.
	    */getBitmapData:function getBitmapData(key){return this.getItem(key,Phaser.Cache.BITMAPDATA,'getBitmapData','data');},/**
	    * Gets a Bitmap Font object from the cache.
	    *
	    * The object is looked-up based on the key given.
	    *
	    * Note: If the object cannot be found a `console.warn` message is displayed.
	    *
	    * @method Phaser.Cache#getBitmapFont
	    * @param {string} key - The key of the asset to retrieve from the cache.
	    * @return {Phaser.BitmapFont} The requested BitmapFont object if found, or null if not.
	    */getBitmapFont:function getBitmapFont(key){return this.getItem(key,Phaser.Cache.BITMAPFONT,'getBitmapFont');},/**
	    * Gets a JSON object from the cache.
	    *
	    * The object is looked-up based on the key given.
	    *
	    * Note: If the object cannot be found a `console.warn` message is displayed.
	    *
	    * You can either return the object by reference (the default), or return a clone
	    * of it by setting the `clone` argument to `true`.
	    *
	    * @method Phaser.Cache#getJSON
	    * @param {string} key - The key of the asset to retrieve from the cache.
	    * @param {boolean} [clone=false] - Return a clone of the original object (true) or a reference to it? (false)
	    * @return {object} The JSON object, or an Array if the key points to an Array property. If the property wasn't found, it returns null.
	    */getJSON:function getJSON(key,clone){var data=this.getItem(key,Phaser.Cache.JSON,'getJSON','data');if(data){if(clone){return Phaser.Utils.extend(true,Array.isArray(data)?[]:{},data);}else{return data;}}else{return null;}},/**
	    * Gets an XML object from the cache.
	    *
	    * The object is looked-up based on the key given.
	    *
	    * Note: If the object cannot be found a `console.warn` message is displayed.
	    *
	    * @method Phaser.Cache#getXML
	    * @param {string} key - The key of the asset to retrieve from the cache.
	    * @return {object} The XML object.
	    */getXML:function getXML(key){return this.getItem(key,Phaser.Cache.XML,'getXML','data');},/**
	    * Gets a Phaser.Video object from the cache.
	    *
	    * The object is looked-up based on the key given.
	    *
	    * Note: If the object cannot be found a `console.warn` message is displayed.
	    *
	    * @method Phaser.Cache#getVideo
	    * @param {string} key - The key of the asset to retrieve from the cache.
	    * @return {Phaser.Video} The video object.
	    */getVideo:function getVideo(key){return this.getItem(key,Phaser.Cache.VIDEO,'getVideo');},/**
	    * Gets a fragment shader object from the cache.
	    *
	    * The object is looked-up based on the key given.
	    *
	    * Note: If the object cannot be found a `console.warn` message is displayed.
	    *
	    * @method Phaser.Cache#getShader
	    * @param {string} key - The key of the asset to retrieve from the cache.
	    * @return {string} The shader object.
	    */getShader:function getShader(key){return this.getItem(key,Phaser.Cache.SHADER,'getShader','data');},/**
	    * Gets a RenderTexture object from the cache.
	    *
	    * The object is looked-up based on the key given.
	    *
	    * Note: If the object cannot be found a `console.warn` message is displayed.
	    *
	    * @method Phaser.Cache#getRenderTexture
	    * @param {string} key - The key of the asset to retrieve from the cache.
	    * @return {Object} The object with Phaser.RenderTexture and Phaser.Frame.
	    */getRenderTexture:function getRenderTexture(key){return this.getItem(key,Phaser.Cache.RENDER_TEXTURE,'getRenderTexture');},////////////////////////////
	//  Frame Related Methods //
	////////////////////////////
	/**
	    * Gets a PIXI.BaseTexture by key from the given Cache.
	    *
	    * @method Phaser.Cache#getBaseTexture
	    * @param {string} key - Asset key of the image for which you want the BaseTexture for.
	    * @param {integer} [cache=Phaser.Cache.IMAGE] - The cache to search for the item in.
	    * @return {PIXI.BaseTexture} The BaseTexture object.
	    */getBaseTexture:function getBaseTexture(key,cache){if(cache===undefined){cache=Phaser.Cache.IMAGE;}return this.getItem(key,cache,'getBaseTexture','base');},/**
	    * Get a single frame by key. You'd only do this to get the default Frame created for a non-atlas/spritesheet image.
	    *
	    * @method Phaser.Cache#getFrame
	    * @param {string} key - Asset key of the frame data to retrieve from the Cache.
	    * @param {integer} [cache=Phaser.Cache.IMAGE] - The cache to search for the item in.
	    * @return {Phaser.Frame} The frame data.
	    */getFrame:function getFrame(key,cache){if(cache===undefined){cache=Phaser.Cache.IMAGE;}return this.getItem(key,cache,'getFrame','frame');},/**
	    * Get the total number of frames contained in the FrameData object specified by the given key.
	    *
	    * @method Phaser.Cache#getFrameCount
	    * @param {string} key - Asset key of the FrameData you want.
	    * @param {integer} [cache=Phaser.Cache.IMAGE] - The cache to search for the item in.
	    * @return {number} Then number of frames. 0 if the image is not found.
	    */getFrameCount:function getFrameCount(key,cache){var data=this.getFrameData(key,cache);if(data){return data.total;}else{return 0;}},/**
	    * Gets a Phaser.FrameData object from the Image Cache.
	    *
	    * The object is looked-up based on the key given.
	    *
	    * Note: If the object cannot be found a `console.warn` message is displayed.
	    *
	    * @method Phaser.Cache#getFrameData
	    * @param {string} key - Asset key of the frame data to retrieve from the Cache.
	    * @param {integer} [cache=Phaser.Cache.IMAGE] - The cache to search for the item in.
	    * @return {Phaser.FrameData} The frame data.
	    */getFrameData:function getFrameData(key,cache){if(cache===undefined){cache=Phaser.Cache.IMAGE;}return this.getItem(key,cache,'getFrameData','frameData');},/**
	    * Check if the FrameData for the given key exists in the Image Cache.
	    *
	    * @method Phaser.Cache#hasFrameData
	    * @param {string} key - Asset key of the frame data to retrieve from the Cache.
	    * @param {integer} [cache=Phaser.Cache.IMAGE] - The cache to search for the item in.
	    * @return {boolean} True if the given key has frameData in the cache, otherwise false.
	    */hasFrameData:function hasFrameData(key,cache){if(cache===undefined){cache=Phaser.Cache.IMAGE;}return this.getItem(key,cache,'','frameData')!==null;},/**
	    * Replaces a set of frameData with a new Phaser.FrameData object.
	    *
	    * @method Phaser.Cache#updateFrameData
	    * @param {string} key - The unique key by which you will reference this object.
	    * @param {number} frameData - The new FrameData.
	    * @param {integer} [cache=Phaser.Cache.IMAGE] - The cache to search. One of the Cache consts such as `Phaser.Cache.IMAGE` or `Phaser.Cache.SOUND`.
	    */updateFrameData:function updateFrameData(key,frameData,cache){if(cache===undefined){cache=Phaser.Cache.IMAGE;}if(this._cacheMap[cache][key]){this._cacheMap[cache][key].frameData=frameData;}},/**
	    * Get a single frame out of a frameData set by key.
	    *
	    * @method Phaser.Cache#getFrameByIndex
	    * @param {string} key - Asset key of the frame data to retrieve from the Cache.
	    * @param {number} index - The index of the frame you want to get.
	    * @param {integer} [cache=Phaser.Cache.IMAGE] - The cache to search. One of the Cache consts such as `Phaser.Cache.IMAGE` or `Phaser.Cache.SOUND`.
	    * @return {Phaser.Frame} The frame object.
	    */getFrameByIndex:function getFrameByIndex(key,index,cache){var data=this.getFrameData(key,cache);if(data){return data.getFrame(index);}else{return null;}},/**
	    * Get a single frame out of a frameData set by key.
	    *
	    * @method Phaser.Cache#getFrameByName
	    * @param {string} key - Asset key of the frame data to retrieve from the Cache.
	    * @param {string} name - The name of the frame you want to get.
	    * @param {integer} [cache=Phaser.Cache.IMAGE] - The cache to search. One of the Cache consts such as `Phaser.Cache.IMAGE` or `Phaser.Cache.SOUND`.
	    * @return {Phaser.Frame} The frame object.
	    */getFrameByName:function getFrameByName(key,name,cache){var data=this.getFrameData(key,cache);if(data){return data.getFrameByName(name);}else{return null;}},/**
	    * Get a cached object by the URL.
	    * This only returns a value if you set Cache.autoResolveURL to `true` *before* starting the preload of any assets.
	    * Be aware that every call to this function makes a DOM src query, so use carefully and double-check for implications in your target browsers/devices.
	    *
	    * @method Phaser.Cache#getURL
	    * @param {string} url - The url for the object loaded to get from the cache.
	    * @return {object} The cached object.
	    */getURL:function getURL(url){var url=this._resolveURL(url);if(url){return this._urlMap[url];}else{console.warn('Phaser.Cache.getUrl: Invalid url: "'+url+'" or Cache.autoResolveURL was false');return null;}},/**
	    * Gets all keys used in the requested Cache.
	    *
	    * @method Phaser.Cache#getKeys
	    * @param {integer} [cache=Phaser.Cache.IMAGE] - The Cache you wish to get the keys from. Can be any of the Cache consts such as `Phaser.Cache.IMAGE`, `Phaser.Cache.SOUND` etc.
	    * @return {Array} The array of keys in the requested cache.
	    */getKeys:function getKeys(cache){if(cache===undefined){cache=Phaser.Cache.IMAGE;}var out=[];if(this._cacheMap[cache]){for(var key in this._cacheMap[cache]){if(key!=='__default'&&key!=='__missing'){out.push(key);}}}return out;},/////////////////////
	//  Remove Methods //
	/////////////////////
	/**
	    * Removes a canvas from the cache.
	    *
	    * Note that this only removes it from the Phaser.Cache. If you still have references to the data elsewhere
	    * then it will persist in memory.
	    *
	    * @method Phaser.Cache#removeCanvas
	    * @param {string} key - Key of the asset you want to remove.
	    */removeCanvas:function removeCanvas(key){delete this._cache.canvas[key];},/**
	    * Removes an image from the cache.
	    *
	    * You can optionally elect to destroy it as well. This calls BaseTexture.destroy on it.
	    *
	    * Note that this only removes it from the Phaser Cache. If you still have references to the data elsewhere
	    * then it will persist in memory.
	    *
	    * @method Phaser.Cache#removeImage
	    * @param {string} key - Key of the asset you want to remove.
	    * @param {boolean} [destroyBaseTexture=true] - Should the BaseTexture behind this image also be destroyed?
	    */removeImage:function removeImage(key,destroyBaseTexture){if(destroyBaseTexture===undefined){destroyBaseTexture=true;}var img=this.getImage(key,true);if(destroyBaseTexture&&img.base){img.base.destroy();}delete this._cache.image[key];},/**
	    * Removes a sound from the cache.
	    *
	    * If any `Phaser.Sound` objects use the audio file in the cache that you remove with this method, they will
	    * _automatically_ destroy themselves. If you wish to have full control over when Sounds are destroyed then
	    * you must finish your house-keeping and destroy them all yourself first, before calling this method.
	    *
	    * Note that this only removes it from the Phaser.Cache. If you still have references to the data elsewhere
	    * then it will persist in memory.
	    *
	    * @method Phaser.Cache#removeSound
	    * @param {string} key - Key of the asset you want to remove.
	    */removeSound:function removeSound(key){delete this._cache.sound[key];},/**
	    * Removes a text file from the cache.
	    *
	    * Note that this only removes it from the Phaser.Cache. If you still have references to the data elsewhere
	    * then it will persist in memory.
	    *
	    * @method Phaser.Cache#removeText
	    * @param {string} key - Key of the asset you want to remove.
	    */removeText:function removeText(key){delete this._cache.text[key];},/**
	    * Removes a physics data file from the cache.
	    *
	    * Note that this only removes it from the Phaser.Cache. If you still have references to the data elsewhere
	    * then it will persist in memory.
	    *
	    * @method Phaser.Cache#removePhysics
	    * @param {string} key - Key of the asset you want to remove.
	    */removePhysics:function removePhysics(key){delete this._cache.physics[key];},/**
	    * Removes a tilemap from the cache.
	    *
	    * Note that this only removes it from the Phaser.Cache. If you still have references to the data elsewhere
	    * then it will persist in memory.
	    *
	    * @method Phaser.Cache#removeTilemap
	    * @param {string} key - Key of the asset you want to remove.
	    */removeTilemap:function removeTilemap(key){delete this._cache.tilemap[key];},/**
	    * Removes a binary file from the cache.
	    *
	    * Note that this only removes it from the Phaser.Cache. If you still have references to the data elsewhere
	    * then it will persist in memory.
	    *
	    * @method Phaser.Cache#removeBinary
	    * @param {string} key - Key of the asset you want to remove.
	    */removeBinary:function removeBinary(key){delete this._cache.binary[key];},/**
	    * Removes a bitmap data from the cache.
	    *
	    * Note that this only removes it from the Phaser.Cache. If you still have references to the data elsewhere
	    * then it will persist in memory.
	    *
	    * @method Phaser.Cache#removeBitmapData
	    * @param {string} key - Key of the asset you want to remove.
	    */removeBitmapData:function removeBitmapData(key){delete this._cache.bitmapData[key];},/**
	    * Removes a bitmap font from the cache.
	    *
	    * Note that this only removes it from the Phaser.Cache. If you still have references to the data elsewhere
	    * then it will persist in memory.
	    *
	    * @method Phaser.Cache#removeBitmapFont
	    * @param {string} key - Key of the asset you want to remove.
	    */removeBitmapFont:function removeBitmapFont(key){delete this._cache.bitmapFont[key];},/**
	    * Removes a json object from the cache.
	    *
	    * Note that this only removes it from the Phaser.Cache. If you still have references to the data elsewhere
	    * then it will persist in memory.
	    *
	    * @method Phaser.Cache#removeJSON
	    * @param {string} key - Key of the asset you want to remove.
	    */removeJSON:function removeJSON(key){delete this._cache.json[key];},/**
	    * Removes a xml object from the cache.
	    *
	    * Note that this only removes it from the Phaser.Cache. If you still have references to the data elsewhere
	    * then it will persist in memory.
	    *
	    * @method Phaser.Cache#removeXML
	    * @param {string} key - Key of the asset you want to remove.
	    */removeXML:function removeXML(key){delete this._cache.xml[key];},/**
	    * Removes a video from the cache.
	    *
	    * Note that this only removes it from the Phaser.Cache. If you still have references to the data elsewhere
	    * then it will persist in memory.
	    *
	    * @method Phaser.Cache#removeVideo
	    * @param {string} key - Key of the asset you want to remove.
	    */removeVideo:function removeVideo(key){delete this._cache.video[key];},/**
	    * Removes a shader from the cache.
	    *
	    * Note that this only removes it from the Phaser.Cache. If you still have references to the data elsewhere
	    * then it will persist in memory.
	    *
	    * @method Phaser.Cache#removeShader
	    * @param {string} key - Key of the asset you want to remove.
	    */removeShader:function removeShader(key){delete this._cache.shader[key];},/**
	    * Removes a Render Texture from the cache.
	    *
	    * Note that this only removes it from the Phaser.Cache. If you still have references to the data elsewhere
	    * then it will persist in memory.
	    *
	    * @method Phaser.Cache#removeRenderTexture
	    * @param {string} key - Key of the asset you want to remove.
	    */removeRenderTexture:function removeRenderTexture(key){delete this._cache.renderTexture[key];},/**
	    * Removes a Sprite Sheet from the cache.
	    *
	    * Note that this only removes it from the Phaser.Cache. If you still have references to the data elsewhere
	    * then it will persist in memory.
	    *
	    * @method Phaser.Cache#removeSpriteSheet
	    * @param {string} key - Key of the asset you want to remove.
	    */removeSpriteSheet:function removeSpriteSheet(key){delete this._cache.spriteSheet[key];},/**
	    * Removes a Texture Atlas from the cache.
	    *
	    * Note that this only removes it from the Phaser.Cache. If you still have references to the data elsewhere
	    * then it will persist in memory.
	    *
	    * @method Phaser.Cache#removeTextureAtlas
	    * @param {string} key - Key of the asset you want to remove.
	    */removeTextureAtlas:function removeTextureAtlas(key){delete this._cache.atlas[key];},/**
	    * Empties out all of the GL Textures from Images stored in the cache.
	    * This is called automatically when the WebGL context is lost and then restored.
	    *
	    * @method Phaser.Cache#clearGLTextures
	    * @protected
	    */clearGLTextures:function clearGLTextures(){for(var key in this._cache.image){this._cache.image[key].base._glTextures=[];}},/**
	    * Resolves a URL to its absolute form and stores it in Cache._urlMap as long as Cache.autoResolveURL is set to `true`.
	    * This is then looked-up by the Cache.getURL and Cache.checkURL calls.
	    *
	    * @method Phaser.Cache#_resolveURL
	    * @private
	    * @param {string} url - The URL to resolve. This is appended to Loader.baseURL.
	    * @param {object} [data] - The data associated with the URL to be stored to the URL Map.
	    * @return {string} The resolved URL.
	    */_resolveURL:function _resolveURL(url,data){if(!this.autoResolveURL){return null;}this._urlResolver.src=this.game.load.baseURL+url;this._urlTemp=this._urlResolver.src;//  Ensure no request is actually made
	this._urlResolver.src='';//  Record the URL to the map
	if(data){this._urlMap[this._urlTemp]=data;}return this._urlTemp;},/**
	    * Clears the cache. Removes every local cache object reference.
	    * If an object in the cache has a `destroy` method it will also be called.
	    *
	    * @method Phaser.Cache#destroy
	    */destroy:function destroy(){for(var i=0;i<this._cacheMap.length;i++){var cache=this._cacheMap[i];for(var key in cache){if(key!=='__default'&&key!=='__missing'){if(cache[key]['destroy']){cache[key].destroy();}delete cache[key];}}}this._urlMap=null;this._urlResolver=null;this._urlTemp=null;}};Phaser.Cache.prototype.constructor=Phaser.Cache;/* jshint wsh:true *//**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Loader handles loading all external content such as Images, Sounds, Texture Atlases and data files.
	*
	* The loader uses a combination of tag loading (eg. Image elements) and XHR and provides progress and completion callbacks.
	*
	* Parallel loading (see {@link #enableParallel}) is supported and enabled by default.
	* Load-before behavior of parallel resources is controlled by synchronization points as discussed in {@link #withSyncPoint}.
	*
	* Texture Atlases can be created with tools such as [Texture Packer](https://www.codeandweb.com/texturepacker/phaser) and
	* [Shoebox](http://renderhjs.net/shoebox/)
	*
	* @class Phaser.Loader
	* @param {Phaser.Game} game - A reference to the currently running game.
	*/Phaser.Loader=function(game){/**
	    * Local reference to game.
	    * @property {Phaser.Game} game
	    * @protected
	    */this.game=game;/**
	    * Local reference to the Phaser.Cache.
	    * @property {Phaser.Cache} cache
	    * @protected
	    */this.cache=game.cache;/**
	    * If true all calls to Loader.reset will be ignored. Useful if you need to create a load queue before swapping to a preloader state.
	    * @property {boolean} resetLocked
	    * @default
	    */this.resetLocked=false;/**
	    * True if the Loader is in the process of loading the queue.
	    * @property {boolean} isLoading
	    * @default
	    */this.isLoading=false;/**
	    * True if all assets in the queue have finished loading.
	    * @property {boolean} hasLoaded
	    * @default
	    */this.hasLoaded=false;/**
	    * You can optionally link a progress sprite with {@link Phaser.Loader#setPreloadSprite setPreloadSprite}.
	    *
	    * This property is an object containing: sprite, rect, direction, width and height
	    *
	    * @property {?object} preloadSprite
	    * @protected
	    */this.preloadSprite=null;/**
	    * The crossOrigin value applied to loaded images. Very often this needs to be set to 'anonymous'.
	    * @property {boolean|string} crossOrigin
	    * @default
	    */this.crossOrigin=false;/**
	    * If you want to append a URL before the path of any asset you can set this here.
	    * Useful if allowing the asset base url to be configured outside of the game code.
	    * The string _must_ end with a "/".
	    *
	    * @property {string} baseURL
	    */this.baseURL='';/**
	    * The value of `path`, if set, is placed before any _relative_ file path given. For example:
	    *
	    * `load.path = "images/sprites/";
	    * load.image("ball", "ball.png");
	    * load.image("tree", "level1/oaktree.png");
	    * load.image("boom", "http://server.com/explode.png");`
	    *
	    * Would load the `ball` file from `images/sprites/ball.png` and the tree from
	    * `images/sprites/level1/oaktree.png` but the file `boom` would load from the URL
	    * given as it's an absolute URL.
	    *
	    * Please note that the path is added before the filename but *after* the baseURL (if set.)
	    *
	    * The string _must_ end with a "/".
	    *
	    * @property {string} path
	    */this.path='';/**
	    * Used to map the application mime-types to to the Accept header in XHR requests.
	    * If you don't require these mappings, or they cause problems on your server, then
	    * remove them from the headers object and the XHR request will not try to use them.
	    *
	    * This object can also be used to set the `X-Requested-With` header to 
	    * `XMLHttpRequest` (or any other value you need). To enable this do:
	    *
	    * `this.load.headers.requestedWith = 'XMLHttpRequest'`
	    *
	    * before adding anything to the Loader. The XHR loader will then call:
	    *
	    * `setRequestHeader('X-Requested-With', this.headers['requestedWith'])`
	    * 
	    * @property {object} headers
	    * @default
	    */this.headers={"requestedWith":false,"json":"application/json","xml":"application/xml"};/**
	     * This event is dispatched when the loading process starts: before the first file has been requested,
	    * but after all the initial packs have been loaded.
	    *
	    * @property {Phaser.Signal} onLoadStart
	    */this.onLoadStart=new Phaser.Signal();/**
	    * This event is dispatched when the final file in the load queue has either loaded or failed.
	    *
	    * @property {Phaser.Signal} onLoadComplete
	    */this.onLoadComplete=new Phaser.Signal();/**
	    * This event is dispatched when an asset pack has either loaded or failed to load.
	    *
	    * This is called when the asset pack manifest file has loaded and successfully added its contents to the loader queue.
	    *
	    * Params: `(pack key, success?, total packs loaded, total packs)`
	    *
	    * @property {Phaser.Signal} onPackComplete
	    */this.onPackComplete=new Phaser.Signal();/**
	    * This event is dispatched immediately before a file starts loading.
	    * It's possible the file may fail (eg. download error, invalid format) after this event is sent.
	    *
	    * Params: `(progress, file key, file url)`
	    *
	    * @property {Phaser.Signal} onFileStart
	    */this.onFileStart=new Phaser.Signal();/**
	    * This event is dispatched when a file has either loaded or failed to load.
	    *
	    * Any function bound to this will receive the following parameters:
	    *
	    * progress, file key, success?, total loaded files, total files
	    *
	    * Where progress is a number between 1 and 100 (inclusive) representing the percentage of the load.
	    *
	    * @property {Phaser.Signal} onFileComplete
	    */this.onFileComplete=new Phaser.Signal();/**
	    * This event is dispatched when a file (or pack) errors as a result of the load request.
	    *
	    * For files it will be triggered before `onFileComplete`. For packs it will be triggered before `onPackComplete`.
	    *
	    * Params: `(file key, file)`
	    *
	    * @property {Phaser.Signal} onFileError
	    */this.onFileError=new Phaser.Signal();/**
	    * If true and if the browser supports XDomainRequest, it will be used in preference for XHR.
	    *
	    * This is only relevant for IE 9 and should _only_ be enabled for IE 9 clients when required by the server/CDN.
	    *
	    * @property {boolean} useXDomainRequest
	    * @deprecated This is only relevant for IE 9.
	    */this.useXDomainRequest=false;/**
	    * @private
	    * @property {boolean} _warnedAboutXDomainRequest - Control number of warnings for using XDR outside of IE 9.
	    */this._warnedAboutXDomainRequest=false;/**
	    * If true (the default) then parallel downloading will be enabled.
	    *
	    * To disable all parallel downloads this must be set to false prior to any resource being loaded.
	    *
	    * @property {boolean} enableParallel
	    */this.enableParallel=true;/**
	    * The number of concurrent / parallel resources to try and fetch at once.
	    *
	    * Many current browsers limit 6 requests per domain; this is slightly conservative.
	    *
	    * @property {integer} maxParallelDownloads
	    * @protected
	    */this.maxParallelDownloads=4;/**
	    * A counter: if more than zero, files will be automatically added as a synchronization point.
	    * @property {integer} _withSyncPointDepth;
	    */this._withSyncPointDepth=0;/**
	    * Contains all the information for asset files (including packs) to load.
	    *
	    * File/assets are only removed from the list after all loading completes.
	    *
	    * @property {file[]} _fileList
	    * @private
	    */this._fileList=[];/**
	    * Inflight files (or packs) that are being fetched/processed.
	    *
	    * This means that if there are any files in the flight queue there should still be processing
	    * going on; it should only be empty before or after loading.
	    *
	    * The files in the queue may have additional properties added to them,
	    * including `requestObject` which is normally the associated XHR.
	    *
	    * @property {file[]} _flightQueue
	    * @private
	    */this._flightQueue=[];/**
	    * The offset into the fileList past all the complete (loaded or error) entries.
	    *
	    * @property {integer} _processingHead
	    * @private
	    */this._processingHead=0;/**
	    * True when the first file (not pack) has loading started.
	    * This used to to control dispatching `onLoadStart` which happens after any initial packs are loaded.
	    *
	    * @property {boolean} _initialPacksLoaded
	    * @private
	    */this._fileLoadStarted=false;/**
	    * Total packs seen - adjusted when a pack is added.
	    * @property {integer} _totalPackCount
	    * @private
	    */this._totalPackCount=0;/**
	    * Total files seen - adjusted when a file is added.
	    * @property {integer} _totalFileCount
	    * @private
	    */this._totalFileCount=0;/**
	    * Total packs loaded - adjusted just prior to `onPackComplete`.
	    * @property {integer} _loadedPackCount
	    * @private
	    */this._loadedPackCount=0;/**
	    * Total files loaded - adjusted just prior to `onFileComplete`.
	    * @property {integer} _loadedFileCount
	    * @private
	    */this._loadedFileCount=0;};/**
	* @constant
	* @type {number}
	*/Phaser.Loader.TEXTURE_ATLAS_JSON_ARRAY=0;/**
	* @constant
	* @type {number}
	*/Phaser.Loader.TEXTURE_ATLAS_JSON_HASH=1;/**
	* @constant
	* @type {number}
	*/Phaser.Loader.TEXTURE_ATLAS_XML_STARLING=2;/**
	* @constant
	* @type {number}
	*/Phaser.Loader.PHYSICS_LIME_CORONA_JSON=3;/**
	* @constant
	* @type {number}
	*/Phaser.Loader.PHYSICS_PHASER_JSON=4;/**
	* @constant
	* @type {number}
	*/Phaser.Loader.TEXTURE_ATLAS_JSON_PYXEL=5;Phaser.Loader.prototype={/**
	    * Set a Sprite to be a "preload" sprite by passing it to this method.
	    *
	    * A "preload" sprite will have its width or height crop adjusted based on the percentage of the loader in real-time.
	    * This allows you to easily make loading bars for games.
	    *
	    * The sprite will automatically be made visible when calling this.
	    *
	    * @method Phaser.Loader#setPreloadSprite
	    * @param {Phaser.Sprite|Phaser.Image} sprite - The sprite or image that will be cropped during the load.
	    * @param {number} [direction=0] - A value of zero means the sprite will be cropped horizontally, a value of 1 means its will be cropped vertically.
	    */setPreloadSprite:function setPreloadSprite(sprite,direction){direction=direction||0;this.preloadSprite={sprite:sprite,direction:direction,width:sprite.width,height:sprite.height,rect:null};if(direction===0){//  Horizontal rect
	this.preloadSprite.rect=new Phaser.Rectangle(0,0,1,sprite.height);}else{//  Vertical rect
	this.preloadSprite.rect=new Phaser.Rectangle(0,0,sprite.width,1);}sprite.crop(this.preloadSprite.rect);sprite.visible=true;},/**
	    * Called automatically by ScaleManager when the game resizes in RESIZE scalemode.
	    *
	    * This can be used to adjust the preloading sprite size, eg.
	    *
	    * @method Phaser.Loader#resize
	    * @protected
	    */resize:function resize(){if(this.preloadSprite&&this.preloadSprite.height!==this.preloadSprite.sprite.height){this.preloadSprite.rect.height=this.preloadSprite.sprite.height;}},/**
	    * Check whether a file/asset with a specific key is queued to be loaded.
	    *
	    * To access a loaded asset use Phaser.Cache, eg. {@link Phaser.Cache#checkImageKey}
	    *
	    * @method Phaser.Loader#checkKeyExists
	    * @param {string} type - The type asset you want to check.
	    * @param {string} key - Key of the asset you want to check.
	    * @return {boolean} Return true if exists, otherwise return false.
	    */checkKeyExists:function checkKeyExists(type,key){return this.getAssetIndex(type,key)>-1;},/**
	    * Get the queue-index of the file/asset with a specific key.
	    *
	    * Only assets in the download file queue will be found.
	    *
	    * @method Phaser.Loader#getAssetIndex
	    * @param {string} type - The type asset you want to check.
	    * @param {string} key - Key of the asset you want to check.
	    * @return {number} The index of this key in the filelist, or -1 if not found.
	    *     The index may change and should only be used immediately following this call
	    */getAssetIndex:function getAssetIndex(type,key){var bestFound=-1;for(var i=0;i<this._fileList.length;i++){var file=this._fileList[i];if(file.type===type&&file.key===key){bestFound=i;// An already loaded/loading file may be superceded.
	if(!file.loaded&&!file.loading){break;}}}return bestFound;},/**
	    * Find a file/asset with a specific key.
	    *
	    * Only assets in the download file queue will be found.
	    *
	    * @method Phaser.Loader#getAsset
	    * @param {string} type - The type asset you want to check.
	    * @param {string} key - Key of the asset you want to check.
	    * @return {any} Returns an object if found that has 2 properties: `index` and `file`; otherwise a non-true value is returned.
	    *     The index may change and should only be used immediately following this call.
	    */getAsset:function getAsset(type,key){var fileIndex=this.getAssetIndex(type,key);if(fileIndex>-1){return{index:fileIndex,file:this._fileList[fileIndex]};}return false;},/**
	    * Reset the loader and clear any queued assets. If `Loader.resetLocked` is true this operation will abort.
	    *
	    * This will abort any loading and clear any queued assets.
	    *
	    * Optionally you can clear any associated events.
	    *
	    * @method Phaser.Loader#reset
	    * @protected
	    * @param {boolean} [hard=false] - If true then the preload sprite and other artifacts may also be cleared.
	    * @param {boolean} [clearEvents=false] - If true then the all Loader signals will have removeAll called on them.
	    */reset:function reset(hard,clearEvents){if(clearEvents===undefined){clearEvents=false;}if(this.resetLocked){return;}if(hard){this.preloadSprite=null;}this.isLoading=false;this._processingHead=0;this._fileList.length=0;this._flightQueue.length=0;this._fileLoadStarted=false;this._totalFileCount=0;this._totalPackCount=0;this._loadedPackCount=0;this._loadedFileCount=0;if(clearEvents){this.onLoadStart.removeAll();this.onLoadComplete.removeAll();this.onPackComplete.removeAll();this.onFileStart.removeAll();this.onFileComplete.removeAll();this.onFileError.removeAll();}},/**
	    * Internal function that adds a new entry to the file list. Do not call directly.
	    *
	    * @method Phaser.Loader#addToFileList
	    * @protected
	    * @param {string} type - The type of resource to add to the list (image, audio, xml, etc).
	    * @param {string} key - The unique Cache ID key of this resource.
	    * @param {string} [url] - The URL the asset will be loaded from.
	    * @param {object} [properties=(none)] - Any additional properties needed to load the file. These are added directly to the added file object and overwrite any defaults.
	    * @param {boolean} [overwrite=false] - If true then this will overwrite a file asset of the same type/key. Otherwise it will only add a new asset. If overwrite is true, and the asset is already being loaded (or has been loaded), then it is appended instead.
	    * @param {string} [extension] - If no URL is given the Loader will sometimes auto-generate the URL based on the key, using this as the extension.
	    * @return {Phaser.Loader} This instance of the Phaser Loader.
	    */addToFileList:function addToFileList(type,key,url,properties,overwrite,extension){if(overwrite===undefined){overwrite=false;}if(key===undefined||key===''){console.warn("Phaser.Loader: Invalid or no key given of type "+type);return this;}if(url===undefined||url===null){if(extension){url=key+extension;}else{console.warn("Phaser.Loader: No URL given for file type: "+type+" key: "+key);return this;}}var file={type:type,key:key,path:this.path,url:url,syncPoint:this._withSyncPointDepth>0,data:null,loading:false,loaded:false,error:false};if(properties){for(var prop in properties){file[prop]=properties[prop];}}var fileIndex=this.getAssetIndex(type,key);if(overwrite&&fileIndex>-1){var currentFile=this._fileList[fileIndex];if(!currentFile.loading&&!currentFile.loaded){this._fileList[fileIndex]=file;}else{this._fileList.push(file);this._totalFileCount++;}}else if(fileIndex===-1){this._fileList.push(file);this._totalFileCount++;}return this;},/**
	    * Internal function that replaces an existing entry in the file list with a new one. Do not call directly.
	    *
	    * @method Phaser.Loader#replaceInFileList
	    * @protected
	    * @param {string} type - The type of resource to add to the list (image, audio, xml, etc).
	    * @param {string} key - The unique Cache ID key of this resource.
	    * @param {string} url - The URL the asset will be loaded from.
	    * @param {object} properties - Any additional properties needed to load the file.
	    */replaceInFileList:function replaceInFileList(type,key,url,properties){return this.addToFileList(type,key,url,properties,true);},/**
	    * Add a JSON resource pack ('packfile') to the Loader.
	    *
	    * A packfile is a JSON file that contains a list of assets to the be loaded.
	    * Please see the example 'loader/asset pack' in the Phaser Examples repository.
	    *
	    * Packs are always put before the first non-pack file that is not loaded / loading.
	    *
	    * This means that all packs added before any loading has started are added to the front
	    * of the file queue, in the order added.
	    *
	    * The key must be a unique String. It is used to add the file to the Phaser.Cache upon successful load.
	    *
	    * The URL of the packfile can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * @method Phaser.Loader#pack
	    * @param {string} key - Unique asset key of this resource pack.
	    * @param {string} [url] - URL of the Asset Pack JSON file. If you wish to pass a json object instead set this to null and pass the object as the data parameter.
	    * @param {object} [data] - The Asset Pack JSON data. Use this to pass in a json data object rather than loading it from a URL. TODO
	    * @param {object} [callbackContext=(loader)] - Some Loader operations, like Binary and Script require a context for their callbacks. Pass the context here.
	    * @return {Phaser.Loader} This Loader instance.
	    */pack:function pack(key,url,data,callbackContext){if(url===undefined){url=null;}if(data===undefined){data=null;}if(callbackContext===undefined){callbackContext=null;}if(!url&&!data){console.warn('Phaser.Loader.pack - Both url and data are null. One must be set.');return this;}var pack={type:'packfile',key:key,url:url,path:this.path,syncPoint:true,data:null,loading:false,loaded:false,error:false,callbackContext:callbackContext};//  A data object has been given
	if(data){if(typeof data==='string'){data=JSON.parse(data);}pack.data=data||{};//  Already consider 'loaded'
	pack.loaded=true;}// Add before first non-pack/no-loaded ~ last pack from start prior to loading
	// (Read one past for splice-to-end)
	for(var i=0;i<this._fileList.length+1;i++){var file=this._fileList[i];if(!file||!file.loaded&&!file.loading&&file.type!=='packfile'){this._fileList.splice(i,0,pack);this._totalPackCount++;break;}}return this;},/**
	    * Adds an Image to the current load queue.
	    *
	    * The file is **not** loaded immediately after calling this method. The file is added to the queue ready to be loaded when the loader starts.
	    *
	    * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
	    *
	    * The key must be a unique String. It is used to add the file to the Phaser.Cache upon successful load.
	    *
	    * Retrieve the image via `Cache.getImage(key)`
	    *
	    * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	    * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension.
	    * If you do not desire this action then provide a URL.
	    *
	    * @method Phaser.Loader#image
	    * @param {string} key - Unique asset key of this image file.
	    * @param {string} [url] - URL of an image file. If undefined or `null` the url will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	    * @param {boolean} [overwrite=false] - If an unloaded file with a matching key already exists in the queue, this entry will overwrite it.
	    * @return {Phaser.Loader} This Loader instance.
	    */image:function image(key,url,overwrite){return this.addToFileList('image',key,url,undefined,overwrite,'.png');},/**
	    * Adds an array of images to the current load queue.
	    *
	    * It works by passing each element of the array to the Loader.image method.
	    *
	    * The files are **not** loaded immediately after calling this method. The files are added to the queue ready to be loaded when the loader starts.
	    *
	    * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
	    *
	    * The keys must be unique Strings. They are used to add the files to the Phaser.Cache upon successful load.
	    *
	    * Retrieve the images via `Cache.getImage(key)`
	    *
	    * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	    * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension.
	    * If you do not desire this action then provide a URL.
	    *
	    * @method Phaser.Loader#images
	    * @param {array} keys - An array of unique asset keys of the image files.
	    * @param {array} [urls] - Optional array of URLs. If undefined or `null` the url will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png". If provided the URLs array length must match the keys array length.
	    * @return {Phaser.Loader} This Loader instance.
	     */images:function images(keys,urls){if(Array.isArray(urls)){for(var i=0;i<keys.length;i++){this.image(keys[i],urls[i]);}}else{for(var i=0;i<keys.length;i++){this.image(keys[i]);}}return this;},/**
	    * Adds a Text file to the current load queue.
	    *
	    * The file is **not** loaded immediately after calling this method. The file is added to the queue ready to be loaded when the loader starts.
	    *
	    * The key must be a unique String. It is used to add the file to the Phaser.Cache upon successful load.
	    *
	    * Retrieve the file via `Cache.getText(key)`
	    *
	    * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	    * and no URL is given then the Loader will set the URL to be "alien.txt". It will always add `.txt` as the extension.
	    * If you do not desire this action then provide a URL.
	    *
	    * @method Phaser.Loader#text
	    * @param {string} key - Unique asset key of the text file.
	    * @param {string} [url] - URL of the text file. If undefined or `null` the url will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
	    * @param {boolean} [overwrite=false] - If an unloaded file with a matching key already exists in the queue, this entry will overwrite it.
	    * @return {Phaser.Loader} This Loader instance.
	    */text:function text(key,url,overwrite){return this.addToFileList('text',key,url,undefined,overwrite,'.txt');},/**
	    * Adds a JSON file to the current load queue.
	    *
	    * The file is **not** loaded immediately after calling this method. The file is added to the queue ready to be loaded when the loader starts.
	    *
	    * The key must be a unique String. It is used to add the file to the Phaser.Cache upon successful load.
	    *
	    * Retrieve the file via `Cache.getJSON(key)`. JSON files are automatically parsed upon load.
	    * If you need to control when the JSON is parsed then use `Loader.text` instead and parse the text file as needed.
	    *
	    * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	    * and no URL is given then the Loader will set the URL to be "alien.json". It will always add `.json` as the extension.
	    * If you do not desire this action then provide a URL.
	    *
	    * @method Phaser.Loader#json
	    * @param {string} key - Unique asset key of the json file.
	    * @param {string} [url] - URL of the JSON file. If undefined or `null` the url will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
	    * @param {boolean} [overwrite=false] - If an unloaded file with a matching key already exists in the queue, this entry will overwrite it.
	    * @return {Phaser.Loader} This Loader instance.
	    */json:function json(key,url,overwrite){return this.addToFileList('json',key,url,undefined,overwrite,'.json');},/**
	    * Adds a fragment shader file to the current load queue.
	    *
	    * The file is **not** loaded immediately after calling this method. The file is added to the queue ready to be loaded when the loader starts.
	    *
	    * The key must be a unique String. It is used to add the file to the Phaser.Cache upon successful load.
	    *
	    * Retrieve the file via `Cache.getShader(key)`.
	    *
	    * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "blur"
	    * and no URL is given then the Loader will set the URL to be "blur.frag". It will always add `.frag` as the extension.
	    * If you do not desire this action then provide a URL.
	    *
	    * @method Phaser.Loader#shader
	    * @param {string} key - Unique asset key of the fragment file.
	    * @param {string} [url] - URL of the fragment file. If undefined or `null` the url will be set to `<key>.frag`, i.e. if `key` was "blur" then the URL will be "blur.frag".
	    * @param {boolean} [overwrite=false] - If an unloaded file with a matching key already exists in the queue, this entry will overwrite it.
	    * @return {Phaser.Loader} This Loader instance.
	    */shader:function shader(key,url,overwrite){return this.addToFileList('shader',key,url,undefined,overwrite,'.frag');},/**
	    * Adds an XML file to the current load queue.
	    *
	    * The file is **not** loaded immediately after calling this method. The file is added to the queue ready to be loaded when the loader starts.
	    *
	    * The key must be a unique String. It is used to add the file to the Phaser.Cache upon successful load.
	    *
	    * Retrieve the file via `Cache.getXML(key)`.
	    *
	    * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	    * and no URL is given then the Loader will set the URL to be "alien.xml". It will always add `.xml` as the extension.
	    * If you do not desire this action then provide a URL.
	    *
	    * @method Phaser.Loader#xml
	    * @param {string} key - Unique asset key of the xml file.
	    * @param {string} [url] - URL of the XML file. If undefined or `null` the url will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
	    * @param {boolean} [overwrite=false] - If an unloaded file with a matching key already exists in the queue, this entry will overwrite it.
	    * @return {Phaser.Loader} This Loader instance.
	    */xml:function xml(key,url,overwrite){return this.addToFileList('xml',key,url,undefined,overwrite,'.xml');},/**
	    * Adds a JavaScript file to the current load queue.
	    *
	    * The file is **not** loaded immediately after calling this method. The file is added to the queue ready to be loaded when the loader starts.
	    *
	    * The key must be a unique String.
	    *
	    * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	    * and no URL is given then the Loader will set the URL to be "alien.js". It will always add `.js` as the extension.
	    * If you do not desire this action then provide a URL.
	    *
	    * Upon successful load the JavaScript is automatically turned into a script tag and executed, so be careful what you load!
	    *
	    * A callback, which will be invoked as the script tag has been created, can also be specified.
	    * The callback must return relevant `data`.
	    *
	    * @method Phaser.Loader#script
	    * @param {string} key - Unique asset key of the script file.
	    * @param {string} [url] - URL of the JavaScript file. If undefined or `null` the url will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
	    * @param {function} [callback=(none)] - Optional callback that will be called after the script tag has loaded, so you can perform additional processing.
	    * @param {object} [callbackContext=(loader)] - The context under which the callback will be applied. If not specified it will use the Phaser Loader as the context.
	    * @return {Phaser.Loader} This Loader instance.
	    */script:function script(key,url,callback,callbackContext){if(callback===undefined){callback=false;}if(callback!==false&&callbackContext===undefined){callbackContext=this;}return this.addToFileList('script',key,url,{syncPoint:true,callback:callback,callbackContext:callbackContext},false,'.js');},/**
	    * Adds a binary file to the current load queue.
	    *
	    * The file is **not** loaded immediately after calling this method. The file is added to the queue ready to be loaded when the loader starts.
	    *
	    * The key must be a unique String. It is used to add the file to the Phaser.Cache upon successful load.
	    *
	    * Retrieve the file via `Cache.getBinary(key)`.
	    *
	    * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	    * and no URL is given then the Loader will set the URL to be "alien.bin". It will always add `.bin` as the extension.
	    * If you do not desire this action then provide a URL.
	    *
	    * It will be loaded via xhr with a responseType of "arraybuffer". You can specify an optional callback to process the file after load.
	    * When the callback is called it will be passed 2 parameters: the key of the file and the file data.
	    *
	    * WARNING: If a callback is specified the data will be set to whatever it returns. Always return the data object, even if you didn't modify it.
	    *
	    * @method Phaser.Loader#binary
	    * @param {string} key - Unique asset key of the binary file.
	    * @param {string} [url] - URL of the binary file. If undefined or `null` the url will be set to `<key>.bin`, i.e. if `key` was "alien" then the URL will be "alien.bin".
	    * @param {function} [callback=(none)] - Optional callback that will be passed the file after loading, so you can perform additional processing on it.
	    * @param {object} [callbackContext] - The context under which the callback will be applied. If not specified it will use the callback itself as the context.
	    * @return {Phaser.Loader} This Loader instance.
	    */binary:function binary(key,url,callback,callbackContext){if(callback===undefined){callback=false;}// Why is the default callback context the ..callback?
	if(callback!==false&&callbackContext===undefined){callbackContext=callback;}return this.addToFileList('binary',key,url,{callback:callback,callbackContext:callbackContext},false,'.bin');},/**
	    * Adds a Sprite Sheet to the current load queue.
	    *
	    * The file is **not** loaded immediately after calling this method. The file is added to the queue ready to be loaded when the loader starts.
	    *
	    * To clarify the terminology that Phaser uses: A Sprite Sheet is an image containing frames, usually of an animation, that are all equal
	    * dimensions and often in sequence. For example if the frame size is 32x32 then every frame in the sprite sheet will be that size.
	    * Sometimes (outside of Phaser) the term "sprite sheet" is used to refer to a texture atlas.
	    * A Texture Atlas works by packing together images as best it can, using whatever frame sizes it likes, often with cropping and trimming
	    * the frames in the process. Software such as Texture Packer, Flash CC or Shoebox all generate texture atlases, not sprite sheets.
	    * If you've got an atlas then use `Loader.atlas` instead.
	    *
	    * The key must be a unique String. It is used to add the image to the Phaser.Cache upon successful load.
	    *
	    * Retrieve the file via `Cache.getImage(key)`. Sprite sheets, being image based, live in the same Cache as all other Images.
	    *
	    * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	    * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension.
	    * If you do not desire this action then provide a URL.
	    *
	    * @method Phaser.Loader#spritesheet
	    * @param {string} key - Unique asset key of the sheet file.
	    * @param {string} url - URL of the sprite sheet file. If undefined or `null` the url will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	    * @param {number} frameWidth - Width in pixels of a single frame in the sprite sheet.
	    * @param {number} frameHeight - Height in pixels of a single frame in the sprite sheet.
	    * @param {number} [frameMax=-1] - How many frames in this sprite sheet. If not specified it will divide the whole image into frames.
	    * @param {number} [margin=0] - If the frames have been drawn with a margin, specify the amount here.
	    * @param {number} [spacing=0] - If the frames have been drawn with spacing between them, specify the amount here.
	    * @return {Phaser.Loader} This Loader instance.
	    */spritesheet:function spritesheet(key,url,frameWidth,frameHeight,frameMax,margin,spacing){if(frameMax===undefined){frameMax=-1;}if(margin===undefined){margin=0;}if(spacing===undefined){spacing=0;}return this.addToFileList('spritesheet',key,url,{frameWidth:frameWidth,frameHeight:frameHeight,frameMax:frameMax,margin:margin,spacing:spacing},false,'.png');},/**
	    * Adds an audio file to the current load queue.
	    *
	    * The file is **not** loaded immediately after calling this method. The file is added to the queue ready to be loaded when the loader starts.
	    *
	    * The key must be a unique String. It is used to add the file to the Phaser.Cache upon successful load.
	    *
	    * Retrieve the file via `Cache.getSound(key)`.
	    *
	    * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * Mobile warning: There are some mobile devices (certain iPad 2 and iPad Mini revisions) that cannot play 48000 Hz audio.
	    * When they try to play the audio becomes extremely distorted and buzzes, eventually crashing the sound system.
	    * The solution is to use a lower encoding rate such as 44100 Hz.
	    *
	    * @method Phaser.Loader#audio
	    * @param {string} key - Unique asset key of the audio file.
	    * @param {string|string[]|object[]} urls - Either a single string or an array of URIs or pairs of `{uri: .., type: ..}`.
	    *    If an array is specified then the first URI (or URI + mime pair) that is device-compatible will be selected.
	    *    For example: `"jump.mp3"`, `['jump.mp3', 'jump.ogg', 'jump.m4a']`, or `[{uri: "data:<opus_resource>", type: 'opus'}, 'fallback.mp3']`.
	    *    BLOB and DATA URIs can be used but only support automatic detection when used in the pair form; otherwise the format must be manually checked before adding the resource.
	    * @param {boolean} [autoDecode=true] - When using Web Audio the audio files can either be decoded at load time or run-time.
	    *    Audio files can't be played until they are decoded and, if specified, this enables immediate decoding. Decoding is a non-blocking async process, however it consumes huge amounts of CPU time on mobiles especially.
	    * @return {Phaser.Loader} This Loader instance.
	    */audio:function audio(key,urls,autoDecode){if(this.game.sound.noAudio){return this;}if(autoDecode===undefined){autoDecode=true;}if(typeof urls==='string'){urls=[urls];}return this.addToFileList('audio',key,urls,{buffer:null,autoDecode:autoDecode});},/**
	    * Adds an audio sprite file to the current load queue.
	    *
	    * The file is **not** loaded immediately after calling this method. The file is added to the queue ready to be loaded when the loader starts.
	    *
	    * The key must be a unique String. It is used to add the file to the Phaser.Cache upon successful load.
	    *
	    * Audio Sprites are a combination of audio files and a JSON configuration.
	    *
	    * The JSON follows the format of that created by https://github.com/tonistiigi/audiosprite
	    *
	    * Retrieve the file via `Cache.getSoundData(key)`.
	    *
	    * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * @method Phaser.Loader#audioSprite
	    * @param {string} key - Unique asset key of the audio file.
	    * @param {Array|string} urls - An array containing the URLs of the audio files, i.e.: [ 'audiosprite.mp3', 'audiosprite.ogg', 'audiosprite.m4a' ] or a single string containing just one URL.
	    * @param {string} [jsonURL=null] - The URL of the audiosprite configuration JSON object. If you wish to pass the data directly set this parameter to null.
	    * @param {string|object} [jsonData=null] - A JSON object or string containing the audiosprite configuration data. This is ignored if jsonURL is not null.
	    * @param {boolean} [autoDecode=true] - When using Web Audio the audio files can either be decoded at load time or run-time.
	    *    Audio files can't be played until they are decoded and, if specified, this enables immediate decoding. Decoding is a non-blocking async process, however it consumes huge amounts of CPU time on mobiles especially.
	    * @return {Phaser.Loader} This Loader instance.
	    */audioSprite:function audioSprite(key,urls,jsonURL,jsonData,autoDecode){if(this.game.sound.noAudio){return this;}if(jsonURL===undefined){jsonURL=null;}if(jsonData===undefined){jsonData=null;}if(autoDecode===undefined){autoDecode=true;}this.audio(key,urls,autoDecode);if(jsonURL){this.json(key+'-audioatlas',jsonURL);}else if(jsonData){if(typeof jsonData==='string'){jsonData=JSON.parse(jsonData);}this.cache.addJSON(key+'-audioatlas','',jsonData);}else{console.warn('Phaser.Loader.audiosprite - You must specify either a jsonURL or provide a jsonData object');}return this;},/**
	    * A legacy alias for Loader.audioSprite. Please see that method for documentation.
	    *
	    * @method Phaser.Loader#audiosprite
	    * @param {string} key - Unique asset key of the audio file.
	    * @param {Array|string} urls - An array containing the URLs of the audio files, i.e.: [ 'audiosprite.mp3', 'audiosprite.ogg', 'audiosprite.m4a' ] or a single string containing just one URL.
	    * @param {string} [jsonURL=null] - The URL of the audiosprite configuration JSON object. If you wish to pass the data directly set this parameter to null.
	    * @param {string|object} [jsonData=null] - A JSON object or string containing the audiosprite configuration data. This is ignored if jsonURL is not null.
	    * @param {boolean} [autoDecode=true] - When using Web Audio the audio files can either be decoded at load time or run-time.
	    *    Audio files can't be played until they are decoded and, if specified, this enables immediate decoding. Decoding is a non-blocking async process, however it consumes huge amounts of CPU time on mobiles especially.
	    * @return {Phaser.Loader} This Loader instance.
	    */audiosprite:function audiosprite(key,urls,jsonURL,jsonData,autoDecode){return this.audioSprite(key,urls,jsonURL,jsonData,autoDecode);},/**
	    * Adds a video file to the current load queue.
	    *
	    * The file is **not** loaded immediately after calling this method. The file is added to the queue ready to be loaded when the loader starts.
	    *
	    * The key must be a unique String. It is used to add the file to the Phaser.Cache upon successful load.
	    *
	    * Retrieve the file via `Cache.getVideo(key)`.
	    *
	    * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * You don't need to preload a video in order to play it in your game. See `Video.createVideoFromURL` for details.
	    *
	    * @method Phaser.Loader#video
	    * @param {string} key - Unique asset key of the video file.
	    * @param {string|string[]|object[]} urls - Either a single string or an array of URIs or pairs of `{uri: .., type: ..}`.
	    *    If an array is specified then the first URI (or URI + mime pair) that is device-compatible will be selected.
	    *    For example: `"boom.mp4"`, `['boom.mp4', 'boom.ogg', 'boom.webm']`, or `[{uri: "data:<opus_resource>", type: 'opus'}, 'fallback.mp4']`.
	    *    BLOB and DATA URIs can be used but only support automatic detection when used in the pair form; otherwise the format must be manually checked before adding the resource.
	    * @param {string} [loadEvent='canplaythrough'] - This sets the Video source event to listen for before the load is considered complete.
	    *    'canplaythrough' implies the video has downloaded enough, and bandwidth is high enough that it can be played to completion.
	    *    'canplay' implies the video has downloaded enough to start playing, but not necessarily to finish.
	    *    'loadeddata' just makes sure that the video meta data and first frame have downloaded. Phaser uses this value automatically if the
	    *    browser is detected as being Firefox and no `loadEvent` is given, otherwise it defaults to `canplaythrough`.
	    * @param {boolean} [asBlob=false] - Video files can either be loaded via the creation of a video element which has its src property set.
	    *    Or they can be loaded via xhr, stored as binary data in memory and then converted to a Blob. This isn't supported in IE9 or Android 2.
	    *    If you need to have the same video playing at different times across multiple Sprites then you need to load it as a Blob.
	    * @return {Phaser.Loader} This Loader instance.
	    */video:function video(key,urls,loadEvent,asBlob){if(loadEvent===undefined){if(this.game.device.firefox){loadEvent='loadeddata';}else{loadEvent='canplaythrough';}}if(asBlob===undefined){asBlob=false;}if(typeof urls==='string'){urls=[urls];}return this.addToFileList('video',key,urls,{buffer:null,asBlob:asBlob,loadEvent:loadEvent});},/**
	    * Adds a Tile Map data file to the current load queue.
	    *
	    * Phaser can load data in two different formats: CSV and Tiled JSON.
	    * 
	    * Tiled is a free software package, specifically for creating tilemaps, and is available from http://www.mapeditor.org
	    *
	    * You can choose to either load the data externally, by providing a URL to a json file.
	    * Or you can pass in a JSON object or String via the `data` parameter.
	    * If you pass a String the data is automatically run through `JSON.parse` and then immediately added to the Phaser.Cache.
	    *
	    * If a URL is provided the file is **not** loaded immediately after calling this method, but is added to the load queue.
	    *
	    * The key must be a unique String. It is used to add the file to the Phaser.Cache upon successful load.
	    *
	    * Retrieve the file via `Cache.getTilemapData(key)`. JSON files are automatically parsed upon load.
	    * If you need to control when the JSON is parsed then use `Loader.text` instead and parse the text file as needed.
	    *
	    * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * If the URL isn't specified and no data is given then the Loader will take the key and create a filename from that.
	    * For example if the key is "level1" and no URL or data is given then the Loader will set the URL to be "level1.json".
	    * If you set the format to be Tilemap.CSV it will set the URL to be "level1.csv" instead.
	    *
	    * If you do not desire this action then provide a URL or data object.
	    *
	    * @method Phaser.Loader#tilemap
	    * @param {string} key - Unique asset key of the tilemap data.
	    * @param {string} [url] - URL of the tile map file. If undefined or `null` and no data is given the url will be set to `<key>.json`, i.e. if `key` was "level1" then the URL will be "level1.json".
	    * @param {object|string} [data] - An optional JSON data object. If given then the url is ignored and this JSON object is used for map data instead.
	    * @param {number} [format=Phaser.Tilemap.CSV] - The format of the map data. Either Phaser.Tilemap.CSV or Phaser.Tilemap.TILED_JSON.
	    * @return {Phaser.Loader} This Loader instance.
	    */tilemap:function tilemap(key,url,data,format){if(url===undefined){url=null;}if(data===undefined){data=null;}if(format===undefined){format=Phaser.Tilemap.CSV;}if(!url&&!data){if(format===Phaser.Tilemap.CSV){url=key+'.csv';}else{url=key+'.json';}}//  A map data object has been given
	if(data){switch(format){//  A csv string or object has been given
	case Phaser.Tilemap.CSV:break;//  A json string or object has been given
	case Phaser.Tilemap.TILED_JSON:if(typeof data==='string'){data=JSON.parse(data);}break;}this.cache.addTilemap(key,null,data,format);}else{this.addToFileList('tilemap',key,url,{format:format});}return this;},/**
	    * Adds a physics data file to the current load queue.
	    *
	    * The data must be in `Lime + Corona` JSON format. [Physics Editor](https://www.codeandweb.com) by code'n'web exports in this format natively.
	    *
	    * You can choose to either load the data externally, by providing a URL to a json file.
	    * Or you can pass in a JSON object or String via the `data` parameter.
	    * If you pass a String the data is automatically run through `JSON.parse` and then immediately added to the Phaser.Cache.
	    *
	    * If a URL is provided the file is **not** loaded immediately after calling this method, but is added to the load queue.
	    *
	    * The key must be a unique String. It is used to add the file to the Phaser.Cache upon successful load.
	    *
	    * Retrieve the file via `Cache.getJSON(key)`. JSON files are automatically parsed upon load.
	    * If you need to control when the JSON is parsed then use `Loader.text` instead and parse the text file as needed.
	    *
	    * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * If the URL isn't specified and no data is given then the Loader will take the key and create a filename from that.
	    * For example if the key is "alien" and no URL or data is given then the Loader will set the URL to be "alien.json".
	    * It will always use `.json` as the extension.
	    *
	    * If you do not desire this action then provide a URL or data object.
	    *
	    * @method Phaser.Loader#physics
	    * @param {string} key - Unique asset key of the physics json data.
	    * @param {string} [url] - URL of the physics data file. If undefined or `null` and no data is given the url will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
	    * @param {object|string} [data] - An optional JSON data object. If given then the url is ignored and this JSON object is used for physics data instead.
	    * @param {string} [format=Phaser.Physics.LIME_CORONA_JSON] - The format of the physics data.
	    * @return {Phaser.Loader} This Loader instance.
	    */physics:function physics(key,url,data,format){if(url===undefined){url=null;}if(data===undefined){data=null;}if(format===undefined){format=Phaser.Physics.LIME_CORONA_JSON;}if(!url&&!data){url=key+'.json';}//  A map data object has been given
	if(data){if(typeof data==='string'){data=JSON.parse(data);}this.cache.addPhysicsData(key,null,data,format);}else{this.addToFileList('physics',key,url,{format:format});}return this;},/**
	    * Adds Bitmap Font files to the current load queue.
	    *
	    * To create the Bitmap Font files you can use:
	    *
	    * BMFont (Windows, free): http://www.angelcode.com/products/bmfont/
	    * Glyph Designer (OS X, commercial): http://www.71squared.com/en/glyphdesigner
	    * Littera (Web-based, free): http://kvazars.com/littera/
	    *
	    * You can choose to either load the data externally, by providing a URL to an xml file.
	    * Or you can pass in an XML object or String via the `xmlData` parameter.
	    * If you pass a String the data is automatically run through `Loader.parseXML` and then immediately added to the Phaser.Cache.
	    *
	    * If URLs are provided the files are **not** loaded immediately after calling this method, but are added to the load queue.
	    *
	    * The key must be a unique String. It is used to add the file to the Phaser.Cache upon successful load.
	    *
	    * Retrieve the file via `Cache.getBitmapFont(key)`. XML files are automatically parsed upon load.
	    * If you need to control when the XML is parsed then use `Loader.text` instead and parse the XML file as needed.
	    *
	    * The URLs can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * If the textureURL isn't specified then the Loader will take the key and create a filename from that.
	    * For example if the key is "megaFont" and textureURL is null then the Loader will set the URL to be "megaFont.png".
	    * The same is true for the atlasURL. If atlasURL isn't specified and no atlasData has been provided then the Loader will
	    * set the atlasURL to be the key. For example if the key is "megaFont" the atlasURL will be set to "megaFont.xml".
	    *
	    * If you do not desire this action then provide URLs and / or a data object.
	    *
	    * @method Phaser.Loader#bitmapFont
	    * @param {string} key - Unique asset key of the bitmap font.
	    * @param {string} textureURL -  URL of the Bitmap Font texture file. If undefined or `null` the url will be set to `<key>.png`, i.e. if `key` was "megaFont" then the URL will be "megaFont.png".
	    * @param {string} atlasURL - URL of the Bitmap Font atlas file (xml/json). If undefined or `null` AND `atlasData` is null, the url will be set to `<key>.xml`, i.e. if `key` was "megaFont" then the URL will be "megaFont.xml".
	    * @param {object} atlasData - An optional Bitmap Font atlas in string form (stringified xml/json).
	    * @param {number} [xSpacing=0] - If you'd like to add additional horizontal spacing between the characters then set the pixel value here.
	    * @param {number} [ySpacing=0] - If you'd like to add additional vertical spacing between the lines then set the pixel value here.
	    * @return {Phaser.Loader} This Loader instance.
	    */bitmapFont:function bitmapFont(key,textureURL,atlasURL,atlasData,xSpacing,ySpacing){if(textureURL===undefined||textureURL===null){textureURL=key+'.png';}if(atlasURL===undefined){atlasURL=null;}if(atlasData===undefined){atlasData=null;}if(atlasURL===null&&atlasData===null){atlasURL=key+'.xml';}if(xSpacing===undefined){xSpacing=0;}if(ySpacing===undefined){ySpacing=0;}//  A URL to a json/xml atlas has been given
	if(atlasURL){this.addToFileList('bitmapfont',key,textureURL,{atlasURL:atlasURL,xSpacing:xSpacing,ySpacing:ySpacing});}else{//  A stringified xml/json atlas has been given
	if(typeof atlasData==='string'){var json,xml;try{json=JSON.parse(atlasData);}catch(e){xml=this.parseXml(atlasData);}if(!xml&&!json){throw new Error("Phaser.Loader. Invalid Bitmap Font atlas given");}this.addToFileList('bitmapfont',key,textureURL,{atlasURL:null,atlasData:json||xml,atlasType:!!json?'json':'xml',xSpacing:xSpacing,ySpacing:ySpacing});}}return this;},/**
	    * Adds a Texture Atlas file to the current load queue.
	    *
	    * Unlike `Loader.atlasJSONHash` this call expects the atlas data to be in a JSON Array format.
	    *
	    * To create the Texture Atlas you can use tools such as:
	    *
	    * [Texture Packer](https://www.codeandweb.com/texturepacker/phaser)
	    * [Shoebox](http://renderhjs.net/shoebox/)
	    *
	    * If using Texture Packer we recommend you enable "Trim sprite names".
	    * If your atlas software has an option to "rotate" the resulting frames, you must disable it.
	    *
	    * You can choose to either load the data externally, by providing a URL to a json file.
	    * Or you can pass in a JSON object or String via the `atlasData` parameter.
	    * If you pass a String the data is automatically run through `JSON.parse` and then immediately added to the Phaser.Cache.
	    *
	    * If URLs are provided the files are **not** loaded immediately after calling this method, but are added to the load queue.
	    *
	    * The key must be a unique String. It is used to add the file to the Phaser.Cache upon successful load.
	    *
	    * Retrieve the file via `Cache.getImage(key)`. JSON files are automatically parsed upon load.
	    * If you need to control when the JSON is parsed then use `Loader.text` instead and parse the JSON file as needed.
	    *
	    * The URLs can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * If the textureURL isn't specified then the Loader will take the key and create a filename from that.
	    * For example if the key is "player" and textureURL is null then the Loader will set the URL to be "player.png".
	    * The same is true for the atlasURL. If atlasURL isn't specified and no atlasData has been provided then the Loader will
	    * set the atlasURL to be the key. For example if the key is "player" the atlasURL will be set to "player.json".
	    *
	    * If you do not desire this action then provide URLs and / or a data object.
	    *
	    * @method Phaser.Loader#atlasJSONArray
	    * @param {string} key - Unique asset key of the texture atlas file.
	    * @param {string} [textureURL] - URL of the texture atlas image file. If undefined or `null` the url will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	    * @param {string} [atlasURL] - URL of the texture atlas data file. If undefined or `null` and no atlasData is given, the url will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
	    * @param {object} [atlasData] - A JSON data object. You don't need this if the data is being loaded from a URL.
	    * @return {Phaser.Loader} This Loader instance.
	    */atlasJSONArray:function atlasJSONArray(key,textureURL,atlasURL,atlasData){return this.atlas(key,textureURL,atlasURL,atlasData,Phaser.Loader.TEXTURE_ATLAS_JSON_ARRAY);},/**
	    * Adds a Texture Atlas file to the current load queue.
	    *
	    * Unlike `Loader.atlas` this call expects the atlas data to be in a JSON Hash format.
	    *
	    * To create the Texture Atlas you can use tools such as:
	    *
	    * [Texture Packer](https://www.codeandweb.com/texturepacker/phaser)
	    * [Shoebox](http://renderhjs.net/shoebox/)
	    *
	    * If using Texture Packer we recommend you enable "Trim sprite names".
	    * If your atlas software has an option to "rotate" the resulting frames, you must disable it.
	    *
	    * You can choose to either load the data externally, by providing a URL to a json file.
	    * Or you can pass in a JSON object or String via the `atlasData` parameter.
	    * If you pass a String the data is automatically run through `JSON.parse` and then immediately added to the Phaser.Cache.
	    *
	    * If URLs are provided the files are **not** loaded immediately after calling this method, but are added to the load queue.
	    *
	    * The key must be a unique String. It is used to add the file to the Phaser.Cache upon successful load.
	    *
	    * Retrieve the file via `Cache.getImage(key)`. JSON files are automatically parsed upon load.
	    * If you need to control when the JSON is parsed then use `Loader.text` instead and parse the JSON file as needed.
	    *
	    * The URLs can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * If the textureURL isn't specified then the Loader will take the key and create a filename from that.
	    * For example if the key is "player" and textureURL is null then the Loader will set the URL to be "player.png".
	    * The same is true for the atlasURL. If atlasURL isn't specified and no atlasData has been provided then the Loader will
	    * set the atlasURL to be the key. For example if the key is "player" the atlasURL will be set to "player.json".
	    *
	    * If you do not desire this action then provide URLs and / or a data object.
	    *
	    * @method Phaser.Loader#atlasJSONHash
	    * @param {string} key - Unique asset key of the texture atlas file.
	    * @param {string} [textureURL] - URL of the texture atlas image file. If undefined or `null` the url will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	    * @param {string} [atlasURL] - URL of the texture atlas data file. If undefined or `null` and no atlasData is given, the url will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
	    * @param {object} [atlasData] - A JSON data object. You don't need this if the data is being loaded from a URL.
	    * @return {Phaser.Loader} This Loader instance.
	    */atlasJSONHash:function atlasJSONHash(key,textureURL,atlasURL,atlasData){return this.atlas(key,textureURL,atlasURL,atlasData,Phaser.Loader.TEXTURE_ATLAS_JSON_HASH);},/**
	    * Adds a Texture Atlas file to the current load queue.
	    *
	    * This call expects the atlas data to be in the Starling XML data format.
	    *
	    * To create the Texture Atlas you can use tools such as:
	    *
	    * [Texture Packer](https://www.codeandweb.com/texturepacker/phaser)
	    * [Shoebox](http://renderhjs.net/shoebox/)
	    *
	    * If using Texture Packer we recommend you enable "Trim sprite names".
	    * If your atlas software has an option to "rotate" the resulting frames, you must disable it.
	    *
	    * You can choose to either load the data externally, by providing a URL to an xml file.
	    * Or you can pass in an XML object or String via the `atlasData` parameter.
	    * If you pass a String the data is automatically run through `Loader.parseXML` and then immediately added to the Phaser.Cache.
	    *
	    * If URLs are provided the files are **not** loaded immediately after calling this method, but are added to the load queue.
	    *
	    * The key must be a unique String. It is used to add the file to the Phaser.Cache upon successful load.
	    *
	    * Retrieve the file via `Cache.getImage(key)`. XML files are automatically parsed upon load.
	    * If you need to control when the XML is parsed then use `Loader.text` instead and parse the XML file as needed.
	    *
	    * The URLs can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * If the textureURL isn't specified then the Loader will take the key and create a filename from that.
	    * For example if the key is "player" and textureURL is null then the Loader will set the URL to be "player.png".
	    * The same is true for the atlasURL. If atlasURL isn't specified and no atlasData has been provided then the Loader will
	    * set the atlasURL to be the key. For example if the key is "player" the atlasURL will be set to "player.xml".
	    *
	    * If you do not desire this action then provide URLs and / or a data object.
	    *
	    * @method Phaser.Loader#atlasXML
	    * @param {string} key - Unique asset key of the texture atlas file.
	    * @param {string} [textureURL] - URL of the texture atlas image file. If undefined or `null` the url will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	    * @param {string} [atlasURL] - URL of the texture atlas data file. If undefined or `null` and no atlasData is given, the url will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.xml".
	    * @param {object} [atlasData] - An XML data object. You don't need this if the data is being loaded from a URL.
	    * @return {Phaser.Loader} This Loader instance.
	    */atlasXML:function atlasXML(key,textureURL,atlasURL,atlasData){if(atlasURL===undefined){atlasURL=null;}if(atlasData===undefined){atlasData=null;}if(!atlasURL&&!atlasData){atlasURL=key+'.xml';}return this.atlas(key,textureURL,atlasURL,atlasData,Phaser.Loader.TEXTURE_ATLAS_XML_STARLING);},/**
	    * Adds a Texture Atlas file to the current load queue.
	    *
	    * To create the Texture Atlas you can use tools such as:
	    *
	    * [Texture Packer](https://www.codeandweb.com/texturepacker/phaser)
	    * [Shoebox](http://renderhjs.net/shoebox/)
	    *
	    * If using Texture Packer we recommend you enable "Trim sprite names".
	    * If your atlas software has an option to "rotate" the resulting frames, you must disable it.
	    *
	    * You can choose to either load the data externally, by providing a URL to a json file.
	    * Or you can pass in a JSON object or String via the `atlasData` parameter.
	    * If you pass a String the data is automatically run through `JSON.parse` and then immediately added to the Phaser.Cache.
	    *
	    * If URLs are provided the files are **not** loaded immediately after calling this method, but are added to the load queue.
	    *
	    * The key must be a unique String. It is used to add the file to the Phaser.Cache upon successful load.
	    *
	    * Retrieve the file via `Cache.getImage(key)`. JSON files are automatically parsed upon load.
	    * If you need to control when the JSON is parsed then use `Loader.text` instead and parse the JSON file as needed.
	    *
	    * The URLs can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	    *
	    * If the textureURL isn't specified then the Loader will take the key and create a filename from that.
	    * For example if the key is "player" and textureURL is null then the Loader will set the URL to be "player.png".
	    * The same is true for the atlasURL. If atlasURL isn't specified and no atlasData has been provided then the Loader will
	    * set the atlasURL to be the key. For example if the key is "player" the atlasURL will be set to "player.json".
	    *
	    * If you do not desire this action then provide URLs and / or a data object.
	    *
	    * @method Phaser.Loader#atlas
	    * @param {string} key - Unique asset key of the texture atlas file.
	    * @param {string} [textureURL] - URL of the texture atlas image file. If undefined or `null` the url will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	    * @param {string} [atlasURL] - URL of the texture atlas data file. If undefined or `null` and no atlasData is given, the url will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
	    * @param {object} [atlasData] - A JSON or XML data object. You don't need this if the data is being loaded from a URL.
	    * @param {number} [format] - The format of the data. Can be Phaser.Loader.TEXTURE_ATLAS_JSON_ARRAY (the default), Phaser.Loader.TEXTURE_ATLAS_JSON_HASH or Phaser.Loader.TEXTURE_ATLAS_XML_STARLING.
	    * @return {Phaser.Loader} This Loader instance.
	    */atlas:function atlas(key,textureURL,atlasURL,atlasData,format){if(textureURL===undefined||textureURL===null){textureURL=key+'.png';}if(atlasURL===undefined){atlasURL=null;}if(atlasData===undefined){atlasData=null;}if(format===undefined){format=Phaser.Loader.TEXTURE_ATLAS_JSON_ARRAY;}if(!atlasURL&&!atlasData){if(format===Phaser.Loader.TEXTURE_ATLAS_XML_STARLING){atlasURL=key+'.xml';}else{atlasURL=key+'.json';}}//  A URL to a json/xml file has been given
	if(atlasURL){this.addToFileList('textureatlas',key,textureURL,{atlasURL:atlasURL,format:format});}else{switch(format){//  A json string or object has been given
	case Phaser.Loader.TEXTURE_ATLAS_JSON_ARRAY:if(typeof atlasData==='string'){atlasData=JSON.parse(atlasData);}break;//  An xml string or object has been given
	case Phaser.Loader.TEXTURE_ATLAS_XML_STARLING:if(typeof atlasData==='string'){var xml=this.parseXml(atlasData);if(!xml){throw new Error("Phaser.Loader. Invalid Texture Atlas XML given");}atlasData=xml;}break;}this.addToFileList('textureatlas',key,textureURL,{atlasURL:null,atlasData:atlasData,format:format});}return this;},/**
	    * Add a synchronization point to the assets/files added within the supplied callback.
	    *
	    * A synchronization point denotes that an asset _must_ be completely loaded before
	    * subsequent assets can be loaded. An asset marked as a sync-point does not need to wait
	    * for previous assets to load (unless they are sync-points). Resources, such as packs, may still
	    * be downloaded around sync-points, as long as they do not finalize loading.
	    *
	    * @method Phaser.Loader#withSyncPoints
	    * @param {function} callback - The callback is invoked and is supplied with a single argument: the loader.
	    * @param {object} [callbackContext=(loader)] - Context for the callback.
	    * @return {Phaser.Loader} This Loader instance.
	    */withSyncPoint:function withSyncPoint(callback,callbackContext){this._withSyncPointDepth++;try{callback.call(callbackContext||this,this);}finally{this._withSyncPointDepth--;}return this;},/**
	    * Add a synchronization point to a specific file/asset in the load queue.
	    *
	    * This has no effect on already loaded assets.
	    *
	    * @method Phaser.Loader#addSyncPoint
	    * @param {string} type - The type of resource to turn into a sync point (image, audio, xml, etc).
	    * @param {string} key - Key of the file you want to turn into a sync point.
	    * @return {Phaser.Loader} This Loader instance.
	    * @see {@link Phaser.Loader#withSyncPoint withSyncPoint}
	    */addSyncPoint:function addSyncPoint(type,key){var asset=this.getAsset(type,key);if(asset){asset.file.syncPoint=true;}return this;},/**
	    * Remove a file/asset from the loading queue.
	    *
	    * A file that is loaded or has started loading cannot be removed.
	    *
	    * @method Phaser.Loader#removeFile
	    * @protected
	    * @param {string} type - The type of resource to add to the list (image, audio, xml, etc).
	    * @param {string} key - Key of the file you want to remove.
	    */removeFile:function removeFile(type,key){var asset=this.getAsset(type,key);if(asset){if(!asset.loaded&&!asset.loading){this._fileList.splice(asset.index,1);}}},/**
	    * Remove all file loading requests - this is _insufficient_ to stop current loading. Use `reset` instead.
	    *
	    * @method Phaser.Loader#removeAll
	    * @protected
	    */removeAll:function removeAll(){this._fileList.length=0;this._flightQueue.length=0;},/**
	    * Start loading the assets. Normally you don't need to call this yourself as the StateManager will do so.
	    *
	    * @method Phaser.Loader#start
	    */start:function start(){if(this.isLoading){return;}this.hasLoaded=false;this.isLoading=true;this.updateProgress();this.processLoadQueue();},/**
	    * Process the next item(s) in the file/asset queue.
	    *
	    * Process the queue and start loading enough items to fill up the inflight queue.
	    *
	    * If a sync-file is encountered then subsequent asset processing is delayed until it completes.
	    * The exception to this rule is that packfiles can be downloaded (but not processed) even if
	    * there appear other sync files (ie. packs) - this enables multiple packfiles to be fetched in parallel.
	    * such as during the start phaser.
	    *
	    * @method Phaser.Loader#processLoadQueue
	    * @private
	    */processLoadQueue:function processLoadQueue(){if(!this.isLoading){console.warn('Phaser.Loader - active loading canceled / reset');this.finishedLoading(true);return;}// Empty the flight queue as applicable
	for(var i=0;i<this._flightQueue.length;i++){var file=this._flightQueue[i];if(file.loaded||file.error){this._flightQueue.splice(i,1);i--;file.loading=false;file.requestUrl=null;file.requestObject=null;if(file.error){this.onFileError.dispatch(file.key,file);}if(file.type!=='packfile'){this._loadedFileCount++;this.onFileComplete.dispatch(this.progress,file.key,!file.error,this._loadedFileCount,this._totalFileCount);}else if(file.type==='packfile'&&file.error){// Non-error pack files are handled when processing the file queue
	this._loadedPackCount++;this.onPackComplete.dispatch(file.key,!file.error,this._loadedPackCount,this._totalPackCount);}}}// When true further non-pack file downloads are suppressed
	var syncblock=false;var inflightLimit=this.enableParallel?Phaser.Math.clamp(this.maxParallelDownloads,1,12):1;for(var i=this._processingHead;i<this._fileList.length;i++){var file=this._fileList[i];// Pack is fetched (ie. has data) and is currently at the start of the process queue.
	if(file.type==='packfile'&&!file.error&&file.loaded&&i===this._processingHead){// Processing the pack / adds more files
	this.processPack(file);this._loadedPackCount++;this.onPackComplete.dispatch(file.key,!file.error,this._loadedPackCount,this._totalPackCount);}if(file.loaded||file.error){// Item at the start of file list finished, can skip it in future
	if(i===this._processingHead){this._processingHead=i+1;}}else if(!file.loading&&this._flightQueue.length<inflightLimit){// -> not loaded/failed, not loading
	if(file.type==='packfile'&&!file.data){// Fetches the pack data: the pack is processed above as it reaches queue-start.
	// (Packs do not trigger onLoadStart or onFileStart.)
	this._flightQueue.push(file);file.loading=true;this.loadFile(file);}else if(!syncblock){if(!this._fileLoadStarted){this._fileLoadStarted=true;this.onLoadStart.dispatch();}this._flightQueue.push(file);file.loading=true;this.onFileStart.dispatch(this.progress,file.key,file.url);this.loadFile(file);}}if(!file.loaded&&file.syncPoint){syncblock=true;}// Stop looking if queue full - or if syncblocked and there are no more packs.
	// (As only packs can be loaded around a syncblock)
	if(this._flightQueue.length>=inflightLimit||syncblock&&this._loadedPackCount===this._totalPackCount){break;}}this.updateProgress();// True when all items in the queue have been advanced over
	// (There should be no inflight items as they are complete - loaded/error.)
	if(this._processingHead>=this._fileList.length){this.finishedLoading();}else if(!this._flightQueue.length){// Flight queue is empty but file list is not done being processed.
	// This indicates a critical internal error with no known recovery.
	console.warn("Phaser.Loader - aborting: processing queue empty, loading may have stalled");var _this=this;setTimeout(function(){_this.finishedLoading(true);},2000);}},/**
	    * The loading is all finished.
	    *
	    * @method Phaser.Loader#finishedLoading
	    * @private
	    * @param {boolean} [abnormal=true] - True if the loading finished abnormally.
	    */finishedLoading:function finishedLoading(abnormal){if(this.hasLoaded){return;}this.hasLoaded=true;this.isLoading=false;// If there were no files make sure to trigger the event anyway, for consistency
	if(!abnormal&&!this._fileLoadStarted){this._fileLoadStarted=true;this.onLoadStart.dispatch();}this.onLoadComplete.dispatch();this.game.state.loadComplete();this.reset();},/**
	    * Informs the loader that the given file resource has been fetched and processed;
	    * or such a request has failed.
	    *
	    * @method Phaser.Loader#asyncComplete
	    * @private
	    * @param {object} file
	    * @param {string} [error=''] - The error message, if any. No message implies no error.
	    */asyncComplete:function asyncComplete(file,errorMessage){if(errorMessage===undefined){errorMessage='';}file.loaded=true;file.error=!!errorMessage;if(errorMessage){file.errorMessage=errorMessage;console.warn('Phaser.Loader - '+file.type+'['+file.key+']'+': '+errorMessage);// debugger;
	}this.processLoadQueue();},/**
	    * Process pack data. This will usually modify the file list.
	    *
	    * @method Phaser.Loader#processPack
	    * @private
	    * @param {object} pack
	    */processPack:function processPack(pack){var packData=pack.data[pack.key];if(!packData){console.warn('Phaser.Loader - '+pack.key+': pack has data, but not for pack key');return;}for(var i=0;i<packData.length;i++){var file=packData[i];switch(file.type){case"image":this.image(file.key,file.url,file.overwrite);break;case"text":this.text(file.key,file.url,file.overwrite);break;case"json":this.json(file.key,file.url,file.overwrite);break;case"xml":this.xml(file.key,file.url,file.overwrite);break;case"script":this.script(file.key,file.url,file.callback,pack.callbackContext||this);break;case"binary":this.binary(file.key,file.url,file.callback,pack.callbackContext||this);break;case"spritesheet":this.spritesheet(file.key,file.url,file.frameWidth,file.frameHeight,file.frameMax,file.margin,file.spacing);break;case"video":this.video(file.key,file.urls);break;case"audio":this.audio(file.key,file.urls,file.autoDecode);break;case"audiosprite":this.audiosprite(file.key,file.urls,file.jsonURL,file.jsonData,file.autoDecode);break;case"tilemap":this.tilemap(file.key,file.url,file.data,Phaser.Tilemap[file.format]);break;case"physics":this.physics(file.key,file.url,file.data,Phaser.Loader[file.format]);break;case"bitmapFont":this.bitmapFont(file.key,file.textureURL,file.atlasURL,file.atlasData,file.xSpacing,file.ySpacing);break;case"atlasJSONArray":this.atlasJSONArray(file.key,file.textureURL,file.atlasURL,file.atlasData);break;case"atlasJSONHash":this.atlasJSONHash(file.key,file.textureURL,file.atlasURL,file.atlasData);break;case"atlasXML":this.atlasXML(file.key,file.textureURL,file.atlasURL,file.atlasData);break;case"atlas":this.atlas(file.key,file.textureURL,file.atlasURL,file.atlasData,Phaser.Loader[file.format]);break;case"shader":this.shader(file.key,file.url,file.overwrite);break;}}},/**
	    * Transforms the asset URL.
	    *
	    * The default implementation prepends the baseURL if the url doesn't begin with http or //
	    *
	    * @method Phaser.Loader#transformUrl
	    * @protected
	    * @param {string} url - The url to transform.
	    * @param {object} file - The file object being transformed.
	    * @return {string} The transformed url. In rare cases where the url isn't specified it will return false instead.
	    */transformUrl:function transformUrl(url,file){if(!url){return false;}if(url.match(/^(?:blob:|data:|http:\/\/|https:\/\/|\/\/)/)){return url;}else{return this.baseURL+file.path+url;}},/**
	    * Start fetching a resource.
	    *
	    * All code paths, async or otherwise, from this function must return to `asyncComplete`.
	    *
	    * @method Phaser.Loader#loadFile
	    * @private
	    * @param {object} file
	    */loadFile:function loadFile(file){//  Image or Data?
	switch(file.type){case'packfile':this.xhrLoad(file,this.transformUrl(file.url,file),'text',this.fileComplete);break;case'image':case'spritesheet':case'textureatlas':case'bitmapfont':this.loadImageTag(file);break;case'audio':file.url=this.getAudioURL(file.url);if(file.url){//  WebAudio or Audio Tag?
	if(this.game.sound.usingWebAudio){this.xhrLoad(file,this.transformUrl(file.url,file),'arraybuffer',this.fileComplete);}else if(this.game.sound.usingAudioTag){this.loadAudioTag(file);}}else{this.fileError(file,null,'No supported audio URL specified or device does not have audio playback support');}break;case'video':file.url=this.getVideoURL(file.url);if(file.url){if(file.asBlob){this.xhrLoad(file,this.transformUrl(file.url,file),'blob',this.fileComplete);}else{this.loadVideoTag(file);}}else{this.fileError(file,null,'No supported video URL specified or device does not have video playback support');}break;case'json':this.xhrLoad(file,this.transformUrl(file.url,file),'text',this.jsonLoadComplete);break;case'xml':this.xhrLoad(file,this.transformUrl(file.url,file),'text',this.xmlLoadComplete);break;case'tilemap':if(file.format===Phaser.Tilemap.TILED_JSON){this.xhrLoad(file,this.transformUrl(file.url,file),'text',this.jsonLoadComplete);}else if(file.format===Phaser.Tilemap.CSV){this.xhrLoad(file,this.transformUrl(file.url,file),'text',this.csvLoadComplete);}else{this.asyncComplete(file,"invalid Tilemap format: "+file.format);}break;case'text':case'script':case'shader':case'physics':this.xhrLoad(file,this.transformUrl(file.url,file),'text',this.fileComplete);break;case'binary':this.xhrLoad(file,this.transformUrl(file.url,file),'arraybuffer',this.fileComplete);break;}},/**
	    * Continue async loading through an Image tag.
	    * @private
	    */loadImageTag:function loadImageTag(file){var _this=this;file.data=new Image();file.data.name=file.key;if(this.crossOrigin){file.data.crossOrigin=this.crossOrigin;}file.data.onload=function(){if(file.data.onload){file.data.onload=null;file.data.onerror=null;_this.fileComplete(file);}};file.data.onerror=function(){if(file.data.onload){file.data.onload=null;file.data.onerror=null;_this.fileError(file);}};file.data.src=this.transformUrl(file.url,file);// Image is immediately-available/cached
	if(file.data.complete&&file.data.width&&file.data.height){file.data.onload=null;file.data.onerror=null;this.fileComplete(file);}},/**
	    * Continue async loading through a Video tag.
	    * @private
	    */loadVideoTag:function loadVideoTag(file){var _this=this;file.data=document.createElement("video");file.data.name=file.key;file.data.controls=false;file.data.autoplay=false;var videoLoadEvent=function videoLoadEvent(){file.data.removeEventListener(file.loadEvent,videoLoadEvent,false);file.data.onerror=null;file.data.canplay=true;Phaser.GAMES[_this.game.id].load.fileComplete(file);};file.data.onerror=function(){file.data.removeEventListener(file.loadEvent,videoLoadEvent,false);file.data.onerror=null;file.data.canplay=false;_this.fileError(file);};file.data.addEventListener(file.loadEvent,videoLoadEvent,false);file.data.src=this.transformUrl(file.url,file);file.data.load();},/**
	    * Continue async loading through an Audio tag.
	    * @private
	    */loadAudioTag:function loadAudioTag(file){var _this=this;if(this.game.sound.touchLocked){//  If audio is locked we can't do this yet, so need to queue this load request. Bum.
	file.data=new Audio();file.data.name=file.key;file.data.preload='auto';file.data.src=this.transformUrl(file.url,file);this.fileComplete(file);}else{file.data=new Audio();file.data.name=file.key;var playThroughEvent=function playThroughEvent(){file.data.removeEventListener('canplaythrough',playThroughEvent,false);file.data.onerror=null;_this.fileComplete(file);};file.data.onerror=function(){file.data.removeEventListener('canplaythrough',playThroughEvent,false);file.data.onerror=null;_this.fileError(file);};file.data.preload='auto';file.data.src=this.transformUrl(file.url,file);file.data.addEventListener('canplaythrough',playThroughEvent,false);file.data.load();}},/**
	    * Starts the xhr loader.
	    *
	    * This is designed specifically to use with asset file processing.
	    *
	    * @method Phaser.Loader#xhrLoad
	    * @private
	    * @param {object} file - The file/pack to load.
	    * @param {string} url - The URL of the file.
	    * @param {string} type - The xhr responseType.
	    * @param {function} onload - The function to call on success. Invoked in `this` context and supplied with `(file, xhr)` arguments.
	    * @param {function} [onerror=fileError]  The function to call on error. Invoked in `this` context and supplied with `(file, xhr)` arguments.
	    */xhrLoad:function xhrLoad(file,url,type,onload,onerror){if(this.useXDomainRequest&&window.XDomainRequest){this.xhrLoadWithXDR(file,url,type,onload,onerror);return;}var xhr=new XMLHttpRequest();xhr.open("GET",url,true);xhr.responseType=type;if(this.headers['requestedWith']!==false){xhr.setRequestHeader('X-Requested-With',this.headers['requestedWith']);}if(this.headers[file.type]){xhr.setRequestHeader('Accept',this.headers[file.type]);}onerror=onerror||this.fileError;var _this=this;xhr.onload=function(){try{if(xhr.readyState===4&&xhr.status>=400&&xhr.status<=599){// Handle HTTP status codes of 4xx and 5xx as errors, even if xhr.onerror was not called.
	return onerror.call(_this,file,xhr);}else{return onload.call(_this,file,xhr);}}catch(e){//  If this was the last file in the queue and an error is thrown in the create method
	//  then it's caught here, so be sure we don't carry on processing it
	if(!_this.hasLoaded){_this.asyncComplete(file,e.message||'Exception');}else{if(window['console']){console.error(e);}}}};xhr.onerror=function(){try{return onerror.call(_this,file,xhr);}catch(e){if(!_this.hasLoaded){_this.asyncComplete(file,e.message||'Exception');}else{if(window['console']){console.error(e);}}}};file.requestObject=xhr;file.requestUrl=url;xhr.send();},/**
	    * Starts the xhr loader - using XDomainRequest.
	    * This should _only_ be used with IE 9. Phaser does not support IE 8 and XDR is deprecated in IE 10.
	    *
	    * This is designed specifically to use with asset file processing.
	    *
	    * @method Phaser.Loader#xhrLoad
	    * @private
	    * @param {object} file - The file/pack to load.
	    * @param {string} url - The URL of the file.
	    * @param {string} type - The xhr responseType.
	    * @param {function} onload - The function to call on success. Invoked in `this` context and supplied with `(file, xhr)` arguments.
	    * @param {function} [onerror=fileError]  The function to call on error. Invoked in `this` context and supplied with `(file, xhr)` arguments.
	    * @deprecated This is only relevant for IE 9.
	    */xhrLoadWithXDR:function xhrLoadWithXDR(file,url,type,onload,onerror){// Special IE9 magic .. only
	if(!this._warnedAboutXDomainRequest&&(!this.game.device.ie||this.game.device.ieVersion>=10)){this._warnedAboutXDomainRequest=true;console.warn("Phaser.Loader - using XDomainRequest outside of IE 9");}// Ref: http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	var xhr=new window.XDomainRequest();xhr.open('GET',url,true);xhr.responseType=type;// XDomainRequest has a few quirks. Occasionally it will abort requests
	// A way to avoid this is to make sure ALL callbacks are set even if not used
	// More info here: http://stackoverflow.com/questions/15786966/xdomainrequest-aborts-post-on-ie-9
	xhr.timeout=3000;onerror=onerror||this.fileError;var _this=this;xhr.onerror=function(){try{return onerror.call(_this,file,xhr);}catch(e){_this.asyncComplete(file,e.message||'Exception');}};xhr.ontimeout=function(){try{return onerror.call(_this,file,xhr);}catch(e){_this.asyncComplete(file,e.message||'Exception');}};xhr.onprogress=function(){};xhr.onload=function(){try{if(xhr.readyState===4&&xhr.status>=400&&xhr.status<=599){// Handle HTTP status codes of 4xx and 5xx as errors, even if xhr.onerror was not called.
	return onerror.call(_this,file,xhr);}else{return onload.call(_this,file,xhr);}return onload.call(_this,file,xhr);}catch(e){_this.asyncComplete(file,e.message||'Exception');}};file.requestObject=xhr;file.requestUrl=url;//  Note: The xdr.send() call is wrapped in a timeout to prevent an issue with the interface where some requests are lost
	//  if multiple XDomainRequests are being sent at the same time.
	setTimeout(function(){xhr.send();},0);},/**
	    * Give a bunch of URLs, return the first URL that has an extension this device thinks it can play.
	    *
	    * It is assumed that the device can play "blob:" or "data:" URIs - There is no mime-type checking on data URIs.
	    *
	    * @method Phaser.Loader#getVideoURL
	    * @private
	    * @param {object[]|string[]} urls - See {@link #video} for format.
	    * @return {string} The URL to try and fetch; or null.
	    */getVideoURL:function getVideoURL(urls){for(var i=0;i<urls.length;i++){var url=urls[i];var videoType;if(url.uri)// {uri: .., type: ..} pair
	{videoType=url.type;url=url.uri;if(this.game.device.canPlayVideo(videoType)){return url;}}else{// Assume direct-data URI can be played if not in a paired form; select immediately
	if(url.indexOf("blob:")===0||url.indexOf("data:")===0){return url;}if(url.indexOf("?")>=0)// Remove query from URL
	{url=url.substr(0,url.indexOf("?"));}var extension=url.substr((Math.max(0,url.lastIndexOf("."))||Infinity)+1);videoType=extension.toLowerCase();if(this.game.device.canPlayVideo(videoType)){return urls[i];}}}return null;},/**
	    * Give a bunch of URLs, return the first URL that has an extension this device thinks it can play.
	    *
	    * It is assumed that the device can play "blob:" or "data:" URIs - There is no mime-type checking on data URIs.
	    *
	    * @method Phaser.Loader#getAudioURL
	    * @private
	    * @param {object[]|string[]} urls - See {@link #audio} for format.
	    * @return {string} The URL to try and fetch; or null.
	    */getAudioURL:function getAudioURL(urls){if(this.game.sound.noAudio){return null;}for(var i=0;i<urls.length;i++){var url=urls[i];var audioType;if(url.uri)// {uri: .., type: ..} pair
	{audioType=url.type;url=url.uri;if(this.game.device.canPlayAudio(audioType)){return url;}}else{// Assume direct-data URI can be played if not in a paired form; select immediately
	if(url.indexOf("blob:")===0||url.indexOf("data:")===0){return url;}if(url.indexOf("?")>=0)// Remove query from URL
	{url=url.substr(0,url.indexOf("?"));}var extension=url.substr((Math.max(0,url.lastIndexOf("."))||Infinity)+1);audioType=extension.toLowerCase();if(this.game.device.canPlayAudio(audioType)){return urls[i];}}}return null;},/**
	    * Error occurred when loading a file.
	    *
	    * @method Phaser.Loader#fileError
	    * @private
	    * @param {object} file
	    * @param {?XMLHttpRequest} xhr - XHR request, unspecified if loaded via other means (eg. tags)
	    * @param {string} reason
	    */fileError:function fileError(file,xhr,reason){var url=file.requestUrl||this.transformUrl(file.url,file);var message='error loading asset from URL '+url;if(!reason&&xhr){reason=xhr.status;}if(reason){message=message+' ('+reason+')';}this.asyncComplete(file,message);},/**
	    * Called when a file/resources had been downloaded and needs to be processed further.
	    *
	    * @method Phaser.Loader#fileComplete
	    * @private
	    * @param {object} file - File loaded
	    * @param {?XMLHttpRequest} xhr - XHR request, unspecified if loaded via other means (eg. tags)
	    */fileComplete:function fileComplete(file,xhr){var loadNext=true;switch(file.type){case'packfile':// Pack data must never be false-ish after it is fetched without error
	var data=JSON.parse(xhr.responseText);file.data=data||{};break;case'image':this.cache.addImage(file.key,file.url,file.data);break;case'spritesheet':this.cache.addSpriteSheet(file.key,file.url,file.data,file.frameWidth,file.frameHeight,file.frameMax,file.margin,file.spacing);break;case'textureatlas':if(file.atlasURL==null){this.cache.addTextureAtlas(file.key,file.url,file.data,file.atlasData,file.format);}else{//  Load the JSON or XML before carrying on with the next file
	loadNext=false;if(file.format===Phaser.Loader.TEXTURE_ATLAS_JSON_ARRAY||file.format===Phaser.Loader.TEXTURE_ATLAS_JSON_HASH||file.format===Phaser.Loader.TEXTURE_ATLAS_JSON_PYXEL){this.xhrLoad(file,this.transformUrl(file.atlasURL,file),'text',this.jsonLoadComplete);}else if(file.format===Phaser.Loader.TEXTURE_ATLAS_XML_STARLING){this.xhrLoad(file,this.transformUrl(file.atlasURL,file),'text',this.xmlLoadComplete);}else{throw new Error("Phaser.Loader. Invalid Texture Atlas format: "+file.format);}}break;case'bitmapfont':if(!file.atlasURL){this.cache.addBitmapFont(file.key,file.url,file.data,file.atlasData,file.atlasType,file.xSpacing,file.ySpacing);}else{//  Load the XML before carrying on with the next file
	loadNext=false;this.xhrLoad(file,this.transformUrl(file.atlasURL,file),'text',function(file,xhr){var json;try{// Try to parse as JSON, if it fails, then it's hopefully XML
	json=JSON.parse(xhr.responseText);}catch(e){}if(!!json){file.atlasType='json';this.jsonLoadComplete(file,xhr);}else{file.atlasType='xml';this.xmlLoadComplete(file,xhr);}});}break;case'video':if(file.asBlob){try{file.data=xhr.response;}catch(e){throw new Error("Phaser.Loader. Unable to parse video file as Blob: "+file.key);}}this.cache.addVideo(file.key,file.url,file.data,file.asBlob);break;case'audio':if(this.game.sound.usingWebAudio){file.data=xhr.response;this.cache.addSound(file.key,file.url,file.data,true,false);if(file.autoDecode){this.game.sound.decode(file.key);}}else{this.cache.addSound(file.key,file.url,file.data,false,true);}break;case'text':file.data=xhr.responseText;this.cache.addText(file.key,file.url,file.data);break;case'shader':file.data=xhr.responseText;this.cache.addShader(file.key,file.url,file.data);break;case'physics':var data=JSON.parse(xhr.responseText);this.cache.addPhysicsData(file.key,file.url,data,file.format);break;case'script':file.data=document.createElement('script');file.data.language='javascript';file.data.type='text/javascript';file.data.defer=false;file.data.text=xhr.responseText;document.head.appendChild(file.data);if(file.callback){file.data=file.callback.call(file.callbackContext,file.key,xhr.responseText);}break;case'binary':if(file.callback){file.data=file.callback.call(file.callbackContext,file.key,xhr.response);}else{file.data=xhr.response;}this.cache.addBinary(file.key,file.data);break;}if(loadNext){this.asyncComplete(file);}},/**
	    * Successfully loaded a JSON file - only used for certain types.
	    *
	    * @method Phaser.Loader#jsonLoadComplete
	    * @private
	    * @param {object} file - File associated with this request
	    * @param {XMLHttpRequest} xhr
	    */jsonLoadComplete:function jsonLoadComplete(file,xhr){var data=JSON.parse(xhr.responseText);if(file.type==='tilemap'){this.cache.addTilemap(file.key,file.url,data,file.format);}else if(file.type==='bitmapfont'){this.cache.addBitmapFont(file.key,file.url,file.data,data,file.atlasType,file.xSpacing,file.ySpacing);}else if(file.type==='json'){this.cache.addJSON(file.key,file.url,data);}else{this.cache.addTextureAtlas(file.key,file.url,file.data,data,file.format);}this.asyncComplete(file);},/**
	    * Successfully loaded a CSV file - only used for certain types.
	    *
	    * @method Phaser.Loader#csvLoadComplete
	    * @private
	    * @param {object} file - File associated with this request
	    * @param {XMLHttpRequest} xhr
	    */csvLoadComplete:function csvLoadComplete(file,xhr){var data=xhr.responseText;this.cache.addTilemap(file.key,file.url,data,file.format);this.asyncComplete(file);},/**
	    * Successfully loaded an XML file - only used for certain types.
	    *
	    * @method Phaser.Loader#xmlLoadComplete
	    * @private
	    * @param {object} file - File associated with this request
	    * @param {XMLHttpRequest} xhr
	    */xmlLoadComplete:function xmlLoadComplete(file,xhr){// Always try parsing the content as XML, regardless of actually response type
	var data=xhr.responseText;var xml=this.parseXml(data);if(!xml){var responseType=xhr.responseType||xhr.contentType;// contentType for MS-XDomainRequest
	console.warn('Phaser.Loader - '+file.key+': invalid XML ('+responseType+')');this.asyncComplete(file,"invalid XML");return;}if(file.type==='bitmapfont'){this.cache.addBitmapFont(file.key,file.url,file.data,xml,file.atlasType,file.xSpacing,file.ySpacing);}else if(file.type==='textureatlas'){this.cache.addTextureAtlas(file.key,file.url,file.data,xml,file.format);}else if(file.type==='xml'){this.cache.addXML(file.key,file.url,xml);}this.asyncComplete(file);},/**
	    * Parses string data as XML.
	    *
	    * @method Phaser.Loader#parseXml
	    * @private
	    * @param {string} data - The XML text to parse
	    * @return {?XMLDocument} Returns the xml document, or null if such could not parsed to a valid document.
	    */parseXml:function parseXml(data){var xml;try{if(window['DOMParser']){var domparser=new DOMParser();xml=domparser.parseFromString(data,"text/xml");}else{xml=new ActiveXObject("Microsoft.XMLDOM");// Why is this 'false'?
	xml.async='false';xml.loadXML(data);}}catch(e){xml=null;}if(!xml||!xml.documentElement||xml.getElementsByTagName("parsererror").length){return null;}else{return xml;}},/**
	    * Update the loading sprite progress.
	    *
	    * @method Phaser.Loader#nextFile
	    * @private
	    * @param {object} previousFile
	    * @param {boolean} success - Whether the previous asset loaded successfully or not.
	    */updateProgress:function updateProgress(){if(this.preloadSprite){if(this.preloadSprite.direction===0){this.preloadSprite.rect.width=Math.floor(this.preloadSprite.width/100*this.progress);}else{this.preloadSprite.rect.height=Math.floor(this.preloadSprite.height/100*this.progress);}if(this.preloadSprite.sprite){this.preloadSprite.sprite.updateCrop();}else{//  We seem to have lost our sprite - maybe it was destroyed?
	this.preloadSprite=null;}}},/**
	    * Returns the number of files that have already been loaded, even if they errored.
	    *
	    * @method Phaser.Loader#totalLoadedFiles
	    * @protected
	    * @return {number} The number of files that have already been loaded (even if they errored)
	    */totalLoadedFiles:function totalLoadedFiles(){return this._loadedFileCount;},/**
	    * Returns the number of files still waiting to be processed in the load queue. This value decreases as each file in the queue is loaded.
	    *
	    * @method Phaser.Loader#totalQueuedFiles
	    * @protected
	    * @return {number} The number of files that still remain in the load queue.
	    */totalQueuedFiles:function totalQueuedFiles(){return this._totalFileCount-this._loadedFileCount;},/**
	    * Returns the number of asset packs that have already been loaded, even if they errored.
	    *
	    * @method Phaser.Loader#totalLoadedPacks
	    * @protected
	    * @return {number} The number of asset packs that have already been loaded (even if they errored)
	    */totalLoadedPacks:function totalLoadedPacks(){return this._totalPackCount;},/**
	    * Returns the number of asset packs still waiting to be processed in the load queue. This value decreases as each pack in the queue is loaded.
	    *
	    * @method Phaser.Loader#totalQueuedPacks
	    * @protected
	    * @return {number} The number of asset packs that still remain in the load queue.
	    */totalQueuedPacks:function totalQueuedPacks(){return this._totalPackCount-this._loadedPackCount;}};/**
	* The non-rounded load progress value (from 0.0 to 100.0).
	*
	* A general indicator of the progress.
	* It is possible for the progress to decrease, after `onLoadStart`, if more files are dynamically added.
	*
	* @name Phaser.Loader#progressFloat
	* @property {number}
	*/Object.defineProperty(Phaser.Loader.prototype,"progressFloat",{get:function get(){var progress=this._loadedFileCount/this._totalFileCount*100;return Phaser.Math.clamp(progress||0,0,100);}});/**
	* The rounded load progress percentage value (from 0 to 100). See {@link Phaser.Loader#progressFloat}.
	*
	* @name Phaser.Loader#progress
	* @property {integer}
	*/Object.defineProperty(Phaser.Loader.prototype,"progress",{get:function get(){return Math.round(this.progressFloat);}});Phaser.Loader.prototype.constructor=Phaser.Loader;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Phaser.LoaderParser parses data objects from Phaser.Loader that need more preparation before they can be inserted into the Cache.
	*
	* @class Phaser.LoaderParser
	*/Phaser.LoaderParser={/**
	    * Alias for xmlBitmapFont, for backwards compatibility.
	    * 
	    * @method Phaser.LoaderParser.bitmapFont
	    * @param {object} xml - XML data you want to parse.
	    * @param {PIXI.BaseTexture} baseTexture - The BaseTexture this font uses.
	    * @param {number} [xSpacing=0] - Additional horizontal spacing between the characters.
	    * @param {number} [ySpacing=0] - Additional vertical spacing between the characters.
	    * @return {object} The parsed Bitmap Font data.
	    */bitmapFont:function bitmapFont(xml,baseTexture,xSpacing,ySpacing){return this.xmlBitmapFont(xml,baseTexture,xSpacing,ySpacing);},/**
	    * Parse a Bitmap Font from an XML file.
	    *
	    * @method Phaser.LoaderParser.xmlBitmapFont
	    * @param {object} xml - XML data you want to parse.
	    * @param {PIXI.BaseTexture} baseTexture - The BaseTexture this font uses.
	    * @param {number} [xSpacing=0] - Additional horizontal spacing between the characters.
	    * @param {number} [ySpacing=0] - Additional vertical spacing between the characters.
	    * @return {object} The parsed Bitmap Font data.
	    */xmlBitmapFont:function xmlBitmapFont(xml,baseTexture,xSpacing,ySpacing){var data={};var info=xml.getElementsByTagName('info')[0];var common=xml.getElementsByTagName('common')[0];data.font=info.getAttribute('face');data.size=parseInt(info.getAttribute('size'),10);data.lineHeight=parseInt(common.getAttribute('lineHeight'),10)+ySpacing;data.chars={};var letters=xml.getElementsByTagName('char');for(var i=0;i<letters.length;i++){var charCode=parseInt(letters[i].getAttribute('id'),10);data.chars[charCode]={x:parseInt(letters[i].getAttribute('x'),10),y:parseInt(letters[i].getAttribute('y'),10),width:parseInt(letters[i].getAttribute('width'),10),height:parseInt(letters[i].getAttribute('height'),10),xOffset:parseInt(letters[i].getAttribute('xoffset'),10),yOffset:parseInt(letters[i].getAttribute('yoffset'),10),xAdvance:parseInt(letters[i].getAttribute('xadvance'),10)+xSpacing,kerning:{}};}var kernings=xml.getElementsByTagName('kerning');for(i=0;i<kernings.length;i++){var first=parseInt(kernings[i].getAttribute('first'),10);var second=parseInt(kernings[i].getAttribute('second'),10);var amount=parseInt(kernings[i].getAttribute('amount'),10);data.chars[second].kerning[first]=amount;}return this.finalizeBitmapFont(baseTexture,data);},/**
	    * Parse a Bitmap Font from a JSON file.
	    *
	    * @method Phaser.LoaderParser.jsonBitmapFont
	    * @param {object} json - JSON data you want to parse.
	    * @param {PIXI.BaseTexture} baseTexture - The BaseTexture this font uses.
	    * @param {number} [xSpacing=0] - Additional horizontal spacing between the characters.
	    * @param {number} [ySpacing=0] - Additional vertical spacing between the characters.
	    * @return {object} The parsed Bitmap Font data.
	    */jsonBitmapFont:function jsonBitmapFont(json,baseTexture,xSpacing,ySpacing){var data={font:json.font.info._face,size:parseInt(json.font.info._size,10),lineHeight:parseInt(json.font.common._lineHeight,10)+ySpacing,chars:{}};json.font.chars["char"].forEach(function parseChar(letter){var charCode=parseInt(letter._id,10);data.chars[charCode]={x:parseInt(letter._x,10),y:parseInt(letter._y,10),width:parseInt(letter._width,10),height:parseInt(letter._height,10),xOffset:parseInt(letter._xoffset,10),yOffset:parseInt(letter._yoffset,10),xAdvance:parseInt(letter._xadvance,10)+xSpacing,kerning:{}};});if(json.font.kernings&&json.font.kernings.kerning){json.font.kernings.kerning.forEach(function parseKerning(kerning){data.chars[kerning._second].kerning[kerning._first]=parseInt(kerning._amount,10);});}return this.finalizeBitmapFont(baseTexture,data);},/**
	    * Finalize Bitmap Font parsing.
	    *
	    * @method Phaser.LoaderParser.finalizeBitmapFont
	    * @private
	    * @param {PIXI.BaseTexture} baseTexture - The BaseTexture this font uses.
	    * @param {object} bitmapFontData - Pre-parsed bitmap font data.
	    * @return {object} The parsed Bitmap Font data.
	    */finalizeBitmapFont:function finalizeBitmapFont(baseTexture,bitmapFontData){Object.keys(bitmapFontData.chars).forEach(function addTexture(charCode){var letter=bitmapFontData.chars[charCode];letter.texture=new PIXI.Texture(baseTexture,new Phaser.Rectangle(letter.x,letter.y,letter.width,letter.height));});return bitmapFontData;}};/**
	 * @author       Jeremy Dowell <jeremy@codevinsky.com>
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2016 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 *//**
	 * Audio Sprites are a combination of audio files and a JSON configuration.
	 * The JSON follows the format of that created by https://github.com/tonistiigi/audiosprite
	 *
	 * @class Phaser.AudioSprite
	 * @constructor
	 * @param {Phaser.Game} game - Reference to the current game instance.
	 * @param {string} key - Asset key for the sound.
	 */Phaser.AudioSprite=function(game,key){/**
	    * A reference to the currently running Game.
	    * @property {Phaser.Game} game
	    */this.game=game;/**
	     * Asset key for the Audio Sprite.
	     * @property {string} key
	     */this.key=key;/**
	     * JSON audio atlas object.
	     * @property {object} config
	     */this.config=this.game.cache.getJSON(key+'-audioatlas');/**
	     * If a sound is set to auto play, this holds the marker key of it.
	     * @property {string} autoplayKey
	     */this.autoplayKey=null;/**
	     * Is a sound set to autoplay or not?
	     * @property {boolean} autoplay
	     * @default
	     */this.autoplay=false;/**
	     * An object containing the Phaser.Sound objects for the Audio Sprite.
	     * @property {object} sounds
	     */this.sounds={};for(var k in this.config.spritemap){var marker=this.config.spritemap[k];var sound=this.game.add.sound(this.key);sound.addMarker(k,marker.start,marker.end-marker.start,null,marker.loop);this.sounds[k]=sound;}if(this.config.autoplay){this.autoplayKey=this.config.autoplay;this.play(this.autoplayKey);this.autoplay=this.sounds[this.autoplayKey];}};Phaser.AudioSprite.prototype={/**
	     * Play a sound with the given name.
	     * 
	     * @method Phaser.AudioSprite#play
	     * @param {string} [marker] - The name of sound to play
	     * @param {number} [volume=1] - Volume of the sound you want to play. If none is given it will use the volume given to the Sound when it was created (which defaults to 1 if none was specified).
	     * @return {Phaser.Sound} This sound instance.
	     */play:function play(marker,volume){if(volume===undefined){volume=1;}return this.sounds[marker].play(marker,null,volume);},/**
	     * Stop a sound with the given name.
	     * 
	     * @method Phaser.AudioSprite#stop
	     * @param {string} [marker=''] - The name of sound to stop. If none is given it will stop all sounds in the audio sprite.
	     */stop:function stop(marker){if(!marker){for(var key in this.sounds){this.sounds[key].stop();}}else{this.sounds[marker].stop();}},/**
	     * Get a sound with the given name.
	     * 
	     * @method Phaser.AudioSprite#get
	     * @param {string} marker - The name of sound to get.
	     * @return {Phaser.Sound} The sound instance.
	     */get:function get(marker){return this.sounds[marker];}};Phaser.AudioSprite.prototype.constructor=Phaser.AudioSprite;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Sound class constructor.
	*
	* @class Phaser.Sound
	* @constructor
	* @param {Phaser.Game} game - Reference to the current game instance.
	* @param {string} key - Asset key for the sound.
	* @param {number} [volume=1] - Default value for the volume, between 0 and 1.
	* @param {boolean} [loop=false] - Whether or not the sound will loop.
	*/Phaser.Sound=function(game,key,volume,loop,connect){if(volume===undefined){volume=1;}if(loop===undefined){loop=false;}if(connect===undefined){connect=game.sound.connectToMaster;}/**
	    * A reference to the currently running Game.
	    * @property {Phaser.Game} game
	    */this.game=game;/**
	    * @property {string} name - Name of the sound.
	    */this.name=key;/**
	    * @property {string} key - Asset key for the sound.
	    */this.key=key;/**
	    * @property {boolean} loop - Whether or not the sound or current sound marker will loop.
	    */this.loop=loop;/**
	    * @property {object} markers - The sound markers.
	    */this.markers={};/**
	    * @property {AudioContext} context - Reference to the AudioContext instance.
	    */this.context=null;/**
	    * @property {boolean} autoplay - Boolean indicating whether the sound should start automatically.
	    */this.autoplay=false;/**
	    * @property {number} totalDuration - The total duration of the sound in seconds.
	    */this.totalDuration=0;/**
	    * @property {number} startTime - The time the Sound starts at (typically 0 unless starting from a marker)
	    * @default
	    */this.startTime=0;/**
	    * @property {number} currentTime - The current time the sound is at.
	    */this.currentTime=0;/**
	    * @property {number} duration - The duration of the current sound marker in seconds.
	    */this.duration=0;/**
	    * @property {number} durationMS - The duration of the current sound marker in ms.
	    */this.durationMS=0;/**
	    * @property {number} position - The position of the current sound marker.
	    */this.position=0;/**
	    * @property {number} stopTime - The time the sound stopped.
	    */this.stopTime=0;/**
	    * @property {boolean} paused - true if the sound is paused, otherwise false.
	    * @default
	    */this.paused=false;/**
	    * @property {number} pausedPosition - The position the sound had reached when it was paused.
	    */this.pausedPosition=0;/**
	    * @property {number} pausedTime - The game time at which the sound was paused.
	    */this.pausedTime=0;/**
	    * @property {boolean} isPlaying - true if the sound is currently playing, otherwise false.
	    * @default
	    */this.isPlaying=false;/**
	    * @property {string} currentMarker - The string ID of the currently playing marker, if any.
	    * @default
	    */this.currentMarker='';/**
	    * @property {Phaser.Tween} fadeTween - The tween that fades the audio, set via Sound.fadeIn and Sound.fadeOut.
	    */this.fadeTween=null;/**
	    * @property {boolean} pendingPlayback - true if the sound file is pending playback
	    * @readonly
	    */this.pendingPlayback=false;/**
	    * @property {boolean} override - if true when you play this sound it will always start from the beginning.
	    * @default
	    */this.override=false;/**
	    * @property {boolean} allowMultiple - This will allow you to have multiple instances of this Sound playing at once. This is only useful when running under Web Audio, and we recommend you implement a local pooling system to not flood the sound channels.
	    * @default
	    */this.allowMultiple=false;/**
	    * @property {boolean} usingWebAudio - true if this sound is being played with Web Audio.
	    * @readonly
	    */this.usingWebAudio=this.game.sound.usingWebAudio;/**
	    * @property {boolean} usingAudioTag - true if the sound is being played via the Audio tag.
	    */this.usingAudioTag=this.game.sound.usingAudioTag;/**
	    * @property {object} externalNode - If defined this Sound won't connect to the SoundManager master gain node, but will instead connect to externalNode.
	    */this.externalNode=null;/**
	    * @property {object} masterGainNode - The master gain node in a Web Audio system.
	    */this.masterGainNode=null;/**
	    * @property {object} gainNode - The gain node in a Web Audio system.
	    */this.gainNode=null;/**
	    * @property {object} _sound - Internal var.
	    * @private
	    */this._sound=null;if(this.usingWebAudio){this.context=this.game.sound.context;this.masterGainNode=this.game.sound.masterGain;if(this.context.createGain===undefined){this.gainNode=this.context.createGainNode();}else{this.gainNode=this.context.createGain();}this.gainNode.gain.value=volume*this.game.sound.volume;if(connect){this.gainNode.connect(this.masterGainNode);}}else if(this.usingAudioTag){if(this.game.cache.getSound(key)&&this.game.cache.isSoundReady(key)){this._sound=this.game.cache.getSoundData(key);this.totalDuration=0;if(this._sound.duration){this.totalDuration=this._sound.duration;}}else{this.game.cache.onSoundUnlock.add(this.soundHasUnlocked,this);}}/**
	    * @property {Phaser.Signal} onDecoded - The onDecoded event is dispatched when the sound has finished decoding (typically for mp3 files)
	    */this.onDecoded=new Phaser.Signal();/**
	    * @property {Phaser.Signal} onPlay - The onPlay event is dispatched each time this sound is played.
	    */this.onPlay=new Phaser.Signal();/**
	    * @property {Phaser.Signal} onPause - The onPause event is dispatched when this sound is paused.
	    */this.onPause=new Phaser.Signal();/**
	    * @property {Phaser.Signal} onResume - The onResume event is dispatched when this sound is resumed from a paused state.
	    */this.onResume=new Phaser.Signal();/**
	    * @property {Phaser.Signal} onLoop - The onLoop event is dispatched when this sound loops during playback.
	    */this.onLoop=new Phaser.Signal();/**
	    * @property {Phaser.Signal} onStop - The onStop event is dispatched when this sound stops playback.
	    */this.onStop=new Phaser.Signal();/**
	    * @property {Phaser.Signal} onMute - The onMute event is dispatched when this sound is muted.
	    */this.onMute=new Phaser.Signal();/**
	    * @property {Phaser.Signal} onMarkerComplete - The onMarkerComplete event is dispatched when a marker within this sound completes playback.
	    */this.onMarkerComplete=new Phaser.Signal();/**
	    * @property {Phaser.Signal} onFadeComplete - The onFadeComplete event is dispatched when this sound finishes fading either in or out.
	    */this.onFadeComplete=new Phaser.Signal();/**
	    * @property {number} _volume - The global audio volume. A value between 0 (silence) and 1 (full volume).
	    * @private
	    */this._volume=volume;/**
	    * @property {any} _buffer - Decoded data buffer / Audio tag.
	    * @private
	    */this._buffer=null;/**
	    * @property {boolean} _muted - Boolean indicating whether the sound is muted or not.
	    * @private
	    */this._muted=false;/**
	    * @property {number} _tempMarker - Internal marker var.
	    * @private
	    */this._tempMarker=0;/**
	    * @property {number} _tempPosition - Internal marker var.
	    * @private
	    */this._tempPosition=0;/**
	    * @property {number} _tempVolume - Internal marker var.
	    * @private
	    */this._tempVolume=0;/**
	    * @property {number} _tempPause - Internal marker var.
	    * @private
	    */this._tempPause=0;/**
	    * @property {number} _muteVolume - Internal cache var.
	    * @private
	    */this._muteVolume=0;/**
	    * @property {boolean} _tempLoop - Internal cache var.
	    * @private
	    */this._tempLoop=0;/**
	    * @property {boolean} _paused - Was this sound paused via code or a game event?
	    * @private
	    */this._paused=false;/**
	    * @property {boolean} _onDecodedEventDispatched - Was the onDecoded event dispatched?
	    * @private
	    */this._onDecodedEventDispatched=false;};Phaser.Sound.prototype={/**
	    * Called automatically when this sound is unlocked.
	    * @method Phaser.Sound#soundHasUnlocked
	    * @param {string} key - The Phaser.Cache key of the sound file to check for decoding.
	    * @protected
	    */soundHasUnlocked:function soundHasUnlocked(key){if(key===this.key){this._sound=this.game.cache.getSoundData(this.key);this.totalDuration=this._sound.duration;}},/**
	    * Adds a marker into the current Sound. A marker is represented by a unique key and a start time and duration.
	    * This allows you to bundle multiple sounds together into a single audio file and use markers to jump between them for playback.
	    *
	    * @method Phaser.Sound#addMarker
	    * @param {string} name - A unique name for this marker, i.e. 'explosion', 'gunshot', etc.
	    * @param {number} start - The start point of this marker in the audio file, given in seconds. 2.5 = 2500ms, 0.5 = 500ms, etc.
	    * @param {number} [duration=1] - The duration of the marker in seconds. 2.5 = 2500ms, 0.5 = 500ms, etc.
	    * @param {number} [volume=1] - The volume the sound will play back at, between 0 (silent) and 1 (full volume).
	    * @param {boolean} [loop=false] - Sets if the sound will loop or not.
	    */addMarker:function addMarker(name,start,duration,volume,loop){if(duration===undefined||duration===null){duration=1;}if(volume===undefined||volume===null){volume=1;}if(loop===undefined){loop=false;}this.markers[name]={name:name,start:start,stop:start+duration,volume:volume,duration:duration,durationMS:duration*1000,loop:loop};},/**
	    * Removes a marker from the sound.
	    * @method Phaser.Sound#removeMarker
	    * @param {string} name - The key of the marker to remove.
	    */removeMarker:function removeMarker(name){delete this.markers[name];},/**
	    * Called automatically by the AudioContext when the sound stops playing.
	    * Doesn't get called if the sound is set to loop or is a section of an Audio Sprite.
	    * 
	    * @method Phaser.Sound#onEndedHandler
	    * @protected
	    */onEndedHandler:function onEndedHandler(){this._sound.onended=null;this.isPlaying=false;this.currentTime=this.durationMS;this.stop();},/**
	    * Called automatically by Phaser.SoundManager.
	    * @method Phaser.Sound#update
	    * @protected
	    */update:function update(){if(!this.game.cache.checkSoundKey(this.key)){this.destroy();return;}if(this.isDecoded&&!this._onDecodedEventDispatched){this.onDecoded.dispatch(this);this._onDecodedEventDispatched=true;}if(this.pendingPlayback&&this.game.cache.isSoundReady(this.key)){this.pendingPlayback=false;this.play(this._tempMarker,this._tempPosition,this._tempVolume,this._tempLoop);}if(this.isPlaying){this.currentTime=this.game.time.time-this.startTime;if(this.currentTime>=this.durationMS){if(this.usingWebAudio){if(this.loop){//  won't work with markers, needs to reset the position
	this.onLoop.dispatch(this);//  Gets reset by the play function
	this.isPlaying=false;if(this.currentMarker===''){this.currentTime=0;this.startTime=this.game.time.time;this.isPlaying=true;// play not called again in this case
	}else{this.onMarkerComplete.dispatch(this.currentMarker,this);this.play(this.currentMarker,0,this.volume,true,true);}}else{//  Stop if we're using an audio marker, otherwise we let onended handle it
	if(this.currentMarker!==''){this.stop();}}}else{if(this.loop){this.onLoop.dispatch(this);if(this.currentMarker===''){this.currentTime=0;this.startTime=this.game.time.time;}//  Gets reset by the play function
	this.isPlaying=false;this.play(this.currentMarker,0,this.volume,true,true);}else{this.stop();}}}}},/**
	     * Loops this entire sound. If you need to loop a section of it then use Sound.play and the marker and loop parameters.
	     *
	     * @method Phaser.Sound#loopFull
	     * @param {number} [volume=1] - Volume of the sound you want to play. If none is given it will use the volume given to the Sound when it was created (which defaults to 1 if none was specified).
	     * @return {Phaser.Sound} This sound instance.
	     */loopFull:function loopFull(volume){return this.play(null,0,volume,true);},/**
	    * Play this sound, or a marked section of it.
	    * 
	    * @method Phaser.Sound#play
	    * @param {string} [marker=''] - If you want to play a marker then give the key here, otherwise leave blank to play the full sound.
	    * @param {number} [position=0] - The starting position to play the sound from - this is ignored if you provide a marker.
	    * @param {number} [volume=1] - Volume of the sound you want to play. If none is given it will use the volume given to the Sound when it was created (which defaults to 1 if none was specified).
	    * @param {boolean} [loop=false] - Loop when finished playing? If not using a marker / audio sprite the looping will be done via the WebAudio loop property, otherwise it's time based.
	    * @param {boolean} [forceRestart=true] - If the sound is already playing you can set forceRestart to restart it from the beginning.
	    * @return {Phaser.Sound} This sound instance.
	    */play:function play(marker,position,volume,loop,forceRestart){if(marker===undefined||marker===false||marker===null){marker='';}if(forceRestart===undefined){forceRestart=true;}if(this.isPlaying&&!this.allowMultiple&&!forceRestart&&!this.override){//  Use Restart instead
	return this;}if(this._sound&&this.isPlaying&&!this.allowMultiple&&(this.override||forceRestart)){if(this.usingWebAudio){if(this._sound.stop===undefined){this._sound.noteOff(0);}else{try{this._sound.stop(0);}catch(e){}}if(this.externalNode){this._sound.disconnect(this.externalNode);}else if(this.gainNode){this._sound.disconnect(this.gainNode);}}else if(this.usingAudioTag){this._sound.pause();this._sound.currentTime=0;}this.isPlaying=false;}if(marker===''&&Object.keys(this.markers).length>0){//  If they didn't specify a marker but this is an audio sprite, 
	//  we should never play the entire thing
	return this;}if(marker!==''){if(this.markers[marker]){this.currentMarker=marker;//  Playing a marker? Then we default to the marker values
	this.position=this.markers[marker].start;this.volume=this.markers[marker].volume;this.loop=this.markers[marker].loop;this.duration=this.markers[marker].duration;this.durationMS=this.markers[marker].durationMS;if(typeof volume!=='undefined'){this.volume=volume;}if(typeof loop!=='undefined'){this.loop=loop;}this._tempMarker=marker;this._tempPosition=this.position;this._tempVolume=this.volume;this._tempLoop=this.loop;}else{console.warn("Phaser.Sound.play: audio marker "+marker+" doesn't exist");return this;}}else{position=position||0;if(volume===undefined){volume=this._volume;}if(loop===undefined){loop=this.loop;}this.position=Math.max(0,position);this.volume=volume;this.loop=loop;this.duration=0;this.durationMS=0;this._tempMarker=marker;this._tempPosition=position;this._tempVolume=volume;this._tempLoop=loop;}if(this.usingWebAudio){//  Does the sound need decoding?
	if(this.game.cache.isSoundDecoded(this.key)){this._sound=this.context.createBufferSource();if(this.externalNode){this._sound.connect(this.externalNode);}else{this._sound.connect(this.gainNode);}this._buffer=this.game.cache.getSoundData(this.key);this._sound.buffer=this._buffer;if(this.loop&&marker===''){this._sound.loop=true;}if(!this.loop&&marker===''){this._sound.onended=this.onEndedHandler.bind(this);}this.totalDuration=this._sound.buffer.duration;if(this.duration===0){this.duration=this.totalDuration;this.durationMS=Math.ceil(this.totalDuration*1000);}//  Useful to cache this somewhere perhaps?
	if(this._sound.start===undefined){this._sound.noteGrainOn(0,this.position,this.duration);}else{if(this.loop&&marker===''){this._sound.start(0,0);}else{this._sound.start(0,this.position,this.duration);}}this.isPlaying=true;this.startTime=this.game.time.time;this.currentTime=0;this.stopTime=this.startTime+this.durationMS;this.onPlay.dispatch(this);}else{this.pendingPlayback=true;if(this.game.cache.getSound(this.key)&&this.game.cache.getSound(this.key).isDecoding===false){this.game.sound.decode(this.key,this);}}}else{if(this.game.cache.getSound(this.key)&&this.game.cache.getSound(this.key).locked){this.game.cache.reloadSound(this.key);this.pendingPlayback=true;}else{if(this._sound&&(this.game.device.cocoonJS||this._sound.readyState===4)){this._sound.play();//  This doesn't become available until you call play(), wonderful ...
	this.totalDuration=this._sound.duration;if(this.duration===0){this.duration=this.totalDuration;this.durationMS=this.totalDuration*1000;}this._sound.currentTime=this.position;this._sound.muted=this._muted;if(this._muted||this.game.sound.mute){this._sound.volume=0;}else{this._sound.volume=this._volume;}this.isPlaying=true;this.startTime=this.game.time.time;this.currentTime=0;this.stopTime=this.startTime+this.durationMS;this.onPlay.dispatch(this);}else{this.pendingPlayback=true;}}}return this;},/**
	    * Restart the sound, or a marked section of it.
	    *
	    * @method Phaser.Sound#restart
	    * @param {string} [marker=''] - If you want to play a marker then give the key here, otherwise leave blank to play the full sound.
	    * @param {number} [position=0] - The starting position to play the sound from - this is ignored if you provide a marker.
	    * @param {number} [volume=1] - Volume of the sound you want to play.
	    * @param {boolean} [loop=false] - Loop when it finished playing?
	    */restart:function restart(marker,position,volume,loop){marker=marker||'';position=position||0;volume=volume||1;if(loop===undefined){loop=false;}this.play(marker,position,volume,loop,true);},/**
	    * Pauses the sound.
	    *
	    * @method Phaser.Sound#pause
	    */pause:function pause(){if(this.isPlaying&&this._sound){this.paused=true;this.pausedPosition=this.currentTime;this.pausedTime=this.game.time.time;this._tempPause=this._sound.currentTime;this.onPause.dispatch(this);this.stop();}},/**
	    * Resumes the sound.
	    *
	    * @method Phaser.Sound#resume
	    */resume:function resume(){if(this.paused&&this._sound){if(this.usingWebAudio){var p=Math.max(0,this.position+this.pausedPosition/1000);this._sound=this.context.createBufferSource();this._sound.buffer=this._buffer;if(this.externalNode){this._sound.connect(this.externalNode);}else{this._sound.connect(this.gainNode);}if(this.loop){this._sound.loop=true;}if(!this.loop&&this.currentMarker===''){this._sound.onended=this.onEndedHandler.bind(this);}var duration=this.duration-this.pausedPosition/1000;if(this._sound.start===undefined){this._sound.noteGrainOn(0,p,duration);//this._sound.noteOn(0); // the zero is vitally important, crashes iOS6 without it
	}else{if(this.loop&&this.game.device.chrome){//  Handle chrome bug: https://code.google.com/p/chromium/issues/detail?id=457099
	if(this.game.device.chromeVersion===42){this._sound.start(0);}else{this._sound.start(0,p);}}else{this._sound.start(0,p,duration);}}}else{this._sound.currentTime=this._tempPause;this._sound.play();}this.isPlaying=true;this.paused=false;this.startTime+=this.game.time.time-this.pausedTime;this.onResume.dispatch(this);}},/**
	    * Stop playing this sound.
	    *
	    * @method Phaser.Sound#stop
	    */stop:function stop(){if(this.isPlaying&&this._sound){if(this.usingWebAudio){if(this._sound.stop===undefined){this._sound.noteOff(0);}else{try{this._sound.stop(0);}catch(e){//  Thanks Android 4.4
	}}if(this.externalNode){this._sound.disconnect(this.externalNode);}else if(this.gainNode){this._sound.disconnect(this.gainNode);}}else if(this.usingAudioTag){this._sound.pause();this._sound.currentTime=0;}}this.pendingPlayback=false;this.isPlaying=false;if(!this.paused){var prevMarker=this.currentMarker;if(this.currentMarker!==''){this.onMarkerComplete.dispatch(this.currentMarker,this);}this.currentMarker='';if(this.fadeTween!==null){this.fadeTween.stop();}this.onStop.dispatch(this,prevMarker);}},/**
	    * Starts this sound playing (or restarts it if already doing so) and sets the volume to zero.
	    * Then increases the volume from 0 to 1 over the duration specified.
	    *
	    * At the end of the fade Sound.onFadeComplete is dispatched with this Sound object as the first parameter,
	    * and the final volume (1) as the second parameter.
	    *
	    * @method Phaser.Sound#fadeIn
	    * @param {number} [duration=1000] - The time in milliseconds over which the Sound should fade in.
	    * @param {boolean} [loop=false] - Should the Sound be set to loop? Note that this doesn't cause the fade to repeat.
	    * @param {string} [marker=(current marker)] - The marker to start at; defaults to the current (last played) marker. To start playing from the beginning specify specify a marker of `''`.
	    */fadeIn:function fadeIn(duration,loop,marker){if(loop===undefined){loop=false;}if(marker===undefined){marker=this.currentMarker;}if(this.paused){return;}this.play(marker,0,0,loop);this.fadeTo(duration,1);},/**
	    * Decreases the volume of this Sound from its current value to 0 over the duration specified.
	    * At the end of the fade Sound.onFadeComplete is dispatched with this Sound object as the first parameter,
	    * and the final volume (0) as the second parameter.
	    *
	    * @method Phaser.Sound#fadeOut
	    * @param {number} [duration=1000] - The time in milliseconds over which the Sound should fade out.
	    */fadeOut:function fadeOut(duration){this.fadeTo(duration,0);},/**
	    * Fades the volume of this Sound from its current value to the given volume over the duration specified.
	    * At the end of the fade Sound.onFadeComplete is dispatched with this Sound object as the first parameter, 
	    * and the final volume (volume) as the second parameter.
	    *
	    * @method Phaser.Sound#fadeTo
	    * @param {number} [duration=1000] - The time in milliseconds during which the Sound should fade out.
	    * @param {number} [volume] - The volume which the Sound should fade to. This is a value between 0 and 1.
	    */fadeTo:function fadeTo(duration,volume){if(!this.isPlaying||this.paused||volume===this.volume){return;}if(duration===undefined){duration=1000;}if(volume===undefined){console.warn("Phaser.Sound.fadeTo: No Volume Specified.");return;}this.fadeTween=this.game.add.tween(this).to({volume:volume},duration,Phaser.Easing.Linear.None,true);this.fadeTween.onComplete.add(this.fadeComplete,this);},/**
	    * Internal handler for Sound.fadeIn, Sound.fadeOut and Sound.fadeTo.
	    *
	    * @method Phaser.Sound#fadeComplete
	    * @private
	    */fadeComplete:function fadeComplete(){this.onFadeComplete.dispatch(this,this.volume);if(this.volume===0){this.stop();}},/**
	    * Called automatically by SoundManager.volume.
	    *
	    * Sets the volume of AudioTag Sounds as a percentage of the Global Volume.
	    *
	    * You should not normally call this directly.
	    *
	    * @method Phaser.Sound#updateGlobalVolume
	    * @protected
	    * @param {float} globalVolume - The global SoundManager volume.
	    */updateGlobalVolume:function updateGlobalVolume(globalVolume){//  this._volume is the % of the global volume this sound should be played at
	if(this.usingAudioTag&&this._sound){this._sound.volume=globalVolume*this._volume;}},/**
	    * Destroys this sound and all associated events and removes it from the SoundManager.
	    *
	    * @method Phaser.Sound#destroy
	    * @param {boolean} [remove=true] - If true this Sound is automatically removed from the SoundManager.
	    */destroy:function destroy(remove){if(remove===undefined){remove=true;}this.stop();if(remove){this.game.sound.remove(this);}else{this.markers={};this.context=null;this._buffer=null;this.externalNode=null;this.onDecoded.dispose();this.onPlay.dispose();this.onPause.dispose();this.onResume.dispose();this.onLoop.dispose();this.onStop.dispose();this.onMute.dispose();this.onMarkerComplete.dispose();}}};Phaser.Sound.prototype.constructor=Phaser.Sound;/**
	* @name Phaser.Sound#isDecoding
	* @property {boolean} isDecoding - Returns true if the sound file is still decoding.
	* @readonly
	*/Object.defineProperty(Phaser.Sound.prototype,"isDecoding",{get:function get(){return this.game.cache.getSound(this.key).isDecoding;}});/**
	* @name Phaser.Sound#isDecoded
	* @property {boolean} isDecoded - Returns true if the sound file has decoded.
	* @readonly
	*/Object.defineProperty(Phaser.Sound.prototype,"isDecoded",{get:function get(){return this.game.cache.isSoundDecoded(this.key);}});/**
	* @name Phaser.Sound#mute
	* @property {boolean} mute - Gets or sets the muted state of this sound.
	*/Object.defineProperty(Phaser.Sound.prototype,"mute",{get:function get(){return this._muted||this.game.sound.mute;},set:function set(value){value=value||false;if(value===this._muted){return;}if(value){this._muted=true;this._muteVolume=this._tempVolume;if(this.usingWebAudio){this.gainNode.gain.value=0;}else if(this.usingAudioTag&&this._sound){this._sound.volume=0;}}else{this._muted=false;if(this.usingWebAudio){this.gainNode.gain.value=this._muteVolume;}else if(this.usingAudioTag&&this._sound){this._sound.volume=this._muteVolume;}}this.onMute.dispatch(this);}});/**
	* @name Phaser.Sound#volume
	* @property {number} volume - Gets or sets the volume of this sound, a value between 0 and 1. The value given is clamped to the range 0 to 1.
	*/Object.defineProperty(Phaser.Sound.prototype,"volume",{get:function get(){return this._volume;},set:function set(value){//  Causes an Index size error in Firefox if you don't clamp the value
	if(this.game.device.firefox&&this.usingAudioTag){value=this.game.math.clamp(value,0,1);}if(this._muted){this._muteVolume=value;return;}this._tempVolume=value;this._volume=value;if(this.usingWebAudio){this.gainNode.gain.value=value;}else if(this.usingAudioTag&&this._sound){this._sound.volume=value;}}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Sound Manager is responsible for playing back audio via either the Legacy HTML Audio tag or via Web Audio if the browser supports it.
	* Note: On Firefox 25+ on Linux if you have media.gstreamer disabled in about:config then it cannot play back mp3 or m4a files.
	* The audio file type and the encoding of those files are extremely important. Not all browsers can play all audio formats.
	* There is a good guide to what's supported here: http://hpr.dogphilosophy.net/test/
	*
	* If you are reloading a Phaser Game on a page that never properly refreshes (such as in an AngularJS project) then you will quickly run out
	* of AudioContext nodes. If this is the case create a global var called PhaserGlobal on the window object before creating the game. The active
	* AudioContext will then be saved to window.PhaserGlobal.audioContext when the Phaser game is destroyed, and re-used when it starts again.
	*
	* Mobile warning: There are some mobile devices (certain iPad 2 and iPad Mini revisions) that cannot play 48000 Hz audio.
	* When they try to play the audio becomes extremely distorted and buzzes, eventually crashing the sound system.
	* The solution is to use a lower encoding rate such as 44100 Hz. Sometimes the audio context will
	* be created with a sampleRate of 48000. If this happens and audio distorts you should re-create the context.
	*
	* @class Phaser.SoundManager
	* @constructor
	* @param {Phaser.Game} game - Reference to the current game instance.
	*/Phaser.SoundManager=function(game){/**
	    * @property {Phaser.Game} game - Local reference to game.
	    */this.game=game;/**
	    * @property {Phaser.Signal} onSoundDecode - The event dispatched when a sound decodes (typically only for mp3 files)
	    */this.onSoundDecode=new Phaser.Signal();/**
	    * This signal is dispatched whenever the global volume changes. The new volume is passed as the only parameter to your callback.
	    * @property {Phaser.Signal} onVolumeChange
	    */this.onVolumeChange=new Phaser.Signal();/**
	    * This signal is dispatched when the SoundManager is globally muted, either directly via game code or as a result of the game pausing.
	    * @property {Phaser.Signal} onMute
	    */this.onMute=new Phaser.Signal();/**
	    * This signal is dispatched when the SoundManager is globally un-muted, either directly via game code or as a result of the game resuming from a pause.
	    * @property {Phaser.Signal} onUnMute
	    */this.onUnMute=new Phaser.Signal();/**
	    * @property {AudioContext} context - The AudioContext being used for playback.
	    * @default
	    */this.context=null;/**
	    * @property {boolean} usingWebAudio - True the SoundManager and device are both using Web Audio.
	    * @readonly
	    */this.usingWebAudio=false;/**
	    * @property {boolean} usingAudioTag - True the SoundManager and device are both using the Audio tag instead of Web Audio.
	    * @readonly
	    */this.usingAudioTag=false;/**
	    * @property {boolean} noAudio - True if audio been disabled via the PhaserGlobal (useful if you need to use a 3rd party audio library) or the device doesn't support any audio.
	    * @default
	    */this.noAudio=false;/**
	    * @property {boolean} connectToMaster - Used in conjunction with Sound.externalNode this allows you to stop a Sound node being connected to the SoundManager master gain node.
	    * @default
	    */this.connectToMaster=true;/**
	    * @property {boolean} touchLocked - true if the audio system is currently locked awaiting a touch event.
	    * @default
	    */this.touchLocked=false;/**
	    * @property {number} channels - The number of audio channels to use in playback.
	    * @default
	    */this.channels=32;/**
	    * Set to true to have all sound muted when the Phaser game pauses (such as on loss of focus),
	    * or set to false to keep audio playing, regardless of the game pause state. You may need to
	    * do this should you wish to control audio muting via external DOM buttons or similar.
	    * @property {boolean} muteOnPause 
	    * @default
	    */this.muteOnPause=true;/**
	    * @property {boolean} _codeMuted - Internal mute tracking var.
	    * @private
	    * @default
	    */this._codeMuted=false;/**
	    * @property {boolean} _muted - Internal mute tracking var.
	    * @private
	    * @default
	    */this._muted=false;/**
	    * @property {AudioContext} _unlockSource - Internal unlock tracking var.
	    * @private
	    * @default
	    */this._unlockSource=null;/**
	    * @property {number} _volume - The global audio volume. A value between 0 (silence) and 1 (full volume).
	    * @private
	    * @default
	    */this._volume=1;/**
	    * @property {array} _sounds - An array containing all the sounds
	    * @private
	    */this._sounds=[];/**
	    * @property {Phaser.ArraySet} _watchList - An array set containing all the sounds being monitored for decoding status.
	    * @private
	    */this._watchList=new Phaser.ArraySet();/**
	    * @property {boolean} _watching - Is the SoundManager monitoring the watchList?
	    * @private
	    */this._watching=false;/**
	    * @property {function} _watchCallback - The callback to invoke once the watchlist is clear.
	    * @private
	    */this._watchCallback=null;/**
	    * @property {object} _watchContext - The context in which to call the watchlist callback.
	    * @private
	    */this._watchContext=null;};Phaser.SoundManager.prototype={/**
	    * Initialises the sound manager.
	    * @method Phaser.SoundManager#boot
	    * @protected
	    */boot:function boot(){if(this.game.device.iOS&&this.game.device.webAudio===false){this.channels=1;}//  PhaserGlobal overrides
	if(window['PhaserGlobal']){//  Check to see if all audio playback is disabled (i.e. handled by a 3rd party class)
	if(window['PhaserGlobal'].disableAudio===true){this.noAudio=true;this.touchLocked=false;return;}//  Check if the Web Audio API is disabled (for testing Audio Tag playback during development)
	if(window['PhaserGlobal'].disableWebAudio===true){this.usingAudioTag=true;this.touchLocked=false;return;}}if(window['PhaserGlobal']&&window['PhaserGlobal'].audioContext){this.context=window['PhaserGlobal'].audioContext;}else{if(!!window['AudioContext']){try{this.context=new window['AudioContext']();}catch(error){this.context=null;this.usingWebAudio=false;this.touchLocked=false;}}else if(!!window['webkitAudioContext']){try{this.context=new window['webkitAudioContext']();}catch(error){this.context=null;this.usingWebAudio=false;this.touchLocked=false;}}}if(this.context===null){//  No Web Audio support - how about legacy Audio?
	if(window['Audio']===undefined){this.noAudio=true;return;}else{this.usingAudioTag=true;}}else{this.usingWebAudio=true;if(this.context.createGain===undefined){this.masterGain=this.context.createGainNode();}else{this.masterGain=this.context.createGain();}this.masterGain.gain.value=1;this.masterGain.connect(this.context.destination);}if(!this.noAudio){//  On mobile we need a native touch event before we can play anything, so capture it here
	if(!this.game.device.cocoonJS&&this.game.device.iOS||window['PhaserGlobal']&&window['PhaserGlobal'].fakeiOSTouchLock){this.setTouchLock();}}},/**
	    * Sets the Input Manager touch callback to be SoundManager.unlock.
	    * Required for iOS audio device unlocking. Mostly just used internally.
	    *
	    * @method Phaser.SoundManager#setTouchLock
	    */setTouchLock:function setTouchLock(){if(this.noAudio||window['PhaserGlobal']&&window['PhaserGlobal'].disableAudio===true){return;}if(this.game.device.iOSVersion>8){this.game.input.touch.addTouchLockCallback(this.unlock,this,true);}else{this.game.input.touch.addTouchLockCallback(this.unlock,this);}this.touchLocked=true;},/**
	    * Enables the audio, usually after the first touch.
	    *
	    * @method Phaser.SoundManager#unlock
	    * @return {boolean} True if the callback should be removed, otherwise false.
	    */unlock:function unlock(){if(this.noAudio||!this.touchLocked||this._unlockSource!==null){return true;}//  Global override (mostly for Audio Tag testing)
	if(this.usingAudioTag){this.touchLocked=false;this._unlockSource=null;}else if(this.usingWebAudio){// Create empty buffer and play it
	// The SoundManager.update loop captures the state of it and then resets touchLocked to false
	var buffer=this.context.createBuffer(1,1,22050);this._unlockSource=this.context.createBufferSource();this._unlockSource.buffer=buffer;this._unlockSource.connect(this.context.destination);if(this._unlockSource.start===undefined){this._unlockSource.noteOn(0);}else{this._unlockSource.start(0);}}//  We can remove the event because we've done what we needed (started the unlock sound playing)
	return true;},/**
	    * Stops all the sounds in the game.
	    *
	    * @method Phaser.SoundManager#stopAll
	    */stopAll:function stopAll(){if(this.noAudio){return;}for(var i=0;i<this._sounds.length;i++){if(this._sounds[i]){this._sounds[i].stop();}}},/**
	    * Pauses all the sounds in the game.
	    *
	    * @method Phaser.SoundManager#pauseAll
	    */pauseAll:function pauseAll(){if(this.noAudio){return;}for(var i=0;i<this._sounds.length;i++){if(this._sounds[i]){this._sounds[i].pause();}}},/**
	    * Resumes every sound in the game.
	    *
	    * @method Phaser.SoundManager#resumeAll
	    */resumeAll:function resumeAll(){if(this.noAudio){return;}for(var i=0;i<this._sounds.length;i++){if(this._sounds[i]){this._sounds[i].resume();}}},/**
	    * Decode a sound by its asset key.
	    *
	    * @method Phaser.SoundManager#decode
	    * @param {string} key - Assets key of the sound to be decoded.
	    * @param {Phaser.Sound} [sound] - Its buffer will be set to decoded data.
	    */decode:function decode(key,sound){sound=sound||null;var soundData=this.game.cache.getSoundData(key);if(soundData){if(this.game.cache.isSoundDecoded(key)===false){this.game.cache.updateSound(key,'isDecoding',true);var _this=this;try{this.context.decodeAudioData(soundData,function(buffer){if(buffer){_this.game.cache.decodedSound(key,buffer);_this.onSoundDecode.dispatch(key,sound);}});}catch(e){}}}},/**
	     * This method allows you to give the SoundManager a list of Sound files, or keys, and a callback.
	     * Once all of the Sound files have finished decoding the callback will be invoked.
	     * The amount of time spent decoding depends on the codec used and file size.
	     * If all of the files given have already decoded the callback is triggered immediately.
	     *
	     * @method Phaser.SoundManager#setDecodedCallback
	     * @param {string|array} files - An array containing either Phaser.Sound objects or their key strings as found in the Phaser.Cache.
	     * @param {Function} callback - The callback which will be invoked once all files have finished decoding.
	     * @param {Object} callbackContext - The context in which the callback will run.
	     */setDecodedCallback:function setDecodedCallback(files,callback,callbackContext){if(typeof files==='string'){files=[files];}this._watchList.reset();for(var i=0;i<files.length;i++){if(files[i]instanceof Phaser.Sound){if(!this.game.cache.isSoundDecoded(files[i].key)){this._watchList.add(files[i].key);}}else if(!this.game.cache.isSoundDecoded(files[i])){this._watchList.add(files[i]);}}//  All decoded already?
	if(this._watchList.total===0){this._watching=false;callback.call(callbackContext);}else{this._watching=true;this._watchCallback=callback;this._watchContext=callbackContext;}},/**
	    * Updates every sound in the game, checks for audio unlock on mobile and monitors the decoding watch list.
	    *
	    * @method Phaser.SoundManager#update
	    * @protected
	    */update:function update(){if(this.noAudio){return;}if(this.touchLocked&&this._unlockSource!==null&&(this._unlockSource.playbackState===this._unlockSource.PLAYING_STATE||this._unlockSource.playbackState===this._unlockSource.FINISHED_STATE)){this.touchLocked=false;this._unlockSource=null;}for(var i=0;i<this._sounds.length;i++){this._sounds[i].update();}if(this._watching){var key=this._watchList.first;while(key){if(this.game.cache.isSoundDecoded(key)){this._watchList.remove(key);}key=this._watchList.next;}if(this._watchList.total===0){this._watching=false;this._watchCallback.call(this._watchContext);}}},/**
	    * Adds a new Sound into the SoundManager.
	    *
	    * @method Phaser.SoundManager#add
	    * @param {string} key - Asset key for the sound.
	    * @param {number} [volume=1] - Default value for the volume.
	    * @param {boolean} [loop=false] - Whether or not the sound will loop.
	    * @param {boolean} [connect=true] - Controls if the created Sound object will connect to the master gainNode of the SoundManager when running under WebAudio.
	    * @return {Phaser.Sound} The new sound instance.
	    */add:function add(key,volume,loop,connect){if(volume===undefined){volume=1;}if(loop===undefined){loop=false;}if(connect===undefined){connect=this.connectToMaster;}var sound=new Phaser.Sound(this.game,key,volume,loop,connect);this._sounds.push(sound);return sound;},/**
	     * Adds a new AudioSprite into the SoundManager.
	     *
	     * @method Phaser.SoundManager#addSprite
	     * @param {string} key - Asset key for the sound.
	     * @return {Phaser.AudioSprite} The new AudioSprite instance.
	     */addSprite:function addSprite(key){var audioSprite=new Phaser.AudioSprite(this.game,key);return audioSprite;},/**
	    * Removes a Sound from the SoundManager. The removed Sound is destroyed before removal.
	    *
	    * @method Phaser.SoundManager#remove
	    * @param {Phaser.Sound} sound - The sound object to remove.
	    * @return {boolean} True if the sound was removed successfully, otherwise false.
	    */remove:function remove(sound){var i=this._sounds.length;while(i--){if(this._sounds[i]===sound){this._sounds[i].destroy(false);this._sounds.splice(i,1);return true;}}return false;},/**
	    * Removes all Sounds from the SoundManager that have an asset key matching the given value.
	    * The removed Sounds are destroyed before removal.
	    *
	    * @method Phaser.SoundManager#removeByKey
	    * @param {string} key - The key to match when removing sound objects.
	    * @return {number} The number of matching sound objects that were removed.
	    */removeByKey:function removeByKey(key){var i=this._sounds.length;var removed=0;while(i--){if(this._sounds[i].key===key){this._sounds[i].destroy(false);this._sounds.splice(i,1);removed++;}}return removed;},/**
	    * Adds a new Sound into the SoundManager and starts it playing.
	    *
	    * @method Phaser.SoundManager#play
	    * @param {string} key - Asset key for the sound.
	    * @param {number} [volume=1] - Default value for the volume.
	    * @param {boolean} [loop=false] - Whether or not the sound will loop.
	    * @return {Phaser.Sound} The new sound instance.
	    */play:function play(key,volume,loop){if(this.noAudio){return;}var sound=this.add(key,volume,loop);sound.play();return sound;},/**
	    * Internal mute handler called automatically by the SoundManager.mute setter.
	    *
	    * @method Phaser.SoundManager#setMute
	    * @private
	    */setMute:function setMute(){if(this._muted){return;}this._muted=true;if(this.usingWebAudio){this._muteVolume=this.masterGain.gain.value;this.masterGain.gain.value=0;}//  Loop through sounds
	for(var i=0;i<this._sounds.length;i++){if(this._sounds[i].usingAudioTag){this._sounds[i].mute=true;}}this.onMute.dispatch();},/**
	    * Internal mute handler called automatically by the SoundManager.mute setter.
	    *
	    * @method Phaser.SoundManager#unsetMute
	    * @private
	    */unsetMute:function unsetMute(){if(!this._muted||this._codeMuted){return;}this._muted=false;if(this.usingWebAudio){this.masterGain.gain.value=this._muteVolume;}//  Loop through sounds
	for(var i=0;i<this._sounds.length;i++){if(this._sounds[i].usingAudioTag){this._sounds[i].mute=false;}}this.onUnMute.dispatch();},/**
	    * Stops all the sounds in the game, then destroys them and finally clears up any callbacks.
	    *
	    * @method Phaser.SoundManager#destroy
	    */destroy:function destroy(){this.stopAll();for(var i=0;i<this._sounds.length;i++){if(this._sounds[i]){this._sounds[i].destroy();}}this._sounds=[];this.onSoundDecode.dispose();if(this.context){if(window['PhaserGlobal']){//  Store this in the PhaserGlobal window var, if set, to allow for re-use if the game is created again without the page refreshing
	window['PhaserGlobal'].audioContext=this.context;}else{if(this.context.close){this.context.close();}}}}};Phaser.SoundManager.prototype.constructor=Phaser.SoundManager;/**
	* @name Phaser.SoundManager#mute
	* @property {boolean} mute - Gets or sets the muted state of the SoundManager. This effects all sounds in the game.
	*/Object.defineProperty(Phaser.SoundManager.prototype,"mute",{get:function get(){return this._muted;},set:function set(value){value=value||false;if(value){if(this._muted){return;}this._codeMuted=true;this.setMute();}else{if(!this._muted){return;}this._codeMuted=false;this.unsetMute();}}});/**
	* @name Phaser.SoundManager#volume
	* @property {number} volume - Gets or sets the global volume of the SoundManager, a value between 0 and 1. The value given is clamped to the range 0 to 1.
	*/Object.defineProperty(Phaser.SoundManager.prototype,"volume",{get:function get(){return this._volume;},set:function set(value){if(value<0){value=0;}else if(value>1){value=1;}if(this._volume!==value){this._volume=value;if(this.usingWebAudio){this.masterGain.gain.value=value;}else{//  Loop through the sound cache and change the volume of all html audio tags
	for(var i=0;i<this._sounds.length;i++){if(this._sounds[i].usingAudioTag){this._sounds[i].updateGlobalVolume(value);}}}this.onVolumeChange.dispatch(value);}}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* @classdesc
	* The ScaleManager object handles the the scaling, resizing, and alignment of the
	* Game size and the game Display canvas.
	*
	* The Game size is the logical size of the game; the Display canvas has size as an HTML element.
	*
	* The calculations of these are heavily influenced by the bounding Parent size which is the computed
	* dimensions of the Display canvas's Parent container/element - the _effective CSS rules of the
	* canvas's Parent element play an important role_ in the operation of the ScaleManager. 
	*
	* The Display canvas - or Game size, depending {@link #scaleMode} - is updated to best utilize the Parent size.
	* When in Fullscreen mode or with {@link #parentIsWindow} the Parent size is that of the visual viewport (see {@link Phaser.ScaleManager#getParentBounds getParentBounds}).
	*
	* Parent and Display canvas containment guidelines:
	*
	* - Style the Parent element (of the game canvas) to control the Parent size and
	*   thus the Display canvas's size and layout.
	*
	* - The Parent element's CSS styles should _effectively_ apply maximum (and minimum) bounding behavior.
	*
	* - The Parent element should _not_ apply a padding as this is not accounted for.
	*   If a padding is required apply it to the Parent's parent or apply a margin to the Parent.
	*   If you need to add a border, margin or any other CSS around your game container, then use a parent element and
	*   apply the CSS to this instead, otherwise you'll be constantly resizing the shape of the game container.
	*
	* - The Display canvas layout CSS styles (i.e. margins, size) should not be altered/specified as
	*   they may be updated by the ScaleManager.
	*
	* @description
	* Create a new ScaleManager object - this is done automatically by {@link Phaser.Game}
	*
	* The `width` and `height` constructor parameters can either be a number which represents pixels or a string that represents a percentage: e.g. `800` (for 800 pixels) or `"80%"` for 80%.
	*
	* @class
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {number|string} width - The width of the game. See above.
	* @param {number|string} height - The height of the game. See above.
	*/Phaser.ScaleManager=function(game,width,height){/**
	    * A reference to the currently running game.
	    * @property {Phaser.Game} game
	    * @protected
	    * @readonly
	    */this.game=game;/**
	    * Provides access to some cross-device DOM functions.
	    * @property {Phaser.DOM} dom
	    * @protected
	    * @readonly
	    */this.dom=Phaser.DOM;/**
	    * _EXPERIMENTAL:_ A responsive grid on which you can align game objects.
	    * @property {Phaser.FlexGrid} grid
	    * @public
	    */this.grid=null;/**
	    * Target width (in pixels) of the Display canvas.
	    * @property {number} width
	    * @readonly
	    */this.width=0;/**
	    * Target height (in pixels) of the Display canvas.
	    * @property {number} height
	    * @readonly
	    */this.height=0;/**
	    * Minimum width the canvas should be scaled to (in pixels).
	    * Change with {@link #setMinMax}.
	    * @property {?number} minWidth
	    * @readonly
	    * @protected
	    */this.minWidth=null;/**
	    * Maximum width the canvas should be scaled to (in pixels).
	    * If null it will scale to whatever width the browser can handle.
	    * Change with {@link #setMinMax}.
	    * @property {?number} maxWidth
	    * @readonly
	    * @protected
	    */this.maxWidth=null;/**
	    * Minimum height the canvas should be scaled to (in pixels).
	    * Change with {@link #setMinMax}.
	    * @property {?number} minHeight
	    * @readonly
	    * @protected
	    */this.minHeight=null;/**
	    * Maximum height the canvas should be scaled to (in pixels).
	    * If null it will scale to whatever height the browser can handle.
	    * Change with {@link #setMinMax}.
	    * @property {?number} maxHeight
	    * @readonly
	    * @protected
	    */this.maxHeight=null;/**
	    * The offset coordinates of the Display canvas from the top-left of the browser window.
	    * The is used internally by Phaser.Pointer (for Input) and possibly other types.
	    * @property {Phaser.Point} offset
	    * @readonly
	    * @protected
	    */this.offset=new Phaser.Point();/**
	    * If true, the game should only run in a landscape orientation.
	    * Change with {@link #forceOrientation}.
	    * @property {boolean} forceLandscape
	    * @readonly
	    * @default
	    * @protected
	    */this.forceLandscape=false;/**
	    * If true, the game should only run in a portrait 
	    * Change with {@link #forceOrientation}.
	    * @property {boolean} forcePortrait
	    * @readonly
	    * @default
	    * @protected
	    */this.forcePortrait=false;/**
	    * True if {@link #forceLandscape} or {@link #forcePortrait} are set and do not agree with the browser orientation.
	    *
	    * This value is not updated immediately.
	    *
	    * @property {boolean} incorrectOrientation    
	    * @readonly
	    * @protected
	    */this.incorrectOrientation=false;/**
	    * See {@link #pageAlignHorizontally}.
	    * @property {boolean} _pageAlignHorizontally
	    * @private
	    */this._pageAlignHorizontally=false;/**
	    * See {@link #pageAlignVertically}.
	    * @property {boolean} _pageAlignVertically
	    * @private
	    */this._pageAlignVertically=false;/**
	    * This signal is dispatched when the orientation changes _or_ the validity of the current orientation changes.
	    * 
	    * The signal is supplied with the following arguments:
	    * - `scale` - the ScaleManager object
	    * - `prevOrientation`, a string - The previous orientation as per {@link Phaser.ScaleManager#screenOrientation screenOrientation}.
	    * - `wasIncorrect`, a boolean - True if the previous orientation was last determined to be incorrect.
	    *
	    * Access the current orientation and validity with `scale.screenOrientation` and `scale.incorrectOrientation`.
	    * Thus the following tests can be done:
	    *
	    *     // The orientation itself changed:
	    *     scale.screenOrientation !== prevOrientation
	    *     // The orientation just became incorrect:
	    *     scale.incorrectOrientation && !wasIncorrect
	    *
	    * It is possible that this signal is triggered after {@link #forceOrientation} so the orientation
	    * correctness changes even if the orientation itself does not change.
	    *
	    * This is signaled from `preUpdate` (or `pauseUpdate`) _even when_ the game is paused.
	    *
	    * @property {Phaser.Signal} onOrientationChange
	    * @public
	    */this.onOrientationChange=new Phaser.Signal();/**
	    * This signal is dispatched when the browser enters an incorrect orientation, as defined by {@link #forceOrientation}.
	    *
	    * This is signaled from `preUpdate` (or `pauseUpdate`) _even when_ the game is paused.
	    *
	    * @property {Phaser.Signal} enterIncorrectOrientation
	    * @public
	    */this.enterIncorrectOrientation=new Phaser.Signal();/**
	    * This signal is dispatched when the browser leaves an incorrect orientation, as defined by {@link #forceOrientation}.
	    *
	    * This is signaled from `preUpdate` (or `pauseUpdate`) _even when_ the game is paused.
	    *
	    * @property {Phaser.Signal} leaveIncorrectOrientation
	    * @public
	    */this.leaveIncorrectOrientation=new Phaser.Signal();/**
	    * This boolean provides you with a way to determine if the browser is in Full Screen
	    * mode (via the Full Screen API), and Phaser was the one responsible for activating it.
	    *
	    * It's possible that ScaleManager.isFullScreen returns `true` even if Phaser wasn't the
	    * one that made the browser go full-screen, so this flag lets you determine that.
	    * 
	    * @property {boolean} hasPhaserSetFullScreen
	    * @default
	    */this.hasPhaserSetFullScreen=false;/**
	    * If specified, this is the DOM element on which the Fullscreen API enter request will be invoked.
	    * The target element must have the correct CSS styling and contain the Display canvas.
	    *
	    * The elements style will be modified (ie. the width and height might be set to 100%)
	    * but it will not be added to, removed from, or repositioned within the DOM.
	    * An attempt is made to restore relevant style changes when fullscreen mode is left.
	    *
	    * For pre-2.2.0 behavior set `game.scale.fullScreenTarget = game.canvas`.
	    *
	    * @property {?DOMElement} fullScreenTarget
	    * @default
	    */this.fullScreenTarget=null;/**
	    * The fullscreen target, as created by {@link #createFullScreenTarget}.
	    * This is not set if {@link #fullScreenTarget} is used and is cleared when fullscreen mode ends.
	    * @property {?DOMElement} _createdFullScreenTarget
	    * @private
	    */this._createdFullScreenTarget=null;/**
	    * This signal is dispatched when fullscreen mode is ready to be initialized but
	    * before the fullscreen request.
	    *
	    * The signal is passed two arguments: `scale` (the ScaleManager), and an object in the form `{targetElement: DOMElement}`.
	    *
	    * The `targetElement` is the {@link #fullScreenTarget} element,
	    * if such is assigned, or a new element created by {@link #createFullScreenTarget}.
	    *
	    * Custom CSS styling or resets can be applied to `targetElement` as required.
	    *
	    * If `targetElement` is _not_ the same element as {@link #fullScreenTarget}:
	    * - After initialization the Display canvas is moved onto the `targetElement` for
	    *   the duration of the fullscreen mode, and restored to it's original DOM location when fullscreen is exited.
	    * - The `targetElement` is moved/re-parented within the DOM and may have its CSS styles updated.
	    *
	    * The behavior of a pre-assigned target element is covered in {@link Phaser.ScaleManager#fullScreenTarget fullScreenTarget}.
	    *
	    * @property {Phaser.Signal} onFullScreenInit
	    * @public
	    */this.onFullScreenInit=new Phaser.Signal();/**
	    * This signal is dispatched when the browser enters or leaves fullscreen mode, if supported.
	    *
	    * The signal is supplied with a single argument: `scale` (the ScaleManager). Use `scale.isFullScreen` to determine
	    * if currently running in Fullscreen mode.
	    *
	    * @property {Phaser.Signal} onFullScreenChange
	    * @public    
	    */this.onFullScreenChange=new Phaser.Signal();/**
	    * This signal is dispatched when the browser fails to enter fullscreen mode;
	    * or if the device does not support fullscreen mode and `startFullScreen` is invoked.
	    *
	    * The signal is supplied with a single argument: `scale` (the ScaleManager).
	    *
	    * @property {Phaser.Signal} onFullScreenError
	    * @public
	    */this.onFullScreenError=new Phaser.Signal();/**
	    * The _last known_ orientation of the screen, as defined in the Window Screen Web API.
	    * See {@link Phaser.DOM.getScreenOrientation} for possible values.
	    *
	    * @property {string} screenOrientation
	    * @readonly
	    * @public
	    */this.screenOrientation=this.dom.getScreenOrientation();/**
	    * The _current_ scale factor based on the game dimensions vs. the scaled dimensions.
	    * @property {Phaser.Point} scaleFactor
	    * @readonly
	    */this.scaleFactor=new Phaser.Point(1,1);/**
	    * The _current_ inversed scale factor. The displayed dimensions divided by the game dimensions.
	    * @property {Phaser.Point} scaleFactorInversed
	    * @readonly
	    * @protected
	    */this.scaleFactorInversed=new Phaser.Point(1,1);/**
	    * The Display canvas is aligned by adjusting the margins; the last margins are stored here.
	    *
	    * @property {Bounds-like} margin
	    * @readonly
	    * @protected
	    */this.margin={left:0,top:0,right:0,bottom:0,x:0,y:0};/**
	    * The bounds of the scaled game. The x/y will match the offset of the canvas element and the width/height the scaled width and height.
	    * @property {Phaser.Rectangle} bounds
	    * @readonly
	    */this.bounds=new Phaser.Rectangle();/**
	    * The aspect ratio of the scaled Display canvas.
	    * @property {number} aspectRatio
	    * @readonly
	    */this.aspectRatio=0;/**
	    * The aspect ratio of the original game dimensions.
	    * @property {number} sourceAspectRatio
	    * @readonly
	    */this.sourceAspectRatio=0;/**
	    * The native browser events from Fullscreen API changes.
	    * @property {any} event
	    * @readonly
	    * @private
	    */this.event=null;/**
	    * The edges on which to constrain the game Display/canvas in _addition_ to the restrictions of the parent container.
	    *
	    * The properties are strings and can be '', 'visual', 'layout', or 'layout-soft'.
	    * - If 'visual', the edge will be constrained to the Window / displayed screen area
	    * - If 'layout', the edge will be constrained to the CSS Layout bounds
	    * - An invalid value is treated as 'visual'
	    *
	    * @member
	    * @property {string} bottom
	    * @property {string} right
	    * @default
	    */this.windowConstraints={right:'layout',bottom:''};/**
	    * Various compatibility settings.
	    * A value of "(auto)" indicates the setting is configured based on device and runtime information.
	    *
	    * A {@link #refresh} may need to be performed after making changes.
	    *
	    * @protected
	    * 
	    * @property {boolean} [supportsFullScreen=(auto)] - True only if fullscreen support will be used. (Changing to fullscreen still might not work.)
	    *
	    * @property {boolean} [orientationFallback=(auto)] - See {@link Phaser.DOM.getScreenOrientation}.
	    *
	    * @property {boolean} [noMargins=false] - If true then the Display canvas's margins will not be updated anymore: existing margins must be manually cleared. Disabling margins prevents automatic canvas alignment/centering, possibly in fullscreen.
	    *
	    * @property {?Phaser.Point} [scrollTo=(auto)] - If specified the window will be scrolled to this position on every refresh.
	    *
	    * @property {boolean} [forceMinimumDocumentHeight=false] - If enabled the document elements minimum height is explicitly set on updates.
	    *    The height set varies by device and may either be the height of the window or the viewport.
	    *
	    * @property {boolean} [canExpandParent=true] - If enabled then SHOW_ALL and USER_SCALE modes can try and expand the parent element. It may be necessary for the parent element to impose CSS width/height restrictions.
	    *
	    * @property {string} [clickTrampoline=(auto)] - On certain browsers (eg. IE) FullScreen events need to be triggered via 'click' events.
	    *     A value of 'when-not-mouse' uses a click trampoline when a pointer that is not the primary mouse is used.
	    *     Any other string value (including the empty string) prevents using click trampolines.
	    *     For more details on click trampolines see {@link Phaser.Pointer#addClickTrampoline}.
	    */this.compatibility={supportsFullScreen:false,orientationFallback:null,noMargins:false,scrollTo:null,forceMinimumDocumentHeight:false,canExpandParent:true,clickTrampoline:''};/**
	    * Scale mode to be used when not in fullscreen.
	    * @property {number} _scaleMode
	    * @private
	    */this._scaleMode=Phaser.ScaleManager.NO_SCALE;/*
	    * Scale mode to be used in fullscreen.
	    * @property {number} _fullScreenScaleMode
	    * @private
	    */this._fullScreenScaleMode=Phaser.ScaleManager.NO_SCALE;/**
	    * If the parent container of the Game canvas is the browser window itself (i.e. document.body),
	    * rather than another div, this should set to `true`.
	    *
	    * The {@link #parentNode} property is generally ignored while this is in effect.
	    *
	    * @property {boolean} parentIsWindow
	    */this.parentIsWindow=false;/**
	    * The _original_ DOM element for the parent of the Display canvas.
	    * This may be different in fullscreen - see {@link #createFullScreenTarget}.
	    *
	    * This should only be changed after moving the Game canvas to a different DOM parent.
	    *
	    * @property {?DOMElement} parentNode
	    */this.parentNode=null;/**
	    * The scale of the game in relation to its parent container.
	    * @property {Phaser.Point} parentScaleFactor
	    * @readonly
	    */this.parentScaleFactor=new Phaser.Point(1,1);/**
	    * The maximum time (in ms) between dimension update checks for the Canvas's parent element (or window).
	    * Update checks normally happen quicker in response to other events.
	    *
	    * @property {integer} trackParentInterval
	    * @default
	    * @protected
	    * @see {@link Phaser.ScaleManager#refresh refresh}
	    */this.trackParentInterval=2000;/**
	    * This signal is dispatched when the size of the Display canvas changes _or_ the size of the Game changes. 
	    * When invoked this is done _after_ the Canvas size/position have been updated.
	    *
	    * This signal is _only_ called when a change occurs and a reflow may be required.
	    * For example, if the canvas does not change sizes because of CSS settings (such as min-width)
	    * then this signal will _not_ be triggered.
	    *
	    * Use this to handle responsive game layout options.
	    *
	    * This is signaled from `preUpdate` (or `pauseUpdate`) _even when_ the game is paused.
	    *
	    * @property {Phaser.Signal} onSizeChange
	    * @todo Formalize the arguments, if any, supplied to this signal.
	    */this.onSizeChange=new Phaser.Signal();/**
	    * The callback that will be called each the parent container resizes.
	    * @property {function} onResize
	    * @private
	    */this.onResize=null;/**
	    * The context in which the {@link #onResize} callback will be called.
	    * @property {object} onResizeContext
	    * @private
	    */this.onResizeContext=null;/**
	    * @property {integer} _pendingScaleMode - Used to retain the scale mode if set from config before Boot.
	    * @private
	    */this._pendingScaleMode=null;/**
	    * Information saved when fullscreen mode is started.
	    * @property {?object} _fullScreenRestore
	    * @private
	    */this._fullScreenRestore=null;/**
	    * The _actual_ game dimensions, as initially set or set by {@link #setGameSize}.
	    * @property {Phaser.Rectangle} _gameSize
	    * @private
	    */this._gameSize=new Phaser.Rectangle();/**
	    * The user-supplied scale factor, used with the USER_SCALE scaling mode.
	    * @property {Phaser.Point} _userScaleFactor
	    * @private
	    */this._userScaleFactor=new Phaser.Point(1,1);/**
	    * The user-supplied scale trim, used with the USER_SCALE scaling mode.
	    * @property {Phaser.Point} _userScaleTrim
	    * @private
	    */this._userScaleTrim=new Phaser.Point(0,0);/**
	    * The last time the bounds were checked in `preUpdate`.
	    * @property {number} _lastUpdate
	    * @private
	    */this._lastUpdate=0;/**
	    * Size checks updates are delayed according to the throttle.
	    * The throttle increases to `trackParentInterval` over time and is used to more
	    * rapidly detect changes in certain browsers (eg. IE) while providing back-off safety.
	    * @property {integer} _updateThrottle
	    * @private
	    */this._updateThrottle=0;/**
	    * The minimum throttle allowed until it has slowed down sufficiently.
	    * @property {integer} _updateThrottleReset   
	    * @private
	    */this._updateThrottleReset=100;/**
	    * The cached result of the parent (possibly window) bounds; used to invalidate sizing.
	    * @property {Phaser.Rectangle} _parentBounds
	    * @private
	    */this._parentBounds=new Phaser.Rectangle();/**
	    * Temporary bounds used for internal work to cut down on new objects created.
	    * @property {Phaser.Rectangle} _parentBounds
	    * @private
	    */this._tempBounds=new Phaser.Rectangle();/**
	    * The Canvas size at which the last onSizeChange signal was triggered.
	    * @property {Phaser.Rectangle} _lastReportedCanvasSize
	    * @private
	    */this._lastReportedCanvasSize=new Phaser.Rectangle();/**
	    * The Game size at which the last onSizeChange signal was triggered.
	    * @property {Phaser.Rectangle} _lastReportedGameSize
	    * @private
	    */this._lastReportedGameSize=new Phaser.Rectangle();/**
	    * @property {boolean} _booted - ScaleManager booted state.
	    * @private
	    */this._booted=false;if(game.config){this.parseConfig(game.config);}this.setupScale(width,height);};/**
	* A scale mode that stretches content to fill all available space - see {@link Phaser.ScaleManager#scaleMode scaleMode}.
	*
	* @constant
	* @type {integer}
	*/Phaser.ScaleManager.EXACT_FIT=0;/**
	* A scale mode that prevents any scaling - see {@link Phaser.ScaleManager#scaleMode scaleMode}.
	*
	* @constant
	* @type {integer}
	*/Phaser.ScaleManager.NO_SCALE=1;/**
	* A scale mode that shows the entire game while maintaining proportions - see {@link Phaser.ScaleManager#scaleMode scaleMode}.
	*
	* @constant
	* @type {integer}
	*/Phaser.ScaleManager.SHOW_ALL=2;/**
	* A scale mode that causes the Game size to change - see {@link Phaser.ScaleManager#scaleMode scaleMode}.
	*
	* @constant
	* @type {integer}
	*/Phaser.ScaleManager.RESIZE=3;/**
	* A scale mode that allows a custom scale factor - see {@link Phaser.ScaleManager#scaleMode scaleMode}.
	*
	* @constant
	* @type {integer}
	*/Phaser.ScaleManager.USER_SCALE=4;Phaser.ScaleManager.prototype={/**
	    * Start the ScaleManager.
	    * 
	    * @method Phaser.ScaleManager#boot
	    * @protected
	    */boot:function boot(){// Configure device-dependent compatibility
	var compat=this.compatibility;compat.supportsFullScreen=this.game.device.fullscreen&&!this.game.device.cocoonJS;//  We can't do anything about the status bars in iPads, web apps or desktops
	if(!this.game.device.iPad&&!this.game.device.webApp&&!this.game.device.desktop){if(this.game.device.android&&!this.game.device.chrome){compat.scrollTo=new Phaser.Point(0,1);}else{compat.scrollTo=new Phaser.Point(0,0);}}if(this.game.device.desktop){compat.orientationFallback='screen';compat.clickTrampoline='when-not-mouse';}else{compat.orientationFallback='';compat.clickTrampoline='';}// Configure event listeners
	var _this=this;this._orientationChange=function(event){return _this.orientationChange(event);};this._windowResize=function(event){return _this.windowResize(event);};// This does not appear to be on the standards track
	window.addEventListener('orientationchange',this._orientationChange,false);window.addEventListener('resize',this._windowResize,false);if(this.compatibility.supportsFullScreen){this._fullScreenChange=function(event){return _this.fullScreenChange(event);};this._fullScreenError=function(event){return _this.fullScreenError(event);};document.addEventListener('webkitfullscreenchange',this._fullScreenChange,false);document.addEventListener('mozfullscreenchange',this._fullScreenChange,false);document.addEventListener('MSFullscreenChange',this._fullScreenChange,false);document.addEventListener('fullscreenchange',this._fullScreenChange,false);document.addEventListener('webkitfullscreenerror',this._fullScreenError,false);document.addEventListener('mozfullscreenerror',this._fullScreenError,false);document.addEventListener('MSFullscreenError',this._fullScreenError,false);document.addEventListener('fullscreenerror',this._fullScreenError,false);}this.game.onResume.add(this._gameResumed,this);// Initialize core bounds
	this.dom.getOffset(this.game.canvas,this.offset);this.bounds.setTo(this.offset.x,this.offset.y,this.width,this.height);this.setGameSize(this.game.width,this.game.height);// Don't use updateOrientationState so events are not fired
	this.screenOrientation=this.dom.getScreenOrientation(this.compatibility.orientationFallback);if(Phaser.FlexGrid){this.grid=new Phaser.FlexGrid(this,this.width,this.height);}this._booted=true;if(this._pendingScaleMode!==null){this.scaleMode=this._pendingScaleMode;this._pendingScaleMode=null;}},/**
	    * Load configuration settings.
	    * 
	    * @method Phaser.ScaleManager#parseConfig
	    * @protected
	    * @param {object} config - The game configuration object.
	    */parseConfig:function parseConfig(config){if(config['scaleMode']!==undefined){if(this._booted){this.scaleMode=config['scaleMode'];}else{this._pendingScaleMode=config['scaleMode'];}}if(config['fullScreenScaleMode']!==undefined){this.fullScreenScaleMode=config['fullScreenScaleMode'];}if(config['fullScreenTarget']){this.fullScreenTarget=config['fullScreenTarget'];}},/**
	    * Calculates and sets the game dimensions based on the given width and height.
	    *
	    * This should _not_ be called when in fullscreen mode.
	    * 
	    * @method Phaser.ScaleManager#setupScale
	    * @protected
	    * @param {number|string} width - The width of the game.
	    * @param {number|string} height - The height of the game.
	    */setupScale:function setupScale(width,height){var target;var rect=new Phaser.Rectangle();if(this.game.parent!==''){if(typeof this.game.parent==='string'){// hopefully an element ID
	target=document.getElementById(this.game.parent);}else if(this.game.parent&&this.game.parent.nodeType===1){// quick test for a HTMLelement
	target=this.game.parent;}}// Fallback, covers an invalid ID and a non HTMLelement object
	if(!target){//  Use the full window
	this.parentNode=null;this.parentIsWindow=true;rect.width=this.dom.visualBounds.width;rect.height=this.dom.visualBounds.height;this.offset.set(0,0);}else{this.parentNode=target;this.parentIsWindow=false;this.getParentBounds(this._parentBounds);rect.width=this._parentBounds.width;rect.height=this._parentBounds.height;this.offset.set(this._parentBounds.x,this._parentBounds.y);}var newWidth=0;var newHeight=0;if(typeof width==='number'){newWidth=width;}else{//  Percentage based
	this.parentScaleFactor.x=parseInt(width,10)/100;newWidth=rect.width*this.parentScaleFactor.x;}if(typeof height==='number'){newHeight=height;}else{//  Percentage based
	this.parentScaleFactor.y=parseInt(height,10)/100;newHeight=rect.height*this.parentScaleFactor.y;}newWidth=Math.floor(newWidth);newHeight=Math.floor(newHeight);this._gameSize.setTo(0,0,newWidth,newHeight);this.updateDimensions(newWidth,newHeight,false);},/**
	    * Invoked when the game is resumed.
	    * 
	    * @method Phaser.ScaleManager#_gameResumed
	    * @private
	    */_gameResumed:function _gameResumed(){this.queueUpdate(true);},/**
	    * Set the actual Game size.
	    * Use this instead of directly changing `game.width` or `game.height`.
	    *
	    * The actual physical display (Canvas element size) depends on various settings including
	    * - Scale mode
	    * - Scaling factor
	    * - Size of Canvas's parent element or CSS rules such as min-height/max-height;
	    * - The size of the Window
	    *
	    * @method Phaser.ScaleManager#setGameSize
	    * @public
	    * @param {integer} width - _Game width_, in pixels.
	    * @param {integer} height - _Game height_, in pixels.
	    */setGameSize:function setGameSize(width,height){this._gameSize.setTo(0,0,width,height);if(this.currentScaleMode!==Phaser.ScaleManager.RESIZE){this.updateDimensions(width,height,true);}this.queueUpdate(true);},/**
	    * Set a User scaling factor used in the USER_SCALE scaling mode.
	    *
	    * The target canvas size is computed by:
	    *
	    *     canvas.width = (game.width * hScale) - hTrim
	    *     canvas.height = (game.height * vScale) - vTrim
	    *
	    * This method can be used in the {@link Phaser.ScaleManager#setResizeCallback resize callback}.
	    *
	    * @method Phaser.ScaleManager#setUserScale
	    * @param {number} hScale - Horizontal scaling factor.
	    * @param {numer} vScale - Vertical scaling factor.
	    * @param {integer} [hTrim=0] - Horizontal trim, applied after scaling.
	    * @param {integer} [vTrim=0] - Vertical trim, applied after scaling.
	    */setUserScale:function setUserScale(hScale,vScale,hTrim,vTrim){this._userScaleFactor.setTo(hScale,vScale);this._userScaleTrim.setTo(hTrim|0,vTrim|0);this.queueUpdate(true);},/**
	    * Sets the callback that will be invoked before sizing calculations.
	    *
	    * This is the appropriate place to call {@link #setUserScale} if needing custom dynamic scaling.
	    *
	    * The callback is supplied with two arguments `scale` and `parentBounds` where `scale` is the ScaleManager
	    * and `parentBounds`, a Phaser.Rectangle, is the size of the Parent element.
	    *
	    * This callback
	    * - May be invoked even though the parent container or canvas sizes have not changed
	    * - Unlike {@link #onSizeChange}, it runs _before_ the canvas is guaranteed to be updated
	    * - Will be invoked from `preUpdate`, _even when_ the game is paused    
	    *
	    * See {@link #onSizeChange} for a better way of reacting to layout updates.
	    * 
	    * @method Phaser.ScaleManager#setResizeCallback
	    * @public
	    * @param {function} callback - The callback that will be called each time a window.resize event happens or if set, the parent container resizes.
	    * @param {object} context - The context in which the callback will be called.
	    */setResizeCallback:function setResizeCallback(callback,context){this.onResize=callback;this.onResizeContext=context;},/**
	    * Signals a resize - IF the canvas or Game size differs from the last signal.
	    *
	    * This also triggers updates on {@link #grid} (FlexGrid) and, if in a RESIZE mode, `game.state` (StateManager).
	    *
	    * @method Phaser.ScaleManager#signalSizeChange
	    * @private
	    */signalSizeChange:function signalSizeChange(){if(!Phaser.Rectangle.sameDimensions(this,this._lastReportedCanvasSize)||!Phaser.Rectangle.sameDimensions(this.game,this._lastReportedGameSize)){var width=this.width;var height=this.height;this._lastReportedCanvasSize.setTo(0,0,width,height);this._lastReportedGameSize.setTo(0,0,this.game.width,this.game.height);if(this.grid){this.grid.onResize(width,height);}this.onSizeChange.dispatch(this,width,height);// Per StateManager#onResizeCallback, it only occurs when in RESIZE mode.
	if(this.currentScaleMode===Phaser.ScaleManager.RESIZE){this.game.state.resize(width,height);this.game.load.resize(width,height);}}},/**
	    * Set the min and max dimensions for the Display canvas.
	    * 
	    * _Note:_ The min/max dimensions are only applied in some cases
	    * - When the device is not in an incorrect orientation; or
	    * - The scale mode is EXACT_FIT when not in fullscreen
	    *
	    * @method Phaser.ScaleManager#setMinMax
	    * @public
	    * @param {number} minWidth - The minimum width the game is allowed to scale down to.
	    * @param {number} minHeight - The minimum height the game is allowed to scale down to.
	    * @param {number} [maxWidth] - The maximum width the game is allowed to scale up to; only changed if specified.
	    * @param {number} [maxHeight] - The maximum height the game is allowed to scale up to; only changed if specified.
	    * @todo These values are only sometimes honored.
	    */setMinMax:function setMinMax(minWidth,minHeight,maxWidth,maxHeight){this.minWidth=minWidth;this.minHeight=minHeight;if(typeof maxWidth!=='undefined'){this.maxWidth=maxWidth;}if(typeof maxHeight!=='undefined'){this.maxHeight=maxHeight;}},/**
	    * The ScaleManager.preUpdate is called automatically by the core Game loop.
	    * 
	    * @method Phaser.ScaleManager#preUpdate
	    * @protected
	    */preUpdate:function preUpdate(){if(this.game.time.time<this._lastUpdate+this._updateThrottle){return;}var prevThrottle=this._updateThrottle;this._updateThrottleReset=prevThrottle>=400?0:100;this.dom.getOffset(this.game.canvas,this.offset);var prevWidth=this._parentBounds.width;var prevHeight=this._parentBounds.height;var bounds=this.getParentBounds(this._parentBounds);var boundsChanged=bounds.width!==prevWidth||bounds.height!==prevHeight;// Always invalidate on a newly detected orientation change
	var orientationChanged=this.updateOrientationState();if(boundsChanged||orientationChanged){if(this.onResize){this.onResize.call(this.onResizeContext,this,bounds);}this.updateLayout();this.signalSizeChange();}// Next throttle, eg. 25, 50, 100, 200..
	var throttle=this._updateThrottle*2;// Don't let an update be too eager about resetting the throttle.
	if(this._updateThrottle<prevThrottle){throttle=Math.min(prevThrottle,this._updateThrottleReset);}this._updateThrottle=Phaser.Math.clamp(throttle,25,this.trackParentInterval);this._lastUpdate=this.game.time.time;},/**
	    * Update method while paused.
	    *
	    * @method Phaser.ScaleManager#pauseUpdate
	    * @private
	    */pauseUpdate:function pauseUpdate(){this.preUpdate();// Updates at slowest.
	this._updateThrottle=this.trackParentInterval;},/**
	    * Update the dimensions taking the parent scaling factor into account.
	    *
	    * @method Phaser.ScaleManager#updateDimensions
	    * @private
	    * @param {number} width - The new width of the parent container.
	    * @param {number} height - The new height of the parent container.
	    * @param {boolean} resize - True if the renderer should be resized, otherwise false to just update the internal vars.
	    */updateDimensions:function updateDimensions(width,height,resize){this.width=width*this.parentScaleFactor.x;this.height=height*this.parentScaleFactor.y;this.game.width=this.width;this.game.height=this.height;this.sourceAspectRatio=this.width/this.height;this.updateScalingAndBounds();if(resize){//  Resize the renderer (which in turn resizes the Display canvas!)
	this.game.renderer.resize(this.width,this.height);//  The Camera can never be smaller than the Game size
	this.game.camera.setSize(this.width,this.height);//  This should only happen if the world is smaller than the new canvas size
	this.game.world.resize(this.width,this.height);}},/**
	    * Update relevant scaling values based on the ScaleManager dimension and game dimensions,
	    * which should already be set. This does not change {@link #sourceAspectRatio}.
	    * 
	    * @method Phaser.ScaleManager#updateScalingAndBounds
	    * @private
	    */updateScalingAndBounds:function updateScalingAndBounds(){this.scaleFactor.x=this.game.width/this.width;this.scaleFactor.y=this.game.height/this.height;this.scaleFactorInversed.x=this.width/this.game.width;this.scaleFactorInversed.y=this.height/this.game.height;this.aspectRatio=this.width/this.height;// This can be invoked in boot pre-canvas
	if(this.game.canvas){this.dom.getOffset(this.game.canvas,this.offset);}this.bounds.setTo(this.offset.x,this.offset.y,this.width,this.height);// Can be invoked in boot pre-input
	if(this.game.input&&this.game.input.scale){this.game.input.scale.setTo(this.scaleFactor.x,this.scaleFactor.y);}},/**
	    * Force the game to run in only one orientation.
	    *
	    * This enables generation of incorrect orientation signals and affects resizing but does not otherwise rotate or lock the orientation.
	    *
	    * Orientation checks are performed via the Screen Orientation API, if available in browser. This means it will check your monitor
	    * orientation on desktop, or your device orientation on mobile, rather than comparing actual game dimensions. If you need to check the 
	    * viewport dimensions instead and bypass the Screen Orientation API then set: `ScaleManager.compatibility.orientationFallback = 'viewport'`
	    * 
	    * @method Phaser.ScaleManager#forceOrientation
	    * @public
	    * @param {boolean} forceLandscape - true if the game should run in landscape mode only.
	    * @param {boolean} [forcePortrait=false] - true if the game should run in portrait mode only.
	    */forceOrientation:function forceOrientation(forceLandscape,forcePortrait){if(forcePortrait===undefined){forcePortrait=false;}this.forceLandscape=forceLandscape;this.forcePortrait=forcePortrait;this.queueUpdate(true);},/**
	    * Classify the orientation, per `getScreenOrientation`.
	    * 
	    * @method Phaser.ScaleManager#classifyOrientation
	    * @private
	    * @param {string} orientation - The orientation string, e.g. 'portrait-primary'.
	    * @return {?string} The classified orientation: 'portrait', 'landscape`, or null.
	    */classifyOrientation:function classifyOrientation(orientation){if(orientation==='portrait-primary'||orientation==='portrait-secondary'){return'portrait';}else if(orientation==='landscape-primary'||orientation==='landscape-secondary'){return'landscape';}else{return null;}},/**
	    * Updates the current orientation and dispatches orientation change events.
	    * 
	    * @method Phaser.ScaleManager#updateOrientationState
	    * @private
	    * @return {boolean} True if the orientation state changed which means a forced update is likely required.
	    */updateOrientationState:function updateOrientationState(){var previousOrientation=this.screenOrientation;var previouslyIncorrect=this.incorrectOrientation;this.screenOrientation=this.dom.getScreenOrientation(this.compatibility.orientationFallback);this.incorrectOrientation=this.forceLandscape&&!this.isLandscape||this.forcePortrait&&!this.isPortrait;var changed=previousOrientation!==this.screenOrientation;var correctnessChanged=previouslyIncorrect!==this.incorrectOrientation;if(correctnessChanged){if(this.incorrectOrientation){this.enterIncorrectOrientation.dispatch();}else{this.leaveIncorrectOrientation.dispatch();}}if(changed||correctnessChanged){this.onOrientationChange.dispatch(this,previousOrientation,previouslyIncorrect);}return changed||correctnessChanged;},/**
	    * window.orientationchange event handler.
	    * 
	    * @method Phaser.ScaleManager#orientationChange
	    * @private
	    * @param {Event} event - The orientationchange event data.
	    */orientationChange:function orientationChange(event){this.event=event;this.queueUpdate(true);},/**
	    * window.resize event handler.
	    * 
	    * @method Phaser.ScaleManager#windowResize
	    * @private
	    * @param {Event} event - The resize event data.
	    */windowResize:function windowResize(event){this.event=event;this.queueUpdate(true);},/**
	    * Scroll to the top - in some environments. See `compatibility.scrollTo`.
	    * 
	    * @method Phaser.ScaleManager#scrollTop
	    * @private
	    */scrollTop:function scrollTop(){var scrollTo=this.compatibility.scrollTo;if(scrollTo){window.scrollTo(scrollTo.x,scrollTo.y);}},/**
	    * The "refresh" methods informs the ScaleManager that a layout refresh is required.
	    *
	    * The ScaleManager automatically queues a layout refresh (eg. updates the Game size or Display canvas layout)
	    * when the browser is resized, the orientation changes, or when there is a detected change
	    * of the Parent size. Refreshing is also done automatically when public properties,
	    * such as {@link #scaleMode}, are updated or state-changing methods are invoked.
	    *
	    * The "refresh" method _may_ need to be used in a few (rare) situtations when
	    *
	    * - a device change event is not correctly detected; or
	    * - the Parent size changes (and an immediate reflow is desired); or
	    * - the ScaleManager state is updated by non-standard means; or
	    * - certain {@link #compatibility} properties are manually changed.
	    *
	    * The queued layout refresh is not immediate but will run promptly in an upcoming `preRender`.
	    * 
	    * @method Phaser.ScaleManager#refresh
	    * @public
	    */refresh:function refresh(){this.scrollTop();this.queueUpdate(true);},/**
	    * Updates the game / canvas position and size.
	    *
	    * @method Phaser.ScaleManager#updateLayout
	    * @private
	    */updateLayout:function updateLayout(){var scaleMode=this.currentScaleMode;if(scaleMode===Phaser.ScaleManager.RESIZE){this.reflowGame();return;}this.scrollTop();if(this.compatibility.forceMinimumDocumentHeight){// (This came from older code, by why is it here?)
	// Set minimum height of content to new window height
	document.documentElement.style.minHeight=window.innerHeight+'px';}if(this.incorrectOrientation){this.setMaximum();}else{if(scaleMode===Phaser.ScaleManager.EXACT_FIT){this.setExactFit();}else if(scaleMode===Phaser.ScaleManager.SHOW_ALL){if(!this.isFullScreen&&this.boundingParent&&this.compatibility.canExpandParent){// Try to expand parent out, but choosing maximizing dimensions.                    
	// Then select minimize dimensions which should then honor parent
	// maximum bound applications.
	this.setShowAll(true);this.resetCanvas();this.setShowAll();}else{this.setShowAll();}}else if(scaleMode===Phaser.ScaleManager.NO_SCALE){this.width=this.game.width;this.height=this.game.height;}else if(scaleMode===Phaser.ScaleManager.USER_SCALE){this.width=this.game.width*this._userScaleFactor.x-this._userScaleTrim.x;this.height=this.game.height*this._userScaleFactor.y-this._userScaleTrim.y;}}if(!this.compatibility.canExpandParent&&(scaleMode===Phaser.ScaleManager.SHOW_ALL||scaleMode===Phaser.ScaleManager.USER_SCALE)){var bounds=this.getParentBounds(this._tempBounds);this.width=Math.min(this.width,bounds.width);this.height=Math.min(this.height,bounds.height);}// Always truncate / force to integer
	this.width=this.width|0;this.height=this.height|0;this.reflowCanvas();},/**
	    * Returns the computed Parent size/bounds that the Display canvas is allowed/expected to fill.
	    *
	    * If in fullscreen mode or without parent (see {@link #parentIsWindow}),
	    * this will be the bounds of the visual viewport itself.
	    *
	    * This function takes the {@link #windowConstraints} into consideration - if the parent is partially outside
	    * the viewport then this function may return a smaller than expected size.
	    *
	    * Values are rounded to the nearest pixel.
	    *
	    * @method Phaser.ScaleManager#getParentBounds
	    * @protected
	    * @param {Phaser.Rectangle} [target=(new Rectangle)] - The rectangle to update; a new one is created as needed.
	    * @return {Phaser.Rectangle} The established parent bounds.
	    */getParentBounds:function getParentBounds(target){var bounds=target||new Phaser.Rectangle();var parentNode=this.boundingParent;var visualBounds=this.dom.visualBounds;var layoutBounds=this.dom.layoutBounds;if(!parentNode){bounds.setTo(0,0,visualBounds.width,visualBounds.height);}else{// Ref. http://msdn.microsoft.com/en-us/library/hh781509(v=vs.85).aspx for getBoundingClientRect
	var clientRect=parentNode.getBoundingClientRect();var parentRect=parentNode.offsetParent?parentNode.offsetParent.getBoundingClientRect():parentNode.getBoundingClientRect();bounds.setTo(clientRect.left-parentRect.left,clientRect.top-parentRect.top,clientRect.width,clientRect.height);var wc=this.windowConstraints;if(wc.right){var windowBounds=wc.right==='layout'?layoutBounds:visualBounds;bounds.right=Math.min(bounds.right,windowBounds.width);}if(wc.bottom){var windowBounds=wc.bottom==='layout'?layoutBounds:visualBounds;bounds.bottom=Math.min(bounds.bottom,windowBounds.height);}}bounds.setTo(Math.round(bounds.x),Math.round(bounds.y),Math.round(bounds.width),Math.round(bounds.height));return bounds;},/**
	    * Update the canvas position/margins - for alignment within the parent container.
	    *
	    * The canvas margins _must_ be reset/cleared prior to invoking this.
	    *
	    * @method Phaser.ScaleManager#alignCanvas
	    * @private
	    * @param {boolean} horizontal - Align horizontally?
	    * @param {boolean} vertical - Align vertically?
	    */alignCanvas:function alignCanvas(horizontal,vertical){var parentBounds=this.getParentBounds(this._tempBounds);var canvas=this.game.canvas;var margin=this.margin;if(horizontal){margin.left=margin.right=0;var canvasBounds=canvas.getBoundingClientRect();if(this.width<parentBounds.width&&!this.incorrectOrientation){var currentEdge=canvasBounds.left-parentBounds.x;var targetEdge=parentBounds.width/2-this.width/2;targetEdge=Math.max(targetEdge,0);var offset=targetEdge-currentEdge;margin.left=Math.round(offset);}canvas.style.marginLeft=margin.left+'px';if(margin.left!==0){margin.right=-(parentBounds.width-canvasBounds.width-margin.left);canvas.style.marginRight=margin.right+'px';}}if(vertical){margin.top=margin.bottom=0;var canvasBounds=canvas.getBoundingClientRect();if(this.height<parentBounds.height&&!this.incorrectOrientation){var currentEdge=canvasBounds.top-parentBounds.y;var targetEdge=parentBounds.height/2-this.height/2;targetEdge=Math.max(targetEdge,0);var offset=targetEdge-currentEdge;margin.top=Math.round(offset);}canvas.style.marginTop=margin.top+'px';if(margin.top!==0){margin.bottom=-(parentBounds.height-canvasBounds.height-margin.top);canvas.style.marginBottom=margin.bottom+'px';}}// Silly backwards compatibility..
	margin.x=margin.left;margin.y=margin.top;},/**
	    * Updates the Game state / size.
	    *
	    * The canvas margins may always be adjusted, even if alignment is not in effect.
	    * 
	    * @method Phaser.ScaleManager#reflowGame
	    * @private
	    */reflowGame:function reflowGame(){this.resetCanvas('','');var bounds=this.getParentBounds(this._tempBounds);this.updateDimensions(bounds.width,bounds.height,true);},/**
	    * Updates the Display canvas size.
	    *
	    * The canvas margins may always be adjusted, even alignment is not in effect.
	    * 
	    * @method Phaser.ScaleManager#reflowCanvas
	    * @private
	    */reflowCanvas:function reflowCanvas(){if(!this.incorrectOrientation){this.width=Phaser.Math.clamp(this.width,this.minWidth||0,this.maxWidth||this.width);this.height=Phaser.Math.clamp(this.height,this.minHeight||0,this.maxHeight||this.height);}this.resetCanvas();if(!this.compatibility.noMargins){if(this.isFullScreen&&this._createdFullScreenTarget){this.alignCanvas(true,true);}else{this.alignCanvas(this.pageAlignHorizontally,this.pageAlignVertically);}}this.updateScalingAndBounds();},/**
	    * "Reset" the Display canvas and set the specified width/height.
	    *
	    * @method Phaser.ScaleManager#resetCanvas
	    * @private
	    * @param {string} [cssWidth=(current width)] - The css width to set.
	    * @param {string} [cssHeight=(current height)] - The css height to set.
	    */resetCanvas:function resetCanvas(cssWidth,cssHeight){if(cssWidth===undefined){cssWidth=this.width+'px';}if(cssHeight===undefined){cssHeight=this.height+'px';}var canvas=this.game.canvas;if(!this.compatibility.noMargins){canvas.style.marginLeft='';canvas.style.marginTop='';canvas.style.marginRight='';canvas.style.marginBottom='';}canvas.style.width=cssWidth;canvas.style.height=cssHeight;},/**
	    * Queues/marks a size/bounds check as needing to occur (from `preUpdate`).
	    *
	    * @method Phaser.ScaleManager#queueUpdate
	    * @private
	    * @param {boolean} force - If true resets the parent bounds to ensure the check is dirty.
	    */queueUpdate:function queueUpdate(force){if(force){this._parentBounds.width=0;this._parentBounds.height=0;}this._updateThrottle=this._updateThrottleReset;},/**
	    * Reset internal data/state.
	    *
	    * @method Phaser.ScaleManager#reset
	    * @private
	    */reset:function reset(clearWorld){if(clearWorld&&this.grid){this.grid.reset();}},/**
	    * Updates the width/height to that of the window.
	    * 
	    * @method Phaser.ScaleManager#setMaximum
	    * @private
	    */setMaximum:function setMaximum(){this.width=this.dom.visualBounds.width;this.height=this.dom.visualBounds.height;},/**
	    * Updates the width/height such that the game is scaled proportionally.
	    * 
	    * @method Phaser.ScaleManager#setShowAll
	    * @private
	    * @param {boolean} expanding - If true then the maximizing dimension is chosen.
	    */setShowAll:function setShowAll(expanding){var bounds=this.getParentBounds(this._tempBounds);var width=bounds.width;var height=bounds.height;var multiplier;if(expanding){multiplier=Math.max(height/this.game.height,width/this.game.width);}else{multiplier=Math.min(height/this.game.height,width/this.game.width);}this.width=Math.round(this.game.width*multiplier);this.height=Math.round(this.game.height*multiplier);},/**
	    * Updates the width/height such that the game is stretched to the available size.
	    * Honors {@link #maxWidth} and {@link #maxHeight} when _not_ in fullscreen.
	    *
	    * @method Phaser.ScaleManager#setExactFit
	    * @private
	    */setExactFit:function setExactFit(){var bounds=this.getParentBounds(this._tempBounds);this.width=bounds.width;this.height=bounds.height;if(this.isFullScreen){// Max/min not honored fullscreen
	return;}if(this.maxWidth){this.width=Math.min(this.width,this.maxWidth);}if(this.maxHeight){this.height=Math.min(this.height,this.maxHeight);}},/**
	    * Creates a fullscreen target. This is called automatically as as needed when entering
	    * fullscreen mode and the resulting element is supplied to {@link #onFullScreenInit}.
	    *
	    * Use {@link #onFullScreenInit} to customize the created object.
	    *
	    * @method Phaser.ScaleManager#createFullScreenTarget
	    * @protected
	    */createFullScreenTarget:function createFullScreenTarget(){var fsTarget=document.createElement('div');fsTarget.style.margin='0';fsTarget.style.padding='0';fsTarget.style.background='#000';return fsTarget;},/**
	    * Start the browsers fullscreen mode - this _must_ be called from a user input Pointer or Mouse event.
	    *
	    * The Fullscreen API must be supported by the browser for this to work - it is not the same as setting
	    * the game size to fill the browser window. See {@link Phaser.ScaleManager#compatibility compatibility.supportsFullScreen} to check if the current
	    * device is reported to support fullscreen mode.
	    *
	    * The {@link #fullScreenFailed} signal will be dispatched if the fullscreen change request failed or the game does not support the Fullscreen API.
	    *
	    * @method Phaser.ScaleManager#startFullScreen
	    * @public
	    * @param {boolean} [antialias] - Changes the anti-alias feature of the canvas before jumping in to fullscreen (false = retain pixel art, true = smooth art). If not specified then no change is made. Only works in CANVAS mode.
	    * @param {boolean} [allowTrampoline=undefined] - Internal argument. If `false` click trampolining is suppressed.
	    * @return {boolean} Returns true if the device supports fullscreen mode and fullscreen mode was attempted to be started. (It might not actually start, wait for the signals.)
	    */startFullScreen:function startFullScreen(antialias,allowTrampoline){if(this.isFullScreen){return false;}if(!this.compatibility.supportsFullScreen){// Error is called in timeout to emulate the real fullscreenerror event better
	var _this=this;setTimeout(function(){_this.fullScreenError();},10);return;}if(this.compatibility.clickTrampoline==='when-not-mouse'){var input=this.game.input;if(input.activePointer&&input.activePointer!==input.mousePointer&&(allowTrampoline||allowTrampoline!==false)){input.activePointer.addClickTrampoline("startFullScreen",this.startFullScreen,this,[antialias,false]);return;}}if(antialias!==undefined&&this.game.renderType===Phaser.CANVAS){this.game.stage.smoothed=antialias;}var fsTarget=this.fullScreenTarget;if(!fsTarget){this.cleanupCreatedTarget();this._createdFullScreenTarget=this.createFullScreenTarget();fsTarget=this._createdFullScreenTarget;}var initData={targetElement:fsTarget};this.hasPhaserSetFullScreen=true;this.onFullScreenInit.dispatch(this,initData);if(this._createdFullScreenTarget){// Move the Display canvas inside of the target and add the target to the DOM
	// (The target has to be added for the Fullscreen API to work.)
	var canvas=this.game.canvas;var parent=canvas.parentNode;parent.insertBefore(fsTarget,canvas);fsTarget.appendChild(canvas);}if(this.game.device.fullscreenKeyboard){fsTarget[this.game.device.requestFullscreen](Element.ALLOW_KEYBOARD_INPUT);}else{fsTarget[this.game.device.requestFullscreen]();}return true;},/**
	    * Stops / exits fullscreen mode, if active.
	    *
	    * @method Phaser.ScaleManager#stopFullScreen
	    * @public
	    * @return {boolean} Returns true if the browser supports fullscreen mode and fullscreen mode will be exited.
	    */stopFullScreen:function stopFullScreen(){if(!this.isFullScreen||!this.compatibility.supportsFullScreen){return false;}this.hasPhaserSetFullScreen=false;document[this.game.device.cancelFullscreen]();return true;},/**
	    * Cleans up the previous fullscreen target, if such was automatically created.
	    * This ensures the canvas is restored to its former parent, assuming the target didn't move.
	    *
	    * @method Phaser.ScaleManager#cleanupCreatedTarget
	    * @private
	    */cleanupCreatedTarget:function cleanupCreatedTarget(){var fsTarget=this._createdFullScreenTarget;if(fsTarget&&fsTarget.parentNode){// Make sure to cleanup synthetic target for sure;
	// swap the canvas back to the parent.
	var parent=fsTarget.parentNode;parent.insertBefore(this.game.canvas,fsTarget);parent.removeChild(fsTarget);}this._createdFullScreenTarget=null;},/**
	    * Used to prepare/restore extra fullscreen mode settings.
	    * (This does move any elements within the DOM tree.)
	    *
	    * @method Phaser.ScaleManager#prepScreenMode
	    * @private
	    * @param {boolean} enteringFullscreen - True if _entering_ fullscreen, false if _leaving_.
	    */prepScreenMode:function prepScreenMode(enteringFullscreen){var createdTarget=!!this._createdFullScreenTarget;var fsTarget=this._createdFullScreenTarget||this.fullScreenTarget;if(enteringFullscreen){if(createdTarget||this.fullScreenScaleMode===Phaser.ScaleManager.EXACT_FIT){// Resize target, as long as it's not the canvas
	if(fsTarget!==this.game.canvas){this._fullScreenRestore={targetWidth:fsTarget.style.width,targetHeight:fsTarget.style.height};fsTarget.style.width='100%';fsTarget.style.height='100%';}}}else{// Have restore information
	if(this._fullScreenRestore){fsTarget.style.width=this._fullScreenRestore.targetWidth;fsTarget.style.height=this._fullScreenRestore.targetHeight;this._fullScreenRestore=null;}// Always reset to game size
	this.updateDimensions(this._gameSize.width,this._gameSize.height,true);this.resetCanvas();}},/**
	    * Called automatically when the browser enters of leaves fullscreen mode.
	    *
	    * @method Phaser.ScaleManager#fullScreenChange
	    * @private
	    * @param {Event} [event=undefined] - The fullscreenchange event
	    */fullScreenChange:function fullScreenChange(event){this.event=event;if(this.isFullScreen){this.prepScreenMode(true);this.updateLayout();this.queueUpdate(true);}else{this.prepScreenMode(false);this.cleanupCreatedTarget();this.updateLayout();this.queueUpdate(true);}this.onFullScreenChange.dispatch(this,this.width,this.height);},/**
	    * Called automatically when the browser fullscreen request fails;
	    * or called when a fullscreen request is made on a device for which it is not supported.
	    *
	    * @method Phaser.ScaleManager#fullScreenError
	    * @private
	    * @param {Event} [event=undefined] - The fullscreenerror event; undefined if invoked on a device that does not support the Fullscreen API.
	    */fullScreenError:function fullScreenError(event){this.event=event;this.cleanupCreatedTarget();console.warn('Phaser.ScaleManager: requestFullscreen failed or device does not support the Fullscreen API');this.onFullScreenError.dispatch(this);},/**
	    * Takes a Sprite or Image object and scales it to fit the given dimensions.
	    * Scaling happens proportionally without distortion to the sprites texture.
	    * The letterBox parameter controls if scaling will produce a letter-box effect or zoom the
	    * sprite until it fills the given values. Note that with letterBox set to false the scaled sprite may spill out over either
	    * the horizontal or vertical sides of the target dimensions. If you wish to stop this you can crop the Sprite.
	    *
	    * @method Phaser.ScaleManager#scaleSprite
	    * @protected
	    * @param {Phaser.Sprite|Phaser.Image} sprite - The sprite we want to scale.
	    * @param {integer} [width] - The target width that we want to fit the sprite in to. If not given it defaults to ScaleManager.width.
	    * @param {integer} [height] - The target height that we want to fit the sprite in to. If not given it defaults to ScaleManager.height.
	    * @param {boolean} [letterBox=false] - True if we want the `fitted` mode. Otherwise, the function uses the `zoom` mode.
	    * @return {Phaser.Sprite|Phaser.Image} The scaled sprite.
	    */scaleSprite:function scaleSprite(sprite,width,height,letterBox){if(width===undefined){width=this.width;}if(height===undefined){height=this.height;}if(letterBox===undefined){letterBox=false;}if(!sprite||!sprite['scale']){return sprite;}sprite.scale.x=1;sprite.scale.y=1;if(sprite.width<=0||sprite.height<=0||width<=0||height<=0){return sprite;}var scaleX1=width;var scaleY1=sprite.height*width/sprite.width;var scaleX2=sprite.width*height/sprite.height;var scaleY2=height;var scaleOnWidth=scaleX2>width;if(scaleOnWidth){scaleOnWidth=letterBox;}else{scaleOnWidth=!letterBox;}if(scaleOnWidth){sprite.width=Math.floor(scaleX1);sprite.height=Math.floor(scaleY1);}else{sprite.width=Math.floor(scaleX2);sprite.height=Math.floor(scaleY2);}//  Enable at some point?
	// sprite.x = Math.floor((width - sprite.width) / 2);
	// sprite.y = Math.floor((height - sprite.height) / 2);
	return sprite;},/**
	    * Destroys the ScaleManager and removes any event listeners.
	    * This should probably only be called when the game is destroyed.
	    *
	    * @method Phaser.ScaleManager#destroy
	    * @protected
	    */destroy:function destroy(){this.game.onResume.remove(this._gameResumed,this);window.removeEventListener('orientationchange',this._orientationChange,false);window.removeEventListener('resize',this._windowResize,false);if(this.compatibility.supportsFullScreen){document.removeEventListener('webkitfullscreenchange',this._fullScreenChange,false);document.removeEventListener('mozfullscreenchange',this._fullScreenChange,false);document.removeEventListener('MSFullscreenChange',this._fullScreenChange,false);document.removeEventListener('fullscreenchange',this._fullScreenChange,false);document.removeEventListener('webkitfullscreenerror',this._fullScreenError,false);document.removeEventListener('mozfullscreenerror',this._fullScreenError,false);document.removeEventListener('MSFullscreenError',this._fullScreenError,false);document.removeEventListener('fullscreenerror',this._fullScreenError,false);}}};Phaser.ScaleManager.prototype.constructor=Phaser.ScaleManager;/**
	* The DOM element that is considered the Parent bounding element, if any.
	*
	* This `null` if {@link #parentIsWindow} is true or if fullscreen mode is entered and {@link #fullScreenTarget} is specified.
	* It will also be null if there is no game canvas or if the game canvas has no parent.
	*
	* @name Phaser.ScaleManager#boundingParent
	* @property {?DOMElement} boundingParent
	* @readonly
	*/Object.defineProperty(Phaser.ScaleManager.prototype,"boundingParent",{get:function get(){if(this.parentIsWindow||this.isFullScreen&&this.hasPhaserSetFullScreen&&!this._createdFullScreenTarget){return null;}var parentNode=this.game.canvas&&this.game.canvas.parentNode;return parentNode||null;}});/**
	* The scaling method used by the ScaleManager when not in fullscreen.
	* 
	* <dl>
	*   <dt>{@link Phaser.ScaleManager.NO_SCALE}</dt>
	*   <dd>
	*       The Game display area will not be scaled - even if it is too large for the canvas/screen.
	*       This mode _ignores_ any applied scaling factor and displays the canvas at the Game size.
	*   </dd>
	*   <dt>{@link Phaser.ScaleManager.EXACT_FIT}</dt>
	*   <dd>
	*       The Game display area will be _stretched_ to fill the entire size of the canvas's parent element and/or screen.
	*       Proportions are not maintained.
	*   </dd>
	*   <dt>{@link Phaser.ScaleManager.SHOW_ALL}</dt>
	*   <dd>
	*       Show the entire game display area while _maintaining_ the original aspect ratio.
	*   </dd>
	*   <dt>{@link Phaser.ScaleManager.RESIZE}</dt>
	*   <dd>
	*       The dimensions of the game display area are changed to match the size of the parent container.
	*       That is, this mode _changes the Game size_ to match the display size.
	*       <p>
	*       Any manually set Game size (see {@link #setGameSize}) is ignored while in effect.
	*   </dd>
	*   <dt>{@link Phaser.ScaleManager.USER_SCALE}</dt>
	*   <dd>
	*       The game Display is scaled according to the user-specified scale set by {@link Phaser.ScaleManager#setUserScale setUserScale}.
	*       <p>
	*       This scale can be adjusted in the {@link Phaser.ScaleManager#setResizeCallback resize callback}
	*       for flexible custom-sizing needs.
	*   </dd>
	* </dl>
	*
	* @name Phaser.ScaleManager#scaleMode
	* @property {integer} scaleMode
	*/Object.defineProperty(Phaser.ScaleManager.prototype,"scaleMode",{get:function get(){return this._scaleMode;},set:function set(value){if(value!==this._scaleMode){if(!this.isFullScreen){this.updateDimensions(this._gameSize.width,this._gameSize.height,true);this.queueUpdate(true);}this._scaleMode=value;}return this._scaleMode;}});/**
	* The scaling method used by the ScaleManager when in fullscreen.
	*
	* See {@link Phaser.ScaleManager#scaleMode scaleMode} for the different modes allowed.
	*
	* @name Phaser.ScaleManager#fullScreenScaleMode
	* @property {integer} fullScreenScaleMode
	*/Object.defineProperty(Phaser.ScaleManager.prototype,"fullScreenScaleMode",{get:function get(){return this._fullScreenScaleMode;},set:function set(value){if(value!==this._fullScreenScaleMode){// If in fullscreen then need a wee bit more work
	if(this.isFullScreen){this.prepScreenMode(false);this._fullScreenScaleMode=value;this.prepScreenMode(true);this.queueUpdate(true);}else{this._fullScreenScaleMode=value;}}return this._fullScreenScaleMode;}});/**
	* Returns the current scale mode - for normal or fullscreen operation.
	*
	* See {@link Phaser.ScaleManager#scaleMode scaleMode} for the different modes allowed.
	*
	* @name Phaser.ScaleManager#currentScaleMode
	* @property {number} currentScaleMode
	* @protected
	* @readonly
	*/Object.defineProperty(Phaser.ScaleManager.prototype,"currentScaleMode",{get:function get(){return this.isFullScreen?this._fullScreenScaleMode:this._scaleMode;}});/**
	* When enabled the Display canvas will be horizontally-aligned _in the Parent container_ (or {@link Phaser.ScaleManager#parentIsWindow window}).
	*
	* To align horizontally across the page the Display canvas should be added directly to page;
	* or the parent container should itself be horizontally aligned.
	*
	* Horizontal alignment is not applicable with the {@link .RESIZE} scaling mode.
	*
	* @name Phaser.ScaleManager#pageAlignHorizontally
	* @property {boolean} pageAlignHorizontally
	* @default false
	*/Object.defineProperty(Phaser.ScaleManager.prototype,"pageAlignHorizontally",{get:function get(){return this._pageAlignHorizontally;},set:function set(value){if(value!==this._pageAlignHorizontally){this._pageAlignHorizontally=value;this.queueUpdate(true);}}});/**
	* When enabled the Display canvas will be vertically-aligned _in the Parent container_ (or {@link Phaser.ScaleManager#parentIsWindow window}).
	*
	* To align vertically the Parent element should have a _non-collapsible_ height, such that it will maintain
	* a height _larger_ than the height of the contained Game canvas - the game canvas will then be scaled vertically
	* _within_ the remaining available height dictated by the Parent element.
	*
	* One way to prevent the parent from collapsing is to add an absolute "min-height" CSS property to the parent element.
	* If specifying a relative "min-height/height" or adjusting margins, the Parent height must still be non-collapsible (see note).
	*
	* _Note_: In version 2.2 the minimum document height is _not_ automatically set to the viewport/window height.
	* To automatically update the minimum document height set {@link Phaser.ScaleManager#compatibility compatibility.forceMinimumDocumentHeight} to true.
	*
	* Vertical alignment is not applicable with the {@link .RESIZE} scaling mode.
	*
	* @name Phaser.ScaleManager#pageAlignVertically
	* @property {boolean} pageAlignVertically
	* @default false
	*/Object.defineProperty(Phaser.ScaleManager.prototype,"pageAlignVertically",{get:function get(){return this._pageAlignVertically;},set:function set(value){if(value!==this._pageAlignVertically){this._pageAlignVertically=value;this.queueUpdate(true);}}});/**
	* Returns true if the browser is in fullscreen mode, otherwise false.
	* @name Phaser.ScaleManager#isFullScreen
	* @property {boolean} isFullScreen
	* @readonly
	*/Object.defineProperty(Phaser.ScaleManager.prototype,"isFullScreen",{get:function get(){return!!(document['fullscreenElement']||document['webkitFullscreenElement']||document['mozFullScreenElement']||document['msFullscreenElement']);}});/**
	* Returns true if the screen orientation is in portrait mode.
	*
	* @name Phaser.ScaleManager#isPortrait
	* @property {boolean} isPortrait
	* @readonly
	*/Object.defineProperty(Phaser.ScaleManager.prototype,"isPortrait",{get:function get(){return this.classifyOrientation(this.screenOrientation)==='portrait';}});/**
	* Returns true if the screen orientation is in landscape mode.
	*
	* @name Phaser.ScaleManager#isLandscape
	* @property {boolean} isLandscape
	* @readonly
	*/Object.defineProperty(Phaser.ScaleManager.prototype,"isLandscape",{get:function get(){return this.classifyOrientation(this.screenOrientation)==='landscape';}});/**
	* Returns true if the game dimensions are portrait (height > width).
	* This is especially useful to check when using the RESIZE scale mode 
	* but wanting to maintain game orientation on desktop browsers, 
	* where typically the screen orientation will always be landscape regardless of the browser viewport.
	*
	* @name Phaser.ScaleManager#isGamePortrait
	* @property {boolean} isGamePortrait
	* @readonly
	*/Object.defineProperty(Phaser.ScaleManager.prototype,"isGamePortrait",{get:function get(){return this.height>this.width;}});/**
	* Returns true if the game dimensions are landscape (width > height).
	* This is especially useful to check when using the RESIZE scale mode 
	* but wanting to maintain game orientation on desktop browsers, 
	* where typically the screen orientation will always be landscape regardless of the browser viewport.
	*
	* @name Phaser.ScaleManager#isGameLandscape
	* @property {boolean} isGameLandscape
	* @readonly
	*/Object.defineProperty(Phaser.ScaleManager.prototype,"isGameLandscape",{get:function get(){return this.width>this.height;}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A collection of methods for displaying debug information about game objects.
	*
	* If your game is running in Canvas mode, then you should invoke all of the Debug methods from
	* your games `render` function. This is because they are drawn directly onto the game canvas
	* itself, so if you call any debug methods outside of `render` they are likely to be overwritten
	* by the game itself.
	* 
	* If your game is running in WebGL then Debug will create a Sprite that is placed at the top of the Stage display list and bind a canvas texture
	* to it, which must be uploaded every frame. Be advised: this is very expensive, especially in browsers like Firefox. So please only enable Debug
	* in WebGL mode if you really need it (or your desktop can cope with it well) and disable it for production!
	*
	* @class Phaser.Utils.Debug
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	*/Phaser.Utils.Debug=function(game){/**
	    * @property {Phaser.Game} game - A reference to the currently running Game.
	    */this.game=game;/**
	    * @property {Phaser.Image} sprite - If debugging in WebGL mode we need this.
	    */this.sprite=null;/**
	    * @property {Phaser.BitmapData} bmd - In WebGL mode this BitmapData contains a copy of the debug canvas.
	    */this.bmd=null;/**
	    * @property {HTMLCanvasElement} canvas - The canvas to which Debug calls draws.
	    */this.canvas=null;/**
	    * @property {CanvasRenderingContext2D} context - The 2d context of the canvas.
	    */this.context=null;/**
	    * @property {string} font - The font that the debug information is rendered in.
	    * @default '14px Courier'
	    */this.font='14px Courier';/**
	    * @property {number} columnWidth - The spacing between columns.
	    */this.columnWidth=100;/**
	    * @property {number} lineHeight - The line height between the debug text.
	    */this.lineHeight=16;/**
	    * @property {boolean} renderShadow - Should the text be rendered with a slight shadow? Makes it easier to read on different types of background.
	    */this.renderShadow=true;/**
	    * @property {number} currentX - The current X position the debug information will be rendered at.
	    * @default
	    */this.currentX=0;/**
	    * @property {number} currentY - The current Y position the debug information will be rendered at.
	    * @default
	    */this.currentY=0;/**
	    * @property {number} currentAlpha - The alpha of the Debug context, set before all debug information is rendered to it.
	    * @default
	    */this.currentAlpha=1;/**
	    * @property {boolean} dirty - Does the canvas need re-rendering?
	    */this.dirty=false;};Phaser.Utils.Debug.prototype={/**
	    * Internal method that boots the debug displayer.
	    *
	    * @method Phaser.Utils.Debug#boot
	    * @protected
	    */boot:function boot(){if(this.game.renderType===Phaser.CANVAS){this.context=this.game.context;}else{this.bmd=new Phaser.BitmapData(this.game,'__DEBUG',this.game.width,this.game.height,true);this.sprite=this.game.make.image(0,0,this.bmd);this.game.stage.addChild(this.sprite);this.game.scale.onSizeChange.add(this.resize,this);this.canvas=PIXI.CanvasPool.create(this,this.game.width,this.game.height);this.context=this.canvas.getContext('2d');}},/**
	    * Internal method that resizes the BitmapData and Canvas.
	    * Called by ScaleManager.onSizeChange only in WebGL mode.
	    *
	    * @method Phaser.Utils.Debug#resize
	    * @protected
	    * @param {Phaser.ScaleManager} scaleManager - The Phaser ScaleManager.
	    * @param {number} width - The new width of the game.
	    * @param {number} height - The new height of the game.
	    */resize:function resize(scaleManager,width,height){this.bmd.resize(width,height);this.canvas.width=width;this.canvas.height=height;},/**
	    * Internal method that clears the canvas (if a Sprite) ready for a new debug session.
	    *
	    * @method Phaser.Utils.Debug#preUpdate
	    * @protected
	    */preUpdate:function preUpdate(){if(this.dirty&&this.sprite){this.bmd.clear();this.bmd.draw(this.canvas,0,0);this.context.clearRect(0,0,this.game.width,this.game.height);this.dirty=false;}},/**
	    * Clears the Debug canvas.
	    *
	    * @method Phaser.Utils.Debug#reset
	    */reset:function reset(){if(this.context){this.context.clearRect(0,0,this.game.width,this.game.height);}if(this.sprite){this.bmd.clear();}},/**
	    * Internal method that resets and starts the debug output values.
	    *
	    * @method Phaser.Utils.Debug#start
	    * @protected
	    * @param {number} [x=0] - The X value the debug info will start from.
	    * @param {number} [y=0] - The Y value the debug info will start from.
	    * @param {string} [color='rgb(255,255,255)'] - The color the debug text will drawn in.
	    * @param {number} [columnWidth=0] - The spacing between columns.
	    */start:function start(x,y,color,columnWidth){if(typeof x!=='number'){x=0;}if(typeof y!=='number'){y=0;}color=color||'rgb(255,255,255)';if(columnWidth===undefined){columnWidth=0;}this.currentX=x;this.currentY=y;this.currentColor=color;this.columnWidth=columnWidth;this.dirty=true;this.context.save();this.context.setTransform(1,0,0,1,0,0);this.context.strokeStyle=color;this.context.fillStyle=color;this.context.font=this.font;this.context.globalAlpha=this.currentAlpha;},/**
	    * Internal method that stops the debug output.
	    *
	    * @method Phaser.Utils.Debug#stop
	    * @protected
	    */stop:function stop(){this.context.restore();},/**
	    * Internal method that outputs a single line of text split over as many columns as needed, one per parameter.
	    *
	    * @method Phaser.Utils.Debug#line
	    * @protected
	    */line:function line(){var x=this.currentX;for(var i=0;i<arguments.length;i++){if(this.renderShadow){this.context.fillStyle='rgb(0,0,0)';this.context.fillText(arguments[i],x+1,this.currentY+1);this.context.fillStyle=this.currentColor;}this.context.fillText(arguments[i],x,this.currentY);x+=this.columnWidth;}this.currentY+=this.lineHeight;},/**
	    * Render Sound information, including decoded state, duration, volume and more.
	    *
	    * @method Phaser.Utils.Debug#soundInfo
	    * @param {Phaser.Sound} sound - The sound object to debug.
	    * @param {number} x - X position of the debug info to be rendered.
	    * @param {number} y - Y position of the debug info to be rendered.
	    * @param {string} [color='rgb(255,255,255)'] - color of the debug info to be rendered. (format is css color string).
	    */soundInfo:function soundInfo(sound,x,y,color){this.start(x,y,color);this.line('Sound: '+sound.key+' Locked: '+sound.game.sound.touchLocked);this.line('Is Ready?: '+this.game.cache.isSoundReady(sound.key)+' Pending Playback: '+sound.pendingPlayback);this.line('Decoded: '+sound.isDecoded+' Decoding: '+sound.isDecoding);this.line('Total Duration: '+sound.totalDuration+' Playing: '+sound.isPlaying);this.line('Time: '+sound.currentTime);this.line('Volume: '+sound.volume+' Muted: '+sound.mute);this.line('WebAudio: '+sound.usingWebAudio+' Audio: '+sound.usingAudioTag);if(sound.currentMarker!==''){this.line('Marker: '+sound.currentMarker+' Duration: '+sound.duration+' (ms: '+sound.durationMS+')');this.line('Start: '+sound.markers[sound.currentMarker].start+' Stop: '+sound.markers[sound.currentMarker].stop);this.line('Position: '+sound.position);}this.stop();},/**
	    * Render camera information including dimensions and location.
	    *
	    * @method Phaser.Utils.Debug#cameraInfo
	    * @param {Phaser.Camera} camera - The Phaser.Camera to show the debug information for.
	    * @param {number} x - X position of the debug info to be rendered.
	    * @param {number} y - Y position of the debug info to be rendered.
	    * @param {string} [color='rgb(255,255,255)'] - color of the debug info to be rendered. (format is css color string).
	    */cameraInfo:function cameraInfo(camera,x,y,color){this.start(x,y,color);this.line('Camera ('+camera.width+' x '+camera.height+')');this.line('X: '+camera.x+' Y: '+camera.y);if(camera.bounds){this.line('Bounds x: '+camera.bounds.x+' Y: '+camera.bounds.y+' w: '+camera.bounds.width+' h: '+camera.bounds.height);}this.line('View x: '+camera.view.x+' Y: '+camera.view.y+' w: '+camera.view.width+' h: '+camera.view.height);// this.line('Screen View x: ' + camera.screenView.x + ' Y: ' + camera.screenView.y + ' w: ' + camera.screenView.width + ' h: ' + camera.screenView.height);
	this.line('Total in view: '+camera.totalInView);this.stop();},/**
	    * Render Timer information.
	    *
	    * @method Phaser.Utils.Debug#timer
	    * @param {Phaser.Timer} timer - The Phaser.Timer to show the debug information for.
	    * @param {number} x - X position of the debug info to be rendered.
	    * @param {number} y - Y position of the debug info to be rendered.
	    * @param {string} [color='rgb(255,255,255)'] - color of the debug info to be rendered. (format is css color string).
	    */timer:function timer(_timer,x,y,color){this.start(x,y,color);this.line('Timer (running: '+_timer.running+' expired: '+_timer.expired+')');this.line('Next Tick: '+_timer.next+' Duration: '+_timer.duration);this.line('Paused: '+_timer.paused+' Length: '+_timer.length);this.stop();},/**
	    * Renders the Pointer.circle object onto the stage in green if down or red if up along with debug text.
	    *
	    * @method Phaser.Utils.Debug#pointer
	    * @param {Phaser.Pointer} pointer - The Pointer you wish to display.
	    * @param {boolean} [hideIfUp=false] - Doesn't render the circle if the pointer is up.
	    * @param {string} [downColor='rgba(0,255,0,0.5)'] - The color the circle is rendered in if down.
	    * @param {string} [upColor='rgba(255,0,0,0.5)'] - The color the circle is rendered in if up (and hideIfUp is false).
	    * @param {string} [color='rgb(255,255,255)'] - color of the debug info to be rendered. (format is css color string).
	    */pointer:function pointer(_pointer,hideIfUp,downColor,upColor,color){if(_pointer==null){return;}if(hideIfUp===undefined){hideIfUp=false;}downColor=downColor||'rgba(0,255,0,0.5)';upColor=upColor||'rgba(255,0,0,0.5)';if(hideIfUp===true&&_pointer.isUp===true){return;}this.start(_pointer.x,_pointer.y-100,color);this.context.beginPath();this.context.arc(_pointer.x,_pointer.y,_pointer.circle.radius,0,Math.PI*2);if(_pointer.active){this.context.fillStyle=downColor;}else{this.context.fillStyle=upColor;}this.context.fill();this.context.closePath();//  Render the points
	this.context.beginPath();this.context.moveTo(_pointer.positionDown.x,_pointer.positionDown.y);this.context.lineTo(_pointer.position.x,_pointer.position.y);this.context.lineWidth=2;this.context.stroke();this.context.closePath();//  Render the text
	this.line('ID: '+_pointer.id+" Active: "+_pointer.active);this.line('World X: '+_pointer.worldX+" World Y: "+_pointer.worldY);this.line('Screen X: '+_pointer.x+" Screen Y: "+_pointer.y+" In: "+_pointer.withinGame);this.line('Duration: '+_pointer.duration+" ms");this.line('is Down: '+_pointer.isDown+" is Up: "+_pointer.isUp);this.stop();},/**
	    * Render Sprite Input Debug information.
	    *
	    * @method Phaser.Utils.Debug#spriteInputInfo
	    * @param {Phaser.Sprite|Phaser.Image} sprite - The sprite to display the input data for.
	    * @param {number} x - X position of the debug info to be rendered.
	    * @param {number} y - Y position of the debug info to be rendered.
	    * @param {string} [color='rgb(255,255,255)'] - color of the debug info to be rendered. (format is css color string).
	    */spriteInputInfo:function spriteInputInfo(sprite,x,y,color){this.start(x,y,color);this.line('Sprite Input: ('+sprite.width+' x '+sprite.height+')');this.line('x: '+sprite.input.pointerX().toFixed(1)+' y: '+sprite.input.pointerY().toFixed(1));this.line('over: '+sprite.input.pointerOver()+' duration: '+sprite.input.overDuration().toFixed(0));this.line('down: '+sprite.input.pointerDown()+' duration: '+sprite.input.downDuration().toFixed(0));this.line('just over: '+sprite.input.justOver()+' just out: '+sprite.input.justOut());this.stop();},/**
	    * Renders Phaser.Key object information.
	    *
	    * @method Phaser.Utils.Debug#key
	    * @param {Phaser.Key} key - The Key to render the information for.
	    * @param {number} x - X position of the debug info to be rendered.
	    * @param {number} y - Y position of the debug info to be rendered.
	    * @param {string} [color='rgb(255,255,255)'] - color of the debug info to be rendered. (format is css color string).
	    */key:function key(_key,x,y,color){this.start(x,y,color,150);this.line('Key:',_key.keyCode,'isDown:',_key.isDown);this.line('justDown:',_key.justDown,'justUp:',_key.justUp);this.line('Time Down:',_key.timeDown.toFixed(0),'duration:',_key.duration.toFixed(0));this.stop();},/**
	    * Render debug information about the Input object.
	    *
	    * @method Phaser.Utils.Debug#inputInfo
	    * @param {number} x - X position of the debug info to be rendered.
	    * @param {number} y - Y position of the debug info to be rendered.
	    * @param {string} [color='rgb(255,255,255)'] - color of the debug info to be rendered. (format is css color string).
	    */inputInfo:function inputInfo(x,y,color){this.start(x,y,color);this.line('Input');this.line('X: '+this.game.input.x+' Y: '+this.game.input.y);this.line('World X: '+this.game.input.worldX+' World Y: '+this.game.input.worldY);this.line('Scale X: '+this.game.input.scale.x.toFixed(1)+' Scale Y: '+this.game.input.scale.x.toFixed(1));this.line('Screen X: '+this.game.input.activePointer.screenX+' Screen Y: '+this.game.input.activePointer.screenY);this.stop();},/**
	    * Renders the Sprites bounds. Note: This is really expensive as it has to calculate the bounds every time you call it!
	    *
	    * @method Phaser.Utils.Debug#spriteBounds
	    * @param {Phaser.Sprite|Phaser.Image} sprite - The sprite to display the bounds of.
	    * @param {string} [color] - Color of the debug info to be rendered (format is css color string).
	    * @param {boolean} [filled=true] - Render the rectangle as a fillRect (default, true) or a strokeRect (false)
	    */spriteBounds:function spriteBounds(sprite,color,filled){var bounds=sprite.getBounds();bounds.x+=this.game.camera.x;bounds.y+=this.game.camera.y;this.rectangle(bounds,color,filled);},/**
	    * Renders the Rope's segments. Note: This is really expensive as it has to calculate new segments every time you call it
	    *
	    * @method Phaser.Utils.Debug#ropeSegments
	    * @param {Phaser.Rope} rope - The rope to display the segments of.
	    * @param {string} [color] - Color of the debug info to be rendered (format is css color string).
	    * @param {boolean} [filled=true] - Render the rectangle as a fillRect (default, true) or a strokeRect (false)
	    */ropeSegments:function ropeSegments(rope,color,filled){var segments=rope.segments;var self=this;segments.forEach(function(segment){self.rectangle(segment,color,filled);},this);},/**
	    * Render debug infos (including name, bounds info, position and some other properties) about the Sprite.
	    *
	    * @method Phaser.Utils.Debug#spriteInfo
	    * @param {Phaser.Sprite} sprite - The Sprite to display the information of.
	    * @param {number} x - X position of the debug info to be rendered.
	    * @param {number} y - Y position of the debug info to be rendered.
	    * @param {string} [color='rgb(255,255,255)'] - color of the debug info to be rendered. (format is css color string).
	    */spriteInfo:function spriteInfo(sprite,x,y,color){this.start(x,y,color);this.line('Sprite: '+' ('+sprite.width+' x '+sprite.height+') anchor: '+sprite.anchor.x+' x '+sprite.anchor.y);this.line('x: '+sprite.x.toFixed(1)+' y: '+sprite.y.toFixed(1));this.line('angle: '+sprite.angle.toFixed(1)+' rotation: '+sprite.rotation.toFixed(1));this.line('visible: '+sprite.visible+' in camera: '+sprite.inCamera);this.line('bounds x: '+sprite._bounds.x.toFixed(1)+' y: '+sprite._bounds.y.toFixed(1)+' w: '+sprite._bounds.width.toFixed(1)+' h: '+sprite._bounds.height.toFixed(1));this.stop();},/**
	    * Renders the sprite coordinates in local, positional and world space.
	    *
	    * @method Phaser.Utils.Debug#spriteCoords
	    * @param {Phaser.Sprite|Phaser.Image} sprite - The sprite to display the coordinates for.
	    * @param {number} x - X position of the debug info to be rendered.
	    * @param {number} y - Y position of the debug info to be rendered.
	    * @param {string} [color='rgb(255,255,255)'] - color of the debug info to be rendered. (format is css color string).
	    */spriteCoords:function spriteCoords(sprite,x,y,color){this.start(x,y,color,100);if(sprite.name){this.line(sprite.name);}this.line('x:',sprite.x.toFixed(2),'y:',sprite.y.toFixed(2));this.line('pos x:',sprite.position.x.toFixed(2),'pos y:',sprite.position.y.toFixed(2));this.line('world x:',sprite.world.x.toFixed(2),'world y:',sprite.world.y.toFixed(2));this.stop();},/**
	    * Renders Line information in the given color.
	    *
	    * @method Phaser.Utils.Debug#lineInfo
	    * @param {Phaser.Line} line - The Line to display the data for.
	    * @param {number} x - X position of the debug info to be rendered.
	    * @param {number} y - Y position of the debug info to be rendered.
	    * @param {string} [color='rgb(255,255,255)'] - color of the debug info to be rendered. (format is css color string).
	    */lineInfo:function lineInfo(line,x,y,color){this.start(x,y,color,80);this.line('start.x:',line.start.x.toFixed(2),'start.y:',line.start.y.toFixed(2));this.line('end.x:',line.end.x.toFixed(2),'end.y:',line.end.y.toFixed(2));this.line('length:',line.length.toFixed(2),'angle:',line.angle);this.stop();},/**
	    * Renders a single pixel at the given size.
	    *
	    * @method Phaser.Utils.Debug#pixel
	    * @param {number} x - X position of the pixel to be rendered.
	    * @param {number} y - Y position of the pixel to be rendered.
	    * @param {string} [color] - Color of the pixel (format is css color string).
	    * @param {number} [size=2] - The 'size' to render the pixel at.
	    */pixel:function pixel(x,y,color,size){size=size||2;this.start();this.context.fillStyle=color;this.context.fillRect(x,y,size,size);this.stop();},/**
	    * Renders a Phaser geometry object including Rectangle, Circle, Point or Line.
	    *
	    * @method Phaser.Utils.Debug#geom
	    * @param {Phaser.Rectangle|Phaser.Circle|Phaser.Point|Phaser.Line} object - The geometry object to render.
	    * @param {string} [color] - Color of the debug info to be rendered (format is css color string).
	    * @param {boolean} [filled=true] - Render the objected as a filled (default, true) or a stroked (false)
	    * @param {number} [forceType=0] - Force rendering of a specific type. If 0 no type will be forced, otherwise 1 = Rectangle, 2 = Circle, 3 = Point and 4 = Line.
	    */geom:function geom(object,color,filled,forceType){if(filled===undefined){filled=true;}if(forceType===undefined){forceType=0;}color=color||'rgba(0,255,0,0.4)';this.start();this.context.fillStyle=color;this.context.strokeStyle=color;if(object instanceof Phaser.Rectangle||forceType===1){if(filled){this.context.fillRect(object.x-this.game.camera.x,object.y-this.game.camera.y,object.width,object.height);}else{this.context.strokeRect(object.x-this.game.camera.x,object.y-this.game.camera.y,object.width,object.height);}}else if(object instanceof Phaser.Circle||forceType===2){this.context.beginPath();this.context.arc(object.x-this.game.camera.x,object.y-this.game.camera.y,object.radius,0,Math.PI*2,false);this.context.closePath();if(filled){this.context.fill();}else{this.context.stroke();}}else if(object instanceof Phaser.Point||forceType===3){this.context.fillRect(object.x-this.game.camera.x,object.y-this.game.camera.y,4,4);}else if(object instanceof Phaser.Line||forceType===4){this.context.lineWidth=1;this.context.beginPath();this.context.moveTo(object.start.x+0.5-this.game.camera.x,object.start.y+0.5-this.game.camera.y);this.context.lineTo(object.end.x+0.5-this.game.camera.x,object.end.y+0.5-this.game.camera.y);this.context.closePath();this.context.stroke();}this.stop();},/**
	    * Renders a Rectangle.
	    *
	    * @method Phaser.Utils.Debug#geom
	    * @param {Phaser.Rectangle|object} object - The geometry object to render.
	    * @param {string} [color] - Color of the debug info to be rendered (format is css color string).
	    * @param {boolean} [filled=true] - Render the objected as a filled (default, true) or a stroked (false)
	    */rectangle:function rectangle(object,color,filled){if(filled===undefined){filled=true;}color=color||'rgba(0, 255, 0, 0.4)';this.start();if(filled){this.context.fillStyle=color;this.context.fillRect(object.x-this.game.camera.x,object.y-this.game.camera.y,object.width,object.height);}else{this.context.strokeStyle=color;this.context.strokeRect(object.x-this.game.camera.x,object.y-this.game.camera.y,object.width,object.height);}this.stop();},/**
	    * Render a string of text.
	    *
	    * @method Phaser.Utils.Debug#text
	    * @param {string} text - The line of text to draw.
	    * @param {number} x - X position of the debug info to be rendered.
	    * @param {number} y - Y position of the debug info to be rendered.
	    * @param {string} [color] - Color of the debug info to be rendered (format is css color string).
	    * @param {string} [font] - The font of text to draw.
	    */text:function text(_text4,x,y,color,font){color=color||'rgb(255,255,255)';font=font||'16px Courier';this.start();this.context.font=font;if(this.renderShadow){this.context.fillStyle='rgb(0,0,0)';this.context.fillText(_text4,x+1,y+1);}this.context.fillStyle=color;this.context.fillText(_text4,x,y);this.stop();},/**
	    * Visually renders a QuadTree to the display.
	    *
	    * @method Phaser.Utils.Debug#quadTree
	    * @param {Phaser.QuadTree} quadtree - The quadtree to render.
	    * @param {string} color - The color of the lines in the quadtree.
	    */quadTree:function quadTree(quadtree,color){color=color||'rgba(255,0,0,0.3)';this.start();var bounds=quadtree.bounds;if(quadtree.nodes.length===0){this.context.strokeStyle=color;this.context.strokeRect(bounds.x,bounds.y,bounds.width,bounds.height);this.text('size: '+quadtree.objects.length,bounds.x+4,bounds.y+16,'rgb(0,200,0)','12px Courier');this.context.strokeStyle='rgb(0,255,0)';for(var i=0;i<quadtree.objects.length;i++){this.context.strokeRect(quadtree.objects[i].x,quadtree.objects[i].y,quadtree.objects[i].width,quadtree.objects[i].height);}}else{for(var i=0;i<quadtree.nodes.length;i++){this.quadTree(quadtree.nodes[i]);}}this.stop();},/**
	    * Render a Sprites Physics body if it has one set. The body is rendered as a filled or stroked rectangle.
	    * This only works for Arcade Physics, Ninja Physics (AABB and Circle only) and Box2D Physics bodies.
	    * To display a P2 Physics body you should enable debug mode on the body when creating it.
	    *
	    * @method Phaser.Utils.Debug#body
	    * @param {Phaser.Sprite} sprite - The Sprite who's body will be rendered.
	    * @param {string} [color='rgba(0,255,0,0.4)'] - Color of the debug rectangle to be rendered. The format is a CSS color string such as '#ff0000' or 'rgba(255,0,0,0.5)'.
	    * @param {boolean} [filled=true] - Render the body as a filled rectangle (true) or a stroked rectangle (false)
	    */body:function body(sprite,color,filled){if(sprite.body){this.start();if(sprite.body.type===Phaser.Physics.ARCADE){Phaser.Physics.Arcade.Body.render(this.context,sprite.body,color,filled);}else if(sprite.body.type===Phaser.Physics.NINJA){Phaser.Physics.Ninja.Body.render(this.context,sprite.body,color,filled);}else if(sprite.body.type===Phaser.Physics.BOX2D){Phaser.Physics.Box2D.renderBody(this.context,sprite.body,color);}this.stop();}},/**
	    * Render a Sprites Physic Body information.
	    *
	    * @method Phaser.Utils.Debug#bodyInfo
	    * @param {Phaser.Sprite} sprite - The sprite to be rendered.
	    * @param {number} x - X position of the debug info to be rendered.
	    * @param {number} y - Y position of the debug info to be rendered.
	    * @param {string} [color='rgb(255,255,255)'] - color of the debug info to be rendered. (format is css color string).
	    */bodyInfo:function bodyInfo(sprite,x,y,color){if(sprite.body){this.start(x,y,color,210);if(sprite.body.type===Phaser.Physics.ARCADE){Phaser.Physics.Arcade.Body.renderBodyInfo(this,sprite.body);}else if(sprite.body.type===Phaser.Physics.BOX2D){this.game.physics.box2d.renderBodyInfo(this,sprite.body);}this.stop();}},/**
	    * Renders 'debug draw' data for the Box2D world if it exists.
	    * This uses the standard debug drawing feature of Box2D, so colors will be decided by
	    * the Box2D engine.
	    *
	    * @method Phaser.Utils.Debug#box2dWorld
	    */box2dWorld:function box2dWorld(){this.start();this.context.translate(-this.game.camera.view.x,-this.game.camera.view.y,0);this.game.physics.box2d.renderDebugDraw(this.context);this.stop();},/**
	    * Renders 'debug draw' data for the given Box2D body.
	    * This uses the standard debug drawing feature of Box2D, so colors will be decided by the Box2D engine.
	    *
	    * @method Phaser.Utils.Debug#box2dBody
	    * @param {Phaser.Sprite} sprite - The sprite whos body will be rendered.
	    * @param {string} [color='rgb(0,255,0)'] - color of the debug info to be rendered. (format is css color string).
	    */box2dBody:function box2dBody(body,color){this.start();Phaser.Physics.Box2D.renderBody(this.context,body,color);this.stop();},/**
	    * Call this function from the Dev Tools console.
	    * 
	    * It will scan the display list and output all of the Objects it finds, and their renderOrderIDs.
	    *
	    * **Note** Requires a browser that supports console.group and console.groupEnd (such as Chrome)
	    *
	    * @method displayList
	    * @param {Object} [displayObject] - The displayObject level display object to start from. Defaults to the World.
	    */displayList:function displayList(displayObject){if(displayObject===undefined){displayObject=this.game.world;}if(displayObject.hasOwnProperty('renderOrderID')){console.log('['+displayObject.renderOrderID+']',displayObject);}else{console.log('[]',displayObject);}if(displayObject.children&&displayObject.children.length>0){for(var i=0;i<displayObject.children.length;i++){this.game.debug.displayList(displayObject.children[i]);}}},/**
	    * Destroy this object.
	    *
	    * @method Phaser.Utils.Debug#destroy
	    */destroy:function destroy(){PIXI.CanvasPool.remove(this);}};Phaser.Utils.Debug.prototype.constructor=Phaser.Utils.Debug;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* DOM utility class.
	*
	* Provides a useful Window and Element functions as well as cross-browser compatibility buffer.
	*
	* Some code originally derived from {@link https://github.com/ryanve/verge verge}.
	* Some parts were inspired by the research of Ryan Van Etten, released under MIT License 2013.
	* 
	* @class Phaser.DOM
	* @static
	*/Phaser.DOM={/**
	    * Get the [absolute] position of the element relative to the Document.
	    *
	    * The value may vary slightly as the page is scrolled due to rounding errors.
	    *
	    * @method Phaser.DOM.getOffset
	    * @param {DOMElement} element - The targeted element that we want to retrieve the offset.
	    * @param {Phaser.Point} [point] - The point we want to take the x/y values of the offset.
	    * @return {Phaser.Point} - A point objet with the offsetX and Y as its properties.
	    */getOffset:function getOffset(element,point){point=point||new Phaser.Point();var box=element.getBoundingClientRect();var scrollTop=Phaser.DOM.scrollY;var scrollLeft=Phaser.DOM.scrollX;var clientTop=document.documentElement.clientTop;var clientLeft=document.documentElement.clientLeft;point.x=box.left+scrollLeft-clientLeft;point.y=box.top+scrollTop-clientTop;return point;},/**
	    * A cross-browser element.getBoundingClientRect method with optional cushion.
	    * 
	    * Returns a plain object containing the properties `top/bottom/left/right/width/height` with respect to the top-left corner of the current viewport.
	    * Its properties match the native rectangle.
	    * The cushion parameter is an amount of pixels (+/-) to cushion the element.
	    * It adjusts the measurements such that it is possible to detect when an element is near the viewport.
	    * 
	    * @method Phaser.DOM.getBounds
	    * @param {DOMElement|Object} element - The element or stack (uses first item) to get the bounds for.
	    * @param {number} [cushion] - A +/- pixel adjustment amount.
	    * @return {Object|boolean} A plain object containing the properties `top/bottom/left/right/width/height` or `false` if a non-valid element is given.
	    */getBounds:function getBounds(element,cushion){if(cushion===undefined){cushion=0;}element=element&&!element.nodeType?element[0]:element;if(!element||element.nodeType!==1){return false;}else{return this.calibrate(element.getBoundingClientRect(),cushion);}},/**
	    * Calibrates element coordinates for `inLayoutViewport` checks.
	    *
	    * @method Phaser.DOM.calibrate
	    * @private
	    * @param {object} coords - An object containing the following properties: `{top: number, right: number, bottom: number, left: number}`
	    * @param {number} [cushion] - A value to adjust the coordinates by.
	    * @return {object} The calibrated element coordinates
	    */calibrate:function calibrate(coords,cushion){cushion=+cushion||0;var output={width:0,height:0,left:0,right:0,top:0,bottom:0};output.width=(output.right=coords.right+cushion)-(output.left=coords.left-cushion);output.height=(output.bottom=coords.bottom+cushion)-(output.top=coords.top-cushion);return output;},/**
	    * Get the Visual viewport aspect ratio (or the aspect ratio of an object or element)    
	    * 
	    * @method Phaser.DOM.getAspectRatio
	    * @param {(DOMElement|Object)} [object=(visualViewport)] - The object to determine the aspect ratio for. Must have public `width` and `height` properties or methods.
	    * @return {number} The aspect ratio.
	    */getAspectRatio:function getAspectRatio(object){object=null==object?this.visualBounds:1===object.nodeType?this.getBounds(object):object;var w=object['width'];var h=object['height'];if(typeof w==='function'){w=w.call(object);}if(typeof h==='function'){h=h.call(object);}return w/h;},/**
	    * Tests if the given DOM element is within the Layout viewport.
	    * 
	    * The optional cushion parameter allows you to specify a distance.
	    * 
	    * inLayoutViewport(element, 100) is `true` if the element is in the viewport or 100px near it.
	    * inLayoutViewport(element, -100) is `true` if the element is in the viewport or at least 100px near it.
	    * 
	    * @method Phaser.DOM.inLayoutViewport
	    * @param {DOMElement|Object} element - The DOM element to check. If no element is given it defaults to the Phaser game canvas.
	    * @param {number} [cushion] - The cushion allows you to specify a distance within which the element must be within the viewport.
	    * @return {boolean} True if the element is within the viewport, or within `cushion` distance from it.
	    */inLayoutViewport:function inLayoutViewport(element,cushion){var r=this.getBounds(element,cushion);return!!r&&r.bottom>=0&&r.right>=0&&r.top<=this.layoutBounds.width&&r.left<=this.layoutBounds.height;},/**
	    * Returns the device screen orientation.
	    *
	    * Orientation values: 'portrait-primary', 'landscape-primary', 'portrait-secondary', 'landscape-secondary'.
	    *
	    * Order of resolving:
	    * - Screen Orientation API, or variation of - Future track. Most desktop and mobile browsers.
	    * - Screen size ratio check - If fallback is 'screen', suited for desktops.
	    * - Viewport size ratio check - If fallback is 'viewport', suited for mobile.
	    * - window.orientation - If fallback is 'window.orientation', works iOS and probably most Android; non-recommended track.
	    * - Media query
	    * - Viewport size ratio check (probably only IE9 and legacy mobile gets here..)
	    *
	    * See
	    * - https://w3c.github.io/screen-orientation/ (conflicts with mozOrientation/msOrientation)
	    * - https://developer.mozilla.org/en-US/docs/Web/API/Screen.orientation (mozOrientation)
	    * - http://msdn.microsoft.com/en-us/library/ie/dn342934(v=vs.85).aspx
	    * - https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Testing_media_queries
	    * - http://stackoverflow.com/questions/4917664/detect-viewport-orientation
	    * - http://www.matthewgifford.com/blog/2011/12/22/a-misconception-about-window-orientation
	    *
	    * @method Phaser.DOM.getScreenOrientation
	    * @protected
	    * @param {string} [primaryFallback=(none)] - Specify 'screen', 'viewport', or 'window.orientation'.
	    */getScreenOrientation:function getScreenOrientation(primaryFallback){var screen=window.screen;var orientation=screen.orientation||screen.mozOrientation||screen.msOrientation;if(orientation&&typeof orientation.type==='string'){// Screen Orientation API specification
	return orientation.type;}else if(typeof orientation==='string'){// moz/ms-orientation are strings
	return orientation;}var PORTRAIT='portrait-primary';var LANDSCAPE='landscape-primary';if(primaryFallback==='screen'){return screen.height>screen.width?PORTRAIT:LANDSCAPE;}else if(primaryFallback==='viewport'){return this.visualBounds.height>this.visualBounds.width?PORTRAIT:LANDSCAPE;}else if(primaryFallback==='window.orientation'&&typeof window.orientation==='number'){// This may change by device based on "natural" orientation.
	return window.orientation===0||window.orientation===180?PORTRAIT:LANDSCAPE;}else if(window.matchMedia){if(window.matchMedia("(orientation: portrait)").matches){return PORTRAIT;}else if(window.matchMedia("(orientation: landscape)").matches){return LANDSCAPE;}}return this.visualBounds.height>this.visualBounds.width?PORTRAIT:LANDSCAPE;},/**
	    * The bounds of the Visual viewport, as discussed in 
	    * {@link http://www.quirksmode.org/mobile/viewports.html A tale of two viewports — part one}
	    * with one difference: the viewport size _excludes_ scrollbars, as found on some desktop browsers.   
	    *
	    * Supported mobile:
	    *   iOS/Safari, Android 4, IE10, Firefox OS (maybe not Firefox Android), Opera Mobile 16
	    *
	    * The properties change dynamically.
	    *
	    * @type {Phaser.Rectangle}
	    * @property {number} x - Scroll, left offset - eg. "scrollX"
	    * @property {number} y - Scroll, top offset - eg. "scrollY"
	    * @property {number} width - Viewport width in pixels.
	    * @property {number} height - Viewport height in pixels.
	    * @readonly
	    */visualBounds:new Phaser.Rectangle(),/**
	    * The bounds of the Layout viewport, as discussed in 
	    * {@link http://www.quirksmode.org/mobile/viewports2.html A tale of two viewports — part two};
	    * but honoring the constraints as specified applicable viewport meta-tag.
	    *
	    * The bounds returned are not guaranteed to be fully aligned with CSS media queries (see
	    * {@link http://www.matanich.com/2013/01/07/viewport-size/ What size is my viewport?}).
	    *
	    * This is _not_ representative of the Visual bounds: in particular the non-primary axis will
	    * generally be significantly larger than the screen height on mobile devices when running with a
	    * constrained viewport.
	    *
	    * The properties change dynamically.
	    *
	    * @type {Phaser.Rectangle}
	    * @property {number} width - Viewport width in pixels.
	    * @property {number} height - Viewport height in pixels.
	    * @readonly
	    */layoutBounds:new Phaser.Rectangle(),/**
	    * The size of the document / Layout viewport.
	    *
	    * This incorrectly reports the dimensions in IE.
	    *
	    * The properties change dynamically.
	    *
	    * @type {Phaser.Rectangle}
	    * @property {number} width - Document width in pixels.
	    * @property {number} height - Document height in pixels.
	    * @readonly
	    */documentBounds:new Phaser.Rectangle()};Phaser.Device.whenReady(function(device){// All target browsers should support page[XY]Offset.
	var scrollX=window&&'pageXOffset'in window?function(){return window.pageXOffset;}:function(){return document.documentElement.scrollLeft;};var scrollY=window&&'pageYOffset'in window?function(){return window.pageYOffset;}:function(){return document.documentElement.scrollTop;};/**
	    * A cross-browser window.scrollX.
	    *
	    * @name Phaser.DOM.scrollX
	    * @property {number} scrollX
	    * @readonly
	    * @protected
	    */Object.defineProperty(Phaser.DOM,"scrollX",{get:scrollX});/**
	    * A cross-browser window.scrollY.
	    *
	    * @name Phaser.DOM.scrollY
	    * @property {number} scrollY
	    * @readonly
	    * @protected
	    */Object.defineProperty(Phaser.DOM,"scrollY",{get:scrollY});Object.defineProperty(Phaser.DOM.visualBounds,"x",{get:scrollX});Object.defineProperty(Phaser.DOM.visualBounds,"y",{get:scrollY});Object.defineProperty(Phaser.DOM.layoutBounds,"x",{value:0});Object.defineProperty(Phaser.DOM.layoutBounds,"y",{value:0});var treatAsDesktop=device.desktop&&document.documentElement.clientWidth<=window.innerWidth&&document.documentElement.clientHeight<=window.innerHeight;// Desktop browsers align the layout viewport with the visual viewport.
	// This differs from mobile browsers with their zooming design.
	// Ref. http://quirksmode.org/mobile/tableViewport.html  
	if(treatAsDesktop){// PST- When scrollbars are not included this causes upstream issues in ScaleManager.
	// So reverted to the old "include scrollbars."
	var clientWidth=function clientWidth(){return Math.max(window.innerWidth,document.documentElement.clientWidth);};var clientHeight=function clientHeight(){return Math.max(window.innerHeight,document.documentElement.clientHeight);};// Interested in area sans-scrollbar
	Object.defineProperty(Phaser.DOM.visualBounds,"width",{get:clientWidth});Object.defineProperty(Phaser.DOM.visualBounds,"height",{get:clientHeight});Object.defineProperty(Phaser.DOM.layoutBounds,"width",{get:clientWidth});Object.defineProperty(Phaser.DOM.layoutBounds,"height",{get:clientHeight});}else{Object.defineProperty(Phaser.DOM.visualBounds,"width",{get:function get(){return window.innerWidth;}});Object.defineProperty(Phaser.DOM.visualBounds,"height",{get:function get(){return window.innerHeight;}});Object.defineProperty(Phaser.DOM.layoutBounds,"width",{get:function get(){var a=document.documentElement.clientWidth;var b=window.innerWidth;return a<b?b:a;// max
	}});Object.defineProperty(Phaser.DOM.layoutBounds,"height",{get:function get(){var a=document.documentElement.clientHeight;var b=window.innerHeight;return a<b?b:a;// max
	}});}// For Phaser.DOM.documentBounds
	// Ref. http://www.quirksmode.org/mobile/tableViewport_desktop.html
	Object.defineProperty(Phaser.DOM.documentBounds,"x",{value:0});Object.defineProperty(Phaser.DOM.documentBounds,"y",{value:0});Object.defineProperty(Phaser.DOM.documentBounds,"width",{get:function get(){var d=document.documentElement;return Math.max(d.clientWidth,d.offsetWidth,d.scrollWidth);}});Object.defineProperty(Phaser.DOM.documentBounds,"height",{get:function get(){var d=document.documentElement;return Math.max(d.clientHeight,d.offsetHeight,d.scrollHeight);}});},null,true);/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* ArraySet is a Set data structure (items must be unique within the set) that also maintains order.
	* This allows specific items to be easily added or removed from the Set.
	*
	* Item equality (and uniqueness) is determined by the behavior of `Array.indexOf`.
	*
	* This used primarily by the Input subsystem.
	*
	* @class Phaser.ArraySet
	* @constructor
	* @param {any[]} [list=(new array)] - The backing array: if specified the items in the list _must_ be unique, per `Array.indexOf`, and the ownership of the array _should_ be relinquished to the ArraySet.
	*/Phaser.ArraySet=function(list){/**
	    * Current cursor position as established by `first` and `next`.
	    * @property {integer} position
	    * @default
	    */this.position=0;/**
	    * The backing array.
	    * @property {any[]} list
	    */this.list=list||[];};Phaser.ArraySet.prototype={/**
	    * Adds a new element to the end of the list.
	    * If the item already exists in the list it is not moved.
	    *
	    * @method Phaser.ArraySet#add
	    * @param {any} item - The element to add to this list.
	    * @return {any} The item that was added.
	    */add:function add(item){if(!this.exists(item)){this.list.push(item);}return item;},/**
	    * Gets the index of the item in the list, or -1 if it isn't in the list.
	    *
	    * @method Phaser.ArraySet#getIndex
	    * @param {any} item - The element to get the list index for.
	    * @return {integer} The index of the item or -1 if not found.
	    */getIndex:function getIndex(item){return this.list.indexOf(item);},/**
	    * Gets an item from the set based on the property strictly equaling the value given.
	    * Returns null if not found.
	    *
	    * @method Phaser.ArraySet#getByKey
	    * @param {string} property - The property to check against the value.
	    * @param {any} value - The value to check if the property strictly equals.
	    * @return {any} The item that was found, or null if nothing matched.
	    */getByKey:function getByKey(property,value){var i=this.list.length;while(i--){if(this.list[i][property]===value){return this.list[i];}}return null;},/**
	    * Checks for the item within this list.
	    *
	    * @method Phaser.ArraySet#exists
	    * @param {any} item - The element to get the list index for.
	    * @return {boolean} True if the item is found in the list, otherwise false.
	    */exists:function exists(item){return this.list.indexOf(item)>-1;},/**
	    * Removes all the items.
	    *
	    * @method Phaser.ArraySet#reset
	    */reset:function reset(){this.list.length=0;},/**
	    * Removes the given element from this list if it exists.
	    *
	    * @method Phaser.ArraySet#remove
	    * @param {any} item - The item to be removed from the list.
	    * @return {any} item - The item that was removed.
	    */remove:function remove(item){var idx=this.list.indexOf(item);if(idx>-1){this.list.splice(idx,1);return item;}},/**
	    * Sets the property `key` to the given value on all members of this list.
	    *
	    * @method Phaser.ArraySet#setAll
	    * @param {any} key - The property of the item to set.
	    * @param {any} value - The value to set the property to.
	    */setAll:function setAll(key,value){var i=this.list.length;while(i--){if(this.list[i]){this.list[i][key]=value;}}},/**
	    * Calls a function on all members of this list, using the member as the context for the callback.
	    *
	    * If the `key` property is present it must be a function.
	    * The function is invoked using the item as the context.
	    *
	    * @method Phaser.ArraySet#callAll
	    * @param {string} key - The name of the property with the function to call.
	    * @param {...*} parameter - Additional parameters that will be passed to the callback.
	    */callAll:function callAll(key){var args=Array.prototype.slice.call(arguments,1);var i=this.list.length;while(i--){if(this.list[i]&&this.list[i][key]){this.list[i][key].apply(this.list[i],args);}}},/**
	    * Removes every member from this ArraySet and optionally destroys it.
	    *
	    * @method Phaser.ArraySet#removeAll
	    * @param {boolean} [destroy=false] - Call `destroy` on each member as it's removed from this set.
	    */removeAll:function removeAll(destroy){if(destroy===undefined){destroy=false;}var i=this.list.length;while(i--){if(this.list[i]){var item=this.remove(this.list[i]);if(destroy){item.destroy();}}}this.position=0;this.list=[];}};/**
	* Number of items in the ArraySet. Same as `list.length`.
	*
	* @name Phaser.ArraySet#total
	* @property {integer} total
	*/Object.defineProperty(Phaser.ArraySet.prototype,"total",{get:function get(){return this.list.length;}});/**
	* Returns the first item and resets the cursor to the start.
	*
	* @name Phaser.ArraySet#first
	* @property {any} first
	*/Object.defineProperty(Phaser.ArraySet.prototype,"first",{get:function get(){this.position=0;if(this.list.length>0){return this.list[0];}else{return null;}}});/**
	* Returns the the next item (based on the cursor) and advances the cursor.
	*
	* @name Phaser.ArraySet#next
	* @property {any} next
	*/Object.defineProperty(Phaser.ArraySet.prototype,"next",{get:function get(){if(this.position<this.list.length){this.position++;return this.list[this.position];}else{return null;}}});Phaser.ArraySet.prototype.constructor=Phaser.ArraySet;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Utility functions for dealing with Arrays.
	*
	* @class Phaser.ArrayUtils
	* @static
	*/Phaser.ArrayUtils={/**
	    * Fetch a random entry from the given array.
	    *
	    * Will return null if there are no array items that fall within the specified range
	    * or if there is no item for the randomly chosen index.
	    *
	    * @method
	    * @param {any[]} objects - An array of objects.
	    * @param {integer} startIndex - Optional offset off the front of the array. Default value is 0, or the beginning of the array.
	    * @param {integer} length - Optional restriction on the number of values you want to randomly select from.
	    * @return {object} The random object that was selected.
	    */getRandomItem:function getRandomItem(objects,startIndex,length){if(objects===null){return null;}if(startIndex===undefined){startIndex=0;}if(length===undefined){length=objects.length;}var randomIndex=startIndex+Math.floor(Math.random()*length);return objects[randomIndex]===undefined?null:objects[randomIndex];},/**
	    * Removes a random object from the given array and returns it.
	    *
	    * Will return null if there are no array items that fall within the specified range
	    * or if there is no item for the randomly chosen index.
	    *
	    * @method
	    * @param {any[]} objects - An array of objects.
	    * @param {integer} startIndex - Optional offset off the front of the array. Default value is 0, or the beginning of the array.
	    * @param {integer} length - Optional restriction on the number of values you want to randomly select from.
	    * @return {object} The random object that was removed.
	    */removeRandomItem:function removeRandomItem(objects,startIndex,length){if(objects==null){// undefined or null
	return null;}if(startIndex===undefined){startIndex=0;}if(length===undefined){length=objects.length;}var randomIndex=startIndex+Math.floor(Math.random()*length);if(randomIndex<objects.length){var removed=objects.splice(randomIndex,1);return removed[0]===undefined?null:removed[0];}else{return null;}},/**
	    * A standard Fisher-Yates Array shuffle implementation which modifies the array in place.
	    *
	    * @method
	    * @param {any[]} array - The array to shuffle.
	    * @return {any[]} The original array, now shuffled.
	    */shuffle:function shuffle(array){for(var i=array.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var temp=array[i];array[i]=array[j];array[j]=temp;}return array;},/**
	    * Transposes the elements of the given matrix (array of arrays).
	    *
	    * @method
	    * @param {Array<any[]>} array - The matrix to transpose.
	    * @return {Array<any[]>} A new transposed matrix
	    */transposeMatrix:function transposeMatrix(array){var sourceRowCount=array.length;var sourceColCount=array[0].length;var result=new Array(sourceColCount);for(var i=0;i<sourceColCount;i++){result[i]=new Array(sourceRowCount);for(var j=sourceRowCount-1;j>-1;j--){result[i][j]=array[j][i];}}return result;},/**
	    * Rotates the given matrix (array of arrays).
	    *
	    * Based on the routine from {@link http://jsfiddle.net/MrPolywhirl/NH42z/}.
	    *
	    * @method
	    * @param {Array<any[]>} matrix - The array to rotate; this matrix _may_ be altered.
	    * @param {number|string} direction - The amount to rotate: the rotation in degrees (90, -90, 270, -270, 180) or a string command ('rotateLeft', 'rotateRight' or 'rotate180').
	    * @return {Array<any[]>} The rotated matrix. The source matrix should be discarded for the returned matrix.
	    */rotateMatrix:function rotateMatrix(matrix,direction){if(typeof direction!=='string'){direction=(direction%360+360)%360;}if(direction===90||direction===-270||direction==='rotateLeft'){matrix=Phaser.ArrayUtils.transposeMatrix(matrix);matrix=matrix.reverse();}else if(direction===-90||direction===270||direction==='rotateRight'){matrix=matrix.reverse();matrix=Phaser.ArrayUtils.transposeMatrix(matrix);}else if(Math.abs(direction)===180||direction==='rotate180'){for(var i=0;i<matrix.length;i++){matrix[i].reverse();}matrix=matrix.reverse();}return matrix;},/**
	    * Snaps a value to the nearest value in an array.
	    * The result will always be in the range `[first_value, last_value]`.
	    *
	    * @method
	    * @param {number} value - The search value
	    * @param {number[]} arr - The input array which _must_ be sorted.
	    * @return {number} The nearest value found.
	    */findClosest:function findClosest(value,arr){if(!arr.length){return NaN;}else if(arr.length===1||value<arr[0]){return arr[0];}var i=1;while(arr[i]<value){i++;}var low=arr[i-1];var high=i<arr.length?arr[i]:Number.POSITIVE_INFINITY;return high-value<=value-low?high:low;},/**
	    * Moves the element from the end of the array to the start, shifting all items in the process.
	    * The "rotation" happens to the right.
	    *
	    * Before: `[ A, B, C, D, E, F ]`
	    * After: `[ F, A, B, C, D, E ]`
	    * 
	    * See also Phaser.ArrayUtils.rotateLeft.
	    *
	    * @method Phaser.ArrayUtils.rotateRight
	    * @param {any[]} array - The array to rotate. The array is modified.
	    * @return {any} The shifted value.
	    */rotateRight:function rotateRight(array){var s=array.pop();array.unshift(s);return s;},/**
	    * Moves the element from the start of the array to the end, shifting all items in the process.
	    * The "rotation" happens to the left.
	    *
	    * Before: `[ A, B, C, D, E, F ]`
	    * After: `[ B, C, D, E, F, A ]`
	    * 
	    * See also Phaser.ArrayUtils.rotateRight
	    *
	    * @method Phaser.ArrayUtils.rotateLeft
	    * @param {any[]} array - The array to rotate. The array is modified.
	    * @return {any} The rotated value.
	    */rotateLeft:function rotateLeft(array){var s=array.shift();array.push(s);return s;},/**
	    * Moves the element from the start of the array to the end, shifting all items in the process.
	    * The "rotation" happens to the left.
	    *
	    * Before: `[ A, B, C, D, E, F ]`
	    * After: `[ B, C, D, E, F, A ]`
	    * 
	    * See also Phaser.ArrayUtils.rotateRight
	    *
	    * @method Phaser.ArrayUtils.rotate
	    * @deprecated Please use Phaser.ArrayUtils.rotate instead.
	    * @param {any[]} array - The array to rotate. The array is modified.
	    * @return {any} The rotated value.
	    */rotate:function rotate(array){var s=array.shift();array.push(s);return s;},/**
	    * Create an array representing the inclusive range of numbers (usually integers) in `[start, end]`.
	    * This is equivalent to `numberArrayStep(start, end, 1)`.
	    *
	    * @method Phaser.ArrayUtils#numberArray
	    * @param {number} start - The minimum value the array starts with.
	    * @param {number} end - The maximum value the array contains.
	    * @return {number[]} The array of number values.
	    */numberArray:function numberArray(start,end){var result=[];for(var i=start;i<=end;i++){result.push(i);}return result;},/**
	    * Create an array of numbers (positive and/or negative) progressing from `start`
	    * up to but not including `end` by advancing by `step`.
	    *
	    * If `start` is less than `end` a zero-length range is created unless a negative `step` is specified.
	    *
	    * Certain values for `start` and `end` (eg. NaN/undefined/null) are currently coerced to 0;
	    * for forward compatibility make sure to pass in actual numbers.
	    *
	    * @method Phaser.ArrayUtils#numberArrayStep
	    * @param {number} start - The start of the range.
	    * @param {number} [end] - The end of the range.
	    * @param {number} [step=1] - The value to increment or decrement by.
	    * @returns {Array} Returns the new array of numbers.
	    * @example
	    * Phaser.ArrayUtils.numberArrayStep(4);
	    * // => [0, 1, 2, 3]
	    *
	    * Phaser.ArrayUtils.numberArrayStep(1, 5);
	    * // => [1, 2, 3, 4]
	    *
	    * Phaser.ArrayUtils.numberArrayStep(0, 20, 5);
	    * // => [0, 5, 10, 15]
	    *
	    * Phaser.ArrayUtils.numberArrayStep(0, -4, -1);
	    * // => [0, -1, -2, -3]
	    *
	    * Phaser.ArrayUtils.numberArrayStep(1, 4, 0);
	    * // => [1, 1, 1]
	    *
	    * Phaser.ArrayUtils.numberArrayStep(0);
	    * // => []
	    */numberArrayStep:function numberArrayStep(start,end,step){if(start===undefined||start===null){start=0;}if(end===undefined||end===null){end=start;start=0;}if(step===undefined){step=1;}var result=[];var total=Math.max(Phaser.Math.roundAwayFromZero((end-start)/(step||1)),0);for(var i=0;i<total;i++){result.push(start);start+=step;}return result;}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A basic Linked List data structure.
	*
	* This implementation _modifies_ the `prev` and `next` properties of each item added:
	* - The `prev` and `next` properties must be writable and should not be used for any other purpose.
	* - Items _cannot_ be added to multiple LinkedLists at the same time.
	* - Only objects can be added.
	*
	* @class Phaser.LinkedList
	* @constructor
	*/Phaser.LinkedList=function(){/**
	    * Next element in the list.
	    * @property {object} next
	    * @default
	    */this.next=null;/**
	    * Previous element in the list.
	    * @property {object} prev
	    * @default
	    */this.prev=null;/**
	    * First element in the list.
	    * @property {object} first
	    * @default
	    */this.first=null;/**
	    * Last element in the list.
	    * @property {object} last
	    * @default
	    */this.last=null;/**
	    * Number of elements in the list.
	    * @property {integer} total
	    * @default
	    */this.total=0;};Phaser.LinkedList.prototype={/**
	    * Adds a new element to this linked list.
	    *
	    * @method Phaser.LinkedList#add
	    * @param {object} item - The element to add to this list. Can be a Phaser.Sprite or any other object you need to quickly iterate through.
	    * @return {object} The item that was added.
	    */add:function add(item){//  If the list is empty
	if(this.total===0&&this.first===null&&this.last===null){this.first=item;this.last=item;this.next=item;item.prev=this;this.total++;return item;}//  Gets appended to the end of the list, regardless of anything, and it won't have any children of its own (non-nested list)
	this.last.next=item;item.prev=this.last;this.last=item;this.total++;return item;},/**
	    * Resets the first, last, next and previous node pointers in this list.
	    *
	    * @method Phaser.LinkedList#reset
	    */reset:function reset(){this.first=null;this.last=null;this.next=null;this.prev=null;this.total=0;},/**
	    * Removes the given element from this linked list if it exists.
	    *
	    * @method Phaser.LinkedList#remove
	    * @param {object} item - The item to be removed from the list.
	    */remove:function remove(item){if(this.total===1){this.reset();item.next=item.prev=null;return;}if(item===this.first){// It was 'first', make 'first' point to first.next
	this.first=this.first.next;}else if(item===this.last){// It was 'last', make 'last' point to last.prev
	this.last=this.last.prev;}if(item.prev){// make item.prev.next point to childs.next instead of item
	item.prev.next=item.next;}if(item.next){// make item.next.prev point to item.prev instead of item
	item.next.prev=item.prev;}item.next=item.prev=null;if(this.first===null){this.last=null;}this.total--;},/**
	    * Calls a function on all members of this list, using the member as the context for the callback.
	    * The function must exist on the member.
	    *
	    * @method Phaser.LinkedList#callAll
	    * @param {function} callback - The function to call.
	    */callAll:function callAll(callback){if(!this.first||!this.last){return;}var entity=this.first;do{if(entity&&entity[callback]){entity[callback].call(entity);}entity=entity.next;}while(entity!==this.last.next);}};Phaser.LinkedList.prototype.constructor=Phaser.LinkedList;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Phaser.Create class is a collection of smaller helper methods that allow you to generate game content
	* quickly and easily, without the need for any external files. You can create textures for sprites and in
	* coming releases we'll add dynamic sound effect generation support as well (like sfxr).
	*
	* Access this via `Game.create` (`this.game.create` from within a State object)
	* 
	* @class Phaser.Create
	* @constructor
	* @param {Phaser.Game} game - Game reference to the currently running game.
	 */Phaser.Create=function(game){/**
	    * @property {Phaser.Game} game - A reference to the currently running Game.
	    */this.game=game;/**
	    * @property {Phaser.BitmapData} bmd - The internal BitmapData Create uses to generate textures from.
	    */this.bmd=null;/**
	    * @property {HTMLCanvasElement} canvas - The canvas the BitmapData uses.
	    */this.canvas=null;/**
	    * @property {CanvasRenderingContext2D} context - The 2d context of the canvas.
	    */this.ctx=null;/**
	    * @property {array} palettes - A range of 16 color palettes for use with sprite generation.
	    */this.palettes=[{0:'#000',1:'#9D9D9D',2:'#FFF',3:'#BE2633',4:'#E06F8B',5:'#493C2B',6:'#A46422',7:'#EB8931',8:'#F7E26B',9:'#2F484E',A:'#44891A',B:'#A3CE27',C:'#1B2632',D:'#005784',E:'#31A2F2',F:'#B2DCEF'},{0:'#000',1:'#191028',2:'#46af45',3:'#a1d685',4:'#453e78',5:'#7664fe',6:'#833129',7:'#9ec2e8',8:'#dc534b',9:'#e18d79',A:'#d6b97b',B:'#e9d8a1',C:'#216c4b',D:'#d365c8',E:'#afaab9',F:'#f5f4eb'},{0:'#000',1:'#2234d1',2:'#0c7e45',3:'#44aacc',4:'#8a3622',5:'#5c2e78',6:'#aa5c3d',7:'#b5b5b5',8:'#5e606e',9:'#4c81fb',A:'#6cd947',B:'#7be2f9',C:'#eb8a60',D:'#e23d69',E:'#ffd93f',F:'#fff'},{0:'#000',1:'#fff',2:'#8b4131',3:'#7bbdc5',4:'#8b41ac',5:'#6aac41',6:'#3931a4',7:'#d5de73',8:'#945a20',9:'#5a4100',A:'#bd736a',B:'#525252',C:'#838383',D:'#acee8b',E:'#7b73de',F:'#acacac'},{0:'#000',1:'#191028',2:'#46af45',3:'#a1d685',4:'#453e78',5:'#7664fe',6:'#833129',7:'#9ec2e8',8:'#dc534b',9:'#e18d79',A:'#d6b97b',B:'#e9d8a1',C:'#216c4b',D:'#d365c8',E:'#afaab9',F:'#fff'}];};/**
	* A 16 color palette by [Arne](http://androidarts.com/palette/16pal.htm)
	* @constant
	* @type {number}
	*/Phaser.Create.PALETTE_ARNE=0;/**
	* A 16 color JMP inspired palette.
	* @constant
	* @type {number}
	*/Phaser.Create.PALETTE_JMP=1;/**
	* A 16 color CGA inspired palette.
	* @constant
	* @type {number}
	*/Phaser.Create.PALETTE_CGA=2;/**
	* A 16 color C64 inspired palette.
	* @constant
	* @type {number}
	*/Phaser.Create.PALETTE_C64=3;/**
	* A 16 color palette inspired by Japanese computers like the MSX.
	* @constant
	* @type {number}
	*/Phaser.Create.PALETTE_JAPANESE_MACHINE=4;Phaser.Create.prototype={/**
	     * Generates a new PIXI.Texture from the given data, which can be applied to a Sprite.
	     *
	     * This allows you to create game graphics quickly and easily, with no external files but that use actual proper images
	     * rather than Phaser.Graphics objects, which are expensive to render and limited in scope.
	     *
	     * Each element of the array is a string holding the pixel color values, as mapped to one of the Phaser.Create PALETTE consts.
	     *
	     * For example:
	     *
	     * `var data = [
	     *   ' 333 ',
	     *   ' 777 ',
	     *   'E333E',
	     *   ' 333 ',
	     *   ' 3 3 '
	     * ];`
	     *
	     * `game.create.texture('bob', data);`
	     *
	     * The above will create a new texture called `bob`, which will look like a little man wearing a hat. You can then use it
	     * for sprites the same way you use any other texture: `game.add.sprite(0, 0, 'bob');`
	     *
	     * @method Phaser.Create#texture
	     * @param {string} key - The key used to store this texture in the Phaser Cache.
	     * @param {array} data - An array of pixel data.
	     * @param {integer} [pixelWidth=8] - The width of each pixel.
	     * @param {integer} [pixelHeight=8] - The height of each pixel.
	     * @param {integer} [palette=0] - The palette to use when rendering the texture. One of the Phaser.Create.PALETTE consts.
	     * @return {PIXI.Texture} The newly generated texture.
	     */texture:function texture(key,data,pixelWidth,pixelHeight,palette){if(pixelWidth===undefined){pixelWidth=8;}if(pixelHeight===undefined){pixelHeight=pixelWidth;}if(palette===undefined){palette=0;}var w=data[0].length*pixelWidth;var h=data.length*pixelHeight;//  No bmd? Let's make one
	if(this.bmd===null){this.bmd=this.game.make.bitmapData();this.canvas=this.bmd.canvas;this.ctx=this.bmd.context;}this.bmd.resize(w,h);this.bmd.clear();//  Draw it
	for(var y=0;y<data.length;y++){var row=data[y];for(var x=0;x<row.length;x++){var d=row[x];if(d!=='.'&&d!==' '){this.ctx.fillStyle=this.palettes[palette][d];this.ctx.fillRect(x*pixelWidth,y*pixelHeight,pixelWidth,pixelHeight);}}}return this.bmd.generateTexture(key);},/**
	     * Creates a grid texture based on the given dimensions.
	     *
	     * @method Phaser.Create#grid
	     * @param {string} key - The key used to store this texture in the Phaser Cache.
	     * @param {integer} width - The width of the grid in pixels.
	     * @param {integer} height - The height of the grid in pixels.
	     * @param {integer} cellWidth - The width of the grid cells in pixels.
	     * @param {integer} cellHeight - The height of the grid cells in pixels.
	     * @param {string} color - The color to draw the grid lines in. Should be a Canvas supported color string like `#ff5500` or `rgba(200,50,3,0.5)`.
	     * @return {PIXI.Texture} The newly generated texture.
	     */grid:function grid(key,width,height,cellWidth,cellHeight,color){//  No bmd? Let's make one
	if(this.bmd===null){this.bmd=this.game.make.bitmapData();this.canvas=this.bmd.canvas;this.ctx=this.bmd.context;}this.bmd.resize(width,height);this.ctx.fillStyle=color;for(var y=0;y<height;y+=cellHeight){this.ctx.fillRect(0,y,width,1);}for(var x=0;x<width;x+=cellWidth){this.ctx.fillRect(x,0,1,height);}return this.bmd.generateTexture(key);}};Phaser.Create.prototype.constructor=Phaser.Create;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* WARNING: This is an EXPERIMENTAL class. The API will change significantly in the coming versions and is incomplete.
	* Please try to avoid using in production games with a long time to build.
	* This is also why the documentation is incomplete.
	* 
	* FlexGrid is a a responsive grid manager that works in conjunction with the ScaleManager RESIZE scaling mode and FlexLayers
	* to provide for game object positioning in a responsive manner.
	*
	* @class Phaser.FlexGrid
	* @constructor
	* @param {Phaser.ScaleManager} manager - The ScaleManager.
	* @param {number} width - The width of the game.
	* @param {number} height - The height of the game.
	*/Phaser.FlexGrid=function(manager,width,height){/**
	    * @property {Phaser.Game} game - A reference to the currently running Game.
	    */this.game=manager.game;/**
	    * @property {Phaser.ScaleManager} manager - A reference to the ScaleManager.
	    */this.manager=manager;//  The perfect dimensions on which everything else is based
	this.width=width;this.height=height;this.boundsCustom=new Phaser.Rectangle(0,0,width,height);this.boundsFluid=new Phaser.Rectangle(0,0,width,height);this.boundsFull=new Phaser.Rectangle(0,0,width,height);this.boundsNone=new Phaser.Rectangle(0,0,width,height);/**
	    * @property {Phaser.Point} position - 
	    * @readonly
	    */this.positionCustom=new Phaser.Point(0,0);this.positionFluid=new Phaser.Point(0,0);this.positionFull=new Phaser.Point(0,0);this.positionNone=new Phaser.Point(0,0);/**
	    * @property {Phaser.Point} scaleFactor - The scale factor based on the game dimensions vs. the scaled dimensions.
	    * @readonly
	    */this.scaleCustom=new Phaser.Point(1,1);this.scaleFluid=new Phaser.Point(1,1);this.scaleFluidInversed=new Phaser.Point(1,1);this.scaleFull=new Phaser.Point(1,1);this.scaleNone=new Phaser.Point(1,1);this.customWidth=0;this.customHeight=0;this.customOffsetX=0;this.customOffsetY=0;this.ratioH=width/height;this.ratioV=height/width;this.multiplier=0;this.layers=[];};Phaser.FlexGrid.prototype={/**
	     * Sets the core game size. This resets the w/h parameters and bounds.
	     *
	     * @method Phaser.FlexGrid#setSize
	     * @param {number} width - The new dimensions.
	     * @param {number} height - The new dimensions.
	     */setSize:function setSize(width,height){//  These are locked and don't change until setSize is called again
	this.width=width;this.height=height;this.ratioH=width/height;this.ratioV=height/width;this.scaleNone=new Phaser.Point(1,1);this.boundsNone.width=this.width;this.boundsNone.height=this.height;this.refresh();},//  Need ability to create your own layers with custom scaling, etc.
	/**
	     * A custom layer is centered on the game and maintains its aspect ratio as it scales up and down.
	     *
	     * @method Phaser.FlexGrid#createCustomLayer
	     * @param {number} width - Width of this layer in pixels.
	     * @param {number} height - Height of this layer in pixels.
	     * @param {PIXI.DisplayObject[]} [children] - An array of children that are used to populate the FlexLayer.
	     * @return {Phaser.FlexLayer} The Layer object.
	     */createCustomLayer:function createCustomLayer(width,height,children,addToWorld){if(addToWorld===undefined){addToWorld=true;}this.customWidth=width;this.customHeight=height;this.boundsCustom.width=width;this.boundsCustom.height=height;var layer=new Phaser.FlexLayer(this,this.positionCustom,this.boundsCustom,this.scaleCustom);if(addToWorld){this.game.world.add(layer);}this.layers.push(layer);if(typeof children!=='undefined'&&typeof children!==null){layer.addMultiple(children);}return layer;},/**
	     * A fluid layer is centered on the game and maintains its aspect ratio as it scales up and down.
	     *
	     * @method Phaser.FlexGrid#createFluidLayer
	     * @param {array} [children] - An array of children that are used to populate the FlexLayer.
	     * @return {Phaser.FlexLayer} The Layer object.
	     */createFluidLayer:function createFluidLayer(children,addToWorld){if(addToWorld===undefined){addToWorld=true;}var layer=new Phaser.FlexLayer(this,this.positionFluid,this.boundsFluid,this.scaleFluid);if(addToWorld){this.game.world.add(layer);}this.layers.push(layer);if(typeof children!=='undefined'&&typeof children!==null){layer.addMultiple(children);}return layer;},/**
	     * A full layer is placed at 0,0 and extends to the full size of the game. Children are scaled according to the fluid ratios.
	     *
	     * @method Phaser.FlexGrid#createFullLayer
	     * @param {array} [children] - An array of children that are used to populate the FlexLayer.
	     * @return {Phaser.FlexLayer} The Layer object.
	     */createFullLayer:function createFullLayer(children){var layer=new Phaser.FlexLayer(this,this.positionFull,this.boundsFull,this.scaleFluid);this.game.world.add(layer);this.layers.push(layer);if(typeof children!=='undefined'){layer.addMultiple(children);}return layer;},/**
	     * A fixed layer is centered on the game and is the size of the required dimensions and is never scaled.
	     *
	     * @method Phaser.FlexGrid#createFixedLayer
	     * @param {PIXI.DisplayObject[]} [children] - An array of children that are used to populate the FlexLayer.
	     * @return {Phaser.FlexLayer} The Layer object.
	     */createFixedLayer:function createFixedLayer(children){var layer=new Phaser.FlexLayer(this,this.positionNone,this.boundsNone,this.scaleNone);this.game.world.add(layer);this.layers.push(layer);if(typeof children!=='undefined'){layer.addMultiple(children);}return layer;},/**
	     * Resets the layer children references
	     *
	     * @method Phaser.FlexGrid#reset
	     */reset:function reset(){var i=this.layers.length;while(i--){if(!this.layers[i].persist){//  Remove references to this class
	this.layers[i].position=null;this.layers[i].scale=null;this.layers.slice(i,1);}}},/**
	     * Called when the game container changes dimensions.
	     *
	     * @method Phaser.FlexGrid#onResize
	     * @param {number} width - The new width of the game container.
	     * @param {number} height - The new height of the game container.
	     */onResize:function onResize(width,height){this.ratioH=width/height;this.ratioV=height/width;this.refresh(width,height);},/**
	     * Updates all internal vars such as the bounds and scale values.
	     *
	     * @method Phaser.FlexGrid#refresh
	     */refresh:function refresh(){this.multiplier=Math.min(this.manager.height/this.height,this.manager.width/this.width);this.boundsFluid.width=Math.round(this.width*this.multiplier);this.boundsFluid.height=Math.round(this.height*this.multiplier);this.scaleFluid.set(this.boundsFluid.width/this.width,this.boundsFluid.height/this.height);this.scaleFluidInversed.set(this.width/this.boundsFluid.width,this.height/this.boundsFluid.height);this.scaleFull.set(this.boundsFull.width/this.width,this.boundsFull.height/this.height);this.boundsFull.width=Math.round(this.manager.width*this.scaleFluidInversed.x);this.boundsFull.height=Math.round(this.manager.height*this.scaleFluidInversed.y);this.boundsFluid.centerOn(this.manager.bounds.centerX,this.manager.bounds.centerY);this.boundsNone.centerOn(this.manager.bounds.centerX,this.manager.bounds.centerY);this.positionFluid.set(this.boundsFluid.x,this.boundsFluid.y);this.positionNone.set(this.boundsNone.x,this.boundsNone.y);},/**
	     * Fits a sprites width to the bounds.
	     *
	     * @method Phaser.FlexGrid#fitSprite
	     * @param {Phaser.Sprite} sprite - The Sprite to fit.
	     */fitSprite:function fitSprite(sprite){this.manager.scaleSprite(sprite);sprite.x=this.manager.bounds.centerX;sprite.y=this.manager.bounds.centerY;},/**
	     * Call in the render function to output the bounds rects.
	     *
	     * @method Phaser.FlexGrid#debug
	     */debug:function debug(){// for (var i = 0; i < this.layers.length; i++)
	// {
	//     this.layers[i].debug();
	// }
	// this.game.debug.text(this.boundsFull.width + ' x ' + this.boundsFull.height, this.boundsFull.x + 4, this.boundsFull.y + 16);
	// this.game.debug.geom(this.boundsFull, 'rgba(0,0,255,0.9', false);
	this.game.debug.text(this.boundsFluid.width+' x '+this.boundsFluid.height,this.boundsFluid.x+4,this.boundsFluid.y+16);this.game.debug.geom(this.boundsFluid,'rgba(255,0,0,0.9',false);// this.game.debug.text(this.boundsNone.width + ' x ' + this.boundsNone.height, this.boundsNone.x + 4, this.boundsNone.y + 16);
	// this.game.debug.geom(this.boundsNone, 'rgba(0,255,0,0.9', false);
	// this.game.debug.text(this.boundsCustom.width + ' x ' + this.boundsCustom.height, this.boundsCustom.x + 4, this.boundsCustom.y + 16);
	// this.game.debug.geom(this.boundsCustom, 'rgba(255,255,0,0.9', false);
	}};Phaser.FlexGrid.prototype.constructor=Phaser.FlexGrid;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* WARNING: This is an EXPERIMENTAL class. The API will change significantly in the coming versions and is incomplete.
	* Please try to avoid using in production games with a long time to build.
	* This is also why the documentation is incomplete.
	* 
	* A responsive grid layer.
	*
	* @class Phaser.FlexLayer
	* @extends Phaser.Group
	* @constructor
	* @param {Phaser.FlexGrid} manager - The FlexGrid that owns this FlexLayer.
	* @param {Phaser.Point} position - A reference to the Point object used for positioning.
	* @param {Phaser.Rectangle} bounds - A reference to the Rectangle used for the layer bounds.
	* @param {Phaser.Point} scale - A reference to the Point object used for layer scaling.
	*/Phaser.FlexLayer=function(manager,position,bounds,scale){Phaser.Group.call(this,manager.game,null,'__flexLayer'+manager.game.rnd.uuid(),false);/**
	    * @property {Phaser.ScaleManager} scale - A reference to the ScaleManager.
	    */this.manager=manager.manager;/**
	    * @property {Phaser.FlexGrid} grid - A reference to the FlexGrid that owns this layer.
	    */this.grid=manager;/**
	     * Should the FlexLayer remain through a State swap?
	     *
	     * @type {boolean}
	     */this.persist=false;/**
	    * @property {Phaser.Point} position
	    */this.position=position;/**
	    * @property {Phaser.Rectangle} bounds
	    */this.bounds=bounds;/**
	    * @property {Phaser.Point} scale
	    */this.scale=scale;/**
	    * @property {Phaser.Point} topLeft
	    */this.topLeft=bounds.topLeft;/**
	    * @property {Phaser.Point} topMiddle
	    */this.topMiddle=new Phaser.Point(bounds.halfWidth,0);/**
	    * @property {Phaser.Point} topRight
	    */this.topRight=bounds.topRight;/**
	    * @property {Phaser.Point} bottomLeft
	    */this.bottomLeft=bounds.bottomLeft;/**
	    * @property {Phaser.Point} bottomMiddle
	    */this.bottomMiddle=new Phaser.Point(bounds.halfWidth,bounds.bottom);/**
	    * @property {Phaser.Point} bottomRight
	    */this.bottomRight=bounds.bottomRight;};Phaser.FlexLayer.prototype=Object.create(Phaser.Group.prototype);Phaser.FlexLayer.prototype.constructor=Phaser.FlexLayer;/**
	 * Resize.
	 *
	 * @method Phaser.FlexLayer#resize
	 */Phaser.FlexLayer.prototype.resize=function(){};/**
	 * Debug.
	 *
	 * @method Phaser.FlexLayer#debug
	 */Phaser.FlexLayer.prototype.debug=function(){this.game.debug.text(this.bounds.width+' x '+this.bounds.height,this.bounds.x+4,this.bounds.y+16);this.game.debug.geom(this.bounds,'rgba(0,0,255,0.9',false);this.game.debug.geom(this.topLeft,'rgba(255,255,255,0.9');this.game.debug.geom(this.topMiddle,'rgba(255,255,255,0.9');this.game.debug.geom(this.topRight,'rgba(255,255,255,0.9');};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Phaser.Color class is a set of static methods that assist in color manipulation and conversion.
	*
	* @class Phaser.Color
	*/Phaser.Color={/**
	    * Packs the r, g, b, a components into a single integer, for use with Int32Array.
	    * If device is little endian then ABGR order is used. Otherwise RGBA order is used.
	    *
	    * @author Matt DesLauriers (@mattdesl)
	    * @method Phaser.Color.packPixel
	    * @static
	    * @param {number} r - The red color component, in the range 0 - 255.
	    * @param {number} g - The green color component, in the range 0 - 255.
	    * @param {number} b - The blue color component, in the range 0 - 255.
	    * @param {number} a - The alpha color component, in the range 0 - 255.
	    * @return {number} The packed color as uint32
	    */packPixel:function packPixel(r,g,b,a){if(Phaser.Device.LITTLE_ENDIAN){return(a<<24|b<<16|g<<8|r)>>>0;}else{return(r<<24|g<<16|b<<8|a)>>>0;}},/**
	    * Unpacks the r, g, b, a components into the specified color object, or a new
	    * object, for use with Int32Array. If little endian, then ABGR order is used when
	    * unpacking, otherwise, RGBA order is used. The resulting color object has the
	    * `r, g, b, a` properties which are unrelated to endianness.
	    *
	    * Note that the integer is assumed to be packed in the correct endianness. On little-endian
	    * the format is 0xAABBGGRR and on big-endian the format is 0xRRGGBBAA. If you want a
	    * endian-independent method, use fromRGBA(rgba) and toRGBA(r, g, b, a).
	    *
	    * @author Matt DesLauriers (@mattdesl)
	    * @method Phaser.Color.unpackPixel
	    * @static
	    * @param {number} rgba - The integer, packed in endian order by packPixel.
	    * @param {object} [out] - An object into which 3 properties will be created: r, g and b. If not provided a new object will be created.
	    * @param {boolean} [hsl=false] - Also convert the rgb values into hsl?
	    * @param {boolean} [hsv=false] - Also convert the rgb values into hsv?
	    * @return {object} An object with the red, green and blue values set in the r, g and b properties.
	    */unpackPixel:function unpackPixel(rgba,out,hsl,hsv){if(out===undefined||out===null){out=Phaser.Color.createColor();}if(hsl===undefined||hsl===null){hsl=false;}if(hsv===undefined||hsv===null){hsv=false;}if(Phaser.Device.LITTLE_ENDIAN){out.a=(rgba&0xff000000)>>>24;out.b=(rgba&0x00ff0000)>>>16;out.g=(rgba&0x0000ff00)>>>8;out.r=rgba&0x000000ff;}else{out.r=(rgba&0xff000000)>>>24;out.g=(rgba&0x00ff0000)>>>16;out.b=(rgba&0x0000ff00)>>>8;out.a=rgba&0x000000ff;}out.color=rgba;out.rgba='rgba('+out.r+','+out.g+','+out.b+','+out.a/255+')';if(hsl){Phaser.Color.RGBtoHSL(out.r,out.g,out.b,out);}if(hsv){Phaser.Color.RGBtoHSV(out.r,out.g,out.b,out);}return out;},/**
	    * A utility to convert an integer in 0xRRGGBBAA format to a color object.
	    * This does not rely on endianness.
	    *
	    * @author Matt DesLauriers (@mattdesl)
	    * @method Phaser.Color.fromRGBA
	    * @static
	    * @param {number} rgba - An RGBA hex
	    * @param {object} [out] - The object to use, optional.
	    * @return {object} A color object.
	    */fromRGBA:function fromRGBA(rgba,out){if(!out){out=Phaser.Color.createColor();}out.r=(rgba&0xff000000)>>>24;out.g=(rgba&0x00ff0000)>>>16;out.b=(rgba&0x0000ff00)>>>8;out.a=rgba&0x000000ff;out.rgba='rgba('+out.r+','+out.g+','+out.b+','+out.a+')';return out;},/**
	    * A utility to convert RGBA components to a 32 bit integer in RRGGBBAA format.
	    *
	    * @author Matt DesLauriers (@mattdesl)
	    * @method Phaser.Color.toRGBA
	    * @static
	    * @param {number} r - The red color component, in the range 0 - 255.
	    * @param {number} g - The green color component, in the range 0 - 255.
	    * @param {number} b - The blue color component, in the range 0 - 255.
	    * @param {number} a - The alpha color component, in the range 0 - 255.
	    * @return {number} A RGBA-packed 32 bit integer
	    */toRGBA:function toRGBA(r,g,b,a){return r<<24|g<<16|b<<8|a;},/**
	    * Converts RGBA components to a 32 bit integer in AABBGGRR format.
	    *
	    * @method Phaser.Color.toABGR
	    * @static
	    * @param {number} r - The red color component, in the range 0 - 255.
	    * @param {number} g - The green color component, in the range 0 - 255.
	    * @param {number} b - The blue color component, in the range 0 - 255.
	    * @param {number} a - The alpha color component, in the range 0 - 255.
	    * @return {number} A RGBA-packed 32 bit integer
	    */toABGR:function toABGR(r,g,b,a){return(a<<24|b<<16|g<<8|r)>>>0;},/**
	    * Converts an RGB color value to HSL (hue, saturation and lightness).
	    * Conversion forumla from http://en.wikipedia.org/wiki/HSL_color_space.
	    * Assumes RGB values are contained in the set [0, 255] and returns h, s and l in the set [0, 1].
	    * Based on code by Michael Jackson (https://github.com/mjijackson)
	    *
	    * @method Phaser.Color.RGBtoHSL
	    * @static
	    * @param {number} r - The red color component, in the range 0 - 255.
	    * @param {number} g - The green color component, in the range 0 - 255.
	    * @param {number} b - The blue color component, in the range 0 - 255.
	    * @param {object} [out] - An object into which 3 properties will be created, h, s and l. If not provided a new object will be created.
	    * @return {object} An object with the hue, saturation and lightness values set in the h, s and l properties.
	    */RGBtoHSL:function RGBtoHSL(r,g,b,out){if(!out){out=Phaser.Color.createColor(r,g,b,1);}r/=255;g/=255;b/=255;var min=Math.min(r,g,b);var max=Math.max(r,g,b);// achromatic by default
	out.h=0;out.s=0;out.l=(max+min)/2;if(max!==min){var d=max-min;out.s=out.l>0.5?d/(2-max-min):d/(max+min);if(max===r){out.h=(g-b)/d+(g<b?6:0);}else if(max===g){out.h=(b-r)/d+2;}else if(max===b){out.h=(r-g)/d+4;}out.h/=6;}return out;},/**
	    * Converts an HSL (hue, saturation and lightness) color value to RGB.
	    * Conversion forumla from http://en.wikipedia.org/wiki/HSL_color_space.
	    * Assumes HSL values are contained in the set [0, 1] and returns r, g and b values in the set [0, 255].
	    * Based on code by Michael Jackson (https://github.com/mjijackson)
	    *
	    * @method Phaser.Color.HSLtoRGB
	    * @static
	    * @param {number} h - The hue, in the range 0 - 1.
	    * @param {number} s - The saturation, in the range 0 - 1.
	    * @param {number} l - The lightness, in the range 0 - 1.
	    * @param {object} [out] - An object into which 3 properties will be created: r, g and b. If not provided a new object will be created.
	    * @return {object} An object with the red, green and blue values set in the r, g and b properties.
	    */HSLtoRGB:function HSLtoRGB(h,s,l,out){if(!out){out=Phaser.Color.createColor(l,l,l);}else{// achromatic by default
	out.r=l;out.g=l;out.b=l;}if(s!==0){var q=l<0.5?l*(1+s):l+s-l*s;var p=2*l-q;out.r=Phaser.Color.hueToColor(p,q,h+1/3);out.g=Phaser.Color.hueToColor(p,q,h);out.b=Phaser.Color.hueToColor(p,q,h-1/3);}// out.r = (out.r * 255 | 0);
	// out.g = (out.g * 255 | 0);
	// out.b = (out.b * 255 | 0);
	out.r=Math.floor(out.r*255|0);out.g=Math.floor(out.g*255|0);out.b=Math.floor(out.b*255|0);Phaser.Color.updateColor(out);return out;},/**
	    * Converts an RGB color value to HSV (hue, saturation and value).
	    * Conversion forumla from http://en.wikipedia.org/wiki/HSL_color_space.
	    * Assumes RGB values are contained in the set [0, 255] and returns h, s and v in the set [0, 1].
	    * Based on code by Michael Jackson (https://github.com/mjijackson)
	    *
	    * @method Phaser.Color.RGBtoHSV
	    * @static
	    * @param {number} r - The red color component, in the range 0 - 255.
	    * @param {number} g - The green color component, in the range 0 - 255.
	    * @param {number} b - The blue color component, in the range 0 - 255.
	    * @param {object} [out] - An object into which 3 properties will be created, h, s and v. If not provided a new object will be created.
	    * @return {object} An object with the hue, saturation and value set in the h, s and v properties.
	    */RGBtoHSV:function RGBtoHSV(r,g,b,out){if(!out){out=Phaser.Color.createColor(r,g,b,255);}r/=255;g/=255;b/=255;var min=Math.min(r,g,b);var max=Math.max(r,g,b);var d=max-min;// achromatic by default
	out.h=0;out.s=max===0?0:d/max;out.v=max;if(max!==min){if(max===r){out.h=(g-b)/d+(g<b?6:0);}else if(max===g){out.h=(b-r)/d+2;}else if(max===b){out.h=(r-g)/d+4;}out.h/=6;}return out;},/**
	    * Converts an HSV (hue, saturation and value) color value to RGB.
	    * Conversion forumla from http://en.wikipedia.org/wiki/HSL_color_space.
	    * Assumes HSV values are contained in the set [0, 1] and returns r, g and b values in the set [0, 255].
	    * Based on code by Michael Jackson (https://github.com/mjijackson)
	    *
	    * @method Phaser.Color.HSVtoRGB
	    * @static
	    * @param {number} h - The hue, in the range 0 - 1.
	    * @param {number} s - The saturation, in the range 0 - 1.
	    * @param {number} v - The value, in the range 0 - 1.
	    * @param {object} [out] - An object into which 3 properties will be created: r, g and b. If not provided a new object will be created.
	    * @return {object} An object with the red, green and blue values set in the r, g and b properties.
	    */HSVtoRGB:function HSVtoRGB(h,s,v,out){if(out===undefined){out=Phaser.Color.createColor(0,0,0,1,h,s,0,v);}var r,g,b;var i=Math.floor(h*6);var f=h*6-i;var p=v*(1-s);var q=v*(1-f*s);var t=v*(1-(1-f)*s);switch(i%6){case 0:r=v;g=t;b=p;break;case 1:r=q;g=v;b=p;break;case 2:r=p;g=v;b=t;break;case 3:r=p;g=q;b=v;break;case 4:r=t;g=p;b=v;break;case 5:r=v;g=p;b=q;break;}out.r=Math.floor(r*255);out.g=Math.floor(g*255);out.b=Math.floor(b*255);Phaser.Color.updateColor(out);return out;},/**
	    * Converts a hue to an RGB color.
	    * Based on code by Michael Jackson (https://github.com/mjijackson)
	    *
	    * @method Phaser.Color.hueToColor
	    * @static
	    * @param {number} p
	    * @param {number} q
	    * @param {number} t
	    * @return {number} The color component value.
	    */hueToColor:function hueToColor(p,q,t){if(t<0){t+=1;}if(t>1){t-=1;}if(t<1/6){return p+(q-p)*6*t;}if(t<1/2){return q;}if(t<2/3){return p+(q-p)*(2/3-t)*6;}return p;},/**
	    * A utility function to create a lightweight 'color' object with the default components.
	    * Any components that are not specified will default to zero.
	    *
	    * This is useful when you want to use a shared color object for the getPixel and getPixelAt methods.
	    *
	    * @author Matt DesLauriers (@mattdesl)
	    * @method Phaser.Color.createColor
	    * @static
	    * @param {number} [r=0] - The red color component, in the range 0 - 255.
	    * @param {number} [g=0] - The green color component, in the range 0 - 255.
	    * @param {number} [b=0] - The blue color component, in the range 0 - 255.
	    * @param {number} [a=1] - The alpha color component, in the range 0 - 1.
	    * @param {number} [h=0] - The hue, in the range 0 - 1.
	    * @param {number} [s=0] - The saturation, in the range 0 - 1.
	    * @param {number} [l=0] - The lightness, in the range 0 - 1.
	    * @param {number} [v=0] - The value, in the range 0 - 1.
	    * @return {object} The resulting object with r, g, b, a properties and h, s, l and v.
	    */createColor:function createColor(r,g,b,a,h,s,l,v){var out={r:r||0,g:g||0,b:b||0,a:a||1,h:h||0,s:s||0,l:l||0,v:v||0,color:0,color32:0,rgba:''};return Phaser.Color.updateColor(out);},/**
	    * Takes a color object and updates the rgba, color and color32 properties.
	    *
	    * @method Phaser.Color.updateColor
	    * @static
	    * @param {object} out - The color object to update.
	    * @returns {number} A native color value integer (format: 0xAARRGGBB).
	    */updateColor:function updateColor(out){out.rgba='rgba('+out.r.toString()+','+out.g.toString()+','+out.b.toString()+','+out.a.toString()+')';out.color=Phaser.Color.getColor(out.r,out.g,out.b);out.color32=Phaser.Color.getColor32(out.a*255,out.r,out.g,out.b);return out;},/**
	    * Given an alpha and 3 color values this will return an integer representation of it.
	    *
	    * @method Phaser.Color.getColor32
	    * @static
	    * @param {number} a - The alpha color component, in the range 0 - 255.
	    * @param {number} r - The red color component, in the range 0 - 255.
	    * @param {number} g - The green color component, in the range 0 - 255.
	    * @param {number} b - The blue color component, in the range 0 - 255.
	    * @returns {number} A native color value integer (format: 0xAARRGGBB).
	    */getColor32:function getColor32(a,r,g,b){return a<<24|r<<16|g<<8|b;},/**
	    * Given 3 color values this will return an integer representation of it.
	    *
	    * @method Phaser.Color.getColor
	    * @static
	    * @param {number} r - The red color component, in the range 0 - 255.
	    * @param {number} g - The green color component, in the range 0 - 255.
	    * @param {number} b - The blue color component, in the range 0 - 255.
	    * @returns {number} A native color value integer (format: 0xRRGGBB).
	    */getColor:function getColor(r,g,b){return r<<16|g<<8|b;},/**
	    * Converts the given color values into a string.
	    * If prefix was '#' it will be in the format `#RRGGBB` otherwise `0xAARRGGBB`.
	    *
	    * @method Phaser.Color.RGBtoString
	    * @static
	    * @param {number} r - The red color component, in the range 0 - 255.
	    * @param {number} g - The green color component, in the range 0 - 255.
	    * @param {number} b - The blue color component, in the range 0 - 255.
	    * @param {number} [a=255] - The alpha color component, in the range 0 - 255.
	    * @param {string} [prefix='#'] - The prefix used in the return string. If '#' it will return `#RRGGBB`, else `0xAARRGGBB`.
	    * @return {string} A string containing the color values. If prefix was '#' it will be in the format `#RRGGBB` otherwise `0xAARRGGBB`.
	    */RGBtoString:function RGBtoString(r,g,b,a,prefix){if(a===undefined){a=255;}if(prefix===undefined){prefix='#';}if(prefix==='#'){return'#'+((1<<24)+(r<<16)+(g<<8)+b).toString(16).slice(1);}else{return'0x'+Phaser.Color.componentToHex(a)+Phaser.Color.componentToHex(r)+Phaser.Color.componentToHex(g)+Phaser.Color.componentToHex(b);}},/**
	    * Converts a hex string into an integer color value.
	    *
	    * @method Phaser.Color.hexToRGB
	    * @static
	    * @param {string} hex - The hex string to convert. Can be in the short-hand format `#03f` or `#0033ff`.
	    * @return {number} The rgb color value in the format 0xAARRGGBB.
	    */hexToRGB:function hexToRGB(hex){var rgb=Phaser.Color.hexToColor(hex);if(rgb){return Phaser.Color.getColor32(rgb.a,rgb.r,rgb.g,rgb.b);}},/**
	    * Converts a hex string into a Phaser Color object.
	    *
	    * The hex string can supplied as `'#0033ff'` or the short-hand format of `'#03f'`; it can begin with an optional "#" or "0x", or be unprefixed.    
	    *
	    * An alpha channel is _not_ supported.
	    *
	    * @method Phaser.Color.hexToColor
	    * @static
	    * @param {string} hex - The color string in a hex format.
	    * @param {object} [out] - An object into which 3 properties will be created or set: r, g and b. If not provided a new object will be created.
	    * @return {object} An object with the red, green and blue values set in the r, g and b properties.
	    */hexToColor:function hexToColor(hex,out){// Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
	hex=hex.replace(/^(?:#|0x)?([a-f\d])([a-f\d])([a-f\d])$/i,function(m,r,g,b){return r+r+g+g+b+b;});var result=/^(?:#|0x)?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);if(result){var r=parseInt(result[1],16);var g=parseInt(result[2],16);var b=parseInt(result[3],16);if(!out){out=Phaser.Color.createColor(r,g,b);}else{out.r=r;out.g=g;out.b=b;}}return out;},/**
	    * Converts a CSS 'web' string into a Phaser Color object.
	    *
	    * The web string can be in the format `'rgb(r,g,b)'` or `'rgba(r,g,b,a)'` where r/g/b are in the range [0..255] and a is in the range [0..1].
	    *
	    * @method Phaser.Color.webToColor
	    * @static
	    * @param {string} web - The color string in CSS 'web' format.
	    * @param {object} [out] - An object into which 4 properties will be created: r, g, b and a. If not provided a new object will be created.
	    * @return {object} An object with the red, green, blue and alpha values set in the r, g, b and a properties.
	    */webToColor:function webToColor(web,out){if(!out){out=Phaser.Color.createColor();}var result=/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d+(?:\.\d+)?))?\s*\)$/.exec(web);if(result){out.r=parseInt(result[1],10);out.g=parseInt(result[2],10);out.b=parseInt(result[3],10);out.a=result[4]!==undefined?parseFloat(result[4]):1;Phaser.Color.updateColor(out);}return out;},/**
	    * Converts a value - a "hex" string, a "CSS 'web' string", or a number - into red, green, blue, and alpha components.
	    *
	    * The value can be a string (see `hexToColor` and `webToColor` for the supported formats) or a packed integer (see `getRGB`).
	    *
	    * An alpha channel is _not_ supported when specifying a hex string.
	    *
	    * @method Phaser.Color.valueToColor
	    * @static
	    * @param {string|number} value - The color expressed as a recognized string format or a packed integer.
	    * @param {object} [out] - The object to use for the output. If not provided a new object will be created.
	    * @return {object} The (`out`) object with the red, green, blue, and alpha values set as the r/g/b/a properties.
	    */valueToColor:function valueToColor(value,out){//  The behavior is not consistent between hexToColor/webToColor on invalid input.
	//  This unifies both by returning a new object, but returning null may be better.
	if(!out){out=Phaser.Color.createColor();}if(typeof value==='string'){if(value.indexOf('rgb')===0){return Phaser.Color.webToColor(value,out);}else{//  `hexToColor` does not support alpha; match `createColor`.
	out.a=1;return Phaser.Color.hexToColor(value,out);}}else if(typeof value==='number'){//  `getRGB` does not take optional object to modify;
	//  alpha is also adjusted to match `createColor`.
	var tempColor=Phaser.Color.getRGB(value);out.r=tempColor.r;out.g=tempColor.g;out.b=tempColor.b;out.a=tempColor.a/255;return out;}else{return out;}},/**
	    * Return a string containing a hex representation of the given color component.
	    *
	    * @method Phaser.Color.componentToHex
	    * @static
	    * @param {number} color - The color channel to get the hex value for, must be a value between 0 and 255.
	    * @returns {string} A string of length 2 characters, i.e. 255 = ff, 100 = 64.
	    */componentToHex:function componentToHex(color){var hex=color.toString(16);return hex.length===1?'0'+hex:hex;},/**
	    * Get HSV color wheel values in an array which will be 360 elements in size.
	    *
	    * @method Phaser.Color.HSVColorWheel
	    * @static
	    * @param {number} [s=1] - The saturation, in the range 0 - 1.
	    * @param {number} [v=1] - The value, in the range 0 - 1.
	    * @return {array} An array containing 360 elements corresponding to the HSV color wheel.
	    */HSVColorWheel:function HSVColorWheel(s,v){if(s===undefined){s=1.0;}if(v===undefined){v=1.0;}var colors=[];for(var c=0;c<=359;c++){colors.push(Phaser.Color.HSVtoRGB(c/359,s,v));}return colors;},/**
	    * Get HSL color wheel values in an array which will be 360 elements in size.
	    *
	    * @method Phaser.Color.HSLColorWheel
	    * @static
	    * @param {number} [s=0.5] - The saturation, in the range 0 - 1.
	    * @param {number} [l=0.5] - The lightness, in the range 0 - 1.
	    * @return {array} An array containing 360 elements corresponding to the HSL color wheel.
	    */HSLColorWheel:function HSLColorWheel(s,l){if(s===undefined){s=0.5;}if(l===undefined){l=0.5;}var colors=[];for(var c=0;c<=359;c++){colors.push(Phaser.Color.HSLtoRGB(c/359,s,l));}return colors;},/**
	    * Interpolates the two given colours based on the supplied step and currentStep properties.
	    *
	    * @method Phaser.Color.interpolateColor
	    * @static
	    * @param {number} color1 - The first color value.
	    * @param {number} color2 - The second color value.
	    * @param {number} steps - The number of steps to run the interpolation over.
	    * @param {number} currentStep - The currentStep value. If the interpolation will take 100 steps, a currentStep value of 50 would be half-way between the two.
	    * @param {number} alpha - The alpha of the returned color.
	    * @returns {number} The interpolated color value.
	    */interpolateColor:function interpolateColor(color1,color2,steps,currentStep,alpha){if(alpha===undefined){alpha=255;}var src1=Phaser.Color.getRGB(color1);var src2=Phaser.Color.getRGB(color2);var r=(src2.red-src1.red)*currentStep/steps+src1.red;var g=(src2.green-src1.green)*currentStep/steps+src1.green;var b=(src2.blue-src1.blue)*currentStep/steps+src1.blue;return Phaser.Color.getColor32(alpha,r,g,b);},/**
	    * Interpolates the two given colours based on the supplied step and currentStep properties.
	    *
	    * @method Phaser.Color.interpolateColorWithRGB
	    * @static
	    * @param {number} color - The first color value.
	    * @param {number} r - The red color value, between 0 and 0xFF (255).
	    * @param {number} g - The green color value, between 0 and 0xFF (255).
	    * @param {number} b - The blue color value, between 0 and 0xFF (255).
	    * @param {number} steps - The number of steps to run the interpolation over.
	    * @param {number} currentStep - The currentStep value. If the interpolation will take 100 steps, a currentStep value of 50 would be half-way between the two.
	    * @returns {number} The interpolated color value.
	    */interpolateColorWithRGB:function interpolateColorWithRGB(color,r,g,b,steps,currentStep){var src=Phaser.Color.getRGB(color);var or=(r-src.red)*currentStep/steps+src.red;var og=(g-src.green)*currentStep/steps+src.green;var ob=(b-src.blue)*currentStep/steps+src.blue;return Phaser.Color.getColor(or,og,ob);},/**
	    * Interpolates the two given colours based on the supplied step and currentStep properties.
	    * @method Phaser.Color.interpolateRGB
	    * @static
	    * @param {number} r1 - The red color value, between 0 and 0xFF (255).
	    * @param {number} g1 - The green color value, between 0 and 0xFF (255).
	    * @param {number} b1 - The blue color value, between 0 and 0xFF (255).
	    * @param {number} r2 - The red color value, between 0 and 0xFF (255).
	    * @param {number} g2 - The green color value, between 0 and 0xFF (255).
	    * @param {number} b2 - The blue color value, between 0 and 0xFF (255).
	    * @param {number} steps - The number of steps to run the interpolation over.
	    * @param {number} currentStep - The currentStep value. If the interpolation will take 100 steps, a currentStep value of 50 would be half-way between the two.
	    * @returns {number} The interpolated color value.
	    */interpolateRGB:function interpolateRGB(r1,g1,b1,r2,g2,b2,steps,currentStep){var r=(r2-r1)*currentStep/steps+r1;var g=(g2-g1)*currentStep/steps+g1;var b=(b2-b1)*currentStep/steps+b1;return Phaser.Color.getColor(r,g,b);},/**
	    * Returns a random color value between black and white
	    * Set the min value to start each channel from the given offset.
	    * Set the max value to restrict the maximum color used per channel.
	    *
	    * @method Phaser.Color.getRandomColor
	    * @static
	    * @param {number} [min=0] - The lowest value to use for the color.
	    * @param {number} [max=255] - The highest value to use for the color.
	    * @param {number} [alpha=255] - The alpha value of the returning color (default 255 = fully opaque).
	    * @returns {number} 32-bit color value with alpha.
	    */getRandomColor:function getRandomColor(min,max,alpha){if(min===undefined){min=0;}if(max===undefined){max=255;}if(alpha===undefined){alpha=255;}//  Sanity checks
	if(max>255||min>max){return Phaser.Color.getColor(255,255,255);}var red=min+Math.round(Math.random()*(max-min));var green=min+Math.round(Math.random()*(max-min));var blue=min+Math.round(Math.random()*(max-min));return Phaser.Color.getColor32(alpha,red,green,blue);},/**
	    * Return the component parts of a color as an Object with the properties alpha, red, green, blue.
	    *
	    * Alpha will only be set if it exist in the given color (0xAARRGGBB)
	    *
	    * @method Phaser.Color.getRGB
	    * @static
	    * @param {number} color - Color in RGB (0xRRGGBB) or ARGB format (0xAARRGGBB).
	    * @returns {object} An Object with properties: alpha, red, green, blue (also r, g, b and a). Alpha will only be present if a color value > 16777215 was given.
	    */getRGB:function getRGB(color){if(color>16777215){//  The color value has an alpha component
	return{alpha:color>>>24,red:color>>16&0xFF,green:color>>8&0xFF,blue:color&0xFF,a:color>>>24,r:color>>16&0xFF,g:color>>8&0xFF,b:color&0xFF};}else{return{alpha:255,red:color>>16&0xFF,green:color>>8&0xFF,blue:color&0xFF,a:255,r:color>>16&0xFF,g:color>>8&0xFF,b:color&0xFF};}},/**
	    * Returns a CSS friendly string value from the given color.
	    *
	    * @method Phaser.Color.getWebRGB
	    * @static
	    * @param {number|Object} color - Color in RGB (0xRRGGBB), ARGB format (0xAARRGGBB) or an Object with r, g, b, a properties.
	    * @returns {string} A string in the format: 'rgba(r,g,b,a)'
	    */getWebRGB:function getWebRGB(color){if((typeof color==='undefined'?'undefined':_typeof(color))==='object'){return'rgba('+color.r.toString()+','+color.g.toString()+','+color.b.toString()+','+(color.a/255).toString()+')';}else{var rgb=Phaser.Color.getRGB(color);return'rgba('+rgb.r.toString()+','+rgb.g.toString()+','+rgb.b.toString()+','+(rgb.a/255).toString()+')';}},/**
	    * Given a native color value (in the format 0xAARRGGBB) this will return the Alpha component, as a value between 0 and 255.
	    *
	    * @method Phaser.Color.getAlpha
	    * @static
	    * @param {number} color - In the format 0xAARRGGBB.
	    * @returns {number} The Alpha component of the color, will be between 0 and 1 (0 being no Alpha (opaque), 1 full Alpha (transparent)).
	    */getAlpha:function getAlpha(color){return color>>>24;},/**
	    * Given a native color value (in the format 0xAARRGGBB) this will return the Alpha component as a value between 0 and 1.
	    *
	    * @method Phaser.Color.getAlphaFloat
	    * @static
	    * @param {number} color - In the format 0xAARRGGBB.
	    * @returns {number} The Alpha component of the color, will be between 0 and 1 (0 being no Alpha (opaque), 1 full Alpha (transparent)).
	    */getAlphaFloat:function getAlphaFloat(color){return(color>>>24)/255;},/**
	    * Given a native color value (in the format 0xAARRGGBB) this will return the Red component, as a value between 0 and 255.
	    *
	    * @method Phaser.Color.getRed
	    * @static
	    * @param {number} color In the format 0xAARRGGBB.
	    * @returns {number} The Red component of the color, will be between 0 and 255 (0 being no color, 255 full Red).
	    */getRed:function getRed(color){return color>>16&0xFF;},/**
	    * Given a native color value (in the format 0xAARRGGBB) this will return the Green component, as a value between 0 and 255.
	    *
	    * @method Phaser.Color.getGreen
	    * @static
	    * @param {number} color - In the format 0xAARRGGBB.
	    * @returns {number} The Green component of the color, will be between 0 and 255 (0 being no color, 255 full Green).
	    */getGreen:function getGreen(color){return color>>8&0xFF;},/**
	    * Given a native color value (in the format 0xAARRGGBB) this will return the Blue component, as a value between 0 and 255.
	    *
	    * @method Phaser.Color.getBlue
	    * @static
	    * @param {number} color - In the format 0xAARRGGBB.
	    * @returns {number} The Blue component of the color, will be between 0 and 255 (0 being no color, 255 full Blue).
	    */getBlue:function getBlue(color){return color&0xFF;},/**
	    * Blends the source color, ignoring the backdrop.
	    *
	    * @method Phaser.Color.blendNormal
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendNormal:function blendNormal(a){return a;},/**
	    * Selects the lighter of the backdrop and source colors.
	    *
	    * @method Phaser.Color.blendLighten
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendLighten:function blendLighten(a,b){return b>a?b:a;},/**
	    * Selects the darker of the backdrop and source colors.
	    *
	    * @method Phaser.Color.blendDarken
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendDarken:function blendDarken(a,b){return b>a?a:b;},/**
	    * Multiplies the backdrop and source color values.
	    * The result color is always at least as dark as either of the two constituent
	    * colors. Multiplying any color with black produces black;
	    * multiplying with white leaves the original color unchanged.
	    *
	    * @method Phaser.Color.blendMultiply
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendMultiply:function blendMultiply(a,b){return a*b/255;},/**
	    * Takes the average of the source and backdrop colors.
	    *
	    * @method Phaser.Color.blendAverage
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendAverage:function blendAverage(a,b){return(a+b)/2;},/**
	    * Adds the source and backdrop colors together and returns the value, up to a maximum of 255.
	    *
	    * @method Phaser.Color.blendAdd
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendAdd:function blendAdd(a,b){return Math.min(255,a+b);},/**
	    * Combines the source and backdrop colors and returns their value minus 255.
	    *
	    * @method Phaser.Color.blendSubtract
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendSubtract:function blendSubtract(a,b){return Math.max(0,a+b-255);},/**
	    * Subtracts the darker of the two constituent colors from the lighter.
	    * 
	    * Painting with white inverts the backdrop color; painting with black produces no change. 
	    *
	    * @method Phaser.Color.blendDifference
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendDifference:function blendDifference(a,b){return Math.abs(a-b);},/**
	    * Negation blend mode.
	    *
	    * @method Phaser.Color.blendNegation
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendNegation:function blendNegation(a,b){return 255-Math.abs(255-a-b);},/**
	    * Multiplies the complements of the backdrop and source color values, then complements the result.
	    * The result color is always at least as light as either of the two constituent colors. 
	    * Screening any color with white produces white; screening with black leaves the original color unchanged. 
	    *
	    * @method Phaser.Color.blendScreen
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendScreen:function blendScreen(a,b){return 255-((255-a)*(255-b)>>8);},/**
	    * Produces an effect similar to that of the Difference mode, but lower in contrast. 
	    * Painting with white inverts the backdrop color; painting with black produces no change. 
	    *
	    * @method Phaser.Color.blendExclusion
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendExclusion:function blendExclusion(a,b){return a+b-2*a*b/255;},/**
	    * Multiplies or screens the colors, depending on the backdrop color.
	    * Source colors overlay the backdrop while preserving its highlights and shadows. 
	    * The backdrop color is not replaced, but is mixed with the source color to reflect the lightness or darkness of the backdrop.
	    *
	    * @method Phaser.Color.blendOverlay
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendOverlay:function blendOverlay(a,b){return b<128?2*a*b/255:255-2*(255-a)*(255-b)/255;},/**
	    * Darkens or lightens the colors, depending on the source color value. 
	    * 
	    * If the source color is lighter than 0.5, the backdrop is lightened, as if it were dodged; 
	    * this is useful for adding highlights to a scene. 
	    * 
	    * If the source color is darker than 0.5, the backdrop is darkened, as if it were burned in. 
	    * The degree of lightening or darkening is proportional to the difference between the source color and 0.5; 
	    * if it is equal to 0.5, the backdrop is unchanged.
	    * 
	    * Painting with pure black or white produces a distinctly darker or lighter area, but does not result in pure black or white. 
	    * The effect is similar to shining a diffused spotlight on the backdrop. 
	    *
	    * @method Phaser.Color.blendSoftLight
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendSoftLight:function blendSoftLight(a,b){return b<128?2*((a>>1)+64)*(b/255):255-2*(255-((a>>1)+64))*(255-b)/255;},/**
	    * Multiplies or screens the colors, depending on the source color value. 
	    * 
	    * If the source color is lighter than 0.5, the backdrop is lightened, as if it were screened; 
	    * this is useful for adding highlights to a scene. 
	    * 
	    * If the source color is darker than 0.5, the backdrop is darkened, as if it were multiplied; 
	    * this is useful for adding shadows to a scene. 
	    * 
	    * The degree of lightening or darkening is proportional to the difference between the source color and 0.5; 
	    * if it is equal to 0.5, the backdrop is unchanged.
	    * 
	    * Painting with pure black or white produces pure black or white. The effect is similar to shining a harsh spotlight on the backdrop. 
	    *
	    * @method Phaser.Color.blendHardLight
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendHardLight:function blendHardLight(a,b){return Phaser.Color.blendOverlay(b,a);},/**
	    * Brightens the backdrop color to reflect the source color. 
	    * Painting with black produces no change.
	    *
	    * @method Phaser.Color.blendColorDodge
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendColorDodge:function blendColorDodge(a,b){return b===255?b:Math.min(255,(a<<8)/(255-b));},/**
	    * Darkens the backdrop color to reflect the source color.
	    * Painting with white produces no change. 
	    *
	    * @method Phaser.Color.blendColorBurn
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendColorBurn:function blendColorBurn(a,b){return b===0?b:Math.max(0,255-(255-a<<8)/b);},/**
	    * An alias for blendAdd, it simply sums the values of the two colors.
	    *
	    * @method Phaser.Color.blendLinearDodge
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendLinearDodge:function blendLinearDodge(a,b){return Phaser.Color.blendAdd(a,b);},/**
	    * An alias for blendSubtract, it simply sums the values of the two colors and subtracts 255.
	    *
	    * @method Phaser.Color.blendLinearBurn
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendLinearBurn:function blendLinearBurn(a,b){return Phaser.Color.blendSubtract(a,b);},/**
	    * This blend mode combines Linear Dodge and Linear Burn (rescaled so that neutral colors become middle gray).
	    * Dodge applies to values of top layer lighter than middle gray, and burn to darker values.
	    * The calculation simplifies to the sum of bottom layer and twice the top layer, subtract 128. The contrast decreases.
	    *
	    * @method Phaser.Color.blendLinearLight
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendLinearLight:function blendLinearLight(a,b){return b<128?Phaser.Color.blendLinearBurn(a,2*b):Phaser.Color.blendLinearDodge(a,2*(b-128));},/**
	    * This blend mode combines Color Dodge and Color Burn (rescaled so that neutral colors become middle gray).
	    * Dodge applies when values in the top layer are lighter than middle gray, and burn to darker values.
	    * The middle gray is the neutral color. When color is lighter than this, this effectively moves the white point of the bottom 
	    * layer down by twice the difference; when it is darker, the black point is moved up by twice the difference. The perceived contrast increases.
	    *
	    * @method Phaser.Color.blendVividLight
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendVividLight:function blendVividLight(a,b){return b<128?Phaser.Color.blendColorBurn(a,2*b):Phaser.Color.blendColorDodge(a,2*(b-128));},/**
	    * If the backdrop color (light source) is lighter than 50%, the blendDarken mode is used, and colors lighter than the backdrop color do not change.
	    * If the backdrop color is darker than 50% gray, colors lighter than the blend color are replaced, and colors darker than the blend color do not change.
	    *
	    * @method Phaser.Color.blendPinLight
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendPinLight:function blendPinLight(a,b){return b<128?Phaser.Color.blendDarken(a,2*b):Phaser.Color.blendLighten(a,2*(b-128));},/**
	    * Runs blendVividLight on the source and backdrop colors.
	    * If the resulting color is 128 or more, it receives a value of 255; if less than 128, a value of 0.
	    * Therefore, all blended pixels have red, green, and blue channel values of either 0 or 255.
	    * This changes all pixels to primary additive colors (red, green, or blue), white, or black.
	    *
	    * @method Phaser.Color.blendHardMix
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendHardMix:function blendHardMix(a,b){return Phaser.Color.blendVividLight(a,b)<128?0:255;},/**
	    * Reflect blend mode. This mode is useful when adding shining objects or light zones to images. 
	    *
	    * @method Phaser.Color.blendReflect
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendReflect:function blendReflect(a,b){return b===255?b:Math.min(255,a*a/(255-b));},/**
	    * Glow blend mode. This mode is a variation of reflect mode with the source and backdrop colors swapped.
	    *
	    * @method Phaser.Color.blendGlow
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendGlow:function blendGlow(a,b){return Phaser.Color.blendReflect(b,a);},/**
	    * Phoenix blend mode. This subtracts the lighter color from the darker color, and adds 255, giving a bright result.
	    *
	    * @method Phaser.Color.blendPhoenix
	    * @static
	    * @param {integer} a - The source color to blend, in the range 1 to 255.
	    * @param {integer} b - The backdrop color to blend, in the range 1 to 255.
	    * @returns {integer} The blended color value, in the range 1 to 255.
	    */blendPhoenix:function blendPhoenix(a,b){return Math.min(a,b)-Math.max(a,b)+255;}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Physics Manager is responsible for looking after all of the running physics systems.
	* Phaser supports 4 physics systems: Arcade Physics, P2, Ninja Physics and Box2D via a commercial plugin.
	* 
	* Game Objects (such as Sprites) can only belong to 1 physics system, but you can have multiple systems active in a single game.
	*
	* For example you could have P2 managing a polygon-built terrain landscape that an vehicle drives over, while it could be firing bullets that use the
	* faster (due to being much simpler) Arcade Physics system.
	*
	* @class Phaser.Physics
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {object} [physicsConfig=null] - A physics configuration object to pass to the Physics world on creation.
	*/Phaser.Physics=function(game,config){config=config||{};/**
	    * @property {Phaser.Game} game - Local reference to game.
	    */this.game=game;/**
	    * @property {object} config - The physics configuration object as passed to the game on creation.
	    */this.config=config;/**
	    * @property {Phaser.Physics.Arcade} arcade - The Arcade Physics system.
	    */this.arcade=null;/**
	    * @property {Phaser.Physics.P2} p2 - The P2.JS Physics system.
	    */this.p2=null;/**
	    * @property {Phaser.Physics.Ninja} ninja - The N+ Ninja Physics system.
	    */this.ninja=null;/**
	    * @property {Phaser.Physics.Box2D} box2d - The Box2D Physics system.
	    */this.box2d=null;/**
	    * @property {Phaser.Physics.Chipmunk} chipmunk - The Chipmunk Physics system (to be done).
	    */this.chipmunk=null;/**
	    * @property {Phaser.Physics.Matter} matter - The MatterJS Physics system (coming soon).
	    */this.matter=null;this.parseConfig();};/**
	* @const
	* @type {number}
	*/Phaser.Physics.ARCADE=0;/**
	* @const
	* @type {number}
	*/Phaser.Physics.P2JS=1;/**
	* @const
	* @type {number}
	*/Phaser.Physics.NINJA=2;/**
	* @const
	* @type {number}
	*/Phaser.Physics.BOX2D=3;/**
	* @const
	* @type {number}
	*/Phaser.Physics.CHIPMUNK=4;/**
	* @const
	* @type {number}
	*/Phaser.Physics.MATTERJS=5;Phaser.Physics.prototype={/**
	    * Parses the Physics Configuration object passed to the Game constructor and starts any physics systems specified within.
	    *
	    * @method Phaser.Physics#parseConfig
	    */parseConfig:function parseConfig(){if((!this.config.hasOwnProperty('arcade')||this.config['arcade']===true)&&Phaser.Physics.hasOwnProperty('Arcade')){//  If Arcade isn't specified, we create it automatically if we can
	this.arcade=new Phaser.Physics.Arcade(this.game);}if(this.config.hasOwnProperty('ninja')&&this.config['ninja']===true&&Phaser.Physics.hasOwnProperty('Ninja')){this.ninja=new Phaser.Physics.Ninja(this.game);}if(this.config.hasOwnProperty('p2')&&this.config['p2']===true&&Phaser.Physics.hasOwnProperty('P2')){this.p2=new Phaser.Physics.P2(this.game,this.config);}if(this.config.hasOwnProperty('box2d')&&this.config['box2d']===true&&Phaser.Physics.hasOwnProperty('BOX2D')){this.box2d=new Phaser.Physics.BOX2D(this.game,this.config);}if(this.config.hasOwnProperty('matter')&&this.config['matter']===true&&Phaser.Physics.hasOwnProperty('Matter')){this.matter=new Phaser.Physics.Matter(this.game,this.config);}},/**
	    * This will create an instance of the requested physics simulation.
	    * Phaser.Physics.Arcade is running by default, but all others need activating directly.
	    * 
	    * You can start the following physics systems:
	    * 
	    * Phaser.Physics.P2JS - A full-body advanced physics system by Stefan Hedman.
	    * Phaser.Physics.NINJA - A port of Metanet Softwares N+ physics system.
	    * Phaser.Physics.BOX2D - A commercial Phaser Plugin (see http://phaser.io)
	    *
	    * Both Ninja Physics and Box2D require their respective plugins to be loaded before you can start them.
	    * They are not bundled into the core Phaser library.
	    *
	    * If the physics world has already been created (i.e. in another state in your game) then 
	    * calling startSystem will reset the physics world, not re-create it. If you need to start them again from their constructors 
	    * then set Phaser.Physics.p2 (or whichever system you want to recreate) to `null` before calling `startSystem`.
	    *
	    * @method Phaser.Physics#startSystem
	    * @param {number} system - The physics system to start: Phaser.Physics.ARCADE, Phaser.Physics.P2JS, Phaser.Physics.NINJA or Phaser.Physics.BOX2D.
	    */startSystem:function startSystem(system){if(system===Phaser.Physics.ARCADE){this.arcade=new Phaser.Physics.Arcade(this.game);}else if(system===Phaser.Physics.P2JS){if(this.p2===null){this.p2=new Phaser.Physics.P2(this.game,this.config);}else{this.p2.reset();}}else if(system===Phaser.Physics.NINJA){this.ninja=new Phaser.Physics.Ninja(this.game);}else if(system===Phaser.Physics.BOX2D){if(this.box2d===null){this.box2d=new Phaser.Physics.Box2D(this.game,this.config);}else{this.box2d.reset();}}else if(system===Phaser.Physics.MATTERJS){if(this.matter===null){this.matter=new Phaser.Physics.Matter(this.game,this.config);}else{this.matter.reset();}}},/**
	    * This will create a default physics body on the given game object or array of objects.
	    * A game object can only have 1 physics body active at any one time, and it can't be changed until the object is destroyed.
	    * It can be for any of the physics systems that have been started:
	    *
	    * Phaser.Physics.Arcade - A light weight AABB based collision system with basic separation.
	    * Phaser.Physics.P2JS - A full-body advanced physics system supporting multiple object shapes, polygon loading, contact materials, springs and constraints.
	    * Phaser.Physics.NINJA - A port of Metanet Softwares N+ physics system. Advanced AABB and Circle vs. Tile collision.
	    * Phaser.Physics.BOX2D - A port of https://code.google.com/p/box2d-html5
	    * Phaser.Physics.MATTER - A full-body and light-weight advanced physics system (still in development)
	    * Phaser.Physics.CHIPMUNK is still in development.
	    *
	    * If you require more control over what type of body is created, for example to create a Ninja Physics Circle instead of the default AABB, then see the
	    * individual physics systems `enable` methods instead of using this generic one.
	    *
	    * @method Phaser.Physics#enable
	    * @param {object|array} object - The game object to create the physics body on. Can also be an array of objects, a body will be created on every object in the array.
	    * @param {number} [system=Phaser.Physics.ARCADE] - The physics system that will be used to create the body. Defaults to Arcade Physics.
	    * @param {boolean} [debug=false] - Enable the debug drawing for this body. Defaults to false.
	    */enable:function enable(object,system,debug){if(system===undefined){system=Phaser.Physics.ARCADE;}if(debug===undefined){debug=false;}if(system===Phaser.Physics.ARCADE){this.arcade.enable(object);}else if(system===Phaser.Physics.P2JS&&this.p2){this.p2.enable(object,debug);}else if(system===Phaser.Physics.NINJA&&this.ninja){this.ninja.enableAABB(object);}else if(system===Phaser.Physics.BOX2D&&this.box2d){this.box2d.enable(object);}else if(system===Phaser.Physics.MATTERJS&&this.matter){this.matter.enable(object);}else{console.warn(object.key+' is attempting to enable a physics body using an unknown physics system.');}},/**
	    * preUpdate checks.
	    *
	    * @method Phaser.Physics#preUpdate
	    * @protected
	    */preUpdate:function preUpdate(){//  ArcadePhysics / Ninja don't have a core to preUpdate
	if(this.p2){this.p2.preUpdate();}if(this.box2d){this.box2d.preUpdate();}if(this.matter){this.matter.preUpdate();}},/**
	    * Updates all running physics systems.
	    *
	    * @method Phaser.Physics#update
	    * @protected
	    */update:function update(){//  ArcadePhysics / Ninja don't have a core to update
	if(this.p2){this.p2.update();}if(this.box2d){this.box2d.update();}if(this.matter){this.matter.update();}},/**
	    * Updates the physics bounds to match the world dimensions.
	    *
	    * @method Phaser.Physics#setBoundsToWorld
	    * @protected
	    */setBoundsToWorld:function setBoundsToWorld(){if(this.arcade){this.arcade.setBoundsToWorld();}if(this.ninja){this.ninja.setBoundsToWorld();}if(this.p2){this.p2.setBoundsToWorld();}if(this.box2d){this.box2d.setBoundsToWorld();}if(this.matter){this.matter.setBoundsToWorld();}},/**
	    * Clears down all active physics systems. This doesn't destroy them, it just clears them of objects and is called when the State changes.
	    *
	    * @method Phaser.Physics#clear
	    * @protected
	    */clear:function clear(){if(this.p2){this.p2.clear();}if(this.box2d){this.box2d.clear();}if(this.matter){this.matter.clear();}},/**
	    * Resets the active physics system. Called automatically on a Phaser.State swap.
	    *
	    * @method Phaser.Physics#reset
	    * @protected
	    */reset:function reset(){if(this.p2){this.p2.reset();}if(this.box2d){this.box2d.reset();}if(this.matter){this.matter.reset();}},/**
	    * Destroys all active physics systems. Usually only called on a Game Shutdown, not on a State swap.
	    *
	    * @method Phaser.Physics#destroy
	    */destroy:function destroy(){if(this.p2){this.p2.destroy();}if(this.box2d){this.box2d.destroy();}if(this.matter){this.matter.destroy();}this.arcade=null;this.ninja=null;this.p2=null;this.box2d=null;this.matter=null;}};Phaser.Physics.prototype.constructor=Phaser.Physics;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Arcade Physics world. Contains Arcade Physics related collision, overlap and motion methods.
	*
	* @class Phaser.Physics.Arcade
	* @constructor
	* @param {Phaser.Game} game - reference to the current game instance.
	*/Phaser.Physics.Arcade=function(game){/**
	    * @property {Phaser.Game} game - Local reference to game.
	    */this.game=game;/**
	    * @property {Phaser.Point} gravity - The World gravity setting. Defaults to x: 0, y: 0, or no gravity.
	    */this.gravity=new Phaser.Point();/**
	    * @property {Phaser.Rectangle} bounds - The bounds inside of which the physics world exists. Defaults to match the world bounds.
	    */this.bounds=new Phaser.Rectangle(0,0,game.world.width,game.world.height);/**
	    * Set the checkCollision properties to control for which bounds collision is processed.
	    * For example checkCollision.down = false means Bodies cannot collide with the World.bounds.bottom.
	    * @property {object} checkCollision - An object containing allowed collision flags.
	    */this.checkCollision={up:true,down:true,left:true,right:true};/**
	    * @property {number} maxObjects - Used by the QuadTree to set the maximum number of objects per quad.
	    */this.maxObjects=10;/**
	    * @property {number} maxLevels - Used by the QuadTree to set the maximum number of iteration levels.
	    */this.maxLevels=4;/**
	    * @property {number} OVERLAP_BIAS - A value added to the delta values during collision checks.
	    */this.OVERLAP_BIAS=4;/**
	    * @property {boolean} forceX - If true World.separate will always separate on the X axis before Y. Otherwise it will check gravity totals first.
	    */this.forceX=false;/**
	    * @property {number} sortDirection - Used when colliding a Sprite vs. a Group, or a Group vs. a Group, this defines the direction the sort is based on. Default is Phaser.Physics.Arcade.LEFT_RIGHT.
	    * @default
	    */this.sortDirection=Phaser.Physics.Arcade.LEFT_RIGHT;/**
	    * @property {boolean} skipQuadTree - If true the QuadTree will not be used for any collision. QuadTrees are great if objects are well spread out in your game, otherwise they are a performance hit. If you enable this you can disable on a per body basis via `Body.skipQuadTree`.
	    */this.skipQuadTree=true;/**
	    * @property {boolean} isPaused - If `true` the `Body.preUpdate` method will be skipped, halting all motion for all bodies. Note that other methods such as `collide` will still work, so be careful not to call them on paused bodies.
	    */this.isPaused=false;/**
	    * @property {Phaser.QuadTree} quadTree - The world QuadTree.
	    */this.quadTree=new Phaser.QuadTree(this.game.world.bounds.x,this.game.world.bounds.y,this.game.world.bounds.width,this.game.world.bounds.height,this.maxObjects,this.maxLevels);/**
	    * @property {number} _total - Internal cache var.
	    * @private
	    */this._total=0;// By default we want the bounds the same size as the world bounds
	this.setBoundsToWorld();};Phaser.Physics.Arcade.prototype.constructor=Phaser.Physics.Arcade;/**
	* A constant used for the sortDirection value.
	* Use this if you don't wish to perform any pre-collision sorting at all, or will manually sort your Groups.
	* @constant
	* @type {number}
	*/Phaser.Physics.Arcade.SORT_NONE=0;/**
	* A constant used for the sortDirection value.
	* Use this if your game world is wide but short and scrolls from the left to the right (i.e. Mario)
	* @constant
	* @type {number}
	*/Phaser.Physics.Arcade.LEFT_RIGHT=1;/**
	* A constant used for the sortDirection value.
	* Use this if your game world is wide but short and scrolls from the right to the left (i.e. Mario backwards)
	* @constant
	* @type {number}
	*/Phaser.Physics.Arcade.RIGHT_LEFT=2;/**
	* A constant used for the sortDirection value.
	* Use this if your game world is narrow but tall and scrolls from the top to the bottom (i.e. Dig Dug)
	* @constant
	* @type {number}
	*/Phaser.Physics.Arcade.TOP_BOTTOM=3;/**
	* A constant used for the sortDirection value.
	* Use this if your game world is narrow but tall and scrolls from the bottom to the top (i.e. Commando or a vertically scrolling shoot-em-up)
	* @constant
	* @type {number}
	*/Phaser.Physics.Arcade.BOTTOM_TOP=4;Phaser.Physics.Arcade.prototype={/**
	    * Updates the size of this physics world.
	    *
	    * @method Phaser.Physics.Arcade#setBounds
	    * @param {number} x - Top left most corner of the world.
	    * @param {number} y - Top left most corner of the world.
	    * @param {number} width - New width of the world. Can never be smaller than the Game.width.
	    * @param {number} height - New height of the world. Can never be smaller than the Game.height.
	    */setBounds:function setBounds(x,y,width,height){this.bounds.setTo(x,y,width,height);},/**
	    * Updates the size of this physics world to match the size of the game world.
	    *
	    * @method Phaser.Physics.Arcade#setBoundsToWorld
	    */setBoundsToWorld:function setBoundsToWorld(){this.bounds.copyFrom(this.game.world.bounds);},/**
	    * This will create an Arcade Physics body on the given game object or array of game objects.
	    * A game object can only have 1 physics body active at any one time, and it can't be changed until the object is destroyed.
	    *
	    * @method Phaser.Physics.Arcade#enable
	    * @param {object|array|Phaser.Group} object - The game object to create the physics body on. Can also be an array or Group of objects, a body will be created on every child that has a `body` property.
	    * @param {boolean} [children=true] - Should a body be created on all children of this object? If true it will recurse down the display list as far as it can go.
	    */enable:function enable(object,children){if(children===undefined){children=true;}var i=1;if(Array.isArray(object)){i=object.length;while(i--){if(object[i]instanceof Phaser.Group){//  If it's a Group then we do it on the children regardless
	this.enable(object[i].children,children);}else{this.enableBody(object[i]);if(children&&object[i].hasOwnProperty('children')&&object[i].children.length>0){this.enable(object[i],true);}}}}else{if(object instanceof Phaser.Group){//  If it's a Group then we do it on the children regardless
	this.enable(object.children,children);}else{this.enableBody(object);if(children&&object.hasOwnProperty('children')&&object.children.length>0){this.enable(object.children,true);}}}},/**
	    * Creates an Arcade Physics body on the given game object.
	    * 
	    * A game object can only have 1 physics body active at any one time, and it can't be changed until the body is nulled.
	    *
	    * When you add an Arcade Physics body to an object it will automatically add the object into its parent Groups hash array.
	    *
	    * @method Phaser.Physics.Arcade#enableBody
	    * @param {object} object - The game object to create the physics body on. A body will only be created if this object has a null `body` property.
	    */enableBody:function enableBody(object){if(object.hasOwnProperty('body')&&object.body===null){object.body=new Phaser.Physics.Arcade.Body(object);if(object.parent&&object.parent instanceof Phaser.Group){object.parent.addToHash(object);}}},/**
	    * Called automatically by a Physics body, it updates all motion related values on the Body unless `World.isPaused` is `true`.
	    *
	    * @method Phaser.Physics.Arcade#updateMotion
	    * @param {Phaser.Physics.Arcade.Body} The Body object to be updated.
	    */updateMotion:function updateMotion(body){var velocityDelta=this.computeVelocity(0,body,body.angularVelocity,body.angularAcceleration,body.angularDrag,body.maxAngular)-body.angularVelocity;body.angularVelocity+=velocityDelta;body.rotation+=body.angularVelocity*this.game.time.physicsElapsed;body.velocity.x=this.computeVelocity(1,body,body.velocity.x,body.acceleration.x,body.drag.x,body.maxVelocity.x);body.velocity.y=this.computeVelocity(2,body,body.velocity.y,body.acceleration.y,body.drag.y,body.maxVelocity.y);},/**
	    * A tween-like function that takes a starting velocity and some other factors and returns an altered velocity.
	    * Based on a function in Flixel by @ADAMATOMIC
	    *
	    * @method Phaser.Physics.Arcade#computeVelocity
	    * @param {number} axis - 0 for nothing, 1 for horizontal, 2 for vertical.
	    * @param {Phaser.Physics.Arcade.Body} body - The Body object to be updated.
	    * @param {number} velocity - Any component of velocity (e.g. 20).
	    * @param {number} acceleration - Rate at which the velocity is changing.
	    * @param {number} drag - Really kind of a deceleration, this is how much the velocity changes if Acceleration is not set.
	    * @param {number} [max=10000] - An absolute value cap for the velocity.
	    * @return {number} The altered Velocity value.
	    */computeVelocity:function computeVelocity(axis,body,velocity,acceleration,drag,max){if(max===undefined){max=10000;}if(axis===1&&body.allowGravity){velocity+=(this.gravity.x+body.gravity.x)*this.game.time.physicsElapsed;}else if(axis===2&&body.allowGravity){velocity+=(this.gravity.y+body.gravity.y)*this.game.time.physicsElapsed;}if(acceleration){velocity+=acceleration*this.game.time.physicsElapsed;}else if(drag){drag*=this.game.time.physicsElapsed;if(velocity-drag>0){velocity-=drag;}else if(velocity+drag<0){velocity+=drag;}else{velocity=0;}}if(velocity>max){velocity=max;}else if(velocity<-max){velocity=-max;}return velocity;},/**
	    * Checks for overlaps between two game objects. The objects can be Sprites, Groups or Emitters.
	    * You can perform Sprite vs. Sprite, Sprite vs. Group and Group vs. Group overlap checks.
	    * Unlike collide the objects are NOT automatically separated or have any physics applied, they merely test for overlap results.
	    * Both the first and second parameter can be arrays of objects, of differing types.
	    * If two arrays are passed, the contents of the first parameter will be tested against all contents of the 2nd parameter.
	    * NOTE: This function is not recursive, and will not test against children of objects passed (i.e. Groups within Groups).
	    *
	    * @method Phaser.Physics.Arcade#overlap
	    * @param {Phaser.Sprite|Phaser.Group|Phaser.Particles.Emitter|array} object1 - The first object or array of objects to check. Can be Phaser.Sprite, Phaser.Group or Phaser.Particles.Emitter.
	    * @param {Phaser.Sprite|Phaser.Group|Phaser.Particles.Emitter|array} object2 - The second object or array of objects to check. Can be Phaser.Sprite, Phaser.Group or Phaser.Particles.Emitter.
	    * @param {function} [overlapCallback=null] - An optional callback function that is called if the objects overlap. The two objects will be passed to this function in the same order in which you specified them, unless you are checking Group vs. Sprite, in which case Sprite will always be the first parameter.
	    * @param {function} [processCallback=null] - A callback function that lets you perform additional checks against the two objects if they overlap. If this is set then `overlapCallback` will only be called if this callback returns `true`.
	    * @param {object} [callbackContext] - The context in which to run the callbacks.
	    * @return {boolean} True if an overlap occurred otherwise false.
	    */overlap:function overlap(object1,object2,overlapCallback,processCallback,callbackContext){overlapCallback=overlapCallback||null;processCallback=processCallback||null;callbackContext=callbackContext||overlapCallback;this._total=0;if(!Array.isArray(object1)&&Array.isArray(object2)){for(var i=0;i<object2.length;i++){this.collideHandler(object1,object2[i],overlapCallback,processCallback,callbackContext,true);}}else if(Array.isArray(object1)&&!Array.isArray(object2)){for(var i=0;i<object1.length;i++){this.collideHandler(object1[i],object2,overlapCallback,processCallback,callbackContext,true);}}else if(Array.isArray(object1)&&Array.isArray(object2)){for(var i=0;i<object1.length;i++){for(var j=0;j<object2.length;j++){this.collideHandler(object1[i],object2[j],overlapCallback,processCallback,callbackContext,true);}}}else{this.collideHandler(object1,object2,overlapCallback,processCallback,callbackContext,true);}return this._total>0;},/**
	    * Checks for collision between two game objects. You can perform Sprite vs. Sprite, Sprite vs. Group, Group vs. Group, Sprite vs. Tilemap Layer or Group vs. Tilemap Layer collisions.
	    * Both the first and second parameter can be arrays of objects, of differing types.
	    * If two arrays are passed, the contents of the first parameter will be tested against all contents of the 2nd parameter.
	    * The objects are also automatically separated. If you don't require separation then use ArcadePhysics.overlap instead.
	    * An optional processCallback can be provided. If given this function will be called when two sprites are found to be colliding. It is called before any separation takes place,
	    * giving you the chance to perform additional checks. If the function returns true then the collision and separation is carried out. If it returns false it is skipped.
	    * The collideCallback is an optional function that is only called if two sprites collide. If a processCallback has been set then it needs to return true for collideCallback to be called.
	    * NOTE: This function is not recursive, and will not test against children of objects passed (i.e. Groups or Tilemaps within other Groups).
	    *
	    * @method Phaser.Physics.Arcade#collide
	    * @param {Phaser.Sprite|Phaser.Group|Phaser.Particles.Emitter|Phaser.TilemapLayer|array} object1 - The first object or array of objects to check. Can be Phaser.Sprite, Phaser.Group, Phaser.Particles.Emitter, or Phaser.TilemapLayer.
	    * @param {Phaser.Sprite|Phaser.Group|Phaser.Particles.Emitter|Phaser.TilemapLayer|array} object2 - The second object or array of objects to check. Can be Phaser.Sprite, Phaser.Group, Phaser.Particles.Emitter or Phaser.TilemapLayer.
	    * @param {function} [collideCallback=null] - An optional callback function that is called if the objects collide. The two objects will be passed to this function in the same order in which you specified them, unless you are colliding Group vs. Sprite, in which case Sprite will always be the first parameter.
	    * @param {function} [processCallback=null] - A callback function that lets you perform additional checks against the two objects if they overlap. If this is set then collision will only happen if processCallback returns true. The two objects will be passed to this function in the same order in which you specified them, unless you are colliding Group vs. Sprite, in which case Sprite will always be the first parameter.
	    * @param {object} [callbackContext] - The context in which to run the callbacks.
	    * @return {boolean} True if a collision occurred otherwise false.
	    */collide:function collide(object1,object2,collideCallback,processCallback,callbackContext){collideCallback=collideCallback||null;processCallback=processCallback||null;callbackContext=callbackContext||collideCallback;this._total=0;if(!Array.isArray(object1)&&Array.isArray(object2)){for(var i=0;i<object2.length;i++){this.collideHandler(object1,object2[i],collideCallback,processCallback,callbackContext,false);}}else if(Array.isArray(object1)&&!Array.isArray(object2)){for(var i=0;i<object1.length;i++){this.collideHandler(object1[i],object2,collideCallback,processCallback,callbackContext,false);}}else if(Array.isArray(object1)&&Array.isArray(object2)){for(var i=0;i<object1.length;i++){for(var j=0;j<object2.length;j++){this.collideHandler(object1[i],object2[j],collideCallback,processCallback,callbackContext,false);}}}else{this.collideHandler(object1,object2,collideCallback,processCallback,callbackContext,false);}return this._total>0;},/**
	     * A Sort function for sorting two bodies based on a LEFT to RIGHT sort direction.
	     *
	     * This is called automatically by World.sort
	     *
	     * @method Phaser.Physics.Arcade#sortLeftRight
	     * @param {Phaser.Sprite} a - The first Sprite to test. The Sprite must have an Arcade Physics Body.
	     * @param {Phaser.Sprite} b - The second Sprite to test. The Sprite must have an Arcade Physics Body.
	     * @return {integer} A negative value if `a > b`, a positive value if `a < b` or 0 if `a === b` or the bodies are invalid.
	     */sortLeftRight:function sortLeftRight(a,b){if(!a.body||!b.body){return 0;}return a.body.x-b.body.x;},/**
	     * A Sort function for sorting two bodies based on a RIGHT to LEFT sort direction.
	     *
	     * This is called automatically by World.sort
	     *
	     * @method Phaser.Physics.Arcade#sortRightLeft
	     * @param {Phaser.Sprite} a - The first Sprite to test. The Sprite must have an Arcade Physics Body.
	     * @param {Phaser.Sprite} b - The second Sprite to test. The Sprite must have an Arcade Physics Body.
	     * @return {integer} A negative value if `a > b`, a positive value if `a < b` or 0 if `a === b` or the bodies are invalid.
	     */sortRightLeft:function sortRightLeft(a,b){if(!a.body||!b.body){return 0;}return b.body.x-a.body.x;},/**
	     * A Sort function for sorting two bodies based on a TOP to BOTTOM sort direction.
	     *
	     * This is called automatically by World.sort
	     *
	     * @method Phaser.Physics.Arcade#sortTopBottom
	     * @param {Phaser.Sprite} a - The first Sprite to test. The Sprite must have an Arcade Physics Body.
	     * @param {Phaser.Sprite} b - The second Sprite to test. The Sprite must have an Arcade Physics Body.
	     * @return {integer} A negative value if `a > b`, a positive value if `a < b` or 0 if `a === b` or the bodies are invalid.
	     */sortTopBottom:function sortTopBottom(a,b){if(!a.body||!b.body){return 0;}return a.body.y-b.body.y;},/**
	     * A Sort function for sorting two bodies based on a BOTTOM to TOP sort direction.
	     *
	     * This is called automatically by World.sort
	     *
	     * @method Phaser.Physics.Arcade#sortBottomTop
	     * @param {Phaser.Sprite} a - The first Sprite to test. The Sprite must have an Arcade Physics Body.
	     * @param {Phaser.Sprite} b - The second Sprite to test. The Sprite must have an Arcade Physics Body.
	     * @return {integer} A negative value if `a > b`, a positive value if `a < b` or 0 if `a === b` or the bodies are invalid.
	     */sortBottomTop:function sortBottomTop(a,b){if(!a.body||!b.body){return 0;}return b.body.y-a.body.y;},/**
	     * This method will sort a Groups hash array.
	     *
	     * If the Group has `physicsSortDirection` set it will use the sort direction defined.
	     *
	     * Otherwise if the sortDirection parameter is undefined, or Group.physicsSortDirection is null, it will use Phaser.Physics.Arcade.sortDirection.
	     *
	     * By changing Group.physicsSortDirection you can customise each Group to sort in a different order.
	     *
	     * @method Phaser.Physics.Arcade#sort
	     * @param {Phaser.Group} group - The Group to sort.
	     * @param {integer} [sortDirection] - The sort direction used to sort this Group.
	     */sort:function sort(group,sortDirection){if(group.physicsSortDirection!==null){sortDirection=group.physicsSortDirection;}else{if(sortDirection===undefined){sortDirection=this.sortDirection;}}if(sortDirection===Phaser.Physics.Arcade.LEFT_RIGHT){//  Game world is say 2000x600 and you start at 0
	group.hash.sort(this.sortLeftRight);}else if(sortDirection===Phaser.Physics.Arcade.RIGHT_LEFT){//  Game world is say 2000x600 and you start at 2000
	group.hash.sort(this.sortRightLeft);}else if(sortDirection===Phaser.Physics.Arcade.TOP_BOTTOM){//  Game world is say 800x2000 and you start at 0
	group.hash.sort(this.sortTopBottom);}else if(sortDirection===Phaser.Physics.Arcade.BOTTOM_TOP){//  Game world is say 800x2000 and you start at 2000
	group.hash.sort(this.sortBottomTop);}},/**
	    * Internal collision handler.
	    *
	    * @method Phaser.Physics.Arcade#collideHandler
	    * @private
	    * @param {Phaser.Sprite|Phaser.Group|Phaser.Particles.Emitter|Phaser.TilemapLayer} object1 - The first object to check. Can be an instance of Phaser.Sprite, Phaser.Group, Phaser.Particles.Emitter, or Phaser.TilemapLayer.
	    * @param {Phaser.Sprite|Phaser.Group|Phaser.Particles.Emitter|Phaser.TilemapLayer} object2 - The second object to check. Can be an instance of Phaser.Sprite, Phaser.Group, Phaser.Particles.Emitter or Phaser.TilemapLayer. Can also be an array of objects to check.
	    * @param {function} collideCallback - An optional callback function that is called if the objects collide. The two objects will be passed to this function in the same order in which you specified them.
	    * @param {function} processCallback - A callback function that lets you perform additional checks against the two objects if they overlap. If this is set then collision will only happen if processCallback returns true. The two objects will be passed to this function in the same order in which you specified them.
	    * @param {object} callbackContext - The context in which to run the callbacks.
	    * @param {boolean} overlapOnly - Just run an overlap or a full collision.
	    */collideHandler:function collideHandler(object1,object2,collideCallback,processCallback,callbackContext,overlapOnly){//  Only collide valid objects
	if(object2===undefined&&object1.physicsType===Phaser.GROUP){this.sort(object1);this.collideGroupVsSelf(object1,collideCallback,processCallback,callbackContext,overlapOnly);return;}//  If neither of the objects are set or exist then bail out
	if(!object1||!object2||!object1.exists||!object2.exists){return;}//  Groups? Sort them
	if(this.sortDirection!==Phaser.Physics.Arcade.SORT_NONE){if(object1.physicsType===Phaser.GROUP){this.sort(object1);}if(object2.physicsType===Phaser.GROUP){this.sort(object2);}}//  SPRITES
	if(object1.physicsType===Phaser.SPRITE){if(object2.physicsType===Phaser.SPRITE){this.collideSpriteVsSprite(object1,object2,collideCallback,processCallback,callbackContext,overlapOnly);}else if(object2.physicsType===Phaser.GROUP){this.collideSpriteVsGroup(object1,object2,collideCallback,processCallback,callbackContext,overlapOnly);}else if(object2.physicsType===Phaser.TILEMAPLAYER){this.collideSpriteVsTilemapLayer(object1,object2,collideCallback,processCallback,callbackContext,overlapOnly);}}//  GROUPS
	else if(object1.physicsType===Phaser.GROUP){if(object2.physicsType===Phaser.SPRITE){this.collideSpriteVsGroup(object2,object1,collideCallback,processCallback,callbackContext,overlapOnly);}else if(object2.physicsType===Phaser.GROUP){this.collideGroupVsGroup(object1,object2,collideCallback,processCallback,callbackContext,overlapOnly);}else if(object2.physicsType===Phaser.TILEMAPLAYER){this.collideGroupVsTilemapLayer(object1,object2,collideCallback,processCallback,callbackContext,overlapOnly);}}//  TILEMAP LAYERS
	else if(object1.physicsType===Phaser.TILEMAPLAYER){if(object2.physicsType===Phaser.SPRITE){this.collideSpriteVsTilemapLayer(object2,object1,collideCallback,processCallback,callbackContext,overlapOnly);}else if(object2.physicsType===Phaser.GROUP){this.collideGroupVsTilemapLayer(object2,object1,collideCallback,processCallback,callbackContext,overlapOnly);}}},/**
	    * An internal function. Use Phaser.Physics.Arcade.collide instead.
	    *
	    * @method Phaser.Physics.Arcade#collideSpriteVsSprite
	    * @private
	    * @param {Phaser.Sprite} sprite1 - The first sprite to check.
	    * @param {Phaser.Sprite} sprite2 - The second sprite to check.
	    * @param {function} collideCallback - An optional callback function that is called if the objects collide. The two objects will be passed to this function in the same order in which you specified them.
	    * @param {function} processCallback - A callback function that lets you perform additional checks against the two objects if they overlap. If this is set then collision will only happen if processCallback returns true. The two objects will be passed to this function in the same order in which you specified them.
	    * @param {object} callbackContext - The context in which to run the callbacks.
	    * @param {boolean} overlapOnly - Just run an overlap or a full collision.
	    * @return {boolean} True if there was a collision, otherwise false.
	    */collideSpriteVsSprite:function collideSpriteVsSprite(sprite1,sprite2,collideCallback,processCallback,callbackContext,overlapOnly){if(!sprite1.body||!sprite2.body){return false;}if(this.separate(sprite1.body,sprite2.body,processCallback,callbackContext,overlapOnly)){if(collideCallback){collideCallback.call(callbackContext,sprite1,sprite2);}this._total++;}return true;},/**
	    * An internal function. Use Phaser.Physics.Arcade.collide instead.
	    *
	    * @method Phaser.Physics.Arcade#collideSpriteVsGroup
	    * @private
	    * @param {Phaser.Sprite} sprite - The sprite to check.
	    * @param {Phaser.Group} group - The Group to check.
	    * @param {function} collideCallback - An optional callback function that is called if the objects collide. The two objects will be passed to this function in the same order in which you specified them.
	    * @param {function} processCallback - A callback function that lets you perform additional checks against the two objects if they overlap. If this is set then collision will only happen if processCallback returns true. The two objects will be passed to this function in the same order in which you specified them.
	    * @param {object} callbackContext - The context in which to run the callbacks.
	    * @param {boolean} overlapOnly - Just run an overlap or a full collision.
	    */collideSpriteVsGroup:function collideSpriteVsGroup(sprite,group,collideCallback,processCallback,callbackContext,overlapOnly){if(group.length===0||!sprite.body){return;}if(this.skipQuadTree||sprite.body.skipQuadTree){var bounds={};for(var i=0;i<group.hash.length;i++){var object1=group.hash[i];//  Skip duff entries - we can't check a non-existent sprite or one with no body
	if(!object1||!object1.exists||!object1.body){continue;}//  Inject the Body bounds data into the bounds object
	bounds=object1.body.getBounds(bounds);//  Skip items either side of the sprite
	if(this.sortDirection===Phaser.Physics.Arcade.LEFT_RIGHT){if(sprite.body.right<bounds.x){break;}else if(bounds.right<sprite.body.x){continue;}}else if(this.sortDirection===Phaser.Physics.Arcade.RIGHT_LEFT){if(sprite.body.x>bounds.right){break;}else if(bounds.x>sprite.body.right){continue;}}else if(this.sortDirection===Phaser.Physics.Arcade.TOP_BOTTOM){if(sprite.body.bottom<bounds.y){break;}else if(bounds.bottom<sprite.body.y){continue;}}else if(this.sortDirection===Phaser.Physics.Arcade.BOTTOM_TOP){if(sprite.body.y>bounds.bottom){break;}else if(bounds.y>sprite.body.bottom){continue;}}this.collideSpriteVsSprite(sprite,object1,collideCallback,processCallback,callbackContext,overlapOnly);}}else{//  What is the sprite colliding with in the quadtree?
	this.quadTree.clear();this.quadTree.reset(this.game.world.bounds.x,this.game.world.bounds.y,this.game.world.bounds.width,this.game.world.bounds.height,this.maxObjects,this.maxLevels);this.quadTree.populate(group);var items=this.quadTree.retrieve(sprite);for(var i=0;i<items.length;i++){//  We have our potential suspects, are they in this group?
	if(this.separate(sprite.body,items[i],processCallback,callbackContext,overlapOnly)){if(collideCallback){collideCallback.call(callbackContext,sprite,items[i].sprite);}this._total++;}}}},/**
	    * An internal function. Use Phaser.Physics.Arcade.collide instead.
	    *
	    * @method Phaser.Physics.Arcade#collideGroupVsSelf
	    * @private
	    * @param {Phaser.Group} group - The Group to check.
	    * @param {function} collideCallback - An optional callback function that is called if the objects collide. The two objects will be passed to this function in the same order in which you specified them.
	    * @param {function} processCallback - A callback function that lets you perform additional checks against the two objects if they overlap. If this is set then collision will only happen if processCallback returns true. The two objects will be passed to this function in the same order in which you specified them.
	    * @param {object} callbackContext - The context in which to run the callbacks.
	    * @param {boolean} overlapOnly - Just run an overlap or a full collision.
	    * @return {boolean} True if there was a collision, otherwise false.
	    */collideGroupVsSelf:function collideGroupVsSelf(group,collideCallback,processCallback,callbackContext,overlapOnly){if(group.length===0){return;}for(var i=0;i<group.hash.length;i++){var bounds1={};var object1=group.hash[i];//  Skip duff entries - we can't check a non-existent sprite or one with no body
	if(!object1||!object1.exists||!object1.body){continue;}//  Inject the Body bounds data into the bounds1 object
	bounds1=object1.body.getBounds(bounds1);for(var j=i+1;j<group.hash.length;j++){var bounds2={};var object2=group.hash[j];//  Skip duff entries - we can't check a non-existent sprite or one with no body
	if(!object2||!object2.exists||!object2.body){continue;}//  Inject the Body bounds data into the bounds2 object
	bounds2=object2.body.getBounds(bounds2);//  Skip items either side of the sprite
	if(this.sortDirection===Phaser.Physics.Arcade.LEFT_RIGHT){if(bounds1.right<bounds2.x){break;}else if(bounds2.right<bounds1.x){continue;}}else if(this.sortDirection===Phaser.Physics.Arcade.RIGHT_LEFT){if(bounds1.x>bounds2.right){continue;}else if(bounds2.x>bounds1.right){break;}}else if(this.sortDirection===Phaser.Physics.Arcade.TOP_BOTTOM){if(bounds1.bottom<bounds2.y){continue;}else if(bounds2.bottom<bounds1.y){break;}}else if(this.sortDirection===Phaser.Physics.Arcade.BOTTOM_TOP){if(bounds1.y>bounds2.bottom){continue;}else if(bounds2.y>object1.body.bottom){break;}}this.collideSpriteVsSprite(object1,object2,collideCallback,processCallback,callbackContext,overlapOnly);}}},/**
	    * An internal function. Use Phaser.Physics.Arcade.collide instead.
	    *
	    * @method Phaser.Physics.Arcade#collideGroupVsGroup
	    * @private
	    * @param {Phaser.Group} group1 - The first Group to check.
	    * @param {Phaser.Group} group2 - The second Group to check.
	    * @param {function} collideCallback - An optional callback function that is called if the objects collide. The two objects will be passed to this function in the same order in which you specified them.
	    * @param {function} processCallback - A callback function that lets you perform additional checks against the two objects if they overlap. If this is set then collision will only happen if processCallback returns true. The two objects will be passed to this function in the same order in which you specified them.
	    * @param {object} callbackContext - The context in which to run the callbacks.
	    * @param {boolean} overlapOnly - Just run an overlap or a full collision.
	    */collideGroupVsGroup:function collideGroupVsGroup(group1,group2,collideCallback,processCallback,callbackContext,overlapOnly){if(group1.length===0||group2.length===0){return;}for(var i=0;i<group1.children.length;i++){if(group1.children[i].exists){if(group1.children[i].physicsType===Phaser.GROUP){this.collideGroupVsGroup(group1.children[i],group2,collideCallback,processCallback,callbackContext,overlapOnly);}else{this.collideSpriteVsGroup(group1.children[i],group2,collideCallback,processCallback,callbackContext,overlapOnly);}}}},/**
	    * The core separation function to separate two physics bodies.
	    *
	    * @private
	    * @method Phaser.Physics.Arcade#separate
	    * @param {Phaser.Physics.Arcade.Body} body1 - The first Body object to separate.
	    * @param {Phaser.Physics.Arcade.Body} body2 - The second Body object to separate.
	    * @param {function} [processCallback=null] - A callback function that lets you perform additional checks against the two objects if they overlap. If this function is set then the sprites will only be collided if it returns true.
	    * @param {object} [callbackContext] - The context in which to run the process callback.
	    * @param {boolean} overlapOnly - Just run an overlap or a full collision.
	    * @return {boolean} Returns true if the bodies collided, otherwise false.
	    */separate:function separate(body1,body2,processCallback,callbackContext,overlapOnly){if(!body1.enable||!body2.enable||body1.checkCollision.none||body2.checkCollision.none||!this.intersects(body1,body2)){return false;}//  They overlap. Is there a custom process callback? If it returns true then we can carry on, otherwise we should abort.
	if(processCallback&&processCallback.call(callbackContext,body1.sprite,body2.sprite)===false){return false;}//  Circle vs. Circle quick bail out
	if(body1.isCircle&&body2.isCircle){return this.separateCircle(body1,body2,overlapOnly);}// We define the behavior of bodies in a collision circle and rectangle
	// If a collision occurs in the corner points of the rectangle, the body behave like circles
	//  Either body1 or body2 is a circle
	if(body1.isCircle!==body2.isCircle){var bodyRect=body1.isCircle?body2:body1;var bodyCircle=body1.isCircle?body1:body2;var rect={x:bodyRect.x,y:bodyRect.y,right:bodyRect.right,bottom:bodyRect.bottom};var circle={x:bodyCircle.x+bodyCircle.radius,y:bodyCircle.y+bodyCircle.radius};if(circle.y<rect.y||circle.y>rect.bottom){if(circle.x<rect.x||circle.x>rect.right){return this.separateCircle(body1,body2,overlapOnly);}}}var resultX=false;var resultY=false;//  Do we separate on x or y first?
	if(this.forceX||Math.abs(this.gravity.y+body1.gravity.y)<Math.abs(this.gravity.x+body1.gravity.x)){resultX=this.separateX(body1,body2,overlapOnly);//  Are they still intersecting? Let's do the other axis then
	if(this.intersects(body1,body2)){resultY=this.separateY(body1,body2,overlapOnly);}}else{resultY=this.separateY(body1,body2,overlapOnly);//  Are they still intersecting? Let's do the other axis then
	if(this.intersects(body1,body2)){resultX=this.separateX(body1,body2,overlapOnly);}}var result=resultX||resultY;if(result){if(overlapOnly){if(body1.onOverlap){body1.onOverlap.dispatch(body1.sprite,body2.sprite);}if(body2.onOverlap){body2.onOverlap.dispatch(body2.sprite,body1.sprite);}}else{if(body1.onCollide){body1.onCollide.dispatch(body1.sprite,body2.sprite);}if(body2.onCollide){body2.onCollide.dispatch(body2.sprite,body1.sprite);}}}return result;},/**
	    * Check for intersection against two bodies.
	    *
	    * @method Phaser.Physics.Arcade#intersects
	    * @param {Phaser.Physics.Arcade.Body} body1 - The first Body object to check.
	    * @param {Phaser.Physics.Arcade.Body} body2 - The second Body object to check.
	    * @return {boolean} True if they intersect, otherwise false.
	    */intersects:function intersects(body1,body2){if(body1===body2){return false;}if(body1.isCircle){if(body2.isCircle){//  Circle vs. Circle
	return Phaser.Math.distance(body1.center.x,body1.center.y,body2.center.x,body2.center.y)<=body1.radius+body2.radius;}else{//  Circle vs. Rect
	return this.circleBodyIntersects(body1,body2);}}else{if(body2.isCircle){//  Rect vs. Circle
	return this.circleBodyIntersects(body2,body1);}else{//  Rect vs. Rect
	if(body1.right<=body2.position.x){return false;}if(body1.bottom<=body2.position.y){return false;}if(body1.position.x>=body2.right){return false;}if(body1.position.y>=body2.bottom){return false;}return true;}}},/**
	    * Checks to see if a circular Body intersects with a Rectangular Body.
	    *
	    * @method Phaser.Physics.Arcade#circleBodyIntersects
	    * @param {Phaser.Physics.Arcade.Body} circle - The Body with `isCircle` set.
	    * @param {Phaser.Physics.Arcade.Body} body - The Body with `isCircle` not set (i.e. uses Rectangle shape)
	    * @return {boolean} Returns true if the bodies intersect, otherwise false.
	    */circleBodyIntersects:function circleBodyIntersects(circle,body){var x=Phaser.Math.clamp(circle.center.x,body.left,body.right);var y=Phaser.Math.clamp(circle.center.y,body.top,body.bottom);var dx=(circle.center.x-x)*(circle.center.x-x);var dy=(circle.center.y-y)*(circle.center.y-y);return dx+dy<=circle.radius*circle.radius;},/**
	    * The core separation function to separate two circular physics bodies.
	    *
	    * @method Phaser.Physics.Arcade#separateCircle
	    * @private
	    * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to separate. Must have `Body.isCircle` true and a positive `radius`.
	    * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to separate. Must have `Body.isCircle` true and a positive `radius`.
	    * @param {boolean} overlapOnly - If true the bodies will only have their overlap data set, no separation or exchange of velocity will take place.
	    * @return {boolean} Returns true if the bodies were separated or overlap, otherwise false.
	    */separateCircle:function separateCircle(body1,body2,overlapOnly){//  Set the bounding box overlap values
	this.getOverlapX(body1,body2);this.getOverlapY(body1,body2);var dx=body2.center.x-body1.center.x;var dy=body2.center.y-body1.center.y;var angleCollision=Math.atan2(dy,dx);var overlap=0;if(body1.isCircle!==body2.isCircle){var rect={x:body2.isCircle?body1.position.x:body2.position.x,y:body2.isCircle?body1.position.y:body2.position.y,right:body2.isCircle?body1.right:body2.right,bottom:body2.isCircle?body1.bottom:body2.bottom};var circle={x:body1.isCircle?body1.position.x+body1.radius:body2.position.x+body2.radius,y:body1.isCircle?body1.position.y+body1.radius:body2.position.y+body2.radius,radius:body1.isCircle?body1.radius:body2.radius};if(circle.y<rect.y){if(circle.x<rect.x){overlap=Phaser.Math.distance(circle.x,circle.y,rect.x,rect.y)-circle.radius;}else if(circle.x>rect.right){overlap=Phaser.Math.distance(circle.x,circle.y,rect.right,rect.y)-circle.radius;}}else if(circle.y>rect.bottom){if(circle.x<rect.x){overlap=Phaser.Math.distance(circle.x,circle.y,rect.x,rect.bottom)-circle.radius;}else if(circle.x>rect.right){overlap=Phaser.Math.distance(circle.x,circle.y,rect.right,rect.bottom)-circle.radius;}}overlap*=-1;}else{overlap=body1.radius+body2.radius-Phaser.Math.distance(body1.center.x,body1.center.y,body2.center.x,body2.center.y);}//  Can't separate two immovable bodies, or a body with its own custom separation logic
	if(overlapOnly||overlap===0||body1.immovable&&body2.immovable||body1.customSeparateX||body2.customSeparateX){if(overlap!==0){if(body1.onOverlap){body1.onOverlap.dispatch(body1.sprite,body2.sprite);}if(body2.onOverlap){body2.onOverlap.dispatch(body2.sprite,body1.sprite);}}//  return true if there was some overlap, otherwise false
	return overlap!==0;}// Transform the velocity vector to the coordinate system oriented along the direction of impact.
	// This is done to eliminate the vertical component of the velocity
	var v1={x:body1.velocity.x*Math.cos(angleCollision)+body1.velocity.y*Math.sin(angleCollision),y:body1.velocity.x*Math.sin(angleCollision)-body1.velocity.y*Math.cos(angleCollision)};var v2={x:body2.velocity.x*Math.cos(angleCollision)+body2.velocity.y*Math.sin(angleCollision),y:body2.velocity.x*Math.sin(angleCollision)-body2.velocity.y*Math.cos(angleCollision)};// We expect the new velocity after impact
	var tempVel1=((body1.mass-body2.mass)*v1.x+2*body2.mass*v2.x)/(body1.mass+body2.mass);var tempVel2=(2*body1.mass*v1.x+(body2.mass-body1.mass)*v2.x)/(body1.mass+body2.mass);// We convert the vector to the original coordinate system and multiplied by factor of rebound
	if(!body1.immovable){body1.velocity.x=(tempVel1*Math.cos(angleCollision)-v1.y*Math.sin(angleCollision))*body1.bounce.x;body1.velocity.y=(v1.y*Math.cos(angleCollision)+tempVel1*Math.sin(angleCollision))*body1.bounce.y;}if(!body2.immovable){body2.velocity.x=(tempVel2*Math.cos(angleCollision)-v2.y*Math.sin(angleCollision))*body2.bounce.x;body2.velocity.y=(v2.y*Math.cos(angleCollision)+tempVel2*Math.sin(angleCollision))*body2.bounce.y;}// When the collision angle is almost perpendicular to the total initial velocity vector
	// (collision on a tangent) vector direction can be determined incorrectly.
	// This code fixes the problem
	if(Math.abs(angleCollision)<Math.PI/2){if(body1.velocity.x>0&&!body1.immovable&&body2.velocity.x>body1.velocity.x){body1.velocity.x*=-1;}else if(body2.velocity.x<0&&!body2.immovable&&body1.velocity.x<body2.velocity.x){body2.velocity.x*=-1;}else if(body1.velocity.y>0&&!body1.immovable&&body2.velocity.y>body1.velocity.y){body1.velocity.y*=-1;}else if(body2.velocity.y<0&&!body2.immovable&&body1.velocity.y<body2.velocity.y){body2.velocity.y*=-1;}}else if(Math.abs(angleCollision)>Math.PI/2){if(body1.velocity.x<0&&!body1.immovable&&body2.velocity.x<body1.velocity.x){body1.velocity.x*=-1;}else if(body2.velocity.x>0&&!body2.immovable&&body1.velocity.x>body2.velocity.x){body2.velocity.x*=-1;}else if(body1.velocity.y<0&&!body1.immovable&&body2.velocity.y<body1.velocity.y){body1.velocity.y*=-1;}else if(body2.velocity.y>0&&!body2.immovable&&body1.velocity.x>body2.velocity.y){body2.velocity.y*=-1;}}if(!body1.immovable){body1.x+=body1.velocity.x*this.game.time.physicsElapsed-overlap*Math.cos(angleCollision);body1.y+=body1.velocity.y*this.game.time.physicsElapsed-overlap*Math.sin(angleCollision);}if(!body2.immovable){body2.x+=body2.velocity.x*this.game.time.physicsElapsed+overlap*Math.cos(angleCollision);body2.y+=body2.velocity.y*this.game.time.physicsElapsed+overlap*Math.sin(angleCollision);}if(body1.onCollide){body1.onCollide.dispatch(body1.sprite,body2.sprite);}if(body2.onCollide){body2.onCollide.dispatch(body2.sprite,body1.sprite);}return true;},/**
	    * Calculates the horizontal overlap between two Bodies and sets their properties accordingly, including:
	    * `touching.left`, `touching.right` and `overlapX`.
	    *
	    * @method Phaser.Physics.Arcade#getOverlapX
	    * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to separate.
	    * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to separate.
	    * @param {boolean} overlapOnly - Is this an overlap only check, or part of separation?
	    * @return {float} Returns the amount of horizontal overlap between the two bodies.
	    */getOverlapX:function getOverlapX(body1,body2,overlapOnly){var overlap=0;var maxOverlap=body1.deltaAbsX()+body2.deltaAbsX()+this.OVERLAP_BIAS;if(body1.deltaX()===0&&body2.deltaX()===0){//  They overlap but neither of them are moving
	body1.embedded=true;body2.embedded=true;}else if(body1.deltaX()>body2.deltaX()){//  Body1 is moving right and / or Body2 is moving left
	overlap=body1.right-body2.x;if(overlap>maxOverlap&&!overlapOnly||body1.checkCollision.right===false||body2.checkCollision.left===false){overlap=0;}else{body1.touching.none=false;body1.touching.right=true;body2.touching.none=false;body2.touching.left=true;}}else if(body1.deltaX()<body2.deltaX()){//  Body1 is moving left and/or Body2 is moving right
	overlap=body1.x-body2.width-body2.x;if(-overlap>maxOverlap&&!overlapOnly||body1.checkCollision.left===false||body2.checkCollision.right===false){overlap=0;}else{body1.touching.none=false;body1.touching.left=true;body2.touching.none=false;body2.touching.right=true;}}//  Resets the overlapX to zero if there is no overlap, or to the actual pixel value if there is
	body1.overlapX=overlap;body2.overlapX=overlap;return overlap;},/**
	    * Calculates the vertical overlap between two Bodies and sets their properties accordingly, including:
	    * `touching.up`, `touching.down` and `overlapY`.
	    *
	    * @method Phaser.Physics.Arcade#getOverlapY
	    * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to separate.
	    * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to separate.
	    * @param {boolean} overlapOnly - Is this an overlap only check, or part of separation?
	    * @return {float} Returns the amount of vertical overlap between the two bodies.
	    */getOverlapY:function getOverlapY(body1,body2,overlapOnly){var overlap=0;var maxOverlap=body1.deltaAbsY()+body2.deltaAbsY()+this.OVERLAP_BIAS;if(body1.deltaY()===0&&body2.deltaY()===0){//  They overlap but neither of them are moving
	body1.embedded=true;body2.embedded=true;}else if(body1.deltaY()>body2.deltaY()){//  Body1 is moving down and/or Body2 is moving up
	overlap=body1.bottom-body2.y;if(overlap>maxOverlap&&!overlapOnly||body1.checkCollision.down===false||body2.checkCollision.up===false){overlap=0;}else{body1.touching.none=false;body1.touching.down=true;body2.touching.none=false;body2.touching.up=true;}}else if(body1.deltaY()<body2.deltaY()){//  Body1 is moving up and/or Body2 is moving down
	overlap=body1.y-body2.bottom;if(-overlap>maxOverlap&&!overlapOnly||body1.checkCollision.up===false||body2.checkCollision.down===false){overlap=0;}else{body1.touching.none=false;body1.touching.up=true;body2.touching.none=false;body2.touching.down=true;}}//  Resets the overlapY to zero if there is no overlap, or to the actual pixel value if there is
	body1.overlapY=overlap;body2.overlapY=overlap;return overlap;},/**
	    * The core separation function to separate two physics bodies on the x axis.
	    *
	    * @method Phaser.Physics.Arcade#separateX
	    * @private
	    * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to separate.
	    * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to separate.
	    * @param {boolean} overlapOnly - If true the bodies will only have their overlap data set, no separation or exchange of velocity will take place.
	    * @return {boolean} Returns true if the bodies were separated or overlap, otherwise false.
	    */separateX:function separateX(body1,body2,overlapOnly){var overlap=this.getOverlapX(body1,body2,overlapOnly);//  Can't separate two immovable bodies, or a body with its own custom separation logic
	if(overlapOnly||overlap===0||body1.immovable&&body2.immovable||body1.customSeparateX||body2.customSeparateX){//  return true if there was some overlap, otherwise false
	return overlap!==0||body1.embedded&&body2.embedded;}//  Adjust their positions and velocities accordingly (if there was any overlap)
	var v1=body1.velocity.x;var v2=body2.velocity.x;if(!body1.immovable&&!body2.immovable){overlap*=0.5;body1.x-=overlap;body2.x+=overlap;var nv1=Math.sqrt(v2*v2*body2.mass/body1.mass)*(v2>0?1:-1);var nv2=Math.sqrt(v1*v1*body1.mass/body2.mass)*(v1>0?1:-1);var avg=(nv1+nv2)*0.5;nv1-=avg;nv2-=avg;body1.velocity.x=avg+nv1*body1.bounce.x;body2.velocity.x=avg+nv2*body2.bounce.x;}else if(!body1.immovable){body1.x-=overlap;body1.velocity.x=v2-v1*body1.bounce.x;//  This is special case code that handles things like vertically moving platforms you can ride
	if(body2.moves){body1.y+=(body2.y-body2.prev.y)*body2.friction.y;}}else{body2.x+=overlap;body2.velocity.x=v1-v2*body2.bounce.x;//  This is special case code that handles things like vertically moving platforms you can ride
	if(body1.moves){body2.y+=(body1.y-body1.prev.y)*body1.friction.y;}}//  If we got this far then there WAS overlap, and separation is complete, so return true
	return true;},/**
	    * The core separation function to separate two physics bodies on the y axis.
	    *
	    * @private
	    * @method Phaser.Physics.Arcade#separateY
	    * @param {Phaser.Physics.Arcade.Body} body1 - The first Body to separate.
	    * @param {Phaser.Physics.Arcade.Body} body2 - The second Body to separate.
	    * @param {boolean} overlapOnly - If true the bodies will only have their overlap data set, no separation or exchange of velocity will take place.
	    * @return {boolean} Returns true if the bodies were separated or overlap, otherwise false.
	    */separateY:function separateY(body1,body2,overlapOnly){var overlap=this.getOverlapY(body1,body2,overlapOnly);//  Can't separate two immovable bodies, or a body with its own custom separation logic
	if(overlapOnly||overlap===0||body1.immovable&&body2.immovable||body1.customSeparateY||body2.customSeparateY){//  return true if there was some overlap, otherwise false
	return overlap!==0||body1.embedded&&body2.embedded;}//  Adjust their positions and velocities accordingly (if there was any overlap)
	var v1=body1.velocity.y;var v2=body2.velocity.y;if(!body1.immovable&&!body2.immovable){overlap*=0.5;body1.y-=overlap;body2.y+=overlap;var nv1=Math.sqrt(v2*v2*body2.mass/body1.mass)*(v2>0?1:-1);var nv2=Math.sqrt(v1*v1*body1.mass/body2.mass)*(v1>0?1:-1);var avg=(nv1+nv2)*0.5;nv1-=avg;nv2-=avg;body1.velocity.y=avg+nv1*body1.bounce.y;body2.velocity.y=avg+nv2*body2.bounce.y;}else if(!body1.immovable){body1.y-=overlap;body1.velocity.y=v2-v1*body1.bounce.y;//  This is special case code that handles things like horizontal moving platforms you can ride
	if(body2.moves){body1.x+=(body2.x-body2.prev.x)*body2.friction.x;}}else{body2.y+=overlap;body2.velocity.y=v1-v2*body2.bounce.y;//  This is special case code that handles things like horizontal moving platforms you can ride
	if(body1.moves){body2.x+=(body1.x-body1.prev.x)*body1.friction.x;}}//  If we got this far then there WAS overlap, and separation is complete, so return true
	return true;},/**
	    * Given a Group and a Pointer this will check to see which Group children overlap with the Pointer coordinates.
	    * Each child will be sent to the given callback for further processing.
	    * Note that the children are not checked for depth order, but simply if they overlap the Pointer or not.
	    *
	    * @method Phaser.Physics.Arcade#getObjectsUnderPointer
	    * @param {Phaser.Pointer} pointer - The Pointer to check.
	    * @param {Phaser.Group} group - The Group to check.
	    * @param {function} [callback] - A callback function that is called if the object overlaps with the Pointer. The callback will be sent two parameters: the Pointer and the Object that overlapped with it.
	    * @param {object} [callbackContext] - The context in which to run the callback.
	    * @return {PIXI.DisplayObject[]} An array of the Sprites from the Group that overlapped the Pointer coordinates.
	    */getObjectsUnderPointer:function getObjectsUnderPointer(pointer,group,callback,callbackContext){if(group.length===0||!pointer.exists){return;}return this.getObjectsAtLocation(pointer.x,pointer.y,group,callback,callbackContext,pointer);},/**
	    * Given a Group and a location this will check to see which Group children overlap with the coordinates.
	    * Each child will be sent to the given callback for further processing.
	    * Note that the children are not checked for depth order, but simply if they overlap the coordinate or not.
	    *
	    * @method Phaser.Physics.Arcade#getObjectsAtLocation
	    * @param {number} x - The x coordinate to check.
	    * @param {number} y - The y coordinate to check.
	    * @param {Phaser.Group} group - The Group to check.
	    * @param {function} [callback] - A callback function that is called if the object overlaps the coordinates. The callback will be sent two parameters: the callbackArg and the Object that overlapped the location.
	    * @param {object} [callbackContext] - The context in which to run the callback.
	    * @param {object} [callbackArg] - An argument to pass to the callback.
	    * @return {PIXI.DisplayObject[]} An array of the Sprites from the Group that overlapped the coordinates.
	    */getObjectsAtLocation:function getObjectsAtLocation(x,y,group,callback,callbackContext,callbackArg){this.quadTree.clear();this.quadTree.reset(this.game.world.bounds.x,this.game.world.bounds.y,this.game.world.bounds.width,this.game.world.bounds.height,this.maxObjects,this.maxLevels);this.quadTree.populate(group);var rect=new Phaser.Rectangle(x,y,1,1);var output=[];var items=this.quadTree.retrieve(rect);for(var i=0;i<items.length;i++){if(items[i].hitTest(x,y)){if(callback){callback.call(callbackContext,callbackArg,items[i].sprite);}output.push(items[i].sprite);}}return output;},/**
	    * Move the given display object towards the destination object at a steady velocity.
	    * If you specify a maxTime then it will adjust the speed (overwriting what you set) so it arrives at the destination in that number of seconds.
	    * Timings are approximate due to the way browser timers work. Allow for a variance of +- 50ms.
	    * Note: The display object does not continuously track the target. If the target changes location during transit the display object will not modify its course.
	    * Note: The display object doesn't stop moving once it reaches the destination coordinates.
	    * Note: Doesn't take into account acceleration, maxVelocity or drag (if you've set drag or acceleration too high this object may not move at all)
	    *
	    * @method Phaser.Physics.Arcade#moveToObject
	    * @param {any} displayObject - The display object to move.
	    * @param {any} destination - The display object to move towards. Can be any object but must have visible x/y properties.
	    * @param {number} [speed=60] - The speed it will move, in pixels per second (default is 60 pixels/sec)
	    * @param {number} [maxTime=0] - Time given in milliseconds (1000 = 1 sec). If set the speed is adjusted so the object will arrive at destination in the given number of ms.
	    * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
	    */moveToObject:function moveToObject(displayObject,destination,speed,maxTime){if(speed===undefined){speed=60;}if(maxTime===undefined){maxTime=0;}var angle=Math.atan2(destination.y-displayObject.y,destination.x-displayObject.x);if(maxTime>0){//  We know how many pixels we need to move, but how fast?
	speed=this.distanceBetween(displayObject,destination)/(maxTime/1000);}displayObject.body.velocity.x=Math.cos(angle)*speed;displayObject.body.velocity.y=Math.sin(angle)*speed;return angle;},/**
	    * Move the given display object towards the pointer at a steady velocity. If no pointer is given it will use Phaser.Input.activePointer.
	    * If you specify a maxTime then it will adjust the speed (over-writing what you set) so it arrives at the destination in that number of seconds.
	    * Timings are approximate due to the way browser timers work. Allow for a variance of +- 50ms.
	    * Note: The display object does not continuously track the target. If the target changes location during transit the display object will not modify its course.
	    * Note: The display object doesn't stop moving once it reaches the destination coordinates.
	    *
	    * @method Phaser.Physics.Arcade#moveToPointer
	    * @param {any} displayObject - The display object to move.
	    * @param {number} [speed=60] - The speed it will move, in pixels per second (default is 60 pixels/sec)
	    * @param {Phaser.Pointer} [pointer] - The pointer to move towards. Defaults to Phaser.Input.activePointer.
	    * @param {number} [maxTime=0] - Time given in milliseconds (1000 = 1 sec). If set the speed is adjusted so the object will arrive at destination in the given number of ms.
	    * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
	    */moveToPointer:function moveToPointer(displayObject,speed,pointer,maxTime){if(speed===undefined){speed=60;}pointer=pointer||this.game.input.activePointer;if(maxTime===undefined){maxTime=0;}var angle=this.angleToPointer(displayObject,pointer);if(maxTime>0){//  We know how many pixels we need to move, but how fast?
	speed=this.distanceToPointer(displayObject,pointer)/(maxTime/1000);}displayObject.body.velocity.x=Math.cos(angle)*speed;displayObject.body.velocity.y=Math.sin(angle)*speed;return angle;},/**
	    * Move the given display object towards the x/y coordinates at a steady velocity.
	    * If you specify a maxTime then it will adjust the speed (over-writing what you set) so it arrives at the destination in that number of seconds.
	    * Timings are approximate due to the way browser timers work. Allow for a variance of +- 50ms.
	    * Note: The display object does not continuously track the target. If the target changes location during transit the display object will not modify its course.
	    * Note: The display object doesn't stop moving once it reaches the destination coordinates.
	    * Note: Doesn't take into account acceleration, maxVelocity or drag (if you've set drag or acceleration too high this object may not move at all)
	    *
	    * @method Phaser.Physics.Arcade#moveToXY
	    * @param {any} displayObject - The display object to move.
	    * @param {number} x - The x coordinate to move towards.
	    * @param {number} y - The y coordinate to move towards.
	    * @param {number} [speed=60] - The speed it will move, in pixels per second (default is 60 pixels/sec)
	    * @param {number} [maxTime=0] - Time given in milliseconds (1000 = 1 sec). If set the speed is adjusted so the object will arrive at destination in the given number of ms.
	    * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
	    */moveToXY:function moveToXY(displayObject,x,y,speed,maxTime){if(speed===undefined){speed=60;}if(maxTime===undefined){maxTime=0;}var angle=Math.atan2(y-displayObject.y,x-displayObject.x);if(maxTime>0){//  We know how many pixels we need to move, but how fast?
	speed=this.distanceToXY(displayObject,x,y)/(maxTime/1000);}displayObject.body.velocity.x=Math.cos(angle)*speed;displayObject.body.velocity.y=Math.sin(angle)*speed;return angle;},/**
	    * Given the angle (in degrees) and speed calculate the velocity and return it as a Point object, or set it to the given point object.
	    * One way to use this is: velocityFromAngle(angle, 200, sprite.velocity) which will set the values directly to the sprites velocity and not create a new Point object.
	    *
	    * @method Phaser.Physics.Arcade#velocityFromAngle
	    * @param {number} angle - The angle in degrees calculated in clockwise positive direction (down = 90 degrees positive, right = 0 degrees positive, up = 90 degrees negative)
	    * @param {number} [speed=60] - The speed it will move, in pixels per second sq.
	    * @param {Phaser.Point|object} [point] - The Point object in which the x and y properties will be set to the calculated velocity.
	    * @return {Phaser.Point} - A Point where point.x contains the velocity x value and point.y contains the velocity y value.
	    */velocityFromAngle:function velocityFromAngle(angle,speed,point){if(speed===undefined){speed=60;}point=point||new Phaser.Point();return point.setTo(Math.cos(this.game.math.degToRad(angle))*speed,Math.sin(this.game.math.degToRad(angle))*speed);},/**
	    * Given the rotation (in radians) and speed calculate the velocity and return it as a Point object, or set it to the given point object.
	    * One way to use this is: velocityFromRotation(rotation, 200, sprite.velocity) which will set the values directly to the sprites velocity and not create a new Point object.
	    *
	    * @method Phaser.Physics.Arcade#velocityFromRotation
	    * @param {number} rotation - The angle in radians.
	    * @param {number} [speed=60] - The speed it will move, in pixels per second sq.
	    * @param {Phaser.Point|object} [point] - The Point object in which the x and y properties will be set to the calculated velocity.
	    * @return {Phaser.Point} - A Point where point.x contains the velocity x value and point.y contains the velocity y value.
	    */velocityFromRotation:function velocityFromRotation(rotation,speed,point){if(speed===undefined){speed=60;}point=point||new Phaser.Point();return point.setTo(Math.cos(rotation)*speed,Math.sin(rotation)*speed);},/**
	    * Given the rotation (in radians) and speed calculate the acceleration and return it as a Point object, or set it to the given point object.
	    * One way to use this is: accelerationFromRotation(rotation, 200, sprite.acceleration) which will set the values directly to the sprites acceleration and not create a new Point object.
	    *
	    * @method Phaser.Physics.Arcade#accelerationFromRotation
	    * @param {number} rotation - The angle in radians.
	    * @param {number} [speed=60] - The speed it will move, in pixels per second sq.
	    * @param {Phaser.Point|object} [point] - The Point object in which the x and y properties will be set to the calculated acceleration.
	    * @return {Phaser.Point} - A Point where point.x contains the acceleration x value and point.y contains the acceleration y value.
	    */accelerationFromRotation:function accelerationFromRotation(rotation,speed,point){if(speed===undefined){speed=60;}point=point||new Phaser.Point();return point.setTo(Math.cos(rotation)*speed,Math.sin(rotation)*speed);},/**
	    * Sets the acceleration.x/y property on the display object so it will move towards the target at the given speed (in pixels per second sq.)
	    * You must give a maximum speed value, beyond which the display object won't go any faster.
	    * Note: The display object does not continuously track the target. If the target changes location during transit the display object will not modify its course.
	    * Note: The display object doesn't stop moving once it reaches the destination coordinates.
	    *
	    * @method Phaser.Physics.Arcade#accelerateToObject
	    * @param {any} displayObject - The display object to move.
	    * @param {any} destination - The display object to move towards. Can be any object but must have visible x/y properties.
	    * @param {number} [speed=60] - The speed it will accelerate in pixels per second.
	    * @param {number} [xSpeedMax=500] - The maximum x velocity the display object can reach.
	    * @param {number} [ySpeedMax=500] - The maximum y velocity the display object can reach.
	    * @return {number} The angle (in radians) that the object should be visually set to in order to match its new trajectory.
	    */accelerateToObject:function accelerateToObject(displayObject,destination,speed,xSpeedMax,ySpeedMax){if(speed===undefined){speed=60;}if(xSpeedMax===undefined){xSpeedMax=1000;}if(ySpeedMax===undefined){ySpeedMax=1000;}var angle=this.angleBetween(displayObject,destination);displayObject.body.acceleration.setTo(Math.cos(angle)*speed,Math.sin(angle)*speed);displayObject.body.maxVelocity.setTo(xSpeedMax,ySpeedMax);return angle;},/**
	    * Sets the acceleration.x/y property on the display object so it will move towards the target at the given speed (in pixels per second sq.)
	    * You must give a maximum speed value, beyond which the display object won't go any faster.
	    * Note: The display object does not continuously track the target. If the target changes location during transit the display object will not modify its course.
	    * Note: The display object doesn't stop moving once it reaches the destination coordinates.
	    *
	    * @method Phaser.Physics.Arcade#accelerateToPointer
	    * @param {any} displayObject - The display object to move.
	    * @param {Phaser.Pointer} [pointer] - The pointer to move towards. Defaults to Phaser.Input.activePointer.
	    * @param {number} [speed=60] - The speed it will accelerate in pixels per second.
	    * @param {number} [xSpeedMax=500] - The maximum x velocity the display object can reach.
	    * @param {number} [ySpeedMax=500] - The maximum y velocity the display object can reach.
	    * @return {number} The angle (in radians) that the object should be visually set to in order to match its new trajectory.
	    */accelerateToPointer:function accelerateToPointer(displayObject,pointer,speed,xSpeedMax,ySpeedMax){if(speed===undefined){speed=60;}if(pointer===undefined){pointer=this.game.input.activePointer;}if(xSpeedMax===undefined){xSpeedMax=1000;}if(ySpeedMax===undefined){ySpeedMax=1000;}var angle=this.angleToPointer(displayObject,pointer);displayObject.body.acceleration.setTo(Math.cos(angle)*speed,Math.sin(angle)*speed);displayObject.body.maxVelocity.setTo(xSpeedMax,ySpeedMax);return angle;},/**
	    * Sets the acceleration.x/y property on the display object so it will move towards the x/y coordinates at the given speed (in pixels per second sq.)
	    * You must give a maximum speed value, beyond which the display object won't go any faster.
	    * Note: The display object does not continuously track the target. If the target changes location during transit the display object will not modify its course.
	    * Note: The display object doesn't stop moving once it reaches the destination coordinates.
	    *
	    * @method Phaser.Physics.Arcade#accelerateToXY
	    * @param {any} displayObject - The display object to move.
	    * @param {number} x - The x coordinate to accelerate towards.
	    * @param {number} y - The y coordinate to accelerate towards.
	    * @param {number} [speed=60] - The speed it will accelerate in pixels per second.
	    * @param {number} [xSpeedMax=500] - The maximum x velocity the display object can reach.
	    * @param {number} [ySpeedMax=500] - The maximum y velocity the display object can reach.
	    * @return {number} The angle (in radians) that the object should be visually set to in order to match its new trajectory.
	    */accelerateToXY:function accelerateToXY(displayObject,x,y,speed,xSpeedMax,ySpeedMax){if(speed===undefined){speed=60;}if(xSpeedMax===undefined){xSpeedMax=1000;}if(ySpeedMax===undefined){ySpeedMax=1000;}var angle=this.angleToXY(displayObject,x,y);displayObject.body.acceleration.setTo(Math.cos(angle)*speed,Math.sin(angle)*speed);displayObject.body.maxVelocity.setTo(xSpeedMax,ySpeedMax);return angle;},/**
	    * Find the distance between two display objects (like Sprites).
	    *
	    * The optional `world` argument allows you to return the result based on the Game Objects `world` property,
	    * instead of its `x` and `y` values. This is useful of the object has been nested inside an offset Group,
	    * or parent Game Object.
	    *
	    * @method Phaser.Physics.Arcade#distanceBetween
	    * @param {any} source - The Display Object to test from.
	    * @param {any} target - The Display Object to test to.
	    * @param {boolean} [world=false] - Calculate the distance using World coordinates (true), or Object coordinates (false, the default)
	    * @return {number} The distance between the source and target objects.
	    */distanceBetween:function distanceBetween(source,target,world){if(world===undefined){world=false;}var dx=world?source.world.x-target.world.x:source.x-target.x;var dy=world?source.world.y-target.world.y:source.y-target.y;return Math.sqrt(dx*dx+dy*dy);},/**
	    * Find the distance between a display object (like a Sprite) and the given x/y coordinates.
	    * The calculation is made from the display objects x/y coordinate. This may be the top-left if its anchor hasn't been changed.
	    * If you need to calculate from the center of a display object instead use the method distanceBetweenCenters()
	    *
	    * The optional `world` argument allows you to return the result based on the Game Objects `world` property,
	    * instead of its `x` and `y` values. This is useful of the object has been nested inside an offset Group,
	    * or parent Game Object.
	    *
	    * @method Phaser.Physics.Arcade#distanceToXY
	    * @param {any} displayObject - The Display Object to test from.
	    * @param {number} x - The x coordinate to move towards.
	    * @param {number} y - The y coordinate to move towards.
	    * @param {boolean} [world=false] - Calculate the distance using World coordinates (true), or Object coordinates (false, the default)
	    * @return {number} The distance between the object and the x/y coordinates.
	    */distanceToXY:function distanceToXY(displayObject,x,y,world){if(world===undefined){world=false;}var dx=world?displayObject.world.x-x:displayObject.x-x;var dy=world?displayObject.world.y-y:displayObject.y-y;return Math.sqrt(dx*dx+dy*dy);},/**
	    * Find the distance between a display object (like a Sprite) and a Pointer. If no Pointer is given the Input.activePointer is used.
	    * The calculation is made from the display objects x/y coordinate. This may be the top-left if its anchor hasn't been changed.
	    * If you need to calculate from the center of a display object instead use the method distanceBetweenCenters()
	    *
	    * The optional `world` argument allows you to return the result based on the Game Objects `world` property,
	    * instead of its `x` and `y` values. This is useful of the object has been nested inside an offset Group,
	    * or parent Game Object.
	    *
	    * @method Phaser.Physics.Arcade#distanceToPointer
	    * @param {any} displayObject - The Display Object to test from.
	    * @param {Phaser.Pointer} [pointer] - The Phaser.Pointer to test to. If none is given then Input.activePointer is used.
	    * @param {boolean} [world=false] - Calculate the distance using World coordinates (true), or Object coordinates (false, the default)
	    * @return {number} The distance between the object and the Pointer.
	    */distanceToPointer:function distanceToPointer(displayObject,pointer,world){if(pointer===undefined){pointer=this.game.input.activePointer;}if(world===undefined){world=false;}var dx=world?displayObject.world.x-pointer.worldX:displayObject.x-pointer.worldX;var dy=world?displayObject.world.y-pointer.worldY:displayObject.y-pointer.worldY;return Math.sqrt(dx*dx+dy*dy);},/**
	    * Find the angle in radians between two display objects (like Sprites).
	    *
	    * The optional `world` argument allows you to return the result based on the Game Objects `world` property,
	    * instead of its `x` and `y` values. This is useful of the object has been nested inside an offset Group,
	    * or parent Game Object.
	    *
	    * @method Phaser.Physics.Arcade#angleBetween
	    * @param {any} source - The Display Object to test from.
	    * @param {any} target - The Display Object to test to.
	    * @param {boolean} [world=false] - Calculate the angle using World coordinates (true), or Object coordinates (false, the default)
	    * @return {number} The angle in radians between the source and target display objects.
	    */angleBetween:function angleBetween(source,target,world){if(world===undefined){world=false;}if(world){return Math.atan2(target.world.y-source.world.y,target.world.x-source.world.x);}else{return Math.atan2(target.y-source.y,target.x-source.x);}},/**
	    * Find the angle in radians between centers of two display objects (like Sprites).
	    *
	    * @method Phaser.Physics.Arcade#angleBetweenCenters
	    * @param {any} source - The Display Object to test from.
	    * @param {any} target - The Display Object to test to.
	    * @return {number} The angle in radians between the source and target display objects.
	    */angleBetweenCenters:function angleBetweenCenters(source,target){var dx=target.centerX-source.centerX;var dy=target.centerY-source.centerY;return Math.atan2(dy,dx);},/**
	    * Find the angle in radians between a display object (like a Sprite) and the given x/y coordinate.
	    *
	    * The optional `world` argument allows you to return the result based on the Game Objects `world` property,
	    * instead of its `x` and `y` values. This is useful of the object has been nested inside an offset Group,
	    * or parent Game Object.
	    *
	    * @method Phaser.Physics.Arcade#angleToXY
	    * @param {any} displayObject - The Display Object to test from.
	    * @param {number} x - The x coordinate to get the angle to.
	    * @param {number} y - The y coordinate to get the angle to.
	    * @param {boolean} [world=false] - Calculate the angle using World coordinates (true), or Object coordinates (false, the default)
	    * @return {number} The angle in radians between displayObject.x/y to Pointer.x/y
	    */angleToXY:function angleToXY(displayObject,x,y,world){if(world===undefined){world=false;}if(world){return Math.atan2(y-displayObject.world.y,x-displayObject.world.x);}else{return Math.atan2(y-displayObject.y,x-displayObject.x);}},/**
	    * Find the angle in radians between a display object (like a Sprite) and a Pointer, taking their x/y and center into account.
	    *
	    * The optional `world` argument allows you to return the result based on the Game Objects `world` property,
	    * instead of its `x` and `y` values. This is useful of the object has been nested inside an offset Group,
	    * or parent Game Object.
	    *
	    * @method Phaser.Physics.Arcade#angleToPointer
	    * @param {any} displayObject - The Display Object to test from.
	    * @param {Phaser.Pointer} [pointer] - The Phaser.Pointer to test to. If none is given then Input.activePointer is used.
	    * @param {boolean} [world=false] - Calculate the angle using World coordinates (true), or Object coordinates (false, the default)
	    * @return {number} The angle in radians between displayObject.x/y to Pointer.x/y
	    */angleToPointer:function angleToPointer(displayObject,pointer,world){if(pointer===undefined){pointer=this.game.input.activePointer;}if(world===undefined){world=false;}if(world){return Math.atan2(pointer.worldY-displayObject.world.y,pointer.worldX-displayObject.world.x);}else{return Math.atan2(pointer.worldY-displayObject.y,pointer.worldX-displayObject.x);}},/**
	    * Find the angle in radians between a display object (like a Sprite) and a Pointer, 
	    * taking their x/y and center into account relative to the world.
	    *
	    * @method Phaser.Physics.Arcade#worldAngleToPointer
	    * @param {any} displayObject - The DisplayObjerct to test from.
	    * @param {Phaser.Pointer} [pointer] - The Phaser.Pointer to test to. If none is given then Input.activePointer is used.
	    * @return {number} The angle in radians between displayObject.world.x/y to Pointer.worldX / worldY
	    */worldAngleToPointer:function worldAngleToPointer(displayObject,pointer){return this.angleToPointer(displayObject,pointer,true);}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Physics Body is linked to a single Sprite. All physics operations should be performed against the body rather than
	* the Sprite itself. For example you can set the velocity, acceleration, bounce values etc all on the Body.
	*
	* @class Phaser.Physics.Arcade.Body
	* @constructor
	* @param {Phaser.Sprite} sprite - The Sprite object this physics body belongs to.
	*/Phaser.Physics.Arcade.Body=function(sprite){/**
	    * @property {Phaser.Sprite} sprite - Reference to the parent Sprite.
	    */this.sprite=sprite;/**
	    * @property {Phaser.Game} game - Local reference to game.
	    */this.game=sprite.game;/**
	    * @property {number} type - The type of physics system this body belongs to.
	    */this.type=Phaser.Physics.ARCADE;/**
	    * @property {boolean} enable - A disabled body won't be checked for any form of collision or overlap or have its pre/post updates run.
	    * @default
	    */this.enable=true;/**
	    * If `true` this Body is using circular collision detection. If `false` it is using rectangular.
	    * Use `Body.setCircle` to control the collision shape this Body uses.
	    * @property {boolean} isCircle
	    * @default
	    * @readOnly
	    */this.isCircle=false;/**
	    * The radius of the circular collision shape this Body is using if Body.setCircle has been enabled.
	    * If you wish to change the radius then call `setCircle` again with the new value.
	    * If you wish to stop the Body using a circle then call `setCircle` with a radius of zero (or undefined).
	    * @property {number} radius
	    * @default
	    * @readOnly
	    */this.radius=0;/**
	    * @property {Phaser.Point} offset - The offset of the Physics Body from the Sprite x/y position.
	    */this.offset=new Phaser.Point();/**
	    * @property {Phaser.Point} position - The position of the physics body.
	    * @readonly
	    */this.position=new Phaser.Point(sprite.x,sprite.y);/**
	    * @property {Phaser.Point} prev - The previous position of the physics body.
	    * @readonly
	    */this.prev=new Phaser.Point(this.position.x,this.position.y);/**
	    * @property {boolean} allowRotation - Allow this Body to be rotated? (via angularVelocity, etc)
	    * @default
	    */this.allowRotation=true;/**
	    * The Body's rotation in degrees, as calculated by its angularVelocity and angularAcceleration. Please understand that the collision Body
	    * itself never rotates, it is always axis-aligned. However these values are passed up to the parent Sprite and updates its rotation.
	    * @property {number} rotation
	    */this.rotation=sprite.angle;/**
	    * @property {number} preRotation - The previous rotation of the physics body.
	    * @readonly
	    */this.preRotation=sprite.angle;/**
	    * @property {number} width - The calculated width of the physics body.
	    * @readonly
	    */this.width=sprite.width;/**
	    * @property {number} height - The calculated height of the physics body.
	    * @readonly
	    */this.height=sprite.height;/**
	    * @property {number} sourceWidth - The un-scaled original size.
	    * @readonly
	    */this.sourceWidth=sprite.width;/**
	    * @property {number} sourceHeight - The un-scaled original size.
	    * @readonly
	    */this.sourceHeight=sprite.height;if(sprite.texture){this.sourceWidth=sprite.texture.frame.width;this.sourceHeight=sprite.texture.frame.height;}/**
	    * @property {number} halfWidth - The calculated width / 2 of the physics body.
	    * @readonly
	    */this.halfWidth=Math.abs(sprite.width/2);/**
	    * @property {number} halfHeight - The calculated height / 2 of the physics body.
	    * @readonly
	    */this.halfHeight=Math.abs(sprite.height/2);/**
	    * @property {Phaser.Point} center - The center coordinate of the Physics Body.
	    * @readonly
	    */this.center=new Phaser.Point(sprite.x+this.halfWidth,sprite.y+this.halfHeight);/**
	    * @property {Phaser.Point} velocity - The velocity, or rate of change in speed of the Body. Measured in pixels per second.
	    */this.velocity=new Phaser.Point();/**
	    * @property {Phaser.Point} newVelocity - The new velocity. Calculated during the Body.preUpdate and applied to its position.
	    * @readonly
	    */this.newVelocity=new Phaser.Point();/**
	    * @property {Phaser.Point} deltaMax - The Sprite position is updated based on the delta x/y values. You can set a cap on those (both +-) using deltaMax.
	    */this.deltaMax=new Phaser.Point();/**
	    * @property {Phaser.Point} acceleration - The acceleration is the rate of change of the velocity. Measured in pixels per second squared.
	    */this.acceleration=new Phaser.Point();/**
	    * @property {Phaser.Point} drag - The drag applied to the motion of the Body.
	    */this.drag=new Phaser.Point();/**
	    * @property {boolean} allowGravity - Allow this Body to be influenced by gravity? Either world or local.
	    * @default
	    */this.allowGravity=true;/**
	    * @property {Phaser.Point} gravity - A local gravity applied to this Body. If non-zero this over rides any world gravity, unless Body.allowGravity is set to false.
	    */this.gravity=new Phaser.Point();/**
	    * @property {Phaser.Point} bounce - The elasticity of the Body when colliding. bounce.x/y = 1 means full rebound, bounce.x/y = 0.5 means 50% rebound velocity.
	    */this.bounce=new Phaser.Point();/**
	    * The elasticity of the Body when colliding with the World bounds.
	    * By default this property is `null`, in which case `Body.bounce` is used instead. Set this property
	    * to a Phaser.Point object in order to enable a World bounds specific bounce value.
	    * @property {Phaser.Point} worldBounce
	    */this.worldBounce=null;/**
	    * A Signal that is dispatched when this Body collides with the world bounds.
	    * Due to the potentially high volume of signals this could create it is disabled by default.
	    * To use this feature set this property to a Phaser.Signal: `sprite.body.onWorldBounds = new Phaser.Signal()`
	    * and it will be called when a collision happens, passing five arguments:
	    * `onWorldBounds(sprite, up, down, left, right)`
	    * where the Sprite is a reference to the Sprite that owns this Body, and the other arguments are booleans
	    * indicating on which side of the world the Body collided.
	    * @property {Phaser.Signal} onWorldBounds
	    */this.onWorldBounds=null;/**
	    * A Signal that is dispatched when this Body collides with another Body.
	    * 
	    * You still need to call `game.physics.arcade.collide` in your `update` method in order
	    * for this signal to be dispatched.
	    *
	    * Usually you'd pass a callback to the `collide` method, but this signal provides for
	    * a different level of notification.
	    * 
	    * Due to the potentially high volume of signals this could create it is disabled by default.
	    * 
	    * To use this feature set this property to a Phaser.Signal: `sprite.body.onCollide = new Phaser.Signal()`
	    * and it will be called when a collision happens, passing two arguments: the sprites which collided.
	    * The first sprite in the argument is always the owner of this Body.
	    * 
	    * If two Bodies with this Signal set collide, both will dispatch the Signal.
	    * @property {Phaser.Signal} onCollide
	    */this.onCollide=null;/**
	    * A Signal that is dispatched when this Body overlaps with another Body.
	    * 
	    * You still need to call `game.physics.arcade.overlap` in your `update` method in order
	    * for this signal to be dispatched.
	    *
	    * Usually you'd pass a callback to the `overlap` method, but this signal provides for
	    * a different level of notification.
	    * 
	    * Due to the potentially high volume of signals this could create it is disabled by default.
	    * 
	    * To use this feature set this property to a Phaser.Signal: `sprite.body.onOverlap = new Phaser.Signal()`
	    * and it will be called when a collision happens, passing two arguments: the sprites which collided.
	    * The first sprite in the argument is always the owner of this Body.
	    * 
	    * If two Bodies with this Signal set collide, both will dispatch the Signal.
	    * @property {Phaser.Signal} onOverlap
	    */this.onOverlap=null;/**
	    * @property {Phaser.Point} maxVelocity - The maximum velocity in pixels per second sq. that the Body can reach.
	    * @default
	    */this.maxVelocity=new Phaser.Point(10000,10000);/**
	    * @property {Phaser.Point} friction - The amount of movement that will occur if another object 'rides' this one.
	    */this.friction=new Phaser.Point(1,0);/**
	    * @property {number} angularVelocity - The angular velocity controls the rotation speed of the Body. It is measured in degrees per second.
	    * @default
	    */this.angularVelocity=0;/**
	    * @property {number} angularAcceleration - The angular acceleration is the rate of change of the angular velocity. Measured in degrees per second squared.
	    * @default
	    */this.angularAcceleration=0;/**
	    * @property {number} angularDrag - The drag applied during the rotation of the Body. Measured in degrees per second squared.
	    * @default
	    */this.angularDrag=0;/**
	    * @property {number} maxAngular - The maximum angular velocity in degrees per second that the Body can reach.
	    * @default
	    */this.maxAngular=1000;/**
	    * @property {number} mass - The mass of the Body. When two bodies collide their mass is used in the calculation to determine the exchange of velocity.
	    * @default
	    */this.mass=1;/**
	    * @property {number} angle - The angle of the Body's velocity in radians.
	    * @readonly
	    */this.angle=0;/**
	    * @property {number} speed - The speed of the Body as calculated by its velocity.
	    * @readonly
	    */this.speed=0;/**
	    * @property {number} facing - A const reference to the direction the Body is traveling or facing.
	    * @default
	    */this.facing=Phaser.NONE;/**
	    * @property {boolean} immovable - An immovable Body will not receive any impacts from other bodies.
	    * @default
	    */this.immovable=false;/**
	    * If you have a Body that is being moved around the world via a tween or a Group motion, but its local x/y position never
	    * actually changes, then you should set Body.moves = false. Otherwise it will most likely fly off the screen.
	    * If you want the physics system to move the body around, then set moves to true.
	    * @property {boolean} moves - Set to true to allow the Physics system to move this Body, otherwise false to move it manually.
	    * @default
	    */this.moves=true;/**
	    * This flag allows you to disable the custom x separation that takes place by Physics.Arcade.separate.
	    * Used in combination with your own collision processHandler you can create whatever type of collision response you need.
	    * @property {boolean} customSeparateX - Use a custom separation system or the built-in one?
	    * @default
	    */this.customSeparateX=false;/**
	    * This flag allows you to disable the custom y separation that takes place by Physics.Arcade.separate.
	    * Used in combination with your own collision processHandler you can create whatever type of collision response you need.
	    * @property {boolean} customSeparateY - Use a custom separation system or the built-in one?
	    * @default
	    */this.customSeparateY=false;/**
	    * When this body collides with another, the amount of overlap is stored here.
	    * @property {number} overlapX - The amount of horizontal overlap during the collision.
	    */this.overlapX=0;/**
	    * When this body collides with another, the amount of overlap is stored here.
	    * @property {number} overlapY - The amount of vertical overlap during the collision.
	    */this.overlapY=0;/**
	    * If `Body.isCircle` is true, and this body collides with another circular body, the amount of overlap is stored here.
	    * @property {number} overlapR - The amount of overlap during the collision.
	    */this.overlapR=0;/**
	    * If a body is overlapping with another body, but neither of them are moving (maybe they spawned on-top of each other?) this is set to true.
	    * @property {boolean} embedded - Body embed value.
	    */this.embedded=false;/**
	    * A Body can be set to collide against the World bounds automatically and rebound back into the World if this is set to true. Otherwise it will leave the World.
	    * @property {boolean} collideWorldBounds - Should the Body collide with the World bounds?
	    */this.collideWorldBounds=false;/**
	    * Set the checkCollision properties to control which directions collision is processed for this Body.
	    * For example checkCollision.up = false means it won't collide when the collision happened while moving up.
	    * If you need to disable a Body entirely, use `body.enable = false`, this will also disable motion.
	    * If you need to disable just collision and/or overlap checks, but retain motion, set `checkCollision.none = true`.
	    * @property {object} checkCollision - An object containing allowed collision.
	    */this.checkCollision={none:false,any:true,up:true,down:true,left:true,right:true};/**
	    * This object is populated with boolean values when the Body collides with another.
	    * touching.up = true means the collision happened to the top of this Body for example.
	    * @property {object} touching - An object containing touching results.
	    */this.touching={none:true,up:false,down:false,left:false,right:false};/**
	    * This object is populated with previous touching values from the bodies previous collision.
	    * @property {object} wasTouching - An object containing previous touching results.
	    */this.wasTouching={none:true,up:false,down:false,left:false,right:false};/**
	    * This object is populated with boolean values when the Body collides with the World bounds or a Tile.
	    * For example if blocked.up is true then the Body cannot move up.
	    * @property {object} blocked - An object containing on which faces this Body is blocked from moving, if any.
	    */this.blocked={up:false,down:false,left:false,right:false};/**
	    * If this is an especially small or fast moving object then it can sometimes skip over tilemap collisions if it moves through a tile in a step.
	    * Set this padding value to add extra padding to its bounds. tilePadding.x applied to its width, y to its height.
	    * @property {Phaser.Point} tilePadding - Extra padding to be added to this sprite's dimensions when checking for tile collision.
	    */this.tilePadding=new Phaser.Point();/**
	    * @property {boolean} dirty - If this Body in a preUpdate (true) or postUpdate (false) state?
	    */this.dirty=false;/**
	    * @property {boolean} skipQuadTree - If true and you collide this Sprite against a Group, it will disable the collision check from using a QuadTree.
	    */this.skipQuadTree=false;/**
	    * If true the Body will check itself against the Sprite.getBounds() dimensions and adjust its width and height accordingly.
	    * If false it will compare its dimensions against the Sprite scale instead, and adjust its width height if the scale has changed.
	    * Typically you would need to enable syncBounds if your sprite is the child of a responsive display object such as a FlexLayer, 
	    * or in any situation where the Sprite scale doesn't change, but its parents scale is effecting the dimensions regardless.
	    * @property {boolean} syncBounds
	    * @default
	    */this.syncBounds=false;/**
	    * @property {boolean} isMoving - Set by the `moveTo` and `moveFrom` methods.
	    */this.isMoving=false;/**
	    * @property {boolean} stopVelocityOnCollide - Set by the `moveTo` and `moveFrom` methods.
	    */this.stopVelocityOnCollide=true;/**
	    * @property {integer} moveTimer - Internal time used by the `moveTo` and `moveFrom` methods.
	    * @private
	    */this.moveTimer=0;/**
	    * @property {integer} moveDistance - Internal distance value, used by the `moveTo` and `moveFrom` methods.
	    * @private
	    */this.moveDistance=0;/**
	    * @property {integer} moveDuration - Internal duration value, used by the `moveTo` and `moveFrom` methods.
	    * @private
	    */this.moveDuration=0;/**
	    * @property {Phaser.Line} moveTarget - Set by the `moveTo` method, and updated each frame.
	    * @private
	    */this.moveTarget=null;/**
	    * @property {Phaser.Point} moveEnd - Set by the `moveTo` method, and updated each frame.
	    * @private
	    */this.moveEnd=null;/**
	    * @property {Phaser.Signal} onMoveComplete - Listen for the completion of `moveTo` or `moveFrom` events.
	    */this.onMoveComplete=new Phaser.Signal();/**
	    * @property {function} movementCallback - Optional callback. If set, invoked during the running of `moveTo` or `moveFrom` events.
	    */this.movementCallback=null;/**
	    * @property {object} movementCallbackContext - Context in which to call the movementCallback.
	    */this.movementCallbackContext=null;/**
	    * @property {boolean} _reset - Internal cache var.
	    * @private
	    */this._reset=true;/**
	    * @property {number} _sx - Internal cache var.
	    * @private
	    */this._sx=sprite.scale.x;/**
	    * @property {number} _sy - Internal cache var.
	    * @private
	    */this._sy=sprite.scale.y;/**
	    * @property {number} _dx - Internal cache var.
	    * @private
	    */this._dx=0;/**
	    * @property {number} _dy - Internal cache var.
	    * @private
	    */this._dy=0;};Phaser.Physics.Arcade.Body.prototype={/**
	    * Internal method.
	    *
	    * @method Phaser.Physics.Arcade.Body#updateBounds
	    * @protected
	    */updateBounds:function updateBounds(){if(this.syncBounds){var b=this.sprite.getBounds();b.ceilAll();if(b.width!==this.width||b.height!==this.height){this.width=b.width;this.height=b.height;this._reset=true;}}else{var asx=Math.abs(this.sprite.scale.x);var asy=Math.abs(this.sprite.scale.y);if(asx!==this._sx||asy!==this._sy){this.width=this.sourceWidth*asx;this.height=this.sourceHeight*asy;this._sx=asx;this._sy=asy;this._reset=true;}}if(this._reset){this.halfWidth=Math.floor(this.width/2);this.halfHeight=Math.floor(this.height/2);this.center.setTo(this.position.x+this.halfWidth,this.position.y+this.halfHeight);}},/**
	    * Internal method.
	    *
	    * @method Phaser.Physics.Arcade.Body#preUpdate
	    * @protected
	    */preUpdate:function preUpdate(){if(!this.enable||this.game.physics.arcade.isPaused){return;}this.dirty=true;//  Store and reset collision flags
	this.wasTouching.none=this.touching.none;this.wasTouching.up=this.touching.up;this.wasTouching.down=this.touching.down;this.wasTouching.left=this.touching.left;this.wasTouching.right=this.touching.right;this.touching.none=true;this.touching.up=false;this.touching.down=false;this.touching.left=false;this.touching.right=false;this.blocked.up=false;this.blocked.down=false;this.blocked.left=false;this.blocked.right=false;this.embedded=false;this.updateBounds();this.position.x=this.sprite.world.x-this.sprite.anchor.x*this.sprite.width+this.sprite.scale.x*this.offset.x;this.position.x-=this.sprite.scale.x<0?this.width:0;this.position.y=this.sprite.world.y-this.sprite.anchor.y*this.sprite.height+this.sprite.scale.y*this.offset.y;this.position.y-=this.sprite.scale.y<0?this.height:0;this.rotation=this.sprite.angle;this.preRotation=this.rotation;if(this._reset||this.sprite.fresh){this.prev.x=this.position.x;this.prev.y=this.position.y;}if(this.moves){this.game.physics.arcade.updateMotion(this);this.newVelocity.set(this.velocity.x*this.game.time.physicsElapsed,this.velocity.y*this.game.time.physicsElapsed);this.position.x+=this.newVelocity.x;this.position.y+=this.newVelocity.y;if(this.position.x!==this.prev.x||this.position.y!==this.prev.y){this.angle=Math.atan2(this.velocity.y,this.velocity.x);}this.speed=Math.sqrt(this.velocity.x*this.velocity.x+this.velocity.y*this.velocity.y);//  Now the State update will throw collision checks at the Body
	//  And finally we'll integrate the new position back to the Sprite in postUpdate
	if(this.collideWorldBounds){if(this.checkWorldBounds()&&this.onWorldBounds){this.onWorldBounds.dispatch(this.sprite,this.blocked.up,this.blocked.down,this.blocked.left,this.blocked.right);}}}this._dx=this.deltaX();this._dy=this.deltaY();this._reset=false;},/**
	    * Internal method.
	    *
	    * @method Phaser.Physics.Arcade.Body#updateMovement
	    * @protected
	    */updateMovement:function updateMovement(){var percent=0;var collided=this.overlapX!==0||this.overlapY!==0;//  Duration or Distance based?
	if(this.moveDuration>0){this.moveTimer+=this.game.time.elapsedMS;percent=this.moveTimer/this.moveDuration;}else{this.moveTarget.end.set(this.position.x,this.position.y);percent=this.moveTarget.length/this.moveDistance;}if(this.movementCallback){var result=this.movementCallback.call(this.movementCallbackContext,this,this.velocity,percent);}if(collided||percent>=1||result!==undefined&&result!==true){this.stopMovement(percent>=1||this.stopVelocityOnCollide&&collided);return false;}return true;},/**
	    * If this Body is moving as a result of a call to `moveTo` or `moveFrom` (i.e. it
	    * has Body.isMoving true), then calling this method will stop the movement before
	    * either the duration or distance counters expire.
	    *
	    * The `onMoveComplete` signal is dispatched.
	    *
	    * @method Phaser.Physics.Arcade.Body#stopMovement
	    * @param {boolean} [stopVelocity] - Should the Body.velocity be set to zero?
	    */stopMovement:function stopMovement(stopVelocity){if(this.isMoving){this.isMoving=false;if(stopVelocity){this.velocity.set(0);}//  Send the Sprite this Body belongs to
	//  and a boolean indicating if it stopped because of a collision or not
	this.onMoveComplete.dispatch(this.sprite,this.overlapX!==0||this.overlapY!==0);}},/**
	    * Internal method.
	    *
	    * @method Phaser.Physics.Arcade.Body#postUpdate
	    * @protected
	    */postUpdate:function postUpdate(){//  Only allow postUpdate to be called once per frame
	if(!this.enable||!this.dirty){return;}//  Moving?
	if(this.isMoving){this.updateMovement();}this.dirty=false;if(this.deltaX()<0){this.facing=Phaser.LEFT;}else if(this.deltaX()>0){this.facing=Phaser.RIGHT;}if(this.deltaY()<0){this.facing=Phaser.UP;}else if(this.deltaY()>0){this.facing=Phaser.DOWN;}if(this.moves){this._dx=this.deltaX();this._dy=this.deltaY();if(this.deltaMax.x!==0&&this._dx!==0){if(this._dx<0&&this._dx<-this.deltaMax.x){this._dx=-this.deltaMax.x;}else if(this._dx>0&&this._dx>this.deltaMax.x){this._dx=this.deltaMax.x;}}if(this.deltaMax.y!==0&&this._dy!==0){if(this._dy<0&&this._dy<-this.deltaMax.y){this._dy=-this.deltaMax.y;}else if(this._dy>0&&this._dy>this.deltaMax.y){this._dy=this.deltaMax.y;}}this.sprite.position.x+=this._dx;this.sprite.position.y+=this._dy;this._reset=true;}this.center.setTo(this.position.x+this.halfWidth,this.position.y+this.halfHeight);if(this.allowRotation){this.sprite.angle+=this.deltaZ();}this.prev.x=this.position.x;this.prev.y=this.position.y;},/**
	    * Internal method.
	    *
	    * @method Phaser.Physics.Arcade.Body#checkWorldBounds
	    * @protected
	    * @return {boolean} True if the Body collided with the world bounds, otherwise false.
	    */checkWorldBounds:function checkWorldBounds(){var pos=this.position;var bounds=this.game.physics.arcade.bounds;var check=this.game.physics.arcade.checkCollision;var bx=this.worldBounce?-this.worldBounce.x:-this.bounce.x;var by=this.worldBounce?-this.worldBounce.y:-this.bounce.y;if(this.isCircle){var bodyBounds={x:this.center.x-this.radius,y:this.center.y-this.radius,right:this.center.x+this.radius,bottom:this.center.y+this.radius};if(bodyBounds.x<bounds.x&&check.left){pos.x=bounds.x-this.halfWidth+this.radius;this.velocity.x*=bx;this.blocked.left=true;}else if(bodyBounds.right>bounds.right&&check.right){pos.x=bounds.right-this.halfWidth-this.radius;this.velocity.x*=bx;this.blocked.right=true;}if(bodyBounds.y<bounds.y&&check.up){pos.y=bounds.y-this.halfHeight+this.radius;this.velocity.y*=by;this.blocked.up=true;}else if(bodyBounds.bottom>bounds.bottom&&check.down){pos.y=bounds.bottom-this.halfHeight-this.radius;this.velocity.y*=by;this.blocked.down=true;}}else{if(pos.x<bounds.x&&check.left){pos.x=bounds.x;this.velocity.x*=bx;this.blocked.left=true;}else if(this.right>bounds.right&&check.right){pos.x=bounds.right-this.width;this.velocity.x*=bx;this.blocked.right=true;}if(pos.y<bounds.y&&check.up){pos.y=bounds.y;this.velocity.y*=by;this.blocked.up=true;}else if(this.bottom>bounds.bottom&&check.down){pos.y=bounds.bottom-this.height;this.velocity.y*=by;this.blocked.down=true;}}return this.blocked.up||this.blocked.down||this.blocked.left||this.blocked.right;},/**
	    * Note: This method is experimental, and may be changed or removed in a future release.
	    * 
	    * This method moves the Body in the given direction, for the duration specified.
	    * It works by setting the velocity on the Body, and an internal timer, and then
	    * monitoring the duration each frame. When the duration is up the movement is
	    * stopped and the `Body.onMoveComplete` signal is dispatched.
	    *
	    * Movement also stops if the Body collides or overlaps with any other Body.
	    * 
	    * You can control if the velocity should be reset to zero on collision, by using
	    * the property `Body.stopVelocityOnCollide`.
	    *
	    * Stop the movement at any time by calling `Body.stopMovement`.
	    *
	    * You can optionally set a speed in pixels per second. If not specified it
	    * will use the current `Body.speed` value. If this is zero, the function will return false.
	    *
	    * Please note that due to browser timings you should allow for a variance in 
	    * when the duration will actually expire. Depending on system it may be as much as
	    * +- 50ms. Also this method doesn't take into consideration any other forces acting
	    * on the Body, such as Gravity, drag or maxVelocity, all of which may impact the
	    * movement.
	    * 
	    * @method Phaser.Physics.Arcade.Body#moveFrom
	    * @param  {integer} duration  - The duration of the movement, in ms.
	    * @param  {integer} [speed] - The speed of the movement, in pixels per second. If not provided `Body.speed` is used.
	    * @param  {integer} [direction] - The angle of movement. If not provided `Body.angle` is used.
	    * @return {boolean} True if the movement successfully started, otherwise false.
	    */moveFrom:function moveFrom(duration,speed,direction){if(speed===undefined){speed=this.speed;}if(speed===0){return false;}var angle;if(direction===undefined){angle=this.angle;direction=this.game.math.radToDeg(angle);}else{angle=this.game.math.degToRad(direction);}this.moveTimer=0;this.moveDuration=duration;//  Avoid sin/cos
	if(direction===0||direction===180){this.velocity.set(Math.cos(angle)*speed,0);}else if(direction===90||direction===270){this.velocity.set(0,Math.sin(angle)*speed);}else{this.velocity.set(Math.cos(angle)*speed,Math.sin(angle)*speed);}this.isMoving=true;return true;},/**
	    * Note: This method is experimental, and may be changed or removed in a future release.
	    * 
	    * This method moves the Body in the given direction, for the duration specified.
	    * It works by setting the velocity on the Body, and an internal distance counter.
	    * The distance is monitored each frame. When the distance equals the distance
	    * specified in this call, the movement is stopped, and the `Body.onMoveComplete` 
	    * signal is dispatched.
	    *
	    * Movement also stops if the Body collides or overlaps with any other Body.
	    * 
	    * You can control if the velocity should be reset to zero on collision, by using
	    * the property `Body.stopVelocityOnCollide`.
	    *
	    * Stop the movement at any time by calling `Body.stopMovement`.
	    *
	    * Please note that due to browser timings you should allow for a variance in 
	    * when the distance will actually expire.
	    * 
	    * Note: This method doesn't take into consideration any other forces acting
	    * on the Body, such as Gravity, drag or maxVelocity, all of which may impact the
	    * movement.
	    * 
	    * @method Phaser.Physics.Arcade.Body#moveTo
	    * @param  {integer} duration - The duration of the movement, in ms.
	    * @param  {integer} distance - The distance, in pixels, the Body will move.
	    * @param  {integer} [direction] - The angle of movement. If not provided `Body.angle` is used.
	    * @return {boolean} True if the movement successfully started, otherwise false.
	    */moveTo:function moveTo(duration,distance,direction){var speed=distance/(duration/1000);if(speed===0){return false;}var angle;if(direction===undefined){angle=this.angle;direction=this.game.math.radToDeg(angle);}else{angle=this.game.math.degToRad(direction);}distance=Math.abs(distance);this.moveDuration=0;this.moveDistance=distance;if(this.moveTarget===null){this.moveTarget=new Phaser.Line();this.moveEnd=new Phaser.Point();}this.moveTarget.fromAngle(this.x,this.y,angle,distance);this.moveEnd.set(this.moveTarget.end.x,this.moveTarget.end.y);this.moveTarget.setTo(this.x,this.y,this.x,this.y);//  Avoid sin/cos
	if(direction===0||direction===180){this.velocity.set(Math.cos(angle)*speed,0);}else if(direction===90||direction===270){this.velocity.set(0,Math.sin(angle)*speed);}else{this.velocity.set(Math.cos(angle)*speed,Math.sin(angle)*speed);}this.isMoving=true;return true;},/**
	    * You can modify the size of the physics Body to be any dimension you need.
	    * This allows you to make it smaller, or larger, than the parent Sprite.
	    * You can also control the x and y offset of the Body. This is the position of the
	    * Body relative to the top-left of the Sprite _texture_.
	    *
	    * For example: If you have a Sprite with a texture that is 80x100 in size,
	    * and you want the physics body to be 32x32 pixels in the middle of the texture, you would do:
	    *
	    * `setSize(32, 32, 24, 34)`
	    *
	    * Where the first two parameters is the new Body size (32x32 pixels).
	    * 24 is the horizontal offset of the Body from the top-left of the Sprites texture, and 34
	    * is the vertical offset.
	    *
	    * Calling `setSize` on a Body that has already had `setCircle` will reset all of the Circle
	    * properties, making this Body rectangular again.
	    *
	    * @method Phaser.Physics.Arcade.Body#setSize
	    * @param {number} width - The width of the Body.
	    * @param {number} height - The height of the Body.
	    * @param {number} [offsetX] - The X offset of the Body from the top-left of the Sprites texture.
	    * @param {number} [offsetY] - The Y offset of the Body from the top-left of the Sprites texture.
	    */setSize:function setSize(width,height,offsetX,offsetY){if(offsetX===undefined){offsetX=this.offset.x;}if(offsetY===undefined){offsetY=this.offset.y;}this.sourceWidth=width;this.sourceHeight=height;this.width=this.sourceWidth*this._sx;this.height=this.sourceHeight*this._sy;this.halfWidth=Math.floor(this.width/2);this.halfHeight=Math.floor(this.height/2);this.offset.setTo(offsetX,offsetY);this.center.setTo(this.position.x+this.halfWidth,this.position.y+this.halfHeight);this.isCircle=false;this.radius=0;},/**
	    * Sets this Body as using a circle, of the given radius, for all collision detection instead of a rectangle.
	    * The radius is given in pixels and is the distance from the center of the circle to the edge.
	    *
	    * You can also control the x and y offset, which is the position of the Body relative to the top-left of the Sprite.
	    *
	    * To change a Body back to being rectangular again call `Body.setSize`.
	    *
	    * Note: Circular collision only happens with other Arcade Physics bodies, it does not
	    * work against tile maps, where rectangular collision is the only method supported.
	    *
	    * @method Phaser.Physics.Arcade.Body#setCircle
	    * @param {number} [radius] - The radius of the Body in pixels. Pass a value of zero / undefined, to stop the Body using a circle for collision.
	    * @param {number} [offsetX] - The X offset of the Body from the Sprite position.
	    * @param {number} [offsetY] - The Y offset of the Body from the Sprite position.
	    */setCircle:function setCircle(radius,offsetX,offsetY){if(offsetX===undefined){offsetX=this.offset.x;}if(offsetY===undefined){offsetY=this.offset.y;}if(radius>0){this.isCircle=true;this.radius=radius;this.sourceWidth=radius*2;this.sourceHeight=radius*2;this.width=this.sourceWidth*this._sx;this.height=this.sourceHeight*this._sy;this.halfWidth=Math.floor(this.width/2);this.halfHeight=Math.floor(this.height/2);this.offset.setTo(offsetX,offsetY);this.center.setTo(this.position.x+this.halfWidth,this.position.y+this.halfHeight);}else{this.isCircle=false;}},/**
	    * Resets all Body values (velocity, acceleration, rotation, etc)
	    *
	    * @method Phaser.Physics.Arcade.Body#reset
	    * @param {number} x - The new x position of the Body.
	    * @param {number} y - The new y position of the Body.
	    */reset:function reset(x,y){this.velocity.set(0);this.acceleration.set(0);this.speed=0;this.angularVelocity=0;this.angularAcceleration=0;this.position.x=x-this.sprite.anchor.x*this.sprite.width+this.sprite.scale.x*this.offset.x;this.position.x-=this.sprite.scale.x<0?this.width:0;this.position.y=y-this.sprite.anchor.y*this.sprite.height+this.sprite.scale.y*this.offset.y;this.position.y-=this.sprite.scale.y<0?this.height:0;this.prev.x=this.position.x;this.prev.y=this.position.y;this.rotation=this.sprite.angle;this.preRotation=this.rotation;this._sx=this.sprite.scale.x;this._sy=this.sprite.scale.y;this.center.setTo(this.position.x+this.halfWidth,this.position.y+this.halfHeight);},/**
	    * Returns the bounds of this physics body.
	    * 
	    * Only used internally by the World collision methods.
	    *
	    * @method Phaser.Physics.Arcade.Body#getBounds
	    * @param {object} obj - The object in which to set the bounds values.
	    * @return {object} The object that was given to this method.
	    */getBounds:function getBounds(obj){if(this.isCircle){obj.x=this.center.x-this.radius;obj.y=this.center.y-this.radius;obj.right=this.center.x+this.radius;obj.bottom=this.center.y+this.radius;}else{obj.x=this.x;obj.y=this.y;obj.right=this.right;obj.bottom=this.bottom;}return obj;},/**
	    * Tests if a world point lies within this Body.
	    *
	    * @method Phaser.Physics.Arcade.Body#hitTest
	    * @param {number} x - The world x coordinate to test.
	    * @param {number} y - The world y coordinate to test.
	    * @return {boolean} True if the given coordinates are inside this Body, otherwise false.
	    */hitTest:function hitTest(x,y){return this.isCircle?Phaser.Circle.contains(this,x,y):Phaser.Rectangle.contains(this,x,y);},/**
	    * Returns true if the bottom of this Body is in contact with either the world bounds or a tile.
	    *
	    * @method Phaser.Physics.Arcade.Body#onFloor
	    * @return {boolean} True if in contact with either the world bounds or a tile.
	    */onFloor:function onFloor(){return this.blocked.down;},/**
	    * Returns true if the top of this Body is in contact with either the world bounds or a tile.
	    *
	    * @method Phaser.Physics.Arcade.Body#onCeiling
	    * @return {boolean} True if in contact with either the world bounds or a tile.
	    */onCeiling:function onCeiling(){return this.blocked.up;},/**
	    * Returns true if either side of this Body is in contact with either the world bounds or a tile.
	    *
	    * @method Phaser.Physics.Arcade.Body#onWall
	    * @return {boolean} True if in contact with either the world bounds or a tile.
	    */onWall:function onWall(){return this.blocked.left||this.blocked.right;},/**
	    * Returns the absolute delta x value.
	    *
	    * @method Phaser.Physics.Arcade.Body#deltaAbsX
	    * @return {number} The absolute delta value.
	    */deltaAbsX:function deltaAbsX(){return this.deltaX()>0?this.deltaX():-this.deltaX();},/**
	    * Returns the absolute delta y value.
	    *
	    * @method Phaser.Physics.Arcade.Body#deltaAbsY
	    * @return {number} The absolute delta value.
	    */deltaAbsY:function deltaAbsY(){return this.deltaY()>0?this.deltaY():-this.deltaY();},/**
	    * Returns the delta x value. The difference between Body.x now and in the previous step.
	    *
	    * @method Phaser.Physics.Arcade.Body#deltaX
	    * @return {number} The delta value. Positive if the motion was to the right, negative if to the left.
	    */deltaX:function deltaX(){return this.position.x-this.prev.x;},/**
	    * Returns the delta y value. The difference between Body.y now and in the previous step.
	    *
	    * @method Phaser.Physics.Arcade.Body#deltaY
	    * @return {number} The delta value. Positive if the motion was downwards, negative if upwards.
	    */deltaY:function deltaY(){return this.position.y-this.prev.y;},/**
	    * Returns the delta z value. The difference between Body.rotation now and in the previous step.
	    *
	    * @method Phaser.Physics.Arcade.Body#deltaZ
	    * @return {number} The delta value. Positive if the motion was clockwise, negative if anti-clockwise.
	    */deltaZ:function deltaZ(){return this.rotation-this.preRotation;},/**
	    * Destroys this Body.
	    * 
	    * First it calls Group.removeFromHash if the Game Object this Body belongs to is part of a Group.
	    * Then it nulls the Game Objects body reference, and nulls this Body.sprite reference.
	    *
	    * @method Phaser.Physics.Arcade.Body#destroy
	    */destroy:function destroy(){if(this.sprite.parent&&this.sprite.parent instanceof Phaser.Group){this.sprite.parent.removeFromHash(this.sprite);}this.sprite.body=null;this.sprite=null;}};/**
	* @name Phaser.Physics.Arcade.Body#left
	* @property {number} left - The x position of the Body. The same as `Body.x`.
	*/Object.defineProperty(Phaser.Physics.Arcade.Body.prototype,"left",{get:function get(){return this.position.x;}});/**
	* @name Phaser.Physics.Arcade.Body#right
	* @property {number} right - The right value of this Body (same as Body.x + Body.width)
	* @readonly
	*/Object.defineProperty(Phaser.Physics.Arcade.Body.prototype,"right",{get:function get(){return this.position.x+this.width;}});/**
	* @name Phaser.Physics.Arcade.Body#top
	* @property {number} top - The y position of the Body. The same as `Body.y`.
	*/Object.defineProperty(Phaser.Physics.Arcade.Body.prototype,"top",{get:function get(){return this.position.y;}});/**
	* @name Phaser.Physics.Arcade.Body#bottom
	* @property {number} bottom - The bottom value of this Body (same as Body.y + Body.height)
	* @readonly
	*/Object.defineProperty(Phaser.Physics.Arcade.Body.prototype,"bottom",{get:function get(){return this.position.y+this.height;}});/**
	* @name Phaser.Physics.Arcade.Body#x
	* @property {number} x - The x position.
	*/Object.defineProperty(Phaser.Physics.Arcade.Body.prototype,"x",{get:function get(){return this.position.x;},set:function set(value){this.position.x=value;}});/**
	* @name Phaser.Physics.Arcade.Body#y
	* @property {number} y - The y position.
	*/Object.defineProperty(Phaser.Physics.Arcade.Body.prototype,"y",{get:function get(){return this.position.y;},set:function set(value){this.position.y=value;}});/**
	* Render Sprite Body.
	*
	* @method Phaser.Physics.Arcade.Body#render
	* @param {object} context - The context to render to.
	* @param {Phaser.Physics.Arcade.Body} body - The Body to render the info of.
	* @param {string} [color='rgba(0,255,0,0.4)'] - color of the debug info to be rendered. (format is css color string).
	* @param {boolean} [filled=true] - Render the objected as a filled (default, true) or a stroked (false)
	*/Phaser.Physics.Arcade.Body.render=function(context,body,color,filled){if(filled===undefined){filled=true;}color=color||'rgba(0,255,0,0.4)';context.fillStyle=color;context.strokeStyle=color;if(body.isCircle){context.beginPath();context.arc(body.center.x-body.game.camera.x,body.center.y-body.game.camera.y,body.radius,0,2*Math.PI);if(filled){context.fill();}else{context.stroke();}}else{if(filled){context.fillRect(body.position.x-body.game.camera.x,body.position.y-body.game.camera.y,body.width,body.height);}else{context.strokeRect(body.position.x-body.game.camera.x,body.position.y-body.game.camera.y,body.width,body.height);}}};/**
	* Render Sprite Body Physics Data as text.
	*
	* @method Phaser.Physics.Arcade.Body#renderBodyInfo
	* @param {Phaser.Physics.Arcade.Body} body - The Body to render the info of.
	* @param {number} x - X position of the debug info to be rendered.
	* @param {number} y - Y position of the debug info to be rendered.
	* @param {string} [color='rgb(255,255,255)'] - color of the debug info to be rendered. (format is css color string).
	*/Phaser.Physics.Arcade.Body.renderBodyInfo=function(debug,body){debug.line('x: '+body.x.toFixed(2),'y: '+body.y.toFixed(2),'width: '+body.width,'height: '+body.height);debug.line('velocity x: '+body.velocity.x.toFixed(2),'y: '+body.velocity.y.toFixed(2),'deltaX: '+body._dx.toFixed(2),'deltaY: '+body._dy.toFixed(2));debug.line('acceleration x: '+body.acceleration.x.toFixed(2),'y: '+body.acceleration.y.toFixed(2),'speed: '+body.speed.toFixed(2),'angle: '+body.angle.toFixed(2));debug.line('gravity x: '+body.gravity.x,'y: '+body.gravity.y,'bounce x: '+body.bounce.x.toFixed(2),'y: '+body.bounce.y.toFixed(2));debug.line('touching left: '+body.touching.left,'right: '+body.touching.right,'up: '+body.touching.up,'down: '+body.touching.down);debug.line('blocked left: '+body.blocked.left,'right: '+body.blocked.right,'up: '+body.blocked.up,'down: '+body.blocked.down);};Phaser.Physics.Arcade.Body.prototype.constructor=Phaser.Physics.Arcade.Body;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Arcade Physics Tile map collision methods.
	*
	* @class Phaser.Physics.Arcade.TilemapCollision
	* @constructor
	*/Phaser.Physics.Arcade.TilemapCollision=function(){};Phaser.Physics.Arcade.TilemapCollision.prototype={/**
	    * @property {number} TILE_BIAS - A value added to the delta values during collision with tiles. Adjust this if you get tunneling.
	    */TILE_BIAS:16,/**
	    * An internal function. Use Phaser.Physics.Arcade.collide instead.
	    *
	    * @method Phaser.Physics.Arcade#collideSpriteVsTilemapLayer
	    * @private
	    * @param {Phaser.Sprite} sprite - The sprite to check.
	    * @param {Phaser.TilemapLayer} tilemapLayer - The layer to check.
	    * @param {function} collideCallback - An optional callback function that is called if the objects collide. The two objects will be passed to this function in the same order in which you specified them.
	    * @param {function} processCallback - A callback function that lets you perform additional checks against the two objects if they overlap. If this is set then collision will only happen if processCallback returns true. The two objects will be passed to this function in the same order in which you specified them.
	    * @param {object} callbackContext - The context in which to run the callbacks.
	    * @param {boolean} overlapOnly - Just run an overlap or a full collision.
	    */collideSpriteVsTilemapLayer:function collideSpriteVsTilemapLayer(sprite,tilemapLayer,collideCallback,processCallback,callbackContext,overlapOnly){if(!sprite.body){return;}var mapData=tilemapLayer.getTiles(sprite.body.position.x-sprite.body.tilePadding.x,sprite.body.position.y-sprite.body.tilePadding.y,sprite.body.width+sprite.body.tilePadding.x,sprite.body.height+sprite.body.tilePadding.y,false,false);if(mapData.length===0){return;}for(var i=0;i<mapData.length;i++){if(processCallback){if(processCallback.call(callbackContext,sprite,mapData[i])){if(this.separateTile(i,sprite.body,mapData[i],tilemapLayer,overlapOnly)){this._total++;if(collideCallback){collideCallback.call(callbackContext,sprite,mapData[i]);}}}}else{if(this.separateTile(i,sprite.body,mapData[i],tilemapLayer,overlapOnly)){this._total++;if(collideCallback){collideCallback.call(callbackContext,sprite,mapData[i]);}}}}},/**
	    * An internal function. Use Phaser.Physics.Arcade.collide instead.
	    *
	    * @private
	    * @method Phaser.Physics.Arcade#collideGroupVsTilemapLayer
	    * @param {Phaser.Group} group - The Group to check.
	    * @param {Phaser.TilemapLayer} tilemapLayer - The layer to check.
	    * @param {function} collideCallback - An optional callback function that is called if the objects collide. The two objects will be passed to this function in the same order in which you specified them.
	    * @param {function} processCallback - A callback function that lets you perform additional checks against the two objects if they overlap. If this is set then collision will only happen if processCallback returns true. The two objects will be passed to this function in the same order in which you specified them.
	    * @param {object} callbackContext - The context in which to run the callbacks.
	    * @param {boolean} overlapOnly - Just run an overlap or a full collision.
	    */collideGroupVsTilemapLayer:function collideGroupVsTilemapLayer(group,tilemapLayer,collideCallback,processCallback,callbackContext,overlapOnly){if(group.length===0){return;}for(var i=0;i<group.children.length;i++){if(group.children[i].exists){this.collideSpriteVsTilemapLayer(group.children[i],tilemapLayer,collideCallback,processCallback,callbackContext,overlapOnly);}}},/**
	    * The core separation function to separate a physics body and a tile.
	    *
	    * @private
	    * @method Phaser.Physics.Arcade#separateTile
	    * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
	    * @param {Phaser.Tile} tile - The tile to collide against.
	    * @param {Phaser.TilemapLayer} tilemapLayer - The tilemapLayer to collide against.
	    * @return {boolean} Returns true if the body was separated, otherwise false.
	    */separateTile:function separateTile(i,body,tile,tilemapLayer,overlapOnly){if(!body.enable){return false;}var tilemapLayerOffsetX=!tilemapLayer.fixedToCamera?tilemapLayer.position.x:0;var tilemapLayerOffsetY=!tilemapLayer.fixedToCamera?tilemapLayer.position.y:0;//  We re-check for collision in case body was separated in a previous step
	if(!tile.intersects(body.position.x-tilemapLayerOffsetX,body.position.y-tilemapLayerOffsetY,body.right-tilemapLayerOffsetX,body.bottom-tilemapLayerOffsetY)){//  no collision so bail out (separated in a previous step)
	return false;}else if(overlapOnly){//  There is an overlap, and we don't need to separate. Bail.
	return true;}//  They overlap. Any custom callbacks?
	//  A local callback always takes priority over a layer level callback
	if(tile.collisionCallback&&!tile.collisionCallback.call(tile.collisionCallbackContext,body.sprite,tile)){//  If it returns true then we can carry on, otherwise we should abort.
	return false;}else if(typeof tile.layer.callbacks!=='undefined'&&tile.layer.callbacks[tile.index]&&!tile.layer.callbacks[tile.index].callback.call(tile.layer.callbacks[tile.index].callbackContext,body.sprite,tile)){//  If it returns true then we can carry on, otherwise we should abort.
	return false;}//  We don't need to go any further if this tile doesn't actually separate
	if(!tile.faceLeft&&!tile.faceRight&&!tile.faceTop&&!tile.faceBottom){//   This could happen if the tile was meant to be collided with re: a callback, but otherwise isn't needed for separation
	return false;}var ox=0;var oy=0;var minX=0;var minY=1;if(body.deltaAbsX()>body.deltaAbsY()){//  Moving faster horizontally, check X axis first
	minX=-1;}else if(body.deltaAbsX()<body.deltaAbsY()){//  Moving faster vertically, check Y axis first
	minY=-1;}if(body.deltaX()!==0&&body.deltaY()!==0&&(tile.faceLeft||tile.faceRight)&&(tile.faceTop||tile.faceBottom)){//  We only need do this if both axis have checking faces AND we're moving in both directions
	minX=Math.min(Math.abs(body.position.x-tilemapLayerOffsetX-tile.right),Math.abs(body.right-tilemapLayerOffsetX-tile.left));minY=Math.min(Math.abs(body.position.y-tilemapLayerOffsetY-tile.bottom),Math.abs(body.bottom-tilemapLayerOffsetY-tile.top));}if(minX<minY){if(tile.faceLeft||tile.faceRight){ox=this.tileCheckX(body,tile,tilemapLayer);//  That's horizontal done, check if we still intersects? If not then we can return now
	if(ox!==0&&!tile.intersects(body.position.x-tilemapLayerOffsetX,body.position.y-tilemapLayerOffsetY,body.right-tilemapLayerOffsetX,body.bottom-tilemapLayerOffsetY)){return true;}}if(tile.faceTop||tile.faceBottom){oy=this.tileCheckY(body,tile,tilemapLayer);}}else{if(tile.faceTop||tile.faceBottom){oy=this.tileCheckY(body,tile,tilemapLayer);//  That's vertical done, check if we still intersects? If not then we can return now
	if(oy!==0&&!tile.intersects(body.position.x-tilemapLayerOffsetX,body.position.y-tilemapLayerOffsetY,body.right-tilemapLayerOffsetX,body.bottom-tilemapLayerOffsetY)){return true;}}if(tile.faceLeft||tile.faceRight){ox=this.tileCheckX(body,tile,tilemapLayer);}}return ox!==0||oy!==0;},/**
	    * Check the body against the given tile on the X axis.
	    *
	    * @private
	    * @method Phaser.Physics.Arcade#tileCheckX
	    * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
	    * @param {Phaser.Tile} tile - The tile to check.
	    * @param {Phaser.TilemapLayer} tilemapLayer - The tilemapLayer to collide against.
	    * @return {number} The amount of separation that occurred.
	    */tileCheckX:function tileCheckX(body,tile,tilemapLayer){var ox=0;var tilemapLayerOffsetX=!tilemapLayer.fixedToCamera?tilemapLayer.position.x:0;if(body.deltaX()<0&&!body.blocked.left&&tile.collideRight&&body.checkCollision.left){//  Body is moving LEFT
	if(tile.faceRight&&body.x-tilemapLayerOffsetX<tile.right){ox=body.x-tilemapLayerOffsetX-tile.right;if(ox<-this.TILE_BIAS){ox=0;}}}else if(body.deltaX()>0&&!body.blocked.right&&tile.collideLeft&&body.checkCollision.right){//  Body is moving RIGHT
	if(tile.faceLeft&&body.right-tilemapLayerOffsetX>tile.left){ox=body.right-tilemapLayerOffsetX-tile.left;if(ox>this.TILE_BIAS){ox=0;}}}if(ox!==0){if(body.customSeparateX){body.overlapX=ox;}else{this.processTileSeparationX(body,ox);}}return ox;},/**
	    * Check the body against the given tile on the Y axis.
	    *
	    * @private
	    * @method Phaser.Physics.Arcade#tileCheckY
	    * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
	    * @param {Phaser.Tile} tile - The tile to check.
	    * @param {Phaser.TilemapLayer} tilemapLayer - The tilemapLayer to collide against.
	    * @return {number} The amount of separation that occurred.
	    */tileCheckY:function tileCheckY(body,tile,tilemapLayer){var oy=0;var tilemapLayerOffsetY=!tilemapLayer.fixedToCamera?tilemapLayer.position.y:0;if(body.deltaY()<0&&!body.blocked.up&&tile.collideDown&&body.checkCollision.up){//  Body is moving UP
	if(tile.faceBottom&&body.y-tilemapLayerOffsetY<tile.bottom){oy=body.y-tilemapLayerOffsetY-tile.bottom;if(oy<-this.TILE_BIAS){oy=0;}}}else if(body.deltaY()>0&&!body.blocked.down&&tile.collideUp&&body.checkCollision.down){//  Body is moving DOWN
	if(tile.faceTop&&body.bottom-tilemapLayerOffsetY>tile.top){oy=body.bottom-tilemapLayerOffsetY-tile.top;if(oy>this.TILE_BIAS){oy=0;}}}if(oy!==0){if(body.customSeparateY){body.overlapY=oy;}else{this.processTileSeparationY(body,oy);}}return oy;},/**
	    * Internal function to process the separation of a physics body from a tile.
	    *
	    * @private
	    * @method Phaser.Physics.Arcade#processTileSeparationX
	    * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
	    * @param {number} x - The x separation amount.
	    */processTileSeparationX:function processTileSeparationX(body,x){if(x<0){body.blocked.left=true;}else if(x>0){body.blocked.right=true;}body.position.x-=x;if(body.bounce.x===0){body.velocity.x=0;}else{body.velocity.x=-body.velocity.x*body.bounce.x;}},/**
	    * Internal function to process the separation of a physics body from a tile.
	    *
	    * @private
	    * @method Phaser.Physics.Arcade#processTileSeparationY
	    * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
	    * @param {number} y - The y separation amount.
	    */processTileSeparationY:function processTileSeparationY(body,y){if(y<0){body.blocked.up=true;}else if(y>0){body.blocked.down=true;}body.position.y-=y;if(body.bounce.y===0){body.velocity.y=0;}else{body.velocity.y=-body.velocity.y*body.bounce.y;}}};//  Merge this with the Arcade Physics prototype
	Phaser.Utils.mixinPrototype(Phaser.Physics.Arcade.prototype,Phaser.Physics.Arcade.TilemapCollision.prototype);/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*///  Add an extra properties to p2 that we need
	p2.Body.prototype.parent=null;p2.Spring.prototype.parent=null;/**
	* This is your main access to the P2 Physics World.
	* From here you can create materials, listen for events and add bodies into the physics simulation.
	* 
	* @class Phaser.Physics.P2
	* @constructor
	* @param {Phaser.Game} game - Reference to the current game instance.
	* @param {object} [config] - Physics configuration object passed in from the game constructor.
	*/Phaser.Physics.P2=function(game,config){/**
	    * @property {Phaser.Game} game - Local reference to game.
	    */this.game=game;if(config===undefined){config={gravity:[0,0],broadphase:new p2.SAPBroadphase()};}else{if(!config.hasOwnProperty('gravity')){config.gravity=[0,0];}if(!config.hasOwnProperty('broadphase')){config.broadphase=new p2.SAPBroadphase();}}/**
	    * @property {object} config - The p2 World configuration object.
	    * @protected
	    */this.config=config;/**
	    * @property {p2.World} world - The p2 World in which the simulation is run.
	    * @protected
	    */this.world=new p2.World(this.config);/**
	    * @property {number} frameRate - The frame rate the world will be stepped at. Defaults to 1 / 60, but you can change here. Also see useElapsedTime property.
	    * @default
	    */this.frameRate=1/60;/**
	    * @property {boolean} useElapsedTime - If true the frameRate value will be ignored and instead p2 will step with the value of Game.Time.physicsElapsed, which is a delta time value.
	    * @default
	    */this.useElapsedTime=false;/**
	    * @property {boolean} paused - The paused state of the P2 World.
	    * @default
	    */this.paused=false;/**
	    * @property {array<Phaser.Physics.P2.Material>} materials - A local array of all created Materials.
	    * @protected
	    */this.materials=[];/**
	    * @property {Phaser.Physics.P2.InversePointProxy} gravity - The gravity applied to all bodies each step.
	    */this.gravity=new Phaser.Physics.P2.InversePointProxy(this,this.world.gravity);/**
	    * @property {object} walls - An object containing the 4 wall bodies that bound the physics world.
	    */this.walls={left:null,right:null,top:null,bottom:null};/**
	    * This signal is dispatched when a new Body is added to the World.
	    *
	    * It sends 1 argument: `body` which is the `Phaser.Physics.P2.Body` that was added to the world.
	    * 
	    * @property {Phaser.Signal} onBodyAdded
	    */this.onBodyAdded=new Phaser.Signal();/**
	    * This signal is dispatched when a Body is removed to the World.
	    *
	    * It sends 1 argument: `body` which is the `Phaser.Physics.P2.Body` that was removed from the world.
	    * 
	    * @property {Phaser.Signal} onBodyRemoved
	    */this.onBodyRemoved=new Phaser.Signal();/**
	    * This signal is dispatched when a Spring is added to the World.
	    *
	    * It sends 1 argument: `spring` which is either a `Phaser.Physics.P2.Spring`, `p2.LinearSpring` or `p2.RotationalSpring` that was added to the world.
	    * 
	    * @property {Phaser.Signal} onSpringAdded
	    */this.onSpringAdded=new Phaser.Signal();/**
	    * This signal is dispatched when a Spring is removed from the World.
	    *
	    * It sends 1 argument: `spring` which is either a `Phaser.Physics.P2.Spring`, `p2.LinearSpring` or `p2.RotationalSpring` that was removed from the world.
	    * 
	    * @property {Phaser.Signal} onSpringRemoved
	    */this.onSpringRemoved=new Phaser.Signal();/**
	    * This signal is dispatched when a Constraint is added to the World.
	    *
	    * It sends 1 argument: `constraint` which is the `Phaser.Physics.P2.Constraint` that was added to the world.
	    * 
	    * @property {Phaser.Signal} onConstraintAdded
	    */this.onConstraintAdded=new Phaser.Signal();/**
	    * This signal is dispatched when a Constraint is removed from the World.
	    *
	    * It sends 1 argument: `constraint` which is the `Phaser.Physics.P2.Constraint` that was removed from the world.
	    * 
	    * @property {Phaser.Signal} onConstraintRemoved
	    */this.onConstraintRemoved=new Phaser.Signal();/**
	    * This signal is dispatched when a Contact Material is added to the World.
	    *
	    * It sends 1 argument: `material` which is the `Phaser.Physics.P2.ContactMaterial` that was added to the world.
	    * 
	    * @property {Phaser.Signal} onContactMaterialAdded
	    */this.onContactMaterialAdded=new Phaser.Signal();/**
	    * This signal is dispatched when a Contact Material is removed from the World.
	    *
	    * It sends 1 argument: `material` which is the `Phaser.Physics.P2.ContactMaterial` that was removed from the world.
	    * 
	    * @property {Phaser.Signal} onContactMaterialRemoved
	    */this.onContactMaterialRemoved=new Phaser.Signal();/**
	    * @property {function} postBroadphaseCallback - A postBroadphase callback.
	    */this.postBroadphaseCallback=null;/**
	    * @property {object} callbackContext - The context under which the callbacks are fired.
	    */this.callbackContext=null;/**
	    * This Signal is dispatched when a first contact is created between two bodies. This happens *before* the step has been done.
	    * 
	    * It sends 5 arguments: `bodyA`, `bodyB`, `shapeA`, `shapeB` and `contactEquations`.
	    * 
	    * It is possible that in certain situations the `bodyA` or `bodyB` values are `null`. You should check for this
	    * in your own code to avoid processing potentially null physics bodies.
	    * 
	    * @property {Phaser.Signal} onBeginContact
	    */this.onBeginContact=new Phaser.Signal();/**
	    * This Signal is dispatched when final contact occurs between two bodies. This happens *before* the step has been done.
	    * 
	    * It sends 4 arguments: `bodyA`, `bodyB`, `shapeA` and `shapeB`.
	    * 
	    * It is possible that in certain situations the `bodyA` or `bodyB` values are `null`. You should check for this
	    * in your own code to avoid processing potentially null physics bodies.
	    * 
	    * @property {Phaser.Signal} onEndContact
	    */this.onEndContact=new Phaser.Signal();//  Pixel to meter function overrides
	if(config.hasOwnProperty('mpx')&&config.hasOwnProperty('pxm')&&config.hasOwnProperty('mpxi')&&config.hasOwnProperty('pxmi')){this.mpx=config.mpx;this.mpxi=config.mpxi;this.pxm=config.pxm;this.pxmi=config.pxmi;}//  Hook into the World events
	this.world.on("beginContact",this.beginContactHandler,this);this.world.on("endContact",this.endContactHandler,this);/**
	    * @property {array} collisionGroups - An array containing the collision groups that have been defined in the World.
	    */this.collisionGroups=[];/**
	    * @property {Phaser.Physics.P2.CollisionGroup} nothingCollisionGroup - A default collision group.
	    */this.nothingCollisionGroup=new Phaser.Physics.P2.CollisionGroup(1);/**
	    * @property {Phaser.Physics.P2.CollisionGroup} boundsCollisionGroup - A default collision group.
	    */this.boundsCollisionGroup=new Phaser.Physics.P2.CollisionGroup(2);/**
	    * @property {Phaser.Physics.P2.CollisionGroup} everythingCollisionGroup - A default collision group.
	    */this.everythingCollisionGroup=new Phaser.Physics.P2.CollisionGroup(2147483648);/**
	    * @property {array} boundsCollidesWith - An array of the bodies the world bounds collides with.
	    */this.boundsCollidesWith=[];/**
	    * @property {array} _toRemove - Internal var used to hold references to bodies to remove from the world on the next step.
	    * @private
	    */this._toRemove=[];/**
	    * @property {number} _collisionGroupID - Internal var.
	    * @private
	    */this._collisionGroupID=2;/**
	    * @property {boolean} _boundsLeft - Internal var that keeps track of world bounds settings.
	    * @private
	    */this._boundsLeft=true;/**
	    * @property {boolean} _boundsRight - Internal var that keeps track of world bounds settings.
	    * @private
	    */this._boundsRight=true;/**
	    * @property {boolean} _boundsTop - Internal var that keeps track of world bounds settings.
	    * @private
	    */this._boundsTop=true;/**
	    * @property {boolean} _boundsBottom - Internal var that keeps track of world bounds settings.
	    * @private
	    */this._boundsBottom=true;/**
	    * @property {boolean} _boundsOwnGroup - Internal var that keeps track of world bounds settings.
	    * @private
	    */this._boundsOwnGroup=false;//  By default we want everything colliding with everything
	this.setBoundsToWorld(true,true,true,true,false);};Phaser.Physics.P2.prototype={/**
	    * This will add a P2 Physics body into the removal list for the next step.
	    *
	    * @method Phaser.Physics.P2#removeBodyNextStep
	    * @param {Phaser.Physics.P2.Body} body - The body to remove at the start of the next step.
	    */removeBodyNextStep:function removeBodyNextStep(body){this._toRemove.push(body);},/**
	    * Called at the start of the core update loop. Purges flagged bodies from the world.
	    *
	    * @method Phaser.Physics.P2#preUpdate
	    */preUpdate:function preUpdate(){var i=this._toRemove.length;while(i--){this.removeBody(this._toRemove[i]);}this._toRemove.length=0;},/**
	    * This will create a P2 Physics body on the given game object or array of game objects.
	    * A game object can only have 1 physics body active at any one time, and it can't be changed until the object is destroyed.
	    * Note: When the game object is enabled for P2 physics it has its anchor x/y set to 0.5 so it becomes centered.
	    *
	    * @method Phaser.Physics.P2#enable
	    * @param {object|array|Phaser.Group} object - The game object to create the physics body on. Can also be an array or Group of objects, a body will be created on every child that has a `body` property.
	    * @param {boolean} [debug=false] - Create a debug object to go with this body?
	    * @param {boolean} [children=true] - Should a body be created on all children of this object? If true it will recurse down the display list as far as it can go.
	    */enable:function enable(object,debug,children){if(debug===undefined){debug=false;}if(children===undefined){children=true;}var i=1;if(Array.isArray(object)){i=object.length;while(i--){if(object[i]instanceof Phaser.Group){//  If it's a Group then we do it on the children regardless
	this.enable(object[i].children,debug,children);}else{this.enableBody(object[i],debug);if(children&&object[i].hasOwnProperty('children')&&object[i].children.length>0){this.enable(object[i],debug,true);}}}}else{if(object instanceof Phaser.Group){//  If it's a Group then we do it on the children regardless
	this.enable(object.children,debug,children);}else{this.enableBody(object,debug);if(children&&object.hasOwnProperty('children')&&object.children.length>0){this.enable(object.children,debug,true);}}}},/**
	    * Creates a P2 Physics body on the given game object.
	    * A game object can only have 1 physics body active at any one time, and it can't be changed until the body is nulled.
	    *
	    * @method Phaser.Physics.P2#enableBody
	    * @param {object} object - The game object to create the physics body on. A body will only be created if this object has a null `body` property.
	    * @param {boolean} debug - Create a debug object to go with this body?
	    */enableBody:function enableBody(object,debug){if(object.hasOwnProperty('body')&&object.body===null){object.body=new Phaser.Physics.P2.Body(this.game,object,object.x,object.y,1);object.body.debug=debug;if(typeof object.anchor!=='undefined'){object.anchor.set(0.5);}}},/**
	    * Impact event handling is disabled by default. Enable it before any impact events will be dispatched.
	    * In a busy world hundreds of impact events can be generated every step, so only enable this if you cannot do what you need via beginContact or collision masks.
	    *
	    * @method Phaser.Physics.P2#setImpactEvents
	    * @param {boolean} state - Set to true to enable impact events, or false to disable.
	    */setImpactEvents:function setImpactEvents(state){if(state){this.world.on("impact",this.impactHandler,this);}else{this.world.off("impact",this.impactHandler,this);}},/**
	    * Sets a callback to be fired after the Broadphase has collected collision pairs in the world.
	    * Just because a pair exists it doesn't mean they *will* collide, just that they potentially could do.
	    * If your calback returns `false` the pair will be removed from the narrowphase. This will stop them testing for collision this step.
	    * Returning `true` from the callback will ensure they are checked in the narrowphase.
	    *
	    * @method Phaser.Physics.P2#setPostBroadphaseCallback
	    * @param {function} callback - The callback that will receive the postBroadphase event data. It must return a boolean. Set to null to disable an existing callback.
	    * @param {object} context - The context under which the callback will be fired.
	    */setPostBroadphaseCallback:function setPostBroadphaseCallback(callback,context){this.postBroadphaseCallback=callback;this.callbackContext=context;if(callback!==null){this.world.on("postBroadphase",this.postBroadphaseHandler,this);}else{this.world.off("postBroadphase",this.postBroadphaseHandler,this);}},/**
	    * Internal handler for the postBroadphase event.
	    *
	    * @method Phaser.Physics.P2#postBroadphaseHandler
	    * @private
	    * @param {object} event - The event data.
	    */postBroadphaseHandler:function postBroadphaseHandler(event){if(!this.postBroadphaseCallback||event.pairs.length===0){return;}for(var i=event.pairs.length-2;i>=0;i-=2){if(event.pairs[i].parent&&event.pairs[i+1].parent&&!this.postBroadphaseCallback.call(this.callbackContext,event.pairs[i].parent,event.pairs[i+1].parent)){event.pairs.splice(i,2);}}},/**
	    * Handles a p2 impact event.
	    *
	    * @method Phaser.Physics.P2#impactHandler
	    * @private
	    * @param {object} event - The event data.
	    */impactHandler:function impactHandler(event){if(event.bodyA.parent&&event.bodyB.parent){//  Body vs. Body callbacks
	var a=event.bodyA.parent;var b=event.bodyB.parent;if(a._bodyCallbacks[event.bodyB.id]){a._bodyCallbacks[event.bodyB.id].call(a._bodyCallbackContext[event.bodyB.id],a,b,event.shapeA,event.shapeB);}if(b._bodyCallbacks[event.bodyA.id]){b._bodyCallbacks[event.bodyA.id].call(b._bodyCallbackContext[event.bodyA.id],b,a,event.shapeB,event.shapeA);}//  Body vs. Group callbacks
	if(a._groupCallbacks[event.shapeB.collisionGroup]){a._groupCallbacks[event.shapeB.collisionGroup].call(a._groupCallbackContext[event.shapeB.collisionGroup],a,b,event.shapeA,event.shapeB);}if(b._groupCallbacks[event.shapeA.collisionGroup]){b._groupCallbacks[event.shapeA.collisionGroup].call(b._groupCallbackContext[event.shapeA.collisionGroup],b,a,event.shapeB,event.shapeA);}}},/**
	    * Handles a p2 begin contact event.
	    *
	    * @method Phaser.Physics.P2#beginContactHandler
	    * @param {object} event - The event data.
	    */beginContactHandler:function beginContactHandler(event){if(event.bodyA&&event.bodyB){this.onBeginContact.dispatch(event.bodyA,event.bodyB,event.shapeA,event.shapeB,event.contactEquations);if(event.bodyA.parent){event.bodyA.parent.onBeginContact.dispatch(event.bodyB.parent,event.bodyB,event.shapeA,event.shapeB,event.contactEquations);}if(event.bodyB.parent){event.bodyB.parent.onBeginContact.dispatch(event.bodyA.parent,event.bodyA,event.shapeB,event.shapeA,event.contactEquations);}}},/**
	    * Handles a p2 end contact event.
	    *
	    * @method Phaser.Physics.P2#endContactHandler
	    * @param {object} event - The event data.
	    */endContactHandler:function endContactHandler(event){if(event.bodyA&&event.bodyB){this.onEndContact.dispatch(event.bodyA,event.bodyB,event.shapeA,event.shapeB);if(event.bodyA.parent){event.bodyA.parent.onEndContact.dispatch(event.bodyB.parent,event.bodyB,event.shapeA,event.shapeB);}if(event.bodyB.parent){event.bodyB.parent.onEndContact.dispatch(event.bodyA.parent,event.bodyA,event.shapeB,event.shapeA);}}},/**
	    * Sets the bounds of the Physics world to match the Game.World dimensions.
	    * You can optionally set which 'walls' to create: left, right, top or bottom.
	    *
	    * @method Phaser.Physics#setBoundsToWorld
	    * @param {boolean} [left=true] - If true will create the left bounds wall.
	    * @param {boolean} [right=true] - If true will create the right bounds wall.
	    * @param {boolean} [top=true] - If true will create the top bounds wall.
	    * @param {boolean} [bottom=true] - If true will create the bottom bounds wall.
	    * @param {boolean} [setCollisionGroup=true] - If true the Bounds will be set to use its own Collision Group.
	    */setBoundsToWorld:function setBoundsToWorld(left,right,top,bottom,setCollisionGroup){this.setBounds(this.game.world.bounds.x,this.game.world.bounds.y,this.game.world.bounds.width,this.game.world.bounds.height,left,right,top,bottom,setCollisionGroup);},/**
	    * Sets the given material against the 4 bounds of this World.
	    *
	    * @method Phaser.Physics#setWorldMaterial
	    * @param {Phaser.Physics.P2.Material} material - The material to set.
	    * @param {boolean} [left=true] - If true will set the material on the left bounds wall.
	    * @param {boolean} [right=true] - If true will set the material on the right bounds wall.
	    * @param {boolean} [top=true] - If true will set the material on the top bounds wall.
	    * @param {boolean} [bottom=true] - If true will set the material on the bottom bounds wall.
	    */setWorldMaterial:function setWorldMaterial(material,left,right,top,bottom){if(left===undefined){left=true;}if(right===undefined){right=true;}if(top===undefined){top=true;}if(bottom===undefined){bottom=true;}if(left&&this.walls.left){this.walls.left.shapes[0].material=material;}if(right&&this.walls.right){this.walls.right.shapes[0].material=material;}if(top&&this.walls.top){this.walls.top.shapes[0].material=material;}if(bottom&&this.walls.bottom){this.walls.bottom.shapes[0].material=material;}},/**
	    * By default the World will be set to collide everything with everything. The bounds of the world is a Body with 4 shapes, one for each face.
	    * If you start to use your own collision groups then your objects will no longer collide with the bounds.
	    * To fix this you need to adjust the bounds to use its own collision group first BEFORE changing your Sprites collision group.
	    *
	    * @method Phaser.Physics.P2#updateBoundsCollisionGroup
	    * @param {boolean} [setCollisionGroup=true] - If true the Bounds will be set to use its own Collision Group.
	    */updateBoundsCollisionGroup:function updateBoundsCollisionGroup(setCollisionGroup){if(setCollisionGroup===undefined){setCollisionGroup=true;}var mask=setCollisionGroup?this.boundsCollisionGroup.mask:this.everythingCollisionGroup.mask;if(this.walls.left){this.walls.left.shapes[0].collisionGroup=mask;}if(this.walls.right){this.walls.right.shapes[0].collisionGroup=mask;}if(this.walls.top){this.walls.top.shapes[0].collisionGroup=mask;}if(this.walls.bottom){this.walls.bottom.shapes[0].collisionGroup=mask;}this._boundsOwnGroup=setCollisionGroup;},/**
	    * Sets the bounds of the Physics world to match the given world pixel dimensions.
	    * You can optionally set which 'walls' to create: left, right, top or bottom.
	    * If none of the walls are given it will default to use the walls settings it had previously.
	    * I.e. if you previously told it to not have the left or right walls, and you then adjust the world size
	    * the newly created bounds will also not have the left and right walls.
	    * Explicitly state them in the parameters to override this.
	    *
	    * @method Phaser.Physics.P2#setBounds
	    * @param {number} x - The x coordinate of the top-left corner of the bounds.
	    * @param {number} y - The y coordinate of the top-left corner of the bounds.
	    * @param {number} width - The width of the bounds.
	    * @param {number} height - The height of the bounds.
	    * @param {boolean} [left=true] - If true will create the left bounds wall.
	    * @param {boolean} [right=true] - If true will create the right bounds wall.
	    * @param {boolean} [top=true] - If true will create the top bounds wall.
	    * @param {boolean} [bottom=true] - If true will create the bottom bounds wall.
	    * @param {boolean} [setCollisionGroup=true] - If true the Bounds will be set to use its own Collision Group.
	    */setBounds:function setBounds(x,y,width,height,left,right,top,bottom,setCollisionGroup){if(left===undefined){left=this._boundsLeft;}if(right===undefined){right=this._boundsRight;}if(top===undefined){top=this._boundsTop;}if(bottom===undefined){bottom=this._boundsBottom;}if(setCollisionGroup===undefined){setCollisionGroup=this._boundsOwnGroup;}this.setupWall(left,'left',x,y,1.5707963267948966,setCollisionGroup);this.setupWall(right,'right',x+width,y,-1.5707963267948966,setCollisionGroup);this.setupWall(top,'top',x,y,-3.141592653589793,setCollisionGroup);this.setupWall(bottom,'bottom',x,y+height,0,setCollisionGroup);//  Remember the bounds settings in case they change later on via World.setBounds
	this._boundsLeft=left;this._boundsRight=right;this._boundsTop=top;this._boundsBottom=bottom;this._boundsOwnGroup=setCollisionGroup;},/**
	    * Internal method called by setBounds. Responsible for creating, updating or 
	    * removing the wall body shapes.
	    *
	    * @method Phaser.Physics.P2#setupWall
	    * @private
	    * @param {boolean} create - True to create the wall shape, false to remove it.
	    * @param {string} wall - The wall segment to update.
	    * @param {number} x - The x coordinate of the wall.
	    * @param {number} y - The y coordinate of the wall.
	    * @param {float} angle - The angle of the wall.
	    * @param {boolean} [setCollisionGroup=true] - If true the Bounds will be set to use its own Collision Group.
	    */setupWall:function setupWall(create,wall,x,y,angle,setCollisionGroup){if(create){//  We need a left wall. Do we have one already?
	if(this.walls[wall]){this.walls[wall].position=[this.pxmi(x),this.pxmi(y)];}else{this.walls[wall]=new p2.Body({mass:0,position:[this.pxmi(x),this.pxmi(y)],angle:angle});this.walls[wall].addShape(new p2.Plane());this.world.addBody(this.walls[wall]);}if(setCollisionGroup){this.walls[wall].shapes[0].collisionGroup=this.boundsCollisionGroup.mask;}}else{if(this.walls[wall]){this.world.removeBody(this.walls[wall]);this.walls[wall]=null;}}},/**
	    * Pauses the P2 World independent of the game pause state.
	    *
	    * @method Phaser.Physics.P2#pause
	    */pause:function pause(){this.paused=true;},/**
	    * Resumes a paused P2 World.
	    *
	    * @method Phaser.Physics.P2#resume
	    */resume:function resume(){this.paused=false;},/**
	    * Internal P2 update loop.
	    *
	    * @method Phaser.Physics.P2#update
	    */update:function update(){// Do nothing if the physics engine was paused before
	if(this.paused){return;}if(this.useElapsedTime){this.world.step(this.game.time.physicsElapsed);}else{this.world.step(this.frameRate);}},/**
	    * Called by Phaser.Physics when a State swap occurs.
	    * Starts the begin and end Contact listeners again.
	    *
	    * @method Phaser.Physics.P2#reset
	    */reset:function reset(){this.world.on("beginContact",this.beginContactHandler,this);this.world.on("endContact",this.endContactHandler,this);this.nothingCollisionGroup=new Phaser.Physics.P2.CollisionGroup(1);this.boundsCollisionGroup=new Phaser.Physics.P2.CollisionGroup(2);this.everythingCollisionGroup=new Phaser.Physics.P2.CollisionGroup(2147483648);this._collisionGroupID=2;this.setBoundsToWorld(true,true,true,true,false);},/**
	    * Clears all bodies from the simulation, resets callbacks and resets the collision bitmask.
	    * 
	    * The P2 world is also cleared:
	    * 
	    * * Removes all solver equations
	    * * Removes all constraints
	    * * Removes all bodies
	    * * Removes all springs
	    * * Removes all contact materials
	    * 
	    * This is called automatically when you switch state.
	    *
	    * @method Phaser.Physics.P2#clear
	    */clear:function clear(){this.world.time=0;this.world.fixedStepTime=0;// Remove all solver equations
	if(this.world.solver&&this.world.solver.equations.length){this.world.solver.removeAllEquations();}// Remove all constraints
	var cs=this.world.constraints;for(var i=cs.length-1;i>=0;i--){this.world.removeConstraint(cs[i]);}// Remove all bodies
	var bodies=this.world.bodies;for(var i=bodies.length-1;i>=0;i--){this.world.removeBody(bodies[i]);}// Remove all springs
	var springs=this.world.springs;for(var i=springs.length-1;i>=0;i--){this.world.removeSpring(springs[i]);}// Remove all contact materials
	var cms=this.world.contactMaterials;for(var i=cms.length-1;i>=0;i--){this.world.removeContactMaterial(cms[i]);}this.world.off("beginContact",this.beginContactHandler,this);this.world.off("endContact",this.endContactHandler,this);this.postBroadphaseCallback=null;this.callbackContext=null;this.impactCallback=null;this.collisionGroups=[];this._toRemove=[];this.boundsCollidesWith=[];//  Remove the world bounds
	this.walls={left:null,right:null,top:null,bottom:null};},/**
	    * Clears all bodies from the simulation and unlinks World from Game. Should only be called on game shutdown. Call `clear` on a State change.
	    *
	    * @method Phaser.Physics.P2#destroy
	    */destroy:function destroy(){this.clear();this.game=null;},/**
	    * Add a body to the world.
	    *
	    * @method Phaser.Physics.P2#addBody
	    * @param {Phaser.Physics.P2.Body} body - The Body to add to the World.
	    * @return {boolean} True if the Body was added successfully, otherwise false.
	    */addBody:function addBody(body){if(body.data.world){return false;}else{this.world.addBody(body.data);this.onBodyAdded.dispatch(body);return true;}},/**
	    * Removes a body from the world. This will silently fail if the body wasn't part of the world to begin with.
	    *
	    * @method Phaser.Physics.P2#removeBody
	    * @param {Phaser.Physics.P2.Body} body - The Body to remove from the World.
	    * @return {Phaser.Physics.P2.Body} The Body that was removed.
	    */removeBody:function removeBody(body){if(body.data.world===this.world){this.world.removeBody(body.data);this.onBodyRemoved.dispatch(body);}return body;},/**
	    * Adds a Spring to the world.
	    *
	    * @method Phaser.Physics.P2#addSpring
	    * @param {Phaser.Physics.P2.Spring|p2.LinearSpring|p2.RotationalSpring} spring - The Spring to add to the World.
	    * @return {Phaser.Physics.P2.Spring} The Spring that was added.
	    */addSpring:function addSpring(spring){if(spring instanceof Phaser.Physics.P2.Spring||spring instanceof Phaser.Physics.P2.RotationalSpring){this.world.addSpring(spring.data);}else{this.world.addSpring(spring);}this.onSpringAdded.dispatch(spring);return spring;},/**
	    * Removes a Spring from the world.
	    *
	    * @method Phaser.Physics.P2#removeSpring
	    * @param {Phaser.Physics.P2.Spring} spring - The Spring to remove from the World.
	    * @return {Phaser.Physics.P2.Spring} The Spring that was removed.
	    */removeSpring:function removeSpring(spring){if(spring instanceof Phaser.Physics.P2.Spring||spring instanceof Phaser.Physics.P2.RotationalSpring){this.world.removeSpring(spring.data);}else{this.world.removeSpring(spring);}this.onSpringRemoved.dispatch(spring);return spring;},/**
	    * Creates a constraint that tries to keep the distance between two bodies constant.
	    *
	    * @method Phaser.Physics.P2#createDistanceConstraint
	    * @param {Phaser.Sprite|Phaser.Physics.P2.Body|p2.Body} bodyA - First connected body.
	    * @param {Phaser.Sprite|Phaser.Physics.P2.Body|p2.Body} bodyB - Second connected body.
	    * @param {number} distance - The distance to keep between the bodies.
	    * @param {Array} [localAnchorA] - The anchor point for bodyA, defined locally in bodyA frame. Defaults to [0,0].
	    * @param {Array} [localAnchorB] - The anchor point for bodyB, defined locally in bodyB frame. Defaults to [0,0].
	    * @param {number} [maxForce] - The maximum force that should be applied to constrain the bodies.
	    * @return {Phaser.Physics.P2.DistanceConstraint} The constraint
	    */createDistanceConstraint:function createDistanceConstraint(bodyA,bodyB,distance,localAnchorA,localAnchorB,maxForce){bodyA=this.getBody(bodyA);bodyB=this.getBody(bodyB);if(!bodyA||!bodyB){console.warn('Cannot create Constraint, invalid body objects given');}else{return this.addConstraint(new Phaser.Physics.P2.DistanceConstraint(this,bodyA,bodyB,distance,localAnchorA,localAnchorB,maxForce));}},/**
	    * Creates a constraint that tries to keep the distance between two bodies constant.
	    *
	    * @method Phaser.Physics.P2#createGearConstraint
	    * @param {Phaser.Sprite|Phaser.Physics.P2.Body|p2.Body} bodyA - First connected body.
	    * @param {Phaser.Sprite|Phaser.Physics.P2.Body|p2.Body} bodyB - Second connected body.
	    * @param {number} [angle=0] - The relative angle
	    * @param {number} [ratio=1] - The gear ratio.
	    * @return {Phaser.Physics.P2.GearConstraint} The constraint
	    */createGearConstraint:function createGearConstraint(bodyA,bodyB,angle,ratio){bodyA=this.getBody(bodyA);bodyB=this.getBody(bodyB);if(!bodyA||!bodyB){console.warn('Cannot create Constraint, invalid body objects given');}else{return this.addConstraint(new Phaser.Physics.P2.GearConstraint(this,bodyA,bodyB,angle,ratio));}},/**
	    * Connects two bodies at given offset points, letting them rotate relative to each other around this point.
	    * The pivot points are given in world (pixel) coordinates.
	    *
	    * @method Phaser.Physics.P2#createRevoluteConstraint
	    * @param {Phaser.Sprite|Phaser.Physics.P2.Body|p2.Body} bodyA - First connected body.
	    * @param {Array} pivotA - The point relative to the center of mass of bodyA which bodyA is constrained to. The value is an array with 2 elements matching x and y, i.e: [32, 32].
	    * @param {Phaser.Sprite|Phaser.Physics.P2.Body|p2.Body} bodyB - Second connected body.
	    * @param {Array} pivotB - The point relative to the center of mass of bodyB which bodyB is constrained to. The value is an array with 2 elements matching x and y, i.e: [32, 32].
	    * @param {number} [maxForce=0] - The maximum force that should be applied to constrain the bodies.
	    * @param {Float32Array} [worldPivot=null] - A pivot point given in world coordinates. If specified, localPivotA and localPivotB are automatically computed from this value.
	    * @return {Phaser.Physics.P2.RevoluteConstraint} The constraint
	    */createRevoluteConstraint:function createRevoluteConstraint(bodyA,pivotA,bodyB,pivotB,maxForce,worldPivot){bodyA=this.getBody(bodyA);bodyB=this.getBody(bodyB);if(!bodyA||!bodyB){console.warn('Cannot create Constraint, invalid body objects given');}else{return this.addConstraint(new Phaser.Physics.P2.RevoluteConstraint(this,bodyA,pivotA,bodyB,pivotB,maxForce,worldPivot));}},/**
	    * Locks the relative position between two bodies.
	    *
	    * @method Phaser.Physics.P2#createLockConstraint
	    * @param {Phaser.Sprite|Phaser.Physics.P2.Body|p2.Body} bodyA - First connected body.
	    * @param {Phaser.Sprite|Phaser.Physics.P2.Body|p2.Body} bodyB - Second connected body.
	    * @param {Array} [offset] - The offset of bodyB in bodyA's frame. The value is an array with 2 elements matching x and y, i.e: [32, 32].
	    * @param {number} [angle=0] - The angle of bodyB in bodyA's frame.
	    * @param {number} [maxForce] - The maximum force that should be applied to constrain the bodies.
	    * @return {Phaser.Physics.P2.LockConstraint} The constraint
	    */createLockConstraint:function createLockConstraint(bodyA,bodyB,offset,angle,maxForce){bodyA=this.getBody(bodyA);bodyB=this.getBody(bodyB);if(!bodyA||!bodyB){console.warn('Cannot create Constraint, invalid body objects given');}else{return this.addConstraint(new Phaser.Physics.P2.LockConstraint(this,bodyA,bodyB,offset,angle,maxForce));}},/**
	    * Constraint that only allows bodies to move along a line, relative to each other.
	    * See http://www.iforce2d.net/b2dtut/joints-prismatic
	    *
	    * @method Phaser.Physics.P2#createPrismaticConstraint
	    * @param {Phaser.Sprite|Phaser.Physics.P2.Body|p2.Body} bodyA - First connected body.
	    * @param {Phaser.Sprite|Phaser.Physics.P2.Body|p2.Body} bodyB - Second connected body.
	    * @param {boolean} [lockRotation=true] - If set to false, bodyB will be free to rotate around its anchor point.
	    * @param {Array} [anchorA] - Body A's anchor point, defined in its own local frame. The value is an array with 2 elements matching x and y, i.e: [32, 32].
	    * @param {Array} [anchorB] - Body A's anchor point, defined in its own local frame. The value is an array with 2 elements matching x and y, i.e: [32, 32].
	    * @param {Array} [axis] - An axis, defined in body A frame, that body B's anchor point may slide along. The value is an array with 2 elements matching x and y, i.e: [32, 32].
	    * @param {number} [maxForce] - The maximum force that should be applied to constrain the bodies.
	    * @return {Phaser.Physics.P2.PrismaticConstraint} The constraint
	    */createPrismaticConstraint:function createPrismaticConstraint(bodyA,bodyB,lockRotation,anchorA,anchorB,axis,maxForce){bodyA=this.getBody(bodyA);bodyB=this.getBody(bodyB);if(!bodyA||!bodyB){console.warn('Cannot create Constraint, invalid body objects given');}else{return this.addConstraint(new Phaser.Physics.P2.PrismaticConstraint(this,bodyA,bodyB,lockRotation,anchorA,anchorB,axis,maxForce));}},/**
	    * Adds a Constraint to the world.
	    *
	    * @method Phaser.Physics.P2#addConstraint
	    * @param {Phaser.Physics.P2.Constraint} constraint - The Constraint to add to the World.
	    * @return {Phaser.Physics.P2.Constraint} The Constraint that was added.
	    */addConstraint:function addConstraint(constraint){this.world.addConstraint(constraint);this.onConstraintAdded.dispatch(constraint);return constraint;},/**
	    * Removes a Constraint from the world.
	    *
	    * @method Phaser.Physics.P2#removeConstraint
	    * @param {Phaser.Physics.P2.Constraint} constraint - The Constraint to be removed from the World.
	    * @return {Phaser.Physics.P2.Constraint} The Constraint that was removed.
	    */removeConstraint:function removeConstraint(constraint){this.world.removeConstraint(constraint);this.onConstraintRemoved.dispatch(constraint);return constraint;},/**
	    * Adds a Contact Material to the world.
	    *
	    * @method Phaser.Physics.P2#addContactMaterial
	    * @param {Phaser.Physics.P2.ContactMaterial} material - The Contact Material to be added to the World.
	    * @return {Phaser.Physics.P2.ContactMaterial} The Contact Material that was added.
	    */addContactMaterial:function addContactMaterial(material){this.world.addContactMaterial(material);this.onContactMaterialAdded.dispatch(material);return material;},/**
	    * Removes a Contact Material from the world.
	    *
	    * @method Phaser.Physics.P2#removeContactMaterial
	    * @param {Phaser.Physics.P2.ContactMaterial} material - The Contact Material to be removed from the World.
	    * @return {Phaser.Physics.P2.ContactMaterial} The Contact Material that was removed.
	    */removeContactMaterial:function removeContactMaterial(material){this.world.removeContactMaterial(material);this.onContactMaterialRemoved.dispatch(material);return material;},/**
	    * Gets a Contact Material based on the two given Materials.
	    *
	    * @method Phaser.Physics.P2#getContactMaterial
	    * @param {Phaser.Physics.P2.Material} materialA - The first Material to search for.
	    * @param {Phaser.Physics.P2.Material} materialB - The second Material to search for.
	    * @return {Phaser.Physics.P2.ContactMaterial|boolean} The Contact Material or false if none was found matching the Materials given.
	    */getContactMaterial:function getContactMaterial(materialA,materialB){return this.world.getContactMaterial(materialA,materialB);},/**
	    * Sets the given Material against all Shapes owned by all the Bodies in the given array.
	    *
	    * @method Phaser.Physics.P2#setMaterial
	    * @param {Phaser.Physics.P2.Material} material - The Material to be applied to the given Bodies.
	    * @param {array<Phaser.Physics.P2.Body>} bodies - An Array of Body objects that the given Material will be set on.
	    */setMaterial:function setMaterial(material,bodies){var i=bodies.length;while(i--){bodies[i].setMaterial(material);}},/**
	    * Creates a Material. Materials are applied to Shapes owned by a Body and can be set with Body.setMaterial().
	    * Materials are a way to control what happens when Shapes collide. Combine unique Materials together to create Contact Materials.
	    * Contact Materials have properties such as friction and restitution that allow for fine-grained collision control between different Materials.
	    *
	    * @method Phaser.Physics.P2#createMaterial
	    * @param {string} [name] - Optional name of the Material. Each Material has a unique ID but string names are handy for debugging.
	    * @param {Phaser.Physics.P2.Body} [body] - Optional Body. If given it will assign the newly created Material to the Body shapes.
	    * @return {Phaser.Physics.P2.Material} The Material that was created. This is also stored in Phaser.Physics.P2.materials.
	    */createMaterial:function createMaterial(name,body){name=name||'';var material=new Phaser.Physics.P2.Material(name);this.materials.push(material);if(typeof body!=='undefined'){body.setMaterial(material);}return material;},/**
	    * Creates a Contact Material from the two given Materials. You can then edit the properties of the Contact Material directly.
	    *
	    * @method Phaser.Physics.P2#createContactMaterial
	    * @param {Phaser.Physics.P2.Material} [materialA] - The first Material to create the ContactMaterial from. If undefined it will create a new Material object first.
	    * @param {Phaser.Physics.P2.Material} [materialB] - The second Material to create the ContactMaterial from. If undefined it will create a new Material object first.
	    * @param {object} [options] - Material options object.
	    * @return {Phaser.Physics.P2.ContactMaterial} The Contact Material that was created.
	    */createContactMaterial:function createContactMaterial(materialA,materialB,options){if(materialA===undefined){materialA=this.createMaterial();}if(materialB===undefined){materialB=this.createMaterial();}var contact=new Phaser.Physics.P2.ContactMaterial(materialA,materialB,options);return this.addContactMaterial(contact);},/**
	    * Populates and returns an array with references to of all current Bodies in the world.
	    *
	    * @method Phaser.Physics.P2#getBodies
	    * @return {array<Phaser.Physics.P2.Body>} An array containing all current Bodies in the world.
	    */getBodies:function getBodies(){var output=[];var i=this.world.bodies.length;while(i--){output.push(this.world.bodies[i].parent);}return output;},/**
	    * Checks the given object to see if it has a p2.Body and if so returns it.
	    *
	    * @method Phaser.Physics.P2#getBody
	    * @param {object} object - The object to check for a p2.Body on.
	    * @return {p2.Body} The p2.Body, or null if not found.
	    */getBody:function getBody(object){if(object instanceof p2.Body){//  Native p2 body
	return object;}else if(object instanceof Phaser.Physics.P2.Body){//  Phaser P2 Body
	return object.data;}else if(object['body']&&object['body'].type===Phaser.Physics.P2JS){//  Sprite, TileSprite, etc
	return object.body.data;}return null;},/**
	    * Populates and returns an array of all current Springs in the world.
	    *
	    * @method Phaser.Physics.P2#getSprings
	    * @return {array<Phaser.Physics.P2.Spring>} An array containing all current Springs in the world.
	    */getSprings:function getSprings(){var output=[];var i=this.world.springs.length;while(i--){output.push(this.world.springs[i].parent);}return output;},/**
	    * Populates and returns an array of all current Constraints in the world.
	    * You will get an array of p2 constraints back. This can be of mixed types, for example the array may contain
	    * PrismaticConstraints, RevoluteConstraints or any other valid p2 constraint type.
	    *
	    * @method Phaser.Physics.P2#getConstraints
	    * @return {array<Phaser.Physics.P2.Constraint>} An array containing all current Constraints in the world.
	    */getConstraints:function getConstraints(){var output=[];var i=this.world.constraints.length;while(i--){output.push(this.world.constraints[i]);}return output;},/**
	    * Test if a world point overlaps bodies. You will get an array of actual P2 bodies back. You can find out which Sprite a Body belongs to
	    * (if any) by checking the Body.parent.sprite property. Body.parent is a Phaser.Physics.P2.Body property.
	    *
	    * @method Phaser.Physics.P2#hitTest
	    * @param {Phaser.Point} worldPoint - Point to use for intersection tests. The points values must be in world (pixel) coordinates.
	    * @param {Array<Phaser.Physics.P2.Body|Phaser.Sprite|p2.Body>} [bodies] - A list of objects to check for intersection. If not given it will check Phaser.Physics.P2.world.bodies (i.e. all world bodies)
	    * @param {number} [precision=5] - Used for matching against particles and lines. Adds some margin to these infinitesimal objects.
	    * @param {boolean} [filterStatic=false] - If true all Static objects will be removed from the results array.
	    * @return {Array} Array of bodies that overlap the point.
	    */hitTest:function hitTest(worldPoint,bodies,precision,filterStatic){if(bodies===undefined){bodies=this.world.bodies;}if(precision===undefined){precision=5;}if(filterStatic===undefined){filterStatic=false;}var physicsPosition=[this.pxmi(worldPoint.x),this.pxmi(worldPoint.y)];var query=[];var i=bodies.length;while(i--){if(bodies[i]instanceof Phaser.Physics.P2.Body&&!(filterStatic&&bodies[i].data.type===p2.Body.STATIC)){query.push(bodies[i].data);}else if(bodies[i]instanceof p2.Body&&bodies[i].parent&&!(filterStatic&&bodies[i].type===p2.Body.STATIC)){query.push(bodies[i]);}else if(bodies[i]instanceof Phaser.Sprite&&bodies[i].hasOwnProperty('body')&&!(filterStatic&&bodies[i].body.data.type===p2.Body.STATIC)){query.push(bodies[i].body.data);}}return this.world.hitTest(physicsPosition,query,precision);},/**
	    * Converts the current world into a JSON object.
	    *
	    * @method Phaser.Physics.P2#toJSON
	    * @return {object} A JSON representation of the world.
	    */toJSON:function toJSON(){return this.world.toJSON();},/**
	    * Creates a new Collision Group and optionally applies it to the given object.
	    * Collision Groups are handled using bitmasks, therefore you have a fixed limit you can create before you need to re-use older groups.
	    *
	    * @method Phaser.Physics.P2#createCollisionGroup
	    * @param {Phaser.Group|Phaser.Sprite} [object] - An optional Sprite or Group to apply the Collision Group to. If a Group is given it will be applied to all top-level children.
	    */createCollisionGroup:function createCollisionGroup(object){var bitmask=Math.pow(2,this._collisionGroupID);if(this.walls.left){this.walls.left.shapes[0].collisionMask=this.walls.left.shapes[0].collisionMask|bitmask;}if(this.walls.right){this.walls.right.shapes[0].collisionMask=this.walls.right.shapes[0].collisionMask|bitmask;}if(this.walls.top){this.walls.top.shapes[0].collisionMask=this.walls.top.shapes[0].collisionMask|bitmask;}if(this.walls.bottom){this.walls.bottom.shapes[0].collisionMask=this.walls.bottom.shapes[0].collisionMask|bitmask;}this._collisionGroupID++;var group=new Phaser.Physics.P2.CollisionGroup(bitmask);this.collisionGroups.push(group);if(object){this.setCollisionGroup(object,group);}return group;},/**
	    * Sets the given CollisionGroup to be the collision group for all shapes in this Body, unless a shape is specified.
	    * Note that this resets the collisionMask and any previously set groups. See Body.collides() for appending them.
	    *
	    * @method Phaser.Physics.P2y#setCollisionGroup
	    * @param {Phaser.Group|Phaser.Sprite} object - A Sprite or Group to apply the Collision Group to. If a Group is given it will be applied to all top-level children.
	    * @param {Phaser.Physics.CollisionGroup} group - The Collision Group that this Bodies shapes will use.
	    */setCollisionGroup:function setCollisionGroup(object,group){if(object instanceof Phaser.Group){for(var i=0;i<object.total;i++){if(object.children[i]['body']&&object.children[i]['body'].type===Phaser.Physics.P2JS){object.children[i].body.setCollisionGroup(group);}}}else{object.body.setCollisionGroup(group);}},/**
	    * Creates a linear spring, connecting two bodies. A spring can have a resting length, a stiffness and damping.
	    *
	    * @method Phaser.Physics.P2#createSpring
	    * @param {Phaser.Sprite|Phaser.Physics.P2.Body|p2.Body} bodyA - First connected body.
	    * @param {Phaser.Sprite|Phaser.Physics.P2.Body|p2.Body} bodyB - Second connected body.
	    * @param {number} [restLength=1] - Rest length of the spring. A number > 0.
	    * @param {number} [stiffness=100] - Stiffness of the spring. A number >= 0.
	    * @param {number} [damping=1] - Damping of the spring. A number >= 0.
	    * @param {Array} [worldA] - Where to hook the spring to body A in world coordinates. This value is an array by 2 elements, x and y, i.e: [32, 32].
	    * @param {Array} [worldB] - Where to hook the spring to body B in world coordinates. This value is an array by 2 elements, x and y, i.e: [32, 32].
	    * @param {Array} [localA] - Where to hook the spring to body A in local body coordinates. This value is an array by 2 elements, x and y, i.e: [32, 32].
	    * @param {Array} [localB] - Where to hook the spring to body B in local body coordinates. This value is an array by 2 elements, x and y, i.e: [32, 32].
	    * @return {Phaser.Physics.P2.Spring} The spring
	    */createSpring:function createSpring(bodyA,bodyB,restLength,stiffness,damping,worldA,worldB,localA,localB){bodyA=this.getBody(bodyA);bodyB=this.getBody(bodyB);if(!bodyA||!bodyB){console.warn('Cannot create Spring, invalid body objects given');}else{return this.addSpring(new Phaser.Physics.P2.Spring(this,bodyA,bodyB,restLength,stiffness,damping,worldA,worldB,localA,localB));}},/**
	    * Creates a rotational spring, connecting two bodies. A spring can have a resting length, a stiffness and damping.
	    *
	    * @method Phaser.Physics.P2#createRotationalSpring
	    * @param {Phaser.Sprite|Phaser.Physics.P2.Body|p2.Body} bodyA - First connected body.
	    * @param {Phaser.Sprite|Phaser.Physics.P2.Body|p2.Body} bodyB - Second connected body.
	    * @param {number} [restAngle] - The relative angle of bodies at which the spring is at rest. If not given, it's set to the current relative angle between the bodies.
	    * @param {number} [stiffness=100] - Stiffness of the spring. A number >= 0.
	    * @param {number} [damping=1] - Damping of the spring. A number >= 0.
	    * @return {Phaser.Physics.P2.RotationalSpring} The spring
	    */createRotationalSpring:function createRotationalSpring(bodyA,bodyB,restAngle,stiffness,damping){bodyA=this.getBody(bodyA);bodyB=this.getBody(bodyB);if(!bodyA||!bodyB){console.warn('Cannot create Rotational Spring, invalid body objects given');}else{return this.addSpring(new Phaser.Physics.P2.RotationalSpring(this,bodyA,bodyB,restAngle,stiffness,damping));}},/**
	    * Creates a new Body and adds it to the World.
	    *
	    * @method Phaser.Physics.P2#createBody
	    * @param {number} x - The x coordinate of Body.
	    * @param {number} y - The y coordinate of Body.
	    * @param {number} mass - The mass of the Body. A mass of 0 means a 'static' Body is created.
	    * @param {boolean} [addToWorld=false] - Automatically add this Body to the world? (usually false as it won't have any shapes on construction).
	    * @param {object} options - An object containing the build options:
	    * @param {boolean} [options.optimalDecomp=false] - Set to true if you need optimal decomposition. Warning: very slow for polygons with more than 10 vertices.
	    * @param {boolean} [options.skipSimpleCheck=false] - Set to true if you already know that the path is not intersecting itself.
	    * @param {boolean|number} [options.removeCollinearPoints=false] - Set to a number (angle threshold value) to remove collinear points, or false to keep all points.
	    * @param {(number[]|...number)} points - An array of 2d vectors that form the convex or concave polygon.
	    *                                       Either [[0,0], [0,1],...] or a flat array of numbers that will be interpreted as [x,y, x,y, ...],
	    *                                       or the arguments passed can be flat x,y values e.g. `setPolygon(options, x,y, x,y, x,y, ...)` where `x` and `y` are numbers.
	    * @return {Phaser.Physics.P2.Body} The body
	    */createBody:function createBody(x,y,mass,addToWorld,options,data){if(addToWorld===undefined){addToWorld=false;}var body=new Phaser.Physics.P2.Body(this.game,null,x,y,mass);if(data){var result=body.addPolygon(options,data);if(!result){return false;}}if(addToWorld){this.world.addBody(body.data);}return body;},/**
	    * Creates a new Particle and adds it to the World.
	    *
	    * @method Phaser.Physics.P2#createParticle
	    * @param {number} x - The x coordinate of Body.
	    * @param {number} y - The y coordinate of Body.
	    * @param {number} mass - The mass of the Body. A mass of 0 means a 'static' Body is created.
	    * @param {boolean} [addToWorld=false] - Automatically add this Body to the world? (usually false as it won't have any shapes on construction).
	    * @param {object} options - An object containing the build options:
	    * @param {boolean} [options.optimalDecomp=false] - Set to true if you need optimal decomposition. Warning: very slow for polygons with more than 10 vertices.
	    * @param {boolean} [options.skipSimpleCheck=false] - Set to true if you already know that the path is not intersecting itself.
	    * @param {boolean|number} [options.removeCollinearPoints=false] - Set to a number (angle threshold value) to remove collinear points, or false to keep all points.
	    * @param {(number[]|...number)} points - An array of 2d vectors that form the convex or concave polygon.
	    *                                       Either [[0,0], [0,1],...] or a flat array of numbers that will be interpreted as [x,y, x,y, ...],
	    *                                       or the arguments passed can be flat x,y values e.g. `setPolygon(options, x,y, x,y, x,y, ...)` where `x` and `y` are numbers.
	    */createParticle:function createParticle(x,y,mass,addToWorld,options,data){if(addToWorld===undefined){addToWorld=false;}var body=new Phaser.Physics.P2.Body(this.game,null,x,y,mass);if(data){var result=body.addPolygon(options,data);if(!result){return false;}}if(addToWorld){this.world.addBody(body.data);}return body;},/**
	    * Converts all of the polylines objects inside a Tiled ObjectGroup into physics bodies that are added to the world.
	    * Note that the polylines must be created in such a way that they can withstand polygon decomposition.
	    *
	    * @method Phaser.Physics.P2#convertCollisionObjects
	    * @param {Phaser.Tilemap} map - The Tilemap to get the map data from.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to operate on. If not given will default to map.currentLayer.
	    * @param {boolean} [addToWorld=true] - If true it will automatically add each body to the world.
	    * @return {array} An array of the Phaser.Physics.Body objects that have been created.
	    */convertCollisionObjects:function convertCollisionObjects(map,layer,addToWorld){if(addToWorld===undefined){addToWorld=true;}var output=[];for(var i=0,len=map.collision[layer].length;i<len;i++){// name: json.layers[i].objects[v].name,
	// x: json.layers[i].objects[v].x,
	// y: json.layers[i].objects[v].y,
	// width: json.layers[i].objects[v].width,
	// height: json.layers[i].objects[v].height,
	// visible: json.layers[i].objects[v].visible,
	// properties: json.layers[i].objects[v].properties,
	// polyline: json.layers[i].objects[v].polyline
	var object=map.collision[layer][i];var body=this.createBody(object.x,object.y,0,addToWorld,{},object.polyline);if(body){output.push(body);}}return output;},/**
	    * Clears all physics bodies from the given TilemapLayer that were created with `World.convertTilemap`.
	    *
	    * @method Phaser.Physics.P2#clearTilemapLayerBodies
	    * @param {Phaser.Tilemap} map - The Tilemap to get the map data from.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to operate on. If not given will default to map.currentLayer.
	    */clearTilemapLayerBodies:function clearTilemapLayerBodies(map,layer){layer=map.getLayer(layer);var i=map.layers[layer].bodies.length;while(i--){map.layers[layer].bodies[i].destroy();}map.layers[layer].bodies.length=0;},/**
	    * Goes through all tiles in the given Tilemap and TilemapLayer and converts those set to collide into physics bodies.
	    * Only call this *after* you have specified all of the tiles you wish to collide with calls like Tilemap.setCollisionBetween, etc.
	    * Every time you call this method it will destroy any previously created bodies and remove them from the world.
	    * Therefore understand it's a very expensive operation and not to be done in a core game update loop.
	    *
	    * @method Phaser.Physics.P2#convertTilemap
	    * @param {Phaser.Tilemap} map - The Tilemap to get the map data from.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to operate on. If not given will default to map.currentLayer.
	    * @param {boolean} [addToWorld=true] - If true it will automatically add each body to the world, otherwise it's up to you to do so.
	    * @param {boolean} [optimize=true] - If true adjacent colliding tiles will be combined into a single body to save processing. However it means you cannot perform specific Tile to Body collision responses.
	    * @return {array} An array of the Phaser.Physics.P2.Body objects that were created.
	    */convertTilemap:function convertTilemap(map,layer,addToWorld,optimize){layer=map.getLayer(layer);if(addToWorld===undefined){addToWorld=true;}if(optimize===undefined){optimize=true;}//  If the bodies array is already populated we need to nuke it
	this.clearTilemapLayerBodies(map,layer);var width=0;var sx=0;var sy=0;for(var y=0,h=map.layers[layer].height;y<h;y++){width=0;for(var x=0,w=map.layers[layer].width;x<w;x++){var tile=map.layers[layer].data[y][x];if(tile&&tile.index>-1&&tile.collides){if(optimize){var right=map.getTileRight(layer,x,y);if(width===0){sx=tile.x*tile.width;sy=tile.y*tile.height;width=tile.width;}if(right&&right.collides){width+=tile.width;}else{var body=this.createBody(sx,sy,0,false);body.addRectangle(width,tile.height,width/2,tile.height/2,0);if(addToWorld){this.addBody(body);}map.layers[layer].bodies.push(body);width=0;}}else{var body=this.createBody(tile.x*tile.width,tile.y*tile.height,0,false);body.addRectangle(tile.width,tile.height,tile.width/2,tile.height/2,0);if(addToWorld){this.addBody(body);}map.layers[layer].bodies.push(body);}}}}return map.layers[layer].bodies;},/**
	    * Convert p2 physics value (meters) to pixel scale.
	    * By default Phaser uses a scale of 20px per meter.
	    * If you need to modify this you can over-ride these functions via the Physics Configuration object.
	    *
	    * @method Phaser.Physics.P2#mpx
	    * @param {number} v - The value to convert.
	    * @return {number} The scaled value.
	    */mpx:function mpx(v){return v*=20;},/**
	    * Convert pixel value to p2 physics scale (meters).
	    * By default Phaser uses a scale of 20px per meter.
	    * If you need to modify this you can over-ride these functions via the Physics Configuration object.
	    *
	    * @method Phaser.Physics.P2#pxm
	    * @param {number} v - The value to convert.
	    * @return {number} The scaled value.
	    */pxm:function pxm(v){return v*0.05;},/**
	    * Convert p2 physics value (meters) to pixel scale and inverses it.
	    * By default Phaser uses a scale of 20px per meter.
	    * If you need to modify this you can over-ride these functions via the Physics Configuration object.
	    *
	    * @method Phaser.Physics.P2#mpxi
	    * @param {number} v - The value to convert.
	    * @return {number} The scaled value.
	    */mpxi:function mpxi(v){return v*=-20;},/**
	    * Convert pixel value to p2 physics scale (meters) and inverses it.
	    * By default Phaser uses a scale of 20px per meter.
	    * If you need to modify this you can over-ride these functions via the Physics Configuration object.
	    *
	    * @method Phaser.Physics.P2#pxmi
	    * @param {number} v - The value to convert.
	    * @return {number} The scaled value.
	    */pxmi:function pxmi(v){return v*-0.05;}};/**
	* @name Phaser.Physics.P2#friction
	* @property {number} friction - Friction between colliding bodies. This value is used if no matching ContactMaterial is found for a Material pair.
	*/Object.defineProperty(Phaser.Physics.P2.prototype,"friction",{get:function get(){return this.world.defaultContactMaterial.friction;},set:function set(value){this.world.defaultContactMaterial.friction=value;}});/**
	* @name Phaser.Physics.P2#restitution
	* @property {number} restitution - Default coefficient of restitution between colliding bodies. This value is used if no matching ContactMaterial is found for a Material pair.
	*/Object.defineProperty(Phaser.Physics.P2.prototype,"restitution",{get:function get(){return this.world.defaultContactMaterial.restitution;},set:function set(value){this.world.defaultContactMaterial.restitution=value;}});/**
	* @name Phaser.Physics.P2#contactMaterial
	* @property {p2.ContactMaterial} contactMaterial - The default Contact Material being used by the World.
	*/Object.defineProperty(Phaser.Physics.P2.prototype,"contactMaterial",{get:function get(){return this.world.defaultContactMaterial;},set:function set(value){this.world.defaultContactMaterial=value;}});/**
	* @name Phaser.Physics.P2#applySpringForces
	* @property {boolean} applySpringForces - Enable to automatically apply spring forces each step.
	*/Object.defineProperty(Phaser.Physics.P2.prototype,"applySpringForces",{get:function get(){return this.world.applySpringForces;},set:function set(value){this.world.applySpringForces=value;}});/**
	* @name Phaser.Physics.P2#applyDamping
	* @property {boolean} applyDamping - Enable to automatically apply body damping each step.
	*/Object.defineProperty(Phaser.Physics.P2.prototype,"applyDamping",{get:function get(){return this.world.applyDamping;},set:function set(value){this.world.applyDamping=value;}});/**
	* @name Phaser.Physics.P2#applyGravity
	* @property {boolean} applyGravity - Enable to automatically apply gravity each step.
	*/Object.defineProperty(Phaser.Physics.P2.prototype,"applyGravity",{get:function get(){return this.world.applyGravity;},set:function set(value){this.world.applyGravity=value;}});/**
	* @name Phaser.Physics.P2#solveConstraints
	* @property {boolean} solveConstraints - Enable/disable constraint solving in each step.
	*/Object.defineProperty(Phaser.Physics.P2.prototype,"solveConstraints",{get:function get(){return this.world.solveConstraints;},set:function set(value){this.world.solveConstraints=value;}});/**
	* @name Phaser.Physics.P2#time
	* @property {boolean} time - The World time.
	* @readonly
	*/Object.defineProperty(Phaser.Physics.P2.prototype,"time",{get:function get(){return this.world.time;}});/**
	* @name Phaser.Physics.P2#emitImpactEvent
	* @property {boolean} emitImpactEvent - Set to true if you want to the world to emit the "impact" event. Turning this off could improve performance.
	*/Object.defineProperty(Phaser.Physics.P2.prototype,"emitImpactEvent",{get:function get(){return this.world.emitImpactEvent;},set:function set(value){this.world.emitImpactEvent=value;}});/**
	* How to deactivate bodies during simulation. Possible modes are: World.NO_SLEEPING, World.BODY_SLEEPING and World.ISLAND_SLEEPING.
	* If sleeping is enabled, you might need to wake up the bodies if they fall asleep when they shouldn't. If you want to enable sleeping in the world, but want to disable it for a particular body, see Body.allowSleep.
	* @name Phaser.Physics.P2#sleepMode
	* @property {number} sleepMode
	*/Object.defineProperty(Phaser.Physics.P2.prototype,"sleepMode",{get:function get(){return this.world.sleepMode;},set:function set(value){this.world.sleepMode=value;}});/**
	* @name Phaser.Physics.P2#total
	* @property {number} total - The total number of bodies in the world.
	* @readonly
	*/Object.defineProperty(Phaser.Physics.P2.prototype,"total",{get:function get(){return this.world.bodies.length;}});/* jshint noarg: false *//**
	* @author       Georgios Kaleadis https://github.com/georgiee
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Allow to access a list of created fixture (coming from Body#addPhaserPolygon)
	* which itself parse the input from PhysicsEditor with the custom phaser exporter.
	* You can access fixtures of a Body by a group index or even by providing a fixture Key.
	
	* You can set the fixture key and also the group index for a fixture in PhysicsEditor.
	* This gives you the power to create a complex body built of many fixtures and modify them
	* during runtime (to remove parts, set masks, categories & sensor properties)
	*
	* @class Phaser.Physics.P2.FixtureList
	* @constructor
	* @param {Array} list - A list of fixtures (from Phaser.Physics.P2.Body#addPhaserPolygon)
	*/Phaser.Physics.P2.FixtureList=function(list){if(!Array.isArray(list)){list=[list];}this.rawList=list;this.init();this.parse(this.rawList);};Phaser.Physics.P2.FixtureList.prototype={/**
	    * @method Phaser.Physics.P2.FixtureList#init
	    */init:function init(){/**
	        * @property {object} namedFixtures - Collect all fixtures with a key
	        * @private
	        */this.namedFixtures={};/**
	        * @property {Array} groupedFixtures - Collect all given fixtures per group index. Notice: Every fixture with a key also belongs to a group
	        * @private
	        */this.groupedFixtures=[];/**
	        * @property {Array} allFixtures - This is a list of everything in this collection
	        * @private
	        */this.allFixtures=[];},/**
	    * @method Phaser.Physics.P2.FixtureList#setCategory
	    * @param {number} bit - The bit to set as the collision group.
	    * @param {string} fixtureKey - Only apply to the fixture with the given key.
	    */setCategory:function setCategory(bit,fixtureKey){var setter=function setter(fixture){fixture.collisionGroup=bit;};this.getFixtures(fixtureKey).forEach(setter);},/**
	    * @method Phaser.Physics.P2.FixtureList#setMask
	    * @param {number} bit - The bit to set as the collision mask
	    * @param {string} fixtureKey - Only apply to the fixture with the given key
	    */setMask:function setMask(bit,fixtureKey){var setter=function setter(fixture){fixture.collisionMask=bit;};this.getFixtures(fixtureKey).forEach(setter);},/**
	    * @method Phaser.Physics.P2.FixtureList#setSensor
	    * @param {boolean} value - sensor true or false
	    * @param {string} fixtureKey - Only apply to the fixture with the given key
	    */setSensor:function setSensor(value,fixtureKey){var setter=function setter(fixture){fixture.sensor=value;};this.getFixtures(fixtureKey).forEach(setter);},/**
	    * @method Phaser.Physics.P2.FixtureList#setMaterial
	    * @param {Object} material - The contact material for a fixture
	    * @param {string} fixtureKey - Only apply to the fixture with the given key
	    */setMaterial:function setMaterial(material,fixtureKey){var setter=function setter(fixture){fixture.material=material;};this.getFixtures(fixtureKey).forEach(setter);},/**
	    * Accessor to get either a list of specified fixtures by key or the whole fixture list
	    * 
	    * @method Phaser.Physics.P2.FixtureList#getFixtures
	    * @param {array} keys - A list of fixture keys
	    */getFixtures:function getFixtures(keys){var fixtures=[];if(keys){if(!(keys instanceof Array)){keys=[keys];}var self=this;keys.forEach(function(key){if(self.namedFixtures[key]){fixtures.push(self.namedFixtures[key]);}});return this.flatten(fixtures);}else{return this.allFixtures;}},/**
	    * Accessor to get either a single fixture by its key.
	    * 
	    * @method Phaser.Physics.P2.FixtureList#getFixtureByKey
	    * @param {string} key - The key of the fixture.
	    */getFixtureByKey:function getFixtureByKey(key){return this.namedFixtures[key];},/**
	    * Accessor to get a group of fixtures by its group index.
	    * 
	    * @method Phaser.Physics.P2.FixtureList#getGroup
	    * @param {number} groupID - The group index.
	    */getGroup:function getGroup(groupID){return this.groupedFixtures[groupID];},/**
	    * Parser for the output of Phaser.Physics.P2.Body#addPhaserPolygon
	    * 
	    * @method Phaser.Physics.P2.FixtureList#parse
	    */parse:function parse(){var key,value,_ref,_results;_ref=this.rawList;_results=[];for(key in _ref){value=_ref[key];if(!isNaN(key-0)){this.groupedFixtures[key]=this.groupedFixtures[key]||[];this.groupedFixtures[key]=this.groupedFixtures[key].concat(value);}else{this.namedFixtures[key]=this.flatten(value);}_results.push(this.allFixtures=this.flatten(this.groupedFixtures));}},/**
	    * A helper to flatten arrays. This is very useful as the fixtures are nested from time to time due to the way P2 creates and splits polygons.
	    * 
	    * @method Phaser.Physics.P2.FixtureList#flatten
	    * @param {array} array - The array to flatten. Notice: This will happen recursive not shallow.
	    */flatten:function flatten(array){var result,self;result=[];self=arguments.callee;array.forEach(function(item){return Array.prototype.push.apply(result,Array.isArray(item)?self(item):[item]);});return result;}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A PointProxy is an internal class that allows for direct getter/setter style property access to Arrays and TypedArrays.
	*
	* @class Phaser.Physics.P2.PointProxy
	* @constructor
	* @param {Phaser.Physics.P2} world - A reference to the P2 World.
	* @param {any} destination - The object to bind to.
	*/Phaser.Physics.P2.PointProxy=function(world,destination){this.world=world;this.destination=destination;};Phaser.Physics.P2.PointProxy.prototype.constructor=Phaser.Physics.P2.PointProxy;/**
	* @name Phaser.Physics.P2.PointProxy#x
	* @property {number} x - The x property of this PointProxy get and set in pixels.
	*/Object.defineProperty(Phaser.Physics.P2.PointProxy.prototype,"x",{get:function get(){return this.world.mpx(this.destination[0]);},set:function set(value){this.destination[0]=this.world.pxm(value);}});/**
	* @name Phaser.Physics.P2.PointProxy#y
	* @property {number} y - The y property of this PointProxy get and set in pixels.
	*/Object.defineProperty(Phaser.Physics.P2.PointProxy.prototype,"y",{get:function get(){return this.world.mpx(this.destination[1]);},set:function set(value){this.destination[1]=this.world.pxm(value);}});/**
	* @name Phaser.Physics.P2.PointProxy#mx
	* @property {number} mx - The x property of this PointProxy get and set in meters.
	*/Object.defineProperty(Phaser.Physics.P2.PointProxy.prototype,"mx",{get:function get(){return this.destination[0];},set:function set(value){this.destination[0]=value;}});/**
	* @name Phaser.Physics.P2.PointProxy#my
	* @property {number} my - The x property of this PointProxy get and set in meters.
	*/Object.defineProperty(Phaser.Physics.P2.PointProxy.prototype,"my",{get:function get(){return this.destination[1];},set:function set(value){this.destination[1]=value;}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A InversePointProxy is an internal class that allows for direct getter/setter style property access to Arrays and TypedArrays but inverses the values on set.
	*
	* @class Phaser.Physics.P2.InversePointProxy
	* @constructor
	* @param {Phaser.Physics.P2} world - A reference to the P2 World.
	* @param {any} destination - The object to bind to.
	*/Phaser.Physics.P2.InversePointProxy=function(world,destination){this.world=world;this.destination=destination;};Phaser.Physics.P2.InversePointProxy.prototype.constructor=Phaser.Physics.P2.InversePointProxy;/**
	* @name Phaser.Physics.P2.InversePointProxy#x
	* @property {number} x - The x property of this InversePointProxy get and set in pixels.
	*/Object.defineProperty(Phaser.Physics.P2.InversePointProxy.prototype,"x",{get:function get(){return this.world.mpxi(this.destination[0]);},set:function set(value){this.destination[0]=this.world.pxmi(value);}});/**
	* @name Phaser.Physics.P2.InversePointProxy#y
	* @property {number} y - The y property of this InversePointProxy get and set in pixels.
	*/Object.defineProperty(Phaser.Physics.P2.InversePointProxy.prototype,"y",{get:function get(){return this.world.mpxi(this.destination[1]);},set:function set(value){this.destination[1]=this.world.pxmi(value);}});/**
	* @name Phaser.Physics.P2.InversePointProxy#mx
	* @property {number} mx - The x property of this InversePointProxy get and set in meters.
	*/Object.defineProperty(Phaser.Physics.P2.InversePointProxy.prototype,"mx",{get:function get(){return this.destination[0];},set:function set(value){this.destination[0]=-value;}});/**
	* @name Phaser.Physics.P2.InversePointProxy#my
	* @property {number} my - The y property of this InversePointProxy get and set in meters.
	*/Object.defineProperty(Phaser.Physics.P2.InversePointProxy.prototype,"my",{get:function get(){return this.destination[1];},set:function set(value){this.destination[1]=-value;}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Physics Body is typically linked to a single Sprite and defines properties that determine how the physics body is simulated.
	* These properties affect how the body reacts to forces, what forces it generates on itself (to simulate friction), and how it reacts to collisions in the scene.
	* In most cases, the properties are used to simulate physical effects. Each body also has its own property values that determine exactly how it reacts to forces and collisions in the scene.
	* By default a single Rectangle shape is added to the Body that matches the dimensions of the parent Sprite. See addShape, removeShape, clearShapes to add extra shapes around the Body.
	* Note: When bound to a Sprite to avoid single-pixel jitters on mobile devices we strongly recommend using Sprite sizes that are even on both axis, i.e. 128x128 not 127x127.
	* Note: When a game object is given a P2 body it has its anchor x/y set to 0.5, so it becomes centered.
	*
	* @class Phaser.Physics.P2.Body
	* @constructor
	* @param {Phaser.Game} game - Game reference to the currently running game.
	* @param {Phaser.Sprite} [sprite] - The Sprite object this physics body belongs to.
	* @param {number} [x=0] - The x coordinate of this Body.
	* @param {number} [y=0] - The y coordinate of this Body.
	* @param {number} [mass=1] - The default mass of this Body (0 = static).
	*/Phaser.Physics.P2.Body=function(game,sprite,x,y,mass){sprite=sprite||null;x=x||0;y=y||0;if(mass===undefined){mass=1;}/**
	    * @property {Phaser.Game} game - Local reference to game.
	    */this.game=game;/**
	    * @property {Phaser.Physics.P2} world - Local reference to the P2 World.
	    */this.world=game.physics.p2;/**
	    * @property {Phaser.Sprite} sprite - Reference to the parent Sprite.
	    */this.sprite=sprite;/**
	    * @property {number} type - The type of physics system this body belongs to.
	    */this.type=Phaser.Physics.P2JS;/**
	    * @property {Phaser.Point} offset - The offset of the Physics Body from the Sprite x/y position.
	    */this.offset=new Phaser.Point();/**
	    * @property {p2.Body} data - The p2 Body data.
	    * @protected
	    */this.data=new p2.Body({position:[this.world.pxmi(x),this.world.pxmi(y)],mass:mass});this.data.parent=this;/**
	    * @property {Phaser.Physics.P2.InversePointProxy} velocity - The velocity of the body. Set velocity.x to a negative value to move to the left, position to the right. velocity.y negative values move up, positive move down.
	    */this.velocity=new Phaser.Physics.P2.InversePointProxy(this.world,this.data.velocity);/**
	    * @property {Phaser.Physics.P2.InversePointProxy} force - The force applied to the body.
	    */this.force=new Phaser.Physics.P2.InversePointProxy(this.world,this.data.force);/**
	    * @property {Phaser.Point} gravity - A locally applied gravity force to the Body. Applied directly before the world step. NOTE: Not currently implemented.
	    */this.gravity=new Phaser.Point();/**
	    * Dispatched when a first contact is created between shapes in two bodies. 
	    * This event is fired during the step, so collision has already taken place.
	    * 
	    * The event will be sent 5 arguments in this order:
	    * 
	    * The Phaser.Physics.P2.Body it is in contact with. *This might be null* if the Body was created directly in the p2 world.
	    * The p2.Body this Body is in contact with.
	    * The Shape from this body that caused the contact.
	    * The Shape from the contact body.
	    * The Contact Equation data array.
	    * 
	    * @property {Phaser.Signal} onBeginContact
	    */this.onBeginContact=new Phaser.Signal();/**
	    * Dispatched when contact ends between shapes in two bodies.
	    * This event is fired during the step, so collision has already taken place.
	    * 
	    * The event will be sent 4 arguments in this order:
	    * 
	    * The Phaser.Physics.P2.Body it is in contact with. *This might be null* if the Body was created directly in the p2 world.
	    * The p2.Body this Body has ended contact with.
	    * The Shape from this body that caused the original contact.
	    * The Shape from the contact body.
	    * 
	    * @property {Phaser.Signal} onEndContact
	    */this.onEndContact=new Phaser.Signal();/**
	    * @property {array} collidesWith - Array of CollisionGroups that this Bodies shapes collide with.
	    */this.collidesWith=[];/**
	    * @property {boolean} removeNextStep - To avoid deleting this body during a physics step, and causing all kinds of problems, set removeNextStep to true to have it removed in the next preUpdate.
	    */this.removeNextStep=false;/**
	    * @property {Phaser.Physics.P2.BodyDebug} debugBody - Reference to the debug body.
	    */this.debugBody=null;/**
	    * @property {boolean} dirty - Internally used by Sprite.x/y
	    */this.dirty=false;/**
	    * @property {boolean} _collideWorldBounds - Internal var that determines if this Body collides with the world bounds or not.
	    * @private
	    */this._collideWorldBounds=true;/**
	    * @property {object} _bodyCallbacks - Array of Body callbacks.
	    * @private
	    */this._bodyCallbacks={};/**
	    * @property {object} _bodyCallbackContext - Array of Body callback contexts.
	    * @private
	    */this._bodyCallbackContext={};/**
	    * @property {object} _groupCallbacks - Array of Group callbacks.
	    * @private
	    */this._groupCallbacks={};/**
	    * @property {object} _bodyCallbackContext - Array of Grouo callback contexts.
	    * @private
	    */this._groupCallbackContext={};/**
	    * @property {boolean} _reset - Internal var.
	    * @private
	    */this._reset=false;//  Set-up the default shape
	if(sprite){this.setRectangleFromSprite(sprite);if(sprite.exists){this.game.physics.p2.addBody(this);}}};Phaser.Physics.P2.Body.prototype={/**
	    * Sets a callback to be fired any time a shape in this Body impacts with a shape in the given Body. The impact test is performed against body.id values.
	    * The callback will be sent 4 parameters: This body, the body that impacted, the Shape in this body and the shape in the impacting body.
	    * Note that the impact event happens after collision resolution, so it cannot be used to prevent a collision from happening.
	    * It also happens mid-step. So do not destroy a Body during this callback, instead set safeDestroy to true so it will be killed on the next preUpdate.
	    *
	    * @method Phaser.Physics.P2.Body#createBodyCallback
	    * @param {Phaser.Sprite|Phaser.TileSprite|Phaser.Physics.P2.Body|p2.Body} object - The object to send impact events for.
	    * @param {function} callback - The callback to fire on impact. Set to null to clear a previously set callback.
	    * @param {object} callbackContext - The context under which the callback will fire.
	    */createBodyCallback:function createBodyCallback(object,callback,callbackContext){var id=-1;if(object['id']){id=object.id;}else if(object['body']){id=object.body.id;}if(id>-1){if(callback===null){delete this._bodyCallbacks[id];delete this._bodyCallbackContext[id];}else{this._bodyCallbacks[id]=callback;this._bodyCallbackContext[id]=callbackContext;}}},/**
	    * Sets a callback to be fired any time this Body impacts with the given Group. The impact test is performed against shape.collisionGroup values.
	    * The callback will be sent 4 parameters: This body, the body that impacted, the Shape in this body and the shape in the impacting body.
	    * This callback will only fire if this Body has been assigned a collision group.
	    * Note that the impact event happens after collision resolution, so it cannot be used to prevent a collision from happening.
	    * It also happens mid-step. So do not destroy a Body during this callback, instead set safeDestroy to true so it will be killed on the next preUpdate.
	    *
	    * @method Phaser.Physics.P2.Body#createGroupCallback
	    * @param {Phaser.Physics.CollisionGroup} group - The Group to send impact events for.
	    * @param {function} callback - The callback to fire on impact. Set to null to clear a previously set callback.
	    * @param {object} callbackContext - The context under which the callback will fire.
	    */createGroupCallback:function createGroupCallback(group,callback,callbackContext){if(callback===null){delete this._groupCallbacks[group.mask];delete this._groupCallbackContext[group.mask];}else{this._groupCallbacks[group.mask]=callback;this._groupCallbackContext[group.mask]=callbackContext;}},/**
	    * Gets the collision bitmask from the groups this body collides with.
	    *
	    * @method Phaser.Physics.P2.Body#getCollisionMask
	    * @return {number} The bitmask.
	    */getCollisionMask:function getCollisionMask(){var mask=0;if(this._collideWorldBounds){mask=this.game.physics.p2.boundsCollisionGroup.mask;}for(var i=0;i<this.collidesWith.length;i++){mask=mask|this.collidesWith[i].mask;}return mask;},/**
	    * Updates the collisionMask.
	    *
	    * @method Phaser.Physics.P2.Body#updateCollisionMask
	    * @param {p2.Shape} [shape] - An optional Shape. If not provided the collision group will be added to all Shapes in this Body.
	    */updateCollisionMask:function updateCollisionMask(shape){var mask=this.getCollisionMask();if(shape===undefined){for(var i=this.data.shapes.length-1;i>=0;i--){this.data.shapes[i].collisionMask=mask;}}else{shape.collisionMask=mask;}},/**
	    * Sets the given CollisionGroup to be the collision group for all shapes in this Body, unless a shape is specified.
	    * This also resets the collisionMask.
	    *
	    * @method Phaser.Physics.P2.Body#setCollisionGroup
	    * @param {Phaser.Physics.CollisionGroup} group - The Collision Group that this Bodies shapes will use.
	    * @param {p2.Shape} [shape] - An optional Shape. If not provided the collision group will be added to all Shapes in this Body.
	    */setCollisionGroup:function setCollisionGroup(group,shape){var mask=this.getCollisionMask();if(shape===undefined){for(var i=this.data.shapes.length-1;i>=0;i--){this.data.shapes[i].collisionGroup=group.mask;this.data.shapes[i].collisionMask=mask;}}else{shape.collisionGroup=group.mask;shape.collisionMask=mask;}},/**
	    * Clears the collision data from the shapes in this Body. Optionally clears Group and/or Mask.
	    *
	    * @method Phaser.Physics.P2.Body#clearCollision
	    * @param {boolean} [clearGroup=true] - Clear the collisionGroup value from the shape/s?
	    * @param {boolean} [clearMask=true] - Clear the collisionMask value from the shape/s?
	    * @param {p2.Shape} [shape] - An optional Shape. If not provided the collision data will be cleared from all Shapes in this Body.
	    */clearCollision:function clearCollision(clearGroup,clearMask,shape){if(clearGroup===undefined){clearGroup=true;}if(clearMask===undefined){clearMask=true;}if(shape===undefined){for(var i=this.data.shapes.length-1;i>=0;i--){if(clearGroup){this.data.shapes[i].collisionGroup=null;}if(clearMask){this.data.shapes[i].collisionMask=null;}}}else{if(clearGroup){shape.collisionGroup=null;}if(clearMask){shape.collisionMask=null;}}if(clearGroup){this.collidesWith.length=0;}},/**
	    * Removes the given CollisionGroup, or array of CollisionGroups, from the list of groups that this body will collide with and updates the collision masks.
	    *
	    * @method Phaser.Physics.P2.Body#removeCollisionGroup
	    * @param {Phaser.Physics.CollisionGroup|array} group - The Collision Group or Array of Collision Groups that this Bodies shapes should not collide with anymore.
	    * @param {boolean} [clearCallback=true] - Clear the callback that will be triggered when this Body impacts with the given Group?
	    * @param {p2.Shape} [shape] - An optional Shape. If not provided the updated collision mask will be added to all Shapes in this Body.
	    */removeCollisionGroup:function removeCollisionGroup(group,clearCallback,shape){if(clearCallback===undefined){clearCallback=true;}var index;if(Array.isArray(group)){for(var i=0;i<group.length;i++){index=this.collidesWith.indexOf(group[i]);if(index>-1){this.collidesWith.splice(index,1);if(clearCallback){delete this._groupCallbacks[group.mask];delete this._groupCallbackContext[group.mask];}}}}else{index=this.collidesWith.indexOf(group);if(index>-1){this.collidesWith.splice(index,1);if(clearCallback){delete this._groupCallbacks[group.mask];delete this._groupCallbackContext[group.mask];}}}var mask=this.getCollisionMask();if(shape===undefined){for(var i=this.data.shapes.length-1;i>=0;i--){this.data.shapes[i].collisionMask=mask;}}else{shape.collisionMask=mask;}},/**
	    * Adds the given CollisionGroup, or array of CollisionGroups, to the list of groups that this body will collide with and updates the collision masks.
	    *
	    * @method Phaser.Physics.P2.Body#collides
	    * @param {Phaser.Physics.CollisionGroup|array} group - The Collision Group or Array of Collision Groups that this Bodies shapes will collide with.
	    * @param {function} [callback] - Optional callback that will be triggered when this Body impacts with the given Group.
	    * @param {object} [callbackContext] - The context under which the callback will be called.
	    * @param {p2.Shape} [shape] - An optional Shape. If not provided the collision mask will be added to all Shapes in this Body.
	    */collides:function collides(group,callback,callbackContext,shape){if(Array.isArray(group)){for(var i=0;i<group.length;i++){if(this.collidesWith.indexOf(group[i])===-1){this.collidesWith.push(group[i]);if(callback){this.createGroupCallback(group[i],callback,callbackContext);}}}}else{if(this.collidesWith.indexOf(group)===-1){this.collidesWith.push(group);if(callback){this.createGroupCallback(group,callback,callbackContext);}}}var mask=this.getCollisionMask();if(shape===undefined){for(var i=this.data.shapes.length-1;i>=0;i--){this.data.shapes[i].collisionMask=mask;}}else{shape.collisionMask=mask;}},/**
	    * Moves the shape offsets so their center of mass becomes the body center of mass.
	    *
	    * @method Phaser.Physics.P2.Body#adjustCenterOfMass
	    */adjustCenterOfMass:function adjustCenterOfMass(){this.data.adjustCenterOfMass();this.shapeChanged();},/**
	    * Gets the velocity of a point in the body.
	    *
	    * @method Phaser.Physics.P2.Body#getVelocityAtPoint
	    * @param {Array} result - A vector to store the result in.
	    * @param {Array} relativePoint - A world oriented vector, indicating the position of the point to get the velocity from.
	    * @return {Array} The result vector.
	    */getVelocityAtPoint:function getVelocityAtPoint(result,relativePoint){return this.data.getVelocityAtPoint(result,relativePoint);},/**
	    * Apply damping, see http://code.google.com/p/bullet/issues/detail?id=74 for details.
	    *
	    * @method Phaser.Physics.P2.Body#applyDamping
	    * @param {number} dt - Current time step.
	    */applyDamping:function applyDamping(dt){this.data.applyDamping(dt);},/**
	    * Apply impulse to a point relative to the body.
	    * This could for example be a point on the Body surface. An impulse is a force added to a body during a short 
	    * period of time (impulse = force * time). Impulses will be added to Body.velocity and Body.angularVelocity.
	    *
	    * @method Phaser.Physics.P2.Body#applyImpulse
	    * @param {Float32Array|Array} impulse - The impulse vector to add, oriented in world space.
	    * @param {number} worldX - A point relative to the body in world space. If not given, it is set to zero and all of the impulse will be exerted on the center of mass.
	    * @param {number} worldY - A point relative to the body in world space. If not given, it is set to zero and all of the impulse will be exerted on the center of mass.
	    */applyImpulse:function applyImpulse(impulse,worldX,worldY){this.data.applyImpulse(impulse,[this.world.pxmi(worldX),this.world.pxmi(worldY)]);},/**
	    * Apply impulse to a point local to the body.
	    * 
	    * This could for example be a point on the Body surface. An impulse is a force added to a body during a short 
	    * period of time (impulse = force * time). Impulses will be added to Body.velocity and Body.angularVelocity.
	    *
	    * @method Phaser.Physics.P2.Body#applyImpulseLocal
	    * @param {Float32Array|Array} impulse - The impulse vector to add, oriented in local space.
	    * @param {number} localX - A local point on the body.
	    * @param {number} localY - A local point on the body.
	    */applyImpulseLocal:function applyImpulseLocal(impulse,localX,localY){this.data.applyImpulseLocal(impulse,[this.world.pxmi(localX),this.world.pxmi(localY)]);},/**
	    * Apply force to a world point.
	    * 
	    * This could for example be a point on the RigidBody surface. Applying force 
	    * this way will add to Body.force and Body.angularForce.
	    *
	    * @method Phaser.Physics.P2.Body#applyForce
	    * @param {Float32Array|Array} force - The force vector to add.
	    * @param {number} worldX - The world x point to apply the force on.
	    * @param {number} worldY - The world y point to apply the force on.
	    */applyForce:function applyForce(force,worldX,worldY){this.data.applyForce(force,[this.world.pxmi(worldX),this.world.pxmi(worldY)]);},/**
	    * Sets the force on the body to zero.
	    *
	    * @method Phaser.Physics.P2.Body#setZeroForce
	    */setZeroForce:function setZeroForce(){this.data.setZeroForce();},/**
	    * If this Body is dynamic then this will zero its angular velocity.
	    *
	    * @method Phaser.Physics.P2.Body#setZeroRotation
	    */setZeroRotation:function setZeroRotation(){this.data.angularVelocity=0;},/**
	    * If this Body is dynamic then this will zero its velocity on both axis.
	    *
	    * @method Phaser.Physics.P2.Body#setZeroVelocity
	    */setZeroVelocity:function setZeroVelocity(){this.data.velocity[0]=0;this.data.velocity[1]=0;},/**
	    * Sets the Body damping and angularDamping to zero.
	    *
	    * @method Phaser.Physics.P2.Body#setZeroDamping
	    */setZeroDamping:function setZeroDamping(){this.data.damping=0;this.data.angularDamping=0;},/**
	    * Transform a world point to local body frame.
	    *
	    * @method Phaser.Physics.P2.Body#toLocalFrame
	    * @param {Float32Array|Array} out - The vector to store the result in.
	    * @param {Float32Array|Array} worldPoint - The input world vector.
	    */toLocalFrame:function toLocalFrame(out,worldPoint){return this.data.toLocalFrame(out,worldPoint);},/**
	    * Transform a local point to world frame.
	    *
	    * @method Phaser.Physics.P2.Body#toWorldFrame
	    * @param {Array} out - The vector to store the result in.
	    * @param {Array} localPoint - The input local vector.
	    */toWorldFrame:function toWorldFrame(out,localPoint){return this.data.toWorldFrame(out,localPoint);},/**
	    * This will rotate the Body by the given speed to the left (counter-clockwise).
	    *
	    * @method Phaser.Physics.P2.Body#rotateLeft
	    * @param {number} speed - The speed at which it should rotate.
	    */rotateLeft:function rotateLeft(speed){this.data.angularVelocity=this.world.pxm(-speed);},/**
	    * This will rotate the Body by the given speed to the left (clockwise).
	    *
	    * @method Phaser.Physics.P2.Body#rotateRight
	    * @param {number} speed - The speed at which it should rotate.
	    */rotateRight:function rotateRight(speed){this.data.angularVelocity=this.world.pxm(speed);},/**
	    * Moves the Body forwards based on its current angle and the given speed.
	    * The speed is represented in pixels per second. So a value of 100 would move 100 pixels in 1 second (1000ms).
	    *
	    * @method Phaser.Physics.P2.Body#moveForward
	    * @param {number} speed - The speed at which it should move forwards.
	    */moveForward:function moveForward(speed){var magnitude=this.world.pxmi(-speed);var angle=this.data.angle+Math.PI/2;this.data.velocity[0]=magnitude*Math.cos(angle);this.data.velocity[1]=magnitude*Math.sin(angle);},/**
	    * Moves the Body backwards based on its current angle and the given speed.
	    * The speed is represented in pixels per second. So a value of 100 would move 100 pixels in 1 second (1000ms).
	    *
	    * @method Phaser.Physics.P2.Body#moveBackward
	    * @param {number} speed - The speed at which it should move backwards.
	    */moveBackward:function moveBackward(speed){var magnitude=this.world.pxmi(-speed);var angle=this.data.angle+Math.PI/2;this.data.velocity[0]=-(magnitude*Math.cos(angle));this.data.velocity[1]=-(magnitude*Math.sin(angle));},/**
	    * Applies a force to the Body that causes it to 'thrust' forwards, based on its current angle and the given speed.
	    * The speed is represented in pixels per second. So a value of 100 would move 100 pixels in 1 second (1000ms).
	    *
	    * @method Phaser.Physics.P2.Body#thrust
	    * @param {number} speed - The speed at which it should thrust.
	    */thrust:function thrust(speed){var magnitude=this.world.pxmi(-speed);var angle=this.data.angle+Math.PI/2;this.data.force[0]+=magnitude*Math.cos(angle);this.data.force[1]+=magnitude*Math.sin(angle);},/**
	    * Applies a force to the Body that causes it to 'thrust' to the left, based on its current angle and the given speed.
	    * The speed is represented in pixels per second. So a value of 100 would move 100 pixels in 1 second (1000ms).
	    *
	    * @method Phaser.Physics.P2.Body#thrustLeft
	    * @param {number} speed - The speed at which it should move to the left.
	    */thrustLeft:function thrustLeft(speed){var magnitude=this.world.pxmi(-speed);var angle=this.data.angle;this.data.force[0]+=magnitude*Math.cos(angle);this.data.force[1]+=magnitude*Math.sin(angle);},/**
	    * Applies a force to the Body that causes it to 'thrust' to the right, based on its current angle and the given speed.
	    * The speed is represented in pixels per second. So a value of 100 would move 100 pixels in 1 second (1000ms).
	    *
	    * @method Phaser.Physics.P2.Body#thrustRight
	    * @param {number} speed - The speed at which it should move to the right.
	    */thrustRight:function thrustRight(speed){var magnitude=this.world.pxmi(-speed);var angle=this.data.angle;this.data.force[0]-=magnitude*Math.cos(angle);this.data.force[1]-=magnitude*Math.sin(angle);},/**
	    * Applies a force to the Body that causes it to 'thrust' backwards (in reverse), based on its current angle and the given speed.
	    * The speed is represented in pixels per second. So a value of 100 would move 100 pixels in 1 second (1000ms).
	    *
	    * @method Phaser.Physics.P2.Body#reverse
	    * @param {number} speed - The speed at which it should reverse.
	    */reverse:function reverse(speed){var magnitude=this.world.pxmi(-speed);var angle=this.data.angle+Math.PI/2;this.data.force[0]-=magnitude*Math.cos(angle);this.data.force[1]-=magnitude*Math.sin(angle);},/**
	    * If this Body is dynamic then this will move it to the left by setting its x velocity to the given speed.
	    * The speed is represented in pixels per second. So a value of 100 would move 100 pixels in 1 second (1000ms).
	    *
	    * @method Phaser.Physics.P2.Body#moveLeft
	    * @param {number} speed - The speed at which it should move to the left, in pixels per second.
	    */moveLeft:function moveLeft(speed){this.data.velocity[0]=this.world.pxmi(-speed);},/**
	    * If this Body is dynamic then this will move it to the right by setting its x velocity to the given speed.
	    * The speed is represented in pixels per second. So a value of 100 would move 100 pixels in 1 second (1000ms).
	    *
	    * @method Phaser.Physics.P2.Body#moveRight
	    * @param {number} speed - The speed at which it should move to the right, in pixels per second.
	    */moveRight:function moveRight(speed){this.data.velocity[0]=this.world.pxmi(speed);},/**
	    * If this Body is dynamic then this will move it up by setting its y velocity to the given speed.
	    * The speed is represented in pixels per second. So a value of 100 would move 100 pixels in 1 second (1000ms).
	    *
	    * @method Phaser.Physics.P2.Body#moveUp
	    * @param {number} speed - The speed at which it should move up, in pixels per second.
	    */moveUp:function moveUp(speed){this.data.velocity[1]=this.world.pxmi(-speed);},/**
	    * If this Body is dynamic then this will move it down by setting its y velocity to the given speed.
	    * The speed is represented in pixels per second. So a value of 100 would move 100 pixels in 1 second (1000ms).
	    *
	    * @method Phaser.Physics.P2.Body#moveDown
	    * @param {number} speed - The speed at which it should move down, in pixels per second.
	    */moveDown:function moveDown(speed){this.data.velocity[1]=this.world.pxmi(speed);},/**
	    * Internal method. This is called directly before the sprites are sent to the renderer and after the update function has finished.
	    *
	    * @method Phaser.Physics.P2.Body#preUpdate
	    * @protected
	    */preUpdate:function preUpdate(){this.dirty=true;if(this.removeNextStep){this.removeFromWorld();this.removeNextStep=false;}},/**
	    * Internal method. This is called directly before the sprites are sent to the renderer and after the update function has finished.
	    *
	    * @method Phaser.Physics.P2.Body#postUpdate
	    * @protected
	    */postUpdate:function postUpdate(){this.sprite.x=this.world.mpxi(this.data.position[0])+this.offset.x;this.sprite.y=this.world.mpxi(this.data.position[1])+this.offset.y;if(!this.fixedRotation){this.sprite.rotation=this.data.angle;}if(this.debugBody){this.debugBody.updateSpriteTransform();}this.dirty=false;},/**
	    * Resets the Body force, velocity (linear and angular) and rotation. Optionally resets damping and mass.
	    *
	    * @method Phaser.Physics.P2.Body#reset
	    * @param {number} x - The new x position of the Body.
	    * @param {number} y - The new x position of the Body.
	    * @param {boolean} [resetDamping=false] - Resets the linear and angular damping.
	    * @param {boolean} [resetMass=false] - Sets the Body mass back to 1.
	    */reset:function reset(x,y,resetDamping,resetMass){if(resetDamping===undefined){resetDamping=false;}if(resetMass===undefined){resetMass=false;}this.setZeroForce();this.setZeroVelocity();this.setZeroRotation();if(resetDamping){this.setZeroDamping();}if(resetMass){this.mass=1;}this.x=x;this.y=y;},/**
	    * Adds this physics body to the world.
	    *
	    * @method Phaser.Physics.P2.Body#addToWorld
	    */addToWorld:function addToWorld(){if(this.game.physics.p2._toRemove){for(var i=0;i<this.game.physics.p2._toRemove.length;i++){if(this.game.physics.p2._toRemove[i]===this){this.game.physics.p2._toRemove.splice(i,1);}}}if(this.data.world!==this.game.physics.p2.world){this.game.physics.p2.addBody(this);}},/**
	    * Removes this physics body from the world.
	    *
	    * @method Phaser.Physics.P2.Body#removeFromWorld
	    */removeFromWorld:function removeFromWorld(){if(this.data.world===this.game.physics.p2.world){this.game.physics.p2.removeBodyNextStep(this);}},/**
	    * Destroys this Body and all references it holds to other objects.
	    *
	    * @method Phaser.Physics.P2.Body#destroy
	    */destroy:function destroy(){this.removeFromWorld();this.clearShapes();this._bodyCallbacks={};this._bodyCallbackContext={};this._groupCallbacks={};this._groupCallbackContext={};if(this.debugBody){this.debugBody.destroy(true,true);}this.debugBody=null;if(this.sprite){this.sprite.body=null;this.sprite=null;}},/**
	    * Removes all Shapes from this Body.
	    *
	    * @method Phaser.Physics.P2.Body#clearShapes
	    */clearShapes:function clearShapes(){var i=this.data.shapes.length;while(i--){this.data.removeShape(this.data.shapes[i]);}this.shapeChanged();},/**
	    * Add a shape to the body. You can pass a local transform when adding a shape, so that the shape gets an offset and an angle relative to the body center of mass.
	    * Will automatically update the mass properties and bounding radius.
	    * If this Body had a previously set Collision Group you will need to re-apply it to the new Shape this creates.
	    *
	    * @method Phaser.Physics.P2.Body#addShape
	    * @param {p2.Shape} shape - The shape to add to the body.
	    * @param {number} [offsetX=0] - Local horizontal offset of the shape relative to the body center of mass.
	    * @param {number} [offsetY=0] - Local vertical offset of the shape relative to the body center of mass.
	    * @param {number} [rotation=0] - Local rotation of the shape relative to the body center of mass, specified in radians.
	    * @return {p2.Shape} The shape that was added to the body.
	    */addShape:function addShape(shape,offsetX,offsetY,rotation){if(offsetX===undefined){offsetX=0;}if(offsetY===undefined){offsetY=0;}if(rotation===undefined){rotation=0;}this.data.addShape(shape,[this.world.pxmi(offsetX),this.world.pxmi(offsetY)],rotation);this.shapeChanged();return shape;},/**
	    * Adds a Circle shape to this Body. You can control the offset from the center of the body and the rotation.
	    *
	    * @method Phaser.Physics.P2.Body#addCircle
	    * @param {number} radius - The radius of this circle (in pixels)
	    * @param {number} [offsetX=0] - Local horizontal offset of the shape relative to the body center of mass.
	    * @param {number} [offsetY=0] - Local vertical offset of the shape relative to the body center of mass.
	    * @param {number} [rotation=0] - Local rotation of the shape relative to the body center of mass, specified in radians.
	    * @return {p2.Circle} The Circle shape that was added to the Body.
	    */addCircle:function addCircle(radius,offsetX,offsetY,rotation){var shape=new p2.Circle({radius:this.world.pxm(radius)});return this.addShape(shape,offsetX,offsetY,rotation);},/**
	    * Adds a Rectangle shape to this Body. You can control the offset from the center of the body and the rotation.
	    *
	    * @method Phaser.Physics.P2.Body#addRectangle
	    * @param {number} width - The width of the rectangle in pixels.
	    * @param {number} height - The height of the rectangle in pixels.
	    * @param {number} [offsetX=0] - Local horizontal offset of the shape relative to the body center of mass.
	    * @param {number} [offsetY=0] - Local vertical offset of the shape relative to the body center of mass.
	    * @param {number} [rotation=0] - Local rotation of the shape relative to the body center of mass, specified in radians.
	    * @return {p2.Box} The shape that was added to the Body.
	    */addRectangle:function addRectangle(width,height,offsetX,offsetY,rotation){var shape=new p2.Box({width:this.world.pxm(width),height:this.world.pxm(height)});return this.addShape(shape,offsetX,offsetY,rotation);},/**
	    * Adds a Plane shape to this Body. The plane is facing in the Y direction. You can control the offset from the center of the body and the rotation.
	    *
	    * @method Phaser.Physics.P2.Body#addPlane
	    * @param {number} [offsetX=0] - Local horizontal offset of the shape relative to the body center of mass.
	    * @param {number} [offsetY=0] - Local vertical offset of the shape relative to the body center of mass.
	    * @param {number} [rotation=0] - Local rotation of the shape relative to the body center of mass, specified in radians.
	    * @return {p2.Plane} The Plane shape that was added to the Body.
	    */addPlane:function addPlane(offsetX,offsetY,rotation){var shape=new p2.Plane();return this.addShape(shape,offsetX,offsetY,rotation);},/**
	    * Adds a Particle shape to this Body. You can control the offset from the center of the body and the rotation.
	    *
	    * @method Phaser.Physics.P2.Body#addParticle
	    * @param {number} [offsetX=0] - Local horizontal offset of the shape relative to the body center of mass.
	    * @param {number} [offsetY=0] - Local vertical offset of the shape relative to the body center of mass.
	    * @param {number} [rotation=0] - Local rotation of the shape relative to the body center of mass, specified in radians.
	    * @return {p2.Particle} The Particle shape that was added to the Body.
	    */addParticle:function addParticle(offsetX,offsetY,rotation){var shape=new p2.Particle();return this.addShape(shape,offsetX,offsetY,rotation);},/**
	    * Adds a Line shape to this Body.
	    * The line shape is along the x direction, and stretches from [-length/2, 0] to [length/2,0].
	    * You can control the offset from the center of the body and the rotation.
	    *
	    * @method Phaser.Physics.P2.Body#addLine
	    * @param {number} length - The length of this line (in pixels)
	    * @param {number} [offsetX=0] - Local horizontal offset of the shape relative to the body center of mass.
	    * @param {number} [offsetY=0] - Local vertical offset of the shape relative to the body center of mass.
	    * @param {number} [rotation=0] - Local rotation of the shape relative to the body center of mass, specified in radians.
	    * @return {p2.Line} The Line shape that was added to the Body.
	    */addLine:function addLine(length,offsetX,offsetY,rotation){var shape=new p2.Line({length:this.world.pxm(length)});return this.addShape(shape,offsetX,offsetY,rotation);},/**
	    * Adds a Capsule shape to this Body.
	    * You can control the offset from the center of the body and the rotation.
	    *
	    * @method Phaser.Physics.P2.Body#addCapsule
	    * @param {number} length - The distance between the end points in pixels.
	    * @param {number} radius - Radius of the capsule in pixels.
	    * @param {number} [offsetX=0] - Local horizontal offset of the shape relative to the body center of mass.
	    * @param {number} [offsetY=0] - Local vertical offset of the shape relative to the body center of mass.
	    * @param {number} [rotation=0] - Local rotation of the shape relative to the body center of mass, specified in radians.
	    * @return {p2.Capsule} The Capsule shape that was added to the Body.
	    */addCapsule:function addCapsule(length,radius,offsetX,offsetY,rotation){var shape=new p2.Capsule({length:this.world.pxm(length),radius:this.world.pxm(radius)});return this.addShape(shape,offsetX,offsetY,rotation);},/**
	    * Reads a polygon shape path, and assembles convex shapes from that and puts them at proper offset points. The shape must be simple and without holes.
	    * This function expects the x.y values to be given in pixels. If you want to provide them at p2 world scales then call Body.data.fromPolygon directly.
	    *
	    * @method Phaser.Physics.P2.Body#addPolygon
	    * @param {object} options - An object containing the build options:
	    * @param {boolean} [options.optimalDecomp=false] - Set to true if you need optimal decomposition. Warning: very slow for polygons with more than 10 vertices.
	    * @param {boolean} [options.skipSimpleCheck=false] - Set to true if you already know that the path is not intersecting itself.
	    * @param {boolean|number} [options.removeCollinearPoints=false] - Set to a number (angle threshold value) to remove collinear points, or false to keep all points.
	    * @param {(number[]|...number)} points - An array of 2d vectors that form the convex or concave polygon.
	    *                                       Either [[0,0], [0,1],...] or a flat array of numbers that will be interpreted as [x,y, x,y, ...],
	    *                                       or the arguments passed can be flat x,y values e.g. `setPolygon(options, x,y, x,y, x,y, ...)` where `x` and `y` are numbers.
	    * @return {boolean} True on success, else false.
	    */addPolygon:function addPolygon(options,points){options=options||{};if(!Array.isArray(points)){points=Array.prototype.slice.call(arguments,1);}var path=[];//  Did they pass in a single array of points?
	if(points.length===1&&Array.isArray(points[0])){path=points[0].slice(0);}else if(Array.isArray(points[0])){path=points.slice();}else if(typeof points[0]==='number'){//  We've a list of numbers
	for(var i=0,len=points.length;i<len;i+=2){path.push([points[i],points[i+1]]);}}//  top and tail
	var idx=path.length-1;if(path[idx][0]===path[0][0]&&path[idx][1]===path[0][1]){path.pop();}//  Now process them into p2 values
	for(var p=0;p<path.length;p++){path[p][0]=this.world.pxmi(path[p][0]);path[p][1]=this.world.pxmi(path[p][1]);}var result=this.data.fromPolygon(path,options);this.shapeChanged();return result;},/**
	    * Remove a shape from the body. Will automatically update the mass properties and bounding radius.
	    *
	    * @method Phaser.Physics.P2.Body#removeShape
	    * @param {p2.Circle|p2.Rectangle|p2.Plane|p2.Line|p2.Particle} shape - The shape to remove from the body.
	    * @return {boolean} True if the shape was found and removed, else false.
	    */removeShape:function removeShape(shape){var result=this.data.removeShape(shape);this.shapeChanged();return result;},/**
	    * Clears any previously set shapes. Then creates a new Circle shape and adds it to this Body.
	    * If this Body had a previously set Collision Group you will need to re-apply it to the new Shape this creates.
	    *
	    * @method Phaser.Physics.P2.Body#setCircle
	    * @param {number} radius - The radius of this circle (in pixels)
	    * @param {number} [offsetX=0] - Local horizontal offset of the shape relative to the body center of mass.
	    * @param {number} [offsetY=0] - Local vertical offset of the shape relative to the body center of mass.
	    * @param {number} [rotation=0] - Local rotation of the shape relative to the body center of mass, specified in radians.
	    */setCircle:function setCircle(radius,offsetX,offsetY,rotation){this.clearShapes();return this.addCircle(radius,offsetX,offsetY,rotation);},/**
	    * Clears any previously set shapes. The creates a new Rectangle shape at the given size and offset, and adds it to this Body.
	    * If you wish to create a Rectangle to match the size of a Sprite or Image see Body.setRectangleFromSprite.
	    * If this Body had a previously set Collision Group you will need to re-apply it to the new Shape this creates.
	    *
	    * @method Phaser.Physics.P2.Body#setRectangle
	    * @param {number} [width=16] - The width of the rectangle in pixels.
	    * @param {number} [height=16] - The height of the rectangle in pixels.
	    * @param {number} [offsetX=0] - Local horizontal offset of the shape relative to the body center of mass.
	    * @param {number} [offsetY=0] - Local vertical offset of the shape relative to the body center of mass.
	    * @param {number} [rotation=0] - Local rotation of the shape relative to the body center of mass, specified in radians.
	    * @return {p2.Rectangle} The Rectangle shape that was added to the Body.
	    */setRectangle:function setRectangle(width,height,offsetX,offsetY,rotation){if(width===undefined){width=16;}if(height===undefined){height=16;}this.clearShapes();return this.addRectangle(width,height,offsetX,offsetY,rotation);},/**
	    * Clears any previously set shapes.
	    * Then creates a Rectangle shape sized to match the dimensions and orientation of the Sprite given.
	    * If no Sprite is given it defaults to using the parent of this Body.
	    * If this Body had a previously set Collision Group you will need to re-apply it to the new Shape this creates.
	    *
	    * @method Phaser.Physics.P2.Body#setRectangleFromSprite
	    * @param {Phaser.Sprite|Phaser.Image} [sprite] - The Sprite on which the Rectangle will get its dimensions.
	    * @return {p2.Rectangle} The Rectangle shape that was added to the Body.
	    */setRectangleFromSprite:function setRectangleFromSprite(sprite){if(sprite===undefined){sprite=this.sprite;}this.clearShapes();return this.addRectangle(sprite.width,sprite.height,0,0,sprite.rotation);},/**
	    * Adds the given Material to all Shapes that belong to this Body.
	    * If you only wish to apply it to a specific Shape in this Body then provide that as the 2nd parameter.
	    *
	    * @method Phaser.Physics.P2.Body#setMaterial
	    * @param {Phaser.Physics.P2.Material} material - The Material that will be applied.
	    * @param {p2.Shape} [shape] - An optional Shape. If not provided the Material will be added to all Shapes in this Body.
	    */setMaterial:function setMaterial(material,shape){if(shape===undefined){for(var i=this.data.shapes.length-1;i>=0;i--){this.data.shapes[i].material=material;}}else{shape.material=material;}},/**
	    * Updates the debug draw if any body shapes change.
	    *
	    * @method Phaser.Physics.P2.Body#shapeChanged
	    */shapeChanged:function shapeChanged(){if(this.debugBody){this.debugBody.draw();}},/**
	    * Reads the shape data from a physics data file stored in the Game.Cache and adds it as a polygon to this Body.
	    * The shape data format is based on the output of the
	    * {@link https://github.com/photonstorm/phaser/tree/master/resources/PhysicsEditor%20Exporter|custom phaser exporter} for
	    * {@link https://www.codeandweb.com/physicseditor|PhysicsEditor}
	    *
	    * @method Phaser.Physics.P2.Body#addPhaserPolygon
	    * @param {string} key - The key of the Physics Data file as stored in Game.Cache.
	    * @param {string} object - The key of the object within the Physics data file that you wish to load the shape data from.
	    * @returns {Array} A list of created fixtures to be used with Phaser.Physics.P2.FixtureList
	    */addPhaserPolygon:function addPhaserPolygon(key,object){var data=this.game.cache.getPhysicsData(key,object);var createdFixtures=[];//  Cycle through the fixtures
	for(var i=0;i<data.length;i++){var fixtureData=data[i];var shapesOfFixture=this.addFixture(fixtureData);//  Always add to a group
	createdFixtures[fixtureData.filter.group]=createdFixtures[fixtureData.filter.group]||[];createdFixtures[fixtureData.filter.group]=createdFixtures[fixtureData.filter.group].concat(shapesOfFixture);//  if (unique) fixture key is provided
	if(fixtureData.fixtureKey){createdFixtures[fixtureData.fixtureKey]=shapesOfFixture;}}this.data.aabbNeedsUpdate=true;this.shapeChanged();return createdFixtures;},/**
	    * Add a polygon fixture. This is used during #loadPolygon.
	    *
	    * @method Phaser.Physics.P2.Body#addFixture
	    * @param {string} fixtureData - The data for the fixture. It contains: isSensor, filter (collision) and the actual polygon shapes.
	    * @return {array} An array containing the generated shapes for the given polygon.
	    */addFixture:function addFixture(fixtureData){var generatedShapes=[];if(fixtureData.circle){var shape=new p2.Circle({radius:this.world.pxm(fixtureData.circle.radius)});shape.collisionGroup=fixtureData.filter.categoryBits;shape.collisionMask=fixtureData.filter.maskBits;shape.sensor=fixtureData.isSensor;var offset=p2.vec2.create();offset[0]=this.world.pxmi(fixtureData.circle.position[0]-this.sprite.width/2);offset[1]=this.world.pxmi(fixtureData.circle.position[1]-this.sprite.height/2);this.data.addShape(shape,offset);generatedShapes.push(shape);}else{var polygons=fixtureData.polygons;var cm=p2.vec2.create();for(var i=0;i<polygons.length;i++){var shapes=polygons[i];var vertices=[];for(var s=0;s<shapes.length;s+=2){vertices.push([this.world.pxmi(shapes[s]),this.world.pxmi(shapes[s+1])]);}var shape=new p2.Convex({vertices:vertices});//  Move all vertices so its center of mass is in the local center of the convex
	for(var j=0;j!==shape.vertices.length;j++){var v=shape.vertices[j];p2.vec2.sub(v,v,shape.centerOfMass);}p2.vec2.scale(cm,shape.centerOfMass,1);cm[0]-=this.world.pxmi(this.sprite.width/2);cm[1]-=this.world.pxmi(this.sprite.height/2);shape.updateTriangles();shape.updateCenterOfMass();shape.updateBoundingRadius();shape.collisionGroup=fixtureData.filter.categoryBits;shape.collisionMask=fixtureData.filter.maskBits;shape.sensor=fixtureData.isSensor;this.data.addShape(shape,cm);generatedShapes.push(shape);}}return generatedShapes;},/**
	    * Reads the shape data from a physics data file stored in the Game.Cache and adds it as a polygon to this Body.
	    * 
	    * As well as reading the data from the Cache you can also pass `null` as the first argument and a
	    * physics data object as the second. When doing this you must ensure the structure of the object is correct in advance.
	    * 
	    * For more details see the format of the Lime / Corona Physics Editor export.
	    *
	    * @method Phaser.Physics.P2.Body#loadPolygon
	    * @param {string} key - The key of the Physics Data file as stored in Game.Cache. Alternatively set to `null` and pass the 
	    *     data as the 2nd argument.
	    * @param {string|object} object - The key of the object within the Physics data file that you wish to load the shape data from, 
	    *     or if key is null pass the actual physics data object itself as this parameter.
	    * @return {boolean} True on success, else false.
	    */loadPolygon:function loadPolygon(key,object){if(key===null){var data=object;}else{var data=this.game.cache.getPhysicsData(key,object);}//  We've multiple Convex shapes, they should be CCW automatically
	var cm=p2.vec2.create();for(var i=0;i<data.length;i++){var vertices=[];for(var s=0;s<data[i].shape.length;s+=2){vertices.push([this.world.pxmi(data[i].shape[s]),this.world.pxmi(data[i].shape[s+1])]);}var c=new p2.Convex({vertices:vertices});// Move all vertices so its center of mass is in the local center of the convex
	for(var j=0;j!==c.vertices.length;j++){var v=c.vertices[j];p2.vec2.sub(v,v,c.centerOfMass);}p2.vec2.scale(cm,c.centerOfMass,1);cm[0]-=this.world.pxmi(this.sprite.width/2);cm[1]-=this.world.pxmi(this.sprite.height/2);c.updateTriangles();c.updateCenterOfMass();c.updateBoundingRadius();this.data.addShape(c,cm);}this.data.aabbNeedsUpdate=true;this.shapeChanged();return true;}};Phaser.Physics.P2.Body.prototype.constructor=Phaser.Physics.P2.Body;/**
	 * Dynamic body. Dynamic bodies body can move and respond to collisions and forces.
	 * @property DYNAMIC
	 * @type {Number}
	 * @static
	 */Phaser.Physics.P2.Body.DYNAMIC=1;/**
	 * Static body. Static bodies do not move, and they do not respond to forces or collision.
	 * @property STATIC
	 * @type {Number}
	 * @static
	 */Phaser.Physics.P2.Body.STATIC=2;/**
	 * Kinematic body. Kinematic bodies only moves according to its .velocity, and does not respond to collisions or force.
	 * @property KINEMATIC
	 * @type {Number}
	 * @static
	 */Phaser.Physics.P2.Body.KINEMATIC=4;/**
	* @name Phaser.Physics.P2.Body#static
	* @property {boolean} static - Returns true if the Body is static. Setting Body.static to 'false' will make it dynamic.
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"static",{get:function get(){return this.data.type===Phaser.Physics.P2.Body.STATIC;},set:function set(value){if(value&&this.data.type!==Phaser.Physics.P2.Body.STATIC){this.data.type=Phaser.Physics.P2.Body.STATIC;this.mass=0;}else if(!value&&this.data.type===Phaser.Physics.P2.Body.STATIC){this.data.type=Phaser.Physics.P2.Body.DYNAMIC;this.mass=1;}}});/**
	* @name Phaser.Physics.P2.Body#dynamic
	* @property {boolean} dynamic - Returns true if the Body is dynamic. Setting Body.dynamic to 'false' will make it static.
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"dynamic",{get:function get(){return this.data.type===Phaser.Physics.P2.Body.DYNAMIC;},set:function set(value){if(value&&this.data.type!==Phaser.Physics.P2.Body.DYNAMIC){this.data.type=Phaser.Physics.P2.Body.DYNAMIC;this.mass=1;}else if(!value&&this.data.type===Phaser.Physics.P2.Body.DYNAMIC){this.data.type=Phaser.Physics.P2.Body.STATIC;this.mass=0;}}});/**
	* @name Phaser.Physics.P2.Body#kinematic
	* @property {boolean} kinematic - Returns true if the Body is kinematic. Setting Body.kinematic to 'false' will make it static.
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"kinematic",{get:function get(){return this.data.type===Phaser.Physics.P2.Body.KINEMATIC;},set:function set(value){if(value&&this.data.type!==Phaser.Physics.P2.Body.KINEMATIC){this.data.type=Phaser.Physics.P2.Body.KINEMATIC;this.mass=4;}else if(!value&&this.data.type===Phaser.Physics.P2.Body.KINEMATIC){this.data.type=Phaser.Physics.P2.Body.STATIC;this.mass=0;}}});/**
	* @name Phaser.Physics.P2.Body#allowSleep
	* @property {boolean} allowSleep -
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"allowSleep",{get:function get(){return this.data.allowSleep;},set:function set(value){if(value!==this.data.allowSleep){this.data.allowSleep=value;}}});/**
	* The angle of the Body in degrees from its original orientation. Values from 0 to 180 represent clockwise rotation; values from 0 to -180 represent counterclockwise rotation.
	* Values outside this range are added to or subtracted from 360 to obtain a value within the range. For example, the statement Body.angle = 450 is the same as Body.angle = 90.
	* If you wish to work in radians instead of degrees use the property Body.rotation instead. Working in radians is faster as it doesn't have to convert values.
	*
	* @name Phaser.Physics.P2.Body#angle
	* @property {number} angle - The angle of this Body in degrees.
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"angle",{get:function get(){return Phaser.Math.wrapAngle(Phaser.Math.radToDeg(this.data.angle));},set:function set(value){this.data.angle=Phaser.Math.degToRad(Phaser.Math.wrapAngle(value));}});/**
	* Damping is specified as a value between 0 and 1, which is the proportion of velocity lost per second.
	* @name Phaser.Physics.P2.Body#angularDamping
	* @property {number} angularDamping - The angular damping acting acting on the body.
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"angularDamping",{get:function get(){return this.data.angularDamping;},set:function set(value){this.data.angularDamping=value;}});/**
	* @name Phaser.Physics.P2.Body#angularForce
	* @property {number} angularForce - The angular force acting on the body.
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"angularForce",{get:function get(){return this.data.angularForce;},set:function set(value){this.data.angularForce=value;}});/**
	* @name Phaser.Physics.P2.Body#angularVelocity
	* @property {number} angularVelocity - The angular velocity of the body.
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"angularVelocity",{get:function get(){return this.data.angularVelocity;},set:function set(value){this.data.angularVelocity=value;}});/**
	* Damping is specified as a value between 0 and 1, which is the proportion of velocity lost per second.
	* @name Phaser.Physics.P2.Body#damping
	* @property {number} damping - The linear damping acting on the body in the velocity direction.
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"damping",{get:function get(){return this.data.damping;},set:function set(value){this.data.damping=value;}});/**
	* @name Phaser.Physics.P2.Body#fixedRotation
	* @property {boolean} fixedRotation -
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"fixedRotation",{get:function get(){return this.data.fixedRotation;},set:function set(value){if(value!==this.data.fixedRotation){this.data.fixedRotation=value;}}});/**
	* @name Phaser.Physics.P2.Body#inertia
	* @property {number} inertia - The inertia of the body around the Z axis..
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"inertia",{get:function get(){return this.data.inertia;},set:function set(value){this.data.inertia=value;}});/**
	* @name Phaser.Physics.P2.Body#mass
	* @property {number} mass - The mass of the body.
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"mass",{get:function get(){return this.data.mass;},set:function set(value){if(value!==this.data.mass){this.data.mass=value;this.data.updateMassProperties();}}});/**
	* @name Phaser.Physics.P2.Body#motionState
	* @property {number} motionState - The type of motion this body has. Should be one of: Body.STATIC (the body does not move), Body.DYNAMIC (body can move and respond to collisions) and Body.KINEMATIC (only moves according to its .velocity).
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"motionState",{get:function get(){return this.data.type;},set:function set(value){if(value!==this.data.type){this.data.type=value;}}});/**
	* The angle of the Body in radians.
	* If you wish to work in degrees instead of radians use the Body.angle property instead. Working in radians is faster as it doesn't have to convert values.
	*
	* @name Phaser.Physics.P2.Body#rotation
	* @property {number} rotation - The angle of this Body in radians.
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"rotation",{get:function get(){return this.data.angle;},set:function set(value){this.data.angle=value;}});/**
	* @name Phaser.Physics.P2.Body#sleepSpeedLimit
	* @property {number} sleepSpeedLimit - .
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"sleepSpeedLimit",{get:function get(){return this.data.sleepSpeedLimit;},set:function set(value){this.data.sleepSpeedLimit=value;}});/**
	* @name Phaser.Physics.P2.Body#x
	* @property {number} x - The x coordinate of this Body.
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"x",{get:function get(){return this.world.mpxi(this.data.position[0]);},set:function set(value){this.data.position[0]=this.world.pxmi(value);}});/**
	* @name Phaser.Physics.P2.Body#y
	* @property {number} y - The y coordinate of this Body.
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"y",{get:function get(){return this.world.mpxi(this.data.position[1]);},set:function set(value){this.data.position[1]=this.world.pxmi(value);}});/**
	* @name Phaser.Physics.P2.Body#id
	* @property {number} id - The Body ID. Each Body that has been added to the World has a unique ID.
	* @readonly
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"id",{get:function get(){return this.data.id;}});/**
	* @name Phaser.Physics.P2.Body#debug
	* @property {boolean} debug - Enable or disable debug drawing of this body
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"debug",{get:function get(){return this.debugBody!==null;},set:function set(value){if(value&&!this.debugBody){//  This will be added to the global space
	this.debugBody=new Phaser.Physics.P2.BodyDebug(this.game,this.data);}else if(!value&&this.debugBody){this.debugBody.destroy();this.debugBody=null;}}});/**
	* A Body can be set to collide against the World bounds automatically if this is set to true. Otherwise it will leave the World.
	* Note that this only applies if your World has bounds! The response to the collision should be managed via CollisionMaterials.
	* Also note that when you set this it will only effect Body shapes that already exist. If you then add further shapes to your Body
	* after setting this it will *not* proactively set them to collide with the bounds.
	*
	* @name Phaser.Physics.P2.Body#collideWorldBounds
	* @property {boolean} collideWorldBounds - Should the Body collide with the World bounds?
	*/Object.defineProperty(Phaser.Physics.P2.Body.prototype,"collideWorldBounds",{get:function get(){return this._collideWorldBounds;},set:function set(value){if(value&&!this._collideWorldBounds){this._collideWorldBounds=true;this.updateCollisionMask();}else if(!value&&this._collideWorldBounds){this._collideWorldBounds=false;this.updateCollisionMask();}}});/**
	* @author       George https://github.com/georgiee
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Draws a P2 Body to a Graphics instance for visual debugging.
	* Needless to say, for every body you enable debug drawing on, you are adding processor and graphical overhead.
	* So use sparingly and rarely (if ever) in production code.
	*
	* Also be aware that the Debug body is only updated when the Sprite it is connected to changes position. If you
	* manipulate the sprite in any other way (such as moving it to another Group or bringToTop, etc) then you will
	* need to manually adjust its BodyDebug as well.
	*
	* @class Phaser.Physics.P2.BodyDebug
	* @constructor
	* @extends Phaser.Group
	* @param {Phaser.Game} game - Game reference to the currently running game.
	* @param {Phaser.Physics.P2.Body} body - The P2 Body to display debug data for.
	* @param {object} settings - Settings object.
	*/Phaser.Physics.P2.BodyDebug=function(game,body,settings){Phaser.Group.call(this,game);/**
	    * @property {object} defaultSettings - Default debug settings.
	    * @private
	    */var defaultSettings={pixelsPerLengthUnit:game.physics.p2.mpx(1),debugPolygons:false,lineWidth:1,alpha:0.5};this.settings=Phaser.Utils.extend(defaultSettings,settings);/**
	    * @property {number} ppu - Pixels per Length Unit.
	    */this.ppu=this.settings.pixelsPerLengthUnit;this.ppu=-1*this.ppu;/**
	    * @property {Phaser.Physics.P2.Body} body - The P2 Body to display debug data for.
	    */this.body=body;/**
	    * @property {Phaser.Graphics} canvas - The canvas to render the debug info to.
	    */this.canvas=new Phaser.Graphics(game);this.canvas.alpha=this.settings.alpha;this.add(this.canvas);this.draw();this.updateSpriteTransform();};Phaser.Physics.P2.BodyDebug.prototype=Object.create(Phaser.Group.prototype);Phaser.Physics.P2.BodyDebug.prototype.constructor=Phaser.Physics.P2.BodyDebug;Phaser.Utils.extend(Phaser.Physics.P2.BodyDebug.prototype,{/**
	    * Core update.
	    *
	    * @method Phaser.Physics.P2.BodyDebug#updateSpriteTransform
	    */updateSpriteTransform:function updateSpriteTransform(){this.position.x=this.body.position[0]*this.ppu;this.position.y=this.body.position[1]*this.ppu;this.rotation=this.body.angle;},/**
	    * Draws the P2 shapes to the Graphics object.
	    *
	    * @method Phaser.Physics.P2.BodyDebug#draw
	    */draw:function draw(){var angle,child,color,i,j,lineColor,lw,obj,offset,sprite,v,verts,vrot,_j,_ref1;obj=this.body;sprite=this.canvas;sprite.clear();color=parseInt(this.randomPastelHex(),16);lineColor=0xff0000;lw=this.lineWidth;if(obj instanceof p2.Body&&obj.shapes.length){var l=obj.shapes.length;i=0;while(i!==l){child=obj.shapes[i];offset=child.position||0;angle=child.angle||0;if(child instanceof p2.Circle){this.drawCircle(sprite,offset[0]*this.ppu,offset[1]*this.ppu,angle,child.radius*this.ppu,color,lw);}else if(child instanceof p2.Capsule){this.drawCapsule(sprite,offset[0]*this.ppu,offset[1]*this.ppu,angle,child.length*this.ppu,child.radius*this.ppu,lineColor,color,lw);}else if(child instanceof p2.Plane){this.drawPlane(sprite,offset[0]*this.ppu,-offset[1]*this.ppu,color,lineColor,lw*5,lw*10,lw*10,this.ppu*100,angle);}else if(child instanceof p2.Line){this.drawLine(sprite,child.length*this.ppu,lineColor,lw);}else if(child instanceof p2.Box){this.drawRectangle(sprite,offset[0]*this.ppu,offset[1]*this.ppu,angle,child.width*this.ppu,child.height*this.ppu,lineColor,color,lw);}else if(child instanceof p2.Convex){verts=[];vrot=p2.vec2.create();for(j=_j=0,_ref1=child.vertices.length;0<=_ref1?_j<_ref1:_j>_ref1;j=0<=_ref1?++_j:--_j){v=child.vertices[j];p2.vec2.rotate(vrot,v,angle);verts.push([(vrot[0]+offset[0])*this.ppu,-(vrot[1]+offset[1])*this.ppu]);}this.drawConvex(sprite,verts,child.triangles,lineColor,color,lw,this.settings.debugPolygons,[offset[0]*this.ppu,-offset[1]*this.ppu]);}i++;}}},/**
	    * Draws a p2.Box to the Graphics object.
	    *
	    * @method Phaser.Physics.P2.BodyDebug#drawRectangle
	    * @private
	    */drawRectangle:function drawRectangle(g,x,y,angle,w,h,color,fillColor,lineWidth){if(lineWidth===undefined){lineWidth=1;}if(color===undefined){color=0x000000;}g.lineStyle(lineWidth,color,1);g.beginFill(fillColor);g.drawRect(x-w/2,y-h/2,w,h);},/**
	    * Draws a p2.Circle to the Graphics object.
	    *
	    * @method Phaser.Physics.P2.BodyDebug#drawCircle
	    * @private
	    */drawCircle:function drawCircle(g,x,y,angle,radius,color,lineWidth){if(lineWidth===undefined){lineWidth=1;}if(color===undefined){color=0xffffff;}g.lineStyle(lineWidth,0x000000,1);g.beginFill(color,1.0);g.drawCircle(x,y,-radius*2);g.endFill();g.moveTo(x,y);g.lineTo(x+radius*Math.cos(-angle),y+radius*Math.sin(-angle));},/**
	    * Draws a p2.Line to the Graphics object.
	    *
	    * @method Phaser.Physics.P2.BodyDebug#drawLine
	    * @private
	    */drawLine:function drawLine(g,len,color,lineWidth){if(lineWidth===undefined){lineWidth=1;}if(color===undefined){color=0x000000;}g.lineStyle(lineWidth*5,color,1);g.moveTo(-len/2,0);g.lineTo(len/2,0);},/**
	    * Draws a p2.Convex to the Graphics object.
	    *
	    * @method Phaser.Physics.P2.BodyDebug#drawConvex
	    * @private
	    */drawConvex:function drawConvex(g,verts,triangles,color,fillColor,lineWidth,debug,offset){var colors,i,v,v0,v1,x,x0,x1,y,y0,y1;if(lineWidth===undefined){lineWidth=1;}if(color===undefined){color=0x000000;}if(!debug){g.lineStyle(lineWidth,color,1);g.beginFill(fillColor);i=0;while(i!==verts.length){v=verts[i];x=v[0];y=v[1];if(i===0){g.moveTo(x,-y);}else{g.lineTo(x,-y);}i++;}g.endFill();if(verts.length>2){g.moveTo(verts[verts.length-1][0],-verts[verts.length-1][1]);return g.lineTo(verts[0][0],-verts[0][1]);}}else{colors=[0xff0000,0x00ff00,0x0000ff];i=0;while(i!==verts.length+1){v0=verts[i%verts.length];v1=verts[(i+1)%verts.length];x0=v0[0];y0=v0[1];x1=v1[0];y1=v1[1];g.lineStyle(lineWidth,colors[i%colors.length],1);g.moveTo(x0,-y0);g.lineTo(x1,-y1);g.drawCircle(x0,-y0,lineWidth*2);i++;}g.lineStyle(lineWidth,0x000000,1);return g.drawCircle(offset[0],offset[1],lineWidth*2);}},/**
	    * Draws a p2.Path to the Graphics object.
	    *
	    * @method Phaser.Physics.P2.BodyDebug#drawPath
	    * @private
	    */drawPath:function drawPath(g,path,color,fillColor,lineWidth){var area,i,lastx,lasty,p1x,p1y,p2x,p2y,p3x,p3y,v,x,y;if(lineWidth===undefined){lineWidth=1;}if(color===undefined){color=0x000000;}g.lineStyle(lineWidth,color,1);if(typeof fillColor==="number"){g.beginFill(fillColor);}lastx=null;lasty=null;i=0;while(i<path.length){v=path[i];x=v[0];y=v[1];if(x!==lastx||y!==lasty){if(i===0){g.moveTo(x,y);}else{p1x=lastx;p1y=lasty;p2x=x;p2y=y;p3x=path[(i+1)%path.length][0];p3y=path[(i+1)%path.length][1];area=(p2x-p1x)*(p3y-p1y)-(p3x-p1x)*(p2y-p1y);if(area!==0){g.lineTo(x,y);}}lastx=x;lasty=y;}i++;}if(typeof fillColor==="number"){g.endFill();}if(path.length>2&&typeof fillColor==="number"){g.moveTo(path[path.length-1][0],path[path.length-1][1]);g.lineTo(path[0][0],path[0][1]);}},/**
	    * Draws a p2.Plane to the Graphics object.
	    *
	    * @method Phaser.Physics.P2.BodyDebug#drawPlane
	    * @private
	    */drawPlane:function drawPlane(g,x0,x1,color,lineColor,lineWidth,diagMargin,diagSize,maxLength,angle){var max,xd,yd;if(lineWidth===undefined){lineWidth=1;}if(color===undefined){color=0xffffff;}g.lineStyle(lineWidth,lineColor,11);g.beginFill(color);max=maxLength;g.moveTo(x0,-x1);xd=x0+Math.cos(angle)*this.game.width;yd=x1+Math.sin(angle)*this.game.height;g.lineTo(xd,-yd);g.moveTo(x0,-x1);xd=x0+Math.cos(angle)*-this.game.width;yd=x1+Math.sin(angle)*-this.game.height;g.lineTo(xd,-yd);},/**
	    * Draws a p2.Capsule to the Graphics object.
	    *
	    * @method Phaser.Physics.P2.BodyDebug#drawCapsule
	    * @private
	    */drawCapsule:function drawCapsule(g,x,y,angle,len,radius,color,fillColor,lineWidth){if(lineWidth===undefined){lineWidth=1;}if(color===undefined){color=0x000000;}g.lineStyle(lineWidth,color,1);// Draw circles at ends
	var c=Math.cos(angle);var s=Math.sin(angle);g.beginFill(fillColor,1);g.drawCircle(-len/2*c+x,-len/2*s+y,-radius*2);g.drawCircle(len/2*c+x,len/2*s+y,-radius*2);g.endFill();// Draw rectangle
	g.lineStyle(lineWidth,color,0);g.beginFill(fillColor,1);g.moveTo(-len/2*c+radius*s+x,-len/2*s+radius*c+y);g.lineTo(len/2*c+radius*s+x,len/2*s+radius*c+y);g.lineTo(len/2*c-radius*s+x,len/2*s-radius*c+y);g.lineTo(-len/2*c-radius*s+x,-len/2*s-radius*c+y);g.endFill();// Draw lines in between
	g.lineStyle(lineWidth,color,1);g.moveTo(-len/2*c+radius*s+x,-len/2*s+radius*c+y);g.lineTo(len/2*c+radius*s+x,len/2*s+radius*c+y);g.moveTo(-len/2*c-radius*s+x,-len/2*s-radius*c+y);g.lineTo(len/2*c-radius*s+x,len/2*s-radius*c+y);},/**
	    * Picks a random pastel color.
	    *
	    * @method Phaser.Physics.P2.BodyDebug#randomPastelHex
	    * @private
	    */randomPastelHex:function randomPastelHex(){var blue,green,mix,red;mix=[255,255,255];red=Math.floor(Math.random()*256);green=Math.floor(Math.random()*256);blue=Math.floor(Math.random()*256);red=Math.floor((red+3*mix[0])/4);green=Math.floor((green+3*mix[1])/4);blue=Math.floor((blue+3*mix[2])/4);return this.rgbToHex(red,green,blue);},/**
	    * Converts from RGB to Hex.
	    *
	    * @method Phaser.Physics.P2.BodyDebug#rgbToHex
	    * @private
	    */rgbToHex:function rgbToHex(r,g,b){return this.componentToHex(r)+this.componentToHex(g)+this.componentToHex(b);},/**
	    * Component to hex conversion.
	    *
	    * @method Phaser.Physics.P2.BodyDebug#componentToHex
	    * @private
	    */componentToHex:function componentToHex(c){var hex;hex=c.toString(16);if(hex.length===2){return hex;}else{return hex+'0';}}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Creates a linear spring, connecting two bodies. A spring can have a resting length, a stiffness and damping.
	*
	* @class Phaser.Physics.P2.Spring
	* @constructor
	* @param {Phaser.Physics.P2} world - A reference to the P2 World.
	* @param {p2.Body} bodyA - First connected body.
	* @param {p2.Body} bodyB - Second connected body.
	* @param {number} [restLength=1] - Rest length of the spring. A number > 0.
	* @param {number} [stiffness=100] - Stiffness of the spring. A number >= 0.
	* @param {number} [damping=1] - Damping of the spring. A number >= 0.
	* @param {Array} [worldA] - Where to hook the spring to body A in world coordinates. This value is an array with 2 elements matching x and y, i.e: [32, 32].
	* @param {Array} [worldB] - Where to hook the spring to body B in world coordinates. This value is an array with 2 elements matching x and y, i.e: [32, 32].
	* @param {Array} [localA] - Where to hook the spring to body A in local body coordinates. This value is an array with 2 elements matching x and y, i.e: [32, 32].
	* @param {Array} [localB] - Where to hook the spring to body B in local body coordinates. This value is an array with 2 elements matching x and y, i.e: [32, 32].
	*/Phaser.Physics.P2.Spring=function(world,bodyA,bodyB,restLength,stiffness,damping,worldA,worldB,localA,localB){/**
	    * @property {Phaser.Game} game - Local reference to game.
	    */this.game=world.game;/**
	    * @property {Phaser.Physics.P2} world - Local reference to P2 World.
	    */this.world=world;if(restLength===undefined){restLength=1;}if(stiffness===undefined){stiffness=100;}if(damping===undefined){damping=1;}restLength=world.pxm(restLength);var options={restLength:restLength,stiffness:stiffness,damping:damping};if(typeof worldA!=='undefined'&&worldA!==null){options.worldAnchorA=[world.pxm(worldA[0]),world.pxm(worldA[1])];}if(typeof worldB!=='undefined'&&worldB!==null){options.worldAnchorB=[world.pxm(worldB[0]),world.pxm(worldB[1])];}if(typeof localA!=='undefined'&&localA!==null){options.localAnchorA=[world.pxm(localA[0]),world.pxm(localA[1])];}if(typeof localB!=='undefined'&&localB!==null){options.localAnchorB=[world.pxm(localB[0]),world.pxm(localB[1])];}/**
	    * @property {p2.LinearSpring} data - The actual p2 spring object.
	    */this.data=new p2.LinearSpring(bodyA,bodyB,options);this.data.parent=this;};Phaser.Physics.P2.Spring.prototype.constructor=Phaser.Physics.P2.Spring;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Creates a rotational spring, connecting two bodies. A spring can have a resting length, a stiffness and damping.
	*
	* @class Phaser.Physics.P2.RotationalSpring
	* @constructor
	* @param {Phaser.Physics.P2} world - A reference to the P2 World.
	* @param {p2.Body} bodyA - First connected body.
	* @param {p2.Body} bodyB - Second connected body.
	* @param {number} [restAngle] - The relative angle of bodies at which the spring is at rest. If not given, it's set to the current relative angle between the bodies.
	* @param {number} [stiffness=100] - Stiffness of the spring. A number >= 0.
	* @param {number} [damping=1] - Damping of the spring. A number >= 0.
	*/Phaser.Physics.P2.RotationalSpring=function(world,bodyA,bodyB,restAngle,stiffness,damping){/**
	    * @property {Phaser.Game} game - Local reference to game.
	    */this.game=world.game;/**
	    * @property {Phaser.Physics.P2} world - Local reference to P2 World.
	    */this.world=world;if(restAngle===undefined){restAngle=null;}if(stiffness===undefined){stiffness=100;}if(damping===undefined){damping=1;}if(restAngle){restAngle=world.pxm(restAngle);}var options={restAngle:restAngle,stiffness:stiffness,damping:damping};/**
	    * @property {p2.RotationalSpring} data - The actual p2 spring object.
	    */this.data=new p2.RotationalSpring(bodyA,bodyB,options);this.data.parent=this;};Phaser.Physics.P2.Spring.prototype.constructor=Phaser.Physics.P2.Spring;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A P2 Material.
	* 
	* \o/ ~ "Because I'm a Material girl"
	*
	* @class Phaser.Physics.P2.Material
	* @constructor
	* @param {string} name - The user defined name given to this Material.
	*/Phaser.Physics.P2.Material=function(name){/**
	    * @property {string} name - The user defined name given to this Material.
	    * @default
	    */this.name=name;p2.Material.call(this);};Phaser.Physics.P2.Material.prototype=Object.create(p2.Material.prototype);Phaser.Physics.P2.Material.prototype.constructor=Phaser.Physics.P2.Material;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Defines a physics material
	*
	* @class Phaser.Physics.P2.ContactMaterial
	* @constructor
	* @param {Phaser.Physics.P2.Material} materialA - First material participating in the contact material.
	* @param {Phaser.Physics.P2.Material} materialB - Second material participating in the contact material.
	* @param {object} [options] - Additional configuration options.
	*/Phaser.Physics.P2.ContactMaterial=function(materialA,materialB,options){/**
		* @property {number} id - The contact material identifier.
		*//**
		* @property {Phaser.Physics.P2.Material} materialA - First material participating in the contact material.
		*//**
		* @property {Phaser.Physics.P2.Material} materialB - Second material participating in the contact material.
		*//**
		* @property {number} [friction=0.3] - Friction to use in the contact of these two materials.
		*//**
		* @property {number} [restitution=0.0] - Restitution to use in the contact of these two materials.
		*//**
		* @property {number} [stiffness=1e7] - Stiffness of the resulting ContactEquation that this ContactMaterial generates.
		*//**
		* @property {number} [relaxation=3] - Relaxation of the resulting ContactEquation that this ContactMaterial generates.
		*//**
		* @property {number} [frictionStiffness=1e7] - Stiffness of the resulting FrictionEquation that this ContactMaterial generates.
		*//**
		* @property {number} [frictionRelaxation=3] - Relaxation of the resulting FrictionEquation that this ContactMaterial generates.
		*//**
		* @property {number} [surfaceVelocity=0] - Will add surface velocity to this material. If bodyA rests on top if bodyB, and the surface velocity is positive, bodyA will slide to the right.
		*/p2.ContactMaterial.call(this,materialA,materialB,options);};Phaser.Physics.P2.ContactMaterial.prototype=Object.create(p2.ContactMaterial.prototype);Phaser.Physics.P2.ContactMaterial.prototype.constructor=Phaser.Physics.P2.ContactMaterial;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Collision Group
	*
	* @class Phaser.Physics.P2.CollisionGroup
	* @constructor
	* @param {number} bitmask - The CollisionGroup bitmask.
	*/Phaser.Physics.P2.CollisionGroup=function(bitmask){/**
	    * @property {number} mask - The CollisionGroup bitmask.
	    */this.mask=bitmask;};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A constraint that tries to keep the distance between two bodies constant.
	*
	* @class Phaser.Physics.P2.DistanceConstraint
	* @constructor
	* @param {Phaser.Physics.P2} world - A reference to the P2 World.
	* @param {p2.Body} bodyA - First connected body.
	* @param {p2.Body} bodyB - Second connected body.
	* @param {number} distance - The distance to keep between the bodies.
	* @param {Array} [localAnchorA] - The anchor point for bodyA, defined locally in bodyA frame. Defaults to [0,0].
	* @param {Array} [localAnchorB] - The anchor point for bodyB, defined locally in bodyB frame. Defaults to [0,0].
	* @param {object} [maxForce=Number.MAX_VALUE] - Maximum force to apply.
	*/Phaser.Physics.P2.DistanceConstraint=function(world,bodyA,bodyB,distance,localAnchorA,localAnchorB,maxForce){if(distance===undefined){distance=100;}if(localAnchorA===undefined){localAnchorA=[0,0];}if(localAnchorB===undefined){localAnchorB=[0,0];}if(maxForce===undefined){maxForce=Number.MAX_VALUE;}/**
	    * @property {Phaser.Game} game - Local reference to game.
	    */this.game=world.game;/**
	    * @property {Phaser.Physics.P2} world - Local reference to P2 World.
	    */this.world=world;distance=world.pxm(distance);localAnchorA=[world.pxmi(localAnchorA[0]),world.pxmi(localAnchorA[1])];localAnchorB=[world.pxmi(localAnchorB[0]),world.pxmi(localAnchorB[1])];var options={distance:distance,localAnchorA:localAnchorA,localAnchorB:localAnchorB,maxForce:maxForce};p2.DistanceConstraint.call(this,bodyA,bodyB,options);};Phaser.Physics.P2.DistanceConstraint.prototype=Object.create(p2.DistanceConstraint.prototype);Phaser.Physics.P2.DistanceConstraint.prototype.constructor=Phaser.Physics.P2.DistanceConstraint;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Connects two bodies at given offset points, letting them rotate relative to each other around this point.
	*
	* @class Phaser.Physics.P2.GearConstraint
	* @constructor
	* @param {Phaser.Physics.P2} world - A reference to the P2 World.
	* @param {p2.Body} bodyA - First connected body.
	* @param {p2.Body} bodyB - Second connected body.
	* @param {number} [angle=0] - The relative angle
	* @param {number} [ratio=1] - The gear ratio.
	*/Phaser.Physics.P2.GearConstraint=function(world,bodyA,bodyB,angle,ratio){if(angle===undefined){angle=0;}if(ratio===undefined){ratio=1;}/**
	    * @property {Phaser.Game} game - Local reference to game.
	    */this.game=world.game;/**
	    * @property {Phaser.Physics.P2} world - Local reference to P2 World.
	    */this.world=world;var options={angle:angle,ratio:ratio};p2.GearConstraint.call(this,bodyA,bodyB,options);};Phaser.Physics.P2.GearConstraint.prototype=Object.create(p2.GearConstraint.prototype);Phaser.Physics.P2.GearConstraint.prototype.constructor=Phaser.Physics.P2.GearConstraint;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Locks the relative position between two bodies.
	*
	* @class Phaser.Physics.P2.LockConstraint
	* @constructor
	* @param {Phaser.Physics.P2} world - A reference to the P2 World.
	* @param {p2.Body} bodyA - First connected body.
	* @param {p2.Body} bodyB - Second connected body.
	* @param {Array} [offset] - The offset of bodyB in bodyA's frame. The value is an array with 2 elements matching x and y, i.e: [32, 32].
	* @param {number} [angle=0] - The angle of bodyB in bodyA's frame.
	* @param {number} [maxForce] - The maximum force that should be applied to constrain the bodies.
	*/Phaser.Physics.P2.LockConstraint=function(world,bodyA,bodyB,offset,angle,maxForce){if(offset===undefined){offset=[0,0];}if(angle===undefined){angle=0;}if(maxForce===undefined){maxForce=Number.MAX_VALUE;}/**
	    * @property {Phaser.Game} game - Local reference to game.
	    */this.game=world.game;/**
	    * @property {Phaser.Physics.P2} world - Local reference to P2 World.
	    */this.world=world;offset=[world.pxm(offset[0]),world.pxm(offset[1])];var options={localOffsetB:offset,localAngleB:angle,maxForce:maxForce};p2.LockConstraint.call(this,bodyA,bodyB,options);};Phaser.Physics.P2.LockConstraint.prototype=Object.create(p2.LockConstraint.prototype);Phaser.Physics.P2.LockConstraint.prototype.constructor=Phaser.Physics.P2.LockConstraint;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Connects two bodies at given offset points, letting them rotate relative to each other around this point.
	*
	* @class Phaser.Physics.P2.PrismaticConstraint
	* @constructor
	* @param {Phaser.Physics.P2} world - A reference to the P2 World.
	* @param {p2.Body} bodyA - First connected body.
	* @param {p2.Body} bodyB - Second connected body.
	* @param {boolean} [lockRotation=true] - If set to false, bodyB will be free to rotate around its anchor point.
	* @param {Array} [anchorA] - Body A's anchor point, defined in its own local frame. The value is an array with 2 elements matching x and y, i.e: [32, 32].
	* @param {Array} [anchorB] - Body A's anchor point, defined in its own local frame. The value is an array with 2 elements matching x and y, i.e: [32, 32].
	* @param {Array} [axis] - An axis, defined in body A frame, that body B's anchor point may slide along. The value is an array with 2 elements matching x and y, i.e: [32, 32].
	* @param {number} [maxForce] - The maximum force that should be applied to constrain the bodies.
	*/Phaser.Physics.P2.PrismaticConstraint=function(world,bodyA,bodyB,lockRotation,anchorA,anchorB,axis,maxForce){if(lockRotation===undefined){lockRotation=true;}if(anchorA===undefined){anchorA=[0,0];}if(anchorB===undefined){anchorB=[0,0];}if(axis===undefined){axis=[0,0];}if(maxForce===undefined){maxForce=Number.MAX_VALUE;}/**
	    * @property {Phaser.Game} game - Local reference to game.
	    */this.game=world.game;/**
	    * @property {Phaser.Physics.P2} world - Local reference to P2 World.
	    */this.world=world;anchorA=[world.pxmi(anchorA[0]),world.pxmi(anchorA[1])];anchorB=[world.pxmi(anchorB[0]),world.pxmi(anchorB[1])];var options={localAnchorA:anchorA,localAnchorB:anchorB,localAxisA:axis,maxForce:maxForce,disableRotationalLock:!lockRotation};p2.PrismaticConstraint.call(this,bodyA,bodyB,options);};Phaser.Physics.P2.PrismaticConstraint.prototype=Object.create(p2.PrismaticConstraint.prototype);Phaser.Physics.P2.PrismaticConstraint.prototype.constructor=Phaser.Physics.P2.PrismaticConstraint;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Connects two bodies at given offset points, letting them rotate relative to each other around this point.
	* The pivot points are given in world (pixel) coordinates.
	*
	* @class Phaser.Physics.P2.RevoluteConstraint
	* @constructor
	* @param {Phaser.Physics.P2} world - A reference to the P2 World.
	* @param {p2.Body} bodyA - First connected body.
	* @param {Float32Array} pivotA - The point relative to the center of mass of bodyA which bodyA is constrained to. The value is an array with 2 elements matching x and y, i.e: [32, 32].
	* @param {p2.Body} bodyB - Second connected body.
	* @param {Float32Array} pivotB - The point relative to the center of mass of bodyB which bodyB is constrained to. The value is an array with 2 elements matching x and y, i.e: [32, 32].
	* @param {number} [maxForce=0] - The maximum force that should be applied to constrain the bodies.
	* @param {Float32Array} [worldPivot=null] - A pivot point given in world coordinates. If specified, localPivotA and localPivotB are automatically computed from this value.
	*/Phaser.Physics.P2.RevoluteConstraint=function(world,bodyA,pivotA,bodyB,pivotB,maxForce,worldPivot){if(maxForce===undefined){maxForce=Number.MAX_VALUE;}if(worldPivot===undefined){worldPivot=null;}/**
	    * @property {Phaser.Game} game - Local reference to game.
	    */this.game=world.game;/**
	    * @property {Phaser.Physics.P2} world - Local reference to P2 World.
	    */this.world=world;pivotA=[world.pxmi(pivotA[0]),world.pxmi(pivotA[1])];pivotB=[world.pxmi(pivotB[0]),world.pxmi(pivotB[1])];if(worldPivot){worldPivot=[world.pxmi(worldPivot[0]),world.pxmi(worldPivot[1])];}var options={worldPivot:worldPivot,localPivotA:pivotA,localPivotB:pivotB,maxForce:maxForce};p2.RevoluteConstraint.call(this,bodyA,bodyB,options);};Phaser.Physics.P2.RevoluteConstraint.prototype=Object.create(p2.RevoluteConstraint.prototype);Phaser.Physics.P2.RevoluteConstraint.prototype.constructor=Phaser.Physics.P2.RevoluteConstraint;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* An Image Collection is a special tileset containing mulitple images, with no slicing into each image.
	*
	* Image Collections are normally created automatically when Tiled data is loaded.
	*
	* @class Phaser.ImageCollection
	* @constructor
	* @param {string} name - The name of the image collection in the map data.
	* @param {integer} firstgid - The first image index this image collection contains.
	* @param {integer} [width=32] - Width of widest image (in pixels).
	* @param {integer} [height=32] - Height of tallest image (in pixels).
	* @param {integer} [margin=0] - The margin around all images in the collection (in pixels).
	* @param {integer} [spacing=0] - The spacing between each image in the collection (in pixels).
	* @param {object} [properties={}] - Custom Image Collection properties.
	*/Phaser.ImageCollection=function(name,firstgid,width,height,margin,spacing,properties){if(width===undefined||width<=0){width=32;}if(height===undefined||height<=0){height=32;}if(margin===undefined){margin=0;}if(spacing===undefined){spacing=0;}/**
	    * The name of the Image Collection.
	    * @property {string} name
	    */this.name=name;/**
	    * The Tiled firstgid value.
	    * This is the starting index of the first image index this Image Collection contains.
	    * @property {integer} firstgid
	    */this.firstgid=firstgid|0;/**
	    * The width of the widest image (in pixels).
	    * @property {integer} imageWidth
	    * @readonly
	    */this.imageWidth=width|0;/**
	    * The height of the tallest image (in pixels).
	    * @property {integer} imageHeight
	    * @readonly
	    */this.imageHeight=height|0;/**
	    * The margin around the images in the collection (in pixels).
	    * Use `setSpacing` to change.
	    * @property {integer} imageMarge
	    * @readonly
	    */// Modified internally
	this.imageMargin=margin|0;/**
	    * The spacing between each image in the collection (in pixels).
	    * Use `setSpacing` to change.
	    * @property {integer} imageSpacing
	    * @readonly
	    */this.imageSpacing=spacing|0;/**
	    * Image Collection-specific properties that are typically defined in the Tiled editor.
	    * @property {object} properties
	    */this.properties=properties||{};/**
	    * The cached images that are a part of this collection.
	    * @property {array} images
	    * @readonly
	    */// Modified internally
	this.images=[];/**
	    * The total number of images in the image collection.
	    * @property {integer} total
	    * @readonly
	    */// Modified internally
	this.total=0;};Phaser.ImageCollection.prototype={/**
	    * Returns true if and only if this image collection contains the given image index.
	    *
	    * @method Phaser.ImageCollection#containsImageIndex
	    * @param {integer} imageIndex - The image index to search for.
	    * @return {boolean} True if this Image Collection contains the given index.
	    */containsImageIndex:function containsImageIndex(imageIndex){return imageIndex>=this.firstgid&&imageIndex<this.firstgid+this.total;},/**
	    * Add an image to this Image Collection.
	    *
	    * @method Phaser.ImageCollection#addImage
	    * @param {integer} gid - The gid of the image in the Image Collection.
	    * @param {string} image - The the key of the image in the Image Collection and in the cache.
	    */addImage:function addImage(gid,image){this.images.push({gid:gid,image:image});this.total++;}};Phaser.ImageCollection.prototype.constructor=Phaser.ImageCollection;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A Tile is a representation of a single tile within the Tilemap.
	*
	* @class Phaser.Tile
	* @constructor
	* @param {object} layer - The layer in the Tilemap data that this tile belongs to.
	* @param {number} index - The index of this tile type in the core map data.
	* @param {number} x - The x coordinate of this tile.
	* @param {number} y - The y coordinate of this tile.
	* @param {number} width - Width of the tile.
	* @param {number} height - Height of the tile.
	*/Phaser.Tile=function(layer,index,x,y,width,height){/**
	    * @property {object} layer - The layer in the Tilemap data that this tile belongs to.
	    */this.layer=layer;/**
	    * @property {number} index - The index of this tile within the map data corresponding to the tileset, or -1 if this represents a blank/null tile.
	    */this.index=index;/**
	    * @property {number} x - The x map coordinate of this tile.
	    */this.x=x;/**
	    * @property {number} y - The y map coordinate of this tile.
	    */this.y=y;/**
	    * @property {number} rotation - The rotation angle of this tile.
	    */this.rotation=0;/**
	    * @property {boolean} flipped - Whether this tile is flipped (mirrored) or not.
	    */this.flipped=false;/**
	    * @property {number} x - The x map coordinate of this tile.
	    */this.worldX=x*width;/**
	    * @property {number} y - The y map coordinate of this tile.
	    */this.worldY=y*height;/**
	    * @property {number} width - The width of the tile in pixels.
	    */this.width=width;/**
	    * @property {number} height - The height of the tile in pixels.
	    */this.height=height;/**
	    * @property {number} width - The width of the tile in pixels.
	    */this.centerX=Math.abs(width/2);/**
	    * @property {number} height - The height of the tile in pixels.
	    */this.centerY=Math.abs(height/2);/**
	    * @property {number} alpha - The alpha value at which this tile is drawn to the canvas.
	    */this.alpha=1;/**
	    * @property {object} properties - Tile specific properties.
	    */this.properties={};/**
	    * @property {boolean} scanned - Has this tile been walked / turned into a poly?
	    */this.scanned=false;/**
	    * @property {boolean} faceTop - Is the top of this tile an interesting edge?
	    */this.faceTop=false;/**
	    * @property {boolean} faceBottom - Is the bottom of this tile an interesting edge?
	    */this.faceBottom=false;/**
	    * @property {boolean} faceLeft - Is the left of this tile an interesting edge?
	    */this.faceLeft=false;/**
	    * @property {boolean} faceRight - Is the right of this tile an interesting edge?
	    */this.faceRight=false;/**
	    * @property {boolean} collideLeft - Indicating collide with any object on the left.
	    * @default
	    */this.collideLeft=false;/**
	    * @property {boolean} collideRight - Indicating collide with any object on the right.
	    * @default
	    */this.collideRight=false;/**
	    * @property {boolean} collideUp - Indicating collide with any object on the top.
	    * @default
	    */this.collideUp=false;/**
	    * @property {boolean} collideDown - Indicating collide with any object on the bottom.
	    * @default
	    */this.collideDown=false;/**
	    * @property {function} collisionCallback - Tile collision callback.
	    * @default
	    */this.collisionCallback=null;/**
	    * @property {object} collisionCallbackContext - The context in which the collision callback will be called.
	    * @default
	    */this.collisionCallbackContext=this;};Phaser.Tile.prototype={/**
	    * Check if the given x and y world coordinates are within this Tile.
	    *
	    * @method Phaser.Tile#containsPoint
	    * @param {number} x - The x coordinate to test.
	    * @param {number} y - The y coordinate to test.
	    * @return {boolean} True if the coordinates are within this Tile, otherwise false.
	    */containsPoint:function containsPoint(x,y){return!(x<this.worldX||y<this.worldY||x>this.right||y>this.bottom);},/**
	    * Check for intersection with this tile.
	    *
	    * @method Phaser.Tile#intersects
	    * @param {number} x - The x axis in pixels.
	    * @param {number} y - The y axis in pixels.
	    * @param {number} right - The right point.
	    * @param {number} bottom - The bottom point.
	    */intersects:function intersects(x,y,right,bottom){if(right<=this.worldX){return false;}if(bottom<=this.worldY){return false;}if(x>=this.worldX+this.width){return false;}if(y>=this.worldY+this.height){return false;}return true;},/**
	    * Set a callback to be called when this tile is hit by an object.
	    * The callback must true true for collision processing to take place.
	    *
	    * @method Phaser.Tile#setCollisionCallback
	    * @param {function} callback - Callback function.
	    * @param {object} context - Callback will be called within this context.
	    */setCollisionCallback:function setCollisionCallback(callback,context){this.collisionCallback=callback;this.collisionCallbackContext=context;},/**
	    * Clean up memory.
	    *
	    * @method Phaser.Tile#destroy
	    */destroy:function destroy(){this.collisionCallback=null;this.collisionCallbackContext=null;this.properties=null;},/**
	    * Sets the collision flags for each side of this tile and updates the interesting faces list.
	    *
	    * @method Phaser.Tile#setCollision
	    * @param {boolean} left - Indicating collide with any object on the left.
	    * @param {boolean} right - Indicating collide with any object on the right.
	    * @param {boolean} up - Indicating collide with any object on the top.
	    * @param {boolean} down - Indicating collide with any object on the bottom.
	    */setCollision:function setCollision(left,right,up,down){this.collideLeft=left;this.collideRight=right;this.collideUp=up;this.collideDown=down;this.faceLeft=left;this.faceRight=right;this.faceTop=up;this.faceBottom=down;},/**
	    * Reset collision status flags.
	    *
	    * @method Phaser.Tile#resetCollision
	    */resetCollision:function resetCollision(){this.collideLeft=false;this.collideRight=false;this.collideUp=false;this.collideDown=false;this.faceTop=false;this.faceBottom=false;this.faceLeft=false;this.faceRight=false;},/**
	    * Is this tile interesting?
	    *
	    * @method Phaser.Tile#isInteresting
	    * @param {boolean} collides - If true will check any collides value.
	    * @param {boolean} faces - If true will check any face value.
	    * @return {boolean} True if the Tile is interesting, otherwise false.
	    */isInteresting:function isInteresting(collides,faces){if(collides&&faces){//  Does this tile have any collide flags OR interesting face?
	return this.collideLeft||this.collideRight||this.collideUp||this.collideDown||this.faceTop||this.faceBottom||this.faceLeft||this.faceRight||this.collisionCallback;}else if(collides){//  Does this tile collide?
	return this.collideLeft||this.collideRight||this.collideUp||this.collideDown;}else if(faces){//  Does this tile have an interesting face?
	return this.faceTop||this.faceBottom||this.faceLeft||this.faceRight;}return false;},/**
	    * Copies the tile data and properties from the given tile to this tile.
	    *
	    * @method Phaser.Tile#copy
	    * @param {Phaser.Tile} tile - The tile to copy from.
	    */copy:function copy(tile){this.index=tile.index;this.alpha=tile.alpha;this.properties=tile.properties;this.collideUp=tile.collideUp;this.collideDown=tile.collideDown;this.collideLeft=tile.collideLeft;this.collideRight=tile.collideRight;this.collisionCallback=tile.collisionCallback;this.collisionCallbackContext=tile.collisionCallbackContext;}};Phaser.Tile.prototype.constructor=Phaser.Tile;/**
	* @name Phaser.Tile#collides
	* @property {boolean} collides - True if this tile can collide on any of its faces.
	* @readonly
	*/Object.defineProperty(Phaser.Tile.prototype,"collides",{get:function get(){return this.collideLeft||this.collideRight||this.collideUp||this.collideDown;}});/**
	* @name Phaser.Tile#canCollide
	* @property {boolean} canCollide - True if this tile can collide on any of its faces or has a collision callback set.
	* @readonly
	*/Object.defineProperty(Phaser.Tile.prototype,"canCollide",{get:function get(){return this.collideLeft||this.collideRight||this.collideUp||this.collideDown||this.collisionCallback;}});/**
	* @name Phaser.Tile#left
	* @property {number} left - The x value in pixels.
	* @readonly
	*/Object.defineProperty(Phaser.Tile.prototype,"left",{get:function get(){return this.worldX;}});/**
	* @name Phaser.Tile#right
	* @property {number} right - The sum of the x and width properties.
	* @readonly
	*/Object.defineProperty(Phaser.Tile.prototype,"right",{get:function get(){return this.worldX+this.width;}});/**
	* @name Phaser.Tile#top
	* @property {number} top - The y value.
	* @readonly
	*/Object.defineProperty(Phaser.Tile.prototype,"top",{get:function get(){return this.worldY;}});/**
	* @name Phaser.Tile#bottom
	* @property {number} bottom - The sum of the y and height properties.
	* @readonly
	*/Object.defineProperty(Phaser.Tile.prototype,"bottom",{get:function get(){return this.worldY+this.height;}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Creates a new Phaser.Tilemap object. The map can either be populated with data from a Tiled JSON file or from a CSV file.
	*
	* Tiled is a free software package specifically for creating tile maps, and is available from http://www.mapeditor.org
	* 
	* To do this pass the Cache key as the first parameter. When using Tiled data you need only provide the key.
	* When using CSV data you must provide the key and the tileWidth and tileHeight parameters.
	* If creating a blank tilemap to be populated later, you can either specify no parameters at all and then use `Tilemap.create` or pass the map and tile dimensions here.
	* Note that all Tilemaps use a base tile size to calculate dimensions from, but that a TilemapLayer may have its own unique tile size that overrides it.
	* A Tile map is rendered to the display using a TilemapLayer. It is not added to the display list directly itself.
	* A map may have multiple layers. You can perform operations on the map data such as copying, pasting, filling and shuffling the tiles around.
	*
	* @class Phaser.Tilemap
	* @constructor
	* @param {Phaser.Game} game - Game reference to the currently running game.
	* @param {string} [key] - The key of the tilemap data as stored in the Cache. If you're creating a blank map either leave this parameter out or pass `null`.
	* @param {number} [tileWidth=32] - The pixel width of a single map tile. If using CSV data you must specify this. Not required if using Tiled map data.
	* @param {number} [tileHeight=32] - The pixel height of a single map tile. If using CSV data you must specify this. Not required if using Tiled map data.
	* @param {number} [width=10] - The width of the map in tiles. If this map is created from Tiled or CSV data you don't need to specify this.
	* @param {number} [height=10] - The height of the map in tiles. If this map is created from Tiled or CSV data you don't need to specify this.
	*/Phaser.Tilemap=function(game,key,tileWidth,tileHeight,width,height){/**
	    * @property {Phaser.Game} game - A reference to the currently running Game.
	    */this.game=game;/**
	    * @property {string} key - The key of this map data in the Phaser.Cache.
	    */this.key=key;var data=Phaser.TilemapParser.parse(this.game,key,tileWidth,tileHeight,width,height);if(data===null){return;}/**
	    * @property {number} width - The width of the map (in tiles).
	    */this.width=data.width;/**
	    * @property {number} height - The height of the map (in tiles).
	    */this.height=data.height;/**
	    * @property {number} tileWidth - The base width of the tiles in the map (in pixels).
	    */this.tileWidth=data.tileWidth;/**
	    * @property {number} tileHeight - The base height of the tiles in the map (in pixels).
	    */this.tileHeight=data.tileHeight;/**
	    * @property {string} orientation - The orientation of the map data (as specified in Tiled), usually 'orthogonal'.
	    */this.orientation=data.orientation;/**
	    * @property {number} format - The format of the map data, either Phaser.Tilemap.CSV or Phaser.Tilemap.TILED_JSON.
	    */this.format=data.format;/**
	    * @property {number} version - The version of the map data (as specified in Tiled, usually 1).
	    */this.version=data.version;/**
	    * @property {object} properties - Map specific properties as specified in Tiled.
	    */this.properties=data.properties;/**
	    * @property {number} widthInPixels - The width of the map in pixels based on width * tileWidth.
	    */this.widthInPixels=data.widthInPixels;/**
	    * @property {number} heightInPixels - The height of the map in pixels based on height * tileHeight.
	    */this.heightInPixels=data.heightInPixels;/**
	    * @property {array} layers - An array of Tilemap layer data.
	    */this.layers=data.layers;/**
	    * @property {array} tilesets - An array of Tilesets.
	    */this.tilesets=data.tilesets;/**
	    * @property {array} imagecollections - An array of Image Collections.
	    */this.imagecollections=data.imagecollections;/**
	    * @property {array} tiles - The super array of Tiles.
	    */this.tiles=data.tiles;/**
	    * @property {array} objects - An array of Tiled Object Layers.
	    */this.objects=data.objects;/**
	    * @property {array} collideIndexes - An array of tile indexes that collide.
	    */this.collideIndexes=[];/**
	    * @property {array} collision - An array of collision data (polylines, etc).
	    */this.collision=data.collision;/**
	    * @property {array} images - An array of Tiled Image Layers.
	    */this.images=data.images;/**
	    * @property {boolean} enableDebug - If set then console.log is used to dump out useful layer creation debug data.
	    */this.enableDebug=false;/**
	    * @property {number} currentLayer - The current layer.
	    */this.currentLayer=0;/**
	    * @property {array} debugMap - Map data used for debug values only.
	    */this.debugMap=[];/**
	    * @property {array} _results - Internal var.
	    * @private
	    */this._results=[];/**
	    * @property {number} _tempA - Internal var.
	    * @private
	    */this._tempA=0;/**
	    * @property {number} _tempB - Internal var.
	    * @private
	    */this._tempB=0;};/**
	* @constant
	* @type {number}
	*/Phaser.Tilemap.CSV=0;/**
	* @constant
	* @type {number}
	*/Phaser.Tilemap.TILED_JSON=1;/**
	* @constant
	* @type {number}
	*/Phaser.Tilemap.NORTH=0;/**
	* @constant
	* @type {number}
	*/Phaser.Tilemap.EAST=1;/**
	* @constant
	* @type {number}
	*/Phaser.Tilemap.SOUTH=2;/**
	* @constant
	* @type {number}
	*/Phaser.Tilemap.WEST=3;Phaser.Tilemap.prototype={/**
	    * Creates an empty map of the given dimensions and one blank layer. If layers already exist they are erased.
	    *
	    * @method Phaser.Tilemap#create
	    * @param {string} name - The name of the default layer of the map.
	    * @param {number} width - The width of the map in tiles.
	    * @param {number} height - The height of the map in tiles.
	    * @param {number} tileWidth - The width of the tiles the map uses for calculations.
	    * @param {number} tileHeight - The height of the tiles the map uses for calculations.
	    * @param {Phaser.Group} [group] - Optional Group to add the layer to. If not specified it will be added to the World group.
	    * @return {Phaser.TilemapLayer} The TilemapLayer object. This is an extension of Phaser.Image and can be moved around the display list accordingly.
	    */create:function create(name,width,height,tileWidth,tileHeight,group){if(group===undefined){group=this.game.world;}this.width=width;this.height=height;this.setTileSize(tileWidth,tileHeight);this.layers.length=0;return this.createBlankLayer(name,width,height,tileWidth,tileHeight,group);},/**
	    * Sets the base tile size for the map.
	    *
	    * @method Phaser.Tilemap#setTileSize
	    * @param {number} tileWidth - The width of the tiles the map uses for calculations.
	    * @param {number} tileHeight - The height of the tiles the map uses for calculations.
	    */setTileSize:function setTileSize(tileWidth,tileHeight){this.tileWidth=tileWidth;this.tileHeight=tileHeight;this.widthInPixels=this.width*tileWidth;this.heightInPixels=this.height*tileHeight;},/**
	    * Adds an image to the map to be used as a tileset. A single map may use multiple tilesets.
	    * Note that the tileset name can be found in the JSON file exported from Tiled, or in the Tiled editor.
	    *
	    * @method Phaser.Tilemap#addTilesetImage
	    * @param {string} tileset - The name of the tileset as specified in the map data.
	    * @param {string|Phaser.BitmapData} [key] - The key of the Phaser.Cache image used for this tileset.
	    *     If `undefined` or `null` it will look for an image with a key matching the tileset parameter.
	    *     You can also pass in a BitmapData which can be used instead of an Image.
	    * @param {number} [tileWidth=32] - The width of the tiles in the Tileset Image. If not given it will default to the map.tileWidth value, if that isn't set then 32.
	    * @param {number} [tileHeight=32] - The height of the tiles in the Tileset Image. If not given it will default to the map.tileHeight value, if that isn't set then 32.
	    * @param {number} [tileMargin=0] - The width of the tiles in the Tileset Image.
	    * @param {number} [tileSpacing=0] - The height of the tiles in the Tileset Image.
	    * @param {number} [gid=0] - If adding multiple tilesets to a blank/dynamic map, specify the starting GID the set will use here.
	    * @return {Phaser.Tileset} Returns the Tileset object that was created or updated, or null if it failed.
	    */addTilesetImage:function addTilesetImage(tileset,key,tileWidth,tileHeight,tileMargin,tileSpacing,gid){if(tileset===undefined){return null;}if(tileWidth===undefined){tileWidth=this.tileWidth;}if(tileHeight===undefined){tileHeight=this.tileHeight;}if(tileMargin===undefined){tileMargin=0;}if(tileSpacing===undefined){tileSpacing=0;}if(gid===undefined){gid=0;}//  In-case we're working from a blank map
	if(tileWidth===0){tileWidth=32;}if(tileHeight===0){tileHeight=32;}var img=null;if(key===undefined||key===null){key=tileset;}if(key instanceof Phaser.BitmapData){img=key.canvas;}else{if(!this.game.cache.checkImageKey(key)){console.warn('Phaser.Tilemap.addTilesetImage: Invalid image key given: "'+key+'"');return null;}img=this.game.cache.getImage(key);}var idx=this.getTilesetIndex(tileset);if(idx===null&&this.format===Phaser.Tilemap.TILED_JSON){console.warn('Phaser.Tilemap.addTilesetImage: No data found in the JSON matching the tileset name: "'+tileset+'"');return null;}if(this.tilesets[idx]){this.tilesets[idx].setImage(img);return this.tilesets[idx];}else{var newSet=new Phaser.Tileset(tileset,gid,tileWidth,tileHeight,tileMargin,tileSpacing,{});newSet.setImage(img);this.tilesets.push(newSet);var i=this.tilesets.length-1;var x=tileMargin;var y=tileMargin;var count=0;var countX=0;var countY=0;for(var t=gid;t<gid+newSet.total;t++){this.tiles[t]=[x,y,i];x+=tileWidth+tileSpacing;count++;if(count===newSet.total){break;}countX++;if(countX===newSet.columns){x=tileMargin;y+=tileHeight+tileSpacing;countX=0;countY++;if(countY===newSet.rows){break;}}}return newSet;}return null;},/**
	    * Creates a Sprite for every object matching the given gid in the map data. You can optionally specify the group that the Sprite will be created in. If none is
	    * given it will be created in the World. All properties from the map data objectgroup are copied across to the Sprite, so you can use this as an easy way to
	    * configure Sprite properties from within the map editor. For example giving an object a property of alpha: 0.5 in the map editor will duplicate that when the
	    * Sprite is created. You could also give it a value like: body.velocity.x: 100 to set it moving automatically.
	    *
	    * @method Phaser.Tilemap#createFromObjects
	    * @param {string} name - The name of the Object Group to create Sprites from.
	    * @param {number} gid - The layer array index value, or if a string is given the layer name within the map data.
	    * @param {string} key - The Game.cache key of the image that this Sprite will use.
	    * @param {number|string} [frame] - If the Sprite image contains multiple frames you can specify which one to use here.
	    * @param {boolean} [exists=true] - The default exists state of the Sprite.
	    * @param {boolean} [autoCull=false] - The default autoCull state of the Sprite. Sprites that are autoCulled are culled from the camera if out of its range.
	    * @param {Phaser.Group} [group=Phaser.World] - Group to add the Sprite to. If not specified it will be added to the World group.
	    * @param {object} [CustomClass=Phaser.Sprite] - If you wish to create your own class, rather than Phaser.Sprite, pass the class here. Your class must extend Phaser.Sprite and have the same constructor parameters.
	    * @param {boolean} [adjustY=true] - By default the Tiled map editor uses a bottom-left coordinate system. Phaser uses top-left. So most objects will appear too low down. This parameter moves them up by their height.
	    */createFromObjects:function createFromObjects(name,gid,key,frame,exists,autoCull,group,CustomClass,adjustY){if(exists===undefined){exists=true;}if(autoCull===undefined){autoCull=false;}if(group===undefined){group=this.game.world;}if(CustomClass===undefined){CustomClass=Phaser.Sprite;}if(adjustY===undefined){adjustY=true;}if(!this.objects[name]){console.warn('Tilemap.createFromObjects: Invalid objectgroup name given: '+name);return;}for(var i=0;i<this.objects[name].length;i++){var found=false;var obj=this.objects[name][i];if(obj.gid!==undefined&&typeof gid==='number'&&obj.gid===gid){found=true;}else if(obj.id!==undefined&&typeof gid==='number'&&obj.id===gid){found=true;}else if(obj.name!==undefined&&typeof gid==='string'&&obj.name===gid){found=true;}if(found){var sprite=new CustomClass(this.game,parseFloat(obj.x,10),parseFloat(obj.y,10),key,frame);sprite.name=obj.name;sprite.visible=obj.visible;sprite.autoCull=autoCull;sprite.exists=exists;if(obj.width){sprite.width=obj.width;}if(obj.height){sprite.height=obj.height;}if(obj.rotation){sprite.angle=obj.rotation;}if(adjustY){sprite.y-=sprite.height;}group.add(sprite);for(var property in obj.properties){group.set(sprite,property,obj.properties[property],false,false,0,true);}}}},/**
	    * Creates a Sprite for every object matching the given tile indexes in the map data.
	    * You can specify the group that the Sprite will be created in. If none is given it will be created in the World.
	    * You can optional specify if the tile will be replaced with another after the Sprite is created. This is useful if you want to lay down special 
	    * tiles in a level that are converted to Sprites, but want to replace the tile itself with a floor tile or similar once converted.
	    *
	    * @method Phaser.Tilemap#createFromTiles
	    * @param {integer|Array} tiles - The tile index, or array of indexes, to create Sprites from.
	    * @param {integer|Array} replacements - The tile index, or array of indexes, to change a converted tile to. Set to `null` to not change.
	    * @param {string} key - The Game.cache key of the image that this Sprite will use.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to operate on.
	    * @param {Phaser.Group} [group=Phaser.World] - Group to add the Sprite to. If not specified it will be added to the World group.
	    * @param {object} [properties] - An object that contains the default properties for your newly created Sprite. This object will be iterated and any matching Sprite property will be set.
	    * @return {integer} The number of Sprites that were created.
	    */createFromTiles:function createFromTiles(tiles,replacements,key,layer,group,properties){if(typeof tiles==='number'){tiles=[tiles];}if(replacements===undefined||replacements===null){replacements=[];}else if(typeof replacements==='number'){replacements=[replacements];}layer=this.getLayer(layer);if(group===undefined){group=this.game.world;}if(properties===undefined){properties={};}if(properties.customClass===undefined){properties.customClass=Phaser.Sprite;}if(properties.adjustY===undefined){properties.adjustY=true;}var lw=this.layers[layer].width;var lh=this.layers[layer].height;this.copy(0,0,lw,lh,layer);if(this._results.length<2){return 0;}var total=0;var sprite;for(var i=1,len=this._results.length;i<len;i++){if(tiles.indexOf(this._results[i].index)!==-1){sprite=new properties.customClass(this.game,this._results[i].worldX,this._results[i].worldY,key);for(var property in properties){sprite[property]=properties[property];}group.add(sprite);total++;}}if(replacements.length===1){//  Assume 1 replacement for all types of tile given
	for(i=0;i<tiles.length;i++){this.replace(tiles[i],replacements[0],0,0,lw,lh,layer);}}else if(replacements.length>1){//  Assume 1 for 1 mapping
	for(i=0;i<tiles.length;i++){this.replace(tiles[i],replacements[i],0,0,lw,lh,layer);}}return total;},/**
	    * Creates a new TilemapLayer object. By default TilemapLayers are fixed to the camera.
	    * The `layer` parameter is important. If you've created your map in Tiled then you can get this by looking in Tiled and looking at the Layer name.
	    * Or you can open the JSON file it exports and look at the layers[].name value. Either way it must match.
	    * If you wish to create a blank layer to put your own tiles on then see Tilemap.createBlankLayer.
	    *
	    * @method Phaser.Tilemap#createLayer
	    * @param {number|string} layer - The layer array index value, or if a string is given the layer name, within the map data that this TilemapLayer represents.
	    * @param {number} [width] - The rendered width of the layer, should never be wider than Game.width. If not given it will be set to Game.width.
	    * @param {number} [height] - The rendered height of the layer, should never be wider than Game.height. If not given it will be set to Game.height.
	    * @param {Phaser.Group} [group] - Optional Group to add the object to. If not specified it will be added to the World group.
	    * @return {Phaser.TilemapLayer} The TilemapLayer object. This is an extension of Phaser.Sprite and can be moved around the display list accordingly.
	    */createLayer:function createLayer(layer,width,height,group){//  Add Buffer support for the left of the canvas
	if(width===undefined){width=this.game.width;}if(height===undefined){height=this.game.height;}if(group===undefined){group=this.game.world;}var index=layer;if(typeof layer==='string'){index=this.getLayerIndex(layer);}if(index===null||index>this.layers.length){console.warn('Tilemap.createLayer: Invalid layer ID given: '+index);return;}//  Sort out the display dimensions, so they never render too much, or too little.
	if(width===undefined||width<=0){width=Math.min(this.game.width,this.layers[index].widthInPixels);}else if(width>this.game.width){width=this.game.width;}if(height===undefined||height<=0){height=Math.min(this.game.height,this.layers[index].heightInPixels);}else if(height>this.game.height){height=this.game.height;}if(this.enableDebug){console.group('Tilemap.createLayer');console.log('Name:',this.layers[index].name);console.log('Size:',width,'x',height);console.log('Tileset:',this.tilesets[0].name,'index:',index);}var rootLayer=group.add(new Phaser.TilemapLayer(this.game,this,index,width,height));if(this.enableDebug){console.groupEnd();}return rootLayer;},/**
	    * Creates a new and empty layer on this Tilemap. By default TilemapLayers are fixed to the camera.
	    *
	    * @method Phaser.Tilemap#createBlankLayer
	    * @param {string} name - The name of this layer. Must be unique within the map.
	    * @param {number} width - The width of the layer in tiles.
	    * @param {number} height - The height of the layer in tiles.
	    * @param {number} tileWidth - The width of the tiles the layer uses for calculations.
	    * @param {number} tileHeight - The height of the tiles the layer uses for calculations.
	    * @param {Phaser.Group} [group] - Optional Group to add the layer to. If not specified it will be added to the World group.
	    * @return {Phaser.TilemapLayer} The TilemapLayer object. This is an extension of Phaser.Image and can be moved around the display list accordingly.
	    */createBlankLayer:function createBlankLayer(name,width,height,tileWidth,tileHeight,group){if(group===undefined){group=this.game.world;}if(this.getLayerIndex(name)!==null){console.warn('Tilemap.createBlankLayer: Layer with matching name already exists: '+name);return;}var layer={name:name,x:0,y:0,width:width,height:height,widthInPixels:width*tileWidth,heightInPixels:height*tileHeight,alpha:1,visible:true,properties:{},indexes:[],callbacks:[],bodies:[],data:null};var row;var output=[];for(var y=0;y<height;y++){row=[];for(var x=0;x<width;x++){row.push(new Phaser.Tile(layer,-1,x,y,tileWidth,tileHeight));}output.push(row);}layer.data=output;this.layers.push(layer);this.currentLayer=this.layers.length-1;var w=layer.widthInPixels;var h=layer.heightInPixels;if(w>this.game.width){w=this.game.width;}if(h>this.game.height){h=this.game.height;}var output=new Phaser.TilemapLayer(this.game,this,this.layers.length-1,w,h);output.name=name;return group.add(output);},/**
	    * Gets the layer index based on the layers name.
	    *
	    * @method Phaser.Tilemap#getIndex
	    * @protected
	    * @param {array} location - The local array to search.
	    * @param {string} name - The name of the array element to get.
	    * @return {number} The index of the element in the array, or null if not found.
	    */getIndex:function getIndex(location,name){for(var i=0;i<location.length;i++){if(location[i].name===name){return i;}}return null;},/**
	    * Gets the layer index based on its name.
	    *
	    * @method Phaser.Tilemap#getLayerIndex
	    * @param {string} name - The name of the layer to get.
	    * @return {number} The index of the layer in this tilemap, or null if not found.
	    */getLayerIndex:function getLayerIndex(name){return this.getIndex(this.layers,name);},/**
	    * Gets the tileset index based on its name.
	    *
	    * @method Phaser.Tilemap#getTilesetIndex
	    * @param {string} name - The name of the tileset to get.
	    * @return {number} The index of the tileset in this tilemap, or null if not found.
	    */getTilesetIndex:function getTilesetIndex(name){return this.getIndex(this.tilesets,name);},/**
	    * Gets the image index based on its name.
	    *
	    * @method Phaser.Tilemap#getImageIndex
	    * @param {string} name - The name of the image to get.
	    * @return {number} The index of the image in this tilemap, or null if not found.
	    */getImageIndex:function getImageIndex(name){return this.getIndex(this.images,name);},/**
	    * Sets a global collision callback for the given tile index within the layer. This will affect all tiles on this layer that have the same index.
	    * If a callback is already set for the tile index it will be replaced. Set the callback to null to remove it.
	    * If you want to set a callback for a tile at a specific location on the map then see setTileLocationCallback.
	    *
	    * @method Phaser.Tilemap#setTileIndexCallback
	    * @param {number|array} indexes - Either a single tile index, or an array of tile indexes to have a collision callback set for.
	    * @param {function} callback - The callback that will be invoked when the tile is collided with.
	    * @param {object} callbackContext - The context under which the callback is called.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to operate on. If not given will default to this.currentLayer.
	    */setTileIndexCallback:function setTileIndexCallback(indexes,callback,callbackContext,layer){layer=this.getLayer(layer);if(typeof indexes==='number'){//  This may seem a bit wasteful, because it will cause empty array elements to be created, but the look-up cost is much
	//  less than having to iterate through the callbacks array hunting down tile indexes each frame, so I'll take the small memory hit.
	this.layers[layer].callbacks[indexes]={callback:callback,callbackContext:callbackContext};}else{for(var i=0,len=indexes.length;i<len;i++){this.layers[layer].callbacks[indexes[i]]={callback:callback,callbackContext:callbackContext};}}},/**
	    * Sets a global collision callback for the given map location within the layer. This will affect all tiles on this layer found in the given area.
	    * If a callback is already set for the tile index it will be replaced. Set the callback to null to remove it.
	    * If you want to set a callback for a tile at a specific location on the map then see setTileLocationCallback.
	    *
	    * @method Phaser.Tilemap#setTileLocationCallback
	    * @param {number} x - X position of the top left of the area to copy (given in tiles, not pixels)
	    * @param {number} y - Y position of the top left of the area to copy (given in tiles, not pixels)
	    * @param {number} width - The width of the area to copy (given in tiles, not pixels)
	    * @param {number} height - The height of the area to copy (given in tiles, not pixels)
	    * @param {function} callback - The callback that will be invoked when the tile is collided with.
	    * @param {object} callbackContext - The context under which the callback is called.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to operate on. If not given will default to this.currentLayer.
	    */setTileLocationCallback:function setTileLocationCallback(x,y,width,height,callback,callbackContext,layer){layer=this.getLayer(layer);this.copy(x,y,width,height,layer);if(this._results.length<2){return;}for(var i=1;i<this._results.length;i++){this._results[i].setCollisionCallback(callback,callbackContext);}},/**
	    * Sets collision the given tile or tiles. You can pass in either a single numeric index or an array of indexes: [ 2, 3, 15, 20].
	    * The `collides` parameter controls if collision will be enabled (true) or disabled (false).
	    *
	    * @method Phaser.Tilemap#setCollision
	    * @param {number|array} indexes - Either a single tile index, or an array of tile IDs to be checked for collision.
	    * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear collision.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to operate on. If not given will default to this.currentLayer.
	    * @param {boolean} [recalculate=true] - Recalculates the tile faces after the update.
	    */setCollision:function setCollision(indexes,collides,layer,recalculate){if(collides===undefined){collides=true;}if(recalculate===undefined){recalculate=true;}layer=this.getLayer(layer);if(typeof indexes==='number'){return this.setCollisionByIndex(indexes,collides,layer,true);}else if(Array.isArray(indexes)){//  Collide all of the IDs given in the indexes array
	for(var i=0;i<indexes.length;i++){this.setCollisionByIndex(indexes[i],collides,layer,false);}if(recalculate){//  Now re-calculate interesting faces
	this.calculateFaces(layer);}}},/**
	    * Sets collision on a range of tiles where the tile IDs increment sequentially.
	    * Calling this with a start value of 10 and a stop value of 14 would set collision for tiles 10, 11, 12, 13 and 14.
	    * The `collides` parameter controls if collision will be enabled (true) or disabled (false).
	    *
	    * @method Phaser.Tilemap#setCollisionBetween
	    * @param {number} start - The first index of the tile to be set for collision.
	    * @param {number} stop - The last index of the tile to be set for collision.
	    * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear collision.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to operate on. If not given will default to this.currentLayer.
	    * @param {boolean} [recalculate=true] - Recalculates the tile faces after the update.
	    */setCollisionBetween:function setCollisionBetween(start,stop,collides,layer,recalculate){if(collides===undefined){collides=true;}if(recalculate===undefined){recalculate=true;}layer=this.getLayer(layer);if(start>stop){return;}for(var index=start;index<=stop;index++){this.setCollisionByIndex(index,collides,layer,false);}if(recalculate){//  Now re-calculate interesting faces
	this.calculateFaces(layer);}},/**
	    * Sets collision on all tiles in the given layer, except for the IDs of those in the given array.
	    * The `collides` parameter controls if collision will be enabled (true) or disabled (false).
	    *
	    * @method Phaser.Tilemap#setCollisionByExclusion
	    * @param {array} indexes - An array of the tile IDs to not be counted for collision.
	    * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear collision.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to operate on. If not given will default to this.currentLayer.
	    * @param {boolean} [recalculate=true] - Recalculates the tile faces after the update.
	    */setCollisionByExclusion:function setCollisionByExclusion(indexes,collides,layer,recalculate){if(collides===undefined){collides=true;}if(recalculate===undefined){recalculate=true;}layer=this.getLayer(layer);//  Collide everything, except the IDs given in the indexes array
	for(var i=0,len=this.tiles.length;i<len;i++){if(indexes.indexOf(i)===-1){this.setCollisionByIndex(i,collides,layer,false);}}if(recalculate){//  Now re-calculate interesting faces
	this.calculateFaces(layer);}},/**
	    * Sets collision values on a tile in the set.
	    * You shouldn't usually call this method directly, instead use setCollision, setCollisionBetween or setCollisionByExclusion.
	    *
	    * @method Phaser.Tilemap#setCollisionByIndex
	    * @protected
	    * @param {number} index - The index of the tile on the layer.
	    * @param {boolean} [collides=true] - If true it will enable collision on the tile. If false it will clear collision values from the tile.
	    * @param {number} [layer] - The layer to operate on. If not given will default to this.currentLayer.
	    * @param {boolean} [recalculate=true] - Recalculates the tile faces after the update.
	    */setCollisionByIndex:function setCollisionByIndex(index,collides,layer,recalculate){if(collides===undefined){collides=true;}if(layer===undefined){layer=this.currentLayer;}if(recalculate===undefined){recalculate=true;}if(collides){this.collideIndexes.push(index);}else{var i=this.collideIndexes.indexOf(index);if(i>-1){this.collideIndexes.splice(i,1);}}for(var y=0;y<this.layers[layer].height;y++){for(var x=0;x<this.layers[layer].width;x++){var tile=this.layers[layer].data[y][x];if(tile&&tile.index===index){if(collides){tile.setCollision(true,true,true,true);}else{tile.resetCollision();}tile.faceTop=collides;tile.faceBottom=collides;tile.faceLeft=collides;tile.faceRight=collides;}}}if(recalculate){//  Now re-calculate interesting faces
	this.calculateFaces(layer);}return layer;},/**
	    * Gets the TilemapLayer index as used in the setCollision calls.
	    *
	    * @method Phaser.Tilemap#getLayer
	    * @protected
	    * @param {number|string|Phaser.TilemapLayer} layer - The layer to operate on. If not given will default to this.currentLayer.
	    * @return {number} The TilemapLayer index.
	    */getLayer:function getLayer(layer){if(layer===undefined){layer=this.currentLayer;}else if(typeof layer==='string'){layer=this.getLayerIndex(layer);}else if(layer instanceof Phaser.TilemapLayer){layer=layer.index;}return layer;},/**
	    * Turn off/on the recalculation of faces for tile or collision updates. 
	    * `setPreventRecalculate(true)` puts recalculation on hold while `setPreventRecalculate(false)` recalculates all the changed layers.
	    *
	    * @method Phaser.Tilemap#setPreventRecalculate
	    * @param {boolean} value - If true it will put the recalculation on hold.
	    */setPreventRecalculate:function setPreventRecalculate(value){if(value===true&&this.preventingRecalculate!==true){this.preventingRecalculate=true;this.needToRecalculate={};}if(value===false&&this.preventingRecalculate===true){this.preventingRecalculate=false;for(var i in this.needToRecalculate){this.calculateFaces(i);}this.needToRecalculate=false;}},/**
	    * Internal function.
	    *
	    * @method Phaser.Tilemap#calculateFaces
	    * @protected
	    * @param {number} layer - The index of the TilemapLayer to operate on.
	    */calculateFaces:function calculateFaces(layer){if(this.preventingRecalculate){this.needToRecalculate[layer]=true;return;}var above=null;var below=null;var left=null;var right=null;for(var y=0,h=this.layers[layer].height;y<h;y++){for(var x=0,w=this.layers[layer].width;x<w;x++){var tile=this.layers[layer].data[y][x];if(tile){above=this.getTileAbove(layer,x,y);below=this.getTileBelow(layer,x,y);left=this.getTileLeft(layer,x,y);right=this.getTileRight(layer,x,y);if(tile.collides){tile.faceTop=true;tile.faceBottom=true;tile.faceLeft=true;tile.faceRight=true;}if(above&&above.collides){//  There is a tile above this one that also collides, so the top of this tile is no longer interesting
	tile.faceTop=false;}if(below&&below.collides){//  There is a tile below this one that also collides, so the bottom of this tile is no longer interesting
	tile.faceBottom=false;}if(left&&left.collides){//  There is a tile left this one that also collides, so the left of this tile is no longer interesting
	tile.faceLeft=false;}if(right&&right.collides){//  There is a tile right this one that also collides, so the right of this tile is no longer interesting
	tile.faceRight=false;}}}}},/**
	    * Gets the tile above the tile coordinates given.
	    * Mostly used as an internal function by calculateFaces.
	    *
	    * @method Phaser.Tilemap#getTileAbove
	    * @param {number} layer - The local layer index to get the tile from. Can be determined by Tilemap.getLayer().
	    * @param {number} x - The x coordinate to get the tile from. In tiles, not pixels.
	    * @param {number} y - The y coordinate to get the tile from. In tiles, not pixels.
	    */getTileAbove:function getTileAbove(layer,x,y){if(y>0){return this.layers[layer].data[y-1][x];}return null;},/**
	    * Gets the tile below the tile coordinates given.
	    * Mostly used as an internal function by calculateFaces.
	    *
	    * @method Phaser.Tilemap#getTileBelow
	    * @param {number} layer - The local layer index to get the tile from. Can be determined by Tilemap.getLayer().
	    * @param {number} x - The x coordinate to get the tile from. In tiles, not pixels.
	    * @param {number} y - The y coordinate to get the tile from. In tiles, not pixels.
	    */getTileBelow:function getTileBelow(layer,x,y){if(y<this.layers[layer].height-1){return this.layers[layer].data[y+1][x];}return null;},/**
	    * Gets the tile to the left of the tile coordinates given.
	    * Mostly used as an internal function by calculateFaces.
	    *
	    * @method Phaser.Tilemap#getTileLeft
	    * @param {number} layer - The local layer index to get the tile from. Can be determined by Tilemap.getLayer().
	    * @param {number} x - The x coordinate to get the tile from. In tiles, not pixels.
	    * @param {number} y - The y coordinate to get the tile from. In tiles, not pixels.
	    */getTileLeft:function getTileLeft(layer,x,y){if(x>0){return this.layers[layer].data[y][x-1];}return null;},/**
	    * Gets the tile to the right of the tile coordinates given.
	    * Mostly used as an internal function by calculateFaces.
	    *
	    * @method Phaser.Tilemap#getTileRight
	    * @param {number} layer - The local layer index to get the tile from. Can be determined by Tilemap.getLayer().
	    * @param {number} x - The x coordinate to get the tile from. In tiles, not pixels.
	    * @param {number} y - The y coordinate to get the tile from. In tiles, not pixels.
	    */getTileRight:function getTileRight(layer,x,y){if(x<this.layers[layer].width-1){return this.layers[layer].data[y][x+1];}return null;},/**
	    * Sets the current layer to the given index.
	    *
	    * @method Phaser.Tilemap#setLayer
	    * @param {number|string|Phaser.TilemapLayer} layer - The layer to set as current.
	    */setLayer:function setLayer(layer){layer=this.getLayer(layer);if(this.layers[layer]){this.currentLayer=layer;}},/**
	    * Checks if there is a tile at the given location.
	    *
	    * @method Phaser.Tilemap#hasTile
	    * @param {number} x - X position to check if a tile exists at (given in tile units, not pixels)
	    * @param {number} y - Y position to check if a tile exists at (given in tile units, not pixels)
	    * @param {number|string|Phaser.TilemapLayer} layer - The layer to set as current.
	    * @return {boolean} True if there is a tile at the given location, otherwise false.
	    */hasTile:function hasTile(x,y,layer){layer=this.getLayer(layer);if(this.layers[layer].data[y]===undefined||this.layers[layer].data[y][x]===undefined){return false;}return this.layers[layer].data[y][x].index>-1;},/**
	    * Removes the tile located at the given coordinates and updates the collision data.
	    *
	    * @method Phaser.Tilemap#removeTile
	    * @param {number} x - X position to place the tile (given in tile units, not pixels)
	    * @param {number} y - Y position to place the tile (given in tile units, not pixels)
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to modify.
	    * @return {Phaser.Tile} The Tile object that was removed from this map.
	    */removeTile:function removeTile(x,y,layer){layer=this.getLayer(layer);if(x>=0&&x<this.layers[layer].width&&y>=0&&y<this.layers[layer].height){if(this.hasTile(x,y,layer)){var tile=this.layers[layer].data[y][x];this.layers[layer].data[y][x]=new Phaser.Tile(this.layers[layer],-1,x,y,this.tileWidth,this.tileHeight);this.layers[layer].dirty=true;this.calculateFaces(layer);return tile;}}},/**
	    * Removes the tile located at the given coordinates and updates the collision data. The coordinates are given in pixel values.
	    *
	    * @method Phaser.Tilemap#removeTileWorldXY
	    * @param {number} x - X position to insert the tile (given in pixels)
	    * @param {number} y - Y position to insert the tile (given in pixels)
	    * @param {number} tileWidth - The width of the tile in pixels.
	    * @param {number} tileHeight - The height of the tile in pixels.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to modify.
	    * @return {Phaser.Tile} The Tile object that was removed from this map.
	    */removeTileWorldXY:function removeTileWorldXY(x,y,tileWidth,tileHeight,layer){layer=this.getLayer(layer);x=this.game.math.snapToFloor(x,tileWidth)/tileWidth;y=this.game.math.snapToFloor(y,tileHeight)/tileHeight;return this.removeTile(x,y,layer);},/**
	    * Puts a tile of the given index value at the coordinate specified.
	    * If you pass `null` as the tile it will pass your call over to Tilemap.removeTile instead.
	    *
	    * @method Phaser.Tilemap#putTile
	    * @param {Phaser.Tile|number|null} tile - The index of this tile to set or a Phaser.Tile object. If null the tile is removed from the map.
	    * @param {number} x - X position to place the tile (given in tile units, not pixels)
	    * @param {number} y - Y position to place the tile (given in tile units, not pixels)
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to modify.
	    * @return {Phaser.Tile} The Tile object that was created or added to this map.
	    */putTile:function putTile(tile,x,y,layer){if(tile===null){return this.removeTile(x,y,layer);}layer=this.getLayer(layer);if(x>=0&&x<this.layers[layer].width&&y>=0&&y<this.layers[layer].height){var index;if(tile instanceof Phaser.Tile){index=tile.index;if(this.hasTile(x,y,layer)){this.layers[layer].data[y][x].copy(tile);}else{this.layers[layer].data[y][x]=new Phaser.Tile(layer,index,x,y,tile.width,tile.height);}}else{index=tile;if(this.hasTile(x,y,layer)){this.layers[layer].data[y][x].index=index;}else{this.layers[layer].data[y][x]=new Phaser.Tile(this.layers[layer],index,x,y,this.tileWidth,this.tileHeight);}}if(this.collideIndexes.indexOf(index)>-1){this.layers[layer].data[y][x].setCollision(true,true,true,true);}else{this.layers[layer].data[y][x].resetCollision();}this.layers[layer].dirty=true;this.calculateFaces(layer);return this.layers[layer].data[y][x];}return null;},/**
	    * Puts a tile into the Tilemap layer. The coordinates are given in pixel values.
	    *
	    * @method Phaser.Tilemap#putTileWorldXY
	    * @param {Phaser.Tile|number} tile - The index of this tile to set or a Phaser.Tile object.
	    * @param {number} x - X position to insert the tile (given in pixels)
	    * @param {number} y - Y position to insert the tile (given in pixels)
	    * @param {number} tileWidth - The width of the tile in pixels.
	    * @param {number} tileHeight - The height of the tile in pixels.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to modify.
	    * @return {Phaser.Tile} The Tile object that was created or added to this map.
	    */putTileWorldXY:function putTileWorldXY(tile,x,y,tileWidth,tileHeight,layer){layer=this.getLayer(layer);x=this.game.math.snapToFloor(x,tileWidth)/tileWidth;y=this.game.math.snapToFloor(y,tileHeight)/tileHeight;return this.putTile(tile,x,y,layer);},/**
	    * Searches the entire map layer for the first tile matching the given index, then returns that Phaser.Tile object.
	    * If no match is found it returns null.
	    * The search starts from the top-left tile and continues horizontally until it hits the end of the row, then it drops down to the next column.
	    * If the reverse boolean is true, it scans starting from the bottom-right corner traveling up to the top-left.
	    *
	    * @method Phaser.Tilemap#searchTileIndex
	    * @param {number} index - The tile index value to search for.
	    * @param {number} [skip=0] - The number of times to skip a matching tile before returning.
	    * @param {number} [reverse=false] - If true it will scan the layer in reverse, starting at the bottom-right. Otherwise it scans from the top-left.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to get the tile from.
	    * @return {Phaser.Tile} The first (or n skipped) tile with the matching index.
	    */searchTileIndex:function searchTileIndex(index,skip,reverse,layer){if(skip===undefined){skip=0;}if(reverse===undefined){reverse=false;}layer=this.getLayer(layer);var c=0;if(reverse){for(var y=this.layers[layer].height-1;y>=0;y--){for(var x=this.layers[layer].width-1;x>=0;x--){if(this.layers[layer].data[y][x].index===index){if(c===skip){return this.layers[layer].data[y][x];}else{c++;}}}}}else{for(var y=0;y<this.layers[layer].height;y++){for(var x=0;x<this.layers[layer].width;x++){if(this.layers[layer].data[y][x].index===index){if(c===skip){return this.layers[layer].data[y][x];}else{c++;}}}}}return null;},/**
	    * Gets a tile from the Tilemap Layer. The coordinates are given in tile values.
	    *
	    * @method Phaser.Tilemap#getTile
	    * @param {number} x - X position to get the tile from (given in tile units, not pixels)
	    * @param {number} y - Y position to get the tile from (given in tile units, not pixels)
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to get the tile from.
	    * @param {boolean} [nonNull=false] - If true getTile won't return null for empty tiles, but a Tile object with an index of -1.
	    * @return {Phaser.Tile} The tile at the given coordinates or null if no tile was found or the coordinates were invalid.
	    */getTile:function getTile(x,y,layer,nonNull){if(nonNull===undefined){nonNull=false;}layer=this.getLayer(layer);if(x>=0&&x<this.layers[layer].width&&y>=0&&y<this.layers[layer].height){if(this.layers[layer].data[y][x].index===-1){if(nonNull){return this.layers[layer].data[y][x];}else{return null;}}else{return this.layers[layer].data[y][x];}}else{return null;}},/**
	    * Gets a tile from the Tilemap layer. The coordinates are given in pixel values.
	    *
	    * @method Phaser.Tilemap#getTileWorldXY
	    * @param {number} x - X position to get the tile from (given in pixels)
	    * @param {number} y - Y position to get the tile from (given in pixels)
	    * @param {number} [tileWidth] - The width of the tiles. If not given the map default is used.
	    * @param {number} [tileHeight] - The height of the tiles. If not given the map default is used.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to get the tile from.
	    * @param {boolean} [nonNull=false] - If true getTile won't return null for empty tiles, but a Tile object with an index of -1.
	    * @return {Phaser.Tile} The tile at the given coordinates.
	    */getTileWorldXY:function getTileWorldXY(x,y,tileWidth,tileHeight,layer,nonNull){if(tileWidth===undefined){tileWidth=this.tileWidth;}if(tileHeight===undefined){tileHeight=this.tileHeight;}layer=this.getLayer(layer);x=this.game.math.snapToFloor(x,tileWidth)/tileWidth;y=this.game.math.snapToFloor(y,tileHeight)/tileHeight;return this.getTile(x,y,layer,nonNull);},/**
	    * Copies all of the tiles in the given rectangular block into the tilemap data buffer.
	    *
	    * @method Phaser.Tilemap#copy
	    * @param {integer} x - X position of the top left of the area to copy (given in tiles, not pixels)
	    * @param {integer} y - Y position of the top left of the area to copy (given in tiles, not pixels)
	    * @param {integer} width - The width of the area to copy (given in tiles, not pixels)
	    * @param {integer} height - The height of the area to copy (given in tiles, not pixels)
	    * @param {integer|string|Phaser.TilemapLayer} [layer] - The layer to copy the tiles from.
	    * @return {array} An array of the tiles that were copied.
	    */copy:function copy(x,y,width,height,layer){layer=this.getLayer(layer);if(!this.layers[layer]){this._results.length=0;return;}if(x===undefined){x=0;}if(y===undefined){y=0;}if(width===undefined){width=this.layers[layer].width;}if(height===undefined){height=this.layers[layer].height;}if(x<0){x=0;}if(y<0){y=0;}if(width>this.layers[layer].width){width=this.layers[layer].width;}if(height>this.layers[layer].height){height=this.layers[layer].height;}this._results.length=0;this._results.push({x:x,y:y,width:width,height:height,layer:layer});for(var ty=y;ty<y+height;ty++){for(var tx=x;tx<x+width;tx++){this._results.push(this.layers[layer].data[ty][tx]);}}return this._results;},/**
	    * Pastes a previously copied block of tile data into the given x/y coordinates. Data should have been prepared with Tilemap.copy.
	    *
	    * @method Phaser.Tilemap#paste
	    * @param {number} x - X position of the top left of the area to paste to (given in tiles, not pixels)
	    * @param {number} y - Y position of the top left of the area to paste to (given in tiles, not pixels)
	    * @param {array} tileblock - The block of tiles to paste.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to paste the tiles into.
	    */paste:function paste(x,y,tileblock,layer){if(x===undefined){x=0;}if(y===undefined){y=0;}layer=this.getLayer(layer);if(!tileblock||tileblock.length<2){return;}//  Find out the difference between tileblock[1].x/y and x/y and use it as an offset, as it's the top left of the block to paste
	var diffX=x-tileblock[1].x;var diffY=y-tileblock[1].y;for(var i=1;i<tileblock.length;i++){this.layers[layer].data[diffY+tileblock[i].y][diffX+tileblock[i].x].copy(tileblock[i]);}this.layers[layer].dirty=true;this.calculateFaces(layer);},/**
	    * Scans the given area for tiles with an index matching tileA and swaps them with tileB.
	    *
	    * @method Phaser.Tilemap#swap
	    * @param {number} tileA - First tile index.
	    * @param {number} tileB - Second tile index.
	    * @param {number} x - X position of the top left of the area to operate one, given in tiles, not pixels.
	    * @param {number} y - Y position of the top left of the area to operate one, given in tiles, not pixels.
	    * @param {number} width - The width in tiles of the area to operate on.
	    * @param {number} height - The height in tiles of the area to operate on.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to operate on.
	    */swap:function swap(tileA,tileB,x,y,width,height,layer){layer=this.getLayer(layer);this.copy(x,y,width,height,layer);if(this._results.length<2){return;}this._tempA=tileA;this._tempB=tileB;this._results.forEach(this.swapHandler,this);this.paste(x,y,this._results,layer);},/**
	    * Internal function that handles the swapping of tiles.
	    *
	    * @method Phaser.Tilemap#swapHandler
	    * @private
	    * @param {number} value
	    */swapHandler:function swapHandler(value){if(value.index===this._tempA){//  Swap A with B
	value.index=this._tempB;}else if(value.index===this._tempB){//  Swap B with A
	value.index=this._tempA;}},/**
	    * For each tile in the given area defined by x/y and width/height run the given callback.
	    *
	    * @method Phaser.Tilemap#forEach
	    * @param {number} callback - The callback. Each tile in the given area will be passed to this callback as the first and only parameter.
	    * @param {number} context - The context under which the callback should be run.
	    * @param {number} x - X position of the top left of the area to operate one, given in tiles, not pixels.
	    * @param {number} y - Y position of the top left of the area to operate one, given in tiles, not pixels.
	    * @param {number} width - The width in tiles of the area to operate on.
	    * @param {number} height - The height in tiles of the area to operate on.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to operate on.
	    */forEach:function forEach(callback,context,x,y,width,height,layer){layer=this.getLayer(layer);this.copy(x,y,width,height,layer);if(this._results.length<2){return;}this._results.forEach(callback,context);this.paste(x,y,this._results,layer);},/**
	    * Scans the given area for tiles with an index matching `source` and updates their index to match `dest`.
	    *
	    * @method Phaser.Tilemap#replace
	    * @param {number} source - The tile index value to scan for.
	    * @param {number} dest - The tile index value to replace found tiles with.
	    * @param {number} x - X position of the top left of the area to operate one, given in tiles, not pixels.
	    * @param {number} y - Y position of the top left of the area to operate one, given in tiles, not pixels.
	    * @param {number} width - The width in tiles of the area to operate on.
	    * @param {number} height - The height in tiles of the area to operate on.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to operate on.
	    */replace:function replace(source,dest,x,y,width,height,layer){layer=this.getLayer(layer);this.copy(x,y,width,height,layer);if(this._results.length<2){return;}for(var i=1;i<this._results.length;i++){if(this._results[i].index===source){this._results[i].index=dest;}}this.paste(x,y,this._results,layer);},/**
	    * Randomises a set of tiles in a given area.
	    *
	    * @method Phaser.Tilemap#random
	    * @param {number} x - X position of the top left of the area to operate one, given in tiles, not pixels.
	    * @param {number} y - Y position of the top left of the area to operate one, given in tiles, not pixels.
	    * @param {number} width - The width in tiles of the area to operate on.
	    * @param {number} height - The height in tiles of the area to operate on.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to operate on.
	    */random:function random(x,y,width,height,layer){layer=this.getLayer(layer);this.copy(x,y,width,height,layer);if(this._results.length<2){return;}var indexes=[];for(var t=1;t<this._results.length;t++){if(this._results[t].index){var idx=this._results[t].index;if(indexes.indexOf(idx)===-1){indexes.push(idx);}}}for(var i=1;i<this._results.length;i++){this._results[i].index=this.game.rnd.pick(indexes);}this.paste(x,y,this._results,layer);},/**
	    * Shuffles a set of tiles in a given area. It will only randomise the tiles in that area, so if they're all the same nothing will appear to have changed!
	    *
	    * @method Phaser.Tilemap#shuffle
	    * @param {number} x - X position of the top left of the area to operate one, given in tiles, not pixels.
	    * @param {number} y - Y position of the top left of the area to operate one, given in tiles, not pixels.
	    * @param {number} width - The width in tiles of the area to operate on.
	    * @param {number} height - The height in tiles of the area to operate on.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to operate on.
	    */shuffle:function shuffle(x,y,width,height,layer){layer=this.getLayer(layer);this.copy(x,y,width,height,layer);if(this._results.length<2){return;}var indexes=[];for(var t=1;t<this._results.length;t++){if(this._results[t].index){indexes.push(this._results[t].index);}}Phaser.ArrayUtils.shuffle(indexes);for(var i=1;i<this._results.length;i++){this._results[i].index=indexes[i-1];}this.paste(x,y,this._results,layer);},/**
	    * Fills the given area with the specified tile.
	    *
	    * @method Phaser.Tilemap#fill
	    * @param {number} index - The index of the tile that the area will be filled with.
	    * @param {number} x - X position of the top left of the area to operate one, given in tiles, not pixels.
	    * @param {number} y - Y position of the top left of the area to operate one, given in tiles, not pixels.
	    * @param {number} width - The width in tiles of the area to operate on.
	    * @param {number} height - The height in tiles of the area to operate on.
	    * @param {number|string|Phaser.TilemapLayer} [layer] - The layer to operate on.
	    */fill:function fill(index,x,y,width,height,layer){layer=this.getLayer(layer);this.copy(x,y,width,height,layer);if(this._results.length<2){return;}for(var i=1;i<this._results.length;i++){this._results[i].index=index;}this.paste(x,y,this._results,layer);},/**
	    * Removes all layers from this tile map.
	    *
	    * @method Phaser.Tilemap#removeAllLayers
	    */removeAllLayers:function removeAllLayers(){this.layers.length=0;this.currentLayer=0;},/**
	    * Dumps the tilemap data out to the console.
	    *
	    * @method Phaser.Tilemap#dump
	    */dump:function dump(){var txt='';var args=[''];for(var y=0;y<this.layers[this.currentLayer].height;y++){for(var x=0;x<this.layers[this.currentLayer].width;x++){txt+="%c  ";if(this.layers[this.currentLayer].data[y][x]>1){if(this.debugMap[this.layers[this.currentLayer].data[y][x]]){args.push("background: "+this.debugMap[this.layers[this.currentLayer].data[y][x]]);}else{args.push("background: #ffffff");}}else{args.push("background: rgb(0, 0, 0)");}}txt+="\n";}args[0]=txt;console.log.apply(console,args);},/**
	    * Removes all layer data from this tile map and nulls the game reference.
	    * Note: You are responsible for destroying any TilemapLayer objects you generated yourself, as Tilemap doesn't keep a reference to them.
	    *
	    * @method Phaser.Tilemap#destroy
	    */destroy:function destroy(){this.removeAllLayers();this.data=[];this.game=null;}};Phaser.Tilemap.prototype.constructor=Phaser.Tilemap;/**
	* @name Phaser.Tilemap#layer
	* @property {number|string|Phaser.TilemapLayer} layer - The current layer object.
	*/Object.defineProperty(Phaser.Tilemap.prototype,"layer",{get:function get(){return this.layers[this.currentLayer];},set:function set(value){if(value!==this.currentLayer){this.setLayer(value);}}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A TilemapLayer is a Phaser.Image/Sprite that renders a specific TileLayer of a Tilemap.
	*
	* Since a TilemapLayer is a Sprite it can be moved around the display, added to other groups or display objects, etc.
	*
	* By default TilemapLayers have fixedToCamera set to `true`. Changing this will break Camera follow and scrolling behavior.
	*
	* @class Phaser.TilemapLayer
	* @extends Phaser.Sprite
	* @constructor
	* @param {Phaser.Game} game - Game reference to the currently running game.
	* @param {Phaser.Tilemap} tilemap - The tilemap to which this layer belongs.
	* @param {integer} index - The index of the TileLayer to render within the Tilemap.
	* @param {integer} width - Width of the renderable area of the layer (in pixels).
	* @param {integer} height - Height of the renderable area of the layer (in pixels).
	*/Phaser.TilemapLayer=function(game,tilemap,index,width,height){width|=0;height|=0;Phaser.Sprite.call(this,game,0,0);/**
	    * The Tilemap to which this layer is bound.
	    * @property {Phaser.Tilemap} map
	    * @protected
	    * @readonly
	    */this.map=tilemap;/**
	    * The index of this layer within the Tilemap.
	    * @property {number} index
	    * @protected
	    * @readonly
	    */this.index=index;/**
	    * The layer object within the Tilemap that this layer represents.
	    * @property {object} layer
	    * @protected
	    * @readonly
	    */this.layer=tilemap.layers[index];/**
	    * The canvas to which this TilemapLayer draws.
	    * @property {HTMLCanvasElement} canvas
	    * @protected
	    */this.canvas=PIXI.CanvasPool.create(this,width,height);/**
	    * The 2d context of the canvas.
	    * @property {CanvasRenderingContext2D} context
	    * @private
	    */this.context=this.canvas.getContext('2d');this.setTexture(new PIXI.Texture(new PIXI.BaseTexture(this.canvas)));/**
	    * The const type of this object.
	    * @property {number} type
	    * @readonly
	    * @protected
	    * @default Phaser.TILEMAPLAYER
	    */this.type=Phaser.TILEMAPLAYER;/**
	    * @property {number} physicsType - The const physics body type of this object.
	    * @readonly
	    */this.physicsType=Phaser.TILEMAPLAYER;/**
	    * Settings that control standard (non-diagnostic) rendering.
	    *
	    * @property {boolean} [enableScrollDelta=true] - Delta scroll rendering only draws tiles/edges as they come into view.
	    *     This can greatly improve scrolling rendering performance, especially when there are many small tiles.
	    *     It should only be disabled in rare cases.
	    *
	    * @property {?DOMCanvasElement} [copyCanvas=(auto)] - [Internal] If set, force using a separate (shared) copy canvas.
	    *     Using a canvas bitblt/copy when the source and destinations region overlap produces unexpected behavior
	    *     in some browsers, notably Safari. 
	    *
	    * @default
	    */this.renderSettings={enableScrollDelta:false,overdrawRatio:0.20,copyCanvas:null};/**
	    * Enable an additional "debug rendering" pass to display collision information.
	    *
	    * @property {boolean} debug
	    * @default
	    */this.debug=false;/**
	    * @property {boolean} exists - Controls if the core game loop and physics update this game object or not.
	    */this.exists=true;/**
	    * Settings used for debugging and diagnostics.
	    *
	    * @property {?string} missingImageFill - A tile is rendered as a rectangle using the following fill if a valid tileset/image cannot be found. A value of `null` prevents additional rendering for tiles without a valid tileset image. _This takes effect even when debug rendering for the layer is not enabled._
	    *
	    * @property {?string} debuggedTileOverfill - If a Tile has `Tile#debug` true then, after normal tile image rendering, a rectangle with the following fill is drawn above/over it. _This takes effect even when debug rendering for the layer is not enabled._
	    *
	    * @property {boolean} forceFullRedraw - When debug rendering (`debug` is true), and this option is enabled, the a full redraw is forced and rendering optimization is suppressed.
	    *
	    * @property {number} debugAlpha - When debug rendering (`debug` is true), the tileset is initially rendered with this alpha level. This can make the tile edges clearer.
	    *
	    * @property {?string} facingEdgeStroke - When debug rendering (`debug` is true), this color/stroke is used to draw "face" edges. A value of `null` disables coloring facing edges.
	    *
	    * @property {?string} collidingTileOverfill - When debug rendering (`debug` is true), this fill is used for tiles that are collidable. A value of `null` disables applying the additional overfill.
	    *
	    */this.debugSettings={missingImageFill:'rgb(255,255,255)',debuggedTileOverfill:'rgba(0,255,0,0.4)',forceFullRedraw:true,debugAlpha:0.5,facingEdgeStroke:'rgba(0,255,0,1)',collidingTileOverfill:'rgba(0,255,0,0.2)'};/**
	    * Speed at which this layer scrolls horizontally, relative to the camera (e.g. scrollFactorX of 0.5 scrolls half as quickly as the 'normal' camera-locked layers do).
	    * @property {number} scrollFactorX
	    * @public
	    * @default
	    */this.scrollFactorX=1;/**
	    * Speed at which this layer scrolls vertically, relative to the camera (e.g. scrollFactorY of 0.5 scrolls half as quickly as the 'normal' camera-locked layers do)
	    * @property {number} scrollFactorY
	    * @public
	    * @default
	    */this.scrollFactorY=1;/**
	    * If true tiles will be force rendered, even if such is not believed to be required.
	    * @property {boolean} dirty
	    * @protected
	    */this.dirty=true;/**
	    * When ray-casting against tiles this is the number of steps it will jump. For larger tile sizes you can increase this to improve performance.
	    * @property {integer} rayStepRate
	    * @default
	    */this.rayStepRate=4;/**
	    * Flag controlling if the layer tiles wrap at the edges.
	    * @property {boolean} _wrap
	    * @private
	    */this._wrap=false;/**
	    * Local map data and calculation cache.
	    * @property {object} _mc
	    * @private
	    */this._mc={// Used to bypass rendering without reliance on `dirty` and detect changes.
	scrollX:0,scrollY:0,renderWidth:0,renderHeight:0,tileWidth:tilemap.tileWidth,tileHeight:tilemap.tileHeight,// Collision width/height (pixels)
	// What purpose do these have? Most things use tile width/height directly.
	// This also only extends collisions right and down.       
	cw:tilemap.tileWidth,ch:tilemap.tileHeight,// Cached tilesets from index -> Tileset
	tilesets:[]};/**
	    * The current canvas left after scroll is applied.
	    * @property {number} _scrollX
	    * @private
	    */this._scrollX=0;/**
	    * The current canvas top after scroll is applied.
	    * @propety {number} _scrollY
	    * @private
	    */this._scrollY=0;/**
	    * Used for caching the tiles / array of tiles.
	    * @property {Phaser.Tile[]} _results
	    * @private
	    */this._results=[];if(!game.device.canvasBitBltShift){this.renderSettings.copyCanvas=Phaser.TilemapLayer.ensureSharedCopyCanvas();}this.fixedToCamera=true;};Phaser.TilemapLayer.prototype=Object.create(Phaser.Sprite.prototype);Phaser.TilemapLayer.prototype.constructor=Phaser.TilemapLayer;Phaser.TilemapLayer.prototype.preUpdateCore=Phaser.Component.Core.preUpdate;/**
	* The shared double-copy canvas, created as needed.
	*
	* @private
	* @static
	*/Phaser.TilemapLayer.sharedCopyCanvas=null;/**
	* Create if needed (and return) a shared copy canvas that is shared across all TilemapLayers.
	*
	* Code that uses the canvas is responsible to ensure the dimensions and save/restore state as appropriate.
	*
	* @method Phaser.TilemapLayer#ensureSharedCopyCanvas
	* @protected
	* @static
	*/Phaser.TilemapLayer.ensureSharedCopyCanvas=function(){if(!this.sharedCopyCanvas){this.sharedCopyCanvas=PIXI.CanvasPool.create(this,2,2);}return this.sharedCopyCanvas;};/**
	* Automatically called by World.preUpdate.
	*
	* @method Phaser.TilemapLayer#preUpdate
	*/Phaser.TilemapLayer.prototype.preUpdate=function(){return this.preUpdateCore();};/**
	* Automatically called by World.postUpdate. Handles cache updates.
	*
	* @method Phaser.TilemapLayer#postUpdate
	* @protected
	*/Phaser.TilemapLayer.prototype.postUpdate=function(){if(this.fixedToCamera){this.position.x=(this.game.camera.view.x+this.cameraOffset.x)/this.game.camera.scale.x;this.position.y=(this.game.camera.view.y+this.cameraOffset.y)/this.game.camera.scale.y;}this._scrollX=this.game.camera.view.x*this.scrollFactorX/this.scale.x;this._scrollY=this.game.camera.view.y*this.scrollFactorY/this.scale.y;};/**
	* Automatically called by the Canvas Renderer.
	* Overrides the Sprite._renderCanvas function.
	*
	* @method Phaser.TilemapLayer#_renderCanvas
	* @private
	*/Phaser.TilemapLayer.prototype._renderCanvas=function(renderSession){if(this.fixedToCamera){this.position.x=(this.game.camera.view.x+this.cameraOffset.x)/this.game.camera.scale.x;this.position.y=(this.game.camera.view.y+this.cameraOffset.y)/this.game.camera.scale.y;}this._scrollX=this.game.camera.view.x*this.scrollFactorX/this.scale.x;this._scrollY=this.game.camera.view.y*this.scrollFactorY/this.scale.y;this.render();PIXI.Sprite.prototype._renderCanvas.call(this,renderSession);};/**
	* Automatically called by the Canvas Renderer.
	* Overrides the Sprite._renderWebGL function.
	*
	* @method Phaser.TilemapLayer#_renderWebGL
	* @private
	*/Phaser.TilemapLayer.prototype._renderWebGL=function(renderSession){if(this.fixedToCamera){this.position.x=(this.game.camera.view.x+this.cameraOffset.x)/this.game.camera.scale.x;this.position.y=(this.game.camera.view.y+this.cameraOffset.y)/this.game.camera.scale.y;}this._scrollX=this.game.camera.view.x*this.scrollFactorX/this.scale.x;this._scrollY=this.game.camera.view.y*this.scrollFactorY/this.scale.y;this.render();PIXI.Sprite.prototype._renderWebGL.call(this,renderSession);};/**
	* Destroys this TilemapLayer.
	*
	* @method Phaser.TilemapLayer#destroy
	*/Phaser.TilemapLayer.prototype.destroy=function(){PIXI.CanvasPool.remove(this);Phaser.Component.Destroy.prototype.destroy.call(this);};/**
	* Resizes the internal canvas and texture frame used by this TilemapLayer.
	*
	* This is an expensive call, so don't bind it to a window resize event! But instead call it at carefully
	* selected times.
	*
	* Be aware that no validation of the new sizes takes place and the current map scroll coordinates are not
	* modified either. You will have to handle both of these things from your game code if required.
	* 
	* @method Phaser.TilemapLayer#resize
	* @param {number} width - The new width of the TilemapLayer
	* @param {number} height - The new height of the TilemapLayer
	*/Phaser.TilemapLayer.prototype.resize=function(width,height){this.canvas.width=width;this.canvas.height=height;this.texture.frame.resize(width,height);this.texture.width=width;this.texture.height=height;this.texture.crop.width=width;this.texture.crop.height=height;this.texture.baseTexture.width=width;this.texture.baseTexture.height=height;this.texture.baseTexture.dirty();this.texture.requiresUpdate=true;this.texture._updateUvs();this.dirty=true;};/**
	* Sets the world size to match the size of this layer.
	*
	* @method Phaser.TilemapLayer#resizeWorld
	* @public
	*/Phaser.TilemapLayer.prototype.resizeWorld=function(){this.game.world.setBounds(0,0,this.layer.widthInPixels*this.scale.x,this.layer.heightInPixels*this.scale.y);};/**
	* Take an x coordinate that doesn't account for scrollFactorX and 'fix' it into a scrolled local space.
	*
	* @method Phaser.TilemapLayer#_fixX
	* @private
	* @param {number} x - x coordinate in camera space
	* @return {number} x coordinate in scrollFactor-adjusted dimensions
	*/Phaser.TilemapLayer.prototype._fixX=function(x){if(this.scrollFactorX===1||this.scrollFactorX===0&&this.position.x===0){return x;}//  This executes if the scrollFactorX is 0 and the x position of the tilemap is off from standard.
	if(this.scrollFactorX===0&&this.position.x!==0){return x-this.position.x;}return this._scrollX+(x-this._scrollX/this.scrollFactorX);};/**
	* Take an x coordinate that _does_ account for scrollFactorX and 'unfix' it back to camera space.
	*
	* @method Phaser.TilemapLayer#_unfixX
	* @private
	* @param {number} x - x coordinate in scrollFactor-adjusted dimensions
	* @return {number} x coordinate in camera space
	*/Phaser.TilemapLayer.prototype._unfixX=function(x){if(this.scrollFactorX===1){return x;}return this._scrollX/this.scrollFactorX+(x-this._scrollX);};/**
	* Take a y coordinate that doesn't account for scrollFactorY and 'fix' it into a scrolled local space.
	*
	* @method Phaser.TilemapLayer#_fixY
	* @private
	* @param {number} y - y coordinate in camera space
	* @return {number} y coordinate in scrollFactor-adjusted dimensions
	*/Phaser.TilemapLayer.prototype._fixY=function(y){if(this.scrollFactorY===1||this.scrollFactorY===0&&this.position.y===0){return y;}//  This executes if the scrollFactorY is 0 and the y position of the tilemap is off from standard.
	if(this.scrollFactorY===0&&this.position.y!==0){return y-this.position.y;}return this._scrollY+(y-this._scrollY/this.scrollFactorY);};/**
	* Take a y coordinate that _does_ account for scrollFactorY and 'unfix' it back to camera space.
	*
	* @method Phaser.TilemapLayer#_unfixY
	* @private
	* @param {number} y - y coordinate in scrollFactor-adjusted dimensions
	* @return {number} y coordinate in camera space
	*/Phaser.TilemapLayer.prototype._unfixY=function(y){if(this.scrollFactorY===1){return y;}return this._scrollY/this.scrollFactorY+(y-this._scrollY);};/**
	* Convert a pixel value to a tile coordinate.
	*
	* @method Phaser.TilemapLayer#getTileX
	* @public
	* @param {number} x - X position of the point in target tile (in pixels).
	* @return {integer} The X map location of the tile.
	*/Phaser.TilemapLayer.prototype.getTileX=function(x){// var tileWidth = this.tileWidth * this.scale.x;
	return Math.floor(this._fixX(x)/this._mc.tileWidth);};/**
	* Convert a pixel value to a tile coordinate.
	*
	* @method Phaser.TilemapLayer#getTileY
	* @public
	* @param {number} y - Y position of the point in target tile (in pixels).
	* @return {integer} The Y map location of the tile.
	*/Phaser.TilemapLayer.prototype.getTileY=function(y){// var tileHeight = this.tileHeight * this.scale.y;
	return Math.floor(this._fixY(y)/this._mc.tileHeight);};/**
	* Convert a pixel coordinate to a tile coordinate.
	*
	* @method Phaser.TilemapLayer#getTileXY
	* @public
	* @param {number} x - X position of the point in target tile (in pixels).
	* @param {number} y - Y position of the point in target tile (in pixels).
	* @param {(Phaser.Point|object)} point - The Point/object to update.
	* @return {(Phaser.Point|object)} A Point/object with its `x` and `y` properties set.
	*/Phaser.TilemapLayer.prototype.getTileXY=function(x,y,point){point.x=this.getTileX(x);point.y=this.getTileY(y);return point;};/**
	* Gets all tiles that intersect with the given line.
	*
	* @method Phaser.TilemapLayer#getRayCastTiles
	* @public
	* @param {Phaser.Line} line - The line used to determine which tiles to return.
	* @param {integer} [stepRate=(rayStepRate)] - How many steps through the ray will we check? Defaults to `rayStepRate`.
	* @param {boolean} [collides=false] - If true, _only_ return tiles that collide on one or more faces.
	* @param {boolean} [interestingFace=false] - If true, _only_ return tiles that have interesting faces.
	* @return {Phaser.Tile[]} An array of Phaser.Tiles.
	*/Phaser.TilemapLayer.prototype.getRayCastTiles=function(line,stepRate,collides,interestingFace){if(!stepRate){stepRate=this.rayStepRate;}if(collides===undefined){collides=false;}if(interestingFace===undefined){interestingFace=false;}//  First get all tiles that touch the bounds of the line
	var tiles=this.getTiles(line.x,line.y,line.width,line.height,collides,interestingFace);if(tiles.length===0){return[];}//  Now we only want the tiles that intersect with the points on this line
	var coords=line.coordinatesOnLine(stepRate);var results=[];for(var i=0;i<tiles.length;i++){for(var t=0;t<coords.length;t++){var tile=tiles[i];var coord=coords[t];if(tile.containsPoint(coord[0],coord[1])){results.push(tile);break;}}}return results;};/**
	* Get all tiles that exist within the given area, defined by the top-left corner, width and height. Values given are in pixels, not tiles.
	*
	* @method Phaser.TilemapLayer#getTiles
	* @public
	* @param {number} x - X position of the top left corner (in pixels).
	* @param {number} y - Y position of the top left corner (in pixels).
	* @param {number} width - Width of the area to get (in pixels).
	* @param {number} height - Height of the area to get (in pixels).
	* @param {boolean} [collides=false] - If true, _only_ return tiles that collide on one or more faces.
	* @param {boolean} [interestingFace=false] - If true, _only_ return tiles that have interesting faces.
	* @return {array<Phaser.Tile>} An array of Tiles.
	*/Phaser.TilemapLayer.prototype.getTiles=function(x,y,width,height,collides,interestingFace){//  Should we only get tiles that have at least one of their collision flags set? (true = yes, false = no just get them all)
	if(collides===undefined){collides=false;}if(interestingFace===undefined){interestingFace=false;}var fetchAll=!(collides||interestingFace);//  Adjust the x,y coordinates for scrollFactor
	x=this._fixX(x);y=this._fixY(y);//  Convert the pixel values into tile coordinates
	var tx=Math.floor(x/(this._mc.cw*this.scale.x));var ty=Math.floor(y/(this._mc.ch*this.scale.y));//  Don't just use ceil(width/cw) to allow account for x/y diff within cell
	var tw=Math.ceil((x+width)/(this._mc.cw*this.scale.x))-tx;var th=Math.ceil((y+height)/(this._mc.ch*this.scale.y))-ty;while(this._results.length){this._results.pop();}for(var wy=ty;wy<ty+th;wy++){for(var wx=tx;wx<tx+tw;wx++){var row=this.layer.data[wy];if(row&&row[wx]){if(fetchAll||row[wx].isInteresting(collides,interestingFace)){this._results.push(row[wx]);}}}}return this._results.slice();};/**
	* Returns the appropriate tileset for the index, updating the internal cache as required.
	* This should only be called if `tilesets[index]` evaluates to undefined.
	*
	* @method Phaser.TilemapLayer#resolveTileset
	* @private
	* @param {integer} Tile index
	* @return {Phaser.Tileset|null} Returns the associated tileset or null if there is no such mapping.
	*/Phaser.TilemapLayer.prototype.resolveTileset=function(tileIndex){var tilesets=this._mc.tilesets;//  Try for dense array if reasonable
	if(tileIndex<2000){while(tilesets.length<tileIndex){tilesets.push(undefined);}}var setIndex=this.map.tiles[tileIndex]&&this.map.tiles[tileIndex][2];if(setIndex!==null){var tileset=this.map.tilesets[setIndex];if(tileset&&tileset.containsTileIndex(tileIndex)){return tilesets[tileIndex]=tileset;}}return tilesets[tileIndex]=null;};/**
	* The TilemapLayer caches tileset look-ups.
	*
	* Call this method of clear the cache if tilesets have been added or updated after the layer has been rendered.
	*
	* @method Phaser.TilemapLayer#resetTilesetCache
	* @public
	*/Phaser.TilemapLayer.prototype.resetTilesetCache=function(){var tilesets=this._mc.tilesets;while(tilesets.length){tilesets.pop();}};/**
	 * This method will set the scale of the tilemap as well as update the underlying block data of this layer.
	 * 
	 * @method Phaser.TilemapLayer#setScale
	 * @param {number} [xScale=1] - The scale factor along the X-plane 
	 * @param {number} [yScale] - The scale factor along the Y-plane
	 */Phaser.TilemapLayer.prototype.setScale=function(xScale,yScale){xScale=xScale||1;yScale=yScale||xScale;for(var y=0;y<this.layer.data.length;y++){var row=this.layer.data[y];for(var x=0;x<row.length;x++){var tile=row[x];tile.width=this.map.tileWidth*xScale;tile.height=this.map.tileHeight*yScale;tile.worldX=tile.x*tile.width;tile.worldY=tile.y*tile.height;}}this.scale.setTo(xScale,yScale);};/**
	* Shifts the contents of the canvas - does extra math so that different browsers agree on the result.
	*
	* The specified (x/y) will be shifted to (0,0) after the copy and the newly exposed canvas area will need to be filled in.
	*
	* @method Phaser.TilemapLayer#shiftCanvas
	* @private
	* @param {CanvasRenderingContext2D} context - The context to shift
	* @param {integer} x
	* @param {integer} y
	*/Phaser.TilemapLayer.prototype.shiftCanvas=function(context,x,y){var canvas=context.canvas;var copyW=canvas.width-Math.abs(x);var copyH=canvas.height-Math.abs(y);//  When x/y non-negative
	var dx=0;var dy=0;var sx=x;var sy=y;if(x<0){dx=-x;sx=0;}if(y<0){dy=-y;sy=0;}var copyCanvas=this.renderSettings.copyCanvas;if(copyCanvas){// Use a second copy buffer, without slice support, for Safari .. again.
	// Ensure copy canvas is large enough
	if(copyCanvas.width<copyW||copyCanvas.height<copyH){copyCanvas.width=copyW;copyCanvas.height=copyH;}var copyContext=copyCanvas.getContext('2d');copyContext.clearRect(0,0,copyW,copyH);copyContext.drawImage(canvas,dx,dy,copyW,copyH,0,0,copyW,copyH);// clear allows default 'source-over' semantics
	context.clearRect(sx,sy,copyW,copyH);context.drawImage(copyCanvas,0,0,copyW,copyH,sx,sy,copyW,copyH);}else{// Avoids a second copy but flickers in Safari / Safari Mobile
	// Ref. https://github.com/photonstorm/phaser/issues/1439
	context.save();context.globalCompositeOperation='copy';context.drawImage(canvas,dx,dy,copyW,copyH,sx,sy,copyW,copyH);context.restore();}};/**
	* Render tiles in the given area given by the virtual tile coordinates biased by the given scroll factor.
	* This will constrain the tile coordinates based on wrapping but not physical coordinates.
	*
	* @method Phaser.TilemapLayer#renderRegion
	* @private
	* @param {integer} scrollX - Render x offset/scroll.
	* @param {integer} scrollY - Render y offset/scroll.
	* @param {integer} left - Leftmost column to render.
	* @param {integer} top - Topmost row to render.
	* @param {integer} right - Rightmost column to render.
	* @param {integer} bottom - Bottommost row to render.
	*/Phaser.TilemapLayer.prototype.renderRegion=function(scrollX,scrollY,left,top,right,bottom){var context=this.context;var width=this.layer.width;var height=this.layer.height;var tw=this._mc.tileWidth;var th=this._mc.tileHeight;var tilesets=this._mc.tilesets;var lastAlpha=NaN;if(!this._wrap){if(left<=right)// Only adjust if going to render
	{left=Math.max(0,left);right=Math.min(width-1,right);}if(top<=bottom){top=Math.max(0,top);bottom=Math.min(height-1,bottom);}}// top-left pixel of top-left cell
	var baseX=left*tw-scrollX;var baseY=top*th-scrollY;// Fix normStartX/normStartY such it is normalized [0..width/height). This allows a simple conditional and decrement to always keep in range [0..width/height) during the loop. The major offset bias is to take care of negative values.
	var normStartX=(left+(1<<20)*width)%width;var normStartY=(top+(1<<20)*height)%height;// tx/ty - are pixel coordinates where tile is drawn
	// x/y - is cell location, normalized [0..width/height) in loop
	// xmax/ymax - remaining cells to render on column/row
	var tx,ty,x,y,xmax,ymax;for(y=normStartY,ymax=bottom-top,ty=baseY;ymax>=0;y++,ymax--,ty+=th){if(y>=height){y-=height;}var row=this.layer.data[y];for(x=normStartX,xmax=right-left,tx=baseX;xmax>=0;x++,xmax--,tx+=tw){if(x>=width){x-=width;}var tile=row[x];if(!tile||tile.index<0){continue;}var index=tile.index;var set=tilesets[index];if(set===undefined){set=this.resolveTileset(index);}//  Setting the globalAlpha is "surprisingly expensive" in Chrome (38)
	if(tile.alpha!==lastAlpha&&!this.debug){context.globalAlpha=tile.alpha;lastAlpha=tile.alpha;}if(set){if(tile.rotation||tile.flipped){context.save();context.translate(tx+tile.centerX,ty+tile.centerY);context.rotate(tile.rotation);if(tile.flipped){context.scale(-1,1);}set.draw(context,-tile.centerX,-tile.centerY,index);context.restore();}else{set.draw(context,tx,ty,index);}}else if(this.debugSettings.missingImageFill){context.fillStyle=this.debugSettings.missingImageFill;context.fillRect(tx,ty,tw,th);}if(tile.debug&&this.debugSettings.debuggedTileOverfill){context.fillStyle=this.debugSettings.debuggedTileOverfill;context.fillRect(tx,ty,tw,th);}}}};/**
	* Shifts the canvas and render damaged edge tiles.
	*
	* @method Phaser.TilemapLayer#renderDeltaScroll
	* @private
	*/Phaser.TilemapLayer.prototype.renderDeltaScroll=function(shiftX,shiftY){var scrollX=this._mc.scrollX;var scrollY=this._mc.scrollY;var renderW=this.canvas.width;var renderH=this.canvas.height;var tw=this._mc.tileWidth;var th=this._mc.tileHeight;// Only cells with coordinates in the "plus" formed by `left <= x <= right` OR `top <= y <= bottom` are drawn. These coordinates may be outside the layer bounds.
	// Start in pixels
	var left=0;var right=-tw;var top=0;var bottom=-th;if(shiftX<0)// layer moving left, damage right
	{left=renderW+shiftX;// shiftX neg.
	right=renderW-1;}else if(shiftX>0){// left -> 0
	right=shiftX;}if(shiftY<0)// layer moving down, damage top
	{top=renderH+shiftY;// shiftY neg.
	bottom=renderH-1;}else if(shiftY>0){// top -> 0
	bottom=shiftY;}this.shiftCanvas(this.context,shiftX,shiftY);// Transform into tile-space
	left=Math.floor((left+scrollX)/tw);right=Math.floor((right+scrollX)/tw);top=Math.floor((top+scrollY)/th);bottom=Math.floor((bottom+scrollY)/th);if(left<=right){// Clear left or right edge
	this.context.clearRect(left*tw-scrollX,0,(right-left+1)*tw,renderH);var trueTop=Math.floor((0+scrollY)/th);var trueBottom=Math.floor((renderH-1+scrollY)/th);this.renderRegion(scrollX,scrollY,left,trueTop,right,trueBottom);}if(top<=bottom){// Clear top or bottom edge
	this.context.clearRect(0,top*th-scrollY,renderW,(bottom-top+1)*th);var trueLeft=Math.floor((0+scrollX)/tw);var trueRight=Math.floor((renderW-1+scrollX)/tw);this.renderRegion(scrollX,scrollY,trueLeft,top,trueRight,bottom);}};/**
	* Clear and render the entire canvas.
	*
	* @method Phaser.TilemapLayer#renderFull
	* @private
	*/Phaser.TilemapLayer.prototype.renderFull=function(){var scrollX=this._mc.scrollX;var scrollY=this._mc.scrollY;var renderW=this.canvas.width;var renderH=this.canvas.height;var tw=this._mc.tileWidth;var th=this._mc.tileHeight;var left=Math.floor(scrollX/tw);var right=Math.floor((renderW-1+scrollX)/tw);var top=Math.floor(scrollY/th);var bottom=Math.floor((renderH-1+scrollY)/th);this.context.clearRect(0,0,renderW,renderH);this.renderRegion(scrollX,scrollY,left,top,right,bottom);};/**
	* Renders the tiles to the layer canvas and pushes to the display.
	*
	* @method Phaser.TilemapLayer#render
	* @protected
	*/Phaser.TilemapLayer.prototype.render=function(){var redrawAll=false;if(!this.visible){return;}if(this.dirty||this.layer.dirty){this.layer.dirty=false;redrawAll=true;}var renderWidth=this.canvas.width;// Use Sprite.width/height?
	var renderHeight=this.canvas.height;//  Scrolling bias; whole pixels only
	var scrollX=this._scrollX|0;var scrollY=this._scrollY|0;var mc=this._mc;var shiftX=mc.scrollX-scrollX;// Negative when scrolling right/down
	var shiftY=mc.scrollY-scrollY;if(!redrawAll&&shiftX===0&&shiftY===0&&mc.renderWidth===renderWidth&&mc.renderHeight===renderHeight){//  No reason to redraw map, looking at same thing and not invalidated.
	return;}this.context.save();mc.scrollX=scrollX;mc.scrollY=scrollY;if(mc.renderWidth!==renderWidth||mc.renderHeight!==renderHeight){//  Could support automatic canvas resizing
	mc.renderWidth=renderWidth;mc.renderHeight=renderHeight;}if(this.debug){this.context.globalAlpha=this.debugSettings.debugAlpha;if(this.debugSettings.forceFullRedraw){redrawAll=true;}}if(!redrawAll&&this.renderSettings.enableScrollDelta&&Math.abs(shiftX)+Math.abs(shiftY)<Math.min(renderWidth,renderHeight)){this.renderDeltaScroll(shiftX,shiftY);}else{// Too much change or otherwise requires full render
	this.renderFull();}if(this.debug){this.context.globalAlpha=1;this.renderDebug();}this.texture.baseTexture.dirty();this.dirty=false;this.context.restore();return true;};/**
	* Renders a debug overlay on-top of the canvas. Called automatically by render when `debug` is true.
	*
	* See `debugSettings` for assorted configuration options.
	*
	* @method Phaser.TilemapLayer#renderDebug
	* @private
	*/Phaser.TilemapLayer.prototype.renderDebug=function(){var scrollX=this._mc.scrollX;var scrollY=this._mc.scrollY;var context=this.context;var renderW=this.canvas.width;var renderH=this.canvas.height;var width=this.layer.width;var height=this.layer.height;var tw=this._mc.tileWidth;var th=this._mc.tileHeight;var left=Math.floor(scrollX/tw);var right=Math.floor((renderW-1+scrollX)/tw);var top=Math.floor(scrollY/th);var bottom=Math.floor((renderH-1+scrollY)/th);var baseX=left*tw-scrollX;var baseY=top*th-scrollY;var normStartX=(left+(1<<20)*width)%width;var normStartY=(top+(1<<20)*height)%height;var tx,ty,x,y,xmax,ymax;context.strokeStyle=this.debugSettings.facingEdgeStroke;for(y=normStartY,ymax=bottom-top,ty=baseY;ymax>=0;y++,ymax--,ty+=th){if(y>=height){y-=height;}var row=this.layer.data[y];for(x=normStartX,xmax=right-left,tx=baseX;xmax>=0;x++,xmax--,tx+=tw){if(x>=width){x-=width;}var tile=row[x];if(!tile||tile.index<0||!tile.collides){continue;}if(this.debugSettings.collidingTileOverfill){context.fillStyle=this.debugSettings.collidingTileOverfill;context.fillRect(tx,ty,this._mc.cw,this._mc.ch);}if(this.debugSettings.facingEdgeStroke){context.beginPath();if(tile.faceTop){context.moveTo(tx,ty);context.lineTo(tx+this._mc.cw,ty);}if(tile.faceBottom){context.moveTo(tx,ty+this._mc.ch);context.lineTo(tx+this._mc.cw,ty+this._mc.ch);}if(tile.faceLeft){context.moveTo(tx,ty);context.lineTo(tx,ty+this._mc.ch);}if(tile.faceRight){context.moveTo(tx+this._mc.cw,ty);context.lineTo(tx+this._mc.cw,ty+this._mc.ch);}context.closePath();context.stroke();}}}};/**
	* Flag controlling if the layer tiles wrap at the edges. Only works if the World size matches the Map size.
	*
	* @property {boolean} wrap
	* @memberof Phaser.TilemapLayer
	* @public
	* @default false
	*/Object.defineProperty(Phaser.TilemapLayer.prototype,"wrap",{get:function get(){return this._wrap;},set:function set(value){this._wrap=value;this.dirty=true;}});/**
	* Scrolls the map horizontally or returns the current x position.
	*
	* @property {number} scrollX
	* @memberof Phaser.TilemapLayer
	* @public
	*/Object.defineProperty(Phaser.TilemapLayer.prototype,"scrollX",{get:function get(){return this._scrollX;},set:function set(value){this._scrollX=value;}});/**
	* Scrolls the map vertically or returns the current y position.
	*
	* @property {number} scrollY
	* @memberof Phaser.TilemapLayer
	* @public
	*/Object.defineProperty(Phaser.TilemapLayer.prototype,"scrollY",{get:function get(){return this._scrollY;},set:function set(value){this._scrollY=value;}});/**
	* The width of the collision tiles (in pixels).
	*
	* @property {integer} collisionWidth
	* @memberof Phaser.TilemapLayer
	* @public
	*/Object.defineProperty(Phaser.TilemapLayer.prototype,"collisionWidth",{get:function get(){return this._mc.cw;},set:function set(value){this._mc.cw=value|0;this.dirty=true;}});/**
	* The height of the collision tiles (in pixels).
	*
	* @property {integer} collisionHeight
	* @memberof Phaser.TilemapLayer
	* @public
	*/Object.defineProperty(Phaser.TilemapLayer.prototype,"collisionHeight",{get:function get(){return this._mc.ch;},set:function set(value){this._mc.ch=value|0;this.dirty=true;}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Phaser.TilemapParser parses data objects from Phaser.Loader that need more preparation before they can be inserted into a Tilemap.
	*
	* @class Phaser.TilemapParser
	* @static
	*/Phaser.TilemapParser={/**
	     * When scanning the Tiled map data the TilemapParser can either insert a null value (true) or
	     * a Phaser.Tile instance with an index of -1 (false, the default). Depending on your game type
	     * depends how this should be configured. If you've a large sparsely populated map and the tile
	     * data doesn't need to change then setting this value to `true` will help with memory consumption.
	     * However if your map is small, or you need to update the tiles (perhaps the map dynamically changes
	     * during the game) then leave the default value set.
	     *
	     * @constant
	     * @type {boolean}
	     */INSERT_NULL:false,/**
	    * Parse tilemap data from the cache and creates data for a Tilemap object.
	    *
	    * @method Phaser.TilemapParser.parse
	    * @param {Phaser.Game} game - Game reference to the currently running game.
	    * @param {string} key - The key of the tilemap in the Cache.
	    * @param {number} [tileWidth=32] - The pixel width of a single map tile. If using CSV data you must specify this. Not required if using Tiled map data.
	    * @param {number} [tileHeight=32] - The pixel height of a single map tile. If using CSV data you must specify this. Not required if using Tiled map data.
	    * @param {number} [width=10] - The width of the map in tiles. If this map is created from Tiled or CSV data you don't need to specify this.
	    * @param {number} [height=10] - The height of the map in tiles. If this map is created from Tiled or CSV data you don't need to specify this.
	    * @return {object} The parsed map object.
	    */parse:function parse(game,key,tileWidth,tileHeight,width,height){if(tileWidth===undefined){tileWidth=32;}if(tileHeight===undefined){tileHeight=32;}if(width===undefined){width=10;}if(height===undefined){height=10;}if(key===undefined){return this.getEmptyData();}if(key===null){return this.getEmptyData(tileWidth,tileHeight,width,height);}var map=game.cache.getTilemapData(key);if(map){if(map.format===Phaser.Tilemap.CSV){return this.parseCSV(key,map.data,tileWidth,tileHeight);}else if(!map.format||map.format===Phaser.Tilemap.TILED_JSON){return this.parseTiledJSON(map.data);}}else{console.warn('Phaser.TilemapParser.parse - No map data found for key '+key);}},/**
	    * Parses a CSV file into valid map data.
	    *
	    * @method Phaser.TilemapParser.parseCSV
	    * @param {string} key - The name you want to give the map data.
	    * @param {string} data - The CSV file data.
	    * @param {number} [tileWidth=32] - The pixel width of a single map tile. If using CSV data you must specify this. Not required if using Tiled map data.
	    * @param {number} [tileHeight=32] - The pixel height of a single map tile. If using CSV data you must specify this. Not required if using Tiled map data.
	    * @return {object} Generated map data.
	    */parseCSV:function parseCSV(key,data,tileWidth,tileHeight){var map=this.getEmptyData();//  Trim any rogue whitespace from the data
	data=data.trim();var output=[];var rows=data.split("\n");var height=rows.length;var width=0;for(var y=0;y<rows.length;y++){output[y]=[];var column=rows[y].split(",");for(var x=0;x<column.length;x++){output[y][x]=new Phaser.Tile(map.layers[0],parseInt(column[x],10),x,y,tileWidth,tileHeight);}if(width===0){width=column.length;}}map.format=Phaser.Tilemap.CSV;map.name=key;map.width=width;map.height=height;map.tileWidth=tileWidth;map.tileHeight=tileHeight;map.widthInPixels=width*tileWidth;map.heightInPixels=height*tileHeight;map.layers[0].width=width;map.layers[0].height=height;map.layers[0].widthInPixels=map.widthInPixels;map.layers[0].heightInPixels=map.heightInPixels;map.layers[0].data=output;return map;},/**
	    * Returns an empty map data object.
	    *
	    * @method Phaser.TilemapParser.getEmptyData
	    * @return {object} Generated map data.
	    */getEmptyData:function getEmptyData(tileWidth,tileHeight,width,height){return{width:width!==undefined&&width!==null?width:0,height:height!==undefined&&height!==null?height:0,tileWidth:tileWidth!==undefined&&tileWidth!==null?tileWidth:0,tileHeight:tileHeight!==undefined&&tileHeight!==null?tileHeight:0,orientation:'orthogonal',version:'1',properties:{},widthInPixels:0,heightInPixels:0,layers:[{name:'layer',x:0,y:0,width:0,height:0,widthInPixels:0,heightInPixels:0,alpha:1,visible:true,properties:{},indexes:[],callbacks:[],bodies:[],data:[]}],images:[],objects:{},collision:{},tilesets:[],tiles:[]};},/**
	    * Parses a Tiled JSON file into valid map data.
	    * @method Phaser.TilemapParser.parseJSON
	    * @param {object} json - The JSON map data.
	    * @return {object} Generated and parsed map data.
	    */parseTiledJSON:function parseTiledJSON(json){if(json.orientation!=='orthogonal'){console.warn('TilemapParser.parseTiledJSON - Only orthogonal map types are supported in this version of Phaser');return null;}//  Map data will consist of: layers, objects, images, tilesets, sizes
	var map={width:json.width,height:json.height,tileWidth:json.tilewidth,tileHeight:json.tileheight,orientation:json.orientation,format:Phaser.Tilemap.TILED_JSON,version:json.version,properties:json.properties,widthInPixels:json.width*json.tilewidth,heightInPixels:json.height*json.tileheight};//  Tile Layers
	var layers=[];for(var i=0;i<json.layers.length;i++){if(json.layers[i].type!=='tilelayer'){continue;}var curl=json.layers[i];// Base64 decode data if necessary
	// NOTE: uncompressed base64 only.
	if(!curl.compression&&curl.encoding&&curl.encoding==='base64'){var binaryString=window.atob(curl.data);var len=binaryString.length;var bytes=new Array(len);// Interpret binaryString as an array of bytes representing
	// little-endian encoded uint32 values.
	for(var j=0;j<len;j+=4){bytes[j/4]=(binaryString.charCodeAt(j)|binaryString.charCodeAt(j+1)<<8|binaryString.charCodeAt(j+2)<<16|binaryString.charCodeAt(j+3)<<24)>>>0;}curl.data=bytes;delete curl.encoding;}else if(curl.compression){console.warn('TilemapParser.parseTiledJSON - Layer compression is unsupported, skipping layer \''+curl.name+'\'');continue;}var layer={name:curl.name,x:curl.x,y:curl.y,width:curl.width,height:curl.height,widthInPixels:curl.width*json.tilewidth,heightInPixels:curl.height*json.tileheight,alpha:curl.opacity,visible:curl.visible,properties:{},indexes:[],callbacks:[],bodies:[]};if(curl.properties){layer.properties=curl.properties;}var x=0;var row=[];var output=[];var rotation,flipped,flippedVal,gid;//  Loop through the data field in the JSON.
	//  This is an array containing the tile indexes, one after the other. -1 = no tile, everything else = the tile index (starting at 1 for Tiled, 0 for CSV)
	//  If the map contains multiple tilesets then the indexes are relative to that which the set starts from.
	//  Need to set which tileset in the cache = which tileset in the JSON, if you do this manually it means you can use the same map data but a new tileset.
	for(var t=0,len=curl.data.length;t<len;t++){rotation=0;flipped=false;gid=curl.data[t];flippedVal=0;//  If true the current tile is flipped or rotated (Tiled TMX format)
	if(gid>0x20000000){// FlippedX
	if(gid>0x80000000){gid-=0x80000000;flippedVal+=4;}// FlippedY
	if(gid>0x40000000){gid-=0x40000000;flippedVal+=2;}// FlippedAD (anti-diagonal = top-right is swapped with bottom-left corners)
	if(gid>0x20000000){gid-=0x20000000;flippedVal+=1;}switch(flippedVal){case 5:rotation=Math.PI/2;break;case 6:rotation=Math.PI;break;case 3:rotation=3*Math.PI/2;break;case 4:rotation=0;flipped=true;break;case 7:rotation=Math.PI/2;flipped=true;break;case 2:rotation=Math.PI;flipped=true;break;case 1:rotation=3*Math.PI/2;flipped=true;break;}}//  index, x, y, width, height
	if(gid>0){var tile=new Phaser.Tile(layer,gid,x,output.length,json.tilewidth,json.tileheight);tile.rotation=rotation;tile.flipped=flipped;if(flippedVal!==0){//  The WebGL renderer uses this to flip UV coordinates before drawing
	tile.flippedVal=flippedVal;}row.push(tile);}else{if(Phaser.TilemapParser.INSERT_NULL){row.push(null);}else{row.push(new Phaser.Tile(layer,-1,x,output.length,json.tilewidth,json.tileheight));}}x++;if(x===curl.width){output.push(row);x=0;row=[];}}layer.data=output;layers.push(layer);}map.layers=layers;//  Images
	var images=[];for(var i=0;i<json.layers.length;i++){if(json.layers[i].type!=='imagelayer'){continue;}var curi=json.layers[i];var image={name:curi.name,image:curi.image,x:curi.x,y:curi.y,alpha:curi.opacity,visible:curi.visible,properties:{}};if(curi.properties){image.properties=curi.properties;}images.push(image);}map.images=images;//  Tilesets & Image Collections
	var tilesets=[];var imagecollections=[];var lastSet=null;for(var i=0;i<json.tilesets.length;i++){//  name, firstgid, width, height, margin, spacing, properties
	var set=json.tilesets[i];if(set.image){var newSet=new Phaser.Tileset(set.name,set.firstgid,set.tilewidth,set.tileheight,set.margin,set.spacing,set.properties);if(set.tileproperties){newSet.tileProperties=set.tileproperties;}// For a normal sliced tileset the row/count/size information is computed when updated.
	// This is done (again) after the image is set.
	newSet.updateTileData(set.imagewidth,set.imageheight);tilesets.push(newSet);}else{var newCollection=new Phaser.ImageCollection(set.name,set.firstgid,set.tilewidth,set.tileheight,set.margin,set.spacing,set.properties);for(var ti in set.tiles){var image=set.tiles[ti].image;var gid=set.firstgid+parseInt(ti,10);newCollection.addImage(gid,image);}imagecollections.push(newCollection);}//  We've got a new Tileset, so set the lastgid into the previous one
	if(lastSet){lastSet.lastgid=set.firstgid-1;}lastSet=set;}map.tilesets=tilesets;map.imagecollections=imagecollections;//  Objects & Collision Data (polylines, etc)
	var objects={};var collision={};function slice(obj,fields){var sliced={};for(var k in fields){var key=fields[k];if(typeof obj[key]!=='undefined'){sliced[key]=obj[key];}}return sliced;}for(var i=0;i<json.layers.length;i++){if(json.layers[i].type!=='objectgroup'){continue;}var curo=json.layers[i];objects[curo.name]=[];collision[curo.name]=[];for(var v=0,len=curo.objects.length;v<len;v++){//  Object Tiles
	if(curo.objects[v].gid){var object={gid:curo.objects[v].gid,name:curo.objects[v].name,type:curo.objects[v].hasOwnProperty("type")?curo.objects[v].type:"",x:curo.objects[v].x,y:curo.objects[v].y,visible:curo.objects[v].visible,properties:curo.objects[v].properties};if(curo.objects[v].rotation){object.rotation=curo.objects[v].rotation;}objects[curo.name].push(object);}else if(curo.objects[v].polyline){var object={name:curo.objects[v].name,type:curo.objects[v].type,x:curo.objects[v].x,y:curo.objects[v].y,width:curo.objects[v].width,height:curo.objects[v].height,visible:curo.objects[v].visible,properties:curo.objects[v].properties};if(curo.objects[v].rotation){object.rotation=curo.objects[v].rotation;}object.polyline=[];//  Parse the polyline into an array
	for(var p=0;p<curo.objects[v].polyline.length;p++){object.polyline.push([curo.objects[v].polyline[p].x,curo.objects[v].polyline[p].y]);}collision[curo.name].push(object);objects[curo.name].push(object);}// polygon
	else if(curo.objects[v].polygon){var object=slice(curo.objects[v],['name','type','x','y','visible','rotation','properties']);//  Parse the polygon into an array
	object.polygon=[];for(var p=0;p<curo.objects[v].polygon.length;p++){object.polygon.push([curo.objects[v].polygon[p].x,curo.objects[v].polygon[p].y]);}objects[curo.name].push(object);}// ellipse
	else if(curo.objects[v].ellipse){var object=slice(curo.objects[v],['name','type','ellipse','x','y','width','height','visible','rotation','properties']);objects[curo.name].push(object);}// otherwise it's a rectangle
	else{var object=slice(curo.objects[v],['name','type','x','y','width','height','visible','rotation','properties']);object.rectangle=true;objects[curo.name].push(object);}}}map.objects=objects;map.collision=collision;map.tiles=[];//  Finally lets build our super tileset index
	for(var i=0;i<map.tilesets.length;i++){var set=map.tilesets[i];var x=set.tileMargin;var y=set.tileMargin;var count=0;var countX=0;var countY=0;for(var t=set.firstgid;t<set.firstgid+set.total;t++){//  Can add extra properties here as needed
	map.tiles[t]=[x,y,i];x+=set.tileWidth+set.tileSpacing;count++;if(count===set.total){break;}countX++;if(countX===set.columns){x=set.tileMargin;y+=set.tileHeight+set.tileSpacing;countX=0;countY++;if(countY===set.rows){break;}}}}// assign tile properties
	var layer;var tile;var sid;var set;// go through each of the map data layers
	for(var i=0;i<map.layers.length;i++){layer=map.layers[i];set=null;// rows of tiles
	for(var j=0;j<layer.data.length;j++){row=layer.data[j];// individual tiles
	for(var k=0;k<row.length;k++){tile=row[k];if(tile===null||tile.index<0){continue;}// find the relevant tileset
	sid=map.tiles[tile.index][2];set=map.tilesets[sid];// if that tile type has any properties, add them to the tile object
	if(set.tileProperties&&set.tileProperties[tile.index-set.firstgid]){tile.properties=Phaser.Utils.mixin(set.tileProperties[tile.index-set.firstgid],tile.properties);}}}}return map;}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A Tile set is a combination of an image containing the tiles and collision data per tile.
	*
	* Tilesets are normally created automatically when Tiled data is loaded.
	*
	* @class Phaser.Tileset
	* @constructor
	* @param {string} name - The name of the tileset in the map data.
	* @param {integer} firstgid - The first tile index this tileset contains.
	* @param {integer} [width=32] - Width of each tile (in pixels).
	* @param {integer} [height=32] - Height of each tile (in pixels).
	* @param {integer} [margin=0] - The margin around all tiles in the sheet (in pixels).
	* @param {integer} [spacing=0] - The spacing between each tile in the sheet (in pixels).
	* @param {object} [properties={}] - Custom Tileset properties.
	*/Phaser.Tileset=function(name,firstgid,width,height,margin,spacing,properties){if(width===undefined||width<=0){width=32;}if(height===undefined||height<=0){height=32;}if(margin===undefined){margin=0;}if(spacing===undefined){spacing=0;}/**
	    * The name of the Tileset.
	    * @property {string} name
	    */this.name=name;/**
	    * The Tiled firstgid value.
	    * This is the starting index of the first tile index this Tileset contains.
	    * @property {integer} firstgid
	    */this.firstgid=firstgid|0;/**
	    * The width of each tile (in pixels).
	    * @property {integer} tileWidth
	    * @readonly
	    */this.tileWidth=width|0;/**
	    * The height of each tile (in pixels).
	    * @property {integer} tileHeight
	    * @readonly
	    */this.tileHeight=height|0;/**
	    * The margin around the tiles in the sheet (in pixels).
	    * Use `setSpacing` to change.
	    * @property {integer} tileMarge
	    * @readonly
	    */// Modified internally
	this.tileMargin=margin|0;/**
	    * The spacing between each tile in the sheet (in pixels).
	    * Use `setSpacing` to change.
	    * @property {integer} tileSpacing
	    * @readonly
	    */this.tileSpacing=spacing|0;/**
	    * Tileset-specific properties that are typically defined in the Tiled editor.
	    * @property {object} properties
	    */this.properties=properties||{};/**
	    * The cached image that contains the individual tiles. Use {@link Phaser.Tileset.setImage setImage} to set.
	    * @property {?object} image
	    * @readonly
	    */// Modified internally
	this.image=null;/**
	    * The number of tile rows in the the tileset.
	    * @property {integer}
	    * @readonly
	    */// Modified internally
	this.rows=0;/**
	    * The number of tile columns in the tileset.
	    * @property {integer} columns
	    * @readonly
	    */// Modified internally
	this.columns=0;/**
	    * The total number of tiles in the tileset.
	    * @property {integer} total
	    * @readonly
	    */// Modified internally
	this.total=0;/**
	    * The look-up table to specific tile image offsets.
	    * The coordinates are interlaced such that it is [x0, y0, x1, y1 .. xN, yN] and the tile with the index of firstgid is found at indices 0/1.
	    * @property {integer[]} drawCoords
	    * @private
	    */this.drawCoords=[];};Phaser.Tileset.prototype={/**
	    * Draws a tile from this Tileset at the given coordinates on the context.
	    *
	    * @method Phaser.Tileset#draw
	    * @public
	    * @param {CanvasRenderingContext2D} context - The context to draw the tile onto.
	    * @param {number} x - The x coordinate to draw to.
	    * @param {number} y - The y coordinate to draw to.
	    * @param {integer} index - The index of the tile within the set to draw.
	    */draw:function draw(context,x,y,index){//  Correct the tile index for the set and bias for interlacing
	var coordIndex=index-this.firstgid<<1;if(coordIndex>=0&&coordIndex+1<this.drawCoords.length){context.drawImage(this.image,this.drawCoords[coordIndex],this.drawCoords[coordIndex+1],this.tileWidth,this.tileHeight,x,y,this.tileWidth,this.tileHeight);}},/**
	    * Returns true if and only if this tileset contains the given tile index.
	    *
	    * @method Phaser.Tileset#containsTileIndex
	    * @public
	    * @return {boolean} True if this tileset contains the given index.
	    */containsTileIndex:function containsTileIndex(tileIndex){return tileIndex>=this.firstgid&&tileIndex<this.firstgid+this.total;},/**
	    * Set the image associated with this Tileset and update the tile data.
	    *
	    * @method Phaser.Tileset#setImage
	    * @public
	    * @param {Image} image - The image that contains the tiles.
	    */setImage:function setImage(image){this.image=image;this.updateTileData(image.width,image.height);},/**
	    * Sets tile spacing and margins.
	    *
	    * @method Phaser.Tileset#setSpacing
	    * @public
	    * @param {integer} [margin=0] - The margin around the tiles in the sheet (in pixels).
	    * @param {integer} [spacing=0] - The spacing between the tiles in the sheet (in pixels).
	    */setSpacing:function setSpacing(margin,spacing){this.tileMargin=margin|0;this.tileSpacing=spacing|0;if(this.image){this.updateTileData(this.image.width,this.image.height);}},/**
	    * Updates tile coordinates and tileset data.
	    *
	    * @method Phaser.Tileset#updateTileData
	    * @private
	    * @param {integer} imageWidth - The (expected) width of the image to slice.
	    * @param {integer} imageHeight - The (expected) height of the image to slice.
	    */updateTileData:function updateTileData(imageWidth,imageHeight){// May be fractional values
	var rowCount=(imageHeight-this.tileMargin*2+this.tileSpacing)/(this.tileHeight+this.tileSpacing);var colCount=(imageWidth-this.tileMargin*2+this.tileSpacing)/(this.tileWidth+this.tileSpacing);if(rowCount%1!==0||colCount%1!==0){console.warn("Phaser.Tileset - "+this.name+" image tile area is not an even multiple of tile size");}// In Tiled a tileset image that is not an even multiple of the tile dimensions
	// is truncated - hence the floor when calculating the rows/columns.
	rowCount=Math.floor(rowCount);colCount=Math.floor(colCount);if(this.rows&&this.rows!==rowCount||this.columns&&this.columns!==colCount){console.warn("Phaser.Tileset - actual and expected number of tile rows and columns differ");}this.rows=rowCount;this.columns=colCount;this.total=rowCount*colCount;this.drawCoords.length=0;var tx=this.tileMargin;var ty=this.tileMargin;for(var y=0;y<this.rows;y++){for(var x=0;x<this.columns;x++){this.drawCoords.push(tx);this.drawCoords.push(ty);tx+=this.tileWidth+this.tileSpacing;}tx=this.tileMargin;ty+=this.tileHeight+this.tileSpacing;}}};Phaser.Tileset.prototype.constructor=Phaser.Tileset;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Create a new `Particle` object. Particles are extended Sprites that are emitted by a particle emitter such as Phaser.Particles.Arcade.Emitter.
	* 
	* @class Phaser.Particle
	* @constructor
	* @extends Phaser.Sprite
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {number} x - The x coordinate (in world space) to position the Particle at.
	* @param {number} y - The y coordinate (in world space) to position the Particle at.
	* @param {string|Phaser.RenderTexture|Phaser.BitmapData|PIXI.Texture} key - This is the image or texture used by the Particle during rendering. It can be a string which is a reference to the Cache entry, or an instance of a RenderTexture or PIXI.Texture.
	* @param {string|number} frame - If this Particle is using part of a sprite sheet or texture atlas you can specify the exact frame to use by giving a string or numeric index.
	*/Phaser.Particle=function(game,x,y,key,frame){Phaser.Sprite.call(this,game,x,y,key,frame);/**
	    * @property {boolean} autoScale - If this Particle automatically scales this is set to true by Particle.setScaleData.
	    * @protected
	    */this.autoScale=false;/**
	    * @property {array} scaleData - A reference to the scaleData array owned by the Emitter that emitted this Particle.
	    * @protected
	    */this.scaleData=null;/**
	    * @property {number} _s - Internal cache var for tracking auto scale.
	    * @private
	    */this._s=0;/**
	    * @property {boolean} autoAlpha - If this Particle automatically changes alpha this is set to true by Particle.setAlphaData.
	    * @protected
	    */this.autoAlpha=false;/**
	    * @property {array} alphaData - A reference to the alphaData array owned by the Emitter that emitted this Particle.
	    * @protected
	    */this.alphaData=null;/**
	    * @property {number} _a - Internal cache var for tracking auto alpha.
	    * @private
	    */this._a=0;};Phaser.Particle.prototype=Object.create(Phaser.Sprite.prototype);Phaser.Particle.prototype.constructor=Phaser.Particle;/**
	* Updates the Particle scale or alpha if autoScale and autoAlpha are set.
	*
	* @method Phaser.Particle#update
	* @memberof Phaser.Particle
	*/Phaser.Particle.prototype.update=function(){if(this.autoScale){this._s--;if(this._s){this.scale.set(this.scaleData[this._s].x,this.scaleData[this._s].y);}else{this.autoScale=false;}}if(this.autoAlpha){this._a--;if(this._a){this.alpha=this.alphaData[this._a].v;}else{this.autoAlpha=false;}}};/**
	* Called by the Emitter when this particle is emitted. Left empty for you to over-ride as required.
	*
	* @method Phaser.Particle#onEmit
	* @memberof Phaser.Particle
	*/Phaser.Particle.prototype.onEmit=function(){};/**
	* Called by the Emitter if autoAlpha has been enabled. Passes over the alpha ease data and resets the alpha counter.
	*
	* @method Phaser.Particle#setAlphaData
	* @memberof Phaser.Particle
	*/Phaser.Particle.prototype.setAlphaData=function(data){this.alphaData=data;this._a=data.length-1;this.alpha=this.alphaData[this._a].v;this.autoAlpha=true;};/**
	* Called by the Emitter if autoScale has been enabled. Passes over the scale ease data and resets the scale counter.
	*
	* @method Phaser.Particle#setScaleData
	* @memberof Phaser.Particle
	*/Phaser.Particle.prototype.setScaleData=function(data){this.scaleData=data;this._s=data.length-1;this.scale.set(this.scaleData[this._s].x,this.scaleData[this._s].y);this.autoScale=true;};/**
	* Resets the Particle. This places the Particle at the given x/y world coordinates and then
	* sets alive, exists, visible and renderable all to true. Also resets the outOfBounds state and health values.
	* If the Particle has a physics body that too is reset.
	*
	* @method Phaser.Particle#reset
	* @memberof Phaser.Particle
	* @param {number} x - The x coordinate (in world space) to position the Particle at.
	* @param {number} y - The y coordinate (in world space) to position the Particle at.
	* @param {number} [health=1] - The health to give the Particle.
	* @return {Phaser.Particle} This instance.
	*/Phaser.Particle.prototype.reset=function(x,y,health){Phaser.Component.Reset.prototype.reset.call(this,x,y,health);this.alpha=1;this.scale.set(1);this.autoScale=false;this.autoAlpha=false;return this;};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Phaser.Particles is the Particle Manager for the game. It is called during the game update loop and in turn updates any Emitters attached to it.
	*
	* @class Phaser.Particles
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	*/Phaser.Particles=function(game){/**
	    * @property {Phaser.Game} game - A reference to the currently running Game.
	    */this.game=game;/**
	    * @property {object} emitters - Internal emitters store.
	    */this.emitters={};/**
	    * @property {number} ID -
	    * @default
	    */this.ID=0;};Phaser.Particles.prototype={/**
	    * Adds a new Particle Emitter to the Particle Manager.
	    * @method Phaser.Particles#add
	    * @param {Phaser.Emitter} emitter - The emitter to be added to the particle manager.
	    * @return {Phaser.Emitter} The emitter that was added.
	    */add:function add(emitter){this.emitters[emitter.name]=emitter;return emitter;},/**
	    * Removes an existing Particle Emitter from the Particle Manager.
	    * @method Phaser.Particles#remove
	    * @param {Phaser.Emitter} emitter - The emitter to remove.
	    */remove:function remove(emitter){delete this.emitters[emitter.name];},/**
	    * Called by the core game loop. Updates all Emitters who have their exists value set to true.
	    * @method Phaser.Particles#update
	    * @protected
	    */update:function update(){for(var key in this.emitters){if(this.emitters[key].exists){this.emitters[key].update();}}}};Phaser.Particles.prototype.constructor=Phaser.Particles;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Arcade Particles is a Particle System integrated with Arcade Physics.
	*
	* @class Phaser.Particles.Arcade
	*/Phaser.Particles.Arcade={};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Emitter is a lightweight particle emitter that uses Arcade Physics.
	* It can be used for one-time explosions or for continuous effects like rain and fire.
	* All it really does is launch Particle objects out at set intervals, and fixes their positions and velocities accordingly.
	* 
	* @class Phaser.Particles.Arcade.Emitter
	* @constructor
	* @extends Phaser.Group
	* @param {Phaser.Game} game - Current game instance.
	* @param {number} [x=0] - The x coordinate within the Emitter that the particles are emitted from.
	* @param {number} [y=0] - The y coordinate within the Emitter that the particles are emitted from.
	* @param {number} [maxParticles=50] - The total number of particles in this emitter.
	*/Phaser.Particles.Arcade.Emitter=function(game,x,y,maxParticles){/**
	    * @property {number} maxParticles - The total number of particles in this emitter.
	    * @default
	    */this.maxParticles=maxParticles||50;Phaser.Group.call(this,game);/**
	    * @property {string} name - A handy string name for this emitter. Can be set to anything.
	    */this.name='emitter'+this.game.particles.ID++;/**
	    * @property {number} type - Internal Phaser Type value.
	    * @protected
	    */this.type=Phaser.EMITTER;/**
	    * @property {number} physicsType - The const physics body type of this object.
	    * @readonly
	    */this.physicsType=Phaser.GROUP;/**
	    * @property {Phaser.Rectangle} area - The area of the emitter. Particles can be randomly generated from anywhere within this rectangle.
	    * @default
	    */this.area=new Phaser.Rectangle(x,y,1,1);/**
	    * @property {Phaser.Point} minParticleSpeed - The minimum possible velocity of a particle.
	    * @default
	    */this.minParticleSpeed=new Phaser.Point(-100,-100);/**
	    * @property {Phaser.Point} maxParticleSpeed - The maximum possible velocity of a particle.
	    * @default
	    */this.maxParticleSpeed=new Phaser.Point(100,100);/**
	    * @property {number} minParticleScale - The minimum possible scale of a particle. This is applied to the X and Y axis. If you need to control each axis see minParticleScaleX.
	    * @default
	    */this.minParticleScale=1;/**
	    * @property {number} maxParticleScale - The maximum possible scale of a particle. This is applied to the X and Y axis. If you need to control each axis see maxParticleScaleX.
	    * @default
	    */this.maxParticleScale=1;/**
	    * @property {array} scaleData - An array of the calculated scale easing data applied to particles with scaleRates > 0.
	    */this.scaleData=null;/**
	    * @property {number} minRotation - The minimum possible angular velocity of a particle.
	    * @default
	    */this.minRotation=-360;/**
	    * @property {number} maxRotation - The maximum possible angular velocity of a particle.
	    * @default
	    */this.maxRotation=360;/**
	    * @property {number} minParticleAlpha - The minimum possible alpha value of a particle.
	    * @default
	    */this.minParticleAlpha=1;/**
	    * @property {number} maxParticleAlpha - The maximum possible alpha value of a particle.
	    * @default
	    */this.maxParticleAlpha=1;/**
	    * @property {array} alphaData - An array of the calculated alpha easing data applied to particles with alphaRates > 0.
	    */this.alphaData=null;/**
	    * @property {number} gravity - Sets the `body.gravity.y` of each particle sprite to this value on launch.
	    * @default
	    */this.gravity=100;/**
	    * @property {any} particleClass - For emitting your own particle class types. They must extend Phaser.Particle.
	    * @default
	    */this.particleClass=Phaser.Particle;/**
	    * @property {Phaser.Point} particleDrag - The X and Y drag component of particles launched from the emitter.
	    */this.particleDrag=new Phaser.Point();/**
	    * @property {number} angularDrag - The angular drag component of particles launched from the emitter if they are rotating.
	    * @default
	    */this.angularDrag=0;/**
	    * @property {number} frequency - How often a particle is emitted in ms (if emitter is started with Explode === false).
	    * @default
	    */this.frequency=100;/**
	    * @property {number} lifespan - How long each particle lives once it is emitted in ms. Default is 2 seconds. Set lifespan to 'zero' for particles to live forever.
	    * @default
	    */this.lifespan=2000;/**
	    * @property {Phaser.Point} bounce - How much each particle should bounce on each axis. 1 = full bounce, 0 = no bounce.
	    */this.bounce=new Phaser.Point();/**
	    * @property {boolean} on - Determines whether the emitter is currently emitting particles. It is totally safe to directly toggle this.
	    * @default
	    */this.on=false;/**
	    * @property {Phaser.Point} particleAnchor - When a particle is created its anchor will be set to match this Point object (defaults to x/y: 0.5 to aid in rotation)
	    * @default
	    */this.particleAnchor=new Phaser.Point(0.5,0.5);/**
	    * @property {number} blendMode - The blendMode as set on the particle when emitted from the Emitter. Defaults to NORMAL. Needs browser capable of supporting canvas blend-modes (most not available in WebGL)
	    * @default
	    */this.blendMode=Phaser.blendModes.NORMAL;/**
	    * The point the particles are emitted from.
	    * Emitter.x and Emitter.y control the containers location, which updates all current particles
	    * Emitter.emitX and Emitter.emitY control the emission location relative to the x/y position.
	    * @property {number} emitX
	    */this.emitX=x;/**
	    * The point the particles are emitted from.
	    * Emitter.x and Emitter.y control the containers location, which updates all current particles
	    * Emitter.emitX and Emitter.emitY control the emission location relative to the x/y position.
	    * @property {number} emitY
	    */this.emitY=y;/**
	    * @property {boolean} autoScale - When a new Particle is emitted this controls if it will automatically scale in size. Use Emitter.setScale to configure.
	    */this.autoScale=false;/**
	    * @property {boolean} autoAlpha - When a new Particle is emitted this controls if it will automatically change alpha. Use Emitter.setAlpha to configure.
	    */this.autoAlpha=false;/**
	    * @property {boolean} particleBringToTop - If this is `true` then when the Particle is emitted it will be bought to the top of the Emitters display list.
	    * @default
	    */this.particleBringToTop=false;/**
	    * @property {boolean} particleSendToBack - If this is `true` then when the Particle is emitted it will be sent to the back of the Emitters display list.
	    * @default
	    */this.particleSendToBack=false;/**
	    * @property {Phaser.Point} _minParticleScale - Internal particle scale var.
	    * @private
	    */this._minParticleScale=new Phaser.Point(1,1);/**
	    * @property {Phaser.Point} _maxParticleScale - Internal particle scale var.
	    * @private
	    */this._maxParticleScale=new Phaser.Point(1,1);/**
	    * @property {number} _quantity - Internal helper for deciding how many particles to launch.
	    * @private
	    */this._quantity=0;/**
	    * @property {number} _timer - Internal helper for deciding when to launch particles or kill them.
	    * @private
	    */this._timer=0;/**
	    * @property {number} _counter - Internal counter for figuring out how many particles to launch.
	    * @private
	    */this._counter=0;/**
	    * @property {number} _flowQuantity - Internal counter for figuring out how many particles to launch per flow update.
	    * @private
	    */this._flowQuantity=0;/**
	    * @property {number} _flowTotal - Internal counter for figuring out how many particles to launch in total.
	    * @private
	    */this._flowTotal=0;/**
	    * @property {boolean} _explode - Internal helper for the style of particle emission (all at once, or one at a time).
	    * @private
	    */this._explode=true;/**
	    * @property {any} _frames - Internal helper for the particle frame.
	    * @private
	    */this._frames=null;};Phaser.Particles.Arcade.Emitter.prototype=Object.create(Phaser.Group.prototype);Phaser.Particles.Arcade.Emitter.prototype.constructor=Phaser.Particles.Arcade.Emitter;/**
	* Called automatically by the game loop, decides when to launch particles and when to "die".
	* 
	* @method Phaser.Particles.Arcade.Emitter#update
	*/Phaser.Particles.Arcade.Emitter.prototype.update=function(){if(this.on&&this.game.time.time>=this._timer){this._timer=this.game.time.time+this.frequency*this.game.time.slowMotion;if(this._flowTotal!==0){if(this._flowQuantity>0){for(var i=0;i<this._flowQuantity;i++){if(this.emitParticle()){this._counter++;if(this._flowTotal!==-1&&this._counter>=this._flowTotal){this.on=false;break;}}}}else{if(this.emitParticle()){this._counter++;if(this._flowTotal!==-1&&this._counter>=this._flowTotal){this.on=false;}}}}else{if(this.emitParticle()){this._counter++;if(this._quantity>0&&this._counter>=this._quantity){this.on=false;}}}}var i=this.children.length;while(i--){if(this.children[i].exists){this.children[i].update();}}};/**
	* This function generates a new set of particles for use by this emitter.
	* The particles are stored internally waiting to be emitted via Emitter.start.
	*
	* @method Phaser.Particles.Arcade.Emitter#makeParticles
	* @param {array|string} keys - A string or an array of strings that the particle sprites will use as their texture. If an array one is picked at random.
	* @param {array|number} [frames=0] - A frame number, or array of frames that the sprite will use. If an array one is picked at random.
	* @param {number} [quantity] - The number of particles to generate. If not given it will use the value of Emitter.maxParticles. If the value is greater than Emitter.maxParticles it will use Emitter.maxParticles as the quantity.
	* @param {boolean} [collide=false] - If you want the particles to be able to collide with other Arcade Physics bodies then set this to true.
	* @param {boolean} [collideWorldBounds=false] - A particle can be set to collide against the World bounds automatically and rebound back into the World if this is set to true. Otherwise it will leave the World.
	* @return {Phaser.Particles.Arcade.Emitter} This Emitter instance.
	*/Phaser.Particles.Arcade.Emitter.prototype.makeParticles=function(keys,frames,quantity,collide,collideWorldBounds){if(frames===undefined){frames=0;}if(quantity===undefined){quantity=this.maxParticles;}if(collide===undefined){collide=false;}if(collideWorldBounds===undefined){collideWorldBounds=false;}var particle;var i=0;var rndKey=keys;var rndFrame=frames;this._frames=frames;if(quantity>this.maxParticles){this.maxParticles=quantity;}while(i<quantity){if(Array.isArray(keys)){rndKey=this.game.rnd.pick(keys);}if(Array.isArray(frames)){rndFrame=this.game.rnd.pick(frames);}particle=new this.particleClass(this.game,0,0,rndKey,rndFrame);this.game.physics.arcade.enable(particle,false);if(collide){particle.body.checkCollision.any=true;particle.body.checkCollision.none=false;}else{particle.body.checkCollision.none=true;}particle.body.collideWorldBounds=collideWorldBounds;particle.body.skipQuadTree=true;particle.exists=false;particle.visible=false;particle.anchor.copyFrom(this.particleAnchor);this.add(particle);i++;}return this;};/**
	* Call this function to turn off all the particles and the emitter.
	*
	* @method Phaser.Particles.Arcade.Emitter#kill
	* @return {Phaser.Particles.Arcade.Emitter} This Emitter instance.
	*/Phaser.Particles.Arcade.Emitter.prototype.kill=function(){this.on=false;this.alive=false;this.exists=false;return this;};/**
	* Handy for bringing game objects "back to life". Just sets alive and exists back to true.
	*
	* @method Phaser.Particles.Arcade.Emitter#revive
	* @return {Phaser.Particles.Arcade.Emitter} This Emitter instance.
	*/Phaser.Particles.Arcade.Emitter.prototype.revive=function(){this.alive=true;this.exists=true;return this;};/**
	* Call this function to emit the given quantity of particles at all once (an explosion)
	* 
	* @method Phaser.Particles.Arcade.Emitter#explode
	* @param {number} [lifespan=0] - How long each particle lives once emitted in ms. 0 = forever.
	* @param {number} [quantity=0] - How many particles to launch.
	* @return {Phaser.Particles.Arcade.Emitter} This Emitter instance.
	*/Phaser.Particles.Arcade.Emitter.prototype.explode=function(lifespan,quantity){this._flowTotal=0;this.start(true,lifespan,0,quantity,false);return this;};/**
	* Call this function to start emitting a flow of particles at the given frequency.
	* It will carry on going until the total given is reached.
	* Each time the flow is run the quantity number of particles will be emitted together.
	* If you set the total to be 20 and quantity to be 5 then flow will emit 4 times in total (4 x 5 = 20 total)
	* If you set the total to be -1 then no quantity cap is used and it will keep emitting.
	* 
	* @method Phaser.Particles.Arcade.Emitter#flow
	* @param {number} [lifespan=0] - How long each particle lives once emitted in ms. 0 = forever.
	* @param {number} [frequency=250] - Frequency is how often to emit the particles, given in ms.
	* @param {number} [quantity=1] - How many particles to launch each time the frequency is met. Can never be > Emitter.maxParticles.
	* @param {number} [total=-1] - How many particles to launch in total. If -1 it will carry on indefinitely.
	* @param {boolean} [immediate=true] - Should the flow start immediately (true) or wait until the first frequency event? (false)
	* @return {Phaser.Particles.Arcade.Emitter} This Emitter instance.
	*/Phaser.Particles.Arcade.Emitter.prototype.flow=function(lifespan,frequency,quantity,total,immediate){if(quantity===undefined||quantity===0){quantity=1;}if(total===undefined){total=-1;}if(immediate===undefined){immediate=true;}if(quantity>this.maxParticles){quantity=this.maxParticles;}this._counter=0;this._flowQuantity=quantity;this._flowTotal=total;if(immediate){this.start(true,lifespan,frequency,quantity);this._counter+=quantity;this.on=true;this._timer=this.game.time.time+frequency*this.game.time.slowMotion;}else{this.start(false,lifespan,frequency,quantity);}return this;};/**
	* Call this function to start emitting particles.
	* 
	* @method Phaser.Particles.Arcade.Emitter#start
	* @param {boolean} [explode=true] - Whether the particles should all burst out at once (true) or at the frequency given (false).
	* @param {number} [lifespan=0] - How long each particle lives once emitted in ms. 0 = forever.
	* @param {number} [frequency=250] - Ignored if Explode is set to true. Frequency is how often to emit 1 particle. Value given in ms.
	* @param {number} [quantity=0] - How many particles to launch. 0 = "all of the particles" which will keep emitting until Emitter.maxParticles is reached.
	* @param {number} [forceQuantity=false] - If `true` and creating a particle flow, the quantity emitted will be forced to the be quantity given in this call. This can never exceed Emitter.maxParticles.
	* @return {Phaser.Particles.Arcade.Emitter} This Emitter instance.
	*/Phaser.Particles.Arcade.Emitter.prototype.start=function(explode,lifespan,frequency,quantity,forceQuantity){if(explode===undefined){explode=true;}if(lifespan===undefined){lifespan=0;}if(frequency===undefined||frequency===null){frequency=250;}if(quantity===undefined){quantity=0;}if(forceQuantity===undefined){forceQuantity=false;}if(quantity>this.maxParticles){quantity=this.maxParticles;}this.revive();this.visible=true;this.lifespan=lifespan;this.frequency=frequency;if(explode||forceQuantity){for(var i=0;i<quantity;i++){this.emitParticle();}}else{this.on=true;this._quantity=quantity;this._counter=0;this._timer=this.game.time.time+frequency*this.game.time.slowMotion;}return this;};/**
	* This function is used internally to emit the next particle in the queue.
	*
	* However it can also be called externally to emit a particle.
	*
	* When called externally you can use the arguments to override any defaults the Emitter has set.
	*
	* @method Phaser.Particles.Arcade.Emitter#emitParticle
	* @param {number} [x] - The x coordinate to emit the particle from. If `null` or `undefined` it will use `Emitter.emitX` or if the Emitter has a width > 1 a random value between `Emitter.left` and `Emitter.right`.
	* @param {number} [y] - The y coordinate to emit the particle from. If `null` or `undefined` it will use `Emitter.emitY` or if the Emitter has a height > 1 a random value between `Emitter.top` and `Emitter.bottom`.
	* @param {string|Phaser.RenderTexture|Phaser.BitmapData|Phaser.Video|PIXI.Texture} [key] - This is the image or texture used by the Particle during rendering. It can be a string which is a reference to the Cache Image entry, or an instance of a RenderTexture, BitmapData, Video or PIXI.Texture.
	* @param {string|number} [frame] - If this Particle is using part of a sprite sheet or texture atlas you can specify the exact frame to use by giving a string or numeric index.
	* @return {boolean} True if a particle was emitted, otherwise false.
	*/Phaser.Particles.Arcade.Emitter.prototype.emitParticle=function(x,y,key,frame){if(x===undefined){x=null;}if(y===undefined){y=null;}var particle=this.getFirstExists(false);if(particle===null){return false;}var rnd=this.game.rnd;if(key!==undefined&&frame!==undefined){particle.loadTexture(key,frame);}else if(key!==undefined){particle.loadTexture(key);}var emitX=this.emitX;var emitY=this.emitY;if(x!==null){emitX=x;}else if(this.width>1){emitX=rnd.between(this.left,this.right);}if(y!==null){emitY=y;}else if(this.height>1){emitY=rnd.between(this.top,this.bottom);}particle.reset(emitX,emitY);particle.angle=0;particle.lifespan=this.lifespan;if(this.particleBringToTop){this.bringToTop(particle);}else if(this.particleSendToBack){this.sendToBack(particle);}if(this.autoScale){particle.setScaleData(this.scaleData);}else if(this.minParticleScale!==1||this.maxParticleScale!==1){particle.scale.set(rnd.realInRange(this.minParticleScale,this.maxParticleScale));}else if(this._minParticleScale.x!==this._maxParticleScale.x||this._minParticleScale.y!==this._maxParticleScale.y){particle.scale.set(rnd.realInRange(this._minParticleScale.x,this._maxParticleScale.x),rnd.realInRange(this._minParticleScale.y,this._maxParticleScale.y));}if(frame===undefined){if(Array.isArray(this._frames)){particle.frame=this.game.rnd.pick(this._frames);}else{particle.frame=this._frames;}}if(this.autoAlpha){particle.setAlphaData(this.alphaData);}else{particle.alpha=rnd.realInRange(this.minParticleAlpha,this.maxParticleAlpha);}particle.blendMode=this.blendMode;var body=particle.body;body.updateBounds();body.bounce.copyFrom(this.bounce);body.drag.copyFrom(this.particleDrag);body.velocity.x=rnd.between(this.minParticleSpeed.x,this.maxParticleSpeed.x);body.velocity.y=rnd.between(this.minParticleSpeed.y,this.maxParticleSpeed.y);body.angularVelocity=rnd.between(this.minRotation,this.maxRotation);body.gravity.y=this.gravity;body.angularDrag=this.angularDrag;particle.onEmit();return true;};/**
	* Destroys this Emitter, all associated child Particles and then removes itself from the Particle Manager.
	* 
	* @method Phaser.Particles.Arcade.Emitter#destroy
	*/Phaser.Particles.Arcade.Emitter.prototype.destroy=function(){this.game.particles.remove(this);Phaser.Group.prototype.destroy.call(this,true,false);};/**
	* A more compact way of setting the width and height of the emitter.
	* 
	* @method Phaser.Particles.Arcade.Emitter#setSize
	* @param {number} width - The desired width of the emitter (particles are spawned randomly within these dimensions).
	* @param {number} height - The desired height of the emitter.
	* @return {Phaser.Particles.Arcade.Emitter} This Emitter instance.
	*/Phaser.Particles.Arcade.Emitter.prototype.setSize=function(width,height){this.area.width=width;this.area.height=height;return this;};/**
	* A more compact way of setting the X velocity range of the emitter.
	* @method Phaser.Particles.Arcade.Emitter#setXSpeed
	* @param {number} [min=0] - The minimum value for this range.
	* @param {number} [max=0] - The maximum value for this range.
	* @return {Phaser.Particles.Arcade.Emitter} This Emitter instance.
	*/Phaser.Particles.Arcade.Emitter.prototype.setXSpeed=function(min,max){min=min||0;max=max||0;this.minParticleSpeed.x=min;this.maxParticleSpeed.x=max;return this;};/**
	* A more compact way of setting the Y velocity range of the emitter.
	* @method Phaser.Particles.Arcade.Emitter#setYSpeed
	* @param {number} [min=0] - The minimum value for this range.
	* @param {number} [max=0] - The maximum value for this range.
	* @return {Phaser.Particles.Arcade.Emitter} This Emitter instance.
	*/Phaser.Particles.Arcade.Emitter.prototype.setYSpeed=function(min,max){min=min||0;max=max||0;this.minParticleSpeed.y=min;this.maxParticleSpeed.y=max;return this;};/**
	* A more compact way of setting the angular velocity constraints of the particles.
	*
	* @method Phaser.Particles.Arcade.Emitter#setRotation
	* @param {number} [min=0] - The minimum value for this range.
	* @param {number} [max=0] - The maximum value for this range.
	* @return {Phaser.Particles.Arcade.Emitter} This Emitter instance.
	*/Phaser.Particles.Arcade.Emitter.prototype.setRotation=function(min,max){min=min||0;max=max||0;this.minRotation=min;this.maxRotation=max;return this;};/**
	* A more compact way of setting the alpha constraints of the particles.
	* The rate parameter, if set to a value above zero, lets you set the speed at which the Particle change in alpha from min to max.
	* If rate is zero, which is the default, the particle won't change alpha - instead it will pick a random alpha between min and max on emit.
	*
	* @method Phaser.Particles.Arcade.Emitter#setAlpha
	* @param {number} [min=1] - The minimum value for this range.
	* @param {number} [max=1] - The maximum value for this range.
	* @param {number} [rate=0] - The rate (in ms) at which the particles will change in alpha from min to max, or set to zero to pick a random alpha between the two.
	* @param {function} [ease=Phaser.Easing.Linear.None] - If you've set a rate > 0 this is the easing formula applied between the min and max values.
	* @param {boolean} [yoyo=false] - If you've set a rate > 0 you can set if the ease will yoyo or not (i.e. ease back to its original values)
	* @return {Phaser.Particles.Arcade.Emitter} This Emitter instance.
	*/Phaser.Particles.Arcade.Emitter.prototype.setAlpha=function(min,max,rate,ease,yoyo){if(min===undefined){min=1;}if(max===undefined){max=1;}if(rate===undefined){rate=0;}if(ease===undefined){ease=Phaser.Easing.Linear.None;}if(yoyo===undefined){yoyo=false;}this.minParticleAlpha=min;this.maxParticleAlpha=max;this.autoAlpha=false;if(rate>0&&min!==max){var tweenData={v:min};var tween=this.game.make.tween(tweenData).to({v:max},rate,ease);tween.yoyo(yoyo);this.alphaData=tween.generateData(60);//  Inverse it so we don't have to do array length look-ups in Particle update loops
	this.alphaData.reverse();this.autoAlpha=true;}return this;};/**
	* A more compact way of setting the scale constraints of the particles.
	* The rate parameter, if set to a value above zero, lets you set the speed and ease which the Particle uses to change in scale from min to max across both axis.
	* If rate is zero, which is the default, the particle won't change scale during update, instead it will pick a random scale between min and max on emit.
	*
	* @method Phaser.Particles.Arcade.Emitter#setScale
	* @param {number} [minX=1] - The minimum value of Particle.scale.x.
	* @param {number} [maxX=1] - The maximum value of Particle.scale.x.
	* @param {number} [minY=1] - The minimum value of Particle.scale.y.
	* @param {number} [maxY=1] - The maximum value of Particle.scale.y.
	* @param {number} [rate=0] - The rate (in ms) at which the particles will change in scale from min to max, or set to zero to pick a random size between the two.
	* @param {function} [ease=Phaser.Easing.Linear.None] - If you've set a rate > 0 this is the easing formula applied between the min and max values.
	* @param {boolean} [yoyo=false] - If you've set a rate > 0 you can set if the ease will yoyo or not (i.e. ease back to its original values)
	* @return {Phaser.Particles.Arcade.Emitter} This Emitter instance.
	*/Phaser.Particles.Arcade.Emitter.prototype.setScale=function(minX,maxX,minY,maxY,rate,ease,yoyo){if(minX===undefined){minX=1;}if(maxX===undefined){maxX=1;}if(minY===undefined){minY=1;}if(maxY===undefined){maxY=1;}if(rate===undefined){rate=0;}if(ease===undefined){ease=Phaser.Easing.Linear.None;}if(yoyo===undefined){yoyo=false;}//  Reset these
	this.minParticleScale=1;this.maxParticleScale=1;this._minParticleScale.set(minX,minY);this._maxParticleScale.set(maxX,maxY);this.autoScale=false;if(rate>0&&(minX!==maxX||minY!==maxY)){var tweenData={x:minX,y:minY};var tween=this.game.make.tween(tweenData).to({x:maxX,y:maxY},rate,ease);tween.yoyo(yoyo);this.scaleData=tween.generateData(60);//  Inverse it so we don't have to do array length look-ups in Particle update loops
	this.scaleData.reverse();this.autoScale=true;}return this;};/**
	* Change the emitters center to match the center of any object with a `center` property, such as a Sprite.
	* If the object doesn't have a center property it will be set to object.x + object.width / 2
	*
	* @method Phaser.Particles.Arcade.Emitter#at
	* @param {object|Phaser.Sprite|Phaser.Image|Phaser.TileSprite|Phaser.Text|PIXI.DisplayObject} object - The object that you wish to match the center with.
	* @return {Phaser.Particles.Arcade.Emitter} This Emitter instance.
	*/Phaser.Particles.Arcade.Emitter.prototype.at=function(object){if(object.center){this.emitX=object.center.x;this.emitY=object.center.y;}else{this.emitX=object.world.x+object.anchor.x*object.width;this.emitY=object.world.y+object.anchor.y*object.height;}return this;};/**
	* @name Phaser.Particles.Arcade.Emitter#width
	* @property {number} width - Gets or sets the width of the Emitter. This is the region in which a particle can be emitted.
	*/Object.defineProperty(Phaser.Particles.Arcade.Emitter.prototype,"width",{get:function get(){return this.area.width;},set:function set(value){this.area.width=value;}});/**
	* @name Phaser.Particles.Arcade.Emitter#height
	* @property {number} height - Gets or sets the height of the Emitter. This is the region in which a particle can be emitted.
	*/Object.defineProperty(Phaser.Particles.Arcade.Emitter.prototype,"height",{get:function get(){return this.area.height;},set:function set(value){this.area.height=value;}});/**
	* @name Phaser.Particles.Arcade.Emitter#x
	* @property {number} x - Gets or sets the x position of the Emitter.
	*/Object.defineProperty(Phaser.Particles.Arcade.Emitter.prototype,"x",{get:function get(){return this.emitX;},set:function set(value){this.emitX=value;}});/**
	* @name Phaser.Particles.Arcade.Emitter#y
	* @property {number} y - Gets or sets the y position of the Emitter.
	*/Object.defineProperty(Phaser.Particles.Arcade.Emitter.prototype,"y",{get:function get(){return this.emitY;},set:function set(value){this.emitY=value;}});/**
	* @name Phaser.Particles.Arcade.Emitter#left
	* @property {number} left - Gets the left position of the Emitter.
	* @readonly
	*/Object.defineProperty(Phaser.Particles.Arcade.Emitter.prototype,"left",{get:function get(){return Math.floor(this.x-this.area.width/2);}});/**
	* @name Phaser.Particles.Arcade.Emitter#right
	* @property {number} right - Gets the right position of the Emitter.
	* @readonly
	*/Object.defineProperty(Phaser.Particles.Arcade.Emitter.prototype,"right",{get:function get(){return Math.floor(this.x+this.area.width/2);}});/**
	* @name Phaser.Particles.Arcade.Emitter#top
	* @property {number} top - Gets the top position of the Emitter.
	* @readonly
	*/Object.defineProperty(Phaser.Particles.Arcade.Emitter.prototype,"top",{get:function get(){return Math.floor(this.y-this.area.height/2);}});/**
	* @name Phaser.Particles.Arcade.Emitter#bottom
	* @property {number} bottom - Gets the bottom position of the Emitter.
	* @readonly
	*/Object.defineProperty(Phaser.Particles.Arcade.Emitter.prototype,"bottom",{get:function get(){return Math.floor(this.y+this.area.height/2);}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* The Weapon Plugin provides the ability to easily create a bullet pool and manager.
	*
	* Weapons fire Phaser.Bullet objects, which are essentially Sprites with a few extra properties.
	* The Bullets are enabled for Arcade Physics. They do not currently work with P2 Physics.
	*
	* The Bullets are created inside of `Weapon.bullets`, which is a Phaser.Group instance. Anything you
	* can usually do with a Group, such as move it around the display list, iterate it, etc can be done
	* to the bullets Group too.
	*
	* Bullets can have textures and even animations. You can control the speed at which they are fired,
	* the firing rate, the firing angle, and even set things like gravity for them.
	*
	* A small example, assumed to be running from within a Phaser.State create method.
	*
	* `var weapon = this.add.weapon(10, 'bullet');`
	* `weapon.fireFrom.set(300, 300);`
	* `this.input.onDown.add(weapon.fire, this);`
	*
	* @class Phaser.Weapon
	* @constructor
	* @param {Phaser.Game} game - A reference to the current Phaser.Game instance.
	* @param {Phaser.PluginManager} parent - The Phaser Plugin Manager which looks after this plugin.
	*/Phaser.Weapon=function(game,parent){Phaser.Plugin.call(this,game,parent);/**
	     * This is the Phaser.Group that contains all of the bullets managed by this plugin.
	     * @type {Phaser.Group}
	     */this.bullets=null;/**
	     * Should the bullet pool run out of bullets (i.e. they are all in flight) then this
	     * boolean controls if the Group will create a brand new bullet object or not.
	     * @type {boolean}
	     */this.autoExpandBulletsGroup=false;/**
	     * Will this weapon auto fire? If set to true then a new bullet will be fired
	     * based on the `fireRate` value.
	     * @type {boolean}
	     */this.autofire=false;/**
	     * The total number of bullets this Weapon has fired so far.
	     * You can limit the number of shots allowed (via `fireLimit`), and reset
	     * this total via `Weapon.resetShots`.
	     * @type {number}
	     */this.shots=0;/**
	     * The maximum number of shots that this Weapon is allowed to fire before it stops.
	     * When the limit is his the `Weapon.onFireLimit` Signal is dispatched.
	     * You can reset the shot counter via `Weapon.resetShots`.
	     * @type {number}
	     */this.fireLimit=0;/**
	     * The rate at which this Weapon can fire. The value is given in milliseconds.
	     * @type {number}
	     */this.fireRate=100;/**
	     * This is a modifier that is added to the `fireRate` each update to add variety
	     * to the firing rate of the Weapon. The value is given in milliseconds.
	     * If you've a `fireRate` of 200 and a `fireRateVariance` of 50 then the actual
	     * firing rate of the Weapon will be between 150 and 250.
	     * @type {number}
	     */this.fireRateVariance=0;/**
	     * This is a Rectangle from within which the bullets are fired. By default it's a 1x1
	     * rectangle, the equivalent of a Point. But you can change the width and height, and if
	     * larger than 1x1 it'll pick a random point within the rectangle to launch the bullet from.
	     * @type {Phaser.Rectangle}
	     */this.fireFrom=new Phaser.Rectangle(0,0,1,1);/**
	     * The angle at which the bullets are fired. This can be a const such as Phaser.ANGLE_UP
	     * or it can be any number from 0 to 360 inclusive, where 0 degrees is to the right.
	     * @type {integer}
	     */this.fireAngle=Phaser.ANGLE_UP;/**
	     * When a Bullet is fired it can optionally inherit the velocity of the `trackedSprite` if set.
	     * @type {boolean}
	     */this.bulletInheritSpriteSpeed=false;/**
	     * The string based name of the animation that the Bullet will be given on launch.
	     * This is set via `Weapon.addBulletAnimation`.
	     * @type {string}
	     */this.bulletAnimation='';/**
	     * If you've added a set of frames via `Weapon.setBulletFrames` then you can optionally
	     * chose for each Bullet fired to pick a random frame from the set.
	     * @type {boolean}
	     */this.bulletFrameRandom=false;/**
	     * If you've added a set of frames via `Weapon.setBulletFrames` then you can optionally
	     * chose for each Bullet fired to use the next frame in the set. The frame index is then
	     * advanced one frame until it reaches the end of the set, then it starts from the start
	     * again. Cycling frames like this allows you to create varied bullet effects via
	     * sprite sheets.
	     * @type {boolean}
	     */this.bulletFrameCycle=false;/**
	     * Should the Bullets wrap around the world bounds? This automatically calls
	     * `World.wrap` on the Bullet each frame. See the docs for that method for details.
	     * @type {boolean}
	     */this.bulletWorldWrap=false;/**
	     * If `bulletWorldWrap` is true then you can provide an optional padding value with this
	     * property. It's added to the calculations determining when the Bullet should wrap around
	     * the world or not. The value is given in pixels.
	     * @type {integer}
	     */this.bulletWorldWrapPadding=0;/**
	     * An optional angle offset applied to the Bullets when they are launched.
	     * This is useful if for example your bullet sprites have been drawn facing up, instead of
	     * to the right, and you want to fire them at an angle. In which case you can set the
	     * angle offset to be 90 and they'll be properly rotated when fired.
	     * @type {number}
	     */this.bulletAngleOffset=0;/**
	     * This is a variance added to the angle of Bullets when they are fired.
	     * If you fire from an angle of 90 and have a `bulletAngleVariance` of 20 then the actual
	     * angle of the Bullets will be between 70 and 110 degrees. This is a quick way to add a
	     * great 'spread' effect to a Weapon.
	     * @type {number}
	     */this.bulletAngleVariance=0;/**
	     * The speed at which the bullets are fired. This value is given in pixels per second, and
	     * is used to set the starting velocity of the bullets.
	     * @type {number}
	     */this.bulletSpeed=200;/**
	     * This is a variance added to the speed of Bullets when they are fired.
	     * If bullets have a `bulletSpeed` value of 200, and a `bulletSpeedVariance` of 50
	     * then the actual speed of the Bullets will be between 150 and 250 pixels per second.
	     * @type {number}
	     */this.bulletSpeedVariance=0;/**
	     * If you've set `bulletKillType` to `Phaser.Weapon.KILL_LIFESPAN` this controls the amount
	     * of lifespan the Bullets have set on launch. The value is given in milliseconds.
	     * When a Bullet hits its lifespan limit it will be automatically killed.
	     * @type {number}
	     */this.bulletLifespan=0;/**
	     * If you've set `bulletKillType` to `Phaser.Weapon.KILL_DISTANCE` this controls the distance
	     * the Bullet can travel before it is automatically killed. The distance is given in pixels.
	     * @type {number}
	     */this.bulletKillDistance=0;/**
	     * This is the amount of gravity added to the Bullets physics body when fired.
	     * Gravity is expressed in pixels / second / second.
	     * @type {Phaser.Point}
	     */this.bulletGravity=new Phaser.Point(0,0);/**
	     * Bullets can optionally adjust their rotation in-flight to match their velocity.
	     * This can create the effect of a bullet 'pointing' to the path it is following, for example
	     * an arrow being fired from a bow, and works especially well when added to `bulletGravity`.
	     * @type {boolean}
	     */this.bulletRotateToVelocity=false;/**
	     * The Texture Key that the Bullets use when rendering.
	     * Changing this has no effect on bullets in-flight, only on newly spawned bullets.
	     * @type {string}
	     */this.bulletKey='';/**
	     * The Texture Frame that the Bullets use when rendering.
	     * Changing this has no effect on bullets in-flight, only on newly spawned bullets.
	     * @type {string|integer}
	     */this.bulletFrame='';/**
	     * Private var that holds the public `bulletClass` property.
	     * @type {object}
	     * @private
	     */this._bulletClass=Phaser.Bullet;/**
	     * Private var that holds the public `bulletCollideWorldBounds` property.
	     * @type {boolean}
	     * @private
	     */this._bulletCollideWorldBounds=false;/**
	     * Private var that holds the public `bulletKillType` property.
	     * @type {integer}
	     * @private
	     */this._bulletKillType=Phaser.Weapon.KILL_WORLD_BOUNDS;/**
	     * Holds internal data about custom bullet body sizes.
	     *
	     * @type {Object}
	     * @private
	     */this._data={customBody:false,width:0,height:0,offsetX:0,offsetY:0};/**
	     * This Rectangle defines the bounds that are used when determining if a Bullet should be killed or not.
	     * It's used in combination with `Weapon.bulletKillType` when that is set to either `Phaser.Weapon.KILL_WEAPON_BOUNDS`
	     * or `Phaser.Weapon.KILL_STATIC_BOUNDS`. If you are not using either of these kill types then the bounds are ignored.
	     * If you are tracking a Sprite or Point then the bounds are centered on that object every frame.
	     *
	     * @type {Phaser.Rectangle}
	     */this.bounds=new Phaser.Rectangle();/**
	     * The Rectangle used to calculate the bullet bounds from.
	     *
	     * @type {Phaser.Rectangle}
	     * @private
	     */this.bulletBounds=game.world.bounds;/**
	     * This array stores the frames added via `Weapon.setBulletFrames`.
	     *
	     * @type {Array}
	     * @protected
	     */this.bulletFrames=[];/**
	     * The index of the frame within `Weapon.bulletFrames` that is currently being used.
	     * This value is only used if `Weapon.bulletFrameCycle` is set to `true`.
	     * @type {number}
	     * @private
	     */this.bulletFrameIndex=0;/**
	     * An internal object that stores the animation data added via `Weapon.addBulletAnimation`.
	     * @type {Object}
	     * @private
	     */this.anims={};/**
	     * The onFire Signal is dispatched each time `Weapon.fire` is called, and a Bullet is
	     * _successfully_ launched. The callback is set two arguments: a reference to the bullet sprite itself,
	     * and a reference to the Weapon that fired the bullet.
	     *
	     * @type {Phaser.Signal}
	     */this.onFire=new Phaser.Signal();/**
	     * The onKill Signal is dispatched each time a Bullet that is in-flight is killed. This can be the result
	     * of leaving the Weapon bounds, an expiring lifespan, or exceeding a specified distance.
	     * The callback is sent one argument: A reference to the bullet sprite itself.
	     *
	     * @type {Phaser.Signal}
	     */this.onKill=new Phaser.Signal();/**
	     * The onFireLimit Signal is dispatched if `Weapon.fireLimit` is > 0, and a bullet launch takes the number
	     * of shots fired to equal the fire limit.
	     * The callback is sent two arguments: A reference to the Weapon that hit the limit, and the value of
	     * `Weapon.fireLimit`.
	     *
	     * @type {Phaser.Signal}
	     */this.onFireLimit=new Phaser.Signal();/**
	     * The Sprite currently being tracked by the Weapon, if any.
	     * This is set via the `Weapon.trackSprite` method.
	     *
	     * @type {Phaser.Sprite|Object}
	     */this.trackedSprite=null;/**
	     * The Pointer currently being tracked by the Weapon, if any.
	     * This is set via the `Weapon.trackPointer` method.
	     *
	     * @type {Phaser.Pointer}
	     */this.trackedPointer=null;/**
	     * If the Weapon is tracking a Sprite, should it also track the Sprites rotation?
	     * This is useful for a game such as Asteroids, where you want the weapon to fire based
	     * on the sprites rotation.
	     *
	     * @type {boolean}
	     */this.trackRotation=false;/**
	     * The Track Offset is a Point object that allows you to specify a pixel offset that bullets use
	     * when launching from a tracked Sprite or Pointer. For example if you've got a bullet that is 2x2 pixels
	     * in size, but you're tracking a Sprite that is 32x32, then you can set `trackOffset.x = 16` to have
	     * the bullet launched from the center of the Sprite.
	     *
	     * @type {Phaser.Point}
	     */this.trackOffset=new Phaser.Point();/**
	     * Internal firing rate time tracking variable.
	     *
	     * @type {number}
	     * @private
	     */this._nextFire=0;/**
	     * Internal firing rotation tracking point.
	     *
	     * @type {Phaser.Point}
	     * @private
	     */this._rotatedPoint=new Phaser.Point();};Phaser.Weapon.prototype=Object.create(Phaser.Plugin.prototype);Phaser.Weapon.prototype.constructor=Phaser.Weapon;/**
	* A `bulletKillType` constant that stops the bullets from ever being destroyed automatically.
	* @constant
	* @type {integer}
	*/Phaser.Weapon.KILL_NEVER=0;/**
	* A `bulletKillType` constant that automatically kills the bullets when their `bulletLifespan` expires.
	* @constant
	* @type {integer}
	*/Phaser.Weapon.KILL_LIFESPAN=1;/**
	* A `bulletKillType` constant that automatically kills the bullets after they
	* exceed the `bulletDistance` from their original firing position.
	* @constant
	* @type {integer}
	*/Phaser.Weapon.KILL_DISTANCE=2;/**
	* A `bulletKillType` constant that automatically kills the bullets when they leave the `Weapon.bounds` rectangle.
	* @constant
	* @type {integer}
	*/Phaser.Weapon.KILL_WEAPON_BOUNDS=3;/**
	* A `bulletKillType` constant that automatically kills the bullets when they leave the `Camera.bounds` rectangle.
	* @constant
	* @type {integer}
	*/Phaser.Weapon.KILL_CAMERA_BOUNDS=4;/**
	* A `bulletKillType` constant that automatically kills the bullets when they leave the `World.bounds` rectangle.
	* @constant
	* @type {integer}
	*/Phaser.Weapon.KILL_WORLD_BOUNDS=5;/**
	* A `bulletKillType` constant that automatically kills the bullets when they leave the `Weapon.bounds` rectangle.
	* @constant
	* @type {integer}
	*/Phaser.Weapon.KILL_STATIC_BOUNDS=6;/**
	* This method performs two actions: First it will check to see if the `Weapon.bullets` Group exists or not,
	* and if not it creates it, adding it the `group` given as the 4th argument.
	*
	* Then it will seed the bullet pool with the `quantity` number of Bullets, using the texture key and frame
	* provided (if any).
	*
	* If for example you set the quantity to be 10, then this Weapon will only ever be able to have 10 bullets
	* in-flight simultaneously. If you try to fire an 11th bullet then nothing will happen until one, or more, of
	* the in-flight bullets have been killed, freeing them up for use by the Weapon again.
	*
	* If you do not wish to have a limit set, then pass in -1 as the quantity. In this instance the Weapon will
	* keep increasing the size of the bullet pool as needed. It will never reduce the size of the pool however,
	* so be careful it doesn't grow too large.
	*
	* You can either set the texture key and frame here, or via the `Weapon.bulletKey` and `Weapon.bulletFrame`
	* properties. You can also animate bullets, or set them to use random frames. All Bullets belonging to a
	* single Weapon instance must share the same texture key however.
	*
	* @method Phaser.Weapon#createBullets
	* @param {integer} [quantity=1] - The quantity of bullets to seed the Weapon with. If -1 it will set the pool to automatically expand.
	* @param {string} [key] - The Game.cache key of the image that this Sprite will use.
	* @param {integer|string} [frame] - If the Sprite image contains multiple frames you can specify which one to use here.
	* @param {Phaser.Group} [group] - Optional Group to add the object to. If not specified it will be added to the World group.
	* @return {Phaser.Weapon} This Weapon instance.
	*/Phaser.Weapon.prototype.createBullets=function(quantity,key,frame,group){if(quantity===undefined){quantity=1;}if(group===undefined){group=this.game.world;}if(!this.bullets){this.bullets=this.game.add.physicsGroup(Phaser.Physics.ARCADE,group);this.bullets.classType=this._bulletClass;}if(quantity!==0){if(quantity===-1){this.autoExpandBulletsGroup=true;quantity=1;}this.bullets.createMultiple(quantity,key,frame);this.bullets.setAll('data.bulletManager',this);this.bulletKey=key;this.bulletFrame=frame;}return this;};/**
	* Call a function on each in-flight bullet in this Weapon.
	*
	* See {@link Phaser.Group#forEachExists forEachExists} for more details.
	*
	* @method Phaser.Weapon#forEach
	* @param {function} callback - The function that will be called for each applicable child. The child will be passed as the first argument.
	* @param {object} callbackContext - The context in which the function should be called (usually 'this').
	* @param {...any} [args=(none)] - Additional arguments to pass to the callback function, after the child item.
	* @return {Phaser.Weapon} This Weapon instance.
	*/Phaser.Weapon.prototype.forEach=function(callback,callbackContext){this.bullets.forEachExists(callback,callbackContext,arguments);return this;};/**
	* Sets `Body.enable` to `false` on each bullet in this Weapon.
	* This has the effect of stopping them in-flight should they be moving.
	* It also stops them being able to be checked for collision.
	*
	* @method Phaser.Weapon#pauseAll
	* @return {Phaser.Weapon} This Weapon instance.
	*/Phaser.Weapon.prototype.pauseAll=function(){this.bullets.setAll('body.enable',false);return this;};/**
	* Sets `Body.enable` to `true` on each bullet in this Weapon.
	* This has the effect of resuming their motion should they be in-flight.
	* It also enables them for collision checks again.
	*
	* @method Phaser.Weapon#resumeAll
	* @return {Phaser.Weapon} This Weapon instance.
	*/Phaser.Weapon.prototype.resumeAll=function(){this.bullets.setAll('body.enable',true);return this;};/**
	* Calls `Bullet.kill` on every in-flight bullet in this Weapon.
	* Also re-enables their physics bodies, should they have been disabled via `pauseAll`.
	*
	* @method Phaser.Weapon#killAll
	* @return {Phaser.Weapon} This Weapon instance.
	*/Phaser.Weapon.prototype.killAll=function(){this.bullets.callAllExists('kill',true);this.bullets.setAll('body.enable',true);return this;};/**
	* Resets the `Weapon.shots` counter back to zero. This is used when you've set
	* `Weapon.fireLimit`, and have hit (or just wish to reset) your limit.
	*
	* @method Phaser.Weapon#resetShots
	* @param {integer} [newLimit] - Optionally set a new `Weapon.fireLimit`.
	* @return {Phaser.Weapon} This Weapon instance.
	*/Phaser.Weapon.prototype.resetShots=function(newLimit){this.shots=0;if(newLimit!==undefined){this.fireLimit=newLimit;}return this;};/**
	* Destroys this Weapon. It removes itself from the PluginManager, destroys
	* the bullets Group, and nulls internal references.
	*
	* @method Phaser.Weapon#destroy
	*/Phaser.Weapon.prototype.destroy=function(){this.parent.remove(this,false);this.bullets.destroy();this.game=null;this.parent=null;this.active=false;this.visible=false;};/**
	* Internal update method, called by the PluginManager.
	*
	* @method Phaser.Weapon#update
	* @protected
	*/Phaser.Weapon.prototype.update=function(){if(this._bulletKillType===Phaser.Weapon.KILL_WEAPON_BOUNDS){if(this.trackedSprite){this.trackedSprite.updateTransform();this.bounds.centerOn(this.trackedSprite.worldPosition.x,this.trackedSprite.worldPosition.y);}else if(this.trackedPointer){this.bounds.centerOn(this.trackedPointer.worldX,this.trackedPointer.worldY);}}if(this.autofire){this.fire();}};/**
	* Sets this Weapon to track the given Sprite, or any Object with a public `world` Point object.
	* When a Weapon tracks a Sprite it will automatically update its `fireFrom` value to match the Sprites
	* position within the Game World, adjusting the coordinates based on the offset arguments.
	*
	* This allows you to lock a Weapon to a Sprite, so that bullets are always launched from its location.
	*
	* Calling `trackSprite` will reset `Weapon.trackedPointer` to null, should it have been set, as you can
	* only track _either_ a Sprite, or a Pointer, at once, but not both.
	*
	* @method Phaser.Weapon#trackSprite
	* @param {Phaser.Sprite|Object} sprite - The Sprite to track the position of.
	* @param {integer} [offsetX=0] - The horizontal offset from the Sprites position to be applied to the Weapon.
	* @param {integer} [offsetY=0] - The vertical offset from the Sprites position to be applied to the Weapon.
	* @param {boolean} [trackRotation=false] - Should the Weapon also track the Sprites rotation?
	* @return {Phaser.Weapon} This Weapon instance.
	*/Phaser.Weapon.prototype.trackSprite=function(sprite,offsetX,offsetY,trackRotation){if(offsetX===undefined){offsetX=0;}if(offsetY===undefined){offsetY=0;}if(trackRotation===undefined){trackRotation=false;}this.trackedPointer=null;this.trackedSprite=sprite;this.trackRotation=trackRotation;this.trackOffset.set(offsetX,offsetY);return this;};/**
	* Sets this Weapon to track the given Pointer.
	* When a Weapon tracks a Pointer it will automatically update its `fireFrom` value to match the Pointers
	* position within the Game World, adjusting the coordinates based on the offset arguments.
	*
	* This allows you to lock a Weapon to a Pointer, so that bullets are always launched from its location.
	*
	* Calling `trackPointer` will reset `Weapon.trackedSprite` to null, should it have been set, as you can
	* only track _either_ a Pointer, or a Sprite, at once, but not both.
	*
	* @method Phaser.Weapon#trackPointer
	* @param {Phaser.Pointer} [pointer] - The Pointer to track the position of. Defaults to `Input.activePointer` if not specified.
	* @param {integer} [offsetX=0] - The horizontal offset from the Pointers position to be applied to the Weapon.
	* @param {integer} [offsetY=0] - The vertical offset from the Pointers position to be applied to the Weapon.
	* @return {Phaser.Weapon} This Weapon instance.
	*/Phaser.Weapon.prototype.trackPointer=function(pointer,offsetX,offsetY){if(pointer===undefined){pointer=this.game.input.activePointer;}if(offsetX===undefined){offsetX=0;}if(offsetY===undefined){offsetY=0;}this.trackedPointer=pointer;this.trackedSprite=null;this.trackRotation=false;this.trackOffset.set(offsetX,offsetY);return this;};/**
	* Attempts to fire a single Bullet. If there are no more bullets available in the pool, and the pool cannot be extended,
	* then this method returns `false`. It will also return false if not enough time has expired since the last time
	* the Weapon was fired, as defined in the `Weapon.fireRate` property.
	*
	* Otherwise the first available bullet is selected and launched.
	*
	* The arguments are all optional, but allow you to control both where the bullet is launched from, and aimed at.
	*
	* If you don't provide any of the arguments then it uses those set via properties such as `Weapon.trackedSprite`,
	* `Weapon.bulletAngle` and so on.
	*
	* When the bullet is launched it has its texture and frame updated, as required. The velocity of the bullet is
	* calculated based on Weapon properties like `bulletSpeed`.
	*
	* @method Phaser.Weapon#fire
	* @param {Phaser.Sprite|Phaser.Point|Object} [from] - Optionally fires the bullet **from** the `x` and `y` properties of this object. If set this overrides `Weapon.trackedSprite` or `trackedPointer`. Pass `null` to ignore it.
	* @param {number} [x] - The x coordinate, in world space, to fire the bullet **towards**. If left as `undefined` the bullet direction is based on its angle.
	* @param {number} [y] - The y coordinate, in world space, to fire the bullet **towards**. If left as `undefined` the bullet direction is based on its angle.
	* @return {Phaser.Bullet} The fired bullet if successful, null otherwise.
	*/Phaser.Weapon.prototype.fire=function(from,x,y){if(this.game.time.now<this._nextFire||this.fireLimit>0&&this.shots===this.fireLimit){return false;}var speed=this.bulletSpeed;//  Apply +- speed variance
	if(this.bulletSpeedVariance!==0){speed+=Phaser.Math.between(-this.bulletSpeedVariance,this.bulletSpeedVariance);}if(from){if(this.fireFrom.width>1){this.fireFrom.centerOn(from.x,from.y);}else{this.fireFrom.x=from.x;this.fireFrom.y=from.y;}}else if(this.trackedSprite){if(this.trackRotation){this._rotatedPoint.set(this.trackedSprite.world.x+this.trackOffset.x,this.trackedSprite.world.y+this.trackOffset.y);this._rotatedPoint.rotate(this.trackedSprite.world.x,this.trackedSprite.world.y,this.trackedSprite.rotation);if(this.fireFrom.width>1){this.fireFrom.centerOn(this._rotatedPoint.x,this._rotatedPoint.y);}else{this.fireFrom.x=this._rotatedPoint.x;this.fireFrom.y=this._rotatedPoint.y;}}else{if(this.fireFrom.width>1){this.fireFrom.centerOn(this.trackedSprite.world.x+this.trackOffset.x,this.trackedSprite.world.y+this.trackOffset.y);}else{this.fireFrom.x=this.trackedSprite.world.x+this.trackOffset.x;this.fireFrom.y=this.trackedSprite.world.y+this.trackOffset.y;}}if(this.bulletInheritSpriteSpeed){speed+=this.trackedSprite.body.speed;}}else if(this.trackedPointer){if(this.fireFrom.width>1){this.fireFrom.centerOn(this.trackedPointer.world.x+this.trackOffset.x,this.trackedPointer.world.y+this.trackOffset.y);}else{this.fireFrom.x=this.trackedPointer.world.x+this.trackOffset.x;this.fireFrom.y=this.trackedPointer.world.y+this.trackOffset.y;}}var fromX=this.fireFrom.width>1?this.fireFrom.randomX:this.fireFrom.x;var fromY=this.fireFrom.height>1?this.fireFrom.randomY:this.fireFrom.y;var angle=this.trackRotation?this.trackedSprite.angle:this.fireAngle;//  The position (in world space) to fire the bullet towards, if set
	if(x!==undefined&&y!==undefined){angle=this.game.math.radToDeg(Math.atan2(y-fromY,x-fromX));}//  Apply +- angle variance
	if(this.bulletAngleVariance!==0){angle+=Phaser.Math.between(-this.bulletAngleVariance,this.bulletAngleVariance);}var moveX=0;var moveY=0;//  Avoid sin/cos for right-angled shots
	if(angle===0||angle===180){moveX=Math.cos(this.game.math.degToRad(angle))*speed;}else if(angle===90||angle===270){moveY=Math.sin(this.game.math.degToRad(angle))*speed;}else{moveX=Math.cos(this.game.math.degToRad(angle))*speed;moveY=Math.sin(this.game.math.degToRad(angle))*speed;}var bullet=null;if(this.autoExpandBulletsGroup){bullet=this.bullets.getFirstExists(false,true,fromX,fromY,this.bulletKey,this.bulletFrame);bullet.data.bulletManager=this;}else{bullet=this.bullets.getFirstExists(false);}if(bullet){bullet.reset(fromX,fromY);bullet.data.fromX=fromX;bullet.data.fromY=fromY;bullet.data.killType=this.bulletKillType;bullet.data.killDistance=this.bulletKillDistance;bullet.data.rotateToVelocity=this.bulletRotateToVelocity;if(this.bulletKillType===Phaser.Weapon.KILL_LIFESPAN){bullet.lifespan=this.bulletLifespan;}bullet.angle=angle+this.bulletAngleOffset;//  Frames and Animations
	if(this.bulletAnimation!==''){if(bullet.animations.getAnimation(this.bulletAnimation)===null){var anim=this.anims[this.bulletAnimation];bullet.animations.add(anim.name,anim.frames,anim.frameRate,anim.loop,anim.useNumericIndex);}bullet.animations.play(this.bulletAnimation);}else{if(this.bulletFrameCycle){bullet.frame=this.bulletFrames[this.bulletFrameIndex];this.bulletFrameIndex++;if(this.bulletFrameIndex>=this.bulletFrames.length){this.bulletFrameIndex=0;}}else if(this.bulletFrameRandom){bullet.frame=this.bulletFrames[Math.floor(Math.random()*this.bulletFrames.length)];}}if(bullet.data.bodyDirty){if(this._data.customBody){bullet.body.setSize(this._data.width,this._data.height,this._data.offsetX,this._data.offsetY);}bullet.body.collideWorldBounds=this.bulletCollideWorldBounds;bullet.data.bodyDirty=false;}bullet.body.velocity.set(moveX,moveY);bullet.body.gravity.set(this.bulletGravity.x,this.bulletGravity.y);if(this.bulletSpeedVariance!==0){var rate=this.fireRate;rate+=Phaser.Math.between(-this.fireRateVariance,this.fireRateVariance);if(rate<0){rate=0;}this._nextFire=this.game.time.now+rate;}else{this._nextFire=this.game.time.now+this.fireRate;}this.shots++;this.onFire.dispatch(bullet,this,speed);if(this.fireLimit>0&&this.shots===this.fireLimit){this.onFireLimit.dispatch(this,this.fireLimit);}}return bullet;};/**
	* Fires a bullet **at** the given Pointer. The bullet will be launched from the `Weapon.fireFrom` position,
	* or from a Tracked Sprite or Pointer, if you have one set.
	*
	* @method Phaser.Weapon#fireAtPointer
	* @param {Phaser.Pointer} [pointer] - The Pointer to fire the bullet towards.
	* @return {Phaser.Bullet} The fired bullet if successful, null otherwise.
	*/Phaser.Weapon.prototype.fireAtPointer=function(pointer){if(pointer===undefined){pointer=this.game.input.activePointer;}return this.fire(null,pointer.worldX,pointer.worldY);};/**
	* Fires a bullet **at** the given Sprite. The bullet will be launched from the `Weapon.fireFrom` position,
	* or from a Tracked Sprite or Pointer, if you have one set.
	*
	* @method Phaser.Weapon#fireAtSprite
	* @param {Phaser.Sprite} [sprite] - The Sprite to fire the bullet towards.
	* @return {Phaser.Bullet} The fired bullet if successful, null otherwise.
	*/Phaser.Weapon.prototype.fireAtSprite=function(sprite){return this.fire(null,sprite.world.x,sprite.world.y);};/**
	* Fires a bullet **at** the given coordinates. The bullet will be launched from the `Weapon.fireFrom` position,
	* or from a Tracked Sprite or Pointer, if you have one set.
	*
	* @method Phaser.Weapon#fireAtXY
	* @param {number} [x] - The x coordinate, in world space, to fire the bullet towards.
	* @param {number} [y] - The y coordinate, in world space, to fire the bullet towards.
	* @return {Phaser.Bullet} The fired bullet if successful, null otherwise.
	*/Phaser.Weapon.prototype.fireAtXY=function(x,y){return this.fire(null,x,y);};/**
	* You can modify the size of the physics Body the Bullets use to be any dimension you need.
	* This allows you to make it smaller, or larger, than the parent Sprite.
	* You can also control the x and y offset of the Body. This is the position of the
	* Body relative to the top-left of the Sprite _texture_.
	*
	* For example: If you have a Sprite with a texture that is 80x100 in size,
	* and you want the physics body to be 32x32 pixels in the middle of the texture, you would do:
	*
	* `setSize(32, 32, 24, 34)`
	*
	* Where the first two parameters is the new Body size (32x32 pixels).
	* 24 is the horizontal offset of the Body from the top-left of the Sprites texture, and 34
	* is the vertical offset.
	*
	* @method Phaser.Weapon#setBulletBodyOffset
	* @param {number} width - The width of the Body.
	* @param {number} height - The height of the Body.
	* @param {number} [offsetX] - The X offset of the Body from the top-left of the Sprites texture.
	* @param {number} [offsetY] - The Y offset of the Body from the top-left of the Sprites texture.
	* @return {Phaser.Weapon} The Weapon Plugin.
	*/Phaser.Weapon.prototype.setBulletBodyOffset=function(width,height,offsetX,offsetY){if(offsetX===undefined){offsetX=0;}if(offsetY===undefined){offsetY=0;}this._data.customBody=true;this._data.width=width;this._data.height=height;this._data.offsetX=offsetX;this._data.offsetY=offsetY;//  Update all bullets in the pool
	this.bullets.callAll('body.setSize','body',width,height,offsetX,offsetY);this.bullets.setAll('data.bodyDirty',false);return this;};/**
	* Sets the texture frames that the bullets can use when being launched.
	*
	* This is intended for use when you've got numeric based frames, such as those loaded via a Sprite Sheet.
	*
	* It works by calling `Phaser.ArrayUtils.numberArray` internally, using the min and max values
	* provided. Then it sets the frame index to be zero.
	*
	* You can optionally set the cycle and random booleans, to allow bullets to cycle through the frames
	* when they're fired, or pick one at random.
	*
	* @method Phaser.Weapon#setBulletFrames
	* @param {integer} min - The minimum value the frame can be. Usually zero.
	* @param {integer} max - The maximum value the frame can be.
	* @param {boolean} [cycle=true] - Should the bullet frames cycle as they are fired?
	* @param {boolean} [random=false] - Should the bullet frames be picked at random as they are fired?
	* @return {Phaser.Weapon} The Weapon Plugin.
	*/Phaser.Weapon.prototype.setBulletFrames=function(min,max,cycle,random){if(cycle===undefined){cycle=true;}if(random===undefined){random=false;}this.bulletFrames=Phaser.ArrayUtils.numberArray(min,max);this.bulletFrameIndex=0;this.bulletFrameCycle=cycle;this.bulletFrameRandom=random;return this;};/**
	* Adds a new animation under the given key. Optionally set the frames, frame rate and loop.
	* The arguments are all the same as for `Animation.add`, and work in the same way.
	*
	* `Weapon.bulletAnimation` will be set to this animation after it's created. From that point on, all
	* bullets fired will play using this animation. You can swap between animations by calling this method
	* several times, and then just changing the `Weapon.bulletAnimation` property to the name of the animation
	* you wish to play for the next launched bullet.
	*
	* If you wish to stop using animations at all, set `Weapon.bulletAnimation` to '' (an empty string).
	*
	* @method Phaser.Weapon#addBulletAnimation
	* @param {string} name - The unique (within the Weapon instance) name for the animation, i.e. "fire", "blast".
	* @param {Array} [frames=null] - An array of numbers/strings that correspond to the frames to add to this animation and in which order. e.g. [1, 2, 3] or ['run0', 'run1', run2]). If null then all frames will be used.
	* @param {number} [frameRate=60] - The speed at which the animation should play. The speed is given in frames per second.
	* @param {boolean} [loop=false] - Whether or not the animation is looped or just plays once.
	* @param {boolean} [useNumericIndex=true] - Are the given frames using numeric indexes (default) or strings?
	* @return {Phaser.Weapon} The Weapon Plugin.
	*/Phaser.Weapon.prototype.addBulletAnimation=function(name,frames,frameRate,loop,useNumericIndex){this.anims[name]={name:name,frames:frames,frameRate:frameRate,loop:loop,useNumericIndex:useNumericIndex};//  Add the animation to any existing bullets in the pool
	this.bullets.callAll('animations.add','animations',name,frames,frameRate,loop,useNumericIndex);this.bulletAnimation=name;return this;};/**
	* Uses `Game.Debug` to draw some useful information about this Weapon, including the number of bullets
	* both in-flight, and available. And optionally the physics debug bodies of the bullets.
	*
	* @method Phaser.Weapon#debug
	* @param {integer} [x=16] - The coordinate, in screen space, at which to draw the Weapon debug data.
	* @param {integer} [y=32] - The coordinate, in screen space, at which to draw the Weapon debug data.
	* @param {boolean} [debugBodies=false] - Optionally draw the physics body of every bullet in-flight.
	*/Phaser.Weapon.prototype.debug=function(x,y,debugBodies){if(x===undefined){x=16;}if(y===undefined){y=32;}if(debugBodies===undefined){debugBodies=false;}this.game.debug.text("Weapon Plugin",x,y);this.game.debug.text("Bullets Alive: "+this.bullets.total+" - Total: "+this.bullets.length,x,y+24);if(debugBodies){this.bullets.forEachExists(this.game.debug.body,this.game.debug,'rgba(255, 0, 255, 0.8)');}};/**
	* The Class of the bullets that are launched by this Weapon. Defaults `Phaser.Bullet`, but can be
	* overridden before calling `createBullets` and set to your own class type.
	*
	* @name Phaser.Weapon#bulletClass
	* @property {Object} bulletClass
	*/Object.defineProperty(Phaser.Weapon.prototype,"bulletClass",{get:function get(){return this._bulletClass;},set:function set(classType){this._bulletClass=classType;this.bullets.classType=this._bulletClass;}});/**
	* This controls how the bullets will be killed. The default is `Phaser.Weapon.KILL_WORLD_BOUNDS`.
	*
	* There are 7 different "kill types" available:
	*
	* * `Phaser.Weapon.KILL_NEVER`
	* The bullets are never destroyed by the Weapon. It's up to you to destroy them via your own code.
	*
	* * `Phaser.Weapon.KILL_LIFESPAN`
	* The bullets are automatically killed when their `bulletLifespan` amount expires.
	*
	* * `Phaser.Weapon.KILL_DISTANCE`
	* The bullets are automatically killed when they exceed `bulletDistance` pixels away from their original launch position.
	*
	* * `Phaser.Weapon.KILL_WEAPON_BOUNDS`
	* The bullets are automatically killed when they no longer intersect with the `Weapon.bounds` rectangle.
	*
	* * `Phaser.Weapon.KILL_CAMERA_BOUNDS`
	* The bullets are automatically killed when they no longer intersect with the `Camera.bounds` rectangle.
	*
	* * `Phaser.Weapon.KILL_WORLD_BOUNDS`
	* The bullets are automatically killed when they no longer intersect with the `World.bounds` rectangle.
	*
	* * `Phaser.Weapon.KILL_STATIC_BOUNDS`
	* The bullets are automatically killed when they no longer intersect with the `Weapon.bounds` rectangle.
	* The difference between static bounds and weapon bounds, is that a static bounds will never be adjusted to
	* match the position of a tracked sprite or pointer.
	*
	* @name Phaser.Weapon#bulletKillType
	* @property {integer} bulletKillType
	*/Object.defineProperty(Phaser.Weapon.prototype,"bulletKillType",{get:function get(){return this._bulletKillType;},set:function set(type){switch(type){case Phaser.Weapon.KILL_STATIC_BOUNDS:case Phaser.Weapon.KILL_WEAPON_BOUNDS:this.bulletBounds=this.bounds;break;case Phaser.Weapon.KILL_CAMERA_BOUNDS:this.bulletBounds=this.game.camera.view;break;case Phaser.Weapon.KILL_WORLD_BOUNDS:this.bulletBounds=this.game.world.bounds;break;}this._bulletKillType=type;}});/**
	* Should bullets collide with the World bounds or not?
	*
	* @name Phaser.Weapon#bulletCollideWorldBounds
	* @property {boolean} bulletCollideWorldBounds
	*/Object.defineProperty(Phaser.Weapon.prototype,"bulletCollideWorldBounds",{get:function get(){return this._bulletCollideWorldBounds;},set:function set(value){this._bulletCollideWorldBounds=value;this.bullets.setAll('body.collideWorldBounds',value);this.bullets.setAll('data.bodyDirty',false);}});/**
	* The x coordinate from which bullets are fired. This is the same as `Weapon.fireFrom.x`, and
	* can be overridden by the `Weapon.fire` arguments.
	*
	* @name Phaser.Weapon#x
	* @property {number} x
	*/Object.defineProperty(Phaser.Weapon.prototype,"x",{get:function get(){return this.fireFrom.x;},set:function set(value){this.fireFrom.x=value;}});/**
	* The y coordinate from which bullets are fired. This is the same as `Weapon.fireFrom.y`, and
	* can be overridden by the `Weapon.fire` arguments.
	*
	* @name Phaser.Weapon#y
	* @property {number} y
	*/Object.defineProperty(Phaser.Weapon.prototype,"y",{get:function get(){return this.fireFrom.y;},set:function set(value){this.fireFrom.y=value;}});/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* Create a new `Bullet` object. Bullets are used by the `Phaser.Weapon` class, and are normal Sprites,
	* with a few extra properties in the data object to handle Weapon specific features.
	* 
	* @class Phaser.Bullet
	* @constructor
	* @extends Phaser.Sprite
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {number} x - The x coordinate (in world space) to position the Particle at.
	* @param {number} y - The y coordinate (in world space) to position the Particle at.
	* @param {string|Phaser.RenderTexture|Phaser.BitmapData|PIXI.Texture} key - This is the image or texture used by the Particle during rendering. It can be a string which is a reference to the Cache entry, or an instance of a RenderTexture or PIXI.Texture.
	* @param {string|number} frame - If this Particle is using part of a sprite sheet or texture atlas you can specify the exact frame to use by giving a string or numeric index.
	*/Phaser.Bullet=function(game,x,y,key,frame){Phaser.Sprite.call(this,game,x,y,key,frame);this.anchor.set(0.5);this.data={bulletManager:null,fromX:0,fromY:0,bodyDirty:true,rotateToVelocity:false,killType:0,killDistance:0};};Phaser.Bullet.prototype=Object.create(Phaser.Sprite.prototype);Phaser.Bullet.prototype.constructor=Phaser.Bullet;/**
	* Kills the Bullet, freeing it up for re-use by the Weapon bullet pool.
	* Also dispatches the `Weapon.onKill` signal.
	*
	* @method Phaser.Bullet#kill
	* @memberof Phaser.Bullet
	*/Phaser.Bullet.prototype.kill=function(){this.alive=false;this.exists=false;this.visible=false;this.data.bulletManager.onKill.dispatch(this);return this;};/**
	* Updates the Bullet, killing as required.
	*
	* @method Phaser.Bullet#kill
	* @memberof Phaser.Bullet
	*/Phaser.Bullet.prototype.update=function(){if(!this.exists){return;}if(this.data.killType>Phaser.Weapon.KILL_LIFESPAN){if(this.data.killType===Phaser.Weapon.KILL_DISTANCE){if(this.game.physics.arcade.distanceToXY(this,this.data.fromX,this.data.fromY,true)>this.data.killDistance){this.kill();}}else{if(!this.data.bulletManager.bulletBounds.intersects(this)){this.kill();}}}if(this.data.rotateToVelocity){this.rotation=Math.atan2(this.body.velocity.y,this.body.velocity.x);}if(this.data.bulletManager.bulletWorldWrap){this.game.world.wrap(this,this.data.bulletManager.bulletWorldWrapPadding);}};/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*//**
	* A Video object that takes a previously loaded Video from the Phaser Cache and handles playback of it.
	*
	* Alternatively it takes a getUserMedia feed from an active webcam and streams the contents of that to
	* the Video instead (see `startMediaStream` method)
	*
	* The video can then be applied to a Sprite as a texture. If multiple Sprites share the same Video texture and playback
	* changes (i.e. you pause the video, or seek to a new time) then this change will be seen across all Sprites simultaneously.
	*
	* Due to a bug in IE11 you cannot play a video texture to a Sprite in WebGL. For IE11 force Canvas mode.
	*
	* If you need each Sprite to be able to play a video fully independently then you will need one Video object per Sprite.
	* Please understand the obvious performance implications of doing this, and the memory required to hold videos in RAM.
	*
	* On some mobile browsers such as iOS Safari, you cannot play a video until the user has explicitly touched the screen.
	* This works in the same way as audio unlocking. Phaser will handle the touch unlocking for you, however unlike with audio
	* it's worth noting that every single Video needs to be touch unlocked, not just the first one. You can use the `changeSource`
	* method to try and work around this limitation, but see the method help for details.
	*
	* Small screen devices, especially iPod and iPhone will launch the video in its own native video player,
	* outside of the Safari browser. There is no way to avoid this, it's a device imposed limitation.
	*
	* Note: On iOS if you need to detect when the user presses the 'Done' button (before the video ends)
	* then you need to add your own event listener
	*
	* @class Phaser.Video
	* @constructor
	* @param {Phaser.Game} game - A reference to the currently running game.
	* @param {string|null} [key=null] - The key of the video file in the Phaser.Cache that this Video object will play. Set to `null` or leave undefined if you wish to use a webcam as the source. See `startMediaStream` to start webcam capture.
	* @param {string|null} [url=null] - If the video hasn't been loaded then you can provide a full URL to the file here (make sure to set key to null)
	*/Phaser.Video=function(game,key,url){if(key===undefined){key=null;}if(url===undefined){url=null;}/**
	    * @property {Phaser.Game} game - A reference to the currently running game.
	    */this.game=game;/**
	    * @property {string} key - The key of the Video in the Cache, if stored there. Will be `null` if this Video is using the webcam instead.
	    * @default null
	    */this.key=key;/**
	    * @property {number} width - The width of the video in pixels.
	    * @default
	    */this.width=0;/**
	    * @property {number} height - The height of the video in pixels.
	    * @default
	    */this.height=0;/**
	    * @property {number} type - The const type of this object.
	    * @default
	    */this.type=Phaser.VIDEO;/**
	    * @property {boolean} disableTextureUpload - If true this video will never send its image data to the GPU when its dirty flag is true. This only applies in WebGL.
	    */this.disableTextureUpload=false;/**
	    * @property {boolean} touchLocked - true if this video is currently locked awaiting a touch event. This happens on some mobile devices, such as iOS.
	    * @default
	    */this.touchLocked=false;/**
	    * @property {Phaser.Signal} onPlay - This signal is dispatched when the Video starts to play. It sends 3 parameters: a reference to the Video object, if the video is set to loop or not and the playback rate.
	    */this.onPlay=new Phaser.Signal();/**
	    * @property {Phaser.Signal} onChangeSource - This signal is dispatched if the Video source is changed. It sends 3 parameters: a reference to the Video object and the new width and height of the new video source.
	    */this.onChangeSource=new Phaser.Signal();/**
	    * @property {Phaser.Signal} onComplete - This signal is dispatched when the Video completes playback, i.e. enters an 'ended' state. On iOS specifically it also fires if the user hits the 'Done' button at any point during playback. Videos set to loop will never dispatch this signal.
	    */this.onComplete=new Phaser.Signal();/**
	    * @property {Phaser.Signal} onAccess - This signal is dispatched if the user allows access to their webcam.
	    */this.onAccess=new Phaser.Signal();/**
	    * @property {Phaser.Signal} onError - This signal is dispatched if an error occurs either getting permission to use the webcam (for a Video Stream) or when trying to play back a video file.
	    */this.onError=new Phaser.Signal();/**
	    * This signal is dispatched if when asking for permission to use the webcam no response is given within a the Video.timeout limit.
	    * This may be because the user has picked `Not now` in the permissions window, or there is a delay in establishing the LocalMediaStream.
	    * @property {Phaser.Signal} onTimeout
	    */this.onTimeout=new Phaser.Signal();/**
	    * @property {integer} timeout - The amount of ms allowed to elapsed before the Video.onTimeout signal is dispatched while waiting for webcam access.
	    * @default
	    */this.timeout=15000;/**
	    * @property {integer} _timeOutID - setTimeout ID.
	    * @private
	    */this._timeOutID=null;/**
	    * @property {HTMLVideoElement} video - The HTML Video Element that is added to the document.
	    */this.video=null;/**
	    * @property {MediaStream} videoStream - The Video Stream data. Only set if this Video is streaming from the webcam via `startMediaStream`.
	    */this.videoStream=null;/**
	    * @property {boolean} isStreaming - Is there a streaming video source? I.e. from a webcam.
	    */this.isStreaming=false;/**
	    * When starting playback of a video Phaser will monitor its readyState using a setTimeout call.
	    * The setTimeout happens once every `Video.retryInterval` ms. It will carry on monitoring the video
	    * state in this manner until the `retryLimit` is reached and then abort.
	    * @property {integer} retryLimit
	    * @default
	    */this.retryLimit=20;/**
	    * @property {integer} retry - The current retry attempt.
	    * @default
	    */this.retry=0;/**
	    * @property {integer} retryInterval - The number of ms between each retry at monitoring the status of a downloading video.
	    * @default
	    */this.retryInterval=500;/**
	    * @property {integer} _retryID - The callback ID of the retry setTimeout.
	    * @private
	    */this._retryID=null;/**
	    * @property {boolean} _codeMuted - Internal mute tracking var.
	    * @private
	    * @default
	    */this._codeMuted=false;/**
	    * @property {boolean} _muted - Internal mute tracking var.
	    * @private
	    * @default
	    */this._muted=false;/**
	    * @property {boolean} _codePaused - Internal paused tracking var.
	    * @private
	    * @default
	    */this._codePaused=false;/**
	    * @property {boolean} _paused - Internal paused tracking var.
	    * @private
	    * @default
	    */this._paused=false;/**
	    * @property {boolean} _pending - Internal var tracking play pending.
	    * @private
	    * @default
	    */this._pending=false;/**
	    * @property {boolean} _autoplay - Internal var tracking autoplay when changing source.
	    * @private
	    * @default
	    */this._autoplay=false;/**
	    * @property {function} _endCallback - The addEventListener ended function.
	    * @private
	    */this._endCallback=null;/**
	    * @property {function} _playCallback - The addEventListener playing function.
	    * @private
	    */this._playCallback=null;if(key&&this.game.cache.checkVideoKey(key)){var _video=this.game.cache.getVideo(key);if(_video.isBlob){this.createVideoFromBlob(_video.data);}else{this.video=_video.data;}this.width=this.video.videoWidth;this.height=this.video.videoHeight;}else if(url){this.createVideoFromURL(url,false);}/**
	    * @property {PIXI.BaseTexture} baseTexture - The PIXI.BaseTexture.
	    * @default
	    */if(this.video&&!url){this.baseTexture=new PIXI.BaseTexture(this.video);this.baseTexture.forceLoaded(this.width,this.height);}else{this.baseTexture=new PIXI.BaseTexture(Phaser.Cache.DEFAULT.baseTexture.source);this.baseTexture.forceLoaded(this.width,this.height);}/**
	    * @property {PIXI.Texture} texture - The PIXI.Texture.
	    * @default
	    */this.texture=new PIXI.Texture(this.baseTexture);/**
	    * @property {Phaser.Frame} textureFrame - The Frame this video uses for rendering.
	    * @default
	    */this.textureFrame=new Phaser.Frame(0,0,0,this.width,this.height,'video');this.texture.setFrame(this.textureFrame);this.texture.valid=false;if(key!==null&&this.video){this.texture.valid=this.video.canplay;}/**
	    * A snapshot grabbed from the video. This is initially black. Populate it by calling Video.grab().
	    * When called the BitmapData is updated with a grab taken from the current video playing or active video stream.
	    * If Phaser has been compiled without BitmapData support this property will always be `null`.
	    *
	    * @property {Phaser.BitmapData} snapshot
	    * @readOnly
	    */this.snapshot=null;if(Phaser.BitmapData){this.snapshot=new Phaser.BitmapData(this.game,'',this.width,this.height);}if(!this.game.device.cocoonJS&&(this.game.device.iOS||this.game.device.android)||window['PhaserGlobal']&&window['PhaserGlobal'].fakeiOSTouchLock){this.setTouchLock();}else{if(_video){_video.locked=false;}}};Phaser.Video.prototype={/**
	     * Connects to an external media stream for the webcam, rather than using a local one.
	     *
	     * @method Phaser.Video#connectToMediaStream
	     * @param {HTMLVideoElement} video - The HTML Video Element that the stream uses.
	     * @param {MediaStream} stream - The Video Stream data.
	     * @return {Phaser.Video} This Video object for method chaining.
	     */connectToMediaStream:function connectToMediaStream(video,stream){if(video&&stream){this.video=video;this.videoStream=stream;this.isStreaming=true;this.baseTexture.source=this.video;this.updateTexture(null,this.video.videoWidth,this.video.videoHeight);this.onAccess.dispatch(this);}return this;},/**
	     * Instead of playing a video file this method allows you to stream video data from an attached webcam.
	     *
	     * As soon as this method is called the user will be prompted by their browser to "Allow" access to the webcam.
	     * If they allow it the webcam feed is directed to this Video. Call `Video.play` to start the stream.
	     *
	     * If they block the webcam the onError signal will be dispatched containing the NavigatorUserMediaError
	     * or MediaStreamError event.
	     *
	     * You can optionally set a width and height for the stream. If set the input will be cropped to these dimensions.
	     * If not given then as soon as the stream has enough data the video dimensions will be changed to match the webcam device.
	     * You can listen for this with the onChangeSource signal.
	     *
	     * @method Phaser.Video#startMediaStream
	     * @param {boolean} [captureAudio=false] - Controls if audio should be captured along with video in the video stream.
	     * @param {integer} [width] - The width is used to create the video stream. If not provided the video width will be set to the width of the webcam input source.
	     * @param {integer} [height] - The height is used to create the video stream. If not provided the video height will be set to the height of the webcam input source.
	     * @return {Phaser.Video} This Video object for method chaining or false if the device doesn't support getUserMedia.
	     */startMediaStream:function startMediaStream(captureAudio,width,height){if(captureAudio===undefined){captureAudio=false;}if(width===undefined){width=null;}if(height===undefined){height=null;}if(!this.game.device.getUserMedia){this.onError.dispatch(this,'No getUserMedia');return false;}if(this.videoStream!==null){if(this.videoStream['active']){this.videoStream.active=false;}else{this.videoStream.stop();}}this.removeVideoElement();this.video=document.createElement("video");this.video.setAttribute('autoplay','autoplay');if(width!==null){this.video.width=width;}if(height!==null){this.video.height=height;}//  Request access to the webcam
	this._timeOutID=window.setTimeout(this.getUserMediaTimeout.bind(this),this.timeout);try{navigator.getUserMedia({"audio":captureAudio,"video":true},this.getUserMediaSuccess.bind(this),this.getUserMediaError.bind(this));}catch(error){this.getUserMediaError(error);}return this;},/**
	     * @method Phaser.Video#getUserMediaTimeout
	     * @private
	     */getUserMediaTimeout:function getUserMediaTimeout(){clearTimeout(this._timeOutID);this.onTimeout.dispatch(this);},/**
	     * @method Phaser.Video#getUserMediaError
	     * @private
	     */getUserMediaError:function getUserMediaError(event){clearTimeout(this._timeOutID);this.onError.dispatch(this,event);},/**
	     * @method Phaser.Video#getUserMediaSuccess
	     * @private
	     */getUserMediaSuccess:function getUserMediaSuccess(stream){clearTimeout(this._timeOutID);// Attach the stream to the video
	this.videoStream=stream;// Set the source of the video element with the stream from the camera
	if(this.video.mozSrcObject!==undefined){this.video.mozSrcObject=stream;}else{this.video.src=window.URL&&window.URL.createObjectURL(stream)||stream;}var self=this;this.video.onloadeddata=function(){var retry=10;function checkStream(){if(retry>0){if(self.video.videoWidth>0){// Patch for Firefox bug where the height can't be read from the video
	var width=self.video.videoWidth;var height=self.video.videoHeight;if(isNaN(self.video.videoHeight)){height=width/(4/3);}self.video.play();self.isStreaming=true;self.baseTexture.source=self.video;self.updateTexture(null,width,height);self.onAccess.dispatch(self);}else{window.setTimeout(checkStream,500);}}else{console.warn('Unable to connect to video stream. Webcam error?');}retry--;}checkStream();};},/**
	     * Creates a new Video element from the given Blob. The Blob must contain the video data in the correct encoded format.
	     * This method is typically called by the Phaser.Loader and Phaser.Cache for you, but is exposed publicly for convenience.
	     *
	     * @method Phaser.Video#createVideoFromBlob
	     * @param {Blob} blob - The Blob containing the video data: `Blob([new Uint8Array(data)])`
	     * @return {Phaser.Video} This Video object for method chaining.
	     */createVideoFromBlob:function createVideoFromBlob(blob){var _this=this;this.video=document.createElement("video");this.video.controls=false;this.video.setAttribute('autoplay','autoplay');this.video.addEventListener('loadeddata',function(event){_this.updateTexture(event);},true);this.video.src=window.URL.createObjectURL(blob);this.video.canplay=true;return this;},/**
	     * Creates a new Video element from the given URL.
	     *
	     * @method Phaser.Video#createVideoFromURL
	     * @param {string} url - The URL of the video.
	     * @param {boolean} [autoplay=false] - Automatically start the video?
	     * @return {Phaser.Video} This Video object for method chaining.
	     */createVideoFromURL:function createVideoFromURL(url,autoplay){if(autoplay===undefined){autoplay=false;}//  Invalidate the texture while we wait for the new one to load (crashes IE11 otherwise)
	if(this.texture){this.texture.valid=false;}this.video=document.createElement("video");this.video.controls=false;if(autoplay){this.video.setAttribute('autoplay','autoplay');}this.video.src=url;this.video.canplay=true;this.video.load();this.retry=this.retryLimit;this._retryID=window.setTimeout(this.checkVideoProgress.bind(this),this.retryInterval);this.key=url;return this;},/**
	     * Called automatically if the video source changes and updates the internal texture dimensions.
	     * Then dispatches the onChangeSource signal.
	     *
	     * @method Phaser.Video#updateTexture
	     * @param {object} [event] - The event which triggered the texture update.
	     * @param {integer} [width] - The new width of the video. If undefined `video.videoWidth` is used.
	     * @param {integer} [height] - The new height of the video. If undefined `video.videoHeight` is used.
	     */updateTexture:function updateTexture(event,width,height){var change=false;if(width===undefined||width===null){width=this.video.videoWidth;change=true;}if(height===undefined||height===null){height=this.video.videoHeight;}this.width=width;this.height=height;if(this.baseTexture.source!==this.video){this.baseTexture.source=this.video;}this.baseTexture.forceLoaded(width,height);this.texture.frame.resize(width,height);this.texture.width=width;this.texture.height=height;this.texture.valid=true;if(this.snapshot){this.snapshot.resize(width,height);}if(change&&this.key!==null){this.onChangeSource.dispatch(this,width,height);if(this._autoplay){this.video.play();this.onPlay.dispatch(this,this.loop,this.playbackRate);}}},/**
	     * Called when the video completes playback (reaches and ended state).
	     * Dispatches the Video.onComplete signal.
	     *
	     * @method Phaser.Video#complete
	     */complete:function complete(){this.onComplete.dispatch(this);},/**
	     * Starts this video playing if it's not already doing so.
	     *
	     * @method Phaser.Video#play
	     * @param {boolean} [loop=false] - Should the video loop automatically when it reaches the end? Please note that at present some browsers (i.e. Chrome) do not support *seamless* video looping.
	     * @param {number} [playbackRate=1] - The playback rate of the video. 1 is normal speed, 2 is x2 speed, and so on. You cannot set a negative playback rate.
	     * @return {Phaser.Video} This Video object for method chaining.
	     */play:function play(loop,playbackRate){if(loop===undefined){loop=false;}if(playbackRate===undefined){playbackRate=1;}if(this.game.sound.onMute){this.game.sound.onMute.add(this.setMute,this);this.game.sound.onUnMute.add(this.unsetMute,this);if(this.game.sound.mute){this.setMute();}}this.game.onPause.add(this.setPause,this);this.game.onResume.add(this.setResume,this);this._endCallback=this.complete.bind(this);this.video.addEventListener('ended',this._endCallback,true);this.video.addEventListener('webkitendfullscreen',this._endCallback,true);if(loop){this.video.loop='loop';}else{this.video.loop='';}this.video.playbackRate=playbackRate;if(this.touchLocked){this._pending=true;}else{this._pending=false;if(this.key!==null){if(this.video.readyState!==4){this.retry=this.retryLimit;this._retryID=window.setTimeout(this.checkVideoProgress.bind(this),this.retryInterval);}else{this._playCallback=this.playHandler.bind(this);this.video.addEventListener('playing',this._playCallback,true);}}this.video.play();this.onPlay.dispatch(this,loop,playbackRate);}return this;},/**
	     * Called when the video starts to play. Updates the texture.
	     *
	     * @method Phaser.Video#playHandler
	     * @private
	     */playHandler:function playHandler(){this.video.removeEventListener('playing',this._playCallback,true);this.updateTexture();},/**
	     * Stops the video playing.
	     *
	     * This removes all locally set signals.
	     *
	     * If you only wish to pause playback of the video, to resume at a later time, use `Video.paused = true` instead.
	     * If the video hasn't finished downloading calling `Video.stop` will not abort the download. To do that you need to
	     * call `Video.destroy` instead.
	     *
	     * If you are using a video stream from a webcam then calling Stop will disconnect the MediaStream session and disable the webcam.
	     *
	     * @method Phaser.Video#stop
	     * @return {Phaser.Video} This Video object for method chaining.
	     */stop:function stop(){if(this.game.sound.onMute){this.game.sound.onMute.remove(this.setMute,this);this.game.sound.onUnMute.remove(this.unsetMute,this);}this.game.onPause.remove(this.setPause,this);this.game.onResume.remove(this.setResume,this);//  Stream or file?
	if(this.isStreaming){if(this.video.mozSrcObject){this.video.mozSrcObject.stop();this.video.src=null;}else{this.video.src="";if(this.videoStream['active']){this.videoStream.active=false;}else{if(this.videoStream.getTracks){this.videoStream.getTracks().forEach(function(track){track.stop();});}else{this.videoStream.stop();}}}this.videoStream=null;this.isStreaming=false;}else{this.video.removeEventListener('ended',this._endCallback,true);this.video.removeEventListener('webkitendfullscreen',this._endCallback,true);this.video.removeEventListener('playing',this._playCallback,true);if(this.touchLocked){this._pending=false;}else{this.video.pause();}}return this;},/**
	    * Updates the given Display Objects so they use this Video as their texture.
	    * This will replace any texture they will currently have set.
	    *
	    * @method Phaser.Video#add
	    * @param {Phaser.Sprite|Phaser.Sprite[]|Phaser.Image|Phaser.Image[]} object - Either a single Sprite/Image or an Array of Sprites/Images.
	    * @return {Phaser.Video} This Video object for method chaining.
	    */add:function add(object){if(Array.isArray(object)){for(var i=0;i<object.length;i++){if(object[i]['loadTexture']){object[i].loadTexture(this);}}}else{object.loadTexture(this);}return this;},/**
	    * Creates a new Phaser.Image object, assigns this Video to be its texture, adds it to the world then returns it.
	    *
	    * @method Phaser.Video#addToWorld
	    * @param {number} [x=0] - The x coordinate to place the Image at.
	    * @param {number} [y=0] - The y coordinate to place the Image at.
	    * @param {number} [anchorX=0] - Set the x anchor point of the Image. A value between 0 and 1, where 0 is the top-left and 1 is bottom-right.
	    * @param {number} [anchorY=0] - Set the y anchor point of the Image. A value between 0 and 1, where 0 is the top-left and 1 is bottom-right.
	    * @param {number} [scaleX=1] - The horizontal scale factor of the Image. A value of 1 means no scaling. 2 would be twice the size, and so on.
	    * @param {number} [scaleY=1] - The vertical scale factor of the Image. A value of 1 means no scaling. 2 would be twice the size, and so on.
	    * @return {Phaser.Image} The newly added Image object.
	    */addToWorld:function addToWorld(x,y,anchorX,anchorY,scaleX,scaleY){scaleX=scaleX||1;scaleY=scaleY||1;var image=this.game.add.image(x,y,this);image.anchor.set(anchorX,anchorY);image.scale.set(scaleX,scaleY);return image;},/**
	    * If the game is running in WebGL this will push the texture up to the GPU if it's dirty.
	    * This is called automatically if the Video is being used by a Sprite, otherwise you need to remember to call it in your render function.
	    * If you wish to suppress this functionality set Video.disableTextureUpload to `true`.
	    *
	    * @method Phaser.Video#render
	    */render:function render(){if(!this.disableTextureUpload&&this.playing){this.baseTexture.dirty();}},/**
	    * Internal handler called automatically by the Video.mute setter.
	    *
	    * @method Phaser.Video#setMute
	    * @private
	    */setMute:function setMute(){if(this._muted){return;}this._muted=true;this.video.muted=true;},/**
	    * Internal handler called automatically by the Video.mute setter.
	    *
	    * @method Phaser.Video#unsetMute
	    * @private
	    */unsetMute:function unsetMute(){if(!this._muted||this._codeMuted){return;}this._muted=false;this.video.muted=false;},/**
	    * Internal handler called automatically by the Video.paused setter.
	    *
	    * @method Phaser.Video#setPause
	    * @private
	    */setPause:function setPause(){if(this._paused||this.touchLocked){return;}this._paused=true;this.video.pause();},/**
	    * Internal handler called automatically by the Video.paused setter.
	    *
	    * @method Phaser.Video#setResume
	    * @private
	    */setResume:function setResume(){if(!this._paused||this._codePaused||this.touchLocked){return;}this._paused=false;if(!this.video.ended){this.video.play();}},/**
	     * On some mobile browsers you cannot play a video until the user has explicitly touched the video to allow it.
	     * Phaser handles this via the `setTouchLock` method. However if you have 3 different videos, maybe an "Intro", "Start" and "Game Over"
	     * split into three different Video objects, then you will need the user to touch-unlock every single one of them.
	     *
	     * You can avoid this by using just one Video object and simply changing the video source. Once a Video element is unlocked it remains
	     * unlocked, even if the source changes. So you can use this to your benefit to avoid forcing the user to 'touch' the video yet again.
	     *
	     * As you'd expect there are limitations. So far we've found that the videos need to be in the same encoding format and bitrate.
	     * This method will automatically handle a change in video dimensions, but if you try swapping to a different bitrate we've found it
	     * cannot render the new video on iOS (desktop browsers cope better).
	     *
	     * When the video source is changed the video file is requested over the network. Listen for the `onChangeSource` signal to know
	     * when the new video has downloaded enough content to be able to be played. Previous settings such as the volume and loop state
	     * are adopted automatically by the new video.
	     *
	     * @method Phaser.Video#changeSource
	     * @param {string} src - The new URL to change the video.src to.
	     * @param {boolean} [autoplay=true] - Should the video play automatically after the source has been updated?
	     * @return {Phaser.Video} This Video object for method chaining.
	     */changeSource:function changeSource(src,autoplay){if(autoplay===undefined){autoplay=true;}//  Invalidate the texture while we wait for the new one to load (crashes IE11 otherwise)
	this.texture.valid=false;this.video.pause();this.retry=this.retryLimit;this._retryID=window.setTimeout(this.checkVideoProgress.bind(this),this.retryInterval);this.video.src=src;this.video.load();this._autoplay=autoplay;if(!autoplay){this.paused=true;}return this;},/**
	    * Internal callback that monitors the download progress of a video after changing its source.
	    *
	    * @method Phaser.Video#checkVideoProgress
	    * @private
	    */checkVideoProgress:function checkVideoProgress(){// if (this.video.readyState === 2 || this.video.readyState === 4)
	if(this.video.readyState===4){//  We've got enough data to update the texture for playback
	this.updateTexture();}else{this.retry--;if(this.retry>0){this._retryID=window.setTimeout(this.checkVideoProgress.bind(this),this.retryInterval);}else{console.warn('Phaser.Video: Unable to start downloading video in time',this.isStreaming);}}},/**
	    * Sets the Input Manager touch callback to be Video.unlock.
	    * Required for mobile video unlocking. Mostly just used internally.
	    *
	    * @method Phaser.Video#setTouchLock
	    */setTouchLock:function setTouchLock(){this.game.input.touch.addTouchLockCallback(this.unlock,this);this.touchLocked=true;},/**
	    * Enables the video on mobile devices, usually after the first touch.
	    * If the SoundManager hasn't been unlocked then this will automatically unlock that as well.
	    * Only one video can be pending unlock at any one time.
	    *
	    * @method Phaser.Video#unlock
	    */unlock:function unlock(){this.touchLocked=false;this.video.play();this.onPlay.dispatch(this,this.loop,this.playbackRate);if(this.key){var _video=this.game.cache.getVideo(this.key);if(_video&&!_video.isBlob){_video.locked=false;}}return true;},/**
	     * Grabs the current frame from the Video or Video Stream and renders it to the Video.snapshot BitmapData.
	     *
	     * You can optionally set if the BitmapData should be cleared or not, the alpha and the blend mode of the draw.
	     *
	     * If you need more advanced control over the grabbing them call `Video.snapshot.copy` directly with the same parameters as BitmapData.copy.
	     *
	     * @method Phaser.Video#grab
	     * @param {boolean} [clear=false] - Should the BitmapData be cleared before the Video is grabbed? Unless you are using alpha or a blend mode you can usually leave this set to false.
	     * @param {number} [alpha=1] - The alpha that will be set on the video before drawing. A value between 0 (fully transparent) and 1, opaque.
	     * @param {string} [blendMode=null] - The composite blend mode that will be used when drawing. The default is no blend mode at all. This is a Canvas globalCompositeOperation value such as 'lighter' or 'xor'.
	     * @return {Phaser.BitmapData} A reference to the Video.snapshot BitmapData object for further method chaining.
	     */grab:function grab(clear,alpha,blendMode){if(clear===undefined){clear=false;}if(alpha===undefined){alpha=1;}if(blendMode===undefined){blendMode=null;}if(this.snapshot===null){console.warn('Video.grab cannot run because Phaser.BitmapData is unavailable');return;}if(clear){this.snapshot.cls();}this.snapshot.copy(this.video,0,0,this.width,this.height,0,0,this.width,this.height,0,0,0,1,1,alpha,blendMode);return this.snapshot;},/**
	     * Removes the Video element from the DOM by calling parentNode.removeChild on itself.
	     * Also removes the autoplay and src attributes and nulls the reference.
	     *
	     * @method Phaser.Video#removeVideoElement
	     */removeVideoElement:function removeVideoElement(){if(!this.video){return;}if(this.video.parentNode){this.video.parentNode.removeChild(this.video);}while(this.video.hasChildNodes()){this.video.removeChild(this.video.firstChild);}this.video.removeAttribute('autoplay');this.video.removeAttribute('src');this.video=null;},/**
	     * Destroys the Video object. This calls `Video.stop` and then `Video.removeVideoElement`.
	     * If any Sprites are using this Video as their texture it is up to you to manage those.
	     *
	     * @method Phaser.Video#destroy
	     */destroy:function destroy(){this.stop();this.removeVideoElement();if(this.touchLocked){this.game.input.touch.removeTouchLockCallback(this.unlock,this);}if(this._retryID){window.clearTimeout(this._retryID);}}};/**
	* @name Phaser.Video#currentTime
	* @property {number} currentTime - The current time of the video in seconds. If set the video will attempt to seek to that point in time.
	*/Object.defineProperty(Phaser.Video.prototype,"currentTime",{get:function get(){return this.video?this.video.currentTime:0;},set:function set(value){this.video.currentTime=value;}});/**
	* @name Phaser.Video#duration
	* @property {number} duration - The duration of the video in seconds.
	* @readOnly
	*/Object.defineProperty(Phaser.Video.prototype,"duration",{get:function get(){return this.video?this.video.duration:0;}});/**
	* @name Phaser.Video#progress
	* @property {number} progress - The progress of this video. This is a value between 0 and 1, where 0 is the start and 1 is the end of the video.
	* @readOnly
	*/Object.defineProperty(Phaser.Video.prototype,"progress",{get:function get(){return this.video?this.video.currentTime/this.video.duration:0;}});/**
	* @name Phaser.Video#mute
	* @property {boolean} mute - Gets or sets the muted state of the Video.
	*/Object.defineProperty(Phaser.Video.prototype,"mute",{get:function get(){return this._muted;},set:function set(value){value=value||null;if(value){if(this._muted){return;}this._codeMuted=true;this.setMute();}else{if(!this._muted){return;}this._codeMuted=false;this.unsetMute();}}});/**
	* Gets or sets the paused state of the Video.
	* If the video is still touch locked (such as on iOS devices) this call has no effect.
	*
	* @name Phaser.Video#paused
	* @property {boolean} paused
	*/Object.defineProperty(Phaser.Video.prototype,"paused",{get:function get(){return this._paused;},set:function set(value){value=value||null;if(this.touchLocked){return;}if(value){if(this._paused){return;}this._codePaused=true;this.setPause();}else{if(!this._paused){return;}this._codePaused=false;this.setResume();}}});/**
	* @name Phaser.Video#volume
	* @property {number} volume - Gets or sets the volume of the Video, a value between 0 and 1. The value given is clamped to the range 0 to 1.
	*/Object.defineProperty(Phaser.Video.prototype,"volume",{get:function get(){return this.video?this.video.volume:1;},set:function set(value){if(value<0){value=0;}else if(value>1){value=1;}if(this.video){this.video.volume=value;}}});/**
	* @name Phaser.Video#playbackRate
	* @property {number} playbackRate - Gets or sets the playback rate of the Video. This is the speed at which the video is playing.
	*/Object.defineProperty(Phaser.Video.prototype,"playbackRate",{get:function get(){return this.video?this.video.playbackRate:1;},set:function set(value){if(this.video){this.video.playbackRate=value;}}});/**
	* Gets or sets if the Video is set to loop.
	* Please note that at present some browsers (i.e. Chrome) do not support *seamless* video looping.
	* If the video isn't yet set this will always return false.
	*
	* @name Phaser.Video#loop
	* @property {boolean} loop
	*/Object.defineProperty(Phaser.Video.prototype,"loop",{get:function get(){return this.video?this.video.loop:false;},set:function set(value){if(value&&this.video){this.video.loop='loop';}else if(this.video){this.video.loop='';}}});/**
	* @name Phaser.Video#playing
	* @property {boolean} playing - True if the video is currently playing (and not paused or ended), otherwise false.
	* @readOnly
	*/Object.defineProperty(Phaser.Video.prototype,"playing",{get:function get(){return!(this.video.paused&&this.video.ended);}});Phaser.Video.prototype.constructor=Phaser.Video;/* global Phaser:true *//**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*///  Pixi expects these globals to exist
	if(PIXI.blendModes===undefined){PIXI.blendModes=Phaser.blendModes;}if(PIXI.scaleModes===undefined){PIXI.scaleModes=Phaser.scaleModes;}if(PIXI.Texture.emptyTexture===undefined){PIXI.Texture.emptyTexture=new PIXI.Texture(new PIXI.BaseTexture());}if(PIXI.DisplayObject._tempMatrix===undefined){PIXI.DisplayObject._tempMatrix=new PIXI.Matrix();}if(PIXI.RenderTexture.tempMatrix===undefined){PIXI.RenderTexture.tempMatrix=new PIXI.Matrix();}if(PIXI.Graphics&&PIXI.Graphics.POLY===undefined){PIXI.Graphics.POLY=Phaser.POLYGON;PIXI.Graphics.RECT=Phaser.RECTANGLE;PIXI.Graphics.CIRC=Phaser.CIRCLE;PIXI.Graphics.ELIP=Phaser.ELLIPSE;PIXI.Graphics.RREC=Phaser.ROUNDEDRECTANGLE;}PIXI.TextureSilentFail=true;/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*/if(true){if(typeof module!=='undefined'&&module.exports){exports=module.exports=Phaser;}exports.Phaser=Phaser;}else if(typeof define!=='undefined'&&define.amd){define('Phaser',function(){return root.Phaser=Phaser;}());}else{root.Phaser=Phaser;}return Phaser;}).call(undefined);/*
	* "What matters in this life is not what we do but what we do for others, the legacy we leave and the imprint we make." - Eric Meyer
	*/
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(358)))

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2016 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	*
	* @overview
	*
	* Phaser - http://phaser.io
	*
	* v2.6.2 "Kore Springs" - Built: Fri Aug 26 2016 01:03:18
	*
	* By Richard Davey http://www.photonstorm.com @photonstorm
	*
	* Phaser is a fun, free and fast 2D game framework for making HTML5 games
	* for desktop and mobile web browsers, supporting Canvas and WebGL rendering.
	*
	* Phaser uses Pixi.js for rendering, created by Mat Groves http://matgroves.com @Doormat23
	* Phaser uses p2.js for full-body physics, created by Stefan Hedman https://github.com/schteppe/p2.js @schteppe
	* Phaser contains a port of N+ Physics, converted by Richard Davey, original by http://www.metanetsoftware.com
	*
	* Many thanks to Adam Saltsman (@ADAMATOMIC) for releasing Flixel, from which both Phaser and my love of framework development originate.
	*
	* Follow development at http://phaser.io and on our forum
	*
	* "If you want your children to be intelligent,  read them fairy tales."
	* "If you want them to be more intelligent, read them more fairy tales."
	*                                                     -- Albert Einstein
	*/
	
	/**
	 * @author Mat Groves http://matgroves.com/ @Doormat23
	 */
	
	(function () {
	
	    var root = this;
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	     * The [pixi.js](http://www.pixijs.com/) module/namespace.
	     *
	     * @module PIXI
	     */
	
	    /**
	     * Namespace-class for [pixi.js](http://www.pixijs.com/).
	     *
	     * Contains assorted static properties and enumerations.
	     *
	     * @class PIXI
	     * @static
	     */
	    var PIXI = PIXI || {};
	
	    /**
	     * A reference to the Phaser Game instance that owns this Pixi renderer.
	     * @property {Phaser.Game} game
	     * @static 
	     */
	    PIXI.game = null;
	
	    /**
	     * @property {Number} WEBGL_RENDERER
	     * @protected
	     * @static 
	     */
	    PIXI.WEBGL_RENDERER = 0;
	
	    /**
	     * @property {Number} CANVAS_RENDERER
	     * @protected
	     * @static
	     */
	    PIXI.CANVAS_RENDERER = 1;
	
	    /**
	     * Version of pixi that is loaded.
	     * @property {String} VERSION
	     * @static 
	     */
	    PIXI.VERSION = "v2.2.9";
	
	    // used to create uids for various pixi objects.
	    PIXI._UID = 0;
	
	    if (typeof Float32Array != 'undefined') {
	        PIXI.Float32Array = Float32Array;
	        PIXI.Uint16Array = Uint16Array;
	
	        // Uint32Array and ArrayBuffer only used by WebGL renderer
	        // We can suppose that if WebGL is supported then typed arrays are supported too
	        // as they predate WebGL support for all browsers:
	        // see typed arrays support: http://caniuse.com/#search=TypedArrays
	        // see WebGL support: http://caniuse.com/#search=WebGL
	        PIXI.Uint32Array = Uint32Array;
	        PIXI.ArrayBuffer = ArrayBuffer;
	    } else {
	        PIXI.Float32Array = Array;
	        PIXI.Uint16Array = Array;
	    }
	
	    /**
	     * @property {Number} PI_2
	     * @static
	     */
	    PIXI.PI_2 = Math.PI * 2;
	
	    /**
	     * @property {Number} RAD_TO_DEG
	     * @static
	     */
	    PIXI.RAD_TO_DEG = 180 / Math.PI;
	
	    /**
	     * @property {Number} DEG_TO_RAD
	     * @static
	     */
	    PIXI.DEG_TO_RAD = Math.PI / 180;
	
	    /**
	     * @property {String} RETINA_PREFIX
	     * @protected
	     * @static
	     */
	    PIXI.RETINA_PREFIX = "@2x";
	
	    /**
	     * The default render options if none are supplied to
	     * {{#crossLink "WebGLRenderer"}}{{/crossLink}} or {{#crossLink "CanvasRenderer"}}{{/crossLink}}.
	     *
	     * @property {Object} defaultRenderOptions
	     * @property {Object} defaultRenderOptions.view=null
	     * @property {Boolean} defaultRenderOptions.transparent=false
	     * @property {Boolean} defaultRenderOptions.antialias=false
	     * @property {Boolean} defaultRenderOptions.preserveDrawingBuffer=false
	     * @property {Number} defaultRenderOptions.resolution=1
	     * @property {Boolean} defaultRenderOptions.clearBeforeRender=true
	     * @property {Boolean} defaultRenderOptions.autoResize=false
	     * @static
	    PIXI.defaultRenderOptions = {
	        view: null,
	        transparent: false,
	        antialias: false, 
	        preserveDrawingBuffer: false,
	        resolution: 1,
	        clearBeforeRender: true,
	        autoResize: false
	    };
	     */
	
	    /**
	    * @author       Mat Groves http://matgroves.com @Doormat23
	    * @author       Richard Davey <rich@photonstorm.com>
	    * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	    */
	
	    /**
	    * The base class for all objects that are rendered. Contains properties for position, scaling,
	    * rotation, masks and cache handling.
	    * 
	    * This is an abstract class and should not be used on its own, rather it should be extended.
	    *
	    * It is used internally by the likes of PIXI.Sprite.
	    *
	    * @class PIXI.DisplayObject
	    * @constructor
	    */
	    PIXI.DisplayObject = function () {
	
	        /**
	        * The coordinates, in pixels, of this DisplayObject, relative to its parent container.
	        * 
	        * The value of this property does not reflect any positioning happening further up the display list.
	        * To obtain that value please see the `worldPosition` property.
	        * 
	        * @property {PIXI.Point} position
	        * @default
	        */
	        this.position = new PIXI.Point(0, 0);
	
	        /**
	        * The scale of this DisplayObject. A scale of 1:1 represents the DisplayObject
	        * at its default size. A value of 0.5 would scale this DisplayObject by half, and so on.
	        * 
	        * The value of this property does not reflect any scaling happening further up the display list.
	        * To obtain that value please see the `worldScale` property.
	        * 
	        * @property {PIXI.Point} scale
	        * @default
	        */
	        this.scale = new PIXI.Point(1, 1);
	
	        /**
	        * The pivot point of this DisplayObject that it rotates around. The values are expressed
	        * in pixel values.
	        * @property {PIXI.Point} pivot
	        * @default
	        */
	        this.pivot = new PIXI.Point(0, 0);
	
	        /**
	        * The rotation of this DisplayObject. The value is given, and expressed, in radians, and is based on
	        * a right-handed orientation.
	        * 
	        * The value of this property does not reflect any rotation happening further up the display list.
	        * To obtain that value please see the `worldRotation` property.
	        * 
	        * @property {number} rotation
	        * @default
	        */
	        this.rotation = 0;
	
	        /**
	        * The alpha value of this DisplayObject. A value of 1 is fully opaque. A value of 0 is transparent.
	        * Please note that an object with an alpha value of 0 is skipped during the render pass.
	        * 
	        * The value of this property does not reflect any alpha values set further up the display list.
	        * To obtain that value please see the `worldAlpha` property.
	        * 
	        * @property {number} alpha
	        * @default
	        */
	        this.alpha = 1;
	
	        /**
	        * The visibility of this DisplayObject. A value of `false` makes the object invisible.
	        * A value of `true` makes it visible. Please note that an object with a visible value of
	        * `false` is skipped during the render pass. Equally a DisplayObject with visible false will
	        * not render any of its children.
	        * 
	        * The value of this property does not reflect any visible values set further up the display list.
	        * To obtain that value please see the `worldVisible` property.
	        * 
	        * @property {boolean} visible
	        * @default
	        */
	        this.visible = true;
	
	        /**
	         * This is the defined area that will pick up mouse / touch events. It is null by default.
	         * Setting it is a neat way of optimising the hitTest function that the interactionManager will use (as it will not need to hit test all the children)
	         *
	         * @property hitArea
	         * @type Rectangle|Circle|Ellipse|Polygon
	         */
	        this.hitArea = null;
	
	        /**
	        * Should this DisplayObject be rendered by the renderer? An object with a renderable value of
	        * `false` is skipped during the render pass.
	        * 
	        * @property {boolean} renderable
	        * @default
	        */
	        this.renderable = false;
	
	        /**
	        * The parent DisplayObjectContainer that this DisplayObject is a child of.
	        * All DisplayObjects must belong to a parent in order to be rendered.
	        * The root parent is the Stage object. This property is set automatically when the
	        * DisplayObject is added to, or removed from, a DisplayObjectContainer.
	        * 
	        * @property {PIXI.DisplayObjectContainer} parent
	        * @default
	        * @readOnly
	        */
	        this.parent = null;
	
	        /**
	        * The multiplied alpha value of this DisplayObject. A value of 1 is fully opaque. A value of 0 is transparent.
	        * This value is the calculated total, based on the alpha values of all parents of this DisplayObjects 
	        * in the display list.
	        * 
	        * To obtain, and set, the local alpha value, see the `alpha` property.
	        *
	        * Note: This property is only updated at the end of the `updateTransform` call, once per render. Until 
	        * that happens this property will contain values based on the previous frame. Be mindful of this if
	        * accessing this property outside of the normal game flow, i.e. from an asynchronous event callback.
	        * 
	        * @property {number} worldAlpha
	        * @readOnly
	        */
	        this.worldAlpha = 1;
	
	        /**
	        * The current transform of this DisplayObject.
	        * 
	        * This property contains the calculated total, based on the transforms of all parents of this 
	        * DisplayObject in the display list.
	        *
	        * Note: This property is only updated at the end of the `updateTransform` call, once per render. Until 
	        * that happens this property will contain values based on the previous frame. Be mindful of this if
	        * accessing this property outside of the normal game flow, i.e. from an asynchronous event callback.
	        *
	        * @property {PIXI.Matrix} worldTransform
	        * @readOnly
	        */
	        this.worldTransform = new PIXI.Matrix();
	
	        /**
	        * The coordinates, in pixels, of this DisplayObject within the world.
	        * 
	        * This property contains the calculated total, based on the positions of all parents of this 
	        * DisplayObject in the display list.
	        *
	        * Note: This property is only updated at the end of the `updateTransform` call, once per render. Until 
	        * that happens this property will contain values based on the previous frame. Be mindful of this if
	        * accessing this property outside of the normal game flow, i.e. from an asynchronous event callback.
	        * 
	        * @property {PIXI.Point} worldPosition
	        * @readOnly
	        */
	        this.worldPosition = new PIXI.Point(0, 0);
	
	        /**
	        * The global scale of this DisplayObject.
	        * 
	        * This property contains the calculated total, based on the scales of all parents of this 
	        * DisplayObject in the display list.
	        *
	        * Note: This property is only updated at the end of the `updateTransform` call, once per render. Until 
	        * that happens this property will contain values based on the previous frame. Be mindful of this if
	        * accessing this property outside of the normal game flow, i.e. from an asynchronous event callback.
	        * 
	        * @property {PIXI.Point} worldScale
	        * @readOnly
	        */
	        this.worldScale = new PIXI.Point(1, 1);
	
	        /**
	        * The rotation, in radians, of this DisplayObject.
	        * 
	        * This property contains the calculated total, based on the rotations of all parents of this 
	        * DisplayObject in the display list.
	        *
	        * Note: This property is only updated at the end of the `updateTransform` call, once per render. Until 
	        * that happens this property will contain values based on the previous frame. Be mindful of this if
	        * accessing this property outside of the normal game flow, i.e. from an asynchronous event callback.
	        * 
	        * @property {number} worldRotation
	        * @readOnly
	        */
	        this.worldRotation = 0;
	
	        /**
	        * The rectangular area used by filters when rendering a shader for this DisplayObject.
	        *
	        * @property {PIXI.Rectangle} filterArea
	        * @type Rectangle
	        * @default
	        */
	        this.filterArea = null;
	
	        /**
	        * @property {number} _sr - Cached rotation value.
	        * @private
	        */
	        this._sr = 0;
	
	        /**
	        * @property {number} _cr - Cached rotation value.
	        * @private
	        */
	        this._cr = 1;
	
	        /**
	        * @property {PIXI.Rectangle} _bounds - The cached bounds of this object.
	        * @private
	        */
	        this._bounds = new PIXI.Rectangle(0, 0, 0, 0);
	
	        /**
	        * @property {PIXI.Rectangle} _currentBounds - The most recently calculated bounds of this object.
	        * @private
	        */
	        this._currentBounds = null;
	
	        /**
	        * @property {PIXI.Rectangle} _mask - The cached mask of this object.
	        * @private
	        */
	        this._mask = null;
	
	        /**
	        * @property {boolean} _cacheAsBitmap - Internal cache as bitmap flag.
	        * @private
	        */
	        this._cacheAsBitmap = false;
	
	        /**
	        * @property {boolean} _cacheIsDirty - Internal dirty cache flag.
	        * @private
	        */
	        this._cacheIsDirty = false;
	    };
	
	    PIXI.DisplayObject.prototype.constructor = PIXI.DisplayObject;
	
	    PIXI.DisplayObject.prototype = {
	
	        /**
	        * Destroy this DisplayObject.
	        *
	        * Removes any cached sprites, sets renderable flag to false, and nulls filters, bounds and mask.
	        *
	        * Also iteratively calls `destroy` on any children.
	        *
	        * @method PIXI.DisplayObject#destroy
	        */
	        destroy: function destroy() {
	
	            if (this.children) {
	                var i = this.children.length;
	
	                while (i--) {
	                    this.children[i].destroy();
	                }
	
	                this.children = [];
	            }
	
	            this.hitArea = null;
	            this.parent = null;
	            this.worldTransform = null;
	            this.filterArea = null;
	            this.renderable = false;
	
	            this._bounds = null;
	            this._currentBounds = null;
	            this._mask = null;
	
	            this._destroyCachedSprite();
	        },
	
	        /*
	        * Updates the transform matrix this DisplayObject uses for rendering.
	        *
	        * If the object has no parent, and no parent parameter is provided, it will default to 
	        * Phaser.Game.World as the parent transform to use. If that is unavailable the transform fails to take place.
	        *
	        * The `parent` parameter has priority over the actual parent. Use it as a parent override.
	        * Setting it does **not** change the actual parent of this DisplayObject.
	        *
	        * Calling this method updates the `worldTransform`, `worldAlpha`, `worldPosition`, `worldScale` 
	        * and `worldRotation` properties.
	        *
	        * If a `transformCallback` has been specified, it is called at the end of this method, and is passed
	        * the new, updated, worldTransform property, along with the parent transform used.
	        *
	        * @method PIXI.DisplayObject#updateTransform
	        * @param {PIXI.DisplayObjectContainer} [parent] - Optional parent to calculate this DisplayObjects transform from.
	        * @return {PIXI.DisplayObject} - A reference to this DisplayObject.
	        */
	        updateTransform: function updateTransform(parent) {
	
	            if (!parent && !this.parent && !this.game) {
	                return this;
	            }
	
	            var p = this.parent;
	
	            if (parent) {
	                p = parent;
	            } else if (!this.parent) {
	                p = this.game.world;
	            }
	
	            // create some matrix refs for easy access
	            var pt = p.worldTransform;
	            var wt = this.worldTransform;
	
	            // temporary matrix variables
	            var a, b, c, d, tx, ty;
	
	            // so if rotation is between 0 then we can simplify the multiplication process..
	            if (this.rotation % PIXI.PI_2) {
	                // check to see if the rotation is the same as the previous render. This means we only need to use sin and cos when rotation actually changes
	                if (this.rotation !== this.rotationCache) {
	                    this.rotationCache = this.rotation;
	                    this._sr = Math.sin(this.rotation);
	                    this._cr = Math.cos(this.rotation);
	                }
	
	                // get the matrix values of the displayobject based on its transform properties..
	                a = this._cr * this.scale.x;
	                b = this._sr * this.scale.x;
	                c = -this._sr * this.scale.y;
	                d = this._cr * this.scale.y;
	                tx = this.position.x;
	                ty = this.position.y;
	
	                // check for pivot.. not often used so geared towards that fact!
	                if (this.pivot.x || this.pivot.y) {
	                    tx -= this.pivot.x * a + this.pivot.y * c;
	                    ty -= this.pivot.x * b + this.pivot.y * d;
	                }
	
	                // concat the parent matrix with the objects transform.
	                wt.a = a * pt.a + b * pt.c;
	                wt.b = a * pt.b + b * pt.d;
	                wt.c = c * pt.a + d * pt.c;
	                wt.d = c * pt.b + d * pt.d;
	                wt.tx = tx * pt.a + ty * pt.c + pt.tx;
	                wt.ty = tx * pt.b + ty * pt.d + pt.ty;
	            } else {
	                // lets do the fast version as we know there is no rotation..
	                a = this.scale.x;
	                d = this.scale.y;
	
	                tx = this.position.x - this.pivot.x * a;
	                ty = this.position.y - this.pivot.y * d;
	
	                wt.a = a * pt.a;
	                wt.b = a * pt.b;
	                wt.c = d * pt.c;
	                wt.d = d * pt.d;
	                wt.tx = tx * pt.a + ty * pt.c + pt.tx;
	                wt.ty = tx * pt.b + ty * pt.d + pt.ty;
	            }
	
	            //  Set the World values
	            this.worldAlpha = this.alpha * p.worldAlpha;
	            this.worldPosition.set(wt.tx, wt.ty);
	            this.worldScale.set(this.scale.x * Math.sqrt(wt.a * wt.a + wt.c * wt.c), this.scale.y * Math.sqrt(wt.b * wt.b + wt.d * wt.d));
	            this.worldRotation = Math.atan2(-wt.c, wt.d);
	
	            // reset the bounds each time this is called!
	            this._currentBounds = null;
	
	            //  Custom callback?
	            if (this.transformCallback) {
	                this.transformCallback.call(this.transformCallbackContext, wt, pt);
	            }
	
	            return this;
	        },
	
	        /**
	        * To be overridden by classes that require it.
	        *
	        * @method PIXI.DisplayObject#preUpdate
	        */
	        preUpdate: function preUpdate() {},
	
	        /**
	        * Generates a RenderTexture based on this DisplayObject, which can they be used to texture other Sprites.
	        * This can be useful if your DisplayObject is static, or complicated, and needs to be reused multiple times.
	        *
	        * Please note that no garbage collection takes place on old textures. It is up to you to destroy old textures,
	        * and references to them, so they don't linger in memory.
	        *
	        * @method PIXI.DisplayObject#generateTexture
	        * @param {number} [resolution=1] - The resolution of the texture being generated.
	        * @param {number} [scaleMode=PIXI.scaleModes.DEFAULT] - See {{#crossLink "PIXI/scaleModes:property"}}PIXI.scaleModes{{/crossLink}} for possible values.
	        * @param {PIXI.CanvasRenderer|PIXI.WebGLRenderer} renderer - The renderer used to generate the texture.
	        * @return {PIXI.RenderTexture} - A RenderTexture containing an image of this DisplayObject at the time it was invoked.
	        */
	        generateTexture: function generateTexture(resolution, scaleMode, renderer) {
	
	            var bounds = this.getLocalBounds();
	
	            var renderTexture = new PIXI.RenderTexture(bounds.width | 0, bounds.height | 0, renderer, scaleMode, resolution);
	
	            PIXI.DisplayObject._tempMatrix.tx = -bounds.x;
	            PIXI.DisplayObject._tempMatrix.ty = -bounds.y;
	
	            renderTexture.render(this, PIXI.DisplayObject._tempMatrix);
	
	            return renderTexture;
	        },
	
	        /**
	        * If this DisplayObject has a cached Sprite, this method generates and updates it.
	        *
	        * @method PIXI.DisplayObject#updateCache
	        * @return {PIXI.DisplayObject} - A reference to this DisplayObject.
	        */
	        updateCache: function updateCache() {
	
	            this._generateCachedSprite();
	
	            return this;
	        },
	
	        /**
	        * Calculates the global position of this DisplayObject, based on the position given.
	        *
	        * @method PIXI.DisplayObject#toGlobal
	        * @param {PIXI.Point} position - The global position to calculate from.
	        * @return {PIXI.Point} - A point object representing the position of this DisplayObject based on the global position given.
	        */
	        toGlobal: function toGlobal(position) {
	
	            this.updateTransform();
	
	            return this.worldTransform.apply(position);
	        },
	
	        /**
	        * Calculates the local position of this DisplayObject, relative to another point.
	        *
	        * @method PIXI.DisplayObject#toLocal
	        * @param {PIXI.Point} position - The world origin to calculate from.
	        * @param {PIXI.DisplayObject} [from] - An optional DisplayObject to calculate the global position from.
	        * @return {PIXI.Point} - A point object representing the position of this DisplayObject based on the global position given.
	        */
	        toLocal: function toLocal(position, from) {
	
	            if (from) {
	                position = from.toGlobal(position);
	            }
	
	            this.updateTransform();
	
	            return this.worldTransform.applyInverse(position);
	        },
	
	        /**
	        * Internal method.
	        *
	        * @method PIXI.DisplayObject#_renderCachedSprite
	        * @private
	        * @param {Object} renderSession - The render session
	        */
	        _renderCachedSprite: function _renderCachedSprite(renderSession) {
	
	            this._cachedSprite.worldAlpha = this.worldAlpha;
	
	            if (renderSession.gl) {
	                PIXI.Sprite.prototype._renderWebGL.call(this._cachedSprite, renderSession);
	            } else {
	                PIXI.Sprite.prototype._renderCanvas.call(this._cachedSprite, renderSession);
	            }
	        },
	
	        /**
	        * Internal method.
	        *
	        * @method PIXI.DisplayObject#_generateCachedSprite
	        * @private
	        */
	        _generateCachedSprite: function _generateCachedSprite() {
	
	            this._cacheAsBitmap = false;
	
	            var bounds = this.getLocalBounds();
	
	            //  Round it off and force non-zero dimensions
	            bounds.width = Math.max(1, Math.ceil(bounds.width));
	            bounds.height = Math.max(1, Math.ceil(bounds.height));
	
	            this.updateTransform();
	
	            if (!this._cachedSprite) {
	                var renderTexture = new PIXI.RenderTexture(bounds.width, bounds.height);
	                this._cachedSprite = new PIXI.Sprite(renderTexture);
	                this._cachedSprite.worldTransform = this.worldTransform;
	            } else {
	                this._cachedSprite.texture.resize(bounds.width, bounds.height);
	            }
	
	            //  Remove filters
	            var tempFilters = this._filters;
	
	            this._filters = null;
	            this._cachedSprite.filters = tempFilters;
	
	            PIXI.DisplayObject._tempMatrix.tx = -bounds.x;
	            PIXI.DisplayObject._tempMatrix.ty = -bounds.y;
	
	            this._cachedSprite.texture.render(this, PIXI.DisplayObject._tempMatrix, true);
	            this._cachedSprite.anchor.x = -(bounds.x / bounds.width);
	            this._cachedSprite.anchor.y = -(bounds.y / bounds.height);
	
	            this._filters = tempFilters;
	
	            this._cacheAsBitmap = true;
	        },
	
	        /**
	        * Destroys a cached Sprite.
	        *
	        * @method PIXI.DisplayObject#_destroyCachedSprite
	        * @private
	        */
	        _destroyCachedSprite: function _destroyCachedSprite() {
	
	            if (!this._cachedSprite) {
	                return;
	            }
	
	            this._cachedSprite.texture.destroy(true);
	
	            this._cachedSprite = null;
	        }
	
	    };
	
	    //  Alias for updateTransform. As used in DisplayObject container, etc.
	    PIXI.DisplayObject.prototype.displayObjectUpdateTransform = PIXI.DisplayObject.prototype.updateTransform;
	
	    Object.defineProperties(PIXI.DisplayObject.prototype, {
	
	        /**
	        * The horizontal position of the DisplayObject, in pixels, relative to its parent.
	        * If you need the world position of the DisplayObject, use `DisplayObject.worldPosition` instead.
	        * @name PIXI.DisplayObject#x
	        * @property {number} x - The horizontal position of the DisplayObject, in pixels, relative to its parent.
	        */
	        'x': {
	
	            get: function get() {
	
	                return this.position.x;
	            },
	
	            set: function set(value) {
	
	                this.position.x = value;
	            }
	
	        },
	
	        /**
	        * The vertical position of the DisplayObject, in pixels, relative to its parent.
	        * If you need the world position of the DisplayObject, use `DisplayObject.worldPosition` instead.
	        * @name PIXI.DisplayObject#y
	        * @property {number} y - The vertical position of the DisplayObject, in pixels, relative to its parent.
	        */
	        'y': {
	
	            get: function get() {
	
	                return this.position.y;
	            },
	
	            set: function set(value) {
	
	                this.position.y = value;
	            }
	
	        },
	
	        /**
	        * Indicates if this DisplayObject is visible, based on it, and all of its parents, `visible` property values.
	        * @name PIXI.DisplayObject#worldVisible
	        * @property {boolean} worldVisible - Indicates if this DisplayObject is visible, based on it, and all of its parents, `visible` property values.
	        */
	        'worldVisible': {
	
	            get: function get() {
	
	                if (!this.visible) {
	                    return false;
	                } else {
	                    var item = this.parent;
	
	                    if (!item) {
	                        return this.visible;
	                    } else {
	                        do {
	                            if (!item.visible) {
	                                return false;
	                            }
	
	                            item = item.parent;
	                        } while (item);
	                    }
	
	                    return true;
	                }
	            }
	
	        },
	
	        /**
	        * Sets a mask for this DisplayObject. A mask is an instance of a Graphics object.
	        * When applied it limits the visible area of this DisplayObject to the shape of the mask.
	        * Under a Canvas renderer it uses shape clipping. Under a WebGL renderer it uses a Stencil Buffer.
	        * To remove a mask, set this property to `null`.
	        * 
	        * @name PIXI.DisplayObject#mask
	        * @property {PIXI.Graphics} mask - The mask applied to this DisplayObject. Set to `null` to remove an existing mask.
	        */
	        'mask': {
	
	            get: function get() {
	
	                return this._mask;
	            },
	
	            set: function set(value) {
	
	                if (this._mask) {
	                    this._mask.isMask = false;
	                }
	
	                this._mask = value;
	
	                if (value) {
	                    this._mask.isMask = true;
	                }
	            }
	
	        },
	
	        /**
	        * Sets the filters for this DisplayObject. This is a WebGL only feature, and is ignored by the Canvas
	        * Renderer. A filter is a shader applied to this DisplayObject. You can modify the placement of the filter
	        * using `DisplayObject.filterArea`.
	        * 
	        * To remove filters, set this property to `null`.
	        *
	        * Note: You cannot have a filter set, and a MULTIPLY Blend Mode active, at the same time. Setting a 
	        * filter will reset this DisplayObjects blend mode to NORMAL.
	        * 
	        * @name PIXI.DisplayObject#filters
	        * @property {Array} filters - An Array of PIXI.AbstractFilter objects, or objects that extend them.
	        */
	        'filters': {
	
	            get: function get() {
	
	                return this._filters;
	            },
	
	            set: function set(value) {
	
	                if (Array.isArray(value)) {
	                    //  Put all the passes in one place.
	                    var passes = [];
	
	                    for (var i = 0; i < value.length; i++) {
	                        var filterPasses = value[i].passes;
	
	                        for (var j = 0; j < filterPasses.length; j++) {
	                            passes.push(filterPasses[j]);
	                        }
	                    }
	
	                    //  Needed any more?
	                    this._filterBlock = { target: this, filterPasses: passes };
	                }
	
	                this._filters = value;
	
	                if (this.blendMode && this.blendMode === PIXI.blendModes.MULTIPLY) {
	                    this.blendMode = PIXI.blendModes.NORMAL;
	                }
	            }
	
	        },
	
	        /**
	        * Sets if this DisplayObject should be cached as a bitmap.
	        *
	        * When invoked it will take a snapshot of the DisplayObject, as it is at that moment, and store it 
	        * in a RenderTexture. This is then used whenever this DisplayObject is rendered. It can provide a
	        * performance benefit for complex, but static, DisplayObjects. I.e. those with lots of children.
	        *
	        * Cached Bitmaps do not track their parents. If you update a property of this DisplayObject, it will not
	        * re-generate the cached bitmap automatically. To do that you need to call `DisplayObject.updateCache`.
	        * 
	        * To remove a cached bitmap, set this property to `null`.
	        * 
	        * @name PIXI.DisplayObject#cacheAsBitmap
	        * @property {boolean} cacheAsBitmap - Cache this DisplayObject as a Bitmap. Set to `null` to remove an existing cached bitmap.
	        */
	        'cacheAsBitmap': {
	
	            get: function get() {
	
	                return this._cacheAsBitmap;
	            },
	
	            set: function set(value) {
	
	                if (this._cacheAsBitmap === value) {
	                    return;
	                }
	
	                if (value) {
	                    this._generateCachedSprite();
	                } else {
	                    this._destroyCachedSprite();
	                }
	
	                this._cacheAsBitmap = value;
	            }
	
	        }
	
	    });
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	     * A DisplayObjectContainer represents a collection of display objects.
	     * It is the base class of all display objects that act as a container for other objects.
	     *
	     * @class DisplayObjectContainer
	     * @extends DisplayObject
	     * @constructor
	     */
	    PIXI.DisplayObjectContainer = function () {
	
	        PIXI.DisplayObject.call(this);
	
	        /**
	         * [read-only] The array of children of this container.
	         *
	         * @property children
	         * @type Array(DisplayObject)
	         * @readOnly
	         */
	        this.children = [];
	
	        /**
	        * If `ignoreChildInput`  is `false` it will allow this objects _children_ to be considered as valid for Input events.
	        * 
	        * If this property is `true` then the children will _not_ be considered as valid for Input events.
	        * 
	        * Note that this property isn't recursive: only immediate children are influenced, it doesn't scan further down.
	        * @property {boolean} ignoreChildInput
	        * @default
	        */
	        this.ignoreChildInput = false;
	    };
	
	    PIXI.DisplayObjectContainer.prototype = Object.create(PIXI.DisplayObject.prototype);
	    PIXI.DisplayObjectContainer.prototype.constructor = PIXI.DisplayObjectContainer;
	
	    /**
	     * Adds a child to the container.
	     *
	     * @method addChild
	     * @param child {DisplayObject} The DisplayObject to add to the container
	     * @return {DisplayObject} The child that was added.
	     */
	    PIXI.DisplayObjectContainer.prototype.addChild = function (child) {
	
	        return this.addChildAt(child, this.children.length);
	    };
	
	    /**
	     * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown
	     *
	     * @method addChildAt
	     * @param child {DisplayObject} The child to add
	     * @param index {Number} The index to place the child in
	     * @return {DisplayObject} The child that was added.
	     */
	    PIXI.DisplayObjectContainer.prototype.addChildAt = function (child, index) {
	
	        if (index >= 0 && index <= this.children.length) {
	            if (child.parent) {
	                child.parent.removeChild(child);
	            }
	
	            child.parent = this;
	
	            this.children.splice(index, 0, child);
	
	            return child;
	        } else {
	            throw new Error(child + 'addChildAt: The index ' + index + ' supplied is out of bounds ' + this.children.length);
	        }
	    };
	
	    /**
	     * Swaps the position of 2 Display Objects within this container.
	     *
	     * @method swapChildren
	     * @param child {DisplayObject}
	     * @param child2 {DisplayObject}
	     */
	    PIXI.DisplayObjectContainer.prototype.swapChildren = function (child, child2) {
	
	        if (child === child2) {
	            return;
	        }
	
	        var index1 = this.getChildIndex(child);
	        var index2 = this.getChildIndex(child2);
	
	        if (index1 < 0 || index2 < 0) {
	            throw new Error('swapChildren: Both the supplied DisplayObjects must be a child of the caller.');
	        }
	
	        this.children[index1] = child2;
	        this.children[index2] = child;
	    };
	
	    /**
	     * Returns the index position of a child DisplayObject instance
	     *
	     * @method getChildIndex
	     * @param child {DisplayObject} The DisplayObject instance to identify
	     * @return {Number} The index position of the child display object to identify
	     */
	    PIXI.DisplayObjectContainer.prototype.getChildIndex = function (child) {
	
	        var index = this.children.indexOf(child);
	
	        if (index === -1) {
	            throw new Error('The supplied DisplayObject must be a child of the caller');
	        }
	
	        return index;
	    };
	
	    /**
	     * Changes the position of an existing child in the display object container
	     *
	     * @method setChildIndex
	     * @param child {DisplayObject} The child DisplayObject instance for which you want to change the index number
	     * @param index {Number} The resulting index number for the child display object
	     */
	    PIXI.DisplayObjectContainer.prototype.setChildIndex = function (child, index) {
	
	        if (index < 0 || index >= this.children.length) {
	            throw new Error('The supplied index is out of bounds');
	        }
	
	        var currentIndex = this.getChildIndex(child);
	
	        this.children.splice(currentIndex, 1); //remove from old position
	        this.children.splice(index, 0, child); //add at new position
	    };
	
	    /**
	     * Returns the child at the specified index
	     *
	     * @method getChildAt
	     * @param index {Number} The index to get the child from
	     * @return {DisplayObject} The child at the given index, if any.
	     */
	    PIXI.DisplayObjectContainer.prototype.getChildAt = function (index) {
	
	        if (index < 0 || index >= this.children.length) {
	            throw new Error('getChildAt: Supplied index ' + index + ' does not exist in the child list, or the supplied DisplayObject must be a child of the caller');
	        }
	
	        return this.children[index];
	    };
	
	    /**
	     * Removes a child from the container.
	     *
	     * @method removeChild
	     * @param child {DisplayObject} The DisplayObject to remove
	     * @return {DisplayObject} The child that was removed.
	     */
	    PIXI.DisplayObjectContainer.prototype.removeChild = function (child) {
	
	        var index = this.children.indexOf(child);
	
	        if (index === -1) {
	            return;
	        }
	
	        return this.removeChildAt(index);
	    };
	
	    /**
	     * Removes a child from the specified index position.
	     *
	     * @method removeChildAt
	     * @param index {Number} The index to get the child from
	     * @return {DisplayObject} The child that was removed.
	     */
	    PIXI.DisplayObjectContainer.prototype.removeChildAt = function (index) {
	
	        var child = this.getChildAt(index);
	
	        if (child) {
	            child.parent = undefined;
	
	            this.children.splice(index, 1);
	        }
	
	        return child;
	    };
	
	    /**
	    * Removes all children from this container that are within the begin and end indexes.
	    *
	    * @method removeChildren
	    * @param beginIndex {Number} The beginning position. Default value is 0.
	    * @param endIndex {Number} The ending position. Default value is size of the container.
	    */
	    PIXI.DisplayObjectContainer.prototype.removeChildren = function (beginIndex, endIndex) {
	
	        if (beginIndex === undefined) {
	            beginIndex = 0;
	        }
	        if (endIndex === undefined) {
	            endIndex = this.children.length;
	        }
	
	        var range = endIndex - beginIndex;
	
	        if (range > 0 && range <= endIndex) {
	            var removed = this.children.splice(begin, range);
	
	            for (var i = 0; i < removed.length; i++) {
	                var child = removed[i];
	                child.parent = undefined;
	            }
	
	            return removed;
	        } else if (range === 0 && this.children.length === 0) {
	            return [];
	        } else {
	            throw new Error('removeChildren: Range Error, numeric values are outside the acceptable range');
	        }
	    };
	
	    /*
	     * Updates the transform on all children of this container for rendering
	     *
	     * @method updateTransform
	     * @private
	     */
	    PIXI.DisplayObjectContainer.prototype.updateTransform = function () {
	
	        if (!this.visible) {
	            return;
	        }
	
	        this.displayObjectUpdateTransform();
	
	        if (this._cacheAsBitmap) {
	            return;
	        }
	
	        for (var i = 0; i < this.children.length; i++) {
	            this.children[i].updateTransform();
	        }
	    };
	
	    // performance increase to avoid using call.. (10x faster)
	    PIXI.DisplayObjectContainer.prototype.displayObjectContainerUpdateTransform = PIXI.DisplayObjectContainer.prototype.updateTransform;
	
	    /**
	     * Retrieves the global bounds of the displayObjectContainer as a rectangle. The bounds calculation takes all visible children into consideration.
	     *
	     * @method getBounds
	     * @param {PIXI.DisplayObject|PIXI.Matrix} [targetCoordinateSpace] Returns a rectangle that defines the area of the display object relative to the coordinate system of the targetCoordinateSpace object.
	     * @return {Rectangle} The rectangular bounding area
	     */
	    PIXI.DisplayObjectContainer.prototype.getBounds = function (targetCoordinateSpace) {
	
	        var isTargetCoordinateSpaceDisplayObject = targetCoordinateSpace && targetCoordinateSpace instanceof PIXI.DisplayObject;
	        var isTargetCoordinateSpaceThisOrParent = true;
	
	        if (!isTargetCoordinateSpaceDisplayObject) {
	            targetCoordinateSpace = this;
	        } else if (targetCoordinateSpace instanceof PIXI.DisplayObjectContainer) {
	            isTargetCoordinateSpaceThisOrParent = targetCoordinateSpace.contains(this);
	        } else {
	            isTargetCoordinateSpaceThisOrParent = false;
	        }
	
	        var i;
	
	        if (isTargetCoordinateSpaceDisplayObject) {
	            var matrixCache = targetCoordinateSpace.worldTransform;
	
	            targetCoordinateSpace.worldTransform = PIXI.identityMatrix;
	
	            for (i = 0; i < targetCoordinateSpace.children.length; i++) {
	                targetCoordinateSpace.children[i].updateTransform();
	            }
	        }
	
	        var minX = Infinity;
	        var minY = Infinity;
	
	        var maxX = -Infinity;
	        var maxY = -Infinity;
	
	        var childBounds;
	        var childMaxX;
	        var childMaxY;
	
	        var childVisible = false;
	
	        for (i = 0; i < this.children.length; i++) {
	            var child = this.children[i];
	
	            if (!child.visible) {
	                continue;
	            }
	
	            childVisible = true;
	
	            childBounds = this.children[i].getBounds();
	
	            minX = minX < childBounds.x ? minX : childBounds.x;
	            minY = minY < childBounds.y ? minY : childBounds.y;
	
	            childMaxX = childBounds.width + childBounds.x;
	            childMaxY = childBounds.height + childBounds.y;
	
	            maxX = maxX > childMaxX ? maxX : childMaxX;
	            maxY = maxY > childMaxY ? maxY : childMaxY;
	        }
	
	        var bounds = this._bounds;
	
	        if (!childVisible) {
	            bounds = new PIXI.Rectangle();
	
	            var w0 = bounds.x;
	            var w1 = bounds.width + bounds.x;
	
	            var h0 = bounds.y;
	            var h1 = bounds.height + bounds.y;
	
	            var worldTransform = this.worldTransform;
	
	            var a = worldTransform.a;
	            var b = worldTransform.b;
	            var c = worldTransform.c;
	            var d = worldTransform.d;
	            var tx = worldTransform.tx;
	            var ty = worldTransform.ty;
	
	            var x1 = a * w1 + c * h1 + tx;
	            var y1 = d * h1 + b * w1 + ty;
	
	            var x2 = a * w0 + c * h1 + tx;
	            var y2 = d * h1 + b * w0 + ty;
	
	            var x3 = a * w0 + c * h0 + tx;
	            var y3 = d * h0 + b * w0 + ty;
	
	            var x4 = a * w1 + c * h0 + tx;
	            var y4 = d * h0 + b * w1 + ty;
	
	            maxX = x1;
	            maxY = y1;
	
	            minX = x1;
	            minY = y1;
	
	            minX = x2 < minX ? x2 : minX;
	            minX = x3 < minX ? x3 : minX;
	            minX = x4 < minX ? x4 : minX;
	
	            minY = y2 < minY ? y2 : minY;
	            minY = y3 < minY ? y3 : minY;
	            minY = y4 < minY ? y4 : minY;
	
	            maxX = x2 > maxX ? x2 : maxX;
	            maxX = x3 > maxX ? x3 : maxX;
	            maxX = x4 > maxX ? x4 : maxX;
	
	            maxY = y2 > maxY ? y2 : maxY;
	            maxY = y3 > maxY ? y3 : maxY;
	            maxY = y4 > maxY ? y4 : maxY;
	        }
	
	        bounds.x = minX;
	        bounds.y = minY;
	        bounds.width = maxX - minX;
	        bounds.height = maxY - minY;
	
	        if (isTargetCoordinateSpaceDisplayObject) {
	            targetCoordinateSpace.worldTransform = matrixCache;
	
	            for (i = 0; i < targetCoordinateSpace.children.length; i++) {
	                targetCoordinateSpace.children[i].updateTransform();
	            }
	        }
	
	        if (!isTargetCoordinateSpaceThisOrParent) {
	            var targetCoordinateSpaceBounds = targetCoordinateSpace.getBounds();
	
	            bounds.x -= targetCoordinateSpaceBounds.x;
	            bounds.y -= targetCoordinateSpaceBounds.y;
	        }
	
	        return bounds;
	    };
	
	    /**
	     * Retrieves the non-global local bounds of the displayObjectContainer as a rectangle without any transformations. The calculation takes all visible children into consideration.
	     *
	     * @method getLocalBounds
	     * @return {Rectangle} The rectangular bounding area
	     */
	    PIXI.DisplayObjectContainer.prototype.getLocalBounds = function () {
	
	        return this.getBounds(this);
	    };
	
	    /**
	    * Determines whether the specified display object is a child of the DisplayObjectContainer instance or the instance itself.
	    *
	    * @method contains
	    * @param {DisplayObject} child
	    * @returns {boolean}
	    */
	    PIXI.DisplayObjectContainer.prototype.contains = function (child) {
	
	        if (!child) {
	            return false;
	        } else if (child === this) {
	            return true;
	        } else {
	            return this.contains(child.parent);
	        }
	    };
	
	    /**
	    * Renders the object using the WebGL renderer
	    *
	    * @method _renderWebGL
	    * @param renderSession {RenderSession} 
	    * @private
	    */
	    PIXI.DisplayObjectContainer.prototype._renderWebGL = function (renderSession) {
	
	        if (!this.visible || this.alpha <= 0) {
	            return;
	        }
	
	        if (this._cacheAsBitmap) {
	            this._renderCachedSprite(renderSession);
	            return;
	        }
	
	        var i;
	
	        if (this._mask || this._filters) {
	            // push filter first as we need to ensure the stencil buffer is correct for any masking
	            if (this._filters) {
	                renderSession.spriteBatch.flush();
	                renderSession.filterManager.pushFilter(this._filterBlock);
	            }
	
	            if (this._mask) {
	                renderSession.spriteBatch.stop();
	                renderSession.maskManager.pushMask(this.mask, renderSession);
	                renderSession.spriteBatch.start();
	            }
	
	            // simple render children!
	            for (i = 0; i < this.children.length; i++) {
	                this.children[i]._renderWebGL(renderSession);
	            }
	
	            renderSession.spriteBatch.stop();
	
	            if (this._mask) renderSession.maskManager.popMask(this._mask, renderSession);
	            if (this._filters) renderSession.filterManager.popFilter();
	
	            renderSession.spriteBatch.start();
	        } else {
	            // simple render children!
	            for (i = 0; i < this.children.length; i++) {
	                this.children[i]._renderWebGL(renderSession);
	            }
	        }
	    };
	
	    /**
	    * Renders the object using the Canvas renderer
	    *
	    * @method _renderCanvas
	    * @param renderSession {RenderSession} 
	    * @private
	    */
	    PIXI.DisplayObjectContainer.prototype._renderCanvas = function (renderSession) {
	
	        if (this.visible === false || this.alpha === 0) {
	            return;
	        }
	
	        if (this._cacheAsBitmap) {
	            this._renderCachedSprite(renderSession);
	            return;
	        }
	
	        if (this._mask) {
	            renderSession.maskManager.pushMask(this._mask, renderSession);
	        }
	
	        for (var i = 0; i < this.children.length; i++) {
	            this.children[i]._renderCanvas(renderSession);
	        }
	
	        if (this._mask) {
	            renderSession.maskManager.popMask(renderSession);
	        }
	    };
	
	    /**
	     * The width of the displayObjectContainer, setting this will actually modify the scale to achieve the value set
	     *
	     * @property width
	     * @type Number
	     */
	    Object.defineProperty(PIXI.DisplayObjectContainer.prototype, 'width', {
	
	        get: function get() {
	            return this.getLocalBounds().width * this.scale.x;
	        },
	
	        set: function set(value) {
	
	            var width = this.getLocalBounds().width;
	
	            if (width !== 0) {
	                this.scale.x = value / width;
	            } else {
	                this.scale.x = 1;
	            }
	
	            this._width = value;
	        }
	    });
	
	    /**
	     * The height of the displayObjectContainer, setting this will actually modify the scale to achieve the value set
	     *
	     * @property height
	     * @type Number
	     */
	    Object.defineProperty(PIXI.DisplayObjectContainer.prototype, 'height', {
	
	        get: function get() {
	            return this.getLocalBounds().height * this.scale.y;
	        },
	
	        set: function set(value) {
	
	            var height = this.getLocalBounds().height;
	
	            if (height !== 0) {
	                this.scale.y = value / height;
	            } else {
	                this.scale.y = 1;
	            }
	
	            this._height = value;
	        }
	
	    });
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	     * The Sprite object is the base for all textured objects that are rendered to the screen
	     *
	     * @class Sprite
	     * @extends DisplayObjectContainer
	     * @constructor
	     * @param texture {Texture} The texture for this sprite
	     */
	    PIXI.Sprite = function (texture) {
	
	        PIXI.DisplayObjectContainer.call(this);
	
	        /**
	         * The anchor sets the origin point of the texture.
	         * The default is 0,0 this means the texture's origin is the top left
	         * Setting than anchor to 0.5,0.5 means the textures origin is centered
	         * Setting the anchor to 1,1 would mean the textures origin points will be the bottom right corner
	         *
	         * @property anchor
	         * @type Point
	         */
	        this.anchor = new PIXI.Point();
	
	        /**
	         * The texture that the sprite is using
	         *
	         * @property texture
	         * @type Texture
	         */
	        this.texture = texture || PIXI.Texture.emptyTexture;
	
	        /**
	         * The width of the sprite (this is initially set by the texture)
	         *
	         * @property _width
	         * @type Number
	         * @private
	         */
	        this._width = 0;
	
	        /**
	         * The height of the sprite (this is initially set by the texture)
	         *
	         * @property _height
	         * @type Number
	         * @private
	         */
	        this._height = 0;
	
	        /**
	         * The tint applied to the sprite. This is a hex value. A value of 0xFFFFFF will remove any tint effect.
	         *
	         * @property tint
	         * @type Number
	         * @default 0xFFFFFF
	         */
	        this.tint = 0xFFFFFF;
	
	        /**
	         * The tint applied to the sprite. This is a hex value. A value of 0xFFFFFF will remove any tint effect.
	         *
	         * @property cachedTint
	         * @private
	         * @type Number
	         * @default -1
	         */
	        this.cachedTint = -1;
	
	        /**
	         * A canvas that contains the tinted version of the Sprite (in Canvas mode, WebGL doesn't populate this)
	         *
	         * @property tintedTexture
	         * @type Canvas
	         * @default null
	         */
	        this.tintedTexture = null;
	
	        /**
	         * The blend mode to be applied to the sprite. Set to PIXI.blendModes.NORMAL to remove any blend mode.
	         *
	         * Warning: You cannot have a blend mode and a filter active on the same Sprite. Doing so will render the sprite invisible.
	         *
	         * @property blendMode
	         * @type Number
	         * @default PIXI.blendModes.NORMAL;
	         */
	        this.blendMode = PIXI.blendModes.NORMAL;
	
	        /**
	         * The shader that will be used to render this Sprite.
	         * Set to null to remove a current shader.
	         *
	         * @property shader
	         * @type AbstractFilter
	         * @default null
	         */
	        this.shader = null;
	
	        /**
	        * Controls if this Sprite is processed by the core Phaser game loops and Group loops.
	        *
	        * @property exists
	        * @type Boolean
	        * @default true
	        */
	        this.exists = true;
	
	        if (this.texture.baseTexture.hasLoaded) {
	            this.onTextureUpdate();
	        }
	
	        this.renderable = true;
	    };
	
	    // constructor
	    PIXI.Sprite.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);
	    PIXI.Sprite.prototype.constructor = PIXI.Sprite;
	
	    /**
	     * The width of the sprite, setting this will actually modify the scale to achieve the value set
	     *
	     * @property width
	     * @type Number
	     */
	    Object.defineProperty(PIXI.Sprite.prototype, 'width', {
	
	        get: function get() {
	            return this.scale.x * this.texture.frame.width;
	        },
	
	        set: function set(value) {
	            this.scale.x = value / this.texture.frame.width;
	            this._width = value;
	        }
	
	    });
	
	    /**
	     * The height of the sprite, setting this will actually modify the scale to achieve the value set
	     *
	     * @property height
	     * @type Number
	     */
	    Object.defineProperty(PIXI.Sprite.prototype, 'height', {
	
	        get: function get() {
	            return this.scale.y * this.texture.frame.height;
	        },
	
	        set: function set(value) {
	            this.scale.y = value / this.texture.frame.height;
	            this._height = value;
	        }
	
	    });
	
	    /**
	     * Sets the texture of the sprite. Be warned that this doesn't remove or destroy the previous
	     * texture this Sprite was using.
	     *
	     * @method setTexture
	     * @param texture {Texture} The PIXI texture that is displayed by the sprite
	     * @param [destroy=false] {boolean} Call Texture.destroy on the current texture before replacing it with the new one?
	     */
	    PIXI.Sprite.prototype.setTexture = function (texture, destroyBase) {
	        if (destroyBase !== undefined) {
	            this.texture.baseTexture.destroy();
	        }
	
	        //  Over-ridden by loadTexture as needed
	        this.texture.baseTexture.skipRender = false;
	        this.texture = texture;
	        this.texture.valid = true;
	        this.cachedTint = -1;
	    };
	
	    /**
	     * When the texture is updated, this event will fire to update the scale and frame
	     *
	     * @method onTextureUpdate
	     * @param event
	     * @private
	     */
	    PIXI.Sprite.prototype.onTextureUpdate = function () {
	        // so if _width is 0 then width was not set..
	        if (this._width) this.scale.x = this._width / this.texture.frame.width;
	        if (this._height) this.scale.y = this._height / this.texture.frame.height;
	    };
	
	    /**
	    * Returns the bounds of the Sprite as a rectangle.
	    * The bounds calculation takes the worldTransform into account.
	    *
	    * It is important to note that the transform is not updated when you call this method.
	    * So if this Sprite is the child of a Display Object which has had its transform
	    * updated since the last render pass, those changes will not yet have been applied
	    * to this Sprites worldTransform. If you need to ensure that all parent transforms
	    * are factored into this getBounds operation then you should call `updateTransform`
	    * on the root most object in this Sprites display list first.
	    *
	    * @method getBounds
	    * @param matrix {Matrix} the transformation matrix of the sprite
	    * @return {Rectangle} the framing rectangle
	    */
	    PIXI.Sprite.prototype.getBounds = function (matrix) {
	        var width = this.texture.frame.width;
	        var height = this.texture.frame.height;
	
	        var w0 = width * (1 - this.anchor.x);
	        var w1 = width * -this.anchor.x;
	
	        var h0 = height * (1 - this.anchor.y);
	        var h1 = height * -this.anchor.y;
	
	        var worldTransform = matrix || this.worldTransform;
	
	        var a = worldTransform.a;
	        var b = worldTransform.b;
	        var c = worldTransform.c;
	        var d = worldTransform.d;
	        var tx = worldTransform.tx;
	        var ty = worldTransform.ty;
	
	        var maxX = -Infinity;
	        var maxY = -Infinity;
	
	        var minX = Infinity;
	        var minY = Infinity;
	
	        if (b === 0 && c === 0) {
	            // scale may be negative!
	            if (a < 0) {
	                a *= -1;
	                var temp = w0;
	                w0 = -w1;
	                w1 = -temp;
	            }
	
	            if (d < 0) {
	                d *= -1;
	                var temp = h0;
	                h0 = -h1;
	                h1 = -temp;
	            }
	
	            // this means there is no rotation going on right? RIGHT?
	            // if thats the case then we can avoid checking the bound values! yay         
	            minX = a * w1 + tx;
	            maxX = a * w0 + tx;
	            minY = d * h1 + ty;
	            maxY = d * h0 + ty;
	        } else {
	            var x1 = a * w1 + c * h1 + tx;
	            var y1 = d * h1 + b * w1 + ty;
	
	            var x2 = a * w0 + c * h1 + tx;
	            var y2 = d * h1 + b * w0 + ty;
	
	            var x3 = a * w0 + c * h0 + tx;
	            var y3 = d * h0 + b * w0 + ty;
	
	            var x4 = a * w1 + c * h0 + tx;
	            var y4 = d * h0 + b * w1 + ty;
	
	            minX = x1 < minX ? x1 : minX;
	            minX = x2 < minX ? x2 : minX;
	            minX = x3 < minX ? x3 : minX;
	            minX = x4 < minX ? x4 : minX;
	
	            minY = y1 < minY ? y1 : minY;
	            minY = y2 < minY ? y2 : minY;
	            minY = y3 < minY ? y3 : minY;
	            minY = y4 < minY ? y4 : minY;
	
	            maxX = x1 > maxX ? x1 : maxX;
	            maxX = x2 > maxX ? x2 : maxX;
	            maxX = x3 > maxX ? x3 : maxX;
	            maxX = x4 > maxX ? x4 : maxX;
	
	            maxY = y1 > maxY ? y1 : maxY;
	            maxY = y2 > maxY ? y2 : maxY;
	            maxY = y3 > maxY ? y3 : maxY;
	            maxY = y4 > maxY ? y4 : maxY;
	        }
	
	        var bounds = this._bounds;
	
	        bounds.x = minX;
	        bounds.width = maxX - minX;
	
	        bounds.y = minY;
	        bounds.height = maxY - minY;
	
	        // store a reference so that if this function gets called again in the render cycle we do not have to recalculate
	        this._currentBounds = bounds;
	
	        return bounds;
	    };
	
	    /**
	     * Retrieves the non-global local bounds of the Sprite as a rectangle. The calculation takes all visible children into consideration.
	     *
	     * @method getLocalBounds
	     * @return {Rectangle} The rectangular bounding area
	     */
	    PIXI.Sprite.prototype.getLocalBounds = function () {
	
	        var matrixCache = this.worldTransform;
	
	        this.worldTransform = PIXI.identityMatrix;
	
	        for (var i = 0; i < this.children.length; i++) {
	            this.children[i].updateTransform();
	        }
	
	        var bounds = this.getBounds();
	
	        this.worldTransform = matrixCache;
	
	        for (i = 0; i < this.children.length; i++) {
	            this.children[i].updateTransform();
	        }
	
	        return bounds;
	    };
	
	    /**
	    * Renders the object using the WebGL renderer
	    *
	    * @method _renderWebGL
	    * @param renderSession {RenderSession}
	    * @param {Matrix} [matrix] - Optional matrix. If provided the Display Object will be rendered using this matrix, otherwise it will use its worldTransform.
	    * @private
	    */
	    PIXI.Sprite.prototype._renderWebGL = function (renderSession, matrix) {
	        // if the sprite is not visible or the alpha is 0 then no need to render this element
	        if (!this.visible || this.alpha <= 0 || !this.renderable) return;
	
	        //  They provided an alternative rendering matrix, so use it
	        var wt = this.worldTransform;
	
	        if (matrix) {
	            wt = matrix;
	        }
	
	        //  A quick check to see if this element has a mask or a filter.
	        if (this._mask || this._filters) {
	            var spriteBatch = renderSession.spriteBatch;
	
	            // push filter first as we need to ensure the stencil buffer is correct for any masking
	            if (this._filters) {
	                spriteBatch.flush();
	                renderSession.filterManager.pushFilter(this._filterBlock);
	            }
	
	            if (this._mask) {
	                spriteBatch.stop();
	                renderSession.maskManager.pushMask(this.mask, renderSession);
	                spriteBatch.start();
	            }
	
	            // add this sprite to the batch
	            spriteBatch.render(this);
	
	            // now loop through the children and make sure they get rendered
	            for (var i = 0; i < this.children.length; i++) {
	                this.children[i]._renderWebGL(renderSession);
	            }
	
	            // time to stop the sprite batch as either a mask element or a filter draw will happen next
	            spriteBatch.stop();
	
	            if (this._mask) renderSession.maskManager.popMask(this._mask, renderSession);
	            if (this._filters) renderSession.filterManager.popFilter();
	
	            spriteBatch.start();
	        } else {
	            renderSession.spriteBatch.render(this);
	
	            //  Render children!
	            for (var i = 0; i < this.children.length; i++) {
	                this.children[i]._renderWebGL(renderSession, wt);
	            }
	        }
	    };
	
	    /**
	    * Renders the object using the Canvas renderer
	    *
	    * @method _renderCanvas
	    * @param renderSession {RenderSession}
	    * @param {Matrix} [matrix] - Optional matrix. If provided the Display Object will be rendered using this matrix, otherwise it will use its worldTransform.
	    * @private
	    */
	    PIXI.Sprite.prototype._renderCanvas = function (renderSession, matrix) {
	        // If the sprite is not visible or the alpha is 0 then no need to render this element
	        if (!this.visible || this.alpha === 0 || !this.renderable || this.texture.crop.width <= 0 || this.texture.crop.height <= 0) {
	            return;
	        }
	
	        var wt = this.worldTransform;
	
	        //  If they provided an alternative rendering matrix then use it
	        if (matrix) {
	            wt = matrix;
	        }
	
	        if (this.blendMode !== renderSession.currentBlendMode) {
	            renderSession.currentBlendMode = this.blendMode;
	            renderSession.context.globalCompositeOperation = PIXI.blendModesCanvas[renderSession.currentBlendMode];
	        }
	
	        if (this._mask) {
	            renderSession.maskManager.pushMask(this._mask, renderSession);
	        }
	
	        //  Ignore null sources
	        if (this.texture.valid) {
	            var resolution = this.texture.baseTexture.resolution / renderSession.resolution;
	
	            renderSession.context.globalAlpha = this.worldAlpha;
	
	            //  If smoothingEnabled is supported and we need to change the smoothing property for this texture
	            if (renderSession.smoothProperty && renderSession.scaleMode !== this.texture.baseTexture.scaleMode) {
	                renderSession.scaleMode = this.texture.baseTexture.scaleMode;
	                renderSession.context[renderSession.smoothProperty] = renderSession.scaleMode === PIXI.scaleModes.LINEAR;
	            }
	
	            //  If the texture is trimmed we offset by the trim x/y, otherwise we use the frame dimensions
	            var dx = this.texture.trim ? this.texture.trim.x - this.anchor.x * this.texture.trim.width : this.anchor.x * -this.texture.frame.width;
	            var dy = this.texture.trim ? this.texture.trim.y - this.anchor.y * this.texture.trim.height : this.anchor.y * -this.texture.frame.height;
	
	            var tx = wt.tx * renderSession.resolution + renderSession.shakeX;
	            var ty = wt.ty * renderSession.resolution + renderSession.shakeY;
	
	            //  Allow for pixel rounding
	            if (renderSession.roundPixels) {
	                renderSession.context.setTransform(wt.a, wt.b, wt.c, wt.d, tx | 0, ty | 0);
	                dx |= 0;
	                dy |= 0;
	            } else {
	                renderSession.context.setTransform(wt.a, wt.b, wt.c, wt.d, tx, ty);
	            }
	
	            var cw = this.texture.crop.width;
	            var ch = this.texture.crop.height;
	
	            dx /= resolution;
	            dy /= resolution;
	
	            if (this.tint !== 0xFFFFFF) {
	                if (this.texture.requiresReTint || this.cachedTint !== this.tint) {
	                    this.tintedTexture = PIXI.CanvasTinter.getTintedTexture(this, this.tint);
	
	                    this.cachedTint = this.tint;
	                    this.texture.requiresReTint = false;
	                }
	
	                renderSession.context.drawImage(this.tintedTexture, 0, 0, cw, ch, dx, dy, cw / resolution, ch / resolution);
	            } else {
	                var cx = this.texture.crop.x;
	                var cy = this.texture.crop.y;
	                renderSession.context.drawImage(this.texture.baseTexture.source, cx, cy, cw, ch, dx, dy, cw / resolution, ch / resolution);
	            }
	        }
	
	        for (var i = 0; i < this.children.length; i++) {
	            this.children[i]._renderCanvas(renderSession);
	        }
	
	        if (this._mask) {
	            renderSession.maskManager.popMask(renderSession);
	        }
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/
	     */
	
	    /**
	     * The SpriteBatch class is a really fast version of the DisplayObjectContainer 
	     * built solely for speed, so use when you need a lot of sprites or particles.
	     * And it's extremely easy to use : 
	    
	        var container = new PIXI.SpriteBatch();
	     
	        for(var i  = 0; i < 100; i++)
	        {
	            var sprite = new PIXI.Sprite.fromImage("myImage.png");
	            container.addChild(sprite);
	        }
	     * And here you have a hundred sprites that will be renderer at the speed of light
	     *
	     * @class SpriteBatch
	     * @constructor
	     * @param texture {Texture}
	     */
	    PIXI.SpriteBatch = function (texture) {
	        PIXI.DisplayObjectContainer.call(this);
	
	        this.textureThing = texture;
	
	        this.ready = false;
	    };
	
	    PIXI.SpriteBatch.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);
	    PIXI.SpriteBatch.prototype.constructor = PIXI.SpriteBatch;
	
	    /*
	     * Initialises the spriteBatch
	     *
	     * @method initWebGL
	     * @param gl {WebGLContext} the current WebGL drawing context
	     */
	    PIXI.SpriteBatch.prototype.initWebGL = function (gl) {
	        // TODO only one needed for the whole engine really?
	        this.fastSpriteBatch = new PIXI.WebGLFastSpriteBatch(gl);
	
	        this.ready = true;
	    };
	
	    /*
	     * Updates the object transform for rendering
	     *
	     * @method updateTransform
	     * @private
	     */
	    PIXI.SpriteBatch.prototype.updateTransform = function () {
	        // TODO don't need to!
	        this.displayObjectUpdateTransform();
	        //  PIXI.DisplayObjectContainer.prototype.updateTransform.call( this );
	    };
	
	    /**
	    * Renders the object using the WebGL renderer
	    *
	    * @method _renderWebGL
	    * @param renderSession {RenderSession} 
	    * @private
	    */
	    PIXI.SpriteBatch.prototype._renderWebGL = function (renderSession) {
	        if (!this.visible || this.alpha <= 0 || !this.children.length) return;
	
	        if (!this.ready) {
	            this.initWebGL(renderSession.gl);
	        }
	
	        if (this.fastSpriteBatch.gl !== renderSession.gl) {
	            this.fastSpriteBatch.setContext(renderSession.gl);
	        }
	
	        renderSession.spriteBatch.stop();
	
	        renderSession.shaderManager.setShader(renderSession.shaderManager.fastShader);
	
	        this.fastSpriteBatch.begin(this, renderSession);
	        this.fastSpriteBatch.render(this);
	
	        renderSession.spriteBatch.start();
	    };
	
	    /**
	    * Renders the object using the Canvas renderer
	    *
	    * @method _renderCanvas
	    * @param renderSession {RenderSession} 
	    * @private
	    */
	    PIXI.SpriteBatch.prototype._renderCanvas = function (renderSession) {
	        if (!this.visible || this.alpha <= 0 || !this.children.length) return;
	
	        var context = renderSession.context;
	
	        context.globalAlpha = this.worldAlpha;
	
	        this.displayObjectUpdateTransform();
	
	        var transform = this.worldTransform;
	
	        var isRotated = true;
	
	        for (var i = 0; i < this.children.length; i++) {
	            var child = this.children[i];
	
	            if (!child.visible) continue;
	
	            var texture = child.texture;
	            var frame = texture.frame;
	
	            context.globalAlpha = this.worldAlpha * child.alpha;
	
	            if (child.rotation % (Math.PI * 2) === 0) {
	                if (isRotated) {
	                    context.setTransform(transform.a, transform.b, transform.c, transform.d, transform.tx, transform.ty);
	                    isRotated = false;
	                }
	
	                // this is the fastest  way to optimise! - if rotation is 0 then we can avoid any kind of setTransform call
	                context.drawImage(texture.baseTexture.source, frame.x, frame.y, frame.width, frame.height, child.anchor.x * (-frame.width * child.scale.x) + child.position.x + 0.5 + renderSession.shakeX | 0, child.anchor.y * (-frame.height * child.scale.y) + child.position.y + 0.5 + renderSession.shakeY | 0, frame.width * child.scale.x, frame.height * child.scale.y);
	            } else {
	                if (!isRotated) isRotated = true;
	
	                child.displayObjectUpdateTransform();
	
	                var childTransform = child.worldTransform;
	                var tx = childTransform.tx * renderSession.resolution + renderSession.shakeX;
	                var ty = childTransform.ty * renderSession.resolution + renderSession.shakeY;
	
	                // allow for trimming
	
	                if (renderSession.roundPixels) {
	                    context.setTransform(childTransform.a, childTransform.b, childTransform.c, childTransform.d, tx | 0, ty | 0);
	                } else {
	                    context.setTransform(childTransform.a, childTransform.b, childTransform.c, childTransform.d, tx, ty);
	                }
	
	                context.drawImage(texture.baseTexture.source, frame.x, frame.y, frame.width, frame.height, child.anchor.x * -frame.width + 0.5 | 0, child.anchor.y * -frame.height + 0.5 | 0, frame.width, frame.height);
	            }
	        }
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	     * Converts a hex color number to an [R, G, B] array
	     *
	     * @method hex2rgb
	     * @param hex {Number}
	     */
	    PIXI.hex2rgb = function (hex) {
	        return [(hex >> 16 & 0xFF) / 255, (hex >> 8 & 0xFF) / 255, (hex & 0xFF) / 255];
	    };
	
	    /**
	     * Converts a color as an [R, G, B] array to a hex number
	     *
	     * @method rgb2hex
	     * @param rgb {Array}
	     */
	    PIXI.rgb2hex = function (rgb) {
	        return (rgb[0] * 255 << 16) + (rgb[1] * 255 << 8) + rgb[2] * 255;
	    };
	
	    /**
	     * Checks whether the Canvas BlendModes are supported by the current browser for drawImage
	     *
	     * @method canUseNewCanvasBlendModes
	     * @return {Boolean} whether they are supported
	     */
	    PIXI.canUseNewCanvasBlendModes = function () {
	        if (document === undefined) return false;
	
	        var pngHead = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAABAQMAAADD8p2OAAAAA1BMVEX/';
	        var pngEnd = 'AAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg==';
	
	        var magenta = new Image();
	        magenta.src = pngHead + 'AP804Oa6' + pngEnd;
	
	        var yellow = new Image();
	        yellow.src = pngHead + '/wCKxvRF' + pngEnd;
	
	        var canvas = PIXI.CanvasPool.create(this, 6, 1);
	        var context = canvas.getContext('2d');
	        context.globalCompositeOperation = 'multiply';
	        context.drawImage(magenta, 0, 0);
	        context.drawImage(yellow, 2, 0);
	
	        if (!context.getImageData(2, 0, 1, 1)) {
	            return false;
	        }
	
	        var data = context.getImageData(2, 0, 1, 1).data;
	
	        PIXI.CanvasPool.remove(this);
	
	        return data[0] === 255 && data[1] === 0 && data[2] === 0;
	    };
	
	    /**
	     * Given a number, this function returns the closest number that is a power of two
	     * this function is taken from Starling Framework as its pretty neat ;)
	     *
	     * @method getNextPowerOfTwo
	     * @param number {Number}
	     * @return {Number} the closest number that is a power of two
	     */
	    PIXI.getNextPowerOfTwo = function (number) {
	        if (number > 0 && (number & number - 1) === 0) // see: http://goo.gl/D9kPj
	            return number;else {
	            var result = 1;
	            while (result < number) {
	                result <<= 1;
	            }return result;
	        }
	    };
	
	    /**
	     * checks if the given width and height make a power of two texture
	     * @method isPowerOfTwo
	     * @param width {Number}
	     * @param height {Number}
	     * @return {Boolean} 
	     */
	    PIXI.isPowerOfTwo = function (width, height) {
	        return width > 0 && (width & width - 1) === 0 && height > 0 && (height & height - 1) === 0;
	    };
	
	    /**
	    * @author       Richard Davey <rich@photonstorm.com>
	    * @copyright    2016 Photon Storm Ltd.
	    * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	    */
	
	    /**
	    * The CanvasPool is a global static object that allows Pixi and Phaser to pool canvas DOM elements.
	    *
	    * @class CanvasPool
	    * @static
	    */
	    PIXI.CanvasPool = {
	
	        /**
	        * Creates a new Canvas DOM element, or pulls one from the pool if free.
	        * 
	        * @method create
	        * @static
	        * @param parent {any} The parent of the canvas element.
	        * @param width {number} The width of the canvas element.
	        * @param height {number} The height of the canvas element.
	        * @return {HTMLCanvasElement} The canvas element.
	        */
	        create: function create(parent, width, height) {
	
	            var idx = PIXI.CanvasPool.getFirst();
	            var canvas;
	
	            if (idx === -1) {
	                var container = {
	                    parent: parent,
	                    canvas: document.createElement('canvas')
	                };
	
	                PIXI.CanvasPool.pool.push(container);
	
	                canvas = container.canvas;
	            } else {
	                PIXI.CanvasPool.pool[idx].parent = parent;
	
	                canvas = PIXI.CanvasPool.pool[idx].canvas;
	            }
	
	            if (width !== undefined) {
	                canvas.width = width;
	                canvas.height = height;
	            }
	
	            return canvas;
	        },
	
	        /**
	        * Gets the first free canvas index from the pool.
	        * 
	        * @method getFirst
	        * @static
	        * @return {number}
	        */
	        getFirst: function getFirst() {
	
	            var pool = PIXI.CanvasPool.pool;
	
	            for (var i = 0; i < pool.length; i++) {
	                if (!pool[i].parent) {
	                    return i;
	                }
	            }
	
	            return -1;
	        },
	
	        /**
	        * Removes the parent from a canvas element from the pool, freeing it up for re-use.
	        * 
	        * @method remove
	        * @param parent {any} The parent of the canvas element.
	        * @static
	        */
	        remove: function remove(parent) {
	
	            var pool = PIXI.CanvasPool.pool;
	
	            for (var i = 0; i < pool.length; i++) {
	                if (pool[i].parent === parent) {
	                    pool[i].parent = null;
	                    pool[i].canvas.width = 1;
	                    pool[i].canvas.height = 1;
	                }
	            }
	        },
	
	        /**
	        * Removes the parent from a canvas element from the pool, freeing it up for re-use.
	        * 
	        * @method removeByCanvas
	        * @param canvas {HTMLCanvasElement} The canvas element to remove
	        * @static
	        */
	        removeByCanvas: function removeByCanvas(canvas) {
	
	            var pool = PIXI.CanvasPool.pool;
	
	            for (var i = 0; i < pool.length; i++) {
	                if (pool[i].canvas === canvas) {
	                    pool[i].parent = null;
	                    pool[i].canvas.width = 1;
	                    pool[i].canvas.height = 1;
	                }
	            }
	        },
	
	        /**
	        * Gets the total number of used canvas elements in the pool.
	        * 
	        * @method getTotal
	        * @static
	        * @return {number} The number of in-use (parented) canvas elements in the pool.
	        */
	        getTotal: function getTotal() {
	
	            var pool = PIXI.CanvasPool.pool;
	            var c = 0;
	
	            for (var i = 0; i < pool.length; i++) {
	                if (pool[i].parent) {
	                    c++;
	                }
	            }
	
	            return c;
	        },
	
	        /**
	        * Gets the total number of free canvas elements in the pool.
	        * 
	        * @method getFree
	        * @static
	        * @return {number} The number of free (un-parented) canvas elements in the pool.
	        */
	        getFree: function getFree() {
	
	            var pool = PIXI.CanvasPool.pool;
	            var c = 0;
	
	            for (var i = 0; i < pool.length; i++) {
	                if (!pool[i].parent) {
	                    c++;
	                }
	            }
	
	            return c;
	        }
	
	    };
	
	    /**
	     * The pool into which the canvas dom elements are placed.
	     *
	     * @property pool
	     * @type Array
	     * @static
	     */
	    PIXI.CanvasPool.pool = [];
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	    * @method initDefaultShaders
	    * @static
	    * @private
	    */
	    PIXI.initDefaultShaders = function () {};
	
	    /**
	    * @method CompileVertexShader
	    * @static
	    * @param gl {WebGLContext} the current WebGL drawing context
	    * @param shaderSrc {Array}
	    * @return {Any}
	    */
	    PIXI.CompileVertexShader = function (gl, shaderSrc) {
	        return PIXI._CompileShader(gl, shaderSrc, gl.VERTEX_SHADER);
	    };
	
	    /**
	    * @method CompileFragmentShader
	    * @static
	    * @param gl {WebGLContext} the current WebGL drawing context
	    * @param shaderSrc {Array}
	    * @return {Any}
	    */
	    PIXI.CompileFragmentShader = function (gl, shaderSrc) {
	        return PIXI._CompileShader(gl, shaderSrc, gl.FRAGMENT_SHADER);
	    };
	
	    /**
	    * @method _CompileShader
	    * @static
	    * @private
	    * @param gl {WebGLContext} the current WebGL drawing context
	    * @param shaderSrc {Array}
	    * @param shaderType {Number}
	    * @return {Any}
	    */
	    PIXI._CompileShader = function (gl, shaderSrc, shaderType) {
	        var src = shaderSrc;
	
	        if (Array.isArray(shaderSrc)) {
	            src = shaderSrc.join("\n");
	        }
	
	        var shader = gl.createShader(shaderType);
	        gl.shaderSource(shader, src);
	        gl.compileShader(shader);
	
	        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
	            window.console.log(gl.getShaderInfoLog(shader));
	            return null;
	        }
	
	        return shader;
	    };
	
	    /**
	    * @method compileProgram
	    * @static
	    * @param gl {WebGLContext} the current WebGL drawing context
	    * @param vertexSrc {Array}
	    * @param fragmentSrc {Array}
	    * @return {Any}
	    */
	    PIXI.compileProgram = function (gl, vertexSrc, fragmentSrc) {
	        var fragmentShader = PIXI.CompileFragmentShader(gl, fragmentSrc);
	        var vertexShader = PIXI.CompileVertexShader(gl, vertexSrc);
	
	        var shaderProgram = gl.createProgram();
	
	        gl.attachShader(shaderProgram, vertexShader);
	        gl.attachShader(shaderProgram, fragmentShader);
	        gl.linkProgram(shaderProgram);
	
	        if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
	            window.console.log(gl.getProgramInfoLog(shaderProgram));
	            window.console.log("Could not initialise shaders");
	        }
	
	        return shaderProgram;
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     * @author Richard Davey http://www.photonstorm.com @photonstorm
	     */
	
	    /**
	    * @class PixiShader
	    * @constructor
	    * @param gl {WebGLContext} the current WebGL drawing context
	    */
	    PIXI.PixiShader = function (gl) {
	        /**
	         * @property _UID
	         * @type Number
	         * @private
	         */
	        this._UID = PIXI._UID++;
	
	        /**
	         * @property gl
	         * @type WebGLContext
	         */
	        this.gl = gl;
	
	        /**
	         * The WebGL program.
	         * @property program
	         * @type Any
	         */
	        this.program = null;
	
	        /**
	         * The fragment shader.
	         * @property fragmentSrc
	         * @type Array
	         */
	        this.fragmentSrc = ['precision lowp float;', 'varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'uniform sampler2D uSampler;', 'void main(void) {', '   gl_FragColor = texture2D(uSampler, vTextureCoord) * vColor ;', '}'];
	
	        /**
	         * A local texture counter for multi-texture shaders.
	         * @property textureCount
	         * @type Number
	         */
	        this.textureCount = 0;
	
	        /**
	         * A local flag
	         * @property firstRun
	         * @type Boolean
	         * @private
	         */
	        this.firstRun = true;
	
	        /**
	         * A dirty flag
	         * @property dirty
	         * @type Boolean
	         */
	        this.dirty = true;
	
	        /**
	         * Uniform attributes cache.
	         * @property attributes
	         * @type Array
	         * @private
	         */
	        this.attributes = [];
	
	        this.init();
	    };
	
	    PIXI.PixiShader.prototype.constructor = PIXI.PixiShader;
	
	    /**
	    * Initialises the shader.
	    *
	    * @method init
	    */
	    PIXI.PixiShader.prototype.init = function () {
	        var gl = this.gl;
	
	        var program = PIXI.compileProgram(gl, this.vertexSrc || PIXI.PixiShader.defaultVertexSrc, this.fragmentSrc);
	
	        gl.useProgram(program);
	
	        // get and store the uniforms for the shader
	        this.uSampler = gl.getUniformLocation(program, 'uSampler');
	        this.projectionVector = gl.getUniformLocation(program, 'projectionVector');
	        this.offsetVector = gl.getUniformLocation(program, 'offsetVector');
	        this.dimensions = gl.getUniformLocation(program, 'dimensions');
	
	        // get and store the attributes
	        this.aVertexPosition = gl.getAttribLocation(program, 'aVertexPosition');
	        this.aTextureCoord = gl.getAttribLocation(program, 'aTextureCoord');
	        this.colorAttribute = gl.getAttribLocation(program, 'aColor');
	
	        // Begin worst hack eva //
	
	        // WHY??? ONLY on my chrome pixel the line above returns -1 when using filters?
	        // maybe its something to do with the current state of the gl context.
	        // I'm convinced this is a bug in the chrome browser as there is NO reason why this should be returning -1 especially as it only manifests on my chrome pixel
	        // If theres any webGL people that know why could happen please help :)
	        if (this.colorAttribute === -1) {
	            this.colorAttribute = 2;
	        }
	
	        this.attributes = [this.aVertexPosition, this.aTextureCoord, this.colorAttribute];
	
	        // End worst hack eva //
	
	        // add those custom shaders!
	        for (var key in this.uniforms) {
	            // get the uniform locations..
	            this.uniforms[key].uniformLocation = gl.getUniformLocation(program, key);
	        }
	
	        this.initUniforms();
	
	        this.program = program;
	    };
	
	    /**
	    * Initialises the shader uniform values.
	    *
	    * Uniforms are specified in the GLSL_ES Specification: http://www.khronos.org/registry/webgl/specs/latest/1.0/
	    * http://www.khronos.org/registry/gles/specs/2.0/GLSL_ES_Specification_1.0.17.pdf
	    *
	    * @method initUniforms
	    */
	    PIXI.PixiShader.prototype.initUniforms = function () {
	        this.textureCount = 1;
	        var gl = this.gl;
	        var uniform;
	
	        for (var key in this.uniforms) {
	            uniform = this.uniforms[key];
	
	            var type = uniform.type;
	
	            if (type === 'sampler2D') {
	                uniform._init = false;
	
	                if (uniform.value !== null) {
	                    this.initSampler2D(uniform);
	                }
	            } else if (type === 'mat2' || type === 'mat3' || type === 'mat4') {
	                //  These require special handling
	                uniform.glMatrix = true;
	                uniform.glValueLength = 1;
	
	                if (type === 'mat2') {
	                    uniform.glFunc = gl.uniformMatrix2fv;
	                } else if (type === 'mat3') {
	                    uniform.glFunc = gl.uniformMatrix3fv;
	                } else if (type === 'mat4') {
	                    uniform.glFunc = gl.uniformMatrix4fv;
	                }
	            } else {
	                //  GL function reference
	                uniform.glFunc = gl['uniform' + type];
	
	                if (type === '2f' || type === '2i') {
	                    uniform.glValueLength = 2;
	                } else if (type === '3f' || type === '3i') {
	                    uniform.glValueLength = 3;
	                } else if (type === '4f' || type === '4i') {
	                    uniform.glValueLength = 4;
	                } else {
	                    uniform.glValueLength = 1;
	                }
	            }
	        }
	    };
	
	    /**
	    * Initialises a Sampler2D uniform (which may only be available later on after initUniforms once the texture has loaded)
	    *
	    * @method initSampler2D
	    */
	    PIXI.PixiShader.prototype.initSampler2D = function (uniform) {
	        if (!uniform.value || !uniform.value.baseTexture || !uniform.value.baseTexture.hasLoaded) {
	            return;
	        }
	
	        var gl = this.gl;
	
	        gl.activeTexture(gl['TEXTURE' + this.textureCount]);
	        gl.bindTexture(gl.TEXTURE_2D, uniform.value.baseTexture._glTextures[gl.id]);
	
	        //  Extended texture data
	        if (uniform.textureData) {
	            var data = uniform.textureData;
	
	            // GLTexture = mag linear, min linear_mipmap_linear, wrap repeat + gl.generateMipmap(gl.TEXTURE_2D);
	            // GLTextureLinear = mag/min linear, wrap clamp
	            // GLTextureNearestRepeat = mag/min NEAREST, wrap repeat
	            // GLTextureNearest = mag/min nearest, wrap clamp
	            // AudioTexture = whatever + luminance + width 512, height 2, border 0
	            // KeyTexture = whatever + luminance + width 256, height 2, border 0
	
	            //  magFilter can be: gl.LINEAR, gl.LINEAR_MIPMAP_LINEAR or gl.NEAREST
	            //  wrapS/T can be: gl.CLAMP_TO_EDGE or gl.REPEAT
	
	            var magFilter = data.magFilter ? data.magFilter : gl.LINEAR;
	            var minFilter = data.minFilter ? data.minFilter : gl.LINEAR;
	            var wrapS = data.wrapS ? data.wrapS : gl.CLAMP_TO_EDGE;
	            var wrapT = data.wrapT ? data.wrapT : gl.CLAMP_TO_EDGE;
	            var format = data.luminance ? gl.LUMINANCE : gl.RGBA;
	
	            if (data.repeat) {
	                wrapS = gl.REPEAT;
	                wrapT = gl.REPEAT;
	            }
	
	            gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, !!data.flipY);
	
	            if (data.width) {
	                var width = data.width ? data.width : 512;
	                var height = data.height ? data.height : 2;
	                var border = data.border ? data.border : 0;
	
	                // void texImage2D(GLenum target, GLint level, GLenum internalformat, GLsizei width, GLsizei height, GLint border, GLenum format, GLenum type, ArrayBufferView? pixels);
	                gl.texImage2D(gl.TEXTURE_2D, 0, format, width, height, border, format, gl.UNSIGNED_BYTE, null);
	            } else {
	                //  void texImage2D(GLenum target, GLint level, GLenum internalformat, GLenum format, GLenum type, ImageData? pixels);
	                gl.texImage2D(gl.TEXTURE_2D, 0, format, gl.RGBA, gl.UNSIGNED_BYTE, uniform.value.baseTexture.source);
	            }
	
	            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, magFilter);
	            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, minFilter);
	            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, wrapS);
	            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, wrapT);
	        }
	
	        gl.uniform1i(uniform.uniformLocation, this.textureCount);
	
	        uniform._init = true;
	
	        this.textureCount++;
	    };
	
	    /**
	    * Updates the shader uniform values.
	    *
	    * @method syncUniforms
	    */
	    PIXI.PixiShader.prototype.syncUniforms = function () {
	        this.textureCount = 1;
	        var uniform;
	        var gl = this.gl;
	
	        //  This would probably be faster in an array and it would guarantee key order
	        for (var key in this.uniforms) {
	            uniform = this.uniforms[key];
	
	            if (uniform.glValueLength === 1) {
	                if (uniform.glMatrix === true) {
	                    uniform.glFunc.call(gl, uniform.uniformLocation, uniform.transpose, uniform.value);
	                } else {
	                    uniform.glFunc.call(gl, uniform.uniformLocation, uniform.value);
	                }
	            } else if (uniform.glValueLength === 2) {
	                uniform.glFunc.call(gl, uniform.uniformLocation, uniform.value.x, uniform.value.y);
	            } else if (uniform.glValueLength === 3) {
	                uniform.glFunc.call(gl, uniform.uniformLocation, uniform.value.x, uniform.value.y, uniform.value.z);
	            } else if (uniform.glValueLength === 4) {
	                uniform.glFunc.call(gl, uniform.uniformLocation, uniform.value.x, uniform.value.y, uniform.value.z, uniform.value.w);
	            } else if (uniform.type === 'sampler2D') {
	                if (uniform._init) {
	                    gl.activeTexture(gl['TEXTURE' + this.textureCount]);
	
	                    if (uniform.value.baseTexture._dirty[gl.id]) {
	                        PIXI.instances[gl.id].updateTexture(uniform.value.baseTexture);
	                    } else {
	                        // bind the current texture
	                        gl.bindTexture(gl.TEXTURE_2D, uniform.value.baseTexture._glTextures[gl.id]);
	                    }
	
	                    //  gl.bindTexture(gl.TEXTURE_2D, uniform.value.baseTexture._glTextures[gl.id] || PIXI.createWebGLTexture( uniform.value.baseTexture, gl));
	                    gl.uniform1i(uniform.uniformLocation, this.textureCount);
	                    this.textureCount++;
	                } else {
	                    this.initSampler2D(uniform);
	                }
	            }
	        }
	    };
	
	    /**
	    * Destroys the shader.
	    *
	    * @method destroy
	    */
	    PIXI.PixiShader.prototype.destroy = function () {
	        this.gl.deleteProgram(this.program);
	        this.uniforms = null;
	        this.gl = null;
	
	        this.attributes = null;
	    };
	
	    /**
	    * The Default Vertex shader source.
	    *
	    * @property defaultVertexSrc
	    * @type String
	    */
	    PIXI.PixiShader.defaultVertexSrc = ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'attribute vec4 aColor;', 'uniform vec2 projectionVector;', 'uniform vec2 offsetVector;', 'varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'const vec2 center = vec2(-1.0, 1.0);', 'void main(void) {', '   gl_Position = vec4( ((aVertexPosition + offsetVector) / projectionVector) + center , 0.0, 1.0);', '   vTextureCoord = aTextureCoord;', '   vColor = vec4(aColor.rgb * aColor.a, aColor.a);', '}'];
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	    * @class PixiFastShader
	    * @constructor
	    * @param gl {WebGLContext} the current WebGL drawing context
	    */
	    PIXI.PixiFastShader = function (gl) {
	        /**
	         * @property _UID
	         * @type Number
	         * @private
	         */
	        this._UID = PIXI._UID++;
	
	        /**
	         * @property gl
	         * @type WebGLContext
	         */
	        this.gl = gl;
	
	        /**
	         * The WebGL program.
	         * @property program
	         * @type Any
	         */
	        this.program = null;
	
	        /**
	         * The fragment shader.
	         * @property fragmentSrc
	         * @type Array
	         */
	        this.fragmentSrc = ['precision lowp float;', 'varying vec2 vTextureCoord;', 'varying float vColor;', 'uniform sampler2D uSampler;', 'void main(void) {', '   gl_FragColor = texture2D(uSampler, vTextureCoord) * vColor ;', '}'];
	
	        /**
	         * The vertex shader.
	         * @property vertexSrc
	         * @type Array
	         */
	        this.vertexSrc = ['attribute vec2 aVertexPosition;', 'attribute vec2 aPositionCoord;', 'attribute vec2 aScale;', 'attribute float aRotation;', 'attribute vec2 aTextureCoord;', 'attribute float aColor;', 'uniform vec2 projectionVector;', 'uniform vec2 offsetVector;', 'uniform mat3 uMatrix;', 'varying vec2 vTextureCoord;', 'varying float vColor;', 'const vec2 center = vec2(-1.0, 1.0);', 'void main(void) {', '   vec2 v;', '   vec2 sv = aVertexPosition * aScale;', '   v.x = (sv.x) * cos(aRotation) - (sv.y) * sin(aRotation);', '   v.y = (sv.x) * sin(aRotation) + (sv.y) * cos(aRotation);', '   v = ( uMatrix * vec3(v + aPositionCoord , 1.0) ).xy ;', '   gl_Position = vec4( ( v / projectionVector) + center , 0.0, 1.0);', '   vTextureCoord = aTextureCoord;',
	        //  '   vec3 color = mod(vec3(aColor.y/65536.0, aColor.y/256.0, aColor.y), 256.0) / 256.0;',
	        '   vColor = aColor;', '}'];
	
	        /**
	         * A local texture counter for multi-texture shaders.
	         * @property textureCount
	         * @type Number
	         */
	        this.textureCount = 0;
	
	        this.init();
	    };
	
	    PIXI.PixiFastShader.prototype.constructor = PIXI.PixiFastShader;
	
	    /**
	    * Initialises the shader.
	    * 
	    * @method init
	    */
	    PIXI.PixiFastShader.prototype.init = function () {
	        var gl = this.gl;
	
	        var program = PIXI.compileProgram(gl, this.vertexSrc, this.fragmentSrc);
	
	        gl.useProgram(program);
	
	        // get and store the uniforms for the shader
	        this.uSampler = gl.getUniformLocation(program, 'uSampler');
	
	        this.projectionVector = gl.getUniformLocation(program, 'projectionVector');
	        this.offsetVector = gl.getUniformLocation(program, 'offsetVector');
	        this.dimensions = gl.getUniformLocation(program, 'dimensions');
	        this.uMatrix = gl.getUniformLocation(program, 'uMatrix');
	
	        // get and store the attributes
	        this.aVertexPosition = gl.getAttribLocation(program, 'aVertexPosition');
	        this.aPositionCoord = gl.getAttribLocation(program, 'aPositionCoord');
	
	        this.aScale = gl.getAttribLocation(program, 'aScale');
	        this.aRotation = gl.getAttribLocation(program, 'aRotation');
	
	        this.aTextureCoord = gl.getAttribLocation(program, 'aTextureCoord');
	        this.colorAttribute = gl.getAttribLocation(program, 'aColor');
	
	        // Begin worst hack eva //
	
	        // WHY??? ONLY on my chrome pixel the line above returns -1 when using filters?
	        // maybe its somthing to do with the current state of the gl context.
	        // Im convinced this is a bug in the chrome browser as there is NO reason why this should be returning -1 especially as it only manifests on my chrome pixel
	        // If theres any webGL people that know why could happen please help :)
	        if (this.colorAttribute === -1) {
	            this.colorAttribute = 2;
	        }
	
	        this.attributes = [this.aVertexPosition, this.aPositionCoord, this.aScale, this.aRotation, this.aTextureCoord, this.colorAttribute];
	
	        // End worst hack eva //
	
	        this.program = program;
	    };
	
	    /**
	    * Destroys the shader.
	    * 
	    * @method destroy
	    */
	    PIXI.PixiFastShader.prototype.destroy = function () {
	        this.gl.deleteProgram(this.program);
	        this.uniforms = null;
	        this.gl = null;
	
	        this.attributes = null;
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	    * @class StripShader
	    * @constructor
	    * @param gl {WebGLContext} the current WebGL drawing context
	    */
	    PIXI.StripShader = function (gl) {
	        /**
	         * @property _UID
	         * @type Number
	         * @private
	         */
	        this._UID = PIXI._UID++;
	
	        /**
	         * @property gl
	         * @type WebGLContext
	         */
	        this.gl = gl;
	
	        /**
	         * The WebGL program.
	         * @property program
	         * @type Any
	         */
	        this.program = null;
	
	        /**
	         * The fragment shader.
	         * @property fragmentSrc
	         * @type Array
	         */
	        this.fragmentSrc = ['precision mediump float;', 'varying vec2 vTextureCoord;',
	        //   'varying float vColor;',
	        'uniform float alpha;', 'uniform sampler2D uSampler;', 'void main(void) {', '   gl_FragColor = texture2D(uSampler, vec2(vTextureCoord.x, vTextureCoord.y)) * alpha;',
	        //  '   gl_FragColor = vec4(1.0, 0.0, 0.0, 1.0);',//gl_FragColor * alpha;',
	        '}'];
	
	        /**
	         * The vertex shader.
	         * @property vertexSrc
	         * @type Array
	         */
	        this.vertexSrc = ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'uniform mat3 translationMatrix;', 'uniform vec2 projectionVector;', 'uniform vec2 offsetVector;',
	        //  'uniform float alpha;',
	        // 'uniform vec3 tint;',
	        'varying vec2 vTextureCoord;',
	        //  'varying vec4 vColor;',
	
	        'void main(void) {', '   vec3 v = translationMatrix * vec3(aVertexPosition , 1.0);', '   v -= offsetVector.xyx;', '   gl_Position = vec4( v.x / projectionVector.x -1.0, v.y / -projectionVector.y + 1.0 , 0.0, 1.0);', '   vTextureCoord = aTextureCoord;',
	        // '   vColor = aColor * vec4(tint * alpha, alpha);',
	        '}'];
	
	        this.init();
	    };
	
	    PIXI.StripShader.prototype.constructor = PIXI.StripShader;
	
	    /**
	    * Initialises the shader.
	    * 
	    * @method init
	    */
	    PIXI.StripShader.prototype.init = function () {
	        var gl = this.gl;
	
	        var program = PIXI.compileProgram(gl, this.vertexSrc, this.fragmentSrc);
	        gl.useProgram(program);
	
	        // get and store the uniforms for the shader
	        this.uSampler = gl.getUniformLocation(program, 'uSampler');
	        this.projectionVector = gl.getUniformLocation(program, 'projectionVector');
	        this.offsetVector = gl.getUniformLocation(program, 'offsetVector');
	        this.colorAttribute = gl.getAttribLocation(program, 'aColor');
	        //this.dimensions = gl.getUniformLocation(this.program, 'dimensions');
	
	        // get and store the attributes
	        this.aVertexPosition = gl.getAttribLocation(program, 'aVertexPosition');
	        this.aTextureCoord = gl.getAttribLocation(program, 'aTextureCoord');
	
	        this.attributes = [this.aVertexPosition, this.aTextureCoord];
	
	        this.translationMatrix = gl.getUniformLocation(program, 'translationMatrix');
	        this.alpha = gl.getUniformLocation(program, 'alpha');
	
	        this.program = program;
	    };
	
	    /**
	    * Destroys the shader.
	    * 
	    * @method destroy
	    */
	    PIXI.StripShader.prototype.destroy = function () {
	        this.gl.deleteProgram(this.program);
	        this.uniforms = null;
	        this.gl = null;
	
	        this.attribute = null;
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	    * @class PrimitiveShader
	    * @constructor
	    * @param gl {WebGLContext} the current WebGL drawing context
	    */
	    PIXI.PrimitiveShader = function (gl) {
	        /**
	         * @property _UID
	         * @type Number
	         * @private
	         */
	        this._UID = PIXI._UID++;
	
	        /**
	         * @property gl
	         * @type WebGLContext
	         */
	        this.gl = gl;
	
	        /**
	         * The WebGL program.
	         * @property program
	         * @type Any
	         */
	        this.program = null;
	
	        /**
	         * The fragment shader.
	         * @property fragmentSrc
	         * @type Array
	         */
	        this.fragmentSrc = ['precision mediump float;', 'varying vec4 vColor;', 'void main(void) {', '   gl_FragColor = vColor;', '}'];
	
	        /**
	         * The vertex shader.
	         * @property vertexSrc
	         * @type Array
	         */
	        this.vertexSrc = ['attribute vec2 aVertexPosition;', 'attribute vec4 aColor;', 'uniform mat3 translationMatrix;', 'uniform vec2 projectionVector;', 'uniform vec2 offsetVector;', 'uniform float alpha;', 'uniform float flipY;', 'uniform vec3 tint;', 'varying vec4 vColor;', 'void main(void) {', '   vec3 v = translationMatrix * vec3(aVertexPosition , 1.0);', '   v -= offsetVector.xyx;', '   gl_Position = vec4( v.x / projectionVector.x -1.0, (v.y / projectionVector.y * -flipY) + flipY , 0.0, 1.0);', '   vColor = aColor * vec4(tint * alpha, alpha);', '}'];
	
	        this.init();
	    };
	
	    PIXI.PrimitiveShader.prototype.constructor = PIXI.PrimitiveShader;
	
	    /**
	    * Initialises the shader.
	    * 
	    * @method init
	    */
	    PIXI.PrimitiveShader.prototype.init = function () {
	        var gl = this.gl;
	
	        var program = PIXI.compileProgram(gl, this.vertexSrc, this.fragmentSrc);
	        gl.useProgram(program);
	
	        // get and store the uniforms for the shader
	        this.projectionVector = gl.getUniformLocation(program, 'projectionVector');
	        this.offsetVector = gl.getUniformLocation(program, 'offsetVector');
	        this.tintColor = gl.getUniformLocation(program, 'tint');
	        this.flipY = gl.getUniformLocation(program, 'flipY');
	
	        // get and store the attributes
	        this.aVertexPosition = gl.getAttribLocation(program, 'aVertexPosition');
	        this.colorAttribute = gl.getAttribLocation(program, 'aColor');
	
	        this.attributes = [this.aVertexPosition, this.colorAttribute];
	
	        this.translationMatrix = gl.getUniformLocation(program, 'translationMatrix');
	        this.alpha = gl.getUniformLocation(program, 'alpha');
	
	        this.program = program;
	    };
	
	    /**
	    * Destroys the shader.
	    * 
	    * @method destroy
	    */
	    PIXI.PrimitiveShader.prototype.destroy = function () {
	        this.gl.deleteProgram(this.program);
	        this.uniforms = null;
	        this.gl = null;
	
	        this.attributes = null;
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	    * @class ComplexPrimitiveShader
	    * @constructor
	    * @param gl {WebGLContext} the current WebGL drawing context
	    */
	    PIXI.ComplexPrimitiveShader = function (gl) {
	        /**
	         * @property _UID
	         * @type Number
	         * @private
	         */
	        this._UID = PIXI._UID++;
	
	        /**
	         * @property gl
	         * @type WebGLContext
	         */
	        this.gl = gl;
	
	        /**
	         * The WebGL program.
	         * @property program
	         * @type Any
	         */
	        this.program = null;
	
	        /**
	         * The fragment shader.
	         * @property fragmentSrc
	         * @type Array
	         */
	        this.fragmentSrc = ['precision mediump float;', 'varying vec4 vColor;', 'void main(void) {', '   gl_FragColor = vColor;', '}'];
	
	        /**
	         * The vertex shader.
	         * @property vertexSrc
	         * @type Array
	         */
	        this.vertexSrc = ['attribute vec2 aVertexPosition;',
	        //'attribute vec4 aColor;',
	        'uniform mat3 translationMatrix;', 'uniform vec2 projectionVector;', 'uniform vec2 offsetVector;', 'uniform vec3 tint;', 'uniform float alpha;', 'uniform vec3 color;', 'uniform float flipY;', 'varying vec4 vColor;', 'void main(void) {', '   vec3 v = translationMatrix * vec3(aVertexPosition , 1.0);', '   v -= offsetVector.xyx;', '   gl_Position = vec4( v.x / projectionVector.x -1.0, (v.y / projectionVector.y * -flipY) + flipY , 0.0, 1.0);', '   vColor = vec4(color * alpha * tint, alpha);', //" * vec4(tint * alpha, alpha);',
	        '}'];
	
	        this.init();
	    };
	
	    PIXI.ComplexPrimitiveShader.prototype.constructor = PIXI.ComplexPrimitiveShader;
	
	    /**
	    * Initialises the shader.
	    * 
	    * @method init
	    */
	    PIXI.ComplexPrimitiveShader.prototype.init = function () {
	        var gl = this.gl;
	
	        var program = PIXI.compileProgram(gl, this.vertexSrc, this.fragmentSrc);
	        gl.useProgram(program);
	
	        // get and store the uniforms for the shader
	        this.projectionVector = gl.getUniformLocation(program, 'projectionVector');
	        this.offsetVector = gl.getUniformLocation(program, 'offsetVector');
	        this.tintColor = gl.getUniformLocation(program, 'tint');
	        this.color = gl.getUniformLocation(program, 'color');
	        this.flipY = gl.getUniformLocation(program, 'flipY');
	
	        // get and store the attributes
	        this.aVertexPosition = gl.getAttribLocation(program, 'aVertexPosition');
	        // this.colorAttribute = gl.getAttribLocation(program, 'aColor');
	
	        this.attributes = [this.aVertexPosition, this.colorAttribute];
	
	        this.translationMatrix = gl.getUniformLocation(program, 'translationMatrix');
	        this.alpha = gl.getUniformLocation(program, 'alpha');
	
	        this.program = program;
	    };
	
	    /**
	    * Destroys the shader.
	    * 
	    * @method destroy
	    */
	    PIXI.ComplexPrimitiveShader.prototype.destroy = function () {
	        this.gl.deleteProgram(this.program);
	        this.uniforms = null;
	        this.gl = null;
	
	        this.attribute = null;
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    PIXI.glContexts = []; // this is where we store the webGL contexts for easy access.
	    PIXI.instances = [];
	
	    /**
	     * The WebGLRenderer draws the stage and all its content onto a webGL enabled canvas. This renderer
	     * should be used for browsers that support webGL. This Render works by automatically managing webGLBatchs.
	     * So no need for Sprite Batches or Sprite Clouds.
	     * Don't forget to add the view to your DOM or you will not see anything :)
	     *
	     * @class WebGLRenderer
	     * @constructor
	     * @param game {Phaser.Game} A reference to the Phaser Game instance
	     */
	    PIXI.WebGLRenderer = function (game) {
	
	        /**
	        * @property {Phaser.Game} game - A reference to the Phaser Game instance.
	        */
	        this.game = game;
	
	        if (!PIXI.defaultRenderer) {
	            PIXI.defaultRenderer = this;
	        }
	
	        /**
	         * @property type
	         * @type Number
	         */
	        this.type = PIXI.WEBGL_RENDERER;
	
	        /**
	         * The resolution of the renderer
	         *
	         * @property resolution
	         * @type Number
	         * @default 1
	         */
	        this.resolution = game.resolution;
	
	        /**
	         * Whether the render view is transparent
	         *
	         * @property transparent
	         * @type Boolean
	         */
	        this.transparent = game.transparent;
	
	        /**
	         * Whether the render view should be resized automatically
	         *
	         * @property autoResize
	         * @type Boolean
	         */
	        this.autoResize = false;
	
	        /**
	         * The value of the preserveDrawingBuffer flag affects whether or not the contents of the stencil buffer is retained after rendering.
	         *
	         * @property preserveDrawingBuffer
	         * @type Boolean
	         */
	        this.preserveDrawingBuffer = game.preserveDrawingBuffer;
	
	        /**
	         * This sets if the WebGLRenderer will clear the context texture or not before the new render pass. If true:
	         * If the Stage is NOT transparent, Pixi will clear to alpha (0, 0, 0, 0).
	         * If the Stage is transparent, Pixi will clear to the target Stage's background color.
	         * Disable this by setting this to false. For example: if your game has a canvas filling background image, you often don't need this set.
	         *
	         * @property clearBeforeRender
	         * @type Boolean
	         * @default
	         */
	        this.clearBeforeRender = game.clearBeforeRender;
	
	        /**
	         * The width of the canvas view
	         *
	         * @property width
	         * @type Number
	         */
	        this.width = game.width;
	
	        /**
	         * The height of the canvas view
	         *
	         * @property height
	         * @type Number
	         */
	        this.height = game.height;
	
	        /**
	         * The canvas element that everything is drawn to
	         *
	         * @property view
	         * @type HTMLCanvasElement
	         */
	        this.view = game.canvas;
	
	        /**
	         * @property _contextOptions
	         * @type Object
	         * @private
	         */
	        this._contextOptions = {
	            alpha: this.transparent,
	            antialias: game.antialias,
	            premultipliedAlpha: this.transparent && this.transparent !== 'notMultiplied',
	            stencil: true,
	            preserveDrawingBuffer: this.preserveDrawingBuffer
	        };
	
	        /**
	         * @property projection
	         * @type Point
	         */
	        this.projection = new PIXI.Point();
	
	        /**
	         * @property offset
	         * @type Point
	         */
	        this.offset = new PIXI.Point();
	
	        // time to create the render managers! each one focuses on managing a state in webGL
	
	        /**
	         * Deals with managing the shader programs and their attribs
	         * @property shaderManager
	         * @type WebGLShaderManager
	         */
	        this.shaderManager = new PIXI.WebGLShaderManager();
	
	        /**
	         * Manages the rendering of sprites
	         * @property spriteBatch
	         * @type WebGLSpriteBatch
	         */
	        this.spriteBatch = new PIXI.WebGLSpriteBatch();
	
	        /**
	         * Manages the masks using the stencil buffer
	         * @property maskManager
	         * @type WebGLMaskManager
	         */
	        this.maskManager = new PIXI.WebGLMaskManager();
	
	        /**
	         * Manages the filters
	         * @property filterManager
	         * @type WebGLFilterManager
	         */
	        this.filterManager = new PIXI.WebGLFilterManager();
	
	        /**
	         * Manages the stencil buffer
	         * @property stencilManager
	         * @type WebGLStencilManager
	         */
	        this.stencilManager = new PIXI.WebGLStencilManager();
	
	        /**
	         * Manages the blendModes
	         * @property blendModeManager
	         * @type WebGLBlendModeManager
	         */
	        this.blendModeManager = new PIXI.WebGLBlendModeManager();
	
	        /**
	         * @property renderSession
	         * @type Object
	         */
	        this.renderSession = {};
	
	        //  Needed?
	        this.renderSession.game = this.game;
	        this.renderSession.gl = this.gl;
	        this.renderSession.drawCount = 0;
	        this.renderSession.shaderManager = this.shaderManager;
	        this.renderSession.maskManager = this.maskManager;
	        this.renderSession.filterManager = this.filterManager;
	        this.renderSession.blendModeManager = this.blendModeManager;
	        this.renderSession.spriteBatch = this.spriteBatch;
	        this.renderSession.stencilManager = this.stencilManager;
	        this.renderSession.renderer = this;
	        this.renderSession.resolution = this.resolution;
	
	        // time init the context..
	        this.initContext();
	
	        // map some webGL blend modes..
	        this.mapBlendModes();
	    };
	
	    // constructor
	    PIXI.WebGLRenderer.prototype.constructor = PIXI.WebGLRenderer;
	
	    /**
	    * @method initContext
	    */
	    PIXI.WebGLRenderer.prototype.initContext = function () {
	        var gl = this.view.getContext('webgl', this._contextOptions) || this.view.getContext('experimental-webgl', this._contextOptions);
	
	        this.gl = gl;
	
	        if (!gl) {
	            // fail, not able to get a context
	            throw new Error('This browser does not support webGL. Try using the canvas renderer');
	        }
	
	        this.glContextId = gl.id = PIXI.WebGLRenderer.glContextId++;
	
	        PIXI.glContexts[this.glContextId] = gl;
	
	        PIXI.instances[this.glContextId] = this;
	
	        // set up the default pixi settings..
	        gl.disable(gl.DEPTH_TEST);
	        gl.disable(gl.CULL_FACE);
	        gl.enable(gl.BLEND);
	
	        // need to set the context for all the managers...
	        this.shaderManager.setContext(gl);
	        this.spriteBatch.setContext(gl);
	        this.maskManager.setContext(gl);
	        this.filterManager.setContext(gl);
	        this.blendModeManager.setContext(gl);
	        this.stencilManager.setContext(gl);
	
	        this.renderSession.gl = this.gl;
	
	        // now resize and we are good to go!
	        this.resize(this.width, this.height);
	    };
	
	    /**
	     * Renders the stage to its webGL view
	     *
	     * @method render
	     * @param stage {Stage} the Stage element to be rendered
	     */
	    PIXI.WebGLRenderer.prototype.render = function (stage) {
	        // no point rendering if our context has been blown up!
	        if (this.contextLost) {
	            return;
	        }
	
	        var gl = this.gl;
	
	        // -- Does this need to be set every frame? -- //
	        gl.viewport(0, 0, this.width, this.height);
	
	        // make sure we are bound to the main frame buffer
	        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
	
	        if (this.game.clearBeforeRender) {
	            gl.clearColor(stage._bgColor.r, stage._bgColor.g, stage._bgColor.b, stage._bgColor.a);
	
	            gl.clear(gl.COLOR_BUFFER_BIT);
	        }
	
	        this.offset.x = this.game.camera._shake.x;
	        this.offset.y = this.game.camera._shake.y;
	
	        this.renderDisplayObject(stage, this.projection);
	    };
	
	    /**
	     * Renders a Display Object.
	     *
	     * @method renderDisplayObject
	     * @param displayObject {DisplayObject} The DisplayObject to render
	     * @param projection {Point} The projection
	     * @param buffer {Array} a standard WebGL buffer
	     */
	    PIXI.WebGLRenderer.prototype.renderDisplayObject = function (displayObject, projection, buffer, matrix) {
	        this.renderSession.blendModeManager.setBlendMode(PIXI.blendModes.NORMAL);
	
	        // reset the render session data..
	        this.renderSession.drawCount = 0;
	
	        // make sure to flip the Y if using a render texture..
	        this.renderSession.flipY = buffer ? -1 : 1;
	
	        // set the default projection
	        this.renderSession.projection = projection;
	
	        //set the default offset
	        this.renderSession.offset = this.offset;
	
	        // start the sprite batch
	        this.spriteBatch.begin(this.renderSession);
	
	        // start the filter manager
	        this.filterManager.begin(this.renderSession, buffer);
	
	        // render the scene!
	        displayObject._renderWebGL(this.renderSession, matrix);
	
	        // finish the sprite batch
	        this.spriteBatch.end();
	    };
	
	    /**
	     * Resizes the webGL view to the specified width and height.
	     *
	     * @method resize
	     * @param width {Number} the new width of the webGL view
	     * @param height {Number} the new height of the webGL view
	     */
	    PIXI.WebGLRenderer.prototype.resize = function (width, height) {
	        this.width = width * this.resolution;
	        this.height = height * this.resolution;
	
	        this.view.width = this.width;
	        this.view.height = this.height;
	
	        if (this.autoResize) {
	            this.view.style.width = this.width / this.resolution + 'px';
	            this.view.style.height = this.height / this.resolution + 'px';
	        }
	
	        this.gl.viewport(0, 0, this.width, this.height);
	
	        this.projection.x = this.width / 2 / this.resolution;
	        this.projection.y = -this.height / 2 / this.resolution;
	    };
	
	    /**
	     * Updates and Creates a WebGL texture for the renderers context.
	     *
	     * @method updateTexture
	     * @param texture {Texture} the texture to update
	     * @return {boolean} True if the texture was successfully bound, otherwise false.
	     */
	    PIXI.WebGLRenderer.prototype.updateTexture = function (texture) {
	        if (!texture.hasLoaded) {
	            return false;
	        }
	
	        var gl = this.gl;
	
	        if (!texture._glTextures[gl.id]) {
	            texture._glTextures[gl.id] = gl.createTexture();
	        }
	
	        gl.bindTexture(gl.TEXTURE_2D, texture._glTextures[gl.id]);
	
	        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultipliedAlpha);
	
	        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, texture.source);
	
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, texture.scaleMode === PIXI.scaleModes.LINEAR ? gl.LINEAR : gl.NEAREST);
	
	        if (texture.mipmap && PIXI.isPowerOfTwo(texture.width, texture.height)) {
	            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, texture.scaleMode === PIXI.scaleModes.LINEAR ? gl.LINEAR_MIPMAP_LINEAR : gl.NEAREST_MIPMAP_NEAREST);
	            gl.generateMipmap(gl.TEXTURE_2D);
	        } else {
	            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, texture.scaleMode === PIXI.scaleModes.LINEAR ? gl.LINEAR : gl.NEAREST);
	        }
	
	        if (!texture._powerOf2) {
	            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
	        } else {
	            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
	            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
	        }
	
	        texture._dirty[gl.id] = false;
	
	        // return texture._glTextures[gl.id];
	        return true;
	    };
	
	    /**
	     * Removes everything from the renderer (event listeners, spritebatch, etc...)
	     *
	     * @method destroy
	     */
	    PIXI.WebGLRenderer.prototype.destroy = function () {
	        PIXI.glContexts[this.glContextId] = null;
	
	        this.projection = null;
	        this.offset = null;
	
	        this.shaderManager.destroy();
	        this.spriteBatch.destroy();
	        this.maskManager.destroy();
	        this.filterManager.destroy();
	
	        this.shaderManager = null;
	        this.spriteBatch = null;
	        this.maskManager = null;
	        this.filterManager = null;
	
	        this.gl = null;
	        this.renderSession = null;
	
	        PIXI.CanvasPool.remove(this);
	
	        PIXI.instances[this.glContextId] = null;
	
	        PIXI.WebGLRenderer.glContextId--;
	    };
	
	    /**
	     * Maps Pixi blend modes to WebGL blend modes.
	     *
	     * @method mapBlendModes
	     */
	    PIXI.WebGLRenderer.prototype.mapBlendModes = function () {
	        var gl = this.gl;
	
	        if (!PIXI.blendModesWebGL) {
	            var b = [];
	            var modes = PIXI.blendModes;
	
	            b[modes.NORMAL] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	            b[modes.ADD] = [gl.SRC_ALPHA, gl.DST_ALPHA];
	            b[modes.MULTIPLY] = [gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA];
	            b[modes.SCREEN] = [gl.SRC_ALPHA, gl.ONE];
	            b[modes.OVERLAY] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	            b[modes.DARKEN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	            b[modes.LIGHTEN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	            b[modes.COLOR_DODGE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	            b[modes.COLOR_BURN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	            b[modes.HARD_LIGHT] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	            b[modes.SOFT_LIGHT] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	            b[modes.DIFFERENCE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	            b[modes.EXCLUSION] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	            b[modes.HUE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	            b[modes.SATURATION] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	            b[modes.COLOR] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	            b[modes.LUMINOSITY] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
	
	            PIXI.blendModesWebGL = b;
	        }
	    };
	
	    PIXI.WebGLRenderer.glContextId = 0;
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	    * @class WebGLBlendModeManager
	    * @constructor
	    * @param gl {WebGLContext} the current WebGL drawing context
	    */
	    PIXI.WebGLBlendModeManager = function () {
	        /**
	         * @property currentBlendMode
	         * @type Number
	         */
	        this.currentBlendMode = 99999;
	    };
	
	    PIXI.WebGLBlendModeManager.prototype.constructor = PIXI.WebGLBlendModeManager;
	
	    /**
	     * Sets the WebGL Context.
	     *
	     * @method setContext
	     * @param gl {WebGLContext} the current WebGL drawing context
	     */
	    PIXI.WebGLBlendModeManager.prototype.setContext = function (gl) {
	        this.gl = gl;
	    };
	
	    /**
	    * Sets-up the given blendMode from WebGL's point of view.
	    * 
	    * @method setBlendMode 
	    * @param blendMode {Number} the blendMode, should be a Pixi const, such as PIXI.BlendModes.ADD
	    */
	    PIXI.WebGLBlendModeManager.prototype.setBlendMode = function (blendMode) {
	        if (this.currentBlendMode === blendMode) return false;
	
	        this.currentBlendMode = blendMode;
	
	        var blendModeWebGL = PIXI.blendModesWebGL[this.currentBlendMode];
	
	        if (blendModeWebGL) {
	            this.gl.blendFunc(blendModeWebGL[0], blendModeWebGL[1]);
	        }
	
	        return true;
	    };
	
	    /**
	    * Destroys this object.
	    * 
	    * @method destroy
	    */
	    PIXI.WebGLBlendModeManager.prototype.destroy = function () {
	        this.gl = null;
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	    * @class WebGLMaskManager
	    * @constructor
	    * @private
	    */
	    PIXI.WebGLMaskManager = function () {};
	
	    PIXI.WebGLMaskManager.prototype.constructor = PIXI.WebGLMaskManager;
	
	    /**
	    * Sets the drawing context to the one given in parameter.
	    * 
	    * @method setContext 
	    * @param gl {WebGLContext} the current WebGL drawing context
	    */
	    PIXI.WebGLMaskManager.prototype.setContext = function (gl) {
	        this.gl = gl;
	    };
	
	    /**
	    * Applies the Mask and adds it to the current filter stack.
	    * 
	    * @method pushMask
	    * @param maskData {Array}
	    * @param renderSession {Object}
	    */
	    PIXI.WebGLMaskManager.prototype.pushMask = function (maskData, renderSession) {
	        var gl = renderSession.gl;
	
	        if (maskData.dirty) {
	            PIXI.WebGLGraphics.updateGraphics(maskData, gl);
	        }
	
	        if (maskData._webGL[gl.id] === undefined || maskData._webGL[gl.id].data === undefined || maskData._webGL[gl.id].data.length === 0) {
	            return;
	        }
	
	        renderSession.stencilManager.pushStencil(maskData, maskData._webGL[gl.id].data[0], renderSession);
	    };
	
	    /**
	    * Removes the last filter from the filter stack and doesn't return it.
	    * 
	    * @method popMask
	    * @param maskData {Array}
	    * @param renderSession {Object} an object containing all the useful parameters
	    */
	    PIXI.WebGLMaskManager.prototype.popMask = function (maskData, renderSession) {
	        var gl = this.gl;
	
	        if (maskData._webGL[gl.id] === undefined || maskData._webGL[gl.id].data === undefined || maskData._webGL[gl.id].data.length === 0) {
	            return;
	        }
	
	        renderSession.stencilManager.popStencil(maskData, maskData._webGL[gl.id].data[0], renderSession);
	    };
	
	    /**
	    * Destroys the mask stack.
	    * 
	    * @method destroy
	    */
	    PIXI.WebGLMaskManager.prototype.destroy = function () {
	        this.gl = null;
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	    * @class WebGLStencilManager
	    * @constructor
	    * @private
	    */
	    PIXI.WebGLStencilManager = function () {
	        this.stencilStack = [];
	        this.reverse = true;
	        this.count = 0;
	    };
	
	    /**
	    * Sets the drawing context to the one given in parameter.
	    * 
	    * @method setContext 
	    * @param gl {WebGLContext} the current WebGL drawing context
	    */
	    PIXI.WebGLStencilManager.prototype.setContext = function (gl) {
	        this.gl = gl;
	    };
	
	    /**
	    * Applies the Mask and adds it to the current filter stack.
	    * 
	    * @method pushMask
	    * @param graphics {Graphics}
	    * @param webGLData {Array}
	    * @param renderSession {Object}
	    */
	    PIXI.WebGLStencilManager.prototype.pushStencil = function (graphics, webGLData, renderSession) {
	        var gl = this.gl;
	        this.bindGraphics(graphics, webGLData, renderSession);
	
	        if (this.stencilStack.length === 0) {
	            gl.enable(gl.STENCIL_TEST);
	            gl.clear(gl.STENCIL_BUFFER_BIT);
	            this.reverse = true;
	            this.count = 0;
	        }
	
	        this.stencilStack.push(webGLData);
	
	        var level = this.count;
	
	        gl.colorMask(false, false, false, false);
	
	        gl.stencilFunc(gl.ALWAYS, 0, 0xFF);
	        gl.stencilOp(gl.KEEP, gl.KEEP, gl.INVERT);
	
	        // draw the triangle strip!
	
	        if (webGLData.mode === 1) {
	            gl.drawElements(gl.TRIANGLE_FAN, webGLData.indices.length - 4, gl.UNSIGNED_SHORT, 0);
	
	            if (this.reverse) {
	                gl.stencilFunc(gl.EQUAL, 0xFF - level, 0xFF);
	                gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR);
	            } else {
	                gl.stencilFunc(gl.EQUAL, level, 0xFF);
	                gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
	            }
	
	            // draw a quad to increment..
	            gl.drawElements(gl.TRIANGLE_FAN, 4, gl.UNSIGNED_SHORT, (webGLData.indices.length - 4) * 2);
	
	            if (this.reverse) {
	                gl.stencilFunc(gl.EQUAL, 0xFF - (level + 1), 0xFF);
	            } else {
	                gl.stencilFunc(gl.EQUAL, level + 1, 0xFF);
	            }
	
	            this.reverse = !this.reverse;
	        } else {
	            if (!this.reverse) {
	                gl.stencilFunc(gl.EQUAL, 0xFF - level, 0xFF);
	                gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR);
	            } else {
	                gl.stencilFunc(gl.EQUAL, level, 0xFF);
	                gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
	            }
	
	            gl.drawElements(gl.TRIANGLE_STRIP, webGLData.indices.length, gl.UNSIGNED_SHORT, 0);
	
	            if (!this.reverse) {
	                gl.stencilFunc(gl.EQUAL, 0xFF - (level + 1), 0xFF);
	            } else {
	                gl.stencilFunc(gl.EQUAL, level + 1, 0xFF);
	            }
	        }
	
	        gl.colorMask(true, true, true, true);
	        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
	
	        this.count++;
	    };
	
	    /**
	     * TODO this does not belong here!
	     * 
	     * @method bindGraphics
	     * @param graphics {Graphics}
	     * @param webGLData {Array}
	     * @param renderSession {Object}
	     */
	    PIXI.WebGLStencilManager.prototype.bindGraphics = function (graphics, webGLData, renderSession) {
	        //if(this._currentGraphics === graphics)return;
	        this._currentGraphics = graphics;
	
	        var gl = this.gl;
	
	        // bind the graphics object..
	        var projection = renderSession.projection,
	            offset = renderSession.offset,
	            shader; // = renderSession.shaderManager.primitiveShader;
	
	        if (webGLData.mode === 1) {
	            shader = renderSession.shaderManager.complexPrimitiveShader;
	
	            renderSession.shaderManager.setShader(shader);
	
	            gl.uniform1f(shader.flipY, renderSession.flipY);
	
	            gl.uniformMatrix3fv(shader.translationMatrix, false, graphics.worldTransform.toArray(true));
	
	            gl.uniform2f(shader.projectionVector, projection.x, -projection.y);
	            gl.uniform2f(shader.offsetVector, -offset.x, -offset.y);
	
	            gl.uniform3fv(shader.tintColor, PIXI.hex2rgb(graphics.tint));
	            gl.uniform3fv(shader.color, webGLData.color);
	
	            gl.uniform1f(shader.alpha, graphics.worldAlpha * webGLData.alpha);
	
	            gl.bindBuffer(gl.ARRAY_BUFFER, webGLData.buffer);
	
	            gl.vertexAttribPointer(shader.aVertexPosition, 2, gl.FLOAT, false, 4 * 2, 0);
	
	            // now do the rest..
	            // set the index buffer!
	            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, webGLData.indexBuffer);
	        } else {
	            //renderSession.shaderManager.activatePrimitiveShader();
	            shader = renderSession.shaderManager.primitiveShader;
	            renderSession.shaderManager.setShader(shader);
	
	            gl.uniformMatrix3fv(shader.translationMatrix, false, graphics.worldTransform.toArray(true));
	
	            gl.uniform1f(shader.flipY, renderSession.flipY);
	            gl.uniform2f(shader.projectionVector, projection.x, -projection.y);
	            gl.uniform2f(shader.offsetVector, -offset.x, -offset.y);
	
	            gl.uniform3fv(shader.tintColor, PIXI.hex2rgb(graphics.tint));
	
	            gl.uniform1f(shader.alpha, graphics.worldAlpha);
	
	            gl.bindBuffer(gl.ARRAY_BUFFER, webGLData.buffer);
	
	            gl.vertexAttribPointer(shader.aVertexPosition, 2, gl.FLOAT, false, 4 * 6, 0);
	            gl.vertexAttribPointer(shader.colorAttribute, 4, gl.FLOAT, false, 4 * 6, 2 * 4);
	
	            // set the index buffer!
	            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, webGLData.indexBuffer);
	        }
	    };
	
	    /**
	     * @method popStencil
	     * @param graphics {Graphics}
	     * @param webGLData {Array}
	     * @param renderSession {Object}
	     */
	    PIXI.WebGLStencilManager.prototype.popStencil = function (graphics, webGLData, renderSession) {
	        var gl = this.gl;
	        this.stencilStack.pop();
	
	        this.count--;
	
	        if (this.stencilStack.length === 0) {
	            // the stack is empty!
	            gl.disable(gl.STENCIL_TEST);
	        } else {
	
	            var level = this.count;
	
	            this.bindGraphics(graphics, webGLData, renderSession);
	
	            gl.colorMask(false, false, false, false);
	
	            if (webGLData.mode === 1) {
	                this.reverse = !this.reverse;
	
	                if (this.reverse) {
	                    gl.stencilFunc(gl.EQUAL, 0xFF - (level + 1), 0xFF);
	                    gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
	                } else {
	                    gl.stencilFunc(gl.EQUAL, level + 1, 0xFF);
	                    gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR);
	                }
	
	                // draw a quad to increment..
	                gl.drawElements(gl.TRIANGLE_FAN, 4, gl.UNSIGNED_SHORT, (webGLData.indices.length - 4) * 2);
	
	                gl.stencilFunc(gl.ALWAYS, 0, 0xFF);
	                gl.stencilOp(gl.KEEP, gl.KEEP, gl.INVERT);
	
	                // draw the triangle strip!
	                gl.drawElements(gl.TRIANGLE_FAN, webGLData.indices.length - 4, gl.UNSIGNED_SHORT, 0);
	
	                if (!this.reverse) {
	                    gl.stencilFunc(gl.EQUAL, 0xFF - level, 0xFF);
	                } else {
	                    gl.stencilFunc(gl.EQUAL, level, 0xFF);
	                }
	            } else {
	                //  console.log("<<>>")
	                if (!this.reverse) {
	                    gl.stencilFunc(gl.EQUAL, 0xFF - (level + 1), 0xFF);
	                    gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
	                } else {
	                    gl.stencilFunc(gl.EQUAL, level + 1, 0xFF);
	                    gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR);
	                }
	
	                gl.drawElements(gl.TRIANGLE_STRIP, webGLData.indices.length, gl.UNSIGNED_SHORT, 0);
	
	                if (!this.reverse) {
	                    gl.stencilFunc(gl.EQUAL, 0xFF - level, 0xFF);
	                } else {
	                    gl.stencilFunc(gl.EQUAL, level, 0xFF);
	                }
	            }
	
	            gl.colorMask(true, true, true, true);
	            gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
	        }
	    };
	
	    /**
	    * Destroys the mask stack.
	    * 
	    * @method destroy
	    */
	    PIXI.WebGLStencilManager.prototype.destroy = function () {
	        this.stencilStack = null;
	        this.gl = null;
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	    * @class WebGLShaderManager
	    * @constructor
	    * @private
	    */
	    PIXI.WebGLShaderManager = function () {
	        /**
	         * @property maxAttibs
	         * @type Number
	         */
	        this.maxAttibs = 10;
	
	        /**
	         * @property attribState
	         * @type Array
	         */
	        this.attribState = [];
	
	        /**
	         * @property tempAttribState
	         * @type Array
	         */
	        this.tempAttribState = [];
	
	        for (var i = 0; i < this.maxAttibs; i++) {
	            this.attribState[i] = false;
	        }
	
	        /**
	         * @property stack
	         * @type Array
	         */
	        this.stack = [];
	    };
	
	    PIXI.WebGLShaderManager.prototype.constructor = PIXI.WebGLShaderManager;
	
	    /**
	    * Initialises the context and the properties.
	    * 
	    * @method setContext 
	    * @param gl {WebGLContext} the current WebGL drawing context
	    */
	    PIXI.WebGLShaderManager.prototype.setContext = function (gl) {
	        this.gl = gl;
	
	        // the next one is used for rendering primitives
	        this.primitiveShader = new PIXI.PrimitiveShader(gl);
	
	        // the next one is used for rendering triangle strips
	        this.complexPrimitiveShader = new PIXI.ComplexPrimitiveShader(gl);
	
	        // this shader is used for the default sprite rendering
	        this.defaultShader = new PIXI.PixiShader(gl);
	
	        // this shader is used for the fast sprite rendering
	        this.fastShader = new PIXI.PixiFastShader(gl);
	
	        // the next one is used for rendering triangle strips
	        this.stripShader = new PIXI.StripShader(gl);
	
	        this.setShader(this.defaultShader);
	    };
	
	    /**
	    * Takes the attributes given in parameters.
	    * 
	    * @method setAttribs
	    * @param attribs {Array} attribs 
	    */
	    PIXI.WebGLShaderManager.prototype.setAttribs = function (attribs) {
	        // reset temp state
	        var i;
	
	        for (i = 0; i < this.tempAttribState.length; i++) {
	            this.tempAttribState[i] = false;
	        }
	
	        // set the new attribs
	        for (i = 0; i < attribs.length; i++) {
	            var attribId = attribs[i];
	            this.tempAttribState[attribId] = true;
	        }
	
	        var gl = this.gl;
	
	        for (i = 0; i < this.attribState.length; i++) {
	            if (this.attribState[i] !== this.tempAttribState[i]) {
	                this.attribState[i] = this.tempAttribState[i];
	
	                if (this.tempAttribState[i]) {
	                    gl.enableVertexAttribArray(i);
	                } else {
	                    gl.disableVertexAttribArray(i);
	                }
	            }
	        }
	    };
	
	    /**
	    * Sets the current shader.
	    * 
	    * @method setShader
	    * @param shader {Any}
	    */
	    PIXI.WebGLShaderManager.prototype.setShader = function (shader) {
	        if (this._currentId === shader._UID) return false;
	
	        this._currentId = shader._UID;
	
	        this.currentShader = shader;
	
	        this.gl.useProgram(shader.program);
	        this.setAttribs(shader.attributes);
	
	        return true;
	    };
	
	    /**
	    * Destroys this object.
	    * 
	    * @method destroy
	    */
	    PIXI.WebGLShaderManager.prototype.destroy = function () {
	        this.attribState = null;
	
	        this.tempAttribState = null;
	
	        this.primitiveShader.destroy();
	
	        this.complexPrimitiveShader.destroy();
	
	        this.defaultShader.destroy();
	
	        this.fastShader.destroy();
	
	        this.stripShader.destroy();
	
	        this.gl = null;
	    };
	
	    /**
	     * @author Mat Groves
	     * 
	     * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	     * for creating the original pixi version!
	     * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now share 4 bytes on the vertex buffer
	     * 
	     * Heavily inspired by LibGDX's WebGLSpriteBatch:
	     * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/WebGLSpriteBatch.java
	     */
	
	    /**
	    *
	    * @class WebGLSpriteBatch
	    * @private
	    * @constructor
	    */
	    PIXI.WebGLSpriteBatch = function () {
	        /**
	         * @property vertSize
	         * @type Number
	         */
	        this.vertSize = 5;
	
	        /**
	         * The number of images in the SpriteBatch before it flushes
	         * @property size
	         * @type Number
	         */
	        this.size = 2000; //Math.pow(2, 16) /  this.vertSize;
	
	        //the total number of bytes in our batch
	        var numVerts = this.size * 4 * 4 * this.vertSize;
	        //the total number of indices in our batch
	        var numIndices = this.size * 6;
	
	        /**
	        * Holds the vertices
	        *
	        * @property vertices
	        * @type ArrayBuffer
	        */
	        this.vertices = new PIXI.ArrayBuffer(numVerts);
	
	        /**
	        * View on the vertices as a Float32Array
	        *
	        * @property positions
	        * @type Float32Array
	        */
	        this.positions = new PIXI.Float32Array(this.vertices);
	
	        /**
	        * View on the vertices as a Uint32Array
	        *
	        * @property colors
	        * @type Uint32Array
	        */
	        this.colors = new PIXI.Uint32Array(this.vertices);
	
	        /**
	         * Holds the indices
	         *
	         * @property indices
	         * @type Uint16Array
	         */
	        this.indices = new PIXI.Uint16Array(numIndices);
	
	        /**
	         * @property lastIndexCount
	         * @type Number
	         */
	        this.lastIndexCount = 0;
	
	        for (var i = 0, j = 0; i < numIndices; i += 6, j += 4) {
	            this.indices[i + 0] = j + 0;
	            this.indices[i + 1] = j + 1;
	            this.indices[i + 2] = j + 2;
	            this.indices[i + 3] = j + 0;
	            this.indices[i + 4] = j + 2;
	            this.indices[i + 5] = j + 3;
	        }
	
	        /**
	         * @property drawing
	         * @type Boolean
	         */
	        this.drawing = false;
	
	        /**
	         * @property currentBatchSize
	         * @type Number
	         */
	        this.currentBatchSize = 0;
	
	        /**
	         * @property currentBaseTexture
	         * @type BaseTexture
	         */
	        this.currentBaseTexture = null;
	
	        /**
	         * @property dirty
	         * @type Boolean
	         */
	        this.dirty = true;
	
	        /**
	         * @property textures
	         * @type Array
	         */
	        this.textures = [];
	
	        /**
	         * @property blendModes
	         * @type Array
	         */
	        this.blendModes = [];
	
	        /**
	         * @property shaders
	         * @type Array
	         */
	        this.shaders = [];
	
	        /**
	         * @property sprites
	         * @type Array
	         */
	        this.sprites = [];
	
	        /**
	         * @property defaultShader
	         * @type AbstractFilter
	         */
	        this.defaultShader = new PIXI.AbstractFilter(['precision lowp float;', 'varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'uniform sampler2D uSampler;', 'void main(void) {', '   gl_FragColor = texture2D(uSampler, vTextureCoord) * vColor ;', '}']);
	    };
	
	    /**
	    * @method setContext
	    * @param gl {WebGLContext} the current WebGL drawing context
	    */
	    PIXI.WebGLSpriteBatch.prototype.setContext = function (gl) {
	        this.gl = gl;
	
	        // create a couple of buffers
	        this.vertexBuffer = gl.createBuffer();
	        this.indexBuffer = gl.createBuffer();
	
	        // 65535 is max index, so 65535 / 6 = 10922.
	
	        //upload the index data
	        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer);
	        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this.indices, gl.STATIC_DRAW);
	
	        gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer);
	        gl.bufferData(gl.ARRAY_BUFFER, this.vertices, gl.DYNAMIC_DRAW);
	
	        this.currentBlendMode = 99999;
	
	        var shader = new PIXI.PixiShader(gl);
	
	        shader.fragmentSrc = this.defaultShader.fragmentSrc;
	        shader.uniforms = {};
	        shader.init();
	
	        this.defaultShader.shaders[gl.id] = shader;
	    };
	
	    /**
	    * @method begin
	    * @param renderSession {Object} The RenderSession object
	    */
	    PIXI.WebGLSpriteBatch.prototype.begin = function (renderSession) {
	        this.renderSession = renderSession;
	        this.shader = this.renderSession.shaderManager.defaultShader;
	
	        this.start();
	    };
	
	    /**
	    * @method end
	    */
	    PIXI.WebGLSpriteBatch.prototype.end = function () {
	        this.flush();
	    };
	
	    /**
	    * @method render
	    * @param sprite {Sprite} the sprite to render when using this spritebatch
	    * @param {Matrix} [matrix] - Optional matrix. If provided the Display Object will be rendered using this matrix, otherwise it will use its worldTransform.
	    */
	    PIXI.WebGLSpriteBatch.prototype.render = function (sprite, matrix) {
	        var texture = sprite.texture;
	
	        //  They provided an alternative rendering matrix, so use it
	        var wt = sprite.worldTransform;
	
	        if (matrix) {
	            wt = matrix;
	        }
	
	        // check texture..
	        if (this.currentBatchSize >= this.size) {
	            this.flush();
	            this.currentBaseTexture = texture.baseTexture;
	        }
	
	        // get the uvs for the texture
	        var uvs = texture._uvs;
	
	        // if the uvs have not updated then no point rendering just yet!
	        if (!uvs) {
	            return;
	        }
	
	        var aX = sprite.anchor.x;
	        var aY = sprite.anchor.y;
	
	        var w0, w1, h0, h1;
	
	        if (texture.trim) {
	            // if the sprite is trimmed then we need to add the extra space before transforming the sprite coords.
	            var trim = texture.trim;
	
	            w1 = trim.x - aX * trim.width;
	            w0 = w1 + texture.crop.width;
	
	            h1 = trim.y - aY * trim.height;
	            h0 = h1 + texture.crop.height;
	        } else {
	            w0 = texture.frame.width * (1 - aX);
	            w1 = texture.frame.width * -aX;
	
	            h0 = texture.frame.height * (1 - aY);
	            h1 = texture.frame.height * -aY;
	        }
	
	        var i = this.currentBatchSize * 4 * this.vertSize;
	        var resolution = texture.baseTexture.resolution;
	
	        var a = wt.a / resolution;
	        var b = wt.b / resolution;
	        var c = wt.c / resolution;
	        var d = wt.d / resolution;
	        var tx = wt.tx;
	        var ty = wt.ty;
	
	        var colors = this.colors;
	        var positions = this.positions;
	
	        if (this.renderSession.roundPixels) {
	            // xy
	            positions[i] = a * w1 + c * h1 + tx | 0;
	            positions[i + 1] = d * h1 + b * w1 + ty | 0;
	
	            // xy
	            positions[i + 5] = a * w0 + c * h1 + tx | 0;
	            positions[i + 6] = d * h1 + b * w0 + ty | 0;
	
	            // xy
	            positions[i + 10] = a * w0 + c * h0 + tx | 0;
	            positions[i + 11] = d * h0 + b * w0 + ty | 0;
	
	            // xy
	            positions[i + 15] = a * w1 + c * h0 + tx | 0;
	            positions[i + 16] = d * h0 + b * w1 + ty | 0;
	        } else {
	            // xy
	            positions[i] = a * w1 + c * h1 + tx;
	            positions[i + 1] = d * h1 + b * w1 + ty;
	
	            // xy
	            positions[i + 5] = a * w0 + c * h1 + tx;
	            positions[i + 6] = d * h1 + b * w0 + ty;
	
	            // xy
	            positions[i + 10] = a * w0 + c * h0 + tx;
	            positions[i + 11] = d * h0 + b * w0 + ty;
	
	            // xy
	            positions[i + 15] = a * w1 + c * h0 + tx;
	            positions[i + 16] = d * h0 + b * w1 + ty;
	        }
	
	        // uv
	        positions[i + 2] = uvs.x0;
	        positions[i + 3] = uvs.y0;
	
	        // uv
	        positions[i + 7] = uvs.x1;
	        positions[i + 8] = uvs.y1;
	
	        // uv
	        positions[i + 12] = uvs.x2;
	        positions[i + 13] = uvs.y2;
	
	        // uv
	        positions[i + 17] = uvs.x3;
	        positions[i + 18] = uvs.y3;
	
	        // color and alpha
	        var tint = sprite.tint;
	
	        colors[i + 4] = colors[i + 9] = colors[i + 14] = colors[i + 19] = (tint >> 16) + (tint & 0xff00) + ((tint & 0xff) << 16) + (sprite.worldAlpha * 255 << 24);
	
	        // increment the batchsize
	        this.sprites[this.currentBatchSize++] = sprite;
	    };
	
	    /**
	    * Renders a TilingSprite using the spriteBatch.
	    * 
	    * @method renderTilingSprite
	    * @param sprite {TilingSprite} the sprite to render
	    */
	    PIXI.WebGLSpriteBatch.prototype.renderTilingSprite = function (sprite) {
	        var texture = sprite.tilingTexture;
	
	        // check texture..
	        if (this.currentBatchSize >= this.size) {
	            this.flush();
	            this.currentBaseTexture = texture.baseTexture;
	        }
	
	        // set the textures uvs temporarily
	        if (!sprite._uvs) {
	            sprite._uvs = new PIXI.TextureUvs();
	        }
	
	        var uvs = sprite._uvs;
	
	        var w = texture.baseTexture.width;
	        var h = texture.baseTexture.height;
	
	        // var w = sprite._frame.sourceSizeW;
	        // var h = sprite._frame.sourceSizeH;
	
	        // w = 16;
	        // h = 16;
	
	        sprite.tilePosition.x %= w * sprite.tileScaleOffset.x;
	        sprite.tilePosition.y %= h * sprite.tileScaleOffset.y;
	
	        var offsetX = sprite.tilePosition.x / (w * sprite.tileScaleOffset.x);
	        var offsetY = sprite.tilePosition.y / (h * sprite.tileScaleOffset.y);
	
	        var scaleX = sprite.width / w / (sprite.tileScale.x * sprite.tileScaleOffset.x);
	        var scaleY = sprite.height / h / (sprite.tileScale.y * sprite.tileScaleOffset.y);
	
	        uvs.x0 = 0 - offsetX;
	        uvs.y0 = 0 - offsetY;
	
	        uvs.x1 = 1 * scaleX - offsetX;
	        uvs.y1 = 0 - offsetY;
	
	        uvs.x2 = 1 * scaleX - offsetX;
	        uvs.y2 = 1 * scaleY - offsetY;
	
	        uvs.x3 = 0 - offsetX;
	        uvs.y3 = 1 * scaleY - offsetY;
	
	        //  Get the sprites current alpha and tint and combine them into a single color
	        var tint = sprite.tint;
	        var color = (tint >> 16) + (tint & 0xff00) + ((tint & 0xff) << 16) + (sprite.worldAlpha * 255 << 24);
	
	        var positions = this.positions;
	        var colors = this.colors;
	
	        var width = sprite.width;
	        var height = sprite.height;
	
	        // TODO trim??
	        var aX = sprite.anchor.x;
	        var aY = sprite.anchor.y;
	        var w0 = width * (1 - aX);
	        var w1 = width * -aX;
	
	        var h0 = height * (1 - aY);
	        var h1 = height * -aY;
	
	        var i = this.currentBatchSize * 4 * this.vertSize;
	
	        var resolution = texture.baseTexture.resolution;
	
	        var wt = sprite.worldTransform;
	
	        var a = wt.a / resolution;
	        var b = wt.b / resolution;
	        var c = wt.c / resolution;
	        var d = wt.d / resolution;
	        var tx = wt.tx;
	        var ty = wt.ty;
	
	        // xy
	        positions[i++] = a * w1 + c * h1 + tx;
	        positions[i++] = d * h1 + b * w1 + ty;
	        // uv
	        positions[i++] = uvs.x0;
	        positions[i++] = uvs.y0;
	        // color
	        colors[i++] = color;
	
	        // xy
	        positions[i++] = a * w0 + c * h1 + tx;
	        positions[i++] = d * h1 + b * w0 + ty;
	        // uv
	        positions[i++] = uvs.x1;
	        positions[i++] = uvs.y1;
	        // color
	        colors[i++] = color;
	
	        // xy
	        positions[i++] = a * w0 + c * h0 + tx;
	        positions[i++] = d * h0 + b * w0 + ty;
	        // uv
	        positions[i++] = uvs.x2;
	        positions[i++] = uvs.y2;
	        // color
	        colors[i++] = color;
	
	        // xy
	        positions[i++] = a * w1 + c * h0 + tx;
	        positions[i++] = d * h0 + b * w1 + ty;
	        // uv
	        positions[i++] = uvs.x3;
	        positions[i++] = uvs.y3;
	        // color
	        colors[i++] = color;
	
	        // increment the batchsize
	        this.sprites[this.currentBatchSize++] = sprite;
	    };
	
	    /**
	    * Renders the content and empties the current batch.
	    *
	    * @method flush
	    */
	    PIXI.WebGLSpriteBatch.prototype.flush = function () {
	        // If the batch is length 0 then return as there is nothing to draw
	        if (this.currentBatchSize === 0) {
	            return;
	        }
	
	        var gl = this.gl;
	        var shader;
	
	        if (this.dirty) {
	            this.dirty = false;
	
	            // bind the main texture
	            gl.activeTexture(gl.TEXTURE0);
	
	            // bind the buffers
	            gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer);
	            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer);
	
	            shader = this.defaultShader.shaders[gl.id];
	
	            // this is the same for each shader?
	            var stride = this.vertSize * 4;
	            gl.vertexAttribPointer(shader.aVertexPosition, 2, gl.FLOAT, false, stride, 0);
	            gl.vertexAttribPointer(shader.aTextureCoord, 2, gl.FLOAT, false, stride, 2 * 4);
	
	            // color attributes will be interpreted as unsigned bytes and normalized
	            gl.vertexAttribPointer(shader.colorAttribute, 4, gl.UNSIGNED_BYTE, true, stride, 4 * 4);
	        }
	
	        // upload the verts to the buffer  
	        if (this.currentBatchSize > this.size * 0.5) {
	            gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.vertices);
	        } else {
	            var view = this.positions.subarray(0, this.currentBatchSize * 4 * this.vertSize);
	            gl.bufferSubData(gl.ARRAY_BUFFER, 0, view);
	        }
	
	        var nextTexture, nextBlendMode, nextShader;
	        var batchSize = 0;
	        var start = 0;
	
	        var currentBaseTexture = null;
	        var currentBlendMode = this.renderSession.blendModeManager.currentBlendMode;
	        var currentShader = null;
	
	        var blendSwap = false;
	        var shaderSwap = false;
	        var sprite;
	
	        for (var i = 0, j = this.currentBatchSize; i < j; i++) {
	
	            sprite = this.sprites[i];
	
	            if (sprite.tilingTexture) {
	                nextTexture = sprite.tilingTexture.baseTexture;
	            } else {
	                nextTexture = sprite.texture.baseTexture;
	            }
	
	            nextBlendMode = sprite.blendMode;
	            nextShader = sprite.shader || this.defaultShader;
	
	            blendSwap = currentBlendMode !== nextBlendMode;
	            shaderSwap = currentShader !== nextShader; // should I use _UIDS???
	
	            var skip = nextTexture.skipRender;
	
	            if (skip && sprite.children.length > 0) {
	                skip = false;
	            }
	
	            if (currentBaseTexture !== nextTexture && !skip || blendSwap || shaderSwap) {
	                this.renderBatch(currentBaseTexture, batchSize, start);
	
	                start = i;
	                batchSize = 0;
	                currentBaseTexture = nextTexture;
	
	                if (blendSwap) {
	                    currentBlendMode = nextBlendMode;
	                    this.renderSession.blendModeManager.setBlendMode(currentBlendMode);
	                }
	
	                if (shaderSwap) {
	                    currentShader = nextShader;
	
	                    shader = currentShader.shaders[gl.id];
	
	                    if (!shader) {
	                        shader = new PIXI.PixiShader(gl);
	
	                        shader.fragmentSrc = currentShader.fragmentSrc;
	                        shader.uniforms = currentShader.uniforms;
	                        shader.init();
	
	                        currentShader.shaders[gl.id] = shader;
	                    }
	
	                    // set shader function???
	                    this.renderSession.shaderManager.setShader(shader);
	
	                    if (shader.dirty) {
	                        shader.syncUniforms();
	                    }
	
	                    // both these only need to be set if they are changing..
	                    // set the projection
	                    var projection = this.renderSession.projection;
	                    gl.uniform2f(shader.projectionVector, projection.x, projection.y);
	
	                    // TODO - this is temporary!
	                    var offsetVector = this.renderSession.offset;
	                    gl.uniform2f(shader.offsetVector, offsetVector.x, offsetVector.y);
	
	                    // set the pointers
	                }
	            }
	
	            batchSize++;
	        }
	
	        this.renderBatch(currentBaseTexture, batchSize, start);
	
	        // then reset the batch!
	        this.currentBatchSize = 0;
	    };
	
	    /**
	    * @method renderBatch
	    * @param texture {Texture}
	    * @param size {Number}
	    * @param startIndex {Number}
	    */
	    PIXI.WebGLSpriteBatch.prototype.renderBatch = function (texture, size, startIndex) {
	        if (size === 0) {
	            return;
	        }
	
	        var gl = this.gl;
	
	        // check if a texture is dirty..
	        if (texture._dirty[gl.id]) {
	            if (!this.renderSession.renderer.updateTexture(texture)) {
	                //  If updateTexture returns false then we cannot render it, so bail out now
	                return;
	            }
	        } else {
	            // bind the current texture
	            gl.bindTexture(gl.TEXTURE_2D, texture._glTextures[gl.id]);
	        }
	
	        // now draw those suckas!
	        gl.drawElements(gl.TRIANGLES, size * 6, gl.UNSIGNED_SHORT, startIndex * 6 * 2);
	
	        // increment the draw count
	        this.renderSession.drawCount++;
	    };
	
	    /**
	    * @method stop
	    */
	    PIXI.WebGLSpriteBatch.prototype.stop = function () {
	        this.flush();
	        this.dirty = true;
	    };
	
	    /**
	    * @method start
	    */
	    PIXI.WebGLSpriteBatch.prototype.start = function () {
	        this.dirty = true;
	    };
	
	    /**
	    * Destroys the SpriteBatch.
	    * 
	    * @method destroy
	    */
	    PIXI.WebGLSpriteBatch.prototype.destroy = function () {
	        this.vertices = null;
	        this.indices = null;
	
	        this.gl.deleteBuffer(this.vertexBuffer);
	        this.gl.deleteBuffer(this.indexBuffer);
	
	        this.currentBaseTexture = null;
	
	        this.gl = null;
	    };
	    /**
	     * @author Mat Groves
	     * 
	     * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
	     * for creating the original pixi version!
	     *
	     * Heavily inspired by LibGDX's WebGLSpriteBatch:
	     * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/WebGLSpriteBatch.java
	     */
	
	    /**
	    * @class WebGLFastSpriteBatch
	    * @constructor
	    */
	    PIXI.WebGLFastSpriteBatch = function (gl) {
	        /**
	         * @property vertSize
	         * @type Number
	         */
	        this.vertSize = 10;
	
	        /**
	         * @property maxSize
	         * @type Number
	         */
	        this.maxSize = 6000; //Math.pow(2, 16) /  this.vertSize;
	
	        /**
	         * @property size
	         * @type Number
	         */
	        this.size = this.maxSize;
	
	        //the total number of floats in our batch
	        var numVerts = this.size * 4 * this.vertSize;
	
	        //the total number of indices in our batch
	        var numIndices = this.maxSize * 6;
	
	        /**
	         * Vertex data
	         * @property vertices
	         * @type Float32Array
	         */
	        this.vertices = new PIXI.Float32Array(numVerts);
	
	        /**
	         * Index data
	         * @property indices
	         * @type Uint16Array
	         */
	        this.indices = new PIXI.Uint16Array(numIndices);
	
	        /**
	         * @property vertexBuffer
	         * @type Object
	         */
	        this.vertexBuffer = null;
	
	        /**
	         * @property indexBuffer
	         * @type Object
	         */
	        this.indexBuffer = null;
	
	        /**
	         * @property lastIndexCount
	         * @type Number
	         */
	        this.lastIndexCount = 0;
	
	        for (var i = 0, j = 0; i < numIndices; i += 6, j += 4) {
	            this.indices[i + 0] = j + 0;
	            this.indices[i + 1] = j + 1;
	            this.indices[i + 2] = j + 2;
	            this.indices[i + 3] = j + 0;
	            this.indices[i + 4] = j + 2;
	            this.indices[i + 5] = j + 3;
	        }
	
	        /**
	         * @property drawing
	         * @type Boolean
	         */
	        this.drawing = false;
	
	        /**
	         * @property currentBatchSize
	         * @type Number
	         */
	        this.currentBatchSize = 0;
	
	        /**
	         * @property currentBaseTexture
	         * @type BaseTexture
	         */
	        this.currentBaseTexture = null;
	
	        /**
	         * @property currentBlendMode
	         * @type Number
	         */
	        this.currentBlendMode = 0;
	
	        /**
	         * @property renderSession
	         * @type Object
	         */
	        this.renderSession = null;
	
	        /**
	         * @property shader
	         * @type Object
	         */
	        this.shader = null;
	
	        /**
	         * @property matrix
	         * @type Matrix
	         */
	        this.matrix = null;
	
	        this.setContext(gl);
	    };
	
	    PIXI.WebGLFastSpriteBatch.prototype.constructor = PIXI.WebGLFastSpriteBatch;
	
	    /**
	     * Sets the WebGL Context.
	     *
	     * @method setContext
	     * @param gl {WebGLContext} the current WebGL drawing context
	     */
	    PIXI.WebGLFastSpriteBatch.prototype.setContext = function (gl) {
	        this.gl = gl;
	
	        // create a couple of buffers
	        this.vertexBuffer = gl.createBuffer();
	        this.indexBuffer = gl.createBuffer();
	
	        // 65535 is max index, so 65535 / 6 = 10922.
	
	        //upload the index data
	        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer);
	        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this.indices, gl.STATIC_DRAW);
	
	        gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer);
	        gl.bufferData(gl.ARRAY_BUFFER, this.vertices, gl.DYNAMIC_DRAW);
	    };
	
	    /**
	     * @method begin
	     * @param spriteBatch {WebGLSpriteBatch}
	     * @param renderSession {Object}
	     */
	    PIXI.WebGLFastSpriteBatch.prototype.begin = function (spriteBatch, renderSession) {
	        this.renderSession = renderSession;
	        this.shader = this.renderSession.shaderManager.fastShader;
	
	        this.matrix = spriteBatch.worldTransform.toArray(true);
	
	        this.start();
	    };
	
	    /**
	     * @method end
	     */
	    PIXI.WebGLFastSpriteBatch.prototype.end = function () {
	        this.flush();
	    };
	
	    /**
	     * @method render
	     * @param spriteBatch {WebGLSpriteBatch}
	     */
	    PIXI.WebGLFastSpriteBatch.prototype.render = function (spriteBatch) {
	        var children = spriteBatch.children;
	        var sprite = children[0];
	
	        // if the uvs have not updated then no point rendering just yet!
	
	        // check texture.
	        if (!sprite.texture._uvs) return;
	
	        this.currentBaseTexture = sprite.texture.baseTexture;
	
	        // check blend mode
	        if (sprite.blendMode !== this.renderSession.blendModeManager.currentBlendMode) {
	            this.flush();
	            this.renderSession.blendModeManager.setBlendMode(sprite.blendMode);
	        }
	
	        for (var i = 0, j = children.length; i < j; i++) {
	            this.renderSprite(children[i]);
	        }
	
	        this.flush();
	    };
	
	    /**
	     * @method renderSprite
	     * @param sprite {Sprite}
	     */
	    PIXI.WebGLFastSpriteBatch.prototype.renderSprite = function (sprite) {
	        //sprite = children[i];
	        if (!sprite.visible) return;
	
	        // TODO trim??
	        if (sprite.texture.baseTexture !== this.currentBaseTexture && !sprite.texture.baseTexture.skipRender) {
	            this.flush();
	            this.currentBaseTexture = sprite.texture.baseTexture;
	
	            if (!sprite.texture._uvs) return;
	        }
	
	        var uvs,
	            vertices = this.vertices,
	            width,
	            height,
	            w0,
	            w1,
	            h0,
	            h1,
	            index;
	
	        uvs = sprite.texture._uvs;
	
	        width = sprite.texture.frame.width;
	        height = sprite.texture.frame.height;
	
	        if (sprite.texture.trim) {
	            // if the sprite is trimmed then we need to add the extra space before transforming the sprite coords..
	            var trim = sprite.texture.trim;
	
	            w1 = trim.x - sprite.anchor.x * trim.width;
	            w0 = w1 + sprite.texture.crop.width;
	
	            h1 = trim.y - sprite.anchor.y * trim.height;
	            h0 = h1 + sprite.texture.crop.height;
	        } else {
	            w0 = sprite.texture.frame.width * (1 - sprite.anchor.x);
	            w1 = sprite.texture.frame.width * -sprite.anchor.x;
	
	            h0 = sprite.texture.frame.height * (1 - sprite.anchor.y);
	            h1 = sprite.texture.frame.height * -sprite.anchor.y;
	        }
	
	        index = this.currentBatchSize * 4 * this.vertSize;
	
	        // xy
	        vertices[index++] = w1;
	        vertices[index++] = h1;
	
	        vertices[index++] = sprite.position.x;
	        vertices[index++] = sprite.position.y;
	
	        //scale
	        vertices[index++] = sprite.scale.x;
	        vertices[index++] = sprite.scale.y;
	
	        //rotation
	        vertices[index++] = sprite.rotation;
	
	        // uv
	        vertices[index++] = uvs.x0;
	        vertices[index++] = uvs.y1;
	        // color
	        vertices[index++] = sprite.alpha;
	
	        // xy
	        vertices[index++] = w0;
	        vertices[index++] = h1;
	
	        vertices[index++] = sprite.position.x;
	        vertices[index++] = sprite.position.y;
	
	        //scale
	        vertices[index++] = sprite.scale.x;
	        vertices[index++] = sprite.scale.y;
	
	        //rotation
	        vertices[index++] = sprite.rotation;
	
	        // uv
	        vertices[index++] = uvs.x1;
	        vertices[index++] = uvs.y1;
	        // color
	        vertices[index++] = sprite.alpha;
	
	        // xy
	        vertices[index++] = w0;
	        vertices[index++] = h0;
	
	        vertices[index++] = sprite.position.x;
	        vertices[index++] = sprite.position.y;
	
	        //scale
	        vertices[index++] = sprite.scale.x;
	        vertices[index++] = sprite.scale.y;
	
	        //rotation
	        vertices[index++] = sprite.rotation;
	
	        // uv
	        vertices[index++] = uvs.x2;
	        vertices[index++] = uvs.y2;
	        // color
	        vertices[index++] = sprite.alpha;
	
	        // xy
	        vertices[index++] = w1;
	        vertices[index++] = h0;
	
	        vertices[index++] = sprite.position.x;
	        vertices[index++] = sprite.position.y;
	
	        //scale
	        vertices[index++] = sprite.scale.x;
	        vertices[index++] = sprite.scale.y;
	
	        //rotation
	        vertices[index++] = sprite.rotation;
	
	        // uv
	        vertices[index++] = uvs.x3;
	        vertices[index++] = uvs.y3;
	        // color
	        vertices[index++] = sprite.alpha;
	
	        // increment the batchs
	        this.currentBatchSize++;
	
	        if (this.currentBatchSize >= this.size) {
	            this.flush();
	        }
	    };
	
	    /**
	     * @method flush
	     */
	    PIXI.WebGLFastSpriteBatch.prototype.flush = function () {
	        // If the batch is length 0 then return as there is nothing to draw
	        if (this.currentBatchSize === 0) return;
	
	        var gl = this.gl;
	
	        // bind the current texture
	
	        if (!this.currentBaseTexture._glTextures[gl.id]) this.renderSession.renderer.updateTexture(this.currentBaseTexture, gl);
	
	        gl.bindTexture(gl.TEXTURE_2D, this.currentBaseTexture._glTextures[gl.id]);
	
	        // upload the verts to the buffer
	
	        if (this.currentBatchSize > this.size * 0.5) {
	            gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.vertices);
	        } else {
	            var view = this.vertices.subarray(0, this.currentBatchSize * 4 * this.vertSize);
	
	            gl.bufferSubData(gl.ARRAY_BUFFER, 0, view);
	        }
	
	        // now draw those suckas!
	        gl.drawElements(gl.TRIANGLES, this.currentBatchSize * 6, gl.UNSIGNED_SHORT, 0);
	
	        // then reset the batch!
	        this.currentBatchSize = 0;
	
	        // increment the draw count
	        this.renderSession.drawCount++;
	    };
	
	    /**
	     * @method stop
	     */
	    PIXI.WebGLFastSpriteBatch.prototype.stop = function () {
	        this.flush();
	    };
	
	    /**
	     * @method start
	     */
	    PIXI.WebGLFastSpriteBatch.prototype.start = function () {
	        var gl = this.gl;
	
	        // bind the main texture
	        gl.activeTexture(gl.TEXTURE0);
	
	        // bind the buffers
	        gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer);
	        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer);
	
	        // set the projection
	        var projection = this.renderSession.projection;
	        gl.uniform2f(this.shader.projectionVector, projection.x, projection.y);
	
	        // set the matrix
	        gl.uniformMatrix3fv(this.shader.uMatrix, false, this.matrix);
	
	        // set the pointers
	        var stride = this.vertSize * 4;
	
	        gl.vertexAttribPointer(this.shader.aVertexPosition, 2, gl.FLOAT, false, stride, 0);
	        gl.vertexAttribPointer(this.shader.aPositionCoord, 2, gl.FLOAT, false, stride, 2 * 4);
	        gl.vertexAttribPointer(this.shader.aScale, 2, gl.FLOAT, false, stride, 4 * 4);
	        gl.vertexAttribPointer(this.shader.aRotation, 1, gl.FLOAT, false, stride, 6 * 4);
	        gl.vertexAttribPointer(this.shader.aTextureCoord, 2, gl.FLOAT, false, stride, 7 * 4);
	        gl.vertexAttribPointer(this.shader.colorAttribute, 1, gl.FLOAT, false, stride, 9 * 4);
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	    * @class WebGLFilterManager
	    * @constructor
	    */
	    PIXI.WebGLFilterManager = function () {
	        /**
	         * @property filterStack
	         * @type Array
	         */
	        this.filterStack = [];
	
	        /**
	         * @property offsetX
	         * @type Number
	         */
	        this.offsetX = 0;
	
	        /**
	         * @property offsetY
	         * @type Number
	         */
	        this.offsetY = 0;
	    };
	
	    PIXI.WebGLFilterManager.prototype.constructor = PIXI.WebGLFilterManager;
	
	    /**
	    * Initialises the context and the properties.
	    * 
	    * @method setContext 
	    * @param gl {WebGLContext} the current WebGL drawing context
	    */
	    PIXI.WebGLFilterManager.prototype.setContext = function (gl) {
	        this.gl = gl;
	        this.texturePool = [];
	
	        this.initShaderBuffers();
	    };
	
	    /**
	    * @method begin
	    * @param renderSession {RenderSession} 
	    * @param buffer {ArrayBuffer} 
	    */
	    PIXI.WebGLFilterManager.prototype.begin = function (renderSession, buffer) {
	        this.renderSession = renderSession;
	        this.defaultShader = renderSession.shaderManager.defaultShader;
	
	        var projection = this.renderSession.projection;
	        this.width = projection.x * 2;
	        this.height = -projection.y * 2;
	        this.buffer = buffer;
	    };
	
	    /**
	    * Applies the filter and adds it to the current filter stack.
	    * 
	    * @method pushFilter
	    * @param filterBlock {Object} the filter that will be pushed to the current filter stack
	    */
	    PIXI.WebGLFilterManager.prototype.pushFilter = function (filterBlock) {
	        var gl = this.gl;
	
	        var projection = this.renderSession.projection;
	        var offset = this.renderSession.offset;
	
	        filterBlock._filterArea = filterBlock.target.filterArea || filterBlock.target.getBounds();
	
	        // >>> modify by nextht
	        filterBlock._previous_stencil_mgr = this.renderSession.stencilManager;
	        this.renderSession.stencilManager = new PIXI.WebGLStencilManager();
	        this.renderSession.stencilManager.setContext(gl);
	        gl.disable(gl.STENCIL_TEST);
	        // <<<  modify by nextht 
	
	        // filter program
	        // OPTIMISATION - the first filter is free if its a simple color change?
	        this.filterStack.push(filterBlock);
	
	        var filter = filterBlock.filterPasses[0];
	
	        this.offsetX += filterBlock._filterArea.x;
	        this.offsetY += filterBlock._filterArea.y;
	
	        var texture = this.texturePool.pop();
	        if (!texture) {
	            texture = new PIXI.FilterTexture(this.gl, this.width * this.renderSession.resolution, this.height * this.renderSession.resolution);
	        } else {
	            texture.resize(this.width * this.renderSession.resolution, this.height * this.renderSession.resolution);
	        }
	
	        gl.bindTexture(gl.TEXTURE_2D, texture.texture);
	
	        var filterArea = filterBlock._filterArea; // filterBlock.target.getBounds();///filterBlock.target.filterArea;
	
	        var padding = filter.padding;
	        filterArea.x -= padding;
	        filterArea.y -= padding;
	        filterArea.width += padding * 2;
	        filterArea.height += padding * 2;
	
	        // cap filter to screen size..
	        if (filterArea.x < 0) filterArea.x = 0;
	        if (filterArea.width > this.width) filterArea.width = this.width;
	        if (filterArea.y < 0) filterArea.y = 0;
	        if (filterArea.height > this.height) filterArea.height = this.height;
	
	        //gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA,  filterArea.width, filterArea.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
	        gl.bindFramebuffer(gl.FRAMEBUFFER, texture.frameBuffer);
	
	        // set view port
	        gl.viewport(0, 0, filterArea.width * this.renderSession.resolution, filterArea.height * this.renderSession.resolution);
	
	        projection.x = filterArea.width / 2;
	        projection.y = -filterArea.height / 2;
	
	        offset.x = -filterArea.x;
	        offset.y = -filterArea.y;
	
	        // update projection
	        // now restore the regular shader..
	        // this.renderSession.shaderManager.setShader(this.defaultShader);
	        //gl.uniform2f(this.defaultShader.projectionVector, filterArea.width/2, -filterArea.height/2);
	        //gl.uniform2f(this.defaultShader.offsetVector, -filterArea.x, -filterArea.y);
	
	        gl.colorMask(true, true, true, true);
	        gl.clearColor(0, 0, 0, 0);
	        gl.clear(gl.COLOR_BUFFER_BIT);
	
	        filterBlock._glFilterTexture = texture;
	    };
	
	    /**
	    * Removes the last filter from the filter stack and doesn't return it.
	    * 
	    * @method popFilter
	    */
	    PIXI.WebGLFilterManager.prototype.popFilter = function () {
	        var gl = this.gl;
	        var filterBlock = this.filterStack.pop();
	        var filterArea = filterBlock._filterArea;
	        var texture = filterBlock._glFilterTexture;
	        var projection = this.renderSession.projection;
	        var offset = this.renderSession.offset;
	
	        if (filterBlock.filterPasses.length > 1) {
	            gl.viewport(0, 0, filterArea.width * this.renderSession.resolution, filterArea.height * this.renderSession.resolution);
	
	            gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer);
	
	            this.vertexArray[0] = 0;
	            this.vertexArray[1] = filterArea.height;
	
	            this.vertexArray[2] = filterArea.width;
	            this.vertexArray[3] = filterArea.height;
	
	            this.vertexArray[4] = 0;
	            this.vertexArray[5] = 0;
	
	            this.vertexArray[6] = filterArea.width;
	            this.vertexArray[7] = 0;
	
	            gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.vertexArray);
	
	            gl.bindBuffer(gl.ARRAY_BUFFER, this.uvBuffer);
	            // now set the uvs..
	            this.uvArray[2] = filterArea.width / this.width;
	            this.uvArray[5] = filterArea.height / this.height;
	            this.uvArray[6] = filterArea.width / this.width;
	            this.uvArray[7] = filterArea.height / this.height;
	
	            gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.uvArray);
	
	            var inputTexture = texture;
	            var outputTexture = this.texturePool.pop();
	            if (!outputTexture) outputTexture = new PIXI.FilterTexture(this.gl, this.width * this.renderSession.resolution, this.height * this.renderSession.resolution);
	            outputTexture.resize(this.width * this.renderSession.resolution, this.height * this.renderSession.resolution);
	
	            // need to clear this FBO as it may have some left over elements from a previous filter.
	            gl.bindFramebuffer(gl.FRAMEBUFFER, outputTexture.frameBuffer);
	            gl.clear(gl.COLOR_BUFFER_BIT);
	
	            gl.disable(gl.BLEND);
	
	            for (var i = 0; i < filterBlock.filterPasses.length - 1; i++) {
	                var filterPass = filterBlock.filterPasses[i];
	
	                gl.bindFramebuffer(gl.FRAMEBUFFER, outputTexture.frameBuffer);
	
	                // set texture
	                gl.activeTexture(gl.TEXTURE0);
	                gl.bindTexture(gl.TEXTURE_2D, inputTexture.texture);
	
	                // draw texture..
	                //filterPass.applyFilterPass(filterArea.width, filterArea.height);
	                this.applyFilterPass(filterPass, filterArea, filterArea.width, filterArea.height);
	
	                // swap the textures..
	                var temp = inputTexture;
	                inputTexture = outputTexture;
	                outputTexture = temp;
	            }
	
	            gl.enable(gl.BLEND);
	
	            texture = inputTexture;
	            this.texturePool.push(outputTexture);
	        }
	
	        var filter = filterBlock.filterPasses[filterBlock.filterPasses.length - 1];
	
	        this.offsetX -= filterArea.x;
	        this.offsetY -= filterArea.y;
	
	        var sizeX = this.width;
	        var sizeY = this.height;
	
	        var offsetX = 0;
	        var offsetY = 0;
	
	        var buffer = this.buffer;
	
	        // time to render the filters texture to the previous scene
	        if (this.filterStack.length === 0) {
	            gl.colorMask(true, true, true, true); //this.transparent);
	        } else {
	            var currentFilter = this.filterStack[this.filterStack.length - 1];
	            filterArea = currentFilter._filterArea;
	
	            sizeX = filterArea.width;
	            sizeY = filterArea.height;
	
	            offsetX = filterArea.x;
	            offsetY = filterArea.y;
	
	            buffer = currentFilter._glFilterTexture.frameBuffer;
	        }
	
	        // TODO need to remove these global elements..
	        projection.x = sizeX / 2;
	        projection.y = -sizeY / 2;
	
	        offset.x = offsetX;
	        offset.y = offsetY;
	
	        filterArea = filterBlock._filterArea;
	
	        var x = filterArea.x - offsetX;
	        var y = filterArea.y - offsetY;
	
	        // update the buffers..
	        // make sure to flip the y!
	        gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer);
	
	        this.vertexArray[0] = x;
	        this.vertexArray[1] = y + filterArea.height;
	
	        this.vertexArray[2] = x + filterArea.width;
	        this.vertexArray[3] = y + filterArea.height;
	
	        this.vertexArray[4] = x;
	        this.vertexArray[5] = y;
	
	        this.vertexArray[6] = x + filterArea.width;
	        this.vertexArray[7] = y;
	
	        gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.vertexArray);
	
	        gl.bindBuffer(gl.ARRAY_BUFFER, this.uvBuffer);
	
	        this.uvArray[2] = filterArea.width / this.width;
	        this.uvArray[5] = filterArea.height / this.height;
	        this.uvArray[6] = filterArea.width / this.width;
	        this.uvArray[7] = filterArea.height / this.height;
	
	        gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.uvArray);
	
	        gl.viewport(0, 0, sizeX * this.renderSession.resolution, sizeY * this.renderSession.resolution);
	
	        // bind the buffer
	        gl.bindFramebuffer(gl.FRAMEBUFFER, buffer);
	
	        // set the blend mode! 
	        //gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA)
	
	        // set texture
	        gl.activeTexture(gl.TEXTURE0);
	        gl.bindTexture(gl.TEXTURE_2D, texture.texture);
	
	        // >>> modify by nextht
	        if (this.renderSession.stencilManager) {
	            this.renderSession.stencilManager.destroy();
	        }
	        this.renderSession.stencilManager = filterBlock._previous_stencil_mgr;
	        filterBlock._previous_stencil_mgr = null;
	        if (this.renderSession.stencilManager.count > 0) {
	            gl.enable(gl.STENCIL_TEST);
	        } else {
	            gl.disable(gl.STENCIL_TEST);
	        }
	        // <<< modify by nextht
	
	        // apply!
	        this.applyFilterPass(filter, filterArea, sizeX, sizeY);
	
	        // now restore the regular shader.. should happen automatically now..
	        // this.renderSession.shaderManager.setShader(this.defaultShader);
	        // gl.uniform2f(this.defaultShader.projectionVector, sizeX/2, -sizeY/2);
	        // gl.uniform2f(this.defaultShader.offsetVector, -offsetX, -offsetY);
	
	        // return the texture to the pool
	        this.texturePool.push(texture);
	        filterBlock._glFilterTexture = null;
	    };
	
	    /**
	    * Applies the filter to the specified area.
	    * 
	    * @method applyFilterPass
	    * @param filter {AbstractFilter} the filter that needs to be applied
	    * @param filterArea {Texture} TODO - might need an update
	    * @param width {Number} the horizontal range of the filter
	    * @param height {Number} the vertical range of the filter
	    */
	    PIXI.WebGLFilterManager.prototype.applyFilterPass = function (filter, filterArea, width, height) {
	        // use program
	        var gl = this.gl;
	        var shader = filter.shaders[gl.id];
	
	        if (!shader) {
	            shader = new PIXI.PixiShader(gl);
	
	            shader.fragmentSrc = filter.fragmentSrc;
	            shader.uniforms = filter.uniforms;
	            shader.init();
	
	            filter.shaders[gl.id] = shader;
	        }
	
	        // set the shader
	        this.renderSession.shaderManager.setShader(shader);
	
	        //    gl.useProgram(shader.program);
	
	        gl.uniform2f(shader.projectionVector, width / 2, -height / 2);
	        gl.uniform2f(shader.offsetVector, 0, 0);
	
	        if (filter.uniforms.dimensions) {
	            filter.uniforms.dimensions.value[0] = this.width; //width;
	            filter.uniforms.dimensions.value[1] = this.height; //height;
	            filter.uniforms.dimensions.value[2] = this.vertexArray[0];
	            filter.uniforms.dimensions.value[3] = this.vertexArray[5]; //filterArea.height;
	        }
	
	        shader.syncUniforms();
	
	        gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer);
	        gl.vertexAttribPointer(shader.aVertexPosition, 2, gl.FLOAT, false, 0, 0);
	
	        gl.bindBuffer(gl.ARRAY_BUFFER, this.uvBuffer);
	        gl.vertexAttribPointer(shader.aTextureCoord, 2, gl.FLOAT, false, 0, 0);
	
	        gl.bindBuffer(gl.ARRAY_BUFFER, this.colorBuffer);
	        gl.vertexAttribPointer(shader.colorAttribute, 2, gl.FLOAT, false, 0, 0);
	
	        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer);
	
	        // draw the filter...
	        gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0);
	
	        this.renderSession.drawCount++;
	    };
	
	    /**
	    * Initialises the shader buffers.
	    * 
	    * @method initShaderBuffers
	    */
	    PIXI.WebGLFilterManager.prototype.initShaderBuffers = function () {
	        var gl = this.gl;
	
	        // create some buffers
	        this.vertexBuffer = gl.createBuffer();
	        this.uvBuffer = gl.createBuffer();
	        this.colorBuffer = gl.createBuffer();
	        this.indexBuffer = gl.createBuffer();
	
	        // bind and upload the vertexs..
	        // keep a reference to the vertexFloatData..
	        this.vertexArray = new PIXI.Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 1.0, 1.0]);
	
	        gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer);
	        gl.bufferData(gl.ARRAY_BUFFER, this.vertexArray, gl.STATIC_DRAW);
	
	        // bind and upload the uv buffer
	        this.uvArray = new PIXI.Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 1.0, 1.0]);
	
	        gl.bindBuffer(gl.ARRAY_BUFFER, this.uvBuffer);
	        gl.bufferData(gl.ARRAY_BUFFER, this.uvArray, gl.STATIC_DRAW);
	
	        this.colorArray = new PIXI.Float32Array([1.0, 0xFFFFFF, 1.0, 0xFFFFFF, 1.0, 0xFFFFFF, 1.0, 0xFFFFFF]);
	
	        gl.bindBuffer(gl.ARRAY_BUFFER, this.colorBuffer);
	        gl.bufferData(gl.ARRAY_BUFFER, this.colorArray, gl.STATIC_DRAW);
	
	        // bind and upload the index
	        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer);
	        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array([0, 1, 2, 1, 3, 2]), gl.STATIC_DRAW);
	    };
	
	    /**
	    * Destroys the filter and removes it from the filter stack.
	    * 
	    * @method destroy
	    */
	    PIXI.WebGLFilterManager.prototype.destroy = function () {
	        var gl = this.gl;
	
	        this.filterStack = null;
	
	        this.offsetX = 0;
	        this.offsetY = 0;
	
	        // destroy textures
	        for (var i = 0; i < this.texturePool.length; i++) {
	            this.texturePool[i].destroy();
	        }
	
	        this.texturePool = null;
	
	        //destroy buffers..
	        gl.deleteBuffer(this.vertexBuffer);
	        gl.deleteBuffer(this.uvBuffer);
	        gl.deleteBuffer(this.colorBuffer);
	        gl.deleteBuffer(this.indexBuffer);
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	    * @class FilterTexture
	    * @constructor
	    * @param gl {WebGLContext} the current WebGL drawing context
	    * @param width {Number} the horizontal range of the filter
	    * @param height {Number} the vertical range of the filter
	    * @param scaleMode {Number} See {{#crossLink "PIXI/scaleModes:property"}}PIXI.scaleModes{{/crossLink}} for possible values
	    */
	    PIXI.FilterTexture = function (gl, width, height, scaleMode) {
	        /**
	         * @property gl
	         * @type WebGLContext
	         */
	        this.gl = gl;
	
	        // next time to create a frame buffer and texture
	
	        /**
	         * @property frameBuffer
	         * @type Any
	         */
	        this.frameBuffer = gl.createFramebuffer();
	
	        /**
	         * @property texture
	         * @type Any
	         */
	        this.texture = gl.createTexture();
	
	        /**
	         * @property scaleMode
	         * @type Number
	         */
	        scaleMode = scaleMode || PIXI.scaleModes.DEFAULT;
	
	        gl.bindTexture(gl.TEXTURE_2D, this.texture);
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, scaleMode === PIXI.scaleModes.LINEAR ? gl.LINEAR : gl.NEAREST);
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, scaleMode === PIXI.scaleModes.LINEAR ? gl.LINEAR : gl.NEAREST);
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
	        gl.bindFramebuffer(gl.FRAMEBUFFER, this.frameBuffer);
	
	        gl.bindFramebuffer(gl.FRAMEBUFFER, this.frameBuffer);
	        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.texture, 0);
	
	        // required for masking a mask??
	        this.renderBuffer = gl.createRenderbuffer();
	        gl.bindRenderbuffer(gl.RENDERBUFFER, this.renderBuffer);
	        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, this.renderBuffer);
	
	        this.resize(width, height);
	    };
	
	    PIXI.FilterTexture.prototype.constructor = PIXI.FilterTexture;
	
	    /**
	    * Clears the filter texture.
	    * 
	    * @method clear
	    */
	    PIXI.FilterTexture.prototype.clear = function () {
	        var gl = this.gl;
	
	        gl.clearColor(0, 0, 0, 0);
	        gl.clear(gl.COLOR_BUFFER_BIT);
	    };
	
	    /**
	     * Resizes the texture to the specified width and height
	     *
	     * @method resize
	     * @param width {Number} the new width of the texture
	     * @param height {Number} the new height of the texture
	     */
	    PIXI.FilterTexture.prototype.resize = function (width, height) {
	        if (this.width === width && this.height === height) return;
	
	        this.width = width;
	        this.height = height;
	
	        var gl = this.gl;
	
	        gl.bindTexture(gl.TEXTURE_2D, this.texture);
	        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
	        // update the stencil buffer width and height
	        gl.bindRenderbuffer(gl.RENDERBUFFER, this.renderBuffer);
	        gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, width, height);
	    };
	
	    /**
	    * Destroys the filter texture.
	    * 
	    * @method destroy
	    */
	    PIXI.FilterTexture.prototype.destroy = function () {
	        var gl = this.gl;
	        gl.deleteFramebuffer(this.frameBuffer);
	        gl.deleteTexture(this.texture);
	
	        this.frameBuffer = null;
	        this.texture = null;
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	     * Creates a Canvas element of the given size.
	     *
	     * @class CanvasBuffer
	     * @constructor
	     * @param width {Number} the width for the newly created canvas
	     * @param height {Number} the height for the newly created canvas
	     */
	    PIXI.CanvasBuffer = function (width, height) {
	        /**
	         * The width of the Canvas in pixels.
	         *
	         * @property width
	         * @type Number
	         */
	        this.width = width;
	
	        /**
	         * The height of the Canvas in pixels.
	         *
	         * @property height
	         * @type Number
	         */
	        this.height = height;
	
	        /**
	         * The Canvas object that belongs to this CanvasBuffer.
	         *
	         * @property canvas
	         * @type HTMLCanvasElement
	         */
	        this.canvas = PIXI.CanvasPool.create(this, this.width, this.height);
	
	        /**
	         * A CanvasRenderingContext2D object representing a two-dimensional rendering context.
	         *
	         * @property context
	         * @type CanvasRenderingContext2D
	         */
	        this.context = this.canvas.getContext("2d");
	
	        this.canvas.width = width;
	        this.canvas.height = height;
	    };
	
	    PIXI.CanvasBuffer.prototype.constructor = PIXI.CanvasBuffer;
	
	    /**
	     * Clears the canvas that was created by the CanvasBuffer class.
	     *
	     * @method clear
	     * @private
	     */
	    PIXI.CanvasBuffer.prototype.clear = function () {
	        this.context.setTransform(1, 0, 0, 1, 0, 0);
	        this.context.clearRect(0, 0, this.width, this.height);
	    };
	
	    /**
	     * Resizes the canvas to the specified width and height.
	     *
	     * @method resize
	     * @param width {Number} the new width of the canvas
	     * @param height {Number} the new height of the canvas
	     */
	    PIXI.CanvasBuffer.prototype.resize = function (width, height) {
	        this.width = this.canvas.width = width;
	        this.height = this.canvas.height = height;
	    };
	
	    /**
	     * Frees the canvas up for use again.
	     *
	     * @method destroy
	     */
	    PIXI.CanvasBuffer.prototype.destroy = function () {
	        PIXI.CanvasPool.remove(this);
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	     * A set of functions used to handle masking.
	     *
	     * @class CanvasMaskManager
	     * @constructor
	     */
	    PIXI.CanvasMaskManager = function () {};
	
	    PIXI.CanvasMaskManager.prototype.constructor = PIXI.CanvasMaskManager;
	
	    /**
	     * This method adds it to the current stack of masks.
	     *
	     * @method pushMask
	     * @param maskData {Object} the maskData that will be pushed
	     * @param renderSession {Object} The renderSession whose context will be used for this mask manager.
	     */
	    PIXI.CanvasMaskManager.prototype.pushMask = function (maskData, renderSession) {
	
	        var context = renderSession.context;
	
	        context.save();
	
	        var cacheAlpha = maskData.alpha;
	        var transform = maskData.worldTransform;
	
	        var resolution = renderSession.resolution;
	
	        context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);
	
	        PIXI.CanvasGraphics.renderGraphicsMask(maskData, context);
	
	        context.clip();
	
	        maskData.worldAlpha = cacheAlpha;
	    };
	
	    /**
	     * Restores the current drawing context to the state it was before the mask was applied.
	     *
	     * @method popMask
	     * @param renderSession {Object} The renderSession whose context will be used for this mask manager.
	     */
	    PIXI.CanvasMaskManager.prototype.popMask = function (renderSession) {
	        renderSession.context.restore();
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	     * Utility methods for Sprite/Texture tinting.
	     *
	     * @class CanvasTinter
	     * @static
	     */
	    PIXI.CanvasTinter = function () {};
	
	    /**
	     * Basically this method just needs a sprite and a color and tints the sprite with the given color.
	     * 
	     * @method getTintedTexture 
	     * @static
	     * @param sprite {Sprite} the sprite to tint
	     * @param color {Number} the color to use to tint the sprite with
	     * @return {HTMLCanvasElement} The tinted canvas
	     */
	    PIXI.CanvasTinter.getTintedTexture = function (sprite, color) {
	        var canvas = sprite.tintedTexture || PIXI.CanvasPool.create(this);
	
	        PIXI.CanvasTinter.tintMethod(sprite.texture, color, canvas);
	
	        return canvas;
	    };
	
	    /**
	     * Tint a texture using the "multiply" operation.
	     * 
	     * @method tintWithMultiply
	     * @static
	     * @param texture {Texture} the texture to tint
	     * @param color {Number} the color to use to tint the sprite with
	     * @param canvas {HTMLCanvasElement} the current canvas
	     */
	    PIXI.CanvasTinter.tintWithMultiply = function (texture, color, canvas) {
	        var context = canvas.getContext("2d");
	
	        var crop = texture.crop;
	
	        if (canvas.width !== crop.width || canvas.height !== crop.height) {
	            canvas.width = crop.width;
	            canvas.height = crop.height;
	        }
	
	        context.clearRect(0, 0, crop.width, crop.height);
	
	        context.fillStyle = "#" + ("00000" + (color | 0).toString(16)).substr(-6);
	        context.fillRect(0, 0, crop.width, crop.height);
	
	        context.globalCompositeOperation = "multiply";
	        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
	
	        context.globalCompositeOperation = "destination-atop";
	        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
	    };
	
	    /**
	     * Tint a texture pixel per pixel.
	     * 
	     * @method tintPerPixel
	     * @static
	     * @param texture {Texture} the texture to tint
	     * @param color {Number} the color to use to tint the sprite with
	     * @param canvas {HTMLCanvasElement} the current canvas
	     */
	    PIXI.CanvasTinter.tintWithPerPixel = function (texture, color, canvas) {
	        var context = canvas.getContext("2d");
	
	        var crop = texture.crop;
	
	        canvas.width = crop.width;
	        canvas.height = crop.height;
	
	        context.globalCompositeOperation = "copy";
	
	        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
	
	        var rgbValues = PIXI.hex2rgb(color);
	        var r = rgbValues[0],
	            g = rgbValues[1],
	            b = rgbValues[2];
	
	        var pixelData = context.getImageData(0, 0, crop.width, crop.height);
	
	        var pixels = pixelData.data;
	
	        for (var i = 0; i < pixels.length; i += 4) {
	            pixels[i + 0] *= r;
	            pixels[i + 1] *= g;
	            pixels[i + 2] *= b;
	
	            if (!PIXI.CanvasTinter.canHandleAlpha) {
	                var alpha = pixels[i + 3];
	
	                pixels[i + 0] /= 255 / alpha;
	                pixels[i + 1] /= 255 / alpha;
	                pixels[i + 2] /= 255 / alpha;
	            }
	        }
	
	        context.putImageData(pixelData, 0, 0);
	    };
	
	    /**
	     * Checks if the browser correctly supports putImageData alpha channels.
	     * 
	     * @method checkInverseAlpha
	     * @static
	     */
	    PIXI.CanvasTinter.checkInverseAlpha = function () {
	        var canvas = new PIXI.CanvasBuffer(2, 1);
	
	        canvas.context.fillStyle = "rgba(10, 20, 30, 0.5)";
	
	        //  Draw a single pixel
	        canvas.context.fillRect(0, 0, 1, 1);
	
	        //  Get the color values
	        var s1 = canvas.context.getImageData(0, 0, 1, 1);
	
	        if (s1 === null) {
	            return false;
	        }
	
	        //  Plot them to x2
	        canvas.context.putImageData(s1, 1, 0);
	
	        //  Get those values
	        var s2 = canvas.context.getImageData(1, 0, 1, 1);
	
	        //  Compare and return
	        return s2.data[0] === s1.data[0] && s2.data[1] === s1.data[1] && s2.data[2] === s1.data[2] && s2.data[3] === s1.data[3];
	    };
	
	    /**
	     * If the browser isn't capable of handling tinting with alpha this will be false.
	     * This property is only applicable if using tintWithPerPixel.
	     *
	     * @property canHandleAlpha
	     * @type Boolean
	     * @static
	     */
	    PIXI.CanvasTinter.canHandleAlpha = PIXI.CanvasTinter.checkInverseAlpha();
	
	    /**
	     * Whether or not the Canvas BlendModes are supported, consequently the ability to tint using the multiply method.
	     *
	     * @property canUseMultiply
	     * @type Boolean
	     * @static
	     */
	    PIXI.CanvasTinter.canUseMultiply = PIXI.canUseNewCanvasBlendModes();
	
	    /**
	     * The tinting method that will be used.
	     * 
	     * @method tintMethod
	     * @static
	     */
	    PIXI.CanvasTinter.tintMethod = PIXI.CanvasTinter.canUseMultiply ? PIXI.CanvasTinter.tintWithMultiply : PIXI.CanvasTinter.tintWithPerPixel;
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	     * The CanvasRenderer draws the Stage and all its content onto a 2d canvas. This renderer should be used for browsers that do not support webGL.
	     * Don't forget to add the CanvasRenderer.view to your DOM or you will not see anything :)
	     *
	     * @class CanvasRenderer
	     * @constructor
	     * @param game {Phaser.Game} A reference to the Phaser Game instance
	     */
	    PIXI.CanvasRenderer = function (game) {
	
	        /**
	        * @property {Phaser.Game} game - A reference to the Phaser Game instance.
	        */
	        this.game = game;
	
	        if (!PIXI.defaultRenderer) {
	            PIXI.defaultRenderer = this;
	        }
	
	        /**
	         * The renderer type.
	         *
	         * @property type
	         * @type Number
	         */
	        this.type = PIXI.CANVAS_RENDERER;
	
	        /**
	         * The resolution of the canvas.
	         *
	         * @property resolution
	         * @type Number
	         */
	        this.resolution = game.resolution;
	
	        /**
	         * This sets if the CanvasRenderer will clear the canvas or not before the new render pass.
	         * If the Stage is NOT transparent Pixi will use a canvas sized fillRect operation every frame to set the canvas background color.
	         * If the Stage is transparent Pixi will use clearRect to clear the canvas every frame.
	         * Disable this by setting this to false. For example if your game has a canvas filling background image you often don't need this set.
	         *
	         * @property clearBeforeRender
	         * @type Boolean
	         * @default
	         */
	        this.clearBeforeRender = game.clearBeforeRender;
	
	        /**
	         * Whether the render view is transparent
	         *
	         * @property transparent
	         * @type Boolean
	         */
	        this.transparent = game.transparent;
	
	        /**
	         * Whether the render view should be resized automatically
	         *
	         * @property autoResize
	         * @type Boolean
	         */
	        this.autoResize = false;
	
	        /**
	         * The width of the canvas view
	         *
	         * @property width
	         * @type Number
	         * @default 800
	         */
	        this.width = game.width * this.resolution;
	
	        /**
	         * The height of the canvas view
	         *
	         * @property height
	         * @type Number
	         * @default 600
	         */
	        this.height = game.height * this.resolution;
	
	        /**
	         * The canvas element that everything is drawn to.
	         *
	         * @property view
	         * @type HTMLCanvasElement
	         */
	        this.view = game.canvas;
	
	        /**
	         * The canvas 2d context that everything is drawn with
	         * @property context
	         * @type CanvasRenderingContext2D
	         */
	        this.context = this.view.getContext("2d", { alpha: this.transparent });
	
	        /**
	         * Boolean flag controlling canvas refresh.
	         *
	         * @property refresh
	         * @type Boolean
	         */
	        this.refresh = true;
	
	        /**
	         * Internal var.
	         *
	         * @property count
	         * @type Number
	         */
	        this.count = 0;
	
	        /**
	         * Instance of a PIXI.CanvasMaskManager, handles masking when using the canvas renderer
	         * @property CanvasMaskManager
	         * @type CanvasMaskManager
	         */
	        this.maskManager = new PIXI.CanvasMaskManager();
	
	        /**
	         * The render session is just a bunch of parameter used for rendering
	         * @property renderSession
	         * @type Object
	         */
	        this.renderSession = {
	            context: this.context,
	            maskManager: this.maskManager,
	            scaleMode: null,
	            smoothProperty: Phaser.Canvas.getSmoothingPrefix(this.context),
	
	            /**
	             * If true Pixi will Math.floor() x/y values when rendering, stopping pixel interpolation.
	             * Handy for crisp pixel art and speed on legacy devices.
	             */
	            roundPixels: false
	        };
	
	        this.mapBlendModes();
	
	        this.resize(this.width, this.height);
	    };
	
	    // constructor
	    PIXI.CanvasRenderer.prototype.constructor = PIXI.CanvasRenderer;
	
	    /**
	     * Renders the DisplayObjectContainer, usually the Phaser.Stage, to this canvas view.
	     *
	     * @method render
	     * @param root {Phaser.Stage|PIXI.DisplayObjectContainer} The root element to be rendered.
	     */
	    PIXI.CanvasRenderer.prototype.render = function (root) {
	
	        this.context.setTransform(1, 0, 0, 1, 0, 0);
	
	        this.context.globalAlpha = 1;
	
	        this.renderSession.currentBlendMode = 0;
	        this.renderSession.shakeX = this.game.camera._shake.x;
	        this.renderSession.shakeY = this.game.camera._shake.y;
	
	        this.context.globalCompositeOperation = 'source-over';
	
	        if (navigator.isCocoonJS && this.view.screencanvas) {
	            this.context.fillStyle = "black";
	            this.context.clear();
	        }
	
	        if (this.clearBeforeRender) {
	            if (this.transparent) {
	                this.context.clearRect(0, 0, this.width, this.height);
	            } else if (root._bgColor) {
	                this.context.fillStyle = root._bgColor.rgba;
	                this.context.fillRect(0, 0, this.width, this.height);
	            }
	        }
	
	        this.renderDisplayObject(root);
	    };
	
	    /**
	     * Removes everything from the renderer and optionally removes the Canvas DOM element.
	     *
	     * @method destroy
	     * @param [removeView=true] {boolean} Removes the Canvas element from the DOM.
	     */
	    PIXI.CanvasRenderer.prototype.destroy = function (removeView) {
	
	        if (removeView === undefined) {
	            removeView = true;
	        }
	
	        if (removeView && this.view.parent) {
	            this.view.parent.removeChild(this.view);
	        }
	
	        this.view = null;
	        this.context = null;
	        this.maskManager = null;
	        this.renderSession = null;
	    };
	
	    /**
	     * Resizes the canvas view to the specified width and height
	     *
	     * @method resize
	     * @param width {Number} the new width of the canvas view
	     * @param height {Number} the new height of the canvas view
	     */
	    PIXI.CanvasRenderer.prototype.resize = function (width, height) {
	
	        this.width = width * this.resolution;
	        this.height = height * this.resolution;
	
	        this.view.width = this.width;
	        this.view.height = this.height;
	
	        if (this.autoResize) {
	            this.view.style.width = this.width / this.resolution + "px";
	            this.view.style.height = this.height / this.resolution + "px";
	        }
	
	        if (this.renderSession.smoothProperty) {
	            this.context[this.renderSession.smoothProperty] = this.renderSession.scaleMode === PIXI.scaleModes.LINEAR;
	        }
	    };
	
	    /**
	     * Renders a display object
	     *
	     * @method renderDisplayObject
	     * @param displayObject {DisplayObject} The displayObject to render
	     * @param context {CanvasRenderingContext2D} the context 2d method of the canvas
	     * @param [matrix] {Matrix} Optional matrix to apply to the display object before rendering.
	     * @private
	     */
	    PIXI.CanvasRenderer.prototype.renderDisplayObject = function (displayObject, context, matrix) {
	
	        this.renderSession.context = context || this.context;
	        this.renderSession.resolution = this.resolution;
	        displayObject._renderCanvas(this.renderSession, matrix);
	    };
	
	    /**
	     * Maps Pixi blend modes to canvas blend modes.
	     *
	     * @method mapBlendModes
	     * @private
	     */
	    PIXI.CanvasRenderer.prototype.mapBlendModes = function () {
	
	        if (!PIXI.blendModesCanvas) {
	            var b = [];
	            var modes = PIXI.blendModes;
	            var useNew = PIXI.canUseNewCanvasBlendModes();
	
	            b[modes.NORMAL] = 'source-over';
	            b[modes.ADD] = 'lighter';
	            b[modes.MULTIPLY] = useNew ? 'multiply' : 'source-over';
	            b[modes.SCREEN] = useNew ? 'screen' : 'source-over';
	            b[modes.OVERLAY] = useNew ? 'overlay' : 'source-over';
	            b[modes.DARKEN] = useNew ? 'darken' : 'source-over';
	            b[modes.LIGHTEN] = useNew ? 'lighten' : 'source-over';
	            b[modes.COLOR_DODGE] = useNew ? 'color-dodge' : 'source-over';
	            b[modes.COLOR_BURN] = useNew ? 'color-burn' : 'source-over';
	            b[modes.HARD_LIGHT] = useNew ? 'hard-light' : 'source-over';
	            b[modes.SOFT_LIGHT] = useNew ? 'soft-light' : 'source-over';
	            b[modes.DIFFERENCE] = useNew ? 'difference' : 'source-over';
	            b[modes.EXCLUSION] = useNew ? 'exclusion' : 'source-over';
	            b[modes.HUE] = useNew ? 'hue' : 'source-over';
	            b[modes.SATURATION] = useNew ? 'saturation' : 'source-over';
	            b[modes.COLOR] = useNew ? 'color' : 'source-over';
	            b[modes.LUMINOSITY] = useNew ? 'luminosity' : 'source-over';
	
	            PIXI.blendModesCanvas = b;
	        }
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	     * A texture stores the information that represents an image. All textures have a base texture.
	     *
	     * @class BaseTexture
	     * @uses EventTarget
	     * @constructor
	     * @param source {String|Canvas} the source object (image or canvas)
	     * @param scaleMode {Number} See {{#crossLink "PIXI/scaleModes:property"}}PIXI.scaleModes{{/crossLink}} for possible values
	     */
	    PIXI.BaseTexture = function (source, scaleMode) {
	        /**
	         * The Resolution of the texture. 
	         *
	         * @property resolution
	         * @type Number
	         */
	        this.resolution = 1;
	
	        /**
	         * [read-only] The width of the base texture set when the image has loaded
	         *
	         * @property width
	         * @type Number
	         * @readOnly
	         */
	        this.width = 100;
	
	        /**
	         * [read-only] The height of the base texture set when the image has loaded
	         *
	         * @property height
	         * @type Number
	         * @readOnly
	         */
	        this.height = 100;
	
	        /**
	         * The scale mode to apply when scaling this texture
	         * 
	         * @property scaleMode
	         * @type {Number}
	         * @default PIXI.scaleModes.LINEAR
	         */
	        this.scaleMode = scaleMode || PIXI.scaleModes.DEFAULT;
	
	        /**
	         * [read-only] Set to true once the base texture has loaded
	         *
	         * @property hasLoaded
	         * @type Boolean
	         * @readOnly
	         */
	        this.hasLoaded = false;
	
	        /**
	         * The image source that is used to create the texture.
	         *
	         * @property source
	         * @type Image
	         */
	        this.source = source;
	
	        /**
	         * Controls if RGB channels should be pre-multiplied by Alpha  (WebGL only)
	         *
	         * @property premultipliedAlpha
	         * @type Boolean
	         * @default true
	         */
	        this.premultipliedAlpha = true;
	
	        // used for webGL
	
	        /**
	         * @property _glTextures
	         * @type Array
	         * @private
	         */
	        this._glTextures = [];
	
	        /**
	         * Set this to true if a mipmap of this texture needs to be generated. This value needs to be set before the texture is used
	         * Also the texture must be a power of two size to work
	         * 
	         * @property mipmap
	         * @type {Boolean}
	         */
	        this.mipmap = false;
	
	        /**
	         * @property _dirty
	         * @type Array
	         * @private
	         */
	        this._dirty = [true, true, true, true];
	
	        if (!source) {
	            return;
	        }
	
	        if ((this.source.complete || this.source.getContext) && this.source.width && this.source.height) {
	            this.hasLoaded = true;
	            this.width = this.source.naturalWidth || this.source.width;
	            this.height = this.source.naturalHeight || this.source.height;
	            this.dirty();
	        }
	
	        /**
	         * A BaseTexture can be set to skip the rendering phase in the WebGL Sprite Batch.
	         * 
	         * You may want to do this if you have a parent Sprite with no visible texture (i.e. uses the internal `__default` texture)
	         * that has children that you do want to render, without causing a batch flush in the process.
	         * 
	         * @property skipRender
	         * @type Boolean
	         */
	        this.skipRender = false;
	
	        /**
	         * @property _powerOf2
	         * @type Boolean
	         * @private
	         */
	        this._powerOf2 = false;
	    };
	
	    PIXI.BaseTexture.prototype.constructor = PIXI.BaseTexture;
	
	    /**
	     * Forces this BaseTexture to be set as loaded, with the given width and height.
	     * Then calls BaseTexture.dirty.
	     * Important for when you don't want to modify the source object by forcing in `complete` or dimension properties it may not have.
	     *
	     * @method forceLoaded
	     * @param {number} width - The new width to force the BaseTexture to be.
	     * @param {number} height - The new height to force the BaseTexture to be.
	     */
	    PIXI.BaseTexture.prototype.forceLoaded = function (width, height) {
	        this.hasLoaded = true;
	        this.width = width;
	        this.height = height;
	        this.dirty();
	    };
	
	    /**
	     * Destroys this base texture
	     *
	     * @method destroy
	     */
	    PIXI.BaseTexture.prototype.destroy = function () {
	        if (this.source) {
	            PIXI.CanvasPool.removeByCanvas(this.source);
	        }
	
	        this.source = null;
	
	        this.unloadFromGPU();
	    };
	
	    /**
	     * Changes the source image of the texture
	     *
	     * @method updateSourceImage
	     * @param newSrc {String} the path of the image
	     * @deprecated This method is deprecated. Please use Phaser.Sprite.loadTexture instead.
	     */
	    PIXI.BaseTexture.prototype.updateSourceImage = function (newSrc) {
	        console.warn("PIXI.BaseTexture.updateSourceImage is deprecated. Use Phaser.Sprite.loadTexture instead.");
	    };
	
	    /**
	     * Sets all glTextures to be dirty.
	     *
	     * @method dirty
	     */
	    PIXI.BaseTexture.prototype.dirty = function () {
	        for (var i = 0; i < this._glTextures.length; i++) {
	            this._dirty[i] = true;
	        }
	    };
	
	    /**
	     * Removes the base texture from the GPU, useful for managing resources on the GPU.
	     * Atexture is still 100% usable and will simply be reuploaded if there is a sprite on screen that is using it.
	     *
	     * @method unloadFromGPU
	     */
	    PIXI.BaseTexture.prototype.unloadFromGPU = function () {
	        this.dirty();
	
	        // delete the webGL textures if any.
	        for (var i = this._glTextures.length - 1; i >= 0; i--) {
	            var glTexture = this._glTextures[i];
	            var gl = PIXI.glContexts[i];
	
	            if (gl && glTexture) {
	                gl.deleteTexture(glTexture);
	            }
	        }
	
	        this._glTextures.length = 0;
	
	        this.dirty();
	    };
	
	    /**
	     * Helper function that creates a base texture from the given canvas element.
	     *
	     * @static
	     * @method fromCanvas
	     * @param canvas {Canvas} The canvas element source of the texture
	     * @param scaleMode {Number} See {{#crossLink "PIXI/scaleModes:property"}}PIXI.scaleModes{{/crossLink}} for possible values
	     * @return {BaseTexture}
	     */
	    PIXI.BaseTexture.fromCanvas = function (canvas, scaleMode) {
	        if (canvas.width === 0) {
	            canvas.width = 1;
	        }
	
	        if (canvas.height === 0) {
	            canvas.height = 1;
	        }
	
	        return new PIXI.BaseTexture(canvas, scaleMode);
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	     * TextureSilentFail is a boolean that defaults to `false`. 
	     * If `true` then `PIXI.Texture.setFrame` will no longer throw an error if the texture dimensions are incorrect. 
	     * Instead `Texture.valid` will be set to `false` (#1556)
	     *
	     * @type {boolean}
	     */
	    PIXI.TextureSilentFail = false;
	
	    /**
	     * A texture stores the information that represents an image or part of an image. It cannot be added
	     * to the display list directly. Instead use it as the texture for a PIXI.Sprite. If no frame is provided then the whole image is used.
	     *
	     * @class Texture
	     * @uses EventTarget
	     * @constructor
	     * @param baseTexture {BaseTexture} The base texture source to create the texture from
	     * @param frame {Rectangle} The rectangle frame of the texture to show
	     * @param [crop] {Rectangle} The area of original texture 
	     * @param [trim] {Rectangle} Trimmed texture rectangle
	     */
	    PIXI.Texture = function (baseTexture, frame, crop, trim) {
	        /**
	         * Does this Texture have any frame data assigned to it?
	         *
	         * @property noFrame
	         * @type Boolean
	         */
	        this.noFrame = false;
	
	        if (!frame) {
	            this.noFrame = true;
	            frame = new PIXI.Rectangle(0, 0, 1, 1);
	        }
	
	        if (baseTexture instanceof PIXI.Texture) {
	            baseTexture = baseTexture.baseTexture;
	        }
	
	        /**
	         * The base texture that this texture uses.
	         *
	         * @property baseTexture
	         * @type BaseTexture
	         */
	        this.baseTexture = baseTexture;
	
	        /**
	         * The frame specifies the region of the base texture that this texture uses
	         *
	         * @property frame
	         * @type Rectangle
	         */
	        this.frame = frame;
	
	        /**
	         * The texture trim data.
	         *
	         * @property trim
	         * @type Rectangle
	         */
	        this.trim = trim;
	
	        /**
	         * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
	         *
	         * @property valid
	         * @type Boolean
	         */
	        this.valid = false;
	
	        /**
	         * Is this a tiling texture? As used by the likes of a TilingSprite.
	         *
	         * @property isTiling
	         * @type Boolean
	         */
	        this.isTiling = false;
	
	        /**
	         * This will let a renderer know that a texture has been updated (used mainly for webGL uv updates)
	         *
	         * @property requiresUpdate
	         * @type Boolean
	         */
	        this.requiresUpdate = false;
	
	        /**
	         * This will let a renderer know that a tinted parent has updated its texture.
	         *
	         * @property requiresReTint
	         * @type Boolean
	         */
	        this.requiresReTint = false;
	
	        /**
	         * The WebGL UV data cache.
	         *
	         * @property _uvs
	         * @type Object
	         * @private
	         */
	        this._uvs = null;
	
	        /**
	         * The width of the Texture in pixels.
	         *
	         * @property width
	         * @type Number
	         */
	        this.width = 0;
	
	        /**
	         * The height of the Texture in pixels.
	         *
	         * @property height
	         * @type Number
	         */
	        this.height = 0;
	
	        /**
	         * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
	         * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
	         *
	         * @property crop
	         * @type Rectangle
	         */
	        this.crop = crop || new PIXI.Rectangle(0, 0, 1, 1);
	
	        if (baseTexture.hasLoaded) {
	            if (this.noFrame) frame = new PIXI.Rectangle(0, 0, baseTexture.width, baseTexture.height);
	            this.setFrame(frame);
	        }
	    };
	
	    PIXI.Texture.prototype.constructor = PIXI.Texture;
	
	    /**
	     * Called when the base texture is loaded
	     *
	     * @method onBaseTextureLoaded
	     * @private
	     */
	    PIXI.Texture.prototype.onBaseTextureLoaded = function () {
	        var baseTexture = this.baseTexture;
	
	        if (this.noFrame) {
	            this.frame = new PIXI.Rectangle(0, 0, baseTexture.width, baseTexture.height);
	        }
	
	        this.setFrame(this.frame);
	    };
	
	    /**
	     * Destroys this texture
	     *
	     * @method destroy
	     * @param destroyBase {Boolean} Whether to destroy the base texture as well
	     */
	    PIXI.Texture.prototype.destroy = function (destroyBase) {
	        if (destroyBase) this.baseTexture.destroy();
	
	        this.valid = false;
	    };
	
	    /**
	     * Specifies the region of the baseTexture that this texture will use.
	     *
	     * @method setFrame
	     * @param frame {Rectangle} The frame of the texture to set it to
	     */
	    PIXI.Texture.prototype.setFrame = function (frame) {
	        this.noFrame = false;
	
	        this.frame = frame;
	        this.width = frame.width;
	        this.height = frame.height;
	
	        this.crop.x = frame.x;
	        this.crop.y = frame.y;
	        this.crop.width = frame.width;
	        this.crop.height = frame.height;
	
	        if (!this.trim && (frame.x + frame.width > this.baseTexture.width || frame.y + frame.height > this.baseTexture.height)) {
	            if (!PIXI.TextureSilentFail) {
	                throw new Error('Texture Error: frame does not fit inside the base Texture dimensions ' + this);
	            }
	
	            this.valid = false;
	            return;
	        }
	
	        this.valid = frame && frame.width && frame.height && this.baseTexture.source && this.baseTexture.hasLoaded;
	
	        if (this.trim) {
	            this.width = this.trim.width;
	            this.height = this.trim.height;
	            this.frame.width = this.trim.width;
	            this.frame.height = this.trim.height;
	        }
	
	        if (this.valid) this._updateUvs();
	    };
	
	    /**
	     * Updates the internal WebGL UV cache.
	     *
	     * @method _updateUvs
	     * @private
	     */
	    PIXI.Texture.prototype._updateUvs = function () {
	        if (!this._uvs) this._uvs = new PIXI.TextureUvs();
	
	        var frame = this.crop;
	        var tw = this.baseTexture.width;
	        var th = this.baseTexture.height;
	
	        this._uvs.x0 = frame.x / tw;
	        this._uvs.y0 = frame.y / th;
	
	        this._uvs.x1 = (frame.x + frame.width) / tw;
	        this._uvs.y1 = frame.y / th;
	
	        this._uvs.x2 = (frame.x + frame.width) / tw;
	        this._uvs.y2 = (frame.y + frame.height) / th;
	
	        this._uvs.x3 = frame.x / tw;
	        this._uvs.y3 = (frame.y + frame.height) / th;
	    };
	
	    /**
	     * Helper function that creates a new a Texture based on the given canvas element.
	     *
	     * @static
	     * @method fromCanvas
	     * @param canvas {Canvas} The canvas element source of the texture
	     * @param scaleMode {Number} See {{#crossLink "PIXI/scaleModes:property"}}PIXI.scaleModes{{/crossLink}} for possible values
	     * @return {Texture}
	     */
	    PIXI.Texture.fromCanvas = function (canvas, scaleMode) {
	        var baseTexture = PIXI.BaseTexture.fromCanvas(canvas, scaleMode);
	
	        return new PIXI.Texture(baseTexture);
	    };
	
	    PIXI.TextureUvs = function () {
	        this.x0 = 0;
	        this.y0 = 0;
	
	        this.x1 = 0;
	        this.y1 = 0;
	
	        this.x2 = 0;
	        this.y2 = 0;
	
	        this.x3 = 0;
	        this.y3 = 0;
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	     * A RenderTexture is a special texture that allows any Pixi display object to be rendered to it.
	     *
	     * __Hint__: All DisplayObjects (i.e. Sprites) that render to a RenderTexture should be preloaded otherwise black rectangles will be drawn instead.
	     *
	     * A RenderTexture takes a snapshot of any Display Object given to its render method. The position and rotation of the given Display Objects is ignored. For example:
	     *
	     *    var renderTexture = new PIXI.RenderTexture(800, 600);
	     *    var sprite = PIXI.Sprite.fromImage("spinObj_01.png");
	     *    sprite.position.x = 800/2;
	     *    sprite.position.y = 600/2;
	     *    sprite.anchor.x = 0.5;
	     *    sprite.anchor.y = 0.5;
	     *    renderTexture.render(sprite);
	     *
	     * The Sprite in this case will be rendered to a position of 0,0. To render this sprite at its actual position a DisplayObjectContainer should be used:
	     *
	     *    var doc = new PIXI.DisplayObjectContainer();
	     *    doc.addChild(sprite);
	     *    renderTexture.render(doc);  // Renders to center of renderTexture
	     *
	     * @class RenderTexture
	     * @extends Texture
	     * @constructor
	     * @param width {Number} The width of the render texture
	     * @param height {Number} The height of the render texture
	     * @param renderer {CanvasRenderer|WebGLRenderer} The renderer used for this RenderTexture
	     * @param scaleMode {Number} See {{#crossLink "PIXI/scaleModes:property"}}PIXI.scaleModes{{/crossLink}} for possible values
	     * @param resolution {Number} The resolution of the texture being generated
	     */
	    PIXI.RenderTexture = function (width, height, renderer, scaleMode, resolution) {
	        /**
	         * The with of the render texture
	         *
	         * @property width
	         * @type Number
	         */
	        this.width = width || 100;
	
	        /**
	         * The height of the render texture
	         *
	         * @property height
	         * @type Number
	         */
	        this.height = height || 100;
	
	        /**
	         * The Resolution of the texture.
	         *
	         * @property resolution
	         * @type Number
	         */
	        this.resolution = resolution || 1;
	
	        /**
	         * The framing rectangle of the render texture
	         *
	         * @property frame
	         * @type Rectangle
	         */
	        this.frame = new PIXI.Rectangle(0, 0, this.width * this.resolution, this.height * this.resolution);
	
	        /**
	         * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
	         * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
	         *
	         * @property crop
	         * @type Rectangle
	         */
	        this.crop = new PIXI.Rectangle(0, 0, this.width * this.resolution, this.height * this.resolution);
	
	        /**
	         * The base texture object that this texture uses
	         *
	         * @property baseTexture
	         * @type BaseTexture
	         */
	        this.baseTexture = new PIXI.BaseTexture();
	        this.baseTexture.width = this.width * this.resolution;
	        this.baseTexture.height = this.height * this.resolution;
	        this.baseTexture._glTextures = [];
	        this.baseTexture.resolution = this.resolution;
	
	        this.baseTexture.scaleMode = scaleMode || PIXI.scaleModes.DEFAULT;
	
	        this.baseTexture.hasLoaded = true;
	
	        PIXI.Texture.call(this, this.baseTexture, new PIXI.Rectangle(0, 0, this.width * this.resolution, this.height * this.resolution));
	
	        /**
	         * The renderer this RenderTexture uses. A RenderTexture can only belong to one renderer at the moment if its webGL.
	         *
	         * @property renderer
	         * @type CanvasRenderer|WebGLRenderer
	         */
	        this.renderer = renderer || PIXI.defaultRenderer;
	
	        if (this.renderer.type === PIXI.WEBGL_RENDERER) {
	            var gl = this.renderer.gl;
	            this.baseTexture._dirty[gl.id] = false;
	
	            this.textureBuffer = new PIXI.FilterTexture(gl, this.width, this.height, this.baseTexture.scaleMode);
	            this.baseTexture._glTextures[gl.id] = this.textureBuffer.texture;
	
	            this.render = this.renderWebGL;
	            this.projection = new PIXI.Point(this.width * 0.5, -this.height * 0.5);
	        } else {
	            this.render = this.renderCanvas;
	            this.textureBuffer = new PIXI.CanvasBuffer(this.width * this.resolution, this.height * this.resolution);
	            this.baseTexture.source = this.textureBuffer.canvas;
	        }
	
	        /**
	         * @property valid
	         * @type Boolean
	         */
	        this.valid = true;
	
	        this.tempMatrix = new Phaser.Matrix();
	
	        this._updateUvs();
	    };
	
	    PIXI.RenderTexture.prototype = Object.create(PIXI.Texture.prototype);
	    PIXI.RenderTexture.prototype.constructor = PIXI.RenderTexture;
	
	    /**
	     * Resizes the RenderTexture.
	     *
	     * @method resize
	     * @param width {Number} The width to resize to.
	     * @param height {Number} The height to resize to.
	     * @param updateBase {Boolean} Should the baseTexture.width and height values be resized as well?
	     */
	    PIXI.RenderTexture.prototype.resize = function (width, height, updateBase) {
	        if (width === this.width && height === this.height) return;
	
	        this.valid = width > 0 && height > 0;
	
	        this.width = width;
	        this.height = height;
	        this.frame.width = this.crop.width = width * this.resolution;
	        this.frame.height = this.crop.height = height * this.resolution;
	
	        if (updateBase) {
	            this.baseTexture.width = this.width * this.resolution;
	            this.baseTexture.height = this.height * this.resolution;
	        }
	
	        if (this.renderer.type === PIXI.WEBGL_RENDERER) {
	            this.projection.x = this.width / 2;
	            this.projection.y = -this.height / 2;
	        }
	
	        if (!this.valid) return;
	
	        this.textureBuffer.resize(this.width, this.height);
	    };
	
	    /**
	     * Clears the RenderTexture.
	     *
	     * @method clear
	     */
	    PIXI.RenderTexture.prototype.clear = function () {
	        if (!this.valid) {
	            return;
	        }
	
	        if (this.renderer.type === PIXI.WEBGL_RENDERER) {
	            this.renderer.gl.bindFramebuffer(this.renderer.gl.FRAMEBUFFER, this.textureBuffer.frameBuffer);
	        }
	
	        this.textureBuffer.clear();
	    };
	
	    /**
	     * This function will draw the display object to the texture.
	     *
	     * @method renderWebGL
	     * @param displayObject {DisplayObject} The display object to render this texture on
	     * @param [matrix] {Matrix} Optional matrix to apply to the display object before rendering.
	     * @param [clear] {Boolean} If true the texture will be cleared before the displayObject is drawn
	     * @private
	     */
	    PIXI.RenderTexture.prototype.renderWebGL = function (displayObject, matrix, clear) {
	        if (!this.valid || displayObject.alpha === 0) {
	            return;
	        }
	
	        //  Let's create a nice matrix to apply to our display object.
	        //  Frame buffers come in upside down so we need to flip the matrix.
	        var wt = displayObject.worldTransform;
	        wt.identity();
	        wt.translate(0, this.projection.y * 2);
	
	        if (matrix) {
	            wt.append(matrix);
	        }
	
	        wt.scale(1, -1);
	
	        //  Time to update all the children of the displayObject with the new matrix.
	        for (var i = 0; i < displayObject.children.length; i++) {
	            displayObject.children[i].updateTransform();
	        }
	
	        //  Time for the webGL fun stuff!
	        var gl = this.renderer.gl;
	
	        gl.viewport(0, 0, this.width * this.resolution, this.height * this.resolution);
	
	        gl.bindFramebuffer(gl.FRAMEBUFFER, this.textureBuffer.frameBuffer);
	
	        if (clear) {
	            this.textureBuffer.clear();
	        }
	
	        this.renderer.spriteBatch.dirty = true;
	
	        this.renderer.renderDisplayObject(displayObject, this.projection, this.textureBuffer.frameBuffer, matrix);
	
	        this.renderer.spriteBatch.dirty = true;
	    };
	
	    /**
	     * This function will draw the display object to the texture.
	     *
	     * @method renderCanvas
	     * @param displayObject {DisplayObject} The display object to render this texture on
	     * @param [matrix] {Matrix} Optional matrix to apply to the display object before rendering.
	     * @param [clear] {Boolean} If true the texture will be cleared before the displayObject is drawn
	     * @private
	     */
	    PIXI.RenderTexture.prototype.renderCanvas = function (displayObject, matrix, clear) {
	        if (!this.valid || displayObject.alpha === 0) {
	            return;
	        }
	
	        //  Let's create a nice matrix to apply to our display object.
	        //  Frame buffers come in upside down so we need to flip the matrix.
	        var wt = displayObject.worldTransform;
	        wt.identity();
	
	        if (matrix) {
	            wt.append(matrix);
	        }
	
	        // Time to update all the children of the displayObject with the new matrix (what new matrix? there isn't one!)
	        for (var i = 0; i < displayObject.children.length; i++) {
	            displayObject.children[i].updateTransform();
	        }
	
	        if (clear) {
	            this.textureBuffer.clear();
	        }
	
	        var realResolution = this.renderer.resolution;
	
	        this.renderer.resolution = this.resolution;
	
	        this.renderer.renderDisplayObject(displayObject, this.textureBuffer.context, matrix);
	
	        this.renderer.resolution = realResolution;
	    };
	
	    /**
	     * Will return a HTML Image of the texture
	     *
	     * @method getImage
	     * @return {Image}
	     */
	    PIXI.RenderTexture.prototype.getImage = function () {
	        var image = new Image();
	        image.src = this.getBase64();
	        return image;
	    };
	
	    /**
	     * Will return a base64 encoded string of this texture. It works by calling RenderTexture.getCanvas and then running toDataURL on that.
	     *
	     * @method getBase64
	     * @return {String} A base64 encoded string of the texture.
	     */
	    PIXI.RenderTexture.prototype.getBase64 = function () {
	        return this.getCanvas().toDataURL();
	    };
	
	    /**
	     * Creates a Canvas element, renders this RenderTexture to it and then returns it.
	     *
	     * @method getCanvas
	     * @return {HTMLCanvasElement} A Canvas element with the texture rendered on.
	     */
	    PIXI.RenderTexture.prototype.getCanvas = function () {
	        if (this.renderer.type === PIXI.WEBGL_RENDERER) {
	            var gl = this.renderer.gl;
	            var width = this.textureBuffer.width;
	            var height = this.textureBuffer.height;
	
	            var webGLPixels = new Uint8Array(4 * width * height);
	
	            gl.bindFramebuffer(gl.FRAMEBUFFER, this.textureBuffer.frameBuffer);
	            gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webGLPixels);
	            gl.bindFramebuffer(gl.FRAMEBUFFER, null);
	
	            var tempCanvas = new PIXI.CanvasBuffer(width, height);
	            var canvasData = tempCanvas.context.getImageData(0, 0, width, height);
	            canvasData.data.set(webGLPixels);
	
	            tempCanvas.context.putImageData(canvasData, 0, 0);
	
	            return tempCanvas.canvas;
	        } else {
	            return this.textureBuffer.canvas;
	        }
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    /**
	     * This is the base class for creating a PIXI filter. Currently only webGL supports filters.
	     * If you want to make a custom filter this should be your base class.
	     * 
	     * @class AbstractFilter
	     * @constructor
	     * @param fragmentSrc {Array} The fragment source in an array of strings.
	     * @param uniforms {Object} An object containing the uniforms for this filter.
	     */
	    PIXI.AbstractFilter = function (fragmentSrc, uniforms) {
	        /**
	        * An array of passes - some filters contain a few steps this array simply stores the steps in a liniear fashion.
	        * For example the blur filter has two passes blurX and blurY.
	        * @property passes
	        * @type Array
	        * @private
	        */
	        this.passes = [this];
	
	        /**
	        * @property shaders
	        * @type Array
	        * @private
	        */
	        this.shaders = [];
	
	        /**
	        * @property dirty
	        * @type Boolean
	        */
	        this.dirty = true;
	
	        /**
	        * @property padding
	        * @type Number
	        */
	        this.padding = 0;
	
	        /**
	        * @property uniforms
	        * @type Object
	        * @private
	        */
	        this.uniforms = uniforms || {};
	
	        /**
	        * @property fragmentSrc
	        * @type Array
	        * @private
	        */
	        this.fragmentSrc = fragmentSrc || [];
	    };
	
	    PIXI.AbstractFilter.prototype.constructor = PIXI.AbstractFilter;
	
	    /**
	     * Syncs the uniforms between the class object and the shaders.
	     *
	     * @method syncUniforms
	     */
	    PIXI.AbstractFilter.prototype.syncUniforms = function () {
	        for (var i = 0, j = this.shaders.length; i < j; i++) {
	            this.shaders[i].dirty = true;
	        }
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/
	     */
	
	    /**
	    *
	    * @class Strip
	    * @extends DisplayObjectContainer
	    * @constructor
	    * @param texture {Texture} The texture to use
	    * @param width {Number} the width
	    * @param height {Number} the height
	    *
	    */
	    PIXI.Strip = function (texture) {
	        PIXI.DisplayObjectContainer.call(this);
	
	        /**
	         * The texture of the strip
	         *
	         * @property texture
	         * @type Texture
	         */
	        this.texture = texture;
	
	        // set up the main bits..
	        this.uvs = new PIXI.Float32Array([0, 1, 1, 1, 1, 0, 0, 1]);
	
	        this.vertices = new PIXI.Float32Array([0, 0, 100, 0, 100, 100, 0, 100]);
	
	        this.colors = new PIXI.Float32Array([1, 1, 1, 1]);
	
	        this.indices = new PIXI.Uint16Array([0, 1, 2, 3]);
	
	        /**
	         * Whether the strip is dirty or not
	         *
	         * @property dirty
	         * @type Boolean
	         */
	        this.dirty = true;
	
	        /**
	         * The blend mode to be applied to the sprite. Set to PIXI.blendModes.NORMAL to remove any blend mode.
	         *
	         * @property blendMode
	         * @type Number
	         * @default PIXI.blendModes.NORMAL;
	         */
	        this.blendMode = PIXI.blendModes.NORMAL;
	
	        /**
	         * Triangles in canvas mode are automatically antialiased, use this value to force triangles to overlap a bit with each other.
	         *
	         * @property canvasPadding
	         * @type Number
	         */
	        this.canvasPadding = 0;
	
	        this.drawMode = PIXI.Strip.DrawModes.TRIANGLE_STRIP;
	    };
	
	    // constructor
	    PIXI.Strip.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);
	    PIXI.Strip.prototype.constructor = PIXI.Strip;
	
	    PIXI.Strip.prototype._renderWebGL = function (renderSession) {
	        // if the sprite is not visible or the alpha is 0 then no need to render this element
	        if (!this.visible || this.alpha <= 0) return;
	        // render triangle strip..
	
	        renderSession.spriteBatch.stop();
	
	        // init! init!
	        if (!this._vertexBuffer) this._initWebGL(renderSession);
	
	        renderSession.shaderManager.setShader(renderSession.shaderManager.stripShader);
	
	        this._renderStrip(renderSession);
	
	        ///renderSession.shaderManager.activateDefaultShader();
	
	        renderSession.spriteBatch.start();
	
	        //TODO check culling
	    };
	
	    PIXI.Strip.prototype._initWebGL = function (renderSession) {
	        // build the strip!
	        var gl = renderSession.gl;
	
	        this._vertexBuffer = gl.createBuffer();
	        this._indexBuffer = gl.createBuffer();
	        this._uvBuffer = gl.createBuffer();
	        this._colorBuffer = gl.createBuffer();
	
	        gl.bindBuffer(gl.ARRAY_BUFFER, this._vertexBuffer);
	        gl.bufferData(gl.ARRAY_BUFFER, this.vertices, gl.DYNAMIC_DRAW);
	
	        gl.bindBuffer(gl.ARRAY_BUFFER, this._uvBuffer);
	        gl.bufferData(gl.ARRAY_BUFFER, this.uvs, gl.STATIC_DRAW);
	
	        gl.bindBuffer(gl.ARRAY_BUFFER, this._colorBuffer);
	        gl.bufferData(gl.ARRAY_BUFFER, this.colors, gl.STATIC_DRAW);
	
	        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._indexBuffer);
	        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this.indices, gl.STATIC_DRAW);
	    };
	
	    PIXI.Strip.prototype._renderStrip = function (renderSession) {
	        var gl = renderSession.gl;
	        var projection = renderSession.projection,
	            offset = renderSession.offset,
	            shader = renderSession.shaderManager.stripShader;
	
	        var drawMode = this.drawMode === PIXI.Strip.DrawModes.TRIANGLE_STRIP ? gl.TRIANGLE_STRIP : gl.TRIANGLES;
	
	        // gl.uniformMatrix4fv(shaderProgram.mvMatrixUniform, false, mat4Real);
	
	        renderSession.blendModeManager.setBlendMode(this.blendMode);
	
	        // set uniforms
	        gl.uniformMatrix3fv(shader.translationMatrix, false, this.worldTransform.toArray(true));
	        gl.uniform2f(shader.projectionVector, projection.x, -projection.y);
	        gl.uniform2f(shader.offsetVector, -offset.x, -offset.y);
	        gl.uniform1f(shader.alpha, this.worldAlpha);
	
	        if (!this.dirty) {
	
	            gl.bindBuffer(gl.ARRAY_BUFFER, this._vertexBuffer);
	            gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.vertices);
	            gl.vertexAttribPointer(shader.aVertexPosition, 2, gl.FLOAT, false, 0, 0);
	
	            // update the uvs
	            gl.bindBuffer(gl.ARRAY_BUFFER, this._uvBuffer);
	            gl.vertexAttribPointer(shader.aTextureCoord, 2, gl.FLOAT, false, 0, 0);
	
	            gl.activeTexture(gl.TEXTURE0);
	
	            // check if a texture is dirty..
	            if (this.texture.baseTexture._dirty[gl.id]) {
	                renderSession.renderer.updateTexture(this.texture.baseTexture);
	            } else {
	                // bind the current texture
	                gl.bindTexture(gl.TEXTURE_2D, this.texture.baseTexture._glTextures[gl.id]);
	            }
	
	            // dont need to upload!
	            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._indexBuffer);
	        } else {
	
	            this.dirty = false;
	            gl.bindBuffer(gl.ARRAY_BUFFER, this._vertexBuffer);
	            gl.bufferData(gl.ARRAY_BUFFER, this.vertices, gl.STATIC_DRAW);
	            gl.vertexAttribPointer(shader.aVertexPosition, 2, gl.FLOAT, false, 0, 0);
	
	            // update the uvs
	            gl.bindBuffer(gl.ARRAY_BUFFER, this._uvBuffer);
	            gl.bufferData(gl.ARRAY_BUFFER, this.uvs, gl.STATIC_DRAW);
	            gl.vertexAttribPointer(shader.aTextureCoord, 2, gl.FLOAT, false, 0, 0);
	
	            gl.activeTexture(gl.TEXTURE0);
	
	            // check if a texture is dirty..
	            if (this.texture.baseTexture._dirty[gl.id]) {
	                renderSession.renderer.updateTexture(this.texture.baseTexture);
	            } else {
	                gl.bindTexture(gl.TEXTURE_2D, this.texture.baseTexture._glTextures[gl.id]);
	            }
	
	            // dont need to upload!
	            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this._indexBuffer);
	            gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this.indices, gl.STATIC_DRAW);
	        }
	        //console.log(gl.TRIANGLE_STRIP)
	        //
	        //
	        gl.drawElements(drawMode, this.indices.length, gl.UNSIGNED_SHORT, 0);
	    };
	
	    PIXI.Strip.prototype._renderCanvas = function (renderSession) {
	        var context = renderSession.context;
	
	        var transform = this.worldTransform;
	
	        var tx = transform.tx * renderSession.resolution + renderSession.shakeX;
	        var ty = transform.ty * renderSession.resolution + renderSession.shakeY;
	
	        if (renderSession.roundPixels) {
	            context.setTransform(transform.a, transform.b, transform.c, transform.d, tx | 0, ty | 0);
	        } else {
	            context.setTransform(transform.a, transform.b, transform.c, transform.d, tx, ty);
	        }
	
	        if (this.drawMode === PIXI.Strip.DrawModes.TRIANGLE_STRIP) {
	            this._renderCanvasTriangleStrip(context);
	        } else {
	            this._renderCanvasTriangles(context);
	        }
	    };
	
	    PIXI.Strip.prototype._renderCanvasTriangleStrip = function (context) {
	        // draw triangles!!
	        var vertices = this.vertices;
	        var uvs = this.uvs;
	
	        var length = vertices.length / 2;
	        this.count++;
	
	        for (var i = 0; i < length - 2; i++) {
	            // draw some triangles!
	            var index = i * 2;
	            this._renderCanvasDrawTriangle(context, vertices, uvs, index, index + 2, index + 4);
	        }
	    };
	
	    PIXI.Strip.prototype._renderCanvasTriangles = function (context) {
	        // draw triangles!!
	        var vertices = this.vertices;
	        var uvs = this.uvs;
	        var indices = this.indices;
	
	        var length = indices.length;
	        this.count++;
	
	        for (var i = 0; i < length; i += 3) {
	            // draw some triangles!
	            var index0 = indices[i] * 2,
	                index1 = indices[i + 1] * 2,
	                index2 = indices[i + 2] * 2;
	            this._renderCanvasDrawTriangle(context, vertices, uvs, index0, index1, index2);
	        }
	    };
	
	    PIXI.Strip.prototype._renderCanvasDrawTriangle = function (context, vertices, uvs, index0, index1, index2) {
	        var textureSource = this.texture.baseTexture.source;
	        var textureWidth = this.texture.width;
	        var textureHeight = this.texture.height;
	
	        var x0 = vertices[index0],
	            x1 = vertices[index1],
	            x2 = vertices[index2];
	        var y0 = vertices[index0 + 1],
	            y1 = vertices[index1 + 1],
	            y2 = vertices[index2 + 1];
	
	        var u0 = uvs[index0] * textureWidth,
	            u1 = uvs[index1] * textureWidth,
	            u2 = uvs[index2] * textureWidth;
	        var v0 = uvs[index0 + 1] * textureHeight,
	            v1 = uvs[index1 + 1] * textureHeight,
	            v2 = uvs[index2 + 1] * textureHeight;
	
	        if (this.canvasPadding > 0) {
	            var paddingX = this.canvasPadding / this.worldTransform.a;
	            var paddingY = this.canvasPadding / this.worldTransform.d;
	            var centerX = (x0 + x1 + x2) / 3;
	            var centerY = (y0 + y1 + y2) / 3;
	
	            var normX = x0 - centerX;
	            var normY = y0 - centerY;
	
	            var dist = Math.sqrt(normX * normX + normY * normY);
	            x0 = centerX + normX / dist * (dist + paddingX);
	            y0 = centerY + normY / dist * (dist + paddingY);
	
	            //
	
	            normX = x1 - centerX;
	            normY = y1 - centerY;
	
	            dist = Math.sqrt(normX * normX + normY * normY);
	            x1 = centerX + normX / dist * (dist + paddingX);
	            y1 = centerY + normY / dist * (dist + paddingY);
	
	            normX = x2 - centerX;
	            normY = y2 - centerY;
	
	            dist = Math.sqrt(normX * normX + normY * normY);
	            x2 = centerX + normX / dist * (dist + paddingX);
	            y2 = centerY + normY / dist * (dist + paddingY);
	        }
	
	        context.save();
	        context.beginPath();
	
	        context.moveTo(x0, y0);
	        context.lineTo(x1, y1);
	        context.lineTo(x2, y2);
	
	        context.closePath();
	
	        context.clip();
	
	        // Compute matrix transform
	        var delta = u0 * v1 + v0 * u2 + u1 * v2 - v1 * u2 - v0 * u1 - u0 * v2;
	        var deltaA = x0 * v1 + v0 * x2 + x1 * v2 - v1 * x2 - v0 * x1 - x0 * v2;
	        var deltaB = u0 * x1 + x0 * u2 + u1 * x2 - x1 * u2 - x0 * u1 - u0 * x2;
	        var deltaC = u0 * v1 * x2 + v0 * x1 * u2 + x0 * u1 * v2 - x0 * v1 * u2 - v0 * u1 * x2 - u0 * x1 * v2;
	        var deltaD = y0 * v1 + v0 * y2 + y1 * v2 - v1 * y2 - v0 * y1 - y0 * v2;
	        var deltaE = u0 * y1 + y0 * u2 + u1 * y2 - y1 * u2 - y0 * u1 - u0 * y2;
	        var deltaF = u0 * v1 * y2 + v0 * y1 * u2 + y0 * u1 * v2 - y0 * v1 * u2 - v0 * u1 * y2 - u0 * y1 * v2;
	
	        context.transform(deltaA / delta, deltaD / delta, deltaB / delta, deltaE / delta, deltaC / delta, deltaF / delta);
	
	        context.drawImage(textureSource, 0, 0);
	        context.restore();
	    };
	
	    /**
	     * Renders a flat strip
	     *
	     * @method renderStripFlat
	     * @param strip {Strip} The Strip to render
	     * @private
	     */
	    PIXI.Strip.prototype.renderStripFlat = function (strip) {
	        var context = this.context;
	        var vertices = strip.vertices;
	
	        var length = vertices.length / 2;
	        this.count++;
	
	        context.beginPath();
	        for (var i = 1; i < length - 2; i++) {
	            // draw some triangles!
	            var index = i * 2;
	
	            var x0 = vertices[index],
	                x1 = vertices[index + 2],
	                x2 = vertices[index + 4];
	            var y0 = vertices[index + 1],
	                y1 = vertices[index + 3],
	                y2 = vertices[index + 5];
	
	            context.moveTo(x0, y0);
	            context.lineTo(x1, y1);
	            context.lineTo(x2, y2);
	        }
	
	        context.fillStyle = '#FF0000';
	        context.fill();
	        context.closePath();
	    };
	
	    /*
	    PIXI.Strip.prototype.setTexture = function(texture)
	    {
	        //TODO SET THE TEXTURES
	        //TODO VISIBILITY
	    
	        // stop current texture
	        this.texture = texture;
	        this.width   = texture.frame.width;
	        this.height  = texture.frame.height;
	        this.updateFrame = true;
	    };
	    */
	
	    /**
	     * When the texture is updated, this event will fire to update the scale and frame
	     *
	     * @method onTextureUpdate
	     * @param event
	     * @private
	     */
	
	    PIXI.Strip.prototype.onTextureUpdate = function () {
	        this.updateFrame = true;
	    };
	
	    /**
	     * Returns the bounds of the mesh as a rectangle. The bounds calculation takes the worldTransform into account.
	     *
	     * @method getBounds
	     * @param matrix {Matrix} the transformation matrix of the sprite
	     * @return {Rectangle} the framing rectangle
	     */
	    PIXI.Strip.prototype.getBounds = function (matrix) {
	        var worldTransform = matrix || this.worldTransform;
	
	        var a = worldTransform.a;
	        var b = worldTransform.b;
	        var c = worldTransform.c;
	        var d = worldTransform.d;
	        var tx = worldTransform.tx;
	        var ty = worldTransform.ty;
	
	        var maxX = -Infinity;
	        var maxY = -Infinity;
	
	        var minX = Infinity;
	        var minY = Infinity;
	
	        var vertices = this.vertices;
	        for (var i = 0, n = vertices.length; i < n; i += 2) {
	            var rawX = vertices[i],
	                rawY = vertices[i + 1];
	            var x = a * rawX + c * rawY + tx;
	            var y = d * rawY + b * rawX + ty;
	
	            minX = x < minX ? x : minX;
	            minY = y < minY ? y : minY;
	
	            maxX = x > maxX ? x : maxX;
	            maxY = y > maxY ? y : maxY;
	        }
	
	        if (minX === -Infinity || maxY === Infinity) {
	            return PIXI.EmptyRectangle;
	        }
	
	        var bounds = this._bounds;
	
	        bounds.x = minX;
	        bounds.width = maxX - minX;
	
	        bounds.y = minY;
	        bounds.height = maxY - minY;
	
	        // store a reference so that if this function gets called again in the render cycle we do not have to recalculate
	        this._currentBounds = bounds;
	
	        return bounds;
	    };
	
	    /**
	     * Different drawing buffer modes supported
	     *
	     * @property
	     * @type {{TRIANGLE_STRIP: number, TRIANGLES: number}}
	     * @static
	     */
	    PIXI.Strip.DrawModes = {
	        TRIANGLE_STRIP: 0,
	        TRIANGLES: 1
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     * @copyright Mat Groves, Rovanion Luckey
	     */
	
	    /**
	     *
	     * @class Rope
	     * @constructor
	     * @extends Strip
	     * @param {Texture} texture - The texture to use on the rope.
	     * @param {Array} points - An array of {PIXI.Point}.
	     *
	     */
	    PIXI.Rope = function (texture, points) {
	        PIXI.Strip.call(this, texture);
	        this.points = points;
	
	        this.vertices = new PIXI.Float32Array(points.length * 4);
	        this.uvs = new PIXI.Float32Array(points.length * 4);
	        this.colors = new PIXI.Float32Array(points.length * 2);
	        this.indices = new PIXI.Uint16Array(points.length * 2);
	
	        this.refresh();
	    };
	
	    // constructor
	    PIXI.Rope.prototype = Object.create(PIXI.Strip.prototype);
	    PIXI.Rope.prototype.constructor = PIXI.Rope;
	
	    /*
	     * Refreshes
	     *
	     * @method refresh
	     */
	    PIXI.Rope.prototype.refresh = function () {
	        var points = this.points;
	        if (points.length < 1) return;
	
	        var uvs = this.uvs;
	
	        var lastPoint = points[0];
	        var indices = this.indices;
	        var colors = this.colors;
	
	        this.count -= 0.2;
	
	        uvs[0] = 0;
	        uvs[1] = 0;
	        uvs[2] = 0;
	        uvs[3] = 1;
	
	        colors[0] = 1;
	        colors[1] = 1;
	
	        indices[0] = 0;
	        indices[1] = 1;
	
	        var total = points.length,
	            point,
	            index,
	            amount;
	
	        for (var i = 1; i < total; i++) {
	            point = points[i];
	            index = i * 4;
	            // time to do some smart drawing!
	            amount = i / (total - 1);
	
	            if (i % 2) {
	                uvs[index] = amount;
	                uvs[index + 1] = 0;
	
	                uvs[index + 2] = amount;
	                uvs[index + 3] = 1;
	            } else {
	                uvs[index] = amount;
	                uvs[index + 1] = 0;
	
	                uvs[index + 2] = amount;
	                uvs[index + 3] = 1;
	            }
	
	            index = i * 2;
	            colors[index] = 1;
	            colors[index + 1] = 1;
	
	            index = i * 2;
	            indices[index] = index;
	            indices[index + 1] = index + 1;
	
	            lastPoint = point;
	        }
	    };
	
	    /*
	     * Updates the object transform for rendering
	     *
	     * @method updateTransform
	     * @private
	     */
	    PIXI.Rope.prototype.updateTransform = function () {
	
	        var points = this.points;
	        if (points.length < 1) return;
	
	        var lastPoint = points[0];
	        var nextPoint;
	        var perp = { x: 0, y: 0 };
	
	        this.count -= 0.2;
	
	        var vertices = this.vertices;
	        var total = points.length,
	            point,
	            index,
	            ratio,
	            perpLength,
	            num;
	
	        for (var i = 0; i < total; i++) {
	            point = points[i];
	            index = i * 4;
	
	            if (i < points.length - 1) {
	                nextPoint = points[i + 1];
	            } else {
	                nextPoint = point;
	            }
	
	            perp.y = -(nextPoint.x - lastPoint.x);
	            perp.x = nextPoint.y - lastPoint.y;
	
	            ratio = (1 - i / (total - 1)) * 10;
	
	            if (ratio > 1) ratio = 1;
	
	            perpLength = Math.sqrt(perp.x * perp.x + perp.y * perp.y);
	            num = this.texture.height / 2; //(20 + Math.abs(Math.sin((i + this.count) * 0.3) * 50) )* ratio;
	            perp.x /= perpLength;
	            perp.y /= perpLength;
	
	            perp.x *= num;
	            perp.y *= num;
	
	            vertices[index] = point.x + perp.x;
	            vertices[index + 1] = point.y + perp.y;
	            vertices[index + 2] = point.x - perp.x;
	            vertices[index + 3] = point.y - perp.y;
	
	            lastPoint = point;
	        }
	
	        PIXI.DisplayObjectContainer.prototype.updateTransform.call(this);
	    };
	    /*
	     * Sets the texture that the Rope will use
	     *
	     * @method setTexture
	     * @param texture {Texture} the texture that will be used
	     */
	    PIXI.Rope.prototype.setTexture = function (texture) {
	        // stop current texture
	        this.texture = texture;
	        //this.updateFrame = true;
	    };
	
	    /**
	     * @author Mat Groves http://matgroves.com/
	     */
	
	    /**
	     * A tiling sprite is a fast way of rendering a tiling image
	     *
	     * @class TilingSprite
	     * @extends Sprite
	     * @constructor
	     * @param texture {Texture} the texture of the tiling sprite
	     * @param width {Number}  the width of the tiling sprite
	     * @param height {Number} the height of the tiling sprite
	     */
	    PIXI.TilingSprite = function (texture, width, height) {
	        PIXI.Sprite.call(this, texture);
	
	        /**
	         * The width of the tiling sprite
	         *
	         * @property width
	         * @type Number
	         */
	        this._width = width || 128;
	
	        /**
	         * The height of the tiling sprite
	         *
	         * @property height
	         * @type Number
	         */
	        this._height = height || 128;
	
	        /**
	         * The scaling of the image that is being tiled
	         *
	         * @property tileScale
	         * @type Point
	         */
	        this.tileScale = new PIXI.Point(1, 1);
	
	        /**
	         * A point that represents the scale of the texture object
	         *
	         * @property tileScaleOffset
	         * @type Point
	         */
	        this.tileScaleOffset = new PIXI.Point(1, 1);
	
	        /**
	         * The offset position of the image that is being tiled
	         *
	         * @property tilePosition
	         * @type Point
	         */
	        this.tilePosition = new PIXI.Point();
	
	        /**
	         * Whether this sprite is renderable or not
	         *
	         * @property renderable
	         * @type Boolean
	         * @default true
	         */
	        this.renderable = true;
	
	        /**
	         * The tint applied to the sprite. This is a hex value
	         *
	         * @property tint
	         * @type Number
	         * @default 0xFFFFFF
	         */
	        this.tint = 0xFFFFFF;
	
	        /**
	         * If enabled a green rectangle will be drawn behind the generated tiling texture, allowing you to visually
	         * debug the texture being used.
	         *
	         * @property textureDebug
	         * @type Boolean
	         */
	        this.textureDebug = false;
	
	        /**
	         * The blend mode to be applied to the sprite
	         *
	         * @property blendMode
	         * @type Number
	         * @default PIXI.blendModes.NORMAL;
	         */
	        this.blendMode = PIXI.blendModes.NORMAL;
	
	        /**
	         * The CanvasBuffer object that the tiled texture is drawn to.
	         *
	         * @property canvasBuffer
	         * @type PIXI.CanvasBuffer
	         */
	        this.canvasBuffer = null;
	
	        /**
	         * An internal Texture object that holds the tiling texture that was generated from TilingSprite.texture.
	         *
	         * @property tilingTexture
	         * @type PIXI.Texture
	         */
	        this.tilingTexture = null;
	
	        /**
	         * The Context fill pattern that is used to draw the TilingSprite in Canvas mode only (will be null in WebGL).
	         *
	         * @property tilePattern
	         * @type PIXI.Texture
	         */
	        this.tilePattern = null;
	
	        /**
	         * If true the TilingSprite will run generateTexture on its **next** render pass.
	         * This is set by the likes of Phaser.LoadTexture.setFrame.
	         *
	         * @property refreshTexture
	         * @type Boolean
	         * @default true
	         */
	        this.refreshTexture = true;
	
	        this.frameWidth = 0;
	        this.frameHeight = 0;
	    };
	
	    PIXI.TilingSprite.prototype = Object.create(PIXI.Sprite.prototype);
	    PIXI.TilingSprite.prototype.constructor = PIXI.TilingSprite;
	
	    PIXI.TilingSprite.prototype.setTexture = function (texture) {
	        if (this.texture !== texture) {
	            this.texture = texture;
	            this.refreshTexture = true;
	            this.cachedTint = 0xFFFFFF;
	        }
	    };
	
	    /**
	    * Renders the object using the WebGL renderer
	    *
	    * @method _renderWebGL
	    * @param renderSession {RenderSession} 
	    * @private
	    */
	    PIXI.TilingSprite.prototype._renderWebGL = function (renderSession) {
	        if (!this.visible || !this.renderable || this.alpha === 0) {
	            return;
	        }
	
	        if (this._mask) {
	            renderSession.spriteBatch.stop();
	            renderSession.maskManager.pushMask(this.mask, renderSession);
	            renderSession.spriteBatch.start();
	        }
	
	        if (this._filters) {
	            renderSession.spriteBatch.flush();
	            renderSession.filterManager.pushFilter(this._filterBlock);
	        }
	
	        if (this.refreshTexture) {
	            this.generateTilingTexture(true, renderSession);
	
	            if (this.tilingTexture) {
	                if (this.tilingTexture.needsUpdate) {
	                    renderSession.renderer.updateTexture(this.tilingTexture.baseTexture);
	                    this.tilingTexture.needsUpdate = false;
	                }
	            } else {
	                return;
	            }
	        }
	
	        renderSession.spriteBatch.renderTilingSprite(this);
	
	        for (var i = 0; i < this.children.length; i++) {
	            this.children[i]._renderWebGL(renderSession);
	        }
	
	        renderSession.spriteBatch.stop();
	
	        if (this._filters) {
	            renderSession.filterManager.popFilter();
	        }
	
	        if (this._mask) {
	            renderSession.maskManager.popMask(this._mask, renderSession);
	        }
	
	        renderSession.spriteBatch.start();
	    };
	
	    /**
	    * Renders the object using the Canvas renderer
	    *
	    * @method _renderCanvas
	    * @param renderSession {RenderSession} 
	    * @private
	    */
	    PIXI.TilingSprite.prototype._renderCanvas = function (renderSession) {
	        if (!this.visible || !this.renderable || this.alpha === 0) {
	            return;
	        }
	
	        var context = renderSession.context;
	
	        if (this._mask) {
	            renderSession.maskManager.pushMask(this._mask, renderSession);
	        }
	
	        context.globalAlpha = this.worldAlpha;
	
	        var wt = this.worldTransform;
	        var resolution = renderSession.resolution;
	        var tx = wt.tx * resolution + renderSession.shakeX;
	        var ty = wt.ty * resolution + renderSession.shakeY;
	
	        context.setTransform(wt.a * resolution, wt.b * resolution, wt.c * resolution, wt.d * resolution, tx, ty);
	
	        if (this.refreshTexture) {
	            this.generateTilingTexture(false, renderSession);
	
	            if (this.tilingTexture) {
	                this.tilePattern = context.createPattern(this.tilingTexture.baseTexture.source, 'repeat');
	            } else {
	                return;
	            }
	        }
	
	        var sessionBlendMode = renderSession.currentBlendMode;
	
	        //  Check blend mode
	        if (this.blendMode !== renderSession.currentBlendMode) {
	            renderSession.currentBlendMode = this.blendMode;
	            context.globalCompositeOperation = PIXI.blendModesCanvas[renderSession.currentBlendMode];
	        }
	
	        var tilePosition = this.tilePosition;
	        var tileScale = this.tileScale;
	
	        tilePosition.x %= this.tilingTexture.baseTexture.width;
	        tilePosition.y %= this.tilingTexture.baseTexture.height;
	
	        //  Translate
	        context.scale(tileScale.x, tileScale.y);
	        context.translate(tilePosition.x + this.anchor.x * -this._width, tilePosition.y + this.anchor.y * -this._height);
	
	        context.fillStyle = this.tilePattern;
	
	        var tx = -tilePosition.x;
	        var ty = -tilePosition.y;
	        var tw = this._width / tileScale.x;
	        var th = this._height / tileScale.y;
	
	        //  Allow for pixel rounding
	        if (renderSession.roundPixels) {
	            tx |= 0;
	            ty |= 0;
	            tw |= 0;
	            th |= 0;
	        }
	
	        context.fillRect(tx, ty, tw, th);
	
	        //  Translate back again
	        context.scale(1 / tileScale.x, 1 / tileScale.y);
	        context.translate(-tilePosition.x + this.anchor.x * this._width, -tilePosition.y + this.anchor.y * this._height);
	
	        if (this._mask) {
	            renderSession.maskManager.popMask(renderSession);
	        }
	
	        for (var i = 0; i < this.children.length; i++) {
	            this.children[i]._renderCanvas(renderSession);
	        }
	
	        //  Reset blend mode
	        if (sessionBlendMode !== this.blendMode) {
	            renderSession.currentBlendMode = sessionBlendMode;
	            context.globalCompositeOperation = PIXI.blendModesCanvas[sessionBlendMode];
	        }
	    };
	
	    /**
	     * When the texture is updated, this event will fire to update the scale and frame
	     *
	     * @method onTextureUpdate
	     * @param event
	     * @private
	     */
	    PIXI.TilingSprite.prototype.onTextureUpdate = function () {
	        // overriding the sprite version of this!
	    };
	
	    /**
	    * 
	    * @method generateTilingTexture
	    * 
	    * @param forcePowerOfTwo {Boolean} Whether we want to force the texture to be a power of two
	    * @param renderSession {RenderSession} 
	    */
	    PIXI.TilingSprite.prototype.generateTilingTexture = function (forcePowerOfTwo, renderSession) {
	        if (!this.texture.baseTexture.hasLoaded) {
	            return;
	        }
	
	        var texture = this.texture;
	        var frame = texture.frame;
	
	        var targetWidth = this._frame.sourceSizeW || this._frame.width;
	        var targetHeight = this._frame.sourceSizeH || this._frame.height;
	
	        var dx = 0;
	        var dy = 0;
	
	        if (this._frame.trimmed) {
	            dx = this._frame.spriteSourceSizeX;
	            dy = this._frame.spriteSourceSizeY;
	        }
	
	        if (forcePowerOfTwo) {
	            targetWidth = PIXI.getNextPowerOfTwo(targetWidth);
	            targetHeight = PIXI.getNextPowerOfTwo(targetHeight);
	        }
	
	        if (this.canvasBuffer) {
	            this.canvasBuffer.resize(targetWidth, targetHeight);
	            this.tilingTexture.baseTexture.width = targetWidth;
	            this.tilingTexture.baseTexture.height = targetHeight;
	            this.tilingTexture.needsUpdate = true;
	        } else {
	            this.canvasBuffer = new PIXI.CanvasBuffer(targetWidth, targetHeight);
	            this.tilingTexture = PIXI.Texture.fromCanvas(this.canvasBuffer.canvas);
	            this.tilingTexture.isTiling = true;
	            this.tilingTexture.needsUpdate = true;
	        }
	
	        if (this.textureDebug) {
	            this.canvasBuffer.context.strokeStyle = '#00ff00';
	            this.canvasBuffer.context.strokeRect(0, 0, targetWidth, targetHeight);
	        }
	
	        //  If a sprite sheet we need this:
	        var w = texture.crop.width;
	        var h = texture.crop.height;
	
	        if (w !== targetWidth || h !== targetHeight) {
	            w = targetWidth;
	            h = targetHeight;
	        }
	
	        this.canvasBuffer.context.drawImage(texture.baseTexture.source, texture.crop.x, texture.crop.y, texture.crop.width, texture.crop.height, dx, dy, w, h);
	
	        this.tileScaleOffset.x = frame.width / targetWidth;
	        this.tileScaleOffset.y = frame.height / targetHeight;
	
	        this.refreshTexture = false;
	
	        this.tilingTexture.baseTexture._powerOf2 = true;
	    };
	
	    /**
	    * Returns the framing rectangle of the sprite as a PIXI.Rectangle object
	    *
	    * @method getBounds
	    * @return {Rectangle} the framing rectangle
	    */
	    PIXI.TilingSprite.prototype.getBounds = function () {
	        var width = this._width;
	        var height = this._height;
	
	        var w0 = width * (1 - this.anchor.x);
	        var w1 = width * -this.anchor.x;
	
	        var h0 = height * (1 - this.anchor.y);
	        var h1 = height * -this.anchor.y;
	
	        var worldTransform = this.worldTransform;
	
	        var a = worldTransform.a;
	        var b = worldTransform.b;
	        var c = worldTransform.c;
	        var d = worldTransform.d;
	        var tx = worldTransform.tx;
	        var ty = worldTransform.ty;
	
	        var x1 = a * w1 + c * h1 + tx;
	        var y1 = d * h1 + b * w1 + ty;
	
	        var x2 = a * w0 + c * h1 + tx;
	        var y2 = d * h1 + b * w0 + ty;
	
	        var x3 = a * w0 + c * h0 + tx;
	        var y3 = d * h0 + b * w0 + ty;
	
	        var x4 = a * w1 + c * h0 + tx;
	        var y4 = d * h0 + b * w1 + ty;
	
	        var maxX = -Infinity;
	        var maxY = -Infinity;
	
	        var minX = Infinity;
	        var minY = Infinity;
	
	        minX = x1 < minX ? x1 : minX;
	        minX = x2 < minX ? x2 : minX;
	        minX = x3 < minX ? x3 : minX;
	        minX = x4 < minX ? x4 : minX;
	
	        minY = y1 < minY ? y1 : minY;
	        minY = y2 < minY ? y2 : minY;
	        minY = y3 < minY ? y3 : minY;
	        minY = y4 < minY ? y4 : minY;
	
	        maxX = x1 > maxX ? x1 : maxX;
	        maxX = x2 > maxX ? x2 : maxX;
	        maxX = x3 > maxX ? x3 : maxX;
	        maxX = x4 > maxX ? x4 : maxX;
	
	        maxY = y1 > maxY ? y1 : maxY;
	        maxY = y2 > maxY ? y2 : maxY;
	        maxY = y3 > maxY ? y3 : maxY;
	        maxY = y4 > maxY ? y4 : maxY;
	
	        var bounds = this._bounds;
	
	        bounds.x = minX;
	        bounds.width = maxX - minX;
	
	        bounds.y = minY;
	        bounds.height = maxY - minY;
	
	        // store a reference so that if this function gets called again in the render cycle we do not have to recalculate
	        this._currentBounds = bounds;
	
	        return bounds;
	    };
	
	    PIXI.TilingSprite.prototype.destroy = function () {
	
	        PIXI.Sprite.prototype.destroy.call(this);
	
	        if (this.canvasBuffer) {
	            this.canvasBuffer.destroy();
	            this.canvasBuffer = null;
	        }
	
	        this.tileScale = null;
	        this.tileScaleOffset = null;
	        this.tilePosition = null;
	
	        if (this.tilingTexture) {
	            this.tilingTexture.destroy(true);
	            this.tilingTexture = null;
	        }
	    };
	
	    /**
	     * The width of the sprite, setting this will actually modify the scale to achieve the value set
	     *
	     * @property width
	     * @type Number
	     */
	    Object.defineProperty(PIXI.TilingSprite.prototype, 'width', {
	
	        get: function get() {
	            return this._width;
	        },
	
	        set: function set(value) {
	            this._width = value;
	        }
	
	    });
	
	    /**
	     * The height of the TilingSprite, setting this will actually modify the scale to achieve the value set
	     *
	     * @property height
	     * @type Number
	     */
	    Object.defineProperty(PIXI.TilingSprite.prototype, 'height', {
	
	        get: function get() {
	            return this._height;
	        },
	
	        set: function set(value) {
	            this._height = value;
	        }
	
	    });
	
	    /**
	     * @author Mat Groves http://matgroves.com/ @Doormat23
	     */
	
	    if (true) {
	        if (typeof module !== 'undefined' && module.exports) {
	            exports = module.exports = PIXI;
	        }
	        exports.PIXI = PIXI;
	    } else if (typeof define !== 'undefined' && define.amd) {
	        define('PIXI', function () {
	            return root.PIXI = PIXI;
	        }());
	    } else {
	        root.PIXI = PIXI;
	    }
	
	    return PIXI;
	}).call(undefined);

/***/ }),
/* 358 */
/***/ (function(module, exports) {

	'use strict';
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout() {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	})();
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while (len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) {
	    return [];
	};
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () {
	    return '/';
	};
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function () {
	    return 0;
	};

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!function (global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = ( false ? "undefined" : _typeof(module)) === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function (method) {
	      prototype[method] = function (arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function (genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor ? ctor === GeneratorFunction ||
	    // For the native GeneratorFunction constructor, the best we can
	    // do is to check its .name property.
	    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
	  };
	
	  runtime.mark = function (genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function (arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function (value) {
	            invoke("next", value, resolve, reject);
	          }, function (err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function (unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (_typeof(global.process) === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function (resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	      // If enqueue has been called before, then we want to wait until
	      // all previous Promises have been resolved before calling invoke,
	      // so that results are always delivered in the correct order. If
	      // enqueue has not been called before, then it is important to
	      // call invoke immediately, without waiting on a callback to fire,
	      // so that the async generator function has the opportunity to do
	      // any necessary setup in a predictable way. This predictability
	      // is why the Promise constructor synchronously invokes its
	      // executor callback, and why async functions synchronously
	      // execute code before the first await. Since we implement simple
	      // async functions in terms of async generators, it is especially
	      // important to get this right, even though it requires care.
	      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
	      // Avoid propagating failures to Promises returned by later
	      // invocations of the iterator.
	      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
	
	    return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
	    : iter.next().then(function (result) {
	      return result.done ? result.value : iter.next();
	    });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done ? GenStateCompleted : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError("The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (!info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function () {
	    return this;
	  };
	
	  Gp.toString = function () {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function (object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1,
	            next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function reset(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function stop() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function dispatchException(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function abrupt(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function complete(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" || record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function finish(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function _catch(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	}(
	// Among the various tricks for obtaining a reference to the global
	// object, this seems to be the most reliable technique that does not
	// use indirect eval (which violates Content Security Policy).
	(typeof global === "undefined" ? "undefined" : _typeof(global)) === "object" ? global : (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" ? window : (typeof self === "undefined" ? "undefined" : _typeof(self)) === "object" ? self : undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(99)(module)))

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * Unidragger v2.4.0
	 * Draggable base class
	 * MIT license
	 */
	
	/*jshint browser: true, unused: true, undef: true, strict: true */
	
	(function (window, factory) {
	  // universal module definition
	  /*jshint strict: false */ /*globals define, module, require */
	
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(98)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Unipointer) {
	      return factory(window, Unipointer);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
	    // CommonJS
	    module.exports = factory(window, require('unipointer'));
	  } else {
	    // browser global
	    window.Unidragger = factory(window, window.Unipointer);
	  }
	})(window, function factory(window, Unipointer) {
	
	  'use strict';
	
	  // -------------------------- Unidragger -------------------------- //
	
	  function Unidragger() {}
	
	  // inherit Unipointer & EvEmitter
	  var proto = Unidragger.prototype = Object.create(Unipointer.prototype);
	
	  // ----- bind start ----- //
	
	  proto.bindHandles = function () {
	    this._bindHandles(true);
	  };
	
	  proto.unbindHandles = function () {
	    this._bindHandles(false);
	  };
	
	  /**
	   * Add or remove start event
	   * @param {Boolean} isAdd
	   */
	  proto._bindHandles = function (isAdd) {
	    // munge isAdd, default to true
	    isAdd = isAdd === undefined ? true : isAdd;
	    // bind each handle
	    var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
	    var touchAction = isAdd ? this._touchActionValue : '';
	    for (var i = 0; i < this.handles.length; i++) {
	      var handle = this.handles[i];
	      this._bindStartEvent(handle, isAdd);
	      handle[bindMethod]('click', this);
	      // touch-action: none to override browser touch gestures. metafizzy/flickity#540
	      if (window.PointerEvent) {
	        handle.style.touchAction = touchAction;
	      }
	    }
	  };
	
	  // prototype so it can be overwriteable by Flickity
	  proto._touchActionValue = 'none';
	
	  // ----- start event ----- //
	
	  /**
	   * pointer start
	   * @param {Event} event
	   * @param {Event or Touch} pointer
	   */
	  proto.pointerDown = function (event, pointer) {
	    var isOkay = this.okayPointerDown(event);
	    if (!isOkay) {
	      return;
	    }
	    // track start event position
	    // Safari 9 overrides pageX and pageY. These values needs to be copied. flickity#842
	    this.pointerDownPointer = {
	      pageX: pointer.pageX,
	      pageY: pointer.pageY
	    };
	
	    event.preventDefault();
	    this.pointerDownBlur();
	    // bind move and end events
	    this._bindPostStartEvents(event);
	    this.emitEvent('pointerDown', [event, pointer]);
	  };
	
	  // nodes that have text fields
	  var cursorNodes = {
	    TEXTAREA: true,
	    INPUT: true,
	    SELECT: true,
	    OPTION: true
	  };
	
	  // input types that do not have text fields
	  var clickTypes = {
	    radio: true,
	    checkbox: true,
	    button: true,
	    submit: true,
	    image: true,
	    file: true
	  };
	
	  // dismiss inputs with text fields. flickity#403, flickity#404
	  proto.okayPointerDown = function (event) {
	    var isCursorNode = cursorNodes[event.target.nodeName];
	    var isClickType = clickTypes[event.target.type];
	    var isOkay = !isCursorNode || isClickType;
	    if (!isOkay) {
	      this._pointerReset();
	    }
	    return isOkay;
	  };
	
	  // kludge to blur previously focused input
	  proto.pointerDownBlur = function () {
	    var focused = document.activeElement;
	    // do not blur body for IE10, metafizzy/flickity#117
	    var canBlur = focused && focused.blur && focused != document.body;
	    if (canBlur) {
	      focused.blur();
	    }
	  };
	
	  // ----- move event ----- //
	
	  /**
	   * drag move
	   * @param {Event} event
	   * @param {Event or Touch} pointer
	   */
	  proto.pointerMove = function (event, pointer) {
	    var moveVector = this._dragPointerMove(event, pointer);
	    this.emitEvent('pointerMove', [event, pointer, moveVector]);
	    this._dragMove(event, pointer, moveVector);
	  };
	
	  // base pointer move logic
	  proto._dragPointerMove = function (event, pointer) {
	    var moveVector = {
	      x: pointer.pageX - this.pointerDownPointer.pageX,
	      y: pointer.pageY - this.pointerDownPointer.pageY
	    };
	    // start drag if pointer has moved far enough to start drag
	    if (!this.isDragging && this.hasDragStarted(moveVector)) {
	      this._dragStart(event, pointer);
	    }
	    return moveVector;
	  };
	
	  // condition if pointer has moved far enough to start drag
	  proto.hasDragStarted = function (moveVector) {
	    return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
	  };
	
	  // ----- end event ----- //
	
	  /**
	   * pointer up
	   * @param {Event} event
	   * @param {Event or Touch} pointer
	   */
	  proto.pointerUp = function (event, pointer) {
	    this.emitEvent('pointerUp', [event, pointer]);
	    this._dragPointerUp(event, pointer);
	  };
	
	  proto._dragPointerUp = function (event, pointer) {
	    if (this.isDragging) {
	      this._dragEnd(event, pointer);
	    } else {
	      // pointer didn't move enough for drag to start
	      this._staticClick(event, pointer);
	    }
	  };
	
	  // -------------------------- drag -------------------------- //
	
	  // dragStart
	  proto._dragStart = function (event, pointer) {
	    this.isDragging = true;
	    // prevent clicks
	    this.isPreventingClicks = true;
	    this.dragStart(event, pointer);
	  };
	
	  proto.dragStart = function (event, pointer) {
	    this.emitEvent('dragStart', [event, pointer]);
	  };
	
	  // dragMove
	  proto._dragMove = function (event, pointer, moveVector) {
	    // do not drag if not dragging yet
	    if (!this.isDragging) {
	      return;
	    }
	
	    this.dragMove(event, pointer, moveVector);
	  };
	
	  proto.dragMove = function (event, pointer, moveVector) {
	    event.preventDefault();
	    this.emitEvent('dragMove', [event, pointer, moveVector]);
	  };
	
	  // dragEnd
	  proto._dragEnd = function (event, pointer) {
	    // set flags
	    this.isDragging = false;
	    // re-enable clicking async
	    setTimeout(function () {
	      delete this.isPreventingClicks;
	    }.bind(this));
	
	    this.dragEnd(event, pointer);
	  };
	
	  proto.dragEnd = function (event, pointer) {
	    this.emitEvent('dragEnd', [event, pointer]);
	  };
	
	  // ----- onclick ----- //
	
	  // handle all clicks and prevent clicks when dragging
	  proto.onclick = function (event) {
	    if (this.isPreventingClicks) {
	      event.preventDefault();
	    }
	  };
	
	  // ----- staticClick ----- //
	
	  // triggered after pointer down & up with no/tiny movement
	  proto._staticClick = function (event, pointer) {
	    // ignore emulated mouse up clicks
	    if (this.isIgnoringMouseUp && event.type == 'mouseup') {
	      return;
	    }
	
	    this.staticClick(event, pointer);
	
	    // set flag for emulated clicks 300ms after touchend
	    if (event.type != 'mouseup') {
	      this.isIgnoringMouseUp = true;
	      // reset flag after 300ms
	      setTimeout(function () {
	        delete this.isIgnoringMouseUp;
	      }.bind(this), 400);
	    }
	  };
	
	  proto.staticClick = function (event, pointer) {
	    this.emitEvent('staticClick', [event, pointer]);
	  };
	
	  // ----- utils ----- //
	
	  Unidragger.getPointerPoint = Unipointer.getPointerPoint;
	
	  // -----  ----- //
	
	  return Unidragger;
	});

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * viewport-units-buggyfill v0.6.2
	 * @web: https://github.com/rodneyrehm/viewport-units-buggyfill/
	 * @author: Rodney Rehm - http://rodneyrehm.de/en/
	 */
	
	(function () {
	  (function (root, factory) {
	    'use strict';
	
	    if (true) {
	      // AMD. Register as an anonymous module.
	      !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	      // Node. Does not work with strict CommonJS, but
	      // only CommonJS-like enviroments that support module.exports,
	      // like Node.
	      module.exports = factory();
	    } else {
	      // Browser globals (root is window)
	      root.viewportUnitsBuggyfill = factory();
	    }
	  })(this, function () {
	    'use strict';
	    /* global document, window, navigator, location, XMLHttpRequest, XDomainRequest, CustomEvent */
	
	    var initialized = false;
	    var options;
	    var userAgent = window.navigator.userAgent;
	    var viewportUnitExpression = /([+-]?[0-9.]+)(vh|vw|vmin|vmax)/g;
	    var urlExpression = /(https?:)?\/\//;
	    var forEach = [].forEach;
	    var dimensions;
	    var declarations;
	    var styleNode;
	    var isBuggyIE = /MSIE [0-9]\./i.test(userAgent);
	    var isOldIE = /MSIE [0-8]\./i.test(userAgent);
	    var isOperaMini = userAgent.indexOf('Opera Mini') > -1;
	
	    var isMobileSafari = /(iPhone|iPod|iPad).+AppleWebKit/i.test(userAgent) && function () {
	      // Regexp for iOS-version tested against the following userAgent strings:
	      // Example WebView UserAgents:
	      // * iOS Chrome on iOS8: "Mozilla/5.0 (iPad; CPU OS 8_1 like Mac OS X) AppleWebKit/600.1.4 (KHTML, like Gecko) CriOS/39.0.2171.50 Mobile/12B410 Safari/600.1.4"
	      // * iOS Facebook on iOS7: "Mozilla/5.0 (iPhone; CPU iPhone OS 7_1_1 like Mac OS X) AppleWebKit/537.51.2 (KHTML, like Gecko) Mobile/11D201 [FBAN/FBIOS;FBAV/12.1.0.24.20; FBBV/3214247; FBDV/iPhone6,1;FBMD/iPhone; FBSN/iPhone OS;FBSV/7.1.1; FBSS/2; FBCR/AT&T;FBID/phone;FBLC/en_US;FBOP/5]"
	      // Example Safari UserAgents:
	      // * Safari iOS8: "Mozilla/5.0 (iPhone; CPU iPhone OS 8_0 like Mac OS X) AppleWebKit/600.1.3 (KHTML, like Gecko) Version/8.0 Mobile/12A4345d Safari/600.1.4"
	      // * Safari iOS7: "Mozilla/5.0 (iPhone; CPU iPhone OS 7_0 like Mac OS X) AppleWebKit/537.51.1 (KHTML, like Gecko) Version/7.0 Mobile/11A4449d Safari/9537.53"
	      var iOSversion = userAgent.match(/OS (\d)/);
	      // viewport units work fine in mobile Safari and webView on iOS 8+
	      return iOSversion && iOSversion.length > 1 && parseInt(iOSversion[1]) < 10;
	    }();
	
	    var isBadStockAndroid = function () {
	      // Android stock browser test derived from
	      // http://stackoverflow.com/questions/24926221/distinguish-android-chrome-from-stock-browser-stock-browsers-user-agent-contai
	      var isAndroid = userAgent.indexOf(' Android ') > -1;
	      if (!isAndroid) {
	        return false;
	      }
	
	      var isStockAndroid = userAgent.indexOf('Version/') > -1;
	      if (!isStockAndroid) {
	        return false;
	      }
	
	      var versionNumber = parseFloat((userAgent.match('Android ([0-9.]+)') || [])[1]);
	      // anything below 4.4 uses WebKit without *any* viewport support,
	      // 4.4 has issues with viewport units within calc()
	      return versionNumber <= 4.4;
	    }();
	
	    // added check for IE10, IE11 and Edge < 20, since it *still* doesn't understand vmax
	    // http://caniuse.com/#feat=viewport-units
	    if (!isBuggyIE) {
	      isBuggyIE = !!navigator.userAgent.match(/MSIE 10\.|Trident.*rv[ :]*1[01]\.| Edge\/1\d\./);
	    }
	
	    // Polyfill for creating CustomEvents on IE9/10/11
	    // from https://github.com/krambuhl/custom-event-polyfill
	    try {
	      // eslint-disable-next-line no-new, no-use-before-define
	      new CustomEvent('test');
	    } catch (e) {
	      var CustomEvent = function CustomEvent(event, params) {
	        var evt;
	        params = params || {
	          bubbles: false,
	          cancelable: false,
	          detail: undefined
	        };
	
	        evt = document.createEvent('CustomEvent');
	        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	        return evt;
	      };
	      CustomEvent.prototype = window.Event.prototype;
	      window.CustomEvent = CustomEvent; // expose definition to window
	    }
	
	    function debounce(func, wait) {
	      var timeout;
	      return function () {
	        var context = this;
	        var args = arguments;
	        var callback = function callback() {
	          func.apply(context, args);
	        };
	
	        clearTimeout(timeout);
	        timeout = setTimeout(callback, wait);
	      };
	    }
	
	    // from http://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t
	    function inIframe() {
	      try {
	        return window.self !== window.top;
	      } catch (e) {
	        return true;
	      }
	    }
	
	    function initialize(initOptions) {
	      if (initialized) {
	        return;
	      }
	
	      if (initOptions === true) {
	        initOptions = {
	          force: true
	        };
	      }
	
	      options = initOptions || {};
	      options.isMobileSafari = isMobileSafari;
	      options.isBadStockAndroid = isBadStockAndroid;
	
	      if (options.ignoreVmax && !options.force && !isOldIE) {
	        // modern IE (10 and up) do not support vmin/vmax,
	        // but chances are this unit is not even used, so
	        // allow overwriting the "hacktivation"
	        // https://github.com/rodneyrehm/viewport-units-buggyfill/issues/56
	        isBuggyIE = false;
	      }
	
	      if (isOldIE || !options.force && !isMobileSafari && !isBuggyIE && !isBadStockAndroid && !isOperaMini && (!options.hacks || !options.hacks.required(options))) {
	        // this buggyfill only applies to mobile safari, IE9-10 and the Stock Android Browser.
	        if (window.console && isOldIE) {
	          console.info('viewport-units-buggyfill requires a proper CSSOM and basic viewport unit support, which are not available in IE8 and below');
	        }
	
	        return {
	          init: function init() {}
	        };
	      }
	
	      // fire a custom event that buggyfill was initialize
	      window.dispatchEvent(new CustomEvent('viewport-units-buggyfill-init'));
	
	      options.hacks && options.hacks.initialize(options);
	
	      initialized = true;
	      styleNode = document.createElement('style');
	      styleNode.id = 'patched-viewport';
	      document[options.appendToBody ? 'body' : 'head'].appendChild(styleNode);
	
	      // Issue #6: Cross Origin Stylesheets are not accessible through CSSOM,
	      // therefore download and inject them as <style> to circumvent SOP.
	      importCrossOriginLinks(function () {
	        var _refresh = debounce(refresh, options.refreshDebounceWait || 100);
	        // doing a full refresh rather than updateStyles because an orientationchange
	        // could activate different stylesheets
	        window.addEventListener('orientationchange', _refresh, true);
	        // orientationchange might have happened while in a different window
	        window.addEventListener('pageshow', _refresh, true);
	
	        if (options.force || isBuggyIE || inIframe()) {
	          window.addEventListener('resize', _refresh, true);
	          options._listeningToResize = true;
	        }
	
	        options.hacks && options.hacks.initializeEvents(options, refresh, _refresh);
	
	        refresh();
	      });
	    }
	
	    function updateStyles() {
	      styleNode.textContent = getReplacedViewportUnits();
	      // move to the end in case inline <style>s were added dynamically
	      styleNode.parentNode.appendChild(styleNode);
	      // fire a custom event that styles were updated
	      window.dispatchEvent(new CustomEvent('viewport-units-buggyfill-style'));
	    }
	
	    function refresh() {
	      if (!initialized) {
	        return;
	      }
	
	      findProperties();
	
	      // iOS Safari will report window.innerWidth and .innerHeight as 0 unless a timeout is used here.
	      // TODO: figure out WHY innerWidth === 0
	      setTimeout(function () {
	        updateStyles();
	      }, 1);
	    }
	
	    // http://stackoverflow.com/a/23613052
	    function processStylesheet(ss) {
	      // cssRules respects same-origin policy, as per
	      // https://code.google.com/p/chromium/issues/detail?id=49001#c10.
	      try {
	        if (!ss.cssRules) {
	          return;
	        }
	      } catch (e) {
	        if (e.name !== 'SecurityError') {
	          throw e;
	        }
	        return;
	      }
	      // ss.cssRules is available, so proceed with desired operations.
	      var rules = [];
	      for (var i = 0; i < ss.cssRules.length; i++) {
	        var rule = ss.cssRules[i];
	        rules.push(rule);
	      }
	      return rules;
	    }
	
	    function findProperties() {
	      declarations = [];
	      forEach.call(document.styleSheets, function (sheet) {
	        var cssRules = processStylesheet(sheet);
	
	        if (!cssRules || sheet.ownerNode.id === 'patched-viewport' || sheet.ownerNode.getAttribute('data-viewport-units-buggyfill') === 'ignore') {
	          // skip entire sheet because no rules are present, it's supposed to be ignored or it's the target-element of the buggyfill
	          return;
	        }
	
	        if (sheet.media && sheet.media.mediaText && window.matchMedia && !window.matchMedia(sheet.media.mediaText).matches) {
	          // skip entire sheet because media attribute doesn't match
	          return;
	        }
	
	        forEach.call(cssRules, findDeclarations);
	      });
	
	      return declarations;
	    }
	
	    function findDeclarations(rule) {
	      if (rule.type === 7) {
	        var value;
	
	        // there may be a case where accessing cssText throws an error.
	        // I could not reproduce this issue, but the worst that can happen
	        // this way is an animation not running properly.
	        // not awesome, but probably better than a script error
	        // see https://github.com/rodneyrehm/viewport-units-buggyfill/issues/21
	        try {
	          value = rule.cssText;
	        } catch (e) {
	          return;
	        }
	
	        viewportUnitExpression.lastIndex = 0;
	        if (viewportUnitExpression.test(value) && !urlExpression.test(value)) {
	          // KeyframesRule does not have a CSS-PropertyName
	          declarations.push([rule, null, value]);
	          options.hacks && options.hacks.findDeclarations(declarations, rule, null, value);
	        }
	
	        return;
	      }
	
	      if (!rule.style) {
	        if (!rule.cssRules) {
	          return;
	        }
	
	        forEach.call(rule.cssRules, function (_rule) {
	          findDeclarations(_rule);
	        });
	
	        return;
	      }
	
	      forEach.call(rule.style, function (name) {
	        var value = rule.style.getPropertyValue(name);
	        // preserve those !important rules
	        if (rule.style.getPropertyPriority(name)) {
	          value += ' !important';
	        }
	
	        viewportUnitExpression.lastIndex = 0;
	        if (viewportUnitExpression.test(value)) {
	          declarations.push([rule, name, value]);
	          options.hacks && options.hacks.findDeclarations(declarations, rule, name, value);
	        }
	      });
	    }
	
	    function getReplacedViewportUnits() {
	      dimensions = getViewport();
	
	      var css = [];
	      var buffer = [];
	      var open;
	      var close;
	
	      declarations.forEach(function (item) {
	        var _item = overwriteDeclaration.apply(null, item);
	        var _open = _item.selector.length ? _item.selector.join(' {\n') + ' {\n' : '';
	        var _close = new Array(_item.selector.length + 1).join('\n}');
	
	        if (!_open || _open !== open) {
	          if (buffer.length) {
	            css.push(open + buffer.join('\n') + close);
	            buffer.length = 0;
	          }
	
	          if (_open) {
	            open = _open;
	            close = _close;
	            buffer.push(_item.content);
	          } else {
	            css.push(_item.content);
	            open = null;
	            close = null;
	          }
	
	          return;
	        }
	
	        if (_open && !open) {
	          open = _open;
	          close = _close;
	        }
	
	        buffer.push(_item.content);
	      });
	
	      if (buffer.length) {
	        css.push(open + buffer.join('\n') + close);
	      }
	
	      // Opera Mini messes up on the content hack (it replaces the DOM node's innerHTML with the value).
	      // This fixes it. We test for Opera Mini only since it is the most expensive CSS selector
	      // see https://developer.mozilla.org/en-US/docs/Web/CSS/Universal_selectors
	      if (isOperaMini) {
	        css.push('* { content: normal !important; }');
	      }
	
	      return css.join('\n\n');
	    }
	
	    function overwriteDeclaration(rule, name, value) {
	      var _value;
	      var _selectors = [];
	
	      _value = value.replace(viewportUnitExpression, replaceValues);
	
	      if (options.hacks) {
	        _value = options.hacks.overwriteDeclaration(rule, name, _value);
	      }
	
	      if (name) {
	        // skipping KeyframesRule
	        _selectors.push(rule.selectorText);
	        _value = name + ': ' + _value + ';';
	      }
	
	      var _rule = rule.parentRule;
	      while (_rule) {
	        if (_rule.media) {
	          _selectors.unshift('@media ' + _rule.media.mediaText);
	        } else if (_rule.conditionText) {
	          _selectors.unshift('@supports ' + _rule.conditionText);
	        }
	
	        _rule = _rule.parentRule;
	      }
	
	      return {
	        selector: _selectors,
	        content: _value
	      };
	    }
	
	    function replaceValues(match, number, unit) {
	      var _base = dimensions[unit];
	      var _number = parseFloat(number) / 100;
	      return _number * _base + 'px';
	    }
	
	    function getViewport() {
	      var vh = window.innerHeight;
	      var vw = window.innerWidth;
	
	      return {
	        vh: vh,
	        vw: vw,
	        vmax: Math.max(vw, vh),
	        vmin: Math.min(vw, vh)
	      };
	    }
	
	    function importCrossOriginLinks(next) {
	      var _waiting = 0;
	      var decrease = function decrease() {
	        _waiting--;
	        if (!_waiting) {
	          next();
	        }
	      };
	
	      forEach.call(document.styleSheets, function (sheet) {
	        if (!sheet.href || origin(sheet.href) === origin(location.href) || sheet.ownerNode.getAttribute('data-viewport-units-buggyfill') === 'ignore') {
	          // skip <style> and <link> from same origin or explicitly declared to ignore
	          return;
	        }
	
	        _waiting++;
	        convertLinkToStyle(sheet.ownerNode, decrease);
	      });
	
	      if (!_waiting) {
	        next();
	      }
	    }
	
	    function origin(url) {
	      return url.slice(0, url.indexOf('/', url.indexOf('://') + 3));
	    }
	
	    function convertLinkToStyle(link, next) {
	      getCors(link.href, function () {
	        var style = document.createElement('style');
	        style.media = link.media;
	        style.setAttribute('data-href', link.href);
	        style.textContent = this.responseText;
	        link.parentNode.replaceChild(style, link);
	        next();
	      }, next);
	    }
	
	    function getCors(url, success, error) {
	      var xhr = new XMLHttpRequest();
	      if ('withCredentials' in xhr) {
	        // XHR for Chrome/Firefox/Opera/Safari.
	        xhr.open('GET', url, true);
	      } else if (typeof XDomainRequest !== 'undefined') {
	        // XDomainRequest for IE.
	        xhr = new XDomainRequest();
	        xhr.open('GET', url);
	      } else {
	        throw new Error('cross-domain XHR not supported');
	      }
	
	      xhr.onload = success;
	      xhr.onerror = error;
	      xhr.send();
	      return xhr;
	    }
	
	    return {
	      version: '0.6.1',
	      findProperties: findProperties,
	      getCss: getReplacedViewportUnits,
	      init: initialize,
	      refresh: refresh
	    };
	  });
	})();

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(11);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _hasClass = __webpack_require__(371);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	var _homepage = __webpack_require__(379);
	
	var _homepage2 = _interopRequireDefault(_homepage);
	
	var _navigation = __webpack_require__(376);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _slider = __webpack_require__(138);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _drag = __webpack_require__(365);
	
	var _drag2 = _interopRequireDefault(_drag);
	
	var _faq = __webpack_require__(368);
	
	var _faq2 = _interopRequireDefault(_faq);
	
	var _hover = __webpack_require__(373);
	
	var _hover2 = _interopRequireDefault(_hover);
	
	var _search = __webpack_require__(377);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _filter = __webpack_require__(370);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _hash = __webpack_require__(372);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _contact = __webpack_require__(364);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _marquee = __webpack_require__(375);
	
	var _marquee2 = _interopRequireDefault(_marquee);
	
	var _draw = __webpack_require__(367);
	
	var _draw2 = _interopRequireDefault(_draw);
	
	var _map = __webpack_require__(374);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _dragTitle = __webpack_require__(366);
	
	var _dragTitle2 = _interopRequireDefault(_dragTitle);
	
	var _filterEvents = __webpack_require__(369);
	
	var _filterEvents2 = _interopRequireDefault(_filterEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var body = new _hasClass2.default("body");
	
	var App = function () {
	  function App() {
	    _classCallCheck(this, App);
	
	    this.injector = { app: this };
	
	    this.navigation = new _navigation2.default();
	    this.search = new _search2.default();
	    this.contact = new _contact2.default();
	    this.hash = new _hash2.default();
	  }
	
	  _createClass(App, [{
	    key: "start",
	    value: function start() {
	      var _this = this;
	
	      (0, _jquery2.default)(document).mousemove(function (e) {
	        (0, _jquery2.default)(".js-hover-image").css({ left: e.pageX + 20, top: e.pageY + 20 });
	        (0, _jquery2.default)(".js-hover-image").find(".js-bg-image").css({ backgroundPositionX: -1 * e.pageX + 20 });
	      });
	
	      body.has("page-home", function () {
	        _this.home = new _homepage2.default(_this.injector);
	      });
	
	      body.has("page-events", function () {
	        new _filter2.default(_this.injector);
	      });
	
	      body.has("page-praktisch", function () {
	        new _map2.default("#map");
	      });
	
	      body.has("page-workshops", function () {
	        new _filterEvents2.default();
	      });
	
	      body.has("page-faq", function () {
	        new _faq2.default();
	      });
	
	      (0, _jquery2.default)(".js-draw").each(function () {
	        new _draw2.default(this);
	      });
	
	      (0, _jquery2.default)(".js-contact-open").each(function (i, e) {
	        _this.contact.addButton(e);
	      });
	
	      (0, _jquery2.default)(".js-foto-shuffle").each(function (i, e) {
	        if (!_this.isMobileDevice()) {
	          new _drag2.default(e);
	        }
	      });
	
	      (0, _jquery2.default)(".marquee").each(function () {
	        new _marquee2.default(this);
	      });
	
	      (0, _jquery2.default)(".js-title-slider").each(function () {
	        new _dragTitle2.default(this);
	      });
	
	      (0, _jquery2.default)(".js-image-hover").each(function () {
	        new _hover2.default(this);
	      });
	
	      (0, _jquery2.default)(".js-video-banner").each(function (e) {
	        var _this2 = this;
	
	        (0, _jquery2.default)(this).on("click", function (e) {
	          e.preventDefault();
	          var $iframe = (0, _jquery2.default)(_this2).find("iframe");
	
	          (0, _jquery2.default)(_this2).addClass("playing");
	
	          $iframe.one("load");
	          $iframe.attr("src", $iframe.data("src"));
	        });
	      });
	
	      (0, _jquery2.default)(".js-toggle-newsletter").each(function () {
	        (0, _jquery2.default)(this).on("click", function (e) {
	          e.preventDefault();
	          (0, _jquery2.default)(".js-newsletter").toggleClass("active");
	        });
	      });
	
	      (0, _jquery2.default)(".js-locatie-slider").each(function () {
	        var locatieSlider = new _slider2.default(this, {
	          prevNextButtons: false,
	          wrapAround: false,
	          touchVerticalScroll: false,
	          adaptiveHeight: true,
	          draggable: false
	        });
	
	        (0, _jquery2.default)(".js-change-nav").on("click", function (e) {
	          var index = (0, _jquery2.default)(e.currentTarget).index();
	          (0, _jquery2.default)(".js-change-nav").removeClass("is-selected");
	          (0, _jquery2.default)(e.currentTarget).addClass("is-selected");
	          locatieSlider.goTo(index);
	        });
	      });
	
	      (0, _jquery2.default)(".js-fotos-slider").each(function () {
	        var _this3 = this;
	
	        new _slider2.default(this, {
	          prevNextButtons: true,
	          pageDots: false,
	          imagesLoaded: true,
	          wrapAround: true,
	          touchVerticalScroll: false,
	          adaptiveHeight: false,
	          autoPlay: 5000,
	          pauseAutoPlayOnHover: false,
	          on: {
	            ready: function ready() {
	              (0, _jquery2.default)(_this3).addClass("show");
	            }
	          }
	        });
	      });
	    }
	  }, {
	    key: "isMobileDevice",
	    value: function isMobileDevice() {
	      return typeof window.orientation !== "undefined" || navigator.userAgent.indexOf("IEMobile") !== -1;
	    }
	  }]);
	
	  return App;
	}();
	
	module.exports = new App();

/***/ }),
/* 363 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Use this class to ensure Google Maps API javascript is loaded before running any google map specific code.
	 */
	var GoogleMapsApi = exports.GoogleMapsApi = function () {
	    /**
	     * Constructor set up config.
	     */
	    function GoogleMapsApi() {
	        _classCallCheck(this, GoogleMapsApi);
	
	        // api key for google maps
	        this.apiKey = 'AIzaSyCtkgvEBsIQ98uWSpY7RwFO1z3cstJbUtA';
	
	        // set a globally scoped callback if it doesn't already exist
	        if (!window._GoogleMapsApi) {
	            this.callbackName = '_GoogleMapsApi.mapLoaded';
	            window._GoogleMapsApi = this;
	            window._GoogleMapsApi.mapLoaded = this.mapLoaded.bind(this);
	        }
	    }
	
	    /**
	     * Load the Google Maps API javascript
	     */
	
	
	    _createClass(GoogleMapsApi, [{
	        key: 'load',
	        value: function load() {
	            var _this = this;
	
	            if (!this.promise) {
	                this.promise = new Promise(function (resolve) {
	                    _this.resolve = resolve;
	                    if (typeof window.google === 'undefined') {
	                        var script = document.createElement('script');
	                        script.src = '//maps.googleapis.com/maps/api/js?key=' + _this.apiKey + '&callback=' + _this.callbackName;
	                        script.async = true;
	                        document.body.append(script);
	                    } else {
	                        _this.resolve();
	                    }
	                });
	            }
	
	            return this.promise;
	        }
	
	        /**
	         * Globally scoped callback for the map loaded
	         */
	
	    }, {
	        key: 'mapLoaded',
	        value: function mapLoaded() {
	            if (this.resolve) {
	                this.resolve();
	            }
	        }
	    }]);

	    return GoogleMapsApi;
	}();

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Contact = function () {
	    function Contact() {
	        var _this = this;
	
	        _classCallCheck(this, Contact);
	
	        this.$form = $('.js-contact-form');
	        this.$contactText = $('.js-contact-text');
	        this.$contactTitle = $('.js-contact-title');
	
	        $('.js-contact-close').on('click', function (e) {
	            _this.$form.removeClass('open');
	        });
	    }
	
	    _createClass(Contact, [{
	        key: 'addButton',
	        value: function addButton(selector) {
	            var _this2 = this;
	
	            $(selector).on('click', function (e) {
	                e.preventDefault();
	
	                _this2.$form.removeClass('open');
	
	                _this2.setTitle(e);
	                _this2.setEmail(e);
	                _this2.setText(e);
	                _this2.setUpload(e);
	                _this2.setSelect(e);
	
	                var input = document.querySelector('select');
	
	                input.addEventListener('input', function () {
	                    if (TOCONTACT[input.value]) {
	                        setEmail(TOCONTACT[input.value]);
	                    } else {
	                        setEmail("info@kavka.be");
	                    }
	                });
	
	                _this2.$form.addClass('open');
	            });
	        }
	    }, {
	        key: 'setText',
	        value: function setText(e) {
	            if ($(e.currentTarget).data("text")) {
	                this.$contactText.html($(e.currentTarget).data("text"));
	            } else {
	                this.$contactText.html("Heb je een vraag? Laat hier een bericht achter of bel ons op 03 290 88 17.");
	            }
	        }
	    }, {
	        key: 'setSelect',
	        value: function setSelect(e) {
	            this.$contactSelect = $('.js-select_to_contact');
	
	            if ($(e.currentTarget).data("select") || $(e.currentTarget).hasClass('js-add-select')) {
	                this.$contactSelect.show();
	            } else {
	                this.$contactSelect.hide();
	            }
	        }
	    }, {
	        key: 'setUpload',
	        value: function setUpload(e) {
	            this.$contactUpload = $('.js-file-upload');
	
	            if ($(e.currentTarget).data("upload")) {
	                this.$contactUpload.show();
	            } else {
	                this.$contactUpload.hide();
	            }
	        }
	    }, {
	        key: 'setTitle',
	        value: function setTitle(e) {
	            if ($(e.currentTarget).data("title")) {
	                this.$contactTitle.html($(e.currentTarget).data("title"));
	                setTopic($(e.currentTarget).data("title"));
	            } else {
	                this.$contactTitle.html("Contacteer ons");
	                setTopic("Contacteer ons");
	            }
	        }
	    }, {
	        key: 'setEmail',
	        value: function (_setEmail) {
	            function setEmail(_x) {
	                return _setEmail.apply(this, arguments);
	            }
	
	            setEmail.toString = function () {
	                return _setEmail.toString();
	            };
	
	            return setEmail;
	        }(function (e) {
	            if ($(e.currentTarget).data("email")) {
	                console.log($(e.currentTarget).data("email"));
	                setEmail($(e.currentTarget).data("email"));
	            } else if ($(e.currentTarget).data("team")) {
	                setEmail($(e.currentTarget).data("team"));
	            } else {
	                setEmail("info@kavka.be");
	            }
	        })
	    }]);
	
	    return Contact;
	}();
	
	module.exports = Contact;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(11);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	window.PIXI = __webpack_require__(357);
	window.p2 = __webpack_require__(355);
	window.Phaser = __webpack_require__(356);
	
	var Main = function () {
	    function Main(el) {
	        var _this = this;
	
	        _classCallCheck(this, Main);
	
	        var $el = (0, _jquery2.default)(el);
	        var images = [];
	
	        $el.find('li').each(function (i, e) {
	            images.push((0, _jquery2.default)(e).html());
	        });
	
	        this.sizes = this.setSize($el);
	        var config = {
	            width: this.sizes[0],
	            height: this.sizes[1],
	            renderer: Phaser.AUTO,
	            parent: el,
	            state: {
	                preload: preload,
	                create: create,
	                update: update
	            },
	            transparent: true
	        };
	
	        this.game = new Phaser.Game(config);
	
	        window.addEventListener('resize', function () {
	            var sizes = _this.setSize($el);
	            _this.game.scale.setGameSize(sizes[0], sizes[1]);
	            _this.game.scale.refresh();
	        });
	
	        function preload() {
	            for (var i = 0; i < images.length; i++) {
	                this.game.load.image('image' + i, images[i]);
	            }
	        }
	
	        function create() {
	            var game = this.game;
	
	            this.sprites = [];
	            this.groups = [];
	
	            //	Enable p2 physics
	            this.game.physics.startSystem(Phaser.Physics.P2JS);
	            this.game.physics.p2.gravity.y = 0;
	
	            //  Make things a bit more bouncey
	            this.game.physics.p2.defaultRestitution = 0.8;
	
	            for (var i = 0; i < images.length; i++) {
	                this.groups[i] = this.add.group();
	                this.sprites[i] = this.game.add.sprite(random(0, game.world.width), random(0, game.world.height), 'image' + i);
	                this.groups[i].add(this.sprites[i]);
	
	                if (game.world.width <= 500) {
	                    this.sprites[i].scale.setTo(.5, .5);
	                }
	            }
	            this.game.physics.p2.enable(this.sprites, false);
	            this.game.physics.p2.updateBoundsCollisionGroup();
	
	            for (var _i = 0; _i < images.length; _i++) {
	                this.sprites[_i].body.setZeroDamping();
	                this.sprites[_i].body.fixedRotation = true;
	                this.sprites[_i].body.collides([]);
	            }
	
	            this.mouseBody = new p2.Body();
	            this.game.physics.p2.world.addBody(this.mouseBody);
	
	            this.bodiesItems = [];
	
	            for (var _i2 = 0; _i2 < images.length; _i2++) {
	                this.bodiesItems.push(this.sprites[_i2]);
	            }
	
	            this.game.input.onDown.add(click, this);
	            this.game.input.onUp.add(release, this);
	            this.game.input.addMoveCallback(move, this);
	        }
	
	        function click(pointer) {
	            var bodies = this.game.physics.p2.hitTest(pointer.position, this.bodiesItems);
	
	            // p2 uses different coordinate system, so convert the pointer position to p2's coordinate system
	            var physicsPos = [this.game.physics.p2.pxmi(pointer.position.x), this.game.physics.p2.pxmi(pointer.position.y)];
	
	            if (bodies.length) {
	                var clickedBody = bodies[0];
	                this.game.world.bringToTop(clickedBody.parent.sprite.parent);
	
	                var localPointInBody = [0, 0];
	                // this function takes physicsPos and coverts it to the body's local coordinate system
	                clickedBody.toLocalFrame(localPointInBody, physicsPos);
	                // use a revoluteContraint to attach mouseBody to the clicked body
	                this.mouseConstraint = this.game.physics.p2.createRevoluteConstraint(this.mouseBody, [0, 0], clickedBody, [this.game.physics.p2.mpxi(localPointInBody[0]), this.game.physics.p2.mpxi(localPointInBody[1])]);
	            }
	        }
	
	        function release() {
	            this.game.physics.p2.removeConstraint(this.mouseConstraint);
	        }
	
	        function move(pointer) {
	            this.mouseBody.position[0] = this.game.physics.p2.pxmi(pointer.position.x);
	            this.mouseBody.position[1] = this.game.physics.p2.pxmi(pointer.position.y);
	
	            var bodies = this.game.physics.p2.hitTest(pointer.position, this.bodiesItems);
	
	            if (bodies.length) {
	                this.game.canvas.style.cursor = "move";
	            } else {
	                this.game.canvas.style.cursor = "default";
	            }
	        }
	
	        function update() {}
	
	        function random(min, max) {
	            return Math.floor(Math.random() * (max - min + 1) + min);
	        }
	    }
	
	    _createClass(Main, [{
	        key: 'setSize',
	        value: function setSize($el) {
	            var $canvas = $el.find('canvas');
	            $canvas.hide();
	
	            var height = $el.height();
	
	            if ($el.width() === window.innerWidth) {
	                if ($el.width() < 500) {
	                    height = $el.width();
	                } else {
	                    height = 400;
	                }
	            }
	
	            if (height === 0) {
	                height = 400;
	            }
	
	            setTimeout(function () {
	                $canvas.show();
	            }, 0);
	
	            return [$el.width(), height];
	        }
	    }]);
	
	    return Main;
	}();
	
	exports.default = Main;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _slider = __webpack_require__(138);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DragTitle = function () {
	    function DragTitle(el) {
	        _classCallCheck(this, DragTitle);
	
	        this.el = el;
	        this.$scrollTitle = $(el);
	
	        this.init();
	    }
	
	    _createClass(DragTitle, [{
	        key: "init",
	        value: function init() {
	            var title = this.$scrollTitle.html();
	            // append it two more times so we have the title 3 times to get a
	            // smooth infinite carousel going without compromising SEO with more than 1 h1 element
	            this.$scrollTitle.append(title);
	            this.$scrollTitle.append(title);
	
	            new _slider2.default(this.el, {
	                prevNextButtons: false,
	                pageDots: false,
	                accessibility: false,
	                wrapAround: true,
	                freeScroll: true,
	                cellAlign: 'left'
	            });
	        }
	    }]);
	
	    return DragTitle;
	}();
	
	exports.default = DragTitle;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(11);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(137);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Draw = function Draw(selector) {
	    _classCallCheck(this, Draw);
	
	    var $el = (0, _jquery2.default)(selector);
	    var $canvas = $el.find('canvas');
	
	    var canvas = $canvas[0];
	    var context = canvas.getContext('2d');
	
	    canvas.width = $el.width();
	    canvas.height = $el.height();
	
	    var lastX = 0;
	    var lastY = 0;
	    var isDrawing = false;
	
	    (0, _jquery2.default)(window).resize(_lodash2.default.debounce(function () {
	        canvas.width = $el.width();
	        canvas.height = $el.height();
	        lastX = 0;
	        lastY = 0;
	        isDrawing = false;
	    }, 100));
	
	    canvas.ontouchstart = function (e) {
	        var rect = e.target.getBoundingClientRect();
	        var mouseX = e.targetTouches[0].pageX - rect.left;
	        var mouseY = e.targetTouches[0].pageY - rect.top;
	        lastX = mouseX;
	        lastY = mouseY;
	        isDrawing = true;
	    };
	
	    canvas.onmousedown = function (e) {
	        var mouseX = e.offsetX;
	        var mouseY = e.offsetY;
	        lastX = mouseX;
	        lastY = mouseY;
	        isDrawing = true;
	    };
	
	    canvas.onmousemove = function (e) {
	        if (!e) {
	            e = event;
	        }
	
	        if (!isDrawing) {
	            return;
	        }
	
	        var mouseX = e.offsetX;
	        var mouseY = e.offsetY;
	        context.moveTo(lastX, lastY);
	        context.lineTo(mouseX, mouseY);
	        context.strokeStyle = "#0000000";
	        context.closePath();
	        context.stroke();
	
	        lastX = mouseX;
	        lastY = mouseY;
	    };
	
	    canvas.ontouchmove = function (e) {
	        if (!isDrawing) {
	            return;
	        }
	
	        if (!e) {
	            e = event;
	        }
	
	        var rect = e.target.getBoundingClientRect();
	        var mouseX = e.targetTouches[0].pageX - rect.left;
	        var mouseY = e.targetTouches[0].pageY - rect.top;
	
	        context.moveTo(lastX, lastY);
	        context.lineTo(mouseX, mouseY);
	        context.strokeStyle = "#0000000";
	
	        context.closePath();
	        context.stroke();
	
	        lastX = mouseX;
	        lastY = mouseY;
	
	        e.preventDefault();
	    };
	
	    document.onmouseup = function (e) {
	        isDrawing = false;
	    };
	
	    document.ontouchend = function (e) {
	        isDrawing = false;
	    };
	};
	
	module.exports = Draw;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Faq = function () {
	    function Faq() {
	        _classCallCheck(this, Faq);
	
	        this.$faqs = $('.js-faq');
	
	        this.init();
	    }
	
	    _createClass(Faq, [{
	        key: 'init',
	        value: function init() {
	            this.$faqs.on('click', function (e) {
	                $(e.currentTarget).toggleClass('open');
	            });
	        }
	    }]);
	
	    return Faq;
	}();
	
	exports.default = Faq;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(11);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FilterEvents = function () {
	    function FilterEvents() {
	        _classCallCheck(this, FilterEvents);
	
	        this.filters = '';
	        this.init();
	    }
	
	    _createClass(FilterEvents, [{
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            (0, _jquery2.default)('.js-filters .js-filter-button').on('click', function (e) {
	                _this.filters = (0, _jquery2.default)(e.currentTarget).data('filter');
	                _this.filter();
	                e.stopPropagation();
	            });
	        }
	    }, {
	        key: 'filter',
	        value: function filter() {
	            var $toFilter = (0, _jquery2.default)('.js-to-filter');
	            $toFilter.removeClass('hide');
	
	            if (this.filters !== "*") {
	                $toFilter.addClass('hide');
	                (0, _jquery2.default)('.js-to-filter.js-filter-tag-' + this.filters).removeClass('hide');
	            }
	
	            var count = $toFilter.length - (0, _jquery2.default)('.js-to-filter.hide').length;
	            var $noResults = (0, _jquery2.default)('.js-no-results');
	
	            if (count === 0) {
	                $noResults.removeClass('hide');
	            } else {
	                $noResults.addClass('hide');
	            }
	        }
	    }]);
	
	    return FilterEvents;
	}();
	
	exports.default = FilterEvents;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(11);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Filter = function () {
	    function Filter(injector) {
	        _classCallCheck(this, Filter);
	
	        this.injector = injector;
	        this.filters = [];
	        this.init();
	    }
	
	    _createClass(Filter, [{
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            this.$filters = (0, _jquery2.default)('.js-filter select');
	
	            this.$filters.each(function (i, e) {
	                _this.initFilter(e);
	            });
	
	            (0, _jquery2.default)('.filter').on('click', function (e) {
	                (0, _jquery2.default)('.filter .dropdown').toggleClass('active');
	                e.stopPropagation();
	            });
	
	            (0, _jquery2.default)('body').on('click', function (e) {
	                (0, _jquery2.default)('.filter .dropdown').removeClass('active');
	            });
	        }
	    }, {
	        key: 'initFilter',
	        value: function initFilter(e) {
	            var _this2 = this;
	
	            var $e = (0, _jquery2.default)(e);
	            var type = $e.data('filter');
	            this.filters[type] = "*";
	
	            $e.change(function () {
	                _this2.filters[type] = $e.find(":selected").val();
	                _this2.filter();
	            });
	        }
	    }, {
	        key: 'filter',
	        value: function filter() {
	            var _this3 = this;
	
	            var $toFilter = (0, _jquery2.default)('.js-to-filter');
	            $toFilter.removeClass('hide');
	
	            var _loop = function _loop(key) {
	                if (_this3.filters.hasOwnProperty(key)) {
	                    if (_this3.filters[key] !== "*") {
	                        $toFilter.each(function (i, e) {
	                            if (!(0, _jquery2.default)(e).hasClass("js-" + key + "-" + _this3.filters[key])) {
	                                (0, _jquery2.default)(e).addClass('hide');
	                            }
	                        });
	                    }
	                }
	            };
	
	            for (var key in this.filters) {
	                _loop(key);
	            }
	
	            var count = $toFilter.length - (0, _jquery2.default)('.js-to-filter.hide').length;
	            var $noResults = (0, _jquery2.default)('.js-no-results');
	
	            if (count === 0) {
	                $noResults.removeClass('hide');
	            } else {
	                $noResults.addClass('hide');
	            }
	        }
	    }]);
	
	    return Filter;
	}();
	
	exports.default = Filter;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(11);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HasClass = function () {
	    function HasClass(selector) {
	        _classCallCheck(this, HasClass);
	
	        this.$ = (0, _jquery2.default)(selector);
	    }
	
	    _createClass(HasClass, [{
	        key: 'has',
	        value: function has(className, cb) {
	            if (this.$.hasClass(className)) {
	                cb();
	            }
	        }
	    }]);
	
	    return HasClass;
	}();
	
	module.exports = HasClass;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Hash = function Hash() {
	    _classCallCheck(this, Hash);
	
	    if (window.location.hash) {
	        if (window.location.hash === "#zappa") {
	            $('.js-zappa').addClass('show');
	
	            $('.js-zappa-verder').on('click', function () {
	                $('.js-zappa').removeClass('show');
	                history.replaceState({}, document.title, ".");
	            });
	        }
	    }
	};
	
	module.exports = Hash;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(11);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Hover = function Hover(el) {
	    var _this = this;
	
	    _classCallCheck(this, Hover);
	
	    var $el = (0, _jquery2.default)(el);
	    this.image = $el.data('image');
	    this.$elImage = (0, _jquery2.default)('.js-hover-image');
	    this.$bgImage = (0, _jquery2.default)('.js-bg-image');
	
	    setTimeout(function () {
	        var images = new Image();
	        images.src = _this.image;
	    }, 500);
	
	    $el.mouseover(function (e) {
	        _this.$elImage.addClass('show');
	        _this.$bgImage.css('background-image', 'url(' + _this.image + ')');
	    }).mouseleave(function () {
	        _this.$elImage.removeClass('show');
	    });
	
	    $el.mousedown(function () {
	        _this.$elImage.addClass('show');
	        _this.$bgImage.css('background-image', 'url(' + _this.image + ')');
	    });
	};
	
	module.exports = Hover;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Gmaps = __webpack_require__(363);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Map = function () {
	  function Map(el) {
	    _classCallCheck(this, Map);
	
	    this.el = el;
	    this.initMap();
	
	    this.style = [{
	      elementType: "geometry",
	      stylers: [{
	        color: "#212121"
	      }]
	    }, {
	      elementType: "labels.icon",
	      stylers: [{
	        visibility: "off"
	      }]
	    }, {
	      elementType: "labels.text.fill",
	      stylers: [{
	        color: "#757575"
	      }]
	    }, {
	      elementType: "labels.text.stroke",
	      stylers: [{
	        color: "#212121"
	      }]
	    }, {
	      featureType: "administrative",
	      elementType: "geometry",
	      stylers: [{
	        color: "#757575"
	      }]
	    }, {
	      featureType: "administrative.country",
	      elementType: "labels.text.fill",
	      stylers: [{
	        color: "#9e9e9e"
	      }]
	    }, {
	      featureType: "administrative.land_parcel",
	      stylers: [{
	        visibility: "off"
	      }]
	    }, {
	      featureType: "administrative.locality",
	      elementType: "labels.text.fill",
	      stylers: [{
	        color: "#bdbdbd"
	      }]
	    }, {
	      featureType: "poi",
	      elementType: "labels.text.fill",
	      stylers: [{
	        color: "#757575"
	      }]
	    }, {
	      featureType: "poi.park",
	      elementType: "geometry",
	      stylers: [{
	        color: "#181818"
	      }]
	    }, {
	      featureType: "poi.park",
	      elementType: "labels.text.fill",
	      stylers: [{
	        color: "#616161"
	      }]
	    }, {
	      featureType: "poi.park",
	      elementType: "labels.text.stroke",
	      stylers: [{
	        color: "#1b1b1b"
	      }]
	    }, {
	      featureType: "road",
	      elementType: "geometry.fill",
	      stylers: [{
	        color: "#2c2c2c"
	      }]
	    }, {
	      featureType: "road",
	      elementType: "labels.text.fill",
	      stylers: [{
	        color: "#8a8a8a"
	      }]
	    }, {
	      featureType: "road.arterial",
	      elementType: "geometry",
	      stylers: [{
	        color: "#373737"
	      }]
	    }, {
	      featureType: "road.highway",
	      elementType: "geometry",
	      stylers: [{
	        color: "#3c3c3c"
	      }]
	    }, {
	      featureType: "road.highway.controlled_access",
	      elementType: "geometry",
	      stylers: [{
	        color: "#4e4e4e"
	      }]
	    }, {
	      featureType: "road.local",
	      elementType: "labels.text.fill",
	      stylers: [{
	        color: "#616161"
	      }]
	    }, {
	      featureType: "transit",
	      elementType: "labels.text.fill",
	      stylers: [{
	        color: "#757575"
	      }]
	    }, {
	      featureType: "water",
	      elementType: "geometry",
	      stylers: [{
	        color: "#000000"
	      }]
	    }, {
	      featureType: "water",
	      elementType: "labels.text.fill",
	      stylers: [{
	        color: "#3d3d3d"
	      }]
	    }];
	  }
	
	  _createClass(Map, [{
	    key: "initMap",
	    value: function initMap() {
	      var _this = this;
	
	      var gmapApi = new _Gmaps.GoogleMapsApi();
	      gmapApi.load().then(function () {
	        var mapOptions = {
	          zoom: 12,
	          center: new google.maps.LatLng(51.211868, 4.415665),
	          disableDefaultUI: true,
	          styles: _this.style
	        };
	
	        var map = new google.maps.Map(document.querySelector("#map"), mapOptions);
	        var pinz = [];
	
	        $(".js-markers li").each(function (i, e) {
	          var pin = [];
	          pin["name"] = $(e).data("name");
	          pin["lat"] = $(e).data("lat");
	          pin["lon"] = $(e).data("lon");
	
	          pinz.push(pin);
	        });
	
	        for (var i = 0; i < pinz.length; i++) {
	          new google.maps.Marker({
	            map: map,
	            position: new google.maps.LatLng(pinz[i].lat, pinz[i].lon),
	            label: {
	              text: pinz[i].name,
	              color: "#333333",
	              fontSize: "16px",
	              fontWeight: "bold"
	            }
	          });
	        }
	      });
	    }
	  }]);
	
	  return Map;
	}();
	
	exports.default = Map;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(11);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Marquee = function () {
	    function Marquee(el) {
	        _classCallCheck(this, Marquee);
	
	        this.el = el;
	        this.$marquee = (0, _jquery2.default)(el);
	
	        this.init();
	    }
	
	    _createClass(Marquee, [{
	        key: 'init',
	        value: function init() {
	            var dir = 'left';
	
	            if (this.$marquee.data('dir')) {
	                dir = this.$marquee.data('dir');
	            }
	
	            this.$marquee.marquee({
	                duplicated: true,
	                pauseOnHover: false,
	                startVisible: true,
	                direction: dir,
	                delayBeforeStart: 0,
	                speed: 50
	            });
	
	            this.$marquee.css('opacity', 1);
	        }
	    }]);
	
	    return Marquee;
	}();
	
	exports.default = Marquee;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(11);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(354);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	window.jQuery = _jquery2.default;
	
	var Navigation = function () {
	    function Navigation() {
	        _classCallCheck(this, Navigation);
	
	        this.$button = (0, _jquery2.default)('.js-hamburger');
	        this.$body = (0, _jquery2.default)('body');
	        this.init();
	    }
	
	    _createClass(Navigation, [{
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            this.$button.on('click', function () {
	                _this.$button.toggleClass('is-active');
	                _this.$body.toggleClass('nav-open');
	            });
	        }
	    }]);
	
	    return Navigation;
	}();
	
	module.exports = Navigation;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(11);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Search = function () {
	    function Search() {
	        _classCallCheck(this, Search);
	
	        this.init();
	    }
	
	    _createClass(Search, [{
	        key: 'init',
	        value: function init() {
	            (0, _jquery2.default)('.js-open-search').on('click', function (e) {
	                e.preventDefault();
	
	                (0, _jquery2.default)('.js-search-input').toggleClass('show');
	            });
	
	            (0, _jquery2.default)('#searchform').submit(function () {
	                if (_jquery2.default.trim((0, _jquery2.default)("#s").val()) === "") {
	                    (0, _jquery2.default)('.js-search-input').toggleClass('show');
	                    return false;
	                }
	            });
	        }
	    }]);
	
	    return Search;
	}();
	
	module.exports = Search;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	__webpack_require__(140);
	
	var _viewportUnitsBuggyfill = __webpack_require__(361);
	
	var _viewportUnitsBuggyfill2 = _interopRequireDefault(_viewportUnitsBuggyfill);
	
	var _app = __webpack_require__(362);
	
	var _app2 = _interopRequireDefault(_app);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = global.jQuery = __webpack_require__(11);
	_viewportUnitsBuggyfill2.default.init();
	
	$(document).ready(function () {
	    _app2.default.start();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Homepage = function Homepage(injector) {
	    _classCallCheck(this, Homepage);
	
	    this.injector = injector;
	};
	
	exports.default = Homepage;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js